angular.module("prism-ui.config", [])
    .constant("appUriConfig", { "acceptProfilesUri": "/reachengine/api/prism/mediaAcceptProfiles", "aggregationUri": "/reachengine/api/prism/aggregation", "assetContentTemplatesUri": "/reachengine/api/prism/system/assetContentTemplates", "artworkUri": "/reachengine/api/prism/artwork", "breakPrePostRollUri": "/reachengine/api/prism/breakPrePostRollContainers", "calendarsUri": "/reachengine/api/prism/calendars", "categoriesUri": "/reachengine/api/prism/categories", "captionsUri": "/reachengine/api/prism/captions", "checkInUri": "/reachengine/api/prism/packages/checkIn", "clipsUri": "/reachengine/api/prism/clips", "collaboratorsUri": "/reachengine/api/prism/collaborators", "componentInventoryUri": "/reachengine/api/prism/componentInventory", "conditionalTemplatesUri": "/reachengine/api/prism/system/deliveryConditions", "contactsUri": "/reachengine/api/prism/system/contacts", "contentUri": "/reachengine/api/prism/contents", "dashboardUri": "/reachengine/api/prism/dashboard", "deliveryTemplatesUri": "/reachengine/api/prism/system/deliveryTemplates", "deliveryUri": "/reachengine/api/prism/delivery", "directoryUri": "/reachengine/api/storage/directories", "dynamicPropertiesUri": "/reachengine/api/prism/system/properties", "echoUri": "/ping", "eventNotificationsUri": "/reachengine/api/events", "emailTemplatesUri": "/reachengine/api/prism/system/emailTemplates", "enumUri": "/reachengine/api/prism/enums", "externalMetadataSourcesUri": "/reachengine/api/prism/aggregation/setup", "externalMetadataLoggingUri": "/reachengine/api/prism/system/externalMetadataLogs", "externalMetadataQueueUri": "/reachengine/api/prism/system/externalIngestJobs", "execServersUri": "/reachengine/api/exec-servers", "fileSystemUri": "/reachengine/api/storage/filesystems", "ffmpegTemplatesUri": "/reachengine/api/prism/system/FFmpegTemplates", "fileUploadUri": "/reachengine/api/system/fileUpload", "genresUri": "/reachengine/api/prism/genres", "imageTemplatesUri": "/reachengine/api/prism/system/imageTemplates", "intermediateTemplatesUri": "/reachengine/api/prism/system/intermediateVideoTemplates", "inventoryUri": "/reachengine/api/prism", "languageUri": "/reachengine/api/prism/languages", "liveClipUri": "/reachengine/api/prism/liveclips", "livefeedsUri": "/reachengine/api/prism/livefeeds", "macCaptionTemplatesUri": "/reachengine/api/prism/system/macCaptionTemplates", "mediaAssetUri": "/reachengine/api/prism/asset", "mediaConversionTemplateUri": "/reachengine/api/conversionTemplates", "mediainfoUri": "/reachengine/api/prism/system/mediainfo", "mediaProfile": "/reachengine/api/prism/media/profile", "metaGroupsUri": "/reachengine/api/metadata/groups", "metaPropsUri": "/reachengine/api/prism/metadata/properties", "networksUri": "/reachengine/api/prism/networks", "packageAcceptTemplatesUri": "/reachengine/api/prism/packageAcceptTemplates", "packageCategoriesUri": "/reachengine/api/prism/packageCategories", "packageMediaInfoUri": "/reachengine/api/prism/packages/mediainfo", "packageCreationTemplatesUri": "/reachengine/api/prism/system/packageCreationTemplates", "packageStatusNotificationsUri": "/reachengine/api/prism/system/packageStatusNotifications", "packageUri": "/reachengine/api/prism/packages", "partnerPackagesUri": "/reachengine/api/prism/partnerPackages", "partnerUri": "/reachengine/api/prism/partners", "permissionsUri": "/reachengine/api/prism/permissions", "prePostRollUri": "/reachengine/api/prism/prePostRolls", "proxyUri": "/reachengine/api/prism/proxies", "queuesUri": "/reachengine/api/prism/queues", "ratingsUri": "/reachengine/api/prism/ratings", "reachDynamicPropertiesUri": "/reachengine/api/properties", "reachPermissionsUri": "/reachengine/api/security/permissions", "recordUri": "/records", "reportUri": "/reachengine/api/prism/report", "repositoryRootsUri": "/reachengine/api/prism/system/assetRepositoryRoots", "roleUri": "/reachengine/api/prism/roles", "samlUri": "/saml/consume", "securityRolesUri": "/reachengine/api/security/roles", "serverInfoUri": "/reachengine/api/prism/version", "transformTemplatesUri": "/reachengine/api/prism/system/xslTemplates", "temporaryFileUploadUri": "/reachengine/api/filesystem/temp", "territoriesUri": "/reachengine/api/prism/territories", "userUri": "/reachengine/api/security/users", "virtualPathUri": "/reachengine/api/filesystem/vfs", "watermarkUri": "/reachengine/api/prism/watermarks", "workflowExecutionsUri": "/reachengine/api/prism/workflows/executions", "workflowFilesUri": "/reachengine/api/workflow-files" });

angular.module("templates-app", []).run(["$templateCache", function ($templateCache) {
        $templateCache.put("login/login-template.html", "<div class=\"container text-center flex-row-container vertically-aligned\">\n    <div class=\"login-logo-container flex-centered-col-container\">\n        <img class=\"img-responsive\"\n             ng-src=\"{{$ctrl.getTopLogo().href}}\"\n             ng-style=\"{ \'width\': $ctrl.getTopLogo().width,\n                         \'height\': $ctrl.getTopLogo().height }\" />\n        <br />\n        <img class=\"img-responsive\"\n             ng-src=\"{{$ctrl.getBottomLogo().href}}\"\n             ng-style=\"{ \'width\': $ctrl.getBottomLogo().width,\n                         \'height\': $ctrl.getBottomLogo().height }\" />\n    </div>\n    <div class=\"col-md-1\">\n        <img class=\"img-responsive\" src=\"assets/images/logindivider.png\"/>\n    </div>\n\n    <div class=\"flex-stretcher flex-stretched-col-container\">\n        <div class=\"col-md-9 flex-align-center\"\n             ng-switch=\"$ctrl.loginType\">\n\n            <!-- SAML -->\n            <div ng-switch-when=\"saml\"\n                 class=\"flex-stretched-col-container\">\n                <saml-login can-submit=\"!$ctrl.serverDown\"></saml-login>\n                <div class=\"flex-align-end col-md-offset-5 flex-row-reverse-container\">\n                    <button class=\"btn btn-link\"\n                            ng-click=\"$ctrl.toggleLoginType()\">\n                        Log into system account\n                    </button>\n                </div>\n            </div>\n\n            <!-- System -->\n            <div ng-switch-when=\"system\"\n                 class=\"flex-col-container\">\n                <button class=\"btn btn-link flex-align-start no-padding-left\"\n                        ng-if=\"$ctrl.isSamlEnabled\"\n                        ng-click=\"$ctrl.toggleLoginType()\">\n                    <i class=\"fa fa-long-arrow-left\"></i>\n                    Back\n                </button>\n                <system-login can-submit=\"!$ctrl.serverDown\"></system-login>\n            </div>\n        </div>\n        <div class=\"login-alert\" role=\"alert\" ng-show=\"$ctrl.errors\">\n            <div ng-repeat=\"(errorName, errorString) in $ctrl.errors\">\n                {{errorString}}\n            </div>\n        </div>\n    </div>\n</div>\n\n\n");
        $templateCache.put("package/package-template.html", "<div class=\"container-fluid no-padding\">\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n    <div class=\"row-no-padding\">\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n        <package-manager class=\"col-md-10 content-pane\"></package-manager>\n    </div>\n</div>\n\n");
        $templateCache.put("components/asperaConnect/aspera-file-select-template.html", "<!-- Drag/Drop Landing Zone -->\n<div class=\"row drop-row\"\n     uib-tooltip-html=\"$ctrl.getToolTip()\">\n    <div class=\"col-md-12 no-padding\"\n         ng-class=\"{ \'top-margin-md\' : ($ctrl.showSelectButton || $ctrl.showLabels)}\">\n\n        <!-- Landing Zone (no preview) -->\n        <div id=\"{{$ctrl.dropZoneId}}\"\n             ng-class=\"[$ctrl.dropZoneId, $ctrl.dropZoneSize]\">\n\n            <div class=\"loadingIndicator\">\n                <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                     ng-class=\"[$ctrl.dropZoneSize]\"\n                     ng-show=\"$ctrl.loadingIndicator.show\">\n                </div>\n            </div>\n\n            <div class=\"center-block flex-centered-col-container\"\n                 ng-class=\"{ \'well\' : $ctrl.showDropZone && $ctrl.asperaConnectInitialized() }\"\n                 ng-show=\"!$ctrl.loadingIndicator.show\">\n                <i ng-show=\"$ctrl.showDropZone && $ctrl.asperaConnectInitialized()\"\n                   class=\"fa fa-arrow-down flex-align-center\"></i>\n            </div>\n        </div>\n\n    </div>\n</div>\n");
        $templateCache.put("components/collaborators/content-collaborator-grid-view-template.html", "<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\" ng-show=\"$ctrl.loadingIndicator.show\"></div>\n</div>\n\n<div class=\"collaborator-edit-view-container\">\n    <uib-tabset horizontal=\"true\" type=\"pills\" class=\"collaborators-edit-view-tabbar\" active=\"$ctrl.currentTab\">\n        <uib-tab heading=\"Actors\" select=\"$ctrl.activateTab(\'Actors\')\" index=\"\'Actors\'\">\n            <div id=\"collaboratorsGrid\"\n                 class=\"collaborator-grid protected-grid\"\n                 ui-grid=\"$ctrl.gridOptions\"\n                 ui-grid-auto-resize\n                 ui-grid-selection>\n            </div>\n        </uib-tab>\n    </uib-tabset>\n</div>\n\n<div class=\"row-no-padding\">\n    <toolbar button-defs=\"$ctrl.toolbarButtonDefs\" pagination-defs=\"$ctrl.paginationDefs\"></toolbar>\n</div>\n");
        $templateCache.put("components/fileSelect/file-select-template.html", "<fieldset class=\"file-select-container\">\n    <div class=\"flex-centered-row-container\">\n        <!-- Local Drop Zone -->\n        <div ng-if=\"$ctrl.isDragDropVisible(\'LOCAL\') && $ctrl.isRemoteUploadEnabled()\"\n             class=\"local-drop-zone flex-centered-col-container\"\n             ng-class=\"$ctrl.dragDropClass\">\n            <div id=\"{{$ctrl.dragDropId}}\"\n                 class=\"well center-block flex-centered-col-container\"\n                 nv-file-drop=\"\"\n                 uploader=\"$ctrl.localFileUploaderConfig\"\n                 options=\"$ctrl.localFileDropZoneOptions\"\n                 ng-hide=\"!$ctrl.isFileSourceEnabled(\'LOCAL\')\">\n                <i class=\"fa fa-arrow-down fa-2x flex-align-center\" ng-show=\"!$ctrl.loadingIndicator.show\"></i>\n            </div>\n\n            <div class=\"loadingIndicator\">\n                <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                     ng-show=\"$ctrl.loadingIndicator.show\">\n                </div>\n            </div>\n        </div>\n\n        <!-- Aspera Drop Zone -->\n        <aspera-file-select ng-if=\"$ctrl.isDragDropVisible(\'ASPERA\') && $ctrl.dragDropId && $ctrl.isRemoteUploadEnabled()\"\n            drop-handler=\"$ctrl.onAsperaFilesDropped\"\n            drop-zone-id=\"$ctrl.dragDropId\"\n            drop-zone-size=\"\'file-drop-zone-xs\'\"\n            file-extensions=\"$ctrl.getFileExtensions()\"\n            show-drop-zone=\"$ctrl.isFileSourceEnabled(\'ASPERA\')\"\n            ng-class=\"$ctrl.dragDropClass\">\n        </aspera-file-select>\n\n        <div ng-if=\"!$ctrl.isRemoteUploadEnabled()\"\n             class=\"no-drop-zone-placeholder\">\n            &nbsp;\n        </div>\n\n        <!-- File Selection Buttons -->\n        <div class=\"ingest-buttons flex-col-container\">\n            <button class=\"btn btn-default prism-button flex-align-center\"\n                    ng-show=\"$ctrl.isFileSourceButtonVisible(\'REMOTE\')\"\n                    ng-disabled=\"!$ctrl.isFileSourceEnabled(\'REMOTE\')\"\n                    ng-click=\"$ctrl.openRemoteFileModal()\">\n                <span uib-tooltip-html=\"$ctrl.buttonTooltips.REMOTE\">Browse Remote</span>\n            </button>\n\n            <span ng-if=\"$ctrl.isRemoteUploadEnabled()\"\n                  class=\"ingest-button-separator\">\n                &nbsp;\n            </span>\n\n            <button class=\"btn btn-default prism-button\"\n                    ng-if=\"$ctrl.isRemoteUploadEnabled()\"\n                    ng-show=\"$ctrl.isFileSourceButtonVisible(\'LOCAL\')\"\n                    ng-disabled=\"!$ctrl.isFileSourceEnabled(\'LOCAL\')\"\n                    ng-click=\"$ctrl.openLocalFileModal()\">\n                <span uib-tooltip-html=\"$ctrl.buttonTooltips.LOCAL\">Upload Local</span>\n            </button>\n            <input class=\"localUploadInputSingle\"\n                   type=\"file\"\n                   nv-file-select=\"\"\n                   uploader=\"$ctrl.localFileUploaderConfig\"\n                   ng-hide=\"true\"/>\n            <input class=\"localUploadInputMultiple\"\n                   type=\"file\"\n                   multiple=\"multiple\"\n                   nv-file-select=\"\"\n                   uploader=\"$ctrl.localFileUploaderConfig\"\n                   ng-hide=\"true\"/>\n        </div>\n    </div>\n</fieldset>\n");
        $templateCache.put("components/fileUpload/file-upload-template.html", "<!-- Select File Button -->\n<div class=\"row padding-top-md\">\n    <div class=\"col-md-12\">\n        <input id=\"uploadInput\"\n               class=\"center-block\"\n               type=\"file\"\n               nv-file-select\n               uploader=\"$ctrl.uploaderConfig\"\n               ng-hide=\"true\" />\n        <button class=\"btn btn-md btn-default center-block\"\n                ng-click=\"$ctrl.onFileSelect()\"\n                onClick=\"document.getElementById(\'uploadInput\').click();\">\n            Select {{$ctrl.typeName}}\n        </button>\n    </div>\n</div>\n\n<div class=\"text-align-center top-margin-md\">\n    OR\n</div>\n\n<!-- Drag/Drop Landing Zone -->\n<div class=\"row\">\n    <div class=\"col-md-12 top-margin-md\">\n\n        <!-- Landing Zone (no preview) -->\n        <div>\n            <div class=\"file-drop-zone-lg\"\n                 nv-file-drop\n                 uploader=\"$ctrl.uploaderConfig\">\n                <div class=\"well center-block flex-centered-col-container\">\n                    <i class=\"fa fa-arrow-down fa-5x flex-align-center\"></i>\n                </div>\n            </div>\n            <div class=\"center-block padding-top-lg\">\n                <p\n                    class=\"grey-label text-center\"\n                    ng-if=\"!$ctrl.selectedItems.length\">\n                    Drop {{$ctrl.typeName}} Here\n                </p>\n                <div\n                    class=\"edit-view-container\"\n                    ng-show=\"$ctrl.selectedItems.length > 0\"\n                    style=\"overflow-y: scroll;max-height: 350px\">\n                    <p\n                        class=\"grey-label text-left\"\n                        ng-repeat=\"item in $ctrl.selectedItems\">\n                        {{item.file.name}}\n                    </p>\n                </div>\n                <p\n                    class=\"grey-label text-center padding-top-lg\"\n                    ng-if=\"$ctrl.selectedItems.length > 0 && $ctrl.progress === 0\">\n                    To begin upload, click \"Upload\" on the toolbar.\n                </p>\n                <p\n                    class=\"grey-label text-center padding-top-lg\"\n                    ng-if=\"$ctrl.progress > 0 && $ctrl.progress < 100\">\n                    Uploading...\n                </p>\n                <p\n                    class=\"grey-label text-center padding-top-lg\"\n                    ng-if=\"$ctrl.progress > 0 && $ctrl.progress < 100\">\n                    Upload complete\n                </p>\n            </div>\n        </div>\n\n    </div>\n</div>\n");
        $templateCache.put("components/jsonViewer/json-viewer-template.html", "<div class=\"navbar navbar-default\"\n     ng-if=\"$ctrl.useNativeSearch\">\n    <form class=\"navbar-form navbar-left padding-left-lg\"\n          role=\"search\"\n          ng-keyup=\"$ctrl.onKeyUp($event)\"\n        <div class=\"form-group\">\n            <div class=\"input-group input-group-sm\">\n                <input id=\"text\"\n                       size=\"50\"\n                       type=\"text\"\n                       class=\"navbar-textfield form-control\"\n                       ng-change=\"$ctrl.onSearchTextInputChanged()\"\n                       ng-model=\"$ctrl.searchTextInput\"/>\n                <a class=\"input-group-addon btn navbar-refresh-btn btn-xs\"\n                   ng-click=\"$ctrl.findPrevious()\">\n                    <i class=\"fa fa-arrow-up\"></i>\n                </a>\n                <a class=\"input-group-addon btn navbar-refresh-btn btn-xs\"\n                   ng-click=\"$ctrl.findNext()\">\n                    <i class=\"fa fa-arrow-down\"></i>\n                </a>\n            </div>\n            <span>\n                <span class=\"search-result-counter\">\n                    {{$ctrl.getSearchResultCountString()}}\n                </span>\n                <span class=\"search-not-found-message\">\n                    {{$ctrl.getNoResultsMsg()}}\n                </span>\n            </span>\n        </div>\n    </form>\n</div>\n\n<div id=\"jsonViewerGrid\"\n     class=\"grid json-viewer-grid\"\n     ui-grid=\"$ctrl.gridOptions\"\n     ui-grid-tree-view\n     ui-grid-auto-resize\n     ui-grid-resize-columns>\n</div>\n");
        $templateCache.put("components/modal/message-modal-template.html", "<div class=\"modal-header\">\n    <h4 class=\"modal-title\">{{msgMdlCntrlr.modalTitle}}</h4>\n</div>\n<div class=\"modal-body\">\n    <p ng-repeat=\"line in msgMdlCntrlr.getLines()\">{{line}}</p>\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-sm btn-default\"\n            ng-show=\"msgMdlCntrlr.showCancel\"\n            ng-class=\"msgMdlCntrlr.pullCancelLeft ? \'pull-left\' : \'\'\"\n            ng-click=\"msgMdlCntrlr.close()\">{{msgMdlCntrlr.cancelText || \'Cancel\'}}\n    </button>\n    <button class=\"btn btn-sm btn-default\"\n            ng-show=\"msgMdlCntrlr.showOK\"\n            ng-click=\"msgMdlCntrlr.onOK()\">{{msgMdlCntrlr.okText || \'OK\'}}\n    </button>\n</div>\n");
        $templateCache.put("components/notification/notification-template.html", "<div data-notify=\"container\" class=\"col-sm-3 alert alert-{0}\" role=\"alert\">\n    <button type=\"button\" class=\"expand close\" aria-hidden=\"true\"\n            ng-click=\"expandMessageClicked()\">\n        <span class=\"fa-stack\">\n            <i class=\"fa fa-expand fa-stack-1x\"></i>\n        </span>\n        <span class=\"sr-only\">Expand</span>\n    </button>\n\n    <button type=\"button\" class=\"close\" aria-hidden=\"true\" data-notify=\"dismiss\">\n        <span class=\"fa-stack\">\n            <i class=\"fa fa-circle-thin fa-stack-1x\"></i>\n            <i class=\"fa fa-times fa-stack-1x\"></i>\n        </span>\n        <span class=\"sr-only\">Close</span>\n    </button>\n\n    <div class=\"alert-contents flex-col-container\">\n        <div class=\"alert-title\">\n            <span data-notify=\"icon\"></span>\n\n            <span data-notify=\"title\">{1}</span>\n        </div>\n        <div class=\"alert-message\">\n            <span data-notify=\"message\">{2}</span>\n        </div>\n\n        <span class=\"dynamic-notification-content\">\n            <div class=\"alert-long-message\">\n                ...\n            </div>\n            <div ng-if=\"detailText\" align=\"left\" class=\"alert-details\">\n                <a ng-click=\"moreInfoClickHandler(detailText, (fileErrorsObject) ? fileErrorsObject : message)\">{{moreInfoText}}</a>\n            </div>\n\n            <div ng-if=\"downloadText\" align=\"left\" class=\"alert-details\">\n                <a ng-click=\"downloadCallback(detailText)\">{{downloadText}}</a>\n            </div>\n        </span>\n    </div>\n\n</div>\n");
        $templateCache.put("components/prism-initialization/prism-initialization-template.html", "<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\">\n    </div>\n</div>\n");
        $templateCache.put("components/proxyPlayer/proxy-player-template.html", "<videogular vg-player-ready=\"playerCtrl.onPlayerReady($API)\"\n            vg-crossorigin=\"\'anonymous\'\"\n            ng-class=\"playerCtrl.isAudio ? \'audio-player\' : \'\'\"\n            vg-update-time=\"playerCtrl.onUpdateTime($currentTime, $duration)\"\n            vg-update-state=\"playerCtrl.onUpdateState($state)\">\n\n    <vg-media class=\"flex-centered-col-container\"\n              vg-src=\"playerCtrl.config.sources\"\n              vg-tracks=\"!playerCtrl.isAudio ? playerCtrl.config.tracks : null\">\n    </vg-media>\n\n    <vg-controls>\n\n        <vg-play-pause-button>\n        </vg-play-pause-button>\n\n        <vg-time-display class=\"preview-player-timecode\">\n            {{ ((currentTime / 1000) + playerCtrl.offset) | timecodeFromSec: playerCtrl.framerate }}\n        </vg-time-display>\n\n        <vg-scrub-bar>\n            <vg-scrub-bar-current-time></vg-scrub-bar-current-time>\n            <vg-scrub-bar-cue-points vg-template=\"components/proxyPlayer/renderers/cue-points-renderer-template.html\"\n                                     vg-cue-points=\"playerCtrl.config.cuePoints\"></vg-scrub-bar-cue-points>\n        </vg-scrub-bar>\n\n        <vg-time-display class=\"preview-player-timecode\">\n            {{ ((timeLeft / 1000)) | timecodeFromSec: playerCtrl.framerate : false : true}}\n        </vg-time-display>\n\n        <vg-volume>\n            <vg-mute-button></vg-mute-button>\n            <vg-volume-bar></vg-volume-bar>\n        </vg-volume>\n\n        <vg-fullscreen-button ng-show=\"!playerCtrl.isAudio\">\n        </vg-fullscreen-button>\n\n    </vg-controls>\n\n    <vg-overlay-play ng-show=\"!playerCtrl.isAudio\">\n    </vg-overlay-play>\n\n    <vg-poster vg-url=\'playerCtrl.config.plugins.poster\'>\n    </vg-poster>\n\n</videogular>\n\n");
        $templateCache.put("components/subscription/subscription-edit-grid-template.html", "<div id=\"contentCategorySubscriptions\" class=\"row-no-padding\">\n\n	<!-- Pacifier -->\n	<div class=\"loadingIndicator\">\n		<div data-lb-progress=\"$ctrl.loadingIndicator\"\n			 ng-show=\"$ctrl.loadingIndicator.show\">\n		</div>\n	</div>\n\n	<!-- Grid -->\n	<fieldset>\n		<form name=\"$ctrl.editorForm\">\n			<div id=\"contentCategorySubscriptionsGrid\"\n				 class=\"breadcrumb-tab-edit-search-grid grid search-grid\"\n				 ui-grid=\"$ctrl.gridOptions\"\n				 ui-grid-selection\n				 ui-grid-pagination\n				 ui-grid-pinning\n				 ui-grid-resize-columns\n				 ui-grid-auto-resize>\n			</div>\n		</form>\n	</fieldset>\n\n	<!-- Toolbar -->\n	<toolbar\n		button-defs=\"$ctrl.toolbarButtonDefs\"\n		pagination-defs=\"$ctrl.paginationDefs\"\n		right-hand-checkbox-defs=\"$ctrl.toolbarCheckboxDefs\">\n	</toolbar>\n\n</div>\n");
        $templateCache.put("dashboard/metrics/metrics-dashboard-template.html", "<div class=\"container-fluid no-padding metrics-dashboard full-height\"\n     ng-if=\"!$ctrl.chromeless\">\n\n    <!-- Navbar -->\n    <div class=\"row-no-padding\">\n        <navbar filter-enabled=\"true\"></navbar>\n    </div>\n\n    <div class=\"row-no-padding\">\n\n        <!-- Sidebar -->\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <!-- Content Pane -->\n        <div class=\"col-md-10 col-lg-10 content-pane dashboard-content-embedded\">\n\n            <!-- Breadcrumbs -->\n            <breadcrumb></breadcrumb>\n\n            <!-- Loading Indicator -->\n            <div class=\"loadingIndicator\">\n                <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                     ng-show=\"$ctrl.loadingIndicator.show\">\n                </div>\n            </div>\n\n            <!-- Content - buttons on left, graphs on right -->\n            <div class=\"flex-row-container flex-stretcher height-100\">\n\n                <!-- Left column - filter button only -->\n                <div class=\"metrics-filter-button-column flex-align-start\">\n                    <button class=\"btn btn-default prism-button metrics-filter-button\"\n                            id=\"metricsFilterButton\"\n                            ng-click=\"$ctrl.onFilterButtonClick($event)\">\n                        <i class=\"fa fa-filter\"></i>\n                    </button>\n                </div>\n\n                <div class=\"full-width dashboard-content height-100\"\n                     ng-include=\"\'dashboard/metrics/renderers/metrics-dashboard-content-renderer-template.html\'\"></div>\n\n                <!-- Right column - padding only, per mockup -->\n                <div class=\"metrics-padding-column\">\n                    &nbsp;\n                </div>\n\n            </div>\n\n            <!-- Toolbar -->\n            <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"></toolbar>\n\n        </div>\n\n    </div>\n\n</div>\n\n<div class=\"metrics-dashboard full-height\"\n     ng-if=\"$ctrl.chromeless\">\n    <div class=\"dashboard-content-chromeless\"\n         ng-include=\"\'dashboard/metrics/renderers/metrics-dashboard-content-renderer-template.html\'\">\n    </div>\n</div>\n");
        $templateCache.put("dashboard/offCyclePlanners/off-cycle-planners-template.html", "<div class=\"container-fluid no-padding off-cycle-planner\">\n	<div class=\"row-no-padding\">\n		<navbar search-enabled=\"$ctrl.isSearchEnabled()\"></navbar>\n	</div>\n	<div class=\"row-no-padding\">\n		<sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n		<div class=\"col-md-10 col-lg-10 content-pane\">\n			<div class=\"row-no-padding\">\n				<breadcrumb tab-name=\"$ctrl.breadcrumbLabel\"></breadcrumb>\n			</div>\n			<div class=\"edit-full-height-no-tabs edit-view\">\n                <fieldset ng-disabled=\"!$ctrl.permissions.write\">\n                    <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n                        <div class=\"edit-view-container\">\n                            <div class=\"row clearfix spacer-top-sm\">\n                                <div class=\"col-md-12 column\">\n                                    <div class=\"form-group\">\n                                        <label for=\"offCyclePlannersMessage\" class=\"col-sm-1 control-label\">Message:</label>\n                                        <div class=\"col-sm-7 pad-text-input-col\">\n                                            <textarea class=\"form-control prism-text-input\"\n                                                      id=\"offCyclePlannersMessage\"\n                                                      rows=\"4\"\n                                                      ng-disabled=\"false\"\n                                                      ng-change=\"$ctrl.messageChangedHandler()\"\n                                                      ng-model=\"$ctrl.offCyclePlannersMessage\">\n                                            </textarea>\n                                        </div>\n                                        <button ng-disabled=\"$ctrl.selectedPlanners.length === 0\"\n                                                class=\"col-sm-4 text-center prism-button col-md-offset-1 off-cycle-planner-button\"\n                                                ng-click=\"$ctrl.deliverOffCyclePlanners()\">\n                                            Deliver Off-Cycle Planners\n                                        </button>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"row clearfix spacer-top-sm\" style=\"padding-bottom: 15px;\">\n                                <div class=\"col-md-12 column\">\n                                    <div id=\"plannersList\"\n                                         class=\"search-grid top-margin-lg off-cycle-planner-grid\"\n                                         ui-grid=\"$ctrl.offCyclePlannersGrid\"\n                                         ui-grid-selection\n                                         ui-grid-auto-resize>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </form>\n                </fieldset>\n			</div>\n			<toolbar\n				button-defs=\"\"\n				checkbox-defs=\"\"\n				pagination-defs=\"$ctrl.paginationDefs\">\n			</toolbar>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("dashboard/packageCheckin/package-checkin-template.html", "<div class=\"container-fluid no-padding\">\n\n    <!-- Navbar -->\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <div class=\"row-no-padding\">\n\n        <!-- Sidebar -->\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <!-- Content Pane -->\n        <div class=\"col-md-10 col-lg-10 content-pane package-checkin-view\">\n\n            <breadcrumb></breadcrumb>\n\n            <batch-checkin></batch-checkin>\n\n            <!--\n\n                2018-Jan-18 / ABC-9319\n\n                We\'re leaving the tab component out for now since\n                Robert would rather have multiple file uploads\n                instead of the checked-out list.\n\n            -->\n\n            <!-- Tab Component -->\n            <!--<uib-tabset horizontal=\"true\"-->\n                        <!--type=\"pills\"-->\n                        <!--class=\"edit-view-tabbar\"-->\n                        <!--active=\"$ctrl.currentTab\">-->\n\n                <!--&lt;!&ndash; Batch Checkin &ndash;&gt;-->\n                <!--<uib-tab heading=\"Batch Check-in\"-->\n                         <!--index=\"\'checkin\'\"-->\n                         <!--select=\"$ctrl.onTabSelect(\'checkin\')\"-->\n                         <!--deselect=\"$ctrl.onTabDeselect(\'checkin\', $event)\">-->\n\n                    <!--<batch-checkin>-->\n                    <!--</batch-checkin>-->\n\n                <!--</uib-tab>-->\n\n                <!--&lt;!&ndash; Checked Out &ndash;&gt;-->\n                <!--<uib-tab heading=\"Checked Out\"-->\n                         <!--index=\"checkedOut\"-->\n                         <!--select=\"$ctrl.onTabSelect(\'checkedOut\')\"-->\n                         <!--deselect=\"$ctrl.onTabDeselect(\'checkedOut\', $event)\">-->\n\n                    <!--<checked-out-package-list></checked-out-package-list>-->\n\n                <!--</uib-tab>-->\n\n            <!--</uib-tabset>-->\n\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("dashboard/queues/queues-view-template.html", "<div class=\"container-fluid no-padding\">\n	<div class=\"row-no-padding\">\n		<navbar></navbar>\n	</div>\n	<div class=\"row-no-padding\">\n		<sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n		<div class=\"col-md-10 col-lg-10 content-pane\">\n			<queues-summary-view></queues-summary-view>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("dashboard/reports/report-view-template.html", "<div class=\"container-fluid no-padding\">\n	<div class=\"row-no-padding\">\n		<navbar></navbar>\n	</div>\n	<div class=\"row-no-padding\">\n		<sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n		<div class=\"col-md-10 col-lg-10 content-pane\">\n			<div class=\"loadingIndicator\">\n				<div data-lb-progress=\"$ctrl.loadingIndicator\"\n					 ng-show=\"$ctrl.loadingIndicator.show\"></div>\n			</div>\n			<div class=\"row-no-padding\">\n				<div class=\"col-md-12 col-lg-12\">\n					<breadcrumb tab-name=\"$ctrl.selectedReport.label\"></breadcrumb>\n					<div class=\"row report-view-toolbar\">\n						<div class=\"col-md-11 col-lg-11\">\n							<label>Reports: </label>\n							<dropdown-select ng-model=\"$ctrl.selectedReport\" btn-min-width=\"390\" label-field=\"label\"\n											 collection=\"$ctrl.availableReports\" sort-collection=\"false\" ng-change=\"$ctrl.handleReportChange()\">\n							</dropdown-select>\n						</div>\n						<div class=\"col-md-1 col-lg-1\">\n							<button class=\"btn btn-default prism-select-btn\" ng-disabled=\"!$ctrl.enableSubmit\" ng-click=\"$ctrl.onSubmit()\">Submit</button>\n						</div>\n\n					</div>\n					<div class=\"row report-view v-align\">\n						<fieldset ng-disabled=\"!$ctrl.enableSubmit\">\n							<div class=\"col-md-7 col-md-offset-3 report-view-container\" ng-if=\"$ctrl.showReportForm()\">\n								<div ng-if=\"$ctrl.selectedReport.generatorName === \'BasicDeliveryReport\'\"\n									 ng-include=\"\'dashboard/reports/renderers/partner-delivery-report-template.html\'\"></div>\n								<div ng-if=\"$ctrl.selectedReport.generatorName === \'SLADeliveryReport\'\"\n									 ng-include=\"\'dashboard/reports/renderers/partner-delivery-report-template.html\'\"></div>\n								<div ng-if=\"$ctrl.selectedReport.generatorName === \'PartnerDeliveryReport\'\"\n									 ng-include=\"\'dashboard/reports/renderers/partner-delivery-report-template.html\'\"></div>\n								<div ng-if=\"$ctrl.selectedReport.generatorName === \'PartnerPlannerReport\'\"\n									 ng-include=\"\'dashboard/reports/renderers/partner-delivery-report-template.html\'\"></div>\n								<div ng-if=\"$ctrl.selectedReport.generatorName === \'BasicDistributionReport\'\"\n									 ng-include=\"\'dashboard/reports/renderers/distribution-report-template.html\'\"></div>\n								<div ng-if=\"$ctrl.selectedReport.generatorName === \'VideoProfileReport\'\"\n									 ng-include=\"\'dashboard/reports/renderers/distribution-report-template.html\'\"></div>\n							</div>\n						</fieldset>\n\n					</div>\n				</div>\n			</div>\n		</div>\n	</div>\n</div>\n\n");
        $templateCache.put("meta/content/content-template.html", "<div class=\"container-fluid no-padding\">\n	<div class=\"row-no-padding\">\n		<navbar></navbar>\n	</div>\n	<div class=\"row-no-padding\">\n		<sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n		<content-searchview class=\"col-md-10 content-pane\"></content-searchview>\n	</div>\n</div>\n\n");
        $templateCache.put("package/editor/package-edit-template.html", "<div class=\"container-fluid no-padding\">\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n    <div class=\"row-no-padding\">\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\">\n        </sidebar-nav>\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n            <div class=\"loadingIndicator\">\n                <div data-lb-progress=\"pkgEditCtrl.loadingIndicator\"\n                     ng-show=\"pkgEditCtrl.loadingIndicator.show\">\n                </div>\n            </div>\n            <div class=\"row-no-padding\">\n                <breadcrumb tab-name=\"pkgEditCtrl.packageObjectData.name\">\n                </breadcrumb>\n                <uib-tabset horizontal=\"true\"\n                            type=\"pills\"\n                            class=\"edit-view-tabbar\"\n                            active=\"pkgEditCtrl.currentViewedTab\">\n\n\n                    <!-- Metadata Tab -->\n                    <uib-tab heading=\"Metadata\"\n                             select=\"pkgEditCtrl.onTabSelect(\'metadata\')\"\n                             deselect=\"pkgEditCtrl.onTabDeselect(\'metadata\', $event)\"\n                             index=\"\'metadata\'\"\n                             ng-show=\"pkgEditCtrl.validTabs.metadata\">\n                        <div ng-if=\"pkgEditCtrl.activeTabs.metadata\">\n                            <package-status-bar package-object=\"pkgEditCtrl.packageObjectData\"\n                                                accept-handler=\"pkgEditCtrl.onAcceptPackage()\"\n                                                reject-handler=\"pkgEditCtrl.onRejectPackage()\">\n                            </package-status-bar>\n                            <package-metadata-view class=\"col-md-12 col-lg-12 package-edit-full-height\"\n                                                   g-switch-default\n                                                   package-object=\"pkgEditCtrl.packageObjectData\"\n                                                   pending-partner-packages=\"pkgEditCtrl.packageObjectData.pendingPartnerPackages\"\n                                                   loading-indicator=\"pkgEditCtrl.loadingIndicator\"\n                                                   pkg-edit-ctrl=\"pkgEditCtrl\">\n                            </package-metadata-view>\n                        </div>\n                    </uib-tab>\n\n\n                    <!-- Collaborators Tab -->\n                    <uib-tab heading=\"Collaborators\"\n                             select=\"pkgEditCtrl.onTabSelect(\'collaborators\')\"\n                             deselect=\"pkgEditCtrl.onTabDeselect(\'collaborators\', $event)\"\n                             index=\"\'collaborators\'\"\n                             ng-show=\"pkgEditCtrl.packageObjectData.content.type !== \'Ad/PreRoll\' && pkgEditCtrl.validTabs.collaborators\">\n                        <div ng-if=\"pkgEditCtrl.activeTabs.collaborators\">\n                            <package-status-bar package-object=\"pkgEditCtrl.packageObjectData\"\n                                                accept-handler=\"pkgEditCtrl.onAcceptPackage()\"\n                                                reject-handler=\"pkgEditCtrl.onRejectPackage()\">\n                            </package-status-bar>\n                            <package-collaborators-view class=\"col-md-12 col-lg-12 package-edit-full-height\"\n                                                        package-object=\"pkgEditCtrl.packageObjectData\"\n                                                        status-allows-edit=\"pkgEditCtrl.statusAllowsEdit\"\n                                                        g-switch-default>\n                            </package-collaborators-view>\n                        </div>\n                    </uib-tab>\n\n\n                    <!-- Media Tab -->\n                    <uib-tab heading=\"Media\"\n                             select=\"pkgEditCtrl.onTabSelect(\'media\')\"\n                             deselect=\"pkgEditCtrl.onTabDeselect(\'media\', $event)\"\n                             index=\"\'media\'\"\n                             ng-show=\"pkgEditCtrl.validTabs.media\">\n                        <div ng-if=\"pkgEditCtrl.activeTabs.media\">\n                            <package-status-bar package-object=\"pkgEditCtrl.packageObjectData\"\n                                                accept-handler=\"pkgEditCtrl.onAcceptPackage()\"\n                                                reject-handler=\"pkgEditCtrl.onRejectPackage()\">\n                            </package-status-bar>\n                            <package-media-view class=\"col-md-12 col-lg-12 package-edit-full-height\"\n                                                g-switch-default\n                                                loading-indicator=\"pkgEditCtrl.loadingIndicator\"\n                                                package-object-data=\"pkgEditCtrl.packageObjectData\"\n                                                pkg-edit-ctrl=\"pkgEditCtrl\">\n                            </package-media-view>\n                        </div>\n                    </uib-tab>\n\n\n                    <!-- Timings Tab -->\n                    <uib-tab heading=\"Timings\"\n                             select=\"pkgEditCtrl.onTabSelect(\'timings\')\"\n                             deselect=\"pkgEditCtrl.onTabDeselect(\'timings\', $event)\"\n                             index=\"\'timings\'\"\n                             ng-show=\"pkgEditCtrl.validTabs.timings\">\n                        <div ng-if=\"pkgEditCtrl.activeTabs.timings\">\n                            <package-status-bar package-object=\"pkgEditCtrl.packageObjectData\"\n                                                accept-handler=\"pkgEditCtrl.onAcceptPackage()\"\n                                                reject-handler=\"pkgEditCtrl.onRejectPackage()\">\n                            </package-status-bar>\n                            <package-timings-view class=\"col-md-12 col-lg-12 package-edit-full-height\"\n                                                  package-object=\"pkgEditCtrl.packageObjectData\">\n                            </package-timings-view>\n                        </div>\n                    </uib-tab>\n\n\n                    <!-- Distribution Tab -->\n                    <uib-tab heading=\"Distribution\"\n                             select=\"pkgEditCtrl.onTabSelect(\'distribution\')\"\n                             deselect=\"pkgEditCtrl.onTabDeselect(\'distribution\', $event)\"\n                             index=\"\'distribution\'\"\n                             ng-show=\"pkgEditCtrl.validTabs.distribution\">\n                        <div ng-if=\"pkgEditCtrl.activeTabs.distribution\">\n                            <package-status-bar package-object=\"pkgEditCtrl.packageObjectData\"\n                                                accept-handler=\"pkgEditCtrl.onAcceptPackage()\"\n                                                reject-handler=\"pkgEditCtrl.onRejectPackage()\"\n                                                tab-view-state=\"PACKAGE_DISTRIBUTIONGRID_VIEW_STATE\">\n                            </package-status-bar>\n                            <package-distribution-grid-view class=\"col-md-12 col-lg-12 package-edit-full-height\"\n                                                            g-switch-default\n                                                            package-object-data=\"pkgEditCtrl.packageObjectData\"\n                                                            is-advanced=\"false\">\n                            </package-distribution-grid-view>\n                        </div>\n                    </uib-tab>\n\n\n                    <!-- Advanced Distribution Tab -->\n                    <uib-tab heading=\"Advanced Distribution\"\n                             select=\"pkgEditCtrl.onTabSelect(\'advancedDistribution\')\"\n                             deselect=\"pkgEditCtrl.onTabDeselect(\'advancedDistribution\', $event)\"\n                             index=\"\'advancedDistribution\'\"\n                             ng-show=\"pkgEditCtrl.validTabs.advancedDistribution\">\n                        <div ng-if=\"pkgEditCtrl.activeTabs.advancedDistribution\">\n                            <package-status-bar package-object=\"pkgEditCtrl.packageObjectData\"\n                                                accept-handler=\"pkgEditCtrl.onAcceptPackage()\"\n                                                reject-handler=\"pkgEditCtrl.onRejectPackage()\"\n                                                tab-view-state=\"ADVANCED_PACKAGE_DISTRIBUTIONGRID_VIEW_STATE\">\n                            </package-status-bar>\n                            <package-distribution-grid-view class=\"col-md-12 col-lg-12 package-edit-full-height\"\n                                                            is-advanced=\"true\"\n                                                            g-switch-default\n                                                            package-object-data=\"pkgEditCtrl.packageObjectData\">\n                            </package-distribution-grid-view>\n                        </div>\n                    </uib-tab>\n\n\n                    <!-- Preview Tab -->\n                    <uib-tab heading=\"Preview\"\n                             select=\"pkgEditCtrl.onTabSelect(\'preview\')\"\n                             deselect=\"pkgEditCtrl.onTabDeselect(\'preview\', $event)\"\n                             index=\"\'preview\'\"\n                             ng-show=\"pkgEditCtrl.validTabs.preview\">\n                        <div ng-if=\"pkgEditCtrl.activeTabs.preview\">\n                            <package-status-bar package-object=\"pkgEditCtrl.packageObjectData\"\n                                                accept-handler=\"pkgEditCtrl.onAcceptPackage()\"\n                                                reject-handler=\"pkgEditCtrl.onRejectPackage()\"\n                                                tab-view-state=\"ADVANCED_PACKAGE_DISTRIBUTIONGRID_VIEW_STATE\">\n                            </package-status-bar>\n                            <package-preview-view class=\"col-md-12 col-lg-12 package-edit-full-height\"\n                                                  package-object=\"pkgEditCtrl.packageObjectData\">\n                            </package-preview-view>\n                        </div>\n                    </uib-tab>\n\n\n                    <!-- Clipper Tab -->\n                    <uib-tab heading=\"Clipper\"\n                             select=\"pkgEditCtrl.onTabSelect(\'liveClip\')\"\n                             deselect=\"pkgEditCtrl.onTabDeselect(\'liveClip\', $event)\"\n                             index=\"\'liveClip\'\"\n                             ng-show=\"pkgEditCtrl.validTabs.clips\">\n                        <div ng-if=\"pkgEditCtrl.activeTabs.liveClip\">\n                            <package-liveclip-view class=\"col-md-12 col-lg-12 live-clip-edit-view-height\"\n                                                   category-valid=\"pkgEditCtrl.categoryRoles[pkgEditCtrl.packageObjectData.category.id].liveClippingEnabled\"\n                                                   package-object=\"pkgEditCtrl.packageObjectData\">\n                            </package-liveclip-view>\n                        </div>\n                    </uib-tab>\n\n\n                    <!-- Advanced Metadata Tab -->\n                    <uib-tab heading=\"Advanced Metadata\"\n                             select=\"pkgEditCtrl.onTabSelect(\'advancedMetadata\')\"\n                             deselect=\"pkgEditCtrl.onTabDeselect(\'advancedMetadata\', $event)\"\n                             index=\"\'advancedMetadata\'\"\n                             ng-show=\"pkgEditCtrl.validTabs.advancedMetadata\">\n                        <div ng-if=\"pkgEditCtrl.activeTabs.advancedMetadata\">\n                            <package-status-bar package-object=\"pkgEditCtrl.packageObjectData\"\n                                                accept-handler=\"pkgEditCtrl.onAcceptPackage()\"\n                                                reject-handler=\"pkgEditCtrl.onRejectPackage()\"\n                                                tab-view-state=\"ADVANCED_PACKAGE_DISTRIBUTIONGRID_VIEW_STATE\">\n                            </package-status-bar>\n                            <package-advanced-metadata-view class=\"col-md-12 col-lg-12 package-edit-full-height\"\n                                                            package-object=\"pkgEditCtrl.packageObjectData\"\n                                                            loading-indicator=\"pkgEditCtrl.loadingIndicator\"\n                                                            pkg-edit-ctrl=\"pkgEditCtrl\">\n                            </package-advanced-metadata-view>\n                        </div>\n                    </uib-tab>\n\n\n                    <!-- Completed Deliveries Tab -->\n                    <uib-tab heading=\"Completed Deliveries\"\n                             select=\"pkgEditCtrl.onTabSelect(\'completedDeliveries\')\"\n                             deselect=\"pkgEditCtrl.onTabDeselect(\'completedDeliveries\', $event)\"\n                             index=\"\'completedDeliveries\'\"\n                             ng-show=\"pkgEditCtrl.validTabs.completedDeliveries && pkgEditCtrl.packageObjectData.revision > 1\">\n                        <div ng-if=\"pkgEditCtrl.activeTabs.completedDeliveries\">\n                            <package-status-bar package-object=\"pkgEditCtrl.packageObjectData\"\n                                                accept-handler=\"pkgEditCtrl.onAcceptPackage()\"\n                                                reject-handler=\"pkgEditCtrl.onRejectPackage()\"\n                                                tab-view-state=\"PACKAGE_COMPLETED_DELIVERIES_VIEW_STATE\">\n                            </package-status-bar>\n                            <package-completed-deliveries-view\n                                class=\"col-md-12 col-lg-12 package-edit-full-height\"\n                                package-object=\"pkgEditCtrl.packageObjectData\"\n                                loading-indicator=\"pkgEditCtrl.loadingIndicator\"\n                                pkg-edit-ctrl=\"pkgEditCtrl\">\n                            </package-completed-deliveries-view>\n                        </div>\n                    </uib-tab>\n\n\n                    <!-- Aggregation Tab -->\n                    <uib-tab heading=\"Aggregation\"\n                             select=\"pkgEditCtrl.onTabSelect(\'aggregation\')\"\n                             deselect=\"pkgEditCtrl.onTabDeselect(\'aggregation\', $event)\"\n                             index=\"\'aggregation\'\"\n                             ng-show=\"pkgEditCtrl.validTabs.aggregation\">\n                        <div ng-if=\"pkgEditCtrl.activeTabs.aggregation\">\n                            <package-status-bar package-object=\"pkgEditCtrl.packageObjectData\"\n                                                accept-handler=\"pkgEditCtrl.onAcceptPackage()\"\n                                                reject-handler=\"pkgEditCtrl.onRejectPackage()\">\n                            </package-status-bar>\n                            <external-ingests-tab\n                                class=\"col-md-12 col-lg-12 package-edit-full-height\"\n                                package-object=\"pkgEditCtrl.packageObjectData\"\n                                loading-indicator=\"pkgEditCtrl.loadingIndicator\"\n                                pkg-edit-ctrl=\"pkgEditCtrl\">\n                            </external-ingests-tab>\n                        </div>\n                    </uib-tab>\n\n                </uib-tabset>\n            </div>\n            <div class=\"row-no-padding manager-toolbar\"\n                 ng-if=\"!pkgEditCtrl.activeTabs.bolt\">\n\n                <div ng-if=\"pkgEditCtrl.activeTabs.liveClip\">\n                    <live-clip-toolbar\n                        paging-options=\"pkgEditCtrl.pagingOptions\"\n                        prev-handler=\"pkgEditCtrl.onPrevPackage()\"\n                        next-handler=\"pkgEditCtrl.onNextPackage()\"\n                        close-handler=\"pkgEditCtrl.onClose()\">\n                    </live-clip-toolbar>\n                </div>\n                <div ng-if=\"!pkgEditCtrl.activeTabs.liveClip\">\n                    <editor-toolbar\n                        context-data=\"pkgEditCtrl.packageObjectData\"\n                        new-handler=\"pkgEditCtrl.onNew()\"\n                        delete-handler=\"pkgEditCtrl.onDelete()\"\n                        add-disabled-handler=\"pkgEditCtrl.onAddDisabled()\"\n                        save-handler=\"pkgEditCtrl.onSave()\"\n                        revert-handler=\"pkgEditCtrl.onRevert()\"\n                        close-handler=\"pkgEditCtrl.onClose()\"\n                        paging-options=\"pkgEditCtrl.pagingOptions\"\n                        prev-handler=\"pkgEditCtrl.onPrevPackage()\"\n                        next-handler=\"pkgEditCtrl.onNextPackage()\"\n                        clone-handler=\"pkgEditCtrl.clonePackage()\"\n                        upload-handler=\"pkgEditCtrl.onUpload()\">\n                    </editor-toolbar>\n                </div>\n\n            </div>\n        </div>\n    </div>\n\n</div>\n");
        $templateCache.put("package/manager/packagemanager-template.html", "<div class=\"loadingIndicator\">\n	<div data-lb-progress=\"searchController.loadingIndicator\" ng-show=\"searchController.loadingIndicator.show\"></div>\n</div>\n<div class=\"row-no-padding\">\n	<div class=\"col-md-12 col-lg-12\">\n		<div ui-grid=\"searchController.currentGridOptions\"\n             id=\"pmGrid\"\n             class=\"grid\"\n             ui-grid-selection\n             ui-grid-pagination\n			 ui-grid-resize-columns\n             ui-grid-save-state></div>\n	</div>\n</div>\n<div class=\"row-no-padding manager-toolbar\" ng-show=\"searchController.pmPerms.read\">\n	<div class=\"col-md-12 col-lg-12\">\n		<form class=\"form-inline toolbar-top-padding-sm\">\n			<div class=\"form-group\">\n				<div class=\"col-md-4 col-lg-4 toolbar-padding\">\n					<a class=\"toolbar-button\" role=\"button\" id=\"pmNewButton\" ng-show=\"searchController.pmPerms.read\" ng-disabled=\"!searchController.pmPerms.write\"\n					   ng-click=\"searchController.pmPerms.write && searchController.showNewPackageModal()\"><i class=\"fa fa-plus\"></i><br>New</a>\n				</div>\n				<div class=\"col-md-4 col-lg-4 toolbar-padding\">\n					<a class=\"toolbar-button\" role=\"button\" id=\"pmEditButton\"\n					   ng-disabled=\"!searchController.pmPerms.write || searchController.selectedPackages.length !== 1\"\n					   ng-click=\"searchController.pmPerms.write && searchController.selectedPackages.length === 1 && searchController.openSelectedPackage()\">\n						<i class=\"fa fa-wrench\"></i><br>Edit\n					</a>\n				</div>\n				<div class=\"col-md-4 col-lg-4 toolbar-padding\">\n					<a class=\"toolbar-button\" role=\"button\" id=\"pmCloneButton\" ng-show=\"searchController.pmPerms.clone.read \"\n					   ng-click=\"searchController.canClone && searchController.openConfirmModal(searchController.cloneMessage, \'Clone \', searchController.cloneSelectedPackages)\"\n					   ng-disabled=\"!searchController.canClone\"><i class=\"fa fa-files-o\"></i><br>Clone</a>\n				</div>\n			</div>\n			<div class=\"form-group\">\n				<div class=\"col-md-5 col-lg-5 toolbar-padding\">\n					<a class=\"toolbar-button\" role=\"button\" id=\"pmHideButton\" ng-disabled=\"searchController.hideInvalid\"\n					   ng-click=\"!searchController.hideInvalid && searchController.openConfirmModal(searchController.hideMessage, \'Hide \', searchController.toggleArchiveFlag)\"><i\n						class=\"fa fa-eye-slash\"></i><br>Hide</a>\n				</div>\n				<div class=\"col-md-7 col-lg-7 toolbar-padding\">\n					<a class=\"toolbar-button\" role=\"button\" id=\"pmUnhideButton\"\n					   ng-disabled=\"searchController.unhideInvalid\"\n					   ng-click=\"!searchController.unhideInvalid && searchController.openConfirmModal(searchController.unhideMessage, \'Unhide \', searchController.toggleArchiveFlag)\"><i\n						class=\"fa fa-eye\"></i><br>Unhide</a>\n				</div>\n			</div>\n			<div class=\"form-group\">\n				<div class=\"col-md-12 col-lg-12\">\n					<dropdown-select id=\"pmActionSelect\" ng-model=\"searchController.selectedAction\"\n									 collection=\"searchController.actions\" btn-min-width=\"250\" sort-collection=\"false\"\n									 show-loading=\"searchController.showActionsLoading\" prompt=\"Select\"\n									 ng-disabled=\"!searchController.actionsEnabled\" dropup=\"true\" label-field=\"label\"\n									 ng-change=\"searchController.handleSelectedAction()\">\n					</dropdown-select>\n				</div>\n			</div>\n			<div class=\"form-group pull-right\">\n				<pagination-controls prev-page-handler=\"searchController.paginationPrevPageHandler()\"\n									 next-page-handler=\"searchController.paginationNextPageHandler()\"\n									 jump-to-page-handler=\"searchController.paginationJumpToPageHandler()\"\n									 paging-options=\"searchController.pagingOptions\" class=\"form-group\"\n                                     page-number-is-text-input=\"true\">\n				</pagination-controls>\n				<div class=\"form-group toolbar-padding\">\n					<div>\n						<input id=\"pmShowHiddenCB\" type=\"checkbox\" ng-change=\"searchController.queryForGridData()\"\n							   ng-model=\"searchController.includeArchived\">\n						<label for=\"pmShowHiddenCB\">Show Hidden</label>\n					</div>\n				</div>\n			</div>\n\n		</form>\n	</div>\n</div>\n");
        $templateCache.put("system/execServers/exec-servers-template.html", "<div class=\"container-fluid no-padding\">\n	<div class=\"row-no-padding\">\n		<navbar></navbar>\n	</div>\n	<div class=\"row-no-padding\">\n		<sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n		<exec-servers-search-view class=\"col-md-10 content-pane\"></exec-servers-search-view>\n	</div>\n</div>\n");
        $templateCache.put("system/externalMetadata/external-metadata-template.html", "<div class=\"container-fluid no-padding\">\n	<div class=\"row-no-padding\">\n		<navbar search-enabled=\"$ctrl.currentTab !== \'setup\'\"></navbar>\n	</div>\n	<div class=\"row-no-padding\">\n		<sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n		<div class=\"col-md-10 col-lg-10 content-pane\">\n\n			<div class=\"row-no-padding\">\n				<!-- Tab Component -->\n				<uib-tabset horizontal=\"true\"\n							type=\"pills\"\n							class=\"edit-view-tabbar\"\n							active=\"$ctrl.currentTab\">\n\n					<uib-tab heading=\"Setup\" index=\"\'setup\'\"\n							 select=\"$ctrl.onTabSelect(\'setup\')\"\n							 deselect=\"$ctrl.onTabDeselect(\'setup\', $event)\">\n						<div ng-if=\"$ctrl.activeTabs.setup\">\n							<external-metadata-grid-view></external-metadata-grid-view>\n						</div>\n					</uib-tab>\n\n                    <!--\n                    <uib-tab heading=\"Queue\" index=\"\'queue\'\"\n                             select=\"$ctrl.onTabSelect(\'queue\')\"\n                             deselect=\"$ctrl.onTabDeselect(\'queue\', $event)\">\n                        <div ng-if=\"$ctrl.activeTabs.queue\">\n                            <external-metadata-queue></external-metadata-queue>\n                        </div>\n                    </uib-tab>\n\n					<uib-tab heading=\"Logging\" index=\"\'logging\'\"\n							 select=\"$ctrl.onTabSelect(\'logging\')\"\n							 deselect=\"$ctrl.onTabDeselect(\'logging\', $event)\">\n						<div ng-if=\"$ctrl.activeTabs.logging\">\n							<external-metadata-system-logging></external-metadata-system-logging>\n						</div>\n					</uib-tab>\n					-->\n\n				</uib-tabset>\n			</div>\n\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("system/livefeed/livefeed-template.html", "<div class=\"container-fluid no-padding\">\n	<div class=\"row-no-padding\">\n		<navbar></navbar>\n	</div>\n	<div class=\"row-no-padding\">\n		<sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n		<livefeed-searchview class=\"col-md-10 content-pane\"></livefeed-searchview>\n	</div>\n</div>\n\n");
        $templateCache.put("system/partner/partner-template.html", "<div class=\"container-fluid no-padding\">\n	<div class=\"row-no-padding\">\n		<navbar></navbar>\n	</div>\n	<div class=\"row-no-padding\">\n		<sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n		<partner-searchview class=\"col-md-10 content-pane\"></partner-searchview>\n	</div>\n</div>\n\n");
        $templateCache.put("components/branding/ratingOverlaySearchView/rating-overlay-search-view-template.html", "<!-- Pacifier -->\n<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\"></div>\n</div>\n\n<div class=\"row-no-padding branding-tree-view\">\n    <div class=\"col-md-12\">\n        <branding-media-search-grid\n            branding-config=\"$ctrl.brandingConfig\"\n            hide-empty=\"$ctrl.hideEmpty\"\n            container=\"$ctrl.container\"\n            media-accept-profiles=\"$ctrl.mediaAcceptProfiles\"\n        ></branding-media-search-grid>\n\n    </div>\n</div>\n\n<div class=\"row-no-padding\">\n    <toolbar right-hand-checkbox-defs=\"$ctrl.toolbarCheckboxDefs\">\n    </toolbar>\n</div>\n");
        $templateCache.put("components/branding/editView/branding-container-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n\n    <!-- Navigation/search toolbar -->\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <!-- Main -->\n    <div class=\"row-no-padding\">\n        <!-- Sidebar -->\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <!-- Content pane -->\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n\n            <!-- Tab component -->\n            <div class=\"row-no-padding\">\n                <breadcrumb tab-name=\"$ctrl.getBreadcrumbName()\"></breadcrumb>\n                <branding-container-properties\n                    class=\"col-md-12 col-lg-12 edit-full-height-no-tabs\"\n                    branding-config=\"$ctrl.brandingConfig\">\n                </branding-container-properties>\n            </div>\n\n        </div>\n    </div>\n\n</div>\n\n");
        $templateCache.put("components/branding/renderers/audio-text-info-renderer-template.html", "<div class=\"form-horizontal\">\n    <div class=\"form-group\">\n        <label for=\"storagePath\" class=\"col-sm-3 control-label lg-txt\">Storage Path:</label>\n        <div class=\"col-sm-9\">\n            <p class=\"form-control-static view-asset-modal-path-text\" id=\"storagePath\" >{{$ctrl.mediaInfo.storagePath}}</p>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <label for=\"archiveStatus\" class=\"col-sm-3 control-label lg-txt\">Storage Class:</label>\n        <div class=\"col-sm-9\">\n            <p class=\"form-control-static\" id=\"archiveStatus\">{{$ctrl.mediaInfo.archiveStatus}}</p>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <label for=\"fileSize\" class=\"col-sm-3 control-label lg-txt\">File Size:</label>\n        <div class=\"col-sm-9\">\n            <p class=\"form-control-static\" id=\"fileSize\">{{$ctrl.mediaInfo.fileSize}}</p>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <label for=\"format\" class=\"col-sm-3 control-label lg-txt\">Format:</label>\n        <div class=\"col-sm-9\">\n            <p class=\"form-control-static\" id=\"format\">{{$ctrl.mediaInfo.fileExtension}}</p>\n        </div>\n    </div>\n    <div class=\"form-group\" ng-show=\"$ctrl.asset.type === \'Image\' || $ctrl.asset.type === \'Video\'\" >\n        <label for=\"dimenisons\" class=\"col-sm-3 control-label lg-txt\">Dimensions:</label>\n        <div class=\"col-sm-9\">\n            <p class=\"form-control-static\" id=\"dimenisons\">{{$ctrl.mediaInfo.width + \'x\' + $ctrl.mediaInfo.height}}</p>\n        </div>\n    </div>\n    <div class=\"form-group\" ng-show=\"$ctrl.asset.type === \'Video\'\">\n        <label for=\"bitDepth\" class=\"col-sm-3 control-label lg-txt\">Bit Depth:</label>\n        <div class=\"col-sm-9\">\n            <p class=\"form-control-static\" id=\"bitDepth\">{{$ctrl.mediaInfo.bitDepth}}</p>\n        </div>\n    </div>\n    <div class=\"form-group\" ng-show=\"$ctrl.asset.type === \'Video\'\">\n        <label for=\"frameRate\" class=\"col-sm-3 control-label lg-txt\">Frame Rate:</label>\n        <div class=\"col-sm-9\">\n            <p class=\"form-control-static\" id=\"frameRate\">{{$ctrl.mediaInfo.frameRate}}</p>\n        </div>\n    </div>\n    <div class=\"form-group\" ng-show=\"$ctrl.asset.type === \'Video\'\">\n        <label for=\"codec\" class=\"col-sm-3 control-label lg-txt\">Codec:</label>\n        <div class=\"col-sm-9\">\n            <p class=\"form-control-static\" id=\"codec\">{{$ctrl.mediaInfo.codec}}</p>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <label for=\"ingestDate\" class=\"col-sm-3 control-label lg-txt\">Ingest Date:</label>\n        <div class=\"col-sm-9\">\n            <p class=\"form-control-static\" id=\"ingestDate\">{{$ctrl.mediaInfo.ingestDate | amDateFormat: \'MM/DD/YYYY HH:mm:ss A\'}}</p>\n        </div>\n    </div>\n    <div class=\"form-group\" ng-if=\"$ctrl.asset.type === \'Image\'\">\n        <label for=\"preview\"  class=\"col-sm-3 control-label lg-txt\">Preview:</label>\n        <div class=\"col-sm-9\">\n            <img id=\"preview\" ng-src=\"{{$ctrl.getProxyContent()}}\" width=\"400\">\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("components/branding/renderers/image-info-renderer-template.html", "<form class=\"form-horizontal\" role=\"form\">\n    <div class=\"form-group\">\n        <label for=\"storagePath\" class=\"col-sm-3 control-label lg-txt\">Storage Path:</label>\n        <div class=\"col-sm-9\">\n            <p class=\"form-control-static view-asset-modal-path-text\" id=\"storagePath\" >{{$ctrl.mediaInfo.storagePath}}</p>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <label for=\"archiveStatus\" class=\"col-sm-3 control-label lg-txt\">Storage Class:</label>\n        <div class=\"col-sm-9\">\n            <p class=\"form-control-static\" id=\"archiveStatus\">{{$ctrl.mediaInfo.archiveStatus}}</p>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <label for=\"fileSize\" class=\"col-sm-3 control-label lg-txt\">File Size:</label>\n        <div class=\"col-sm-9\">\n            <p class=\"form-control-static\" id=\"fileSize\">{{$ctrl.mediaInfo.fileSize}}</p>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <label for=\"format\" class=\"col-sm-3 control-label lg-txt\">Format:</label>\n        <div class=\"col-sm-9\">\n            <p class=\"form-control-static\" id=\"format\">{{$ctrl.mediaInfo.fileExtension}}</p>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <label for=\"videoDimensions\" class=\"col-sm-3 control-label lg-txt\">Dimensions:</label>\n        <div class=\"col-sm-8\">\n            <p class=\"form-control-static\" id=\"videoDimensions\">{{$ctrl.mediaInfo.width + \' x \' + $ctrl.mediaInfo.height}}</p>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <label for=\"bitDepth\" class=\"col-sm-3 control-label lg-txt\">Bit Depth:</label>\n        <div class=\"col-sm-9\">\n            <p class=\"form-control-static\" id=\"bitDepth\">{{$ctrl.mediaInfo.bitDepth}}</p>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <label for=\"ingestDate\" class=\"col-sm-3 control-label lg-txt\">Ingest Date:</label>\n        <div class=\"col-sm-9\">\n            <p class=\"form-control-static\" id=\"ingestDate\">{{$ctrl.mediaInfo.ingestDate | amDateFormat: \'MM/DD/YYYY HH:mm:ss A\'}}</p>\n        </div>\n    </div>\n</form>\n");
        $templateCache.put("components/branding/renderers/video-info-renderer-template.html", "<form class=\"form-horizontal\" role=\"form\">\n	<div class=\"form-group\">\n		<label for=\"storagePath\" class=\"col-sm-3 control-label lg-txt\">Storage Path:</label>\n		<div class=\"col-sm-9\">\n			<p class=\"form-control-static view-asset-modal-path-text\" id=\"storagePath\" >{{$ctrl.mediaInfo.storagePath}}</p>\n		</div>\n	</div>\n	<div class=\"form-group\">\n		<label for=\"archiveStatus\" class=\"col-sm-3 control-label lg-txt\">Storage Class:</label>\n		<div class=\"col-sm-9\">\n			<p class=\"form-control-static\" id=\"archiveStatus\">{{$ctrl.mediaInfo.archiveStatus}}</p>\n		</div>\n	</div>\n	<div class=\"form-group\">\n		<label for=\"fileSize\" class=\"col-sm-3 control-label lg-txt\">File Size:</label>\n		<div class=\"col-sm-9\">\n			<p class=\"form-control-static\" id=\"fileSize\">{{$ctrl.mediaInfo.fileSize}}</p>\n		</div>\n	</div>\n	<div class=\"form-group\">\n		<label for=\"format\" class=\"col-sm-3 control-label lg-txt\">Format:</label>\n		<div class=\"col-sm-9\">\n			<p class=\"form-control-static\" id=\"format\">{{$ctrl.mediaInfo.fileExtension}}</p>\n		</div>\n	</div>\n	<div class=\"form-group\">\n		<label for=\"videoDimensions\" class=\"col-sm-3 control-label lg-txt\">Dimensions:</label>\n		<div class=\"col-sm-8\">\n			<p class=\"form-control-static\" id=\"videoDimensions\">{{$ctrl.mediaInfo.width + \' x \' + $ctrl.mediaInfo.height}}</p>\n		</div>\n	</div>\n	<div class=\"form-group\">\n		<label for=\"bitDepth\" class=\"col-sm-3 control-label lg-txt\">Bit Depth:</label>\n		<div class=\"col-sm-9\">\n			<p class=\"form-control-static\" id=\"bitDepth\">{{$ctrl.mediaInfo.bitDepth}}</p>\n		</div>\n	</div>\n	<div class=\"form-group\">\n		<label for=\"frameRate\" class=\"col-sm-3 control-label lg-txt\">Frame Rate:</label>\n		<div class=\"col-sm-9\">\n			<p class=\"form-control-static\" id=\"frameRate\">{{$ctrl.mediaInfo.frameRate}}</p>\n		</div>\n	</div>\n	<div class=\"form-group\">\n		<label for=\"codec\" class=\"col-sm-3 control-label lg-txt\">Codec:</label>\n		<div class=\"col-sm-9\">\n			<p class=\"form-control-static\" id=\"codec\">{{$ctrl.mediaInfo.codec}}</p>\n		</div>\n	</div>\n	<div class=\"form-group\">\n		<label for=\"ingestDate\" class=\"col-sm-3 control-label lg-txt\">Ingest Date:</label>\n		<div class=\"col-sm-9\">\n			<p class=\"form-control-static\" id=\"ingestDate\">{{$ctrl.mediaInfo.ingestDate | amDateFormat: \'MM/DD/YYYY HH:mm:ss A\'}}</p>\n		</div>\n	</div>\n</form>\n\n<!--<div class=\"modal-footer\">-->\n<!--<button class=\"btn btn-sm btn-default\" ng-click=\"$ctrl.downloadAsset()\">{{$ctrl.resolve.asset.type === \'Video\' ? \'Download Proxy\' : \'Download Source\'}}</button>-->\n<!--<button class=\"btn btn-sm btn-default\" ng-click=\"$ctrl.onDone()\">Done</button>-->\n<!--</div>-->\n");
        $templateCache.put("components/branding/searchView/branding-search-view-template.html", "<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\"></div>\n</div>\n\n<div class=\"row-no-padding branding-tree-view\">\n    <div class=\"col-md-12\">\n        <div id=\"brandingSearchGrid\"\n             class=\"grid\"\n             ui-grid=\"$ctrl.gridOptions\"\n             ui-grid-selection\n             ui-grid-tree-view\n             ui-grid-auto-resize>\n        </div>\n    </div>\n</div>\n\n<div class=\"row-no-padding\">\n    <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"\n             right-hand-checkbox-defs=\"$ctrl.toolbarCheckboxDefs\"></toolbar>\n</div>\n");
        $templateCache.put("components/collaborators/roles/actor-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <!-- Main -->\n    <div class=\"row-no-padding\">\n        <!-- Sidebar -->\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <!-- Content pane -->\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n            <div class=\"loadingIndicator\">\n                <div data-lb-progress=\"$ctrl.loadingIndicator\" ng-show=\"$ctrl.loadingIndicator.show\"></div>\n            </div>\n            <div class=\"row-no-padding\">\n                <div class=\"col-md-12\">\n\n                    <breadcrumb tab-name=\"\'Actor\'\"></breadcrumb>\n\n                    <div class=\"edit-full-height-no-tabs edit-view\">\n                        <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n                            <div class=\"edit-view-container\">\n\n                                <div class=\"row clearfix\">\n                                    <div class=\"col-md-12 column\">\n                                        <div class=\"row\">\n                                            <div class=\"col-md-2\">\n                                                <div class=\"prism-form-heading\">General</div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class=\"row clearfix spacer-top-lg\">\n                                        <div class=\"col-md-12 column\">\n\n                                            <div class=\"form-group\">\n                                                <label for=\"actorName\"\n                                                       class=\"col-sm-2 prism-form-item-label text-align-right\">Actor\n                                                    Name</label>\n                                                <div class=\"col-sm-6\">\n                                                    <p id=\"actorName\">\n                                                        {{($ctrl.editData.collaborator.displayName)}}\n                                                        <a ng-show=\"true\"\n                                                           ng-click=\"$ctrl.changeActorForRole()\"><i class=\"fa fa-pencil\"></i></a>\n                                                    </p>\n                                                </div>\n                                            </div>\n\n                                            <div class=\"form-group\">\n                                                <label for=\"characterName\"\n                                                       class=\"col-sm-2 prism-form-item-label text-align-right\">\n                                                    Character Name\n                                                </label>\n                                                <div class=\"input-radio-button-label\">\n                                                    <input type=\"radio\"\n                                                           class=\"radio-button\"\n                                                           id=\"characterIsCharacterRadioButton\"\n                                                           ng-value=\"false\"\n                                                           ng-model=\"$ctrl.actorIsSelf\"/>\n                                                    <label for=\"characterIsCharacterRadioButton\"\n                                                           class=\"control-label\"></label>\n                                                </div>\n                                                <div class=\"col-sm-5\">\n                                                    <fieldset ng-disabled=\"$ctrl.actorIsSelf\">\n                                                    <input type=\"text\" id=\"characterName\"\n                                                           class=\"form-control prism-text-input\"\n                                                           autocomplete=\"off\"\n                                                           ng-model=\"$ctrl.editData.character\"/>\n                                                    </fieldset>\n                                                </div>\n                                            </div>\n\n                                            <div class=\"form-group\">\n                                                <span class=\"col-sm-offset-2 col-sm-2 prism-form-item-label text-align-right\">\n                                                   <input type=\"radio\"\n                                                          class=\"radio-button\"\n                                                          id=\"characterIsSelfRadioButton\"\n                                                          ng-value=\"true\"\n                                                          ng-model=\"$ctrl.actorIsSelf\"/>\n                                                    <label for=\"characterIsSelfRadioButton\"\n                                                           class=\"control-label\">Self</label>\n                                                </span>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n\n                            </div>\n\n                        </form>\n                    </div>\n\n                </div>\n            </div>\n\n            <div class=\"row-no-padding manager-toolbar\">\n\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"></toolbar>\n\n            </div>\n\n        </div>\n\n    </div>\n\n</div>\n");
        $templateCache.put("components/form/customMetadata/custom-metadata-template.html", "<form class=\"form-horizontal\"\n      name=\"$ctrl.customMetaForm\"\n      role=\"form\">\n\n    <!-- Fields -->\n    <custom-metadata-field\n        ng-repeat=\"componentDef in $ctrl.orderedComponents\"\n\n        component-def=\"componentDef\"\n        component-style-overrides=\"$ctrl.componentStyleOverrides\"\n        disable-components=\"$ctrl.disableComponents\"\n        id-prefix=\"$ctrl.idPrefix\"\n        ignore-preferred-width=\"$ctrl.ignorePreferredWidth\"\n        label-col-size=\"$ctrl.labelColSize\"\n        on-update=\"$ctrl.onUpdate\"\n        revision=\"$ctrl.revision\"\n    ></custom-metadata-field>\n\n</form>\n");
        $templateCache.put("components/grids/default-artwork-maps-grid/default-artwork-maps-grid-template.html", "<button id=\"addDefaultMap\" class=\"btn btn-default prism-button\" ng-click=\"$ctrl.addDefaultMap()\"><i\n        class=\"fa fa-plus\"></i></button>\n<button id=\"removeDefaultMap\" class=\"btn btn-default prism-button\"\n        ng-click=\"$ctrl.removeDefaultMaps()\"><i class=\"fa fa-minus\"></i></button>\n<hr/>\n<div class=\"grid\"\n     id=\"defaultMapsGrid\"\n     ui-grid=\"$ctrl.gridOptions\"\n     ui-grid-selection\n     style=\"width: 720px; height: 450px;\">\n</div>\n");
        $templateCache.put("components/modal/contactsSelectModal/contacts-select-modal-template.html", "<item-select-modal\n    modal-title=\"\'Select Contacts\'\"\n    select-button-text=\"\'Add\'\"\n    loading-indicator=\"$ctrl.loadingIndicator\"\n    execute-search=\"$ctrl.executeSearch(searchText)\"\n\n    grid-is-empty=\"$ctrl.contactsGridOptions.data.length < 1\"\n    on-cancel-clicked=\"$ctrl.dismiss({$value: \'cancel\'})\"\n    on-select-clicked=\"$ctrl.onOk()\"\n    select-button-enabled=\"$ctrl.getSelectedCount() >= 1\">\n\n    <!-- Contacts Grid -->\n    <div id=\"contactsSearchViewGrid\"\n         ui-grid=\"$ctrl.contactsGridOptions\"\n         ui-grid-selection\n         ui-grid-resize-columns>\n    </div>\n\n</item-select-modal>\n");
        $templateCache.put("components/grids/serviceable-languages-grid/serviceable-languages-grid-template.html", "<!--\n - Filename: serviceable-languages-grid-template.html\n -\n - Created by randysorensen on 2019-04-12.\n -->\n\n<div class=\"form-group\">\n    <div class=\"padding-left-md\">\n        <input type=\"radio\"\n               class=\"radio-button\"\n               id=\"allLanguagesRadioBtn\"\n               ng-value=\"false\"\n               ng-model=\"$ctrl.canSelectLanguages\"\n               ng-disabled=\"$ctrl.isDisabled\"\n               ng-change=\"$ctrl.onSelectRadioToggled(false)\"/>\n        <label for=\"allLanguagesRadioBtn\"\n               class=\"control-label\">All</label>\n    </div>\n    <div class=\"padding-left-md\">\n        <input type=\"radio\"\n               class=\"radio-button\"\n               id=\"customLanguagesRadioBtn\"\n               ng-value=\"true\"\n               ng-model=\"$ctrl.canSelectLanguages\"\n               ng-disabled=\"$ctrl.isDisabled\"\n               ng-change=\"$ctrl.onSelectRadioToggled(true)\"/>\n        <label for=\"customLanguagesRadioBtn\"\n               class=\"control-label\">Custom</label>\n    </div>\n</div>\n<div class=\"grid languages-grid\"\n     id=\"languagesGrid\"\n     ng-class=\"{\'protected-grid\': $ctrl.isDisabled || !$ctrl.canSelectLanguages}\"\n     ui-grid=\"$ctrl.gridOptions\"\n     ui-grid-auto-resize\n     ui-grid-selection>\n</div>\n");
        $templateCache.put("components/jsonViewer/gridTemplates/json-property-cell-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\"\n     ng-class=\"{\n        \'cell-contains-a-search-result\' : grid.appScope.$ctrl.cellHasASearchResult(row.entity, col.field),\n        \'cell-contains-current-search-result\' : grid.appScope.$ctrl.cellHasCurrentSearchResult(row.entity, col.field)\n     }\"\n     data-tooltip-append-to-body=\"true\"\n     uib-tooltip=\"{{row.entity.property}}\">\n\n    <span style=\"padding-left: {{row.entity.$$treeLevel * grid.appScope.$ctrl.gridOptions.treeRowHeaderBaseWidth}}px\">\n        {{COL_FIELD CUSTOM_FILTERS}}\n    </span>\n</div>\n");
        $templateCache.put("components/modal/content-category-filter-modal/content-subscription-filter-template.html", "<div class=\"modal-header\">\n    <a id=\"contentFilterXBttn\"\n       href=\"\"\n       ng-click=\"$ctrl.cancel()\"\n    >\n        <i class=\"fa fa-times pull-right\"></i>\n    </a>\n    <h5 class=\"modal-title\">Search Filters</h5>\n</div>\n\n<div class=\"modal-body\">\n    <form class=\"edit-view-container flex-col-container form-horizontal\"\n          role=\"form\">\n        <div class=\"prism-form-heading padding-left-md\">Content Subscription Properties</div>\n        <span class=\"horizontal-spacer-50\"></span>\n\n        <!-- Seasons -->\n        <div class=\"form-group no-margin-bottom padding-left-md\">\n            <label for=\"categorySeasons\"\n                   class=\"control-label\">Season</label>\n            <div class=\"flex-stretcher metadata-control-col\">\n                <dropdown-select\n                    btn-min-width=\"200\"\n                    clearable=\"true\"\n                    collection=\"$ctrl.resolve.availableSeasons\"\n                    enable-select-all=\"true\"\n                    id=\"categorySeasons\"\n                    ignore-locks=\"true\"\n                    label-field=\"name\"\n                    ng-change=\"$ctrl.onSeasonSelected()\"\n                    ng-disabled=\"$ctrl.selectedVolume\"\n                    ng-model=\"$ctrl.selectedSeason\"\n                    prompt=\"Select Season\"\n                >\n                </dropdown-select>\n            </div>\n        </div>\n\n        <!-- Volumes -->\n        <div class=\"form-group padding-left-md\">\n            <label for=\"categoryVolumes\"\n                   class=\"control-label\">Volume</label>\n            <div class=\"flex-stretcher metadata-control-col\">\n                <dropdown-select\n                    btn-min-width=\"200\"\n                    clearable=\"true\"\n                    collection=\"$ctrl.resolve.availableVolumes\"\n                    enable-select-all=\"true\"\n                    id=\"categoryVolumes\"\n                    ignore-locks=\"true\"\n                    label-field=\"name\"\n                    ng-change=\"$ctrl.onVolumeSelected()\"\n                    ng-disabled=\"$ctrl.selectedSeason\"\n                    ng-model=\"$ctrl.selectedVolume\"\n                    prompt=\"Select Volume\"\n                >\n                </dropdown-select>\n            </div>\n        </div>\n\n    </form>\n</div>\n\n\n<div class=\"modal-footer\">\n    <button class=\"btn btn-default btn-sm\"\n            ng-click=\"$ctrl.reset()\">Reset Defaults\n    </button>\n    <button class=\"btn btn-default btn-sm\"\n            ng-click=\"$ctrl.onOk()\">Apply\n    </button>\n</div>\n");
        $templateCache.put("components/modal/content-select-modal/content-select-modal-template.html", "<item-select-modal\n    modal-title=\"\'Select \' + $ctrl.resolve.contentType\"\n    select-button-text=\"\'Select\'\"\n    execute-search=\"$ctrl.executeSearch(searchText)\"\n\n    grid-is-empty=\"$ctrl.gridOptions.data.length < 1\"\n    on-cancel-clicked=\"$ctrl.cancel()\"\n    on-select-clicked=\"$ctrl.onOK()\"\n    select-button-enabled=\"!$ctrl.disableOKButton()\">\n\n    <div id=\"contentSearchListGrid\"\n         ui-grid=\"$ctrl.gridOptions\"\n         class=\"content-grid\"\n         ui-grid-selection\n         ui-grid-auto-resize></div>\n\n</item-select-modal>\n");
        $templateCache.put("components/modal/content-select-modal/locked-content-cell-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\" data-tooltip-append-to-body=\"true\" uib-tooltip=\"{{COL_FIELD}}\">\n	<i class=\"fa fa-lock content-lock\" ng-show=\"row.entity.locked\"></i>\n	<span ng-class=\"row.entity.locked ? \'content-grid-text-lock\' : \'content-grid-text\'\">{{COL_FIELD}}</span>\n</div>\n");
        $templateCache.put("components/modal/email-attachment-modal/email-attachment-modal-template.html", "<item-select-modal\n    modal-title=\"\'Select Partner Delivery Item(s)\'\"\n    select-button-text=\"\'Add\'\"\n    execute-search=\"$ctrl.executeSearch(searchText)\"\n\n    grid-is-empty=\"$ctrl.gridOptions.data.length < 1\"\n    on-cancel-clicked=\"$ctrl.cancel()\"\n    on-select-clicked=\"$ctrl.onOK()\"\n    select-button-enabled=\"!$ctrl.disableOKButton()\">\n\n    <div id=\"attachmentSearchListGrid\"\n         ui-grid=\"$ctrl.gridOptions\"\n         class=\"content-grid\"\n         ui-grid-selection\n         ui-grid-resize-columns></div>\n\n</item-select-modal>\n");
        $templateCache.put("components/modal/file-upload-modal/file-upload-modal-template.html", "<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\">\n    </div>\n</div>\n\n<file-select-modal\n    modal-title=\"\'File Upload\'\"\n    drop-zone-label=\"\'Drop Here\'\"\n    get-file-extensions=\"$ctrl.getFileExtensions()\"\n    initialize-uploader-config=\"$ctrl.initializeLocalUploaderConfig(fileUploaderConfig)\"\n    get-local-file-pre-validation-errors=\"$ctrl.getLocalFilePreValidationErrors(file, filter)\"\n    validate-local-file=\"$ctrl.validateLocalFile(fileItem)\"\n    validate-progress=\"$ctrl.fileUploadProgress\"\n    button-sources=\"[\'LOCAL\']\"\n    button-tooltips=\"$ctrl.buttonTooltips\"\n\n    on-cancel-clicked=\"$ctrl.dismiss({$value: \'cancel\'})\"\n    on-select-clicked=\"$ctrl.close({$value: fileValue.results[0].uploadData})\">\n    <file-select-modal-preview>\n        <img class=\"center-block\" ng-if=\"$ctrl.previewImage\" ng-src=\"{{$ctrl.previewImage}}\"\n             width=\"400\"/>\n    </file-select-modal-preview>\n</file-select-modal>\n");
        $templateCache.put("components/modal/fileProgressModal/file-progress-modal-template.html", "<div class=\"modal-header\">\n    <a id=\"fileProgressModalXBtn\"\n       href=\"\"\n       ng-click=\"$ctrl.close()\">\n        <i class=\"fa fa-times pull-right\"></i>\n    </a>\n    <h5 class=\"modal-title\">File Upload Progress</h5>\n</div>\n\n<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\">\n    </div>\n</div>\n\n<div class=\"modal-body\">\n    <div class=\"row\">\n        <label for=\"showCompletedUploadCheckbox\"\n               class=\"col-md-6 col-lg-3 control-label text-align-right\">\n            Show Completed\n        </label>\n        <div class=\"col-md-6 col-lg-9\">\n            <input type=\"checkbox\"\n                   id=\"showCompletedUploadCheckbox\"\n                   ng-model=\"$ctrl.showCompleted\"\n                   ng-change=\"$ctrl.updateRowFilter()\"/>\n            <label for=\"showCompletedUploadCheckbox\">&nbsp;</label>\n        </div>\n    </div>\n    <div id=\"fileProgressGrid\"\n         ui-grid=\"$ctrl.gridOptions\"\n         class=\"file-progress-grid\"\n         ui-grid-selection\n         ui-grid-auto-resize\n         ui-grid-resize-columns></div>\n</div>\n\n\n<div class=\"modal-footer\">\n    <button class=\"btn btn-default btn-sm\"\n            ng-click=\"$ctrl.clearCompletedUploads()\">Clear Completed\n    </button>\n    <button class=\"btn btn-default btn-sm\"\n            ng-click=\"$ctrl.close()\">Close\n    </button>\n</div>\n");
        $templateCache.put("components/modal/fileSelectModal/file-select-modal-template.html", "<!--\n - Filename: file-select-modal-template.html\n -\n - Created by kyang on 2021-03-25.\n -->\n\n\n<!-- Header -->\n<div class=\"modal-header\">\n    <a id=\"selectModalXBtn\"\n       href=\"\"\n       ng-click=\"$ctrl.onCancelClicked()\">\n        <i class=\"fa fa-times pull-right\"></i>\n    </a>\n    <h5 align=\"center\"\n        class=\"modal-title\">\n        {{$ctrl.modalTitle}}\n    </h5>\n</div>\n\n\n<!-- Body -->\n<div class=\"modal-body\">\n    <div class=\"text-align-center\">\n        {{($ctrl.filePath) ? \'Selected file: \' + $ctrl.filePath : \'\'}}\n    </div>\n\n    <!-- Select Buttons -->\n    <div>\n        <file-select ng-model=\"$ctrl.buttonFile\"\n                     ng-change=\"$ctrl.onFileChanged($ctrl.buttonFile)\"\n                     required\n                     get-file-extensions=\"$ctrl.getFileExtensions()\"\n                     get-local-file-pre-validation-errors=\"$ctrl.getLocalFilePreValidationErrors({file: file, filter: filter})\"\n                     initialize-uploader-config=\"$ctrl.initializeUploaderConfig({fileUploaderConfig: fileUploaderConfig})\"\n                     validate-remote-file=\"$ctrl.validateRemoteFile({fileSystemItem: fileSystemItem})\"\n                     validate-local-file=\"$ctrl.validateLocalFile({fileItem: fileItem})\"\n                     button-sources=\"$ctrl.buttonSources\"\n                     button-tooltips=\"$ctrl.buttonTooltips\"\n                     drag-drop-source=\"null\"\n                     show-validation-error-modal=\"false\">\n        </file-select>\n    </div>\n\n    <div class=\"text-align-center top-margin-md\" ng-if=\"!$ctrl.isValidating()\">\n        OR\n    </div>\n\n    <!-- Drop Well -->\n    <div class=\"top-margin-md\">\n        <file-select ng-model=\"$ctrl.dropFile\"\n                     ng-change=\"$ctrl.onFileChanged($ctrl.dropFile)\"\n                     required\n                     get-file-extensions=\"$ctrl.getFileExtensions()\"\n                     get-local-file-pre-validation-errors=\"$ctrl.getLocalFilePreValidationErrors({file: file, filter: filter})\"\n                     initialize-uploader-config=\"$ctrl.initializeUploaderConfig({fileUploaderConfig: fileUploaderConfig})\"\n                     validate-local-file=\"$ctrl.validateLocalFile({fileItem: fileItem})\"\n                     button-sources=\"null\"\n                     drag-drop-class=\"\'large\'\"\n                     show-validation-error-modal=\"false\">\n        </file-select>\n        <div class=\"center-block\"\n             ng-style=\"{\'visibility\': ($ctrl.isValidating() && \'hidden\')}\">\n            <p class=\"grey-label text-center\">{{$ctrl.dropZoneLabel}}</p>\n        </div>\n\n        <!-- Preview -->\n        <div ng-if=\"$ctrl.okButtonEnabled()\">\n            <ng-transclude ng-transclude-slot=\"preview\"></ng-transclude>\n        </div>\n\n        <!-- Upload status -->\n        <div class=\"center-block\" ng-if=\"$ctrl.validationError\">\n            <p class=\"red-label-lg text-center\">\n                {{$ctrl.validationError}}</p>\n        </div>\n        <div class=\"flex-row-container top-margin-xs\"\n             ng-if=\"$ctrl.isValidating()\">\n            <uib-progressbar ng-if=\"!$ctrl.validateProgress\"\n                class=\"progress-striped active flex-stretcher\"/>\n            <div ng-if=\"$ctrl.validateProgress\"\n                 class=\"progress-container image-upload-progress center-block\">\n                <label class=\"control-label\">Loading:</label>\n                <uib-progress class=\"prism-progress top-margin-xs\">\n                    <uib-bar class=\"prism-progressbar\" value=\"$ctrl.validateProgress\"></uib-bar>\n                </uib-progress>\n            </div>\n        </div>\n    </div>\n</div>\n\n\n<!-- Footer -->\n<div class=\"modal-footer flex-row-container\">\n\n    <!-- Cancel -->\n    <button class=\"btn btn-sm btn-default\"\n            id=\"cancelButton\"\n            ng-click=\"$ctrl.onCancelClicked()\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <!-- Select -->\n    <button class=\"btn btn-sm btn-default\"\n            id=\"selectButton\"\n            ng-click=\"$ctrl.onOkClicked()\"\n            ng-disabled=\"!$ctrl.okButtonEnabled()\">\n        OK\n    </button>\n\n</div>\n");
        $templateCache.put("components/modal/generateAcceptProfileModal/generate-accept-profile-modal-template.html", "<!--\n - Filename: generate-map-modal-template.html\n -\n - Created by kyang on 2021-01-26.\n -->\n\n\n<!-- Loading Indicator -->\n<div class=\"loadingIndicator\" ng-if=\"$ctrl.loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\"></div>\n</div>\n\n<file-select-modal\n    modal-title=\"\'Derive Media Accept Profile Values from Media\'\"\n    drop-zone-label=\"$ctrl.dropZoneLabel\"\n    get-file-extensions=\"$ctrl.getFileExtensions()\"\n    get-local-file-pre-validation-errors=\"$ctrl.getLocalFilePreValidationErrors(file, filter)\"\n    initialize-uploader-config=\"$ctrl.initializeLocalUploaderConfig(fileUploaderConfig)\"\n    validate-remote-file=\"$ctrl.validateRemoteFile(fileSystemItem)\"\n    validate-local-file=\"$ctrl.validateLocalFile(fileItem)\"\n    on-cancel-clicked=\"$ctrl.onCancelClicked()\"\n    on-select-clicked=\"$ctrl.onOkClicked(fileValue)\">\n</file-select-modal>\n");
        $templateCache.put("components/modal/item-select-modal/item-select-modal-template.html", "<!--\n - Filename: item-select-select-modal-template.html\n -\n - Created by kyang on 2019-06-17.\n -->\n\n\n<!-- Header -->\n<div class=\"modal-header\">\n    <a id=\"selectModalXBtn\"\n       href=\"\"\n       ng-click=\"$ctrl.onCancelClicked()\">\n        <i class=\"fa fa-times pull-right\"></i>\n    </a>\n    <h5 align=\"center\"\n        class=\"modal-title\">\n        {{$ctrl.modalTitle}}\n    </h5>\n</div>\n\n\n<!-- Loading Indicator -->\n<div class=\"loadingIndicator\" ng-if=\"$ctrl.loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\"></div>\n</div>\n\n\n<!-- Body -->\n<div class=\"modal-body\">\n\n    <!-- Search Bar -->\n    <div class=\"row\">\n        <div class=\"col-sm-5\">\n        </div>\n        <div class=\"col-sm-7\">\n\n            <!-- Label -->\n            <label for=\"titleSearch\"\n                   class=\"col-sm-3\">\n                Search\n            </label>\n\n            <div id=\"titleSearch\"\n                 class=\"input-group input-group-sm col-sm-9\">\n\n                <!-- Input -->\n                <input type=\"text\"\n                       ng-change=\"$ctrl.executeSearch({searchText: $ctrl.searchText})\"\n                       class=\"prism-text-input form-control\"\n                       ng-model=\"$ctrl.searchText\"\n                       ng-disabled=\"$ctrl.gridIsEmpty() && !$ctrl.searchText\"/>\n\n                <!-- Search Button -->\n                <a id=\"searchButton\"\n                   class=\"input-group-addon btn  btn-xs\"\n                   ng-click=\"$ctrl.onSearchRefresh && $ctrl.onSearchRefresh({searchText: $ctrl.searchText}) || $ctrl.executeSearch({searchText: $ctrl.searchText})\"\n                   ng-disabled=\"$ctrl.gridIsEmpty()\">\n                    <i class=\"fa fa-refresh\"></i>\n                </a>\n\n            </div>\n\n        </div>\n    </div>\n    <hr />\n\n    <!-- Search Grid -->\n    <ng-transclude></ng-transclude>\n\n</div>\n\n\n<!-- Footer -->\n<div class=\"modal-footer flex-row-container\">\n\n    <!-- Cancel -->\n    <button class=\"btn btn-sm btn-default\"\n            id=\"cancelButton\"\n            ng-click=\"$ctrl.onCancelClicked()\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <!-- Select -->\n    <button class=\"btn btn-sm btn-default\"\n            id=\"selectButton\"\n            ng-click=\"$ctrl.onSelectClicked()\"\n            ng-disabled=\"!$ctrl.selectButtonEnabled()\">\n        {{$ctrl.selectButtonText}}\n    </button>\n\n</div>\n");
        $templateCache.put("components/modal/jsonViewerModal/json-viewer-modal-template.html", "<div class=\"modal-header\">\n    <span class=\"modal-title\">JSON Viewer</span>\n</div>\n\n<div class=\"modal-body\">\n    <json-viewer\n        json-data-promise=\"$ctrl.jsonDataPromise\"\n        use-native-search=\"true\">\n    </json-viewer>\n</div>\n\n<div class=\"modal-footer\">\n    <div class=\"row\">\n        <div class=\"col-sm-12\">\n            <div class=\"form-inline\">\n                <div class=\"form-group padding-left-md\">\n                    <button class=\"btn btn-sm btn-default\"\n                            uib-tooltip=\"Copies the Context JSON Data to the clipboard\"\n                            ng-click=\"$ctrl.onCopyContextDataClicked()\">\n                        <i class=\"fa fa-copy\"></i> Copy to Clipboard\n                    </button>\n                    <button class=\"btn btn-sm btn-default\"\n                            ng-click=\"$ctrl.dismiss()\">\n                        Dismiss\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("components/modal/media-modal/media-modal-template.html", "<div class=\"modal-header\">\n    <div class=\"pull-right\">\n    </div>\n    <h4 class=\"modal-title\">Media Viewer</h4>\n</div>\n\n<div class=\"modal-body\">\n    <div class=\"row\">\n        <div>\n            <div ng-if=\"mediaModal.type === \'video\' || mediaModal.type === \'clip\'\">\n                <div ng-if=\"!mediaModal.perms.canViewProxy\">\n                    <p class=\"text-center\">\n                        <i class=\"fa fa-lock\">&nbsp;</i> Access denied. You do not have permission to view this content.\n                    </p>\n                </div>\n                <proxy-player ng-if=\"mediaModal.media && mediaModal.perms.canViewProxy\"\n                              media=\"mediaModal.media\">&nbsp;</proxy-player>\n            </div>\n            <div class=\"text-align-center\"\n                 ng-if=\"mediaModal.type === \'watermark\' || mediaModal.type === \'artwork\' || mediaModal.type === \'image\' || mediaModal.type === \'ratingOverlay\'\">\n                <img style=\"max-width:800px\"\n                     ng-if=\"mediaModal.media.mediaPath\"\n                     ng-src=\"{{ mediaModal.media.mediaPath }}\"/>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"modal-footer\">\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"mediaModal.downloadAsset()\"\n            ng-if=\"mediaModal.type === \'clip\' && mediaModal.perms.canDownloadProxy\">\n        Download Proxy\n    </button>\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"mediaModal.onDone()\">\n        Done\n    </button>\n</div>\n");
        $templateCache.put("components/modal/metadata-item-editor/component-previews-template.html", "<form role=\"form\" class=\"form-horizontal\">\n	<div class=\"edit-view-container\">\n		<div class=\"form-group preview-tooltip\">\n			<div class=\"row-no-padding\">\n				<label class=\"control-label\">Preview:</label>\n			</div>\n\n			<!-- Checkbox -->\n			<div ng-if=\"tooltipData.label == \'CheckBox\'\">\n				<div class=\"v-align\">\n					<label class=\"control-label col-md-6\" for=\"cbPreview\">Checkbox</label>\n					<div class=\"col-md-1\">\n						<input id=\"cbPreview\"\n							   type=\"checkbox\"\n							   ng-model=\"tooltipData.model\">\n						<label class=\"control-label\" for=\"cbPreview\"></label>\n					</div>\n					<div class=\"col-md-5\"></div>\n				</div>\n			</div>\n\n			<!-- CheckboxList -->\n			<div class=\"checkbox-list-md v-align\"\n				 ng-if=\"tooltipData.label == \'CheckboxList\'\">\n				<checkbox-list items=\"tooltipData.items\"\n							   ng-model=\"tooltipData.model\"></checkbox-list>\n			</div>\n\n			<!-- DateField -->\n			<div class=\"date-time preview-date\"\n				 ng-if=\"tooltipData.label == \'DateField\'\">\n				<date-picker\n					ng-model=\"tooltipData.model\">\n				</date-picker>\n			</div>\n\n			<!-- DateFieldEnhanced -->\n			<div class=\"date-enhanced\"\n				 ng-if=\"tooltipData.label == \'DateFieldEnhanced\'\">\n				<date-time-enhanced\n					show-time=\"false\"\n					ng-model=\"tooltipData.model\">\n				</date-time-enhanced>\n			</div>\n\n			<!-- DateTimeField -->\n			<div class=\"row-no-padding date-time\"\n				 ng-if=\"tooltipData.label == \'DateTimeField\'\">\n				<date-time-picker\n					ng-model=\"tooltipData.model\">\n				</date-time-picker>\n			</div>\n\n			<!-- DateTimeFieldEnhanced -->\n			<div class=\"date-time-enhanced\"\n				 ng-if=\"tooltipData.label == \'DateTimeFieldEnhanced\'\"\n				 ng-model=\"tooltipData.model\">\n				<date-time-enhanced\n					class=\"v-align\"\n					show-time=\"true\"\n					ng-model=\"tooltipData.model\">\n				</date-time-enhanced>\n			</div>\n\n			<!-- DropDownList -->\n			<div class=\"preview-dropdown\"\n				 ng-if=\"tooltipData.label == \'DropDownList\'\">\n				<!-- Note: You can\'t have two open drop-downs on one page, so we have\n					 	   to fake this one.\n\n				<dropdown-select class=\"open\"\n					collection=\"tooltipData.collection\"\n					label-field=\"label\"\n					default-open=\"true\"\n					attach-to-body=\"true\"\n					ng-model=\"tooltipData.model\">\n				</dropdown-select>\n				-->\n				<div class=\"btn-group dropdown open\">\n					<button type=\"button\" class=\"btn btn-default prism-button dropdown-toggle preview-dropdown-menu\">\n						<i class=\"fa fa-sort dropdown-arrows pull-right\"></i>\n						Item 1\n					</button>\n					<ul uib-dropdown-menu role=\"menu\" class=\"dropdown-menu preview-dropdown-menu\">\n						<li role=\"menuitem\">Item 1</li>\n						<li role=\"menuitem\">Item 2</li>\n						<li role=\"menuitem\">Item 3</li>\n					</ul>\n				</div>\n			</div>\n\n			<!-- TextListInput -->\n			<div ng-if=\"tooltipData.label === \'TextListInput\'\">\n				<text-list-input items=\"tooltipData.items\"></text-list-input>\n			</div>\n\n			<!-- List -->\n			<div ng-if=\"tooltipData.label == \'List\'\">\n				<prism-list items=\"tooltipData.items\" label-field=\"label\" ng-model=\"tooltipData.model\" model-prop=\"label\"></prism-list>\n			</div>\n\n			<!-- TextArea -->\n			<div class=\"preview-text\"\n				 ng-if=\"tooltipData.label == \'TextArea\'\">\n				<div class=\"char-counter-input-container\">\n					<textarea\n						class=\"form-control prism-text-input preview-text-input\"\n						rows=\"4\"\n						ng-model=\"tooltipData.model\">\n					</textarea>\n				</div>\n				<div class=\"char-counter-container\">\n					<div class=\"label character-counter\">488</div>\n				</div>\n			</div>\n\n			<!-- TextInput -->\n			<div class=\"preview-text\"\n				 ng-if=\"tooltipData.label == \'TextInput\'\">\n				<div class=\"char-counter-input-container\">\n					<input\n						class=\"form-control prism-text-input preview-text-input\"\n						type=\"text\"\n						ng-model=\"tooltipData.model\">\n					</input>\n				</div>\n				<div class=\"char-counter-container\">\n					<div class=\"label character-counter\">38</div>\n				</div>\n			</div>\n\n			<!-- TimeCodeInput -->\n			<div ng-if=\"tooltipData.label == \'TimeCodeInput\'\">\n				<timecode-input ng-model=\"tooltipData.model\"></timecode-input>\n			</div>\n\n			<!-- TimeInput -->\n			<div ng-if=\"tooltipData.label == \'TimeInput\'\">\n				<prism-time-picker ng-model=\"tooltipData.model\"></prism-time-picker>\n			</div>\n\n		</div>\n	</div>\n</form>\n");
        $templateCache.put("components/modal/metadata-item-editor/metadata-item-edit-modal-template.html", "<div class=\"modal-header\">\n	<a id=\"metaItemEditWndXBtn\" href=\"\"\n	   ng-click=\"$ctrl.dismiss({$value: \'cancel\'})\">\n		<i class=\"fa fa-times pull-right\"></i>\n	</a>\n	<span class=\"modal-title\">Create/Edit Custom Metadata Item</span>\n</div>\n\n<div class=\"modal-body metadata-item-edit-modal scrolling-modal\">\n    <div class=\"loadingIndicator\">\n        <div data-lb-progress=\"$ctrl.loadingIndicator\"\n             ng-show=\"$ctrl.loadingIndicator.show\">\n        </div>\n    </div>\n\n	<form role=\"form\" class=\"form-horizontal\"\n		  name=\"$ctrl.metaItemEditForm\">\n\n		<div class=\"edit-view-container\">\n			<div>\n				General\n			</div>\n\n			<div class=\"form-group v-align\">\n				<label class=\"control-label col-md-6 padding-bottom-sm\">\n					Name\n				</label>\n				<div class=\"col-md-5\">\n					<input id=\"displayName\" class=\"prism-text-input\"\n						   type=\"text\"\n						   ng-model=\"$ctrl.metadataItem.displayName\"/>\n				</div>\n				<div class=\"required-text-input\"\n					 required\n					 x-required-indicator>\n				</div>\n			</div>\n\n			<div class=\"form-group v-align\"\n				 ng-show=\"$ctrl.resolve.propertyId > -1\">\n				<label class=\"control-label col-md-6 padding-bottom-sm\">\n					Property Name\n				</label>\n				<div class=\"col-md-6\">\n					<span id=\"name\">{{ $ctrl.metadataItem.name }}</span>\n				</div>\n			</div>\n\n			<div class=\"form-group v-align\">\n				<label class=\"control-label col-md-6 padding-bottom-sm\">\n					Type\n				</label>\n				<div class=\"col-md-5\">\n					<multiselect-dropdown id=\"group\"\n										  ng-model=\"$ctrl.groupNames\"\n										  collection=\"$ctrl.groupList\"\n										  btn-min-width=\"200\"\n										  enable-select-all=\"true\"\n										  ng-disabled=\"$ctrl.resolve.conversion || (($ctrl.resolve.propertyId > -1 || $ctrl.groupList.length === 1) && !$ctrl.resolve.mvpd)\"\n                                          class=\"hide-required-indicator\"\n                                          required>\n					</multiselect-dropdown>\n				</div>\n				<div class=\"required-text-input\"\n					 required\n					 x-required-indicator>\n				</div>\n			</div>\n\n			<div class=\"form-group v-align\"\n				 ng-if=\"$ctrl.resolve.ownerClass === \'partner\' && !$ctrl.resolve.mvpd\">\n				<label class=\"control-label col-md-6 padding-bottom-sm\">\n					Partners\n				</label>\n				<div class=\"col-md-5\">\n					<multiselect-dropdown id=\"partners\"\n										  ng-model=\"$ctrl.selectedPartners\"\n										  collection=\"$ctrl.partnerDropdownCollection\"\n										  btn-min-width=\"175\"\n										  label-field=\"name\"\n										  model-prop=\"id\"\n										  enable-select-all=\"true\"\n                                          class=\"hide-required-indicator\"\n                                          required>\n					</multiselect-dropdown>\n				</div>\n				<div class=\"required-text-input\"\n					 required\n					 x-required-indicator>\n				</div>\n			</div>\n\n			<div class=\"form-group v-align\">\n				<label class=\"control-label col-md-6 padding-bottom-sm\">\n					Component\n				</label>\n				<div class=\"col-md-5\">\n					<dropdown-select id=\"type\"\n									 ng-model=\"$ctrl.component\"\n									 ng-change=\"$ctrl.metadataItem.uiControlHint = $ctrl.component.label\"\n									 collection=\"$ctrl.componentList\"\n									 btn-min-width=\"200\"\n									 label-field=\"label\"\n									 tooltip-template=\"$ctrl.tooltipTemplate\"\n									 tooltip-class=\"preview-tooltip\"\n									 ng-disabled=\"$ctrl.resolve.propertyId > -1\">\n					</dropdown-select>\n				</div>\n				<div class=\"required-text-input\"\n					 required\n					 x-required-indicator>\n				</div>\n			</div>\n\n			<div class=\"form-group v-align\"\n				 ng-show=\"$ctrl.isPickList()\">\n				<label class=\"control-label col-md-6 padding-bottom-sm\">\n					Picklist\n				</label>\n				<div class=\"col-md-5\">\n					<editable-list\n						collection=\"$ctrl.picklistItems\"\n						label-field=\"displayName\"\n						change-handler=\"$ctrl.onPicklistChange()\">\n					</editable-list>\n				</div>\n				<div class=\"required-text-input\"\n					 required\n					 x-required-indicator>\n				</div>\n			</div>\n\n            <!--ABC-9392 - Package Metadata Items - Added Default Value-->\n			<div class=\"form-group v-align\"\n				 ng-show=\"($ctrl.resolve.ownerClass === \'package\' || $ctrl.resolve.ownerClass === \'partner\' || $ctrl.resolve.conversion) && !$ctrl.resolve.mvpd\">\n				<label class=\"control-label col-md-6 padding-bottom-sm\">\n					Default Value\n				</label>\n				<div class=\"col-md-6\">\n					<input id=\"defaultValue\" class=\"prism-text-input\"\n						   type=\"text\"\n						   ng-model=\"$ctrl.metadataItem.defaultValue\"/>\n				</div>\n			</div>\n\n			<div class=\"form-group v-align\">\n				<label class=\"control-label col-md-6\" for=\"excludeFromMetadata\">\n                    Suppress from Metadata XML, Hierarchical Metadata and Reports\n				</label>\n				<div class=\"col-md-6 padding-top-sm\">\n					<input id=\"excludeFromMetadata\"\n						   type=\"checkbox\"\n                           ng-disabled=\"$ctrl.resolve.conversion\"\n						   ng-model=\"$ctrl.metadataItem.excludeFromMetadata\"/>\n					<label class=\"control-label\" for=\"excludeFromMetadata\">\n					</label>\n				</div>\n			</div>\n\n			<!-- Package Specific Flags -->\n			<div class=\"form-group\"\n				 ng-show=\"$ctrl.resolve.ownerClass === \'package\'\">\n				<div class=\"row\">\n					<div class=\"form-group v-align\">\n\n						<label class=\"control-label col-md-6\" for=\"packageAdvanced\">\n							Advanced\n						</label>\n						<div class=\"col-md-1 padding-top-sm\">\n							<input id=\"packageAdvanced\"\n								   type=\"checkbox\"\n								   ng-model=\"$ctrl.metadataItem.advanced\"/>\n							<label class=\"control-label\" for=\"packageAdvanced\">\n							</label>\n						</div>\n					</div>\n				</div>\n			</div>\n\n			<!-- Partner-specific flags -->\n			<div class=\"form-group\">\n				<div class=\"row\" ng-show=\"$ctrl.resolve.ownerClass === \'partner\' && !$ctrl.resolve.mvpd\">\n					<div class=\"form-group v-align\">\n\n						<label class=\"control-label col-md-6\" for=\"advanced\">\n							Advanced\n						</label>\n						<div class=\"col-md-1 padding-top-sm\">\n							<input id=\"advanced\"\n								   type=\"checkbox\"\n								   ng-model=\"$ctrl.metadataItem.advanced\"/>\n							<label class=\"control-label\" for=\"advanced\">\n							</label>\n						</div>\n\n						<label class=\"control-label col-md-3\" for=\"searchable\">\n							Search Partner Properties\n						</label>\n						<div class=\"col-md-2 padding-top-sm\">\n							<input id=\"searchable\"\n								   type=\"checkbox\"\n								   ng-model=\"$ctrl.metadataItem.searchable\"/>\n							<label class=\"control-label\" for=\"searchable\">\n							</label>\n						</div>\n\n					</div>\n				</div>\n\n                <!--ABC-9392 - Package Metadata Items - Added Live Update and Always Live fields-->\n				<div class=\"row\" ng-show=\"($ctrl.resolve.ownerClass === \'package\' || $ctrl.resolve.ownerClass === \'partner\') && !$ctrl.resolve.mvpd\">\n					<div class=\"form-group v-align\">\n\n						<label class=\"control-label col-md-6\" for=\"liveUpdate\">\n							Live Update\n						</label>\n						<div class=\"col-md-1 padding-top-sm\">\n							<input id=\"liveUpdate\"\n								   type=\"checkbox\"\n								   ng-model=\"$ctrl.metadataItem.liveUpdate\"/>\n							<label class=\"control-label\" for=\"liveUpdate\">\n							</label>\n						</div>\n\n						<label class=\"control-label col-md-3\" for=\"alwaysLive\"\n							   ng-class=\"{\'disabled-label\' : !$ctrl.metadataItem.liveUpdate}\"\n							   ng-disabled=\"!$ctrl.metadataItem.liveUpdate\">\n							Always Live\n						</label>\n						<div class=\"col-md-2 padding-top-sm\">\n							<input id=\"alwaysLive\"\n								   type=\"checkbox\"\n								   ng-disabled=\"!$ctrl.metadataItem.liveUpdate\"\n								   ng-model=\"$ctrl.metadataItem.alwaysLive\"/>\n							<label class=\"control-label\" for=\"alwaysLive\" ng-disabled=\"!$ctrl.metadataItem.liveUpdate\">\n							</label>\n						</div>\n\n					</div>\n				</div>\n\n\n				<div class=\"row\" ng-show=\"$ctrl.resolve.ownerClass === \'partner\' && !$ctrl.resolve.mvpd\">\n					<div class=\"form-group v-align\">\n\n						<label class=\"control-label col-md-6\" for=\"synchronizeClips\">\n							Inherited by Clips\n						</label>\n						<span class=\"col-md-1 padding-top-sm\">\n							<input id=\"synchronizeClips\"\n								   type=\"checkbox\"\n								   ng-model=\"$ctrl.metadataItem.synchronizeClips\"/>\n							<label class=\"control-label\" for=\"synchronizeClips\">\n							</label>\n						</span>\n\n						<label class=\"control-label col-md-3\" for=\"liveUpdate\">\n							<!-- next checkbox could go here -->\n						</label>\n						<div class=\"col-md-2 padding-top-sm\">\n							<!-- -->\n						</div>\n\n					</div>\n				</div>\n			</div>\n		</div>\n\n		<hr/>\n\n		<div class=\"edit-view-container\">\n			<div>\n				Display\n			</div>\n\n            <div class=\"form-group v-align\">\n                <label class=\"control-label col-md-6 padding-bottom-sm\" for=\"visible\">\n                    Visible\n                </label>\n                <div class=\"col-md-6\">\n                    <input id=\"visible\"\n                           type=\"checkbox\"\n                           ng-model=\"$ctrl.metadataItem.visible\"/>\n                    <label class=\"control-label\" for=\"visible\">\n                    </label>\n                </div>\n            </div>\n\n			<div class=\"form-group v-align\">\n				<label class=\"control-label col-md-6 padding-bottom-sm\">\n					Display Order\n				</label>\n				<div class=\"col-md-6\">\n					<input id=\"displayIndex\" class=\"prism-text-input\"\n						   type=\"text\"\n						   ng-model=\"$ctrl.metadataItem.displayIndex\"/>\n				</div>\n			</div>\n\n			<div class=\"form-group v-align\"\n				 ng-show=\"$ctrl.showDisplayWidth()\">\n				<label class=\"control-label col-md-6 padding-bottom-sm\">\n					Width\n				</label>\n				<div class=\"col-md-6\">\n					<!--\n						Make this a \"dropup\" selector when the \"Height (lines)\" field\n						isn\'t present (as there\'s insufficient vertical space\n						otherwise).\n					-->\n					<dropdown-select id=\"preferredWidth\"\n									 clearable=\"true\"\n									 dropup=\"$ctrl.metadataItem.uiControlHint !== \'TextArea\'\"\n									 ng-model=\"$ctrl.preferredWidth\"\n									 collection=\"$ctrl.preferredWidthList\"\n									 btn-min-width=\"200\">\n					</dropdown-select>\n				</div>\n			</div>\n\n			<div class=\"form-group v-align\"\n				 ng-show=\"$ctrl.metadataItem.uiControlHint === \'TextArea\'\">\n				<label class=\"control-label col-md-6 padding-bottom-sm\">\n					Height (lines)\n				</label>\n				<div class=\"col-md-6\">\n					<input id=\"preferredHeight\" class=\"prism-text-input\"\n						   type=\"text\"\n						   ng-model=\"$ctrl.metadataItem.preferredHeight\"/>\n				</div>\n			</div>\n\n			<div class=\"form-group v-align\"\n				 ng-show=\"$ctrl.showMaxCharacterCount()\">\n				<label class=\"control-label col-md-6 padding-bottom-sm\">\n					Max. Character Count\n				</label>\n				<div class=\"col-md-6\">\n					<input id=\"maxCharacterCount\" class=\"prism-text-input\"\n						   type=\"text\"\n						   ng-model=\"$ctrl.metadataItem.maxCharacterCount\"/>\n				</div>\n			</div>\n		</div>\n	</form>\n</div>\n\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.dismiss({$value: \'cancel\'})\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.onSave()\"\n            ng-disabled=\"!$ctrl.canSave()\">\n        OK\n    </button>\n</div>\n");
        $templateCache.put("components/modal/moveDirectoryModal/move-directory-modal-template.html", "<item-select-modal\n    modal-title=\"\'Select File System\'\"\n    select-button-text=\"\'Move\'\"\n    loading-indicator=\"$ctrl.loadingIndicator\"\n    execute-search=\"$ctrl.executeSearch(searchText)\"\n\n    grid-is-empty=\"$ctrl.gridOptions.data.length < 1\"\n    on-cancel-clicked=\"$ctrl.dismiss({$value: \'cancel\'})\"\n    on-select-clicked=\"$ctrl.onOk()\"\n    select-button-enabled=\"$ctrl.getSelectedCount() == 1\">\n\n    <!-- Directory Grid -->\n    <div id=\"directoryMoveGrid\"\n         ui-grid=\"$ctrl.gridOptions\"\n         ui-grid-selection\n         ui-grid-resize-columns>\n    </div>\n\n</item-select-modal>\n");
        $templateCache.put("components/modal/partnerPackageAcceptReject/partner-package-accept-reject-modal-template.html", "<div class=\"modal-header\">\n    <span class=\"modal-title\">{{$ctrl.resolve.action}} {{$ctrl.resolve.partnerPackagePartnerName}} Partner Package</span>\n</div>\n\n<div class=\"modal-body\">\n    <div class=\"row clearfix\">\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n                <div class=\"row-no-padding\">\n                    <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n                        <div class=\"form-group\">\n                            <label for=\"approvalMessage\"\n                                   class=\"col-sm-2 control-label\">\n                                Message\n                            </label>\n                            <div class=\"col-sm-9 pad-text-input-col\">\n                                <textarea type=\"text\"\n                                          rows=\"8\"\n                                          id=\"approvalMessage\"\n                                          class=\"prism-text-input form-control\"\n                                          ng-model=\"$ctrl.approvalMessage\">\n                                </textarea>\n                            </div>\n                        </div>\n\n                    </form>\n                </div>\n            </div>\n        </div>\n    </div>\n\n\n</div>\n\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.dismiss({$value: \'cancel\'})\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default pull-right\"\n            ng-click=\"$ctrl.onDone()\">\n        {{$ctrl.resolve.action}}\n    </button>\n</div>\n");
        $templateCache.put("components/modal/queue-priority-modal/queue-priority-modal-template.html", "<!-- Header -->\n<div class=\"modal-header\">\n    <a id=\"selectModalXBtn\"\n       href=\"\"\n       ng-click=\"$ctrl.onCancelClicked()\">\n        <i class=\"fa fa-times pull-right\"></i>\n    </a>\n    <h5 class=\"modal-title\">Modify Queue Steps</h5>\n</div>\n\n<!-- Body -->\n<div class=\"modal-body edit-view-container\">\n    <form class=\"flex-col-container form-horizontal\"\n          name=\"$ctrl.editorForm\"\n          role=\"form\">\n\n        <div class=\"col-md-2\">\n            <div class=\"prism-form-heading\">General</div>\n        </div>\n\n        <!-- Priority -->\n        <div class=\"form-group padding-left-md\">\n            <label for=\"priority\"\n                   class=\"col-sm-2 control-label\">\n                Priority\n            </label>\n            <div class=\"col-sm-3 pad-text-input-col\">\n                <input\n                    class=\"form-control prism-text-input\"\n                    id=\"priority\"\n                    ng-model=\"$ctrl.priority\"\n                    pattern=\"\\d+\"\n                    required\n                    step=\"1\"\n                    type=\"number\"/>\n            </div>\n        </div>\n\n    </form>\n</div>\n\n<!-- Footer -->\n<div class=\"modal-footer flex-row-container padding-left-md\">\n    <!-- Cancel -->\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.onCancelClicked()\">\n        Cancel\n    </button>\n    <span class=\"flex-stretcher\"><!-- Spacer --></span>\n\n    <!-- Accept -->\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.onOkClicked()\"\n            ng-disabled=\"!$ctrl.okButtonEnabled()\">\n        OK\n    </button>\n</div>\n");
        $templateCache.put("components/modal/subscription-properties-modal/custom-metadata-container-template.html", "<div ng-if=\"!$ctrl.batchUpdate || ($ctrl.batchUpdate && $ctrl.isPartner)\">\n    <form class=\"form-horizontal\"\n          role=\"form\">\n        <div id=\"customMetadataContainer\"\n             class=\"edit-view-container\">\n            <div>\n                Custom\n            </div>\n            <uib-accordion class=\"accordion-header\"\n                           close-others=\"false\">\n\n                <!-- Accordion Containers -->\n                <div uib-accordion-group\n                     id=\"mainMetaContainer\"\n                     class=\"accordion-header\"\n                     is-open=\"$ctrl.customMetaContainers.mainContainer\">\n                    <uib-accordion-heading>\n                        Main Metadata\n                        <i class=\"pull-right glyphicon\"\n                           ng-class=\"{\'glyphicon-chevron-down\' : $ctrl.customMetaContainers.mainContainer,\n						   \'glyphicon-chevron-right\' : !$ctrl.customMetaContainers.mainContainer}\">\n                        </i>\n                    </uib-accordion-heading>\n                    <custom-metadata-component main=\"\'Main\'\"\n                                               metadata=\"$ctrl.subscription.metadata.properties\"\n                                               batch-update-enabled=\"$ctrl.batchUpdate\"\n                                               partner-meta=\"$ctrl.partnerMetadata\">\n                    </custom-metadata-component>\n                </div>\n\n                <div ng-if=\"$ctrl.isSeasonVolumeMetaValid()\">\n                    <div uib-accordion-group\n                         id=\"seasonVolumeMetaContainer\"\n                         class=\"accordion-header\"\n                         is-open=\"$ctrl.customMetaContainers.mainSeasonVolumeContainer\">\n                        <uib-accordion-heading>\n                            Season/Volume Metadata\n                            <i class=\"pull-right glyphicon\"\n                               ng-class=\"{\'glyphicon-chevron-down\' : $ctrl.customMetaContainers.mainSeasonVolumeContainer,\n						   \'glyphicon-chevron-right\' : !$ctrl.customMetaContainers.mainSeasonVolumeContainer}\">\n                            </i>\n                        </uib-accordion-heading>\n\n                        <uib-accordion class=\"accordion-header\"\n                                       close-others=\"true\">\n                            <div ng-switch=\"$ctrl.subscription.seasonSubscription\">\n                                <div ng-switch-when=\"true\">\n                                    <div ng-repeat=\"season in $ctrl.subscription.seasons | orderBy: \'season.name\'\">\n                                        <div ng-if=\"$ctrl.showSeasonVolumeContainer(season)\">\n                                            <div uib-accordion-group\n                                                 class=\"accordion-header\"\n                                                 is-open=\"$ctrl.customMetaContainers.seasonContainers[season.season.name]\">\n                                                <uib-accordion-heading>\n                                                    {{season.season.name}}\n                                                    <i class=\"pull-right glyphicon\"\n                                                       ng-class=\"{\'glyphicon-chevron-down\' : $ctrl.customMetaContainers.seasonContainers[season.season.name],\n						  					  \'glyphicon-chevron-right\' : !$ctrl.customMetaContainers.seasonContainers[season.season.name]}\">\n                                                    </i>\n                                                </uib-accordion-heading>\n\n                                                <custom-metadata-component season-volume=\"season.season\"\n                                                                           metadata=\"season.metadata.properties\"\n                                                                           batch-update-enabled=\"$ctrl.batchUpdate\"\n                                                                           partner-meta=\"$ctrl.partnerMetadata\">\n                                                </custom-metadata-component>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div ng-switch-when=\"false\">\n                                    <div ng-repeat=\"volume in $ctrl.subscription.volumes | orderBy: \'volume.name\'\">\n                                        <div ng-if=\"$ctrl.showSeasonVolumeContainer(volume)\">\n                                            <div uib-accordion-group\n                                                 class=\"accordion-header\"\n                                                 is-open=\"$ctrl.customMetaContainers.volumeContainers[volume.volume.name]\">\n                                                <uib-accordion-heading>\n                                                    {{volume.volume.name}}\n                                                    <i class=\"pull-right glyphicon\"\n                                                       ng-class=\"{\'glyphicon-chevron-down\' : $ctrl.customMetaContainers.volumeContainers[volume.volume.name],\n						  			   		   \'glyphicon-chevron-right\' : !$ctrl.customMetaContainers.volumeContainers[volume.volume.name]}\">\n                                                    </i>\n                                                </uib-accordion-heading>\n\n                                                <custom-metadata-component seasonVolume=\"volume.volume\"\n                                                                           metadata=\"volume.metadata.properties\"\n                                                                           batch-update-enabled=\"$ctrl.batchUpdate\"\n                                                                           partner-meta=\"$ctrl.partnerMetadata\">\n                                                </custom-metadata-component>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </uib-accordion>\n                    </div>\n                </div>\n            </uib-accordion>\n        </div>\n    </form>\n</div>\n");
        $templateCache.put("components/modal/subscription-properties-modal/custom-metadata-template.html", "<div ng-repeat=\"partnerMetadataItem in $ctrl.partnerMeta\">\n\n    <!-- Batch Update Row -->\n    <div class=\"flex-row-container padding-right-lg\"\n         ng-if=\"$ctrl.batchUpdateEnabled\">\n        <span class=\"flex-stretcher\"></span>\n        <label class=\"prism-checkbox-inline control-label\">\n            <input id=\"Updated_{{$ctrl.generateComponentId(partnerMetadataItem.name, partnerMetadataItem.uiControlHint, false)}}\"\n                   type=\"checkbox\"\n                   ng-model=\"$ctrl.metadata[partnerMetadataItem.name].includeInBatchUpdate\"/>\n            <label ng-class=\"{ \'red-label\' : $ctrl.metadata[partnerMetadataItem.name].includeInBatchUpdate }\"\n                   for=\"Updated_{{$ctrl.generateComponentId(partnerMetadataItem.name, partnerMetadataItem.uiControlHint, false)}}\">\n                Batch Update\n            </label>\n        </label>\n    </div>\n\n    <!-- Metadata Field Row -->\n    <div class=\"row padding-top-md\">\n        <fieldset ng-disabled=\"$ctrl.batchUpdateEnabled && !$ctrl.metadata[partnerMetadataItem.name].includeInBatchUpdate\">\n            <div class=\"col-sm-12\">\n\n                <!-- Field Name Column -->\n                <label class=\"col-sm-3 control-label\"\n                       ng-class=\"{ \'red-label\' : $ctrl.metadata[partnerMetadataItem.name].includeInBatchUpdate }\">\n                    {{partnerMetadataItem.displayName}}\n                </label>\n\n                <!-- Field Editor Column -->\n                <div class=\"col-sm-9 form-group form-group-custom\">\n                    <div ng-switch=\"partnerMetadataItem.uiControlHint\">\n\n                        <!-- Checkbox -->\n                        <div ng-switch-when=\"CheckBox\">\n                            <div class=\"form-group form-group-custom\">\n                                <input type=\"radio\"\n                                       ng-model=\"$ctrl.metadata[partnerMetadataItem.name].isExpression\"\n                                       ng-value=\"false\"\n                                       id=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, \'radio\', false)}}\"\n                                       class=\"col-sm-2 no-padding\"/>\n                                <label for=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, \'radio\', false)}}\"\n                                       class=\"col-sm-1 no-padding\"></label>\n                                <div class=\"col-sm-1 checkbox-custom\">\n                                    <input type=\"checkbox\"\n                                           ng-disabled=\"$ctrl.metadata[partnerMetadataItem.name].isExpression\"\n                                           id=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, partnerMetadataItem.uiControlHint, false)}}\"\n                                           ng-model=\"$ctrl.metadata[partnerMetadataItem.name].value\"/>\n                                    <label for=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, partnerMetadataItem.uiControlHint, false)}}\"></label>\n                                </div>\n                                <div class=\"col-sm-1\">\n                                    <input type=\"radio\"\n                                           id=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, \'radio\', true)}}\"\n                                           ng-model=\"$ctrl.metadata[partnerMetadataItem.name].isExpression\"\n                                           ng-value=\"true\"/>\n                                    <label for=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, \'radio\', true)}}\"\n                                           class=\"control-label\">Expression</label>\n                                </div>\n                            </div>\n                            <expression-field custom-meta-obj=\"$ctrl.metadata[partnerMetadataItem.name]\"\n                                              partner-meta-item=\"partnerMetadataItem\">\n                            </expression-field>\n                            <div ng-if=\"!!partnerMetadataItem.defaultValue\">\n                                <div class=\"sub-default-value\">\n                                    <div class=\"default-value-tooltip\"\n                                         uib-tooltip=\"{{partnerMetadataItem.defaultValue}}\"\n                                         tooltip-append-to-body=\"true\">\n                                        <label class=\"default-value-label control-label\"><i>Default Value: </i></label>\n                                        <label class=\"default-value control-label\"><i>{{partnerMetadataItem.defaultValue}}</i></label>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n\n                        <!-- DateField -->\n                        <div ng-switch-when=\"DateField\">\n                            <div class=\"form-group form-group-custom\">\n                                <input type=\"radio\"\n                                       id=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, \'radio\', false)}}\"\n                                       ng-model=\"$ctrl.metadata[partnerMetadataItem.name].isExpression\"\n                                       ng-value=\"false\"/>\n                                <label for=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, \'radio\', false)}}\"\n                                       class=\"col-sm-1 no-padding\"></label>\n                                <fieldset ng-disabled=\"$ctrl.metadata[partnerMetadataItem.name].isExpression\"\n                                          class=\"col-sm-3\">\n                                    <date-picker id=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, partnerMetadataItem.uiControlHint, false)}}\"\n                                                 ng-model=\"$ctrl.metadata[partnerMetadataItem.name].value\"\n                                                 timezone-offset-millis=\"\'SERVER\'\">\n                                    </date-picker>\n                                </fieldset>\n                                <div class=\"col-sm-1\">\n                                    <input type=\"radio\"\n                                           id=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, \'radio\', true)}}\"\n                                           ng-model=\"$ctrl.metadata[partnerMetadataItem.name].isExpression\"\n                                           ng-value=\"true\"/>\n                                    <label for=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, \'radio\', true)}}\"\n                                           class=\"control-label\">Expression</label>\n                                </div>\n                            </div>\n                            <expression-field custom-meta-obj=\"$ctrl.metadata[partnerMetadataItem.name]\"\n                                              partner-meta-item=\"partnerMetadataItem\">\n                            </expression-field>\n                            <div ng-if=\"!!partnerMetadataItem.defaultValue\">\n                                <div class=\"sub-default-value\">\n                                    <div class=\"default-value-tooltip\"\n                                         uib-tooltip=\"{{partnerMetadataItem.defaultValue}}\"\n                                         tooltip-append-to-body=\"true\">\n                                        <label class=\"default-value-label control-label\"><i>Default Value: </i></label>\n                                        <label class=\"default-value control-label\"><i>{{partnerMetadataItem.defaultValue}}</i></label>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n\n                        <!-- DateTimeField -->\n                        <div ng-switch-when=\"DateTimeField\">\n                            <div class=\"form-group form-group-custom\">\n                                <input type=\"radio\"\n                                       id=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, \'radio\', false)}}\"\n                                       ng-model=\"$ctrl.metadata[partnerMetadataItem.name].isExpression\"\n                                       ng-value=\"false\"/>\n                                <label for=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, \'radio\', false)}}\"\n                                       class=\"col-sm-1\"></label>\n                                <div class=\"col-lg-6\">\n                                    <fieldset ng-disabled=\"$ctrl.metadata[partnerMetadataItem.name].isExpression\"\n                                              class=\"custom-datetime-fieldset\">\n                                        <date-time-picker id=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, partnerMetadataItem.uiControlHint, false)}}\"\n                                                          ng-model=\"$ctrl.metadata[partnerMetadataItem.name].value\">\n                                        </date-time-picker>\n                                    </fieldset>\n                                </div>\n                                <div class=\"col-sm-1\">\n                                    <input type=\"radio\"\n                                           id=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, \'radio\', true)}}\"\n                                           ng-model=\"$ctrl.metadata[partnerMetadataItem.name].isExpression\"\n                                           ng-value=\"true\"/>\n                                    <label for=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, \'radio\', true)}}\"\n                                           class=\"control-label\">Expression</label>\n                                </div>\n                            </div>\n                            <expression-field custom-meta-obj=\"$ctrl.metadata[partnerMetadataItem.name]\"\n                                              partner-meta-item=\"partnerMetadataItem\">\n                            </expression-field>\n                            <div ng-if=\"!!partnerMetadataItem.defaultValue\">\n                                <div class=\"sub-default-value\">\n                                    <div class=\"default-value-tooltip\"\n                                         uib-tooltip=\"{{partnerMetadataItem.defaultValue}}\"\n                                         tooltip-append-to-body=\"true\">\n                                        <label class=\"default-value-label control-label\"><i>Default Value: </i></label>\n                                        <label class=\"default-value control-label\"><i>{{partnerMetadataItem.defaultValue}}</i></label>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n\n                        <!-- DateTimeFieldEnhanced -->\n                        <div ng-switch-when=\"DateTimeFieldEnhanced\">\n                            <div class=\"form-group form-group-custom\">\n                                <input type=\"radio\"\n                                       id=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, \'radio\', false)}}\"\n                                       ng-model=\"$ctrl.metadata[partnerMetadataItem.name].isExpression\"\n                                       ng-value=\"false\"/>\n                                <label for=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, \'radio\', false)}}\"\n                                       class=\"col-sm-1 no-padding\"></label>\n                                <div class=\"col-sm-7 padding-bottom-sm\">\n                                    <fieldset ng-disabled=\"$ctrl.metadata[partnerMetadataItem.name].isExpression\">\n                                        <div class=\"custom-meta-date-time\">\n                                            <date-time-enhanced ng-model=\"$ctrl.metadata[partnerMetadataItem.name].value\"\n                                                                show-time=\"true\"\n                                                                component-name=\"customDateTimeEnhanced\">\n                                            </date-time-enhanced>\n                                        </div>\n                                    </fieldset>\n                                </div>\n                                <div class=\"col-sm-1\">\n                                    <input type=\"radio\"\n                                           id=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, \'radio\', true)}}\"\n                                           ng-model=\"$ctrl.metadata[partnerMetadataItem.name].isExpression\"\n                                           ng-value=\"true\"/>\n                                    <label for=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, \'radio\', true)}}\"\n                                           class=\"control-label\">Expression</label>\n                                </div>\n                            </div>\n                            <expression-field custom-meta-obj=\"$ctrl.metadata[partnerMetadataItem.name]\"\n                                              partner-meta-item=\"partnerMetadataItem\">\n                            </expression-field>\n                            <div ng-if=\"!!partnerMetadataItem.defaultValue\">\n                                <div class=\"sub-default-value\">\n                                    <div class=\"default-value-tooltip\"\n                                         uib-tooltip=\"{{partnerMetadataItem.defaultValue}}\"\n                                         tooltip-append-to-body=\"true\">\n                                        <label class=\"default-value-label control-label\"><i>Default Value: </i></label>\n                                        <label class=\"default-value control-label\"><i>{{partnerMetadataItem.defaultValue}}</i></label>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n\n                        <!-- DateFieldEnhanced -->\n                        <div ng-switch-when=\"DateFieldEnhanced\">\n                            <div class=\"form-group form-group-custom\">\n                                <input type=\"radio\"\n                                       id=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, \'radio\', false)}}\"\n                                       ng-model=\"$ctrl.metadata[partnerMetadataItem.name].isExpression\"\n                                       ng-value=\"false\"/>\n                                <label for=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, \'radio\', false)}}\"\n                                       class=\"col-sm-1 no-padding\"></label>\n                                <fieldset ng-disabled=\"$ctrl.metadata[partnerMetadataItem.name].isExpression\"\n                                          class=\"col-sm-6\">\n                                    <div class=\"custom-meta-date-time\">\n                                        <date-time-enhanced ng-model=\"$ctrl.metadata[partnerMetadataItem.name].value\"\n                                                            show-time=\"false\"\n                                                            component-name=\"customDateEnhanced\">\n                                        </date-time-enhanced>\n                                    </div>\n                                </fieldset>\n                                <div class=\"col-sm-1\">\n                                    <input type=\"radio\"\n                                           id=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, \'radio\', true)}}\"\n                                           ng-model=\"$ctrl.metadata[partnerMetadataItem.name].isExpression\"\n                                           ng-value=\"true\"/>\n                                    <label for=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, \'radio\', true)}}\"\n                                           class=\"control-label\">Expression</label>\n                                </div>\n                            </div>\n                            <expression-field custom-meta-obj=\"$ctrl.metadata[partnerMetadataItem.name]\"\n                                              partner-meta-item=\"partnerMetadataItem\">\n                            </expression-field>\n                            <div ng-if=\"!!partnerMetadataItem.defaultValue\">\n                                <div class=\"sub-default-value\">\n                                    <div class=\"default-value-tooltip\"\n                                         uib-tooltip=\"{{partnerMetadataItem.defaultValue}}\"\n                                         tooltip-append-to-body=\"true\">\n                                        <label class=\"default-value-label control-label\"><i>Default Value: </i></label>\n                                        <label class=\"default-value control-label\"><i>{{partnerMetadataItem.defaultValue}}</i></label>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n\n                        <!-- TimeInput -->\n                        <div ng-switch-when=\"TimeInput\">\n                            <div class=\"padding-bottom-sm form-group form-group-custom\">\n                                <input type=\"radio\"\n                                       id=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, \'radio\', false)}}\"\n                                       ng-model=\"$ctrl.metadata[partnerMetadataItem.name].isExpression\"\n                                       ng-value=\"false\"\n                                       class=\"col-md-1 no-padding\"/>\n                                <label for=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, \'radio\', false)}}\"\n                                       class=\"col-sm-1 no-padding\"></label>\n                                <div class=\"col-sm-3\">\n                                    <fieldset ng-disabled=\"$ctrl.metadata[partnerMetadataItem.name].isExpression\"\n                                              class=\"no-padding\">\n                                        <prism-time-picker id=\"{{partnerMetadataItem.name + \'TimePicker\' + $index}}\"\n                                                         ng-model=\"$ctrl.metadata[partnerMetadataItem.name].value\">\n                                        </prism-time-picker>\n                                    </fieldset>\n                                </div>\n                                <div class=\"col-sm-1\">\n                                    <input type=\"radio\"\n                                           id=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, \'radio\', true)}}\"\n                                           ng-model=\"$ctrl.metadata[partnerMetadataItem.name].isExpression\"\n                                           ng-value=\"true\"/>\n                                    <label for=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, \'radio\', true)}}\"\n                                           class=\"control-label\">Expression</label>\n                                </div>\n                            </div>\n                            <expression-field custom-meta-obj=\"$ctrl.metadata[partnerMetadataItem.name]\"\n                                              partner-meta-item=\"partnerMetadataItem\">\n                            </expression-field>\n                            <div ng-if=\"!!partnerMetadataItem.defaultValue\">\n                                <div class=\"sub-default-value\">\n                                    <div class=\"default-value-tooltip\"\n                                         uib-tooltip=\"{{partnerMetadataItem.defaultValue}}\"\n                                         tooltip-append-to-body=\"true\">\n                                        <label class=\"default-value-label control-label\"><i>Default Value: </i></label>\n                                        <label class=\"default-value control-label\"><i>{{partnerMetadataItem.defaultValue}}</i></label>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n\n                        <!-- TextInput -->\n                        <div ng-switch-when=\"TextInput\">\n                            <div ng-switch=\"$ctrl.isTextExpression($ctrl.metadata[partnerMetadataItem.name])\">\n                                <div ng-switch-when=\"true\">\n                                    <enhanced-textarea ng-model=\"$ctrl.metadata[partnerMetadataItem.name].expression\"\n                                                       input-rows=\"4\"\n                                                       id=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, partnerMetadataItem.uiControlHint, true)}}\"\n                                                       autocomplete=\"off\">\n                                    </enhanced-textarea>\n                                </div>\n                                <div ng-switch-when=\"false\">\n                                    <enhanced-textarea ng-model=\"$ctrl.metadata[partnerMetadataItem.name].value\"\n                                                       input-rows=\"4\"\n                                                       id=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, partnerMetadataItem.uiControlHint, false)}}\"\n                                                       autocomplete=\"off\">\n                                    </enhanced-textarea>\n                                </div>\n                            </div>\n                            <div ng-if=\"!!partnerMetadataItem.defaultValue\">\n                                <div class=\"sub-default-value\">\n                                    <div class=\"default-value-tooltip\"\n                                         uib-tooltip=\"{{partnerMetadataItem.defaultValue}}\"\n                                         tooltip-append-to-body=\"true\">\n                                        <label class=\"default-value-label control-label\"><i>Default Value: </i></label>\n                                        <label class=\"default-value control-label\"><i>{{partnerMetadataItem.defaultValue}}</i></label>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n\n                        <!-- TextArea -->\n                        <div ng-switch-when=\"TextArea\">\n                            <div ng-switch=\"$ctrl.isTextExpression($ctrl.metadata[partnerMetadataItem.name])\">\n                                <div ng-switch-when=\"true\">\n                                    <enhanced-textarea ng-model=\"$ctrl.metadata[partnerMetadataItem.name].expression\"\n                                                       input-rows=\"4\"\n                                                       id=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, partnerMetadataItem.uiControlHint, true)}}\"\n                                                       autocomplete=\"off\">\n                                    </enhanced-textarea>\n                                </div>\n                                <div ng-switch-when=\"false\">\n                                    <enhanced-textarea ng-model=\"$ctrl.metadata[partnerMetadataItem.name].value\"\n                                                       input-rows=\"4\"\n                                                       id=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, partnerMetadataItem.uiControlHint, false)}}\"\n                                                       autocomplete=\"off\">\n                                    </enhanced-textarea>\n                                </div>\n                            </div>\n                            <div ng-if=\"!!partnerMetadataItem.defaultValue\">\n                                <div class=\"sub-default-value\">\n                                    <div class=\"default-value-tooltip\"\n                                         uib-tooltip=\"{{partnerMetadataItem.defaultValue}}\"\n                                         tooltip-append-to-body=\"true\">\n                                        <label class=\"default-value-label control-label\"><i>Default Value: </i></label>\n                                        <label class=\"default-value control-label\"><i>{{partnerMetadataItem.defaultValue}}</i></label>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n\n                        <!-- DropDownList -->\n                        <div ng-switch-when=\"DropDownList\">\n                            <dropdown-select clearable=\"true\"\n                                             id=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, partnerMetadataItem.uiControlHint, false)}}\"\n                                             ng-model=\"$ctrl.metadata[partnerMetadataItem.name].value\"\n                                             collection=\"partnerMetadataItem.picklistItems\"\n                                             model-prop=\"id\"\n                                             value-prop=\"displayName\"\n                                             label-field=\"displayName\"\n                                             btn-min-width=\"295\"\n                                             prompt=\"\">\n                            </dropdown-select>\n                            <div ng-if=\"!!partnerMetadataItem.defaultValue\">\n                                <div class=\"sub-default-value\">\n                                    <div class=\"default-value-tooltip\"\n                                         uib-tooltip=\"{{partnerMetadataItem.defaultValue}}\"\n                                         tooltip-append-to-body=\"true\">\n                                        <label class=\"default-value-label control-label\"><i>Default Value: </i></label>\n                                        <label class=\"default-value control-label\"><i>{{partnerMetadataItem.defaultValue}}</i></label>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n\n                        <!-- CheckboxList -->\n                        <div ng-switch-when=\"CheckboxList\">\n                            <checkbox-list id=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, partnerMetadataItem.uiControlHint, false)}}\"\n                                           items=\"partnerMetadataItem.picklistItems\"\n                                           ng-model=\"$ctrl.metadata[partnerMetadataItem.name].value\">\n                            </checkbox-list>\n                            <div ng-if=\"!!partnerMetadataItem.defaultValue\">\n                                <div class=\"sub-default-value\">\n                                    <div class=\"default-value-tooltip\"\n                                         uib-tooltip=\"{{partnerMetadataItem.defaultValue}}\"\n                                         tooltip-append-to-body=\"true\">\n                                        <label class=\"default-value-label control-label\"><i>Default Value: </i></label>\n                                        <label class=\"default-value control-label\"><i>{{partnerMetadataItem.defaultValue}}</i></label>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n\n                        <!-- TextListInput -->\n                        <div ng-switch-when=\"TextListInput\">\n                            <text-list-input id=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, partnerMetadataItem.uiControlHint, false)}}\"\n                                             items=\"$ctrl.metadata[partnerMetadataItem.name].value\"\n                                             on-update=\"$ctrl.onUpdate(event)\">\n                            </text-list-input>\n                            <div ng-if=\"!!partnerMetadataItem.defaultValue\">\n                                <div class=\"sub-default-value\">\n                                    <div class=\"default-value-tooltip\"\n                                         uib-tooltip=\"{{partnerMetadataItem.defaultValue}}\"\n                                         tooltip-append-to-body=\"true\">\n                                        <label class=\"default-value-label control-label\"><i>Default Value: </i></label>\n                                        <label class=\"default-value control-label\"><i>{{partnerMetadataItem.defaultValue}}</i></label>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n\n                        <!-- List -->\n                        <div ng-switch-when=\"List\">\n                            <prism-list id=\"{{$ctrl.generateComponentId(partnerMetadataItem.name, partnerMetadataItem.uiControlHint, false)}}\"\n                                      items=\"partnerMetadataItem.picklistItems\"\n                                      label-field=\"displayName\"\n                                      class=\"col-sm-3 no-padding\"\n                                      ng-model=\"$ctrl.metadata[partnerMetadataItem.name].value\"\n                                      model-prop=\"id\">\n                            </prism-list>\n                            <div ng-if=\"!!partnerMetadataItem.defaultValue\">\n                                <div class=\"sub-default-value\">\n                                    <div class=\"default-value-tooltip\"\n                                         uib-tooltip=\"{{partnerMetadataItem.defaultValue}}\"\n                                         tooltip-append-to-body=\"true\">\n                                        <label class=\"default-value-label control-label\"><i>Default Value: </i></label>\n                                        <label class=\"default-value control-label\"><i>{{partnerMetadataItem.defaultValue}}</i></label>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </fieldset>\n    </div>\n\n    <hr class=\"gray-hrule\"/>\n</div>\n");
        $templateCache.put("components/modal/subscription-properties-modal/subscription-properties-modal-template.html", "<div class=\"modal-header\">\n    <a id=\"metadataPropertiesEditWndXBtn\" href=\"\"\n       ng-click=\"$ctrl.dismiss({$value: \'cancel\'})\">\n        <i class=\"fa fa-times pull-right\"></i>\n    </a>\n    <span class=\"modal-title\">{{($ctrl.isPartner) ? $ctrl.subscription.content.name : $ctrl.subscription.partner.name}} - Subscription Properties - {{$ctrl.content.type}}</span>\n</div>\n\n<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\"></div>\n</div>\n\n<div class=\"modal-body metadata-item-edit-modal scrolling-modal subscription-properties-modal\">\n    <form role=\"form\" class=\"form-horizontal\"\n          name=\"$ctrl.editorForm\">\n        <div ng-if=\"!$ctrl.content || $ctrl.content.type === \'Series\' || $ctrl.content.type === \'Movie/Special\'\"\n             ng-include=\"\'components/modal/subscription-properties-modal/renderers/series-movie-subscription-properties-template.html\'\"></div>\n        <div ng-if=\"$ctrl.content.type === \'Ad/PreRoll\'\"\n             ng-include=\"\'components/modal/subscription-properties-modal/renderers/ads-and-prerolls-properties-template.html\'\"></div>\n    </form>\n</div>\n\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.dismiss({$value: \'cancel\'})\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"($ctrl.isOkEnabled()) ? $ctrl.onOk() : $event.stopImmediatePropagation()\"\n            ng-class=\"{\'disabled-label\' : !$ctrl.isOkEnabled()}\">\n        OK\n    </button>\n</div>\n");
        $templateCache.put("components/modal/view-asset-modal/view-asset-modal-template.html", "<!-- Header -->\n<div class=\"modal-header\">\n    <h3 class=\"modal-title\">\n        Asset Info\n    </h3>\n</div>\n\n\n<!-- Body -->\n<div class=\"modal-body flex-col-container view-asset-modal\">\n\n    <!-- Pacifier -->\n    <div class=\"loadingIndicator\">\n        <div data-lb-progress=\"$ctrl.loadingIndicator\"\n             ng-show=\"$ctrl.loadingIndicator.show\">\n        </div>\n    </div>\n\n\n    <!-- Media Info -->\n    <ng-include src=\"$ctrl.contentTemplateUrl\">&nbsp;</ng-include>\n\n\n    <!-- Audio Tracks -->\n    <div class=\"form-group\"\n         ng-if=\"$ctrl.isVideoModal() && $ctrl.packageContent.audioTrackDescriptors\">\n        <label for=\"audioTracksGrid\"\n               class=\"col-sm-2 control-label lg-txt\">\n            Audio Tracks:\n        </label>\n        <div id=\"audioTracksGrid\"\n             class=\"col-sm-9 search-grid asset-audio-tracks-grid\"\n             ui-grid=\"$ctrl.audioTracksGridOptions\"\n             ui-grid-auto-resize>\n        </div>\n    </div>\n\n\n    <!-- Asset Preview -->\n    <hr ng-if=\"$ctrl.showPreviewContainer()\"/>\n    <uib-accordion class=\"preview-accordion\"\n                   ng-if=\"$ctrl.showPreviewContainer()\">\n\n        <div uib-accordion-group\n             id=\"previewAccordionGroup\"\n             class=\"preview-accordion-group\"\n             is-open=\"$ctrl.previewExpanded\">\n\n            <uib-accordion-heading>\n                <h4>\n                    Preview &nbsp;\n                    <i class=\" glyphicon\"\n                       ng-class=\"{\'glyphicon-chevron-down\' : $ctrl.previewExpanded,\n                                  \'glyphicon-chevron-right\' : !$ctrl.previewExpanded}\">\n                    </i>\n                </h4>\n            </uib-accordion-heading>\n\n\n            <div class=\"flex-row-container preview-media-container\">\n                <span class=\"flex-stretcher\">&nbsp;</span>\n\n                <!-- Video/Audio Preview -->\n                <div ng-if=\"$ctrl.showProxyPlayer()\"\n                     class=\"preview-media\">\n                    <proxy-player ng-if=\"!!$ctrl.getMediaPath()\"\n                                  framerate=\"$ctrl.mediaInfo.framerate\"\n                                  isAudio=\"$ctrl.isAudio()\"\n                                  media=\"$ctrl.packageContent\">\n                    </proxy-player>\n\n                    <!-- No Proxy Stub -->\n                    <img ng-if=\"!$ctrl.getMediaPath()\"\n                         ng-src=\"assets/images/no-proxy-16x9.png\"/>\n                </div>\n\n                <!-- Image Preview -->\n                <div ng-if=\"$ctrl.showImagePreview()\">\n                    <img ng-if=\"!!$ctrl.getMediaPath()\"\n                         class=\"preview-media\"\n                         ng-src=\"{{$ctrl.getMediaPath()}}\">\n\n                    <!-- No Proxy Stub -->\n                    <img ng-if=\"!$ctrl.getMediaPath()\"\n                         ng-src=\"assets/images/no-proxy.png\"/>\n                </div>\n\n                <span class=\"flex-stretcher\">&nbsp;</span>\n            </div>\n\n        </div> <!-- uib-accordion-group -->\n\n    </uib-accordion>\n</div>\n\n\n<!-- Footer -->\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default flex-align-start\"\n            ng-click=\"$ctrl.downloadProxy()\"\n            ng-disabled=\"!$ctrl.canDownloadProxy()\">\n        Download Proxy\n    </button>\n    <button class=\"btn btn-sm btn-default flex-align-end\"\n            ng-click=\"$ctrl.downloadSource()\"\n            ng-disabled=\"!$ctrl.canDownloadSource()\">\n        Download Source\n    </button>\n    <span class=\"flex-stretcher\">&nbsp;</span>\n    <button class=\"btn btn-sm btn-default flex-align-end\"\n            ng-click=\"$ctrl.onDone()\">\n        Done\n    </button>\n</div>\n");
        $templateCache.put("components/navigation/breadcrumb/breadcrumb-template.html", "<div class=\"breadcrumb-custom\">\n	<a ng-click=\"breadCrumbCtrl.navigateToBreadCrumb(item)\" ng-repeat=\"item in breadCrumbCtrl.breadcrumbs\">\n		<i class=\"fa fa-caret-right\" ng-if=\"$index > 0\"></i>\n		<p class=\"breadcrumb-label\">{{item.name}}</p>\n	</a>\n	<i class=\"fa fa-caret-right\" ng-if=\"breadCrumbCtrl.tabName\"></i>\n	<span> <p class=\"breadcrumb-label\">{{breadCrumbCtrl.tabName}}</p> </span>\n</div>\n");
        $templateCache.put("components/navigation/navbar/navbar-template.html", "<nav class=\"navbar navbar-default\">\n    <div class=\"container-fluid\">\n        <!-- Collect the nav links, forms, and other content for toggling -->\n        <div class=\"collapse navbar-collapse\"\n             id=\"bs-example-navbar-collapse-1\">\n            <ul class=\"nav navbar-nav\">\n                <li class=\"dropdown\">\n                    <a href=\"\"\n                       class=\"dropdown-toggle\"\n                       data-toggle=\"dropdown\"\n                       role=\"button\"\n                       aria-expanded=\"false\">\n                        <img src=\"assets/images/default-user-icon.png\"/> {{$ctrl.username()}}\n                        <span class=\"caret\"></span>\n                    </a>\n                    <ul class=\"dropdown-menu\"\n                        role=\"menu\">\n                        <li><a class=\"btn btn-link\"\n                               ng-click=\"$ctrl.logout()\">Logout</a></li>\n                        <li><a class=\"btn btn-link\"\n                               ng-if=\"$ctrl.canChangePassword\"\n                               ng-click=\"$ctrl.openChangePasswordModal()\">Reset Password</a></li>\n                    </ul>\n                </li>\n            </ul>\n\n            <form class=\"navbar-form navbar-left\"\n                  role=\"search\"\n                  ng-keyup=\"$event.keyCode === 13 && $ctrl.setSearchText()\"\n                  ng-show=\"$ctrl.searchEnabled\">\n                <div class=\"form-group\">\n                    <div class=\"input-group input-group-sm\">\n                        <input id=\"text\"\n                               size=\"50\"\n                               type=\"text\"\n                               class=\"navbar-textfield form-control\"\n                               ng-model=\"$ctrl.keywords\"\n                               ng-model-options=\"{getterSetter: true}\">\n                        <a class=\"input-group-addon btn navbar-refresh-btn btn-xs\"\n                           ng-click=\"$ctrl.setSearchText(true)\">\n                            <i class=\"fa fa-refresh\"></i>\n                        </a>\n                        <a class=\"input-group-addon btn navbar-refresh-btn btn-xs\"\n                           ng-if=\"$ctrl.showNextPreviousButtons\"\n                           ng-click=\"$ctrl.findPrevious()\">\n                            <i class=\"fa fa-arrow-up\"></i>\n                        </a>\n                        <a class=\"input-group-addon btn navbar-refresh-btn btn-xs\"\n                           ng-if=\"$ctrl.showNextPreviousButtons\"\n                           ng-click=\"$ctrl.findNext()\">\n                            <i class=\"fa fa-arrow-down\"></i>\n                        </a>\n                    </div>\n                    <span>\n                        <span class=\"search-result-counter\"\n                              ng-if=\"$ctrl.showNextPreviousButtons\">\n                            {{$ctrl.getSearchResultCountString()}}\n                        </span>\n                        <span class=\"search-not-found-message\"\n                              ng-if=\"$ctrl.showNextPreviousButtons\">\n                            {{$ctrl.getNoResultsMsg()}}\n                        </span>\n                    </span>\n                    <button ng-show=\"$ctrl.filterEnabled\"\n                            type=\"button\"\n                            class=\"btn navbar-filter-btn\"\n                            ng-class=\"{\'filter-applied\' : $ctrl.isFilterApplied()}\"\n                            ng-click=\"$ctrl.filterBtnClickHandler()\">\n                        <i class=\"fa fa-filter\"></i>\n                    </button>\n                </div>\n                <div class=\"form-group verticalLine\">\n                    <button id=\"exportCurrentViewReportBtn\"\n                            ng-show=\"$ctrl.showPMViewMenu\"\n                            type=\"button\"\n                            class=\"btn navbar-report-btn\"\n                            ng-click=\"$ctrl.reportBtnHandler(\'packageReport\')\"\n                            title=\"Export Current View\">\n                        <span class=\"fa-stack\">\n                            <i class=\"fa fa-list-alt fa-stack-1x\"></i>\n                            <i class=\"fa fa-arrow-right fa-stack-1x\"></i>\n                        </span>\n                    </button>\n                    <button id=\"exportAllMetadataReportBtn\"\n                            ng-show=\"$ctrl.showPMViewMenu\"\n                            type=\"button\"\n                            class=\"btn navbar-report-btn\"\n                            ng-click=\"$ctrl.reportBtnHandler(\'packageMetadataReport\')\"\n                            title=\"Export ALL Metadata\">\n                        <span class=\"fa-stack\">\n                            <i class=\"fa fa-file-text fa-stack-1x\"></i>\n                            <i class=\"fa fa-arrow-right fa-stack-1x\"></i>\n                        </span>\n                    </button>\n                    <button id=\"executeDeliveryReportBtn\"\n                            ng-show=\"$ctrl.showPMViewMenu\"\n                            type=\"button\"\n                            class=\"btn navbar-report-btn\"\n                            title=\"Execute Delivery Report\"\n                            ng-click=\"$ctrl.reportBtnHandler(\'deliveryReport\')\">\n                        <i class=\"fa fa-truck fa-flip-horizontal\"></i>\n                    </button>\n                    <button id=\"executeMediaReportBtn\"\n                            ng-show=\"$ctrl.showPMViewMenu\"\n                            type=\"button\"\n                            class=\"btn navbar-report-btn\"\n                            title=\"Execute Media Report\"\n                            ng-click=\"$ctrl.reportBtnHandler(\'packageMediaReport\')\">\n                        <i class=\"fa fa-film\"></i>\n                    </button>\n                    <button id=\"executeAuditLevelReportBtn\"\n                            ng-show=\"$ctrl.showPMViewMenu\"\n                            type=\"button\"\n                            class=\"btn navbar-report-btn\"\n                            title=\"Execute Partner Delivery Report with Distribution Metadata\"\n                            ng-click=\"$ctrl.reportBtnHandler(\'packageAuditLevelReport\')\">\n                        <i class=\"fa fa-clipboard\"></i>\n                    </button>\n                </div>\n            </form>\n\n            <form class=\"navbar-form navbar-left\"\n                  role=\"refresh\"\n                  ng-show=\"$ctrl.showRefreshOnly\">\n                <div class=\"form-group\">\n                    <div class=\"input-group input-group-sm\">\n                        <button class=\"refresh-only btn navbar-refresh-btn btn-xs\"\n                                ng-click=\"$ctrl.refreshView()\">\n                            <i class=\"fa fa-refresh\"></i>\n                        </button>\n                    </div>\n                </div>\n            </form>\n\n            <ul class=\"nav navbar-nav navbar-right\"\n                ng-show=\"$ctrl.showPMViewMenu\">\n                <li class=\"dropdown\">\n                    <a href=\"\"\n                       class=\"dropdown-toggle\"\n                       data-toggle=\"dropdown\"\n                       role=\"button\"\n                       aria-expanded=\"false\">\n                        <i class=\"fa fa-eye pad-icon-right-sm\"></i>{{$ctrl.getPMViewSelectorLabel()}}<span\n                        class=\"caret\"></span>\n                    </a>\n                    <ul id=\"pmViewMenu\"\n                        class=\"dropdown-menu\"\n                        role=\"menu\">\n                        <li><a tabindex=\"0\"\n                               class=\"btn btn-link\"\n                               ng-click=\"$ctrl.setPMView(\'basic\')\">Basic\n                                                                   Inventory</a></li>\n                        <li><a tabindex=\"1\"\n                               class=\"btn btn-link\"\n                               ng-click=\"$ctrl.setPMView(\'detailed\')\">Detailed</a>\n                        </li>\n                        <li><a tabindex=\"0\"\n                               class=\"btn btn-link\"\n                               ng-click=\"$ctrl.setPMView(\'status\')\">Status</a></li>\n                    </ul>\n\n                </li>\n            </ul>\n        </div><!-- /.navbar-collapse -->\n    </div><!-- /.container-fluid -->\n</nav>\n");
        $templateCache.put("components/navigation/pagination/pagination-controls-template.html", "<div class=\"pagination-controls\">\n	<fieldset ng-disabled=\"$ctrl.isDisabled()\">\n\n		<!-- Page Navigation Buttons -->\n		<div class=\"form-group pagination-btn-gang\"\n			 ng-if=\"$ctrl.isMultiPage()\">\n			<div class=\"col-md-12 col-md-offset-2\">\n				<div class=\"pagination pagination-sm\">\n\n					<!-- Previous Page button -->\n					<button\n						class=\"pagination-btn left-btn btn btn-sm btn-default prism-button\"\n						id=\"paginationPrevButton\"\n						ng-disabled=\"$ctrl.isPrevBtnDisabled()\"\n						ng-click=\"$ctrl.onPrevBtnClicked($event)\"\n                        type=\"button\">\n						<i class=\"fa fa-chevron-left\"></i>\n					</button>\n\n					<!-- Next Page button -->\n					<button\n						class=\"pagination-btn right-btn btn btn-sm btn-default prism-button\"\n						id=\"paginationNextButton\"\n						ng-disabled=\"$ctrl.isNextBtnDisabled()\"\n						ng-click=\"$ctrl.onNextBtnClicked($event)\"\n                        type=\"button\">\n						<i class=\"fa fa-chevron-right\"></i>\n					</button>\n\n				</div>\n\n			</div>\n		</div>\n\n		<!-- Page Size Selector -->\n		<div class=\"form-group pagination-spacer\"\n			 ng-if=\"$ctrl.isMultiPage()\">\n			<dropdown-select\n				id=\"paginationPageSizeSelect\"\n				ng-model=\"$ctrl.pagingOptions.pageSize\"\n				dropup=\"true\"\n				ng-change=\"$ctrl.onPageSizeChanged()\"\n				track-by=\"$index\" collection=\"$ctrl.pagingOptions.pageSizes\">\n			</dropdown-select>\n			<label class=\"control-label\">per Page</label>\n		</div>\n\n		<!-- Page Number Selector -->\n		<div class=\"form-group\"\n			 ng-if=\"$ctrl.isMultiPage()\">\n			<label class=\"control-label toolbar-padding\">Page No.</label>\n\n            <!-- dropdown version -->\n			<dropdown-select\n				id=\"paginationPageNoSelect\"\n				ng-model=\"$ctrl.pagingOptions.currentPage\"\n				dropup=\"true\"\n				track-by=\"$index\"\n				collection=\"$ctrl.pagingOptions.totalPagesArray\"\n                ng-if=\"!$ctrl.showPageNumberAsText()\"\n				ng-change=\"$ctrl.jumpToPageHandler()\">\n			</dropdown-select>\n\n            <!-- text input version -->\n            <input\n                class=\"form-control prism-text-input\"\n                id=\"paginationPageNoTextInput\"\n                size=\"7\"\n                ng-if=\"$ctrl.showPageNumberAsText()\"\n                ng-model=\"$ctrl.pagingOptions.currentPage\"\n                ng-keydown=\"$ctrl.onPageNumberTextInputKeyDown($event)\"/>\n\n			<label class=\"control-label toolbar-padding\"> of {{$ctrl.pagingOptions.totalPages}}</label>\n		</div>\n\n		<!-- Total Pages Label (e.g. \"... of 2374\") -->\n		<div ng-if=\"!$ctrl.isMultiPage()\">\n			<label class=\"control-label toolbar-padding\">{{$ctrl.pagingOptions.totalPages}} Results</label>\n		</div>\n	</fieldset>\n</div>\n");
        $templateCache.put("components/navigation/sidebar/sidebar-template.html", "<div class=\"sidebar-list-group full-height\">\n\n    <!-- DASHBOARD -->\n    <div class=\"list-group-item\"\n         ng-show=\"$ctrl.showParentNavItem([\'workflows\', \'queues\', \'reports\', \'calendars\', \'offCyclePlanners\', \'checkin\'])\">\n        <h5 class=\"list-group-item-heading\">\n            DASHBOARD\n        </h5>\n        <div class=\"list-group-item-text no-bottom-padding\"\n             ng-click=\"$ctrl.sidebarItemClick(\'workflows\')\"\n             ng-if=\"$ctrl.showNavItem(\'workflows\')\"\n             ng-class=\"{\'active\': $ctrl.isNavItemActive(\'workflows\')}\">\n                <span class=\"fa-stack workflows-sidebar-icon\">\n                    <i class=\"fa fa-film fa-stack-1x\"></i>\n                    <i class=\"fa fa-file-o fa-lg fa-stack-1x\"></i>\n                </span>Workflows\n        </div>\n        <div class=\"list-group-item-text\"\n             ng-click=\"$ctrl.sidebarItemClick(\'queues\')\"\n             ng-if=\"$ctrl.showNavItem(\'queues\')\"\n             ng-class=\"{\'active\': $ctrl.isNavItemActive(\'queues\')}\">\n            <i class=\"fa fa-tasks fa-lg fa-fw\"></i>Queues\n        </div>\n        <div class=\"list-group-item-text\"\n             ng-click=\"$ctrl.sidebarItemClick(\'reports\')\"\n             ng-if=\"$ctrl.showNavItem(\'reports\')\"\n             ng-class=\"{\'active\': $ctrl.isNavItemActive(\'reports\')}\">\n            <i class=\"fa fa-file-text fa-lg fa-fw\"></i>Reports\n        </div>\n        <div class=\"list-group-item-text\"\n             ng-click=\"$ctrl.sidebarItemClick(\'calendars\')\"\n             ng-if=\"$ctrl.showNavItem(\'calendars\')\"\n             ng-class=\"{\'active\': $ctrl.isNavItemActive(\'calendars\')}\">\n            <i class=\"fa fa-calendar fa-lg fa-fw\"></i>Calendars\n        </div>\n        <div class=\"list-group-item-text\"\n             ng-click=\"$ctrl.sidebarItemClick(\'offCyclePlanners\')\"\n             ng-if=\"$ctrl.showNavItem(\'offCyclePlanners\')\"\n             ng-class=\"{\'active\': $ctrl.isNavItemActive(\'offCyclePlanners\')}\">\n            <i class=\"fa fa-calendar-check-o fa-lg fa-fw\"></i>Off-Cycle Planners\n        </div>\n        <div class=\"list-group-item-text\"\n             ng-click=\"$ctrl.sidebarItemClick(\'checkin\')\"\n             ng-if=\"$ctrl.showNavItemPessimisstic(\'checkin\')\"\n             ng-class=\"{\'active\': $ctrl.isNavItemActive(\'checkin\')}\">\n            <i class=\"fa fa-inbox fa-lg fa-fw\"></i>Package Check-in\n        </div>\n        <div class=\"list-group-item-text\"\n             ng-click=\"$ctrl.sidebarItemClick(\'metrics\')\"\n             ng-class=\"{\'active\': $ctrl.isNavItemActive(\'metrics\')}\">\n            <i class=\"fa fa-bar-chart fa-lg fa-fw\"></i>Metrics\n        </div>\n    </div>\n\n\n    <!-- META -->\n    <div class=\"list-group-item\"\n         ng-show=\"$ctrl.showParentNavItem([\'networks\', \'adsAndPreRolls\' , \'series\', \'movies\', \'collaborators\', \'mvpd\'])\">\n        <h5 class=\"list-group-item-heading\">META</h5>\n        <div class=\"list-group-item-text\"\n             ng-click=\"$ctrl.sidebarItemClick(\'networks\')\"\n             ng-class=\"{\'active\': $ctrl.isNavItemActive(\'networks\')}\"\n             ng-if=\"$ctrl.showNavItem(\'networks\')\">\n            <i class=\"fa fa-sitemap fa-lg fa-fw\"></i>Networks\n        </div>\n        <div class=\"list-group-item-text\"\n             ng-click=\"$ctrl.sidebarItemClick(\'adsAndPreRolls\')\"\n             ng-class=\"{\'active\': $ctrl.isNavItemActive(\'adsAndPreRolls\')}\"\n             ng-if=\"$ctrl.showNavItem(\'adsAndPreRolls\')\">\n            <i class=\"fa fa-bullhorn fa-lg fa-fw\"></i>Ads/PreRolls\n        </div>\n        <div class=\"list-group-item-text\"\n             ng-click=\"$ctrl.sidebarItemClick(\'series\')\"\n             ng-class=\"{\'active\': $ctrl.isNavItemActive(\'series\')}\"\n             ng-if=\"$ctrl.showNavItem(\'series\')\">\n            <i class=\"fa fa-television fa-lg fa-fw\"></i>Series\n        </div>\n        <div class=\"list-group-item-text\"\n             ng-click=\"$ctrl.sidebarItemClick(\'movies\')\"\n             ng-class=\"{\'active\': $ctrl.isNavItemActive(\'movies\')}\"\n             ng-if=\"$ctrl.showNavItem(\'movies\')\">\n            <i class=\"fa fa-film fa-lg fa-fw\"></i>Movies/Specials\n        </div>\n        <div class=\"list-group-item-text\"\n             ng-click=\"$ctrl.sidebarItemClick(\'collaborators\')\"\n             ng-class=\"{\'active\': $ctrl.isNavItemActive(\'collaborators\')}\"\n             ng-if=\"$ctrl.showNavItem(\'collaborators\')\">\n            <i class=\"fa fa-address-book-o fa-lg fa-fw\"></i>Collaborators\n        </div>\n        <div class=\"list-group-item-text\"\n             ng-click=\"$ctrl.sidebarItemClick(\'mvpd\')\"\n             ng-class=\"{\'active\': $ctrl.isNavItemActive(\'mvpd\')}\"\n             ng-if=\"$ctrl.showNavItem(\'mvpd\')\">\n            <i class=\"fa fa-stumbleupon fa-lg fa-fw\"></i>MVPD Setup\n        </div>\n    </div>\n\n\n    <!-- SYSTEM -->\n    <div class=\"list-group-item\"\n         ng-show=\"$ctrl.showParentNavItem([\'partners\'])\">\n        <h5 class=\"list-group-item-heading\">SYSTEM</h5>\n        <div class=\"list-group-item-text\"\n             ng-click=\"$ctrl.sidebarItemClick(\'partners\')\"\n             ng-if=\"$ctrl.showNavItem(\'partners\')\"\n             ng-class=\"{\'active\': $ctrl.isNavItemActive(\'partners\')}\">\n            <i class=\"fa fa-chain fa-lg fa-rotate-90 fa-fw\"></i>Partners\n        </div>\n        <div class=\"list-group-item-text\"\n             ng-click=\"$ctrl.sidebarItemClick(\'properties\')\"\n             ng-if=\"$ctrl.isAdmin\"\n             ng-class=\"{\'active\': $ctrl.isNavItemActive(\'properties\')}\">\n            <i class=\"fa fa-edit fa-lg fa-fw\"></i>Properties\n        </div>\n        <div class=\"list-group-item-text\"\n             ng-click=\"$ctrl.sidebarItemClick(\'templates\')\"\n             ng-if=\"$ctrl.isAdmin\"\n             ng-class=\"{\'active\': $ctrl.isNavItemActive(\'templates\')}\">\n            <i class=\"fa fa-code fa-lg fa-fw\"></i>Templates\n        </div>\n        <div class=\"list-group-item-text\"\n             ng-click=\"$ctrl.sidebarItemClick(\'metadataItems\')\"\n             ng-if=\"$ctrl.isAdmin\"\n             ng-class=\"{\'active\': $ctrl.isNavItemActive(\'metadataItems\')}\">\n            <i class=\"fa fa-th-list fa-lg fa-fw\"></i>Metadata Items\n        </div>\n        <div class=\"list-group-item-text\"\n             ng-click=\"$ctrl.sidebarItemClick(\'livefeeds\')\"\n             ng-class=\"{\'active\': $ctrl.isNavItemActive(\'livefeeds\')}\"\n             ng-if=\"$ctrl.showNavItem(\'livefeeds\')\">\n            <i class=\"fa fa-video-camera fa-lg fa-fw\"></i>Live Feeds\n        </div>\n\n        <div class=\"list-group-item-text\"\n             ng-click=\"$ctrl.sidebarItemClick(\'fileSystems\')\"\n             ng-show=\"$ctrl.isAdmin\"\n             ng-class=\"{\'active\': $ctrl.isNavItemActive(\'fileSystems\')}\">\n            <i class=\"fa fa-database fa-lg fa-fw\"></i>File Systems\n        </div>\n        <div class=\"list-group-item-text\"\n             ng-click=\"$ctrl.sidebarItemClick(\'aggregation\')\"\n             ng-if=\"$ctrl.isAdmin\"\n             ng-class=\"{\'active\': $ctrl.isNavItemActive(\'aggregation\')}\">\n            <i class=\"fa fa-asterisk fa-lg fa-fw\"\n               aria-hidden=\"true\"></i>Aggregation\n        </div>\n        <div class=\"list-group-item-text\"\n             ng-click=\"$ctrl.sidebarItemClick(\'execServers\')\"\n             ng-if=\"$ctrl.isAdmin\"\n             ng-class=\"{\'active\': $ctrl.isNavItemActive(\'execServers\')}\">\n            <i class=\"fa fa-refresh fa-lg fa-fw\"\n               aria-hidden=\"true\"></i>Exec Servers\n        </div>\n        <div class=\"list-group-item-text\"\n             ng-click=\"$ctrl.sidebarItemClick(\'packageNotifications\')\"\n             ng-if=\"$ctrl.isAdmin\"\n             ng-class=\"{\'active\': $ctrl.isNavItemActive(\'packageNotifications\')}\">\n            <i class=\"fa fa-bell fa-lg fa-fw\"\n               aria-hidden=\"true\"></i>Package Notifications\n        </div>\n        <div class=\"list-group-item-text\"\n             ng-click=\"$ctrl.sidebarItemClick(\'users\')\"\n             ng-if=\"$ctrl.isAdmin\"\n             ng-class=\"{\'active\': $ctrl.isNavItemActive(\'users\')}\">\n            <i class=\"fa fa-user fa-lg fa-fw\"></i>Users\n        </div>\n        <div class=\"list-group-item-text\"\n             ng-click=\"$ctrl.sidebarItemClick(\'groups\')\"\n             ng-if=\"$ctrl.isAdmin\"\n             ng-class=\"{\'active\': $ctrl.isNavItemActive(\'groups\')}\">\n            <i class=\"fa fa-users fa-lg fa-fw\"></i>Groups\n        </div>\n        <div class=\"list-group-item-text\"\n             ng-click=\"$ctrl.sidebarItemClick(\'contacts\')\"\n             ng-if=\"$ctrl.isAdmin\"\n             ng-class=\"{\'active\': $ctrl.isNavItemActive(\'contacts\')}\">\n            <i class=\"fa fa-address-card fa-lg fa-fw\"></i>Contacts\n        </div>\n\n\n    </div>\n\n\n    <!-- PACKAGES -->\n    <div class=\"list-group-item\">\n        <h5 class=\"list-group-item-heading\">PACKAGES</h5>\n        <div class=\"list-group-item-text\"\n             ng-click=\"$ctrl.sidebarItemClick(\'packages\')\"\n             ng-class=\"{\'active\': $ctrl.isNavItemActive(\'packages\')}\">\n            <i class=\"fa fa-cube fa-lg fa-fw\"></i>Package\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("components/proxyPlayer/renderers/cue-points-renderer-template.html", "<div class=\"cue-point-timeline\">\n	<div ng-repeat=\"cuePoint in vgCuePoints\" class=\"cue-point\" ng-style=\"cuePoint.$$style\" ng-class=\"cuePoint.cuePointClass\"></div>\n</div>\n");
        $templateCache.put("components/subscription/gridTemplates/branding-season-volume-template.html", "<div class=\"ui-grid-cell-contents\"\n	 uib-tooltip=\n		 \"{{\n		  	COL_FIELD.name CUSTOM_FILTERS\n		 }}{{\n		  	 grid.appScope.$ctrl.isCellModified(row, col)?\n				\' (modified)\':\n				\'\'\n		 }}\"\n	 tooltip-append-to-body=\"true\"\n	 ng-click=\"grid.appScope.$ctrl.preventRowDefault($event)\"\n	 ng-dblclick=\"grid.appScope.$ctrl.rowDoubleClick(row, column)\">\n	<span class=\"padding-left-sm\"\n		  ng-class=\"{\'blue-label\': grid.appScope.$ctrl.isCellModified(row, col)}\">\n		{{ grid.appScope.$ctrl.seasonVolumeFormat(row, col) }}\n	</span>\n\n</div>\n");
        $templateCache.put("components/subscription/gridTemplates/subscription-artwork-template.html", "<div class=\"ui-grid-cell-contents\"\n	 uib-tooltip=\n		\"{{\n			row.entity.artwork | artworkAssetFilter\n		 }}{{\n		  	 grid.appScope.$ctrl.isCellModified(row, col)?\n				\' (modified)\':\n				\'\'\n		 }}\"\n	 tooltip-append-to-body=\"true\"\n	 ng-click=\"grid.appScope.$ctrl.preventRowDefault($event)\"\n	 ng-dblclick=\"grid.appScope.$ctrl.rowDoubleClick(row)\">\n	<span class=\"padding-left-sm\"\n		  ng-class=\"{\'blue-label\': grid.appScope.$ctrl.isCellModified(row, col)}\">\n		{{ row.entity.artwork | artworkAssetFilter }}\n	</span>\n</div>\n");
        $templateCache.put("components/subscription/gridTemplates/subscription-boolean-template.html", "<div class=\"ui-grid-cell-contents\"\n     uib-tooltip=\n         \"{{\n			row.entity[col.field]? \'Enabled\': \'Disabled\'\n		 }}{{\n		  	 grid.appScope.$ctrl.isCellModified(row, col)?\n				\' (modified)\':\n				\'\'\n		 }}\"\n     tooltip-append-to-body=\"true\"\n     ng-click=\"grid.appScope.$ctrl.preventRowDefault($event)\"\n     ng-dblclick=\"grid.appScope.$ctrl.rowDoubleClick(row)\">\n	<span class=\"subscription-status-icon fa-stack\">\n		<i ng-if=\"grid.appScope.$ctrl.isCellModified(row, col)\"\n           class=\"fa fa-square fa-stack-1x subscription-modified no-shadow\"></i>\n		<i class=\"fa fa-circle fa-stack-1x\"\n           ng-class=\"{\'boolean-indicator-true\': row.entity[col.field], \'boolean-indicator-false\': !row.entity[col.field]}\"></i>\n	</span>\n</div>\n");
        $templateCache.put("components/subscription/gridTemplates/subscription-collaborators-template.html", "<div class=\"ui-grid-cell-contents\"\n	 uib-tooltip=\n		\"{{\n			row.entity.requiredCrewRoles.length === grid.appScope.$ctrl.crewMemberRoles.length+1?\n				\'All Collaborators\':\n				row.entity.requiredCrewRoles.join(\', \')\n		 }}{{\n		  	grid.appScope.$ctrl.isCellModified(row, col)?\n				\' (modified)\':\n				\'\'\n		 }}\"\n	 tooltip-append-to-body=\"true\"\n	 ng-click=\"grid.appScope.$ctrl.preventRowDefault($event)\"\n	 ng-dblclick=\"grid.appScope.$ctrl.rowDoubleClick(row)\">\n	<span class=\"padding-left-sm\"\n		  ng-class=\"{\'blue-label\': grid.appScope.$ctrl.isCellModified(row, col)}\">\n		{{\n			row.entity.requiredCrewRoles.length === grid.appScope.$ctrl.crewMemberRoles.length+1?\n				\'All Collaborators\':\n				row.entity.requiredCrewRoles.join(\', \')\n		}}\n	</span>\n</div>\n");
        $templateCache.put("components/subscription/gridTemplates/subscription-component-role-template.html", "<div class=\"ui-grid-cell-contents\"\n	 uib-tooltip=\n		\"{{\n			row.entity.videoRoles | videoRolesFilter\n		 }}{{\n		  	 grid.appScope.$ctrl.isCellModified(row, col)?\n				\' (modified)\':\n				\'\'\n		 }}\"\n	 tooltip-append-to-body=\"true\"\n	 ng-click=\"grid.appScope.$ctrl.preventRowDefault($event)\"\n	 ng-dblclick=\"grid.appScope.$ctrl.rowDoubleClick(row)\">\n	<span class=\"padding-left-sm\"\n		  ng-class=\"{\'blue-label\': grid.appScope.$ctrl.isCellModified(row, col)}\">\n		{{ row.entity.videoRoles | videoRolesFilter }}\n	</span>\n</div>\n");
        $templateCache.put("components/subscription/gridTemplates/subscription-custom-meta-change-template.html", "<div class=\"ui-grid-cell-contents\"\n	 uib-tooltip=\n		 \"{{\n			(grid.appScope.$ctrl.isCellModified(row, col)) ? \'TRUE (modified)\' : \'FALSE\'\n		}}\"\n	 tooltip-append-to-body=\"true\"\n	 ng-click=\"grid.appScope.$ctrl.preventRowDefault($event)\"\n	 ng-dblclick=\"grid.appScope.$ctrl.rowDoubleClick(row)\">\n	<span class=\"padding-left-sm\"\n		  ng-class=\"{\'blue-label\': grid.appScope.$ctrl.isCellModified(row, col)}\">\n		{{ (grid.appScope.$ctrl.isCellModified(row, col)) ? \'TRUE (modified)\' : \'FALSE\' }}\n	</span>\n</div>\n");
        $templateCache.put("components/subscription/gridTemplates/subscription-custom-meta-template.html", "<div class=\"ui-grid-cell-contents\"\n	 uib-tooltip=\n		 \"{{\n              grid.appScope.$ctrl.getPartnerMetadataField(row, col) CUSTOM_FILTERS\n         }}{{\n               grid.appScope.$ctrl.isCellModified(row, col)?\n                \' (modified)\':\n                \'\'\n         }}\"\n	 tooltip-append-to-body=\"true\"\n	 ng-click=\"grid.appScope.$ctrl.preventRowDefault($event)\"\n	 ng-dblclick=\"grid.appScope.$ctrl.rowDoubleClick(row, column)\">\n    <span class=\"padding-left-sm\"\n		  ng-class=\"{\'blue-label\': grid.appScope.$ctrl.isCellModified(row, col)}\">\n        {{grid.appScope.$ctrl.getPartnerMetadataField(row, col) CUSTOM_FILTERS}}\n    </span>\n</div>\n");
        $templateCache.put("components/subscription/gridTemplates/subscription-custom-metadata-property-template.html", "<div class=\"ui-grid-cell-contents\"\n	 uib-tooltip=\n		 \"{{\n		  	grid.appScope.$ctrl.getPartnerMetadataField(row, col) CUSTOM_FILTERS\n		 }}{{\n		  	 grid.appScope.$ctrl.isCellModified(row, col)?\n				\' (modified)\':\n				\'\'\n		 }}\"\n	 tooltip-append-to-body=\"true\"\n	 ng-click=\"grid.appScope.$ctrl.preventRowDefault($event)\"\n	 ng-dblclick=\"grid.appScope.$ctrl.rowDoubleClick(row, column)\">\n	<span class=\"padding-left-sm\"\n		  ng-class=\"{\'blue-label\': grid.appScope.$ctrl.isCellModified(row, col)}\">\n		{{grid.appScope.$ctrl.getPartnerMetadataField(row, col) CUSTOM_FILTERS}}\n	</span>\n</div>\n");
        $templateCache.put("components/subscription/gridTemplates/subscription-enabled-template.html", "<div class=\"ui-grid-cell-contents\"\n	 uib-tooltip=\n		\"{{\n			row.entity[col.field]? \'Enabled\': \'Disabled\'\n		 }}{{\n		  	 grid.appScope.$ctrl.isCellModified(row, col)?\n				\' (modified)\':\n				\'\'\n		 }}\"\n	 tooltip-append-to-body=\"true\"\n	 ng-click=\"grid.appScope.$ctrl.preventRowDefault($event)\"\n	 ng-dblclick=\"grid.appScope.$ctrl.rowDoubleClick(row)\">\n	<span class=\"subscription-status-icon fa-stack\">\n		<i ng-if=\"grid.appScope.$ctrl.isCellModified(row, col)\"\n		   class=\"fa fa-square fa-stack-1x subscription-modified no-shadow\"></i>\n		<i class=\"fa fa-circle fa-stack-1x {{grid.appScope.$ctrl.getSubscriptionStatus(row.entity)}}\"></i>\n	</span>\n</div>\n");
        $templateCache.put("components/subscription/gridTemplates/subscription-property-default-template.html", "<div class=\"ui-grid-cell-contents\"\n	 uib-tooltip=\n		\"{{\n		  	COL_FIELD CUSTOM_FILTERS\n		 }}{{\n		  	 grid.appScope.$ctrl.isCellModified(row, col)?\n				\' (modified)\':\n				\'\'\n		 }}\"\n	 tooltip-append-to-body=\"true\"\n	 ng-click=\"grid.appScope.$ctrl.preventRowDefault($event)\"\n	 ng-dblclick=\"grid.appScope.$ctrl.rowDoubleClick(row, column)\">\n	<span class=\"padding-left-sm\"\n		  ng-class=\"{\'blue-label\': grid.appScope.$ctrl.isCellModified(row, col)}\">\n		{{COL_FIELD CUSTOM_FILTERS}}\n	</span>\n</div>\n");
        $templateCache.put("components/subscription/gridTemplates/subscription-seasons-volumes-template.html", "<div class=\"ui-grid-cell-contents\"\n	 uib-tooltip=\n		\"{{\n			row.entity.seasonSubscription?\n				row.entity.seasons:\n				row.entity.volumes\n			| volumeSeasonFilter:this\n		 }}{{\n		  	 grid.appScope.$ctrl.isCellModified(row, col)?\n				\' (modified)\':\n				\'\'\n		 }}\"\n	 tooltip-append-to-body=\"true\"\n	 ng-click=\"grid.appScope.$ctrl.preventRowDefault($event)\"\n	 ng-dblclick=\"grid.appScope.$ctrl.rowDoubleClick(row)\">\n	<span class=\"padding-left-sm\"\n		  ng-class=\"{\'blue-label\': grid.appScope.$ctrl.isCellModified(row, col)}\">\n		{{\n			row.entity.seasonSubscription?\n				row.entity.seasons:\n				row.entity.volumes\n			| volumeSeasonFilter:this\n		}}\n	</span>\n</div>\n");
        $templateCache.put("components/subscription/gridTemplates/subscription-type-template.html", "<div class=\"ui-grid-cell-contents\"\n	 uib-tooltip=\n		\"{{\n			(row.entity.content.type === \'Series\') ? row.entity.seasonSubscription ? \'Season\': \'Volume\' : \'N/A\'\n		}}\n		{{\n			grid.appScope.$ctrl.isCellModified(row, col)?\n				\' (modified)\':\n				\'\'\n		 }}\"\n	 tooltip-append-to-body=\"true\"\n	 ng-click=\"grid.appScope.$ctrl.preventRowDefault($event)\"\n	 ng-dblclick=\"grid.appScope.$ctrl.rowDoubleClick(row)\">\n	<span class=\"padding-left-sm\"\n		  ng-class=\"{\'blue-label\': grid.appScope.$ctrl.isCellModified(row, col)}\">\n		{{\n			(row.entity.content.type === \'Series\')?\n				(row.entity.seasonSubscription? \'Season\': \'Volume\'):\n				\'N/A\'\n		}}\n	</span>\n</div>\n");
        $templateCache.put("components/subscription/gridTemplates/subscription-watermark-details-template.html", "<div class=\"ui-grid-cell-contents\"\n	 uib-tooltip=\n		\"{{\n			\'FadeIn: \' + row.entity.watermarkFadeInSeconds + \' &nbsp; | &nbsp; \' +\n			\'FadeOut: \' + row.entity.watermarkFadeOutSeconds + \' &nbsp; | &nbsp; \' +\n			\'Offset: \' + row.entity.watermarkOffsetSeconds\n		 }}{{\n			grid.appScope.$ctrl.isCellModified(row, col)?\n				\' (modified)\':\n				\'\'\n		 }}\"\n	 tooltip-append-to-body=\"true\"\n 	 ng-click=\"grid.appScope.$ctrl.preventRowDefault($event)\"\n	 ng-dblclick=\"grid.appScope.$ctrl.rowDoubleClick(row)\">\n	<span class=\"padding-left-sm\"\n		  ng-class=\"{\'blue-label\': grid.appScope.$ctrl.isCellModified(row, col)}\">\n		{{\n			\'FadeIn: \' + row.entity.watermarkFadeInSeconds + \' &nbsp; | &nbsp; \' +\n			\'FadeOut: \' + row.entity.watermarkFadeOutSeconds + \' &nbsp; | &nbsp; \' +\n			\'Offset: \' + row.entity.watermarkOffsetSeconds\n		}}\n	</span>\n</div>\n");
        $templateCache.put("components/visual/asset-info-row/asset-info-row-template.html", "<div class=\"form-group\">\n    <label for=\"{{$ctrl.inputId}}\"\n           class=\"col-sm-3 control-label text-align-right lg-txt\">\n        {{$ctrl.label}}&nbsp;\n    </label>\n    <p class=\"col-sm-9 view-asset-modal-row-value padding-bottom-sm\"\n       id=\"{{$ctrl.inputId}}\">\n        {{$ctrl.value}}&nbsp;\n    </p>\n</div>\n");
        $templateCache.put("components/visual/bar-graph/bar-graph-template.html", "<!--\n - Filename: bar-graph-template.html\n -\n - Created by randysorensen on 2019-02-22.\n -->\n\n<div class=\"bar-graph-horizontal-margin-top\">\n</div>\n\n<div class=\"bar-graph-container\">\n    <div class=\"bar-graph-frame\">\n\n        <!-- Scale lines / vertical axis labels -->\n        <div class=\"guide-line-container\"\n             ng-repeat=\"scaleLine in $ctrl.getScaleLines()\">\n            <div class=\"guide-line\"></div>\n            <span class=\"guide-line-label\">{{scaleLine.toLocaleString() || \'&nbsp;\'}}</span>\n        </div>\n\n        <!-- The bars -->\n        <div class=\"bar-graph\">\n            <div class=\"bar-container\">\n                <div class=\"bar\"\n                     ng-repeat=\"(index, bar) in $ctrl.getBars()\"\n                     uib-tooltip-html=\"bar.tooltip\"\n                     tooltip-append-to-body=\"true\"\n                     tooltip-class=\"{{bar.tooltipClass}}\"\n                     ng-style=\"{\n                         \'background-color\': bar.color,\n                         \'height\': $ctrl.getHeight(bar) + \'%\',\n                         \'margin-right\': !$ctrl.isLastBar(index) ? \'1px\' : \'0\',\n                         \'-webkit-transition\': \'height \' + $ctrl.getAnimationDuration() + \'s cubic-bezier(0.46, 0.03, 0.52, 0.96)\',\n                         \'-moz-transition\': \'height \' + $ctrl.getAnimationDuration() + \'s cubic-bezier(0.46, 0.03, 0.52, 0.96)\',\n                         \'-o-transition\': \'height \' + $ctrl.getAnimationDuration() + \'s cubic-bezier(0.46, 0.03, 0.52, 0.96)\',\n                         \'transition\': \'height \' + $ctrl.getAnimationDuration() + \'s cubic-bezier(0.46, 0.03, 0.52, 0.96)\',\n                     }\">\n                </div>\n            </div>\n\n            <!--\n                Makes the bars line up with the bottom scale line\n              -->\n            <div class=\"bar-bumper\">\n                &nbsp;\n            </div>\n        </div>\n    </div>\n\n    <!-- Horizontal Axis Labels -->\n    <div class=\"horizontal-axis-container\">\n        <div ng-repeat=\"bar in $ctrl.getBars()\"\n             class=\"label-frame\">\n            &nbsp;\n            <div class=\"bar-label\">\n\n                <!-- Single-letter abbreviation -->\n                <span>\n                    {{bar.label.substring(0, 1)}}\n                </span>\n\n                <!-- The rest of the label -->\n                <span>\n                    {{bar.label.substring(1)}}\n                </span>\n            </div>\n        </div>\n\n    </div>\n\n</div>\n\n<!--<div class=\"bar-graph-horizontal-margin-bottom\">-->\n<!--</div>-->\n");
        $templateCache.put("components/visual/chartPill/chart-pill-template.html", "<div class=\"progress progress-queue\">\n	<div class=\"progress-bar progress-bar-queue\" ng-repeat=\"item in $ctrl.chartdata.data\" ng-style=\"{\'width\': $ctrl.getPillWidth(item.value) + \'%\', \'background-color\': item.color}\" ng-click=\"$ctrl.statusChange({ queue: $ctrl.chartdata, status: item.field })\">\n		{{(item.value > 0) ? item.value : \'\'}}\n	</div>\n	<div class=\"progress-bar-queue none-pill progress-bar-striped\" ng-if=\"$ctrl.chartdata.total === 0\" ng-click=\"$ctrl.statusChange({ queue: $ctrl.chartdata, status: \'Executing\' })\"></div>\n</div>\n");
        $templateCache.put("components/visual/conversionTemplateDropdown/conversion-template-dropdown-template.html", "<!-- Conversion Template Type -->\n<div class=\"form-group v-align\" ng-if=\"$ctrl.isTypePromptVisible()\">\n    <label for=\"{{$ctrl.id}}_type\"\n           ng-class=\"\'control-label padding-bottom-sm col-md-\' + $ctrl.promptWidthNum\">\n        {{$ctrl.typePrompt}}\n    </label>\n    <div ng-class=\"\'col-md-\' + (11 - $ctrl.promptWidthNum)\">\n        <dropdown-select id=\"{{$ctrl.id}}_type\"\n            btn-min-width=\"200\"\n            clearable=\"!$ctrl.isTypeRequired()\"\n            collection=\"$ctrl.conversionTypes\"\n            ng-disabled=\"$ctrl.isDisabled\"\n            ng-required=\"$ctrl.isTypeRequired()\"\n            ng-model=\"$ctrl.selectedType\"\n            ng-model-options=\"{getterSetter: true}\"\n            prompt=\"Select Type\"\n            tooltip-template=\"$ctrl.typeTooltipTemplate\"\n            tooltip-class=\"{{$ctrl.typeTooltipClass}}\">\n        </dropdown-select>\n    </div>\n</div>\n\n<!-- Conversion Template -->\n<div ng-if=\"$ctrl.isTemplatePromptVisible()\"\n     ng-disabled=\"!$ctrl.isTemplatePromptEnabled()\">\n    <div class=\"form-group v-align\">\n        <label for=\"{{$ctrl.id}}_template\"\n               ng-class=\"\'control-label padding-bottom-sm col-md-\' + $ctrl.promptWidthNum\">\n            {{$ctrl.getTemplatePrompt()}}\n        </label>\n        <div ng-class=\"\'col-md-\' + (11 - $ctrl.promptWidthNum)\">\n            <dropdown-select id=\"{{$ctrl.id}}_template\"\n                btn-min-width=\"200\"\n                clearable=\"!$ctrl.isRequired\"\n                collection=\"$ctrl.conversionTemplates\"\n                label-field=\"name\"\n                ng-disabled=\"$ctrl.isDisabled || !$ctrl.selectedType()\"\n                ng-required=\"$ctrl.isRequired\"\n                ng-model=\"$ctrl.selectedTemplate\"\n                ng-model-options=\"{getterSetter: true}\"\n                prompt=\"Select Template\"\n                tooltip-template=\"\'components/visual/conversionTemplateDropdown/templates/conversion-tooltip-template.html\'\">\n            </dropdown-select>\n            <!-- Template info -->\n            <a class=\"fa fa-stack clear-dropdown fa-info-circle fa-2x prism-into-button asset-info-button\"\n               ng-if=\"$ctrl.templateHasDescription()\"\n               ng-click=\"$ctrl.openDescriptionModal()\">\n            </a>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("components/visual/contactsList/contacts-list-template.html", "<div>\n\n    <fieldset>\n        <ng-form class=\"form-horizontal\"\n                 role=\"form\"\n                 name=\"$ctrl.editorForm\">\n\n            <!-- [ + ][ - ] -->\n            <div class=\"col-sm-4 pad-text-input-col\">\n                <!-- [ + ] -->\n                <button class=\"btn btn-default prism-button\"\n                        ng-click=\"$ctrl.onAddContactsClick($event)\">\n                    <i class=\"fa fa-plus\"></i>\n                </button>\n\n                <!-- [ - ] -->\n                <button class=\"btn btn-default prism-button\"\n                        ng-disabled=\"$ctrl.gridApi.selection.getSelectedCount() <= 0\"\n                        ng-click=\"$ctrl.gridApi.selection.getSelectedCount() > 0 &&\n                                  $ctrl.onRemoveContactsClick($event)\">\n                    <i class=\"fa fa-minus\"></i>\n                </button>\n            </div>\n\n            <!-- Contacts List Grid -->\n            <div class=\"col-lg-9 padding-top-md\">\n                <div id=\"contactsListGrid\"\n                     ng-class=\"{\'protected-grid\': !$ctrl.canWrite}\"\n                     ui-grid=\"$ctrl.gridOptions\"\n                     ui-grid-selection\n                     ui-grid-resize-columns>\n                </div>\n            </div>\n\n        </ng-form>\n    </fieldset>\n\n</div>\n\n");
        $templateCache.put("components/visual/datePicker/datepicker-template.html", "<p class=\"input-group\">\n	<input type=\"text\" class=\"form-control prism-text-input datepicker-input\"\n		   ng-change=\"datePickerCtrl.dateChanged()\"\n		   uib-datepicker-popup=\"M!/d!/yyyy\"\n		   alt-input-formats=\"[\'M!/d!/yy\']\"\n		   ng-model=\"datePickerCtrl.date\"\n		   ng-disabled=\"datePickerCtrl.disabled\"\n		   is-open=\"datePickerCtrl.opened\"\n		   datepicker-options=\"datePickerCtrl.dateOptions\"\n		   close-text=\"Close\"\n		   autocomplete=\"off\"\n		   ng-click=\"datePickerCtrl.onDateFieldClick($event)\"/>\n		<span class=\"input-group-btn\">\n			<button id=\"{{datePickerCtrl.buttonId + \'CalPopup\'}}\"\n					type=\"button\"\n					class=\"btn btn-xs btn-default\"\n					ng-click=\"datePickerCtrl.open($event)\"\n					ng-disabled=\"datePickerCtrl.disabled\">\n				<i class=\"glyphicon glyphicon-calendar\"></i>\n			</button>\n		</span>\n</p>\n");
        $templateCache.put("components/visual/dateTime/datetime-template.html", "<fieldset class=\"padding-bottom-xsm no-padding date-time\" ng-class=\"(dateTimePickerCtrl.fieldSetSize)? \'col-sm-\' + dateTimePickerCtrl.fieldSetSize : \'col-sm-8\'\"\n		  ng-disabled=\"dateTimePickerCtrl.componentDisabled\">\n	<div class=\"col-sm-5 date-field top-margin-xs\">\n		<date-picker ng-model=\"dateTimePickerCtrl.datePart\" ng-change=\"dateTimePickerCtrl.dateChanged()\" cal-btn-id=\"dateTimePickerCtrl.calBtnId\"></date-picker>\n	</div>\n	<div class=\"col-sm-6 no-padding time-component-md top-margin\">\n		<div uib-timepicker class=\"timepicker col-sm-1 time-component-md\"\n					ng-model=\"dateTimePickerCtrl.timePart\"\n					ng-change=\"dateTimePickerCtrl.dateChanged()\"\n					hour-step=\"1\" minute-step=\"15\" show-meridian=\"true\"\n					mousewheel=\"false\" arrowkeys=\"false\" template-url=\"components/visual/timepicker/prism-timepicker-template.html\">\n		</div>\n	</div>\n</fieldset>\n");
        $templateCache.put("components/visual/dateTimeEnhanced/datetime-enhanced-template.html", "\n<div data-ng-switch=\"dateTimeEnhancedCtrl.showTime\">\n	<div data-ng-switch-when=\"true\">\n		<ng-include src=\"\'components/visual/dateTimeEnhanced/templates/date-time-enhanced-renderer-template.html\'\"></ng-include>\n	</div>\n	<div data-ng-switch-default>\n		<ng-include src=\"\'components/visual/dateTimeEnhanced/templates/date-enhanced-renderer-template.html\'\"></ng-include>\n	</div>\n</div>\n");
        $templateCache.put("components/visual/dropdown/dropdown-template.html", "<div class=\"btn-group\"\n     ng-class=\"{\'dropup\': $ctrl.dropup, \'singleSelect\': !$ctrl.isMultiSelect, \'multiSelect\': $ctrl.isMultiSelect}\"\n     uib-dropdown\n     ng-attr-dropdown-append-to-body=\"{{$ctrl.attachToBody || undefined}}\"\n     is-open=\"$ctrl.areItemsVisible\"\n     auto-close=\"{{$ctrl.isMultiSelect && \'outsideClick\'}}\"\n     ng-keydown=\"$ctrl.onKeyDown($event)\"\n     >\n\n    <dropdown-button\n        select-service=\"$ctrl.selectService\"\n        dropdown-config=\"$ctrl.config\"\n        on-dropdown-toggled=\"$ctrl.toggleItemsVisibility()\"\n        ng-disabled=\"$ctrl.isDisabled\"\n        btn-min-width=\"$ctrl.btnMinWidth\"\n    ></dropdown-button>\n\n    <div class=\"dropdown-list-container\"\n         ng-class=\"{\'open\': $ctrl.areItemsVisible, \'singleSelect\': !$ctrl.isMultiSelect, \'multiSelect\': $ctrl.isMultiSelect}\"\n        uib-dropdown-menu\n        role=\"menu\"\n    >\n        <dropdown-list\n            select-service=\"$ctrl.selectService\"\n            dropdown-config=\"$ctrl.config\"\n            ng-disabled=\"$ctrl.isDisabled\"\n            enable-select-all=\"$ctrl.enableSelectAll\"\n            max-height-style=\"$ctrl.maxHeight ? $ctrl.maxHeight + \'px\' : undefined\"\n        ></dropdown-list>\n    </div>\n</div>\n");
        $templateCache.put("components/visual/dropdown-select/dropdown-select-template.html", "<div class=\"btn-group select-dropdown-container\"\n     ng-class=\"{\'dropup\': dropup}\"\n     uib-dropdown\n     ng-attr-dropdown-append-to-body=\"{{attachToBody || undefined}}\"\n     keyboard-nav\n     is-open=\"dropdown.isopen\">\n    <button type=\"button\"\n            class=\"btn btn-default prism-button dropdown-toggle\"\n            ng-disabled=\"componentDisabled\"\n            ng-click=\"toggleDropDown($event)\"\n            ng-keydown=\"selectOptionFromKey($event)\"\n            ng-style=\"minWidthStyle\">\n        <i class=\"fa fa-sort dropdown-arrows pull-right\"></i>{{getLabelForViewValue()}}\n    </button>\n    <ul ng-style=\"{\'max-height\': maxHeight, \'min-width\': btnMinWidth}\"\n        uib-dropdown-menu\n        role=\"menu\"\n        ng-style=\"minWidthStyle\"\n        ng-keydown=\"selectOptionFromKey($event)\">\n\n        <div class=\"loadingIndicator\">\n            <div data-lb-progress=\"loadingIndicator\"\n                 ng-show=\"isLoading()\"></div>\n        </div>\n        <li role=\"menuitem\"\n            ng-repeat=\"item in (collection | limitTo:numItemsToRender | filter:collectionFilter) track by $index\"\n            ng-disabled=\"item.disabled\">\n            <a href=\"#\"\n               ng-class=\"{\'option-selected\': isIndexSelected($index)}\"\n               ng-disabled=\"item.disabled\"\n               ng-keydown=\"selectOptionFromKey($event)\"\n               uib-tooltip-template=\"getTooltipTemplate(item)\"\n               data-tooltip-append-to-body=\"true\"\n               data-tooltip-placement=\"right\"\n               data-tooltip-class=\"{{tooltipClass}}\"\n               ng-click=\"selectOption(item || $index + 1, $event)\">{{dropdownLabelFunction(item || $index +\n                1)}}<i class=\"fa fa-lock content-lock\"\n                       ng-if=\"item.locked\"></i></a>\n        </li>\n    </ul>\n    <a class=\"fa-stack clear-dropdown\"\n       ng-disabled=\"componentDisabled\"\n       ng-class=\"{\'invisible\': clearable && !clearVisible()}\"\n       ng-show=\"clearable\"\n       ng-click=\"clearOption($event)\"\n       href=\"\">\n        <i class=\"fa fa-circle fa-stack-1x\"></i>\n        <i class=\"fa fa-times fa-stack-1x\"></i>\n    </a>\n</div>\n");
        $templateCache.put("components/visual/editable-list/editable-list-template.html", "<div class=\"list-group prism-list protected-grid\">\n	<input type=\"text\" class=\"prism-text-input list-group-item\" ng-repeat=\"item in $ctrl.collection\" ng-model=\"item[$ctrl.labelField]\"\n		   ng-change=\"$ctrl.changeHandler()\" ng-click=\"$ctrl.selectFocusedItem(item)\"/>\n</div>\n<div>\n	<button class=\"btn btn-default prism-button\" ng-click=\"$ctrl.addNewItem()\">Add</button>\n	<button class=\"btn btn-default prism-button\" ng-click=\"$ctrl.removeItem()\" ng-disabled=\"!$ctrl.selectedItem\">Remove</button>\n</div>\n");
        $templateCache.put("components/visual/emailRecipientsList/email-recipients-list-template.html", "<div>\n\n    <fieldset>\n        <ng-form class=\"form-horizontal\"\n                 role=\"form\"\n                 name=\"$ctrl.editorForm\">\n\n            <!-- [ + ][ - ] -->\n            <div class=\"col-sm-4 pad-text-input-col\">\n                <!-- [ + ] -->\n                <button class=\"btn btn-default prism-button\"\n                        ng-click=\"$ctrl.onAddRecipientsClick($event)\">\n                    <i class=\"fa fa-plus\"></i>\n                </button>\n\n                <!-- [ - ] -->\n                <button class=\"btn btn-default prism-button\"\n                        ng-disabled=\"$ctrl.gridApi.selection.getSelectedCount() <= 0\"\n                        ng-click=\"$ctrl.gridApi.selection.getSelectedCount() > 0 &&\n                                  $ctrl.onRemoveRecipientsClick($event)\">\n                    <i class=\"fa fa-minus\"></i>\n                </button>\n            </div>\n\n            <!-- Recipients List Grid -->\n            <div class=\"col-lg-9 padding-top-md\">\n                <div id=\"emailRecipientsListGrid\"\n                     ng-class=\"{\'protected-grid\': !$ctrl.canWrite}\"\n                     ui-grid=\"$ctrl.gridOptions\"\n                     ui-grid-selection\n                     ui-grid-resize-columns>\n                </div>\n            </div>\n\n        </ng-form>\n    </fieldset>\n</div>\n\n");
        $templateCache.put("components/visual/enhancedTextArea/enhanced-textarea-template.html", "<div class=\"row\">\n	<div class=\"enhanced-text-area-container\"\n         ng-class=\"{\n            \'char-counter-input-container\' : $ctrl.inputFocused && ($ctrl.maxChars && $ctrl.maxChars > 0),\n            \'col-sm-12\' : !$ctrl.inputFocused || !$ctrl.maxChars || $ctrl.maxChars <= 0,\n            \'padding-left-error\' : $ctrl.errorCharIndex !== undefined\n            }\">\n        <div class=\"fa error-warning-triangle line-error\"\n             ng-show=\"$ctrl.errorCharIndex === 0 || $ctrl.errorCharIndex > 0\">\n            <span class=\"fa-stack\">\n                <i class=\"fa fa-square fa-stack-1x\"></i>\n                <i class=\"fa fa-exclamation-triangle fa-stack-1x\"></i>\n            </span>\n            <div class=\"line-error-border\"></div>\n        </div>\n		<textarea class=\"form-control prism-text-input\"\n				  id=\"{{ $ctrl.inputId }}\"\n				  maxlength=\"{{ $ctrl.maxChars }}\"\n				  ng-blur=\"$ctrl.onBlur()\"\n				  ng-change=\"$ctrl.onInputChange()\"\n				  ng-class=\"{ \'monospace\' : $ctrl.monospace }\"\n				  ng-disabled=\"$ctrl.disableProp\"\n				  ng-focus=\"$ctrl.onFocus()\"\n				  ng-model=\"$ctrl.value\"\n				  ng-model-options=\"{ getterSetter: true, allowInvalid: true }\"\n				  ng-trim=\"false\"\n				  rows=\"{{ $ctrl.inputRows }}\">\n		</textarea>\n	</div>\n	<div ng-if=\"$ctrl.maxChars && $ctrl.maxChars > 0\">\n		<div class=\"col-sm-2 char-counter-container\"\n			 ng-if=\"$ctrl.inputFocused\">\n			<div class=\"label character-counter\">{{ $ctrl.charsRemaining }}</div>\n		</div>\n	</div>\n</div>\n\n");
        $templateCache.put("components/visual/enhancedTextInput/enhanced-textinput-template.html", "<div class=\"row\">\n	<div ng-class=\"$ctrl.inputFocused && $ctrl.maxChars && $ctrl.maxChars > 0 ? \'char-counter-input-container\' : \'col-sm-12\'\">\n		<input type=\"text\"\n			   autocomplete=\"off\"\n			   class=\"form-control prism-text-input\"\n			   id=\"{{ $ctrl.inputId }}\"\n			   maxlength=\"{{ $ctrl.maxChars }}\"\n			   ng-blur=\"$ctrl.onBlur()\"\n			   ng-change=\"$ctrl.onInputChange()\"\n			   ng-disabled=\"$ctrl.disableProp\"\n			   ng-focus=\"$ctrl.onFocus()\"\n			   ng-model=\"$ctrl.modelProp\"\n			   ng-model-options=\"{ allowInvalid: true }\"\n			   ng-trim=\"false\"/>\n	</div>\n	<div ng-if=\"$ctrl.maxChars && $ctrl.maxChars > 0\">\n		<div class=\"col-sm-2 char-counter-container\"\n			 ng-if=\"$ctrl.inputFocused\">\n			<div class=\"label character-counter\">{{ $ctrl.charsRemaining }}</div>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("components/visual/errorsAndWarnings/errors-and-warnings-indicator-template.html", "<div ng-switch=\"$ctrl.errorWarning.type\">\n	<div ng-switch-when=\"error\" class=\"fa-stack fa error-warning-triangle metadata tree-top-level-error\" data-tooltip-append-to-body=\"true\"\n		 uib-tooltip=\"{{$ctrl.errorWarning.message}}\">\n		<i class=\"fa fa-square fa-stack-1x\"></i>\n		<i class=\"fa fa-exclamation-triangle fa-stack-2x\"></i>\n	</div>\n	<div ng-switch-when=\"warning\" class=\"fa-stack fa error-warning-triangle metadata tree-top-level-warning\" data-tooltip-append-to-body=\"true\"\n		 uib-tooltip=\"{{$ctrl.errorWarning.message}}\">\n		<i class=\"fa fa-square fa-stack-1x\"></i>\n		<i class=\"fa fa-exclamation-triangle fa-stack-2x\"></i>\n	</div>\n</div>\n");
        $templateCache.put("components/visual/expressionField/expression-field-template.html", "<div class=\"form-group form-group-custom\">\n	<fieldset ng-if=\"$ctrl.customMetaObj.isExpression\">\n		<enhanced-textarea ng-model=\"$ctrl.customMetaObj.expression\"\n						   id=\"{{$ctrl.partnerMetaItem.name + \'expressionField\' + $index}}\"\n						   ng-disabled=\"!$ctrl.customMetaObj.isExpression\"\n						   input-rows=\"4\"\n						   class=\"col-sm-11 no-padding expression-field\">\n		</enhanced-textarea>\n	</fieldset>\n</div>\n\n\n\n\n\n\n\n\n");
        $templateCache.put("components/visual/fieldValidation/field-validation-template.html", "<div class=\"field-validation\">\n    <ng-form role=\"form\" name=\"$ctrl.editorForm\">\n        <div class=\"field-requirements-header\">{{$ctrl.header}}</div>\n        <div class=\"field-requirements-entry\"\n             ng-repeat=\"requirement in $ctrl.requirements\"\n             ng-class=\"{\'pass\': $ctrl.isValid(requirement), \'warning\': $ctrl.isWarning(requirement), \'fail\': $ctrl.isFail(requirement)}\">\n            <i class=\"fa fa-check requirement-pass-icon\"></i>\n            <i class=\"fa fa-warning requirement-warning-icon\"></i>\n            <i class=\"fa fa-times requirement-fail-icon\"></i>\n            {{$ctrl.getDescription(requirement)}}\n        </div>\n    </ng-form>\n</div>\n");
        $templateCache.put("components/visual/grid/base-tooltip-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\" data-tooltip-append-to-body=\"true\" uib-tooltip=\"{{COL_FIELD CUSTOM_FILTERS}}\">\n    <span>{{COL_FIELD CUSTOM_FILTERS}}</span>\n</div>\n");
        $templateCache.put("components/visual/grid/boolean-flag-checkmark-template.html", "<div class=\"ui-grid-cell-contents text-align-center\">\n	<i class=\"fa fa-check\" ng-if=\"COL_FIELD\"></i>\n</div>\n");
        $templateCache.put("components/visual/grid/boolean-flag-template.html", "<div class=\"ui-grid-cell-contents\">\n	<span>{{COL_FIELD? \'YES\' : \'NO\'}}</span>\n</div>\n");
        $templateCache.put("components/visual/grid/category-type-cell-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\"\n     data-tooltip-append-to-body=\"true\"\n     ng-class=\"{ \'ui-grid-cell-hidden\' : row.entity.hidden,  \'ui-grid-cell-disabled\' : row.entity.disabled , \'ui-grid-cell-short-form\': row.entity.type.name === \'Short Form\', \'ui-grid-cell-long-form\': row.entity.type.name === \'Long Form\'}\"\n     uib-tooltip=\"{{COL_FIELD CUSTOM_FILTERS}}\"\n     ng-dblclick=\"grid.appScope.$ctrl.rowDoubleClick(row, column)\">\n    <span class=\"padding-left-sm\">{{COL_FIELD CUSTOM_FILTERS}}</span>\n</div>\n");
        $templateCache.put("components/visual/grid/check-mark-boolean-template.html", "<div class=\"checkbox-grid-cell\" ng-click=\"grid.appScope.$ctrl.checkMarkCellClicked(row, $event)\">\n	<input type=\"checkbox\" ng-checked=\"COL_FIELD\"/>\n	<label></label>\n</div>\n");
        $templateCache.put("components/visual/grid/check-mark-template.html", "<div class=\"checkbox-grid-cell\" ng-click=\"selectButtonClick(row, $event)\">\n    <input type=\"checkbox\" ng-checked=\"row.isSelected\"/>\n	<label></label>\n</div>\n");
        $templateCache.put("components/visual/grid/checkbox-cell-template.html", "<div class=\"checkbox-grid-cell\" ng-click=\"grid.appScope.$ctrl.onRowSelection(row, col, $event)\">\n    <input type=\"checkbox\" id=\"{{row.entity.name + col.field + \'CB\'}}\" ng-checked=\"grid.appScope.$ctrl.shouldBeChecked(row, col)\"/>\n    <label for=\"{{row.entity.name + col.field + \'CB\'}}\"></label>\n</div>\n\n");
        $templateCache.put("components/visual/grid/comma-seperated-array-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\" data-tooltip-append-to-body=\"true\" uib-tooltip=\"{{COL_FIELD.join(\', \')}}\">\n	<span>{{COL_FIELD.join(\', \')}}</span>\n</div>\n");
        $templateCache.put("components/visual/grid/date-column-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\" data-tooltip-append-to-body=\"true\"\n     uib-tooltip=\"{{COL_FIELD | date: \'MMM d, yyyy\'}}\">\n     <span>{{COL_FIELD | date: \'MMM d, yyyy\'}}</span>\n</div>\n");
        $templateCache.put("components/visual/grid/date-time-column-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\" data-tooltip-append-to-body=\"true\"\n     uib-tooltip=\"{{COL_FIELD | amDateFormat: \'MM/DD/YYYY hh:mm:ss A\'}}\">\n     <span>{{COL_FIELD | amDateFormat: \'MM/DD/YYYY hh:mm:ss A\'}}</span>\n</div>\n");
        $templateCache.put("components/visual/grid/date-time-noseconds-column-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\" data-tooltip-append-to-body=\"true\"\n	 uib-tooltip=\"{{COL_FIELD | amDateFormat: \'MM/DD/YYYY hh:mm A\'}}\">\n	<span>{{COL_FIELD | amDateFormat: \'MM/DD/YYYY hh:mm A\'}}</span>\n</div>\n");
        $templateCache.put("components/visual/grid/day-count-template.html", "<div class=\"ui-grid-cell-contents\">\n	<span class=\"padding-left-sm\">\n		{{ COL_FIELD + \" day\" + (COL_FIELD == 1 ? \"\" : \"s\") }}\n	</span>\n</div>\n");
        $templateCache.put("components/visual/grid/exception-icon-template.html", "<div class=\"ui-grid-cell-contents no-cell-padding ng-scope ng-binding\"\n     ng-if=\"COL_FIELD.exceptions.length >= 0 || (col.field === \'edit\' || col.field === \'remove\')\"\n     ng-click=\"grid.appScope.$ctrl.exceptionCellClickHandler(row, col, rowRenderIndex, $event)\">\n    <span class=\"fa-stack\">\n        <div ng-switch=\"col.field\">\n            <div ng-switch-when=\"edit\">\n                <i class=\"fa fa-pencil fa-stack-1x\"></i>\n            </div>\n            <div ng-switch-when=\"remove\">\n                <i class=\"fa fa-minus-circle fa-stack-1x\"></i>\n            </div>\n            <div data-ng-switch-default>\n                <i class=\"fa fa-plus-circle fa-stack-1x\"\n                   ng-class=\"{ \'cell-disabled\' : COL_FIELD.permissionTypes.length === 0 }\">\n                </i>\n            </div>\n        </div>\n    </span>\n</div>\n");
        $templateCache.put("components/visual/grid/header-check-mark-component-template.html", "<div class=\"ui-grid-cell-contents\"\n	 col-index=\"renderIndex\"\n	 ng-click=\"grid.appScope.$ctrl.onSelectAllToggled($event)\">\n	<input type=\"checkbox\"\n		   ng-checked=\"grid.selection.selectAll\"/>\n	<label></label>\n</div>\n");
        $templateCache.put("components/visual/grid/header-check-mark-row-count-template.html", "<div class=\"ui-grid-cell-contents\"  col-index=\"renderIndex\" ng-click=\"grid.appScope.$ctrl.toggleRows($event)\">\n	<input type=\"checkbox\" ng-checked=\"grid.selection.selectAll\"/>\n	<label>{{grid.selection.selectedCount}}</label>\n</div>\n\n");
        $templateCache.put("components/visual/grid/header-check-mark-template.html", "<div class=\"ui-grid-cell-contents\"  col-index=\"renderIndex\" ng-click=\"grid.appScope.searchController.toggleRows($event)\">\n    <input type=\"checkbox\" ng-checked=\"grid.selection.selectAll\"/>\n	<label></label>\n</div>\n");
        $templateCache.put("components/visual/grid/header-lock-icon-template.html", "<div  class=\"ui-grid-cell-contents lock-header\" col-index=\"renderIndex\" data-tooltip-append-to-body=\"true\">\n	<i class=\"fa fa-lock content-lock\"></i>\n</div>\n");
        $templateCache.put("components/visual/grid/hour-count-template.html", "<div class=\"ui-grid-cell-contents\">\n	<span class=\"padding-left-sm\">\n		{{ COL_FIELD + \" hour\" + (COL_FIELD == 1 ? \"\" : \"s\") }}\n	</span>\n</div>\n");
        $templateCache.put("components/visual/grid/hyperlink-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\"><a\n        href=\"{{row.entity.collaborator ?  row.entity.collaborator.iMDbLink : row.entity.iMDbLink}}\" class=\"imdb-link\"\n        target=\"_blank\">{{row.entity.collaborator ? row.entity.collaborator.iMDbNumber : row.entity.iMDbNumber}}</a>\n</div>\n");
        $templateCache.put("components/visual/grid/inline-edit-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\"\n     ng-class=\"{\'ui-grid-cell-edited\': row.entity.edited, \'ui-grid-cell-error\': row.entity.alias === \'\'}\"\n     data-tooltip-append-to-body=\"true\"\n     uib-tooltip=\"{{COL_FIELD CUSTOM_FILTERS}}\">\n    <span class=\"padding-left-sm\">{{COL_FIELD CUSTOM_FILTERS}}</span>\n</div>\n");
        $templateCache.put("components/visual/grid/lock-icon-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\" data-tooltip-append-to-body=\"true\">\n	<i class=\"fa fa-lock content-lock\" ng-show=\"COL_FIELD\"></i>\n</div>\n");
        $templateCache.put("components/visual/grid/mvpd-required-error-template.html", "<div class=\"workflow-status-icon\"\n	 ng-dblclick=\"grid.appScope.$ctrl.rowDoubleClick(row, column)\">\n	<span class=\"padding-left-sm\">{{COL_FIELD CUSTOM_FILTERS}}</span>\n	<span ng-if=\"row.entity.metadata.missingMVPDFields.length > 0\"\n		  class=\"fa-stack stalled-status\" data-tooltip-append-to-body=\"true\"\n		  uib-tooltip=\"{{grid.appScope.$ctrl.getFieldErrorsTooltip(row.entity.metadata.missingMVPDFields)}}\">\n		<i class=\"fa fa-square fa-stack-1x\"></i>\n		<i class=\"fa fa-exclamation-triangle fa-stack-2x\"></i>\n	</span>\n</div>\n");
        $templateCache.put("components/visual/grid/padded-base-tooltip-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\"\n     ng-class=\"{\n        \'cell-contains-a-search-result\' : grid.appScope.$ctrl.cellHasASearchResult(row.entity, col.field),\n        \'cell-contains-current-search-result\' : grid.appScope.$ctrl.cellHasCurrentSearchResult(row.entity, col.field)\n     }\"\n     data-tooltip-append-to-body=\"true\"\n     uib-tooltip=\"{{COL_FIELD CUSTOM_FILTERS}}\"\n     ng-dblclick=\"grid.appScope.$ctrl.rowDoubleClick(row, column)\">\n    <span class=\"padding-left-sm\">{{COL_FIELD CUSTOM_FILTERS}}</span>\n</div>\n");
        $templateCache.put("components/visual/grid/pdf-file-download-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding text-align-center\"\n	 data-tooltip-append-to-body=\"true\"\n	 ng-if=\"COL_FIELD.length > 0\"\n	 ng-click=\"grid.appScope.$ctrl.downloadFile(COL_FIELD)\"\n	 uib-tooltip=\"{{COL_FIELD CUSTOM_FILTERS}}\">\n	<span><i class=\"fa fa-file-pdf-o\"></i></span>\n</div>\n");
        $templateCache.put("components/visual/grid/play-proxy-icon-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding play-icon\"\n	 ng-show=\"row.entity.proxyPath\">\n    <span class=\"fa-stack\">\n		<a ng-click=\"grid.appScope.openVideoModal(row.entity)\">\n			<i class=\"fa fa-circle-thin fa-stack-1x\"></i>\n      		<i class=\"fa fa-play fa-stack-1x\"></i>\n			<i class=\"fa fa-minus fa-1\" ng-if=\"!row.entity.proxyPath\"></i>\n		</a>\n    </span>\n</div>\n");
        $templateCache.put("components/visual/grid/predelivery-approval-icon-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding text-align-center\"\n	 data-tooltip-append-to-body=\"true\"\n     uib-tooltip=\"{{\'Pre-Delivery QC Approval\' CUSTOM_FILTERS}}\"\n	 ng-if=\"COL_FIELD\">\n	<span><i class=\"fa fa-check\"></i></span>\n</div>\n");
        $templateCache.put("components/visual/grid/predelivery-validate-icon-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding text-align-center\"\n	 data-tooltip-append-to-body=\"true\"\n     uib-tooltip=\"{{\'Pre-Delivery Validator\' CUSTOM_FILTERS}}\"\n	 ng-if=\"COL_FIELD\">\n	<span><i class=\"fa fa-check\"></i></span>\n</div>\n");
        $templateCache.put("components/visual/grid/progress-bar-template.html", "<div class=\"ui-grid-cell-contents progress-container ng-scope ng-binding\" data-tooltip-append-to-body=\"true\"\n	 uib-tooltip=\"{{COL_FIELD}}%\">\n	<uib-progress class=\"prism-progress pull-left\">\n		<uib-bar class=\"prism-progressbar\" value=\"COL_FIELD\"></uib-bar>\n	</uib-progress>\n	<span class=\"prism-progress-pct-label\">\n		({{COL_FIELD}})%\n	</span>\n</div>\n");
        $templateCache.put("components/visual/grid/radio-button-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\" data-tooltip-append-to-body=\"true\">\n	<i class=\"fa fa-circle\" ng-class=\"{\'valid\' : COL_FIELD}\"></i>\n</div>\n");
        $templateCache.put("components/visual/grid/read-check-mark-template.html", "<div class=\"checkbox-grid-cell text-align-right\" ng-click=\"grid.appScope.$ctrl.checkMarkCellClicked(row, col, $event)\">\n    <input type=\"checkbox\" ng-checked=\"COL_FIELD.length > 0\"/>\n    <label></label>\n</div>\n");
        $templateCache.put("components/visual/grid/read-only-text-input-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\" data-tooltip-append-to-body=\"true\"\n	 uib-tooltip=\"{{COL_FIELD CUSTOM_FILTERS}}\">\n	<input disabled type=\"text\" class=\"form-control read-only-input\" value=\"{{COL_FIELD CUSTOM_FILTERS}}\"/>\n</div>\n");
        $templateCache.put("components/visual/grid/searchview-component-row-template.html", "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\"\n     ng-class=\"{ \'ui-grid-cell-hidden\' : row.entity.hidden || row.entity.archivedFlag,  \'ui-grid-cell-disabled\' : row.entity.disabled}\"\n     class=\"ui-grid-cell ng-scope ng-binding\"\n     ui-grid-cell\n     ng-dblclick=\"grid.appScope.$ctrl.onRowDblClick(row)\">\n</div>\n");
        $templateCache.put("components/visual/grid/text-file-download-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding text-align-center\"\n	 data-tooltip-append-to-body=\"true\"\n	 ng-if=\"COL_FIELD.length > 0\"\n	 ng-click=\"grid.appScope.$ctrl.downloadFile(COL_FIELD)\"\n	 uib-tooltip=\"{{COL_FIELD CUSTOM_FILTERS}}\">\n	<span><i class=\"fa fa-file-text-o\"></i></span>\n</div>\n");
        $templateCache.put("components/visual/grid/time-column-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding time-cell\" data-tooltip-append-to-body=\"true\"\n	 uib-tooltip=\"{{COL_FIELD | timeTo12HFormat}}\">\n	<span>{{COL_FIELD | timeTo12HFormat}}</span>\n</div>\n");
        $templateCache.put("components/visual/grid/time-from-date-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\" data-tooltip-append-to-body=\"true\"\n	 uib-tooltip=\"{{COL_FIELD | amDateFormat: \'hh:mm A\'}}\">\n	<span>{{COL_FIELD | amDateFormat: \'hh:mm A\'}}</span>\n</div>\n");
        $templateCache.put("components/visual/grid/video-file-download-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding text-align-center\"\n	 data-tooltip-append-to-body=\"true\"\n	 ng-if=\"COL_FIELD.length > 0\"\n	 ng-click=\"grid.appScope.$ctrl.downloadFile(COL_FIELD)\"\n	 uib-tooltip=\"{{COL_FIELD CUSTOM_FILTERS}}\">\n	<span><i class=\"fa fa-file-video-o\"></i></span>\n</div>\n");
        $templateCache.put("components/visual/grid/write-execute-check-mark-template.html", "<div class=\"checkbox-grid-cell text-align-right\" ng-click=\"grid.appScope.$ctrl.checkMarkCellClicked(row, col, $event)\">\n    <input type=\"checkbox\" ng-checked=\"COL_FIELD.length > 1\"/>\n    <label></label>\n</div>\n");
        $templateCache.put("components/visual/icon/qc-notes-icon-template.html", "<div ng-switch on=\"$ctrl.iconState\" class=\"qc-note-wrapper\">\n	<div class=\"fa-stack qc-notes-add\" ng-switch-when=\"add\">\n		<i class=\"fa fa-pencil fa-stack-1x\"></i>\n		<span class=\"fa-stack add-circle\">\n			<i class=\"fa fa-circle fa-stack-1x\"></i>\n			<i class=\"fa fa-plus fa-stack-1x\"></i>\n		</span>\n	</div>\n	<div class=\"qc-notes-edit\" ng-switch-when=\"edit\">\n		<i class=\"fa fa-sticky-note\"></i>\n	</div>\n</div>\n");
        $templateCache.put("components/visual/icon/status-icon-template.html", "<div ng-switch=\"$ctrl.status\">\n    <div ng-switch-when=\"CREATING\"\n         class=\"fa-stack pkg-status-creating\">\n        <i class=\"fa fa-circle fa-stack-2x\"></i>\n        <i class=\"fa fa-cogs fa-stack-1x\"></i>\n    </div>\n    <div ng-switch-when=\"DELIVERED\"\n         class=\"fa-stack pkg-status-delivered \">\n        <i class=\"fa fa-circle fa-stack-2x\"></i>\n        <i class=\"fa fa-trophy fa-stack-1x\"></i>\n    </div>\n    <div ng-switch-when=\"DELIVERING\"\n         class=\"fa-stack pkg-status-delivering \">\n        <i class=\"fa fa-circle fa-stack-2x\"></i>\n        <i class=\"fa fa-download fa-stack-1x\"></i>\n    </div>\n    <div ng-switch-when=\"INVALID\"\n         class=\"fa-stack pkg-status-invalid \">\n        <i class=\"fa fa-circle fa-stack-2x\"></i>\n        <i class=\"fa fa-ban fa-stack-1x fa-flip-horizontal\"></i>\n    </div>\n    <div ng-switch-when=\"READY_FOR_DELIVERY\"\n         class=\"fa-stack pkg-status-ready \">\n        <i class=\"fa fa-circle fa-stack-2x\"></i>\n        <i class=\"fa fa-thumbs-o-up fa-stack-1x fa-flip-horizontal\"></i>\n    </div>\n    <div ng-switch-when=\"REJECTED\"\n         class=\"fa-stack pkg-status-rejected \">\n        <i class=\"fa fa-circle fa-stack-2x\"></i>\n        <i class=\"fa fa-thumbs-o-down fa-stack-1x\"></i>\n    </div>\n    <div ng-switch-when=\"STALLED\"\n         class=\"fa-stack pkg-status-stalled \">\n        <i class=\"fa fa-circle fa-stack-2x\"></i>\n        <i class=\"fa fa-bug fa-stack-1x\"></i>\n    </div>\n    <div ng-switch-when=\"INPROGRESS\"\n         class=\"fa-stack pkg-status-inprogress\">\n        <i class=\"fa fa-play-circle fa-2x\"></i>\n    </div>\n    <div ng-switch-when=\"PENDING\"\n         class=\"fa-stack pkg-status-pending \">\n        <i class=\"fa fa-exclamation-triangle fa-stack-2x\"></i>\n    </div>\n    <div ng-switch-when=\"DRAFT\"\n         class=\"fa-stack pkg-status-draft \">\n        <i class=\"fa fa-fw fa-circle fa-stack-2x\"></i>\n        <i class=\"fa fa-fw fa-pencil fa-stack-1x\"></i>\n    </div>\n    <div ng-switch-when=\"PENDING_DELIVERY\"\n         class=\"fa-stack pkg-status-pending-delivery\">\n        <i class=\"fa fa-circle fa-stack-2x\"></i>\n        <i class=\"fa fa-hourglass-end fa-stack-1x\"></i>\n    </div>\n    <div ng-switch-when=\"PENDING_APPROVAL\"\n         class=\"fa-stack pkg-status-pending-approval\">\n        <i class=\"fa fa-circle fa-stack-2x\"></i>\n        <i class=\"fa fa-hourglass-end fa-stack-1x\"></i>\n    </div>\n    <div ng-switch-when=\"TRANSCODING\"\n         class=\"fa-stack pkg-status-transcoding\">\n        <i class=\"fa fa-circle fa-stack-2x\"></i>\n        <i class=\"fa fa-cogs fa-stack-1x\"></i>\n    </div>\n    <div ng-switch-when=\"RESTORING\"\n         class=\"fa-stack pkg-status-delivering\">\n        <i class=\"fa fa-circle fa-stack-2x\"></i>\n        <i class=\"fa fa-download fa-stack-1x\"></i>\n    </div>\n    <div ng-switch-when=\"PENDING_RESTORE\"\n         class=\"fa-stack pkg-status-delivering\">\n        <i class=\"fa fa-circle fa-stack-2x\"></i>\n        <i class=\"fa fa-download fa-stack-1x\"></i>\n    </div>\n</div>\n\n");
        $templateCache.put("components/visual/list/prism-list-template.html", "<div class=\"list-group prism-list protected-grid\">\n	<a class=\"list-group-item\" ng-class=\"{\'active\': listController.isItemSelected(item)}\" ng-click=\"listController.selectItem(item)\"\n	   ng-repeat=\"item in listController.items\">{{item[listController.labelField]}}</a>\n</div>\n");
        $templateCache.put("components/visual/multiselect-dropdown/multiselect-dropdown-template.html", "<div class=\"btn-group select-dropdown-container\"\n     ng-class=\"{\'dropup\': dropup}\"\n     uib-dropdown\n     keyboard-nav\n     ng-attr-dropdown-append-to-body=\"{{attachToBody || undefined}}\"\n     is-open=\"dropdown.isopen\"\n     auto-close=\"outsideClick\">\n    <button type=\"button\"\n            class=\"btn btn-default prism-button dropdown-toggle flex-row-container\"\n            ng-disabled=\"componentDisabled\"\n            ng-click=\"toggleDropDown($event)\"\n            ng-style=\"widthStyle\"\n            ng-keydown=\"selectOptionFromKey($event)\">\n        <div class=\"flex-truncate-text\">\n            {{buttonPrompt || promptFunction()}}\n        </div>\n        <div class=\"flex-stretcher\" style=\"min-width: 5px;\">\n            <div class=\"loadingIndicator padding-right-sm\"\n                 ng-show=\"showLoading && dropdown.isopen\">\n                <div class=\"button-loading-indicator\"\n                     data-lb-progress=\"loadingIndicator\"\n                     ng-show=\"true\">\n                </div>\n            </div>\n        </div>\n        <i class=\"fa fa-sort dropdown-arrows\"></i>\n    </button>\n    <ul class=\"multiselect-dropdown-menu\"\n        ng-style=\"{\'max-height\' : maxHeight}\"\n        uib-dropdown-menu\n        role=\"menu\"\n        ng-style=\"widthStyle\"\n        ng-keydown=\"selectOptionFromKey($event)\">\n\n        <div class=\"loadingIndicator\">\n            <div data-lb-progress=\"loadingIndicator\"\n                 class=\"flex-stretcher\"\n                 ng-show=\"showLoading\">\n            </div>\n        </div>\n\n        <!-- Select All -->\n        <li role=\"menuitem\"\n            ng-if=\"enableSelectAll\"\n            ng-keydown=\"selectOptionFromKey($event)\">\n            <div class=\"checkbox\">\n                <input id=\"{{idCleaner(parentId + \'SelectAllMSCB\')}}\"\n                       type=\"checkbox\"\n                       ng-click=\"toggleAllOptions($event)\"\n                       ng-checked=\"areAllOptionsSelected()\"/>\n                <label for=\"{{idCleaner(parentId + \'SelectAllMSCB\')}}\">\n                    Select All\n                </label>\n            </div>\n        </li>\n\n        <!-- List Items -->\n        <li role=\"menuitem\"\n            ng-repeat=\"item in (collection | filter:collectionFilter | orderBy:collectionSortProperty) track by $index\"\n            ng-keydown=\"selectOptionFromKey($event)\"\n            ng-disabled=\"item.disabled\">\n\n            <!-- List Option - Divider (if enabled) -->\n            <div class=\"multiselect-divider\"\n                 ng-style=\"{\'color\' : item._multiselectDividerColor || \'black\', \'font-weight\' : item._multiselectDividerFontWeight || \'regular\'}\"\n                 ng-if=\"dividersEnabled && item._multiselectDivider\">\n                {{item._multiselectDividerText}}&nbsp;\n            </div>\n\n            <!-- List Option - Checkbox + Label -->\n            <div class=\"checkbox\"\n                 ng-if=\"!dividersEnabled || !item._multiselectDivider\">\n                <input id=\"{{idCleaner(parentId + \'_Option\' + $index + \'MSCB\')}}\"\n                       type=\"checkbox\"\n                       ng-click=\"toggleOption(item || $index + 1, $event)\"\n                       ng-checked=\"isOptionSelected(item)\"\n                       ng-disabled=\"item.disabled\"/>\n                <label for=\"{{idCleaner(parentId + \'_Option\' + $index + \'MSCB\')}}\"\n                       ng-class=\"{\'lockSelection\' : item[lockSelectionProp]}\">{{dropdownLabelFunction(item || $index + 1)}}</label>\n            </div>\n\n            <i class=\"fa fa-lock content-lock\"\n               ng-show=\"!ignoreLocks && item.locked\"></i>\n        </li>\n\n    </ul>\n    <a class=\"fa-stack clear-dropdown\"\n       ng-disabled=\"componentDisabled\"\n       ng-show=\"clearVisible()\"\n       ng-click=\"clearSelections($event)\"\n       href=\"\">\n        <i class=\"fa fa-circle fa-stack-1x\"></i>\n        <i class=\"fa fa-times fa-stack-1x\"></i>\n    </a>\n</div>\n");
        $templateCache.put("components/visual/pacifier/pacifier-template.html", "<div data-ng-switch class=\"preloader-container\" data-on=\"lbProgress.size\">\n	<div data-ng-switch-when=\"lg\" class=\"preloader-lg\">\n<!--		<img class=\"preloader-img img-lg\" src=\"assets/images/preloader.svg\"/>-->\n        <div class=\"preloader-img img-lg\">\n            <i class=\"fa fa-circle-o-notch preloader-spin fa-3x fa-fw\"></i>\n            <span class=\"sr-only\">Loading...</span>\n        </div>\n\n		<div class=\"preloader-content text-center\">\n            <p class=\"title\">LOADING</p>\n<!--			<p class=\"title\">{{lbProgress.title}}</p>-->\n			<p class=\"message\">{{lbProgress.message}}</p>\n		</div>\n	</div>\n\n	<div data-ng-switch-when=\"md\" class=\"preloader-md\">\n        <i class=\"fa fa-circle-o-notch fa-spin fa-3x fa-fw\"></i>\n<!--		<img class=\"preloader-img img-md\" src=\"assets/images/preloader.svg\"/>-->\n	</div>\n\n	<div data-ng-switch-when=\"sm\" class=\"preloader-sm\">\n        <i class=\"fa fa-circle-o-notch fa-spin fa-3x fa-fw\"></i>\n<!--		<img class=\"preloader-img img-sm\" src=\"assets/images/preloader_small.svg\"/>-->\n	</div>\n\n</div>\n");
        $templateCache.put("components/visual/requirementList/requirement-list-template.html", "<div ui-grid=\"$ctrl.gridOptions\"\n	 class=\"requirement-list inline-checkbox-grid\"\n	 ng-class=\"{\'protected-grid\': $ctrl.disabled}\"\n	 ui-grid-selection\n	 ui-grid-auto-resize>\n</div>\n");
        $templateCache.put("components/visual/textListInput/text-list-input-template.html", "<fieldset ng-disabled=\"$ctrl.componentDisabled\">\n\n	<div class=\"row text-list-input\">\n\n		<div class=\"col-sm-12\">\n\n			<div class=\"row\">\n\n				<div class=\"col-md-6\">\n					<button id=\"{{$ctrl.name}}_addStringItem\"\n							class=\"btn btn-default prism-button\"\n							ng-disabled=\"!$ctrl.canAddItem()\"\n							ng-click=\"$ctrl.addStringItem($event)\">\n						<i class=\"fa fa-plus\"></i>\n					</button>\n					<button id=\"{{$ctrl.name}}_removeStringItem\"\n							ng-disabled=\"$ctrl.items.length === 0\"\n							class=\"btn btn-default prism-button\"\n							ng-click=\"$ctrl.removeStringItem()\">\n						<i class=\"fa fa-minus\"></i>\n					</button>\n				</div>\n\n			</div>\n\n			<div class=\"row padding-left-md\">\n				<div class=\"row padding-left-md\">\n					<div class=\"pad-select-all-checkbox-col\">\n						<input type=\"checkbox\"\n							   id=\"{{$ctrl.name}}{{$index}}_selectAll\"\n							   ng-disabled=\"$ctrl.items.length === 0\"\n							   ng-click=\"$ctrl.selectAll()\"\n							   ng-model=\"$ctrl.selectAllActive\"/>\n						<label for=\"{{$ctrl.name}}{{$index}}_selectAll\">Select All</label>\n					</div>\n				</div>\n\n				<div class=\"col-md-12 no-padding text-list-input-content\">\n\n					<div ng-repeat=\"item in $ctrl.items track by $index\" class=\"clearfix\">\n\n						<div class=\"no-padding pad-checkbox-col pull-left\">\n							<input type=\"checkbox\"\n								   id=\"{{$ctrl.name}}{{$index}}_checkBox\"\n								   ng-model=\"item.active\"/>\n							<label for=\"{{$ctrl.name}}{{$index}}_checkBox\"></label>\n						</div>\n\n						<div class=\"no-padding pad-text-input-col pull-left\">\n							<input id=\"{{$ctrl.name}}_stringInput_{{$index}}\"\n								   type=\"text\"\n								   class=\"prism-text-input\"\n								   autocomplete=\"off\"\n								   ng-model=\"item.stringValue\"\n								   ng-blur=\"$ctrl.updateModel()\"\n								   ng-change=\"$ctrl.validateInput(item.stringValue)\"/>\n						</div>\n\n					</div>\n\n				</div>\n\n			</div>\n\n		</div>\n\n	</div>\n\n</fieldset>\n");
        $templateCache.put("components/visual/timecode/timecodeinput-template.html", "<div ng-class=\"$ctrl.rootClass\" >\n	<input id=\"hours\"\n           class=\"prism-timecode-part\"\n           ng-class=\"{\'has-error\': $ctrl.hours > 23}\"\n           type=\"text\"\n		   ng-model=\"$ctrl.hours\"\n           ng-disabled=\"$ctrl.componentDisabled\"\n           ng-change=\"$ctrl.timecodeChanged(\'hours\', \'minutes\')\"\n           ng-blur=\"$ctrl.onPartExit($event)\"\n           size=\"2\"\n           autocomplete=\"off\"/> :\n	<input id=\"minutes\"\n           class=\"prism-timecode-part\"\n           ng-class=\"{\'has-error\': $ctrl.minutes > 59}\"\n           type=\"text\"\n		   ng-model=\"$ctrl.minutes\"\n           ng-disabled=\"$ctrl.componentDisabled\"\n           ng-change=\"$ctrl.timecodeChanged(\'minutes\', \'seconds\')\"\n           ng-blur=\"$ctrl.onPartExit($event)\"\n           size=\"2\"\n           autocomplete=\"off\"/> :\n	<input id=\"seconds\"\n           class=\"prism-timecode-part\"\n           ng-class=\"{\'has-error\': $ctrl.seconds > 59}\"\n           type=\"text\"\n		   ng-model=\"$ctrl.seconds\"\n           ng-disabled=\"$ctrl.componentDisabled\"\n           ng-change=\"$ctrl.timecodeChanged(\'seconds\', \'frames\')\"\n           ng-blur=\"$ctrl.onPartExit($event)\"\n           size=\"2\"\n           autocomplete=\"off\"/> {{($ctrl.dropFrame)? \';\' : \':\'}}\n	<input id=\"frames\"\n           class=\"prism-timecode-part\"\n           ng-class=\"{\'has-error\': $ctrl.frames > 59}\"\n           type=\"text\"\n		   ng-model=\"$ctrl.frames\"\n           ng-disabled=\"$ctrl.componentDisabled\"\n           ng-change=\"$ctrl.timecodeChanged(\'frames\', \'frames\')\"\n           ng-blur=\"$ctrl.onPartExit($event)\"\n           size=\"2\"\n           autocomplete=\"off\"\n    />\n</div>\n\n");
        $templateCache.put("components/visual/timepicker/prism-timepicker-template.html", "<table>\n	<tbody>\n	<tr class=\"text-center\" ng-show=\"::showSpinners\">\n		<td><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementHours()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n		<td>&nbsp;</td>\n		<td><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementMinutes()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n		<td ng-show=\"showMeridian\"></td>\n	</tr>\n	<tr>\n		<td class=\"form-group\" ng-class=\"{\'has-error\': invalidHours}\">\n			<input style=\"width:35px;\" type=\"text\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control prism-text-input text-center\"\n				   ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" autocomplete=\"off\">\n		</td>\n		<td class=\"timepickerseperator\">:</td>\n		<td class=\"form-group\" ng-class=\"{\'has-error\': invalidMinutes}\">\n			<input style=\"width:35px;\" type=\"text\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control prism-text-input text-center\"\n				   ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" autocomplete=\"off\">\n		</td>\n		<td ng-show=\"showMeridian\">\n			<dropdown-select collection=\"[\'AM\', \'PM\']\" ng-model=\"meridian\" ng-change=\"toggleMeridian()\" btn-min-width=\"55\"></dropdown-select>\n		</td>\n	</tr>\n	<tr class=\"text-center\" ng-show=\"::showSpinners\">\n		<td><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementHours()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n		<td>&nbsp;</td>\n		<td><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementMinutes()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n		<td ng-show=\"showMeridian\"></td>\n	</tr>\n	</tbody>\n</table>\n");
        $templateCache.put("components/visual/toolbar/toolbar-template.html", "<div class=\"row-no-padding manager-toolbar\">\n	<div class=\"col-lg-12 col-md-12\">\n		<form class=\"form-inline toolbar-top-padding-sm\" name=\"partnerSearchViewToolbar\">\n			<div class=\"flex-row-container col-sm-4 col-md-4 col-lg-4\">\n\n				<!-- Toolbar Buttons -->\n				<div ng-repeat=\"btn in $ctrl.getButtons()\"\n					 class=\"toolbar-padding\"\n					 style=\"order: {{btn.order}}\">\n					<a class=\"toolbar-button\"\n					   role=\"button\"\n					   id=\"{{btn.label.toLowerCase() + \'ToolbarBtn\'}}\"\n					   ng-disabled=\"!btn.enabled()\"\n					   ng-click=\"btn.enabled()? btn.onClick(): angular.noop()\">\n						<i ng-if=\"!btn.hasIconStack\" class=\"fa {{btn.icon}}\"></i>\n                        <span ng-if=\"btn.hasIconStack\" class=\"fa-stack\">\n                            <i ng-repeat=\"iconName in btn.icon\" class=\"fa {{iconName}} fa-stack-1x\"></i>\n                        </span>\n                        <br>{{btn.label}}\n					</a>\n				</div>\n\n			</div>\n\n			<div class=\"flex-row-reverse-container col-sm-8 col-md-8 col-lg-8\" style=\"height:100%\">\n\n				<!-- Pagination -->\n				<pagination-controls\n					ng-show=\"$ctrl.paginationSupported()\"\n					prev-page-handler=\"$ctrl.paginationDefs.paginationPrevPageHandler()\"\n					next-page-handler=\"$ctrl.paginationDefs.paginationNextPageHandler()\"\n					jump-to-page-handler=\"$ctrl.paginationDefs.paginationJumpToPageHandler()\"\n					page-size-change-handler=\"$ctrl.paginationDefs.paginationPageSizeChanged()\"\n					paging-options=\"$ctrl.paginationDefs.pagingOptions\"\n                    page-number-is-text-input=\"$ctrl.paginationDefs.pageNumberIsTextInput\"\n					disabled=\"$ctrl.paginationDefs.disabled()\"\n					class=\"form-inline\"\n					style=\"order: 2\">\n				</pagination-controls>\n\n				<!-- Right-Hand Checkboxes -->\n				<div ng-repeat=\"cb in $ctrl.getRightHandCheckboxes()\"\n					 class=\"flex-align-start padding-top-md\"\n					 style=\"order: {{cb.order}}\">\n					<div class=\"padding-left-sm\">\n						<input type=\"checkbox\"\n							   id=\"{{cb.id}}\"\n							   ng-model=\"cb.isChecked\"\n							   ng-change=\"cb.toggled(cb)\" />\n						<label for=\"{{cb.id}}\">{{cb.label}}</label>\n					</div>\n				</div>\n\n			</div>\n\n		</form>\n	</div>\n</div>\n");
        $templateCache.put("components/visual/translatableMetadata/translatable-metadata-template.html", "<div class=\"edit-view-container translatable-metadata-component\">\n    <div class=\"col-md-12 column\" ng-form=\"$ctrl.editorForm\">\n        <div class=\"row\">\n            <div class=\"col-md-2 prism-form-heading\">\n                {{$ctrl.formTitle}}\n            </div>\n\n            <!-- Language Selector -->\n            <div class=\"col-md-6\">\n                <label for=\"language\"\n                       class=\"col-sm-4 control-label text-align-right\">Select Language</label>\n\n                <div class=\"col-sm-8 metadata-control-col\">\n                    <dropdown-select id=\"language\"\n                                     class=\"hide-required-indicator\"\n                                     ng-model=\"$ctrl.selectedLanguage\"\n                                     required\n                                     dropup=\"true\"\n                                     prompt=\"Select Language\"\n                                     label-field=\"name\"\n                                     clearable=\"false\"\n                                     collection=\"$ctrl.languages\"\n                                     sort-collection=\"false\"\n                                     on-change=\"$ctrl.onLanguageChange()\"\n                                     btn-min-width=\"295\"\n                                     ignore-dirty>\n                    </dropdown-select>\n                </div>\n            </div>\n\n            <div class=\"col-md-3 text-align-right\">\n                <button class=\"btn btn-default prism-button\"\n                        ng-click=\"$ctrl.clearAllFields()\">\n                    Clear Language\n                </button>\n            </div>\n\n        </div>\n    </div>\n\n    <hr class=\"padding-bottom-md\"/>\n\n    <div class=\"row clearfix\">\n        <div class=\"row clearfix spacer-top-lg\">\n\n            <!-- Title -->\n            <div ng-if=\"$ctrl.isFieldEnabled(\'title\')\"\n                 class=\"col-md-12 column\">\n                <div class=\"row-no-padding\">\n                    <form role=\"form\" class=\"form-horizontal\">\n                        <div class=\"form-group\">\n                            <label class=\"control-label col-md-2\" for=\"titleInput\">\n                                {{$ctrl.getFieldTitle(\'title\')}}\n                            </label>\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <enhanced-textinput\n                                        model-prop=\"$ctrl.translation.title\"\n                                        max-chars=\"{{$ctrl.getFieldMaxChars(\'title\')}}\"\n                                        disable-prop=\"$ctrl.lockableFields.title\"\n                                        input-id=\"titleInput\">\n                                </enhanced-textinput>\n                            </div>\n                            <div ng-if=\"$ctrl.isFieldRequired(\'title\')\">\n                                <div class=\"required-text-input\"\n                                     required\n                                     x-required-indicator>\n                                </div>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </div>\n\n            <!-- Value -->\n            <div ng-if=\"$ctrl.isFieldEnabled(\'value\')\"\n                 class=\"col-md-12 column\">\n                <div class=\"row-no-padding\">\n                    <form role=\"form\" class=\"form-horizontal\">\n                        <div class=\"form-group\">\n                            <label class=\"control-label col-md-2\" for=\"valueInput\">\n                                {{$ctrl.getFieldTitle(\'value\')}}\n                            </label>\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <enhanced-textinput\n                                        model-prop=\"$ctrl.translation.value\"\n                                        max-chars=\"{{$ctrl.getFieldMaxChars(\'value\')}}\"\n                                        disable-prop=\"$ctrl.lockableFields.value\"\n                                        input-id=\"valueInput\">\n                                </enhanced-textinput>\n                            </div>\n                            <div ng-if=\"$ctrl.isFieldRequired(\'value\')\">\n                                <div class=\"required-text-input\"\n                                     required\n                                     x-required-indicator>\n                                </div>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </div>\n\n            <!-- Short Description -->\n            <div ng-if=\"$ctrl.isFieldEnabled(\'shortDescription\')\"\n                 class=\"col-md-12 column\">\n                <div class=\"row-no-padding\">\n                    <form role=\"form\" class=\"form-horizontal\">\n                        <div class=\"form-group\">\n                            <label class=\"control-label col-md-2\" for=\"shortDescriptionInput\">\n                                {{$ctrl.getFieldTitle(\'shortDescription\')}}\n                            </label>\n                            <div class=\"col-sm-9 pad-text-input-col\">\n                                <enhanced-textarea\n                                        input-id=\"shortDescriptionInput\"\n                                        max-chars=\"{{$ctrl.getFieldMaxChars(\'shortDescription\')}}\"\n                                        input-rows=\"3\"\n                                        ng-model=\"$ctrl.translation.shortDescription\">\n                                </enhanced-textarea>\n                            </div>\n                            <div ng-if=\"$ctrl.isFieldRequired(\'shortDescription\')\">\n                                <div class=\"required-text-area-3\"\n                                     required\n                                     x-required-indicator>\n                                </div>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </div>\n\n            <!-- Long Description -->\n            <div ng-if=\"$ctrl.isFieldEnabled(\'longDescription\')\"\n                 class=\"col-md-12 column\">\n                <div class=\"row-no-padding\">\n                    <form role=\"form\" class=\"form-horizontal\">\n                        <div class=\"form-group\">\n                            <label class=\"control-label col-md-2\" for=\"longDescriptionInput\">\n                                {{$ctrl.getFieldTitle(\'longDescription\')}}\n                            </label>\n                            <div class=\"col-sm-9 pad-text-input-col\">\n                                <enhanced-textarea\n                                        input-id=\"longDescriptionInput\"\n                                        max-chars=\"{{$ctrl.getFieldMaxChars(\'longDescription\')}}\"\n                                        input-rows=\"6\"\n                                        ng-model=\"$ctrl.translation.longDescription\">\n                                </enhanced-textarea>\n                            </div>\n                            <div ng-if=\"$ctrl.isFieldRequired(\'longDescription\')\">\n                                <div class=\"required-text-area-6\"\n                                     required\n                                     x-required-indicator>\n                                </div>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </div>\n\n            <!-- Keywords -->\n            <div ng-if=\"$ctrl.isFieldEnabled(\'keywords\')\"\n                 class=\"col-md-12 column\">\n                <div class=\"row-no-padding\">\n                    <form role=\"form\" class=\"form-horizontal\">\n                        <div class=\"form-group\">\n                            <label class=\"control-label col-md-2\" for=\"keywordsInput\">\n                                {{$ctrl.getFieldTitle(\'keywords\')}}\n                            </label>\n                            <div class=\"col-sm-9 pad-text-input-col\">\n                                <enhanced-textarea\n                                        input-id=\"keywordsInput\"\n                                        max-chars=\"{{$ctrl.getFieldMaxChars(\'keywords\')}}\"\n                                        input-rows=\"3\"\n                                        ng-model=\"$ctrl.translation.keywords\">\n                                </enhanced-textarea>\n                            </div>\n                            <div ng-if=\"$ctrl.isFieldRequired(\'keywords\')\">\n                                <div class=\"required-text-input\"\n                                     required\n                                     x-required-indicator>\n                                </div>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </div>\n\n        </div>\n    </div>\n\n</div>\n\n");
        $templateCache.put("components/visual/weekdaySelector/weekday-selector-component-template.html", "<div class=\"row clearfix\">\n	<div class=\"col-md-12\">\n		<form class=\"form-horizontal\" role=\"form\">\n			<div class=\"form-group\">\n				<div>\n					<div id=\"weekdaySelectorGrid\"\n						 ui-grid=\"$ctrl.gridOptions\"\n						 class=\"weekly-schedule-grid\"\n						 ng-class=\"{\'protected-grid\': $ctrl.disabled}\"\n						 ui-grid-selection\n						 ui-grid-auto-resize>\n					</div>\n				</div>\n			</div>\n		</form>\n	</div>\n</div>\n");
        $templateCache.put("dashboard/calendars/base/calendar-template.html", "<div class=\"row-no-padding\">\n	<div class=\"col-md-12 col-lg-12\">\n		<div ui-grid=\"$ctrl.currentGridOptions\" class=\"cal-grid\" ui-grid-selection ui-grid-auto-resize\n			 id=\"{{$ctrl.calName + \'CalGrid\'}}\"></div>\n	</div>\n</div>\n");
        $templateCache.put("dashboard/calendars/searchView/calendars-view-template.html", "<div class=\"loadingIndicator\">\n	<div data-lb-progress=\"calCtrl.loadingIndicator\" ng-show=\"calCtrl.loadingIndicator.show\"></div>\n</div>\n<div class=\"container-fluid no-padding\">\n	<div class=\"row-no-padding\">\n		<navbar></navbar>\n	</div>\n	<div class=\"row-no-padding\">\n		<sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n		<div class=\"col-md-10 col-lg-10 content-pane\">\n			<div class=\"row-no-padding\">\n				<breadcrumb tab-name=\"calCtrl.breadCrumb\"></breadcrumb>\n				<uib-tabset horizontal=\"true\" type=\"pills\" class=\"edit-view-tabbar\" active=\"calCtrl.currentTab\">\n					<uib-tab heading=\"Partner SLA\" select=\"calCtrl.activateTab(\'dueDate\')\" index=\"\'dueDate\'\" ng-show=\"true\">\n						<calendar ng-if=\"calCtrl.activeTabs.dueDate\" column-defs=\"calCtrl.activeColumnDefs\" grid-data=\"calCtrl.activeData\" allow-row-click=\"true\" cal-name=\"dueDate\"></calendar>\n					</uib-tab>\n					<uib-tab heading=\"Original Release Date\" select=\"calCtrl.activateTab(\'ord\')\" index=\"\'ord\'\" ng-show=\"true\">\n						<calendar ng-if=\"calCtrl.activeTabs.ord\" column-defs=\"calCtrl.activeColumnDefs\" grid-data=\"calCtrl.activeData\" allow-row-click=\"true\" cal-name=\"ord\"></calendar>\n					</uib-tab>\n					<uib-tab heading=\"First Launch\" select=\"calCtrl.activateTab(\'firstLaunch\')\" index=\"\'firstLaunch\'\" ng-show=\"true\">\n						<calendar ng-if=\"calCtrl.activeTabs.firstLaunch\" column-defs=\"calCtrl.activeColumnDefs\" grid-data=\"calCtrl.activeData\" allow-row-click=\"true\" cal-name=\"firstLaunch\"></calendar>\n					</uib-tab>\n					<uib-tab heading=\"LIVE Schedules\" select=\"calCtrl.activateTab(\'liveRecordings\')\" index=\"\'liveRecordings\'\" ng-show=\"calCtrl.canReadLiveRecordings\">\n						<calendar ng-if=\"calCtrl.activeTabs.liveRecordings\" column-defs=\"calCtrl.activeColumnDefs\" grid-data=\"calCtrl.activeData\" allow-row-click=\"false\" cal-name=\"liveRecordings\"></calendar>\n					</uib-tab>\n					<div class=\"pull-right\" ng-show=\"calCtrl.activeTabs.liveRecordings\">\n						<button class=\"prism-button btn btn-default cal-zoom-btn\" ng-click=\"calCtrl.zoom(60)\" ng-disabled=\"calCtrl.disableZoomIn()\">+</button>\n						<button class=\"prism-button btn btn-default cal-zoom-btn\" ng-click=\"calCtrl.zoom(-60)\" ng-disabled=\"calCtrl.disableZoomOut()\">-</button>\n					</div>\n				</uib-tabset>\n			</div>\n\n			<div class=\"row-no-padding manager-toolbar\">\n				<form class=\"form-inline toolbar-top-padding-sm\" name=\"calendarsToolbar\">\n					<div class=\"form-group\">\n						<div class=\"col-md-6\" ng-show=\"!calCtrl.showTodayOnly\">\n							<a class=\"toolbar-button\"\n							   role=\"button\"\n							   id=\"todayToolbarButton\"\n							   ng-click=\"calCtrl.todayClicked()\"\n							   ng-disabled=\"false\">\n								<i class=\"fa fa-calendar\"></i><br>Today\n							</a>\n						</div>\n						<div class=\"col-md-6\" ng-show=\"calCtrl.showTodayOnly\">\n							<a class=\"toolbar-button\"\n							   role=\"button\"\n							   id=\"showAllToolbarButton\"\n							   ng-click=\"calCtrl.showAllClicked()\">\n								<i class=\"fa fa-reply-all\"></i><br>All\n							</a>\n						</div>\n					</div>\n					<div class=\"form-group pull-right spacer-top-xsm\" ng-show=\"calCtrl.currentTab !== \'liveRecordings\'\">\n						<div class=\"col-md-6\">\n							<div>\n								<input id=\"showDeliveredCB\" type=\"checkbox\"\n									   ng-change=\"calCtrl.executeQuery(calCtrl.currentTab, true)\"\n									   ng-model=\"calCtrl.includeDelivered\">\n								<label for=\"showDeliveredCB\">Show Delivered</label>\n							</div>\n						</div>\n					</div>\n				</form>\n			</div>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("dashboard/metrics/dashboard-panels/dashboard-panel-template.html", "<div class=\"dashboard-panel\"\n     ng-if=\"$ctrl.getPanelData() || $ctrl.panelTemplateUrl\">\n\n    <!-- Header -->\n    <div class=\"dashboard-panel-header\"\n         ng-style=\"{\'font-size\': $ctrl.headerTextSize, \'background-color\': $ctrl.headerBGColor};\">\n        <span class=\"flex-align-center\">\n            {{$ctrl.headerLabel || \'&nbsp;\'}}\n        </span>\n    </div>\n\n    <!-- Body (if template URL is included) -->\n    <div class=\"dashboard-panel-body flex-col-container\"\n         ng-if=\"$ctrl.panelTemplateUrl\">\n        <div class=\"flex-stretcher flex-col-container\"\n             ng-include=\"$ctrl.panelTemplateUrl\">\n        </div>\n    </div>\n\n    <!-- Body (no template; simple text value) -->\n    <div class=\"dashboard-panel-body flex-col-container\"\n         ng-if=\"!$ctrl.panelTemplateUrl\"\n         ng-style=\"{\'font-size\': $ctrl.panelTextSize}\">\n        <span class=\"flex-align-center\">\n            {{$ctrl.getPanelData() || \'&nbsp;\'}}\n        </span>\n    </div>\n\n</div>\n");
        $templateCache.put("dashboard/metrics/metrics-filter-modal/metrics-filter-modal-template.html", "<div class=\"modal-header\">\n    <a id=\"metricsFilterModalXBtn\"\n       href=\"\"\n       ng-click=\"$ctrl.dismiss({$value: \'cancel\'})\">\n        <i class=\"fa fa-times pull-right\"></i>\n    </a>\n    <span class=\"modal-title\">Metrics Dashboard Criteria</span>\n</div>\n\n<div class=\"modal-body\">\n\n    <form class=\"form-horizontal\"\n          role=\"form\">\n\n        <div class=\"edit-view-container\">\n            <div class=\"row\">\n                <div class=\"col-md-12\">\n                    <div class=\"prism-form-heading\">Date Range</div>\n                </div>\n            </div>\n\n            <br />\n\n            <!-- From Date -->\n            <div class=\"form-group\">\n                <label class=\"col-sm-4 control-label lg-txt\">\n                    From\n                </label>\n                <div class=\"col-sm-8 padding-top-xs\">\n                    <dropdown\n                        btn-min-width=\"150\"\n                        collection=\"$ctrl.months\"\n                        id=\"fromDateMonthDropDown\"\n                        ng-model=\"$ctrl.fromDateMonth\"\n                        ng-model-options=\"{ getterSetter: true }\">\n                    </dropdown>\n                    <dropdown\n                        collection=\"$ctrl.years\"\n                        id=\"fromDateYearDropDown\"\n                        ng-model=\"$ctrl.fromDateYear\"\n                        ng-model-options=\"{ getterSetter: true }\">\n                    </dropdown>\n                </div>\n            </div>\n\n            <!-- To Date -->\n            <div class=\"form-group\">\n                <label for=\"toDateMonthDropdown\"\n                       class=\"col-sm-4 control-label lg-txt\">\n                    To\n                </label>\n                <div class=\"col-sm-8 padding-top-md\">\n                    <dropdown\n                        btn-min-width=\"150\"\n                        collection=\"$ctrl.months\"\n                        id=\"toDateMonthDropDown\"\n                        ng-model=\"$ctrl.toDateMonth\"\n                        ng-model-options=\"{ getterSetter: true }\">\n                    </dropdown>\n                    <dropdown\n                        collection=\"$ctrl.years\"\n                        id=\"toDateYearDropDown\"\n                        ng-model=\"$ctrl.toDateYear\"\n                        ng-model-options=\"{ getterSetter: true }\">\n                    </dropdown>\n                    <br/>\n                    <span class=\"criteria-error padding-left-md\"\n                          ng-show=\"$ctrl.dateRangeIsInvalid()\">\n                        invalid date range\n                    </span>\n\n                </div>\n            </div>\n        </div>\n\n        <hr />\n\n        <!-- Partner Types -->\n        <div class=\"edit-view-container\">\n            <div class=\"row\">\n                <div class=\"col-md-12\">\n                    <div class=\"prism-form-heading\">Partner Type(s)</div>\n                </div>\n            </div>\n\n            <br />\n\n            <div class=\"form-group\">\n                <label for=\"partnerDropdown\"\n                       class=\"col-sm-4 control-label lg-txt\">\n                    Partner Type(s)\n                </label>\n                <div class=\"col-sm-8 padding-top-md\">\n                    <dropdown\n                        is-multi-select=\"true\"\n                        attach-to-body=\"true\"\n                        btn-min-width=\"300\"\n                        clearable=\"true\"\n                        collection=\"$ctrl.availablePartnerTypes\"\n                        enable-select-all=\"true\"\n                        id=\"partnerTypesDropdown\"\n                        max-height=\"250\"\n                        ng-model=\"$ctrl.currentCriteria.partnerTypes\"\n                        ng-change=\"$ctrl.onPartnerTypeSelectionsChanged()\"\n                        prompt=\"Select Partner Type(s)\">\n                    </dropdown>\n                </div>\n            </div>\n        </div>\n\n        <hr />\n\n        <!-- Partner -->\n        <div class=\"edit-view-container\">\n            <div class=\"row\">\n                <div class=\"col-md-12\">\n                    <div class=\"prism-form-heading\">Partner(s)</div>\n                </div>\n            </div>\n\n            <br />\n\n            <div class=\"form-group\">\n                <label for=\"partnerDropdown\"\n                       class=\"col-sm-4 control-label lg-txt\">\n                    Partner(s)\n                </label>\n                <div class=\"col-sm-8 padding-top-md\">\n                    <dropdown\n                        is-multi-select=\"true\"\n                        attach-to-body=\"true\"\n                        btn-min-width=\"300\"\n                        clearable=\"true\"\n                        collection=\"$ctrl.getAvailablePartners()\"\n                        enable-select-all=\"true\"\n                        id=\"partnerDropdown\"\n                        label-path=\"name\"\n                        max-height=\"250\"\n                        ng-model=\"$ctrl.currentCriteria.partners\"\n                        prompt=\"{{$ctrl.partnerDropdownLabel}}\">\n                    </dropdown>\n\n                </div>\n            </div>\n        </div>\n\n    </form>\n\n</div>\n\n<div class=\"modal-footer\">\n    <div class=\"row\">\n        <div class=\"col-sm-12\">\n            <div class=\"form-inline\">\n                <div class=\"form-group padding-left-md\">\n                    <button class=\"btn btn-sm btn-default\"\n                            id=\"cancelButton\"\n                            ng-click=\"$ctrl.onAcceptCriteria($event, true)\">\n                        Reset to Defaults\n                    </button>\n                    <button class=\"btn btn-sm btn-default\"\n                            id=\"addButton\"\n                            ng-disabled=\"!$ctrl.applyButtonEnabled()\"\n                            ng-click=\"$ctrl.onAcceptCriteria($event, false)\">\n                        Apply\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("dashboard/metrics/renderers/metrics-dashboard-content-renderer-template.html", "<!--\n - Filename: metrics-dashboard-content-renderer-template.html\n -\n - Created by randysorensen on 2019-03-27.\n -->\n\n<!-- Center column - graphs & widgets -->\n<div class=\"flex-align-start flex-stretcher metrics-display height-100\"\n     ng-show=\"!$ctrl.loadingIndicator.show\">\n\n    <!-- Row 0: Partner Type Distribution -->\n    <div class=\"flex-row-container\">\n\n        <!-- Prism Temporary Logo -->\n        <img class=\"padding-left-md padding-right-md\"\n             ng-if=\"$ctrl.chromeless\"\n             src=\"assets/images/prismTempLogo.png\"\n             height=\"80\"/>\n\n        <!-- Partner Distribution Panel -->\n        <partner-distribution-dashboard-panel\n            class=\"partner-type-distribution full-width\">\n        </partner-distribution-dashboard-panel>\n\n        <!-- Reach Engine Logo -->\n        <a href=\"/login\"\n           ng-if=\"$ctrl.chromeless\">\n            <img src=\"assets/images/reachengineLogo.png\"\n                 height=\"80\"/>\n        </a>\n    </div>\n\n    <!-- Rows 1~N: Panel Metric Rows -->\n    <metric-panel-row\n        class=\"flex-stretcher\"\n        current-month-data-property=\"$ctrl.panelRows[$index].currentMonthDataProperty\"\n        monthly-dataset-property=\"$ctrl.panelRows[$index].monthlyDatasetProperty\"\n        ng-repeat=\"row in $ctrl.panelRows track by $index\"\n        sum-label=\"$ctrl.panelRows[$index].sumLabel\"\n        sum-data-property=\"$ctrl.panelRows[$index].sumDataProperty\">\n    </metric-panel-row>\n\n</div>\n");
        $templateCache.put("dashboard/queues/groupSummary/queues-group-summary-view-template.html", "<div class=\"container-fluid no-padding\">\n	<div class=\"row-no-padding\">\n		<navbar></navbar>\n	</div>\n	<div class=\"row-no-padding\">\n\n		<sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n		<div class=\"loadingIndicator\">\n			<div data-lb-progress=\"queueGroupSummaryCtrlr.loadingIndicator\"\n				 ng-show=\"queueGroupSummaryCtrlr.loadingIndicator.show\">\n			</div>\n		</div>\n\n		<div class=\"col-md-10 col-lg-10 content-pane\">\n			<breadcrumb tab-name=\"queueGroupSummaryCtrlr.tabName\"></breadcrumb>\n\n			<div class=\"spacer-top-md report-view\">\n				<!-- group chart panel -->\n				<div class=\"col-md-4\">\n					<react-component name=\"ReactChartPanel\" class=\"queue-panel\" props=\"queueGroupSummaryCtrlr.groupProps\"></react-component>\n				</div>\n\n				<!-- group queue status pill list -->\n				<div class=\"col-md-8\">\n					<div class=\"queue-status-pill-list panel panel-default\">\n						<div class=\"panel-heading\">\n							<h3 class=\"default-header-class panel-title\">\n								<!-- TODO - custom tailored name -->\n								{{queueGroupSummaryCtrlr.groupLabel}} Queues\n							</h3>\n						</div>\n						<div class=\"panel-body\" ng-repeat=\"queue in queueGroupSummaryCtrlr.groupProps.chartData.subSeries\">\n							<div class=\"row\">\n								<div class=\"col-sm-2\"></div>\n								<div class=\"col-sm-7 queue-name\" ng-class=\"queue.bandwidthWarningFlag ? \'yellow-label\' : \'\'\">{{queue.header + \' \'}}<span ng-class=\"queue.bandwidthWarningFlag ? \'fa fa-exclamation-triangle\': \'\'\"></span></div>\n								<div class=\"col-sm-1 text-align-right\"\n									 ng-click=\"queueGroupSummaryCtrlr.openQueueLimitersListModal(queue.id)\">\n									<i class=\"fa fa-wrench\" aria-hidden=\"true\"></i>\n								</div>\n								<div class=\"col-sm-2\"></div>\n							</div>\n							<div class=\"row\">\n								<div class=\"col-sm-2 queue-total\">{{queue.total}}</div>\n								<chart-pill class=\"col-lg-8\" chartdata=\"queue\" status-change=\"queueGroupSummaryCtrlr.openQueueDetailView(queue, queueGroupSummaryCtrlr.getSelectedStatusForDetailGrid(status))\"></chart-pill>\n								<div class=\"col-sm-2 queue-bandwidth\">{{(queue.totalBandwidth > 0) ? queue.totalBandwidth + queue.unit : \'\'}}</div>\n							</div>\n						</div>\n					</div>\n				</div>\n			</div>\n\n			<div class=\"row-no-padding manager-toolbar\">\n				<div class=\"col-md-12 col-lg-12\">\n					<form class=\"form-inline toolbar-top-padding-md\">\n						<div class=\"form-group pull-right\">\n							<div class=\"col-md-12\">\n								<input id=\"queueShowFinishedCB\" type=\"checkbox\"\n									   ng-change=\"queueGroupSummaryCtrlr.reloadQueuesFromShowFinishedChange()\"\n									   ng-model=\"queueGroupSummaryCtrlr.showFinished\">\n								<label for=\"queueShowFinishedCB\">Show Finished</label>\n							</div>\n						</div>\n					</form>\n				</div>\n			</div>\n\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("dashboard/queues/queueDetail/queue-detail-view-template.html", "<div class=\"container-fluid no-padding\">\n	<div class=\"loadingIndicator\">\n		<div data-lb-progress=\"$ctrl.loadingIndicator\"\n			 ng-show=\"$ctrl.loadingIndicator.show\"></div>\n	</div>\n	<div class=\"row-no-padding\">\n		<navbar></navbar>\n	</div>\n	<div class=\"row-no-padding\">\n\n		<sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n		<div class=\"col-md-10 col-lg-10 content-pane\">\n			<div class=\"row-no-padding\">\n				<breadcrumb tab-name=\"$ctrl.breadcrumbTabName\"></breadcrumb>\n				<uib-tabset horizontal=\"true\" type=\"pills\" class=\"edit-view-tabbar\" active=\"$ctrl.currentTab\">\n					<uib-tab heading=\"Active/Queued\" index=\"\'active\'\"\n							 select=\"$ctrl.activateTab(\'active\')\">\n						<queue-detail-grid ng-if=\"$ctrl.currentTab === \'active\'\"\n                                           can-open-video-model=\"$ctrl.canOpenVideoModel(media)\"\n                                           can-edit-priority=\"$ctrl.canEditPriority(queueStep)\"\n                                           on-step-priorities-changed=\"$ctrl.onStepPrioritiesChanged(modifiedQueueSteps)\"\n                                           excluded-columns=\"$ctrl.excludedColumns\"\n                                           paging-options=\"$ctrl.pagingOptions\"\n                                           queue-steps=\"$ctrl.queueSteps\"\n                                           status-name=\"active\"></queue-detail-grid>\n					</uib-tab>\n					<uib-tab heading=\"Paused\" index=\"\'paused\'\"\n							 select=\"$ctrl.activateTab(\'paused\')\">\n						<queue-detail-grid ng-if=\"$ctrl.currentTab === \'paused\'\"\n                                           can-open-video-model=\"$ctrl.canOpenVideoModel(media)\"\n                                           can-edit-priority=\"$ctrl.canEditPriority(queueStep)\"\n                                           on-step-priorities-changed=\"$ctrl.onStepPrioritiesChanged(modifiedQueueSteps)\"\n                                           excluded-columns=\"$ctrl.excludedColumns\"\n                                           paging-options=\"$ctrl.pagingOptions\"\n                                           queue-steps=\"$ctrl.queueSteps\"\n                                           status-name=\"paused\"></queue-detail-grid>\n					</uib-tab>\n					<uib-tab heading=\"Stalled\" index=\"\'stalled\'\"\n							 select=\"$ctrl.activateTab(\'stalled\')\">\n						<queue-detail-grid ng-if=\"$ctrl.currentTab === \'stalled\'\"\n                                           can-open-video-model=\"$ctrl.canOpenVideoModel(media)\"\n                                           can-edit-priority=\"$ctrl.canEditPriority(queueStep)\"\n                                           on-step-priorities-changed=\"$ctrl.onStepPrioritiesChanged(modifiedQueueSteps)\"\n                                           excluded-columns=\"$ctrl.excludedColumns\"\n                                           paging-options=\"$ctrl.pagingOptions\"\n                                           queue-steps=\"$ctrl.queueSteps\"\n                                           status-name=\"stalled\"></queue-detail-grid>\n					</uib-tab>\n					<uib-tab heading=\"Finished\" index=\"\'finished\'\"\n							 select=\"$ctrl.activateTab(\'finished\')\">\n						<queue-detail-grid ng-if=\"$ctrl.currentTab === \'finished\'\"\n                                           can-open-video-model=\"$ctrl.canOpenVideoModel(media)\"\n                                           can-edit-priority=\"$ctrl.canEditPriority(queueStep)\"\n                                           on-step-priorities-changed=\"$ctrl.onStepPrioritiesChanged(modifiedQueueSteps)\"\n                                           excluded-columns=\"$ctrl.excludedColumns\"\n                                           paging-options=\"$ctrl.pagingOptions\"\n                                           queue-steps=\"$ctrl.queueSteps\"\n                                           status-name=\"finished\"></queue-detail-grid>\n					</uib-tab>\n				</uib-tabset>\n			</div>\n			<div class=\"row-no-padding manager-toolbar\">\n				<div class=\"col-md-12 col-lg-12\">\n					<form class=\"form-inline toolbar-top-padding-sm\">\n						<div class=\"form-group pull-right\">\n							<pagination-controls prev-page-handler=\"$ctrl.paginationPrevPageHandler()\"\n												 next-page-handler=\"$ctrl.paginationNextPageHandler()\"\n												 jump-to-page-handler=\"$ctrl.paginationJumpToPageHandler()\"\n												 page-size-change-handler=\"$ctrl.paginationPageSizeChanged()\"\n												 paging-options=\"$ctrl.pagingOptions\"\n												 class=\"form-group\">\n							</pagination-controls>\n						</div>\n					</form>\n				</div>\n			</div>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("dashboard/queues/summary/queues-summary-view-template.html", "<div class=\"loadingIndicator\">\n	<div data-lb-progress=\"$ctrl.loadingIndicator\"\n		 ng-show=\"$ctrl.loadingIndicator.show\"></div>\n</div>\n<div class=\"row-no-padding\">\n</div>\n<div class=\"row report-view\">\n	<div class=\"col-md-12 padding-top-sm\">\n		<div class=\"row\">\n			<div class=\"col-md-6\">\n				<react-component name=\"ReactChartPanel\" class=\"queue-panel\" props=\"$ctrl.transcodesProps\" ng-click=\"$ctrl.openQueueGroupSummaryView(\'transcodes\')\"></react-component>\n			</div>\n			<div class=\"col-md-6\">\n				<react-component name=\"ReactChartPanel\" class=\"queue-panel\" props=\"$ctrl.deliveriesProps\" ng-click=\"$ctrl.openQueueGroupSummaryView(\'deliveries\')\"></react-component>\n			</div>\n		</div>\n		<div class=\"row\">\n			<div class=\"col-md-6\">\n				<react-component name=\"ReactChartPanel\" class=\"queue-panel bottom-row-panel\" props=\"$ctrl.restoresProps\" ng-click=\"$ctrl.openQueueGroupSummaryView(\'restores\')\"></react-component>\n			</div>\n			<div class=\"col-md-6\">\n				<react-component name=\"ReactChartPanel\" class=\"queue-panel bottom-row-panel\" props=\"$ctrl.fileCopyProps\" ng-click=\"$ctrl.openQueueGroupSummaryView(\'fileCopy\')\"></react-component>\n			</div>\n		</div>\n	</div>\n\n</div>\n\n\n<div class=\"row-no-padding manager-toolbar\">\n	<div class=\"col-md-12 col-lg-12\">\n		<form class=\"form-inline toolbar-top-padding-md\">\n			<div class=\"form-group pull-right\">\n				<div class=\"col-md-12\">\n					<input id=\"queueShowFinishedCB\" type=\"checkbox\" ng-change=\"$ctrl.reloadQueuesFromShowFinishedChange()\"\n						   ng-model=\"$ctrl.showFinished\">\n					<label for=\"queueShowFinishedCB\">Show Finished</label>\n				</div>\n			</div>\n		</form>\n	</div>\n</div>\n");
        $templateCache.put("dashboard/reports/renderers/distribution-report-template.html", "<div class=\"row\">\n	<div class=\"col-md-3\">\n		<div class=\"prism-form-heading\">Report Criteria</div>\n	</div>\n</div>\n<div class=\"row spacer-top-lg\">\n	<div class=\"col-md-12\">\n		<form class=\"form-horizontal\">\n			<div class=\"form-group\">\n				<label class=\"col-md-3 prism-form-item-label text-align-right\">Partners</label>\n				<div class=\"col-md-6\">\n					<multiselect-dropdown ng-model=\"$ctrl.selectedPartners\"\n										  collection=\"$ctrl.partners\"\n										  btn-min-width=\"300\" btn-max-width=\"325\" label-field=\"name\" enable-select-all=\"true\"></multiselect-dropdown>\n				</div>\n				<div class=\"col-md-1 no-left-padding\">\n					<input type=\"checkbox\" id=\"includeHiddenPartnersCB\" ng-change=\"$ctrl.updatePartnerList()\"\n						   ng-model=\"$ctrl.includeHiddenPartners\"/>\n					<label for=\"includeHiddenPartnersCB\">Show Hidden</label>\n				</div>\n			</div>\n		</form>\n	</div>\n</div>\n");
        $templateCache.put("dashboard/reports/renderers/partner-delivery-report-template.html", "<div class=\"row\">\n	<div class=\"col-md-3\">\n		<div class=\"prism-form-heading\">Report Criteria</div>\n	</div>\n</div>\n<div class=\"row spacer-top-lg\">\n	<div class=\"col-md-12\">\n		<form class=\"form-horizontal\">\n			<div class=\"form-group\">\n				<label class=\"col-md-3 prism-form-item-label text-align-right\">Date Range</label>\n				<div class=\"col-md-3 no-right-padding\">\n					<date-picker ng-model=\"$ctrl.reportStartDate\"></date-picker>\n				</div>\n				<label class=\"col-md-1 prism-form-item-label text-align-center\">to</label>\n				<div class=\"col-md-3 no-left-padding\">\n					<date-picker ng-model=\"$ctrl.reportEndDate\"></date-picker>\n				</div>\n			</div>\n			<div class=\"form-group\">\n				<label class=\"col-md-3 prism-form-item-label text-align-right\">Partners</label>\n				<div class=\"col-md-6\">\n					<div ng-if=\"$ctrl.selectedReport.generatorName === \'BasicDeliveryReport\'\">\n						<multiselect-dropdown ng-model=\"$ctrl.selectedPartners\"\n											  collection=\"$ctrl.partners\"\n											  btn-min-width=\"300\"\n											  btn-max-width=\"325\"\n											  label-field=\"name\"\n											  enable-select-all=\"true\"\n                                              prompt=\"Select Partner\"\n                                              collection-filter=\"{numberOfChildren: \'0\'}\">\n						</multiselect-dropdown>\n					</div>\n					<div ng-if=\"$ctrl.selectedReport.generatorName === \'SLADeliveryReport\'\">\n						<multiselect-dropdown ng-model=\"$ctrl.selectedPartners\"\n											  collection=\"$ctrl.partners\"\n											  btn-min-width=\"300\"\n											  btn-max-width=\"325\"\n											  label-field=\"name\"\n											  enable-select-all=\"true\"\n                                              prompt=\"Select SLA Partner\"\n                                              collection-filter=\"{numberOfChildren: \'0\'}\">\n						</multiselect-dropdown>\n					</div>\n					<div ng-if=\"$ctrl.selectedReport.generatorName === \'PartnerDeliveryReport\'\">\n						<dropdown-select ng-model=\"$ctrl.selectedPartners\"\n										 collection=\"$ctrl.partners\"\n										 btn-min-width=\"300\"\n										 btn-max-width=\"325\"\n										 label-field=\"name\"\n										 prompt=\"Select Partner\"\n                                         collection-filter=\"{numberOfChildren: \'0\'}\">\n						</dropdown-select>\n					</div>\n					<div ng-if=\"$ctrl.selectedReport.generatorName === \'PartnerPlannerReport\'\">\n						<dropdown-select ng-model=\"$ctrl.selectedPartners\"\n										 collection=\"$ctrl.partners\"\n										 btn-min-width=\"300\"\n										 btn-max-width=\"325\"\n										 label-field=\"name\"\n										 enable-select-all=\"true\"\n										 prompt=\"Select Partner\"\n										 collection-filter=\"{numberOfChildren: \'0\'}\">\n						</dropdown-select>\n					</div>\n				</div>\n				<div class=\"col-md-1 no-left-padding\">\n					<input type=\"checkbox\"\n						   id=\"includeHiddenPartnersCB\"\n						   ng-change=\"$ctrl.updatePartnerList()\"\n						   ng-model=\"$ctrl.includeHiddenPartners\"/>\n					<label for=\"includeHiddenPartnersCB\">Show Hidden</label>\n				</div>\n			</div>\n		</form>\n	</div>\n</div>\n\n");
        $templateCache.put("dashboard/workflows/gridTemplates/delivery-progress-template.html", "<div class=\"ui-grid-cell-contents progress-container ng-scope ng-binding\" data-tooltip-append-to-body=\"true\" ng-if=\"COL_FIELD\"\n	 uib-tooltip=\"{{COL_FIELD}}\">\n	<uib-progress class=\"prism-progress pull-left\" max=\"COL_FIELD.split(\'/\')[1]\">\n		<uib-bar class=\"prism-progressbar\" value=\"COL_FIELD.split(\'/\')[0]\"></uib-bar>\n	</uib-progress>\n	<span class=\"prism-progress-pct-label\">\n		({{COL_FIELD}})\n	</span>\n</div>\n");
        $templateCache.put("dashboard/workflows/gridTemplates/header-check-mark-template.html", "<div class=\"ui-grid-cell-contents\" col-index=\"renderIndex\" ng-click=\"grid.appScope.$ctrl.toggleRows($event, grid.api)\">\n	<input type=\"checkbox\" ng-checked=\"grid.selection.selectAll\"/>\n	<label></label>\n</div>\n");
        $templateCache.put("dashboard/workflows/gridTemplates/index-column-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\" data-tooltip-append-to-body=\"true\" uib-tooltip=\"{{row.entity.name}}\">\n    <span>\n        {{grid.renderContainers.body.visibleRowCache.indexOf(row) + 1 +\n        grid.appScope.$ctrl.pagingOptions.pageSize * (grid.appScope.$ctrl.pagingOptions.currentPage - 1)}}\n    </span>\n</div>\n");
        $templateCache.put("dashboard/workflows/gridTemplates/package-link-icons-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding workflow-package-icon-column\" data-tooltip-append-to-body=\"true\"\n	 ng-if=\"row.entity.packageId && row.entity.$$treeLevel === 0\n	    || (row.entity.packageId && row.entity.$$treeLevel > 0 && row.entity.packageIdList && row.entity.packageIdList.length === 1)\">\n	<span>\n        <package-link-icon\n                package-id=\"row.entity.packageId\"\n                package-id-list=\"row.entity.packageIdList\"\n                on-navigation-started=\"grid.appScope.$ctrl.onPackageNavigationStarted()\"\n                on-navigation-ended=\"grid.appScope.$ctrl.onPackageNavigationEnded()\"\n        ></package-link-icon>\n		<i\n                class=\"fa fa-filter\"\n                ng-click=\"grid.appScope.$ctrl.filterByPackageId(row.entity)\"\n                ng-if=\"row.entity.packageIdList && row.entity.packageIdList.length === 1\">\n        </i>\n	</span>\n</div>\n");
        $templateCache.put("dashboard/workflows/gridTemplates/package-status-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding text-center\" data-tooltip-append-to-body=\"true\"\n	 uib-tooltip=\"{{grid.appScope.$ctrl.getWorkflowStatusColumnTooltip(row.entity)}}\">\n	<span>{{grid.appScope.$ctrl.getWorkflowStatusColumnText(row.entity)}}</span>\n</div>\n");
        $templateCache.put("dashboard/workflows/gridTemplates/status-template.html", "<div class=\"ui-grid-cell-contents workflow-status-icon\">\n	<div ng-class=\"{\'current-status\': !!row.entity.pendingStatus}\" data-ng-switch=\"row.entity.status\">\n		<span class=\"fa-stack executing-status\" data-ng-switch-when=\"EXECUTING\">\n			<i class=\"fa fa-circle-thin fa-stack-1x\" aria-hidden=\"true\"></i>\n			<i class=\"fa fa-refresh fa-spin fa-stack-1x fa-fw\"></i>\n		</span>\n		<span class=\"fa-stack pending-delivery-status\" data-ng-switch-when=\"\">\n			<i class=\"fa fa-square fa-stack-1x\"></i>\n			<i class=\"fa fa-exclamation-triangle fa-stack-2x\"></i>\n		</span>\n		<span class=\"fa-stack pending-approval-status\" data-ng-switch-when=\"\">\n			<i class=\"fa fa-square fa-stack-1x\"></i>\n			<i class=\"fa fa-exclamation-triangle fa-stack-2x\"></i>\n		</span>\n		<span class=\"fa-stack stalled-status\" data-ng-switch-when=\"STALLED\">\n			<i class=\"fa fa-square fa-stack-1x\"></i>\n			<i class=\"fa fa-exclamation-triangle fa-stack-2x\"></i>\n		</span>\n		<span class=\"failed-status\" data-ng-switch-when=\"FAILED\">\n			<i class=\"fa fa-times\"></i>\n		</span>\n		<span class=\"fa-stack completed-status\" data-ng-switch-when=\"COMPLETED\">\n			<i class=\"fa fa-circle-thin fa-stack-1x\" aria-hidden=\"true\"></i>\n			<i class=\"fa fa-check fa-stack-1x\"></i>\n		</span>\n		<span class=\"fa-stack paused-status\" data-ng-switch-when=\"PAUSED\">\n			<i class=\"fa fa-circle-thin fa-stack-1x\" aria-hidden=\"true\"></i>\n			<i class=\"fa fa-pause fa-stack-1x\" aria-hidden=\"true\"></i>\n		</span>\n		<span class=\"fa-stack abandoned-status\" data-ng-switch-when=\"ABANDONED\">\n			<i class=\"fa fa-circle-thin fa-stack-1x\" aria-hidden=\"true\"></i>\n			<i class=\"fa fa-life-ring fa-stack-1x\" aria-hidden=\"true\"></i>\n		</span>\n		<span class=\"fa-stack queued-status\" data-ng-switch-when=\"QUEUED\">\n			<i class=\"fa fa-circle-thin fa-stack-1x\" aria-hidden=\"true\"></i>\n			<i class=\"fa fa-clock-o fa-stack-1x\" aria-hidden=\"true\"></i>\n		</span>\n		<div data-ng-switch-when=\"WAITING\">\n			<div data-ng-switch=\"row.entity.packageStatus\">\n				<span class=\"fa-stack pending-delivery-status\" data-ng-switch-when=\"PENDING_DELIVERY\">\n					<i class=\"fa fa-square fa-stack-1x\"></i>\n					<i class=\"fa fa-exclamation-triangle fa-stack-2x\"></i>\n				</span>\n				<span class=\"fa-stack pending-approval-status\" data-ng-switch-when=\"PENDING_APPROVAL\">\n					<i class=\"fa fa-square fa-stack-1x\"></i>\n					<i class=\"fa fa-exclamation-triangle fa-stack-2x\"></i>\n				</span>\n				<span class=\"fa-stack pkg-status-pending\" ng-switch-when=\"PENDING_RESTORE\">\n					<i class=\"fa fa-square fa-stack-1x\"></i>\n					<i class=\"fa fa-exclamation-triangle fa-stack-2x\"></i>\n				</span>\n				<span class=\"fa-stack pending-approval-status\" data-ng-switch-default>\n					<i class=\"fa fa-square fa-stack-1x\"></i>\n					<i class=\"fa fa-exclamation-triangle fa-stack-2x\"></i>\n				</span>\n			</div>\n		</div>\n		<i class=\"fa fa-cog created-status\" aria-hidden=\"true\" data-ng-switch-default></i>\n	</div>\n	<div class=\"pending-status\" data-ng-switch=\"row.entity.pendingStatus\">\n		<span class=\"fa-stack executing-status\" data-ng-switch-when=\"EXECUTING\">\n			<i class=\"fa fa-circle-thin fa-stack-1x\" aria-hidden=\"true\"></i>\n			<i class=\"fa fa-refresh fa-spin fa-stack-1x fa-fw\"></i>\n		</span>\n		<span class=\"fa-stack paused-status\" data-ng-switch-when=\"PAUSED\">\n			<i class=\"fa fa-circle-thin fa-stack-1x\" aria-hidden=\"true\"></i>\n			<i class=\"fa fa-pause fa-stack-1x\" aria-hidden=\"true\"></i>\n		</span>\n		<span class=\"fa-stack abandoned-status\" data-ng-switch-when=\"ABANDONED\">\n			<i class=\"fa fa-circle-thin fa-stack-1x\" aria-hidden=\"true\"></i>\n			<i class=\"fa fa-life-ring fa-stack-1x\" aria-hidden=\"true\"></i>\n		</span>\n	</div>\n</div>\n");
        $templateCache.put("dashboard/workflows/gridTemplates/workflow-subject-expandable-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding expandable-caret\" data-tooltip-append-to-body=\"true\" uib-tooltip=\"{{COL_FIELD CUSTOM_FILTERS}}\">\n	<div ng-if=\"row.entity.subflowCount > 0\">\n		<span ng-style=\"{\'padding-left\': grid.appScope.$ctrl.getTreeLevelPadding(row.entity)}\">\n			<i class=\"fa fa-lg caret-width\" ng-class=\"row.entity.expanded ? \'fa-caret-down\' : \'fa-caret-right\'\"\n			   ng-click=\"grid.appScope.$ctrl.toggleChildrenVisibility(row.entity, $event)\"></i> {{COL_FIELD CUSTOM_FILTERS}}</span>\n	</div>\n	<div ng-if=\"!parseInt(row.entity.subflowCount, 10)\">\n		<span ng-style=\"{\'padding-left\': grid.appScope.$ctrl.getTreeLevelPadding(row.entity)}\">{{COL_FIELD CUSTOM_FILTERS}}</span>\n	</div>\n</div>\n");
        $templateCache.put("dashboard/workflows/searchView/workflows-search-view-template.html", "<div class=\"loadingIndicator\">\n	<div data-lb-progress=\"$ctrl.loadingIndicator\" ng-show=\"$ctrl.loadingIndicator.show\"></div>\n</div>\n<div class=\"row-no-padding\">\n	<div class=\"col-md-12 col-lg-12\">\n		<div id=\"workflowGrid\"\n             ui-grid=\"$ctrl.gridOptions\"\n             class=\"grid\"\n             ui-grid-selection\n             ui-grid-pagination\n             ui-grid-tree-view\n			 ui-grid-resize-columns\n             ui-grid-save-state>\n        </div>\n	</div>\n</div>\n<div class=\"row-no-padding manager-toolbar\">\n	<div class=\"col-md-12 col-lg-12\">\n		<form class=\"form-inline toolbar-top-padding-sm\">\n			<div class=\"form-group\">\n				<div class=\"col-md-6 col-lg-6\">\n					<a class=\"toolbar-button\" role=\"button\" id=\"wfViewButton\"\n					   ng-disabled=\"$ctrl.isWorkflowActionDisabled(\'view\')\"\n					   ng-click=\"$ctrl.handleWorkflowAction(\'view\')\">\n                        <i class=\"fa fa-eye\"></i>\n                        <br>View</a>\n				</div>\n				<div class=\"col-md-6 col-lg-6\">\n					<a class=\"toolbar-button\" role=\"button\" id=\"wfResumeButton\"\n					   ng-disabled=\"$ctrl.isWorkflowActionDisabled(\'resume\')\"\n					   ng-click=\"$ctrl.handleWorkflowAction(\'resume\')\">\n                        <i class=\"fa fa-play\"></i>\n                        <br>Resume</a>\n				</div>\n			</div>\n			<div class=\"form-group\">\n				<div class=\"col-md-6 col-lg-6\">\n					<a class=\"toolbar-button\" role=\"button\" id=\"wfPauseButton\"\n					   ng-disabled=\"$ctrl.isWorkflowActionDisabled(\'pause\')\"\n					   ng-click=\"$ctrl.handleWorkflowAction(\'pause\')\">\n                        <i class=\"fa fa-pause\"></i>\n                        <br>Pause\n                    </a>\n				</div>\n				<div class=\"col-md-6 col-lg-6\">\n					<a class=\"toolbar-button\" role=\"button\" id=\"wfAbandonButton\"\n					   ng-disabled=\"$ctrl.isWorkflowActionDisabled(\'abandon\')\"\n					   ng-click=\"$ctrl.handleWorkflowAction(\'abandon\')\">\n                        <i class=\"fa fa-trash\"></i>\n                        <br>Abandon</a>\n				</div>\n			</div>\n			<div class=\"form-group pull-right\">\n				<pagination-controls prev-page-handler=\"$ctrl.paginationPrevPageHandler()\"\n									 next-page-handler=\"$ctrl.paginationNextPageHandler()\"\n									 jump-to-page-handler=\"$ctrl.paginationJumpToPageHandler()\"\n                                     page-size-change-handler=\"$ctrl.paginationSizeChangeHandler()\"\n									 paging-options=\"$ctrl.pagingOptions\" class=\"form-group\">\n				</pagination-controls>\n			</div>\n		</form>\n	</div>\n</div>\n");
        $templateCache.put("dashboard/workflows/searchView/workflows-view-template.html", "<div class=\"container-fluid no-padding\">\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n    <div class=\"row-no-padding\">\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n		<div class=\"col-md-10 col-lg-10 content-pane\">\n			<workflow-search-view></workflow-search-view>\n		</div>\n    </div>\n</div>\n");
        $templateCache.put("dashboard/workflows/stepView/workflow-step-view-template.html", "<div class=\"container-fluid no-padding\">\n	<div class=\"row-no-padding\">\n		<navbar></navbar>\n	</div>\n	<div class=\"row-no-padding\">\n		<sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n		<div class=\"col-md-10 col-lg-10 content-pane\">\n\n			<div class=\"loadingIndicator\">\n				<div data-lb-progress=\"workflowStepViewCntrlr.loadingIndicator\"\n					 ng-show=\"workflowStepViewCntrlr.loadingIndicator.show\"></div>\n			</div>\n			<div class=\"row-no-padding\">\n				<breadcrumb	tab-name=\"workflowStepViewCntrlr.parentWorkflowExecutionLabel\"></breadcrumb>\n				<uib-tabset horizontal=\"true\" type=\"pills\" class=\"edit-view-tabbar\">\n					<uib-tab heading=\"Workflow Execution Steps\" active=\"true\">\n						<div class=\"row-no-padding\">\n							<div ng-class=\"workflowStepViewCntrlr.selectedStep? \'col-md-8 col-lg-8\' : \'col-md-12 col-lg-12\'\">\n								<div ui-grid=\"workflowStepViewCntrlr.gridOptions\"\n									 class=\"workflow-step-grid search-grid\"\n									 ui-grid-auto-resize ui-grid-resize-columns  ui-grid-selection\n									 id=\"workflowStepGrid\">\n								</div>\n							</div>\n							<div class=\"col-md-4 col-lg-4\" ng-if=\"workflowStepViewCntrlr.selectedStep\">\n								<context-detail-view selected-workflow-step=\"workflowStepViewCntrlr.selectedStep\"\n													 close-handler=\"workflowStepViewCntrlr.detailViewCloseHandler()\"></context-detail-view>\n							</div>\n						</div>\n					</uib-tab>\n				</uib-tabset>\n			</div>\n\n			<div class=\"row-no-padding manager-toolbar\">\n				<div class=\"col-md-12 col-lg-12\">\n					<form class=\"form-inline toolbar-top-padding-sm\">\n						<div class=\"form-group pull-right\">\n							<!-- Pagination disabled until API supports sort order.\n							<pagination-controls\n								prev-page-handler=\"workflowStepViewCntrlr.paginationPrevPageHandler()\"\n								next-page-handler=\"workflowStepViewCntrlr.paginationNextPageHandler()\"\n								jump-to-page-handler=\"workflowStepViewCntrlr.paginationJumpToPageHandler()\"\n								paging-options=\"workflowStepViewCntrlr.pagingOptions\" class=\"form-group\">\n							</pagination-controls>\n                            -->\n						</div>\n					</form>\n				</div>\n			</div>\n\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("login/components/samlLogin/saml-login-template.html", "<div class=\"form-group flex-col-container\">\n    <div class=\"col-md-4 flex-row-container\">\n        <button id=\"loginBtn\"\n                type=\"submit\"\n                class=\"btn btn-default btn-link flex-stretcher\"\n                ng-click=\"$ctrl.login()\"\n                ng-disabled=\"!$ctrl.canSubmit\"\n                role=\"button\">\n            LOG IN\n        </button>\n    </div>\n</div>\n");
        $templateCache.put("login/components/systemLogin/system-login-template.html", "<form id=\"loginForm\"\n      name=\"loginForm\"\n      class=\"form-horizontal\"\n      role=\"form\"\n      ng-submit=\"$ctrl.login()\">\n    <div class=\"form-group\">\n        <div class=\"col-md-12\">\n            <input type=\"text\" name=\"username\" class=\"login-input\" id=\"usernameInput\" autofocus\n                   placeholder=\"Username\" ng-model=\"$ctrl.username\" required/>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <div class=\"col-md-12\">\n            <input type=\"password\" name=\"password\" class=\"login-input\" id=\"passwordInput\"\n                   placeholder=\"Password\" ng-model=\"$ctrl.password\" required/>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <div class=\"col-md-7 \">\n            <!--TODO: Add back in once resetPassword endpoint is created-->\n            <!--<button class=\"btn btn-link\">Forgot your password?</button>-->\n        </div>\n        <div class=\"col-md-4 col-md-offset-1 flex-row-container\">\n            <button id=\"loginBtn\"\n                    type=\"submit\"\n                    class=\"btn btn-default btn-link brn-blue flex-stretcher\"\n                    ng-disabled=\"!$ctrl.canSubmit\"\n                    role=\"button\">\n                LOG IN\n            </button>\n        </div>\n    </div>\n</form>\n");
        $templateCache.put("meta/collaborator/editView/collaborators-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <div class=\"row-no-padding\">\n\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n            <breadcrumb tab-name=\"$ctrl.editData.displayName\"></breadcrumb>\n            <fieldset ng-disabled=\"!$ctrl.permissions.write\" ng-if=\"$ctrl.permissions.read || $ctrl.isAdmin\">\n                <div class=\"edit-full-height edit-view\">\n                    <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n                        <div class=\"edit-view-container\">\n                            <div class=\"col-md-12 column\">\n                                <div class=\"row\">\n                                    <div class=\"col-md-2\">\n                                        <div class=\"prism-form-heading\">General</div>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class=\"row clearfix\">\n                                <div class=\"row clearfix spacer-top-lg\">\n                                    <div class=\"col-md-12 column\">\n                                        <div class=\"row-no-padding\">\n                                            <form role=\"form\" class=\"form-horizontal\">\n                                                <div class=\"form-group\">\n                                                    <label class=\"control-label col-md-2\">Display Name</label>\n                                                    <div class=\"col-sm-4 pad-text-input-col\">\n                                                        <input type=\"text\" class=\"prism-text-input\"\n                                                               ng-model=\"$ctrl.editData.displayName\"\n                                                               ng-change=\"$ctrl.handleDisplayNameChange()\"\n                                                               id=\"displayNameInput\"/>\n                                                        <label class=\"under-field-hint\">(First Name Last Name)</label>\n                                                    </div>\n                                                </div>\n                                                <div class=\"form-group\">\n                                                    <label class=\"control-label col-md-2\">Sort Name</label>\n                                                    <div class=\"col-sm-4 pad-text-input-col\">\n                                                        <input type=\"text\" class=\"prism-text-input\"\n                                                               ng-model=\"$ctrl.editData.sortName\"\n                                                               id=\"sortNameInput\"/>\n                                                        <label class=\"under-field-hint\">(Last Name, First Name)</label>\n                                                    </div>\n                                                </div>\n                                                <div class=\"form-group\">\n                                                    <label class=\"control-label col-md-2\">Nickname</label>\n                                                    <div class=\"col-sm-4 pad-text-input-col\">\n                                                        <input type=\"text\" class=\"prism-text-input\"\n                                                               ng-model=\"$ctrl.editData.nickname\"\n                                                               id=\"nicknameInput\"/>\n                                                    </div>\n                                                </div>\n                                                <div class=\"form-group\">\n                                                    <label class=\"control-label col-md-2\">IMDB#</label>\n                                                    <div class=\"col-sm-4 pad-text-input-col\">\n                                                        <input type=\"text\" class=\"prism-text-input\"\n                                                               ng-model=\"$ctrl.editData.iMDbNumber\"\n                                                               id=\"imdbNumberInput\"/>\n                                                    </div>\n                                                </div>\n                                                <div class=\"form-group\">\n                                                    <label class=\"control-label col-md-2\">Roles</label>\n                                                    <div class=\"col-sm-4 pad-text-input-col\">\n                                                        <div id=\"collaboratorRolesGrid\"\n                                                             class=\"grid search-grid\"\n                                                             ui-grid=\"$ctrl.gridOptions\"\n                                                             ui-grid-selection\n                                                             ui-grid-pagination\n                                                             style=\"max-height: 305px;\"\n                                                             ui-grid-resize-columns>\n                                                        </div>\n                                                    </div>\n                                                </div>\n                                            </form>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </fieldset>\n            <div class=\"row-no-padding manager-toolbar\">\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\" pagination-defs=\"$ctrl.paginationDefs\"></toolbar>\n            </div>\n        </div>\n        <div class=\"loadingIndicator\">\n            <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                 ng-show=\"$ctrl.loadingIndicator.show\">\n            </div>\n        </div>\n    </div>\n\n</div>\n\n");
        $templateCache.put("meta/collaborator/searchView/collaborators-grid-search-view-template.html", "<div>\n    <div class=\"container-fluid no-padding\">\n        <div class=\"row-no-padding\">\n            <navbar></navbar>\n        </div>\n\n        <div class=\"row-no-padding\">\n            <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n            <div class=\"col-md-10 col-lg-10 content-pane\">\n\n                <div class=\"loadingIndicator\">\n                    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                         ng-show=\"$ctrl.loadingIndicator.show\">\n                    </div>\n                </div>\n\n                <div id=\"collaboratorsGrid\"\n                     class=\"grid search-grid\"\n                     ui-grid=\"$ctrl.gridOptions\"\n                     ui-grid-selection\n                     ui-grid-resize-columns>\n                </div>\n\n                <!-- Toolbar -->\n                <div class=\"row-no-padding manager-toolbar\">\n                    <div class=\"row-no-padding manager-toolbar\">\n                        <toolbar button-defs=\"$ctrl.toolbarButtonDefs\" pagination-defs=\"$ctrl.paginationDefs\"></toolbar>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n");
        $templateCache.put("meta/content/editor/content-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n    <div class=\"row-no-padding\">\n        <navbar search-enabled=\"$ctrl.isSearchEnabled()\"\n                show-next-previous-buttons=\"$ctrl.isNextPreviousShown()\"></navbar>\n    </div>\n    <div class=\"row-no-padding\">\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n            <div class=\"row-no-padding\">\n                <breadcrumb tab-name=\"$ctrl.contentObject.name\"></breadcrumb>\n                <uib-tabset\n                        horizontal=\"true\"\n                        type=\"pills\"\n                        class=\"edit-view-tabbar\"\n                        active=\"$ctrl.currentViewedTab\">\n                    <div class=\"loadingIndicator\">\n                        <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                             ng-show=\"$ctrl.loadingIndicator.show\"></div>\n                    </div>\n\n                    <!-- Properties -->\n                    <uib-tab heading=\"Properties\"\n                             select=\"$ctrl.onTabSelect(\'properties\')\"\n                             deselect=\"$ctrl.onTabDeselect($event)\"\n                             index=\"\'properties\'\">\n                        <div ng-if=\"$ctrl.currentViewedTab === \'properties\'\">\n                            <content-properties-view class=\"col-md-12 col-lg-12 edit-full-height\"\n                                                     content-object=\"$ctrl.contentObject\"\n                                                     genres=\"$ctrl.genres\"\n                                                     networks=\"$ctrl.networks\"\n                                                     metadata-components-map=\"$ctrl.metadataComponentsMap\"\n                                                     available-live-feeds=\"$ctrl.availableLiveFeeds\">\n                            </content-properties-view>\n                        </div>\n                    </uib-tab>\n\n                    <!-- Media Profiles -->\n                    <uib-tab heading=\"Media Profiles\"\n                             select=\"$ctrl.onTabSelect(\'mediaProfiles\')\"\n                             deselect=\"$ctrl.onTabDeselect($event)\"\n                             index=\"\'mediaProfiles\'\">\n                        <div ng-if=\"$ctrl.currentViewedTab === \'mediaProfiles\'\">\n                            <content-package-accept-templates class=\"edit-full-height\">\n                            </content-package-accept-templates>\n                        </div>\n                    </uib-tab>\n\n                    <!-- Collaborators -->\n                    <uib-tab ng-show=\"$ctrl.contentType !== \'Ad/PreRoll\'\"\n                             heading=\"Collaborators\"\n                             select=\"$ctrl.onTabSelect(\'collaborators\')\"\n                             deselect=\"$ctrl.onTabDeselect($event)\"\n                             index=\"\'collaborators\'\">\n                        <div ng-if=\"$ctrl.contentLoaded && $ctrl.currentViewedTab === \'collaborators\'\">\n                            <content-collaborator-grid-view\n                                    class=\"col-md-12 col-lg-12 edit-full-height-tabs no-padding\"\n                                    is-season-volume=\"false\"\n                                    content=\"$ctrl.contentObject\">\n                            </content-collaborator-grid-view>\n                        </div>\n                    </uib-tab>\n\n                    <!-- Categories -->\n                    <uib-tab heading=\"Categories\"\n                             select=\"$ctrl.onTabSelect(\'categories\')\"\n                             deselect=\"$ctrl.onTabDeselect($event)\"\n                             index=\"\'categories\'\">\n                        <div ng-if=\"$ctrl.currentViewedTab === \'categories\'\">\n                            <content-categories-search-view\n                                    class=\"col-md-12 col-lg-12 edit-full-height-tabs no-padding\">\n                            </content-categories-search-view>\n                        </div>\n                    </uib-tab>\n\n                    <!-- Seasons (series only) -->\n                    <uib-tab heading=\"Seasons\"\n                             ng-show=\"$ctrl.contentType === \'Series\'\"\n                             select=\"$ctrl.onTabSelect(\'seasons\')\"\n                             deselect=\"$ctrl.onTabDeselect($event)\"\n                             index=\"\'seasons\'\">\n                        <div ng-if=\"$ctrl.currentViewedTab === \'seasons\'\">\n                            <content-season-volume-search-view\n                                    is-season=\"true\">\n                            </content-season-volume-search-view>\n                        </div>\n                    </uib-tab>\n\n                    <!-- Volumes (series only) -->\n                    <uib-tab heading=\"Volumes\"\n                             ng-show=\"$ctrl.contentType === \'Series\'\"\n                             select=\"$ctrl.onTabSelect(\'volumes\')\"\n                             deselect=\"$ctrl.onTabDeselect($event)\"\n                             index=\"\'volumes\'\">\n                        <div ng-if=\"$ctrl.currentViewedTab === \'volumes\'\">\n                            <content-season-volume-search-view\n                                    is-season=\"false\">\n                            </content-season-volume-search-view>\n                        </div>\n                    </uib-tab>\n\n                    <!-- Preroll -->\n                    <uib-tab heading=\"Prerolls\"\n                             select=\"$ctrl.onTabSelect(\'preRolls\')\"\n                             deselect=\"$ctrl.onTabDeselect($event)\"\n                             index=\"\'preRolls\'\"\n                             ng-show=\"$ctrl.contentType !== \'Ad/PreRoll\' && $ctrl.permissions.preRoll.read\">\n                        <branding-search-view\n                                is-admin=\"$ctrl.isAdmin\"\n                                group-name=\"$ctrl.brandingConfigGroup\"\n                                type=\"\'preRolls\'\"\n                                base-url=\"$ctrl.baseUrl\"\n                                permission-view-state=\"$ctrl.permissionViewStates[$ctrl.contentType].preRoll\"\n                                class=\"col-md-12 col-lg-12 no-padding\"\n                                ng-if=\"$ctrl.currentViewedTab === \'preRolls\'\">\n                        </branding-search-view>\n                    </uib-tab>\n\n                    <!-- Postroll -->\n                    <uib-tab heading=\"Postrolls\"\n                             select=\"$ctrl.onTabSelect(\'postRolls\')\"\n                             deselect=\"$ctrl.onTabDeselect($event)\"\n                             index=\"\'postRolls\'\"\n                             ng-show=\"$ctrl.contentType !== \'Ad/PreRoll\' && $ctrl.permissions.postRoll.read\">\n                        <branding-search-view\n                                is-admin=\"$ctrl.isAdmin\"\n                                group-name=\"$ctrl.brandingConfigGroup\"\n                                type=\"\'postRolls\'\"\n                                base-url=\"$ctrl.baseUrl\"\n                                permission-view-state=\"$ctrl.permissionViewStates[$ctrl.contentType].postRoll\"\n                                class=\"col-md-12 col-lg-12 no-padding\"\n                                ng-if=\"$ctrl.currentViewedTab === \'postRolls\'\">\n                        </branding-search-view>\n                    </uib-tab>\n\n                    <!-- Break Pre/Postrolls -->\n                    <uib-tab heading=\"Break Pre/Postrolls\"\n                             select=\"$ctrl.onTabSelect(\'breakPrePostRolls\')\"\n                             deselect=\"$ctrl.onTabDeselect($event)\"\n                             index=\"\'breakPrePostRolls\'\"\n                             ng-show=\"$ctrl.contentType !== \'Ad/PreRoll\' && $ctrl.permissions.breakprepostroll.read\">\n                        <branding-search-view\n                                is-admin=\"$ctrl.isAdmin\"\n                                group-name=\"$ctrl.brandingConfigGroup\"\n                                type=\"\'breakPrePostRolls\'\"\n                                base-url=\"$ctrl.baseUrl\"\n                                permission-view-state=\"$ctrl.permissionViewStates[$ctrl.contentType].breakPrePostRoll\"\n                                class=\"col-md-12 col-lg-12 no-padding\"\n                                ng-if=\"$ctrl.currentViewedTab === \'breakPrePostRolls\'\">\n                        </branding-search-view>\n                    </uib-tab>\n\n                    <!-- Watermarks -->\n                    <uib-tab heading=\"Watermarks\"\n                             select=\"$ctrl.onTabSelect(\'watermarks\')\"\n                             deselect=\"$ctrl.onTabDeselect($event)\"\n                             index=\"\'watermarks\'\"\n                             ng-show=\"$ctrl.contentType !== \'Ad/PreRoll\'\">\n                        <branding-search-view\n                                is-admin=\"$ctrl.isAdmin\"\n                                group-name=\"$ctrl.brandingConfigGroup\"\n                                type=\"\'watermarks\'\"\n                                base-url=\"$ctrl.baseUrl\"\n                                permission-view-state=\"$ctrl.permissionViewStates[$ctrl.contentType].watermark\"\n                                class=\"col-md-12 col-lg-12 no-padding\"\n                                ng-if=\"$ctrl.currentViewedTab === \'watermarks\'\">\n                        </branding-search-view>\n                    </uib-tab>\n\n                    <!-- Artwork -->\n                    <uib-tab heading=\"Artwork\"\n                             select=\"$ctrl.onTabSelect(\'artwork\')\"\n                             deselect=\"$ctrl.onTabDeselect($event)\"\n                             index=\"\'artwork\'\"\n                             ng-show=\"$ctrl.contentType !== \'Ad/PreRoll\'\">\n                        <branding-search-view\n                                is-admin=\"$ctrl.isAdmin\"\n                                group-name=\"$ctrl.brandingConfigGroup\"\n                                type=\"\'artwork\'\"\n                                base-url=\"$ctrl.baseUrl\"\n                                permission-view-state=\"$ctrl.permissionViewStates[$ctrl.contentType].artwork\"\n                                class=\"col-md-12 col-lg-12 no-padding\"\n                                ng-if=\"$ctrl.currentViewedTab === \'artwork\'\">\n                        </branding-search-view>\n                    </uib-tab>\n\n                    <!-- Aggregation -->\n                    <uib-tab heading=\"Aggregation\"\n                             select=\"$ctrl.onTabSelect(\'aggregation\')\"\n                             deselect=\"$ctrl.onTabDeselect($event)\"\n                             index=\"\'aggregation\'\"\n                             ng-show=\"$ctrl.contentType !== \'Ad/PreRoll\'\">\n                        <div ng-if=\"$ctrl.currentViewedTab === \'aggregation\'\">\n                            <aggregation-tab\n                                class=\"edit-full-height\"\n                                content-object=\"$ctrl.contentObject\"\n                                loading-indicator=\"$ctrl.loadingIndicator\">\n                            </aggregation-tab>\n                        </div>\n                    </uib-tab>\n\n                </uib-tabset>\n            </div>\n\n        </div>\n    </div>\n\n</div>\n");
        $templateCache.put("meta/content/searchView/content-searchview-template.html", "<div>\n    <div class=\"container-fluid no-padding\">\n        <div class=\"row-no-padding\">\n            <navbar></navbar>\n        </div>\n\n        <div class=\"row-no-padding\">\n            <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n            <div class=\"col-md-10 col-lg-10 content-pane\">\n\n                <div class=\"loadingIndicator\">\n                    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                         ng-show=\"$ctrl.loadingIndicator.show\">\n                    </div>\n                </div>\n\n                <div id=\"contentGrid\"\n                     class=\"grid search-grid\"\n                     ui-grid=\"$ctrl.gridOptions\"\n                     ui-grid-selection\n                     ui-grid-pagination\n                     ui-grid-resize-columns>\n                </div>\n\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"\n                         pagination-defs=\"$ctrl.paginationDefs\"\n                         right-hand-checkbox-defs=\"$ctrl.toolbarCheckboxDefs\">\n                </toolbar>\n\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("meta/mvpd/metadataEditView/mvpd-metadata-item-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n\n	<div class=\"row-no-padding\">\n		<navbar></navbar>\n	</div>\n\n	<div class=\"row-no-padding\">\n\n		<sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n		<div class=\"col-md-10 col-lg-10 content-pane\">\n\n			<div class=\"loadingIndicator\">\n				<div data-lb-progress=\"$ctrl.loadingIndicator\"\n					 ng-show=\"$ctrl.loadingIndicator.show\">\n				</div>\n			</div>\n\n			<div class=\"row-no-padding\">\n				<breadcrumb tab-name=\"$ctrl.editData.name\"></breadcrumb>\n				<uib-tabset horizontal=\"true\"\n							type=\"pills\"\n							class=\"edit-view-tabbar\"\n							active=\"$ctrl.currentTab\">\n					<uib-tab heading=\"Properties\" index=\"\'properties\'\"\n							 select=\"$ctrl.onTabSelect(\'properties\')\"\n							 deselect=\"$ctrl.onTabDeselect(\'properties\', $event)\">\n\n						<div ng-if=\"$ctrl.activeTabs.properties\" class=\"col-md-12 col-lg-12 edit-full-height\">\n\n							<fieldset ng-disabled=\"!$ctrl.permissions.write\"\n                                      ng-if=\"$ctrl.permissions.read || $ctrl.isAdmin\">\n								<div ng-show=\"$ctrl.editData\" class=\"row edit-full-height edit-view\">\n\n									<form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n\n										<div class=\"edit-view-container\">\n											<div class=\"row\">\n												<div class=\"col-md-2\">\n													<div class=\"prism-form-heading\">{{$ctrl.groupName}} Metadata</div>\n												</div>\n											</div>\n\n											<div class=\"row clearfix spacer-top-lg\">\n												<div class=\"col-md-12 column\">\n\n													<custom-metadata components-map=\"$ctrl.getComponentsMap()\"\n																	 id-prefix=\"{{$ctrl.editData.name}}\"\n																	 on-update=\"$ctrl.onUpdate(event)\">\n													</custom-metadata>\n\n												</div>\n											</div>\n										</div>\n\n									</form>\n								</div>\n							</fieldset>\n\n						</div>\n\n					</uib-tab>\n\n					<uib-tab ng-if=\"$ctrl.isSeries && !$ctrl.seasonVolumeId\"\n							 heading=\"Seasons\" index=\"\'seasons\'\"\n							 select=\"$ctrl.onTabSelect(\'seasons\')\"\n							 deselect=\"$ctrl.onTabDeselect(\'seasons\', $event)\">\n\n						<div ng-if=\"$ctrl.activeTabs.seasons\">\n\n							<div id=\"mvpdSeasonGrid\"\n								 class=\"grid search-grid\"\n								 ui-grid=\"$ctrl.gridOptions\"\n								 ui-grid-selection\n								 ui-grid-pagination\n								 ui-grid-resize-columns>\n							</div>\n\n						</div>\n\n					</uib-tab>\n\n					<uib-tab ng-if=\"$ctrl.isSeries && !$ctrl.seasonVolumeId\"\n							 heading=\"Volumes\" index=\"\'volumes\'\"\n							 select=\"$ctrl.onTabSelect(\'volumes\')\"\n							 deselect=\"$ctrl.onTabDeselect(\'volumes\', $event)\">\n\n						<div ng-if=\"$ctrl.activeTabs.volumes\">\n\n							<div id=\"mvpdSeasonVolumeGrid\"\n								 class=\"grid search-grid\"\n								 ui-grid=\"$ctrl.gridOptions\"\n								 ui-grid-selection\n								 ui-grid-pagination\n								 ui-grid-resize-columns>\n							</div>\n\n						</div>\n\n					</uib-tab>\n\n				</uib-tabset>\n			</div>\n\n			<toolbar button-defs=\"$ctrl.toolbarButtonDefs\" pagination-defs=\"$ctrl.paginationDefs\"></toolbar>\n\n		</div>\n	</div>\n\n</div>\n");
        $templateCache.put("meta/mvpd/partnerSearchView/mvpd-partner-grid-search-view-template.html", "<div class=\"container-fluid no-padding\">\n\n	<div class=\"row-no-padding\">\n		<navbar></navbar>\n	</div>\n\n	<!-- Main -->\n	<div class=\"row-no-padding\">\n		<!-- Sidebar -->\n		<sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n		<!-- Content pane -->\n		<div class=\"col-md-10 col-lg-10 content-pane\">\n\n			<div class=\"loadingIndicator\">\n				<div data-lb-progress=\"$ctrl.loadingIndicator\"\n					 ng-show=\"$ctrl.loadingIndicator.show\">\n				</div>\n			</div>\n\n			<breadcrumb tab-name=\"$ctrl.mvpdConfig.partnerName\"></breadcrumb>\n\n			<div class=\"row-no-padding\">\n				<!-- Tab Component -->\n				<uib-tabset horizontal=\"true\"\n							type=\"pills\"\n							class=\"edit-view-tabbar\"\n							active=\"$ctrl.currentTab\">\n\n					<uib-tab heading=\"Networks\" index=\"\'networks\'\"\n							 select=\"$ctrl.onTabSelect(\'networks\')\"\n							 deselect=\"$ctrl.onTabDeselect(\'networks\', $event)\">\n\n						<div ng-if=\"$ctrl.activeTabs.networks\"\n							 id=\"mvpdNetworkGrid\"\n							 class=\"breadcrumb-tab-edit-search-grid\"\n							 ui-grid=\"$ctrl.gridOptions\"\n							 ui-grid-selection\n							 ui-grid-pagination\n							 ui-grid-resize-columns>\n						</div>\n\n					</uib-tab>\n\n					<uib-tab heading=\"Series\" index=\"\'series\'\"\n							 select=\"$ctrl.onTabSelect(\'series\')\"\n							 deselect=\"$ctrl.onTabDeselect(\'series\', $event)\">\n\n						<div ng-if=\"$ctrl.activeTabs.series\">\n\n							<div id=\"mvpdSeriesGrid\"\n								 class=\"grid search-grid\"\n								 ui-grid=\"$ctrl.gridOptions\"\n								 ui-grid-selection\n								 ui-grid-pagination\n								 ui-grid-resize-columns>\n							</div>\n\n						</div>\n\n					</uib-tab>\n\n					<uib-tab heading=\"Movies/Specials\" index=\"\'movies\'\"\n							 select=\"$ctrl.onTabSelect(\'movies\')\"\n							 deselect=\"$ctrl.onTabDeselect(\'movies\', $event)\">\n\n						<div ng-if=\"$ctrl.activeTabs.movies\">\n\n							<div id=\"mvpdMovieGrid\"\n								 class=\"grid search-grid\"\n								 ui-grid=\"$ctrl.gridOptions\"\n								 ui-grid-selection\n								 ui-grid-pagination\n								 ui-grid-resize-columns>\n							</div>\n\n						</div>\n\n					</uib-tab>\n\n				</uib-tabset>\n\n			</div>\n\n			<toolbar button-defs=\"$ctrl.toolbarButtonDefs\" pagination-defs=\"$ctrl.paginationDefs\" right-hand-checkbox-defs=\"$ctrl.toolbarCheckboxDefs\"></toolbar>\n\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("meta/mvpd/searchView/mvpd-grid-search-view-template.html", "<div>\n	<div class=\"container-fluid no-padding\">\n		<div class=\"row-no-padding\">\n			<navbar></navbar>\n		</div>\n\n		<div class=\"row-no-padding\">\n			<sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n			<div class=\"col-md-10 col-lg-10 content-pane\">\n\n				<div class=\"loadingIndicator\">\n					<div data-lb-progress=\"$ctrl.loadingIndicator\"\n						 ng-show=\"$ctrl.loadingIndicator.show\">\n					</div>\n				</div>\n\n				<div id=\"mvpdGrid\"\n					 class=\"grid search-grid\"\n					 ui-grid=\"$ctrl.gridOptions\"\n					 ui-grid-selection\n					 ui-grid-pagination\n					 ui-grid-resize-columns>\n				</div>\n\n				<toolbar pagination-defs=\"$ctrl.paginationDefs\"></toolbar>\n\n			</div>\n		</div>\n	</div>\n</div>\n\n");
        $templateCache.put("meta/network/editor/network-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n\n	<!-- Navigation/search toolbar -->\n	<div class=\"row-no-padding\">\n		<navbar filter-enabled=\"$ctrl.filterEnabled\"></navbar>\n	</div>\n\n	<!-- Main -->\n	<div class=\"row-no-padding\">\n		<!-- Sidebar -->\n		<sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n		<!-- Content pane -->\n		<div class=\"col-md-10 col-lg-10 content-pane\">\n\n			<!-- Tab component -->\n			<div class=\"row-no-padding\">\n				<breadcrumb tab-name=\"$ctrl.getBreadcrumbName()\"></breadcrumb>\n\n				<uib-tabset horizontal=\"true\"\n							type=\"pills\"\n							class=\"edit-view-tabbar\"\n							active=\"$ctrl.currentTab\">\n\n					<!-- Network Properties -->\n					<uib-tab heading=\"{{\'Properties\'}}\"\n							 index=\"\'properties\'\"\n							 select=\"$ctrl.setActiveTab(\'properties\')\">\n						<network-properties-edit-view\n							is-admin=\"$ctrl.isAdmin\"\n							class=\"col-md-12 col-lg-12 edit-full-height no-padding\">\n						</network-properties-edit-view>\n					</uib-tab>\n\n					<!-- Preroll -->\n					<uib-tab heading=\"Prerolls\"\n							 index=\"\'preRolls\'\"\n							 select=\"$ctrl.setActiveTab(\'preRolls\')\"\n							 ng-if=\"$ctrl.permissions.preroll.read\">\n						<branding-search-view\n							is-admin=\"$ctrl.isAdmin\"\n							group-name=\"\'networks\'\"\n							type=\"\'preRolls\'\"\n							base-url=\"\'/meta/networks\'\"\n							permission-view-state=\"$ctrl.permissionViewStates.NETWORK_PREROLL_SEARCH_VIEW_STATE\"\n							class=\"col-md-12 col-lg-12 no-padding\"\n							ng-if=\"$ctrl.currentTab === \'preRolls\'\">\n						</branding-search-view>\n					</uib-tab>\n\n					<!-- Postroll -->\n					<uib-tab heading=\"Postrolls\"\n							 index=\"\'postRolls\'\"\n							 select=\"$ctrl.setActiveTab(\'postRolls\')\"\n							 ng-if=\"$ctrl.permissions.postroll.read\">\n						<branding-search-view\n							is-admin=\"$ctrl.isAdmin\"\n							group-name=\"\'networks\'\"\n							type=\"\'postRolls\'\"\n							base-url=\"\'/meta/networks\'\"\n							permission-view-state=\"$ctrl.permissionViewStates.NETWORK_POSTROLL_SEARCH_VIEW_STATE\"\n							class=\"col-md-12 col-lg-12 no-padding\"\n							ng-if=\"$ctrl.currentTab === \'postRolls\'\">\n						</branding-search-view>\n					</uib-tab>\n\n					<!-- Break Pre & Post Rolls -->\n					<uib-tab heading=\"Break Pre/Postrolls\"\n							 index=\"\'breakPrePostRolls\'\"\n							 select=\"$ctrl.setActiveTab(\'breakPrePostRolls\')\"\n							 ng-if=\"$ctrl.permissions.breakprepostroll.read && $ctrl.permissions.breakprepostroll.read\">\n						<branding-search-view\n							is-admin=\"$ctrl.isAdmin\"\n							group-name=\"\'networks\'\"\n							type=\"\'breakPrePostRolls\'\"\n							base-url=\"\'/meta/networks\'\"\n							permission-view-state=\"$ctrl.permissionViewStates.NETWORK_BREAKPREPOSTROLL_SEARCH_VIEW_STATE\"\n							class=\"col-md-12 col-lg-12 no-padding\"\n							ng-if=\"$ctrl.currentTab === \'breakPrePostRolls\'\">\n						</branding-search-view>\n					</uib-tab>\n\n                    <!-- Watermarks -->\n                    <uib-tab heading=\"Watermarks\"\n                             index=\"\'watermarks\'\"\n                             select=\"$ctrl.setActiveTab(\'watermarks\')\"\n                             ng-if=\"$ctrl.permissions.watermark.read\">\n                        <branding-search-view\n                            is-admin=\"$ctrl.isAdmin\"\n                            group-name=\"\'networks\'\"\n                            type=\"\'watermarks\'\"\n                            base-url=\"\'/meta/networks\'\"\n                            permission-view-state=\"$ctrl.permissionViewStates.NETWORK_WATERMARK_SEARCH_VIEW_STATE\"\n                            class=\"col-md-12 col-lg-12 no-padding\"\n                            ng-if=\"$ctrl.currentTab === \'watermarks\'\">\n                        </branding-search-view>\n                    </uib-tab>\n\n                    <!-- Artwork -->\n                    <uib-tab heading=\"Artwork\"\n                             index=\"\'artwork\'\"\n                             select=\"$ctrl.setActiveTab(\'artwork\')\"\n                             ng-if=\"$ctrl.permissions.watermark.read\">\n                        <branding-search-view\n                            is-admin=\"$ctrl.isAdmin\"\n                            group-name=\"\'networks\'\"\n                            type=\"\'artwork\'\"\n                            base-url=\"\'/meta/networks\'\"\n                            permission-view-state=\"$ctrl.permissionViewStates.NETWORK_ARTWORK_SEARCH_VIEW_STATE\"\n                            class=\"col-md-12 col-lg-12 no-padding\"\n                            ng-if=\"$ctrl.currentTab === \'artwork\'\">\n                        </branding-search-view>\n                    </uib-tab>\n\n                    <!-- Rating Overlays -->\n                    <uib-tab heading=\"Rating Overlays\"\n                             index=\"\'ratingOverlays\'\"\n                             select=\"$ctrl.setActiveTab(\'ratingOverlays\')\"\n                             ng-if=\"$ctrl.permissions.ratingOverlay.read\">\n                        <rating-overlay-search-view\n                            is-admin=\"$ctrl.isAdmin\"\n                            group-name=\"\'networks\'\"\n                            base-url=\"\'/meta/networks\'\"\n                            permission-view-state=\"$ctrl.permissionViewStates.NETWORK_RATING_OVERLAY_SEARCH_VIEW_STATE\"\n                            class=\"col-md-12 col-lg-12 no-padding\"\n                            ng-if=\"$ctrl.currentTab === \'ratingOverlays\'\">\n                        </rating-overlay-search-view>\n                    </uib-tab>\n\n                </uib-tabset>\n			</div>\n\n		</div>\n	</div>\n\n</div>\n");
        $templateCache.put("meta/network/searchView/network-search-view-template.html", "<div class=\"container-fluid no-padding\">\n	<div class=\"row-no-padding\">\n		<navbar></navbar>\n	</div>\n\n	<div class=\"row-no-padding\">\n		<sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n		<div class=\"col-md-10 col-lg-10 content-pane\">\n\n			<div class=\"loadingIndicator\">\n				<div data-lb-progress=\"$ctrl.loadingIndicator\" ng-show=\"$ctrl.loadingIndicator.show\"></div>\n			</div>\n\n			<div id=\"networkSearchGrid\"\n				 class=\"grid search-grid\"\n				 ui-grid=\"$ctrl.gridOptions\"\n				 ui-grid-selection\n				 ui-grid-pagination\n				 ui-grid-resize-columns>\n			</div>\n\n			<toolbar button-defs=\"$ctrl.toolbarButtonDefs\"></toolbar>\n\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("package/common/selectDeliveryPartnersModal/check-mark-tree-template.html", "<div class=\"checkbox-grid-cell\" ng-click=\"selectButtonClick(row, $event)\">\n	<input type=\"checkbox\" ng-checked=\"row.isSelected\" ng-if=\"row.entity.id && grid.appScope.selectDeliveryPartnersMdlCtrlr.partnerMap[row.entity.id] && grid.appScope.selectDeliveryPartnersMdlCtrlr.canSelectPartner(row.entity)\"/>\n	<label></label>\n</div>\n");
        $templateCache.put("package/common/selectDeliveryPartnersModal/partner-error-expandable-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\"\n     data-tooltip-append-to-body=\"true\">\n    <div ng-if=\"grid.appScope.selectDeliveryPartnersMdlCtrlr.partnerMap[row.entity.id]\">\n        <div class=\"pull-right text-nowrap\">\n\n            {{row.entity.deliveryLabel}}\n\n            <span class=\"partner-delivery-modal-item-container padding-left-sm padding-right-sm\">\n                <multiselect-dropdown\n                    attach-to-body=\"true\"\n                    btn-min-width=\"400\"\n                    btn-max-width=\"400\"\n                    clearable=\"false\"\n                    collection=\"row.entity.deliveryItems\"\n                    dividers-enabled=\"true\"\n                    id=\"{{row.entity.name + \'_deliveryItemDropdown\'}}\"\n                    label-field=\"type\"\n                    label-function=\"grid.appScope.selectDeliveryPartnersMdlCtrlr.deliveryItemDropdownLabelFunction\"\n                    max-height=\"300\"\n                    ng-disabled=\"!grid.appScope.selectDeliveryPartnersMdlCtrlr.selectedPartnerMap[row.entity.id] ||\n                                                   !grid.appScope.selectDeliveryPartnersMdlCtrlr.selectedPartnerMap[row.entity.id].template.template.custom\"\n                    ng-model=\"grid.appScope.selectDeliveryPartnersMdlCtrlr.selectedPartnerMap[row.entity.id].template.partnerDeliveryItemIds\"\n                    ng-if=\"grid.appScope.selectDeliveryPartnersMdlCtrlr.showDeliveryTemplateDropdown(row.entity)\"\n                    prompt=\"Select Items\"\n                    lock-selection=\"true\"\n                    lock-selection-prop=\"requiredForDelivery\"\n                    sort-collection=\"false\"\n                    show-loading=\"row.entity.showDeliveryItemsDropdownPacifier\"\n                    value-prop=\"msdId\">\n                </multiselect-dropdown>\n            </span>\n\n            <span class=\"partner-delivery-modal-template-container padding-left-sm\">\n				<dropdown-select\n                    attach-to-body=\"true\"\n                    btn-min-width=\"185\"\n                    collection=\"grid.appScope.selectDeliveryPartnersMdlCtrlr.partnerMap[row.entity.id].deliveryTemplates\"\n                    label-field=\"name\"\n                    max-height=\"\'185px\'\"\n                    ng-change=\"grid.appScope.selectDeliveryPartnersMdlCtrlr.deliveryTemplateChangeHandler(row.entity)\"\n                    ng-disabled=\"!grid.appScope.selectDeliveryPartnersMdlCtrlr.selectedPartnerMap[row.entity.id]\"\n                    ng-if=\"grid.appScope.selectDeliveryPartnersMdlCtrlr.showDeliveryTemplateDropdown(row.entity)\"\n                    ng-model=\"grid.appScope.selectDeliveryPartnersMdlCtrlr.selectedPartnerMap[row.entity.id].template\"\n                    prompt=\"Select Delivery Template\"\n                    track-by=\"template\">\n				</dropdown-select>\n			</span>\n        </div>\n        <span>\n			<i class=\"fa fa-fw\"\n               ng-class=\"row.entity.expanded ? \'fa-caret-down\' : \'fa-caret-right\'\"\n               ng-if=\"grid.appScope.selectDeliveryPartnersMdlCtrlr.showExpandableRowIndicator(row.entity)\"\n               ng-click=\"grid.appScope.selectDeliveryPartnersMdlCtrlr.togglePartnerErrors(row.entity, $event)\"></i>\n			<span class=\"fa-stack fa error-warning-triangle\"\n                  ng-if=\"grid.appScope.selectDeliveryPartnersMdlCtrlr.showErrorsAndWarningsTriangle(row.entity)\"\n                  ng-class=\"grid.appScope.selectDeliveryPartnersMdlCtrlr.partnerHasErrors(row.entity)?  \'tree-top-level-error\' : \'tree-top-level-warning\'\">\n				<i class=\"fa fa-square fa-stack-1x\"></i>\n				<i class=\"fa fa-exclamation-triangle fa-stack-2x\"></i>\n			</span>\n			<i class=\"fa green-check\"\n               ng-if=\"grid.appScope.selectDeliveryPartnersMdlCtrlr.showPartnerCheckmark(row.entity)\"></i>\n            <i class=\"fa blue-check\"\n               ng-if=\"row.entity.parentId\"></i>\n			<span class=\"tree-top-level-text\">\n                {{COL_FIELD}}\n                <span ng-show=\"grid.appScope.selectDeliveryPartnersMdlCtrlr.partnerMap[row.entity.id].redeliver\"\n                      class=\"required-form-control\">\n                    *\n                </span>\n			</span>\n		</span>\n    </div>\n    <div ng-if=\"!grid.appScope.selectDeliveryPartnersMdlCtrlr.partnerMap[row.entity.id]\"\n         data-tooltip-append-to-body=\"true\"\n         uib-tooltip=\"{{row.entity.label}}\">\n		<span class=\"select-delivery-partners-grid-errors-warnings-row\"><i\n            ng-class=\"row.entity.type === \'error\'?  \'tree-child-level-error\' : \'tree-child-level-warning\'\"></i>\n            {{row.entity.label}}\n        </span>\n    </div>\n</div>\n");
        $templateCache.put("package/common/selectDeliveryPartnersModal/select-delivery-partners-modal-template.html", "<div class=\"modal-header\">\n    <h5 class=\"modal-title\">Select Partners</h5>\n</div>\n<div class=\"modal-body\">\n    <form>\n        <div class=\"form-group\">\n            <label\n                class=\"prism-form-item-label\"\n                for=\"partnerSelectGrid\">\n                Select Partners:\n            </label>\n            <div id=\"partnerSelectGrid\"\n                 ui-grid=\"selectDeliveryPartnersMdlCtrlr.gridOptions\"\n                 class=\"inline-checkbox-grid\"\n                 ui-grid-selection>\n            </div>\n        </div>\n        <div class=\"form-group\"\n             ng-show=\"selectDeliveryPartnersMdlCtrlr.showRedeliverReasonDropdown()\">\n            <label class=\"yellow-label\"\n                   for=\"redeliveryReasonsDD\">\n                Redelivery Reason:\n                <span class=\"required-text-input\"\n                      required\n                      x-required-indicator>\n                </span>\n            </label>\n            <div>\n                <dropdown-select\n                    id=\"redeliveryReasonsDD\"\n                    ng-model=\"selectDeliveryPartnersMdlCtrlr.selectedRedeliveryReason\"\n                    prompt=\"Select Reason\"\n                    btn-min-width=\"250\"\n                    collection=\"selectDeliveryPartnersMdlCtrlr.redeliveryReasons\">\n                </dropdown-select>\n            </div>\n        </div>\n    </form>\n\n</div>\n<div class=\"modal-footer flex-row-container\">\n    <button\n        class=\"btn btn-sm btn-default\"\n        ng-click=\"selectDeliveryPartnersMdlCtrlr.cancel()\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button\n        class=\"btn btn-sm btn-default\"\n        ng-click=\"selectDeliveryPartnersMdlCtrlr.onOk()\"\n        ng-disabled=\"selectDeliveryPartnersMdlCtrlr.disableOKButton()\">\n        Deliver\n    </button>\n</div>\n");
        $templateCache.put("package/common/selectMasterMediaTypesModal/select-master-media-types-modal-template.html", "<div class=\"modal-header\">\n    <h5 class=\"modal-title\">Select Master Media Types</h5>\n</div>\n<div class=\"modal-body\">\n    <div class=\"row\">\n        <label class=\"col-sm-12 control-label\">Select Package Content:</label>\n    </div>\n    <form>\n        <div class=\"form-group\">\n            <label for=\"videoCheckbox\"\n                   class=\"col-sm-1 prism-form-item-label text-align-right\">\n                Video\n            </label>\n            <div class=\"col-sm-1\">\n                <input type=\"checkbox\"\n                       id=\"videoCheckbox\"\n                       ng-checked=\"selectMasterMediaTypesModal.selectedContent.Video\"\n                       ng-click=\"selectMasterMediaTypesModal.toggleContent(\'Video\')\"/>\n                <label for=\"videoCheckbox\"></label>\n            </div>\n            <label for=\"audioCheckbox\"\n                   class=\"col-sm-1 prism-form-item-label text-align-right\">\n                Audio\n            </label>\n            <div class=\"col-sm-1\">\n                <input type=\"checkbox\"\n                       id=\"audioCheckbox\"\n                       ng-checked=\"selectMasterMediaTypesModal.selectedContent.Audio\"\n                       ng-click=\"selectMasterMediaTypesModal.toggleContent(\'Audio\')\"/>\n                <label for=\"audioCheckbox\"></label>\n            </div>\n            <label for=\"closedCaptionCheckbox\"\n                   class=\"col-sm-1 prism-form-item-label text-align-right\">\n                CC\n            </label>\n            <div class=\"col-sm-1 no-left-padding\">\n                <input type=\"checkbox\"\n                       id=\"closedCaptionCheckbox\"\n                       ng-checked=\"selectMasterMediaTypesModal.selectedContent.CC\"\n                       ng-click=\"selectMasterMediaTypesModal.toggleContent(\'CC\')\"/>\n                <label for=\"closedCaptionCheckbox\"></label>\n            </div>\n            <label for=\"subtitleCheckbox\"\n                   class=\"col-sm-1 no-padding prism-form-item-label text-align-right\">\n                Subtitle\n            </label>\n            <div class=\"col-sm-1\">\n                <input type=\"checkbox\"\n                       id=\"subtitleCheckbox\"\n                       ng-checked=\"selectMasterMediaTypesModal.selectedContent.Subtitle\"\n                       ng-click=\"selectMasterMediaTypesModal.toggleContent(\'Subtitle\')\"/>\n                <label for=\"subtitleCheckbox\"></label>\n            </div>\n            <label for=\"imageCheckbox\"\n                   class=\"col-sm-1 prism-form-item-label text-align-right\">\n                Image\n            </label>\n            <div class=\"col-sm-1 padding-left-md\">\n                <input type=\"checkbox\"\n                       id=\"imageCheckbox\"\n                       ng-checked=\"selectMasterMediaTypesModal.selectedContent.Image\"\n                       ng-click=\"selectMasterMediaTypesModal.toggleContent(\'Image\')\"/>\n                <label for=\"imageCheckbox\"></label>\n            </div>\n        </div>\n    </form>\n\n</div>\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"selectMasterMediaTypesModal.cancel()\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"selectMasterMediaTypesModal.onOk()\"\n            ng-disabled=\"selectMasterMediaTypesModal.disableOKButton()\">\n        Ok\n    </button>\n</div>\n");
        $templateCache.put("package/manager/gridTemplates/accept-status-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding, {{row.entity.acceptStatus === \'ACCEPTED\'? \'grid-green\': \'grid-red\'}}\">\n	{{row.entity.acceptStatus === \'ACCEPTED\'? \'YES\' : \'NO\'}}\n</div>\n");
        $templateCache.put("package/manager/gridTemplates/clip-icon-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding clip-icon\" ng-show=\"row.entity.clipCount > 0\">\n    <i class=\"fa fa-film\"></i>\n</div>\n");
        $templateCache.put("package/manager/gridTemplates/component-icon-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding clip-icon\" ng-show=\"row.entity.videoComponentCount > 0\">\n	<span class=\"fa-stack component-video-icon\">\n		<i class=\"fa fa-film fa-stack-1x\"></i>\n		<i class=\"fa fa-film fa-stack-1x\"></i>\n	</span>\n</div>\n");
        $templateCache.put("package/manager/gridTemplates/delivery-icon-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding delivery-icon\">\n    <i class=\"fa fa-check-circle fa-lg\"\n	   ng-show=\"row.entity.acceptStatus === \'ACCEPTED\' && row.entity.mediaErrorCount === \'0\' &&\n	   row.entity.metadataErrorCount === \'0\' && !row.entity.locked\"></i>\n	<i class=\"fa fa-lock content-lock\" ng-show=\"row.entity.locked\"></i>\n</div>\n");
        $templateCache.put("package/manager/gridTemplates/index-column-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\" data-tooltip-append-to-body=\"true\" uib-tooltip=\"{{row.entity.name}}\">\n    <span>{{grid.renderContainers.body.visibleRowCache.indexOf(row) + 1 +\n        grid.appScope.searchController.pagingOptions.pageSize * (grid.appScope.searchController.packageIndexBase - 1)}}\n    </span>\n</div>\n");
        $templateCache.put("package/manager/gridTemplates/media-error-count-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding, {{row.entity.mediaErrorCount === \'0\'? \'grid-green\': \'grid-red\'}}\">\n	{{row.entity.mediaErrorCount === \'0\'? \'YES\' : \'NO\'}}\n</div>\n");
        $templateCache.put("package/manager/gridTemplates/metadata-error-count-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding {{(row.entity.metadataErrorCount === \'0\' || row.entity.metaErrorCount === \'0\')? \'grid-green\': \'grid-red\'}}\">\n	{{(row.entity.metadataErrorCount === \'0\' || row.entity.metaErrorCount === \'0\') ? \'YES\' : \'NO\'}}\n</div>\n");
        $templateCache.put("package/manager/gridTemplates/package-nickname-expandable-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\" data-tooltip-append-to-body=\"true\" uib-tooltip=\"{{COL_FIELD CUSTOM_FILTERS}}\"\n		ng-class=\"{\'caret-icon-cell\': row.entity.clipCount > 0 || row.entity.parentPackageId }\">\n	<div ng-if=\"!row.entity.parentPackageId\">\n		<span ng-class=\"row.entity.clipCount === \'0\'? \'manager-nickname-column\' : \'manager-nickname-column-icon\'\">\n			<i class=\"fa fa-lg fa-fw\" ng-class=\"row.entity.expanded ? \'fa-caret-down\' : \'fa-caret-right\'\"\n			   ng-if=\"row.entity.clipCount > 0\"\n			   ng-click=\"grid.appScope.searchController.toggleClipPackages(row.entity, $event)\"></i>{{COL_FIELD CUSTOM_FILTERS}}</span>\n	</div>\n	<div ng-if=\"row.entity.parentPackageId\">\n		<span class=\"manager-clip-package-nickname\"><i class=\"fa fa-circle\"></i>{{COL_FIELD CUSTOM_FILTERS}}</span>\n	</div>\n</div>\n");
        $templateCache.put("package/manager/gridTemplates/play-icon-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding play-icon\"\n	 ng-show=\"row.entity.primaryVideo && row.entity.primaryVideo.proxyPath\">\n    <span class=\"fa-stack\">\n		<a ng-click=\"grid.appScope.searchController.openVideoModal(row.entity.primaryVideo)\">\n			<i class=\"fa fa-circle-thin fa-stack-1x\"></i>\n      		<i class=\"fa fa-play fa-stack-1x\"></i>\n			<i class=\"fa fa-minus fa-1\" ng-if=\"!grid.appScope.searchController.pmPerms.preview.read\"></i>\n		</a>\n    </span>\n</div>\n");
        $templateCache.put("package/manager/gridTemplates/qc-icon-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding qc-icon\" ng-show=\"row.entity.qualityControlFlag\"\n     ng-click=\"grid.appScope.searchController.viewQCNotes(row.entity)\">\n	<qc-note-icon icon-state=\"\'edit\'\"></qc-note-icon>\n</div>\n");
        $templateCache.put("system/categories/editor/categories-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <div class=\"row-no-padding\">\n\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n            <breadcrumb tab-name=\"\'Category Properties\'\"></breadcrumb>\n            <fieldset>\n                <div class=\"edit-full-height edit-view\">\n                    <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n                        <div>\n                            <div class=\"edit-view-container\">\n                                <div class=\"col-md-12 column\">\n                                    <div class=\"row\">\n                                        <div class=\"col-md-2\">\n                                            <div class=\"prism-form-heading\">GENERAL</div>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"row clearfix\">\n                                    <div class=\"row clearfix spacer-top-lg\">\n                                        <div class=\"col-md-12 column\">\n                                            <div class=\"row-no-padding\">\n                                                <form role=\"form\" class=\"form-horizontal\">\n                                                    <div class=\"form-group\">\n                                                        <label class=\"control-label col-md-2\">Name</label>\n                                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                                            <input type=\"text\" class=\"prism-text-input\"\n                                                                   ng-model=\"$ctrl.editData.name\"\n                                                                   id=\"nameInput\"/>\n                                                        </div>\n                                                        <div class=\"required-text-input\" required\n                                                             x-required-indicator></div>\n                                                    </div>\n                                                    <div class=\"form-group\" ng-if=\"$ctrl.allowCategoryTypeEdit\">\n                                                        <label class=\"control-label col-md-2\">Type</label>\n                                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                                            <dropdown-select id=\"typeDropdown\"\n                                                                             ng-model=\"$ctrl.editData.type\"\n                                                                             clearable=\"true\"\n                                                                             btn-min-width=\"200\"\n                                                                             btn-max-width=\"275\"\n                                                                             prompt=\"Select Category Type\"\n                                                                             label-field=\"name\"\n                                                                             collection=\"$ctrl.availableCategoryTypes\">\n                                                            </dropdown-select>\n                                                            <span class=\"required-text-input\"\n                                                                  required\n                                                                  x-required-indicator>\n                                                             </span>\n                                                        </div>\n                                                    </div>\n\n                                                    <div class=\"form-group\" ng-if=\"!$ctrl.allowCategoryTypeEdit\">\n                                                        <label class=\"control-label col-md-2\">Type</label>\n                                                        <div class=\"col-sm-9\">\n                                                            <span class=\"form-control-static\" id=\"typeName\">\n                                                                {{$ctrl.editData.type.name}}</span>\n                                                        </div>\n                                                    </div>\n\n                                                    <div class=\"form-group\">\n                                                        <label for=\"cloneableCheckbox\"\n                                                               class=\"col-sm-2 control-label\">Cloneable</label>\n                                                        <div class=\"col-sm-1 partner-nielsen-enabled-cb\">\n                                                            <input type=\"checkbox\"\n                                                                   id=\"cloneableCheckbox\"\n                                                                   ng-model=\"$ctrl.editData.cloneable\"/>\n                                                            <label for=\"cloneableCheckbox\">&nbsp;</label>\n                                                        </div>\n                                                    </div>\n\n                                                    <div class=\"form-group\">\n                                                        <label for=\"adPodEnabledForUpLynkCheckbox\"\n                                                               class=\"col-sm-2 control-label\">AD POD Enabled For\n                                                            UpLynk</label>\n                                                        <div class=\"col-sm-1 partner-nielsen-enabled-cb\">\n                                                            <input type=\"checkbox\"\n                                                                   id=\"adPodEnabledForUpLynkCheckbox\"\n                                                                   ng-model=\"$ctrl.editData.adPodEnabledForUpLynk\"/>\n                                                            <label for=\"adPodEnabledForUpLynkCheckbox\">&nbsp;</label>\n                                                        </div>\n                                                    </div>\n                                                    <div class=\"form-group\">\n                                                        <label class=\"control-label col-md-2\">AD POD Profile</label>\n                                                        <div class=\"col-sm-9\">\n                                                            <span class=\"form-control-static\">\n                                                                <dropdown-select id=\"adPodAcceptProfileDropdown\"\n                                                                                 ng-model=\"$ctrl.editData.adPodAcceptProfile\"\n                                                                                 clearable=\"true\"\n                                                                                 btn-min-width=\"200\"\n                                                                                 btn-max-width=\"275\"\n                                                                                 prompt=\"Select AD Pod Profile\"\n                                                                                 label-field=\"name\"\n                                                                                 collection=\"$ctrl.availableAdPodProfiles\">\n                                                                </dropdown-select>\n                                                            </span>\n                                                        </div>\n                                                    </div>\n\n                                                    <div class=\"form-group\">\n                                                        <label class=\"control-label col-md-2\">Aliases</label>\n                                                        <div class=\"col-sm-6 pad-text-input-col\">\n                                                            <button id=\"launchPartnerSelectionModalButton\"\n                                                                    type=\"button\"\n                                                                    class=\"btn btn-default prism-button\"\n                                                                    uib-tooltip=\"Create new Partner Aliases\"\n                                                                    data-tooltip-append-to-body=\"true\"\n                                                                    ng-click=\"$ctrl.addAlias()\">\n                                                                <i class=\"fa fa-plus\"></i>\n                                                            </button>\n                                                            <button id=\"deleteSelectedPartnerAliasesButton\"\n                                                                    type=\"button\"\n                                                                    class=\"btn btn-default prism-button\"\n                                                                    uib-tooltip=\"Remove alias(es)\"\n                                                                    data-tooltip-append-to-body=\"true\"\n                                                                    ng-disabled=\"!$ctrl.gridApi.selection.getSelectedRows().length\"\n                                                                    ng-click=\"$ctrl.removeAlias()\">\n                                                                <i class=\"fa fa-minus\"></i>\n                                                            </button>\n                                                            <br>\n                                                            <br>\n                                                            <div id=\"partnerAliasesGrid\"\n                                                                 class=\"inline-edit-grid grid search-grid\"\n                                                                 ui-grid=\"$ctrl.gridOptions\"\n                                                                 ui-grid-selection\n                                                                 ui-grid-edit\n                                                                 style=\"max-height: 225px;\"\n                                                                 ui-grid-resize-columns>\n                                                            </div>\n                                                        </div>\n                                                    </div>\n                                                </form>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n\n                            </div>\n\n                            <hr />\n\n                            <translatable-metadata\n                                    fields=\"$ctrl.translatableMetadataFields\">\n                            </translatable-metadata>\n                        </div>\n                    </form>\n                </div>\n            </fieldset>\n            <div class=\"row-no-padding manager-toolbar\">\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\" pagination-defs=\"$ctrl.paginationDefs\"></toolbar>\n            </div>\n        </div>\n        <div class=\"loadingIndicator\">\n            <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                 ng-show=\"$ctrl.loadingIndicator.show\">\n            </div>\n        </div>\n    </div>\n\n</div>\n\n");
        $templateCache.put("system/contacts/editView/contacts-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <div class=\"row-no-padding\">\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n\n            <div class=\"loadingIndicator\">\n                <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                     ng-show=\"$ctrl.loadingIndicator.show\">\n                </div>\n            </div>\n\n            <div class=\"row\">\n                <div class=\"col-md-12\">\n                    <breadcrumb tab-name=\"$ctrl.getBreadcrumbName()\"></breadcrumb>\n\n                    <fieldset>\n                        <div class=\"edit-full-height-no-tabs edit-view\">\n                            <form class=\"form-horizontal\"\n                                  role=\"form\"\n                                  name=\"$ctrl.editorForm\">\n\n                                <div class=\"edit-view-container\">\n                                    <div ng-include=\"\'system/contacts/editView/renderers/contacts-editor-general-section-template.html\'\"></div>\n                                </div>\n\n                                <hr/>\n\n                                <div class=\"edit-view-container\">\n                                    <div ng-include=\"\'system/contacts/editView/renderers/contacts-editor-management-section-template.html\'\"></div>\n                                </div>\n\n                            </form>\n                        </div>\n                    </fieldset>\n                </div>\n            </div>\n\n            <!-- Toolbar -->\n            <div class=\"row-no-padding manager-toolbar\">\n                <div>\n                    <toolbar button-defs=\"$ctrl.toolbarButtonDefs\">\n                    </toolbar>\n                </div>\n            </div>\n\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/contacts/searchView/contacts-search-view-template.html", "<div class=\"container-fluid no-padding\">\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <div class=\"row-no-padding\">\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n\n            <!-- Pacifier -->\n            <div class=\"loadingIndicator\">\n                <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                     ng-show=\"$ctrl.loadingIndicator.show\"></div>\n            </div>\n\n            <!-- Grid -->\n            <div id=\"contactsSearchViewGrid\"\n                 class=\"grid search-grid\"\n                 ui-grid=\"$ctrl.gridOptions\"\n                 ui-grid-selection>\n            </div>\n\n            <!-- Toolbar -->\n            <toolbar\n                button-defs=\"$ctrl.toolbarButtonDefs\"\n                right-hand-checkbox-defs=\"$ctrl.toolbarCheckboxDefs\"\n                pagination-defs=\"$ctrl.paginationDefs\">\n            </toolbar>\n\n        </div>\n\n    </div>\n</div>\n");
        $templateCache.put("system/deliveryTemplate/editor/delivery-template-edit-template.html", "<div class=\"container-fluid no-padding\">\n\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <div class=\"row-no-padding\">\n\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n            <breadcrumb tab-name=\"$ctrl.editData.name\"></breadcrumb>\n            <fieldset ng-disabled=\"$ctrl.editData.custom\">\n                <div class=\"edit-full-height edit-view\">\n                    <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n                        <uib-tabset horizontal=\"true\" type=\"pills\" class=\"edit-view-tabbar\">\n                            <uib-tab heading=\"Properties\" active=\"true\">\n                                <div class=\"col-md-12 col-lg-12 edit-full-height\">\n                                    <fieldset>\n                                        <div class=\"row edit-full-height edit-view\">\n                                            <div class=\"edit-view-container\">\n                                                <div class=\"row clearfix\">\n                                                    <div class=\"col-md-12 column\">\n                                                        <div class=\"row\">\n                                                            <div class=\"col-md-2\">\n                                                                <div class=\"prism-form-heading\">General</div>\n                                                            </div>\n                                                        </div>\n                                                    </div>\n                                                    <div class=\"row clearfix spacer-top-lg\">\n                                                        <div class=\"col-md-12 column\">\n                                                            <form class=\"form-horizontal\" role=\"form\"\n                                                                  name=\"$ctrl.editorForm\">\n                                                                <div class=\"form-group\">\n                                                                    <label for=\"deliveryTemplateName\"\n                                                                           class=\"col-sm-2 control-label\">Name</label>\n                                                                    <div class=\"col-sm-4 pad-text-input-col\">\n                                                                        <input type=\"text\" id=\"deliveryTemplateName\"\n                                                                               class=\"form-control prism-text-input\"\n                                                                               autocomplete=\"off\"\n                                                                               ng-model=\"$ctrl.editData.name\"\n                                                                               required/>\n                                                                    </div>\n                                                                    <div class=\"required-text-input\"\n                                                                         required\n                                                                         x-required-indicator></div>\n                                                                </div>\n                                                                <div class=\"form-group\">\n                                                                    <label for=\"audioCheckbox\"\n                                                                           class=\"col-sm-2 prism-form-item-label text-align-right\">\n                                                                        Audio\n                                                                    </label>\n                                                                    <div class=\"col-sm-1\">\n                                                                        <input type=\"checkbox\" id=\"audioCheckbox\"\n                                                                               ng-model=\"$ctrl.editData.audio\"/>\n                                                                        <label for=\"audioCheckbox\"></label>\n                                                                    </div>\n\n                                                                    <label for=\"metadataCheckbox\"\n                                                                           class=\"col-sm-2 prism-form-item-label text-align-right\">\n                                                                        Metadata\n                                                                    </label>\n                                                                    <div class=\"col-sm-1\">\n                                                                        <input type=\"checkbox\" id=\"metadataCheckbox\"\n                                                                               ng-model=\"$ctrl.editData.metadata\"/>\n                                                                        <label for=\"metadataCheckbox\"></label>\n                                                                    </div>\n                                                                </div>\n                                                                <div class=\"form-group\">\n                                                                    <label for=\"artworkCheckbox\"\n                                                                           class=\"col-sm-2 prism-form-item-label text-align-right\">\n                                                                        Artwork\n                                                                    </label>\n                                                                    <div class=\"col-sm-1\">\n                                                                        <input type=\"checkbox\" id=\"artworkCheckbox\"\n                                                                               ng-model=\"$ctrl.editData.artwork\"/>\n                                                                        <label for=\"artworkCheckbox\"></label>\n                                                                    </div>\n                                                                    <label for=\"subtitleCheckbox\"\n                                                                           class=\"col-sm-2 prism-form-item-label text-align-right\">\n                                                                        Subtitle\n                                                                    </label>\n                                                                    <div class=\"col-sm-1\">\n                                                                        <input type=\"checkbox\" id=\"subtitleCheckbox\"\n                                                                               ng-model=\"$ctrl.editData.subtitle\"/>\n                                                                        <label for=\"subtitleCheckbox\"></label>\n                                                                    </div>\n                                                                </div>\n                                                                <div class=\"form-group\">\n                                                                    <label for=\"closedCaptionCheckbox\"\n                                                                           class=\"col-sm-2 prism-form-item-label text-align-right\">\n                                                                        Closed Caption\n                                                                    </label>\n                                                                    <div class=\"col-sm-1\">\n                                                                        <input type=\"checkbox\"\n                                                                               id=\"closedCaptionCheckbox\"\n                                                                               ng-model=\"$ctrl.editData.closedCaption\"/>\n                                                                        <label for=\"closedCaptionCheckbox\"></label>\n                                                                    </div>\n                                                                    <label for=\"videoCheckbox\"\n                                                                           class=\"col-sm-2 prism-form-item-label text-align-right\">\n                                                                        Video\n                                                                    </label>\n                                                                    <div class=\"col-sm-1\">\n                                                                        <input type=\"checkbox\" id=\"videoCheckbox\"\n                                                                               ng-model=\"$ctrl.editData.video\"/>\n                                                                        <label for=\"videoCheckbox\"></label>\n                                                                    </div>\n                                                                </div>\n                                                                <div class=\"form-group\">\n                                                                    <label for=\"imageCheckbox\"\n                                                                           class=\"col-sm-2 prism-form-item-label text-align-right\">\n                                                                        Image\n                                                                    </label>\n                                                                    <div class=\"col-sm-1\">\n                                                                        <input type=\"checkbox\" id=\"imageCheckbox\"\n                                                                               ng-model=\"$ctrl.editData.image\"/>\n                                                                        <label for=\"imageCheckbox\"></label>\n                                                                    </div>\n                                                                </div>\n                                                                <div class=\"form-group\">\n                                                                    <div class=\"col-sm-2\"></div>\n                                                                    <div class=\"col-sm-8\">\n                                                                        <label class=\"under-field-hint pull-left\" ng-if=\"$ctrl.editData.custom\"><i class=\"fa fa-warning\"></i> Cannot\n                                                                            Edit Custom Delivery Templates</label>\n                                                                    </div>\n                                                                </div>\n                                                                <div class=\"form-group\">\n                                                                </div>\n                                                                <div class=\"form-group\">\n                                                                </div>\n                                                            </form>\n                                                        </div>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </fieldset>\n                                </div>\n                            </uib-tab>\n                        </uib-tabset>\n\n                    </form>\n                </div>\n            </fieldset>\n            <div class=\"row-no-padding manager-toolbar\">\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\" pagination-defs=\"$ctrl.paginationDefs\"></toolbar>\n            </div>\n        </div>\n        <div class=\"loadingIndicator\">\n            <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                 ng-show=\"$ctrl.loadingIndicator.show\">\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/dynamicProperties/editor/dynamic-property-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <div class=\"row-no-padding\">\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n            <div class=\"loadingIndicator\">\n                <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                     ng-show=\"$ctrl.loadingIndicator.show\">\n                </div>\n            </div>\n            <breadcrumb tab-name=\"$ctrl.editData.name\"></breadcrumb>\n\n            <fieldset>\n                <div class=\"edit-full-height edit-view\">\n                    <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n                        <div class=\"edit-view-container\">\n                            <div class=\"col-md-12 column\">\n                                <div class=\"row\">\n                                    <div class=\"col-md-2\">\n                                        <div class=\"prism-form-heading\">General</div>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class=\"row clearfix\">\n                                <div class=\"row clearfix spacer-top-lg\">\n                                    <div class=\"col-md-12 column\">\n                                        <div class=\"row-no-padding\">\n                                            <form role=\"form\" class=\"form-horizontal\">\n\n\n                                                <div class=\"form-group\"\n                                                     ng-if=\"$ctrl.isCreatingProperty()\">\n                                                    <label class=\"control-label col-md-2\"\n                                                           for=\"nameInput\">Name</label>\n                                                    <div class=\"col-sm-9 pad-text-input-col\">\n                                                        <input type=\"text\" class=\"prism-text-input\"\n                                                               ng-model=\"$ctrl.editData.name\"\n                                                               id=\"nameInput\"\n                                                               required/>\n                                                    </div>\n                                                    <div class=\"required-text-input\"\n                                                         required\n                                                         x-required-indicator></div>\n                                                </div>\n                                                <div class=\"form-group\"\n                                                     ng-if=\"!$ctrl.isCreatingProperty()\">\n                                                    <label class=\"control-label col-md-2\">\n                                                        Name</label>\n                                                    <div class=\"col-sm-9 pad-text-input-col\">\n                                                        {{$ctrl.editData.name}}\n                                                    </div>\n                                                </div>\n\n\n                                            </form>\n                                        </div>\n                                    </div>\n                                    <div class=\"col-md-12 column\">\n                                        <div class=\"row-no-padding\">\n                                            <form role=\"form\" class=\"form-horizontal\">\n\n\n                                                <div class=\"form-group\">\n                                                    <label class=\"control-label col-md-2\"\n                                                           for=\"valueInput\">Value</label>\n                                                    <div class=\"col-sm-9 pad-text-input-col\">\n                                                        <textarea id=\"valueInput\"\n                                                                  class=\"form-control prism-text-input\"\n                                                                  ng-if=\"!$ctrl.editData || !$ctrl.editData.hasConfidentialInfo\"\n                                                                  rows=\"7\"\n                                                                  ng-model=\"$ctrl.editData.value\"></textarea>\n                                                        <input id=\"valueInput\"\n                                                               ng-if=\"$ctrl.editData && $ctrl.editData.hasConfidentialInfo\"\n                                                               type=\"password\"\n                                                               class=\"form-control prism-text-input\"\n                                                               ng-model=\"$ctrl.editData.value\"/>\n                                                    </div>\n                                                    <div class=\"required-text-input\"\n                                                         required\n                                                         x-required-indicator></div>\n                                                </div>\n\n\n                                            </form>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </fieldset>\n\n            <div class=\"row-no-padding manager-toolbar\">\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"></toolbar>\n            </div>\n        </div>\n    </div>\n\n</div>\n\n");
        $templateCache.put("system/emailTemplate/editor/email-template-edit-template.html", "<div class=\"container-fluid no-padding\">\n\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <div class=\"row-no-padding\">\n\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n            <breadcrumb tab-name=\"$ctrl.editData.name\"></breadcrumb>\n            <fieldset>\n                <div class=\"edit-full-height edit-view\">\n                    <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n                        <uib-tabset horizontal=\"true\" type=\"pills\" class=\"edit-view-tabbar\">\n                            <uib-tab heading=\"Properties\" active=\"true\">\n                                <div class=\"col-md-12 col-lg-12 edit-full-height\">\n                                    <fieldset>\n                                        <div class=\"row edit-full-height edit-view\">\n                                            <div class=\"edit-view-container\">\n                                                <div class=\"row clearfix\">\n                                                    <div class=\"col-md-12 column\">\n                                                        <div class=\"row\">\n                                                            <div class=\"col-md-2\">\n                                                                <div class=\"prism-form-heading\">General</div>\n                                                            </div>\n                                                        </div>\n                                                    </div>\n                                                    <div class=\"row clearfix spacer-top-lg\">\n                                                        <div class=\"col-md-12 column\">\n                                                            <form class=\"form-horizontal\" role=\"form\"\n                                                                  name=\"$ctrl.editorForm\">\n                                                                <div class=\"form-group\">\n                                                                    <label for=\"emailTemplateName\"\n                                                                           class=\"col-sm-2 control-label\">Name</label>\n                                                                    <div class=\"col-sm-4 pad-text-input-col\">\n                                                                        <input type=\"text\" id=\"emailTemplateName\"\n                                                                               class=\"form-control prism-text-input\"\n                                                                               autocomplete=\"off\"\n                                                                               ng-model=\"$ctrl.editData.name\"\n                                                                               required/>\n                                                                    </div>\n                                                                    <div class=\"required-text-input\"\n                                                                         required\n                                                                         x-required-indicator></div>\n                                                                </div>\n                                                                <div class=\"form-group\">\n                                                                    <label for=\"emailTemplateTemplateText\"\n                                                                           class=\"col-sm-2 control-label\">Template</label>\n                                                                    <div class=\"col-sm-8 pad-text-input-col\">\n                                                                    <textarea type=\"text\" id=\"emailTemplateTemplateText\"\n                                                                              class=\"prism-text-input form-control\"\n                                                                              rows=\"35\"\n                                                                              autocomplete=\"off\"\n                                                                              ng-model=\"$ctrl.editData.templateText\"> </textarea>\n                                                                    </div>\n                                                                </div>\n                                                            </form>\n                                                        </div>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </fieldset>\n                                </div>\n                            </uib-tab>\n                        </uib-tabset>\n                    </form>\n                </div>\n            </fieldset>\n            <div class=\"row-no-padding manager-toolbar\">\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\" pagination-defs=\"$ctrl.paginationDefs\"></toolbar>\n            </div>\n        </div>\n        <div class=\"loadingIndicator\">\n            <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                 ng-show=\"$ctrl.loadingIndicator.show\">\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/execServers/searchView/exec-servers-search-template.html", "<div class=\"row-no-padding\">\n	<div class=\"col-md-12 col-lg-12\">\n		<div class=\"loadingIndicator\">\n			<div data-lb-progress=\"$ctrl.loadingIndicator\"\n				 ng-show=\"$ctrl.loadingIndicator.show\">\n			</div>\n		</div>\n		<div ui-grid=\"$ctrl.currentGridOptions\" class=\"grid search-grid\" ui-grid-selection ui-grid-pagination\n			 ui-grid-resize-columns id=\"execServersSearchGrid\"></div>\n	</div>\n\n	<!-- ****FOR FUTURE PAGINATION IF NEEDED****\n	<div class=\"row-no-padding manager-toolbar\">\n		<div class=\"col-md-12 col-lg-12\">\n			<form class=\"form-inline toolbar-top-padding-sm\">\n				<div class=\"form-group pull-right\">\n					<pagination-controls prev-page-handler=\"$ctrl.paginationPrevPageHandler()\"\n										 next-page-handler=\"$ctrl.paginationNextPageHandler()\"\n										 jump-to-page-handler=\"$ctrl.paginationJumpToPageHandler()\"\n										 paging-options=\"$ctrl.pagingOptions\" class=\"form-group\">\n					</pagination-controls>\n				</div>\n			</form>\n		</div>\n	</div>\n	-->\n\n</div>\n");
        $templateCache.put("system/externalMetadata/logging/external-metadata-package-link-cell-template.html", "<div\n    class=\"ui-grid-cell-contents ng-scope ng-binding\"\n    data-tooltip-append-to-body=\"true\"\n    ng-click=\"grid.appScope.$ctrl.onPackageIdClicked(COL_FIELD)\"\n    uib-tooltip=\"{{COL_FIELD}}\"\n>\n    <span>\n        {{COL_FIELD}}\n        <package-link-icon\n                ng-if=\"COL_FIELD && COL_FIELD.length > 0 && COL_FIELD !== \'-1\'\"\n                id=\"packageLinkIcon{{COL_FIELD}}\"\n                package-id=\"COL_FIELD\"\n                on-navigation-started=\"grid.appScope.$ctrl.onPackageNavigationStarted()\"\n                on-navigation-ended=\"grid.appScope.$ctrl.onPackageNavigationEnded()\"\n        ></package-link-icon>\n    </span>\n</div>\n");
        $templateCache.put("system/externalMetadata/logging/external-metadata-system-logging-template.html", "<div class=\"col-md-12 col-lg-12 no-padding\">\n\n	<div class=\"loadingIndicator\">\n		<div data-lb-progress=\"$ctrl.loadingIndicator\" ng-show=\"$ctrl.loadingIndicator.show\"></div>\n	</div>\n\n	<div id=\"loggingGrid\"\n		 class=\"grid search-grid\"\n		 ui-grid=\"$ctrl.gridOptions\"\n		 ui-grid-selection\n		 ui-grid-pagination\n		 ui-grid-resize-columns>\n	</div>\n\n	<toolbar pagination-defs=\"$ctrl.paginationDefs\"></toolbar>\n\n</div>\n");
        $templateCache.put("system/externalMetadata/queue/external-metadata-queue-template.html", "<div class=\"col-md-12 col-lg-12 no-padding\">\n    <div class=\"loadingIndicator\">\n        <div data-lb-progress=\"$ctrl.loadingIndicator\" ng-show=\"$ctrl.loadingIndicator.show\"></div>\n    </div>\n\n\n    <div id=\"queueGrid\"\n         class=\"grid search-grid\"\n         ui-grid=\"$ctrl.gridOptions\"\n         ui-grid-selection\n         ui-grid-resize-columns>\n    </div>\n\n    <toolbar button-defs=\"$ctrl.toolbarButtonDefs\" pagination-defs=\"$ctrl.paginationDefs\"></toolbar>\n\n</div>\n");
        $templateCache.put("system/fileSystem/editView/file-system-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n\n    <!-- Navigation/search toolbar -->\n    <div class=\"row-no-padding\">\n        <navbar search-enabled=\"$ctrl.currentTab === \'directories\'\"></navbar>\n    </div>\n\n    <!-- Main -->\n    <div class=\"row-no-padding\">\n        <!-- Sidebar -->\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <!-- Content pane -->\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n\n            <!-- Tab component -->\n            <div class=\"row-no-padding\">\n                <breadcrumb tab-name=\"$ctrl.getBreadcrumbName()\"></breadcrumb>\n                <uib-tabset horizontal=\"true\"\n                            type=\"pills\"\n                            class=\"edit-view-tabbar\"\n                            active=\"$ctrl.currentTab\">\n\n                    <!-- Properties -->\n                    <uib-tab heading=\"{{\'Properties\'}}\"\n                             index=\"\'properties\'\"\n                             select=\"$ctrl.onTabSelect(\'properties\')\"\n                             deselect=\"$ctrl.onTabDeselect($event)\">\n                        <div ng-if=\"$ctrl.currentTab === \'properties\'\">\n                            <file-system-properties-view\n                                class=\"col-md-12 col-lg-12 edit-full-height\">\n                            </file-system-properties-view>\n                        </div>\n                    </uib-tab>\n\n                    <!-- Directories -->\n                    <uib-tab ng-if=\"!$ctrl.editingNewFileSystem()\"\n                             heading=\"{{\'Directories\'}}\"\n                             index=\"\'directories\'\"\n                             select=\"$ctrl.onTabSelect(\'directories\')\"\n                             deselect=\"$ctrl.onTabDeselect($event)\">\n                        <div ng-if=\"$ctrl.currentTab === \'directories\'\">\n                            <directory-search-view>\n                            </directory-search-view>\n                        </div>\n                    </uib-tab>\n                </uib-tabset>\n            </div>\n\n        </div>\n    </div>\n\n</div>\n");
        $templateCache.put("system/fileSystem/searchView/file-system-search-view-template.html", "<div>\n    <div class=\"container-fluid no-padding\">\n        <div class=\"row-no-padding\">\n            <navbar></navbar>\n        </div>\n\n        <div class=\"row-no-padding\">\n            <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n            <div class=\"col-md-10 col-lg-10 content-pane\">\n\n                <div class=\"loadingIndicator\">\n                    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                         ng-show=\"$ctrl.loadingIndicator.show\">\n                    </div>\n                </div>\n\n                <div id=\"fileSystemsGrid\"\n                     class=\"grid search-grid\"\n                     ui-grid=\"$ctrl.gridOptions\"\n                     ui-grid-selection\n                     ui-grid-pagination>\n                </div>\n\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"\n                         pagination-defs=\"$ctrl.paginationDefs\">\n                </toolbar>\n\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/groups/editor/group-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <div class=\"row-no-padding\">\n\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <div class=\"col-md-12 col-lg-12 content-pane\">\n\n            <div class=\"row-no-padding\">\n                <breadcrumb tab-name=\"$ctrl.getBreadcrumbName()\"></breadcrumb>\n\n                <uib-tabset horizontal=\"true\"\n                            type=\"pills\"\n                            class=\"edit-view-tabbar\"\n                            active=\"$ctrl.currentTab\">\n\n                    <!-- Group Properties -->\n                    <uib-tab heading=\"Group Properties\"\n                             index=\"\'properties\'\"\n                             select=\"$ctrl.setActiveTab(\'properties\')\">\n                        <group-properties-edit-view\n                            is-admin=\"$ctrl.isAdmin\"\n                            class=\"col-md-12 col-lg-12 edit-full-height no-padding\">\n                        </group-properties-edit-view>\n                    </uib-tab>\n\n                    <!-- Group Members -->\n                    <uib-tab heading=\"Group Members\"\n                             index=\"\'members\'\"\n                             select=\"$ctrl.setActiveTab(\'members\')\">\n                        <group-member-search-view\n                            is-admin=\"$ctrl.isAdmin\"\n                            class=\"col-md-12 col-lg-12 no-padding\">\n                        </group-member-search-view>\n                    </uib-tab>\n\n                </uib-tabset>\n\n            </div>\n\n        </div>\n\n    </div>\n\n</div>\n");
        $templateCache.put("system/groups/modals/groups-exception-modal-template.html", "<div class=\"modal-header\">\n    <h5 class=\"modal-title\">{{ $ctrl.resolve.exceptionPermission.name }} Exception</h5>\n</div>\n\n<div class=\"modal-body\">\n    <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.modalForm\">\n\n        <div class=\"row-no-padding\">\n            <div class=\"form-group\">\n\n                <label class=\"col-sm-4 col-md-offset-1 control-label\">\n                    Content\n                </label>\n\n                <div class=\"col-sm-7 padding-left-md\">\n                    <input type=\"radio\"\n                           id=\"seriesRadio\"\n                           ng-change=\"$ctrl.exception.content = null\"\n                           ng-model=\"$ctrl.contentType\"\n                           ng-value=\"\'Series\'\">\n                    <label class=\"control-label\"\n                           for=\"seriesRadio\">\n                        Series\n                    </label>\n\n                    <input type=\"radio\"\n                           id=\"movieRadio\"\n                           ng-change=\"$ctrl.exception.content = null\"\n                           ng-model=\"$ctrl.contentType\"\n                           ng-value=\"\'Movie\'\">\n                    <label class=\"control-label\"\n                           for=\"movieRadio\">\n                        Movie/Special\n                    </label>\n\n                </div>\n            </div>\n        </div>\n\n        <div class=\"row spacer-top-xsm padding-bottom-xsm\">\n            <div class=\"form-group no-margin-bottom\">\n\n                <label for=\"seriesDropdown\"\n                       class=\"col-md-4 col-md-offset-1 control-label\"\n                       ng-if=\"$ctrl.contentType === \'Series\'\">\n                    Series\n                </label>\n                <div class=\"col-md-4 metadata-control-col\"\n                     ng-if=\"$ctrl.contentType === \'Series\'\">\n                    <dropdown-select id=\"seriesDropdown\"\n                                     btn-min-width=\"200\"\n                                     clearable=\"true\"\n                                     collection=\"$ctrl.resolve.series\"\n                                     label-field=\"name\"\n                                     ng-model=\"$ctrl.exception.content\"\n                                     prompt=\"Select Series\">\n                    </dropdown-select>\n                </div>\n\n                <label for=\"movieDropdown\"\n                       class=\"col-md-4 col-md-offset-1 control-label\"\n                       ng-if=\"$ctrl.contentType === \'Movie\'\">\n                    Movie/Special\n                </label>\n                <div class=\"col-md-4 metadata-control-col\"\n                     ng-if=\"$ctrl.contentType === \'Movie\'\">\n                    <dropdown-select id=\"movieDropdown\"\n                                     btn-min-width=\"200\"\n                                     clearable=\"true\"\n                                     collection=\"$ctrl.resolve.movies\"\n                                     label-field=\"name\"\n                                     ng-model=\"$ctrl.exception.content\"\n                                     prompt=\"Select Movie/Special\">\n                    </dropdown-select>\n                </div>\n\n                <label for=\"categoryDropdown\" class=\"col-md-4 col-md-offset-1 control-label\">\n                    Categories\n                </label>\n                <div class=\"col-md-4 metadata-control-col\">\n                    <multiselect-dropdown id=\"categoryDropdown\"\n                                     btn-min-width=\"200\"\n                                     clearable=\"true\"\n                                     collection=\"$ctrl.resolve.categories\"\n                                     label-field=\"name\"\n                                     ng-model=\"$ctrl.exception.categories\"\n                                     prompt=\"Select Categories\">\n                    </multiselect-dropdown>\n                </div>\n\n            </div>\n        </div>\n\n        <div class=\"row spacer-top-xsm padding-bottom-xsm\">\n            <div class=\"form-group no-margin-bottom\">\n\n                <label for=\"offsetInput\"\n                       class=\"col-md-4 col-md-offset-1 control-label\"\n                       ng-if=\"$ctrl.includeOffset\">\n                    Exception Offset Minutes\n                </label>\n                <div class=\"col-md-2\"\n                     ng-if=\"$ctrl.includeOffset\">\n\n                    <input type=\"number\"\n                           class=\"prism-text-input\"\n                           id=\"offsetInput\"\n                           name=\"offsetStepper\"\n                           min=\"-10000\"\n                           max=\"10000\"\n                           step=\"1\"\n                           pattern=\"-?\\d*\"\n                           ng-model=\"$ctrl.exception.proxyReleaseOffsetInMinutes\"/>\n\n                </div>\n\n                <label for=\"offsetInput\"\n                       class=\"control-label exception-offset-label\">\n                    *Offset is relative to ORD + air time.\n                </label>\n\n            </div>\n        </div>\n\n    </form>\n</div>\n\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default\" ng-click=\"$ctrl.dismiss()\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.closeHandler()\">\n        OK\n    </button>\n</div>\n");
        $templateCache.put("system/groups/searchView/groups-search-view-template.html", "<div>\n    <div class=\"container-fluid no-padding\">\n        <div class=\"row-no-padding\">\n            <navbar></navbar>\n        </div>\n\n        <div class=\"row-no-padding\">\n            <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n            <div class=\"col-md-10 col-lg-10 content-pane\"\n                 ng-if=\"$ctrl.isAdmin\">\n\n                <div class=\"loadingIndicator\">\n                    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                         ng-show=\"$ctrl.loadingIndicator.show\">\n                    </div>\n                </div>\n\n                <div id=\"groupsGrid\"\n                     class=\"grid search-grid\"\n                     ui-grid=\"$ctrl.gridOptions\"\n                     ui-grid-selection\n                     ui-grid-pagination\n                     ui-grid-resize-columns>\n                </div>\n\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"\n                         pagination-defs=\"$ctrl.paginationDefs\">\n                </toolbar>\n\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/genres/editor/genres-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <div class=\"row-no-padding\">\n\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n            <div class=\"loadingIndicator\">\n                <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                     ng-show=\"$ctrl.loadingIndicator.show\">\n                </div>\n            </div>\n            <breadcrumb tab-name=\"$ctrl.editData.name\"></breadcrumb>\n            <fieldset>\n                <div class=\"edit-full-height edit-view\">\n                    <form class=\"form-horizontal\" name=\"$ctrl.editorForm\">\n                        <div>\n                            <div class=\"edit-view-container\">\n                                <div class=\"col-md-12 column\">\n                                    <div class=\"row\">\n                                        <div class=\"col-md-2\">\n                                            <div class=\"prism-form-heading\">GENERAL</div>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"row clearfix\">\n                                    <div class=\"row clearfix spacer-top-lg\">\n                                        <div class=\"col-md-12 column\">\n                                            <div class=\"row-no-padding\">\n                                                <form role=\"form\" class=\"form-horizontal\">\n                                                    <div class=\"form-group\">\n                                                        <label class=\"control-label col-md-2\">Name</label>\n                                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                                            <input type=\"text\" class=\"prism-text-input\"\n                                                                   ng-model=\"$ctrl.editData.name\"\n                                                                   id=\"nameInput\"/>\n                                                        </div>\n                                                        <div class=\"required-text-input\"\n                                                             required\n                                                             x-required-indicator></div>\n                                                    </div>\n\n                                                    <div class=\"form-group\">\n                                                        <label class=\"control-label col-md-2\">Aliases</label>\n                                                        <div class=\"col-sm-6 pad-text-input-col\">\n                                                            <button id=\"launchPartnerSelectionModalButton\"\n                                                                    type=\"button\"\n                                                                    class=\"btn btn-default prism-button\"\n                                                                    uib-tooltip=\"Create new Partner Aliases\"\n                                                                    data-tooltip-append-to-body=\"true\"\n                                                                    ng-click=\"$ctrl.addAlias()\">\n                                                                <i class=\"fa fa-plus\"></i>\n                                                            </button>\n                                                            <button id=\"deleteSelectedPartnerAliasesButton\"\n                                                                    type=\"button\"\n                                                                    class=\"btn btn-default prism-button\"\n                                                                    uib-tooltip=\"Remove alias(es)\"\n                                                                    data-tooltip-append-to-body=\"true\"\n                                                                    ng-disabled=\"!$ctrl.gridApi.selection.getSelectedRows().length\"\n                                                                    ng-click=\"$ctrl.removeAlias()\">\n                                                                <i class=\"fa fa-minus\"></i>\n                                                            </button>\n                                                            <br>\n                                                            <br>\n                                                            <div id=\"partnerAliasesGrid\"\n                                                                 class=\"inline-edit-grid grid search-grid\"\n                                                                 ui-grid=\"$ctrl.gridOptions\"\n                                                                 ui-grid-selection\n                                                                 ui-grid-edit\n                                                                 style=\"max-height: 225px;\"\n                                                                 ui-grid-resize-columns>\n                                                            </div>\n\n                                                        </div>\n                                                    </div>\n\n                                                </form>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <hr />\n\n                            <translatable-metadata\n                                    fields=\"$ctrl.translatableMetadataFields\">\n                            </translatable-metadata>\n                        </div>\n                    </form>\n                </div>\n            </fieldset>\n            <div class=\"row-no-padding manager-toolbar\">\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\" pagination-defs=\"$ctrl.paginationDefs\"></toolbar>\n            </div>\n        </div>\n    </div>\n\n</div>\n\n");
        $templateCache.put("system/languages/editor/languages-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <div class=\"row-no-padding\">\n\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n            <breadcrumb tab-name=\"$ctrl.editData.name\"></breadcrumb>\n            <fieldset>\n                <div class=\"edit-full-height edit-view\">\n                    <form class=\"form-horizontal\"\n                          role=\"form\"\n                          name=\"$ctrl.editorForm\">\n                        <div class=\"edit-view-container\">\n                            <div class=\"col-md-12 column\">\n                                <div class=\"row\">\n                                    <div class=\"col-md-2\">\n                                        <div class=\"prism-form-heading\">General</div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"row clearfix\">\n                                <div class=\"row clearfix spacer-top-lg\">\n                                    <div class=\"col-md-12 column\">\n                                        <div class=\"row-no-padding\">\n                                            <form role=\"form\"\n                                                  class=\"form-horizontal\">\n\n                                                <!-- Name -->\n                                                <div class=\"form-group\">\n                                                    <label class=\"control-label col-md-2\"\n                                                           for=\"nameInput\">\n                                                        Name\n                                                    </label>\n                                                    <div class=\"col-sm-4 pad-text-input-col\">\n                                                        <input\n                                                            type=\"text\"\n                                                            class=\"prism-text-input\"\n                                                            ng-model=\"$ctrl.editData.name\"\n                                                            id=\"nameInput\"/>\n                                                    </div>\n                                                    <div class=\"required-text-input\"\n                                                         required\n                                                         x-required-indicator></div>\n                                                </div>\n\n                                                <!-- AI Translated -->\n                                                <div class=\"form-group\">\n                                                    <div class=\"v-align padding-bottom-xsm\">\n                                                        <label class=\"col-md-2 padding-top-xs control-label\"\n                                                               for=\"aiTranslateCheckbox\">\n                                                            AI Translate\n                                                        </label>\n                                                        <div class=\"col-md-1 padding-top-sm\">\n                                                            <input type=\"checkbox\"\n                                                                   id=\"aiTranslateCheckbox\"\n                                                                   ng-model=\"$ctrl.editData.aITranslate\"/>\n                                                            <label for=\"aiTranslateCheckbox\" class=\"control-label\"></label>\n                                                        </div>\n                                                    </div>\n                                                </div>\n\n                                                <!-- ISO2 Code -->\n                                                <div class=\"form-group\">\n                                                    <label class=\"control-label col-md-2\"\n                                                           for=\"iso2CodeInput\">\n                                                        ISO 639-1\n                                                    </label>\n                                                    <div class=\"col-sm-4 pad-text-input-col\">\n                                                        <input\n                                                            type=\"text\"\n                                                            class=\"prism-text-input text-uppercase\"\n                                                            ng-model=\"$ctrl.editData.iso2Code\"\n                                                            maxlength=\"2\"\n                                                            ng-keydown=\"$ctrl.validateInput($event, $ctrl.editData.iso2Code, \'^[a-zA-Z]+$\')\"\n                                                            id=\"iso2CodeInput\"/>\n                                                        <label class=\"under-field-hint\">(must be 2 characters)</label>\n                                                    </div>\n                                                    <div class=\"required-text-input\"\n                                                         required\n                                                         x-required-indicator></div>\n                                                </div>\n\n                                                <!-- Locale -->\n                                                <div class=\"form-group\">\n                                                    <label class=\"control-label col-md-2\"\n                                                           for=\"localeInput\">\n                                                        Locale\n                                                    </label>\n                                                    <div class=\"col-sm-4 pad-text-input-col\">\n                                                        <input\n                                                                type=\"text\"\n                                                                class=\"prism-text-input\"\n                                                                ng-model=\"$ctrl.editData.locale\"\n                                                                id=\"localeInput\"/>\n                                                    </div>\n                                                </div>\n\n                                                <!-- Vantage Alias -->\n                                                <div class=\"form-group\">\n                                                    <label class=\"control-label col-md-2\"\n                                                           for=\"vantageValueInput\">\n                                                        Telestream Vantage Value\n                                                    </label>\n                                                    <div class=\"col-sm-4 pad-text-input-col\">\n                                                        <input\n                                                            class=\"prism-text-input\"\n                                                            id=\"vantageValueInput\"\n                                                            ng-model=\"$ctrl.editData.vantageValue\"\n                                                            type=\"text\"/>\n                                                    </div>\n                                                </div>\n\n                                                <!-- UpLynk Alias -->\n                                                <div class=\"form-group\">\n                                                    <label class=\"control-label col-md-2\"\n                                                           for=\"uplynkValueInput\">\n                                                        UpLynk Value\n                                                    </label>\n                                                    <div class=\"col-sm-4 pad-text-input-col\">\n                                                        <input\n                                                            class=\"prism-text-input\"\n                                                            id=\"uplynkValueInput\"\n                                                            ng-model=\"$ctrl.editData.upLynkValue\"\n                                                            type=\"text\"/>\n                                                    </div>\n                                                </div>\n\n                                                <!-- Aliases -->\n                                                <div class=\"form-group\">\n                                                    <label class=\"control-label col-md-2\">Aliases</label>\n                                                    <div class=\"col-sm-6 pad-text-input-col\">\n                                                        <button\n                                                            id=\"launchPartnerSelectionModalButton\"\n                                                            type=\"button\"\n                                                            class=\"btn btn-default prism-button\"\n                                                            uib-tooltip=\"Create new Partner Aliases\"\n                                                            data-tooltip-append-to-body=\"true\"\n                                                            ng-click=\"$ctrl.addAlias()\">\n                                                            <i class=\"fa fa-plus\"></i>\n                                                        </button>\n                                                        <button\n                                                            id=\"deleteSelectedPartnerAliasesButton\"\n                                                            type=\"button\"\n                                                            class=\"btn btn-default prism-button\"\n                                                            uib-tooltip=\"Remove alias(es)\"\n                                                            data-tooltip-append-to-body=\"true\"\n                                                            ng-disabled=\"!$ctrl.gridApi.selection.getSelectedRows().length\"\n                                                            ng-click=\"$ctrl.removeAlias()\">\n                                                            <i class=\"fa fa-minus\"></i>\n                                                        </button>\n                                                        <br>\n                                                        <br>\n                                                        <div id=\"partnerAliasesGrid\"\n                                                             class=\"inline-edit-grid grid search-grid\"\n                                                             ui-grid=\"$ctrl.gridOptions\"\n                                                             ui-grid-selection\n                                                             ui-grid-edit\n                                                             style=\"max-height: 605px;\"\n                                                             ui-grid-resize-columns>\n                                                        </div>\n\n                                                    </div>\n                                                </div>\n\n\n                                            </form>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </fieldset>\n            <div class=\"row-no-padding manager-toolbar\">\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"\n                         pagination-defs=\"$ctrl.paginationDefs\"></toolbar>\n            </div>\n        </div>\n        <div class=\"loadingIndicator\">\n            <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                 ng-show=\"$ctrl.loadingIndicator.show\">\n            </div>\n        </div>\n    </div>\n\n</div>\n");
        $templateCache.put("system/livefeed/editor/livefeed-edit-template.html", "<div class=\"container-fluid no-padding\">\n	<div class=\"row-no-padding\">\n		<navbar></navbar>\n	</div>\n	<div class=\"row-no-padding\">\n		<sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n		<div class=\"col-md-10 col-lg-10 content-pane\">\n			<div class=\"loadingIndicator\">\n				<div data-lb-progress=\"liveFeedEditCtrl.loadingIndicator\" ng-show=\"liveFeedEditCtrl.loadingIndicator.show\"></div>\n			</div>\n			<div class=\"row-no-padding\">\n				<breadcrumb tab-name=\"liveFeedEditCtrl.editData.name\"></breadcrumb>\n				<uib-tabset horizontal=\"true\" type=\"pills\" class=\"edit-view-tabbar\">\n					<uib-tab heading=\"Properties\" active=\"true\">\n						<div class=\"col-md-12 col-lg-12 edit-full-height\"\n							 ng-include=\"\'system/livefeed/editor/components/livefeed-properties-template.html\'\">\n						</div>\n					</uib-tab>\n				</uib-tabset>\n			</div>\n\n            <toolbar button-defs=\"liveFeedEditCtrl.toolbarButtonDefs\"></toolbar>\n\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("system/livefeed/searchView/livefeed-searchview-template.html", "<div class=\"loadingIndicator\">\n	<div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\"></div>\n</div>\n\n<div class=\"row-no-padding\">\n	<div class=\"col-md-12 col-lg-12\">\n		<div id=\"liveFeedSearchGrid\"\n             class=\"grid search-grid\"\n             ui-grid=\"$ctrl.currentGridOptions\"\n             ui-grid-selection\n             ui-grid-pagination\n			 ui-grid-resize-columns></div>\n	</div>\n</div>\n\n<toolbar button-defs=\"$ctrl.toolbarButtonDefs\"></toolbar>\n\n");
        $templateCache.put("system/metadata/grid/metadata-items-grid-template.html", "<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\">\n    </div>\n</div>\n\n<div class=\"col-md-12 col-lg-12 edit-full-height\">\n    <div class=\"row edit-full-height edit-view\">\n        <div class=\"edit-view-container\">\n            <div class=\"prism-form-heading\">{{$ctrl.headerTitle}}</div>\n\n            <div ui-grid=\"$ctrl.currentGridOptions\"\n                 class=\"grid inline-checkbox-grid metadata-items-grid\"\n                 wrap-column-headers-grid\n                 ui-grid-selection\n                 ui-grid-pagination\n                 ui-grid-resize-columns\n                 id=\"metadataItemsGrid\"></div>\n\n        </div>\n    </div>\n</div>\n\n\n<div class=\"row-no-padding manager-toolbar\">\n    <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"></toolbar>\n</div>\n");
        $templateCache.put("system/metadata/searchView/metadata-items-searchview-grid-template.html", "");
        $templateCache.put("system/metadata/searchView/metadata-items-searchview-template.html", "<div class=\"container-fluid no-padding\">\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <div class=\"row-no-padding\">\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n        <div>\n            <div class=\"col-md-10 col-lg-10 content-pane\">\n                <breadcrumb tab-name=\"\'Metadata Item Search\'\"></breadcrumb>\n\n                <uib-tabset horizontal=\"true\" type=\"pills\" class=\"edit-view-tabbar\"\n                            active=\"$ctrl.currentTab\">\n                    <uib-tab heading=\"Package Metadata Items\" index=\"\'package\'\" select=\"$ctrl.onTabSelect(\'package\')\">\n                    </uib-tab>\n                    <uib-tab heading=\"Non-Package Metadata Items\" index=\"\'nonPackage\'\" select=\"$ctrl.onTabSelect(\'nonPackage\')\">\n                    </uib-tab>\n                    <uib-tab heading=\"Conversion Template Variables\" index=\"\'conversion\'\" select=\"$ctrl.onTabSelect(\'conversion\')\">\n                    </uib-tab>\n                </uib-tabset>\n\n\n                <div>\n                    <metadata-items-grid\n                        column-defs=\"$ctrl.columnDefs\"\n                        get-properties-promise=\"$ctrl.getPropertiesPromise()\"\n                        header-title=\"$ctrl.headerTitle()\"\n                        owner-class=\"$ctrl.currentTab\"\n                        show-m-v-p-d=\"false\"\n                        show-conversion=\"$ctrl.currentTab === \'conversion\'\">\n                    </metadata-items-grid>\n                </div>\n            </div>\n        </div>\n\n    </div>\n\n</div>\n");
        $templateCache.put("system/packageNotifications/editView/package-notifications-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <div class=\"row-no-padding\">\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n\n            <div class=\"loadingIndicator\">\n                <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                     ng-show=\"$ctrl.loadingIndicator.show\">\n                </div>\n            </div>\n\n            <div class=\"row\">\n                <div class=\"col-md-12\">\n                    <breadcrumb tab-name=\"$ctrl.breadcrumbName\"></breadcrumb>\n\n                    <fieldset>\n                        <div class=\"edit-full-height-no-tabs edit-view\">\n                            <form class=\"form-horizontal\"\n                                  role=\"form\"\n                                  name=\"$ctrl.editorForm\">\n\n                                <div class=\"edit-view-container\">\n                                    <div ng-include=\"\'system/packageNotifications/editView/renderers/package-notifications-editor-general-section-template.html\'\"></div>\n                                </div>\n\n                            </form>\n                        </div>\n                    </fieldset>\n                </div>\n            </div>\n\n            <!-- Toolbar -->\n            <div class=\"row-no-padding manager-toolbar\">\n                <div>\n                    <toolbar button-defs=\"$ctrl.toolbarButtonDefs\">\n                    </toolbar>\n                </div>\n            </div>\n\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/packageNotifications/searchView/package-notifications-search-view-template.html", "<div class=\"container-fluid no-padding\">\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <div class=\"row-no-padding\">\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n\n            <!-- Pacifier -->\n            <div class=\"loadingIndicator\">\n                <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                     ng-show=\"$ctrl.loadingIndicator.show\"></div>\n            </div>\n\n            <!-- Grid -->\n            <div id=\"packageNotificationsSearchViewGrid\"\n                 class=\"grid search-grid\"\n                 ui-grid=\"$ctrl.gridOptions\"\n                 ui-grid-selection>\n            </div>\n\n            <!-- Toolbar -->\n            <toolbar\n                button-defs=\"$ctrl.toolbarButtonDefs\">\n            </toolbar>\n\n        </div>\n\n    </div>\n</div>\n");
        $templateCache.put("system/partner/editor/partner-edit-template.html", "<div class=\"container-fluid no-padding\">\n\n	<!-- Pacifier -->\n	<div class=\"loadingIndicator\">\n		<div data-lb-progress=\"$ctrl.loadingIndicator\"\n			 ng-show=\"$ctrl.loadingIndicator.show\"></div>\n	</div>\n\n	<!-- Navigation/search toolbar -->\n	<div class=\"row-no-padding\">\n		<navbar filter-enabled=\"$ctrl.filterEnabled\"></navbar>\n	</div>\n\n	<!-- Main -->\n	<div class=\"row-no-padding\">\n		<!-- Sidebar -->\n		<sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n		<!-- Content pane -->\n		<div class=\"col-md-10 col-lg-10 content-pane\">\n\n			<!-- Tab component -->\n			<div class=\"row-no-padding\">\n				<breadcrumb tab-name=\"$ctrl.partnerObject.name\"></breadcrumb>\n				<uib-tabset horizontal=\"true\"\n							type=\"pills\"\n							class=\"edit-view-tabbar\"\n							active=\"$ctrl.currentViewedTab\"\n                            ng-if=\"$ctrl.partnerObject\">\n\n					<!-- Properties -->\n					<uib-tab heading=\"{{\'Properties\'}}\"\n                             index=\"\'properties\'\"\n							 select=\"$ctrl.onTabSelect(\'properties\')\"\n							 deselect=\"$ctrl.onTabDeselect(\'properties\', $event)\"\n							 ng-show=\"$ctrl.validTabs.properties\">\n						<div ng-if=\"$ctrl.activeTabs.properties\">\n							<partner-properties-view\n								partner-object=\"$ctrl.partnerObject\">\n							</partner-properties-view>\n						</div>\n					</uib-tab>\n\n					<!-- Delivery Endpoints -->\n					<uib-tab ng-if=\"$ctrl.permissions.deliveryEndpoints.read\"\n							 heading=\"{{\'Delivery Endpoints\'}}\"\n							 index=\"\'deliveryEndpoints\'\"\n							 select=\"$ctrl.onTabSelect(\'deliveryEndpoints\')\"\n							 deselect=\"$ctrl.onTabDeselect(\'deliveryEndpoints\', $event)\"\n							 ng-show=\"$ctrl.validTabs.deliveryEndpoints\">\n						<partner-delivery-endpoints-search-view\n							ng-if=\"$ctrl.activeTabs.deliveryEndpoints\"\n							can-read=\"$ctrl.permissions.deliveryEndpoints.read\"\n							can-write=\"$ctrl.permissions.deliveryEndpoints.write\">\n						</partner-delivery-endpoints-search-view>\n					</uib-tab>\n\n					<!-- Delivery Profiles -->\n					<uib-tab ng-if=\"$ctrl.permissions.deliveryProfiles.read\"\n							 heading=\"{{\'Delivery Profiles\'}}\"\n							 index=\"\'deliveryProfiles\'\"\n							 select=\"$ctrl.onTabSelect(\'deliveryProfiles\')\"\n							 deselect=\"$ctrl.onTabDeselect(\'deliveryProfiles\', $event)\"\n							 ng-show=\"$ctrl.validTabs.deliveryProfiles\">\n						<partner-delivery-profiles-search-view\n							ng-if=\"$ctrl.activeTabs.deliveryProfiles\"\n							can-read=\"$ctrl.permissions.deliveryProfiles.read\"\n							can-write=\"$ctrl.permissions.deliveryProfiles.write\">\n						</partner-delivery-profiles-search-view>\n					</uib-tab>\n\n					<!-- Email Endpoints -->\n					<uib-tab ng-if=\"$ctrl.permissions.emailEndpoints.read\"\n							 heading=\"{{\'Email Endpoints\'}}\"\n							 index=\"\'emailEndpoints\'\"\n							 select=\"$ctrl.onTabSelect(\'emailEndpoints\')\"\n							 deselect=\"$ctrl.onTabDeselect(\'emailEndpoints\', $event)\"\n							 ng-show=\"$ctrl.validTabs.emailEndpoints\">\n						<partner-email-endpoints-search-view\n							ng-if=\"$ctrl.activeTabs.emailEndpoints\"\n							can-read=\"$ctrl.permissions.emailEndpoints.read\"\n							can-write=\"$ctrl.permissions.emailEndpoints.write\">\n						</partner-email-endpoints-search-view>\n					</uib-tab>\n\n					<!-- Planners -->\n					<uib-tab heading=\"{{\'Planner\'}}\"\n							 index=\"\'planner\'\"\n							 select=\"$ctrl.onTabSelect(\'planner\')\"\n							 deselect=\"$ctrl.onTabDeselect(\'planner\', $event)\"\n							 ng-show=\"$ctrl.validTabs.planner\">\n						<partner-planner-search-view\n							ng-if=\"$ctrl.activeTabs.planner\">\n						</partner-planner-search-view>\n					</uib-tab>\n\n					<!-- Metadata Items -->\n					<uib-tab heading=\"{{\'Metadata Items\'}}\"\n							 index=\"\'metadataItems\'\"\n							 select=\"$ctrl.onTabSelect(\'metadataItems\')\"\n							 deselect=\"$ctrl.onTabDeselect(\'metdataItems\', $event)\"\n							 ng-show=\"$ctrl.validTabs.metadataItems\">\n                        <metadata-items-grid\n                            column-defs=\"$ctrl.columnDefs\"\n                            get-properties-promise=\"$ctrl.getMetadataPropertiesPromise()\"\n                            header-title=\"\'Partner Custom Metadata\'\"\n                            owner-class=\"\'partner\'\"\n                            show-m-v-p-d=\"false\"\n                            show-conversion=\"false\"\n                            ng-if=\"$ctrl.activeTabs.metadataItems\">\n                        </metadata-items-grid>\n					</uib-tab>\n\n					<!-- MVPD Metadata Items -->\n					<uib-tab heading=\"{{\'MVPD Items\'}}\"\n							 index=\"\'mvpdItems\'\"\n							 select=\"$ctrl.onTabSelect(\'mvpdItems\')\"\n							 deselect=\"$ctrl.onTabDeselect(\'mvpdItems\', $event)\"\n							 ng-show=\"$ctrl.validTabs.mvpdItems\">\n                        <metadata-items-grid\n                            column-defs=\"$ctrl.columnDefs\"\n                            get-properties-promise=\"$ctrl.getMetadataPropertiesPromise()\"\n                            header-title=\"\'MVPD Partner Custom Metadata\'\"\n                            owner-class=\"\'partner\'\"\n                            show-m-v-p-d=\"true\"\n                            show-conversion=\"false\"\n                            ng-if=\"$ctrl.activeTabs.mvpdItems\">\n                        </metadata-items-grid>\n					</uib-tab>\n\n					<!-- Subscriptions -->\n					<uib-tab heading=\"{{\'Subscriptions\'}}\"\n							 index=\"\'subscriptions\'\"\n							 select=\"$ctrl.onTabSelect(\'subscriptions\')\"\n							 deselect=\"$ctrl.onTabDeselect(\'subscriptions\', $event)\"\n							 ng-show=\"$ctrl.validTabs.subscriptions\">\n						<div ng-if=\"$ctrl.activeTabs.subscriptions\">\n							<subscription-edit-grid is-partner=\"true\">\n							</subscription-edit-grid>\n						</div>\n					</uib-tab>\n\n                    <!-- SLA Templates -->\n                    <uib-tab heading=\"{{\'SLA Templates\'}}\"\n                             index=\"\'dueDateTemplates\'\"\n                             select=\"$ctrl.onTabSelect(\'dueDateTemplates\')\"\n                             deselect=\"$ctrl.onTabDeselect(\'dueDateTemplates\', $event)\"\n                             ng-show=\"$ctrl.validTabs.dueDateTemplates\">\n                        <div ng-if=\"$ctrl.activeTabs.dueDateTemplates\">\n                            <partner-due-date-templates-search-view\n                                can-read=\"$ctrl.permissions.dueDateTemplates.read\"\n                                can-write=\"$ctrl.permissions.dueDateTemplates.write\"\n                                partner-object=\"$ctrl.partnerObject\">\n                            </partner-due-date-templates-search-view>\n                        </div>\n                    </uib-tab>\n\n                    <!-- Nielsen Templates -->\n                    <uib-tab heading=\"{{\'Nielsen Templates\'}}\"\n                             index=\"\'nielsenTemplates\'\"\n                             select=\"$ctrl.onTabSelect(\'nielsenTemplates\')\"\n                             deselect=\"$ctrl.onTabDeselect(\'nielsenTemplates\', $event)\"\n                             ng-show=\"$ctrl.validTabs.nielsenTemplates\">\n                        <div ng-if=\"$ctrl.activeTabs.nielsenTemplates\">\n                            <nielsen-templates-search-view\n                                    partner-object=\"$ctrl.partnerObject\">\n                            </nielsen-templates-search-view>\n                        </div>\n                    </uib-tab>\n\n                    <!-- Audio Mapping Rules -->\n                    <uib-tab ng-if=\"$ctrl.permissions.deliveryProfiles.read\"\n                             heading=\"{{\'Audio Mapping Rules\'}}\"\n                             index=\"\'audioMappingRules\'\"\n                             select=\"$ctrl.onTabSelect(\'audioMappingRules\')\"\n                             deselect=\"$ctrl.onTabDeselect(\'audioMappingRules\', $event)\"\n                             ng-show=\"$ctrl.validTabs.audioMappingRules\">\n                        <partner-audio-mapping-rules-grid\n                            ng-if=\"$ctrl.activeTabs.audioMappingRules\"\n                            can-read=\"$ctrl.permissions.deliveryProfiles.read\"\n                            can-write=\"$ctrl.permissions.deliveryProfiles.write\"\n                            partner-object=\"$ctrl.partnerObject\">\n                        </partner-audio-mapping-rules-grid>\n                    </uib-tab>\n				</uib-tabset>\n			</div>\n\n			<!-- Tab-dynamic toolbar -->\n			<div ng-switch=\"$ctrl.currentViewedTab\">\n\n				<!-- Partner properties toolbar -->\n                <toolbar\n                         button-defs=\"$ctrl.toolbarButtonDefs\"\n                         ng-switch-when=\"properties\">\n                </toolbar>\n\n			</div>\n\n		</div>\n	</div>\n\n</div>\n");
        $templateCache.put("system/partner/searchView/partner-searchview-template.html", "<div class=\"loadingIndicator\">\n	<div data-lb-progress=\"$ctrl.loadingIndicator\" ng-show=\"$ctrl.loadingIndicator.show\"></div>\n</div>\n<div class=\"row-no-padding\">\n	<div class=\"col-md-12 col-lg-12\">\n		<div ui-grid=\"$ctrl.currentGridOptions\"\n             class=\"grid search-grid\"\n             ui-grid-selection\n             ui-grid-pagination\n			 ui-grid-resize-columns\n             id=\"partnerSearchGrid\"></div>\n	</div>\n\n</div>\n\n<!-- Toolbar -->\n<toolbar\n    button-defs=\"$ctrl.toolbarButtonDefs\"\n    pagination-defs=\"$ctrl.paginationDefs\"\n    right-hand-checkbox-defs=\"$ctrl.toolbarCheckboxDefs\">\n</toolbar>\n");
        $templateCache.put("system/properties/searchView/properties-search-view-template.html", "<div>\n    <div class=\"container-fluid no-padding\">\n        <div class=\"row-no-padding\">\n            <navbar></navbar>\n        </div>\n\n        <div class=\"row-no-padding\">\n            <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n            <div class=\"col-md-10 col-lg-10 content-pane\">\n                <div >\n                    <uib-tabset horizontal=\"true\" type=\"pills\" class=\"edit-view-tabbar\" active=\"$ctrl.currentTab\">\n                        <uib-tab id=\"categories\" heading=\"{{$ctrl.tabs.Categories.displayName}}\"\n                                 select=\"$ctrl.changeTab($ctrl.tabs.Categories)\" index=\"$ctrl.tabs.Categories\">\n                        </uib-tab>\n                        <uib-tab id=\"genres\" heading=\"{{$ctrl.tabs.Genres.displayName}}\"\n                                 select=\"$ctrl.changeTab($ctrl.tabs.Genres)\" index=\"$ctrl.tabs.Genres\">\n                        </uib-tab>\n                        <uib-tab id=\"languages\" heading=\"{{$ctrl.tabs.Languages.displayName}}\"\n                                 select=\"$ctrl.changeTab($ctrl.tabs.Languages)\" index=\"$ctrl.tabs.Languages\">\n                        </uib-tab>\n                        <uib-tab id=\"territories\" heading=\"{{$ctrl.tabs.Territories.displayName}}\"\n                                 select=\"$ctrl.changeTab($ctrl.tabs.Territories)\" index=\"$ctrl.tabs.Territories\">\n                        </uib-tab>\n                        <uib-tab id=\"roles\" heading=\"{{$ctrl.tabs.Roles.displayName}}\"\n                                 select=\"$ctrl.changeTab($ctrl.tabs.Roles)\" index=\"$ctrl.tabs.Roles\">\n                        </uib-tab>\n                        <uib-tab id=\"dynamicProps\" heading=\"{{$ctrl.tabs.DynamicProps.displayName}}\"\n                                 select=\"$ctrl.changeTab($ctrl.tabs.DynamicProps)\" index=\"$ctrl.tabs.DynamicProps\">\n                        </uib-tab>\n                    </uib-tabset>\n                </div>\n                <div ng-if=\"$ctrl.currentTab === $ctrl.tabs.Roles\">\n                    <uib-tabset horizontal=\"true\" type=\"pills\" class=\"edit-view-tabbar\" active=\"$ctrl.currentSubTab\">\n                        <uib-tab id=\"audioRoleTab\" heading=\"{{$ctrl.tabs.Roles.subTabs.All.displayName}}\"\n                                 select=\"$ctrl.changeSubTab($ctrl.tabs.Roles.subTabs.All)\"\n                                 index=\"$ctrl.tabs.Roles.subTabs.All\">\n                        </uib-tab>\n                        <uib-tab id=\"audioRoleTab\" heading=\"{{$ctrl.tabs.Roles.subTabs.Audio.displayName}}\"\n                                 select=\"$ctrl.changeSubTab($ctrl.tabs.Roles.subTabs.Audio)\"\n                                 index=\"$ctrl.tabs.Roles.subTabs.Audio\">\n                        </uib-tab>\n                        <uib-tab id=\"closedCaptioningRoleTab\" heading=\"{{$ctrl.tabs.Roles.subTabs.CC.displayName}}\"\n                                 select=\"$ctrl.changeSubTab($ctrl.tabs.Roles.subTabs.CC)\"\n                                 index=\"$ctrl.tabs.Roles.subTabs.CC\">\n                        </uib-tab>\n                        <uib-tab id=\"subtitlesRoleTab\" heading=\"{{$ctrl.tabs.Roles.subTabs.Subtitle.displayName}}\"\n                                 select=\"$ctrl.changeSubTab($ctrl.tabs.Roles.subTabs.Subtitle)\"\n                                 index=\"$ctrl.tabs.Roles.subTabs.Subtitle\">\n                        </uib-tab>\n                        <uib-tab id=\"videoComponentRoleTab\" heading=\"{{$ctrl.tabs.Roles.subTabs.Video.displayName}}\"\n                                 select=\"$ctrl.changeSubTab($ctrl.tabs.Roles.subTabs.Video)\"\n                                 index=\"$ctrl.tabs.Roles.subTabs.Video\">\n                        </uib-tab>\n                    </uib-tabset>\n                </div>\n                <div class=\"loadingIndicator\">\n                    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                         ng-show=\"$ctrl.loadingIndicator.show\">\n                    </div>\n                </div>\n\n                <div id=\"propertiesSearchGrid\"\n                     class=\"grid-with-two-rows-of-tabs search-grid\"\n                     ui-grid=\"$ctrl.gridOptions\"\n                     ng-class=\"{\'grid-with-one-row-of-tabs\': $ctrl.currentTab !== $ctrl.tabs.Roles}\"\n                     ui-grid-selection\n                     ui-grid-pagination\n                     ui-grid-auto-resize\n                     ui-grid-resize-columns>\n                </div>\n\n                <toolbar\n                        button-defs=\"$ctrl.toolbarButtonDefs\">\n                </toolbar>\n\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/roles/editor/roles-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <div class=\"row-no-padding\">\n\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n            <breadcrumb tab-name=\"$ctrl.editData.name\"></breadcrumb>\n            <fieldset>\n                <div class=\"edit-full-height edit-view\">\n                    <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n                        <div class=\"edit-view-container\">\n                            <div class=\"col-md-12 column\">\n                                <div class=\"row\">\n                                    <div class=\"col-md-2\">\n                                        <div class=\"prism-form-heading\">General</div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"row clearfix\">\n                                <div class=\"row clearfix spacer-top-lg\">\n                                    <div class=\"col-md-12 column\">\n                                        <div class=\"row-no-padding\">\n                                            <form role=\"form\" class=\"form-horizontal\">\n                                                <div class=\"form-group\">\n                                                    <label class=\"control-label col-md-2\">Name</label>\n                                                    <div class=\"col-sm-4 pad-text-input-col\">\n                                                        <input type=\"text\" class=\"prism-text-input\"\n                                                               ng-model=\"$ctrl.editData.name\"\n                                                               id=\"nameInput\"/>\n                                                    </div>\n                                                    <div class=\"required-text-input\"\n                                                         required\n                                                         x-required-indicator></div>\n                                                </div>\n                                                <div class=\"form-group\" ng-if=\"$ctrl.allowRoleTypeEdit\">\n                                                    <label for=\"roleTypeDropdown\"\n                                                           class=\"col-sm-2 control-label\">\n                                                        Type\n                                                    </label>\n                                                    <div class=\"col-sm-4 pad-text-input-col\">\n                                                        <dropdown-select\n                                                                id=\"roleTypeDropdown\"\n                                                                collection=\"$ctrl.roleTypes\"\n                                                                ng-model=\"$ctrl.editData.type\"\n                                                                prompt=\"Select role type\"\n                                                                clearable=\"false\"\n                                                                btn-min-width=\"200\"\n                                                                class=\"hide-required-indicator\"\n                                                                required>\n                                                        </dropdown-select>\n                                                    </div>\n                                                    <div class=\"required-text-input\"\n                                                         required\n                                                         x-required-indicator></div>\n                                                </div>\n                                                <div class=\"form-group\" ng-if=\"!$ctrl.allowRoleTypeEdit\">\n                                                    <label for=\"roleType\" class=\"col-sm-2 control-label\">\n                                                        Type\n                                                    </label>\n                                                    <div class=\"col-sm-4 pad-text-input-col\">\n                                                     <span class=\"form-control-static\" id=\"roleType\">\n                                                         {{$ctrl.editData.type}}\n                                                     </span>\n                                                    </div>\n                                                </div>\n                                                <div class=\"form-group\" ng-if=\"$ctrl.editData.type === \'Audio\'\">\n                                                    <label class=\"col-sm-2 control-label\">\n                                                        DVS\n                                                    </label>\n                                                    <div class=\"col-sm-4 pad-text-input-col\">\n                                                        <span class=\"form-control-static\" id=\"dvsFlag\">\n                                                            {{$ctrl.editData.dvsFlag ? \'Enabled\' : \'Not Enabled\'}}\n                                                        </span>\n                                                    </div>\n                                                </div>\n                                                <div class=\"form-group\">\n                                                    <label class=\"control-label col-md-2\">Aliases</label>\n                                                    <div class=\"col-sm-6 pad-text-input-col\">\n                                                        <button id=\"launchPartnerSelectionModalButton\"\n                                                                type=\"button\"\n                                                                class=\"btn btn-default prism-button\"\n                                                                uib-tooltip=\"Create new Partner Aliases\"\n                                                                data-tooltip-append-to-body=\"true\"\n                                                                ng-click=\"$ctrl.addAlias()\">\n                                                            <i class=\"fa fa-plus\"></i>\n                                                        </button>\n                                                        <button id=\"deleteSelectedPartnerAliasesButton\"\n                                                                type=\"button\"\n                                                                class=\"btn btn-default prism-button\"\n                                                                uib-tooltip=\"Remove alias(es)\"\n                                                                data-tooltip-append-to-body=\"true\"\n                                                                ng-disabled=\"!$ctrl.gridApi.selection.getSelectedRows().length\"\n                                                                ng-click=\"$ctrl.removeAlias()\">\n                                                            <i class=\"fa fa-minus\"></i>\n                                                        </button>\n                                                        <br>\n                                                        <br>\n                                                        <div id=\"partnerAliasesGrid\"\n                                                             class=\"inline-edit-grid grid search-grid\"\n                                                             ui-grid=\"$ctrl.gridOptions\"\n                                                             ui-grid-selection\n                                                             ui-grid-edit\n                                                             style=\"max-height: 605px;\"\n                                                             ui-grid-resize-columns>\n                                                        </div>\n\n                                                    </div>\n                                                </div>\n\n\n                                            </form>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </fieldset>\n            <div class=\"row-no-padding manager-toolbar\">\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\" pagination-defs=\"$ctrl.paginationDefs\"></toolbar>\n            </div>\n        </div>\n        <div class=\"loadingIndicator\">\n            <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                 ng-show=\"$ctrl.loadingIndicator.show\">\n            </div>\n        </div>\n    </div>\n\n</div>\n\n");
        $templateCache.put("system/territories/editor/territories-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n\n    <!-- Navbar -->\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <div class=\"row-no-padding\">\n\n        <!-- Sidebar -->\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n            <!-- Loading Indicator -->\n            <div class=\"loadingIndicator\">\n                <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                     ng-show=\"$ctrl.loadingIndicator.show\">\n                </div>\n            </div>\n\n            <!-- Breadcrumb -->\n            <breadcrumb tab-name=\"$ctrl.editData.name\"></breadcrumb>\n\n            <!-- Content -->\n            <fieldset>\n                <div class=\"edit-full-height edit-view\">\n                    <form class=\"form-horizontal\"\n                          role=\"form\"\n                          name=\"$ctrl.editorForm\">\n                        <div class=\"edit-view-container\">\n\n                            <!-- General -->\n                            <div class=\"col-md-12 column\">\n                                <div class=\"row\">\n                                    <div class=\"col-md-2\">\n                                        <div class=\"prism-form-heading\">General</div>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class=\"row clearfix\">\n                                <div class=\"row clearfix spacer-top-lg\">\n                                    <div class=\"col-md-12 column\">\n                                        <div class=\"row-no-padding\">\n                                            <form role=\"form\"\n                                                  class=\"form-horizontal\">\n\n                                                <!-- Name -->\n                                                <div class=\"form-group\">\n                                                    <label class=\"control-label col-md-2\"\n                                                           for=\"nameInput\">\n                                                        Name\n                                                    </label>\n                                                    <div class=\"col-sm-4 pad-text-input-col\">\n                                                        <input type=\"text\"\n                                                               class=\"prism-text-input\"\n                                                               ng-model=\"$ctrl.editData.name\"\n                                                               id=\"nameInput\"/>\n                                                    </div>\n                                                    <div class=\"required-text-input\"\n                                                         required\n                                                         x-required-indicator></div>\n                                                </div>\n\n                                                <!-- Value -->\n                                                <div class=\"form-group\">\n                                                    <label class=\"control-label col-md-2\"\n                                                           for=\"valueInput\">\n                                                        Value\n                                                    </label>\n                                                    <div class=\"col-sm-4 pad-text-input-col\">\n                                                        <input type=\"text\"\n                                                               class=\"prism-text-input\"\n                                                               ng-model=\"$ctrl.editData.value\"\n                                                               id=\"valueInput\"/>\n                                                    </div>\n                                                    <div class=\"required-text-input\"\n                                                         required\n                                                         x-required-indicator></div>\n                                                </div>\n\n                                                <!-- ISO2 Code -->\n                                                <div class=\"form-group\">\n                                                    <label class=\"control-label col-md-2\"\n                                                           for=\"iSO2CodeInput\">\n                                                        ISO2 Code\n                                                    </label>\n                                                    <div class=\"col-sm-4 pad-text-input-col\">\n                                                        <input type=\"text\"\n                                                               class=\"prism-text-input text-uppercase\"\n                                                               ng-model=\"$ctrl.editData.iSO2Code\"\n                                                               ng-keydown=\"$ctrl.validateInput($event, $ctrl.editData.iSO2Code, \'^[a-zA-Z]+$\')\"\n                                                               maxlength=\"2\"\n                                                               name=\"iSO2Code\"\n                                                               id=\"iSO2CodeInput\"/>\n                                                        <label class=\"under-field-hint\">(must be 2 characters)</label>\n                                                    </div>\n                                                    <div class=\"required-text-input\"\n                                                         required\n                                                         x-required-indicator></div>\n                                                </div>\n\n                                                <!-- ISO3 Code -->\n                                                <div class=\"form-group\">\n                                                    <label class=\"control-label col-md-2\"\n                                                           for=\"iSO3CodeInput\">\n                                                        ISO3 Code\n                                                    </label>\n                                                    <div class=\"col-sm-4 pad-text-input-col\">\n                                                        <input type=\"text\"\n                                                               class=\"prism-text-input text-uppercase\"\n                                                               ng-model=\"$ctrl.editData.iSO3Code\"\n                                                               ng-keydown=\"$ctrl.validateInput($event, $ctrl.editData.iSO3Code, \'^[a-zA-Z]+$\')\"\n                                                               name=\"iSO3Code\"\n                                                               maxlength=\"3\"\n                                                               id=\"iSO3CodeInput\"/>\n                                                        <label class=\"under-field-hint\">(must be 3 characters)</label>\n                                                    </div>\n                                                    <div class=\"required-text-input\"\n                                                         required\n                                                         x-required-indicator></div>\n                                                </div>\n\n                                            </form>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </fieldset>\n\n            <!-- Toolbar -->\n            <div class=\"row-no-padding manager-toolbar\">\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"\n                         pagination-defs=\"$ctrl.paginationDefs\"></toolbar>\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/templates/ffmpegTemplate/ffmpeg-template-template.html", "<div class=\"container-fluid no-padding\">\n	<div class=\"row-no-padding\">\n		<navbar></navbar>\n	</div>\n	<div class=\"row-no-padding\">\n		<sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n		<ffmpegtemplate-searchview class=\"col-md-10 content-pane\"></ffmpegtemplate-searchview>\n	</div>\n</div>\n\n");
        $templateCache.put("system/templates/mediaAcceptProfiles/media-accept-profiles-template.html", "<div class=\"container-fluid no-padding\">\n	<div class=\"row-no-padding\">\n		<navbar></navbar>\n	</div>\n	<div class=\"row-no-padding\">\n		<sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n		<media-accept-profiles-search-view class=\"col-md-10 content-pane\"></media-accept-profiles-search-view>\n	</div>\n</div>\n");
        $templateCache.put("system/templates/searchView/templates-search-view-template.html", "<div>\n    <div class=\"container-fluid no-padding\">\n        <div class=\"row-no-padding\">\n            <navbar></navbar>\n        </div>\n\n        <div class=\"row-no-padding\">\n            <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n            <div class=\"col-md-10 col-lg-10 content-pane\">\n                <div>\n                    <uib-tabset horizontal=\"true\" type=\"pills\" class=\"edit-view-tabbar\" active=\"$ctrl.currentTab\">\n                        <uib-tab id=\"deliveryTemplatesTab\" heading=\"{{$ctrl.tabs.DeliveryTemplates.tabName}}\"\n                                 select=\"$ctrl.changeTab($ctrl.tabs.DeliveryTemplates)\"\n                                 index=\"$ctrl.tabs.DeliveryTemplates\">\n                        </uib-tab>\n                        <uib-tab id=\"emailTemplatesTab\" heading=\"{{$ctrl.tabs.EmailTemplates.tabName}}\"\n                                 select=\"$ctrl.changeTab($ctrl.tabs.EmailTemplates)\" index=\"$ctrl.tabs.EmailTemplates\">\n                        </uib-tab>\n                        <uib-tab id=\"hybrikTemplatesTab\" heading=\"{{$ctrl.tabs.HybrikTemplates.tabName}}\"\n                                 select=\"$ctrl.changeTab($ctrl.tabs.HybrikTemplates)\"\n                                 index=\"$ctrl.tabs.HybrikTemplates\">\n                        </uib-tab>\n                        <uib-tab id=\"ffmpegTemplatesTab\" heading=\"{{$ctrl.tabs.FfmpegTemplates.tabName}}\"\n                                 select=\"$ctrl.changeTab($ctrl.tabs.FfmpegTemplates)\"\n                                 index=\"$ctrl.tabs.FfmpegTemplates\">\n                        </uib-tab>\n                        <uib-tab id=\"intermediateTemplatesTab\"\n                                 heading=\"{{$ctrl.tabs.IntermediateTemplates.tabName}}\"\n                                 select=\"$ctrl.changeTab($ctrl.tabs.IntermediateTemplates)\"\n                                 index=\"$ctrl.tabs.IntermediateTemplates\">\n                        </uib-tab>\n                        <uib-tab id=\"conditionalTemplatesTab\" heading=\"{{$ctrl.tabs.ConditionalTemplates.tabName}}\"\n                                 select=\"$ctrl.changeTab($ctrl.tabs.ConditionalTemplates)\"\n                                 index=\"$ctrl.tabs.ConditionalTemplates\">\n                        </uib-tab>\n                        <uib-tab ng-if=\"$ctrl.canReadPackageTemplates\" id=\"packageCreationTemplatesTab\" heading=\"{{$ctrl.tabs.PackageCreationTemplates.tabName}}\"\n                                 select=\"$ctrl.changeTab($ctrl.tabs.PackageCreationTemplates)\"\n                                 index=\"$ctrl.tabs.PackageCreationTemplates\">\n                        </uib-tab>\n                        <uib-tab id=\"transformTemplatesTab\" heading=\"{{$ctrl.tabs.TransformTemplates.tabName}}\"\n                                 select=\"$ctrl.changeTab($ctrl.tabs.TransformTemplates)\"\n                                 index=\"$ctrl.tabs.TransformTemplates\">\n                        </uib-tab>\n                        <uib-tab id=\"imageTemplatesTab\" heading=\"{{$ctrl.tabs.ImageTemplates.tabName}}\"\n                                 select=\"$ctrl.changeTab($ctrl.tabs.ImageTemplates)\" index=\"$ctrl.tabs.ImageTemplates\">\n                        </uib-tab>\n                        <uib-tab id=\"macCaptionTemplatesTab\" heading=\"{{$ctrl.tabs.MacCaptionTemplates.tabName}}\"\n                                 select=\"$ctrl.changeTab($ctrl.tabs.MacCaptionTemplates)\"\n                                 index=\"$ctrl.tabs.MacCaptionTemplates\">\n                        </uib-tab>\n                        <uib-tab id=\"mediaTab\" heading=\"{{$ctrl.tabs.Media.displayName}}\"\n                                 select=\"$ctrl.changeTab($ctrl.tabs.Media)\" index=\"$ctrl.tabs.Media\">\n                        </uib-tab>\n\n                    </uib-tabset>\n                </div>\n                <div ng-if=\"$ctrl.currentTab === $ctrl.tabs.Media\">\n                    <uib-tabset horizontal=\"true\" type=\"pills\" class=\"edit-view-tabbar\" active=\"$ctrl.currentSubTab\">\n                        <uib-tab id=\"mediaAcceptProfilesRoleTab\"\n                                 heading=\"{{$ctrl.tabs.Media.subTabs.MediaAcceptProfiles.tabName}}\"\n                                 select=\"$ctrl.changeSubTab($ctrl.tabs.Media.subTabs.MediaAcceptProfiles)\"\n                                 index=\"$ctrl.tabs.Media.subTabs.MediaAcceptProfiles\">\n                        </uib-tab>\n                        <uib-tab id=\"packageAcceptTemplatesRoleTab\"\n                                 heading=\"{{$ctrl.tabs.Media.subTabs.PackageAcceptTemplates.tabName}}\"\n                                 select=\"$ctrl.changeSubTab($ctrl.tabs.Media.subTabs.PackageAcceptTemplates)\"\n                                 index=\"$ctrl.tabs.Media.subTabs.PackageAcceptTemplates\">\n                        </uib-tab>\n                    </uib-tabset>\n                </div>\n                <div class=\"loadingIndicator\">\n                    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                         ng-show=\"$ctrl.loadingIndicator.show\">\n                    </div>\n                </div>\n\n                <div id=\"templatesGrid\"\n                     class=\"grid-with-two-rows-of-tabs search-grid\"\n                     ui-grid=\"$ctrl.gridOptions\"\n                     ng-class=\"{\'grid-with-one-row-of-tabs\': !$ctrl.currentTab.subTabs}\"\n                     ui-grid-selection\n                     ui-grid-pagination\n                     ui-grid-auto-resize\n                     ui-grid-resize-columns>\n                </div>\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"\n                         pagination-defs=\"$ctrl.enablePagination ? $ctrl.paginationDefs : undefined\"\n                         right-hand-checkbox-defs=\"$ctrl.toolbarCheckboxDefs\">\n                </toolbar>\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/users/editor/users-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <div class=\"row-no-padding\">\n\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n            <breadcrumb tab-name=\"\'User Properties\'\"></breadcrumb>\n            <fieldset>\n                <div class=\"edit-full-height edit-view\">\n\n                    <div class=\"edit-view-container\">\n                        <div class=\"col-md-12 column\">\n                            <div class=\"row\">\n                                <div class=\"col-md-2\">\n                                    <div class=\"prism-form-heading\">General</div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"row clearfix\">\n                            <div class=\"row clearfix spacer-top-lg\">\n                                <div class=\"col-md-12 column\">\n                                    <div class=\"row-no-padding\">\n                                        <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n                                            <div class=\"form-group\">\n                                                <label class=\"control-label col-md-2\">Email (username)</label>\n                                                <div class=\"col-sm-4 pad-text-input-col\">\n                                                    <input type=\"email\" class=\"prism-text-input\"\n                                                           autocomplete=\"off\"\n                                                           ng-model=\"$ctrl.emailUsernameInput\"\n                                                           id=\"usernameInput\"/>\n                                                    <label class=\"under-field-hint\">example@domain.com</label>\n                                                </div>\n                                                <div class=\"required-text-input\" required\n                                                     x-required-indicator></div>\n                                            </div>\n                                            <div class=\"form-group\"\n                                                 ng-if=\"$ctrl.requirePassword\">\n                                                <label class=\"control-label col-md-2\">Password</label>\n                                                <div class=\"col-sm-4 pad-text-input-col\">\n                                                    <input type=\"password\" class=\"prism-text-input\"\n                                                           ng-model=\"$ctrl.passwordInput\"\n                                                           autocomplete=\"new-password\"\n                                                           id=\"password1Input\"/>\n                                                    <password-validation\n                                                            password=\"$ctrl.passwordInput\"\n                                                            password-requirements=\"$ctrl.passwordRequirements\"\n                                                            is-valid=\"$ctrl.passwordValid\">\n                                                    </password-validation>\n\n                                                </div>\n                                                <div>\n                                                    <div class=\"required-text-input\"\n                                                         required\n                                                         x-required-indicator>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                            <div class=\"form-group\"\n                                                 ng-if=\"$ctrl.requirePassword\">\n                                                <label class=\"control-label col-md-2\">Retype Password</label>\n                                                <div class=\"col-sm-4 pad-text-input-col\">\n                                                    <input type=\"password\" class=\"prism-text-input\"\n                                                           ng-model=\"$ctrl.retypedPasswordInput\"\n                                                           autocomplete=\"new-password\"\n                                                           id=\"retypedPasswordInput\"/>\n                                                    <password-validation\n                                                            ng-hide=\"true\"\n                                                            password=\"$ctrl.retypedPasswordInput\"\n                                                            password-requirements=\"$ctrl.passwordRequirements\"\n                                                            is-valid=\"$ctrl.retypedPasswordValid\">\n                                                    </password-validation>\n                                                </div>\n                                                <div>\n                                                    <div class=\"required-text-input\"\n                                                         required\n                                                         x-required-indicator>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                            <div class=\"form-group\"\n                                                 ng-if=\"$ctrl.requirePassword\">\n                                                <label class=\"control-label col-md-2\"></label>\n                                                <div class=\"col-sm-4 pad-text-input-col\">\n                                                    <field-validation header=\"\"\n                                                                      requirements=\"$ctrl.retypedPasswordRequirements\">\n                                                    </field-validation>\n                                                </div>\n                                            </div>\n                                            <div class=\"form-group\">\n                                                <label class=\"control-label col-md-2\">First Name</label>\n                                                <div class=\"col-sm-4 pad-text-input-col\">\n                                                    <input type=\"text\" class=\"prism-text-input\"\n                                                           autocomplete=\"off\"\n                                                           ng-model=\"$ctrl.editData.firstName\"\n                                                           id=\"firstNameInput\"/>\n                                                </div>\n                                            </div>\n                                            <div class=\"form-group\">\n                                                <label class=\"control-label col-md-2\">Last Name</label>\n                                                <div class=\"col-sm-4 pad-text-input-col\">\n                                                    <input type=\"text\" class=\"prism-text-input\"\n                                                           autocomplete=\"off\"\n                                                           ng-model=\"$ctrl.editData.lastName\"\n                                                           id=\"lastNameInput\"/>\n                                                </div>\n                                            </div>\n\n                                            <div class=\"form-group\">\n                                                <label class=\"control-label col-md-2\">Groups</label>\n                                                <div class=\"col-sm-4 pad-text-input-col\">\n                                                    <button id=\"addToGroup\"\n                                                            type=\"button\"\n                                                            class=\"btn btn-default prism-button\"\n                                                            uib-tooltip=\"Add user to a new group\"\n                                                            data-tooltip-append-to-body=\"true\"\n                                                            ng-click=\"$ctrl.addUserToNewGroup()\">\n                                                        <i class=\"fa fa-plus\"></i>\n                                                    </button>\n                                                    <button id=\"removeFromSelectedGroups\"\n                                                            type=\"button\"\n                                                            class=\"btn btn-default prism-button\"\n                                                            uib-tooltip=\"Remove user from group(s)\"\n                                                            data-tooltip-append-to-body=\"true\"\n                                                            ng-disabled=\"!$ctrl.gridApi.selection.getSelectedRows().length\"\n                                                            ng-click=\"$ctrl.removeUserFromSelectedGroups()\">\n                                                        <i class=\"fa fa-minus\"></i>\n                                                    </button>\n                                                    <br>\n                                                    <br>\n                                                    <div id=\"userGroupsGrid\"\n                                                         class=\"inline-edit-grid grid search-grid\"\n                                                         ui-grid=\"$ctrl.gridOptions\"\n                                                         ui-grid-selection\n                                                         ui-grid-pagination\n                                                         style=\"max-height: 305px;\"\n                                                         ui-grid-resize-columns>\n                                                    </div>\n                                                </div>\n                                            </div>\n\n                                            <div class=\"form-group\">\n                                                <label for=\"adminCheckbox\"\n                                                       class=\"col-sm-2 control-label\">Admin</label>\n                                                <div class=\"col-sm-1 partner-nielsen-enabled-cb\">\n                                                    <input type=\"checkbox\"\n                                                           id=\"adminCheckbox\"\n                                                           ng-model=\"$ctrl.editData.adminFlag\"/>\n                                                    <label for=\"adminCheckbox\">&nbsp;</label>\n                                                </div>\n                                            </div>\n                                        </form>\n\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </fieldset>\n            <div class=\"row-no-padding manager-toolbar\">\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\" pagination-defs=\"$ctrl.paginationDefs\"></toolbar>\n            </div>\n        </div>\n        <div class=\"loadingIndicator\">\n            <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                 ng-show=\"$ctrl.loadingIndicator.show\">\n            </div>\n        </div>\n    </div>\n\n</div>\n\n");
        $templateCache.put("system/users/searchView/users-search-view-template.html", "<div>\n    <div class=\"container-fluid no-padding\">\n        <div class=\"row-no-padding\">\n            <navbar></navbar>\n        </div>\n\n        <div class=\"row-no-padding\">\n            <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n            <div class=\"col-md-10 col-lg-10 content-pane\">\n\n                <div class=\"loadingIndicator\">\n                    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                         ng-show=\"$ctrl.loadingIndicator.show\">\n                    </div>\n                </div>\n\n                <div id=\"usersGrid\"\n                     class=\"grid search-grid\"\n                     ui-grid=\"$ctrl.gridOptions\"\n                     ui-grid-selection\n                     ui-grid-pagination\n                     ui-grid-resize-columns>\n                </div>\n\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"\n                         pagination-defs=\"$ctrl.paginationDefs\"\n                         right-hand-checkbox-defs=\"$ctrl.toolbarCheckboxDefs\">\n                </toolbar>\n\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("components/branding/searchView/cellTemplates/branding-tree-child-template.html", "<!-- Accept Profile -->\n<span class=\"blue-label\">\n	{{grid.appScope.$ctrl.getAssetAcceptProfile(row.entity).name}}\n</span>\n\n<!-- Separator -->\n<span class=\"separator-label\">\n	{{\'-\'}}\n</span>\n\n<!-- Assets (non break pre/post roll) -->\n<span ng-if=\"!grid.appScope.$ctrl.isBreakPrePostRoll\"\n      class=\"branding-asset-count\">\n	{{row.entity.virtualPath.split(\'/\')[row.entity.virtualPath.split(\'/\').length-1]}}\n</span>\n\n<!-- Assets (break pre/post roll) -->\n<span ng-if=\"grid.appScope.$ctrl.isBreakPrePostRoll\">Preroll: </span>\n<span ng-if=\"grid.appScope.$ctrl.isBreakPrePostRoll\"\n      class=\"branding-asset-count\">\n	{{row.entity.preRoll.virtualPath.split(\'/\')[row.entity.preRoll.virtualPath.split(\'/\').length-1]}}\n</span>\n<span ng-if=\"grid.appScope.$ctrl.isBreakPrePostRoll\"\n      class=\"separator-label\">\n	|\n</span>\n<span ng-if=\"grid.appScope.$ctrl.isBreakPrePostRoll\"> Postroll: </span>\n<span ng-if=\"grid.appScope.$ctrl.isBreakPrePostRoll\"\n      class=\"branding-asset-count\">\n	{{row.entity.postRoll.virtualPath.split(\'/\')[row.entity.postRoll.virtualPath.split(\'/\').length-1]}}\n</span>\n");
        $templateCache.put("components/branding/searchView/cellTemplates/branding-tree-template.html", "<div class=\"ui-grid-cell-contents\"\n     title=\"TOOLTIP\"\n     ng-dblclick=\"grid.appScope.$ctrl.rowDoubleClick(row.entity, column)\">\n\n    <!-- $$treeLevel === 0 -->\n    <!-- Always a container -->\n    <span ng-if=\"row.entity.$$treeLevel === 0\"\n          class=\"tree-level-0\">\n		<span ng-class=\"{ \'italic\' : row.entity.hidden }\">\n			{{COL_FIELD}}\n		</span>\n	</span>\n\n    <!-- $$treeLevel === 1 -->\n    <!-- Could be a season/volume container _or_ an asset -->\n    <span ng-if=\"row.entity.$$treeLevel === 1\"\n          class=\"tree-level-1\">\n\n		<span ng-if=\"!grid.appScope.$ctrl.getAssetAcceptProfile(row.entity)\">\n			{{row.entity.name}}\n		</span>\n\n		<span ng-if=\"grid.appScope.$ctrl.getAssetAcceptProfile(row.entity)\">\n            <ng-include src=\"\'components/branding/searchView/cellTemplates/branding-tree-child-template.html\'\">\n            </ng-include>\n		</span>\n\n    </span>\n\n    <!-- $$treeLevel === 2 -->\n    <!-- Can only be an asset -->\n    <span ng-if=\"row.entity.$$treeLevel === 2\"\n          class=\"tree-level-2\">\n\n		<span>\n            <ng-include src=\"\'components/branding/searchView/cellTemplates/branding-tree-child-template.html\'\">\n            </ng-include>\n		</span>\n\n    </span>\n\n</div>\n");
        $templateCache.put("components/form/customMetadata/customMetadataField/custom-metadata-field-template.html", "<div class=\"form-group\">\n    <!-- Label -->\n    <label\n        class=\"{{$ctrl.formData.labelClass}}\"\n        for=\"{{$ctrl.componentDef.name}}\"\n    >\n        {{$ctrl.componentDef.displayName}}\n    </label>\n\n    <!-- Metadata Input -->\n    <!--\n        Angular 2 will not support dynamic HTML templates, but this should be convertible.\n        1. Wrap the included HTML with <ngTemplate> tags\n        2. Place all the included HTML somewhere in this template file.\n        3. Replace <ng-include> with <ngTemplateOutlet> tags\n    -->\n    <span ng-switch=\"$ctrl.fieldType\">\n        <span ng-switch-when=\"textinput\">\n            <ng-include src=\"\'components/form/customMetadata/customMetadataField/renderers/metadata-field-text-input-template.html\'\">\n            </ng-include>\n        </span>\n\n        <span ng-switch-when=\"datetimefield\">\n            <ng-include src=\"\'components/form/customMetadata/customMetadataField/renderers/metadata-field-date-time-picker-template.html\'\">\n            </ng-include>\n        </span>\n\n        <span ng-switch-when=\"datetimefieldenhanced\">\n            <ng-include src=\"\'components/form/customMetadata/customMetadataField/renderers/metadata-field-date-time-enhanced-template.html\'\">\n            </ng-include>\n        </span>\n\n        <span ng-switch-when=\"datefieldenhanced\">\n            <ng-include src=\"\'components/form/customMetadata/customMetadataField/renderers/metadata-field-date-enhanced-template.html\'\">\n            </ng-include>\n        </span>\n\n        <span ng-switch-when=\"datefield\">\n            <ng-include src=\"\'components/form/customMetadata/customMetadataField/renderers/metadata-field-date-picker-template.html\'\">\n            </ng-include>\n        </span>\n\n        <span ng-switch-when=\"textarea\">\n            <ng-include src=\"\'components/form/customMetadata/customMetadataField/renderers/metadata-field-text-area-template.html\'\">\n            </ng-include>\n        </span>\n\n        <span ng-switch-when=\"timeinput\">\n            <ng-include src=\"\'components/form/customMetadata/customMetadataField/renderers/metadata-field-time-picker-template.html\'\">\n            </ng-include>\n        </span>\n\n        <span ng-switch-when=\"timecodeinput\">\n            <ng-include src=\"\'components/form/customMetadata/customMetadataField/renderers/metadata-field-timecode-input-template.html\'\">\n            </ng-include>\n        </span>\n\n        <span ng-switch-when=\"checkbox\">\n            <ng-include src=\"\'components/form/customMetadata/customMetadataField/renderers/metadata-field-checkbox-input-template.html\'\">\n            </ng-include>\n        </span>\n\n        <span ng-switch-when=\"dropdownlist\">\n            <ng-include src=\"\'components/form/customMetadata/customMetadataField/renderers/metadata-field-dropdown-list-template.html\'\">\n            </ng-include>\n        </span>\n\n        <span ng-switch-when=\"checkboxlist\">\n            <ng-include src=\"\'components/form/customMetadata/customMetadataField/renderers/metadata-field-checkbox-list-template.html\'\">\n            </ng-include>\n        </span>\n\n        <span ng-switch-when=\"list\">\n            <ng-include src=\"\'components/form/customMetadata/customMetadataField/renderers/metadata-field-list-template.html\'\">\n            </ng-include>\n        </span>\n\n        <span ng-switch-when=\"textlistinput\">\n            <ng-include src=\"\'components/form/customMetadata/customMetadataField/renderers/metadata-field-text-list-template.html\'\">\n            </ng-include>\n        </span>\n    </span>\n\n    <!-- Override Property Checkbox -->\n    <label ng-class=\"\'prism-checkbox-inline col-sm-1 auto-width no-padding \'+ $ctrl.formData.warningClass\"\n           ng-if=\"$ctrl.showOverrideCheckbox\">\n        <input\n            id=\"{{$ctrl.inputId +\'Override\'}}\"\n            ng-model=\"$ctrl.componentDef.instanceData.valueOverridden\"\n            type=\"checkbox\"\n        />\n\n        <label for=\"{{$ctrl.inputId +\'Override\'}}\">\n            Override\n        </label>\n    </label>\n\n    <!-- Warning Indicator -->\n    <div ng-class=\"\'col-sm-1 error-warning \'+ $ctrl.formData.warningClass\"\n         ng-if=\"$ctrl.componentDef.instanceData.errorWarning && $ctrl.formData.warningClass\"\n    >\n        <error-warning-indicator error-warning=\"$ctrl.componentDef.instanceData.errorWarning\">\n        </error-warning-indicator>\n    </div>\n\n    <!-- Error Indicator -->\n    <span ng-if=\"$ctrl.componentDef.instanceData.required && $ctrl.formData.requiredClass\">\n        <div ng-class=\"$ctrl.formData.requiredClass\"\n             required\n             x-required-indicator\n        ></div>\n    </span>\n\n</div>\n");
        $templateCache.put("components/grids/default-artwork-maps-grid/cell-templates/artwork-accept-profile-cell-template.html", "<div class=\"cell-dropdown-container\">\n    <dropdown-select id=\"artworkProfileSelect{{$index}}\"\n                     attach-to-body=\"false\"\n                     ng-model=\"row.entity.acceptProfile\"\n                     on-change=\"grid.appScope.$ctrl.onArtworkRowChanged(row.entity)\"\n                     collection=\"grid.appScope.$ctrl.availableArtworkAcceptProfiles\"\n                     label-field=\"name\"\n                     clearable=\"false\"\n                     btn-min-width=\"440\"\n                     prompt=\"Select Artwork MAP\">\n    </dropdown-select>\n</div>\n");
        $templateCache.put("components/grids/default-artwork-maps-grid/cell-templates/category-type-cell-template.html", "<div class=\"cell-dropdown-container\">\n    <dropdown-select id=\"artworkCategorySelect{{$index}}\"\n                     attach-to-body=\"false\"\n                     ng-model=\"row.entity.packageCategoryType\"\n                     on-change=\"grid.appScope.$ctrl.onArtworkRowChanged(row.entity)\"\n                     collection=\"grid.appScope.$ctrl.categoryTypes\"\n                     label-field=\"name\"\n                     clearable=\"false\"\n                     btn-min-width=\"185\"\n                     prompt=\"Select Category Type\">\n    </dropdown-select>\n</div>\n");
        $templateCache.put("components/grids/default-artwork-maps-grid/cell-templates/header-check-mark-row-count-template.html", "<div class=\"ui-grid-cell-contents\"\n     col-index=\"renderIndex\"\n     ng-click=\"grid.appScope.$ctrl.onSelectAllToggled($event)\">\n    <input type=\"checkbox\"\n           ng-checked=\"grid.appScope.$ctrl.areAllRowsSelected()\"/>\n    <label>{{grid.appScope.$ctrl.gridApi.selection.getSelectedCount()}}</label>\n</div>\n");
        $templateCache.put("components/grids/serviceable-languages-grid/cell-templates/check-mark-template.html", "<!--\n - Filename: check-mark-template.html\n -\n - Created by randysorensen on 2019-04-12.\n -->\n\n<div class=\"checkbox-grid-cell\"\n     ng-click=\"grid.appScope.$ctrl.checkMarkCellClicked(row, col, $event)\">\n    <input ng-checked=\"COL_FIELD\"\n           type=\"checkbox\"/>\n    <label></label>\n</div>\n");
        $templateCache.put("components/grids/serviceable-languages-grid/cell-templates/header-check-mark-row-count-template.html", "<!--\n - Filename: header-check-mark-row-count-template.html\n -\n - Created by randysorensen on 2019-04-22.\n -->\n<div class=\"ui-grid-cell-contents\"\n     col-index=\"renderIndex\"\n     ng-click=\"grid.appScope.$ctrl.onSelectAllToggled($event)\">\n    <input type=\"checkbox\"\n           ng-checked=\"grid.appScope.$ctrl.areAllRowsSelected()\"/>\n    <label>{{grid.appScope.$ctrl.gridApi.selection.getSelectedCount()}}</label>\n</div>\n");
        $templateCache.put("components/grids/serviceable-languages-grid/cell-templates/language-name-template.html", "<!--\n - Filename: languages-name-template.html\n -\n - Created by randysorensen on 2019-04-22.\n -->\n\n<div class=\"ui-grid-cell-contents ng-scope ng-binding\"\n     ng-class=\"{\n        \'cell-contains-a-search-result\' : grid.appScope.$ctrl.cellHasASearchResult(row.entity, col.field),\n        \'cell-contains-current-search-result\' : grid.appScope.$ctrl.cellHasCurrentSearchResult(row.entity, col.field)\n     }\"\n     data-tooltip-append-to-body=\"true\"\n     uib-tooltip=\"{{COL_FIELD CUSTOM_FILTERS}}\"\n     ng-dblclick=\"grid.appScope.$ctrl.rowDoubleClick(row, column)\">\n    <span class=\"padding-left-sm\">{{(COL_FIELD? COL_FIELD: \'[Package Primary]\') CUSTOM_FILTERS}}</span>\n</div>\n");
        $templateCache.put("components/modal/externalIngest/externalIngestQueueEditorModal/external-ingest-queue-editor-modal-template.html", "<div class=\"modal-header\">\n    <h5 class=\"modal-title\">Modify External Ingest</h5>\n</div>\n\n<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\"></div>\n</div>\n\n<div class=\"edit-view-container modal-body\">\n    <form class=\"flex-col-container form-horizontal\"\n          name=\"$ctrl.editorForm\"\n          role=\"form\">\n\n        <div class=\"col-md-2\">\n            <div class=\"prism-form-heading\">General</div>\n        </div>\n\n        <!-- Priority -->\n        <div class=\"form-group padding-left-md\">\n            <label for=\"priority\"\n                   class=\"col-sm-2 control-label\">\n                Priority\n            </label>\n            <div class=\"col-sm-3 pad-text-input-col\">\n                <input\n                    class=\"form-control prism-text-input\"\n                    id=\"priority\"\n                    required\n                    ng-model=\"$ctrl.priority\"\n                    pattern=\"\\d*\"\n                    step=\"1\"\n                    type=\"number\"/>\n            </div>\n        </div>\n\n    </form>\n</div>\n\n<div class=\"modal-footer\">\n    <div class=\"flex-row-container padding-left-md\">\n        <button class=\"btn btn-default btn-sm\"\n                ng-click=\"$ctrl.cancel()\">\n            Cancel\n        </button>\n        <span class=\"flex-stretcher\"><!-- Spacer --></span>\n\n        <button class=\"btn btn-default btn-sm\"\n                ng-click=\"$ctrl.onSave()\"\n                ng-disabled=\"!$ctrl.canSave()\">\n            Save\n        </button>\n    </div>\n</div>\n");
        $templateCache.put("components/modal/externalIngest/externalIngestTypeModal/external-ingest-type-modal-template.html", "<div class=\"modal-header\">\n    <span class=\"modal-title\">Create New External Ingest</span>\n</div>\n\n<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\"></div>\n</div>\n\n<div class=\"modal-body\">\n\n\n    <div class=\"row clearfix\">\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n                <div class=\"row-no-padding\">\n                    <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n                        <div class=\"form-group\">\n                            <label for=\"externalIngestType\" class=\"col-sm-offset-1 col-sm-4 control-label\">Select\n                                External Ingest Type</label>\n                            <div class=\"col-sm-2 pad-text-input-col\">\n                                <dropdown-select id=\"externalIngestType\"\n                                                 ng-model=\"$ctrl.externalIngestType\"\n                                                 collection=\"$ctrl.externalIngestTypes\"\n                                                 btn-min-width=\"250\"\n                                                 prompt=\"Select Type\"\n                                                 label-field=\"displayName\"\n                                                 clearable=\"false\">\n                                </dropdown-select>\n                            </div>\n                        </div>\n\n                    </form>\n                </div>\n            </div>\n        </div>\n    </div>\n\n\n</div>\n\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.dismiss({$value: \'cancel\'})\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.onDone()\"\n            ng-disabled=\"$ctrl.externalIngestType === undefined\">\n        Okay\n    </button>\n</div>\n");
        $templateCache.put("components/modal/externalIngest/externalIngestRunModal/external-ingest-run-modal-template.html", "<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\"></div>\n</div>\n\n<file-select-modal\n    modal-title=\"\'Run Aggregation\'\"\n    drop-zone-label=\"\'Drop Aggregation XML Here\'\"\n    get-file-extensions=\"$ctrl.getFileExtensions()\"\n    initialize-uploader-config=\"$ctrl.initializeLocalUploaderConfig(fileUploaderConfig)\"\n    get-local-file-pre-validation-errors=\"$ctrl.getLocalFilePreValidationErrors(file, filter)\"\n    validate-local-file=\"$ctrl.validateLocalFile(fileItem)\"\n    validate-progress=\"$ctrl.validationProgress\"\n    button-sources=\"[\'LOCAL\']\"\n\n    on-cancel-clicked=\"$ctrl.onCancelClicked()\"\n    on-select-clicked=\"$ctrl.onOkClicked(fileValue)\">\n</file-select-modal>\n");
        $templateCache.put("components/modal/fileProgressModal/cellTemplates/target-package-link-cell-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding workflow-package-icon-column\" data-tooltip-append-to-body=\"true\">\n	<span>\n        <package-link-icon\n            package-id-list=\"[COL_FIELD]\"\n            package-id=\"COL_FIELD\"\n            on-navigation-started=\"grid.appScope.$ctrl.onPackageNavigationStarted()\"\n            on-navigation-ended=\"grid.appScope.$ctrl.onPackageNavigationEnded()\"\n        ></package-link-icon>\n        {{$ctrl.packageIdList}}\n	</span>\n</div>\n");
        $templateCache.put("components/modal/fileProgressModal/cellTemplates/upload-progress-cell-template.html", "<div class=\"ui-grid-cell-contents progress-container ng-scope ng-binding\" data-tooltip-append-to-body=\"true\" uib-tooltip=\"{{COL_FIELD}}%\">\n    <uib-progress class=\"prism-progress pull-left\" max=\"100\">\n        <uib-bar class=\"prism-progressbar\" value=\"COL_FIELD\"></uib-bar>\n    </uib-progress>\n</div>\n");
        $templateCache.put("components/modal/fileProgressModal/cellTemplates/upload-status-cell-template.html", "<div class=\"ui-grid-cell-contents workflow-status-icon\"\n     data-tooltip-append-to-body=\"true\"\n     uib-tooltip=\"{{COL_FIELD}}\">\n    <div data-ng-switch=\"COL_FIELD\">\n		<span class=\"fa-stack executing-status\" data-ng-switch-when=\"PENDING\">\n			<i class=\"fa fa-circle-thin fa-stack-1x\" aria-hidden=\"true\"></i>\n			<i class=\"fa fa-refresh fa-spin fa-stack-1x fa-fw\"></i>\n		</span>\n        <span class=\"fa-stack completed-status\" data-ng-switch-when=\"SUCCEEDED\">\n			<i class=\"fa fa-circle-thin fa-stack-1x\" aria-hidden=\"true\"></i>\n			<i class=\"fa fa-check fa-stack-1x\"></i>\n		</span>\n        <span class=\"fa-stack stalled-status\" data-ng-switch-when=\"FAILED\">\n			<i class=\"fa fa-square fa-stack-1x\"></i>\n			<i class=\"fa fa-exclamation-triangle fa-stack-2x\"></i>\n		</span>\n        <span class=\"fa-stack abandoned-status\" data-ng-switch-when=\"CANCELLED\">\n			<i class=\"fa fa-circle-thin fa-stack-1x\" aria-hidden=\"true\"></i>\n			<i class=\"fa fa-life-ring fa-stack-1x\" aria-hidden=\"true\"></i>\n		</span>\n        <i class=\"fa fa-cog created-status\" aria-hidden=\"true\" data-ng-switch-default></i>\n    </div>\n</div>\n");
        $templateCache.put("components/modal/security/changePasswordModal/change-password-modal-template.html", "<div class=\"modal-header\">\n    <span class=\"modal-title\">Change Password</span>\n</div>\n\n<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\"></div>\n</div>\n\n<div class=\"modal-body\">\n\n\n    <div class=\"row clearfix\">\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n                <div class=\"row-no-padding\">\n                    <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n                        <div class=\"form-group\">\n                            <label class=\"control-label col-md-4 \">Current Password</label>\n                            <div class=\"col-sm-7  pad-text-input-col\">\n                                <input type=\"password\" class=\"prism-text-input\"\n                                       ng-model=\"$ctrl.currentPasswordInput\"\n                                       autocomplete=\"new-password\"\n                                       id=\"currentPasswordInput\"/>\n                            </div>\n                            <div>\n                                <div class=\"required-text-input\"\n                                     required\n                                     x-required-indicator>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"control-label col-md-4 \">New Password</label>\n                            <div class=\"col-sm-7  pad-text-input-col\">\n                                <input type=\"password\" class=\"prism-text-input\"\n                                       ng-model=\"$ctrl.passwordInput\"\n                                       autocomplete=\"new-password\"\n                                       id=\"passwordInput\"/>\n                                <password-validation\n                                        password=\"$ctrl.passwordInput\"\n                                        password-requirements=\"$ctrl.passwordRequirements\"\n                                        is-valid=\"$ctrl.passwordInputValid\">\n                                </password-validation>\n                            </div>\n                            <div>\n                                <div class=\"required-text-input\"\n                                     required\n                                     x-required-indicator>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"control-label col-md-4 \">Retype New Password</label>\n                            <div class=\"col-sm-7  pad-text-input-col\">\n                                <input type=\"password\" class=\"prism-text-input\"\n                                       ng-model=\"$ctrl.retypedPasswordInput\"\n                                       autocomplete=\"new-password\"\n                                       id=\"retypedPasswordInput\"/>\n                                <password-validation\n                                        ng-hide=\"true\"\n                                        password=\"$ctrl.retypedPasswordInput\"\n                                        password-requirements=\"$ctrl.passwordRequirements\"\n                                        is-valid=\"$ctrl.retypedPasswordValid\">\n                                </password-validation>\n                            </div>\n                            <div>\n                                <div class=\"required-text-input\"\n                                     required\n                                     x-required-indicator>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"control-label col-md-4 \"></label>\n                            <div class=\"col-sm-7  pad-text-input-col\">\n                                <field-validation header=\"\"\n                                                  requirements=\"$ctrl.retypedPasswordRequirements\">\n                                </field-validation>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </div>\n        </div>\n    </div>\n\n\n</div>\n\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.dismiss({$value: \'cancel\'})\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.onDone()\"\n            ng-disabled=\"!$ctrl.doneEnabled()\">\n        Done\n    </button>\n</div>\n");
        $templateCache.put("components/modal/subscription-properties-modal/cellTemplates/artwork-accept-profile-cell-template.html", "<div class=\"cell-dropdown-container\">\n    <dropdown-select id=\"artworkProfileSelect{{$index}}\"\n                     btn-min-width=\"440\"\n                     attach-to-body=\"false\"\n                     ng-model=\"row.entity.artworkAcceptProfile\"\n                     collection=\"grid.appScope.$ctrl.artworkAcceptProfiles\"\n                     label-field=\"name\"\n                     prompt=\"Select Artwork MAP\">\n    </dropdown-select>\n</div>\n");
        $templateCache.put("components/modal/subscription-properties-modal/cellTemplates/artwork-cell-template.html", "<div class=\"cell-dropdown-container\">\n    <dropdown-select id=\"artworkSelect{{$index}}\"\n                     attach-to-body=\"false\"\n                     ng-model=\"row.entity.artwork\"\n                     collection=\"grid.appScope.$ctrl.artworks\"\n                     btn-min-width=\"315\"\n                     label-field=\"name\"\n                     prompt=\"Select Artwork\">\n    </dropdown-select>\n</div>\n");
        $templateCache.put("components/modal/subscription-properties-modal/cellTemplates/check-mark-header-template.html", "<div class=\"ui-grid-cell-contents\"\n     col-index=\"renderIndex\"\n     ng-click=\"grid.appScope.$ctrl.toggleRows($event, grid)\">\n    <input type=\"checkbox\" ng-checked=\"grid.selection.selectAll\"/>\n    <label>\n    </label>\n</div>\n");
        $templateCache.put("components/modal/subscription-properties-modal/cellTemplates/collaborator-check-mark-cell-template.html", "<div class=\"checkbox-grid-cell\"\n     ng-click=\"grid.appScope.$ctrl.editorForm.$setDirty()\">\n    <input type=\"checkbox\" ng-checked=\"row.isSelected\"/>\n    <label></label>\n</div>\n");
        $templateCache.put("components/modal/subscription-properties-modal/cellTemplates/collaborator-check-mark-header-cell-template.html", "<div class=\"ui-grid-cell-contents\"\n     col-index=\"renderIndex\"\n     ng-click=\"grid.appScope.$ctrl.toggleRows($event, grid, \'collaborator\')\">\n    <input type=\"checkbox\" ng-checked=\"grid.selection.selectAll\"/>\n    <label></label>\n</div>\n");
        $templateCache.put("components/modal/subscription-properties-modal/cellTemplates/season-check-mark-cell-template.html", "<div class=\"checkbox-grid-cell\"\n     ng-click=\"grid.appScope.$ctrl.editorForm.$setDirty()\">\n    <input type=\"checkbox\"\n           ng-checked=\"row.isSelected\"/><label></label>\n</div>\n");
        $templateCache.put("components/modal/subscription-properties-modal/cellTemplates/season-check-mark-header-cell-template.html", "<div class=\"ui-grid-cell-contents\"\n     col-index=\"renderIndex\"\n     ng-click=\"grid.appScope.$ctrl.toggleRows($event, grid, \'volumeSeason\')\">\n    <input type=\"checkbox\" ng-checked=\"grid.selection.selectAll\"/>\n    <label></label>\n</div>\n");
        $templateCache.put("components/modal/subscription-properties-modal/cellTemplates/volume-check-mark-cell-template.html", "<div class=\"checkbox-grid-cell\"\n     ng-click=\"grid.appScope.$ctrl.editorForm.$setDirty()\">\n    <input type=\"checkbox\" ng-checked=\"row.isSelected\"/><label></label>\n</div>\n");
        $templateCache.put("components/modal/subscription-properties-modal/cellTemplates/volume-check-mark-header-cell-template.html", "<div class=\"ui-grid-cell-contents\"\n     col-index=\"renderIndex\"\n     ng-click=\"grid.appScope.$ctrl.toggleRows($event, grid, \'volumeSeason\')\">\n    <input type=\"checkbox\" ng-checked=\"grid.selection.selectAll\"/><label></label>\n</div>\n");
        $templateCache.put("components/modal/subscription-properties-modal/renderers/ads-and-prerolls-properties-template.html", "<div class=\"edit-view-container\" ng-show=\"!$ctrl.loadingIndicator.show\">\n    <div>\n        General\n    </div>\n\n    <!-- Enabled -->\n    <div class=\"form-group\">\n        <label for=\"enabledCheckbox\" class=\"col-sm-2 control-label\">\n            Enabled\n        </label>\n        <div class=\"col-sm-8 prism-checkbox-inline\">\n            <input type=\"checkbox\"\n                   id=\"enabledCheckbox\"\n                   ng-model=\"$ctrl.subscription.enabled\"/>\n            <label class=\"control-label\"\n                   for=\"enabledCheckbox\"></label>\n        </div>\n    </div>\n\n    <!-- Priority Offset -->\n    <div class=\"form-group form-group-custom\"\n         ng-if=\"!$ctrl.batchUpdate\">\n        <label for=\"priorityOffset\" class=\"col-sm-2 control-label\">\n            Priority Offset\n        </label>\n        <input id=\"priorityOffset\" class=\"prism-text-input input-sm\" ng-model=\"$ctrl.subscription.priorityOffset\"/>\n    </div>\n\n    <!-- SLA Template -->\n    <div class=\"form-group\"\n         ng-if=\"!$ctrl.batchUpdate || $ctrl.isPartner\">\n        <label for=\"dueDateDropdown\" class=\"col-sm-2 control-label\">\n            SLA Template\n        </label>\n\n        <div class=\"col-sm-9\">\n            <dropdown-select\n                    id=\"dueDateDropdown\"\n                    btn-min-width=\"230\"\n                    ng-disabled=\"!$ctrl.availableDueDateTemplates || $ctrl.availableDueDateTemplates.length === 0\"\n                    clearable=\"true\"\n                    ng-model=\"$ctrl.subscription.dueDateTemplate\"\n                    prompt=\"Select SLA Template\"\n                    label-field=\"name\"\n                    collection=\"$ctrl.availableDueDateTemplates\">\n            </dropdown-select>\n        </div>\n    </div>\n\n    <!-- Nielsen Template -->\n    <div class=\"form-group\"\n         ng-if=\"!$ctrl.batchUpdate || $ctrl.isPartner\">\n        <label for=\"nielsenDropdown\" class=\"col-sm-2 control-label\">\n            Nielsen Template\n        </label>\n\n        <div class=\"col-sm-9\">\n					<span>\n						<dropdown-select id=\"nielsenDropdown\" btn-min-width=\"230\"\n                                         ng-disabled=\"!$ctrl.availableNielsenTemplates || $ctrl.availableNielsenTemplates.length === 0\"\n                                         ng-model=\"$ctrl.subscription.nielsenTemplate\"\n                                         prompt=\"Select Nielsen\"\n                                         label-field=\"name\"\n                                         clearable=\"true\"\n                                         collection=\"$ctrl.availableNielsenTemplates\">\n						</dropdown-select>\n					</span>\n        </div>\n    </div>\n\n    <!-- Territory Select-->\n    <div class=\"form-group\">\n        <label for=\"territoryDropDown\" class=\"col-sm-2 control-label\">\n            Territory (Override)\n        </label>\n        <div class=\"col-md-8 pad-text-input-col\">\n            <dropdown-select id=\"territoryDropDown\"\n                             sort-collection=\"false\"\n                             ng-model=\"$ctrl.subscription.territory\"\n                             prompt=\"Select Territory\" btn-min-width=\"200\" clearable=\"true\"\n                             label-field=\"name\"\n                             collection=\"$ctrl.availableTerritories\">\n            </dropdown-select>\n        </div>\n    </div>\n    <!-- Video Roles -->\n    <div class=\"form-group\"\n         ng-if=\"!$ctrl.batchUpdate\">\n        <label for=\"componentRoles\" class=\"col-sm-2 control-label\">\n            Video Roles\n        </label>\n        <div class=\"col-sm-7\">\n            <requirement-list\n                    all-entities=\"$ctrl.availableVideoRoles\"\n                    context=\"subscription\"\n                    enabled-entities=\"$ctrl.subscription.videoRoles\"\n                    entity-name=\"Video Role\"\n                    entity-prop=\"role\"\n                    id=\"componentRoles\"\n                    on-update=\"$ctrl.enabledVideoRolesUpdated(context, newEnabledEntities)\"\n                    required-flag-prop=\"isRequired\">\n            </requirement-list>\n        </div>\n    </div>\n\n    <!-- Delivery Eligibility -->\n    <div class=\"row-no-padding\">\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">\n                Delivery Eligibility\n            </label>\n\n            <div class=\"col-sm-2 padding-left-md\">\n                <input type=\"radio\" id=\"whenApprovedRadio\"\n                       name=\"deliveryEligibilityRadios\"\n                       ng-model=\"$ctrl.deliveryEligibility\"\n                       ng-value=\"false\">\n                <label class=\"control-label\" for=\"whenApprovedRadio\">\n                    When Approved\n                </label>\n            </div>\n            <div class=\"col-sm-3\">\n                <input type=\"radio\" id=\"holdDeliveryRadio\"\n                       name=\"deliveryEligibilityRadios\"\n                       ng-model=\"$ctrl.deliveryEligibility\"\n                       ng-value=\"true\">\n                <label class=\"control-label\" for=\"holdDeliveryRadio\">\n                    Hold Delivery Date Expression\n                </label>\n            </div>\n        </div>\n\n        <div class=\"form-group\" ng-if=\"$ctrl.deliveryEligibility\">\n            <label class=\"col-sm-2 control-label\"></label>\n            <div class=\"col-sm-9\">\n                <input type=\"text\"\n                       class=\"prism-text-input form-control\"\n                       ng-model=\"$ctrl.subscription.deliveryEligibilityExpression\"\n                       ng-disabled=\"!$ctrl.deliveryEligibility\">\n            </div>\n        </div>\n    </div>\n\n    <ng-include\n            src=\"\'components/modal/subscription-properties-modal/custom-metadata-container-template.html\'\"></ng-include>\n\n</div>\n");
        $templateCache.put("components/modal/subscription-properties-modal/renderers/series-movie-subscription-properties-template.html", "<div class=\"edit-view-container\"\n     ng-show=\"!$ctrl.loadingIndicator.show\">\n    <div>\n        General\n    </div>\n\n    <!-- Enabled -->\n    <div class=\"form-group\">\n        <label for=\"enabledCheckbox\"\n               class=\"col-sm-2 control-label\">\n            Enabled\n        </label>\n        <div class=\"col-sm-8 prism-checkbox-inline\">\n            <input type=\"checkbox\"\n                   id=\"enabledCheckbox\"\n                   ng-model=\"$ctrl.subscription.enabled\"/>\n            <label class=\"control-label\"\n                   for=\"enabledCheckbox\"></label>\n        </div>\n    </div>\n\n    <!-- Priority Offset -->\n    <div class=\"form-group form-group-custom\"\n         ng-if=\"!$ctrl.batchUpdate\">\n        <label for=\"priorityOffset\"\n               class=\"col-sm-2 control-label\">\n            Priority Offset\n        </label>\n        <input id=\"priorityOffset\"\n               class=\"prism-text-input input-sm\"\n               ng-model=\"$ctrl.subscription.priorityOffset\"/>\n    </div>\n\n    <!-- SLA Template -->\n    <div class=\"form-group\"\n         ng-if=\"!$ctrl.batchUpdate || $ctrl.isPartner\">\n        <label for=\"dueDateDropdown\"\n               class=\"col-sm-2 control-label\">\n            SLA Template\n        </label>\n\n        <div class=\"col-sm-9 pad-text-input-col\">\n            <dropdown-select\n                    id=\"dueDateDropdown\"\n                    btn-min-width=\"230\"\n                    ng-disabled=\"!$ctrl.availableDueDateTemplates || $ctrl.availableDueDateTemplates.length === 0\"\n                    clearable=\"true\"\n                    ng-model=\"$ctrl.subscription.dueDateTemplate\"\n                    prompt=\"Select SLA Template\"\n                    label-field=\"name\"\n                    collection=\"$ctrl.availableDueDateTemplates\">\n            </dropdown-select>\n        </div>\n    </div>\n\n    <!-- Nielsen Template -->\n    <div class=\"form-group\"\n         ng-if=\"!$ctrl.batchUpdate || $ctrl.isPartner\">\n        <label for=\"nielsenDropdown\"\n               class=\"col-sm-2 control-label\">\n            Nielsen Template\n        </label>\n        <div class=\"col-sm-9 pad-text-input-col\">\n            <dropdown-select\n                id=\"nielsenDropdown\"\n                btn-min-width=\"230\"\n                ng-disabled=\"!$ctrl.availableNielsenTemplates || $ctrl.availableNielsenTemplates.length === 0\"\n                ng-model=\"$ctrl.subscription.nielsenTemplate\"\n                prompt=\"Select Nielsen\"\n                label-field=\"name\"\n                clearable=\"true\"\n                collection=\"$ctrl.availableNielsenTemplates\">\n            </dropdown-select>\n        </div>\n    </div>\n\n    <!-- NexGuard Enabled -->\n    <div class=\"form-group\">\n        <label for=\"nexGuardEnabledCheckbox\"\n               class=\"col-sm-2 control-label\">\n            NexGuard Enabled\n        </label>\n        <div class=\"col-sm-8 prism-checkbox-inline\">\n            <input type=\"checkbox\"\n                   id=\"nexGuardEnabledCheckbox\"\n                   ng-model=\"$ctrl.subscription.nexGuardEnabledFlag\"/>\n            <label class=\"control-label\"\n                   for=\"nexGuardEnabledCheckbox\"></label>\n        </div>\n    </div>\n\n    <!-- Watermark -->\n    <div class=\"form-group\"\n         ng-if=\"!$ctrl.batchUpdate || $ctrl.isPartner\">\n        <label for=\"watermarkDropdown\"\n               class=\"col-sm-2 control-label\">\n            Watermark\n        </label>\n\n        <div class=\"col-sm-9\">\n            <dropdown-select\n                id=\"watermarkDropdown\"\n                ng-disabled=\"!$ctrl.availableWatermarks || $ctrl.availableWatermarks.length === 0\"\n                clearable=\"true\"\n                ng-model=\"$ctrl.subscription.watermark\"\n                prompt=\"Select Watermark\"\n                label-field=\"name\"\n                btn-min-width=\"230\"\n                collection=\"$ctrl.availableWatermarks\">\n            </dropdown-select>\n            <label class=\"prism-checkbox-inline\"\n                   ng-if=\"$ctrl.content && $ctrl.content.type !== \'Movie/Special\'\">\n                <input id=\"watermarkCheckbox\"\n                       type=\"checkbox\"\n                       ng-model=\"$ctrl.subscription.watermarkSeasonVolume\"\n                       ng-disabled=\"!$ctrl.subscription.watermark\"/>\n                <label for=\"watermarkCheckbox\">\n                    Use Season/Volume\n                </label>\n            </label>\n        </div>\n    </div>\n\n    <!-- Watermark Durations -->\n    <div class=\"form-group form-group-custom\"\n         ng-if=\"!$ctrl.batchUpdate || $ctrl.isPartner\">\n        <label for=\"waterMarkInOutOffset\"\n               class=\"col-sm-2 control-label\">\n            Watermark Durations\n        </label>\n        <div id=\"waterMarkInOutOffset\"\n             class=\"col-sm-9\">\n            Fade In: <input id=\"watermarkFadeIn\"\n                            class=\"prism-text-input input-sm\"\n                            ng-model=\"$ctrl.subscription.watermarkFadeInSeconds\"/>\n            Fade Out: <input id=\"watermarkFadeOut\"\n                             class=\"prism-text-input input-sm\"\n                             ng-model=\"$ctrl.subscription.watermarkFadeOutSeconds\"/>\n            Fade Offset: <input id=\"watermarkOffset\"\n                                class=\"prism-text-input input-sm\"\n                                ng-model=\"$ctrl.subscription.watermarkOffsetSeconds\"/>\n        </div>\n    </div>\n\n    <!-- Pre-Roll -->\n    <div class=\"form-group\">\n        <label for=\"preRollDropdown\"\n               class=\"col-sm-2 control-label\">\n            Pre-Roll\n        </label>\n\n        <div class=\"col-sm-9\">\n            <dropdown-select\n                id=\"preRollDropdown\"\n                ng-disabled=\"!$ctrl.availablePrerolls || $ctrl.availablePrerolls.length === 0\"\n                clearable=\"true\"\n                ng-model=\"$ctrl.subscription.preRoll\"\n                prompt=\"Select Preroll\"\n                label-field=\"name\"\n                btn-min-width=\"230\"\n                collection=\"$ctrl.availablePrerolls\">\n            </dropdown-select>\n            <span ng-if=\"$ctrl.content && $ctrl.content.type !== \'Movie/Special\'\">\n                <label class=\"prism-checkbox-inline\">\n                    <input id=\"preRollCheckbox\"\n                           type=\"checkbox\"\n                           ng-model=\"$ctrl.subscription.preRollSeasonVolume\"\n                           ng-disabled=\"!$ctrl.subscription.preRoll\"/>\n                    <label for=\"preRollCheckbox\">\n                        Use Season/Volume\n                    </label>\n                </label>\n            </span>\n        </div>\n    </div>\n\n    <!-- Post-Roll -->\n    <div class=\"form-group\">\n        <label for=\"postRollDropdown\"\n               class=\"col-sm-2 control-label\">\n            Post-Roll\n        </label>\n\n        <div class=\"col-sm-9\">\n            <dropdown-select\n                id=\"postRollDropdown\"\n                ng-disabled=\"!$ctrl.availablePostrolls || $ctrl.availablePostrolls.length === 0\"\n                clearable=\"true\"\n                ng-model=\"$ctrl.subscription.postRoll\"\n                prompt=\"Select Postroll\"\n                label-field=\"name\"\n                btn-min-width=\"230\"\n                collection=\"$ctrl.availablePostrolls\">\n            </dropdown-select>\n            <span ng-if=\"$ctrl.content && $ctrl.content.type !== \'Movie/Special\'\">\n                <label class=\"prism-checkbox-inline\">\n                    <input id=\"postRollCheckbox\"\n                           type=\"checkbox\"\n                           ng-model=\"$ctrl.subscription.postRollSeasonVolume\"\n                           ng-disabled=\"!$ctrl.subscription.postRoll\"/>\n                    <label for=\"postRollCheckbox\">\n                        Use Season/Volume\n                    </label>\n                </label>\n            </span>\n        </div>\n    </div>\n\n    <!-- Break Pre/Postrolls -->\n    <div class=\"form-group\">\n        <div class=\"break-branding-label\">\n            <label for=\"breakPrePostRollDropdown\"\n                   class=\"col-sm-2 control-label\">\n                Break Pre/PostRoll\n            </label>\n        </div>\n\n        <div class=\"col-sm-9\">\n            <dropdown-select\n                id=\"breakPrePostRollDropdown\"\n                ng-disabled=\"!$ctrl.availableBreakPrePostRolls ||\n                                    $ctrl.availableBreakPrePostRolls.length === 0\"\n                clearable=\"true\"\n                ng-model=\"$ctrl.subscription.breakPrePostRoll\"\n                prompt=\"Select Break Pre/Postroll\"\n                label-field=\"name\"\n                btn-min-width=\"230\"\n                collection=\"$ctrl.availableBreakPrePostRolls\">\n            </dropdown-select>\n            <span ng-if=\"$ctrl.content && $ctrl.content.type !== \'Movie/Special\'\">\n                <label class=\"prism-checkbox-inline\">\n                    <input id=\"breakPrePostRollCheckbox\"\n                           type=\"checkbox\"\n                           ng-model=\"$ctrl.subscription.breakPrePostRollSeasonVolume\"\n                           ng-disabled=\"!$ctrl.subscription.breakPrePostRoll\"/>\n                    <label for=\"breakPrePostRollCheckbox\">\n                        Use Season/Volume\n                    </label>\n                </label>\n            </span>\n        </div>\n    </div>\n\n    <!-- Master Intermediate Template -->\n    <div class=\"form-group\"\n         ng-if=\"!$ctrl.batchUpdate\">\n        <label for=\"masterIntermediateDropdown\"\n               class=\"col-sm-2 control-label\">\n            Master Template\n        </label>\n\n        <div class=\"col-sm-9 pad-text-input-col\">\n            <dropdown-select\n                id=\"masterIntermediateDropdown\"\n                ng-disabled=\"!$ctrl.availableIntermediateTemplates || $ctrl.availableIntermediateTemplates.length === 0\"\n                clearable=\"true\"\n                ng-model=\"$ctrl.subscription.intermediateVideoTemplate\"\n                prompt=\"Select Master Template\"\n                label-field=\"name\"\n                btn-min-width=\"230\"\n                collection=\"$ctrl.availableIntermediateTemplates\">\n            </dropdown-select>\n        </div>\n    </div>\n\n    <!-- Multiple Territory Select-->\n    <div class=\"form-group\">\n        <label for=\"territoriesDropDown\"\n               class=\"col-sm-2 control-label\">\n            Territories (Override)\n        </label>\n        <div class=\"col-md-8 pad-text-input-col\">\n            <multiselect-dropdown\n                id=\"territoriesDropDown\"\n                sort-collection=\"false\"\n                ng-model=\"$ctrl.subscription.territories\"\n                prompt=\"Select Territories\"\n                btn-min-width=\"200\"\n                clearable=\"true\"\n                label-field=\"name\"\n                collection=\"$ctrl.availableTerritories\">\n            </multiselect-dropdown>\n        </div>\n    </div>\n\n    <!-- Languages -->\n    <div class=\"form-group\">\n        <label for=\"languagesGrid\"\n               class=\"col-lg-2 control-label\">\n            Languages\n        </label>\n        <div class=\"col-lg-9\">\n            <div class=\"column-sm-8\"\n                 ng-if=\"$ctrl.batchUpdate\">\n                <label class=\"prism-checkbox-inline\">\n                    <input id=\"updateLanguagesCheckbox\"\n                           type=\"checkbox\"\n                           ng-model=\"$ctrl.isChangingLanguages\"/>\n                    <label for=\"updateLanguagesCheckbox\">\n                        Update Serviceable Languages\n                    </label>\n                </label>\n            </div>\n            <serviceable-languages-grid\n                class=\"languages-grid\"\n                id=\"languagesGrid\"\n                ng-disabled=\"!$ctrl.isChangingLanguages\"\n                on-serviceable-languages-changed=\"$ctrl.onServiceableLanguagesChanged(validServiceableLanguages)\"\n                serviceable-languages=\"$ctrl.availableServiceableLanguages\"\n                is-radio-group-empty=\"$ctrl.hasNoLanguages\">\n            </serviceable-languages-grid>\n        </div>\n    </div>\n\n    <!-- Video Roles -->\n    <div class=\"form-group\"\n         ng-if=\"!$ctrl.batchUpdate\">\n        <label for=\"componentRoles\"\n               class=\"col-sm-2 control-label\">\n            Video Roles\n        </label>\n        <div class=\"col-sm-7 pad-text-input-col\">\n            <requirement-list\n                all-entities=\"$ctrl.availableVideoRoles\"\n                context=\"subscription\"\n                enabled-entities=\"$ctrl.subscription.videoRoles\"\n                entity-name=\"Video Role\"\n                entity-prop=\"role\"\n                id=\"componentRoles\"\n                on-update=\"$ctrl.enabledVideoRolesUpdated(context, newEnabledEntities)\"\n                required-flag-prop=\"isRequired\">\n            </requirement-list>\n        </div>\n    </div>\n\n    <!-- Artwork -->\n    <div class=\"form-group\"\n         ng-if=\"!$ctrl.batchUpdate\">\n        <label for=\"contentArtwork\"\n               class=\"col-sm-2 control-label\">\n            Artwork\n        </label>\n        <div class=\"col-sm-9 pad-text-input-col\">\n            <form class=\"form-horizontal\"\n                  role=\"form\">\n                <div class=\"form-group\">\n                    <button id=\"addContentArtwork\"\n                            class=\"btn btn-default prism-button\"\n                            ng-click=\"$ctrl.addArtwork()\">\n                        <i class=\"fa fa-plus\"></i>\n                    </button>\n                    <button id=\"removeContentArtwork\"\n                            class=\"btn btn-default prism-button\"\n                            ng-click=\"$ctrl.removeArtwork()\">\n                        <i class=\"fa fa-minus\"></i>\n                    </button>\n\n                    <hr/>\n\n                    <div>\n                        <div id=\"contentArtwork\"\n                             ui-grid=\"$ctrl.artworkGridOptions\"\n                             class=\"search-grid top-margin-xs\"\n                             ui-grid-selection\n                             ui-grid-auto-resize\n                             style=\"height: 450px;\">\n                        </div>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n\n    <!-- Delivery Eligibility -->\n    <div class=\"row-no-padding\">\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">\n                Delivery Eligibility\n            </label>\n\n            <div class=\"col-sm-2 padding-left-md\">\n                <input type=\"radio\"\n                       id=\"whenApprovedRadio\"\n                       name=\"deliveryEligibilityRadios\"\n                       ng-model=\"$ctrl.deliveryEligibility\"\n                       ng-value=\"false\">\n                <label class=\"control-label\"\n                       for=\"whenApprovedRadio\">\n                    When Approved\n                </label>\n            </div>\n            <div class=\"col-sm-3\">\n                <input type=\"radio\"\n                       id=\"holdDeliveryRadio\"\n                       name=\"deliveryEligibilityRadios\"\n                       ng-model=\"$ctrl.deliveryEligibility\"\n                       ng-value=\"true\">\n                <label class=\"control-label\"\n                       for=\"holdDeliveryRadio\">\n                    Hold Delivery Date Expression\n                </label>\n            </div>\n        </div>\n\n        <div class=\"form-group\"\n             ng-if=\"$ctrl.deliveryEligibility\">\n            <label class=\"col-sm-2 control-label\"></label>\n            <div class=\"col-sm-9\">\n                <input type=\"text\"\n                       class=\"prism-text-input form-control\"\n                       ng-model=\"$ctrl.subscription.deliveryEligibilityExpression\"\n                       ng-disabled=\"!$ctrl.deliveryEligibility\">\n            </div>\n        </div>\n    </div>\n\n    <!-- Required Collaborators -->\n    <div class=\"form-group no-margin-bottom\"\n         ng-if=\"!$ctrl.batchUpdate\">\n\n        <label for=\"requireCollaboratorsGrid\"\n               class=\"col-sm-2 control-label\">\n            Required Collaborators\n        </label>\n        <div class=\"col-sm-1 padding-left-md\">\n            <input type=\"radio\"\n                   id=\"allCollaboratorsRadio\"\n                   name=\"collaboratorRadios\"\n                   ng-model=\"$ctrl.allCollaborators\"\n                   ng-value=\"true\">\n            <label class=\"control-label\"\n                   for=\"allCollaboratorsRadio\">\n                All\n            </label>\n        </div>\n        <div class=\"col-sm-2\">\n            <input type=\"radio\"\n                   id=\"customCollaboratorsRadio\"\n                   name=\"collaboratorRadios\"\n                   ng-model=\"$ctrl.allCollaborators\"\n                   ng-value=\"false\">\n            <label class=\"control-label\"\n                   for=\"customCollaboratorsRadio\">\n                Custom\n            </label>\n        </div>\n\n    </div>\n\n    <div class=\"form-group\"\n         ng-if=\"!$ctrl.batchUpdate\">\n\n        <label class=\"col-sm-2 control-label\"></label>\n        <div class=\"col-sm-7\">\n            <fieldset ng-disabled=\"$ctrl.allCollaborators\">\n                <div id=\"requireCollaboratorsGrid\"\n                     ui-grid=\"$ctrl.collaboratorGridOptions\"\n                     class=\"inline-checkbox-grid\"\n                     ng-class=\"{\'protected-grid\': $ctrl.allCollaborators}\"\n                     ui-grid-selection\n                     ui-grid-auto-resize>\n                </div>\n            </fieldset>\n        </div>\n\n    </div>\n\n    <!-- Subscription Type -->\n    <fieldset>\n        <div class=\"form-group\"\n             ng-if=\"!$ctrl.batchUpdate && $ctrl.content.type !== \'Movie/Special\'\">\n\n            <label class=\"col-sm-2 control-label\">\n                Type\n            </label>\n            <div class=\"padding-left-md condensed-label\">\n                <input type=\"radio\"\n                       id=\"seasonRadio\"\n                       name=\"typeRadios\"\n                       ng-model=\"$ctrl.subscription.seasonSubscription\"\n                       ng-value=\"true\"\n                       ng-change=\"$ctrl.typeChange()\">\n                <label class=\"control-label\"\n                       for=\"seasonRadio\">\n                    Season\n                </label>\n            </div>\n            <div class=\"padding-left-sm condensed-label\">\n                <input type=\"radio\"\n                       id=\"volumeRadio\"\n                       name=\"typeRadios\"\n                       ng-model=\"$ctrl.subscription.seasonSubscription\"\n                       ng-value=\"false\"\n                       ng-change=\"$ctrl.typeChange()\">\n                <label class=\"control-label\"\n                       for=\"volumeRadio\">\n                    Volume\n                </label>\n            </div>\n\n        </div>\n\n\n        <!-- Seasons / Volumes -->\n        <div class=\"form-group no-margin-bottom\"\n             ng-if=\"!$ctrl.batchUpdate && $ctrl.content.type === \'Series\'\">\n\n            <label for=\"volumeSeasonGrid\"\n                   class=\"col-sm-2 control-label\">\n                Include {{$ctrl.subscription.seasonSubscription ? \'Season\' : \'Volume\'}}\n            </label>\n            <div class=\"col-sm-1 padding-left-md\">\n                <input type=\"radio\"\n                       id=\"allSeasonVolumeRadio\"\n                       name=\"seasonVolumeRadios\"\n                       ng-model=\"$ctrl.allSeasonVolume\"\n                       ng-value=\"true\">\n                <label class=\"control-label\"\n                       for=\"allSeasonVolumeRadio\">\n                    All\n                </label>\n            </div>\n            <div class=\"col-sm-2\">\n                <input type=\"radio\"\n                       id=\"customSeasonVolumeRadio\"\n                       name=\"seasonVolumeRadios\"\n                       ng-model=\"$ctrl.allSeasonVolume\"\n                       ng-value=\"false\">\n                <label class=\"control-label\"\n                       for=\"customSeasonVolumeRadio\">\n                    Custom\n                </label>\n            </div>\n\n        </div>\n\n        <div class=\"form-group\"\n             ng-if=\"!$ctrl.batchUpdate && $ctrl.content.type === \'Series\'\">\n            <label class=\"col-sm-2 control-label\"></label>\n            <div class=\"col-sm-8\">\n                <fieldset ng-disabled=\"$ctrl.allSeasonVolume\">\n                    <div id=\"volumeSeasonGrid\"\n                         ui-grid=\"$ctrl.volumeSeasonGridOptions\"\n                         class=\"inline-checkbox-grid\"\n                         ng-class=\"{\'protected-grid\': true}\"\n                         ui-grid-selection\n                         ui-grid-auto-resize>\n                    </div>\n                </fieldset>\n            </div>\n        </div>\n    </fieldset>\n\n    <ng-include src=\"\'components/modal/subscription-properties-modal/custom-metadata-container-template.html\'\"></ng-include>\n\n</div>\n\n");
        $templateCache.put("components/visual/conversionTemplateDropdown/templates/conversion-tooltip-template.html", "<form role=\"form\" class=\"form-horizontal\">\n    <div class=\"edit-view-container\">\n        <!-- Description -->\n        <div class=\"description-tooltip\">{{tooltipData.description || \'(none)\'}}\n        </div>\n    </div>\n</form>\n");
        $templateCache.put("components/visual/dateTimeEnhanced/templates/date-enhanced-renderer-template.html", "\n<fieldset class=\"col-sm-10 date-enhanced no-padding\"\n		  ng-disabled=\"dateTimeEnhancedCtrl.isLockedDate || dateTimeEnhancedCtrl.componentDisabled\">\n\n	<!-- Date/Time Radio Button -->\n	<div class=\"col-sm-1 radio-column auto-width\">\n		<input id=\"{{dateTimeEnhancedCtrl.componentName + \'idRegular\'}}\"\n			   type=\"radio\"\n			   name=\"{{dateTimeEnhancedCtrl.componentName + \'btn-group\'}}\"\n			   ng-model=\"dateTimeEnhancedCtrl.isRegularDate\"\n			   ng-value=\"true\"\n			   ng-change=\"dateTimeEnhancedCtrl.dateChanged(\'date\')\"/>\n		<label for=\"{{dateTimeEnhancedCtrl.componentName + \'idRegular\'}}\" class=\"control-label\"></label>\n	</div>\n\n	<!-- Date Picker -->\n	<div class=\"col-sm-7 no-padding top-margin-xs\">\n		<date-picker ng-change=\"dateTimeEnhancedCtrl.dateChanged(\'date\')\"\n					 disabled=\"dateTimeEnhancedCtrl.isNoneDate\"\n					 ng-model=\"dateTimeEnhancedCtrl.datePart\"\n					 cal-btn-id=\"dateTimeEnhancedCtrl.calBtnId\"\n					 timezone-offset-millis=\"\'SERVER\'\">\n		</date-picker>\n	</div>\n\n	<!-- \"None\" Radio Button -->\n	<div class=\"col-sm-1 none-radio\">\n		<input id=\"{{dateTimeEnhancedCtrl.componentName + \'idNone\'}}\" type=\"radio\"\n			   name=\"{{dateTimeEnhancedCtrl.componentName + \'btn-group\'}}\"\n			   ng-model=\"dateTimeEnhancedCtrl.isNoneDate\"\n			   ng-value=\"true\"\n			   ng-change=\"dateTimeEnhancedCtrl.dateChanged(\'none\')\"/>\n		<label for=\"{{dateTimeEnhancedCtrl.componentName + \'idNone\'}}\" class=\"control-label\">None</label>\n	</div>\n\n	<!-- Lock Control -->\n	<!--\n\n		ABC-6968 - Hide lock control.\n\n	  -->\n	<!--<div class=\"col-sm-1 spacer-top-xsm no-padding lock-width-sm\">-->\n		<!--<ui-lock is-locked=\"dateTimeEnhancedCtrl.isLockedDate\"-->\n				 <!--ng-disabled=\"dateTimeEnhancedCtrl.componentDisabled\"-->\n				 <!--click-handler=\"dateTimeEnhancedCtrl.handleLockChange()\">-->\n		<!--</ui-lock>-->\n	<!--</div>-->\n\n</fieldset>\n");
        $templateCache.put("components/visual/dateTimeEnhanced/templates/date-time-enhanced-renderer-template.html", "<fieldset class=\"col-sm-10 no-padding date-time-enhanced\"\n		  ng-disabled=\"dateTimeEnhancedCtrl.isLockedDate || dateTimeEnhancedCtrl.componentDisabled\">\n\n	<!-- Date/Time Radio Button -->\n	<div class=\"col-sm-1 radio-column auto-width\">\n		<input id=\"{{dateTimeEnhancedCtrl.componentName + \'idRegular\'}}\"\n			   type=\"radio\"\n			   name=\"{{dateTimeEnhancedCtrl.componentName + \'btn-group\'}}\"\n			   ng-model=\"dateTimeEnhancedCtrl.isRegularDate\"\n			   ng-value=\"true\"\n			   ng-change=\"dateTimeEnhancedCtrl.dateChanged(\'date\')\"/>\n		<label for=\"{{dateTimeEnhancedCtrl.componentName + \'idRegular\'}}\" class=\"control-label\"></label>\n	</div>\n\n	<!-- Date Picker -->\n	<div class=\"col-sm-4 no-left-padding top-margin-xs\">\n		<date-picker ng-change=\"dateTimeEnhancedCtrl.dateChanged(\'date\')\"\n					 disabled=\"dateTimeEnhancedCtrl.isNoneDate\"\n					 ng-model=\"dateTimeEnhancedCtrl.datePart\"\n					 cal-btn-id=\"dateTimeEnhancedCtrl.calBtnId\">\n		</date-picker>\n	</div>\n\n	<!-- Time Picker -->\n	<fieldset class=\"col-sm-3 no-padding time-component-md top-margin\"\n			  ng-disabled=\"dateTimeEnhancedCtrl.isNoneDate\">\n		<div uib-timepicker class=\"timepicker col-sm-3 time-component-md\"\n			 ng-model=\"dateTimeEnhancedCtrl.datePart\"\n			 ng-change=\"dateTimeEnhancedCtrl.dateChanged(\'time\')\"\n			 hour-step=\"1\" minute-step=\"15\" show-meridian=\"true\"\n			 mousewheel=\"false\" arrowkeys=\"false\"\n			 template-url=\"components/visual/timepicker/prism-timepicker-template.html\">\n		</div>\n	</fieldset>\n\n	<!-- \"None\" Radio Button -->\n	<div class=\"col-sm-1 none-radio\">\n		<input id=\"{{dateTimeEnhancedCtrl.componentName + \'idNone\'}}\"\n			   type=\"radio\"\n			   name=\"{{dateTimeEnhancedCtrl.componentName + \'btn-group\'}}\"\n			   ng-model=\"dateTimeEnhancedCtrl.isNoneDate\"\n			   ng-value=\"true\"\n			   ng-change=\"dateTimeEnhancedCtrl.dateChanged(\'none\')\"/>\n		<label for=\"{{dateTimeEnhancedCtrl.componentName + \'idNone\'}}\" class=\"control-label\">None </label>\n	</div>\n\n	<!-- Lock Control -->\n	<!--\n\n		ABC-6968 - Hide lock control.\n\n	  -->\n	<!--<div class=\"col-sm-1 spacer-top-xsm no-padding lock-width-sm\">-->\n		<!--<ui-lock is-locked=\"dateTimeEnhancedCtrl.isLockedDate\"-->\n				 <!--ng-disabled=\"dateTimeEnhancedCtrl.componentDisabled\"-->\n				 <!--click-handler=\"dateTimeEnhancedCtrl.handleLockChange()\">-->\n		<!--</ui-lock>-->\n	<!--</div>-->\n\n</fieldset>\n");
        $templateCache.put("components/visual/dropdown/dropdownButton/dropdown-button-template.html", "<div class=\"btn-group\">\n    <button\n        type=\"button\"\n        class=\"btn btn-default prism-button dropdown-toggle flex-row-container\"\n        ng-disabled=\"$ctrl.isDisabled\"\n        ng-click=\"$ctrl.toggleDropDown($event)\"\n        ng-style=\"{\'min-width\': $ctrl.btnMinWidth +\'px\'}\"\n    >\n        <div class=\"flex-truncate-text\">\n            {{$ctrl.getButtonText()}}\n        </div>\n        <div class=\"flex-stretcher\" style=\"min-width: 5px;\">\n        </div>\n        <i class=\"fa fa-sort dropdown-arrows\"></i>\n    </button>\n\n    <a\n        class=\"fa-stack clear-dropdown\"\n        ng-show=\"$ctrl.canClearSelection()\"\n        ng-disabled=\"$ctrl.isDisabled\"\n        ng-click=\"$ctrl.onClearClicked($event)\"\n        href=\"\"\n    >\n        <i class=\"fa fa-circle fa-stack-1x\"></i>\n        <i class=\"fa fa-times fa-stack-1x\"></i>\n    </a>\n</div>\n");
        $templateCache.put("components/visual/dropdown/dropdownList/dropdown-list-template.html", "<div class=\"flex-col-container\"\n     ng-style=\"{\'maxHeight\': $ctrl.maxHeightStyle}\">\n    <!-- Multi Select: Default select all template -->\n    <!-- TODO: Don\'t forget transclude Select All transclude template! -->\n    <div role=\"menuitem\"\n         ng-if=\"$ctrl.dropdownConfig.isMultiSelect\"\n         ng-click=\"$ctrl.onSelectAllClicked()\">\n        <div class=\"checkbox\">\n            <input type=\"checkbox\"\n                   ng-checked=\"$ctrl.areAllItemsSelected()\"/>\n            <label>Select All</label>\n        </div>\n    </div>\n\n    <div role=\"menuitem\"\n        ng-repeat=\"item in ($ctrl.dropdownConfig.collection | filter:$ctrl.shouldShowItem) track by $index\"\n        ng-class=\"{\'item-selected\': $ctrl.isItemSelected(item)}\"\n        ng-click=\"$ctrl.onItemClicked(item)\"\n        ng-transclude=\"dropdown-option\"\n    >\n        <!-- Single Select: Default option template -->\n        <a ng-if=\"!$ctrl.dropdownConfig.isMultiSelect\"\n           href=\"#\">\n            {{$ctrl.getItemLabel(item)}}\n        </a>\n\n        <!-- Multi Select: Default option template -->\n        <div ng-if=\"$ctrl.dropdownConfig.isMultiSelect\"\n             class=\"checkbox\">\n            <input type=\"checkbox\"\n                   ng-checked=\"$ctrl.isItemSelected(item)\"\n                   ng-disabled=\"$ctrl.isItemDisabled(item)\"/>\n            <label>\n                {{$ctrl.getItemLabel(item)}}\n            </label>\n        </div>\n\n        <!-- // TODO: Dividers? -->\n    </div>\n</div>\n");
        $templateCache.put("components/visual/emailRecipientsList/gridTemplates/networks-list-cell-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\"\n	 data-tooltip-append-to-body=\"true\"\n	 uib-tooltip=\"{{grid.appScope.$ctrl.getNetworksList(row.entity).join(\', \')}}\">\n	<span>{{grid.appScope.$ctrl.getNetworksList(row.entity).join(\', \')}}</span>\n</div>\n");
        $templateCache.put("components/visual/emailRecipientsList/modals/partner-email-recipient-modal-template.html", "<div class=\"modal-header\">\n	<a id=\"partnerEmailRecipientModalXBtn\"\n	   href=\"\"\n	   ng-click=\"$ctrl.dismiss({$value: \'cancel\'})\">\n		<i class=\"fa fa-times pull-right\"></i>\n	</a>\n	<span class=\"modal-title\">\n		Email Recipient\n	</span>\n</div>\n\n<div class=\"modal-body\">\n\n	<!-- Pacifier -->\n	<div class=\"loadingIndicator\">\n		<div data-lb-progress=\"$ctrl.loadingIndicator\"\n			 ng-show=\"$ctrl.loadingIndicator.show\">\n		</div>\n	</div>\n\n	<form role=\"form\"\n		  class=\"form-horizontal\"\n		  name=\"$ctrl.editorForm\">\n\n		<!-- Name -->\n		<div class=\"form-group\">\n			<label class=\"col-sm-3 prism-form-item-label text-align-right\"\n				   for=\"contactName\">\n				Name\n			</label>\n\n			<div class=\"col-sm-9 padding-left-md\"\n				 id=\"contactName\">\n				{{$ctrl.recipientObject.contact.lastName}},&nbsp;{{$ctrl.recipientObject.contact.firstName}}\n			</div>\n		</div>\n\n		<!-- Title -->\n		<div class=\"form-group\">\n			<label class=\"col-sm-3 prism-form-item-label text-align-right\"\n				   for=\"contactTitle\">\n				Title\n			</label>\n\n			<div class=\"col-sm-9 padding-left-md\"\n				 id=\"contactTitle\">\n				{{$ctrl.recipientObject.contact.title}}\n			</div>\n		</div>\n\n		<!-- Email -->\n		<div class=\"form-group\">\n			<label class=\"col-sm-3 prism-form-item-label text-align-right\"\n				   for=\"contactEmail\">\n				Email Address\n			</label>\n\n			<div class=\"col-sm-9 padding-left-md\"\n				 id=\"contactEmail\">\n				{{$ctrl.recipientObject.contact.emailAddress}}\n			</div>\n		</div>\n\n		<!-- Networks -->\n		<div class=\"form-group\">\n			<label class=\"col-sm-3 prism-form-item-label text-align-right\"\n				   for=\"applicableNetworks\">\n				Networks\n			</label>\n			<div class=\"col-sm-9\">\n				<multiselect-dropdown\n					id=\"applicableNetworks\"\n					collection=\"$ctrl.availableNetworks\"\n					ng-model=\"$ctrl.recipientObject.applicableNetworks\"\n					prompt=\"Select applicable networks\"\n					enable-select-all=\"true\"\n					clearable=\"true\"\n					label-field=\"name\"\n					btn-min-width=\"300\">\n				</multiselect-dropdown>\n			</div>\n		</div>\n\n		<div class=\"form-group v-align\">\n			<label class=\"col-sm-3 prism-form-item-label text-align-right\"\n				   for=\"longFormFlag\">\n				Category Types\n			</label>\n\n			<div class=\"col-sm-9 row\">\n				<!-- Long Form Flag -->\n				<label class=\"col-sm-3 prism-form-item-label text-align-right\"\n					   for=\"longFormFlag\">\n					Long Form\n				</label>\n\n				<div class=\"col-sm-3\">\n					<input type=\"checkbox\"\n						   id=\"longFormFlag\"\n						   ng-model=\"$ctrl.recipientObject.longFormFlag\"/>\n					<label for=\"longFormFlag\"\n						   class=\"control-label\">\n					</label>\n				</div>\n\n				<!-- Short Form Flag -->\n				<label class=\"col-sm-3 prism-form-item-label text-align-right\"\n					   for=\"shortFormFlag\">\n					Short Form\n				</label>\n\n				<div class=\"col-sm-3\">\n					<input type=\"checkbox\"\n						   id=\"shortFormFlag\"\n						   ng-model=\"$ctrl.recipientObject.shortFormFlag\"/>\n					<label for=\"shortFormFlag\"\n						   class=\"control-label\">\n					</label>\n				</div>\n			</div>\n		</div>\n\n	</form>\n\n</div>\n\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.dismiss({$value: \'cancel\'})\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.onOk()\">\n        OK\n    </button>\n</div>\n");
        $templateCache.put("components/visual/icon/packageLinkIcon/package-link-icon-template.html", "<i\n        class=\"fa fa-cube pkg-link-icon\"\n        ng-click=\"$ctrl.onClick($event)\"\n        ng-if=\"$ctrl.packageIdList && $ctrl.packageIdList.length === 1\">\n</i>\n<i\n        class=\"fa fa-cube pkg-filter-link-icon\"\n        ng-click=\"$ctrl.onClick($event)\"\n        ng-if=\"$ctrl.packageIdList && $ctrl.packageIdList.length > 1\">\n</i>\n");
        $templateCache.put("components/visual/requirementList/gridCells/required-column-grid-cell-template.html", "<div class=\"checkbox-cell\"\n     ng-click=\"grid.appScope.$ctrl.onEntityRequireClicked(row, $event)\">\n    <div>\n        <input type=\"checkbox\"\n               ng-checked=\"row.entity.required\"/>\n        <label></label>\n    </div>\n</div>\n");
        $templateCache.put("components/visual/requirementList/gridCells/required-column-header-cell-template.html", "<div class=\"ui-grid-cell-contents header-cell text-align-center\"\n     col-index=\"renderIndex\">\n    <div>\n		<span>\n			<input type=\"checkbox\"\n                   ng-checked=\"grid.appScope.$ctrl.areAllEntitiesRequired(col.field)\"/>\n			<label ng-click=\"grid.appScope.$ctrl.onRequireAllClicked()\">\n				Required\n			</label>\n		</span>\n    </div>\n</div>\n");
        $templateCache.put("components/visual/weekdaySelector/gridTemplates/weekday-grid-cell-template.html", "<div class=\"ui-grid-cell-contents\">\n	<div class=\"weekly-schedule-checkbox\"\n		 ng-click=\"grid.appScope.$ctrl.toggleDayOfWeek(col.field, $event)\">\n		<input type=\"checkbox\" id=\"{{ \'sched\' + col.field }}\"\n			   ng-checked=\"grid.appScope.$ctrl.enabledDays.indexOf(col.field) >= 0\">\n		<label class=\"padding-right-xsm\" for=\"{{ \'sched\' + col.field }}\"></label>\n	</div>\n</div>\n");
        $templateCache.put("dashboard/calendars/base/gridTemplates/calendar-row-template.html", "<div ng-if=\"row.entity.header\"\n     class=\"{{row.entity.style}}\">\n    <p>{{row.entity.title}}</p>\n</div>\n\n<div ng-if=\"!row.entity.header\"\n     class=\"ui-grid-cell\"\n     ng-dblclick=\"grid.appScope.$ctrl.allowRowClick && grid.appScope.$ctrl.rowDoubleClicked(row.entity)\"\n     ng-repeat=\"col in colContainer.renderedColumns track by col.colDef.name\"\n     ui-grid-cell>\n</div>\n");
        $templateCache.put("dashboard/calendars/base/gridTemplates/live-calendar-cell-template.html", "<div class=\"ui-grid-cell-contents live-cell ng-scope ng-binding\">\n	<div class=\"progress live-cell-progress\">\n		<!--Must be included template as grid is not allowing ng-repeat on a wrapper div-->\n		<ng-include src=\"\'dashboard/calendars/base/gridTemplates/progress-renderer-template.html\'\" ng-repeat=\"schedule in COL_FIELD\"></ng-include>\n	</div>\n</div>\n");
        $templateCache.put("dashboard/calendars/base/gridTemplates/play-icon-column-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding play-icon\" ng-show=\"COL_FIELD\">\n    <span class=\"fa-stack\">\n      <i class=\"fa fa-circle-thin fa-stack-1x\"></i>\n      <i class=\"fa fa-play fa-stack-1x\"></i>\n    </span>\n</div>\n");
        $templateCache.put("dashboard/calendars/base/gridTemplates/progress-renderer-template.html", "<div class=\"progress-bar progress-bar-prism-green progress-bar-empty\" ng-style=\"{width: schedule.paddingStart + \'%\'}\">\n</div>\n<div class=\"progress-bar progress-bar-prism-green schedule-conflict\"\n	 ng-style=\"{width: schedule.conflictPct + \'%\'}\" ng-show=\"schedule.hasConflict\"\n	 data-tooltip-append-to-body=\"true\" uib-tooltip=\"{{\'Package Name: \' + schedule.packageName + \' start: \' + (schedule.start | amDateFormat: \'MM/DD/YYYY hh:mm A\') + \' stop: \' + (schedule.stop | amDateFormat: \'MM/DD/YYYY hh:mm A\')}}\"\n	 ng-dblclick=\"grid.appScope.$ctrl.rowDoubleClicked(schedule, \'/liveClip\')\">\n</div>\n<div class=\"progress-bar progress-bar-prism-green\" ng-style=\"{width: schedule.blockPct + \'%\'}\"\n	 data-tooltip-append-to-body=\"true\" uib-tooltip=\"{{\'Package Name: \' + schedule.packageName + \' start: \' + (schedule.start | amDateFormat: \'MM/DD/YYYY hh:mm A\') + \' stop: \' + (schedule.stop | amDateFormat: \'MM/DD/YYYY hh:mm A\')}}\"\n	 ng-dblclick=\"grid.appScope.$ctrl.rowDoubleClicked(schedule, \'/liveClip\')\">\n</div>\n<div class=\"progress-bar progress-bar-prism-green progress-bar-empty\" ng-style=\"{width: schedule.paddingEnd + \'%\'}\">\n</div>\n");
        $templateCache.put("dashboard/calendars/base/gridTemplates/status-column-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\">\n	<status-icon status=\"COL_FIELD\" class=\"cal-status-icon\"></status-icon>\n</div>\n");
        $templateCache.put("dashboard/metrics/dashboard-panels/metric-panel-row/metric-panel-row-template.html", "<!--\n - Filename: metric-panel-row-template.html\n -\n - Created by randysorensen on 2019-02-20.\n -->\n\n<div class=\"flex-row-container metric-panel-row\">\n    <dashboard-panel\n        class=\"metric-panel-sum\"\n        header-label=\"$ctrl.sumLabel\"\n        panel-data-property=\"$ctrl.sumDataProperty\"\n        panel-text-size=\"\'50px\'\">\n    </dashboard-panel>\n\n    <monthly-bar-graph\n        class=\"metric-panel-bargraph flex-stretcher\"\n        monthly-dataset-property=\"$ctrl.monthlyDatasetProperty\">\n    </monthly-bar-graph>\n\n    <dashboard-panel\n        class=\"metric-panel-last-month\"\n        header-b-g-color=\"\'#26CA00\'\"\n        ng-show=\"$ctrl.showCurrentMonthData()\"\n        panel-data-property=\"$ctrl.currentMonthDataProperty\"\n        panel-text-size=\"\'50px\'\">\n    </dashboard-panel>\n</div>\n");
        $templateCache.put("dashboard/metrics/dashboard-panels/monthly-bar-graph/monthly-bar-graph-renderer-template.html", "<!--\n - Filename: monthly-bar-graph-renderer-template.html\n -\n - Created by randysorensen on 2019-02-22.\n -->\n\n<bar-graph\n    class=\"metric-panel-bargraph flex-stretcher flex-col-container\"\n    bar-graph-data=\"$ctrl.getPanelData()\">\n</bar-graph>\n");
        $templateCache.put("dashboard/metrics/dashboard-panels/monthly-bar-graph/monthly-bar-graph-template.html", "<!--\n - Filename: monthly-bar-graph-template.html\n -\n - Created by randysorensen on 2019-02-22.\n -->\n\n<dashboard-panel\n    panel-data=\"$ctrl.monthlyBarGraphData\"\n    panel-template-url=\"\'dashboard/metrics/dashboard-panels/monthly-bar-graph/monthly-bar-graph-renderer-template.html\'\">\n</dashboard-panel>\n");
        $templateCache.put("dashboard/metrics/dashboard-panels/partner-distribution/partner-distribution-dashboard-panel-template.html", "<!--\n - Filename: partner-distribution-dashboard-panel-template.html\n -\n - Created by randysorensen on 2019-02-19.\n -->\n\n<dashboard-panel\n    header-label=\"$ctrl.getDateRange()\"\n    header-text-size=\"\'24px\'\"\n    panel-data=\"$ctrl.partnerRatioMap\"\n    panel-template-url=\"\'dashboard/metrics/dashboard-panels/partner-distribution/partner-distribution-renderer-template.html\'\">\n</dashboard-panel>\n");
        $templateCache.put("dashboard/metrics/dashboard-panels/partner-distribution/partner-distribution-renderer-template.html", "<!--\n - Filename: partner-distribution-renderer-template.html\n -\n - Created by randysorensen on 2019-02-19.\n -->\n\n<div class=\"flex-row-container partner-distribution-panel\">\n\n    <div class=\"partner-distribution-section\"\n         ng-class=\"{\'flex-stretcher\': !$last}\"\n         ng-repeat=\"(category, data) in $ctrl.getPanelData()\">\n        <span class=\"partner-distribution-category\">\n            {{category}}\n        </span>\n        <span class=\"partner-distribution-percentage\">\n            {{data}}%\n        </span>\n    </div>\n\n</div>\n");
        $templateCache.put("dashboard/queues/modals/queueLimiterEditor/queue-limiter-edit-template.html", "<div class=\"modal-header\">\n    <h5 align=\"center\"\n        class=\"modal-title\">Create/Edit Queue Limiter</h5>\n</div>\n<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"queueLimiterEditCtrl.loadingIndicator\"\n         ng-show=\"queueLimiterEditCtrl.loadingIndicator.show\">\n    </div>\n</div>\n<div class=\"modal-body\">\n    <form class=\"form-horizontal\"\n          role=\"form\"\n          name=\"queueLimiterEditCtrl.modalForm\">\n        <div class=\"form-group\">\n            <label class=\"control-label col-md-4\">Category Type</label>\n            <div class=\"col-md-5 metadata-control-col\">\n                <dropdown-select id=\"queueLimiterCategoryType\"\n                                 ng-model=\"queueLimiterEditCtrl.limiterObject.categoryType\"\n                                 ng-change=\"queueLimiterEditCtrl.filterEditDropdowns()\"\n                                 ng-disabled=\"queueLimiterEditCtrl.limiterObject.id && queueLimiterEditCtrl.limiterObject.categoryType\"\n                                 collection=\"queueLimiterEditCtrl.catTypes\"\n                                 prompt=\"Select Category Type\"\n                                 label-field=\"name\"\n                                 clearable=\"true\"\n                                 btn-min-width=\"225\"\n                                 btn-max-width=\"250\">\n                </dropdown-select>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"control-label col-md-4\">Partners</label>\n            <div class=\"col-md-5 metadata-control-col\">\n                <dropdown-select id=\"queueLimiterPartners\"\n                                 ng-model=\"queueLimiterEditCtrl.limiterObject.partner\"\n                                 ng-change=\"queueLimiterEditCtrl.filterEditDropdowns()\"\n                                 ng-disabled=\"queueLimiterEditCtrl.limiterObject.id && queueLimiterEditCtrl.limiterObject.partner\"\n                                 collection=\"queueLimiterEditCtrl.partners\"\n                                 prompt=\"Select Partner\"\n                                 clearable=\"true\"\n                                 label-field=\"name\"\n                                 btn-min-width=\"225\"\n                                 btn-max-width=\"250\">\n                </dropdown-select>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"control-label col-md-4\">Limit</label>\n            <div class=\"col-md-2 metadata-control-col\">\n                <input type=\"text\"\n                       class=\"form-control prism-text-input\"\n                       style=\"max-width: 50px\"\n                       id=\"editQueueLimiter\"\n                       ng-model=\"queueLimiterEditCtrl.limiterObject.maxActive\"\n                       ng-change=\"queueLimiterEditCtrl.onMaxActiveChange()\"/>\n            </div>\n            <label class=\"col-md-4 pad-text-input-col no-left-padding control-label text-align-left\">1-Queue\n                                                                                                     Maximum</label>\n        </div>\n    </form>\n</div>\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"queueLimiterEditCtrl.cancel()\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"queueLimiterEditCtrl.onOk()\"\n            ng-disabled=\"queueLimiterEditCtrl.disableOkButton()\">\n        Save\n    </button>\n</div>\n");
        $templateCache.put("dashboard/queues/modals/queueLimiterList/queue-limiter-list-modal-template.html", "<div class=\"modal-header\">\n    <a id=\"queueLimiterListXBtn\"\n       ng-click=\"queueLimiterController.xClicked()\"><i class=\"fa fa-times pull-right\"></i></a>\n    <h5 align=\"center\"\n        class=\"modal-title\">Queue Limiters</h5>\n</div>\n<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"queueLimiterController.loadingIndicator\"\n         ng-show=\"queueLimiterController.loadingIndicator.show\">\n    </div>\n</div>\n<div class=\"modal-body\">\n    <form class=\"form-horizontal\"\n          role=\"form\"\n          name=\"queueLimiterController.modalForm\">\n        <div class=\"form-group\">\n            <div class=\"col-md-4 padding-left-md padding-top-sm\">\n                <button id=\"addQueueLimiter\"\n                        class=\"btn btn-default prism-button\"\n                        ng-click=\"queueLimiterController.addQueueLimiter()\"\n                        ng-disabled=\"queueLimiterController.disableListComponents()\">\n                    <i class=\"fa fa-plus\"></i>\n                </button>\n                <button id=\"removeQueueLimiter\"\n                        class=\"btn btn-default prism-button\"\n                        ng-click=\"queueLimiterController.openConfirmModal(queueLimiterController.deleteMessage, \'Delete\', queueLimiterController.deleteQueueLimiter)\"\n                        ng-disabled=\"queueLimiterController.disableLimiterDeleteButton()\">\n                    <i class=\"fa fa-minus\"></i>\n                </button>\n            </div>\n            <label for=\"queueMaxActive\"\n                   class=\"control-label col-md-6 padding-right-xsm padding-bottom-sm\">Queue Maximum</label>\n            <div class=\"col-md-1 no-padding pad-text-input-col\">\n                <input type=\"text\"\n                       class=\"form-control prism-text-input\"\n                       id=\"queueMaxActive\"\n                       ng-model=\"queueLimiterController.queueObject.maxActive\"/>\n            </div>\n            <label class=\"col-md-1 pad-text-input-col no-left-padding control-label text-align-left\">1-999</label>\n        </div>\n        <fieldset ng-disabled=\"queueLimiterController.disableListComponents()\">\n            <div id=\"queueLimiterGrid\"\n                 ui-grid=\"queueLimiterController.gridOptions\"\n                 class=\"queue-limiter-ui-grid protected-grid\"\n                 ui-grid-selection\n                 ui-grid-auto-resize>\n            </div>\n        </fieldset>\n\n    </form>\n</div>\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"queueLimiterController.cancel()\"\n            ng-disabled=\"queueLimiterController.disableOkButton();\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            ng-if=\"queueLimiterController.canClearQueue\"\n            ng-click=\"queueLimiterController.clearQueue();\">\n        Clear Queue\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"queueLimiterController.onOk()\"\n            ng-disabled=\"queueLimiterController.disableOkButton()\">\n        Save\n    </button>\n</div>\n");
        $templateCache.put("dashboard/queues/queueDetail/components/queue-detail-grid-template.html", "<div class=\"row-no-padding\">\n	<div class=\"col-md-12 col-lg-12\">\n		<div ui-grid=\"$ctrl.gridOptions\"\n             class=\"queue-grid\"\n             ui-grid-selection\n             ui-grid-auto-resize></div>\n	</div>\n</div>\n");
        $templateCache.put("dashboard/reports/modals/createReportModal/create-report-modal-template.html", "<div class=\"modal-header\">\n    <h5 class=\"modal-title\">{{createReportModal.selectedReport.modalTitle}}</h5>\n</div>\n<div class=\"modal-body\">\n    <div class=\"row\">\n        <label class=\"col-sm-12 control-label text-align-center\">{{createReportModal.selectedReport.formTitle}}</label>\n    </div>\n    <form class=\"form-horizontal\"\n          role=\"form\"\n          name=\"createReportModal.modalForm\">\n        <div class=\"form-group\">\n            <label for=\"reportName\"\n                   class=\"col-sm-3 control-label\">Name</label>\n            <div class=\"col-sm-7 pad-text-input-col\">\n                <input id=\"reportName\"\n                       type=\"text\"\n                       class=\"prism-text-input\"\n                       ng-change=\"createReportModal.reportNameChanged()\"\n                       ng-model=\"createReportModal.reportName\"/>\n                <div\n                    class=\"red-label\"\n                    data-tooltip-append-to-body=\"true\"\n                    ng-show=\"!createReportModal.isReportNameValid()\"\n                    uib-tooltip-html=\"createReportModal.nameWarningTooltip\">\n                        Name must begin with a letter, a number, an underscore or a tilde (\'~\'). Subsequent\n                        characters may be letters, numbers, underscores, tildes, hyphens, periods or spaces.\n                </div>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-3 control-label\"\n                   ng-if=\"createReportModal.selectedReport.showIncludePackagesOptions ||\n						  createReportModal.showIncludeArchived()\">Include</label>\n            <div class=\"col-sm-6 pad-text-input-col\">\n                <input type=\"checkbox\"\n                       id=\"includeMasterPkgsCB\"\n                       ng-model=\"createReportModal.includeMasterPkgs\"\n                       ng-if=\"createReportModal.selectedReport.showIncludePackagesOptions\"\n                       checked=\"true\"/>\n                <label for=\"includeMasterPkgsCB\"\n                       class=\"prism-form-item-label\"\n                       ng-if=\"createReportModal.selectedReport.showIncludePackagesOptions\">Master Packages</label>\n                <input type=\"checkbox\"\n                       id=\"includeClipToolPkgs\"\n                       ng-model=\"createReportModal.includeClipToolPkgs\"\n                       ng-if=\"createReportModal.selectedReport.showIncludePackagesOptions\"/>\n                <label for=\"includeClipToolPkgs\"\n                       class=\"prism-form-item-label\"\n                       ng-if=\"createReportModal.selectedReport.showIncludePackagesOptions\">Clipping Tool\n                                                                                           Packages</label>\n                <input type=\"checkbox\"\n                       id=\"includeArchivedCB\"\n                       ng-model=\"createReportModal.includeArchived\"\n                       ng-if=\"createReportModal.showIncludeArchived()\"/>\n                <label for=\"includeArchivedCB\"\n                       class=\"prism-form-item-label\"\n                       ng-if=\"createReportModal.showIncludeArchived()\">Archived Content</label>\n            </div>\n        </div>\n        <div class=\"form-group\"\n             ng-if=\"createReportModal.showMode()\">\n            <label class=\"col-sm-3 control-label\">Mode</label>\n            <div class=\"col-sm-2 pad-text-input-col\">\n                <input type=\"radio\"\n                       id=\"basicModeRadio\"\n                       ng-model=\"createReportModal.reportMode\"\n                       value=\"Basic\"\n                       ng-change=\"createReportModal.handleModeChange()\"/>\n                <label class=\"prism-form-item-label\"\n                       for=\"basicModeRadio\">Basic</label>\n                <input type=\"radio\"\n                       id=\"advancedModeRadio\"\n                       ng-model=\"createReportModal.reportMode\"\n                       value=\"Advanced\"\n                       ng-change=\"createReportModal.handleModeChange()\"/>\n                <label class=\"prism-form-item-label\"\n                       for=\"advancedModeRadio\">Advanced</label>\n            </div>\n        </div>\n\n        <div class=\"form-group\"\n             ng-if=\"createReportModal.showPartners\">\n            <label class=\"col-md-3 prism-form-item-label text-align-right\">Partners</label>\n            <div class=\"col-md-6\">\n                <dropdown-select ng-model=\"createReportModal.selectedPartners\"\n                                 collection=\"createReportModal.partners\"\n                                 btn-min-width=\"250\"\n                                 btn-max-width=\"300\"\n                                 label-field=\"name\"\n                                 prompt=\"Select Partner\"\n                                 required>\n                </dropdown-select>\n            </div>\n            <div class=\"col-md-1 no-left-padding\">\n                <input type=\"checkbox\"\n                       id=\"includeHiddenPartnersCB\"\n                       ng-change=\"createReportModal.updatePartnerList()\"\n                       ng-model=\"createReportModal.includeHiddenPartners\"/>\n                <label for=\"includeHiddenPartnersCB\">Show Hidden</label>\n            </div>\n        </div>\n\n    </form>\n</div>\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"createReportModal.cancel()\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"createReportModal.onOk()\"\n            ng-disabled=\"!createReportModal.isReportNameValid() ||\n                         (createReportModal.showPartners && !createReportModal.selectedPartners)\">\n        Create Report\n    </button>\n</div>\n");
        $templateCache.put("dashboard/workflows/stepView/contextDetailView/context-detail-view-template.html", "\n<div class=\"panel panel-default context-data-detail-container\">\n	<div class=\"panel-heading\">\n		<i class=\"fa fa-times-circle-o fa-lg\" ng-click=\"contextView.closeHandler()\"></i>\n	</div>\n	<div class=\"panel-body\">\n		<div class=\"row\">\n			<div class=\"col-md-12\">\n				<span>{{\'Percent Complete \' + \'(\' + contextView.selectedWorkflowStep.percentComplete + \')%\'}}</span>\n				<uib-progressbar animate=\"false\" value=\"contextView.selectedWorkflowStep.percentComplete\" type=\"success\"></uib-progressbar>\n			</div>\n		</div>\n		<div class=\"row\">\n			<div class=\"col-md-12\">\n				<form>\n					<div class=\"form-group\">\n						<label for=\"workflowStepContextExceptionText\">Exception Text</label>\n						<textarea class=\"form-control prism-text-input\" id=\"workflowStepContextExceptionText\"\n								  rows=\"6\" ng-disabled=\"true\" ng-model=\"contextView.selectedWorkflowStep.exceptionText\"></textarea>\n					</div>\n					<div class=\"form-group\">\n						<label for=\"workflowStepContextStatus\">Status</label>\n						<input type=\"text\" class=\"form-control prism-text-input\" id=\"workflowStepContextStatus\"\n							   ng-disabled=\"true\" ng-model=\"contextView.selectedWorkflowStep.status\">\n					</div>\n					<div class=\"form-group\">\n						<label for=\"workflowStepContextStepType\">Step Type</label>\n						<input type=\"text\" class=\"form-control prism-text-input\" id=\"workflowStepContextStepType\"\n							   ng-disabled=\"true\" ng-model=\"contextView.selectedWorkflowStep.type\">\n					</div>\n					<div class=\"form-group\" ng-if=\"contextView.selectedWorkflowStep.type === \'EMAILSTEPEXECUTION\'\">\n						<label for=\"workflowEmailSubject\">Email Subject</label>\n						<input type=\"text\" class=\"form-control prism-text-input\" id=\"workflowEmailSubject\"\n							   ng-disabled=\"true\" ng-model=\"contextView.selectedWorkflowStep.customData.emailSubject\">\n					</div>\n					<div class=\"form-group\" ng-if=\"contextView.selectedWorkflowStep.type === \'EMAILSTEPEXECUTION\'\">\n						<label for=\"workflowEmailAddresses\">Email Addresses</label>\n						<textarea class=\"form-control prism-text-input\" id=\"workflowEmailAddresses\" rows=\"6\"\n								  ng-disabled=\"true\" ng-model=\"contextView.selectedWorkflowStep.customData.emailAddresses\">\n						</textarea>\n					</div>\n					<div class=\"form-group\" ng-if=\"contextView.selectedWorkflowStep.type === \'EMAILSTEPEXECUTION\'\">\n						<label for=\"workflowAttachmentPaths\">Attachment Paths</label>\n						<textarea class=\"form-control prism-text-input\" id=\"workflowAttachmentPaths\" rows=\"6\"\n								  ng-disabled=\"true\" ng-model=\"contextView.selectedWorkflowStep.customData.attachmentFilePaths\">\n						</textarea>\n					</div>\n					<div class=\"form-group\">\n						<label>Deadline</label>\n						<date-picker disabled=\"true\" ng-model=\"contextView.selectedWorkflowStep.deadline\"></date-picker>\n					</div>\n					<div class=\"form-group\">\n						<label>Start Date</label>\n						<date-picker disabled=\"true\" ng-model=\"contextView.selectedWorkflowStep.startDate\"></date-picker>\n					</div>\n					<div class=\"form-group\">\n						<label>End Date</label>\n						<date-picker disabled=\"true\" ng-model=\"contextView.selectedWorkflowStep.endDate\"></date-picker>\n					</div>\n					<div class=\"form-group\">\n						<label>Updated Date</label>\n						<date-picker disabled=\"true\" ng-model=\"contextView.selectedWorkflowStep.dateUpdated\"></date-picker>\n					</div>\n					<div class=\"form-group\">\n						<label>Created Date</label>\n						<date-picker disabled=\"true\" ng-model=\"contextView.selectedWorkflowStep.dateCreated\"></date-picker>\n					</div>\n					<div class=\"form-group\">\n						<label>Context Data\n                            <a class=\"prism-button\" uib-tooltip=\"View the Context JSON Data\"\n                               ng-click=\"contextView.showContextDataClicked()\">\n                                <i class=\"fa fa-eye\"></i>\n                            </a>\n                            <a class=\"prism-button\" uib-tooltip=\"Copies the Context JSON Data to the clipboard\"\n                               ng-click=\"contextView.onCopyContextDataClicked()\">\n                                <i class=\"fa fa-copy\"></i>\n                            </a>\n                        </label>\n						<div ui-grid=\"contextView.gridOptions\" class=\"workflow-step-grid search-grid context-data-grid\"\n							 ui-grid-auto-resize ui-grid-resize-columns></div>\n					</div>\n				</form>\n			</div>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("meta/collaborator/editor/components/create-collaborator-modal-template.html", "<div class=\"modal-header\">\n    <div class=\"pull-right\">\n    </div>\n    <h6 class=\"modal-title\">Add Collaborator</h6>\n</div>\n<div class=\"modal-body\">\n    <form role=\"form\" class=\"form-horizontal\" name=\"createCollaborator.createCollabForm\">\n        <div class=\"form-group\">\n            <label class=\"control-label col-md-3\">Display Name</label>\n            <div class=\"col-md-8 pad-text-input-col\">\n                <input type=\"text\" class=\"prism-text-input\"\n                       ng-model=\"createCollaborator.newCollab.displayName\"\n                       ng-change=\"createCollaborator.handleDisplayNameChange()\"\n                       id=\"displayNameInput\"/>\n                <label class=\"under-field-hint\">(First Name Last Name)</label>\n            </div>\n            <div class=\"required-text-input\" required x-required-indicator></div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"control-label col-md-3\">Sort Name</label>\n            <div class=\"col-md-8 pad-text-input-col\">\n                <input type=\"text\" class=\"prism-text-input\"\n                       ng-model=\"createCollaborator.newCollab.sortName\"\n                       id=\"sortNameInput\"/>\n                <label class=\"under-field-hint\">(Last Name, First Name)</label>\n            </div>\n            <div class=\"required-text-input\" required x-required-indicator></div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"control-label col-md-3\">Nickname</label>\n            <div class=\"col-md-8 pad-text-input-col\">\n                <input type=\"text\" class=\"prism-text-input\"\n                       ng-model=\"createCollaborator.newCollab.nickname\"\n                       id=\"nicknameInput\"/>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"control-label col-md-3\">IMDB#</label>\n            <div class=\"col-md-8 pad-text-input-col\">\n                <input type=\"text\" class=\"prism-text-input\" ng-model=\"createCollaborator.newCollab.iMDbNumber\"\n                       id=\"imdbNumberInput\"/>\n            </div>\n        </div>\n    </form>\n</div>\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default\" ng-click=\"createCollaborator.cancel()\"\n            id=\"cancelButton\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\" ng-click=\"createCollaborator.onSave()\"\n            ng-disabled=\"createCollaborator.disableOKButton()\" id=\"saveButton\">\n        Save\n    </button>\n</div>\n");
        $templateCache.put("package/editor/components/renderers/package-lock-messages-template.html", "<!-- TODO: Have all controls use this template! -->\n<div class=\"row read-only-msg\"\n     ng-show=\"!$ctrl.canWrite && !$ctrl.loadingIndicator.show\">\n    <p><i class=\"fa fa-lock\"></i> User access denied! Your permissions do not allow you to edit this content.\n    </p>\n</div>\n\n<div class=\"row read-only-msg\"\n     ng-show=\"!$ctrl.pkgEditCtrl.statusAllowsEdit() && !$ctrl.packageObject.locked && $ctrl.canWrite && !$ctrl.loadingIndicator.show\">\n    <p><i class=\"fa fa-lock\"></i> Due to the current package status, this package cannot be modified.</p>\n</div>\n\n<div class=\"row read-only-msg\"\n     ng-show=\"$ctrl.packageObject.locked && $ctrl.canWrite && !$ctrl.loadingIndicator.show\">\n    <p><i class=\"fa fa-lock\"></i> This package is checked out, and cannot be modified or delivered.</p>\n</div>\n");
        $templateCache.put("package/editor/components/renderers/package-metadataproperties-renderer-template.html", "<div class=\"row clearfix\">\n	<div class=\"col-md-12 column\">\n		<div class=\"row\">\n			<div class=\"col-md-3\">\n				<div class=\"prism-form-heading\">\n					PACKAGE PROPERTIES\n				</div>\n			</div>\n\n			<div class=\"col-md-push-6 col-md-3\"\n				 ng-if=\"$ctrl.showHierarchicalMetadataButton\">\n				<button class=\"btn btn-default\"\n						ng-click=\"$ctrl.showHierarchicalMetadataModal()\">\n					Hierarchical Metadata\n				</button>\n			</div>\n		</div>\n	</div>\n\n	<!-- ID / Package Created Date -->\n	<div class=\"top-margin-md row clearfix spacer-top-lg\">\n		<div class=\"col-md-6\">\n			<label for=\"id\"\n				   class=\"col-sm-6 prism-form-item-label text-align-right\">\n				ID\n			</label>\n			<div class=\"col-sm-6\">\n				<p id=\"id\">\n					{{$ctrl.packageObject.id}}\n				</p>\n			</div>\n		</div>\n		<div class=\"col-md-6\">\n			<label for=\"createdDate\"\n				   class=\"col-sm-4 prism-form-item-label text-align-right\">\n				Package Created Date\n			</label>\n			<div class=\"col-sm-8\">\n				<p id=\"createdDate\">\n					{{$ctrl.packageObject.dateCreated | amDateFormat: \'MM/DD/YYYY HH:mm:ss A\'}}\n				</p>\n			</div>\n		</div>\n	</div>\n\n	<!-- Content Type / Package Creator -->\n	<div class=\"row clearfix\">\n		<div class=\"col-md-6\">\n			<label for=\"content\"\n				   class=\"col-sm-6 prism-form-item-label text-align-right\">\n				{{$ctrl.packageObject.content.type}}\n			</label>\n			<div class=\"col-sm-6\">\n				<p id=\"content\">\n					{{$ctrl.packageObject.content.name}}\n					<a ng-show=\"$ctrl.writePerms && $ctrl.packageObject.clone\"\n					   ng-click=\"$ctrl.changeContent()\"><i class=\"fa fa-pencil\"></i></a>\n				</p>\n			</div>\n		</div>\n		<div class=\"col-md-6\">\n			<label for=\"creator\"\n				   class=\"col-sm-4 prism-form-item-label text-align-right\">\n				Package Creator\n			</label>\n			<div class=\"col-sm-8\">\n				<p id=\"creator\">\n					{{$ctrl.packageObject.createdBy.firstName + \' \' +\n					$ctrl.packageObject.createdBy.lastName}}\n				</p>\n			</div>\n		</div>\n	</div>\n\n	<!-- Prefix / Package Last Edited -->\n	<div class=\"row clearfix\">\n		<div class=\"col-md-6\">\n			<label for=\"prefix\"\n				   class=\"col-sm-6 prism-form-item-label text-align-right\">\n				Prefix\n			</label>\n			<div class=\"col-sm-6 \">\n				<p id=\"prefix\">\n					{{$ctrl.packageObject.content.prefix}}\n				</p>\n			</div>\n		</div>\n		<div class=\"col-md-6\">\n			<label for=\"lastEdited\"\n				   class=\"col-sm-4 prism-form-item-label text-align-right\">\n				Package Last Edited\n			</label>\n			<div class=\"col-sm-8\">\n				<p id=\"lastEdited\">\n					{{$ctrl.packageObject.lastEdited | amDateFormat: \'MM/DD/YYYY HH:mm:ss A\'}}\n				</p>\n			</div>\n		</div>\n	</div>\n\n	<!-- Category Type / Last Edited By -->\n	<div class=\"row clearfix\">\n		<div class=\"col-md-6\">\n			<label for=\"prefix\"\n				   class=\"col-sm-6 prism-form-item-label text-align-right\">\n				Category Type\n			</label>\n			<div class=\"col-sm-6\">\n				<p id=\"categoryType\">\n					{{$ctrl.packageObject.categoryType.name}}\n				</p>\n			</div>\n		</div>\n		<div class=\"col-md-6\">\n			<label for=\"lastEditedby\"\n				   class=\"col-sm-4 prism-form-item-label text-align-right\">\n				Last Edited By\n			</label>\n			<div class=\"col-sm-8\">\n				<p id=\"lastEditedby\">\n					{{$ctrl.packageObject.updatedBy.firstName + \' \' + $ctrl.packageObject.updatedBy.lastName}}\n				</p>\n			</div>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("package/editor/components/toolbar/advanced-metadata-toolbar-template.html", "<form class=\"form-inline toolbar-top-padding-sm\"\n      name=\"advancedMetadataToolbar\">\n    <div class=\"form-group\">\n        <div class=\"col-md-4\">\n            <a class=\"toolbar-button\"\n               role=\"button\"\n               id=\"saveToolbarButton\"\n               ng-click=\"pkgEditorToolbarCtrlr.saveClickHandler()\"\n               ng-dblclick=\"return\"\n               ng-disabled=\"pkgEditorToolbarCtrlr.saveDisabled()\">\n                <i class=\"fa fa-floppy-o\"></i><br>Save\n            </a>\n        </div>\n        <div class=\"col-md-4\">\n            <a class=\"toolbar-button\"\n               role=\"button\"\n               id=\"revertToolbarButton\"\n               ng-click=\"pkgEditorToolbarCtrlr.revertClickHandler()\"\n               ng-disabled=\"pkgEditorToolbarCtrlr.revertDisabled()\">\n                <i class=\"fa fa-undo\"></i><br>Revert\n            </a>\n        </div>\n        <div class=\"col-md-4\">\n            <a class=\"toolbar-button\"\n               role=\"button\"\n               id=\"closeToolbarButton\"\n               ng-click=\"pkgEditorToolbarCtrlr.closeClickHandler()\">\n                <i class=\"fa fa-times\"></i><br>Close\n            </a>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <div class=\"col-md-12 col-md-offset-2\">\n            <ul class=\"pagination pagination-sm\">\n                <li ng-click=\"pkgEditorToolbarCtrlr.prevPageClickHandler()\">\n                    <a ng-disabled=\"pkgEditorToolbarCtrlr.prevPageDisabled()\">Prev</a>\n                </li>\n                <li ng-click=\"pkgEditorToolbarCtrlr.nextPageClickHandler()\">\n                    <a ng-disabled=\"pkgEditorToolbarCtrlr.nextPageDisabled()\">Next</a>\n                </li>\n            </ul>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <div class=\"col-md-12\">\n            <dropdown-select id=\"pkgEditActionSelect\"\n                             ng-model=\"pkgEditorToolbarCtrlr.selectedAction\"\n                             ng-disabled=\"pkgEditorToolbarCtrlr.actionDropdownDisabled()\"\n                             collection=\"pkgEditorToolbarCtrlr.actions\"\n                             btn-min-width=\"250\"\n                             sort-collection=\"false\"\n                             prompt=\"Select Action\"\n                             disabled=\"true\"\n                             dropup=\"true\"\n                             label-field=\"label\"\n                             ng-change=\"pkgEditorToolbarCtrlr.handleSelectedAction()\">\n            </dropdown-select>\n        </div>\n    </div>\n</form>\n");
        $templateCache.put("package/editor/components/toolbar/basicdistribution-toolbar-template.html", "<form class=\"form-inline toolbar-top-padding-sm\" name=\"mediaToolbar\">\n	<div class=\"form-group\">\n		<div class=\"col-md-4\">\n			<a class=\"toolbar-button\" role=\"button\" id=\"saveToolbarButton\" ng-click=\"pkgEditorToolbarCtrlr.saveClickHandler()\"\n			   ng-disabled=\"pkgEditorToolbarCtrlr.saveDisabled()\">\n				<i class=\"fa fa-floppy-o\"></i><br>Save\n			</a>\n		</div>\n		<div class=\"col-md-4\">\n			<a class=\"toolbar-button\" role=\"button\" id=\"revertToolbarButton\" ng-click=\"pkgEditorToolbarCtrlr.revertClickHandler()\"\n			   ng-disabled=\"pkgEditorToolbarCtrlr.revertDisabled()\">\n				<i class=\"fa fa-undo\"></i><br>Revert\n			</a>\n		</div>\n		<div class=\"col-md-4\">\n			<a class=\"toolbar-button\" role=\"button\" id=\"closeToolbarButton\" ng-click=\"pkgEditorToolbarCtrlr.closeClickHandler()\"><i class=\"fa fa-times\"></i><br>Close</a>\n		</div>\n	</div>\n	<div class=\"form-group\">\n		<div class=\"col-md-12 col-md-offset-2\">\n			<ul class=\"pagination pagination-sm\">\n				<li ng-click=\"pkgEditorToolbarCtrlr.prevPageClickHandler()\">\n					<a ng-disabled=\"pkgEditorToolbarCtrlr.prevPageDisabled()\">Prev</a>\n				</li>\n				<li ng-click=\"pkgEditorToolbarCtrlr.nextPageClickHandler()\">\n					<a ng-disabled=\"pkgEditorToolbarCtrlr.nextPageDisabled()\">Next</a>\n				</li>\n			</ul>\n		</div>\n	</div>\n	<div class=\"form-group\">\n		<div class=\"col-md-12\">\n			<div>\n				<input type=\"checkbox\"\n					   id=\"autoDeliverCB\"\n					   ng-model=\"pkgEditorToolbarCtrlr.contextData.autoDeliver\"\n					   ng-change=\"pkgEditorToolbarCtrlr.editorForm.$setDirty()\"\n					   ng-disabled=\"!pkgEditorToolbarCtrlr.toolbarPerms.mediaWrite || !pkgEditorToolbarCtrlr.canChangeAutoDelivery()\">\n				<label for=\"autoDeliverCB\">Auto Delivery</label>\n			</div>\n		</div>\n	</div>\n	<div class=\"form-group\">\n		<div class=\"col-md-12\">\n			<dropdown-select id=\"pkgEditActionSelect\" ng-model=\"pkgEditorToolbarCtrlr.selectedAction\"\n							 ng-disabled=\"pkgEditorToolbarCtrlr.actionDropdownDisabled()\"\n							 collection=\"pkgEditorToolbarCtrlr.actions\" btn-min-width=\"250\" sort-collection=\"false\"\n							 prompt=\"Select Action\" disabled=\"true\" dropup=\"true\" label-field=\"label\"\n							 ng-change=\"pkgEditorToolbarCtrlr.handleSelectedAction()\">\n			</dropdown-select>\n		</div>\n	</div>\n	<div class=\"form-group pull-right\">\n		<div class=\"col-md-12\">\n			<a class=\"toolbar-button\" role=\"button\" id=\"adHocButton\"\n			   ng-click=\"pkgEditorToolbarCtrlr.addAdHocSubscription()\"\n			   ng-show=\"pkgEditorToolbarCtrlr.adHocButtonVisible()\">\n				<i class=\"fa fa-plus\"></i><br>Ad-Hoc\n			</a>\n		</div>\n	</div>\n</form>\n");
        $templateCache.put("package/editor/components/toolbar/collaborators-toolbar-template.html", "<form class=\"form-inline\" name=\"collaboratorsToolbar\">\n	<div class=\"form-group\">\n		<div ng-class=\"pkgEditorToolbarCtrlr.tabAddDisabledInvalid() ? \'col-md-6\' : \'col-md-4\'\">\n			<a class=\"toolbar-button\"\n			   role=\"button\"\n			   id=\"collabNewButton\"\n			   ng-click=\"pkgEditorToolbarCtrlr.toolbarPerms.collaboratorsWrite && pkgEditorToolbarCtrlr.newClickHandler()\"\n			   ng-disabled=\"!pkgEditorToolbarCtrlr.toolbarPerms.collaboratorsWrite || !pkgEditorToolbarCtrlr.statusAllowsEdit()\">\n				<i class=\"fa fa-plus\"></i><br>&nbsp;&nbsp;New\n			</a>\n		</div>\n		<div ng-class=\"pkgEditorToolbarCtrlr.tabAddDisabledInvalid() ? \'col-md-6\' : \'col-md-4\'\">\n			<a class=\"toolbar-button\"\n			   ng-click=\"pkgEditorToolbarCtrlr.toolbarPerms.collaboratorsWrite && !pkgEditorToolbarCtrlr.tabDeleteInvalid() && pkgEditorToolbarCtrlr.deleteClickHandler()\"\n			   role=\"button\"\n			   id=\"deleteCollabButton\"\n			   ng-disabled=\"!pkgEditorToolbarCtrlr.toolbarPerms.collaboratorsWrite || pkgEditorToolbarCtrlr.tabDeleteInvalid()\">\n				<i class=\"fa fa-trash-o\"></i><br>Delete\n			</a>\n		</div>\n		<div class=\"col-md-4\" ng-show=\"!pkgEditorToolbarCtrlr.tabAddDisabledInvalid()\">\n			<a class=\"toolbar-button\"\n			   ng-click=\"pkgEditorToolbarCtrlr.toolbarPerms.collaboratorsWrite && pkgEditorToolbarCtrlr.addDisabledClickHandler()\"\n			   role=\"button\"\n			   id=\"addDisabledCollabButton\"\n			   ng-disabled=\"!pkgEditorToolbarCtrlr.toolbarPerms.collaboratorsWrite\">\n				<i class=\"fa fa-plus\"></i><br>Disabled\n			</a>\n		</div>\n	</div>\n	<div class=\"form-group\">\n		<div class=\"col-md-12 col-md-offset-2\">\n			<ul class=\"pagination pagination-sm\">\n				<li ng-click=\"pkgEditorToolbarCtrlr.prevPageClickHandler()\">\n					<a ng-disabled=\"pkgEditorToolbarCtrlr.prevPageDisabled()\">Prev</a>\n				</li>\n				<li ng-click=\"pkgEditorToolbarCtrlr.nextPageClickHandler()\">\n					<a ng-disabled=\"pkgEditorToolbarCtrlr.nextPageDisabled()\">Next</a>\n				</li>\n			</ul>\n		</div>\n	</div>\n	<div class=\"form-group\">\n		<div class=\"col-md-12 col-lg-12\">\n			<dropdown-select id=\"pkgEditActionSelect\" ng-model=\"pkgEditorToolbarCtrlr.selectedAction\"\n							 ng-disabled=\"pkgEditorToolbarCtrlr.actionDropdownDisabled()\"\n							 collection=\"pkgEditorToolbarCtrlr.actions\" btn-min-width=\"250\" sort-collection=\"false\"\n							 prompt=\"Select Action\" disabled=\"true\" dropup=\"true\" label-field=\"label\"\n							 ng-change=\"pkgEditorToolbarCtrlr.handleSelectedAction()\">\n			</dropdown-select>\n		</div>\n	</div>\n</form>\n\n");
        $templateCache.put("package/editor/components/toolbar/external-ingests-tab-toolbar-template.html", "<form class=\"form-inline toolbar-top-padding-sm\" name=\"mediaToolbar\">\n    <div class=\"form-group\">\n        <div class=\"col-md-4\">\n            <a class=\"toolbar-button\" role=\"button\" id=\"saveToolbarButton\" ng-click=\"pkgEditorToolbarCtrlr.saveClickHandler()\"\n               ng-disabled=\"pkgEditorToolbarCtrlr.saveDisabled()\">\n                <i class=\"fa fa-floppy-o\"></i><br>Save\n            </a>\n        </div>\n        <div class=\"col-md-4\">\n            <a class=\"toolbar-button\" role=\"button\" id=\"revertToolbarButton\" ng-click=\"pkgEditorToolbarCtrlr.revertClickHandler()\"\n               ng-disabled=\"pkgEditorToolbarCtrlr.revertDisabled()\">\n                <i class=\"fa fa-undo\"></i><br>Revert\n            </a>\n        </div>\n        <div class=\"col-md-4\">\n            <a class=\"toolbar-button\" role=\"button\" id=\"closeToolbarButton\" ng-click=\"pkgEditorToolbarCtrlr.closeClickHandler()\"><i class=\"fa fa-times\"></i><br>Close</a>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <div class=\"col-md-12 col-md-offset-2\">\n            <ul class=\"pagination pagination-sm\">\n                <li ng-click=\"pkgEditorToolbarCtrlr.prevPageClickHandler()\">\n                    <a ng-disabled=\"pkgEditorToolbarCtrlr.prevPageDisabled()\">Prev</a>\n                </li>\n                <li ng-click=\"pkgEditorToolbarCtrlr.nextPageClickHandler()\">\n                    <a ng-disabled=\"pkgEditorToolbarCtrlr.nextPageDisabled()\">Next</a>\n                </li>\n            </ul>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <div class=\"col-md-12\">\n            <dropdown-select id=\"pkgEditActionSelect\" ng-model=\"pkgEditorToolbarCtrlr.selectedAction\"\n                             ng-disabled=\"pkgEditorToolbarCtrlr.actionDropdownDisabled()\"\n                             collection=\"pkgEditorToolbarCtrlr.actions\" btn-min-width=\"250\" sort-collection=\"false\"\n                             prompt=\"Select Action\" disabled=\"true\" dropup=\"true\" label-field=\"label\"\n                             ng-change=\"pkgEditorToolbarCtrlr.handleSelectedAction()\">\n            </dropdown-select>\n        </div>\n    </div>\n</form>\n");
        $templateCache.put("package/editor/components/toolbar/liveclip-toolbar-template.html", "<form class=\"form-inline\" name=\"liveclipToolbar\">\n	<div class=\"form-group\">\n		<div class=\"col-md-12 toolbar-padding\">\n			<a class=\"toolbar-button\" role=\"button\" id=\"closeToolbarButton\" ng-click=\"liveClipToolbarCtrlr.closeClickHandler()\"><i class=\"fa fa-times\"></i><br>Close</a>\n		</div>\n	</div>\n	<div class=\"form-group\">\n		<div class=\"col-md-12 col-md-offset-2\">\n			<ul class=\"pagination pagination-sm\">\n				<li ng-click=\"liveClipToolbarCtrlr.prevPageClickHandler()\">\n					<a ng-disabled=\"liveClipToolbarCtrlr.prevPageDisabled()\">Prev</a>\n				</li>\n				<li ng-click=\"liveClipToolbarCtrlr.nextPageClickHandler()\">\n					<a ng-disabled=\"liveClipToolbarCtrlr.nextPageDisabled()\">Next</a>\n				</li>\n			</ul>\n		</div>\n	</div>\n	<div class=\"form-group col-md-offset-4\">\n		<div class=\"form-group\">\n			<div class=\"col-md-12 col-lg-12\">\n				<dropdown-select id=\"liveClipActionSelect\" ng-model=\"liveClipToolbarCtrlr.selectedAction\" collection=\"liveClipToolbarCtrlr.liveClipActions\"\n								 btn-mid-width=\"250\" sort-collection=\"false\" prompt=\"Select Action\" disabled=\"true\"\n								 dropup=\"true\" ng-disabled=\"liveClipToolbarCtrlr.disableActionDropdown()\"\n								 show-loading=\"liveClipToolbarCtrlr.showActionsLoading\" label-field=\"label\"\n								 ng-change=\"liveClipToolbarCtrlr.handleSelectedAction()\" dropdown-click=\"liveClipToolbarCtrlr.retrieveClipPermissions()\">\n				</dropdown-select>\n			</div>\n		</div>\n		<div class=\"form-group\">\n			<div class=\"col-md-4 col-lg-4 toolbar-padding\">\n				<a class=\"toolbar-button\" role=\"button\" id=\"liveClipHideBtn\" ng-disabled=\"liveClipToolbarCtrlr.hideInvalid\"\n				   ng-show=\"liveClipToolbarCtrlr.liveToolbarPerms.clipHideRead\"\n				   ng-click=\"!liveClipToolbarCtrlr.hideInvalid && liveClipToolbarCtrlr.openConfirmModal(liveClipToolbarCtrlr.hideMessage, \'Hide\', liveClipToolbarCtrlr.toggleArchiveFlag)\">\n					<i class=\"fa fa-eye-slash\"></i><br>Hide</a>\n			</div>\n			<div class=\"col-md-4 col-lg-4 toolbar-padding\">\n				<a class=\"toolbar-button\" role=\"button\" id=\"liveClipUnhideBtn\" ng-disabled=\"liveClipToolbarCtrlr.unhideInvalid\"\n				   ng-show=\"liveClipToolbarCtrlr.liveToolbarPerms.clipHideRead\"\n				   ng-click=\"!liveClipToolbarCtrlr.unhideInvalid && liveClipToolbarCtrlr.openConfirmModal(liveClipToolbarCtrlr.unhideMessage, \'Unhide\', liveClipToolbarCtrlr.toggleArchiveFlag)\">\n					<i class=\"fa fa-eye\"></i><br>Unhide</a>\n			</div>\n		</div>\n	</div>\n	<div class=\"form-group pull-right toolbar-top-padding-md\" ng-show=\"liveClipToolbarCtrlr.liveToolbarPerms.clipHideRead\">\n		<div>\n			<input id=\"liveClipShowHiddenCB\" type=\"checkbox\" ng-change=\"liveClipToolbarCtrlr.updateClipList()\" ng-model=\"liveClipToolbarCtrlr.includeArchived\"\n				   ng-disabled=\"!liveClipToolbarCtrlr.liveToolbarPerms.clipHideWrite\">\n			<label for=\"liveClipShowHiddenCB\">Show Hidden</label>\n		</div>\n	</div>\n</form>\n\n");
        $templateCache.put("package/editor/components/toolbar/media-toolbar-template.html", "<form class=\"form-inline toolbar-top-padding-sm\" name=\"mediaToolbar\">\n	<div class=\"form-group\">\n		<div class=\"col-md-4\">\n			<a class=\"toolbar-button\" role=\"button\" id=\"saveToolbarButton\" ng-click=\"pkgEditorToolbarCtrlr.saveClickHandler()\"\n			   ng-disabled=\"pkgEditorToolbarCtrlr.saveDisabled()\">\n				<i class=\"fa fa-floppy-o\"></i><br>Save\n			</a>\n		</div>\n		<div class=\"col-md-4\">\n			<a class=\"toolbar-button\" role=\"button\" id=\"revertToolbarButton\" ng-click=\"pkgEditorToolbarCtrlr.revertClickHandler()\"\n			   ng-disabled=\"pkgEditorToolbarCtrlr.revertDisabled()\">\n				<i class=\"fa fa-undo\"></i><br>Revert\n			</a>\n		</div>\n		<div class=\"col-md-4\">\n			<a class=\"toolbar-button\" role=\"button\" id=\"closeToolbarButton\" ng-click=\"pkgEditorToolbarCtrlr.closeClickHandler()\"><i class=\"fa fa-times\"></i><br>Close</a>\n		</div>\n	</div>\n	<div class=\"form-group\">\n		<div class=\"col-md-12 col-md-offset-2\">\n			<ul class=\"pagination pagination-sm\">\n				<li ng-click=\"pkgEditorToolbarCtrlr.prevPageClickHandler()\">\n					<a ng-disabled=\"pkgEditorToolbarCtrlr.prevPageDisabled()\">Prev</a>\n				</li>\n				<li ng-click=\"pkgEditorToolbarCtrlr.nextPageClickHandler()\">\n					<a ng-disabled=\"pkgEditorToolbarCtrlr.nextPageDisabled()\">Next</a>\n				</li>\n			</ul>\n		</div>\n	</div>\n	<div class=\"form-group\">\n		<div class=\"col-md-12\">\n			<div>\n				<input type=\"checkbox\"\n					   id=\"autoDeliverCB\"\n					   ng-model=\"pkgEditorToolbarCtrlr.contextData.autoDeliver\"\n					   ng-change=\"pkgEditorToolbarCtrlr.editorForm.$setDirty()\"\n					   ng-disabled=\"!pkgEditorToolbarCtrlr.toolbarPerms.mediaWrite || !pkgEditorToolbarCtrlr.canChangeAutoDelivery() \">\n				<label for=\"autoDeliverCB\">Auto Delivery</label>\n			</div>\n		</div>\n	</div>\n	<div class=\"form-group\"\n         ng-show=\"pkgEditorToolbarCtrlr.showHoldForComponentsCB()\">\n		<div class=\"col-md-12\">\n			<div>\n				<input type=\"checkbox\"\n					   id=\"holdForComponentsCB\"\n					   ng-model=\"pkgEditorToolbarCtrlr.contextData.pendingIngest\"\n					   ng-change=\"pkgEditorToolbarCtrlr.editorForm.$setDirty()\"\n					   ng-disabled=\"!pkgEditorToolbarCtrlr.toolbarPerms.mediaWrite\">\n				<label for=\"holdForComponentsCB\">Hold for Components</label>\n			</div>\n		</div>\n	</div>\n	<div class=\"form-group\"\n         ng-show=\"!pkgEditorToolbarCtrlr.wasMainVideoUploaded()\">\n		<div class=\"col-md-12\">\n			<div>\n				<input type=\"checkbox\"\n					   id=\"purgeOnIngestCB\"\n					   ng-model=\"pkgEditorToolbarCtrlr.contextData.purgeOnIngest\"\n					   ng-change=\"pkgEditorToolbarCtrlr.editorForm.$setDirty()\"\n					   ng-disabled=\"!pkgEditorToolbarCtrlr.toolbarPerms.mediaWrite || !pkgEditorToolbarCtrlr.statusAllowsEdit()\">\n				<label for=\"purgeOnIngestCB\">Purge on Ingest</label>\n			</div>\n		</div>\n	</div>\n	<div class=\"form-group\">\n		<div class=\"col-md-12 col-lg-12\">\n			<dropdown-select id=\"pkgEditActionSelect\" ng-model=\"pkgEditorToolbarCtrlr.selectedAction\"\n							 ng-disabled=\"pkgEditorToolbarCtrlr.actionDropdownDisabled()\"\n							 collection=\"pkgEditorToolbarCtrlr.actions\" btn-min-width=\"250\" sort-collection=\"false\"\n							 prompt=\"Select Action\" disabled=\"true\" dropup=\"true\" label-field=\"label\"\n							 ng-change=\"pkgEditorToolbarCtrlr.handleSelectedAction()\">\n			</dropdown-select>\n		</div>\n	</div>\n</form>\n");
        $templateCache.put("package/editor/components/toolbar/metadata-toolbar-template.html", "<form class=\"form-inline toolbar-top-padding-sm\"\n      name=\"metadataToolbar\">\n    <div class=\"form-group\">\n        <div class=\"col-md-3\">\n            <a class=\"toolbar-button\"\n               role=\"button\"\n               id=\"saveToolbarButton\"\n               ng-click=\"pkgEditorToolbarCtrlr.saveClickHandler()\"\n               ng-dblclick=\"return\"\n               ng-disabled=\"pkgEditorToolbarCtrlr.saveDisabled()\">\n                <i class=\"fa fa-floppy-o\"></i><br>Save\n            </a>\n        </div>\n        <div class=\"col-md-3\">\n            <a class=\"toolbar-button\"\n               role=\"button\"\n               id=\"revertToolbarButton\"\n               ng-click=\"pkgEditorToolbarCtrlr.revertClickHandler()\"\n               ng-disabled=\"pkgEditorToolbarCtrlr.revertDisabled()\">\n                <i class=\"fa fa-undo\"></i><br>Revert\n            </a>\n        </div>\n        <div class=\"col-md-3\">\n            <a class=\"toolbar-button\"\n               role=\"button\"\n               id=\"packageMetaCloneButton\"\n               ng-click=\"pkgEditorToolbarCtrlr.toolbarPerms.cloneWrite && pkgEditorToolbarCtrlr.confirmClone()\"\n               ng-disabled=\"!pkgEditorToolbarCtrlr.toolbarPerms.cloneWrite\"\n               ng-show=\"pkgEditorToolbarCtrlr.toolbarPerms.cloneRead\">\n                <i class=\"fa fa-files-o\"></i><br>Clone\n            </a>\n        </div>\n        <div class=\"col-md-3\">\n            <a class=\"toolbar-button\"\n               role=\"button\"\n               id=\"closeToolbarButton\"\n               ng-click=\"pkgEditorToolbarCtrlr.closeClickHandler()\">\n                <i class=\"fa fa-times\"></i><br>Close\n            </a>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <div class=\"col-md-12 col-md-offset-2\">\n            <ul class=\"pagination pagination-sm\">\n                <li ng-click=\"pkgEditorToolbarCtrlr.prevPageClickHandler()\">\n                    <a ng-disabled=\"pkgEditorToolbarCtrlr.prevPageDisabled()\">Prev</a>\n                </li>\n                <li ng-click=\"pkgEditorToolbarCtrlr.nextPageClickHandler()\">\n                    <a ng-disabled=\"pkgEditorToolbarCtrlr.nextPageDisabled()\">Next</a>\n                </li>\n            </ul>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <div class=\"col-md-12\">\n            <div class=\"\">\n                <input type=\"checkbox\"\n                       id=\"autoDeliverCB\"\n                       ng-model=\"pkgEditorToolbarCtrlr.contextData.autoDeliver\"\n                       ng-change=\"pkgEditorToolbarCtrlr.editorForm.$setDirty()\"\n                       ng-disabled=\"!pkgEditorToolbarCtrlr.toolbarPerms.metaWrite || !pkgEditorToolbarCtrlr.canChangeAutoDelivery()\"/>\n                <label for=\"autoDeliverCB\">Auto Delivery</label>\n            </div>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <div class=\"col-md-12 col-lg-12\">\n            <dropdown-select id=\"pkgEditActionSelect\"\n                             ng-model=\"pkgEditorToolbarCtrlr.selectedAction\"\n                             ng-disabled=\"pkgEditorToolbarCtrlr.actionDropdownDisabled()\"\n                             collection=\"pkgEditorToolbarCtrlr.actions\"\n                             btn-min-width=\"250\"\n                             sort-collection=\"false\"\n                             prompt=\"Select Action\"\n                             disabled=\"true\"\n                             dropup=\"true\"\n                             label-field=\"label\"\n                             ng-change=\"pkgEditorToolbarCtrlr.handleSelectedAction()\">\n            </dropdown-select>\n        </div>\n    </div>\n</form>\n");
        $templateCache.put("package/editor/components/toolbar/package-completed-deliveries-toolbar-template.html", "<form class=\"form-inline toolbar-top-padding-sm\"\n      name=\"advancedMetadataToolbar\">\n    <div class=\"form-group\">\n        <div class=\"col-md-4\">\n            <a class=\"toolbar-button\"\n               role=\"button\"\n               id=\"closeToolbarButton\"\n               ng-click=\"pkgEditorToolbarCtrlr.closeClickHandler()\">\n                <i class=\"fa fa-times\"></i><br>Close\n            </a>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <div class=\"col-md-12 col-md-offset-2\">\n            <ul class=\"pagination pagination-sm\">\n                <li ng-click=\"pkgEditorToolbarCtrlr.prevPageClickHandler()\">\n                    <a ng-disabled=\"pkgEditorToolbarCtrlr.prevPageDisabled()\">Prev</a>\n                </li>\n                <li ng-click=\"pkgEditorToolbarCtrlr.nextPageClickHandler()\">\n                    <a ng-disabled=\"pkgEditorToolbarCtrlr.nextPageDisabled()\">Next</a>\n                </li>\n            </ul>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <div class=\"col-md-12\">\n            <dropdown-select id=\"pkgEditActionSelect\"\n                             ng-model=\"pkgEditorToolbarCtrlr.selectedAction\"\n                             ng-disabled=\"pkgEditorToolbarCtrlr.actionDropdownDisabled()\"\n                             collection=\"pkgEditorToolbarCtrlr.actions\"\n                             btn-min-width=\"250\"\n                             sort-collection=\"false\"\n                             prompt=\"Select Action\"\n                             disabled=\"true\"\n                             dropup=\"true\"\n                             label-field=\"label\"\n                             ng-change=\"pkgEditorToolbarCtrlr.handleSelectedAction()\">\n            </dropdown-select>\n        </div>\n    </div>\n</form>\n");
        $templateCache.put("package/editor/components/toolbar/packageeditor-toolbar-template.html", "<div ng-switch=\"pkgEditorToolbarCtrlr.editorForm.$name\">\n    <div ng-switch-when=\"$ctrl.packageMetadataEditorForm\">\n        <div ng-include=\"\'package/editor/components/toolbar/metadata-toolbar-template.html\'\"></div>\n    </div>\n    <div ng-switch-when=\"$ctrl.packageMediaEditorForm\">\n        <div ng-include=\"\'package/editor/components/toolbar/media-toolbar-template.html\'\"></div>\n    </div>\n    <div ng-switch-when=\"$ctrl.packageCollaboratorsEditorForm\">\n        <div ng-include=\"\'package/editor/components/toolbar/collaborators-toolbar-template.html\'\"></div>\n    </div>\n    <div ng-switch-when=\"$ctrl.packageDistributionGridEditorForm\">\n        <div ng-include=\"\'package/editor/components/toolbar/basicdistribution-toolbar-template.html\'\"></div>\n    </div>\n    <div ng-switch-when=\"pkgPreviewCtrl.editorForm\">\n        <div ng-include=\"\'package/editor/components/toolbar/preview-toolbar-template.html\'\"></div>\n    </div>\n    <div ng-switch-when=\"$ctrl.timingsSearchForm\">\n        <div ng-include=\"\'package/editor/components/toolbar/timings-toolbar-template.html\'\"></div>\n    </div>\n    <div ng-switch-when=\"$ctrl.packageAdvancedMetadataEditorForm\">\n        <div ng-include=\"\'package/editor/components/toolbar/advanced-metadata-toolbar-template.html\'\"></div>\n    </div>\n    <div ng-switch-when=\"$ctrl.packageCompletedDeliveriesEditorForm\">\n        <div ng-include=\"\'package/editor/components/toolbar/package-completed-deliveries-toolbar-template.html\'\"></div>\n    </div>\n    <div ng-switch-when=\"$ctrl.externalIngestsTabEditorForm\">\n        <div ng-include=\"\'package/editor/components/toolbar/external-ingests-tab-toolbar-template.html\'\"></div>\n    </div>\n</div>\n");
        $templateCache.put("package/editor/components/toolbar/preview-toolbar-template.html", "<form class=\"form-inline toolbar-top-padding-sm\" name=\"metadataToolbar\">\n	<div class=\"form-group\">\n		<div class=\"col-md-3\">\n			<a class=\"toolbar-button\"\n			   role=\"button\"\n			   id=\"closeToolbarButton\"\n			   ng-click=\"pkgEditorToolbarCtrlr.closeClickHandler()\">\n				<i class=\"fa fa-times\"></i><br>Close\n			</a>\n		</div>\n	</div>\n	<div class=\"form-group\">\n		<div class=\"col-md-12 col-md-offset-2\">\n			<ul class=\"pagination pagination-sm\">\n				<li ng-click=\"pkgEditorToolbarCtrlr.prevPageClickHandler()\">\n					<a ng-disabled=\"pkgEditorToolbarCtrlr.prevPageDisabled()\">Prev</a>\n				</li>\n				<li ng-click=\"pkgEditorToolbarCtrlr.nextPageClickHandler()\">\n					<a ng-disabled=\"pkgEditorToolbarCtrlr.nextPageDisabled()\">Next</a>\n				</li>\n			</ul>\n		</div>\n	</div>\n	<div class=\"form-group\">\n		<div class=\"col-md-12 col-lg-12\">\n			<dropdown-select id=\"pkgEditActionSelect\" ng-model=\"pkgEditorToolbarCtrlr.selectedAction\"\n							 ng-disabled=\"pkgEditorToolbarCtrlr.actionDropdownDisabled()\"\n							 collection=\"pkgEditorToolbarCtrlr.actions\" btn-min-width=\"250\" sort-collection=\"false\"\n							 prompt=\"Select Action\" disabled=\"true\" dropup=\"true\" label-field=\"label\"\n							 ng-change=\"pkgEditorToolbarCtrlr.handleSelectedAction()\">\n			</dropdown-select>\n		</div>\n	</div>\n</form>\n");
        $templateCache.put("package/editor/components/toolbar/timings-toolbar-template.html", "<form class=\"form-inline\" name=\"timingsToolbar\">\n	<div class=\"form-group\">\n		<div class=\"col-md-4\">\n			<a class=\"toolbar-button\"\n			   role=\"button\"\n			   id=\"timingsNewButton\"\n			   ng-click=\"pkgEditorToolbarCtrlr.toolbarPerms.timingsWrite && pkgEditorToolbarCtrlr.newClickHandler()\"\n			   ng-disabled=\"!pkgEditorToolbarCtrlr.toolbarPerms.timingsWrite || !pkgEditorToolbarCtrlr.statusAllowsEdit() || pkgEditorToolbarCtrlr.contextData.locked || pkgEditorToolbarCtrlr.contextData.isDelivering\">\n				<i class=\"fa fa-plus\"></i><br>&nbsp;&nbsp;New\n			</a>\n		</div>\n		<div class=\"col-md-4\">\n			<a class=\"toolbar-button\"\n			   ng-click=\"pkgEditorToolbarCtrlr.toolbarPerms.timingsWrite && !pkgEditorToolbarCtrlr.tabDeleteInvalid() && pkgEditorToolbarCtrlr.deleteClickHandler()\"\n			   role=\"button\"\n			   id=\"deleteTimingsButton\"\n			   ng-disabled=\"!pkgEditorToolbarCtrlr.toolbarPerms.timingsWrite || pkgEditorToolbarCtrlr.tabDeleteInvalid() || pkgEditorToolbarCtrlr.contextData.locked || pkgEditorToolbarCtrlr.contextData.isDelivering\">\n				<i class=\"fa fa-trash-o\"></i><br>Delete\n			</a>\n		</div>\n		<div class=\"col-md-4\">\n			<a class=\"toolbar-button\"\n			   ng-click=\"pkgEditorToolbarCtrlr.toolbarPerms.timingsWrite && pkgEditorToolbarCtrlr.uploadClickHandler()\"\n			   role=\"button\"\n			   id=\"uploadTimingsButton\"\n			   ng-disabled=\"!pkgEditorToolbarCtrlr.toolbarPerms.timingsWrite || !pkgEditorToolbarCtrlr.statusAllowsEdit() || pkgEditorToolbarCtrlr.contextData.locked || pkgEditorToolbarCtrlr.contextData.isDelivering\">\n				<i class=\"fa fa-upload\"></i><br>Upload\n			</a>\n		</div>\n	</div>\n	<div class=\"form-group\">\n		<div class=\"col-md-12 col-md-offset-2\">\n			<ul class=\"pagination pagination-sm\">\n				<li ng-click=\"pkgEditorToolbarCtrlr.prevPageClickHandler()\">\n					<a ng-disabled=\"pkgEditorToolbarCtrlr.prevPageDisabled()\">Prev</a>\n				</li>\n				<li ng-click=\"pkgEditorToolbarCtrlr.nextPageClickHandler()\">\n					<a ng-disabled=\"pkgEditorToolbarCtrlr.nextPageDisabled()\">Next</a>\n				</li>\n			</ul>\n		</div>\n	</div>\n	<div class=\"form-group\">\n		<div class=\"col-md-12 col-lg-12\">\n			<dropdown-select id=\"pkgEditActionSelect\" ng-model=\"pkgEditorToolbarCtrlr.selectedAction\"\n							 ng-disabled=\"pkgEditorToolbarCtrlr.actionDropdownDisabled()\"\n							 collection=\"pkgEditorToolbarCtrlr.actions\" btn-min-width=\"250\" sort-collection=\"false\"\n							 prompt=\"Select Action\" disabled=\"true\" dropup=\"true\" label-field=\"label\"\n							 ng-change=\"pkgEditorToolbarCtrlr.handleSelectedAction()\">\n			</dropdown-select>\n		</div>\n	</div>\n</form>\n\n");
        $templateCache.put("package/manager/modals/filter/filter-modal-template.html", "<div class=\"modal-header\">\n	<a id=\"packageFilterXBtn\" href=\"\" ng-click=\"pmFilterModal.xClicked()\"><i class=\"fa fa-times pull-right\"></i></a>\n	<h5 align=\"center\" class=\"modal-title\">Search Filters</h5>\n</div>\n<div class=\"modal-body\">\n	<form class=\"form-horizontal\" role=\"form\">\n		<div class=\"edit-view-container\">\n			<div ng-include=\"\'package/manager/modals/filter/metadataSearchSection/metadata-search-section-template.html\'\"></div>\n		</div>\n\n		<hr/>\n\n        <div class=\"edit-view-container\">\n			<div ng-include=\"\'package/manager/modals/filter/packagePropertiesSection/package-properties-section-template.html\'\"></div>\n		</div>\n\n		<hr/>\n\n        <div class=\"edit-view-container\">\n            <div ng-include=\"\'package/manager/modals/filter/deliverySection/delivery-section-template.html\'\"></div>\n        </div>\n\n        <hr/>\n\n        <div class=\"edit-view-container\">\n			<div ng-include=\"\'package/manager/modals/filter/datePropertiesSection/date-properties-section-template.html\'\"></div>\n		</div>\n\n		<hr/>\n\n		<div class=\"edit-view-container\">\n			<div ng-include=\"\'package/manager/modals/filter/metadataPropertiesSection/metadata-properties-section-template.html\'\"></div>\n		</div>\n\n	</form>\n</div>\n<div class=\"modal-footer\">\n	<button class=\"btn btn-sm btn-default\" ng-click=\"pmFilterModal.cancel()\">Reset Defaults</button>\n	<button class=\"btn btn-sm btn-default\" ng-click=\"pmFilterModal.onOk()\">Apply</button>\n</div>\n");
        $templateCache.put("package/manager/modals/newPackage/new-package-modal-template.html", "<div class=\"modal-header\">\n    <h5 align=\"center\"\n        class=\"modal-title\">Create Package</h5>\n</div>\n<div class=\"modal-body\">\n    <div class=\"form-horizontal\">\n        <div class=\"form-group\">\n            <label for=\"name\"\n                   class=\"col-sm-3 control-label lg-txt\">Name</label>\n\n            <div class=\"col-sm-5 pad-text-input-col\">\n                <input type=\"text\"\n                       class=\"form-control input-sm prism-text-input\"\n                       autocomplete=\"off\"\n                       ng-model=\"newPackageCtrl.name\"\n                       id=\"name\"/>\n            </div>\n            <div class=\"col-sm-4 no-padding pad-text-input-col\">\n                <input type=\"number\"\n                       class=\" col-md-2 prism-text-input bulk-pkg-create-field\"\n                       id=\"numPackages\"\n                       name=\"packageStepper\"\n                       min=\"1\"\n                       max=\"99\"\n                       ng-change=\"newPackageCtrl.onNumPackagesChanged(newPackageCtrl.numPackages, 1, 99)\"\n                       ng-model-options=\"{allowInvalid: true}\"\n                       ng-model=\"newPackageCtrl.numPackages\"/>\n                <label for=\"numPackages\"\n                       class=\"control-label bulk-pkg-create-label\">1-99</label>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label for=\"format\"\n                   class=\"col-sm-3 control-label lg-txt\">Format</label>\n\n            <fieldset class=\"col-sm-3 metadata-control-col\"\n                      ng-disabled=\"newPackageCtrl.contentType === \'Ad/PreRoll\'\">\n                <dropdown-select id=\"format\"\n                                 ng-model=\"newPackageCtrl.packageType\"\n                                 label-field=\"name\"\n                                 btn-min-width=\"350\"\n                                 collection=\"newPackageCtrl.packageTypes\">\n                </dropdown-select>\n            </fieldset>\n        </div>\n        <div class=\"form-group\">\n            <label for=\"contentRadios\"\n                   class=\"col-sm-3 control-label\">Content</label>\n            <div class=\"col-sm-9\">\n                <div class=\"input-group\"\n                     id=\"contentRadios\">\n                    <input type=\"radio\"\n                           id=\"ads\"\n                           name=\"contentType\"\n                           ng-change=\"newPackageCtrl.resetDefaultContent(true)\"\n                           ng-model=\"newPackageCtrl.contentType\"\n                           value=\"Ad/PreRoll\"/>\n                    <label class=\"control-label right-side-label\"\n                           for=\"ads\"> Ads/Prerolls</label>\n                    <input type=\"radio\"\n                           id=\"movies\"\n                           name=\"contentType\"\n                           ng-change=\"newPackageCtrl.resetDefaultContent()\"\n                           ng-model=\"newPackageCtrl.contentType\"\n                           value=\"Movie/Special\"/>\n                    <label class=\"control-label right-side-label\"\n                           for=\"movies\"> Movie/Special</label>\n                    <input type=\"radio\"\n                           id=\"series\"\n                           name=\"contentType\"\n                           ng-change=\"newPackageCtrl.resetDefaultContent()\"\n                           ng-model=\"newPackageCtrl.contentType\"\n                           value=\"Series\"/>\n                    <label class=\"control-label right-side-label\"\n                           for=\"series\"> Series</label>\n                </div>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label for=\"name\"\n                   class=\"col-sm-3 control-label lg-txt\">{{newPackageCtrl.contentType}}</label>\n            <div class=\"col-sm-6 spacer-top-sm\">\n                <p class=\"text-input-color\">{{newPackageCtrl.selectedContent.name}}</p>\n            </div>\n            <div class=\"col-sm-3 spacer-top-sm\">\n                <button class=\"btn btn-default prism-button\"\n                        ng-disabled=\"!newPackageCtrl.packageType.name\"\n                        ng-click=\"newPackageCtrl.openContentSelectModal()\">Change\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"modal-footer\">\n    <div class=\"flex-row-container\">\n        <button class=\"btn btn-sm btn-default\"\n                ng-click=\"newPackageCtrl.cancel()\">\n            Cancel\n        </button>\n\n        <div class=\"flex-stretcher\">\n        </div>\n\n        <button class=\"btn btn-sm btn-default\"\n                ng-click=\"newPackageCtrl.onOk()\"\n                ng-disabled=\"newPackageCtrl.disableOk()\">\n            OK\n        </button>\n    </div>\n</div>\n");
        $templateCache.put("package/manager/modals/packagequalitycontrol/package-quality-control-modal-template.html", "<div class=\"modal-header\">\n	<h5 align=\"center\" class=\"modal-title\">Package Media Quality Control Notes</h5>\n</div>\n<div class=\"modal-body\">\n	<div ng-repeat=\"note in qualCntrlMdlCntrlr.qcNoteData\">\n		<h5>{{note.type}}</h5>\n		<span class=\"qc-notes-text\">{{note.qualityControlNote}}</span>\n	</div>\n</div>\n<div class=\"modal-footer\">\n	<button class=\"btn btn-sm btn-default\" ng-click=\"qualCntrlMdlCntrlr.onOk()\">OK</button>\n</div>\n");
        $templateCache.put("system/contacts/editView/renderers/contacts-editor-general-section-template.html", "<div class=\"row clearfix\">\n\n    <div class=\"col-md-12 column\">\n        <div class=\"row\">\n            <div class=\"col-md-2\">\n                <div class=\"prism-form-heading\">\n                    General\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"row clearfix spacer-top-lg\">\n        <div class=\"col-md-12 column\">\n\n            <!-- First Name -->\n            <div class=\"form-group\">\n                <label for=\"contactFirstName\"\n                       class=\"col-sm-2 control-label\">\n                    First Name\n                </label>\n                <div class=\"col-sm-4 pad-text-input-col\">\n                    <input type=\"text\"\n                           id=\"contactFirstName\"\n                           class=\"prism-text-input form-control\"\n                           ng-model=\"$ctrl.contact.firstName\">\n                    </input>\n                </div>\n            </div>\n\n            <!-- Last Name -->\n            <div class=\"form-group\">\n                <label for=\"contactLastName\"\n                       class=\"col-sm-2 control-label\">\n                    Last Name\n                </label>\n                <div class=\"col-sm-4 pad-text-input-col\">\n                    <input type=\"text\"\n                           id=\"contactLastName\"\n                           class=\"prism-text-input form-control\"\n                           ng-model=\"$ctrl.contact.lastName\">\n                    </input>\n                </div>\n            </div>\n\n            <!-- Title -->\n            <div class=\"form-group\">\n                <label for=\"contactTitle\"\n                       class=\"col-sm-2 control-label\">\n                    Title\n                </label>\n                <div class=\"col-sm-4 pad-text-input-col\">\n                    <input type=\"text\"\n                           id=\"contactTitle\"\n                           class=\"prism-text-input form-control\"\n                           ng-model=\"$ctrl.contact.title\">\n                    </input>\n                </div>\n            </div>\n\n            <!-- Address -->\n            <div class=\"form-group\">\n                <label for=\"contactAddress\"\n                       class=\"col-sm-2 control-label\">\n                    Address\n                </label>\n                <div class=\"col-sm-4 pad-text-input-col\">\n                    <input type=\"text\"\n                           id=\"contactAddress\"\n                           class=\"prism-text-input form-control\"\n                           ng-model=\"$ctrl.contact.address\">\n                    </input>\n                </div>\n            </div>\n\n            <!-- Email -->\n            <div class=\"form-group\">\n                <label for=\"contactEmailAddress\"\n                       class=\"col-sm-2 control-label\">\n                    Email\n                </label>\n                <div class=\"col-sm-4 pad-text-input-col\">\n                    <input type=\"text\"\n                           id=\"contactEmailAddress\"\n                           class=\"prism-text-input form-control\"\n                           ng-model=\"$ctrl.contact.emailAddress\">\n                    </input>\n                </div>\n                <div class=\"required-text-input\"\n                     required\n                     x-required-indicator>\n                </div>\n            </div>\n\n            <!-- Phone -->\n            <div class=\"form-group\">\n                <label for=\"contactPhoneNumber\"\n                       class=\"col-sm-2 control-label\">\n                    Phone\n                </label>\n                <div class=\"col-sm-4 pad-text-input-col\">\n                    <input type=\"text\"\n                           id=\"contactPhoneNumber\"\n                           class=\"prism-text-input form-control\"\n                           ng-model=\"$ctrl.contact.phoneNumber\">\n                    </input>\n                </div>\n            </div>\n\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/contacts/editView/renderers/contacts-editor-management-section-template.html", "<div class=\"row clearfix\">\n\n    <div class=\"col-md-12 column\">\n        <div class=\"row\">\n            <div class=\"col-md-2\">\n                <div class=\"prism-form-heading\">\n                    Management\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"row clearfix spacer-top-lg\">\n        <div class=\"col-md-12 column\">\n\n            <div class=\"form-group\">\n                <div class=\"v-align\">\n                    <label for=\"contactEnabled\"\n                           class=\"col-sm-2 control-label\">\n                        Enabled\n                    </label>\n                    <div class=\"col-sm-1 padding-top-sm\">\n                        <input type=\"checkbox\"\n                               id=\"contactEnabled\"\n                               ng-model=\"$ctrl.contact.enabledFlag\"/>\n                        <label for=\"contactEnabled\"\n                               class=\"control-label\"></label>\n                    </div>\n                </div>\n            </div>\n\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/externalMetadata/queue/cellTemplates/external-ingest-priority-cell-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\"\n     ng-class=\"{\n        \'cell-contains-a-search-result\' : grid.appScope.$ctrl.cellHasASearchResult(row.entity, col.field),\n        \'cell-contains-current-search-result\' : grid.appScope.$ctrl.cellHasCurrentSearchResult(row.entity, col.field)\n     }\"\n     data-tooltip-append-to-body=\"true\"\n     uib-tooltip=\"{{COL_FIELD CUSTOM_FILTERS}}\"\n     ng-dblclick=\"grid.appScope.$ctrl.onPriorityCellDoubleClicked(row, $event)\">\n    <span class=\"padding-left-sm\">{{COL_FIELD CUSTOM_FILTERS}}</span>\n</div>\n");
        $templateCache.put("system/externalMetadata/queue/cellTemplates/external-ingest-source-cell-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\"\n     ng-class=\"{\n        \'cell-contains-a-search-result\' : grid.appScope.$ctrl.cellHasASearchResult(row.entity, col.field),\n        \'cell-contains-current-search-result\' : grid.appScope.$ctrl.cellHasCurrentSearchResult(row.entity, col.field)\n     }\"\n     data-tooltip-append-to-body=\"true\"\n     uib-tooltip=\"{{COL_FIELD CUSTOM_FILTERS}}\"\n     ng-dblclick=\"grid.appScope.$ctrl.onIngestCellDoubleClicked(row, $event)\">\n    <span class=\"padding-left-sm\">{{COL_FIELD CUSTOM_FILTERS}}</span>\n</div>\n");
        $templateCache.put("system/execServers/searchView/renderers/exec-servers-checkmark-cell-template.html", "<div class=\"ui-grid-cell-contents\">\n	<input type=\"checkbox\" id=\"{{row.entity.name + col.field + \'CB\'}}\"  ng-model=\"row.entity[col.field]\"\n		   ng-click=\"grid.appScope.$ctrl.checkMarkCellClicked(row.entity)\"/>\n	<label for=\"{{row.entity.name + col.field + \'CB\'}}\"></label>\n</div>\n\n");
        $templateCache.put("system/externalMetadata/setup/editor/external-metadata-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <!-- Main -->\n    <div class=\"row-no-padding\">\n        <!-- Sidebar -->\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <!-- Content pane -->\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n\n            <div class=\"loadingIndicator\">\n                <div data-lb-progress=\"$ctrl.loadingIndicator\" ng-show=\"$ctrl.loadingIndicator.show\"></div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-12\">\n                    <breadcrumb tab-name=\"$ctrl.editData.name\"></breadcrumb>\n                    <fieldset>\n                        <div class=\"edit-full-height-no-tabs edit-view\">\n                            <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n                                <div ng-include=\"\'system/externalMetadata/setup/editor/renderers/general-template.html\'\"></div>\n                                <br>\n                                <source-collaborators ng-if=\"$ctrl.editData\" edit-data=\"$ctrl.editData\">\n                                </source-collaborators>\n                                <br>\n                                <div ng-if=\"$ctrl.externalIngestType === $ctrl.externalIngestTypes.watchFolder.value\"\n                                     ng-include=\"\'system/externalMetadata/setup/editor/renderers/watch-folder-template.html\'\">\n                                </div>\n                                <div ng-if=\"$ctrl.externalIngestType === $ctrl.externalIngestTypes.jsonFeed.value\"\n                                     ng-include=\"\'system/externalMetadata/setup/editor/renderers/json-feed-template.html\'\">\n                                </div>\n                            </form>\n                        </div>\n                    </fieldset>\n                </div>\n            </div>\n\n            <div class=\"row-no-padding manager-toolbar\">\n\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"></toolbar>\n\n            </div>\n\n        </div>\n\n    </div>\n\n</div>\n\n");
        $templateCache.put("system/externalMetadata/setup/gridView/external-metadata-grid-view-template.html", "<div class=\"col-md-12 col-lg-12 no-padding\">\n\n	<div class=\"loadingIndicator\">\n		<div data-lb-progress=\"$ctrl.loadingIndicator\" ng-show=\"$ctrl.loadingIndicator.show\"></div>\n	</div>\n\n	<div id=\"searchGrid\"\n		 class=\"grid search-grid\"\n		 ui-grid=\"$ctrl.gridOptions\"\n		 ui-grid-selection\n		 ui-grid-pagination\n		 ui-grid-resize-columns>\n	</div>\n\n	<toolbar button-defs=\"$ctrl.toolbarButtonDefs\"></toolbar>\n\n</div>\n");
        $templateCache.put("system/fileSystem/editView/properties/file-system-properties-template.html", "<!-- Pacifier -->\n<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\"></div>\n</div>\n\n<div class=\"row edit-full-height edit-view\">\n    <form class=\"form-horizontal\"\n          role=\"form\"\n          name=\"$ctrl.editorForm\"\n          ng-show=\"$ctrl.fileSystemObject\">\n        <div class=\"edit-view-container\">\n            <div>\n                <div class=\"prism-form-heading\">\n                    General\n                </div>\n\n                <!-- Name -->\n                <div class=\"form-group\">\n                    <label for=\"name\" class=\"col-sm-2 control-label\">\n                        Name\n                    </label>\n                    <div class=\"col-sm-4 pad-text-input-col\">\n                        <input id=\"name\"\n                               class=\"prism-text-input input-sm\"\n                               ng-model=\"$ctrl.fileSystemObject.name\"\n                               required/>\n                    </div>\n                    <div class=\"required-text-input\"\n                         required\n                         x-required-indicator>\n                    </div>\n                </div>\n\n                <!-- Type -->\n                <div class=\"form-group\">\n                    <label for=\"typeName\" class=\"col-sm-2 control-label\">\n                        Type\n                    </label>\n                    <div class=\"col-sm-4\">\n                        <dropdown-select\n                            id=\"typeName\"\n                            btn-min-width=\"230\"\n                            ng-disabled=\"!$ctrl.editingNewFileSystem()\"\n                            label-field=\"name\"\n                            model-prop=\"name\"\n                            required\n                            ng-model=\"$ctrl.fileSystemObject.typeName\"\n                            prompt=\"Select Type\"\n                            collection=\"$ctrl.fileSystemTypes\">\n                        </dropdown-select>\n                    </div>\n                </div>\n\n                <!-- Path Prefix -->\n                <div class=\"form-group\">\n                    <label for=\"pathPrefix\" class=\"col-sm-2 control-label\">\n                        Path Prefix\n                    </label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <input id=\"pathPrefix\"\n                               class=\"prism-text-input input-sm\"\n                               ng-model=\"$ctrl.fileSystemObject.pathPrefix\"\n                               required/>\n                    </div>\n                    <div class=\"required-text-input\"\n                         required\n                         x-required-indicator>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <hr/>\n\n        <file-system-parameters\n            file-system-object=\"$ctrl.fileSystemObject\"\n            file-system-types=\"$ctrl.fileSystemTypes\"\n            selected-type-name=\"$ctrl.fileSystemObject.typeName\">\n        </file-system-parameters>\n    </form>\n\n    <div class=\"row-no-padding\">\n        <div>\n            <toolbar button-defs=\"$ctrl.toolbarButtonDefs\">\n            </toolbar>\n        </div>\n    </div>\n</div>\n\n");
        $templateCache.put("system/groups/editor/members/group-member-search-view-template.html", "<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\">\n    </div>\n</div>\n\n<div id=\"groupMemberSearchViewGrid\"\n     class=\"breadcrumb-tab-edit-search-grid grid search-grid\"\n     ui-grid=\"$ctrl.gridOptions\"\n     ui-grid-resize-columns>\n</div>\n");
        $templateCache.put("system/groups/editor/properties/group-properties-edit-view-template.html", "<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\">\n    </div>\n</div>\n\n<div class=\"row-no-padding\">\n\n        <fieldset ng-if=\"$ctrl.isAdmin\">\n\n            <div ng-show=\"$ctrl.editData\"\n                 class=\"edit-full-height-tabs edit-view\">\n\n                <form class=\"form-horizontal\"\n                      role=\"form\"\n                      name=\"$ctrl.editorForm\">\n\n                    <div class=\"edit-view-container\">\n\n                        <div class=\"row\">\n\n                            <div class=\"col-md-12\">\n\n                                <div class=\"prism-form-heading\">\n                                    General\n                                </div>\n\n                                <div class=\"row clearfix spacer-top-lg\">\n\n                                    <div class=\"col-md-12 column permission-row\">\n\n                                        <div class=\"form-group no-left-padding\">\n\n                                            <label for=\"groupName\"\n                                                   class=\"col-sm-1 control-label\">\n                                                Group Name\n                                            </label>\n\n                                            <div class=\"col-sm-3 pad-text-input-col\">\n                                                <input type=\"text\"\n                                                       id=\"groupName\"\n                                                       class=\"form-control prism-text-input\"\n                                                       autocomplete=\"off\"\n                                                       ng-model=\"$ctrl.editData.group.name\"/>\n                                            </div>\n                                            <div class=\"required-text-input\"\n                                                 required\n                                                 x-required-indicator>\n                                            </div>\n\n                                        </div>\n\n                                        <! ------------------------------ >\n                                        <! -- // Network Permissions // -->\n                                        <! ------------------------------ >\n\n                                        <div class=\"row\">\n                                            <label for=\"networkPermissionsGrid\"\n                                                   class=\"row col-sm-3 control-label\">\n                                                Networks\n                                            </label>\n                                        </div>\n\n                                        <div class=\"row\">\n                                            <div class=\"col-sm-5\">\n                                                <div id=\"networkPermissionsGrid\"\n                                                     class=\"inline-grid-row-8 search-grid top-margin-xs\"\n                                                     ui-grid=\"$ctrl.permissionGridContainers.network.gridOptions\"\n                                                     ui-grid-selection\n                                                     ui-grid-auto-resize>\n                                                </div>\n                                            </div>\n                                        </div>\n\n                                    </div>\n\n                                    <! ------------------------------ >\n                                    <! -- // Category Type Permissions // -->\n                                    <! ------------------------------ >\n\n                                    <div class=\"col-sm-5 permission-row\">\n\n                                        <div class=\"row\">\n                                            <label for=\"shortFormPermissionsGrid\"\n                                                   class=\"row col-sm-3 control-label\">\n                                                Short Form\n                                            </label>\n                                        </div>\n\n                                        <div class=\"row\">\n                                            <div class=\"col-sm-12 no-padding-right\">\n                                                <div id=\"shortFormPermissionsGrid\"\n                                                     class=\"inline-grid-row-1 search-grid top-margin-xs\"\n                                                     ui-grid=\"$ctrl.permissionGridContainers.shortFormType.gridOptions\">\n                                                </div>\n                                            </div>\n                                        </div>\n\n                                    </div>\n\n                                    <div class=\"col-sm-5 permission-row\">\n\n                                        <div class=\"row\">\n                                            <label for=\"longFormPermissionsGrid\"\n                                                   class=\"row col-sm-3 control-label\">\n                                                Long Form\n                                            </label>\n                                        </div>\n\n                                        <div class=\"row\">\n                                            <div class=\"col-sm-12 no-padding-right\">\n                                                <div id=\"longFormPermissionsGrid\"\n                                                     class=\"inline-grid-row-1 search-grid top-margin-xs\"\n                                                     ui-grid=\"$ctrl.permissionGridContainers.longFormType.gridOptions\"\n                                                     ui-grid-selection\n                                                     ui-grid-auto-resize>\n                                                </div>\n                                            </div>\n                                        </div>\n\n                                    </div>\n\n                                    <div class=\"col-sm-5 permission-row\">\n\n                                        <div class=\"row\">\n                                            <label for=\"longFormPermissionsGrid\"\n                                                   class=\"row col-sm-5 control-label\">\n                                                Short Form Categories\n                                            </label>\n                                        </div>\n\n                                        <div class=\"row\">\n                                            <div class=\"col-sm-12 no-padding-right\">\n                                                <div id=\"shortFormGrid\"\n                                                     class=\"inline-grid-row-8 search-grid top-margin-xs\"\n                                                     ui-grid=\"$ctrl.permissionGridContainers.shortForm.gridOptions\"\n                                                     ui-grid-selection\n                                                     ui-grid-auto-resize>\n                                                </div>\n                                            </div>\n                                        </div>\n\n                                    </div>\n\n                                    <div class=\"col-sm-5 permission-row\">\n\n                                        <div class=\"row\">\n                                            <label for=\"longFormPermissionsGrid\"\n                                                   class=\"row col-sm-5 control-label\">\n                                                Long Form Categories\n                                            </label>\n                                        </div>\n\n                                        <div class=\"row\">\n                                            <div class=\"col-sm-12 no-padding-right\">\n                                                <div id=\"longFormGrid\"\n                                                     class=\"inline-grid-row-8 search-grid top-margin-xs\"\n                                                     ui-grid=\"$ctrl.permissionGridContainers.longForm.gridOptions\"\n                                                     ui-grid-selection\n                                                     ui-grid-auto-resize>\n                                                </div>\n                                            </div>\n                                        </div>\n\n                                    </div>\n\n                                    <! ------------------------------ >\n                                    <! -- // Content Permissions // -->\n                                    <! ------------------------------ >\n\n                                    <div class=\"col-sm-3 permission-row no-padding\">\n\n                                        <div class=\"row\">\n\n                                            <div class=\"col-sm-12 no-padding\">\n\n                                                <label for=\"seriesGrid\" class=\"row col-sm-2 control-label\">\n                                                    Series\n                                                </label>\n\n                                                <div class=\"form-group\">\n\n                                                    <div class=\"col-sm-11 add-remove-grid-container\">\n\n                                                        <button id=\"addSeries\"\n                                                                class=\"btn btn-default prism-button\"\n                                                                ng-click=\"$ctrl.addContent(\'series\')\">\n                                                            <i class=\"fa fa-plus\"></i>\n                                                        </button>\n\n                                                        <button id=\"removeSeries\"\n                                                                ng-disabled=\"!$ctrl.permissionGridContainers.series.gridApi.selection.getSelectedRows()[0]\"\n                                                                class=\"btn btn-default prism-button\"\n                                                                ng-click=\"$ctrl.removeGridContentAndPermissionContext(\'series\')\">\n                                                            <i class=\"fa fa-minus\"></i>\n                                                        </button>\n\n                                                        <hr/>\n\n                                                        <div id=\"seriesGrid\"\n                                                             class=\"inline-grid-row-8 search-grid top-margin-xs\"\n                                                             ui-grid=\"$ctrl.permissionGridContainers.series.gridOptions\"\n                                                             ui-grid-selection\n                                                             ui-grid-auto-resize>\n                                                        </div>\n\n                                                    </div>\n\n                                                </div>\n\n                                            </div>\n\n                                        </div>\n\n                                    </div>\n\n                                    <div class=\"col-sm-3 permission-row no-padding\">\n\n                                        <div class=\"row\">\n\n                                            <div class=\"col-sm-12 no-padding\">\n\n                                                <label for=\"movieGrid\" class=\"row col-sm-2 control-label\">\n                                                    Movie\n                                                </label>\n\n                                                <div class=\"form-group\">\n\n                                                    <div class=\"col-sm-11 add-remove-grid-container\">\n\n                                                        <button id=\"addMovie\"\n                                                                class=\"btn btn-default prism-button\"\n                                                                ng-click=\"$ctrl.addContent(\'movie\')\">\n                                                            <i class=\"fa fa-plus\"></i>\n                                                        </button>\n\n                                                        <button id=\"removeMovie\"\n                                                                ng-disabled=\"!$ctrl.permissionGridContainers.movie.gridApi.selection.getSelectedRows()[0]\"\n                                                                class=\"btn btn-default prism-button\"\n                                                                ng-click=\"$ctrl.removeGridContentAndPermissionContext(\'movie\')\">\n                                                            <i class=\"fa fa-minus\"></i>\n                                                        </button>\n\n                                                        <hr/>\n\n                                                        <div id=\"movieGrid\"\n                                                             class=\"inline-grid-row-8 search-grid top-margin-xs\"\n                                                             ui-grid=\"$ctrl.permissionGridContainers.movie.gridOptions\"\n                                                             ui-grid-selection\n                                                             ui-grid-auto-resize>\n                                                        </div>\n\n                                                    </div>\n\n                                                </div>\n\n                                            </div>\n\n                                        </div>\n\n                                    </div>\n\n                                    <div class=\"col-sm-3 permission-row no-padding\">\n\n                                        <div class=\"row\">\n\n                                            <div class=\"col-sm-12 no-padding\">\n\n                                                <label for=\"advertisementGrid\" class=\"row col-sm-2 control-label\">\n                                                    Advertisement\n                                                </label>\n\n                                                <div class=\"form-group\">\n\n                                                    <div class=\"col-sm-11 add-remove-grid-container\">\n\n                                                        <button id=\"addAdvertisement\"\n                                                                class=\"btn btn-default prism-button\"\n                                                                ng-click=\"$ctrl.addContent(\'advertisement\')\">\n                                                            <i class=\"fa fa-plus\"></i>\n                                                        </button>\n\n                                                        <button id=\"removeAdvertiesment\"\n                                                                ng-disabled=\"!$ctrl.permissionGridContainers.advertisement.gridApi.selection.getSelectedRows()[0]\"\n                                                                class=\"btn btn-default prism-button\"\n                                                                ng-click=\"$ctrl.removeGridContentAndPermissionContext(\'advertisement\')\">\n                                                            <i class=\"fa fa-minus\"></i>\n                                                        </button>\n\n                                                        <hr/>\n\n                                                        <div id=\"advertisementGrid\"\n                                                             class=\"inline-grid-row-8 search-grid top-margin-xs\"\n                                                             ui-grid=\"$ctrl.permissionGridContainers.advertisement.gridOptions\"\n                                                             ui-grid-selection\n                                                             ui-grid-auto-resize>\n                                                        </div>\n\n                                                    </div>\n\n                                                </div>\n\n                                            </div>\n\n                                        </div>\n\n                                    </div>\n\n                                </div>\n\n                            </div>\n\n                        </div>\n\n                    </div>\n\n                    <hr/>\n\n                    <div class=\"edit-view-container\">\n\n                        <div class=\"row\">\n\n                            <div class=\"col-md-12\">\n\n                                <div class=\"prism-form-heading\">\n                                    Dashboards\n                                </div>\n\n                                <div class=\"row clearfix\">\n\n                                    <div class=\"col-md-12 column permission-row\">\n\n                                        <! ------------------------------ >\n                                        <! -- // Dashboard Permissions // -->\n                                        <! ------------------------------ >\n\n                                        <div class=\"row\">\n                                            <div class=\"col-sm-5\">\n                                                <div id=\"dashboardPermissionsGrid\"\n                                                     class=\"inline-grid-row-5 search-grid top-margin-xs\"\n                                                     ui-grid=\"$ctrl.permissionGridContainers.dashboard.gridOptions\"\n                                                     ui-grid-selection\n                                                     ui-grid-auto-resize>\n                                                </div>\n                                            </div>\n                                        </div>\n\n                                    </div>\n\n                                </div>\n\n                            </div>\n\n                        </div>\n\n                    </div>\n\n                    <hr/>\n\n                    <div class=\"edit-view-container\">\n\n                        <div class=\"row\">\n\n                            <div class=\"col-md-12\">\n\n                                <div class=\"row col-sm-5 prism-form-heading margin-right-xl\">\n                                    Meta\n                                </div>\n\n                                <div class=\"row col-sm-5 prism-form-heading\">\n                                    System\n                                </div>\n\n                                <div class=\"row clearfix\">\n\n                                    <div class=\"col-md-5 column permission-row\">\n\n                                        <! ------------------------------ >\n                                        <! --- // Meta Permissions // --- >\n                                        <! ------------------------------ >\n\n                                        <div class=\"row\">\n                                            <div class=\"col-sm-12 no-padding-right\">\n                                                <div id=\"metaPermissionsGrid\"\n                                                     class=\"inline-grid-row-6 search-grid top-margin-xs\"\n                                                     ui-grid=\"$ctrl.permissionGridContainers.meta.gridOptions\"\n                                                     ui-grid-selection\n                                                     ui-grid-auto-resize>\n                                                </div>\n                                            </div>\n                                        </div>\n\n                                        <div class=\"row spacer-top-lg\">\n                                            <label for=\"longFormPermissionsGrid\"\n                                                   class=\"row col-sm-5 control-label\">\n                                                Network\n                                            </label>\n                                        </div>\n\n                                        <div class=\"row\">\n                                            <div class=\"col-sm-12 no-padding-right\">\n                                                <div id=\"metaNetworkPermissionsGrid\"\n                                                     class=\"inline-grid-row-4 search-grid top-margin-xs\"\n                                                     ui-grid=\"$ctrl.permissionGridContainers.metaNetwork.gridOptions\"\n                                                     ui-grid-selection\n                                                     ui-grid-auto-resize>\n                                                </div>\n                                            </div>\n                                        </div>\n\n                                        <div class=\"row spacer-top-lg\">\n                                            <label for=\"longFormPermissionsGrid\"\n                                                   class=\"row col-sm-5 control-label\">\n                                                Series\n                                            </label>\n                                        </div>\n\n                                        <div class=\"row\">\n                                            <div class=\"col-sm-12 no-padding-right\">\n                                                <div id=\"metaSeriesPermissionsGrid\"\n                                                     class=\"inline-grid-row-4 search-grid top-margin-xs\"\n                                                     ui-grid=\"$ctrl.permissionGridContainers.metaSeries.gridOptions\"\n                                                     ui-grid-selection\n                                                     ui-grid-auto-resize>\n                                                </div>\n                                            </div>\n                                        </div>\n\n                                        <div class=\"row  spacer-top-lg\">\n                                            <label for=\"longFormPermissionsGrid\"\n                                                   class=\"row col-sm-5 control-label\">\n                                                Movie\n                                            </label>\n                                        </div>\n\n                                        <div class=\"row\">\n                                            <div class=\"col-sm-12 no-padding-right\">\n                                                <div id=\"metaMoviePermissionsGrid\"\n                                                     class=\"inline-grid-row-4 search-grid top-margin-xs\"\n                                                     ui-grid=\"$ctrl.permissionGridContainers.metaMovie.gridOptions\"\n                                                     ui-grid-selection\n                                                     ui-grid-auto-resize>\n                                                </div>\n                                            </div>\n                                        </div>\n\n                                    </div>\n\n                                    <div class=\"col-md-5 column permission-row\">\n\n                                        <! -------------------------------- >\n                                        <! --- // System Permissions // --- >\n                                        <! -------------------------------- >\n\n                                        <div class=\"row\">\n                                            <div class=\"col-sm-12 no-padding-right\">\n                                                <div id=\"systemPermissionsGrid\"\n                                                     class=\"inline-grid-row-1 search-grid top-margin-xs\"\n                                                     ui-grid=\"$ctrl.permissionGridContainers.system.gridOptions\"\n                                                     ui-grid-selection\n                                                     ui-grid-auto-resize>\n                                                </div>\n                                            </div>\n                                        </div>\n\n                                        <div class=\"row spacer-top-lg\">\n                                            <div class=\"col-sm-12 no-padding-right\">\n                                                <div id=\"systemPartnerPermissionsGrid\"\n                                                     class=\"inline-grid-row-4 search-grid top-margin-xs\"\n                                                     ui-grid=\"$ctrl.permissionGridContainers.systemPartner.gridOptions\"\n                                                     ui-grid-selection\n                                                     ui-grid-auto-resize>\n                                                </div>\n                                            </div>\n                                        </div>\n\n                                    </div>\n\n                                </div>\n\n                            </div>\n\n                        </div>\n\n                    </div>\n\n                    <hr/>\n\n                    <div class=\"edit-view-container\">\n\n                        <div class=\"row\">\n\n                            <div class=\"col-md-12\">\n\n                                <div class=\"row col-sm-5 prism-form-heading margin-right-xl\">\n                                    Package Actions\n                                </div>\n\n                                <div class=\"row col-sm-5 prism-form-heading\">\n                                    Clip Actions\n                                </div>\n\n                                <div class=\"row clearfix\">\n\n                                    <div class=\"col-md-5 column permission-row\">\n\n                                        <! ---------------------------------------- >\n                                        <! --- // Package Action Permissions // --- >\n                                        <! ---------------------------------------- >\n\n                                        <div class=\"row\">\n                                            <div class=\"col-sm-12 no-padding-right\">\n                                                <div id=\"packageActionPermissionsGrid\"\n                                                     class=\"inline-grid-row-16 search-grid top-margin-xs\"\n                                                     ui-grid=\"$ctrl.permissionGridContainers.packageAction.gridOptions\"\n                                                     ui-grid-selection\n                                                     ui-grid-auto-resize>\n                                                </div>\n                                            </div>\n                                        </div>\n\n                                    </div>\n\n                                    <div class=\"col-md-5 column permission-row\">\n\n                                        <! -------------------------------------- >\n                                        <! --- // Clip Actions Permissions // --- >\n                                        <! -------------------------------------- >\n\n                                        <div class=\"row\">\n                                            <div class=\"col-sm-12 no-padding-right\">\n                                                <div id=\"clipActionPermissionsGrid\"\n                                                     class=\"inline-grid-row-12 search-grid top-margin-xs\"\n                                                     ui-grid=\"$ctrl.permissionGridContainers.packageActionClip.gridOptions\"\n                                                     ui-grid-selection\n                                                     ui-grid-auto-resize>\n                                                </div>\n                                            </div>\n                                        </div>\n\n                                    </div>\n\n                                </div>\n\n                            </div>\n\n                        </div>\n\n                    </div>\n\n                    <hr/>\n\n                    <div class=\"edit-view-container\">\n\n                        <div class=\"row\">\n\n                            <div class=\"col-md-12\">\n\n                                <div class=\"row col-sm-5 prism-form-heading margin-right-xl\">\n                                    Package Views\n                                </div>\n\n                                <div class=\"row col-sm-5 prism-form-heading\">\n                                    Clipping Views\n                                </div>\n\n                                <div class=\"row clearfix\">\n\n                                    <div class=\"col-md-5 column permission-row\">\n\n                                        <! ---------------------------------------- >\n                                        <! --- // Package Action Permissions // --- >\n                                        <! ---------------------------------------- >\n\n                                        <div class=\"row\">\n                                            <div class=\"col-sm-12 no-padding-right\">\n                                                <div id=\"packageViewPermissionsGrid\"\n                                                     class=\"inline-grid-row-12 search-grid top-margin-xs\"\n                                                     ui-grid=\"$ctrl.permissionGridContainers.packageBasic.gridOptions\"\n                                                     ui-grid-selection\n                                                     ui-grid-auto-resize>\n                                                </div>\n                                            </div>\n                                        </div>\n\n                                    </div>\n\n                                    <div class=\"col-md-5 column permission-row\">\n\n                                        <! -------------------------------------- >\n                                        <! --- // Clip Actions Permissions // --- >\n                                        <! -------------------------------------- >\n\n                                        <div class=\"row\">\n                                            <div class=\"col-sm-12 no-padding-right\">\n                                                <div id=\"clipViewPermissionsGrid\"\n                                                     class=\"inline-grid-row-3 search-grid top-margin-xs\"\n                                                     ui-grid=\"$ctrl.permissionGridContainers.packageClip.gridOptions\"\n                                                     ui-grid-selection\n                                                     ui-grid-auto-resize>\n                                                </div>\n                                            </div>\n                                        </div>\n\n                                    </div>\n\n                                </div>\n\n                            </div>\n\n                        </div>\n\n                    </div>\n\n                    <hr/>\n\n                    <div class=\"edit-view-container\">\n\n                        <div class=\"row\">\n\n                            <div class=\"col-md-12\">\n\n                                <div class=\"prism-form-heading\">\n                                    Aggregation\n                                </div>\n\n                                <div class=\"row clearfix\">\n\n                                    <div class=\"col-md-12 column permission-row\">\n\n                                        <! ---------------------------------- >\n                                        <! -- // Aggregation Permissions // -->\n                                        <! ---------------------------------- >\n\n                                        <div class=\"row\">\n                                            <div class=\"col-sm-5\">\n                                                <div id=\"aggregationPermissionsGrid\"\n                                                     class=\"inline-grid-row-5 search-grid top-margin-xs\"\n                                                     ui-grid=\"$ctrl.permissionGridContainers.aggregationSetup.gridOptions\"\n                                                     ui-grid-selection\n                                                     ui-grid-auto-resize>\n                                                </div>\n                                            </div>\n                                        </div>\n\n                                    </div>\n\n                                </div>\n\n                            </div>\n\n                        </div>\n\n                    </div>\n\n                    <hr ng-if=\"$ctrl.canWriteSystemOpsPermissions\"/>\n\n                    <div class=\"edit-view-container\" ng-if=\"$ctrl.canWriteSystemOpsPermissions\">\n\n                        <div class=\"row\">\n\n                            <div class=\"col-md-12\">\n\n                                <div class=\"row col-sm-5 prism-form-heading margin-right-xl\">\n                                    System Operations\n                                </div>\n\n                                <div class=\"row col-sm-5 prism-form-heading\">\n                                    System Operations - Implied\n                                </div>\n\n                                <div class=\"row clearfix\">\n\n                                    <div class=\"col-md-5 column permission-row\">\n\n                                        <! ----------------------------------------------- >\n                                        <! ----- // System-Operation Permissions // ------ >\n                                        <! ----------------------------------------------- >\n\n                                        <div class=\"row\">\n                                            <div class=\"col-sm-12 no-padding-right\">\n                                                <div id=\"debugGrid\"\n                                                     class=\"inline-grid-row-8 search-grid top-margin-xs\"\n                                                     ui-grid=\"$ctrl.permissionGridContainers.systemOps.gridOptions\"\n                                                     ui-grid-selection\n                                                     ui-grid-auto-resize>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div>\n\n                                        <div class=\"col-md-5 column permission-row\">\n\n                                            <! ------------------------------------------------------- >\n                                            <! ----- // System-Operation Implied Permissions // ------ >\n                                            <! ------------------------------------------------------- >\n\n                                            <fieldset disabled>\n                                                <div class=\"row\">\n                                                    <div class=\"col-sm-12 no-padding-right\">\n                                                        <div id=\"debugImpliedGrid\"\n                                                             class=\"inline-grid-row-8 search-grid top-margin-xs\"\n                                                             ui-grid=\"$ctrl.permissionGridContainers.impliedSystemOps.gridOptions\"\n                                                             ui-grid-selection\n                                                             ui-grid-auto-resize>\n                                                        </div>\n                                                    </div>\n                                                </div>\n                                            </fieldset>\n                                        </div>\n                                    </div>\n\n                                </div>\n\n                            </div>\n\n                        </div>\n\n                    </div>\n\n                    <hr/>\n\n                    <div class=\"edit-view-container\">\n\n                        <div class=\"row\">\n\n                            <div class=\"col-md-12\">\n\n                                <div class=\"row col-sm-12 prism-form-heading margin-right-xl\">\n                                    Exceptions\n                                </div>\n\n                                <div class=\"row clearfix\">\n\n                                    <div class=\"col-md-10 column permission-row\">\n\n                                        <! ---------------------------------------- >\n                                        <! ----- // Permission Exceptions // ------ >\n                                        <! ---------------------------------------- >\n\n                                        <div class=\"row\">\n                                            <div class=\"col-sm-12 no-padding-right\">\n                                                <div id=\"exceptionsGrid\"\n                                                     class=\"inline-grid-row-6 search-grid top-margin-xs\"\n                                                     ui-grid=\"$ctrl.permissionGridContainers.exceptions.gridOptions\"\n                                                     ui-grid-selection\n                                                     ui-grid-auto-resize>\n                                                </div>\n                                            </div>\n                                        </div>\n\n                                    </div>\n\n                                </div>\n\n                            </div>\n\n                        </div>\n\n                    </div>\n\n                </form>\n\n            </div>\n\n        </fieldset>\n\n</div>\n\n<toolbar button-defs=\"$ctrl.toolbarButtonDefs\"></toolbar>\n");
        $templateCache.put("system/livefeed/editor/components/livefeed-properties-template.html", "<fieldset>\n	<div class=\"row edit-full-height edit-view\">\n		<div class=\"edit-view-container\">\n			<div class=\"row clearfix\">\n				<div class=\"col-md-12 column\">\n					<div class=\"row\">\n						<div class=\"col-md-2\">\n							<div class=\"prism-form-heading\">General</div>\n						</div>\n					</div>\n				</div>\n				<div class=\"row clearfix spacer-top-lg\">\n					<div class=\"col-md-12 column\">\n						<form class=\"form-horizontal\" role=\"form\" name=\"liveFeedEditCtrl.editorForm\">\n							<div class=\"form-group\">\n								<label for=\"liveFeedName\" class=\"col-sm-2 control-label\">Name</label>\n								<div class=\"col-sm-4 pad-text-input-col\">\n									<input\n                                        type=\"text\"\n                                        id=\"liveFeedName\"\n                                        class=\"form-control prism-text-input\"\n                                        autocomplete=\"off\"\n                                        ng-model=\"liveFeedEditCtrl.editData.name\"\n                                        required/>\n								</div>\n                                <div class=\"required-text-input\"\n                                     required\n                                     x-required-indicator></div>\n							</div>\n							<div class=\"form-group\">\n								<label for=\"liveFeedElementalAddress\" class=\"col-sm-2 control-label\">Elemental Address</label>\n								<div class=\"col-sm-4 pad-text-input-col\">\n									<input\n                                        type=\"text\"\n                                        id=\"liveFeedElementalAddress\"\n                                        class=\"form-control prism-text-input\"\n                                        autocomplete=\"off\"\n                                        ng-model=\"liveFeedEditCtrl.editData.elementalAddress\"\n                                        required/>\n								</div>\n                                <div class=\"required-text-input\"\n                                     required\n                                     x-required-indicator></div>\n							</div>\n							<div class=\"form-group\">\n								<label for=\"liveFeedProfileName\" class=\"col-sm-2 control-label\">Profile Name</label>\n								<div class=\"col-sm-4 pad-text-input-col\">\n									<input\n                                        type=\"text\"\n                                        id=\"liveFeedProfileName\"\n                                        class=\"form-control prism-text-input\"\n                                        autocomplete=\"off\"\n                                        ng-model=\"liveFeedEditCtrl.editData.profileName\"\n                                        required/>\n								</div>\n                                <div class=\"required-text-input\"\n                                     required\n                                     x-required-indicator></div>\n							</div>\n							<div class=\"form-group\">\n								<label for=\"liveFeedProfilePermaLinkID\" class=\"col-sm-2 control-label\">Profile PermaLink ID</label>\n								<div class=\"col-sm-4 pad-text-input-col\">\n									<input\n                                        type=\"text\"\n                                        id=\"liveFeedProfilePermaLinkID\"\n                                        class=\"form-control prism-text-input\"\n                                        autocomplete=\"off\"\n                                        ng-model=\"liveFeedEditCtrl.editData.profilePermaLinkID\"\n                                        required/>\n								</div>\n                                <div class=\"required-text-input\"\n                                     required\n                                     x-required-indicator></div>\n							</div>\n						</form>\n					</div>\n				</div>\n			</div>\n		</div>\n	</div>\n</fieldset>\n");
        $templateCache.put("system/metadata/searchView/cellTemplates/header-check-mark-template.html", "<div class=\"ui-grid-cell-contents\"  col-index=\"renderIndex\" ng-click=\"grid.appScope.$ctrl.toggleRows($event)\">\n    <input type=\"checkbox\" ng-checked=\"grid.selection.selectAll\"/>\n	<label></label>\n</div>\n");
        $templateCache.put("system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html", "<div class=\"checkbox-grid-cell\" ng-click=\"grid.appScope.$ctrl.checkMarkCellClicked(row.entity)\">\n    <input type=\"checkbox\" id=\"{{row.entity.name + col.field + \'CB\'}}\"  ng-model=\"row.entity[col.field]\"/>\n    <label for=\"{{row.entity.name + col.field + \'CB\'}}\"></label>\n</div>\n\n");
        $templateCache.put("system/packageNotifications/editView/renderers/package-notifications-editor-general-section-template.html", "<div class=\"row clearfix\">\n\n    <div class=\"col-md-12 column\">\n        <div class=\"row\">\n            <div class=\"col-md-2\">\n                <div class=\"prism-form-heading\">\n                    General\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"row clearfix spacer-top-lg\">\n        <div class=\"col-md-12 column\">\n\n            <!-- Email Template -->\n            <div class=\"form-group\">\n                <label for=\"packageNotificationEmailTemplate\"\n                       class=\"col-sm-2 control-label\">\n                    Email Template\n                </label>\n                <div class=\"col-sm-4 pad-text-input-col\">\n                    <dropdown-select\n                        id=\"packageNotificationEmailTemplate\"\n                        collection=\"$ctrl.availableEmailTemplates\"\n                        ng-model=\"$ctrl.notification.emailTemplate\"\n                        prompt=\"Select email template\"\n                        clearable=\"false\"\n                        label-field=\"name\"\n                        btn-min-width=\"300\"\n                        class=\"hide-required-indicator\"\n                        required>\n                    </dropdown-select>\n                    <span class=\"required-text-input\"\n                         required\n                         x-required-indicator>\n                    </span>\n                </div>\n            </div>\n\n            <!-- Subject Expression -->\n            <div class=\"form-group\">\n                <label for=\"packageNotificationSubject\"\n                       class=\"col-sm-2 control-label\">\n                    Email Subject\n                </label>\n                <div class=\"col-sm-9 pad-text-input-col\">\n                    <textarea type=\"text\"\n                              rows=\"2\"\n                              id=\"packageNotificationSubject\"\n                              class=\"prism-text-input form-control\"\n                              ng-model=\"$ctrl.notification.emailSubjectExpression\">\n                    </textarea>\n                </div>\n            </div>\n\n            <!-- Package Status -->\n            <div class=\"form-group\">\n                <label for=\"packageNotificationEmailTemplate\"\n                       class=\"col-sm-2 control-label\">\n                    Package Status\n                </label>\n                <div class=\"col-sm-4 pad-text-input-col\">\n                    <dropdown-select\n                        id=\"packageNotificationPackageStatus\"\n                        collection=\"$ctrl.availablePackageStatuses\"\n                        ng-model=\"$ctrl.notification.status\"\n                        prompt=\"Select package status\"\n                        clearable=\"false\"\n                        label-field=\"label\"\n                        value-prop=\"label\"\n                        model-prop=\"status\"\n                        btn-min-width=\"300\"\n                        class=\"hide-required-indicator\"\n                        required>\n                    </dropdown-select>\n                    <span class=\"top-margin-md required-text-input\"\n                          required\n                          x-required-indicator>\n                    </span>\n                </div>\n            </div>\n\n            <!-- Waiting Time -->\n            <div class=\"form-group\">\n                <label for=\"packageNotificationWaitingTime\"\n                       class=\"col-sm-2 control-label\">\n                    Waiting Time\n                </label>\n                <div class=\"col-sm-4 pad-text-input-col\">\n                    <input type=\"text\"\n                           id=\"packageNotificationWaitingTime\"\n                           class=\"prism-text-input form-control\"\n                           ng-model=\"$ctrl.notification.delay\"/>\n                </div>\n                <div class=\"required-text-input\"\n                     required\n                     x-required-indicator>\n                </div>\n            </div>\n\n            <!-- Recipients -->\n            <div class=\"form-group\">\n                <label class=\"col-sm-2 control-label\">\n                    Recipients\n                </label>\n                <email-recipients-list class=\"col-sm-10\"\n                                       ng-model=\"$ctrl.notification\"\n                                       model-prop=\"\'recipients\'\">\n                </email-recipients-list>\n            </div>\n\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/packageNotifications/searchView/gridTemplates/package-status-cell-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\"\n     data-tooltip-append-to-body=\"true\"\n     uib-tooltip=\"{{grid.appScope.$ctrl.getStatusDescription(COL_FIELD CUSTOM_FILTERS)}}\"\n     ng-dblclick=\"grid.appScope.$ctrl.rowDoubleClick(row, column)\">\n    <span class=\"padding-left-sm\">{{grid.appScope.$ctrl.getStatusDescription(COL_FIELD CUSTOM_FILTERS)}}</span>\n</div>\n");
        $templateCache.put("system/properties/searchView/cellTemplates/dynamic-prop-value-template.html", "<div ng-if=\"!row.entity.hasConfidentialInfo\"\n     class=\"ui-grid-cell-contents ng-scope ng-binding\"\n     data-tooltip-append-to-body=\"true\" uib-tooltip=\"{{COL_FIELD CUSTOM_FILTERS}}\"\n>\n    <span>{{COL_FIELD CUSTOM_FILTERS}}</span>\n</div>\n<div ng-if=\"row.entity.hasConfidentialInfo\"\n     class=\"ui-grid-cell-contents ng-scope ng-binding\"\n     data-tooltip-append-to-body=\"true\" uib-tooltip=\"Property contains confidential information\"\n>\n    <span>* * * * *</span>\n</div>\n");
        $templateCache.put("system/templates/conditionalTemplate/editor/conditional-template-edit-template.html", "<div class=\"container-fluid no-padding\">\n	<div class=\"row-no-padding\">\n		<navbar></navbar>\n	</div>\n	<div class=\"row-no-padding\">\n		<sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n		<div class=\"col-md-10 col-lg-10 content-pane\">\n			<div class=\"loadingIndicator\">\n				<div data-lb-progress=\"$ctrl.loadingIndicator\" ng-show=\"$ctrl.loadingIndicator.show\"></div>\n			</div>\n			<div class=\"row-no-padding\">\n				<breadcrumb tab-name=\"$ctrl.editData.name\"></breadcrumb>\n				<uib-tabset horizontal=\"true\" type=\"pills\" class=\"edit-view-tabbar\">\n					<uib-tab heading=\"Properties\" active=\"true\">\n						<div class=\"col-md-12 col-lg-12 edit-full-height\"\n							 ng-include=\"\'system/templates/conditionalTemplate/editor/conditional-template-properties-template.html\'\">\n						</div>\n					</uib-tab>\n				</uib-tabset>\n			</div>\n\n			<div class=\"row-no-padding manager-toolbar\">\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"></toolbar>\n			</div>\n\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("system/templates/conditionalTemplate/editor/conditional-template-properties-template.html", "<fieldset>\n	<div class=\"row edit-full-height edit-view\">\n		<div class=\"edit-view-container\">\n			<div class=\"row clearfix\">\n				<div class=\"col-md-12 column\">\n					<div class=\"row\">\n						<div class=\"col-md-2\">\n							<div class=\"prism-form-heading\">General</div>\n						</div>\n					</div>\n				</div>\n				<div class=\"row clearfix spacer-top-lg\">\n					<div class=\"col-md-12 column\">\n						<form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n							<div class=\"form-group\">\n								<label for=\"conditionalTemplateName\" class=\"col-sm-2 control-label\">Name</label>\n								<div class=\"col-sm-3 pad-text-input-col\">\n									<input\n                                        type=\"text\"\n                                        id=\"conditionalTemplateName\"\n                                        class=\"form-control prism-text-input\"\n                                        autocomplete=\"off\"\n                                        ng-model=\"$ctrl.editData.name\"\n                                        required/>\n								</div>\n                                <div class=\"required-text-input\"\n                                     required\n                                     x-required-indicator></div>\n							</div>\n							<div class=\"form-group\">\n								<label for=\"conditionalTemplateExpression\" class=\"col-sm-2 control-label\">Expression</label>\n								<div class=\"col-sm-9 pad-text-input-col\">\n									<input\n                                        type=\"text\"\n                                        id=\"conditionalTemplateExpression\"\n                                        class=\"form-control prism-text-input\"\n                                        autocomplete=\"off\"\n                                        ng-model=\"$ctrl.editData.expression\"\n                                        required/>\n								</div>\n                                <div class=\"required-text-input\"\n                                     required\n                                     x-required-indicator></div>\n							</div>\n						</form>\n					</div>\n				</div>\n			</div>\n		</div>\n	</div>\n</fieldset>\n");
        $templateCache.put("system/templates/ffmpegTemplate/editor/ffmpeg-template-edit-template.html", "<div class=\"container-fluid no-padding\">\n	<div class=\"row-no-padding\">\n		<navbar></navbar>\n	</div>\n	<div class=\"row-no-padding\">\n		<sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n		<div class=\"col-md-10 col-lg-10 content-pane\">\n			<div class=\"loadingIndicator\">\n				<div data-lb-progress=\"$ctrl.loadingIndicator\" ng-show=\"$ctrl.loadingIndicator.show\"></div>\n			</div>\n			<div class=\"row-no-padding\">\n				<breadcrumb tab-name=\"$ctrl.editData.name\"></breadcrumb>\n				<uib-tabset horizontal=\"true\" type=\"pills\" class=\"edit-view-tabbar\">\n					<uib-tab heading=\"Properties\" active=\"true\">\n						<div class=\"col-md-12 col-lg-12 edit-full-height\"\n							 ng-include=\"\'system/templates/ffmpegTemplate/editor/ffmpeg-template-properties-template.html\'\">\n						</div>\n					</uib-tab>\n				</uib-tabset>\n			</div>\n\n			<div class=\"row-no-padding manager-toolbar\">\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"></toolbar>\n            </div>\n\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("system/templates/ffmpegTemplate/editor/ffmpeg-template-properties-template.html", "<fieldset>\n    <div class=\"row edit-full-height edit-view\">\n        <div class=\"edit-view-container\">\n            <div class=\"row clearfix\">\n                <div class=\"col-md-12 column\">\n                    <div class=\"row\">\n                        <div class=\"col-md-2\">\n                            <div class=\"prism-form-heading\">\n                                General\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row clearfix spacer-top-lg\">\n                    <div class=\"col-md-12 column\">\n                        <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n                            <div class=\"form-group\">\n                                <label for=\"ffmpegTemplateName\" class=\"col-sm-2 control-label\">\n                                    Name\n                                </label>\n                                <div class=\"col-sm-4 pad-text-input-col\">\n                                    <input type=\"text\"\n                                           id=\"ffmpegTemplateName\"\n                                           class=\"form-control prism-text-input\"\n                                           autocomplete=\"off\"\n                                           ng-model=\"$ctrl.editData.name\"\n                                           required/>\n                                </div>\n                                <div class=\"required-text-input\"\n                                     required\n                                     x-required-indicator></div>\n                            </div>\n                            <div class=\"form-group\">\n                                <label for=\"description\" class=\"col-sm-2 control-label\">\n                                    Description\n                                </label>\n                                <div class=\"col-sm-9 pad-text-input-col\">\n                                    <textarea id=\"description\"\n                                              class=\"form-control prism-text-input\"\n                                              ng-model=\"$ctrl.editData.description\"\n                                              rows=\"6\">\n                                    </textarea>\n                                </div>\n                            </div>\n                            <div class=\"form-group\">\n                                <label for=\"ffmepgInputArguments\" class=\"col-sm-2 control-label\">\n                                    Input Arguments\n                                </label>\n                                <div class=\"col-sm-4 pad-text-input-col\">\n                                    <input type=\"text\" id=\"ffmepgInputArguments\" class=\"form-control prism-text-input\"\n                                           autocomplete=\"off\"\n                                           ng-model=\"$ctrl.editData.inputArgsExpression\"/>\n                                </div>\n                            </div>\n                            <div class=\"form-group\">\n                                <label for=\"ffmpegOutputArguments\" class=\"col-sm-2 control-label\">\n                                    Output Arguments\n                                </label>\n                                <div class=\"col-sm-9 pad-text-input-col\">\n                                    <textarea id=\"ffmpegOutputArguments\"\n                                              class=\"form-control prism-text-input\"\n                                              ng-model=\"$ctrl.editData.outputArgsExpression\"\n                                              rows=\"6\">\n                                    </textarea>\n                                </div>\n                            </div>\n                            <div class=\"form-group\">\n                                <label for=\"ffmpegFileExtension\" class=\"col-sm-2 control-label\">\n                                    Output File Extension\n                                </label>\n                                <div class=\"col-sm-4 pad-text-input-col\">\n                                    <input type=\"text\" id=\"ffmpegFileExtension\" class=\"form-control prism-text-input\"\n                                           autocomplete=\"off\"\n                                           ng-model=\"$ctrl.editData.outputFileExtension\"/>\n                                </div>\n                            </div>\n                            <div class=\"form-group\">\n                                <label class=\"col-sm-2 prism-form-item-label text-align-right\">\n                                    Fast Seek\n                                </label>\n                                <div class=\"col-sm-1\">\n                                    <input type=\"checkbox\" id=\"fastSeekCB\" ng-model=\"$ctrl.editData.fastSeek\"/>\n                                    <label for=\"fastSeekCB\"></label>\n                                </div>\n                            </div>\n                        </form>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</fieldset>\n");
        $templateCache.put("system/templates/hybrikTemplate/editor/hybrik-template-edit-template.html", "<div class=\"container-fluid no-padding\">\n\n    <!-- Navigation/search toolbar -->\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <!-- Main -->\n    <div class=\"row-no-padding\">\n        <!-- Sidebar -->\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <!-- Content pane -->\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n            <!-- Pacifier -->\n            <div class=\"loadingIndicator\">\n                <div data-lb-progress=\"$ctrl.loadingIndicator\" ng-show=\"$ctrl.loadingIndicator.show\"></div>\n            </div>\n\n            <!-- Properties -->\n            <div class=\"row-no-padding\">\n                <breadcrumb tab-name=\"$ctrl.editData.name\"></breadcrumb>\n                <div class=\"col-md-12 col-lg-12 edit-full-height-no-tabs\"\n                     ng-include=\"\'system/templates/hybrikTemplate/editor/hybrik-template-properties-template.html\'\">\n                </div>\n            </div>\n\n            <div class=\"row-no-padding manager-toolbar\">\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"></toolbar>\n            </div>\n\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/templates/hybrikTemplate/editor/hybrik-template-properties-template.html", "<div class=\"edit-full-height-no-tabs edit-view\">\n    <form class=\"form-horizontal\"\n          role=\"form\"\n          name=\"$ctrl.editorForm\">\n        <div class=\"edit-view-container\">\n            <div class=\"prism-form-heading\">\n                General\n            </div>\n\n            <!-- Name -->\n            <div class=\"form-group\">\n                <label for=\"name\" class=\"col-sm-2 control-label\">\n                    Name\n                </label>\n                <div class=\"col-sm-4 pad-text-input-col\">\n                    <input id=\"name\"\n                           class=\"prism-text-input input-sm\"\n                           ng-model=\"$ctrl.editData.name\"\n                           required/>\n                </div>\n                <div class=\"required-text-input\"\n                     required\n                     x-required-indicator>\n                </div>\n            </div>\n\n            <!-- Description -->\n            <div class=\"form-group\">\n                <label for=\"description\" class=\"col-sm-2 control-label\">\n                    Description\n                </label>\n                <div class=\"col-sm-9 pad-text-input-col\">\n                    <textarea id=\"description\"\n                              class=\"form-control prism-text-input\"\n                              ng-model=\"$ctrl.editData.description\"\n                              rows=\"6\">\n                    </textarea>\n                </div>\n            </div>\n        </div>\n\n\n        <!-- Template JSON -->\n        <div class=\"edit-view-container top-margin-md\">\n            <div class=\"prism-form-heading\">\n                Template\n            </div>\n\n            <div class=\"form-group\">\n                <div class=\"col-sm-10 pad-text-input-col col-md-offset-1\">\n                    <enhanced-textarea ng-model=\"$ctrl.payloadString\"\n                                       input-rows=\"27\"\n                                       input-id=\"templateJsonField\"\n                                       monospace=\"true\"\n                                       error-index=\"$ctrl.errorIndex\">\n                    </enhanced-textarea>\n                </div>\n            </div>\n        </div>\n\n    </form>\n</div>\n");
        $templateCache.put("system/templates/imageTemplate/editView/image-template-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <!-- Main -->\n    <div class=\"row-no-padding\">\n        <!-- Sidebar -->\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <!-- Content pane -->\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n\n            <div class=\"loadingIndicator\">\n                <div data-lb-progress=\"$ctrl.loadingIndicator\" ng-show=\"$ctrl.loadingIndicator.show\"></div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-12\">\n                    <breadcrumb tab-name=\"$ctrl.editData.name\"></breadcrumb>\n                    <fieldset>\n                        <div class=\"edit-full-height-no-tabs edit-view\">\n                            <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n                                <div class=\"edit-view-container\">\n\n                                    <div class=\"row clearfix\">\n                                        <div class=\"col-md-12 column\">\n                                            <div class=\"row\">\n                                                <div class=\"col-md-2\">\n                                                    <div class=\"prism-form-heading\">General</div>\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div class=\"row clearfix spacer-top-lg\">\n                                            <div class=\"col-md-12 column\">\n\n                                                <div class=\"form-group\">\n                                                    <label for=\"imageTemplateName\" class=\"col-sm-2 control-label\">Name</label>\n                                                    <div class=\"col-sm-4 pad-text-input-col\">\n                                                        <input type=\"text\"\n                                                               id=\"imageTemplateName\"\n                                                               class=\"form-control prism-text-input\"\n                                                               autocomplete=\"off\"\n                                                               ng-model=\"$ctrl.editData.name\"\n                                                               required/>\n                                                    </div>\n                                                    <div class=\"required-text-input\" required x-required-indicator></div>\n                                                </div>\n\n                                                <div class=\"form-group\">\n                                                    <label for=\"imageTemplateTextArea\" class=\"col-sm-2 control-label\">Parameters</label>\n                                                    <div class=\"col-sm-8 pad-text-input-col\">\n                                                        <enhanced-textarea\n                                                            input-id=\"imageTemplateTextArea\"\n                                                            ng-model=\"$ctrl.editData.params\">\n                                                        </enhanced-textarea>\n                                                    </div>\n                                                    <div class=\"required-text-input\" required x-required-indicator></div>\n                                                </div>\n\n                                            </div>\n                                        </div>\n                                    </div>\n\n                                </div>\n\n                            </form>\n                        </div>\n                    </fieldset>\n\n                </div>\n            </div>\n\n            <div class=\"row-no-padding manager-toolbar\">\n\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"></toolbar>\n\n            </div>\n\n        </div>\n    </div>\n\n</div>\n");
        $templateCache.put("system/templates/intermediateTemplate/editor/intermediate-template-edit-template.html", "<div class=\"container-fluid no-padding\">\n	<div class=\"row-no-padding\">\n		<navbar></navbar>\n	</div>\n	<div class=\"row-no-padding\">\n		<sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n		<div class=\"col-md-10 col-lg-10 content-pane\">\n			<div class=\"loadingIndicator\">\n				<div data-lb-progress=\"$ctrl.loadingIndicator\" ng-show=\"$ctrl.loadingIndicator.show\"></div>\n			</div>\n			<div class=\"row-no-padding\">\n				<breadcrumb tab-name=\"$ctrl.editData.name\"></breadcrumb>\n				<uib-tabset horizontal=\"true\" type=\"pills\" class=\"edit-view-tabbar\">\n					<uib-tab heading=\"Properties\" active=\"true\">\n						<div class=\"col-md-12 col-lg-12 edit-full-height\"\n							 ng-include=\"\'system/templates/intermediateTemplate/editor/intermediate-template-properties-template.html\'\">\n						</div>\n					</uib-tab>\n				</uib-tabset>\n			</div>\n\n			<div class=\"row-no-padding manager-toolbar\">\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"></toolbar>\n            </div>\n\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("system/templates/intermediateTemplate/editor/intermediate-template-properties-template.html", "<fieldset>\n	<div class=\"row edit-full-height edit-view\">\n		<div class=\"edit-view-container\">\n			<div class=\"row clearfix\">\n				<div class=\"col-md-12 column\">\n					<div class=\"row\">\n						<div class=\"col-md-2\">\n							<div class=\"prism-form-heading\">General</div>\n						</div>\n					</div>\n				</div>\n				<div class=\"row clearfix spacer-top-lg\">\n					<div class=\"col-md-12 column\">\n						<form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n							<div class=\"form-group\">\n								<label for=\"intermediateTemplateName\" class=\"col-sm-3 control-label\">Name</label>\n								<div class=\"col-sm-4 pad-text-input-col\">\n									<input type=\"text\"\n                                           id=\"intermediateTemplateName\"\n                                           class=\"form-control prism-text-input\"\n                                           autocomplete=\"off\"\n										   ng-model=\"$ctrl.editData.name\"\n                                           required/>\n								</div>\n                                <div class=\"required-text-input\"\n                                     required\n                                     x-required-indicator></div>\n							</div>\n							<div class=\"form-group\">\n								<label for=\"intermediateProgramStartOffset\" class=\"col-sm-3 control-label\">Program Start Offset (Frames)</label>\n								<div class=\"col-sm-1 pad-text-input-col\">\n									<input type=\"text\" id=\"intermediateProgramStartOffset\" class=\"form-control prism-text-input\" autocomplete=\"off\"\n										   ng-model=\"$ctrl.editData.programStartOffset\"/>\n								</div>\n							</div>\n							<div class=\"form-group\">\n								<label for=\"intermediateProgramEndOffset\" class=\"col-sm-3 control-label\">Program End Offset (Frames)</label>\n								<div class=\"col-sm-1 pad-text-input-col\">\n									<input type=\"text\" id=\"intermediateProgramEndOffset\" class=\"form-control prism-text-input\" autocomplete=\"off\"\n										   ng-model=\"$ctrl.editData.programEndOffset\"/>\n								</div>\n							</div>\n						</form>\n					</div>\n				</div>\n			</div>\n		</div>\n	</div>\n</fieldset>\n");
        $templateCache.put("system/templates/maccaptionTemplate/editor/maccaption-template-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n\n	<div class=\"row-no-padding\">\n		<navbar></navbar>\n	</div>\n\n	<!-- Main -->\n	<div class=\"row-no-padding\">\n		<!-- Sidebar -->\n		<sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n		<!-- Content pane -->\n		<div class=\"col-md-10 col-lg-10 content-pane\">\n\n			<div class=\"loadingIndicator\">\n				<div data-lb-progress=\"$ctrl.loadingIndicator\" ng-show=\"$ctrl.loadingIndicator.show\"></div>\n			</div>\n			<div class=\"row\">\n				<div class=\"col-md-12\">\n					<breadcrumb tab-name=\"$ctrl.templateData.name\"></breadcrumb>\n					<fieldset>\n						<div class=\"edit-full-height-no-tabs edit-view\">\n							<form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n								<div class=\"edit-view-container\">\n\n									<div class=\"row clearfix\">\n										<div class=\"col-md-12 column\">\n											<div class=\"row\">\n												<div class=\"col-md-2\">\n													<div class=\"prism-form-heading\">General</div>\n												</div>\n											</div>\n										</div>\n										<div class=\"row clearfix spacer-top-lg\">\n											<div class=\"col-md-12 column\">\n\n												<div class=\"form-group\">\n													<label for=\"maccaptionTemplateName\" class=\"col-sm-2 control-label\">Name</label>\n													<div class=\"col-sm-4 pad-text-input-col\">\n														<input type=\"text\"\n                                                               id=\"maccaptionTemplateName\"\n                                                               class=\"form-control prism-text-input\"\n                                                               autocomplete=\"off\"\n															   ng-model=\"$ctrl.editData.name\"\n                                                               required/>\n													</div>\n													<div class=\"required-text-input\" required x-required-indicator></div>\n												</div>\n\n												<div class=\"form-group\">\n													<label for=\"maccaptionTemplateTextArea\" class=\"col-sm-2 control-label\">Template</label>\n													<div class=\"col-sm-8 pad-text-input-col  \">\n														<enhanced-textarea ng-model=\"$ctrl.editData.template\"\n																		   input-rows=\"24\"\n																		   input-id=\"maccaptionTemplateTextArea\">\n														</enhanced-textarea>\n													</div>\n													<div class=\"required-text-input\" required x-required-indicator></div>\n												</div>\n\n											</div>\n										</div>\n									</div>\n\n								</div>\n\n							</form>\n						</div>\n					</fieldset>\n\n				</div>\n			</div>\n\n			<div class=\"row-no-padding manager-toolbar\">\n\n				<toolbar button-defs=\"$ctrl.toolbarButtonDefs\"></toolbar>\n\n			</div>\n\n		</div>\n	</div>\n\n</div>\n");
        $templateCache.put("system/templates/mediaAcceptProfiles/editView/media-accept-profiles-editview-template.html", "<div class=\"container-fluid no-padding\">\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n    <div class=\"row-no-padding\">\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n            <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n                <div class=\"row-no-padding\">\n                    <breadcrumb tab-name=\"$ctrl.acceptProfileName\"></breadcrumb>\n                    <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n                        <div class=\"row-no-padding\">\n                            <uib-tabset horizontal=\"true\"\n                                        type=\"pills\"\n                                        class=\"edit-view-tabbar\"\n                                        active=\"$ctrl.currentTab\">\n\n                                <!-- Properties -->\n                                <uib-tab heading=\"Properties\" index=\"\'properties\'\"\n                                         deselect=\"$ctrl.onTabDeselect(\'properties\', $event)\"\n                                         select=\"$ctrl.onTabSelect(\'properties\')\"\n                                         ng-show=\"$ctrl.enabledTabs.properties\">\n                                    <div ng-include=\"\'system/templates/mediaAcceptProfiles/editView/renderers/media-accept-profiles-editview-properties-tab-template.html\'\"></div>\n                                </uib-tab>\n\n\n                                <!-- General Validator -->\n                                <uib-tab heading=\"General\" index=\"\'general\'\"\n                                         deselect=\"$ctrl.onTabDeselect(\'general\', $event)\"\n                                         select=\"$ctrl.onTabSelect(\'general\')\"\n                                         ng-if=\"$ctrl.enabledTabs.general && $ctrl.mapObject\">\n                                    <media-accept-profiles-general-validator-edit-view\n                                            ng-if=\"$ctrl.currentTab === \'general\'\"\n                                            media-accept-profile=\"$ctrl.mapObject\"\n                                            set-form-pristine=\"$ctrl.onChildComponentSetFormPristineHandler()\">\n                                    </media-accept-profiles-general-validator-edit-view>\n                                </uib-tab>\n\n                                <!-- Video Validators -->\n                                <uib-tab heading=\"Video\" index=\"\'video\'\"\n                                         deselect=\"$ctrl.onTabDeselect(\'video\', $event)\"\n                                         select=\"$ctrl.onTabSelect(\'video\')\"\n                                         ng-if=\"$ctrl.enabledTabs.video && $ctrl.mapObject\">\n                                    <media-accept-profiles-video-validators-search-view\n                                            ng-if=\"$ctrl.currentTab === \'video\'\"\n                                            media-accept-profile=\"$ctrl.mapObject\"\n                                            set-form-pristine=\"$ctrl.onChildComponentSetFormPristineHandler()\">\n                                    </media-accept-profiles-video-validators-search-view>\n                                </uib-tab>\n\n                                <!-- Audio Validators -->\n                                <uib-tab heading=\"Audio\" index=\"\'audio\'\"\n                                         deselect=\"$ctrl.onTabDeselect(\'audio\', $event)\"\n                                         select=\"$ctrl.onTabSelect(\'audio\')\"\n                                         ng-if=\"$ctrl.enabledTabs.audio && $ctrl.mapObject\">\n                                    <media-accept-profiles-audio-validators-search-view\n                                            ng-if=\"$ctrl.currentTab === \'audio\'\"\n                                            media-accept-profile=\"$ctrl.mapObject\"\n                                            set-form-pristine=\"$ctrl.onChildComponentSetFormPristineHandler()\">\n                                    </media-accept-profiles-audio-validators-search-view>\n                                </uib-tab>\n\n                                <!-- Audio Channel Validators -->\n                                <!--\n                                <uib-tab heading=\"Audio Channels\" index=\"\'audioChannels\'\"\n                                         deselect=\"$ctrl.onTabDeselect(\'audioChannels\', $event)\"\n                                         select=\"$ctrl.onTabSelect(\'audioChannels\')\"\n                                         ng-if=\"$ctrl.enabledTabs.audioChannels && $ctrl.mapObject\">\n                                    <media-accept-profiles-audio-channel-validators-search-view\n                                            ng-if=\"$ctrl.currentTab === \'audioChannels\'\"\n                                            media-accept-profile=\"$ctrl.mapObject\"\n                                            set-form-pristine=\"$ctrl.onChildComponentSetFormPristineHandler()\">\n                                    </media-accept-profiles-audio-channel-validators-search-view>\n                                </uib-tab>\n                                -->\n\n                                <!-- Text Validator -->\n                                <uib-tab heading=\"Text\" index=\"\'text\'\"\n                                         deselect=\"$ctrl.onTabDeselect(\'text\', $event)\"\n                                         select=\"$ctrl.onTabSelect(\'text\')\"\n                                         ng-if=\"$ctrl.enabledTabs.text && $ctrl.mapObject\">\n                                    <media-accept-profiles-text-validator-edit-view\n                                            ng-if=\"$ctrl.currentTab === \'text\'\"\n                                            set-form-pristine=\"$ctrl.onChildComponentSetFormPristineHandler()\">\n                                    </media-accept-profiles-text-validator-edit-view>\n                                </uib-tab>\n\n                                <!-- Artwork Validators -->\n                                <uib-tab heading=\"Artwork\" index=\"\'artwork\'\"\n                                         deselect=\"$ctrl.onTabDeselect(\'artwork\', $event)\"\n                                         select=\"$ctrl.onTabSelect(\'artwork\')\"\n                                         ng-if=\"$ctrl.enabledTabs.artwork && $ctrl.mapObject\">\n                                    <media-accept-profiles-artwork-validators-search-view\n                                            ng-if=\"$ctrl.currentTab === \'artwork\'\"\n                                            media-accept-profile=\"$ctrl.mapObject\"\n                                            set-form-pristine=\"$ctrl.onChildComponentSetFormPristineHandler()\">\n                                    </media-accept-profiles-artwork-validators-search-view>\n                                </uib-tab>\n\n                                <!-- Image Validators -->\n                                <uib-tab heading=\"Image\" index=\"\'image\'\"\n                                         deselect=\"$ctrl.onTabDeselect(\'image\', $event)\"\n                                         select=\"$ctrl.onTabSelect(\'image\')\"\n                                         ng-if=\"$ctrl.enabledTabs.image && $ctrl.mapObject\">\n                                    <media-accept-profiles-image-validators-search-view\n                                            ng-if=\"$ctrl.currentTab === \'image\'\"\n                                            media-accept-profile=\"$ctrl.mapObject\"\n                                            set-form-pristine=\"$ctrl.onChildComponentSetFormPristineHandler()\">\n                                    </media-accept-profiles-image-validators-search-view>\n                                </uib-tab>\n\n                                <!-- Intermediates -->\n                                <uib-tab heading=\"Intermediates\" index=\"\'intermediates\'\"\n                                         deselect=\"$ctrl.onTabDeselect(\'intermediates\', $event)\"\n                                         select=\"$ctrl.onTabSelect(\'intermediates\')\"\n                                         ng-show=\"$ctrl.enabledTabs.intermediates\">\n                                    <div ng-include=\"\'system/templates/mediaAcceptProfiles/editView/renderers/media-accept-profiles-editview-intermediates-tab-template.html\'\"></div>\n                                </uib-tab>\n\n                                <!-- Shared Video -->\n                                <uib-tab heading=\"Shared Video\" index=\"\'sharedVideo\'\"\n                                         deselect=\"$ctrl.onTabDeselect(\'sharedVideo\', $event)\"\n                                         select=\"$ctrl.onTabSelect(\'sharedVideo\')\"\n                                         ng-show=\"$ctrl.enabledTabs.sharedVideo\">\n                                    <div ng-include=\"\'system/templates/mediaAcceptProfiles/editView/renderers/media-accept-profiles-editview-sharedvideo-tab-template.html\'\"></div>\n                                </uib-tab>\n\n                                <!-- CC Extraction -->\n                                <uib-tab heading=\"CC Extraction\" index=\"\'ccExtraction\'\"\n                                         deselect=\"$ctrl.onTabDeselect(\'ccExtraction\', $event)\"\n                                         select=\"$ctrl.onTabSelect(\'ccExtraction\')\"\n                                         ng-show=\"$ctrl.enabledTabs.ccExtraction\">\n                                    <div ng-include=\"\'system/templates/mediaAcceptProfiles/editView/renderers/media-accept-profiles-editview-ccextraction-tab-template.html\'\"></div>\n                                </uib-tab>\n\n                                <!-- Clip Extraction -->\n                                <uib-tab heading=\"Clip Extraction\" index=\"\'clipExtraction\'\"\n                                         deselect=\"$ctrl.onTabDeselect(\'clipExtraction\', $event)\"\n                                         select=\"$ctrl.onTabSelect(\'clipExtraction\')\"\n                                         ng-show=\"$ctrl.enabledTabs.clipExtraction\">\n                                    <div ng-include=\"\'system/templates/mediaAcceptProfiles/editView/renderers/media-accept-profiles-editview-clipextraction-tab-template.html\'\"></div>\n                                </uib-tab>\n\n                                <!-- Proxy Player -->\n                                <uib-tab heading=\"Proxy Player\" index=\"\'proxyPlayer\'\"\n                                         deselect=\"$ctrl.onTabDeselect(\'proxyPlayer\', $event)\"\n                                         select=\"$ctrl.onTabSelect(\'proxyPlayer\')\"\n                                         ng-show=\"$ctrl.enabledTabs.proxyPlayer\">\n                                    <div ng-include=\"\'system/templates/mediaAcceptProfiles/editView/renderers/media-accept-profiles-editview-proxyplayer-tab-template.html\'\"></div>\n                                </uib-tab>\n                            </uib-tabset>\n                        </div>\n                    </form>\n                </div>\n        </div>\n    </div>\n</div>\n<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\" ng-show=\"$ctrl.loadingIndicator.show\"></div>\n</div>\n");
        $templateCache.put("system/templates/mediaAcceptProfiles/modals/new-media-profile-modal-template.html", "<div class=\"modal-header\">\n    <h5 class=\"modal-title\">New Media Profile Type</h5>\n</div>\n\n<div class=\"modal-body\">\n    <form class=\"form-horizontal\"\n          role=\"form\"\n          name=\"$ctrl.modalForm\">\n\n        <div class=\"row spacer-top-xsm padding-bottom-xsm\">\n            <div class=\"form-group no-margin-bottom\">\n                <label for=\"newMediaProfileTypeDropdown\"\n                       class=\"col-md-4 col-md-offset-1 control-label\">\n                    Type\n                </label>\n                <div class=\"col-md-4 metadata-control-col\">\n                    <dropdown-select id=\"newMediaProfileTypeDropdown\"\n                                     ng-model=\"$ctrl.selectedMediaProfileType\"\n                                     prompt=\"Select Type\"\n                                     btn-min-width=\"200\"\n                                     clearable=\"true\"\n                                     collection=\"$ctrl.availableProfileTypes\"\n                                     required>\n                    </dropdown-select>\n                </div>\n            </div>\n        </div>\n\n    </form>\n</div>\n\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default pull-left\"\n            ng-click=\"$ctrl.onCancel()\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.onCreate()\"\n            ng-disabled=\"!$ctrl.canCreate()\">\n        Create\n    </button>\n</div>\n");
        $templateCache.put("system/templates/packageAcceptTemplates/editView/package-accept-templates-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n    <div class=\"row-no-padding\">\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n            <div class=\"loadingIndicator\">\n                <div data-lb-progress=\"$ctrl.loadingIndicator\" ng-show=\"$ctrl.loadingIndicator.show\"></div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-12\">\n                    <breadcrumb tab-name=\"$ctrl.editData.name\"></breadcrumb>\n                    <fieldset>\n                        <div class=\"edit-full-height-no-tabs edit-view\">\n                            <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n                                <div class=\"edit-view-container\">\n                                    <div class=\"form-group\">\n                                        <label for=\"packageAcceptTemplateName\"\n                                               class=\"col-sm-3 control-label\">Name</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\"\n                                                   id=\"packageAcceptTemplateName\"\n                                                   class=\"form-control prism-text-input\"\n                                                   autocomplete=\"off\"\n                                                   ng-model=\"$ctrl.editData.name\"\n                                                   required/>\n                                        </div>\n                                        <div class=\"required-text-input\"\n                                             required\n                                             x-required-indicator></div>\n                                    </div>\n                                    <div ng-if=\"$ctrl.editData.mediaAcceptProfiles\"\n                                         ng-repeat=\"mediaAcceptProfileType in $ctrl.mediaAcceptProfileTypes\"\n                                         class=\"form-group\">\n                                        <media-accept-profile-member\n                                                media-accept-profile-type=\"mediaAcceptProfileType\"\n                                                ng-model=\"$ctrl.editData\"\n                                                model-prop=\"\'mediaAcceptProfiles\'\">\n                                        </media-accept-profile-member>\n                                    </div>\n\n                                </div>\n                            </form>\n\n\n                        </div>\n                    </fieldset>\n                </div>\n            </div>\n            <div class=\"row-no-padding manager-toolbar\">\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"></toolbar>\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/templates/packageCreationTemplates/editView/package-creation-templates-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n    <div class=\"row-no-padding\">\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n            <div class=\"loadingIndicator\">\n                <div data-lb-progress=\"$ctrl.loadingIndicator\" ng-show=\"$ctrl.loadingIndicator.show\"></div>\n            </div>\n\n            <div class=\"row\">\n                <div class=\"col-md-12\">\n                    <breadcrumb tab-name=\"$ctrl.editData.name\"></breadcrumb>\n                    <fieldset>\n                        <div class=\"edit-full-height-no-tabs edit-view\">\n                            <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n                                <div class=\"edit-view-container\">\n                                    <div class=\"row\">\n                                        <div class=\"col-md-2\">\n                                            <div class=\"prism-form-heading\">General</div>\n                                        </div>\n                                    </div>\n                                    <div class=\"form-group\">\n                                        <label for=\"packageCreationTemplateName\"\n                                               class=\"col-sm-2 control-label\">Name</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" id=\"packageCreationTemplateName\"\n                                                   class=\"form-control prism-text-input\" autocomplete=\"off\"\n                                                   ng-model=\"$ctrl.editData.name\"/>\n                                        </div>\n                                    </div>\n                                    <div class=\"form-group\">\n                                        <label for=\"packageCreationTemplate\"\n                                               class=\"col-sm-2 control-label\">Template</label>\n                                        <div class=\"col-sm-8  pad-text-input-col\">\n                                            <enhanced-textarea ng-model=\"$ctrl.templateJson\"\n                                                               input-rows=\"50\"\n                                                               input-id=\"packageCreationTemplate\"\n                                                               monospace=\"true\"\n                                                               error-index=\"$ctrl.errorIndex\">\n                                            </enhanced-textarea>\n                                        </div>\n                                    </div>\n\n                                </div>\n                            </form>\n                        </div>\n                    </fieldset>\n                </div>\n            </div>\n            <div class=\"row-no-padding manager-toolbar\">\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"></toolbar>\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/templates/transformTemplate/editor/transform-template-editor-template.html", "<div class=\"container-fluid no-padding\">\n	<div class=\"row-no-padding\">\n		<navbar></navbar>\n	</div>\n	<div class=\"row-no-padding\">\n		<sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n		<div class=\"col-md-10 col-lg-10 content-pane\">\n			<div class=\"loadingIndicator\">\n				<div data-lb-progress=\"$ctrl.loadingIndicator\" ng-show=\"$ctrl.loadingIndicator.show\"></div>\n			</div>\n			<div class=\"row\">\n				<div class=\"col-md-12\">\n					<breadcrumb tab-name=\"$ctrl.editData.name\"></breadcrumb>\n					<fieldset>\n						<div class=\"edit-full-height-no-tabs edit-view\">\n							<form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n                                <div ng-include=\"\'system/templates/transformTemplate/editor/renderers/transform-template-fields-template.html\'\"></div>\n							</form>\n						</div>\n					</fieldset>\n				</div>\n			</div>\n			<div class=\"row-no-padding manager-toolbar\">\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"></toolbar>\n			</div>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("system/users/editor/passwordValidation/password-validation-template.html", "<ng-form role=\"form\" name=\"$ctrl.editorForm\">\n    <field-validation ng-if=\"$ctrl.passwordRequirements\"\n                      header=\"Password Requirements:\"\n                      requirements=\"$ctrl.requirements\">\n    </field-validation>\n</ng-form>\n");
        $templateCache.put("components/branding/editView/components/properties/branding-container-properties-template.html", "<!-- Pacifier -->\n<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\"></div>\n</div>\n\n<div class=\"edit-view\">\n    <form class=\"form-horizontal\"\n          role=\"form\"\n          name=\"$ctrl.editorForm\"\n          ng-show=\"$ctrl.brandingAssetContainer\">\n\n        <fieldset ng-disabled=\"!$ctrl.canWriteContainer\">\n            <div class=\"edit-view-container\">\n                <div>\n                    <div class=\"prism-form-heading\">\n                        General\n                    </div>\n\n                    <!-- Name -->\n                    <div class=\"form-group\">\n                        <label for=\"brandingName\"\n                               class=\"col-md-2 control-label\">\n                            Name\n                        </label>\n                        <div class=\"col-md-3 pad-text-input-col\">\n                            <input id=\"brandingName\"\n                                   class=\"prism-text-input input-sm\"\n                                   type=\"text\"\n                                   ng-model=\"$ctrl.brandingAssetContainer.name\"\n                                   required/>\n                        </div>\n                        <div class=\"required-text-input\"\n                             required\n                             x-required-indicator></div>\n                    </div>\n\n                    <!-- Lead Black Duration (seconds) -->\n                    <div class=\"form-group\"\n                         ng-if=\"$ctrl.editingPreRolls()\">\n                        <label for=\"brandingName\"\n                               class=\"col-md-2 control-label\">\n                            Lead Black Duration (seconds)\n                        </label>\n                        <div class=\"col-md-3 pad-text-input-col\">\n                            <input id=\"prerollDuration\"\n                                   class=\"prism-text-input input-sm\"\n                                   type=\"number\"\n                                   ng-model=\"$ctrl.brandingAssetContainer.leadBlackDuration\"/>\n                        </div>\n                    </div>\n\n                </div>\n            </div>\n        </fieldset>\n\n        <hr/>\n\n        <div class=\"edit-view-container\"\n             ng-if=\"!$ctrl.editingNewBrandingAssetContainer()\">\n            <div>\n                <div class=\"prism-form-heading\">\n                    Media Accept Profiles\n                </div>\n\n                <div class=\"form-group\">\n\n                    <!-- Hide Empty -->\n                    <div class=\"col-md-12\">\n                        <div class=\"prism-checkbox-inline\">\n                            <input type=\"checkbox\"\n                                   id=\"hideEmptyCheckbox\"\n                                   ng-click=\"$ctrl.toggleHidden()\"\n                                   ng-checked=\"$ctrl.hideEmpty\"/>\n                            <label class=\"prism-form-item-label\"\n                                   for=\"hideEmptyCheckbox\">\n                                Hide Empty\n                            </label>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <div class=\"col-md-12\">\n                        <branding-media-search-grid\n                            branding-config=\"$ctrl.brandingConfig\"\n                            hide-empty=\"$ctrl.hideEmpty\"\n                            container=\"$ctrl.brandingAssetContainer\"\n                            media-accept-profiles=\"$ctrl.mediaAcceptProfiles\"\n                            ng-disabled=\"!$ctrl.editorForm.$pristine\"\n                            on-row-clicked=\"$ctrl.onAcceptProfileClicked()\"\n                        ></branding-media-search-grid>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n    </form>\n\n    <div class=\"row-no-padding\">\n        <div>\n            <toolbar button-defs=\"$ctrl.toolbarButtonDefs\">\n            </toolbar>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("components/branding/editView/components/searchGrid/branding-media-search-grid-template.html", "<div class=\"grid-with-one-row-of-tabs-and-breadcrumbs search-grid\"\n     ui-grid=\"$ctrl.gridOptions\"\n     ui-grid-selection\n     ui-grid-resize-columns>\n</div>\n");
        $templateCache.put("components/form/customMetadata/customMetadataField/renderers/metadata-field-checkbox-input-template.html", "<div ng-class=\"$ctrl.formData.columnClass\">\n    <input\n        ng-class=\"$ctrl.formData.componentClass\"\n        id=\"{{$ctrl.inputId}}\"\n        ng-disabled=\"$ctrl.disabled\"\n        ng-model=\"$ctrl.componentDef.instanceData.value\"\n        type=\"checkbox\"\n    />\n    <label for=\"{{$ctrl.inputId}}\"></label>\n</div>\n");
        $templateCache.put("components/form/customMetadata/customMetadataField/renderers/metadata-field-checkbox-list-template.html", "<div ng-class=\"$ctrl.formData.columnClass\">\n    <checkbox-list\n        id=\"{{$ctrl.inputId}}\"\n        items=\"$ctrl.componentDef.picklistItems\"\n        ng-disabled=\"$ctrl.disabled\"\n        ng-model=\"$ctrl.componentDef.instanceData.value\"\n    ></checkbox-list>\n</div>\n");
        $templateCache.put("components/form/customMetadata/customMetadataField/renderers/metadata-field-date-enhanced-template.html", "<date-time-enhanced\n    component-name=\"$ctrl.componentDef.name\"\n    id=\"{{$ctrl.inputId}}\"\n    ng-disabled=\"$ctrl.disabled\"\n    ng-model=\"$ctrl.componentDef.instanceData.value\"\n    show-time=\"false\"\n></date-time-enhanced>\n");
        $templateCache.put("components/form/customMetadata/customMetadataField/renderers/metadata-field-date-picker-template.html", "<div ng-class=\"$ctrl.formData.columnClass\">\n    <date-picker\n        id=\"{{$ctrl.inputId}}\"\n        ng-model=\"$ctrl.componentDef.instanceData.value\"\n        timezone-offset-millis=\"\'SERVER\'\"\n        ng-disabled=\"$ctrl.disabled\"\n    ></date-picker>\n</div>\n");
        $templateCache.put("components/form/customMetadata/customMetadataField/renderers/metadata-field-date-time-enhanced-template.html", "<date-time-enhanced\n    component-name=\"$ctrl.componentDef.name\"\n    id=\"{{$ctrl.inputId}}\"\n    ng-disabled=\"$ctrl.disabled\"\n    ng-model=\"$ctrl.componentDef.instanceData.value\"\n    show-time=\"true\"\n></date-time-enhanced>\n");
        $templateCache.put("components/form/customMetadata/customMetadataField/renderers/metadata-field-date-time-picker-template.html", "<div ng-class=\"$ctrl.formData.columnClass\">\n    <date-time-picker\n        id=\"{{$ctrl.inputId}}\"\n        ng-model=\"$ctrl.componentDef.instanceData.value\"\n        ng-disabled=\"$ctrl.disabled\"\n    ></date-time-picker>\n</div>\n");
        $templateCache.put("components/form/customMetadata/customMetadataField/renderers/metadata-field-dropdown-list-template.html", "<div ng-class=\"$ctrl.formData.columnClass\">\n    <dropdown-select\n        btn-min-width=\"150\"\n        clearable=\"true\"\n        collection=\"$ctrl.componentDef.picklistItems\"\n        id=\"{{$ctrl.inputId}}\"\n        label-field=\"displayName\"\n        model-prop=\"id\"\n        ng-class=\"($ctrl.componentDef.instanceData.required ? \'force-invalid-outline-computation \' : \'\') + $ctrl.formData.componentClass\"\n        ng-disabled=\"$ctrl.disableComponents || $ctrl.disabled\"\n        ng-model=\"$ctrl.componentDef.instanceData.value\"\n        value-prop=\"displayName\"\n    ></dropdown-select>\n</div>\n");
        $templateCache.put("components/form/customMetadata/customMetadataField/renderers/metadata-field-list-template.html", "<div ng-class=\"$ctrl.formData.columnClass\">\n    <prism-list\n        id=\"{{$ctrl.inputId}}\"\n        items=\"$ctrl.componentDef.picklistItems\"\n        label-field=\"displayName\"\n        model-prop=\"id\"\n        multi-select=\"$ctrl.componentDef.multiple\"\n        ng-disabled=\"$ctrl.disabled\"\n        ng-model=\"$ctrl.componentDef.instanceData.value\"\n    ></prism-list>\n</div>\n");
        $templateCache.put("components/form/customMetadata/customMetadataField/renderers/metadata-field-text-area-template.html", "<div ng-class=\"$ctrl.formData.columnClass + $ctrl.getColumnClassSize()\">\n    <textarea\n        ng-class=\"$ctrl.formData.componentClass\"\n        id=\"{{$ctrl.inputId}}\"\n        ng-disabled=\"$ctrl.disabled\"\n        ng-if=\"!$ctrl.componentDef.maxCharacterCount\"\n        ng-model=\"$ctrl.componentDef.instanceData.value\"\n        rows=\"{{$ctrl.componentDef.preferredHeight || \'3\'}}\"\n    ></textarea>\n\n    <enhanced-textarea\n        ng-disabled=\"$ctrl.disabled\"\n        ng-input-id=\"$ctrl.inputId\"\n        input-rows=\"{{$ctrl.componentDef.preferredHeight || \'3\'}}\"\n        ng-model=\"$ctrl.componentDef.instanceData.value\"\n        max-chars=\"{{$ctrl.componentDef.maxCharacterCount}}\"\n        ng-if=\"$ctrl.componentDef.maxCharacterCount\"\n    ></enhanced-textarea>\n</div>\n");
        $templateCache.put("components/form/customMetadata/customMetadataField/renderers/metadata-field-text-input-template.html", "<div ng-class=\"$ctrl.formData.columnClass + $ctrl.getColumnClassSize()\">\n    <input\n        autocomplete=\"off\"\n        ng-class=\"$ctrl.formData.componentClass\"\n        id=\"{{$ctrl.inputId}}\"\n        ng-disabled=\"$ctrl.disabled\"\n        ng-if=\"!$ctrl.componentDef.maxCharacterCount\"\n        ng-model=\"$ctrl.componentDef.instanceData.value\"\n        type=\"text\"\n    />\n\n    <enhanced-textinput\n        disable-prop=\"$ctrl.disabled\"\n        ng-input-id=\"$ctrl.inputId\"\n        max-chars=\"{{$ctrl.componentDef.maxCharacterCount}}\"\n        model-prop=\"$ctrl.componentDef.instanceData.value\"\n        ng-if=\"$ctrl.componentDef.maxCharacterCount\"\n    ></enhanced-textinput>\n</div>\n");
        $templateCache.put("components/form/customMetadata/customMetadataField/renderers/metadata-field-text-list-template.html", "<div ng-class=\"$ctrl.formData.columnClass\">\n    <text-list-input\n        id=\"{{$ctrl.inputId}}\"\n        ng-name=\"$ctrl.componentDef.name\"\n        items=\"$ctrl.componentDef.instanceData.value\"\n        ng-disabled=\"$ctrl.disabled\"\n        on-update=\"$ctrl.onUpdate({event})\"\n    ></text-list-input>\n</div>\n");
        $templateCache.put("components/form/customMetadata/customMetadataField/renderers/metadata-field-time-picker-template.html", "<div class=\"top-margin {{$ctrl.formData.columnClass}}\">\n    <prism-time-picker\n        id=\"{{$ctrl.inputId}}\"\n        ng-model=\"$ctrl.componentDef.instanceData.value\"\n        hour-step=\"1\"\n        minute-step=\"15\"\n        show-meridian=\"true\"\n        ng-disabled=\"$ctrl.disabled\"\n    ></prism-time-picker>\n</div>\n");
        $templateCache.put("components/form/customMetadata/customMetadataField/renderers/metadata-field-timecode-input-template.html", "<timecode-input\n    id=\"{{$ctrl.inputId}}\"\n    ng-model=\"$ctrl.componentDef.instanceData.value\"\n    root-class=\"{{$ctrl.formData.attributes[\'root-class\']}}\"\n    ng-disabled=\"$ctrl.disabled\"\n></timecode-input>\n");
        $templateCache.put("dashboard/packageCheckin/components/modals/checkinResultModal/checkin-result-modal-template.html", "<div class=\"modal-header\">\n    <div class=\"pull-right\">\n    </div>\n    <h4 class=\"modal-title\">Package Check-in Result</h4>\n</div>\n\n<div class=\"modal-body\">\n    <div id=\"checkinResultGrid\"\n         ui-grid=\"$ctrl.gridOptions\"\n         ui-grid-tree-view\n         ui-grid-auto-resize\n         ui-grid-resize-columns\n         class=\"checkin-result-grid\"></div>\n</div>\n\n<div class=\"modal-footer\">\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.close()\">OK\n    </button>\n</div>\n");
        $templateCache.put("dashboard/packageCheckin/components/views/batchCheckIn/batch-checkin-template.html", "<!-- Content Area -->\n<div class=\"edit-full-height-no-tabs flex-centered-col-container\">\n\n    <file-upload\n        file-extensions=\"[\'xls\', \'xlsx\']\"\n        type-name=\"\'Excel Spreadsheet (.xlsx)\'\"\n        on-uploader-initialized=\"$ctrl.onUploaderInitialized()\"\n        on-upload-progress=\"$ctrl.onUploadProgress(progress)\"\n        on-files-uploaded=\"$ctrl.onFilesUploaded(uploadedFiles)\">\n    </file-upload>\n\n    <!-- Progress Indicator -->\n    <div class=\"progress-container center-block image-upload-progress padding-top-md\"\n         ng-if=\"$ctrl.progress > 0\">\n        <label class=\"control-label\">Upload progress:&nbsp;</label>\n        <uib-progress class=\"prism-progress top-margin-xs\">\n            <uib-bar\n                class=\"prism-progressbar\"\n                value=\"$ctrl.progress\">\n            </uib-bar>\n        </uib-progress>\n    </div>\n    <div>\n        <p\n            class=\"grey-label text-center padding-top-lg\"\n            ng-if=\"$ctrl.progress > 0 && $ctrl.progress < 100\">\n            Checking in packages...\n        </p>\n    </div>\n\n</div>\n\n<!-- Toolbar -->\n<div class=\"row-no-padding manager-toolbar\">\n    <div>\n        <toolbar button-defs=\"$ctrl.toolbarButtonDefs\">\n        </toolbar>\n    </div>\n</div>\n");
        $templateCache.put("dashboard/packageCheckin/components/views/checkedOutPackageList/checked-out-package-list-template.html", "<!-- Pacifier -->\n<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\">\n    </div>\n</div>\n\n<!-- Grid -->\n<div id=\"packageCheckinCheckedOutListGrid\"\n     class=\"grid search-grid\"\n     ui-grid=\"$ctrl.gridOptions\"\n     ui-grid-selection\n     ui-grid-pagination\n     ui-grid-resize-columns>\n</div>\n\n<!-- Toolbar -->\n<toolbar\n    button-defs=\"$ctrl.toolbarButtonDefs\"\n    right-hand-checkbox-defs=\"$ctrl.toolbarCheckboxDefs\">\n</toolbar>\n");
        $templateCache.put("dashboard/queues/queueDetail/components/cellTemplates/queue-bandwidth-cell-template.html", "<div ng-if=\"row.entity.bandwidthWarning\" class=\"padding-left-sm yellow-label\">\n    {{ (row.entity.bandwidth) ? (row.entity.bandwidth / 1000000).toFixed(3) : 0 }} Mbps\n</div>\n<div ng-if=\"!row.entity.bandwidthWarning\" class=\"padding-left-sm\">\n    {{ (row.entity.bandwidth) ? (row.entity.bandwidth / 1000000).toFixed(3) : 0 }} Mbps\n</div>\n");
        $templateCache.put("dashboard/queues/queueDetail/components/cellTemplates/queue-priority-cell-template.html", "<div ng-if=\"row.entity.priorityOverride\"\n     class=\"padding-left-sm\"\n     style=\"padding-top: 3px;\"\n     ng-class=\"{\'yellow-label\': !row.isSelected, \'blue-label\': row.isSelected}\"\n     ng-dblclick=\"grid.appScope.onRowDoubleClicked(row)\">\n    {{ row.entity.priorityOverride }}\n</div>\n<div ng-if=\"!row.entity.priorityOverride\"\n     class=\"padding-left-sm ui-grid-cell-contents\"\n     ng-dblclick=\"grid.appScope.onRowDoubleClicked(row)\">\n    {{ row.entity.priority }}\n</div>\n");
        $templateCache.put("dashboard/queues/queueDetail/components/cellTemplates/queue-step-row-template.html", "<div ng-if=\"row.entity.header\"\n     class=\"{{row.entity.style}}\">\n    <p>{{row.entity.title}}</p>\n</div>\n<div ng-if=\"!row.entity.header\"\n     ng-repeat=\"col in colContainer.renderedColumns track by col.colDef.name\"\n     class=\"ui-grid-cell\"\n     ui-grid-cell>\n</div>\n");
        $templateCache.put("dashboard/workflows/searchView/modals/filter/workflow-filter-modal-template.html", "<div class=\"modal-header\">\n    <a id=\"workflowFilterXBtn\"\n       href=\"\"\n       ng-click=\"workflowFilterModal.xClicked()\"><i class=\"fa fa-times pull-right\"></i></a>\n    <h5 align=\"center\"\n        class=\"modal-title\">Search Filters</h5>\n</div>\n<div class=\"modal-body\">\n    <form class=\"form horizontal\"\n          role=\"form\">\n        <div class=\"edit-view-container\">\n            <div ng-include=\"\'dashboard/workflows/searchView/modals/filter/datePropertiesSection/date-properties-section-template.html\'\"></div>\n        </div>\n\n        <hr/>\n\n        <div class=\"edit-view-container\">\n            <div ng-include=\"\'dashboard/workflows/searchView/modals/filter/workflowsPropertiesSection/workflow-properties-section-template.html\'\"></div>\n        </div>\n\n        <hr/>\n\n        <div class=\"edit-view-container\">\n            <div ng-include=\"\'dashboard/workflows/searchView/modals/filter/packagePropertiesSection/package-properties-section-template.html\'\"></div>\n        </div>\n    </form>\n</div>\n\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"workflowFilterModal.cancel()\">\n        Reset Defaults\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"workflowFilterModal.onOk()\">\n        Apply\n    </button>\n</div>\n");
        $templateCache.put("meta/network/editor/components/properties/network-properties-edit-view-template.html", "<div class=\"loadingIndicator\">\n	<div data-lb-progress=\"$ctrl.loadingIndicator\" ng-show=\"$ctrl.loadingIndicator.show\"></div>\n</div>\n<div class=\"row-no-padding\">\n	<div class=\"col-md-12\">\n\n		<fieldset ng-disabled=\"!$ctrl.canWrite\" ng-if=\"$ctrl.permissions.read || $ctrl.isAdmin\">\n			<div class=\"edit-full-height edit-view\">\n				<form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n					<div class=\"edit-view-container\">\n\n						<div class=\"row clearfix\">\n							<div class=\"col-md-12 column\">\n								<div class=\"row\">\n									<div class=\"col-md-2\">\n										<div class=\"prism-form-heading\">General</div>\n									</div>\n								</div>\n							</div>\n							<div class=\"row clearfix spacer-top-lg\">\n								<div class=\"col-md-12 column\">\n\n									<div class=\"form-group\">\n										<label for=\"networkName\" class=\"col-sm-2 control-label\">Name</label>\n										<div class=\"col-sm-3 pad-text-input-col\">\n											<input type=\"text\" id=\"networkName\" class=\"form-control prism-text-input\" autocomplete=\"off\"\n												   ng-model=\"$ctrl.network.name\"/>\n										</div>\n                                        <div class=\"required-text-input\" required x-required-indicator></div>\n									</div>\n\n									<div class=\"form-group\">\n										<label for=\"networkValue\" class=\"col-sm-2 control-label\">Value</label>\n										<div class=\"col-sm-3 pad-text-input-col\">\n											<input type=\"text\" id=\"networkValue\" class=\"form-control prism-text-input\" autocomplete=\"off\"\n												   ng-model=\"$ctrl.network.value\"/>\n										</div>\n                                        <div class=\"required-text-input\" required x-required-indicator></div>\n									</div>\n\n									<div class=\"form-group\">\n										<label for=\"networkPerfix\" class=\"col-sm-2 control-label\">Prefix</label>\n										<div class=\"col-sm-3 pad-text-input-col\">\n											<input type=\"text\" id=\"networkPerfix\" class=\"form-control prism-text-input\" autocomplete=\"off\"\n												   ng-model=\"$ctrl.network.prefix\"/>\n										</div>\n									</div>\n\n									<div class=\"form-group\">\n										<label for=\"shortDescriptionTextArea\" class=\"col-sm-2 control-label\">Short Description</label>\n										<div class=\"col-sm-4\">\n											<enhanced-textarea ng-model=\"$ctrl.network.shortDescription\" input-rows=\"3\"\n															   input-id=\"shortDescriptionTextArea\">\n											</enhanced-textarea>\n										</div>\n									</div>\n\n									<div class=\"form-group\">\n										<label for=\"longDescriptionTextArea\" class=\"col-sm-2 control-label\">Long Description</label>\n										<div class=\"col-sm-4\">\n											<enhanced-textarea ng-model=\"$ctrl.network.longDescription\" input-rows=\"3\"\n															   input-id=\"longDescriptionTextArea\">\n											</enhanced-textarea>\n										</div>\n									</div>\n\n									<div class=\"form-group\">\n										<label for=\"networkCopyright\" class=\"col-sm-2 control-label\">Copyright</label>\n										<div class=\"col-sm-3 pad-text-input-col\">\n											<input type=\"text\" id=\"networkCopyright\" class=\"form-control prism-text-input\" autocomplete=\"off\"\n												   ng-model=\"$ctrl.network.copyright\"/>\n										</div>\n									</div>\n\n									<div class=\"form-group\">\n										<label for=\"networkBreakPattern\" class=\"col-sm-2 control-label\">Break Pre/Postroll Pattern</label>\n										<div class=\"col-sm-4 pad-text-input-col\">\n                                            <dropdown id=\"networkBreakPattern\"\n                                                      ng-model=\"$ctrl.network.breakPrePostRollPattern\"\n                                                      label-path=\"displayName\"\n                                                      collection=\"$ctrl.availableBreakPatterns\"\n                                                      btn-min-width=\"150\">\n                                            </dropdown>\n										</div>\n									</div>\n\n								</div>\n							</div>\n						</div>\n\n					</div>\n\n                    <div class=\"edit-view-container top-margin-md\">\n\n                        <div class=\"row clearfix\">\n                            <div class=\"col-md-12 column\">\n                                <div class=\"row\">\n                                    <div class=\"col-md-2\">\n                                        <div class=\"prism-form-heading\">Rating Overlays</div>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class=\"row clearfix spacer-top-lg\">\n                                <div class=\"col-md-12 column\">\n                                    <div class=\"form-group\">\n                                        <label for=\"ratingOverlayEnabledCheckbox\" class=\"col-sm-2 control-label\">Enabled</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"checkbox\"\n                                                   id=\"ratingOverlayEnabledCheckbox\"\n                                                   ng-model=\"$ctrl.network.ratingOverlayEnabled\"/>\n                                            <label for=\"ratingOverlayEnabledCheckbox\">&nbsp;</label>\n                                        </div>\n                                    </div>\n                                    <fieldset ng-disabled=\"!$ctrl.network.ratingOverlayEnabled\">\n                                        <div class=\"form-group\">\n                                            <label for=\"ratingOverlayPattern\" class=\"col-sm-2 control-label\">Acts</label>\n                                            <div class=\"col-sm-4 pad-text-input-col\">\n                                                <dropdown id=\"ratingOverlayPattern\"\n                                                          ng-model=\"$ctrl.network.ratingOverlayPattern\"\n                                                          label-path=\"displayName\"\n                                                          collection=\"$ctrl.availableRatingOverlayPatterns\"\n                                                          btn-min-width=\"150\">\n                                                </dropdown>\n                                            </div>\n                                        </div>\n                                        <div class=\"form-group\">\n                                            <label for=\"ratingOverlayCategories\" class=\"col-sm-2 control-label\">Rating Systems</label>\n                                            <div class=\"col-sm-4 pad-text-input-col\">\n                                                <multiselect-dropdown id=\"ratingOverlayRatingSystems\"\n                                                                      ng-model=\"$ctrl.network.ratingOverlaySystems\"\n                                                                      label-field=\"systemCode\"\n                                                                      collection=\"$ctrl.availableRatingSystems\"\n                                                                      btn-min-width=\"150\">\n                                                </multiselect-dropdown>\n                                            </div>\n                                        </div>\n                                        <div class=\"form-group\">\n                                            <label for=\"ratingOverlayCategories\" class=\"col-sm-2 control-label\">Categories</label>\n                                            <div class=\"col-sm-4 pad-text-input-col\">\n                                                <multiselect-dropdown id=\"ratingOverlayCategories\"\n                                                                      ng-model=\"$ctrl.network.ratingOverlayCategories\"\n                                                                      label-field=\"name\"\n                                                                      collection=\"$ctrl.availablePackageCategories\"\n                                                                      btn-min-width=\"150\">\n                                                </multiselect-dropdown>\n                                            </div>\n                                        </div>\n                                        <div class=\"form-group form-group-custom padding-bottom-sm\">\n                                            <label for=\"ratingOverlayFadeIn\" class=\"col-sm-2 control-label\">Timings</label>\n                                            <div class=\"col-sm-9\">\n                                                Fade In: <input id=\"ratingOverlayFadeIn\"\n                                                                class=\"prism-text-input input-sm\"\n                                                                ng-model=\"$ctrl.network.ratingOverlayFadeIn\"/>\n                                                Fade Out: <input id=\"ratingOverlayFadeOut\"\n                                                                 class=\"prism-text-input input-sm\"\n                                                                 ng-model=\"$ctrl.network.ratingOverlayFadeOut\"/>\n                                                Fade Offset: <input id=\"ratingOverlayOffset\"\n                                                                    class=\"prism-text-input input-sm\"\n                                                                    ng-model=\"$ctrl.network.ratingOverlayOffset\"/>\n                                                Duration: <input id=\"ratingOverlayDuration\"\n                                                                    class=\"prism-text-input input-sm\"\n                                                                    ng-model=\"$ctrl.network.ratingOverlayDuration\"/>\n                                            </div>\n                                        </div>\n                                    </fieldset>\n                                </div>\n                            </div>\n                        </div>\n\n                    </div>\n\n					<div class=\"edit-view-container top-margin-md\">\n\n						<div class=\"row clearfix\">\n							<div class=\"col-md-12 column\">\n								<div class=\"row\">\n									<div class=\"col-md-2\">\n										<div class=\"prism-form-heading\">Metadata</div>\n									</div>\n								</div>\n\n								<div class=\"row clearfix spacer-top-lg\">\n									<div class=\"col-md-12 column\">\n\n										<custom-metadata components-map=\"$ctrl.getNetworkComponentsMap()\"\n														 id-prefix=\"{{$ctrl.network.name}}\">\n										</custom-metadata>\n\n									</div>\n								</div>\n							</div>\n						</div>\n\n					</div>\n				</form>\n			</div>\n		</fieldset>\n\n	</div>\n</div>\n\n<div class=\"row-no-padding manager-toolbar\">\n\n	<toolbar button-defs=\"$ctrl.toolbarButtonDefs\"></toolbar>\n\n</div>\n");
        $templateCache.put("package/editor/components/modals/adHocSelectPartners/adhoc-subscription-modal-template.html", "<!-- Modal Header -->\n<div class=\"modal-header\">\n	<h5 class=\"modal-title\">Ad-Hoc Delivery to Selected Partners</h5>\n</div>\n\n<!-- Modal Body -->\n<div class=\"modal-body\">\n	<div class=\"form-horizontal\">\n		<form name=\"editorForm\">\n\n			<!-- Partner Selector -->\n			<div class=\"form-group\">\n				<div class=\"col-md-6 col-md-offset-3\">\n					<label for=\"partnerMultiSelect\">\n						Select Partners:\n					</label>\n				</div>\n			</div>\n			<div class=\"form-group\">\n				<div class=\"col-sm-9 col-md-offset-3\">\n					<multiselect-dropdown id=\"partnerMultiSelect\"\n										  ng-model=\"adHocPartnersCntrlr.selectedPartners\"\n										  collection=\"adHocPartnersCntrlr.availablePartners\"\n										  label-field=\"name\"\n										  prompt=\"Select Partners\"\n										  btn-min-width=\"350\">\n					</multiselect-dropdown>\n				</div>\n			</div>\n\n			<!-- Season -->\n			<div class=\"form-group no-margin-bottom\"\n				 ng-show=\"adHocPartnersCntrlr.isSeries && adHocPartnersCntrlr.isSeason\">\n				<div class=\"col-md-5 col-md-offset-5\">\n					<div class=\"radio\">\n						<input type=\"radio\"\n							   id=\"adHocSeriesRadio\"\n							   name=\"seriesSubGroup\"\n							   ng-model=\"adHocPartnersCntrlr.subType\"\n							   value=\"season\"/>\n						<label class=\"control-label right-side-label\"\n							   for=\"adHocSeriesRadio\">\n							Season\n						</label>\n					</div>\n				</div>\n			</div>\n\n			<!-- Volume -->\n			<div class=\"form-group no-margin-bottom\"\n				 ng-show=\"adHocPartnersCntrlr.isSeries && adHocPartnersCntrlr.isVolume\">\n				<div class=\"col-md-5 col-md-offset-5\">\n					<div class=\"radio\">\n						<input type=\"radio\"\n							   id=\"adHocVolumeRadio\"\n							   name=\"seriesSubGroup\"\n							   ng-model=\"adHocPartnersCntrlr.subType\"\n							   value=\"volume\"/>\n						<label class=\"control-label right-side-label\"\n							   for=\"adHocVolumeRadio\">\n							Volume\n						</label>\n					</div>\n				</div>\n			</div>\n\n		</form>\n	</div>\n</div>\n\n<!-- Modal Footer -->\n<div class=\"modal-footer flex-row-container\">\n    <!-- [ Cancel ] -->\n	<button class=\"btn btn-sm btn-default\"\n			ng-click=\"adHocPartnersCntrlr.cancel()\">\n        Cancel\n	</button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n	<!-- [ OK ] -->\n	<button class=\"btn btn-sm btn-default\"\n			ng-click=\"adHocPartnersCntrlr.onOk()\"\n			ng-disabled=\"adHocPartnersCntrlr.disableOKButton()\">\n        OK\n	</button>\n</div>\n");
        $templateCache.put("package/editor/components/modals/aliases/aliases-modal-template.html", "<item-select-modal\n    modal-title=\"\'Select Partner(s)\'\"\n    select-button-text=\"\'Select\'\"\n    loading-indicator=\"$ctrl.loadingIndicator\"\n    execute-search=\"$ctrl.executeSearch(searchText)\"\n    on-search-refresh=\"$ctrl.onSearchRefresh(searchText)\"\n\n    grid-is-empty=\"$ctrl.gridOptions.data.length < 1\"\n    on-cancel-clicked=\"$ctrl.cancel()\"\n    on-select-clicked=\"$ctrl.onOK()\"\n    select-button-enabled=\"!$ctrl.disableOKButton()\">\n\n    <div id=\"addAliasModalGrid\"\n         ui-grid=\"$ctrl.gridOptions\"\n         ui-grid-selection\n         ui-grid-auto-resize></div>\n\n</item-select-modal>\n");
        $templateCache.put("package/editor/components/modals/assetValidationResults/asset-validation-results-modal-template.html", "<div class=\"modal-header\">\n    <div class=\"pull-right\">\n    </div>\n    <h4 class=\"modal-title\">Asset Validation Results</h4>\n</div>\n<div class=\"modal-body\">\n    <div id=\"errorsWarningGrid\"\n         ui-grid=\"$ctrl.combinedOptions\"\n         ui-grid-tree-view\n         class=\"errors-warnings-grid\"\n         ng-if=\"$ctrl.currentTab === \'all\'\"></div>\n</div>\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.onCancel()\"\n            ng-show=\"$ctrl.showCancel\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.onOk()\">\n        {{$ctrl.showCancel? \'Accept\' : \'Cancel\'}}\n    </button>\n</div>\n");
        $templateCache.put("package/editor/components/modals/brandingDistributionOverrides/branding-distribution-overrides-modal-template.html", "<!-- Modal Header -->\n<div class=\"modal-header\">\n    <h5 class=\"modal-title\">\n		Override Partner Branding Assets\n	</h5>\n</div>\n\n<!-- Modal Body -->\n<div class=\"modal-body\">\n    <fieldset>\n        <form role=\"form\"\n              name=\"$ctrl.overrideForm\">\n\n			<div ng-repeat=\"(name, assetInfo) in $ctrl.overrideAssetDescriptors\">\n				<branding-distribution-overrides-selector\n					override-context=\"$ctrl.overrideContext\"\n					override-asset-type=\"name\"\n					override-asset-descriptor=\"assetInfo\"\n					partner-package=\"$ctrl.resolve.partnerPackage\">\n				</branding-distribution-overrides-selector>\n\n				<!-- SPACER -->\n				<div class=\"v-space-50px\"></div>\n			</div>\n\n        </form>\n    </fieldset>\n</div>\n\n<!-- Modal Footer -->\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.close({$value: \'cancel\'})\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.close({$value: $ctrl.resolve.partnerPackage})\"\n            ng-disabled=\"$ctrl.overrideForm.$pristine\">\n        OK\n    </button>\n</div>\n");
        $templateCache.put("package/editor/components/modals/brandingDistributionOverrides/branding-distribution-overrides-selector-template.html", "<div class=\"row\">\n	<label for=\"{{$ctrl.partnerPackage.partner.name + \'_\' + $ctrl.overrideAssetType}}\"\n		   class=\"col-md-3 padding-top-sm control-label text-align-right\">\n		{{$ctrl.overrideAssetDescriptor.displayName}}\n	</label>\n\n	<div class=\"col-md-9 flex-row-container\">\n		<div class=\"flex-align-start flex-col-container\">\n			<div class=\"edit-view-container flex-col-container\">\n\n				<!-- Container Selector -->\n				<div>\n					<dropdown-select\n						btn-min-width=\"230\"\n						clearable=\"false\"\n						collection=\"$ctrl.availableContainers\"\n						id=\"{{$ctrl.partnerPackage.partner.name + \'_\' + $ctrl.overrideAssetType}}\"\n						label-field=\"name\"\n						ng-disabled=\"!$ctrl.dropDownEnabled()\"\n						ng-model-options=\"{ getterSetter: true }\"\n						ng-model=\"$ctrl._viewProperty\"\n						prompt=\"(None)\"\n						sort-collection=\"false\">\n					</dropdown-select>\n				</div>\n\n				<!-- Use Season/Volume CB -->\n				<div ng-show=\"$ctrl.overrideAssetDescriptor.seasonVolumeFlagPropertyName !== undefined\">\n					<label class=\"prism-checkbox-inline\">\n						<input id=\"{{$ctrl.partnerPackage.partner.name + \'_\' + $ctrl.overrideAssetType + \'_SV_CB\'}}\"\n							   ng-disabled=\"!$ctrl.seasonVolumeCBEnabled()\"\n							   ng-model=\"$ctrl._viewAssetSeasonVolumeFlag\"\n							   ng-model-options=\"{ getterSetter: true }\"\n							   type=\"checkbox\"/>\n						<label class=\"control-label\"\n							   for=\"{{$ctrl.partnerPackage.partner.name + \'_\' + $ctrl.overrideAssetType + \'_SV_CB\'}}\">\n							Use Season/Volume\n						</label>\n					</label>\n				</div>\n\n				<!-- Spacer (if there\'s no season/volume property) -->\n				<div class=\"v-space-10px\"\n					 ng-show=\"$ctrl.overrideAssetDescriptor.seasonVolumeFlagPropertyName === undefined\">\n				</div>\n			</div>\n\n			<hr/>\n\n			<!-- Preview Play Button(s) -->\n			<div class=\"flex-align-start flex-row-container\">\n				<span class=\"control-label padding-left-md padding-bottom-xsm\">\n					Preview:&nbsp;\n				</span>\n				<div ng-if=\"$ctrl.previewEnabled()\"\n					 ng-repeat=\"previewInfo in $ctrl.overrideAssetDescriptor.previewPropertyDescriptors\">\n					<button class=\"btn btn-default play-button flex-align-start\"\n							ng-disabled=\"$ctrl._viewProperty().id === null\"\n							ng-click=\"$ctrl.openMediaModal($event, $ctrl.getPreviewInfo(previewInfo))\">\n						<span class=\"fa-stack\">\n							<i class=\"fa fa-circle-thin fa-stack-1x\"></i>\n							<i class=\"fa fa-play fa-stack-1x\"></i>\n						</span>\n						<span>\n							{{previewInfo.label}}\n						</span>\n					</button>\n				</div>\n			</div>\n\n		</div>\n\n		<!-- Override CB -->\n		<div class=\"flex-align-start flex-stretcher flex-col-container\">\n			<div class=\"flex-align-start padding-left-md\"\n				 ng-disabled=\"!$ctrl.canWriteOverrides\">\n				<input id=\"{{$ctrl.partnerPackage.partner.name + \'_\' + $ctrl.overrideAssetType + \'_overrideCB\'}}\"\n					   type=\"checkbox\"\n					   ng-model=\"$ctrl.partnerPackage[$ctrl.overrideAssetDescriptor.overrideFlagPropertyName]\"/>\n				<label class=\"control-label\"\n					   for=\"{{$ctrl.partnerPackage.partner.name + \'_\' + $ctrl.overrideAssetType + \'_overrideCB\'}}\">\n					Override\n				</label>\n			</div>\n\n			<hr />\n\n			<div class=\"flex-align-start\">\n				<label class=\"padding-left-md default-value-label control-label\">\n					<b>Default:</b> <em>{{$ctrl.getDefaultLabel().name}}</em> {{$ctrl.getDefaultLabel().svLabel}}\n				</label>\n			</div>\n		</div>\n\n	</div>\n</div>\n");
        $templateCache.put("package/editor/components/modals/collaborators/collaborator-add-modal-template.html", "<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\">\n    </div>\n</div>\n<div class=\"modal-header\">\n    <div class=\"pull-right\">\n    </div>\n    <h6 class=\"modal-title\">Add Collaborator</h6>\n</div>\n<div class=\"modal-body\">\n    <div class=\"row\">\n        <div class=\"col-sm-5\"></div>\n        <div class=\"col-sm-7\">\n            <label for=\"collaboratorSearch\"\n                   class=\"col-sm-3\">Search</label>\n            <div id=\"collaboratorSearch\"\n                 class=\"input-group input-group-sm col-sm-9\">\n                <input type=\"text\"\n                       ng-keyup=\"$ctrl.executeSearch($event)\"\n                       class=\"prism-text-input form-control\"\n                       ng-model=\"$ctrl.searchText\">\n                <a id=\"searchButton\"\n                   class=\"input-group-addon btn  btn-xs\"\n                   ng-click=\"$ctrl.executeSearch()\">\n                    <i class=\"fa fa-refresh\"></i>\n                </a>\n            </div>\n        </div>\n    </div>\n    <div id=\"addCollaboratorModalGrid\"\n         ui-grid=\"$ctrl.gridOptions\"\n         class=\"select-collaborator-grid\"\n         ui-grid-selection\n         ui-grid-auto-resize>\n    </div>\n</div>\n<div class=\"modal-footer\">\n    <div class=\"row\">\n        <div class=\"col-sm-12\">\n        </div>\n    </div>\n\n    <hr/>\n    <hr/>\n\n    <div class=\"flex-row-container\">\n        <button class=\"btn btn-sm btn-default\"\n                id=\"cancelButton\"\n                ng-click=\"$ctrl.dismiss({$value: \'cancel\'})\">\n            Cancel\n        </button>\n\n        <div class=\"flex-stretcher\">\n        </div>\n\n        <div class=\"form-inline\"\n             ng-show=\"$ctrl.showPaginationControls()\">\n            <pagination-controls\n                prev-page-handler=\"$ctrl.paginationPrevPageHandler()\"\n                next-page-handler=\"$ctrl.paginationNextPageHandler()\"\n                jump-to-page-handler=\"$ctrl.paginationJumpToPageHandler()\"\n                page-size-change-handler=\"$ctrl.pageSizeChangeHandler()\"\n                paging-options=\"$ctrl.pagingOptions\"\n                class=\"form-group\">\n            </pagination-controls>\n        </div>\n\n        <div class=\"flex-stretcher\">\n        </div>\n\n        <button id=\"newButton\"\n                class=\"btn btn-sm btn-default\"\n                ng-click=\"$ctrl.newCollaborator()\"\n                ng-if=\"$ctrl.resolve.showNewButton && $ctrl.showPaginationControls()\">\n            New\n        </button>\n\n        <button class=\"btn btn-sm btn-default\"\n                id=\"selectButton\"\n                ng-click=\"$ctrl.close({$value: $ctrl.gridApi.selection.getSelectedRows()})\"\n                ng-disabled=\"$ctrl.disableOKButton()\">\n            Select\n        </button>\n    </div>\n</div>\n");
        $templateCache.put("package/editor/components/modals/collaborators/grid-checkbox-header-template.html", "<div class=\"ui-grid-cell-contents\"  col-index=\"renderIndex\" ng-click=\"grid.appScope.$ctrl.toggleRows($event)\">\n	<input type=\"checkbox\" ng-checked=\"grid.selection.selectAll\"/>\n	<label></label>\n</div>\n");
        $templateCache.put("package/editor/components/modals/collaborators/role-grid-cell-template.html", "<!--\n	NOTE: model-prop not yet working for multiselect-dropdown.\n		  Would be set to \"name\".\n	(2016-Jul-6 RDS)\n-->\n<div class=\"ui-grid-cell-contents ng-scope ng-binding\" data-tooltip-append-to-body=\"true\">\n	<multiselect-dropdown\n		id=\"{{row.entity.displayName + \'_msd\' | removeStringSpaces}}\"\n		ng-model=\"row.entity.collaboratorRoleSelection\"\n		enable-select-all=\"true\"\n		prompt=\"Select Role\"\n		btn-min-width=\"180\"\n		attach-to-body=\"true\"\n		label-field=\"name\"\n		ng-disabled=\"!row.isSelected\"\n		collection=\"COL_FIELD\">\n	</multiselect-dropdown>\n</div>\n");
        $templateCache.put("package/editor/components/modals/completedDeliveries/completed-deliveries-modal-template.html", "<div class=\"modal-header\">\n    <div class=\"pull-right\">\n    </div>\n    <h4 class=\"modal-title\">Completed Deliveries</h4>\n</div>\n<div class=\"modal-body\">\n    <div class=\"preloader-backdrop\"\n         ng-show=\"$ctrl.loadingIndicator.show\">\n        <div data-lb-progress=\"$ctrl.loadingIndicator\">\n        </div>\n    </div>\n    <completed-deliveries\n        package-object=\"$ctrl.resolve.packageObject\"\n        loading-indicator=\"$ctrl.loadingIndicator\">\n    </completed-deliveries>\n</div>\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.onCancel()\"\n            ng-show=\"$ctrl.showCancel\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.onOk()\">\n        OK\n    </button>\n</div>\n");
        $templateCache.put("package/editor/components/modals/errorsWarnings/errors-warnings-modal-template.html", "<div class=\"modal-header\">\n    <div class=\"pull-right\">\n    </div>\n    <h4 class=\"modal-title\">Errors and Warnings</h4>\n</div>\n<div class=\"modal-body\">\n    <uib-tabset horizontal=\"true\"\n                type=\"pills\"\n                class=\"edit-view-tabbar\">\n        <uib-tab heading=\"All\"\n                 active=\"true\"\n                 ng-click=\"$ctrl.activateTab(\'all\')\">\n            <div id=\"errorsWarningGrid\"\n                 ui-grid=\"$ctrl.combinedOptions\"\n                 ui-grid-tree-view\n                 class=\"errors-warnings-grid\"\n                 ng-if=\"$ctrl.currentTab === \'all\'\"></div>\n        </uib-tab>\n        <uib-tab heading=\"Warnings\"\n                 ng-click=\"$ctrl.activateTab(\'warnings\')\">\n            <div id=\"warningsGrid\"\n                 ui-grid=\"$ctrl.warningsOptions\"\n                 ui-grid-tree-view\n                 class=\"errors-warnings-grid\"\n                 ng-if=\"$ctrl.currentTab === \'warnings\'\"></div>\n        </uib-tab>\n        <uib-tab heading=\"Errors\"\n                 ng-click=\"$ctrl.activateTab(\'errors\')\">\n            <div id=\"errorsGrid\"\n                 ui-grid=\"$ctrl.errorsOptions\"\n                 ui-grid-tree-view\n                 class=\"errors-warnings-grid\"\n                 ng-if=\"$ctrl.currentTab === \'errors\'\"></div>\n        </uib-tab>\n    </uib-tabset>\n</div>\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.onCancel()\"\n            ng-show=\"$ctrl.resolve.showCancel\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.onOk()\">\n        OK\n    </button>\n</div>\n");
        $templateCache.put("package/editor/components/modals/errorsWarnings/errors-warnings-tree-cell-template.html", "<div class=\"ui-grid-cell-contents\" title=\"TOOLTIP\">\n    <span ng-if=\"row.entity.$$treeLevel === 0\">\n		<span class=\"fa-stack fa error-warning-triangle\"\n			  ng-class=\"row.entity.type === \'error\'?  \'tree-top-level-error\' : \'tree-top-level-warning\'\">\n			<i class=\"fa fa-square fa-stack-1x\"></i>\n			<i class=\"fa fa-exclamation-triangle fa-stack-2x\"></i>\n		</span><span class=\"tree-top-level-text\">{{COL_FIELD}}</span></span>\n    <span ng-if=\"row.entity.$$treeLevel === 1\">\n        <i ng-class=\"row.entity.type === \'error\' ?  \'tree-child-level-error\' : \'tree-child-level-warning\'\"></i>\n        {{COL_FIELD}}\n    </span>\n    <span ng-if=\"row.entity.$$treeLevel === 2\">\n        <i ng-class=\"row.entity.type === \'error\' ?  \'tree-child-level-two-error\' : \'\'\"></i>\n        {{COL_FIELD}}\n    </span>\n</div>\n");
        $templateCache.put("package/editor/components/modals/groups/groups-modal-template.html", "<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\">\n    </div>\n</div>\n<div class=\"modal-header\">\n    <div class=\"pull-right\">\n    </div>\n    <h6 class=\"modal-title\">Add To Group</h6>\n</div>\n<div class=\"modal-body\">\n    <div class=\"row\">\n        <div class=\"col-sm-5\"></div>\n        <div class=\"col-sm-7\">\n            <label for=\"groupSearch\"\n                   class=\"col-sm-3\">Search</label>\n            <div id=\"groupSearch\"\n                 class=\"input-group input-group-sm col-sm-9\">\n                <input type=\"text\"\n                       class=\"prism-text-input form-control\"\n                       ng-model=\"$ctrl.searchText\"\n                       ng-keyup=\"$ctrl.executeSearch()\">\n                <a class=\"input-group-addon btn  btn-xs\"\n                   ng-click=\"$ctrl.getData()\">\n                    <i class=\"fa fa-refresh\"></i>\n                </a>\n            </div>\n        </div>\n    </div>\n    <div id=\"addGroupModalGrid\"\n         ui-grid=\"$ctrl.gridOptions\"\n         ui-grid-selection\n         ui-grid-auto-resize></div>\n</div>\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default\"\n            id=\"cancelButton\"\n            ng-click=\"$ctrl.dismiss({$value: \'cancel\'})\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            id=\"selectButton\"\n            ng-click=\"$ctrl.close({$value: $ctrl.gridApi.selection.getSelectedRows()})\"\n            ng-disabled=\"$ctrl.disableOKButton()\">\n        Select\n    </button>\n</div>\n");
        $templateCache.put("package/editor/components/modals/hierarchicalMetadata/hierarchical-metadata-modal-template.html", "<div>\n\n    <!--\n        Header\n    -->\n    <div class=\"modal-header\">\n        <a id=\"pkgHierarchicalMetadataXBtn\"\n           href=\"\"\n           ng-click=\"$ctrl.dismiss({$value: \'cancel\'})\">\n            <i class=\"fa fa-times pull-right\"></i>\n        </a>\n        <span class=\"modal-title\">Hierarchical Metadata: {{$ctrl.resolve.packageObject.title}}</span>\n    </div>\n\n    <!--\n        Body\n    -->\n    <div class=\"modal-body\">\n        <div class=\"loadingIndicator\">\n            <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                 ng-show=\"$ctrl.loadingIndicator.show\">\n            </div>\n        </div>\n\n        <form class=\"form-horizontal\"\n              role=\"form\"\n              name=\"$ctrl.editorForm\">\n\n\n            <!-- Navbar -->\n            <div class=\"hierarchical-metadata-modal-navbar\">\n                <div class=\"form-group no-margin-bottom flex-row-container\">\n                    <!-- Partner Selector -->\n                    <div class=\"flex-row-container\"\n                         ng-if=\"$ctrl.partnerList.length > 0\">\n                        <label class=\"control-label\"\n                               for=\"partnerSelector\">\n                            MVPD Partner:\n                        </label>\n                        &nbsp;\n                        <div class=\"pad-text-input-col\">\n                            <dropdown-select\n                                    attach-to-body=\"true\"\n                                    clearable=\"false\"\n                                    collection=\"$ctrl.partnerList\"\n                                    component-disabled=\"!$ctrl.partnerList\"\n                                    id=\"partnerSelector\"\n                                    label-field=\"name\"\n                                    model-prop=\"name\"\n                                    ng-model=\"$ctrl.selectedPartner\"\n                                    sort-collection=\"true\"\n                                    track-by=\"name\">\n                            </dropdown-select>\n                        </div>\n                    </div>\n\n                    <div class=\"flex-stretcher\">\n                    </div>\n\n                    <!-- Section Nav Buttons -->\n                    <div class=\"flex-row-container\">\n                        <!-- Network -->\n                        <button class=\"btn btn-sm btn-default margin-right-md\"\n                                ng-if=\"$ctrl.viewData.network.show\"\n                                ng-click=\"$ctrl.onNavigate($event, \'networkSection\')\">\n                            <i class=\"fa fa-sitemap fa-lg fa-fw\"></i>\n                            Network\n                        </button>\n\n                        <!-- Content -->\n                        <button class=\"btn btn-sm btn-default margin-right-md\"\n                                ng-if=\"$ctrl.viewData.content.show\"\n                                ng-click=\"$ctrl.onNavigate($event, \'contentSection\')\">\n                            <i class=\"fa fa-television fa-lg fa-fw\"\n                               ng-if=\"$ctrl.resolve.packageObject.content.type === \'Series\'\"></i>\n                            <i class=\"fa fa-film fa-lg fa-fw\"\n                               ng-if=\"$ctrl.resolve.packageObject.content.type === \'Movies/Special\'\"></i>\n                            {{$ctrl.resolve.packageObject.content.type}}\n                        </button>\n\n                        <!-- Season -->\n                        <button class=\"btn btn-sm btn-default margin-right-md\"\n                                ng-if=\"$ctrl.viewData.season.show\"\n                                ng-click=\"$ctrl.onNavigate($event, \'seasonSection\')\">\n                            Season\n                        </button>\n\n                        <!-- Volume -->\n                        <button class=\"btn btn-sm btn-default\"\n                                ng-if=\"$ctrl.viewData.volume.show\"\n                                ng-click=\"$ctrl.onNavigate($event, \'volumeSection\')\">\n                            Volume\n                        </button>\n                    </div>\n                </div>\n            </div>\n\n            <hr/>\n\n\n            <!-- Metadata Sections -->\n            <div class=\"hierarchical-metadata-modal-body\">\n                <!-- Network Section -->\n                <a name=\"networkSection\"></a>\n                <ng-include ng-if=\"$ctrl.viewData.network.show\"\n                            src=\"\'package/editor/components/modals/hierarchicalMetadata/renderers/network-meta-renderer-template.html\'\">\n                </ng-include>\n                <hr/>\n\n                <!-- Content Section -->\n                <a name=\"contentSection\"></a>\n                <ng-include ng-if=\"$ctrl.viewData.content.show\"\n                            src=\"\'package/editor/components/modals/hierarchicalMetadata/renderers/content-meta-renderer-template.html\'\">\n                </ng-include>\n                <hr/>\n\n                <!-- Season Section -->\n                <a name=\"seasonSection\"></a>\n                <ng-include ng-if=\"$ctrl.viewData.season.show\"\n                            src=\"\'package/editor/components/modals/hierarchicalMetadata/renderers/season-meta-renderer-template.html\'\">\n                </ng-include>\n                <hr/>\n\n                <!-- Volume Section -->\n                <a name=\"volumeSection\"></a>\n                <ng-include ng-if=\"$ctrl.viewData.volume.show\"\n                            src=\"\'package/editor/components/modals/hierarchicalMetadata/renderers/volume-meta-renderer-template.html\'\">\n                </ng-include>\n            </div>\n        </form>\n    </div>\n\n    <!--\n        Footer\n    -->\n    <div class=\"modal-footer\">\n        <div class=\"row\">\n            <div class=\"col-sm-12\">\n                <div class=\"form-inline\">\n                    <div class=\"form-group padding-left-md\">\n                        <button class=\"btn btn-sm btn-default\"\n                                ng-click=\"$ctrl.dismiss({$value: \'cancel\'})\">\n                            Close\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("package/editor/components/modals/qualitycontrol/quality-control-modal-template.html", "<div class=\"modal-header\">\n    <div class=\"pull-right\">\n    </div>\n    <h6 class=\"modal-title\">{{qualCntrlMdlCntrlr.qcNoteData.type}} Quality Control Notes</h6>\n</div>\n<div class=\"modal-body\">\n    <textarea type=\"text\"\n              ng-disabled=\"qualCntrlMdlCntrlr.isDisabled\"\n              id=\"qualityControlInput\"\n              class=\"prism-text-input\"\n              rows=\"6\"\n              cols=\"50\"\n              autofocus\n              ng-model=\"qualCntrlMdlCntrlr.qcNoteData\"></textarea>\n</div>\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"qualCntrlMdlCntrlr.cancel()\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"qualCntrlMdlCntrlr.onOk()\"\n            ng-disabled=\"qualCntrlMdlCntrlr.disableOKButton()\">\n        OK\n    </button>\n</div>\n");
        $templateCache.put("package/editor/components/modals/rejectPackage/reject-package-modal-template.html", "<div class=\"modal-header\">\n    <div class=\"pull-right\">\n    </div>\n    <h4 class=\"modal-title\">Reject Package</h4>\n</div>\n<div class=\"modal-body\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <label class=\"col-md-12\"\n                   ng-show=\"rejectPkgCntrlr.showRejectClipWarning\">Reject this Package will also reject all Clips\n                                                                   associated with it.</label>\n            <label class=\"col-md-12\">Rejection Comment</label>\n            <textarea class=\"form-control col-md-12\"\n                      ng-disabled=\"!rejectPkgCntrlr.editable\"\n                      ng-model=\"rejectPkgCntrlr.rejectReason\"></textarea>\n        </div>\n    </div>\n</div>\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"rejectPkgCntrlr.onCancel()\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"rejectPkgCntrlr.onOk()\"\n            ng-disabled=\"!rejectPkgCntrlr.rejectReason || !rejectPkgCntrlr.editable\">\n        OK\n    </button>\n</div>\n");
        $templateCache.put("package/editor/components/modals/selectAsset/folder-cell-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\" data-tooltip-append-to-body=\"true\" uib-tooltip=\"{{row.entity.directory ? \'\' : COL_FIELD}}\">\n	<div ng-switch=\"row.entity.directory\">\n		<div ng-switch-when=\"true\" >\n			<i class=\"fa fa-folder\"></i>\n		</div>\n		<div ng-switch-when=\"false\">\n			<span>{{COL_FIELD}}</span>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("package/editor/components/modals/selectAsset/select-asset-modal-template.html", "<div class=\"modal-header\">\n    <div class=\"pull-right\">\n        <button class=\"btn btn-link modal-header-buttons\"\n				ng-click=\"$ctrl.refreshCurrentDirectory()\">\n			<i class=\"fa fa-refresh\"></i>\n		</button>\n        <button class=\"btn btn-link modal-header-buttons\"\n				ng-click=\"$ctrl.loadParentDirectory()\"\n				ng-disabled=\"$ctrl.currentDirectory.path === \'/\'\">\n            <i class=\"fa fa-level-up\"></i>\n        </button>\n    </div>\n	<h6 class=\"modal-title\">Directory: {{$ctrl.currentDirectory.path}}</h6>\n</div>\n<div class=\"modal-body\">\n	<div class=\"loadingIndicator\">\n		<div data-lb-progress=\"$ctrl.loadingIndicator\"\n			 ng-show=\"$ctrl.loadingIndicator.show\">\n		</div>\n	</div>\n    <div ui-grid=\"$ctrl.gridOptions\" class=\"file-grid\" ui-grid-selection ui-grid-auto-resize></div>\n    <input type=\"text\" class=\"prism-text-input\" ng-model=\"$ctrl.builtPath\" autocomplete=\"off\"/>\n</div>\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.dismiss({$value: \'cancel\'})\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.loadSelectedItem()\"\n            ng-disabled=\"!$ctrl.selectedRow\">\n        Load\n    </button>\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.loadSelectedItem()\"\n            ng-disabled=\"$ctrl.disableOKButton()\">\n        OK\n    </button>\n</div>\n");
        $templateCache.put("package/editor/components/shared/completedDeliveries/completed-deliveries-template.html", "<!-- Completed Deliveries Grid -->\n<div id=\"completedDeliveriesGrid\"\n     ui-grid=\"$ctrl.gridOptions\"\n     ui-grid-tree-view\n     ui-grid-auto-resize\n     ui-grid-resize-columns\n     class=\"completed-deliveries-grid\">\n</div>\n");
        $templateCache.put("package/editor/components/view/advancedMetadata/package-advanced-metadata-view-template.html", "<div class=\"row package-edit-full-height edit-view\">\n\n    <!-- Package Lock Messages -->\n    <div ng-include=\"\'package/editor/components/renderers/package-lock-messages-template.html\'\"></div>\n\n    <!-- Package Properties -->\n    <div class=\"edit-view-container\">\n        <div ng-include=\"\'package/editor/components/renderers/package-metadataproperties-renderer-template.html\'\"></div>\n    </div>\n\n    <hr/>\n    <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.packageAdvancedMetadataEditorForm\">\n\n        <!-- Advanced Package Custom Metadata -->\n        <div class=\"edit-view-container\">\n            <div class=\"row clearfix\">\n\n                <!-- Section Header -->\n                <div class=\"col-md-12 column\">\n                    <div class=\"row\">\n                        <div class=\"col-md-3\">\n                            <div class=\"prism-form-heading\">\n                                ADVANCED METADATA\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <!-- Fields -->\n                <div class=\"spacer-top-lg\">\n                    <fieldset viewstate-permission=\"PACKAGE_ADVANCED_METADATA_VIEW_STATE\"\n                              ng-disabled=\"!$ctrl.pkgEditCtrl.statusAllowsEdit() || !$ctrl.canWrite\">\n                        <custom-metadata\n                                components-map=\"$ctrl.metadataComponentsMap\"\n                                disable-components=\"!$ctrl.pkgEditCtrl.statusAllowsEdit() || !$ctrl.canWrite\">\n                        </custom-metadata>\n                    </fieldset>\n                </div>\n            </div>\n        </div>\n    </form>\n\n    <hr/>\n\n    <!-- Shared Nielsen Values -->\n    <div class=\"edit-view-container\">\n        <div class=\"row clearfix\">\n\n            <!-- Section Header -->\n            <div class=\"col-md-12 column\">\n                <div class=\"row\">\n                    <div class=\"col-md-3\">\n                        <div class=\"prism-form-heading\">\n                            SHARED NIELSEN\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <!-- Fields -->\n            <div class=\"row\"\n                 ng-repeat=\"(key, label) in $ctrl.nielsenFieldLabels\">\n                <div class=\"form-group no-margin-bottom\">\n                    <label class=\"col-md-3 control-label text-align-right\"\n                           for={{key}}>\n                        {{label}}\n                    </label>\n                    <div class=\"col-md-9 padding-bottom-xsm\">\n                        <p id={{key}}>\n                            {{$ctrl.packageObject.nielsenData[key]}}&nbsp;\n                        </p>\n                    </div>\n                </div>\n            </div>\n\n            <hr/>\n\n        </div>\n    </div>\n\n</div>\n");
        $templateCache.put("package/editor/components/view/collaborator/grid-checkbox-header-template.html", "<div class=\"ui-grid-cell-contents\"  col-index=\"renderIndex\" ng-click=\"grid.appScope.$ctrl.toggleRows($event)\">\n	<input type=\"checkbox\" ng-checked=\"grid.selection.selectAll\"/>\n	<label></label>\n</div>\n");
        $templateCache.put("package/editor/components/view/collaborator/packagecollaborators-view-template.html", "<div class=\"row package-edit-full-height\"\n     ng-class=\"$ctrl.isClipCollaborators ? \'live-clip-collaborator-view\' : \'\'\"\n     viewstate-permission=\"{{$ctrl.isClipCollaborators ? \'CLIP_COLLABORATORS_VIEW_STATE\' : \'PACKAGE_COLLABORATORS_VIEW_STATE\' }}\">\n    <div class=\"row read-only-msg\"\n         ng-show=\"!$ctrl.loadingIndicator.show && !$ctrl.hasWrite\">\n        <p class=\"text-center\"><i class=\"fa fa-lock\"></i> User access denied! Your permissions do not allow you to edit\n                                                          this content.</p>\n    </div>\n    <div class=\"row read-only-msg\"\n         ng-show=\"!$ctrl.statusAllowsEdit($ctrl.packageObject) && !$ctrl.packageObject.locked &&\n		 			$ctrl.hasWrite\">\n        <p><i class=\"fa fa-lock\"></i> Due to the current package status, this package cannot be modified.</p>\n    </div>\n    <div class=\"row read-only-msg\"\n         ng-show=\"$ctrl.packageObject.locked && $ctrl.hasWrite\">\n        <p><i class=\"fa fa-lock\"></i> This package is checked out, and cannot be modified or delivered.</p>\n    </div>\n    <form class=\"form-horizontal\"\n          role=\"form\"\n          name=\"{{$ctrl.isClipCollaborators ? \'$ctrl.pkgLiveClip.\' + $ctrl.editorFormName : \'$ctrl.packageCollaboratorsEditorForm\'}}\">\n        <div class=\"collaborator-edit-view-container\">\n            <fieldset ng-disabled=\"$ctrl.loadingIndicator.show || !$ctrl.hasWrite || !$ctrl.statusAllowsEdit($ctrl.packageObject)\">\n                <div ng-switch=\"$ctrl.isClipCollaborators\">\n                    <div ng-switch-when=\"true\">\n                        <div ng-include=\"\'package/editor/components/view/collaborator/renderers/clip-collaborators-renderer-template.html\'\"></div>\n                    </div>\n                    <div ng-switch-when=\"false\">\n                        <div ng-include=\"\'package/editor/components/view/collaborator/renderers/package-collaborators-renderer-template.html\'\"></div>\n                    </div>\n                </div>\n            </fieldset>\n        </div>\n    </form>\n</div>\n");
        $templateCache.put("package/editor/components/view/completedDeliveries/package-completed-deliveries-view-template.html", "<div class=\"row package-edit-full-height package-completed-deliveries-view\">\n\n    <!-- Package Lock Messages -->\n    <div class=\"row read-only-msg\"\n         ng-show=\"!$ctrl.pkgEditCtrl.statusAllowsEdit() &&\n                  !$ctrl.packageObject.locked &&\n                  $ctrl.canWrite &&\n                  !$ctrl.loadingIndicator.show\">\n        <p><i class=\"fa fa-lock\"></i> Due to the current package status, this package cannot be modified.</p>\n    </div>\n\n    <div class=\"row read-only-msg\"\n         ng-show=\"$ctrl.packageObject.locked &&\n                  $ctrl.canWrite &&\n                  !$ctrl.loadingIndicator.show\">\n        <p>\n            <i class=\"fa fa-lock\"></i> This package is checked out, and cannot be modified or delivered.\n        </p>\n    </div>\n\n    <!-- Completed Deliveries Grid -->\n    <form class=\"form-horizontal\"\n          name=\"$ctrl.packageCompletedDeliveriesEditorForm\">\n        <completed-deliveries\n            class=\"full-height\"\n            package-object=\"$ctrl.packageObject\"\n            loading-indicator=\"$ctrl.loadingIndicator\">\n        </completed-deliveries>\n    </form>\n\n</div>\n");
        $templateCache.put("package/editor/components/view/distributionGrid/packagedistributiongrid-view-template.html", "<fieldset viewstate-permission=\"{{$ctrl.viewState}}\"\n          ng-disabled=\"!$ctrl.statusAllowsEdit()\">\n\n    <div class=\"row edit-view\"\n         ng-class=\"{\'package-edit-full-height\' : !$ctrl.isClipDistribution}\">\n\n        <!-- Lockout messages -->\n        <div class=\"row read-only-msg\"\n             ng-show=\"!$ctrl.loading && !$ctrl.writePerms\">\n            <p><i class=\"fa fa-lock\"></i> User access denied! Your permissions do not allow you to edit this content.\n            </p>\n        </div>\n        <div class=\"row read-only-msg\"\n             ng-show=\"!$ctrl.loading && !$ctrl.statusAllowsEdit() && !$ctrl.packageObject.locked && $ctrl.writePerms\">\n            <p><i class=\"fa fa-lock\"></i> Due to the current package status, this package cannot be modified.</p>\n        </div>\n        <div class=\"row read-only-msg\"\n             ng-show=\"!$ctrl.packageObjectData.category || $ctrl.partnerPackages.length < 1\">\n            <p>There are either no partner subscriptions or you must select a category</p>\n        </div>\n        <div class=\"row read-only-msg\"\n             ng-show=\"$ctrl.packageObjectData.locked && $ctrl.writePerms && !$ctrl.loading\">\n            <p><i class=\"fa fa-lock\"></i> This package is checked out, and cannot be modified or delivered.</p>\n        </div>\n\n        <!-- \"Select All Partner Packages\" Checkbox -->\n        <div class=\"row select-all-row\"\n             ng-show=\"($ctrl.writePerms && !$ctrl.packageObjectData.locked) && !$ctrl.isAdvanced && ($ctrl.seasonPartnerPackages.length || $ctrl.volumePartnerPackages.length)\">\n            <p>\n                <input type=\"checkbox\"\n                       id=\"selectAllCheckbox\"\n                       class=\"select-all-checkbox\"\n                       ng-model=\"$ctrl.selectAllPartnerPackages\"\n                       ng-click=\"($ctrl.selectAllPartnerPackages) ? $ctrl.updatePartnerPackageSubscriptionSelection(true) : $ctrl.updatePartnerPackageSubscriptionSelection(false)\"/>\n                <label for=\"selectAllCheckbox\"\n                       class=\"prism-form-heading\">\n                    Select All Partner Packages\n                </label>\n            </p>\n        </div>\n\n        <form class=\"form-horizontal\"\n              name=\"{{$ctrl.isClipDistribution ? \'$ctrl.pkgLiveClip.\' + $ctrl.editorFormName : \'$ctrl.packageDistributionGridEditorForm\'}}\">\n\n            <!-- main package editor distribution grid -->\n            <div>\n                <h5 class=\"distributionHeader\"\n                    ng-show=\"$ctrl.packageObjectData.season && $ctrl.packageObjectData.volume && $ctrl.volumePartnerPackages.length && $ctrl.seasonPartnerPackages.length\">\n                    SEASON BASED DISTRIBUTION: {{$ctrl.packageObjectData.season.name}}</h5>\n                <div ng-repeat=\"partnerPackage in $ctrl.seasonPartnerPackages\">\n                    <div class=\"padding-bottom-xsm\">\n                        <div class=\"edit-view-container\"\n                             ng-class=\"{\'edit-view-container-disabled\' : !partnerPackage.enabled}\">\n                            <div ng-switch=\"$ctrl.isAdvanced\">\n                                <div ng-switch-when=\"false\">\n\n                                    <!-- basic dist. grid -->\n                                    <div ng-include=\"\'package/editor/components/view/distributionGrid/renderers/basic-distribution-renderer-template.html\'\">\n                                    </div>\n\n                                </div>\n                                <div ng-switch-when=\"true\">\n\n                                    <!-- adv. dist. grid -->\n                                    <div ng-include=\"\'package/editor/components/view/distributionGrid/renderers/advanced-distribution-renderer-template.html\'\">\n                                    </div>\n\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <!-- Clip distribution grid -->\n            <div>\n                <h5 class=\"distributionHeader\"\n                    ng-show=\"$ctrl.packageObjectData.season && $ctrl.packageObjectData.volume && $ctrl.volumePartnerPackages.length && $ctrl.seasonPartnerPackages.length\">\n                    VOLUME BASED DISTRIBUTION: {{$ctrl.packageObjectData.volume.name}}</h5>\n                <div ng-repeat=\"partnerPackage in $ctrl.volumePartnerPackages\">\n                    <div class=\"padding-bottom-xsm\">\n                        <div class=\"edit-view-container\"\n                             ng-class=\"{\'edit-view-container-disabled\' : !partnerPackage.enabled && !$ctrl.isAdvanced}\">\n                            <div ng-switch=\"$ctrl.isAdvanced\">\n                                <div ng-switch-when=\"false\">\n\n                                    <!-- basic dist. grid -->\n                                    <div ng-include=\"\'package/editor/components/view/distributionGrid/renderers/basic-distribution-renderer-template.html\'\">\n                                    </div>\n\n                                </div>\n                                <div ng-switch-when=\"true\">\n\n                                    <!-- adv. dist. grid -->\n                                    <div ng-include=\"\'package/editor/components/view/distributionGrid/renderers/advanced-distribution-renderer-template.html\'\">\n                                    </div>\n\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n        </form>\n    </div>\n</fieldset>\n");
        $templateCache.put("package/editor/components/view/externalIngests/external-ingests-tab-template.html", "<fieldset class=\"package-edit-full-height edit-view row\"\n     viewstate-permission=\"PACKAGE_EXTERNAL_INGESTS_VIEW_STATE\"\n     ng-disabled=\"!$ctrl.areControlsEnabled()\">\n\n    <!-- Package Lock Messages -->\n    <div ng-include=\"\'package/editor/components/renderers/package-lock-messages-template.html\'\"></div>\n\n    <form class=\"form-horizontal\"\n          name=\"$ctrl.externalIngestsTabEditorForm\">\n        <hr/>\n        <div class=\"edit-view-container\">\n            <div class=\"prism-form-heading\">AGGREGATION</div>\n\n            <!-- System Name -->\n            <div class=\"form-group spacer-top-lg\">\n                <label for=\"externalSystemNameExpressionInput\"\n                       class=\"col-sm-3 control-label\">System Name</label>\n                <div class=\"col-sm-6 pad-text-input-col\">\n                    <span id=\"externalSystemNameExpressionInput\"\n                          class=\"form-control-static\"\n                          ng-model=\"$ctrl.packageObject.name\">\n                        {{$ctrl.packageObject.externalSystem}}\n                    </span>\n                </div>\n            </div>\n\n            <!-- Aggregation ID -->\n            <div class=\"form-group\">\n                <label for=\"externalSystemIdExpressionInput\"\n                       class=\"col-sm-3 control-label\">External ID</label>\n                <div class=\"col-sm-6 pad-text-input-col\">\n                    <input type=\"text\"\n                           class=\"form-control input-sm prism-text-input\"\n                           autocomplete=\"off\"\n                           ng-model=\"$ctrl.packageObject.externalId\"\n                           ng-change=\"$ctrl.onExternalIdChange()\"\n                           id=\"externalSystemIdExpressionInput\"/>\n                </div>\n                <a class=\"fa-stack clear-dropdown\"\n                   ng-class=\"{\'disabled-cursor\': !$ctrl.canWrite}\"\n                   ng-click=\"$ctrl.areControlsEnabled() && $ctrl.clearExternalId()\"\n                   ng-show=\"$ctrl.packageObject.externalId\"\n                   href=\"\">\n                    <i class=\"fa fa-circle fa-stack-1x\"></i>\n                    <i class=\"fa fa-times fa-stack-1x\"></i>\n                </a>\n            </div>\n\n            <!-- Aggregation Date Update -->\n            <div class=\"form-group\">\n                <label for=\"externalDateUpdatedInput\"\n                       class=\"col-sm-3 control-label\">Aggregation Date Update</label>\n                <div class=\"col-sm-6 pad-text-input-col\">\n                    <span class=\"form-control-static\"\n                          id=\"externalDateUpdatedInput\">\n                        {{$ctrl.packageObject.externalDateUpdated | amDateFormat: \'MM/DD/YYYY HH:mm:ss A\'}}\n                    </span>\n                    <a class=\"fa-stack clear-dropdown\"\n                       ng-class=\"{\'disabled-cursor\': !$ctrl.canWrite}\"\n                       ng-click=\"$ctrl.areControlsEnabled() && $ctrl.clearExternalDateUpdated()\"\n                       ng-show=\"$ctrl.packageObject.externalDateUpdated\"\n                       href=\"\">\n                        <i class=\"fa fa-circle fa-stack-1x\"></i>\n                        <i class=\"fa fa-times fa-stack-1x\"></i>\n                    </a>\n                </div>\n            </div>\n\n        </div>\n\n\n        <hr/>\n\n\n        <div class=\"edit-view-container\">\n            <div class=\"prism-form-heading\">AGGREGATION SOURCES</div>\n\n            <!-- Xml Grid -->\n            <div class=\"row spacer-top-lg\">\n                <div class=\"col-md-12 column\">\n                    <div class=\"grid unsorted-grid externalIngestHistoryGrid\"\n                         ui-grid=\"$ctrl.gridOptions\"\n                         ui-grid-auto-resize>\n                    </div>\n                </div>\n            </div>\n\n        </div>\n    </form>\n</fieldset>\n");
        $templateCache.put("package/editor/components/view/liveclip/packageliveclip-view-template.html", "<!-- If changes are made to the column sizes or padding around the video player column, packageliveclip-view-controller.js\n	also needs it\'s values that are used to calculate the player\'s width updated to reflect new values.\n-->\n<div class=\"row live-clip-edit-view-height edit-view\" viewstate-permission=\"PACKAGE_VIDEO_CLIPS_VIEW_STATE\">\n	<div ng-if=\"!pkgLiveClip.packageObject.category\" class=\"row read-only-msg\">\n		<p><i class=\"fa fa-lock\"></i> Please Select A Category </p>\n		<form class=\"form-horizontal\" role=\"form\" name=\"pkgLiveClip.editorForm\"></form>\n	</div>\n	<!--<div ng-if=\"pkgLiveClip.packageObject.category && !pkgLiveClip.categoryValid\" class=\"row read-only-msg\">\n		<p><i class=\"fa fa-lock\"></i> Category Is Not Valid For Clips </p>\n		<form class=\"form-horizontal\" role=\"form\" name=\"pkgLiveClip.editorForm\"></form>\n	</div>-->\n	<div ng-if=\"pkgLiveClip.packageObject.category\">\n		<div ng-include=\"\'package/editor/components/view/liveclip/renderers/live-clip-tab-status-renderer-template.html\'\">\n		</div>\n		<div class=\"row\">\n			<div class=\"col-sm-6\">\n				<fieldset ng-disabled=\"!pkgLiveClip.perms.livePerms || (pkgLiveClip.draftClipMode && pkgLiveClip.clipInEdit.id) || !pkgLiveClip.streamExists\">\n\n					<div class=\"row\">\n						<div class=\"edit-view-container live-player-container\">\n							<react-component ng-if=\"pkgLiveClip.props.sourcePath\"\n											 name=\"liveClippingVideoPlayer\"\n											 props=\"pkgLiveClip.props\"\n											 class=\"live-clip-video-player\"\n											 ng-click=\"pkgLiveClip.preventClickInDraftMode($event)\"/>\n						</div>\n					</div>\n\n					<div ng-include=\"\'package/editor/components/view/liveclip/renderers/clip-edit-renderer-template.html\'\"></div>\n\n				</fieldset>\n			</div>\n			<div class=\"col-sm-6\">\n				<div ng-switch=\"pkgLiveClip.clipInEdit.id\">\n					<div ng-switch-when=\"undefined\">\n						<div\n							ng-include=\"\'package/editor/components/view/liveclip/renderers/clipList/clip-list-drawer-template.html\'\"></div>\n					</div>\n					<div ng-switch-default>\n						<div\n							ng-include=\"\'package/editor/components/view/liveclip/renderers/clipEditTabs/tab-edit-renderer-template.html\'\"></div>\n					</div>\n				</div>\n			</div>\n		</div>\n		<!--Removing for now until we determine a use-->\n		<!--<div ng-include=\"\'package/editor/components/view/liveclip/renderers/clip-actions-renderer-template.html\'\"></div>-->\n	</div>\n</div>\n");
        $templateCache.put("package/editor/components/view/media/component-video-tab-template.html", "<!-- Component Videos -->\n<package-media-component-video-asset-list\n    component-role=\"componentRole\">\n</package-media-component-video-asset-list>\n<hr/>\n\n<!-- CC -->\n<package-media-text-asset-list\n    component-role=\"componentRole\"\n    variant=\"\'cc\'\">\n</package-media-text-asset-list>\n<hr/>\n\n<!-- Subtitles -->\n<package-media-text-asset-list\n    component-role=\"componentRole\"\n    variant=\"\'subtitle\'\">\n</package-media-text-asset-list>\n");
        $templateCache.put("package/editor/components/view/media/main-video-tab-template.html", "<video-metadata>\n</video-metadata>\n<hr/>\n\n<package-media-main-video-asset-list>\n</package-media-main-video-asset-list>\n\n<!-- Find Related -->\n<!--\n<div class=\"row clearfix edit-container-no-border\"\n     align=\"center\"\n     ng-if=\"$ctrl.getMainVideo().virtualPath && !$ctrl.wasMainVideoUploaded()\">\n    <button class=\"btn btn-default prism-button\"\n            ng-click=\"$ctrl.onFindRelated()\">\n        Find Related Items\n    </button>\n</div>\n-->\n<hr/>\n\n<!-- Images -->\n<package-media-image-asset-list>\n</package-media-image-asset-list>\n<hr/>\n\n<!-- CC -->\n<package-media-text-asset-list\n    component-role=\"$ctrl.getDefaultComponentRole()\"\n    variant=\"\'cc\'\">\n</package-media-text-asset-list>\n<hr/>\n\n<!-- Subtitles -->\n<package-media-text-asset-list\n    component-role=\"$ctrl.getDefaultComponentRole()\"\n    variant=\"\'subtitle\'\">\n</package-media-text-asset-list>\n<hr/>\n\n<!-- Audio -->\n<package-media-audio-asset-list>\n</package-media-audio-asset-list>\n<hr/>\n\n<!-- Artwork -->\n\n<!--\n    2018-Sep-19\n\n    Robert says we can remove artwork from the package media tab\n    for now, it hasn\'t been used in years. This commented-out\n    asset list element will mark where it was in the list should\n    he ever ask for it to be replaced.\n  -->\n\n<!--<artwork-manager>-->\n<!--</artwork-manager>-->\n<!--<hr/>-->\n\n<!-- AdPods -->\n<package-media-ad-pod-asset-list>\n</package-media-ad-pod-asset-list>\n");
        $templateCache.put("package/editor/components/view/media/packagemedia-view-template.html", "<fieldset viewstate-permission=\"PACKAGE_MEDIA_VIEW_STATE\"\n          ng-disabled=\"!$ctrl.pkgEditCtrl.statusAllowsEdit()\">\n    <div class=\"row package-edit-full-height edit-view\">\n\n        <div class=\"row read-only-msg\"\n             ng-show=\"!$ctrl.loadingIndicator.show && !$ctrl.canWrite\">\n            <p class=\"text-center\">\n                <i class=\"fa fa-lock\"></i>\n                User access denied! Your permissions do not allow you to edit this content.\n            </p>\n        </div>\n\n        <div class=\"row read-only-msg\"\n             ng-show=\"!$ctrl.pkgEditCtrl.statusAllowsEdit() && !$ctrl.loadingIndicator.show\">\n            <p>\n                <i class=\"fa fa-lock\"></i>\n                Due to the current package status, this package cannot be modified.\n            </p>\n        </div>\n\n        <div class=\"row read-only-msg\"\n             ng-show=\"$ctrl.packageObjectData.locked && $ctrl.canWrite && !$ctrl.loadingIndicator.show\">\n            <p>\n                <i class=\"fa fa-lock\"></i>\n                This package is checked out, and cannot be modified or delivered.\n            </p>\n        </div>\n\n        <div class=\"row read-only-msg\"\n             ng-show=\"!$ctrl.packageObjectData.category && !$ctrl.loadingIndicator.show\">\n            <p>\n                <i class=\"fa fa-lock\"></i>\n                Please select a category on the metadata tab\n            </p>\n        </div>\n\n        <div class=\"row read-only-msg\"\n             ng-show=\"$ctrl.showMissingContentComponentRoles && !$ctrl.loadingIndicator.show\">\n            <p>\n				<span class=\"fa-stack fa error-warning-triangle metadata tree-top-level-error\"\n                      data-tooltip-append-to-body=\"true\"\n                      uib-tooltip=\"Please make sure all roles required for a partner are available on the content category.\">\n					<i class=\"fa fa-square fa-stack-1x\"></i>\n					<i class=\"fa fa-exclamation-triangle fa-stack-2x\"></i>\n				</span>\n                Partner(s) require role(s) that are not available for this content\n            </p>\n        </div>\n\n        <form class=\"form-horizontal\"\n              role=\"form\"\n              ng-show=\"$ctrl.packageObjectData.category\"\n              name=\"$ctrl.packageMediaEditorForm\">\n\n            <uib-tabset active=\"$ctrl.activeTabs[componentRole.role.name]\"\n                        class=\"media-edit-view-tabbar\"\n                        horizontal=\"true\"\n                        type=\"pills\">\n\n                <uib-tab deselect=\"$ctrl.onTabDeselect(componentRole, $event)\"\n                         disable=\"$ctrl.disableTab(componentRole.role.name)\"\n                         ng-if=\"$ctrl.isComponentRoleEnabled(componentRole)\"\n                         ng-repeat=\"componentRole in $ctrl.componentRoles\"\n                         select=\"$ctrl.onTabSelect(componentRole)\">\n\n                    <uib-tab-heading ng-show=\"$ctrl.getComponentRoleCount() > 1\">\n                        <div ng-if=\"$ctrl.isComponentRoleRequired(componentRole)\">\n                            <span class=\"spacer-top-xsm\"\n                                  required\n                                  x-required-indicator>{{componentRole.name}}</span>\n                        </div>\n                        <div ng-if=\"!$ctrl.isComponentRoleRequired(componentRole)\">\n                            <span>{{componentRole.name}}</span>\n                        </div>\n                    </uib-tab-heading>\n\n                    <!-- Main Video -->\n                    <div ng-if=\"componentRole.isDefault\">\n                        <div ng-if=\"$ctrl.getLockMessage().length\"\n                             class=\"row read-only-msg\">\n                            <p><i class=\"fa fa-lock\"></i> {{$ctrl.getLockMessage()}}</p>\n                            <hr/>\n                        </div>\n                        <fieldset ng-disabled=\"$ctrl.getLockMessage().length\">\n                            <div ng-include=\"\'package/editor/components/view/media/main-video-tab-template.html\'\"></div>\n                        </fieldset>\n                    </div>\n\n                    <!-- Component Role -->\n                    <div ng-if=\"!componentRole.isDefault\">\n\n                        <div ng-if=\"$ctrl.getMainVideo()\">\n                            <div ng-if=\"$ctrl.getLockMessage().length\"\n                                 class=\"row read-only-msg\">\n                                <p><i class=\"fa fa-lock\"></i> {{$ctrl.getLockMessage()}}</p>\n                                <hr/>\n                            </div>\n                            <fieldset ng-disabled=\"$ctrl.getLockMessage().length\">\n                                <div ng-include=\"\'package/editor/components/view/media/component-video-tab-template.html\'\"></div>\n                            </fieldset>\n                        </div>\n\n                        <div ng-if=\"!$ctrl.getMainVideo()\">\n                            <div class=\"row read-only-msg spacer-top-xsm\">\n                                <p><i class=\"fa fa-lock\"></i> Please select the main video</p>\n                            </div>\n                        </div>\n\n                    </div>\n\n                </uib-tab>\n            </uib-tabset>\n        </form>\n    </div>\n</fieldset>\n");
        $templateCache.put("package/editor/components/view/metadata/packagemetadata-view-template.html", "<div class=\"row package-edit-full-height edit-view\">\n    <div class=\"row\" ng-if=\"1\"\n         ng-repeat=\"pendingPartnerPackage in $ctrl.pendingPartnerPackages\">\n        <div class=\"col-md-12\">\n            <div class=\"pull-right\">\n                <span>{{pendingPartnerPackage.partnerName}} Pre-Delivery QC Approval</span>\n\n                <span class=\"approval-status-label\" ng-if=\"pendingPartnerPackage.approvalStatus  === \'ACCEPTED\' || pendingPartnerPackage.approvalStatus === \'REJECTED\'\">\n                    <i class=\"fa fa-check green-check\" ng-if=\"pendingPartnerPackage.approvalStatus === \'ACCEPTED\'\"></i>\n                    <i class=\"fa fa-times red-x\" ng-if=\"pendingPartnerPackage.approvalStatus === \'REJECTED\'\"></i>\n                    {{pendingPartnerPackage.approvalStatus}}\n                    <i class=\"fa fa-info-circle info padding-left-xsm\" ng-if=\"pendingPartnerPackage.approvalStatus  === \'ACCEPTED\' || pendingPartnerPackage.approvalStatus === \'REJECTED\'\"\n                       ng-click=\"$ctrl.showApprovalMessage(pendingPartnerPackage)\"></i>\n                </span>\n                <span class=\"approval-button-group\" ng-if=\"pendingPartnerPackage.approvalStatus === \'PENDING\' || pendingPartnerPackage.approvalStatus == null\">\n                    <button id=\"acceptButton\"\n                            type=\"button\"\n                            class=\"accept-status-btn\"\n                            ng-click=\"$ctrl.showApprovePartnerPackageModal(pendingPartnerPackage)\">\n                        accept\n                    </button>\n                    <button id=\"rejectButton\"\n                            type=\"button\"\n                            class=\"reject-status-btn\"\n                            ng-click=\"$ctrl.showRejectPartnerPackageModal(pendingPartnerPackage)\">\n                        reject\n                    </button>\n                </span>\n            </div>\n        </div>\n    </div>\n    <hr/>\n    <fieldset viewstate-permission=\"PACKAGE_METADATA_VIEW_STATE\"\n              ng-disabled=\"!$ctrl.pkgEditCtrl.statusAllowsEdit()\">\n        <!-- Package Lock Messages -->\n        <div class=\"row read-only-msg\"\n             ng-show=\"!$ctrl.loading && !$ctrl.writePerms\">\n            <p><i class=\"fa fa-lock\"></i> User access denied! Your permissions do not allow you to edit this\n                content.\n            </p>\n        </div>\n\n        <div class=\"row read-only-msg\"\n             ng-show=\"!$ctrl.pkgEditCtrl.statusAllowsEdit() && !$ctrl.packageObject.locked && $ctrl.writePerms && !$ctrl.loading\">\n            <p><i class=\"fa fa-lock\"></i> Due to the current package status, this package cannot be modified.\n            </p>\n        </div>\n\n        <div class=\"row read-only-msg\"\n             ng-show=\"$ctrl.packageObject.locked && $ctrl.writePerms && !$ctrl.loading\">\n            <p><i class=\"fa fa-lock\"></i> This package is checked out, and cannot be modified or delivered.</p>\n        </div>\n\n        <form class=\"form-horizontal\"\n              role=\"form\"\n              name=\"$ctrl.packageMetadataEditorForm\">\n\n            <div>\n                <div class=\"edit-view-container\">\n                    <div ng-include=\"\'package/editor/components/renderers/package-metadataproperties-renderer-template.html\'\">\n                    </div>\n                </div>\n\n                <hr/>\n\n                <div class=\"edit-view-container\">\n                    <div ng-switch=\"$ctrl.packageObject.content.type\">\n                        <div class=\"row clearfix\">\n                            <div class=\"col-md-12 column\">\n                                <div class=\"row\">\n                                    <div class=\"col-md-2\">\n                                        <div class=\"prism-form-heading\">GENERAL</div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <div ng-switch-when=\"Ad/PreRoll\">\n                            <div ng-include=\"\'package/editor/components/view/metadata/renderers/package-adpreroll-metadata-template.html\'\">\n                            </div>\n                        </div>\n                        <div ng-switch-default>\n                            <div ng-include=\"\'package/editor/components/view/metadata/renderers/package-short-longform-metadata-template.html\'\">\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <hr />\n\n                <translatable-metadata\n                        form-title=\"\'LOCALIZATION\'\"\n                        fields=\"$ctrl.translatableMetadataFields\">\n                </translatable-metadata>\n\n                <hr/>\n\n                <div class=\"edit-view-container\">\n                    <div class=\"row clearfix\">\n                        <div class=\"col-md-12 column\">\n                            <div class=\"row\">\n                                <div class=\"col-md-2\">\n                                    <div class=\"prism-form-heading\">GLOBAL METADATA</div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row clearfix spacer-top-lg\">\n                        <div class=\"col-md-12 column\">\n                            <custom-metadata components-map=\"$ctrl.metadataComponentsMap\"\n                                             disable-components=\"!$ctrl.pkgEditCtrl.statusAllowsEdit() || !$ctrl.writePerms\"\n                                             on-update=\"$ctrl.onMetadataUpdate(event)\">\n                            </custom-metadata>\n\n                            <!-- Rating System -->\n                            <div class=\"form-group\">\n                                <label for=\"rating\"\n                                       class=\"col-sm-2 control-label\">Rating System</label>\n                                <div class=\"col-sm-4 top-margin-xs\">\n                                    <dropdown-select id=\"ratingSystem\"\n                                                     ng-model=\"$ctrl.ratingSystem\"\n                                                     on-change=\"$ctrl.onRatingSystemChange()\"\n                                                     label-field=\"systemCode\"\n                                                     dropup=\"true\"\n                                                     clearable=\"false\"\n                                                     prompt=\"Select Rating System\"\n                                                     collection=\"$ctrl.ratingSystemValues\"\n                                                     sort-collection=\"false\"\n                                                     btn-min-width=\"150\"\n                                                     ng-disabled=\"!$ctrl.pkgEditCtrl.statusAllowsEdit() || !$ctrl.writePerms\">\n                                    </dropdown-select>\n                                </div>\n                            </div>\n\n                            <!-- Rating -->\n                            <div class=\"form-group\">\n                                <label for=\"rating\"\n                                       class=\"col-sm-2 control-label top-margin-xs\">Rating</label>\n\n                                <div class=\"col-sm-4 flex-row-container top-margin-xs\">\n                                    <dropdown-select id=\"rating\"\n                                                     class=\"hide-required-indicator\"\n                                                     ng-model=\"$ctrl.packageObject.rating.ratingCode\"\n                                                     label-field=\"ratingCode\"\n                                                     on-change=\"$ctrl.onRatingChange()\"\n                                                     on-clear=\"$ctrl.onRatingClear()\"\n                                                     dropup=\"true\"\n                                                     clearable=\"true\"\n                                                     prompt=\"Select Rating\"\n                                                     collection=\"$ctrl.ratingSystem.ratingCodes\"\n                                                     sort-collection=\"false\"\n                                                     btn-min-width=\"150\"\n                                                     required\n                                                     ng-disabled=\"!$ctrl.pkgEditCtrl.statusAllowsEdit() || !$ctrl.writePerms\">\n                                    </dropdown-select>\n                                    <div class=\"error-warning error-warning-select padding-left-sm\">\n                                        <error-warning-indicator\n                                                error-warning=\"$ctrl.pkgEditCtrl.checkErrorWarning(\'rating\', $ctrl.packageObject.name)\">\n                                        </error-warning-indicator>\n                                    </div>\n                                    <div class=\"top-margin-xs padding-left-sm\">\n                                        <div class=\"required-select\"\n                                             required\n                                             x-required-indicator>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <!-- Rating Descriptor -->\n                            <div class=\"form-group\">\n                                <label for=\"ratingDescriptor\"\n                                       class=\"col-sm-2 control-label\">Advisories</label>\n\n                                <div class=\"col-sm-4 top-margin-xs\">\n                                    <multiselect-dropdown\n                                            id=\"ratingDescriptor\"\n                                            class=\"margin-right-md\"\n                                            collection=\"$ctrl.advisoryCodes\"\n                                            ng-disabled=\"!$ctrl.advisoryCodes.length\"\n                                            dropup=\"true\"\n                                            ng-model=\"$ctrl.packageObject.rating.ratingAdvisoryCodes\"\n                                            label-field=\"description\"\n                                            prompt=\"Select Advisories\"\n                                            clearable=\"false\"\n                                            btn-min-width=\"150\"\n                                            sort-collection=\"false\"\n                                            max-height=\"375\">\n                                    </multiselect-dropdown>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </form>\n    </fieldset>\n</div>\n\n");
        $templateCache.put("package/editor/components/view/preview/package-preview-view-template.html", "<fieldset viewstate-permission=\"PACKAGE_VIDEO_PREVIEW_VIEW_STATE\">\n	<div class=\"row package-edit-full-height edit-view preview-view\">\n		<div class=\"row read-only-msg\" ng-show=\"!pkgPreviewCtrl.loading && (!pkgPreviewCtrl.perms.download || !pkgPreviewCtrl.perms.write) && !pkgPreviewCtrl.perms.exception\">\n			<p class=\"text-center\"><i class=\"fa fa-lock\"></i> User access denied! Your permissions do not allow you to edit this content.</p>\n		</div>\n		<div class=\"row read-only-msg\" ng-show=\"!pkgEditCtrl.statusAllowsEdit() && !pkgPreviewCtrl.packageObject.locked\n		 && pkgPreviewCtrl.perms.write && !pkgPreviewCtrl.loading\">\n			<p><i class=\"fa fa-lock\"></i> Due to the current package status, this package cannot be modified.</p>\n		</div>\n		<div class=\"row read-only-msg\" ng-show=\"!pkgPreviewCtrl.loading && !pkgPreviewCtrl.canViewProxy() && pkgPreviewCtrl.perms.exception\">\n			<p class=\"text-center\">{{\'Proxies will be available on \' + (pkgPreviewCtrl.perms.exception | amDateFormat: \'llll\')}} </p>\n		</div>\n		<form class=\"form-horizontal\" role=\"form\" name=\"pkgPreviewCtrl.editorForm\" ng-show=\"pkgPreviewCtrl.canViewProxy()\">\n			<ng-include\n				src=\"\'package/editor/components/view/preview/renderers/availableElements/preview-elements-renderer-template.html\'\">\n			</ng-include>\n			<hr>\n			<ng-include\n				src=\"\'package/editor/components/view/preview/renderers/video/preview-video-renderer-template.html\'\">\n			</ng-include>\n			<hr>\n			<div class=\"form-group\">\n				<div class=\"col-sm-6 padding-right-xsm\">\n					<ng-include\n						src=\"\'package/editor/components/view/preview/renderers/image/preview-image-renderer-template.html\'\">\n					</ng-include>\n				</div>\n				<div class=\"col-sm-6 padding-left-xsm\">\n					<ng-include\n						src=\"\'package/editor/components/view/preview/renderers/artwork/preview-artwork-renderer-template.html\'\">\n					</ng-include>\n				</div>\n			</div>\n		</form>\n	</div>\n</fieldset>\n");
        $templateCache.put("package/editor/components/view/statusbar/packagestatus-bar-template.html", "<nav class=\"navbar navbar-default status-bar\">\n    <div class=\"container-fluid\">\n        <!-- Brand and toggle get grouped for better mobile display -->\n        <div class=\"navbar-header\">\n            <div>Package Status:</div>\n        </div>\n\n        <!-- Collect the nav links, forms, and other content for toggling -->\n        <div class=\"collapse navbar-collapse\"\n             id=\"bs-example-navbar-collapse-1\">\n            <ul class=\"nav navbar-nav\">\n                <li>\n                    <status-icon status=\"$ctrl.packageObject.status\"\n                                 class=\"package-status-icon\"></status-icon>\n                </li>\n                <li id=\"packageStatusText\">{{$ctrl.packageObject.status |\n                                           enumFilter:\'Package_status\'}}\n                </li>\n                <li class=\"status-element\">\n                    <button type=\"button\"\n                            class=\"btn btn-xs btn-default\"\n                            ng-show=\"$ctrl.showErrorsWarningsButton()\"\n                            ng-click=\"$ctrl.showErrorsWarningsModal()\">\n                        Errors and Warnings\n                    </button>\n                </li>\n            </ul>\n            <ul class=\"nav navbar-nav navbar-right\">\n                <li class=\"approval-status-text\"\n                    ng-show=\"$ctrl.showApprovalText()\">\n                    Approval Status: {{($ctrl.packageObject.acceptStatus || \'Pending Approval\') |\n                    enumFilter:\'Package_acceptStatus\'}}\n                    <button type=\"button\"\n                            class=\"btn btn-xs btn-default\"\n                            ng-show=\"$ctrl.showRejectedButton()\"\n                            ng-click=\"$ctrl.openRejectionModal()\">\n                        Rejection Comments\n                    </button>\n                </li>\n                <li ng-show=\"$ctrl.showApprovalButtons() && $ctrl.approvalPermitted\">\n                    <a class=\"accept-status-btn\"\n                       ng-click=\"$ctrl.acceptHandler()\">\n                        accept\n                    </a>\n                </li>\n                <li ng-show=\"$ctrl.showApprovalButtons() && $ctrl.approvalPermitted\">\n                    <a class=\"reject-status-btn\"\n                       ng-click=\"$ctrl.rejectHandler()\">\n                        reject\n                    </a>\n                </li>\n                <li class=\"approval-status-text\"\n                    ng-show=\"$ctrl.showApprovalButtons() && !$ctrl.approvalPermitted\">\n                    Accept/Reject Restricted\n                    <div class=\"fa-stack package-status-icon help-icon\">\n                        <i class=\"fa fa-circle fa-stack-2x\"></i>\n                        <i class=\"fa fa-circle-thin fa-stack-2x\"></i>\n                        <i class=\"fa fa-question fa-stack-1x\"></i>\n                    </div>\n                </li>\n            </ul>\n        </div><!-- /.navbar-collapse -->\n    </div><!-- /.container-fluid -->\n</nav>\n");
        $templateCache.put("package/editor/components/view/timings/packagetimings-view-template.html", "<fieldset viewstate-permission=\"PACKAGE_TIMINGS_VIEW_STATE\" ng-disabled=\"!pkgEditCtrl.statusAllowsEdit()\">\n	<div class=\"row package-edit-full-height\">\n		<div class=\"row read-only-msg\" ng-show=\"!pkgTimingsCtrlr.loading && !pkgTimingsCtrlr.writePerms\">\n			<p><i class=\"fa fa-lock\"></i> User access denied! Your permissions do not allow you to edit this content.</p>\n		</div>\n		<div class=\"row read-only-msg\" ng-show=\"!pkgEditCtrl.statusAllowsEdit() && !pkgTimingsCtrlr.packageObject.locked\n		 && pkgTimingsCtrlr.writePerms && !pkgTimingsCtrlr.loading\">\n			<p><i class=\"fa fa-lock\"></i> Due to the current package status, this package cannot be modified.</p>\n		</div>\n		<div class=\"row read-only-msg\" ng-show=\"pkgTimingsCtrlr.packageObject.locked && pkgTimingsCtrlr.writePerms && !pkgTimingsCtrlr.loading\">\n			<p><i class=\"fa fa-lock\"></i> This package is checked out, and cannot be modified or delivered.</p>\n		</div>\n		<package-timings-search-view\n			package-object=\"pkgTimingsCtrlr.packageObject\">\n		</package-timings-search-view>\n	</div>\n</fieldset>\n");
        $templateCache.put("package/manager/modals/filter/datePropertiesSection/date-properties-section-template.html", "<div class=\"row clearfix\" ng-controller=\"PMDatePropertiesSectionController as pmDateProperties\">\n	<div class=\"col-md-12 column\">\n		<div class=\"row\">\n			<div class=\"col-md-12\">\n				<div class=\"prism-form-heading\">Date Properties</div>\n			</div>\n		</div>\n		<div class=\"row\">\n			<div class=\"col-md-6\">\n				<div class=\"row\">\n					<div>\n						<span class=\"col-md-12 control-label\">\n							<input type=\"radio\" name=\"dateRadios\" id=\"noneFilterDateRadio\" value=\"\" ng-model=\"pmDateProperties.selectedDateProperty\"/>\n							<label class=\"condensed-label\" for=\"noneFilterDateRadio\">\n								None\n							</label>\n						</span>\n					</div>\n				</div>\n				<div class=\"row\">\n					<div>\n						<span class=\"col-md-12 control-label padding-bottom-sm\">\n							<input type=\"radio\" name=\"dateRadios\" id=\"dateCreatedFilterDateRadio\" value=\"dateCreated\" ng-model=\"pmDateProperties.selectedDateProperty\"/>\n							<label class=\"condensed-label\" for=\"dateCreatedFilterDateRadio\">\n								Date Created\n							</label>\n						</span>\n					</div>\n				</div>\n				<div class=\"row\">\n					<fieldset ng-disabled=\"pmDateProperties.selectedDateProperty !== \'dateCreated\'\">\n						<div class=\"col-md-4\">\n							<date-picker ng-model=\"pmDateProperties.selectedDateProperties.dateCreated.fromDate\"></date-picker>\n						</div>\n						<div class=\"col-md-1\">\n							<span class=\"control-label\">to</span>\n						</div>\n						<div class=\"col-md-4\">\n							<date-picker ng-model=\"pmDateProperties.selectedDateProperties.dateCreated.toDate\"></date-picker>\n						</div>\n					</fieldset>\n				</div>\n			</div>\n			<div class=\"col-md-6\">\n				<div class=\"row\">\n					<div>\n						<span class=\"col-md-12 control-label padding-bottom-sm\">\n							<input type=\"radio\" name=\"dateRadios\" id=\"ordFilterDateRadio\" value=\"originalReleaseDate\" ng-model=\"pmDateProperties.selectedDateProperty\"/>\n							<label class=\"condensed-label\" for=\"ordFilterDateRadio\">\n								Original Release Date\n							</label>\n						</span>\n					</div>\n				</div>\n\n				<div class=\"row\">\n					<fieldset ng-disabled=\"pmDateProperties.selectedDateProperty !== \'originalReleaseDate\'\">\n						<div class=\"col-md-4\">\n							<date-picker ng-model=\"pmDateProperties.selectedDateProperties.originalReleaseDate.fromDate\"></date-picker>\n						</div>\n						<div class=\"col-md-1\">\n							<span class=\"control-label\">to</span>\n						</div>\n						<div class=\"col-md-4\">\n							<date-picker ng-model=\"pmDateProperties.selectedDateProperties.originalReleaseDate.toDate\"></date-picker>\n						</div>\n					</fieldset>\n				</div>\n				<div class=\"row\">\n					<div>\n						<span class=\"col-md-12 control-label padding-bottom-sm\">\n							<input type=\"radio\" name=\"dateRadios\" id=\"lastEditedFilterDateRadio\" value=\"lastEdited\" ng-model=\"pmDateProperties.selectedDateProperty\"/>\n							<label class=\"condensed-label\" for=\"lastEditedFilterDateRadio\">\n								Last Edited\n							</label>\n						</span>\n					</div>\n				</div>\n				<div class=\"row\">\n					<fieldset ng-disabled=\"pmDateProperties.selectedDateProperty !== \'lastEdited\'\">\n						<div class=\"col-md-4\">\n							<date-picker ng-model=\"pmDateProperties.selectedDateProperties.lastEdited.fromDate\"></date-picker>\n						</div>\n						<div class=\"col-md-1\">\n							<span class=\"control-label\">to</span>\n						</div>\n						<div class=\"col-md-4\">\n							<date-picker ng-model=\"pmDateProperties.selectedDateProperties.lastEdited.toDate\"></date-picker>\n						</div>\n					</fieldset>\n				</div>\n			</div>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("package/manager/modals/filter/deliverySection/delivery-section-template.html", "<div class=\"row clearfix\" ng-controller=\"PMSearchFiltersDeliverySectionController as pmDatePropertiesCtrl\">\n    <div class=\"col-md-12 column\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"prism-form-heading\">Delivery</div>\n            </div>\n        </div>\n\n        <div class=\"row spacer-top-xsm padding-bottom-xsm\">\n            <div class=\"col-md-6\">\n                <div class=\"form-group no-margin-bottom\">\n                    <label for=\"deliveredFlag\"\n                           class=\"col-md-4 control-label\">Status</label>\n                    <div class=\"col-md-8 metadata-control-col\">\n                        <dropdown-select id=\"deliveredFlag\"\n                                         collection=\"pmDatePropertiesCtrl.deliveredFlagOptions\"\n                                         label-field=\"label\"\n                                         ng-model=\"pmDatePropertiesCtrl.delivered\"\n                                         clearable=\"true\"\n                                         prompt=\"Select Status\"\n                                         sort-collection=\"false\"\n                                         btn-min-width=\"150\">\n                        </dropdown-select>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"col-md-6\">\n                <div class=\"form-group no-margin-bottom\">\n                    <label for=\"deliveredPartners\"\n                           class=\"col-md-2 control-label\">Partners</label>\n                    <div class=\"col-md-10 metadata-control-col\">\n                        <multiselect-dropdown\n                                id=\"deliveredPartners\"\n                                collection=\"pmDatePropertiesCtrl.availablePartners\"\n                                label-field=\"name\"\n                                label-function=\"pmDatePropertiesCtrl.getPartnerLabel\"\n                                value-prop=\"id\"\n                                ng-model=\"pmDatePropertiesCtrl.deliveredToPartners\"\n                                ng-disabled=\"!pmDatePropertiesCtrl.delivered\"\n                                prompt=\"Select Partners\"\n                                clearable=\"true\"\n                                btn-min-width=\"250\"\n                                sort-collection=\"true\"\n                                max-height=\"375\">\n                        </multiselect-dropdown>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n{{}}\n");
        $templateCache.put("package/manager/modals/filter/metadataPropertiesSection/metadata-properties-section-template.html", "<div class=\"row clearfix\" ng-controller=\"PMMetadataSearchFieldsSectionController as pmMetadataSearchFieldsCtrl\">\n	<div class=\"col-md-12 column\">\n		<div class=\"row\">\n			<div class=\"col-md-12\">\n				<div class=\"prism-form-heading\">Metadata Properties</div>\n			</div>\n		</div>\n		<div class=\"row spacer-top-xsm padding-bottom-xsm\">\n			<div class=\"col-md-6\">\n				<div class=\"form-group no-margin-bottom\">\n					<label for=\"packageFieldsDropdown\" class=\"col-sm-3 auto-width control-label\">Metadata Fields</label>\n					<div class=\"col-sm-9 metadata-control-col\">\n						<multiselect-dropdown id=\"packageFieldsDropdown\"\n											  ng-model=\"pmMetadataSearchFieldsCtrl.selectedSearchablePackageFields\"\n											  clearable=\"true\"\n											  model-prop=\"name\"\n											  prompt=\"Select Package Fields\" label-field=\"name\" enable-select-all=\"true\"\n											  collection=\"pmMetadataSearchFieldsCtrl.searchablePackageFields\">\n						</multiselect-dropdown>\n					</div>\n				</div>\n			</div>\n			<div class=\"col-md-6\">\n				<div class=\"form-group no-margin-bottom\">\n					<label for=\"partnerFieldsDropdown\" class=\"col-sm-3 auto-width control-label\">Partner Metadata Fields\n					</label>\n\n					<div class=\"col-sm-9 metadata-control-col\">\n						<multiselect-dropdown id=\"partnerFieldsDropdown\"\n											  ng-model=\"pmMetadataSearchFieldsCtrl.selectedSearchablePartnerFields\"\n											  clearable=\"true\"\n											  model-prop=\"displayName\"\n											  prompt=\"Select Partner Fields\" label-field=\"displayName\"\n											  collection=\"pmMetadataSearchFieldsCtrl.searchablePartnerFields\">\n						</multiselect-dropdown>\n					</div>\n				</div>\n			</div>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("package/manager/modals/filter/metadataSearchSection/metadata-search-section-template.html", "<div class=\"row clearfix\" ng-controller=\"PMMetadataSearchSectionController as pmMetadataSearchFilterSection\">\n	<div class=\"col-md-12 column\">\n		<div class=\"row\">\n			<div class=\"col-md-12\">\n				<div class=\"prism-form-heading\">Metadata Search</div>\n			</div>\n		</div>\n		<div class=\"row\">\n			<div class=\"col-md-12\">\n				<form class=\"form-horizontal\" role=\"form\">\n					<div class=\"form-group\">\n						<label for=\"searchTextInput\" class=\"col-sm-2 control-label\">Text</label>\n						<div class=\"col-sm-9 pad-text-input-col\">\n							<enhanced-textinput model-prop=\"pmMetadataSearchFilterSection.searchCriteria.keywords\" max-chars=\"255\"\n												input-id=\"searchTextInput\"></enhanced-textinput>\n						</div>\n					</div>\n				</form>\n			</div>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("package/manager/modals/filter/packagePropertiesSection/package-properties-section-template.html", "<div class=\"row clearfix\" ng-controller=\"PackagePropertiesFilterSectionController as pmPackagePropertiesCtrl\">\n	<div class=\"col-md-12 column\">\n		<div class=\"row\">\n			<div class=\"col-md-12\">\n				<div class=\"prism-form-heading\">Package Properties</div>\n			</div>\n		</div>\n		<div class=\"row spacer-top-xsm padding-bottom-xsm\">\n			<div class=\"col-md-6\">\n				<div class=\"form-group no-margin-bottom\">\n					<label for=\"contentTypeDropdown\" class=\"col-md-4 control-label\">Content Type</label>\n					<div class=\"col-md-8 metadata-control-col\">\n						<dropdown-select id=\"contentTypeDropdown\"\n										 ng-model=\"pmPackagePropertiesCtrl.searchCriteria.contentType\"\n										 clearable=\"true\"\n										 btn-min-width=\"200\"\n										 collection=\"pmPackagePropertiesCtrl.available.contentTypes\">\n						</dropdown-select>\n					</div>\n				</div>\n				<div ng-show=\"pmPackagePropertiesCtrl.searchCriteria.contentType && pmPackagePropertiesCtrl.searchCriteria.contentType !== \'Ad/PreRoll\'\">\n					<div class=\"form-group no-margin-bottom\">\n						<label for=\"networksDropdown\" class=\"col-sm-4 control-label\">Networks</label>\n						<div class=\"col-sm-8 metadata-control-col\">\n							<multiselect-dropdown id=\"networksDropdown\"\n												  ng-model=\"pmPackagePropertiesCtrl.searchCriteria.networks\"\n												  clearable=\"true\"\n												  btn-min-width=\"200\"\n												  btn-max-width=\"300\"\n												  model-prop=\"id\"\n												  label-field=\"name\" collection=\"pmPackagePropertiesCtrl.available.networks\">\n							</multiselect-dropdown>\n						</div>\n					</div>\n					<div class=\"form-group no-margin-bottom\">\n						<label for=\"categoryTypeDropdown\" class=\"col-md-4 control-label\">Category Type</label>\n						<div class=\"col-md-8 metadata-control-col\">\n							<multiselect-dropdown id=\"categoryTypeDropdown\"\n												  ng-model=\"pmPackagePropertiesCtrl.searchCriteria.categoryTypes\"\n												  clearable=\"true\"\n												  btn-min-width=\"200\"\n												  btn-max-width=\"300\"\n												  model-prop=\"id\"\n												  label-field=\"name\" collection=\"pmPackagePropertiesCtrl.available.categoryTypes\">\n							</multiselect-dropdown>\n						</div>\n					</div>\n					<div class=\"form-group no-margin-bottom\">\n						<label for=\"categoryDropdown\" class=\"col-sm-4 control-label\">Category</label>\n						<div class=\"col-sm-8 metadata-control-col\">\n							<multiselect-dropdown id=\"categoryDropdown\"\n												  ng-model=\"pmPackagePropertiesCtrl.searchCriteria.categories\"\n												  clearable=\"true\"\n												  btn-min-width=\"200\"\n												  btn-max-width=\"300\"\n												  model-prop=\"id\"\n												  label-field=\"name\" collection=\"pmPackagePropertiesCtrl.available.categories\">\n							</multiselect-dropdown>\n						</div>\n					</div>\n				</div>\n			</div>\n			<div class=\"col-md-6\" ng-show=\"pmPackagePropertiesCtrl.searchCriteria.contentType\">\n				<div class=\"form-group no-margin-bottom\">\n					<label for=\"contentDropdown\" class=\"col-sm-3 control-label\">{{pmPackagePropertiesCtrl.searchCriteria.contentType}}</label>\n					<div class=\"col-sm-9 metadata-control-col\">\n						<multiselect-dropdown id=\"contentDropdown\"\n											  ng-model=\"pmPackagePropertiesCtrl.searchCriteria.contents\"\n											  clearable=\"true\"\n											  btn-min-width=\"200\"\n											  btn-max-width=\"300\"\n											  label-field=\"name\"\n											  model-prop=\"id\"\n											  ignore-locks=\"true\"\n											  collection=\"pmPackagePropertiesCtrl.available.contents\">\n						</multiselect-dropdown>\n					</div>\n				</div>\n				<div class=\"form-group no-margin-bottom\" ng-show=\"pmPackagePropertiesCtrl.searchCriteria.contentType === \'Series\' && pmPackagePropertiesCtrl.searchCriteria.contents.length\">\n					<label for=\"seasonDropdown\" class=\"col-sm-3 control-label\">Season</label>\n					<div class=\"col-sm-9 metadata-control-col\">\n						<multiselect-dropdown id=\"seasonDropdown\"\n											  ng-model=\"pmPackagePropertiesCtrl.searchCriteria.seasons\"\n											  clearable=\"true\"\n											  btn-min-width=\"200\"\n											  btn-max-width=\"300\"\n											  model-prop=\"id\"\n											  ignore-locks=\"true\"\n											  label-field=\"name\" collection=\"pmPackagePropertiesCtrl.available.seasons\">\n						</multiselect-dropdown>\n					</div>\n				</div>\n				<div class=\"form-group no-margin-bottom\" ng-show=\"pmPackagePropertiesCtrl.searchCriteria.contentType === \'Series\' && pmPackagePropertiesCtrl.searchCriteria.contents.length\">\n					<label for=\"volumeDropdown\" class=\"col-sm-3 control-label\">Volume</label>\n					<div class=\"col-sm-9 metadata-control-col\">\n						<multiselect-dropdown id=\"volumeDropdown\"\n											  ng-model=\"pmPackagePropertiesCtrl.searchCriteria.volumes\"\n											  clearable=\"true\"\n											  btn-min-width=\"200\"\n											  btn-max-width=\"300\"\n											  model-prop=\"id\"\n											  ignore-locks=\"true\"\n											  label-field=\"name\" collection=\"pmPackagePropertiesCtrl.available.volumes\">\n						</multiselect-dropdown>\n					</div>\n				</div>\n				<div class=\"form-group no-margin-bottom\">\n					<label for=\"contentDropdown\" class=\"col-sm-3 control-label\">External Ingest</label>\n					<div class=\"col-sm-9 metadata-control-col\">\n						<multiselect-dropdown id=\"externalIngestDropdown\"\n											  ng-model=\"pmPackagePropertiesCtrl.searchCriteria.externalSystems\"\n											  clearable=\"true\"\n											  btn-min-width=\"200\"\n											  btn-max-width=\"300\"\n											  label-field=\"name\"\n											  model-prop=\"id\"\n											  ignore-locks=\"true\"\n											  collection=\"pmPackagePropertiesCtrl.available.externalSystems\">\n						</multiselect-dropdown>\n					</div>\n				</div>\n			</div>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("system/externalMetadata/setup/editor/renderers/general-template.html", "<div class=\"edit-view-container\">\n\n    <div class=\"row clearfix\">\n        <div class=\"col-md-12 column\">\n            <div class=\"row\">\n                <div class=\"col-md-2\">\n                    <div class=\"prism-form-heading\">General</div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n                <div class=\"form-group\" ng-if=\"$ctrl.externalIngestTypeDisplayText\">\n                    <label for=\"externalIngestTypeDisplayText\" class=\"col-sm-2 control-label\">External Ingest\n                        Type</label>\n                    <div class=\"col-sm-4 pad-text-input-col\">\n                        <span class=\"form-control-static\"\n                              id=\"externalIngestTypeDisplayText\">\n                              {{$ctrl.externalIngestTypeDisplayText}}\n                        </span>\n                    </div>\n                </div>\n                <!-- Enabled -->\n                <div class=\"form-group\">\n                    <label for=\"enabledCheckbox\" class=\"col-sm-2 control-label\">\n                        Enabled\n                    </label>\n                    <div class=\"col-sm-5 partner-nielsen-enabled-cb\">\n                        <input type=\"checkbox\"\n                               id=\"enabledCheckbox\"\n                               ng-model=\"$ctrl.editData.enabled\" />\n                        <label class=\"control-label\"\n                               for=\"enabledCheckbox\"></label>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label for=\"sourceName\" class=\"col-sm-2 control-label\">Name</label>\n                    <div class=\"col-sm-5 pad-text-input-col\">\n                        <input type=\"text\" id=\"sourceName\"\n                               class=\"form-control prism-text-input\"\n                               autocomplete=\"off\"\n                               ng-model=\"$ctrl.editData.name\"/>\n                    </div>\n                    <div class=\"required-text-input\" required x-required-indicator></div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"systemName\" class=\"col-sm-2 control-label\">System Name</label>\n                    <div class=\"col-sm-4 pad-text-input-col\">\n                        <input type=\"text\" id=\"systemName\"\n                               class=\"form-control prism-text-input\"\n                               autocomplete=\"off\"\n                               ng-disabled=\"$ctrl.systemNameLocked\"\n                               ng-model=\"$ctrl.editData.systemName\"/>\n                    </div>\n                    <div class=\"col-sm-1 pad-text-input-col\">\n\n                        <ui-lock id=\"systemNameLock\" ng-if=\"$ctrl.showSystemNamePadLock\"\n                                 is-locked=\"$ctrl.systemNameLocked\"\n                                 click-handler=\"$ctrl.systemNameLocked = !$ctrl.systemNameLocked\">\n                        </ui-lock>\n                        <div>&nbsp;</div>\n                    </div>\n                    <div class=\"required-text-input\" required x-required-indicator></div>\n                </div>\n\n                <!--\n                <div class=\"form-group\">\n                    <label for=\"priority\" class=\"col-sm-2 control-label\">Priority</label>\n                    <div class=\"col-sm-3 pad-text-input-col\">\n                        <input\n                            class=\"form-control prism-text-input\"\n                            id=\"priority\"\n                            ng-model=\"$ctrl.editData.priority\"\n                            pattern=\"\\d*\"\n                            step=\"1\"\n                            type=\"number\"\n                        />\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"ingestsPerMin\" class=\"col-sm-2 control-label\">Maximum Ingests Per Minute</label>\n                    <div class=\"col-sm-3 pad-text-input-col\">\n                        <input\n                            class=\"form-control prism-text-input\"\n                            id=\"ingestsPerMin\"\n                            ng-model=\"$ctrl.editData.ingestsPerMinute\"\n                            pattern=\"\\d*\\.?\\d*\"\n                            type=\"number\"\n                        />\n                    </div>\n                </div>\n                -->\n\n                <div class=\"form-group\">\n                    <label for=\"xslTemplate\" class=\"col-sm-2 control-label\">XSL Template</label>\n                    <div class=\"col-sm-5 pad-text-input-col\">\n                        <dropdown-select id=\"xslTemplate\"\n                                         ng-model=\"$ctrl.editData.xslTemplate\"\n                                         collection=\"$ctrl.xslTemplates\"\n                                         btn-min-width=\"305\"\n                                         prompt=\"Select XSL Template\"\n                                         label-field=\"name\"\n                                         required>\n                        </dropdown-select>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"minimumReleaseDate\" class=\"col-sm-2 control-label\">Minimum Release Date</label>\n                    <div class=\"col-sm-1 pad-text-input-col\">\n                        <date-picker id=\"minimumReleaseDate\"\n                                     ng-model=\"$ctrl.editData.minimumReleaseDate\"\n                                     timezone-offset-millis=\"\'SERVER\'\"></date-picker>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/externalMetadata/setup/editor/renderers/json-feed-template.html", "<div class=\"edit-view-container\">\n    <div class=\"row clearfix\">\n        <div class=\"col-md-12 column\">\n            <div class=\"row\">\n                <div class=\"col-md-2\">\n                    <div class=\"prism-form-heading\">News Feed</div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n                <div class=\"form-group\">\n                    <label for=\"feedUrl\" class=\"col-sm-2 control-label\">Feed URL</label>\n                    <div class=\"col-sm-5 pad-text-input-col\">\n                        <input type=\"text\" id=\"feedUrl\" class=\"form-control prism-text-input\" autocomplete=\"off\"\n                               ng-model=\"$ctrl.editData.feedUrl\"/>\n                    </div>\n                    <div class=\"required-text-input\" required x-required-indicator></div>\n                </div>\n                <div class=\"form-group\">\n                    <label for=\"channelTitle\" class=\"col-sm-2 control-label\">Channel Title</label>\n                    <div class=\"col-sm-5 pad-text-input-col\">\n                        <input type=\"text\" id=\"channelTitle\"\n                               class=\"form-control prism-text-input\"\n                               autocomplete=\"off\"\n                               ng-model=\"$ctrl.editData.channelTitle\"/>\n                    </div>\n                    <div class=\"required-text-input\" required x-required-indicator></div>\n                </div>\n                <div class=\"form-group\">\n                    <label for=\"pollInterval\" class=\"col-sm-2 control-label\">Refresh Interval (minutes)</label>\n                    <div class=\"col-sm-5 pad-text-input-col\">\n                        <input type=\"text\" id=\"pollInterval\" class=\"form-control prism-text-input\" autocomplete=\"off\"\n                               ng-model=\"$ctrl.editData.pollInterval\"/>\n                    </div>\n                    <div class=\"required-text-input\" required x-required-indicator></div>\n                </div>\n                <div class=\"form-group\">\n                    <label for=\"videoXPath\" class=\"col-sm-2 control-label\">Video XPath</label>\n                    <div class=\"col-sm-5 pad-text-input-col\">\n                        <input type=\"text\" id=\"videoXPath\" class=\"form-control prism-text-input\" autocomplete=\"off\"\n                               ng-model=\"$ctrl.editData.videoXPath\"/>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label for=\"imageXPath\" class=\"col-sm-2 control-label\">Image XPath</label>\n                    <div class=\"col-sm-5 pad-text-input-col\">\n                        <input type=\"text\" id=\"imageXPath\" class=\"form-control prism-text-input\" autocomplete=\"off\"\n                               ng-model=\"$ctrl.editData.imageXPath\"/>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label for=\"closedCaptioningXPath\" class=\"col-sm-2 control-label\">CC XPath</label>\n                    <div class=\"col-sm-5 pad-text-input-col\">\n                        <input type=\"text\" id=\"closedCaptioningXPath\" class=\"form-control prism-text-input\"\n                               autocomplete=\"off\"\n                               ng-model=\"$ctrl.editData.closedCaptioningXPath\"/>\n                    </div>\n                </div>\n                <div class=\"form-group v-align\">\n                    <label for=\"ccaMacCaptionTemplate\"\n                           class=\"col-sm-2 control-label\">\n                        CCA MacCaption Template\n                    </label>\n                    <div class=\"col-sm-10 pad-text-input-col\">\n                        <dropdown-select id=\"ccaMacCaptionTemplate\"\n                                         ng-model=\"$ctrl.editData.ccaMacCaptionTemplate\"\n                                         label-field=\"name\"\n                                         prompt=\"Select CCA MacCaption Template\" btn-min-width=\"500\" clearable=\"true\"\n                                         collection=\"$ctrl.macCaptionTemplates\">\n                        </dropdown-select>\n                    </div>\n                </div>\n                <div class=\"form-group v-align\">\n                    <label for=\"sccMacCaptionTemplate\"\n                           class=\"col-sm-2 control-label\">\n                        SCC MacCaption Template\n                    </label>\n                    <div class=\"col-sm-10 pad-text-input-col\">\n                        <dropdown-select id=\"sccMacCaptionTemplate\"\n                                         ng-model=\"$ctrl.editData.sccMacCaptionTemplate\"\n                                         label-field=\"name\"\n                                         prompt=\"Select SCC MacCaption Template\" btn-min-width=\"500\" clearable=\"true\"\n                                         collection=\"$ctrl.macCaptionTemplates\">\n                        </dropdown-select>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label for=\"noCaptionsFallback\" class=\"col-sm-2 control-label\">No Captions Fallback</label>\n                    <div class=\"col-sm-5 pad-text-input-col\">\n                        <enhanced-textarea ng-model=\"$ctrl.editData.noCaptionsFallback\"\n                                           input-rows=\"10\"\n                                           id=\"noCaptionsFallback\"\n                                           input-id=\"noCaptionsFallback\">\n                        </enhanced-textarea>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n");
        $templateCache.put("system/externalMetadata/setup/editor/renderers/watch-folder-template.html", "<div class=\"edit-view-container\">\n    <div class=\"row clearfix\">\n        <div class=\"col-md-12 column\">\n            <div class=\"row\">\n                <div class=\"col-md-2\">\n                    <div class=\"prism-form-heading\">Watch Folder</div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n\n                <div class=\"form-group\">\n                    <label for=\"watchFolderPath\" class=\"col-sm-2 control-label\">Watch Folder</label>\n                    <div class=\"col-sm-5 pad-text-input-col\">\n                        <input type=\"text\" id=\"watchFolderPath\" class=\"form-control prism-text-input\" autocomplete=\"off\"\n                               ng-model=\"$ctrl.editData.watchFolderPath\"/>\n                    </div>\n                    <div class=\"required-text-input\" required x-required-indicator></div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"manifestRequiredCheckbox\" class=\"col-sm-2 control-label\">\n                        Manifest Inventory ID Required\n                    </label>\n                    <div class=\"col-sm-5 partner-nielsen-enabled-cb\">\n                        <input type=\"checkbox\"\n                               id=\"manifestRequiredCheckbox\"\n                               ng-model=\"$ctrl.editData.manifestInventoryIdRequired\" />\n                        <label\n                               for=\"manifestRequiredCheckbox\"></label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n");
        $templateCache.put("system/externalMetadata/setup/editor/sourceCollaborators/source-collaborators-template.html", "<div class=\"edit-view-container\">\n    <div class=\"row clearfix\">\n        <div class=\"col-md-12 column\">\n            <div class=\"row\">\n                <div class=\"col-md-2\">\n                    <div class=\"prism-form-heading\">Email Notifications</div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n                <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n                    <div class=\"form-group\">\n                        <label class=\"control-label col-md-2\">Email Contacts</label>\n                        <div class=\"col-sm-7 pad-text-input-col\">\n                            <button id=\"addToGroup\"\n                                    type=\"button\"\n                                    class=\"btn btn-default prism-button\"\n                                    uib-tooltip=\"Add a email contact\"\n                                    data-tooltip-append-to-body=\"true\"\n                                    ng-click=\"$ctrl.addContact()\">\n                                <i class=\"fa fa-plus\"></i>\n                            </button>\n                            <button id=\"removeFromSelectedGroups\"\n                                    type=\"button\"\n                                    class=\"btn btn-default prism-button\"\n                                    uib-tooltip=\"Remove an email contact\"\n                                    data-tooltip-append-to-body=\"true\"\n                                    ng-disabled=\"!$ctrl.gridApi.selection.getSelectedRows().length\"\n                                    ng-click=\"$ctrl.removeSelectedContacts()\">\n                                <i class=\"fa fa-minus\"></i>\n                            </button>\n                            <br>\n                            <br>\n                            <div id=\"userGroupsGrid\"\n                                 class=\"inline-edit-grid grid search-grid\"\n                                 ui-grid=\"$ctrl.gridOptions\"\n                                 ui-grid-selection\n                                 ui-grid-pagination\n                                 style=\"max-height: 305px;\"\n                                 ui-grid-resize-columns>\n                            </div>\n                        </div>\n                    </div>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n\n");
        $templateCache.put("system/fileSystem/editView/directory/editView/directory-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n\n    <!-- Navigation/search toolbar -->\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <!-- Main -->\n    <div class=\"row-no-padding\">\n        <!-- Sidebar -->\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <!-- Content pane -->\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n            <div class=\"row-no-padding\">\n\n                <!-- Pacifier -->\n                <div class=\"loadingIndicator\">\n                    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                         ng-show=\"$ctrl.loadingIndicator.show\"></div>\n                </div>\n\n                <!-- Breadcrumb -->\n                <breadcrumb tab-name=\"$ctrl.directoryObject.name || \'Edit Directory\'\"></breadcrumb>\n\n                <div class=\"edit-full-height-no-tabs edit-view\">\n                    <form class=\"form-horizontal\"\n                          role=\"form\"\n                          name=\"$ctrl.editorForm\">\n                        <div class=\"edit-view-container\">\n                            <div>\n                                <div class=\"prism-form-heading\">\n                                    General\n                                </div>\n\n                                <!-- Name -->\n                                <div class=\"form-group\">\n                                    <label for=\"name\" class=\"col-sm-2 control-label\">\n                                        Unique Directory Name\n                                    </label>\n                                    <div class=\"col-sm-4 pad-text-input-col\">\n                                        <input id=\"name\"\n                                               class=\"prism-text-input input-sm\"\n                                               ng-model=\"$ctrl.directoryObject.name\"\n                                               required/>\n                                    </div>\n                                    <div class=\"required-text-input\"\n                                         required\n                                         x-required-indicator>\n                                    </div>\n                                </div>\n\n                                <!-- Description -->\n                                <div class=\"form-group\">\n                                    <label for=\"description\" class=\"col-sm-2 control-label\">\n                                        Description\n                                    </label>\n                                    <div class=\"col-sm-9 pad-text-input-col\">\n                                        <input id=\"description\"\n                                               class=\"prism-text-input input-sm\"\n                                               ng-model=\"$ctrl.directoryObject.description\"/>\n                                    </div>\n                                </div>\n\n                                <!-- Path -->\n                                <div class=\"form-group\">\n                                    <label for=\"path\" class=\"col-sm-2 control-label\">\n                                        Path\n                                    </label>\n                                    <div class=\"col-sm-6 pad-text-input-col\">\n                                        <input id=\"path\"\n                                               class=\"prism-text-input input-sm\"\n                                               ng-model=\"$ctrl.directoryObject.path\"\n                                               required/>\n                                        <field-validation ng-if=\"$ctrl.pathRequirements\"\n                                                          header=\"Path Requirements:\"\n                                                          requirements=\"$ctrl.pathRequirements\">\n                                        </field-validation>\n                                    </div>\n                                    <div class=\"required-text-input\"\n                                         required\n                                         x-required-indicator>\n                                    </div>\n                                </div>\n\n                                <!-- Read -->\n                                <div class=\"form-group\">\n                                    <label for=\"canRead\" class=\"col-sm-2 control-label\">\n                                        Can Read\n                                    </label>\n\n                                    <div class=\"col-sm-2 pad-text-input-col\">\n                                        <input id=\"canRead\"\n                                               type=\"checkbox\"\n                                               class=\"prism-text-input input-sm\"\n                                               ng-model=\"$ctrl.directoryObject.defaultPermissionRead\"/>\n                                        <label for=\"canRead\"></label>\n                                    </div>\n                                </div>\n\n                                <!-- Write -->\n                                <div class=\"form-group\">\n                                    <label for=\"canWrite\" class=\"col-sm-2 control-label\">\n                                        Can Write\n                                    </label>\n\n                                    <div class=\"col-sm-2 pad-text-input-col\">\n                                        <input id=\"canWrite\"\n                                               type=\"checkbox\"\n                                               class=\"prism-text-input input-sm\"\n                                               ng-model=\"$ctrl.directoryObject.defaultPermissionWrite\"/>\n                                        <label for=\"canWrite\"></label>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </div>\n\n            <!-- Toolbar -->\n            <div class=\"row-no-padding manager-toolbar\">\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\">\n                </toolbar>\n            </div>\n        </div>\n    </div>\n\n</div>\n");
        $templateCache.put("system/fileSystem/editView/directory/searchView/directory-search-view-template.html", "<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\">\n    </div>\n</div>\n\n<div class=\"row-no-padding\">\n    <div class=\"col-md-12 col-lg-12 no-padding\">\n        <div id=\"directoriesGrid\"\n             class=\"edit-grid search-grid\"\n             ui-grid=\"$ctrl.gridOptions\"\n             ui-grid-selection>\n        </div>\n    </div>\n</div>\n\n<toolbar button-defs=\"$ctrl.toolbarButtonDefs\">\n</toolbar>\n");
        $templateCache.put("system/templates/mediaAcceptProfiles/editView/renderers/clipextraction-mezzanine-type-tooltip-template.html", "<form role=\"form\" class=\"form-horizontal\">\n    <div class=\"edit-view-container\">\n        <div class=\"form-group preview-tooltip wrap-tooltip-labels\" ng-class=\"{\'medium\': tooltipData == \'FFmpeg\'}\">\n\n            <!-- Vantage -->\n            <div class=\"row-no-padding\" ng-if=\"tooltipData == \'Vantage\'\">\n                <label class=\"control-label\">Vantage-Specific Fields</label>\n            </div>\n            <div ng-if=\"tooltipData == \'Vantage\'\">\n                (none)\n            </div>\n\n            <!-- FFmpeg -->\n            <div class=\"row-no-padding\" ng-if=\"tooltipData == \'FFmpeg\'\">\n                <label class=\"control-label\">FFmpeg-Specific Fields</label>\n            </div>\n            <div ng-if=\"tooltipData == \'FFmpeg\'\">\n                <conversion-template-dropdown\n                    id=\"ccExtractTemplate\"\n                    collection=\"$ctrl.mediaConversionTemplates\"\n                    ng-model=\"$ctrl.mapObject.ccExtractTemplate\"\n                    prompt-width=\"4\"\n                    type-prompt=\"CC Video Extract Template Type\"\n                    template-prompt-suffix=\"CC Video Extract Template\"\n                ></conversion-template-dropdown>\n\n                <conversion-template-dropdown\n                    id=\"liveClipHLSConcatTemplate\"\n                    collection=\"$ctrl.mediaConversionTemplates\"\n                    ng-model=\"$ctrl.mapObject.liveClipHLSConcatTemplate\"\n                    prompt-width=\"4\"\n                    type-prompt=\"Clipping HLS Concat Template Type\"\n                    template-prompt-suffix=\"Live Clipping HLS Concat Template\"\n                ></conversion-template-dropdown>\n\n                <conversion-template-dropdown\n                    id=\"liveClipIntermediateTemplate\"\n                    collection=\"$ctrl.mediaConversionTemplates\"\n                    ng-model=\"$ctrl.mapObject.liveClipIntermediateTemplate\"\n                    prompt-width=\"4\"\n                    type-prompt=\"Clipping Intermediate Video Transcoder\"\n                    template-prompt-suffix=\"Clipping Intermediate Video Template\"\n                ></conversion-template-dropdown>\n\n                <div class=\"form-group\">\n                    <label for=\"liveClipsCCDelay\" class=\"col-sm-4 control-label\">\n                        Clipping Timed Text FFmpeg Delay\n                    </label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <enhanced-textinput id=\"liveClipsCCDelay\"\n                                            model-prop=\"$ctrl.mapObject.liveClipsCCDelay\"\n                                            max-chars=\"4000\"\n                                            input-id=\"nielsenAssetName\"\n                                            ng-keydown=\"$ctrl.numericFieldKeyDown($event, $ctrl.mapObject.liveClipsCCDelay)\">\n                        </enhanced-textinput>\n                    </div>\n                </div>\n            </div>\n\n            <!-- Hybrik -->\n            <div class=\"row-no-padding\" ng-if=\"tooltipData == \'Hybrik\'\">\n                <label class=\"control-label\">Hybrik-Specific Fields</label>\n            </div>\n            <div ng-if=\"tooltipData == \'Hybrik\'\">\n                (none)\n            </div>\n\n            <!-- MediaConvert -->\n            <div class=\"row-no-padding\" ng-if=\"tooltipData == \'MediaConvert\'\">\n                <label class=\"control-label\">MediaConvert-Specific Fields</label>\n            </div>\n            <div ng-if=\"tooltipData == \'MediaConvert\'\">\n                (none)\n            </div>\n\n            <!-- Passthrough -->\n            <div class=\"row-no-padding\" ng-if=\"tooltipData == \'Passthrough\'\">\n                <label class=\"control-label\">Passthrough-Specific Fields</label>\n            </div>\n            <div ng-if=\"tooltipData == \'Passthrough\'\">\n                (none)\n            </div>\n        </div>\n    </div>\n</form>\n<br>\n");
        $templateCache.put("system/templates/mediaAcceptProfiles/editView/renderers/media-accept-profiles-editview-ccextraction-tab-template.html", "<div id=\"mediaAcceptProfileEditViewCcExtractionTab\">\n    <fieldset>\n        <div class=\"edit-full-height edit-view\">\n            <div class=\"edit-view-container\">\n\n                <div class=\"row\">\n                    <div class=\"col-md-4\">\n                        <div class=\"prism-form-heading\">\n                            CC Extraction\n                        </div>\n                    </div>\n                </div>\n\n                <conversion-template-dropdown\n                    id=\"timedTextExtractWorkflow\"\n                    collection=\"$ctrl.mediaConversionTemplates\"\n                    ng-model=\"$ctrl.mapObject.vantageTimedTextExtractWorkflow\"\n                    prompt-width=\"4\"\n                    type-prompt=\"Timed Text Extract Workflow Type\"\n                    template-prompt-suffix=\"Template\"\n                ></conversion-template-dropdown>\n\n                <div class=\"form-group v-align\">\n                    <label for=\"macCaptionTimedTextToCCATemplate\"\n                           class=\"col-md-4 control-label padding-bottom-sm\">\n                        Timed Text to CCA Template\n                    </label>\n                    <div class=\"col-md-8\">\n                        <dropdown-select id=\"macCaptionTimedTextToCCATemplate\"\n                                         ng-model=\"$ctrl.mapObject.macCaptionTimedTextToCCATemplate\"\n                                         label-field=\"name\"\n                                         prompt=\"Select Template\" btn-min-width=\"200\" clearable=\"true\"\n                                         collection=\"$ctrl.macCaptionTemplates\">\n                        </dropdown-select>\n                    </div>\n                </div>\n\n                <div class=\"form-group v-align\">\n                    <label for=\"macCaptionTimedTextToSCCTemplate\"\n                           class=\"col-md-4 control-label padding-bottom-sm\">\n                        Timed Text to SCC Template\n                    </label>\n                    <div class=\"col-md-8\">\n                        <dropdown-select id=\"macCaptionTimedTextToSCCTemplate\"\n                                         ng-model=\"$ctrl.mapObject.macCaptionTimedTextToSCCTemplate\"\n                                         label-field=\"name\"\n                                         prompt=\"Select Template\" btn-min-width=\"200\" clearable=\"true\"\n                                         collection=\"$ctrl.macCaptionTemplates\">\n                        </dropdown-select>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"noCaptionsFallbackSCC\" class=\"col-sm-4 control-label\">\n                        No Captions Fallback SCC\n                    </label>\n                    <div class=\"col-sm-7 pad-text-input-col\">\n						<textarea id=\"noCaptionsFallbackSCC\" class=\"form-control prism-text-input\" rows=\"4\"\n                                  ng-model=\"$ctrl.mapObject.noCaptionsFallbackSCC\"></textarea>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <toolbar\n            button-defs=\"$ctrl.toolbarButtonDefs\">\n        </toolbar>\n    </fieldset>\n</div>\n");
        $templateCache.put("system/templates/mediaAcceptProfiles/editView/renderers/media-accept-profiles-editview-clipextraction-tab-template.html", "<div id=\"mediaAcceptProfileEditViewClipExtractionTab\">\n    <fieldset>\n        <div class=\"edit-full-height edit-view\">\n            <div class=\"edit-view-container\">\n\n                <div class=\"row\">\n                    <div class=\"col-md-4\">\n                        <div class=\"prism-form-heading\">\n                            Clip Extraction\n                        </div>\n                    </div>\n                </div>\n\n                <conversion-template-dropdown\n                    id=\"clipMezzanineTemplate\"\n                    ng-model=\"$ctrl.mapObject.videoExtractTemplate\"\n                    default-template-type=\"\'FFmpeg\'\"\n                    collection=\"$ctrl.mediaConversionTemplates\"\n                    force-type-required=\"true\"\n                    ng-required=\"$ctrl.isClipMezzanineTemplateRequired()\"\n                    prompt-width=\"4\"\n                    type-prompt=\"Clip Mezzanine Transcoder\"\n                    template-prompt-suffix=\"Video Extract Template\"\n                    type-tooltip-template=\"$ctrl.clipMezzanineTypeTooltip\"\n                    type-tooltip-class=\"preview-tooltip\"\n                    on-type-change=\"$ctrl.onClipMezzanineTypeChanged(type)\"\n                >\n                </conversion-template-dropdown>\n\n                <div ng-if=\"$ctrl.clipMezzanineType === \'FFmpeg\'\">\n                    <conversion-template-dropdown\n                        id=\"ccExtractTemplate\"\n                        collection=\"$ctrl.mediaConversionTemplates\"\n                        ng-model=\"$ctrl.mapObject.ccExtractTemplate\"\n                        prompt-width=\"4\"\n                        type-prompt=\"CC Video Extract Template Type\"\n                        template-prompt-suffix=\"CC Video Extract Template\"\n                    ></conversion-template-dropdown>\n\n                    <conversion-template-dropdown\n                        id=\"liveClipHLSConcatTemplate\"\n                        collection=\"$ctrl.mediaConversionTemplates\"\n                        ng-model=\"$ctrl.mapObject.liveClipHLSConcatTemplate\"\n                        prompt-width=\"4\"\n                        type-prompt=\"Clipping HLS Concat Template Type\"\n                        template-prompt-suffix=\"Live Clipping HLS Concat Template\"\n                    ></conversion-template-dropdown>\n\n                    <conversion-template-dropdown\n                        id=\"liveClipIntermediateTemplate\"\n                        collection=\"$ctrl.mediaConversionTemplates\"\n                        ng-model=\"$ctrl.mapObject.liveClipIntermediateTemplate\"\n                        prompt-width=\"4\"\n                        type-prompt=\"Clipping Intermediate Video Transcoder\"\n                        template-prompt-suffix=\"Clipping Intermediate Video Template\"\n                    ></conversion-template-dropdown>\n\n                    <div class=\"form-group\">\n                        <label for=\"liveClipsCCDelay\" class=\"col-sm-4 control-label\">\n                            Clipping Timed Text FFmpeg Delay\n                        </label>\n                        <div class=\"col-sm-6 pad-text-input-col\">\n                            <enhanced-textinput id=\"liveClipsCCDelay\"\n                                                model-prop=\"$ctrl.mapObject.liveClipsCCDelay\"\n                                                max-chars=\"4000\"\n                                                input-id=\"nielsenAssetName\"\n                                                ng-keydown=\"$ctrl.numericFieldKeyDown($event, $ctrl.mapObject.liveClipsCCDelay)\">\n                            </enhanced-textinput>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"form-group v-align\">\n                    <label for=\"clipAcceptProfile\"\n                           class=\"col-md-4 control-label padding-bottom-sm\">\n                        Clip Accept Profile\n                    </label>\n                    <div class=\"col-md-8\">\n                        <dropdown-select id=\"clipAcceptProfile\"\n                                         ng-model=\"$ctrl.mapObject.clipAcceptProfile\"\n                                         label-field=\"name\"\n                                         prompt=\"Select Template\" btn-min-width=\"200\" clearable=\"true\"\n                                         collection=\"$ctrl.videoAcceptProfiles\">\n                        </dropdown-select>\n                    </div>\n                </div>\n\n                <div class=\"form-group v-align\">\n                    <label for=\"macCaptionClipCCAExtractTemplate\"\n                           class=\"col-md-4 control-label padding-bottom-sm\">\n                        Clip CCA Extract Template\n                    </label>\n                    <div class=\"col-md-8\">\n                        <dropdown-select id=\"macCaptionClipCCAExtractTemplate\"\n                                         ng-model=\"$ctrl.mapObject.macCaptionClipCCAExtractTemplate\"\n                                         label-field=\"name\"\n                                         prompt=\"Select Template\" btn-min-width=\"200\" clearable=\"true\"\n                                         collection=\"$ctrl.macCaptionTemplates\">\n                        </dropdown-select>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <toolbar\n            button-defs=\"$ctrl.toolbarButtonDefs\">\n        </toolbar>\n    </fieldset>\n</div>\n");
        $templateCache.put("system/templates/mediaAcceptProfiles/editView/renderers/media-accept-profiles-editview-intermediates-tab-template.html", "<div id=\"mediaAcceptProfileEditViewIntermediatesTab\">\n    <fieldset>\n        <div class=\"edit-full-height edit-view\">\n            <div class=\"edit-view-container\">\n\n                <div class=\"row\">\n                    <div class=\"col-md-4\">\n                        <div class=\"prism-form-heading\">\n                            Master Video To P2P\n                        </div>\n                    </div>\n                </div>\n\n                <conversion-template-dropdown\n                    id=\"masterVideoP2P\"\n                    collection=\"$ctrl.mediaConversionTemplates\"\n                    ng-model=\"$ctrl.mapObject.videoMasterP2PWorkflow\"\n                    prompt-width=\"3\"\n                    type-prompt=\"Transcoder\"\n                    template-prompt-suffix=\"Template\"\n                ></conversion-template-dropdown>\n\n                <div class=\"form-group v-align\">\n                    <label for=\"masterRemoveAdPods\" class=\"col-sm-3 control-label padding-bottom-sm\">Master Video to P2P Remove Ad Pods</label>\n                    <div class=\"col-sm-8\">\n                        <div class=\"col-sm-1 no-padding\">\n                            <input type=\"checkbox\"\n                                   id=\"masterRemoveAdPods\"\n                                   ng-model=\"$ctrl.mapObject.videoMasterP2PRemoveAdPods\"/>\n                            <label for=\"masterRemoveAdPods\"></label>\n                        </div>\n                        <div class=\"col-sm-10 no-padding-left\">\n                            <small class=\"col-sm-12 base-label\"><em>\n                                * Applies to drop-frame timecodes & subtitles only.\n                            </em></small>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"edit-view-container top-margin-md\">\n\n                <div class=\"row\">\n                    <div class=\"col-md-4\">\n                        <div class=\"prism-form-heading\">\n                            Component Master\n                        </div>\n                    </div>\n                </div>\n\n                <conversion-template-dropdown\n                    id=\"componentMasterTemplate\"\n                    collection=\"$ctrl.mediaConversionTemplates\"\n                    ng-model=\"$ctrl.mapObject.videoComponentMasterWorkflow\"\n                    prompt-width=\"3\"\n                    type-prompt=\"Transcoder\"\n                    template-prompt-suffix=\"Template\"\n                ></conversion-template-dropdown>\n            </div>\n\n            <div class=\"edit-view-container top-margin-md\">\n\n                <div class=\"row\">\n                    <div class=\"col-md-4\">\n                        <div class=\"prism-form-heading\">\n                            Alpha Channel Output\n                        </div>\n                    </div>\n                </div>\n\n                <conversion-template-dropdown\n                    id=\"componentMasterAlpha\"\n                    collection=\"$ctrl.mediaConversionTemplates\"\n                    ng-model=\"$ctrl.mapObject.videoComponentMasterAlphaWorkflow\"\n                    prompt-width=\"3\"\n                    type-prompt=\"Transcoder\"\n                    template-prompt-suffix=\"Template\"\n                ></conversion-template-dropdown>\n            </div>\n\n            <div class=\"edit-view-container top-margin-md\">\n\n                <div class=\"row\">\n                    <div class=\"col-md-4\">\n                        <div class=\"prism-form-heading\">\n                        </div>\n                        Rating Overlay\n                    </div>\n                </div>\n\n                <conversion-template-dropdown\n                    id=\"ratingOverlay\"\n                    collection=\"$ctrl.mediaConversionTemplates\"\n                    ng-model=\"$ctrl.mapObject.videoRatingOverlayWorkflow\"\n                    prompt-width=\"3\"\n                    type-prompt=\"Transcoder\"\n                    template-prompt-suffix=\"Template\"\n                ></conversion-template-dropdown>\n            </div>\n\n            <div class=\"edit-view-container top-margin-md\">\n\n                <div class=\"row\">\n                    <div class=\"col-md-4\">\n                        <div class=\"prism-form-heading\">\n                            Shared Nielson Template\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"form-group v-align\">\n                    <label for=\"sharedNielsenEnabled\" class=\"col-sm-3 control-label padding-bottom-sm\">Shared\n                        Nielsen Enabled</label>\n                    <div class=\"col-sm-1\">\n                        <input type=\"checkbox\"\n                               id=\"sharedNielsenEnabled\"\n                               ng-model=\"$ctrl.mapObject.nielsenData.enabledFlag\"/>\n                        <label for=\"sharedNielsenEnabled\"></label>\n                    </div>\n                </div>\n\n                <fieldset ng-disabled=\"!$ctrl.mapObject.nielsenData.enabledFlag\">\n                    <conversion-template-dropdown\n                        id=\"nielsenTemplate\"\n                        collection=\"$ctrl.mediaConversionTemplates\"\n                        default-template-type=\"\'Vantage\'\"\n                        ng-model=\"$ctrl.mapObject.nielsenVantageWorkflow\"\n                        prompt-width=\"3\"\n                        type-prompt=\"Nielsen Template Type\"\n                        template-prompt-prefix=\"Nielson\"\n                        template-prompt-suffix=\"Template\"\n                    ></conversion-template-dropdown>\n\n                    <div class=\"form-group\">\n                        <label for=\"nielsenAssetId\" class=\"col-sm-3 control-label\">Asset ID</label>\n                        <div class=\"col-sm-6 pad-text-input-col\">\n                            <enhanced-textinput model-prop=\"$ctrl.mapObject.nielsenData.nielsenAssetId\"\n                                                max-chars=\"4000\"\n                                                input-id=\"nielsenAssetId\">\n                            </enhanced-textinput>\n                        </div>\n                    </div>\n\n                    <div class=\"form-group\">\n                        <label for=\"nielsenAssetName\" class=\"col-sm-3 control-label\">Asset Name</label>\n                        <div class=\"col-sm-6 pad-text-input-col\">\n                            <enhanced-textinput model-prop=\"$ctrl.mapObject.nielsenData.nielsenAssetName\"\n                                                max-chars=\"4000\"\n                                                input-id=\"nielsenAssetName\">\n                            </enhanced-textinput>\n                        </div>\n                    </div>\n\n                    <div class=\"form-group\">\n                        <label for=\"nielsenDsrcId\" class=\"col-sm-3 control-label\">DSRC ID</label>\n                        <div class=\"col-sm-6 pad-text-input-col\">\n                            <enhanced-textinput model-prop=\"$ctrl.mapObject.nielsenData.nielsenDsrcId\"\n                                                max-chars=\"4000\"\n                                                input-id=\"nielsenDsrcId\">\n                            </enhanced-textinput>\n                        </div>\n                    </div>\n\n                    <div class=\"form-group\">\n                        <label for=\"nielsenDsrcName\" class=\"col-sm-3 control-label\">DSRC Name</label>\n                        <div class=\"col-sm-6 pad-text-input-col\">\n                            <enhanced-textinput model-prop=\"$ctrl.mapObject.nielsenData.nielsenDsrcName\"\n                                                max-chars=\"4000\"\n                                                input-id=\"nielsenDsrcName\">\n                            </enhanced-textinput>\n                        </div>\n                    </div>\n\n                    <div class=\"form-group\">\n                        <label for=\"nielsenEpisodeId\" class=\"col-sm-3 control-label\">Episode ID</label>\n                        <div class=\"col-sm-6 pad-text-input-col\">\n                            <enhanced-textinput model-prop=\"$ctrl.mapObject.nielsenData.nielsenEpisodeId\"\n                                                max-chars=\"4000\"\n                                                input-id=\"nielsenEpisodeId\">\n                            </enhanced-textinput>\n                        </div>\n                    </div>\n\n                    <div class=\"form-group\">\n                        <label for=\"nielsenSId\" class=\"col-sm-3 control-label\">SID</label>\n                        <div class=\"col-sm-6 pad-text-input-col\">\n                            <enhanced-textinput model-prop=\"$ctrl.mapObject.nielsenData.nielsenSId\"\n                                                max-chars=\"4000\"\n                                                input-id=\"nielsenSId\">\n                            </enhanced-textinput>\n                        </div>\n                    </div>\n                </fieldset>\n            </div>\n        </div>\n\n        <toolbar\n            button-defs=\"$ctrl.toolbarButtonDefs\">\n        </toolbar>\n    </fieldset>\n</div>\n");
        $templateCache.put("system/templates/mediaAcceptProfiles/editView/renderers/media-accept-profiles-editview-properties-tab-template.html", "<div id=\"mediaAcceptProfileEditViewPropertiesTab\">\n    <fieldset>\n        <div class=\"edit-full-height edit-view\">\n            <div class=\"edit-view-container\">\n\n                <div class=\"row\">\n                    <div class=\"col-md-4\">\n                        <div class=\"prism-form-heading\">\n                            Properties\n                        </div>\n                    </div>\n                </div>\n\n                <!-- Name -->\n                <div class=\"form-group\">\n                    <label for=\"acceptProfileName\"\n                           class=\"col-sm-3 control-label\">\n                        Name\n                    </label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <enhanced-textinput\n                            model-prop=\"$ctrl.mapObject.name\"\n                            max-chars=\"4000\"\n                            input-id=\"acceptProfileName\">\n                        </enhanced-textinput>\n                    </div>\n                    <div class=\"required-text-input\"\n                         required\n                         x-required-indicator></div>\n                </div>\n\n                <!-- Type -->\n                <fieldset ng-disabled=\"true\">\n                    <div class=\"form-group\">\n                        <label for=\"acceptProfileType\"\n                               class=\"col-sm-3 control-label\">\n                            Type\n                        </label>\n                        <div class=\"col-sm-6 pad-text-input-col\">\n                            <input type=\"text\"\n                                   class=\"form-control prism-text-input\"\n                                   ng-disabled=\"true\"\n                                   id=\"acceptProfileType\"\n                                   autocomplete=\"off\"\n                                   value=\"{{($ctrl.mapObject.type === \'OTHER\') ? \'ARTWORK\' : $ctrl.mapObject.type}}\"/>\n                        </div>\n                    </div>\n                </fieldset>\n\n                <!-- Repository -->\n                <div class=\"form-group v-align\">\n                    <label for=\"acceptProfileRepository\"\n                           class=\"col-md-3 control-label padding-bottom-sm\">Repository</label>\n                    <div class=\"col-md-8\">\n                        <dropdown-select\n                            id=\"acceptProfileRepository\"\n                            ng-model=\"$ctrl.mapObject.assetRepositoryRoot\"\n                            prompt=\"Select Repository\"\n                            btn-min-width=\"200\"\n                            clearable=\"true\"\n                            label-field=\"rootKey\"\n                            collection=\"$ctrl.repositoryRoots\">\n                        </dropdown-select>\n                    </div>\n                </div>\n\n                <!-- Convertible-type Fields -->\n                <div ng-if=\"$ctrl.mapObject.type === \'VIDEO\' || $ctrl.mapObject.type === \'AUDIO\'\">\n\n                    <!-- Proxy Template Dropdowns -->\n                    <conversion-template-dropdown\n                        id=\"proxyTemplate\"\n                        ng-model=\"$ctrl.mapObject.proxyTemplate\"\n                        collection=\"$ctrl.mediaConversionTemplates\"\n                        required\n                        prompt-width=\"3\"\n                        type-prompt=\"Proxy Template Type\"\n                        template-prompt-suffix=\"Template\"\n                    >\n                    </conversion-template-dropdown>\n                </div>\n\n                <!-- Video-Specific Fields -->\n                <div ng-if=\"$ctrl.mapObject.type === \'VIDEO\'\">\n\n                    <!-- Video Master Type -->\n                    <div class=\"form-group v-align\">\n                        <label for=\"videoMasterType\"\n                               class=\"col-md-3 control-label padding-bottom-sm\">\n                            Video Master Type\n                        </label>\n                        <div class=\"col-md-8\">\n                            <dropdown-select\n                                id=\"videoMasterType\"\n                                ng-model=\"$ctrl.mapObject.videoMasterType\"\n                                label-field=\"displayName\"\n                                prompt=\"Select Type\"\n                                btn-min-width=\"200\"\n                                clearable=\"true\"\n                                collection=\"$ctrl.availableVideoMasterTypes\">\n                            </dropdown-select>\n                        </div>\n                    </div>\n\n                    <!-- Is HDR Video -->\n                    <div class=\"form-group v-align\">\n                        <label for=\"hdr\"\n                               class=\"col-sm-3 control-label padding-bottom-sm\">\n                            HDR\n                        </label>\n                        <div class=\"col-sm-1\">\n                            <input type=\"checkbox\"\n                                   id=\"hdr\"\n                                   ng-model=\"$ctrl.mapObject.hdrVideoFlag\"/>\n                            <label for=\"hdr\"></label>\n                        </div>\n                    </div>\n\n                    <!-- Automatically Extract CC -->\n                    <div class=\"form-group v-align\">\n                        <label for=\"autoExtractCC\"\n                               class=\"col-sm-3 control-label padding-bottom-sm\">\n                            Automatically Extract CC\n                        </label>\n                        <div class=\"col-sm-1\">\n                            <input type=\"checkbox\"\n                                   id=\"autoExtractCC\"\n                                   ng-model=\"$ctrl.mapObject.extractClosedCaptioning\"/>\n                            <label for=\"autoExtractCC\"></label>\n                        </div>\n                    </div>\n\n                    <!-- Minimum Caption Duration -->\n                    <div class=\"form-group\">\n                        <label for=\"minCaptionDuration\"\n                               class=\"col-sm-3 control-label\">\n                            Minimum Caption Duration\n                        </label>\n                        <div class=\"col-sm-6 pad-text-input-col\">\n                            <enhanced-textinput\n                                model-prop=\"$ctrl.mapObject.minimumCaptionDuration\"\n                                max-chars=\"4000\"\n                                input-id=\"minCaptionDuration\"\n                                ng-keydown=\"$ctrl.numericFieldKeyDown($event, $ctrl.mapObject.minCaptionDuration)\">\n                            </enhanced-textinput>\n                        </div>\n                    </div>\n\n                    <!-- Minimum Caption Duration Error Flag -->\n                    <div class=\"form-group v-align\">\n                        <label for=\"minimumCaptionResult\"\n                               class=\"col-md-3 control-label padding-bottom-sm\">\n                            Minimum Caption Result\n                        </label>\n                        <div class=\"col-md-8\">\n                            <dropdown-select\n                                btn-min-width=\"200\"\n                                collection=\"$ctrl.minimumCaptionResultOptions\"\n                                id=\"minimumCaptionResult\"\n                                on-change=\"$ctrl.onMinimumCaptionResultChanged()\"\n                                ng-model=\"$ctrl.minimumCaptionResult\">\n                            </dropdown-select>\n                        </div>\n                    </div>\n\n                    <!-- Proxy SCC Injection Template -->\n                    <div class=\"form-group v-align\">\n                        <label for=\"proxySccInjectTemplate\"\n                               class=\"col-md-3 control-label padding-bottom-sm\">\n                            Proxy SCC Injection Template\n                        </label>\n                        <div class=\"col-md-8\">\n                            <dropdown-select id=\"proxySccInjectTemplate\"\n                                             ng-model=\"$ctrl.mapObject.macCaptionProxyEmbedTemplate\"\n                                             label-field=\"name\"\n                                             prompt=\"Select Template\"\n                                             btn-min-width=\"200\"\n                                             clearable=\"true\"\n                                             collection=\"$ctrl.macCaptionTemplates\">\n                            </dropdown-select>\n                        </div>\n                    </div>\n\n                </div>\n            </div>\n\n            <br/>\n\n        </div>\n\n        <!-- Toolbar -->\n        <toolbar\n            button-defs=\"$ctrl.toolbarButtonDefs\">\n        </toolbar>\n    </fieldset>\n</div>\n");
        $templateCache.put("system/templates/mediaAcceptProfiles/editView/renderers/media-accept-profiles-editview-proxyplayer-tab-template.html", "<div id=\"mediaAcceptProfileEditViewProxyPlayerTab\">\n    <fieldset>\n        <div class=\"edit-full-height edit-view\">\n            <div class=\"edit-view-container\">\n\n                <div class=\"row\">\n                    <div class=\"col-md-4\">\n                        <div class=\"prism-form-heading\">\n                            Proxy Player\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"form-group v-align\">\n                    <label for=\"macCaptionProxyTemplate\" class=\"col-md-3 control-label padding-bottom-sm\">Flash Proxy\n                        Player Template</label>\n                    <div class=\"col-md-8\">\n                        <dropdown-select id=\"macCaptionProxyTemplate\"\n                                         ng-model=\"$ctrl.mapObject.macCaptionProxyTemplate\"\n                                         label-field=\"name\"\n                                         prompt=\"Select Template\" btn-min-width=\"200\" clearable=\"true\"\n                                         collection=\"$ctrl.macCaptionTemplates\">\n                        </dropdown-select>\n                    </div>\n                </div>\n\n                <div class=\"form-group v-align\">\n                    <label for=\"macCaptionCCAToVTTTemplate\" class=\"col-md-3 control-label padding-bottom-sm\">CCA to VTT\n                        Template</label>\n                    <div class=\"col-md-8\">\n                        <dropdown-select id=\"macCaptionCCAToVTTTemplate\"\n                                         ng-model=\"$ctrl.mapObject.macCaptionCCAToVTTTemplate\"\n                                         label-field=\"name\"\n                                         prompt=\"Select Template\" btn-min-width=\"200\" clearable=\"true\"\n                                         collection=\"$ctrl.macCaptionTemplates\">\n                        </dropdown-select>\n                    </div>\n                </div>\n\n                <div class=\"form-group v-align\">\n                    <label for=\"macCaptionSCCToVTTTemplate\" class=\"col-md-3 control-label padding-bottom-sm\">SCC to VTT\n                        Template</label>\n                    <div class=\"col-md-8\">\n                        <dropdown-select id=\"macCaptionSCCToVTTTemplate\"\n                                         ng-model=\"$ctrl.mapObject.macCaptionSCCToVTTTemplate\"\n                                         label-field=\"name\"\n                                         prompt=\"Select Template\" btn-min-width=\"200\" clearable=\"true\"\n                                         collection=\"$ctrl.macCaptionTemplates\">\n                        </dropdown-select>\n                    </div>\n                </div>\n\n                <div class=\"form-group v-align\">\n                    <label for=\"macCaptionSCCExtractTemplate\" class=\"col-md-3 control-label padding-bottom-sm\">SCC\n                        Extract Template</label>\n                    <div class=\"col-md-8\">\n                        <dropdown-select id=\"macCaptionSCCExtractTemplate\"\n                                         ng-model=\"$ctrl.mapObject.macCaptionSCCExtractTemplate\"\n                                         label-field=\"name\"\n                                         prompt=\"Select Template\" btn-min-width=\"200\" clearable=\"true\"\n                                         collection=\"$ctrl.macCaptionTemplates\">\n                        </dropdown-select>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <toolbar\n            button-defs=\"$ctrl.toolbarButtonDefs\">\n        </toolbar>\n    </fieldset>\n</div>\n");
        $templateCache.put("system/templates/mediaAcceptProfiles/editView/renderers/media-accept-profiles-editview-sharedvideo-tab-template.html", "<div id=\"mediaAcceptProfileEditViewSharedVideoTab\">\n    <fieldset>\n        <div class=\"edit-full-height edit-view\">\n            <div class=\"edit-view-container\">\n\n                <div class=\"row\">\n                    <div class=\"col-md-4\">\n                        <div class=\"prism-form-heading\">\n                            Shared Partner Video\n                        </div>\n                    </div>\n                </div>\n\n                <conversion-template-dropdown\n                    id=\"mediaConversionTemplate\"\n                    collection=\"$ctrl.mediaConversionTemplates\"\n                    ng-model=\"$ctrl.mapObject.sharedVideoDeliveryItem.mediaConversionTemplate\"\n                    prompt-width=\"3\"\n                    type-prompt=\"Transcoder\"\n                    template-prompt-suffix=\"Template\"\n                ></conversion-template-dropdown>\n\n                <div class=\"form-group\">\n                    <label for=\"namingScheme\"\n                           class=\"col-md-3 control-label padding-bottom-sm\">\n                        Naming Scheme\n                    </label>\n                    <div class=\"col-sm-7 pad-text-input-col\">\n                        <enhanced-textarea ng-model=\"$ctrl.mapObject.sharedVideoDeliveryItem.filenameExpression\"\n                                           input-rows=\"3\"\n                                           input-id=\"namingScheme\">\n                        </enhanced-textarea>\n                    </div>\n                    <div class=\"col-sm-1 error-warning error-warning-text-area-3\">\n                        <error-warning-indicator\n                                error-warning=\"$ctrl.pkgEditCtrl.checkErrorWarning(\'desc1\', $ctrl.packageObject.name)\">\n                        </error-warning-indicator>\n                    </div>\n                    <div class=\"required-text-area-3\"\n                         required\n                         x-required-indicator>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"edit-view-container top-margin-md\">\n\n                <div class=\"row\">\n                    <div class=\"col-md-4\">\n                        <div class=\"prism-form-heading\">\n                            Post Delivery Processing\n                        </div>\n                    </div>\n                </div>\n\n                <conversion-template-dropdown\n                    id=\"postDeliveryProxyTemplate\"\n                    collection=\"$ctrl.mediaConversionTemplates\"\n                    ng-model=\"$ctrl.mapObject.sharedVideoDeliveryItem.postDeliveryProxyTemplate\"\n                    prompt-width=\"3\"\n                    type-prompt=\"Post Delivery Proxy Transcoder\"\n                    template-prompt-prefix=\"Post Delivery \"\n                    template-prompt-suffix=\"Proxy Template\"\n                ></conversion-template-dropdown>\n\n                <conversion-template-dropdown\n                    id=\"postDeliveryQCTemplate\"\n                    collection=\"$ctrl.mediaConversionTemplates\"\n                    ng-model=\"$ctrl.mapObject.sharedVideoDeliveryItem.postDeliveryQCTemplate\"\n                    prompt-width=\"3\"\n                    type-prompt=\"Post QC Report Workflow Type\"\n                    template-prompt-prefix=\"Post\"\n                    template-prompt-suffix=\"QC Report Workflow\"\n                ></conversion-template-dropdown>\n\n                <div class=\"form-group\">\n                    <label for=\"postDeliveryProxyBurnInText\" class=\"col-md-3 control-label padding-bottom-sm\">\n                        Proxy Burn-in Text Expression\n                    </label>\n\n                    <div class=\"col-sm-7 pad-text-input-col\">\n                        <textarea id=\"postDeliveryProxyBurnInText\"\n                                  class=\"form-control prism-text-input\"\n                                  rows=\"4\"\n                                  ng-model=\"$ctrl.mapObject.sharedVideoDeliveryItem.postDeliveryProxyBurnInText\">\n                        </textarea>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <toolbar\n            button-defs=\"$ctrl.toolbarButtonDefs\">\n        </toolbar>\n    </fieldset>\n</div>\n");
        $templateCache.put("system/templates/mediaAcceptProfiles/editView/renderers/media-accept-profiles-editview-video-tab-template.html", "<div id=\"mediaAcceptProfileEditViewVideoTab\">\n    <fieldset>\n        <div class=\"edit-full-height edit-view\">\n            <div class=\"edit-view-container\">\n                <div class=\"form-group\">\n                    <label for=\"trackNumber\" class=\"control-label col-md-3\">Track Number</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <input type=\"text\" class=\"prism-text-input\"\n                               ng-model=\"$ctrl.mapObject.generalValidator.trackNumber\"\n                               name=\"trackNumber\"\n                               id=\"trackNumber\"/>\n                    </div>\n                    <div class=\"required-text-input\" required\n                         x-required-indicator></div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"fileName\" class=\"control-label col-md-3\">File Name</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <input type=\"text\" class=\"prism-text-input\"\n                               ng-model=\"$ctrl.mapObject.generalValidator.fileName\"\n                               name=\"fileName\"\n                               id=\"fileName\"/>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"fileExtension\" class=\"control-label col-md-3\">File Extensions</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <input type=\"text\" class=\"prism-text-input\"\n                               ng-model=\"$ctrl.mapObject.generalValidator.fileExtension\"\n                               name=\"fileExtension\"\n                               id=\"fileExtension\"/>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"format\" class=\"control-label col-md-3\">Format</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <input type=\"text\" class=\"prism-text-input\"\n                               ng-model=\"$ctrl.mapObject.generalValidator.format\"\n                               name=\"format\"\n                               id=\"format\"/>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"duration\" class=\"control-label col-md-3\">Duration</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <input type=\"text\" class=\"prism-text-input\"\n                               ng-model=\"$ctrl.mapObject.generalValidator.duration\"\n                               name=\"duration\"\n                               id=\"duration\"/>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"audioCount\" class=\"control-label col-md-3\">Audio Count</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <input type=\"text\" class=\"prism-text-input\"\n                               ng-model=\"$ctrl.mapObject.generalValidator.audioCount\"\n                               name=\"audioCount\"\n                               id=\"audioCount\"/>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"chapterCount\" class=\"control-label col-md-3\">Chapter Count</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <input type=\"text\" class=\"prism-text-input\"\n                               ng-model=\"$ctrl.mapObject.generalValidator.chapterCount\"\n                               name=\"chapterCount\"\n                               id=\"chapterCount\"/>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"videoCount\" class=\"control-label col-md-3\">Video Count</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <input type=\"text\" class=\"prism-text-input\"\n                               ng-model=\"$ctrl.mapObject.generalValidator.videoCount\"\n                               name=\"videoCount\"\n                               id=\"videoCount\"/>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"imageCount\" class=\"control-label col-md-3\">Image Count</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <input type=\"text\" class=\"prism-text-input\"\n                               ng-model=\"$ctrl.mapObject.generalValidator.imageCount\"\n                               name=\"imageCount\"\n                               id=\"imageCount\"/>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"textCount\" class=\"control-label col-md-3\">Text Count</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <input type=\"text\" class=\"prism-text-input\"\n                               ng-model=\"$ctrl.mapObject.generalValidator.textCount\"\n                               name=\"textCount\"\n                               id=\"textCount\"/>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"overallBitRate\" class=\"control-label col-md-3\">Overall Bit Rate</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <input type=\"text\" class=\"prism-text-input\"\n                               ng-model=\"$ctrl.mapObject.generalValidator.overallBitRate\"\n                               name=\"overallBitRate\"\n                               id=\"overallBitRate\"/>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <toolbar\n            button-defs=\"$ctrl.toolbarButtonDefs\">\n        </toolbar>\n    </fieldset>\n</div>\n");
        $templateCache.put("system/templates/mediaAcceptProfiles/searchView/renderers/accept-profile-tooltip-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\"\n	 data-tooltip-append-to-body=\"true\"\n	 uib-tooltip=\"{{(COL_FIELD === \'OTHER\') ? \'ARTWORK\' : COL_FIELD}}\"\n	 ng-dblclick=\"grid.appScope.$ctrl.rowDoubleClick(row, column)\">\n	<span class=\"padding-left-sm\">{{(COL_FIELD === \'OTHER\') ? \'ARTWORK\' : COL_FIELD}}</span>\n</div>\n");
        $templateCache.put("system/templates/packageAcceptTemplates/editView/mediaAcceptProfileMembers/media-accept-profile-member-template.html", "<form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n\n    <label class=\"control-label col-md-2\">{{$ctrl.mediaAcceptProfileType}}</label>\n    <div class=\"col-sm-6 pad-text-input-col\">\n        <button id=\"launchMediaAcceptProfileSelectionModalButton\"\n                type=\"button\"\n                class=\"btn btn-default prism-button\"\n                uib-tooltip=\"Create new MediaAcceptProfile MediaAcceptProfilees\"\n                data-tooltip-append-to-body=\"true\"\n                ng-click=\"$ctrl.addMediaProfileHandler()\">\n            <i class=\"fa fa-plus\"></i>\n        </button>\n        <button id=\"deleteSelectedMediaAcceptProfileMediaAcceptProfileesButton\"\n                type=\"button\"\n                class=\"btn btn-default prism-button\"\n                uib-tooltip=\"Remove mediaAcceptProfile(es)\"\n                data-tooltip-append-to-body=\"true\"\n                ng-disabled=\"!$ctrl.gridApi.selection.getSelectedRows().length\"\n                ng-click=\"$ctrl.removeMediaAcceptProfile()\">\n            <i class=\"fa fa-minus\"></i>\n        </button>\n        <br>\n        <br>\n        <div id=\"someGrid\"\n             class=\"inline-edit-grid grid search-grid\"\n             ui-grid=\"$ctrl.gridOptions\"\n             ui-grid-selection\n             ui-grid-edit\n             style=\"max-height: 305px;\"\n             ui-grid-resize-columns>\n        </div>\n    </div>\n</form>\n");
        $templateCache.put("system/templates/transformTemplate/editor/renderers/transform-template-fields-template.html", "<div class=\"edit-view-container\">\n    <div class=\"row clearfix\">\n        <div class=\"col-md-12 column\">\n            <div class=\"row\">\n                <div class=\"col-md-2\">\n                    <div class=\"prism-form-heading\">General</div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n                <div class=\"form-group\">\n                    <label for=\"transformTemplateName\" class=\"col-sm-2 control-label\">Name</label>\n                    <div class=\"col-sm-4 pad-text-input-col\">\n                        <input type=\"text\"\n                               id=\"transformTemplateName\"\n                               class=\"form-control prism-text-input\"\n                               autocomplete=\"off\"\n                               ng-model=\"$ctrl.editData.name\"\n                               required/>\n                    </div>\n                    <div class=\"required-text-input\"\n                         required\n                         x-required-indicator></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<hr/>\n\n<div class=\"edit-view-container\">\n    <div class=\"row clearfix\">\n        <div class=\"col-md-12 column\">\n            <div class=\"row\">\n                <div class=\"col-md-2\">\n                    <div class=\"prism-form-heading\">Template</div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n                <div class=\"form-group\">\n                    <div class=\"col-sm-10 pad-text-input-col col-md-offset-1\">\n                        <enhanced-textarea ng-model=\"$ctrl.editData.xslText\" input-rows=\"27\"\n                                           input-id=\"templateEditorField\" monospace=\"true\" >\n                        </enhanced-textarea>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("components/branding/editView/components/media/editView/branding-media-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n\n    <!-- Navigation/search toolbar -->\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <!-- Main -->\n    <div class=\"row-no-padding\">\n        <!-- Sidebar -->\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <!-- Content pane -->\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n            <breadcrumb tab-name=\"$ctrl.breadcrumbName\"></breadcrumb>\n\n            <!-- Pacifier -->\n            <div class=\"loadingIndicator\">\n                <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                     ng-show=\"$ctrl.loadingIndicator.show\"></div>\n            </div>\n\n            <div class=\"edit-full-height-no-tabs edit-view\">\n                <fieldset ng-disabled=\"!$ctrl.canWriteMedia\">\n                    <form class=\"form-horizontal\"\n                          role=\"form\"\n                          name=\"$ctrl.editorForm\"\n                          ng-show=\"$ctrl.brandingAssetContainer\">\n\n                        <branding-media-edit-view-break-pre-post-roll\n                            ng-if=\"$ctrl.brandingConfig.type === \'breakPrePostRolls\'\"\n                            break-pre-post-roll=\"$ctrl.rootAsset\"\n                            available-languages=\"$ctrl.availableLanguages\"\n                            available-territories=\"$ctrl.availableTerritories\"\n                            available-audio-accept-profiles=\"$ctrl.availableAudioAcceptProfiles\"\n                            available-audio-roles=\"$ctrl.availableAudioRoles\"\n                            available-text-roles=\"$ctrl.availableTextRoles\">\n                        </branding-media-edit-view-break-pre-post-roll>\n\n                        <branding-media-edit-view-asset\n                             ng-if=\"$ctrl.brandingConfig.type === \'preRolls\' || $ctrl.brandingConfig.type === \'postRolls\'\"\n                             section-name=\"Video\"\n                             container-type=\"{{$ctrl.brandingConfig.type}}\"\n                             asset-type=\"video\"\n                             root-asset=\"$ctrl.rootAsset\"\n                             asset=\"$ctrl.rootAsset\">\n                        </branding-media-edit-view-asset>\n\n                        <branding-media-edit-view-asset-list\n                            ng-if=\"$ctrl.brandingConfig.type === \'preRolls\' || $ctrl.brandingConfig.type === \'postRolls\'\"\n                            section-name=\"Closed Captioning\"\n                            container-type=\"{{$ctrl.brandingConfig.type}}\"\n                            asset-type=\"cc\"\n                            root-asset=\"$ctrl.rootAsset\"\n                            asset-list=\"$ctrl.rootAsset.texts\"\n                            prompt-accept-profile=\"false\"\n                            available-languages=\"$ctrl.availableLanguages\"\n                            available-roles=\"$ctrl.availableTextRoles\"\n                            add-asset=\"$ctrl.addText\"\n                            remove-asset=\"$ctrl.removeText\">\n                        </branding-media-edit-view-asset-list>\n\n                        <branding-media-edit-view-asset-list\n                            ng-if=\"$ctrl.brandingConfig.type === \'preRolls\' || $ctrl.brandingConfig.type === \'postRolls\'\"\n                            section-name=\"Audio\"\n                            container-type=\"{{$ctrl.brandingConfig.type}}\"\n                            asset-type=\"audio\"\n                            root-asset=\"$ctrl.rootAsset\"\n                            asset-list=\"$ctrl.rootAsset.audios\"\n                            prompt-accept-profile=\"true\"\n                            available-accept-profiles=\"$ctrl.availableAudioAcceptProfiles\"\n                            available-languages=\"$ctrl.availableLanguages\"\n                            available-roles=\"$ctrl.availableAudioRoles\"\n                            add-asset=\"$ctrl.addAudio\"\n                            remove-asset=\"$ctrl.removeAudio\">\n                        </branding-media-edit-view-asset-list>\n\n                        <branding-media-edit-view-asset\n                            ng-if=\"$ctrl.brandingConfig.type === \'watermarks\'\"\n                            section-name=\"Watermark\"\n                            container-type=\"{{$ctrl.brandingConfig.type}}\"\n                            asset-type=\"watermark\"\n                            root-asset=\"$ctrl.rootAsset\"\n                            asset=\"$ctrl.rootAsset\"\n                            available-accept-profiles=\"$ctrl.availableImageAcceptProfiles\">\n                        </branding-media-edit-view-asset>\n\n                        <branding-media-edit-view-asset-list\n                            ng-if=\"$ctrl.brandingConfig.type === \'artwork\'\"\n                            section-name=\"Artwork\"\n                            container-type=\"{{$ctrl.brandingConfig.type}}\"\n                            asset-type=\"artwork\"\n                            root-asset=\"$ctrl.rootAsset\"\n                            asset-list=\"$ctrl.rootAsset.assets\"\n                            prompt-accept-profile=\"false\"\n                            available-accept-profiles=\"$ctrl.availableArtworkAcceptProfiles\"\n                            available-languages=\"$ctrl.availableArtworkLanguages\"\n                            available-territories=\"$ctrl.availableTerritories\"\n                            add-asset=\"$ctrl.addArtwork\"\n                            remove-asset=\"$ctrl.removeArtwork\">\n                        </branding-media-edit-view-asset-list>\n\n                        <branding-media-edit-view-asset-list\n                            ng-if=\"$ctrl.brandingConfig.type === \'ratingOverlays\'\"\n                            section-name=\"Rating Overlay Images\"\n                            container-type=\"{{$ctrl.brandingConfig.type}}\"\n                            asset-type=\"ratingOverlay\"\n                            root-asset=\"$ctrl.rootAsset\"\n                            asset-list=\"$ctrl.rootAsset.images\"\n                            prompt-accept-profile=\"false\"\n                            available-accept-profiles=\"$ctrl.availableImageAcceptProfiles\"\n                            available-rating-systems=\"$ctrl.availableRatingSystems\"\n                            selected-rating-systems=\"$ctrl.selectedRatingSystems\"\n                            add-asset=\"$ctrl.addOverlayImage\"\n                            remove-asset=\"$ctrl.removeOverlayImage\">\n                        </branding-media-edit-view-asset-list>\n                    </form>\n                </fieldset>\n\n            </div>\n\n            <!-- Toolbar -->\n            <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"></toolbar>\n        </div>\n    </div>\n\n</div>\n");
        $templateCache.put("components/branding/editView/components/searchGrid/cellTemplates/asset-info-cell-template.html", "<div class=\"ui-grid-cell-contents branding-asset-info-cell ng-scope ng-binding\">\n    <div id=\"{{col.colDef.field + \'AssetPreview\' + $index}}\"\n       class=\"fa play-icon\"\n       ng-if=\"COL_FIELD && grid.appScope.$ctrl.assetHasPreview(row.entity, col.colDef.field)\">\n        <span class=\"fa-stack\">\n            <a ng-click=\"grid.appScope.$ctrl.openAssetPreviewModal(row.entity, col.colDef.field)\">\n                <i class=\"fa fa-circle-thin fa-stack-1x\"></i>\n                <i class=\"fa fa-play fa-stack-1x\"></i>\n            </a>\n        </span>\n    </div>\n    <span>{{COL_FIELD | fileNameFromPath}}</span>\n    <a id=\"{{col.colDef.field + \'AssetInfo\' + $index}}\"\n       class=\"fa fa-info-circle fa-2x prism-into-button\"\n       ng-if=\"COL_FIELD && grid.appScope.$ctrl.assetHasInfo(row.entity, col.colDef.field)\"\n       ng-click=\"grid.appScope.$ctrl.openAssetInfoModal(row.entity, col.colDef.field)\">\n    </a>\n</div>\n");
        $templateCache.put("components/branding/editView/components/searchGrid/cellTemplates/break-prepostroll-cell-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\">\n    <span>{{grid.appScope.$ctrl.getPreRollField(row, col)}}</span>\n    <span ng-if=\"grid.appScope.$ctrl.hasEitherPrePostRollField(row, col)\"> | </span>\n    <span>{{grid.appScope.$ctrl.getPostRollField(row, col)}}</span>\n</div>\n");
        $templateCache.put("dashboard/packageCheckin/components/modals/checkinResultModal/gridTemplates/result-cell-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\"\n     data-tooltip-append-to-body=\"true\"\n     uib-tooltip=\"{{COL_FIELD CUSTOM_FILTERS}}\">\n\n    <!--\n        ngClass logic for \"Spreadsheet Name\" column\n\n        (Spreadsheet Name)\n           (Import Error #1)\n           (Import Error #2)\n    -->\n\n    <span ng-class=\"\n    		{\'tree-level-1\' : row.entity.top,\n    		 \'tree-level-2\' : !row.entity.top}\">\n        {{COL_FIELD CUSTOM_FILTERS}}\n	</span>\n</div>\n");
        $templateCache.put("dashboard/workflows/searchView/modals/filter/packagePropertiesSection/package-properties-section-template.html", "<div class=\"row clearfix\" ng-controller=\"PackagePropertiesFilterSectionController as workflowsPackagePropertiesCtrl\">\n	<div class=\"col-md-12 column\">\n		<div class=\"row\">\n			<div class=\"col-md-12\">\n				<div class=\"prism-form-heading\">Package Properties</div>\n			</div>\n		</div>\n		<div class=\"row spacer-top-xsm padding-bottom-xsm\">\n			<div class=\"col-md-6\">\n				<div class=\"form-group no-margin-bottom\">\n					<label for=\"contentTypeDropdown\" class=\"col-md-3 control-label\">Content Type</label>\n					<div class=\"col-md-9 metadata-control-col\">\n						<dropdown-select id=\"contentTypeDropdown\"\n										 ng-model=\"workflowsPackagePropertiesCtrl.searchCriteria.contentType\"\n										 clearable=\"true\"\n										 btn-min-width=\"350\"\n										 prompt=\"Select Content Type\"\n										 collection=\"workflowsPackagePropertiesCtrl.available.contentTypes\">\n						</dropdown-select>\n					</div>\n				</div>\n				<div class=\"form-group no-margin-bottom\"\n					 ng-if=\"workflowsPackagePropertiesCtrl.searchCriteria.contentType && workflowsPackagePropertiesCtrl.searchCriteria.contentType !== \'Ad/PreRoll\'\">\n					<label for=\"networksDropdown\" class=\"col-sm-3 control-label\">Networks</label>\n					<div class=\"col-sm-9 metadata-control-col\">\n						<multiselect-dropdown id=\"networksDropdown\"\n											  ng-model=\"workflowsPackagePropertiesCtrl.searchCriteria.networks\"\n											  clearable=\"true\"\n											  btn-min-width=\"350\"\n											  model-prop=\"id\"\n											  label-field=\"name\"\n											  collection=\"workflowsPackagePropertiesCtrl.available.networks\">\n						</multiselect-dropdown>\n					</div>\n				</div>\n				<div class=\"form-group no-margin-bottom\">\n					<label for=\"submitterDropdown\" class=\"col-md-3 control-label\">Submitter</label>\n					<div class=\"col-md-9 metadata-control-col\">\n                        <multiselect-dropdown id=\"submitterDropdown\"\n                                              ng-disabled=\"!workflowsPackagePropertiesCtrl.available.submitters\"\n                                              ng-model=\"workflowsPackagePropertiesCtrl.searchCriteria.submitters\"\n                                              clearable=\"true\"\n                                              btn-min-width=\"350\"\n                                              label-function=\"workflowsPackagePropertiesCtrl.submitterDropdownLabelFxn\"\n                                              label-field=\"username\"\n                                              collection=\"workflowsPackagePropertiesCtrl.available.submitters\"\n                                              collection-sort-property=\"\'firstName\'\">\n                        </multiselect-dropdown>\n					</div>\n				</div>\n			</div>\n			<div class=\"col-md-6\" ng-show=\"workflowsPackagePropertiesCtrl.searchCriteria.contentType\">\n				<div class=\"form-group no-margin-bottom\"\n					 ng-show=\"workflowsPackagePropertiesCtrl.searchCriteria.contentType && workflowsPackagePropertiesCtrl.searchCriteria.contentType !== \'Ad/PreRoll\'\">\n					<label for=\"categoryTypeDropdown\" class=\"col-md-3 control-label\">Category Type</label>\n					<div class=\"col-md-9 metadata-control-col\">\n						<multiselect-dropdown id=\"categoryTypeDropdown\"\n											  ng-model=\"workflowsPackagePropertiesCtrl.searchCriteria.categoryTypes\"\n											  clearable=\"true\"\n											  btn-min-width=\"350\"\n											  model-prop=\"id\"\n											  label-field=\"name\"\n											  collection=\"workflowsPackagePropertiesCtrl.available.categoryTypes\">\n						</multiselect-dropdown>\n					</div>\n				</div>\n				<div class=\"form-group no-margin-bottom\"\n					 ng-show=\"workflowsPackagePropertiesCtrl.searchCriteria.contentType && workflowsPackagePropertiesCtrl.searchCriteria.contentType !== \'Ad/PreRoll\'\">\n					<label for=\"categoryDropdown\" class=\"col-sm-3 control-label\">Category</label>\n					<div class=\"col-sm-9 metadata-control-col\">\n						<multiselect-dropdown id=\"categoryDropdown\"\n											  ng-model=\"workflowsPackagePropertiesCtrl.searchCriteria.categories\"\n											  clearable=\"true\"\n											  btn-min-width=\"350\"\n											  model-prop=\"id\"\n											  label-field=\"name\"\n											  collection=\"workflowsPackagePropertiesCtrl.available.categories\">\n						</multiselect-dropdown>\n					</div>\n				</div>\n				<div class=\"form-group no-margin-bottom\">\n					<label for=\"contentDropdown\" class=\"col-sm-3 control-label\">{{workflowsPackagePropertiesCtrl.searchCriteria.contentType}}</label>\n					<div class=\"col-sm-9 metadata-control-col\">\n						<multiselect-dropdown id=\"contentDropdown\"\n											  ng-model=\"workflowsPackagePropertiesCtrl.searchCriteria.contents\"\n											  clearable=\"true\"\n                                              btn-min-width=\"350\"\n                                              label-field=\"name\"\n											  model-prop=\"id\"\n											  ignore-locks=\"true\"\n											  collection=\"workflowsPackagePropertiesCtrl.available.contents\">\n						</multiselect-dropdown>\n					</div>\n				</div>\n			</div>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("dashboard/workflows/searchView/modals/filter/datePropertiesSection/date-properties-section-template.html", "<div class=\"row clearfix\" ng-controller=\"WorkflowsDatePropertiesSectionController as workflowsDatePropertiesCtrl\">\n	<div class=\"col-md-12\">\n		<div class=\"row\">\n			<div class=\"col-md-12\">\n				<div class=\"prism-form-heading\">Date Properties</div>\n			</div>\n		</div>\n		<div class=\"row spacer-top-xsm\">\n			<div>\n				<input type=\"radio\" name=\"dateRadios\" id=\"noneFilterDateRadio\" value=\"\" ng-model=\"workflowsDatePropertiesCtrl.selectedDateProperty\"/>\n				<label class=\"col-md-12 control-label\" for=\"noneFilterDateRadio\">\n					None\n				</label>\n			</div>\n		</div>\n		<div class=\"row\">\n			<div class=\"col-md-12\">\n				<div class=\"row padding-top-md\">\n					<input type=\"radio\" name=\"dateRadios\" id=\"lastXDaysRadio\" value=\"lastXDays\" ng-model=\"workflowsDatePropertiesCtrl.selectedDateProperty\"/>\n					<label class=\"col-md-3 control-label\" for=\"lastXDaysRadio\">\n						Created within Last X Days\n					</label>\n					<div class=\"col-md-9\">\n						<input type=\"text\" class=\"prism-text-input\" id=\"lastXDaysTextInput\" ng-model=\"workflowsDatePropertiesCtrl.recentDays\" ng-disabled=\"workflowsDatePropertiesCtrl.selectedDateProperty !== \'lastXDays\'\"/>\n					</div>\n\n				</div>\n\n				<div class=\"row padding-top-md\">\n					<input type=\"radio\" name=\"dateRadios\" id=\"startDateRadio\" value=\"startDate\" ng-model=\"workflowsDatePropertiesCtrl.selectedDateProperty\"/>\n					<label class=\"col-md-3 control-label\" for=\"startDateRadio\">\n						Workflow Start Date\n					</label>\n\n					<fieldset ng-disabled=\"workflowsDatePropertiesCtrl.selectedDateProperty !== \'startDate\'\">\n						<div class=\"col-md-4\">\n							<date-picker ng-model=\"workflowsDatePropertiesCtrl.selectedDateProperties.startDate.fromDate\"></date-picker>\n						</div>\n						<div class=\"col-md-1\">\n							<span class=\"control-label\">to</span>\n						</div>\n						<div class=\"col-md-4\">\n							<date-picker ng-model=\"workflowsDatePropertiesCtrl.selectedDateProperties.startDate.toDate\"></date-picker>\n						</div>\n					</fieldset>\n				</div>\n			</div>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("dashboard/workflows/searchView/modals/filter/workflowsPropertiesSection/workflow-properties-section-template.html", "<div class=\"row clearfix\" ng-controller=\"WorkflowsPropertiesSectionController as workflowsPropertiesCtrl\">\n    <div class=\"col-md-12 column\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"prism-form-heading\">Workflow Properties</div>\n            </div>\n        </div>\n        <div class=\"row spacer-top-xsm padding-bottom-xsm\">\n            <div class=\"col-md-12\">\n                <div class=\"form-group no-margin-bottom\">\n                    <label for=\"workflowsStatusDropdown\" class=\"col-md-3 control-label\">Workflow Status</label>\n                    <div class=\"col-md-9 padding-left-sm\">\n                        <multiselect-dropdown id=\"workflowsStatusDropdown\"\n                                              ng-model=\"workflowsPropertiesCtrl.searchCriteria.statuses\"\n                                              clearable=\"true\"\n                                              btn-min-width=\"210\"\n                                              prompt=\"Select Status\"\n                                              enable-select-all=\"true\"\n                                              label-field=\"displayName\"\n                                              model-prop=\"id\"\n                                              collection=\"workflowsPropertiesCtrl.available.statuses\">\n                        </multiselect-dropdown>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("meta/content/editor/components/view/aggregation/aggregation-tab-template.html", "<fieldset>\n    <div class=\"edit-full-height edit-view\">\n        <form class=\"form-horizontal aggregation-tab\"\n              name=\"$ctrl.editorForm\">\n\n            <div class=\"edit-view-container\">\n                <div class=\"prism-form-heading\">\n                    AGGREGATION\n                </div>\n\n                <!-- System Name -->\n                <div class=\"form-group spacer-top-lg\">\n                    <label for=\"externalSystemNameExpressionInput\"\n                           class=\"col-sm-3 control-label\">System Name</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <span id=\"externalSystemNameExpressionInput\"\n                              class=\"form-control-static\"\n                              ng-model=\"$ctrl.contentObject.name\">\n                            {{$ctrl.contentObject.externalSystem}}\n                        </span>\n                    </div>\n                </div>\n\n                <!-- Aggregation ID -->\n                <div class=\"form-group\">\n                    <label for=\"externalSystemIdExpressionInput\"\n                           class=\"col-sm-3 control-label\">External ID</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <input type=\"text\"\n                               class=\"form-control input-sm prism-text-input\"\n                               autocomplete=\"off\"\n                               ng-model=\"$ctrl.contentObject.externalId\"\n                               ng-change=\"$ctrl.onExternalIdChange()\"\n                               id=\"externalSystemIdExpressionInput\"/>\n                    </div>\n                    <a class=\"fa-stack clear-dropdown\"\n                       ng-click=\"$ctrl.clearExternalId()\"\n                       ng-show=\"$ctrl.contentObject.externalId\"\n                       href=\"\">\n                        <i class=\"fa fa-circle fa-stack-1x\"></i>\n                        <i class=\"fa fa-times fa-stack-1x\"></i>\n                    </a>\n                </div>\n\n            </div>\n\n            <hr/>\n\n            <div class=\"edit-view-container\">\n                <div class=\"prism-form-heading\">AGGREGATION SOURCES</div>\n\n                <!-- Xml Grid -->\n                <div class=\"row spacer-top-lg\">\n                    <div class=\"col-md-12 column\">\n                        <div class=\"grid unsorted-grid externalIngestHistoryGrid\"\n                             ui-grid=\"$ctrl.gridOptions\"\n                             ui-grid-auto-resize>\n                        </div>\n                    </div>\n                </div>\n\n            </div>\n        </form>\n    </div>\n</fieldset>\n\n\n<!-- Toolbar -->\n<toolbar button-defs=\"$ctrl.toolbarButtonDefs\">\n</toolbar>\n");
        $templateCache.put("meta/content/editor/components/view/packageAcceptTemplates/content-package-accept-templates-template.html", "<fieldset>\n    <div class=\"edit-full-height edit-view\">\n        <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n            <div class=\"edit-view-container\">\n                <div class=\"row clearfix\">\n                    <div class=\"row clearfix spacer-top-lg\">\n                        <div class=\"col-md-12 column\">\n                            <div class=\"\">\n                                <form role=\"form\" class=\"form-horizontal\" ng-if=\"$ctrl.editData\">\n                                    <content-package-accept-templates-member-view\n                                            ng-repeat=\"contentPackageAcceptTemplateContainer in $ctrl.editData.contentPackageAcceptTemplateContainers track by $index\"\n                                            content-package-accept-template-container=\"contentPackageAcceptTemplateContainer\"\n                                            package-accept-templates=\"$ctrl.editData.packageAcceptTemplates\"\n                                            validation-types=\"$ctrl.editData.validationTypes\">\n                                    </content-package-accept-templates-member-view>\n                                </form>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </form>\n    </div>\n</fieldset>\n<div class=\"manager-toolbar\">\n    <toolbar button-defs=\"$ctrl.toolbarButtonDefs\" pagination-defs=\"$ctrl.paginationDefs\"></toolbar>\n</div>\n<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\">\n    </div>\n</div>\n\n");
        $templateCache.put("meta/content/editor/components/view/properties/content-properties-view-template.html", "<fieldset>\n    <div class=\"row edit-full-height edit-view\">\n        <div class=\"loadingIndicator\">\n            <div data-lb-progress=\"$ctrl.loadingIndicator\" ng-show=\"$ctrl.loadingIndicator.show\"></div>\n        </div>\n        <form class=\"form-horizontal\" name=\"$ctrl.editorForm\">\n\n            <div>\n                <div class=\"edit-view-container\">\n                    <div ng-if=\"$ctrl.contentObject.type === \'Series\'\"\n                         ng-include=\"\'meta/content/editor/components/view/properties/renderers/content-properties-series-general-template.html\'\">\n                    </div>\n\n                    <div ng-if=\"$ctrl.contentObject.type === \'Movie/Special\'\"\n                         ng-include=\"\'meta/content/editor/components/view/properties/renderers/content-properties-movies-general-template.html\'\">\n                    </div>\n\n                    <div ng-if=\"$ctrl.contentObject.type === \'Ad/PreRoll\'\"\n                         ng-include=\"\'meta/content/editor/components/view/properties/renderers/content-properties-ads-prerolls-general-template.html\'\">\n                    </div>\n                </div>\n\n                <hr/>\n\n                <div ng-if=\"$ctrl.contentObject.type !== \'Ad/PreRoll\'\">\n                    <translatable-metadata\n                        form-title=\"\'LOCALIZATION\'\"\n                        fields=\"$ctrl.translatableMetadataFields\">\n                    </translatable-metadata>\n                </div>\n\n                <hr/>\n\n                <div class=\"edit-view-container\" ng-if=\"$ctrl.canWriteLiveFeeds && $ctrl.contentObject.type !== \'Ad/PreRoll\'\">\n                    <div ng-include=\"\'meta/content/editor/components/view/properties/renderers/content-properties-liveclipping-template.html\'\">\n                    </div>\n                </div>\n\n                <hr/>\n\n                <div class=\"edit-view-container\">\n                    <div class=\"row clearfix\">\n                        <div class=\"col-md-12 column\">\n                            <div class=\"row\">\n                                <div class=\"col-md-2\">\n                                    <div class=\"prism-form-heading\">\n                                        CUSTOM METADATA\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row clearfix spacer-top-lg\">\n                        <div class=\"col-md-12 column\">\n                            <custom-metadata components-map=\"$ctrl.metadataComponentsMap\">\n                            </custom-metadata>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n        </form>\n    </div>\n</fieldset>\n\n<!-- Toolbar -->\n<toolbar button-defs=\"$ctrl.toolbarButtonDefs\">\n</toolbar>\n");
        $templateCache.put("meta/content/editor/components/modals/addContentCategoriesModal/add-content-categories-modal-template.html", "<div class=\"modal-header\">\n    <h5 class=\"modal-title\">Add Content Category</h5>\n</div>\n<div class=\"modal-body\">\n    <form class=\"form-horizontal\"\n          role=\"form\"\n          name=\"addContentCategoriesModalCtrl.modalForm\">\n        <div class-=\"row spacer-top-xsm padding-bottom-xsm\">\n            <div class=\"form-group no-margin-bottom\">\n                <label for=\"contentCategoryTypeSelect\"\n                       class=\"col-md-4 col-md-offset-1 control-label\">Select Category Type</label>\n                <div class=\"col-md-4 metadata-control-col\">\n                    <dropdown-select id=\"contentCategoryTypeSelect\"\n                                     ng-model=\"addContentCategoriesModalCtrl.selectedCategoryType\"\n                                     prompt=\"Select Category Type\"\n                                     btn-min-width=\"200\"\n                                     clearable=\"true\"\n                                     collection=\"addContentCategoriesModalCtrl.categoryTypes\"\n                                     required>\n\n                    </dropdown-select>\n                </div>\n            </div>\n        </div>\n        <div class=\"row spacer-top-xsm padding-bottom-xsm\"\n             ng-if=\"addContentCategoriesModalCtrl.selectedCategoryType\">\n            <div class=\"form-group no-margin-bottom\">\n                <label for=\"contentCategorySelect\"\n                       class=\"col-md-4 col-md-offset-1 control-label\">Select Category</label>\n                <div class=\"col-md-4 metadata-control-col\">\n                    <dropdown-select id=\"contentCategorySelect\"\n                                     label-field=\"name\"\n                                     ng-model=\"addContentCategoriesModalCtrl.selectedCategory\"\n                                     prompt=\"Select Category\"\n                                     btn-min-width=\"200\"\n                                     clearable=\"true\"\n                                     collection=\"addContentCategoriesModalCtrl.catTypeMap[addContentCategoriesModalCtrl.selectedCategoryType]\">\n                    </dropdown-select>\n                </div>\n            </div>\n        </div>\n    </form>\n</div>\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"addContentCategoriesModalCtrl.cancel()\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"addContentCategoriesModalCtrl.onOk()\"\n            ng-disabled=\"addContentCategoriesModalCtrl.disableOKButton()\">\n        OK\n    </button>\n</div>\n");
        $templateCache.put("meta/content/editor/components/modals/addShowLiveFeed/add-showlivefeed-modal-template.html", "<div class=\"modal-header\">\n    <h5 class=\"modal-title\">Add Show Live Feed</h5>\n</div>\n<div class=\"modal-body\">\n    <form class=\"form-horizontal\"\n          role=\"form\"\n          name=\"addShowLiveFeedCtrlr.modalForm\">\n        <div class=\"form-group\">\n            <label for=\"liveFeedSelect\"\n                   class=\"col-sm-6 control-label\">Live Feed</label>\n            <div class=\"col-sm-4 pad-text-input-col\">\n                <dropdown-select id=\"liveFeedSelect\"\n                                 ng-model=\"addShowLiveFeedCtrlr.showLiveFeed.liveFeed\"\n                                 label-field=\"name\"\n                                 collection=\"addShowLiveFeedCtrlr.liveFeeds\"\n                                 prompt=\"Select Feed\"\n                                 btn-min-width=\"170\">\n                </dropdown-select>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label for=\"liveFeedTimezoneOffset\"\n                   class=\"col-sm-6 control-label\">Eastern Timezone Offset (minutes)</label>\n            <div class=\"col-sm-4 pad-text-input-col\">\n                <input type=\"text\"\n                       id=\"liveFeedTimezoneOffset\"\n                       class=\"form-control prism-text-input\"\n                       autocomplete=\"off\"\n                       ng-model=\"addShowLiveFeedCtrlr.showLiveFeed.timezoneOffset\"/>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-6 prism-form-item-label text-align-right\">\n                Default\n            </label>\n            <div class=\"col-sm-4\">\n                <input type=\"checkbox\"\n                       id=\"liveFeedDefaultCB\"\n                       ng-model=\"addShowLiveFeedCtrlr.showLiveFeed.defaultFlag\"\n                       ng-disabled=\"!addShowLiveFeedCtrlr.showLiveFeed.defaultFlag && addShowLiveFeedCtrlr.isDefaultFeedSet()\"/>\n                <label for=\"liveFeedDefaultCB\"></label>\n            </div>\n        </div>\n    </form>\n\n</div>\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"addShowLiveFeedCtrlr.cancel()\">Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"addShowLiveFeedCtrlr.onOk()\"\n            ng-disabled=\"addShowLiveFeedCtrlr.disableOKButton()\">OK\n    </button>\n</div>\n");
        $templateCache.put("meta/content/editor/components/modals/newSubscriptionModal/artwork-cell-template.html", "<div class=\"cell-dropdown-container\">\n    <dropdown-select id=\"artworkSelect{{$index}}\"\n                     attach-to-body=\"false\"\n                     ng-model=\"row.entity.artwork\"\n                     collection=\"grid.appScope.$ctrl.artworks\"\n                     btn-min-width=\"315\"\n                     label-field=\"name\"\n                     prompt=\"Select Artwork\">\n    </dropdown-select>\n</div>\n");
        $templateCache.put("meta/content/editor/components/modals/newSubscriptionModal/new-subscription-modal-template.html", "<div class=\"modal-header\">\n	<h5 class=\"modal-title\">Add New Subscription</h5>\n</div>\n<div class=\"modal-body\">\n	<div class=\"form-horizontal row\">\n		<div class=\"col-md-12 col-md-offset-3 padding-left-md\">\n			<dropdown-select id=\"subscriptionPartnerDropdown\"\n							 prompt=\"Select Partner\"\n							 ng-model=\"$ctrl.selectedPartner\"\n							 collection=\"$ctrl.availablePartners\"\n							 label-field=\"name\"\n                             btn-min-width=\"350\"\n                             max-height=\"350\"\n                             on-change=\"$ctrl.onPartnerSelected()\"\n							 clearable=\"true\"\n                             required>\n			</dropdown-select>\n		</div>\n\n        <div class=\"col-md-12 padding-top-lg form-group\"\n                ng-if=\"$ctrl.selectedPartner && $ctrl.requiredArtworks && $ctrl.requiredArtworks.length >= 1\">\n            <label for=\"requiredArtwork\" class=\"col-sm-3 control-label\">\n                Required Artwork\n            </label>\n            <div class=\"col-md-9 padding-left-md\">\n                <dropdown-select id=\"artworkSelect\"\n                                 ng-model=\"$ctrl.selectedArtwork\"\n                                 collection=\"$ctrl.availableArtworks\"\n                                 btn-min-width=\"315\"\n                                 label-field=\"name\"\n                                 on-change=\"$ctrl.onArtworkSelected()\"\n                                 prompt=\"Select Artwork\">\n                </dropdown-select>\n                <label class=\"prism-checkbox-inline padding-left-md\"\n                       ng-if=\"$ctrl.showMovieSpecialCheckbox\"\n                >\n                    <input type=\"checkbox\" id=\"artworkSVCheckbox\"\n                           ng-model=\"$ctrl.artworkSeasonVolume\"\n                           ng-click=\"$ctrl.onSVCheckboxClicked()\"/>\n                    <label for=\"artworkSVCheckbox\">\n                        S/V Art\n                    </label>\n                </label>\n            </div>\n\n            <div class=\"col-sm-9 col-sm-offset-3\">\n                <div id=\"requiredArtwork\"\n                     class=\"search-grid\"\n                     ui-grid=\"$ctrl.artworkGridOptions\"\n                     ui-grid-auto-resize\n                     style=\"height: 220px;\"></div>\n            </div>\n        </div>\n\n	</div>\n</div>\n<div class=\"modal-footer flex-row-container\">\n	<button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.cancel()\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n	<button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.onOk()\"\n            ng-disabled=\"!$ctrl.isOkEnabled()\">\n        Create\n    </button>\n</div>\n");
        $templateCache.put("package/editor/components/modals/collaborators/addNewCrewCollaboratorModal/add-new-crew-collaborator-modal-template.html", "<div class=\"modal-header\">\n    <div class=\"pull-right\">\n    </div>\n    <h6 class=\"modal-title\">Add Collaborator</h6>\n</div>\n<div class=\"modal-body\">\n    <form role=\"form\"\n          class=\"form-horizontal\"\n          name=\"$ctrl.newCollabEditForm\">\n        <div class=\"form-group\">\n            <label class=\"control-label col-md-3\">Display Name</label>\n            <div class=\"col-md-8 pad-text-input-col\">\n                <input type=\"text\"\n                       class=\"prism-text-input\"\n                       ng-model=\"$ctrl.newCrewCollab.collaborator.displayName\"\n                       ng-change=\"$ctrl.handleDisplayNameChange()\"\n                       id=\"displayNameInput\"/>\n                <label class=\"under-field-hint\">(First Name Last Name)</label>\n            </div>\n            <div class=\"required-text-input\"\n                 required\n                 x-required-indicator></div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"control-label col-md-3\">Sort Name</label>\n            <div class=\"col-md-8 pad-text-input-col\">\n                <input type=\"text\"\n                       class=\"prism-text-input\"\n                       ng-model=\"$ctrl.newCrewCollab.collaborator.sortName\"\n                       id=\"sortNameInput\"/>\n                <label class=\"under-field-hint\">(Last Name, First Name)</label>\n            </div>\n            <div class=\"required-text-input\"\n                 required\n                 x-required-indicator></div>\n        </div>\n        <div class=\"form-group\"\n             ng-if=\"$ctrl.resolve.newActor\">\n            <label for=\"characterName\"\n                   class=\"control-label col-md-3\">\n                Character Name\n            </label>\n            <div class=\"col-md-1\">\n                <input type=\"radio\"\n                       class=\"radio-button\"\n                       id=\"characterIsCharacterRadioButton\"\n                       ng-value=\"false\"\n                       ng-model=\"$ctrl.actorIsSelf\"/>\n                <label for=\"characterIsCharacterRadioButton\"\n                       class=\"control-label\">&#160</label>\n            </div>\n            <div class=\"col-md-7 pad-text-input-col\">\n                <input type=\"text\"\n                       id=\"characterName\"\n                       class=\"form-control prism-text-input input-with-checkbox\"\n                       autocomplete=\"off\"\n                       ng-model=\"$ctrl.newCrewCollab.collaborator.character\"/>\n            </div>\n            <div class=\"required-text-input\"\n                 required\n                 x-required-indicator></div>\n        </div>\n        <div class=\"form-group\"\n             ng-if=\"$ctrl.resolve.newActor\">\n            <span class=\"col-md-offset-3 col-md-1 prism-form-item-label text-align-right\">\n               <input type=\"radio\"\n                      class=\"radio-button\"\n                      id=\"characterIsSelfRadioButton\"\n                      ng-value=\"true\"\n                      ng-model=\"$ctrl.actorIsSelf\"/>\n                <label for=\"characterIsSelfRadioButton\"\n                       class=\"control-label\">&#160</label>\n            </span>\n            <div class=\"col-md-7\">\n                <label for=\"characterIsSelfRadioButton\"\n                       class=\"control-label label-with-checkbox\">Self</label>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"control-label col-md-3\">Nickname</label>\n            <div class=\"col-md-8 pad-text-input-col\">\n                <input type=\"text\"\n                       class=\"prism-text-input\"\n                       ng-model=\"$ctrl.newCrewCollab.collaborator.nickname\"\n                       id=\"nicknameInput\"/>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"control-label col-md-3\">IMDB#</label>\n            <div class=\"col-md-8 pad-text-input-col\">\n                <input type=\"text\"\n                       class=\"prism-text-input\"\n                       ng-model=\"$ctrl.newCrewCollab.collaborator.iMDbNumber\"\n                       id=\"imdbNumberInput\"/>\n            </div>\n        </div>\n        <div class=\"form-group\"\n             ng-if=\"!$ctrl.resolve.newActor\">\n            <label class=\"control-label col-md-3\">Roles</label>\n            <div class=\"col-md-8 pad-text-input-col\">\n                <multiselect-dropdown\n                    class=\"force-required-indicator force-invalid-outline-computation\"\n                    id=\"collaboratorEditRoleSelector\"\n                    ng-model=\"$ctrl.newCrewCollab.selectedRoles\"\n                    enable-select-all=\"true\"\n                    prompt=\"Select Role\"\n                    btn-min-width=\"180\"\n                    attach-to-body=\"true\"\n                    collection=\"$ctrl.availableRoles\">\n                </multiselect-dropdown>\n            </div>\n        </div>\n    </form>\n</div>\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default\"\n            id=\"cancelButton\"\n            ng-click=\"$ctrl.dismiss({$value: \'cancel\'})\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            id=\"saveButton\"\n            ng-click=\"$ctrl.close({$value: {newCrewCollab: $ctrl.newCrewCollab, actorIsSelf: $ctrl.actorIsSelf}})\"\n            ng-disabled=\"$ctrl.disableOKButton()\">\n        Save\n    </button>\n</div>\n");
        $templateCache.put("package/editor/components/modals/hierarchicalMetadata/renderers/content-meta-renderer-template.html", "<div class=\"edit-view-container\">\n    <div class=\"row clearfix\">\n        <div class=\"col-md-12 column\">\n            <div class=\"row\">\n                <span class=\"col-md-2\">\n                    <div class=\"prism-form-heading\">\n                        <i class=\"fa fa-television fa-lg fa-fw\"\n                           ng-if=\"$ctrl.resolve.packageObject.content.type === \'Series\'\"></i>\n                        <i class=\"fa fa-film fa-lg fa-fw\"\n                           ng-if=\"$ctrl.resolve.packageObject.content.type === \'Movies/Special\'\"></i>\n                        &nbsp;\n                        {{$ctrl.resolve.packageObject.content.type.toUpperCase()}}\n                    </div>\n                </span>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"form-group no-margin-bottom\">\n        <label class=\"col-sm-4 control-label\"\n               for=\"contentName\">Name</label>\n        <div class=\"col-sm-8 pad-text-input-col\">\n            <p id=\"contentName\">&nbsp;{{$ctrl.viewData.content.name}}</p>\n        </div>\n    </div>\n    <div ng-show=\"$ctrl.viewData.content.type != \'Ad/PreRoll\'\">\n        <div class=\"form-group no-margin-bottom\">\n            <label class=\"col-sm-4 control-label\"\n                   for=\"contentValue\">Value</label>\n            <div class=\"col-sm-8 pad-text-input-col\">\n                <p id=\"contentValue\">&nbsp;{{$ctrl.viewData.content.value}}</p>\n            </div>\n        </div>\n        <div class=\"form-group no-margin-bottom\">\n            <label class=\"col-sm-4 control-label\"\n                   for=\"contentPrefix\">Prefix</label>\n            <div class=\"col-sm-8 pad-text-input-col\">\n                <p id=\"contentPrefix\">&nbsp;{{$ctrl.viewData.content.prefix}}</p>\n            </div>\n        </div>\n        <div class=\"form-group no-margin-bottom\">\n            <label class=\"col-sm-4 control-label\"\n                   for=\"contentShortDesc\">Short Description</label>\n            <div class=\"col-sm-8 pad-text-input-col\">\n                <p id=\"contentShortDesc\">&nbsp;{{$ctrl.viewData.content.shortDescription}}</p>\n            </div>\n        </div>\n        <div class=\"form-group no-margin-bottom\">\n            <label class=\"col-sm-4 control-label\"\n                   for=\"contentLongDesc\">Long Description</label>\n            <div class=\"col-sm-8 pad-text-input-col\">\n                <p id=\"contentLongDesc\">&nbsp;{{$ctrl.viewData.content.longDescription}}</p>\n            </div>\n        </div>\n        <div class=\"form-group no-margin-bottom\">\n            <label class=\"col-sm-4 control-label\"\n                   for=\"contentAirTime\">Air Time</label>\n            <div class=\"col-sm-8 pad-text-input-col\">\n                <p id=\"contentAirTime\">&nbsp;{{$ctrl.viewData.content.airTime | timeTo12HFormat}}</p>\n            </div>\n        </div>\n        <div class=\"form-group no-margin-bottom\">\n            <label class=\"col-sm-4 control-label\"\n                   for=\"contentStartYear\">Start Year</label>\n            <div class=\"col-sm-8 pad-text-input-col\">\n                <p id=\"contentStartYear\">&nbsp;{{$ctrl.viewData.content.startYear}}</p>\n            </div>\n        </div>\n        <div class=\"form-group no-margin-bottom\">\n            <label class=\"col-sm-4 control-label\"\n                   for=\"contentGenre\">Genre</label>\n            <div class=\"col-sm-8 pad-text-input-col\">\n                <p id=\"contentGenre\">&nbsp;{{$ctrl.viewData.content.genre.name}}</p>\n            </div>\n        </div>\n        <div class=\"form-group no-margin-bottom\">\n            <label class=\"col-sm-4 control-label\"\n                   for=\"contentSecondGenre\">Second Genre</label>\n            <div class=\"col-sm-8 pad-text-input-col\">\n                <p id=\"contentSecondGenre\">&nbsp;{{$ctrl.viewData.content.secondGenre.name}}</p>\n            </div>\n        </div>\n        <div class=\"form-group no-margin-bottom\">\n            <label class=\"col-sm-4 control-label\"\n                   for=\"contentCopyright\">Copyright</label>\n            <div class=\"col-sm-8 pad-text-input-col\">\n                <p id=\"contentCopyright\">&nbsp;{{$ctrl.viewData.content.copyright}}</p>\n            </div>\n        </div>\n        <div class=\"form-group no-margin-bottom\">\n            <label class=\"col-sm-4 control-label\"\n                   for=\"territory\">Territory</label>\n            <div class=\"col-sm-8 pad-text-input-col\">\n                <p id=\"territory\">&nbsp;{{$ctrl.viewData.content.territory.name}}</p>\n            </div>\n        </div>\n        <div class=\"form-group no-margin-bottom\">\n            <label class=\"col-sm-4 control-label\"\n                   for=\"contentAutoKeywords\">Auto Keywords</label>\n            <div class=\"col-sm-8 pad-text-input-col\">\n                <p id=\"contentAutoKeywords\">&nbsp;{{$ctrl.viewData.content.autoKeywords}}</p>\n            </div>\n        </div>\n        <div ng-repeat=\"metaItem in $ctrl.viewData.content.metadata\">\n            <div class=\"form-group no-margin-bottom\"\n                 ng-if=\"!metaItem.excludeFromMetadata\">\n                <label class=\"col-sm-4 control-label\"\n                       for=\"{{metaItem.name}}\">{{metaItem.displayName}}</label>\n                <div class=\"col-sm-8 pad-text-input-col\">\n                    <p id=\"{{metaItem.name}}\"\n                       class=\"custom-meta-value\">&nbsp;{{$ctrl.getMetadataValue(metaItem)}}</p>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <hr/>\n\n    <!-- Partner MVPD -->\n    <div ng-if=\"$ctrl.partnerMVPDProperties.content[$ctrl.selectedPartner]\">\n        <div class=\"clearfix padding-top-lg\">\n            <div class=\"prism-form-heading\">\n                <i class=\"fa fa-chain fa-lg fa-rotate-90 fa-fw\"></i>\n                &nbsp;\n                {{$ctrl.selectedPartner}} MVPD\n            </div>\n        </div>\n\n        <hr/>\n\n        <div ng-repeat=\"metaItem in $ctrl.partnerMVPDProperties.content[$ctrl.selectedPartner]\">\n            <div class=\"form-group no-margin-bottom\"\n                 ng-if=\"!metaItem.excludeFromMetadata\">\n                <label class=\"col-sm-4 control-label\"\n                       for=\"{{metaItem.name}}\">{{metaItem.displayName}}</label>\n                <div class=\"col-sm-8 pad-text-input-col\">\n                    <p id=\"{{metaItem.name}}\">&nbsp;{{$ctrl.getMetadataValue(metaItem)}}</p>\n                </div>\n            </div>\n        </div>\n    </div>\n    <hr/>\n</div>\n");
        $templateCache.put("package/editor/components/modals/hierarchicalMetadata/renderers/network-meta-renderer-template.html", "<div class=\"edit-view-container\">\n\n    <div class=\"row clearfix\">\n        <div class=\"col-md-12 column\">\n            <div class=\"row\">\n                <div class=\"col-md-2\">\n                    <div class=\"prism-form-heading\">\n                        <i class=\"fa fa-sitemap fa-lg fa-fw\"></i>\n                        &nbsp;\n                        NETWORK\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"form-group no-margin-bottom\">\n        <label class=\"col-sm-4 control-label\"\n               for=\"networkName\">Name</label>\n        <div class=\"col-sm-8 pad-text-input-col\">\n            <p id=\"networkName\">&nbsp;{{$ctrl.viewData.network.name}}</p>\n        </div>\n    </div>\n    <div class=\"form-group no-margin-bottom\">\n        <label class=\"col-sm-4 control-label\"\n               for=\"networkValue\">Value</label>\n        <div class=\"col-sm-8 pad-text-input-col\">\n            <p id=\"networkValue\">&nbsp;{{$ctrl.viewData.network.value}}</p>\n        </div>\n    </div>\n    <div class=\"form-group no-margin-bottom\">\n        <label class=\"col-sm-4 control-label\"\n               for=\"networkPrefix\">Prefix</label>\n        <div class=\"col-sm-8 pad-text-input-col\">\n            <p id=\"networkPrefix\">&nbsp;{{$ctrl.viewData.network.prefix}}</p>\n        </div>\n    </div>\n    <div class=\"form-group no-margin-bottom\">\n        <label class=\"col-sm-4 control-label\"\n               for=\"networkShortDesc\">Short Description</label>\n        <div class=\"col-sm-8 pad-text-input-col\">\n            <p id=\"networkShortDesc\">&nbsp;{{$ctrl.viewData.network.shortDescription}}</p>\n        </div>\n    </div>\n    <div class=\"form-group no-margin-bottom\">\n        <label class=\"col-sm-4 control-label\"\n               for=\"networkLongDesc\">Long Description</label>\n        <div class=\"col-sm-8 pad-text-input-col\">\n            <p id=\"networkLongDesc\">&nbsp;{{$ctrl.viewData.network.longDescription}}</p>\n        </div>\n    </div>\n    <div class=\"form-group no-margin-bottom\">\n        <label class=\"col-sm-4 control-label\"\n               for=\"networkCopyright\">Copyright</label>\n        <div class=\"col-sm-8 pad-text-input-col\">\n            <p id=\"networkCopyright\">&nbsp;{{$ctrl.viewData.network.copyright}}</p>\n        </div>\n    </div>\n    <div ng-repeat=\"metaItem in $ctrl.viewData.network.metadata\">\n        <div class=\"form-group no-margin-bottom\"\n             ng-if=\"!metaItem.excludeFromMetadata\">\n            <label class=\"col-sm-4 control-label\"\n                   for=\"{{metaItem.name}}\">{{metaItem.displayName}}\n            </label>\n            <div class=\"col-sm-8 pad-text-input-col\">\n                <p id=\"{{metaItem.name}}\"\n                   class=\"custom-meta-value\">&nbsp;{{$ctrl.getMetadataValue(metaItem)}}\n                </p>\n            </div>\n        </div>\n    </div>\n\n    <hr/>\n\n    <!-- Partner MVPD -->\n    <div ng-if=\"$ctrl.partnerMVPDProperties.network[$ctrl.selectedPartner]\">\n        <div class=\"clearfix padding-top-lg\">\n            <div class=\"prism-form-heading\">\n                <i class=\"fa fa-chain fa-lg fa-rotate-90 fa-fw\"></i>\n                &nbsp;\n                {{$ctrl.selectedPartner}} MVPD\n            </div>\n        </div>\n\n        <hr/>\n\n        <div ng-repeat=\"metaItem in $ctrl.partnerMVPDProperties.network[$ctrl.selectedPartner]\">\n            <div class=\"form-group no-margin-bottom\"\n                 ng-if=\"!metaItem.excludeFromMetadata\">\n                <label class=\"col-sm-4 control-label\"\n                       for=\"{{metaItem.name}}\">{{metaItem.displayName}}</label>\n                <div class=\"col-sm-8 pad-text-input-col\">\n                    <p id=\"{{metaItem.name}}\">&nbsp;{{$ctrl.getMetadataValue(metaItem)}}</p>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <hr/>\n</div>\n");
        $templateCache.put("package/editor/components/modals/hierarchicalMetadata/renderers/season-meta-renderer-template.html", "<div class=\"edit-view-container\">\n    <div class=\"row clearfix\">\n        <div class=\"col-md-12 column\">\n            <div class=\"row\">\n                <div class=\"col-md-2\">\n                    <div class=\"prism-form-heading\">SEASON</div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"form-group no-margin-bottom\">\n        <label class=\"col-sm-4 control-label\"\n               for=\"seasonName\">Name</label>\n        <div class=\"col-sm-8 pad-text-input-col\">\n            <p id=\"seasonName\">&nbsp;{{$ctrl.viewData.season.name}}</p>\n        </div>\n    </div>\n    <div class=\"form-group no-margin-bottom\">\n        <label class=\"col-sm-4 control-label\"\n               for=\"seasonValue\">Value</label>\n        <div class=\"col-sm-8 pad-text-input-col\">\n            <p id=\"seasonValue\">&nbsp;{{$ctrl.viewData.season.value}}</p>\n        </div>\n    </div>\n    <div class=\"form-group no-margin-bottom\">\n        <label class=\"col-sm-4 control-label\"\n               for=\"seasonStartDate\">Start Date</label>\n        <div class=\"col-sm-8 pad-text-input-col\">\n            <p id=\"seasonStartDate\">&nbsp;{{$ctrl.viewData.season.startDate | amDateFormat: \'MM/DD/YYYY\'}}</p>\n        </div>\n    </div>\n    <div class=\"form-group no-margin-bottom\">\n        <label class=\"col-sm-4 control-label\"\n               for=\"seasonEndDate\">End Date</label>\n        <div class=\"col-sm-8 pad-text-input-col\">\n            <p id=\"seasonEndDate\">&nbsp;{{$ctrl.viewData.season.endDate | amDateFormat: \'MM/DD/YYYY\'}}</p>\n        </div>\n    </div>\n    <div class=\"form-group no-margin-bottom\">\n        <label class=\"col-sm-4 control-label\"\n               for=\"seasonShortDesc\">Short Description</label>\n        <div class=\"col-sm-8 pad-text-input-col\">\n            <p id=\"seasonShortDesc\">&nbsp;{{$ctrl.viewData.season.shortDescription}}</p>\n        </div>\n    </div>\n    <div class=\"form-group no-margin-bottom\">\n        <label class=\"col-sm-4 control-label\"\n               for=\"seasonLongDesc\">Long Description</label>\n        <div class=\"col-sm-8 pad-text-input-col\">\n            <p id=\"seasonLongDesc\">&nbsp;{{$ctrl.viewData.season.longDescription}}</p>\n        </div>\n    </div>\n    <div ng-repeat=\"metaItem in $ctrl.viewData.season.metadata\">\n        <div class=\"form-group no-margin-bottom\"\n             ng-if=\"!metaItem.excludeFromMetadata\">\n            <label class=\"col-sm-4 control-label\"\n                   for={{metaItem.name}}>{{metaItem.displayName}}</label>\n            <div class=\"col-sm-8 pad-text-input-col\">\n                <p id={{metaItem.name}}\n                   class=\"custom-meta-value\">&nbsp;{{$ctrl.getMetadataValue(metaItem)}}</p>\n            </div>\n        </div>\n    </div>\n\n    <hr/>\n\n    <!-- Partner MVPD -->\n    <div ng-if=\"$ctrl.partnerMVPDProperties.season[$ctrl.selectedPartner]\">\n        <div class=\"clearfix padding-top-lg\">\n            <div class=\"prism-form-heading\">\n                <i class=\"fa fa-chain fa-lg fa-rotate-90 fa-fw\"></i>\n                {{$ctrl.selectedPartner}} MVPD\n            </div>\n        </div>\n\n        <hr/>\n\n        <div ng-repeat=\"metaItem in $ctrl.partnerMVPDProperties.season[$ctrl.selectedPartner]\">\n            <div class=\"form-group no-margin-bottom\"\n                 ng-if=\"!metaItem.excludeFromMetadata\">\n                <label class=\"col-sm-4 control-label\"\n                       for=\"{{metaItem.name}}\">{{metaItem.displayName}}</label>\n                <div class=\"col-sm-8 pad-text-input-col\">\n                    <p id=\"{{metaItem.name}}\">&nbsp;{{$ctrl.getMetadataValue(metaItem)}}</p>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <hr/>\n</div>\n");
        $templateCache.put("package/editor/components/modals/hierarchicalMetadata/renderers/volume-meta-renderer-template.html", "<div class=\"edit-view-container\">\n    <div class=\"row clearfix\">\n        <div class=\"col-md-12 column\">\n            <div class=\"row\">\n                <div class=\"col-md-2\">\n                    <div class=\"prism-form-heading\">VOLUME</div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"form-group no-margin-bottom\">\n        <label class=\"col-sm-4 control-label\"\n               for=\"volumeName\">Name</label>\n        <div class=\"col-sm-8 pad-text-input-col\">\n            <p id=\"volumeName\">&nbsp;{{$ctrl.viewData.volume.name}}</p>\n        </div>\n    </div>\n    <div class=\"form-group no-margin-bottom\">\n        <label class=\"col-sm-4 control-label\"\n               for=\"volumeValue\">Value</label>\n        <div class=\"col-sm-8 pad-text-input-col\">\n            <p id=\"volumeValue\">&nbsp;{{$ctrl.viewData.volume.value}}</p>\n        </div>\n    </div>\n    <div class=\"form-group no-margin-bottom\">\n        <label class=\"col-sm-4 control-label\"\n               for=\"volumeStartDate\">Start Date</label>\n        <div class=\"col-sm-8 pad-text-input-col\">\n            <p id=\"volumeStartDate\">&nbsp;{{$ctrl.viewData.volume.startDate | amDateFormat: \'MM/DD/YYYY\'}}</p>\n        </div>\n    </div>\n    <div class=\"form-group no-margin-bottom\">\n        <label class=\"col-sm-4 control-label\"\n               for=\"volumeEndDate\">End Date</label>\n        <div class=\"col-sm-8 pad-text-input-col\">\n            <p id=\"volumeEndDate\">&nbsp;{{$ctrl.viewData.volume.endDate | amDateFormat: \'MM/DD/YYYY\'}}</p>\n        </div>\n    </div>\n    <div class=\"form-group no-margin-bottom\">\n        <label class=\"col-sm-4 control-label\"\n               for=\"volumeShortDesc\">Short Description</label>\n        <div class=\"col-sm-8 pad-text-input-col\">\n            <p id=\"volumeShortDesc\">&nbsp;{{$ctrl.viewData.volume.shortDescription}}</p>\n        </div>\n    </div>\n    <div class=\"form-group no-margin-bottom\">\n        <label class=\"col-sm-4 control-label\"\n               for=\"volumeLongDesc\">Long Description</label>\n        <div class=\"col-sm-8 pad-text-input-col\">\n            <p id=\"volumeLongDesc\">&nbsp;{{$ctrl.viewData.volume.longDescription}}</p>\n        </div>\n    </div>\n    <div ng-repeat=\"metaItem in $ctrl.viewData.volume.metadata\">\n        <div class=\"form-group no-margin-bottom\"\n             ng-if=\"!metaItem.excludeFromMetadata\">\n            <label class=\"col-sm-4 control-label\"\n                   for={{metaItem.name}}>{{metaItem.displayName}}</label>\n            <div class=\"col-sm-8 pad-text-input-col\">\n                <p id={{metaItem.name}}\n                   class=\"custom-meta-value\">&nbsp;{{$ctrl.getMetadataValue(metaItem)}}</p>\n            </div>\n        </div>\n    </div>\n\n    <hr/>\n\n    <!-- Partner MVPD -->\n    <div ng-if=\"$ctrl.partnerMVPDProperties.volume[$ctrl.selectedPartner]\">\n        <div class=\"clearfix padding-top-lg\">\n            <div class=\"prism-form-heading\">\n                <i class=\"fa fa-chain fa-lg fa-rotate-90 fa-fw\"></i>\n                {{$ctrl.selectedPartner}} MVPD\n            </div>\n        </div>\n\n        <hr/>\n\n        <div ng-repeat=\"metaItem in $ctrl.partnerMVPDProperties.volume[$ctrl.selectedPartner]\">\n            <div class=\"form-group no-margin-bottom\"\n                 ng-if=\"!metaItem.excludeFromMetadata\">\n                <label class=\"col-sm-4 control-label\"\n                       for=\"{{metaItem.name}}\">{{metaItem.displayName}}</label>\n                <div class=\"col-sm-8 pad-text-input-col\">\n                    <p id=\"{{metaItem.name}}\">&nbsp;{{$ctrl.getMetadataValue(metaItem)}}</p>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <hr/>\n</div>\n");
        $templateCache.put("package/editor/components/shared/completedDeliveries/gridTemplates/delivery-cell-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\"\n     data-tooltip-append-to-body=\"true\"\n     uib-tooltip=\"{{row.entity.delivery}}\">\n\n    <span ng-class=\"\n    		{\'tree-level-0\' : row.entity.$$treeLevel === 0,\n    		 \'tree-level-1\' : row.entity.$$treeLevel === 1,\n    		 \'tree-level-2\' : row.entity.$$treeLevel === 2,\n    		 \'tree-level-3\' : row.entity.$$treeLevel === 3}\">\n        {{COL_FIELD CUSTOM_FILTERS}}\n	</span>\n</div>\n");
        $templateCache.put("package/editor/components/shared/completedDeliveries/gridTemplates/delivery-row-template.html", "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\"\n     class=\"ui-grid-cell ng-scope ng-binding\"\n     data-tooltip-append-to-body=\"true\"\n     ui-grid-cell\n     ng-class=\"{\'delivery-job\' : row.entity.isJob,\n    		    \'delivery-file\' : row.entity.isFile}\">\n</div>\n");
        $templateCache.put("package/editor/components/view/advancedMetadata/renderers/package-shared-nielsen-template.html", "");
        $templateCache.put("package/editor/components/view/collaborator/renderers/clip-collaborators-renderer-template.html", "<div class=\"row spacer-top-xsm padding-bottom-xsm\">\n	<div class=\"form-group\">\n		<div class=\"col-sm-6\">\n			<button id=\"clipCollaboratorsAdd\"\n					class=\"btn btn-default prism-button prism-select-btn\"\n					ng-click=\"$ctrl.addCollaborator()\">+</button>\n			<button id=\"clipCollaboratorsRemove\"\n					class=\"btn btn-default prism-button prism-select-btn\"\n					ng-click=\"$ctrl.deleteCollaborator()\"\n					ng-disabled=\"$ctrl.deleteInvalid()\">-</button>\n		</div>\n	</div>\n</div>\n<div class=\"row\">\n	<div class=\"col-md-12\">\n		<div ui-grid=\"$ctrl.currentGridOptions\"\n			 class=\"clip-collaborator-grid protected-grid\"\n			 ui-grid-auto-resize\n			 ui-grid-selection\n			 ui-grid-pagination\n			 id=\"pmEditActorCollaboratorsGrid\">\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("package/editor/components/view/collaborator/renderers/package-collaborators-renderer-template.html", "<uib-tabset horizontal=\"true\"\n            type=\"pills\"\n            class=\"collaborators-edit-view-tabbar\"\n            active=\"$ctrl.currentTab\">\n\n    <uib-tab heading=\"Actors\"\n             select=\"$ctrl.activateTab(\'Actors\')\"\n             index=\"\'Actors\'\">\n\n        <div ui-grid=\"$ctrl.currentGridOptions\"\n             class=\"collaborator-grid protected-grid\"\n             ui-grid-auto-resize\n             ui-grid-selection\n             ui-grid-pagination\n             id=\"pmEditActorCollaboratorsGrid\"\n             ng-if=\"$ctrl.roleTabs.actors\">\n        </div>\n\n    </uib-tab>\n\n    <uib-tab heading=\"Crew\"\n             select=\"$ctrl.activateTab(\'Crew\')\"\n             index=\"\'Crew\'\">\n\n        <div ui-grid=\"$ctrl.currentGridOptions\"\n             class=\"collaborator-grid protected-grid\"\n             ui-grid-auto-resize\n             ui-grid-selection\n             ui-grid-resize-columns\n             id=\"pmEditProducerCollaboratorsGrid\"\n             ng-if=\"$ctrl.roleTabs.crew\">\n        </div>\n\n    </uib-tab>\n\n</uib-tabset>\n");
        $templateCache.put("package/editor/components/view/distributionGrid/mmcInventoryModal/mmc-inventory-modal-template.html", "<!--\n - Filename: mmc-inventory-modal-template.html\n -\n - Created by randysorensen on 2019-05-09.\n -->\n\n<div class=\"asset-info-list-modal\">\n\n    <!-- Modal Header -->\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\">\n            MMC Inventory\n        </h4>\n    </div>\n\n    <!-- Modal Body -->\n    <div class=\"modal-body\">\n\n        <!-- Loading Indicator -->\n        <div class=\"loadingIndicator\">\n            <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                 ng-show=\"$ctrl.loadingIndicator.show\"></div>\n        </div>\n\n        <!-- Component Inventory Grid -->\n        <fieldset ng-disabled=\"$ctrl.readOnly\">\n            <div id=\"componentInventoryGrid\"\n                 class=\"inline-edit-grid grid search-grid component-inventory-grid\"\n                 ui-grid=\"$ctrl.gridOptions\"\n                 ui-grid-edit\n                 ui-grid-resize-columns>\n            </div>\n        </fieldset>\n\n    </div>\n\n    <!-- Modal Footer -->\n    <div class=\"modal-footer\">\n        <div class=\"flex-row-container\">\n            <button class=\"btn btn-sm btn-default\"\n                    ng-click=\"$ctrl.onCancelClicked()\">\n                Cancel\n            </button>\n\n            <div class=\"flex-stretcher\">\n            </div>\n\n            <span class=\"no-results-label\"\n                  ng-show=\"$ctrl.componentInventory.length === 0\">\n                There are no component inventory items for this partner package.\n            </span>\n\n            <div class=\"flex-stretcher\">\n            </div>\n\n            <button class=\"btn btn-sm btn-default\"\n                    ng-click=\"$ctrl.onSaveClicked()\"\n                    ng-disabled=\"$ctrl.saveButtonDisabled()\">\n                Save\n            </button>\n        </div>\n    </div>\n\n</div>\n");
        $templateCache.put("package/editor/components/view/distributionGrid/renderers/advanced-distribution-renderer-template.html", "<!-- Partner Header -->\n<div class=\"padding-bottom-sm distribution-partner-header\">\n\n    <!-- Partner Name -->\n    <div class=\"row padding-bottom-lg\">\n        <div class=\"col-sm-12 column\">\n            <div class=\"prism-form-heading\">\n                {{partnerPackage.partner.name}}\n\n            </div>\n        </div>\n    </div>\n    <div class=\"distribution-icons\">\n        <div class=\"distribution-icon\">\n        <span class=\"label label-success sub group\"\n              data-tooltip-append-to-body=\"true\"\n              uib-tooltip=\"There {{(partnerPackage.partner.numberOfChildren | stringToNumber) === 1 ? \'is\' : \'are\'}} {{partnerPackage.partner.numberOfChildren}} Partner{{(partnerPackage.partner.numberOfChildren | stringToNumber) > 1 ? \'s\' : \'\'}} in this Group\"\n              ng-if=\"partnerPackage.partner.numberOfChildren && partnerPackage.partner.numberOfChildren !== \'0\'\">\n                    GROUP SUB\n                </span>\n        </div>\n    </div>\n\n	<!-- Stretcher -->\n	<!-- (pushes left & right sides apart) -->\n	<div class=\"flex-stretcher\"></div>\n\n    <!-- Partner Instance -->\n	<div class=\"padding-top-xs distribution-instance-selector\"\n		 ng-show=\"partnerPackage.partner.partnerDeliveryInstanceEnabled && !$ctrl.isClipDistribution\">\n		{{$ctrl.getInstanceLabel(partnerPackage)}}\n	</div>\n\n    <!-- MMC Inventory ID editor button -->\n    <div>\n        <i class=\"fa fa-cog fa-2x mmc-inventory-id-gear\"\n           id=\"{{partnerPackage.partner.name + \'MMCGear\'}}\"\n           ng-click=\"$ctrl.showMMCInventoryModal(partnerPackage)\"\n           style=\"flex-shrink: 1\"\n           uib-tooltip-html=\"\'<span>MMC Inventory</span>\'\"\n           tooltip-append-to-body=\"true\"\n           tooltip-placement=\"bottom\">\n        </i>\n    </div>\n</div>\n\n\n<!-- Static (e.g. non custom metadata) Fields -->\n<div class=\"row\">\n	<div class=\"col-sm-12 column\">\n		<div class=\"form-horizontal\"\n			 role=\"form\">\n\n			<!-- Instance Revision -->\n			<div class=\"form-group\"\n				 ng-show=\"partnerPackage.partner.partnerDeliveryInstanceEnabled && !$ctrl.isClipDistribution\">\n				<label for=\"instanceRevision\"\n					   class=\"col-sm-3 control-label\">\n					Revision\n				</label>\n				<div class=\"col-sm-1 pad-text-input-col\">\n					<input type=\"text\"\n						   id=\"instanceRevision\"\n						   class=\"form-control input-sm prism-text-input\"\n						   ng-model=\"$ctrl.selectedInstanceRevisionAccessors()[partnerPackage.id]\"\n						   ng-model-options=\"{getterSetter: true}\"\n						   ng-keydown=\"$ctrl.numericFieldKeyDown($event, $ctrl.endpointObject.tcpPort)\"\n						   autocomplete=\"off\"/>\n				</div>\n				<div class=\"required-text-input\"\n					 required\n					 x-required-indicator>\n				</div>\n			</div>\n\n			<!-- Due Date -->\n			<div class=\"form-group no-margin-bottom\"\n				 ng-show=\"partnerPackage.dueDate\">\n				<label for=\"{{partnerPackage.partner.name + \'dueDate\'}}\"\n					   class=\"col-sm-3 control-label\">\n					Due Date\n				</label>\n\n				<div class=\"col-sm-9 no-padding\">\n\n					<!-- Due Date Selector -->\n					<date-time-picker id=\"{{partnerPackage.partner.name + \'dueDate\'}}\"\n									  disabled=\"!partnerPackage.dueDateOverridden\"\n									  ng-model=\"partnerPackage.dueDate\"\n									  field-set-size=\"3\">\n					</date-time-picker>\n\n					<!-- Override Checkbox -->\n					<label class=\"prism-checkbox-inline\">\n						<input id=\"{{partnerPackage.partner.name + \'dueDateOverridden\'}}\"\n							   type=\"checkbox\"\n							   ng-model=\"partnerPackage.dueDateOverridden\"/>\n						<label for=\"{{partnerPackage.partner.name + \'dueDateOverridden\'}}\">\n							Override\n						</label>\n					</label>\n				</div>\n			</div>\n\n			<!-- Warning Due Date -->\n			<div class=\"form-group no-margin-bottom\"\n				 ng-show=\"partnerPackage.warningDueDate\">\n				<label for=\"{{partnerPackage.partner.name + \'warningDueDate\'}}\"\n					   class=\"col-sm-3 control-label\">\n					Warning Due Date\n				</label>\n\n				<div class=\"col-sm-9 no-padding\">\n					<date-time-picker id=\"{{partnerPackage.partner.name + \'warningDueDate\'}}\"\n									  disabled=\"true\"\n									  ng-model=\"partnerPackage.warningDueDate\"\n									  field-set-size=\"3\">\n					</date-time-picker>\n				</div>\n			</div>\n\n			<!-- Video Component Role -->\n			<div class=\"form-group\">\n				<label for=\"{{partnerPackage.partner.name + \'componentRole\'}}\"\n					   class=\"col-sm-3 control-label\">\n					Video Component Role\n				</label>\n				<div class=\"col-sm-9\">\n					<!--\n						Role Requirement List is disabled (for\n						now) in the adv. dist. grid\n					  -->\n					<fieldset ng-disabled=\"true\">\n						<requirement-list\n							all-entities=\"$ctrl.availableComponentRoles\"\n							context=\"partnerPackage\"\n							enabled-entities=\"$ctrl.videoRoleMap[partnerPackage.id]\"\n                            entity-name=\"Video Role\"\n                            entity-prop=\"role\"\n							id=\"{{partnerPackage.partner.name + \'componentRole\'}}\"\n							ng-disabled=\"true\"\n							on-update=\"$ctrl.enabledVideoRolesUpdated(context, newEnabledEntities)\"\n                            required-flag-prop=\"isRequired\">\n						</requirement-list>\n					</fieldset>\n				</div>\n			</div>\n\n			<!-- Delivery Eligibility -->\n			<div class=\"form-group no-margin-bottom\">\n				<label for=\"{{partnerPackage.partner.name + \'deliveryEligibility\'}}\"\n					   class=\"col-sm-3 control-label\">\n					Delivery Eligibility\n				</label>\n\n				<div class=\"col-sm-9 no-padding\">\n					<date-time-picker id=\"{{partnerPackage.partner.name + \'deliveryEligibility\'}}\"\n									  ng-disabled=\"!partnerPackage.deliveryEligibilityDateOverridden\"\n									  ng-model=\"partnerPackage.deliveryEligibilityDate\"\n									  field-set-size=\"3\">\n					</date-time-picker>\n					<label class=\"prism-checkbox-inline\">\n						<input id=\"{{partnerPackage.partner.name + \'deliveryEligibilityOverride\'}}\"\n							   type=\"checkbox\"\n							   ng-model=\"partnerPackage.deliveryEligibilityDateOverridden\"/>\n						<label for=\"{{partnerPackage.partner.name + \'deliveryEligibilityOverride\'}}\">\n							Override\n						</label>\n					</label>\n				</div>\n			</div>\n\n			<!-- NexGuard Watermarking -->\n			<div class=\"form-group\">\n\n				<!-- NexGuard enabled checkbox -->\n				<label for=\"{{partnerPackage.partner.name + \'nexGuardEnabled\'}}\"\n					   class=\"col-sm-3 control-label\">\n					NexGuard Watermarking Enabled\n				</label>\n\n				<div class=\"col-sm-1 spacer-top-xsm auto-width\">\n					<input id=\"{{partnerPackage.partner.name + \'nexGuardEnabled\'}}\"\n						   type=\"checkbox\"\n						   ng-model=\"partnerPackage.nexGuardEnabled\"\n						   ng-disabled=\"!partnerPackage.nexGuardOverridden\"/>\n					<label for=\"{{partnerPackage.partner.name + \'nexGuardEnabled\'}}\">\n					</label>\n				</div>\n\n                <!-- Override checkbox -->\n				<label class=\"prism-checkbox-inline\">\n					<input id=\"{{partnerPackage.partner.name + \'nexGuardOverridden\'}}\"\n						   type=\"checkbox\"\n						   ng-model=\"partnerPackage.nexGuardOverridden\"/>\n					<label for=\"{{partnerPackage.partner.name + \'nexGuardOverridden\'}}\">\n						Override\n					</label>\n				</label>\n			</div>\n\n			<!-- Nielsen Watermarking -->\n			<div class=\"form-group\">\n\n				<!-- Nielsen Enabled Checkbox -->\n				<label for=\"{{partnerPackage.partner.name + \'nielsenEnabled\'}}\"\n					   class=\"col-sm-3 control-label\">\n					Nielsen Watermarking Enabled\n				</label>\n				<div class=\"col-sm-1 spacer-top-xsm auto-width\">\n					<input id=\"{{partnerPackage.partner.name + \'nielsenEnabled\'}}\"\n						   type=\"checkbox\"\n						   ng-model=\"partnerPackage.nielsenData.enabledFlag\"\n						   ng-disabled=\"!partnerPackage.nielsenData.enabledFlagOverridden\"/>\n					<label for=\"{{partnerPackage.partner.name + \'nielsenEnabled\'}}\">\n					</label>\n				</div>\n\n				<!-- Override Checkbox -->\n				<label class=\"prism-checkbox-inline\">\n					<input id=\"{{partnerPackage.partner.name + \'nielsenEnabledOverridden\'}}\"\n						   type=\"checkbox\"\n						   ng-model=\"partnerPackage.nielsenData.enabledFlagOverridden\"/>\n					<label for=\"{{partnerPackage.partner.name + \'nielsenEnabledOverridden\'}}\">\n						Override\n					</label>\n				</label>\n			</div>\n\n			<div ng-if=\"partnerPackage.nielsenData.enabledFlag\"\n				 ng-include=\"\'package/editor/components/view/distributionGrid/renderers/nielsen-renderer-template.html\'\">\n			</div>\n		</div>\n	</div>\n</div>\n\n\n<!-- Partner Custom Metadata -->\n<div class=\"row padding-bottom-xsm\">\n	<div class=\"col-sm-12 column\">\n        <custom-metadata components-map=\"$ctrl.partnerComponentsMap[partnerPackage.id].advanced\"\n                         label-col-size=\"{{$ctrl.isClipDistribution? \'2\': \'3\'}}\"\n                         id-prefix=\"{{partnerPackage.partner.name}}\"\n                         component-style-overrides=\"$ctrl.customMetadataOverrides\"\n                         revision=\"partnerPackage.revision\"\n                         ignore-preferred-width=\"$ctrl.isClipDistribution\"\n                         on-update=\"$ctrl.onUpdate(event)\">\n        </custom-metadata>\n	</div>\n</div>\n");
        $templateCache.put("package/editor/components/view/distributionGrid/renderers/basic-distribution-renderer-template.html", "<!-- Partner Header -->\n<div class=\"padding-bottom-sm distribution-partner-header\">\n\n	<!-- Partner Name and Enable/Disable Checkbox -->\n	<div class=\"distribution-partner-name\">\n		<input type=\"checkbox\"\n			   id=\"{{partnerPackage.partner.name}}\"\n			   ng-model=\"partnerPackage.enabled\"\n			   ng-click=\"$ctrl.resetSelectAll(partnerPackage.enabled)\"/>\n		<label for=\"{{partnerPackage.partner.name}}\"\n			   class=\"prism-form-heading\">\n			{{partnerPackage.partner.name}}\n		</label>\n	</div>\n\n	<!-- \"SUB\" or \"AD-HOC\" labels -->\n	<div class=\"distribution-icons\">\n		<div ng-switch=\"$ctrl.getSubscriptionTypeForPartnerPackage(partnerPackage)\"\n			 class=\"distribution-icon\">\n            <!-- todo once the numberOfChildren becomes a number instead of a string this will break-->\n            <span class=\"label label-success sub group\"\n                  data-tooltip-append-to-body=\"true\"\n                  uib-tooltip=\"There {{(partnerPackage.partner.numberOfChildren | stringToNumber) === 1 ? \'is\' : \'are\'}} {{partnerPackage.partner.numberOfChildren}} Partner{{(partnerPackage.partner.numberOfChildren | stringToNumber) > 1 ? \'s\' : \'\'}} in this Group\"\n                  ng-switch-when=\"isSuperPartner\">GROUP SUB</span>\n			<span class=\"label label-success sub all\"\n				  data-tooltip-append-to-body=\"true\"\n				  uib-tooltip=\"This Partner is subscribed to all seasons for this Series\"\n				  ng-switch-when=\"allSeasons\">SUB</span>\n			<span class=\"label label-success sub partial\"\n				  data-tooltip-append-to-body=\"true\"\n				  uib-tooltip=\"This Partner is subscribed to a custom set of seasons for this Series\"\n				  ng-switch-when=\"partialSeasons\">SUB</span>\n			<span class=\"label label-success sub all\"\n				  data-tooltip-append-to-body=\"true\"\n				  uib-tooltip=\"This Partner is subscribed to all volumes for this Series\"\n				  ng-switch-when=\"allVolumes\">SUB</span>\n			<span class=\"label label-success sub partial\"\n				  data-tooltip-append-to-body=\"true\"\n				  uib-tooltip=\"This Partner is subscribed to a custom set of volumes for this Series\"\n				  ng-switch-when=\"partialVolumes\">SUB</span>\n			<span class=\"label label-success sub all\"\n				  data-tooltip-append-to-body=\"true\"\n				  uib-tooltip=\"This Partner is subscribed to this Movie/Special\"\n				  ng-switch-when=\"movieSpecial\">SUB</span>\n			<span class=\"label label-warning sub ad-hoc\"\n				  data-tooltip-append-to-body=\"true\"\n				  uib-tooltip=\"This Partner has an Ad-Hoc subscription for this content\"\n				  ng-switch-when=\"adHoc\"\n				  ng-mouseover=\"adHocHovered = true\"\n				  ng-mouseleave=\"adHocHovered = false\">AD-HOC <i class=\"fa fa-times\"\n																 ng-show=\"adHocHovered\"\n																 ng-click=\"$ctrl.removeAdHocSub(partnerPackage)\"></i>\n			</span>\n		</div>\n	</div>\n\n	<!-- \"MAIN VIDEO\" and \"+ COMPONENT\" Labels -->\n	<div class=\"distribution-icons\">\n		<div style=\"order: 0\"\n			 class=\"distribution-icon\">\n			<span class=\"label label-success sub component\">MAIN VIDEO</span>\n		</div>\n		<div style=\"order: {{$index + 1}}\"\n			 class=\"distribution-icon\"\n			 ng-repeat=\"role in partnerPackage.videoRoles | orderBy: \'role.name\'\">\n			<span class=\"label label-success sub component\">+ {{role.role.name.toUpperCase()}}</span>\n		</div>\n	</div>\n\n	<!-- Stretcher -->\n	<!-- (pushes left & right sides apart) -->\n	<div class=\"flex-stretcher\"></div>\n\n	<!-- Delivery Instance Selector -->\n	<div class=\"padding-top-xs distribution-instance-selector\"\n		 ng-show=\"partnerPackage.partner.partnerDeliveryInstanceEnabled && !$ctrl.isClipDistribution\">\n		<dropdown-select\n			id=\"deliveryInstanceSelector\"\n			collection=\"$ctrl.deliveryInstanceMap()[partnerPackage.id]\"\n			ng-model=\"$ctrl.selectedInstanceMap()[partnerPackage.id]\"\n			model-prop=\"id\"\n			label-field=\"label\"\n			value-prop=\"label\"\n			attach-to-body=\"true\"\n			sort-collection=\"false\"\n			on-change=\"$ctrl.onInstanceSelected(partnerPackage, $selected, $oldValue)\">\n		</dropdown-select>\n	</div>\n\n	<!-- Override Gear -->\n	<i class=\"fa fa-cog fa-2x distribution-branding-override-gear\"\n	   style=\"flex-shrink: 1\"\n	   id=\"{{partnerPackage.partner.name + \'OverrideGear\'}}\"\n	   ng-disabled=\"!$ctrl.statusAllowsEdit() || $ctrl.packageObject.locked || !$ctrl.writePerms\"\n	   ng-show=\"$ctrl.canOverridePartnerBranding(partnerPackage)\"\n	   ng-class=\"{\'hasOverrides\': $ctrl.partnerHasBrandingOverrides(partnerPackage) === true}\"\n	   ng-click=\"$ctrl.showBrandingOverridesModal(partnerPackage)\">\n    </i>\n</div>\n\n<!-- Partner Custom Metadata -->\n<div class=\"row padding-bottom-xsm\">\n    <div class=\"col-md-12 column\">\n        <fieldset ng-disabled=\"!partnerPackage.enabled\">\n            <custom-metadata components-map=\"$ctrl.partnerComponentsMap[partnerPackage.id].basic\"\n                             ignore-preferred-width=\"$ctrl.isClipDistribution\"\n                             component-style-overrides=\"$ctrl.customMetadataOverrides\"\n                             revision=\"partnerPackage.revision\"\n                             id-prefix=\"{{partnerPackage.partner.name}}\"\n                             on-update=\"$ctrl.onUpdate(event)\">\n            </custom-metadata>\n        </fieldset>\n    </div>\n</div>\n\n<!-- External Embargo Enabled -->\n<div class=\"form-group\" ng-show=\"partnerPackage.partner.embargoEnabledFlag\">\n    <!-- Nielsen Enabled Checkbox -->\n    <label for=\"{{partnerPackage.partner.name + \'EmbargoEnabled\'}}\"\n           class=\"col-sm-3 control-label\">\n        Pre-Delivery Validator Enabled\n    </label>\n    <div class=\"col-sm-9 spacer-top-xsm auto-width\">\n        <input id=\"{{partnerPackage.partner.name + \'embargoEnabled\'}}\"\n               type=\"checkbox\"\n               ng-model=\"partnerPackage.embargoEnabledFlag\"/>\n        <label for=\"{{partnerPackage.partner.name + \'embargoEnabled\'}}\">\n        </label>\n    </div>\n</div>\n\n<!-- Pre-Delivery QC Approval Enabled -->\n<div class=\"form-group\" ng-show=\"partnerPackage.partner.approvalEnabledFlag\">\n    <!-- Nielsen Enabled Checkbox -->\n    <label for=\"{{partnerPackage.partner.name + \'ApprovalEnabled\'}}\"\n           class=\"col-sm-3 control-label\">\n        Pre-Delivery QC Approval Enabled\n    </label>\n    <div class=\"col-sm-9 spacer-top-xsm auto-width\">\n        <input id=\"{{partnerPackage.partner.name + \'approvalEnabled\'}}\"\n               type=\"checkbox\"\n               ng-model=\"partnerPackage.approvalEnabledFlag\"/>\n        <label for=\"{{partnerPackage.partner.name + \'approvalEnabled\'}}\">\n        </label>\n    </div>\n</div>\n");
        $templateCache.put("package/editor/components/view/distributionGrid/renderers/nielsen-renderer-template.html", "<div class=\"form-group\">\n	<label for=\"{{partnerPackage.partner.name + \'nielsenSId\'}}\" class=\"col-sm-3 control-label\">Nielsen SID</label>\n	<div class=\"col-sm-6\">\n		<input id=\"{{partnerPackage.partner.name + \'nielsenSId\'}}\" type=\"text\" class=\"prism-text-input\" ng-disabled=\"!partnerPackage.nielsenData.nielsenSIdOverridden\" ng-model=\"partnerPackage.nielsenData.nielsenSId\"/>\n	</div>\n	<label class=\"prism-checkbox-inline\">\n		<input id=\"{{partnerPackage.partner.name + \'nielsenSIdOverridden\'}}\" type=\"checkbox\" ng-model=\"partnerPackage.nielsenData.nielsenSIdOverridden\"/>\n		<label for=\"{{partnerPackage.partner.name + \'nielsenSIdOverridden\'}}\">Override</label>\n	</label>\n</div>\n<div class=\"form-group\">\n	<label for=\"{{partnerPackage.partner.name + \'nielsenDsrcId\'}}\" class=\"col-sm-3 control-label\">Nielsen DSRC ID</label>\n	<div class=\"col-sm-6\">\n		<input id=\"{{partnerPackage.partner.name + \'nielsenDsrcId\'}}\" type=\"text\" class=\"prism-text-input\" ng-disabled=\"!partnerPackage.nielsenData.nielsenDsrcIdOverridden\" ng-model=\"partnerPackage.nielsenData.nielsenDsrcId\"/>\n	</div>\n	<label class=\"prism-checkbox-inline\">\n		<input id=\"{{partnerPackage.partner.name + \'nielsenDsrcIdOverridden\'}}\" type=\"checkbox\" ng-model=\"partnerPackage.nielsenData.nielsenDsrcIdOverridden\"/>\n		<label for=\"{{partnerPackage.partner.name + \'nielsenDsrcIdOverridden\'}}\">Override</label>\n	</label>\n</div>\n<div class=\"form-group\">\n	<label for=\"{{partnerPackage.partner.name + \'nielsenDsrcName\'}}\" class=\"col-sm-3 control-label\">Nielsen DSRC Name</label>\n	<div class=\"col-sm-6\">\n		<input id=\"{{partnerPackage.partner.name + \'nielsenDsrcName\'}}\" type=\"text\" class=\"prism-text-input\" ng-disabled=\"!partnerPackage.nielsenData.nielsenDsrcNameOverridden\" ng-model=\"partnerPackage.nielsenData.nielsenDsrcName\"/>\n	</div>\n	<label class=\"prism-checkbox-inline\">\n		<input id=\"{{partnerPackage.partner.name + \'nielsenDsrcNameOverridden\'}}\" type=\"checkbox\" ng-model=\"partnerPackage.nielsenData.nielsenDsrcNameOverridden\"/>\n		<label for=\"{{partnerPackage.partner.name + \'nielsenDsrcNameOverridden\'}}\">Override</label>\n	</label>\n</div>\n<div class=\"form-group\">\n	<label for=\"{{partnerPackage.partner.name + \'nielsenAssetId\'}}\" class=\"col-sm-3 control-label\">Nielsen Asset ID</label>\n	<div class=\"col-sm-6\">\n		<input id=\"{{partnerPackage.partner.name + \'nielsenAssetId\'}}\" type=\"text\" class=\"prism-text-input\" ng-disabled=\"!partnerPackage.nielsenData.nielsenAssetIdOverridden\" ng-model=\"partnerPackage.nielsenData.nielsenAssetId\"/>\n	</div>\n	<label class=\"prism-checkbox-inline\">\n		<input id=\"{{partnerPackage.partner.name + \'nielsenAssetIdOverridden\'}}\" type=\"checkbox\" ng-model=\"partnerPackage.nielsenData.nielsenAssetIdOverridden\"/>\n		<label for=\"{{partnerPackage.partner.name + \'nielsenAssetIdOverridden\'}}\">Override</label>\n	</label>\n</div>\n<div class=\"form-group\">\n	<label for=\"{{partnerPackage.partner.name + \'nielsenAssetName\'}}\" class=\"col-sm-3 control-label\">Nielsen Asset Name</label>\n	<div class=\"col-sm-6\">\n		<input id=\"{{partnerPackage.partner.name + \'nielsenAssetName\'}}\" type=\"text\" class=\"prism-text-input\" ng-disabled=\"!partnerPackage.nielsenData.nielsenAssetNameOverridden\" ng-model=\"partnerPackage.nielsenData.nielsenAssetName\"/>\n	</div>\n	<label class=\"prism-checkbox-inline\">\n		<input id=\"{{partnerPackage.partner.name + \'nielsenAssetNameOverridden\'}}\" type=\"checkbox\" ng-model=\"partnerPackage.nielsenData.nielsenAssetNameOverridden\"/>\n		<label for=\"{{partnerPackage.partner.name + \'nielsenAssetNameOverridden\'}}\">Override</label>\n	</label>\n</div>\n<div class=\"form-group\">\n	<label for=\"{{partnerPackage.partner.name + \'nielsenEpisodeId\'}}\" class=\"col-sm-3 control-label\">Nielsen Episode ID</label>\n	<div class=\"col-sm-6\">\n		<input id=\"{{partnerPackage.partner.name + \'nielsenEpisodeId\'}}\" type=\"text\" class=\"prism-text-input\" ng-disabled=\"!partnerPackage.nielsenData.nielsenEpisodeIdOverridden\" ng-model=\"partnerPackage.nielsenData.nielsenEpisodeId\"/>\n	</div>\n	<label class=\"prism-checkbox-inline\">\n		<input id=\"{{partnerPackage.partner.name + \'nielsenEpisodeIdOverridden\'}}\" type=\"checkbox\" ng-model=\"partnerPackage.nielsenData.nielsenEpisodeIdOverridden\"/>\n		<label for=\"{{partnerPackage.partner.name + \'nielsenEpisodeIdOverridden\'}}\">Override</label>\n	</label>\n</div>\n");
        $templateCache.put("package/editor/components/view/liveclip/renderers/clip-actions-renderer-template.html", "<div class=\"row spacer-top-xsm\" ng-show=\"true\">\n	<div class=\"edit-view-container\">\n		<div class=\"row clearfix\">\n			<div class=\"col-sm-12 column\">\n				<form class=\"form-horizontal\" role=\"form\">\n					<fieldset ng-disabled=\"!pkgLiveClip.perms.livePerms\">\n						<div class=\"col-sm-2 col-sm-offset-4\">\n							<button id=\"clipDeliverButton\" class=\"btn btn-default prism-button prism-select-btn\" ng-click=\"\">DELIVER</button>\n						</div>\n						<div class=\"col-sm-2\">\n							<button id=\"clipDraftButton\" class=\"btn btn-default prism-button prism-select-btn\" ng-click=\"\">DRAFT</button>\n						</div>\n					</fieldset>\n				</form>\n			</div>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("package/editor/components/view/liveclip/renderers/clip-edit-renderer-template.html", "<div class=\"row spacer-top-xsm\">\n	<div class=\"edit-view-container live-clip-properties-container\">\n		<div class=\"row clearfix\">\n			<div class=\"col-sm-12 column no-left-padding\">\n				<form class=\"form-horizontal\" role=\"form\" name=\"pkgLiveClip.editorForm\">\n					<fieldset ng-disabled=\"!pkgLiveClip.perms.livePerms || (pkgLiveClip.draftClipMode && pkgLiveClip.clipInEdit.id)\">\n						<div class=\"col-sm-6 no-right-padding padding-left-sm\">\n							<div class=\"form-group no-margin-bottom padding-bottom-lg\">\n								<label for=\"imageOffset\" class=\"control-label no-padding col-sm-3\">Image:</label>\n								<div class=\"col-sm-7 no-padding-right top-margin-xs auto-width\">\n									<fieldset ng-disabled=\"true\">\n										<timecode-input id=\"imageOffset\"\n														drop-frame=\"pkgLiveClip.currentFeed.isLive\"\n														ng-model=\"pkgLiveClip.clipInEdit.imageTimeCode\"></timecode-input>\n									</fieldset>\n								</div>\n								<div ng-if=\"pkgLiveClip.clipInEdit.imageTimeCode\" uib-tooltip=\"Go to image timecode\">\n									<div class=\"col-sm-2 spacer-top-xsm\">\n										<button class=\"btn btn-default prism-button\" ng-click=\"pkgLiveClip.goToImage($event)\">\n											<i class=\"fa fa-arrow-left\"></i>\n										</button>\n									</div>\n								</div>\n								<div class=\"col-sm-1 no-padding top-margin-xs\" uib-tooltip=\"Upload custom image\">\n									<button class=\"btn btn-default prism-button\"\n											ng-click=\"pkgLiveClip.openFileUploadModal()\">\n										<i class=\"fa fa-upload\"></i>\n									</button>\n								</div>\n								<div ng-if=\"pkgLiveClip.showNoImageErrorIcon()\">\n									<div class=\"col-sm-2 spacer-top-xsm\">\n										<div class=\"fa-stack fa error-warning-triangle metadata tree-top-level-error\">\n											<i class=\"fa fa-square fa-stack-1x\"></i>\n											<i class=\"fa fa-exclamation-triangle fa-stack-2x\"></i>\n										</div>\n									</div>\n								</div>\n							</div>\n							<div class=\"form-group no-margin-bottom\">\n								<label for=\"playClip\" class=\"control-label no-padding col-sm-3\">Play Clip:</label>\n								<div class=\"col-sm-2 spacer-top-xsm\" uib-tooltip=\"Play stream from mark-in to mark-out\">\n									<button class=\"btn btn-default prism-button\" ng-click=\"pkgLiveClip.playClip($event)\"\n											ng-disabled=\"!pkgLiveClip.hasMarkPoints()\">\n										<i id=\"playClip\" class=\"fa fa-play-circle-o\"></i>\n									</button>\n								</div>\n							</div>\n							<div class=\"form-group no-margin-bottom\">\n								<label for=\"clipIn\" class=\"control-label no-padding col-sm-3\">Mark In:</label>\n								<div class=\"col-sm-7 no-padding-right top-margin-xs auto-width\">\n									<timecode-input id=\"clipIn\" ng-model=\"pkgLiveClip.clipInEdit.markInTimeCode\"\n													drop-frame=\"pkgLiveClip.currentFeed.isLive\"\n													ng-change=\"pkgLiveClip.onMarkInChange()\" ng-model-options=\"{debounce: 250}\"></timecode-input>\n								</div>\n								<div class=\"col-sm-2 spacer-top-xsm\" uib-tooltip=\"Go to mark-in timecode\">\n									<button class=\"btn btn-default prism-button\" ng-click=\"pkgLiveClip.goToIn($event)\"\n											ng-disabled=\"!pkgLiveClip.hasMarkIn()\">\n										<i class=\"fa fa-arrow-left\"></i>\n									</button>\n								</div>\n							</div>\n							<div class=\"form-group no-margin-bottom padding-bottom-lg\">\n								<label for=\"clipOut\" class=\"control-label no-padding col-sm-3\">Mark Out:</label>\n								<div class=\"col-sm-7 no-padding-right top-margin-xs auto-width\">\n									<timecode-input id=\"clipOut\" ng-model=\"pkgLiveClip.clipInEdit.markOutTimeCode\"\n													drop-frame=\"pkgLiveClip.currentFeed.isLive\"\n													ng-change=\"pkgLiveClip.onMarkOutChange()\" ng-model-options=\"{debounce: 250}\"></timecode-input>\n								</div>\n								<div class=\"col-sm-2 spacer-top-xsm\" uib-tooltip=\"Go to mark-out timecode\">\n									<button class=\"btn btn-default prism-button\" ng-click=\"pkgLiveClip.goToOut($event)\"\n											ng-disabled=\"!pkgLiveClip.hasMarkOut()\">\n										<i class=\"fa fa-arrow-left\"></i>\n									</button>\n								</div>\n							</div>\n							<div class=\"form-group no-margin-bottom\">\n								<label for=\"duration\" class=\"control-label no-padding col-sm-3\">Duration:</label>\n								<div class=\"col-sm-7 auto-width no-padding-right padding-bottom-xsm top-margin-xs\">\n									<fieldset ng-disabled=\"true\">\n										<timecode-input id=\"duration\"\n														drop-frame=\"pkgLiveClip.currentFeed.isLive\"\n														ng-model=\"pkgLiveClip.clipInEdit.clipDuration\"></timecode-input>\n									</fieldset>\n								</div>\n							</div>\n						</div>\n						<div class=\"col-sm-4 padding-bottom-sm\"\n							 ng-class=\"pkgLiveClip.getAssetURL(pkgLiveClip.clipInEdit) !== \'assets/images/no-proxy.png\'? \'clip-edit-thumbnail-present\' : \'clip-edit-thumbnail-placeholder\'\">\n							<img src=\"{{pkgLiveClip.getAssetURL(pkgLiveClip.clipInEdit)}}\"/>\n						</div>\n					</fieldset>\n				</form>\n			</div>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("package/editor/components/view/liveclip/renderers/live-clip-tab-status-renderer-template.html", "<div class=\"row padding-bottom-xsm\">\n	<div class=\"edit-view-container toolbar-top-padding-sm\">\n		<div class=\"row clearfix\">\n			<div class=\"col-sm-12 column\">\n				<form class=\"form-inline\" role=\"form\">\n					<div class=\"form-group top-margin-xs\">\n						<div class=\"col-sm-12 no-left-padding\">\n							<p ng-if=\"pkgLiveClip.clipInEdit.id\"> CLIP STATUS: <span class=\"clip-status-text status-{{pkgLiveClip.clipInEdit.packageData.status.toLowerCase()}}\">{{pkgLiveClip.clipInEdit.packageData.status | enumFilter:\'Package_status\'}}</span></p>\n							<p ng-if=\"!pkgLiveClip.clipInEdit.id\"> STATUS:\n								<span class=\"record-status-text status-{{pkgLiveClip.record.status}}\">\n									<i class=\"fa fa-circle\" ng-show=\"pkgLiveClip.record.status === \'running\'\"></i> {{(pkgLiveClip.record.status !== \'running\')? pkgLiveClip.record.status.toUpperCase() : \'RECORDING\'}}\n								</span>\n							</p>\n						</div>\n					</div>\n					<div class=\"form-group top-margin-xs\">\n						<div class=\"col-sm-12 bottom-margin-sm\">\n							<dropdown-select id=\"liveFeedSelect\" ng-model=\"pkgLiveClip.currentFeed\" label-field=\"label\"\n											 collection=\"pkgLiveClip.availableFeeds\"\n											 ng-change=\"pkgLiveClip.selectScheduleForFeed()\"\n											 btn-min-width=\"295\">\n							</dropdown-select>\n						</div>\n					</div>\n					<div class=\"form-group top-margin-xs\"\n						 ng-show=\"pkgLiveClip.currentFeed.isLive\">\n						<div class=\"col-md-12\">\n							<span class=\"live-clip-schedule-button\" id=\"liveClipScheduleButton\"\n								  ng-disabled=\"pkgLiveClip.scheduleButtonDisabled() === true\"\n							   ng-click=\"pkgLiveClip.showScheduleModal($event)\"><i class=\"fa fa-calendar fa-lg fa-fw\"></i>Schedule\n							</span>\n						</div>\n					</div>\n					<div class=\"form-group\"\n						 ng-show=\"pkgLiveClip.canDownloadProxy()\">\n						<div class=\"col-md-12 bottom-margin-xs\">\n							<button class=\"btn btn-default prism-button\"\n									ng-click=\"pkgLiveClip.downloadMainProxy()\">\n								Download Proxy\n							</button>\n						</div>\n					</div>\n					<div class=\"form-group pull-right\" ng-show=\"pkgLiveClip.clipInEdit.id\">\n						<div class=\"col-sm-3\" ng-class=\"(pkgLiveClip.activeEditTabs.distribution || pkgLiveClip.activeEditTabs.advanced) && pkgLiveClip.perms.adHocPerms && pkgLiveClip.statusAllowsEdit(pkgLiveClip.clipInEdit) &&\n			   									pkgLiveClip.clipInEdit.packageData.category && pkgLiveClip.clipInEdit.packageData.season ? \'\' : \'col-sm-offset-3\'\">\n							<a class=\"toolbar-button\" role=\"button\" id=\"saveToolbarButton\"\n							   ng-click=\"pkgLiveClip.checkSave()\"\n							   ng-disabled=\"pkgLiveClip.toolBarDisabled()\">\n								<i class=\"fa fa-floppy-o\"></i><br>Save\n							</a>\n						</div>\n						<div class=\"col-sm-3\">\n							<a class=\"toolbar-button\" role=\"button\" id=\"revertToolbarButton\"\n							   ng-click=\"pkgLiveClip.onRevert()\"\n							   ng-disabled=\"pkgLiveClip.toolBarDisabled()\">\n								<i class=\"fa fa-undo\"></i><br>Revert\n							</a>\n						</div>\n						<div class=\"col-sm-3\">\n							<a class=\"toolbar-button\" role=\"button\" id=\"closeToolbarButton\"\n							   ng-click=\"pkgLiveClip.onCloseClipEdit()\">\n								<i class=\"fa fa-times\"></i><br>Close</a>\n						</div>\n						<div class=\"col-sm-3 no-padding\" ng-show=\"(pkgLiveClip.activeEditTabs.distribution || pkgLiveClip.activeEditTabs.advanced) && pkgLiveClip.perms.adHocPerms && pkgLiveClip.statusAllowsEdit(pkgLiveClip.clipInEdit) &&\n			   									pkgLiveClip.clipInEdit.packageData.category && pkgLiveClip.clipInEdit.packageData.season\">\n							<a class=\"toolbar-button\" role=\"button\" id=\"adHocButton\"\n							   ng-click=\"pkgLiveClip.addAdHocSubscription()\">\n								<i class=\"fa fa-plus\"></i><br>Ad-Hoc\n							</a>\n						</div>\n					</div>\n					<div class=\"form-group pull-right top-margin-xs\">\n						<div class=\"col-sm-12\">\n							<button type=\"button\" class=\"btn btn-xs btn-default prism-button\"\n									ng-if=\"pkgLiveClip.clipHasErrorsWarnings(pkgLiveClip.clipInEdit)\"\n									ng-click=\"pkgLiveClip.showErrorsAndWarningsForClip(pkgLiveClip.clipInEdit)\">\n								Errors\n								and Warnings\n							</button>\n						</div>\n					</div>\n				</form>\n			</div>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("package/editor/components/view/media/renderers/packagemedia-view-asset-mediainfo-template.html", "<!-- Media Info -->\n<div class=\"flex-stretcher flex-col-container flex-align-start asset-info-container\">\n    <asset-info-row input-id=\"storagePath\"\n                          label=\"\'Storage Path\'\"\n                          value=\"$ctrl.mediaInfo.storagePath\">&nbsp;</asset-info-row>\n    <asset-info-row input-id=\"ingestDate\"\n                          label=\"\'Ingest Date\'\"\n                          value=\"$ctrl.mediaInfo.ingestDate | amDateFormat: \'MM/DD/YYYY HH:mm:ss A\'\">&nbsp;</asset-info-row>\n    <asset-info-row input-id=\"archiveStatus\"\n                          label=\"\'Storage Class\'\"\n                          value=\"$ctrl.mediaInfo.archiveStatus\">&nbsp;</asset-info-row>\n    <asset-info-row input-id=\"language\"\n                          label=\"\'Language\'\"\n                          ng-if=\"!$ctrl.secondaryAsset\"\n                          value=\"$ctrl.packageContent.language.name\">&nbsp;</asset-info-row>\n    <asset-info-row input-id=\"fileSize\"\n                          label=\"\'File Size (bytes)\'\"\n                          value=\"$ctrl.mediaInfo.fileSize | number\">&nbsp;</asset-info-row>\n    <asset-info-row input-id=\"fileExtension\"\n                          label=\"\'Filename Extension\'\"\n                          value=\"$ctrl.mediaInfo.fileExtension\">&nbsp;</asset-info-row>\n    <asset-info-row input-id=\"dimensions\"\n                          label=\"\'Dimensions\'\"\n                          ng-if=\"$ctrl.hasPixels()\"\n                          value=\"$ctrl.mediaInfo.width + \'x\' + $ctrl.mediaInfo.height\">&nbsp;</asset-info-row>\n    <asset-info-row input-id=\"bitDepth\"\n                          label=\"\'Bit Depth\'\"\n                          ng-if=\"$ctrl.hasPixels()\"\n                          value=\"$ctrl.mediaInfo.bitDepth\">&nbsp;</asset-info-row>\n    <asset-info-row input-id=\"frameRate\"\n                          ng-if=\"$ctrl.isVideoModal()\"\n                          label=\"\'Frame Rate\'\"\n                          value=\"$ctrl.mediaInfo.frameRate\">&nbsp;</asset-info-row>\n    <asset-info-row input-id=\"codec\"\n                          label=\"\'Codec\'\"\n                          ng-if=\"$ctrl.isVideoModal()\"\n                          value=\"$ctrl.mediaInfo.codec\">&nbsp;</asset-info-row>\n    <asset-info-row input-id=\"externalSource\"\n                          label=\"\'External Source\'\"\n                          value=\"$ctrl.packageContent.externalMediaSource\">&nbsp;</asset-info-row>\n    <asset-info-row input-id=\"externalId\"\n                          label=\"\'External ID\'\"\n                          value=\"$ctrl.packageContent.externalMediaId\">&nbsp;</asset-info-row>\n</div>\n");
        $templateCache.put("package/editor/components/view/metadata/renderers/package-adpreroll-metadata-template.html", "<div class=\"row clearfix spacer-top-lg\">\n	<div class=\"col-md-12 column\">\n		<form class=\"form-horizontal\"\n			  role=\"form\">\n\n			<!-- Nickname -->\n			<div class=\"form-group\">\n				<label for=\"nickname\"\n					   class=\"col-sm-2 control-label\">Nickname</label>\n\n				<div class=\"col-sm-9 pad-text-input-col\">\n					<input type=\"text\"\n						   class=\"form-control input-sm prism-text-input\"\n						   autocomplete=\"off\"\n						   ng-model=\"$ctrl.packageObject.name\"\n						   id=\"nickname\"/>\n				</div>\n				<div class=\"required-text-input\"\n					 required\n					 x-required-indicator>\n				</div>\n			</div>\n\n			<!-- Title -->\n			<div class=\"form-group\">\n				<label for=\"title\"\n					   class=\"col-sm-2 control-label\">Title</label>\n\n				<div class=\"col-sm-9 pad-text-input-col\">\n					<input type=\"text\"\n						   class=\"form-control prism-text-input\"\n						   ng-model=\"$ctrl.packageObject.title\"\n						   id=\"title\"\n						   autocomplete=\"off\"/>\n				</div>\n				<div class=\"col-sm-1 error-warning spacer-top-xsm\">\n					<error-warning-indicator error-warning=\"$ctrl.pkgEditCtrl.checkErrorWarning(\'episodeTitle\', $ctrl.packageObject.name)\">\n					</error-warning-indicator>\n				</div>\n				<div class=\"required-text-input\"\n					 required\n					 x-required-indicator>\n				</div>\n			</div>\n\n			<!-- Category -->\n			<div class=\"form-group\">\n				<label for=\"category\"\n					   class=\"col-md-2 control-label\">Category</label>\n				<div class=\"col-md-2 metadata-control-col\">\n					<dropdown-select id=\"category\"\n                                     class=\"hide-required-indicator\"\n									 ng-model=\"$ctrl.packageObject.category\"\n                                     required\n									 prompt=\"Select Category\"\n									 label-field=\"name\"\n									 clearable=\"true\"\n									 collection=\"$ctrl.availableCategories\">\n					</dropdown-select>\n				</div>\n				<div class=\"col-md-7 metadata-icons-col\">\n					<div class=\"col-sm-1 error-warning error-warning-select\">\n						<error-warning-indicator\n							error-warning=\"$ctrl.pkgEditCtrl.checkErrorWarning(\'category\', $ctrl.packageObject.name)\">\n						</error-warning-indicator>\n					</div>\n					<div class=\"required-select\"\n						 required\n						 x-required-indicator>\n					</div>\n				</div>\n			</div>\n\n			<!-- Sequence Number (ads & prerolls) -->\n			<div class=\"form-group\"\n				 ng-show=\"$ctrl.packageObject.content.type === \'Ad/PreRoll\'\">\n				<label for=\"sequenceNumber\"\n					   class=\"col-sm-2 control-label\">Sequence Number</label>\n\n				<div class=\"col-sm-1 pad-text-input-col\">\n					<input type=\"text\"\n						   class=\"form-control prism-text-input\"\n						   ng-focus=\"inputFocused=true\"\n						   ng-blur=\"inputFocused=false\"\n						   id=\"movieSequenceNumber\"\n						   ng-model=\"$ctrl.packageObject.sequenceNumber\"/>\n				</div>\n			</div>\n		</form>\n	</div>\n</div>\n");
        $templateCache.put("package/editor/components/view/metadata/renderers/package-short-longform-metadata-template.html", "<div class=\"row clearfix spacer-top-lg\">\n	<div class=\"col-md-12 column\">\n		<form class=\"form-horizontal\"\n			  role=\"form\">\n\n			<!-- Nickname -->\n			<div class=\"form-group\">\n				<label for=\"nickname\"\n					   class=\"col-sm-2 control-label\">Nickname</label>\n\n				<div class=\"col-sm-9 pad-text-input-col\">\n					<enhanced-textinput model-prop=\"$ctrl.packageObject.name\"\n										max-chars=\"255\"\n										input-id=\"nickname\">\n                    </enhanced-textinput>\n				</div>\n				<div class=\"required-text-input\"\n					 required\n					 x-required-indicator>\n				</div>\n			</div>\n\n			<!-- Title -->\n<!--			<div class=\"form-group\">-->\n<!--				<label for=\"title\"-->\n<!--					   class=\"col-sm-2 control-label\">Title</label>-->\n\n<!--				<div class=\"col-sm-9 pad-text-input-col\">-->\n<!--					<enhanced-textinput model-prop=\"$ctrl.packageObject.title\"-->\n<!--										max-chars=\"{{$ctrl.maxTitleLength}}\"-->\n<!--										disable-prop=\"$ctrl.lockableFields.title\"-->\n<!--										input-id=\"title\">-->\n<!--					</enhanced-textinput>-->\n<!--				</div>-->\n<!--				<div class=\"col-sm-1 lock-width spacer-top-xsm\"-->\n<!--                     ng-if=\"$ctrl.isLongformEditor\">-->\n<!--					<ui-lock id=\"titleLock\"-->\n<!--							 is-locked=\"$ctrl.lockableFields.title\"</ui-lock>-->\n<!--				</div>-->\n<!--				<div class=\"col-sm-1 error-warning spacer-top-xsm\">-->\n<!--					<error-warning-indicator error-warning=\"$ctrl.pkgEditCtrl.checkErrorWarning(\'episodeTitle\', $ctrl.packageObject.name)\">-->\n<!--					</error-warning-indicator>-->\n<!--				</div>-->\n<!--				<div class=\"required-text-input\"-->\n<!--					 required-->\n<!--					 x-required-indicator>-->\n<!--				</div>-->\n<!--			</div>-->\n\n			<!-- Production ID -->\n			<div class=\"form-group\">\n				<label for=\"prodNumber\"\n					   class=\"col-sm-2 control-label\">Production ID</label>\n\n				<div class=\"col-sm-3 pad-text-input-col\">\n					<enhanced-textinput model-prop=\"$ctrl.packageObject.productionNumber\"\n										max-chars=\"18\"\n										disable-prop=\"$ctrl.lockableFields.productionNumber\"\n										input-id=\"prodNumber\">\n					</enhanced-textinput>\n				</div>\n				<div class=\"col-sm-1 lock-width spacer-top-xsm\"\n                     ng-if=\"$ctrl.isLongformEditor\">\n					<ui-lock id=\"prodNumberLock\"\n							 is-locked=\"$ctrl.lockableFields.productionNumber\">\n					</ui-lock>\n				</div>\n				<div class=\"col-sm-1 error-warning spacer-top-xsm\">\n					<error-warning-indicator error-warning=\"$ctrl.pkgEditCtrl.checkErrorWarning(\'productionNumber\', $ctrl.packageObject.name)\">\n					</error-warning-indicator>\n				</div>\n				<div class=\"required-text-input\"\n					 required\n					 x-required-indicator></div>\n			</div>\n\n			<!-- Short Description -->\n<!--			<div class=\"form-group\">-->\n<!--				<label for=\"shortDescription\"-->\n<!--					   class=\"col-sm-2 control-label\">Short Description</label>-->\n<!--				<div class=\"col-sm-9 pad-text-input-col\">-->\n<!--					<enhanced-textarea ng-model=\"$ctrl.packageObject.shortDescription\"-->\n<!--									   max-chars=\"{{$ctrl.maxShortDescLength}}\"-->\n<!--									   input-rows=\"3\"-->\n<!--									   input-id=\"shortDescription\">-->\n<!--					</enhanced-textarea>-->\n<!--				</div>-->\n<!--				<div class=\"col-sm-1 error-warning error-warning-text-area-3\">-->\n<!--					<error-warning-indicator error-warning=\"$ctrl.pkgEditCtrl.checkErrorWarning(\'desc1\', $ctrl.packageObject.name)\">-->\n<!--					</error-warning-indicator>-->\n<!--				</div>-->\n<!--				<div class=\"required-text-area-3\"-->\n<!--					 required-->\n<!--					 x-required-indicator>-->\n<!--                </div>-->\n<!--			</div>-->\n\n			<!-- Long Description -->\n<!--			<div class=\"form-group\">-->\n<!--				<label for=\"longDescription\"-->\n<!--					   class=\"col-sm-2 control-label\">Long Description</label>-->\n<!--				<div class=\"col-sm-9 pad-text-input-col\">-->\n<!--					<enhanced-textarea ng-model=\"$ctrl.packageObject.longDescription\"-->\n<!--									   max-chars=\"{{$ctrl.maxLongDescLength}}\"-->\n<!--									   input-rows=\"6\"-->\n<!--									   input-id=\"longDescription\">-->\n<!--					</enhanced-textarea>-->\n<!--				</div>-->\n<!--				<div class=\"col-sm-1 error-warning error-warning-text-area-6\">-->\n<!--					<error-warning-indicator error-warning=\"$ctrl.pkgEditCtrl.checkErrorWarning(\'desc2\', $ctrl.packageObject.name)\">-->\n<!--					</error-warning-indicator>-->\n<!--				</div>-->\n<!--				<div class=\"required-text-area-6\"-->\n<!--					 required-->\n<!--					 x-required-indicator></div>-->\n<!--			</div>-->\n\n			<!-- Keywords -->\n<!--			<div class=\"form-group\">-->\n<!--				<label for=\"keywords\"-->\n<!--					   class=\"col-sm-2 control-label\">Keywords</label>-->\n\n<!--				<div class=\"col-sm-9 pad-text-input-col\">-->\n<!--					<enhanced-textinput model-prop=\"$ctrl.packageObject.keywords\"-->\n<!--										max-chars=\"200\"-->\n<!--										input-id=\"keywords\">-->\n<!--					</enhanced-textinput>-->\n<!--				</div>-->\n<!--				<div class=\"col-sm-1 error-warning spacer-top-xsm\">-->\n<!--					<error-warning-indicator error-warning=\"$ctrl.pkgEditCtrl.checkErrorWarning(\'keywords\', $ctrl.packageObject.name)\">-->\n<!--					</error-warning-indicator>-->\n<!--				</div>-->\n<!--				<div class=\"required-text-input\"-->\n<!--					 required-->\n<!--					 x-required-indicator>-->\n<!--                </div>-->\n<!--			</div>-->\n\n			<!-- Primary Language -->\n<!--			<div class=\"form-group\">-->\n<!--				<label for=\"primaryLanguage\"-->\n<!--					   class=\"col-sm-2 control-label\">Primary Language</label>-->\n\n<!--				<div class=\"col-sm-4 metadata-control-col\">-->\n<!--					<dropdown-select id=\"primaryLanguage\"-->\n<!--                                     class=\"hide-required-indicator\"-->\n<!--									 ng-model=\"$ctrl.packageObject.primaryLanguage\"-->\n<!--                                     required-->\n<!--									 prompt=\"Spoken Language\"-->\n<!--									 label-field=\"name\"-->\n<!--									 clearable=\"true\"-->\n<!--									 collection=\"$ctrl.languages\"-->\n<!--                                     sort-collection=\"false\"-->\n<!--									 btn-min-width=\"295\"-->\n<!--									 ng-disabled=\"!$ctrl.pkgEditCtrl.statusAllowsEdit() || !$ctrl.writePerms\">-->\n<!--					</dropdown-select>-->\n<!--				</div>-->\n<!--				<div class=\"col-md-5 metadata-icons-col\">-->\n<!--					<div class=\"col-sm-1 error-warning error-warning-select\">-->\n<!--						<error-warning-indicator-->\n<!--							error-warning=\"$ctrl.pkgEditCtrl.checkErrorWarning(\'primaryLanguage\', $ctrl.packageObject.name)\">-->\n<!--						</error-warning-indicator>-->\n<!--					</div>-->\n<!--					<div class=\"required-select\"-->\n<!--						 required-->\n<!--						 x-required-indicator>-->\n<!--					</div>-->\n<!--				</div>-->\n<!--			</div>-->\n\n			<!-- Category -->\n			<div class=\"form-group\">\n				<label for=\"category\"\n					   class=\"col-md-2 control-label\">Category</label>\n				<div class=\"col-md-4 metadata-control-col\">\n					<dropdown-select id=\"category\"\n                                     class=\"hide-required-indicator\"\n									 ng-model=\"$ctrl.packageObject.category\"\n                                     required\n									 prompt=\"Select Category\"\n									 label-field=\"name\"\n									 clearable=\"true\"\n									 collection=\"$ctrl.availableCategories\"\n									 btn-min-width=\"295\"\n									 ng-disabled=\"$ctrl.lockableFields.category || !$ctrl.pkgEditCtrl.statusAllowsEdit() || !$ctrl.writePerms\">\n					</dropdown-select>\n				</div>\n				<div class=\"col-md-5 metadata-icons-col\">\n					<div class=\"col-sm-1 select-lock\">\n						<ui-lock id=\"categoryLock\"\n								 is-locked=\"$ctrl.lockableFields.category\">\n						</ui-lock>\n					</div>\n					<div class=\"col-sm-1 error-warning error-warning-select\">\n						<error-warning-indicator\n							error-warning=\"$ctrl.pkgEditCtrl.checkErrorWarning(\'category\', $ctrl.packageObject.name)\">\n						</error-warning-indicator>\n					</div>\n					<div class=\"required-select\"\n						 required\n						 x-required-indicator>\n                    </div>\n				</div>\n			</div>\n\n			<!-- Original Release Date -->\n			<div class=\"form-group\">\n				<label for=\"ord\"\n					   class=\"col-sm-2 control-label\">Original Release Date</label>\n\n				<div class=\"col-sm-3 pad-text-input-col\">\n					<date-picker id=\"ord\"\n								 ng-model=\"$ctrl.packageObject.originalReleaseDate\"\n								 timezone-offset-millis=\"\'SERVER\'\"\n								 disabled=\"$ctrl.lockableFields.originalReleaseDate\">\n					</date-picker>\n				</div>\n				<div class=\"col-sm-1 lock-width spacer-top-xsm\"\n                     ng-if=\"$ctrl.isLongformEditor\">\n					<ui-lock id=\"ordLock\"\n							 is-locked=\"$ctrl.lockableFields.originalReleaseDate\">\n					</ui-lock>\n				</div>\n				<div class=\"col-sm-1 error-warning spacer-top-xsm\">\n					<error-warning-indicator\n						error-warning=\"$ctrl.pkgEditCtrl.checkErrorWarning(\'originalReleaseDate\', $ctrl.packageObject.name)\">\n					</error-warning-indicator>\n				</div>\n				<div class=\"required-date-picker\"\n					 required\n					 x-required-indicator>\n                </div>\n			</div>\n\n			<!-- Air Time -->\n			<div class=\"form-group\">\n				<label for=\"airTime\"\n					   class=\"col-sm-2 control-label\">Air Time</label>\n\n				<div class=\"col-sm-4 pad-text-input-col time-component top-margin auto-width\">\n					<prism-time-picker id=\"airTime\"\n									 ng-model=\"$ctrl.packageObject.airTime\"\n									 hour-step=\"1\"\n									 minute-step=\"15\"\n									 show-meridian=\"true\">\n					</prism-time-picker>\n				</div>\n				<div class=\"required-time-picker\"\n					 required\n					 x-required-indicator>\n                </div>\n			</div>\n\n			<!-- Season (dropdown) and Sequence Number -->\n			<div class=\"form-group\"\n				 ng-show=\"$ctrl.packageObject.content.type === \'Series\'\">\n				<label for=\"season\"\n					   class=\"col-sm-2 control-label\">Season</label>\n				<div class=\"col-md-4 metadata-control-col\">\n					<dropdown-select id=\"season\"\n                                     class=\"hide-required-indicator\"\n									 ng-model=\"$ctrl.packageObject.season\"\n                                     ng-required=\"$ctrl.packageObject.content.type === \'Series\'\"\n									 prompt=\"Select Season\"\n									 label-field=\"name\"\n									 clearable=\"true\"\n									 collection=\"$ctrl.availableSeasons\"\n									 showdates=\"true\"\n									 btn-min-width=\"295\"\n									 ng-disabled=\"$ctrl.lockableFields.season || !$ctrl.pkgEditCtrl.statusAllowsEdit() || !$ctrl.writePerms\">\n					</dropdown-select>\n				</div>\n				<div class=\"col-md-5 row\">\n					<div class=\"col-sm-2 metadata-icons-col\">\n						<div class=\"col-sm-1 select-lock\">\n							<ui-lock id=\"seasonLock\"\n									 is-locked=\"$ctrl.lockableFields.season\">\n                            </ui-lock>\n						</div>\n						<div class=\"col-sm-1 error-warning error-warning-select\">\n							<error-warning-indicator\n								error-warning=\"$ctrl.pkgEditCtrl.checkErrorWarning(\'season\', $ctrl.packageObject.name)\">\n							</error-warning-indicator>\n						</div>\n						<div class=\"required-select\"\n							 required\n							 x-required-indicator>\n                        </div>\n					</div>\n					<label for=\"sequenceNumber\"\n						   class=\"control-label\"\n						   ng-class=\"{ \'col-sm-6\': $ctrl.hasVolumes(), \'col-sm-4\': !$ctrl.hasVolumes() }\">\n                        Sequence Number\n                    </label>\n					<div class=\"col-sm-3 sequence-num-field\">\n						<input type=\"text\"\n							   class=\"form-control prism-text-input\"\n							   ng-focus=\"inputFocused=true\"\n							   ng-blur=\"inputFocused=false\"\n							   id=\"sequenceNumber\"\n							   ng-model=\"$ctrl.packageObject.sequenceNumber\"/>\n					</div>\n					<div class=\"col-sm-1 error-warning spacer-top-xsm\">\n						<error-warning-indicator error-warning=\"$ctrl.pkgEditCtrl.checkErrorWarning(\'sequenceNumber\', $ctrl.packageObject.name)\">\n						</error-warning-indicator>\n					</div>\n					<div class=\"required-select\"\n						 required\n						 x-required-indicator>\n					</div>\n				</div>\n			</div>\n\n			<!-- Volume (dropdown) and Volume Sequence Number -->\n			<div class=\"form-group\"\n				 ng-show=\"$ctrl.hasVolumes()\">\n				<label for=\"volume\"\n					   class=\"col-sm-2 control-label\">Volume</label>\n				<div class=\"col-md-4 metadata-control-col\">\n					<dropdown-select id=\"volume\"\n                                     class=\"hide-required-indicator\"\n									 ng-model=\"$ctrl.packageObject.volume\"\n                                     ng-required=\"$ctrl.packageObject.volumeRequired && $ctrl.hasVolumes()\"\n									 prompt=\"Select Volume\"\n									 label-field=\"name\"\n									 clearable=\"true\"\n									 collection=\"$ctrl.availableVolumes\"\n									 btn-min-width=\"295\"\n									 ng-disabled=\"$ctrl.lockableFields.volume || !$ctrl.pkgEditCtrl.statusAllowsEdit() || !$ctrl.writePerms\">\n					</dropdown-select>\n				</div>\n				<div class=\"col-md-5 row\">\n					<div class=\"col-sm-2 metadata-icons-col\">\n						<div class=\"col-sm-1 select-lock\">\n							<ui-lock id=\"volumeLock\"\n									 is-locked=\"$ctrl.lockableFields.volume\">\n                            </ui-lock>\n						</div>\n						<div class=\"col-sm-1 error-warning error-warning-select\">\n							<error-warning-indicator\n								error-warning=\"$ctrl.pkgEditCtrl.checkErrorWarning(\'volume\', $ctrl.packageObject.name)\">\n							</error-warning-indicator>\n						</div>\n						<div ng-if=\"$ctrl.packageObject.volumeRequired\">\n							<div class=\"required-select\"\n								 required\n								 x-required-indicator>\n							</div>\n						</div>\n					</div>\n					<label for=\"volumeSequenceNumber\"\n						   class=\"control-label col-sm-6\">Volume Sequence Number</label>\n					<div class=\"col-sm-3 sequence-num-field\">\n						<input type=\"text\"\n							   class=\"form-control prism-text-input\"\n							   ng-focus=\"inputFocused=true\"\n							   ng-blur=\"inputFocused=false\"\n							   id=\"volumeSequenceNumber\"\n							   ng-model=\"$ctrl.packageObject.volumeSequenceNumber\"/>\n					</div>\n					<div class=\"col-sm-1 error-warning spacer-top-xsm\">\n						<error-warning-indicator error-warning=\"$ctrl.pkgEditCtrl.checkErrorWarning(\'volumeSequenceNumber\', $ctrl.packageObject.name)\">\n						</error-warning-indicator>\n					</div>\n					<div ng-if=\"$ctrl.packageObject.volumeRequired\">\n						<div class=\"required-select\"\n							 required\n							 x-required-indicator>\n						</div>\n					</div>\n				</div>\n			</div>\n\n			<!-- Sequence Number (movie) -->\n			<div class=\"form-group\"\n				 ng-show=\"$ctrl.packageObject.content.type === \'Movie/Special\'\">\n				<label for=\"sequenceNumber\"\n					   class=\"col-sm-2 control-label\">Sequence Number</label>\n\n				<div class=\"col-sm-1 pad-text-input-col\">\n					<input type=\"text\"\n						   class=\"form-control prism-text-input\"\n						   ng-focus=\"inputFocused=true\"\n						   ng-blur=\"inputFocused=false\"\n						   id=\"movieSequenceNumber\"\n						   ng-model=\"$ctrl.packageObject.sequenceNumber\"/>\n				</div>\n				<div class=\"col-sm-1 error-warning spacer-top-xsm\">\n					<error-warning-indicator error-warning=\"$ctrl.pkgEditCtrl.checkErrorWarning(\'sequenceNumber\', $ctrl.packageObject.name)\">\n					</error-warning-indicator>\n				</div>\n				<div class=\"required-text-input\"\n					 required\n					 x-required-indicator>\n				</div>\n			</div>\n\n			<!-- TMS ID -->\n			<div class=\"form-group\">\n				<label for=\"tmsId\"\n					   class=\"col-sm-2 control-label\">TMS ID</label>\n\n				<div class=\"col-sm-3 pad-text-input-col\">\n					<enhanced-textinput model-prop=\"$ctrl.packageObject.tMSId\"\n										max-chars=\"14\"\n										input-id=\"tmsId\">\n					</enhanced-textinput>\n				</div>\n				<div class=\"col-sm-1 error-warning spacer-top-xsm\">\n					<error-warning-indicator error-warning=\"$ctrl.pkgEditCtrl.checkErrorWarning(\'tmsId\', $ctrl.packageObject.name)\">\n					</error-warning-indicator>\n				</div>\n                <div ng-if=\"$ctrl.isLongformEditor\">\n                    <div class=\"required-text-input\"\n                         required\n                         x-required-indicator>\n                    </div>\n                </div>\n			</div>\n		</form>\n	</div>\n</div>\n");
        $templateCache.put("package/editor/components/view/preview/header/package-preview-header-template.html", "<div class=\"row clearfix\">\n	<div class=\"col-sm-12 column\">\n		<div class=\"row\">\n			<div class=\"col-md-3\">\n				<div class=\"prism-form-item-label\">\n					{{pkgPreviewHeaderCtrl.mediaType}}\n				</div>\n			</div>\n			<div class=\"col-sm-9\">\n				<div class=\"pull-right\" style=\"white-space: nowrap\">\n					<input type=\"checkbox\"\n						   class=\"top-margin-sm\" id=\"masterStartEndCB\"\n						   ng-show=\"pkgPreviewHeaderCtrl.showMasterVideoOffset && !pkgPreviewCtrl.selectedVideoAudio.prePostRollId && !pkgPreviewCtrl.selectedVideoAudio.isAudio\"\n						   ng-model=\"pkgPreviewCtrl.useMasterVideoOffset\"\n					       ng-change=\"pkgPreviewCtrl.masterVideoOffsetChangeHandler()\"/>\n					<label for=\"masterStartEndCB\" class=\"prism-form-item-label\" style=\"width: auto; margin-right: 15px;\"\n						   ng-show=\"pkgPreviewHeaderCtrl.showMasterVideoOffset && !pkgPreviewCtrl.selectedVideoAudio.prePostRollId && !pkgPreviewCtrl.selectedVideoAudio.isAudio\">\n						Master Start/End Only\n					</label>\n                    <button class=\"btn btn-default prism-button\"\n                            ng-show=\"pkgPreviewHeaderCtrl.showCreateSnapshot\"\n                            ng-disabled=\"!pkgPreviewCtrl.canCreateSnapshot()\"\n                            ng-click=\"pkgPreviewCtrl.createSnapshot()\">\n                        <i class=\"fa fa-camera\"></i>\n                    </button>\n					<button class=\"btn btn-default prism-button\"\n							ng-show=\"pkgPreviewHeaderCtrl.showCreateProxy\"\n							ng-disabled=\"!pkgPreviewCtrl.canCreateProxy(pkgPreviewHeaderCtrl.mediaObj)\"\n							ng-click=\"pkgPreviewCtrl.createProxy(pkgPreviewHeaderCtrl.mediaType.toLowerCase())\">\n						Create Proxy\n					</button>\n					<button class=\"btn btn-default prism-button\"\n							ng-show=\"pkgPreviewHeaderCtrl.showDownload\"\n							ng-click=\"pkgPreviewCtrl.download(pkgPreviewHeaderCtrl.mediaType.toLowerCase())\">\n						Download\n					</button>\n				</div>\n			</div>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("package/editor/components/view/timings/editor/pkg-timing-edit-modal-template.html", "<div class=\"modal-header\">\n    <h5 align=\"center\"\n        class=\"modal-title\">Program Event</h5>\n</div>\n<div class=\"modal-body\">\n    <form class=\"form-horizontal\">\n        <div class=\"form-group no-margin-bottom\">\n            <label for=\"timingTypeDD\"\n                   class=\"col-sm-3 col-sm-offset-2 control-label\">Type</label>\n\n            <div class=\"col-sm-3 metadata-control-col\">\n                <dropdown-select id=\"timingTypeDD\"\n                                 ng-model=\"pkgTimingEditor.selectedTimingType\"\n                                 btn-min-width=\"165\"\n                                 collection=\"pkgTimingEditor.timingTypes\">\n                </dropdown-select>\n            </div>\n        </div>\n        <div class=\"form-group no-margin-bottom\">\n            <label for=\"timingStart\"\n                   class=\"col-sm-3 col-sm-offset-2 control-label\">Timecode Start</label>\n\n            <div class=\"col-sm-4 pad-text-input-col\">\n                <timecode-input ng-model=\"pkgTimingEditor.selectedTiming.startTC\"\n                                id=\"timingStart\"></timecode-input>\n            </div>\n        </div>\n        <div class=\"form-group no-margin-bottom\">\n            <label for=\"timingEnd\"\n                   class=\"col-sm-3 col-sm-offset-2 control-label\">Timecode End</label>\n\n            <div class=\"col-sm-4 pad-text-input-col\">\n                <timecode-input ng-model=\"pkgTimingEditor.selectedTiming.endTC\"\n                                id=\"timingEnd\"></timecode-input>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-3 col-sm-offset-2 control-label\">Duration</label>\n            <div class=\"col-sm-4 pad-text-input-col\">\n                <fieldset ng-disabled=\"true\">\n                    <timecode-input ng-model=\"pkgTimingEditor.selectedTiming.durationTC\"\n                                    id=\"timingDuration\"></timecode-input>\n                </fieldset>\n            </div>\n        </div>\n        <div class=\"form-group no-margin-bottom\">\n            <small class=\"col-sm-12 base-label\"><em>* All timecodes must be entered in non-drop format</em></small>\n        </div>\n        <div class=\"form-group\">\n            <small class=\"col-sm-12 base-label\"><em>* Duration for manually entered timecodes will be calculated once\n                                                    the main video has been ingested and timecodes are saved</em>\n            </small>\n        </div>\n    </form>\n</div>\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"pkgTimingEditor.cancel()\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"pkgTimingEditor.onOk()\"\n            ng-disabled=\"pkgTimingEditor.disableOk()\">\n        Save\n    </button>\n</div>\n");
        $templateCache.put("package/editor/components/view/timings/searchView/packagetimings-search-view-template.html", "<div class=\"collaborator-edit-view-container\">\n	<div class=\"row\">\n		<div class=\"col-md-12\">\n			<form name=\"$ctrl.timingsSearchForm\">\n				<div ui-grid=\"$ctrl.currentGridOptions\" class=\"edit-search-grid protected-grid\" ui-grid-selection ui-grid-pagination\n						ui-grid-resize-columns id=\"pkgTimingsSearchGrid\"></div>\n			</form>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("system/fileSystem/editView/properties/components/fileSystemParameters/file-system-parameters-template.html", "<div ng-show=\"$ctrl.hasParameters()\"\n    class=\"edit-view-container\">\n    <div>\n        <div class=\"prism-form-heading\">\n            {{$ctrl.selectedTypeName}} Parameters\n        </div>\n\n        <!-- Parameters -->\n        <div ng-repeat=\"parameter in $ctrl.typeParameters\"\n             class=\"form-group\">\n            <label for=\"{{parameter.name}}\" class=\"col-sm-3 control-label\">\n                {{parameter.name}}\n            </label>\n            <div class=\"col-sm-4 pad-text-input-col\">\n                <input id=\"{{parameter.name}}\"\n                       class=\"prism-text-input input-sm\"\n                       type=\"{{(parameter.type == \'boolean\') ? \'checkbox\' : \'text\'}}\"\n                       ng-model=\"parameter.value\"\n                       ng-change=\"$ctrl.onParameterChanged(parameter)\"\n                       ng-required=\"parameter.required\"/>\n                <label for=\"{{parameter.name}}\"\n                       ng-if=\"parameter.type == \'boolean\'\">\n                </label>\n            </div>\n            <div ng-if=\"parameter.required\">\n                <div class=\"required-text-input\"\n                     required\n                     x-required-indicator>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/audioMappingRules/partner-audio-mapping-rules-grid-template.html", "<div id=\"partnerAudioMappingRules\" class=\"row-no-padding\">\n\n    <!-- Pacifier -->\n    <div class=\"loadingIndicator\">\n        <div data-lb-progress=\"$ctrl.loadingIndicator\"\n             ng-show=\"$ctrl.loadingIndicator.show\">\n        </div>\n    </div>\n\n\n    <!-- Audio Mapping Rules -->\n    <form name=\"$ctrl.editorForm\">\n        <div class=\"audio-mapping-button-row flex-row-container padding-top-lg padding-bottom-md\">\n            <div class=\"padding-left-md padding-right-md\">\n                <input\n                    id=\"uniqueLangsCheckbox\"\n                    ng-model=\"$ctrl.partnerObject.audioRoutingUniqueLanguagesFlag\"\n                    type=\"checkbox\"/>\n                <label\n                    class=\"control-label\"\n                    for=\"uniqueLangsCheckbox\">\n                    Match Unique Language(s) Only\n                </label>\n            </div>\n            <div class=\"padding-left-md padding-right-md\">\n                <input\n                    id=\"uniqueRolesCheckbox\"\n                    ng-model=\"$ctrl.partnerObject.audioRoutingUniqueRolesFlag\"\n                    type=\"checkbox\"/>\n                <label\n                    class=\"control-label\"\n                    for=\"uniqueRolesCheckbox\">\n                    Match Unique Role(s) Only\n                </label>\n            </div>\n            <div class=\"padding-left-md padding-right-md\">\n                <input\n                    id=\"matchFirstCheckbox\"\n                    ng-model=\"$ctrl.partnerObject.audioRoutingFirstMatchOnlyFlag\"\n                    type=\"checkbox\"/>\n                <label\n                    class=\"control-label\"\n                    for=\"matchFirstCheckbox\">\n                    Select First Language/Role Only\n                </label>\n            </div>\n        </div>\n\n\n        <!-- Grid -->\n        <div id=\"partnerAudioMapRulesGrid\"\n             class=\"breadcrumb-tab-edit-search-grid grid unsorted-grid search-grid wrap-column-headers-grid\"\n             ui-grid=\"$ctrl.gridOptions\"\n             ui-grid-edit\n             ui-grid-selection\n             ui-grid-resize-columns>\n        </div>\n    </form>\n\n    <!-- Toolbar -->\n    <toolbar\n        button-defs=\"$ctrl.toolbarButtonDefs\">\n    </toolbar>\n\n</div>\n\n");
        $templateCache.put("system/partner/editor/components/view/properties/partner-properties-view-template.html", "<div class=\"row\">\n    <div class=\"col-md-12\">\n        <fieldset>\n            <div class=\"edit-full-height edit-view partner-properties-view\">\n                <div class=\"loadingIndicator\">\n                    <div data-lb-progress=\"partnerEditCtrl.loadingIndicator\"\n                         ng-show=\"partnerEditCtrl.loadingIndicator.show\"></div>\n                </div>\n                <form class=\"form-horizontal\" role=\"form\" name=\"partnerPropCtrlr.editorForm\">\n                    <div class=\"edit-view-container\">\n                        <div ng-include=\"\'system/partner/editor/components/view/properties/renderers/partner-properties-general-template.html\'\"></div>\n                    </div>\n                    <hr/>\n                    <hr/>\n                    <div class=\"edit-view-container\"  ng-if=\"!partnerPropCtrlr.partnerObject.parentId\">\n                        <div ng-include=\"\'system/partner/editor/components/view/properties/renderers/partner-properties-defaults-template.html\'\"></div>\n                    </div>\n                    <hr/>\n                    <div class=\"edit-view-container\">\n                        <div ng-include=\"\'system/partner/editor/components/view/properties/renderers/partner-properties-external-embargo-template.html\'\"></div>\n                    </div>\n                    <hr/>\n                    <div class=\"edit-view-container\">\n                        <div ng-include=\"\'system/partner/editor/components/view/properties/renderers/partner-properties-pre-delivery-qc-approval-template.html\'\"></div>\n                    </div>\n                    <hr/>\n                    <div class=\"edit-view-container\">\n                        <div ng-include=\"\'system/partner/editor/components/view/properties/renderers/partner-properties-formatting-template.html\'\"></div>\n                    </div>\n                </form>\n            </div>\n        </fieldset>\n    </div>\n</div>\n");
        $templateCache.put("system/templates/mediaAcceptProfiles/components/validators/renderers/track-validator-xml-textarea-template.html", "\n<div class=\"edit-view-container\">\n    <div class=\"row\">\n        <div class=\"col-md-4\">\n            <div class=\"prism-form-heading\">Track Validator XML</div>\n        </div>\n    </div>\n\n    <hr/>\n\n    <div class=\"form-group\">\n        <div class=\"col-lg-11 pad-text-input-col\">\n            <label for=\"trackValidatorInput\">&nbsp;</label>\n            <textarea class=\"form-control prism-text-input\"\n                      id=\"trackValidatorInput\"\n                      rows=\"36\"\n                      ng-model=\"$ctrl.editData.trackValidator\">\n            </textarea>\n        </div>\n    </div>\n\n</div>\n");
        $templateCache.put("meta/content/editor/components/view/categories/editor/content-categories-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n    <div class=\"row-no-padding\">\n        <navbar filter-enabled=\"$ctrl.filterEnabled\"\n                search-enabled=\"$ctrl.searchEnabled\"></navbar>\n    </div>\n    <div class=\"loadingIndicator\">\n        <div data-lb-progress=\"$ctrl.loadingIndicator\"\n             ng-show=\"$ctrl.loadingIndicator.show\"></div>\n    </div>\n\n\n    <div class=\"row-no-padding\">\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n            <breadcrumb tab-name=\"$ctrl.categoryBreadcrumb.name\"\n                        param-map=\"$ctrl.breadcrumbMap\"></breadcrumb>\n            <uib-tabset horizontal=\"true\"\n                        type=\"pills\"\n                        class=\"edit-view-tabbar\"\n                        active=\"$ctrl.viewTab\">\n\n                <!-- Properties -->\n                <uib-tab heading=\"Properties\"\n                         index=\"\'properties\'\"\n                         select=\"$ctrl.onTabSelect(\'properties\')\"\n                         deselect=\"$ctrl.onTabDeselect(\'properties\', $event)\">\n                    <content-categories-properties-edit-view\n                            content-breadcrumb=\"$ctrl.contentBreadcrumb\"\n                            category-breadcrumb=\"$ctrl.categoryBreadcrumb\">\n                    </content-categories-properties-edit-view>\n                </uib-tab>\n\n                <!-- Subscriptions -->\n                <uib-tab heading=\"Subscriptions\"\n                         index=\"\'subscriptions\'\"\n                         select=\"$ctrl.onTabSelect(\'subscriptions\')\"\n                         deselect=\"$ctrl.onTabDeselect(\'subscriptions\', $event)\"\n                         disable=\"$ctrl.subscriptionsDisabled()\">\n                    <subscription-edit-grid\n                            ng-if=\"$ctrl.viewTab === \'subscriptions\'\"\n                            content-breadcrumb=\"$ctrl.contentBreadcrumb\"\n                            category-breadcrumb=\"$ctrl.categoryBreadcrumb\"\n                            is-partner=\"false\">\n                    </subscription-edit-grid>\n                </uib-tab>\n            </uib-tabset>\n        </div>\n    </div>\n\n</div>\n");
        $templateCache.put("meta/content/editor/components/view/categories/searchView/content-categories-searchview-template.html", "<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\"></div>\n</div>\n<div class=\"row-no-padding\">\n    <div class=\"col-md-12 col-lg-12 no-padding\">\n        <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n            <div ui-grid=\"$ctrl.currentGridOptions\" class=\"edit-grid search-grid\"\n                 ui-grid-resize-columns id=\"contentCategoriesSearchGrid\"></div>\n        </form>\n    </div>\n</div>\n<!-- Toolbar -->\n<toolbar button-defs=\"$ctrl.toolbarButtonDefs\"></toolbar>\n");
        $templateCache.put("meta/content/editor/components/view/packageAcceptTemplates/content-package-accept-templates-member-view-component/content-package-accept-templates-member-view-template.html", "<div class=\"container-fluid\">\n    <div class=\"prism-form-heading\">{{$ctrl.contentPackageAcceptTemplateContainer.categoryType.name}}</div>\n    <fieldset>\n        <div ng-if=\"$ctrl.contentPackageAcceptTemplateContainer.members\">\n            <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n                <div class=\"form-group no-margin-bottom\">\n                    <label for=\"packageAcceptTemplatesDropDown\"\n                           class=\"col-sm-2 control-label\">\n                        Package Accept Template\n                    </label>\n                    <div class=\"col-sm-3 pad-text-input-col\">\n                        <dropdown-select id=\"packageAcceptTemplatesDropDown\"\n                                         btn-min-width=\"200\"\n                                         collection=\"$ctrl.packageAcceptTemplates\"\n                                         label-field=\"name\"\n                                         ng-change=\"$ctrl.onSelectedPackageAcceptTemplateChangeHandler()\"\n                                         ng-model=\"$ctrl.contentPackageAcceptTemplateContainer.packageAcceptTemplate\"\n                                         prompt=\"Select Package Accept Template\">\n                        </dropdown-select>\n                    </div>\n                </div>\n                <br>\n                <div class=\"form-group no-margin-bottom\" ng-repeat=\"mediaAcceptProfile in $ctrl.mediaAcceptProfiles\">\n                    <label class=\"col-sm-2 control-label\">\n                        {{mediaAcceptProfile.mediaAcceptProfileType}}\n                    </label>\n                    <div class=\"col-sm-8\">\n                        <member-grid\n                                available-validation-types=\"$ctrl.validationTypes\"\n                                media-accept-profile-type=\"mediaAcceptProfile.mediaAcceptProfileType\"\n                                media-accept-profiles=\"mediaAcceptProfile.mediaAcceptProfiles\"\n                                available-members=\"$ctrl.contentPackageAcceptTemplateContainer.members\">\n                        </member-grid>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </fieldset>\n</div>\n<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\">\n    </div>\n</div>\n");
        $templateCache.put("meta/content/editor/components/view/properties/renderers/content-properties-ads-prerolls-general-template.html", "<div class=\"row clearfix\">\n    <div class=\"col-md-12 column\">\n        <div class=\"row\">\n            <div class=\"col-md-2\">\n                <div class=\"prism-form-heading\">General</div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row clearfix spacer-top-lg\">\n        <div class=\"col-md-12 column\">\n            <form class=\"form-horizontal\" role=\"form\">\n                <div class=\"form-group\">\n                    <label for=\"contentName\"\n                           class=\"col-sm-2 control-label\">Name</label>\n                    <div class=\"col-sm-4 pad-text-input-col\">\n                        <input id=\"contentName\"\n                               class=\"form-control prism-text-input\"\n                               autocomplete=\"off\"\n                               ng-model=\"$ctrl.contentObject.name\"/>\n                    </div>\n                    <div class=\"required-text-input\"\n                         required\n                         x-required-indicator></div>\n                </div>\n                <div class=\"form-group\">\n                    <label for=\"contentNetwork\"\n                           class=\"col-sm-2 control-label\">Network</label>\n                    <div class=\"col-sm-4 pad-text-input-col\">\n                        <dropdown-select id=\"contentNetwork\"\n                                         ng-model=\"$ctrl.contentObject.network\"\n                                         prompt=\"Choose Network\"\n                                         label-field=\"name\"\n                                         clearable=\"true\"\n                                         collection=\"$ctrl.networks\"\n                                         btn-min-width=\"295\"\n                                         class=\"hide-required-indicator\"\n                                         required>\n                        </dropdown-select>\n                    </div>\n                    <div class=\"required-select\"\n                         required\n                         x-required-indicator></div>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("meta/content/editor/components/view/properties/renderers/content-properties-liveclipping-template.html", "<div class=\"row clearfix\">\n	<div class=\"col-md-12 column\">\n		<div class=\"row\">\n			<div class=\"col-md-2\">\n				<div class=\"prism-form-heading\">\n					LIVE Recording Settings\n				</div>\n			</div>\n		</div>\n	</div>\n\n	<div class=\"row clearfix spacer-top-lg\">\n		<div class=\"col-md-12 column\">\n			<form class=\"form-horizontal\">\n\n				<!-- Duration -->\n				<div class=\"form-group\">\n					<label for=\"contentDuration\"\n						   class=\"col-sm-2 control-label\">\n						Duration (minutes)\n					</label>\n					<div class=\"col-sm-4 pad-text-input-col\">\n						<input id=\"contentDuration\"\n							   class=\"form-control prism-text-input\"\n							   ng-model=\"$ctrl.contentObject.duration\"/>\n					</div>\n				</div>\n\n				<!-- Start Padding (minutes) -->\n				<div class=\"form-group\">\n					<label for=\"contentStartPadding\"\n						   class=\"col-sm-2 control-label\">\n						Start Padding (minutes)\n					</label>\n					<div class=\"col-sm-4 pad-text-input-col\">\n						<input id=\"contentStartPadding\"\n							   class=\"form-control prism-text-input\"\n							   ng-model=\"$ctrl.contentObject.extendBefore\"/>\n					</div>\n				</div>\n\n				<!-- End Padding (minutes) -->\n				<div class=\"form-group\">\n					<label for=\"contentEndPadding\"\n						   class=\"col-sm-2 control-label\">\n						End Padding (minutes)\n					</label>\n					<div class=\"col-sm-4 pad-text-input-col\">\n						<input id=\"contentEndPadding\"\n							   class=\"form-control prism-text-input\"\n							   ng-model=\"$ctrl.contentObject.extendAfter\"/>\n					</div>\n				</div>\n\n				<!-- Live Feeds -->\n				<div class=\"form-group\">\n					<label for=\"contentLiveFeeds\"\n						   class=\"col-sm-2 control-label\">\n						Live Feeds\n					</label>\n					<div class=\"col-sm-7\">\n						<button id=\"addContentLiveFeed\"\n								class=\"btn btn-default prism-button\"\n								ng-click=\"$ctrl.addShowLiveFeed()\"><i class=\"fa fa-plus\"></i></button>\n						<button id=\"removeContentLiveFeed\"\n								class=\"btn btn-default prism-button\"\n								ng-click=\"$ctrl.removeSelectedFeeds()\"\n								ng-disabled=\"!$ctrl.canRemoveSelected()\">\n							<i class=\"fa fa-minus\"></i></button>\n\n						<hr/>\n\n						<div id=\"contentLiveFeeds\"\n							 class=\"inline-grid search-grid top-margin-xs\"\n							 ui-grid=\"$ctrl.liveFeedsGridOptions\"\n							 ui-grid-selection\n							 ui-grid-auto-resize>\n						</div>\n\n						<hr/>\n\n						<span class=\"control-label\">\n							<em>\n								Note: Live feeds that have already been associated with a recording may not be removed\n								here; contact support for assistance.\n							</em>\n						</span>\n					</div>\n				</div>\n\n			</form>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("meta/content/editor/components/view/properties/renderers/content-properties-movies-general-template.html", "<div class=\"row clearfix\">\n    <div class=\"col-md-12 column\">\n        <div class=\"row\">\n            <div class=\"col-md-2\">\n                <div class=\"prism-form-heading\">GENERAL</div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row clearfix spacer-top-lg\">\n        <div class=\"col-md-12 column\">\n            <form class=\"form-horizontal\"\n                  role=\"form\">\n                <div class=\"form-group\">\n                    <label for=\"contentLocked\"\n                           class=\"col-sm-2 control-label\">\n                        {{($ctrl.contentObject.locked? \'Locked\': \'Unlocked\')}}\n                    </label>\n                    <div class=\"col-sm-9 pad-text-input-col\">\n                        <p id=\"contentLocked\">\n                            <ui-lock is-locked=\"$ctrl.contentObject.locked\"\n                                     click-handler=\"$ctrl.toggleContentLock()\"></ui-lock>\n                        </p>\n                    </div>\n                </div>\n\n                <!-- Name -->\n                <div class=\"form-group\">\n                    <label for=\"contentName\"\n                           class=\"col-sm-2 control-label\">Name</label>\n                    <div class=\"col-sm-4 pad-text-input-col\">\n                        <input id=\"contentName\"\n                               class=\"form-control prism-text-input\"\n                               autocomplete=\"off\"\n                               ng-model=\"$ctrl.contentObject.name\"/>\n                    </div>\n                    <div class=\"required-text-input\"\n                         required\n                         x-required-indicator></div>\n                </div>\n\n                <!-- Network -->\n                <div class=\"form-group\">\n                    <label for=\"contentNetwork\"\n                           class=\"col-sm-2 control-label\">Network</label>\n                    <div class=\"col-sm-4 pad-text-input-col\">\n                        <dropdown-select id=\"contentNetwork\"\n                                         ng-model=\"$ctrl.contentObject.network\"\n                                         prompt=\"Choose Network\"\n                                         label-field=\"name\"\n                                         clearable=\"true\"\n                                         collection=\"$ctrl.networks\"\n                                         btn-min-width=\"295\"\n                                         class=\"hide-required-indicator\"\n                                         required>\n                        </dropdown-select>\n                    </div>\n                    <div class=\"required-select\"\n                         required\n                         x-required-indicator></div>\n                </div>\n\n                <!-- Prefix -->\n                <div class=\"form-group\">\n                    <label for=\"contentPrefix\"\n                           class=\"col-sm-2 control-label\">Prefix</label>\n                    <div class=\"col-sm-4 pad-text-input-col\">\n                        <input id=\"contentPrefix\"\n                               class=\"form-control prism-text-input\"\n                               autocomplete=\"off\"\n                               ng-model=\"$ctrl.contentObject.prefix\"/>\n                    </div>\n                </div>\n\n                <!-- Territory Select-->\n                <div class=\"form-group\">\n                    <label for=\"territoryDropDown\" class=\"col-sm-2 control-label\">\n                        Territory\n                    </label>\n                    <div class=\"col-md-4 pad-text-input-col\">\n                        <dropdown-select id=\"territoryDropDown\"\n                                         sort-collection=\"false\"\n                                         ng-model=\"$ctrl.contentObject.territory\"\n                                         prompt=\"Select Territory\" btn-min-width=\"200\" clearable=\"false\"\n                                         label-field=\"name\"\n                                         collection=\"$ctrl.availableTerritories\"\n                                         class=\"hide-required-indicator\"\n                                         required>\n                        </dropdown-select>\n                        <span class=\"required-text-input\"\n                              required\n                              x-required-indicator></span>\n                    </div>\n\n                </div>\n\n                <!-- Original Language -->\n                <div class=\"form-group\">\n                    <label for=\"contentOriginalLanguage\"\n                           class=\"col-sm-2 control-label\">Original Language</label>\n                    <div class=\"col-sm-4 pad-text-input-col\">\n                        <dropdown-select id=\"contentOriginalLanguage\"\n                                         ng-model=\"$ctrl.contentObject.originalLanguage\"\n                                         prompt=\"Select Language\"\n                                         label-field=\"name\"\n                                         clearable=\"true\"\n                                         collection=\"$ctrl.languages\"\n                                         sort-collection=\"false\"\n                                         btn-min-width=\"295\">\n                        </dropdown-select>\n                        <span class=\"required-text-input\"\n                              required\n                              x-required-indicator></span>\n                    </div>\n                </div>\n\n                <!-- Air Time -->\n                <div class=\"form-group\">\n                    <label for=\"contentAirTime\"\n                           class=\"col-sm-2 control-label\">Air Time</label>\n                    <div class=\"col-sm-9 pad-text-input-col\">\n                        <prism-time-picker id=\"contentAirTime\"\n                                         ng-model=\"$ctrl.contentObject.airTime\"\n                                         hour-step=\"1\"\n                                         minute-step=\"15\"\n                                         show-meridian=\"true\">\n                        </prism-time-picker>\n                    </div>\n                </div>\n\n                <!-- Start Year -->\n                <div class=\"form-group\">\n                    <label for=\"contentStartYear\"\n                           class=\"col-sm-2 control-label\">Start Year</label>\n                    <div class=\"col-sm-4 pad-text-input-col\">\n                        <input id=\"contentStartYear\"\n                               class=\"form-control prism-text-input\"\n                               autocomplete=\"off\"\n                               ng-model=\"$ctrl.contentObject.startYear\"/>\n                    </div>\n                </div>\n\n                <!-- Genre -->\n                <div class=\"form-group\">\n                    <label for=\"contentGenre\"\n                           class=\"col-sm-2 control-label\">Genre</label>\n                    <div class=\"col-sm-4 pad-text-input-col\">\n                        <dropdown-select id=\"contentGenre\"\n                                         ng-model=\"$ctrl.contentObject.genre\"\n                                         prompt=\"\"\n                                         label-field=\"name\"\n                                         clearable=\"true\"\n                                         collection=\"$ctrl.genres\"\n                                         btn-min-width=\"295\">\n                        </dropdown-select>\n                    </div>\n                </div>\n\n                <!-- Second Genre -->\n                <div class=\"form-group\">\n                    <label for=\"content2ndGenre\"\n                           class=\"col-sm-2 control-label\">Second Genre</label>\n                    <div class=\"col-sm-4 pad-text-input-col\">\n                        <dropdown-select id=\"content2ndGenre\"\n                                         ng-model=\"$ctrl.contentObject.secondGenre\"\n                                         prompt=\"\"\n                                         label-field=\"name\"\n                                         clearable=\"true\"\n                                         collection=\"$ctrl.genres\"\n                                         btn-min-width=\"295\">\n                        </dropdown-select>\n                    </div>\n                </div>\n\n                <!-- Copyright -->\n                <div class=\"form-group\">\n                    <label for=\"contentCopyright\"\n                           class=\"col-sm-2 control-label\">Copyright</label>\n                    <div class=\"col-sm-4 pad-text-input-col\">\n                        <input id=\"contentCopyright\"\n                               class=\"form-control prism-text-input\"\n                               autocomplete=\"off\"\n                               ng-model=\"$ctrl.contentObject.copyright\"/>\n                    </div>\n                </div>\n\n                <!-- Break Pre/Postroll Pattern -->\n                <div class=\"form-group\">\n                    <label for=\"contentBreakPattern\"\n                           class=\"col-sm-2 control-label\">Break Pre/Postroll Pattern</label>\n                    <div class=\"col-sm-4 pad-text-input-col\">\n                        <dropdown-select id=\"contentBreakPattern\"\n                                         ng-model=\"$ctrl.contentObject.breakPrePostRollPattern\"\n                                         label-field=\"displayName\"\n                                         collection=\"$ctrl.availableBreakPatterns\"\n                                         btn-min-width=\"150\"\n                                         ng-disabled=\"!$ctrl.contentObject.breakPrePostRollPatternOverridden\">\n                        </dropdown-select>\n                        <label class=\"prism-checkbox-inline\">\n                            <input id=\"breakPatternOverride\"\n                                   type=\"checkbox\"\n                                   ng-model=\"$ctrl.contentObject.breakPrePostRollPatternOverridden\"/>\n                            <label for=\"breakPatternOverride\">\n                                Override\n                            </label>\n                        </label>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("meta/content/editor/components/view/properties/renderers/content-properties-series-general-template.html", "<div class=\"row clearfix\">\n    <div class=\"col-md-12 column\">\n        <div class=\"row\">\n            <div class=\"col-md-2\">\n                <div class=\"prism-form-heading\">GENERAL</div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row clearfix spacer-top-lg\">\n        <div class=\"col-md-12 column\">\n            <form class=\"form-horizontal\"\n                  role=\"form\">\n                <div class=\"form-group\">\n                    <label for=\"contentLocked\"\n                           class=\"col-sm-2 control-label\">\n                        {{($ctrl.contentObject.locked? \'Locked\': \'Unlocked\')}}\n                    </label>\n                    <div class=\"col-sm-9 pad-text-input-col\">\n                        <p id=\"contentLocked\">\n                            <ui-lock is-locked=\"$ctrl.contentObject.locked\"\n                                     click-handler=\"$ctrl.toggleContentLock()\"></ui-lock>\n                        </p>\n                    </div>\n                </div>\n\n                <!-- Name -->\n                <div class=\"form-group\">\n                    <label for=\"contentName\"\n                           class=\"col-sm-2 control-label\">Name</label>\n                    <div class=\"col-sm-4 pad-text-input-col\">\n                        <input id=\"contentName\"\n                               class=\"form-control prism-text-input\"\n                               autocomplete=\"off\"\n                               ng-model=\"$ctrl.contentObject.name\"/>\n                    </div>\n                    <div class=\"required-text-input\"\n                         required\n                         x-required-indicator></div>\n                </div>\n\n                <!-- Network -->\n                <div class=\"form-group\">\n                    <label for=\"contentNetwork\"\n                           class=\"col-sm-2 control-label\">Network</label>\n                    <div class=\"col-sm-4 pad-text-input-col\">\n                        <dropdown-select id=\"contentNetwork\"\n                                         ng-model=\"$ctrl.contentObject.network\"\n                                         prompt=\"Choose Network\"\n                                         label-field=\"name\"\n                                         clearable=\"true\"\n                                         collection=\"$ctrl.networks\"\n                                         btn-min-width=\"295\"\n                                         class=\"hide-required-indicator\"\n                                         required>\n                        </dropdown-select>\n                    </div>\n                    <div class=\"required-select\"\n                         required\n                         x-required-indicator></div>\n                </div>\n\n                <!-- Prefix -->\n                <div class=\"form-group\">\n                    <label for=\"contentPrefix\"\n                           class=\"col-sm-2 control-label\">Prefix</label>\n                    <div class=\"col-sm-4 pad-text-input-col\">\n                        <input id=\"contentPrefix\"\n                               class=\"form-control prism-text-input\"\n                               autocomplete=\"off\"\n                               ng-model=\"$ctrl.contentObject.prefix\"/>\n                    </div>\n                </div>\n\n                <!-- Territory Select-->\n                <div class=\"form-group\">\n                    <label for=\"territoryDropDown\" class=\"col-sm-2 control-label\">\n                        Territory\n                    </label>\n                    <div class=\"col-md-4 pad-text-input-col\">\n                        <dropdown-select id=\"territoryDropDown\"\n                                         sort-collection=\"false\"\n                                         ng-model=\"$ctrl.contentObject.territory\"\n                                         prompt=\"Select Territory\" btn-min-width=\"200\" clearable=\"false\"\n                                         label-field=\"name\"\n                                         collection=\"$ctrl.availableTerritories\">\n                        </dropdown-select>\n                        <span class=\"required-text-input\"\n                              required\n                              x-required-indicator></span>\n                    </div>\n                </div>\n\n                <!-- Original Language -->\n                <div class=\"form-group\">\n                    <label for=\"contentOriginalLanguage\"\n                           class=\"col-sm-2 control-label\">Original Language</label>\n                    <div class=\"col-sm-4 pad-text-input-col\">\n                        <dropdown-select id=\"contentOriginalLanguage\"\n                                         ng-model=\"$ctrl.contentObject.originalLanguage\"\n                                         prompt=\"Select Language\"\n                                         label-field=\"name\"\n                                         clearable=\"true\"\n                                         collection=\"$ctrl.languages\"\n                                         sort-collection=\"false\"\n                                         btn-min-width=\"295\">\n                        </dropdown-select>\n                        <span class=\"required-text-input\"\n                              required\n                              x-required-indicator></span>\n                    </div>\n                </div>\n\n                <!-- Air Time -->\n                <div class=\"form-group\">\n                    <label for=\"contentAirTime\"\n                           class=\"col-sm-2 control-label\">Air Time</label>\n                    <div class=\"col-sm-9 pad-text-input-col\">\n                        <prism-time-picker id=\"contentAirTime\"\n                                         ng-model=\"$ctrl.contentObject.airTime\"\n                                         hour-step=\"1\"\n                                         minute-step=\"15\"\n                                         show-meridian=\"true\">\n                        </prism-time-picker>\n                    </div>\n                </div>\n\n                <!-- Start Year -->\n                <div class=\"form-group\">\n                    <label for=\"contentStartYear\"\n                           class=\"col-sm-2 control-label\">Start Year</label>\n                    <div class=\"col-sm-4 pad-text-input-col\">\n                        <input id=\"contentStartYear\"\n                               class=\"form-control prism-text-input\"\n                               autocomplete=\"off\"\n                               ng-model=\"$ctrl.contentObject.startYear\"/>\n                    </div>\n                </div>\n\n                <!-- Genre -->\n                <div class=\"form-group\">\n                    <label for=\"contentGenre\"\n                           class=\"col-sm-2 control-label\">Genre</label>\n                    <div class=\"col-sm-4 pad-text-input-col\">\n                        <dropdown-select id=\"contentGenre\"\n                                         ng-model=\"$ctrl.contentObject.genre\"\n                                         prompt=\"\"\n                                         label-field=\"name\"\n                                         clearable=\"true\"\n                                         collection=\"$ctrl.genres\"\n                                         btn-min-width=\"295\">\n                        </dropdown-select>\n                    </div>\n                </div>\n\n                <!-- Second Genre -->\n                <div class=\"form-group\">\n                    <label for=\"content2ndGenre\"\n                           class=\"col-sm-2 control-label\">Second Genre</label>\n                    <div class=\"col-sm-4 pad-text-input-col\">\n                        <dropdown-select id=\"content2ndGenre\"\n                                         ng-model=\"$ctrl.contentObject.secondGenre\"\n                                         prompt=\"\"\n                                         label-field=\"name\"\n                                         clearable=\"true\"\n                                         collection=\"$ctrl.genres\"\n                                         btn-min-width=\"295\">\n                        </dropdown-select>\n                    </div>\n                </div>\n\n                <!-- Copyright -->\n                <div class=\"form-group\">\n                    <label for=\"contentCopyright\"\n                           class=\"col-sm-2 control-label\">Copyright</label>\n                    <div class=\"col-sm-4 pad-text-input-col\">\n                        <input id=\"contentCopyright\"\n                               class=\"form-control prism-text-input\"\n                               autocomplete=\"off\"\n                               ng-model=\"$ctrl.contentObject.copyright\"/>\n                    </div>\n                </div>\n\n                <!-- Break Pre/Postroll Pattern -->\n                <div class=\"form-group\">\n                    <label for=\"contentBreakPattern\"\n                           class=\"col-sm-2 control-label\">Break Pre/Postroll Pattern</label>\n                    <div class=\"col-sm-4 pad-text-input-col\">\n                        <dropdown-select id=\"contentBreakPattern\"\n                                         ng-model=\"$ctrl.contentObject.breakPrePostRollPattern\"\n                                         label-field=\"displayName\"\n                                         collection=\"$ctrl.availableBreakPatterns\"\n                                         btn-min-width=\"150\"\n                                         ng-disabled=\"!$ctrl.contentObject.breakPrePostRollPatternOverridden\">\n                        </dropdown-select>\n                        <label class=\"prism-checkbox-inline\">\n                            <input id=\"breakPatternOverride\"\n                                   type=\"checkbox\"\n                                   ng-model=\"$ctrl.contentObject.breakPrePostRollPatternOverridden\"/>\n                            <label for=\"breakPatternOverride\">\n                                Override\n                            </label>\n                        </label>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("meta/content/editor/components/view/seasonvolume/editor/content-seasonvolume-editor-template.html", "<div class=\"container-fluid no-padding\">\n\n    <!-- Navigation/search toolbar -->\n    <div class=\"row-no-padding\">\n        <navbar search-enabled=\"$ctrl.isSearchEnabled()\"\n                show-next-previous-buttons=\"$ctrl.isNextPreviousShown()\"\n                filter-enabled=\"$ctrl.filterEnabled\">\n        </navbar>\n    </div>\n\n    <!-- Main -->\n    <div class=\"row-no-padding\">\n\n        <!-- Sidebar -->\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <!-- Content pane -->\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n            <div class=\"row-no-padding\">\n\n                <!-- Breadcrumb -->\n                <breadcrumb tab-name=\"$ctrl.breadcrumb.name\"></breadcrumb>\n\n                <!-- Pill Tabs -->\n                <uib-tabset horizontal=\"true\"\n                            type=\"pills\"\n                            class=\"edit-view-tabbar\"\n                            active=\"$ctrl.currentTab\">\n\n                    <!-- Properties Tab -->\n                    <uib-tab heading=\"Properties\"\n                             index=\"\'properties\'\"\n                             select=\"$ctrl.onTabSelect(\'properties\')\"\n                             deselect=\"$ctrl.onTabDeselect(\'properties\', $event)\">\n                        <content-season-volume-properties\n                            ng-if=\"$ctrl.currentTab === \'properties\'\"\n                            class=\"edit-full-height\">\n                        </content-season-volume-properties>\n                    </uib-tab>\n\n                    <!-- Collaborators Tab -->\n                    <uib-tab ng-show=\"$ctrl.isSeason()\"\n                             heading=\"Collaborators\"\n                             select=\"$ctrl.onTabSelect(\'collaborators\')\"\n                             deselect=\"$ctrl.onTabDeselect($event)\"\n                             index=\"\'collaborators\'\">\n                        <div ng-if=\"$ctrl.currentTab === \'collaborators\'\">\n                            <content-collaborator-grid-view class=\"col-md-12 col-lg-12 edit-full-height-tabs no-padding\"\n                                                            content=\"$ctrl.content\"\n                                                            season=\"$ctrl.season\">\n                            </content-collaborator-grid-view>\n                        </div>\n                    </uib-tab>\n\n                    <!-- Preroll Tab -->\n                    <uib-tab heading=\"Prerolls\"\n                             index=\"\'preRolls\'\"\n                             select=\"$ctrl.onTabSelect(\'preRolls\')\"\n                             deselect=\"$ctrl.onTabDeselect(\'preRolls\', $event)\">\n                        <branding-search-view\n                            is-admin=\"$ctrl.isAdmin\"\n                            group-name=\"\'series\'\"\n                            type=\"\'preRolls\'\"\n                            permission-view-state=\"$ctrl.isSeason ?\n								$ctrl.seasonVolumeViewStates.season :\n								$ctrl.seasonVolumeViewStates.volume\"\n                            base-url=\"\'/meta/series\'\"\n                            class=\"col-md-12 col-lg-12 no-padding\"\n                            is-season-volume=\"true\"\n                            ng-if=\"$ctrl.currentTab === \'preRolls\'\">\n                        </branding-search-view>\n                    </uib-tab>\n\n                    <!-- Postroll Tab -->\n                    <uib-tab heading=\"Postrolls\"\n                             index=\"\'postRolls\'\"\n                             select=\"$ctrl.onTabSelect(\'postRolls\')\"\n                             deselect=\"$ctrl.onTabDeselect(\'postRolls\', $event)\">\n                        <branding-search-view\n                            is-admin=\"$ctrl.isAdmin\"\n                            group-name=\"\'series\'\"\n                            type=\"\'postRolls\'\"\n                            base-url=\"\'/meta/series\'\"\n                            class=\"col-md-12 col-lg-12 no-padding\"\n                            permission-view-state=\"$ctrl.isSeason ?\n								$ctrl.seasonVolumeViewStates.season :\n								$ctrl.seasonVolumeViewStates.volume\"\n                            is-season-volume=\"true\"\n                            ng-if=\"$ctrl.currentTab === \'postRolls\'\">\n                        </branding-search-view>\n                    </uib-tab>\n\n                    <!-- Break Pre/Postrolls (someday) -->\n\n                    <!-- Watermarks -->\n                    <uib-tab heading=\"Watermarks\"\n                             index=\"\'watermarks\'\"\n                             select=\"$ctrl.onTabSelect(\'watermarks\')\"\n                             deselect=\"$ctrl.onTabDeselect(\'watermarks\', $event)\">\n                        <branding-search-view\n                            is-admin=\"$ctrl.isAdmin\"\n                            group-name=\"\'series\'\"\n                            type=\"\'watermarks\'\"\n                            base-url=\"\'/meta/series\'\"\n                            class=\"col-md-12 col-lg-12 no-padding\"\n                            permission-view-state=\"($ctrl.isSeason) ?\n								$ctrl.seasonVolumeViewStates.season :\n								$ctrl.seasonVolumeViewStates.volume\"\n                            is-season-volume=\"true\"\n                            ng-if=\"$ctrl.currentTab === \'watermarks\'\">\n                        </branding-search-view>\n                    </uib-tab>\n\n                    <!-- Artwork -->\n                    <uib-tab heading=\"Artwork\"\n                             index=\"\'artwork\'\"\n                             select=\"$ctrl.onTabSelect(\'artwork\')\"\n                             deselect=\"$ctrl.onTabDeselect(\'artwork\', $event)\">\n                        <branding-search-view\n                            is-admin=\"$ctrl.isAdmin\"\n                            group-name=\"\'series\'\"\n                            type=\"\'artwork\'\"\n                            base-url=\"\'/meta/series\'\"\n                            class=\"col-md-12 col-lg-12 no-padding\"\n                            permission-view-state=\"($ctrl.isSeason) ?\n								$ctrl.seasonVolumeViewStates.season :\n								$ctrl.seasonVolumeViewStates.volume\"\n                            is-season-volume=\"true\"\n                            ng-if=\"$ctrl.currentTab === \'artwork\'\">\n                        </branding-search-view>\n                    </uib-tab>\n\n                    <!-- Aggregation -->\n                    <uib-tab heading=\"Aggregation\"\n                             index=\"\'aggregation\'\"\n                             select=\"$ctrl.onTabSelect(\'aggregation\')\"\n                             deselect=\"$ctrl.onTabDeselect(\'aggregation\', $event)\">\n                        <season-aggregation-tab class=\"col-md-12 col-lg-12 no-padding\">\n                        </season-aggregation-tab>\n                    </uib-tab>\n\n                </uib-tabset>\n            </div>\n\n        </div>\n    </div>\n\n</div>\n");
        $templateCache.put("meta/content/editor/components/view/seasonvolume/searchView/content-seasonvolume-searchview-template.html", "<div id=\"contentSeasonVolumeSearchView\" class=\"row-no-padding\">\n\n	<!-- Pacifier -->\n	<div class=\"loadingIndicator\">\n		<div data-lb-progress=\"$ctrl.loadingIndicator\"\n			 ng-show=\"$ctrl.loadingIndicator.show\">\n		</div>\n	</div>\n\n\n	<!-- Grid -->\n	<div id=\"contentSeasonVolumeSearchViewGrid\"\n		 class=\"breadcrumb-tab-edit-search-grid grid search-grid\"\n		 ui-grid=\"$ctrl.gridOptions\"\n		 ui-grid-selection\n		 ui-grid-pagination\n		 ui-grid-resize-columns>\n	</div>\n\n	<!-- Toolbar -->\n	<toolbar\n		button-defs=\"$ctrl.toolbarButtonDefs\"\n		right-hand-checkbox-defs=\"$ctrl.toolbarCheckboxDefs\">\n	</toolbar>\n\n</div>\n");
        $templateCache.put("package/editor/components/view/distributionGrid/mmcInventoryModal/cellTemplates/check-mark-header-template.html", "<!--\n - Filename: check-mark-header-template.html\n -\n - Created by kyang on 2019-05-16.\n -->\n\n<div class=\"ui-grid-cell-contents checkbox-grid-cell\"\n     ng-click=\"!grid.appScope.$ctrl.readOnly && grid.appScope.$ctrl.onCheckMarkHeaderClicked($event)\">\n    <input class=\"\"\n           ng-checked=\"grid.appScope.$ctrl.areAllRowsActive()\"\n           type=\"checkbox\"/>\n    <label></label>\n</div>\n");
        $templateCache.put("package/editor/components/view/distributionGrid/mmcInventoryModal/cellTemplates/check-mark-template.html", "<!--\n - Filename: check-mark-template.html\n -\n - Created by randysorensen on 2019-05-10.\n -->\n\n<div class=\"ui-grid-cell-contents checkbox-grid-cell\"\n     ng-click=\"!grid.appScope.$ctrl.readOnly && grid.appScope.$ctrl.onCheckMarkCellClicked(row, $event)\">\n    <input class=\"\"\n           ng-checked=\"COL_FIELD\"\n           type=\"checkbox\"/>\n    <label></label>\n</div>\n");
        $templateCache.put("package/editor/components/view/distributionGrid/mmcInventoryModal/cellTemplates/inline-edit-template.html", "<!--\n - Filename: inline-edit-template.html\n -\n - Created by randysorensen on 2019-05-10.\n -->\n<div class=\"ui-grid-cell-contents ng-scope ng-binding\"\n     ng-class=\"{\n        \'ui-grid-cell-error\': row.entity.inventoryId === \'\'\n     }\"\n     data-tooltip-append-to-body=\"true\"\n     uib-tooltip=\"{{COL_FIELD CUSTOM_FILTERS}}\">\n\n    <span class=\"padding-left-sm editable-grid-cell\">\n        {{COL_FIELD CUSTOM_FILTERS}}\n    </span>\n</div>\n");
        $templateCache.put("package/editor/components/view/liveclip/modals/clipSchedule/clip-schedule-modal-template.html", "<div class=\"modal-header\">\n    <h5 class=\"modal-title\">Live Schedule Override</h5>\n</div>\n<div class=\"modal-body\">\n    <div class=\"form-horizontal\">\n        <div class=\"form-group\">\n            <label for=\"scheduleFeedSelect\"\n                   class=\"col-sm-2 control-label col-sm-offset-1\">Feed</label>\n            <div class=\"col-sm-6 metadata-control-col\">\n\n                <dropdown-select id=\"scheduleFeedSelect\"\n                                 ng-model=\"scheduleCtrlr.currentFeed\"\n                                 label-field=\"shortLabel\"\n                                 collection=\"scheduleCtrlr.availableFeeds\"\n                                 ng-change=\"scheduleCtrlr.selectScheduleForFeed()\"\n                                 btn-min-width=\"295\">\n                </dropdown-select>\n            </div>\n        </div>\n\n        <div class=\"form-group metadata-control-col no-margin-bottom\">\n            <div class=\"col-sm-7 col-sm-offset-3\">\n                <input type=\"checkbox\"\n                       id=\"liveScheduleOverrideCB\"\n                       ng-model=\"scheduleCtrlr.schedule.liveRecordOverridden\"\n                       ng-disabled=\"scheduleCtrlr.record.status === \'complete\' || scheduleCtrlr.record.status === \'cancelled\'\"/>\n                <label for=\"liveScheduleOverrideCB\"\n                       class=\"prism-form-item-label\">Override Schedule Times</label>\n            </div>\n        </div>\n        <fieldset ng-disabled=\"scheduleCtrlr.disableStartTimeField()\">\n            <div class=\"form-group no-margin-bottom\">\n                <label for=\"liveScheduleStartTime\"\n                       class=\"col-sm-2 control-label col-sm-offset-1\">Start Time</label>\n                <date-time-picker id=\"liveScheduleStartTime\"\n                                  ng-model=\"scheduleCtrlr.schedule.startTime\"\n                                  required\n                                  field-set-size=\"6\"></date-time-picker>\n            </div>\n        </fieldset>\n        <fieldset ng-disabled=\"scheduleCtrlr.disableStopTimeField()\">\n            <div class=\"form-group no-margin-bottom\">\n                <label for=\"liveScheduleStopTime\"\n                       class=\"col-sm-2 control-label col-sm-offset-1\">Stop Time</label>\n                <date-time-picker id=\"liveScheduleStopTime\"\n                                  ng-model=\"scheduleCtrlr.schedule.stopTime\"\n                                  required\n                                  field-set-size=\"6\"></date-time-picker>\n            </div>\n        </fieldset>\n    </div>\n</div>\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"scheduleCtrlr.cancel()\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"scheduleCtrlr.cancelRecording($event)\"\n            ng-disabled=\"!scheduleCtrlr.record.id\"\n            ng-show=\"scheduleCtrlr.record && scheduleCtrlr.record.status !== \'complete\' && scheduleCtrlr.record.status !== \'cancelled\'\">\n        {{(scheduleCtrlr.record.status === \'running\')? \'Stop Recording\' : \'Cancel Recording\'}}\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"scheduleCtrlr.onOk()\"\n            ng-disabled=\"scheduleCtrlr.disableOKButton()\">\n        OK\n    </button>\n</div>\n");
        $templateCache.put("package/editor/components/view/liveclip/modals/createNewClip/create-clip-modal-template.html", "<div class=\"modal-header\">\n    <h5 class=\"modal-title\">Create New Clip</h5>\n</div>\n<div class=\"modal-body\">\n    <form class=\"form-horizontal\">\n        <div class=\"form-group no-margin-bottom\">\n            <div class=\"col-sm-12\">\n                <label for=\"clipTitle\"\n                       class=\"col-sm-3 control-label\">Clip Title</label>\n                <div class=\"col-sm-5 no-padding pad-text-input-col\">\n                    <input type=\"text\"\n                           class=\"prism-text-input\"\n                           id=\"clipTitle\"\n                           autocomplete=\"off\"\n                           ng-model=\"createClipMdlCntrlr.clipTitle\"/>\n                </div>\n                <div class=\"col-sm-4 pad-text-input-col\">\n                    <input type=\"number\"\n                           class=\"col-sm-2 prism-text-input bulk-pkg-create-field\"\n                           id=\"numDraftClips\"\n                           min=\"1\"\n                           max=createClipMdlCntrlr.maxClips\n                           ng-change=\"createClipMdlCntrlr.onNumDraftClipsChanged(createClipMdlCntrlr.numberOfClips)\"\n                           ng-model=\"createClipMdlCntrlr.numberOfClips\"/>\n                    <label for=\"numDraftClips\"\n                           class=\"control-label bulk-pkg-create-label\">1-99</label>\n                </div>\n            </div>\n        </div>\n    </form>\n</div>\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"createClipMdlCntrlr.cancel()\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"createClipMdlCntrlr.onOk()\"\n            ng-disabled=\"!createClipMdlCntrlr.clipTitle\">\n        Create Clip\n    </button>\n</div>\n");
        $templateCache.put("package/editor/components/view/liveclip/modals/selectDraftClip/select-draft-clip-modal-template.html", "<div class=\"modal-header\">\n    <h5 class=\"modal-title\">Select Draft Clip</h5>\n</div>\n<div class=\"modal-body draft-clip-modal-body\">\n    <div class=\"row\">\n        <div class=\"col-md-12 \">\n            <div class=\"input-group input-group-unstyled\">\n                <input id=\"draftClipSearchTextInput\"\n                       type=\"text\"\n                       class=\"prism-text-input\"\n                       ng-model=\"$ctrl.draftClipSearch\">\n                <span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span>\n            </div>\n        </div>\n    </div>\n    <ul class=\"list-group clip-list\">\n        <li class=\"list-group-item draft-clip-list-item-renderer selectable\"\n            ng-repeat=\"clip in $ctrl.resolve.draftClips | filter:$ctrl.searchDrafts\"\n            ng-class=\"$ctrl.selectedClip.id === clip.id ? \'selected\' : \'\'\"\n            ng-click=\"$ctrl.selectClip(clip)\">\n            <span>{{clip.title || clip.name}}</span>\n        </li>\n    </ul>\n\n</div>\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.cancel()\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.onOk($ctrl.selectedClip)\"\n            ng-disabled=\"!$ctrl.selectedClip\">\n        Use Draft Clip\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.onOk(null)\">\n        Create New Clip\n    </button>\n</div>\n\n");
        $templateCache.put("package/editor/components/view/liveclip/renderers/clipEditTabs/clip-metadata-renderer-template.html", "<div class=\"row clearfix spacer-top-lg\">\n	<div class=\"col-md-12 column\">\n		<div class=\"row read-only-msg\" ng-show=\"!pkgLiveClip.loading && !pkgLiveClip.perms.livePerms\">\n			<p><i class=\"fa fa-lock\"></i> User access denied! Your permissions do not allow you to edit this content.</p>\n		</div>\n		<div class=\"row read-only-msg\" ng-show=\"!pkgEditCtrl.statusAllowsEdit(pkgLiveClip.clipInEdit.packageData) && !pkgLiveClip.clipInEdit.packageData.locked\n		 && pkgLiveClip.perms.livePerms && !pkgLiveClip.loading\">\n			<p><i class=\"fa fa-lock\"></i> Due to the current package status, this package cannot be modified.</p>\n		</div>\n		<div class=\"row read-only-msg\" ng-show=\"pkgLiveClip.clipInEdit.packageData.locked && pkgLiveClip.perms.livePerms && !pkgLiveClip.loading\">\n			<p><i class=\"fa fa-lock\"></i> This package is checked out, and cannot be modified or delivered.</p>\n		</div>\n\n		<form class=\"form-horizontal\" role=\"form\" name=\"pkgLiveClip.metadataForm\">\n			<div class=\"form-group no-margin-bottom\">\n				<label for=\"clipTitle\" class=\"col-sm-3 control-label\">Title</label>\n\n				<div class=\"col-sm-8 pad-text-input-col\">\n					<enhanced-textinput model-prop=\"pkgLiveClip.clipInEdit.packageData.title\" max-chars=\"255\" input-id=\"clipTitle\"></enhanced-textinput>\n				</div>\n				<div class=\"col-sm-1 no-padding error-warning spacer-top-xsm\">\n					<error-warning-indicator error-warning=\"pkgEditCtrl.checkErrorWarning(\'episodeTitle\', pkgLiveClip.clipInEdit.packageData.name)\"></error-warning-indicator>\n				</div>\n				<div class=\"required-text-input\" required x-required-indicator></div>\n			</div>\n			<div class=\"form-group no-margin-bottom\">\n				<label for=\"shortDescriptionClip\" class=\"col-sm-3 control-label\">Short Description</label>\n\n				<div class=\"col-sm-8 pad-text-input-col\">\n					<enhanced-textarea ng-model=\"pkgLiveClip.clipInEdit.packageData.shortDescription\" max-chars=\"75\"\n									   input-rows=\"3\" input-id=\"shortDescriptionClip\"></enhanced-textarea>\n				</div>\n				<div class=\"col-sm-1 error-warning error-warning-text-area-3\">\n					<error-warning-indicator error-warning=\"pkgEditCtrl.checkErrorWarning(\'desc1\', pkgLiveClip.clipInEdit.packageData.name)\" ></error-warning-indicator>\n				</div>\n				<div class=\"required-text-area-3\" required x-required-indicator></div>\n			</div>\n			<div class=\"form-group no-margin-bottom\">\n				<label for=\"longDescriptionClip\" class=\"col-sm-3 control-label\">Long Description</label>\n				<div class=\"col-sm-8 pad-text-input-col\">\n					<enhanced-textarea ng-model=\"pkgLiveClip.clipInEdit.packageData.longDescription\" max-chars=\"715\"\n									   input-rows=\"6\" input-id=\"longDescriptionClip\"></enhanced-textarea>\n				</div>\n				<div class=\"col-sm-1 error-warning error-warning-text-area-6\">\n					<error-warning-indicator error-warning=\"pkgEditCtrl.checkErrorWarning(\'desc2\', pkgLiveClip.clipInEdit.packageData.name)\"></error-warning-indicator>\n				</div>\n				<div class=\"required-text-area-6\" required x-required-indicator></div>\n			</div>\n			<div class=\"form-group no-margin-bottom\">\n				<label for=\"keywordsClip\" class=\"col-sm-3 control-label\">Keywords</label>\n\n				<div class=\"col-sm-8 pad-text-input-col\">\n					<enhanced-textinput model-prop=\"pkgLiveClip.clipInEdit.packageData.keywords\" max-chars=\"200\"\n										input-id=\"keywordsClip\"></enhanced-textinput>\n				</div>\n				<div class=\"col-sm-1 error-warning spacer-top-xsm\">\n					<error-warning-indicator error-warning=\"pkgEditCtrl.checkErrorWarning(\'keywords\', pkgLiveClip.clipInEdit.packageData.name)\"></error-warning-indicator>\n				</div>\n				<div class=\"required-text-input\" required x-required-indicator></div>\n			</div>\n		</form>\n	</div>\n</div>\n");
        $templateCache.put("package/editor/components/view/liveclip/renderers/clipEditTabs/liveclip-editortoolbar-template.html", "<form class=\"form-inline\" name=\"liveClipToolbar\">\n	<div class=\"form-group\">\n		<div class=\"col-sm-6\">\n			<a class=\"toolbar-button\" role=\"button\" id=\"saveToolbarButton\" ng-click=\"pkgLiveClip.onSave()\"\n			   ng-disabled=\"pkgLiveClip.toolBarDisabled()\">\n				<i class=\"fa fa-floppy-o\"></i><br>Save\n			</a>\n		</div>\n		<div class=\"col-sm-6\">\n			<a class=\"toolbar-button\" role=\"button\" id=\"revertToolbarButton\" ng-click=\"pkgLiveClip.onRevert()\"\n			   ng-disabled=\"pkgLiveClip.toolBarDisabled()\">\n				<i class=\"fa fa-undo\"></i><br>Revert\n			</a>\n		</div>\n	</div>\n</form>\n");
        $templateCache.put("package/editor/components/view/liveclip/renderers/clipEditTabs/tab-edit-renderer-template.html", "<div class=\"row padding-left-sm\" ng-show=\"pkgLiveClip.clipInEdit.id\">\n	<div class=\"edit-view-container no-padding\">\n		<fieldset ng-disabled=\"!pkgLiveClip.perms.livePerms || !pkgEditCtrl.statusAllowsEdit(pkgLiveClip.clipInEdit.packageData)\">\n			<uib-tabset horizontal=\"true\" type=\"pills\" class=\"liveclip-edit-tabs\">\n				<uib-tab heading=\"METADATA\" ng-click=\"pkgLiveClip.activateEditTab(\'metadata\')\" active=\"pkgLiveClip.activeEditTabs.metadata\">\n					<div>\n						<div ng-include=\"\'package/editor/components/view/liveclip/renderers/clipEditTabs/clip-metadata-renderer-template.html\'\"></div>\n					</div>\n				</uib-tab>\n				<uib-tab ng-show=\"pkgLiveClip.perms.collabPerms\" heading=\"ROLES\" ng-click=\"pkgLiveClip.activateEditTab(\'roles\')\" active=\"pkgLiveClip.activeEditTabs.roles\">\n					<div>\n						<package-collaborators-view class=\"col-md-12 col-lg-12 live-clip-collaborator-view\"\n							package-object=\"pkgLiveClip.clipInEdit.packageData\"\n							set-dirty-fctn=\"pkgLiveClip.clipCollaboratorsChanged\"\n                            status-allows-edit=\"pkgLiveClip.statusAllowsEdit\"\n                            editor-form-name=\"\'collaboratorsForm\'\"\n							g-switch-default>\n						</package-collaborators-view>\n					</div>\n				</uib-tab>\n				<uib-tab ng-show=\"pkgLiveClip.perms.distPerms\" heading=\"DISTRIBUTION\" ng-click=\"pkgLiveClip.activateEditTab(\'distribution\')\" active=\"pkgLiveClip.activeEditTabs.distribution\">\n					<div>\n						<package-distribution-grid-view is-advanced=\"false\" package-object-data=\"pkgLiveClip.clipInEdit.packageData\"\n														editor-form-name=\"\'distributionForm\'\">\n						</package-distribution-grid-view>\n					</div>\n				</uib-tab>\n\n				<uib-tab ng-show=\"pkgLiveClip.perms.advancedDistPerms\" heading=\"ADVANCED\" ng-click=\"pkgLiveClip.activateEditTab(\'advanced\')\" active=\"pkgLiveClip.activeEditTabs.advanced\">\n					<div>\n						<package-distribution-grid-view is-advanced=\"true\" package-object-data=\"pkgLiveClip.clipInEdit.packageData\"\n														editor-form-name=\"\'advancedForm\'\">\n						</package-distribution-grid-view>\n					</div>\n				</uib-tab>\n			</uib-tabset>\n		</fieldset>\n	</div>\n</div>\n");
        $templateCache.put("package/editor/components/view/liveclip/renderers/clipList/clip-list-clip-renderer-template.html", "<div class=\"row v-align\">\n	<div class=\"clip-select-cb-container\" ng-click=\"pkgLiveClip.selectClipCheckboxClicked(clip, $event)\">\n		<input id=\"{{\'cb-\' + clip.id}}\" type=\"checkbox\" ng-checked=\"pkgLiveClip.isClipSelected(clip)\"\n			   ng-click=\"pkgLiveClip.selectClipCheckboxClicked(clip, $event)\">\n		<label for=\"{{\'cb-\' + clip.id}}\"></label>\n	</div>\n	<div class=\"clip-detail-thumbnail-col\"\n		 ng-class=\"pkgLiveClip.getAssetURL(clip) !== \'assets/images/no-proxy-16x9.png\'? \'thumbnail-present\' : \'\'\">\n		<div class=\"center-block clip-delivery-progress ng-scope ng-binding\"\n			 data-tooltip-append-to-body=\"true\"\n			 uib-tooltip=\"{{pkgLiveClip.deliveryProgressMap[clip.id]}}\">\n			<div class=\"progress-container\" ng-if=\"pkgLiveClip.deliveryProgressMap[clip.id]\">\n				<uib-progress class=\"prism-progress pull-left\" max=\"pkgLiveClip.deliveryProgressMap[clip.id].split(\'/\')[1]\">\n					<uib-bar class=\"prism-progressbar\" value=\"pkgLiveClip.deliveryProgressMap[clip.id].split(\'/\')[0]\"></uib-bar>\n				</uib-progress>\n				<span class=\"prism-progress-pct-label\">({{pkgLiveClip.deliveryProgressMap[clip.id]}})</span>\n			</div>\n		</div>\n		<div class=\"clip-thumb-container\" ng-click=\"pkgLiveClip.clipThumbClicked(clip)\">\n			<img ng-class=\"{\'clip-hidden\' : clip.hidden}\" src=\"{{pkgLiveClip.getAssetURL(clip)}}\" width=\"160\"/>\n			<div class=\"clip-thumb-button\">\n				<div class=\"fa-stack\">\n					<i class=\"fa fa-circle-thin fa-stack-1x\"></i>\n					<i class=\"fa fa-play fa-stack-1x\"></i>\n				</div>\n			</div>\n		</div>\n	</div>\n	<div class=\"clip-detail-col\" ng-class=\"{\'clip-hidden\' : clip.hidden}\">\n		<div class=\"row\">\n			<div class=\"col-md-12\">\n				<div class=\"pull-right clip-detail-button\">\n					<button class=\"clip-accept-button\" ng-disabled=\"pkgLiveClip.disableClipAccept(clip) === true\"\n							ng-show=\"clip.acceptStatus !== \'ACCEPTED\'\"\n							ng-click=\"pkgLiveClip.acceptClip(clip)\">Accept\n					</button>\n				</div>\n			</div>\n		</div>\n		<div class=\"row\">\n			<div class=\"col-md-12\">\n				<span>{{clip.title}}\n					<ui-lock is-locked=\"clip.lockedBy || clip.locked\" ng-if=\"clip.lockedBy || clip.locked\" click-handler=\"pkgLiveClip.unlockClip(clip)\"\n							 uib-tooltip=\"{{\'Currently Editing: \' + clip.lockedBy.firstName + \' \' + clip.lockedBy.lastName}}\"></ui-lock>\n					<div ng-if=\"pkgLiveClip.clipHasErrorsWarnings(clip)\" class=\"fa-stack fa error-warning-triangle metadata\"\n						 ng-class=\"pkgLiveClip.clipHasErrors(clip)? \' tree-top-level-error\' : \' tree-top-level-warning\'\"\n						 ng-click=\"pkgLiveClip.showErrorsAndWarningsForClip(clip)\">\n						<i class=\"fa fa-square fa-stack-1x\"></i>\n						<i class=\"fa fa-exclamation-triangle fa-stack-2x\"></i>\n					</div>\n				</span>\n			</div>\n		</div>\n		<div class=\"row\">\n			<div class=\"col-md-4 no-right-padding\">\n				<span>IN: {{clip.clipStartOffset | timecodeFromSec:pkgLiveClip.props.framerate:pkgLiveClip.getClipFeed(clip).isLive}}</span>\n			</div>\n			<div class=\"col-md-4 clip-out-col\">\n				<span>OUT: {{clip.clipEndOffset | timecodeFromSec:pkgLiveClip.props.framerate:pkgLiveClip.getClipFeed(clip).isLive}}</span>\n			</div>\n			<div class=\"col-md-4 no-right-padding\">\n				<span>DUR: {{ clip.clipDuration | durationFromSec}}</span>\n			</div>\n		</div>\n		<div class=\"row\">\n			<div class=\"col-md-12\">\n				<span>ID:  {{clip.id}}</span>\n			</div>\n		</div>\n		<div class=\"row\">\n			<div class=\"col-md-12\">\n				<span>Feed: {{pkgLiveClip.getClipFeed(clip).shortLabel || pkgLiveClip.getClipFeed(clip).label}}</span>\n			</div>\n		</div>\n		<div class=\"row\">\n			<div class=\"col-md-12\">\n				<span>Updated By:  {{clip.updatedBy.firstName }} {{clip.updatedBy.lastName}}</span>\n			</div>\n		</div>\n		<div class=\"row\" ng-if=\"clip.lockedBy\">\n			<div class=\"col-md-12\">\n				<span>Currently Editing: {{clip.lockedBy.firstName }} {{clip.lockedBy.lastName}}</span>\n			</div>\n		</div>\n		<div class=\"row\">\n			<div class=\"col-md-12\">\n				<span class=\"\" ng-if=\"!clip.revision || clip.revision <= 1\">Status:\n					<span class=\"clip-status-text\"\n						  ng-class=\"{\'status-stalled\' : clip.status === \'STALLED\', \'status-executing\': clip.status === \'EXECUTING\', \'status-delivered\': clip.status === \'DELIVERED\'}\">{{clip.status | enumFilter:\'Package_status\'}}</span>\n				</span>\n				<span class=\"\" ng-if=\"clip.revision > 1\">Status:\n					<span class=\"clip-status-link\" ng-click=\"pkgLiveClip.openCompletedDeliveriesModal(clip)\"\n						  ng-class=\"{\'status-stalled\' : clip.status === \'STALLED\', \'status-executing\': clip.status === \'EXECUTING\', \'status-delivered\': clip.status === \'DELIVERED\'}\">{{clip.status | enumFilter:\'Package_status\'}}</span>\n				</span>\n			</div>\n		</div>\n		<div class=\"row\">\n			<div class=\"col-md-12\">\n				<div class=\"pull-right\">\n					<button class=\"btn btn-default prism-button\" ng-show=\"pkgLiveClip.showClipEditButton(clip)\" ng-disabled=\"clip.lockedBy || clip.locked || clip.hidden\"\n							ng-click=\"pkgLiveClip.editClip(clip)\">Edit\n					</button>\n				</div>\n			</div>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("package/editor/components/view/liveclip/renderers/clipList/clip-list-drawer-template.html", "<div class=\"row padding-left-sm\">\n	<div class=\"edit-view-container live-clip-list-container\">\n		<div class=\"row\">\n			<div class=\"col-md-12\">\n				<div class=\"row\">\n					<div class=\"col-md-8 no-padding-right\">\n						<div class=\"row padding-bottom-xsm\">\n							<div class=\"col-md-12\">\n							</div>\n						</div>\n						<div class=\"row\">\n							<div class=\"col-md-12 \">\n								<div class=\"input-group input-group-unstyled\">\n									<input id=\"clipSearchTextInput\" type=\"text\" class=\"prism-text-input\" ng-model=\"pkgLiveClip.clipSearch.text\">\n									<span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span>\n								</div>\n							</div>\n						</div>\n					</div>\n					<div class=\"col-md-4 clip-drawer-stats\" ng-class=\"{\'draft-mode\' : pkgLiveClip.draftClipMode}\">\n						<div class=\"row\">\n							<div class=\"col-md-12\">\n								<span ng-if=\"!pkgLiveClip.draftClipMode\">TOTAL Clips: {{pkgLiveClip.clips.length}}</span>\n								<span ng-if=\"pkgLiveClip.draftClipMode\">TOTAL Draft Clips: {{pkgLiveClip.draftClips.length}}</span>\n							</div>\n						</div>\n						<div class=\"row\">\n							<div class=\"col-md-12\">\n								<span ng-if=\"!pkgLiveClip.draftClipMode\">TOTAL Duration: {{pkgLiveClip.totalDuration | durationFromSec}}</span>\n								<span ng-if=\"pkgLiveClip.draftClipMode\"><button class=\"btn btn-default prism-button\"\n									  ng-click=\"pkgLiveClip.showCreateDraftClipModal()\">Add</button></span>\n							</div>\n						</div>\n						<div class=\"row\" ng-if=\"!pkgLiveClip.draftClipMode\">\n							<label for=\"showDeliveredClipsCB\" class=\"col-md-10 padding-right-xsm\">\n								Show Delivered\n							</label>\n							<div class=\"col-md-1 no-left-padding\">\n								<input type=\"checkbox\" id=\"showDeliveredClipsCB\" ng-model=\"pkgLiveClip.clipSearch.includeDelivered\"/>\n								<label for=\"showDeliveredClipsCB\"></label>\n							</div>\n						</div>\n					</div>\n				</div>\n				<div class=\"list-group-item clip-list-toolbar\">\n					<span class=\"inline-label\">\n						<input type=\"checkbox\" id=\"cb-select-all-clips\" ng-click=\"pkgLiveClip.selectAllClicked()\"\n							   ng-model=\"pkgLiveClip.selectAllFlag\">\n						<label for=\"cb-select-all-clips\"></label>\n					</span>\n					<div class=\"checkbox-spacer row\">\n						<span>\n							<button type=\"button\" class=\"btn btn-xs btn-default prism-button clip-type-toggle\"\n									ng-click=\"pkgLiveClip.toggleDraftClipMode()\">{{(pkgLiveClip.draftClipMode)? \'Draft Clips\' : \'Clips\'}}\n								<span class=\"loadingIndicator\" ng-show=\"pkgLiveClip.showClipsLoading\">\n									<span class=\"preloader-container\">\n										<span class=\"preloader-sm\">\n											<img class=\"preloader-img img-sm\" src=\"assets/progress/preloader_small.svg\">\n										</span>\n									</span>\n								</span>\n							</button>\n						</span>\n\n						<span ng-show=\"false\" class=\"vod-toggle-container\">\n							<!--\n							 	Reserved for future use\n							  -->\n							<button type=\"button\" class=\"btn btn-xs btn-default prism-button clip-type-toggle\"\n									ng-click=\"pkgLiveClip.vodMode = !pkgLiveClip.vodMode\">\n								{{(pkgLiveClip.vodMode) ? \'VOD\' : \'Clipping\'}}\n							</button>\n						</span>\n\n					</div>\n				</div>\n				<ul class=\"list-group clip-list\">\n					<li ng-if=\"!pkgLiveClip.draftClipMode\" class=\"list-group-item clip-list-item-renderer\" ng-repeat=\"clip in pkgLiveClip.clips | filter:pkgLiveClip.searchClips\">\n						<div ng-include=\"\'package/editor/components/view/liveclip/renderers/clipList/clip-list-clip-renderer-template.html\'\"></div>\n					</li>\n					<li ng-if=\"pkgLiveClip.draftClipMode\" class=\"list-group-item draft-clip-list-item-renderer\" ng-repeat=\"clip in pkgLiveClip.draftClips | filter:pkgLiveClip.searchClips\">\n						<div ng-include=\"\'package/editor/components/view/liveclip/renderers/clipList/draft-clip-list-clip-renderer-template.html\'\"></div>\n					</li>\n				</ul>\n			</div>\n		</div>\n	</div>\n</div>\n\n");
        $templateCache.put("package/editor/components/view/liveclip/renderers/clipList/draft-clip-list-clip-renderer-template.html", "<div class=\"row\">\n	<div class=\"col-md-8\">\n		<input id=\"{{\'cb-\' + clip.id}}\" type=\"checkbox\" ng-checked=\"pkgLiveClip.isClipSelected(clip)\"\n			   ng-click=\"pkgLiveClip.selectClipCheckboxClicked(clip, $event)\">\n		<label for=\"{{\'cb-\' + clip.id}}\">\n			<span>\n				{{($index + 1) + \'. \'}}\n				<ui-lock is-locked=\"clip.lockedBy || clip.locked\" click-handler=\"pkgLiveClip.unlockClip(clip)\" class=\"spacer-top-xsm\"\n						 uib-tooltip=\"{{\'Currently Editing: \' + clip.lockedBy.firstName + \' \' + clip.lockedBy.lastName}}\"\n						 data-tooltip-append-to-body=\"true\" ng-if=\"clip.lockedBy || clip.locked\">\n				</ui-lock>\n				{{clip.title}}\n				<div ng-if=\"pkgLiveClip.clipHasErrorsWarnings(clip)\" class=\"fa-stack fa error-warning-triangle metadata\"\n					 ng-class=\"pkgLiveClip.clipHasErrors(clip)? \' tree-top-level-error\' : \' tree-top-level-warning\'\"\n					 ng-click=\"pkgLiveClip.showErrorsAndWarningsForClip(clip)\">\n					<i class=\"fa fa-square fa-stack-1x\"></i>\n					<i class=\"fa fa-exclamation-triangle fa-stack-2x\"></i>\n				</div>\n			</span>\n		</label>\n	</div>\n	<div class=\"col-md-4\">\n		<div class=\"pull-right\">\n			<button class=\"btn btn-default prism-button\" ng-click=\"pkgLiveClip.editClip(clip)\" ng-disabled=\" clip.locked || clip.lockedBy || clip.hidden\"\n					ng-show=\"pkgLiveClip.showClipEditButton(clip)\">Edit\n			</button>\n			<button class=\"btn btn-default prism-button\" ng-click=\"pkgLiveClip.removeDraftClip(clip)\"\n					ng-show=\"pkgLiveClip.showClipEditButton(clip)\">Remove\n			</button>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("package/editor/components/view/media/assetList/adPodAssetList/package-media-adpod-asset-list-template.html", "<div class=\"edit-view-container\"\n     ng-if=\"$ctrl.adPodAcceptProfile\"\n     id=\"mainVideoEditContainer\">\n\n    <!-- Media Status Header -->\n    <package-media-asset-list-header\n        ingest-percent=\"$ctrl.getIngestPercent()\"\n        type=\"\'ad pod\'\">\n    </package-media-asset-list-header>\n\n    <hr/>\n\n    <div class=\"flex-row-container clearfix\">\n        <label for=\"adpodAcceptProfile\"\n               class=\"padding-left-xl padding-right-md prism-form-item-label text-align-right\">\n            Document Accept Profile\n        </label>\n        <div class=\"input-background-placeholder\"\n             ng-disabled=\"true\">\n            <p class=\"prism-form-control-static padding-right-lg\"\n               id=\"adpodAcceptProfile\">\n                {{$ctrl.adPodAcceptProfile.name}}\n            </p>\n        </div>\n\n        <span class=\"flex-stretcher\"><!-- Spacer --></span>\n\n        <button class=\"btn btn-default prism-button flex-align-end\"\n                ng-click=\"$ctrl.addNewAdPod()\"\n                id=\"addAdPodAssetButton\"\n                ng-disabled=\"!$ctrl.adPodAcceptProfile || !$ctrl.isEnabled()\">\n            Add\n        </button>\n    </div>\n\n    <hr/>\n\n    <div class=\"package-media-asset-selector-container\"\n         ng-if=\"$ctrl.getAdPod()\">\n        <button type=\"button\"\n                class=\"close media-render-close\"\n                ng-click=\"$ctrl.removeAdPod()\"\n                id=\"{{\'removeAdPod\'}}\">\n            <i class=\"fa fa-close\"></i>\n            <span class=\"sr-only\">Close</span>\n        </button>\n\n        <package-media-adpod-asset-selector\n            adpod-asset=\"$ctrl.getAdPod()\">\n        </package-media-adpod-asset-selector>\n\n    </div>\n\n    <hr/>\n\n</div>\n");
        $templateCache.put("package/editor/components/view/media/assetList/audioAssetList/package-media-audio-asset-list-template.html", "<div class=\"edit-view-container\"\n     ng-if=\"$ctrl.isVisible()\"\n     id=\"mainVideoEditContainer\">\n\n\n    <!-- Media Status Header -->\n    <package-media-asset-list-header\n        ingest-percent=\"$ctrl.getIngestPercent()\"\n        type=\"\'audio\'\">\n    </package-media-asset-list-header>\n\n    {{$ctrl.getPartnersRequiring()}}\n\n    <hr/>\n\n    <div class=\"flex-row-container clearfix\">\n\n        <span class=\"flex-stretcher\"><!-- Spacer --></span>\n\n        <button class=\"btn btn-default prism-button flex-align-end\"\n                ng-click=\"$ctrl.addNewAudio()\"\n                id=\"addMainAudioMediaButton\"\n                ng-disabled=\"!$ctrl.isEnabled()\">\n            Add\n        </button>\n    </div>\n\n    <hr/>\n\n    <div ng-repeat=\"audioAsset in $ctrl.getAudioList()\"\n         class=\"package-media-asset-selector-container\">\n        <button type=\"button\"\n                class=\"close media-render-close\"\n                ng-click=\"$ctrl.removeAudio(audioAsset)\"\n                id=\"{{\'removeAudio\' + $index}}\">\n            <i class=\"fa fa-close\"></i>\n            <span class=\"sr-only\">Close</span>\n        </button>\n        <package-media-audio-asset-selector\n            audio-asset=\"audioAsset\"\n            list-index=\"$index\">\n        </package-media-audio-asset-selector>\n    </div>\n\n    <hr/>\n\n</div>\n");
        $templateCache.put("package/editor/components/view/media/assetList/header/package-media-asset-list-header-template.html", "<div class=\"package-media-list-header flex-row-container clearfix\">\n\n    <!-- Asset Type -->\n    <div class=\"package-media-header-asset-type flex-align-start prism-form-heading\">\n        <i ng-show=\"$ctrl.ingestPercent === 100\"\n           class=\"fa green-check\"></i>{{$ctrl.getTypeLabel()}}\n    </div>\n\n    <!-- Progress Bar -->\n    <div class=\"package-media-header-ingest-progress flex-align-start\">\n        <uib-progressbar class=\"progress-striped active\"\n                         ng-show=\"$ctrl.ingestPercent >= 0 && $ctrl.ingestPercent < 100\"\n                         value=\"$ctrl.ingestPercent\">\n            {{$ctrl.ingestPercent}}%\n        </uib-progressbar>\n    </div>\n\n    <!-- Required / Optional -->\n    <div class=\"package-media-header-required-optional flex-align-end\"\n         tooltip-placement=\"left\">\n        <span uib-tooltip-html=\"\'{{$ctrl.getTooltip()}}\'\">{{$ctrl.getValidationStatus()}}</span>\n    </div>\n\n</div>\n");
        $templateCache.put("package/editor/components/view/media/assetList/imageAssetList/package-media-image-asset-list-template.html", "<div class=\"edit-view-container\"\n     ng-if=\"$ctrl.isVisible()\"\n     id=\"mainVideoEditContainer\">\n\n    <!-- Media Status Header -->\n    <package-media-asset-list-header\n        ingest-percent=\"$ctrl.getIngestPercent()\"\n        type=\"\'image\'\">\n    </package-media-asset-list-header>\n\n    <hr/>\n\n    <!-- Fields -->\n    <div class=\"flex-row-container clearfix\">\n\n        <label for=\"imageAcceptProfile\"\n               class=\"padding-left-xl padding-right-md prism-form-item-label text-align-right\">\n            Image Accept Profile\n        </label>\n        <dropdown-select\n            collection=\"$ctrl.acceptTemplateMembers\"\n            collection-filter=\"\n                {\n                    validationType: \'!NOT_APPLICABLE\',\n                    acceptProfile: {\n                        type: \'IMAGE\'\n                    }\n                }\"\n            id=\"imageAcceptProfile\"\n            label-field=\"name\"\n            ng-disabled=\"!$ctrl.isEnabled()\"\n            ng-model=\"$ctrl.selectedImageAcceptTemplateMember\"\n            ng-model-options=\"{ getterSetter: true }\"\n            on-change=\"$ctrl.onImageAcceptTemplateMemberChanged()\"\n            prompt=\"Select MAP\"\n            track-by=\"acceptProfile\">\n        </dropdown-select>\n\n        <span class=\"flex-stretcher\"><!-- Spacer --></span>\n\n        <button class=\"btn btn-default prism-button flex-align-end\"\n                ng-click=\"$ctrl.addNewImage()\"\n                id=\"addMainImageMediaButton\"\n                ng-disabled=\"!$ctrl.selectedImageAcceptTemplateMember() || !$ctrl.isEnabled()\">\n            Add\n        </button>\n    </div>\n\n    <hr/>\n\n    <div ng-repeat=\"imageAsset in $ctrl.getImageList()\"\n         class=\"package-media-asset-selector-container\">\n        <button type=\"button\"\n                class=\"close media-render-close\"\n                ng-click=\"$ctrl.removeImage(imageAsset)\"\n                id=\"{{\'removeMainImage\' + $index}}\">\n            <i class=\"fa fa-close\"></i>\n            <span class=\"sr-only\">Close</span>\n        </button>\n        <package-media-image-asset-selector\n            image-asset=\"imageAsset\"\n            list-index=\"$index\">\n        </package-media-image-asset-selector>\n\n    </div>\n\n    <hr/>\n\n</div>\n");
        $templateCache.put("package/editor/components/view/media/assetList/textAssetList/package-media-text-asset-list-template.html", "<div class=\"edit-view-container\"\n     ng-if=\"$ctrl.isVisible()\"\n     id=\"mainVideoEditContainer\">\n\n    <!-- Media Status Header -->\n    <package-media-asset-list-header\n        component-role=\"$ctrl.componentRole\"\n        ingest-percent=\"$ctrl.getIngestPercent()\"\n        type=\"$ctrl.variant\">\n    </package-media-asset-list-header>\n\n    <hr/>\n\n    <div class=\"flex-row-container clearfix\">\n\n        <span class=\"flex-stretcher\"><!-- Spacer --></span>\n\n        <button class=\"btn btn-default prism-button flex-align-end\"\n                ng-click=\"$ctrl.addNewTextTrack()\"\n                id=\"addMainImageMediaButton\"\n                ng-disabled=\"!$ctrl.isEnabled()\">\n            Add\n        </button>\n    </div>\n\n    <hr/>\n\n    <div ng-repeat=\"textTrackAsset in $ctrl.getTextTrackList()\"\n         class=\"package-media-asset-selector-container\">\n        <button type=\"button\"\n                class=\"close media-render-close\"\n                ng-click=\"$ctrl.removeTextTrack(textTrackAsset)\"\n                id=\"{{\'removeTextTrackAsset\' + $index}}\">\n            <i class=\"fa fa-close\"></i>\n            <span class=\"sr-only\">Close</span>\n        </button>\n        <package-media-text-asset-selector\n            component-role=\"$ctrl.componentRole\"\n            list-index=\"$index\"\n            text-accept-template=\"$ctrl.getAcceptTemplate()\"\n            text-asset=\"textTrackAsset\"\n            variant=\"$ctrl.variant\">\n        </package-media-text-asset-selector>\n\n    </div>\n\n    <hr/>\n\n</div>\n");
        $templateCache.put("package/editor/components/view/media/assetList/videoComponentAssetList/package-media-component-video-asset-list-template.html", "<div class=\"edit-view-container\"\n     id=\"componentVideoEditContainer\">\n\n\n    <!-- Media Status Header -->\n    <package-media-asset-list-header\n        component-role=\"$ctrl.componentRole\"\n        ingest-percent=\"$ctrl.getIngestPercent()\"\n        type=\"\'video\'\">\n    </package-media-asset-list-header>\n\n    <hr/>\n\n    <div class=\"flex-row-container clearfix\">\n\n        <span class=\"flex-stretcher\"><!-- Spacer --></span>\n\n        <button class=\"btn btn-default prism-button flex-align-end\"\n                ng-click=\"$ctrl.addNewComponentVideo()\"\n                id=\"addComponentVideoAssetButton\">\n            Add\n        </button>\n    </div>\n\n    <hr/>\n\n    <div ng-repeat=\"componentVideoAsset in $ctrl.getComponentVideoList()\"\n         class=\"package-media-asset-selector-container\">\n        <button type=\"button\"\n                class=\"close media-render-close\"\n                ng-click=\"$ctrl.removeComponentVideo(componentVideoAsset)\"\n                id=\"{{\'removeComponentVideo\' + $index}}\">\n            <i class=\"fa fa-close\"></i>\n            <span class=\"sr-only\">Close</span>\n        </button>\n        <package-media-component-video-asset-selector\n            component-role=\"$ctrl.componentRole\"\n            component-video-asset=\"componentVideoAsset\"\n            list-index=\"$index\">\n        </package-media-component-video-asset-selector>\n\n    </div>\n\n    <hr/>\n\n</div>\n");
        $templateCache.put("package/editor/components/view/media/assetList/videoMainAssetList/package-media-main-video-asset-list-template.html", "<div class=\"edit-view-container package-media-asset-list\"\n     id=\"mainVideoAssetList\">\n\n    <!-- Media Status Header -->\n    <package-media-asset-list-header\n        ingest-percent=\"$ctrl.getIngestPercent()\"\n        type=\"$ctrl.isHdrVideo() ? \'hdr video\' : \'sdr video\'\">\n    </package-media-asset-list-header>\n\n    <hr/>\n\n    <div class=\"flex-row-container clearfix\">\n\n        <label for=\"videoAcceptProfile\"\n               class=\"padding-left-xl padding-right-md prism-form-item-label text-align-right\">\n            Video Accept Profile\n        </label>\n\n        <dropdown-select\n            btn-min-width=\"350\"\n            collection=\"$ctrl.acceptTemplateMembers\"\n            collection-filter=\"\n                    {\n                        validationType: \'!NOT_APPLICABLE\',\n                        acceptProfile: {\n                            liveClipsOnly: false,\n                            type: \'VIDEO\'\n                        }\n                    }\"\n            id=\"videoAcceptProfile\"\n            label-field=\"name\"\n            ng-model=\"$ctrl.selectedVideoAcceptTemplateMember\"\n            ng-model-options=\"{ getterSetter: true }\"\n            on-change=\"$ctrl.onVideoAcceptProfileChange()\"\n            prompt=\"Select MAP\"\n            track-by=\"acceptProfile\">\n        </dropdown-select>\n\n        <span class=\"flex-stretcher\"><!-- Spacer --></span>\n\n        <button class=\"btn btn-default prism-button flex-align-end\"\n                ng-click=\"\"\n                id=\"addMainVideoMediaButton\"\n                ng-show=\"false\"\n                ng-disabled=\"true\">\n            Add\n        </button>\n    </div>\n\n    <hr/>\n\n    <div class=\"package-media-asset-selector-container\"\n         ng-if=\"$ctrl.getMainVideo()\">\n\n        <span class=\"remove-asset-button\">\n            &nbsp;<!-- Spacer only - can\'t remove main video -->\n        </span>\n\n        <package-media-video-main-asset-selector>\n        </package-media-video-main-asset-selector>\n\n    </div>\n\n\n    <div class=\"package-media-asset-selector-container\"\n         ng-if=\"$ctrl.isHdrVideo()\">\n\n        <button type=\"button\"\n                class=\"btn close media-render-close\"\n                ng-show=\"$ctrl.hasHdrVideoXml()\"\n                ng-click=\"$ctrl.removeHdrXml()\"\n                id=\"removeHdrXml\">\n            <i class=\"fa fa-close\"></i>\n            <span class=\"sr-only\">Close</span>\n        </button>\n\n        <package-media-hdr-xml-asset-selector>\n        </package-media-hdr-xml-asset-selector>\n\n    </div>\n\n    <hr/>\n\n</div>\n");
        $templateCache.put("package/editor/components/view/media/assetSelector/adPod/package-media-adpod-asset-selector-template.html", "<form class=\"package-media-asset-selector flex-row-container clearfix\"\n      role=\"form\">\n\n    <!-- File upload -->\n    <file-select ng-model=\"$ctrl.currentFile\"\n                 ng-change=\"$ctrl.onCurrentFileChanged()\"\n                 get-file-extensions=\"$ctrl.getAcceptProfile().fileExtensions\"\n                 get-local-file-pre-validation-errors=\"$ctrl.getLocalFilePreValidationErrors(file, filter)\"\n                 initialize-uploader-config=\"$ctrl.initializeLocalUploaderConfig(fileUploaderConfig)\"\n                 remote-upload-enabled=\"$ctrl.remoteUploadEnabled()\"\n                 validate-remote-file=\"$ctrl.validateRemoteFile(fileSystemItem)\"\n                 validate-aspera-file=\"$ctrl.validateAsperaFile(asperaFileObject)\"\n                 validate-local-file=\"$ctrl.validateLocalFile(fileItem, fileUploaderConfig)\"\n                 drag-drop-source=\"\'LOCAL\'\"\n                 drag-drop-id=\"\'adpod\'\">\n    </file-select>\n\n    <span class=\"horizontal-spacer-10\"></span>\n\n    <!-- Asset MAP selection -->\n    <div class=\"asset-map-area flex-row-container clearfix\">\n        <!-- No per-asset MAP selection for adpod assets -->\n    </div>\n\n    <!-- Asset path -->\n    <span>\n        <label class=\"prism-form-item-label text-align-right\"\n               for=\"adpodFileInput\">\n            AdPod File\n        </label>\n    </span>\n    &nbsp;\n    <span class=\"prism-form-control-static input-background-placeholder flex-stretcher asset-virtual-path\"\n          id=\"adpodFileInput\"\n          uib-tooltip=\"{{$ctrl.adpodAsset.virtualPath | fileNameFromPath}}\"\n          ng-model=\"$ctrl.adpodAsset.virtualPath\"\n          data-tooltip-append-to-body=\"true\"\n          required>\n        <!--\n            Note - by having an ngModel and the \"required\"\n            directive, the virtualPath property is enrolled in\n            form validation.\n        -->\n        {{$ctrl.adpodAsset.virtualPath | fileNameFromPath}}\n    </span>\n\n    <!-- Asset info -->\n    <a class=\"fa fa-info-circle fa-2x prism-into-button asset-info-button disabled-ingester-button\"\n       id=\"adPodAssetInfoBtn\"\n       uib-tooltip=\"(Not Applicable)\"\n       ng-disabled=\"true\">\n    </a>\n\n    <qc-note-icon\n        class=\"asset-qc-notes-button\"\n        id=\"adPodQCNotesBtn\"\n        icon-state=\"$ctrl.adpodAsset.qualityControlNote? \'edit\' : \'add\'\"\n        ng-click=\"$ctrl.onQualityControlButtonClick($event)\">\n    </qc-note-icon>\n\n\n    <span class=\"asset-errors-and-warnings-indicator\">\n        <!-- AdPods do not have errors/warnings -->\n        &nbsp;\n    </span>\n\n    <span class=\"horizontal-spacer-10\"></span>\n\n    <div class=\"asset-role-area flex-row-container\">\n        <!-- No language/role selection for adpod assets -->\n    </div>\n\n    <span class=\"horizontal-spacer-10\"></span>\n\n</form>\n");
        $templateCache.put("package/editor/components/view/media/assetSelector/audio/package-media-audio-asset-selector-template.html", "<form class=\"package-media-asset-selector flex-row-container clearfix\"\n      role=\"form\">\n\n    <!-- File upload -->\n    <file-select ng-model=\"$ctrl.currentFile\"\n                 ng-change=\"$ctrl.onCurrentFileChanged()\"\n                 ng-disabled=\"!$ctrl.audioAsset.acceptTemplateMember\"\n                 get-file-extensions=\"$ctrl.getFileExtensions()\"\n                 get-local-file-pre-validation-errors=\"$ctrl.getLocalFilePreValidationErrors(file, filter)\"\n                 initialize-uploader-config=\"$ctrl.initializeLocalUploaderConfig(fileUploaderConfig)\"\n                 remote-upload-enabled=\"$ctrl.remoteUploadEnabled()\"\n                 validate-remote-file=\"$ctrl.validateRemoteFile(fileSystemItem)\"\n                 validate-aspera-file=\"$ctrl.validateAsperaFile(asperaFileObject)\"\n                 validate-local-file=\"$ctrl.validateLocalFile(fileItem, fileUploaderConfig)\"\n                 drag-drop-source=\"\'LOCAL\'\"\n                 drag-drop-id=\"\'audio_\' + $ctrl.listIndex\">\n    </file-select>\n\n    <span class=\"horizontal-spacer-10\"></span>\n\n    <!-- Asset MAP selection -->\n    <div class=\"asset-map-area flex-row-container clearfix\">\n        <dropdown-select\n            collection=\"$ctrl.acceptTemplateMembers\"\n            collection-filter=\"{ validationType: \'!NOT_APPLICABLE\', acceptProfile: { type: \'AUDIO\' } }\"\n            required\n            default-select-index=\"0\"\n            id=\"audioAcceptProfile\"\n            prompt=\"Select MAP\"\n            label-field=\"name\"\n            ng-model=\"$ctrl.audioAsset.acceptTemplateMember\"\n            on-change=\"$ctrl.onAudioAcceptTemplateMemberChanged()\"\n            sort-collection=\"true\"\n            track-by=\"acceptProfile\">\n        </dropdown-select>\n    </div>\n\n    <!-- Asset Path -->\n    <span>\n        <label class=\"prism-form-item-label text-align-right\"\n               for=\"{{\'audioFileInput\' + $ctrl.audioAsset.type + $ctrl.listIndex}}\">\n            Audio File\n        </label>\n    </span>\n    &nbsp;\n    <span class=\"prism-form-control-static input-background-placeholder flex-stretcher asset-virtual-path\"\n          id=\"{{\'audioFileInput\' + $ctrl.audioAsset.type + $ctrl.listIndex}}\"\n          uib-tooltip=\"{{$ctrl.audioAsset.virtualPath | fileNameFromPath}}\"\n          ng-model=\"$ctrl.audioAsset.virtualPath\"\n          data-tooltip-append-to-body=\"true\"\n          required>\n        <!--\n            Note - by having an ngModel and the \"required\"\n            directive, the virtualPath property is enrolled in\n            form validation.\n        -->\n        {{$ctrl.audioAsset.virtualPath | fileNameFromPath}}\n    </span>\n\n    <!-- Asset info -->\n    <a id=\"{{\'audioFileInfo\' + $ctrl.listIndex}}\"\n       class=\"fa fa-info-circle fa-2x prism-into-button asset-info-button\"\n       ng-click=\"$ctrl.onViewAssetButtonClick($event)\">\n    </a>\n\n    <qc-note-icon\n        class=\"asset-qc-notes-button\"\n        icon-state=\"$ctrl.audioAsset.qualityControlNote? \'edit\' : \'add\'\"\n        ng-click=\"$ctrl.onQualityControlButtonClick($event)\">\n    </qc-note-icon>\n\n    <span class=\"asset-errors-and-warnings-indicator\">\n        <!-- Sidecar audio assets do not have errors/warnings -->\n        &nbsp;\n    </span>\n\n    <span class=\"horizontal-spacer-10\">&nbsp;</span>\n\n    <!-- Audio asset language and role selectors -->\n    <div class=\"asset-role-area flex-row-container\">\n\n        <dropdown-select\n            id=\"{{\'audioLanguageSelect\' + $ctrl.listIndex}}\"\n            ng-model=\"$ctrl.audioAsset.language\"\n            required\n            prompt=\"Spoken Language\"\n            label-field=\"name\"\n            sort-collection=\"false\"\n            collection=\"$ctrl.languages\">\n        </dropdown-select>\n\n        <span class=\"horizontal-spacer-10\"></span>\n\n        <dropdown-select\n            id=\"{{\'audioRoleSelect\' + $ctrl.listIndex}}\"\n            ng-model=\"$ctrl.audioAsset.role\"\n            required\n            prompt=\"Select Audio Role\"\n            label-field=\"name\"\n            collection=\"$ctrl.audioRoles\">\n        </dropdown-select>\n\n    </div>\n\n\n    <span class=\"horizontal-spacer-10\"></span>\n\n</form>\n");
        $templateCache.put("package/editor/components/view/media/assetSelector/image/package-media-image-asset-selector-template.html", "<div class=\"package-media-asset-selector flex-row-container clearfix\">\n\n    <!-- File upload -->\n    <file-select ng-model=\"$ctrl.currentFile\"\n                 ng-change=\"$ctrl.onCurrentFileChanged()\"\n                 ng-disabled=\"!$ctrl.getSelectedAcceptTemplateMember()\"\n                 get-file-extensions=\"$ctrl.getSelectedAcceptTemplateMember().acceptProfile.fileExtensions\"\n                 get-local-file-pre-validation-errors=\"$ctrl.getLocalFilePreValidationErrors(file, filter)\"\n                 initialize-uploader-config=\"$ctrl.initializeLocalUploaderConfig(fileUploaderConfig)\"\n                 remote-upload-enabled=\"$ctrl.remoteUploadEnabled()\"\n                 validate-remote-file=\"$ctrl.validateRemoteFile(fileSystemItem)\"\n                 validate-aspera-file=\"$ctrl.validateAsperaFile(asperaFileObject)\"\n                 validate-local-file=\"$ctrl.validateLocalFile(fileItem, fileUploaderConfig)\"\n                 drag-drop-source=\"\'LOCAL\'\"\n                 drag-drop-id=\"\'image_\' + $ctrl.listIndex\">\n    </file-select>\n\n    <span class=\"horizontal-spacer-10\"></span>\n\n    <!-- Asset MAP selection -->\n    <div class=\"asset-map-area flex-row-container clearfix\">\n        <!-- No per-asset MAP selection for image assets -->\n    </div>\n\n    <!-- Asset path -->\n    <span>\n        <label class=\"prism-form-item-label text-align-right\"\n               for=\"{{\'imageFileInput\' + $ctrl.imageAsset.type + $ctrl.listIndex}}\">\n            Image File\n        </label>\n    </span>\n\n    &nbsp;\n\n    <span class=\"prism-form-control-static input-background-placeholder flex-stretcher asset-virtual-path\"\n          id=\"{{\'imageFileInput\' + $ctrl.imageAsset.type + $ctrl.listIndex}}\"\n          uib-tooltip=\"{{$ctrl.imageAsset.virtualPath | fileNameFromPath}}\"\n          ng-model=\"$ctrl.imageAsset.virtualPath\"\n          data-tooltip-append-to-body=\"true\"\n          required>\n        <!--\n            Note - by having an ngModel and the \"required\"\n            directive, the virtualPath property is enrolled in\n            form validation.\n        -->\n            {{$ctrl.imageAsset.virtualPath | fileNameFromPath}}\n    </span>\n\n    <!-- Asset info -->\n    <a id=\"{{\'imageFileInfo\' + $ctrl.listIndex}}\"\n       class=\"fa fa-info-circle fa-2x prism-into-button asset-info-button\"\n       ng-click=\"$ctrl.onViewAssetButtonClick($event)\">\n    </a>\n\n    <qc-note-icon\n        class=\"asset-qc-notes-button\"\n        icon-state=\"$ctrl.imageAsset.qualityControlNote? \'edit\' : \'add\'\"\n        ng-click=\"$ctrl.onQualityControlButtonClick($event)\">\n    </qc-note-icon>\n\n    <span class=\"asset-errors-and-warnings-indicator\">\n        <!-- Images do not have errors/warnings -->\n        &nbsp;\n    </span>\n\n    <span class=\"horizontal-spacer-10\"></span>\n\n    <!-- Image language selector -->\n    <div class=\"asset-role-area flex-row-container\">\n\n        <dropdown-select\n            collection=\"$ctrl.languages\"\n            id=\"{{\'languageSelect\' + $ctrl.imageAsset.type + $ctrl.listIndex}}\"\n            label-field=\"name\"\n            ng-model=\"$ctrl.imageAsset.language\"\n            prompt=\"Spoken Language\"\n            required\n            sort-collection=\"false\">\n        </dropdown-select>\n\n    </div>\n\n\n    <span class=\"horizontal-spacer-10\"></span>\n\n</div>\n");
        $templateCache.put("package/editor/components/view/media/assetSelector/text/package-media-text-asset-selector-template.html", "<form class=\"package-media-asset-selector flex-row-container clearfix\"\n      role=\"form\">\n\n    <!-- File upload -->\n    <!-- TODO: Check fileType, not mimeType -->\n    <file-select ng-model=\"$ctrl.currentFile\"\n                 ng-change=\"$ctrl.onCurrentFileChanged()\"\n                 get-file-extensions=\"$ctrl.getFileExtensions()\"\n                 get-local-file-pre-validation-errors=\"$ctrl.getLocalFilePreValidationErrors(file, filter)\"\n                 initialize-uploader-config=\"$ctrl.initializeLocalUploaderConfig(fileUploaderConfig)\"\n                 remote-upload-enabled=\"$ctrl.remoteUploadEnabled()\"\n                 validate-remote-file=\"$ctrl.validateRemoteFile(fileSystemItem)\"\n                 validate-aspera-file=\"$ctrl.validateAsperaFile(asperaFileObject)\"\n                 validate-local-file=\"$ctrl.validateLocalFile(fileItem, fileUploaderConfig)\"\n                 drag-drop-source=\"\'LOCAL\'\"\n                 disabled-sources=\"$ctrl.getDisabledFileSources()\"\n                 button-tooltips=\"$ctrl.getButtonTooltips()\"\n                 drag-drop-id=\"\'text_\' + $ctrl.variant + \'_\' + $ctrl.componentRole.id + \'_\' + $ctrl.listIndex\">\n    </file-select>\n\n    <span class=\"horizontal-spacer-10\"></span>\n\n    <!-- Text file ingest -->\n    <div class=\"flex-stretcher text-asset-selector-row-container flex-row-container\">\n\n        <div class=\"asset-map-area flex-row-container clearfix\">\n            <!-- No per-asset MAP selection for text assets -->\n        </div>\n\n        <!-- Asset path -->\n        <span>\n            <label class=\"prism-form-item-label text-align-right\"\n                   for=\"{{\'textFileInput\' + $ctrl.textAsset.type + $ctrl.componentRoleName + $ctrl.listIndex | removeStringSpaces}}\">\n                Text File\n            </label>\n        </span>\n        &nbsp;\n        <span class=\"prism-form-control-static input-background-placeholder flex-stretcher asset-virtual-path\"\n              id=\"{{\'textFileInput\' + $ctrl.textAsset.type + $ctrl.componentRoleName + $ctrl.listIndex | removeStringSpaces}}\"\n              uib-tooltip=\"{{$ctrl.textAsset.virtualPath | fileNameFromPath}}\"\n              ng-model=\"$ctrl.textAsset.virtualPath\"\n              data-tooltip-append-to-body=\"true\"\n              required>\n            <!--\n                Note - by having an ngModel and the \"required\"\n                directive, the virtualPath property is enrolled in\n                form validation.\n            -->\n            {{$ctrl.textAsset.virtualPath | fileNameFromPath}}\n        </span>\n\n        <!-- Asset info button -->\n        <a class=\"fa fa-info-circle fa-2x prism-into-button asset-info-button\"\n           id=\"{{\'textFileInfo\' + $ctrl.textAsset.type + $ctrl.componentRoleName + $ctrl.listIndex | removeStringSpaces}}\"\n           ng-click=\"$ctrl.onViewAssetButtonClick($event)\">\n        </a>\n\n    </div>\n\n\n    <!-- Text asset Errors & Warnings indicator and QC notes button -->\n    <qc-note-icon\n        class=\"asset-qc-notes-button\"\n        icon-state=\"$ctrl.textAsset.qualityControlNote? \'edit\' : \'add\'\"\n        id=\"{{\'qcNoteBtn\' + $ctrl.textAsset.type + $ctrl.componentRoleName + $ctrl.listIndex  | removeStringSpaces}}\"\n        ng-click=\"$ctrl.onQualityControlButtonClick($event)\">\n    </qc-note-icon>\n    <error-warning-indicator\n        class=\"asset-errors-and-warnings-indicator\"\n        error-warning=\"$ctrl.warnings\"\n        ng-click=\"$ctrl.showAssetWarnings()\">\n    </error-warning-indicator>\n\n    <span class=\"horizontal-spacer-10\"></span>\n\n    <!-- Text asset language and role selectors -->\n    <div class=\"asset-role-area flex-row-container\">\n\n        <dropdown-select\n            collection=\"$ctrl.languages\"\n            id=\"{{\'subLanguageSelect\' + $ctrl.textAsset.type + $ctrl.componentRoleName + $ctrl.listIndex | removeStringSpaces}}\"\n            required\n            label-field=\"name\"\n            ng-change=\"$ctrl.handleSelectedLanguageRoleSelection()\"\n            ng-model=\"$ctrl.textAsset.language\"\n            prompt=\"Language\"\n            sort-collection=\"false\">\n        </dropdown-select>\n\n        <span class=\"horizontal-spacer-10\"></span>\n\n        <dropdown-select\n            collection=\"$ctrl.textTrackRoles\"\n            id=\"{{\'subRoleSelect\' + $ctrl.textAsset.type + $ctrl.componentRoleName + $ctrl.listIndex | removeStringSpaces}}\"\n            required\n            label-field=\"name\"\n            ng-change=\"$ctrl.handleSelectedLanguageRoleSelection()\"\n            ng-model=\"$ctrl.textAsset.role\"\n            prompt=\"{{\'Select \' + $ctrl.textAsset.type + \' Role\'}}\">\n        </dropdown-select>\n\n    </div>\n\n    <span class=\"horizontal-spacer-10\"></span>\n\n</form>\n");
        $templateCache.put("package/editor/components/view/media/assetSelector/videoComponent/package-media-component-video-asset-selector-template.html", "<form class=\"package-media-asset-selector flex-row-container clearfix\"\n      role=\"form\">\n\n    <!-- File upload -->\n    <file-select ng-model=\"$ctrl.currentFile\"\n                 ng-change=\"$ctrl.onCurrentFileChanged()\"\n                 get-file-extensions=\"$ctrl.getPrimaryAcceptTemplateMember().acceptProfile.fileExtensions\"\n                 get-local-file-pre-validation-errors=\"$ctrl.getLocalFilePreValidationErrors(file, filter)\"\n                 initialize-uploader-config=\"$ctrl.initializeLocalUploaderConfig(fileUploaderConfig)\"\n                 remote-upload-enabled=\"$ctrl.remoteUploadEnabled()\"\n                 validate-remote-file=\"$ctrl.validateRemoteFile(fileSystemItem)\"\n                 validate-aspera-file=\"$ctrl.validateAsperaFile(asperaFileObject)\"\n                 validate-local-file=\"$ctrl.validateLocalFile(fileItem, fileUploaderConfig)\"\n                 drag-drop-source=\"\'LOCAL\'\"\n                 disabled-sources=\"$ctrl.getDisabledFileSources()\"\n                 button-tooltips=\"$ctrl.getButtonTooltips()\"\n                 drag-drop-id=\"\'component_video_\' + $ctrl.variant + \'_\' + $ctrl.componentRole.id + \'_\' + $ctrl.listIndex\">\n    </file-select>\n\n    <span class=\"horizontal-spacer-10\"></span>\n\n    <!-- Asset MAP selection -->\n    <div class=\"asset-map-area flex-row-container clearfix\">\n        <!-- No per-asset MAP selection for component video assets -->\n    </div>\n\n    <!-- Asset path -->\n    <label class=\"prism-form-item-label text-align-right\"\n           for=\"{{\'componentVideoFileInput\' + $ctrl.componentRole.name + $ctrl.listIndex | removeStringSpaces}}\">\n        Video File\n    </label>\n    &nbsp;\n    <span class=\"prism-form-control-static input-background-placeholder flex-stretcher\"\n          id=\"{{\'componentVideoFileInput\' + $ctrl.componentRole.name + $ctrl.listIndex | removeStringSpaces}}\"\n          uib-tooltip=\"{{$ctrl.componentVideoAsset.virtualPath | fileNameFromPath}}\"\n          ng-model=\"$ctrl.componentVideoAsset.virtualPath\"\n          data-tooltip-append-to-body=\"true\"\n          required>\n        <!--\n            Note - by having an ngModel and the \"required\"\n            directive, the virtualPath property is enrolled in\n            form validation.\n        -->\n        {{$ctrl.componentVideoAsset.virtualPath | fileNameFromPath}}\n    </span>\n\n    <!-- Asset info -->\n    <a id=\"{{\'videoFileInfo\' + $ctrl.componentRole.name + $ctrl.listIndex | removeStringSpaces}}\"\n       class=\"fa fa-info-circle fa-2x prism-into-button asset-info-button\"\n       ng-click=\"$ctrl.onViewAssetButtonClick($event)\">\n    </a>\n\n    <qc-note-icon\n        icon-state=\"$ctrl.componentVideoAsset.qualityControlNote? \'edit\' : \'add\'\"\n        class=\"asset-qc-notes-button\"\n        id=\"{{\'videoQCButton\' + $ctrl.componentRole.name + $ctrl.listIndex | removeStringSpaces}}\"\n        ng-click=\"$ctrl.onQualityControlButtonClick($event)\">\n    </qc-note-icon>\n\n    <span class=\"asset-errors-and-warnings-indicator\">\n        <!-- Video components do not have errors/warnings -->\n        &nbsp;\n    </span>\n\n    <span class=\"horizontal-spacer-10\"></span>\n\n    <div class=\"asset-role-area flex-row-container\">\n        <!-- No per-asset role selection for video components -->\n    </div>\n\n\n    <span class=\"horizontal-spacer-10\"></span>\n\n</form>\n");
        $templateCache.put("package/editor/components/view/media/assetSelector/videoMain/package-media-video-main-asset-selector-template.html", "<div class=\"package-media-asset-selector flex-row-container clearfix\">\n\n    <!-- File upload -->\n    <file-select ng-model=\"$ctrl.currentFile\"\n                 ng-change=\"$ctrl.onCurrentFileChanged()\"\n                 ng-disabled=\"!$ctrl.getPrimaryAcceptTemplateMember()\"\n                 get-file-extensions=\"$ctrl.getPrimaryAcceptTemplateMember().acceptProfile.fileExtensions\"\n                 get-local-file-pre-validation-errors=\"$ctrl.getLocalFilePreValidationErrors(file, filter)\"\n                 initialize-uploader-config=\"$ctrl.initializeLocalUploaderConfig(fileUploaderConfig)\"\n                 prompt-warnings=\"$ctrl.promptFileWarnings()\"\n                 remote-upload-enabled=\"$ctrl.remoteUploadEnabled()\"\n                 validate-remote-file=\"$ctrl.validateRemoteFile(fileSystemItem)\"\n                 validate-aspera-file=\"$ctrl.validateAsperaFile(asperaFileObject)\"\n                 validate-local-file=\"$ctrl.validateLocalFile(fileItem, fileUploaderConfig)\"\n                 drag-drop-source=\"\'LOCAL\'\"\n                 drag-drop-id=\"\'main_video\'\">\n    </file-select>\n\n    <span class=\"horizontal-spacer-10\"></span>\n\n    <!-- Asset MAP selection -->\n    <div class=\"asset-map-area flex-row-container clearfix\">\n        <!-- No per-asset MAP selection for main video asset -->\n    </div>\n\n    <!-- Asset path -->\n    <span>\n        <label class=\"prism-form-item-label text-align-right\"\n               for=\"videoFileInput\">\n            Video File\n        </label>\n    </span>\n\n    &nbsp;\n\n    <span class=\"prism-form-control-static input-background-placeholder flex-stretcher asset-virtual-path\"\n          id=\"videoFileInput\"\n          uib-tooltip=\"{{$ctrl.getMainVideo().virtualPath | fileNameFromPath}}\"\n          ng-model=\"$ctrl.getMainVideo().virtualPath\"\n          data-tooltip-append-to-body=\"true\"\n          required>\n        <!--\n            Note - by having an ngModel and the \"required\"\n            directive, the virtualPath property is enrolled in\n            form validation.\n        -->\n        {{$ctrl.getMainVideo().virtualPath | fileNameFromPath}}\n    </span>\n\n    <!-- Asset info -->\n    <a id=\"videoFileInfo\"\n       class=\"fa fa-info-circle fa-2x prism-into-button asset-info-button\"\n       ng-click=\"$ctrl.onViewAssetButtonClick($event)\">\n    </a>\n\n    <qc-note-icon\n        class=\"asset-qc-notes-button\"\n        icon-state=\"$ctrl.getMainVideo().qualityControlNote? \'edit\' : \'add\'\"\n        ng-click=\"$ctrl.onQualityControlButtonClick($event)\">\n    </qc-note-icon>\n\n    <span class=\"asset-errors-and-warnings-indicator\">\n        <!-- Main video has no errors/warnings -->\n        &nbsp;\n    </span>\n\n    <span class=\"horizontal-spacer-10\"></span>\n\n    <div class=\"asset-role-area flex-row-container\">\n        <!--\n            No asset-level language/role selection for main video\n        -->\n    </div>\n\n    <span class=\"horizontal-spacer-10\"></span>\n\n</div>\n");
        $templateCache.put("package/editor/components/view/media/components/videoMetadata/video-metadata-template.html", "<div class=\"edit-view-container\"\n     id=\"mainVideoEditContainer\">\n\n    <!-- Media Status Header -->\n    <package-media-asset-list-header\n        ingest-percent=\"-1\"\n        type=\"\'video metadata\'\">\n    </package-media-asset-list-header>\n\n    <!-- Fields -->\n    <div class=\"row clearfix spacer-top-lg\">\n\n        <!-- Column 1 -->\n        <div class=\"col-md-6 column\">\n\n            <!-- Version -->\n            <div class=\"form-group\">\n                <label for=\"mediaVersionSelect\"\n                       class=\"col-md-4 prism-form-item-label text-align-right\">\n                    Version\n                </label>\n\n                <div class=\"col-sm-5 no-left-padding\">\n                    <dropdown-select\n                        id=\"mediaVersionSelect\"\n                        ng-model=\"$ctrl.getPackageObject().mediaVersion\"\n                        ng-required=\"$ctrl.hasMainVideo()\"\n                        default-select-index=\"0\"\n                        collection=\"$ctrl.availableMediaVersions\"\n                        ng-disabled=\"!$ctrl.hasMainVideo()\">\n                    </dropdown-select>\n                </div>\n            </div>\n\n            <!-- Master Video Kind -->\n            <div class=\"form-group\"\n                 ng-if=\"$ctrl.showMasterVideoKindDD()\">\n                <label for=\"masterVideoKind\"\n                       class=\"col-md-4 prism-form-item-label text-align-right\">\n                    Master Video Kind\n                </label>\n\n                <div class=\"col-sm-8 no-left-padding no-right-padding\">\n                    <dropdown-select\n                        id=\"masterVideoKind\"\n                        ng-model=\"$ctrl.getMainVideo().masterVideoKind\"\n                        ng-required=\"$ctrl.hasMainVideo()\"\n                        prompt=\"Select\"\n                        btn-min-width=\"350\"\n                        collection=\"$ctrl.masterVideoKinds\"\n                        ng-disabled=\"!$ctrl.hasMainVideo()\">\n                    </dropdown-select>\n                </div>\n            </div>\n\n            <!-- Language -->\n            <div class=\"form-group\">\n                <label for=\"languageSelect\"\n                       class=\"col-md-4 prism-form-item-label text-align-right\">\n                    Language\n                </label>\n\n                <div class=\"col-sm-5 no-left-padding\">\n                    <dropdown-select\n                        id=\"languageSelect\"\n                        ng-model=\"$ctrl.getMainVideo().language\"\n                        ng-required=\"$ctrl.hasMainVideo()\"\n                        prompt=\"Spoken Language\"\n                        label-field=\"name\"\n                        collection=\"$ctrl.languages\"\n                        sort-collection=\"false\"\n                        ng-disabled=\"!$ctrl.hasMainVideo()\">\n                    </dropdown-select>\n                </div>\n            </div>\n\n            <!-- Media Revision -->\n            <div class=\"form-group\">\n                <label for=\"revisionValue\"\n                       class=\"col-md-4 prism-form-item-label text-align-right\">\n                    Media Revision\n                </label>\n\n                <div class=\"col-sm-7 no-left-padding no-right-padding\">\n                    <dropdown-select\n                        id=\"revisionValue\"\n                        ng-model=\"$ctrl.getPackageObject().mediaRevision\"\n                        prompt=\"Select Media Revision\"\n                        btn-min-width=\"50\"\n                        clearable=\"true\"\n                        collection=\"$ctrl.availableRevisions\">\n                    </dropdown-select>\n                </div>\n            </div>\n\n        </div>\n\n\n        <!-- Column 2 -->\n        <div class=\"col-md-6 column form-padding\">\n\n            <!-- 4x3 Safe -->\n            <div class=\"form-group\">\n                <label for=\"ratioCheckBox\"\n                       class=\"col-md-4 prism-form-item-label text-align-right\">\n                    4x3Safe\n                </label>\n                <div class=\"col-sm-6 no-left-padding\">\n                    <input\n                        type=\"checkbox\"\n                        id=\"ratioCheckBox\"\n                        ng-model=\"$ctrl.getPackageObject().fourByThreeSafe\"\n                        ng-disabled=\"!$ctrl.hasMainVideo()\"/>\n                    <label for=\"ratioCheckBox\"></label>\n                </div>\n            </div>\n\n            <!-- End Credit Timecode -->\n            <div class=\"form-group\">\n                <label for=\"endTimeCodeInput\"\n                       class=\"col-md-4 prism-form-item-label text-align-right\">\n                    End Credit Timecode\n                </label>\n                <div class=\"col-sm-4 no-left-padding\">\n                    <timecode-input\n                        id=\"endTimeCodeInput\"\n                        ng-model=\"$ctrl.getPackageObject().endCreditTimecode\"\n                        ng-disabled=\"!$ctrl.hasMainVideo()\">\n                    </timecode-input>\n                </div>\n            </div>\n\n            <!-- Recap Ending Timecode -->\n            <div class=\"form-group\">\n                <label for=\"recapEndingTimecode\"\n                       class=\"col-md-4 prism-form-item-label text-align-right\">\n                    Recap Ending Timecode\n                </label>\n                <div class=\"col-sm-4 no-left-padding\">\n                    <timecode-input\n                        disabled\n                        id=\"recapEndingTimecode\"\n                        class=\"auto-width\"\n                        ng-model=\"$ctrl.getMainVideo().recapEndingTimecode\"\n                        ng-disabled=\"!$ctrl.hasMainVideo()\">\n                    </timecode-input>\n                </div>\n                <div class=\"col-sm-4\">\n                    <div class=\"col-sm-5 no-padding auto-width\">\n                        <input type=\"checkbox\"\n                               id=\"recapCleanFlag\"\n                               ng-model=\"$ctrl.getMainVideo().recapEndingTimecodeClean\"\n                               ng-disabled=\"!$ctrl.hasMainVideo()\">\n                        <label for=\"recapCleanFlag\"\n                               class=\"prism-form-item-label\">\n                            Clean\n                        </label>\n                    </div>\n                    <span class=\"fa fa-stack help-icon\"\n                          ng-click=\"$ctrl.onHelpClicked(\'recap\')\">\n                        <i class=\"fa fa-circle fa-stack-2x\"></i>\n                        <i class=\"fa fa-circle-thin fa-stack-2x\"></i>\n                        <i class=\"fa fa-question fa-stack-2x\"></i>\n                    </span>\n                </div>\n            </div>\n\n            <!-- Narrative Burned-in Text -->\n            <div class=\"form-group\">\n                <label class=\"col-md-4 prism-form-item-label text-align-right\">\n                    Narrative Burned-in Text\n                </label>\n                <multiselect-dropdown\n                    class=\"col-md-3 no-left-padding\"\n                    id=\"narrativeText\"\n                    collection=\"$ctrl.languages\"\n                    label-field=\"name\"\n                    btn-min-width=\"150\"\n                    sort-collection=\"false\"\n                    ng-model=\"$ctrl.getMainVideo().narrativeBurnedInText\">\n                </multiselect-dropdown>\n                <span class=\"col-sm-2 fa fa-stack help-icon\"\n                      ng-click=\"$ctrl.onHelpClicked(\'narrativeBurned\')\">\n                    <i class=\"fa fa-circle fa-stack-2x\"></i>\n                    <i class=\"fa fa-circle-thin fa-stack-2x\"></i>\n                    <i class=\"fa fa-question fa-stack-2x\"></i>\n                </span>\n            </div>\n\n            <!-- Burned-in Subtitles -->\n            <div class=\"form-group  no-margin-bottom\">\n                <label for=\"burnedSubtitles\"\n                       class=\"col-md-4 prism-form-item-label text-align-right\">\n                    Burned-in Subtitles\n                </label>\n                <multiselect-dropdown\n                    class=\"col-md-3 no-left-padding\"\n                    id=\"burnedSubtitles\"\n                    collection=\"$ctrl.languages\"\n                    label-field=\"name\"\n                    btn-min-width=\"150\"\n                    sort-collection=\"false\"\n                    ng-model=\"$ctrl.getMainVideo().burnedInSubtitles\">\n                </multiselect-dropdown>\n                <span class=\"col-sm-2 fa fa-stack help-icon\"\n                      ng-click=\"$ctrl.onHelpClicked(\'burnedSub\')\">\n                    <i class=\"fa fa-circle fa-stack-2x\"></i>\n                    <i class=\"fa fa-circle-thin fa-stack-2x\"></i>\n                    <i class=\"fa fa-question fa-stack-2x\"></i>\n                </span>\n            </div>\n\n        </div>\n\n    </div>\n\n    <hr/>\n\n</div>\n");
        $templateCache.put("package/editor/components/view/preview/modals/assetInfoModal/asset-info-modal-template.html", "<div class=\"modal-header\">\n    <h6 class=\"modal-title\">Asset Info</h6>\n</div>\n\n<div class=\"modal-body\">\n    <ng-include src=\"$ctrl.resolve.contentTemplate\"></ng-include>\n</div>\n\n<div class=\"modal-footer flex-row-container\">\n\n    <!-- Download Source Button -->\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.downloadAsset()\"\n            ng-if=\"$ctrl.hasSource()\">\n        Download Source\n    </button>\n\n    <!-- Download Proxy Button -->\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.downloadAsset()\"\n            ng-if=\"$ctrl.hasProxy()\">\n        Download Proxy\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <!-- Cancel Button -->\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.dismiss({$value: \'cancel\'})\">Done\n    </button>\n</div>\n");
        $templateCache.put("package/editor/components/view/preview/renderers/artwork/preview-artwork-info-renderer-template.html", "<div class=\"flex-stretcher flex-col-container flex-align-start asset-info-container\">\n\n    <asset-info-row input-id=\"format\"\n                    label=\"\'File Extension\'\"\n                    value=\"$ctrl.mediaInfo.fileExtension | uppercase\">&nbsp;</asset-info-row>\n    <asset-info-row input-id=\"dimensions\"\n                    label=\"\'Dimensions\'\"\n                    ng-if=\"$ctrl.hasPixels()\"\n                    value=\"$ctrl.mediaInfo.width + \'x\' + $ctrl.mediaInfo.height\">&nbsp;</asset-info-row>\n    <asset-info-row input-id=\"fileSize\"\n                    label=\"\'File Size (bytes)\'\"\n                    value=\"$ctrl.mediaInfo.fileSize | number\">&nbsp;</asset-info-row>\n    <asset-info-row input-id=\"map\"\n                    label=\"\'Artwork MAP\'\"\n                    value=\"$ctrl.resolve.asset.acceptProfile.name\">&nbsp;</asset-info-row>\n    <asset-info-row input-id=\"archiveStatus\"\n                    label=\"\'Storage Class\'\"\n                    value=\"$ctrl.mediaInfo.archiveStatus\">&nbsp;</asset-info-row>\n</div>\n");
        $templateCache.put("package/editor/components/view/preview/renderers/artwork/preview-artwork-renderer-template.html", "<div class=\"edit-view-container preview-image-container\">\n	<package-preview-header media-type=\"ARTWORK\" show-download=\"true\"\n							show-create-proxy=\"false\"></package-preview-header>\n	<div class=\"row clearfix spacer-top-xsm padding-bottom-xsm\">\n		<div class=\"col-sm-12\">\n			<div class=\"row padding-bottom-xsm\">\n				<div class=\"col-sm-12 text-align-center\">\n					<dropdown-select id=\"partnerArtworkSelectDropdown\" ng-model=\"pkgPreviewCtrl.selectedArtworkPartner\" class=\"padding-right-sm\"\n									 label-field=\"partnerName\" prompt=\"Select Partner\" collection=\"pkgPreviewCtrl.currentViewData.partnerArtworks\">\n					</dropdown-select>\n                    <dropdown-select id=\"partnerLanguageSelectDropdown\" ng-model=\"pkgPreviewCtrl.selectedArtworkLanguage\" class=\"padding-right-sm\"\n                                     label-field=\"languageName\" prompt=\"Select Language\" collection=\"pkgPreviewCtrl.selectedArtworkPartner.languagesData\">\n                    </dropdown-select>\n					<dropdown-select id=\"artworkSelectDropdown\" ng-model=\"pkgPreviewCtrl.selectedArtwork\"\n									 label-function=\"pkgPreviewCtrl.getArtworkDropdownLabel\" prompt=\"Select Artwork\" collection=\"pkgPreviewCtrl.selectedArtworkLanguage.assets\">\n					</dropdown-select>\n				</div>\n			</div>\n			<div class=\"row\" ng-show=\"pkgPreviewCtrl.canViewProxy()\">\n				<div class=\"col-sm-12 text-align-center\">\n					<a id=\"{{\'artworkFileInfo\' + pkgArtworkCntrlr.listIndex}}\"\n					   class=\"fa fa-info-circle fa-2x prism-into-button\"\n					   ng-show=\"pkgPreviewCtrl.selectedArtwork\"\n					   ng-click=\"pkgPreviewCtrl.showArtworkInfoModal(pkgPreviewCtrl.selectedArtwork, \'package/editor/components/view/preview/renderers/artwork/preview-artwork-info-renderer-template.html\')\">\n					</a>\n					<img ng-if=\"(pkgPreviewCtrl.selectedArtworkPartner && !pkgPreviewCtrl.selectedArtwork.mediaPath) || !pkgPreviewCtrl.canViewProxy()\" id=\"artworkPreviewNoProxy\" src=\"assets/images/no-proxy.png\" width=\"200\" height=\"136\">\n					<img ng-if=\"pkgPreviewCtrl.selectedArtworkPartner && pkgPreviewCtrl.selectedArtwork.mediaPath && pkgPreviewCtrl.canViewProxy()\" class=\"artwork-preview\" id=\"artworkPreview\" ng-src=\"{{pkgPreviewCtrl.selectedArtwork.mediaPath}}\">\n				</div>\n			</div>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("package/editor/components/view/preview/renderers/audio/preview-audio-info-renderer-template.html", "<div class=\"preview-info-container\">\n	<div class=\"preview-info-inner-container\">\n		<form class=\"form-horizontal\" role=\"form\">\n			<div class=\"form-group no-margin-bottom\">\n				<label for=\"format\" class=\"col-sm-5 control-label lg-txt\">File Type:</label>\n				<div class=\"col-sm-7\">\n					<p class=\"form-control-static\" id=\"format\">{{pkgPreviewCtrl.selectedVideoAudio.mediaInfo.fileExtension | uppercase}}</p>\n				</div>\n			</div>\n			<div class=\"form-group no-margin-bottom\">\n				<label for=\"codec\" class=\"col-sm-5 control-label lg-txt\">Codec:</label>\n				<div class=\"col-sm-7\">\n					<p class=\"form-control-static\" id=\"codec\">{{pkgPreviewCtrl.selectedVideoAudio.mediaInfo.codec}}</p>\n				</div>\n			</div>\n			<div class=\"form-group no-margin-bottom\">\n				<label for=\"audioChannels\" class=\"col-sm-5 control-label lg-txt\">Audio Channels:</label>\n				<div class=\"col-sm-7\">\n					<p class=\"form-control-static\" id=\"audioChannels\">{{pkgPreviewCtrl.selectedVideoAudio.mediaInfo.audioChannelCount}}</p>\n				</div>\n			</div>\n			<div class=\"form-group no-margin-bottom\">\n				<label for=\"audioBitRate\" class=\"col-sm-5 control-label lg-txt\">Bit Rate:</label>\n				<div class=\"col-sm-7\">\n					<p class=\"form-control-static\" id=\"audioBitRate\">{{pkgPreviewCtrl.selectedVideoAudio.mediaInfo.bitRate | bitrate}}</p>\n				</div>\n			</div>\n			<div class=\"form-group no-margin-bottom\">\n				<label for=\"audioDuration\" class=\"col-sm-5 control-label lg-txt\">Duration:</label>\n				<div class=\"col-sm-7\">\n					<p class=\"form-control-static\" id=\"audioDuration\">{{pkgPreviewCtrl.selectedVideoAudio.duration | timecodeFromSec: pkgPreview.selectedVideoAudio.mediaInfo.frameRate}}</p>\n				</div>\n			</div>\n			<div class=\"form-group no-margin-bottom\">\n				<label for=\"fileSize\" class=\"col-sm-5 control-label lg-txt\">File Size:</label>\n				<div class=\"col-sm-7\">\n					<p class=\"form-control-static\" id=\"fileSize\">{{pkgPreviewCtrl.selectedVideoAudio.mediaInfo.fileSize | bytes}}</p>\n				</div>\n			</div>\n			<div class=\"form-group no-margin-bottom\">\n				<label for=\"audioMap\" class=\"col-sm-5 control-label lg-txt\">MAP:</label>\n				<div class=\"col-sm-7\">\n					<p class=\"form-control-static\" id=\"audioMap\">{{pkgPreviewCtrl.selectedVideoAudio.videoMap || pkgPreviewCtrl.mainVideo.videoMap}}</p>\n				</div>\n			</div>\n			<div class=\"form-group no-margin-bottom padding-bottom-lg\">\n				<label for=\"archiveStatus\" class=\"col-sm-5 control-label lg-txt\">Storage Class:</label>\n				<div class=\"col-sm-7\">\n					<p class=\"form-control-static\" id=\"archiveStatus\">{{pkgPreviewCtrl.selectedVideoAudio.mediaInfo.archiveStatus}}</p>\n				</div>\n			</div>\n		</form>\n	</div>\n</div>\n");
        $templateCache.put("package/editor/components/view/preview/renderers/availableElements/preview-elements-renderer-template.html", "<div class=\"edit-view-container\">\n	<package-preview-header media-type=\"AVAILABLE ELEMENTS\"></package-preview-header>\n	<div class=\"row clearfix spacer-top-xsm padding-bottom-sm\">\n		<div class=\"col-sm-12\">\n			<div class=\"row padding-left-sm\">\n				<div class=\"form-group\">\n					<div class=\"col-sm-12\">\n						<div class=\"padding-right-sm auto-width\">\n							<span ng-repeat=\"element in pkgPreviewCtrl.availableElements\" class=\"padding-right-sm\">\n								<div class=\"label label-warning sub component padding-right-sm\" uib-tooltip=\"{{element.partners}}\" data-tooltip-append-to-body=\"true\">\n									{{element.element | uppercase}}\n								</div>\n							</span>\n						</div>\n					</div>\n				</div>\n			</div>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("package/editor/components/view/preview/renderers/image/preview-image-info-render-template.html", "<div class=\"flex-stretcher flex-col-container flex-align-start asset-info-container\">\n\n    <asset-info-row input-id=\"format\"\n                          label=\"\'File Extension\'\"\n                          value=\"$ctrl.mediaInfo.fileExtension | uppercase\">&nbsp;</asset-info-row>\n    <asset-info-row input-id=\"dimensions\"\n                          label=\"\'Dimensions\'\"\n                          ng-if=\"$ctrl.hasPixels()\"\n                          value=\"$ctrl.mediaInfo.width + \'x\' + $ctrl.mediaInfo.height\">&nbsp;</asset-info-row>\n    <asset-info-row input-id=\"fileSize\"\n                          label=\"\'File Size (bytes)\'\"\n                          value=\"$ctrl.mediaInfo.fileSize | number\">&nbsp;</asset-info-row>\n    <asset-info-row input-id=\"map\"\n                          label=\"\'Image MAP\'\"\n                          value=\"$ctrl.resolve.packageContent.map\">&nbsp;</asset-info-row>\n    <asset-info-row input-id=\"archiveStatus\"\n                          label=\"\'Storage Class\'\"\n                          value=\"$ctrl.mediaInfo.archiveStatus\">&nbsp;</asset-info-row>\n</div>\n");
        $templateCache.put("package/editor/components/view/preview/renderers/image/preview-image-renderer-template.html", "<div class=\"edit-view-container preview-image-container\">\n    <package-preview-header media-type=\"IMAGE\"\n                            show-download=\"true\"\n                            show-create-proxy=\"true\"\n                            show-create-snapshot=\"true\"\n                            media-obj=\"pkgPreviewCtrl.selectedImage\">&nbsp;</package-preview-header>\n    <div class=\"flex-col-container clearfix spacer-top-xsm padding-bottom-xsm\">\n        <div class=\"flex-row-container padding-bottom-xsm\">\n            <span class=\"flex-stretcher\">&nbsp;</span>\n            <dropdown-select id=\"imageSelectDropdown\"\n                             class=\"flex-align-center\"\n                             ng-model=\"pkgPreviewCtrl.selectedImage\"\n                             label-field=\"dropdownLabel\"\n                             prompt=\"Select Image MAP\"\n                             collection=\"pkgPreviewCtrl.currentViewData.images\">&nbsp;</dropdown-select>\n            <a id=\"{{\'artworkFileInfo\' + pkgArtworkCntrlr.listIndex}}\"\n               class=\"fa fa-info-circle fa-2x flex-align-center prism-into-button\"\n               ng-if=\"pkgPreviewCtrl.selectedImage\"\n               ng-click=\"pkgPreviewCtrl.showImageInfoModal(pkgPreviewCtrl.selectedImage, \'package/editor/components/view/preview/renderers/image/preview-image-info-render-template.html\')\">\n            </a>\n            <span class=\"flex-stretcher\">&nbsp;</span>\n        </div>\n        <div class=\"flex-col-container\"\n             ng-if=\"pkgPreviewCtrl.canViewProxy()\">\n            <div class=\"text-align-center padding-bottom-sm\">\n                <img id=\"imagePreview\"\n                     ng-class=\"pkgPreviewCtrl.getImageProxyPath() !== \'assets/images/no-proxy.png\'? \'preview-image-present\' : \'preview-image-placeholder\'\"\n                     ng-src=\"{{pkgPreviewCtrl.getImageProxyPath()}}\">\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("package/editor/components/view/preview/renderers/video/preview-video-info-renderer-template.html", "<form class=\"form-horizontal\" role=\"form\">\n	<div class=\"form-group no-margin-bottom\">\n		<label for=\"videoFormat\" class=\"col-sm-5 control-label lg-txt\">File Type:</label>\n		<div class=\"col-sm-7\">\n			<p class=\"form-control-static\" id=\"videoFormat\">{{pkgPreviewCtrl.selectedVideoAudio.mediaInfo.fileExtension | uppercase}}</p>\n		</div>\n	</div>\n	<div class=\"form-group no-margin-bottom\">\n		<label for=\"videoCodec\" class=\"col-sm-5 control-label lg-txt\">Codec:</label>\n		<div class=\"col-sm-7\">\n			<p class=\"form-control-static\" id=\"videoCodec\">{{pkgPreviewCtrl.selectedVideoAudio.mediaInfo.codec}}</p>\n		</div>\n	</div>\n	<div class=\"form-group no-margin-bottom\">\n		<label for=\"videoDimensions\" class=\"col-sm-5 control-label lg-txt\">Dimensions:</label>\n		<div class=\"col-sm-7\">\n			<p class=\"form-control-static\" id=\"videoDimensions\">{{pkgPreviewCtrl.selectedVideoAudio.mediaInfo.width + \'x\' + pkgPreviewCtrl.selectedVideoAudio.mediaInfo.height}}</p>\n		</div>\n	</div>\n	<div class=\"form-group no-margin-bottom\">\n		<label for=\"videoFrameRate\" class=\"col-sm-5 control-label lg-txt\">Frame Rate:</label>\n		<div class=\"col-sm-7\">\n			<p class=\"form-control-static\" id=\"videoFrameRate\">{{pkgPreviewCtrl.selectedVideoAudio.mediaInfo.frameRate}}</p>\n		</div>\n	</div>\n	<div class=\"form-group no-margin-bottom\">\n		<label for=\"audioChannels\" class=\"col-sm-5 control-label lg-txt\">Audio Channels:</label>\n		<div class=\"col-sm-7\">\n			<p class=\"form-control-static\" id=\"audioChannels\">{{pkgPreviewCtrl.selectedVideoAudio.mediaInfo.audioChannelCount}}</p>\n		</div>\n	</div>\n	<div class=\"form-group no-margin-bottom\">\n		<label for=\"videoBitRate\" class=\"col-sm-5 control-label lg-txt\">Bit Rate:</label>\n		<div class=\"col-sm-7\">\n			<p class=\"form-control-static\" id=\"videoBitRate\">{{pkgPreviewCtrl.selectedVideoAudio.mediaInfo.bitRate | bitrate}}</p>\n		</div>\n	</div>\n	<div class=\"form-group no-margin-bottom\">\n		<label for=\"videoDuration\" class=\"col-sm-5 control-label lg-txt\">Duration:</label>\n		<div class=\"col-sm-7\">\n			<p class=\"form-control-static\" id=\"videoDuration\">{{pkgPreviewCtrl.selectedVideoAudio.durationTimecode || (pkgPreviewCtrl.selectedVideoAudio.mediainfo.duration | timecodeFromSec: pkgPreview.selectedVideoAudio.mediaInfo.frameRate)}}</p>\n		</div>\n	</div>\n	<div class=\"form-group no-margin-bottom\">\n		<label for=\"videoFileSize\" class=\"col-sm-5 control-label lg-txt\">File Size:</label>\n		<div class=\"col-sm-7\">\n			<p class=\"form-control-static\" id=\"videoFileSize\">{{pkgPreviewCtrl.selectedVideoAudio.mediaInfo.fileSize | bytes}}</p>\n		</div>\n	</div>\n	<div class=\"form-group no-margin-bottom\">\n		<label for=\"videoMap\" class=\"col-sm-5 control-label lg-txt\">MAP:</label>\n		<div class=\"col-sm-7\">\n			<p class=\"form-control-static\" id=\"videoMap\">{{pkgPreviewCtrl.selectedVideoAudio.videoMap || pkgPreviewCtrl.mainVideo.videoMap}}</p>\n		</div>\n	</div>\n	<div class=\"form-group no-margin-bottom padding-bottom-lg\">\n		<label for=\"videoArchiveStatus\" class=\"col-sm-5 control-label lg-txt\">Storage Class:</label>\n		<div class=\"col-sm-7\">\n			<p class=\"form-control-static\" id=\"videoArchiveStatus\">{{pkgPreviewCtrl.selectedVideoAudio.mediaInfo.archiveStatus}}</p>\n		</div>\n	</div>\n</form>\n");
        $templateCache.put("package/editor/components/view/preview/renderers/video/preview-video-renderer-template.html", "<div class=\"edit-view-container\">\n    <package-preview-header media-type=\"{{pkgPreviewCtrl.selectedVideoAudio.isAudio ? \'AUDIO\' : \'VIDEO\'}}\"\n                            show-download=\"true\"\n                            show-create-proxy=\"true\"\n                            media-obj=\"pkgPreviewCtrl.selectedVideoAudio\"\n                            show-master-video-offset=\"pkgPreviewCtrl.isMasterVideo\">\n    </package-preview-header>\n    <div class=\"row clearfix spacer-top-xsm\"\n         ng-show=\"pkgPreviewCtrl.canViewProxy()\">\n        <div class=\"col-sm-6\">\n            <div class=\"row padding-left-sm\">\n                <div class=\"form-group no-margin-bottom padding-bottom-xsm\">\n                    <div class=\"col-sm-6 metadata-control-col\">\n                        <dropdown-select id=\"partnerSelectDropdown\"\n                                         ng-model=\"pkgPreviewCtrl.selectedPartner\"\n                                         clearable=\"true\"\n                                         prompt=\"Select Partner\"\n                                         label-field=\"partner\"\n                                         collection=\"pkgPreviewCtrl.currentViewData.partners\">\n                        </dropdown-select>\n                    </div>\n                    <div class=\"col-sm-6 metadata-control-col\">\n                        <dropdown-select\n                                id=\"videosDropdown\"\n                                ng-model=\"pkgPreviewCtrl.selectedVideoAudio\"\n                                ng-change=\"pkgPreviewCtrl.videoAudioRoleChange()\"\n                                label-field=\"dropdownLabel\"\n                                collection=\"pkgPreviewCtrl.currentViewData.videosAudios\">\n                        </dropdown-select>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row padding-left-sm\">\n                <img ng-if=\"!pkgPreviewCtrl.selectedVideoAudio.mediaPath\"\n                     src=\"assets/images/no-proxy.png\"/>\n                <proxy-player ng-if=\"pkgPreviewCtrl.selectedVideoAudio.mediaPath\"\n                              media=\"pkgPreviewCtrl.selectedVideoAudio\"\n                              is-audio=\"pkgPreviewCtrl.selectedVideoAudio.isAudio\"\n                              cc-subtitle=\"pkgPreviewCtrl.selectedCCSub\"\n                              cue-points=\"pkgPreviewCtrl.cuePoints\"\n                              offset=\"pkgPreviewCtrl.previewPlayerOffset\"\n                              framerate=\"pkgPreviewCtrl.mainVideoMediaInfoFramerate\">&nbsp;</proxy-player>\n            </div>\n            <div class=\"row padding-left-sm\"\n                 ng-show=\"!(pkgPreviewCtrl.selectedVideoAudio.isAudio || pkgPreviewCtrl.selectedVideoAudio.prePostRollId)\">\n                <div class=\"form-group\">\n                    <label for=\"ccSubSelecter\"\n                           class=\"col-sm-3 auto-width control-label\">CC/Subtitle</label>\n                    <div class=\"col-sm-9 metadata-control-col\">\n                        <dropdown-select id=\"ccSubSelectDropdown\"\n                                         ng-model=\"pkgPreviewCtrl.selectedCCSub\"\n                                         label-field=\"dropdownLabel\"\n                                         prompt=\"Select CC/SUB\"\n                                         collection=\"pkgPreviewCtrl.currentViewData.ccSubtitles\">\n                        </dropdown-select>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <!--Audio visualizor placeholder-->\n        <div class=\"col-sm-1\"></div>\n        <div class=\"col-sm-5\">\n            <div ng-switch=\"pkgPreviewCtrl.selectedVideoAudio.isAudio\">\n                <div ng-switch-when=\"true\">\n                    <ng-include src=\"\'package/editor/components/view/preview/renderers/audio/preview-audio-info-renderer-template.html\'\">&nbsp;</ng-include>\n                </div>\n                <div ng-switch-default>\n                    <ng-include src=\"\'package/editor/components/view/preview/renderers/video/video-tabs-renderer-template.html\'\">&nbsp;</ng-include>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("package/editor/components/view/preview/renderers/video/video-tabs-renderer-template.html", "<div class=\"preview-info-container\">\n	<div class=\"preview-info-inner-container\">\n		<uib-tabset horizontal=\"true\" type=\"pills\" class=\"video-preview-tabs\" active=\"pkgPreviewCtrl.currentViewedTab\">\n			<uib-tab heading=\"Details\" index=\"\'details\'\"\n					 ng-show=\"pkgPreviewCtrl.showVideoTab(\'details\')\">\n				<ng-include ng-if=\"pkgPreviewCtrl.currentViewedTab === \'details\'\"\n							src=\"\'package/editor/components/view/preview/renderers/video/preview-video-info-renderer-template.html\'\"></ng-include>\n			</uib-tab>\n			<uib-tab heading=\"Markers\" index=\"\'markers\'\"\n					 ng-show=\"pkgPreviewCtrl.showVideoTab(\'markers\')\">\n				<form class=\"form-horizontal\" role=\"form\" ng-if=\"pkgPreviewCtrl.currentViewedTab === \'markers\'\">\n					<div class=\"form-group\">\n						<prism-list items=\"pkgPreviewCtrl.markerTimecodesArray\" label-field=\"displayTimecode\" model-prop=\"chapterPlusOneFrameInSeconds\"\n								  ng-model=\"pkgPreviewCtrl.selectedVideoAudio.selectedMarker\"></prism-list>\n					</div>\n				</form>\n			</uib-tab>\n			<uib-tab heading=\"Adpods\" index=\"\'adpods\'\"\n					 ng-show=\"pkgPreviewCtrl.showVideoTab(\'adpods\')\">\n				<div class=\"row\" ng-if=\"pkgPreviewCtrl.currentViewedTab === \'adpods\'\">\n					<div class=\"col-sm-12\">\n						<div ui-grid=\"pkgPreviewCtrl.adpodGrid\" class=\"preview-grid\"\n							 id=\"previewAdpodsGrid\" ui-grid-cellNav></div>\n					</div>\n				</div>\n			</uib-tab>\n			<uib-tab heading=\"Captions\" disable=\"false\" index=\"\'captions\'\">\n				<div class=\"row\" ng-if=\"pkgPreviewCtrl.currentViewedTab === \'captions\'\">\n					<div class=\"col-sm-12\">\n						<form class=\"form\" role=\"search\" ></form>\n\n					</div>\n				</div>\n			</uib-tab>\n			<uib-tab heading=\"Components\" disable=\"false\" index=\"\'components\'\"\n					 ng-show=\"pkgPreviewCtrl.showVideoTab(\'components\')\">\n				<div class=\"row\" ng-if=\"pkgPreviewCtrl.currentViewedTab === \'components\'\">\n					<div class=\"col-sm-12\">\n						<div ui-grid=\"pkgPreviewCtrl.componentsGrid\" class=\"preview-grid\"\n							 id=\"previewCaptionsGrid\" ui-grid-cellNav>\n						</div>\n					</div>\n				</div>\n			</uib-tab>\n		</uib-tabset>\n	</div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/audioMappingRules/cellTemplates/language-cell-template.html", "<div class=\"ui-grid-cell-contents\">\n    <dropdown-select id=\"audioMappingRules{{$index}}language\"\n                     attach-to-body=\"true\"\n                     ng-model=\"row.entity.language\"\n                     ng-change=\"grid.appScope.$ctrl.checkColumnsValidity()\"\n                     collection=\"grid.appScope.$ctrl.availableLanguages\"\n                     label-field=\"name\"\n                     clearable=\"false\"\n                     btn-min-width=\"200\"\n                     max-height=\"200\"\n                     prompt=\"Select Language\"\n                     required>\n    </dropdown-select>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/audioMappingRules/cellTemplates/role-cell-template.html", "<div class=\"ui-grid-cell-contents\">\n    <dropdown-select id=\"audioMappingRules{{$index}}role\"\n                     attach-to-body=\"true\"\n                     ng-model=\"row.entity.role\"\n                     ng-change=\"grid.appScope.$ctrl.checkColumnsValidity()\"\n                     collection=\"grid.appScope.$ctrl.availableRoles\"\n                     label-field=\"name\"\n                     clearable=\"false\"\n                     btn-min-width=\"200\"\n                     max-height=\"200\"\n                     prompt=\"Select Role\"\n                     required>\n    </dropdown-select>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/audioMappingRules/cellTemplates/validated-inline-edit-cell-template.html", "<div class=\"ui-grid-cell-contents\"\n     ng-class=\"{\'ui-grid-cell-edited\': row.entity.edited, \'ui-grid-cell-error\': !col.colDef.isFieldValid(COL_FIELD)}\"\n     data-tooltip-append-to-body=\"true\"\n     uib-tooltip=\"{{COL_FIELD CUSTOM_FILTERS}}\">\n\n    <span class=\"padding-left-sm\">{{COL_FIELD CUSTOM_FILTERS}}</span>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryEndpoints/editor/partner-delivery-endpoints-editor-template.html", "<div>\n	<div class=\"container-fluid no-padding\">\n		<div class=\"row-no-padding\">\n			<navbar></navbar>\n		</div>\n\n		<div class=\"row-no-padding\">\n			<sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n			<div class=\"col-md-10 col-lg-10 content-pane\">\n\n				<div class=\"loadingIndicator\">\n					<div data-lb-progress=\"$ctrl.loadingIndicator\"\n						 ng-show=\"$ctrl.loadingIndicator.show\">\n					</div>\n				</div>\n\n				<div class=\"row\">\n					<div class=\"col-md-12\">\n						<breadcrumb tab-name=\"$ctrl.breadcrumbName\"></breadcrumb>\n\n						<fieldset ng-disabled=\"!$ctrl.canWrite\">\n							<div class=\"edit-full-height-no-tabs edit-view\">\n								<form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n									<!-- General Section -->\n									<div class=\"edit-view-container\">\n										<div ng-include=\"\'system/partner/editor/components/view/deliveryEndpoints/editor/renderers/partner-deliveryendpoints-editor-general-section-template.html\'\"></div>\n									</div>\n\n									<hr />\n\n									<!-- Type-specific Editor Sections -->\n									<div class=\"edit-view-container\">\n                                        <div\n                                                ng-if=\"$ctrl.endpointType === \'applenews\'\"\n                                                ng-include=\"\'system/partner/editor/components/view/deliveryEndpoints/editor/renderers/partner-deliveryendpoints-editor-apple-news-template.html\'\">\n                                        </div>\n\n                                        <div\n                                            ng-if=\"$ctrl.endpointType === \'aspera\'\"\n                                            ng-include=\"\'system/partner/editor/components/view/deliveryEndpoints/editor/renderers/partner-deliveryendpoints-editor-aspera-template.html\'\">\n                                        </div>\n\n                                        <div\n                                            ng-if=\"$ctrl.endpointType === \'aspera_cli\'\"\n                                            ng-include=\"\'system/partner/editor/components/view/deliveryEndpoints/editor/renderers/partner-deliveryendpoints-editor-aspera-cli-template.html\'\">\n                                        </div>\n\n                                        <div\n                                            ng-if=\"$ctrl.endpointType === \'aspera_key\'\"\n                                            ng-include=\"\'system/partner/editor/components/view/deliveryEndpoints/editor/renderers/partner-deliveryendpoints-editor-aspera-template.html\'\">\n                                        </div>\n\n                                        <div\n                                            ng-if=\"$ctrl.endpointType === \'ftp\'\"\n                                            ng-include=\"\'system/partner/editor/components/view/deliveryEndpoints/editor/renderers/partner-deliveryendpoints-editor-ftp-template.html\'\">\n                                        </div>\n\n                                        <div\n											ng-if=\"$ctrl.endpointType === \'gs\'\"\n											ng-include=\"\'system/partner/editor/components/view/deliveryEndpoints/editor/renderers/partner-deliveryendpoints-editor-gs-template.html\'\">\n										</div>\n\n										<div\n											ng-if=\"$ctrl.endpointType === \'itunes\'\"\n											ng-include=\"\'system/partner/editor/components/view/deliveryEndpoints/editor/renderers/partner-deliveryendpoints-editor-itunes-template.html\'\">\n										</div>\n\n										<div\n											ng-if=\"$ctrl.endpointType === \'ivi\'\"\n											ng-include=\"\'system/partner/editor/components/view/deliveryEndpoints/editor/renderers/partner-deliveryendpoints-editor-ivi-template.html\'\">\n										</div>\n\n										<div\n											ng-if=\"$ctrl.endpointType === \'netflix\'\"\n											ng-include=\"\'system/partner/editor/components/view/deliveryEndpoints/editor/renderers/partner-deliveryendpoints-editor-aspera-template.html\'\">\n										</div>\n\n										<div\n											ng-if=\"$ctrl.endpointType === \'network\'\"\n											ng-include=\"\'system/partner/editor/components/view/deliveryEndpoints/editor/renderers/partner-deliveryendpoints-editor-network-template.html\'\">\n										</div>\n\n                                        <div\n                                            ng-if=\"$ctrl.endpointType === \'s3\'\"\n                                            ng-include=\"\'system/partner/editor/components/view/deliveryEndpoints/editor/renderers/partner-deliveryendpoints-editor-s3-template.html\'\">\n                                        </div>\n\n                                        <div\n                                            ng-if=\"$ctrl.endpointType === \'sftp\'\"\n                                            ng-include=\"\'system/partner/editor/components/view/deliveryEndpoints/editor/renderers/partner-deliveryendpoints-editor-sftp-template.html\'\">\n                                        </div>\n\n                                        <div\n                                            ng-if=\"$ctrl.endpointType === \'uplynk\'\"\n                                            ng-include=\"\'system/partner/editor/components/view/deliveryEndpoints/editor/renderers/partner-deliveryendpoints-editor-uplynk-template.html\'\">\n                                        </div>\n\n                                        <div\n                                            ng-if=\"$ctrl.endpointType === \'vantage\'\"\n                                            ng-include=\"\'system/partner/editor/components/view/deliveryEndpoints/editor/renderers/partner-deliveryendpoints-editor-vantage-template.html\'\">\n                                        </div>\n									</div>\n\n								</form>\n							</div>\n						</fieldset>\n					</div>\n				</div>\n\n				<div class=\"row-no-padding manager-toolbar\">\n					<div>\n						<toolbar button-defs=\"$ctrl.toolbarButtonDefs\">\n						</toolbar>\n					</div>\n				</div>\n\n			</div>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryEndpoints/searchView/partner-delivery-endpoints-searchview-template.html", "<div id=\"partnerDeliveryEndpoints\" class=\"row-no-padding\">\n\n	<!-- Pacifier -->\n	<div class=\"loadingIndicator\">\n		<div data-lb-progress=\"$ctrl.loadingIndicator\"\n			 ng-show=\"$ctrl.loadingIndicator.show\">\n		</div>\n	</div>\n\n\n	<!-- Grid -->\n	<div id=\"partnerDeliveryEndpointsSearchViewGrid\"\n		 class=\"breadcrumb-tab-edit-search-grid grid search-grid\"\n		 ui-grid=\"$ctrl.gridOptions\"\n		 ui-grid-selection\n		 ui-grid-pagination\n		 ui-grid-resize-columns>\n	</div>\n\n	<!-- Toolbar -->\n	<toolbar\n		button-defs=\"$ctrl.toolbarButtonDefs\"\n		right-hand-checkbox-defs=\"$ctrl.checkboxDefs\">\n	</toolbar>\n\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryProfiles/editor/delivery-profiles-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <div class=\"row-no-padding\">\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n            <breadcrumb tab-name=\"\'Delivery Profiles\'\"></breadcrumb>\n            <uib-tabset horizontal=\"true\"\n                        type=\"pills\"\n                        class=\"edit-view-tabbar\"\n                        active=\"$ctrl.currentTab\">\n                <uib-tab heading=\"Properties\" index=\"\'properties\'\"\n                         select=\"$ctrl.onTabSelect(\'properties\')\"\n                         ng-show=\"$ctrl.enabledTabs.properties\"\n                         deselect=\"$ctrl.onTabDeselect(\'properties\', $event)\">\n                    <delivery-profiles-properties-edit-view\n                            ng-if=\"$ctrl.currentTab === \'properties\'\">\n                    </delivery-profiles-properties-edit-view>\n                </uib-tab>\n                <uib-tab heading=\"Delivery Emails\" index=\"\'emails\'\"\n                         select=\"$ctrl.onTabSelect(\'emails\')\"\n                         ng-show=\"$ctrl.enabledTabs.emails\"\n                         deselect=\"$ctrl.onTabDeselect(\'emails\', $event)\">\n                    <delivery-profiles-emails-search-view\n                            ng-if=\"$ctrl.currentTab === \'emails\'\">\n                    </delivery-profiles-emails-search-view>\n                </uib-tab>\n                <uib-tab heading=\"Delivery Items\" index=\"\'deliveryItems\'\"\n                         select=\"$ctrl.onTabSelect(\'deliveryItems\')\"\n                         ng-show=\"$ctrl.enabledTabs.deliveryItems\"\n                         deselect=\"$ctrl.onTabDeselect(\'deliveryItems\', $event)\">\n                    <delivery-profiles-delivery-items-search-view\n                            ng-if=\"$ctrl.currentTab === \'deliveryItems\'\">\n                    </delivery-profiles-delivery-items-search-view>\n                </uib-tab>\n            </uib-tabset>\n        </div>\n    </div>\n</div>\n<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\">\n    </div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryProfiles/searchView/partner-delivery-profiles-searchview-template.html", "<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\">\n    </div>\n</div>\n\n<div id=\"deliveryProfilePackageAcceptTemplatesGrid\"\n     class=\"grid search-grid\"\n     ui-grid=\"$ctrl.gridOptions\"\n     ui-grid-selection\n     ui-grid-resize-columns>\n</div>\n\n<!-- Toolbar -->\n<div class=\"row-no-padding manager-toolbar\">\n    <div class=\"row-no-padding manager-toolbar\">\n        <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"></toolbar>\n    </div>\n</div>\n\n");
        $templateCache.put("system/partner/editor/components/view/dueDateTemplates/editor/partner-due-date-templates-editor-template.html", "<div>\n    <div class=\"container-fluid no-padding\">\n        <!-- Navbar -->\n        <div class=\"row-no-padding\">\n            <navbar></navbar>\n        </div>\n\n        <div class=\"row-no-padding\">\n            <!-- Sidebar -->\n            <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n            <!-- Permission block -->\n            <div class=\"row read-only-msg\"\n                 ng-if=\"!$ctrl.canRead\">\n                <p class=\"text-center\">\n                    <i class=\"fa fa-lock\"></i>\n                    Your permissions do not allow you to view this content.\n                </p>\n            </div>\n\n            <!-- Content -->\n            <div ng-if=\"$ctrl.canRead\"\n                 class=\"col-md-10 col-lg-10 content-pane\">\n\n                <!-- Pacifier -->\n                <div class=\"loadingIndicator\">\n                    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                         ng-show=\"$ctrl.loadingIndicator.show\">\n                    </div>\n                </div>\n\n                <div class=\"row\">\n                    <div class=\"col-md-12\">\n                        <breadcrumb tab-name=\"$ctrl.breadcrumbName\"></breadcrumb>\n\n                        <fieldset ng-disabled=\"!$ctrl.canWrite\">\n                            <div class=\"edit-full-height-no-tabs edit-view\">\n								<span ng-if=\"$ctrl.canRead && !$ctrl.canWrite\"\n                                      class=\"read-only-msg\">\n									<i class=\"fa fa-lock\"></i>\n									Your permissions do not allow you to edit this content.\n								</span>\n\n                                <form class=\"form-horizontal\"\n                                      role=\"form\"\n                                      name=\"$ctrl.editorForm\">\n\n                                    <!-- General Section -->\n                                    <div class=\"edit-view-container\">\n                                        <div ng-include=\"\'system/partner/editor/components/view/dueDateTemplates/editor/renderers/partner-due-date-templates-editor-general-section-template.html\'\"></div>\n                                    </div>\n\n                                    <hr/>\n\n                                    <!-- Email Section -->\n                                    <div class=\"edit-view-container\">\n                                        <div ng-include=\"\'system/partner/editor/components/view/dueDateTemplates/editor/renderers/partner-due-date-templates-editor-email-section-template.html\'\"></div>\n                                    </div>\n\n                                </form>\n                            </div>\n                        </fieldset>\n                    </div>\n                </div>\n\n                <!-- Toolbar -->\n                <div class=\"row-no-padding manager-toolbar\">\n                    <div>\n                        <toolbar button-defs=\"$ctrl.toolbarButtonDefs\">\n                        </toolbar>\n                    </div>\n                </div>\n\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/dueDateTemplates/searchView/partner-due-date-templates-searchview-template.html", "<div id=\"partnerDueDateTemplates\" class=\"row-no-padding\">\n\n    <!-- Pacifier -->\n    <div class=\"loadingIndicator\">\n        <div data-lb-progress=\"$ctrl.loadingIndicator\"\n             ng-show=\"$ctrl.loadingIndicator.show\">\n        </div>\n    </div>\n\n    <!-- Grid -->\n    <div id=\"partnerDueDateTemplatesSearchGrid\"\n         class=\"grid search-grid\"\n         ui-grid=\"$ctrl.gridOptions\"\n         ui-grid-selection>\n    </div>\n\n    <!-- Toolbar -->\n    <toolbar\n        button-defs=\"$ctrl.toolbarButtonDefs\"\n        right-hand-checkbox-defs=\"$ctrl.toolbarCheckboxDefs\"\n        pagination-defs=\"$ctrl.paginationDefs\">\n    </toolbar>\n\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/emailEndpoints/editor/partner-email-endpoints-editor-template.html", "<div>\n	<div class=\"container-fluid no-padding\">\n		<!-- Navbar -->\n		<div class=\"row-no-padding\">\n			<navbar></navbar>\n		</div>\n\n		<div class=\"row-no-padding\">\n			<!-- Sidebar -->\n			<sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n			<!-- Permission block -->\n			<div class=\"row read-only-msg\"\n				 ng-if=\"!$ctrl.canRead\">\n				<p class=\"text-center\">\n					<i class=\"fa fa-lock\"></i>\n					Your permissions do not allow you to view this content.\n				</p>\n			</div>\n\n			<!-- Content -->\n			<div ng-if=\"$ctrl.canRead\"\n				 class=\"col-md-10 col-lg-10 content-pane\">\n\n				<!-- Pacifier -->\n				<div class=\"loadingIndicator\">\n					<div data-lb-progress=\"$ctrl.loadingIndicator\"\n						 ng-show=\"$ctrl.loadingIndicator.show\">\n					</div>\n				</div>\n\n				<div class=\"row\">\n					<div class=\"col-md-12\">\n						<breadcrumb tab-name=\"$ctrl.breadcrumbName\"></breadcrumb>\n\n						<fieldset ng-disabled=\"!$ctrl.canWrite\">\n							<div class=\"edit-full-height-no-tabs edit-view\">\n								<span ng-if=\"$ctrl.canRead && !$ctrl.canWrite\"\n									  class=\"read-only-msg\">\n									<i class=\"fa fa-lock\"></i>\n									Your permissions do not allow you to edit this content.\n								</span>\n\n								<form class=\"form-horizontal\"\n									  role=\"form\"\n									  name=\"$ctrl.editorForm\">\n\n									<!-- General Section -->\n									<div class=\"edit-view-container\">\n										<div ng-include=\"\'system/partner/editor/components/view/emailEndpoints/editor/renderers/partner-emailendpoints-editor-general-section-template.html\'\"></div>\n									</div>\n\n								</form>\n							</div>\n						</fieldset>\n					</div>\n				</div>\n\n				<!-- Toolbar -->\n				<div class=\"row-no-padding manager-toolbar\">\n					<div>\n						<toolbar button-defs=\"$ctrl.toolbarButtonDefs\">\n						</toolbar>\n					</div>\n				</div>\n\n			</div>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/emailEndpoints/searchView/partner-email-endpoints-searchview-template.html", "<div id=\"partnerEmailEndpoints\"\n	 class=\"row-no-padding\">\n\n	<!-- Pacifier -->\n	<div class=\"loadingIndicator\">\n		<div data-lb-progress=\"$ctrl.loadingIndicator\"\n			 ng-show=\"$ctrl.loadingIndicator.show\">\n		</div>\n	</div>\n\n\n	<!-- Grid -->\n	<div id=\"partnerEmailEndpointsSearchViewGrid\"\n		 class=\"email-endpoints-search-grid grid search-grid\"\n		 ui-grid=\"$ctrl.gridOptions\"\n		 ui-grid-selection\n		 ui-grid-pagination\n		 ui-grid-resize-columns>\n	</div>\n\n	<!-- Toolbar -->\n	<toolbar\n		button-defs=\"$ctrl.toolbarButtonDefs\"\n		right-hand-checkbox-defs=\"$ctrl.toolbarCheckboxDefs\">\n	</toolbar>\n\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/nielsenTemplates/editor/nielsen-templates-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <div class=\"row-no-padding\">\n\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n            <div class=\"loadingIndicator\">\n                <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                     ng-show=\"$ctrl.loadingIndicator.show\">\n                </div>\n            </div>\n            <breadcrumb tab-name=\"$ctrl.editData.name\"></breadcrumb>\n            <fieldset>\n                <div class=\"edit-full-height edit-view\">\n                    <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n                        <div class=\"edit-view-container\">\n                            <div class=\"col-md-12 column\">\n                                <div class=\"row\">\n                                    <div class=\"col-md-2\">\n                                        <div class=\"prism-form-heading\">General</div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"row clearfix\">\n                                <div class=\"row clearfix spacer-top-lg\">\n                                    <div class=\"col-md-12 column\">\n                                        <div class=\"row-no-padding\">\n                                            <form role=\"form\" class=\"form-horizontal\">\n                                                <div class=\"form-group\">\n                                                    <label class=\"control-label col-md-2\">Name</label>\n                                                    <div class=\"col-sm-4 pad-text-input-col\">\n                                                        <input type=\"text\" class=\"prism-text-input\"\n                                                               ng-model=\"$ctrl.editData.name\"\n                                                               id=\"nameInput\"/>\n                                                    </div>\n                                                    <div class=\"required-text-input\" required\n                                                         x-required-indicator></div>\n                                                </div>\n                                                <div class=\"form-group\">\n                                                    <label class=\"control-label col-md-2\">Asset ID</label>\n                                                    <div class=\"col-sm-4 pad-text-input-col\">\n                                                        <input type=\"text\" class=\"prism-text-input\"\n                                                               ng-model=\"$ctrl.editData.data.nielsenAssetId\"\n                                                               id=\"assetIdInput\"/>\n                                                    </div>\n                                                </div>\n                                                <div class=\"form-group\">\n                                                    <label class=\"control-label col-md-2\">Asset Name</label>\n                                                    <div class=\"col-sm-4 pad-text-input-col\">\n                                                        <input type=\"text\" class=\"prism-text-input\"\n                                                               ng-model=\"$ctrl.editData.data.nielsenAssetName\"\n                                                               id=\"assetNameInput\"/>\n                                                    </div>\n                                                </div>\n                                            </form>\n                                            <div class=\"form-group\">\n                                                <label class=\"control-label col-md-2\">DSRC ID</label>\n                                                <div class=\"col-sm-4 pad-text-input-col\">\n                                                    <input type=\"text\" class=\"prism-text-input\"\n                                                           ng-model=\"$ctrl.editData.data.nielsenDsrcId\"\n                                                           id=\"dsrcIdInput\"/>\n                                                </div>\n                                            </div>\n                                            <div class=\"form-group\">\n                                                <label class=\"control-label col-md-2\">Episode ID</label>\n                                                <div class=\"col-sm-4 pad-text-input-col\">\n                                                    <input type=\"text\" class=\"prism-text-input\"\n                                                           ng-model=\"$ctrl.editData.data.nielsenEpisodeId\"\n                                                           id=\"episodeIdInput\"/>\n                                                </div>\n                                            </div>\n                                            <div class=\"form-group\">\n                                                <label class=\"control-label col-md-2\">SID</label>\n                                                <div class=\"col-sm-4 pad-text-input-col\">\n                                                    <input type=\"text\" class=\"prism-text-input\"\n                                                           ng-model=\"$ctrl.editData.data.nielsenSId\"\n                                                           id=\"sIdInput\"/>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </fieldset>\n            <div class=\"row-no-padding manager-toolbar\">\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\" pagination-defs=\"$ctrl.paginationDefs\"></toolbar>\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/nielsenTemplates/searchView/nielsen-templates-searchview-template.html", "<div id=\"nielsenTemplatesTemplates\" class=\"row-no-padding\">\n    <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n\n        <!-- Pacifier -->\n        <div class=\"loadingIndicator\">\n            <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                 ng-show=\"$ctrl.loadingIndicator.show\">\n            </div>\n        </div>\n\n        <!-- Grid -->\n        <div id=\"nielsenTemplatesTemplatesSearchGrid\"\n             class=\"grid search-grid\"\n             ui-grid=\"$ctrl.gridOptions\"\n             ui-grid-selection>\n        </div>\n\n        <!-- Toolbar -->\n        <toolbar\n                button-defs=\"$ctrl.toolbarButtonDefs\"\n                right-hand-checkbox-defs=\"$ctrl.toolbarCheckboxDefs\"\n                pagination-defs=\"$ctrl.paginationDefs\">\n        </toolbar>\n    </form>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/planner/editor/partner-planner-editor-template.html", "<div>\n	<div class=\"container-fluid no-padding\">\n		<div class=\"row-no-padding\">\n			<navbar></navbar>\n		</div>\n		<div class=\"row-no-padding\">\n			<sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n			<div class=\"col-md-10 col-lg-10 content-pane\">\n				<div class=\"loadingIndicator\">\n					<div data-lb-progress=\"$ctrl.loadingIndicator\"\n						 ng-show=\"$ctrl.loadingIndicator.show\">\n					</div>\n				</div>\n\n				<div class=\"row\">\n					<div class=\"col-md-12\">\n						<breadcrumb tab-name=\"$ctrl.breadcrumbName\"></breadcrumb>\n						<fieldset>\n							<div class=\"edit-full-height-no-tabs edit-view\">\n								<form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n									<div class=\"edit-view-container\">\n										<div ng-include=\"\'system/partner/editor/components/view/planner/editor/renderers/partner-planner-general-section-template.html\'\"></div>\n									</div>\n									<hr />\n									<div class=\"edit-view-container\">\n										<div ng-include=\"\'system/partner/editor/components/view/planner/editor/renderers/partner-planner-schedule-section-template.html\'\"></div>\n									</div>\n									<hr />\n									<div class=\"edit-view-container\">\n										<div ng-include=\"\'system/partner/editor/components/view/planner/editor/renderers/partner-planner-delivery-section-template.html\'\"></div>\n									</div>\n								</form>\n							</div>\n						</fieldset>\n					</div>\n				</div>\n\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"></toolbar>\n\n                <!--\n				<div class=\"row-no-padding manager-toolbar\">\n					<div>\n						<basiceditor-toolbar edit-service=\"$ctrl.editService\"\n											 save-handler=\"$ctrl.onSave()\"\n											 revert-handler=\"$ctrl.onRevert()\"\n											 close-handler=\"$ctrl.onClose()\">\n						</basiceditor-toolbar>\n					</div>\n				</div>\n				-->\n			</div>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/planner/searchView/partner-planner-searchview-template.html", "<div id=\"partnerPlanner\" class=\"row-no-padding\">\n\n	<!-- Pacifier -->\n	<div class=\"loadingIndicator\">\n		<div data-lb-progress=\"$ctrl.loadingIndicator\"\n			 ng-show=\"$ctrl.loadingIndicator.show\">\n		</div>\n	</div>\n\n\n	<!-- Grid -->\n	<div id=\"partnerPlannerGrid\"\n		 class=\"breadcrumb-tab-edit-search-grid grid search-grid\"\n		 ui-grid=\"$ctrl.gridOptions\"\n		 ui-grid-selection\n		 ui-grid-pagination\n		 ui-grid-resize-columns>\n	</div>\n\n	<!-- Toolbar -->\n	<toolbar\n		button-defs=\"$ctrl.toolbarButtonDefs\">\n	</toolbar>\n\n</div>\n");
        $templateCache.put("system/templates/mediaAcceptProfiles/components/validators/artwork/searchView/media-accept-profiles-artwork-validators-search-view-template.html", "<div class=\"edit-full-height\">\n\n        <div id=\"grid\"\n             class=\"grid search-grid\"\n             ui-grid=\"$ctrl.gridOptions\"\n             ui-grid-selection\n             ui-grid-resize-columns>\n        </div>\n\n    <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"\n             right-hand-checkbox-defs=\"$ctrl.toolbarCheckboxDefs\">\n    </toolbar>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/subscriptions/modal/partner-subscription-filter-template.html", "<div class=\"modal-header\">\n    <a id=\"partnerSubFilterXBtn\"\n       href=\"\"\n       ng-click=\"pmFilterModal.xClicked()\"><i class=\"fa fa-times pull-right\"></i></a>\n    <h5 align=\"center\"\n        class=\"modal-title\">Search Filters</h5>\n</div>\n<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"pmPackagePropertiesCtrl.loadingIndicator\"\n         ng-show=\"pmPackagePropertiesCtrl.loadingIndicator.show\">\n    </div>\n</div>\n<div class=\"modal-body\">\n    <form class=\"form-horizontal\"\n          role=\"form\">\n        <div class=\"edit-view-container\">\n            <div class=\"row clearfix\"\n                 ng-controller=\"PackagePropertiesFilterSectionController as pmPackagePropertiesCtrl\">\n                <div class=\"loadingIndicator\">\n                    <div data-lb-progress=\"PackagePropertiesFilterSectionController.loadingIndicator\"\n                         ng-show=\"PackagePropertiesFilterSectionController.loadingIndicator.show\"></div>\n                </div>\n                <div class=\"col-md-12 column\">\n                    <div class=\"row\">\n                        <div class=\"col-md-12\">\n                            <div class=\"prism-form-heading padding-left-md\">Partner Subscription Properties</div>\n                        </div>\n                    </div>\n                    <div class=\"row spacer-top-xsm padding-bottom-xsm\">\n                        <div class=\"col-md-6\">\n                            <div class=\"form-group no-margin-bottom\">\n                                <label for=\"partnerSubContentType\"\n                                       class=\"col-md-4 control-label\">Content Type</label>\n                                <div class=\"col-md-8 metadata-control-col\">\n                                    <dropdown-select id=\"partnerSubContentType\"\n                                                     ng-model=\"pmPackagePropertiesCtrl.searchCriteria.contentType\"\n                                                     prompt=\"Select Type\"\n                                                     clearable=\"true\"\n                                                     collection=\"pmPackagePropertiesCtrl.available.contentTypes\"\n                                                     btn-min-width=\"200\">\n                                    </dropdown-select>\n                                </div>\n                            </div>\n                            <div ng-show=\"pmPackagePropertiesCtrl.searchCriteria.contentType && pmPackagePropertiesCtrl.searchCriteria.contentType !== \'Ad/Preroll\'\">\n                                <div class=\"form-group no-margin-bottom\">\n                                    <label for=\"partnerSubNetwork\"\n                                           class=\"col-sm-4 control-label\">Networks</label>\n                                    <div class=\"col-sm-8 metadata-control-col\">\n                                        <multiselect-dropdown id=\"partnerSubNetwork\"\n                                                              prompt=\"Select Network\"\n                                                              ng-model=\"pmPackagePropertiesCtrl.searchCriteria.networks\"\n                                                              clearable=\"true\"\n                                                              btn-min-width=\"200\"\n                                                              btn-max-width=\"300\"\n                                                              model-prop=\"id\"\n                                                              label-field=\"name\"\n                                                              collection=\"pmPackagePropertiesCtrl.available.networks\">\n                                        </multiselect-dropdown>\n                                    </div>\n                                </div>\n                                <div class=\"form-group no-margin-bottom\">\n                                    <label for=\"partnerSubCategoryType\"\n                                           class=\"col-md-4 control-label\">Category Type</label>\n                                    <div class=\"col-md-8 metadata-control-col\">\n                                        <multiselect-dropdown id=\"partnerSubCategoryType\"\n                                                              ng-model=\"pmPackagePropertiesCtrl.searchCriteria.categoryTypes\"\n                                                              prompt=\"Select Type\"\n                                                              clearable=\"true\"\n                                                              btn-min-width=\"200\"\n                                                              btn-max-width=\"300\"\n                                                              model-prop=\"id\"\n                                                              label-field=\"name\"\n                                                              collection=\"pmPackagePropertiesCtrl.available.categoryTypes\">\n                                        </multiselect-dropdown>\n                                    </div>\n                                </div>\n                                <div class=\"form-group no-margin-bottom\">\n                                    <label for=\"partnerSubCategory\"\n                                           class=\"col-md-4 control-label\">Category</label>\n                                    <div class=\"col-md-8 metadata-control-col\">\n                                        <multiselect-dropdown id=\"partnerSubCategory\"\n                                                              ng-model=\"pmPackagePropertiesCtrl.searchCriteria.categories\"\n                                                              prompt=\"Select Category\"\n                                                              clearable=\"true\"\n                                                              btn-min-width=\"200\"\n                                                              btn-max-width=\"300\"\n                                                              model-prop=\"id\"\n                                                              label-field=\"name\"\n                                                              collection=\"pmPackagePropertiesCtrl.available.categories\">\n                                        </multiselect-dropdown>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <div ng-show=\"pmPackagePropertiesCtrl.searchCriteria.contentType\">\n                            <div class=\"col-md-6\"\n                                 ng-show=\"pmPackagePropertiesCtrl.searchCriteria.contentType\">\n                                <div class=\"form-group no-margin-bottom\">\n                                    <label for=\"partnerSubContent\"\n                                           class=\"col-sm-3 control-label\">Content</label>\n                                    <div class=\"col-sm-9 metadata-control-col\">\n                                        <multiselect-dropdown id=\"partnerSubContent\"\n                                                              ng-model=\"pmPackagePropertiesCtrl.searchCriteria.contents\"\n                                                              prompt=\"Select Type\"\n                                                              clearable=\"true\"\n                                                              collection=\"pmPackagePropertiesCtrl.available.contents\"\n                                                              label-field=\"name\"\n                                                              model-prop=\"id\"\n                                                              btn-min-width=\"200\"\n                                                              btn-max-width=\"300\"\n                                                              ignore-locks=\"true\">\n                                        </multiselect-dropdown>\n                                    </div>\n                                </div>\n                                <div class=\"form-group no-margin-bottom\"\n                                     ng-show=\"pmPackagePropertiesCtrl.searchCriteria.contentType === \'Series\' && pmPackagePropertiesCtrl.searchCriteria.contents.length\">\n                                    <label for=\"partnerSubSeason\"\n                                           class=\"col-sm-3 control-label\">Season</label>\n                                    <div class=\"col-sm-9 metadata-control-col\">\n                                        <multiselect-dropdown id=\"partnerSubSeason\"\n                                                              ng-model=\"pmPackagePropertiesCtrl.searchCriteria.seasons\"\n                                                              prompt=\"Select Season\"\n                                                              clearable=\"true\"\n                                                              label-field=\"name\"\n                                                              model-prop=\"id\"\n                                                              collection=\"pmPackagePropertiesCtrl.available.seasons\"\n                                                              btn-min-width=\"200\"\n                                                              btn-max-width=\"300\"\n                                                              ignore-locks=\"true\">\n                                        </multiselect-dropdown>\n                                    </div>\n                                </div>\n                                <div class=\"form-group no-margin-bottom\"\n                                     ng-show=\"pmPackagePropertiesCtrl.searchCriteria.contentType === \'Series\' && pmPackagePropertiesCtrl.searchCriteria.contents.length\">\n                                    <label for=\"partnerSubVolume\"\n                                           class=\"col-sm-3 control-label\">Volume</label>\n                                    <div class=\"col-sm-9 metadata-control-col\">\n                                        <multiselect-dropdown id=\"partnerSubVolume\"\n                                                              ng-model=\"pmPackagePropertiesCtrl.searchCriteria.volumes\"\n                                                              prompt=\"Select Volume\"\n                                                              clearable=\"true\"\n                                                              collection=\"pmPackagePropertiesCtrl.available.volumes\"\n                                                              label-field=\"name\"\n                                                              model-prop=\"id\"\n                                                              btn-min-width=\"200\"\n                                                              btn-max-width=\"300\"\n                                                              ignore-locks=\"true\">\n                                        </multiselect-dropdown>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n    </form>\n</div>\n\n\n<div class=\"modal-footer\">\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"pmFilterModal.cancel()\">Reset Defaults\n    </button>\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"pmFilterModal.onOk()\">Apply\n    </button>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/properties/renderers/partner-properties-defaults-template.html", "<div class=\"row clearfix\">\n    <div class=\"col-md-12 column\">\n        <div class=\"row\">\n            <div class=\"col-md-2\">\n                <div class=\"prism-form-heading\">New Subscription Defaults</div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row clearfix spacer-top-lg\">\n        <div class=\"col-md-12 column\">\n            <form class=\"form-horizontal\"\n                  role=\"form\">\n\n                <!-- Default Artwork MAPs -->\n                <div class=\"form-group\">\n                    <label for=\"defaultArtworkMapsGrid\"\n                           class=\"col-sm-2 control-label\">\n                        Default Artwork MAPs\n                    </label>\n                    <div class=\"col-sm-7\">\n                        <default-maps-grid id=\"defaultArtworkMapsGrid\"\n                                            category-types=\"partnerPropCtrlr.availableCategoryTypes\"\n                                            available-artwork-accept-profiles=\"partnerPropCtrlr.availableArtworkAcceptProfiles\"\n                                            initial-artwork-accept-profiles=\"partnerPropCtrlr.initialArtworkAcceptProfiles\"\n                                            on-artwork-accept-profiles-changed=\"partnerPropCtrlr.onArtworkAcceptProfilesChanged(validAcceptProfiles)\"\n                        </default-maps-grid>\n                    </div>\n                </div>\n\n                <!-- Video Roles -->\n                <div class=\"form-group\">\n                    <label for=\"componentRoles\"\n                           class=\"col-sm-2 control-label\">\n                        Video Roles\n                    </label>\n                    <div class=\"col-sm-7\">\n                        <requirement-list\n                            all-entities=\"partnerPropCtrlr.availableVideoRoles\"\n                            context=\"undefined\"\n                            enabled-entities=\"partnerPropCtrlr.partnerObject.videoRoles\"\n                            entity-name=\"Video Role\"\n                            entity-prop=\"role\"\n                            id=\"componentRoles\"\n                            on-update=\"partnerPropCtrlr.enabledVideoRolesUpdated(context, newEnabledEntities)\"\n                            required-flag-prop=\"isRequired\">\n                        </requirement-list>\n                    </div>\n                </div>\n\n                <!-- Multiple Territory Select-->\n                <div class=\"form-group\">\n                    <label for=\"territoriesDropDown\"\n                           class=\"col-sm-2 control-label\">\n                        Territories\n                    </label>\n                    <div class=\"col-md-8 pad-text-input-col\">\n                        <multiselect-dropdown id=\"territoriesDropDown\"\n                                              ng-model=\"partnerPropCtrlr.partnerObject.territories\"\n                                              prompt=\"Select Territories\"\n                                              btn-min-width=\"200\"\n                                              clearable=\"true\"\n                                              label-field=\"name\"\n                                              sort-collection=\"false\"\n                                              collection=\"partnerPropCtrlr.availableTerritories\">\n                        </multiselect-dropdown>\n                    </div>\n                </div>\n\n                <!-- Intermediate Templates -->\n                <div class=\"form-group\">\n                    <label for=\"intermediateTemplate\"\n                           class=\"col-sm-2 control-label\">\n                        Intermediate Template\n                    </label>\n                    <div class=\"col-sm-7 top-margin-xs\">\n                        <dropdown-select\n                            id=\"intermediateTemplate\"\n                            ng-model=\"partnerPropCtrlr.partnerObject.intermediateVideoTemplate\"\n                            prompt=\"Select Intermediate Profile\"\n                            btn-min-width=\"200\"\n                            clearable=\"true\"\n                            label-field=\"name\"\n                            attach-to-body=\"false\"\n                            collection=\"partnerPropCtrlr.intermediateTemplates\">\n                        </dropdown-select>\n                    </div>\n                </div>\n\n                <!-- Shared Nielsen Enabled -->\n                <div class=\"form-group\">\n                    <label for=\"sharedNielsenEnabled\"\n                           class=\"col-sm-2 control-label\">\n                        Shared Nielsen Enabled\n                    </label>\n                    <div class=\"col-sm-1 partner-nielsen-enabled-cb\">\n                        <input type=\"checkbox\"\n                               id=\"sharedNielsenEnabled\"\n                               ng-model=\"partnerPropCtrlr.partnerObject.sharedNielsenTranscode\"/>\n                        <label for=\"sharedNielsenEnabled\"></label>\n                    </div>\n                </div>\n\n                <!-- Languages -->\n                <div class=\"form-group\">\n                    <label for=\"languagesGrid\"\n                           class=\"col-lg-2 control-label\">\n                        Languages\n                    </label>\n                    <div class=\"col-lg-9\">\n                        <serviceable-languages-grid\n                            class=\"languages-grid\"\n                            id=\"languagesGrid\"\n                            on-serviceable-languages-changed=\"partnerPropCtrlr.onServiceableLanguagesChanged(validServiceableLanguages)\"\n                            serviceable-languages=\"partnerPropCtrlr.availableServiceableLanguages\">\n                        </serviceable-languages-grid>\n                    </div>\n                </div>\n\n            </form>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/properties/renderers/partner-properties-external-embargo-template.html", "<div class=\"row clearfix\">\n\n    <div class=\"col-md-12 column\">\n        <div class=\"row\">\n            <div class=\"col-md-2\">\n                <div class=\"prism-form-heading\">\n                    Pre-Delivery Validator\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"row clearfix spacer-top-lg\">\n        <div class=\"col-md-12 column\">\n            <form class=\"form-horizontal\"\n                  role=\"form\">\n\n                <!-- Enabled -->\n                <div class=\"form-group\">\n                    <label for=\"embargoEnabledFlagCheckbox\"\n                           class=\"col-sm-2 control-label\">Enabled</label>\n                    <div class=\"col-sm-1 partner-nielsen-enabled-cb\">\n                        <input type=\"checkbox\"\n                               id=\"embargoEnabledFlagCheckbox\"\n                               ng-model=\"partnerPropCtrlr.partnerObject.embargoEnabledFlag\"/>\n                        <label for=\"embargoEnabledFlagCheckbox\"></label>\n                    </div>\n                </div>\n\n                <!-- Delivery Endpoint -->\n                <div class=\"form-group\">\n                    <label for=\"embargoDeliveryEndpointDropDown\"\n                           class=\"col-sm-2 control-label\">\n                        Delivery Endpoint\n                    </label>\n                    <div class=\"col-sm-7 top-margin-xs\">\n                        <dropdown-select\n                            id=\"embargoDeliveryEndpointDropDown\"\n                            prompt=\"Select Embargo Delivery Endpoint\"\n                            label-field=\"name\"\n                            collection=\"partnerPropCtrlr.availableDeliveryEndpoints\"\n                            attach-to-body=\"false\"\n                            ng-model=\"partnerPropCtrlr.partnerObject.embargoDeliveryEndpoint\"\n                            ng-disabled=\"!partnerPropCtrlr.partnerObject.embargoEnabledFlag\"\n                            clearable=\"false\">\n                        </dropdown-select>\n                        <span ng-show=\"partnerPropCtrlr.partnerObject.embargoEnabledFlag\">\n                            <span class=\"required-text-input\"\n                                  required\n                                  x-required-indicator>\n                            </span>\n                        </span>\n                    </div>\n                </div>\n\n                <!-- Email Notice -->\n                <div class=\"form-group\">\n                    <label for=\"embargoEmailEndpointDropDown\"\n                           class=\"col-sm-2 control-label\">\n                        Email Notice\n                    </label>\n                    <div class=\"col-sm-7 top-margin-xs\">\n                        <dropdown-select\n                            id=\"embargoEmailEndpointDropDown\"\n                            prompt=\"Select Embargo Email Endpoint\"\n                            label-field=\"name\"\n                            collection=\"partnerPropCtrlr.availableEmailEndpoints\"\n                            attach-to-body=\"false\"\n                            ng-model=\"partnerPropCtrlr.partnerObject.embargoEmailEndpoint\"\n                            ng-disabled=\"!partnerPropCtrlr.partnerObject.embargoEnabledFlag\"\n                            clearable=\"true\">\n                        </dropdown-select>\n                    </div>\n                </div>\n\n            </form>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/properties/renderers/partner-properties-formatting-template.html", "<div class=\"row clearfix\">\n	<div class=\"col-md-12 column\">\n		<div class=\"row\">\n			<div class=\"col-md-3\">\n				<div class=\"prism-form-heading\">Formatting <button class=\"btn btn-default prism-button\" ng-click=\"partnerPropCtrlr.setFormatsToDefault()\">Use Defaults</button></div>\n			</div>\n		</div>\n	</div>\n	<div class=\"row clearfix spacer-top-lg\">\n		<div class=\"col-md-12 column\">\n			<form class=\"form-horizontal\" role=\"form\">\n				<div class=\"form-group\">\n					<label for=\"partnerDateFormat\" class=\"col-sm-2 control-label\">Date Format</label>\n					<div class=\"col-sm-4 pad-text-input-col\">\n						<enhanced-textinput model-prop=\"partnerPropCtrlr.partnerObject.dateFormat\" max-chars=\"40\"\n											input-id=\"partnerDateFormat\"></enhanced-textinput>\n					</div>\n					<label class=\"col-sm-2 pad-text-input-col no-right-padding control-label text-align-left\">{{\'Default: \' + partnerPropCtrlr.DEFAULT_FORMAT_VALUES.dateFormat}} <span class=\"required-form-control\">*</span> </label>\n				</div>\n				<div class=\"form-group\">\n					<label for=\"partnerDateTimeFormat\" class=\"col-sm-2 control-label\">Date/Time Format</label>\n					<div class=\"col-sm-4 pad-text-input-col\">\n						<enhanced-textinput model-prop=\"partnerPropCtrlr.partnerObject.dateTimeFormat\" max-chars=\"40\"\n											input-id=\"partnerDateTimeFormat\"></enhanced-textinput>\n					</div>\n					<label class=\"col-sm-3 pad-text-input-col no-right-padding control-label text-align-left\">{{\'Default: \' + partnerPropCtrlr.DEFAULT_FORMAT_VALUES.dateTimeFormat}} <span class=\"required-form-control\">*</span> </label>\n				</div>\n				<div class=\"form-group\">\n					<label for=\"partnerTimeFormat\" class=\"col-sm-2 control-label\">Time Format</label>\n					<div class=\"col-sm-4 pad-text-input-col\">\n						<enhanced-textinput model-prop=\"partnerPropCtrlr.partnerObject.timeFormat\" max-chars=\"40\"\n											input-id=\"partnerTimeFormat\"></enhanced-textinput>\n					</div>\n					<label class=\"col-sm-2 pad-text-input-col no-right-padding control-label text-align-left\">{{\'Default: \' + partnerPropCtrlr.DEFAULT_FORMAT_VALUES.timeFormat}} <span class=\"required-form-control\">*</span> </label>\n				</div>\n				<div class=\"form-group\">\n					<label for=\"partnerNumberFormat\" class=\"col-sm-2 control-label\">Number Format</label>\n					<div class=\"col-sm-4 pad-text-input-col\">\n						<enhanced-textinput model-prop=\"partnerPropCtrlr.partnerObject.numberFormat\" max-chars=\"40\"\n											input-id=\"partnerNumberFormat\"></enhanced-textinput>\n					</div>\n					<label class=\"col-sm-2 pad-text-input-col no-right-padding control-label text-align-left\">{{\'Default: \' + partnerPropCtrlr.DEFAULT_FORMAT_VALUES.numberFormat}} <span class=\"required-form-control\">*</span> </label>\n				</div>\n			</form>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/properties/renderers/partner-properties-general-template.html", "<div class=\"row clearfix\">\n    <div class=\"col-md-12 column\">\n        <div class=\"row\">\n            <div class=\"col-md-2\">\n                <div class=\"prism-form-heading\">\n                    General\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row clearfix spacer-top-lg\">\n        <div class=\"col-md-12 column\">\n            <form class=\"form-horizontal\"\n                  role=\"form\">\n\n                <!-- Parent Partners Select-->\n                <div class=\"form-group\">\n                    <label for=\"parentPartnerDropDown\" class=\"col-sm-2 control-label\">\n                        Select Parent Partner\n                    </label>\n                    <div class=\"col-md-8 pad-text-input-col\">\n                        <dropdown id=\"parentPartnerDropDown\"\n                                  ng-model=\"partnerPropCtrlr.selectedParentPartner\"\n                                  ng-change=\"partnerPropCtrlr.setPartnerObjectParentPartnerId()\"\n                                  prompt=\"Select Parent Partner\" btn-min-width=\"200\" clearable=\"true\"\n                                  label-path=\"name\"\n                                  ng-disabled=\"(partnerPropCtrlr.partnerObject.numberOfChildren | stringToNumber) > 0\"\n                                  collection=\"partnerPropCtrlr.availableParentPartners\">\n                        </dropdown>\n                    </div>\n                </div>\n\n                <!-- Child Partners -->\n                <div class=\"form-group\" ng-if=\"(partnerPropCtrlr.partnerObject.numberOfChildren | stringToNumber) > 0\">\n                    <label for=\"deliveryTemplatesGrid\"\n                           class=\"col-sm-2 control-label\">Child Partners</label>\n                    <div class=\"col-sm-3\">\n                        <div class=\"list-group child-partner-list\">\n                            <div class=\"list-group-item child-partner-list-item\" ng-repeat=\"childPartner in partnerPropCtrlr.childPartners\" ng-dblclick=\"partnerPropCtrlr.navigateToChildPartner(childPartner.id)\">\n                                {{childPartner.name}}\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <!-- Name -->\n                <div class=\"form-group\">\n                    <label for=\"partnerName\"\n                           class=\"col-sm-2 control-label\">\n                        Name\n                    </label>\n                    <div class=\"col-sm-4 pad-text-input-col\">\n                        <enhanced-textinput model-prop=\"partnerPropCtrlr.partnerObject.name\"\n                                            max-chars=\"40\"\n                                            input-id=\"partnerName\">\n                        </enhanced-textinput>\n                    </div>\n                    <div class=\"required-text-input\"\n                         required\n                         x-required-indicator></div>\n                </div>\n\n                <!-- Value -->\n                <div class=\"form-group\">\n                    <label for=\"partnerValue\"\n                           class=\"col-sm-2 control-label\">\n                        Value\n                    </label>\n                    <div class=\"col-sm-4 pad-text-input-col\">\n                        <enhanced-textinput model-prop=\"partnerPropCtrlr.partnerObject.value\"\n                                            max-chars=\"40\"\n                                            input-id=\"partnerValue\">\n                        </enhanced-textinput>\n                    </div>\n                    <div class=\"required-text-input\"\n                         required\n                         x-required-indicator></div>\n                </div>\n\n                <!-- Type -->\n                <div class=\"form-group\">\n                    <label for=\"typeDropDown\" class=\"col-sm-2 control-label\">\n                        Type\n                    </label>\n                    <div class=\"col-md-8 pad-text-input-col\">\n                        <dropdown-select id=\"typeDropDown\"\n                                         ng-model=\"partnerPropCtrlr.partnerObject.type\"\n                                         prompt=\"Select Partner Type\" btn-min-width=\"200\" clearable=\"true\"\n                                         collection=\"partnerPropCtrlr.availablePartnerTypes\">\n                        </dropdown-select>\n                    </div>\n                </div>\n\n                <!-- Timezone -->\n                <div class=\"form-group\">\n                    <label for=\"partnerTimezone\"\n                           class=\"col-sm-2 control-label\">\n                        Timezone\n                    </label>\n                    <div class=\"col-sm-4 pad-text-input-col\">\n                        <enhanced-textinput model-prop=\"partnerPropCtrlr.partnerObject.timeZone\"\n                                            max-chars=\"40\"\n                                            input-id=\"partnerTimezone\">\n                        </enhanced-textinput>\n                    </div>\n                    <label class=\"col-sm-2 pad-text-input-col no-right-padding control-label text-align-left\">\n                        Default: PST Time Zone\n                        <span class=\"required-form-control\">*</span>\n                    </label>\n                </div>\n\n                <div class=\"row\">\n                    <div class=\"col-lg-4\">\n                        <!-- PDI Enabled -->\n                        <div class=\"form-group\" ng-if=\"!partnerPropCtrlr.partnerObject.parentId\">\n                            <div class=\"v-align\">\n                                <label for=\"pdiEnabled\"\n                                       class=\"col-sm-6 control-label\">\n                                    Enable Distribution Instances\n                                </label>\n                                <div class=\"col-sm-1 padding-top-sm\">\n                                    <input type=\"checkbox\"\n                                           id=\"pdiEnabled\"\n                                           ng-model=\"partnerPropCtrlr.partnerObject.partnerDeliveryInstanceEnabled\"/>\n                                    <label for=\"pdiEnabled\" class=\"control-label\"></label>\n                                </div>\n                            </div>\n                        </div>\n\n                        <!-- Record Individual File Deliveries -->\n                        <div class=\"form-group\">\n                            <div class=\"v-align\">\n                                <label for=\"recordIndividualDeliveries\"\n                                       class=\"col-sm-6 control-label\">\n                                    Record Individual File Deliveries\n                                </label>\n                                <div class=\"col-sm-1 padding-top-sm\">\n                                    <input type=\"checkbox\"\n                                           id=\"recordIndividualDeliveries\"\n                                           ng-model=\"partnerPropCtrlr.partnerObject.recordIndividualDeliveries\"/>\n                                    <label for=\"recordIndividualDeliveries\" class=\"control-label\"></label>\n                                </div>\n                            </div>\n                        </div>\n\n                        <!-- Include MMC Siblings Data -->\n                        <div class=\"form-group\">\n                            <div class=\"v-align\">\n                                <label for=\"includeMMCSiblings\"\n                                       class=\"col-sm-6 control-label\">\n                                    Include MMC Siblings Data\n                                </label>\n                                <div class=\"col-sm-1 padding-top-sm\">\n                                    <input type=\"checkbox\"\n                                           id=\"includeMMCSiblings\"\n                                           ng-model=\"partnerPropCtrlr.partnerObject.includeMMCSiblings\"/>\n                                    <label for=\"includeMMCSiblings\" class=\"control-label\"></label>\n                                </div>\n                            </div>\n                        </div>\n\n                        <!-- Network Rating Overlay Enabled -->\n                        <div class=\"form-group\">\n                            <div class=\"v-align\">\n                                <label for=\"networkRatingOverlayEnabled\"\n                                       class=\"col-sm-6 control-label\">\n                                    Network Rating Overlay Enabled\n                                </label>\n                                <div class=\"col-sm-1 padding-top-sm\">\n                                    <input type=\"checkbox\"\n                                           id=\"networkRatingOverlayEnabled\"\n                                           ng-model=\"partnerPropCtrlr.partnerObject.ratingOverlayEnabled\"/>\n                                    <label for=\"networkRatingOverlayEnabled\" class=\"control-label\"></label>\n                                </div>\n                            </div>\n                        </div>\n\n                    </div>\n                </div>\n\n                <!--\n                    ABC-6991\n                        * Remove lock date override field.\n                        * Keeping inactive code in place should Robert want it back.\n                  -->\n\n                <!--\n                <div class=\"form-group\">\n                    <label for=\"partnerLockDateOverride\" class=\"col-sm-2 control-label\">Lock Date Override</label>\n                    <div class=\"col-sm-4 pad-text-input-col no-padding\">\n                        <date-time-picker id=\"partnerLockDateOverride\" ng-model=\"partnerPropCtrlr.partnerObject.lockDate\"></date-time-picker>\n                    </div>\n                    <label class=\"col-sm-3 pad-text-input-col no-right-padding control-label text-align-left\">Default: Jan. 1, 2100, 12:00:00 AM </label>\n                </div>\n                -->\n\n                <!-- Delivery Template(s) -->\n                <div class=\"form-group\">\n                    <label for=\"deliveryTemplatesGrid\"\n                           class=\"col-sm-2 control-label\">Delivery Template(s)</label>\n                    <div class=\"col-sm-7\">\n                        <div id=\"deliveryTemplatesGrid\"\n                             ui-grid=\"partnerPropCtrlr.deliveryTemplatesGridOptions\"\n                             class=\"inline-checkbox-grid top-margin-xs\"\n                             ui-grid-selection\n                             ui-grid-auto-resize>\n                        </div>\n                    </div>\n                </div>\n\n            </form>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/properties/renderers/partner-properties-pre-delivery-qc-approval-template.html", "<div class=\"row clearfix\">\n    <div class=\"col-md-12 column\">\n        <div class=\"row\">\n            <div class=\"col-md-2\">\n                <div class=\"prism-form-heading\">\n                    Pre-Delivery QC Approval\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row clearfix spacer-top-lg\">\n        <div class=\"col-md-12 column\">\n            <form class=\"form-horizontal\"\n                  role=\"form\">\n\n                <!-- Enabled -->\n                <div class=\"form-group\">\n                    <label for=\"approvalEnabledFlagCheckbox\"\n                           class=\"col-sm-2 control-label\">Enabled</label>\n                    <div class=\"col-sm-1 partner-nielsen-enabled-cb\">\n                        <input type=\"checkbox\"\n                               id=\"approvalEnabledFlagCheckbox\"\n                               ng-model=\"partnerPropCtrlr.partnerObject.approvalEnabledFlag\"/>\n                        <label for=\"approvalEnabledFlagCheckbox\"></label>\n                    </div>\n                </div>\n\n                <!-- Auto Approve -->\n                <div class=\"form-group\">\n                    <label for=\"autoApproveCheckbox\"\n                           class=\"col-sm-2 control-label\">Auto Approve</label>\n                    <div class=\"col-sm-1 partner-nielsen-enabled-cb\">\n                        <input type=\"checkbox\"\n                               id=\"autoApproveCheckbox\"\n                               ng-disabled=\"!partnerPropCtrlr.partnerObject.approvalEnabledFlag\"\n                               ng-model=\"partnerPropCtrlr.partnerObject.autoApprovalFlag\"/>\n                        <label for=\"autoApproveCheckbox\"></label>\n                    </div>\n                </div>\n\n                <!-- Delivery Endpoint -->\n                <div class=\"form-group\">\n                    <label for=\"approvalDeliveryEndpointDropDown\"\n                           class=\"col-sm-2 control-label\">\n                        Delivery Endpoint\n                    </label>\n                    <div class=\"col-sm-7 top-margin-xs\">\n                        <dropdown-select\n                            id=\"approvalDeliveryEndpointDropDown\"\n                            prompt=\"Select Approval Delivery Endpoint\"\n                            label-field=\"name\"\n                            collection=\"partnerPropCtrlr.availableDeliveryEndpoints\"\n                            attach-to-body=\"false\"\n                            ng-disabled=\"!partnerPropCtrlr.partnerObject.approvalEnabledFlag\"\n                            ng-model=\"partnerPropCtrlr.partnerObject.approvalDeliveryEndpoint\"\n                            clearable=\"false\">\n                        </dropdown-select>\n                        <span ng-show=\"partnerPropCtrlr.partnerObject.approvalEnabledFlag\">\n                            <span class=\"required-text-input\"\n                                  required\n                                  x-required-indicator>\n                            </span>\n                        </span>\n                    </div>\n                </div>\n\n                <!-- Email Notice -->\n                <div class=\"form-group\">\n                    <label for=\"approvalEmailEndpointDropDown\"\n                           class=\"col-sm-2 control-label\">\n                        Email Notifce\n                    </label>\n                    <div class=\"col-sm-7 top-margin-xs\">\n                        <dropdown-select\n                            id=\"approvalEmailEndpointDropDown\"\n                            prompt=\"Select Approval Email Endpoint\"\n                            label-field=\"name\"\n                            collection=\"partnerPropCtrlr.availableEmailEndpoints\"\n                            attach-to-body=\"false\"\n                            ng-model=\"partnerPropCtrlr.partnerObject.approvalEmailEndpoint\"\n                            ng-disabled=\"!partnerPropCtrlr.partnerObject.approvalEnabledFlag\"\n                            clearable=\"true\">\n                        </dropdown-select>\n                    </div>\n                </div>\n\n            </form>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/templates/mediaAcceptProfiles/components/validators/audio/searchView/media-accept-profiles-audio-validators-search-view-template.html", "<div class=\"edit-full-height\">\n\n        <div id=\"grid\"\n             class=\"grid search-grid\"\n             ui-grid=\"$ctrl.gridOptions\"\n             ui-grid-selection\n             ui-grid-resize-columns>\n        </div>\n\n    <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"\n             right-hand-checkbox-defs=\"$ctrl.toolbarCheckboxDefs\">\n    </toolbar>\n</div>\n");
        $templateCache.put("system/templates/mediaAcceptProfiles/components/validators/audio/editor/media-accept-profiles-audio-validator-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <div class=\"row-no-padding\">\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n            <div class=\"col-md-12 column\">\n                <div class=\"row\">\n                    <breadcrumb tab-name=\"\'Validator Properties\'\"></breadcrumb>\n                    <fieldset>\n                        <div class=\"edit-full-height-no-tabs edit-view\">\n                            <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n                                <div class=\"edit-view-container\">\n                                    <div class=\"row\">\n                                        <div class=\"col-md-4\">\n                                            <div class=\"prism-form-heading\">Audio Validator</div>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group spacer-top-lg\">\n                                        <label class=\"control-label col-md-3\">Track Number</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"number\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.trackNumber\"\n                                                   id=\"trackNumberInput\"/>\n                                        </div>\n                                        <div class=\"col-sm-1 error-warning spacer-top-xsm\">\n                                            <error-warning-indicator\n                                                ng-if=\"$ctrl.trackNumberNotAllowed()\"\n                                                class=\"asset-errors-and-warnings-indicator\"\n                                                error-warning=\"$ctrl.existingAudioValidatorTrackNumberWarningMessage\">\n                                            </error-warning-indicator>\n                                            <error-warning-indicator\n                                                ng-if=\"!$ctrl.validateInteger($ctrl.editData.trackNumber) && $ctrl.editData.trackNumber != undefined\"\n                                                class=\"asset-errors-and-warnings-indicator\"\n                                                error-warning=\"{type: \'warning\', message: \'Positive Integers and 0 only\'}\">\n                                            </error-warning-indicator>\n                                        </div>\n                                        <div class=\"required-text-input\" required\n                                             x-required-indicator></div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Title</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.title\"\n                                                   id=\"titleInput\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Format</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.format\"\n                                                   id=\"formatInput\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Codec</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.codec\" id=\"codecInput\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Compression\n                                            Mode</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.compressionMode\"\n                                                   id=\"compressionModeInput\"/></div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Duration</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.duration\"\n                                                   id=\"durationInput\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Channels</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.channels\"\n                                                   id=\"channelsInput\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Language</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.language\"\n                                                   id=\"languageInput\"/></div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Bit Rate</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.bitRate\"\n                                                   id=\"bitRateInput\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Bit Rate Mode</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.bitRateMode\"\n                                                   id=\"bitRateModeInput\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Sampling Rate</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.samplingRate\"\n                                                   id=\"samplingRateInput\"/>\n                                        </div>\n                                    </div>\n                                </div>\n\n                                <hr/>\n\n                                <div ng-include=\"\'system/templates/mediaAcceptProfiles/components/validators/renderers/track-validator-xml-textarea-template.html\'\"></div>\n\n                            </form>\n                        </div>\n                    </fieldset>\n                </div>\n            </div>\n\n            <div class=\"row-no-padding manager-toolbar\">\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\" pagination-defs=\"$ctrl.paginationDefs\"></toolbar>\n            </div>\n        </div>\n        <div class=\"loadingIndicator\">\n            <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                 ng-show=\"$ctrl.loadingIndicator.show\">\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/templates/mediaAcceptProfiles/components/validators/general/editor/media-accept-profiles-general-validator-edit-view-template.html", "<fieldset>\n    <div class=\"edit-full-height edit-view\">\n        <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n            <div class=\"edit-view-container\">\n                <div class=\"row\">\n                    <div class=\"col-md-4\">\n                        <div class=\"prism-form-heading\">General Validator</div>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label class=\"control-label col-md-3\">Track Number</label>\n                    <div class=\"col-sm-4 pad-text-input-col\">\n                        <input type=\"number\" class=\"prism-text-input\"\n                               ng-model=\"$ctrl.editData.trackNumber\"\n                               id=\"trackNumberInput\"/>\n                    </div>\n                    <div class=\"col-sm-1 error-warning spacer-top-xsm\">\n                        <error-warning-indicator\n                            ng-if=\"!$ctrl.validateInteger($ctrl.editData.trackNumber) && $ctrl.editData.trackNumber != null\"\n                            class=\"asset-errors-and-warnings-indicator\"\n                            error-warning=\"{type: \'warning\', message: \'Positive Integers and 0 only\'}\">\n                        </error-warning-indicator>\n                    </div>\n                    <div class=\"required-text-input\" required\n                         x-required-indicator></div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"fileName\" class=\"control-label col-md-3\">File Name</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <input type=\"text\" class=\"prism-text-input\"\n                               ng-model=\"$ctrl.editData.fileName\"\n                               name=\"fileName\"\n                               id=\"fileName\"/>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"fileExtension\" class=\"control-label col-md-3\">File\n                        Extensions</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <input type=\"text\" class=\"prism-text-input\"\n                               ng-model=\"$ctrl.editData.fileExtension\"\n                               name=\"fileExtension\"\n                               id=\"fileExtension\"/>\n                    </div>\n                </div>\n\n                <div class=\"form-group\" ng-if=\"$ctrl.mediaAcceptProfile.type !== \'DOCUMENT\'\">\n                    <label for=\"format\" class=\"control-label col-md-3\">Format</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <input type=\"text\" class=\"prism-text-input\"\n                               ng-model=\"$ctrl.editData.format\"\n                               name=\"format\"\n                               id=\"format\"/>\n                    </div>\n                </div>\n\n                <div class=\"form-group\" ng-if=\"$ctrl.mediaAcceptProfile.type !== \'DOCUMENT\'\">\n                    <label for=\"duration\" class=\"control-label col-md-3\">Duration</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <input type=\"text\" class=\"prism-text-input\"\n                               ng-model=\"$ctrl.editData.duration\"\n                               name=\"duration\"\n                               id=\"duration\"/>\n                    </div>\n                </div>\n\n                <div class=\"form-group\" ng-if=\"$ctrl.mediaAcceptProfile.type !== \'DOCUMENT\'\">\n                    <label for=\"audioCount\" class=\"control-label col-md-3\">Audio Count</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <input type=\"text\" class=\"prism-text-input\"\n                               ng-model=\"$ctrl.editData.audioCount\"\n                               name=\"audioCount\"\n                               id=\"audioCount\"/>\n                    </div>\n                </div>\n\n                <div class=\"form-group\" ng-if=\"$ctrl.mediaAcceptProfile.type !== \'DOCUMENT\'\">\n                    <label for=\"chapterCount\" class=\"control-label col-md-3\">Chapter Count</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <input type=\"text\" class=\"prism-text-input\"\n                               ng-model=\"$ctrl.editData.chapterCount\"\n                               name=\"chapterCount\"\n                               id=\"chapterCount\"/>\n                    </div>\n                </div>\n\n                <div class=\"form-group\" ng-if=\"$ctrl.mediaAcceptProfile.type !== \'DOCUMENT\'\">\n                    <label for=\"videoCount\" class=\"control-label col-md-3\">Video Count</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <input type=\"text\" class=\"prism-text-input\"\n                               ng-model=\"$ctrl.editData.videoCount\"\n                               name=\"videoCount\"\n                               id=\"videoCount\"/>\n                    </div>\n                </div>\n\n                <div class=\"form-group\" ng-if=\"$ctrl.mediaAcceptProfile.type !== \'DOCUMENT\'\">\n                    <label for=\"imageCount\" class=\"control-label col-md-3\">Image Count</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <input type=\"text\" class=\"prism-text-input\"\n                               ng-model=\"$ctrl.editData.imageCount\"\n                               name=\"imageCount\"\n                               id=\"imageCount\"/>\n                    </div>\n                </div>\n\n                <div class=\"form-group\" ng-if=\"$ctrl.mediaAcceptProfile.type !== \'DOCUMENT\'\">\n                    <label for=\"textCount\" class=\"control-label col-md-3\">Text Count</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <input type=\"text\" class=\"prism-text-input\"\n                               ng-model=\"$ctrl.editData.textCount\"\n                               name=\"textCount\"\n                               id=\"textCount\"/>\n                    </div>\n                </div>\n\n                <div class=\"form-group\" ng-if=\"$ctrl.mediaAcceptProfile.type !== \'DOCUMENT\'\">\n                    <label for=\"overallBitRate\" class=\"control-label col-md-3\">Overall Bit\n                        Rate</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <input type=\"text\" class=\"prism-text-input\"\n                               ng-model=\"$ctrl.editData.overallBitRate\"\n                               name=\"overallBitRate\"\n                               id=\"overallBitRate\"/>\n                    </div>\n                </div>\n\n                <div class=\"form-group v-align\">\n                    <label for=\"truncated\"\n                           class=\"col-md-3 control-label padding-bottom-sm\">\n                        Truncated Media\n                    </label>\n                    <div class=\"col-md-8\">\n                        <dropdown-select\n                                btn-min-width=\"200\"\n                                collection=\"$ctrl.truncatedOptions\"\n                                id=\"truncated\"\n                                on-change=\"$ctrl.onTruncatedChanged()\"\n                                ng-model=\"$ctrl.truncated\">\n                        </dropdown-select>\n                    </div>\n                </div>\n\n            </div>\n\n            <hr/>\n\n            <div ng-include=\"\'system/templates/mediaAcceptProfiles/components/validators/renderers/track-validator-xml-textarea-template.html\'\"></div>\n\n        </form>\n\n    </div>\n</fieldset>\n\n<div class=\"row-no-padding manager-toolbar\">\n    <toolbar button-defs=\"$ctrl.toolbarButtonDefs\" pagination-defs=\"$ctrl.paginationDefs\"></toolbar>\n</div>\n</div>\n<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\">\n    </div>\n</div>\n\n");
        $templateCache.put("system/templates/mediaAcceptProfiles/components/validators/image/editor/media-accept-profiles-image-validator-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <div class=\"row-no-padding\">\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n            <div class=\"col-md-12 column\">\n                <div class=\"row\">\n                    <breadcrumb tab-name=\"\'Validator Properties\'\"></breadcrumb>\n                    <fieldset>\n                        <div class=\"edit-full-height-no-tabs edit-view\">\n                            <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n                                <div class=\"edit-view-container\">\n                                    <div class=\"row\">\n                                        <div class=\"col-md-4\">\n                                            <div class=\"prism-form-heading\">Image Validator</div>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group spacer-top-lg\">\n                                        <label class=\"control-label col-md-3\">Track Number</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"number\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.trackNumber\"\n                                                   id=\"trackNumberInput\"/>\n                                        </div>\n                                        <div class=\"col-sm-1 error-warning spacer-top-xsm\">\n                                            <error-warning-indicator\n                                                ng-if=\"$ctrl.trackNumberNotAllowed()\"\n                                                class=\"asset-errors-and-warnings-indicator\"\n                                                error-warning=\"$ctrl.existingImageValidatorTrackNumberWarningMessage\">\n                                            </error-warning-indicator>\n                                            <error-warning-indicator\n                                                ng-if=\"!$ctrl.validateInteger($ctrl.editData.trackNumber) && $ctrl.editData.trackNumber != undefined\"\n                                                class=\"asset-errors-and-warnings-indicator\"\n                                                error-warning=\"{type: \'warning\', message: \'Positive Integers and 0 only\'}\">\n                                            </error-warning-indicator>\n                                        </div>\n                                        <div class=\"required-text-input\" required\n                                             x-required-indicator></div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Format</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.format\"\n                                                   id=\"formatInput\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Bit Depth</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.bitDepth\"\n                                                   id=\"bitDepthInput\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">\n                                            Compression Mode\n                                        </label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.compressionMode\"\n                                                   id=\"compressionModeInput\"/></div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">\n                                            Chroma Sub-Sampling\n                                        </label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.chromaSubsampling\"\n                                                   id=\"chromaSubsamplingInput\"/></div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Aspect Ratio</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.aspectRatio\"\n                                                   id=\"aspectRatioInput\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">\n                                            Width\n                                        </label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.width\"\n                                                   id=\"widthInput\"\n                                                   type=\"text\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">\n                                            Height\n                                        </label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.height\"\n                                                   id=\"heightInput\"\n                                                   type=\"text\"/>\n                                        </div>\n                                    </div>\n\n                                </div>\n\n                                <hr/>\n\n                                <div ng-include=\"\'system/templates/mediaAcceptProfiles/components/validators/renderers/track-validator-xml-textarea-template.html\'\"></div>\n\n                            </form>\n                        </div>\n                    </fieldset>\n                </div>\n            </div>\n\n            <div class=\"row-no-padding manager-toolbar\">\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\" pagination-defs=\"$ctrl.paginationDefs\"></toolbar>\n            </div>\n        </div>\n        <div class=\"loadingIndicator\">\n            <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                 ng-show=\"$ctrl.loadingIndicator.show\">\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/templates/mediaAcceptProfiles/components/validators/image/searchView/media-accept-profiles-image-validators-search-view-template.html", "<div class=\"edit-full-height\">\n\n        <div id=\"grid\"\n             class=\"grid search-grid\"\n             ui-grid=\"$ctrl.gridOptions\"\n             ui-grid-selection\n             ui-grid-resize-columns>\n        </div>\n\n    <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"\n             right-hand-checkbox-defs=\"$ctrl.toolbarCheckboxDefs\">\n    </toolbar>\n</div>\n");
        $templateCache.put("system/templates/mediaAcceptProfiles/components/validators/text/editor/media-accept-profiles-text-validator-edit-view-template.html", "<fieldset>\n    <div class=\"edit-full-height edit-view\">\n        <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n            <div class=\"edit-view-container\">\n                <div class=\"row\">\n                    <div class=\"col-md-4\">\n                        <div class=\"prism-form-heading\">Text Validator</div>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"eia608FormatInput\"\n                           class=\"col-md-3 control-label\">EIA-608</label>\n                    <div class=\"col-sm-4 partner-nielsen-enabled-cb\">\n                        <input type=\"checkbox\"\n                               id=\"eia608FormatInput\"\n                               ng-model=\"$ctrl.eia608\"/>\n                        <label for=\"eia608FormatInput\">&nbsp;</label>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"eia708FormatInput\"\n                           class=\"col-md-3 control-label\">EIA-708</label>\n                    <div class=\"col-sm-4 partner-nielsen-enabled-cb\">\n                        <input type=\"checkbox\"\n                               id=\"eia708FormatInput\"\n                               ng-model=\"$ctrl.eia708\"/>\n                        <label for=\"eia708FormatInput\">&nbsp;</label>\n                    </div>\n                </div>\n            </div>\n        </form>\n    </div>\n</fieldset>\n\n<div class=\"row-no-padding manager-toolbar\">\n    <toolbar button-defs=\"$ctrl.toolbarButtonDefs\" pagination-defs=\"$ctrl.paginationDefs\"></toolbar>\n</div>\n</div>\n<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\">\n    </div>\n</div>\n\n");
        $templateCache.put("system/templates/mediaAcceptProfiles/components/validators/video/editor/media-accept-profiles-video-validator-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <div class=\"row-no-padding\">\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n            <div class=\"col-md-12 column\">\n                <div class=\"row\">\n                    <breadcrumb tab-name=\"\'Validator Properties\'\"></breadcrumb>\n                    <fieldset>\n                        <div class=\"edit-full-height-no-tabs edit-view\">\n                            <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n                                <div class=\"edit-view-container\">\n                                    <div class=\"row\">\n                                        <div class=\"col-md-4\">\n                                            <div class=\"prism-form-heading\">Video Validator</div>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group spacer-top-lg\">\n                                        <label class=\"control-label col-md-3\">Track Number</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"number\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.trackNumber\"\n                                                   id=\"trackNumberInput\"/>\n                                        </div>\n                                        <div class=\"col-sm-1 error-warning spacer-top-xsm\">\n                                            <error-warning-indicator\n                                                ng-if=\"$ctrl.trackNumberNotAllowed()\"\n                                                class=\"asset-errors-and-warnings-indicator\"\n                                                error-warning=\"$ctrl.existingVideoValidatorTrackNumberWarningMessage\">\n                                            </error-warning-indicator>\n                                            <error-warning-indicator\n                                                ng-if=\"!$ctrl.validateInteger($ctrl.editData.trackNumber) && $ctrl.editData.trackNumber != undefined\"\n                                                class=\"asset-errors-and-warnings-indicator\"\n                                                error-warning=\"{type: \'warning\', message: \'Positive Integers and 0 only\'}\">\n                                            </error-warning-indicator>\n                                        </div>\n                                        <div class=\"required-text-input\" required\n                                             x-required-indicator></div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Timecode Delay\n                                            (seconds)</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.startTime\"\n                                                   id=\"startTimeInput\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Format</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.format\"\n                                                   id=\"formatInput\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Format Profile</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.formatProfile\"\n                                                   id=\"formatProfileInput\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Format Settings</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.formatSettings\"\n                                                   id=\"formatSettingsInput\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Format Settings CABAC</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.formatSettingsCABAC\"\n                                                   id=\"formatSettingsCABACInput\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Format Settings Reference Frames</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.formatSettingsRefFrames\"\n                                                   id=\"formatSettingsRefFramesInput\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Format Settings GOP</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.formatSettingsGOP\"\n                                                   id=\"formatSettingsGOPInput\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Codec</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.codec\" id=\"codecInput\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Chroma\n                                            Sub-Sampling</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.chromaSubsampling\"\n                                                   id=\"chromaSubsamplingInput\"/></div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Standard</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.standard\"\n                                                   id=\"standardInput\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Scan Order</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.scanOrder\"\n                                                   id=\"scanOrderInput\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Frame Count</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.frameCount\"\n                                                   id=\"frameCountInput\"/></div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Frame Rate</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.frameRate\"\n                                                   id=\"frameRateInput\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">\n                                            Frame Rate Mode\n                                        </label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input class=\"prism-text-input\"\n                                                   id=\"frameRateModeInput\"\n                                                   ng-model=\"$ctrl.editData.frameRateMode\"\n                                                   type=\"text\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">\n                                            Frame Rate Numerator\n                                        </label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input class=\"prism-text-input\"\n                                                   id=\"frameRateNumInput\"\n                                                   ng-model=\"$ctrl.editData.frameRateNum\"\n                                                   type=\"text\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">\n                                            Frame Rate Denominator\n                                        </label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input class=\"prism-text-input\"\n                                                   id=\"frameRateDenInput\"\n                                                   ng-model=\"$ctrl.editData.frameRateDen\"\n                                                   type=\"text\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label for=\"dropFrameInput\"\n                                               class=\"col-md-3 control-label\">Timecode Format</label>\n                                        <div class=\"col-sm-4 partner-nielsen-enabled-cb\">\n                                            <dropdown-select\n                                                id=\"dropFrameInput\"\n                                                collection=\"$ctrl.dropframeOptions\"\n                                                ng-model=\"$ctrl.dropFrame\"\n                                                clearable=\"true\"\n                                                label-field=\"name\"\n                                                btn-min-width=\"300\">\n                                            </dropdown-select>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Scan Type</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.scanType\"\n                                                   id=\"scanTypeInput\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Bit Depth</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.bitDepth\"\n                                                   id=\"bitDepthInput\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">\n                                            Bit Rate\n                                        </label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input class=\"prism-text-input\"\n                                                   id=\"bitRateInput\"\n                                                   ng-model=\"$ctrl.editData.bitRate\"\n                                                   type=\"text\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">\n                                            Bit Rate Mode\n                                        </label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input class=\"prism-text-input\"\n                                                   id=\"bitRateModeInput\"\n                                                   ng-model=\"$ctrl.editData.bitRateMode\"\n                                                   type=\"text\"\n                                            />\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Display Aspect\n                                            Ratio</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.displayAspectRatio\"\n                                                   id=\"displayAspectRatioInput\"/></div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Pixel Aspect\n                                            Ratio</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.pixelAspectRatio\"\n                                                   id=\"pixelAspectRatioInput\"/></div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Compression\n                                            Mode</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.compressionMode\"\n                                                   id=\"compressionModeInput\"/></div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Color Space</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.colorSpace\"\n                                                   id=\"colorSpaceInput\"/></div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">Duration</label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input type=\"text\" class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.duration\"\n                                                   id=\"durationInput\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">\n                                            Rotation\n                                        </label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input class=\"prism-text-input\"\n                                                   id=\"rotationInput\"\n                                                   ng-model=\"$ctrl.editData.rotation\"\n                                                   type=\"text\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">\n                                            Color Primaries\n                                        </label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input class=\"prism-text-input\"\n                                                   id=\"colorPrimariesInput\"\n                                                   ng-model=\"$ctrl.editData.colorPrimaries\"\n                                                   type=\"text\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">\n                                            Transfer Characteristics\n                                        </label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input class=\"prism-text-input\"\n                                                   id=\"transferCharacteristicsInput\"\n                                                   ng-model=\"$ctrl.editData.transferCharacteristics\"\n                                                   type=\"text\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">\n                                            Matrix Coefficients\n                                        </label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input class=\"prism-text-input\"\n                                                   id=\"matrixCoefficientsInput\"\n                                                   ng-model=\"$ctrl.editData.matrixCoefficients\"\n                                                   type=\"text\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">\n                                            Original Width\n                                        </label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input id=\"originalWidthInput\"\n                                                   class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.originalWidth\"\n                                                   type=\"text\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">\n                                            Original Height\n                                        </label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input class=\"prism-text-input\"\n                                                   id=\"originalHeightInput\"\n                                                   ng-model=\"$ctrl.editData.originalHeight\"\n                                                   type=\"text\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">\n                                            Width\n                                        </label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input class=\"prism-text-input\"\n                                                   id=\"widthInput\"\n                                                   ng-model=\"$ctrl.editData.width\"\n                                                   type=\"text\"/>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <label class=\"control-label col-md-3\">\n                                            Height\n                                        </label>\n                                        <div class=\"col-sm-4 pad-text-input-col\">\n                                            <input class=\"prism-text-input\"\n                                                   ng-model=\"$ctrl.editData.height\"\n                                                   id=\"heightInput\"\n                                                   type=\"text\"/>\n                                        </div>\n                                    </div>\n                                </div>\n\n                                <hr/>\n\n                                <div ng-include=\"\'system/templates/mediaAcceptProfiles/components/validators/renderers/track-validator-xml-textarea-template.html\'\"></div>\n\n                            </form>\n                        </div>\n                    </fieldset>\n                </div>\n            </div>\n\n            <div class=\"row-no-padding manager-toolbar\">\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\" pagination-defs=\"$ctrl.paginationDefs\"></toolbar>\n            </div>\n        </div>\n        <div class=\"loadingIndicator\">\n            <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                 ng-show=\"$ctrl.loadingIndicator.show\">\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/templates/mediaAcceptProfiles/components/validators/video/searchView/media-accept-profiles-video-validators-search-view-template.html", "<div class=\"edit-full-height\">\n\n        <div id=\"grid\"\n             class=\"grid search-grid\"\n             ui-grid=\"$ctrl.gridOptions\"\n             ui-grid-selection\n             ui-grid-resize-columns>\n        </div>\n\n    <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"\n             right-hand-checkbox-defs=\"$ctrl.toolbarCheckboxDefs\">\n    </toolbar>\n</div>\n");
        $templateCache.put("system/templates/packageAcceptTemplates/editView/mediaAcceptProfileMembers/modals/mediaAcceptProfiles/media-accept-profiles-modal-template.html", "<item-select-modal\n    modal-title=\"\'Select \' + $ctrl.resolve.mediaAcceptProfileType + \' Media Accept Profile(s)\'\"\n    select-button-text=\"\'Select\'\"\n    loading-indicator=\"$ctrl.loadingIndicator\"\n    execute-search=\"$ctrl.executeSearch(searchText)\"\n    on-search-refresh=\"$ctrl.onSearchRefresh(searchText)\"\n\n    grid-is-empty=\"$ctrl.gridOptions.data.length < 1\"\n    on-cancel-clicked=\"$ctrl.cancel()\"\n    on-select-clicked=\"$ctrl.onOK()\"\n    select-button-enabled=\"!$ctrl.disableOKButton()\">\n\n    <div id=\"addMediaAcceptProfileModalGrid\"\n         ui-grid=\"$ctrl.gridOptions\"\n         ui-grid-selection\n         ui-grid-auto-resize></div>\n\n</item-select-modal>\n");
        $templateCache.put("components/branding/editView/components/media/editView/components/asset/branding-media-edit-view-asset-template.html", "<div class=\"edit-view-container branding-asset-container\">\n    <div class=\"prism-form-heading flex-row-container spacer-bottom-lg\">\n        {{$ctrl.sectionName}}\n\n        <!-- Progress -->\n        <div class=\"flex-stretcher\">\n            <div class=\"flex-row-reverse-container\">\n                <div class=\"flex-stretcher\"></div>\n                <div class=\"flex-stretcher\">\n                    <uib-progressbar class=\"progress-striped active\"\n                                     ng-show=\"$ctrl.ingestPercent && $ctrl.ingestPercent >= 0\"\n                                     value=\"$ctrl.ingestPercent\">\n                        {{$ctrl.ingestPercent}}%\n                    </uib-progressbar>\n                </div>\n                <div class=\"flex-stretcher\"></div>\n            </div>\n        </div>\n    </div>\n\n    <branding-file-selector\n        container-type=\"{{$ctrl.containerType}}\"\n        asset-type=\"{{$ctrl.assetType}}\"\n        root-asset=\"$ctrl.rootAsset\"\n        asset=\"$ctrl.asset\"\n        available-accept-profiles=\"$ctrl.availableAcceptProfiles\"\n        include-accept-profile=\"true\"\n        prompt-accept-profile=\"false\"\n        on-ingest-progress=\"$ctrl.onIngestProgress(progress)\"></branding-file-selector>\n\n    <hr/>\n</div>\n\n<hr/>\n");
        $templateCache.put("components/branding/editView/components/media/editView/components/breakPrePostRoll/branding-media-edit-view-break-prepostroll-template.html", "<ng-form class=\"form-horizontal\"\n         role=\"form\"\n         name=\"$ctrl.editorForm\">\n    <branding-media-edit-view-asset\n        section-name=\"PreRoll Video\"\n        container-type=\"{{$ctrl.containerType}}\"\n        asset-type=\"video\"\n        root-asset=\"$ctrl.breakPrePostRoll\"\n        asset=\"$ctrl.breakPrePostRoll.preRoll\">\n    </branding-media-edit-view-asset>\n    <branding-media-edit-view-asset\n        section-name=\"PostRoll Video\"\n        container-type=\"{{$ctrl.containerType}}\"\n        asset-type=\"video\"\n        root-asset=\"$ctrl.breakPrePostRoll\"\n        asset=\"$ctrl.breakPrePostRoll.postRoll\">\n    </branding-media-edit-view-asset>\n\n    <branding-media-edit-view-asset-list\n        section-name=\"PreRoll Closed Captioning\"\n        container-type=\"{{$ctrl.containerType}}\"\n        asset-type=\"cc\"\n        root-asset=\"$ctrl.breakPrePostRoll\"\n        asset-list=\"$ctrl.breakPrePostRoll.preRoll.texts\"\n        prompt-accept-profile=\"false\"\n        available-languages=\"$ctrl.availableLanguages\"\n        available-roles=\"$ctrl.availableTextRoles\"\n        add-asset=\"$ctrl.addPreRollText\"\n        remove-asset=\"$ctrl.removePreRollText\">\n    </branding-media-edit-view-asset-list>\n    <branding-media-edit-view-asset-list\n        section-name=\"PostRoll Closed Captioning\"\n        container-type=\"{{$ctrl.containerType}}\"\n        asset-type=\"cc\"\n        root-asset=\"$ctrl.breakPrePostRoll\"\n        asset-list=\"$ctrl.breakPrePostRoll.postRoll.texts\"\n        prompt-accept-profile=\"false\"\n        available-languages=\"$ctrl.availableLanguages\"\n        available-roles=\"$ctrl.availableTextRoles\"\n        add-asset=\"$ctrl.addPostRollText\"\n        remove-asset=\"$ctrl.removePostRollText\">\n    </branding-media-edit-view-asset-list>\n\n    <branding-media-edit-view-asset-list\n        section-name=\"PreRoll Audio\"\n        container-type=\"{{$ctrl.containerType}}\"\n        asset-type=\"audio\"\n        root-asset=\"$ctrl.breakPrePostRoll\"\n        asset-list=\"$ctrl.breakPrePostRoll.preRoll.audios\"\n        prompt-accept-profile=\"true\"\n        available-accept-profiles=\"$ctrl.availableAudioAcceptProfiles\"\n        available-languages=\"$ctrl.availableLanguages\"\n        available-roles=\"$ctrl.availableAudioRoles\"\n        add-asset=\"$ctrl.addPreRollAudio\"\n        remove-asset=\"$ctrl.removePreRollAudio\">\n    </branding-media-edit-view-asset-list>\n    <branding-media-edit-view-asset-list\n        section-name=\"PostRoll Audio\"\n        container-type=\"{{$ctrl.containerType}}\"\n        asset-type=\"audio\"\n        root-asset=\"$ctrl.breakPrePostRoll\"\n        asset-list=\"$ctrl.breakPrePostRoll.postRoll.audios\"\n        prompt-accept-profile=\"true\"\n        available-accept-profiles=\"$ctrl.availableAudioAcceptProfiles\"\n        available-languages=\"$ctrl.availableLanguages\"\n        available-roles=\"$ctrl.availableAudioRoles\"\n        add-asset=\"$ctrl.addPostRollAudio\"\n        remove-asset=\"$ctrl.removePostRollAudio\">\n    </branding-media-edit-view-asset-list>\n</ng-form>\n");
        $templateCache.put("components/branding/editView/components/media/editView/components/brandingFileSelector/branding-file-selector-template.html", "<div class=\"branding-file-selector-container flex-col-container\">\n    <ng-form role=\"form\" name=\"$ctrl.editorForm\">\n\n        <!-- Close Button -->\n        <button type=\"button\"\n                class=\"close\"\n                ng-if=\"$ctrl.canRemove\"\n                ng-click=\"$ctrl.removeAsset()\">\n            <i class=\"fa fa-close\"></i>\n        </button>\n\n        <!-- Media Accept Profile -->\n        <div class=\"flex-row-container\"\n             ng-if=\"$ctrl.includeAcceptProfile\">\n            <div class=\"flex-stretcher\"></div>\n            <div class=\"flex-stretcher flex-row-container map-container\">\n                <label for=\"assetName\" class=\"control-label padding-right-sm\">\n                    Media Accept Profile:\n                </label>\n                <div class=\"input-background-placeholder margin-right-lg map-label\"\n                     ng-if=\"!$ctrl.promptAcceptProfile\">\n                    <p id=\"assetName\" uib-tooltip=\"{{$ctrl.getCorrespondingAcceptProfileName()}}\"\n                       data-tooltip-append-to-body=\"true\"\n                       class=\"prism-form-control-static ng-binding\">{{$ctrl.getCorrespondingAcceptProfileName()}}</p>\n                </div>\n                <dropdown-select\n                    ng-if=\"$ctrl.promptAcceptProfile\"\n                    collection=\"$ctrl.availableAcceptProfiles\"\n                    ng-model=\"$ctrl.asset.acceptProfile\"\n                    label-field=\"name\"\n                    required\n                    btn-min-width=\"450\">\n                </dropdown-select>\n            </div>\n            <div class=\"flex-stretcher\"></div>\n        </div>\n\n        <!-- File Ingest -->\n        <div class=\"flex-row-container branding-file-ingest-row\">\n\n            <!-- Upload -->\n            <file-select ng-model=\"$ctrl.file\"\n                         ng-change=\"$ctrl.onFileChanged()\"\n                         ng-disabled=\"!$ctrl.canSelectFile()\"\n                         required\n                         validate-local-mime-types=\"true\"\n                         get-file-extensions=\"$ctrl.getFileExtensions()\"\n                         get-local-file-pre-validation-errors=\"$ctrl.getLocalFilePreValidationErrors(file, filter)\"\n                         initialize-uploader-config=\"$ctrl.initializeLocalUploaderConfig(fileUploaderConfig)\"\n                         validate-remote-file=\"$ctrl.validateRemoteFile(fileSystemItem)\"\n                         validate-local-file=\"$ctrl.validateLocalFile(fileItem)\"\n                >\n            </file-select>\n\n            <!-- File Info -->\n            <div class=\"file-info-container flex-stretcher flex-truncate-text flex-row-container padding-left-md\">\n                <div class=\"input-background-placeholder flex-stretcher flex-truncate-text\"\n                     ng-class=\"{\'invalid\': !$ctrl.assetFileIsValid()}\">\n                    <p uib-tooltip=\"{{$ctrl.asset.virtualPath | fileNameFromPath}}\"\n                       data-tooltip-append-to-body=\"true\"\n                       class=\"prism-form-control-static flex-truncate-text ng-binding\">{{$ctrl.asset.virtualPath | fileNameFromPath}}</p>\n                </div>\n\n                <div class=\"fa error-warning-triangle\"\n                     ng-if=\"$ctrl.getAssetError()\">\n                    <span class=\"fa-stack\"\n                          uib-tooltip=\"{{$ctrl.getAssetError()}}\">\n                        <i class=\"fa fa-square fa-stack-1x\"></i>\n                        <i class=\"fa fa-exclamation-triangle fa-stack-1x\"></i>\n                    </span>\n                </div>\n                <div class=\"fa play-icon\"\n                     ng-if=\"$ctrl.assetHasPreview()\">\n                    <span class=\"fa-stack\">\n                        <a ng-click=\"$ctrl.openAssetPreviewModal()\">\n                            <i class=\"fa fa-circle-thin fa-stack-1x\"></i>\n                            <i class=\"fa fa-play fa-stack-1x\"></i>\n                        </a>\n                    </span>\n                </div>\n\n                <a class=\"fa fa-info-circle fa-2x prism-into-button asset-info-button\"\n                   ng-if=\"$ctrl.assetHasInfo()\"\n                   ng-click=\"$ctrl.openAssetInfoModal()\">\n                </a>\n            </div>\n\n            <!-- Extra Properties -->\n            <fieldset class=\"file-properties-container\"\n                      ng-disabled=\"!$ctrl.assetFileIsValid()\">\n                <div class=\"flex-stretcher flex-row-container\">\n                    <ng-transclude ng-transclude-slot=\"properties\"></ng-transclude>\n                </div>\n            </fieldset>\n        </div>\n    </ng-form>\n</div>\n");
        $templateCache.put("components/branding/editView/components/media/editView/components/assetList/branding-media-edit-view-asset-list-template.html", "<div class=\"edit-view-container branding-asset-list-container\">\n    <ng-form role=\"form\" name=\"$ctrl.editorForm\">\n        <div class=\"prism-form-heading flex-row-container padding-right-md spacer-bottom-lg\">\n            {{$ctrl.sectionName}}\n\n            <!-- Progress -->\n            <div class=\"flex-stretcher\">\n                <div class=\"flex-row-reverse-container\">\n                    <div class=\"flex-stretcher\"></div>\n                    <div class=\"flex-stretcher\">\n                        <uib-progressbar class=\"progress-striped active\"\n                                         ng-show=\"$ctrl.ingestPercent && $ctrl.ingestPercent >= 0\"\n                                         value=\"$ctrl.ingestPercent\">\n                            {{$ctrl.ingestPercent}}%\n                        </uib-progressbar>\n                    </div>\n                    <div class=\"flex-stretcher\"></div>\n                </div>\n            </div>\n\n            <!-- Add Button -->\n            <button type=\"button\"\n                    class=\"btn btn-default prism-button\"\n                    ng-click=\"$ctrl.addAsset()\">\n                Add\n            </button>\n        </div>\n\n        <div ng-repeat=\"(index, asset) in $ctrl.assetList\">\n\n            <branding-file-selector\n                ng-class=\"{\'invalid\': !!$ctrl.getExtraAssetPropertiesError(index)}\"\n                container-type=\"{{$ctrl.containerType}}\"\n                asset-type=\"{{$ctrl.assetType}}\"\n                root-asset=\"$ctrl.rootAsset\"\n                asset=\"asset\"\n                include-accept-profile=\"$ctrl.assetContainsAcceptProfile()\"\n                prompt-accept-profile=\"$ctrl.promptAcceptProfile\"\n                available-accept-profiles=\"$ctrl.availableAcceptProfiles\"\n                on-ingest-progress=\"$ctrl.onIngestProgress(asset, progress)\"\n                on-file-selected=\"$ctrl.updateValidity()\"\n                extra-properties-error=\"$ctrl.getExtraAssetPropertiesError(index)\"\n                can-remove=\"true\"\n                on-remove-clicked=\"$ctrl.removeAsset(index)\">\n                <branding-file-selector-properties>\n                    <dropdown-select\n                        ng-if=\"$ctrl.availableLanguages\"\n                        id=\"{{$ctrl.sectionName + \'Languages\' + index}}\"\n                        class=\"margin-right-md\"\n                        collection=\"$ctrl.availableLanguages\"\n                        ng-model=\"asset.language\"\n                        ng-change=\"$ctrl.updateValidity()\"\n                        required\n                        prompt=\"Select Language\"\n                        label-field=\"name\"\n                        sort-collection=\"false\"\n                        btn-min-width=\"150\">\n                    </dropdown-select>\n\n                    <div class=\"flex-col-container height-100\">\n                        <dropdown-select\n                            ng-if=\"$ctrl.availableRatingSystems\"\n                            id=\"{{$ctrl.sectionName + \'RatingSystem\' + index}}\"\n                            class=\"margin-right-md\"\n                            collection=\"$ctrl.availableRatingSystems\"\n                            ng-disabled=\"!asset.virtualPath\"\n                            ng-model=\"$ctrl.selectedRatingSystems[index]\"\n                            ng-change=\"$ctrl.onRatingSystemChanged(asset)\"\n                            prompt=\"Select Rating System\"\n                            label-field=\"systemCode\"\n                            sort-collection=\"false\"\n                            btn-min-width=\"150\">\n                        </dropdown-select>\n\n                        <span class=\"top-margin-sm\"></span>\n\n                        <div class=\"flex-row-container\">\n                            <dropdown-select\n                                    ng-if=\"$ctrl.availableRatingSystems\"\n                                    id=\"{{$ctrl.sectionName + \'Ratings\' + index}}\"\n                                    class=\"margin-right-md\"\n                                    collection=\"$ctrl.selectedRatingSystems[index].ratingCodes\"\n                                    ng-disabled=\"!asset.virtualPath\"\n                                    ng-model=\"asset.rating.ratingCode\"\n                                    ng-change=\"$ctrl.updateValidity()\"\n                                    clearable=\"true\"\n                                    prompt=\"Select Rating\"\n                                    label-field=\"ratingCode\"\n                                    sort-collection=\"false\"\n                                    btn-min-width=\"150\">\n                            </dropdown-select>\n                            &nbsp;\n                            <multiselect-dropdown\n                                ng-disabled=\"!asset.virtualPath || !$ctrl.availableRatingSystems || !$ctrl.selectedRatingSystems[index].advisoryCodes.length\"\n                                id=\"{{$ctrl.sectionName + \'RatingDescriptors\' + index}}\"\n                                class=\"margin-right-md\"\n                                collection=\"$ctrl.selectedRatingSystems[index].advisoryCodes\"\n                                ng-disabled=\"!asset.virtualPath\"\n                                ng-model=\"asset.rating.ratingAdvisoryCodes\"\n                                ng-change=\"$ctrl.updateValidity()\"\n                                clearable=\"false\"\n                                prompt=\"Select Advisories\"\n                                label-field=\"description\"\n                                btn-min-width=\"150\"\n                                sort-collection=\"false\"\n                                max-height=\"375\">\n                            </multiselect-dropdown>\n                        </div>\n                    </div>\n\n                    <dropdown-select\n                        ng-if=\"$ctrl.availableRoles\"\n                        id=\"{{$ctrl.sectionName + \'Roles\' + index}}\"\n                        class=\"margin-right-md\"\n                        collection=\"$ctrl.availableRoles\"\n                        ng-model=\"asset.role\"\n                        ng-change=\"$ctrl.updateValidity()\"\n                        required\n                        prompt=\"Select Role\"\n                        label-field=\"name\"\n                        sort-collection=\"false\"\n                        btn-min-width=\"150\">\n                    </dropdown-select>\n\n                    <multiselect-dropdown\n                        ng-if=\"$ctrl.availableTerritories\"\n                        id=\"{{$ctrl.sectionName + \'Territories\' + index}}\"\n                        class=\"margin-right-md\"\n                        collection=\"$ctrl.availableTerritories\"\n                        ng-model=\"asset.territories\"\n                        ng-change=\"$ctrl.updateValidity()\"\n                        clearable=\"false\"\n                        prompt=\"Select Territories\"\n                        label-field=\"name\"\n                        btn-min-width=\"150\"\n                        sort-collection=\"false\"\n                        max-height=\"375\">\n                    </multiselect-dropdown>\n                </branding-file-selector-properties>\n            </branding-file-selector>\n\n        </div>\n        <hr/>\n    </ng-form>\n</div>\n\n<hr/>\n");
        $templateCache.put("meta/content/editor/components/view/packageAcceptTemplates/content-package-accept-templates-member-view-component/member-grid-component/member-grid-template.html", "<div class=\"container-fluid\">\n\n    <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n        <div class=\"form-group metadata-control-col\">\n            <dropdown-select id=\"validationTypeDropDown\"\n                             btn-min-width=\"200\"\n                             collection=\"$ctrl.availableValidationTypes\"\n                             label-field=\"displayName\"\n                             ng-model=\"$ctrl.validationType\"\n                             prompt=\"Select Validation Type\"\n                             ng-change=\"$ctrl.onValidationTypeChanged()\"\n                             ng-disabled=\"$ctrl.mediaAcceptProfileType === \'VIDEO\'\">\n            </dropdown-select>\n\n                <label class=\"under-field-hint\"\n                       ng-if=\"$ctrl.validationType.id === \'NOT_APPLICABLE\'\">\n                     <i class=\"fa fa-warning\"></i> All selections will be cleared upon save when the validation type is set to \"Not Applicable\"\n                </label>\n        </div>\n        <div class=\"form-group\">\n            <fieldset ng-disabled=\"$ctrl.validationType.id === \'NOT_APPLICABLE\'\">\n                <div id=\"contentPackageAcceptTemplateMembersGrid\"\n                     class=\"grid protected-grid\"\n                     ng-if=\"$ctrl.mediaAcceptProfiles\"\n                     ui-grid=\"$ctrl.gridOptions\"\n                     ui-grid-selection\n                     style=\"max-height: 205px;\"\n                     ui-grid-resize-columns>\n                </div>\n            </fieldset>\n        </div>\n    </form>\n\n\n</div>\n");
        $templateCache.put("meta/content/editor/components/view/seasonvolume/searchView/gridTemplates/seasonvolume-name-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\" data-tooltip-append-to-body=\"true\"\n	 uib-tooltip=\"{{COL_FIELD | seasonVolumeNameFilter: this}}\">\n	<span>{{COL_FIELD | seasonVolumeNameFilter: this}}</span>\n</div>\n");
        $templateCache.put("package/editor/components/view/media/assetSelector/videoMain/hdrXml/package-media-hdr-xml-asset-selector-template.html", "<div class=\"package-media-asset-selector flex-row-container clearfix\">\n\n    <!-- File upload -->\n    <file-select ng-model=\"$ctrl.currentFile\"\n                 ng-change=\"$ctrl.onCurrentFileChanged()\"\n                 ng-disabled=\"!$ctrl.canIngestHdrXml()\"\n                 get-file-extensions=\"$ctrl.getFileExtensions()\"\n                 get-local-file-pre-validation-errors=\"$ctrl.getLocalFilePreValidationErrors(file, filter)\"\n                 initialize-uploader-config=\"$ctrl.initializeLocalUploaderConfig(fileUploaderConfig)\"\n                 remote-upload-enabled=\"$ctrl.remoteUploadEnabled()\"\n                 validate-remote-file=\"$ctrl.validateRemoteFile(fileSystemItem)\"\n                 validate-aspera-file=\"$ctrl.validateAsperaFile(asperaFileObject)\"\n                 validate-local-file=\"$ctrl.validateLocalFile(fileItem, fileUploaderConfig)\"\n                 drag-drop-source=\"\'LOCAL\'\"\n                 drag-drop-id=\"\'main_video_hdr_xml\'\">\n    </file-select>\n\n    <span class=\"horizontal-spacer-10\"></span>\n\n    <!-- Asset MAP selection -->\n    <div class=\"asset-map-area flex-row-container clearfix\">\n        <!-- No per-asset MAP selection for main video asset -->\n    </div>\n\n    <!-- Asset path -->\n    <span>\n        <label class=\"prism-form-item-label text-align-right\"\n               for=\"videoHdrXmlFileInput\">\n            HDR 10<br/>\n            ST 2086<br/>\n            XML\n        </label>\n    </span>\n\n    &nbsp;\n\n    <span class=\"prism-form-control-static input-background-placeholder flex-stretcher asset-virtual-path\"\n          id=\"videoHdrXmlFileInput\"\n          uib-tooltip=\"{{$ctrl.getMainVideo().hdrMetadataPath | fileNameFromPath}}\"\n          ng-model=\"$ctrl.getMainVideo().hdrMetadataPath\"\n          data-tooltip-append-to-body=\"true\">\n        <!--\n            Note - by having an ngModel and the \"required\"\n            directive, the virtualPath property is enrolled in\n            form validation.\n        -->\n        {{$ctrl.getMainVideo().hdrMetadataPath | fileNameFromPath}}\n    </span>\n\n    <!-- Asset info -->\n    <a id=\"videoHdrXmlFileInfo\"\n       class=\"fa fa-info-circle fa-2x prism-into-button asset-info-button\"\n       ng-click=\"$ctrl.onViewAssetButtonClick($event)\">\n    </a>\n\n    <span class=\"asset-qc-notes-button\">\n    </span>\n\n    <span class=\"asset-errors-and-warnings-indicator\">\n        <!-- Main video has no errors/warnings -->\n        &nbsp;\n    </span>\n\n    <span class=\"horizontal-spacer-10\"></span>\n\n    <div class=\"asset-role-area flex-row-container\">\n        <!--\n            No asset-level language/role selection for main video\n        -->\n    </div>\n\n    <span class=\"horizontal-spacer-10\"></span>\n\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryEndpoints/searchView/modals/new-delivery-endpoint-modal-template.html", "<div class=\"modal-header\">\n    <h5 class=\"modal-title\">Create Partner Delivery Endpoint</h5>\n</div>\n\n<div class=\"modal-body\">\n    <form class=\"form-horizontal\"\n          role=\"form\"\n          name=\"$ctrl.modalForm\">\n\n        <div class=\"row spacer-top-xsm padding-bottom-xsm\">\n            <div class=\"form-group no-margin-bottom\">\n                <label for=\"newEndpointTypeDropdown\"\n                       class=\"col-md-4 col-md-offset-1 control-label\">\n                    Type\n                </label>\n                <div class=\"col-md-4 metadata-control-col\">\n                    <dropdown-select id=\"newEndpointTypeDropdown\"\n                                     ng-model=\"$ctrl.selectedEndpointType\"\n                                     label-function=\"$ctrl.getLabel\"\n                                     prompt=\"Select Endpoint Type\"\n                                     btn-min-width=\"200\"\n                                     clearable=\"true\"\n                                     collection=\"$ctrl.supportedEndpointTypes\">\n                    </dropdown-select>\n                </div>\n            </div>\n        </div>\n\n    </form>\n</div>\n\n<div class=\"modal-footer flex-row-container\">\n    <button class=\"btn btn-sm btn-default pull-left\"\n            ng-click=\"$ctrl.onCancel()\">\n        Cancel\n    </button>\n\n    <div class=\"flex-stretcher\">\n    </div>\n\n    <button class=\"btn btn-sm btn-default\"\n            ng-click=\"$ctrl.onCreate()\"\n            ng-disabled=\"!$ctrl.canCreate()\">\n        Create\n    </button>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryEndpoints/searchView/cellTemplates/endpoint-type-cell-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\" data-tooltip-append-to-body=\"true\" uib-tooltip=\"{{COL_FIELD CUSTOM_FILTERS}}\" ng-dblclick=\"grid.appScope.$ctrl.rowDoubleClick(row, column)\">\n	<span class=\"padding-left-sm\">{{COL_FIELD CUSTOM_FILTERS}}</span>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryEndpoints/editor/renderers/partner-deliveryendpoints-editor-apple-news-template.html", "<!--\n\n	\"AppleNews\" delivery endpoint editor / delivery section template\n\n-->\n\n<div>\n    <div class=\"row clearfix\">\n        <div class=\"col-md-12 column\">\n            <div class=\"row\">\n                <div class=\"col-md-2\">\n                    <div class=\"prism-form-heading\">\n                        Delivery\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n                <form class=\"form-horizontal\"\n                      role=\"form\">\n\n                    <!-- Channel ID -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAppleNewsUserName\">\n                                Channel ID\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointAppleNewsUserName\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.channelId\"/>\n                            </div>\n                            <div class=\"required-select\"\n                                 required\n                                 x-required-indicator>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Channel Key -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAppleNewsKey\">\n                                Channel Key\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointAppleNewsKey\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.apiKeyId\"/>\n                            </div>\n                            <div class=\"required-select\"\n                                 required\n                                 x-required-indicator>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Channel Secret -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAppleNewsScret\">\n                                Channel Secret\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointAppleNewsScret\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.apiKeySecret\"/>\n                            </div>\n                            <div class=\"required-select\"\n                                 required\n                                 x-required-indicator>\n                            </div>\n                        </div>\n                    </div>\n\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryEndpoints/editor/renderers/partner-deliveryendpoints-editor-aspera-cli-template.html", "<!--\n\n    \"Aspera CLI\" delivery endpoint editor / delivery section\n    template\n\n-->\n\n<div>\n    <div class=\"row clearfix\">\n        <div class=\"col-md-12 column\">\n            <div class=\"row\">\n                <div class=\"col-md-2\">\n                    <div class=\"prism-form-heading\">\n                        Delivery\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n                <form class=\"form-horizontal\"\n                      role=\"form\">\n\n                    <!-- Host -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAsperaCLIHost\">\n                                Host\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointAsperaCLIHost\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.serverAddress\"/>\n                            </div>\n                            <div class=\"required-select\"\n                                 required\n                                 x-required-indicator>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Port -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAsperaCLIPort\">\n                                Port\n                            </label>\n\n                            <div class=\"col-sm-2 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointAsperaCLIPort\"\n                                       ng-keydown=\"$ctrl.numericFieldKeyDown($event, $ctrl.endpointObject.tcpPort)\"\n                                       autocomplete=\"off\"\n                                       ng-model=\"$ctrl.endpointObject.port\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Username -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAsperaCLIUsername\">\n                                Username\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointAsperaCLIUsername\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.userName\"/>\n                            </div>\n                            <div class=\"required-select\"\n                                 required\n                                 x-required-indicator>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Password -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAsperaCLIPassword\">\n                                Password\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointAsperaCLIPassword\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.password\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Path -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAsperaCLIPath\">\n                                Path\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointAsperaCLIPath\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.path\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Minimum Rate (kbps) -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAsperaCLIMinimumRate\">\n                                Minimum Rate (kbps)\n                            </label>\n\n                            <div class=\"col-sm-2 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointAsperaCLIMinimumRate\"\n                                       ng-keydown=\"$ctrl.numericFieldKeyDown($event, $ctrl.endpointObject.minTransferRate)\"\n                                       autocomplete=\"off\"\n                                       ng-model=\"$ctrl.endpointObject.minTransferRate\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Target Rate (kbps) -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAsperaCLITargetRate\">\n                                Target Rate (kbps)\n                            </label>\n\n                            <div class=\"col-sm-2 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointAsperaCLITargetRate\"\n                                       ng-keydown=\"$ctrl.numericFieldKeyDown($event, $ctrl.endpointObject.targetTransferRate)\"\n                                       autocomplete=\"off\"\n                                       ng-model=\"$ctrl.endpointObject.targetTransferRate\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Rate Policy -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAsperaCLIRatePolicy\">\n                                Rate Policy\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <dropdown-select\n                                    id=\"endpointAsperaCLIRatePolicy\"\n                                    collection=\"$ctrl.asperaCLIRatePolicies\"\n                                    ng-model=\"$ctrl.endpointObject.ratePolicy\"\n                                    model-prop=\"value\"\n                                    label-field=\"label\"\n                                    value-prop=\"label\"\n                                    sort-collection=\"false\"\n                                    prompt=\"Select a Policy\">\n                                </dropdown-select>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Cipher -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAsperaCLICipher\">\n                                Transfer Policy\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <dropdown-select\n                                    id=\"endpointAsperaCLICipher\"\n                                    collection=\"$ctrl.asperaCLICiphers\"\n                                    ng-model=\"$ctrl.endpointObject.cipher\"\n                                    model-prop=\"value\"\n                                    label-field=\"label\"\n                                    value-prop=\"label\"\n                                    sort-collection=\"false\"\n                                    prompt=\"Select a Policy\">\n                                </dropdown-select>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Insecure -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAsperaCLIInsecure\">\n                                Insecure\n                            </label>\n\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input type=\"checkbox\"\n                                       id=\"endpointAsperaCLIInsecure\"\n                                       ng-model=\"$ctrl.endpointObject.insecureFlag\"/>\n                                <label for=\"endpointAsperaCLIInsecure\"\n                                       class=\"control-label\">\n                                </label>\n                            </div>\n                        </div>\n                    </div>\n\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryEndpoints/editor/renderers/partner-deliveryendpoints-editor-aspera-template.html", "<!--\n\n    \"Aspera\", \"Aspera Key\", \"Netflix\" delivery endpoint editor /\n    delivery section template\n\n-->\n\n<div>\n    <div class=\"row clearfix\">\n        <div class=\"col-md-12 column\">\n            <div class=\"row\">\n                <div class=\"col-md-2\">\n                    <div class=\"prism-form-heading\">\n                        Delivery\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n                <form class=\"form-horizontal\"\n                      role=\"form\">\n\n                    <!-- Host -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAsperaHost\">\n                                Host\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointAsperaHost\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.serverAddress\"/>\n                            </div>\n                            <div class=\"required-select\"\n                                 required\n                                 x-required-indicator>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- TCP Port -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAsperaTcpPort\">\n                                TCP Port\n                            </label>\n\n                            <div class=\"col-sm-2 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointAsperaTcpPort\"\n                                       ng-keydown=\"$ctrl.numericFieldKeyDown($event, $ctrl.endpointObject.tcpPort)\"\n                                       autocomplete=\"off\"\n                                       ng-model=\"$ctrl.endpointObject.tcpPort\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- UDP Port -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAsperaUdpPort\">\n                                UDP Port\n                            </label>\n\n                            <div class=\"col-sm-2 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointAsperaUdpPort\"\n                                       ng-keydown=\"$ctrl.numericFieldKeyDown($event, $ctrl.endpointObject.udpPort)\"\n                                       autocomplete=\"off\"\n                                       ng-model=\"$ctrl.endpointObject.udpPort\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Username -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAsperaUsername\">\n                                Username\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointAsperaUsername\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.userName\"/>\n                            </div>\n                            <div class=\"required-select\"\n                                 required\n                                 x-required-indicator>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Password -->\n                    <div class=\"row-no-padding\"\n                         ng-if=\"$ctrl.endpointType === \'aspera\'\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAsperaPassword\">\n                                Password\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointAsperaPassword\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.password\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Passphrase -->\n                    <div class=\"row-no-padding\"\n                         ng-if=\"$ctrl.endpointType === \'aspera_key\'\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAsperaPassphrase\">\n                                Passphrase\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointAsperaPassphrase\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.passphrase\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Private Key -->\n                    <div class=\"row-no-padding\"\n                         ng-if=\"$ctrl.endpointType === \'aspera_key\'\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAsperaPrivateKey\">\n                                Private Key\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointAsperaPrivateKey\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.privateKey\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- GDPR Enabled -->\n                    <div class=\"row-no-padding\"\n                         ng-if=\"$ctrl.endpointType === \'aspera\'\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAsperaGDPREnabled\">\n                                GDPR Enabled\n                            </label>\n\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input type=\"checkbox\"\n                                       id=\"endpointAsperaGDPREnabled\"\n                                       ng-model=\"$ctrl.endpointObject.generalDataProtectionRegulationFlag\"/>\n                                <label for=\"endpointAsperaGDPREnabled\"\n                                       class=\"control-label\">\n                                </label>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Private Key Filename -->\n                    <div class=\"row-no-padding\"\n                         ng-if=\"$ctrl.endpointType === \'aspera\'\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAsperaPrivateKeyFilename\">\n                                Private Key Filename\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointAsperaPrivateKeyFilename\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.privateKeyFilename\"/>\n                            </div>\n                            <span ng-if=\"$ctrl.endpointObject.generalDataProtectionRegulationFlag\">\n                                <div class=\"required-select\"\n                                     required\n                                     x-required-indicator>\n                                </div>\n                            </span>\n                        </div>\n                    </div>\n\n                    <!-- Path -->\n                    <div class=\"row-no-padding\"\n                         ng-if=\"$ctrl.endpointType !== \'netflix\'\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAsperaPath\">\n                                Path\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointAsperaPath\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.path\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Transfer Policy -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAsperaTransferPolicy\">\n                                Transfer Policy\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <dropdown-select\n                                    id=\"endpointAsperaTransferPolicy\"\n                                    collection=\"$ctrl.asperaTransferPolicies\"\n                                    ng-model=\"$ctrl.endpointObject.transferPolicy\"\n                                    model-prop=\"value\"\n                                    label-field=\"label\"\n                                    value-prop=\"label\"\n                                    sort-collection=\"false\"\n                                    prompt=\"Select a Policy\">\n                                </dropdown-select>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Resume Transfer -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAsperaResumeTransfer\">\n                                Resume Transfer\n                            </label>\n\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <dropdown-select\n                                    id=\"endpointAsperaResumeTransfer\"\n                                    collection=\"$ctrl.asperaResumePolicies\"\n                                    ng-model=\"$ctrl.endpointObject.resumePolicy\"\n                                    model-prop=\"value\"\n                                    label-field=\"label\"\n                                    value-prop=\"label\"\n                                    sort-collection=\"false\"\n                                    prompt=\"Select a Policy\">\n                                </dropdown-select>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Minimum Rate (kbps) -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAsperaMinimumRate\">\n                                Minimum Rate (kbps)\n                            </label>\n\n                            <div class=\"col-sm-2 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointAsperaMinimumRate\"\n                                       ng-keydown=\"$ctrl.numericFieldKeyDown($event, $ctrl.endpointObject.minTransferRate)\"\n                                       autocomplete=\"off\"\n                                       ng-model=\"$ctrl.endpointObject.minTransferRate\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Target Rate (kbps) -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAsperaTargetRate\">\n                                Target Rate (kbps)\n                            </label>\n\n                            <div class=\"col-sm-2 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointAsperaTargetRate\"\n                                       ng-keydown=\"$ctrl.numericFieldKeyDown($event, $ctrl.endpointObject.targetTransferRate)\"\n                                       autocomplete=\"off\"\n                                       ng-model=\"$ctrl.endpointObject.targetTransferRate\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Encryption -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAsperaEncryption\">\n                                Encryption\n                            </label>\n\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input type=\"checkbox\"\n                                       id=\"endpointAsperaEncryption\"\n                                       ng-model=\"$ctrl.endpointObject.fileEncryption\"/>\n                                <label for=\"endpointAsperaEncryption\"\n                                       class=\"control-label\">\n                                </label>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Content Encryption Password -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAsperaContentEncryptionPassword\">\n                                Content Encryption Password\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointAsperaContentEncryptionPassword\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.contentProtectionPassphrase\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Storage URL -->\n                    <div class=\"row-no-padding\"\n                         ng-if=\"$ctrl.endpointType !== \'netflix\'\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAsperaStorageUrl\">\n                                Storage URL\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointAsperaStorageUrl\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.storageUrl\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Storage Key -->\n                    <div class=\"row-no-padding\"\n                         ng-if=\"$ctrl.endpointType !== \'netflix\'\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointAsperaStorageKey\">\n                                Storage Key\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointAsperaStorageKey\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.storageKey\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Netflix SSH Key File -->\n                    <div class=\"row-no-padding\"\n                         ng-if=\"$ctrl.endpointType === \'netflix\'\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointNetflixSSHKeyFile\">\n                                Netflix SSH Key File\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointNetflixSSHKeyFile\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.netflixSSHKeyFilename\"/>\n                            </div>\n                            <div class=\"required-select\"\n                                 required\n                                 x-required-indicator></div>\n                        </div>\n                    </div>\n\n                    <!-- Netflix Client ID -->\n                    <div class=\"row-no-padding\"\n                         ng-if=\"$ctrl.endpointType === \'netflix\'\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointNetflixClientId\">\n                                Netflix Client ID\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointNetflixClientId\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.netflixClientId\"/>\n                            </div>\n                            <div class=\"required-select\"\n                                 required\n                                 x-required-indicator></div>\n                        </div>\n                    </div>\n\n                    <!-- Netflix Client Secret -->\n                    <div class=\"row-no-padding\"\n                         ng-if=\"$ctrl.endpointType === \'netflix\'\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointNetflixClientSecret\">\n                                Netflix Client Secret\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointNetflixClientSecret\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.netflixClientSecret\"/>\n                            </div>\n                            <div class=\"required-select\"\n                                 required\n                                 x-required-indicator></div>\n                        </div>\n                    </div>\n\n                    <!-- Netflix Password -->\n                    <div class=\"row-no-padding\"\n                         ng-if=\"$ctrl.endpointType === \'netflix\'\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointNetflixPassword\">\n                                Netflix Password\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointNetflixPassword\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.netflixPassword\"/>\n                            </div>\n                            <div class=\"required-select\"\n                                 required\n                                 x-required-indicator></div>\n                        </div>\n                    </div>\n\n                    <!--\n                        ...someday we could expose the Netflix\n                        Delivery Info Expression field here...\n                        for now it\'s hardcoded in the controller\n                    -->\n\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryEndpoints/editor/renderers/partner-deliveryendpoints-editor-ftp-template.html", "<!--\n\n	\"FTP\" delivery endpoint editor / delivery section template\n\n-->\n\n<div>\n    <div class=\"row clearfix\">\n        <div class=\"col-md-12 column\">\n            <div class=\"row\">\n                <div class=\"col-md-2\">\n                    <div class=\"prism-form-heading\">\n                        Delivery\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n                <form class=\"form-horizontal\"\n                      role=\"form\">\n\n                    <!-- User Name -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointFtpUserName\">\n                                User Name\n                            </label>\n\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointFtpUserName\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.userName\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Password -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointFtpPassword\">\n                                Password\n                            </label>\n\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointFtpPassword\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.password\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Server Address -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointFtpServerAddress\">\n                                Server Address\n                            </label>\n\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointFtpServerAddress\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.serverAddress\"/>\n                            </div>\n                            <div class=\"required-select\"\n                                 required\n                                 x-required-indicator>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Server Port -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointFtpServerPort\">\n                                Server Port\n                            </label>\n\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointFtpServerPort\"\n                                       ng-keydown=\"$ctrl.numericFieldKeyDown($event, $ctrl.endpointObject.serverPort)\"\n                                       autocomplete=\"off\"\n                                       ng-model=\"$ctrl.endpointObject.serverPort\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Anonymous -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointFtpAnonymous\">\n                                Anonymous\n                            </label>\n\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input type=\"checkbox\"\n                                       id=\"endpointFtpAnonymous\"\n                                       ng-model=\"$ctrl.endpointObject.anonymousFlag\"/>\n                                <label for=\"endpointFtpAnonymous\"\n                                       class=\"control-label\"></label>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Force Active Connection -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointFtpForceActiveConnection\">\n                                Force Active Connection\n                            </label>\n\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input type=\"checkbox\"\n                                       id=\"endpointFtpForceActiveConnection\"\n                                       ng-model=\"$ctrl.endpointObject.forceActiveConnectionFlag\"/>\n                                <label for=\"endpointFtpForceActiveConnection\"\n                                       class=\"control-label\"></label>\n                            </div>\n                        </div>\n                    </div>\n\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryEndpoints/editor/renderers/partner-deliveryendpoints-editor-general-section-template.html", "<div>\n	<div class=\"row clearfix\">\n		<div class=\"col-md-12 column\">\n			<div class=\"row\">\n				<div class=\"col-md-2\">\n					<div class=\"prism-form-heading\">\n						General\n					</div>\n				</div>\n			</div>\n		</div>\n\n		<div class=\"row clearfix spacer-top-lg\">\n			<div class=\"col-md-12 column\">\n				<form class=\"form-horizontal\"\n					  role=\"form\">\n\n					<!-- Name -->\n					<div class=\"row-no-padding\">\n						<div class=\"form-group v-align\">\n							<label class=\"col-sm-2 control-label\"\n								   for=\"endpointName\">\n								Name\n							</label>\n\n							<div class=\"col-sm-4 pad-text-input-col\">\n								<input type=\"text\"\n									   class=\"form-control input-sm prism-text-input\"\n									   id=\"endpointName\"\n									   autocomplete=\"off\"\n									   ng-model=\"$ctrl.endpointObject.name\"/>\n							</div>\n							<div class=\"required-select\"\n								 required\n								 x-required-indicator></div>\n						</div>\n					</div>\n\n					<!-- Type -->\n					<div class=\"row-no-padding\">\n						<div class=\"form-group v-align\">\n							<label class=\"col-sm-2 control-label\"\n								   for=\"endpointType\">\n								Type\n							</label>\n\n							<div class=\"col-sm-3 pad-text-input-col\">\n								<input type=\"text\"\n									   class=\"form-control input-sm prism-text-input\"\n									   id=\"endpointType\"\n									   autocomplete=\"off\"\n									   ng-value=\"$ctrl.getEndpointTypeLabel($ctrl.endpointObject.type)\"\n									   ng-disabled=\"true\"/>\n							</div>\n						</div>\n					</div>\n\n					<!-- Description -->\n					<div class=\"row-no-padding\">\n						<div class=\"form-group v-align\">\n							<label class=\"col-sm-2 control-label\"\n								   for=\"endpointDescription\">\n								Description\n							</label>\n\n							<div class=\"col-sm-8 pad-text-input-col\">\n								<input type=\"text\"\n									   class=\"form-control input-sm prism-text-input\"\n									   id=\"endpointDescription\"\n									   autocomplete=\"off\"\n									   ng-model=\"$ctrl.endpointObject.description\"/>\n							</div>\n						</div>\n					</div>\n\n					<!-- Max Retries -->\n					<div class=\"row-no-padding\">\n						<div class=\"form-group v-align\">\n							<label class=\"col-sm-2 control-label\"\n								   for=\"endpointMaxRetries\">\n								Max Retries\n							</label>\n\n							<div class=\"col-sm-1 pad-text-input-col\">\n								<input type=\"number\"\n									   class=\"prism-text-input\"\n									   id=\"endpointMaxRetries\"\n									   name=\"endpointMaxRetriesStepper\"\n									   min=\"0\"\n									   max=\"9999\"\n									   step=\"1\"\n									   pattern=\"\\d*\"\n									   ng-change=\"$ctrl.onStepperChanged($ctrl.endpointObject, \'maxRetries\', 0, 9999)\"\n									   ng-model-options=\"{allowInvalid: true}\"\n									   ng-model=\"$ctrl.endpointObject.maxRetries\"/>\n							</div>\n						</div>\n					</div>\n\n					<!-- Bandwidth Warning Rate -->\n					<div class=\"row-no-padding\">\n						<div class=\"form-group v-align\">\n							<label class=\"col-sm-2 control-label\"\n								   for=\"endpointbandwidthThreshold\">\n								Bandwidth Warning Rate\n							</label>\n\n							<div class=\"col-sm-1 pad-text-input-col\">\n								<input type=\"number\"\n									   class=\"prism-text-input\"\n									   id=\"endpointbandwidthThreshold\"\n									   name=\"endpointbandwidthThresholdStepper\"\n									   min=\"0\"\n									   max=\"999999999999\"\n									   step=\"100\"\n									   pattern=\"\\d*\"\n									   ng-change=\"$ctrl.onStepperChanged($ctrl.endpointObject, \'bandwidthThreshold\', 0, 999999999999)\"\n									   ng-model-options=\"{allowInvalid: true}\"\n									   ng-model=\"$ctrl.endpointObject.bandwidthThreshold\"/>\n							</div>\n							<span class=\"control-label text-align-left\">&nbsp;kbps</span>\n						</div>\n					</div>\n\n					<!-- Bandwidth Warning Delay -->\n					<div class=\"row-no-padding\">\n						<div class=\"form-group v-align\">\n							<label class=\"col-sm-2 control-label\"\n								   for=\"endpointBandwidthWarningDelay\">\n								Bandwidth Warning Delay\n							</label>\n\n							<div class=\"col-sm-1 pad-text-input-col\">\n								<input type=\"number\"\n									   class=\"prism-text-input\"\n									   id=\"endpointBandwidthWarningDelay\"\n									   name=\"endpointBandwidthWarningDelayStepper\"\n									   min=\"0\"\n									   max=\"999999\"\n									   step=\"10\"\n									   pattern=\"\\d*\"\n									   ng-change=\"$ctrl.onStepperChanged($ctrl.endpointObject, \'bandwidthWarningDelay\', 0, 999999)\"\n									   ng-model-options=\"{allowInvalid: true}\"\n									   ng-model=\"$ctrl.endpointObject.bandwidthWarningDelay\"/>\n							</div>\n							<span class=\"control-label text-align-left\">&nbsp;seconds</span>\n						</div>\n					</div>\n\n				</form>\n			</div>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryEndpoints/editor/renderers/partner-deliveryendpoints-editor-gs-template.html", "<!--\n\n    \"Google Storage\" delivery endpoint editor / delivery section\n     template\n\n-->\n\n<div>\n    <div class=\"row clearfix\">\n        <div class=\"col-md-12 column\">\n            <div class=\"row\">\n                <div class=\"col-md-2\">\n                    <div class=\"prism-form-heading\">\n                        Delivery\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n                <form class=\"form-horizontal\"\n                      role=\"form\">\n\n                    <!-- GSC Bucket Name -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointGSBucketName\">\n                                Google Storage Bucket Name\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointGSBucketName\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.gSBucket\"/>\n                            </div>\n                            <div class=\"required-select\"\n                                 required\n                                 x-required-indicator>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- GSC Bucket Key -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointGSKey\">\n                                Google Storage Bucket Key\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointGSKey\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.gSKey\"/>\n                            </div>\n                            <div class=\"required-select\"\n                                 required\n                                 x-required-indicator>\n                            </div>\n                        </div>\n                    </div>\n\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryEndpoints/editor/renderers/partner-deliveryendpoints-editor-itunes-template.html", "<!--\n\n    \"iTunes\" delivery endpoint editor / delivery section template\n\n-->\n\n<div>\n    <div class=\"row clearfix\">\n        <div class=\"col-md-12 column\">\n            <div class=\"row\">\n                <div class=\"col-md-2\">\n                    <div class=\"prism-form-heading\">\n                        Delivery\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n                <form class=\"form-horizontal\"\n                      role=\"form\">\n\n                    <!-- Folder -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointITunesFolder\">\n                                Folder\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointITunesFolder\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.networkPath\"/>\n                            </div>\n                            <div class=\"required-select\"\n                                 required\n                                 x-required-indicator>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Username -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointITunesUsername\">\n                                Username\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointITunesUsername\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.userName\"/>\n                            </div>\n                            <div class=\"required-select\"\n                                 required\n                                 x-required-indicator>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Password -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointITunesPassword\">\n                                Password\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointITunesPassword\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.password\"/>\n                            </div>\n                            <div class=\"required-select\"\n                                 required\n                                 x-required-indicator>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Short Name -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointITunesShortName\">\n                                Short Name\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointITunesShortName\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.shortName\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Transport -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointITunesTransport\">\n                                Transport\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <dropdown-select\n                                    id=\"endpointITunesTransport\"\n                                    collection=\"$ctrl.iTunesDeliveryMethods\"\n                                    ng-model=\"$ctrl.endpointObject.deliveryMethod\"\n                                    model-prop=\"value\"\n                                    label-field=\"label\"\n                                    value-prop=\"label\"\n                                    sort-collection=\"false\"\n                                    prompt=\"Select a Policy\">\n                                </dropdown-select>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Upload Speed (kbps) -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointITunesUploadSpeed\">\n                                Upload Speed (kbps)\n                            </label>\n\n                            <div class=\"col-sm-2 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointITunesUploadSpeed\"\n                                       ng-keydown=\"$ctrl.numericFieldKeyDown($event, $ctrl.endpointObject.minTransferRate)\"\n                                       autocomplete=\"off\"\n                                       ng-model=\"$ctrl.endpointObject.transferSpeed\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Log Verbosity -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointITunesLogVerbosity\">\n                                Log Verbosity\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <dropdown-select\n                                    id=\"endpointITunesLogVerbosity\"\n                                    collection=\"$ctrl.iTunesLogLevels\"\n                                    ng-model=\"$ctrl.endpointObject.logLevel\"\n                                    model-prop=\"value\"\n                                    label-field=\"label\"\n                                    value-prop=\"label\"\n                                    sort-collection=\"false\"\n                                    prompt=\"Select a Policy\">\n                                </dropdown-select>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Log Output File -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointITunesLogOutputFile\">\n                                Log Output File\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointITunesLogOutputFile\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.logFileExpr\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Delete On Success -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointITunesDeleteOnSuccess\">\n                                Delete On Success\n                            </label>\n\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input type=\"checkbox\"\n                                       id=\"endpointITunesDeleteOnSuccess\"\n                                       ng-model=\"$ctrl.endpointObject.deleteOnSuccess\"/>\n                                <label for=\"endpointITunesDeleteOnSuccess\"\n                                       class=\"control-label\">\n                                </label>\n                            </div>\n                        </div>\n                    </div>\n\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryEndpoints/editor/renderers/partner-deliveryendpoints-editor-ivi-template.html", "<!--\n\n	\"IVI\" delivery endpoint editor / delivery section template\n\n-->\n\n<div>\n	<div class=\"row clearfix\">\n		<div class=\"col-md-12 column\">\n			<div class=\"row\">\n				<div class=\"col-md-2\">\n					<div class=\"prism-form-heading\">\n						Delivery\n					</div>\n				</div>\n			</div>\n		</div>\n\n		<div class=\"row clearfix spacer-top-lg\">\n			<div class=\"col-md-12 column\">\n				<form class=\"form-horizontal\" role=\"form\">\n\n					<!-- IVI UserName -->\n					<div class=\"row-no-padding\">\n						<div class=\"form-group v-align\">\n							<label class=\"col-sm-2 control-label\" for=\"endpointIviUserName\">\n								Username\n							</label>\n\n							<div class=\"col-sm-4 pad-text-input-col\">\n								<input class=\"form-control input-sm prism-text-input\"\n									   id=\"endpointIviUserName\"\n									   autocomplete=\"off\"\n									   autocorrect=\"off\"\n									   autocapitalize=\"off\"\n									   spellcheck=\"false\"\n									   ng-model=\"$ctrl.endpointObject.iviUserName\"/>\n							</div>\n							<div class=\"required-select\" required x-required-indicator></div>\n						</div>\n					</div>\n\n					<!-- IVI Password -->\n					<div class=\"row-no-padding\">\n						<div class=\"form-group v-align\">\n							<label class=\"col-sm-2 control-label\" for=\"endpointIviPassword\">\n								Password\n							</label>\n\n							<div class=\"col-sm-4 pad-text-input-col\">\n								<input class=\"form-control input-sm prism-text-input\"\n									   id=\"endpointIviPassword\"\n									   autocomplete=\"off\"\n									   autocorrect=\"off\"\n									   autocapitalize=\"off\"\n									   spellcheck=\"false\"\n									   ng-model=\"$ctrl.endpointObject.iviPassword\"/>\n							</div>\n							<div class=\"required-select\" required x-required-indicator></div>\n						</div>\n					</div>\n\n					<!-- IVI Network ID -->\n					<div class=\"row-no-padding\">\n						<div class=\"form-group v-align\">\n							<label class=\"col-sm-2 control-label\" for=\"endpointIviNetworkId\">\n								Network ID\n							</label>\n\n							<div class=\"col-sm-4 pad-text-input-col\">\n								<input class=\"form-control input-sm prism-text-input\"\n									   id=\"endpointIviNetworkId\"\n									   autocomplete=\"off\"\n									   autocorrect=\"off\"\n									   autocapitalize=\"off\"\n									   spellcheck=\"false\"\n									   ng-model=\"$ctrl.endpointObject.iviNetworkId\"/>\n							</div>\n							<div class=\"required-select\" required x-required-indicator></div>\n						</div>\n					</div>\n\n				</form>\n			</div>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryEndpoints/editor/renderers/partner-deliveryendpoints-editor-network-template.html", "<!--\n\n	\"Network\" delivery endpoint editor / delivery section template\n\n-->\n\n<div>\n	<div class=\"row clearfix\">\n		<div class=\"col-md-12 column\">\n			<div class=\"row\">\n				<div class=\"col-md-2\">\n					<div class=\"prism-form-heading\">\n						Delivery\n					</div>\n				</div>\n			</div>\n		</div>\n\n		<div class=\"row clearfix spacer-top-lg\">\n			<div class=\"col-md-12 column\">\n				<form class=\"form-horizontal\" role=\"form\">\n\n					<!-- Network Path -->\n					<div class=\"row-no-padding\">\n						<div class=\"form-group v-align\">\n							<label class=\"col-sm-2 control-label\" for=\"endpointNetworkPath\">\n								Network Path\n							</label>\n\n							<div class=\"col-sm-4 pad-text-input-col\">\n								<input type=\"text\" class=\"form-control input-sm prism-text-input\" id=\"endpointNetworkPath\"\n									   autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\"\n									   ng-model=\"$ctrl.endpointObject.networkPath\"/>\n							</div>\n							<div class=\"required-select\" required x-required-indicator></div>\n						</div>\n					</div>\n\n				</form>\n			</div>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryEndpoints/editor/renderers/partner-deliveryendpoints-editor-s3-template.html", "<!--\n\n    \"Amazon S3\" delivery endpoint editor / delivery section\n     template\n\n-->\n\n<div>\n    <div class=\"row clearfix\">\n        <div class=\"col-md-12 column\">\n            <div class=\"row\">\n                <div class=\"col-md-2\">\n                    <div class=\"prism-form-heading\">\n                        Delivery\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n                <form class=\"form-horizontal\"\n                      role=\"form\">\n\n                    <!-- AWS S3 Bucket Name -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointS3BucketName\">\n                                AWS S3 Bucket Name\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointS3BucketName\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.s3Bucket\"/>\n                            </div>\n                            <div class=\"required-select\"\n                                 required\n                                 x-required-indicator>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- AWS S3 Access Key -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointS3AccessKey\">\n                                AWS S3 Access Key\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointS3AccessKey\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.awsAccessKey\"/>\n                            </div>\n                            <div class=\"required-select\"\n                                 required\n                                 x-required-indicator>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- AWS S3 Secret Key -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointS3SecretKey\">\n                                AWS S3 Secret Key\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointS3SecretKey\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.awsSecretKey\"/>\n                            </div>\n                            <div class=\"required-select\"\n                                 required\n                                 x-required-indicator>\n                            </div>\n                        </div>\n                    </div>\n\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryEndpoints/editor/renderers/partner-deliveryendpoints-editor-sftp-template.html", "<!--\n\n	\"SFTP\" delivery endpoint editor / delivery section template\n\n-->\n\n<div>\n    <div class=\"row clearfix\">\n        <div class=\"col-md-12 column\">\n            <div class=\"row\">\n                <div class=\"col-md-2\">\n                    <div class=\"prism-form-heading\">\n                        Delivery\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n                <form class=\"form-horizontal\"\n                      role=\"form\">\n\n                    <!-- User Name -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointSftpUserName\">\n                                User Name\n                            </label>\n\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointSftpUserName\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.userName\"/>\n                            </div>\n                            <div class=\"required-select\"\n                                 required\n                                 x-required-indicator>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Password -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointSftpPassword\">\n                                Password\n                            </label>\n\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointSftpPassword\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.password\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Passphrase -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointSftpPassphrase\">\n                                Passphrase\n                            </label>\n\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointSftpPassphrase\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.passphrase\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Known Hosts -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointSftpKnownHosts\">\n                                Known Hosts\n                            </label>\n\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointSftpKnownHosts\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.knownHosts\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Server Address -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointSftpServerAddress\">\n                                Server Address\n                            </label>\n\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointSftpServerAddress\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.serverAddress\"/>\n                            </div>\n                            <div class=\"required-select\"\n                                 required\n                                 x-required-indicator>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Private Key -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointSftpPrivateKey\">\n                                Private Key\n                            </label>\n\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointSftpPrivateKey\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.privateKey\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Public Key -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointSftpPublicKey\">\n                                Public Key\n                            </label>\n\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointSftpPublicKey\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.publicKey\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Server Port -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointSftpServerPort\">\n                                Server Port\n                            </label>\n\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointSftpServerPort\"\n                                       ng-keydown=\"$ctrl.numericFieldKeyDown($event, $ctrl.endpointObject.serverPort)\"\n                                       autocomplete=\"off\"\n                                       ng-model=\"$ctrl.endpointObject.serverPort\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryEndpoints/editor/renderers/partner-deliveryendpoints-editor-uplynk-template.html", "<!--\n\n    \"UpLynk\" delivery endpoint editor / delivery section template\n\n-->\n\n<div>\n    <div class=\"row clearfix\">\n        <div class=\"col-md-12 column\">\n            <div class=\"row\">\n                <div class=\"col-md-2\">\n                    <div class=\"prism-form-heading\">\n                        Delivery\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n                <form class=\"form-horizontal\"\n                      role=\"form\">\n\n                    <!-- Username Expression -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointUpLynkUsernameExpression\">\n                                Username Expression\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointUpLynkUsernameExpression\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.userName\"/>\n                            </div>\n                            <div class=\"required-select\"\n                                 required\n                                 x-required-indicator>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- API key Expression -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointUpLynkAPIKeyExpression\">\n                                API Key Expression\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointUpLynkAPIKeyExpression\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.apiKey\"/>\n                            </div>\n                            <div class=\"required-select\"\n                                 required\n                                 x-required-indicator>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Library GUID Expression -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointUpLynkLibraryGUIDExpression\">\n                                Library GUID Expression\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointUpLynkLibraryGUIDExpression\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.libraryGUID\"/>\n                            </div>\n                        </div>\n                    </div>\n                    <br/>\n\n                    <!-- Secondary Username Expression -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointUpLynkSecondaryUsernameExpression\">\n                                Secondary Username Expression\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointUpLynkSecondaryUsernameExpression\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.secondaryUserName\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Secondary API Key -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointUpLynkSecondaryAPIKeyExpression\">\n                                Secondary API Key Expression\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointUpLynkSecondaryAPIKeyExpression\"\n                                       ng-model=\"$ctrl.endpointObject.secondaryApiKey\"\n                                       spellcheck=\"false\"/>\n                            </div>\n                            <div ng-if=\"$ctrl.endpointObject.secondaryUserName\">\n                                <div class=\"required-select\"\n                                     required\n                                     x-required-indicator>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Secondary Library GUID Expression -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointUpLynkSecondaryLibraryGUIDExpression\">\n                                Secondary Library GUID Expression\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointUpLynkSecondaryLibraryGUIDExpression\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.secondaryLibraryGUID\"/>\n                            </div>\n                        </div>\n                    </div>\n                    <br/>\n\n                    <!-- External ID Expression -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointUpLynkExternalIDExpression\">\n                                External ID Expression\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input class=\"form-control input-sm prism-text-input\"\n                                       id=\"endpointUpLynkExternalIDExpression\"\n                                       autocomplete=\"off\"\n                                       autocorrect=\"off\"\n                                       autocapitalize=\"off\"\n                                       spellcheck=\"false\"\n                                       ng-model=\"$ctrl.endpointObject.externalIdExpression\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Slicer Options -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointUpLynkSlicerOptions\">\n                                Slicer Options\n                            </label>\n\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <textarea type=\"text\"\n                                          rows=\"3\"\n                                          id=\"endpointUpLynkSlicerOptions\"\n                                          class=\"prism-text-input form-control\"\n                                          ng-model=\"$ctrl.endpointObject.slicerOptions\">\n                                </textarea>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Skip DRM -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointUpLynkSkipDRM\">\n                                Skip DRM\n                            </label>\n\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input type=\"checkbox\"\n                                       id=\"endpointUpLynkSkipDRM\"\n                                       ng-model=\"$ctrl.endpointObject.skipDRM\"/>\n                                <label for=\"endpointUpLynkSkipDRM\"\n                                       class=\"control-label\">\n                                </label>\n                            </div>\n                        </div>\n                    </div>\n\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryEndpoints/editor/renderers/partner-deliveryendpoints-editor-vantage-template.html", "<!--\n\n    \"Vantage\" delivery endpoint editor / delivery section template\n\n-->\n\n<div>\n    <div class=\"row clearfix\">\n        <div class=\"col-md-12 column\">\n            <div class=\"row\">\n                <div class=\"col-md-2\">\n                    <div class=\"prism-form-heading\">\n                        Delivery\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n                <form class=\"form-horizontal\"\n                      role=\"form\">\n\n                    <!-- Workflow -->\n                    <conversion-template-dropdown\n                        id=\"endpointWorkflow\"\n                        required\n                        collection=\"$ctrl.mediaConversionTemplates\"\n                        ng-model=\"$ctrl.endpointObject.vantageWorkflow\"\n                        default-template-type=\"\'Vantage\'\"\n                        prompt-width=\"2\"\n                        type-prompt=\"Workflow Type\"\n                        template-prompt-suffix=\"Workflow\"\n                        type-whitelist=\"$ctrl.endpointWorkflowTypeWhitelist\"\n                    ></conversion-template-dropdown>\n\n                    <!-- Attach Metadata -->\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group v-align\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"endpointVantageAttachMetadata\">\n                                Attach Metadata\n                            </label>\n\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input type=\"checkbox\"\n                                       id=\"endpointVantageAttachMetadata\"\n                                       ng-model=\"$ctrl.endpointObject.attachMetadataFlag\"/>\n                                <label for=\"endpointVantageAttachMetadata\"\n                                       class=\"control-label\">\n                                </label>\n                            </div>\n                        </div>\n                    </div>\n\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/dueDateTemplates/editor/renderers/partner-due-date-templates-editor-email-section-template.html", "<div class=\"row clearfix\">\n\n    <div class=\"col-md-12 column\">\n        <div class=\"row\">\n            <div class=\"col-md-2\">\n                <div class=\"prism-form-heading\">\n                    Email\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"row clearfix spacer-top-lg\">\n        <div class=\"col-md-12 column\">\n\n            <!-- Overdue Template -->\n            <div class=\"form-group\">\n                <label for=\"dueDateTemplateOverdueTemplate\"\n                       class=\"col-sm-2 control-label\">\n                    Overdue Template\n                </label>\n                <div class=\"col-sm-4 pad-text-input-col\">\n                    <dropdown-select\n                        id=\"dueDateTemplateOverdueTemplate\"\n                        collection=\"$ctrl.availableEmailTemplates\"\n                        ng-model=\"$ctrl.dueDateTemplateObject.overdueTemplate\"\n                        required\n                        clearable=\"false\"\n                        label-field=\"name\"\n                        btn-min-width=\"300\">\n                    </dropdown-select>\n                </div>\n            </div>\n\n            <!-- Overdue Subject Expression -->\n            <div class=\"form-group\">\n                <label for=\"dueDateTemplateOverdueSubject\"\n                       class=\"col-sm-2 control-label\">\n                    Overdue Subject Expression\n                </label>\n                <div class=\"col-sm-9 pad-text-input-col\">\n						<textarea type=\"text\"\n                                  rows=\"3\"\n                                  id=\"dueDateTemplateOverdueSubject\"\n                                  class=\"prism-text-input form-control\"\n                                  ng-model=\"$ctrl.dueDateTemplateObject.overdueSubject\">\n						</textarea>\n                </div>\n            </div>\n\n            <!-- Due Date Warning Template -->\n            <div class=\"form-group\">\n                <label for=\"dueDateTemplateWarningTemplate\"\n                       class=\"col-sm-2 control-label\">\n                    Due Date Warning Template\n                </label>\n                <div class=\"col-sm-4 pad-text-input-col\">\n                    <dropdown-select\n                        id=\"dueDateTemplateWarningTemplate\"\n                        collection=\"$ctrl.availableEmailTemplates\"\n                        ng-model=\"$ctrl.dueDateTemplateObject.dueDateWarningTemplate\"\n                        required\n                        clearable=\"false\"\n                        label-field=\"name\"\n                        btn-min-width=\"300\">\n                    </dropdown-select>\n                </div>\n            </div>\n\n            <!-- Due Date Warning Subject Expression -->\n            <div class=\"form-group\">\n                <label for=\"dueDateTemplateWarningSubject\"\n                       class=\"col-sm-2 control-label\">\n                    Due Date Warning Subject Expression\n                </label>\n                <div class=\"col-sm-9 pad-text-input-col\">\n						<textarea type=\"text\"\n                                  rows=\"3\"\n                                  id=\"dueDateTemplateWarningSubject\"\n                                  class=\"prism-text-input form-control\"\n                                  ng-model=\"$ctrl.dueDateTemplateObject.dueDateWarningSubject\">\n						</textarea>\n                </div>\n            </div>\n\n            <!-- Recipients -->\n            <div class=\"form-group\">\n                <label class=\"col-sm-2 control-label\">\n                    Recipients\n                </label>\n                <contacts-list class=\"col-sm-10\"\n                                       ng-model=\"$ctrl.dueDateTemplateObject\"\n                                       model-prop=\"\'contacts\'\">\n                </contacts-list>\n            </div>\n\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/dueDateTemplates/editor/renderers/partner-due-date-templates-editor-general-section-template.html", "<div class=\"row clearfix\">\n\n    <div class=\"col-md-12 column\">\n        <div class=\"row\">\n            <div class=\"col-md-2\">\n                <div class=\"prism-form-heading\">\n                    General\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"row clearfix spacer-top-lg\">\n        <div class=\"col-md-12 column\">\n\n            <!-- Name -->\n            <div class=\"form-group\">\n                <label for=\"dueDateTemplateName\"\n                       class=\"col-sm-2 control-label\">\n                    Name\n                </label>\n                <div class=\"col-sm-4 pad-text-input-col\">\n                    <input type=\"text\"\n                           id=\"dueDateTemplateName\"\n                           class=\"prism-text-input form-control\"\n                           ng-model=\"$ctrl.dueDateTemplateObject.name\" />\n                </div>\n                <div class=\"required-text-input\"\n                     required\n                     x-required-indicator>\n                </div>\n            </div>\n\n            <!-- Expression -->\n            <div class=\"form-group\">\n                <label for=\"dueDateTemplateExpression\"\n                       class=\"col-sm-2 control-label\">\n                    Expression\n                </label>\n                <div class=\"col-sm-9 pad-text-input-col\">\n						<textarea type=\"text\"\n                                  rows=\"3\"\n                                  id=\"dueDateTemplateExpression\"\n                                  class=\"prism-text-input form-control\"\n                                  ng-model=\"$ctrl.dueDateTemplateObject.expression\">\n						</textarea>\n                </div>\n                <div class=\"required-text-input\"\n                     required\n                     x-required-indicator></div>\n            </div>\n\n            <!-- Operational Hour Set -->\n            <div class=\"form-group\">\n                <label for=\"dueDateTemplateBusiness\"\n                       class=\"col-sm-2 control-label\">\n                    Operational Hour Set\n                </label>\n                <div class=\"col-sm-4 pad-text-input-col\">\n                    <dropdown-select\n                        id=\"dueDateTemplateBusiness\"\n                        collection=\"$ctrl.availableBusinesses\"\n                        ng-model=\"$ctrl.dueDateTemplateObject.business\"\n                        clearable=\"false\"\n                        label-field=\"name\"\n                        btn-min-width=\"300\">\n                    </dropdown-select>\n                </div>\n            </div>\n\n            <!-- Warn Hours Before -->\n            <div class=\"row-no-padding\">\n                <div class=\"form-group\">\n                    <label for=\"dueDateTemplateWarningThresholdHours\"\n                           class=\"col-sm-2 control-label\">Warn Hours Before</label>\n                    <div class=\"col-sm-1 pad-text-input-col\">\n                        <input type=\"number\"\n                               class=\"prism-text-input\"\n                               id=\"dueDateTemplateWarningThresholdHours\"\n                               name=\"warningThresholdStepper\"\n                               min=\"0\"\n                               max=\"99\"\n                               step=\"1\"\n                               pattern=\"\\d*\"\n                               ng-change=\"$ctrl.onStepperChanged($ctrl.dueDateTemplateObject, \'warningThresholdHours\', 0, 99)\"\n                               ng-model-options=\"{allowInvalid: true}\"\n                               ng-model=\"$ctrl.dueDateTemplateObject.warningThresholdHours\"/>\n                    </div>\n                    <span class=\"control-label col-sm-1 text-align-left\">\n                        hours\n                        <span class=\"required-text-input\"\n                             required\n                             x-required-indicator></span>\n                    </span>\n                </div>\n            </div>\n\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/emailEndpoints/editor/gridTemplates/networks-list-cell-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\"\n	 data-tooltip-append-to-body=\"true\"\n	 uib-tooltip=\"{{grid.appScope.$ctrl.getNetworksList(row.entity).join(\', \')}}\">\n	<span>{{grid.appScope.$ctrl.getNetworksList(row.entity).join(\', \')}}</span>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/emailEndpoints/editor/renderers/partner-emailendpoints-editor-general-section-template.html", "<div class=\"row clearfix\">\n	<div class=\"col-md-12 column\">\n		<div class=\"row\">\n			<div class=\"col-md-2\">\n				<div class=\"prism-form-heading\">\n					General\n				</div>\n			</div>\n		</div>\n	</div>\n	<div class=\"row clearfix spacer-top-lg\">\n		<div class=\"col-md-12 column\">\n			<form class=\"form-horizontal\"\n				  role=\"form\">\n\n				<!-- Name -->\n				<div class=\"form-group\">\n					<label for=\"emailEndpointName\"\n						   class=\"col-sm-2 control-label\">\n						Name\n					</label>\n					<div class=\"col-sm-4 pad-text-input-col\">\n						<input type=\"text\"\n							   id=\"emailEndpointName\"\n							   class=\"prism-text-input form-control\"\n							   ng-model=\"$ctrl.endpointObject.name\" />\n					</div>\n					<div class=\"required-text-input\"\n						 required\n						 x-required-indicator>\n					</div>\n				</div>\n\n				<!-- Email Template -->\n				<div class=\"form-group\">\n					<label for=\"emailEndpointEmailTemplate\"\n						   class=\"col-sm-2 control-label\">\n						Email Template\n					</label>\n					<div class=\"col-sm-4 pad-text-input-col\">\n						<dropdown-select\n							id=\"emailEndpointEmailTemplate\"\n							collection=\"$ctrl.availableEmailTemplates\"\n							ng-model=\"$ctrl.endpointObject.emailTemplate\"\n							prompt=\"Select email template\"\n							clearable=\"false\"\n							label-field=\"name\"\n							btn-min-width=\"300\"\n                            class=\"hide-required-indicator\"\n                            required>\n						</dropdown-select>\n						<span class=\"top-margin-md required-text-input\"\n							 required\n							 x-required-indicator>\n						</span>\n					</div>\n				</div>\n\n				<!-- Delivery Templates -->\n				<div class=\"form-group\">\n					<label for=\"emailEndpointDeliveryTemplates\"\n						   class=\"col-sm-2 control-label\">\n						Delivery Templates\n					</label>\n					<div class=\"col-sm-4 pad-text-input-col\">\n						<multiselect-dropdown\n							id=\"emailEndpointDeliveryTemplates\"\n							collection=\"$ctrl.availableDeliveryTemplates\"\n							ng-model=\"$ctrl.endpointObject.deliveryTemplates\"\n							prompt=\"Select delivery templates\"\n							clearable=\"$ctrl.canWrite\"\n							label-function=\"$ctrl.getDeliveryTemplateName\"\n							btn-min-width=\"300\">\n						</multiselect-dropdown>\n					</div>\n				</div>\n\n				<!-- Subject Expression -->\n				<div class=\"form-group\">\n					<label for=\"emailEndpointSubject\"\n						   class=\"col-sm-2 control-label\">\n						Email Subject\n					</label>\n					<div class=\"col-sm-9 pad-text-input-col\">\n						<textarea type=\"text\"\n								  rows=\"2\"\n								  id=\"emailEndpointSubject\"\n								  class=\"prism-text-input form-control\"\n								  ng-model=\"$ctrl.endpointObject.subjectExpression\">\n						</textarea>\n					</div>\n					<div class=\"required-text-input\"\n						 required\n						 x-required-indicator></div>\n				</div>\n\n                <!-- Recipients -->\n                <div class=\"form-group\">\n                    <label class=\"col-sm-2 control-label\">\n                        Recipients\n                    </label>\n                    <email-recipients-list class=\"col-sm-10\"\n                                           ng-model=\"$ctrl.endpointObject\"\n                                           model-prop=\"\'recipients\'\">\n                    </email-recipients-list>\n                </div>\n\n			</form>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/emailEndpoints/searchView/gridTemplates/delivery-template-list-cell-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\"\n	 data-tooltip-append-to-body=\"true\"\n	 uib-tooltip=\"{{grid.appScope.$ctrl.getDeliveryTemplateNames(row.entity).join(\', \')}}\">\n	<span>{{grid.appScope.$ctrl.getDeliveryTemplateNames(row.entity).join(\', \')}}</span>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/planner/editor/renderers/partner-planner-delivery-section-template.html", "<div>\n	<div class=\"row clearfix\">\n		<div class=\"col-md-12 column\">\n			<div class=\"row\">\n				<div class=\"col-md-2\">\n					<div class=\"prism-form-heading\">Delivery</div>\n				</div>\n			</div>\n		</div>\n		<div class=\"row clearfix spacer-top-lg\">\n			<div class=\"col-md-12 column\">\n				<form class=\"form-horizontal\"\n					  role=\"form\">\n\n					<!-- Transform Template -->\n					<div class=\"form-group\">\n						<label for=\"transformTemplate\"\n							   class=\"col-sm-2 control-label\">Transform Template</label>\n						<div class=\"col-sm-4 metadata-control-col\">\n							<dropdown-select id=\"transformTemplate\"\n											 ng-model=\"$ctrl.plannerObject.xslTemplate\"\n											 prompt=\"Select Template\"\n											 label-field=\"name\"\n											 clearable=\"true\"\n											 collection=\"$ctrl.availableTransformTemplates\"\n											 btn-min-width=\"295\">\n							</dropdown-select>\n						</div>\n					</div>\n\n					<!-- Convert to Excel Flag -->\n					<div class=\"form-group v-align\">\n						<label for=\"cbConvertToExcel\"\n							   class=\"col-sm-2 control-label\">\n							Convert to Excel Spreadsheet\n						</label>\n						<div class=\"col-sm-4 metadata-control-col\">\n							<input type=\"checkbox\"\n								   id=\"cbConvertToExcel\"\n								   ng-model=\"$ctrl.plannerObject.convertToExcelFlag\">\n							<label for=\"cbConvertToExcel\"\n								   class=\"control-label\"></label>\n						</div>\n					</div>\n\n					<!-- Naming Scheme -->\n					<div class=\"form-group v-align\">\n						<label for=\"namingScheme\"\n							   class=\"col-sm-2 control-label\">Naming Scheme</label>\n						<div class=\"col-sm-9 pad-text-input-col\">\n							<input type=\"text\"\n								   class=\"form-control prism-text-input\"\n								   autocomplete=\"off\"\n								   ng-model=\"$ctrl.plannerObject.filenameExpression\"\n								   id=\"namingScheme\"/>\n						</div>\n						<div class=\"required-select\"\n							 required\n							 x-required-indicator></div>\n					</div>\n\n					<!-- Email Endpoint -->\n					<div class=\"form-group\">\n						<label for=\"plannerEmailEndpoint\"\n							   class=\"col-sm-2 control-label\">Email Endpoint</label>\n						<div class=\"col-sm-4 metadata-control-col\">\n							<dropdown-select id=\"plannerEmailEndpoint\"\n											 ng-model=\"$ctrl.plannerObject.emailEndpoint\"\n											 prompt=\"Select Endpoint\"\n											 label-field=\"name\"\n											 clearable=\"true\"\n											 collection=\"$ctrl.availableEmailEndpoints\"\n											 btn-min-width=\"295\">\n							</dropdown-select>\n						</div>\n					</div>\n\n					<!-- Delivery Endpoint -->\n					<div class=\"form-group\">\n						<label for=\"plannerDeliveryEndpoint\"\n							   class=\"col-sm-2 control-label\">Delivery Endpoint</label>\n						<div class=\"col-sm-4 metadata-control-col\">\n							<dropdown-select id=\"plannerDeliveryEndpoint\"\n											 ng-model=\"$ctrl.plannerObject.deliveryEndpoint\"\n											 prompt=\"Select Endpoint\"\n											 label-field=\"name\"\n											 clearable=\"true\"\n											 collection=\"$ctrl.availableDeliveryEndpoints\"\n											 btn-min-width=\"295\"\n											 ng-change=\"$ctrl.deliveryEndpointChange()\">\n							</dropdown-select>\n						</div>\n					</div>\n\n					<!-- Delivery Endpoint Config -->\n					<div class=\"form-group no-margin-bottom\"\n						 ng-if=\"!$ctrl.plannerObject.deliveryEndpoint && !$ctrl.plannerObject.emailEndpoint\">\n						<small class=\"col-sm-12 base-required-label\"><em>* Either a Delivery or Email Template are\n																		 required.</em></small>\n					</div>\n					<div class=\"form-group\">\n						<div class=\"edit-view-container col-sm-10 col-sm-offset-1 top-margin-md \"\n							 ng-if=\"$ctrl.plannerObject.deliveryEndpoint\"\n							 max-width=\"295\">\n\n							<!-- Username Expression -->\n							<div class=\"form-group\">\n								<label for=\"usernameExpression\"\n									   class=\"col-sm-3 control-label\">UserName Expression</label>\n								<div class=\"col-sm-8 pad-text-input-col\">\n									<input type=\"text\"\n										   class=\"form-control input-sm prism-text-input\"\n										   autocomplete=\"off\"\n										   ng-model=\"$ctrl.plannerObject.userNameExpression\"\n										   id=\"usernameExpression\"/>\n								</div>\n							</div>\n\n							<!-- Password Expression -->\n							<div class=\"form-group\">\n								<label for=\"passwordExpression\"\n									   class=\"col-sm-3 control-label\">Password Expression</label>\n								<div class=\"col-sm-8 pad-text-input-col\">\n									<input type=\"text\"\n										   class=\"form-control input-sm prism-text-input\"\n										   autocomplete=\"off\"\n										   ng-model=\"$ctrl.plannerObject.passwordExpression\"\n										   id=\"passwordExpression\"/>\n								</div>\n							</div>\n\n							<!-- Target Path -->\n							<div class=\"form-group\">\n								<label for=\"targetPath\"\n									   class=\"col-sm-3 control-label\">Target Path</label>\n								<div class=\"col-sm-8 pad-text-input-col\">\n									<input type=\"text\"\n										   class=\"form-control input-sm prism-text-input\"\n										   autocomplete=\"off\"\n										   ng-model=\"$ctrl.plannerObject.targetPathExpression\"\n										   id=\"targetPath\"/>\n								</div>\n							</div>\n						</div>\n					</div>\n				</form>\n			</div>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/planner/editor/renderers/partner-planner-general-section-template.html", "<div>\n	<div class=\"row clearfix\">\n		<div class=\"col-md-12 column\">\n			<div class=\"row\">\n				<div class=\"col-md-2\">\n					<div class=\"prism-form-heading\">General</div>\n				</div>\n			</div>\n		</div>\n		<div class=\"row clearfix spacer-top-lg\">\n			<div class=\"col-md-12 column\">\n				<form class=\"form-horizontal\"\n					  role=\"form\">\n\n					<!-- ID -->\n					<div class=\"row-no-padding\">\n						<div class=\"form-group v-align\">\n							<label class=\"col-sm-2 control-label\">\n								ID\n							</label>\n							<div class=\"col-sm-8 padding-top-sm\">\n								<p id=\"id\"\n								   class=\"top-margin-xs\">{{$ctrl.plannerObject.id}}</p>\n							</div>\n						</div>\n					</div>\n\n					<!-- Enabled flag -->\n					<div class=\"row-no-padding\">\n						<div class=\"form-group v-align\">\n							<label for=\"enabled\"\n								   class=\"col-sm-2 control-label\">\n								Enabled\n							</label>\n							<div class=\"col-sm-8 padding-top-sm\">\n								<input type=\"checkbox\"\n									   ng-model=\"$ctrl.plannerObject.enabledFlag\"\n									   id=\"enabled\">\n								<label for=\"enabled\"\n									   class=\"control-label\"></label>\n							</div>\n						</div>\n					</div>\n\n					<!-- Name -->\n					<div class=\"row-no-padding\">\n						<div class=\"form-group v-align\">\n							<label for=\"plannerName\"\n								   class=\"col-sm-2 control-label\">Name</label>\n							<div class=\"col-sm-4 pad-text-input-col\">\n								<input type=\"text\"\n									   class=\"form-control input-sm prism-text-input\"\n									   autocomplete=\"off\"\n									   ng-model=\"$ctrl.plannerObject.name\"\n									   id=\"plannerName\"/>\n							</div>\n							<div class=\"required-select\"\n								 required\n								 x-required-indicator></div>\n						</div>\n					</div>\n\n					<!-- Search Criteria -->\n					<div class=\"row-no-padding\">\n						<div class=\"form-group v-align\">\n							<label for=\"searchCriteria\"\n								   class=\"col-sm-2 control-label\">Search Criteria</label>\n							<div class=\"col-sm-9 pad-text-input-col\">\n								<input type=\"text\"\n									   class=\"form-control input-sm prism-text-input\"\n									   autocomplete=\"off\"\n									   ng-model=\"$ctrl.plannerObject.searchCriteria\"\n									   id=\"searchCriteria\"/>\n							</div>\n						</div>\n					</div>\n\n					<!-- Look Back -->\n					<div class=\"row-no-padding\">\n						<div class=\"form-group\">\n							<label for=\"lookBack\"\n								   class=\"col-sm-2 control-label\">Look Back</label>\n							<div class=\"col-sm-1 pad-text-input-col\">\n								<input type=\"number\"\n									   class=\"prism-text-input\"\n									   id=\"lookBack\"\n									   name=\"lookBackStepper\"\n									   min=\"0\"\n									   max=\"1000000\"\n									   step=\"1\"\n									   pattern=\"\\d*\"\n									   ng-change=\"$ctrl.onStepperChanged($ctrl.plannerObject, \'lookBack\', 0, 1000000)\"\n									   ng-model-options=\"{allowInvalid: true}\"\n									   ng-model=\"$ctrl.plannerObject.lookBack\"/>\n							</div>\n							<div class=\"required-select text-align-left\"\n								 required\n								 x-required-indicator></div>\n							<span class=\"control-label text-align-left\">days</span>\n						</div>\n					</div>\n\n					<!-- Look Forward -->\n					<div class=\"row-no-padding\">\n						<div class=\"form-group\">\n							<label for=\"lookForward\"\n								   class=\"col-sm-2 control-label\">Look Forward</label>\n							<div class=\"col-sm-1 pad-text-input-col\">\n								<input type=\"number\"\n									   class=\"prism-text-input\"\n									   id=\"lookForward\"\n									   name=\"lookForwardStepper\"\n									   min=\"0\"\n                                       max=\"1000000\"\n									   step=\"1\"\n									   pattern=\"\\d*\"\n									   ng-change=\"$ctrl.onStepperChanged($ctrl.plannerObject, \'lookForward\', 0, 1000000)\"\n									   ng-model-options=\"{allowInvalid: true}\"\n									   ng-model=\"$ctrl.plannerObject.lookForward\"/>\n							</div>\n							<div class=\"required-select text-align-left\"\n								 required\n								 x-required-indicator></div>\n							<span class=\"control-label text-align-left\">days</span>\n						</div>\n					</div>\n\n					<!-- Look Back/Forward Criteria -->\n					<div class=\"row-no-padding\">\n						<div class=\"form-group\">\n							<label class=\"col-sm-2 control-label\">Look Back/Forward Criteria</label>\n							<div class=\"col-sm-10 padding-left-md\">\n								<input type=\"radio\"\n									   id=\"lookCriteriaORD\"\n									   ng-model=\"$ctrl.plannerObject.searchBySunrise\"\n									   ng-value=\"false\">\n								<label class=\"control-label\"\n									   for=\"lookCriteriaORD\">\n									Original Release Date\n								</label>\n\n								<input type=\"radio\"\n									   id=\"lookCriteriaEarliestSunrise\"\n									   ng-model=\"$ctrl.plannerObject.searchBySunrise\"\n									   ng-value=\"true\">\n								<label class=\"control-label\"\n									   for=\"lookCriteriaEarliestSunrise\">\n									Earliest Partner Sunrise\n								</label>\n							</div>\n						</div>\n					</div>\n\n				</form>\n			</div>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/planner/editor/renderers/partner-planner-schedule-section-template.html", "<!-- Schedule -->\n<div>\n	<div class=\"row clearfix\">\n		<div class=\"col-md-12 column\">\n			<div class=\"row\">\n				<div class=\"col-md-2\">\n					<div class=\"prism-form-heading\">Schedule</div>\n				</div>\n			</div>\n		</div>\n		<div class=\"row clearfix spacer-top-lg\">\n			<div class=\"col-md-12 column\">\n				<form class=\"form-horizontal\"\n					  role=\"form\">\n\n					<!-- Frequency -->\n					<div class=\"form-group\">\n						<span class=\"col-sm-offset-1 col-sm-4\">\n							<input type=\"radio\"\n								   class=\"radio-button\"\n								   id=\"frequencyRadioBtn\"\n								   ng-value=\"\'recurring\'\"\n								   ng-model=\"$ctrl.plannerObject.scheduleType\"\n								   ng-change=\"$ctrl.updateRequiredFields()\"/>\n							<label for=\"frequencyRadioBtn\"\n								   class=\"control-label\">Recurring Interval</label>\n						</span>\n					</div>\n					<div class=\"form-group\">\n						<label class=\"col-sm-offset-1 col-sm-2 control-label\">Frequency</label>\n						<div class=\"col-sm-1 pad-text-input-col\">\n							<input type=\"number\"\n								   class=\"prism-text-input\"\n								   id=\"frequency\"\n								   name=\"frequencyStepper\"\n								   min=\"1\"\n								   max=\"8760\"\n								   step=\"1\"\n								   pattern=\"\\d*\"\n								   ng-change=\"$ctrl.onStepperChanged($ctrl.plannerObject, \'frequency\', 1, 8760)\"\n								   ng-disabled=\"$ctrl.plannerObject.scheduleType != \'recurring\'\"\n								   ng-model-options=\"{allowInvalid: true}\"\n								   ng-model=\"$ctrl.plannerObject.frequency\"/>\n						</div>\n						<div class=\"required-select padding-top\"\n							 ng-if=\"$ctrl.plannerObject.scheduleType == \'recurring\'\">\n							<span class=\"required-select text-align-left\"\n								  required\n								  x-required-indicator>\n							</span>\n							<span class=\"control-label\">hours</span>\n						</div>\n						<div class=\"required-select padding-top\"\n							 ng-if=\"$ctrl.plannerObject.scheduleType == \'weekly\'\">\n							<span class=\"control-label padding-left-xsm\">hours</span>\n						</div>\n					</div>\n\n					<!-- Weekday Scheduler -->\n					<div class=\"form-group\">\n						<span class=\"col-sm-offset-1 col-sm-2\">\n							<input type=\"radio\"\n								   class=\"radio-button\"\n								   id=\"weeklyScheduleRadioBtn\"\n								   ng-value=\"\'weekly\'\"\n								   ng-model=\"$ctrl.plannerObject.scheduleType\"\n								   ng-change=\"$ctrl.updateRequiredFields()\"/>\n							<label for=\"weeklyScheduleRadioBtn\"\n								   class=\"control-label\">Weekly Schedule</label>\n						</span>\n					</div>\n					<div class=\"form-group\">\n						<label class=\"col-sm-offset-1 col-sm-2 control-label\">Weekday(s)</label>\n						<div class=\"col-sm-7 weekday-schedule-left-margin\">\n							<fieldset ng-disabled=\"$ctrl.plannerObject.scheduleType != \'weekly\'\">\n								<weekday-selector\n									enabled-days=\"$ctrl.plannerObject.scheduleDays\"\n									updated=\"$ctrl.editorForm.$setDirty()\"\n									ng-disabled=\"$ctrl.plannerObject.scheduleType != \'weekly\'\">\n								</weekday-selector>\n							</fieldset>\n						</div>\n					</div>\n					<div class=\"form-group\">\n						<label for=\"scheduleTimePicker\"\n							   class=\"col-sm-offset-1 col-sm-2 control-label\">Time of Day</label>\n						<div class=\"col-sm-2 pad-text-input-col time-component auto-width\">\n							<prism-time-picker\n								id=\"scheduleTimePicker\"\n								ng-model=\"$ctrl.plannerObject.scheduleTimeOfDay\"\n								ng-disabled=\"$ctrl.plannerObject.scheduleType != \'weekly\'\">\n							</prism-time-picker>\n						</div>\n						<div class=\"required-select padding-top\"\n							 ng-if=\"$ctrl.plannerObject.scheduleType == \'weekly\'\">\n							<span class=\"required-select text-align-left\"\n								  required\n								  x-required-indicator>\n							</span>\n						</div>\n					</div>\n\n				</form>\n			</div>\n		</div>\n	</div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/planner/searchView/gridTemplates/enabled-check-mark-cell-template.html", "<div class=\"checkbox-grid-cell ui-grid-cell-contents ng-scope ng-binding\"\n	 ng-click=\"grid.appScope.$ctrl.enabledCheckMarkClicked(row, $event)\"\n	 ng-dblclick=\"grid.appScope.$ctrl.enabledCheckMarkDblClicked(row, $event)\">\n	<span class=\"padding-left-sm\">\n		<input type=\"checkbox\" ng-checked=\"COL_FIELD\"/>\n		<label></label>\n	</span>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/planner/searchView/gridTemplates/next-run-cell-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding\">\n	<span class=\"padding-left-sm\">\n		{{ grid.appScope.$ctrl.createNextRunLabel(row.entity) !== null?\n			(grid.appScope.$ctrl.createNextRunLabel(row.entity) CUSTOM_FILTERS):\n			\'N/A\' }}\n	</span>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/planner/searchView/gridTemplates/planner-row-template.html", "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\"\n	 class=\"ui-grid-cell ng-scope ng-binding\"\n	 ui-grid-cell\n	 ng-dblclick=\"grid.appScope.$ctrl.onRowDblClick(row)\">\n</div>\n");
        $templateCache.put("meta/content/editor/components/view/categories/editor/components/contentCategoriesPropertiesView/content-categories-properties-edit-view-template.html", "<div class=\"edit-full-height edit-view\">\n    <div class=\"loadingIndicator\">\n        <div data-lb-progress=\"$ctrl.loadingIndicator\"\n             ng-show=\"$ctrl.loadingIndicator.show\">\n        </div>\n    </div>\n    <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n        <div class=\"row spacer-top-sm\">\n            <div class=\"col-md-12 column\">\n                <content-categories-properties-panel edit-data=\"$ctrl.editData\">\n                </content-categories-properties-panel>\n            </div>\n        </div>\n        <div class=\"row spacer-top-sm\">\n            <div class=\"col-md-12 column\">\n                <content-categories-automatic-creation-panel edit-data=\"$ctrl.editData\">\n                </content-categories-automatic-creation-panel>\n            </div>\n        </div>\n        <div class=\"row spacer-top-sm\">\n            <div class=\"col-md-12 column\">\n                <div ng-include=\"\'meta/content/editor/components/view/categories/editor/components/contentCategoriesPropertiesView/renderers/automated-external-ingest-template.html\'\"></div>\n            </div>\n        </div>\n        <div class=\"row spacer-top-sm\">\n            <div class=\"col-md-12 column\">\n                <content-categories-video-component-roles-panel edit-data=\"$ctrl.editData\">\n                </content-categories-video-component-roles-panel>\n            </div>\n        </div>\n        <div class=\"row spacer-top-sm\" ng-if=\"$ctrl.editData.contentCategoryObject.videoRoles\">\n            <div class=\"col-md-12 column\">\n                <content-categories-video-roles-panel edit-data=\"$ctrl.editData\">\n                </content-categories-video-roles-panel>\n            </div>\n        </div>\n    </form>\n</div>\n<div class=\"row-no-padding manager-toolbar\">\n    <toolbar button-defs=\"$ctrl.toolbarButtonDefs\" pagination-defs=\"$ctrl.paginationDefs\"></toolbar>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryProfiles/editor/components/properties/delivery-profiles-properties-edit-view-template.html", "    <div class=\"loadingIndicator\">\n        <div data-lb-progress=\"$ctrl.loadingIndicator\"\n             ng-show=\"$ctrl.loadingIndicator.show\">\n        </div>\n    </div>\n    <fieldset>\n        <div class=\"edit-full-height edit-view\">\n            <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n                <div class=\"edit-view-container\">\n                    <div class=\"col-md-12 column\">\n                        <div class=\"row\">\n                            <div class=\"col-md-2\">\n                                <div class=\"prism-form-heading\">General</div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row clearfix\">\n                        <div class=\"row clearfix spacer-top-lg\">\n                            <div class=\"col-md-12 column\">\n                                <div class=\"row-no-padding\">\n                                    <form role=\"form\" class=\"form-horizontal\">\n\n                                        <div class=\"form-group\">\n                                            <label for=\"packageAcceptTemplate\"\n                                                   class=\"col-sm-2 control-label\">Package Accept Template</label>\n                                            <div class=\"col-sm-4 metadata-control-col\">\n                                                <dropdown-select id=\"packageAcceptTemplate\"\n                                                                 ng-model=\"$ctrl.editData.packageAcceptTemplate\"\n                                                                 prompt=\"Select Package Accept Template\"\n                                                                 label-field=\"name\"\n                                                                 clearable=\"false\"\n                                                                 collection=\"$ctrl.availablePackageAcceptTemplates\"\n                                                                 btn-min-width=\"295\">\n                                                </dropdown-select>\n                                                <error-warning-indicator\n                                                        ng-if=\"$ctrl.selectedPackageAcceptTemplateInUse()\"\n                                                        class=\"inline-block\"\n                                                        error-warning=\"$ctrl.selectedPackageAcceptTemplateInUseError\"\n                                                        ng-click=\"pkgTextCntrlr.showAssetWarnings()\">\n                                                </error-warning-indicator>\n                                            </div>\n                                            <div class=\"required-text-input\" required x-required-indicator></div>\n                                        </div>\n                                        <div class=\"form-group\">\n                                            <label for=\"categoryType\"\n                                                   class=\"col-sm-2 control-label\">Category Type</label>\n                                            <div class=\"col-sm-4 metadata-control-col\">\n                                                <dropdown-select id=\"categoryType\"\n                                                                 ng-model=\"$ctrl.editData.categoryType\"\n                                                                 prompt=\"Select Category Type\"\n                                                                 label-field=\"name\"\n                                                                 clearable=\"false\"\n                                                                 collection=\"$ctrl.availableCategoryTypes\"\n                                                                 btn-min-width=\"295\">\n                                                </dropdown-select>\n                                            </div>\n                                            <div class=\"required-text-input\" required x-required-indicator></div>\n                                        </div>\n                                    </form>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </fieldset>\n    <div class=\"row-no-padding manager-toolbar\">\n        <toolbar button-defs=\"$ctrl.toolbarButtonDefs\" pagination-defs=\"$ctrl.paginationDefs\"></toolbar>\n    </div>\n");
        $templateCache.put("meta/content/editor/components/view/categories/editor/components/contentCategoriesPropertiesView/automaticCreationPanel/content-categories-automatic-creation-panel-template.html", "<div class=\"edit-view-container\">\n    <div class=\"prism-form-heading\">Automatic Creation</div>\n    <div class=\"row\">\n        <ng-form class=\"form-horizontal\"\n                 role=\"form\"\n                 name=\"$ctrl.editorForm\">\n        <div class=\"form-group\">\n\n            <div class=\"col-xs-offset-3 col-sm-offset-3 col-md-offset-2 col-lg-offset-1 col-xl-offset-1 col-xs-7 col-sm-7 col-md-10 col-lg-11 col-xl-11\">\n                <weekday-selector\n                        updated=\"$ctrl.editorForm.$setDirty()\"\n                        enabled-days=\"$ctrl.editData.contentCategoryObject.daysOfWeekSchedule\">\n                </weekday-selector>\n            </div>\n        </div>\n        </ng-form>\n    </div>\n</div>\n\n\n");
        $templateCache.put("meta/content/editor/components/view/categories/editor/components/contentCategoriesPropertiesView/categoryPropertiesPanel/content-categories-properties-panel-template.html", "<div class=\"edit-view-container\">\n    <div class=\"prism-form-heading\">Category Properties</div>\n    <div class=\"row\">\n        <div class=\"form-group\">\n            <label for=\"category\"\n                   class=\"col-md-6 col-lg-3 control-label\">Category\n            </label>\n            <div class=\"col-md-6 col-lg-9\">\n                <p class=\"form-control-static\" id=\"category\">\n                    {{$ctrl.editData.contentCategoryObject.category.name}}\n                </p>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label for=\"commercialBlackTimingRequiredCheckbox\"\n                   class=\"col-md-6 col-lg-3 control-label\">\n                Commercial Black TCs Required\n            </label>\n            <div class=\"col-md-6 col-lg-9 partner-nielsen-enabled-cb\">\n                <input type=\"checkbox\"\n                       id=\"commercialBlackTimingRequiredCheckbox\"\n                       ng-model=\"$ctrl.editData.contentCategoryObject.commercialBlackTimingRequired\"/>\n                <label for=\"commercialBlackTimingRequiredCheckbox\">&nbsp;</label>\n            </div>\n        </div>\n        <div class=\"form-group\" ng-if=\"$ctrl.canWriteLiveClipProps\">\n            <label for=\"liveClipEnabledCheckbox\"\n                   class=\"col-md-6 col-lg-3 control-label\">Enabled\n                for Live Clipping</label>\n            <div class=\"col-md-6 col-lg-9 partner-nielsen-enabled-cb\">\n                <input type=\"checkbox\"\n                       id=\"liveClipEnabledCheckbox\"\n                       ng-model=\"$ctrl.editData.contentCategoryObject.liveClipEnabled\"/>\n                <label for=\"liveClipEnabledCheckbox\">&nbsp;</label>\n            </div>\n        </div>\n        <div class=\"edit-view-container col-md-10 col-md-offset-1 bottom-margin-sm\"\n             ng-if=\"$ctrl.canWriteLiveClipProps && $ctrl.editData.contentCategoryObject.liveClipEnabled\">\n            <div class=\"form-group\">\n                <label for=\"liveClipCategoryDropdown\"\n                       class=\"col-md-6 col-lg-3 prism-for-item-label text-align-right\">\n                    Short Form Category for Live Clips\n                </label>\n                <div class=\"col-md-6 col-lg-9 no-left-padding\">\n                    <dropdown-select id=\"liveClipCategoryDropdown\"\n                                     ng-model=\"$ctrl.editData.contentCategoryObject.liveClipCategory\"\n                                     prompt=\"Select Category\" btn-min-width=\"200\"\n                                     clearable=\"true\"\n                                     label-field=\"name\"\n                                     collection=\"$ctrl.shortFormCategoriesForLiveClips\">\n                    </dropdown-select>\n                </div>\n            </div>\n            <div class=\"form-group\">\n                <label for=\"liveClipAcceptProfileDropdown\"\n                       class=\"col-md-6 col-lg-3 prism-for-item-label text-align-right\">\n                    Video Accept Profile for Live Clips\n                </label>\n                <div class=\"col-md-6 col-lg-9 no-left-padding\">\n                    <dropdown-select id=\"liveClipAcceptProfileDropdown\"\n                                     ng-model=\"$ctrl.editData.contentCategoryObject.liveClipAcceptProfile\"\n                                     collection=\"$ctrl.editData.videoAcceptProfiles\"\n                                     label-field=\"name\"\n                                     prompt=\"Select Profile\" btn-min-width=\"200\"\n                                     clearable=\"true\">\n                    </dropdown-select>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n\n");
        $templateCache.put("meta/content/editor/components/view/categories/editor/components/contentCategoriesPropertiesView/renderers/automated-external-ingest-template.html", "<div class=\"edit-view-container\">\n    <div class=\"prism-form-heading\">Automated External Ingest</div>\n    <div class=\"row\">\n        <div class=\"form-group\">\n            <label for=\"externalSystemNameExpressionInput\" class=\"control-label col-md-2\">System Name</label>\n            <div class=\"col-md-8 pad-text-input-col\">\n                <input type=\"text\" class=\"prism-text-input\"\n                       ng-model=\"$ctrl.editData.contentCategoryObject.externalSystemNameExpression\"\n                       id=\"externalSystemNameExpressionInput\"/>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label for=\"externalSystemIdExpressionInput\" class=\"control-label col-md-2\">External ID</label>\n            <div class=\"col-md-8 pad-text-input-col\">\n                <input type=\"text\" class=\"prism-text-input\"\n                       ng-model=\"$ctrl.editData.contentCategoryObject.externalSystemIdExpression\"\n                       id=\"externalSystemIdExpressionInput\"/>\n            </div>\n        </div>\n    </div>\n</div>\n\n\n");
        $templateCache.put("meta/content/editor/components/view/categories/editor/components/contentCategoriesPropertiesView/videoComponentRoles/content-categories-video-component-roles-panel-template.html", "<div class=\"edit-view-container\">\n    <div class=\"prism-form-heading\">Video Component Roles</div>\n    <ng-form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n        <div class=\"row\">\n            <div class=\" col-md-offset-1 col-md-10 column\">\n                <div class=\"form-group\">\n                    <div id=\"videoComponentRolesGrid\"\n                         ui-grid=\"$ctrl.gridOptions\"\n                         inline-checkbox-grid\n                         ui-grid-selection\n                         style=\"max-height: 225px;\"\n                         ui-grid-auto-resize>\n                    </div>\n                    <label class=\"under-field-hint\">Video Role Components Cannot be Deselected</label>\n                </div>\n            </div>\n        </div>\n    </ng-form>\n</div>\n\n");
        $templateCache.put("meta/content/editor/components/view/categories/editor/components/contentCategoriesPropertiesView/videoRolesPanel/content-categories-video-roles-panel-template.html", "<div class=\"edit-view-container\">\n\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <uib-tabset horizontal=\"true\"\n                        class=\"pull-left content-categories-tabbar\"\n                        active=\"$ctrl.activeTab\">\n                <uib-tab\n                        ng-repeat=\"videoRole in $ctrl.editData.contentCategoryObject.videoRoles\"\n                        ng-if=\"$ctrl.hideUnselectedTab(videoRole.roles) || true\"\n                        ng-click=\"$ctrl.onTabSelect(videoRole)\"\n                        index=\"videoRole\"\n                        heading=\"{{videoRole.role.name}}\">\n                </uib-tab>\n            </uib-tabset>\n        </div>\n    </div>\n    <div class=\"row\">\n        <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n            <div class=\"col-md-12\">\n                <div class=\"row\" ng-if=\"$ctrl.videoRole\">\n                    <div class=\"no-padding col-md-6 column\">\n                        <content-categories-role-definitions-panel\n                                edit-data=\"$ctrl.editData\"\n                                heading-text=\"\'CLOSED CAPTIONING\'\"\n                                video-role=\"$ctrl.videoRole\"\n                                roles=\"$ctrl.editData.ccRoles\"\n                                accept-template-type=\"\'closedCaptioningAcceptTemplate\'\">\n                        </content-categories-role-definitions-panel>\n                    </div>\n                    <div class=\"no-padding col-md-6 column\">\n                        <content-categories-role-definitions-panel\n                                edit-data=\"$ctrl.editData\"\n                                heading-text=\"\'SUBTITLES\'\"\n                                video-role=\"$ctrl.videoRole\"\n                                roles=\"$ctrl.editData.subtitleRoles\"\n                                accept-template-type=\"\'subtitleAcceptTemplate\'\">\n                        </content-categories-role-definitions-panel>\n                    </div>\n                </div>\n            </div>\n        </form>\n    </div>\n</div>\n");
        $templateCache.put("meta/content/editor/components/view/seasonvolume/editor/components/view/aggregation/aggregation-tab-template.html", "<fieldset>\n    <div class=\"edit-full-height edit-view\">\n\n        <div class=\"loadingIndicator\">\n            <div data-lb-progress=\"$ctrl.loadingIndicator\" ng-show=\"$ctrl.loadingIndicator.show\"></div>\n        </div>\n\n        <form class=\"form-horizontal aggregation-tab\"\n              name=\"$ctrl.editorForm\">\n\n            <div class=\"edit-view-container\">\n                <div class=\"prism-form-heading\">\n                    AGGREGATION\n                </div>\n\n                <!-- System Name -->\n                <div class=\"form-group spacer-top-lg\">\n                    <label for=\"externalSystemNameExpressionInput\"\n                           class=\"col-sm-3 control-label\">System Name</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <span id=\"externalSystemNameExpressionInput\"\n                              class=\"form-control-static\"\n                              ng-model=\"$ctrl.seasonVolume.name\">\n                            {{$ctrl.seasonVolume.externalSystem}}\n                        </span>\n                    </div>\n                </div>\n\n                <!-- Aggregation ID -->\n                <div class=\"form-group\">\n                    <label for=\"externalSystemIdExpressionInput\"\n                           class=\"col-sm-3 control-label\">External ID</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <input type=\"text\"\n                               class=\"form-control input-sm prism-text-input\"\n                               autocomplete=\"off\"\n                               ng-model=\"$ctrl.seasonVolume.externalId\"\n                               ng-change=\"$ctrl.onExternalIdChange()\"\n                               id=\"externalSystemIdExpressionInput\"/>\n                    </div>\n                    <a class=\"fa-stack clear-dropdown\"\n                       ng-click=\"$ctrl.clearExternalId()\"\n                       ng-show=\"$ctrl.seasonVolume.externalId\"\n                       href=\"\">\n                        <i class=\"fa fa-circle fa-stack-1x\"></i>\n                        <i class=\"fa fa-times fa-stack-1x\"></i>\n                    </a>\n                </div>\n            </div>\n\n        </form>\n    </div>\n</fieldset>\n\n<!-- Toolbar -->\n<toolbar button-defs=\"$ctrl.toolbarButtons\">\n</toolbar>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/delivery-profiles-delivery-items-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <div class=\"row-no-padding\">\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n            <breadcrumb tab-name=\"$ctrl.resolveData.mediaAcceptProfile.Name\"></breadcrumb>\n            <uib-tabset horizontal=\"true\"\n                        type=\"pills\"\n                        class=\"edit-view-tabbar\"\n                        active=\"$ctrl.currentTab\">\n                <uib-tab heading=\"Videos\" index=\"\'Video\'\"\n                         select=\"$ctrl.onTabSelect(\'Video\')\"\n                         ng-show=\"$ctrl.enabledTabs.Video\"\n                         deselect=\"$ctrl.onTabDeselect(\'Video\', $event)\">\n                </uib-tab>\n                <uib-tab heading=\"Audio\" index=\"\'Audio\'\"\n                         select=\"$ctrl.onTabSelect(\'Audio\')\"\n                         ng-show=\"$ctrl.enabledTabs.Audio\"\n                         deselect=\"$ctrl.onTabDeselect(\'Audio\', $event)\">\n                </uib-tab>\n                <uib-tab heading=\"Images\" index=\"\'Image\'\"\n                         select=\"$ctrl.onTabSelect(\'Image\')\"\n                         ng-show=\"$ctrl.enabledTabs.Image\"\n                         deselect=\"$ctrl.onTabDeselect(\'Image\', $event)\">\n                </uib-tab>\n                <uib-tab heading=\"Artwork\" index=\"\'Artwork\'\"\n                         select=\"$ctrl.onTabSelect(\'Artwork\')\"\n                         ng-show=\"$ctrl.enabledTabs.Artwork\"\n                         deselect=\"$ctrl.onTabDeselect(\'Artwork\', $event)\">\n                </uib-tab>\n                <uib-tab heading=\"Closed Captions\" index=\"\'CC\'\"\n                         select=\"$ctrl.onTabSelect(\'CC\')\"\n                         ng-show=\"$ctrl.enabledTabs.CC\"\n                         deselect=\"$ctrl.onTabDeselect(\'CC\', $event)\">\n                </uib-tab>\n                <uib-tab heading=\"Subtitles\" index=\"\'Subtitle\'\"\n                         select=\"$ctrl.onTabSelect(\'Subtitle\')\"\n                         ng-show=\"$ctrl.enabledTabs.Subtitle\"\n                         deselect=\"$ctrl.onTabDeselect(\'Subtitle\', $event)\">\n                </uib-tab>\n                <uib-tab heading=\"Metadata\" index=\"\'Metadata\'\"\n                         select=\"$ctrl.onTabSelect(\'Metadata\')\"\n                         ng-show=\"$ctrl.enabledTabs.Metadata\"\n                         deselect=\"$ctrl.onTabDeselect(\'Metadata\', $event)\">\n                </uib-tab>\n                <uib-tab heading=\"Archives\" index=\"\'Archive\'\"\n                         select=\"$ctrl.onTabSelect(\'Archive\')\"\n                         ng-show=\"$ctrl.enabledTabs.Archive\"\n                         deselect=\"$ctrl.onTabDeselect(\'Archive\', $event)\">\n                </uib-tab>\n            </uib-tabset>\n            <delivery-item-search-view\n                    ng-if=\"$ctrl.currentTab\"\n                    delivery-item-type=\"$ctrl.currentTab\">\n            </delivery-item-search-view>\n        </div>\n    </div>\n</div>\n<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\">\n    </div>\n</div>\n");
        $templateCache.put("meta/content/editor/components/view/seasonvolume/editor/components/view/properties/content-seasonvolume-properties-template.html", "<!-- Loading Indicator -->\n<div class=\"loadingIndicator\">\n	<div data-lb-progress=\"$ctrl.loadingIndicator\"\n		 ng-show=\"$ctrl.loadingIndicator.show\">\n	</div>\n</div>\n\n<!-- Editor Forms -->\n<fieldset>\n	<div class=\"edit-full-height edit-view\">\n		<form class=\"form-horizontal\" name=\"$ctrl.editorForm\">\n            <div>\n                <!-- General -->\n                <div class=\"edit-view-container\">\n                    <div ng-include=\"\'meta/content/editor/components/view/seasonvolume/editor/components/view/properties/renderers/content-seasonvolume-properties-general-template.html\'\"></div>\n                </div>\n\n                <hr />\n\n                <translatable-metadata\n                    form-title=\"\'LOCALIZATION\'\"\n                    fields=\"$ctrl.translatableMetadataFields\">\n                </translatable-metadata>\n\n                <hr/>\n\n                <!-- Metadata -->\n                <div class=\"edit-view-container\">\n                    <div ng-include=\"\'meta/content/editor/components/view/seasonvolume/editor/components/view/properties/renderers/content-seasonvolume-properties-metadata-template.html\'\"></div>\n                </div>\n\n            </div>\n\n		</form>\n	</div>\n</fieldset>\n\n<!-- Toolbar -->\n<div class=\"row-no-padding manager-toolbar\">\n	<toolbar button-defs=\"$ctrl.toolbarButtons\">\n	</toolbar>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/searchView/delivery-profiles-delivery-items-search-view-template.html", "<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\">\n    </div>\n</div>\n<div class=\"edit-full-height no-padding\">\n    <div id=\"deliveryProfileDeliveryItemsGrid\"\n         class=\"grid-with-one-row-of-tabs-and-breadcrumbs search-grid\"\n         ui-grid=\"$ctrl.gridOptions\"\n         ui-grid-selection\n         ui-grid-resize-columns>\n    </div>\n\n    <!-- Toolbar -->\n    <div class=\"row-no-padding manager-toolbar\">\n        <div class=\"row-no-padding manager-toolbar\">\n          <toolbar right-hand-checkbox-defs=\"$ctrl.toolbarCheckboxDefs\"></toolbar>\n        </div>\n    </div>\n</div>\n\n");
        $templateCache.put("system/partner/editor/components/view/deliveryProfiles/editor/components/emails/editor/delivery-profiles-delivery-emails-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <div class=\"row-no-padding\">\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n            <breadcrumb tab-name=\"\'Delivery Email\'\"></breadcrumb>\n\n            <fieldset>\n                <div class=\"edit-full-height edit-view\">\n                    <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n                        <div class=\"edit-view-container\">\n\n                            <div class=\"col-md-12 column\">\n                                <div class=\"row\">\n                                    <div class=\"col-md-2\">\n                                        <div class=\"prism-form-heading\">General</div>\n                                    </div>\n                                </div>\n                            </div>\n\n\n                            <div class=\"row clearfix\">\n                                <div class=\"row clearfix spacer-top-lg\">\n                                    <div class=\"col-md-12 column\">\n                                        <div class=\"row-no-padding\">\n                                            <form role=\"form\" class=\"form-horizontal\">\n\n                                                <div class=\"form-group\">\n                                                    <label for=\"emailConfig\"\n                                                           class=\"col-sm-2 control-label\">Email Config</label>\n                                                    <div class=\"col-sm-4 metadata-control-col\">\n                                                        <dropdown-select id=\"emailConfig\"\n                                                                         ng-model=\"$ctrl.deliveryEmail.emailConfig\"\n                                                                         required\n                                                                         prompt=\"Select Email Endpoint\"\n                                                                         label-field=\"name\"\n                                                                         clearable=\"false\"\n                                                                         collection=\"$ctrl.availableEndpoints\"\n                                                                         sort-collection=\"true\"\n                                                                         btn-min-width=\"400\">\n                                                        </dropdown-select>\n                                                    </div>\n                                                </div>\n\n                                                <div class=\"form-group\">\n                                                    <label for=\"attachments\"\n                                                           class=\"col-sm-2 control-label\">Attachments</label>\n                                                    <div id=\"attachments\" class=\"col-sm-4 metadata-control-col\">\n\n                                                        <button id=\"addAttachment\" class=\"btn btn-default prism-button\" ng-click=\"$ctrl.onAddAttachmentClicked()\"><i\n                                                            class=\"fa fa-plus\"></i></button>\n                                                        <button id=\"removeAttachment\" class=\"btn btn-default prism-button\"\n                                                                ng-click=\"$ctrl.onRemoveAttachmentsClicked()\"><i class=\"fa fa-minus\"></i></button>\n                                                        <hr/>\n\n                                                        <div class=\"grid\"\n                                                             id=\"attachmentsGrid\"\n                                                             ui-grid=\"$ctrl.gridOptions\"\n                                                             ui-grid-selection\n                                                             style=\"width: 670px; height: 156px;\">\n                                                        </div>\n\n                                                    </div>\n                                                </div>\n\n                                            </form>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </fieldset>\n\n            <div class=\"row-no-padding manager-toolbar\">\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"></toolbar>\n            </div>\n\n        </div>\n    </div>\n</div>\n<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\">\n    </div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryProfiles/editor/components/emails/searchView/delivery-profiles-emails-search-view-template.html", "<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\">\n    </div>\n</div>\n<div class=\"edit-full-height no-padding\">\n    <div id=\"deliveryProfileEmailsGrid\"\n         class=\"grid-with-one-row-of-tabs-and-breadcrumbs search-grid\"\n         ui-grid=\"$ctrl.gridOptions\"\n         ui-grid-selection\n         ui-grid-resize-columns>\n    </div>\n\n    <!-- Toolbar -->\n    <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"\n             right-hand-checkbox-defs=\"$ctrl.toolbarCheckboxDefs\">\n    </toolbar>\n</div>\n");
        $templateCache.put("meta/content/editor/components/view/categories/editor/components/contentCategoriesPropertiesView/videoRolesPanel/roleDefinitionsPanel/content-categories-role-definitions-panel-template.html", "<div class=\"edit-view-container\">\n\n    <div class=\"row\">\n        <div class=\" col-md-offset-1 col-md-10 column\">\n            <div class=\"row\">\n                <br>\n                <div class=\"prism-form-heading\">{{$ctrl.headingText}}</div>\n                <ng-form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n\n                    <div class=\"form-group\">\n                        <label for=\"{{$ctrl.acceptTemplateType}}Checkbox\"\n                               class=\"col-md-3 prism-form-item-label text-align-right\">Required</label>\n                        <div class=\"col-md-9 no-left-padding\">\n                            <input type=\"checkbox\" id=\"{{$ctrl.acceptTemplateType}}Checkbox\"\n                                   ng-model=\"$ctrl.requiresMapping\"\n                                   ng-click=\"$ctrl.requiresMappingCheckboxToggled()\"/>\n                            <label for=\"{{$ctrl.acceptTemplateType}}Checkbox\"></label>\n                        </div>\n                    </div>\n                    <fieldset ng-disabled=\"!$ctrl.requiresMapping\">\n                        <div class=\"form-group\">\n                            <label for=\"closedCaptioningTypeDropdown\"\n                                   class=\"col-md-3 prism-form-item-label text-align-right\">Type</label>\n                            <div class=\"col-md-9 no-left-padding\">\n                                <dropdown-select id=\"closedCaptioningTypeDropdown\"\n                                                 ng-disabled=\"!$ctrl.requiresMapping\"\n                                                 ng-model=\"$ctrl.videoRoleAcceptTemplate.displayMode\"\n                                                 btn-min-width=\"200\" prompt=\"Any\"\n                                                 model-prop=\"value\" label-field=\"label\"\n                                                 value-prop=\"label\"\n                                                 collection=\"$ctrl.roleTypes\">\n                                </dropdown-select>\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <div class=\"col-md-offset-3 col-md-8 no-left-padding\">\n                                <div id=\"grid\"\n                                     ui-grid=\"$ctrl.gridOptions\"\n                                     inline-checkbox-grid\n                                     ui-grid-selection\n                                     ui-grid-resize-columns\n                                     class=\"search-grid top-margin-xs protected-grid\"\n                                     style=\"max-height: 250px;\"\n                                     ui-grid-auto-resize>\n                                </div>\n                            </div>\n                        </div>\n                    </fieldset>\n                </ng-form>\n            </div>\n\n        </div>\n\n    </div>\n</div>\n");
        $templateCache.put("meta/content/editor/components/view/seasonvolume/editor/components/view/properties/renderers/content-seasonvolume-properties-general-template.html", "<div class=\"row clearfix\">\n\n	<div class=\"col-md-12 column\">\n		<div class=\"row\">\n			<div class=\"col-md-2\">\n				<div class=\"prism-form-heading\">GENERAL</div>\n			</div>\n		</div>\n	</div>\n\n	<div class=\"row clearfix spacer-top-lg\">\n		<div class=\"col-md-12 column\">\n			<form class=\"form-horizontal\">\n\n				<!-- Padlock -->\n				<div class=\"form-group\">\n					<label for=\"svLocked\" class=\"col-sm-2 control-label\">\n						{{$ctrl.seasonVolume.locked? \'Locked\': \'Unlocked\'}}\n					</label>\n					<div class=\"col-sm-4 pad-text-input-col\">\n						<ui-lock id=\"svLocked\"\n								 is-locked=\"$ctrl.seasonVolume.locked\"\n								 click-handler=\"$ctrl.editorForm.$setDirty()\">\n						</ui-lock>\n					</div>\n				</div>\n\n				<!-- Name -->\n				<div class=\"form-group\">\n					<label for=\"svName\" class=\"col-sm-2 control-label\">\n						Name\n					</label>\n					<div class=\"col-sm-3 pad-text-input-col\">\n						<input class=\"form-control input-sm prism-text-input\"\n							   autocomplete=\"off\"\n							   ng-model=\"$ctrl.seasonVolume.name\"\n							   id=\"svName\" />\n					</div>\n					<div class=\"required-text-input\" required x-required-indicator></div>\n				</div>\n\n                <!-- Sequence Number -->\n                <div class=\"form-group\">\n                    <label for=\"svSequenceNumber\" class=\"col-sm-2 control-label\">\n                        Sequence Number\n                    </label>\n                    <div class=\"col-sm-3 pad-text-input-col\">\n                        <input class=\"form-control input-sm prism-text-input\"\n                               autocomplete=\"off\"\n                               ng-model=\"$ctrl.seasonVolume.sequenceNumber\"\n                               id=\"svSequenceNumber\" />\n                    </div>\n                    <div class=\"required-text-input\" required x-required-indicator></div>\n                </div>\n\n                <!-- Start Date -->\n				<div class=\"form-group\">\n					<label for=\"svStartDate\" class=\"col-sm-2 control-label\">Start Date</label>\n					<div class=\"col-sm-2 pad-text-input-col\">\n						<date-picker id=\"svStartDate\"\n									 ng-model=\"$ctrl.seasonVolume.startDate\"\n									 timezone-offset-millis=\"\'SERVER\'\">\n						</date-picker>\n					</div>\n				</div>\n\n\n				<!-- End Date -->\n				<div class=\"form-group\">\n					<label for=\"svEndDate\" class=\"col-sm-2 control-label\">End Date</label>\n					<div class=\"col-sm-2 pad-text-input-col\">\n						<date-picker id=\"svEndDate\"\n									 ng-model=\"$ctrl.seasonVolume.endDate\"\n									 timezone-offset-millis=\"\'SERVER\'\">\n						</date-picker>\n					</div>\n				</div>\n\n			</form>\n		</div>\n	</div>\n\n</div>\n");
        $templateCache.put("meta/content/editor/components/view/seasonvolume/editor/components/view/properties/renderers/content-seasonvolume-properties-metadata-template.html", "<div class=\"row clearfix\">\n	<div class=\"col-md-12 column\">\n		<div class=\"row\">\n			<div class=\"col-md-2\">\n				<div class=\"prism-form-heading\">\n					CUSTOM METADATA\n				</div>\n			</div>\n		</div>\n\n		<div class=\"row clearfix spacer-top-lg\">\n			<div class=\"col-md-12 column\">\n\n				<custom-metadata\n					components-map=\"$ctrl.metadataComponentsMap\"\n					id-prefix=\"{{$ctrl.seasonVolume.name}}\">\n				</custom-metadata>\n\n			</div>\n		</div>\n\n	</div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/searchView/delivery-item-search-view-template.html", "<div class=\"loadingIndicator\">\n    <div data-lb-progress=\"$ctrl.loadingIndicator\"\n         ng-show=\"$ctrl.loadingIndicator.show\">\n    </div>\n</div>\n<div class=\"edit-full-height no-padding\">\n    <div id=\"deliveryItemsVideosGrid\"\n         class=\"grid-with-one-row-of-tabs-and-breadcrumbs search-grid\"\n         ui-grid=\"$ctrl.gridOptions\"\n         ui-grid-selection\n         ui-grid-resize-columns>\n    </div>\n</div>\n\n<!-- Toolbar -->\n<div class=\"row-no-padding manager-toolbar\">\n    <div class=\"row-no-padding manager-toolbar\">\n        <toolbar button-defs=\"$ctrl.toolbarButtonDefs\"\n                 pagination-defs=\"$ctrl.paginationDefs\"\n                 right-hand-checkbox-defs=\"$ctrl.toolbarCheckboxDefs\">\n        </toolbar>\n    </div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/delivery-item-edit-view-template.html", "<div class=\"container-fluid no-padding\">\n\n    <div class=\"row-no-padding\">\n        <navbar></navbar>\n    </div>\n\n    <div class=\"row-no-padding\">\n        <sidebar-nav class=\"col-md-2 col-lg-2 sidebar-nav\"></sidebar-nav>\n\n        <div class=\"col-md-10 col-lg-10 content-pane\">\n\n            <div class=\"loadingIndicator\">\n                <div data-lb-progress=\"$ctrl.loadingIndicator\"\n                     ng-show=\"$ctrl.loadingIndicator.show\">\n                </div>\n            </div>\n\n            <div class=\"row\">\n                <div class=\"col-md-12\">\n                    <breadcrumb tab-name=\"$ctrl.deliveryItemType\"></breadcrumb>\n\n                    <fieldset>\n                        <div class=\"edit-full-height-no-tabs edit-view\" ng-if=\"$ctrl.editData\">\n\n                            <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n                                <delivery-item-edit-view-general\n                                        ng-if=\"$ctrl.visiblePanels.general\"\n                                        edit-data=\"$ctrl.editData\"\n                                        conditional-templates=\"$ctrl.conditionalTemplates\">\n                                </delivery-item-edit-view-general>\n\n                                <delivery-item-edit-view-archive\n                                        ng-if=\"$ctrl.visiblePanels.archive\"\n                                        edit-data=\"$ctrl.editData\"\n                                        delivery-endpoints-for-partner=\"$ctrl.deliveryEndpointsForPartner\">\n                                </delivery-item-edit-view-archive>\n\n                                <delivery-item-edit-view-from\n                                        ng-if=\"$ctrl.visiblePanels.from\"\n                                        edit-data=\"$ctrl.editData\"\n                                        asset-content-templates=\"$ctrl.assetContentTemplates\"\n                                        languages=\"$ctrl.languages\"\n                                        roles=\"$ctrl.roles\"\n                                        transform-templates=\"$ctrl.transformTemplates\"\n                                        media-accept-profiles=\"$ctrl.mediaAcceptProfiles\"\n                                        package-accept-template=\"$ctrl.packageAcceptTemplate\">\n                                </delivery-item-edit-view-from>\n\n                                <delivery-item-edit-view-to\n                                        ng-if=\"$ctrl.visiblePanels.to\"\n                                        edit-data=\"$ctrl.editData\"\n                                        media-conversion-templates=\"$ctrl.mediaConversionTemplates\"\n                                        asset-content-templates=\"$ctrl.assetContentTemplates\"\n                                        transform-templates=\"$ctrl.transformTemplates\"\n                                        mac-caption-templates=\"$ctrl.macCaptionTemplates\"\n                                        conversion-template-variable-components-map=\"$ctrl.conversionTemplateVariableComponentsMap\"\n                                        on-media-conversion-template-type-change=\"$ctrl.onMediaConversionTemplateTypeChanged(type)\">\n                                </delivery-item-edit-view-to>\n\n                                <video-delivery-item-edit-view-audio-channel-mapping\n                                        ng-if=\"$ctrl.visiblePanels.audioChannelMapping\"\n                                        edit-data=\"$ctrl.editData\"\n                                        languages=\"$ctrl.languages\"\n                                        roles=\"$ctrl.roles\"\n                                        media-accept-profiles=\"$ctrl.mediaAcceptProfiles\">\n                                </video-delivery-item-edit-view-audio-channel-mapping>\n\n                                <video-delivery-item-edit-view-closed-captioning-subtitle\n                                        ng-if=\"$ctrl.visiblePanels.closedCaptioningSubtitle\"\n                                        edit-data=\"$ctrl.editData\"\n                                        languages=\"$ctrl.languages\"\n                                        roles=\"$ctrl.roles\"\n                                        asset-content-templates=\"$ctrl.assetContentTemplates\"\n                                        mac-caption-templates=\"$ctrl.macCaptionTemplates\">\n                                </video-delivery-item-edit-view-closed-captioning-subtitle>\n\n                                <delivery-item-edit-view-vantage-md5\n                                    ng-if=\"$ctrl.visiblePanels.vantageMd5\"\n                                    edit-data=\"$ctrl.editData\">\n                                </delivery-item-edit-view-vantage-md5>\n\n                                <video-delivery-item-edit-view-post-delivery-processing\n                                        ng-if=\"$ctrl.visiblePanels.postDeliveryProcessing\"\n                                        edit-data=\"$ctrl.editData\"\n                                        media-conversion-templates=\"$ctrl.mediaConversionTemplates\">\n                                </video-delivery-item-edit-view-post-delivery-processing>\n\n                                <video-delivery-item-edit-view-ad-partner-properties\n                                        ng-if=\"$ctrl.visiblePanels.adPartnerProperties\"\n                                        edit-data=\"$ctrl.editData\">\n                                </video-delivery-item-edit-view-ad-partner-properties>\n\n                                <delivery-item-edit-view-delivery\n                                        ng-if=\"$ctrl.visiblePanels.delivery\"\n                                        edit-data=\"$ctrl.editData\">\n                                </delivery-item-edit-view-delivery>\n\n                                <delivery-item-edit-view-redelivery\n                                        ng-if=\"$ctrl.visiblePanels.redelivery\"\n                                        edit-data=\"$ctrl.editData\">\n                                </delivery-item-edit-view-redelivery>\n\n                                <delivery-item-edit-view-partner-format\n                                        ng-if=\"$ctrl.visiblePanels.partnerFormat\"\n                                        edit-data=\"$ctrl.editData\">\n                                </delivery-item-edit-view-partner-format>\n                            </form>\n                        </div>\n                    </fieldset>\n                </div>\n            </div>\n\n            <div class=\"row-no-padding manager-toolbar\">\n                <toolbar button-defs=\"$ctrl.toolbarButtonDefs\" pagination-defs=\"$ctrl.paginationDefs\"></toolbar>\n            </div>\n        </div>\n    </div>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/searchView/cell-templates/to-template-cell-template.html", "<div class=\"ui-grid-cell-contents ng-scope ng-binding TEST\"\n     ng-class=\"{\n        \'cell-contains-a-search-result\' : grid.appScope.$ctrl.cellHasASearchResult(row.entity, col.field),\n        \'cell-contains-current-search-result\' : grid.appScope.$ctrl.cellHasCurrentSearchResult(row.entity, col.field)\n     }\"\n     data-tooltip-append-to-body=\"true\"\n     uib-tooltip=\"{{(COL_FIELD || row.entity.targetContentTemplate.name) CUSTOM_FILTERS}}\"\n     ng-dblclick=\"grid.appScope.$ctrl.rowDoubleClick(row, column)\">\n    <span class=\"padding-left-sm\">{{COL_FIELD || row.entity.targetContentTemplate.name}}</span>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/adPartnerProperties/delivery-items-video-edit-view-ad-partner-properties-template.html", "<div class=\"edit-view-container\">\n    <div class=\"col-md-12 column\">\n        <div class=\"row\">\n            <div class=\"col-md-2\">\n                <div class=\"prism-form-heading\">Ad Partner Properties</div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row clearfix\">\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n                <div class=\"row-no-padding\">\n                    <form role=\"form\" class=\"form-horizontal\">\n                        <div class=\"form-group\">\n                            <label class=\"control-label col-md-2\"\n                                   for=\"adPartnerTypeDropdown\">Partner Type\n                            </label>\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <dropdown-select id=\"adPartnerTypeDropdown\"\n                                                 ng-model=\"$ctrl.editData.adPartnerType\"\n                                                 clearable=\"true\"\n                                                 btn-min-width=\"300\"\n                                                 btn-max-width=\"500\"\n                                                 prompt=\"Select Partner Type\"\n                                                 tooltip-class=\"preview-tooltip\"\n                                                 model-prop=\"id\"\n                                                 value-prop=\"displayName\"\n                                                 label-field=\"displayName\"\n                                                 collection=\"$ctrl.availableAdPartnerTypeValidators\"\n                                </dropdown-select>\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"control-label col-md-2\"\n                                   for=\"cdnUrlExpressionInput\">CDN URL Expression</label>\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input type=\"text\" class=\"prism-text-input\"\n                                       ng-model=\"$ctrl.editData.cdnUrlExpression\"\n                                       id=\"cdnUrlExpressionInput\"/>\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"control-label col-md-2\"\n                                   for=\"huluVendorHashInput\">Hulu Vendor Hash</label>\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input type=\"text\" class=\"prism-text-input\"\n                                       ng-model=\"$ctrl.editData.huluVendorHash\"\n                                       id=\"huluVendorHashInput\"/>\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"control-label col-md-2\"\n                                   for=\"partnerApiDelaySecondsInput\">Partner API Delay</label>\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input type=\"text\" class=\"prism-text-input\"\n                                       ng-model=\"$ctrl.editData.partnerAPIDelaySeconds\"\n                                       id=\"partnerApiDelaySecondsInput\"/>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<br>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/archive/delivery-items-edit-view-archive-template.html", "<div class=\"edit-view-container\">\n    <div class=\"col-md-12 column\">\n        <div class=\"row\">\n            <div class=\"col-md-2\">\n                <div class=\"prism-form-heading\">Archive</div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row clearfix\">\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n                <div class=\"row-no-padding\">\n                    <form role=\"form\" class=\"form-horizontal\">\n                        <div class=\"form-group\">\n                            <label class=\"control-label col-md-2\">Format</label>\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <dropdown-select id=\"formatDropdown\"\n                                                 ng-model=\"$ctrl.editData.archiveFormat\"\n                                                 required\n                                                 clearable=\"false\"\n                                                 btn-min-width=\"300\"\n                                                 btn-max-width=\"500\"\n                                                 prompt=\"Select Format\"\n                                                 label-field=\"displayName\"\n                                                 model-prop=\"id\"\n                                                 value-prop=\"displayName\"\n                                                 default-select-index=\"0\"\n                                                 collection=\"$ctrl.availableFormats\">\n                                </dropdown-select>\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"control-label col-md-2\">Source Endpoint</label>\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <dropdown-select id=\"sourceEndpointDropdown\"\n                                                 ng-model=\"$ctrl.editData.sourceEndpoint\"\n                                                 required\n                                                 clearable=\"false\"\n                                                 btn-min-width=\"300\"\n                                                 btn-max-width=\"500\"\n                                                 prompt=\"Select Source Endpoint\"\n                                                 label-field=\"name\"\n                                                 collection=\"$ctrl.availableSourceEndpoints\">\n                                </dropdown-select>\n                                <span ng-if=\"!$ctrl.availableSourceEndpoints.length\" class=\"under-field-hint pull-left\"><span class=\"fa fa-warning grid-red\"></span> There are no Network Delivery Endpoints configured for this Partner, cannot create a new Archive Delivery Item</span>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<br>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/audioChannelMapping/delivery-items-video-edit-view-audio-channel-mapping-template.html", "<div class=\"edit-view-container\">\n    <form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n        <div class=\"col-md-12 column\">\n            <div class=\"row\">\n                <div class=\"col-md-2\">\n                    <div class=\"prism-form-heading\">Audio Channel Mapping</div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row clearfix\">\n            <div class=\"row clearfix spacer-top-lg\">\n                <div class=\"col-md-12 column\">\n                    <div class=\"row-no-padding\">\n                        <div class=\"form-group\">\n                            <label for=\"audioChannelMappingEnabledCheckbox\"\n                                   class=\"col-sm-2 control-label\">Enabled</label>\n                            <div class=\"col-sm-1 partner-nielsen-enabled-cb\">\n                                <input type=\"checkbox\"\n                                       id=\"audioChannelMappingEnabledCheckbox\"\n                                       ng-model=\"$ctrl.editData.audioMappingFlag\"/>\n                                <label for=\"audioChannelMappingEnabledCheckbox\">&nbsp;</label>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <fieldset ng-disabled=\"!$ctrl.editData.audioMappingFlag\">\n            <div class=\"col-md-12 column\">\n                <div class=\"row\">\n                    <div class=\"col-md-2\">\n                        <div class=\"prism-form-heading\">Video Asset Audio</div>\n                    </div>\n\n                </div>\n            </div>\n            <div class=\"row\">\n                <label for=\"rulesMappingEnabledCheckbox\"\n                       class=\"col-sm-2 control-label\">Rules based Partner Delivery Audio Mapping</label>\n                <div class=\"col-sm-1\">\n                    <input type=\"checkbox\"\n                           id=\"rulesMappingEnabledCheckbox\"\n                           ng-model=\"$ctrl.editData.ruleBasedAudioMappingFlag\"/>\n                    <label for=\"rulesMappingEnabledCheckbox\">&nbsp;</label>\n                </div>\n            </div>\n            <video-delivery-item-edit-view-audio-channel-maps-list\n                    channel-map-group=\"$ctrl.videoChannelMapGroup\"\n                    ng-disabled=\"$ctrl.editData.ruleBasedAudioMappingFlag\">\n            </video-delivery-item-edit-view-audio-channel-maps-list>\n            <br>\n\n            <video-delivery-item-edit-view-audio-channel-mapping-audio-sidecar\n                    edit-data=\"$ctrl.editData\"\n                    media-accept-profiles=\"$ctrl.mediaAcceptProfiles\"\n                    languages=\"$ctrl.languages\"\n                    roles=\"$ctrl.roles\">\n            </video-delivery-item-edit-view-audio-channel-mapping-audio-sidecar>\n        </fieldset>\n    </form>\n</div>\n<br>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/closedCaptioningSubtitles/delivery-items-video-edit-view-closed-captioning-subtitle-template.html", "<div class=\"edit-view-container\">\n    <div class=\"col-md-12 column\">\n        <div class=\"row\">\n            <div class=\"col-md-2\">\n                <div class=\"prism-form-heading\">Closed Captioning / Subtitle</div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row clearfix\">\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n                <div class=\"row-no-padding\">\n                    <form role=\"form\" class=\"form-horizontal\">\n                        <div class=\"form-group\">\n                            <label for=\"ccEnabledFlagCheckbox\"\n                                   class=\"col-sm-2 control-label\">Enable</label>\n                            <div class=\"col-sm-1 partner-nielsen-enabled-cb\">\n                                <input type=\"checkbox\"\n                                       id=\"ccEnabledFlagCheckbox\"\n                                       ng-model=\"$ctrl.editData.ccEnabledFlag\"/>\n                                <label for=\"ccEnabledFlagCheckbox\">&nbsp;</label>\n                            </div>\n                        </div>\n                        <fieldset ng-disabled=\"!$ctrl.editData.ccEnabledFlag\">\n                            <div class=\"form-group\">\n                                <label class=\"control-label col-md-2\">Profile</label>\n                                <div class=\"col-sm-4 pad-text-input-col\">\n                                    <dropdown-select id=\"closedCaptionsSubtitleProfileDropdown\"\n                                                     ng-model=\"$ctrl.editData.ccTargetContentTemplate\"\n                                                     ng-required=\"$ctrl.editData.ccEnabledFlag\"\n                                                     clearable=\"false\"\n                                                     btn-min-width=\"300\"\n                                                     btn-max-width=\"500\"\n                                                     prompt=\"Select Profile\"\n                                                     label-field=\"name\"\n                                                     tooltip-class=\"preview-tooltip\"\n                                                     collection=\"$ctrl.closedCaptionAssetContentTemplates\"\n                                    </dropdown-select>\n                                </div>\n                            </div>\n                            <div class=\"form-group\">\n                                <label class=\"control-label col-md-2\">CC Mac Caption Template</label>\n                                <div class=\"col-sm-4 pad-text-input-col\">\n                                    <dropdown-select id=\"ccMacCaptionTemplateDropdown\"\n                                                     ng-model=\"$ctrl.editData.ccMacCaptionTemplate\"\n                                                     clearable=\"true\"\n                                                     btn-min-width=\"300\"\n                                                     btn-max-width=\"500\"\n                                                     label-field=\"name\"\n                                                     prompt=\"Select CC Mac Caption Template\"\n                                                     tooltip-class=\"preview-tooltip\"\n                                                     collection=\"$ctrl.macCaptionTemplates\"\n                                    </dropdown-select>\n                                </div>\n                            </div>\n                            <div class=\"form-group\">\n                                <label class=\"control-label col-md-2\">CC Mac Caption Embed Template</label>\n                                <div class=\"col-sm-4 pad-text-input-col\">\n                                    <dropdown-select id=\"ccMacCaptionEmbedTemplateDropdown\"\n                                                     ng-model=\"$ctrl.editData.ccMacCaptionEmbedTemplate\"\n                                                     clearable=\"true\"\n                                                     btn-min-width=\"300\"\n                                                     btn-max-width=\"500\"\n                                                     label-field=\"name\"\n                                                     prompt=\"Select CC Mac Caption Embed Template\"\n                                                     tooltip-class=\"preview-tooltip\"\n                                                     collection=\"$ctrl.macCaptionTemplates\"\n                                    </dropdown-select>\n                                </div>\n                            </div>\n                            <div class=\"form-group\">\n                                <label class=\"control-label col-md-2\">CC Language</label>\n                                <div class=\"col-sm-4 pad-text-input-col\">\n                                    <dropdown-select id=\"ccLanguageDropdown\"\n                                                     ng-model=\"$ctrl.editData.ccLanguage\"\n                                                     clearable=\"true\"\n                                                     btn-min-width=\"300\"\n                                                     btn-max-width=\"500\"\n                                                     label-field=\"name\"\n                                                     sort-collection=\"false\"\n                                                     prompt=\"Select CC Language\"\n                                                     tooltip-class=\"preview-tooltip\"\n                                                     collection=\"$ctrl.languages\"\n                                    </dropdown-select>\n                                </div>\n                            </div>\n                            <div class=\"form-group\">\n                                <label class=\"control-label col-md-2\">Sidecar Role</label>\n                                <div class=\"col-sm-4 pad-text-input-col\">\n                                    <dropdown-select id=\"sidecarAudioRoleDropdown\"\n                                                     ng-model=\"$ctrl.editData.ccSubtitleRole\"\n                                                     ng-required=\"$ctrl.editData.ccEnabledFlag\"\n                                                     clearable=\"false\"\n                                                     btn-min-width=\"300\"\n                                                     btn-max-width=\"500\"\n                                                     prompt=\"Select CC Role\"\n                                                     prompt=\"Select CC Language\"\n                                                     sort-collection=\"false\"\n                                                     label-field=\"name\"\n                                                     label-function=\"$ctrl.buildCcSubtitleRoleName\"\n                                                     collection=\"$ctrl.roles\">\n                                    </dropdown-select>\n                                </div>\n                            </div>\n                            <div class=\"form-group\">\n                                <label for=\"ccExtractFromVideoFlagCheckbox\"\n                                       class=\"col-sm-2 control-label\">Extract Embedded CC From Resulting Video to be\n                                    used as CC Sidecar</label>\n                                <div class=\"col-sm-1 partner-nielsen-enabled-cb\">\n                                    <input type=\"checkbox\"\n                                           id=\"ccExtractFromVideoFlagCheckbox\"\n                                           ng-model=\"$ctrl.editData.ccExtractFromVideoFlag\"/>\n                                    <label for=\"ccExtractFromVideoFlagCheckbox\">&nbsp;</label>\n                                </div>\n                            </div>\n                            <div class=\"form-group\">\n                                <label class=\"control-label col-md-2\">Vantage Timed Text Nickname</label>\n                                <div class=\"col-sm-4 pad-text-input-col\">\n                                    <input type=\"text\" class=\"prism-text-input\"\n                                           ng-model=\"$ctrl.editData.vantageTimedTextNickname\"\n                                           id=\"vantageTimedTextNicknameInput\"/>\n                                </div>\n                            </div>\n                        </fieldset>\n                    </form>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<br>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/vantageMd5/delivery-items-edit-view-vantage-md5-template.html", "<div class=\"edit-view-container\">\n    <div class=\"col-md-12 column\">\n        <div class=\"row\">\n            <div class=\"col-md-2\">\n                <div class=\"prism-form-heading\">Vantage MD5 Checksum</div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row clearfix\">\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n                <div class=\"row-no-padding\">\n                    <form role=\"form\" class=\"form-horizontal\">\n\n                        <div class=\"form-group\">\n                            <label class=\"col-sm-2 control-label\"\n                                   for=\"enableVantageMd5Checkbox\">Enable</label>\n                            <div class=\"col-sm-4 vantage-md5-enabled-cb\">\n                                <input type=\"checkbox\"\n                                       id=\"enableVantageMd5Checkbox\"\n                                       ng-model=\"$ctrl.editData.vantageMd5Flag\"/>\n                                <label for=\"enableVantageMd5Checkbox\">&nbsp;</label>\n                            </div>\n                        </div>\n\n                        <div class=\"form-group\">\n                            <label class=\"control-label col-md-2\">Vantage MD5 Nickname</label>\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input type=\"text\"\n                                       id=\"vantageMd5NicknameInput\"\n                                       class=\"prism-text-input\"\n                                       ng-model=\"$ctrl.editData.vantageMd5Nickname\"/>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<br>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/postDeliveryProcessing/delivery-items-video-edit-view-post-delivery-processing-template.html", "<div class=\"edit-view-container\">\n    <div class=\"col-md-12 column\">\n        <div class=\"row\">\n            <div class=\"col-md-2\">\n                <div class=\"prism-form-heading\">Post Delivery Processing</div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row clearfix\">\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n                <div class=\"row-no-padding\">\n                    <form role=\"form\" class=\"form-horizontal\">\n                        <conversion-template-dropdown\n                            id=\"closedCaptionsSubtitleProfile\"\n                            collection=\"$ctrl.mediaConversionTemplates\"\n                            ng-model=\"$ctrl.editData.postDeliveryProxyTemplate\"\n                            prompt-width=\"2\"\n                            type-tooltip-class=\"preview-tooltip\"\n                            type-prompt=\"Post Delivery Proxy Type\"\n                            template-prompt-prefix=\"Post Delivery \"\n                            template-prompt-suffix=\"Proxy Workflow\"\n                        ></conversion-template-dropdown>\n                        <conversion-template-dropdown\n                            id=\"postDeliveryQcTemplate\"\n                            collection=\"$ctrl.mediaConversionTemplates\"\n                            ng-model=\"$ctrl.editData.postDeliveryQCTemplate\"\n                            prompt-width=\"2\"\n                            type-tooltip-class=\"preview-tooltip\"\n                            type-prompt=\"Post QC Report Workflow Type\"\n                            template-prompt-suffix=\"Post\"\n                            template-prompt-suffix=\"QC Report Workflow\"\n                        ></conversion-template-dropdown>\n                        <div class=\"form-group\">\n                            <label class=\"control-label col-md-2\"\n                                   for=\"postDeliveryProxyBurnInTextInput\">Proxy Burn-In Text Expression\n                            </label>\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <textarea type=\"text\" class=\"prism-text-input break-word\"\n                                          ng-model=\"$ctrl.editData.postDeliveryProxyBurnInText\"\n                                          rows=\"4\"\n                                          id=\"postDeliveryProxyBurnInTextInput\"></textarea>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<br/>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/audioChannelMapping/deliveryItemsVideoEditViewAudioChannelMappingAudioSidecarComponent/delivery-items-video-edit-view-audio-channel-mapping-audio-sidecar-template.html", "<ng-form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n\n    <div class=\"row  spacer-top-lg\">\n        <div class=\"col-md-12 column\">\n            <div class=\"row\">\n                <div class=\"col-md-2\">\n                    <div class=\"prism-form-heading\">Audio Sidecar</div>\n                </div>\n                <div class=\"col-md-10\">\n                <span class=\"pull-right\">\n                    <button id=\"addAudioChannelMapGroup\"\n                            type=\"button\"\n                            class=\"btn btn-default prism-button\"\n                            uib-tooltip=\"Add new Audio Channel Map Group\"\n                            data-tooltip-append-to-body=\"true\"\n                            ng-click=\"$ctrl.addGroup()\">\n                            <i class=\"fa fa-plus\"></i> ADD\n                    </button>\n                </span>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"row spacer-top-md\">\n        <label class=\"control-label col-md-2\">Audio MAP</label>\n        <div class=\"col-md-2 pad-text-input-col\">\n            <dropdown-select id=\"typeDropdown\"\n                             ng-model=\"$ctrl.editData.sourceAudioAcceptProfile\"\n                             clearable=\"false\"\n                             btn-min-width=\"250\"\n                             prompt=\"Select Audio MAP\"\n                             label-field=\"name\"\n                             max-height=\"\"\n                             collection=\"$ctrl.audioMediaAcceptProfiles\">\n            </dropdown-select>\n        </div>\n    </div>\n    <br>\n\n    <div class=\"row spacer-top-md\"\n         ng-repeat=\"audioChannelMap in $ctrl.audioChannelMapGroups\"\n         ng-class=\"{\'audio-channel-group-panel-band-even\': ($index % 2) === 0, \'audio-channel-group-panel-band-odd\': ($index % 2) !== 0}\">\n        <span class=\"padding-left-md prism-form-item-label grid-green\"\n              ng-if=\"audioChannelMap.id == undefined\"><i class=\"fa fa-plus\"></i> New\n        </span>\n\n        <div class=\"pull-right padding-right-md\">\n            <button id=\"moveAudioChannelMapGroupDown\"\n                    type=\"button\"\n                    class=\"btn btn-default prism-button\"\n                    uib-tooltip=\"Move Audio Channel Map Group Down\"\n                    data-tooltip-append-to-body=\"true\"\n                    ng-disabled=\"$index >= $ctrl.audioChannelMapGroups.length -1\"\n                    ng-click=\"$ctrl.swap($index, 1)\">\n                <i class=\"fa fa-caret-down\"></i> Down\n            </button>\n            <button id=\"moveAudioChannelMapUp\"\n                    type=\"button\"\n                    class=\"btn btn-default prism-button margin-right-md\"\n                    uib-tooltip=\"Move Audio Channel Map Group Up\"\n                    data-tooltip-append-to-body=\"true\"\n                    ng-disabled=\"$index <= 0\"\n                    ng-click=\"$ctrl.swap($index, -1)\">\n                <i class=\"fa fa-caret-up\"></i> Up\n            </button>\n\n            <button id=\"removeAudioChannelMapGroup\"\n                    type=\"button\"\n                    class=\"btn btn-default prism-button\"\n                    uib-tooltip=\"Remove this Audio Channel Map Group\"\n                    data-tooltip-append-to-body=\"true\"\n                    ng-disabled=\"false\"\n                    ng-click=\"$ctrl.removeGroup($index)\">\n                <i class=\"fa fa-times\"></i> REMOVE\n            </button>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"row form-group spacer-top-lg\">\n                <div class=\"col-md-6\">\n                    <label class=\"control-label col-md-4\">Sidecar Audio Role</label>\n                    <div class=\"col-md-5 pad-text-input-col\">\n                        <dropdown-select id=\"sidecarAudioRoleDropdown\"\n                                         ng-model=\"audioChannelMap.role\"\n                                         clearable=\"false\"\n                                         btn-min-width=\"250\"\n                                         prompt=\"Select Role\"\n                                         label-field=\"name\"\n                                         collection=\"$ctrl.audioRoles\">\n                        </dropdown-select>\n                    </div>\n                </div>\n\n                <div class=\"col-md-6\">\n                    <label class=\"control-label col-md-4\">Sidecar Audio Language</label>\n                    <div class=\"col-md-5 pad-text-input-col\">\n                        <dropdown-select id=\"sidecarAudioLanguageDropdown\"\n                                         ng-model=\"audioChannelMap.language\"\n                                         clearable=\"false\"\n                                         btn-min-width=\"250\"\n                                         sort-collection=\"false\"\n                                         prompt=\"Select Language\"\n                                         label-field=\"name\"\n                                         collection=\"$ctrl.languages\">\n                        </dropdown-select>\n                    </div>\n                </div>\n            </div>\n\n            <video-delivery-item-edit-view-audio-channel-maps-list\n                channel-map-group=\"audioChannelMap\">\n            </video-delivery-item-edit-view-audio-channel-maps-list>\n\n        </div>\n    </div>\n\n</ng-form>\n<br>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/audioChannelMapping/deliveryItemsVideoEditViewAudioChannelMapsListComponent/delivery-items-video-edit-view-audio-channel-maps-list-template.html", "<div class=\"row clearfix\">\n    <label for=\"showUnassigned{{$ctrl.channelMapGroup.type}}Maps{{$ctrl.channelMapGroup.index}}Checkbox\"\n           class=\"col-sm-2 control-label\">Show Unassigned</label>\n    <div class=\"col-sm-1 partner-nielsen-enabled-cb\">\n        <input type=\"checkbox\"\n               id=\"showUnassigned{{$ctrl.channelMapGroup.type}}Maps{{$ctrl.channelMapGroup.index}}Checkbox\"\n               ng-model=\"$ctrl.showUnassignedAudioChannelMaps\"\n               ng-change=\"$ctrl.updateVisibleChannelMaps()\"/>\n        <label for=\"showUnassigned{{$ctrl.channelMapGroup.type}}Maps{{$ctrl.channelMapGroup.index}}Checkbox\">&nbsp;</label>\n    </div>\n</div>\n<div class=\"row clearfix\">\n\n    <ng-form class=\"form-horizontal\" role=\"form\" name=\"$ctrl.editorForm\">\n\n        <div class=\"col-md-6 column\">\n            <div class=\"row clearfix spacer-top-lg\">\n                <label class=\"control-label col-md-2\">OUTPUT</label>\n                <label class=\"control-label col-md-2 text-align-left\">INPUT</label>\n            </div>\n            <div class=\"form-group\"\n                 ng-repeat=\"audioChannelMap in $ctrl.visibleAudioChannelMaps\"\n                 ng-if=\"$index < 16\">\n                <label class=\"control-label col-md-2\" for=\"{{$ctrl.channelMapGroup.type}}Maps{{$ctrl.channelMapGroup.index}}_{{audioChannelMap.input}}Input\">Channel {{(audioChannelMap.output * 1)+\n                    1}}</label>\n                <div class=\"col-sm-8 pad-text-input-col\">\n                    <input type=\"number\" class=\"prism-text-input\"\n                           min=\"1\" max=\"32\" step=\"1\" pattern=\"\\d*\"\n                           ng-model=\"audioChannelMap._userInput\"\n                           ng-change=\"$ctrl.onInputChange(audioChannelMap)\"\n                           ng-if=\"!$ctrl.isInputDisabled(audioChannelMap)\"\n                           id=\"{{$ctrl.channelMapGroup.type}}Maps{{$ctrl.channelMapGroup.index}}_{{audioChannelMap.input}}Input\"/>\n                    <input\n                        class=\"prism-text-input\"\n                        disabled\n                        id=\"{{$ctrl.channelMapGroup.type}}Maps{{$ctrl.channelMapGroup.index}}_{{audioChannelMap.input}}Input\"\n                        ng-if=\"$ctrl.isInputDisabled(audioChannelMap)\"\n                        placeholder=\"---\"\n                        type=\"text\"/>\n                </div>\n            </div>\n        </div>\n        <div class=\"col-md-6 column\"\n            ng-if=\"$ctrl.visibleAudioChannelMaps.length > 16\">\n            <div class=\"row clearfix spacer-top-lg\">\n                <label class=\"control-label col-md-2\">OUTPUT</label>\n                <label class=\"control-label col-md-2 text-align-left\">INPUT</label>\n            </div>\n            <div class=\"form-group\"\n                 ng-repeat=\"audioChannelMap in $ctrl.visibleAudioChannelMaps\"\n                 ng-if=\"$index > 15\">\n                <label class=\"control-label col-md-2 for=\"{{$ctrl.channelMapGroup.type}}Maps{{$ctrl.channelMapGroup.index}}_{{audioChannelMap.input}}Input\">Channel {{(audioChannelMap.output * 1)+\n                    1}}</label>\n                <div class=\"col-sm-8 pad-text-input-col\">\n                    <input type=\"number\" class=\"prism-text-input\"\n                           min=\"1\" max=\"32\" step=\"1\" pattern=\"\\d*\"\n                           ng-model=\"audioChannelMap._userInput\"\n                           ng-change=\"$ctrl.onInputChange(audioChannelMap)\"\n                           ng-if=\"!$ctrl.isInputDisabled(audioChannelMap)\"\n                           id=\"{{$ctrl.channelMapGroup.type}}Maps{{$ctrl.channelMapGroup.index}}_{{audioChannelMap.input}}Input\"/>\n                    <input\n                        class=\"prism-text-input\"\n                        disabled\n                        id=\"{{$ctrl.channelMapGroup.type}}Maps{{$ctrl.channelMapGroup.index}}_{{audioChannelMap.input}}Input\"\n                        ng-if=\"$ctrl.isInputDisabled(audioChannelMap)\"\n                        placeholder=\"---\"\n                        type=\"text\"/>\n                </div>\n            </div>\n        </div>\n    </ng-form>\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/common/delivery/delivery-items-edit-view-delivery-template.html", "<div class=\"edit-view-container\">\n    <div class=\"col-md-12 column\">\n        <div class=\"row\">\n            <div class=\"col-md-2\">\n                <div class=\"prism-form-heading\">\n                    Delivery\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row clearfix\">\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n                <div class=\"row-no-padding\">\n                    <form role=\"form\"\n                          class=\"form-horizontal\">\n\n                        <!-- Username Expression -->\n                        <div class=\"form-group\"\n                             ng-if=\"$ctrl.visibleFormControls.usernameExpression\">\n                            <label class=\"control-label col-md-2\">\n                                Username Expression\n                            </label>\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input\n                                    class=\"prism-text-input\"\n                                    id=\"usernameExpressionInput\"\n                                    ng-model=\"$ctrl.editData.usernameExpression\"\n                                    type=\"text\"/>\n                            </div>\n                        </div>\n\n                        <!-- Password Expression -->\n                        <div class=\"form-group\"\n                             ng-if=\"$ctrl.visibleFormControls.passwordExpression\">\n                            <label class=\"control-label col-md-2\">\n                                Password Expression\n                            </label>\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input\n                                    class=\"prism-text-input\"\n                                    id=\"passwordExpressionInput\"\n                                    ng-model=\"$ctrl.editData.passwordExpression\"\n                                    type=\"text\"/>\n                            </div>\n                        </div>\n\n                        <!-- Naming Scheme -->\n                        <div class=\"form-group\"\n                             ng-if=\"$ctrl.visibleFormControls.namingScheme\">\n                            <label class=\"control-label col-md-2\">\n                                Naming Scheme\n                            </label>\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <textarea\n                                    class=\"prism-text-input break-word\"\n                                    id=\"namingSchemeInput\"\n                                    type=\"text\"\n                                    ng-model=\"$ctrl.editData.filenameExpression\"\n                                    ng-required=\"$ctrl.isFieldRequired(\'namingScheme\')\"\n                                    rows=\"4\">\n                                </textarea>\n                            </div>\n                            <span ng-if=\"$ctrl.isFieldRequired(\'namingScheme\')\">\n                                <div class=\"required-text-input\"\n                                     required\n                                     x-required-indicator></div>\n                            </span>\n                        </div>\n\n                        <!-- Target Path -->\n                        <div class=\"form-group\"\n                             ng-if=\"$ctrl.visibleFormControls.targetPath\">\n                            <label class=\"control-label col-md-2\">\n                                Target Path\n                            </label>\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <textarea\n                                    class=\"prism-text-input break-word\"\n                                    id=\"targetPathInput\"\n                                    ng-model=\"$ctrl.editData.targetPathExpression\"\n                                    rows=\"4\"\n                                    type=\"text\">\n                                </textarea>\n                            </div>\n                        </div>\n\n                        <!-- Component Inventory ID -->\n                        <div class=\"form-group\"\n                             ng-if=\"$ctrl.visibleFormControls.componentInventoryId\">\n                            <label class=\"control-label col-md-2\">\n                                Component Inventory Id\n                            </label>\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <textarea\n                                    class=\"prism-text-input break-word\"\n                                    id=\"componentInventoryIdInput\"\n                                    ng-model=\"$ctrl.editData.componentInventoryId\"\n                                    rows=\"4\"\n                                    type=\"text\">\n                                </textarea>\n                            </div>\n                        </div>\n\n                        <!-- Delivery Endpoint -->\n                        <div class=\"form-group\"\n                             ng-if=\"$ctrl.visibleFormControls.deliveryEndpoint\">\n                            <label class=\"control-label col-md-2\">\n                                Delivery Endpoint\n                            </label>\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <dropdown-select\n                                    btn-max-width=\"500\"\n                                    btn-min-width=\"300\"\n                                    clearable=\"false\"\n                                    collection=\"$ctrl.availableDeliveryEndpoints\"\n                                    id=\"deliveryEndpointDropdown\"\n                                    label-field=\"name\"\n                                    ng-model=\"$ctrl.editData.deliveryEndpoint\"\n                                    prompt=\"Select Delivery Endpoint\"\n                                    required>\n                                </dropdown-select>\n                            </div>\n                        </div>\n\n                        <!-- (Netflix Specific Fields) -->\n                        <div ng-include=\"\'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/common/delivery/renderers/delivery-items-edit-view-delivery-component-netflix-renderer-template.html\'\">\n                        </div>\n\n                        <!-- Delivery Priority -->\n                        <div class=\"form-group\"\n                             ng-if=\"$ctrl.visibleFormControls.deliveryPriority\">\n                            <label class=\"control-label col-md-2\">\n                                Delivery Priority\n                            </label>\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <dropdown-select\n                                    btn-max-width=\"500\"\n                                    btn-min-width=\"300\"\n                                    clearable=\"false\"\n                                    collection=\"$ctrl.availableDeliveryPriorities\"\n                                    default-select-index=\"0\"\n                                    id=\"deliveryPriorityDropdown\"\n                                    label-function=\"$ctrl.transformDeliveryPriorityLabel\"\n                                    ng-model=\"$ctrl.editData.deliveryPriority\"\n                                    prompt=\"Select Delivery Priority\"\n                                    required>\n                                </dropdown-select>\n                            </div>\n                        </div>\n\n                        <!-- Delivery Delay -->\n                        <div class=\"form-group\"\n                             ng-if=\"$ctrl.visibleFormControls.deliveryDelay\">\n                            <label class=\"control-label col-md-2\"\n                                   for=\"deliveryDelayInput\">\n                                Delivery Delay\n                            </label>\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input class=\"prism-text-input\"\n                                       ng-model=\"$ctrl.editData.deliveryDelaySeconds\"\n                                       id=\"deliveryDelayInput\"/>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<br/>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/common/general/delivery-items-edit-view-general-template.html", "<div class=\"edit-view-container\">\n    <div class=\"col-md-12 column\">\n        <div class=\"row\">\n            <div class=\"col-md-2\">\n                <div class=\"prism-form-heading\">General</div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row clearfix\">\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n                <div class=\"row-no-padding\">\n                    <form role=\"form\" class=\"form-horizontal\">\n                        <div class=\"form-group\" ng-if=\"$ctrl.visibleFormControls.type\">\n                            <label class=\"control-label col-md-2\">Type</label>\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <span class=\"form-control-static\" id=\"type\">{{$ctrl.editData.sourceType === \'ARTWORK_IMAGE\' ? \'Artwork\' : $ctrl.editData.type}}\n                                </span>\n                            </div>\n                        </div>\n                        <div class=\"form-group\" ng-if=\"$ctrl.visibleFormControls.name\">\n                            <label class=\"control-label col-md-2\">Name</label>\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input type=\"text\" class=\"prism-text-input\"\n                                       ng-model=\"$ctrl.editData.name\"\n                                       id=\"nameInput\"/>\n                            </div>\n                        </div>\n                        <div class=\"form-group\" ng-if=\"$ctrl.visibleFormControls.includeMd5Values\">\n                            <label for=\"includeMd5ValuesCheckbox\"\n                                   class=\"col-sm-2 control-label\">Include MD5 Values</label>\n                            <div class=\"col-sm-1 partner-nielsen-enabled-cb\">\n                                <input type=\"checkbox\"\n                                       id=\"includeMd5ValuesCheckbox\"\n                                       ng-model=\"$ctrl.editData.md5ChecksumFlag\"/>\n                                <label for=\"includeMd5ValuesCheckbox\">&nbsp;</label>\n                            </div>\n                        </div>\n                        <div class=\"form-group\" ng-if=\"$ctrl.visibleFormControls.byteOrderMark\">\n                            <label for=\"byteOrderMarkCheckbox\"\n                                   class=\"col-sm-2 control-label\">Byte Order Mark</label>\n                            <div class=\"col-sm-1 partner-nielsen-enabled-cb\">\n                                <input type=\"checkbox\"\n                                       id=\"byteOrderMarkCheckbox\"\n                                       ng-model=\"$ctrl.editData.byteOrderMarkFlag\"/>\n                                <label for=\"byteOrderMarkCheckbox\">&nbsp;</label>\n                            </div>\n                        </div>\n                        <div class=\"form-group\" ng-if=\"$ctrl.visibleFormControls.deliveryConditionTemplate\">\n                            <label class=\"control-label col-md-2\">Delivery Condition Template</label>\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <dropdown-select id=\"typeDropdown\"\n                                                 ng-model=\"$ctrl.deliveryConditions\"\n                                                 clearable=\"true\"\n                                                 btn-min-width=\"300\"\n                                                 btn-max-width=\"500\"\n                                                 ng-change=\"$ctrl.handleDeliveryConditionTemplateChange()\"\n                                                 prompt=\"Select Delivery Condition Template\"\n                                                 label-field=\"name\"\n                                                 collection=\"$ctrl.conditionalTemplates\">\n                                </dropdown-select>\n                            </div>\n                        </div>\n                        <div class=\"form-group\" ng-if=\"$ctrl.visibleFormControls.requiredForDelivery\">\n                            <label for=\"requiredForDeliveryCheckbox\"\n                                   class=\"col-sm-2 control-label\">Required For Delivery</label>\n                            <div class=\"col-sm-1 partner-nielsen-enabled-cb\">\n                                <input type=\"checkbox\"\n                                       id=\"requiredForDeliveryCheckbox\"\n                                       ng-model=\"$ctrl.editData.requiredForDelivery\"/>\n                                <label for=\"requiredForDeliveryCheckbox\">&nbsp;</label>\n                            </div>\n                        </div>\n                        <div class=\"form-group\" ng-if=\"$ctrl.visibleFormControls.ccRequiredForDelivery\">\n                            <label for=\"ccRequiredForDeliveryCheckbox\"\n                                   class=\"col-sm-2 control-label\">CC Required For Delivery</label>\n                            <div class=\"col-sm-1 partner-nielsen-enabled-cb\">\n                                <input type=\"checkbox\"\n                                       id=\"ccRequiredForDeliveryCheckbox\"\n                                       ng-model=\"$ctrl.editData.requiredForDelivery\"/>\n                                <label for=\"ccRequiredForDeliveryCheckbox\">&nbsp;</label>\n                            </div>\n                        </div>\n                        <div class=\"form-group\" ng-if=\"$ctrl.visibleFormControls.embargoManifestFlag\">\n                            <label for=\"embargoManifestFlagCheckbox\"\n                                   class=\"col-sm-2 control-label\">Pre - Delivery Manifest</label>\n                            <div class=\"col-sm-1 partner-nielsen-enabled-cb\">\n                                <input type=\"checkbox\"\n                                       id=\"embargoManifestFlagCheckbox\"\n                                       ng-model=\"$ctrl.editData.embargoManifestFlag\"/>\n                                <label for=\"embargoManifestFlagCheckbox\">&nbsp;</label>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<br>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/common/from/delivery-items-edit-view-from-template.html", "<div class=\"edit-view-container\">\n\n    <div class=\"col-md-12 column\">\n        <div class=\"row\">\n            <div class=\"col-md-2\">\n                <div class=\"prism-form-heading\">\n                    From\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"row clearfix\">\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n                <div class=\"row-no-padding\">\n                    <form role=\"form\"\n                          class=\"form-horizontal\">\n\n                        <!-- Source MAP -->\n                        <div class=\"form-group\"\n                             ng-if=\"$ctrl.visibleFormControls.profile\">\n                            <label class=\"control-label col-md-2\">\n                                Source Media Accept Profile\n                            </label>\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <dropdown-select\n                                    btn-max-width=\"500\"\n                                    btn-min-width=\"300\"\n                                    clearable=\"false\"\n                                    collection=\"$ctrl.mediaAcceptProfiles\"\n                                    id=\"profileDropdown\"\n                                    label-field=\"name\"\n                                    ng-model=\"$ctrl.editData.sourceMediaAcceptProfile\"\n                                    prompt=\"Select Profile\"\n                                    required>\n                                </dropdown-select>\n                            </div>\n                        </div>\n\n                        <!-- Delivery Mode -->\n                        <div class=\"form-group\"\n                             ng-if=\"$ctrl.visibleFormControls.deliveryMode\">\n                            <label class=\"control-label col-md-2\">Delivery Mode</label>\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <dropdown-select\n                                    btn-max-width=\"500\"\n                                    btn-min-width=\"300\"\n                                    clearable=\"!$ctrl.isFieldRequired(\'deliveryMode\')\"\n                                    collection=\"$ctrl.deliveryModes\"\n                                    id=\"deliveryModeDropdown\"\n                                    label-field=\"displayName\"\n                                    label-function=\"$ctrl.transformDeliveryModeLabel\"\n                                    model-prop=\"id\"\n                                    ng-change=\"$ctrl.onDeliveryModeChanged()\"\n                                    ng-model=\"$ctrl.editData.mode\"\n                                    ng-required=\"$ctrl.isFieldRequired(\'deliveryMode\')\"\n                                    prompt=\"Select Delivery Mode\"\n                                    value-prop=\"displayName\">\n                                </dropdown-select>\n                            </div>\n                        </div>\n\n                        <!-- Languages -->\n                        <div class=\"form-group\"\n                             ng-if=\"$ctrl.visibleFormControls.languages\">\n                            <label class=\"control-label col-md-2\">\n                                Languages\n                            </label>\n                            <div class=\"col-sm-4\">\n                                <delivery-items-from-languages-search-view\n                                    edit-data=\"$ctrl.editData\"\n                                    languages=\"$ctrl.languages\">\n                                </delivery-items-from-languages-search-view>\n                            </div>\n                        </div>\n\n                        <!-- Roles -->\n                        <div class=\"form-group\"\n                             ng-if=\"$ctrl.visibleFormControls.roles\">\n                            <label class=\"control-label col-md-2\">\n                                {{$ctrl.roleType}} Roles\n                            </label>\n                            <div class=\"col-sm-4\">\n                                <delivery-items-from-roles-search-view\n                                    edit-data=\"$ctrl.editData\"\n                                    roles=$ctrl.roles\n                                    role-type=\"$ctrl.roleType\">\n                                </delivery-items-from-roles-search-view>\n                            </div>\n                        </div>\n\n                    </form>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<br>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/common/to/delivery-items-edit-view-to-template.html", "<div class=\"edit-view-container\">\n    <div class=\"col-md-12 column\">\n        <div class=\"row\">\n            <div class=\"col-md-2\">\n                <div class=\"prism-form-heading\">To</div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row clearfix\">\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n                <div class=\"row-no-padding\">\n                    <form role=\"form\" class=\"form-horizontal\">\n                        <conversion-template-dropdown\n                            ng-if=\"$ctrl.visibleFormControls.templateDropdown\"\n                            collection=\"$ctrl.availableMediaConversionTemplates\"\n                            default-template-type=\"$ctrl.nullTemplateType\"\n                            ng-model=\"$ctrl.editData.mediaConversionTemplate\"\n                            id=\"conversionTemplate\"\n                            ng-required=\"$ctrl.isTemplateRequired()\"\n                            force-type-required=\"true\"\n                            type-prompt=\"Select Template Type\"\n                            template-prompt-suffix=\"Template\"\n                            include-passthrough=\"true\"\n                            type-tooltip-template=\"$ctrl.tooltipTemplate\"\n                            type-tooltip-class=\"preview-tooltip\"\n                            prompt-width=\"2\"\n                            on-type-change=\"$ctrl.onTemplateTypeChanged(type)\"\n                        ></conversion-template-dropdown>\n\n                        <div class=\"form-group\" ng-if=\"$ctrl.visibleFormControls.forceVantageComposition\">\n                            <label for=\"forceVantageCompositionCheckbox\"\n                                   class=\"col-sm-2 control-label\">Force Vantage Composition</label>\n                            <div class=\"col-sm-1 partner-nielsen-enabled-cb\">\n                                <input type=\"checkbox\"\n                                       id=\"forceVantageCompositionCheckbox\"\n                                       ng-model=\"$ctrl.editData.vantageCompositionFlag\"/>\n                                <label for=\"forceVantageCompositionCheckbox\">&nbsp;</label>\n                            </div>\n                        </div>\n                        <div class=\"form-group\"\n                             ng-if=\"$ctrl.visibleFormControls.vantageProcessorName && $ctrl.editData.vantageCompositionFlag\">\n                            <label class=\"control-label col-md-2\">Vantage Composition Processor Name</label>\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input type=\"text\" class=\"prism-text-input\"\n                                       ng-model=\"$ctrl.editData.vantageCompositionProcessorName\"\n                                       id=\"vantageProcessorNameInput\"/>\n                            </div>\n                        </div>\n                        <div class=\"form-group\"\n                             ng-if=\"$ctrl.visibleFormControls.fadeInDuration\">\n                            <label class=\"control-label col-md-2\">Fade In Duration (Seconds)</label>\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input type=\"text\" class=\"prism-text-input\"\n                                       ng-model=\"$ctrl.editData.fadeInSeconds\"\n                                       id=\"fadeInDurationInput\"/>\n                            </div>\n                        </div>\n                        <div class=\"form-group\"\n                             ng-if=\"$ctrl.visibleFormControls.fadeOutDuration\">\n                            <label class=\"control-label col-md-2\">Fade Out Duration (Seconds)</label>\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input type=\"text\" class=\"prism-text-input\"\n                                       ng-model=\"$ctrl.editData.fadeOutSeconds\"\n                                       id=\"fadeOutDurationInput\"/>\n                            </div>\n                        </div>\n                        <div class=\"form-group\"\n                             ng-if=\"$ctrl.visibleFormControls.startTimecode\">\n                            <label class=\"control-label col-md-2\">Start Timecode</label>\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input type=\"text\" class=\"prism-text-input\"\n                                       ng-model=\"$ctrl.editData.startTimecodeExpression\"\n                                       id=\"startTimecodeExpressionInput\"/>\n                            </div>\n                        </div>\n                        <div class=\"form-group\" ng-if=\"$ctrl.visibleFormControls.disableNielsenWatermarking\">\n                            <label for=\"disableNielsenWatermarkingCheckbox\"\n                                   class=\"col-sm-2 control-label\">Disable Nielsen Watermarking</label>\n                            <div class=\"col-sm-1 partner-nielsen-enabled-cb\">\n                                <input type=\"checkbox\"\n                                       id=\"disableNielsenWatermarkingCheckbox\"\n                                       ng-model=\"$ctrl.editData.nielsenDisabledFlag\"/>\n                                <label for=\"disableNielsenWatermarkingCheckbox\">&nbsp;</label>\n                            </div>\n                        </div>\n                        <div class=\"form-group\" ng-if=\"$ctrl.visibleFormControls.disableNexGuardWatermarking\">\n                            <label for=\"disableNexGuardWatermarkingCheckbox\"\n                                   class=\"col-sm-2 control-label\">Disable NexGuard Watermarking</label>\n                            <div class=\"col-sm-1 partner-nielsen-enabled-cb\">\n                                <input type=\"checkbox\"\n                                       id=\"disableNexGuardWatermarkingCheckbox\"\n                                       ng-model=\"$ctrl.editData.nexGuardDisabled\"/>\n                                <label for=\"disableNexGuardWatermarkingCheckbox\">&nbsp;</label>\n                            </div>\n                        </div>\n\n                        <div class=\"form-group\"\n                             ng-if=\"$ctrl.visibleFormControls.activePixelsWidth\">\n                            <label class=\"control-label col-md-2\">Active Pixels Width</label>\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input type=\"text\" class=\"prism-text-input\"\n                                       ng-model=\"$ctrl.editData.activePixelsWidth\"\n                                       id=\"activePixelsWidthInput\"/>\n                            </div>\n                        </div>\n                        <div class=\"form-group\"\n                             ng-if=\"$ctrl.visibleFormControls.activePixelsHeight\">\n                            <label class=\"control-label col-md-2\">Active Pixels Height</label>\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input type=\"text\" class=\"prism-text-input\"\n                                       ng-model=\"$ctrl.editData.activePixelsHeight\"\n                                       id=\"activePixelsHeightInput\"/>\n                            </div>\n                        </div>\n\n                        <div class=\"form-group\" ng-if=\"$ctrl.visibleFormControls.closedCaptionsSubtitleProfile\">\n                            <label class=\"control-label col-md-2\">Profile</label>\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <dropdown-select id=\"closedCaptionsSubtitleProfileDropdown\"\n                                                 ng-model=\"$ctrl.editData.targetContentTemplate\"\n                                                 required\n                                                 clearable=\"false\"\n                                                 btn-min-width=\"300\"\n                                                 btn-max-width=\"500\"\n                                                 ng-change=\"$ctrl.onTemplateTypeChanged()\"\n                                                 prompt=\"Select Profile\"\n                                                 label-field=\"name\"\n                                                 tooltip-class=\"preview-tooltip\"\n                                                 collection=\"$ctrl.availableClosedCaptionAssetContentTemplates\"\n                                </dropdown-select>\n                            </div>\n                        </div>\n                        <div class=\"form-group\" ng-if=\"$ctrl.visibleFormControls.metaDataProfile\">\n                            <label class=\"control-label col-md-2\">Profile</label>\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <dropdown-select id=\"metaDataProfileDropdown\"\n                                                 ng-model=\"$ctrl.editData.xslTemplate\"\n                                                 required\n                                                 clearable=\"false\"\n                                                 btn-min-width=\"300\"\n                                                 btn-max-width=\"500\"\n                                                 ng-change=\"$ctrl.onTemplateTypeChanged()\"\n                                                 prompt=\"Select Profile\"\n                                                 label-field=\"name\"\n                                                 tooltip-class=\"preview-tooltip\"\n                                                 collection=\"$ctrl.transformTemplates\"\n                                </dropdown-select>\n                            </div>\n                        </div>\n                        <div class=\"form-group\" ng-if=\"$ctrl.visibleFormControls.macCaptionTemplate\">\n                            <label class=\"control-label col-md-2\">Mac Caption Template</label>\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <dropdown-select id=\"macCaptionTemplateDropdown\"\n                                                 ng-model=\"$ctrl.editData.macCaptionTemplate\"\n                                                 clearable=\"true\"\n                                                 btn-min-width=\"300\"\n                                                 btn-max-width=\"500\"\n                                                 ng-change=\"$ctrl.onTemplateTypeChanged()\"\n                                                 label-field=\"name\"\n                                                 prompt=\"Select Mac Caption Template\"\n                                                 tooltip-class=\"preview-tooltip\"\n                                                 collection=\"$ctrl.macCaptionTemplates\"\n                                </dropdown-select>\n                            </div>\n                        </div>\n                        <div class=\"form-group\" ng-if=\"$ctrl.visibleFormControls.imageTemplate\">\n                            <label class=\"control-label col-sm-2\">Image Template</label>\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <dropdown-select id=\"imageTemplateDropdown\"\n                                                 ng-model=\"$ctrl.editData.targetContentTemplate\"\n                                                 required\n                                                 clearable=\"false\"\n                                                 btn-min-width=\"300\"\n                                                 btn-max-width=\"500\"\n                                                 prompt=\"Select Image Template\"\n                                                 label-field=\"name\"\n                                                 collection=\"$ctrl.availableImageAssetContentTemplates\"\n                                </dropdown-select>\n                            </div>\n                        </div>\n\n                        <div class=\"form-group\" ng-if=\"$ctrl.visibleFormControls.vantageVideoNickname\">\n                            <label class=\"control-label col-md-2\">Vantage Video Nickname</label>\n                            <div class=\"col-sm-4 pad-text-input-col\">\n                                <input type=\"text\" class=\"prism-text-input\"\n                                       ng-model=\"$ctrl.editData.vantageVideoNickname\"\n                                       id=\"vantageVideoNicknameInput\"/>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </div>\n        </div>\n\n        <fieldset ng-if=\"$ctrl.visibleFormControls.conversionTemplateVariables\">\n            <div class=\"col-md-12 column\">\n                <div class=\"row\">\n                    <div class=\"col-md-2\">\n                        <div class=\"prism-form-heading\">Hybrik Template Variables</div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-md-12 column\">\n                <custom-metadata components-map=\"$ctrl.conversionTemplateVariableComponentsMap\"\n                                 id-prefix=\"\'conversionTemplateVariables\'\">\n                </custom-metadata>\n            </div>\n        </fieldset>\n    </div>\n</div>\n<br>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/common/to/to-panel-template-type-tooltip-template.html", "<form role=\"form\" class=\"form-horizontal\">\n    <div class=\"edit-view-container\">\n        <div class=\"form-group preview-tooltip\" ng-class=\"{\'large\': tooltipData == \'Vantage\'}\">\n\n            <!-- Vantage -->\n            <div class=\"row-no-padding\" ng-if=\"tooltipData == \'Vantage\'\">\n                <label class=\"control-label\">Vantage-Specific Fields</label>\n            </div>\n            <div ng-if=\"tooltipData == \'Vantage\'\">\n                <div class=\"form-group\">\n                    <label class=\"control-label col-sm-4\">Vantage Template</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <dropdown-select id=\"mediaConversionTemplateDropdown\"\n                                         ng-model=\"$ctrl.editData.mediaConversionTemplateTooltip\"\n                                         required\n                                         clearable=\"false\"\n                                         btn-min-width=\"200\"\n                                         prompt=\"Select Template\"\n                                         collection=\"[]\"\n                        </dropdown-select>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label for=\"forceVantageCompositionCheckbox\"\n                           class=\"col-sm-4 control-label\">Force Vantage Composition</label>\n                    <div class=\"col-sm-6 partner-nielsen-enabled-cb\">\n                        <input type=\"checkbox\"\n                               id=\"forceVantageCompositionCheckbox\"\n                               ng-model=\"$ctrl.editData.vantageCompositionFlag\"/>\n                        <label for=\"forceVantageCompositionCheckbox\">&nbsp;</label>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"control-label col-sm-4\">Vantage Composition Processor Name</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <input type=\"text\" class=\"prism-text-input\"\n                               ng-model=\"$ctrl.editData.vantageCompositionProcessorName\"\n                               id=\"vantageProcessorNameInput\"/>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"control-label col-sm-4\">Fade In Duration (Seconds)</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <input type=\"text\" class=\"prism-text-input\"\n                               ng-model=\"$ctrl.editData.fadeInSeconds\"\n                               id=\"fadeInDurationInput\"/>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"control-label col-sm-4\">Fade Out Duration (Seconds)</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <input type=\"text\" class=\"prism-text-input\"\n                               ng-model=\"$ctrl.editData.fadeOutSeconds\"\n                               id=\"fadeOutDurationInput\"/>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"control-label col-sm-4\">Start Timecode</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <input type=\"text\" class=\"prism-text-input\"\n                               ng-model=\"$ctrl.editData.startTimecodeExpression\"\n                               id=\"startTimecodeExpressionInput\"/>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label for=\"disableNielsenWatermarkingCheckbox\"\n                           class=\"col-sm-4 control-label\">Disable Nielsen Watermarking</label>\n                    <div class=\"col-sm-6 partner-nielsen-enabled-cb\">\n                        <input type=\"checkbox\"\n                               id=\"disableNielsenWatermarkingCheckbox\"\n                               ng-model=\"$ctrl.editData.nielsenDisabledFlag\"/>\n                        <label for=\"disableNielsenWatermarkingCheckbox\">&nbsp;</label>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label for=\"disableNexGuardWatermarkingCheckbox\"\n                           class=\"col-sm-4 control-label\">Disable NexGuard Watermarking</label>\n                    <div class=\"col-sm-6 partner-nexguard-enabled-cb\">\n                        <input type=\"checkbox\"\n                               id=\"disableNexGuardWatermarkingCheckbox\"\n                               ng-model=\"$ctrl.editData.nexGuardDisabled\"/>\n                        <label for=\"disableNexGuardWatermarkingCheckbox\">&nbsp;</label>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"control-label col-sm-4\">Min Split Duration (Seconds)</label>\n                    <div class=\"col-sm-6 pad-text-input-col\">\n                        <input type=\"text\" class=\"prism-text-input\"\n                               ng-model=\"$ctrl.editData.snsMinDurationSeconds\"\n                               id=\"maxDurationInput\"/>\n                    </div>\n                </div>\n            </div>\n\n            <!-- FFmpeg -->\n            <div class=\"row-no-padding\" ng-if=\"tooltipData == \'FFmpeg\'\">\n                <label class=\"control-label\">FFmpeg-Specific Fields</label>\n            </div>\n            <div ng-if=\"tooltipData == \'FFmpeg\'\">\n                (none)\n            </div>\n\n            <!-- Hybrik -->\n            <div class=\"row-no-padding\" ng-if=\"tooltipData == \'Hybrik\'\">\n                <label class=\"control-label\">Hybrik-Specific Fields</label>\n            </div>\n            <div ng-if=\"tooltipData == \'Hybrik\'\">\n                <div class=\"col-md-12 column\">\n                    <div class=\"row\">\n                        <div class=\"col-md-2\">\n                            <div class=\"prism-form-heading\">Hybrik Template Variables</div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"col-md-12 column\">\n                    <custom-metadata components-map=\"$ctrl.conversionTemplateVariableComponentsMap\"\n                                     id-prefix=\"\'conversionTemplateVariablesTooltip\'\">\n                    </custom-metadata>\n                </div>\n            </div>\n\n            <!-- MediaConvert -->\n            <div class=\"row-no-padding\" ng-if=\"tooltipData == \'MediaConvert\'\">\n                <label class=\"control-label\">MediaConvert-Specific Fields</label>\n            </div>\n            <div ng-if=\"tooltipData == \'MediaConvert\'\">\n                (none)\n            </div>\n\n            <!-- Passthrough -->\n            <div class=\"row-no-padding\" ng-if=\"tooltipData == \'Passthrough\'\">\n                <label class=\"control-label\">Passthrough-Specific Fields</label>\n            </div>\n            <div ng-if=\"tooltipData == \'Passthrough\'\">\n                (none)\n            </div>\n        </div>\n    </div>\n</form>\n<br>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/common/partnerFormat/delivery-items-edit-view-partner-format-template.html", "<div class=\"edit-view-container\">\n    <div class=\"col-md-12 column\">\n        <div class=\"row\">\n            <div class=\"col-md-2\">\n                <div class=\"prism-form-heading\">Partner Format</div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row clearfix\">\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n                <div class=\"row-no-padding\">\n                    <form role=\"form\" class=\"form-horizontal\">\n                        <div class=\"form-group\">\n                            <label class=\"control-label col-md-2\">Finance Format</label>\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input type=\"text\" class=\"prism-text-input\"\n                                       ng-model=\"$ctrl.editData.financeFormat\"\n                                       id=\"namingSchemeInput\"/>\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"control-label col-md-2\">Finance Recovery Fee</label>\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <input type=\"text\" class=\"prism-text-input\"\n                                       ng-model=\"$ctrl.editData.financeRecoveryFee\"\n                                       id=\"targetPathInput\"/>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<br>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/common/redelivery/delivery-items-edit-view-redelivery-template.html", "<div class=\"edit-view-container\">\n    <div class=\"col-md-12 column\">\n        <div class=\"row\">\n            <div class=\"col-md-2\">\n                <div class=\"prism-form-heading\">Redelivery</div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row clearfix\">\n        <div class=\"row clearfix spacer-top-lg\">\n            <div class=\"col-md-12 column\">\n                <div class=\"row-no-padding\">\n                    <form role=\"form\" class=\"form-horizontal\">\n                        <div class=\"form-group\">\n                            <label class=\"control-label col-md-2\">Naming Scheme</label>\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <textarea type=\"text\" class=\"prism-text-input break-word\"\n                                          ng-model=\"$ctrl.editData.redeliveryFilenameExpression\"\n                                          rows=\"4\"\n                                          id=\"namingSchemeInput\"></textarea>\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"control-label col-md-2\">Target Path</label>\n                            <div class=\"col-sm-8 pad-text-input-col\">\n                                <textarea type=\"text\" class=\"prism-text-input break-word\"\n                                          ng-model=\"$ctrl.editData.redeliveryTargetPathExpression\"\n                                          rows=\"4\"\n                                          id=\"targetPathInput\"></textarea>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<br>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/common/delivery/renderers/delivery-items-edit-view-delivery-component-netflix-renderer-template.html", "<!--\n\n    Netflix Specific Fields\n\n  -->\n\n<div ng-if=\"$ctrl.showNetflixFields()\">\n\n    <!-- Netflix Request ID -->\n    <div class=\"form-group\">\n        <label class=\"control-label col-md-2\">Netflix Request ID</label>\n        <div class=\"col-sm-8 pad-text-input-col\">\n            <dropdown-select\n                btn-max-width=\"500\"\n                btn-min-width=\"300\"\n                clearable=\"false\"\n                collection=\"$ctrl.availablePartnerMetadataProperties\"\n                id=\"netflixRequestIdDropdown\"\n                label-field=\"displayName\"\n                model-prop=\"displayName\"\n                ng-model=\"$ctrl.editData.netflixRequestId\"\n                prompt=\"Select Partner Metadata Field\"\n                required>\n            </dropdown-select>\n        </div>\n    </div>\n\n    <!-- Netflix Channel Mapping -->\n    <div class=\"form-group\">\n        <label class=\"control-label col-md-2\">Netflix Channel Mapping</label>\n        <div class=\"col-sm-8 pad-text-input-col\">\n            <dropdown-select\n                btn-max-width=\"500\"\n                btn-min-width=\"300\"\n                clearable=\"false\"\n                collection=\"$ctrl.availableNetflixChannelMappings\"\n                id=\"netflixChannelMappingDropdown\"\n                ng-model=\"$ctrl.editData.netflixChannelMapping\"\n                prompt=\"Select Netflix Channel Mapping\"\n                required>\n            </dropdown-select>\n        </div>\n    </div>\n\n</div>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/common/from/languagesGrid/delivery-items-from-languages-grid-template.html", "<form name=\"$ctrl.editorForm\">\n    <span class=\"pull-left padding-right-md\">\n        <input type=\"radio\"\n               id=\"allLanguagesRadio\"\n               ng-model=\"$ctrl.languageRadioSelection\"\n               ng-change=\"$ctrl.handleLanguageRadioSelectionChanged()\"\n               class=\"radio-button\"\n               ng-value=\"\'All\'\">\n        <label class=\"control-label\"\n               for=\"allLanguagesRadio\">\n            All\n        </label>\n    </span>\n    <span>\n    <input type=\"radio\"\n           id=\"customLanguagesRadio\"\n           ng-model=\"$ctrl.languageRadioSelection\"\n           ng-change=\"$ctrl.handleLanguageRadioSelectionChanged()\"\n           class=\"radio-button pull-left\"\n           ng-value=\"\'Custom\'\">\n    <label class=\"control-label\"\n           for=\"customLanguagesRadio\">\n        Custom\n    </label>\n</span>\n    <br>\n    <div id=\"deliveryItemsFromPanelLanguagesGrid\"\n         ng-if=\"$ctrl.showGrid &&  $ctrl.languageRadioSelection === \'Custom\'\"\n         class=\"grid search-grid\"\n         ng-class=\"{\'grid-disabled\' : $ctrl.languageRadioSelection === \'All\'}\"\n         ui-grid=\"$ctrl.gridOptions\"\n         ui-grid-selection\n         style=\"max-height: 305px;\"\n         ui-grid-resize-columns>\n    </div>\n</form>\n");
        $templateCache.put("system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/common/from/rolesGrid/delivery-items-from-roles-grid-template.html", "<form name=\"$ctrl.editorForm\">\n    <span class=\"pull-left padding-right-md\">\n        <input type=\"radio\"\n               id=\"allRolesRadio\"\n               ng-model=\"$ctrl.roleRadioSelection\"\n               ng-change=\"$ctrl.handleRoleRadioSelectionChanged()\"\n               class=\"radio-button\"\n               ng-value=\"\'All\'\">\n        <label class=\"control-label\"\n               for=\"allRolesRadio\">\n            All\n        </label>\n    </span>\n    <span>\n    <input type=\"radio\"\n           id=\"customRolesRadio\"\n           ng-model=\"$ctrl.roleRadioSelection\"\n           ng-change=\"$ctrl.handleRoleRadioSelectionChanged()\"\n           class=\"radio-button pull-left\"\n           ng-value=\"\'Custom\'\">\n    <label class=\"control-label\"\n           for=\"customRolesRadio\">\n        Custom\n    </label>\n</span>\n    <br>\n    <div id=\"deliveryItemsFromPanelRolesGrid\"\n         ng-if=\"$ctrl.showGrid &&  $ctrl.roleRadioSelection === \'Custom\'\"\n         class=\"grid search-grid\"\n         ng-class=\"{\'grid-disabled\' : $ctrl.roleRadioSelection === \'All\'}\"\n         ui-grid=\"$ctrl.gridOptions\"\n         ui-grid-selection\n         style=\"max-height: 305px;\"\n         ui-grid-resize-columns>\n    </div>\n</form>\n");
    }]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by richardwilliams on 3/25/15.
 */
'use strict';
angular
    .module('prism-ui.components', ['reachEngine.authentication',
    'reachEngine.user',
    'prism-ui.components.branding',
    'prism-ui.components.data',
    'prism-ui.components.filters',
    'prism-ui.components.navigation',
    'prism-ui.externalMetadata',
    'prism-ui.system',
    'ui.grid.edit',
    'ui.grid.autoResize',
    'ui.grid.selection',
    'angularMoment',
    'ngSanitize',
    'com.2fdevs.videogular',
    'com.2fdevs.videogular.plugins.controls',
    'com.2fdevs.videogular.plugins.overlayplay',
    'com.2fdevs.videogular.plugins.poster'])
    .constant('_', window._)
    .constant('Rx', window.Rx)
    .constant('X2JS', window.X2JS)
    .constant('AW4', window.AW4)
    .constant('AWS', window.AWS);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 2/24/15.
 */
'use strict';
angular.module('prism-ui.package', [
    'ngRoute',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'ui.grid.saveState',
    'ui.grid.treeView',
    'ui.grid.cellNav',
    'prism-ui.components',
    'prism-ui.components.navigation',
    'prism-ui.components.filters'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: branding-module
 *
 * Created by rwilliams on 8/4/17.
 */
'use strict';
angular.module('prism-ui.components.branding', [
    'ngRoute',
    'reachEngine.authentication',
    'reachEngine.user',
    'ui.bootstrap',
    'prism-ui.components.data',
    'prism-ui.content',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'ui.grid.treeView',
    'ui.grid.cellNav'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by richardwilliams on 3/31/15.
 */
'use strict';
angular
    .module('prism-ui.components.data', ['prism-ui.config', 'ngResource', 'prism-ui.components'])
    .constant('_', window._);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 7/31/15.
 */
'use strict';
angular.module('prism-ui.components.filters', []);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by richardwilliams on 3/25/15.
 */
'use strict';
angular.module('prism-ui.components.navigation', [
    'prism-ui.components.data',
    'ngRoute',
    'reachEngine.authentication',
    'reachEngine.user',
    'ui.bootstrap',
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 2/2/16.
 */
'use strict';
angular.module('prism-ui.calendars', [
    'ngRoute',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'ui.grid.treeView',
    'prism-ui.components.navigation'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.offCyclePlanners', [
    'ngRoute',
    'reachEngine.authentication',
    'reachEngine.user',
    'ui.bootstrap',
    'prism-ui.components',
    'prism-ui.components.data',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'ui.grid.treeView',
    'ui.grid.cellNav'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.queues', [
    'ngRoute',
    'ui.grid',
    'ui.grid.edit',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'ui.grid.treeView',
    'prism-ui.components.navigation'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.report', [
    'prism-ui.components.data'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.workflows', [
    'ui.grid.saveState',
    'ui.grid.treeView',
    'prism-ui.components.data'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 12/29/15.
 */
'use strict';
angular.module('prism-ui.content', [
    'prism-ui.components.navigation',
    'ngRoute',
    'ui.grid',
    'ui.grid.autoResize',
    'ui.grid.pagination',
    'ui.grid.pinning',
    'ui.grid.resizeColumns',
    'ui.grid.selection',
    'ui.grid.treeView',
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: mvpd-module
 *
 * Created by rwilliams on 10/16/17.
 */
'use strict';
angular.module('prism-ui.mvpd', [
    'prism-ui.components.navigation',
    'ngRoute',
    'ui.grid',
    'ui.grid.autoResize',
    'ui.grid.pagination',
    'ui.grid.pinning',
    'ui.grid.resizeColumns',
    'ui.grid.selection'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: network-module
 *
 * Created by rwilliams on 7/19/17.
 */
'use strict';
angular.module('prism-ui.network', [
    'prism-ui.components.branding',
    'prism-ui.components.navigation',
    'ngRoute',
    'ui.grid',
    'ui.grid.autoResize',
    'ui.grid.pagination',
    'ui.grid.pinning',
    'ui.grid.resizeColumns',
    'ui.grid.selection',
    'ui.grid.treeView',
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 6/17/16.
 */
'use strict';
angular.module('prism-ui.execServers', [
    'ngRoute',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'prism-ui.components.navigation'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: external-metadata-component
 *
 * Created by rwilliams on 10/3/17.
 */
'use strict';
angular.module('prism-ui.externalMetadata', [
    'ngRoute',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'prism-ui.components.navigation',
    'prism-ui.components.data',
    'prism-ui.components.filters'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 1/13/16.
 */
'use strict';
angular.module('prism-ui.livefeed', [
    'ngRoute',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'ui.grid.treeView',
    'prism-ui.components.navigation'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by randysorensen on 8/10/16.
 */
'use strict';
angular
    .module('prism-ui.metadataItems', [
    'ngRoute',
    'prism-ui.components.navigation'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 2/16/16.
 */
'use strict';
angular.module('prism-ui.partner', [
    'ngRoute',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'ui.grid.treeView',
    'prism-ui.components.navigation',
    'prism-ui.components',
    'prism-ui.components.data',
    'prism-ui.components.filters'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 6/17/16.
 */
'use strict';
angular.module('prism-ui.conditionalTemplate', [
    'ngRoute',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'prism-ui.components.navigation'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 4/4/16.
 */
'use strict';
angular.module('prism-ui.ffmpegTemplate', [
    'ngRoute',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'ui.grid.treeView',
    'prism-ui.components.navigation'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.imageTemplate', [
    'ngRoute',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'ui.grid.treeView',
    'prism-ui.components.navigation'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.intermediateTemplate', [
    'ngRoute',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'ui.grid.treeView',
    'prism-ui.components.navigation'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: maccaption-template-module
 *
 * Created by rwilliams on 9/18/17.
 */
'use strict';
angular.module('prism-ui.system.maccaptionTemplate', [
    'ngRoute',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'ui.grid.treeView',
    'prism-ui.components.navigation'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.mediaAcceptProfiles', [
    'ngRoute',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'prism-ui.components.navigation',
    'prism-ui.components.data',
    'prism-ui.components.filters'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.packageAcceptTemplate', [
    'ngRoute',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'prism-ui.components.navigation',
    'prism-ui.components.data',
    'prism-ui.components.filters'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.packageCreationTemplate', [
    'ngRoute',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'prism-ui.components.navigation',
    'prism-ui.components.data',
    'prism-ui.components.filters'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: transform-template-module.js
 *
 * Created by randysorensen on 3/17/17.
 */
'use strict';
angular.module('prism-ui.transformTemplate', [
    'ngRoute',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'ui.grid.treeView',
    'prism-ui.components',
    'prism-ui.components.navigation',
    'prism-ui.components.filters'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 2/24/15,
 * Refactored by kyang on 9/24/20
 */
angular.module('prism-ui.login', ['reachEngine.authentication'])
    .constant('Rx', window.Rx);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: system-module.ts
 *
 * Created by randysorensen on 10/2/17.
 */
'use strict';
angular
    .module('prism-ui.system', [
    'prism-ui.components.data'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: metrics-dashboard-module.ts
 *
 * Created by randysorensen on 2019-02-13.
 */
angular.module('prism-ui.metricsDashboard', [
    'ngRoute',
    'ui.bootstrap',
    'prism-ui.components',
    'prism-ui.components.data',
    'prism-ui.components.navigation',
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: package-checkin-module.js
 *
 * Created by randysorensen on 1/4/18.
 */
'use strict';
angular
    .module('prism-ui.dashboard.checkin', [
    'ngRoute',
    'ui.bootstrap',
    'prism-ui.components',
    'prism-ui.components.data',
    'prism-ui.components.navigation',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'ui.grid.treeView',
    'ui.grid.cellNav',
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: collaborators-module
 *
 * Created by sjacobs on 2/2/18.
 */
'use strict';
angular.module('prism-ui.collaborators', [
    'prism-ui.components.navigation',
    'ngRoute',
    'ui.grid',
    'ui.grid.autoResize',
    'ui.grid.pagination',
    'ui.grid.pinning',
    'ui.grid.resizeColumns',
    'ui.grid.selection'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 2/17/16.
 */
'use strict';
angular.module('prism-ui.assetContentTemplates', [
    'prism-ui.components.data',
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.categories', [
    'ngRoute',
    'ui.grid',
    'ui.grid.edit',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'prism-ui.components.navigation',
    'prism-ui.components.data',
    'prism-ui.components.filters'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 2/17/16.
 */
'use strict';
angular.module('prism-ui.deliveryTemplates', [
    'ngRoute',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'ui.grid.treeView',
    'prism-ui.components.navigation'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 2/17/16.
 */
'use strict';
angular.module('prism-ui.emailTemplates', [
    'ngRoute',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'ui.grid.treeView',
    'prism-ui.components.navigation'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: file-system-module.ts
 *
 * Created by kyang on 2020-09-10.
 */
angular.module('prism-ui.fileSystem', [
    'ngRoute',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.pagination',
    'prism-ui.components.navigation',
    'prism-ui.components.data'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.groups', [
    'ngRoute',
    'ui.grid',
    'ui.grid.selection',
    'prism-ui.components.navigation',
    'prism-ui.components.data',
    'prism-ui.components.filters'
])
    .constant('X2JS', window.X2JS)
    .value('PERMISSION_EXCEPTION_LIST', {
    PACKAGE_VIEW_DOWNLOAD_PROXY_VIEW_STATE: {
        displayName: 'Packages - View/Download Proxies',
        includeOffset: true
    },
    PACKAGE_APPROVE_REJECT_VIEW_STATE: {
        displayName: 'Packages - Approve/Reject',
        includeOffset: false
    },
    PACKAGE_RESTORE_MASTER_MEDIA_VIEW_STATE: {
        displayName: 'Packages - Restore Master Media',
        includeOffset: true
    },
    CLIP_ACTION_RETRIEVE_MASTER_MEDIA_VIEW_STATE: {
        displayName: 'Clips - Retrieve Master Clip Media',
        includeOffset: true
    },
    CLIP_ACTION_VIEW_PROXIES_VIEW_STATE: {
        displayName: 'Clips - View Clip Proxies',
        includeOffset: true
    },
    CLIP_ACTION_DOWNLOAD_PROXIES_VIEW_STATE: {
        displayName: 'Clips - Download Clip Proxies',
        includeOffset: true
    }
})
    .value('APPLICATION_STATE_LIST', {
    packages: {
        parentViewStates: {
            PACKAGE_VIEW_STATE: 'Package'
        },
        childViewStates: {
            packageAction: {
                PACKAGE_SEARCH_VIEW_STATE: 'Packages - Create',
                PACKAGE_DELIVER_VIEW_STATE: 'Packages - Execute/Deliver',
                PACKAGE_MANAGER_DELIVER_VIEW_STATE: 'Packages - Batch Execute/Deliver',
                PACKAGE_SELECT_DELIVERY_CONTENT_VIEW_STATE: 'Packages - Select Package Content',
                PACKAGE_VIEW_DOWNLOAD_PROXY_VIEW_STATE: 'Packages - View/Download Proxies',
                PACKAGE_RECREATE_PROXY_VIEW_STATE: 'Packages - Recreate Proxies',
                PACKAGE_APPROVE_REJECT_VIEW_STATE: 'Packages - Approve/Reject',
                PACKAGE_AD_HOC_ADD_PARTNERS_VIEW_STATE: 'Packages - Ad-Hoc Add Partners',
                PACKAGE_RESTORE_MASTER_MEDIA_VIEW_STATE: 'Packages - Restore Master Media',
                PACKAGE_CLONE_VIEW_STATE: 'Packages - Clone a Package',
                PACKAGE_BATCH_CLONE_VIEW_STATE: 'Packages - Batch Clone Packages',
                PACKAGE_ORD_VIEW_STATE: 'Packages - ORD for Non-Delivered',
                PACKAGE_CREATE_COLLABORATOR_VIEW_STATE: 'Packages - Create Collaborator',
                PACKAGE_BRANDING_VIEW_STATE: 'Packages - Branding'
            },
            packageBasic: {
                PACKAGE_METADATA_VIEW_STATE: 'Package Metadata',
                PACKAGE_COLLABORATORS_VIEW_STATE: 'Package Collaborators',
                PACKAGE_MEDIA_VIEW_STATE: 'Package Media',
                PACKAGE_DISTRIBUTIONGRID_VIEW_STATE: 'Package Distribution',
                ADVANCED_PACKAGE_DISTRIBUTIONGRID_VIEW_STATE: 'Package Advanced Distribution',
                PACKAGE_VIDEO_PREVIEW_VIEW_STATE: 'Package Video Preview',
                PACKAGE_VIDEO_CLIPS_VIEW_STATE: 'Package Video Clips',
                PACKAGE_TIMINGS_VIEW_STATE: 'Package Timings',
                PACKAGE_ADVANCED_METADATA_VIEW_STATE: 'Package Advanced Metadata',
                PACKAGE_COMPLETED_DELIVERIES_VIEW_STATE: 'Package Completed Deliveries',
                PACKAGE_EXTERNAL_INGESTS_VIEW_STATE: 'Package Aggregation'
            },
            packageActionClip: {
                CLIP_ACTION_RESET_VIEW_STATE: 'Clips - Reset',
                CLIP_ACTION_DELIVER_VIEW_STATE: 'Clips - Execute/Deliver',
                CLIP_ACTION_RE_EXTRACT_VIEW_STATE: 'Clips - Re-Extract',
                CLIP_ACTION_VALIDATE_VIEW_STATE: 'Clips - Validate',
                CLIP_ACTION_RETRIEVE_MASTER_MEDIA_VIEW_STATE: 'Clips - Retrieve Master Clip Media',
                CLIP_ACTION_HIDE_VIEW_STATE: 'Clips - Hide/Show Hidden',
                CLIP_ACTION_VIEW_PROXIES_VIEW_STATE: 'Clips - View Clip Proxies',
                CLIP_ACTION_DOWNLOAD_PROXIES_VIEW_STATE: 'Clips - Download Clip Proxies',
                CLIP_ACTION_EXPORT_METADATA_VIEW_STATE: 'Clips - Export Metadata',
                CLIP_ACTION_GENERATE_DELIVERY_REPORT_VIEW_STATE: 'Clips - Generate Delivery Report',
                CLIP_ACTION_BRANDING_VIEW_STATE: 'Clips - Branding'
            },
            packageClip: {
                CLIP_COLLABORATORS_VIEW_STATE: 'Clips - Collaborators',
                CLIP_DISTRIBUTIONGRID_VIEW_STATE: 'Clips - Distribution Grid',
                ADVANCED_LIVE_CLIP_PACKAGE_DISTRIBUTIONGRID_VIEW_STATE: 'Clips - Advanced Distribution Grid'
            }
        }
    },
    dashboard: {
        parentViewStates: {
            DASHBOARD_WORKFLOW_VIEW: 'Workflows',
            DASHBOARD_QUEUE_VIEW: 'Queues',
            DASHBOARD_REPORT_VIEW_STATE: 'Reports',
            DASHBOARD_CALENDAR_VIEW_STATE: 'Calendars',
            DASHBOARD_OFF_CYCLE_PLANNERS_VIEW_STATE: 'Off-Cycle Planners'
        }
    },
    meta: {
        parentViewStates: {
            NETWORK_VIEW_STATE: 'Networks',
            ADS_VIEW_STATE: 'Ads/PreRolls',
            SERIES_VIEW_STATE: 'Series',
            MOVIE_VIEW_STATE: 'Movies/Specials',
            COLLABORATOR_VIEW_STATE: 'Collaborators',
            MVPD_VIEW_STATE: 'MVPD Setup'
        },
        childViewStates: {
            metaNetwork: {
                NETWORK_PREROLL_SEARCH_VIEW_STATE: 'Preroll',
                NETWORK_POSTROLL_SEARCH_VIEW_STATE: 'Postroll',
                NETWORK_WATERMARK_SEARCH_VIEW_STATE: 'Watermark',
                NETWORK_ARTWORK_SEARCH_VIEW_STATE: 'Artwork'
            },
            metaSeries: {
                SERIES_PREROLL_SEARCH_VIEW_STATE: 'Preroll',
                SERIES_POSTROLL_SEARCH_VIEW_STATE: 'Postroll',
                SERIES_WATERMARK_SEARCH_VIEW_STATE: 'Watermark',
                SERIES_ARTWORK_SEARCH_VIEW_STATE: 'Artwork'
            },
            metaMovie: {
                MOVIE_PREROLL_SEARCH_VIEW_STATE: 'Preroll',
                MOVIE_POSTROLL_SEARCH_VIEW_STATE: 'Postroll',
                MOVIE_WATERMARK_SEARCH_VIEW_STATE: 'Watermark',
                MOVIE_ARTWORK_SEARCH_VIEW_STATE: 'Artwork'
            }
        }
    },
    system: {
        parentViewStates: {
            SYSTEM_PARTNERS_VIEW_STATE: 'Partners'
        },
        childViewStates: {
            systemPartner: {
                SYSTEM_PARTNERS_DELIVERYENDPOINTS_VIEW_STATE: 'Delivery Endpoints',
                SYSTEM_PARTNERS_EMAIL_VIEW_STATE: 'Email Endpoints',
                SYSTEM_PARTNERS_DELIVERYPROFILES_VIEW_STATE: 'Delivery Profiles',
                SYSTEM_PARTNERS_DUE_DATE_TEMPLATES_VIEW_STATE: 'SLA Templates',
                SYSTEM_PARTNERS_NIELSEN_TEMPLATES_VIEW_STATE: 'Nielsen Templates',
                SYSTEM_PARTNERS_SETUPGUIDES_VIEW_STATE: 'Setup Guides'
            }
        }
    },
    systemOps: {
        parentViewStates: {
            DEBUG_SYSTEM_OPERATIONS_VIEW_STATE: 'Debug - System Operations'
        },
        childViewStates: {
            impliedSystemOps: {
                PACKAGE_BATCH_MODIFY_METADATA_VIEW_STATE: 'Packages - Batch Modify Metadata',
                CLIP_ACTION_BATCH_MODIFY_METADATA_VIEW_STATE: 'Clips - Batch Modify Metadata'
            }
        }
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.genres', [
    'ngRoute',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'prism-ui.components.navigation',
    'prism-ui.components.data',
    'prism-ui.components.filters'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.languages', [
    'ngRoute',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'prism-ui.components.navigation',
    'prism-ui.components.data',
    'prism-ui.components.filters'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: package-notifications-template.ts
 *
 * Created by randysorensen on 4/9/18.
 */
angular.module('prism-ui.packageNotifications', [
    'ngRoute',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'ui.grid.treeView',
    'prism-ui.components.data',
    'prism-ui.components.navigation',
    'prism-ui.components.filters'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.roles', [
    'ngRoute',
    'ui.grid',
    'ui.grid.edit',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'prism-ui.components.navigation',
    'prism-ui.components.data',
    'prism-ui.components.filters'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: territories-module
 *
 * Created by sjacobs on 3/16/18.
 */
'use strict';
angular.module('prism-ui.territories', [
    'prism-ui.components.navigation',
    'ngRoute',
    'ui.grid',
    'ui.grid.autoResize',
    'ui.grid.pagination',
    'ui.grid.pinning',
    'ui.grid.resizeColumns',
    'ui.grid.selection'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.users', [
    'ngRoute',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'prism-ui.components.navigation',
    'prism-ui.components.data',
    'prism-ui.components.filters'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.properties', [
    'ngRoute',
    'ui.grid',
    'ui.grid.edit',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'prism-ui.components.navigation',
    'prism-ui.components.data',
    'prism-ui.components.filters'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.templates', [
    'ngRoute',
    'ui.grid',
    'ui.grid.edit',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'prism-ui.components.navigation',
    'prism-ui.components.data',
    'prism-ui.components.filters'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by sjacobs on 11/6/18.
 */
'use strict';
angular.module('prism-ui.deliveryProfiles', [
    'ngRoute',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'ui.grid.treeView',
    'prism-ui.components.data',
    'prism-ui.components.navigation'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.nielsenTemplates', [
    'ngRoute',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'prism-ui.components.navigation',
    'prism-ui.components.data',
    'prism-ui.components.filters'
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
var appModule = angular.module('prism-ui', [
    'prism-ui.assetContentTemplates',
    'prism-ui.calendars',
    'prism-ui.categories',
    'prism-ui.collaborators',
    'prism-ui.components',
    'prism-ui.components.branding',
    'prism-ui.components.constants',
    'prism-ui.components.navigation',
    'prism-ui.conditionalTemplate',
    'prism-ui.config',
    'prism-ui.content',
    'prism-ui.dashboard.checkin',
    'prism-ui.deliveryTemplates',
    'prism-ui.deliveryProfiles',
    'prism-ui.execServers',
    'prism-ui.emailTemplates',
    'prism-ui.externalMetadata',
    'prism-ui.fileSystem',
    'prism-ui.ffmpegTemplate',
    'prism-ui.genres',
    'prism-ui.groups',
    'prism-ui.imageTemplate',
    'prism-ui.intermediateTemplate',
    'prism-ui.languages',
    'prism-ui.livefeed',
    'prism-ui.login',
    'prism-ui.mediaAcceptProfiles',
    'prism-ui.metadataItems',
    'prism-ui.metricsDashboard',
    'prism-ui.mvpd',
    'prism-ui.network',
    'prism-ui.nielsenTemplates',
    'prism-ui.offCyclePlanners',
    'prism-ui.package',
    'prism-ui.packageAcceptTemplate',
    'prism-ui.packageCreationTemplate',
    'prism-ui.packageNotifications',
    'prism-ui.partner',
    'prism-ui.properties',
    'prism-ui.queues',
    'prism-ui.report',
    'prism-ui.roles',
    'prism-ui.system.maccaptionTemplate',
    'prism-ui.templates',
    'prism-ui.territories',
    'prism-ui.transformTemplate',
    'prism-ui.users',
    'prism-ui.workflows',
    'angularFileUpload',
    'angularMoment',
    // 'levelsBeyond.ui.progress',
    'ngAnimate',
    'ngRoute',
    'reachEngine.authentication',
    'reachEngine.user',
    'react',
    'templates-app',
    'ui.bootstrap',
]);
var canIgnoreResponseError = function (rejection) {
    try {
        var rejectionUrl = new URL(rejection.config.url);
        return (rejectionUrl.pathname === '/ping' ||
            rejectionUrl.pathname.match('^/reachengine/api/events/\\d+$'));
    }
    catch (e) {
        return false;
    }
};
//
// Returns an object describing our HTTP error response
// interceptor.
//
var failureInterceptor = function ($location, $q, $rootScope) {
    return {
        responseError: function (rejection) {
            if (rejection.status === 401) {
                $rootScope.session.clear();
                $location.path('/login');
            }
            else if (rejection.status >= 400 && rejection.status <= 599) {
                if (canIgnoreResponseError(rejection)) {
                    return $q.reject(rejection);
                }
                var message = (rejection.data && rejection.data.message) ?
                    rejection.data.message :
                    rejection.statusText;
                $rootScope.$broadcast('server-error', { message: message });
            }
            $rootScope.$broadcast('server-busy', { working: false });
            return $q.reject(rejection);
        }
    };
};
function configInterceptors($httpProvider, jwtOptionsProvider) {
    // overwrite A.R.E.S. jwt config
    jwtOptionsProvider.config({
        tokenGetter: function (jwtStore) { return jwtStore.get(); },
        whiteListedDomains: ['relocal', 'localhost']
    });
    $httpProvider.interceptors.push(failureInterceptor);
}
appModule.config(configInterceptors);
function afterConfig($location, $rootScope, $route, $routeParams, configService, loginService, BreadcrumbService, EndPointService, ModalService, NotificationService, SearchFilterService, SidebarService) {
    configService.setReachEngineUrl(EndPointService.reachengineServerUrl);
    $rootScope.$on('$routeChangeStart', function (event) {
        var path = $location.path();
        ModalService.closeAllModals();
        if (!loginService.isAuthenticated()) {
            BreadcrumbService.clearBreadcrumbs();
            // look for "chromeless" (no login) paths
            switch (path) {
                case '/dashboard/metrics':
                case '/login':
                    break;
                default:
                    // All Others
                    localStorage.preLoginRoute = $location.url();
                    $location.url('/login');
                    break;
            }
            return;
        }
        var routeChangeHandlerTable = [
            //
            // Each object corresponds to one route change handler.
            // The objects have the following properties:
            //
            //  path - the route's base path
            //
            //  sidebarItem - the name of the sidebar item which
            //      will be passed to
            //      SidebarService.setSelectedItem()
            //
            //  baseBreadcrumbPath - the name of the topmost
            //      subpath (e.g. '/search) that will correspond
            //      to the base breadcrumb
            //
            //  hasFilterParams - true if the route will use
            //      $location.search() to track search criteria
            //      for a filter (such as workflows or packages)
            //
            //
            // NOTICE!
            //
            // 1) These are organized in the order in which they
            // appear on the app sidebar. Please keep it that way!
            //
            // 2) Please also keep the corresponding table in
            // app_test.js up-to-date. Difficult-to-trace errors
            // can be avoided by having the unit tests check the
            // route change handlers.
            //
            // Thanks! :D
            //
            // DASHBOARD
            { path: '/dashboard/workflows', sidebarItem: 'workflows', baseBreadcrumbPath: '', hasFilterParams: true },
            { path: '/dashboard/queues', sidebarItem: 'queues', baseBreadcrumbPath: '', hasFilterParams: true },
            { path: '/dashboard/report', sidebarItem: 'reports', baseBreadcrumbPath: '', hasFilterParams: false },
            { path: '/dashboard/calendars', sidebarItem: 'calendars', baseBreadcrumbPath: '', hasFilterParams: false },
            { path: '/dashboard/offCyclePlanners', sidebarItem: 'offCyclePlanners', baseBreadcrumbPath: '', hasFilterParams: false },
            { path: '/dashboard/checkin', sidebarItem: 'checkin', baseBreadcrumbPath: '', hasFilterParams: false },
            { path: '/dashboard/metrics', sidebarItem: 'metrics', baseBreadcrumbPath: '', hasFilterParams: false },
            // META
            { path: '/meta/networks', sidebarItem: 'networks', baseBreadcrumbPath: '/search', hasFilterParams: false },
            { path: '/meta/adsAndPreRolls', sidebarItem: 'adsAndPreRolls', baseBreadcrumbPath: '/search', hasFilterParams: false },
            { path: '/meta/series', sidebarItem: 'series', baseBreadcrumbPath: '/search', hasFilterParams: false },
            { path: '/meta/movies', sidebarItem: 'movies', baseBreadcrumbPath: '/search', hasFilterParams: false },
            { path: '/meta/collaborators', sidebarItem: 'collaborators', baseBreadcrumbPath: '/search', hasFilterParams: false },
            { path: '/meta/mvpd', sidebarItem: 'mvpd', baseBreadcrumbPath: '/search', hasFilterParams: false },
            // SYSTEM
            { path: '/system/partners', sidebarItem: 'partners', baseBreadcrumbPath: '/search', hasFilterParams: false },
            { path: '/system/properties', sidebarItem: 'properties', baseBreadcrumbPath: '/search', hasFilterParams: false },
            { path: '/system/templates', sidebarItem: 'templates', baseBreadcrumbPath: '/search', hasFilterParams: false },
            { path: '/system/metadataItems', sidebarItem: 'metadataItems', baseBreadcrumbPath: '/search', hasFilterParams: false },
            { path: '/system/livefeeds', sidebarItem: 'livefeeds', baseBreadcrumbPath: '/search', hasFilterParams: false },
            { path: '/system/fileSystems', sidebarItem: 'fileSystems', baseBreadcrumbPath: '/search', hasFilterParams: false },
            { path: '/system/aggregation', sidebarItem: 'aggregation', baseBreadcrumbPath: '/setup', hasFilterParams: false },
            { path: '/system/execServers', sidebarItem: 'execServers', baseBreadcrumbPath: '', hasFilterParams: false },
            { path: '/system/packageNotifications', sidebarItem: 'packageNotifications', baseBreadcrumbPath: '/search', hasFilterParams: false },
            { path: '/system/users', sidebarItem: 'users', baseBreadcrumbPath: '/search', hasFilterParams: false },
            { path: '/system/groups', sidebarItem: 'groups', baseBreadcrumbPath: '/search', hasFilterParams: false },
            { path: '/system/contacts', sidebarItem: 'contacts', baseBreadcrumbPath: '/search', hasFilterParams: false },
            // PACKAGES
            { path: '/packages', sidebarItem: 'packages', baseBreadcrumbPath: '', hasFilterParams: true },
        ];
        var handled = false;
        angular.forEach(routeChangeHandlerTable, function (routeChangeHandler) {
            if (path.startsWith(routeChangeHandler.path)) {
                handled = true;
                SidebarService.setSelectedItem(routeChangeHandler.sidebarItem);
                if (path === routeChangeHandler.path + routeChangeHandler.baseBreadcrumbPath) {
                    BreadcrumbService.clearBreadcrumbs();
                    if (routeChangeHandler.hasFilterParams) {
                        SearchFilterService.updateLocationSearch();
                    }
                }
            }
        });
        // weird routes get sent back to the package manager
        if (!handled) {
            event.preventDefault();
            BreadcrumbService.clearBreadcrumbs();
            $location.path('/packages');
            $location.search('pmView', 'basic');
        }
    });
    $rootScope.$on('server-error', function (event, error) {
        NotificationService.createFailureNotification(error.message, '', true, -1);
    });
    $rootScope.session = {
        clear: function () {
            loginService.deleteSessionData();
        }
    };
}
appModule.factory('AuthFactory', function (jwtStore) {
    var authQueryParamName = 'auth';
    return {
        getAuthQueryString: function () { return authQueryParamName + "=" + jwtStore.get(); },
        getAuthHeader: function () { return "Bearer " + jwtStore.get(); }
    };
});
appModule.run(afterConfig);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 2/16/16.
 */
'use strict';
function configRoutes($injector, $locationProvider, $routeProvider) {
    $locationProvider.html5Mode(true);
    $routeProvider
        .when('/login', {
        template: '<login></login>',
        publicAccess: true
    })
        //===========//
        // Dashboard //
        //===========//
        .when('/dashboard/queues/summary', {
        templateUrl: 'dashboard/queues/queues-view-template.html',
        label: 'Queues Summary',
        showRefreshOnly: true
    })
        .when('/dashboard/workflows', {
        templateUrl: 'dashboard/workflows/searchView/workflows-view-template.html',
        label: 'Workflow Execution Progress',
        reloadOnSearch: false,
        searchEnabled: true,
        filterEnabled: true
    })
        .when('/dashboard/workflows/:id/steps', {
        templateUrl: 'dashboard/workflows/stepView/workflow-step-view-template.html',
        controller: 'WorkflowStepViewController as workflowStepViewCntrlr',
        rootRoute: '/dashboard/workflows',
        resolve: {
            parentWorkflow: ['WorkflowExecutionResourceFactory', '$route',
                function (WorkflowExecutionResourceFactory, $route) {
                    return WorkflowExecutionResourceFactory.getWorkflowExecution({
                        id: $route.current.params.id
                    }).$promise;
                }]
        },
        reloadOnSearch: false,
        searchEnabled: true
    })
        .when('/dashboard/queues/summary/:group', {
        templateUrl: 'dashboard/queues/groupSummary/queues-group-summary-view-template.html',
        controller: 'QueuesGroupSummaryViewController as queueGroupSummaryCtrlr',
        rootRoute: '/dashboard/queues/summary',
        showRefreshOnly: true
    })
        .when('/dashboard/queues/summary/:group/:id/steps', {
        template: '<queue-detail-view></queue-detail-view>',
        rootRoute: '/dashboard/queues/summary',
        reloadOnSearch: false,
        searchEnabled: true
    })
        .when('/dashboard/report/:reportName', {
        template: '<report-view></report-view>',
        searchEnabled: false
    })
        .when('/dashboard/calendars', {
        templateUrl: 'dashboard/calendars/searchView/calendars-view-template.html',
        controller: 'CalendarsViewController as calCtrl',
        label: 'calendars',
        reloadOnSearch: false,
        searchEnabled: true,
    })
        .when('/dashboard/offCyclePlanners', {
        template: '<off-cycle-planners-view></off-cycle-planners-view>',
        label: 'Off Cycle Planners',
        reloadOnSearch: false,
        searchEnabled: true
    })
        .when('/dashboard/checkin', {
        template: '<package-checkin></package-checkin>',
        label: 'Package Check-in',
        reloadOnSearch: false,
        searchEnabled: false,
    })
        .when('/dashboard/metrics', {
        label: 'Metrics',
        publicAccess: true,
        reloadOnSearch: false,
        rootRoute: '/dashboard/metrics',
        searchEnabled: false,
        template: '<metrics-dashboard></metrics-dashboard>'
    })
        //======//
        // Meta //
        //======//
        // Networks
        .when('/meta/networks/search', {
        template: '<network-search-view></network-search-view>',
        label: 'Networks',
        searchEnabled: true
    })
        .when('/meta/networks/edit/:id', {
        template: '<network-edit-view></network-edit-view>',
        label: 'Networks',
        reloadOnSearch: false
    })
        .when('/meta/networks/edit/:id/ratingOverlays/edit/:acceptProfileId', {
        template: '<branding-media-edit-view branding-config="$resolve.brandingConfig"></branding-media-edit-view>',
        resolve: {
            brandingConfig: ['$route',
                function ($route) {
                    return {
                        parentLocation: '/meta/networks/edit/' + $route.current.params.id,
                        id: $route.current.params.id,
                        type: 'ratingOverlays',
                        isShow: false,
                        groupName: 'networks'
                    };
                }]
        },
        rootRoute: '/meta/networks/search',
        reloadOnSearch: false
    })
        .when('/meta/networks/edit/:id/:type/edit/:containerId', {
        template: '<branding-container-edit-view branding-config="$resolve.brandingConfig"></branding-container-edit-view>',
        resolve: {
            brandingConfig: ['$route',
                function ($route) {
                    return {
                        parentLocation: '/meta/networks/edit/' + $route.current.params.id,
                        id: $route.current.params.containerId,
                        type: $route.current.params.type,
                        isShow: false,
                        groupName: 'networks'
                    };
                }]
        },
        rootRoute: '/meta/networks/search',
        reloadOnSearch: false
    })
        .when('/meta/networks/edit/:id/:type/edit/:containerId/acceptProfiles/edit/:acceptProfileId', {
        template: '<branding-media-edit-view branding-config="$resolve.brandingConfig"></branding-media-edit-view>',
        resolve: {
            brandingConfig: ['$route',
                function ($route) {
                    return {
                        parentLocation: '/meta/networks/edit/' + $route.current.params.id,
                        id: $route.current.params.containerId,
                        type: $route.current.params.type,
                        isShow: false,
                        groupName: 'networks'
                    };
                }]
        },
        rootRoute: '/meta/networks/search',
        reloadOnSearch: false
    })
        // Ads & PreRolls
        .when('/meta/adsAndPreRolls/search', {
        template: "<content-search-view content-type=\"'Ad/PreRoll'\"></content-search-view-view>",
        label: 'AdsAndPreRolls',
        searchEnabled: true
    })
        .when('/meta/adsAndPreRolls/edit/:id/:editView', {
        template: "<content-edit-view content-type=\"'Ad/PreRoll'\" is-season=\"false\"></content-edit-view>",
        label: 'AdsAndPreRolls',
        rootRoute: '/meta/adsAndPreRolls/search',
        reloadOnSearch: false
    })
        .when('/meta/adsAndPreRolls/edit/:id/categories/edit/:contentCategoryId', {
        template: "<content-categories-edit-view content-type=\"'Ad/PreRoll'\"></content-categories-edit-view>",
        label: 'Series',
        rootRoute: '/meta/adsAndPreRolls/edit/:id/categories',
        reloadOnSearch: false
    })
        // Series
        .when('/meta/series/search', {
        template: "<content-search-view content-type=\"'Series'\"></content-search-view-view>",
        label: 'Series',
        searchEnabled: true
    })
        .when('/meta/series/edit/:id/:editView', {
        template: "<content-edit-view content-type=\"'Series'\" is-season=\"false\"></content-edit-view>",
        label: 'Series',
        rootRoute: '/meta/series/search',
        reloadOnSearch: false
    })
        .when('/meta/series/edit/:id/actor/edit/:actorId', {
        template: '<actor-edit-view content-name="$resolve.contentName" is-series="true"></actor-edit-view>',
        resolve: {
            contentName: ['$route', 'ContentResourceFactory',
                function ($route, ContentResourceFactory) {
                    return ContentResourceFactory.get({ id: $route.current.params.id }).$promise.then(function (content) {
                        return content.name;
                    });
                }]
        },
        label: 'Series',
        rootRoute: '/meta/series/search',
        reloadOnSearch: false
    })
        .when('/meta/series/edit/:id/categories/edit/:contentCategoryId', {
        template: "<content-categories-edit-view content-type=\"'Series'\"></content-categories-edit-view>",
        label: 'Series',
        rootRoute: '/meta/series/edit/:id/categories',
        reloadOnSearch: false
    })
        .when('/meta/series/edit/:id/seasons/edit/:seasonId/:editView', {
        template: '<content-season-volume-editor content="$resolve.content" season="$resolve.season"></content-season-volume-editor>',
        label: 'Series',
        rootRoute: '/meta/series/edit/:id/seasons',
        reloadOnSearch: false,
        resolve: {
            content: ['$route', 'ContentResourceFactory',
                function ($route, ContentResourceFactory) {
                    return ContentResourceFactory.get({ id: $route.current.params.id }).$promise;
                }],
            season: ['$route', 'ContentResourceFactory',
                function ($route, ContentResourceFactory) {
                    if ($route.current.params.seasonId !== '-1') {
                        return ContentResourceFactory.getSeason({ id: $route.current.params.seasonId }).$promise;
                    }
                    else {
                        return undefined;
                    }
                }]
        },
    })
        .when('/meta/series/edit/:id/volumes/edit/:volumeId/:editView', {
        template: '<content-season-volume-editor></content-season-volume-editor>',
        label: 'Series',
        rootRoute: '/meta/series/edit/:id/volumes',
        reloadOnSearch: false,
    })
        .when('/meta/series/edit/:id/:type/edit/:containerId', {
        template: '<branding-container-edit-view branding-config="$resolve.brandingConfig"></branding-container-edit-view>',
        resolve: {
            brandingConfig: ['$route',
                function ($route) {
                    return {
                        parentLocation: '/meta/series/edit/' + $route.current.params.id + '/' + $route.current.params.type,
                        id: $route.current.params.containerId,
                        type: $route.current.params.type,
                        isShow: true,
                        groupName: 'series'
                    };
                }]
        },
        rootRoute: '/meta/series/search',
        reloadOnSearch: false
    })
        .when('/meta/series/edit/:id/seasons/edit/:seasonId/:type/edit/:containerId', {
        template: '<branding-container-edit-view branding-config="$resolve.brandingConfig"></branding-container-edit-view>',
        resolve: {
            brandingConfig: ['$route', function ($route) {
                    return {
                        parentLocation: '/meta/series/edit/' + $route.current.params.id + '/seasons/edit/' + $route.current.params.seasonId + '/' + $route.current.params.type,
                        id: $route.current.params.containerId,
                        seasonId: $route.current.params.seasonId,
                        type: $route.current.params.type,
                        isShow: true,
                        groupName: 'series'
                    };
                }]
        },
        rootRoute: '/meta/series/search',
        reloadOnSearch: false,
    })
        .when('/meta/series/edit/:id/volumes/edit/:volumeId/:type/edit/:containerId', {
        template: '<branding-container-edit-view branding-config="$resolve.brandingConfig"></branding-container-edit-view>',
        resolve: {
            brandingConfig: ['$route', function ($route) {
                    return {
                        parentLocation: '/meta/series/edit/' + $route.current.params.id + '/volumes/edit/' + $route.current.params.volumeId + '/' + $route.current.params.type,
                        id: $route.current.params.containerId,
                        volumeId: $route.current.params.volumeId,
                        type: $route.current.params.type,
                        isShow: true,
                        groupName: 'series'
                    };
                }]
        },
        rootRoute: '/meta/series/search',
        reloadOnSearch: false,
    })
        .when('/meta/series/edit/:id/:type/edit/:containerId/acceptProfiles/edit/:acceptProfileId', {
        template: '<branding-media-edit-view branding-config="$resolve.brandingConfig"></branding-media-edit-view>',
        resolve: {
            brandingConfig: ['$route',
                function ($route) {
                    return {
                        parentLocation: '/meta/series/edit/' + $route.current.params.id + '/' + $route.current.params.type,
                        id: $route.current.params.containerId,
                        type: $route.current.params.type,
                        isShow: true,
                        groupName: 'series'
                    };
                }]
        },
        rootRoute: '/meta/series/search',
        reloadOnSearch: false
    })
        .when('/meta/series/edit/:id/seasons/edit/:seasonId/:type/edit/:containerId/acceptProfiles/edit/:acceptProfileId', {
        template: '<branding-media-edit-view branding-config="$resolve.brandingConfig"></branding-media-edit-view>',
        resolve: {
            brandingConfig: ['$route', function ($route) {
                    return {
                        parentLocation: '/meta/series/edit/' + $route.current.params.id + '/seasons/edit/' + $route.current.params.seasonId + '/' + $route.current.params.type,
                        id: $route.current.params.containerId,
                        seasonId: $route.current.params.seasonId,
                        type: $route.current.params.type,
                        isShow: true,
                        groupName: 'series'
                    };
                }]
        },
        rootRoute: '/meta/series/search',
        reloadOnSearch: false,
    })
        .when('/meta/series/edit/:id/volumes/edit/:volumeId/:type/edit/:containerId/acceptProfiles/edit/:acceptProfileId', {
        template: '<branding-media-edit-view branding-config="$resolve.brandingConfig"></branding-media-edit-view>',
        resolve: {
            brandingConfig: ['$route', function ($route) {
                    return {
                        parentLocation: '/meta/series/edit/' + $route.current.params.id + '/volumes/edit/' + $route.current.params.volumeId + '/' + $route.current.params.type,
                        id: $route.current.params.containerId,
                        volumeId: $route.current.params.volumeId,
                        type: $route.current.params.type,
                        isShow: true,
                        groupName: 'series'
                    };
                }]
        },
        rootRoute: '/meta/series/search',
        reloadOnSearch: false,
    })
        // Movies
        .when('/meta/movies/search', {
        template: "<content-search-view content-type=\"'Movie/Special'\"></content-search-view-view>",
        label: 'Movies/Specials',
        searchEnabled: true
    })
        .when('/meta/movies/edit/:id/:editView', {
        template: "<content-edit-view content-type=\"'Movie/Special'\"></content-edit-view>",
        label: 'Movies/Specials',
        rootRoute: '/meta/movies/search',
        reloadOnSearch: false
    })
        .when('/meta/movies/edit/:id/actor/edit/:actorId', {
        template: '<actor-edit-view content-name="$resolve.contentName" is-series="false"></actor-edit-view>',
        resolve: {
            contentName: ['$route', 'ContentResourceFactory',
                function ($route, ContentResourceFactory) {
                    return ContentResourceFactory.get({ id: $route.current.params.id }).$promise.then(function (content) {
                        return content.name;
                    });
                }]
        },
        label: 'Movies/Specials',
        rootRoute: '/meta/movies/search',
        reloadOnSearch: false
    })
        .when('/meta/movies/edit/:id/categories/edit/:contentCategoryId', {
        template: "<content-categories-edit-view content-type=\"'Movie/Special'\"></content-categories-edit-view>",
        label: 'Movies/Specials',
        rootRoute: '/meta/movies/edit/:id/categories',
        reloadOnSearch: false
    })
        .when('/meta/movies/edit/:id/:type/edit/:containerId', {
        template: '<branding-container-edit-view branding-config="$resolve.brandingConfig"></branding-container-edit-view>',
        resolve: {
            brandingConfig: ['$route',
                function ($route) {
                    return {
                        parentLocation: '/meta/movies/edit/' + $route.current.params.id + '/' + $route.current.params.type,
                        id: $route.current.params.containerId,
                        type: $route.current.params.type,
                        isShow: true,
                        groupName: 'movies'
                    };
                }]
        },
        rootRoute: '/meta/movies/search',
        reloadOnSearch: false
    })
        .when('/meta/movies/edit/:id/:type/edit/:containerId/acceptProfiles/edit/:acceptProfileId', {
        template: '<branding-media-edit-view branding-config="$resolve.brandingConfig"></branding-media-edit-view>',
        resolve: {
            brandingConfig: ['$route',
                function ($route) {
                    return {
                        parentLocation: '/meta/movies/edit/' + $route.current.params.id + '/' + $route.current.params.type,
                        id: $route.current.params.containerId,
                        type: $route.current.params.type,
                        isShow: true,
                        groupName: 'movies'
                    };
                }]
        },
        rootRoute: '/meta/movies/search',
        reloadOnSearch: false
    })
        // Collaborators
        .when('/meta/collaborators/search', {
        template: '<collaborators-grid-search-view></collaborators-grid-search-view>',
        label: 'Collaborators',
        searchEnabled: true
    })
        .when('/meta/collaborators/edit/:id', {
        template: '<collaborators-edit-view></collaborators-edit-view>',
        label: 'Collaborators',
        reloadOnSearch: false,
        rootRoute: '/meta/collaborators/search'
    })
        // MVPD Setup
        .when('/meta/mvpd/search', {
        template: '<mvpd-grid-search-view></mvpd-grid-search-view>',
        label: 'MVPD Setup',
        searchEnabled: true
    })
        .when('/meta/mvpd/edit/partner/:id/:groupName', {
        template: "<mvpd-partner-grid-search-view mvpd-config=\"$resolve.mvpdConfig\"></mvpd-partner-grid-search-view>",
        resolve: {
            mvpdConfig: ['$route', 'PartnerResourceFactory',
                function ($route, PartnerResourceFactory) {
                    return PartnerResourceFactory.get({ id: $route.current.params.id }).$promise.then(function (partner) {
                        return { partnerName: partner.name };
                    });
                }]
        },
        rootRoute: '/meta/mvpd/search',
        searchEnabled: true,
        reloadOnSearch: false
    })
        .when('/meta/mvpd/edit/partner/:id/:groupName/:groupId/metadata/:view', {
        template: "<mvpd-metadata-item-edit-view mvpd-config=\"$resolve.mvpdConfig\"></mvpd-metadata-item-edit-view>",
        resolve: {
            mvpdConfig: ['$route', 'PartnerResourceFactory',
                function ($route, PartnerResourceFactory) {
                    var mvpdConfig = {
                        parentLocation: "/meta/mvpd/edit/partner/" + $route.current.params.id + "/" + $route.current.params.groupName
                    };
                    return PartnerResourceFactory.get({ id: $route.current.params.id }).$promise.then(function (partner) {
                        mvpdConfig.partnerName = partner.name;
                        return mvpdConfig;
                    });
                }]
        },
        rootRoute: '/meta/mvpd/search',
        searchEnabled: false
    })
        .when('/meta/mvpd/edit/partner/:id/:groupName/:groupId/metadata/:view/:seasonVolumeId/edit/:subView', {
        template: "<mvpd-metadata-item-edit-view mvpd-config=\"$resolve.mvpdConfig\"></mvpd-metadata-item-edit-view>",
        resolve: {
            mvpdConfig: ['$route', 'PartnerResourceFactory',
                function ($route, PartnerResourceFactory) {
                    var mvpdConfig = {
                        parentLocation: "/meta/mvpd/edit/partner/" + $route.current.params.id + "/" + $route.current.params.groupName + "/" + $route.current.params.groupId + "/metadata/" + $route.current.params.view
                    };
                    return PartnerResourceFactory.get({ id: $route.current.params.id }).$promise.then(function (partner) {
                        mvpdConfig.partnerName = partner.name;
                        return mvpdConfig;
                    });
                }]
        },
        rootRoute: '/meta/mvpd/search',
        searchEnabled: false
    })
        //========//
        // System //
        //========//
        // Partners
        .when('/system/partners/search', {
        templateUrl: 'system/partner/partner-template.html',
        label: 'Partners',
        searchEnabled: true
    })
        .when('/system/partners/edit/:id/:editView', {
        template: '<partner-edit-view></partner-edit-view>',
        rootRoute: '/system/partners/search',
        reloadOnSearch: false,
        searchEnabled: true,
        filterEnabled: true
    })
        .when('/system/partners/edit/:id/deliveryendpoints/:endpointType/edit/:endpointId', {
        template: '<partner-delivery-endpoints-editor></partner-delivery-endpoints-editor>',
        rootRoute: '/system/partners/edit/:id/:editView',
        reloadOnSearch: false
    })
        .when('/system/partners/edit/:id/emailendpoints/edit/:endpointId', {
        template: '<partner-email-endpoints-editor></partner-email-endpoints-editor>',
        rootRoute: '/system/partners/edit/:id/:editView',
        reloadOnSearch: false
    })
        .when('/system/partners/edit/:id/planner/edit/:plannerId', {
        template: '<partner-planner-editor></partner-planner-editor>',
        rootRoute: '/system/partners/edit/:id/:editView',
        reloadOnSearch: false
    })
        .when('/system/partners/edit/:id/dueDateTemplates/edit/:dueDateTemplateId', {
        template: '<partner-due-date-templates-editor></partner-due-date-templates-editor>',
        rootRoute: '/system/partners/edit/:id/:editView',
        reloadOnSearch: false
    })
        .when('/system/partners/edit/:id/nielsenTemplates/edit/:nielsenTemplateId', {
        template: '<nielsen-templates-edit-view></nielsen-templates-edit-view>',
        rootRoute: '/system/partners/edit/:id/:editView',
        reloadOnSearch: false
    })
        .when('/system/partners/edit/:id/deliveryProfiles/edit/:deliveryProfileId', {
        template: '<delivery-profiles-edit-view partner-name="$resolve.partnerName"></delivery-profiles-edit-view>',
        resolve: {
            partnerName: ['$route', 'PartnerResourceFactory',
                function ($route, PartnerResourceFactory) {
                    return PartnerResourceFactory.get({ id: $route.current.params.id }).$promise.then(function (partner) {
                        return partner.name;
                    });
                }],
        }
    })
        .when('/system/partners/edit/:id/deliveryProfiles/edit/:deliveryProfileId/emails/edit/:deliveryEmailId', {
        template: '<delivery-email-edit-view></delivery-email-edit-view>'
    })
        .when('/system/partners/edit/:id/deliveryProfiles/edit/:deliveryProfileId/deliveryItems/edit/:mediaAcceptProfileId', {
        template: '<delivery-profiles-delivery-items-edit-view  resolve-data="$resolve.resolveData"></delivery-profiles-delivery-items-edit-view>',
        resolve: {
            resolveData: ['$route', 'PartnerResourceFactory', 'MediaAcceptProfileService', '$q',
                function ($route, PartnerResourceFactory, MediaAcceptProfileService, $q) {
                    return $q.all({
                        partner: PartnerResourceFactory.get({ id: $route.current.params.id }).$promise,
                        mediaAcceptProfile: MediaAcceptProfileService.getAcceptProfile($route.current.params.mediaAcceptProfileId),
                    }).then(function (data) {
                        return {
                            partnerName: data.partner.name,
                            mediaAcceptProfile: data.mediaAcceptProfile,
                        };
                    });
                }]
        }
    })
        .when('/system/partners/edit/:id/deliveryProfiles/edit/:deliveryProfileId/deliveryItems/edit/:mediaAcceptProfileId/:deliveryItemType/edit/:deliveryItemId', {
        template: '<delivery-item-edit-view resolve-data="$resolve.resolveData"></delivery-item-edit-view>',
        resolve: {
            resolveData: ['$route', 'PartnerResourceFactory', 'MediaAcceptProfileService', 'PartnerEditService', '$q',
                function ($route, PartnerResourceFactory, MediaAcceptProfileService, PartnerEditService, $q) {
                    return $q.all({
                        partner: PartnerResourceFactory.get({ id: $route.current.params.id }).$promise,
                        mediaAcceptProfile: MediaAcceptProfileService.getAcceptProfile($route.current.params.mediaAcceptProfileId),
                        deliveryProfile: PartnerEditService.getDeliveryProfile($route.current.params.deliveryProfileId)
                    }).then(function (data) {
                        return {
                            partnerName: data.partner.name,
                            mediaAcceptProfile: data.mediaAcceptProfile,
                            deliveryProfilePackageAcceptTemplateId: data.deliveryProfile.packageAcceptTemplate.id
                        };
                    });
                }]
        }
    })
        // Users
        .when('/system/users/search', {
        template: '<users-search-view></users-search-view>',
        label: 'Users',
        searchEnabled: true
    })
        .when('/system/users/edit/:id', {
        template: '<users-edit-view></users-edit-view>',
        rootRoute: '/system/users/search'
    })
        // Groups
        .when('/system/groups/search', {
        template: '<groups-search-view></groups-search-view>',
        label: 'Groups',
        searchEnabled: true
    })
        .when('/system/groups/edit/:id', {
        template: '<group-edit-view></group-edit-view>',
        rootRoute: '/system/groups/search'
    })
        // Contacts
        .when('/system/contacts/search', {
        template: '<contacts-search-view></contacts-search-view>',
        label: 'Contacts',
        searchEnabled: true
    })
        .when('/system/contacts/edit/:contactId', {
        template: '<contacts-edit-view></contacts-edit-view>',
        rootRoute: '/system/contacts/search'
    })
        // Properties
        .when('/system/properties/search', {
        template: '<properties-search-view></properties-search-view>',
        label: 'Properties',
        searchEnabled: true,
        reloadOnSearch: false
    })
        // Dynamic Properties
        .when('/system/properties/dynamicProperty/edit', {
        template: '<dynamic-props-edit-view></dynamic-props-edit-view>',
        reloadOnSearch: true
    })
        // Roles
        .when('/system/properties/roles/edit/:id', {
        template: '<roles-edit-view></roles-edit-view>',
    })
        // Roles
        .when('/system/properties/roles/edit/:id/:type', {
        template: '<roles-edit-view></roles-edit-view>',
    })
        // Categories
        .when('/system/properties/categories/edit/:id', {
        template: '<categories-edit-view></categories-edit-view>',
    })
        // Languages
        .when('/system/properties/languages/edit/:id', {
        template: '<languages-edit-view></languages-edit-view>',
    })
        // Genres
        .when('/system/properties/genres/edit/:id', {
        template: '<genres-edit-view></genres-edit-view>',
    })
        // Territories
        .when('/system/properties/territories/edit/:id', {
        template: '<territories-edit-view></territories-edit-view>',
    })
        // Metadata Items
        .when('/system/metadataItems/:type', {
        template: '<metadata-items-search-view></metadata-items-search-view>',
        label: 'Metadata Items',
        reloadOnSearch: false
    })
        // Live Feeds
        .when('/system/livefeeds/search', {
        templateUrl: 'system/livefeed/livefeed-template.html',
        label: 'Live Feeds',
        reloadOnSearch: false,
        searchEnabled: true
    })
        .when('/system/livefeeds/edit/:id', {
        templateUrl: 'system/livefeed/editor/livefeed-edit-template.html',
        controller: 'LiveFeedEditController as liveFeedEditCtrl',
        rootRoute: '/system/livefeeds/search',
        reloadOnSearch: false
    })
        // File Systems
        .when('/system/fileSystems/search', {
        template: '<file-system-search-view></file-system-search-view>',
        label: 'File Systems',
        searchEnabled: true,
        reloadOnSearch: false
    })
        .when('/system/fileSystems/edit/:id/:editView', {
        template: '<file-system-edit-view></file-system-edit-view>',
        searchEnabled: true,
        reloadOnSearch: false
    })
        .when('/system/fileSystems/edit/:id/directories/edit/:directoryId', {
        template: '<directory-edit-view></directory-edit-view>'
    })
        // Templates
        .when('/system/templates/search', {
        template: '<templates-search-view></templates-search-view>',
        label: 'Templates',
        searchEnabled: true,
        reloadOnSearch: false
    })
        // Delivery Templates
        .when('/system/templates/deliveryTemplates/edit/:id', {
        template: '<delivery-templates-edit-view></delivery-templates-edit-view>',
    })
        // Email Templates
        .when('/system/templates/emailTemplates/edit/:id', {
        template: '<email-templates-edit-view></email-templates-edit-view>',
    })
        // Hybrik Templates
        .when('/system/templates/hybrikTemplates/edit/:id', {
        template: '<hybrik-template-edit-view></hybrik-template-edit-view>',
    })
        // FFmpeg Templates
        .when('/system/templates/ffmpegTemplates/edit/:id', {
        template: '<ffmpeg-templates-edit-view></ffmpeg-templates-edit-view>',
    })
        // Intermediate Templates
        .when('/system/templates/intermediateTemplates/edit/:id', {
        template: '<intermediate-templates-edit-view></intermediate-templates-edit-view>',
    })
        // Conditional Templates
        .when('/system/templates/conditionalTemplates/edit/:id', {
        template: '<conditional-templates-edit-view></conditional-templates-edit-view>',
    })
        // Transform Templates
        .when('/system/templates/transformTemplates/edit/:id', {
        template: '<transform-templates-edit-view></transform-templates-edit-view>',
    })
        // Image Templates
        .when('/system/templates/imageTemplates/edit/:id', {
        template: '<image-templates-edit-view></image-templates-edit-view>',
    })
        // Image Templates
        .when('/system/templates/packageCreationTemplates/edit/:id', {
        template: '<package-creation-templates-edit-view></package-creation-templates-edit-view>',
    })
        // MacCaption Templates
        .when('/system/templates/macCaptionTemplates/edit/:id', {
        template: '<mac-caption-templates-edit-view></maccaption-templates-edit-view>',
    })
        // Media Accept Profiles
        .when('/system/templates/media/acceptProfiles/edit/:id', {
        template: '<media-accept-profiles-edit-view></media-accept-profiles-edit-view>',
        reloadOnSearch: false
    })
        // Media Accept Profile Video Validator Edit
        .when('/system/templates/media/acceptProfiles/edit/:id/videoValidators/edit/:validatorId', {
        template: '<media-accept-profiles-video-validator-edit-view accept-profile="$resolve.acceptProfile"></media-accept-profiles-video-validator-edit-view>',
        reloadOnSearch: false,
        resolve: {
            acceptProfile: ['$route', 'MediaAcceptProfileService',
                function ($route, MediaAcceptProfileService) {
                    return MediaAcceptProfileService.getAcceptProfile($route.current.params.id);
                }]
        }
    })
        // Media Accept Profile Audio Validator Edit
        .when('/system/templates/media/acceptProfiles/edit/:id/audioValidators/edit/:validatorId', {
        template: '<media-accept-profiles-audio-validator-edit-view accept-profile="$resolve.acceptProfile"></media-accept-profiles-audio-validator-edit-view>',
        reloadOnSearch: false,
        resolve: {
            acceptProfile: ['$route', 'MediaAcceptProfileService',
                function ($route, MediaAcceptProfileService) {
                    return MediaAcceptProfileService.getAcceptProfile($route.current.params.id);
                }]
        }
    })
        // Media Accept Profile Artwork Validator Edit
        .when('/system/templates/media/acceptProfiles/edit/:id/artworkValidators/edit/:validatorId', {
        template: '<media-accept-profiles-image-validator-edit-view accept-profile="$resolve.acceptProfile"></media-accept-profiles-image-validator-edit-view>',
        reloadOnSearch: false,
        resolve: {
            acceptProfile: ['$route', 'MediaAcceptProfileService',
                function ($route, MediaAcceptProfileService) {
                    return MediaAcceptProfileService.getAcceptProfile($route.current.params.id);
                }]
        }
    })
        // Media Accept Profile Image Validator Edit
        .when('/system/templates/media/acceptProfiles/edit/:id/imageValidators/edit/:validatorId', {
        template: '<media-accept-profiles-image-validator-edit-view accept-profile="$resolve.acceptProfile"></media-accept-profiles-image-validator-edit-view>',
        reloadOnSearch: false,
        resolve: {
            acceptProfile: ['$route', 'MediaAcceptProfileService',
                function ($route, MediaAcceptProfileService) {
                    return MediaAcceptProfileService.getAcceptProfile($route.current.params.id);
                }]
        }
    })
        // Package Accept Profiles
        .when('/system/templates/media/packageAcceptTemplates/edit/:id', {
        template: '<package-accept-templates-edit-view></package-accept-templates-edit-view>',
    })
        // External Ingest
        .when('/system/aggregation/:view', {
        template: '<external-metadata></external-metadata>',
        reloadOnSearch: false
    })
        .when('/system/aggregation/edit/:id/:externalIngestType?', {
        template: '<external-metadata-edit-view xsl-templates="$resolve.xslTemplates"></external-metadata-edit-view>',
        resolve: {
            xslTemplates: ['TransformTemplatesResourceFactory',
                function (TransformTemplatesResourceFactory) {
                    return TransformTemplatesResourceFactory.query().$promise;
                }]
        }
    })
        // Exec Servers
        .when('/system/execServers', {
        templateUrl: 'system/execServers/exec-servers-template.html',
        reloadOnSearch: false,
        searchEnabled: true
    })
        // Package Notifications
        .when('/system/packageNotifications/search', {
        template: '<package-notifications-search-view></package-notifications-search-view>',
        label: 'Package Notifications',
        reloadOnSearch: false
    })
        .when('/system/packageNotifications/edit/:notificationId', {
        template: '<package-notifications-edit-view></package-notifications-edit-view>',
        rootRoute: '/system/packageNotifications/search',
        reloadOnSearch: false
    })
        //
        // PACKAGES
        //
        .when('/packages', {
        templateUrl: 'package/package-template.html',
        label: 'Packages - Edit',
        reloadOnSearch: false,
        searchEnabled: true,
        filterEnabled: true
    })
        .when('/packages/package/edit/:id/:editView', {
        templateUrl: 'package/editor/package-edit-template.html',
        controller: 'PackageEditController as pkgEditCtrl',
        rootRoute: '/packages',
        reloadOnSearch: false,
        searchEnabled: false
    })
        .otherwise({
        redirectTo: function () {
            return '/login';
        }
    });
}
angular.module('prism-ui').config(configRoutes);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: branding-service
 *
 * Created by rwilliams on 8/4/17.
 */
'use strict';
angular.module('prism-ui.components.branding').service('BrandingViewService', function (_, $q, AcceptProfileResourceFactory, ArtworkResourceFactory, BrandingAssetService, BreadcrumbService, BreakPrePostRollResourceFactory, ContentEditService, ContentResourceFactory, DebugService, MediaProfileResourceFactory, ModalService, NetworkResourceFactory, NotificationService, PermissionsService, PrePostRollResourceFactory, RequestService) {
    var self = this;
    self.initializeParentBreadcrumbs = function (brandingConfig, params) {
        var breadcrumbDataPromises = [];
        var newBreadcrumbs = [{
                location: brandingConfig.parentLocation,
                params: 'view=' + brandingConfig.type,
            }];
        if (brandingConfig.isShow) {
            breadcrumbDataPromises.push(ContentResourceFactory.get({ id: params.id, view: 'MINIMAL' }).$promise);
            if (brandingConfig.seasonId) {
                breadcrumbDataPromises.push(ContentResourceFactory.getSeason({ id: brandingConfig.seasonId, view: 'MINIMAL' }).$promise);
                newBreadcrumbs.splice(0, 0, {
                    location: brandingConfig.parentLocation.replace(/\/seasons\/.+/, '/seasons'),
                });
            }
            else if (brandingConfig.volumeId) {
                breadcrumbDataPromises.push(ContentResourceFactory.getVolume({ id: brandingConfig.volumeId, view: 'MINIMAL' }).$promise);
                newBreadcrumbs.splice(0, 0, {
                    location: brandingConfig.parentLocation.replace(/\/volumes\/.+/, '/volumes'),
                });
            }
        }
        else {
            breadcrumbDataPromises.push(NetworkResourceFactory.get({ id: params.id, view: 'MINIMAL' }).$promise);
        }
        return $q.all(breadcrumbDataPromises).then(function (breadcrumbsData) {
            return _.map(breadcrumbsData, function (breadcrumbData, index) {
                var parentBreadcrumb = _.get(BreadcrumbService.getBreadcrumbs(), index + 1);
                if (!parentBreadcrumb) {
                    parentBreadcrumb = newBreadcrumbs[index];
                    parentBreadcrumb.name = breadcrumbData.name;
                    BreadcrumbService.addBreadcrumb(parentBreadcrumb);
                }
                return parentBreadcrumb;
            });
        });
    };
    self.getMediaAcceptProfiles = function () {
        var queryParam = {
            fetchLimit: 0,
            view: 'NORMAL'
        };
        return AcceptProfileResourceFactory.query(queryParam).$promise;
    };
    var permissionViewStates = {
        // TODO: All branding use same permission
        networks: {
            preRolls: 'NETWORK_PREROLL_SEARCH_VIEW_STATE',
            postRolls: 'NETWORK_POSTROLL_SEARCH_VIEW_STATE',
            breakPrePostRolls: 'NETWORK_BREAKPREPOSTROLL_SEARCH_VIEW_STATE',
            watermarks: 'NETWORK_WATERMARK_SEARCH_VIEW_STATE',
            artwork: 'NETWORK_ARTWORK_SEARCH_VIEW_STATE'
        },
        series: {
            preRolls: 'SERIES_PREROLL_SEARCH_VIEW_STATE',
            postRolls: 'SERIES_POSTROLL_SEARCH_VIEW_STATE',
            breakPrePostRolls: 'SERIES_PREROLL_SEARCH_VIEW_STATE',
            watermarks: 'SERIES_WATERMARK_SEARCH_VIEW_STATE',
            artwork: 'SERIES_ARTWORK_SEARCH_VIEW_STATE'
        },
        movies: {
            preRolls: 'MOVIE_PREROLL_SEARCH_VIEW_STATE',
            postRolls: 'MOVIE_POSTROLL_SEARCH_VIEW_STATE',
            breakPrePostRolls: 'MOVIE_PREROLL_SEARCH_VIEW_STATE',
            watermarks: 'MOVIE_WATERMARK_SEARCH_VIEW_STATE',
            artwork: 'MOVIE_ARTWORK_SEARCH_VIEW_STATE'
        }
    };
    self.getReadWritePermissions = function (brandingConfig) {
        var permissionViewState = permissionViewStates[brandingConfig.groupName][brandingConfig.type];
        return PermissionsService.getReadWritePermissions(permissionViewState);
    };
    //===========================//
    // Branding Asset Containers //
    //===========================//
    var acceptProfileKey = function (assetType) {
        switch (assetType) {
            case 'watermarks':
                return 'videoAcceptProfile';
            case 'ratingOverlays':
                return 'mediaAcceptProfile';
            default:
                return 'acceptProfile';
        }
    };
    //=================//
    // Branding Assets //
    //=================//
    self.openAssetPreviewModal = function (asset, assetType) {
        if (assetType === 'ratingOverlay') {
            asset = _.assign({ type: 'ratingOverlay' }, asset);
        }
        ModalService.showMediaModal(assetType, asset);
    };
    var assetInfoModalTemplateUrls = {
        cc: 'components/branding/renderers/audio-text-info-renderer-template.html',
        audio: 'components/branding/renderers/audio-text-info-renderer-template.html',
        artwork: 'components/branding/renderers/image-info-renderer-template.html',
        watermark: 'components/branding/renderers/image-info-renderer-template.html',
        ratingOverlay: 'components/branding/renderers/image-info-renderer-template.html',
    };
    self.openAssetInfoModal = function (asset, assetType) {
        var templateUrl = _.get(assetInfoModalTemplateUrls, assetType, "components/branding/renderers/" + assetType + "-info-renderer-template.html");
        switch (assetType) {
            case 'cc':
            case 'audio':
                ModalService.showAssetModal(asset, templateUrl, assetType);
                break;
            case 'ratingOverlay':
                ModalService.showAssetModal(_.assign({ type: 'ratingOverlay' }, asset), templateUrl);
                break;
            default:
                ModalService.showAssetModal(asset, templateUrl);
        }
    };
    self.showVideoIngestStatusNotifications = function (brandingConfig, videoAsset, status, mapPrefix) {
        var acceptProfile = videoAsset[acceptProfileKey(brandingConfig.type)];
        switch (status) {
            case 'COMPLETED':
                NotificationService.createInfoNotification("Proxy COMPLETED for MAP " + mapPrefix + acceptProfile.name);
                break;
            case 'STALLED':
                NotificationService.createWarningNotification("Proxy STALLED for MAP " + mapPrefix + acceptProfile.name);
                break;
            default:
        }
    };
    self.createRootAssetProxyNotifications = function (brandingConfig, rootAsset) {
        var intervalId;
        var deferred = $q.defer();
        var acceptProfile = rootAsset[acceptProfileKey(brandingConfig.type)];
        NotificationService.createInfoNotification("Creating Proxy for MAP " + acceptProfile.name);
        var intervalData = {};
        intervalId = RequestService.createRequestInterval(function () {
            return BrandingAssetService.updateVideoAssetProxyStatus(brandingConfig, rootAsset, intervalData)
                .then(function (status) {
                switch (status) {
                    case 'COMPLETED':
                        RequestService.cancelRequestInterval(intervalId);
                        deferred.resolve();
                        break;
                    case 'STALLED':
                        RequestService.cancelRequestInterval(intervalId);
                        deferred.reject('Failed to create proxy');
                        break;
                }
            });
        }, 2000);
        return deferred.promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: constants
 *
 * Created by rwilliams on 8/8/17.
 */
'use strict';
angular.module('prism-ui.components.constants', [])
    .value('VALID_FILE_EXTENSIONS', {
    ADPOD: ['csv'],
    AUDIO: ['aif', 'aiff', 'mp3', 'mov', 'wav'],
    CC: ['cca', 'scc', 'mcc', 'cap', 'sml', 'srt', 'xml', 'vtt', 'asc', 'dfxp', 'itt'],
    SUBTITLE: ['cca', 'scc', 'mcc', 'cap', 'sml', 'srt', 'xml', 'vtt', 'asc', 'dfxp', 'itt'],
    IMAGE: ['jpg', 'jpeg', 'tiff', 'png'],
    OTHER: ['jpg', 'jpeg', 'tiff', 'png'],
    RATING_OVERLAY: ['jpg', 'jpeg', 'tiff', 'png'],
    VIDEO: ['mov', 'mp4', 'wmv', 'avi', 'webm', 'flv', 'mxf', 'mpg', 'mpeg', 'm2t', 'm2ts', 'ts']
})
    .value('_', window._)
    .value('Timecode', window.tmcd)
    .value('BRAND_ASSET_MAP_TYPES', {
    watermarks: 'VIDEO',
    breakPrePostRolls: 'VIDEO',
    preRolls: 'VIDEO',
    postRolls: 'VIDEO',
    artwork: 'OTHER',
    audios: 'AUDIO',
    ratingOverlays: 'VIDEO'
}).value('MEDIA_INFO_AUDIO_CHANNEL_ASSIGNMENT', [
    { name: 'Center', value: 'C' },
    { name: 'Left', value: 'L' },
    { name: 'LFE', value: 'LFE' },
    { name: 'Left Surround', value: 'Ls' },
    { name: 'Left Total', value: 'Lt' },
    { name: 'Right', value: 'R' },
    { name: 'Right Surround', value: 'Rs' },
    { name: 'Right Total', value: 'Rt' }
]);

'use strict';
angular
    .module('prism-ui.components.data')
    .directive('ignoreDirty', [function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {
                // Override $setDirty method to do nothing
                ngModelCtrl.$setDirty = function () { };
            }
        };
    }]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 4/12/16.
 */
'use strict';
angular.module('prism-ui.components.filters').filter('bitrate', function () {
    return function (bytes) {
        if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) {
            return 'NaN';
        }
        var units = ['bps', 'kbps', 'mbps', 'gbps'], number = Math.floor(Math.log(bytes) / Math.log(1000));
        return (bytes / Math.pow(1000, Math.floor(number))).toFixed(2) + ' ' + units[number];
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 4/12/16.
 */
'use strict';
angular.module('prism-ui.components.filters').filter('bytes', function () {
    return function (bytes) {
        if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) {
            return 'NaN';
        }
        var units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'], number = Math.floor(Math.log(bytes) / Math.log(1000));
        return (bytes / Math.pow(1000, Math.floor(number))).toFixed(2) + ' ' + units[number];
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components.filters').filter('capitalize', function () {
    return function (input) {
        if (!angular.isString(input)) {
            return input;
        }
        return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 9/1/15.
 */
'use strict';
angular.module('prism-ui.components.filters').filter('durationFromSec', function () {
    var padString = function (value, precision, round) {
        var string = '' + Math.floor(value);
        while (string.length < precision) {
            string = '0' + string;
        }
        return string;
    };
    return function (input) {
        if (input) {
            var seconds = input;
            var hours = (seconds / 3600) % 3600;
            var minutes = (seconds / 60) % 60;
            seconds %= 60;
            var label = padString(hours, 2);
            label += ':' + padString(minutes, 2);
            label += ':' + padString(seconds, 2);
            return label;
        }
        return '';
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 10/23/15.
 */
'use strict';
angular.module('prism-ui.components.filters').filter('removeStringSpaces', function () {
    return function (input) {
        if (!angular.isString(input)) {
            return input;
        }
        return input.replace(/[\s]/g, '');
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 12/7/15.
 */
'use strict';
angular.module('prism-ui.components.filters').filter('secFromTimecode', function (Timecode) {
    return function (input, framerate, dropframe) {
        var timecodeFrameCount = Timecode.fromString(input, { frameRate: framerate, dropFrame: dropframe }).frameCount;
        return timecodeFrameCount / framerate;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 12/30/15.
 */
'use strict';
angular.module('prism-ui.components.filters').filter('timeTo12HFormat', function () {
    return function (input) {
        if (!input) {
            return '';
        }
        var timeParts = input.split(':');
        var h = timeParts[0] % 12;
        if (h === 0) {
            h = 12;
        }
        return h + ':' + timeParts[1] + (timeParts[0] < 12 ? ' AM' : ' PM');
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 9/1/15.
 */
'use strict';
angular.module('prism-ui.components.filters').filter('timecodeFromSec', function (Timecode) {
    return function (input, framerate, dropFrame) {
        if (input !== null && typeof input !== 'undefined' && !isNaN(input)) {
            var timecode = Timecode.fromSeconds(input, { frameRate: parseFloat(framerate) || 29.97, dropFrame: dropFrame });
            return timecode.toString();
        }
        return '';
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 1/8/16.
 */
'use strict';
angular.module('prism-ui.components.filters').filter('twoDigitNum', function () {
    return function (input) {
        return (input < 10) ? '0' + input : input;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 5/18/15.
 */
'use strict';
angular.module('prism-ui.components').directive('requiredIndicator', function () {
    return {
        restrict: 'A',
        compile: function (element) {
            element.after('<span class="required-form-control">*</span>');
        }
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 4/30/15.
 */
'use strict';
angular.module('prism-ui.components').controller('MessageModalController', function (_, $uibModalInstance, options) {
    var _this = this;
    this.messageText = options.messageText;
    this.modalTitle = options.title;
    this.showOK = options.showOK;
    this.okText = options.okText;
    this.cancelText = options.cancelText;
    this.windowClass = options.windowClass;
    this.optionsToPersist = options.optionsToPersist;
    this.pullCancelLeft = options.pullCancelLeft;
    this.showCancel = (_.has(options, 'showCancel')) ? options.showCancel : true;
    this.getLines = function () {
        if (!Array.isArray(_this.messageText)) {
            return [_this.messageText];
        }
        else {
            return _this.messageText;
        }
    };
    this.close = function () {
        $uibModalInstance.dismiss('cancel');
    };
    this.onOK = function () {
        if (_.isNil(this.optionsToPersist)) {
            $uibModalInstance.close('OK');
        }
        else {
            $uibModalInstance.close(this.optionsToPersist);
        }
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
//
// Warning: Notification is created with a string copy of this directive's HTML.
//    - Copying strings means buttons will not invoke this directive's functions.
//    - Also, when directive's template changes, the notification won't update.
// To workaround these issues, directive replaces a portion of the copied HTML
// with the directive's original HTML elements.
//    - The portion that isn't copied uses dynamic values set by the notification.
//    - Notice: Any HTML outside of the replaced HTML will not change.
//        - aka: Can't use ng-*** outside of the replaced HTML.
//
/**
 * Created by bbonet on 1/28/15.
 */
'use strict';
angular.module('prism-ui.components').directive('notificationDirective', function ($window) {
    return {
        restrict: 'E',
        templateUrl: 'components/notification/notification-template.html',
        replace: true,
        link: function (scope, iElement, iAttrs) {
            //This directive requires Bootstrap Growl.
            //Details on options and settings for bootstrap growl can be found here: http://bootstrap-growl.remabledesigns.com/
            var options = {};
            if (scope.message) {
                options.message = scope.message;
            }
            if (scope.icon) {
                options.icon = scope.icon;
            }
            if (scope.title) {
                options.title = scope.title;
            }
            var settings = {};
            var notificationVisible = true;
            settings.template = iElement[0].outerHTML;
            settings.onClose = function () {
                notificationVisible = false;
            };
            if (scope.element) {
                settings.element = scope.element; //default: body
            }
            if (scope.type) {
                settings.type = scope.type; //default: info
            }
            if (scope.allow_dismiss !== null && typeof scope.allow_dismiss !== 'undefined') {
                settings.allow_dismiss = scope.allow_dismiss; //default: true
            }
            if (scope.placement) {
                settings.placement = {};
                if (scope.placement.from) {
                    settings.placement.from = scope.placement.from; //default: top
                }
                if (scope.placement.align) {
                    settings.placement.align = scope.placement.align; //default: right
                }
            }
            else {
                settings.placement = {};
                settings.placement.from = 'bottom';
                settings.placement.align = 'left';
            }
            settings.offset = {
                x: 20,
                y: 32
            };
            if (typeof scope.offset === 'number') {
                settings.offset.x = scope.offset;
                settings.offset.y = scope.offset;
            }
            else if (scope.offset) {
                if (scope.offset.x) {
                    settings.offset.x = scope.offset.x;
                }
                if (scope.offset.y) {
                    settings.offset.y = scope.offset.y;
                }
            }
            settings.z_index = scope.z_index || 1000000; //default: 1031
            if (scope.spacing) {
                settings.spacing = scope.spacing; //default: 10
            }
            if (scope.delay) {
                settings.delay = scope.delay; //default: 5000
            }
            if (scope.timer) {
                settings.timer = scope.timer; //default: 1000
            }
            if (scope.mouse_over !== null && typeof scope.mouse_over !== 'undefined') {
                settings.mouse_over = scope.mouse_over; //default: false
            }
            if (!scope.animate) {
                scope.animate = {};
            }
            settings.animate = {
                enter: scope.animate.enter || 'animate__animated animate__fadeInDown animate__fast',
                exit: scope.animate.exit || 'animate__animated animate__fadeOutDown animate__fast'
            };
            if (scope.onShow) {
                settings.onShow = scope.onShow; //default: null
            }
            if (scope.onShown) {
                settings.onShown = scope.onShown; //default: null
            }
            if (scope.onHide) {
                settings.onHide = scope.onHide; //default: null
            }
            if (scope.onHidden) {
                settings.onHidden = scope.onHidden; //default: null
            }
            if (scope.icon_type) {
                settings.icon_type = scope.icon_type; //default: class
            }
            scope.api = $.notify(options, settings);
            var messageContainerElem = scope.api.$ele.find('.alert-message')[0];
            var messageElem = scope.api.$ele.find('[data-notify="message"]')[0];
            var expandButtonElem = iElement.find('.expand.close')[0];
            var longMessageIndicatorElem = iElement.find('.alert-long-message')[0];
            var dynamicElements = ['.expand.close', '.dynamic-notification-content'];
            dynamicElements.forEach(function (searchString) {
                scope.api.$ele.find(searchString).replaceWith(iElement.find(searchString));
            });
            var onFrameRendered = function () {
                if (notificationVisible) {
                    var tooWide = messageElem.offsetWidth > messageContainerElem.offsetWidth;
                    var tooTall = messageElem.offsetHeight > messageContainerElem.offsetHeight;
                    if (tooTall) {
                        longMessageIndicatorElem.classList.remove('ng-hide');
                    }
                    else {
                        longMessageIndicatorElem.classList.add('ng-hide');
                    }
                    if (tooWide || tooTall) {
                        expandButtonElem.classList.remove('ng-hide');
                    }
                    else {
                        expandButtonElem.classList.add('ng-hide');
                    }
                    $window.requestAnimationFrame(onFrameRendered);
                }
            };
            $window.requestAnimationFrame(onFrameRendered);
            scope.expandMessageClicked = function () {
                var originalMessage = (scope.fileErrorsObject) ? scope.fileErrorsObject : scope.message;
                scope.longerMessageCallback(options.message, originalMessage);
            };
        }
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by bbonet on 1/26/15.
 */
'use strict';
angular.module('prism-ui.components').service('NotificationService', function ($injector, $rootScope, $interval, _) {
    var _this = this;
    var DEFAULT_NOTIFICATION_OPTIONS = {
        // Max time to keep notification on screen
        delay: undefined,
        allow_dismiss: undefined,
        moreInfoText: 'details...',
        // Function to call when bottom's "Detail" button is clicked
        moreInfoClickHandler: undefined,
        downloadText: undefined,
        // Function to call when "Download" button is clicked
        downloadCallback: undefined,
    };
    var timedNotifications = [];
    var generateNotification = function (scope, overrideOptions) {
        // When message too long & expand button clicked
        scope.longerMessageCallback = _this.defaultLongerMessageClickHandler;
        // Parse standardized options
        for (var key in DEFAULT_NOTIFICATION_OPTIONS) {
            if (overrideOptions && key in overrideOptions) {
                scope[key] = overrideOptions[key];
            }
            else if (DEFAULT_NOTIFICATION_OPTIONS[key] !== undefined) {
                scope[key] = DEFAULT_NOTIFICATION_OPTIONS[key];
            }
        }
        if (scope.detailText === undefined && scope.moreInfoClickHandler) {
            scope.detailText = 'Details';
        }
        var compile = $injector.get('$compile');
        var notificationElement = angular.element(document.createElement('notification-directive'));
        var notification = compile(notificationElement)(scope);
        return {
            close: function () { return scope.api.close(); },
        };
    };
    // TODO: Refactor all NotificationService calls to use options object
    this.createSuccessNotification = function (message, delay) {
        var options = _.isPlainObject(delay) ? delay : undefined;
        var scope = $rootScope.$new();
        scope.title = 'SUCCESS';
        scope.message = message;
        scope.type = 'success'; //success, info, warning, danger
        /*
         scope.icon = 'fa fa-lg fa-check-circle';
        */
        if (!options) {
            options = { delay: delay || -1 };
        }
        return generateNotification(scope, options);
    };
    this.createInfoNotification = function (message, downloadText, downloadCallback) {
        var options = (_.isPlainObject(downloadText)) ? downloadText : undefined;
        var scope = $rootScope.$new();
        scope.title = 'INFO';
        scope.message = message;
        scope.type = 'success'; //success, info, warning, danger
        /*
         scope.icon = 'fa fa-lg fa-info-circle';
        */
        if (!options && downloadText) {
            options = {
                downloadText: downloadText,
                downloadCallback: downloadCallback,
                delay: (downloadText) ? -1 : 5000,
            };
        }
        return generateNotification(scope, options);
    };
    // TODO: When NotificationService.infoNotification options is standardized, delete function.
    //       This func == same as: options.allowDismiss = false
    this.createPersistentInfoNotification = function (message, details, allowDismiss) {
        var hasDetailFunction = typeof (details) === 'function';
        var scope = $rootScope.$new();
        scope.title = 'INFO';
        scope.message = message;
        scope.type = 'success';
        if (hasDetailFunction) {
            scope.moreInfoClickHandler = details;
        }
        else if (details) {
            scope.detailText = details;
            scope.moreInfoClickHandler = this.defaultMoreInfoClickHandler;
        }
        scope.allow_dismiss = allowDismiss;
        scope.delay = -1;
        return generateNotification(scope);
    };
    this.createPersistentSuccessNotification = function (title, message, details, allowDismiss) {
        var hasDetailFunction = typeof (details) === 'function';
        var scope = $rootScope.$new();
        scope.title = title || 'SUCCESS';
        scope.message = message;
        scope.type = 'success';
        if (hasDetailFunction) {
            scope.moreInfoClickHandler = details;
        }
        else if (details) {
            scope.detailText = details;
            scope.moreInfoClickHandler = this.defaultMoreInfoClickHandler;
        }
        scope.allow_dismiss = allowDismiss;
        scope.delay = -1;
        return generateNotification(scope);
    };
    this.createPersistentWarningNotification = function (title, message, details, allowDismiss) {
        var hasDetailFunction = typeof (details) === 'function';
        var scope = $rootScope.$new();
        scope.title = title || 'WARNING';
        scope.message = message;
        scope.type = 'warning';
        if (hasDetailFunction) {
            scope.moreInfoClickHandler = details;
        }
        else if (details) {
            scope.detailText = details;
            scope.moreInfoClickHandler = this.defaultMoreInfoClickHandler;
        }
        scope.allow_dismiss = allowDismiss;
        scope.delay = -1;
        return generateNotification(scope);
    };
    this.createWarningNotification = function (message, moreInfoCallback) {
        var options = (_.isPlainObject(moreInfoCallback)) ? moreInfoCallback : undefined;
        var scope = $rootScope.$new();
        scope.title = 'WARNING';
        scope.message = message;
        scope.type = 'warning'; //success, info, warning, danger
        /*
         scope.icon = 'fa fa-lg fa-exclamation-triangle';
        */
        if (!options) {
            scope.moreInfo = moreInfoCallback;
            options = { moreInfoClickHandler: moreInfoCallback };
        }
        return generateNotification(scope, options);
    };
    this.createFailureNotification = function (message, detailText, allowDismiss, delay) {
        var options = _.isPlainObject(detailText) ? detailText : undefined;
        var scope = $rootScope.$new();
        scope.title = 'ERROR';
        if (_.isString(message)) {
            scope.message = message;
        }
        else {
            scope.message = message.errorText;
            scope.fileErrorsObject = message.fileErrorsObject;
        }
        scope.type = 'danger'; //success, info, warning, danger
        /*
         scope.icon = 'fa fa-lg fa-times-circle';
        */
        if (!options) {
            scope.detailText = detailText;
            options = {
                moreInfoClickHandler: this.defaultMoreInfoClickHandler,
                allow_dismiss: allowDismiss,
                delay: delay || -1,
            };
        }
        return generateNotification(scope, options);
    };
    this.createTimedInfoNotification = function (message, intervalTime) {
        var timed = $interval(this.createInfoNotification, intervalTime, 1, true, message);
        timedNotifications.push(timed);
    };
    this.defaultLongerMessageClickHandler = function (messageText, message) {
        var ModalService = $injector.get('ModalService');
        ModalService.showMessageModal({
            messageText: messageText,
            pullCancelLeft: true,
            title: 'Error Message',
            windowClass: 'wide-message-modal'
        });
    };
    this.defaultMoreInfoClickHandler = function (detailText, message) {
        var messageOptions = {
            messageText: detailText,
            pullCancelLeft: true,
            title: 'Message Detail',
            windowClass: 'wide-message-modal'
        };
        if (message && !_.isString(message)) {
            messageOptions.messageText = [detailText];
            _.forEach(message, function (messageObject) {
                if (_.get(messageObject, 'failures')) {
                    _.forEach(messageObject.failures, function (failure) {
                        var failureMessage = failure.source + ": " + failure.description;
                        messageOptions.messageText.push(failureMessage);
                    });
                }
                else {
                    messageOptions.messageText.push(messageObject);
                }
            });
        }
        var ModalService = $injector.get('ModalService');
        ModalService.showMessageModal(messageOptions);
    };
    this.clearTimedNotifications = function () {
        angular.forEach(timedNotifications, function (timed) {
            $interval.cancel(timed);
        });
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 12/21/15.
 */
'use strict';
angular.module('prism-ui.components').controller('ProxyPlayerController', function ($rootScope, $scope, $sce, EndPointService, ProxyPlayerService) {
    var self = this;
    // hard-coded MIME types - these are a safe bet for now given
    // current HTML5 format support
    var MimeTypeAudioMp3 = 'audio/mp3';
    var MimeTypeVideoMp4 = 'video/mp4';
    var MimeTypeTextVtt = 'text/vtt';
    self.config = {
        sources: [{
                src: '',
                type: MimeTypeVideoMp4
            }],
        autoHide: true,
        autoHideTime: 3000,
        tracks: [{
                src: '',
                default: true,
                type: MimeTypeTextVtt
            }],
        cuePoints: self.cuePoints,
        plugins: {
            poster: self.posterPath
        }
    };
    self.onPlayerReady = function (API) {
        self.API = API;
    };
    self.onUpdateTime = function (currentTime, duration) {
        ProxyPlayerService.playerTime = currentTime;
        if (ProxyPlayerService.onTimeUpdate) {
            ProxyPlayerService.onTimeUpdate(currentTime, duration);
        }
    };
    self.onUpdateState = function (state) {
        if (ProxyPlayerService.onChangedState) {
            ProxyPlayerService.onChangedState(state);
        }
    };
    ProxyPlayerService.seek = function (seekValue) {
        self.API.seekTime(seekValue);
    };
    ProxyPlayerService.stop = function () {
        self.API.stop();
    };
    ProxyPlayerService.pause = function () {
        self.API.pause();
    };
    ProxyPlayerService.play = function () {
        self.API.play();
    };
    $scope.$watch(function () {
        return self.media;
    }, function (newVal) {
        if (newVal && newVal !== '') {
            self.API.stop();
            self.config.sources = [{
                    src: $sce.trustAsResourceUrl(self.media.mediaPath),
                    type: self.isAudio ? MimeTypeAudioMp3 : MimeTypeVideoMp4
                }];
        }
    });
    $scope.$watch(function () {
        return self.cuePoints;
    }, function (newVal, oldVal) {
        if (newVal !== oldVal) {
            self.config.cuePoints = newVal;
        }
    });
    $scope.$watch(function () {
        return self.ccSubtitle;
    }, function (newVal) {
        if (newVal && newVal !== '') {
            self.config.tracks = [{
                    src: $sce.trustAsResourceUrl(self.ccSubtitle.mediaPath),
                    default: true,
                    type: MimeTypeTextVtt,
                    label: newVal
                }];
        }
        else {
            self.config.tracks = [];
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 12/21/15.
 */
'use strict';
angular.module('prism-ui.components').directive('proxyPlayer', function () {
    return {
        restrict: 'E',
        templateUrl: 'components/proxyPlayer/proxy-player-template.html',
        controller: 'ProxyPlayerController as playerCtrl',
        scope: true,
        bindToController: {
            media: '=',
            ccSubtitle: '=',
            posterPath: '=',
            cuePoints: '=',
            isAudio: '=',
            offset: '=',
            framerate: '='
        }
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 3/31/16.
 */
'use strict';
angular.module('prism-ui.components').service('ProxyPlayerService', function () {
    var ProxyPlayerService = this;
    ProxyPlayerService.seek = null;
    ProxyPlayerService.stop = null;
    ProxyPlayerService.pause = null;
    ProxyPlayerService.play = null;
    ProxyPlayerService.playerTime = null;
    ProxyPlayerService.onTimeUpdate = null;
    ProxyPlayerService.onChangedState = null;
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: subscription-edit-grid-component.js
 *
 * Created by randysorensen on 5/17/17.
 */
'use strict';
function SubscriptionEditGridController(_, uiGridConstants, $timeout, $routeParams, $location, SubscriptionsService, NavbarUtilService, PaginationService, UtilsService, DynamicPropertiesService, ModalService, SearchFilterService, NotificationService, BreadcrumbService, SidebarService) {
    var self = this;
    var canLeaveOrRefresh = function () {
        if (self.editorForm.$dirty) {
            NotificationService.createWarningNotification('You have unsaved changes! ' +
                'Please save or revert your changes before refreshing the subscriptions list.', '');
            return false;
        }
        else {
            return true;
        }
    };
    //======//
    // Data //
    //======//
    var setQueryOptions = function () {
        SubscriptionsService.queryOptions.searchString =
            SubscriptionsService.queryOptions.keywords = $location.search().searchText || null;
        if (self.showDisabled && !self.showEnabled && self.pagingOptions.currentPage > 1) {
            self.pagingOptions.currentPage = 1;
        }
        SubscriptionsService.queryOptions.fetchOffset = self.pagingOptions.pageSize * (self.pagingOptions.currentPage - 1);
        SubscriptionsService.queryOptions.fetchLimit = self.pagingOptions.pageSize;
        SubscriptionsService.queryOptions.includeEnabled = self.showEnabled;
        SubscriptionsService.queryOptions.includeDisabled = self.showDisabled;
    };
    var initializeQuery = function () {
        self.loadingIndicator.show = true;
        setQueryOptions();
    };
    var setContentCategoryBreadcrumbNames = function () {
        self.contentBreadcrumb.location = "/meta/" + UtilsService.getPathKeywordFromContentType(SubscriptionsService.contentObject.type) + "/edit/" + SubscriptionsService.contentObject.id + "/categories";
        self.contentBreadcrumb.name = SubscriptionsService.contentObject.name;
        self.categoryBreadcrumb.name = SubscriptionsService.contentCategoryObject.category.name;
    };
    var addPartnerCustomMetadataColumns = function (partnerId) {
        SubscriptionsService.getPartnerCustomMetadataProperties(partnerId).then(function (props) {
            var sortedProps = _.sortBy(props, [function (metaItem) { return metaItem.displayIndex; }]);
            _.forEach(sortedProps, function (propertyObject) {
                self.gridOptions.columnDefs.push({
                    field: 'metadata.properties.' + propertyObject.name,
                    type: 'string',
                    width: '*',
                    minWidth: 200,
                    cellTemplate: 'components/subscription/gridTemplates/subscription-custom-meta-template.html',
                    displayName: propertyObject.displayName,
                    definition: propertyObject
                });
            });
        });
    };
    var queryCompleted = function (subs) {
        self.subscriptionData = subs;
        self.originalSubscriptionData = _.cloneDeep(self.subscriptionData);
        self.originalSubscriptionDataById = _.keyBy(self.originalSubscriptionData, 'id');
        self.gridOptions.data = self.subscriptionData;
        if (!!self.editorForm && !self.editorForm.$pristine) {
            self.editorForm.$setPristine();
        }
        $timeout(function () {
            self.isCellModified.cache.clear();
        });
        self.gridApi.selection.clearSelectedRows();
        self.gridApi.core.refresh();
        self.loadingIndicator.show = false;
        if (!self.isPartner) {
            setContentCategoryBreadcrumbNames();
        }
    };
    var getSubscriptionData = null;
    var setupGetDataFunction = function () {
        if (self.isPartner) {
            // For partner subscriptions
            getSubscriptionData = function () {
                initializeQuery();
                var partnerId = $routeParams.id;
                SubscriptionsService.getPartnerSubscriptions(partnerId)
                    .then(queryCompleted);
            };
        }
        else {
            // For content category subscriptions
            getSubscriptionData = function () {
                initializeQuery();
                var contentId = $routeParams.id;
                var contentCategoryId = $routeParams.contentCategoryId;
                SubscriptionsService.getContentCategorySubscriptions(contentId, contentCategoryId)
                    .then(queryCompleted);
            };
        }
    };
    var getChangedSubscriptions = function () {
        var changed = [];
        self.subscriptionData.forEach(function (sub) {
            var original = self.originalSubscriptionDataById[sub.id];
            if (UtilsService.compareBasic(sub, original) !== 0) {
                changed.push(sub);
            }
        });
        return changed;
    };
    var saveSubscriptions = function () {
        self.loadingIndicator.show = true;
        var changed = getChangedSubscriptions();
        SubscriptionsService.updateSubscriptions(changed)
            .then(getSubscriptionData);
    };
    var revertSubscriptions = function () {
        self.subscriptionData = _.cloneDeep(self.originalSubscriptionData);
        self.gridOptions.data = self.subscriptionData;
        self.editorForm.$setPristine();
        // If cache reset without timeout, isCellModified memoizes old modified flag.
        $timeout(function () {
            self.isCellModified.cache.clear();
        });
        self.gridApi.selection.clearSelectedRows();
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    self.$onInit = function () {
        // Loading indicator
        self.loadingIndicator = {
            backdrop: true,
            show: true,
            title: 'Working',
            message: 'Please wait...'
        };
        // For partner subscriptions grid: augment grid columns
        // with partner custom metadata
        if (self.isPartner) {
            var partnerId = $routeParams.id;
            addPartnerCustomMetadataColumns(partnerId);
        }
        // Initialize pagination
        if ($routeParams.id !== SubscriptionsService.partnerIdForSubscriptionFilter) {
            SubscriptionsService.searchCriteria = null;
            SubscriptionsService.partnerIdForSubscriptionFilter = null;
        }
        self.pagingOptions = PaginationService;
        PaginationService.currentPage = 1;
        DynamicPropertiesService.queryForProperties().then(function () {
            self.crewMemberRoles = DynamicPropertiesService.getPropValueAsList('package.crewMemberRoles');
            PaginationService.pageSize = DynamicPropertiesService.getPropValue(self.isPartner ? 'partnerSubscriptions.defaultFetchLimit' : 'contentCategorySubscriptions.defaultFetchLimit', UtilsService.constants.DEFAULT_FETCH_LIMIT);
            // Get grid/edit data
            setupGetDataFunction();
            getSubscriptionData();
            // Hookup navbar search button
            NavbarUtilService.viewSearchFunction = function () {
                if (canLeaveOrRefresh()) {
                    getSubscriptionData();
                }
            };
        });
        // Freshen the query options
        SubscriptionsService.resetQueryOptions();
        // Tell services that the subscriptions service is in
        // charge of our editor form (so the user can't leave
        // via breadcrumbs or sidebar with a dirty grid)
        BreadcrumbService.editService = SubscriptionsService;
        SidebarService.editService = SubscriptionsService;
    };
    self.$postLink = function () {
        $timeout(function () {
            SubscriptionsService.editorForm = self.editorForm;
        });
    };
    //========//
    // Filter //
    //========//
    var filterPartnerSubscriptions = function () {
        self.pagingOptions.currentPage = 1;
        SubscriptionsService.partnerIdForSubscriptionFilter = $routeParams.id;
        SearchFilterService.updateLocationSearch();
        getSubscriptionData();
    };
    var filterContentSubscriptions = function () {
        self.pagingOptions.currentPage = 1;
        SearchFilterService.updateLocationSearch();
        getSubscriptionData();
    };
    var handleSearchFilterModalCancel = function (cancelMessage) {
        if (cancelMessage === 'setToDefaults') {
            SearchFilterService.resetCriteriaToDefault();
            SubscriptionsService.resetQueryOptions();
            getSubscriptionData();
        }
    };
    NavbarUtilService.viewFilterBtnHandler = function () {
        if (canLeaveOrRefresh()) {
            if (self.isPartner) {
                ModalService.showPartnerSubscriptionFilterModal(filterPartnerSubscriptions, handleSearchFilterModalCancel);
            }
            else {
                ModalService.showContentCategorySubscriptionFilterModal(SubscriptionsService.contentObject.seasons, SubscriptionsService.contentObject.volumes, filterContentSubscriptions, handleSearchFilterModalCancel);
            }
        }
    };
    //================//
    // Event Handlers //
    //================//
    var getCellMemoizeKey = function (sub, field) {
        return sub.id + "|" + field;
    };
    // Stop using memoized self.isCellModified() result for all columns of this subscription
    self.invalidateSubscriptionModifiedCache = function (subscription) {
        _.forEach(self.gridOptions.columnDefs, function (column) {
            self.isCellModified.cache.delete(getCellMemoizeKey(subscription, column.field));
        });
    };
    var patchSubscriptionMetadata = function (subscription, changeSet, batchUpdate) {
        if (_.get(subscription, 'metadata.properties')) {
            _.chain(subscription.metadata.properties)
                .keys()
                .filter(function (propName) { return !batchUpdate || changeSet.metadata.properties[propName].includeInBatchUpdate; })
                .forEach(function (propName) {
                var oldProp = subscription.metadata.properties[propName];
                var newProp = changeSet.metadata.properties[propName];
                if (!_.isUndefined(newProp.expression)) {
                    // set an expression
                    delete oldProp.value;
                    oldProp.expression = _.trim(newProp.expression);
                }
                else if (!_.isUndefined(newProp.value)) {
                    // set a value
                    delete oldProp.expression;
                    oldProp.value = newProp.value;
                }
                else {
                    // blank the field
                    delete oldProp.expression;
                    oldProp.value = '';
                }
            })
                .value();
        }
    };
    var patchSubscription = function (sub, changeSet) {
        _.forEach(_.keys(changeSet), function (prop) {
            if (prop !== 'metadata') {
                var newValue = changeSet[prop];
                sub[prop] = newValue === null ? {} : newValue;
            }
        });
    };
    var updateSubscriptionHandler = function (subscriptionChangeSet) {
        var wasBatchUpdate = self.gridApi.selection.getSelectedCount() > 1;
        var subs;
        if (wasBatchUpdate) {
            subs = self.gridApi.selection.getSelectedRows();
        }
        else {
            subs = self.gridOptions.data.filter(function (sub) { return sub.id === subscriptionChangeSet.id; });
        }
        _.forEach(subs, function (sub) {
            patchSubscription(sub, subscriptionChangeSet);
            if (!wasBatchUpdate || self.isPartner) {
                // Partner custom metadata cannot be batch-updated
                // from the content categories screen.
                patchSubscriptionMetadata(sub, subscriptionChangeSet, wasBatchUpdate);
            }
            self.invalidateSubscriptionModifiedCache(sub);
        });
        self.editorForm.$setDirty();
    };
    var handleNewSubscription = function (newSubscriptionData) {
        self.loadingIndicator.show = true;
        SubscriptionsService.createSubscription({
            enabled: true,
            artwork: newSubscriptionData.artwork,
            content: SubscriptionsService.contentObject,
            category: SubscriptionsService.contentCategoryObject.category,
            partner: newSubscriptionData.partner
        }).then(function (newSubscription) {
            getSubscriptionData();
        }, function () {
            NotificationService.createFailureNotification('Subscription already exists.  Please check enabled and disabled subscriptions.', '', true);
            self.loadingIndicator.show = false;
        });
    };
    var openSubscriptionModal = function (subscriptions) {
        ModalService.showContentSubscriptionPropertiesModal(subscriptions, false, self.isPartner, updateSubscriptionHandler);
    };
    //======//
    // Grid //
    //======//
    self.seasonVolumeFormat = function (row, col) {
        var formattedDisplayName = col.field.split('.')[0];
        if (row.entity.hasOwnProperty(formattedDisplayName)) {
            var artworkObject = row.entity[formattedDisplayName];
            if (formattedDisplayName === 'artwork' && artworkObject && artworkObject.length > 0) {
                var artworkArray = [];
                _.forEach(artworkObject, function (artwork) {
                    if (artwork.artworkSeasonVolume) {
                        if (artwork.artwork.name.length > 12) {
                            artworkArray.push(artwork.artwork.name.substring(0, 12) + '...(S/V)');
                        }
                        else {
                            artworkArray.push(artwork.artwork.name + ' (S/V)');
                        }
                    }
                    else {
                        artworkArray.push(artwork.artwork.name);
                    }
                });
                return artworkArray.join(', ');
            }
            else {
                if (row.entity[formattedDisplayName + 'SeasonVolume']) {
                    if (row.entity[formattedDisplayName].name.length > 12) {
                        return row.entity[formattedDisplayName].name.substring(0, 12) + '...(S/V)';
                    }
                    else {
                        return row.entity[formattedDisplayName].name + ' (S/V)';
                    }
                }
                else {
                    return (row.entity[formattedDisplayName]) ? row.entity[formattedDisplayName].name : '';
                }
            }
        }
    };
    self.getPartnerMetadataField = function (row, col) {
        var metaProp = _.get(row.entity, col.field);
        var pickListItems = _.get(col.colDef, 'definition.picklistItems');
        var uiControlHint = _.get(col.colDef, 'definition.uiControlHint');
        if (uiControlHint === 'CheckboxList') {
            if (metaProp.hasOwnProperty('value') && metaProp.value.length > 0) {
                var selectedItems = [];
                _.forEach(metaProp.value, function (value) {
                    selectedItems.push(_.filter(pickListItems, function (item) {
                        return item.id === value;
                    })[0]);
                });
                return _.join(_.map(selectedItems, 'displayName'), ', ');
            }
            else {
                return '';
            }
        }
        else if (uiControlHint === 'List') {
            if (metaProp.hasOwnProperty('value')) {
                return _.map(_.filter(pickListItems, function (item) {
                    return item.id === metaProp.value;
                }), 'displayName')[0];
            }
        }
        return metaProp.value || metaProp.expression;
    };
    self.gridApi = null;
    self.searchText = null;
    self.gridColumnDefs = [
        {
            field: 'checkMark',
            width: '50',
            enableSorting: false,
            enableColumnResizing: false,
            cellTemplate: 'components/visual/grid/check-mark-template.html',
            headerCellTemplate: 'components/visual/grid/header-check-mark-row-count-template.html',
            enablePinning: true,
            displayName: '',
            pinnedLeft: true
        },
        {
            partnerOnly: true,
            field: 'content.name',
            type: 'string',
            minWidth: 200,
            displayName: 'Content',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html',
            enablePinning: true,
            pinnedLeft: true,
        },
        {
            partnerOnly: true,
            field: 'category.name',
            type: 'string',
            minWidth: 200,
            displayName: 'Category',
            cellTemplate: 'components/subscription/gridTemplates/subscription-property-default-template.html',
            enablePinning: true,
            pinnedLeft: true,
        },
        {
            contentCategoryOnly: true,
            field: 'partner.name',
            type: 'string',
            minWidth: 250,
            displayName: 'Partner',
            cellTemplate: 'components/subscription/gridTemplates/subscription-property-default-template.html',
            enablePinning: true,
            pinnedLeft: true
        },
        {
            field: 'enabled',
            type: 'string',
            minWidth: 90,
            displayName: 'Enabled',
            cellTemplate: 'components/subscription/gridTemplates/subscription-enabled-template.html'
        },
        {
            seriesOnly: true,
            field: 'seasonSubscription',
            type: 'string',
            minWidth: 70,
            displayName: 'Type',
            cellTemplate: 'components/subscription/gridTemplates/subscription-type-template.html'
        },
        {
            seriesOnly: true,
            field: 'seasons',
            type: 'string',
            minWidth: 140,
            displayName: 'Volumes / Seasons',
            cellTemplate: 'components/subscription/gridTemplates/subscription-seasons-volumes-template.html'
        },
        {
            field: 'preRoll',
            seasonVolumeField: 'preRollSeasonVolume',
            type: 'string',
            minWidth: 170,
            displayName: 'Pre-Roll',
            cellTemplate: 'components/subscription/gridTemplates/branding-season-volume-template.html'
        },
        {
            field: 'postRoll',
            seasonVolumeField: 'postRollSeasonVolume',
            type: 'string',
            minWidth: 170,
            displayName: 'Post-Roll',
            cellTemplate: 'components/subscription/gridTemplates/branding-season-volume-template.html'
        },
        {
            field: 'breakPrePostRoll',
            seasonVolumeField: 'breakPrePostRollSeasonVolume',
            type: 'string',
            minWidth: 170,
            displayName: 'Break Pre/Postroll',
            cellTemplate: 'components/subscription/gridTemplates/branding-season-volume-template.html'
        },
        {
            field: 'nielsenTemplate.name',
            type: 'string',
            minWidth: 232,
            displayName: 'Nielsen Template',
            cellTemplate: 'components/subscription/gridTemplates/subscription-property-default-template.html'
        },
        {
            field: 'nexGuardEnabledFlag',
            type: 'boolean',
            displayName: 'NexGuard Enabled',
            minWidth: 155,
            cellTemplate: 'components/subscription/gridTemplates/subscription-boolean-template.html',
        },
        {
            field: 'watermark',
            seasonVolumeField: 'watermarkSeasonVolume',
            type: 'string',
            minWidth: 180,
            displayName: 'Watermark',
            cellTemplate: 'components/subscription/gridTemplates/branding-season-volume-template.html'
        },
        {
            // aggregate of three fields: watermarkOffsetSeconds, watermarkFadeInSeconds, watermarkFadeOutSeconds
            field: 'watermarkFadeInSeconds',
            type: 'string',
            minWidth: 310,
            displayName: 'Watermark Details (in seconds)',
            cellTemplate: 'components/subscription/gridTemplates/subscription-watermark-details-template.html'
        },
        {
            field: 'intermediateVideoTemplate.name',
            type: 'string',
            minWidth: 232,
            displayName: 'Master Intermediate Template',
            cellTemplate: 'components/subscription/gridTemplates/subscription-property-default-template.html'
        },
        {
            field: 'videoRoles',
            type: 'string',
            minWidth: 250,
            displayName: 'Main Video + Component Role',
            cellTemplate: 'components/subscription/gridTemplates/subscription-component-role-template.html'
        },
        {
            field: 'artwork',
            type: 'string',
            minWidth: 140,
            displayName: 'Artwork',
            cellTemplate: 'components/subscription/gridTemplates/branding-season-volume-template.html'
        },
        {
            field: 'dueDateTemplate.name',
            type: 'string',
            minWidth: 232,
            displayName: 'SLA Template',
            cellTemplate: 'components/subscription/gridTemplates/subscription-property-default-template.html'
        },
        {
            field: 'deliveryEligibilityExpression',
            type: 'string',
            minWidth: 240,
            displayName: 'Delivery Eligibility Expression',
            cellTemplate: 'components/subscription/gridTemplates/subscription-property-default-template.html'
        },
        {
            seriesOnly: true,
            field: 'requiredCrewRoles',
            type: 'string',
            minWidth: 170,
            displayName: 'Required Collaborators',
            cellTemplate: 'components/subscription/gridTemplates/subscription-collaborators-template.html'
        },
        {
            field: 'priorityOffset',
            type: 'string',
            minWidth: 130,
            displayName: 'Priority Offset',
            cellTemplate: 'components/subscription/gridTemplates/subscription-property-default-template.html'
        },
        {
            field: 'territory.name',
            type: 'string',
            minWidth: 100,
            displayName: 'Territory',
            cellTemplate: 'components/subscription/gridTemplates/subscription-property-default-template.html'
        },
        {
            contentCategoryOnly: true,
            field: 'metadata',
            type: 'string',
            minWidth: 240,
            displayName: 'Custom Meta Modified',
            cellTemplate: 'components/subscription/gridTemplates/subscription-custom-meta-change-template.html'
        }
    ];
    var pruneColumnDefs = function () {
        var columnDefs = [];
        self.gridColumnDefs.forEach(function (column) {
            if (self.isPartner && !column.contentCategoryOnly) {
                columnDefs.push(column);
            }
            else if (!self.isPartner && !column.partnerOnly) {
                var contentType = $location.path().indexOf('movies') > 0 ? 'movies' : 'series';
                if (contentType === 'series' || !column.seriesOnly) {
                    columnDefs.push(column);
                }
            }
        });
        return columnDefs;
    };
    self.getSubscriptionStatus = function (sub) {
        if (!sub.enabled) {
            return 'subscription-disabled';
        }
        if (sub.adHocPackageId) {
            return 'subscription-adhoc';
        }
        if ((!!sub.seasons && sub.seasons.length > 0) || (!!sub.volumes && sub.volumes.length > 0)) {
            return 'subscription-partial';
        }
        else {
            return 'subscription-all';
        }
    };
    self.gridOptions = {
        rowSelection: false,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        multiSelect: true,
        columnDefs: pruneColumnDefs(),
        onRegisterApi: function (gridApi) {
            self.gridApi = gridApi;
        }
    };
    self.rowDoubleClick = function (row) {
        var selectedCount = self.gridApi.selection.getSelectedCount();
        var selectedRows = self.gridApi.selection.getSelectedRows();
        var multiSelect = selectedCount > 1;
        var batchUpdate = false;
        if (multiSelect) {
            // Multiple rows selected... is the double-clicked
            // row one of them?
            batchUpdate = !!_.find(selectedRows, function (subscription) {
                return subscription.id === row.entity.id;
            });
        }
        var selectedSubscriptionsList;
        if (batchUpdate) {
            selectedSubscriptionsList = _.cloneDeep(selectedRows);
            openSubscriptionModal(selectedSubscriptionsList);
        }
        else {
            var editSelectedSubscription = function () {
                selectedSubscriptionsList = [_.cloneDeep(row.entity)];
                openSubscriptionModal(selectedSubscriptionsList);
            };
            if (multiSelect) {
                ModalService.showMessageModal({
                    messageText: 'You have one or more subscriptions selected, but have ' +
                        'chosen to edit a single unselected subscription.',
                    title: 'Update Unselected Subscription',
                    windowClass: 'confirm-modal-lg',
                    showOK: true,
                    showCancel: true,
                    pullCancelLeft: true,
                }, editSelectedSubscription);
            }
            else {
                editSelectedSubscription();
            }
        }
    };
    self.preventRowDefault = function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    };
    self.toggleRows = function (event) {
        if (self.gridApi.selection.selectAll) {
            self.gridApi.selection.clearSelectedRows(event);
            self.gridApi.selection.selectAll = false;
        }
        else {
            self.gridApi.selection.selectAllVisibleRows(event);
            self.gridApi.selection.selectAll = true;
        }
    };
    var isCellModified = function (row, col) {
        var originalSubscription = self.originalSubscriptionDataById[row.entity.id];
        var result = false;
        if (col.field === 'seasons') {
            var subTypeName = (row.entity.seasonSubscription) ? 'seasons' : 'volumes';
            var seasonOrVolume = (row.entity.seasonSubscription) ? 'season' : 'volume';
            if (originalSubscription[subTypeName].length === row.entity[subTypeName].length) {
                result = !_.chain(originalSubscription[subTypeName])
                    .differenceBy(row.entity[subTypeName], seasonOrVolume + '.id')
                    .isEmpty()
                    .value();
            }
            else {
                result = true;
            }
        }
        else if (col.field === 'metadata') {
            result = UtilsService.compareBasic(_.get(originalSubscription, 'metadata.properties'), _.get(row.entity, 'metadata.properties')) !== 0;
        }
        else {
            result = UtilsService.compareBasic(_.get(originalSubscription, col.field), _.get(row.entity, col.field)) !== 0;
            if (col.colDef.seasonVolumeField) {
                var result_sv = UtilsService.compareBasic(_.get(originalSubscription, col.colDef.seasonVolumeField), _.get(row.entity, col.colDef.seasonVolumeField)) !== 0;
                result = result || result_sv;
            }
        }
        return result;
    };
    self.isCellModified = _.memoize(isCellModified, function (row, col) {
        return getCellMemoizeKey(row.entity, col.field);
    });
    //=================//
    // Toolbar Buttons //
    //=================//
    var isNotPristine = function () {
        return self.editorForm && !self.editorForm.$pristine;
    };
    self.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: function () { return !self.isPartner && self.editorForm.$pristine; },
            onClick: function () {
                if (canLeaveOrRefresh()) {
                    ModalService.showNewSubscriptionModal(SubscriptionsService.contentCategoryObject.category.type.id, SubscriptionsService.contentCategoryObject.category.id, SubscriptionsService.contentObject.id, SubscriptionsService.contentObject.network.id, handleNewSubscription);
                }
            }
        },
        {
            label: 'Save',
            enabled: function () {
                return isNotPristine();
            },
            onClick: function () {
                ModalService.showMessageModal({
                    messageText: 'You are about to SAVE all pending subscription changes. ' +
                        'Are you sure you wish to continue?',
                    title: 'Save Subscriptions',
                    showOK: true,
                    okText: 'Yes',
                    pullCancelLeft: true,
                    cancelText: 'No',
                    windowClass: 'confirm-modal-sm'
                }, saveSubscriptions);
            }
        },
        {
            label: 'Revert',
            enabled: function () {
                return isNotPristine();
            },
            onClick: function () {
                ModalService.showMessageModal({
                    messageText: 'You are about to REVERT all pending subscription changes. ' +
                        'Are you sure you wish to continue?',
                    title: 'Revert Subscriptions',
                    showOK: true,
                    okText: 'Yes',
                    pullCancelLeft: true,
                    cancelText: 'No',
                    windowClass: 'confirm-modal-sm'
                }, revertSubscriptions);
            }
        },
        {
            label: 'Close',
            enabled: function () { return false; },
            onClick: null
        },
    ];
    //===========================//
    // Toolbar Filter Checkboxes //
    //===========================//
    self.showEnabled = true;
    self.showDisabled = false;
    var showEnabledCB = {
        label: 'Show Enabled',
        isChecked: self.showEnabled,
    };
    var showDisabledCB = {
        label: 'Show Disabled',
        isChecked: self.showDisabled,
    };
    showEnabledCB.onUpdate = function (newValue) {
        if (canLeaveOrRefresh()) {
            // unchecking "Show Enabled" will automatically check "Show Disabled"
            showEnabledCB.isChecked = newValue;
            self.showEnabled = newValue;
            if (!newValue) {
                showDisabledCB.isChecked = true;
                self.showDisabled = true;
            }
            getSubscriptionData();
        }
        else {
            showEnabledCB.isChecked = !newValue;
        }
    };
    showDisabledCB.onUpdate = function (newValue) {
        if (canLeaveOrRefresh()) {
            // unchecking "Show Disabled" will automatically check "Show Enabled"
            showDisabledCB.isChecked = newValue;
            self.showDisabled = newValue;
            if (!newValue) {
                showEnabledCB.isChecked = true;
                self.showEnabled = true;
            }
            getSubscriptionData();
        }
        else {
            showDisabledCB.isChecked = !newValue;
        }
    };
    self.toolbarCheckboxDefs = [
        showEnabledCB,
        showDisabledCB
    ];
    //============//
    // Pagination //
    //============//
    self.onPaginationChanged = function () {
        getSubscriptionData();
    };
    self.paginationPageSizeChanged = function () {
        self.pagingOptions.currentPage = 1;
        self.onPaginationChanged();
    };
    self.paginationPrevPageHandler = function () {
        --self.pagingOptions.currentPage;
        self.onPaginationChanged();
    };
    self.paginationNextPageHandler = function () {
        ++self.pagingOptions.currentPage;
        self.onPaginationChanged();
    };
    self.paginationDefs = {
        paginationPrevPageHandler: self.paginationPrevPageHandler,
        paginationNextPageHandler: self.paginationNextPageHandler,
        paginationPageSizeChanged: self.paginationPageSizeChanged,
        paginationJumpToPageHandler: self.onPaginationChanged,
        disabled: function () {
            return self.editorForm.$dirty;
        },
        pagingOptions: PaginationService,
    };
}
angular
    .module('prism-ui.components')
    .component('subscriptionEditGrid', {
    templateUrl: 'components/subscription/subscription-edit-grid-template.html',
    controller: SubscriptionEditGridController,
    bindings: {
        isPartner: '<',
        contentBreadcrumb: '<',
        categoryBreadcrumb: '<'
    }
})
    .filter('volumeSeasonFilter', function () {
    return function (value, grid) {
        if (grid.row.entity.content.type !== 'Series') {
            return 'N/A';
        }
        var type = (grid.row.entity.seasonSubscription) ? ' Seasons' : ' Volumes';
        if (value.length === 0) {
            return 'All' + type;
        }
        else if (value.length === 1) {
            return value.length + type.slice(0, -1);
        }
        else {
            return value.length + type;
        }
    };
})
    .filter('artworkAssetFilter', function () {
    return function (value) {
        if (value.length === 1) {
            return '1 Artwork Asset';
        }
        else if (value.length > 1) {
            return value.length + ' Artwork Assets';
        }
        else {
            return '';
        }
    };
})
    .filter('videoRolesFilter', function (_) {
    return function (videoRoles) {
        return _.map(videoRoles, 'role.name').join(', ');
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: file-upload-select-service
 *
 * Created by rwilliams on 8/22/17.
 */
'use strict';
angular.module('prism-ui.components').service('FileUploadSelectService', function (MediaProfileResourceFactory) {
    var self = this;
    self.validateAsset = function (path, profileId, brandType) {
        var queryParams = {
            path: path,
            profileId: profileId
        };
        var prePostRoll = (brandType === 'preRolls' || brandType === 'postRolls' || brandType === 'breakPrePostRolls');
        var watermark = brandType === 'watermarks';
        if (prePostRoll) {
            return MediaProfileResourceFactory.validatePrePostRoll(queryParams).$promise;
        }
        else if (!watermark) {
            return MediaProfileResourceFactory.validate(queryParams).$promise;
        }
    };
    self.validateClosedCaption = function (ccPath, prePostRollId, asset) {
        return MediaProfileResourceFactory.validateClosedCaption({ ccPath: ccPath, prePostRollId: prePostRollId }, asset).$promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components').service('MediaAcceptProfileService', function (_, $q, $route, $routeParams, $location, AcceptProfileResourceFactory, RepositoryRootsResourceFactory, PaginationService, MediaConversionTemplateService, MacCaptionTemplatesResourceFactory) {
    var self = this;
    self.originalAcceptProfile = {};
    self.mainForm = null;
    var handleGridDataQuery = function (gridData, responseHeaders) {
        PaginationService.parseResponseHeaders(responseHeaders());
        PaginationService.pageData = gridData;
        self.currentPageSize = gridData.length;
    };
    self.createNewProfile = function (acceptProfileType) {
        self.mapObject = {
            type: acceptProfileType
        };
        $location.url('/system/templates/media/acceptProfiles/edit/-1?editView=properties');
    };
    self.getAcceptProfiles = function (queryOpts) {
        return AcceptProfileResourceFactory.query(queryOpts, handleGridDataQuery).$promise;
    };
    self.getAcceptProfile = function (profileId) {
        return AcceptProfileResourceFactory.getAcceptProfile({ id: profileId }).$promise;
    };
    self.getValidators = function (profileId, includeHidden, criteria) {
        if (criteria === void 0) { criteria = null; }
        var getValidatorsPromise = AcceptProfileResourceFactory.getValidators({
            profileId: profileId,
            includeHidden: includeHidden
        }).$promise;
        if (criteria === null) {
            return getValidatorsPromise;
        }
        else {
            return getValidatorsPromise.then(function (validators) {
                return _.filter(validators, criteria);
            });
        }
    };
    self.updateValidators = function (profileId, validators) {
        return AcceptProfileResourceFactory.updateValidators({ profileId: profileId }, validators).$promise;
    };
    self.updateValidatorsFromMedia = function (profileId, virtualPath) {
        return AcceptProfileResourceFactory.updateValidatorsFromMedia({ profileId: profileId, mediaPath: virtualPath }).$promise;
    };
    self.updateValidatorsFromMediaInfo = function (profileId, mediaInfoXml) {
        return AcceptProfileResourceFactory.updateValidatorsFromMedia({ profileId: profileId }, mediaInfoXml).$promise;
    };
    self.toggleValidatorVisibility = function (id) {
        return AcceptProfileResourceFactory.toggleValidatorVisibility({ id: id }).$promise;
    };
    self.getMediaAcceptProfileEditViewData = function () {
        var repositoryRootsPromise = RepositoryRootsResourceFactory.query().$promise;
        var macCaptionTemplatesPromise = MacCaptionTemplatesResourceFactory.query().$promise;
        var acceptTemplatesPromise = AcceptProfileResourceFactory.query().$promise;
        var conversionTemplatesPromise = MediaConversionTemplateService.getAllMediaConversionTemplates();
        return $q.all({
            repositoryRoots: repositoryRootsPromise,
            mediaConversionTemplates: conversionTemplatesPromise,
            macCaptionTemplates: macCaptionTemplatesPromise,
            acceptTemplates: acceptTemplatesPromise,
        });
    };
    self.saveAcceptProfile = function (acceptProfile) {
        return AcceptProfileResourceFactory.save(acceptProfile).$promise;
    };
    self.hideAcceptProfile = function (acceptProfileId) {
        return AcceptProfileResourceFactory.hideAcceptProfile({ id: acceptProfileId }).$promise;
    };
    self.cloneAcceptProfile = function (acceptProfile) {
        return AcceptProfileResourceFactory.cloneAcceptProfile({ id: acceptProfile.id }).$promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jesse on 5/6/16.
 */
'use strict';
angular.module('prism-ui.components').service('PackagePropertiesQueryService', function ($q, ContentResourceFactory, NetworkResourceFactory, PackageResourceFactory) {
    var PackagePropertiesQueryService = this;
    var CONTENT_TYPES = ['Ad/PreRoll', 'Movie/Special', 'Series'];
    var retrievedContents = {};
    var retrievedContentsExtended = {}; // holds series with seasons volumes
    PackagePropertiesQueryService.getNetworks = function () {
        var defferred = $q.defer();
        NetworkResourceFactory.getNetworks({ fetchLimit: 500 }).$promise.then(function (networks) {
            defferred.resolve(networks);
        });
        return defferred.promise;
    };
    PackagePropertiesQueryService.getContentTypes = function () {
        var defferred = $q.defer();
        defferred.resolve(CONTENT_TYPES);
        return defferred.promise;
    };
    PackagePropertiesQueryService.getSeasonsVolumesForContents = function (contents) {
        var defferred = $q.defer();
        var retrivedContents = [];
        var promises = {};
        angular.forEach(contents, function (content) {
            var seasonsVolumes = retrievedContentsExtended[content.id];
            if (seasonsVolumes) {
                retrivedContents = retrivedContents.concat(seasonsVolumes);
            }
            else {
                promises[content.id] = ContentResourceFactory.get({ id: content.id }).$promise;
            }
        });
        $q.all(promises).then(function (data) {
            angular.forEach(data, function (content, contentID) {
                retrievedContentsExtended[contentID] = content;
                retrivedContents.push(content);
            });
            defferred.resolve(angular.copy(retrivedContents));
        });
        return defferred.promise;
    };
    PackagePropertiesQueryService.getContents = function (type) {
        var defferred = $q.defer();
        if (retrievedContents[type]) {
            defferred.resolve(retrievedContents[type]);
        }
        else {
            var params = { type: type, fetchLimit: 1000000 };
            ContentResourceFactory.query({}, params).$promise.then(function (contents) {
                retrievedContents[type] = contents;
                defferred.resolve(contents);
            });
        }
        return defferred.promise;
    };
    PackagePropertiesQueryService.getCategories = function () {
        return PackageResourceFactory.getCategories({}, { view: 'EXTENDED' }).$promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components').service('ReportViewService', function ($interval, $q, PartnerResourceFactory, WorkflowExecutionResourceFactory, NotificationService, WorkflowService, PermissionsService, EndPointService, AuthFactory) {
    var self = this, executionPollIntervals = {}, REPORT_WORKFLOW_KEY = 'generateReport';
    self.PARTNER_DELIVERY_REPORT_CLASS = 'BasicDeliveryReport';
    self.ADVANCED_PARTNER_DELIVERY_REPORT_CLASS = 'DeliveryReport';
    self.SLA_DELIVERY_REPORT_CLASS = 'SLADeliveryReport';
    self.DISTRIBUTION_REPORT_CLASS = 'BasicDistributionReport';
    self.ADVANCED_DISTRIBUTION_REPORT_CLASS = 'DistributionReport';
    self.PARTNER_PROFILES_REPORT_CLASS = 'VideoProfileReport';
    self.HIERARCHICAL_NETWORK_REPORT_CLASS = 'NetworkReport';
    self.HIERARCHICAL_SHOW_REPORT_CLASS = 'ShowReport';
    self.HIERARCHICAL_SEASON_VOLUME_REPORT_CLASS = 'SeasonVolumeReport';
    self.COLLABORATOR_REPORT_CLASS = 'CollaboratorReport';
    self.PACKAGE_BATCH_MODIFY_REPORT_CLASS = 'PackageMetadataBatchUpdateReport';
    self.PACKAGE_REPORT_CLASS = 'PackageReport';
    self.PACKAGE_ALL_METADATA_REPORT_CLASS = 'PackageMetadataReport';
    self.PACKAGE_MEDIA_REPORT_CLASS = 'PackageMediaReport';
    self.PARTNER_PLANNER_DELIVERY_REPORT_CLASS = 'PartnerPlannerReport';
    self.AUDIT_LEVEL_REPORT_CLASS = 'PartnerDeliveryReport';
    self.availableReports = [
        {
            label: 'Partner Delivery Report',
            showIncludePackagesOptions: true,
            generatorName: self.PARTNER_DELIVERY_REPORT_CLASS,
            advancedGeneratorName: self.ADVANCED_PARTNER_DELIVERY_REPORT_CLASS,
            viewState: 'DASHBOARD_REPORT_VIEW_STATE',
            path: '/dashboard/report/partnerdeliveryreport',
            reportClass: 'Package',
            modalTitle: 'Create Package Delivery Report',
            formTitle: 'Create a Basic or Advanced Package Delivery Report',
            includePartners: true
        },
        {
            label: 'SLA Delivery Metrics',
            showIncludePackagesOptions: true,
            generatorName: self.SLA_DELIVERY_REPORT_CLASS,
            viewState: 'DASHBOARD_REPORT_VIEW_STATE',
            path: '/dashboard/report/estdeliverymetrics',
            reportClass: 'PartnerPackageLog',
            modalTitle: 'Generate SLA Delivery Metrics',
            formTitle: 'Create an SLA Partner Delivery Metrics Report',
            includePartners: true
        },
        {
            label: 'Partner Delivery Report with Distribution Metadata',
            showIncludePackagesOptions: true,
            generatorName: self.AUDIT_LEVEL_REPORT_CLASS,
            viewState: 'DASHBOARD_REPORT_VIEW_STATE',
            path: '/dashboard/report/auditlevelreport',
            modalTitle: 'Create Partner Delivery Report with Distribution Metadata',
            formTitle: 'Create a Partner Delivery Report with Distribution Metadata',
            includePartners: true
        },
        {
            label: 'Distribution Report',
            generatorName: self.DISTRIBUTION_REPORT_CLASS,
            advancedGeneratorName: self.ADVANCED_DISTRIBUTION_REPORT_CLASS,
            viewState: 'DASHBOARD_REPORT_VIEW_STATE',
            path: '/dashboard/report/distributionreport',
            reportClass: 'Partner',
            modalTitle: 'Create Distribution Report',
            formTitle: 'Create a Package Distribution Report',
            includePartners: true
        },
        {
            label: 'Partner Profiles Report',
            generatorName: self.PARTNER_PROFILES_REPORT_CLASS,
            viewState: 'DASHBOARD_REPORT_VIEW_STATE',
            path: '/dashboard/report/partnerprofilesreport',
            reportClass: 'PartnerDeliveryProfile',
            modalTitle: 'Create Profiles Report',
            formTitle: 'Create a Partner Profiles Report',
            includePartners: true
        },
        {
            label: 'Partner Planners Delivery Report',
            generatorName: self.PARTNER_PLANNER_DELIVERY_REPORT_CLASS,
            viewState: 'DASHBOARD_REPORT_VIEW_STATE',
            path: '/dashboard/report/partnerplannerreport',
            reportClass: 'Partner',
            modalTitle: 'Create Partner Planner Delivery Report',
            formTitle: 'Create a Partner Planner Delivery Report',
            includePartners: true
        },
        {
            label: 'Hierarchical Metadata - Networks',
            generatorName: self.HIERARCHICAL_NETWORK_REPORT_CLASS,
            viewState: 'DASHBOARD_REPORT_VIEW_STATE',
            path: '/dashboard/report/networksmetadatareport',
            reportClass: 'AbstractShow',
            modalTitle: 'Create Networks Hierarchical Meta Report',
            formTitle: 'Create a Networks Hierarchical Metadata Report'
        },
        {
            label: 'Hierarchical Metadata - Series & Movie/Specials',
            generatorName: self.HIERARCHICAL_SHOW_REPORT_CLASS,
            viewState: 'DASHBOARD_REPORT_VIEW_STATE',
            path: '/dashboard/report/seriesmoviemetadatareport',
            reportClass: 'AbstractShow',
            modalTitle: 'Create Series/Movie Hierarchical Meta Report',
            formTitle: 'Create a Series/Movie Hierarchical Metadata Report'
        },
        {
            label: 'Hierarchical Metadata - Series Seasons & Volumes',
            generatorName: self.HIERARCHICAL_SEASON_VOLUME_REPORT_CLASS,
            viewState: 'DASHBOARD_REPORT_VIEW_STATE',
            path: '/dashboard/report/seasonvolumemetadatareport',
            reportClass: 'Series',
            modalTitle: 'Create Season/Volume Hierarchical Meta Report',
            formTitle: 'Create a Season/Volume Hierarchical Metadata Report'
        },
        {
            label: 'Collaborators Report',
            generatorName: self.COLLABORATOR_REPORT_CLASS,
            viewState: 'DASHBOARD_REPORT_VIEW_STATE',
            path: '/dashboard/report/collaboratorsreport',
            reportClass: 'Collaborator',
            modalTitle: 'Create Collaborators Report',
            formTitle: 'Create a Collaborators Report'
        }
    ];
    self.PACKAGE_BATCH_MODIFY_REPORT = {
        label: 'Package Metadata Report',
        generatorName: self.PACKAGE_BATCH_MODIFY_REPORT_CLASS,
        reportClass: 'Package',
        modalTitle: 'Batch Modify Warning'
    };
    self.PACKAGE_REPORT = {
        label: 'Package Report',
        showIncludePackagesOptions: true,
        generatorName: self.PACKAGE_REPORT_CLASS,
        reportClass: 'Package',
        modalTitle: 'Export Package Data',
        formTitle: 'Create a package report for the current packages'
    };
    self.PACKAGE_ALL_METADATA_REPORT = {
        label: 'Package Metadata Report',
        showIncludePackagesOptions: true,
        generatorName: self.PACKAGE_ALL_METADATA_REPORT_CLASS,
        reportClass: 'Package',
        modalTitle: 'Export Package Metadata',
        formTitle: 'Create a metadata report for the current packages'
    };
    self.CLIP_PACKAGE_ALL_METADATA_REPORT = {
        label: 'Package Metadata Report',
        generatorName: self.PACKAGE_ALL_METADATA_REPORT_CLASS,
        viewState: 'CLIP_ACTION_EXPORT_METADATA_VIEW_STATE',
        reportClass: 'Package',
        modalTitle: 'Export Package Metadata',
        formTitle: 'Create a metadata report for the current packages'
    };
    self.PACKAGE_MEDIA_REPORT = {
        label: 'Media Report',
        showIncludePackagesOptions: true,
        generatorName: self.PACKAGE_MEDIA_REPORT_CLASS,
        reportClass: 'Package',
        modalTitle: 'Create Package Media Report',
        formTitle: 'Create a Media Report'
    };
    self.CLIP_PACKAGE_DELIVERY_REPORT = {
        label: 'Partner Delivery Report',
        generatorName: self.PARTNER_DELIVERY_REPORT_CLASS,
        advancedGeneratorName: self.ADVANCED_PARTNER_DELIVERY_REPORT_CLASS,
        viewState: 'CLIP_ACTION_GENERATE_DELIVERY_REPORT_VIEW_STATE',
        path: '/dashboard/report/partnerdeliveryreport',
        reportClass: 'Package',
        modalTitle: 'Create Package Delivery Report',
        formTitle: 'Create a Basic or Advanced Package Delivery Report',
        includePartners: true
    };
    self.PACKAGE_AUDIT_LEVEL_REPORT = {
        label: 'Partner Delivery Report with Distribution Metadata',
        showIncludePackagesOptions: true,
        generatorName: self.AUDIT_LEVEL_REPORT_CLASS,
        viewState: 'DASHBOARD_REPORT_VIEW_STATE',
        path: '/dashboard/report/auditlevelreport',
        modalTitle: 'Create Partner Delivery Report with Distribution Metadata',
        formTitle: 'Create a Partner Delivery Report with Distribution Metadata',
        includePartners: true
    };
    var getReportCriteria = function (options) {
        var reportCriteria = {};
        if (options.reportStartDate) {
            reportCriteria.fromDate = options.reportStartDate;
        }
        if (options.reportEndDate) {
            reportCriteria.toDate = options.reportEndDate;
        }
        if (options.selectedPartners) {
            reportCriteria.targetObjectIds = options.selectedPartners.map(function (partner) {
                return parseInt(partner.id);
            });
        }
        else if (options.selectedPackages) {
            reportCriteria.targetObjectIds = options.selectedPackages.map(function (pkg) {
                return parseInt(pkg.id);
            });
            reportCriteria.targetObjectPath = 'package.id';
        }
        if (options.includeArchiveContent !== null) {
            reportCriteria.includeArchived = options.includeArchiveContent;
        }
        if (options.includeMasterPkgs !== null) {
            reportCriteria.includeMasterPackages = options.includeMasterPkgs;
        }
        if (options.includeClipToolPkgs !== null) {
            reportCriteria.includeClipPackages = options.includeClipToolPkgs;
        }
        if (options.filterCriteria) {
            reportCriteria.filterCriteria = options.filterCriteria;
        }
        return reportCriteria;
    };
    var generateWorkflowBody = function (selectedReport, options) {
        return {
            reportName: options.name,
            reportGeneratorName: (options.mode === 'Advanced') ? selectedReport.advancedGeneratorName : selectedReport.generatorName,
            reportClassName: selectedReport.reportClass,
            reportFormat: 'XLSX',
            runAsCurrentUser: false,
            reportCriteria: getReportCriteria(options)
        };
    };
    var cleanupExecutionPollInterval = function (workflowGuid) {
        $interval.cancel(executionPollIntervals[workflowGuid]);
        delete executionPollIntervals[workflowGuid];
    };
    var pollForWorkflowExecution = function (reportName, workflowGuid) {
        WorkflowExecutionResourceFactory.getWorkflowExecution({ id: workflowGuid }).$promise.then(function (workflowExecution) {
            if (parseInt(workflowExecution.percentComplete) === 100 && workflowExecution.isDownloadAvailable) {
                cleanupExecutionPollInterval(workflowGuid);
                NotificationService.createInfoNotification('Report Generation Complete:\n' + reportName, 'Download Report', function () {
                    window.open(EndPointService.workflowFilesEndpoint + '/' + workflowExecution.id +
                        '?attach=true&' + AuthFactory.getAuthQueryString());
                });
            }
            else if (WorkflowService.hasWorkflowFailed(workflowExecution.status)) {
                cleanupExecutionPollInterval(workflowGuid);
                WorkflowExecutionResourceFactory.getExecutionSteps({ id: workflowGuid }).$promise.then(function (steps) {
                    var errorText = steps[steps.length - 1].exceptionText;
                    NotificationService.createFailureNotification('Report Generation encountered an Error.', errorText, true);
                });
            }
            else if (WorkflowService.hasWorkflowBeenAbandoned(workflowExecution.status)) {
                cleanupExecutionPollInterval(workflowGuid);
                NotificationService.createWarningNotification('Report Generation Abandoned:' + reportName);
            }
        });
    };
    self.getReportForPath = function (path) {
        return self.availableReports.filter(function (report) {
            return report.path === path;
        })[0];
    };
    self.queryForPartners = function (includeHidden) {
        self.partners = PartnerResourceFactory.query({ fetchLimit: 1000, includeHidden: includeHidden });
        return self.partners.$promise;
    };
    self.startReportWorkflow = function (selectedReport, options) {
        var workflowParameters = generateWorkflowBody(selectedReport, options);
        return WorkflowService.startWorkflow(REPORT_WORKFLOW_KEY, workflowParameters)
            .then(function (workflowExecution) {
            NotificationService.createInfoNotification('Generating Report:\n' +
                workflowParameters.reportName +
                '\nYou will receive an email when this report is complete');
            executionPollIntervals[workflowExecution.workflowGuid] = $interval(pollForWorkflowExecution, 3000, 0, true, workflowParameters.reportName, workflowExecution.workflowGuid);
        });
    };
    self.doesUserHaveWritePermission = function (selectedReport) {
        return PermissionsService.getPermissionsForViewState(selectedReport.viewState).then(function (viewState) {
            return $q.when(PermissionsService.hasWritePermission(viewState.permission));
        });
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components').service('SearchFilterService', function ($location, $q, moment, UsersResourceFactory, EnumService) {
    var self = this;
    var CONTENT_TYPES = ['Ad/PreRoll', 'Movie/Special', 'Series'];
    var normalizeCriteriaBody = function (param) {
        if (typeof param === 'string') {
            return [param];
        }
        else if (!param) {
            return null;
        }
        return param;
    };
    self.defaultWorkflowCriteria = {
        dateProperty: '',
        contentType: null,
        fromDate: null,
        toDate: null,
        recentDays: 14,
        status: ['EXECUTING', 'FAILED', 'PAUSED', 'QUEUED', 'STALLED', 'WAITING', 'CREATED'],
        submitters: null
    };
    self.defaultPackageCriteria = {
        dateProperty: null,
        keywords: null,
        fromDate: null,
        toDate: null,
        packageProperties: ['episodeTitle', 'id', 'name']
    };
    self.defaultBaseCriteria = {
        dateProperty: $location.path().indexOf('system/partners') < 0 ? 'lastXDays' : null,
        contentType: null,
        keywords: null,
        fromDate: null,
        toDate: null,
        recentDays: 7
    };
    self.workflowSearchCriteria = angular.copy(self.defaultWorkflowCriteria);
    self.searchCriteria = angular.copy(self.defaultPackageCriteria);
    self.baseCriteria = angular.copy(self.defaultBaseCriteria);
    var isSearchingForPackages = function () {
        return $location.path().indexOf('/package') > -1;
    };
    var isSearchingForWorkflows = function () {
        // Regex: Last part of url == 'workflows' (with optional '/')
        //        followed by query parameters '?' or anchor '#'
        return $location.path().match('dashboard/workflows/?([?#]|$)');
    };
    self.getCurrentSearchCriteria = function () {
        if (isSearchingForWorkflows()) {
            return self.workflowSearchCriteria;
        }
        else if (isSearchingForPackages()) {
            return self.searchCriteria;
        }
        else {
            return self.baseCriteria;
        }
    };
    self.updateLocationSearch = function () {
        //
        // I believe this is needed because `searchText` and
        // `keywords` have been interchanged and conflated.
        //
        var packageSearchText = $location.search().searchText;
        $location.search('searchText', self.getCurrentSearchCriteria().keywords);
        $location.search('dateType', self.getCurrentSearchCriteria().dateProperty);
        $location.search('startDate', (self.getCurrentSearchCriteria().fromDate) ? moment(self.getCurrentSearchCriteria().fromDate).format('MM-DD-YYYY') : null);
        $location.search('endDate', (self.getCurrentSearchCriteria().toDate) ? moment(self.getCurrentSearchCriteria().toDate).format('MM-DD-YYYY') : null);
        $location.search('contentType', self.getCurrentSearchCriteria().contentType);
        $location.search('network', self.getCurrentSearchCriteria().network);
        $location.search('categoryType', self.getCurrentSearchCriteria().categoryType);
        $location.search('category', self.getCurrentSearchCriteria().category);
        $location.search('content', self.getCurrentSearchCriteria().content);
        $location.search('season', self.getCurrentSearchCriteria().season);
        $location.search('volume', self.getCurrentSearchCriteria().volume);
        $location.search('delivered', self.getCurrentSearchCriteria().delivered);
        $location.search('deliveredToPartners', self.getCurrentSearchCriteria().deliveredToPartners);
        if (isSearchingForWorkflows()) {
            $location.search('recentDays', self.getCurrentSearchCriteria().recentDays);
            $location.search('submitters', self.getCurrentSearchCriteria().submitters);
            $location.search('status', self.getCurrentSearchCriteria().status);
            $location.search('packageProperties', null);
            $location.search('partnerProperties', null);
        }
        else if (isSearchingForPackages()) {
            if (packageSearchText) {
                $location.search('searchText', packageSearchText);
            }
            $location.search('packageProperties', self.getCurrentSearchCriteria().packageProperties);
            $location.search('partnerProperties', self.getCurrentSearchCriteria().partnerProperties);
            $location.search('externalSystem', self.getCurrentSearchCriteria().externalSystem);
            $location.search('recentDays', null);
            $location.search('submitters', null);
            $location.search('status', null);
        }
    };
    self.populateCriteriaFromLocationSearch = function () {
        var searchParams = $location.search();
        self.getCurrentSearchCriteria().keywords = searchParams.searchText;
        self.getCurrentSearchCriteria().dateProperty = searchParams.dateType;
        self.getCurrentSearchCriteria().fromDate = (searchParams.startDate) ? new Date(searchParams.startDate) : null;
        self.getCurrentSearchCriteria().toDate = (searchParams.endDate) ? new Date(searchParams.endDate) : null;
        self.getCurrentSearchCriteria().contentType = searchParams.contentType || null;
        self.getCurrentSearchCriteria().categoryType = normalizeCriteriaBody(searchParams.categoryType);
        self.getCurrentSearchCriteria().category = normalizeCriteriaBody(searchParams.category);
        self.getCurrentSearchCriteria().network = normalizeCriteriaBody(searchParams.network);
        self.getCurrentSearchCriteria().content = normalizeCriteriaBody(searchParams.content);
        self.getCurrentSearchCriteria().season = normalizeCriteriaBody(searchParams.season);
        self.getCurrentSearchCriteria().volume = normalizeCriteriaBody(searchParams.volume);
        self.getCurrentSearchCriteria().delivered = searchParams.delivered;
        self.getCurrentSearchCriteria().deliveredToPartners = normalizeCriteriaBody(searchParams.deliveredToPartners);
        if (isSearchingForWorkflows()) {
            self.getCurrentSearchCriteria().recentDays = searchParams.recentDays;
            self.getCurrentSearchCriteria().submitters = normalizeCriteriaBody(searchParams.submitters);
            self.getCurrentSearchCriteria().status = normalizeCriteriaBody(searchParams.status);
        }
        else if (isSearchingForPackages()) {
            self.getCurrentSearchCriteria().packageProperties = normalizeCriteriaBody(searchParams.packageProperties);
            self.getCurrentSearchCriteria().partnerProperties = normalizeCriteriaBody(searchParams.partnerProperties);
            self.getCurrentSearchCriteria().externalSystem = normalizeCriteriaBody(searchParams.externalSystem);
        }
    };
    self.setSearchCriteriaForQueryOpts = function () {
        var theQueryOpts = {};
        if (self.workflowSearchCriteria.dateProperty === 'startDate') {
            theQueryOpts.dateProperty = self.workflowSearchCriteria.dateProperty;
            if (self.workflowSearchCriteria.fromDate) {
                self.workflowSearchCriteria.fromDate.setHours(0);
                theQueryOpts.fromDate = self.workflowSearchCriteria.fromDate.toString();
            }
            if (self.workflowSearchCriteria.toDate) {
                self.workflowSearchCriteria.toDate.setHours(23);
                theQueryOpts.toDate = self.workflowSearchCriteria.toDate.toString();
            }
        }
        if (self.workflowSearchCriteria.dateProperty === 'lastXDays') {
            var xDays = new Date();
            xDays.setDate(xDays.getDate() - self.workflowSearchCriteria.recentDays);
            theQueryOpts.dateProperty = 'dateCreated';
            theQueryOpts.fromDate = xDays.toString();
            theQueryOpts.toDate = new Date().toString();
        }
        if (self.workflowSearchCriteria.submitters) {
            theQueryOpts.submittedByUserId = self.workflowSearchCriteria.submitters;
        }
        if (self.workflowSearchCriteria.status) {
            theQueryOpts.status = self.workflowSearchCriteria.status;
        }
        if (self.workflowSearchCriteria.submitters) {
            theQueryOpts.submittedByUserId = self.workflowSearchCriteria.submitters;
        }
        theQueryOpts.searchString = self.workflowSearchCriteria.keywords;
        theQueryOpts.categoryType = self.workflowSearchCriteria.categoryType;
        theQueryOpts.category = self.workflowSearchCriteria.category;
        theQueryOpts.network = self.workflowSearchCriteria.network;
        theQueryOpts.contentName = self.workflowSearchCriteria.content;
        return theQueryOpts;
    };
    self.resetCriteriaToDefault = function () {
        if (isSearchingForWorkflows()) {
            self.workflowSearchCriteria = angular.copy(self.defaultWorkflowCriteria);
        }
        else if (isSearchingForPackages()) {
            self.searchCriteria = angular.copy(self.defaultPackageCriteria);
        }
        else {
            self.baseCriteria = angular.copy(self.defaultBaseCriteria);
        }
        self.updateLocationSearch();
    };
    self.isSearchFilterApplied = function () {
        if (isSearchingForWorkflows()) {
            return self.workflowSearchCriteria.dateProperty || self.workflowSearchCriteria.submitters || self.workflowSearchCriteria.contentType ||
                self.workflowSearchCriteria.fromDate || self.workflowSearchCriteria.toDate || self.workflowSearchCriteria.status;
        }
        else {
            return self.getCurrentSearchCriteria().keywords ||
                self.getCurrentSearchCriteria().dateProperty ||
                self.getCurrentSearchCriteria().contentType ||
                self.getCurrentSearchCriteria().delivered;
        }
    };
    self.extractQueryProp = function (collection, modelProp) {
        var returnVal = [];
        angular.forEach(collection, function (item) {
            returnVal.push(item[modelProp]);
        });
        return returnVal;
    };
    self.getObjectsFromPathProp = function (collection, objectProp, pathParam) {
        var objects = [];
        var pathValue = $location.search()[pathParam];
        if (typeof pathValue === 'string') {
            pathValue = [pathValue];
        }
        angular.forEach(pathValue, function (entry) {
            for (var i = 0; i < collection.length; i++) {
                var collectionObj = collection[i];
                if (collectionObj[objectProp] === entry) {
                    objects.push(collectionObj);
                    break;
                }
            }
        });
        return objects;
    };
    self.getSubmitters = function () {
        return UsersResourceFactory.query({ fetchLimit: 10000 }).$promise;
    };
    self.getContentTypes = function () {
        var defferred = $q.defer();
        defferred.resolve(CONTENT_TYPES);
        return defferred.promise;
    };
    self.getWorkflowStatuses = function () {
        var defferred = $q.defer();
        EnumService.queryForEnums().then(function () {
            defferred.resolve(EnumService.getEnumPicklist('WorkflowExecution_status'));
        });
        return defferred.promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: subscriptions-service.js
 *
 * Created by randysorensen on 5/24/17.
 */
'use strict';
angular
    .module('prism-ui.content')
    .service('SubscriptionsService', function (_, $q, $location, $routeParams, AcceptProfileResourceFactory, BreakPrePostRollResourceFactory, ContentResourceFactory, IntermediateTemplatesResourceFactory, LanguagesService, NetworkResourceFactory, PackageResourceFactory, PaginationService, PartnerResourceFactory, SubscriptionsResourceFactory) {
    var self = this;
    self.contentObject = null;
    self.contentCategoryObject = null;
    var defaultQueryOptions = {
        fetchOffset: 0,
        fetchLimit: 25,
        searchString: '',
        keywords: '',
        includeEnabled: true,
        includeDisabled: false,
    };
    self.queryOptions = _.cloneDeep(defaultQueryOptions);
    self.resetQueryOptions = function () {
        self.queryOptions = _.cloneDeep(defaultQueryOptions);
    };
    var convertPropertyToString = function (newQueryOpts, parameterName) {
        var paramValue = _.get(newQueryOpts, parameterName);
        if (_.isArray(paramValue)) {
            paramValue = _.join(paramValue, '');
        }
        if (_.isString(paramValue) && _.size(paramValue) >= 1) {
            newQueryOpts[parameterName] = paramValue;
        }
        else {
            delete newQueryOpts[parameterName];
        }
    };
    var createSearchSubQueryOptions = function () {
        var newQueryOpts = angular.copy(self.queryOptions);
        var locationObj = $location.search();
        for (var queryOpt in locationObj) {
            if (locationObj.hasOwnProperty(queryOpt)) {
                if (!Array.isArray(locationObj[queryOpt]) && queryOpt !== 'contentType') {
                    locationObj[queryOpt] = JSON.parse('[' + '"' + locationObj[queryOpt] + '"' + ']');
                }
                newQueryOpts[queryOpt] = locationObj[queryOpt];
            }
        }
        //
        // TODO: ABC-11697 - https://levelsbeyond.atlassian.net/browse/ABC-11697
        //       Figure out why this case occurs, and fix it at the source.
        //           Once fixed, remove the convertPropertyToString() function also.
        //       Explanation:
        //           The server expects searchString & keywords to be strings.
        //           However, the parameters sometimes change into an array.
        //
        convertPropertyToString(newQueryOpts, 'searchString');
        convertPropertyToString(newQueryOpts, 'keywords');
        self.queryOptions = newQueryOpts;
        self.queryOptions.includeEnabled = !!self.queryOptions.includeEnabled;
        self.queryOptions.includeDisabled = !!self.queryOptions.includeDisabled;
    };
    var deleteSubQueryOptions = function () {
        var newQueryOpts = angular.copy(self.queryOptions);
        var locationObj = $location.search();
        for (var queryOpt in locationObj) {
            if (locationObj.hasOwnProperty(queryOpt) && !defaultQueryOptions.hasOwnProperty(queryOpt)) {
                delete newQueryOpts[queryOpt];
            }
        }
        self.queryOptions = newQueryOpts;
    };
    self.getPartnerCustomMetadataProperties = function (partnerId) {
        var partnerCustomMetadataProperties = {};
        // create a map of the properties with the property names
        // as map keys
        return PartnerResourceFactory
            .getMetadataProperties({ id: partnerId })
            .$promise
            .then(function (metaPropsArray) {
            partnerCustomMetadataProperties = _.keyBy(metaPropsArray, 'name');
            return partnerCustomMetadataProperties;
        });
    };
    self.getContentCategorySubscriptionData = function (contentId, categoryId) {
        var contentPromise = ContentResourceFactory.get({ id: contentId }).$promise;
        var contentCategoryPromise = ContentResourceFactory.getContentCategories({
            id: contentId,
            categoryId: categoryId
        }).$promise;
        return $q.all({
            content: contentPromise,
            contentCategory: contentCategoryPromise
        })
            .then(function (subscriptionData) {
            return {
                content: subscriptionData.content,
                contentCategory: subscriptionData.contentCategory['0']
            };
        });
    };
    self.getContentCategorySubscriptions = function (contentId, contentCategoryId) {
        //
        // we need these two objects:
        //
        //	content
        // 		- for the breadcrumb
        //
        //	contentCategory
        // 		- for the breadcrumb
        //		- for the "category ID" (NOT the "content category
        //		  ID", that's its own thing)
        //
        var contentPromise = ContentResourceFactory
            .get({ id: contentId })
            .$promise;
        var contentCategoryPromise = ContentResourceFactory
            .getContentCategory({ contentCategoryId: contentCategoryId })
            .$promise;
        return $q.all({
            content: contentPromise,
            contentCategory: contentCategoryPromise
        }).then(function (data) {
            self.contentObject = data.content;
            self.contentCategoryObject = data.contentCategory;
            createSearchSubQueryOptions();
            return SubscriptionsResourceFactory.getSubscriptionsByContentCategoryFiltered({
                contentId: data.content.id,
                categoryId: data.contentCategory.category.id
            }, self.queryOptions, function (subs, headersCB) {
                PaginationService.parseResponseHeaders(headersCB());
                return subs;
            }).$promise;
        });
    };
    self.getPartnerSubscriptions = function (partnerId) {
        if ($location.search().hasOwnProperty('contentType')) {
            createSearchSubQueryOptions();
        }
        else {
            deleteSubQueryOptions();
            delete self.queryOptions.contentType;
        }
        return SubscriptionsResourceFactory
            .getSubscriptionsFiltered({
            partnerId: partnerId
        }, self.queryOptions, function (subs, headersCB) {
            PaginationService.parseResponseHeaders(headersCB());
            return subs;
        }).$promise;
    };
    self.createSubscription = function (subscription) {
        return SubscriptionsResourceFactory.createSubscription({
            partnerId: subscription.partner.id,
        }, subscription).$promise;
    };
    self.updateSubscription = function (subscription) {
        return SubscriptionsResourceFactory.saveSubscription({
            partnerId: subscription.partner.id,
            subId: subscription.id,
        }, subscription).$promise;
    };
    self.updateSubscriptions = function (subscriptions) {
        return SubscriptionsResourceFactory.saveSubscriptions({}, subscriptions).$promise;
    };
    self.getPartnerSubscriptionFilterData = function (type) {
        var contentPromise = ContentResourceFactory.query({ type: type, fetchLimit: -1 }).$promise;
        var categoryTypesPromise = PackageResourceFactory.getCategories().$promise;
        var categoriesPromise = PackageResourceFactory.getCategories({ view: 'EXTENDED' }).$promise;
        var networksPromise = NetworkResourceFactory.getNetworks({ fetchLimit: -1 }).$promise;
        return $q.all({
            contentList: contentPromise,
            categoryTypes: categoryTypesPromise,
            categories: categoriesPromise,
            networks: networksPromise
        });
    };
    self.getNetworkBreakPrePostRolls = function (network) {
        if (network) {
            return NetworkResourceFactory.getBranding({ id: network.id, view: 'breakPrePostRolls' }).$promise;
        }
        else {
            return [];
        }
    };
    self.getContentBreakPrePostRolls = function (content) {
        if (content) {
            return ContentResourceFactory.getBranding({ id: content.id, view: 'breakPrePostRolls' }).$promise;
        }
        else {
            return [];
        }
    };
    self.getSeasonsVolumesForContents = function (content) {
        var contentPromise = ContentResourceFactory.get({ id: content.id }).$promise;
        return $q.all({
            content: contentPromise
        });
    };
    var isHomogeneousNetwork = function (contents) {
        // Iterate an array of content DTOs and return true if
        // they all share the same network.
        var networkIds = _.map(contents, 'network.id');
        var uniqueNetworkIds = _.uniq(networkIds);
        return uniqueNetworkIds.length === 1;
    };
    var getNetworkId = function (subscriptions) {
        // Grab all unique content IDs
        var contents = _.uniqBy(subscriptions, function (sub) {
            return sub.content.id;
        });
        var contentIds = _.map(contents, 'content.id');
        // Grab content DTOs for each unique ID
        var contentPromises = [];
        _.forEach(contentIds, function (contentId) {
            contentPromises.push(ContentResourceFactory.get({ id: contentId, view: 'EXTENDED' }).$promise);
        });
        // Return promise that resolves with the network ID
        // shared by each content, or undefined if they do not
        // share the same network
        var networkIdPromise = $q.defer();
        $q.all(contentPromises).then(function (contents) {
            if (isHomogeneousNetwork(contents)) {
                networkIdPromise.resolve(contents[0].network.id);
            }
            else {
                networkIdPromise.resolve(undefined);
            }
        });
        return networkIdPromise;
    };
    var getNetworkBrandingData = function (contentPromise, subscriptions) {
        var networkPromise = $q.defer();
        contentPromise.then(function (content) {
            var networkIdPromise;
            // If the content promise is resolved with undefined,
            // it means there's more than one content among the
            // selected subscriptions. In this case, we need to
            // find whether these different contents belong to a
            // single network or not.
            if (content) {
                networkIdPromise = $q.defer();
                networkIdPromise.resolve(content.network.id);
            }
            else {
                networkIdPromise = getNetworkId(subscriptions);
            }
            // If the network ID promise is resolved with
            // undefined, it means all selected subscriptions
            // belong to a single network, and we can obtain its
            // branding data.
            networkIdPromise.promise.then(function (networkId) {
                if (networkId) {
                    NetworkResourceFactory.get({ id: networkId, view: 'EXTENDED' }).$promise.then(function (network) {
                        networkPromise.resolve(network);
                    });
                }
                else {
                    networkPromise.resolve(undefined);
                }
            });
        });
        return networkPromise.promise;
    };
    self.getCollectionData = function (batchUpdate, isPartner, partner, content, category, subscriptions) {
        var promises = {};
        if (!batchUpdate || isPartner) {
            promises.partnerMetadata = self.getPartnerCustomMetadataProperties(partner.id);
            promises.partner = PartnerResourceFactory.get({ id: partner.id, view: 'EXTENDED' }).$promise;
        }
        if (content) {
            promises.content = ContentResourceFactory.get({ id: content.id, view: 'EXTENDED' }).$promise;
            if (category) {
                promises.contentCategory = self.getContentCategorySubscriptionData(content.id, category.id);
            }
        }
        else {
            var contentPromise = $q.defer();
            promises.content = contentPromise.promise;
            contentPromise.resolve(undefined);
        }
        promises.network = getNetworkBrandingData(promises.content, subscriptions);
        promises.intermediateTemplateData = IntermediateTemplatesResourceFactory.query({}).$promise;
        promises.artworkAcceptProfiles = AcceptProfileResourceFactory.query({ profileType: 'OTHER' }).$promise;
        promises.languages = LanguagesService.getAllLanguages().then(function (allAvailableLanguages) {
            return _
                .chain(allAvailableLanguages)
                .orderBy('name')
                .partition({ name: 'English' })
                .flatten()
                .value();
        });
        return $q.all(promises).then(function (data) {
            return $q.all({
                networkBreakPrePostRolls: self.getNetworkBreakPrePostRolls(data.network),
                contentBreakPrePostRolls: content && content.type === 'Ad/PreRoll' ? null : self.getContentBreakPrePostRolls(content)
            })
                .then(function (networkContentData) {
                if (data.network) {
                    data.network.breakPrePostRolls = networkContentData.networkBreakPrePostRolls;
                }
                if (data.content) {
                    data.content.breakPrePostRolls = networkContentData.contentBreakPrePostRolls;
                }
                return data;
            });
        });
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.queues').service('QueuesViewService', function (_, $q, DashboardResourceFactory, ModalService, PaginationService, PermissionsService, QueuesResourceFactory, PartnerResourceFactory, PackageResourceFactory) {
    var self = this;
    var colorMap = {
        'Aspera': '#c647f4', 'FTP': '#f7a261', 'Network': '#8ae3c0', 'upLynk': '#7cb7ea', 'Stalled': '#bd000b',
        'SFTP': '#bababe', 'iTunes': '#7f89e6', 'Amazon S3': '#eee779', 'Executing': '#2ec92d', 'Queued': '#f68f41',
        'Pending Restore': '#f7a261', 'Pending Delivery': '#bababe', 'Stalls': '#bd000b', 'Pending Approval': '#7f89e6',
        'Paused': '#eee779', 'Waiting': '#c647f4', 'Completed': '#9933ff'
    };
    var errorStates = { 'Stalled': true };
    var ignoreForGraphStates = { 'Completed': true };
    var ignoreForPanelStates = { 'Waiting': true };
    var statusToLabel = function (status) {
        switch (status) {
            case 'Completed':
                return 'Finished';
            default:
                return status;
        }
    };
    var hasBandwidthWarningFlag = function (deliveryReportQueues, queueName) {
        for (var i = 0; i < deliveryReportQueues.length; i++) {
            if (queueName === deliveryReportQueues[i].name) {
                return deliveryReportQueues[i].bandwidthWarningFlag;
            }
        }
        return false;
    };
    self.getQueueViewPermissions = function (viewState) {
        var previewPromise = PermissionsService.canRead(viewState);
        return $q.all({ preview: previewPromise });
    };
    self.queueId = null;
    self.showFinishedDataInGraph = false;
    self.parseDashboardData = function (dashboardData, parseAsFloat, bandwidth, bandwidthReport) {
        var parsedDashboardData = {
            header: dashboardData.header,
            subHeader: dashboardData.subHeader,
            total: (parseAsFloat) ? parseFloat(dashboardData.total).toFixed(2) : parseInt(dashboardData.total),
            unit: dashboardData.unit,
            data: [],
            series: [],
            hasError: false,
            hasWarning: false
        };
        var includeSubSeries = 'subSeries' in dashboardData;
        var hideCompletedForPills = false;
        if (dashboardData.lastStallDate) {
            parsedDashboardData.lastStallDate = dashboardData.lastStallDate;
        }
        for (var dataKey in dashboardData.data) {
            if (!ignoreForPanelStates[dataKey]) {
                var dataPoint = { field: dataKey, value: dashboardData.data[dataKey] };
                var dataValueString = (parseAsFloat) ? parseFloat(dataPoint.value).toFixed(2) : parseInt(dataPoint.value);
                var legendName = statusToLabel(dataKey) + ((dataPoint.value) ? ' (' + dataValueString + ')' : '');
                var seriesEntry = { field: dataKey, name: legendName, color: colorMap[dataKey] };
                if (errorStates[dataPoint.field] && parseInt(dataPoint.value) > 0) {
                    parsedDashboardData.hasError = true;
                }
                if (ignoreForGraphStates[dataPoint.field] && !self.showFinishedDataInGraph) {
                    seriesEntry.ignoreForGraph = hideCompletedForPills = true;
                    parsedDashboardData.total -= dataPoint.value;
                }
                parsedDashboardData.data.push(dataPoint);
                parsedDashboardData.series.push(seriesEntry);
            }
        }
        if (includeSubSeries) {
            parsedDashboardData.subSeries = [];
            for (var i = 0; i < dashboardData.subSeries.length; i++) {
                var queueData = dashboardData.subSeries[i];
                var totalBandwidth = 0;
                if (bandwidthReport && bandwidthReport.totalBandwidth > 0) {
                    for (var k = 0; k < bandwidthReport.deliveryQueues.length; k++) {
                        if (queueData.id === bandwidthReport.deliveryQueues[k].id) {
                            totalBandwidth = _.round(parseInt(bandwidthReport.deliveryQueues[k].bandwidth) / 1000000, 3);
                        }
                    }
                }
                var parsedSubSeriesDashboardData = {
                    header: queueData.header,
                    id: queueData.id,
                    total: parseInt(queueData.total),
                    totalBandwidth: totalBandwidth,
                    unit: (bandwidth) ? bandwidth.unit : ' Mbps',
                    bandwidthWarningFlag: (dashboardData.bandwidthReport) ? hasBandwidthWarningFlag(dashboardData.bandwidthReport.deliveryQueues, queueData.header) : false,
                    showFinished: self.showFinishedDataInGraph,
                    data: [],
                    hasError: false,
                    hasWarning: false
                };
                for (var seriesDataKey in queueData.data) {
                    if (!ignoreForPanelStates[seriesDataKey]) {
                        var statusValue = parseInt(queueData.data[seriesDataKey]);
                        var subSeriesDataPoint = {
                            field: seriesDataKey,
                            value: (statusValue > 0) ? statusValue : 0,
                            color: colorMap[seriesDataKey]
                        };
                        if (errorStates[subSeriesDataPoint.field] && parseInt(subSeriesDataPoint.value) > 0) {
                            subSeriesDataPoint.hasError = true;
                        }
                        if (ignoreForGraphStates[subSeriesDataPoint.field] && !self.showFinishedDataInGraph) {
                            subSeriesDataPoint.total -= subSeriesDataPoint.value;
                        }
                        else {
                            parsedSubSeriesDashboardData.data.push(subSeriesDataPoint);
                        }
                    }
                }
                parsedDashboardData.subSeries.push(parsedSubSeriesDashboardData);
            }
        }
        return parsedDashboardData;
    };
    self.saveQueueLimiters = function (queueObj) {
        QueuesResourceFactory.updateQueue({ id: queueObj.id }, queueObj);
    };
    self.deleteQueueLimiter = function (limiterObj) {
        return QueuesResourceFactory.deleteQueueLimiter({ id: limiterObj.id }).$promise;
    };
    self.saveQueueLimiter = function (limiterObj) {
        return QueuesResourceFactory.createNewQueueLimiter({ id: self.selectedQueueId }, limiterObj).$promise;
    };
    self.getQueuesListData = function (queueId) {
        self.selectedQueueId = queueId;
        var queue = QueuesResourceFactory.get({ id: queueId }).$promise;
        var queueLimiters = QueuesResourceFactory.getAllQueueLimiters({ id: queueId }).$promise;
        return $q.all({ queueData: queue, queueLimiters: queueLimiters }).then(function (data) {
            return data;
        });
    };
    self.getLimiterEditData = function (limiterId) {
        var promises = {
            partners: PartnerResourceFactory.query({ fetchLimit: -1 }).$promise,
            categoryTypes: PackageResourceFactory.getCategories().$promise
        };
        if (limiterId > -1) {
            promises.limiter = QueuesResourceFactory.getSingleQueueLimiter({ id: limiterId }).$promise;
        }
        return $q.all(promises);
    };
    self.getTranscodesPanelData = function (includeSubSeries) {
        return DashboardResourceFactory.getTranscodeSteps({
            'showCompleted': self.showFinishedDataInGraph,
            'includeSubSeries': includeSubSeries
        }).$promise.then(function (dashboardData) {
            return self.parseDashboardData(dashboardData);
        });
    };
    self.getDeliveriesPanelData = function (includeSubSeries) {
        var steps = DashboardResourceFactory.getDeliverySteps({
            'showCompleted': self.showFinishedDataInGraph,
            'includeSubSeries': includeSubSeries
        }).$promise;
        var bandwidth = DashboardResourceFactory.getDeliveryBandwidth().$promise;
        var bandwidthReport = DashboardResourceFactory.getDeliveryBandwidthReport().$promise;
        return $q.all({
            steps: steps,
            bandwidth: bandwidth,
            bandwidthReport: bandwidthReport
        }).then(function (dashboardData) {
            var parsedData = self.parseDashboardData(dashboardData.steps, false, dashboardData.bandWidth, dashboardData.bandwidthReport);
            parsedData.subHeader = 'TOTAL BANDWIDTH: ' + dashboardData.bandwidth.total + ' ' + dashboardData.bandwidth.unit;
            return parsedData;
        });
    };
    self.getRestoresPanelData = function (includeSubSeries) {
        return DashboardResourceFactory.getRestoreSteps({
            'showCompleted': self.showFinishedDataInGraph,
            'includeSubSeries': includeSubSeries
        }).$promise.then(function (dashboardData) {
            return self.parseDashboardData(dashboardData);
        });
    };
    self.getFileCopyPanelData = function (includeSubSeries) {
        return DashboardResourceFactory.getFileCopySteps({
            'showCompleted': self.showFinishedDataInGraph,
            'includeSubSeries': includeSubSeries
        }).$promise.then(function (dashboardData) {
            return self.parseDashboardData(dashboardData);
        });
    };
    self.getQueueStepData = function (queryOpts) {
        var queueDataPromise = QueuesResourceFactory.get({ id: queryOpts.id }).$promise;
        var stepDataPromise = QueuesResourceFactory.getQueueSteps(queryOpts, function (data, headers) {
            PaginationService.parseResponseHeaders(headers());
        }).$promise;
        return $q.all({ queueData: queueDataPromise, stepData: stepDataPromise });
    };
    self.saveQueueStep = function (queue) {
        return QueuesResourceFactory.updateQueueStepPriority({ id: queue.stepId, priority: queue.priority }).$promise;
    };
    self.loadSummaryData = function () {
        var dataPromises = {};
        dataPromises.transcodes = self.getTranscodesPanelData();
        dataPromises.deliveries = self.getDeliveriesPanelData();
        dataPromises.restores = self.getRestoresPanelData();
        dataPromises.fileCopy = self.getFileCopyPanelData();
        return $q.all(dataPromises);
    };
    self.loadGroupSummaryData = function (groupName) {
        switch (groupName) {
            case 'transcodes':
                return $q.when(self.getTranscodesPanelData(true));
            case 'deliveries':
                return $q.when(self.getDeliveriesPanelData(true));
            case 'restores':
                return $q.when(self.getRestoresPanelData(true));
            case 'fileCopy':
                return $q.when(self.getFileCopyPanelData(true));
        }
    };
    self.clearQueue = function (queueId) {
        return QueuesResourceFactory.clearQueue({ id: queueId }).$promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
function ReportViewController(_, $location, ReportViewService, ModalService) {
    var self = this;
    function handleCreateReportModalResult(reportOptions) {
        reportOptions.reportStartDate = self.reportStartDate;
        reportOptions.reportEndDate = self.reportEndDate;
        if (self.selectedPartners) {
            reportOptions.selectedPartners = (_.isArray(self.selectedPartners)) ?
                self.selectedPartners : _.concat(self.selectedPartners);
        }
        ReportViewService.startReportWorkflow(self.selectedReport, reportOptions);
    }
    self.includeHiddenPartners = false;
    self.availableReports = ReportViewService.availableReports;
    self.selectedReport = ReportViewService.getReportForPath($location.path());
    self.enableSubmit = false;
    self.updatePartnerList = function () {
        ReportViewService.queryForPartners(self.includeHiddenPartners).then(function (partners) {
            self.partners = partners;
        });
    };
    self.showReportForm = function () {
        return self.selectedReport.generatorName === ReportViewService.PARTNER_DELIVERY_REPORT_CLASS ||
            self.selectedReport.generatorName === ReportViewService.SLA_DELIVERY_REPORT_CLASS ||
            self.selectedReport.generatorName === ReportViewService.DISTRIBUTION_REPORT_CLASS ||
            self.selectedReport.generatorName === ReportViewService.PARTNER_PROFILES_REPORT_CLASS ||
            self.selectedReport.generatorName === ReportViewService.PARTNER_PLANNER_DELIVERY_REPORT_CLASS ||
            self.selectedReport.generatorName === ReportViewService.AUDIT_LEVEL_REPORT_CLASS;
    };
    self.onSubmit = function () {
        ModalService.showCreateReportModal(self.selectedReport, handleCreateReportModalResult);
    };
    self.handleReportChange = function () {
        $location.path(self.selectedReport.path);
    };
    self.$onInit = function () {
        ReportViewService.doesUserHaveWritePermission(self.selectedReport).then(function (writePermission) {
            self.enableSubmit = writePermission;
        });
        if (self.selectedReport.includePartners) {
            self.updatePartnerList();
        }
    };
}
angular.module('prism-ui.report').component('reportView', {
    controller: ReportViewController,
    templateUrl: 'dashboard/reports/report-view-template.html'
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 8/3/16.
 */
'use strict';
angular.module('prism-ui.workflows').service('WorkflowsService', function (_, $q, EnumService, WorkflowExecutionResourceFactory, PermissionsService, PaginationService) {
    var self = this;
    self.expandedWorkflowsByTreeLevel = []; // 2D array. 1st == treeLevel, 2nd == workflows in that level (sorted by id)
    self.permissions = {};
    var WORKFLOWS_VIEW_STATE = 'DASHBOARD_WORKFLOW_VIEW';
    var RESUMEABLE_STATUSES = ['EXECUTING', 'STALLED', 'PAUSED', 'WAITING', 'CREATED'];
    var PAUSEABLE_STATUSES = ['EXECUTING', 'STALLED', 'QUEUED'];
    //============================//
    // Expanded Workflow Tracking //
    //============================//
    self.addItemToExpandedWorkflows = function (workflow) {
        var workflowsInTreeLevelById = self.expandedWorkflowsByTreeLevel[workflow.$$treeLevel];
        if (!workflowsInTreeLevelById) {
            workflowsInTreeLevelById = {};
            self.expandedWorkflowsByTreeLevel[workflow.$$treeLevel] = workflowsInTreeLevelById;
        }
        workflowsInTreeLevelById[workflow.id] = workflow;
    };
    self.removeItemFromExpandedWorkflows = function (workflowId) {
        for (var i in self.expandedWorkflowsByTreeLevel) {
            var workflowsInTreeLevelById = self.expandedWorkflowsByTreeLevel[i];
            if (workflowId in workflowsInTreeLevelById) {
                delete workflowsInTreeLevelById[workflowId];
                return;
            }
        }
    };
    //====================//
    // Workflow Retrieval //
    //====================//
    var getQueryOpts = function (pagingOptions, searchCriteria) {
        var offset = pagingOptions.pageSize * (pagingOptions.currentPage - 1);
        var queryOpts = {
            fetchOffset: offset,
            fetchLimit: pagingOptions.pageSize
        };
        angular.extend(queryOpts, searchCriteria);
        return queryOpts;
    };
    self.getWorkflows = function (pagingOptions, searchCriteria) {
        var queryOpts = getQueryOpts(pagingOptions, searchCriteria);
        return WorkflowExecutionResourceFactory.query(queryOpts, function (data, headers) {
            PaginationService.parseResponseHeaders(headers());
            angular.forEach(data, function (workflow) {
                workflow.$$treeLevel = 0;
            });
            return data;
        }).$promise.then(function (data) {
            return _.orderBy(data, ['dateCreated', 'id'], ['desc', 'desc']);
        });
    };
    self.retrieveAllExpandedSubflows = function () {
        var subflowPromisesByParentId = {};
        var parentIds = []; // Guarantees that workflow's id is inserted before any of it's descendant's ids
        _.forEach(self.expandedWorkflowsByTreeLevel, function (workflowsInTreeLevelById, treeLevel) {
            // Iterates through each workflow to make it easier to identify subflows by parentId
            _.forEach(workflowsInTreeLevelById, function (workflow) {
                parentIds.push(workflow.id);
                var subflowsPromise = self.retrieveSubflowData([workflow], treeLevel + 1)
                    // Only one workflow's subflows were retrieved, so flatten out the object
                    .then(function (subflowsByParentId) {
                    return _.values(subflowsByParentId)[0];
                });
                subflowPromisesByParentId[workflow.id] = subflowsPromise;
            });
        });
        return $q.all({
            subflowsByParentId: $q.all(subflowPromisesByParentId),
            parentIterationOrder: parentIds
        });
    };
    self.retrieveSubflowData = function (workflows, subflowsTreeLevel) {
        var subflowsPromisesByParentId = {};
        _.forEach(workflows, function (workflow) {
            subflowsPromisesByParentId[workflow.id] = WorkflowExecutionResourceFactory.getSubflowExecutions({ id: workflow.id }).$promise;
        });
        return $q.all(subflowsPromisesByParentId).then(function (subflowsByParentId) {
            _.forEach(workflows, function (workflow) {
                subflowsByParentId[workflow.id] = _.orderBy(subflowsByParentId[workflow.id], ['dateCreated', 'id'], ['desc', 'desc']);
                workflow.subflows = subflowsByParentId[workflow.id];
                _.forEach(workflow.subflows, function (subflow) {
                    subflow.$$treeLevel = subflowsTreeLevel;
                });
            });
            return subflowsByParentId;
        });
    };
    //===================//
    // Permission Checks //
    //===================//
    self.canReadWorkflows = function () {
        return self.permissions.read;
    };
    var doesWorkflowHaveParent = function (workflow) {
        return !!workflow.parentExecutionId;
    };
    var isWorkflowResumeable = function (workflow) {
        return !doesWorkflowHaveParent(workflow) && RESUMEABLE_STATUSES.indexOf(workflow.status) >= 0;
    };
    var isWorkflowPauseable = function (workflow) {
        return PAUSEABLE_STATUSES.indexOf(workflow.status) >= 0;
    };
    self.canDoWorkflowAction = function (action, selectedWorkflows) {
        if (!selectedWorkflows || selectedWorkflows.length < 1) {
            return false;
        }
        if (action !== 'view' && !self.permissions.write) {
            return false;
        }
        switch (action) {
            case 'view':
                return selectedWorkflows.length === 1;
            case 'resume':
                if (!_.every(selectedWorkflows, isWorkflowResumeable)) {
                    return false;
                }
                break;
            case 'pause':
                if (!_.every(selectedWorkflows, isWorkflowPauseable)) {
                    return false;
                }
                break;
            case 'abandon':
                if (_.some(selectedWorkflows, doesWorkflowHaveParent)) {
                    return false;
                }
                break;
        }
        return true;
    };
    //=======================//
    // Workflow Modification //
    //=======================//
    self.pause = function (workflowList) {
        var promises = [];
        for (var i in workflowList) {
            promises.push(WorkflowExecutionResourceFactory.stop({ id: workflowList[i].id }).$promise);
        }
        return $q.all(promises);
    };
    self.resume = function (workflowList) {
        var promises = [];
        for (var i in workflowList) {
            promises.push(WorkflowExecutionResourceFactory.resume({ id: workflowList[i].id }).$promise);
        }
        return $q.all(promises);
    };
    self.abandon = function (workflowList) {
        var promises = [];
        for (var i in workflowList) {
            workflowList[i].status = 'ABANDONED';
            promises.push(WorkflowExecutionResourceFactory.abandon({ id: workflowList[i].id }).$promise);
        }
        return $q.all(promises);
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    self.initialize = function () {
        var canRead = PermissionsService.canRead(WORKFLOWS_VIEW_STATE);
        var canWrite = PermissionsService.canWrite(WORKFLOWS_VIEW_STATE);
        var enums = EnumService.queryForEnums();
        return $q.all({
            read: canRead,
            write: canWrite,
            enums: enums
        }).then(function (permissions) {
            self.permissions = permissions;
        });
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: network-view-service
 *
 * Created by rwilliams on 7/19/17.
 */
'use strict';
angular.module('prism-ui.network').service('NetworkViewService', function (_, $q, $routeParams, $location, BreadcrumbService, PermissionsService, NotificationService, NetworkResourceFactory, MetaPropsResourceFactory) {
    var self = this;
    var _networkComponentsMap = {};
    var setBreakPrePostrollPermissions = function (permissions) {
        var readPerms = permissions.preroll.read && permissions.postroll.read;
        var writePerms = permissions.preroll.write && permissions.postroll.write;
        permissions.breakprepostroll = { read: readPerms, write: writePerms };
        return permissions;
    };
    var getTabViewPermissions = function () {
        var prerollPromise = PermissionsService.getReadWritePermissions(self.permissionViewStates.NETWORK_PREROLL_SEARCH_VIEW_STATE);
        var postrollPromise = PermissionsService.getReadWritePermissions(self.permissionViewStates.NETWORK_POSTROLL_SEARCH_VIEW_STATE);
        var watermarkPromise = PermissionsService.getReadWritePermissions(self.permissionViewStates.NETWORK_WATERMARK_SEARCH_VIEW_STATE);
        var artworkPromise = PermissionsService.getReadWritePermissions(self.permissionViewStates.NETWORK_ARTWORK_SEARCH_VIEW_STATE);
        var ratingOverlayPromise = PermissionsService.getReadWritePermissions(self.permissionViewStates.NETWORK_RATING_OVERLAY_SEARCH_VIEW_STATE);
        return $q.all({
            preroll: prerollPromise,
            postroll: postrollPromise,
            watermark: watermarkPromise,
            artwork: artworkPromise,
            ratingOverlay: ratingOverlayPromise,
        }).then(function (permissions) {
            return setBreakPrePostrollPermissions(permissions);
        });
    };
    var resetBreadcrumbs = function () {
        BreadcrumbService.clearBreadcrumbs();
        BreadcrumbService.addBreadcrumb({
            name: 'Networks',
            location: '/meta/networks/search',
            params: angular.copy($location.search())
        });
    };
    var closeEditView = function () {
        resetBreadcrumbs();
        self.network = null;
        self.editorForm = null;
        $location.path(self.parentRoute);
    };
    var canExitEditView = function () {
        return !self.editorForm || (self.network.id && self.editorForm.$pristine);
    };
    var revertComponents = function () {
        angular.forEach(self.networkComponentsMap(), function (comp, key) {
            comp.instanceData.value = self.originalNetworkData.metadata.properties[key].value;
        });
    };
    self.permissionViewStates = {
        NETWORK_VIEW_STATE: 'NETWORK_VIEW_STATE',
        NETWORK_PREROLL_SEARCH_VIEW_STATE: 'NETWORK_PREROLL_SEARCH_VIEW_STATE',
        NETWORK_POSTROLL_SEARCH_VIEW_STATE: 'NETWORK_POSTROLL_SEARCH_VIEW_STATE',
        NETWORK_BREAKPREPOSTROLL_SEARCH_VIEW_STATE: 'NETWORK_BREAKPREPOSTROLL_SEARCH_VIEW_STATE',
        NETWORK_WATERMARK_SEARCH_VIEW_STATE: 'NETWORK_WATERMARK_SEARCH_VIEW_STATE',
        NETWORK_ARTWORK_SEARCH_VIEW_STATE: 'NETWORK_ARTWORK_SEARCH_VIEW_STATE',
        // TODO: Consolidate all branding asset permissions into 1
        NETWORK_RATING_OVERLAY_SEARCH_VIEW_STATE: 'NETWORK_ARTWORK_SEARCH_VIEW_STATE',
    };
    self.editorForm = null;
    self.tabRevertFunction = null;
    self.parentRoute = '/meta/networks/search';
    self.originalNetworkData = null;
    self.getViewPermissions = function (viewStateKey) {
        if (viewStateKey) {
            return PermissionsService.getReadWritePermissions(viewStateKey);
        }
        else {
            return getTabViewPermissions();
        }
    };
    self.getSearchViewData = function (criteria, handleGridDataQuery) {
        self.breadcrumbName = '';
        return NetworkResourceFactory.getNetworks(criteria, handleGridDataQuery).$promise;
    };
    self.getEditViewData = function (criteria) {
        return NetworkResourceFactory.get(criteria).$promise.then(function (data) {
            self.breadcrumbName = data.name;
            self.originalNetworkData = _.cloneDeep(data);
            return data;
        });
    };
    self.saveNetwork = function (network) {
        if ($routeParams.id > -1) {
            return NetworkResourceFactory.update(network).$promise;
        }
        return NetworkResourceFactory.save(network).$promise;
    };
    self.revertEditData = function () {
        if (self.network) {
            self.network = _.cloneDeep(self.originalNetworkData);
            revertComponents();
            return self.network;
        }
        else {
            closeEditView();
        }
    };
    self.exitEdit = function () {
        if (canExitEditView()) {
            closeEditView();
        }
        else {
            NotificationService.createWarningNotification('You have unsaved changes.  Please save or revert.', '');
        }
    };
    self.networkComponentsMap = function (newNetworkComponentsMap) {
        if (arguments.length) {
            _networkComponentsMap = newNetworkComponentsMap;
        }
        return _networkComponentsMap;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 2/22/16.
 */
'use strict';
angular.module('prism-ui.package').service('PackageActionService', function (_, $q, $route, $timeout, loginService, ClipResourceFactory, DownloadAssetService, DynamicPropertiesService, EndPointService, ModalService, NavbarUtilService, NotificationService, orderByFilter, PackageMediaResourceFactory, PackageResourceFactory, PackageService, PackageMediaService, PackageUtilService, PartnerPackagesService, PartnerResourceFactory, PermissionsResourceFactory, PermissionsService, UtilsService, ReportViewService, WorkflowExecutionResourceFactory, WorkflowService) {
    var self = this;
    var BATCH_MODIFY_METADATA_WORKFLOW_KEY = 'batchModifyPackageMetadata';
    var DOWNLOAD_PROXIES_WORKFLOW_KEY = 'downloadProxies';
    var EXPORT_DELIVERY_REPORT_WORKFLOW_KEY = 'exportDeliveryReport';
    var EXPORT_METADATA_WORKFLOW_KEY = 'exportMetadataReport';
    var PACKAGEDELIVERY_SELECTPACKAGES_WORKFLOW_KEY = 'mainPartnerDeliveryWorkflow';
    var REMOVE_PACKAGE_MEDIA_WORKFLOW_KEY = 'removePackageMedia';
    var RESET_SELECTED_CLIP_PACKAGE_WORKFLOW_KEY = 'resetSelectedClipPackages';
    var RESET_SELECTED_PACKAGES_WORKFLOW_KEY = 'resetSelectedPackages';
    var RETRIEVE_MASTER_MEDIA_WORKFLOW_KEY = 'retrievePackageMedia';
    var VALIDATE_SELECTED_PACKAGES_WORKFLOW_KEY = 'validateSelectedPackages';
    self.clipPermissions = {
        hasPermissions: false,
        validatePermissions: [],
        deliverClipPermissions: [],
        retrieveClipMediaPermission: [],
        clipBatchModifyPermission: [],
        clipMetadataReportPermission: [],
        clipResetPermissions: [],
        clipDeliveryReportPermission: []
    };
    self.actionsLoading = false;
    //
    // 2018-Jan-3
    //
    // ABC-9317 - The "Batch Modify Metadata" action will function
    //      the same but will be renamed to "Check Out Package(s)"
    //
    self.BATCH_MODIFY_METADATA_ACTION = {
        label: 'Check Out Package(s)',
        workflowKey: BATCH_MODIFY_METADATA_WORKFLOW_KEY,
        disabled: true
    };
    self.DELIVER_PACKAGE_SELECT_PARTNERS_ACTION = {
        label: 'Deliver Package(s) - Select Partners',
        workflowKey: PACKAGEDELIVERY_SELECTPACKAGES_WORKFLOW_KEY,
        disabled: true
    };
    self.DELIVERY_REPORT_ACTION = {
        label: 'Execute Delivery Report',
        workflowKey: EXPORT_DELIVERY_REPORT_WORKFLOW_KEY,
        disabled: true
    };
    self.DOWNLOAD_PROXIES_ACTION = {
        label: 'Download Video Proxies',
        workflowKey: DOWNLOAD_PROXIES_WORKFLOW_KEY,
        disabled: true
    };
    self.EXPORT_METADATA_REPORT_ACTION = {
        label: 'Export ALL Metadata',
        workflowKey: EXPORT_METADATA_WORKFLOW_KEY,
        disabled: true
    };
    self.REMOVE_PACKAGE_MEDIA_ACTION = {
        label: 'Remove Package Media',
        workflowKey: REMOVE_PACKAGE_MEDIA_WORKFLOW_KEY,
        disabled: true
    };
    self.RESET_CLIP_PACKAGE_ACTION = {
        label: 'Reset Clip Package',
        workflowKey: RESET_SELECTED_CLIP_PACKAGE_WORKFLOW_KEY,
        disabled: true
    };
    self.RESET_PACKAGE_ACTION = {
        label: 'Reset Package',
        workflowKey: RESET_SELECTED_PACKAGES_WORKFLOW_KEY,
        disabled: true
    };
    self.RETRIEVE_MASTER_MEDIA_ACTION = {
        label: 'Retrieve Master Media',
        workflowKey: RETRIEVE_MASTER_MEDIA_WORKFLOW_KEY,
        disabled: true
    };
    self.VALIDATE_PACKAGE_ACTION = {
        label: 'Validate Package(s)',
        workflowKey: VALIDATE_SELECTED_PACKAGES_WORKFLOW_KEY,
        disabled: true
    };
    DynamicPropertiesService.queryForProperties().then(function () {
        self.redeliveryReasons = DynamicPropertiesService.getPropValueAsList('package.redeliveryReasons');
    });
    self.actions = [
        self.BATCH_MODIFY_METADATA_ACTION,
        self.DELIVER_PACKAGE_SELECT_PARTNERS_ACTION,
        self.DOWNLOAD_PROXIES_ACTION,
        self.RESET_PACKAGE_ACTION,
        self.RETRIEVE_MASTER_MEDIA_ACTION,
        self.VALIDATE_PACKAGE_ACTION
    ];
    self.editorActions = [
        self.DELIVER_PACKAGE_SELECT_PARTNERS_ACTION,
        self.REMOVE_PACKAGE_MEDIA_ACTION,
        self.RESET_PACKAGE_ACTION,
        self.RETRIEVE_MASTER_MEDIA_ACTION
    ];
    self.liveClipActions = [
        self.BATCH_MODIFY_METADATA_ACTION,
        self.DELIVER_PACKAGE_SELECT_PARTNERS_ACTION,
        self.DELIVERY_REPORT_ACTION,
        self.EXPORT_METADATA_REPORT_ACTION,
        self.RESET_CLIP_PACKAGE_ACTION,
        self.RETRIEVE_MASTER_MEDIA_ACTION,
        self.VALIDATE_PACKAGE_ACTION
    ];
    self.liveClipEditorActions = [
        self.DELIVER_PACKAGE_SELECT_PARTNERS_ACTION,
        self.RESET_CLIP_PACKAGE_ACTION,
        self.RETRIEVE_MASTER_MEDIA_ACTION,
        self.VALIDATE_PACKAGE_ACTION
    ];
    self.selectedPackages = [];
    self.partnerMap = {};
    self.availableDeliveryTemplatesForPartners = {};
    self.partners = [];
    var resetActionsToDisabled = function () {
        _.forEach(self.actions, function (action) {
            action.disabled = true;
        });
    };
    var resetClipActionsToDisabled = function () {
        _.forEach(self.liveClipActions, function (action) {
            action.disabled = true;
        });
    };
    var hasValidPackage = function (partnerPackage) {
        return !_.get(partnerPackage, 'validationResult.errors.length');
    };
    var setValidationErrorsAndWarnings = function (parentPackage, partnerPackage, partnerMapObj) {
        var mappedErrors = partnerPackage.validationResult.errors.map(function (error) {
            return { type: 'error', label: error.description + " - " + parentPackage.name };
        });
        var mappedWarnings = partnerPackage.validationResult.warnings.map(function (warning) {
            return { type: 'warning', label: warning.description + " - " + parentPackage.name };
        });
        Array.prototype.push.apply(partnerMapObj.partnerPkgErrors, mappedErrors);
        Array.prototype.push.apply(partnerMapObj.partnerPkgWarnings, mappedWarnings);
    };
    var partnerArraysMap = {};
    var setPartnerMapValidations = function (partnerPackage, partnerMapObj, parentPackage, partnerPromises) {
        // Is the partner package enabled?
        if (partnerPackage.enabled) {
            // Add to list of partners
            self.partners.push(partnerPackage.partner);
            if (_.toNumber(partnerPackage.partner.numberOfChildren) > 0) {
                var childPartnerPromise = PartnerResourceFactory.getChildren({ id: partnerPackage.partner.id })
                    .$promise.then(function (childPartners) {
                    var sortIteratee = function (partner) { return partner.name.toLowerCase(); };
                    _.chain(childPartners)
                        .orderBy(sortIteratee)
                        .sortedUniqBy(sortIteratee)
                        .value();
                    partnerArraysMap[childPartners[0].parentId] = childPartners;
                    _.forEach(childPartners, function (childPartner) {
                        if (!self.partnerMap[childPartner.id]) {
                            self.partnerMap[childPartner.id] = {
                                partner: childPartner,
                                partnerPkgErrors: [],
                                partnerPkgWarnings: [],
                                deliveryTemplates: childPartner.deliveryTemplates,
                                redeliver: false,
                                packageIds: [],
                                partnerPackageInfoLookup: {}
                            };
                        }
                        self.partnerMap[childPartner.id].partnerPackageInfoLookup[partnerPackage.id] = {
                            partnerPackage: partnerPackage,
                            package: parentPackage
                        };
                        self.partnerMap[childPartner.id].packageIds.push(parentPackage.id);
                        self.partnerMap[childPartner.id].hasValidPackage = hasValidPackage(partnerPackage);
                        // Add errors & warnings for package to partner
                        if (partnerPackage.validationResult) {
                            setValidationErrorsAndWarnings(parentPackage, partnerPackage, self.partnerMap[childPartner.id]);
                        }
                    });
                });
                partnerPromises.push(childPartnerPromise);
            }
            // Add instance label to partner package partner
            if (partnerPackage.partner.partnerDeliveryInstanceEnabled) {
                var selectedInstance = PartnerPackagesService.getSelectedInstance(partnerPackage);
                if (!selectedInstance) {
                    selectedInstance = partnerPackage.deliveryInstances[partnerPackage.deliveryInstances.length - 1];
                }
                partnerPackage.partner.deliveryLabel = 'Instance ' +
                    selectedInstance.instance + '.' + selectedInstance.revision;
            }
        }
        else {
            // Create artificial error for being disabled
            partnerMapObj.partnerPkgErrors.push({
                type: 'error',
                label: "De-selected partner - " + parentPackage.name
            });
        }
        // Partner has valid package if there's no errors
        partnerMapObj.hasValidPackage = hasValidPackage(partnerPackage);
        // Add errors & warnings for package to partner
        if (partnerPackage.validationResult) {
            setValidationErrorsAndWarnings(parentPackage, partnerPackage, partnerMapObj);
        }
    };
    var handleNewPartnerMapObj = function (partnerPackage) {
        // Create partner map entry
        self.partnerMap[partnerPackage.partner.id] = {
            partner: partnerPackage.partner,
            partnerPackageInfoLookup: {},
            partnerPkgErrors: [],
            partnerPkgWarnings: [],
            deliveryTemplates: [],
            redeliver: parseInt(partnerPackage.revision) > 1,
            packageIds: []
        };
        // Add partner delivery template list
        return PartnerResourceFactory.get({ id: partnerPackage.partner.id }).$promise.then(function (partner) {
            self.partnerMap[partnerPackage.partner.id].deliveryTemplates = partner.deliveryTemplates;
        });
    };
    var setupPartnerMap = function (parentPackage, partnerPkgs) {
        var partnerPromises = [];
        // Populate partner map
        _.forEach(partnerPkgs, function (partnerPackage) {
            var partnerMapObj = self.partnerMap[partnerPackage.partner.id];
            if (!partnerMapObj) {
                partnerPromises.push(handleNewPartnerMapObj(partnerPackage));
                partnerMapObj = self.partnerMap[partnerPackage.partner.id];
            }
            else {
                if (!partnerMapObj.redeliver) {
                    // ... shouldn't this be an or-equals?
                    partnerMapObj.redeliver = parseInt(partnerPackage.revision) > 1;
                }
            }
            // Add main package ID to partner's list of packages
            partnerMapObj.partnerPackageInfoLookup[partnerPackage.id] = {
                package: parentPackage,
                partnerPackage: partnerPackage
            };
            partnerMapObj.packageIds.push(parentPackage.id);
            // Add validation info to partner
            setPartnerMapValidations(partnerPackage, partnerMapObj, parentPackage, partnerPromises);
        });
        partnerArraysMap = _.chain(self.partnerMap)
            .cloneDeep(self.partnerMap)
            .mapValues(function () { return []; })
            .value();
        partnerArraysMap.partners = [];
        return $q.all(partnerPromises);
    };
    var callNavbarViewSearchFunction = function () {
        if (NavbarUtilService.viewSearchFunction) {
            NavbarUtilService.viewSearchFunction();
        }
        else if (PackageUtilService.tabLoadDataFunction) {
            PackageUtilService.tabLoadDataFunction();
        }
    };
    var setupWorkflowPromises = function (workflowPromises) {
        //
        // This collects all workflow promises into one promise.
        //
        // Subsequent to that one promise, display relevant
        // notifications and reset the view.
        //
        return $q.all(workflowPromises)
            .then(function (workflowPromises) {
            NotificationService.createInfoNotification(workflowPromises.length + ((workflowPromises.length > 1) ?
                ' packages' :
                ' package') +
                ' sent to workflow');
        })
            .catch(function (failure) {
            if (failure && failure.statusText && failure.statusText.indexOf('already being delivered.') > -1) {
                NotificationService.createFailureNotification(failure.statusText, '', true);
            }
            else {
                NotificationService.createFailureNotification('One or more of the workflows failed to start.', '', true);
            }
        })
            .finally(function () {
            callNavbarViewSearchFunction();
            //
            // ABC-8725 - Duplicate delivery workflows
            //
            // This is the end of the line after a user sends
            // a workflow to delivery.
            //
            // So now we're going to destroy everything that
            // was used to create the call that initiates the
            // workflow.
            //
            // We also attempt to lock the dist. grid ASAP by
            // giving the server 2 seconds to change the
            // package's status and then polling for status
            // updates.
            //
            $timeout(function () {
                PackageUtilService.pollForPackageUpdates();
            }, 2000);
            self.partnerMap = {};
            self.availableDeliveryTemplatesForPartners = {};
            self.partners = [];
            _.forEach(workflowPromises, function (workflowPromise, index) {
                _.forEach(_.keys(workflowPromise), function (key) {
                    delete workflowPromise[key];
                    workflowPromises[index] = null;
                    // ... is it dead yet?
                });
            });
        });
    };
    var packageHasPartnerSelected = function (pkg, partnerId) {
        var foundDeselectedError = self.partnerMap[partnerId].partnerPkgErrors.filter(function (pkgError) {
            return pkgError.label === 'De-selected partner - ' + pkg.name;
        });
        return foundDeselectedError.length === 0;
    };
    var startDeliveryWorkflow = function (selectedPackage, redeliveryReason, partnerDeliveryTemplates) {
        var deliveryWorkflowPromise = null;
        if (partnerDeliveryTemplates.length > 0) {
            deliveryWorkflowPromise = WorkflowExecutionResourceFactory.startInstanceDelivery({
                packageId: selectedPackage.id,
                redeliveryReason: redeliveryReason,
            }, partnerDeliveryTemplates);
        }
        return deliveryWorkflowPromise;
    };
    var createDeliveryWorkflowTemplateData = function (selectedPackage, partnerMapItem, partnerDeliveryInstanceId) {
        if (partnerDeliveryInstanceId === void 0) { partnerDeliveryInstanceId = null; }
        var template = _.cloneDeep(partnerMapItem.template);
        if (partnerDeliveryInstanceId) {
            template.partnerDeliveryInstanceId = partnerDeliveryInstanceId;
        }
        if (template.template.custom) {
            var deliveryItemIds_1 = [];
            _.forEach(template.partnerDeliveryItemIds, function (deliveryItemMSDId) {
                var encodedId = _.split(deliveryItemMSDId, '_');
                var packageId = encodedId[0];
                var deliveryItemId = encodedId[1];
                if (packageId === selectedPackage.id) {
                    deliveryItemIds_1.push(deliveryItemId);
                }
            });
            if (deliveryItemIds_1.length > 0) {
                template.partnerDeliveryItemIds = deliveryItemIds_1;
            }
            else {
                delete template.partnerDeliveryItemIds;
                template = null;
            }
        }
        return template;
    };
    var createDeliveryPromise = function (selectedPackage, modalValues) {
        var selectedInstance = {};
        if (selectedPackage.id === PartnerPackagesService.parentPackageId()) {
            _.forEach(PartnerPackagesService.partnerPackages(), function (partnerPackage) {
                var selectedInstanceMap = PartnerPackagesService.selectedInstanceMap();
                selectedInstance[partnerPackage.partner.id] = selectedInstanceMap[partnerPackage.id];
            });
        }
        var partnerDeliveryTemplates = [];
        _.forEach(modalValues.selectedPartners, function (partnerMapItem, partnerId) {
            if (_.includes(self.partnerMap[partnerId].packageIds, selectedPackage.id) &&
                packageHasPartnerSelected(selectedPackage, partnerId)) {
                var template = createDeliveryWorkflowTemplateData(selectedPackage, partnerMapItem, _.get(selectedInstance, partnerId, null));
                if (template) {
                    partnerDeliveryTemplates.push(template);
                }
            }
        });
        return startDeliveryWorkflow(selectedPackage, modalValues.redeliveryReason, partnerDeliveryTemplates);
    };
    self.handlePartnerDelivery = function (modalValues) {
        var workflowPromises = [];
        _.forEach(self.selectedPackages, function (selectedPackage) {
            var deliveryPromise = createDeliveryPromise(selectedPackage, modalValues);
            if (deliveryPromise) {
                workflowPromises.push(deliveryPromise);
            }
        });
        setupWorkflowPromises(workflowPromises);
    };
    var setInvalidPartnerErrors = function () {
        _.forEach(self.partners, function (partner) {
            _.forEach(self.selectedPackages, function (pkg) {
                if (self.partnerMap[partner.id].packageIds.indexOf(pkg.id) === -1) {
                    self.partnerMap[partner.id].partnerPkgErrors.push({
                        type: 'error',
                        label: 'Invalid Partner for Package - ' + pkg.name
                    });
                }
            });
        });
    };
    var setPartnerRedeliverFlag = function () {
        var deliveryPromises = [];
        _.forEach(self.selectedPackages, function (selectedPackage) {
            var completedDeliveriesPromise = PackageService.getCompletedDeliveries(selectedPackage, true).then(function (completedDeliveries) {
                _.forEach(completedDeliveries, function (delivery) {
                    _.forEach(self.partnerMap, function (partnerMapContainer) {
                        if (partnerMapContainer.partner.name === delivery.partnerName) {
                            partnerMapContainer.redeliver = true;
                        }
                    });
                });
            });
            deliveryPromises.push(completedDeliveriesPromise);
        });
        return $q.all(deliveryPromises);
    };
    var showPackageDeliveryModal = function () {
        self.partnerMap = {};
        self.availableDeliveryTemplatesForPartners = {};
        self.partners = [];
        var partnerPkgsQueries = [];
        var partnerSetupPromises = [];
        _.forEach(self.selectedPackages, function (selectedPkg) {
            var partnerPkgQuery = PartnerPackagesService.getPartnerPackagesForValidation(selectedPkg.id).then(function (partnerPkgs) {
                var partnerSetupPromise = setupPartnerMap(selectedPkg, partnerPkgs);
                partnerSetupPromises.push(partnerSetupPromise);
                return partnerSetupPromises;
            });
            partnerPkgsQueries.push(partnerPkgQuery);
        });
        return $q.all(partnerPkgsQueries).then(function () {
            return $q.all(partnerSetupPromises).then(function () {
                var sortIteratee = function (partner) { return partner.name.toLowerCase(); };
                _.chain(self.partners)
                    .orderBy(sortIteratee)
                    .sortedUniqBy(sortIteratee)
                    .forEach(function (partner) {
                    partnerArraysMap[partner.id].unshift(partner);
                    partnerArraysMap.partners = partnerArraysMap.partners.concat(partnerArraysMap[partner.id]);
                })
                    .value();
                self.partners = partnerArraysMap.partners;
                setInvalidPartnerErrors();
                setPartnerRedeliverFlag().then(function () {
                    ModalService.showSelectDeliveryPartnersModal(self.handlePartnerDelivery);
                });
            });
        });
    };
    var validatePackages = function () {
        var packageIds = self.selectedPackages.map(function (pkg) {
            return '' + pkg.id;
        });
        return PackageResourceFactory.validatePackages(packageIds).$promise.then(callNavbarViewSearchFunction);
    };
    var resetPackages = function () {
        var pkgIds = self.selectedPackages.map(function (pkg) {
            return pkg.id;
        });
        return PackageResourceFactory.resetPackages(pkgIds).$promise.then(callNavbarViewSearchFunction);
    };
    var removePackageMedia = function (showLoadingIndicator, hideLoadingIndicator) {
        var pkg = _.first(self.selectedPackages);
        showLoadingIndicator();
        delete pkg.primaryAcceptTemplateMember;
        delete pkg.primaryVideo;
        delete pkg.primaryImage;
        delete pkg.mediaRevision;
        delete pkg.mediaVersion;
        delete pkg.fourByThreeSafe;
        delete pkg.endCreditTimecode;
        return PackageResourceFactory.save({ id: pkg.id }, pkg).$promise
            .then(function () {
            return PackageMediaResourceFactory.save({
                id: pkg.id,
                pendingIngest: true
            }, [ /* Empty media asset array to clear package media assets */]).$promise;
        }).then(function () {
            $route.reload();
        }).finally(hideLoadingIndicator);
    };
    var confirmRemovePackageMedia = function (showLoadingIndicator, hideLoadingIndicator) {
        ModalService.showMessageModal({
            messageText: "Are you sure you want to remove all package assets? This cannot be undone.",
            pullCancelLeft: true,
            title: 'Reset Package Media',
            windowClass: 'confirm-modal-lg',
            showOK: true
        }, function () {
            removePackageMedia(showLoadingIndicator, hideLoadingIndicator);
        });
        return $q.when(false);
    };
    var downloadPackageProxies = function () {
        _.forEach(self.selectedPackages, function (packageObject) {
            var assetId = packageObject.primaryVideo.assetId;
            var proxyFileName = PackageMediaService.generatePackageDownloadFilenamePrefix(packageObject, false) +
                'video_proxy.' + UtilsService.getFileExtension(packageObject.primaryVideo.proxyPath);
            DownloadAssetService.downloadAsset(assetId, proxyFileName, DownloadAssetService.AssetType.Video, DownloadAssetService.ContentUse.Proxy);
        });
        // each of these handlers is expected to return a promise
        return $q.when(true);
    };
    var resetClipPackages = function () {
        var resetPromises = [];
        _.forEach(self.selectedPackages, function (selectedPackage) {
            resetPromises.push(ClipResourceFactory.resetClip({ id: selectedPackage.id }).$promise);
        });
        return $q.all(resetPromises).then(callNavbarViewSearchFunction);
    };
    var handleGenerateBatchMetadataReport = function (reportOptions) {
        ReportViewService.PACKAGE_BATCH_MODIFY_REPORT.formTitle = '';
        reportOptions.selectedPackages = self.selectedPackages;
        ReportViewService.startReportWorkflow(ReportViewService.PACKAGE_BATCH_MODIFY_REPORT, reportOptions);
    };
    var showBatchMetadataReportModal = function () {
        ReportViewService.PACKAGE_BATCH_MODIFY_REPORT.formTitle = 'Create a package report that will lock ' +
            self.selectedPackages.length + ' package' + (self.selectedPackages.length > 1 ? 's' : '') + ' for batch modification';
        ModalService.showCreateReportModal(ReportViewService.PACKAGE_BATCH_MODIFY_REPORT, handleGenerateBatchMetadataReport);
        return $q.when(true);
    };
    var handleSelectedMasterMediaContent = function (selectedContentTypes) {
        var mediaTypes = [], workflowPromises = [];
        _.forEach(selectedContentTypes, function (contentType, key) {
            mediaTypes.push(key);
        });
        _.forEach(self.selectedPackages, function (pkg) {
            var workflowParameters = {
                subject: '[Package.' + pkg.id + ']',
                mediaTypes: mediaTypes
            };
            workflowPromises.push(WorkflowService.startWorkflow(RETRIEVE_MASTER_MEDIA_WORKFLOW_KEY, workflowParameters));
        });
        setupWorkflowPromises(workflowPromises);
    };
    var showSelectMasterMediaTypesModal = function () {
        ModalService.showSelectMasterMediaTypesModal(handleSelectedMasterMediaContent);
        return $q.when(true);
    };
    var showPackageMetadataReportModal = function () {
        ModalService.showCreateReportModal(ReportViewService.CLIP_PACKAGE_ALL_METADATA_REPORT, function (reportOptions) {
            reportOptions.selectedPackages = self.selectedPackages;
            ReportViewService.startReportWorkflow(ReportViewService.CLIP_PACKAGE_ALL_METADATA_REPORT, reportOptions);
        });
        return $q.when(true);
    };
    var showPackageDeliveryReportModal = function () {
        ModalService.showCreateReportModal(ReportViewService.CLIP_PACKAGE_DELIVERY_REPORT, function (reportOptions) {
            reportOptions.selectedPackages = self.selectedPackages;
            reportOptions.includeMasterPkgs = false;
            reportOptions.includeClipToolPkgs = true;
            ReportViewService.startReportWorkflow(ReportViewService.CLIP_PACKAGE_DELIVERY_REPORT, reportOptions);
        });
        return $q.when(true);
    };
    self.handleSelectedAction = function (selectedAction, showLoadingIndicator, hideLoadingIndicator) {
        var actionPromise = $q.when(true);
        showLoadingIndicator();
        switch (selectedAction.workflowKey) {
            case BATCH_MODIFY_METADATA_WORKFLOW_KEY:
                actionPromise = showBatchMetadataReportModal();
                break;
            case DOWNLOAD_PROXIES_WORKFLOW_KEY:
                actionPromise = downloadPackageProxies();
                break;
            case EXPORT_DELIVERY_REPORT_WORKFLOW_KEY:
                actionPromise = showPackageDeliveryReportModal();
                break;
            case EXPORT_METADATA_WORKFLOW_KEY:
                actionPromise = showPackageMetadataReportModal();
                break;
            case PACKAGEDELIVERY_SELECTPACKAGES_WORKFLOW_KEY:
                actionPromise = showPackageDeliveryModal();
                break;
            case REMOVE_PACKAGE_MEDIA_WORKFLOW_KEY:
                actionPromise = confirmRemovePackageMedia(showLoadingIndicator, hideLoadingIndicator);
                break;
            case RESET_SELECTED_CLIP_PACKAGE_WORKFLOW_KEY:
                actionPromise = resetClipPackages();
                break;
            case RESET_SELECTED_PACKAGES_WORKFLOW_KEY:
                actionPromise = resetPackages();
                break;
            case RETRIEVE_MASTER_MEDIA_WORKFLOW_KEY:
                actionPromise = showSelectMasterMediaTypesModal();
                break;
            case VALIDATE_SELECTED_PACKAGES_WORKFLOW_KEY:
                actionPromise = validatePackages();
        }
        return actionPromise.then(hideLoadingIndicator);
    };
    //========================================//
    // Package / Clip Action Enable & Disable //
    //========================================//
    var canValidateClip = function (pkg) {
        return PermissionsService.canWritePackage('CLIP_ACTION_VALIDATE_VIEW_STATE', pkg.id);
    };
    var allClipsCanBeValidated = function (validatePermissions) {
        var allClipsCanBeValidated = validatePermissions.length > 0;
        return $q.all(validatePermissions).then(function (clipsCanBeValidated) {
            _.forEach(clipsCanBeValidated, function (clipCanBeValidated) {
                allClipsCanBeValidated = allClipsCanBeValidated && clipCanBeValidated;
            });
            self.VALIDATE_PACKAGE_ACTION.disabled = !allClipsCanBeValidated;
            return !allClipsCanBeValidated;
        });
    };
    var canResetClip = function (pkg) {
        if (self.selectedPackages.length === 1) {
            return PermissionsService.canWritePackage('CLIP_ACTION_RESET_VIEW_STATE', pkg.id);
        }
    };
    var allClipsCanBeReset = function (clipResetPermissions) {
        var allClipsCanBeReset = clipResetPermissions.length > 0;
        return $q.all(clipResetPermissions).then(function (clipsCanBeReset) {
            _.forEach(clipsCanBeReset, function (clipCanBeReset) {
                allClipsCanBeReset = allClipsCanBeReset && clipCanBeReset;
            });
            self.RESET_CLIP_PACKAGE_ACTION.disabled = !allClipsCanBeReset;
            return !allClipsCanBeReset;
        });
    };
    var allPackagesCanBeDelivered = function (deliveryPermissions) {
        var allPackagesCanBeDelivered = deliveryPermissions.length > 0;
        return $q.all(deliveryPermissions).then(function (pkgsCanBeDelivered) {
            _.forEach(pkgsCanBeDelivered, function (pkgCanBeDelivered) {
                allPackagesCanBeDelivered = allPackagesCanBeDelivered && pkgCanBeDelivered;
            });
            var actionLabelTextAppend = ' - Select Partners';
            self.DELIVER_PACKAGE_SELECT_PARTNERS_ACTION.label = (deliveryPermissions.length > 1) ?
                "Deliver Package(s) " + actionLabelTextAppend :
                "Deliver Package " + actionLabelTextAppend;
            self.DELIVER_PACKAGE_SELECT_PARTNERS_ACTION.disabled = !allPackagesCanBeDelivered;
            return !allPackagesCanBeDelivered;
        });
    };
    var hasExportMetadataPermissions = function (pkg) {
        if (self.selectedPackages.length > 0) {
            return PermissionsService.canWritePackage('CLIP_ACTION_EXPORT_METADATA_VIEW_STATE', pkg.id);
        }
    };
    var metadataReportCanBeGenerated = function (reportPermissions) {
        var hasMetadataReportPermissions = reportPermissions.length > 0;
        return $q.all(reportPermissions).then(function (metadataReportPermissions) {
            _.forEach(metadataReportPermissions, function (metadataReportPermission) {
                hasMetadataReportPermissions = hasMetadataReportPermissions && metadataReportPermission;
            });
            self.EXPORT_METADATA_REPORT_ACTION.disabled = !hasMetadataReportPermissions;
            return !hasMetadataReportPermissions;
        });
    };
    var hasDeliveryReportPermissions = function (pkg) {
        if (self.selectedPackages.length > 0) {
            return PermissionsService.canWritePackage('CLIP_ACTION_GENERATE_DELIVERY_REPORT_VIEW_STATE', pkg.id);
        }
    };
    var deliveryReportCanBeGenerated = function (reportPermissions) {
        var hasDeliveryReportPermissions = reportPermissions.length > 0;
        return $q.all(reportPermissions).then(function (deliveryReportPermissions) {
            _.forEach(deliveryReportPermissions, function (deliveryReportPermission) {
                hasDeliveryReportPermissions = hasDeliveryReportPermissions && deliveryReportPermission;
            });
            self.DELIVERY_REPORT_ACTION.disabled = !hasDeliveryReportPermissions;
            return !hasDeliveryReportPermissions;
        });
    };
    var canModifyPkgMetadata = function (pkg, editView) {
        if (!PackageUtilService.statusAllowsEdit(pkg.status) || pkg.isDelivering) {
            return $q.when(false);
        }
        return PermissionsService.canWritePackage(editView === 'notClip' ? 'PACKAGE_BATCH_MODIFY_METADATA_VIEW_STATE' : 'CLIP_ACTION_BATCH_MODIFY_METADATA_VIEW_STATE', pkg.id);
    };
    var allPackagesCanModifyMetadata = function (modifyMetdataPermissions) {
        var allPackagesCanModifyMetadata = modifyMetdataPermissions.length > 0;
        return $q.all(modifyMetdataPermissions).then(function (pkgCanModifyMetadata) {
            _.forEach(pkgCanModifyMetadata, function (canModify) {
                allPackagesCanModifyMetadata = allPackagesCanModifyMetadata && canModify;
            });
            self.BATCH_MODIFY_METADATA_ACTION.disabled = !allPackagesCanModifyMetadata;
            return !allPackagesCanModifyMetadata;
        });
    };
    var canRetrieveMasterMedia = function (pkg, editView) {
        if (editView === 'notClip') {
            if (parseInt(pkg.mediaCount) > 0 && !pkg.isDelivering) {
                return PermissionsService.canWritePackage('PACKAGE_RESTORE_MASTER_MEDIA_VIEW_STATE', pkg.id).then(function (hasPermission) {
                    return $q.when(hasPermission);
                });
            }
            else {
                return $q.when(false);
            }
        }
        else if (editView === 'clip') {
            if (pkg.primaryVideo && pkg.primaryImage && !pkg.isDelivering) {
                return PermissionsService.canWritePackage('CLIP_ACTION_RETRIEVE_MASTER_MEDIA_VIEW_STATE', pkg.id).then(function (hasPermission) {
                    return $q.when(hasPermission);
                });
            }
            else {
                return $q.when(false);
            }
        }
    };
    var allPackagesCanRetrieveMedia = function (retrieveMediaPermissions) {
        var allPackagesCanRetrieveMedia = self.selectedPackages.length > 0;
        return $q.all(retrieveMediaPermissions).then(function (pkgCanRetrieveMedia) {
            _.forEach(pkgCanRetrieveMedia, function (canRetrieve) {
                allPackagesCanRetrieveMedia = allPackagesCanRetrieveMedia && canRetrieve;
            });
            self.RETRIEVE_MASTER_MEDIA_ACTION.disabled = !allPackagesCanRetrieveMedia;
            return !allPackagesCanRetrieveMedia;
        });
    };
    var enableClipActions = function () {
        var hasSelectedClips = self.selectedPackages.length > 0;
        self.VALIDATE_PACKAGE_ACTION.disabled = !hasSelectedClips;
        self.RESET_PACKAGE_ACTION.disabled = !hasSelectedClips;
        var allValidated = allClipsCanBeValidated(self.clipPermissions.validatePermissions);
        var allDelivered = allPackagesCanBeDelivered(self.clipPermissions.deliverClipPermissions);
        var allMedia = allPackagesCanRetrieveMedia(self.clipPermissions.retrieveClipMediaPermission);
        var allModifyMetadata = allPackagesCanModifyMetadata(self.clipPermissions.clipBatchModifyPermission);
        var allMetadataReport = metadataReportCanBeGenerated(self.clipPermissions.clipMetadataReportPermission);
        var allReset = allClipsCanBeReset(self.clipPermissions.clipResetPermissions);
        var allDeliveryReport = deliveryReportCanBeGenerated(self.clipPermissions.clipDeliveryReportPermission);
        return $q.all([allValidated, allDelivered, allMedia, allModifyMetadata, allMetadataReport, allReset, allDeliveryReport]);
    };
    var packageCanBeDelivered = function (pkg, isEditView, editView) {
        if (!PackageUtilService.packageCanBeDelivered(pkg) || pkg.isDelivering) {
            return $q.when(false);
        }
        else {
            if (editView === 'notClip') {
                return PermissionsService.canWritePackage((isEditView) ? 'PACKAGE_DELIVER_VIEW_STATE' : 'PACKAGE_MANAGER_DELIVER_VIEW_STATE', pkg.id);
            }
            else if (editView === 'clip') {
                return PermissionsService.canWritePackage('CLIP_ACTION_DELIVER_VIEW_STATE', pkg.id);
            }
        }
    };
    var canRemovePackageMedia = function () {
        // disabled by default
        self.REMOVE_PACKAGE_MEDIA_ACTION.disabled = true;
        var mediaTabActive = $route.current.params.editView === 'media';
        var singlePackageSelected = _.size(self.selectedPackages) === 1;
        if (mediaTabActive && singlePackageSelected) {
            var pkg_1 = _.first(self.selectedPackages);
            PermissionsService.canWritePackage('PACKAGE_MEDIA_VIEW_STATE', pkg_1.id).then(function (canWrite) {
                var packageStatus = _.get(pkg_1, 'status', null);
                var statusAllowsEdit = PackageUtilService.statusAllowsEdit(packageStatus);
                var packageIsLocked = _.get(pkg_1, 'locked');
                var packageIsDelivering = _.get(pkg_1, 'isDelivering');
                var packageMediaRemovalIsAllowed = (canWrite &&
                    packageStatus !== null &&
                    statusAllowsEdit &&
                    !packageIsLocked &&
                    !packageIsDelivering);
                self.REMOVE_PACKAGE_MEDIA_ACTION.disabled = !packageMediaRemovalIsAllowed;
            });
        }
    };
    var canDownloadPackageProxies = function () {
        self.DOWNLOAD_PROXIES_ACTION.disabled = false;
        // get proxy download permissions for each package
        var packagePermissionPromises = {};
        _.forEach(self.selectedPackages, function (packageObject) {
            packagePermissionPromises[packageObject.id] = PermissionsService.getPackagePermissions('PACKAGE_VIEW_DOWNLOAD_PROXY_VIEW_STATE', packageObject.id);
        });
        $q.all(packagePermissionPromises).then(function (packagePermissionData) {
            // determine whether proxies exist for each package
            var canDownloadAllProxies = true;
            _.forEach(self.selectedPackages, function (packageObject) {
                canDownloadAllProxies = canDownloadAllProxies &&
                    _.has(packageObject, 'primaryVideo.proxyId') &&
                    PermissionsService.hasWritePermission(_.get(packagePermissionData[packageObject.id], '[0].permission'));
            });
            self.DOWNLOAD_PROXIES_ACTION.disabled = !canDownloadAllProxies;
        });
    };
    var checkPackagesToEnableActions = function (isEditView) {
        var hasSelectedPackages = self.selectedPackages.length > 0;
        var allPackagesCanBeReset = hasSelectedPackages && PermissionsService.isAdmin();
        var deliveryPermissions = [], modifyMetadataPermissions = [], retrieveMediaPermissions = [];
        _.forEach(self.selectedPackages, function (packageObj) {
            deliveryPermissions.push(packageCanBeDelivered(packageObj, isEditView, 'notClip'));
            modifyMetadataPermissions.push(canModifyPkgMetadata(packageObj, 'notClip'));
            retrieveMediaPermissions.push(canRetrieveMasterMedia(packageObj, 'notClip'));
            allPackagesCanBeReset = allPackagesCanBeReset && PackageUtilService.statusAllowsReset(packageObj.status);
        });
        self.VALIDATE_PACKAGE_ACTION.disabled = !hasSelectedPackages;
        self.RESET_PACKAGE_ACTION.disabled = !allPackagesCanBeReset;
        var allDelivered = allPackagesCanBeDelivered(deliveryPermissions);
        var allMetadata = allPackagesCanModifyMetadata(modifyMetadataPermissions);
        var allMedia = allPackagesCanRetrieveMedia(retrieveMediaPermissions);
        return $q.all([allDelivered, allMetadata, allMedia, canRemovePackageMedia(), canDownloadPackageProxies()]);
    };
    self.checkClipPackagesToEnableActions = function () {
        self.clipPermissions.validatePermissions = [];
        self.clipPermissions.clipResetPermissions = [];
        self.clipPermissions.deliverClipPermissions = [];
        self.clipPermissions.retrieveClipMediaPermission = [];
        self.clipPermissions.clipBatchModifyPermission = [];
        self.clipPermissions.clipMetadataReportPermission = [];
        self.clipPermissions.clipDeliveryReportPermission = [];
        _.forEach(self.selectedPackages, function (packageObj) {
            self.clipPermissions.hasPermissions = true;
            self.clipPermissions.validatePermissions.push(canValidateClip(packageObj));
            self.clipPermissions.clipResetPermissions.push(canResetClip(packageObj));
            self.clipPermissions.deliverClipPermissions.push(packageCanBeDelivered(packageObj, true, 'clip'));
            self.clipPermissions.retrieveClipMediaPermission.push(canRetrieveMasterMedia(packageObj, 'clip'));
            self.clipPermissions.clipBatchModifyPermission.push(canModifyPkgMetadata(packageObj, 'clip'));
            self.clipPermissions.clipMetadataReportPermission.push(hasExportMetadataPermissions(packageObj));
            self.clipPermissions.clipDeliveryReportPermission.push(hasDeliveryReportPermissions(packageObj));
        });
        return enableClipActions();
    };
    self.handleGridItemSelection = function () {
        self.actionsLoading = true;
        resetActionsToDisabled();
        checkPackagesToEnableActions().then(function () {
            self.actionsLoading = false;
        });
    };
    self.handleEditView = function (editView) {
        if (editView === 'notClip') {
            // Package Manager
            self.actionsLoading = true;
            resetActionsToDisabled();
            checkPackagesToEnableActions(true).then(function () {
                self.actionsLoading = false;
            });
        }
        else if (editView === 'clip') {
            // Clipper Tab
            resetClipActionsToDisabled();
            if (self.clipPermissions.hasPermissions) {
                enableClipActions();
            }
        }
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by richardwilliams on 4/3/15.
 */
'use strict';
angular
    .module('prism-ui.package')
    .controller('PackageEditController', function (_, $scope, $routeParams, $q, $location, $route, PackageResourceFactory, PaginationService, PackageActionService, NotificationService, PackageUtilService, ModalService, PermissionsService, BreadcrumbService, ContentResourceFactory, PartnerPackagesService, MetadataService, EnumService, DynamicPropertiesService, TranslatableMetadataService) {
    var META_TAB_VIEW_STATE = 'PACKAGE_METADATA_VIEW_STATE';
    var COLLABORATORS_TAB_VIEW_STATE = 'PACKAGE_COLLABORATORS_VIEW_STATE';
    var MEDIA_TAB_VIEW_STATE = 'PACKAGE_MEDIA_VIEW_STATE';
    var TIMINGS_TAB_VIEW_STATE = 'PACKAGE_TIMINGS_VIEW_STATE';
    var DISTRIBUTION_TAB_VIEW_STATE = 'PACKAGE_DISTRIBUTIONGRID_VIEW_STATE';
    var ADVANCED_DISTRIBUTION_TAB_VIEW_STATE = 'ADVANCED_PACKAGE_DISTRIBUTIONGRID_VIEW_STATE';
    var PREVIEW_TAB_VIEW_STATE = 'PACKAGE_VIDEO_PREVIEW_VIEW_STATE';
    var CLIP_TABS_VIEW_STATE = 'PACKAGE_VIDEO_CLIPS_VIEW_STATE';
    var PACKAGE_ADVANCED_METADATA_VIEW_STATE = 'PACKAGE_ADVANCED_METADATA_VIEW_STATE';
    var PACKAGE_COMPLETED_DELIVERIES_VIEW_STATE = 'PACKAGE_COMPLETED_DELIVERIES_VIEW_STATE';
    var PACKAGE_EXTERNAL_INGESTS_VIEW_STATE = 'PACKAGE_EXTERNAL_INGESTS_VIEW_STATE';
    var originalPackageData;
    var self = this;
    self.permissionsMap = {};
    self.activeTabs = {
        metadata: false,
        collaborators: false,
        media: false,
        timings: false,
        distribution: false,
        advancedDistribution: false,
        preview: false,
        liveClip: false,
        advancedMetadata: false,
        completedDeliveries: false,
        aggregation: false,
    };
    self.currentViewedTab = '';
    self.validTabs = {
        metadata: false,
        collaborators: false,
        media: false,
        timings: false,
        distribution: false,
        advancedDistribution: false,
        preview: false,
        clips: false,
        advancedMetadata: false,
        completedDeliveries: false,
        aggregation: false,
    };
    BreadcrumbService.editService = PackageUtilService;
    var syncPackageValidation = function (packageObject) {
        return PartnerPackagesService.reviseInstanceValidationResults(self.packageObjectData.id, packageObject.validationResult).then(function () {
            return packageObject;
        });
    };
    var pollForPackageUpdates = function () {
        return PackageResourceFactory.get({
            id: $routeParams.id,
            view: 'STATUS'
        }).$promise
            .then(function (packageData) {
            return syncPackageValidation(packageData);
        })
            .then(function (packageData) {
            self.packageObjectData.metadataErrorCount = packageData.metadataErrorCount;
            self.packageObjectData.mediaErrorCount = packageData.mediaErrorCount;
            self.packageObjectData.status = packageData.status;
            self.packageObjectData.acceptStatus = packageData.acceptStatus;
            self.packageObjectData.validationResult = packageData.validationResult;
            self.packageObjectData.primaryVideo = packageData.primaryVideo;
            self.packageObjectData.revision = packageData.revision;
            self.packageObjectData.isDelivering = packageData.isDelivering;
            self.packageObjectData.pendingPartnerPackages = packageData.pendingPartnerPackages;
            originalPackageData.metadataErrorCount = packageData.metadataErrorCount;
            originalPackageData.mediaErrorCount = packageData.mediaErrorCount;
            originalPackageData.status = packageData.status;
            originalPackageData.acceptStatus = packageData.acceptStatus;
            originalPackageData.validationResult = packageData.validationResult;
            originalPackageData.primaryVideo = packageData.primaryVideo;
            originalPackageData.revision = packageData.revision;
            originalPackageData.isDelivering = packageData.isDelivering;
            if (self.currentViewedTab !== 'liveClip') {
                PackageActionService.selectedPackages = [self.packageObjectData];
                PackageActionService.handleEditView('notClip');
            }
        });
    };
    var showUnsavedChangesWarning = function () {
        var message = 'You have unsaved changes.  Please save or revert.';
        NotificationService.createWarningNotification(message, '');
    };
    var parseContentCategories = function (allContentCategories) {
        var categories = {};
        _.forEach(allContentCategories, function (contentCategory) {
            categories[contentCategory.category.id] = contentCategory;
        });
        return categories;
    };
    var getEditData = function (perms) {
        $q.all([
            DynamicPropertiesService.queryForProperties(),
            EnumService.queryForEnums(),
        ])
            .then(function () {
            self.packageObjectData = PackageResourceFactory.get({ id: $routeParams.id });
            return self.packageObjectData.$promise;
        })
            .then(function (data) {
            TranslatableMetadataService.setDataObject(self.packageObjectData);
            return self.packageObjectData.$promise;
        })
            .then(function (data) {
            //
            // In theory, this should never be needed.
            // Reloading a package resets all instance
            // selections to the newest instances, making
            // the package's validation result accurate.
            //
            return syncPackageValidation(data);
        })
            .then(function (data) {
            var deferred = $q.defer();
            if (data.hidden) {
                $location.url('/packages');
                NotificationService.createWarningNotification('Package is Hidden');
                deferred.reject('Package is Hidden');
            }
            else {
                originalPackageData = _.cloneDeep(data);
                PackageUtilService.createErrorsAndWarningsMap(data.validationResult);
                deferred.promise = ContentResourceFactory.get({ id: data.content.id }).$promise;
            }
            return deferred.promise;
        })
            .then(function (content) {
            self.categoryRoles = parseContentCategories(content.contentCategories);
            PackageUtilService.contentCategories(self.categoryRoles);
            // This tab needs to be set after all data is ready to prevent exceptions on data access
            self.activeTabs[$routeParams.editView] = true;
            self.currentViewedTab = $routeParams.editView;
            self.validTabs.metadata = perms.meta;
            self.validTabs.collaborators = perms.collaborators;
            self.validTabs.media = perms.media;
            self.validTabs.timings = perms.timings;
            self.validTabs.distribution = perms.distribution;
            self.validTabs.advancedDistribution = perms.advancedDistribution;
            self.validTabs.preview = perms.preview;
            self.validTabs.clips = perms.clips;
            self.validTabs.advancedMetadata = perms.advancedMetadata;
            self.validTabs.completedDeliveries = perms.completedDeliveries;
            self.validTabs.aggregation = perms.externalIngests;
            if (self.currentViewedTab !== 'liveClip') {
                PackageActionService.selectedPackages = [self.packageObjectData];
                PackageActionService.handleEditView('notClip');
            }
            PackageUtilService.setPollingInterval();
        });
    };
    var getPermissions = function () {
        var metaPromise = PermissionsService.canRead(META_TAB_VIEW_STATE);
        var collaboratorPromise = PermissionsService.canRead(COLLABORATORS_TAB_VIEW_STATE);
        var mediaPromise = PermissionsService.canRead(MEDIA_TAB_VIEW_STATE);
        var timingsPromise = PermissionsService.canRead(TIMINGS_TAB_VIEW_STATE);
        var distributionPromise = PermissionsService.canRead(DISTRIBUTION_TAB_VIEW_STATE);
        var advancedDistributionPromise = PermissionsService.canRead(ADVANCED_DISTRIBUTION_TAB_VIEW_STATE);
        var previewPromise = PermissionsService.canRead(PREVIEW_TAB_VIEW_STATE);
        var clipsPromise = PermissionsService.canRead(CLIP_TABS_VIEW_STATE);
        var advancedMetadataPromise = PermissionsService.canRead(PACKAGE_ADVANCED_METADATA_VIEW_STATE);
        var completedDeliveriesPromise = PermissionsService.canRead(PACKAGE_COMPLETED_DELIVERIES_VIEW_STATE);
        var externalIngestsPromise = PermissionsService.canRead(PACKAGE_EXTERNAL_INGESTS_VIEW_STATE);
        return $q.all({
            meta: metaPromise,
            collaborators: collaboratorPromise,
            media: mediaPromise,
            timings: timingsPromise,
            distribution: distributionPromise,
            advancedDistribution: advancedDistributionPromise,
            preview: previewPromise,
            clips: clipsPromise,
            advancedMetadata: advancedMetadataPromise,
            completedDeliveries: completedDeliveriesPromise,
            externalIngests: externalIngestsPromise,
        });
    };
    var hasWarnings = function () {
        for (var i = 0; i < self.packageObjectData.validationResult.length; i++) {
            var valResult = self.packageObjectData.validationResult[i];
            if (valResult.warnings && valResult.warnings.length > 0) {
                return true;
            }
        }
        return false;
    };
    self.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };
    self.pagingOptions = PaginationService;
    self.onSave = function (savePackageOnly) {
        self.loadingIndicator.show = true;
        // Stop polling until saving is complete
        PackageUtilService.cancelPollingInterval();
        var tabPromise = null;
        var packagePromise = null;
        var packageSaved = false;
        // Clones are no longer clones after being saved
        if (self.packageObjectData.clone) {
            self.packageObjectData.clone = false;
        }
        // When changing package media, clear accept/reject data
        if (self.currentViewedTab === 'media' && !savePackageOnly) {
            self.packageObjectData.acceptStatus = null;
            self.packageObjectData.rejectReason = null;
        }
        // Call pre save hooks
        TranslatableMetadataService.preSave();
        // **************************************************************** //
        // **************************************************************** //
        // **** Seriously! Always perform this action before you save  **** //
        // **** metadata items to ensure the correct data is persisted **** //
        // **************************************************************** //
        // **************************************************************** //
        if (PackageUtilService.metadataComponentsMap) {
            var cleanData = MetadataService.cleanData(self.packageObjectData, PackageUtilService.metadataComponentsMap);
            self.packageObjectData = cleanData;
        }
        if ('rating' in self.packageObjectData) {
            if (_.isEmpty(_.get(self.packageObjectData, 'rating.ratingCode'))) {
                self.packageObjectData.rating = null;
            }
        }
        // Only save when modified
        if (!angular.equals(self.packageObjectData, originalPackageData)) {
            packagePromise = self.packageObjectData.$save().then(function (packageObject) {
                return syncPackageValidation(packageObject);
            });
            packageSaved = true;
        }
        // Save "specialized" tabs
        if (PackageUtilService.tabSaveFunction &&
            !savePackageOnly &&
            self.currentViewedTab !== 'metadata' &&
            self.currentViewedTab !== 'media') {
            tabPromise = PackageUtilService.tabSaveFunction(packageSaved);
        }
        // Saves on any package tab can potentially change the
        // validation result
        var validationPromise;
        if (!packagePromise) {
            validationPromise = PackageResourceFactory.query({
                id: $routeParams.id,
                sub: 'validationResult',
            }).$promise.then(function (validationResult) {
                self.packageObjectData.validationResult = validationResult;
                return syncPackageValidation(self.packageObjectData);
            });
        }
        else {
            validationPromise = $q.when(true);
        }
        return $q.all({
            package: packagePromise,
            tabData: tabPromise,
            validationResult: validationPromise,
        })
            .then(function (results) {
            if (results.package) {
                originalPackageData = _.cloneDeep(results.package);
                self.packageObjectData = results.package;
                TranslatableMetadataService.dataObjectSaved(self.packageObjectData);
                PackageActionService.selectedPackages = [
                    self.packageObjectData
                ];
                PackageActionService.handleEditView('notClip');
            }
            if (PackageUtilService.postPackageSaveFunction && results.package) {
                PackageUtilService.postPackageSaveFunction();
            }
            if (PackageUtilService.setPristinePostSave) {
                PackageUtilService.editorForm.$setPristine();
            }
            // Restart polling interval
            PackageUtilService.setPollingInterval();
            self.loadingIndicator.show = false;
            // ABC-8573 - https://levelsbeyond.atlassian.net/browse/ABC-8573
            // Until a refactor of the package edit can be performed, ensure all package data is first
            // saved to prevent assets from being purged on ingest unintentionally.
            if (PackageUtilService.tabSaveFunction && !savePackageOnly && self.currentViewedTab === 'media') {
                PackageUtilService.tabSaveFunction();
            }
        })
            .then(function () {
        });
    };
    PackageUtilService.tabLoadDataFunction = function () {
        getPermissions();
    };
    self.onNew = function () {
        if (PackageUtilService.tabNewFunction) {
            PackageUtilService.tabNewFunction();
        }
    };
    self.onDelete = function () {
        if (PackageUtilService.tabDeleteFunction) {
            PackageUtilService.tabDeleteFunction();
        }
    };
    self.onAddDisabled = function () {
        if (PackageUtilService.tabAddDisabledFunction) {
            PackageUtilService.tabAddDisabledFunction();
        }
    };
    self.onRevert = function () {
        self.packageObjectData = _.cloneDeep(originalPackageData);
        TranslatableMetadataService.dataObjectReverted(self.packageObjectData);
        if (PackageUtilService.tabRevertFunction) {
            PackageUtilService.tabRevertFunction(self.packageObjectData);
        }
        PackageUtilService.editorForm.$setPristine();
    };
    self.onClose = function () {
        if (PackageUtilService.editorForm.$pristine) {
            PartnerPackagesService.clearInstanceSelections();
            BreadcrumbService.clearBreadcrumbs();
            $location.path('/packages');
            $location.search('pmView', 'basic');
        }
        else {
            showUnsavedChangesWarning();
        }
    };
    self.onUpload = function () {
        if (PackageUtilService.tabUploadFunction) {
            PackageUtilService.tabUploadFunction();
        }
    };
    self.onPrevPackage = function () {
        PaginationService.getPreviousItemInPage().then(function (packageData) {
            PartnerPackagesService.clearInstanceSelections();
            $route.updateParams({ id: packageData.id });
        });
    };
    self.onNextPackage = function () {
        PaginationService.getNextItemInPage().then(function (packageData) {
            PartnerPackagesService.clearInstanceSelections();
            $route.updateParams({ id: packageData.id });
        });
    };
    self.onTabSelect = function (tabName) {
        if (_.get(PackageUtilService, 'editorForm.$pristine')) {
            if (tabName === 'metadata') {
                PackageUtilService.tabSaveFunction = self.onSave;
            }
            $route.updateParams({ editView: tabName });
        }
    };
    self.onTabDeselect = function (tabName, event) {
        if (!_.get(PackageUtilService, 'editorForm.$dirty')) {
            if (tabName === 'metadata') {
                PackageUtilService.tabSaveFunction = null;
            }
            if (PackageUtilService.postCloseUpdate) {
                PackageUtilService.postCloseUpdate();
            }
        }
        else {
            event.preventDefault();
            showUnsavedChangesWarning();
        }
    };
    self.onAcceptPackage = function () {
        if (hasWarnings()) {
            ModalService.showErrorsWarningsModal(self.packageObjectData.validationResult, self.packageObjectData.name, true, self.acceptPackage);
        }
        else {
            self.acceptPackage();
        }
    };
    self.acceptPackage = function () {
        self.packageObjectData.acceptStatus = 'ACCEPTED';
        self.loadingIndicator.show = true;
        PackageResourceFactory.acceptPackage({ id: $routeParams.id }).$promise.then(function (val) {
            PackageUtilService.pollForPackageUpdates();
            self.loadingIndicator.show = false;
        });
    };
    self.onRejectPackage = function () {
        ModalService.showRejectPackageModal(self.packageObjectData.rejectReason, false, true, self.rejectPackage);
    };
    self.rejectPackage = function (rejectReason) {
        self.packageObjectData.acceptStatus = 'REJECTED';
        self.loadingIndicator.show = true;
        PackageResourceFactory.rejectPackage({
            id: $routeParams.id,
            reason: rejectReason
        }).$promise.then(function (val) {
            self.packageObjectData.rejectReason = rejectReason;
            PackageUtilService.pollForPackageUpdates();
            self.loadingIndicator.show = false;
        });
    };
    self.clonePackage = function () {
        self.loadingIndicator.show = true;
        PackageResourceFactory.clone({ id: $routeParams.id }, {}).$promise.then(function (val) {
            self.loadingIndicator.show = false;
        });
    };
    self.statusAllowsEdit = function (pkgObject) {
        if (pkgObject) {
            return PackageUtilService.statusAllowsEdit(pkgObject.status) && !pkgObject.locked &&
                !pkgObject.isDelivering;
        }
        return PackageUtilService.statusAllowsEdit(self.packageObjectData.status) &&
            !self.packageObjectData.locked && !self.packageObjectData.isDelivering;
    };
    self.checkErrorWarning = function (field, name) {
        var source = PackageUtilService.errorsAndWarnings()[name];
        return source ? source[field] : null;
    };
    // This listens to server-busy events from all package tabs.
    $scope.$on('server-busy', function (event, options) {
        self.loadingIndicator.show = options.working;
    });
    $scope.$on('$destroy', function () {
        if (self.packageObjectData && self.packageObjectData.$cancelRequest) {
            self.packageObjectData.$cancelRequest();
        }
        PackageUtilService.cancelPollingInterval();
        NotificationService.clearTimedNotifications();
    });
    getPermissions().then(function (perms) {
        getEditData(perms);
    });
    PackageUtilService.pollForPackageUpdates = pollForPackageUpdates;
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 3/27/15.
 */
'use strict';
angular.module('prism-ui.package').controller('PackageManagerController', function (_, $location, $q, $scope, uiGridConstants, BreadcrumbService, DownloadAssetService, GridService, ModalService, NavbarUtilService, NotificationService, PackageActionService, PackageManagerViewDataTransformer, PackageMediaResourceFactory, PackageResourceFactory, PaginationService, PartnerPackagesService, PermissionsService, ReportViewService, SearchFilterService) {
    var self = this;
    PartnerPackagesService.clearInstanceSelections();
    var COLUMNS_KEY_NAMES = {
        'basic': 'package#basic',
        'detailed': 'package#detailed',
        'status': 'package#status'
    };
    // View Permissions
    var PACKAGE_SEARCH_VIEW_STATE = 'PACKAGE_SEARCH_VIEW_STATE';
    var META_TAB_VIEW_STATE = 'PACKAGE_METADATA_VIEW_STATE';
    var PACKAGE_ADVANCED_METADATA_VIEW_STATE = 'PACKAGE_ADVANCED_METADATA_VIEW_STATE';
    var COLLABORATORS_TAB_VIEW_STATE = 'PACKAGE_COLLABORATORS_VIEW_STATE';
    var MEDIA_TAB_VIEW_STATE = 'PACKAGE_MEDIA_VIEW_STATE';
    var PREVIEW_TAB_VIEW_STATE = 'PACKAGE_VIDEO_PREVIEW_VIEW_STATE';
    var BATCH_CLONE_STATE = 'PACKAGE_BATCH_CLONE_VIEW_STATE';
    var CLONE_STATE = 'PACKAGE_CLONE_VIEW_STATE';
    var CLIP_TABS_VIEW_STATE = 'PACKAGE_VIDEO_CLIPS_VIEW_STATE';
    var parentPackageChildren = {};
    self.pmPerms = {
        read: false,
        write: false,
        clone: {
            read: false,
            write: false,
            batch: {
                write: false
            }
        },
        preview: {
            read: false
        }
    };
    var editView = ''; //Set upon permissions evaluation
    self.actionsEnabled = false;
    self.includeArchived = false;
    self.unhideInvalid = self.hideInvalid = true;
    var enableHideUnhide = function () {
        var archivedFound = false;
        var unarchivedFound = false;
        if (self.selectedPackages.length === 0 || !self.pmPerms.write) {
            self.hideInvalid = self.unhideInvalid = true;
            return;
        }
        for (var idx in self.selectedPackages) {
            var pkg = self.selectedPackages[idx];
            if (pkg.hidden) {
                archivedFound = true;
            }
            else {
                unarchivedFound = true;
            }
            if (unarchivedFound && archivedFound) {
                self.hideInvalid = self.unhideInvalid = true;
                return;
            }
        }
        if (unarchivedFound) {
            self.unhideInvalid = true;
            self.hideInvalid = false;
        }
        else {
            self.unhideInvalid = false;
            self.hideInvalid = true;
        }
    };
    var enableClone = function () {
        var length = self.selectedPackages.length;
        self.canClone = (length >= 1 && self.pmPerms.clone.batch.write) || (self.pmPerms.clone.write && length === 1);
    };
    var enableActions = function () {
        var enable = !!self.selectedPackages.length;
        angular.forEach(self.selectedPackages, function (pkg) {
            if (pkg.locked) {
                enable = false;
            }
        });
        self.actionsEnabled = enable;
    };
    var enableToolbarItems = function () {
        enableHideUnhide();
        enableClone();
        enableActions();
    };
    var updateToolbarAndResetActions = function () {
        PackageActionService.handleGridItemSelection();
        enableToolbarItems();
    };
    self.gridRowBatchSelectionChangedHandler = function (rows) {
        self.selectedPackages = _.concat(self.selectedPackages, _.map(rows, 'entity'));
        PackageActionService.selectedPackages = self.selectedPackages;
        updateToolbarAndResetActions();
    };
    self.gridRowSelectionChangedHandler = function (row) {
        if (row.isSelected) {
            self.selectedPackages.push(row.entity);
        }
        else {
            var index = self.selectedPackages.indexOf(row.entity);
            self.selectedPackages.splice(index, 1);
        }
        PackageActionService.selectedPackages = self.selectedPackages;
        updateToolbarAndResetActions();
    };
    var getPackageEditIndex = function (packageObj) {
        var collection = self.currentGridOptions.data;
        var item;
        for (var i = 0; i < collection.length; i++) {
            item = collection[i];
            if (item.id === packageObj.id) {
                return i;
            }
        }
        return -1;
    };
    var openPackageEdit = function (packageToEdit) {
        if (packageToEdit.hidden) {
            NotificationService.createWarningNotification('Package is Hidden');
        }
        else {
            PaginationService.currentPageItemIndex = getPackageEditIndex(packageToEdit);
            BreadcrumbService.addBreadcrumb({
                location: '/packages',
                name: 'Packages - Edit',
                params: angular.copy($location.search())
            });
            if (packageToEdit.parentPackageId && editView !== '' && !packageToEdit.locked) {
                $location.url('/packages/package/edit/' + packageToEdit.parentPackageId + '/liveClip/');
                $location.search({ livePackageId: packageToEdit.id });
            }
            else if (editView !== '') {
                $location.url('/packages/package/edit/' + packageToEdit.id + '/' + editView);
            }
        }
    };
    var newPackageCallback = function (newPackages) {
        var deffered = $q.defer();
        var promise;
        // If we are on page one, no need to query for grid data.
        if (self.pagingOptions.currentPage === 1) {
            newPackages.sort(function (a, b) {
                return Date.parse(b.dateCreated) - Date.parse(a.dateCreated);
            });
            var newData = newPackages.concat(self.currentGridOptions.data).slice(0, self.pagingOptions.pageSize);
            self.currentGridOptions.data = newData;
            self.pagingOptions.pageData = newData;
            deffered.resolve(newData);
            promise = deffered.promise;
        }
        else {
            // Need to make sure the retrieved data is for page one if we are entering a package on creation
            if (newPackages.length === 1) {
                self.pagingOptions.currentPage = 1;
            }
            promise = self.queryForGridData();
        }
        promise.then(function () {
            if (newPackages.length === 1 && !newPackages[0].clone) {
                openPackageEdit(newPackages[0]);
            }
            $scope.$broadcast('server-busy', { working: false });
        });
    };
    self.populateNewPackages = function (newPackageObjData) {
        $scope.$broadcast('server-busy', { working: true });
        var newPackages = [];
        newPackages.push(PackageResourceFactory.save(newPackageObjData.package).$promise);
        for (var i = 2; i <= newPackageObjData.numPackages; i++) {
            var newPackageCopy = {
                name: newPackageObjData.package.name + ' (' + (i - 1) + ')',
                content: newPackageObjData.package.content,
                categoryType: newPackageObjData.package.categoryType,
                purgeOnIngest: true,
                autoDeliver: true
            };
            newPackages.push(PackageResourceFactory.save(newPackageCopy).$promise);
        }
        $q.all(newPackages).then(function (newPackageData) {
            newPackageCallback(newPackageData);
        });
    };
    self.showActionsLoading = PackageActionService.actionsLoading;
    self.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };
    self.showNewPackageModal = function () {
        ModalService.showNewPackageModal(self.populateNewPackages);
    };
    $scope.$on('server-busy', function (event, options) {
        self.loadingIndicator.show = options.working;
    });
    function getColumnsKeyName() {
        return COLUMNS_KEY_NAMES[self.currentView];
    }
    self.handleSortColumnChange = function (grid, sortColumns) {
        if (_.size(sortColumns) > 0) {
            if (_.size(sortColumns) > 1 && SearchFilterService.searchCriteria.sortProperty) {
                var prevSortColumn = _.remove(sortColumns, function (column) {
                    return (column.colDef.sortField === SearchFilterService.searchCriteria.sortProperty ||
                        column.field === SearchFilterService.searchCriteria.sortProperty);
                })[0];
                prevSortColumn.unsort();
            }
            SearchFilterService.searchCriteria.sortProperty = sortColumns[0].colDef.sortField || sortColumns[0].field;
            SearchFilterService.searchCriteria.sortDescending = sortColumns[0].sort.direction === uiGridConstants.DESC;
        }
        else {
            delete SearchFilterService.searchCriteria.sortProperty;
            delete SearchFilterService.searchCriteria.sortDescending;
        }
        self.queryForGridData();
    };
    self.defaultGridOptions = {
        selectionRowHeaderColName: 'checkMarkRowHeaderCol',
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        rowHeight: 26,
        multiSelect: true,
        useExternalSorting: true,
        columnDefs: PackageManagerViewDataTransformer.basicColumns,
        rowTemplate: '<div ng-dblclick="grid.appScope.searchController.rowDoubleClicked(row)" ' +
            'ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ' +
            'ng-class="row.entity.hidden ? \'ui-grid-cell-hidden\' : \'\'" class="ui-grid-cell" ui-grid-cell> ' +
            '</div>',
        onRegisterApi: function (gridApi) {
            self.gridApi = gridApi;
            GridService.manageSavedColumns($scope, self.gridApi, getColumnsKeyName);
            gridApi.selection.on.rowSelectionChanged($scope, self.gridRowSelectionChangedHandler);
            gridApi.selection.on.rowSelectionChangedBatch($scope, self.gridRowBatchSelectionChangedHandler);
            gridApi.core.on.sortChanged($scope, self.handleSortColumnChange);
        }
    };
    self.toggleRows = function (evt) {
        if (self.gridApi.selection.selectAll) {
            self.gridApi.selection.clearSelectedRows(evt);
            self.gridApi.selection.selectAll = false;
        }
        else {
            self.gridApi.selection.selectAllVisibleRows(evt);
            self.gridApi.selection.selectAll = true;
        }
        self.selectedPackages = self.gridApi.selection.getSelectedRows();
        PackageActionService.selectedPackages = self.selectedPackages;
        PackageActionService.handleGridItemSelection();
        enableToolbarItems();
    };
    self.selectedPackages = [];
    self.actions = PackageActionService.actions;
    var showLoadingIndicator = function () {
        $scope.$emit('server-busy', { working: true });
    };
    var hideLoadingIndicator = function () {
        $scope.$emit('server-busy', { working: false });
    };
    self.handleSelectedAction = function () {
        PackageActionService.handleSelectedAction(self.selectedAction, showLoadingIndicator, hideLoadingIndicator);
        self.selectedAction = null;
    };
    self.pagingOptions = PaginationService;
    self.currentPageSize = self.pagingOptions.pageSize; //Need to hold local reference in order to modify to include clip packages
    PaginationService.pageDataResource = PackageResourceFactory;
    self.currentGridOptions = self.defaultGridOptions;
    self.currentView = 'basic';
    var indexColumnWidth = function () {
        return ((self.pagingOptions.pageSize * self.pagingOptions.currentPage) + '').length * 9 + 10;
    };
    var handleGridDataQuery = function (gridData, responseHeaders) {
        self.parseResponseHeaders(responseHeaders);
        PaginationService.pageData = gridData;
        self.currentPageSize = gridData.length;
        if ($location.search().hasOwnProperty('pmView') && $location.search().pmView === 'detailed') {
            angular.forEach(gridData, function (item) {
                var media = {
                    video: [],
                    image: [],
                    cc: [],
                    subtitle: [],
                    adpod: [],
                    audio: [],
                    videocomponentmaster: []
                };
                PackageResourceFactory.query({
                    id: item.id,
                    sub: 'media'
                }, function (mediaData) {
                    angular.forEach(mediaData, function (mediaObj) {
                        media[mediaObj.type.toLowerCase()].push(mediaObj);
                        if (mediaObj.type.toLowerCase() === 'video' && mediaObj.role.isDefault) {
                            item.burnedInSubtitles = PackageManagerViewDataTransformer.generateBurnedInSubtitleLanguageString(mediaObj);
                            item.narrativeBurnedInText = PackageManagerViewDataTransformer.generateNarrativeBurnedInTextLanguageString(mediaObj);
                            item.recapEndingTimecode = mediaObj.recapEndingTimecode;
                            item.recapEndingTimecodeClean = (mediaObj.recapEndingTimecodeClean) ? 'YES' : '';
                        }
                    });
                    item.ccLanguageRole = PackageManagerViewDataTransformer.generateLanguageRoleString(media.cc);
                    item.subtitleLanguageRole = PackageManagerViewDataTransformer.generateLanguageRoleString(media.subtitle);
                    item.audioLanguageRole = PackageManagerViewDataTransformer.generateLanguageRoleString(media.audio);
                    item.availableComponentRoles = PackageManagerViewDataTransformer.generateAvailableComponentString(media.video);
                    $scope.$broadcast('server-busy', { working: false });
                });
            });
        }
        else {
            $scope.$broadcast('server-busy', { working: false });
        }
        // [1] = package index column
        if (self.gridApi) {
            self.gridApi.grid.columns[1].width = indexColumnWidth();
            GridService.saveCurrentColumns(self.gridApi, getColumnsKeyName);
        }
        else {
            self.currentGridOptions.columnDefs[1].width = indexColumnWidth();
        }
        //
        // packageIndexBase is used for calculating the row
        // numbers shown on the package manager grid.
        //
        // We buffer this value so that the row numbers don't
        // recalculate as the user is typing a page number
        // into the pagination controls.
        //
        self.packageIndexBase = self.pagingOptions.currentPage;
    };
    self.queryForGridData = function () {
        if (!self.pmPerms.read) {
            return;
        }
        $scope.$broadcast('server-busy', { working: true });
        var offset = self.pagingOptions.pageSize * (self.pagingOptions.currentPage - 1);
        self.selectedPackages = [];
        PackageActionService.selectedPackages = [];
        PackageActionService.handleGridItemSelection();
        enableToolbarItems();
        var queryOpts = {
            fetchOffset: offset,
            fetchLimit: self.pagingOptions.pageSize,
            includeHidden: self.includeArchived
        };
        angular.extend(queryOpts, SearchFilterService.searchCriteria);
        self.currentGridOptions.data = (SearchFilterService.isSearchFilterApplied() || SearchFilterService.searchCriteria.sortProperty) ?
            PackageResourceFactory.executeSearchFilter({}, queryOpts, handleGridDataQuery) :
            PackageResourceFactory.query(queryOpts, handleGridDataQuery);
        return self.currentGridOptions.data.$promise;
    };
    self.parseResponseHeaders = function (responseHeaders) {
        var headers = responseHeaders();
        var contentRange = headers['content-range'];
        if (contentRange) {
            var contentTotal = parseInt(contentRange.split('/')[1]);
            self.pagingOptions.contentTotal = contentTotal;
            self.pagingOptions.totalPages = Math.ceil(contentTotal / self.pagingOptions.pageSize);
            self.pagingOptions.totalPagesArray = [].constructor(self.pagingOptions.totalPages);
        }
    };
    self.paginationPrevPageHandler = function () {
        --self.pagingOptions.currentPage;
        self.onPaginationChanged();
    };
    self.paginationNextPageHandler = function () {
        ++self.pagingOptions.currentPage;
        self.onPaginationChanged();
    };
    self.paginationJumpToPageHandler = function () {
        self.onPaginationChanged();
    };
    self.rowDoubleClicked = function (row) {
        openPackageEdit(row.entity);
    };
    self.viewQCNotes = function (row) {
        self.packageMediaQuery = PackageMediaResourceFactory.get({
            id: row.id
        }, function (mediaData) {
            ModalService.showPackageQCNotesModal(mediaData.reverse());
        });
    };
    self.toggleClipPackages = function (parentPackage, event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        parentPackage.expanded = !parentPackage.expanded;
        var parentDataIndex = self.currentGridOptions.data.indexOf(parentPackage);
        if (parentPackage.expanded) {
            PackageResourceFactory.getClips({ id: parentPackage.id, includeHidden: self.includeArchived }).$promise.then(function (clips) {
                parentPackageChildren[parentPackage.id] = clips;
                self.currentGridOptions.data.splice.apply(self.currentGridOptions.data, [parentDataIndex + 1, 0].concat(clips));
                self.currentPageSize += clips.length;
            });
        }
        else {
            self.currentPageSize -= parentPackageChildren[parentPackage.id].length;
            self.currentGridOptions.data.splice(parentDataIndex + 1, parentPackageChildren[parentPackage.id].length);
            parentPackageChildren[parentPackage.id] = null;
        }
    };
    self.onPaginationChanged = function () {
        self.queryForGridData();
    };
    self.openSelectedPackage = function () {
        openPackageEdit(self.selectedPackages[0]);
    };
    $scope.$watch(function () {
        return self.pagingOptions.pageSize;
    }, function (newValue, oldValue) {
        if (newValue !== oldValue) {
            self.currentPageSize = newValue;
            self.onPaginationChanged();
        }
    });
    self.switchView = function (currView) {
        self.currentView = currView;
        switch (currView) {
            case 'detailed':
                self.currentGridOptions.columnDefs = PackageManagerViewDataTransformer.detailedColumns;
                break;
            case 'status':
                self.currentGridOptions.columnDefs = PackageManagerViewDataTransformer.statusColumns;
                break;
            default:
                self.currentGridOptions.columnDefs = PackageManagerViewDataTransformer.basicColumns;
                self.currentView = 'basic';
        }
        if (self.gridApi) {
            GridService.loadSavedColumns(self.gridApi, getColumnsKeyName);
        }
    };
    self.cloneSelectedPackages = function () {
        $scope.$broadcast('server-busy', { working: true });
        var clonePromises = [];
        angular.forEach(self.selectedPackages, function (packageObj) {
            var clone = PackageResourceFactory.clone({ id: packageObj.id }, {}).$promise;
            clonePromises.push(clone);
        });
        $q.all(clonePromises).then(function (clones) {
            newPackageCallback(clones);
            $scope.$broadcast('server-busy', { working: false });
        });
    };
    self.toggleArchiveFlag = function () {
        self.unhideInvalid = self.hideInvalid = true;
        $scope.$broadcast('server-busy', { working: true });
        var promises = [];
        angular.forEach(self.selectedPackages, function (packageObj) {
            var pkg = PackageResourceFactory.toggleArchive({ id: packageObj.id }).$promise;
            promises.push(pkg);
        });
        $q.all(promises).then(function (pkgs) {
            self.queryForGridData();
        });
    };
    self.hideMessage = 'Are you sure you want to hide ';
    self.unhideMessage = 'Are you sure you want to unhide ';
    self.cloneMessage = 'Are you sure you want to clone ';
    self.openConfirmModal = function (messageText, title, handler) {
        if (self.selectedPackages.length === 1) {
            messageText += self.selectedPackages[0].name + '?';
            title += self.selectedPackages[0].name + '?';
        }
        else {
            messageText += 'these items?';
            title += 'items?';
        }
        ModalService.showMessageModal({
            messageText: messageText,
            pullCancelLeft: true,
            title: title,
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, handler);
    };
    $scope.$watch(function () {
        return $location.search().pmView;
    }, function (newView) {
        if (newView) {
            self.switchView(newView);
        }
    });
    var getPackagePermissions = function () {
        var packageSearchRead = PermissionsService.canRead(PACKAGE_SEARCH_VIEW_STATE);
        var packageSearchWrite = PermissionsService.canWrite(PACKAGE_SEARCH_VIEW_STATE);
        var metaPromise = PermissionsService.canRead(META_TAB_VIEW_STATE);
        var collaboratorPromise = PermissionsService.canRead(COLLABORATORS_TAB_VIEW_STATE);
        var mediaPromise = PermissionsService.canRead(MEDIA_TAB_VIEW_STATE);
        var hierarchicalPromise = PermissionsService.canRead(PACKAGE_ADVANCED_METADATA_VIEW_STATE);
        var previewPromise = PermissionsService.canRead(PREVIEW_TAB_VIEW_STATE);
        var clipsPromise = PermissionsService.canRead(CLIP_TABS_VIEW_STATE);
        var clonePromise = PermissionsService.canWrite(CLONE_STATE);
        var cloneReadPromise = PermissionsService.canRead(CLONE_STATE);
        var batchClonePromise = PermissionsService.canWrite(BATCH_CLONE_STATE);
        var batchCloneReadPromise = PermissionsService.canRead(BATCH_CLONE_STATE);
        $q.all({
            searchRead: packageSearchRead,
            searchWrite: packageSearchWrite,
            meta: metaPromise,
            collaborators: collaboratorPromise,
            media: mediaPromise,
            preview: previewPromise,
            clips: clipsPromise,
            hierarchical: hierarchicalPromise,
            clone: clonePromise,
            cloneRead: cloneReadPromise,
            batchClone: batchClonePromise,
            batchCloneRead: batchCloneReadPromise
        }).then(function (perms) {
            if (perms.meta) {
                editView = 'metadata';
            }
            else if (perms.collaborators) {
                editView = 'collaborators';
            }
            else if (perms.media) {
                editView = 'media';
            }
            else if (perms.preview) {
                editView = 'preview';
            }
            else if (perms.clips) {
                editView = 'liveClip';
            }
            else if (perms.hierarchical) {
                editView = 'hierarchicalMeta';
            }
            self.pmPerms.read = perms.searchRead;
            self.pmPerms.write = perms.searchWrite;
            self.pmPerms.clone.read = perms.cloneRead || perms.batchCloneRead;
            self.pmPerms.clone.write = perms.clone;
            self.pmPerms.clone.batch.write = perms.batchClone;
            self.pmPerms.preview.read = perms.preview;
            self.queryForGridData();
        });
    };
    NavbarUtilService.viewSearchFunction = function (searchText, forceRefresh) {
        if (forceRefresh) {
            self.pagingOptions.currentPage = 1;
        }
        self.queryForGridData();
    };
    var handleSearchFilterModalApply = function () {
        self.pagingOptions.currentPage = 1;
        SearchFilterService.updateLocationSearch();
        self.queryForGridData();
    };
    var handleSearchFilterModalCancel = function (cancelMessage) {
        if (cancelMessage === 'setToDefaults') {
            self.pagingOptions.currentPage = 1;
            SearchFilterService.resetCriteriaToDefault();
            self.queryForGridData();
        }
    };
    NavbarUtilService.viewFilterBtnHandler = function () {
        ModalService.showPMSearchFilterModal(handleSearchFilterModalApply, handleSearchFilterModalCancel);
    };
    NavbarUtilService.viewReportButtonHandlers.deliveryReport = function () {
        ModalService.showCreateReportModal(ReportViewService.availableReports[0], function (reportOptions) {
            reportOptions.filterCriteria = SearchFilterService.searchCriteria;
            ReportViewService.startReportWorkflow(ReportViewService.availableReports[0], reportOptions);
        });
    };
    NavbarUtilService.viewReportButtonHandlers.packageReport = function () {
        ModalService.showCreateReportModal(ReportViewService.PACKAGE_REPORT, function (reportOptions) {
            reportOptions.filterCriteria = SearchFilterService.searchCriteria;
            ReportViewService.startReportWorkflow(ReportViewService.PACKAGE_REPORT, reportOptions);
        });
    };
    NavbarUtilService.viewReportButtonHandlers.packageMetadataReport = function () {
        ModalService.showCreateReportModal(ReportViewService.PACKAGE_ALL_METADATA_REPORT, function (reportOptions) {
            reportOptions.filterCriteria = SearchFilterService.searchCriteria;
            ReportViewService.startReportWorkflow(ReportViewService.PACKAGE_ALL_METADATA_REPORT, reportOptions);
        });
    };
    NavbarUtilService.viewReportButtonHandlers.packageMediaReport = function () {
        ModalService.showCreateReportModal(ReportViewService.PACKAGE_MEDIA_REPORT, function (reportOptions) {
            reportOptions.filterCriteria = SearchFilterService.searchCriteria;
            ReportViewService.startReportWorkflow(ReportViewService.PACKAGE_MEDIA_REPORT, reportOptions);
        });
    };
    NavbarUtilService.viewReportButtonHandlers.packageAuditLevelReport = function () {
        ModalService.showCreateReportModal(ReportViewService.PACKAGE_AUDIT_LEVEL_REPORT, function (reportOptions) {
            reportOptions.filterCriteria = SearchFilterService.searchCriteria;
            ReportViewService.startReportWorkflow(ReportViewService.PACKAGE_AUDIT_LEVEL_REPORT, reportOptions);
        }, true);
    };
    $scope.$on('$destroy', function () {
        NavbarUtilService.viewSearchFunction = null;
        NavbarUtilService.viewFilterBtnHandler = null;
        NavbarUtilService.viewReportButtonHandlers = {
            deliveryReport: null,
            packageMediaReport: null,
            packageReport: null,
            packageMetadataReport: null
        };
    });
    $scope.$watch(function () {
        return PackageActionService.actionsLoading;
    }, function () {
        self.showActionsLoading = PackageActionService.actionsLoading;
    });
    SearchFilterService.populateCriteriaFromLocationSearch();
    getPackagePermissions();
    self.openVideoModal = function (video) {
        if (self.pmPerms.preview.read) {
            self.loadingIndicator.show = true;
            DownloadAssetService.getAssetUri(video.assetId, DownloadAssetService.AssetType.Video, DownloadAssetService.ContentUse.Proxy).then(function (proxyUriInfo) {
                video.mediaPath = proxyUriInfo.uri;
                ModalService.showMediaModal('video', video);
            }).finally(function () {
                self.loadingIndicator.show = false;
            });
        }
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 3/27/15.
 */
'use strict';
angular.module('prism-ui.package').directive('packageManager', function () {
    return {
        restrict: 'E',
        controller: 'PackageManagerController',
        controllerAs: 'searchController',
        templateUrl: 'package/manager/packagemanager-template.html',
        scope: {}
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 4/30/15.
 */
'use strict';
angular.module('prism-ui.package').factory('PackageManagerViewDataTransformer', function () {
    return {
        basicColumns: [
            {
                name: 'checkMarkRowHeaderCol',
                field: 'checkMark',
                width: 30,
                enableColumnMenu: false,
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'components/visual/grid/check-mark-template.html',
                headerCellTemplate: 'components/visual/grid/header-check-mark-template.html'
            },
            {
                field: 'index',
                name: 'indexColumn',
                displayName: '',
                width: 50,
                enableColumnMenu: false,
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'package/manager/gridTemplates/index-column-template.html'
            },
            {
                field: 'deliveryIcon',
                enableColumnMenu: false,
                name: 'deliveredIcon',
                displayName: '',
                width: 30,
                minWidth: 30,
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'package/manager/gridTemplates/delivery-icon-template.html'
            },
            {
                field: 'playIcon',
                enableColumnMenu: false,
                name: 'playIconColumn',
                displayName: '',
                width: 30,
                minWidth: 30,
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'package/manager/gridTemplates/play-icon-template.html'
            },
            {
                field: 'clipIcon',
                enableColumnMenu: false,
                name: 'clipIconColumn',
                displayName: '',
                width: 30,
                minWidth: 30,
                enableColumnResizing: false,
                enableSorting: false,
                cellTemplate: 'package/manager/gridTemplates/clip-icon-template.html'
            },
            {
                field: 'videoComponentCount',
                enableColumnMenu: false,
                name: 'componentIconColumn',
                displayName: '',
                width: 30,
                minWidth: 30,
                enableColumnResizing: false,
                enableSorting: false,
                cellTemplate: 'package/manager/gridTemplates/component-icon-template.html'
            },
            {
                field: 'qcIcon',
                enableColumnMenu: false,
                name: 'qcIconColumn',
                displayName: '',
                width: 30,
                minWidth: 30,
                enableColumnResizing: false,
                enableSorting: false,
                cellTemplate: 'package/manager/gridTemplates/qc-icon-template.html'
            },
            {
                field: 'name',
                name: 'Nickname',
                minWidth: 200,
                cellTemplate: 'package/manager/gridTemplates/package-nickname-expandable-template.html'
            },
            {
                field: 'content.name',
                name: 'Series/Movie/Ad',
                width: 150,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'productionNumber',
                width: 150,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'title',
                sortField: 'episodeTitle',
                minWidth: 100,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'categoryType.name',
                name: 'Category',
                width: 100,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'primaryVideo.acceptTemplateMember.acceptProfile.name',
                sortField: 'primaryAcceptTemplateMember.mediaAcceptProfile.name',
                name: 'acceptProfile',
                width: 300,
                displayName: 'Video MAP',
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'metadataErrorCount',
                name: 'Meta Valid',
                width: 100,
                enableSorting: false,
                cellTemplate: 'package/manager/gridTemplates/metadata-error-count-template.html'
            },
            {
                field: 'mediaErrorCount',
                name: 'Media Valid',
                width: 100,
                enableSorting: false,
                cellTemplate: 'package/manager/gridTemplates/media-error-count-template.html'
            },
            {
                field: 'acceptStatus',
                name: 'Approved',
                width: 125,
                enableSorting: false,
                cellTemplate: 'package/manager/gridTemplates/accept-status-template.html'
            }
        ],
        detailedColumns: [
            {
                name: 'checkMarkRowHeaderCol',
                field: 'checkMark',
                width: 30,
                enableColumnMenu: false,
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'components/visual/grid/check-mark-template.html',
                headerCellTemplate: 'components/visual/grid/header-check-mark-template.html'
            },
            {
                field: 'index',
                name: 'indexColumn',
                displayName: '',
                width: 50,
                enableColumnMenu: false,
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'package/manager/gridTemplates/index-column-template.html'
            },
            {
                field: 'deliveryIcon',
                enableColumnMenu: false,
                name: 'deliveredIcon',
                displayName: '',
                width: 30,
                minWidth: 30,
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'package/manager/gridTemplates/delivery-icon-template.html'
            },
            {
                field: 'playIcon',
                enableColumnMenu: false,
                name: 'playIconColumn',
                displayName: '',
                width: 30,
                minWidth: 30,
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'package/manager/gridTemplates/play-icon-template.html'
            },
            {
                field: 'clipIcon',
                enableColumnMenu: false,
                name: 'clipIconColumn',
                displayName: '',
                width: 30,
                minWidth: 30,
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'package/manager/gridTemplates/clip-icon-template.html'
            },
            {
                field: 'videoComponentCount',
                enableColumnMenu: false,
                name: 'componentIconColumn',
                displayName: '',
                width: 30,
                minWidth: 30,
                enableColumnResizing: false,
                enableSorting: false,
                cellTemplate: 'package/manager/gridTemplates/component-icon-template.html'
            },
            {
                field: 'qcIcon',
                enableColumnMenu: false,
                name: 'qcIconColumn',
                displayName: '',
                width: 30,
                minWidth: 30,
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'package/manager/gridTemplates/qc-icon-template.html'
            },
            {
                field: 'name',
                name: 'Nickname',
                width: 200,
                cellTemplate: 'package/manager/gridTemplates/package-nickname-expandable-template.html'
            },
            {
                field: 'id',
                name: 'ID',
                width: 100,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'content.network.name',
                name: 'Network',
                width: 150,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'content.name',
                name: 'Series/Movie/Ad',
                width: 150,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'title',
                sortField: 'episodeTitle',
                width: 100,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'season.name',
                name: 'Season',
                enableSorting: false,
                width: 100,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'volume.name',
                name: 'Volume',
                enableSorting: false,
                width: 100,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'productionNumber',
                width: 150,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'categoryType.name',
                name: 'Category',
                width: 100,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'primaryVideo.durationTimecode',
                name: 'Duration',
                width: 100,
                enableSorting: false,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'primaryVideo.acceptTemplateMember.acceptProfile.name',
                sortField: 'primaryAcceptTemplateMember.mediaAcceptProfile.name',
                name: 'acceptProfile',
                width: 300,
                displayName: 'Video MAP',
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'mediaVersion',
                name: 'Version',
                width: 125,
                enableSorting: true,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'primaryVideo.languageAndRole',
                name: 'Video Language/Role',
                width: 200,
                enableSorting: false,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'availableComponentRoles',
                name: 'Available Video Components',
                width: 200,
                enableSorting: false,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'ccLanguageRole',
                name: 'Closed Captioning',
                width: 200,
                enableSorting: false,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'subtitleLanguageRole',
                name: 'Subtitle',
                width: 200,
                enableSorting: false,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'burnedInSubtitles',
                name: 'Burned-in Subtitles',
                width: 200,
                enableSorting: false,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'narrativeBurnedInText',
                name: 'Narrative Burned-in Text',
                width: 200,
                enableSorting: false,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'recapEndingTimecode',
                name: 'Recap Ending Timecode',
                width: 200,
                enableSorting: false,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'recapEndingTimecodeClean',
                name: 'Recap Ending Timecode Clean',
                width: 100,
                enableSorting: false,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'audioLanguageRole',
                name: 'Sidecar Audio',
                width: 200,
                enableSorting: false,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'dateCreated',
                width: 250,
                cellTemplate: 'components/visual/grid/date-time-column-template.html'
            },
            {
                field: 'lastEdited',
                name: 'Date Edited',
                width: 250,
                cellTemplate: 'components/visual/grid/date-time-column-template.html'
            },
            {
                field: 'metadataErrorCount',
                name: 'Meta Valid',
                width: 100,
                enableSorting: false,
                cellTemplate: 'package/manager/gridTemplates/metadata-error-count-template.html'
            },
            {
                field: 'mediaErrorCount',
                name: 'Media Valid',
                width: 100,
                enableSorting: false,
                cellTemplate: 'package/manager/gridTemplates/media-error-count-template.html'
            },
            {
                field: 'acceptStatus',
                name: 'Approved',
                width: 125,
                enableSorting: false,
                cellTemplate: 'package/manager/gridTemplates/accept-status-template.html'
            }
        ],
        statusColumns: [
            {
                name: 'checkMarkRowHeaderCol',
                field: 'checkMark',
                width: 30,
                enableColumnMenu: false,
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'components/visual/grid/check-mark-template.html',
                headerCellTemplate: 'components/visual/grid/header-check-mark-template.html'
            },
            {
                field: 'index',
                name: 'indexColumn',
                displayName: '',
                width: 50,
                enableColumnMenu: false,
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'package/manager/gridTemplates/index-column-template.html'
            },
            {
                field: 'deliveryIcon',
                enableColumnMenu: false,
                name: 'deliveredIcon',
                displayName: '',
                width: 30,
                minWidth: 30,
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'package/manager/gridTemplates/delivery-icon-template.html'
            },
            {
                field: 'playIcon',
                enableColumnMenu: false,
                name: 'playIconColumn',
                displayName: '',
                width: 30,
                minWidth: 30,
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'package/manager/gridTemplates/play-icon-template.html'
            },
            {
                field: 'clipIcon',
                enableColumnMenu: false,
                name: 'clipIconColumn',
                displayName: '',
                width: 30,
                minWidth: 30,
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'package/manager/gridTemplates/clip-icon-template.html'
            },
            {
                field: 'videoComponentCount',
                enableColumnMenu: false,
                name: 'componentIconColumn',
                displayName: '',
                width: 30,
                minWidth: 30,
                enableColumnResizing: false,
                enableSorting: false,
                cellTemplate: 'package/manager/gridTemplates/component-icon-template.html'
            },
            {
                field: 'qcIcon',
                enableColumnMenu: false,
                name: 'qcIconColumn',
                displayName: '',
                width: 30,
                minWidth: 30,
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'package/manager/gridTemplates/qc-icon-template.html'
            },
            {
                field: 'name',
                name: 'Nickname',
                cellTemplate: 'package/manager/gridTemplates/package-nickname-expandable-template.html'
            },
            {
                field: 'status',
                name: 'Status',
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'id',
                name: 'ID',
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'content.name',
                name: 'Series/Movie/Ad',
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'title',
                sortField: 'episodeTitle',
                width: 100,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'primaryVideo.durationTimecode',
                name: 'Duration',
                enableSorting: false,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'metadataErrorCount',
                name: 'Meta Valid',
                width: 75,
                enableSorting: false,
                cellTemplate: 'package/manager/gridTemplates/metadata-error-count-template.html'
            },
            {
                field: 'mediaErrorCount',
                name: 'Media Valid',
                width: 75,
                enableSorting: false,
                cellTemplate: 'package/manager/gridTemplates/media-error-count-template.html'
            },
            {
                field: 'acceptStatus',
                name: 'Approved',
                width: 75,
                enableSorting: false,
                cellTemplate: 'package/manager/gridTemplates/accept-status-template.html'
            }
        ],
        generateLanguageRoleString: function (media) {
            var returnLabel = '';
            angular.forEach(media, function (mediaObj) {
                returnLabel += mediaObj.languageAndRole + ', ';
            });
            return returnLabel.substring(0, returnLabel.length - 2);
        },
        generateBurnedInSubtitleLanguageString: function (media) {
            var returnLabel = '';
            angular.forEach(media.burnedInSubtitles, function (burnSub) {
                returnLabel += burnSub.name + ', ';
            });
            return returnLabel.substring(0, returnLabel.length - 2);
        },
        generateNarrativeBurnedInTextLanguageString: function (media) {
            var returnLabel = '';
            angular.forEach(media.narrativeBurnedInText, function (burnNarr) {
                returnLabel += burnNarr.name + ', ';
            });
            return returnLabel.substring(0, returnLabel.length - 2);
        },
        generateAvailableComponentString: function (videoMedia) {
            var returnLabel = '', hasDefault = false;
            angular.forEach(videoMedia, function (video) {
                if (video.role.isDefault) {
                    hasDefault = true;
                }
                else if (returnLabel.indexOf(video.role.name) === -1) {
                    returnLabel += ' + ' + video.role.name;
                }
            });
            return (hasDefault) ? 'Main Video' + returnLabel : returnLabel;
        }
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: external-metadata-service
 *
 * Created by rwilliams on 10/5/17.
 */
'use strict';
angular.module('prism-ui.externalMetadata').service('ExternalMetadataService', function (_, AggregationResourceFactory, ExternalMetadataLoggingResourceFactory, UtilsService) {
    var self = this;
    self.editorForm = null;
    self.getExternalSources = function () { return AggregationResourceFactory.query().$promise; };
    self.getExternalSource = function (externalSourceId) { return AggregationResourceFactory.get({ id: externalSourceId }).$promise; };
    self.getExternalSourceType = function (externalSource) {
        if (_.has(externalSource, 'watchFolderPath')) {
            return UtilsService.externalIngestTypes.watchFolder;
        }
        else {
            return UtilsService.externalIngestTypes.jsonFeed;
        }
    };
    self.saveUpdateMetadataSource = function (requestMethod, editData) { return AggregationResourceFactory[requestMethod](editData).$promise; };
    self.runMetadataSource = function (externalSourceId, filename, externalIngestXml) {
        return AggregationResourceFactory.run({
            id: externalSourceId,
            filename: filename,
        }, externalIngestXml).$promise;
    };
    self.getExternalMetadataLogging = function (queryParams, queryHandler) { return ExternalMetadataLoggingResourceFactory.query(queryParams, queryHandler).$promise; };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 2/18/16.
 */
'use strict';
angular.module('prism-ui.livefeed').service('LiveFeedEditService', function ($routeParams, $location, $route, $q, NotificationService, BreadcrumbService, _) {
    var self = this;
    var originalData;
    var closeEditView = function () {
        BreadcrumbService.clearBreadcrumbs();
        var rootPath = $route.current.$$route.rootRoute;
        var queryParams = '';
        _.forEach(self.rootQueryParams, function (value, key) {
            queryParams += key + '=' + value;
        });
        if (!!queryParams) {
            rootPath += '?' + queryParams;
        }
        self.resetServiceData();
        $location.url(rootPath);
    };
    self.resetServiceData = function () {
        self.editData = null;
        self.editorForm = null;
        self.tabRevertFunction = null;
        self.tabSaveFunction = null;
        self.EditDataResource = null;
        self.rootQueryParams = {};
        originalData = null;
    };
    self.getEditData = function () {
        var dataReady = $q.defer();
        if ($routeParams.id > -1) {
            self.editData = self.EditDataResource.get({ id: $routeParams.id });
            self.editData.$promise.then(function (editData) {
                originalData = angular.copy(editData);
                dataReady.resolve(self.editData);
            });
        }
        else {
            self.editData = new self.EditDataResource();
            dataReady.resolve(self.editData);
        }
        return dataReady.promise;
    };
    self.revertEditData = function () {
        if (self.editData.id) {
            self.editData = angular.copy(originalData);
            self.editorForm.$setPristine();
            if (self.tabRevertFunction) {
                self.tabRevertFunction();
            }
        }
        else {
            closeEditView();
        }
    };
    self.saveEditData = function () {
        var savePromise = (self.editData.id > -1) ? self.editData.$update() : self.editData.$save();
        savePromise.then(function (contentData) {
            $route.updateParams({ id: contentData.id });
            originalData = angular.copy(contentData);
            self.editorForm.$setPristine();
            if (self.tabSaveFunction) {
                self.tabSaveFunction();
            }
        });
        return savePromise;
    };
    self.exitEdit = function () {
        if (self.editData.id && self.editorForm.$pristine) {
            closeEditView();
        }
        else {
            NotificationService.createWarningNotification('You have unsaved changes.  Please save or revert.', '');
        }
    };
    self.resetServiceData();
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 6/11/15.
 */
'use strict';
angular.module('prism-ui.components.data').filter('enumFilter', function (EnumService) {
    return function (input, enumPropKey) {
        if (input) {
            return EnumService.getEnumValue(enumPropKey, input);
        }
        return '';
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 6/11/15.
 */
'use strict';
angular.module('prism-ui.components.data').service('EnumService', function (EnumResource) {
    var self = this;
    self.EnumMap = null;
    self.enumsPromise = null;
    self.createEnumMap = function (enums) {
        self.EnumMap = {};
        angular.forEach(enums, function (enumItem) {
            var propKey = enumItem.className + '_' + enumItem.propertyName;
            self.EnumMap[propKey] = {};
            angular.forEach(enumItem.picklistItems, function (picklistItem) {
                self.EnumMap[propKey][picklistItem.id] = picklistItem.displayName;
            });
        });
    };
    self.getEnumPicklist = function (propKey) {
        if (!self.EnumMap) {
            console.error('Expected queryForEnums() call before getEnumPicklist()');
        }
        else {
            var pickListObject = self.EnumMap[propKey];
            if (pickListObject) {
                var returnVal = [];
                angular.forEach(pickListObject, function (value, key) {
                    returnVal.push({ displayName: value, id: key });
                });
                return returnVal;
            }
        }
        return propKey;
    };
    self.queryForEnums = function () {
        if (!self.enumsPromise) {
            self.enumsPromise = EnumResource.query().$promise.then(function (enums) {
                self.createEnumMap(enums);
                return self.EnumMap;
            });
        }
        return self.enumsPromise;
    };
    self.getEnumValue = function (propKey, enumKey) {
        if (!self.EnumMap) {
            console.error('Expected queryForEnums() call before getEnumValue()');
        }
        if (self.EnumMap && self.EnumMap[propKey] && self.EnumMap[propKey][enumKey]) {
            return self.EnumMap[propKey][enumKey];
        }
        return enumKey;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 1/13/16.
 */
'use strict';
angular.module('prism-ui.components.data').service('DynamicPropertiesService', function (_, $q, $window, DynamicPropertiesResourceFactory) {
    var self = this;
    self.properties = null;
    self.queryForProperties = function () {
        var deferred = $q.defer();
        if (self.properties) {
            deferred.resolve(self.properties);
        }
        else {
            DynamicPropertiesResourceFactory.query().$promise.then(function (props) {
                self.properties = _.omitBy(props, function (propValue, propName) {
                    return !self.propNameIsValid(propName) || !_.isString(propValue);
                });
                deferred.resolve(self.properties);
            });
        }
        return deferred.promise;
    };
    self.getPropValue = function (propertyName, defaultString) {
        if (self.properties && self.properties[propertyName]) {
            return self.properties[propertyName];
        }
        if (defaultString !== undefined) {
            return defaultString;
        }
        return '';
    };
    self.getPropValueAsBoolean = function (propertyName, defaultBool) {
        var strValue = self.getPropValue(propertyName);
        if (strValue) {
            return strValue.toLowerCase() === 'true';
        }
        if (defaultBool !== undefined) {
            return defaultBool;
        }
        return false;
    };
    self.getPropValueAsInt = function (propertyName, defaultInt) {
        var strValue = self.getPropValue(propertyName);
        if (strValue) {
            return parseInt(strValue);
        }
        if (defaultInt !== undefined) {
            return defaultInt;
        }
        return NaN;
    };
    self.getPropValueAsArray = function (propertyName, defaultArray) {
        var array = defaultArray;
        var strValue = self.getPropValue(propertyName);
        if (strValue) {
            try {
                array = JSON.parse(strValue);
            }
            catch (error) {
                console.log("error parsing dynamic property '" + propertyName + "' as JSON: " + error);
            }
            finally {
                if (!Array.isArray(array)) {
                    console.log("dynamic property value for '" + propertyName + "' is not an array");
                    array = defaultArray;
                }
            }
        }
        return array;
    };
    self.getPropValueAsList = function (propertyName, defaultList) {
        var strValue = self.getPropValue(propertyName);
        if (strValue) {
            return _.split(strValue, '|');
        }
        if (defaultList !== undefined) {
            return defaultList;
        }
        return [];
    };
    self.saveProperty = function (propertyName, value) {
        var _a;
        return DynamicPropertiesResourceFactory.updateProperties((_a = {},
            _a[propertyName] = value,
            _a)).$promise.then(function (results) {
            self.properties = null;
            return results;
        });
    };
    self.deleteProperty = function (propertyName) {
        return DynamicPropertiesResourceFactory.delete({
            propertyName: propertyName
        }).$promise.then(function (results) {
            self.properties = null;
            return results;
        });
    };
    //=================//
    // Property Checks //
    //=================//
    var hiddenDynamicProperties = _.get($window, '__wfcConfig.hiddenDynamicProperties', [
        'backupCayenneModel'
    ]);
    var confidentialProperties = _.get($window, '__wfcConfig.confidentialDynamicProperties', []);
    self.propNameIsValid = function (name) {
        return _.size(name) > 0 && !name.startsWith('$');
    };
    self.propIsEditable = function (name) {
        return self.propNameIsValid(name) && hiddenDynamicProperties.indexOf(name) === -1;
    };
    self.propContainsConfidentialInfo = function (name) {
        return name.match(/pass|secret|salt/i) || confidentialProperties.indexOf(name) !== -1;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components.data').service('WorkflowService', function ($q, WorkflowExecutionResourceFactory) {
    var self = this;
    self.hasWorkflowFailed = function (status) {
        return status === 'STALLED' || status === 'FAILED';
    };
    self.hasWorkflowBeenAbandoned = function (status) {
        return status === 'ABANDONED';
    };
    self.startWorkflow = function (workflowKey, workflowParameters) {
        return WorkflowExecutionResourceFactory
            .start({ id: workflowKey }, workflowParameters).$promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by randysorensen on 8/16/16.
 */
'use strict';
angular
    .module('prism-ui.components.data')
    .service('MetadataEditService', function (_, $q, MetaPropsResourceFactory, MetaGroupsResourceFactory) {
    var self = this;
    self.serviceReady = undefined;
    var rawGroups = [];
    var groupsBy;
    var groupsByOwnerClass = {};
    var getMetadataGroupsList = function (deferred) {
        MetaGroupsResourceFactory.query(function (metaGroups) {
            rawGroups = metaGroups;
            deferred.resolve(metaGroups);
        });
        return deferred.promise;
    };
    var buildLookupMaps = function (objects) {
        var by = {
            id: {},
            name: {}
        };
        angular.forEach(objects, function (object) {
            by.name[object.name] = object;
            by.id[object.id] = object;
        });
        return by;
    };
    var buildGroupOwnerClassMap = function (groups) {
        var classMap = {
            package: [],
            nonPackage: [],
            partner: []
        };
        angular.forEach(groups, function (group) {
            if (group.name.indexOf('Package') > -1 && group.name.indexOf('Partner') === -1) {
                classMap.package.push(group.name);
            }
            else if (group.name.indexOf('Partner') < 0) {
                classMap.nonPackage.push(group.name);
            }
            else if (group.name.indexOf('Package') === -1) {
                classMap.partner.push(group.name);
            }
        });
        return classMap;
    };
    var initialize = function () {
        if (self.serviceReady === undefined) {
            var groupsPromise = getMetadataGroupsList($q.defer());
            self.serviceReady = $q.defer();
            groupsPromise.then(function (rawGroupList) {
                groupsBy = buildLookupMaps(rawGroupList);
                groupsByOwnerClass = buildGroupOwnerClassMap(rawGroupList);
                self.serviceReady.resolve(true);
            });
        }
    };
    // public API
    self.getPropertyById = function (id) {
        return MetaPropsResourceFactory.get({ id: id }).$promise;
    };
    self.saveProperty = function (prop) {
        return MetaPropsResourceFactory.save(prop).$promise;
    };
    self.deleteProperty = function (prop) {
        return MetaPropsResourceFactory.delete({ id: prop.id }).$promise;
    };
    self.getGroupIdsByNames = function (names) {
        initialize();
        return self.serviceReady.promise.then(function () {
            var groupIdsByNames = [];
            _.forEach(names, function (name) {
                groupIdsByNames.push(groupsBy.name[name].id);
            });
            return groupIdsByNames;
        });
    };
    self.getGroupNamesByIds = function (ids) {
        initialize();
        return self.serviceReady.promise.then(function () {
            var groupsNamesByIds = [];
            _.forEach(ids, function (id) {
                groupsNamesByIds.push(groupsBy.id[id].name);
            });
            return groupsNamesByIds;
        });
    };
    self.getGroupList = function (ownerClass) {
        initialize();
        return self.serviceReady.promise.then(function () {
            return groupsByOwnerClass[ownerClass];
        });
    };
    self.getMetadataByGroup = function (groupName) {
        initialize();
        return self.serviceReady.promise.then(function () {
            return MetaPropsResourceFactory.query().$promise.then(function (properties) {
                return _.remove(properties, function (property) {
                    return _.includes(property.groupIds, _.get(_.get(groupsBy.name, groupName), 'id'));
                });
            });
        });
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 6/10/15.
 */
'use strict';
angular
    .module('prism-ui.components.data')
    .service('MetadataService', function (_, $q, MetaPropsResourceFactory, filterFilter, UtilsService) {
    var self = this;
    var serviceReady = $q.defer();
    var retrievedProperties = {};
    self.textListInputProps = {
        delimiter: '|',
        objectKey: 'stringValue'
    };
    self.propertiesPromise = serviceReady.promise;
    self.searchableProperties = [];
    var resultAsMap = function (resultData) {
        var propsMap = {};
        resultData.forEach(function (property) {
            propsMap[property.name] = property;
        });
        return propsMap;
    };
    var getMetadataPropertyList = function (deferred) {
        MetaPropsResourceFactory.query().$promise.then(function (metaProps) {
            deferred.resolve(metaProps);
            self.searchableProperties = filterFilter(metaProps, { searchable: true });
        });
        return deferred.promise;
    };
    self.initialize = function () {
        var propertiesPromise = getMetadataPropertyList($q.defer());
        propertiesPromise.then(function (initialProps) {
            retrievedProperties = resultAsMap(initialProps);
            serviceReady.resolve(true);
        });
    };
    self.cleanData = function (data, componentMap) {
        var newData = _.cloneDeep(data);
        _.forEach(componentMap, function (comp, key) {
            if (comp.uiControlHint === 'TextListInput') {
                newData.metadata.properties[key].value = UtilsService.arrayToString(comp.instanceData.value, self.textListInputProps.delimiter, self.textListInputProps.objectKey);
            }
        });
        return newData;
    };
    self.buildCustomComponentMap = function (metaProps, errorsAndWarnings, includeMVPD) {
        var components = {};
        _.forEach(metaProps, function (prop, propName) {
            var metaServiceComponent = self.getCustomMetadataProperty(propName);
            if (metaServiceComponent) {
                if (!metaServiceComponent.mvpd || includeMVPD) {
                    components[propName] = metaServiceComponent;
                    if (metaServiceComponent.uiControlHint === 'TextListInput') {
                        prop.value = UtilsService.stringToArray(prop.value, self.textListInputProps.delimiter, self.textListInputProps.objectKey);
                    }
                    components[propName].instanceData = prop;
                    components[propName].instanceData.errorWarning = errorsAndWarnings ? errorsAndWarnings[propName] : undefined;
                }
            }
        });
        if (includeMVPD) {
            _.forEach(components, function (component) {
                _.forEach(errorsAndWarnings, function (error, index) {
                    if (component.displayName === error) {
                        component.instanceData.required = component.uiControlHint !== 'CheckBox';
                        _.pullAt(errorsAndWarnings, index);
                    }
                });
            });
        }
        return components;
    };
    /**
     * Gets a metadata property from system set of custom properties
     *
     * @param name of the metadata property
     * @returns A metadata property with all mongodb key/values(if applicable) needed to display and save properties
     */
    self.getCustomMetadataProperty = function (name) {
        var comp = _.cloneDeep(retrievedProperties[name]);
        if (comp) {
            return comp;
        }
        serviceReady = $q.defer();
        getMetadataPropertyList($q.defer()).then(function (newProps) {
            retrievedProperties = resultAsMap(newProps);
            comp = _.cloneDeep(retrievedProperties[name]);
            serviceReady.resolve(true);
        });
        //
        // Oops! comp will be undefined until the properties are
        // resolved.
        //
        return comp;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 7/17/15.
 */
'use strict';
angular.module('prism-ui.components.data').service('PermissionsService', function ($q, loginService, PermissionsResourceFactory, UsersResourceFactory) {
    var self = this;
    var APPROVAL_VIEW_STATE = 'PACKAGE_APPROVE_REJECT_VIEW_STATE';
    var SYSTEM_OPS_STATE = 'DEBUG_SYSTEM_OPERATIONS_VIEW_STATE';
    var SYSTEM_OPS_ONLY_STATES = [
        SYSTEM_OPS_STATE,
        'PACKAGE_BATCH_MODIFY_METADATA_VIEW_STATE',
        'CLIP_ACTION_BATCH_MODIFY_METADATA_VIEW_STATE'
    ];
    var currentUserPromise = null;
    var _permissionsMap = {};
    var systemOpsPromise = null;
    self.NO_PERMISSION = 0;
    self.EXECUTE_PERMISSION = 1;
    self.WRITE_PERMISSION = 2;
    self.READ_PERMISSION = 4;
    self.isAdmin = function () {
        return loginService.isAdmin();
    };
    // loginService provides some basic information on the user: name, isAdmin, when jwt expires
    // This function provides the rest of the login information
    self.getCurrentUser = function () {
        if (!currentUserPromise) {
            currentUserPromise = UsersResourceFactory.getCurrentUser().$promise
                .catch(function () {
                currentUserPromise = null;
                return null;
            });
        }
        return currentUserPromise;
    };
    self.isExternalUser = function () {
        return self.getCurrentUser().then(function (user) {
            return !!(user && user.externalUser);
        });
    };
    self.isSystemOperator = function () {
        if (!systemOpsPromise) {
            systemOpsPromise = self.canWrite(SYSTEM_OPS_STATE);
        }
        return systemOpsPromise;
    };
    self.clearPermissions = function () {
        _permissionsMap = {};
        currentUserPromise = null;
        systemOpsPromise = null;
    };
    self.getPermissionsByParentKey = function (parentKey) {
        var deferred = $q.defer();
        PermissionsResourceFactory.get({ viewState: parentKey }).$promise.then(function (permissions) {
            var parentPermissions = {};
            angular.forEach(permissions, function (value) {
                _permissionsMap[value.viewState] = value;
                parentPermissions[value.viewState] = _permissionsMap[value.viewState];
            });
            deferred.resolve(parentPermissions);
        }, function (rejectReason) {
            deferred.reject(rejectReason);
        });
        return deferred.promise;
    };
    self.getPermissionsForViewState = function (viewStateKey) {
        var deferredCheck = $q.defer();
        if (_permissionsMap[viewStateKey]) {
            deferredCheck.resolve(_permissionsMap[viewStateKey]);
        }
        else if (SYSTEM_OPS_ONLY_STATES.indexOf(viewStateKey) === -1) {
            if (self.isAdmin()) {
                _permissionsMap[viewStateKey] = {};
                _permissionsMap[viewStateKey].viewState = viewStateKey;
                _permissionsMap[viewStateKey].permission = 7;
            }
            deferredCheck.resolve(_permissionsMap[viewStateKey]);
        }
        else if (viewStateKey !== SYSTEM_OPS_STATE) {
            self.isSystemOperator().then(function (isSystemOps) {
                return isSystemOps;
            }, function () {
                return false;
            }).then(function (isSystemOps) {
                _permissionsMap[viewStateKey] = {};
                _permissionsMap[viewStateKey].viewState = viewStateKey;
                _permissionsMap[viewStateKey].permission = (isSystemOps) ? 7 : 0;
                deferredCheck.resolve(_permissionsMap[viewStateKey]);
            });
        }
        else {
            deferredCheck.resolve(null);
        }
        return deferredCheck.promise.then(function (prevPermission) {
            if (prevPermission) {
                return prevPermission;
            }
            return PermissionsResourceFactory.get({ viewState: viewStateKey }).$promise.then(function (permissions) {
                angular.forEach(permissions, function (value) {
                    _permissionsMap[value.viewState] = value;
                });
                return _permissionsMap[viewStateKey];
            });
        });
    };
    self.getReadWritePermissions = function (viewStateKey) {
        var readPromise = self.canRead(viewStateKey);
        var writePromise = self.canWrite(viewStateKey);
        return $q.all({ read: readPromise, write: writePromise });
    };
    self.hasReadPermission = function (permission) {
        return (permission & self.READ_PERMISSION) === self.READ_PERMISSION;
    };
    self.canRead = function (viewStateKey) {
        var deferred = $q.defer();
        self.getPermissionsForViewState(viewStateKey).then(function (permissions) {
            deferred.resolve(self.hasReadPermission(permissions.permission));
        }, function (rejectReason) {
            deferred.reject(rejectReason);
        });
        return deferred.promise;
    };
    self.hasWritePermission = function (permission) {
        return (permission & self.WRITE_PERMISSION) === self.WRITE_PERMISSION;
    };
    self.canWrite = function (viewStateKey) {
        var deferred = $q.defer();
        self.getPermissionsForViewState(viewStateKey).then(function (permissions) {
            deferred.resolve(self.hasWritePermission(permissions.permission));
        }, function (rejectReason) {
            deferred.reject(rejectReason);
        });
        return deferred.promise;
    };
    self.hasExecutePermission = function (permission) {
        return (permission & self.EXECUTE_PERMISSION) === self.EXECUTE_PERMISSION;
    };
    self.canExecute = function (viewStateKey) {
        var deferred = $q.defer();
        self.getPermissionsForViewState(viewStateKey).then(function (permissions) {
            deferred.resolve(self.hasExecutePermission(permissions.permission));
        }, function (rejectReason) {
            deferred.reject(rejectReason);
        });
        return deferred.promise;
    };
    self.hasException = function (viewStateKey) {
        var deferred = $q.defer();
        self.getPermissionsForViewState(viewStateKey).then(function (permission) {
            deferred.resolve((permission.hasOwnProperty('availableAt') && permission.availableAt) ? permission.availableAt : null);
        }, function (rejectReason) {
            deferred.reject(rejectReason);
        });
        return deferred.promise;
    };
    self.exceptionApplies = function (viewStateKey) {
        var deferred = $q.defer();
        self.hasException(viewStateKey).then(function (exception) {
            if (exception) {
                var now = new Date(), exceptionTime = new Date(exception);
                deferred.resolve(now <= exceptionTime);
            }
            else {
                deferred.resolve(false);
            }
        }, function (rejectReason) {
            deferred.reject(rejectReason);
        });
        return deferred.promise;
    };
    self.hasReadWritePermission = function (permission) {
        var mask = self.READ_PERMISSION | self.WRITE_PERMISSION;
        return (permission & mask) === mask;
    };
    self.canReadWrite = function (viewStateKey) {
        var deferred = $q.defer();
        self.getPermissionsForViewState(viewStateKey).then(function (permissions) {
            deferred.resolve(self.hasReadWritePermission(permissions.permission));
        }, function (rejectReason) {
            deferred.reject(rejectReason);
        });
        return deferred.promise;
    };
    self.hasReadWriteExecutePermission = function (permission) {
        var mask = self.READ_PERMISSION | self.WRITE_PERMISSION | self.EXECUTE_PERMISSION;
        return (permission & mask) === mask;
    };
    self.canReadWriteExecute = function (viewStateKey) {
        var deferred = $q.defer();
        self.getPermissionsForViewState(viewStateKey).then(function (permissions) {
            deferred.resolve(self.hasReadWriteExecutePermission(permissions.permission));
        }, function (rejectReason) {
            deferred.reject(rejectReason);
        });
        return deferred.promise;
    };
    self.hasWriteExecutePermission = function (permission) {
        var mask = self.WRITE_PERMISSION | self.EXECUTE_PERMISSION;
        return (permission & mask) === mask;
    };
    self.canWriteExecute = function (viewStateKey) {
        return self.getPermissionsForViewState(viewStateKey).then(function (permissions) {
            return $q.when(self.hasWriteExecutePermission(permissions.permission));
        });
    };
    self.getPackagePermissions = function (viewStateKey, pkgId) {
        return PermissionsResourceFactory.get({ viewState: viewStateKey, packageId: pkgId }).$promise;
    };
    self.packageExceptionApplies = function (viewState) {
        if (viewState[0] && viewState[0].hasOwnProperty('availableAt') && viewState[0].availableAt) {
            var now = new Date(), exceptionTime = new Date(viewState[0].availableAt);
            return viewState[0].viewState === APPROVAL_VIEW_STATE ? true : now.getTime() <= exceptionTime.getTime();
        }
        else {
            return false;
        }
    };
    self.canWritePackage = function (viewStateKey, pkgId) {
        return self.getPackagePermissions(viewStateKey, pkgId).then(function (viewState) {
            return $q.when(self.hasWritePermission(viewState[0].permission) && !self.packageExceptionApplies(viewState));
        });
    };
    self.hasPackageException = function (viewStateKey, pkgId) {
        return self.getPackagePermissions(viewStateKey, pkgId).then(function (viewState) {
            return $q.when(self.packageExceptionApplies(viewState));
        });
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 7/21/15.
 */
'use strict';
angular.module('prism-ui.components.data').directive('viewstatePermission', function (PermissionsService, $compile) {
    return {
        restrict: 'A',
        terminal: true,
        compile: function (ielement) {
            ielement.removeAttr('viewstate-permission');
            return function (scope, element, attrs) {
                var canRead = false;
                var canWrite = false;
                var applyException = false;
                var viewStateKey = attrs.viewstatePermission;
                var componentsToDisable = 'dropdown-select';
                /**
                 *  Intercepts click from element and does not allow click if user does not have canWrite permission
                 */
                var clickInterceptor = function (event) {
                    event.stopImmediatePropagation();
                };
                /**
                 * Ensures that a change to the disabled attribute will not wipe out permission-based disabling.  This is
                 * useful for elements like buttons that are enabled when an item in a grid or list is selected.  This function
                 * will still keep the element disabled if the user does not have write permission.
                 */
                var ngDisabledChangeHandler = function (val) {
                    var currentVal = scope.$eval(val);
                    var disabled = (currentVal) || !canWrite || applyException;
                    element.attr('ng-disabled', disabled);
                    element.attr('disabled', disabled);
                    element.find(componentsToDisable).attr('ng-disabled', disabled);
                    element.find(componentsToDisable).attr('disabled', disabled);
                };
                /**
                 * Util PermissionsService to get read permission for the view state, then chains getting of the write
                 * permission, finally chaining determining if there is an exception.  Read Permission will determine rather
                 * or not the element will even be visible.  Write permission and an exception will disable/enable the element
                 * and also intercept the click of the element if the element has a click handler set.
                 */
                PermissionsService.canRead(viewStateKey).then(function (readPerm) {
                    canRead = readPerm;
                    if (readPerm) {
                        element.show();
                    }
                    else {
                        element.hide();
                    }
                    return PermissionsService.canWrite(viewStateKey);
                }).then(function (writePerm) {
                    canWrite = writePerm;
                    if (!attrs.disabled) {
                        if (attrs.ngDisabled) {
                            element.attr('ng-disabled', !canWrite + '||' + attrs.ngDisabled);
                        }
                        else {
                            element.attr('ng-disabled', !canWrite);
                        }
                    }
                    if (!writePerm && element.attr('ng-click') || attrs.disabled) {
                        scope.$watch(function () { return element.attr('ng-disabled'); }, ngDisabledChangeHandler);
                        element.off('click');
                        element.on('click', clickInterceptor);
                    }
                    return PermissionsService.exceptionApplies(viewStateKey);
                }).then(function (exception) {
                    applyException = exception;
                    if (!attrs.disabled) {
                        if (attrs.ngDisabled) {
                            element.attr('ng-disabled', !canWrite + '||' + exception + '||' + attrs.ngDisabled);
                        }
                        else {
                            element.attr('ng-disabled', !canWrite || exception);
                        }
                    }
                    if (exception && canWrite && element.attr('ng-click') || attrs.disabled) {
                        scope.$watch(function () { return element.attr('ng-disabled'); }, ngDisabledChangeHandler);
                        element.off('click');
                        element.on('click', clickInterceptor);
                    }
                    $compile(element)(scope);
                });
            };
        }
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components.data').factory('AcceptProfileResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.acceptProfileEndPoint, { mediaType: '@mediaType' }, {
        hideAcceptProfile: {
            method: 'DELETE',
            url: EndPointService.acceptProfileEndPoint + '/:id'
        },
        getAcceptProfile: {
            method: 'GET',
            url: EndPointService.acceptProfileEndPoint + '/:id'
        },
        cloneAcceptProfile: {
            method: 'POST',
            url: EndPointService.acceptProfileEndPoint + '/:id',
            params: {
                id: '@id'
            }
        },
        getValidators: {
            method: 'GET',
            params: {
                includeHidden: '@includeHidden'
            },
            isArray: true,
            url: EndPointService.acceptProfileEndPoint + '/:profileId/validators'
        },
        updateValidators: {
            method: 'PUT',
            isArray: true,
            url: EndPointService.acceptProfileEndPoint + '/:profileId/validators'
        },
        updateValidatorsFromMedia: {
            method: 'PUT',
            params: {
                mediaPath: '@mediaPath',
                profileId: '@profileId',
            },
            isArray: true,
            url: EndPointService.acceptProfileEndPoint + '/:profileId/validatorsFromMediaInfo'
        },
        toggleValidatorVisibility: {
            method: 'DELETE',
            url: EndPointService.acceptProfileEndPoint + '/validators/:id'
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: breakprepostroll-resource-factory.js
 *
 * Created by Phil I think
 */
'use strict';
angular
    .module('prism-ui.components')
    .factory('BreakPrePostRollResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.breakPrePostRollEndpoint + "/:containerId", {}, {
        //===============//
        // Container API //
        //===============//
        update: {
            method: 'PUT'
        },
        //================================//
        // Break Pre/post Roll Couple API //
        //================================//
        //
        // Ordinary branding asset containers have assets,
        // and accordingly the container API includes a
        // separate CRUD API for those assets.
        //
        // Break pre/post roll containers have break pre/post
        // roll coupling objects, simply known as "break
        // pre/post rolls". These coupling objects each have a
        // preroll and a postroll asset.
        //
        // Those discrete assets are managed using the
        // ordinary pre/post roll API, but API calls for
        // managing the break pre/post roll coupling objects
        // are here.
        //
        //
        // Note!
        //
        //      There's a key difference from other branding
        //      asset resources, in that there is no `/assets`
        //      endpoint path.
        //
        //      Rather, POSTing to a break pre/post roll
        //      container _itself_ creates the coupling object,
        //      while updates are handled by the
        //      `breakPrePostRolls/:breakPrePostRollId`
        //      endpoint.
        //
        createAsset: {
            // this is a synonym for the default 'save' action
            method: 'POST',
        },
        updateAsset: {
            method: 'PUT',
            url: EndPointService.breakPrePostRollEndpoint + "/breakPrePostRolls/:assetId"
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 2/16/16.
 */
'use strict';
angular.module('prism-ui.components.data').factory('CalendarsResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.calendarsEndpoint, {
        showDelivered: '@showDelivered'
    }, {
        dueDateItems: {
            method: 'GET',
            isArray: true,
            url: EndPointService.calendarsEndpoint + '/partnerDueDateCalendar'
        },
        firstLaunchItems: {
            method: 'GET',
            isArray: true,
            url: EndPointService.calendarsEndpoint + '/firstLaunchDateCalendar'
        },
        ordItems: {
            method: 'GET',
            isArray: true,
            url: EndPointService.calendarsEndpoint + '/originalReleaseDateCalendar'
        },
        liveRecordingsItems: {
            method: 'GET',
            isArray: true,
            url: EndPointService.calendarsEndpoint + '/liveRecordScheduleCalendar'
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 3/25/16.
 */
'use strict';
angular.module('prism-ui.components.data').factory('CaptionsResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.captionsEndpoint + '/:id' + '/paths', { id: '@id', packageId: '@packageId' }, {
        get: {
            method: 'GET',
            isArray: false
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components.data').factory('ClipResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.clipEndpoint + '/:id', { action: '@action' }, {
        'acceptClip': {
            method: 'PUT',
            url: EndPointService.clipEndpoint + '/:id',
            params: { id: '@id', action: 'accept' },
            isArray: false
        },
        'acceptAndDeliverClip': {
            method: 'PUT',
            url: EndPointService.clipEndpoint + '/:id',
            params: { id: '@id', action: 'accept_and_deliver' },
            isArray: false
        },
        'resetClip': {
            method: 'PUT',
            url: EndPointService.clipEndpoint + '/:id',
            params: { id: '@id', action: 'reset' },
            isArray: false
        },
        'uploadThumbnail': {
            method: 'POST',
            url: EndPointService.clipEndpoint + '/:id/images',
            params: { id: '@id' },
            isArray: false
        },
        'createDraftClip': {
            method: 'POST',
            url: EndPointService.clipEndpoint + '/:id/draftClips',
            params: {
                id: '@id',
                numberOfClips: '@numberOfClips',
                title: '@title',
                scheduleId: '@scheduleId'
            },
            isArray: true
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 6/20/16.
 */
'use strict';
angular.module('prism-ui.components.data').factory('ConditionalTemplatesResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.conditionalTemplateEndPoint + '/:id', { id: '@id' }, {
        'toggleArchive': {
            method: 'DELETE',
            url: EndPointService.conditionalTemplateEndPoint + '/:id',
            isArray: false
        },
        'clone': {
            method: 'POST',
            url: EndPointService.conditionalTemplateEndPoint + '/:id',
            isArray: false
        },
        'update': {
            method: 'PUT',
            url: EndPointService.conditionalTemplateEndPoint + '/:id',
            isArray: false
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 7/17/15.
 */
'use strict';
angular.module('prism-ui.components.data').factory('ContentResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.contentEndPoint + '/:id' + '/:sub', {
        type: '@type',
        id: '@id',
        sub: '@sub',
        categoryId: '@categoryId',
        fetchOffset: '@fetchOffset',
        fetchLimit: '@fetchLimit',
        view: '@view',
        mvpdPartnerId: '@mvpdPartnerId'
    }, {
        getPackageAcceptTemplates: {
            method: 'GET',
            url: EndPointService.contentEndPoint + "/:id/mediaProfiles",
            isArray: true
        },
        updatePackageAcceptTemplates: {
            method: 'PUT',
            url: EndPointService.contentEndPoint + "/:id/mediaProfiles",
            isArray: true
        },
        getActorsByContent: {
            method: 'GET',
            url: EndPointService.contentEndPoint + "/:id/actors",
            params: {
                seasonId: '@seasonId'
            },
            isArray: true
        },
        saveActorByContent: {
            method: 'POST',
            url: EndPointService.contentEndPoint + "/:id/actors",
            isArray: false
        },
        deleteActorsByContent: {
            method: 'DELETE',
            url: EndPointService.contentEndPoint + "/:id/actors",
            isArray: true
        },
        getMVPDContent: {
            method: 'GET',
            url: EndPointService.contentEndPoint + '/:id',
            params: { id: '@id', mvpdPartnerId: '@mvpdPartnerId' },
            isArray: false
        },
        getContentCategories: {
            method: 'GET',
            url: EndPointService.contentEndPoint + '/:id/categories',
            params: { id: '@id', categoryId: '@categoryId' },
            isArray: true
        },
        getContentCategory: {
            method: 'GET',
            url: EndPointService.contentEndPoint + '/categories/:contentCategoryId',
            params: { contentCategoryId: '@contentCategoryId' },
            isArray: false
        },
        updateContentCategory: {
            method: 'PUT',
            url: EndPointService.contentEndPoint + '/categories/:contentCategoryId',
            params: { id: null, contentCategoryId: '@contentCategoryId' },
            isArray: false
        },
        saveContentCategory: {
            method: 'POST',
            url: EndPointService.contentEndPoint + '/:id/categories',
            params: { id: '@id' },
            isArray: false
        },
        toggleArchive: {
            method: 'DELETE',
            url: EndPointService.contentEndPoint + '/:id',
            isArray: false
        },
        clone: {
            method: 'PUT',
            url: EndPointService.contentEndPoint + '/:id',
            isArray: false
        },
        update: {
            method: 'PUT',
            url: EndPointService.contentEndPoint + '/:id',
            isArray: false
        },
        getGenres: {
            method: 'GET',
            url: EndPointService.contentEndPoint + '/genres',
            isArray: true
        },
        getSeasons: {
            method: 'GET',
            url: EndPointService.contentEndPoint + '/:contentId/seasons',
            params: { mvpdPartnerId: '@mvpdPartnerId' },
            isArray: true
        },
        getVolumes: {
            method: 'GET',
            url: EndPointService.contentEndPoint + '/:contentId/volumes',
            params: { mvpdPartnerId: '@mvpdPartnerId' },
            isArray: true
        },
        getMVPDSeasonContent: {
            method: 'GET',
            url: EndPointService.contentEndPoint + '/seasons/:id',
            params: { id: '@id', mvpdPartnerId: '@mvpdPartnerId' },
            isArray: false
        },
        getSeason: {
            method: 'GET',
            url: EndPointService.contentEndPoint + '/seasons/:id',
            params: { view: '@view', mvpdPartnerId: '@mvpdPartnerId' },
            isArray: false
        },
        getMVPDVolumeContent: {
            method: 'GET',
            url: EndPointService.contentEndPoint + '/volumes/:id',
            params: { id: '@id', mvpdPartnerId: '@mvpdPartnerId' },
            isArray: false
        },
        getVolume: {
            method: 'GET',
            url: EndPointService.contentEndPoint + '/volumes/:id',
            isArray: false
        },
        toggleSeasonVisibility: {
            method: 'DELETE',
            url: EndPointService.contentEndPoint + '/seasons/:seasonId',
            isArray: false
        },
        toggleVolumeVisibility: {
            method: 'DELETE',
            url: EndPointService.contentEndPoint + '/volumes/:volumeId',
            isArray: false
        },
        createSeason: {
            method: 'POST',
            url: EndPointService.contentEndPoint + '/:contentId/seasons',
            isArray: false
        },
        createVolume: {
            method: 'POST',
            url: EndPointService.contentEndPoint + '/:contentId/volumes',
            isArray: false
        },
        updateSeason: {
            method: 'PUT',
            url: EndPointService.contentEndPoint + '/seasons/:seasonId',
            params: { id: null, seasonId: '@seasonId' },
            isArray: false
        },
        updateVolume: {
            method: 'PUT',
            url: EndPointService.contentEndPoint + '/volumes/:volumeId',
            params: { id: null, volumeId: '@volumeId' },
            isArray: false
        },
        getBranding: {
            method: 'GET',
            isArray: true,
            url: EndPointService.contentEndPoint + '/:id' + '/:view'
        },
        saveBranding: {
            method: 'POST',
            isArray: false,
            url: EndPointService.contentEndPoint + '/:id' + '/:view'
        },
        updateBranding: {
            method: 'PUT',
            isArray: false,
            url: EndPointService.contentEndPoint + '/:id' + '/:view'
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components.data').factory('DashboardResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.dashboardEndpoint, { 'showCompleted': '@showCompleted', 'includeSubSeries': '@includeSubSeries' }, {
        getRestoreSteps: {
            method: 'GET',
            url: EndPointService.dashboardEndpoint + '/restoreSteps',
            isArray: false
        },
        getFileCopySteps: {
            method: 'GET',
            url: EndPointService.dashboardEndpoint + '/fileCopySteps',
            isArray: false
        },
        getTranscodeSteps: {
            method: 'GET',
            url: EndPointService.dashboardEndpoint + '/transcodeSteps',
            isArray: false
        },
        getDeliverySteps: {
            method: 'GET',
            url: EndPointService.dashboardEndpoint + '/deliverySteps',
            isArray: false
        },
        getDeliveryBandwidth: {
            method: 'GET',
            url: EndPointService.dashboardEndpoint + '/deliveryBandwidth',
            isArray: false
        },
        getDeliveryMetrics: {
            method: 'GET',
            url: EndPointService.dashboardEndpoint + '/deliveryMetrics',
            isArray: false
        },
        getDeliveryBandwidthReport: {
            method: 'GET',
            url: EndPointService.reportEndpoint + '/delivery/bandwidth',
            isArray: false
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 1/13/16.
 */
'use strict';
angular.module('prism-ui.components.data').factory('DynamicPropertiesResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.dynamicPropertiesEndPoint, {}, {
        'query': {
            method: 'GET',
            isArray: false
        },
        'updateProperties': {
            method: 'POST',
            url: EndPointService.reachDynamicPropertiesEndPoint,
            isArray: false
        },
        'delete': {
            method: 'DELETE',
            isArray: false,
            url: EndPointService.reachDynamicPropertiesEndPoint + '/:propertyName',
            params: { propertyName: '@propertyName' }
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 6/11/15.
 */
'use strict';
angular.module('prism-ui.components.data').factory('EnumResource', function ($resource, EndPointService) {
    return $resource(EndPointService.enumEndPoint);
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components.data').factory('ExecServersResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.execServersEndPoint + '/:id', { id: '@id'
        // ------- FOR FUTURE PAGINATION IF NEEDED -----------
        //
        // fetchOffset: '@fetchOffset',
        // fetchLimit: '@fetchLimit'
    }, {
        'update': {
            method: 'PUT',
            url: EndPointService.execServersEndPoint + '/:id',
            params: { id: '@id' },
            isArray: false
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: external-metadata-resource-factory
 *
 * Created by rwilliams on 10/5/17.
 */
'use strict';
angular.module('prism-ui.components.data').factory('ExternalMetadataResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.externalMetadataSourcesEndPoint + '/:id', { id: '@id' }, {
        save: {
            method: 'POST',
            url: EndPointService.externalMetadataSourcesEndPoint,
            isArray: false
        },
        update: {
            method: 'PUT',
            url: EndPointService.externalMetadataSourcesEndPoint + '/:id',
            isArray: false
        },
        run: {
            method: 'POST',
            url: EndPointService.externalMetadataSourcesEndPoint + '/:id/jobs',
            isArray: true,
            headers: {
                'Content-Type': 'application/xml',
            },
        },
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 4/4/16.
 */
'use strict';
angular.module('prism-ui.components.data').factory('FFmpegTemplatesResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.ffmpegTemplateEndPoint + '/:id', {
        id: '@id'
    }, {
        'toggleArchive': {
            method: 'DELETE',
            url: EndPointService.ffmpegTemplateEndPoint + '/:id',
            isArray: false
        },
        'clone': {
            method: 'POST',
            url: EndPointService.ffmpegTemplateEndPoint + '/:id',
            isArray: false
        },
        'update': {
            method: 'PUT',
            url: EndPointService.ffmpegTemplateEndPoint + '/:id',
            isArray: false
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components.data').factory('ImageTemplateResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.imageTemplatesEndpoint + '/:id', {
        id: '@id',
        fetchOffset: '@fetchOffset',
        fetchLimit: '@fetchLimit',
        searchString: '@searchString',
        includeHidden: '@includeHidden'
    }, {
        'delete': {
            method: 'DELETE',
            url: EndPointService.imageTemplatesEndpoint + '/:id',
            isArray: false
        },
        'clone': {
            method: 'POST',
            url: EndPointService.imageTemplatesEndpoint + '/:id',
            isArray: false
        },
        'update': {
            method: 'PUT',
            url: EndPointService.imageTemplatesEndpoint + '/:id',
            isArray: false
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components.data').factory('IntermediateTemplatesResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.intermediateTemplateEndPoint + '/:id', { id: '@id' }, {
        'toggleArchive': {
            method: 'DELETE',
            url: EndPointService.intermediateTemplateEndPoint + '/:id',
            isArray: false
        },
        'clone': {
            method: 'POST',
            url: EndPointService.intermediateTemplateEndPoint + '/:id',
            isArray: false
        },
        'update': {
            method: 'PUT',
            url: EndPointService.intermediateTemplateEndPoint + '/:id',
            isArray: false
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 9/2/15.
 */
'use strict';
angular.module('prism-ui.components.data').factory('LiveClipResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.liveClipEndPoint + '/:id', null, {
        'update': {
            method: 'PUT',
            isArray: false
        },
        'updateImage': {
            method: 'PUT',
            params: { id: '@id', imageCaptureTime: '@imageCaptureTime', deliver: '@deliver' },
            isArray: false
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 1/5/16.
 */
'use strict';
angular.module('prism-ui.components.data').factory('LivefeedsResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.livefeedsEndPoint + '/:id', { id: '@id' }, {
        'toggleArchive': {
            method: 'DELETE',
            url: EndPointService.livefeedsEndPoint + '/:id',
            isArray: false
        },
        'clone': {
            method: 'POST',
            url: EndPointService.livefeedsEndPoint + '/:id',
            isArray: false
        },
        'update': {
            method: 'PUT',
            url: EndPointService.livefeedsEndPoint + '/:id',
            isArray: false
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components.data').factory('MacCaptionTemplatesResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.macCaptionTemplatesEndpoint + '/:id', {
        id: '@id',
        includeHidden: '@includeHidden'
    }, {
        getTemplateData: {
            method: 'GET',
            url: EndPointService.macCaptionTemplatesEndpoint + '/:id',
            isArray: false
        },
        save: {
            method: 'POST',
            url: EndPointService.macCaptionTemplatesEndpoint,
            isArray: false
        },
        clone: {
            method: 'POST',
            url: EndPointService.macCaptionTemplatesEndpoint + '/:id',
            isArray: false
        },
        update: {
            method: 'PUT',
            url: EndPointService.macCaptionTemplatesEndpoint + '/:id',
            isArray: false
        },
        toggleArchive: {
            method: 'DELETE',
            url: EndPointService.macCaptionTemplatesEndpoint + '/:id',
            isArray: false
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components.data').factory('MediaConversionTemplateResource', function ($resource, EndPointService) {
    return $resource(EndPointService.mediaConversionTemplateEndpoint, {}, {
        getMediaConversionTemplates: {
            method: 'GET',
            url: EndPointService.mediaConversionTemplateEndpoint,
        },
        getMediaConversionTemplate: {
            method: 'GET',
            params: { id: '@id' },
            url: EndPointService.mediaConversionTemplateEndpoint + "/:id",
        },
        createMediaConversionTemplate: {
            method: 'POST',
            url: "" + EndPointService.mediaConversionTemplateEndpoint,
        },
        updateMediaConversionTemplate: {
            method: 'PUT',
            params: { id: '@id' },
            url: EndPointService.mediaConversionTemplateEndpoint + "/:id",
        },
        deleteMediaConversionTemplate: {
            method: 'DELETE',
            params: { id: '@id' },
            url: EndPointService.mediaConversionTemplateEndpoint + "/:id",
        },
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 5/7/15.
 */
'use strict';
angular.module('prism-ui.components.data').factory('MediaAssetResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.mediaAssetEndpoint, {
        assetType: '@assetType',
        assetId: '@assetId',
        contentId: '@contentId',
        contentUse: '@contentUse',
    }, {
        get: {
            method: 'GET',
            isArray: false
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by randysorensen on 8/15/16.
 */
'use strict';
angular
    .module('prism-ui.components.data')
    .factory('MetaGroupsResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.metaGroupsEndpoint);
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 6/10/15.
 */
'use strict';
angular.module('prism-ui.components.data').factory('MetaPropsResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.metaPropertiesEndpoint + '/:id', {
        ownerFilter: '@ownerFilter',
        id: '@id'
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 7/20/16.
 */
'use strict';
angular.module('prism-ui.components.data').factory('NetworkResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.networksEndPoint + '/:id', {
        id: '@id',
        sub: '@sub',
        fetchOffset: '@fetchOffset',
        fetchLimit: '@fetchLimit',
        includeHidden: '@includeHidden',
        view: '@view',
        mvpdOnly: '@mvpdOnly',
        mvpdPartnerId: '@mvpdPartnerId'
    }, {
        getNetworks: {
            method: 'GET',
            isArray: true
        },
        update: {
            method: 'PUT',
            isArray: false
        },
        save: {
            method: 'POST',
            isArray: false
        },
        getBranding: {
            method: 'GET',
            isArray: true,
            url: EndPointService.networksEndPoint + '/:id' + '/:view'
        },
        saveBranding: {
            method: 'POST',
            isArray: false,
            url: EndPointService.networksEndPoint + '/:id' + '/:view'
        },
        updateBranding: {
            method: 'PUT',
            isArray: false,
            url: EndPointService.networksEndPoint + '/:id' + '/:view'
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 3/31/15.
 */
'use strict';
angular.module('prism-ui.components.data').factory('PackageResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.packageEndPoint + '/:id' + '/:sub', {
        fetchOffset: '@fetchOffset',
        fetchLimit: '@limit',
        searchString: '@searchString',
        id: '@id',
        sub: '@sub',
        includeHidden: '@includeHidden',
        numberOfPackages: '@numberOfPackages',
        view: '@view',
        lock: '@lock',
        mapId: '@mapId',
        forceRefresh: '@forceRefresh'
    }, {
        query: {
            method: 'GET',
            isArray: true,
            cancellable: true
        },
        get: {
            method: 'GET',
            isArray: false,
            cancellable: true
        },
        save: {
            method: 'POST',
            isArray: false
        },
        saveCollaborators: {
            method: 'POST',
            isArray: true
        },
        savePartnerPackages: {
            method: 'PUT',
            isArray: true
        },
        findRelatedItems: {
            method: 'GET',
            url: EndPointService.packageEndPoint + '/:id' + '/relatedMedia',
            params: {
                videoPath: '@path', acceptTemplateMemberId: '@acceptTemplateMemberId'
            },
            isArray: true
        },
        completedDeliveries: {
            method: 'GET',
            url: EndPointService.packageEndPoint + '/:id' + '/completedDeliveries',
            params: {
                excludePreDeliveries: '@excludePreDeliveries'
            },
            isArray: true
        },
        saveMetadata: {
            method: 'PUT',
            url: EndPointService.packageEndPoint + '/:id' + '/metadata',
            isArray: false
        },
        toggleArchive: {
            method: 'DELETE',
            url: EndPointService.packageEndPoint + '/:id',
            isArray: false
        },
        clone: {
            method: 'PUT',
            url: EndPointService.packageEndPoint + '/:id',
            isArray: false
        },
        getClips: {
            method: 'GET',
            url: EndPointService.packageEndPoint + '/:id' + '/clips',
            params: {
                includeHidden: '@includeHidden'
            },
            isArray: true
        },
        saveArtwork: {
            method: 'POST',
            isArray: true,
            url: EndPointService.packageEndPoint + '/:id' + '/artworkAssets'
        },
        removeLock: {
            method: 'DELETE',
            url: EndPointService.packageEndPoint + '/locks/:id',
            isArray: false
        },
        validatePackages: {
            method: 'PUT',
            url: EndPointService.packageEndPoint + '/validate',
            isArray: false
        },
        executeSearchFilter: {
            method: 'POST',
            url: EndPointService.packageEndPoint + '/searches',
            isArray: true
        },
        getCategories: {
            method: 'GET',
            url: EndPointService.packageEndPoint + '/categoryTypes',
            params: {
                view: '@view'
            },
            isArray: true
        },
        getTimings: {
            method: 'GET',
            url: EndPointService.packageEndPoint + '/:id/timings',
            isArray: false
        },
        saveTiming: {
            method: 'PUT',
            isArray: false,
            url: EndPointService.packageEndPoint + '/:id/timings'
        },
        uploadTimings: {
            method: 'PUT',
            isArray: false,
            url: EndPointService.packageEndPoint + '/:id/importTimings'
        },
        acceptPackage: {
            method: 'PUT',
            isArray: false,
            url: EndPointService.packageEndPoint + '/:id/accept'
        },
        rejectPackage: {
            method: 'PUT',
            isArray: false,
            params: {
                reason: '@reason'
            },
            url: EndPointService.packageEndPoint + '/:id/reject'
        },
        resetPackages: {
            method: 'PUT',
            url: EndPointService.packageEndPoint + '/reset',
            isArray: false
        },
        deliveryWorkflows: {
            method: 'GET',
            url: EndPointService.packageEndPoint + '/:id/deliveryWorkflows',
            params: {
                includeClips: '@includeClips'
            },
            isArray: true
        },
        getClipAcceptTemplateMembers: {
            method: 'GET',
            url: EndPointService.packageEndPoint + '/:id/clipAcceptTemplateMembers',
            isArray: true
        },
        checkIn: {
            method: 'PUT',
            url: EndPointService.checkInEndpoint,
            isArray: true,
        },
        getExternalIngests: {
            method: 'GET',
            params: {
                packageId: '@packageId'
            },
            url: EndPointService.packageEndPoint + "/:packageId/externalIngests",
            isArray: true
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 5/4/15.
 */
'use strict';
angular.module('prism-ui.components.data').factory('PackageMediaResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.packageEndPoint + '/:id' + '/media', { id: '@id', pendingIngest: '@pendingIngest' }, {
        get: {
            method: 'GET',
            isArray: true
        },
        save: {
            method: 'POST',
            isArray: true
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 5/7/15.
 */
'use strict';
angular.module('prism-ui.components.data').factory('PackageMediaInfoResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.packageMediaInfoEndpoint + '/:id', { id: '@id' }, {
        get: {
            method: 'GET',
            isArray: false,
            params: { primary: '@primary' }
        },
        save: {
            method: 'POST',
            isArray: true
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components.data').factory('PartnerResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.partnerEndPoint + '/:id', {
        id: '@id',
        fetchOffset: '@fetchOffset',
        fetchLimit: '@fetchLimit',
        searchString: '@searchString',
        includeHidden: '@includeHidden',
        mvpd: '@mvpd'
    }, {
        //==========//
        // Partners //
        //==========//
        clone: {
            method: 'POST',
            url: EndPointService.partnerEndPoint + '/:id',
            params: { id: '@id' },
            isArray: false
        },
        update: {
            method: 'PUT',
            url: EndPointService.partnerEndPoint + '/:id',
            params: { id: '@id' },
            isArray: false
        },
        toggleArchive: {
            method: 'DELETE',
            url: EndPointService.partnerEndPoint + '/:id',
            params: { id: '@id' },
            isArray: false
        },
        getChildren: {
            method: 'GET',
            url: EndPointService.partnerEndPoint + "/:id/children",
            isArray: true
        },
        //=============================//
        // Partner Metadata Properties //
        //=============================//
        getMetadataProperties: {
            method: 'GET',
            url: EndPointService.partnerEndPoint + '/:id/metadataProperties',
            params: { id: '@id' },
            isArray: true
        },
        //==================//
        // Partner Planners //
        //==================//
        getAllPlanners: {
            method: 'GET',
            url: EndPointService.partnerEndPoint + '/planners',
            interceptor: {
                response: function (response) {
                    response.resource.$httpHeaders = response.headers;
                    return response.resource;
                }
            },
            isArray: true
        },
        getPlanners: {
            method: 'GET',
            url: EndPointService.partnerEndPoint + '/:id/planners',
            params: { id: '@id' },
            isArray: true
        },
        createPlanner: {
            method: 'POST',
            url: EndPointService.partnerEndPoint + '/:id/planners',
            params: { id: '@id' },
            isArray: false
        },
        getPlanner: {
            method: 'GET',
            url: EndPointService.partnerEndPoint + '/planners/:id',
            params: { id: '@id' },
            isArray: false
        },
        updatePlanner: {
            method: 'PUT',
            url: EndPointService.partnerEndPoint + '/planners/:id',
            params: { id: '@id' },
            isArray: false
        },
        deletePlanner: {
            method: 'DELETE',
            url: EndPointService.partnerEndPoint + '/planners/:id',
            params: { id: '@id' },
            isArray: false
        },
        deliverOffCyclePlanners: {
            method: 'GET',
            params: {
                plannerId: '@plannerId',
                message: '@message'
            },
            url: EndPointService.partnerEndPoint + '/offCyclePlanners',
            isArray: false
        },
        //============================//
        // Partner Delivery Endpoints //
        //============================//
        getDeliveryEndpoints: {
            method: 'GET',
            url: EndPointService.partnerEndPoint + '/:id/deliveryEndpoints',
            params: { id: '@id' },
            isArray: true
        },
        createDeliveryEndpoint: {
            method: 'POST',
            url: EndPointService.partnerEndPoint + '/:partnerId/deliveryEndpoints',
            params: { id: '@partnerId' },
            isArray: false
        },
        cloneDeliveryEndpoint: {
            method: 'POST',
            url: EndPointService.partnerEndPoint + '/:partnerId/deliveryEndpoints/:endpointId',
            params: { partnerId: '@partnerId', endpointId: '@endpointId' },
            isArray: false
        },
        getDeliveryEndpoint: {
            method: 'GET',
            url: EndPointService.partnerEndPoint + '/deliveryEndpoints/:endpointId',
            params: { id: '@endpointId' },
            isArray: false
        },
        updateDeliveryEndpoint: {
            method: 'PUT',
            url: EndPointService.partnerEndPoint + '/deliveryEndpoints/:endpointId',
            params: { id: '@endpointId' },
            isArray: false
        },
        deleteDeliveryEndpoint: {
            method: 'DELETE',
            url: EndPointService.partnerEndPoint + '/deliveryEndpoints/:id',
            params: { id: '@id' },
            isArray: false
        },
        //=========================//
        // Partner Email Endpoints //
        //=========================//
        getEmailEndpoints: {
            method: 'GET',
            url: EndPointService.partnerEndPoint + '/:partnerId/emailEndpoints',
            isArray: true,
        },
        getEmailEndpoint: {
            method: 'GET',
            url: EndPointService.partnerEndPoint + '/emailEndpoints/:id',
        },
        createEmailEndpoint: {
            method: 'POST',
            url: EndPointService.partnerEndPoint + '/:partnerId/emailEndpoints',
        },
        cloneEmailEndpoint: {
            method: 'POST',
            url: EndPointService.partnerEndPoint + '/emailEndpoints/:id',
        },
        updateEmailEndpoint: {
            method: 'PUT',
            url: EndPointService.partnerEndPoint + '/emailEndpoints/:id',
        },
        toggleEmailEndpointVisibility: {
            method: 'DELETE',
            url: EndPointService.partnerEndPoint + '/emailEndpoints/:id',
        },
        //===============
        // SLA Templates
        //===============
        getDueDateTemplates: {
            method: 'GET',
            url: EndPointService.partnerEndPoint + "/:partnerId/dueDateTemplates",
            isArray: true
        },
        cloneDueDateTemplate: {
            method: 'POST',
            url: EndPointService.partnerEndPoint + "/dueDateTemplates/:id"
        },
        createDueDateTemplate: {
            method: 'POST',
            url: EndPointService.partnerEndPoint + "/:partnerId/dueDateTemplates"
        },
        getDueDateTemplate: {
            method: 'GET',
            url: EndPointService.partnerEndPoint + "/dueDateTemplates/:id"
        },
        updateDueDateTemplate: {
            method: 'PUT',
            url: EndPointService.partnerEndPoint + "/dueDateTemplates/:id"
        },
        toggleDueDateTemplateVisibility: {
            method: 'DELETE',
            url: EndPointService.partnerEndPoint + "/dueDateTemplates/:id"
        },
        //============//
        // Businesses //
        //============//
        getBusinesses: {
            method: 'GET',
            url: EndPointService.partnerEndPoint + "/businesses",
            isArray: true
        },
        getNielsenTemplates: {
            method: 'GET',
            url: EndPointService.partnerEndPoint + "/:partnerId/nielsenTemplates",
            isArray: true
        },
        cloneNielsenTemplate: {
            method: 'POST',
            url: EndPointService.partnerEndPoint + "/nielsenTemplates/:id",
            params: { id: '@id' }
        },
        createNielsenTemplate: {
            method: 'POST',
            url: EndPointService.partnerEndPoint + "/:partnerId/nielsenTemplates"
        },
        getNielsenTemplate: {
            method: 'GET',
            url: EndPointService.partnerEndPoint + "/nielsenTemplates/:id"
        },
        updateNielsenTemplate: {
            method: 'PUT',
            url: EndPointService.partnerEndPoint + "/nielsenTemplates/:id"
        },
        toggleNielsenTemplateHidden: {
            method: 'DELETE',
            url: EndPointService.partnerEndPoint + "/nielsenTemplates/:id"
        },
        getDeliveryProfiles: {
            method: 'GET',
            url: EndPointService.partnerEndPoint + "/:partnerId/deliveryProfiles",
            isArray: true
        },
        getDeliveryProfile: {
            method: 'GET',
            params: {
                includeHiddenEmails: '@includeHiddenEmails'
            },
            url: EndPointService.deliveryEndPoint + "/profiles/:profileId"
        },
        createDeliveryProfile: {
            method: 'POST',
            url: EndPointService.partnerEndPoint + "/:partnerId/deliveryProfiles"
        },
        updateDeliveryProfile: {
            method: 'PUT',
            url: EndPointService.deliveryEndPoint + "/profiles/:id"
        },
        toggleDeliveryEmailHidden: {
            method: 'DELETE',
            url: EndPointService.deliveryEndPoint + "/profiles/:profileId/emails/:id",
            params: { profileId: '@profileId' }
        },
        getDeliveryEmail: {
            method: 'GET',
            url: EndPointService.deliveryEndPoint + "/profiles/:profileId/emails/:id",
            params: { profileId: '@profileId' }
        },
        updateDeliveryEmail: {
            method: 'PUT',
            url: EndPointService.deliveryEndPoint + "/profiles/:profileId/emails/:id",
            params: { profileId: '@profileId' }
        },
        createDeliveryEmail: {
            method: 'POST',
            url: EndPointService.deliveryEndPoint + "/profiles/:profileId/emails/",
            params: { profileId: '@profileId' }
        },
        getDeliveryItemsForProfile: {
            method: 'GET',
            isArray: true,
            params: {
                includeHidden: '@includeHidden',
                acceptProfileId: '@acceptProfileId',
                profileId: '@profileId',
                fetchOffset: '@fetchOffset',
                fetchLimit: '@fetchLimit',
                type: '@type'
            },
            url: EndPointService.deliveryEndPoint + "/profiles/:profileId/deliveryItems"
        },
        toggleDeliveryItemHidden: {
            method: 'DELETE',
            url: EndPointService.deliveryEndPoint + "/items/:id"
        },
        cloneDeliveryItem: {
            method: 'POST',
            url: EndPointService.deliveryEndPoint + "/items/:id"
        },
        getDeliveryItem: {
            method: 'GET',
            url: EndPointService.deliveryEndPoint + "/items/:id"
        },
        updateDeliveryItem: {
            method: 'PUT',
            url: EndPointService.deliveryEndPoint + "/items/:id"
        },
        createDeliveryItem: {
            method: 'POST',
            url: EndPointService.deliveryEndPoint + "/items"
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: partnerpackages-resource-factory.js
 *
 * Created by randysorensen on 8/30/17.
 */
'use strict';
angular
    .module('prism-ui.components.data')
    .factory('PartnerPackagesResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.partnerPackagesEndPoint + '/:partnerPackageId', {
        partnerPackageId: '@partnerPackageId',
    }, {
        //==================//
        // Partner Packages //
        //==================//
        getPartnerPackage: {
            method: 'GET',
            isArray: false,
        },
        updatePartnerPackage: {
            method: 'PUT',
            isArray: false,
        },
        //============================//
        // Partner Delivery Instances //
        //============================//
        getDeliveryInstances: {
            url: EndPointService.partnerPackagesEndPoint + '/:partnerPackageId/deliveryInstances',
            method: 'GET',
            isArray: true,
            params: {
                partnerPackageId: '@partnerPackageId'
            },
        },
        getDeliveryInstance: {
            url: EndPointService.partnerPackagesEndPoint + '/deliveryInstances/:instanceId',
            method: 'GET',
            params: {
                instanceId: '@instanceId',
            },
            isArray: false,
        },
        updateDeliveryInstance: {
            url: EndPointService.partnerPackagesEndPoint + '/deliveryInstances/:instanceId',
            method: 'PUT',
            params: {
                instanceId: '@instanceId',
            },
            isArray: false,
        },
        createDeliveryInstance: {
            url: EndPointService.partnerPackagesEndPoint + '/:partnerPackageId/deliveryInstances',
            method: 'POST',
            isArray: false,
        },
        getApplicableDeliveryItems: {
            url: EndPointService.partnerPackagesEndPoint + '/:partnerPackageId/applicableDeliveryItems',
            method: 'GET',
            isArray: true
        },
        approvePartnerPackageForPreDeliveryQc: {
            url: EndPointService.partnerPackagesEndPoint + '/:partnerPackageId/approve',
            method: 'PUT',
            params: {
                message: '@message',
            }
        },
        rejectPartnerPackageForPreDeliveryQc: {
            url: EndPointService.partnerPackagesEndPoint + '/:partnerPackageId/reject',
            method: 'PUT',
            params: {
                message: '@message',
            }
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 7/16/15.
 */
'use strict';
angular.module('prism-ui.components.data').factory('PermissionsResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.permissionsEndPoint, { viewState: '@viewState', packageId: '@packageId' }, {
        get: { method: 'GET', isArray: true }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: prepostroll-resource-factory.js
 *
 * Created by rwilliams on 8/14/17.
 */
'use strict';
angular
    .module('prism-ui.components.data')
    .factory('PrePostRollResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.prePostRollEndpoint + "/:containerId", {}, {
        //===============//
        // Container API //
        //===============//
        update: {
            method: 'PUT'
        },
        //===========//
        // Asset API //
        //===========//
        createAsset: {
            method: 'POST',
            url: EndPointService.prePostRollEndpoint + '/:containerId/assets',
        },
        getAsset: {
            method: 'GET',
            url: EndPointService.prePostRollEndpoint + "/assets/:assetId"
        },
        updateAsset: {
            method: 'PUT',
            url: EndPointService.prePostRollEndpoint + "/assets/:assetId"
        },
        deleteAsset: {
            method: 'DELETE',
            url: EndPointService.prePostRollEndpoint + "/assets/:assetId"
        },
        //=====================//
        // Auxiliary Asset API //
        //=====================//
        //
        // These are used for sidecar audio and text tracks
        // which are associated with pre/post roll assets.
        //
        createAssetData: {
            method: 'POST',
            url: EndPointService.prePostRollEndpoint + "/assets/:assetId/:subTypeKey"
        },
        updateAssetData: {
            method: 'PUT',
            url: EndPointService.prePostRollEndpoint + "/assets/:subTypeKey/:subTypeId"
        },
        deleteAssetData: {
            method: 'DELETE',
            url: EndPointService.prePostRollEndpoint + "/assets/:subTypeKey/:subTypeId"
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components.data').factory('ProxyResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.proxyEndPoint + '/:id' + '/paths', { id: '@id' }, {
        get: {
            method: 'GET',
            isArray: false
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: queues-resource-factory.js
 *
 * Created by psnyder on 3/1/17.
 */
'use strict';
angular.module('prism-ui.components.data').factory('QueuesResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.queuesEndpoint + '/:id', { id: '@id', filter: '@filter', fetchOffset: '@fetchOffset', fetchLimit: '@fetchLimit' }, {
        'getAllQueueLimiters': {
            method: 'GET',
            url: EndPointService.queuesEndpoint + '/:id/limiters',
            params: { id: '@id' },
            isArray: true
        },
        'createNewQueueLimiter': {
            method: 'POST',
            url: EndPointService.queuesEndpoint + '/:id/limiters',
            params: { id: '@id' },
            isArray: false
        },
        'getSingleQueueLimiter': {
            method: 'GET',
            url: EndPointService.queuesEndpoint + '/limiters/:id',
            params: { id: '@id' },
            isArray: false
        },
        'getQueueSteps': {
            method: 'GET',
            url: EndPointService.queuesEndpoint + '/:id/steps',
            params: {
                id: '@id',
                filter: '@filter',
                fetchOffset: '@fetchOffset',
                fetchLimit: '@fetchLimit'
            },
            isArray: true
        },
        'updateQueueStepPriority': {
            method: 'PUT',
            url: EndPointService.queuesEndpoint + '/steps/:id/priority',
            params: { id: '@id', priority: '@priority' },
            isArray: false
        },
        'updateLimiter': {
            method: 'PUT',
            url: EndPointService.queuesEndpoint + '/limiters/:id',
            params: { id: '@id' },
            isArray: false
        },
        'deleteQueueLimiter': {
            method: 'DELETE',
            url: EndPointService.queuesEndpoint + '/limiters/:id',
            params: { id: '@id' },
            isArray: false
        },
        'updateQueue': {
            method: 'PUT',
            url: EndPointService.queuesEndpoint + '/:id',
            params: { id: '@id' },
            isArray: false
        },
        'clearQueue': {
            method: 'DELETE',
            url: EndPointService.queuesEndpoint + '/:id',
            params: { id: '@id' },
            isArray: false
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 8/10/15.
 */
'use strict';
angular.module('prism-ui.components.data').factory('RecordResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.recordEndPoint + '/:id', { id: '@id' }, {
        'stop': { method: 'POST', url: EndPointService.recordEndPoint + '/:id/stop', params: { id: '@id' }, isArray: false },
        'update': { method: 'PUT', params: { id: '@id' }, isArray: false },
        'createClip': { method: 'POST', url: EndPointService.recordEndPoint + '/:id/clips', params: { id: '@id' }, isArray: false },
        'updateClip': { method: 'PUT', url: EndPointService.recordEndPoint + '/:id/clips/:clipId', params: { id: '@id', clipId: '@clipId' }, isArray: false },
        'getClips': { method: 'GET', url: EndPointService.recordEndPoint + '/:id/clips', params: { id: '@id' }, isArray: true },
        'saveThumbnail': { method: 'POST', url: EndPointService.recordEndPoint + '/:id/clips/:clipId/thumbnail',
            params: { id: '@id', clipId: '@clipId' }, isArray: false,
            headers: { 'Content-Type': undefined } },
        'deleteClip': { method: 'DELETE', url: EndPointService.recordEndPoint + '/:id/clips/:clipId', params: { id: '@id' }, isArray: false }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components.data').factory('RepositoryRootsResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.repositoryRootsEndpoint);
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 5/14/15.
 */
'use strict';
angular.module('prism-ui.components.data').factory('RoleResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.roleEndPoint, { mediaType: '@mediaType' });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: subscriptions-resource-factory.js
 *
 * Created by randysorensen on 5/25/17.
 */
'use strict';
angular
    .module('prism-ui.components.data')
    .factory('SubscriptionsResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.partnerEndPoint, {}, {
        'getSubscriptions': {
            method: 'GET',
            url: EndPointService.partnerEndPoint + '/:partnerId/subscriptions',
            params: {
                id: '@partnerId'
            },
            isArray: true
        },
        'getSubscriptionsFiltered': {
            method: 'POST',
            url: EndPointService.partnerEndPoint + '/:partnerId/subscriptions/searches',
            params: {
                partnerId: '@partnerId'
            },
            isArray: true,
        },
        'getSubscription': {
            method: 'GET',
            url: EndPointService.partnerEndPoint + '/:partnerId/subscriptions/:subId',
            params: {
                partnerId: '@partnerId',
                subId: '@subId'
            },
            isArray: false
        },
        'createSubscription': {
            method: 'POST',
            url: EndPointService.partnerEndPoint + '/:partnerId/subscriptions',
            params: {
                partnerId: '@partnerId'
            },
            isArray: false
        },
        'saveSubscription': {
            method: 'PUT',
            url: EndPointService.partnerEndPoint + '/:partnerId/subscriptions/:subId',
            params: {
                partnerId: '@partnerId',
                subId: '@subId'
            },
            isArray: false
        },
        'saveSubscriptions': {
            method: 'POST',
            url: EndPointService.partnerEndPoint + '/subscriptions',
            isArray: true
        },
        'getSubscriptionsByContentCategory': {
            method: 'GET',
            url: EndPointService.partnerEndPoint + '/subscriptions/:contentId/:categoryId',
            params: {
                contentId: '@contentId',
                categoryId: '@categoryId'
            },
            isArray: true
        },
        'getSubscriptionsByContentCategoryFiltered': {
            method: 'POST',
            url: EndPointService.partnerEndPoint + '/subscriptions/:contentId/:categoryId/searches',
            params: {
                contentId: '@contentId',
                categoryId: '@categoryId'
            },
            isArray: true
        },
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 4/1/16.
 */
'use strict';
angular.module('prism-ui.components.data').factory('SystemMediainfoResource', function ($resource, EndPointService) {
    return $resource(EndPointService.systemMediainfoEndpoint + '/:id', { id: '@id' }, {
        get: {
            method: 'GET',
            isArray: false
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by randysorensen on 2/17/2017.
 */
'use strict';
angular
    .module('prism-ui.components.data')
    .factory('TransformTemplatesResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.transformTemplatesEndPoint + '/:id', { id: '@id' }, {
        'toggleArchive': {
            method: 'DELETE',
            url: EndPointService.transformTemplatesEndPoint + '/:id',
            isArray: false
        },
        'clone': {
            method: 'POST',
            url: EndPointService.transformTemplatesEndPoint + '/:id',
            isArray: false
        },
        'update': {
            method: 'PUT',
            url: EndPointService.transformTemplatesEndPoint + '/:id',
            isArray: false
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 4/20/15.
 */
'use strict';
angular.module('prism-ui.components.data').factory('VirtualPathResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.virtualPathEndPoint);
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components.data').factory('WorkflowExecutionResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.workflowExecutionEndPoint + '/:id', {
        id: '@id', fetchLimit: '@fetchLimit',
        fetchOffset: '@fetchOffset',
        workflowId: '@workflowId',
        status: '@status',
        dateProperty: '@dateProperty',
        fromDate: '@fromDate',
        toDate: '@toDate',
        submittedByUserId: '@submittedByUserId'
    }, {
        start: {
            method: 'POST',
            isArray: false,
            url: EndPointService.workflowExecutionEndPoint + '/:id/start',
            params: { id: '@id' }
        },
        resume: {
            method: 'POST',
            isArray: false,
            url: EndPointService.workflowExecutionEndPoint + '/:id/resume'
        },
        stop: {
            method: 'POST',
            isArray: false,
            url: EndPointService.workflowExecutionEndPoint + '/:id/stop'
        },
        abandon: {
            method: 'POST',
            isArray: false,
            url: EndPointService.workflowExecutionEndPoint + '/:id/abandon'
        },
        getWorkflowExecution: {
            method: 'GET',
            isArray: false,
            url: EndPointService.workflowExecutionEndPoint + '/:id'
        },
        getSubflowExecutions: {
            method: 'GET',
            isArray: true,
            url: EndPointService.workflowExecutionEndPoint + '/:id/subflows',
            params: {
                id: '@id',
                fetchLimit: '1000',
                fetchOffset: '0'
            }
        },
        getExecutionSteps: {
            method: 'GET',
            isArray: true,
            url: EndPointService.workflowExecutionEndPoint + '/:id/steps',
            params: {
                executionId: '@id',
                fetchLimit: '@fetchLimit',
                fetchOffset: '@fetchOffset'
            }
        },
        getExecutionContextData: {
            method: 'GET',
            isArray: true,
            url: EndPointService.workflowExecutionEndPoint + '/:id/contextData',
            transformResponse: function (data) {
                var contextDataArray = [];
                angular.forEach(angular.fromJson(data), function (contextValue, contextKey) {
                    contextDataArray.push({
                        name: contextKey,
                        value: (Array.isArray(contextValue)) ? JSON.stringify(contextValue) : contextValue
                    });
                });
                return contextDataArray;
            }
        },
        createPackageSnapshot: {
            method: 'POST',
            isArray: false,
            url: EndPointService.workflowExecutionEndPoint + '/createImageFromVideo',
            params: {
                packageId: '@packageId',
                frameOffset: '@frameOffset',
            }
        },
        startInstanceDelivery: {
            method: 'POST',
            isArray: false,
            url: EndPointService.workflowExecutionEndPoint + '/startDelivery'
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 7/31/15.
 */
'use strict';
angular.module('prism-ui.components.filters').filter('gridSearch', function () {
    return function (array, searchText, searchFields) {
        var result = [];
        var getObject = function (array, item) {
            var result = angular.copy(item);
            for (var i = 0; i < array.length; i++) {
                var prop = array[i];
                if (result.hasOwnProperty(prop)) {
                    result = result[prop];
                }
                else {
                    return undefined;
                }
            }
            return result;
        };
        if (searchText) {
            var matcher = new RegExp(searchText.toLowerCase());
            array.forEach(function (item) {
                var field;
                for (var i = 0; i < searchFields.length; i++) {
                    field = searchFields[i];
                    var compare = getObject(field.split('.'), item);
                    if (compare && compare.toLowerCase().match(matcher)) {
                        result.push(item);
                        break;
                    }
                }
            });
            return result;
        }
        return array;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
function FileUploadModalController(_, $q, $window) {
    var self = this;
    self.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };
    var getAcceptProfileData = function (acceptObject) {
        if (acceptObject.acceptProfile) {
            return acceptObject.acceptProfile;
        }
        else {
            return acceptObject;
        }
    };
    if (self.resolve.fileFilterType !== 'TEXT') {
        var fileExtensions = self.resolve.acceptTemplateMembers.map(function (acceptTemplateMember) {
            return getAcceptProfileData(acceptTemplateMember).fileExtensions;
        });
        var acceptHeights = self.resolve.acceptTemplateMembers.map(function (acceptTemplateMember) {
            return getAcceptProfileData(acceptTemplateMember).height;
        });
        var acceptWidths = self.resolve.acceptTemplateMembers.map(function (acceptTemplateMember) {
            return getAcceptProfileData(acceptTemplateMember).width;
        });
    }
    //================//
    // Template Logic //
    //================//
    self.getUploadButtonText = function () {
        var fileFilters = _.uniqBy(_.flatten(fileExtensions), _.upperCase).join('|').toUpperCase();
        var buttonText = '';
        switch (self.resolve.fileFilterType.toLowerCase()) {
            case 'image':
                buttonText = 'Select ' + self.fileWidths + ' x ' + self.fileHeights + ' ' + fileFilters + ' Image';
                break;
            default:
                buttonText = 'Select ' + self.resolve.fileFilterType.toUpperCase();
        }
        return buttonText;
    };
    self.getFileExtensions = function () {
        return _.chain(fileExtensions)
            .flatten()
            .map(_.toLower)
            .value();
    };
    //=======================//
    // Local File Validation //
    //=======================//
    var readFile = function (fileItem) {
        self.fileUploadProgress = 1;
        var deferred = $q.defer();
        var reader = new FileReader();
        reader.onload = function (event) {
            self.fileUploadProgress = 100;
            deferred.resolve(event);
        };
        reader.onprogress = function (event) {
            self.fileUploadProgress = Math.round((event.loaded * 100) / event.total);
        };
        reader.readAsDataURL(fileItem._file);
        return deferred.promise;
    };
    var createResult = function (fileItem, event, errors) {
        return {
            source: fileItem.file.name,
            errors: errors,
            warnings: [],
            uploadData: {
                path: fileItem.file.name,
                data: event.target.result
            }
        };
    };
    var imageAddHandler = function (fileItem) {
        return readFile(fileItem).then(function (event) {
            var deferredImage = $q.defer();
            var img = new Image();
            img.onload = function () {
                if (self.fileHeights.indexOf(img.height + '') === -1 ||
                    self.fileWidths.indexOf(img.width + '') === -1) {
                    deferredImage.resolve(createResult(fileItem, event, [{
                            description: 'File Dimensions not valid!',
                            severity: 'ERROR'
                        }]));
                }
                else {
                    self.previewImage = $window.URL.createObjectURL(fileItem._file);
                    deferredImage.resolve(createResult(fileItem, event, []));
                }
            };
            img.src = event.target.result;
            return deferredImage.promise;
        });
    };
    var audioAddHandler = function (fileItem) {
        return readFile(fileItem).then(function (event) {
            return createResult(fileItem, event, []);
        });
    };
    var baseFileAddHandler = function (fileItem) {
        return readFile(fileItem).then(function (event) {
            return createResult(fileItem, event, []);
        });
    };
    self.validateLocalFile = function (fileItem) {
        switch (self.resolve.fileFilterType.toLowerCase()) {
            case 'image':
            case 'other':
                return imageAddHandler(fileItem);
            case 'audio':
            case 'video':
                return audioAddHandler(fileItem);
            default:
                return baseFileAddHandler(fileItem);
        }
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    self.$onInit = function () {
        self.fileHeights = _.uniq(acceptHeights).join('|');
        self.fileWidths = _.uniq(acceptWidths).join('|');
        self.buttonTooltips = {
            LOCAL: self.getUploadButtonText()
        };
    };
    self.initializeLocalUploaderConfig = function (uploaderConfig) {
        var typeFilter = _.find(uploaderConfig.filters, { name: 'fileTypeFilter' });
        typeFilter.origFn = typeFilter.fn;
        // TODO: AB#88420 Once file-select checks fileTypes, remove this override
        typeFilter.fn = function (item, options) {
            var type = item.type.slice(item.type.lastIndexOf('/') + 1).toLowerCase();
            if (self.resolve.fileFilterType === 'VIDEO') {
                typeFilter.errorDescription = 'File Type not valid!';
                return type === 'quicktime';
            }
            return typeFilter.origFn(item, options);
        };
    };
}
angular.module('prism-ui.components').component('fileUploadModal', {
    templateUrl: 'components/modal/file-upload-modal/file-upload-modal-template.html',
    controller: FileUploadModalController,
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components').controller('FilterModalController', function ($uibModalInstance) {
    var self = this;
    self.onOk = function () {
        $uibModalInstance.close();
    };
    self.cancel = function () {
        $uibModalInstance.dismiss('setToDefaults');
    };
    self.xClicked = function () {
        $uibModalInstance.dismiss('cancel');
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jesse on 5/6/16.
 */
'use strict';
angular.module('prism-ui.components').controller('PackagePropertiesFilterSectionController', function ($scope, $q, ExternalMetadataService, SearchFilterService, PackagePropertiesQueryService, $location, PermissionsService) {
    var self = this;
    self.available = {
        contentTypes: [],
        networks: [],
        categoryTypes: [],
        categories: [],
        contents: [],
        seasons: [],
        volumes: [],
        submitters: [],
        externalSystems: [],
    };
    self.searchCriteria = {
        contentType: undefined,
        networks: [],
        categoryTypes: [],
        categories: [],
        contents: [],
        externalSystems: [],
    };
    self.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };
    var contentSetFromLocation = false;
    var seasonVolumeSetFromLocation = false;
    var categoriesSetFromLocation = false;
    var unfilteredContents = [];
    var packageView;
    var objectProp;
    var getAvailableCategories = function () {
        var allCategories = [];
        if (self.searchCriteria.categoryTypes && self.searchCriteria.categoryTypes.length) {
            angular.forEach(self.searchCriteria.categoryTypes, function (categoryType) {
                allCategories = allCategories.concat(categoryType.categories);
            });
        }
        else {
            angular.forEach(self.available.categoryTypes, function (categoryType) {
                allCategories = allCategories.concat(categoryType.categories);
            });
        }
        return allCategories;
    };
    var retrieveData = function () {
        packageView = $location.path().indexOf('dashboard/workflow') === -1;
        objectProp = (packageView) ? 'id' : 'name';
        self.loadingIndicator.show = true;
        var contentTypesPromise = PackagePropertiesQueryService.getContentTypes();
        var networksPromise = PackagePropertiesQueryService.getNetworks();
        var categoriesPromise = PackagePropertiesQueryService.getCategories();
        var submittersPromise = (!packageView && PermissionsService.isAdmin()) ? SearchFilterService.getSubmitters() : null;
        var externalSystemsPromise = ExternalMetadataService.getExternalSources();
        $q.all({
            contentTypes: contentTypesPromise,
            networks: networksPromise,
            categories: categoriesPromise,
            submitters: submittersPromise,
            externalSystems: externalSystemsPromise,
        }).then(function (data) {
            self.available.contentTypes = data.contentTypes;
            self.available.networks = data.networks;
            self.available.categoryTypes = data.categories;
            self.available.categories = getAvailableCategories();
            self.available.submitters = data.submitters;
            self.available.externalSystems = data.externalSystems;
            self.searchCriteria.contentType = $location.search().contentType;
            self.searchCriteria.categoryTypes = SearchFilterService.getObjectsFromPathProp(self.available.categoryTypes, objectProp, 'categoryType');
            self.searchCriteria.networks = SearchFilterService.getObjectsFromPathProp(self.available.networks, objectProp, 'network');
            if (packageView) {
                self.searchCriteria.externalSystems = SearchFilterService.getObjectsFromPathProp(self.available.externalSystems, 'systemName', 'externalSystem');
            }
            else {
                self.searchCriteria.submitters = SearchFilterService.getObjectsFromPathProp(self.available.submitters, 'id', 'submitters');
            }
            // Value set in the watcher if url criteria contains categoryType
            if (!$location.search().hasOwnProperty('categoryType') || !$location.search().categoryType.length) {
                self.searchCriteria.categories = SearchFilterService.getObjectsFromPathProp(self.available.categories, objectProp, 'category');
            }
            self.loadingIndicator.show = false;
        });
    };
    var getAvailableSeasonsVolumes = function (contents) {
        var allSeasons = [];
        var allVolumes = [];
        if (contents.length === 1) {
            angular.forEach(contents, function (content) {
                angular.forEach(content.seasons, function (season) {
                    allSeasons.push(season);
                });
                angular.forEach(content.volumes, function (volume) {
                    allVolumes.push(volume);
                });
            });
        }
        else {
            angular.forEach(contents, function (content) {
                angular.forEach(content.seasons, function (season) {
                    season.name = content.prefix + '-' + season.name;
                    allSeasons.push(season);
                });
                angular.forEach(content.volumes, function (volume) {
                    volume.name = content.prefix + '-' + volume.name;
                    allVolumes.push(volume);
                });
            });
        }
        return {
            seasons: allSeasons,
            volumes: allVolumes
        };
    };
    function filterContentByNetworks(contents, networks) {
        var valid = [];
        if (!(networks && networks.length)) {
            return contents;
        }
        angular.forEach(contents, function (content) {
            for (var i = 0; i < networks.length; i++) {
                var network = networks[i];
                if (network.id === content.network.id) {
                    valid.push(content);
                }
            }
        });
        return valid;
    }
    $scope.$watch(function () {
        return self.searchCriteria.networks.length;
    }, function (newVal) {
        if (newVal) {
            self.available.contents = filterContentByNetworks(unfilteredContents, self.searchCriteria.networks);
            self.searchCriteria.contents = filterContentByNetworks(self.searchCriteria.contents, self.searchCriteria.networks);
        }
    });
    $scope.$watch(function () {
        return self.searchCriteria.categoryTypes.length;
    }, function () {
        self.available.categories = getAvailableCategories();
        if ($location.search().category && !categoriesSetFromLocation) {
            self.searchCriteria.categories = SearchFilterService.getObjectsFromPathProp(self.available.categories, objectProp, 'category');
        }
    });
    var removeInvalidSeasonsVolumes = function (availableCollection, selectedCollection) {
        var valid = [];
        angular.forEach(selectedCollection, function (selection) {
            for (var i = 0; i < availableCollection.length; i++) {
                var available = availableCollection[i];
                if (available.id === selection.id) {
                    valid.push(available);
                    break;
                }
            }
        });
        return valid;
    };
    var onSeriesChanged = function (newContents) {
        if (newContents) {
            PackagePropertiesQueryService.getSeasonsVolumesForContents(self.searchCriteria.contents).then(function (contentWithSeasonsVolumes) {
                var seasonsVolumes = getAvailableSeasonsVolumes(contentWithSeasonsVolumes);
                self.available.seasons = seasonsVolumes.seasons;
                self.available.volumes = seasonsVolumes.volumes;
                self.searchCriteria.seasons = removeInvalidSeasonsVolumes(self.available.seasons, self.searchCriteria.seasons);
                self.searchCriteria.volumes = removeInvalidSeasonsVolumes(self.available.volumes, self.searchCriteria.volumes);
                if (($location.search().season || $location.search().volume) && !seasonVolumeSetFromLocation) {
                    self.searchCriteria.seasons = SearchFilterService.getObjectsFromPathProp(self.available.seasons, objectProp, 'season');
                    self.searchCriteria.volumes = SearchFilterService.getObjectsFromPathProp(self.available.volumes, objectProp, 'volume');
                    seasonVolumeSetFromLocation = true;
                }
            });
        }
        else {
            self.available.seasons = [];
            self.searchCriteria.seasons = [];
            self.available.volumes = [];
            self.searchCriteria.volumes = [];
        }
    };
    $scope.$watch(function () {
        return self.searchCriteria.contentType;
    }, function (newVal, oldValue) {
        self.available.contents = [];
        self.searchCriteria.contents = [];
        if (packageView) {
            self.searchCriteria.seasons = [];
            self.searchCriteria.volumes = [];
        }
        if (newVal) {
            PackagePropertiesQueryService.getContents(newVal).then(function (contents) {
                unfilteredContents = angular.copy(contents);
                self.available.contents = filterContentByNetworks(unfilteredContents, self.searchCriteria.networks);
                if ($location.search().content && !contentSetFromLocation) {
                    self.searchCriteria.contents = SearchFilterService.getObjectsFromPathProp(self.available.contents, objectProp, 'content');
                    contentSetFromLocation = true;
                }
            });
            if (packageView && self.searchCriteria.contentType === 'Series') {
                $scope.$watch(function () {
                    return self.searchCriteria.contents.length;
                }, onSeriesChanged);
            }
        }
        else if (newVal !== oldValue) {
            self.available.contents = [];
            self.searchCriteria.contents = [];
            self.searchCriteria.categoryTypes = [];
            self.searchCriteria.categories = [];
            self.searchCriteria.networks = [];
            if (packageView) {
                self.searchCriteria.seasons = [];
                self.searchCriteria.volumes = [];
                self.searchCriteria.externalSystems = [];
            }
        }
    });
    self.submitterDropdownLabelFxn = function (submitter) {
        var firstName = (submitter.firstName) ? submitter.firstName : '';
        var lastName = (submitter.lastName) ? submitter.lastName : '';
        var label = (firstName + ' ' + lastName).trim();
        if (!label) {
            return submitter.username;
        }
        return label;
    };
    $scope.$on('modal.closing', function () {
        SearchFilterService.getCurrentSearchCriteria().contentType = self.searchCriteria.contentType;
        SearchFilterService.getCurrentSearchCriteria().network = SearchFilterService.extractQueryProp(self.searchCriteria.networks, objectProp);
        SearchFilterService.getCurrentSearchCriteria().categoryType = SearchFilterService.extractQueryProp(self.searchCriteria.categoryTypes, objectProp);
        SearchFilterService.getCurrentSearchCriteria().category = SearchFilterService.extractQueryProp(self.searchCriteria.categories, objectProp);
        SearchFilterService.getCurrentSearchCriteria().content = SearchFilterService.extractQueryProp(self.searchCriteria.contents, objectProp);
        if (packageView) {
            SearchFilterService.getCurrentSearchCriteria().season = SearchFilterService.extractQueryProp(self.searchCriteria.seasons, objectProp);
            SearchFilterService.getCurrentSearchCriteria().volume = SearchFilterService.extractQueryProp(self.searchCriteria.volumes, objectProp);
            SearchFilterService.getCurrentSearchCriteria().externalSystem = SearchFilterService.extractQueryProp(self.searchCriteria.externalSystems, 'systemName');
        }
        else {
            SearchFilterService.getCurrentSearchCriteria().submitters = SearchFilterService.extractQueryProp(self.searchCriteria.submitters, 'id');
        }
    });
    retrieveData();
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 7/5/16.
 */
'use strict';
angular.module('prism-ui.components').controller('MediaModalController', function (_, $q, $scope, $uibModalInstance, clipId, media, type, DownloadAssetService, EndPointService, PermissionsService, PreviewQueryService) {
    var self = this;
    var ViewClipProxyViewState = 'CLIP_ACTION_VIEW_PROXIES_VIEW_STATE';
    var DownloadClipProxyViewState = 'CLIP_ACTION_DOWNLOAD_PROXIES_VIEW_STATE';
    self.type = type;
    self.perms = {
        canViewProxy: false,
        canDownloadProxy: false
    };
    PreviewQueryService.getAssetUri(media)
        .finally(function () {
        self.media = media;
    });
    var getPermissions = function () {
        // if not a clip, allow all - at this time the package
        // manager is responsible for non-clip proxy
        // permissions
        if (clipId && !PermissionsService.isAdmin()) {
            var permissionsPromises = {
                viewClipProxy: PermissionsService.getPackagePermissions(ViewClipProxyViewState, clipId),
                downloadClipProxy: PermissionsService.getPackagePermissions(DownloadClipProxyViewState, clipId)
            };
            $q.all(permissionsPromises).then(function (perms) {
                self.perms.canViewProxy = PermissionsService.hasReadPermission(perms.viewClipProxy[0].permission);
                self.perms.canDownloadProxy = PermissionsService
                    .hasReadPermission(perms.downloadClipProxy[0].permission);
            });
        }
        else {
            self.perms.canViewProxy = true;
            self.perms.canDownloadProxy = true;
        }
    };
    self.downloadAsset = function () {
        if (self.perms.canDownloadProxy) {
            DownloadAssetService.downloadAsset(self.media.assetId, "video_proxy.mp4", DownloadAssetService.AssetType.Video, DownloadAssetService.ContentUse.Proxy);
        }
    };
    self.onDone = function () {
        $uibModalInstance.close();
    };
    getPermissions();
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by randysorensen on 8/15/16.
 */
//
// Glossary:
//
//		"group" - shown as "Type" in the UI. Examples are Package, Partner Package,
// 			Partner-specific, Series, Movie/Special, Volume, etc.
//
//		"uiControlHint" - shown as "Component" in the UI. Examples are CheckBox, List,
//			TextInput, etc.
//
//		"type" - should be "string", or "picklist" for lists
//
//		"ownerClass" - either "package", "nonPackage" or "partnerSpecific"
//
'use strict';
function MetadataItemEditModalController(_, $q, $routeParams, MetadataEditService, PartnerResourceFactory) {
    var self = this;
    var updateGroupName = function () {
        if (self.resolve.conversion) {
            self.groupNames = ['Media Conversion'];
        }
        else if (self.metadataItem.groupIds === undefined) {
            self.groupNames = (self.groupList && self.groupList.length === 1) ? self.groupList : '';
        }
        else {
            MetadataEditService.getGroupNamesByIds(self.metadataItem.groupIds).then(function (groupNames) {
                self.groupNames = groupNames;
            });
        }
    };
    var updatePartners = function () {
        self.selectedPartners = [];
        if (self.resolve.ownerClass === 'partner') {
            angular.forEach(self.metadataItem.partnerIds, function (partnerId) {
                self.selectedPartners.push(self.partnerDict[partnerId]);
            });
        }
    };
    var getPartnerList = function () {
        if (self.resolve.ownerClass === 'partner') {
            return PartnerResourceFactory.query({ fetchLimit: -1 })
                .$promise.then(function (partners) {
                self.partnerDropdownCollection = angular.copy(partners);
                self.partnerDict = {};
                angular.forEach(self.partnerDropdownCollection, function (partner) {
                    self.partnerDict[partner.id] = partner;
                });
                updatePartners();
            });
        }
    };
    var syncPropToForm = function () {
        updateGroupName();
        if (self.isPickList()) {
            self.picklistItems = self.metadataItem.picklistItems;
        }
        self.component = self.componentDict[self.metadataItem.uiControlHint];
        if (!!self.metadataItem.preferredWidth) {
            self.preferredWidth = self.preferredWidthLookup[self.metadataItem.preferredWidth];
        }
        if (self.resolve.conversion) {
            self.metadataItem.excludeFromMetadata = true;
        }
        updatePartners();
    };
    var syncFormToProp = function () {
        MetadataEditService.getGroupIdsByNames(self.groupNames).then(function (groupIds) {
            self.metadataItem.groupIds = groupIds;
        });
        self.metadataItem.uiControlHint = self.component.label;
        self.metadataItem.multiple = self.component.label === 'CheckboxList';
        self.metadataItem.type = self.isPickList() ? 'picklist' : 'string';
        if (self.isPickList()) {
            self.metadataItem.picklistItems = self.picklistItems;
        }
        else {
            delete self.metadataItem.picklistItems;
        }
        if (!!self.preferredWidth && self.preferredWidth.length > 0) {
            self.metadataItem.preferredWidth = self.preferredWidthDict[self.preferredWidth];
        }
        else {
            delete self.metadataItem.preferredWidth;
        }
        delete self.metadataItem.partnerIds;
        if (self.resolve.ownerClass === 'partner') {
            self.metadataItem.partnerIds = [];
            angular.forEach(self.selectedPartners, function (partner) {
                self.metadataItem.partnerIds.push(partner.id);
            });
        }
    };
    var getFormData = function () {
        var ownerClass = (self.resolve.mvpd) ? 'nonPackage' : self.resolve.ownerClass;
        var promises = [];
        promises.push(MetadataEditService.getGroupList(ownerClass)
            .then(function (groups) {
            if (self.resolve.mvpd) {
                _.remove(groups, function (group) { return group === 'Ad/PreRoll'; });
            }
            self.groupList = groups;
            updateGroupName();
        }));
        if (self.resolve.propertyId >= 0) {
            promises.push(MetadataEditService.getPropertyById(self.resolve.propertyId)
                .then(function (prop) {
                self.metadataItem = prop;
                syncPropToForm(prop);
            }));
        }
        return $q.all(promises);
    };
    self.$onInit = function () {
        self.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        if (self.resolve.ownerClass === 'partner') {
            self.metadataItem.partnerIds = [$routeParams.id];
        }
        if (self.resolve.conversion) {
            self.metadataItem.excludeFromMetadata = true;
        }
        self.loadingIndicator.show = true;
        $q.all([
            getPartnerList(),
            getFormData(),
        ]).then(function () {
            self.loadingIndicator.show = false;
        });
    };
    self.metaItemEditForm = undefined;
    self.tooltipTemplate = 'components/modal/metadata-item-editor/component-previews-template.html';
    // This includes all of the data for the component preview tooltips.
    self.componentDict = {
        CheckBox: { model: true },
        CheckboxList: {
            items: [
                { id: 1, displayName: 'Item 1' },
                { id: 2, displayName: 'Item 2' },
                { id: 3, displayName: 'Item 3' },
                { id: 4, displayName: 'Item 4' }
            ],
            model: [1, 2]
        },
        DateField: { model: new Date('2016/08/24') },
        DateFieldEnhanced: { model: new Date('2016/08/24') },
        DateTimeField: { model: new Date('2016-08-24T22:07:31.000+0000') },
        DateTimeFieldEnhanced: { model: new Date('2016-08-24T22:07:31.000+0000') },
        DropDownList: {
            collection: [
                { label: 'Item 1' },
                { label: 'Item 2' },
                { label: 'Item 3' }
            ]
            // model: { label: 'Item 1' }
        },
        List: {
            items: [
                { label: 'Item 1' },
                { label: 'Item 2' },
                { label: 'Item 3' },
                { label: 'Item 4' },
                { label: 'Item 5' }
            ],
            model: 'Item 2'
        },
        TextArea: { model: 'preview text' },
        TextInput: { model: 'preview text' },
        TimeCodeInput: { model: '01:00:19:34' },
        TimeInput: { model: '16:07:31' },
        TextListInput: {
            items: [
                { stringValue: '/path1' },
                { stringValue: '/path1' },
                { stringValue: '/path1' },
                { stringValue: '/path1' }
            ]
        }
    };
    if (self.resolve.conversion) {
        self.componentDict = _.pick(self.componentDict, [
            'CheckBox', 'DropDownList', 'TextArea', 'TextInput', 'TimeCodeInput'
        ]);
    }
    self.componentList = [];
    angular.forEach(self.componentDict, function (component, componentLabel) {
        component.label = componentLabel;
        self.componentList.push(component);
    });
    self.preferredWidthDict = { Small: '25', Medium: '50', Large: '75', Full: '100' }; // lookup label -> percent
    self.preferredWidthLookup = {}; // lookup percent -> label
    self.preferredWidthList = []; // for UI dropdown
    angular.forEach(self.preferredWidthDict, function (width, widthLabel) {
        self.preferredWidthList.push(widthLabel);
        self.preferredWidthLookup[width] = widthLabel;
    });
    self.selectedPartners = [];
    self.partnerDropdownCollection = [];
    self.partnerDict = {};
    self.component = self.componentList[0];
    self.groupList = [];
    self.groupName = '';
    self.picklistItems = [];
    self.preferredWidth = '';
    self.metadataItem = {
        id: -1,
        uiControlHint: self.component.label,
        type: 'string',
        multiple: false,
        advanced: false,
        synchronizeClips: false,
        liveUpdate: false,
        alwaysLive: false,
        searchable: false,
        visible: true,
        excludeFromMetadata: false,
        requiredAdPreRoll: false,
        requiredLongMovie: false,
        requiredLongSeason: false,
        requiredLongVolume: false,
        requiredShortMovie: false,
        requiredShortSeason: false,
        requiredShortVolume: false
    };
    self.showDisplayWidth = function () {
        switch (self.metadataItem.uiControlHint) {
            case 'CheckboxList':
            case 'DropDownList':
            case 'List':
            case 'TextArea':
            case 'TextInput':
                return true;
            default:
                return false;
        }
    };
    self.showMaxCharacterCount = function () {
        switch (self.metadataItem.uiControlHint) {
            case 'TextArea':
            case 'TextInput':
                return true;
            default:
                return false;
        }
    };
    self.isPickList = function () {
        switch (self.metadataItem.uiControlHint) {
            case 'CheckboxList':
            case 'DropDownList':
            case 'List':
                return true;
            default:
                return false;
        }
    };
    self.canSave = function () {
        return ((!!self.metadataItem.displayName && self.metadataItem.displayName.length > 0) &&
            (!!self.groupNames && self.groupNames.length > 0) &&
            ((self.isPickList() && self.picklistItems.length > 0) || !self.isPickList()) &&
            (!!self.metaItemEditForm && !self.metaItemEditForm.$pristine) &&
            (self.resolve.ownerClass !== 'partner' || self.selectedPartners.length > 0));
    };
    self.onPicklistChange = function () {
        self.metaItemEditForm.$setDirty();
    };
    self.onSave = function () {
        syncFormToProp();
        self.close({ $value: self.metadataItem });
    };
    self.showPartnerFlags = function () {
        return self.resolve.ownerClass === 'partner';
    };
}
angular.module('prism-ui.components').component('metadataItemEditModal', {
    templateUrl: 'components/modal/metadata-item-editor/metadata-item-edit-modal-template.html',
    controller: MetadataItemEditModalController,
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
function CustomMetadataController() {
    var self = this;
    self.isTextExpression = function (partnerMetadataItem) {
        if (partnerMetadataItem) {
            return partnerMetadataItem.hasOwnProperty('expression');
        }
    };
    self.generateComponentId = function (componentName, uiControlHint, isExpression) {
        var componentId = componentName + uiControlHint;
        if (!!self.main) {
            componentId += self.main;
        }
        else if (!!self.seasonVolume) {
            componentId += self.seasonVolume.name;
        }
        if (isExpression) {
            componentId += 'Expression';
        }
        return componentId.replace(/\s/g, '');
    };
}
angular.module('prism-ui.components').component('customMetadataComponent', {
    templateUrl: 'components/modal/subscription-properties-modal/custom-metadata-template.html',
    controller: CustomMetadataController,
    bindings: {
        main: '<',
        seasonVolume: '<',
        metadata: '<',
        batchUpdateEnabled: '<',
        partnerMeta: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: metadata-properties-modal-component
 *
 * Created by rwilliams on 5/24/17.
 */
'use strict';
function SubscriptionPropertiesModalController(_, $q, $timeout, uiGridConstants, DebugService, DynamicPropertiesService, PartnerEditService, SubscriptionsService, TerritoriesService, UtilsService) {
    var self = this;
    self.availableTerritories = [];
    self.availableSeasonVolumes = [];
    self.availableServiceableLanguages = [];
    //	Object and properties that are set and hold the initial is-open value for each accordion in
    // 	the custom metadata section.  These control the open/close chevron on each accordion's header
    self.customMetaContainers = {
        mainContainer: true,
        mainSeasonVolumeContainer: false,
        seasonContainers: [],
        volumeContainers: []
    };
    self.isMovieSpecial = false;
    var volumeSeasonGridApiPromise = $q.defer();
    var collaboratorGridApiPromise = $q.defer();
    var modalReadyPromise = $q.defer();
    var serviceableLanguageFlags = [
        'cCEnabled', 'subtitleEnabled', 'audioEnabled', 'artworkEnabled'
    ];
    //
    // Creates a new ServiceableLanguage object for the given
    // language.
    //
    var createServiceableLanguage = function (language) {
        return {
            language: language,
            cCEnabled: false,
            subtitleEnabled: false,
            audioEnabled: false,
            artworkEnabled: false,
        };
    };
    var serviceableLanguageUsed = function (serviceableLanguage) {
        return _.some(serviceableLanguageFlags, function (flagName) {
            return (serviceableLanguage[flagName] === true);
        });
    };
    var getServiceableLanguageIndex = function (serviceableLanguageList, language) {
        if (language) {
            return _.findIndex(serviceableLanguageList, {
                language: { id: language.id }
            });
        }
        return _.findIndex(serviceableLanguageList, function (serviceableLanguage) {
            return (!serviceableLanguage.language);
        });
    };
    //
    // Called when the serviceable languages array should be
    // rebuilt (specifically, during initialization and when
    // reverting).
    //
    var updateServiceableLanguages = function () {
        _.forEach(self.allAvailableLanguages.concat(undefined), function (language) {
            var subscriptionIndex = getServiceableLanguageIndex(self.subscription.serviceableLanguages, language);
            var serviceableLanguage;
            if (subscriptionIndex >= 0) {
                serviceableLanguage = self.subscription.serviceableLanguages[subscriptionIndex];
                // If language isn't used, don't keep this language
                if (!serviceableLanguageUsed(serviceableLanguage)) {
                    self.subscription.serviceableLanguages.splice(subscriptionIndex, 1);
                }
            }
            else {
                serviceableLanguage = createServiceableLanguage(language);
            }
            // Add language to visible list
            var gridIndex = getServiceableLanguageIndex(self.availableServiceableLanguages, language);
            if (gridIndex >= 0) {
                _.assign(self.availableServiceableLanguages[gridIndex], serviceableLanguage);
            }
            else {
                self.availableServiceableLanguages.push(serviceableLanguage);
            }
        });
        self.availableServiceableLanguages = _
            .chain(self.availableServiceableLanguages)
            .orderBy('language.name')
            .partition({ language: { name: 'English' } })
            .flatten()
            .partition(function (serviceableLanguage) { return !serviceableLanguage.language; })
            .flatten()
            .value();
        // If nothing selected, implies serviceableLanguage grid "All" chosen (and in valid state),
        // so make array valid also
        if (self.subscription.serviceableLanguages) {
            self.hasNoLanguages = false;
        }
        else {
            self.subscription.serviceableLanguages = [];
            self.hasNoLanguages = self.batchUpdate;
        }
        $timeout(self.editorForm.$setPristine);
    };
    this.onServiceableLanguagesChanged = function (validServiceableLanguages) {
        self.subscription.serviceableLanguages = validServiceableLanguages;
        if (!_.isNull(validServiceableLanguages)) {
            self.hasNoLanguages = false;
        }
        self.editorForm.$setDirty();
    };
    var getRoles = function (videoRoles) {
        var roles = [];
        _.forEach(videoRoles, function (videoRole) {
            if (videoRole.role.name !== 'Main Video') {
                roles.push(videoRole.role);
            }
        });
        return roles;
    };
    var getCrewMemberRolesAsStrings = function (crewMemberRoles) {
        var roles = [];
        _.forEach(crewMemberRoles, function (crewMemberRole) {
            roles.push(crewMemberRole.name);
        });
        return roles;
    };
    var getCrewMemberRoles = function () {
        var roleNames = DynamicPropertiesService.getPropValueAsList('package.crewMemberRoles');
        var crewMemberRoles = [];
        crewMemberRoles.push({ name: 'Actor' });
        _.forEach(roleNames, function (roleName) {
            crewMemberRoles.push({ name: roleName });
        });
        return crewMemberRoles;
    };
    var selectSeasonVolumeRows = function () {
        volumeSeasonGridApiPromise.promise.then(function () {
            var volumeSeasons = (self.subscription.seasonSubscription) ? self.subscription.seasons : self.subscription.volumes;
            var seasonOrVolume = (self.subscription.seasonSubscription) ? 'season' : 'volume';
            self.volumeSeasonGridApi.grid.modifyRows(self.volumeSeasonGridOptions.data);
            _.forEach(volumeSeasons, function (volumeSeason) {
                var _a;
                var row = _.find(self.volumeSeasonGridOptions.data, (_a = {},
                    _a[seasonOrVolume] = {
                        id: volumeSeason[seasonOrVolume].id
                    },
                    _a));
                self.volumeSeasonGridApi.selection.selectRow(row);
            });
            self.volumeSeasonGridApi.grid.modifyRows(self.volumeSeasonGridOptions.data);
        });
    };
    var selectCollaboratorRoles = function () {
        if (!self.subscription.actorsRequired) {
            collaboratorGridApiPromise.promise.then(function () {
                _.forEach(self.collaboratorGridOptions.data, function (row) {
                    _.forEach(self.subscription.requiredCrewRoles, function (crewRole) {
                        if (row.name === crewRole) {
                            self.collaboratorGridApi.grid.modifyRows(self.collaboratorGridOptions.data);
                            self.collaboratorGridApi.selection.selectRow(row);
                        }
                    });
                });
            });
        }
    };
    var setDefaultData = function (data) {
        if (!self.batchUpdate) {
            self.collaboratorGridOptions.data = getCrewMemberRoles();
            self.availableVideoRoles = data.contentCategory ? getRoles(data.contentCategory.videoRoles) : [];
            switch (self.content.type) {
                case 'Series':
                    var subTypeName = self.subscription.seasonSubscription ? 'seasons' : 'volumes';
                    var seasonOrVolume = self.subscription.seasonSubscription ? 'season' : 'volume';
                    self.availableSeasonVolumes = _.map(self.content[subTypeName], function (seasonVolume) {
                        var _a, _b;
                        var result = _.find(self.subscription[subTypeName], (_a = {},
                            _a[seasonOrVolume] = {
                                id: seasonVolume.id
                            },
                            _a));
                        if (!result) {
                            result = (_b = {},
                                _b[seasonOrVolume] = seasonVolume,
                                _b);
                        }
                        return result;
                    });
                    self.setSeasonVolumeGridData(seasonOrVolume);
                    self.allSeasonVolume = (!_.size(self.subscription[subTypeName]));
                    self.allCollaborators = self.subscription.actorsRequired || false;
                    break;
                case 'Movie':
                    self.allCollaborators = true;
                    break;
            }
        }
    };
    var setSubscriptionData = function () {
        if (!self.batchUpdate) {
            self.subscription.artwork = _.sortBy(self.subscription.artwork, ['artworkAcceptProfile.name']);
            self.artworkGridOptions.data = self.subscription.artwork;
            volumeSeasonGridApiPromise.resolve();
            collaboratorGridApiPromise.resolve();
        }
        if (self.subscription.deliveryEligibilityExpression) {
            self.deliveryEligibility = true;
        }
        updateServiceableLanguages();
    };
    self.showSeasonVolumeContainer = function (seasonVolume) {
        return seasonVolume.hasOwnProperty('id');
    };
    self.isSeasonVolumeMetaValid = function () {
        var metaValid = false;
        if (self.subscription && !self.batchUpdate &&
            _.get(self.subscription, 'content.type') !== 'Movie/Special') {
            var volumeSeasons = (self.subscription.seasonSubscription) ? self.subscription.seasons : self.subscription.volumes;
            metaValid = _.some(volumeSeasons, function (seasonVolume) {
                return seasonVolume.id;
            });
        }
        return metaValid;
    };
    var fixupMetadataProperties = function () {
        // Add an isExpression field to the subscription metadata
        // properties objects for radio button functionality
        var collection = self.subscription.seasonSubscription ? self.subscription.seasons : self.subscription.volumes;
        if ((!self.batchUpdate || self.isPartner) && self.subscription.metadata.properties) {
            _.forEach(self.partnerMetadata, function (property) {
                var targetProp = self.subscription.metadata.properties[property.name];
                var excludedTypes = ['TextInput', 'TextArea', 'CheckboxList', 'DropDownList', 'List'];
                if (!_.includes(excludedTypes, property.uiControlHint)) {
                    targetProp.isExpression = !targetProp.hasOwnProperty('value');
                }
                _.forEach(collection, function (seasonOrVolume) {
                    if (seasonOrVolume.metadata) {
                        var targetSeasonVolumeProp = seasonOrVolume.metadata.properties[property.name];
                        if (!_.includes(excludedTypes, property.uiControlHint)) {
                            targetSeasonVolumeProp.isExpression = !targetSeasonVolumeProp.hasOwnProperty('value');
                        }
                    }
                });
            });
        }
        // 	Set the initial is-open value for all the season and volume accordions in order
        //	to control the open/close chevron on each custom metadata accordion header
        _.forEach(collection, function (seasonOrVolume) {
            var seasonVolumeObj = {};
            var seasonVolumeName = self.subscription.seasonSubscription ? seasonOrVolume.season.name : seasonOrVolume.volume.name;
            var container = self.subscription.seasonSubscription ? 'seasonContainers' : 'volumeContainers';
            seasonVolumeObj[seasonVolumeName] = false;
            self.customMetaContainers[container].push(seasonVolumeObj);
        });
    };
    var isHomogeneousContent = function () {
        // Iterate an array of subscriptions and return true if
        // they all share the same content
        var contentIds = _.map(self.subscriptions, 'content.id');
        var uniqueContentIds = _.uniq(contentIds);
        return uniqueContentIds.length === 1;
    };
    //
    // In batch update, we can default the modal properties
    // to a specific value when all of the selected
    // subscriptions share the same value.
    //
    // These functions attempt to set the default value based on
    // that.
    //
    var setDefaultChangeSetValue = function (changeSet, propName) {
        var i = 0;
        var sub;
        do {
            sub = self.subscriptions[i];
            if (sub.hasOwnProperty(propName) && !changeSet.hasOwnProperty(propName)) {
                changeSet[propName] = sub[propName];
            }
            else if (!sub.hasOwnProperty(propName) ||
                UtilsService.compareBasic(changeSet[propName], sub[propName]) !== 0) {
                delete changeSet[propName];
                break;
            }
            ++i;
        } while (i < self.subscriptions.length);
    };
    var copyServiceableLanguagesWithoutId = function (serviceableLanguages) {
        var results = [];
        for (var i in serviceableLanguages) {
            results.push(_.omit(serviceableLanguages[i], 'id'));
        }
        return results;
    };
    var setDefaultLanguagesValue = function (changeSet) {
        var languagesValue = copyServiceableLanguagesWithoutId(self.subscriptions[0].serviceableLanguages);
        for (var i = 1; i < self.subscriptions.length; ++i) {
            var languages = copyServiceableLanguagesWithoutId(self.subscriptions[i].serviceableLanguages);
            if (UtilsService.compareBasic(languagesValue, languages) !== 0) {
                return;
            }
        }
        changeSet.serviceableLanguages = languagesValue;
    };
    var setDefaultMetadataPropertyValue = function (changeSet, propName) {
        var i = 0;
        var sub;
        var propValue = null;
        do {
            sub = self.subscriptions[i];
            // Found a few of these in the database
            if (!sub.metadata || !sub.metadata.properties) {
                console.warn('Subscription has no metadata and/or no metadata properties:');
                console.warn('  -> ' + sub.partner.name + ' / ' + sub.content.name + ' / ' + sub.category.name);
                return;
            }
            if (!propValue) {
                // first iteration - grab metadata property value
                // of first subscription in list
                propValue = sub.metadata.properties[propName];
            }
            else if (UtilsService.compareBasic(propValue, sub.metadata.properties[propName]) !== 0) {
                // "this" subscription's value for the property
                // doesn't match previous subscriptions, so assign
                // no default in the change set
                return;
            }
            ++i;
        } while (i < self.subscriptions.length);
        if (propValue.value) {
            changeSet.metadata.properties[propName].value = propValue.value;
        }
        else if (propValue.expression) {
            changeSet.metadata.properties[propName].expression = propValue.expression;
        }
    };
    var createDefaultChangeSet = function () {
        //
        // Creates the initial, default subscription "change set"
        // for batch updating. By default, we don't actually want
        // to change anything. Rather by setting these values, we
        // set the default values that the different property
        // components in the modal.
        //
        // For instance, if all of the subscriptions in the batch
        // update have the same preroll, that preroll will be
        // selected in the modal.
        //
        var batchUpdateFields = ['enabled', 'preRoll', 'preRollSeasonVolume', 'postRoll', 'postRollSeasonVolume',
            'deliveryEligibilityExpression', 'territories', 'allCollaborators'];
        var partnerOnlyBatchUpdateFields = ['nielsenTemplate', 'watermark', 'watermarkSeasonVolume',
            'watermarkFadeInSeconds', 'watermarkFadeOutSeconds', 'watermarkOffsetSeconds', 'dueDateTemplate'];
        if (self.isPartner) {
            batchUpdateFields = _.concat(batchUpdateFields, partnerOnlyBatchUpdateFields);
        }
        var changeSet = {};
        _.forEach(batchUpdateFields, function (fieldName) {
            setDefaultChangeSetValue(changeSet, fieldName);
        });
        setDefaultLanguagesValue(changeSet);
        if (self.isPartner) {
            // Partner custom metadata cannot be batch-updated
            // from the content categories screen.
            changeSet.metadata = { properties: {} };
            _.forEach(self.partnerMetadata, function (prop) {
                changeSet.metadata.properties[prop.name] = {};
                setDefaultMetadataPropertyValue(changeSet, prop.name);
            });
        }
        return changeSet;
    };
    var getData = function () {
        DynamicPropertiesService.queryForProperties()
            .then(function () {
            return SubscriptionsService.getCollectionData(self.batchUpdate, self.isPartner, self.partner, self.content, self.category, self.subscriptions);
        }).then(function (collectionData) {
            if (collectionData.partnerMetadata !== undefined) {
                self.partnerMetadata = _.sortBy(collectionData.partnerMetadata, [function (metaItem) {
                        return metaItem.displayIndex;
                    }]);
            }
            if (collectionData.partner !== undefined) {
                self.partner = collectionData.partner;
                PartnerEditService.getDueDateTemplatesForPartner(self.partner.id, false)
                    .then(function (dueDateTemplates) {
                    _.set(self, 'availableDueDateTemplates', dueDateTemplates);
                });
                PartnerEditService.getNielsenTemplatesForPartner(self.partner.id)
                    .then(function (nielsenTemplates) {
                    _.set(self, 'availableNielsenTemplates', nielsenTemplates);
                });
            }
            self.availablePrerolls = _.concat(collectionData.content !== undefined ? collectionData.content.preRolls : [], collectionData.network !== undefined ? collectionData.network.preRolls : []);
            self.availablePostrolls = _.concat(collectionData.content !== undefined ? collectionData.content.postRolls : [], collectionData.network !== undefined ? collectionData.network.postRolls : []);
            self.availableWatermarks = _.concat(collectionData.content !== undefined ? collectionData.content.watermarks : [], collectionData.network !== undefined ? collectionData.network.watermarks : []);
            self.artworks = _.concat(collectionData.content !== undefined ? collectionData.content.artwork : [], collectionData.network !== undefined ? collectionData.network.artwork : []);
            self.availableBreakPrePostRolls = _.concat(collectionData.content !== undefined ? collectionData.content.breakPrePostRolls : [], collectionData.network !== undefined ? collectionData.network.breakPrePostRolls : []);
            self.availableIntermediateTemplates = collectionData.intermediateTemplateData;
            self.artworkAcceptProfiles = collectionData.artworkAcceptProfiles;
            self.allAvailableLanguages = collectionData.languages;
            self.subscription = self.batchUpdate ? createDefaultChangeSet() : self.subscriptions[0];
            if (collectionData.content !== undefined) {
                self.content = collectionData.content;
            }
            if (collectionData.contentCategory !== undefined) {
                self.contentCategory = collectionData.contentCategory;
                setDefaultData(self.contentCategory);
            }
            setSubscriptionData();
            self.setArtworkGridColumns(self.content);
            fixupMetadataProperties();
            modalReadyPromise.resolve();
            self.loadingIndicator.show = false;
        });
        // get the available territories
        TerritoriesService.getAllTerritories({ fetchLimit: 0, includeHidden: false }).then(function (territories) {
            // Place USA at the top of the list
            var territoriesWithUsaFirst = _.chain(territories)
                .partition({ name: 'USA' })
                .flatten()
                .value();
            _.set(self, 'availableTerritories', territoriesWithUsaFirst);
        });
    };
    var setRequiredCollaborators = function () {
        if (self.allCollaborators) {
            self.subscription.actorsRequired = true;
            return getCrewMemberRolesAsStrings(self.collaboratorGridOptions.data);
        }
        self.subscription.actorsRequired = false;
        return getCrewMemberRolesAsStrings(self.collaboratorGridApi.selection.getSelectedRows());
    };
    self.dropDownSelectLabelFunction = function (item, field) {
        return _.get(item, field);
    };
    self.typeChange = function () {
        setDefaultData(self.contentCategory);
        selectSeasonVolumeRows();
    };
    self.toggleRows = function (event, grid) {
        if (grid.api.selection.selectAll) {
            grid.api.selection.clearSelectedRows(event);
            grid.api.selection.selectAll = false;
        }
        else {
            grid.api.selection.selectAllVisibleRows(event);
            grid.api.selection.selectAll = true;
        }
    };
    self.enabledVideoRolesUpdated = function (context, newEnabledEntities) {
        self.subscription.videoRoles = newEnabledEntities;
        self.editorForm.$setDirty();
    };
    self.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };
    self.$onInit = function () {
        self.loadingIndicator.show = true;
        // Passed into modal from grid
        self.isPartner = self.resolve.isPartner;
        self.subscriptions = self.resolve.subscriptions;
        self.batchUpdate = self.subscriptions.length > 1;
        self.isChangingLanguages = !self.batchUpdate;
        self.partnerMetadata = null;
        self.partner = null;
        self.content = null;
        self.category = null;
        self.partner = !self.batchUpdate || self.isPartner ? self.subscriptions[0].partner : null;
        self.content = !self.batchUpdate || (!self.isPartner || isHomogeneousContent()) ? self.subscriptions[0].content : null;
        self.category = !self.batchUpdate || !self.isPartner ? self.subscriptions[0].category : null;
        self.deliveryEligibility = false;
        self.allSeasonVolume = true;
        self.allCollaborators = false;
        getData();
    };
    self.isOkEnabled = function () {
        var languagesValid = !self.isChangingLanguages || !!_.get(self.subscription, 'serviceableLanguages');
        return (self.editorForm.$dirty && languagesValid);
    };
    self.onOk = function () {
        if (self.subscription.deliveryEligibilityExpression && !self.deliveryEligibility) {
            self.subscription.deliveryEligibilityExpression = '';
        }
        if (!self.isChangingLanguages) {
            delete self.subscription.serviceableLanguages;
        }
        if (!self.batchUpdate) {
            if (self.subscription.content.type !== 'Movie/Special') {
                var seasonsVolumes = (self.allSeasonVolume) ? [] : self.volumeSeasonGridApi.selection.getSelectedRows();
                if (self.subscription.seasonSubscription) {
                    self.subscription.seasons = seasonsVolumes;
                    self.subscription.volumes = [];
                }
                else {
                    self.subscription.seasons = [];
                    self.subscription.volumes = seasonsVolumes;
                }
            }
            _.remove(self.subscription.artwork, function (artworkAsset) {
                return !artworkAsset.artwork.id && !artworkAsset.artworkAcceptProfile.id;
            });
            if (self.content.type !== 'Ad/PreRoll') {
                self.subscription.requiredCrewRoles = setRequiredCollaborators();
            }
        }
        var customMeta = self.subscription.metadata;
        if (customMeta && customMeta.properties) {
            for (var metadataItem in customMeta.properties) {
                if (customMeta.properties.hasOwnProperty(metadataItem)) {
                    if (customMeta.properties[metadataItem].hasOwnProperty('isExpression')) {
                        if (customMeta.properties[metadataItem].isExpression && customMeta.properties[metadataItem].hasOwnProperty('value')) {
                            delete customMeta.properties[metadataItem].value;
                        }
                        if (!customMeta.properties[metadataItem].isExpression && customMeta.properties[metadataItem].hasOwnProperty('expression')) {
                            delete customMeta.properties[metadataItem].expression;
                        }
                        delete customMeta.properties[metadataItem].isExpression;
                    }
                }
            }
        }
        self.close({ $value: self.subscription });
    };
    self.addArtwork = function () {
        var artworkAsset = {
            artwork: {},
            artworkAcceptProfile: {},
            artworkSeasonVolume: false
        };
        self.artworkGridOptions.data.push(artworkAsset);
        self.editorForm.$setDirty();
    };
    self.removeArtwork = function () {
        var selectedRows = self.artworkGridApi.selection.getSelectedRows();
        if (selectedRows.length > 0) {
            _.pullAll(self.artworkGridOptions.data, selectedRows);
            self.editorForm.$setDirty();
        }
    };
    // This is currently only used for the Artwork "Use
    // Season/Volume Artwork" column checkboxes in the artwork
    // grid.
    self.checkMarkCellClicked = function (row, event) {
        event.stopPropagation();
        row.isSelected = true;
        row.entity.artworkSeasonVolume = !row.entity.artworkSeasonVolume;
        self.editorForm.$setDirty();
    };
    //===============//
    // Grids Columns //
    //===============//
    var seasonColDefs = [
        {
            name: 'checkMarkRowHeaderCol',
            field: 'checkMark',
            width: 30,
            enableColumnMenu: false,
            enableSorting: false,
            enableColumnResizing: false,
            headerCellTemplate: 'components/modal/subscription-properties-modal/cellTemplates/season-check-mark-header-cell-template.html',
            cellTemplate: 'components/modal/subscription-properties-modal/cellTemplates/season-check-mark-cell-template.html'
        },
        {
            field: 'season.name',
            name: 'Season',
            width: 160,
            sortable: false,
            enableColumnMenu: false,
            sort: {
                direction: uiGridConstants.ASC,
                priority: 0
            }
        },
        {
            field: 'season.startDate',
            name: 'Start Date',
            width: 140,
            sortable: false,
            enableColumnMenu: false,
            cellFilter: 'amDateFormat: \'MMMM DD, YYYY\''
        },
        {
            field: 'season.endDate',
            name: 'End Date',
            width: 140,
            sortable: false,
            enableColumnMenu: false,
            cellFilter: 'amDateFormat: \'MMMM DD, YYYY\''
        },
        {
            field: 'modified',
            name: 'Modified',
            sortable: false,
            enableColumnMenu: false
        }
    ];
    var volumeColDefs = [
        {
            name: 'checkMarkRowHeaderCol',
            field: 'checkMark',
            width: 30,
            enableColumnMenu: false,
            enableSorting: false,
            enableColumnResizing: false,
            headerCellTemplate: 'components/modal/subscription-properties-modal/cellTemplates/volume-check-mark-header-cell-template.html',
            cellTemplate: 'components/modal/subscription-properties-modal/cellTemplates/volume-check-mark-cell-template.html'
        },
        {
            field: 'volume.name',
            name: 'Volume',
            width: 160,
            sortable: false,
            enableColumnMenu: false,
            sort: {
                direction: uiGridConstants.ASC,
                priority: 0
            }
        },
        {
            field: 'volume.startDate',
            name: 'Start Date',
            width: 140,
            sortable: false,
            enableColumnMenu: false,
            cellFilter: 'amDateFormat: \'MMMM DD, YYYY\''
        },
        {
            field: 'volume.endDate',
            name: 'End Date',
            width: 140,
            sortable: false,
            enableColumnMenu: false,
            cellFilter: 'amDateFormat: \'MMMM DD, YYYY\''
        },
        {
            field: 'modified',
            name: 'Modified',
            sortable: false,
            enableColumnMenu: false
        }
    ];
    var dropdownSortByName = function (a, b) {
        return _.toLower(_.get(a, 'name')).localeCompare(_.toLower(_.get(b, 'name')));
    };
    var artworkGridColumns = [
        {
            field: 'checkMark',
            name: 'checkMarkRowHeaderCol',
            width: 30,
            enableColumnMenu: false,
            enableSorting: false,
            enableColumnResizing: false,
            cellTemplate: 'components/visual/grid/check-mark-template.html',
            headerCellTemplate: 'components/modal/subscription-properties-modal/cellTemplates/check-mark-header-template.html'
        },
        {
            field: 'artwork',
            name: 'Artwork',
            sortable: true,
            enableSorting: true,
            sort: {
                direction: uiGridConstants.ASC,
                priority: 0
            },
            sortingAlgorithm: dropdownSortByName,
            enableColumnMenu: false,
            width: 330,
            cellTemplate: 'components/modal/subscription-properties-modal/cellTemplates/artwork-cell-template.html'
        },
        {
            field: 'artworkAcceptProfile',
            name: 'Artwork MAP',
            width: 455,
            sortable: true,
            enableSorting: true,
            sort: {
                direction: uiGridConstants.ASC,
                priority: 1
            },
            sortingAlgorithm: dropdownSortByName,
            enableColumnMenu: false,
            cellTemplate: 'components/modal/subscription-properties-modal/cellTemplates/artwork-accept-profile-cell-template.html'
        },
        {
            field: 'artworkSeasonVolume',
            name: 'S/V Art',
            enableColumnMenu: false,
            enableSorting: false,
            enableColumnResizing: false,
            cellTemplate: 'components/visual/grid/check-mark-boolean-template.html'
        }
    ];
    var collaboratorGridColumns = [
        {
            name: 'checkMarkRowHeaderCol',
            field: 'checkMark',
            width: 30,
            enableColumnMenu: false,
            enableSorting: false,
            enableColumnResizing: false,
            cellTemplate: 'components/modal/subscription-properties-modal/cellTemplates/collaborator-check-mark-cell-template.html',
            headerCellTemplate: 'components/modal/subscription-properties-modal/cellTemplates/collaborator-check-mark-header-cell-template.html'
        },
        {
            field: 'name',
            name: 'Collaborator',
            sortable: false,
            enableColumnMenu: false
        }
    ];
    self.setSeasonVolumeGridData = function (seasonOrVolume) {
        self.volumeSeasonGridOptions.data = self.availableSeasonVolumes;
        if (seasonOrVolume === 'season') {
            self.volumeSeasonGridOptions.columnDefs = seasonColDefs;
        }
        else {
            self.volumeSeasonGridOptions.columnDefs = volumeColDefs;
        }
    };
    self.setArtworkGridColumns = function (content) {
        if (content && content.type === 'Movie/Special') {
            artworkGridColumns.splice(3, 1);
            self.isMovieSpecial = true;
        }
        self.artworkGridOptions.columnDefs = artworkGridColumns;
    };
    //===============//
    // Grids Options //
    //===============//
    self.volumeSeasonGridOptions = {
        selectionRowHeaderColName: 'checkMarkRowHeaderCol',
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: false,
        enablePaginationControls: false,
        enableFullRowSelection: true,
        enableSorting: false,
        rowHeight: 26,
        multiSelect: true,
        minRowsToShow: 10,
        enableVerticalScrollbar: 2,
        columnDefs: seasonColDefs,
        onRegisterApi: function (gridApi) {
            self.volumeSeasonGridApi = gridApi;
            selectSeasonVolumeRows();
        }
    };
    self.artworkGridOptions = {
        selectionRowHeaderColName: 'checkMarkRowHeaderCol',
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: false,
        enablePaginationControls: false,
        enableFullRowSelection: true,
        enableSorting: true,
        rowHeight: 26,
        multiSelect: true,
        minRowsToShow: 4,
        enableVerticalScrollbar: 2,
        onRegisterApi: function (gridApi) {
            self.artworkGridApi = gridApi;
        }
    };
    self.collaboratorGridOptions = {
        selectionRowHeaderColName: 'checkMarkRowHeaderCol',
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: false,
        enablePaginationControls: false,
        enableFullRowSelection: true,
        enableSorting: false,
        rowHeight: 26,
        multiSelect: true,
        minRowsToShow: 5,
        enableVerticalScrollbar: 2,
        columnDefs: collaboratorGridColumns,
        onRegisterApi: function (gridApi) {
            self.collaboratorGridApi = gridApi;
            modalReadyPromise.promise.then(function () {
                selectCollaboratorRoles();
            });
        }
    };
}
angular.module('prism-ui.components').component('subscriptionPropertiesModal', {
    templateUrl: 'components/modal/subscription-properties-modal/subscription-properties-modal-template.html',
    controller: SubscriptionPropertiesModalController,
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by richardwilliams on 4/13/15.
 */
'use strict';
angular.module('prism-ui.components.navigation').controller('BreadcrumbController', function ($location, $route, BreadcrumbService, PackageUtilService, NotificationService) {
    var self = this;
    self.breadcrumbs = BreadcrumbService.getBreadcrumbs();
    function setBreadcrumbsFromCurrentRoute() {
        if ($route.current.rootRoute) {
            var parentRoute = $route.routes[$route.current.rootRoute];
            var rootBreadcrumb = { location: parentRoute.originalPath, name: parentRoute.label, params: {} };
            self.breadcrumbs.push(rootBreadcrumb);
        }
    }
    self.navigateToBreadCrumb = function (breadcrumb) {
        if (!BreadcrumbService.editService || !BreadcrumbService.editService.editorForm ||
            (BreadcrumbService.editService.editorForm && BreadcrumbService.editService.editorForm.$pristine)) {
            if (BreadcrumbService.editService && BreadcrumbService.editService.postCloseUpdate) {
                BreadcrumbService.editService.postCloseUpdate();
            }
            if ($route.current.rootRoute === breadcrumb.location) {
                BreadcrumbService.clearBreadcrumbs();
            }
            else {
                self.breadcrumbs = BreadcrumbService.removeBreadcrumbs();
            }
            if (self.paramMap) {
                for (var param in self.paramMap) {
                    var re = new RegExp(':' + param);
                    breadcrumb.location = breadcrumb.location.replace(re, self.paramMap[param]);
                }
            }
            $location.path(breadcrumb.location);
            if (breadcrumb.params) {
                $location.search(breadcrumb.params);
            }
        }
        else {
            var message = 'You have unsaved changes.  Please save or revert.';
            NotificationService.createWarningNotification(message, '');
        }
    };
    if (!self.breadcrumbs.length) {
        setBreadcrumbsFromCurrentRoute();
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by richardwilliams on 4/13/15.
 */
'use strict';
angular.module('prism-ui.components.navigation').directive('breadcrumb', function () {
    return {
        restrict: 'E',
        controller: 'BreadcrumbController',
        controllerAs: 'breadCrumbCtrl',
        templateUrl: 'components/navigation/breadcrumb/breadcrumb-template.html',
        scope: {},
        bindToController: {
            tabName: '=',
            paramMap: '='
        }
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 7/8/15.
 */
'use strict';
angular.module('prism-ui.components.navigation').service('BreadcrumbService', function () {
    var self = this;
    var breadcrumbs = [];
    self.editService = null;
    self.addBreadcrumb = function (breadcrumb) {
        breadcrumbs.push(breadcrumb);
    };
    self.removeBreadcrumbs = function () {
        angular.forEach(breadcrumbs, function (breadcrumb, index) {
            var startIndex = breadcrumbs.length - 1;
            if (breadcrumbs[startIndex].name !== breadcrumb.name) {
                breadcrumbs.splice(startIndex, breadcrumbs.length - (index + 1));
            }
        });
        return breadcrumbs;
    };
    self.getBreadcrumbs = function () {
        return breadcrumbs;
    };
    self.clearBreadcrumbs = function () {
        breadcrumbs.splice(0, breadcrumbs.length);
    };
    self.updateBreadcrumbs = function (breadcrumb) {
        if (breadcrumb && (breadcrumbs.length === 0 || breadcrumbs[breadcrumbs.length - 1].name !== breadcrumb.name)) {
            self.addBreadcrumb(breadcrumb);
        }
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by rwilliams on 4/27/17.
 */
'use strict';
function PaginationControlsController(_) {
    var MAX_DROPDOWN_SIZE = 1000;
    var self = this;
    //=========//
    // General //
    //=========//
    self.isDisabled = function () {
        return self.disabled || false;
    };
    self.isMultiPage = function () {
        return !!self.pagingOptions && self.pagingOptions.contentTotal !== 0;
    };
    self.showPageNumberAsText = function () {
        //
        // TODO ABC-11744:
        //  If previous screen had a lot of entries in totalPagesArray,
        //  a new screen with pagination might display all of those entries
        //  and freeze the UI for a few seconds.
        //      To properly fix this issue,
        //      we should optimize the dropdown instead.
        //
        return (self.pageNumberIsTextInput ||
            _.chain(self)
                .get('pagingOptions.totalPagesArray')
                .size()
                .value() > MAX_DROPDOWN_SIZE);
    };
    //======================//
    // Previous Page Button //
    //======================//
    self.isPrevBtnDisabled = function () {
        return !!self.pagingOptions && self.pagingOptions.currentPage === 1;
    };
    self.onPrevBtnClicked = function ($event) {
        // ensure button doesn't stay focused
        $event.target.blur();
        if (!self.isPrevBtnDisabled()) {
            self.prevPageHandler();
        }
    };
    //==================//
    // Next Page Button //
    //==================//
    self.isNextBtnDisabled = function () {
        return !!self.pagingOptions && self.pagingOptions.currentPage === self.pagingOptions.totalPages;
    };
    self.onNextBtnClicked = function ($event) {
        // ensure button doesn't stay focused
        $event.target.blur();
        if (!self.isNextBtnDisabled()) {
            self.nextPageHandler();
        }
    };
    //====================//
    // Page Size Selector //
    //====================//
    self.onPageSizeChanged = function () {
        if (!!self.pageSizeChangeHandler) {
            self.pageSizeChangeHandler();
        }
    };
    //========================//
    // Page Number Text Input //
    //========================//
    self.onPageNumberTextInputKeyDown = function ($event) {
        if ($event.keyCode === 13) {
            $event.target.blur();
            $event.preventDefault();
            var currentPageNum = _.parseInt(self.pagingOptions.currentPage);
            if (isNaN(currentPageNum) || currentPageNum < 1) {
                currentPageNum = 1;
            }
            self.pagingOptions.currentPage = currentPageNum;
            self.jumpToPageHandler();
        }
    };
}
angular
    .module('prism-ui.components.navigation')
    .component('paginationControls', {
    templateUrl: 'components/navigation/pagination/pagination-controls-template.html',
    controller: PaginationControlsController,
    bindings: {
        nextPageHandler: '&',
        prevPageHandler: '&',
        jumpToPageHandler: '&',
        pageSizeChangeHandler: '&',
        pageNumberIsTextInput: '<',
        pagingOptions: '=',
        disabled: '<',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 5/14/15.
 */
'use strict';
angular.module('prism-ui.components.navigation').service('PaginationService', function ($q) {
    var PaginationService = this;
    this.pageNumberMap = undefined;
    this.updateCurrentPage = function () {
        if (!this.pageNumberMap) {
            var currentPage = Math.ceil(this.contentTotal / this.pageSize);
            if (this.totalPages === 0) {
                this.currentPage = 1;
            }
            else if (this.currentPage > currentPage) {
                this.currentPage = currentPage;
            }
        }
    };
    this.getNextItemInPage = function () {
        var deferred = $q.defer();
        if (this.currentPageItemIndex === this.pageSize - 1) {
            ++this.currentPage;
            this.currentPageItemIndex = 0;
            return this.queryForNewPageData(deferred);
        }
        else {
            deferred.resolve(this.pageData[++this.currentPageItemIndex]);
            return deferred.promise;
        }
    };
    this.getPreviousItemInPage = function () {
        var deferred = $q.defer();
        if (this.currentPageItemIndex === 0) {
            --this.currentPage;
            this.currentPageItemIndex = this.pageSize - 1;
            return this.queryForNewPageData(deferred);
        }
        else {
            deferred.resolve(this.pageData[--this.currentPageItemIndex]);
            return deferred.promise;
        }
    };
    this.queryForNewPageData = function (deferred) {
        var queryOptions = {
            fetchOffset: this.pageSize * (this.currentPage - 1),
            fetchLimit: this.pageSize
        };
        this.pageDataResource.query(queryOptions).$promise.then(function (pageData) {
            PaginationService.pageData = pageData;
            deferred.resolve(PaginationService.pageData[PaginationService.currentPageItemIndex]);
        });
        return deferred.promise;
    };
    this.parseResponseHeaders = function (headers) {
        var contentRange = headers['content-range'];
        if (contentRange) {
            this.contentTotal = parseInt(contentRange.split('/')[1]);
            this.totalPages = Math.ceil(this.contentTotal / this.pageSize);
            this.totalPagesArray = [].constructor(this.totalPages);
            this.updateCurrentPage();
        }
    };
    this.resetToDefaultValues = function () {
        this.pageSizes = [10, 25, 50, 100, 500];
        this.pageSize = 25;
        this.currentPage = 1;
        this.totalPages = 0;
        this.currentPageItemIndex = 0;
        this.pageData = [];
        this.totalPagesArray = [];
        this.pageDataResource = null;
    };
    this.saveCurrentValues = function () {
        return {
            pageSizes: this.pageSizes,
            pageSize: this.pageSize,
            currentPage: this.currentPage,
            totalPages: this.totalPages,
            currentPageItemIndex: this.currentPageItemIndex
        };
    };
    this.restoreValues = function (values) {
        for (var prop in values) {
            this[prop] = values[prop];
        }
    };
    this.resetToDefaultValues();
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 3/25/15.
 */
'use strict';
function SidebarController(SidebarService, PermissionsService, NotificationService) {
    var self = this;
    self.isAdmin = PermissionsService.isAdmin();
    self.sidebarItemClick = function (sidebarItem) {
        var cleanForm = !SidebarService.editService ||
            !SidebarService.editService.editorForm ||
            SidebarService.editService.editorForm.$pristine;
        if (!cleanForm) {
            NotificationService.createWarningNotification('Please save or revert your changes before navigating away from this page.');
        }
        else {
            SidebarService.setSelectedItem(sidebarItem);
        }
    };
    self.isNavItemActive = function (navItem) {
        return SidebarService.getSelectedItem() === navItem;
    };
    self.showNavItem = function (navItem) {
        return SidebarService.userHasPermissionForSidebarItem(navItem);
    };
    self.showNavItemPessimisstic = function (navItem) {
        //
        // Won't show the item unless the user has both read AND
        // write permissions for the view state.
        //
        return SidebarService.userHasRWPermissionForSidebarItem(navItem);
    };
    self.showParentNavItem = function (navChildren) {
        for (var i = 0; i < navChildren.length; i++) {
            if (self.showNavItem(navChildren[i])) {
                return true;
            }
        }
        return false;
    };
    SidebarService.setNavPermissions();
}
angular
    .module('prism-ui.components.navigation')
    .component('sidebarNav', {
    templateUrl: 'components/navigation/sidebar/sidebar-template.html',
    controller: SidebarController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 12/29/15.
 */
'use strict';
angular.module('prism-ui.components.navigation').service('SidebarService', function ($location, PaginationService, BreadcrumbService, PermissionsService) {
    var self = this;
    var currentSelectedItem;
    var defaultSessionData = {
        previousLocation: '',
        paginationData: {},
        permissions: null
    };
    self.editService = null;
    var navigationMap = {
        //===========//
        // DASHBOARD //
        //===========//
        'workflows': {
            label: 'Workflows',
            defaultLocation: 'dashboard/workflows',
            viewState: 'DASHBOARD_WORKFLOW_VIEW',
            sessionData: angular.copy(defaultSessionData)
        },
        'queues': {
            label: 'Queues',
            defaultLocation: '/dashboard/queues/summary',
            viewState: 'DASHBOARD_QUEUE_VIEW',
            sessionData: angular.copy(defaultSessionData)
        },
        'reports': {
            label: 'Reports',
            defaultLocation: '/dashboard/report/partnerdeliveryreport',
            viewState: 'DASHBOARD_REPORT_VIEW_STATE',
            sessionData: angular.copy(defaultSessionData)
        },
        'calendars': {
            label: 'Calendars',
            defaultLocation: '/dashboard/calendars',
            viewState: 'DASHBOARD_CALENDAR_VIEW_STATE',
            sessionData: angular.copy(defaultSessionData)
        },
        'offCyclePlanners': {
            label: 'Off Cycle Planners',
            defaultLocation: '/dashboard/offCyclePlanners',
            viewState: 'DASHBOARD_OFF_CYCLE_PLANNERS_VIEW_STATE',
            sessionData: angular.copy(defaultSessionData)
        },
        'checkin': {
            label: 'Package Check-in',
            defaultLocation: '/dashboard/checkin',
            //
            // 2018-Jan-18 / ABC-9319
            //
            // The permission state for check-in, for now,
            // will be the same as for checkout, a.k.a. "batch
            // modify".
            //
            viewState: 'PACKAGE_BATCH_MODIFY_METADATA_VIEW_STATE',
            sessionData: angular.copy(defaultSessionData),
        },
        'metrics': {
            label: 'Metrics',
            defaultLocation: '/dashboard/metrics',
            sessionData: angular.copy(defaultSessionData)
        },
        //======//
        // META //
        //======//
        'networks': {
            label: 'Networks',
            defaultLocation: '/meta/networks/search',
            viewState: 'NETWORK_VIEW_STATE',
            sessionData: angular.copy(defaultSessionData)
        },
        'adsAndPreRolls': {
            label: 'Ads/PreRolls',
            defaultLocation: '/meta/adsAndPreRolls/search',
            viewState: 'ADS_VIEW_STATE',
            sessionData: angular.copy(defaultSessionData)
        },
        'series': {
            label: 'Series',
            defaultLocation: '/meta/series/search',
            viewState: 'SERIES_VIEW_STATE',
            sessionData: angular.copy(defaultSessionData)
        },
        'movies': {
            label: 'Movies',
            defaultLocation: '/meta/movies/search',
            viewState: 'MOVIE_VIEW_STATE',
            sessionData: angular.copy(defaultSessionData)
        },
        'collaborators': {
            label: 'Collaborators',
            defaultLocation: '/meta/collaborators/search',
            viewState: 'COLLABORATOR_VIEW_STATE',
            sessionData: angular.copy(defaultSessionData)
        },
        'mvpd': {
            label: 'MVPD',
            defaultLocation: '/meta/mvpd/search',
            viewState: 'MVPD_VIEW_STATE',
            sessionData: angular.copy(defaultSessionData)
        },
        //========//
        // SYSTEM //
        //========//
        'partners': {
            label: 'Partners',
            defaultLocation: '/system/partners/search',
            viewState: 'SYSTEM_PARTNERS_VIEW_STATE',
            sessionData: angular.copy(defaultSessionData)
        },
        'users': {
            label: 'Users',
            defaultLocation: '/system/users/search',
            sessionData: angular.copy(defaultSessionData)
        },
        'groups': {
            label: 'Groups',
            defaultLocation: '/system/groups/search',
            sessionData: angular.copy(defaultSessionData)
        },
        'properties': {
            label: 'properties',
            defaultLocation: '/system/properties/search',
            sessionData: angular.copy(defaultSessionData)
        },
        'contacts': {
            label: 'Contacts',
            defaultLocation: '/system/contacts/search',
            sessionData: angular.copy(defaultSessionData)
        },
        'metadataItems': {
            label: 'Metadata Items',
            defaultLocation: '/system/metadataItems/package',
            sessionData: angular.copy(defaultSessionData)
        },
        'livefeeds': {
            label: 'Live Feeds',
            defaultLocation: '/system/livefeeds/search',
            viewState: 'DEBUG_SYSTEM_OPERATIONS_VIEW_STATE',
            sessionData: angular.copy(defaultSessionData)
        },
        'fileSystems': {
            label: 'File Systems',
            defaultLocation: '/system/fileSystems/search',
            sessionData: angular.copy(defaultSessionData)
        },
        'templates': {
            label: 'templates',
            defaultLocation: '/system/templates/search',
            sessionData: angular.copy(defaultSessionData)
        },
        'aggregation': {
            label: 'Aggregation',
            defaultLocation: '/system/aggregation/setup',
            sessionData: angular.copy(defaultSessionData)
        },
        'execServers': {
            label: 'Exec Servers',
            defaultLocation: '/system/execServers',
            sessionData: angular.copy(defaultSessionData)
        },
        'packageNotifications': {
            label: 'Package Notifications',
            defaultLocation: '/system/packageNotifications/search',
            sessionData: angular.copy(defaultSessionData)
        },
        //==========//
        // PACKAGES //
        //==========//
        'packages': {
            label: 'Package',
            defaultLocation: '/packages',
            sessionData: angular.copy(defaultSessionData)
        },
    };
    currentSelectedItem = '';
    self.setNavPermissions = function () {
        angular.forEach(navigationMap, function (navItem) {
            if (navItem.viewState && !navItem.sessionData.permissions) {
                PermissionsService.getPermissionsForViewState(navItem.viewState).then(function (viewState) {
                    navItem.sessionData.permissions = {
                        canRead: PermissionsService.hasReadPermission(viewState.permission),
                        canWrite: PermissionsService.hasWritePermission(viewState.permission),
                        canExecute: PermissionsService.hasExecutePermission(viewState.permission)
                    };
                });
            }
        });
    };
    self.ignoreNavUpdates = false;
    self.overrideNavigationProperty = function (sidebarSection, overrideProp, overrideVal) {
        var navItem = navigationMap[sidebarSection];
        navItem.sessionData[overrideProp] = overrideVal;
    };
    self.setSelectedItem = function (item) {
        if (currentSelectedItem !== item) {
            if (currentSelectedItem && !self.ignoreNavUpdates) {
                BreadcrumbService.clearBreadcrumbs();
                var current = navigationMap[currentSelectedItem];
                var newSelection = navigationMap[item];
                current.sessionData.previousLocation = $location.url();
                current.sessionData.paginationData = PaginationService.saveCurrentValues();
                if (newSelection.sessionData.previousLocation) {
                    PaginationService.restoreValues(newSelection.sessionData.paginationData);
                    $location.url(newSelection.sessionData.previousLocation);
                }
                else {
                    PaginationService.resetToDefaultValues();
                    $location.url(newSelection.defaultLocation);
                }
            }
            currentSelectedItem = item;
        }
    };
    self.getSelectedItem = function () {
        return currentSelectedItem;
    };
    self.userHasPermissionForSidebarItem = function (item) {
        return !!navigationMap[item].sessionData.permissions &&
            navigationMap[item].sessionData.permissions.canRead;
    };
    self.userHasRWPermissionForSidebarItem = function (item) {
        return !!navigationMap[item].sessionData.permissions &&
            navigationMap[item].sessionData.permissions.canRead &&
            navigationMap[item].sessionData.permissions.canWrite;
    };
    self.clearSessionData = function () {
        currentSelectedItem = '';
        self.ignoreNavUpdates = false;
        angular.forEach(navigationMap, function (navItem) {
            navItem.sessionData = angular.copy(defaultSessionData);
        });
    };
    self.goToUrl = function (goToUrl, destinationBase, previousBase) {
        self.overrideNavigationProperty(destinationBase, 'previousLocation', goToUrl);
        self.overrideNavigationProperty(destinationBase, 'paginationData', {});
        self.overrideNavigationProperty(previousBase, 'previousLocation', $location.url());
        BreadcrumbService.clearBreadcrumbs();
        self.ignoreNavUpdates = true;
        $location.url(goToUrl);
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: chart-pill-component
 *
 * Created by rwilliams on 2/23/17.
 */
'use strict';
function ChartPillController() {
    var self = this;
    var currentValue = 0;
    var defaultStatusWidth = 8; // In percent
    self.getPillWidth = function (value) {
        if (self.chartdata.showFinished && value > 0) {
            var remainingTotal;
            var percentTotal = (value / self.chartdata.total) * 100;
            percentTotal = Math.round(percentTotal);
            if (percentTotal < 10) {
                currentValue += defaultStatusWidth;
                return defaultStatusWidth;
            }
            if ((percentTotal + currentValue) >= 100) {
                if (percentTotal + currentValue === 100) {
                    currentValue = 0;
                    return percentTotal;
                }
                else {
                    remainingTotal = 100 - currentValue;
                    currentValue = 0;
                    return remainingTotal;
                }
            }
            currentValue += percentTotal;
            return percentTotal;
        }
        else {
            var total = 0;
            for (var i = 0; i < self.chartdata.data.length; i++) {
                total = total + self.chartdata.data[i].value;
            }
            return value / total * 100;
        }
    };
}
angular.module('prism-ui.components').component('chartPill', {
    templateUrl: 'components/visual/chartPill/chart-pill-template.html',
    controller: ChartPillController,
    bindings: {
        chartdata: '<',
        statusChange: '&'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 6/15/15.
 */
'use strict';
angular.module('prism-ui.components').controller('CheckboxListController', function ($scope, uiGridConstants, $interval) {
    var self = this;
    var getIndexFor = function (propKey) {
        for (var i = 0; i < self.gridOptions.data.length; i++) {
            if (self.gridOptions.data[i].id === propKey) {
                return i;
            }
        }
    };
    self.setSelections = function () {
        $interval(function () {
            self.setRowsFromData();
        }, 0, 1);
    };
    self.gridOptions = {
        selectionRowHeaderColName: 'checkMarkRowHeaderCol',
        enableSorting: false,
        enableFiltering: false,
        enableColumnMenus: false,
        minRowsToShow: 4,
        enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
        enableVerticalScrollbar: 2,
        enableRowSelection: true,
        enableRowHeaderSelection: false,
        enableFullRowSelection: true,
        showHeader: false,
        autoResize: true,
        data: self.items,
        selectedItems: [],
        columnDefs: [
            {
                name: 'checkMarkRowHeaderCol',
                field: 'checkMark',
                width: 30,
                enableColumnMenu: false,
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'components/visual/grid/check-mark-template.html',
                headerCellTemplate: 'components/visual/grid/header-check-mark-template.html'
            },
            {
                field: 'displayName',
                enableColumnMenu: false,
                enableSorting: false,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            }
        ],
        onRegisterApi: function (gridApi) {
            self.gridApi = gridApi;
            self.gridApi.selection.on.rowSelectionChanged(null, self.selectionChanged);
        }
    };
    self.selectionChanged = function (rowChanged, event) {
        // Only reset view value if row is changed due to selection
        if (event) {
            var selectedEntities = self.gridApi.selection.getSelectedRows();
            var selectedKeys = [];
            angular.forEach(selectedEntities, function (entity) {
                selectedKeys.push(entity.id);
            });
            self.modelCtrl.$setViewValue(selectedKeys);
        }
    };
    self.setRowsFromData = function () {
        self.gridApi.selection.clearSelectedRows();
        angular.forEach(self.modelCtrl.$modelValue, function (key) {
            var index = getIndexFor(key);
            self.gridApi.selection.selectRow(self.gridOptions.data[index]);
        });
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 6/14/15.
 */
'use strict';
angular.module('prism-ui.components').directive('checkboxList', function () {
    return {
        restrict: 'E',
        template: '<div ui-grid="checkboxListCtrl.gridOptions" class="checkbox-list-sm protected-grid" ui-grid-selection ui-grid-auto-resize></div>',
        controller: 'CheckboxListController',
        controllerAs: 'checkboxListCtrl',
        require: ['ng-model', 'checkboxList'],
        scope: {
            items: '='
        },
        bindToController: {
            items: '='
        },
        link: function (scope, elmnt, attrs, ctrls) {
            var ngModelCtrl = ctrls[0];
            var checkboxListCtrl = ctrls[1];
            checkboxListCtrl.modelCtrl = ngModelCtrl;
            /**
             * Called whenever the model is changed programatically and also on initial loading
             */
            ngModelCtrl.$formatters.push(function (modelValue) {
                checkboxListCtrl.setSelections();
                return modelValue;
            });
        }
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by richardwilliams on 5/28/15.
 */
'use strict';
angular.module('prism-ui.package').factory('CollaboratorViewDataTransformer', function () {
    return {
        actorsColumns: [
            {
                name: 'checkMarkRowHeaderCol',
                field: 'checkMark',
                width: '2%',
                enableColumnMenu: false,
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'components/visual/grid/check-mark-template.html',
                headerCellTemplate: 'package/editor/components/view/collaborator/grid-checkbox-header-template.html'
            },
            {
                field: 'collaborator.displayName',
                width: '25%',
                displayName: 'Actor',
                sort: {
                    direction: 'asc',
                    priority: 0
                }
            },
            {
                field: 'collaborator.nickname',
                width: '25%',
                displayName: 'Nickname',
                enableColumnMenu: false
            },
            {
                field: 'character',
                width: '25%',
                displayName: 'Character',
                enableColumnMenu: false
            },
            {
                field: 'collaborator.iMDbNumber',
                enableColumnMenu: false,
                name: 'imdbColumn',
                displayName: 'IMDB#',
                width: '23%',
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'components/visual/grid/hyperlink-template.html'
            }
        ],
        crewColumns: [
            {
                name: 'checkMarkRowHeaderCol',
                field: 'checkMark',
                width: '2%',
                enableColumnMenu: false,
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'components/visual/grid/check-mark-template.html',
                headerCellTemplate: 'package/editor/components/view/collaborator/grid-checkbox-header-template.html'
            },
            {
                field: 'collaborator.displayName',
                width: '30%',
                displayName: 'Collaborator',
                sort: {
                    direction: 'asc',
                    priority: 0
                }
            },
            {
                field: 'collaborator.nickname',
                width: '25%',
                displayName: 'Nickname',
                enableColumnMenu: false
            },
            {
                field: 'collaborator.iMDbNumber',
                enableColumnMenu: false,
                name: 'imdbColumn',
                displayName: 'IMDB#',
                width: '23%',
                minWidth: 150,
                enableSorting: false,
                cellTemplate: 'components/visual/grid/hyperlink-template.html'
            },
            {
                field: 'role',
                displayName: 'Role',
                enableColumnMenu: false,
                enableSorting: true,
                name: 'role',
                width: '20%'
            }
        ]
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 5/28/15.
 */
'use strict';
angular.module('prism-ui.components').controller('DatePickerController', [
    function () {
        var self = this;
        self.open = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();
            self.opened = true;
        };
        self.dateOptions = {
            formatYear: 'yyyy',
            showWeeks: false
        };
        self.format = 'DD/MM/YYYY';
    }
]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 5/28/15.
 */
'use strict';
angular.module('prism-ui.components').directive('datePicker', function (moment, ServerInfoService) {
    return {
        restrict: 'E',
        controller: 'DatePickerController',
        templateUrl: 'components/visual/datePicker/datepicker-template.html',
        require: ['ngModel', 'datePicker'],
        scope: { disabled: '=', calBtnId: '=', timezoneOffsetMillis: '=?' },
        bindToController: { disabled: '=', calBtnId: '=' },
        controllerAs: 'datePickerCtrl',
        link: function (scope, element, attrs, ctrls) {
            // Standard timezone == Daylight timezone - 1 hour
            // If server in daylight timezone (ex: June 1st) & passing Standard time (ex: Jan 3rd) to the server...
            //     Standard time = Jan 3, 00:00 - 1 hour
            //     aka: Standard time will be in the previous date. (Jan 2, 23:00)
            // To avoid this, consider server 3-hours ahead of what it actually is
            // In daylight time: Input daylight time => sends 3AM
            //                   Input standard time => sends 2AM
            // In Standard time: Input daylight time => sends 4AM
            //                   Input standard time => sends 3AM
            // 3 hours ahead also prevents date from sending the invalid 12AM - 1AM time when daylight time switches.
            // Should work in all timezones because there aren't any timezones that would roll-over to the next date.
            //     aka: There are no "UTC+21", "UTC+22", or "UTC+23" timezones
            var DAYLIGHT_SAVINGS_SERVER_TIMEZONE_OFFSET_MILLIS = 3 * 60 * 60 * 1000;
            var ngModelCtrl = ctrls[0];
            var datePickerCtrl = ctrls[1];
            function getTimezoneOffsetMillis(dateStr) {
                if (scope.timezoneOffsetMillis === 'SERVER') {
                    // Get offset from server
                    return -ServerInfoService.getServerTimezoneOffsetMillis() + DAYLIGHT_SAVINGS_SERVER_TIMEZONE_OFFSET_MILLIS;
                }
                else if (typeof (scope.timezoneOffsetMillis) === 'number') {
                    return scope.timezoneOffsetMillis;
                }
                // Default offset: Local time (With Daylight time-zone based on the input date)
                return 1000 * 60 * ((new Date(dateStr)).getTimezoneOffset());
            }
            datePickerCtrl.buttonId = datePickerCtrl.calBtnId || attrs.id;
            ngModelCtrl.$render = function () {
                datePickerCtrl.date = ngModelCtrl.$viewValue.date;
            };
            ngModelCtrl.$formatters.push(function (modelValue) {
                var date = modelValue;
                if (date && !(date instanceof Date)) {
                    modelValue = moment.parseZone(modelValue).format('YYYY-MM-DD');
                    date = moment(modelValue).toDate();
                }
                return {
                    date: date
                };
            });
            ngModelCtrl.$parsers.push(function (viewValue) {
                return viewValue.date;
            });
            datePickerCtrl.dateChanged = function () {
                var ctrlDateString = moment.parseZone(datePickerCtrl.date).format('YYYY-MM-DD');
                var date = moment.utc(ctrlDateString).toDate();
                date.setUTCMilliseconds(getTimezoneOffsetMillis(ctrlDateString));
                ngModelCtrl.$setViewValue({ date: date });
            };
            datePickerCtrl.onDateFieldClick = function (event) {
                event.target.select();
            };
        }
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 6/14/15.
 */
'use strict';
angular.module('prism-ui.components').directive('dateTimePicker', function (moment) {
    return {
        restrict: 'E',
        controller: function () { },
        templateUrl: 'components/visual/dateTime/datetime-template.html',
        require: ['ngModel', 'dateTimePicker'],
        scope: { componentDisabled: '=ngDisabled', fieldSetSize: '=', calBtnId: '@' },
        bindToController: { componentDisabled: '=ngDisabled', fieldSetSize: '=', calBtnId: '@' },
        controllerAs: 'dateTimePickerCtrl',
        link: function (scope, element, attrs, ctrls) {
            var ngModelCtrl = ctrls[0];
            var dateTimePickerCtrl = ctrls[1];
            dateTimePickerCtrl.calBtnId = dateTimePickerCtrl.calBtnId || attrs.id;
            ngModelCtrl.$render = function () {
                dateTimePickerCtrl.datePart = ngModelCtrl.$viewValue.datePart;
                dateTimePickerCtrl.timePart = ngModelCtrl.$viewValue.timePart;
            };
            ngModelCtrl.$formatters.push(function (modelValue) {
                var datePart = modelValue, timePart;
                if (!datePart) {
                    datePart = undefined;
                    timePart = new Date(2000, 0, 1, 0, 0, 0, 0);
                }
                else if (!(datePart instanceof Date)) {
                    datePart = moment(modelValue).toDate();
                }
                return {
                    datePart: datePart,
                    timePart: timePart || datePart
                };
            });
            ngModelCtrl.$parsers.push(function (viewValue) {
                var newDate = viewValue.datePart;
                if (newDate) {
                    newDate.setHours(viewValue.timePart.getHours());
                    newDate.setMinutes(viewValue.timePart.getMinutes());
                }
                return newDate;
            });
            dateTimePickerCtrl.dateChanged = function () {
                if (!dateTimePickerCtrl.datePart) {
                    dateTimePickerCtrl.timePart = new Date(2000, 0, 1, 0, 0, 0, 0);
                }
                ngModelCtrl.$setViewValue({ datePart: dateTimePickerCtrl.datePart, timePart: dateTimePickerCtrl.timePart });
            };
        }
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 6/14/15.
 */
'use strict';
angular
    .module('prism-ui.components')
    .directive('dateTimeEnhanced', function (moment) {
    return {
        restrict: 'E',
        controller: function () { },
        templateUrl: 'components/visual/dateTimeEnhanced/datetime-enhanced-template.html',
        require: ['ngModel', 'dateTimeEnhanced'],
        scope: {
            modifiedLockDate: '=',
            ngModel: '=',
            componentName: '=',
            showTime: '@',
            componentDisabled: '=ngDisabled'
        },
        bindToController: {
            modifiedLockDate: '=',
            ngModel: '=',
            componentName: '=',
            showTime: '=',
            componentDisabled: '=ngDisabled'
        },
        controllerAs: 'dateTimeEnhancedCtrl',
        link: function (scope, element, attrs, ctrls) {
            var ngModelCtrl = ctrls[0];
            var dateTimeEnhancedCtrl = ctrls[1];
            var NONE_DATE = new Date(Date.UTC(9999, 0, 1, 0, 0, 0, 0));
            var DEFAULT_LOCK_DATE = new Date(Date.UTC(2100, 0, 1, 0, 0, 0, 0));
            dateTimeEnhancedCtrl.calBtnId = attrs.id;
            dateTimeEnhancedCtrl.lockedDate = dateTimeEnhancedCtrl.modifiedLockDate || new Date(Date.UTC(2100, 0, 1, 0, 0, 0, 0));
            var isLocked = function (date) {
                return dateTimeEnhancedCtrl.lockedDate.valueOf() === date.valueOf();
            };
            var isDefaultLocked = function (date) {
                return date && date.valueOf() === DEFAULT_LOCK_DATE.valueOf();
            };
            var isNone = function (date) {
                return date && date.valueOf() === NONE_DATE.valueOf();
            };
            /**
             * Reset displayed (scope) values based on $viewValue
             */
            ngModelCtrl.$render = function () {
                if (ngModelCtrl.$viewValue) {
                    if (isNone(ngModelCtrl.$viewValue.datePart)) {
                        dateTimeEnhancedCtrl.datePart = null;
                    }
                    else if (isDefaultLocked(ngModelCtrl.$viewValue.datePart)) {
                        dateTimeEnhancedCtrl.datePart = new Date(2100, 0, 1, 0, 0, 0, 0);
                    }
                    else {
                        dateTimeEnhancedCtrl.datePart = ngModelCtrl.$viewValue.datePart;
                    }
                    dateTimeEnhancedCtrl.isRegularDate = ngModelCtrl.$viewValue.isRegularDate;
                    dateTimeEnhancedCtrl.isLockedDate = ngModelCtrl.$viewValue.isLockedDate;
                    dateTimeEnhancedCtrl.isNoneDate = ngModelCtrl.$viewValue.isNoneDate;
                }
            };
            /**
             * Called whenever the model is changed programatically and also on initial loading
             */
            ngModelCtrl.$formatters.push(function (modelValue) {
                if (modelValue) {
                    var date;
                    if (!(modelValue instanceof Date)) {
                        if (!dateTimeEnhancedCtrl.showTime) {
                            modelValue = moment.parseZone(modelValue).format('YYYY-MM-DD');
                        }
                        date = moment(modelValue).toDate();
                    }
                    else {
                        date = modelValue;
                    }
                    var locked = isLocked(date);
                    var none = isNone(date);
                    return {
                        datePart: date,
                        isRegularDate: !(locked || none),
                        isLockedDate: locked,
                        isNoneDate: none
                    };
                }
            });
            /**
             * Called when the view value is set manually
             *
             * @return The updated view model which is then assigned to $modelValue
             */
            ngModelCtrl.$parsers.push(function (viewValue) {
                return viewValue.datePart;
            });
            dateTimeEnhancedCtrl.handleLockChange = function () {
                if (!dateTimeEnhancedCtrl.isLockedDate) {
                    ngModelCtrl.$setViewValue({
                        datePart: dateTimeEnhancedCtrl.lockedDate,
                        isLockedDate: true,
                        isRegularDate: false,
                        isNoneDate: false
                    });
                }
                else {
                    ngModelCtrl.$setViewValue({
                        datePart: dateTimeEnhancedCtrl.datePart,
                        isLockedDate: false,
                        isRegularDate: true,
                        isNoneDate: false
                    });
                }
                ngModelCtrl.$render();
            };
            dateTimeEnhancedCtrl.dateChanged = function (componentPart) {
                if (componentPart === 'none') {
                    ngModelCtrl.$setViewValue({
                        datePart: NONE_DATE,
                        isLockedDate: false,
                        isRegularDate: false,
                        isNoneDate: true
                    });
                }
                else {
                    ngModelCtrl.$setViewValue({
                        datePart: dateTimeEnhancedCtrl.datePart,
                        isLockedDate: false,
                        isRegularDate: true,
                        isNoneDate: false
                    });
                }
                ngModelCtrl.$render();
            };
        }
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 6/24/15.
 */
'use strict';
angular.module('prism-ui.components').directive('dropdownSelect', function (_, $filter, $timeout) {
    return {
        restrict: 'E',
        templateUrl: 'components/visual/dropdown-select/dropdown-select-template.html',
        require: 'ngModel',
        scope: {
            attachToBody: '=',
            btnMinWidth: '=',
            clearable: '=',
            collection: '=',
            collectionFilter: '=',
            componentDisabled: '=ngDisabled',
            defaultSelectIndex: '=',
            dropdownClick: '&',
            dropup: '=',
            ignoreLocks: '=',
            labelField: '@',
            labelFunction: '=',
            maxHeight: '<',
            modelProp: '@',
            onChange: '&',
            onClear: '&',
            prompt: '@',
            ngRequired: '<',
            showdates: '=',
            showLoading: '=',
            sortCollection: '@',
            tooltipClass: '@',
            tooltipTemplate: '=',
            trackBy: '@',
            updateButtonPrompt: '=',
            valueProp: '@',
        },
        link: function (scope, element, attrs, modelController) {
            var MAX_NUM_RENDER_ITEMS_ON_INIT = 100;
            var sortCollection = (scope.sortCollection !== undefined) ? attrs.sortCollection === 'true' : true;
            var getCollection = function () {
                return (!!scope.collectionFilter) ? $filter('filter')(scope.collection, scope.collectionFilter) : scope.collection;
            };
            var setViewValue = function (value, trigger) {
                scope.getSelectedIndex.cache.clear();
                modelController.$setViewValue(value, trigger);
            };
            scope.numItemsToRender = MAX_NUM_RENDER_ITEMS_ON_INIT;
            var isRenderingAllItems = false;
            scope.$watch('dropdown.isopen', function (isOpen, wasOpen) {
                if (wasOpen && !isOpen) {
                    modelController.$setTouched();
                }
            });
            scope.isLoading = function () {
                return scope.showLoading || isRenderingAllItems;
            };
            scope.$watch('collection', function (collection) {
                if (collection && collection.length > 1 && scope.labelField && !scope.trackBy && sortCollection) {
                    collection.sort(function (a, b) {
                        if (a[scope.labelField].toLowerCase() < b[scope.labelField].toLowerCase()) {
                            return -1;
                        }
                        if (a[scope.labelField].toLowerCase() > b[scope.labelField].toLowerCase()) {
                            return 1;
                        }
                        return 0;
                    });
                }
                else if (collection && collection.length > 1 && scope.labelField && scope.trackBy && sortCollection) {
                    collection.sort(function (a, b) {
                        if (a[scope.trackBy][scope.labelField].toLowerCase() < b[scope.trackBy][scope.labelField].toLowerCase()) {
                            return -1;
                        }
                        if (a[scope.trackBy][scope.labelField].toLowerCase() > b[scope.trackBy][scope.labelField].toLowerCase()) {
                            return 1;
                        }
                        return 0;
                    });
                }
                scope.getSelectedIndex.cache.clear();
                if (!modelController.$modelValue && angular.isDefined(scope.defaultSelectIndex) && !!scope.collection) {
                    var filteredCollection = getCollection();
                    if (scope.defaultSelectIndex >= 0 && scope.defaultSelectIndex < filteredCollection.length) {
                        modelController.$setViewValue(filteredCollection[scope.defaultSelectIndex]);
                    }
                }
            });
            function getButtonLabel(viewValue) {
                var dateString = '', startYear, endYear;
                if (scope.labelFunction) {
                    return scope.labelFunction(viewValue, scope.labelField);
                }
                if (scope.showdates && viewValue.hasOwnProperty('startDate') && viewValue.hasOwnProperty('endDate')) {
                    startYear = (viewValue.startDate) ? '' + new Date(viewValue.startDate).getUTCFullYear() : '';
                    endYear = (viewValue.endDate) ? '' + new Date(viewValue.endDate).getUTCFullYear() : '';
                    dateString = (startYear && endYear) ? ' (' + startYear + ' - ' + endYear + ')' : '';
                }
                if (!scope.labelField) {
                    return viewValue;
                }
                else if (!scope.trackBy) {
                    if (viewValue && viewValue[scope.labelField]) {
                        return viewValue[scope.labelField] + dateString;
                    }
                    else {
                        return scope.prompt || '';
                    }
                }
                else {
                    if (typeof viewValue[scope.trackBy] !== 'string') {
                        if (viewValue && viewValue[scope.trackBy] && viewValue[scope.trackBy][scope.labelField]) {
                            return viewValue[scope.trackBy][scope.labelField] + dateString;
                        }
                        else {
                            return scope.prompt || '';
                        }
                    }
                    else {
                        if (viewValue && viewValue[scope.labelField]) {
                            return viewValue[scope.labelField] + dateString;
                        }
                        else {
                            return scope.prompt || '';
                        }
                    }
                }
            }
            function findValueInFilteredOptions(filteredCollection, value) {
                if (scope.modelProp) {
                    for (var i = 0; i < filteredCollection.length; i++) {
                        if (filteredCollection[i][scope.modelProp] === value) {
                            return i;
                        }
                    }
                    return -1;
                }
                else {
                    return filteredCollection.indexOf(value);
                }
            }
            scope.getLabelForViewValue = function () {
                return (modelController.$viewValue) ? getButtonLabel(modelController.$viewValue) : scope.buttonPrompt;
            };
            modelController.$render = function () {
                scope.buttonPrompt = scope.prompt || '';
                scope.buttonPrompt = scope.getLabelForViewValue();
            };
            modelController.$formatters.push(function (modelValue) {
                if (modelValue) {
                    if (scope.modelProp) {
                        var selectedValue;
                        for (var i = 0; i < _.size(scope.collection); ++i) {
                            if (scope.collection[i][scope.modelProp] === modelValue) {
                                selectedValue = scope.collection[i][scope.valueProp];
                                break;
                            }
                        }
                        var returnObj = {};
                        returnObj[scope.modelProp] = modelValue;
                        returnObj[scope.valueProp] = selectedValue;
                        return returnObj;
                    }
                    return modelValue;
                }
            });
            modelController.$parsers.push(function (viewValue) {
                return scope.modelProp ? _.get(viewValue, scope.modelProp) : viewValue;
            });
            modelController.$isEmpty = function (viewValue) {
                if (scope.modelProp) {
                    return !_.get(viewValue, scope.modelProp);
                }
                return !viewValue;
            };
            var getMenuItemPanel = function () {
                if (scope.attachToBody) {
                    var ulElem = _.find(angular.element(document.body).children(), function (child) {
                        return child.tagName.toLowerCase() === 'ul' && child.style.display === 'block';
                    });
                    return angular.element(ulElem);
                }
                else {
                    return element.find('ul');
                }
            };
            function scrollToSelectedOption() {
                if (!_.isNil(modelController.$viewValue)) {
                    var menuPanel = getMenuItemPanel();
                    var selectedMenuItem = menuPanel.find('li > a').filter(function (index, item) {
                        return '' + item.text === '' + scope.dropdownLabelFunction(modelController.$viewValue);
                    })[0];
                    if (selectedMenuItem) {
                        menuPanel[0].scrollTop = selectedMenuItem.offsetTop;
                        selectedMenuItem.focus();
                    }
                    menuPanel[0].scrollLeft = 0;
                }
            }
            function handleDropDownEvent(event) {
                event.preventDefault();
                event.stopPropagation();
                scope.dropdown.isopen = !scope.dropdown.isopen;
                if (scope.dropdown.isopen) {
                    scope.getSelectedIndex.cache.clear();
                    if (_.size(scope.collection) <= scope.numItemsToRender) {
                        scope.numItemsToRender = Infinity;
                        $timeout(scrollToSelectedOption);
                    }
                    else if (!isRenderingAllItems) {
                        isRenderingAllItems = true;
                        // Render dropdown before adding rest of the items... & when done, scroll
                        $timeout(function () {
                            scope.numItemsToRender = Infinity;
                            $timeout(function () {
                                scrollToSelectedOption();
                                isRenderingAllItems = false;
                            });
                        });
                    }
                    scope.dropdownClick();
                }
            }
            scope.dropdownLabelFunction = function (item) {
                var dateString = '';
                if (scope.labelFunction) {
                    if (scope.updateButtonPrompt) {
                        scope.buttonPrompt = scope.labelFunction(modelController.$modelValue, scope.labelField);
                        scope.updateButtonPrompt = false;
                    }
                    return scope.labelFunction(item, scope.labelField);
                }
                if (scope.showdates && item.hasOwnProperty('startDate') && item.hasOwnProperty('endDate')) {
                    var startYear = (item.startDate) ? '' + new Date(item.startDate).getUTCFullYear() : '';
                    var endYear = (item.endDate) ? '' + new Date(item.endDate).getUTCFullYear() : '';
                    dateString = (startYear && endYear) ? ' (' + startYear + ' - ' + endYear + ')' : '';
                }
                if (!scope.labelField) {
                    return item;
                }
                else if (!scope.trackBy) {
                    return _.get(item, scope.labelField, '') + dateString;
                }
                else if (typeof item[scope.trackBy] !== 'string') {
                    return _.get(item, scope.trackBy + '.' + scope.labelField, '') + dateString;
                }
                else {
                    return _.get(item, scope.labelField, '') + dateString;
                }
            };
            scope.getTooltipTemplate = function (item) {
                if (scope.dropdown.isopen && scope.tooltipTemplate !== undefined) {
                    scope.tooltipData = item;
                    return scope.tooltipTemplate;
                }
                else {
                    return '';
                }
            };
            var getSelectedIndexImpl = function () {
                var selectedIndex = findValueInFilteredOptions(scope.collection, modelController.$modelValue);
                if (selectedIndex < 0) {
                    var selectedLabel = scope.dropdownLabelFunction(modelController.$viewValue);
                    selectedIndex = _.findIndex(scope.collection, function (item) {
                        return selectedLabel === scope.dropdownLabelFunction(item);
                    });
                }
                return selectedIndex;
            };
            scope.getSelectedIndex = _.memoize(getSelectedIndexImpl);
            scope.isIndexSelected = function (index) {
                if (!modelController.$modelValue || _.isNil(modelController.$viewValue)) {
                    return false;
                }
                return scope.getSelectedIndex() === index;
            };
            scope.selectOption = function (option, event) {
                if ((!scope.ignoreLocks && option.locked) || option.disabled) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                else {
                    var oldValue = modelController.$modelValue;
                    if (event) {
                        handleDropDownEvent(event);
                    }
                    setViewValue(option);
                    if (scope.onChange) {
                        scope.onChange({
                            $selected: option,
                            $oldValue: oldValue
                        });
                    }
                    modelController.$render();
                }
            };
            scope.selectOptionFromKey = function (event) {
                var filteredCollection = getCollection();
                var optionToSelect = null, currentIndex;
                if (event.keyCode === 38) {
                    //up arrow
                    event.preventDefault();
                    event.stopPropagation();
                    currentIndex = findValueInFilteredOptions(filteredCollection, modelController.$modelValue);
                    if (currentIndex === -1) {
                        currentIndex = filteredCollection.length;
                    }
                    while (currentIndex - 1 > -1) {
                        if (!filteredCollection[--currentIndex].locked || scope.ignoreLocks) {
                            optionToSelect = filteredCollection[currentIndex];
                            break;
                        }
                    }
                    if (optionToSelect) {
                        setViewValue(optionToSelect);
                        modelController.$render();
                        getMenuItemPanel().find('li > a').filter(function (index, item) {
                            return item.text === scope.dropdownLabelFunction(optionToSelect);
                        })[0].focus();
                    }
                }
                else if (event.keyCode === 40) {
                    //down arrow
                    event.preventDefault();
                    event.stopPropagation();
                    currentIndex = findValueInFilteredOptions(filteredCollection, modelController.$modelValue);
                    while (currentIndex + 1 < filteredCollection.length) {
                        if (!filteredCollection[++currentIndex].locked || scope.ignoreLocks) {
                            optionToSelect = filteredCollection[currentIndex];
                            break;
                        }
                    }
                    if (optionToSelect) {
                        setViewValue(optionToSelect);
                        modelController.$render();
                        getMenuItemPanel().find('li > a').filter(function (index, item) {
                            return item.text === scope.dropdownLabelFunction(optionToSelect);
                        })[0].focus();
                    }
                }
                else if (event.keyCode >= 48 && event.keyCode <= 90) {
                    event.preventDefault();
                    event.stopPropagation();
                    var focusOption = null;
                    var key = String.fromCharCode(event.keyCode).toLowerCase();
                    var menuItems = getMenuItemPanel().find('li > a');
                    menuItems = menuItems.filter(function (index, item) {
                        return item.text.charAt(0).toLowerCase() === key && angular.element(item).find('i').length === 0;
                    });
                    if (scope.focusedOption && scope.focusedOption.charAt(0).toLowerCase() === key && menuItems.length > 1) {
                        var focusedIndex = -1;
                        for (var i = 0; i < menuItems.length; i++) {
                            var option = menuItems[i];
                            if (option.text === scope.focusedOption) {
                                focusedIndex = i;
                                break;
                            }
                        }
                        if (focusedIndex + 1 < menuItems.length) {
                            focusOption = menuItems[focusedIndex + 1];
                            focusOption.focus();
                            scope.focusedOption = focusOption.text;
                        }
                        else {
                            focusOption = menuItems[0];
                            focusOption.focus();
                            scope.focusedOption = focusOption.text;
                        }
                    }
                    else if (menuItems.length > 0) {
                        focusOption = menuItems[0];
                        focusOption.focus();
                        scope.focusedOption = focusOption.text;
                    }
                    if (!scope.dropdown.isopen && focusOption) {
                        optionToSelect = filteredCollection.filter(function (option) {
                            return scope.dropdownLabelFunction(option) === scope.focusedOption;
                        })[0];
                        setViewValue(optionToSelect);
                        modelController.$render();
                    }
                }
            };
            scope.clearOption = function (event) {
                event.preventDefault();
                event.stopPropagation();
                if (!scope.componentDisabled) {
                    if (scope.modelProp) {
                        var nullObj = {};
                        nullObj[scope.modelProp] = null;
                        setViewValue(nullObj);
                    }
                    else {
                        setViewValue(null);
                    }
                    modelController.$render();
                }
                scope.onClear();
            };
            scope.clearVisible = function () {
                return !!scope.clearable && modelController.$modelValue;
            };
            scope.toggleDropDown = function (event) {
                handleDropDownEvent(event);
            };
            function onRequiredUpdate() {
                scope.selectRequired = attrs.required;
                modelController.$validate();
            }
            scope.$watch('ngRequired', onRequiredUpdate);
            modelController.$name = attrs.name;
            scope.focusedOption = null;
            scope.minWidthStyle = (scope.btnMinWidth > 0) ? { 'min-width': scope.btnMinWidth + 'px' } : {};
            scope.loadingIndicator = {
                size: 'sm'
            };
        }
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
function EditableListController() {
    var self = this;
    self.selectedItem = null;
    self.addNewItem = function () {
        var newItem = {};
        newItem[self.labelField] = '';
        if (self.collection === undefined) {
            self.collection = [];
        }
        self.collection.push(newItem);
        self.changeHandler();
    };
    self.removeItem = function () {
        if (self.selectedItem) {
            var itemIndex = self.collection.indexOf(self.selectedItem);
            self.collection.splice(itemIndex, 1);
            self.changeHandler();
        }
    };
    self.selectFocusedItem = function (item) {
        self.selectedItem = item;
    };
}
angular.module('prism-ui.components').component('editableList', {
    templateUrl: 'components/visual/editable-list/editable-list-template.html',
    controller: EditableListController,
    bindings: {
        collection: '=',
        changeHandler: '&',
        labelField: '@'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
function EnhancedTextAreaController($element, $timeout, $window) {
    var self = this;
    var isRenderingError = false;
    var textAreaElem;
    var textAreaCloneElem;
    var lineErrorElem;
    //=================//
    // Lifecycle Hooks //
    //=================//
    var formatCharsDisplay = function (modelValue) {
        var length = 0;
        if (modelValue && modelValue.length >= 0) {
            length = modelValue.length;
        }
        var output = '' + (self.maxChars - length);
        while (output.length < 4) {
            output = '0' + output;
        }
        self.charsRemaining = output;
    };
    var onInputChange = function (newValue) {
        formatCharsDisplay(newValue);
        self.errorCharIndex = (self.errorCharIndex !== undefined) ? null : undefined;
        return newValue;
    };
    self.$onInit = function () {
        self.ngModelCtrl.$formatters.push(onInputChange);
        self.ngModelCtrl.$parsers.push(onInputChange);
    };
    self.$postLink = function () {
        lineErrorElem = $element.find('.line-error')[0];
        textAreaElem = $element.find('textarea')[0];
        textAreaCloneElem = textAreaElem.cloneNode();
        textAreaCloneElem.disabled = true;
        textAreaCloneElem.rows = 1;
        textAreaCloneElem.classList.add('anchored-invisible-clone');
        textAreaElem.parentElement.insertBefore(textAreaCloneElem, textAreaElem);
        $timeout(function () {
            formatCharsDisplay(self.value());
        });
    };
    var onRenderError = function () {
        if (Number.isInteger(self.errorCharIndex)) {
            textAreaCloneElem.style.top = textAreaElem.offsetTop + 'px';
            textAreaCloneElem.style.left = textAreaElem.offsetLeft + 'px';
            textAreaCloneElem.style.width = textAreaElem.offsetWidth + 'px';
            var scrollHeight = textAreaCloneElem.scrollHeight;
            if (!textAreaCloneElem.value.length) {
                scrollHeight = 0;
            }
            lineErrorElem.style.top = (scrollHeight - textAreaElem.scrollTop) + 'px';
            $window.requestAnimationFrame(onRenderError);
        }
        else {
            isRenderingError = false;
        }
    };
    self.$doCheck = function () {
        if (!isRenderingError && self.value() && Number.isInteger(self.errorCharIndex)) {
            var errorStartIndex = self.value().lastIndexOf('\n', self.errorCharIndex);
            if (errorStartIndex >= self.errorCharIndex) {
                errorStartIndex = 0;
            }
            textAreaCloneElem.value = self.value().substring(0, errorStartIndex);
            isRenderingError = true;
            $window.requestAnimationFrame(onRenderError);
        }
    };
    //================//
    // Template Logic //
    //================//
    self.value = function (newValue) {
        if (newValue === undefined) {
            return self.ngModelCtrl.$modelValue;
        }
        self.ngModelCtrl.$setViewValue(newValue);
    };
    self.onFocus = function () {
        self.inputFocused = true;
        formatCharsDisplay(self.value());
    };
    self.onBlur = function () {
        self.inputFocused = false;
    };
}
angular
    .module('prism-ui.components')
    .component('enhancedTextarea', {
    templateUrl: 'components/visual/enhancedTextArea/enhanced-textarea-template.html',
    controller: EnhancedTextAreaController,
    require: {
        ngModelCtrl: '^ngModel',
    },
    bindings: {
        maxChars: '@',
        errorCharIndex: '=errorIndex',
        disableProp: '=ngDisabled',
        inputId: '@',
        inputRows: '@',
        monospace: '='
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
function EnhancedTextInputController($timeout) {
    var self = this;
    var formatCharsDisplay = function () {
        var length = 0;
        if (self.modelProp && self.modelProp.length >= 0) {
            length = self.modelProp.length;
        }
        var output = '' + (self.maxChars - length);
        while (output.length < 4) {
            output = '0' + output;
        }
        self.charsRemaining = output;
    };
    self.$postLink = function () {
        $timeout(function () {
            formatCharsDisplay();
        });
    };
    self.onFocus = function () {
        self.inputFocused = true;
        formatCharsDisplay();
    };
    self.onBlur = function () {
        self.inputFocused = false;
    };
    self.onInputChange = function () {
        formatCharsDisplay();
    };
}
angular
    .module('prism-ui.components')
    .component('enhancedTextinput', {
    templateUrl: 'components/visual/enhancedTextInput/enhanced-textinput-template.html',
    controller: EnhancedTextInputController,
    bindings: {
        modelProp: '=',
        maxChars: '@',
        disableProp: '=',
        inputId: '@'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 6/6/15.
 */
'use strict';
angular.module('prism-ui.components').component('errorWarningIndicator', {
    controller: function () { },
    templateUrl: 'components/visual/errorsAndWarnings/errors-and-warnings-indicator-template.html',
    bindings: {
        errorWarning: '='
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
function ExpressionFieldCtrl() { }
angular.module('prism-ui.components').component('expressionField', {
    templateUrl: 'components/visual/expressionField/expression-field-template.html',
    controller: ExpressionFieldCtrl,
    bindings: {
        customMetaObj: '<',
        partnerMetaItem: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 8/20/15.
 */
'use strict';
angular.module('prism-ui.components').controller('PrismListController', ['$scope', function ($scope) {
    }]);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 8/20/15.
 */
'use strict';
angular.module('prism-ui.components').directive('prismList', function () {
    return {
        restrict: 'E',
        require: ['ng-model', 'prismList'],
        templateUrl: 'components/visual/list/prism-list-template.html',
        controller: 'PrismListController',
        controllerAs: 'listController',
        scope: true,
        bindToController: {
            items: '=',
            labelField: '@',
            modelProp: '@',
            componentDisabled: '=ngDisabled'
        },
        link: function (scope, element, attrs, ctrls) {
            var ngModelCtrl = ctrls[0];
            var listController = ctrls[1];
            ngModelCtrl.$formatters.push(function (modelValue) {
                listController.selectedItem = modelValue;
                return modelValue;
            });
            listController.isItemSelected = function (item) {
                return listController.selectedItem === item[listController.modelProp];
            };
            listController.selectItem = function (item) {
                var viewValue = item[listController.modelProp];
                if (listController.selectedItem === viewValue) {
                    listController.selectedItem = null;
                }
                else {
                    listController.selectedItem = viewValue;
                }
                ngModelCtrl.$setViewValue(listController.selectedItem);
            };
        }
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 6/2/15.
 */
'use strict';
angular.module('prism-ui.components').component('uiLock', {
    template: '<a ng-click="!$ctrl.componentDisabled && $ctrl.handleLockClick()" ng-class="$ctrl.isLocked ? \'fa fa-lock\' : \'fa fa-unlock-alt\'" tabindex="0" href=""></a>',
    controller: function (PermissionsService) {
        var self = this;
        self.handleLockClick = function (event) {
            if (PermissionsService.isAdmin()) {
                self.isLocked = !self.isLocked;
                self.clickHandler(); // Click handler is always defined due to & binding
            }
        };
    },
    bindings: {
        isLocked: '=',
        componentDisabled: '=ngDisabled',
        clickHandler: '&'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components').directive('multiselectDropdown', function (_) {
    return {
        restrict: 'E',
        templateUrl: 'components/visual/multiselect-dropdown/multiselect-dropdown-template.html',
        require: ['ngModel', '?^form'],
        scope: {
            attachToBody: '=',
            btnMinWidth: '=',
            btnMaxWidth: '=',
            clearable: '=',
            collection: '=',
            collectionFilter: '=',
            collectionSortProperty: '=',
            componentDisabled: '=ngDisabled',
            dividersEnabled: '=',
            dropup: '=',
            enableSelectAll: '=',
            ignoreLocks: '=',
            labelField: '@',
            labelFunction: '=',
            lockSelection: '=',
            lockSelectionProp: '@',
            maxHeight: '=',
            modelProp: '@',
            ngChange: '&',
            ngRequired: '<',
            onChange: '<',
            prompt: '@',
            promptFunction: '<',
            sortCollection: '@',
            showdates: '=',
            showLoading: '<',
            valueProp: '@'
        },
        link: function (scope, element, attrs, controllers) {
            var modelController = controllers[0];
            var sortCollection = (scope.sortCollection !== undefined) ? attrs.sortCollection === 'true' : true;
            var form = controllers[1];
            scope.selections = [];
            scope.parentId = attrs.id;
            scope.widthStyle = {};
            scope.loadingIndicator = {
                backdrop: true,
                size: 'sm',
            };
            if (scope.btnMinWidth > 0) {
                scope.widthStyle.minWidth = scope.btnMinWidth + 'px';
            }
            if (scope.btnMaxWidth > 0) {
                scope.widthStyle.maxWidth = scope.btnMaxWidth + 'px';
            }
            scope.$watch(function () {
                return attrs.id;
            }, function (newParentId) {
                scope.parentId = newParentId;
            });
            scope.$watch('dropdown.isopen', function (isOpen, wasOpen) {
                if (wasOpen && !isOpen) {
                    modelController.$setTouched();
                }
            });
            if (!scope.collectionSortProperty) {
                scope.$watch('collection', function (collection) {
                    if (collection && collection.length > 1 && scope.labelField && sortCollection) {
                        collection.sort(function (a, b) {
                            if (a[scope.labelField].toLowerCase() < b[scope.labelField].toLowerCase()) {
                                return -1;
                            }
                            if (a[scope.labelField].toLowerCase() > b[scope.labelField].toLowerCase()) {
                                return 1;
                            }
                            return 0;
                        });
                    }
                });
            }
            function onRequiredUpdate() {
                scope.selectRequired = attrs.required;
                modelController.$validate();
            }
            scope.$watch('ngRequired', onRequiredUpdate);
            onRequiredUpdate();
            function isClearable() {
                // default to true if undefined
                return angular.isUndefined(scope.clearable) || scope.clearable;
            }
            function getSelectionIndex(candidate) {
                if (scope.valueProp) {
                    if (_.isObjectLike(candidate[scope.valueProp])) {
                        return _.findIndex(scope.selections, candidate[scope.valueProp]);
                    }
                    else {
                        return scope.selections.indexOf(candidate[scope.valueProp]);
                    }
                }
                else if (candidate.id) {
                    return _.findIndex(scope.selections, { id: candidate.id });
                }
                else {
                    return scope.selections.indexOf(candidate);
                }
            }
            function getButtonLabel(viewValue) {
                var dateString = '', startYear, endYear;
                if (scope.labelFunction) {
                    return scope.labelFunction(viewValue);
                }
                if (scope.showdates && viewValue.hasOwnProperty('startDate') && viewValue.hasOwnProperty('endDate')) {
                    startYear = (viewValue.startDate) ? '' + new Date(viewValue.startDate).getUTCFullYear() : '';
                    endYear = (viewValue.endDate) ? '' + new Date(viewValue.endDate).getUTCFullYear() : '';
                    dateString = (startYear && endYear) ? ' (' + startYear + ' - ' + endYear + ')' : '';
                }
                if (!scope.labelField) {
                    return viewValue;
                }
                else {
                    if (viewValue[scope.labelField]) {
                        return viewValue[scope.labelField] + dateString;
                    }
                    else {
                        return scope.prompt || '';
                    }
                }
            }
            modelController.$render = function () {
                scope.selections = modelController.$viewValue.selections;
                scope.buttonPrompt = scope.prompt || '';
                if (modelController.$viewValue.selections && modelController.$viewValue.selections.length > 1) {
                    scope.buttonPrompt = 'multiple selections';
                }
                else if (modelController.$viewValue.selections && modelController.$viewValue.selections.length === 1) {
                    scope.buttonPrompt = getButtonLabel(modelController.$viewValue.selections[0]);
                }
            };
            modelController.$formatters.push(function (modelValue) {
                var selections = modelValue || [];
                return { selections: selections };
            });
            modelController.$isEmpty = function (viewValue) {
                return _.get(viewValue, 'selections.length', 0) < 1;
            };
            modelController.$parsers.push(function (viewValue) {
                return viewValue.selections;
            });
            scope.dropdownLabelFunction = function (item) {
                if (scope.labelFunction) {
                    if (scope.updateButtonPrompt) {
                        scope.buttonPrompt = scope.labelFunction(modelController.$modelValue);
                        scope.updateButtonPrompt = false;
                    }
                    return scope.labelFunction(item);
                }
                var dateString = '';
                if (scope.showdates && item.hasOwnProperty('startDate') && item.hasOwnProperty('endDate')) {
                    var startYear = (item.startDate) ? '' + new Date(item.startDate).getUTCFullYear() : '';
                    var endYear = (item.endDate) ? '' + new Date(item.endDate).getUTCFullYear() : '';
                    dateString = (startYear && endYear) ? ' (' + startYear + ' - ' + endYear + ')' : '';
                }
                if (!scope.labelField) {
                    return item;
                }
                else {
                    return item[scope.labelField] + dateString;
                }
            };
            scope.idCleaner = function (rawId) {
                return rawId.replace(/ /g, '');
            };
            var updateSelection = function () {
                modelController.$setViewValue({ selections: scope.selections });
                modelController.$render();
                modelController.$validate();
                if (typeof (scope.onChange) === 'function') {
                    scope.onChange(modelController.$viewValue.selections);
                }
                if (typeof (scope.ngChange) === 'function') {
                    scope.ngChange();
                }
            };
            var addOptionToSelection = function (option) {
                if (scope.valueProp) {
                    scope.selections.push(option[scope.valueProp]);
                }
                else {
                    scope.selections.push(option);
                }
                updateSelection();
            };
            scope.toggleOption = function (option, event) {
                if (option.disabled) {
                    event.preventDefault();
                    event.stopPropagation();
                    return;
                }
                if (event.currentTarget && event.currentTarget.tagName !== 'INPUT') {
                    event.preventDefault();
                }
                event.stopPropagation();
                event.stopImmediatePropagation();
                var selectionIndex = getSelectionIndex(option);
                if (selectionIndex > -1) {
                    scope.selections.splice(selectionIndex, 1);
                    updateSelection();
                }
                else {
                    addOptionToSelection(option);
                }
                if (form) {
                    form.$setDirty();
                }
            };
            scope.isOptionSelected = function (option) {
                var selectionIndex = getSelectionIndex(option);
                if (selectionIndex > -1) {
                    if (option.id && scope.lockSelection && scope.lockSelectionProp && option[scope.lockSelectionProp]) {
                        option.disabled = true;
                    }
                    return true;
                }
                return false;
            };
            scope.toggleDropDown = function (event) {
                event.preventDefault();
                event.stopPropagation();
                scope.dropdown.isopen = !scope.dropdown.isopen;
            };
            scope.toggleAllOptions = function (event) {
                if (event.currentTarget.tagName !== 'INPUT') {
                    event.preventDefault();
                }
                event.stopPropagation();
                event.stopImmediatePropagation();
                if (!scope.areAllOptionsSelected()) {
                    angular.forEach(scope.collection, function (option) {
                        if (!scope.isOptionSelected(option) && !option.disabled) {
                            addOptionToSelection(option);
                        }
                    });
                }
                else {
                    scope.selections = [];
                }
                updateSelection();
                if (form) {
                    form.$setDirty();
                }
            };
            // TODO: Might want to fix this bug: Select All ignores locked options
            scope.areAllOptionsSelected = function () {
                return (scope.selections && scope.selections.length) === (scope.collection && scope.collection.length);
            };
            scope.clearVisible = function () {
                return isClearable() && scope.selections && scope.selections.length > 0;
            };
            scope.clearSelections = function (event) {
                if (isClearable()) {
                    event.preventDefault();
                    event.stopPropagation();
                    if (!scope.componentDisabled) {
                        scope.selections.splice(0, scope.selections.length);
                    }
                    if (form) {
                        form.$setDirty();
                    }
                    updateSelection();
                }
            };
            var indexFromMenuItem = function (menuItems, item) {
                for (var i = 0; i < menuItems.length; i++) {
                    var option = menuItems[i];
                    if (item.textContent === option.textContent) {
                        return i;
                    }
                }
                return -1;
            };
            var getMenuItemPanel = function () {
                if (scope.attachToBody) {
                    var ulElem = _.find(angular.element(document.body).children(), function (child) {
                        return child.tagName.toLowerCase() === 'ul' && child.style.display === 'block';
                    });
                    return angular.element(ulElem);
                }
                else {
                    return element.find('ul');
                }
            };
            var optionToSelect = null;
            scope.focusOption = {};
            var currentIndex = -1;
            scope.selectOptionFromKey = function (event) {
                if (scope.dropdown.isopen) {
                    var menuItems = getMenuItemPanel().find('li > div > label');
                    if (event.keyCode === 38) {
                        //up arrow
                        event.preventDefault();
                        event.stopPropagation();
                        if (currentIndex === -1) {
                            currentIndex = scope.collection.length;
                        }
                        while (currentIndex - 1 > -1) {
                            optionToSelect = scope.collection[--currentIndex];
                            if (scope.ignoreLocks || !optionToSelect.locked) {
                                break;
                            }
                        }
                        if (!optionToSelect.locked) {
                            scope.focusOption = menuItems[currentIndex];
                            scope.focusOption.focus();
                        }
                        if (currentIndex === 0) {
                            currentIndex--;
                        }
                    }
                    else if (event.keyCode === 32) {
                        // Spacebar to change selection status
                        scope.toggleOption(scope.collection[currentIndex], event);
                        scope.focusOption = {};
                    }
                    else if (event.keyCode === 40) {
                        //down arrow
                        event.preventDefault();
                        event.stopPropagation();
                        if (currentIndex === scope.collection.length - 1) {
                            currentIndex = -1;
                        }
                        while (currentIndex + 1 < scope.collection.length) {
                            optionToSelect = scope.collection[++currentIndex];
                            if (scope.ignoreLocks || !optionToSelect.locked) {
                                break;
                            }
                        }
                        if (!optionToSelect.locked) {
                            scope.focusOption = menuItems[currentIndex];
                            scope.focusOption.focus();
                        }
                    }
                    else if (event.keyCode >= 48 && event.keyCode <= 90) {
                        event.preventDefault();
                        event.stopPropagation();
                        var key = String.fromCharCode(event.keyCode).toLowerCase();
                        var filteredMenuItems = menuItems.filter(function (index, item) {
                            return item.textContent.charAt(0).toLowerCase() === key && angular.element(item).find('i').length === 0;
                        });
                        if (scope.focusOption.textContent && scope.focusOption.textContent.charAt(0).toLowerCase() === key && filteredMenuItems.length > 1) {
                            var focusedIndex = -1;
                            for (var i = 0; i < filteredMenuItems.length; i++) {
                                var option = filteredMenuItems[i];
                                if (option.textContent === scope.focusOption.textContent) {
                                    focusedIndex = i;
                                    break;
                                }
                            }
                            if (focusedIndex + 1 < filteredMenuItems.length) {
                                scope.focusOption = filteredMenuItems[focusedIndex + 1];
                            }
                            else {
                                scope.focusOption = filteredMenuItems[0];
                            }
                            scope.focusOption.focus();
                        }
                        else if (filteredMenuItems.length > 0) {
                            scope.focusOption = filteredMenuItems[0];
                            scope.focusOption.focus();
                        }
                        currentIndex = indexFromMenuItem(menuItems, scope.focusOption);
                    }
                }
            };
        }
    };
});

// 'use strict';
// angular.module('levelsBeyond.ui.progress', [
//     'levelsBeyond.ui.progress.templates'
// ]).directive('lbProgress', function lbProgressFactory(){
//
//     return {
//         scope: {
//             lbProgress: '='
//         },
//         templateUrl: 'progress.tpl.html',
//         restrict: 'A',
//         link: function ($scope, $iElement/*, $iAttrs, Controller*/) {
//
//             var defaults = {
//                 backdrop: true,
//                 title: 'Loading',
//                 message: '',
//                 size: 'lg'
//             };
//
//             angular.extend(defaults, $scope.lbProgress);
//
//             // Show backdrop.
//             if (defaults.backdrop) {
//                 $iElement.addClass('preloader-backdrop');
//             }
//
//             // Expose the settings to the template.
//             $scope.lbProgress = defaults;
//
//             return;
//
//         }
//
//     };
//
// });
'use strict';
angular.module('prism-ui.components')
    .directive('lbProgress', function lbProgressFactory() {
    return {
        scope: {
            lbProgress: '='
        },
        templateUrl: 'components/visual/pacifier/pacifier-template.html',
        restrict: 'A',
        link: function ($scope, $iElement /*, $iAttrs, Controller*/) {
            var defaults = {
                backdrop: true,
                title: 'Loading',
                message: '',
                size: 'lg'
            };
            angular.extend(defaults, $scope.lbProgress);
            // Show backdrop.
            if (defaults.backdrop) {
                $iElement.addClass('preloader-backdrop');
            }
            // Expose the settings to the template.
            $scope.lbProgress = defaults;
        }
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 7/27/15.
 */
'use strict';
angular.module('prism-ui.components').directive('prismTimePicker', function (twoDigitNumFilter) {
    return {
        restrict: 'E',
        controller: function () { },
        template: '<fieldset ng-disabled="timePickerCtrl.componentDisabled">' + '<div uib-timepicker ng-model="timePickerCtrl.timeInput" class="timepicker col-sm-3 time-component-md" mousewheel="false" hour-step="1" ' +
            'minute-step="15" show-meridian="true" ng-change="timePickerCtrl.timeChanged()" template-url="components/visual/timepicker/prism-timepicker-template.html"> </div></fieldset>',
        require: ['ngModel', 'prismTimePicker'],
        scope: { componentDisabled: '=ngDisabled' },
        bindToController: { componentDisabled: '=ngDisabled' },
        controllerAs: 'timePickerCtrl',
        link: function (scope, element, attrs, ctrls) {
            var ngModelCtrl = ctrls[0];
            var timePickerCtrl = ctrls[1];
            /**
             * Reset displayed (scope) values based on $viewValue
             */
            ngModelCtrl.$render = function () {
                timePickerCtrl.timeInput = ngModelCtrl.$viewValue.timeInput;
            };
            var verifyModelFormat = function (val) {
                return /[0-9][0-9]:[0-9][0-9]/.test(val);
            };
            /**
             * Called whenever the model is changed programatically and also on initial loading
             */
            ngModelCtrl.$formatters.push(function (modelValue) {
                var time = new Date();
                var timeString = modelValue && verifyModelFormat(modelValue) ? modelValue : '00:00';
                var timeParts = timeString.split(':');
                time.setHours(timeParts[0]);
                time.setMinutes(timeParts[1]);
                return { timeInput: time };
            });
            /**
             * Called when the view value is set manually
             *
             * @return The updated model which is then assigned to $modelValue
             */
            ngModelCtrl.$parsers.push(function (viewValue) {
                return twoDigitNumFilter(viewValue.timeInput.getHours()) + ':' + twoDigitNumFilter(viewValue.timeInput.getMinutes());
            });
            timePickerCtrl.timeChanged = function () {
                var newDate = new Date();
                newDate.setHours(timePickerCtrl.timeInput.getHours());
                newDate.setMinutes(timePickerCtrl.timeInput.getMinutes());
                ngModelCtrl.$setViewValue({ timeInput: newDate });
            };
        }
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: toolbar-component.js
 *
 * Created by randysorensen on 2/16/17.
 */
'use strict';
function ToolbarController(_, UtilsService) {
    var self = this;
    //=================//
    // Lifecycle Hooks //
    //=================//
    self.$onInit = function () {
        if (self.buttonDefs === undefined) {
            self.buttonDefs = [];
        }
        if (self.rightHandCheckboxDefs === undefined) {
            self.rightHandCheckboxDefs = [];
        }
    };
    // Our local copy of the button defs, which can be further
    // processed (e.g. have default icons assigned)
    var processedButtonDefs = null;
    var processedRightHandCheckboxDefs = null;
    self.$onChanges = function (changes) {
        if (_.has(changes, 'buttonDefs')) {
            processedButtonDefs = null;
            if (self.buttonDefs === undefined) {
                self.buttonDefs = [];
            }
        }
        if (_.has(changes, 'rightHandCheckboxDefs')) {
            processedRightHandCheckboxDefs = null;
            if (self.rightHandCheckboxDefs === undefined) {
                self.rightHandCheckboxDefs = [];
            }
        }
    };
    //=================//
    // Toolbar Buttons //
    //=================//
    // Default Font Awesome icons to use for buttons with
    // particular names
    var defaultIcons = {
        clone: 'fa-files-o',
        close: 'fa-times',
        delete: 'fa-times',
        edit: 'fa-wrench',
        new: 'fa-plus',
        hide: 'fa-eye-slash',
        revert: 'fa-undo',
        save: 'fa-floppy-o',
        unhide: 'fa-eye',
        refresh: 'fa-refresh'
    };
    var processButtonDefs = function () {
        var order = 0;
        processedButtonDefs = _.cloneDeep(self.buttonDefs);
        processedButtonDefs.forEach(function (buttonDef) {
            // assign default icon if none included
            if (buttonDef.icon === undefined) {
                buttonDef.icon = defaultIcons[buttonDef.label.toLowerCase()] !== undefined ?
                    defaultIcons[buttonDef.label.toLowerCase()] :
                    'fa-question';
            }
            buttonDef.hasIconStack = (typeof (buttonDef.icon) !== 'string');
            // assign button order; utilize included order, if any
            if (buttonDef.order >= order) {
                order = buttonDef.order + 1;
            }
            else if (buttonDef.order === undefined) {
                buttonDef.order = order;
                ++order;
            }
        });
    };
    self.getButtons = function () {
        if (processedButtonDefs === null) {
            processButtonDefs(self.buttonDefs);
        }
        return processedButtonDefs;
    };
    //============//
    // Pagination //
    //============//
    self.paginationSupported = function () {
        return self.paginationDefs;
    };
    //===============================//
    // Dynamic Right-Hand Checkboxes //
    //===============================//
    var checkboxToggledFunc = function (cbDef) {
        // call owner's onUpdate() function
        cbDef.onUpdate(cbDef.isChecked);
    };
    var processCheckboxDefs = function (checkboxDefs) {
        var processedCheckboxDefs = _.clone(checkboxDefs);
        var order = 0;
        processedCheckboxDefs.forEach(function (cbDef) {
            cbDef.toggled = checkboxToggledFunc;
            cbDef.order = order++;
            cbDef.id = UtilsService.firstToLowerCase(UtilsService.removeSpaces(cbDef.label)) + 'Checkbox';
        });
        return processedCheckboxDefs;
    };
    self.getRightHandCheckboxes = function () {
        if (processedRightHandCheckboxDefs === null) {
            processedRightHandCheckboxDefs = processCheckboxDefs(self.rightHandCheckboxDefs);
        }
        return processedRightHandCheckboxDefs;
    };
}
angular
    .module('prism-ui.components')
    .component('toolbar', {
    bindings: {
        /*
        buttonDefs - an array of objects, each defining a toolbar
        button.

        Each button object consists of the following properties:

            label:		(string; required) The button label. Also
                        used to find default icon (see 'icon' &
                        'defaultIcons' var above).

            enabled:	(function; required) Function returning
                        boolean to indicate whether the button is
                        enabled.

            onClick:	(function; required) Click handler
                        function.

            icon:		(string | string[]; optional) Font Awesome
                        icon name (e.g. 'fa-plus'). If a default
                        exists for the label you provide, this may
                        be omitted.
                        If multiple Font Awesome icon names are
                        specified, all the icons will be stacked
                        on-top of each other.

            order:		(integer; optional) The order in which the
                        button should appear on the toolbar. If
                        omitted, the order of appearance in the
                        array will be used.
        */
        buttonDefs: '<',
        paginationDefs: '<',
        /*
        rightHandCheckboxDefs - a dynamic array of checkbox
        objects, each representing a checkbox to place on the
        right-hand side of the toolbar.

        The first checkbox in the list will be the right-most.
        Subsequent checkboxes will proceed in order to the left.

        Each checkbox object consist of the following properties:

            label:		(string; required) The checkbox's label.

            onUpdate:	(function; required) A function that will
                        be called when the checkbox's state
                        changes, being passed the new state. E.g.
                        onUpdate(false).

            isChecked:  (boolean; optional) The checkbox's initial
                        checked state.
        */
        rightHandCheckboxDefs: '<',
    },
    controller: ToolbarController,
    templateUrl: 'components/visual/toolbar/toolbar-template.html',
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: weekday-selector-component.js
 *
 * Created by randysorensen on 3/27/17.
 */
'use strict';
function WeekdaySelectorController($scope, $attrs, UtilsService) {
    var self = this;
    self.disabled = $scope.$eval($attrs.ngDisabled);
    //======//
    // Grid //
    //======//
    self.colDefs = [];
    var createWeekdayColDef = function (dayOfWeek) {
        return {
            name: dayOfWeek + 'Column',
            field: dayOfWeek,
            width: 75,
            enableColumnResizing: false,
            headerCellTemplate: '<div class="text-align-center">' + dayOfWeek + '</div>',
            cellTemplate: 'components/visual/weekdaySelector/gridTemplates/weekday-grid-cell-template.html'
        };
    };
    angular.forEach(UtilsService.constants.WEEKDAYS, function (dayOfWeek) {
        self.colDefs.push(createWeekdayColDef(dayOfWeek));
    });
    self.gridOptions = {
        enableRowHeaderSelection: false,
        enableColumnResizing: false,
        rowHeight: 28,
        minRowsToShow: 1,
        enableScrollbars: false,
        columnDefs: self.colDefs,
        data: [{}]
    };
    //================//
    // Event Handlers //
    //================//
    self.toggleDayOfWeek = function (dayOfWeek, event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (self.enabledDays.indexOf(dayOfWeek) >= 0) {
            var idx = self.enabledDays.indexOf(dayOfWeek);
            self.enabledDays.splice(idx, 1);
        }
        else {
            self.enabledDays.push(dayOfWeek);
        }
        self.updated();
    };
}
angular.module('prism-ui.components').component('weekdaySelector', {
    templateUrl: 'components/visual/weekdaySelector/weekday-selector-component-template.html',
    controller: WeekdaySelectorController,
    bindings: {
        enabledDays: '<',
        updated: '&',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 2/3/16.
 */
'use strict';
angular.module('prism-ui.calendars').factory('CalendarColumnsFactory', function () {
    var buildLiveColumns = function () {
        var returnValue = [];
        var feedColumn = {
            field: 'feed',
            minWidth: 200,
            width: 200,
            cellTemplate: 'components/visual/grid/base-tooltip-template.html',
            enableColumnResizing: false
        };
        returnValue.push(feedColumn);
        for (var i = 0; i < 24; i++) {
            var obj = {
                field: i + '',
                width: 60,
                minWidth: 60,
                cellTemplate: 'dashboard/calendars/base/gridTemplates/live-calendar-cell-template.html',
                enableColumnResizing: true
            };
            if (i === 0) {
                obj.displayName = '12 am';
            }
            else if (i <= 11) {
                obj.displayName = i + ' am';
            }
            else if (i === 12) {
                obj.displayName = '12 pm';
            }
            else {
                obj.displayName = (i - 12) + ' pm';
            }
            returnValue.push(obj);
        }
        return returnValue;
    };
    return {
        dueDateColumns: [
            {
                field: 'status',
                name: 'statusIcon',
                displayName: '',
                width: 30,
                minWidth: 30,
                enableColumnResizing: false,
                enableSorting: false,
                cellTemplate: 'dashboard/calendars/base/gridTemplates/status-column-template.html'
            },
            {
                field: 'proxyId',
                enableColumnMenu: false,
                name: 'playIconColumn',
                displayName: '',
                width: 30,
                minWidth: 30,
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'dashboard/calendars/base/gridTemplates/play-icon-column-template.html'
            },
            {
                field: 'dueDate',
                displayName: 'First Due',
                width: 200,
                cellTemplate: 'components/visual/grid/date-time-noseconds-column-template.html'
            },
            {
                field: 'warningDueDate',
                displayName: 'First Warning',
                width: 200,
                cellTemplate: 'components/visual/grid/date-time-noseconds-column-template.html'
            },
            {
                field: 'instanceId',
                displayName: 'Instance',
                width: 75,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'instanceRevision',
                displayName: 'Revision',
                width: 75,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'status',
                displayName: 'Package Status',
                width: 175,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'partnerName',
                displayName: 'Partner',
                width: 175,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'networkName',
                displayName: 'Network',
                width: 175,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'contentName',
                displayName: 'Series/Movie/Ad',
                width: 175,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'episodeTitle',
                displayName: 'Title',
                width: 175,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'productionNumber',
                displayName: 'Prod No.',
                width: 125,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'categoryName',
                displayName: 'Category',
                width: 125,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'metaErrorCount',
                displayName: 'Meta Valid',
                minWidth: 100,
                cellTemplate: 'package/manager/gridTemplates/metadata-error-count-template.html'
            },
            {
                field: 'mediaErrorCount',
                displayName: 'Media Valid',
                width: 100,
                cellTemplate: 'package/manager/gridTemplates/media-error-count-template.html'
            },
            {
                field: 'acceptStatus',
                name: 'Approved',
                width: 100,
                cellTemplate: 'package/manager/gridTemplates/accept-status-template.html'
            }
        ],
        ordColumns: [
            {
                field: 'status',
                name: 'statusIcon',
                displayName: '',
                width: 30,
                minWidth: 30,
                enableColumnResizing: false,
                enableSorting: false,
                cellTemplate: 'dashboard/calendars/base/gridTemplates/status-column-template.html'
            },
            {
                field: 'proxyId',
                enableColumnMenu: false,
                name: 'playIconColumn',
                displayName: '',
                width: 30,
                minWidth: 30,
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'dashboard/calendars/base/gridTemplates/play-icon-column-template.html'
            },
            {
                field: 'status',
                displayName: 'Package Status',
                width: 175,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'networkName',
                displayName: 'Network',
                width: 175,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'contentName',
                displayName: 'Series/Movie/Ad',
                width: 300,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'episodeTitle',
                displayName: 'Title',
                width: 300,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'productionNumber',
                displayName: 'Prod No.',
                width: 125,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'airTime',
                displayName: 'Air Time',
                width: 125,
                cellTemplate: 'components/visual/grid/time-column-template.html'
            },
            {
                field: 'categoryName',
                displayName: 'Category',
                width: 125,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'metaErrorCount',
                displayName: 'Meta Valid',
                minWidth: 100,
                maxWidth: 100,
                cellTemplate: 'package/manager/gridTemplates/metadata-error-count-template.html'
            },
            {
                field: 'mediaErrorCount',
                displayName: 'Media Valid',
                width: 100,
                maxWidth: 100,
                cellTemplate: 'package/manager/gridTemplates/media-error-count-template.html'
            },
            {
                field: 'acceptStatus',
                name: 'Approved',
                width: 100,
                maxWidth: 100,
                cellTemplate: 'package/manager/gridTemplates/accept-status-template.html'
            }
        ],
        firstLaunchColumns: [
            {
                field: 'status',
                name: 'statusIcon',
                displayName: '',
                width: 30,
                minWidth: 30,
                enableColumnResizing: false,
                enableSorting: false,
                cellTemplate: 'dashboard/calendars/base/gridTemplates/status-column-template.html'
            },
            {
                field: 'proxyId',
                enableColumnMenu: false,
                name: 'playIconColumn',
                displayName: '',
                width: 30,
                minWidth: 30,
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'dashboard/calendars/base/gridTemplates/play-icon-column-template.html'
            },
            {
                field: 'status',
                displayName: 'Package Status',
                width: 175,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'networkName',
                displayName: 'Network',
                width: 175,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'partnerNames',
                displayName: 'Partner',
                width: 175,
                cellTemplate: 'components/visual/grid/comma-seperated-array-template.html'
            },
            {
                field: 'contentName',
                displayName: 'Series/Movie/Ad',
                width: 300,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'episodeTitle',
                displayName: 'Title',
                width: 300,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'productionNumber',
                displayName: 'Prod No.',
                width: 125,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'earliestLaunchDate',
                displayName: 'Launch Time',
                width: 125,
                cellTemplate: 'components/visual/grid/time-from-date-template.html'
            },
            {
                field: 'categoryName',
                displayName: 'Category',
                width: 125,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'metaErrorCount',
                displayName: 'Meta Valid',
                minWidth: 100,
                maxWidth: 100,
                cellTemplate: 'package/manager/gridTemplates/metadata-error-count-template.html'
            },
            {
                field: 'mediaErrorCount',
                displayName: 'Media Valid',
                width: 100,
                maxWidth: 100,
                cellTemplate: 'package/manager/gridTemplates/media-error-count-template.html'
            },
            {
                field: 'acceptStatus',
                name: 'Approved',
                width: 100,
                maxWidth: 100,
                cellTemplate: 'package/manager/gridTemplates/accept-status-template.html'
            }
        ],
        liveRecordingsColumns: buildLiveColumns()
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 2/2/16.
 */
'use strict';
angular.module('prism-ui.calendars').controller('CalendarsViewController', function ($interval, $location, $q, $scope, CalendarColumnsFactory, CalendarsFilterService, CalendarsQueryService, DynamicPropertiesService, NavbarUtilService, PermissionsService, SearchFilterService) {
    var self = this, refreshInterval, originalActiveData = {}, refreshDelay;
    self.breadCrumb = 'Calendars';
    self.activeData = {};
    self.activeColumnDefs = [];
    self.showTodayOnly = false;
    self.zoomLevel = 0;
    self.canReadLiveRecordings = null;
    self.activeTabs = {
        dueDate: false,
        ord: false,
        firstLaunch: false,
        liveRecordings: false
    };
    self.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };
    var setCalSearchText = function (searchText) {
        CalendarsFilterService.searchText = searchText ? searchText : '';
    };
    var handleRefresh = function (tab) {
        self.executeQuery(tab, true);
    };
    var filterData = function () {
        var newData = {};
        if (self.showTodayOnly) {
            newData = CalendarsFilterService.filterToday(originalActiveData, self.currentTab);
        }
        else {
            newData = CalendarsFilterService.executeSearch(originalActiveData);
        }
        return newData;
    };
    self.executeQuery = function (newTab, isRefresh) {
        $scope.$broadcast('server-busy', { working: true });
        var promises = [];
        if (self.canReadLiveRecordings === null) {
            promises.push(PermissionsService.isSystemOperator().then(function (isSystemOperator) {
                self.canReadLiveRecordings = isSystemOperator;
            }));
        }
        promises.push(CalendarsQueryService[newTab + 'Query'](self.includeDelivered).then(function (data) {
            if (!isRefresh) {
                for (var tabName in self.activeTabs) {
                    self.activeTabs[tabName] = (tabName === newTab);
                }
                self.activeColumnDefs = CalendarColumnsFactory[newTab + 'Columns'];
                self.currentTab = newTab;
            }
            originalActiveData = angular.copy(data);
        }));
        $q.all(promises).then(function () {
            if (!self.canReadLiveRecordings && self.currentTab === 'liveRecordings') {
                originalActiveData = {};
            }
            self.activeData = filterData();
            $scope.$broadcast('server-busy', { working: false });
        });
    };
    self.activateTab = function (tab) {
        $location.search('subView', tab);
        if (self.currentTab !== tab) {
            self.currentTab = tab;
            self.includeDelivered = tab === 'ord' || tab === 'firstLaunch';
            $interval.cancel(refreshInterval);
            DynamicPropertiesService.queryForProperties().then(function () {
                refreshDelay = DynamicPropertiesService.getPropValueAsInt('calendars.refreshInterval', 60000);
                refreshInterval = $interval(handleRefresh, refreshDelay, 0, true, tab);
                self.executeQuery(tab, false);
            });
        }
    };
    self.todayClicked = function () {
        self.showTodayOnly = true;
        self.activeData = CalendarsFilterService.filterToday(originalActiveData, self.currentTab);
    };
    self.showAllClicked = function () {
        self.showTodayOnly = false;
        self.activeData = CalendarsFilterService.executeSearch(originalActiveData);
    };
    self.zoom = function (zoomPixels) {
        var newDefs = angular.copy(self.activeColumnDefs);
        if ((zoomPixels < 0 && self.zoomLevel > 0) || zoomPixels > 0 && self.zoomLevel < 10) {
            angular.forEach(newDefs, function (columnDef) {
                if (columnDef.enableColumnResizing) {
                    columnDef.width = columnDef.width + zoomPixels;
                }
            });
            if (zoomPixels >= 0) {
                self.zoomLevel++;
            }
            else {
                self.zoomLevel--;
            }
        }
        self.activeColumnDefs = newDefs;
    };
    self.disableZoomIn = function () {
        return self.zoomLevel >= 10;
    };
    self.disableZoomOut = function () {
        return self.zoomLevel <= 0;
    };
    $scope.$on('server-busy', function (event, options) {
        self.loadingIndicator.show = options.working;
    });
    $scope.$on('$destroy', function () {
        $interval.cancel(refreshInterval);
    });
    SearchFilterService.populateCriteriaFromLocationSearch();
    NavbarUtilService.viewSearchFunction = function (searchText) {
        setCalSearchText(searchText);
        self.activeData = filterData();
    };
    setCalSearchText($location.search().searchText);
    self.activateTab($location.search().subView || 'dueDate');
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by randysorensen on 2/26/17.
 */
'use strict';
function QueuesGroupSummaryViewController($scope, $routeParams, $interval, $location, QueuesViewService, ModalService, NavbarUtilService) {
    var self = this;
    var queueGroupLabels = {
        'Deliveries': 'Delivery',
        'Transcodes': 'Transcode',
        'Restores': 'Restore'
    };
    var STATUSES = {
        executing: {
            name: 'executing',
            altName: 'active',
            label: 'Executing',
            altLabel: 'Active'
        },
        queued: {
            name: 'queued',
            label: 'Queued'
        },
        paused: {
            name: 'paused',
            label: 'Paused'
        },
        stalled: {
            name: 'stalled',
            label: 'Stalled'
        },
        finished: {
            name: 'finished',
            label: 'Finished'
        }
    };
    self.groupName = $routeParams.group;
    self.tabName = ($routeParams.group === 'fileCopy') ? 'File Copy' : $routeParams.group;
    self.groupLabel = '';
    self.groupProps = {
        chartData: {
            series: [],
            data: []
        },
        width: 500,
        height: 250
    };
    self.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };
    self.pollingInterval = null;
    self.showFinished = QueuesViewService.showFinishedDataInGraph;
    var pollingFrequency = 30000;
    var updateGroupLabel = function (groupName) {
        if (queueGroupLabels[groupName]) {
            return queueGroupLabels[groupName];
        }
        return groupName;
    };
    var loadQueueGroupSummary = function () {
        self.loadingIndicator.show = true;
        if (self.pollingInterval) {
            $interval.cancel(self.pollingInterval);
            self.pollingInterval = null;
        }
        QueuesViewService.loadGroupSummaryData(self.groupName).then(function (summaryData) {
            self.groupProps.chartData = summaryData;
            self.groupLabel = updateGroupLabel(summaryData.header);
            self.pollingInterval = $interval(loadQueueGroupSummary, pollingFrequency);
            self.loadingIndicator.show = false;
        });
    };
    NavbarUtilService.viewSearchFunction = loadQueueGroupSummary;
    self.getSelectedStatusForDetailGrid = function (status) {
        if (status === STATUSES.executing.label || status === STATUSES.queued.label) {
            return STATUSES.executing.altName;
        }
        else if (status === STATUSES.paused.label) {
            return STATUSES.paused.name;
        }
        else if (status === STATUSES.stalled.label) {
            return STATUSES.stalled.name;
        }
        else {
            return STATUSES.finished.name;
        }
    };
    self.reloadQueuesFromShowFinishedChange = function () {
        QueuesViewService.showFinishedDataInGraph = self.showFinished;
        loadQueueGroupSummary();
    };
    self.openQueueLimitersListModal = function (queueId) {
        if (self.pollingInterval) {
            $interval.cancel(self.pollingInterval);
            self.pollingInterval = null;
        }
        ModalService.showQueueLimiterModal(queueId, self.saveQueueLimiterListModal, self.closeQueueLimiterHandler);
    };
    self.saveQueueLimiterListModal = function (queueObj) {
        QueuesViewService.saveQueueLimiters(queueObj);
        self.pollingInterval = $interval(loadQueueGroupSummary, pollingFrequency);
    };
    self.closeQueueLimiterHandler = function () {
        self.pollingInterval = $interval(loadQueueGroupSummary, pollingFrequency);
    };
    self.openQueueDetailView = function (queue, status) {
        $location.url('/dashboard/queues/summary/' + self.groupName + '/' + queue.id + '/steps' + '?' + 'status=' + status);
    };
    $scope.$on('$destroy', function () {
        $interval.cancel(self.pollingInterval);
    });
    QueuesViewService.breadcrumb = {
        name: self.tabName,
        location: '/dashboard/queues/summary/' + self.groupName
    };
    loadQueueGroupSummary();
}
angular.module('prism-ui.queues').controller('QueuesGroupSummaryViewController', QueuesGroupSummaryViewController);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: queue-detail-view-controller
 *
 * Created by rwilliams on 3/29/17.
 */
'use strict';
function QueueDetailViewController(_, $interval, $location, $q, $routeParams, BreadcrumbService, ModalService, NavbarUtilService, PaginationService, PermissionsService, QueuesViewService, RequestService) {
    var self = this;
    var pollingFrequency = 10000;
    //==================//
    // View Permissions //
    //==================//
    var PREVIEW_TAB_VIEW_STATE = 'PACKAGE_VIDEO_PREVIEW_VIEW_STATE';
    self.canOpenVideoModel = function (media) {
        return self.queuePermissions.preview.read;
    };
    self.canEditPriority = function (queueStep) {
        return queueStep.status === 'QUEUED' && PermissionsService.isAdmin();
    };
    var getColumnsToExclude = function () {
        var statusTab = $location.search().status;
        var queueGroup = $routeParams.group;
        var excludedColumns = [];
        if (statusTab === 'active') {
            excludedColumns = _.concat(excludedColumns, 'endTime');
        }
        else {
            excludedColumns = _.concat(excludedColumns, 'percentComplete', 'bandwidth', 'eTA');
            if (statusTab !== 'finished') {
                excludedColumns = _.concat(excludedColumns, 'endTime');
            }
        }
        // Group Specific
        if (queueGroup === 'transcodes') {
            excludedColumns = _.concat(excludedColumns, 'bandwidth', 'eTA', 'airTime');
        }
        if (queueGroup === 'fileCopy' || queueGroup === 'restores') {
            excludedColumns = _.concat(excludedColumns, 'bandwidth', 'eTA');
        }
        return excludedColumns;
    };
    //======//
    // Data //
    //======//
    var getDataQuery = function () {
        var offset = self.pagingOptions.pageSize * (self.pagingOptions.currentPage - 1);
        var searchText = $location.search().searchText;
        var queryOpts = {
            id: $routeParams.id,
            filter: self.currentTab,
            fetchOffset: offset,
            fetchLimit: self.pagingOptions.pageSize,
        };
        if (searchText) {
            queryOpts.searchString = searchText.toLowerCase();
        }
        if (self.currentTab === 'active') {
            queryOpts.filter = 'active|queued';
        }
        return QueuesViewService.getQueueStepData(queryOpts);
    };
    var loadQueueSteps = function () {
        self.loadingIndicator.show = true;
        if (self.pollingInterval) {
            $interval.cancel(self.pollingInterval);
            self.pollingInterval = null;
        }
        RequestService.queryForNewData(getDataQuery, function (data) { return _.isEmpty(data.stepData); })
            .then(function (data) {
            self.breadcrumbTabName = self.queueName = data.queueData.name;
            self.excludedColumns = getColumnsToExclude();
            self.queueSteps = data.stepData;
        }).finally(function () {
            self.pollingInterval = $interval(loadQueueSteps, pollingFrequency);
            self.loadingIndicator.show = false;
        });
    };
    //============//
    // Pagination //
    //============//
    self.paginationPrevPageHandler = function () {
        --self.pagingOptions.currentPage;
        loadQueueSteps();
    };
    self.paginationNextPageHandler = function () {
        ++self.pagingOptions.currentPage;
        loadQueueSteps();
    };
    self.paginationPageSizeChanged = function () {
        self.pagingOptions.updateCurrentPage();
        loadQueueSteps();
    };
    self.paginationJumpToPageHandler = function () {
        loadQueueSteps();
    };
    //===================//
    // Template Response //
    //===================//
    self.onStepPrioritiesChanged = function (queueSteps) {
        self.loadingIndicator.show = true;
        var promises = _.map(queueSteps, function (queueStep) {
            return QueuesViewService.saveQueueStep(queueStep)
                .then(function (entity) {
                queueStep.priorityOverride = entity.priorityOverride;
                queueStep.priority = null;
            });
        });
        $q.all(promises).then(function () {
            loadQueueSteps();
        });
    };
    self.activateTab = function (tab) {
        QueuesViewService.getQueueViewPermissions(PREVIEW_TAB_VIEW_STATE).then(function (permissions) {
            self.queuePermissions.preview.read = permissions.preview;
            $location.search('status', tab);
            if (self.currentTab !== tab) {
                self.currentTab = tab;
                loadQueueSteps();
            }
        });
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    self.$onInit = function () {
        self.queuePermissions = {
            read: false,
            write: false,
            clone: {
                read: false,
                write: false,
                batch: {
                    write: false
                }
            },
            preview: {
                read: false
            }
        };
        self.pagingOptions = PaginationService;
        self.currentPageSize = self.pagingOptions.pageSize;
        self.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        self.excludedColumns = getColumnsToExclude();
        NavbarUtilService.viewSearchFunction = function () {
            loadQueueSteps(self.currentTab);
        };
    };
    self.$postLink = function () {
        self.activateTab($location.search().status || 'active');
        BreadcrumbService.updateBreadcrumbs(QueuesViewService.breadcrumb);
    };
    self.$onDestroy = function () {
        $interval.cancel(self.pollingInterval);
        self.pollingInterval = null;
    };
}
angular.module('prism-ui.queues').component('queueDetailView', {
    templateUrl: 'dashboard/queues/queueDetail/queue-detail-view-template.html',
    controller: QueueDetailViewController
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
function QueuesSummaryViewController($timeout, $location, BreadcrumbService, QueuesViewService, NavbarUtilService) {
    var self = this;
    var defaultProps = { chartData: { series: [], data: [] }, width: 500, height: 250 };
    var loadDataTimeout = null;
    var loadQueueSummaries = function () {
        self.loadingIndicator.show = true;
        $timeout.cancel(loadDataTimeout);
        QueuesViewService.loadSummaryData().then(function (summaryData) {
            self.transcodesProps.chartData = summaryData.transcodes;
            self.deliveriesProps.chartData = summaryData.deliveries;
            self.restoresProps.chartData = summaryData.restores;
            self.fileCopyProps.chartData = summaryData.fileCopy;
            loadDataTimeout = $timeout(loadQueueSummaries, 15000);
            self.loadingIndicator.show = false;
        });
    };
    self.openQueueGroupSummaryView = function (group) {
        BreadcrumbService.updateBreadcrumbs({ name: 'Queues Summary', location: '/dashboard/queues/summary' });
        QueuesViewService.showFinishedDataInGraph = self.showFinished;
        $location.url('/dashboard/queues/summary/' + group);
    };
    NavbarUtilService.viewSearchFunction = loadQueueSummaries;
    self.transcodesProps = angular.copy(defaultProps);
    self.deliveriesProps = angular.copy(defaultProps);
    self.restoresProps = angular.copy(defaultProps);
    self.fileCopyProps = angular.copy(defaultProps);
    self.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };
    self.reloadQueuesFromShowFinishedChange = function () {
        QueuesViewService.showFinishedDataInGraph = self.showFinished;
        loadQueueSummaries();
    };
    self.$onInit = function () {
        self.showFinished = QueuesViewService.showFinishedDataInGraph;
        loadQueueSummaries();
    };
    self.$onDestroy = function () {
        NavbarUtilService.viewSearchFunction = null;
        $timeout.cancel(loadDataTimeout);
        loadDataTimeout = null;
    };
}
angular.module('prism-ui.queues').component('queuesSummaryView', {
    templateUrl: 'dashboard/queues/summary/queues-summary-view-template.html',
    controller: QueuesSummaryViewController
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by randysorensen on 8/2/16.
 */
'use strict';
angular
    .module('prism-ui.workflows')
    .controller('WorkflowStepViewController', function (_, $interval, $q, $routeParams, $scope, $timeout, parentWorkflow, BreadcrumbService, NavbarUtilService, PaginationService, PermissionsService, SearchFilterService, WorkflowExecutionResourceFactory) {
    var self = this;
    var WORKFLOW_VIEW_STATE = 'DASHBOARD_WORKFLOW_VIEW';
    BreadcrumbService.editService = {
        editorForm: {
            $pristine: true
        }
    };
    self.parentWorkflowId = $routeParams.id;
    self.parentWorkflowExecutionLabel = parentWorkflow.executionLabel;
    self.selectedStep = null;
    self.pagingOptions = PaginationService;
    self.pollingInterval = null;
    self.perms = {
        read: false,
        write: false
    };
    self.gridApi = null;
    self.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };
    self.gridColumnDefs = [
        {
            field: 'percentComplete',
            width: '200',
            displayName: 'Status',
            enableSorting: true,
            enableColumnResizing: true,
            cellTemplate: 'components/visual/grid/progress-bar-template.html'
        },
        {
            field: 'executionLabel',
            displayName: 'Type',
            enableSorting: true,
            enableColumnResizing: true,
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        },
        {
            field: 'startDate',
            width: '200',
            displayName: 'Start',
            enableSorting: true,
            enableColumnResizing: true,
            cellFilter: 'amDateFormat:"MMM, D, YYYY, h:mm:ss A"',
            sort: {
                direction: 'desc',
                priority: 0
            }
        },
        {
            field: 'endDate',
            width: '200',
            displayName: 'End',
            enableSorting: true,
            enableColumnResizing: true,
            cellFilter: 'amDateFormat:"MMM, D, YYYY, h:mm:ss A"'
        }
    ];
    self.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        rowHeight: 30,
        multiSelect: false,
        columnDefs: self.gridColumnDefs,
        onRegisterApi: function (gridApi) {
            self.gridApi = gridApi;
            self.gridApi.selection.on.rowSelectionChanged($scope, self.gridRowSelectionChangedHandler);
        },
        rowTemplate: '<div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ' +
            'class="ui-grid-cell" ui-grid-cell> ' +
            '</div>',
        data: []
    };
    self.gridRowSelectionChangedHandler = function (row) {
        if (!row.isSelected) {
            self.selectedStep = null;
        }
        else {
            self.selectedStep = row.entity;
        }
    };
    self.detailViewCloseHandler = function () {
        self.selectedStep = null;
        self.gridApi.selection.clearSelectedRows();
    };
    var updateRow = function (oldStep, newStep) {
        _.forEach(oldStep, function (value, key) {
            if (!_.isEqual(value, newStep[key])) {
                oldStep[key] = newStep[key];
            }
        });
    };
    var updateGrid = function (newStepData) {
        var newStepDict = {};
        angular.forEach(newStepData, function (step) {
            newStepDict[step.id] = step;
        });
        for (var k = 0; k < self.gridOptions.data.length; k++) {
            var oldStep = self.gridOptions.data[k];
            if (oldStep.id in newStepDict) {
                // Keep oldStep object so selectedStep still points to correct data
                updateRow(oldStep, newStepDict[oldStep.id]);
                delete newStepDict[oldStep.id];
            }
            else {
                self.gridOptions.data.splice(k, 1);
            }
        }
        angular.forEach(newStepDict, function (step) {
            self.gridOptions.data.push(step);
        });
    };
    var getStepData = function () {
        if (!self.perms.read) {
            self.gridOptions.data = [];
            return;
        }
        if (!self.pollingInterval) {
            $scope.$broadcast('server-busy', { working: true });
            self.pollingInterval = $interval(getStepData, 10000);
        }
        var queryOpts = {
            id: self.parentWorkflowId,
            fetchOffset: 0,
            fetchLimit: -1
        };
        WorkflowExecutionResourceFactory.getExecutionSteps(queryOpts, function (stepArray) {
            updateGrid(stepArray);
            $scope.$broadcast('server-busy', { working: false });
        });
    };
    var getPermissions = function () {
        $scope.$broadcast('server-busy', { working: true });
        var canRead = PermissionsService.canRead(WORKFLOW_VIEW_STATE);
        var canWrite = PermissionsService.canWrite(WORKFLOW_VIEW_STATE);
        $q.all({
            read: canRead,
            write: canWrite
        }).then(function (perms) {
            self.perms = perms;
            getStepData();
        });
    };
    //
    // 2017-July-18 (RS)
    //
    // Pagination isn't enabled for workflow steps, and this
    // code isn't yet covered by unit tests, so I'm removing
    // it.
    //
    // self.paginationPrevPageHandler = function () {
    // 	--self.pagingOptions.currentPage;
    // 	self.onPaginationChanged();
    // };
    //
    // self.paginationNextPageHandler = function () {
    // 	++self.pagingOptions.currentPage;
    // 	self.onPaginationChanged();
    // };
    //
    // self.paginationJumpToPageHandler = function () {
    // 	self.onPaginationChanged();
    // };
    //
    // self.onPaginationChanged = function () {
    // 	getStepData();
    // };
    SearchFilterService.populateCriteriaFromLocationSearch();
    NavbarUtilService.viewSearchFunction = function () {
        $scope.$broadcast('server-busy', { working: true });
        getStepData();
    };
    // $scope.$watch(function() {
    // 		return self.pagingOptions.pageSize;
    // 	},
    // 	function (newValue, oldValue) {
    // 		if (newValue !== oldValue) {
    // 			self.currentPageSize = newValue;
    // 			self.onPaginationChanged();
    // 		}
    // 	}
    // );
    $scope.$on('server-busy', function (event, options) {
        self.loadingIndicator.show = options.working;
    });
    $scope.$on('$destroy', function () {
        NavbarUtilService.viewSearchFunction = null;
        $interval.cancel(self.pollingInterval);
    });
    getPermissions();
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: network-edit-view-component
 *
 * Created by rwilliams on 7/25/17.
 */
'use strict';
function NetworkEditViewController($location, NetworkViewService, PermissionsService, SidebarService) {
    var self = this;
    self.getBreadcrumbName = function () {
        return NetworkViewService.breadcrumbName;
    };
    self.setActiveTab = function (tab) {
        $location.search('view', tab);
        if (self.currentTab !== tab) {
            self.currentTab = tab;
        }
    };
    self.$onInit = function () {
        SidebarService.editService = NetworkViewService;
        this.isAdmin = PermissionsService.isAdmin();
        self.permissionViewStates = NetworkViewService.permissionViewStates;
        NetworkViewService.getViewPermissions().then(function (permissions) {
            self.permissions = permissions;
            //If there are write permissions for both preroll and postroll then there are
            //also permissions for break pre/postroll
            self.setActiveTab($location.search().view || 'properties');
        });
    };
    self.$onDestroy = function () {
        $location.search('view', null);
    };
}
angular.module('prism-ui.network').component('networkEditView', {
    templateUrl: 'meta/network/editor/network-edit-view-template.html',
    controller: NetworkEditViewController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: network-search-view-component
 *
 * Created by rwilliams on 7/19/17.
 */
'use strict';
function NetworkSearchViewController($location, uiGridConstants, NetworkViewService, ModalService, SearchFilterService) {
    var self = this;
    var getData = function () {
        self.loadingIndicator.show = true;
        self.searchText = $location.search().searchText || null;
        NetworkViewService.getSearchViewData({ fetchLimit: 0, searchString: self.searchText }).then(function (data) {
            self.gridOptions.data = data;
            self.loadingIndicator.show = false;
        });
    };
    var getPermissions = function () {
        NetworkViewService.getViewPermissions(NetworkViewService.permissionViewStates.NETWORK_VIEW_STATE).then(function (permissions) {
            self.permissions = permissions;
            getData();
        });
    };
    var gridColumns = [
        {
            field: 'name',
            displayName: 'Name',
            sort: {
                direction: uiGridConstants.ASC,
                priority: 0
            },
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        },
        {
            field: 'value',
            displayName: 'Value',
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        },
        {
            field: 'prefix',
            displayName: 'Prefix',
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        },
        {
            field: 'shortDescription',
            displayName: 'Description 1',
            cellTemplate: 'components/visual/grid/base-tooltip-template.html',
            minWidth: 375
        }
    ];
    var openConfirmationModal = function (action, resultHandler) {
        var networkName = self.gridApi.selection.getSelectedRows()[0].name;
        ModalService.showMessageModal({
            messageText: 'Are you sure you want to ' + action + networkName + '?',
            pullCancelLeft: true,
            title: (action.charAt(0).toUpperCase() + action.slice(1)) + 'Network',
            showOK: true,
            okText: 'Yes',
            windowClass: 'confirm-modal-sm'
        }, resultHandler);
    };
    var newNetwork = function () {
        $location.url('/meta/networks/edit/-1');
    };
    var editNetwork = function (networkId) {
        $location.url('/meta/networks/edit/' + networkId);
    };
    var cloneNetwork = function (network) {
        var clonedNetwork = angular.copy(network);
        delete clonedNetwork.id;
        NetworkViewService.saveNetwork(clonedNetwork).then(function (data) {
            $location.url('/meta/networks/edit/' + data.id);
        });
    };
    var showCloneConfirmationModal = function () {
        openConfirmationModal('clone ', function () { cloneNetwork(self.gridApi.selection.getSelectedRows()[0]); });
    };
    self.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };
    self.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: function () { return self.permissions.write; },
            onClick: function () { newNetwork(); }
        },
        {
            label: 'Edit',
            enabled: function () { return self.permissions.read && self.gridApi.selection.getSelectedCount() === 1; },
            onClick: function () { editNetwork(self.gridApi.selection.getSelectedRows()[0].id); }
        },
        {
            label: 'Clone',
            enabled: function () { return self.permissions.write && self.gridApi.selection.getSelectedCount() === 1; },
            onClick: function () { showCloneConfirmationModal(); }
        }
    ];
    self.permissions = {
        read: false,
        write: false
    };
    self.onRowDblClick = function (row) {
        editNetwork(row.entity.id);
    };
    self.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: gridColumns,
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        onRegisterApi: function (gridApi) {
            self.gridApi = gridApi;
        }
    };
    self.$onInit = function () {
        SearchFilterService.populateCriteriaFromLocationSearch();
        getPermissions();
    };
}
angular.module('prism-ui.network').component('networkSearchView', {
    templateUrl: 'meta/network/searchView/network-search-view-template.html',
    controller: NetworkSearchViewController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 2/22/16.
 */
'use strict';
angular.module('prism-ui.package').controller('SelectDeliveryPartnersModalController', function (_, $q, $timeout, $uibModalInstance, PackageActionService, PartnerPackagesService) {
    var self = this;
    var parentPartnerChildren = {};
    self.partnerMap = PackageActionService.partnerMap;
    self.availableDeliveryTemplatesForPartners = PackageActionService.availableDeliveryTemplatesForPartners;
    self.redeliveryReasons = PackageActionService.redeliveryReasons;
    self.selectedPartnerMap = {};
    self.selectedRedeliveryReason = null;
    self.selectedPartnerDeliveryItems = null;
    var isChildPartner = function (partner) {
        return partner.parentId && !_.toNumber(partner.numberOfChildren);
    };
    var isParentPartner = function (partner) {
        return !partner.parentId && !!_.toNumber(partner.numberOfChildren);
    };
    var selectPartnersWithNoErrors = function () {
        _.forEach(PackageActionService.partners, function (partner) {
            if (!self.partnerHasErrors(partner)) {
                $timeout(function () {
                    self.gridApi.selection.selectRow(partner);
                });
            }
        });
    };
    var findPartnerDefaultTemplate = function (partner) {
        if (!PackageActionService.partnerMap[partner.id] || !PackageActionService.partnerMap[partner.id].deliveryTemplates) {
            return null;
        }
        var defaultTemplates = PackageActionService.partnerMap[partner.id].deliveryTemplates.filter(function (template) {
            return template.defaultFlag;
        });
        return (defaultTemplates.length === 1 && !self.partnerHasErrors(partner)) ? defaultTemplates[0] : null;
    };
    var selectPartnersFromToggle = function () {
        _.forEach(self.gridApi.selection.getSelectedRows(), function (partner) {
            if (!self.selectedPartnerMap[partner.id] && !isParentPartner(partner)) {
                self.selectedPartnerMap[partner.id] = {
                    template: findPartnerDefaultTemplate(partner)
                };
            }
        });
    };
    var validPartnerSelection = function () {
        var validPartnerSelection = _.keys(self.selectedPartnerMap).length > 0;
        _.forEach(self.selectedPartnerMap, function (selectedPartner) {
            validPartnerSelection = (validPartnerSelection &&
                selectedPartner.template !== null &&
                (!selectedPartner.template.template.custom ||
                    selectedPartner.template.partnerDeliveryItemIds.length > 0) &&
                !self.partnerHasErrors(selectedPartner));
        });
        return validPartnerSelection;
    };
    self.columns = [
        {
            name: 'checkMarkRowHeaderCol',
            field: 'checkMark',
            width: 30,
            enableColumnMenu: false,
            enableSorting: false,
            cellTemplate: 'package/common/selectDeliveryPartnersModal/check-mark-tree-template.html',
            headerCellTemplate: "<div class=\"ui-grid-cell-contents\"\n                                    col-index=\"renderIndex\"\n                                    ng-click=\"grid.appScope.selectDeliveryPartnersMdlCtrlr.toggleRows($event)\">\n                                    <input type=\"checkbox\" ng-checked=\"grid.appScope.selectDeliveryPartnersMdlCtrlr.gridApi.selection.selectAll\"/>\n                                    <label></label>\n                                </div>"
        },
        {
            field: 'name',
            width: '*',
            displayName: 'Partner',
            cellTemplate: 'package/common/selectDeliveryPartnersModal/partner-error-expandable-template.html',
            enableSorting: false,
            enableColumnMenu: false
        }
    ];
    self.gridOptions = {
        selectionRowHeaderColName: 'checkMarkRowHeaderCol',
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: false,
        enablePaginationControls: false,
        enableFullRowSelection: true,
        enableSorting: false,
        rowHeight: 26,
        multiSelect: true,
        minRowsToShow: 4,
        columnDefs: self.columns,
        enableVerticalScrollbar: 2,
        enableHorizontalScrollbar: 0,
        isRowSelectable: function (row) {
            return row.entity.id && self.canSelectPartner(row.entity);
        },
        data: PackageActionService.partners,
        onRegisterApi: function (gridApi) {
            self.gridApi = gridApi;
            self.gridApi.selection.on.rowSelectionChanged(null, self.gridRowSelectionChangedHandler);
            selectPartnersWithNoErrors();
        }
    };
    var togglePartners = function (parentRow, selectedChildRow, childPartnerRows) {
        if (selectedChildRow) {
            var selectedChildRowCount_1 = 0;
            _.forEach(childPartnerRows, function (childPartnerRow) {
                if (childPartnerRow.isSelected) {
                    selectedChildRowCount_1++;
                }
            });
            parentRow.isSelected = selectedChildRowCount_1 === parentRow.entity.numberOfChildren;
        }
        else {
            _.forEach(childPartnerRows, function (childRow) {
                childRow.isSelected = parentRow.isSelected;
                if (parentRow.isSelected) {
                    self.selectedPartnerMap[childRow.entity.id] = { template: findPartnerDefaultTemplate(childRow.entity) };
                }
                else {
                    delete self.selectedPartnerMap[childRow.entity.id];
                }
            });
        }
    };
    var getParentPartnerRow = function (selectedPartner) {
        var parentRow = {};
        _.forEach(self.gridApi.grid.rows, function (row) {
            if (row.entity.id === selectedPartner.parentId) {
                parentRow = row;
            }
        });
        return parentRow;
    };
    var getChildRows = function (selectedPartner) {
        var childRows = [];
        _.forEach(self.gridApi.grid.rows, function (row) {
            if (isParentPartner(selectedPartner)) {
                if (row.entity.parentId === selectedPartner.id) {
                    childRows.push(row);
                }
            }
            else {
                if (row.entity.parentId === selectedPartner.parentId) {
                    childRows.push(row);
                }
            }
        });
        return childRows;
    };
    self.gridRowSelectionChangedHandler = function (row, event) {
        var partner = row.entity;
        if (!partner.id || self.partnerHasErrors(partner)) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
        }
        if (row.isSelected && partner.id) {
            if (!_.toNumber(partner.numberOfChildren)) {
                self.selectedPartnerMap[partner.id] = { template: findPartnerDefaultTemplate(partner) };
            }
        }
        else {
            _.set(self.selectedPartnerMap[partner.id], 'template.partnerDeliveryItemIds', []);
            delete self.selectedPartnerMap[partner.id];
        }
        if (event && (isParentPartner(partner) || isChildPartner(partner))) {
            var parentPartnerRow = void 0;
            var childPartnerRow = void 0;
            if (isParentPartner(partner)) {
                parentPartnerRow = row;
            }
            else {
                childPartnerRow = row;
                parentPartnerRow = getParentPartnerRow(partner);
            }
            togglePartners(parentPartnerRow, childPartnerRow, getChildRows(partner));
        }
    };
    self.toggleRows = function (evt) {
        if (self.gridApi.selection.selectAll) {
            self.gridApi.selection.clearSelectedRows(evt);
            self.gridApi.selection.selectAll = false;
            self.selectedPartnerMap = {};
        }
        else {
            _.forEach(self.gridOptions.data, function (selection) {
                if (selection.id && !self.partnerHasErrors(selection)) {
                    self.gridApi.selection.selectRow(selection, evt);
                }
            });
            self.gridApi.selection.selectAll = true;
            selectPartnersFromToggle();
        }
    };
    self.canSelectPartner = function (partner) {
        return self.partnerMap[partner.id].hasValidPackage;
    };
    self.partnerHasErrors = function (partner) {
        return partner &&
            partner.id &&
            self.partnerMap[partner.id] &&
            self.partnerMap[partner.id].partnerPkgErrors &&
            self.partnerMap[partner.id].partnerPkgErrors.length > 0;
    };
    var partnerHasErrorsWarnings = function (partner) {
        return self.partnerMap[partner.id].partnerPkgErrors.length > 0 ||
            self.partnerMap[partner.id].partnerPkgWarnings.length > 0;
    };
    self.showErrorsAndWarningsTriangle = function (rowEntity) {
        return partnerHasErrorsWarnings(rowEntity) && !isChildPartner(rowEntity);
    };
    self.showPartnerCheckmark = function (rowEntity) {
        return !partnerHasErrorsWarnings(rowEntity) && !rowEntity.parentId;
    };
    self.showExpandableRowIndicator = function (rowEntity) {
        return partnerHasErrorsWarnings(rowEntity) && !isChildPartner(rowEntity);
    };
    self.showDeliveryTemplateDropdown = function (rowEntity) {
        return (!self.partnerHasErrors(rowEntity) &&
            !isParentPartner(rowEntity)) ||
            isChildPartner(rowEntity);
    };
    var createDivider = function (text, color, fontWeight) {
        if (text === void 0) { text = ""; }
        if (color === void 0) { color = "black"; }
        if (fontWeight === void 0) { fontWeight = "regular"; }
        return {
            _multiselectDivider: true,
            _multiselectDividerText: text,
            _multiselectDividerColor: color,
            _multiselectDividerFontWeight: fontWeight
        };
    };
    var processPartnerPackageDeliveryItems = function (partner, partnerPkgDeliveryItems, partnerPkgId) {
        var partnerPackageInfo = self.selectedPartnerMap[partner.id].partnerPackageInfoLookup[partnerPkgId];
        var newSelectedIds = _.clone(self.selectedPartnerMap[partner.id].template.partnerDeliveryItemIds);
        var headerDivider = createDivider("" + partnerPackageInfo.package.name, 'red', 'bold');
        headerDivider.package = partnerPackageInfo.package;
        var blankDivider = createDivider();
        blankDivider.package = partnerPackageInfo.package;
        _.forEach(partnerPkgDeliveryItems, function (deliveryItem) {
            var msdId = partnerPackageInfo.package.id + "_" + deliveryItem.id;
            deliveryItem.partnerPackage = partnerPackageInfo.partnerPackage;
            deliveryItem.package = partnerPackageInfo.package;
            deliveryItem.msdId = msdId;
            // each delivery item must have a unique ID for the
            // selection locking to work in the multiselect
            // dropdown
            deliveryItem.id = msdId;
            if (deliveryItem.requiredForDelivery) {
                newSelectedIds.push(msdId);
            }
        });
        self.selectedPartnerMap[partner.id].template.partnerDeliveryItemIds = newSelectedIds;
        if (partnerPkgDeliveryItems.length === 0) {
            var noItemsDivider = createDivider("(no configured delivery items)");
            noItemsDivider.package = partnerPackageInfo.package;
            partnerPkgDeliveryItems.push(noItemsDivider);
        }
        return _.concat(headerDivider, _.sortBy(partnerPkgDeliveryItems, self.deliveryItemDropdownLabelFunction), blankDivider);
    };
    self.deliveryTemplateChangeHandler = function (partner) {
        partner.deliveryItems = [];
        if (self.selectedPartnerMap[partner.id].template.template.custom) {
            var deliveryItemPromises_1 = {};
            self.selectedPartnerMap[partner.id].partnerPackageInfoLookup = self.partnerMap[partner.id].partnerPackageInfoLookup;
            _.forEach(_.keys(self.selectedPartnerMap[partner.id].partnerPackageInfoLookup), function (partnerPackageId) {
                deliveryItemPromises_1[partnerPackageId] = PartnerPackagesService.getApplicableDeliveryItems(partnerPackageId);
            });
            partner.showDeliveryItemsDropdownPacifier = true;
            $q.all(deliveryItemPromises_1).then(function (deliveryItems) {
                var partnerDeliveryItemCollection = [];
                _.forEach(deliveryItems, function (partnerPkgDeliveryItems, partnerPkgId) {
                    partnerDeliveryItemCollection.push(processPartnerPackageDeliveryItems(partner, partnerPkgDeliveryItems, partnerPkgId));
                });
                partner.deliveryItems = _.chain(partnerDeliveryItemCollection)
                    .sortBy([
                    function (value) { return _.first(value).package.content.prefix; },
                    function (value) { return _.first(value).package.productionNumber; }
                ])
                    .flatten()
                    .value();
                partner.deliveryItems.splice(-1, 1);
                // remove package headers if there's only one
                // package...
                var headers = _.filter(partner.deliveryItems, { _multiselectDividerColor: 'red' });
                if (headers.length === 1) {
                    _.remove(partner.deliveryItems, headers[0]);
                }
                partner.showDeliveryItemsDropdownPacifier = false;
            });
        }
    };
    self.deliveryItemDropdownLabelFunction = function (deliveryItem) {
        if (_.isString(deliveryItem)) {
            return 'multiple selections';
        }
        var packagePrefix = _.get(deliveryItem, 'package.content.prefix');
        var packageProductionNumber = _.get(deliveryItem, 'package.productionNumber');
        var entityType = _.get(deliveryItem, 'type');
        var entityId = _.chain(deliveryItem)
            .get('id')
            .split('_')
            .last()
            .value();
        var entityName = _.get(deliveryItem, 'name', "(" + entityType + " - ID " + entityId + ")");
        return packagePrefix + " " + packageProductionNumber + " " + entityName;
    };
    self.togglePartnerErrors = function (partner, event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        partner.expanded = !partner.expanded;
        var parentDataIndex = self.gridOptions.data.indexOf(partner);
        if (partner.expanded) {
            var children = self.partnerMap[partner.id].partnerPkgErrors.concat(self.partnerMap[partner.id].partnerPkgWarnings);
            parentPartnerChildren[partner.id] = children;
            self.gridOptions.data.splice.apply(self.gridOptions.data, [parentDataIndex + 1, 0].concat(children));
        }
        else {
            self.gridOptions.data.splice(parentDataIndex + 1, parentPartnerChildren[partner.id].length);
            parentPartnerChildren[partner.id] = null;
        }
    };
    self.showRedeliverReasonDropdown = function () {
        for (var partnerId in self.selectedPartnerMap) {
            if (self.partnerMap[partnerId].redeliver) {
                return true;
            }
        }
        return false;
    };
    self.onOk = function () {
        $uibModalInstance.close({ selectedPartners: self.selectedPartnerMap, redeliveryReason: self.selectedRedeliveryReason });
    };
    self.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
    self.disableOKButton = function () {
        return (self.showRedeliverReasonDropdown() && !self.selectedRedeliveryReason) || !validPartnerSelection();
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 3/30/16.
 */
'use strict';
angular.module('prism-ui.package').controller('SelectMasterMediaTypesModalController', function ($uibModalInstance) {
    var self = this;
    self.selectedContent = {
        'Video': true,
        'Audio': true,
        'CC': true,
        'Subtitle': true,
        'Image': true
    };
    self.toggleContent = function (contentType) {
        if (self.selectedContent[contentType]) {
            delete self.selectedContent[contentType];
        }
        else {
            self.selectedContent[contentType] = true;
        }
    };
    self.onOk = function () {
        $uibModalInstance.close(self.selectedContent);
    };
    self.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
    self.disableOKButton = function () {
        return Object.keys(self.selectedContent).length === 0;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: exec-servers-controller.js
 *
 * Created by psnyder on 3/28/17.
 */
'use strict';
function ExecServersController($interval, $location, $scope, ExecServersResourceFactory, NavbarUtilService, NotificationService, SearchFilterService) {
    var self = this;
    var execServerInterval;
    self.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };
    self.gridColumns = [
        {
            field: 'name',
            displayName: 'Name',
            enableSorting: false,
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        },
        {
            field: 'host',
            displayName: 'Host',
            enableSorting: false,
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        },
        {
            field: 'port',
            displayName: 'Port',
            enableSorting: false,
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        },
        {
            field: 'operatingSystem',
            displayName: 'OS',
            enableSorting: false,
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        },
        {
            field: 'enabledFlag',
            displayName: 'Enabled',
            enableSorting: false,
            cellTemplate: 'system/execServers/searchView/renderers/exec-servers-checkmark-cell-template.html'
        },
        {
            field: 'onlineFlag',
            displayName: 'Online',
            enableSorting: false,
            cellTemplate: 'components/visual/grid/radio-button-template.html'
        }
    ];
    self.currentGridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: false,
        enablePaginationControls: false,
        useExternalPagination: true,
        enableColumnMenus: false,
        enableFullRowSelection: false,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: self.gridColumns,
        rowTemplate: '<div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ' +
            'class="ui-grid-cell" ui-grid-cell></div>',
        onRegisterApi: function (gridApi) {
            self.gridApi = gridApi;
            self.gridApi.grid.registerRowsProcessor(self.processGridFilter, 200);
        },
    };
    var queryForGridData = function () {
        self.loadingIndicator.show = true;
        // ------------- SETUP FOR FUTURE PAGINATION ------------
        //
        // var offset = self.pagingOptions.pageSize * (self.pagingOptions.currentPage - 1);
        // var queryOpts = {
        // 	fetchOffset: offset,
        // 	fetchLimit: self.pagingOptions.pageSize
        // };
        $interval.cancel(execServerInterval);
        self.execServers = ExecServersResourceFactory.query();
        self.execServers.$promise.then(function (data) {
            self.editData = data;
            self.currentGridOptions.data = self.editData;
            self.searchText = $location.search().searchText || null;
            self.filterGrid(self.searchText);
            self.loadingIndicator.show = false;
            execServerInterval = $interval(queryForGridData, 20000);
        });
    };
    self.checkMarkCellClicked = function (row) {
        var tempObject = angular.copy(row);
        if (tempObject.operatingSystem === 'UNIX') {
            tempObject.operatingSystem = 'Linux/Unix';
        }
        ExecServersResourceFactory.update({ id: row.id }, tempObject).$promise.then(function (data) {
            queryForGridData();
            // self.currentGridOptions.data = data;
            if (data.enabledFlag) {
                NotificationService.createInfoNotification('Enabling Exec Server:\n The exec will go online within 5 minutes');
            }
            else {
                NotificationService.createInfoNotification('Disabling Exec Server:\n The exec will go offline within 5 minutes');
            }
        });
    };
    self.filterGrid = function (searchText) {
        if (searchText !== null) {
            self.searchText = searchText.toLowerCase();
            self.gridApi.grid.refresh();
        }
    };
    self.processGridFilter = function (renderableRows) {
        renderableRows.forEach(function (row) {
            row.visible = (self.searchText === null) ?
                true :
                row.entity.name.toLowerCase().indexOf(self.searchText) !== -1;
        });
        return renderableRows;
    };
    // -------- SETUP FOR FUTURE PAGINATION --------
    //
    // self.pagingOptions = PaginationService;
    // PaginationService.pageDataResource = ExecServersResourceFactory;
    //
    // var handleGridDataQuery = function (gridData, responseHeaders) {
    // 	PaginationService.parseResponseHeaders(responseHeaders());
    // 	PaginationService.pageData = gridData;
    // 	self.currentPageSize = gridData.length;
    // };
    // -------HANDLERS FOR FUTURE PAGINATION TOOLBAR IF NEEDED--------
    //
    // self.paginationPrevPageHandler = function () {
    // 	--self.pagingOptions.currentPage;
    // 	self.onPaginationChanged();
    // };
    //
    // self.paginationNextPageHandler = function () {
    // 	++self.pagingOptions.currentPage;
    // 	self.onPaginationChanged();
    // };
    //
    // self.paginationJumpToPageHandler = function () {
    // 	self.onPaginationChanged();
    // };
    //
    // self.onPaginationChanged = function () {
    // 	queryForGridData();
    // };
    //
    // $scope.$watch(function() {
    // 		return self.pagingOptions.pageSize;
    // 	},
    // 	function (newValue, oldValue) {
    // 		if (newValue !== oldValue) {
    // 			self.currentPageSize = newValue;
    // 			self.onPaginationChanged();
    // 		}
    // 	}
    // );
    NavbarUtilService.viewSearchFunction = queryForGridData;
    SearchFilterService.populateCriteriaFromLocationSearch();
    queryForGridData();
    $scope.$on('$destroy', function () {
        $interval.cancel(execServerInterval);
    });
}
angular.module('prism-ui.execServers').component('execServersSearchView', {
    templateUrl: 'system/execServers/searchView/exec-servers-search-template.html',
    controller: ExecServersController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 1/13/16.
 */
'use strict';
angular.module('prism-ui.livefeed').controller('LiveFeedEditController', function ($routeParams, $scope, BreadcrumbService, LiveFeedEditService, LivefeedsResourceFactory) {
    var self = this;
    LiveFeedEditService.EditDataResource = LivefeedsResourceFactory;
    BreadcrumbService.editService = LiveFeedEditService;
    self.editService = LiveFeedEditService;
    self.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };
    self.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () {
                return (self.editorForm &&
                    !self.editorForm.$pristine &&
                    self.editorForm.$valid);
            },
            onClick: function () {
                $scope.$broadcast('server-busy', { working: true });
                LiveFeedEditService.saveEditData().then(function () {
                    self.editData = LiveFeedEditService.editData;
                    $scope.$broadcast('server-busy', { working: false });
                });
            }
        }, {
            label: 'Revert',
            enabled: function () {
                return $routeParams.id <= -1 || (self.editorForm &&
                    !self.editorForm.$pristine);
            },
            onClick: function () {
                LiveFeedEditService.revertEditData();
                self.editData = LiveFeedEditService.editData;
            }
        }, {
            label: 'Close',
            enabled: function () { return true; },
            onClick: function () {
                LiveFeedEditService.exitEdit();
            }
        }
    ];
    $scope.$watch(function () {
        return self.editorForm;
    }, function () {
        if (self.editorForm) {
            LiveFeedEditService.editorForm = self.editorForm;
        }
    });
    $scope.$on('server-busy', function (event, options) {
        self.loadingIndicator.show = options.working;
    });
    $scope.$on('$destroy', function () {
        BreadcrumbService.editService = null;
        LiveFeedEditService.resetServiceData();
    });
    $scope.$broadcast('server-busy', { working: true });
    LiveFeedEditService.getEditData().then(function () {
        self.editData = LiveFeedEditService.editData;
        $scope.$broadcast('server-busy', { working: false });
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 2/16/16.
 */
'use strict';
function PartnerEditController(_, $location, $routeParams, BreadcrumbService, MetadataItemsSearchViewService, MetadataItemsViewDataTransformerFactory, NotificationService, PartnerEditService, PermissionsService, SearchFilterService, SidebarService, SubscriptionsService, UtilsService) {
    var self = this;
    var requiredPropertiesForPartner = {
        'properties': ['name', 'value', 'timeZone',
            'dateFormat', 'timeFormat', 'dateTimeFormat', 'numberFormat',
            'artwork', 'serviceableLanguages']
    };
    var requiredPropertiesForChildPartner = {
        'properties': ['name', 'value', 'timeZone',
            'dateFormat', 'timeFormat', 'dateTimeFormat', 'numberFormat',
            'artwork', 'serviceableLanguages']
    };
    var getEditViewData = function () {
        PartnerEditService.getEditData().then(function (editData) {
            self.partnerObject = editData.partner;
            // if its a child partner (e.g. a child of a super
            // partner) and the path matches any of the tabs that
            // should not be accessible then navigate back to the
            // login screen
            if (_.has(editData.partner, 'parentId') &&
                ($routeParams.editView === 'mvpdItems' ||
                    $routeParams.editView === 'metadataItems' ||
                    $routeParams.editView === 'subscriptions')) {
                // navigate to the login screen
                $location.path('/login');
            }
            else {
                // show the tabs
                self.activeTabs[$routeParams.editView] = true;
                self.currentViewedTab = $routeParams.editView;
                self.setTabVisibility(editData.partner);
                self.loadingIndicator.show = false;
            }
        });
        PartnerEditService.saveDisabled = self.saveDisabled;
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    self.$onInit = function () {
        BreadcrumbService.editService = PartnerEditService;
        self.isAdmin = PermissionsService.isAdmin();
        SidebarService.editService = PartnerEditService;
        self.editService = PartnerEditService;
        self.loadingIndicator.show = true;
        SearchFilterService.populateCriteriaFromLocationSearch();
        if ($routeParams.editView === 'mvpdItems') {
            this.columnDefs = MetadataItemsViewDataTransformerFactory.mvpdColumns;
        }
        else {
            this.columnDefs = MetadataItemsViewDataTransformerFactory.partnerColumns;
        }
        self.permissions = {};
        PartnerEditService.getViewPermissions()
            .then(function (permissions) {
            _.set(self.permissions, 'deliveryEndpoints.read', permissions.deliveryEndpointsRead);
            _.set(self.permissions, 'deliveryEndpoints.write', permissions.deliveryEndpointsWrite);
            _.set(self.permissions, 'deliveryProfiles.read', true);
            _.set(self.permissions, 'deliveryProfiles.write', true);
            _.set(self.permissions, 'emailEndpoints.read', permissions.emailEndpointsRead);
            _.set(self.permissions, 'emailEndpoints.write', permissions.emailEndpointsWrite);
            _.set(self.permissions, 'dueDateTemplates.read', permissions.dueDateTemplatesRead);
            _.set(self.permissions, 'dueDateTemplates.write', permissions.dueDateTemplatesWrite);
            getEditViewData();
        });
    };
    self.$onDestroy = function () {
        self.loadingIndicator.show = false;
        PartnerEditService.saveDisabled = null;
    };
    self.currentViewedTab = '';
    // required property lists, indexed by tab name
    self.requiredProperties = requiredPropertiesForPartner;
    self.activeTabs = {
        properties: false,
        deliveryEndpoints: false,
        deliveryProfiles: false,
        emailEndpoints: false,
        planner: false,
        metadataItems: false,
        mvpdItems: false,
        subscriptions: false,
        dueDateTemplates: false,
        nielsenTemplates: false,
        audioMappingRules: false
    };
    self.validTabs = {
        properties: true,
        deliveryEndpoints: true,
        deliveryProfiles: true,
        emailEndpoints: true,
        planner: true,
        metadataItems: true,
        mvpdItems: true,
        subscriptions: true,
        dueDateTemplates: true,
        nielsenTemplates: true,
        audioMappingRules: true
    };
    self.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };
    self.onSave = function () {
        self.loadingIndicator.show = true;
        PartnerEditService.saveEditData().then(function () {
            self.partnerObject = PartnerEditService.partnerObject;
            self.setTabVisibility(self.partnerObject);
            self.loadingIndicator.show = false;
        });
    };
    self.onRevert = function () {
        self.partnerObject = PartnerEditService.revertEditData();
    };
    self.onClose = function () {
        PartnerEditService.exitEdit();
    };
    self.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () {
                var isProcessing = self.loadingIndicator.show;
                var isNew = $routeParams.id <= -1;
                var isPristine = PartnerEditService.editorForm && PartnerEditService.editorForm.$pristine;
                var saveDisabled = PartnerEditService.saveDisabled && PartnerEditService.saveDisabled() === true;
                return !isProcessing && (isNew || !isPristine) && !saveDisabled;
            },
            onClick: self.onSave
        },
        {
            label: 'Revert',
            enabled: function () {
                var isProcessing = self.loadingIndicator.show;
                var isNew = $routeParams.id <= -1;
                var isPristine = PartnerEditService.editorForm && PartnerEditService.editorForm.$pristine;
                return !isProcessing && (isNew || !isPristine);
            },
            onClick: self.onRevert
        },
        {
            label: 'Close',
            enabled: function () { return !self.loadingIndicator.show; },
            onClick: self.onClose
        }
    ];
    self.onTabSelect = function (tabName) {
        PartnerEditService.changeEditTab(tabName);
        self.filterEnabled = (tabName === 'subscriptions');
    };
    self.onTabDeselect = function (tabName, event) {
        if (tabName === 'subscriptions' &&
            SubscriptionsService.editorForm &&
            SubscriptionsService.editorForm.$dirty ||
            !PartnerEditService.canExitEditView()) {
            event.preventDefault();
            NotificationService.createWarningNotification('Please save or revert your changes before navigating away from this page.');
        }
    };
    self.saveDisabled = function () {
        if (!PartnerEditService.partnerObject) {
            return true;
        }
        // "Pre-Delivery Validator" - "Enabled" + required
        // "Delivery Endpoint" check
        if (PartnerEditService.partnerObject.embargoEnabledFlag &&
            !_.has(PartnerEditService, 'partnerObject.embargoDeliveryEndpoint')) {
            return true;
        }
        // "Pre-Delivery QC Approval" - "Enabled" + required
        // "Delivery Endpoint" check
        if (PartnerEditService.partnerObject.approvalEnabledFlag &&
            !_.has(PartnerEditService, 'partnerObject.approvalDeliveryEndpoint')) {
            return true;
        }
        self.requiredProperties = _.get(PartnerEditService, 'partnerObject.parentId') ? requiredPropertiesForChildPartner : requiredPropertiesForPartner;
        if (self.currentViewedTab in self.requiredProperties) {
            return self.requiredProperties[self.currentViewedTab].reduce(function (accum, current) {
                return accum || !UtilsService.hasData(PartnerEditService.partnerObject[current]);
            }, false);
        }
        return false;
    };
    self.setTabVisibility = function (partner) {
        // if the partner is a child of a super partner, these
        // tabs should not be viewable
        self.validTabs.metadataItems = !partner.parentId;
        self.validTabs.mvpdItems = !partner.parentId;
        self.validTabs.subscriptions = !partner.parentId;
        self.validTabs.dueDateTemplates = self.permissions.dueDateTemplates.read;
    };
    self.getMetadataPropertiesPromise = function () {
        var showMVPD = $routeParams.editView === 'mvpdItems';
        return MetadataItemsSearchViewService.getPartnerMetadataProperties($routeParams.id, showMVPD);
    };
}
angular.module('prism-ui.partner').component('partnerEditView', {
    templateUrl: 'system/partner/editor/partner-edit-template.html',
    controller: PartnerEditController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 2/16/16.
 */
'use strict';
angular
    .module('prism-ui.partner')
    .service('PartnerEditService', function (_, $routeParams, $location, $q, $route, BreadcrumbService, ContentResourceFactory, DeliveryTemplatesResourceFactory, EmailTemplatesResourceFactory, NetworkResourceFactory, NotificationService, PackageResourceFactory, PartnerResourceFactory, PermissionsService, LivefeedsResourceFactory, TransformTemplatesResourceFactory, UtilsService, MediaConversionTemplateService, PaginationService) {
    var self = this;
    var originalPartnerData;
    self.partnerObject = null;
    self.editorForm = null;
    self.deliveryTemplates = [];
    self.tabRevertFunction = null;
    self.tabSaveSuccessFunction = null;
    self.tabSaveErrorFunction = null;
    self.saveDisabled = null;
    self.parentRoute = '/system/partners/search';
    self.viewStates = {
        SYSTEM_PARTNERS_DELIVERYENDPOINTS_VIEW_STATE: 'SYSTEM_PARTNERS_DELIVERYENDPOINTS_VIEW_STATE',
        SYSTEM_PARTNERS_EMAIL_VIEW_STATE: 'SYSTEM_PARTNERS_EMAIL_VIEW_STATE',
        SYSTEM_PARTNERS_DUE_DATE_TEMPLATES_VIEW_STATE: 'SYSTEM_PARTNERS_DUE_DATE_TEMPLATES_VIEW_STATE'
    };
    self.resetBreadcrumbs = function () {
        BreadcrumbService.clearBreadcrumbs();
        BreadcrumbService.addBreadcrumb({
            name: 'Partners',
            location: '/system/partners/search',
            params: angular.copy($location.search())
        });
    };
    //================//
    // Partner Editor //
    //================//
    var closeEditView = function (toRoute) {
        self.resetBreadcrumbs();
        self.partnerObject = null;
        self.editorForm = null;
        $location.path(toRoute || self.parentRoute);
    };
    self.getViewPermissions = function () {
        var deliveryEndpointsViewState = self.viewStates.SYSTEM_PARTNERS_DELIVERYENDPOINTS_VIEW_STATE;
        var emailEndpointsViewState = self.viewStates.SYSTEM_PARTNERS_EMAIL_VIEW_STATE;
        var dueDateTemplatesViewState = self.viewStates.SYSTEM_PARTNERS_DUE_DATE_TEMPLATES_VIEW_STATE;
        return $q.all({
            deliveryEndpointsRead: PermissionsService.canRead(deliveryEndpointsViewState),
            deliveryEndpointsWrite: PermissionsService.canWrite(deliveryEndpointsViewState),
            emailEndpointsRead: PermissionsService.canRead(emailEndpointsViewState),
            emailEndpointsWrite: PermissionsService.canWrite(emailEndpointsViewState),
            dueDateTemplatesRead: PermissionsService.canRead(dueDateTemplatesViewState),
            dueDateTemplatesWrite: PermissionsService.canWrite(dueDateTemplatesViewState)
        });
    };
    self.getAllPartners = function (queryParams, queryHandler) {
        if (queryParams === void 0) { queryParams = {}; }
        if (queryHandler === void 0) { queryHandler = function () {
        }; }
        return PartnerResourceFactory.query(queryParams, queryHandler).$promise;
    };
    self.getEditData = function () {
        var partnerReady = $q.defer();
        if ($routeParams.id > -1) {
            self.partnerObject = PartnerResourceFactory.get({ id: $routeParams.id });
            self.partnerObject.$promise.then(function (partnerData) {
                originalPartnerData = angular.copy(partnerData);
                partnerReady.resolve(partnerData);
            });
        }
        else {
            self.partnerObject = new PartnerResourceFactory({});
            partnerReady.resolve(self.partnerObject);
        }
        self.deliveryTemplates = DeliveryTemplatesResourceFactory.query();
        return $q.all({
            partner: partnerReady.promise,
            deliveryTemplates: self.deliveryTemplates.$promise,
            partnersWithoutChildPartners: self.getAllPartners({ fetchLimit: 0, includeChildren: false })
        });
    };
    self.revertEditData = function () {
        if (self.partnerObject.id) {
            self.partnerObject = _.cloneDeep(originalPartnerData);
            self.editorForm.$setPristine();
            if (self.tabRevertFunction) {
                self.tabRevertFunction();
            }
            return self.partnerObject;
        }
        else {
            closeEditView();
        }
    };
    self.saveEditData = function () {
        if (!self.partnerObject.embargoEnabledFlag) {
            delete self.partnerObject.embargoDeliveryEndpoint;
            delete self.partnerObject.embargoEmailEndpoint;
        }
        if (!self.partnerObject.approvalEnabledFlag) {
            delete self.partnerObject.autoApprovalFlag;
            delete self.partnerObject.approvalDeliveryEndpoint;
            delete self.partnerObject.approvalEmailEndpoint;
        }
        var savePromise = (self.partnerObject.id > -1) ?
            self.partnerObject.$update() :
            self.partnerObject.$save();
        savePromise.then(function (partnerData) {
            originalPartnerData = angular.copy(partnerData);
            self.editorForm.$setPristine();
            $route.updateParams({ id: partnerData.id });
            if (self.tabSaveSuccessFunction) {
                self.tabSaveSuccessFunction();
            }
        }, function () {
            if (self.tabSaveErrorFunction) {
                self.tabSaveErrorFunction();
            }
        });
        return savePromise;
    };
    self.showUnsavedChangesNotification = function () {
        NotificationService.createWarningNotification('You have unsaved changes. Please save or revert.', '');
    };
    self.exitEdit = function (toRoute) {
        if (self.canExitEditView()) {
            closeEditView(toRoute);
        }
        else {
            self.showUnsavedChangesNotification();
        }
    };
    self.changeEditTab = function (tabName) {
        if (self.canExitEditView()) {
            $route.updateParams({ editView: tabName });
        }
    };
    self.canExitEditView = function () {
        return !self.editorForm || (self.partnerObject.id && self.editorForm.$pristine);
    };
    //==================//
    // Partner Planners //
    //==================//
    self.deletePlanner = function (planner) {
        return PartnerResourceFactory.deletePlanner({ id: planner.id }).$promise;
    };
    // The server maintains a planner's weekly schedule as a set
    // of integers which each represent the number of minutes into
    // the week after which the planner should be delivered.
    //
    // The UI presents this data as an array of weekdays, and a time
    // of day at which the planner will run.
    var getScheduleSet = function (planner) {
        // Create PlannerDTO.weeklySchedule
        var scheduleSet = [];
        var hoursAndMinutes = planner.scheduleTimeOfDay.split(':');
        var timeOfDayOffset = Number(hoursAndMinutes[0]) * 60 + Number(hoursAndMinutes[1]);
        var dayOfWeekOffsets = {
            'Sun': 0,
            'Mon': UtilsService.constants.MINUTES_PER_DAY,
            'Tue': UtilsService.constants.MINUTES_PER_DAY * 2,
            'Wed': UtilsService.constants.MINUTES_PER_DAY * 3,
            'Thu': UtilsService.constants.MINUTES_PER_DAY * 4,
            'Fri': UtilsService.constants.MINUTES_PER_DAY * 5,
            'Sat': UtilsService.constants.MINUTES_PER_DAY * 6
        };
        planner.scheduleDays.forEach(function (day) {
            scheduleSet.push(dayOfWeekOffsets[day] + timeOfDayOffset);
        });
        return scheduleSet;
    };
    var getDaysAndTime = function (planner) {
        // Interpret PlannerDTO.weeklySchedule for UI
        if (planner.weeklySchedule !== undefined) {
            planner.scheduleDays = [];
            planner.weeklySchedule.forEach(function (minutesIntoWeek) {
                planner.scheduleDays.push(UtilsService.minutesToWeekday(minutesIntoWeek));
                planner.scheduleTimeOfDay = UtilsService.minutesToTimeOfDay(minutesIntoWeek);
            });
        }
    };
    var createPlannerScheduleLabel = function (scheduleDays, scheduleTime) {
        // Create a compact label to represent a planner's weekly
        // schedule in the search view.
        //
        // Example: 'Mo,We,Fr @ 08:30 AM'
        var label = '';
        scheduleDays.forEach(function (day) {
            if (label.length > 0) {
                label += ',';
            }
            label += day.substring(0, 2);
        });
        var meridian = 'AM';
        var parts = scheduleTime.split(':');
        parts[0] = Number(parts[0]);
        parts[1] = Number(parts[1]);
        if (parts[0] === 0) {
            parts[0] = 12;
        }
        else if (parts[0] >= 12) {
            if (parts[0] > 12) {
                parts[0] -= 12;
            }
            meridian = 'PM';
        }
        label += ' @ ' + UtilsService.timeToString(parts[0], parts[1]) + ' ' + meridian;
        return label;
    };
    //
    // Planner <==> DTO converters - add/remove properties
    // only needed by the server and/or the UI
    //
    var plannerFromDTO = function (plannerDTO) {
        var planner = _.cloneDeep(plannerDTO, true);
        // these fields must be Number()'s for the editor UI
        UtilsService.convertToNumber(planner, 'lookBack');
        UtilsService.convertToNumber(planner, 'lookForward');
        UtilsService.convertToNumber(planner, 'frequency');
        // setup schedule properties for UI
        if (planner.weeklySchedule !== undefined) {
            planner.frequency = undefined;
            planner.scheduleType = 'weekly';
            getDaysAndTime(planner);
            planner.scheduleLabel = createPlannerScheduleLabel(planner.scheduleDays, planner.scheduleTimeOfDay);
        }
        else {
            planner.scheduleType = 'recurring';
            planner.weeklySchedule = [];
            planner.scheduleDays = [];
            planner.scheduleTimeOfDay = '00:00';
            planner.scheduleLabel = planner.frequency + ' hour';
            if (planner.frequency > 1) {
                planner.scheduleLabel += 's';
            }
        }
        // coerce searchBySunrise to a default of false
        // since it's excluded from the DTO unless true
        if (plannerDTO.searchBySunrise === undefined) {
            planner.searchBySunrise = false;
        }
        return planner;
    };
    var plannersFromDTO = function (planners) {
        var modifiedPlanners = [];
        planners.forEach(function (planner) {
            modifiedPlanners.push(plannerFromDTO(planner));
        });
        return modifiedPlanners;
    };
    var plannerToDTO = function (planner) {
        var dto = _.cloneDeep(planner);
        // remove extraneous schedule
        // properties used only by the UI
        if (planner.scheduleType === 'recurring') {
            delete dto.weeklySchedule;
        }
        else {
            dto.weeklySchedule = getScheduleSet(planner);
            dto.frequency = 1;
        }
        delete dto.scheduleType;
        delete dto.scheduleDays;
        delete dto.scheduleTimeOfDay;
        delete dto.scheduleLabel;
        return dto;
    };
    self.savePartnerPlanner = function (planner) {
        var dto = plannerToDTO(planner);
        var promise = $routeParams.plannerId > -1 ?
            PartnerResourceFactory.updatePlanner({ id: planner.id }, dto).$promise :
            PartnerResourceFactory.createPlanner({ id: $routeParams.id }, dto).$promise;
        promise.then(function (data) {
            var newPlanner = plannerFromDTO(data);
            self.originalPlannerData = _.cloneDeep(newPlanner);
            self.plannerObject = _.cloneDeep(newPlanner);
            self.editorForm.$setPristine();
        });
        return promise;
    };
    self.revertPartnerPlanner = function () {
        self.editorForm.$setPristine();
        if ($routeParams.plannerId > -1) {
            self.plannerObject = _.cloneDeep(self.originalPlannerData);
        }
        else {
            self.closePlannerEditView();
        }
    };
    self.closePlannerEditView = function () {
        if (self.editorForm && self.editorForm.$dirty) {
            self.showUnsavedChangesNotification();
        }
        else {
            self.resetBreadcrumbs();
            self.plannerObject = _.cloneDeep(self.originalPlannerData);
            self.editorForm = null;
            $location.path('/system/partners/edit/' + self.partnerObject.id + '/planner');
        }
    };
    var getPartnerPromise = function () {
        if (!self.partnerObject || self.partnerObject.id !== $routeParams.id) {
            return PartnerResourceFactory.get({ id: $routeParams.id }).$promise;
        }
        else {
            var partnerDeferred = $q.defer();
            partnerDeferred.resolve(self.partnerObject);
            return partnerDeferred.promise;
        }
    };
    self.deliverOffCyclePlanners = function (plannersList, message) {
        var plannerIds = [];
        _.forEach(plannersList, function (planner) {
            plannerIds = _.concat(plannerIds, planner.id);
        });
        return PartnerResourceFactory.deliverOffCyclePlanners({
            plannerId: plannerIds,
            message: message
        }).$promise;
    };
    self.getPartnerPlanners = function (queryParams) {
        var plannersPromise = PartnerResourceFactory.getAllPlanners(queryParams).$promise;
        return plannersPromise.then(function (response) {
            var returnObj = {
                planners: plannersFromDTO(response),
                headers: response.$httpHeaders()
            };
            delete returnObj.planners.$httpHeaders;
            return returnObj;
        });
    };
    self.getPlannerSearchViewData = function () {
        var partnerPromise = getPartnerPromise();
        var plannersPromise = PartnerResourceFactory.getPlanners({ id: $routeParams.id }).$promise;
        return $q.all({
            partnerObject: partnerPromise,
            planners: plannersPromise
        }).then(function (data) {
            data.planners = plannersFromDTO(data.planners);
            self.partnerObject = data.partnerObject;
            return data;
        });
    };
    self.getPlannerEditViewData = function () {
        var partnerPromise = getPartnerPromise();
        var plannerPromise;
        if ($routeParams.plannerId > -1) {
            plannerPromise = PartnerResourceFactory
                .getPlanner({ id: $routeParams.plannerId })
                .$promise;
        }
        else {
            var plannerDeferred = $q.defer();
            self.plannerObject = {
                enabledFlag: false,
                searchBySunrise: false,
                scheduleDays: [],
                scheduleTimeOfDay: '00:00',
                scheduleType: 'recurring'
            };
            plannerDeferred.resolve(self.plannerObject);
            plannerPromise = plannerDeferred.promise;
        }
        return $q.all({
            partnerObject: partnerPromise,
            availableDeliveryEndpoints: PartnerResourceFactory.getDeliveryEndpoints({
                id: $routeParams.id
            }).$promise,
            availableEmailEndpoints: PartnerResourceFactory.getEmailEndpoints({
                partnerId: $routeParams.id
            }).$promise,
            availableTransformTemplates: TransformTemplatesResourceFactory.query().$promise,
            plannerObject: plannerPromise,
        }).then(function (data) {
            self.partnerObject = data.partnerObject;
            self.plannerObject = plannerFromDTO(data.plannerObject);
            data.plannerObject = self.plannerObject;
            self.originalPlannerData = _.cloneDeep(self.plannerObject);
            return data;
        });
    };
    //====================//
    // Delivery Endpoints //
    //====================//
    self.supportedEndpointTypes = {
        'S3': 'Amazon S3',
        'AppleNews': 'Apple News',
        'ASPERA': 'Aspera',
        'ASPERA_KEY': 'Aspera Key',
        'ASPERA_CLI': 'Aspera Share',
        'IVI': 'Freewheel IVI',
        'FTP': 'FTP',
        'GS': 'Google Storage',
        'iTunes': 'iTunes',
        'Netflix': 'Netflix',
        'Network': 'Network',
        'SFTP': 'SFTP',
        'UPLYNK': 'UpLynk',
        'Vantage': 'Vantage'
    };
    self.getEndpointTypeLabel = function (type) {
        return self.supportedEndpointTypes[type];
    };
    //
    // Planner <==> DTO converters - add/remove properties
    // only needed by the server and/or the UI
    //
    var deliveryEndpointFromDTO = function (deliveryEndpointDTO) {
        var deliveryEndpoint = _.cloneDeep(deliveryEndpointDTO, true);
        // these fields default to 0
        ['maxRetries', 'bandwidthThreshold'].forEach(function (field) {
            if (!UtilsService.hasData(deliveryEndpointDTO[field])) {
                deliveryEndpoint[field] = 0;
            }
        });
        // these fields must be Number()'s for the editor UI
        UtilsService.convertToNumber(deliveryEndpoint, 'maxRetries');
        UtilsService.convertToNumber(deliveryEndpoint, 'bandwidthThreshold');
        UtilsService.convertToNumber(deliveryEndpoint, 'bandwidthWarningDelay');
        return deliveryEndpoint;
    };
    var deliveryEndpointsFromDTO = function (deliveryEndpoints) {
        var modifiedDeliveryEndpoints = [];
        deliveryEndpoints.forEach(function (deliveryEndpoint) {
            modifiedDeliveryEndpoints.push(deliveryEndpointFromDTO(deliveryEndpoint));
        });
        return modifiedDeliveryEndpoints;
    };
    self.getDeliveryEndpointSearchViewData = function (showHidden) {
        var partnerPromise = getPartnerPromise();
        var deliveryEndpointsPromise = PartnerResourceFactory
            .getDeliveryEndpoints({
            id: $routeParams.id,
            includeHidden: showHidden
        }).$promise;
        return $q.all({
            partnerObject: partnerPromise,
            deliveryEndpoints: deliveryEndpointsPromise
        })
            .then(function (data) {
            data.deliveryEndpoints = deliveryEndpointsFromDTO(data.deliveryEndpoints);
            self.partnerObject = data.partnerObject;
            return data;
        });
    };
    var endpointTypeMap = {
        applenews: 'AppleNews',
        aspera: 'ASPERA',
        aspera_key: 'ASPERA_KEY',
        aspera_cli: 'ASPERA_CLI',
        ftp: 'FTP',
        itunes: 'iTunes',
        ivi: 'IVI',
        netflix: 'Netflix',
        network: 'Network',
        s3: 'S3',
        sftp: 'SFTP',
        uplynk: 'UPLYNK',
        vantage: 'Vantage'
    };
    self.getPartnerDeliveryEndpointEditData = function () {
        var partnerPromise = getPartnerPromise();
        var deliveryEndpointPromise;
        if ($routeParams.endpointId > -1) {
            // Get existing endpoint
            deliveryEndpointPromise = PartnerResourceFactory
                .getDeliveryEndpoint({ endpointId: $routeParams.endpointId })
                .$promise;
        }
        else {
            // Construct new endpoint
            var deliveryEndpointDeferred = $q.defer();
            var type = $routeParams.endpointType;
            self.endpointObject = {
                type: endpointTypeMap[type],
                maxRetries: '0',
                bandwidthThreshold: '0',
            };
            // Set protocol specific defaults
            switch (type) {
                case 'aspera':
                case 'aspera_key':
                    self.endpointObject.tcpPort = 22;
                    self.endpointObject.udpPort = 33001;
                    self.endpointObject.transferPolicy = '-Q';
                    self.endpointObject.resumePolicy = '0';
                    break;
                case 'aspera_cli':
                    self.endpointObject.cipher = 'none';
                    break;
                case 'ftp':
                    self.endpointObject.serverPort = 21;
                    break;
                case 'itunes':
                    self.endpointObject.deliveryMethod = 'Auto';
                    self.endpointObject.transferSpeed = 10000;
                    self.endpointObject.logLevel = 'eXtreme';
                    break;
                case 'netflix':
                    self.endpointObject.tcpPort = 22;
                    self.endpointObject.udpPort = 33001;
                    self.endpointObject.transferPolicy = '-Q';
                    self.endpointObject.resumePolicy = '0';
                    self.endpointObject.netflixDeliveryInfoExpression = '=subject.netflixDeliveryInfo';
                    break;
                case 'applenews':
                case 'gs':
                case 'ivi':
                case 'network':
                case 's3':
                case 'sftp':
                case 'uplynk':
                case 'vantage':
                    break;
                default:
                    console.warn('Unknown endpoint type: ' + type);
                    break;
            }
            deliveryEndpointDeferred.resolve(self.endpointObject);
            deliveryEndpointPromise = deliveryEndpointDeferred.promise;
        }
        var mediaConversionTemplatesPromise = MediaConversionTemplateService.getAllMediaConversionTemplates();
        return $q.all({
            partnerObject: partnerPromise,
            endpointObject: deliveryEndpointPromise,
            mediaConversionTemplates: mediaConversionTemplatesPromise
        }).then(function (data) {
            self.endpointObject =
                data.endpointObject =
                    deliveryEndpointFromDTO(data.endpointObject);
            self.partnerObject = data.partnerObject;
            self.originalEndpointData = _.cloneDeep(self.endpointObject);
            return data;
        });
    };
    self.savePartnerDeliveryEndpoint = function (deliveryEndpoint) {
        var promise;
        if (_.size(deliveryEndpoint.secondaryApiKey) > 0 && !_.size(deliveryEndpoint.secondaryUserName)) {
            delete deliveryEndpoint.secondaryApiKey;
        }
        if (!!deliveryEndpoint.id) {
            promise = PartnerResourceFactory.updateDeliveryEndpoint({
                endpointId: deliveryEndpoint.id
            }, deliveryEndpoint).$promise;
        }
        else {
            promise = PartnerResourceFactory.createDeliveryEndpoint({
                partnerId: $routeParams.id
            }, deliveryEndpoint).$promise;
        }
        promise.then(function (newEndpointDTO) {
            var newEndpoint = deliveryEndpointFromDTO(newEndpointDTO);
            self.originalEndpointData = _.cloneDeep(newEndpoint);
            self.endpointObject = _.cloneDeep(newEndpoint);
            self.editorForm.$setPristine();
        });
        return promise;
    };
    self.revertPartnerDeliveryEndpoint = function () {
        if (self.endpointObject.id) {
            self.endpointObject = _.cloneDeep(self.originalEndpointData);
            self.editorForm.$setPristine();
        }
        else {
            closeEditView();
        }
    };
    self.getDeliveryEndpointsForPartner = function (partnerId, extendedDTO) {
        if (partnerId >= 0) {
            return PartnerResourceFactory.getDeliveryEndpoints({
                id: partnerId,
                view: extendedDTO ? 'EXTENDED' : 'MINIMAL'
            }).$promise;
        }
        else {
            return $q.when([]);
        }
    };
    //=================//
    // Email Endpoints //
    //=================//
    self.getEmailEndpointSearchViewData = function (showHidden) {
        var partnerPromise = getPartnerPromise();
        var emailEndpointsPromise = PartnerResourceFactory.getEmailEndpoints({
            partnerId: $routeParams.id,
            includeHidden: showHidden
        }).$promise;
        return $q.all({
            partnerObject: partnerPromise,
            emailEndpoints: emailEndpointsPromise
        })
            .then(function (data) {
            self.partnerObject = data.partnerObject;
            return data;
        });
    };
    self.getEmailEndpointEditData = function () {
        // Get partner
        var partnerPromise = getPartnerPromise();
        // Get email endpoint
        var emailEndpointPromise;
        if ($routeParams.endpointId > -1) {
            // Get existing email endpoint
            emailEndpointPromise = PartnerResourceFactory
                .getEmailEndpoint({
                id: $routeParams.endpointId
            }).$promise;
        }
        else {
            // Construct new email endpoint
            var emailEndpointDeferred = $q.defer();
            emailEndpointDeferred.resolve({});
            emailEndpointPromise = emailEndpointDeferred.promise;
        }
        // Get email templates
        var emailTemplatesPromise = EmailTemplatesResourceFactory.query().$promise;
        return $q.all({
            partnerObject: partnerPromise,
            availableEmailTemplates: emailTemplatesPromise,
            endpointObject: emailEndpointPromise
        })
            .then(function (data) {
            self.partnerObject = data.partnerObject;
            self.endpointObject = data.endpointObject;
            self.originalEndpointObject = _.cloneDeep(data.endpointObject);
            return data;
        });
    };
    self.saveEmailEndpoint = function (emailEndpoint) {
        var resourceFunc = emailEndpoint.id ? 'updateEmailEndpoint' : 'createEmailEndpoint';
        var params = emailEndpoint.id ? { id: emailEndpoint.id } : { partnerId: self.partnerObject.id };
        return PartnerResourceFactory[resourceFunc](params, emailEndpoint).$promise
            .then(function (newEndpoint) {
            self.endpointObject = newEndpoint;
            self.originalEndpointObject = _.cloneDeep(newEndpoint);
            self.editorForm.$setPristine();
            return newEndpoint;
        });
    };
    self.toggleEmailEndpointVisibility = function (emailEndpointId) {
        return PartnerResourceFactory.toggleEmailEndpointVisibility({
            id: emailEndpointId,
        }).$promise;
    };
    self.cloneEmailEndpoint = function (emailEndpointId) {
        return PartnerResourceFactory.cloneEmailEndpoint({
            id: emailEndpointId,
        }).$promise;
    };
    self.revertEmailEndpoint = function (toRoute) {
        if (self.endpointObject.id) {
            self.endpointObject = _.cloneDeep(self.originalEndpointObject);
            self.editorForm.$setPristine();
        }
        else {
            closeEditView(toRoute);
        }
    };
    self.getEmailEndpointsForPartner = function (partnerId) {
        if (partnerId >= 0) {
            return PartnerResourceFactory.getEmailEndpoints({
                partnerId: partnerId
            }).$promise;
        }
        else {
            return $q.when([]);
        }
    };
    //===============
    // SLA Templates
    //===============
    self.getDueDateTemplatesForPartner = function (partnerId, includeHidden) {
        if (includeHidden === void 0) { includeHidden = false; }
        return PartnerResourceFactory.getDueDateTemplates({
            partnerId: partnerId,
            includeHidden: includeHidden
        }).$promise;
    };
    self.getDueDateTemplatesSearchViewData = function (showHidden) {
        var partnerPromise = getPartnerPromise();
        var dueDateTemplatesPromise = self.getDueDateTemplatesForPartner($routeParams.id, showHidden);
        return $q.all({
            partnerObject: partnerPromise,
            dueDateTemplates: dueDateTemplatesPromise
        }).then(function (data) {
            self.partnerObject = data.partnerObject;
            return data;
        });
    };
    self.cloneDueDateTemplate = function (dueDateTemplate) {
        return PartnerResourceFactory.cloneDueDateTemplate({
            id: dueDateTemplate.id
        }).$promise;
    };
    self.saveDueDateTemplate = function (dueDateTemplate) {
        var resourceFunc;
        var params;
        if (dueDateTemplate.id) {
            resourceFunc = 'updateDueDateTemplate';
            params = { id: dueDateTemplate.id };
        }
        else {
            resourceFunc = 'createDueDateTemplate';
            params = { partnerId: $routeParams.id };
        }
        return PartnerResourceFactory[resourceFunc](params, dueDateTemplate).$promise
            .then(function (newDueDateTemplateObject) {
            self.dueDateTemplateObject = newDueDateTemplateObject;
            self.originalDueDateTemplateObject = _.cloneDeep(newDueDateTemplateObject);
            self.editorForm.$setPristine();
            return newDueDateTemplateObject;
        });
    };
    self.getDueDateTemplatesEditViewData = function () {
        var partnerPromise = getPartnerPromise();
        var dueDateTemplatePromise;
        if ($routeParams.dueDateTemplateId > -1) {
            dueDateTemplatePromise = PartnerResourceFactory.getDueDateTemplate({
                id: $routeParams.dueDateTemplateId
            }).$promise;
        }
        else {
            var dueDateTemplateDeferred = $q.defer();
            dueDateTemplateDeferred.resolve({});
            dueDateTemplatePromise = dueDateTemplateDeferred.promise;
        }
        var emailTemplatesPromise = EmailTemplatesResourceFactory.query().$promise;
        var businessesPromise = PartnerResourceFactory.getBusinesses().$promise;
        return $q.all({
            partnerObject: partnerPromise,
            availableEmailTemplates: emailTemplatesPromise,
            availableBusinesses: businessesPromise,
            dueDateTemplateObject: dueDateTemplatePromise
        }).then(function (data) {
            self.partnerObject = data.partnerObject;
            self.dueDateTemplateObject = data.dueDateTemplateObject;
            UtilsService.convertToNumber(self.dueDateTemplateObject, 'warningThresholdHours');
            self.originalDueDateTemplateObject = _.cloneDeep(data.dueDateTemplateObject);
            if ($routeParams.dueDateTemplateId < 0) {
                self.dueDateTemplateObject.business = data.availableBusinesses[0];
            }
            return data;
        });
    };
    self.toggleDueDateTemplateVisibility = function (dueDateTemplate) {
        return PartnerResourceFactory.toggleDueDateTemplateVisibility({
            id: dueDateTemplate.id
        }).$promise;
    };
    self.revertDueDateTemplate = function (toRoute) {
        if (self.dueDateTemplateObject.id) {
            self.dueDateTemplateObject = _.cloneDeep(self.originalDueDateTemplateObject);
            self.editorForm.$setPristine();
        }
        else {
            closeEditView(toRoute);
        }
    };
    //===================//
    // Nielsen Templates //
    //===================//
    self.getNielsenTemplatesForPartner = function (partnerId, includeHidden) {
        if (includeHidden === void 0) { includeHidden = false; }
        return PartnerResourceFactory.getNielsenTemplates({
            partnerId: partnerId,
            includeHidden: includeHidden
        }).$promise;
    };
    self.createNielsenTemplate = function (partnerId, nielsenTemplate) {
        return PartnerResourceFactory.createNielsenTemplate({ partnerId: partnerId }, nielsenTemplate).$promise;
    };
    self.cloneNielsenTemplate = function (nielsenTemplateId) {
        return PartnerResourceFactory.cloneNielsenTemplate({ id: nielsenTemplateId }).$promise;
    };
    self.getNielsenTemplate = function (nielsenTemplateId) {
        return PartnerResourceFactory.getNielsenTemplate({ id: nielsenTemplateId }).$promise;
    };
    self.updateNielsenTemplate = function (nielsenTemplate) {
        return PartnerResourceFactory.updateNielsenTemplate(nielsenTemplate).$promise;
    };
    self.toggleNielsenTemplateHidden = function (nielsenTemplateId) {
        return PartnerResourceFactory.toggleNielsenTemplateHidden({ id: nielsenTemplateId }).$promise;
    };
    //===================//
    // Delivery Profiles//
    //===================//
    self.getDeliveryProfilesForPartner = function (partnerId, includeHidden) {
        if (includeHidden === void 0) { includeHidden = false; }
        return PartnerResourceFactory.getDeliveryProfiles({
            partnerId: partnerId,
            includeHidden: includeHidden
        }).$promise;
    };
    self.getDeliveryProfile = function (deliveryProfileId, showHiddenEmails) {
        if (showHiddenEmails === void 0) { showHiddenEmails = false; }
        return PartnerResourceFactory.getDeliveryProfile({ profileId: deliveryProfileId, includeHiddenEmails: showHiddenEmails }).$promise;
    };
    self.createDeliveryProfile = function (partnerId, deliveryProfile) {
        return PartnerResourceFactory.createDeliveryProfile({ partnerId: partnerId }, deliveryProfile).$promise;
    };
    self.updateDeliveryProfile = function (deliveryProfile) {
        return PartnerResourceFactory.updateDeliveryProfile(deliveryProfile).$promise;
    };
    self.toggleDeliveryEmailHidden = function (deliveryProfileId, deliveryEmailId) {
        return PartnerResourceFactory.toggleDeliveryEmailHidden({ profileId: deliveryProfileId, id: deliveryEmailId }).$promise;
    };
    self.getDeliveryEmail = function (deliveryProfileId, deliveryEmailId) {
        return PartnerResourceFactory.getDeliveryEmail({ profileId: deliveryProfileId, id: deliveryEmailId }).$promise;
    };
    self.updateDeliveryEmail = function (deliveryProfileId, deliveryEmail) {
        return PartnerResourceFactory.updateDeliveryEmail({ profileId: deliveryProfileId, id: deliveryEmail.id }, deliveryEmail).$promise;
    };
    self.createDeliveryEmail = function (deliveryProfileId, deliveryEmail) {
        return PartnerResourceFactory.createDeliveryEmail({ profileId: deliveryProfileId }, deliveryEmail).$promise;
    };
    self.getDeliveryItemsForProfile = function (criteria) {
        return PartnerResourceFactory.getDeliveryItemsForProfile(criteria, function (gridData, responseHeaders) {
            PaginationService.parseResponseHeaders(responseHeaders());
            PaginationService.pageData = gridData;
        }).$promise;
    };
    self.toggleDeliveryItemHidden = function (deliveryProfileId) {
        return PartnerResourceFactory.toggleDeliveryItemHidden({ id: deliveryProfileId }).$promise;
    };
    self.cloneDeliveryItem = function (deliveryProfileId) {
        return PartnerResourceFactory.cloneDeliveryItem({ id: deliveryProfileId }).$promise;
    };
    self.getDeliveryItem = function (id) {
        return PartnerResourceFactory.getDeliveryItem({ id: id }).$promise;
    };
    self.updateDeliveryItem = function (deliveryItem) {
        return PartnerResourceFactory.updateDeliveryItem({ id: deliveryItem.id }, deliveryItem).$promise;
    };
    self.createDeliveryItem = function (deliveryItem) {
        return PartnerResourceFactory.createDeliveryItem(deliveryItem).$promise;
    };
    //===============//
    // Service Entry //
    //===============//
    if (BreadcrumbService.getBreadcrumbs().length === 0) {
        self.resetBreadcrumbs();
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 2/19/16.
 */
'use strict';
angular.module('prism-ui.calendars').service('CalendarsFilterService', function () {
    var CalendarsFilterService = this;
    var searchFields = ['episodeTitle'];
    CalendarsFilterService.searchText = '';
    var matchesSearchFields = function (data) {
        var matcher = new RegExp(CalendarsFilterService.searchText.toLowerCase());
        for (var key in searchFields) {
            var searchVal = data[searchFields[key]];
            if (searchVal && searchVal.toLowerCase().match(matcher)) {
                return true;
            }
        }
        return false;
    };
    var filterDueDateSectionsForToday = function (collection, dateProp, today) {
        var returnVal = [];
        angular.forEach(collection.data, function (item) {
            if (new Date(item[dateProp]).setHours(0, 0, 0, 0) === today.getTime() && matchesSearchFields(item)) {
                returnVal.push(item);
            }
        });
        return returnVal;
    };
    var filterDueDateForToday = function (todayKey, collection) {
        var returnValue = {};
        if (collection.Overdue) {
            returnValue.Overdue = {
                data: filterDueDateSectionsForToday(collection.Overdue, 'dueDate', todayKey),
                style: 'overdue-cal-header'
            };
        }
        if (collection.Warning) {
            returnValue.Warning = {
                data: filterDueDateSectionsForToday(collection.Warning, 'warningDueDate', todayKey),
                style: 'warning-cal-header'
            };
        }
        return returnValue;
    };
    CalendarsFilterService.filterToday = function (collection, calendar) {
        var todayKey = new Date(new Date().setHours(0, 0, 0, 0));
        var newData = {};
        var dateData = collection[todayKey];
        if (dateData) {
            var searchable = {};
            searchable[todayKey] = dateData;
            newData = CalendarsFilterService.executeSearch(searchable);
        }
        if (calendar === 'dueDate') {
            var dueSpecialSections = filterDueDateForToday(todayKey, collection);
            newData.Overdue = dueSpecialSections.Overdue;
            newData.Warning = dueSpecialSections.Warning;
        }
        return newData;
    };
    CalendarsFilterService.executeSearch = function (toFilter) {
        var newData = {};
        if (!CalendarsFilterService.searchText || !CalendarsFilterService.searchText.length) {
            return toFilter;
        }
        angular.forEach(toFilter, function (dateData, itemKey) {
            angular.forEach(dateData.data, function (calObject) {
                if (matchesSearchFields(calObject)) {
                    var keyData = newData[itemKey];
                    if (!keyData) {
                        keyData = { data: [], style: dateData.style };
                        newData[itemKey] = keyData;
                    }
                    newData[itemKey].data.push(calObject);
                }
            });
        });
        return newData;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 2/3/16.
 */
'use strict';
angular
    .module('prism-ui.calendars')
    .service('CalendarsQueryService', function ($q, CalendarsResourceFactory, RecordResourceFactory) {
    var CalendarsQueryService = this;
    var buildDueDateMap = function (data) {
        var returnValue = {};
        var overdueCollection = [];
        var warningCollection = [];
        angular.forEach(data, function (item) {
            var dueDate = new Date(item.dueDate);
            var warningDate = new Date(item.warningDueDate);
            var now = new Date();
            if (dueDate.getTime() <= now.getTime()) {
                overdueCollection.push(item);
            }
            else if (warningDate.getTime() <= now.getTime()) {
                warningCollection.push(item);
            }
            else {
                var dateKey = new Date(dueDate.setHours(0, 0, 0, 0));
                var dateData = returnValue[dateKey];
                if (!dateData) {
                    dateData = {
                        data: []
                    };
                    returnValue[dateKey] = dateData;
                }
                dateData.data.push(item);
            }
        });
        if (overdueCollection.length) {
            returnValue.Overdue = {
                position: 0,
                data: overdueCollection,
                style: 'overdue-cal-header'
            };
        }
        if (warningCollection.length) {
            returnValue.Warning = {
                position: 1,
                data: warningCollection,
                style: 'warning-cal-header'
            };
        }
        return returnValue;
    };
    var buildDateHeaderMap = function (data, keyProp) {
        var returnValue = {};
        angular.forEach(data, function (item) {
            var date = new Date(item[keyProp]);
            var dateKey = new Date(date.setHours(0, 0, 0, 0));
            var dateData = returnValue[dateKey];
            if (!dateData) {
                dateData = {
                    data: []
                };
                returnValue[dateKey] = dateData;
            }
            dateData.data.push(item);
        });
        return returnValue;
    };
    var buildOrdMap = function (data) {
        return buildDateHeaderMap(data, 'originalReleaseDate');
    };
    var buildFirstLaunchMap = function (data) {
        return buildDateHeaderMap(data, 'earliestLaunchDate');
    };
    var insertSlotData = function (slotData, toInsert) {
        var returnValue = angular.copy(slotData);
        if (returnValue && returnValue.length) {
            angular.forEach(slotData, function (schedule) {
                var toInsertStart = toInsert.start.getTime();
                var toInsertEnd = toInsert.stop.getTime();
                var scheduleStart = schedule.start.getTime();
                var scheduleEnd = schedule.stop.getTime();
                var startsBeforeEnd = toInsertStart >= scheduleStart && toInsertStart <= scheduleEnd;
                var endsAfterStarts = toInsertEnd >= scheduleStart && toInsertStart <= scheduleEnd;
                if (startsBeforeEnd || endsAfterStarts) {
                    toInsert.hasConflict = true;
                }
            });
            returnValue.push(toInsert);
        }
        else {
            returnValue = [toInsert];
        }
        return returnValue;
    };
    var handleConflict = function (timeSlot, current, previous, i, endBlock) {
        var conflictPercent = 0;
        current.paddingStart = 0;
        if (current.startMinutes) {
            if (current.stopMinutes < previous.stopMinutes) {
                //var endBlock = angular.copy(previous);
                var previousLeftPct = ((current.startMinutes - previous.startMinutes) / 60) * 100;
                conflictPercent = ((current.stopMinutes - current.startMinutes) / 60) * 100;
                current.paddingEnd = 0;
                previous.blockPct = previousLeftPct;
                current.blockPct -= conflictPercent;
                current.conflictPct = conflictPercent;
                endBlock.blockPct -= conflictPercent + previousLeftPct;
                endBlock.paddingStart = 0;
                var conflictIndex = i + 1;
                var nextSchedule = timeSlot[conflictIndex];
                var previousSchedule = timeSlot[i];
                while (nextSchedule && nextSchedule.hasConflict) {
                    var scheduleConflictPct = ((previousSchedule.stopMinutes - nextSchedule.startMinutes) / 60) * 100;
                    var conflictWithEndBlockPct = ((nextSchedule.stopMinutes - nextSchedule.startMinutes) / 60) * 100;
                    if (previousSchedule.stopMinutes < nextSchedule.startMinutes) {
                        conflictPercent = ((previous.stopMinutes - nextSchedule.startMinutes) / 60) * 100;
                        nextSchedule.blockPct -= conflictPercent;
                        nextSchedule.paddingStart = 0;
                        nextSchedule.conflictPct = conflictPercent;
                        endBlock.blockPct -= conflictPercent;
                        timeSlot.splice(conflictIndex, 0, endBlock);
                        return conflictIndex + 2;
                    }
                    else {
                        previousSchedule.conflictPct -= scheduleConflictPct;
                        nextSchedule.blockPct -= conflictWithEndBlockPct;
                        endBlock.blockPct -= (conflictWithEndBlockPct - scheduleConflictPct);
                        nextSchedule.conflictPct = conflictWithEndBlockPct;
                        nextSchedule.paddingStart = nextSchedule.paddingEnd = 0;
                    }
                    conflictIndex++;
                    nextSchedule = timeSlot[conflictIndex];
                    previousSchedule = timeSlot[conflictIndex - 1];
                }
                timeSlot.splice(conflictIndex, 0, endBlock);
                return conflictIndex + 1;
            }
            else {
                conflictPercent = (Math.abs(previous.stopMinutes - current.startMinutes) / 60) * 100;
                previous.blockPct -= conflictPercent;
                current.blockPct -= conflictPercent;
                current.conflictPct = conflictPercent;
            }
        }
        else if (previous.stopMinutes <= current.stopMinutes) {
            conflictPercent = (previous.stopMinutes / 60) * 100;
            current.conflictPct = conflictPercent;
            previous.blockPct = Math.max(previous.blockPct - conflictPercent, 0);
            current.blockPct = Math.max(current.blockPct - conflictPercent, 0);
        }
        else {
            conflictPercent = ((current.stopMinutes - current.startMinutes) / 60) * 100;
            current.conflictPct = conflictPercent;
            current.paddingEnd = 0;
            timeSlot[i - 1] = current;
            timeSlot[i] = previous;
            current.conflictPct = conflictPercent;
            previous.blockPct = Math.max(previous.blockPct - conflictPercent, 0);
            current.blockPct = Math.max(current.blockPct - conflictPercent, 0);
        }
        return i;
    };
    var adjustSlotData = function (toAdjust) {
        angular.forEach(toAdjust, function (timeSlot) {
            for (var i = 1; i < timeSlot.length; i++) {
                var current = timeSlot[i];
                var previous = timeSlot[i - 1];
                previous.paddingEnd = 0;
                if (current.hasConflict) {
                    i = handleConflict(timeSlot, current, previous, i, angular.copy(previous));
                }
                else {
                    current.paddingStart = ((current.start.getMinutes() - previous.stop.getMinutes()) / 60) * 100;
                }
            }
        });
    };
    var createLiveRowData = function (data) {
        var returnValue = {};
        angular.forEach(data, function (item) {
            var start = new Date(item.startTime);
            var stop = new Date(item.stopTime);
            var startHours = start.getHours();
            var startMinutes = start.getMinutes();
            var stopHours = stop.getHours();
            var stopMinutes = stop.getMinutes();
            var blocks = stopHours - startHours;
            var recordingLength = (stop.getTime() - start.getTime()) / 60000;
            var toInsert = {};
            var arrayMarker = angular.copy(startHours);
            if (startMinutes !== 0) {
                // Doesn't start at the top of the hour, but will go through the end of the hour
                if (blocks > 0) {
                    toInsert = {
                        blockPct: ((60 - startMinutes) / 60) * 100,
                        startMinutes: startMinutes,
                        stopMinutes: 60,
                        paddingStart: (startMinutes / 60) * 100,
                        packageId: item.packageId,
                        packageName: item.packageName,
                        start: start,
                        stop: stop
                    };
                    recordingLength -= (60 - startMinutes);
                }
                // Starts and ends during the same hour but doesn't start at the top of the hour
                else {
                    toInsert = {
                        blockPct: ((stopMinutes - startMinutes) / 60) * 100,
                        paddingStart: (startMinutes / 60) * 100,
                        startMinutes: startMinutes,
                        stopMinutes: stopMinutes,
                        packageName: item.packageName,
                        start: start,
                        stop: stop,
                        packageId: item.packageId
                    };
                    recordingLength -= stopMinutes - startMinutes;
                }
                toInsert.paddingEnd = 100 - toInsert.paddingStart - toInsert.blockPct;
                returnValue[arrayMarker] = insertSlotData(returnValue[arrayMarker], toInsert);
                arrayMarker++;
            }
            while (recordingLength >= 60) {
                toInsert = {
                    blockPct: 100,
                    paddingStart: 0,
                    startMinutes: 0,
                    stopMinutes: 60,
                    paddingEnd: 0,
                    packageId: item.packageId,
                    packageName: item.packageName,
                    start: start,
                    stop: stop
                };
                returnValue[arrayMarker] = insertSlotData(returnValue[arrayMarker], toInsert);
                recordingLength -= 60;
                arrayMarker++;
            }
            if (recordingLength > 0) {
                toInsert = {
                    blockPct: (stopMinutes / 60) * 100,
                    paddingStart: 0,
                    startMinutes: 0,
                    stopMinutes: stopMinutes,
                    paddingEnd: 0,
                    packageId: item.packageId,
                    packageName: item.packageName,
                    start: start,
                    stop: stop
                };
                toInsert.paddingEnd = 100 - toInsert.blockPct;
                returnValue[arrayMarker] = insertSlotData(returnValue[arrayMarker], toInsert);
            }
        });
        adjustSlotData(returnValue);
        return returnValue;
    };
    var buildDateFeedMap = function (data) {
        var returnValue = {};
        angular.forEach(data, function (recording) {
            if (recording.recordStatus === 'cancelled') {
                return;
            }
            var dateKey = new Date(new Date(recording.startTime).setHours(0, 0, 0, 0));
            var dayData = returnValue[dateKey];
            if (!dayData) {
                returnValue[dateKey] = {};
            }
            var feed = returnValue[dateKey][recording.feedName];
            if (!feed) {
                returnValue[dateKey][recording.feedName] = [];
            }
            returnValue[dateKey][recording.feedName].push(recording);
        });
        return returnValue;
    };
    var buildLiveMap = function (data) {
        var liveData = buildDateFeedMap(data);
        var returnValue = {};
        angular.forEach(liveData, function (feedData, dateKey) {
            returnValue[dateKey] = { data: [] };
            angular.forEach(feedData, function (dayFeedSchedules, feedKey) {
                dayFeedSchedules.sort(function (a, b) {
                    var start1 = new Date(a.startTime).getTime();
                    var start2 = new Date(b.startTime).getTime();
                    var stop1 = new Date(a.stopTime).getTime();
                    var stop2 = new Date(b.stopTime).getTime();
                    if (start1 < start2) {
                        return -1;
                    }
                    else if (start1 > start2) {
                        return 1;
                    }
                    else {
                        if (stop1 < stop2) {
                            return 1;
                        }
                        else if (stop1 > stop2) {
                            return -1;
                        }
                    }
                    return 0;
                });
                var row = createLiveRowData(dayFeedSchedules);
                row.feed = feedKey;
                returnValue[dateKey].data.push(row);
            });
        });
        return returnValue;
    };
    CalendarsQueryService.dueDateQuery = function (showDelivered) {
        var deferred = $q.defer();
        CalendarsResourceFactory.dueDateItems({ showDelivered: showDelivered }).$promise.then(function (data) {
            deferred.resolve(buildDueDateMap(data));
        });
        return deferred.promise;
    };
    CalendarsQueryService.ordQuery = function (showDelivered) {
        var deferred = $q.defer();
        CalendarsResourceFactory.ordItems({ showDelivered: showDelivered }).$promise.then(function (data) {
            deferred.resolve(buildOrdMap(data));
        });
        return deferred.promise;
    };
    CalendarsQueryService.firstLaunchQuery = function (showDelivered) {
        var deferred = $q.defer();
        CalendarsResourceFactory.firstLaunchItems({ showDelivered: showDelivered }).$promise.then(function (data) {
            deferred.resolve(buildFirstLaunchMap(data));
        });
        return deferred.promise;
    };
    //
    // Record schedule data is pulled from the ABC server, but
    // other record properties (such as Elemental status) are only
    // available from the Live Clipping server.
    //
    // This function is used to grab this extra schedule data
    // from the Live Clipping server and add necessary properties
    // to the data obtained from the ABC server, for use in the
    // Live Schedule calendar.
    //
    var augmentScheduleData = function (recordings) {
        var recordingPromises = {};
        angular.forEach(recordings, function (recording) {
            recordingPromises[recording.liveRecordId] = RecordResourceFactory
                .get({ id: recording.liveRecordId })
                .$promise;
        });
        var deferred = $q.defer();
        $q.all(recordingPromises).then(function (recordingSchedules) {
            var augmentedSchedules = recordings.map(function (recording) {
                // grab any properties we
                // need from LC server schedule
                recording.recordStatus = recordingSchedules[recording.liveRecordId].status;
                return recording;
            });
            deferred.resolve(augmentedSchedules);
        });
        return deferred.promise;
    };
    CalendarsQueryService.liveRecordingsQuery = function (showDelivered) {
        var deferred = $q.defer();
        CalendarsResourceFactory.liveRecordingsItems({ showDelivered: showDelivered }).$promise.then(function (data) {
            augmentScheduleData(data).then(function (recordings) {
                var liveMap = buildLiveMap(recordings);
                deferred.resolve(liveMap);
            });
        });
        return deferred.promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: queue-limiter-edit-controller.js
 *
 * Created by psnyder on 3/1/17.
 */
'use strict';
angular.module('prism-ui.queues').controller('QueueLimiterEditController', function ($uibModalInstance, limiterId, queueMaxActive, QueuesViewService) {
    var self = this;
    self.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };
    var filterCategoryTypeDropdown = function () {
        var allCategoryTypes = angular.copy(self.categoryTypes);
        var tempCategoryTypeLimiters = [];
        var tempPartnerCatTypeLimiters = [];
        QueuesViewService.queueLimiters.forEach(function (limiter) {
            if (limiter.categoryType && !limiter.partner) {
                tempCategoryTypeLimiters.push(limiter);
            }
            else if (limiter.categoryType && limiter.partner) {
                tempPartnerCatTypeLimiters.push(limiter);
            }
        });
        if (!self.limiterObject.partner) {
            allCategoryTypes.forEach(function (catType, index) {
                tempCategoryTypeLimiters.forEach(function (catTypeLimiter) {
                    if (catTypeLimiter.categoryType &&
                        catTypeLimiter.categoryType.name === catType.name) {
                        allCategoryTypes.splice(index, 1);
                    }
                });
            });
        }
        else {
            tempPartnerCatTypeLimiters.forEach(function (partnerLimiter) {
                if (partnerLimiter.partner.name === self.limiterObject.partner.name) {
                    allCategoryTypes.forEach(function (catType, index) {
                        if (catType.name === partnerLimiter.categoryType.name) {
                            allCategoryTypes.splice(index, 1);
                        }
                    });
                }
            });
        }
        return allCategoryTypes;
    };
    var filterPartnerDropdown = function () {
        var tempPartnersList = angular.copy(self.partnersList);
        for (var partnerIndex = tempPartnersList.length - 1; partnerIndex >= 0; partnerIndex--) {
            var hasShortForm = false;
            var hasLongForm = false;
            var hasPartnerGlobal = false;
            var partnerSpliced = false;
            for (var limiter = 0; limiter < QueuesViewService.queueLimiters.length; limiter++) {
                if (!partnerSpliced && QueuesViewService.queueLimiters[limiter].partner &&
                    tempPartnersList[partnerIndex].name === QueuesViewService.queueLimiters[limiter].partner.name) {
                    if (!QueuesViewService.queueLimiters[limiter].categoryType) {
                        hasPartnerGlobal = true;
                        tempPartnersList.splice(partnerIndex, 1);
                        partnerSpliced = true;
                    }
                    if (!hasPartnerGlobal) {
                        if (QueuesViewService.queueLimiters[limiter].categoryType.name === 'Long Form') {
                            hasLongForm = true;
                        }
                        if (QueuesViewService.queueLimiters[limiter].categoryType.name === 'Short Form') {
                            hasShortForm = true;
                        }
                        if (hasLongForm && hasShortForm) {
                            tempPartnersList.splice(partnerIndex, 1);
                            partnerSpliced = true;
                        }
                    }
                }
            }
        }
        if (self.limiterObject.categoryType) {
            QueuesViewService.queueLimiters.forEach(function (queueLimiter) {
                if (queueLimiter.categoryType && queueLimiter.partner && queueLimiter.categoryType.name === self.limiterObject.categoryType.name) {
                    for (var tempPartner = tempPartnersList.length - 1; tempPartner >= 0; tempPartner--) {
                        if (tempPartnersList[tempPartner].name === queueLimiter.partner.name) {
                            tempPartnersList.splice(tempPartner, 1);
                        }
                    }
                }
            });
        }
        return tempPartnersList;
    };
    self.filterEditDropdowns = function () {
        self.partners = filterPartnerDropdown();
        self.catTypes = filterCategoryTypeDropdown();
    };
    self.getLimiterEditData = function () {
        self.loadingIndicator.show = true;
        QueuesViewService.getLimiterEditData(limiterId).then(function (data) {
            if (data.limiter) {
                self.limiterObject = data.limiter;
                self.limiterObject.maxActive = parseInt(self.limiterObject.maxActive);
            }
            else {
                self.limiterObject = { maxActive: 1 };
            }
            self.partnersList = data.partners;
            self.categoryTypes = data.categoryTypes;
            self.maxActiveLimit = parseInt(queueMaxActive);
            self.tempQueueLimiters = QueuesViewService.queueLimiters;
            self.filterEditDropdowns();
            self.loadingIndicator.show = false;
        });
    };
    self.onMaxActiveChange = function () {
        self.limiterObject.maxActive = parseInt(self.limiterObject.maxActive);
    };
    self.maxActiveInvalid = function () {
        return !self.limiterObject.maxActive || self.limiterObject.maxActive > self.maxActiveLimit || self.limiterObject.maxActive < 1;
    };
    self.disableOkButton = function () {
        return !self.limiterObject || self.maxActiveInvalid() ||
            (!self.limiterObject.partner && !self.limiterObject.categoryType) || self.modalForm.$pristine;
    };
    self.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
    self.onOk = function () {
        if (limiterId < 0) {
            delete self.limiterObject.id;
        }
        $uibModalInstance.close(self.limiterObject);
    };
    self.getLimiterEditData();
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: queue-limiter-list-modal-controller.js
 *
 * Created by psnyder on 2/27/17.
 */
'use strict';
angular.module('prism-ui.queues').controller('QueueLimiterListController', function ($scope, $q, $uibModalInstance, uiGridConstants, QueuesViewService, queueId, ModalService, NotificationService, PermissionsService) {
    var self = this;
    self.queueMaxActive = null;
    self.selectedLimiterObject = {};
    self.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };
    self.gridColumns = [
        {
            field: 'partner.name',
            displayName: 'Partner',
            suppressRemoveSort: true,
            enableColumnResizing: true,
            sort: {
                direction: uiGridConstants.ASC,
                priority: 0
            },
            sortingAlgorithm: function (a, b) {
                if (a === undefined) {
                    a = '';
                }
                else {
                    a = a.toLowerCase();
                }
                if (b === undefined) {
                    b = '';
                }
                else {
                    b = b.toLowerCase();
                }
                return a.localeCompare(b);
            },
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        },
        {
            field: 'categoryType.name',
            displayName: 'Category Type',
            enableSorting: false,
            suppressRemoveSort: true,
            enableColumnResizing: false,
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        },
        {
            field: 'maxActive',
            displayName: 'Max Active',
            enableSorting: false,
            suppressRemoveSort: true,
            enableColumnResizing: false,
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        }
    ];
    self.gridOptions = {
        rowSelection: true,
        multiSelect: false,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableRowHeaderSelection: false,
        rowHeight: 30,
        minRowsToShow: 5,
        columnDefs: self.gridColumns,
        rowTemplate: '<div ng-dblclick="grid.appScope.queueLimiterController.rowDoubleClicked(row)" ' +
            ' ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ' +
            ' class="ui-grid-cell" ui-grid-cell></div>',
        onRegisterApi: function (gridApi) {
            self.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged($scope, self.gridRowSelectionChangedHandler);
        }
    };
    self.gridRowSelectionChangedHandler = function (row) {
        if (row.isSelected) {
            self.selectedLimiterObject = angular.copy(row.entity);
        }
        else {
            self.selectedLimiterObject = {};
        }
    };
    self.rowDoubleClicked = function (row) {
        ModalService.showQueueLimiterEditModal(row.entity.id, self.queueObject.maxActive, self.saveQueueLimiter);
    };
    self.addQueueLimiter = function () {
        ModalService.showQueueLimiterEditModal(-1, self.queueObject.maxActive, self.saveQueueLimiter);
    };
    self.saveQueueLimiter = function (limiterObj) {
        self.loadingIndicator.show = true;
        QueuesViewService.saveQueueLimiter(limiterObj).then(function (data) {
            self.selectedLimiterObject = {};
            self.setQueuesListModalData();
            self.loadingIndicator.show = false;
        });
    };
    self.setQueuesListModalData = function () {
        self.loadingIndicator.show = true;
        $q.all([
            PermissionsService.isSystemOperator().then(function (isSystemOperator) {
                self.canClearQueue = isSystemOperator;
            }),
            QueuesViewService.getQueuesListData(queueId).then(function (data) {
                self.gridOptions.data = data.queueLimiters;
                self.queueObject = data.queueData;
                self.originalQueueMaxActive = self.queueObject.maxActive;
                QueuesViewService.queueLimiters = data.queueLimiters;
            })
        ]).then(function () {
            self.loadingIndicator.show = false;
        });
    };
    self.disableLimiterDeleteButton = function () {
        return angular.equals(self.selectedLimiterObject, {});
    };
    self.deleteQueueLimiter = function () {
        self.loadingIndicator.show = true;
        QueuesViewService.deleteQueueLimiter(self.selectedLimiterObject).then(function (data) {
            self.selectedLimiterObject = {};
            self.setQueuesListModalData();
            self.loadingIndicator.show = false;
        });
    };
    self.deleteMessage = 'Are you sure you want to delete ';
    self.openConfirmModal = function (messageText, title, handler) {
        messageText += self.selectedLimiterObject.name + '?';
        title += ' ' + self.selectedLimiterObject.name + '?';
        ModalService.showMessageModal({
            messageText: messageText,
            pullCancelLeft: true,
            title: title,
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, handler);
    };
    self.disableListComponents = function () {
        return self.modalForm.$dirty;
    };
    self.disableOkButton = function () {
        return self.modalForm.$pristine || self.queueObject.maxActive > 999;
    };
    self.onOk = function () {
        $uibModalInstance.close(self.queueObject);
        QueuesViewService.selectedQueueId = null;
        QueuesViewService.queueLimiters = [];
    };
    self.cancel = function () {
        self.queueObject.maxActive = self.originalQueueMaxActive;
        self.modalForm.$setPristine();
    };
    self.clearQueue = function () {
        ModalService.showMessageModal({
            messageText: 'Are you sure you want to clear this queue?',
            pullCancelLeft: true,
            title: 'Clear Queue',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, function () {
            QueuesViewService.clearQueue(queueId).then(function (clearedQueue) {
                NotificationService.createSuccessNotification("Successfully cleared queue");
            }).catch(function (error) {
                NotificationService.createFailureNotification("Could not clear queue");
            });
        });
    };
    self.xClicked = function () {
        $uibModalInstance.dismiss('cancel');
    };
    self.setQueuesListModalData();
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.report').controller('CreateReportModalController', function (_, $uibModalInstance, ReportViewService, UtilsService, amDateFormatFilter, report, showPartners) {
    var self = this;
    var defaultReportName = function () {
        var dateString = amDateFormatFilter(new Date(), 'MM-DD-YYYY hhmmA');
        var reportName = '';
        switch (self.selectedReport.generatorName) {
            case ReportViewService.PARTNER_DELIVERY_REPORT_CLASS:
                reportName = self.reportMode + ' Delivery Report';
                break;
            case ReportViewService.PARTNER_PLANNER_DELIVERY_REPORT_CLASS:
                reportName = 'Partner Planner Delivery Report';
                break;
            case ReportViewService.SLA_DELIVERY_REPORT_CLASS:
                reportName = 'SLA Delivery Metrics';
                break;
            case ReportViewService.DISTRIBUTION_REPORT_CLASS:
                reportName = self.reportMode + ' Distribution Report';
                break;
            case ReportViewService.PARTNER_PROFILES_REPORT_CLASS:
                reportName = 'Partner Profiles Report';
                break;
            case ReportViewService.HIERARCHICAL_NETWORK_REPORT_CLASS:
                reportName = 'Networks Hierarchical Metadata Report';
                break;
            case ReportViewService.HIERARCHICAL_SHOW_REPORT_CLASS:
                reportName = 'Series Movie Hierarchical Metadata Report';
                break;
            case ReportViewService.HIERARCHICAL_SEASON_VOLUME_REPORT_CLASS:
                reportName = 'Season Volume Hierarchical Metadata Report';
                break;
            case ReportViewService.COLLABORATOR_REPORT_CLASS:
                reportName = 'Collaborators Report';
                break;
            case ReportViewService.PACKAGE_BATCH_MODIFY_REPORT_CLASS:
                reportName = 'Package Batch Modify Metadata Report';
                break;
            case ReportViewService.PACKAGE_REPORT_CLASS:
                reportName = 'Package Report';
                break;
            case ReportViewService.PACKAGE_ALL_METADATA_REPORT_CLASS:
                reportName = 'Package Metadata Report';
                break;
            case ReportViewService.PACKAGE_MEDIA_REPORT_CLASS:
                reportName = 'Media Report';
                break;
            case ReportViewService.AUDIT_LEVEL_REPORT_CLASS:
                reportName = 'Partner Delivery Report with Distribution Metadata';
        }
        return reportName + ' ' + dateString;
    };
    self.selectedReport = report;
    self.showPartners = showPartners;
    self.reportMode = 'Basic';
    self.includeMasterPkgs = true;
    self.reportName = defaultReportName();
    self.handleModeChange = function () {
        self.reportName = defaultReportName();
    };
    self.showMode = function () {
        return self.selectedReport.generatorName === ReportViewService.PARTNER_DELIVERY_REPORT_CLASS ||
            self.selectedReport.generatorName === ReportViewService.DISTRIBUTION_REPORT_CLASS;
    };
    self.showInclude = function () {
        return self.selectedReport.generatorName === ReportViewService.PARTNER_DELIVERY_REPORT_CLASS ||
            self.selectedReport.generatorName === ReportViewService.SLA_DELIVERY_REPORT_CLASS ||
            self.selectedReport.generatorName === ReportViewService.COLLABORATOR_REPORT_CLASS ||
            self.selectedReport.generatorName === ReportViewService.PACKAGE_REPORT_CLASS ||
            self.selectedReport.generatorName === ReportViewService.PACKAGE_ALL_METADATA_REPORT_CLASS ||
            self.selectedReport.generatorName === ReportViewService.CLIP_PACKAGE_ALL_METADATA_REPORT ||
            self.selectedReport.generatorName === ReportViewService.PACKAGE_MEDIA_REPORT_CLASS ||
            self.selectedReport.generatorName === ReportViewService.AUDIT_LEVEL_REPORT_CLASS;
    };
    self.showIncludeArchived = function () {
        return self.selectedReport.generatorName === ReportViewService.COLLABORATOR_REPORT_CLASS;
    };
    self.updatePartnerList = function () {
        ReportViewService.queryForPartners(self.includeHiddenPartners).then(function (partners) {
            self.partners = partners;
        });
    };
    self.updatePartnerList();
    var isReportNameValid = function () {
        return UtilsService.isFileNameValid(self.reportName);
    };
    self.isReportNameValid = _.memoize(isReportNameValid, function () { return self.reportName; });
    self.reportNameChanged = function () {
        self.isReportNameValid.cache.clear();
    };
    self.onOk = function () {
        var reportOptions = {
            name: self.reportName,
            mode: (self.showMode()) ? self.reportMode : null,
            includeMasterPkgs: (self.selectedReport.showIncludePackagesOptions) ? self.includeMasterPkgs : null,
            includeClipToolPkgs: (self.selectedReport.showIncludePackagesOptions) ? self.includeClipToolPkgs : null,
            includeArchiveContent: (self.showIncludeArchived()) ? self.includeArchived : null
        };
        if (self.showPartners) {
            reportOptions.selectedPartners = (_.isArray(self.selectedPartners)) ?
                self.selectedPartners : _.concat(self.selectedPartners);
        }
        $uibModalInstance.close(reportOptions);
    };
    self.cancel = function () {
        $uibModalInstance.dismiss();
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.workflows').controller('WorkflowContextDetailViewController', function ($document, $routeParams, $window, WorkflowExecutionResourceFactory, NotificationService, ModalService, _) {
    var self = this;
    self.gridColumns = [
        {
            field: 'name',
            displayName: 'Name',
            enableSorting: false,
            enableColumnResizing: false,
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        },
        {
            field: 'value',
            displayName: 'Value',
            enableSorting: false,
            enableColumnResizing: false,
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        }
    ];
    self.gridOptions = {
        rowSelection: false,
        enableSorting: false,
        enableColumnMenus: false,
        enableFullRowSelection: false,
        enableRowHeaderSelection: false,
        rowHeight: 30,
        minRowsToShow: 5,
        columnDefs: self.gridColumns
    };
    self.getContextGridData = function () {
        self.gridOptions.data = WorkflowExecutionResourceFactory.getExecutionContextData({ id: $routeParams.id });
    };
    self.getContextGridData();
    var getPreparedJsonData = function () {
        var jsonData = _.cloneDeep(self.gridOptions.data);
        _.unset(jsonData, '$resolved');
        _.unset(jsonData, '$promise');
        _.forEach(jsonData, function (jsonNode) {
            try {
                _.unset(jsonNode, '$$hashKey');
                jsonNode.value = JSON.parse(jsonNode.value);
            }
            catch (exception) {
                console.warn(exception);
            }
        });
        return jsonData;
    };
    self.onCopyContextDataClicked = function () {
        var preparedJsonData = getPreparedJsonData(self.gridOptions.data);
        if (!_.isNil($window.navigator.clipboard)) {
            console.warn('Navigator available. Copying to clipboard using Clipboard API');
            $window.navigator.clipboard.writeText(JSON.stringify(preparedJsonData)).then(function () {
                NotificationService.createSuccessNotification('Copied Context JSON Data to clipboard successfully', 2000);
            }, function () {
                NotificationService.createFailureNotification('Unable to copy Context JSON Data to clipboard', '', true, -1);
            });
        }
        else {
            console.warn('Navigator not available. Copying to clipboard using document.execCommand');
            var input = $document.createElement('input');
            $document.body.appendChild(input);
            input.value = JSON.stringify(preparedJsonData);
            input.focus();
            input.select();
            var result = $document.execCommand('copy');
            input.remove();
            if (result) {
                NotificationService.createSuccessNotification('Copied Context JSON Data to clipboard successfully', 2000);
            }
            else {
                NotificationService.createFailureNotification('Unable to copy Context JSON Data to clipboard', '', true, -1);
            }
        }
    };
    self.showContextDataClicked = function () {
        ModalService.showJsonViewerModal(getPreparedJsonData(self.gridOptions.data));
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.workflows').directive('contextDetailView', function () {
    return {
        restrict: 'E',
        controller: 'WorkflowContextDetailViewController as contextView',
        templateUrl: 'dashboard/workflows/stepView/contextDetailView/context-detail-view-template.html',
        scope: true,
        bindToController: {
            selectedWorkflowStep: '=',
            closeHandler: '&'
        }
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.collaborators').controller('CreateCollaboratorModalController', function ($uibModalInstance, _, UtilsService) {
    var self = this;
    self.newCollab = {};
    self.onSave = function () {
        $uibModalInstance.close(self.newCollab);
    };
    self.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
    self.disableOKButton = function () {
        return self.createCollabForm.$pristine || !self.newCollab.displayName || !self.newCollab.sortName;
    };
    self.handleDisplayNameChange = function () {
        _.set(self.newCollab, 'sortName', _.cloneDeep(UtilsService.transformDisplayNameToSortName(_.get(self.newCollab, 'displayName'))));
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.package').controller('LiveClipToolbarController', function ($scope, $location, PackageUtilService, ModalService, PermissionsService, $q, PackageActionService, PackageResourceFactory, PackageLiveClipViewService) {
    var PACKAGE_VIDEO_CLIPS_VIEW_STATE = 'PACKAGE_VIDEO_CLIPS_VIEW_STATE';
    var PACKAGE_AD_HOC_ADD_PARTNERS_VIEW_STATE = 'PACKAGE_AD_HOC_ADD_PARTNERS_VIEW_STATE';
    var CLIP_ACTION_RESET_VIEW_STATE = 'CLIP_ACTION_RESET_VIEW_STATE';
    var CLIP_ACTION_DELIVER_VIEW_STATE = 'CLIP_ACTION_DELIVER_VIEW_STATE';
    var CLIP_ACTION_RE_EXTRACT_VIEW_STATE = 'CLIP_ACTION_RE_EXTRACT_VIEW_STATE';
    var CLIP_ACTION_VALIDATE_VIEW_STATE = 'CLIP_ACTION_VALIDATE_VIEW_STATE';
    var CLIP_ACTION_RETRIEVE_MASTER_MEDIA_VIEW_STATE = 'CLIP_ACTION_RETRIEVE_MASTER_MEDIA_VIEW_STATE';
    var CLIP_ACTION_HIDE_VIEW_STATE = 'CLIP_ACTION_HIDE_VIEW_STATE';
    var CLIP_ACTION_BATCH_MODIFY_METADATA_VIEW_STATE = 'CLIP_ACTION_BATCH_MODIFY_METADATA_VIEW_STATE';
    var CLIP_ACTION_EXPORT_METADATA_VIEW_STATE = 'CLIP_ACTION_EXPORT_METADATA_VIEW_STATE';
    var CLIP_ACTION_GENERATE_DELIVERY_REPORT_VIEW_STATE = 'CLIP_ACTION_GENERATE_DELIVERY_REPORT_VIEW_STATE';
    var self = this;
    self.liveToolbarPerms = {
        clipResetRead: false,
        clipResetWrite: false,
        clipDeliverRead: false,
        clipDeliverWrite: false,
        clipExtractRead: false,
        clipExtractWrite: false,
        clipValidateRead: false,
        clipValidateWrite: false,
        clipMasterMediaRead: false,
        clipMasterMediaWrite: false,
        clipHideRead: false,
        clipHideWrite: false,
        clipBatchModifyRead: false,
        clipBatchModifyWrite: false,
        clipExportMetaRead: false,
        clipExportMetaWrite: false,
        clipDeliveryReportRead: false,
        clipDeliveryReportWrite: false
    };
    self.selectedPackages = [];
    self.viewModel = PackageLiveClipViewService.viewModel;
    self.liveClipActions = PackageActionService.liveClipActions;
    self.showActionsLoading = PackageActionService.actionsLoading;
    self.retrieveClipPermissions = function () {
        if (self.selectedPackages.length > 0) {
            PackageActionService.actionsLoading = true;
            PackageActionService.checkClipPackagesToEnableActions().then(function () {
                self.actionsLoading = PackageActionService.actionsLoading = false;
            });
        }
    };
    var showLoadingIndicator = function () {
        $scope.$emit('server-busy', { working: true });
    };
    var hideLoadingIndicator = function () {
        $scope.$emit('server-busy', { working: false });
    };
    self.handleSelectedAction = function () {
        PackageActionService.handleSelectedAction(self.selectedAction, showLoadingIndicator, hideLoadingIndicator);
        self.selectedAction = null;
    };
    self.includeArchived = false;
    self.unhideInvalid = self.hideInvalid = true;
    var enableHideUnhide = function () {
        var archivedFound = false;
        var unarchivedFound = false;
        if (self.selectedPackages.length === 0 || !self.liveToolbarPerms.clipHideWrite) {
            self.hideInvalid = self.unhideInvalid = true;
            return;
        }
        for (var i = 0; i < self.selectedPackages.length; i++) {
            var pkg = self.selectedPackages[i];
            if (pkg.hidden) {
                archivedFound = true;
            }
            else {
                unarchivedFound = true;
            }
            if (unarchivedFound && archivedFound) {
                self.hideInvalid = self.unhideInvalid = true;
                return;
            }
        }
        if (unarchivedFound) {
            self.unhideInvalid = true;
            self.hideInvalid = false;
        }
        else {
            self.unhideInvalid = false;
            self.hideInvalid = true;
        }
    };
    self.updateClipList = function () {
        PackageLiveClipViewService.includeHidden = self.includeArchived;
        PackageLiveClipViewService.refreshClips();
    };
    self.disableActionDropdown = function () {
        if ($location.search().livePackageId) {
            return (PackageLiveClipViewService.collaboratorsForm && PackageLiveClipViewService.collaboratorsForm.$dirty) ||
                (PackageLiveClipViewService.metadataForm && PackageLiveClipViewService.metadataForm.$dirty) ||
                (PackageLiveClipViewService.distributionForm && PackageLiveClipViewService.distributionForm.$dirty) ||
                (PackageLiveClipViewService.advancedForm && PackageLiveClipViewService.advancedForm.$dirty);
        }
        else {
            return false;
        }
    };
    var enableLiveToolbarItems = function () {
        enableHideUnhide();
    };
    var getPermissions = function () {
        var clipResetReadPromise = PermissionsService.canRead(CLIP_ACTION_RESET_VIEW_STATE);
        var clipResetWritePromise = PermissionsService.canWrite(CLIP_ACTION_RESET_VIEW_STATE);
        var clipDeliverReadPromise = PermissionsService.canRead(CLIP_ACTION_DELIVER_VIEW_STATE);
        var clipDeliverWritePromise = PermissionsService.canWrite(CLIP_ACTION_DELIVER_VIEW_STATE);
        var clipReExtractReadPromise = PermissionsService.canRead(CLIP_ACTION_RE_EXTRACT_VIEW_STATE);
        var clipReExtractWritePromise = PermissionsService.canWrite(CLIP_ACTION_RE_EXTRACT_VIEW_STATE);
        var clipValidateReadPromise = PermissionsService.canRead(CLIP_ACTION_VALIDATE_VIEW_STATE);
        var clipValidateWritePromise = PermissionsService.canWrite(CLIP_ACTION_VALIDATE_VIEW_STATE);
        var clipRetrieveMasterMediaReadPromise = PermissionsService.canRead(CLIP_ACTION_RETRIEVE_MASTER_MEDIA_VIEW_STATE);
        var clipRetrieveMasterMediaWritePromise = PermissionsService.canWrite(CLIP_ACTION_RETRIEVE_MASTER_MEDIA_VIEW_STATE);
        var clipHideReadPromise = PermissionsService.canRead(CLIP_ACTION_HIDE_VIEW_STATE);
        var clipHideWritePromise = PermissionsService.canWrite(CLIP_ACTION_HIDE_VIEW_STATE);
        var clipBatchModifyClipsReadPromise = PermissionsService.canRead(CLIP_ACTION_BATCH_MODIFY_METADATA_VIEW_STATE);
        var clipBatchModifyClipsWritePromise = PermissionsService.canWrite(CLIP_ACTION_BATCH_MODIFY_METADATA_VIEW_STATE);
        var clipExportMetadataReadPromise = PermissionsService.canRead(CLIP_ACTION_EXPORT_METADATA_VIEW_STATE);
        var clipExportMetadataWritePromise = PermissionsService.canWrite(CLIP_ACTION_EXPORT_METADATA_VIEW_STATE);
        var clipDeliveryReportReadPromise = PermissionsService.canRead(CLIP_ACTION_GENERATE_DELIVERY_REPORT_VIEW_STATE);
        var clipDeliveryReportWritePromise = PermissionsService.canWrite(CLIP_ACTION_GENERATE_DELIVERY_REPORT_VIEW_STATE);
        $q.all({
            clipResetRead: clipResetReadPromise,
            clipResetWrite: clipResetWritePromise,
            clipDeliverRead: clipDeliverReadPromise,
            clipDeliverWrite: clipDeliverWritePromise,
            clipExtractRead: clipReExtractReadPromise,
            clipExtractWrite: clipReExtractWritePromise,
            clipValidateRead: clipValidateReadPromise,
            clipValidateWrite: clipValidateWritePromise,
            clipMasterMediaRead: clipRetrieveMasterMediaReadPromise,
            clipMasterMediaWrite: clipRetrieveMasterMediaWritePromise,
            clipHideRead: clipHideReadPromise,
            clipHideWrite: clipHideWritePromise,
            clipBatchModifyRead: clipBatchModifyClipsReadPromise,
            clipBatchModifyWrite: clipBatchModifyClipsWritePromise,
            clipExportMetaRead: clipExportMetadataReadPromise,
            clipExportMetaWrite: clipExportMetadataWritePromise,
            clipDeliveryReportRead: clipDeliveryReportReadPromise,
            clipDeliveryReportWrite: clipDeliveryReportWritePromise
        }).then(function (perms) {
            self.liveToolbarPerms.clipResetRead = perms.clipResetRead;
            self.liveToolbarPerms.clipResetWrite = perms.clipResetWrite;
            self.liveToolbarPerms.clipDeliverRead = perms.clipDeliverRead;
            self.liveToolbarPerms.clipDeliverWrite = perms.clipDeliverWrite;
            self.liveToolbarPerms.clipExtractRead = perms.clipExtractRead;
            self.liveToolbarPerms.clipExtractWrite = perms.clipExtractWrite;
            self.liveToolbarPerms.clipValidateRead = perms.clipValidateRead;
            self.liveToolbarPerms.clipValidateWrite = perms.clipValidateWrite;
            self.liveToolbarPerms.clipMasterMediaRead = perms.clipMasterMediaRead;
            self.liveToolbarPerms.clipMasterMediaWrite = perms.clipMasterMediaWrite;
            self.liveToolbarPerms.clipHideRead = perms.clipHideRead;
            self.liveToolbarPerms.clipHideWrite = perms.clipHideWrite;
            self.liveToolbarPerms.clipBatchModifyRead = perms.clipBatchModifyRead;
            self.liveToolbarPerms.clipBatchModifyWrite = perms.clipBatchModifyWrite;
            self.liveToolbarPerms.clipExportMetaRead = perms.clipExportMetaRead;
            self.liveToolbarPerms.clipExportMetaWrite = perms.clipExportMetaWrite;
            self.liveToolbarPerms.clipDeliveryReportRead = perms.clipDeliveryReportRead;
            self.liveToolbarPerms.clipDeliveryReportWrite = perms.clipDeliveryReportWrite;
            self.selectedPackages = [];
            enableLiveToolbarItems();
        });
    };
    self.hideMessage = 'Are you sure you want to hide ';
    self.unhideMessage = 'Are you sure you want to unhide ';
    self.openConfirmModal = function (messageText, title, handler) {
        if (self.selectedPackages.length === 1) {
            messageText += self.selectedPackages[0].name + '?';
            title += self.selectedPackages[0].name + '?';
        }
        else {
            messageText += 'these items?';
            title += 'items?';
        }
        ModalService.showMessageModal({
            messageText: messageText,
            pullCancelLeft: true,
            title: title,
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, handler);
    };
    self.toggleArchiveFlag = function () {
        self.unhideInvalid = self.hideInvalid = true;
        $scope.$emit('server-busy', { working: true });
        var promises = [];
        angular.forEach(self.selectedPackages, function (packageObj) {
            var pkg = PackageResourceFactory.toggleArchive({ id: packageObj.id }).$promise;
            promises.push(pkg);
        });
        $q.all(promises).then(function (pkgs) {
            PackageLiveClipViewService.refreshClips();
            $scope.$emit('server-busy', { working: false });
        });
    };
    self.prevPageDisabled = function () {
        return (self.pagingOptions.pageData.length) ? self.pagingOptions.currentPage === 1 && self.pagingOptions.currentPageItemIndex === 0 : true;
    };
    self.prevPageClickHandler = function () {
        if (!self.prevPageDisabled() && self.prevHandler) {
            self.prevHandler();
        }
    };
    self.nextPageDisabled = function () {
        return (self.pagingOptions.pageData.length) ? self.pagingOptions.currentPage === self.pagingOptions.totalPages &&
            self.pagingOptions.currentPageItemIndex === self.pagingOptions.pageSize : true;
    };
    self.nextPageClickHandler = function () {
        if (!self.nextPageDisabled() && self.nextHandler) {
            self.nextHandler();
        }
    };
    self.closeClickHandler = function () {
        if (PackageUtilService.postCloseUpdate) {
            PackageUtilService.postCloseUpdate();
        }
        if (self.closeHandler) {
            self.closeHandler();
        }
    };
    $scope.$watch(function () {
        return PackageUtilService.editorForm;
    }, function () {
        self.editorForm = PackageUtilService.editorForm;
    });
    $scope.$watch(function () {
        return self.includeArchived;
    }, function () {
        PackageLiveClipViewService.includeHidden = self.includeArchived;
    });
    $scope.$watchCollection(function () {
        return PackageActionService.selectedPackages;
    }, function () {
        self.selectedPackages = PackageActionService.selectedPackages;
        enableLiveToolbarItems();
    });
    $scope.$watch(function () {
        return $location.search();
    }, function () {
        if ($location.search().livePackageId) {
            self.liveClipActions = PackageActionService.liveClipEditorActions;
        }
        else {
            self.liveClipActions = PackageActionService.liveClipActions;
        }
    }, true);
    $scope.$watch(function () {
        return PackageActionService.actionsLoading;
    }, function () {
        self.showActionsLoading = PackageActionService.actionsLoading;
    });
    getPermissions();
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.package').directive('liveClipToolbar', function () {
    return {
        restrict: 'E',
        controller: 'LiveClipToolbarController',
        controllerAs: 'liveClipToolbarCtrlr',
        templateUrl: 'package/editor/components/toolbar/liveclip-toolbar-template.html',
        scope: true,
        bindToController: {
            contextData: '=',
            newHandler: '&',
            closeHandler: '&',
            nextHandler: '&',
            prevHandler: '&',
            pagingOptions: '='
        }
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 4/7/15.
 */
'use strict';
angular.module('prism-ui.package').controller('PackageEditorToolbarController', function (_, $scope, PackageUtilService, ModalService, PermissionsService, $q, PackageActionService, PackageMediaService) {
    var META_TAB_VIEW_STATE = 'PACKAGE_METADATA_VIEW_STATE';
    var COLLABORATORS_TAB_VIEW_STATE = 'PACKAGE_COLLABORATORS_VIEW_STATE';
    var MEDIA_TAB_VIEW_STATE = 'PACKAGE_MEDIA_VIEW_STATE';
    var TIMINGS_TAB_VIEW_STATE = 'PACKAGE_TIMINGS_VIEW_STATE';
    var BATCH_CLONE_STATE = 'PACKAGE_BATCH_CLONE_VIEW_STATE';
    var CLONE_STATE = 'PACKAGE_CLONE_VIEW_STATE';
    var PACKAGE_AD_HOC_ADD_PARTNERS_VIEW_STATE = 'PACKAGE_AD_HOC_ADD_PARTNERS_VIEW_STATE';
    var self = this;
    var saveCalled = false;
    self.toolbarPerms = {
        cloneRead: false,
        cloneWrite: false,
        collaboratorsWrite: false,
        mediaWrite: false,
        metaWrite: false,
        timingsWrite: false
    };
    var getPermissions = function () {
        var cloneReadPromise = PermissionsService.canRead(CLONE_STATE);
        var batchCloneReadPromise = PermissionsService.canRead(BATCH_CLONE_STATE);
        var cloneWritePromise = PermissionsService.canWrite(CLONE_STATE);
        var batchCloneWritePromise = PermissionsService.canWrite(BATCH_CLONE_STATE);
        var collaboratorsWritePromise = PermissionsService.canWrite(COLLABORATORS_TAB_VIEW_STATE);
        var mediaWritePromise = PermissionsService.canWrite(MEDIA_TAB_VIEW_STATE);
        var metaWritePromise = PermissionsService.canWrite(META_TAB_VIEW_STATE);
        var timingsWritePromise = PermissionsService.canWrite(TIMINGS_TAB_VIEW_STATE);
        var distroAdHocAddPartnersPromise = PermissionsService.canWrite(PACKAGE_AD_HOC_ADD_PARTNERS_VIEW_STATE);
        $q.all({ cloneRead: cloneReadPromise,
            cloneWrite: cloneWritePromise,
            batchCloneRead: batchCloneReadPromise,
            batchCloneWrite: batchCloneWritePromise,
            collaboratorsWrite: collaboratorsWritePromise,
            mediaWrite: mediaWritePromise,
            metaWrite: metaWritePromise,
            timingsWrite: timingsWritePromise,
            adHocWrite: distroAdHocAddPartnersPromise }).then(function (perms) {
            self.toolbarPerms.cloneRead = perms.cloneRead || perms.batchCloneRead;
            self.toolbarPerms.cloneWrite = perms.cloneWrite || perms.batchCloneWrite;
            self.toolbarPerms.collaboratorsWrite = perms.collaboratorsWrite;
            self.toolbarPerms.mediaWrite = perms.mediaWrite;
            self.toolbarPerms.metaWrite = perms.metaWrite;
            self.toolbarPerms.timingsWrite = perms.timingsWrite;
            self.toolbarPerms.adHocWrite = perms.adHocWrite;
        });
    };
    self.editorForm = PackageUtilService.editorForm;
    self.actions = PackageActionService.editorActions;
    var showLoadingIndicator = function () {
        $scope.$emit('server-busy', { working: true });
    };
    var hideLoadingIndicator = function () {
        $scope.$emit('server-busy', { working: false });
    };
    self.handleSelectedAction = function () {
        PackageActionService.handleSelectedAction(self.selectedAction, showLoadingIndicator, hideLoadingIndicator);
        self.selectedAction = null;
    };
    self.saveDisabled = function () {
        if (self.editorForm.$pristine) {
            return true;
        }
        if (self.editorForm.$name === '$ctrl.packageMediaEditorForm') {
            return self.editorForm.$invalid || saveCalled || PackageMediaService.hasSaveConflict();
        }
        else {
            return (self.editorForm.$name !== '$ctrl.packageMetadataEditorForm' && self.editorForm.$invalid) || saveCalled;
        }
    };
    self.saveClickHandler = function () {
        if (!self.saveDisabled() && self.saveHandler) {
            saveCalled = true;
            self.saveHandler().then(function () {
                saveCalled = false;
            });
        }
    };
    self.newClickHandler = function () {
        if (self.statusAllowsEdit() && !self.contextData.locked && !self.contextData.isDelivering) {
            self.newHandler();
        }
    };
    self.deleteClickHandler = function () {
        if (self.statusAllowsEdit() && !self.contextData.locked && !self.contextData.isDelivering) {
            self.deleteHandler();
        }
    };
    self.addDisabledClickHandler = function () {
        self.addDisabledHandler();
    };
    self.revertDisabled = function () {
        return self.editorForm.$pristine;
    };
    self.revertClickHandler = function () {
        if (!self.revertDisabled() && self.revertHandler) {
            self.revertHandler();
        }
    };
    self.closeClickHandler = function () {
        if (PackageUtilService.postCloseUpdate) {
            PackageUtilService.postCloseUpdate();
        }
        if (self.closeHandler) {
            self.closeHandler();
        }
    };
    self.prevPageDisabled = function () {
        return (self.pagingOptions.pageData.length) ? self.pagingOptions.currentPage === 1 && self.pagingOptions.currentPageItemIndex === 0 : true;
    };
    self.prevPageClickHandler = function () {
        if (!self.prevPageDisabled() && self.prevHandler) {
            self.prevHandler();
        }
    };
    self.nextPageDisabled = function () {
        return (self.pagingOptions.pageData.length) ? self.pagingOptions.currentPage === self.pagingOptions.totalPages &&
            self.pagingOptions.currentPageItemIndex === self.pagingOptions.pageSize : true;
    };
    self.nextPageClickHandler = function () {
        if (!self.nextPageDisabled() && self.nextHandler) {
            self.nextHandler();
        }
    };
    self.uploadClickHandler = function () {
        if (self.statusAllowsEdit() && !self.contextData.locked &&
            !self.contextData.isDelivering && self.uploadHandler) {
            self.uploadHandler();
        }
    };
    self.confirmClone = function () {
        ModalService.showMessageModal({
            messageText: 'Are you sure you want to clone ' + self.contextData.name + '?',
            pullCancelLeft: true,
            title: 'Clone ' + self.contextData.name + '?',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, self.packageCloneClickHandler);
    };
    self.tabAddDisabledInvalid = function () {
        return PackageUtilService.tabAddDisabledInvalid();
    };
    self.tabDeleteInvalid = function () {
        return PackageUtilService.tabDeleteInvalid();
    };
    self.packageCloneClickHandler = function () {
        if (self.cloneHandler) {
            self.cloneHandler();
        }
    };
    self.statusAllowsEdit = function () {
        return PackageUtilService.statusAllowsEdit(self.contextData.status);
    };
    self.canChangeAutoDelivery = function () {
        return self.contextData && self.contextData.content && self.contextData.content.type !== 'Ad/PreRoll' &&
            !self.contextData.locked &&
            PackageUtilService.statusAllowsAutoDeliveryCheckbox(self.contextData.status);
    };
    self.addAdHocSubscription = function () {
        PackageUtilService.tabAdHocPartnerFunction();
    };
    self.showHoldForComponentsCB = function () {
        return _.invoke(PackageUtilService, 'showHoldForComponentsCB') || false;
    };
    self.adHocButtonVisible = function () {
        return !!(self.toolbarPerms.adHocWrite &&
            self.statusAllowsEdit() &&
            self.contextData.category &&
            self.contextData.content.type !== 'Ad/PreRoll' &&
            (self.contextData.content.type === 'Movie/Special' || self.contextData.season || self.contextData.volume));
    };
    self.actionDropdownDisabled = function () {
        return !self.saveDisabled() || (self.contextData && self.contextData.locked);
    };
    self.wasMainVideoUploaded = function () {
        return PackageMediaService.isAnUploadPath();
    };
    $scope.$watch(function () {
        return PackageUtilService.editorForm;
    }, function () {
        self.editorForm = PackageUtilService.editorForm;
    });
    getPermissions();
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 4/7/15.
 */
'use strict';
angular.module('prism-ui.package').directive('editorToolbar', function () {
    return {
        restrict: 'E',
        controller: 'PackageEditorToolbarController',
        controllerAs: 'pkgEditorToolbarCtrlr',
        templateUrl: 'package/editor/components/toolbar/packageeditor-toolbar-template.html',
        scope: true,
        bindToController: {
            contextData: '=',
            newHandler: '&',
            deleteHandler: '&',
            addDisabledHandler: '&',
            cloneHandler: '&',
            saveHandler: '&',
            revertHandler: '&',
            closeHandler: '&',
            nextHandler: '&',
            prevHandler: '&',
            uploadHandler: '&',
            pagingOptions: '='
        }
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 5/28/15.
 */
'use strict';
angular.module('prism-ui.package').service('PackageUtilService', function (_, DebugService, DynamicPropertiesService, PackageResourceFactory, RequestService) {
    var _this = this;
    var self = this;
    self.validateAssetSelection = null;
    self.tabNewFunction = null;
    self.tabDeleteFunction = null;
    self.tabDeleteInvalid = null;
    self.tabAddDisabledFunction = null;
    self.tabAddDisabledInvalid = null;
    self.tabSaveFunction = null;
    self.tabRevertFunction = null;
    self.editorForm = null;
    self.postPackageSaveFunction = null;
    self.postCloseUpdate = null;
    self.setPristinePostSave = true;
    self.tabAdHocPartnerFunction = null;
    self.showClipScheduler = null;
    self.subTabRevertFunctions = {};
    self.subTabSaveFunctions = {};
    self.tabLoadDataFunction = null;
    self.tabUploadFunction = null;
    // Key value pair of field name and type
    var _errorsAndWarnings = {};
    var _contentCategories = {};
    self.parseNameFromPath = function (path) {
        return (path) ? path.split('/').pop() : '';
    };
    self.statusAllowsEdit = function (status) {
        //
        // TODO
        //
        // This should look at the package states that allow
        // modification, not the ones that don't.
        //
        // If the package status is empty, null, '42', etc. then
        // we probably don't want the package to be modified, yet
        // this method will allow it.
        //
        return (status !== 'CREATING_CLIP' &&
            status !== 'DELIVERING' &&
            status !== 'PENDING_APPROVAL' &&
            status !== 'PENDING_DELIVERY' &&
            status !== 'PENDING_RESTORE' &&
            status !== 'RESTORING' &&
            status !== 'TRANSCODING');
    };
    self.statusAllowsAutoDeliveryCheckbox = function (status) {
        return status === 'DRAFT' || status === 'REJECTED' || status === 'READY_FOR_DELIVERY';
    };
    self.statusAllowsReset = function (status) {
        return status !== 'DRAFT' && status !== 'READY_FOR_DELIVERY' && status !== 'STALLED';
    };
    self.statusAllowsDelivery = function (status) {
        return status === 'READY_FOR_DELIVERY' || status === 'DELIVERED' || status === 'STALLED';
    };
    self.packageHasNoErrors = function (pkg) {
        return parseInt(pkg.metadataErrorCount) === 0 && parseInt(pkg.mediaErrorCount) === 0;
    };
    self.packageCanBeDelivered = function (pkg) {
        return self.statusAllowsDelivery(pkg.status) && self.packageHasNoErrors(pkg);
    };
    self.errorsAndWarnings = function (newErrorsAndWarnings) {
        if (arguments.length) {
            _errorsAndWarnings = newErrorsAndWarnings;
            return _errorsAndWarnings;
        }
        return _errorsAndWarnings;
    };
    self.contentCategories = function (contentCategories) {
        if (arguments.length) {
            _contentCategories = contentCategories;
            return _contentCategories;
        }
        return _contentCategories;
    };
    var populateMap = function (result) {
        var errorsAndWarnings = {};
        var errors = result.errors;
        var warnings = result.warnings;
        angular.forEach(errors, function (error) {
            errorsAndWarnings[error.member] = { type: 'error', message: error.description };
        });
        angular.forEach(warnings, function (warning) {
            errorsAndWarnings[warning.member] = { type: 'warning', message: warning.description };
        });
        return errorsAndWarnings;
    };
    self.createErrorsAndWarningsMap = function (validationResult) {
        var errorsAndWarnings = {};
        angular.forEach(validationResult, function (result) {
            var key = result.source;
            errorsAndWarnings[key] = populateMap(result);
        });
        self.errorsAndWarnings(errorsAndWarnings);
    };
    var packageUpdateIntervalId = null;
    var packageUpdatePromise = null;
    self.cancelPollingInterval = function () {
        DebugService.debug("PackageUtilService: status refresh cancelled");
        RequestService.cancelRequestInterval(packageUpdateIntervalId);
        packageUpdateIntervalId = null;
    };
    var pollingIntervalCallback = function () {
        if (DebugService.trace()) {
            if (!_this.lastStatusUpdate) {
                _this.lastStatusUpdate = new Date();
            }
            else {
                var now = new Date();
                var duration = now - _this.lastStatusUpdate;
                DebugService.trace("PackageUtilService: last update occurred " + duration + "ms ago");
                _this.lastStatusUpdate = now;
            }
        }
        if (!packageUpdatePromise) {
            packageUpdatePromise = self.pollForPackageUpdates().then(function () {
                packageUpdatePromise = null;
                DebugService.debug("PackageUtilService: status updated");
            });
        }
        else {
            DebugService.warn("PackageUtilService: status update already in progress");
        }
    };
    self.setPollingInterval = function () {
        DynamicPropertiesService.queryForProperties().then(function () {
            var intervalValue = DynamicPropertiesService.getPropValueAsInt('package.statusRefreshInterval', 30000);
            if (packageUpdateIntervalId === null) {
                packageUpdatePromise = null;
                packageUpdateIntervalId = RequestService.createRequestInterval(pollingIntervalCallback, intervalValue);
                DebugService.debug("PackageUtilService: created status refresh interval (increment: " + intervalValue + "ms)");
            }
            else {
                DebugService.warn("PackageUtilService: refusing to create another status update refresh interval");
            }
        });
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 7/17/15.
 */
'use strict';
angular.module('prism-ui.package').controller('NewPackageModalController', function ($uibModalInstance, ContentResourceFactory, ModalService, PackageResourceFactory) {
    var self = this;
    var defaultContent = { name: '<no selection>' };
    self.selectedContent = defaultContent;
    self.contentType = 'Series';
    self.name = '';
    self.numPackages = 1;
    self.packageType = {};
    self.onOk = function () {
        var newPackage = {
            name: self.name,
            content: self.selectedContent,
            categoryType: self.packageType,
            purgeOnIngest: true,
            autoDeliver: true
        };
        var data = {
            package: newPackage,
            numPackages: self.numPackages
        };
        $uibModalInstance.close(data);
    };
    self.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
    self.openContentSelectModal = function () {
        ModalService.showContentSelectModal(self.contentType, undefined, self.contentSelectionHandler);
    };
    self.disableOk = function () {
        return self.selectedContent === defaultContent || !self.packageType.id || self.name === '';
    };
    self.resetDefaultContent = function (isAd) {
        self.selectedContent = defaultContent;
        if (isAd) {
            self.packageType = self.packageTypesMap.shortform;
        }
    };
    self.contentSelectionHandler = function (result) {
        self.selectedContent = result;
    };
    self.onNumPackagesChanged = function (value, min, max) {
        if (value > max) {
            self.numPackages = max;
        }
        else if (value < min) {
            self.numPackages = min;
        }
    };
    PackageResourceFactory.query({ sub: 'categoryTypes' }).$promise.then(function (packageTypes) {
        self.packageTypesMap = {};
        angular.forEach(packageTypes, function (packageType) {
            self.packageTypesMap[packageType.name.toLowerCase().replace(/ /, '')] = packageType;
        });
        self.packageTypes = packageTypes;
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
function NewMediaProfileModal(_) {
    var self = this;
    self.selectedMediaProfileType = null;
    self.$onInit = function () {
        self.availableProfileTypes = ['VIDEO', 'IMAGE', 'AUDIO', 'ARTWORK', 'DOCUMENT'];
    };
    self.canCreate = function () {
        return self.selectedMediaProfileType !== null;
    };
    self.onCreate = function () {
        self.close({ $value: self.selectedMediaProfileType });
    };
    self.onCancel = function () {
        self.dismiss({ $value: 'cancel' });
    };
}
angular.module('prism-ui.mediaAcceptProfiles').component('newMediaProfileModal', {
    templateUrl: 'system/templates/mediaAcceptProfiles/modals/new-media-profile-modal-template.html',
    controller: NewMediaProfileModal,
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: network- edit-view-component
 *
 * Created by rwilliams on 7/24/17.
 */
'use strict';
function NetworkPropertiesEditViewController(_, $q, $routeParams, $route, $timeout, NetworkViewService, BreadcrumbService, CategoriesService, EnumService, MetadataService, MetadataEditService, RatingsService) {
    var self = this;
    var getProps = function (properties) {
        var props = {};
        angular.forEach(properties, function (prop, name) {
            props[name] = prop;
        });
        return props;
    };
    var buildNetworkComponentsMap = function (network) {
        var allComponents = MetadataService.buildCustomComponentMap(network.metadata.properties);
        return getProps(allComponents);
    };
    var convertEnumPatternObjects = function () {
        self.network.breakPrePostRollPattern =
            _.find(self.availableBreakPatterns, {
                id: self.network.breakPrePostRollPattern
            });
        self.network.ratingOverlayPattern =
            _.find(self.availableRatingOverlayPatterns, {
                id: self.network.ratingOverlayPattern
            });
    };
    var getData = function () {
        BreadcrumbService.editService = NetworkViewService;
        self.loadingIndicator.show = true;
        self.breadcrumb = {
            location: '/meta/networks/search',
            name: 'Networks',
            params: null
        };
        if (BreadcrumbService.getBreadcrumbs().length < 2) {
            BreadcrumbService.addBreadcrumb(self.breadcrumb);
        }
        var networkPromise;
        if ($routeParams.id !== '-1') {
            networkPromise = NetworkViewService.getEditViewData({ id: $routeParams.id }).then(function (data) {
                self.network = NetworkViewService.network = data;
                return data;
            });
        }
        else {
            self.breadcrumbName = 'New Network';
            self.metadataProperties = [];
            networkPromise = $q.when(self.network);
        }
        return $q.all({
            enums: EnumService.queryForEnums(),
            network: networkPromise,
            packageCategories: CategoriesService.getAllCategories(),
            properties: MetadataEditService.getMetadataByGroup('Network'),
            ratingSystems: RatingsService.getRatingSystems()
        }).then(function (data) {
            var networkComponentsMap = {};
            self.availableBreakPatterns = EnumService.getEnumPicklist('Network_breakPrePostRollPattern');
            self.availableRatingOverlayPatterns = EnumService.getEnumPicklist('Network_ratingOverlayPattern');
            self.availableRatingSystems = _.values(data.ratingSystems);
            self.availablePackageCategories = data.packageCategories;
            self.metadataProperties = data.properties;
            if (self.network.metadata) {
                networkComponentsMap = buildNetworkComponentsMap(self.network);
            }
            else {
                var metadataItems = self.metadataProperties.reduce(function (mappedItems, metadataItem) {
                    mappedItems[metadataItem.name] = { required: false, valueOverridden: false };
                    return mappedItems;
                }, {});
                networkComponentsMap = MetadataService.buildCustomComponentMap(metadataItems);
            }
            NetworkViewService.networkComponentsMap(networkComponentsMap);
            convertEnumPatternObjects();
            self.loadingIndicator.show = false;
        });
    };
    var getPermissions = function () {
        NetworkViewService.getViewPermissions(NetworkViewService.permissionViewStates.NETWORK_VIEW_STATE).then(function (permissions) {
            self.permissions = permissions;
            self.canWrite = self.permissions.write;
            getData();
        });
    };
    var saveEditData = function () {
        self.loadingIndicator.show = true;
        if (typeof self.network.breakPrePostRollPattern === 'object') {
            self.network.breakPrePostRollPattern = self.network.breakPrePostRollPattern.id;
        }
        if (typeof self.network.ratingOverlayPattern === 'object') {
            self.network.ratingOverlayPattern = self.network.ratingOverlayPattern.id;
        }
        if (!self.network.metadata) {
            self.network.metadata = {
                properties: {}
            };
        }
        angular.forEach(NetworkViewService.networkComponentsMap(), function (comp, name) {
            var instanceValue = comp.instanceData.value;
            if (instanceValue) {
                if (self.network.metadata.properties[name]) {
                    self.network.metadata.properties[name].value = instanceValue;
                }
                else {
                    self.network.metadata.properties[name] = {
                        value: instanceValue
                    };
                }
            }
        });
        NetworkViewService
            .saveNetwork(self.network)
            .then(function (data) {
            self.breadcrumbName = self.network.name;
            self.network = data;
            convertEnumPatternObjects();
            NetworkViewService.originalNetworkData = _.cloneDeep(data);
            self.loadingIndicator.show = false;
            $route.updateParams({ id: self.network.id });
            self.editorForm.$pristine = true;
            self.editorForm.$setPristine();
        });
    };
    self.$onInit = function () {
        if (self.isAdmin) {
            self.canWrite = true;
            getData();
        }
        else {
            getPermissions();
        }
    };
    self.$postLink = function () {
        $timeout(function () {
            NetworkViewService.editorForm = self.editorForm;
        });
    };
    self.$onDestroy = function () {
        NetworkViewService.network = null;
        self.metadataProperties = [];
    };
    self.network = {};
    self.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };
    self.getNetworkComponentsMap = function () {
        return NetworkViewService.networkComponentsMap();
    };
    self.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () {
                var isNotPristine = self.editorForm && !self.editorForm.$pristine;
                var requiredFieldsSpecified = !!_.get(self.network, 'name') &&
                    !!_.get(self.network, 'value');
                return isNotPristine && requiredFieldsSpecified && self.canWrite;
            },
            onClick: saveEditData
        },
        {
            label: 'Revert',
            enabled: function () {
                var isNew = $routeParams.id < 0;
                var isNotPristine = self.editorForm && !self.editorForm.$pristine;
                return self.canWrite && (isNew || isNotPristine);
            },
            onClick: function () {
                self.network = NetworkViewService.revertEditData();
                convertEnumPatternObjects();
                self.editorForm.$pristine = true;
                self.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: function () {
                return true;
            },
            onClick: NetworkViewService.exitEdit
        }
    ];
}
angular.module('prism-ui.network').component('networkPropertiesEditView', {
    templateUrl: 'meta/network/editor/components/properties/network-properties-edit-view-template.html',
    controller: NetworkPropertiesEditViewController,
    bindings: {
        isAdmin: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.package').controller('AdHocSelectPartnersModalController', function ($uibModalInstance, currentPartners, isSeries, isSeason, isVolume, allPartners) {
    var self = this;
    self.availablePartners = [];
    self.selectedPartners = [];
    self.isSeries = isSeries;
    self.isSeason = isSeason;
    self.isVolume = isVolume;
    self.subType = '';
    function filterPartners() {
        self.availablePartners = allPartners.filter(function (partner) {
            var found = false;
            for (var i = 0; i < currentPartners.length; i++) {
                if (currentPartners[i].id === partner.id) {
                    found = true;
                    break;
                }
            }
            return !found;
        });
    }
    this.onOk = function () {
        $uibModalInstance.close({ selectedPartners: self.selectedPartners, subType: self.subType });
    };
    this.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
    this.disableOKButton = function () {
        return self.selectedPartners.length < 1 || (self.isSeries && !self.subType);
    };
    filterPartners();
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by richardwilliams on 5/4/15.
 */
'use strict';
angular.module('prism-ui.package').controller('QualityControlModalController', function ($uibModalInstance, qcNoteData, canEdit) {
    this.qcNoteData = qcNoteData;
    this.isDisabled = !canEdit;
    this.onOk = function () {
        $uibModalInstance.close(this.qcNoteData);
    };
    this.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 6/10/15.
 */
'use strict';
angular.module('prism-ui.package').controller('RejectPackageModalController', function ($uibModalInstance, rejectReason, showRejectClipWarning, editable) {
    var self = this;
    self.rejectReason = rejectReason;
    self.showRejectClipWarning = showRejectClipWarning;
    self.editable = editable;
    self.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
    self.onOk = function () {
        $uibModalInstance.close(self.rejectReason);
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 4/20/15.
 */
//
// This is the original "Select Asset" modal. It's used for
// navigating and choosing files from Reach Engine virtual
// filesystem roots.
//
'use strict';
function SelectAssetModalController(_, VALID_FILE_EXTENSIONS, VirtualPathResourceFactory, ModalService, UtilsService) {
    var _this = this;
    var setParentDirectory = function () {
        var paths = _this.currentDirectory.path.split('/');
        _this.parentDirectory = paths.slice(0, paths.length - 2).join('/') + '/';
    };
    var fileSystemSuccessHandler = function (fileSystemDirectory) {
        var filteredFiles = fileSystemDirectory.files.filter(function (file) {
            // always include directories, and match all files by
            // default
            return _.get(_this, 'currentFileTypes', new RegExp("")).test(file.name) || file.directory;
        });
        var gridRows = fileSystemDirectory.roots.concat(filteredFiles);
        angular.forEach(gridRows, function (row) {
            row.name = row.alias || row.name;
        });
        _this.gridOptions.data = gridRows;
        _this.currentDirectory = fileSystemDirectory;
        _this.builtPath = fileSystemDirectory.path;
        setParentDirectory();
    };
    var gridColumnDefinitions = [{
            field: 'name',
            width: '60%',
            displayName: 'Name',
            sort: { direction: 'asc', priority: 0 },
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        },
        {
            field: 'length',
            name: 'Type',
            width: '15%',
            displayName: '',
            enableColumnMenu: false,
            cellTemplate: 'package/editor/components/modals/selectAsset/folder-cell-template.html'
        },
        {
            field: 'lastModified',
            width: '25%',
            displayName: 'Modified',
            cellFilter: 'amDateFormat: \'MM/DD/YYYY\''
        }];
    this.builtPath = '';
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableRowSelection: true,
        multiSelect: false,
        columnDefs: gridColumnDefinitions,
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            _this.gridApi.selection.on.rowSelectionChanged(null, function (row) {
                _this.selectedRow = (row.isSelected) ? row.entity : null;
            });
        }
    };
    this.onRowDblClick = function (row) {
        _this.loadFileSystemItem(row.entity);
    };
    this.loadSelectedItem = function () {
        _this.loadFileSystemItem(_this.selectedRow);
    };
    this.disableOKButton = function () {
        return !_this.selectedRow || (_this.selectedRow && (_this.selectedRow.alias || _this.selectedRow.directory));
    };
    var traverseToPath = function (fileSystemItem) {
        var path;
        if (fileSystemItem.path) {
            path = fileSystemItem.alias;
        }
        else {
            path = fileSystemItem.parent + fileSystemItem.name + '/';
        }
        VirtualPathResourceFactory.get({ path: path }, fileSystemSuccessHandler);
    };
    var acceptItem = function (item) {
        var assetPath = (item) ? item.parent + item.name : _this.selectedRow.parent + _this.selectedRow.name;
        _this.close({ $value: assetPath });
    };
    this.loadFileSystemItem = function (fileSystemItem) {
        if (fileSystemItem.path || fileSystemItem.directory) {
            traverseToPath(fileSystemItem);
        }
        else if (!_this.validateFileFunc) {
            acceptItem(fileSystemItem);
        }
        else {
            _this.loadingIndicator.show = true;
            _this.validateFileFunc(fileSystemItem)
                .then(function (validationResults) {
                if (!_.isArray(validationResults)) {
                    validationResults = [validationResults];
                }
                var hasErrors = _.some(validationResults, function (validationResult) {
                    return !_.isEmpty(validationResult.errors);
                });
                var hasWarnings = _.some(validationResults, function (validationResult) {
                    return !_.isEmpty(validationResult.warnings);
                });
                if (hasErrors || hasWarnings) {
                    ModalService.showAssetValidationResultsModal(validationResults, !hasErrors, function () { return acceptItem(fileSystemItem); });
                }
                else {
                    acceptItem(fileSystemItem);
                }
            })
                .finally(function () {
                _this.loadingIndicator.show = false;
            });
        }
    };
    this.loadParentDirectory = function () {
        VirtualPathResourceFactory.get({ path: _this.parentDirectory }, fileSystemSuccessHandler);
    };
    this.refreshCurrentDirectory = function () {
        VirtualPathResourceFactory.get({ path: _this.currentDirectory.path }, fileSystemSuccessHandler);
    };
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.validateFileFunc = _this.resolve.validateFileFunc;
        _this.currentFileTypes = (typeof _this.resolve.fileFilterType === 'string') ?
            UtilsService.buildFilters(VALID_FILE_EXTENSIONS[_this.resolve.fileFilterType]) :
            UtilsService.buildFilters(_this.resolve.fileFilterType);
        VirtualPathResourceFactory.get({}, fileSystemSuccessHandler);
    };
}
angular.module('prism-ui.package').component('selectAssetModal', {
    templateUrl: 'package/editor/components/modals/selectAsset/select-asset-modal-template.html',
    controller: SelectAssetModalController,
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 8/28/15.
 */
'use strict';
function PackageDistributionViewController(_, $q, $routeParams, $scope, $timeout, ContentResourceFactory, MetadataService, ModalService, NotificationService, PackageLiveClipViewService, PackageResourceFactory, PackageUtilService, PartnerEditService, PartnerPackagesService, PermissionsService, SubscriptionsResourceFactory, UtilsService) {
    var self = this;
    var queryId;
    //=============//
    // Permissions //
    //=============//
    var DISTRIBUTION_TAB_VIEW_STATE = 'PACKAGE_DISTRIBUTIONGRID_VIEW_STATE';
    var ADVANCED_DISTRIBUTION_TAB_VIEW_STATE = 'ADVANCED_PACKAGE_DISTRIBUTIONGRID_VIEW_STATE';
    var CLIP_DISTRIBUTION_GRID_VIEW_STATE = 'CLIP_DISTRIBUTIONGRID_VIEW_STATE';
    var ADVANCED_LIVE_CLIP_PACKAGE_DISTRIBUTIONGRID_VIEW_STATE = 'ADVANCED_LIVE_CLIP_PACKAGE_DISTRIBUTIONGRID_VIEW_STATE';
    var PACKAGE_BRANDING_VIEW_STATE = 'PACKAGE_BRANDING_VIEW_STATE';
    var CLIP_ACTION_BRANDING_VIEW_STATE = 'CLIP_ACTION_BRANDING_VIEW_STATE';
    var BASE_TEN_RADIX = 10;
    var getPermissions = function () {
        self.basicViewState = (self.isClipDistribution ?
            CLIP_DISTRIBUTION_GRID_VIEW_STATE :
            DISTRIBUTION_TAB_VIEW_STATE);
        self.advancedViewState = (self.isClipDistribution ?
            ADVANCED_LIVE_CLIP_PACKAGE_DISTRIBUTIONGRID_VIEW_STATE :
            ADVANCED_DISTRIBUTION_TAB_VIEW_STATE);
        self.viewState = self.isAdvanced ? self.advancedViewState : self.basicViewState;
        var writePromise = PermissionsService.canWrite(self.basicViewState);
        var advancedWritePromise = PermissionsService.canWrite(self.advancedViewState);
        var brandingOverridesPromise = PermissionsService.getPermissionsForViewState(PACKAGE_BRANDING_VIEW_STATE);
        var clipBrandingOverridesPromise = PermissionsService.getPermissionsForViewState(CLIP_ACTION_BRANDING_VIEW_STATE);
        return $q.all({
            basic: writePromise,
            advanced: advancedWritePromise,
            branding: brandingOverridesPromise,
            clipBranding: clipBrandingOverridesPromise
        }).then(function (perms) {
            self.writePerms = self.isAdvanced ? perms.advanced : perms.basic;
            self.canViewBrandingOverrides = self.isClipDistribution ?
                PermissionsService.hasReadPermission(perms.clipBranding.permission) :
                PermissionsService.hasReadPermission(perms.branding.permission);
        });
    };
    //================//
    // Dynamic Styles //
    //================//
    // Used to impose different stylesheet styles for the main
    // package dist. grids and the clip dist. grids.
    var liveMetadataOverrides = {
        episodeNumber: {
            columnClass: 'col-sm-4 pad-sm-right'
        },
        textinput: {
            labelClass: 'prism-form-item-label col-sm-' + (self.isAdvanced ? '3' : '12'),
            requiredClass: 'required-text-input-lg'
        },
        datetimefield: {
            labelClass: 'prism-form-item-label col-sm-' + (self.isAdvanced ? '3' : '12'),
            requiredClass: 'required-text-input-lg'
        },
        datetimefieldenhanced: {
            labelClass: 'prism-form-item-label col-sm-' + (self.isAdvanced ? '3' : '12'),
            requiredClass: 'required-text-input-lg'
        },
        datefieldenhanced: {
            labelClass: 'prism-form-item-label col-sm-' + (self.isAdvanced ? '3' : '12'),
            requiredClass: 'required-text-input-lg'
        },
        datefield: {
            labelClass: 'prism-form-item-label col-sm-' + (self.isAdvanced ? '3' : '12'),
            requiredClass: 'required-text-input-lg'
        },
        textarea: {
            labelClass: 'prism-form-item-label col-sm-' + (self.isAdvanced ? '3' : '12'),
            requiredClass: 'required-text-area-3-lg'
        },
        timeinput: {
            labelClass: 'prism-form-item-label col-sm-' + (self.isAdvanced ? '3' : '12'),
            columnClass: 'col-sm-4 time-component top-margin pad-sm-right',
            requiredClass: 'required-time-picker-lg'
        },
        timecodeinput: {
            labelClass: 'prism-form-item-label col-sm-' + (self.isAdvanced ? '3' : '12'),
            requiredClass: 'required-text-input-lg',
            attributes: {
                'root-class': 'col-sm-4'
            }
        },
        checkbox: {
            labelClass: 'prism-form-item-label col-sm-' + (self.isAdvanced ? '3' : '12'),
            requiredClass: 'required-text-input-lg'
        },
        dropdownlist: {
            labelClass: 'prism-form-item-label col-sm-' + (self.isAdvanced ? '3' : '12'),
            warningClasses: 'metadata-icons-col'
        },
        checkboxlist: {
            labelClass: 'prism-form-item-label col-sm-' + (self.isAdvanced ? '3' : '12'),
            requiredClass: 'required-checkbox-list-lg'
        },
        list: {
            labelClass: 'prism-form-item-label col-sm-' + (self.isAdvanced ? '3' : '12'),
            requiredClass: 'required-list-lg'
        }
    };
    var mainPackageMetadataOverrides = {
        episodeNumber: {
            columnClass: 'col-sm-2 pad-sm-right'
        }
    };
    self.customMetadataOverrides = self.isClipDistribution ? liveMetadataOverrides : mainPackageMetadataOverrides;
    //============//
    // Select All //
    //============//
    self.selectAllPartnerPackages = false;
    self.resetSelectAll = function (enabled) {
        if (!enabled && self.selectAllPartnerPackages) {
            self.selectAllPartnerPackages = false;
        }
    };
    self.updatePartnerPackageSubscriptionSelection = function (select) {
        PackageUtilService.editorForm.$setDirty();
        _.forEach(self.partnerPackages, function (partnerPackage) {
            if (partnerPackage.enabled !== select) {
                partnerPackage.enabled = select;
            }
        });
    };
    var partnerSubscriptionAllSelected = function () {
        var allSelected = true;
        _.forEach(self.partnerPackages, function (partnerPackage) {
            if (allSelected && !partnerPackage.enabled) {
                allSelected = false;
            }
        });
        return allSelected;
    };
    //===============//
    // Branding Data //
    //===============//
    self.canViewBrandingOverrides = false;
    self.showBrandingOverridesModal = function (partnerPkg) {
        var brandingViewState = self.isClipDistribution ?
            CLIP_ACTION_BRANDING_VIEW_STATE :
            PACKAGE_BRANDING_VIEW_STATE;
        var readOnly = self.packageObjectData.locked || !PackageUtilService.statusAllowsEdit(self.packageObjectData.status);
        ModalService.showBrandingDistributionOverridesModal(_.cloneDeep(partnerPkg), self.packageObjectData, brandingViewState, readOnly, function (newPartnerPackage) {
            if (self.isClipDistribution) {
                PackageLiveClipViewService.distributionForm.$setDirty();
            }
            PackageUtilService.editorForm.$setDirty();
            var brandingProps = [
                'preRollOverride', 'postRollOverride', 'breakPrePostRollOverride', 'watermarkOverride',
                'preRollOverridden', 'postRollOverridden', 'breakPrePostRollOverridden', 'watermarkOverridden',
                'preRollSeasonVolume', 'postRollSeasonVolume', 'breakPrePostRollSeasonVolume', 'watermarkSeasonVolume'
            ];
            _.forEach(brandingProps, function (prop) {
                if (newPartnerPackage[prop] !== undefined) {
                    partnerPkg[prop] = newPartnerPackage[prop];
                }
            });
        });
    };
    //===========//
    // Edit Data //
    //===========//
    self.partnerPackages = [];
    self.seasonPartnerPackages = [];
    self.volumePartnerPackages = [];
    self.partnerComponentsMap = {};
    self.videoRoleMap = {};
    var handleQuery = function () {
        _.forEach(PartnerPackagesService.partnerPackages(), function (partnerPackage) {
            self.videoRoleMap[partnerPackage.id] = _.cloneDeep(partnerPackage.videoRoles);
        });
        self.partnerPackages = PartnerPackagesService.partnerPackages();
        self.seasonPartnerPackages = PartnerPackagesService.seasonPartnerPackages();
        self.volumePartnerPackages = PartnerPackagesService.volumePartnerPackages();
        self.partnerComponentsMap = PartnerPackagesService.partnerComponentsMap();
    };
    var getEditData = function () {
        if (!self.packageObjectData.category) {
            return $q.when(true);
        }
        var promises = {};
        // get partner packages
        if (self.isClipDistribution) {
            var deferred = $q.defer();
            deferred.resolve(PartnerPackagesService.partnerPackages());
            promises.pkgs = deferred.promise;
        }
        else {
            promises.pkgs = PartnerPackagesService.queryPartnerPackages(queryId, self.packageObjectData);
        }
        // get content categories
        if (self.isAdvanced) {
            promises.contentCategories = PartnerPackagesService.queryContentCategories(self.packageObjectData);
        }
        // get seasons & volumes
        if (self.packageObjectData.content.type === 'Series') {
            promises.seasons = PartnerPackagesService.querySeasons($routeParams.id);
            promises.volumes = PartnerPackagesService.queryVolumes($routeParams.id);
        }
        return $q.all(promises).then(function (editData) {
            self.availableSeasons = editData.seasons;
            self.availableVolumes = editData.volumes;
            if (self.isAdvanced) {
                self.availableComponentRoles = [];
                var contentCategory = editData.contentCategories.filter(function (contentCategory) {
                    return contentCategory.category.id === self.packageObjectData.category.id;
                })[0];
                if (!!contentCategory) {
                    _.forEach(contentCategory.videoRoles, function (videoRole) {
                        if (videoRole.role.name !== 'Main Video') {
                            self.availableComponentRoles.push(videoRole.role);
                        }
                    });
                }
                else {
                    // Assume a default content category,
                    // as no explicit/customized one is
                    // being returned.
                    self.availableComponentRoles = [];
                }
            }
            handleQuery();
            self.selectAllPartnerPackages = partnerSubscriptionAllSelected();
        });
    };
    var createNewPartnerSubscription = function (partner, subType) {
        var partnerSub = {};
        partnerSub.enabled = true;
        partnerSub.category = self.packageObjectData.category;
        partnerSub.content = self.packageObjectData.content;
        partnerSub.partner = partner;
        partnerSub.adHocPackageId = self.packageObjectData.id;
        if (partnerSub.content.type === 'Series') {
            partnerSub.seasonSubscription = subType === 'season';
            partnerSub.seasons = [{ season: self.packageObjectData.season }];
            partnerSub.volumes = subType !== 'season' ? [{ volume: self.packageObjectData.volume }] : [];
        }
        return partnerSub;
    };
    var selectPartnerPackageInstance = function (partnerPackage, instanceId) {
        return PartnerPackagesService.selectPartnerPackageInstance(partnerPackage, instanceId).then(function () {
            // the service takes care of replacing instances
            // of partner packages in the "main" arrays, so we
            // just need to grab the new arrays
            self.partnerPackages = PartnerPackagesService.partnerPackages();
            self.seasonPartnerPackages = PartnerPackagesService.seasonPartnerPackages();
            self.volumePartnerPackages = PartnerPackagesService.volumePartnerPackages();
            self.partnerComponentsMap = PartnerPackagesService.partnerComponentsMap();
        });
    };
    self.canOverridePartnerBranding = function (partnerPkg) {
        return partnerPkg.enabled && self.canViewBrandingOverrides;
    };
    self.partnerHasBrandingOverrides = function (partnerPkg) {
        return (partnerPkg.preRollOverridden ||
            partnerPkg.postRollOverridden ||
            partnerPkg.breakPrePostRollOverridden ||
            partnerPkg.watermarkOverridden);
    };
    var getDataToSave = function () {
        var partnerPackagesSavePayload = {};
        _.forEach(PartnerPackagesService.partnerPackages(), function (partnerPackageToSave, index) {
            // don't save unmodified partner packages
            if (!PartnerPackagesService.isPartnerPackageModified(partnerPackageToSave)) {
                return;
            }
            partnerPackagesSavePayload[index] = _.cloneDeep(partnerPackageToSave);
            // **************************************************************** //
            // **************************************************************** //
            // **** Seriously! Always perform this action before you save  **** //
            // **** metadata items to ensure the correct data is persisted **** //
            // **************************************************************** //
            // **************************************************************** //
            // save metadata components
            _.forEach(PartnerPackagesService.partnerComponentsMap()[partnerPackageToSave.id][self.isAdvanced ? 'advanced' : 'basic'], function (comp, name) {
                if (comp.uiControlHint === 'TextListInput') {
                    partnerPackagesSavePayload[index].metadata.properties[name].value = UtilsService.arrayToString(comp.instanceData.value, MetadataService.textListInputProps.delimiter, MetadataService.textListInputProps.objectKey);
                }
                else {
                    partnerPackagesSavePayload[index].metadata.properties[name].value = comp.instanceData.value;
                }
            });
        });
        return _.values(partnerPackagesSavePayload);
    };
    var getBlankInstanceRevisionPartners = function () {
        var partners = [];
        _.forEach(PartnerPackagesService.partnerPackages(), function (partnerPackage) {
            var selectedInstance = PartnerPackagesService.getSelectedInstance(partnerPackage);
            if (selectedInstance && !selectedInstance.revision) {
                partners.push(partnerPackage.partner.name);
            }
        });
        return partners;
    };
    var onSave = function () {
        $scope.$emit('server-busy', { working: true });
        var partnersWithBlankInstanceRevisions = getBlankInstanceRevisionPartners();
        if (partnersWithBlankInstanceRevisions.length > 0) {
            var msg = 'The following partners have empty instance revision fields: ';
            msg += partnersWithBlankInstanceRevisions.join(', ');
            msg += '\n\nPlease populate these fields before saving.';
            NotificationService.createWarningNotification(msg);
            $scope.$emit('server-busy', { working: false });
            return;
        }
        var allPartrnerPackagesToSave = getDataToSave();
        var partnerPackagesToBatchSave = [];
        var partnerPackagesToSaveIndividually = [];
        var batchSavePromise;
        var savePromises = [];
        _.forEach(allPartrnerPackagesToSave, function (partPkg) {
            var individualSave = false;
            if (partPkg.partner.partnerDeliveryInstanceEnabled) {
                var mostRecentInstance = PartnerPackagesService.mostRecentDeliveryInstance(partPkg.id);
                var selectedInstance = PartnerPackagesService.selectedInstanceMap()[partPkg.id];
                if (mostRecentInstance !== selectedInstance) {
                    partnerPackagesToSaveIndividually.push(partPkg);
                    individualSave = true;
                }
            }
            if (!individualSave) {
                partnerPackagesToBatchSave.push(partPkg);
            }
        });
        batchSavePromise = $q.when(true);
        if (partnerPackagesToBatchSave.length > 0) {
            batchSavePromise = PackageResourceFactory.savePartnerPackages({
                id: queryId,
                sub: 'partnerPackages'
            }, partnerPackagesToBatchSave).$promise;
        }
        if (partnerPackagesToSaveIndividually.length > 0) {
            _.forEach(partnerPackagesToSaveIndividually, function (partPkg) {
                savePromises.push(PartnerPackagesService.updatePartnerPackage(partPkg));
            });
        }
        // save most recent instances first
        return batchSavePromise
            .then(function () {
            // save "old" instances individually
            return $q.all(savePromises);
        })
            .then(function () {
            // save instances
            return PartnerPackagesService.saveInstanceRevisions();
        })
            .then(function () {
            // refresh edit data
            return getEditData();
        })
            .then(function () {
            // re-select old instances
            _.forEach(partnerPackagesToSaveIndividually, function (partPkg) {
                selectPartnerPackageInstance(partPkg, PartnerPackagesService.selectedInstanceMap()[partPkg.id]);
            });
        });
    };
    var onRevert = function () {
        $scope.$emit('server-busy', { working: true });
        PartnerPackagesService.revertPartnerPackages();
        _.forEach(PartnerPackagesService.partnerPackages(), function (partnerPackage) {
            self.videoRoleMap[partnerPackage.id] = _.cloneDeep(partnerPackage.videoRoles);
        });
        self.partnerPackages = PartnerPackagesService.partnerPackages();
        self.seasonPartnerPackages = PartnerPackagesService.seasonPartnerPackages();
        self.volumePartnerPackages = PartnerPackagesService.volumePartnerPackages();
        self.partnerComponentsMap = PartnerPackagesService.partnerComponentsMap();
        self.selectAllPartnerPackages = partnerSubscriptionAllSelected();
        $scope.$emit('server-busy', { working: false });
    };
    self.enabledVideoRolesUpdated = function (context, newEnabledEntities) {
        var partnerPackage = context;
        partnerPackage.videoRoles = newEnabledEntities;
        self.packageDistributionGridEditorForm.$setDirty();
    };
    self.onInstanceSelected = function (partnerPackage, $selected, $oldValue) {
        if (PartnerPackagesService.isPartnerPackageModified(partnerPackage)) {
            PartnerPackagesService.selectedInstanceMap()[partnerPackage.id] = $oldValue;
            NotificationService.createWarningNotification('The current instance has been modified. Please save or revert your changes first.');
            return;
        }
        $scope.$emit('server-busy', { working: true });
        var isDirty = PartnerPackagesService.isPartnerDataModified();
        var onSelectedPromise;
        if ($selected.createNew) {
            onSelectedPromise = PartnerPackagesService.createPartnerPackageInstance(partnerPackage);
            onSelectedPromise.then(function (instance) {
                return selectPartnerPackageInstance(partnerPackage, instance.id);
            });
        }
        else {
            onSelectedPromise = selectPartnerPackageInstance(partnerPackage, $selected.id);
        }
        onSelectedPromise.then(function () {
            if (!isDirty) {
                self.packageDistributionGridEditorForm.$setPristine();
            }
            $scope.$emit('server-busy', { working: false });
        });
    };
    //=================//
    // Ad-Hoc Packages //
    //=================//
    var addAdHocHandler = function (newSubs) {
        $scope.$emit('server-busy', { working: true });
        var partnerSubsPromises = [];
        var selectedPartners = newSubs.selectedPartners;
        _.forEach(selectedPartners, function (partner) {
            var newSub = createNewPartnerSubscription(partner, newSubs.subType);
            var subPromise = SubscriptionsResourceFactory.createSubscription({ partnerId: partner.id }, newSub).$promise;
            partnerSubsPromises.push(subPromise);
        });
        $q.all(partnerSubsPromises).then(function () {
            PartnerPackagesService.queryPartnerPackages(queryId, self.packageObjectData).then(function () {
                handleQuery(PartnerPackagesService.partnerPackages());
                $scope.$emit('server-busy', { working: false });
            });
        });
    };
    self.removeAdHocSub = function (partnerPackage) {
        $scope.$emit('server-busy', { working: true });
        partnerPackage.subscription.enabled = false;
        SubscriptionsResourceFactory.saveSubscription({
            partnerId: partnerPackage.partner.id,
            subId: partnerPackage.subscription.id
        }, partnerPackage.subscription).$promise
            .then(function () {
            return PackageResourceFactory.query({
                id: queryId,
                sub: 'partnerPackages'
            }).$promise;
        })
            .then(function (pkgs) {
            handleQuery(pkgs);
            $scope.$emit('server-busy', { working: false });
        });
    };
    PackageUtilService.tabAdHocPartnerFunction = function () {
        var selectedPartners = [];
        _.forEach(PartnerPackagesService.partnerPackages(), function (partnerPackage) {
            selectedPartners.push(partnerPackage.partner);
        });
        ModalService.showAdHocSelectPartnersModal(selectedPartners, self.packageObjectData.content.type === 'Series', !!self.packageObjectData.season, !!self.packageObjectData.volume, addAdHocHandler);
        self.selectAllPartnerPackages = partnerSubscriptionAllSelected();
    };
    //================//
    // Template Logic //
    //================//
    self.deliveryInstanceMap = PartnerPackagesService.deliveryInstanceMap;
    self.selectedInstanceMap = PartnerPackagesService.selectedInstanceMap;
    self.selectedInstanceRevisionAccessors = PartnerPackagesService.selectedInstanceRevisionAccessors;
    self.getSubscriptionTypeForPartnerPackage = function (partnerPackage) {
        if (partnerPackage.subscription.adHocPackageId) {
            return 'adHoc';
        }
        else if (partnerPackage.partner.numberOfChildren && parseInt(partnerPackage.partner.numberOfChildren, BASE_TEN_RADIX)) {
            return 'isSuperPartner';
        }
        else if (self.packageObjectData.content && self.packageObjectData.content.type === 'Series') {
            if (partnerPackage.subscription.seasonSubscription) {
                return (partnerPackage.subscription.seasons && partnerPackage.subscription.seasons.length) ?
                    'partialSeasons' :
                    'allSeasons';
            }
            else {
                return (partnerPackage.subscription.volumes && partnerPackage.subscription.volumes.length) ?
                    'partialVolumes' :
                    'allVolumes';
            }
        }
        else {
            return 'movieSpecial';
        }
    };
    self.statusAllowsEdit = function () {
        return PackageUtilService.statusAllowsEdit(self.packageObjectData.status) && !self.packageObjectData.isDelivering;
    };
    self.disableOverrides = function (partnerPackage) {
        return parseInt(partnerPackage.revision) > 1;
    };
    self.getInstanceLabel = function (partnerPackage) {
        if (!partnerPackage.partner.partnerDeliveryInstanceEnabled) {
            return '';
        }
        return PartnerPackagesService.deliveryInstanceMap()[partnerPackage.id].filter(function (instance) {
            return instance.id === PartnerPackagesService.selectedInstanceMap()[partnerPackage.id];
        })[0].label;
    };
    self.numericFieldKeyDown = function ($event, currentValue) {
        if ($event.key.length === 1) {
            var newValue = currentValue || '';
            newValue += $event.key;
            if (!(/^[0-9]+$/.test(newValue))) {
                $event.preventDefault();
            }
        }
    };
    self.showMMCInventoryModal = function (partnerPackage) {
        var readOnly = self.packageObjectData.locked || !self.statusAllowsEdit(self.packageObjectData.status) || !self.writePerms;
        ModalService.showMMCInventoryModal(partnerPackage.packageId, partnerPackage.partner.id, readOnly);
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    self.$postLink = function () {
        $timeout(function () {
            if (self.isClipDistribution) {
                PackageUtilService.editorForm = PackageLiveClipViewService[self.editorFormName];
            }
            else {
                PackageUtilService.editorForm = self.packageDistributionGridEditorForm;
            }
        });
    };
    self.$onDestroy = function () {
        if (self.isClipDistribution && self.editorFormName) {
            delete PackageUtilService.subTabSaveFunctions[self.editorFormName];
            delete PackageUtilService.subTabRevertFunctions[self.editorFormName];
        }
        self.partnerPackages = [];
        self.seasonPartnerPackages = [];
        self.volumePartnerPackages = [];
        self.partnerComponentsMap = {};
    };
    // **************************************************************** //
    // **************************************************************** //
    // **** Seriously! Always perform this action before you save  **** //
    // **** metadata items to ensure the correct data is persisted **** //
    // **************************************************************** //
    // **************************************************************** //
    self.onUpdate = function (event) {
        self.validationErrors = event.errors;
        if (!self.validationErrors) {
            _.forEach(PartnerPackagesService.partnerPackages(), function (partnerPackageToSave, index) {
                // update metadata components
                var textListInputComponent = PartnerPackagesService.partnerComponentsMap()[partnerPackageToSave.id][self.isAdvanced ? 'advanced' : 'basic'][event.name];
                if (textListInputComponent) {
                    textListInputComponent.instanceData.value = event.items;
                }
            });
        }
    };
    self.$onInit = function () {
        $scope.$emit('server-busy', { working: true });
        self.isClipDistribution = $routeParams.editView === 'liveClip';
        queryId = self.isClipDistribution ? self.packageObjectData.id : $routeParams.id;
        if (self.isClipDistribution && self.editorFormName) {
            PackageUtilService.subTabSaveFunctions[self.editorFormName] = {
                data: getDataToSave,
                callback: getEditData,
            };
            PackageUtilService.subTabRevertFunctions[self.editorFormName] = onRevert;
        }
        else {
            PackageUtilService.tabSaveFunction = onSave;
            PackageUtilService.tabRevertFunction = onRevert;
        }
        $q.all([
            getPermissions(),
            getEditData(),
        ])
            .then(function () {
            $scope.$emit('server-busy', { working: false });
        });
    };
}
angular
    .module('prism-ui.package')
    .component('packageDistributionGridView', {
    templateUrl: 'package/editor/components/view/distributionGrid/packagedistributiongrid-view-template.html',
    controller: PackageDistributionViewController,
    bindings: {
        packageObjectData: '=',
        isAdvanced: '=',
        editorFormName: '=',
    },
    transclude: true,
    require: {
        pkgLiveClip: '?^packageLiveclipView',
    }
}).filter('stringToNumber', function () {
    return function (numberAsString) {
        return parseInt(numberAsString, 10);
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 1/7/16.
 */
'use strict';
angular
    .module('prism-ui.package')
    .service('PartnerPackagesService', function (_, $q, moment, ComponentInventoryResourceFactory, ContentResourceFactory, MetadataService, PackageResourceFactory, PackageUtilService, PartnerPackagesResourceFactory, UtilsService) {
    var self = this;
    var _parentPackageObject;
    var _partnerPackages = [];
    var _seasonPartnerPackages = [];
    var _volumePartnerPackages = [];
    var _partnerComponentsMap = {};
    var _originalPartnerPackages = [];
    var _originalSeasonPartnerPackages = [];
    var _originalVolumePartnerPackages = [];
    var _originalPartnerComponentsMap = {};
    var _deliveryInstanceMap = {};
    var _originalDeliveryInstanceMap = {};
    var _selectedInstanceMap = {};
    var _selectedInstanceRevisionAccessors = {};
    /*
     * TODO
     * 		- default label
     * 		- disable preview buttons
     * 		- collection order...?
     * 		- live clipping
     */
    //================//
    // Getter-Setters //
    //================//
    self.parentPackageObject = function () { return _parentPackageObject; };
    self.partnerPackages = function () { return _partnerPackages; };
    self.seasonPartnerPackages = function () { return _seasonPartnerPackages; };
    self.volumePartnerPackages = function () { return _volumePartnerPackages; };
    self.partnerComponentsMap = function () { return _partnerComponentsMap; };
    self.originalPartnerPackages = function () { return _originalPartnerPackages; };
    self.originalSeasonPartnerPackages = function () { return _originalSeasonPartnerPackages; };
    self.originalVolumePartnerPackages = function () { return _originalVolumePartnerPackages; };
    self.originalPartnerComponentsMap = function () { return _originalPartnerComponentsMap; };
    self.deliveryInstanceMap = function () { return _deliveryInstanceMap; };
    self.selectedInstanceMap = function () { return _selectedInstanceMap; };
    self.selectedInstanceRevisionAccessors = function () { return _selectedInstanceRevisionAccessors; };
    self.clearData = function () {
        _partnerPackages = [];
        _seasonPartnerPackages = [];
        _volumePartnerPackages = [];
        _partnerComponentsMap = {};
        _originalPartnerPackages = [];
        _originalSeasonPartnerPackages = [];
        _originalVolumePartnerPackages = [];
        _originalPartnerComponentsMap = {};
        _deliveryInstanceMap = {};
    };
    self.clearInstanceSelections = function () {
        _parentPackageObject = undefined;
        _selectedInstanceMap = {};
        _selectedInstanceRevisionAccessors = {};
    };
    //==========//
    // Metadata //
    //==========//
    var getBasicAndAdvancedProps = function (properties) {
        var props = { basic: {}, advanced: {} };
        _.forEach(properties, function (prop, name) {
            if (prop.advanced) {
                props.advanced[name] = prop;
            }
            else {
                props.basic[name] = prop;
            }
        });
        return props;
    };
    var buildPartnerComponentsMap = function (partnerPackage) {
        var errorsWarnings = PackageUtilService.errorsAndWarnings()[partnerPackage.partner.name];
        var allComponents = MetadataService.buildCustomComponentMap(partnerPackage.metadata.properties, errorsWarnings);
        return getBasicAndAdvancedProps(allComponents);
    };
    //===================//
    // Supplemental Data //
    //===================//
    self.queryContentCategories = function (packageObject) {
        return ContentResourceFactory.getContentCategories({
            id: packageObject.content.id,
            categoryId: packageObject.category.id,
        }).$promise;
    };
    self.querySeasons = function (packageId) {
        return PackageResourceFactory.query({
            id: packageId,
            sub: 'seasons',
        }).$promise;
    };
    self.queryVolumes = function (packageId) {
        return PackageResourceFactory.query({
            id: packageId,
            sub: 'volumes',
        }).$promise;
    };
    //===========================================//
    // Partner Packages & Distribution Instances //
    //===========================================//
    var updateErrorsAndWarnings = function () {
        //
        // TODO - single partner package E&W update
        //
        var validationResults = [];
        if (_parentPackageObject && _parentPackageObject.validationResult) {
            var packageValidationResult = _parentPackageObject.validationResult.filter(function (result) {
                return result && result.source === _parentPackageObject.name;
            })[0];
            if (packageValidationResult) {
                validationResults.push(packageValidationResult);
            }
        }
        _.forEach(_partnerPackages, function (partnerPkg) {
            if (partnerPkg.validationResult) {
                validationResults.push(partnerPkg.validationResult);
            }
        });
        PackageUtilService.createErrorsAndWarningsMap(validationResults);
    };
    var processPartnerPackage = function (partnerPkg) {
        // build metadata components map
        _partnerComponentsMap[partnerPkg.id] = buildPartnerComponentsMap(partnerPkg);
        _originalPartnerComponentsMap[partnerPkg.id] = _.cloneDeep(_partnerComponentsMap[partnerPkg.id]);
    };
    var replacePartnerPackageInArray = function (partnerPackageArray, partnerPackage) {
        var index = _.findIndex(partnerPackageArray, { id: partnerPackage.id });
        partnerPackageArray.splice(index, 1, partnerPackage);
    };
    var amendPartnerPackageArrays = function (partnerPackage) {
        replacePartnerPackageInArray(_partnerPackages, partnerPackage);
        replacePartnerPackageInArray(_originalPartnerPackages, partnerPackage);
        if (partnerPackage.subscription.seasonSubscription) {
            replacePartnerPackageInArray(_seasonPartnerPackages, partnerPackage);
            replacePartnerPackageInArray(_originalSeasonPartnerPackages, partnerPackage);
        }
        else {
            replacePartnerPackageInArray(_volumePartnerPackages, partnerPackage);
            replacePartnerPackageInArray(_originalVolumePartnerPackages, partnerPackage);
        }
    };
    self.mostRecentDeliveryInstance = function (partnerPackageId) {
        // element 0 is the "Create new ..." label, so the most
        // recent instance is at element 1
        return _deliveryInstanceMap[partnerPackageId][1].id;
    };
    var createRevisionAccessor = function (partnerPackageId) {
        //
        // Creates a closure that can be used to read/write a
        // partner package instance's revision, without any data
        // identifying the partner package.
        //
        // This closure is then stored in a map keyed on partner
        // package IDs so it may be easily accessed via template.
        //
        _selectedInstanceRevisionAccessors[partnerPackageId] = function (revision) {
            var selectedInstance = _deliveryInstanceMap[partnerPackageId].filter(function (instance) {
                return instance.id === _selectedInstanceMap[partnerPackageId];
            })[0];
            if (arguments.length) {
                selectedInstance.revision = revision;
            }
            return selectedInstance.revision;
        };
    };
    var processInstanceList = function (partnerPackageId, deliveryInstances) {
        // Add dropdown-select label to each instance
        _.forEach(deliveryInstances, function (deliveryInstance) {
            var lastEditedFmt = moment(deliveryInstance.lastEdited).format('YYYYMMDD');
            deliveryInstance.label = deliveryInstance.instance + ' - Last Edited ' + lastEditedFmt;
        });
        // Sort descending by instance number (they should be
        // sorted by creation time, which will have the same
        // ordinality as the instance number)
        deliveryInstances = _.sortBy(deliveryInstances, 'instance').reverse();
        // Add "Create new instance" option to dropdown collection
        deliveryInstances.unshift({
            label: 'Create new instance',
            createNew: true,
        });
        _deliveryInstanceMap[partnerPackageId] = deliveryInstances;
        _originalDeliveryInstanceMap[partnerPackageId] = _.cloneDeep(deliveryInstances);
        createRevisionAccessor(partnerPackageId);
    };
    var queryDeliveryInstances = function (partnerPackage) {
        return PartnerPackagesResourceFactory.getDeliveryInstances({
            partnerPackageId: partnerPackage.id,
        }).$promise.then(function (deliveryInstances) {
            return {
                partnerPackage: partnerPackage,
                deliveryInstances: deliveryInstances,
            };
        });
    };
    var queryAllDeliveryInstances = function () {
        var instancePromises = {};
        _.forEach(_partnerPackages, function (partnerPackage) {
            if (!partnerPackage.partner.partnerDeliveryInstanceEnabled) {
                return;
            }
            instancePromises[partnerPackage.id] = queryDeliveryInstances(partnerPackage)
                .then(function (instanceData) {
                processInstanceList(partnerPackage.id, instanceData.deliveryInstances);
                // Select most recent by default
                if (!_selectedInstanceMap[partnerPackage.id]) {
                    _selectedInstanceMap[partnerPackage.id] = self.mostRecentDeliveryInstance(partnerPackage.id);
                }
                return instanceData.deliveryInstances;
            });
        });
        return $q.all(instancePromises);
    };
    self.selectPartnerPackageInstance = function (partnerPackage, instanceId) {
        var params = {
            partnerPackageId: partnerPackage.id,
            deliveryInstanceId: instanceId ? instanceId : undefined,
        };
        return PartnerPackagesResourceFactory.getPartnerPackage(params).$promise
            .then(function (partnerPackage) {
            amendPartnerPackageArrays(partnerPackage);
            updateErrorsAndWarnings(); // (!!) This could be called a lot. See note at top of method.
            processPartnerPackage(partnerPackage);
            return queryDeliveryInstances(partnerPackage);
        })
            .then(function (instanceData) {
            _selectedInstanceMap[partnerPackage.id] = instanceId;
            processInstanceList(partnerPackage.id, instanceData.deliveryInstances);
        })
            .then(function () {
            return PackageUtilService.pollForPackageUpdates();
        });
    };
    self.createPartnerPackageInstance = function (partPkg) {
        return PartnerPackagesResourceFactory.createDeliveryInstance({
            partnerPackageId: partPkg.id
        }).$promise;
    };
    self.saveInstanceRevisions = function () {
        var savePromises = [];
        _.forEach(_deliveryInstanceMap, function (deliveryInstances, partnerPackageId) {
            _.forEach(deliveryInstances, function (instance, index) {
                if (UtilsService.compareBasic(instance, _originalDeliveryInstanceMap[partnerPackageId][index])) {
                    savePromises.push(PartnerPackagesResourceFactory.updateDeliveryInstance({ instanceId: instance.id }, instance).$promise);
                }
            });
        });
        if (savePromises.length > 0) {
            return $q.all(savePromises);
        }
        else {
            return $q.when(true);
        }
    };
    self.updatePartnerPackage = function (partnerPackage) {
        return PartnerPackagesResourceFactory.updatePartnerPackage({
            partnerPackageId: partnerPackage.id,
            deliveryInstanceId: _selectedInstanceMap[partnerPackage.id],
        }, partnerPackage).$promise;
    };
    //
    // Called after retrieving all partner packages from the main
    // PP API. That call only grabs the most recent instances;
    // this scans the selected instance map and updates any
    // partner packages with older (e.g. "not most recent")
    // selections made in the UI.
    //
    var queryOldPartnerPackageInstances = function () {
        var selectPromises = [];
        _.forEach(_partnerPackages, function (partnerPackage) {
            if (!partnerPackage.partner.partnerDeliveryInstanceEnabled) {
                return;
            }
            if (_selectedInstanceMap[partnerPackage.id] !== self.mostRecentDeliveryInstance(partnerPackage.id)) {
                selectPromises.push(self.selectPartnerPackageInstance(partnerPackage, _selectedInstanceMap[partnerPackage.id]));
            }
        });
        return $q.all(selectPromises);
    };
    self.queryPartnerPackages = function (packageId, parentPackageObject) {
        //
        // packageId
        // 		the ID of the package whose partner packages to
        // 		obtain
        //
        // parentPackageObject
        // 		the ID of the package whose partner package
        // 		instance selections and validation data will be
        // 		remembered - won't match the packageId when on the
        //		clipping tab; we still have to remember what the
        //		parent package was
        //
        _parentPackageObject = parentPackageObject;
        //
        // Cloning here detaches the arrays from the controller.
        // This prevents flicker when grabbing new edit data,
        // because we first grab all of the most recent instances
        // in one API call, but then have to go back and replace
        // any existing instance selections with subsequent,
        // discrete API calls.
        //
        // The controller should replace its references to these
        // arrays after calling this function.
        //
        _partnerPackages = _.cloneDeep(_partnerPackages);
        _seasonPartnerPackages = _.cloneDeep(_seasonPartnerPackages);
        _volumePartnerPackages = _.cloneDeep(_volumePartnerPackages);
        _partnerComponentsMap = _.cloneDeep(_partnerComponentsMap);
        _deliveryInstanceMap = _.cloneDeep(_deliveryInstanceMap);
        // Step 1: Get all the partner packages, specifically the
        // most recent instances of each package, in one API call.
        return PackageResourceFactory.query({
            id: packageId,
            sub: 'partnerPackages'
        }).$promise
            .then(function (partnerPackages) {
            _partnerPackages = _.sortBy(partnerPackages, function (partnerPkg) {
                return partnerPkg.partner.name.toLowerCase();
            });
            _seasonPartnerPackages = _partnerPackages.filter(function (partnerPkg) {
                return partnerPkg.subscription.seasonSubscription;
            });
            _volumePartnerPackages = _partnerPackages.filter(function (partnerPkg) {
                return !partnerPkg.subscription.seasonSubscription;
            });
            // Step 2: Get metadata property definitions before
            // processing partner packages and building components
            // map.
            return MetadataService.propertiesPromise;
        })
            .then(function () {
            // digest E&W's for all partner packages, then build
            // metadata components map
            updateErrorsAndWarnings();
            _.forEach(_partnerPackages, processPartnerPackage);
            // Step 3: Get instance lists for each partner package
            return queryAllDeliveryInstances();
        })
            .then(function () {
            _originalDeliveryInstanceMap = _.cloneDeep(_deliveryInstanceMap);
            // Step 4: Update instances for packages that have
            // older selections made in the UI
            return queryOldPartnerPackageInstances();
        })
            .then(function () {
            _originalPartnerPackages = _.cloneDeep(_partnerPackages);
            _originalSeasonPartnerPackages = _.cloneDeep(_seasonPartnerPackages);
            _originalVolumePartnerPackages = _.cloneDeep(_volumePartnerPackages);
            _originalPartnerComponentsMap = _.cloneDeep(_partnerComponentsMap);
            _originalDeliveryInstanceMap = _.cloneDeep(_deliveryInstanceMap);
        })
            .then(function () {
            return _partnerPackages;
        });
    };
    self.isPartnerPackageModified = function (partnerPackage) {
        var originalPartnerPackage = _originalPartnerPackages.filter(function (p) {
            return partnerPackage.id === p.id;
        })[0];
        var partnerComponents = _partnerComponentsMap[partnerPackage.id];
        var originalPartnerComponents = _originalPartnerComponentsMap[partnerPackage.id];
        return (UtilsService.compareBasic(partnerPackage, originalPartnerPackage) ||
            UtilsService.compareBasic(partnerComponents, originalPartnerComponents));
    };
    self.isPartnerDataModified = function () {
        // returns true if any partner data is modified - doesn't
        // examine instance selections (but does examine instance
        // revision numbers
        return (UtilsService.compareBasic(_partnerPackages, _originalPartnerPackages) ||
            UtilsService.compareBasic(_partnerComponentsMap, _originalPartnerComponentsMap) ||
            UtilsService.compareBasic(_deliveryInstanceMap, _originalDeliveryInstanceMap));
    };
    self.parentPackageId = function () {
        if (_parentPackageObject && _parentPackageObject.id) {
            return _parentPackageObject.id;
        }
        else {
            return -1;
        }
    };
    var reviseInstanceValidationResult = function (validationResults, partnerPackage) {
        var selectedInstance = _selectedInstanceMap[partnerPackage.id];
        var mostRecentInstance = self.mostRecentDeliveryInstance(partnerPackage.id);
        var instanceValidationPromise = null;
        if (selectedInstance !== mostRecentInstance) {
            var params = {
                partnerPackageId: partnerPackage.id,
                deliveryInstanceId: selectedInstance,
            };
            instanceValidationPromise = PartnerPackagesResourceFactory.getPartnerPackage(params).$promise
                .then(function (partnerPackage) {
                var foundIndex = _.findIndex(validationResults, function (validationResult) {
                    return validationResult.source === partnerPackage.partner.name;
                });
                if (partnerPackage.validationResult) {
                    if (foundIndex >= 0) {
                        // replace the result with the instance's result
                        validationResults.splice(foundIndex, 1, partnerPackage.validationResult);
                    }
                    else {
                        // add the instance's result
                        validationResults.push(partnerPackage.validationResult);
                    }
                }
                else if (foundIndex >= 0) {
                    // remove the result
                    validationResults.splice(foundIndex, 1);
                }
            });
        }
        return instanceValidationPromise;
    };
    self.reviseInstanceValidationResults = function (packageId, validationResults) {
        var vrPromise = $q.defer();
        if (_parentPackageObject && packageId === _parentPackageObject.id) {
            var partnerPackagePromises = [];
            _.forEach(_partnerPackages, function (partnerPackage) {
                if (!partnerPackage.partner.partnerDeliveryInstanceEnabled) {
                    return;
                }
                var instanceValidationPromise = reviseInstanceValidationResult(validationResults, partnerPackage);
                if (instanceValidationPromise) {
                    partnerPackagePromises.push(instanceValidationPromise);
                }
            });
            $q.all(partnerPackagePromises).then(function () {
                vrPromise.resolve(validationResults);
            });
        }
        else {
            vrPromise.resolve();
        }
        return vrPromise.promise;
    };
    self.getSelectedInstance = function (partnerPackage) {
        var selectedInstance;
        if (partnerPackage.packageId === self.parentPackageId()) {
            var selectedInstanceId = self.selectedInstanceMap()[partnerPackage.id];
            if (selectedInstanceId) {
                selectedInstance = _deliveryInstanceMap[partnerPackage.id].filter(function (instance) {
                    return instance.id === selectedInstanceId;
                })[0];
            }
        }
        return selectedInstance;
    };
    self.getPartnerPackagesForValidation = function (packageId) {
        var basePartnerPackages;
        return PackageResourceFactory.query({
            id: packageId,
            sub: 'partnerPackages',
        }).$promise
            .then(function (partnerPackages) {
            basePartnerPackages = partnerPackages;
            var instancePromises = [];
            _.forEach(partnerPackages, function (partnerPackage) {
                var selectedInstance = self.getSelectedInstance(partnerPackage);
                if (selectedInstance && selectedInstance.id !== self.mostRecentDeliveryInstance(partnerPackage.id)) {
                    instancePromises.push(PartnerPackagesResourceFactory.getPartnerPackage({
                        partnerPackageId: partnerPackage.id,
                        deliveryInstanceId: selectedInstance.id,
                    }).$promise);
                }
            });
            return $q.all(instancePromises);
        })
            .then(function (partnerPackageInstances) {
            var partnerPackageMap = _.keyBy(basePartnerPackages, 'id');
            var instanceObjectPromises = [];
            _.forEach(partnerPackageInstances, function (partnerPackageInstance) {
                partnerPackageMap[partnerPackageInstance.id] = partnerPackageInstance;
            });
            _.forEach(partnerPackageMap, function (partnerPackage) {
                instanceObjectPromises.push(queryDeliveryInstances(partnerPackage));
            });
            return $q.all(instanceObjectPromises);
        })
            .then(function (partnerPackageInstanceTuples) {
            _.forEach(partnerPackageInstanceTuples, function (partnerPackageInstanceTuple) {
                var deliveryInstances = _.sortBy(partnerPackageInstanceTuple.deliveryInstances, 'instance');
                partnerPackageInstanceTuple.partnerPackage.deliveryInstances = deliveryInstances;
            });
            return _.map(partnerPackageInstanceTuples, 'partnerPackage');
        });
    };
    self.revertPartnerPackages = function () {
        _partnerPackages = _.cloneDeep(_originalPartnerPackages);
        _seasonPartnerPackages = _.cloneDeep(_originalSeasonPartnerPackages);
        _volumePartnerPackages = _.cloneDeep(_originalVolumePartnerPackages);
        _partnerComponentsMap = _.cloneDeep(_originalPartnerComponentsMap);
        _deliveryInstanceMap = _.cloneDeep(_originalDeliveryInstanceMap);
    };
    self.getApplicableDeliveryItems = function (partnerPackageId) {
        return PartnerPackagesResourceFactory.getApplicableDeliveryItems({ partnerPackageId: partnerPackageId }).$promise;
    };
    self.approvePartnerPackageForPreDeliveryQc = function (partnerPackageId, message) {
        return PartnerPackagesResourceFactory.approvePartnerPackageForPreDeliveryQc({ partnerPackageId: partnerPackageId, message: message }).$promise;
    };
    self.rejectPartnerPackageForPreDeliveryQc = function (partnerPackageId, message) {
        return PartnerPackagesResourceFactory.rejectPartnerPackageForPreDeliveryQc({ partnerPackageId: partnerPackageId, message: message }).$promise;
    };
    self.getComponentInventory = function (packageId, partnerId) {
        return ComponentInventoryResourceFactory.query({
            packageId: packageId,
            partnerId: partnerId
        }).$promise;
    };
    self.updateComponentInventory = function (componentInventoryObject) {
        return ComponentInventoryResourceFactory.updateComponentInventory({
            id: componentInventoryObject.id
        }, componentInventoryObject).$promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 8/10/15.
 */
'use strict';
angular.module('prism-ui.package').controller('PackageLiveClipViewController', function (_, $document, $filter, $interval, $location, $q, $routeParams, $scope, $window, durationFromSecFilter, secFromTimecodeFilter, timecodeFromSecFilter, twoDigitNumFilter, ContentResourceFactory, DownloadAssetService, DynamicPropertiesService, EndPointService, LiveClipResourceFactory, ModalService, NotificationService, PackageActionService, PackageLiveClipViewService, PackageMediaService, PackageResourceFactory, PackageUtilService, PartnerPackagesService, PermissionsService, UtilsService) {
    var liveClippingMediaUrl = EndPointService.liveClippingMediaUrl;
    var webProxyMp4Url = EndPointService.webProxyMp4Url;
    var proxyUrl = EndPointService.proxyUrl;
    var PACKAGE_AD_HOC_ADD_PARTNERS_VIEW_STATE = 'PACKAGE_AD_HOC_ADD_PARTNERS_VIEW_STATE';
    var ADVANCED_LIVE_CLIP_PACKAGE_DISTRIBUTIONGRID_VIEW_STATE = 'ADVANCED_LIVE_CLIP_PACKAGE_DISTRIBUTIONGRID_VIEW_STATE';
    var self = this, defaultMediaPath = liveClippingMediaUrl, sidebarWidth = 235, editContainerPadding = 30, playerContainerPercent = 0.5, playerContainerPadding = 40;
    var windowElement = angular.element($window);
    var clipPlaying = null;
    var resumePlaybackAfterScheduleChange = false;
    var clipToEdit;
    var confirmingFeedSwitch = false;
    var createThumbnailAfterScheduleChange = false;
    self.loading = false;
    PackageLiveClipViewService.packageObject = self.packageObject;
    self.packageContent = null;
    self.updateFeedLabel = false;
    self.clipInEdit = null;
    self.clips = [];
    self.draftClips = [];
    self.feedScheduleMap = {};
    self.partnerPackages = [];
    self.totalDuration = PackageLiveClipViewService.totalDuration;
    self.activeEditTabs = {
        metadata: false,
        distribution: false,
        advanced: false,
        roles: false,
        prepostRolls: false
    };
    self.currentPlayheadTime = null;
    self.draftClipMode = false;
    self.vodMode = false;
    self.showClipsLoading = false;
    self.clipSearch = { includeDelivered: true };
    self.selectedClipArray = [];
    self.selectedDraftClipArray = [];
    self.selectAllFlag = false;
    var calcPlayerWidth = function () {
        var windowWidth = $window.innerWidth;
        var containerWidth = windowWidth - sidebarWidth - editContainerPadding;
        return containerWidth * playerContainerPercent - playerContainerPadding;
    };
    self.props = {
        width: calcPlayerWidth(),
        markIn: null,
        markOut: null,
        crossOrigin: 'anonymous',
        tracks: [],
        enableNLEHotKeys: true,
        maxPlaybackRate: 6
    };
    var calculateDuration = function () {
        var duration = (new Date(PackageLiveClipViewService.currentSchedule.stopTime).getTime() - new Date(PackageLiveClipViewService.currentSchedule.startTime).getTime()) / 60000;
        var extendBefore = parseInt(self.packageObject.content.extendBefore) || 0;
        var extendAfter = parseInt(self.packageObject.content.extendAfter) || 0;
        return (duration + extendBefore + extendAfter) * 60;
    };
    var resetActive = function () {
        self.activeEditTabs.metadata = self.activeEditTabs.distribution = self.activeEditTabs.advanced = self.activeEditTabs.roles = self.activeEditTabs.prepostRolls = false;
    };
    var setLoading = function (isLoading) {
        $scope.$emit('server-busy', { working: isLoading });
        self.loading = isLoading;
    };
    var getEditClipData = function (clip) {
        setLoading(true);
        return PackageLiveClipViewService.getEditClipData(clip).then(function () {
            self.clipInEdit = PackageLiveClipViewService.viewModel.clipInEdit;
            if (self.clipInEdit.clipStartOffset > -1 && self.clipInEdit.clipEndOffset > -1) {
                self.props.markIn = self.clipInEdit.clipStartOffset;
                self.props.markOut = self.clipInEdit.clipEndOffset;
            }
            self.props.editMode = true;
            resetActive();
            self.activeEditTabs.metadata = true;
            if (clipToEdit) {
                clipToEdit = null;
            }
            else if (!self.draftClipMode) {
                $window.liveClippingVideoPlayer.seek(self.clipInEdit.clipStartOffset);
            }
            else {
                $window.liveClippingVideoPlayer.pause();
            }
            self.partnerPackages = PartnerPackagesService.partnerPackages();
            setLoading(false);
        });
    };
    /**
     * This is a hack for now to programattically click the thumbnail button until the player has exposed an API for
     * us to generate a temporary thumbnail based on a timecode.
     */
    var generateNewThumbnail = function () {
        $window.liveClippingVideoPlayer.seek(self.clipInEdit.clipImageOffset);
        $interval(function () {
            var evt = new Event('click', { 'view': window, 'bubbles': true, 'cancelable': true });
            document.getElementById('thumbnailBtn').dispatchEvent(evt);
            createThumbnailAfterScheduleChange = false;
            setLoading(false);
            $window.liveClippingVideoPlayer.seek(self.clipInEdit.clipStartOffset);
        }, 1000, 1);
    };
    var handleStreamStatusEvent = function (e) {
        self.streamExists = e.originalEvent.detail.exists;
        if (self.streamExists) {
            windowElement.off('streamStatus');
            // Calling play then pause will cause the player to properly initialize so that seeking to clips works
            $window.liveClippingVideoPlayer.play();
            if (!self.currentFeed.isLive) {
                // Keep pre-recorded clips from auto-playing if
                // no stream was previously loaded in the player
                $window.liveClippingVideoPlayer.seek(0.0);
            }
            $window.liveClippingVideoPlayer.pause();
            var now = new Date();
            var recordStart = new Date(self.record.startTime);
            var recordEnd = new Date(self.record.stopTime);
            if (now.getTime() >= recordStart.getTime() && now.getTime() <= recordEnd.getTime()) {
                NotificationService.createInfoNotification('Live Event started for current Package!');
            }
            if (clipToEdit) {
                setLoading(false);
                getEditClipData(clipToEdit);
            }
            else if (self.clipInEdit.clipStartOffset && !createThumbnailAfterScheduleChange) {
                setLoading(false);
                $window.liveClippingVideoPlayer.seek(self.clipInEdit.clipStartOffset);
            }
            else if (createThumbnailAfterScheduleChange) {
                //This is needed so the player actually has loaded the video, otherwise a thumbnail will be generated
                // based on the first frame
                $interval(generateNewThumbnail, 5000, 1);
            }
            if (resumePlaybackAfterScheduleChange) {
                $window.liveClippingVideoPlayer.play();
            }
        }
    };
    var setPlayerPropsFromPrimaryVideo = function () {
        var videoPath = PackageLiveClipViewService.switchToPrimaryVideoFeed();
        var textTracks = PackageLiveClipViewService.setAvailableTextTracks();
        return $q.all({ path: videoPath, tracks: textTracks }).then(function (videoData) {
            self.streamExists = true;
            self.props.markIn = null;
            self.props.markOut = null;
            self.props.mimeType = 'video/mp4';
            self.props.sourcePath = webProxyMp4Url + '/' + videoData.path;
            self.props.editMode = false;
            self.props.framerate = parseFloat(self.currentFeed.framerate);
            self.props.tracks = videoData.tracks;
            self.props.dropFrame = false;
            if (clipToEdit) {
                setLoading(false);
                getEditClipData(clipToEdit);
            }
            return videoData.path;
        });
    };
    var createLiveClip = function (clipData) {
        setLoading(true);
        clipData.name = PackageLiveClipViewService.createInitialLiveClipName();
        PackageLiveClipViewService.createNewClip(clipData).then(function () {
            setLoading(false);
            NotificationService.createSuccessNotification('Clip was succesfully saved.', 2000);
        });
    };
    var updateClip = function () {
        setLoading(true);
        PackageLiveClipViewService.onSave().then(function () {
            self.exitEditClipMode();
            NotificationService.createSuccessNotification('Clip was succesfully updated.', 2000);
            self.editorForm.$setPristine();
            setLoading(false);
        });
    };
    var handleUpdateForDeliveredClip = function (clip) {
        function confirmResetHandler() {
            setLoading(true);
            $q.all({
                savePromise: PackageLiveClipViewService.onSave().$promise,
                resetPromise: PackageLiveClipViewService.resetClip().$promise
            }).then(function () {
                self.exitEditClipMode();
                NotificationService.createSuccessNotification('Clip was succesfully updated and reset.', 2000);
                self.editorForm.$setPristine();
                setLoading(false);
            });
        }
        function cancelHandler() {
            self.props.markIn = self.clipInEdit.clipStartOffset;
            self.props.markOut = self.clipInEdit.clipEndOffset;
            self.props.editMode = true;
        }
        if (PackageLiveClipViewService.requiresResetAfterSave() && self.streamExists) {
            ModalService.showMessageModal({
                messageText: 'Are you sure you want to update a delivered clip\'s mark points?\n' +
                    'Clip media will be recaptured and the clip\'s status reset to DRAFT.',
                title: 'Confirm Clip Reset',
                windowClass: 'confirm-modal-sm',
                showOK: true,
                pullCancelLeft: true
            }, confirmResetHandler, cancelHandler);
        }
        else {
            self.onSave();
        }
    };
    var getClipList = function () {
        return self.draftClipMode ? self.draftClips : self.clips;
    };
    var getSelectionArray = function () {
        return self.draftClipMode ? self.selectedDraftClipArray : self.selectedClipArray;
    };
    var clipSelectionChanged = function () {
        PackageActionService.selectedPackages = angular.copy(getSelectionArray());
        PackageActionService.handleEditView('clip');
    };
    var selectClipInEdit = function (clip) {
        getSelectionArray().splice(0, getSelectionArray().length);
        getSelectionArray().push(clip);
        self.selectAllFlag = false;
        clipSelectionChanged();
    };
    var getSelectionIndex = function (clip) {
        for (var idx = 0; idx < getSelectionArray().length; idx++) {
            if (clip.id === getSelectionArray()[idx].id) {
                return idx;
            }
        }
        return -1;
    };
    var updateSelectionArray = function (viewModel) {
        var clipList = self.draftClipMode ? viewModel.draftClips : viewModel.clips;
        var newClipsMap = {};
        angular.forEach(clipList, function (clip) {
            newClipsMap[clip.id] = clip;
        });
        var selectionArray = getSelectionArray();
        for (var idx = 0; idx < selectionArray.length; idx++) {
            var clipId = selectionArray[idx].id;
            if (clipId in newClipsMap) {
                selectionArray[idx] = angular.copy(newClipsMap[clipId]);
            }
            else {
                selectionArray.splice(idx, 1);
            }
        }
        if (selectionArray.length < clipList.length) {
            self.selectAllFlag = false;
        }
        clipSelectionChanged();
    };
    var clearSelectedClips = function () {
        self.selectedClipArray = [];
        self.selectedDraftClipArray = [];
        clipSelectionChanged();
    };
    var setDataFromViewModel = function (viewModel) {
        updateSelectionArray(viewModel);
        self.perms = viewModel.perms;
        self.record = viewModel.record || {};
        self.clips = viewModel.clips;
        self.draftClips = viewModel.draftClips;
        self.totalDuration = viewModel.totalClipsDuration;
        self.clipInEdit = viewModel.clipInEdit;
        self.feedScheduleMap = viewModel.feedScheduleMap;
        self.availableFeeds = viewModel.availableFeeds;
        self.deliveryProgressMap = viewModel.deliveryProgressMap;
        if (!confirmingFeedSwitch) {
            self.currentFeed = viewModel.currentFeed;
        }
        self.showClipsLoading = viewModel.showClipsLoading;
    };
    var handleThumbnailUpload = function (thumbnailObject) {
        if (self.clipInEdit.id) {
            self.editorForm.$setDirty();
        }
        self.clipInEdit.clipThumbnailData = null;
        self.clipInEdit.clipImageOffset = null;
        self.clipInEdit.tempThumbnail = null;
        self.clipInEdit.imageTimeCode = null;
        self.clipInEdit.thumbnailObject = thumbnailObject;
    };
    self.setPlayerPropsFromRecord = function (record) {
        windowElement.on('streamStatus', handleStreamStatusEvent);
        self.props.sourcePath = defaultMediaPath + '/' + record.directory + '/stream/hls.m3u8';
        self.props.editMode = false;
        self.props.framerate = record.framerate;
        self.props.duration = calculateDuration();
        self.props.tracks = [];
        self.props.dropFrame = true;
        self.props.autoLevelCapping = 2;
    };
    var switchCurrentSchedule = function () {
        confirmingFeedSwitch = false;
        PackageLiveClipViewService.viewModel.currentFeed = self.currentFeed;
        if (self.currentFeed && self.currentFeed.isLive) {
            resumePlaybackAfterScheduleChange = $window.player.isPlaying();
            self.props.sourcePath = '';
            return PackageLiveClipViewService.switchCurrentSchedule().then(function (recordData) {
                self.props.duration = calculateDuration();
                if (!self.clipInEdit.id) {
                    self.props.markIn = null;
                    self.props.markOut = null;
                    self.clipInEdit = PackageLiveClipViewService.viewModel.clipInEdit = {};
                    self.setPlayerPropsFromRecord(recordData);
                    setLoading(false);
                }
                else {
                    PackageUtilService.editorForm.$setDirty();
                    if (self.clipInEdit.clipImageOffset) {
                        createThumbnailAfterScheduleChange = true;
                    }
                    self.setPlayerPropsFromRecord(recordData);
                }
                return recordData;
            });
        }
        else if (self.packageObject.primaryVideo && self.packageObject.primaryVideo.proxyId) {
            self.props.sourcePath = '';
            if (self.clipInEdit.id) {
                PackageUtilService.editorForm.$setDirty();
            }
            return setPlayerPropsFromPrimaryVideo();
        }
        else {
            return $q.when(true);
        }
    };
    var switchToClipFeed = function (clip) {
        self.streamExists = false;
        $window.liveClippingVideoPlayer.pause();
        if (clip.liveRecordId) {
            return PackageLiveClipViewService.switchToClipFeed(clip).then(function (record) {
                self.setPlayerPropsFromRecord(record);
            });
        }
        else {
            self.currentFeed = self.availableFeeds.filter(function (feed) {
                return !feed.isLive;
            })[0];
            return switchCurrentSchedule();
        }
    };
    var switchToClipFeedAndEditClip = function (clip) {
        clipToEdit = clip;
        return switchToClipFeed(clip);
    };
    windowElement.on('createClipEvent', function (e) {
        var clip = e.originalEvent.detail;
        if (self.draftClips.length) {
            self.showSelectDraftClipModal();
        }
        else if (self.currentFeed.isLive) {
            createLiveClip(clip);
        }
        else {
            self.createPreRecordedClip();
        }
    });
    windowElement.on('updateClipEvent', function (e) {
        var clip = e.originalEvent.detail;
        if (self.clipInEdit.packageData.revision > 1) {
            handleUpdateForDeliveredClip(clip);
        }
        else {
            updateClip();
        }
    });
    windowElement.on('timeUpdate', function (e) {
        self.currentPlayheadTime = e.originalEvent.detail.progress;
        if (clipPlaying && self.currentPlayheadTime >= clipPlaying.clipEndOffset) {
            $window.liveClippingVideoPlayer.pause();
            var clipEndOffset = clipPlaying.clipEndOffset;
            clipPlaying = null;
            $window.liveClippingVideoPlayer.seek(clipEndOffset);
        }
    });
    windowElement.on('markIn', function (e) {
        var newMarkIn = e.originalEvent.detail.markIn;
        var dropFrame = self.currentFeed.isLive;
        if (self.props.editMode && self.clipInEdit.clipStartOffset !== newMarkIn && !isNaN(newMarkIn)) {
            self.editorForm.$setDirty();
        }
        self.clipInEdit.clipStartOffset = newMarkIn;
        self.clipInEdit.markInTimeCode = timecodeFromSecFilter(self.clipInEdit.clipStartOffset, self.props.framerate, dropFrame);
        clipPlaying = null;
        if (self.clipInEdit.clipEndOffset) {
            self.clipInEdit.clipDuration = timecodeFromSecFilter(self.clipInEdit.clipEndOffset - self.clipInEdit.clipStartOffset, self.props.framerate, dropFrame);
        }
        _.defer(function () { $scope.$apply(); });
    });
    windowElement.on('markOut', function (e) {
        var newMarkOut = e.originalEvent.detail.markOut;
        var dropFrame = self.currentFeed.isLive;
        if (self.props.editMode && self.clipInEdit.clipEndOffset !== newMarkOut && !isNaN(newMarkOut)) {
            self.editorForm.$setDirty();
        }
        self.clipInEdit.clipEndOffset = newMarkOut;
        self.clipInEdit.markOutTimeCode = timecodeFromSecFilter(self.clipInEdit.clipEndOffset, self.props.framerate, dropFrame);
        clipPlaying = null;
        self.clipInEdit.clipDuration = timecodeFromSecFilter(self.clipInEdit.clipEndOffset - self.clipInEdit.clipStartOffset, self.props.framerate, dropFrame);
        _.defer(function () { $scope.$apply(); });
    });
    windowElement.on('createThumbnail', function (e) {
        if (e.originalEvent.detail.source === 'thumbnailBtn') {
            var offsetTime = self.currentPlayheadTime;
            var dropFrame = self.currentFeed.isLive;
            if (self.props.editMode && self.clipInEdit.clipImageOffset !== offsetTime) {
                self.editorForm.$setDirty();
            }
            self.clipInEdit.tempThumbnail = e.originalEvent.detail.thumbnail;
            self.clipInEdit.clipImageOffset = offsetTime;
            self.clipInEdit.imageTimeCode = timecodeFromSecFilter(offsetTime, self.props.framerate, dropFrame);
            _.defer(function () { $scope.$apply(); });
        }
    });
    self.updateSchedules = function (recordMap) {
        setLoading(true);
        PackageLiveClipViewService.updateSchedule(recordMap).then(function () {
            setLoading(false);
        });
    };
    self.stopCancelRecord = function (event, record) {
        event.preventDefault();
        event.stopImmediatePropagation();
        setLoading(true);
        PackageLiveClipViewService.stopCancelRecord(record).then(function () {
            NotificationService.clearTimedNotifications();
            setLoading(false);
        });
    };
    self.getClipFeed = PackageLiveClipViewService.getClipFeed;
    self.editClip = function (clip) {
        PackageUtilService.tabLoadDataFunction = function () {
            getEditClipData(clip);
        };
        selectClipInEdit(clip);
        $location.search('livePackageId', clip.id);
        setLoading(true);
        if (!self.draftClipMode && clip.liveRecordId && self.record.id !== parseInt(clip.liveRecordId)) {
            switchToClipFeedAndEditClip(clip);
        }
        else if (!self.draftClipMode && !clip.liveRecordId && self.currentFeed && self.currentFeed.isLive) {
            switchToClipFeedAndEditClip(clip);
            getEditClipData(clip);
        }
        else {
            getEditClipData(clip);
        }
    };
    self.onCloseClipEdit = function () {
        if (self.metadataForm.$dirty || self.collaboratorsForm.$dirty || self.distributionForm.$dirty ||
            self.advancedForm.$dirty || PackageUtilService.editorForm.$dirty) {
            var message = 'You have unsaved changes.  Please save or revert.';
            NotificationService.createWarningNotification(message, '');
        }
        else {
            setLoading(true);
            self.exitEditClipMode();
        }
    };
    self.exitEditClipMode = function () {
        clearSelectedClips();
        $location.search('livePackageId', null);
        return PackageLiveClipViewService.exitEditClipMode().then(function () {
            self.props.editMode = false;
            self.props.markIn = NaN;
            self.props.markOut = NaN;
            clipPlaying = null;
            setLoading(false);
            PackageUtilService.tabLoadDataFunction = PackageLiveClipViewService.refreshClips;
        });
    };
    self.acceptClip = function (clip) {
        function acceptWithDelivery(skipNotification) {
            setLoading(true);
            PackageLiveClipViewService.acceptClip(clip, true).then(function () {
                setLoading(false);
                if (skipNotification === true) {
                    return;
                }
                NotificationService.createSuccessNotification('Clip media will be ingested and delivered.', 2000);
            });
        }
        function acceptWithoutDelivery() {
            setLoading(true);
            PackageLiveClipViewService.acceptClip(clip, false).then(function () {
                setLoading(false);
                NotificationService.createSuccessNotification('Clip media will be recaptured but NOT delivered.', 2000);
            });
        }
        if (clip.autoDeliver) {
            // A new clip was accepted
            acceptWithDelivery(true);
        }
        else {
            // An already-delivered clip was accepted
            ModalService.showMessageModal({
                messageText: 'Clip media will be recaptured.\n' +
                    'Would you like to deliver the clip?',
                title: 'Confirm Clip Redelivery',
                windowClass: 'confirm-modal-sm',
                showOK: true,
                okText: 'Yes',
                cancelText: 'No',
                pullCancelLeft: false
            }, acceptWithDelivery, acceptWithoutDelivery);
        }
    };
    self.formattedStatus = function () {
        return self.record.status.charAt(0).toUpperCase() + self.record.status.slice(1);
    };
    self.getAssetURL = function (clip) {
        if (clip.tempThumbnail) {
            return clip.tempThumbnail;
        }
        else if (clip.thumbnailObject && clip.thumbnailObject.data) {
            return clip.thumbnailObject.data;
        }
        else if (clip.liveClipTempThumbnailPath) {
            return proxyUrl + '/' + clip.liveClipTempThumbnailPath;
        }
        else if (clip.primaryImage && clip.primaryImage.proxyPath) {
            return proxyUrl + '/' + clip.primaryImage.proxyPath;
        }
        else if (clip.clipThumbnailData) {
            return clip.clipThumbnailData;
        }
        else {
            return 'assets/images/no-proxy-16x9.png';
        }
    };
    self.activateEditTab = function (editTab) {
        resetActive();
        self.activeEditTabs[editTab] = true;
    };
    self.collaboratorDeleteInvalid = function () {
        return PackageUtilService.tabDeleteInvalid();
    };
    self.statusAllowsEdit = function (clip) {
        return PackageUtilService.statusAllowsEdit(clip.status);
    };
    self.showClipEditButton = function (clip) {
        var userCanEdit = PermissionsService.isAdmin() || ((clip.lockedBy) ? self.perms.userId === clip.lockedBy.id : true);
        return PackageUtilService.statusAllowsEdit(clip.status) && userCanEdit;
    };
    self.disableClipAccept = function (clip) {
        return self.clipHasErrors(clip) || !!clip.lockedBy || (!clip.clipImageOffset && !clip.primaryImage) || clip.hidden;
    };
    self.showScheduleModal = function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!self.scheduleButtonDisabled()) {
            PackageUtilService.showClipScheduler();
        }
    };
    self.scheduleButtonDisabled = function () {
        return !PermissionsService.isAdmin();
    };
    $scope.$watch(function () {
        return self.editorForm;
    }, function (newValue) {
        if (newValue) {
            PackageUtilService.editorForm = self.editorForm;
        }
    });
    $scope.$watchCollection(function () {
        return [self.metadataForm, self.collaboratorsForm, self.distributionForm, self.advancedForm];
    }, function (newValue) {
        if (PackageLiveClipViewService.metadataForm !== newValue[0]) {
            PackageLiveClipViewService.metadataForm = newValue[0];
        }
        if (PackageLiveClipViewService.collaboratorsForm !== newValue[1]) {
            PackageLiveClipViewService.collaboratorsForm = newValue[1];
        }
        if (PackageLiveClipViewService.distributionForm !== newValue[2]) {
            PackageLiveClipViewService.distributionForm = newValue[2];
        }
        if (PackageLiveClipViewService.advancedForm !== newValue[3]) {
            PackageLiveClipViewService.advancedForm = newValue[3];
        }
        if (((self.metadataForm && self.metadataForm.$dirty) ||
            (self.collaboratorsForm && self.collaboratorsForm.$dirty) ||
            (self.distributionForm && self.distributionForm.$dirty) ||
            (self.advancedForm && self.advancedForm.$dirty)) && PackageUtilService.editorForm) {
            PackageUtilService.editorForm.$setDirty();
        }
        else if (PackageUtilService.editorForm) {
            PackageUtilService.editorForm.$setPristine();
        }
    }, true);
    $scope.$on('$destroy', function () {
        if (self.clipInEdit && self.clipInEdit.id) {
            self.exitEditClipMode();
        }
        $location.search('livePackageId', null);
        windowElement.off('createClipEvent');
        windowElement.off('updateClipEvent');
        windowElement.off('timeUpdate');
        windowElement.off('markIn');
        windowElement.off('markOut');
        windowElement.off('createThumbnail');
        windowElement.off('streamStatus');
        $window.player.off('play');
        $window.player.off('pause');
        PackageLiveClipViewService.cleanup();
        self.props = null;
        PackageUtilService.postCloseUpdate = null;
    });
    self.checkSave = function () {
        if (self.clipInEdit.packageData.revision > 1) {
            var clipData = {
                markIn: self.clipInEdit.clipStartOffset,
                markOut: self.clipInEdit.clipEndOffset
            };
            handleUpdateForDeliveredClip(clipData);
        }
        else {
            self.onSave();
        }
    };
    // Clip package edit
    self.onSave = function () {
        setLoading(true);
        PackageLiveClipViewService.onSave({}, false, false).then(function (saveData) {
            self.exitEditClipMode();
        });
    };
    self.onRevert = function () {
        var deferred = $q.defer();
        if ((self.clipInEdit.liveRecordId && self.record.id !== parseInt(self.clipInEdit.liveRecordId)) ||
            (!self.clipInEdit.liveRecordId && self.currentFeed.isLive)) {
            switchToClipFeedAndEditClip(self.clipInEdit.packageData).then(function () {
                deferred.resolve(true);
            });
        }
        else {
            deferred.resolve(true);
        }
        deferred.promise.then(function () {
            PackageLiveClipViewService.revertData();
            getEditClipData(self.clipInEdit).then(function () {
                self.goToIn();
            });
        });
    };
    self.toolBarDisabled = function () {
        if (!self.metadataForm || !self.collaboratorsForm || !self.distributionForm || !self.advancedForm) {
            return true;
        }
        return self.metadataForm.$pristine &&
            self.collaboratorsForm.$pristine &&
            self.distributionForm.$pristine &&
            self.advancedForm.$pristine &&
            PackageUtilService.editorForm.$pristine;
    };
    self.disableTab = function (tabName) {
        return !self.activeEditTabs[tabName] && PackageUtilService.editorForm && !PackageUtilService.editorForm.$pristine;
    };
    self.clipHasErrorsWarnings = function (clip) {
        for (var i = 0; clip.validationResult && i < clip.validationResult.length; i++) {
            if ((clip.validationResult[i].errors && clip.validationResult[i].errors.length) || (clip.validationResult[i].warnings && clip.validationResult[i].warnings.length)) {
                return true;
            }
        }
        return false;
    };
    self.clipHasErrors = function (clip) {
        for (var i = 0; i < clip.validationResult.length; i++) {
            if (clip.validationResult[i].errors && clip.validationResult[i].errors.length) {
                return true;
            }
        }
        return false;
    };
    self.showErrorsAndWarningsForClip = function (clip) {
        ModalService.showErrorsWarningsModal(clip.validationResult, clip.title);
    };
    PackageUtilService.showClipScheduler = function () {
        ModalService.showLiveClipScheduleModal(self.packageObject, PackageLiveClipViewService.viewModel.currentFeed, self.availableFeeds, self.stopCancelRecord, self.updateSchedules);
    };
    self.createNewClip = function (newClip, isDraftClip) {
        setLoading(true);
        clearSelectedClips();
        PackageLiveClipViewService.createNewClip(newClip, isDraftClip).then(function () {
            var notificationMessage;
            if (newClip.numberOfClips > 1) {
                notificationMessage = ' Clips \'' + newClip.title + '\' were succesfully created.';
            }
            else {
                notificationMessage = 'Clip \'' + newClip.title + '\' was succesfully created.';
            }
            setLoading(false);
            NotificationService.createSuccessNotification(notificationMessage, 2000);
        });
    };
    self.createPreRecordedClip = function () {
        self.createNewClip({
            name: PackageLiveClipViewService.createInitialClipName()
        }, false);
    };
    self.showCreateDraftClipModal = function () {
        ModalService.showCreateClipModal(function (draftClip) {
            self.createNewClip(draftClip, true);
        });
    };
    self.handleDraftClipCancel = function () {
        self.props.markIn = self.clipInEdit.clipStartOffset;
        self.props.markOut = self.clipInEdit.clipEndOffset;
    };
    self.assignMarkPointsToDraftClip = function (draftClip) {
        setLoading(true);
        PackageLiveClipViewService.assignMarkPointsToDraftClip(draftClip).then(function () {
            self.exitEditClipMode();
            setLoading(false);
        });
    };
    self.showSelectDraftClipModal = function () {
        self.props.markIn = null;
        self.props.markOut = null;
        ModalService.showSelectDraftClipModal(self.draftClips, self.assignMarkPointsToDraftClip, self.handleDraftClipCancel);
    };
    self.removeDraftClip = function (draftClip) {
        function confirmResult() {
            setLoading(true);
            PackageLiveClipViewService.removeDraftClip(draftClip).then(function () {
                setLoading(false);
            });
        }
        ModalService.showMessageModal({
            messageText: 'Are you sure you want to remove draft clip ' + draftClip.title + '?',
            pullCancelLeft: true,
            title: 'Remove Draft Clip',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, confirmResult);
    };
    self.goToIn = function (event) {
        if (event) {
            event.currentTarget.blur();
        }
        $window.liveClippingVideoPlayer.seek(self.clipInEdit.clipStartOffset);
    };
    self.goToImage = function (event) {
        event.currentTarget.blur();
        $window.liveClippingVideoPlayer.seek(self.clipInEdit.clipImageOffset);
    };
    self.goToOut = function (event) {
        event.currentTarget.blur();
        $window.liveClippingVideoPlayer.seek(self.clipInEdit.clipEndOffset);
    };
    self.playClip = function (event, clip) {
        if (event) {
            event.currentTarget.blur();
        }
        if (!clip) {
            clip = self.clipInEdit;
        }
        $window.liveClippingVideoPlayer.seek(clip.clipStartOffset);
        $window.liveClippingVideoPlayer.play();
        clipPlaying = clip;
    };
    self.onMarkInChange = function () {
        var dropFrame = self.currentFeed.isLive;
        self.props.markIn = secFromTimecodeFilter(self.clipInEdit.markInTimeCode, self.props.framerate, dropFrame);
        self.props.markOut = null;
    };
    self.onMarkOutChange = function () {
        var dropFrame = self.currentFeed.isLive;
        var updateMarkOut = secFromTimecodeFilter(self.clipInEdit.markOutTimeCode, self.props.framerate, dropFrame);
        if (updateMarkOut > 0) {
            self.props.markOut = updateMarkOut;
            self.props.markIn = null;
            $window.liveClippingVideoPlayer.seek(updateMarkOut);
        }
    };
    self.searchClips = function (clip) {
        if (!self.clipSearch.text) {
            return self.clipSearch.includeDelivered || clip.status !== 'DELIVERED';
        }
        return ((clip.title && clip.title.toLowerCase().indexOf(self.clipSearch.text.toLowerCase()) !== -1) ||
            (clip.name && clip.name.toLowerCase().indexOf(self.clipSearch.text.toLowerCase()) !== -1)) &&
            (self.clipSearch.includeDelivered || clip.status !== 'DELIVERED');
    };
    self.addAdHocSubscription = function () {
        PackageUtilService.tabAdHocPartnerFunction();
    };
    self.clipCollaboratorsChanged = function () {
        self.collaboratorsForm.$setDirty();
    };
    var markPointsSet = function () {
        return !self.clipInEdit.id && (self.clipInEdit.markInTimeCode || self.clipInEdit.markOutTimeCode || self.clipInEdit.imageTimeCode);
    };
    self.selectScheduleForFeed = function () {
        function revertFeedSwitch() {
            confirmingFeedSwitch = false;
            self.currentFeed = PackageLiveClipViewService.viewModel.currentFeed;
        }
        function confirmFeedSwitch() {
            switchCurrentSchedule().then(function () {
                setLoading(false);
            });
        }
        if (markPointsSet()) {
            confirmingFeedSwitch = true;
            ModalService.showMessageModal({
                messageText: 'Are you sure you want to switch feeds?\nWARNING - The current mark-in/mark-out and image timecodes will be reset.',
                title: 'Confirm Switch Feed',
                windowClass: 'confirm-modal-sm',
                showOK: true,
                pullCancelLeft: true
            }, confirmFeedSwitch, revertFeedSwitch);
        }
        else {
            setLoading(true);
            confirmFeedSwitch();
        }
    };
    self.unlockClip = PackageLiveClipViewService.unlockClip;
    self.preventClickInDraftMode = function (event) {
        if ((self.draftClipMode && self.clipInEdit.id) || !self.streamExists) {
            event.preventDefault();
            event.stopImmediatePropagation();
            event.stopPropagation();
        }
    };
    self.isClipSelected = function (clip) {
        return getSelectionIndex(clip) >= 0;
    };
    self.toggleDraftClipMode = function () {
        self.selectedClipArray = [];
        self.selectedDraftClipArray = [];
        self.selectAllFlag = false;
        self.draftClipMode = !self.draftClipMode;
        self.props.enableKeyboardShortcuts = !self.draftClipMode;
    };
    self.selectClipCheckboxClicked = function (clip, event) {
        if (!self.draftClipMode) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
        var idx = getSelectionIndex(clip);
        if (idx < 0) {
            getSelectionArray().push(angular.copy(clip));
        }
        else {
            getSelectionArray().splice(idx, 1);
        }
        self.selectAllFlag = false;
        clipSelectionChanged();
    };
    self.selectAllClicked = function () {
        var clipList = getClipList();
        getSelectionArray().splice(0, getSelectionArray().length);
        if (self.selectAllFlag) {
            angular.forEach(clipList, function (clip) {
                getSelectionArray().push(clip);
            });
        }
        clipSelectionChanged();
    };
    self.openCompletedDeliveriesModal = function (clip) {
        // setLoading(true);
        ModalService.showCompletedDeliveriesModal(clip);
    };
    self.showNoImageErrorIcon = function () {
        return !!self.clipInEdit.id && self.getAssetURL(self.clipInEdit) === 'assets/images/no-proxy-16x9.png';
    };
    self.openFileUploadModal = function () {
        var imageUploadAcceptTemplate = { acceptProfile: { fileExtensions: ['png', 'PNG'], height: '', width: '' } };
        // Live Feeds always require a 1280x720 thumbnail, for non-live we'll use the Main Video dimensions
        if (self.currentFeed.isLive) {
            imageUploadAcceptTemplate.acceptProfile.height = '720';
            imageUploadAcceptTemplate.acceptProfile.width = '1280';
        }
        else {
            imageUploadAcceptTemplate.acceptProfile.height = self.currentFeed.height;
            imageUploadAcceptTemplate.acceptProfile.width = self.currentFeed.width;
        }
        ModalService.showFileUploadModal([imageUploadAcceptTemplate], 'image', handleThumbnailUpload);
    };
    self.canDownloadProxy = function () {
        return !!self.packageObject && !!self.packageObject.primaryVideo && !!self.packageObject.primaryVideo.proxyId &&
            !!self.currentFeed && !self.currentFeed.isLive && !!self.perms && !!self.perms.downloadProxy &&
            PermissionsService.hasReadWritePermission(parseInt(self.perms.downloadProxy.permission));
    };
    self.downloadMainProxy = function () {
        var proxyFileName = PackageMediaService.generatePackageDownloadFilenamePrefix(self.packageObject, false) +
            'video_proxy.' + UtilsService.getFileExtension(self.packageObject.primaryVideo.proxyPath);
        DownloadAssetService.downloadAsset(self.packageObject.primaryVideo.proxyId, proxyFileName, DownloadAssetService.AssetType.Video, DownloadAssetService.ContentUse.Proxy);
    };
    var onPlayerLoadedAndReady = function (handler) {
        //
        // TODO
        // 		This works great, but is certainly not clean or elegant.
        //		It's also challenging to unit test properly.
        //
        $window.player.on('ready', function () {
            $window.player.off('ready');
            angular.element('video').on('canplay', function () {
                angular.element('video').off('canplay');
                handler();
            });
        });
    };
    self.clipThumbClicked = function (clip) {
        if (clip.primaryVideo) {
            ModalService.showMediaModal('clip', clip.primaryVideo, clip.id);
        }
        else {
            var clipFeed = PackageLiveClipViewService.getClipFeed(clip);
            if (self.currentFeed !== clipFeed) {
                setLoading(true);
                self.currentFeed = clipFeed;
                onPlayerLoadedAndReady(function () {
                    self.playClip(undefined, clip);
                });
                switchToClipFeed(clip, true).then(function () {
                    setLoading(false);
                });
            }
            else {
                self.playClip(undefined, clip);
            }
        }
    };
    var isOffsetValid = function (offset) {
        return offset !== undefined && offset !== null && !isNaN(offset);
    };
    self.hasMarkIn = function () {
        return isOffsetValid(self.clipInEdit.clipStartOffset);
    };
    self.hasMarkOut = function () {
        return isOffsetValid(self.clipInEdit.clipEndOffset);
    };
    self.hasMarkPoints = function () {
        return self.hasMarkIn() && self.hasMarkOut();
    };
    $scope.$watch(function () {
        return PackageLiveClipViewService.viewModel;
    }, function (viewModel) {
        setDataFromViewModel(viewModel);
    }, true);
    self.getEditData = function () {
        setLoading(true);
        setDataFromViewModel(PackageLiveClipViewService.viewModel);
        var deepLinkClipToEdit = ($location.search().livePackageId) ? PackageResourceFactory.get({ id: $location.search().livePackageId }).$promise : $q.resolve(null);
        deepLinkClipToEdit.then(function (clip) {
            $q.all({
                perms: PackageLiveClipViewService.getPermissions(clip),
                editData: PackageLiveClipViewService.getEditData()
            }).then(function (allData) {
                if (clip) {
                    selectClipInEdit(clip);
                    switchToClipFeedAndEditClip(clip).then(function () {
                        if (!self.currentFeed) {
                            getEditClipData(clipToEdit);
                        }
                        setLoading(false);
                    });
                }
                else if (self.packageObject.primaryVideo && self.packageObject.primaryVideo.proxyId) {
                    setPlayerPropsFromPrimaryVideo().then(function () {
                        setLoading(false);
                    });
                }
                else if (allData.editData && allData.editData.record && allData.editData.record.id) {
                    self.setPlayerPropsFromRecord(allData.editData.record);
                    setLoading(false);
                }
                else {
                    setLoading(false);
                }
                PackageActionService.selectedPackages = getSelectionArray();
            });
        });
    };
    PackageUtilService.tabLoadDataFunction = PackageLiveClipViewService.refreshClips;
    self.getEditData();
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 8/10/15.
 */
'use strict';
angular.module('prism-ui.package').directive('packageLiveclipView', function () {
    return {
        restrict: 'E',
        controller: 'PackageLiveClipViewController',
        controllerAs: 'pkgLiveClip',
        templateUrl: 'package/editor/components/view/liveclip/packageliveclip-view-template.html',
        scope: true,
        bindToController: {
            packageObject: '=',
            categoryValid: '='
        }
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 2/1/16.
 */
'use strict';
angular.module('prism-ui.package').service('PackageLiveClipViewService', function ($filter, $interval, $location, $q, moment, timecodeFromSecFilter, ClipResourceFactory, ContentResourceFactory, DownloadAssetService, DynamicPropertiesService, EndPointService, LiveClipResourceFactory, PackagePropertiesQueryService, PackageResourceFactory, PackageUtilService, PartnerPackagesService, PermissionsService, PreviewQueryService, RecordResourceFactory, SystemMediainfoResource) {
    var self = this, clipsInterval = null, recordInterval = null;
    var PACKAGE_AD_HOC_ADD_PARTNERS_VIEW_STATE = 'PACKAGE_AD_HOC_ADD_PARTNERS_VIEW_STATE';
    var CLIP_TABS_VIEW_STATE = 'PACKAGE_VIDEO_CLIPS_VIEW_STATE';
    var ADVANCED_LIVE_CLIP_PACKAGE_DISTRIBUTIONGRID_VIEW_STATE = 'ADVANCED_LIVE_CLIP_PACKAGE_DISTRIBUTIONGRID_VIEW_STATE';
    var CLIP_COLLABORATORS_VIEW_STATE = 'CLIP_COLLABORATORS_VIEW_STATE';
    var CLIP_DISTRIBUTIONGRID_VIEW_STATE = 'CLIP_DISTRIBUTIONGRID_VIEW_STATE';
    var DOWNLOAD_PROXY_STATE = 'CLIP_ACTION_DOWNLOAD_PROXIES_VIEW_STATE';
    self.originalClipEditData = {};
    self.viewModel = {
        perms: {
            livePerms: false,
            collabPerms: false,
            distPerms: false,
            advancedDistPerms: false,
            adHocPerms: false
        },
        record: null,
        clips: [],
        draftClips: [],
        totalClipsDuration: 0,
        currentFeed: {},
        clipInEdit: {},
        feedScheduleMap: {},
        availableFeeds: [],
        showClipsLoading: false
    };
    self.currentSchedule = {};
    self.categoryTypes = [];
    self.includeHidden = false;
    self.packageMedia = null;
    var filterClipValidationResults = function (validationResult) {
        var valResults = angular.copy(validationResult);
        angular.forEach(valResults, function (result) {
            result.errors = result.errors.filter(function (error) {
                return error.hasOwnProperty('member');
            });
            result.warnings = result.warnings.filter(function (warning) {
                return warning.description.indexOf('Original Release Date') === -1;
            });
        });
        return valResults;
    };
    var setupClips = function (clips) {
        self.viewModel.clips.length = 0;
        self.viewModel.draftClips.length = 0;
        self.viewModel.totalClipsDuration = 0;
        angular.forEach(clips, function (clip) {
            clip.validationResult = filterClipValidationResults(clip.validationResult);
            if (clip.clipStartOffset > -1 && clip.clipEndOffset > -1) {
                clip.clipDuration = clip.clipEndOffset - clip.clipStartOffset;
                self.viewModel.totalClipsDuration += clip.clipDuration;
                self.viewModel.clips.push(clip);
            }
            else {
                self.viewModel.draftClips.push(clip);
            }
        });
    };
    var getClipDeliveryWorkflows = function (parentPackageId) {
        return PackageResourceFactory.deliveryWorkflows({
            id: parentPackageId,
            includeClips: true
        }).$promise.then(function (deliveryList) {
            var deliveryWorkflowMap = {};
            angular.forEach(deliveryList, function (deliveryWorkflow) {
                deliveryWorkflowMap[deliveryWorkflow.packageId] = deliveryWorkflow.deliveryWorkflowProgress;
            });
            return deliveryWorkflowMap;
        });
    };
    self.refreshClips = function () {
        if (!self.packageObject) {
            return;
        }
        self.viewModel.showClipsLoading = true;
        return $q.all({
            clips: PackageResourceFactory.getClips({ id: self.packageObject.id, includeHidden: self.includeHidden }).$promise,
            deliveries: getClipDeliveryWorkflows(self.packageObject.id),
            dynamicProperties: DynamicPropertiesService.queryForProperties()
        }).then(function (resolved) {
            $interval.cancel(clipsInterval);
            self.viewModel.deliveryProgressMap = resolved.deliveries;
            setupClips(resolved.clips);
            clipsInterval = $interval(self.refreshClips, self.getClipRefreshInterval());
            self.viewModel.showClipsLoading = false;
            return resolved.clips;
        });
    };
    var delayedPollForClips = function (promiseToResolve) {
        self.refreshClips().then(function () {
            promiseToResolve.resolve();
        });
    };
    var pollForRecord = function () {
        self.viewModel.record = RecordResourceFactory.get({ id: self.currentSchedule.liveRecordId });
        self.viewModel.record.$promise.then(function (record) {
            if (record.status === 'complete' || record.status === 'error') {
                $interval.cancel(recordInterval);
            }
        });
        return self.viewModel.record.$promise;
    };
    var handleRecordSuccess = function (record) {
        if (record.status !== 'complete' && record.status !== 'error') {
            $interval.cancel(recordInterval);
            recordInterval = $interval(pollForRecord, 30000);
        }
    };
    var createDraftClipName = function (clipTitle) {
        self.draftClipTitle = self.packageObject.content.prefix + ' ' +
            self.packageObject.productionNumber + ' ' +
            clipTitle;
    };
    self.getRecordData = function (recordId) {
        self.viewModel.record = RecordResourceFactory.get({ id: recordId });
        self.viewModel.record.$promise.then(function (recordData) {
            handleRecordSuccess(recordData);
        });
        return self.viewModel.record.$promise;
    };
    self.getClipRefreshInterval = function () {
        return DynamicPropertiesService.getPropValueAsInt('liveClipping.clipRefreshInterval', 10000);
    };
    var getRecordAndClipData = function (recordId) {
        var clipPromise = self.refreshClips();
        var recordPromise = self.getRecordData(recordId);
        return $q.all({ clips: clipPromise, record: recordPromise });
    };
    var buildFeedScheduleMap = function (feeds, schedules) {
        var feedSchedules = {};
        var feed = null;
        var schedule = null;
        for (var i = 0; i < feeds.length; i++) {
            feed = feeds[i];
            for (var j = 0; j < schedules.length; j++) {
                schedule = schedules[j];
                if (feed.id === schedule.showLiveFeedId) {
                    feedSchedules[feed.id] = { feed: feed, schedule: schedule };
                    break;
                }
            }
        }
        return feedSchedules;
    };
    self.setAvailableTextTracks = function () {
        var defaultCCTrack = null;
        if (self.packageMedia && self.packageMedia.cc) {
            defaultCCTrack = self.packageMedia.cc.filter(function (ccMedia) {
                return ccMedia.languageId === self.packageMedia.video[0].languageId &&
                    ccMedia.dropdownLabel.toLowerCase().indexOf('spoken language') > -1;
            })[0];
        }
        if (defaultCCTrack) {
            return DownloadAssetService.getAssetUri(defaultCCTrack.assetId, DownloadAssetService.AssetType.Document, DownloadAssetService.ContentUse.Source).then(function (assetUriData) {
                return [{
                        label: defaultCCTrack.dropdownLabel,
                        source: assetUriData.uri,
                        kind: 'captions'
                    }];
            });
        }
        return $q.when([]);
    };
    self.getPermissions = function (clip) {
        var userPromise = PermissionsService.getCurrentUser();
        var writePromise = PermissionsService.canWrite(CLIP_TABS_VIEW_STATE);
        var collabWritePromise = PermissionsService.canRead(CLIP_COLLABORATORS_VIEW_STATE);
        var distWritePromise = PermissionsService.canRead(CLIP_DISTRIBUTIONGRID_VIEW_STATE);
        var advancedWritePromise = PermissionsService.canRead(ADVANCED_LIVE_CLIP_PACKAGE_DISTRIBUTIONGRID_VIEW_STATE);
        var adHocWritePromise = PermissionsService.canWrite(PACKAGE_AD_HOC_ADD_PARTNERS_VIEW_STATE);
        var downloadViewStatePromise = PermissionsService.getPackagePermissions(DOWNLOAD_PROXY_STATE, self.packageObject.id);
        var allPromise = $q.all({
            user: userPromise,
            livePerms: writePromise,
            collabPerms: collabWritePromise,
            distPerms: distWritePromise,
            advancedDistPerms: advancedWritePromise,
            adHocPerms: adHocWritePromise,
            downloadProxy: downloadViewStatePromise
        });
        allPromise.then(function (perms) {
            self.viewModel.perms.userId = perms.user && perms.user.id;
            self.viewModel.perms.livePerms = perms.livePerms;
            self.viewModel.perms.collabPerms = perms.collabPerms;
            self.viewModel.perms.distPerms = perms.distPerms;
            self.viewModel.perms.advancedDistPerms = perms.advancedDistPerms;
            self.viewModel.perms.adHocPerms = perms.adHocPerms;
            self.viewModel.perms.downloadProxy = perms.downloadProxy[0];
        });
        return allPromise;
    };
    self.feedDropdownLabelFxn = function (feed, feedSchedule, shortLabel) {
        var startTime = '', stopTime = '', feedName = (feed && feed.liveFeed) ? feed.liveFeed.name : '';
        var timeString = '';
        if (!shortLabel && feedSchedule && feedSchedule.startTime && feedSchedule.stopTime) {
            startTime = $filter('amDateFormat')(feedSchedule.startTime, 'MMM DD hh:mm A');
            stopTime = $filter('amDateFormat')(feedSchedule.stopTime, 'hh:mm A');
            timeString = ' ' + startTime + ' - ' + stopTime;
        }
        return feedName + timeString + ((feed.defaultFlag) ? ' (default)' : '');
    };
    self.getEditData = function () {
        var catTypes = PackageResourceFactory.query({ sub: 'categoryTypes' }).$promise;
        var content = ContentResourceFactory.get({ id: self.packageObject.content.id }).$promise;
        var mediaInfo = (self.packageObject.primaryVideo) ? SystemMediainfoResource.get({ id: self.packageObject.primaryVideo.assetId }).$promise : null;
        var pkgMedia = PreviewQueryService.getPackageMedia(self.packageObject.id);
        return $q.all({ content: content, catType: catTypes, media: mediaInfo, pkgMedia: pkgMedia })
            .then(function (editData) {
            self.categoryTypes = editData.catType;
            self.viewModel.availableFeeds = [];
            self.packageMedia = editData.pkgMedia['Main Video'];
            if (self.packageObject.primaryVideo) {
                self.viewModel.availableFeeds.push({
                    label: self.packageObject.primaryVideo.acceptTemplateMember.acceptProfile.name,
                    isLive: false,
                    framerate: editData.media.frameRate,
                    width: editData.media.width,
                    height: editData.media.height
                });
                self.defaultFeed = self.viewModel.availableFeeds[0];
            }
            angular.forEach(self.packageObject.liveRecordSchedules, function (schedule) {
                angular.forEach(editData.content.liveFeeds, function (feed) {
                    if (schedule.showLiveFeedId === feed.id) {
                        var wrappedFeed = {
                            label: self.feedDropdownLabelFxn(feed, schedule),
                            shortLabel: self.feedDropdownLabelFxn(feed, schedule, true),
                            isLive: true,
                            id: feed.id,
                            feedData: feed
                        };
                        if (feed.defaultFlag && !self.defaultFeed) {
                            self.defaultFeed = wrappedFeed;
                        }
                        self.viewModel.availableFeeds.push(wrappedFeed);
                    }
                });
            });
            self.viewModel.currentFeed = self.defaultFeed || self.viewModel.availableFeeds[0];
            if (self.packageObject.liveRecordSchedules && self.packageObject.liveRecordSchedules.length &&
                self.viewModel.currentFeed.isLive) {
                self.viewModel.feedScheduleMap = buildFeedScheduleMap(self.viewModel.availableFeeds, self.packageObject.liveRecordSchedules);
                self.currentSchedule = self.viewModel.feedScheduleMap[self.viewModel.currentFeed.id].schedule;
                return getRecordAndClipData(self.currentSchedule.liveRecordId);
            }
            else {
                return self.refreshClips();
            }
        });
    };
    self.updateSchedule = function (recordMap) {
        var saveFinished = $q.defer();
        var savePromises = {};
        angular.forEach(self.packageObject.liveRecordSchedules, function (schedule) {
            if (schedule.liveRecordOverridden && recordMap[schedule.liveRecordId]) {
                var recordToSave = recordMap[schedule.liveRecordId];
                recordToSave.startTime = schedule.startTime;
                recordToSave.stopTime = schedule.stopTime;
                savePromises[schedule.liveRecordId] = recordToSave.$update();
            }
        });
        savePromises.packageSave = self.packageObject.$save();
        $q.all(savePromises).then(function (savedObjects) {
            self.viewModel.feedScheduleMap = buildFeedScheduleMap(self.viewModel.availableFeeds, self.packageObject.liveRecordSchedules);
            self.updateFeedLabel = true;
            pollForRecord();
            saveFinished.resolve(savedObjects);
        });
        return saveFinished.promise;
    };
    self.stopCancelRecord = function (record) {
        var recordPromise = (record.status === 'running') ? record.$stop() : record.$delete();
        var packageSave = self.packageObject.$save();
        return $q.all([recordPromise, packageSave]).then(function () {
            return pollForRecord();
        });
    };
    var checkIfPackageSaveRequired = function () {
        return self.metadataForm.$dirty || !angular.equals(self.viewModel.clipInEdit, self.originalClipEditData);
    };
    var setClipData = function () {
        self.viewModel.clipInEdit.packageData.clipStartOffset = self.viewModel.clipInEdit.clipStartOffset;
        self.viewModel.clipInEdit.packageData.clipEndOffset = self.viewModel.clipInEdit.clipEndOffset;
        self.viewModel.clipInEdit.packageData.clipImageFromTimecode = !!self.viewModel.clipInEdit.clipImageOffset;
        self.viewModel.clipInEdit.packageData.clipImageOffset = self.viewModel.clipInEdit.clipImageOffset;
        self.viewModel.clipInEdit.packageData.clipThumbnailData = self.viewModel.clipInEdit.tempThumbnail;
        if (self.viewModel.currentFeed && self.viewModel.currentFeed.isLive) {
            self.viewModel.clipInEdit.packageData.liveRecordId = self.viewModel.record.id;
        }
    };
    var savePackageResource = function () {
        return PackageResourceFactory.save({ id: self.viewModel.clipInEdit.packageData.id }, self.viewModel.clipInEdit.packageData).$promise
            .then(function (data) {
            self.viewModel.clipInEdit.packageData = data;
            self.originalClipEditData.packageData = angular.copy(self.viewModel.clipInEdit.packageData);
            PackageUtilService.createErrorsAndWarningsMap(self.viewModel.clipInEdit.packageData.validationResult);
            return data;
        });
    };
    var saveClipPackage = function (isDraftClip, useDraftClip) {
        if (isDraftClip) {
            setClipData();
            return ClipResourceFactory.createDraftClip({
                id: self.viewModel.clipInEdit.packageData.parentPackageId,
                name: self.viewModel.clipInEdit.packageData.name,
                title: self.viewModel.clipInEdit.packageData.title,
                numberOfClips: self.viewModel.clipInEdit.packageData.numberOfClips,
                scheduleId: self.packageObject.liveRecordSchedules.map(function (schedule) {
                    return schedule.id;
                })
            }, self.viewModel.clipInEdit.packageData).$promise
                .then(function (data) {
                self.viewModel.clipInEdit.packageData = data;
                self.originalClipEditData.packageData = angular.copy(self.viewModel.clipInEdit.packageData);
                PackageUtilService.createErrorsAndWarningsMap(self.viewModel.clipInEdit.packageData.validationResult);
                return data;
            });
        }
        else {
            if (useDraftClip) {
                return PackageResourceFactory.get({ id: self.viewModel.clipInEdit.packageData.id }).$promise.then(function (data) {
                    self.viewModel.clipInEdit.packageData = data;
                    setClipData();
                    return savePackageResource();
                });
            }
            else {
                setClipData();
                return savePackageResource();
            }
        }
    };
    var offsetModified = function (propName) {
        var orig = parseFloat(self.originalClipEditData.packageData[propName]);
        //The 'orig' seconds (above) can be rounded to 2-3 decimal places.  The 'current' seconds need to be rounded
        //the same otherwise any clip package save will result in a re-extraction of media.
        var current = parseFloat(self.viewModel.clipInEdit[propName]);
        var currentFormatted = parseFloat(current.toFixed(orig.toString().split('.')[1].length));
        return (orig !== currentFormatted) && !(isNaN(orig) && isNaN(currentFormatted));
    };
    self.requiresResetAfterSave = function () {
        return (offsetModified('clipStartOffset') ||
            offsetModified('clipEndOffset') ||
            offsetModified('clipImageOffset'));
    };
    self.resetClip = function () {
        return ClipResourceFactory.resetClip({ id: self.viewModel.clipInEdit.id });
    };
    self.onSave = function () {
        var distributionData = null, partnerPromise = null, advancedPromise = null, thumbnailPromise = null, advancedData = null, collaboratorsPromise = null, collaboratorsData = null;
        var packagePromise = (checkIfPackageSaveRequired()) ? saveClipPackage() : null;
        if (self.viewModel.clipInEdit.thumbnailObject) {
            thumbnailPromise = self.uploadThumbnail(self.viewModel.clipInEdit.packageData, self.viewModel.clipInEdit.thumbnailObject);
        }
        if (self.collaboratorsForm.$dirty) {
            collaboratorsData = PackageUtilService.subTabSaveFunctions.collaboratorsForm.data();
        }
        if (self.distributionForm.$dirty) {
            distributionData = PackageUtilService.subTabSaveFunctions.distributionForm.data();
        }
        if (self.advancedForm.$dirty) {
            advancedData = PackageUtilService.subTabSaveFunctions.advancedForm.data();
        }
        if (collaboratorsData) {
            collaboratorsPromise = PackageResourceFactory.saveCollaborators({
                id: self.viewModel.clipInEdit.id,
                sub: 'actors'
            }, collaboratorsData).$promise;
        }
        if (distributionData) {
            partnerPromise = PackageResourceFactory.savePartnerPackages({
                id: self.viewModel.clipInEdit.id,
                sub: 'partnerPackages'
            }, distributionData).$promise;
        }
        if (advancedData) {
            advancedPromise = PackageResourceFactory.savePartnerPackages({
                id: self.viewModel.clipInEdit.id,
                sub: 'partnerPackages'
            }, advancedData).$promise;
        }
        var allPromise = $q.all({
            pkg: packagePromise,
            partners: partnerPromise,
            advanced: advancedPromise,
            collaborators: collaboratorsPromise,
            thumbnail: thumbnailPromise
        });
        return allPromise.then(function (data) {
            if (self.distributionForm.$dirty) {
                PackageUtilService.subTabSaveFunctions.distributionForm.callback();
                self.distributionForm.$setPristine();
            }
            else if (self.advancedForm.$dirty) {
                PackageUtilService.subTabSaveFunctions.advancedForm.callback();
                self.advancedForm.$setPristine();
            }
            if (self.collaboratorsForm.$dirty) {
                PackageUtilService.subTabSaveFunctions.collaboratorsForm.callback(data.collaborators);
                self.collaboratorsForm.$setPristine();
            }
            self.viewModel.clipInEdit.thumbnailObject = null;
            self.metadataForm.$setPristine();
            PackageUtilService.editorForm.$setPristine();
        });
    };
    self.uploadThumbnail = function (clipPackage, thumbnailObject) {
        return ClipResourceFactory.uploadThumbnail({ id: clipPackage.id }, thumbnailObject).$promise;
    };
    self.exitEditClipMode = function () {
        var lockPromise = (self.viewModel.clipInEdit.id) ? PackageResourceFactory.removeLock({ id: self.viewModel.clipInEdit.id }).$promise : null;
        return $q.when(lockPromise).then(function () {
            self.viewModel.clipInEdit = {};
            PartnerPackagesService.partnerPackages([]);
            self.originalClipEditData = {};
            return self.refreshClips();
        });
    };
    self.createNewClip = function (clip, draftClip) {
        self.viewModel.clipInEdit.packageData = {
            name: draftClip ? createDraftClipName(clip.title) : clip.name,
            title: clip.title || '',
            numberOfClips: clip.numberOfClips,
            scheduleId: draftClip ? self.packageObject.liveRecordSchedules.map(function (schedule) {
                return schedule.id;
            }) : [],
            content: self.packageObject.content,
            categoryType: self.categoryTypes.filter(function (categoryType) {
                return categoryType.name === 'Short Form';
            })[0],
            parentPackageId: self.packageObject.id,
            autoDeliver: true,
            purgeOnIngest: true
        };
        return saveClipPackage(draftClip).then(function (clipPackage) {
            if (self.viewModel.clipInEdit.thumbnailObject) {
                return self.uploadThumbnail(clipPackage, self.viewModel.clipInEdit.thumbnailObject).then(function () {
                    self.viewModel.clipInEdit = {};
                    return self.refreshClips();
                });
            }
            else {
                self.viewModel.clipInEdit = {};
                return self.refreshClips();
            }
        });
    };
    self.createDraftClip = function (draftClip) {
        return self.createNewClip(draftClip, true);
    };
    self.createInitialLiveClipName = function () {
        return self.viewModel.record.name + '-' + self.viewModel.clips.length;
    };
    self.createInitialClipName = function () {
        return self.packageObject.content.prefix +
            ' ' + moment(new Date()).format('YYYYMMDD') +
            ' ' + self.packageObject.id +
            '-' + self.viewModel.clips.length;
    };
    self.assignMarkPointsToDraftClip = function (draftClip) {
        var clipData = {
            markIn: self.viewModel.clipInEdit.clipStartOffset,
            markOut: self.viewModel.clipInEdit.clipEndOffset
        };
        if (draftClip) {
            self.viewModel.clipInEdit.packageData = draftClip;
            return saveClipPackage(false, true).then(function () {
                return self.refreshClips();
            });
        }
        else {
            clipData.name = self.viewModel.record ? self.createInitialLiveClipName() : self.createInitialClipName();
            return self.createNewClip(clipData);
        }
    };
    self.removeDraftClip = function (draftClip) {
        var removeComplete = $q.defer();
        PackageResourceFactory.toggleArchive({ id: draftClip.id }).$promise.then(function (pkg) {
            return self.refreshClips();
        }).then(function () {
            removeComplete.resolve();
        });
        return removeComplete.promise;
    };
    self.acceptClip = function (clip, deliverClip) {
        var acceptFn = ClipResourceFactory[deliverClip ? 'acceptAndDeliverClip' : 'acceptClip'];
        var deliverComplete = $q.defer();
        clip.acceptStatus = 'ACCEPTED';
        acceptFn({ id: clip.id }).$promise.then(function (clip) {
            $interval(delayedPollForClips, 500, 1, true, deliverComplete);
        });
        return deliverComplete.promise;
    };
    self.getEditClipData = function (clip) {
        var editDataComplete = $q.defer();
        var promises = {
            clip: PackageResourceFactory.get({ id: clip.id, lock: true }).$promise,
            partnerPackages: PartnerPackagesService.queryPartnerPackages(clip.id)
        };
        $q.all(promises).then(function (data) {
            var framerate = 0;
            if (self.viewModel.record) {
                framerate = self.viewModel.record.framerate;
            }
            else if (self.viewModel.currentFeed) {
                framerate = self.viewModel.currentFeed.framerate;
            }
            self.viewModel.clipInEdit = {
                id: data.clip.id,
                packageData: data.clip,
                liveClipId: data.clip.liveClipId,
                clipStartOffset: parseFloat(data.clip.clipStartOffset),
                clipEndOffset: parseFloat(data.clip.clipEndOffset),
                markInTimeCode: (data.clip.clipStartOffset > -1) ? timecodeFromSecFilter(data.clip.clipStartOffset, framerate) : '',
                markOutTimeCode: (data.clip.clipEndOffset) ? timecodeFromSecFilter(data.clip.clipEndOffset, framerate) : '',
                clipImageOffset: data.clip.clipImageOffset,
                imageTimeCode: timecodeFromSecFilter(parseFloat(data.clip.clipImageOffset), framerate),
                primaryImage: data.clip.primaryImage,
                clipDuration: timecodeFromSecFilter(clip.clipDuration, framerate),
                validationResult: filterClipValidationResults(data.clip.validationResult),
                liveClipTempThumbnailPath: data.clip.liveClipTempThumbnailPath,
                liveRecordId: data.clip.liveRecordId,
                tempThumbnail: data.clip.clipThumbnailData
            };
            PartnerPackagesService.partnerPackages(data.partnerPackages);
            PackageUtilService.createErrorsAndWarningsMap(self.viewModel.clipInEdit.validationResult);
            self.originalClipEditData = angular.copy(self.viewModel.clipInEdit);
            editDataComplete.resolve(self.viewModel.clipInEdit);
        });
        return editDataComplete.promise;
    };
    self.getClipFeed = function (clip) {
        if (clip.liveRecordId) {
            var clipSchedule = self.packageObject.liveRecordSchedules.filter(function (schedule) {
                return schedule.liveRecordId === clip.liveRecordId;
            })[0];
            return self.viewModel.availableFeeds.filter(function (feed) {
                return feed.id === clipSchedule.showLiveFeedId;
            })[0];
        }
        else {
            return self.viewModel.availableFeeds.filter(function (feed) {
                return !feed.isLive;
            })[0];
        }
    };
    self.switchToClipFeed = function (clip) {
        self.viewModel.currentFeed = self.getClipFeed(clip);
        self.currentSchedule = self.packageObject.liveRecordSchedules.filter(function (schedule) {
            return schedule.showLiveFeedId === self.viewModel.currentFeed.id;
        })[0];
        return self.getRecordData(self.currentSchedule.liveRecordId);
    };
    self.switchCurrentSchedule = function () {
        self.currentSchedule = self.packageObject.liveRecordSchedules.filter(function (schedule) {
            return schedule.showLiveFeedId === self.viewModel.currentFeed.feedData.id;
        })[0];
        return self.getRecordData(self.currentSchedule.liveRecordId);
    };
    self.switchToPrimaryVideoFeed = function () {
        self.currentSchedule = null;
        self.viewModel.record = null;
    };
    self.revertData = function () {
        if (self.metadataForm.$dirty) {
            self.viewModel.clipInEdit.packageData = angular.copy(self.originalClipEditData.packageData);
        }
        if (self.collaboratorsForm.$dirty) {
            PackageUtilService.subTabRevertFunctions.collaboratorsForm();
        }
        if (self.distributionForm.$dirty) {
            PackageUtilService.subTabRevertFunctions.distributionForm();
        }
        if (self.advancedForm.$dirty) {
            PackageUtilService.subTabRevertFunctions.advancedForm();
        }
        if (PackageUtilService.editorForm.$dirty) {
            self.viewModel.clipInEdit = angular.copy(self.originalClipEditData);
        }
        self.metadataForm.$setPristine();
        self.collaboratorsForm.$setPristine();
        self.distributionForm.$setPristine();
        self.advancedForm.$setPristine();
        PackageUtilService.editorForm.$setPristine();
    };
    self.unlockClip = function (clip) {
        if (PermissionsService.isAdmin()) {
            PackageResourceFactory.removeLock({ id: clip.id });
        }
    };
    self.cleanup = function () {
        $interval.cancel(clipsInterval);
        $interval.cancel(recordInterval);
        self.viewModel.clipInEdit = {};
        PartnerPackagesService.partnerPackages([]);
        self.originalClipEditData = {};
        self.viewModel = {
            perms: { livePerms: false, distPerms: false },
            record: null,
            clips: [],
            draftClips: [],
            totalClipsDuration: 0,
            currentFeed: {},
            clipInEdit: {},
            feedScheduleMap: {},
            availableFeeds: [],
            showClipsLoading: false
        };
        self.packageObject = null;
        self.defaultFeed = null;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 3/23/16.
 */
'use strict';
angular.module('prism-ui.package').controller('PackagePreviewViewController', function (_, $element, $q, $rootScope, $scope, secFromTimecodeFilter, CreateProxyService, CreateSnapshotService, DynamicPropertiesService, DownloadAssetService, ModalService, PackageMediaService, PackageUtilService, PermissionsService, PreviewQueryService, ProxyPlayerService, Timecode, UtilsService) {
    var PREVIEW_TAB_VIEW_STATE = 'PACKAGE_VIDEO_PREVIEW_VIEW_STATE';
    var DOWNLOAD_PROXY_STATE = 'PACKAGE_VIEW_DOWNLOAD_PROXY_VIEW_STATE';
    var RECREATE_PROXY_STATE = 'PACKAGE_RECREATE_PROXY_VIEW_STATE';
    var self = this;
    var startTimecodeInSeconds = 0;
    var programStartTimecodeInSeconds = 0;
    var programEndTimecodeInSeconds = 0;
    var playerProgramStartTime = 0;
    var playerProgramEndTime = 0;
    var defaultStartTimecode = '00:00:00:00';
    var mainVideoFrameRate;
    var currentlySelectedComponent;
    var VIDEO_AUDIO_ROLES = {
        mainVideo: {
            label: 'Main Video'
        }
    };
    self.currentViewedTab = 'details';
    self.creatingSnapshots = {};
    self.createdProxies = {};
    self.perms = {};
    self.loading = true;
    self.currentViewData = { partners: [], images: [], ccSubtitles: [], partnerArtworks: [], adpod: [], videosAudios: [] };
    self.selectedPartner = undefined;
    self.selectedArtworkPartner = undefined;
    self.selectedArtworkLanguage = undefined;
    self.selectedArtwork = undefined;
    self.selectedVideoAudio = undefined;
    self.selectedCCSub = undefined;
    self.selectedImage = undefined;
    self.tempImagePath = undefined;
    self.availableElements = [];
    self.mainVideo = {};
    self.previewGridOptions = {
        rowHeight: 26,
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableFullRowSelection: false,
        enableCellSelection: true,
        enableCellEditOnFocus: true,
        multiSelect: false,
        enableColumnMenus: false,
        enableSorting: false,
        enableColumnResizing: true,
        modifierKeysToMultiSelectCells: true,
        enableVerticalScrollbar: 2,
        enablePaginationControls: false
    };
    self.adpodGrid = angular.copy(self.previewGridOptions);
    self.adpodGrid.columnDefs = [
        {
            field: 'name',
            allowCellFocus: false
        },
        {
            field: 'startTimeCode',
            name: 'In'
        },
        {
            field: 'endTimeCode',
            name: 'Out'
        }
    ];
    self.adpodGrid.onRegisterApi = function (gridApi) {
        gridApi.cellNav.on.navigate($scope, function (newRowCol) {
            var seekValue;
            if (newRowCol.col.field === 'startTimeCode') {
                seekValue = newRowCol.row.entity.startTime;
            }
            else {
                seekValue = newRowCol.row.entity.endTime;
            }
            ProxyPlayerService.seek(parseFloat(seekValue));
        });
    };
    self.componentsGrid = angular.copy(self.previewGridOptions);
    self.componentsGrid.columnDefs = [
        {
            field: 'name',
            allowCellFocus: false
        },
        {
            field: 'in'
        },
        {
            field: 'out'
        }
    ];
    var getSeekTime = function (timeCode, offsetTimeCode) {
        mainVideoFrameRate = parseFloat(self.mainVideo.mediaInfo.frameRate);
        return offsetTimeCode ?
            secFromTimecodeFilter(timeCode, mainVideoFrameRate) - secFromTimecodeFilter(self.mainVideo.startTimecode, mainVideoFrameRate)
            : secFromTimecodeFilter(timeCode, mainVideoFrameRate);
    };
    self.componentsGrid.onRegisterApi = function (gridApi) {
        gridApi.cellNav.on.navigate($scope, function (newRowCol) {
            var seekValue;
            var timeCode = newRowCol.row.entity[newRowCol.col.field];
            seekValue = getSeekTime(timeCode, true);
            ProxyPlayerService.seek(parseFloat(seekValue));
        });
    };
    self.captionsGrid = angular.copy(self.previewGridOptions);
    var defaultMediaRole = 'Main Video';
    var masterMediaData;
    var handleMasterOutOfBounds = function (timeCode) {
        ProxyPlayerService.onTimeUpdate = null;
        ProxyPlayerService.seek(timeCode);
        ProxyPlayerService.pause();
        ProxyPlayerService.onTimeUpdate = self.playerTimeChangeHandler;
    };
    self.playButtonStateChangeHandler = function (state) {
        if (state === 'play') {
            if (ProxyPlayerService.onTimeUpdate === null) {
                ProxyPlayerService.onTimeUpdate = self.playerTimeChangeHandler;
            }
        }
    };
    self.playerTimeChangeHandler = function (currentTime) {
        if (currentTime >= playerProgramEndTime) {
            handleMasterOutOfBounds(playerProgramEndTime);
        }
        if (currentTime < playerProgramStartTime) {
            handleMasterOutOfBounds(playerProgramStartTime);
        }
    };
    self.masterVideoOffsetChangeHandler = function () {
        if (self.useMasterVideoOffset && !self.selectedVideoAudio.prePostRollId && !self.selectedVideoAudio.isAudio) {
            ProxyPlayerService.seek(playerProgramStartTime);
            ProxyPlayerService.onTimeUpdate = self.playerTimeChangeHandler;
            ProxyPlayerService.onChangedState = self.playButtonStateChangeHandler;
        }
        else {
            ProxyPlayerService.seek(0);
            ProxyPlayerService.onTimeUpdate = null;
            ProxyPlayerService.onChangedState = null;
        }
    };
    var setPlayerProgramStart = function () {
        playerProgramStartTime = Timecode.fromSeconds(programStartTimecodeInSeconds - startTimecodeInSeconds, { frameRate: parseFloat(self.mainVideo.mediaInfo.frameRate), dropFrame: false });
        playerProgramStartTime = playerProgramStartTime.subtractFrames(10).frameCount / parseFloat(self.mainVideo.mediaInfo.frameRate);
    };
    var setPlayerProgramEnd = function () {
        playerProgramEndTime = Timecode.fromSeconds(programEndTimecodeInSeconds - startTimecodeInSeconds, { frameRate: parseFloat(self.mainVideo.mediaInfo.frameRate), dropFrame: false });
        playerProgramEndTime = playerProgramEndTime.addFrames(10).frameCount / parseFloat(self.mainVideo.mediaInfo.frameRate);
    };
    var setMasterVideo = function () {
        var startTimecode = self.mainVideoWithMediaInfo.video[0].startTimecode ? self.mainVideoWithMediaInfo.video[0].startTimecode : defaultStartTimecode;
        startTimecodeInSeconds = getSeekTime(startTimecode, false);
        self.previewPlayerOffset = startTimecodeInSeconds;
        if (self.mainVideoWithMediaInfo.video[0].acceptTemplateMember.acceptProfile.videoMasterType &&
            self.mainVideoWithMediaInfo.video[0].acceptTemplateMember.acceptProfile.videoMasterType.programTimingRequired) {
            programStartTimecodeInSeconds = getSeekTime(self.mainVideoWithMediaInfo.video[0].programStartTimecode, false);
            programEndTimecodeInSeconds = getSeekTime(self.mainVideoWithMediaInfo.video[0].programEndTimecode, false);
            setPlayerProgramStart();
            setPlayerProgramEnd();
            self.isMasterVideo = true;
            self.useMasterVideoOffset = true;
            self.masterVideoOffsetChangeHandler();
        }
    };
    var getMediaInfo = function (pkgMediaContents) {
        var promises = [];
        angular.forEach(pkgMediaContents, function (pkgMediaContent) {
            if (pkgMediaContent && pkgMediaContent.assetId && _.toLower(pkgMediaContent.type) !== 'videocomponentmaster') {
                var mediaInfoPromise = PreviewQueryService.getMediaInfo(pkgMediaContent.id, true)
                    .then(function (mediaInfo) {
                    pkgMediaContent.mediaInfo = mediaInfo;
                });
                promises.push(mediaInfoPromise);
            }
        });
        return promises;
    };
    var getDefaultSubCC = function (ccSubs) {
        for (var i = 0; i < ccSubs.length; i++) {
            var ccSub = ccSubs[i];
            if (ccSub.languageId === self.mainVideo.languageId) {
                return ccSub;
            }
        }
        return ccSubs && ccSubs.length && ccSubs[0];
    };
    var getCCSubtitles = function (viewMedia) {
        var cc = viewMedia.cc;
        var subs = viewMedia.subtitle;
        var returnValue = [];
        if (cc && cc.length) {
            returnValue = subs && subs.length ? cc.concat(subs) : cc;
        }
        else if (subs && subs.length) {
            returnValue = subs;
        }
        return returnValue;
    };
    var createLanguageData = function (partner) {
        var tempPartnerLanguagesObject = {};
        // Keep one copy of each language
        _.forEach(partner.artworkAssets, function (artwork) {
            var language = {
                id: _.get(artwork, 'language.id', null),
                name: _.get(artwork, 'language.name', '[None]')
            };
            var languageData = _.get(tempPartnerLanguagesObject, language.id, {
                id: language.id,
                languageName: language.name,
                assets: []
            });
            if (!tempPartnerLanguagesObject[language.id]) {
                tempPartnerLanguagesObject[language.id] = languageData;
            }
            // Store artwork in language data
            languageData.assets.push(artwork);
        });
        return _.chain(tempPartnerLanguagesObject)
            .values() // Keep values from object
            .sortBy(function (languageData) {
            languageData.languageName.toLowerCase();
        })
            .forEach(function (languageData) {
            _.sortBy(languageData.assets, function (asset) {
                return asset.acceptProfile.name.toLowerCase();
            });
        })
            .value(); // Output sorted languagesData
    };
    var createArtworkData = function () {
        var partnersArtworkData = [];
        _.forEach(self.currentViewData.partners, function (partner) {
            if (partner.artworkAssets.length) {
                partnersArtworkData.push({
                    partnerName: partner.partner,
                    languagesData: createLanguageData(partner)
                });
            }
        });
        return _.orderBy(partnersArtworkData, function (partner) {
            return partner.partnerName.toLowerCase();
        });
    };
    var setVideoContentDefaults = function (viewMedia) {
        if (viewMedia && viewMedia.video && viewMedia.video.length) {
            if (!self.selectedPartner) {
                angular.forEach(masterMediaData, function (val, componentName) {
                    if (componentName !== defaultMediaRole) {
                        angular.forEach(masterMediaData[componentName].videocomponentmaster, function (componentMaster) {
                            self.currentViewData.videosAudios = self.currentViewData.videosAudios.concat(componentMaster);
                        });
                    }
                    else {
                        self.currentViewData.videosAudios = self.currentViewData.videosAudios.concat(masterMediaData[defaultMediaRole].video);
                    }
                });
            }
            self.currentViewData.ccSubtitles = getCCSubtitles(viewMedia);
            if (viewMedia.adpod && viewMedia.adpod.length) {
                self.currentViewData.adpod = viewMedia.adpod;
            }
        }
    };
    var getPartnerRoles = function () {
        var roleMap = {};
        angular.forEach(self.currentViewData.partners, function (partnerPackage) {
            angular.forEach(partnerPackage.videoRoles, function (videoRole) {
                var key = videoRole.role.isRequired || masterMediaData[videoRole.role.name] ? videoRole.role.name : defaultMediaRole;
                var collection = roleMap[key];
                if (!collection) {
                    collection = [];
                    roleMap[key] = collection;
                }
                roleMap[key].push(partnerPackage.partner);
            });
        });
        return roleMap;
    };
    var getAvailableElements = function (partnerRoleMap) {
        var elements = [];
        angular.forEach(masterMediaData, function (val, componentName) {
            var elementString;
            var partners = partnerRoleMap && partnerRoleMap[componentName] ? partnerRoleMap[componentName].join(', ') : '';
            if (componentName !== defaultMediaRole) {
                elementString = defaultMediaRole + ' + ' + componentName;
                elements.push({
                    element: elementString,
                    partners: partners
                });
            }
            else { // Default role should always appear first
                elementString = componentName;
                elements.unshift({
                    element: elementString,
                    partners: partners
                });
            }
        });
        return elements;
    };
    var setNonVideoDefaults = function (viewMedia) {
        if (viewMedia && viewMedia.image && viewMedia.image.length) {
            self.currentViewData.images = viewMedia.image;
            self.selectedImage = self.currentViewData.images[0];
        }
        self.availableElements = getAvailableElements(getPartnerRoles());
        self.currentViewData.partnerArtworks = createArtworkData();
        self.selectedArtworkPartner = self.currentViewData.partnerArtworks[0];
    };
    var getCCSubsForPartner = function (partner) {
        var viewMedia;
        var defaultViewMedia = {
            roleName: defaultMediaRole,
            cc: masterMediaData[defaultMediaRole].cc,
            subtitle: masterMediaData[defaultMediaRole].subtitle
        };
        if (!partner.videoRoles.length) {
            viewMedia = defaultViewMedia;
        }
        else {
            angular.forEach(partner.videoRoles, function (videoRole) {
                if (videoRole.role.name === currentlySelectedComponent) {
                    var partnerCC = (masterMediaData[videoRole.role.name] && masterMediaData[videoRole.role.name].cc) || masterMediaData[defaultMediaRole].cc;
                    var partnerSubs = (masterMediaData[videoRole.role.name] && masterMediaData[videoRole.role.name].subtitle) || masterMediaData[defaultMediaRole].subtitle;
                    viewMedia = {
                        roleName: videoRole.role.name,
                        cc: partnerCC,
                        subtitle: partnerSubs
                    };
                }
                else {
                    viewMedia = defaultViewMedia;
                }
            });
        }
        return getCCSubtitles(viewMedia);
    };
    self.getImageProxyPath = function () {
        if (self.canViewProxy()) {
            if (self.selectedImage && self.selectedImage.mediaPath) {
                return self.selectedImage.mediaPath;
            }
            else if (self.tempImagePath) {
                return self.tempImagePath;
            }
        }
        return 'assets/images/no-proxy.png';
    };
    self.getArtworkDropdownLabel = function (artwork) {
        return artwork.acceptProfile.name;
    };
    //Change here for preroll
    var getVideosForPartner = function (partner) {
        var partnerPreroll = partner.preRoll;
        var partnerPostroll = partner.postRoll;
        var partnerBreakPreRoll = partner.breakPreRoll;
        var partnerBreakPostRoll = partner.breakPostRoll;
        var allVideos = [];
        var componentMaster;
        if (partner.videoRoles.length) {
            angular.forEach(partner.videoRoles, function (videoRole) {
                if (videoRole.isRequired) {
                    componentMaster = masterMediaData[videoRole.role.name] && masterMediaData[videoRole.role.name].videocomponentmaster;
                }
                else {
                    componentMaster = (masterMediaData[videoRole.role.name] && masterMediaData[videoRole.role.name].videocomponentmaster) || masterMediaData[defaultMediaRole].video;
                }
                if (componentMaster) {
                    allVideos = allVideos.concat(componentMaster);
                }
            });
        }
        else {
            allVideos = allVideos.concat(masterMediaData[defaultMediaRole].video);
        }
        if (partnerPreroll) {
            allVideos.push(partnerPreroll);
        }
        if (partnerPostroll) {
            allVideos.push(partnerPostroll);
        }
        if (partnerBreakPreRoll && partnerBreakPostRoll) {
            allVideos.push(partnerBreakPreRoll);
            allVideos.push(partnerBreakPostRoll);
        }
        return allVideos;
    };
    var markerConversion = function () {
        self.markerTimecodesArray = [];
        var frameRate = parseFloat(self.mainVideo.mediaInfo.frameRate);
        var mainVideoFrames = Timecode.fromString(self.mainVideo.startTimecode, {
            frameRate: frameRate,
            dropFrame: false
        });
        angular.forEach(self.mainVideo.chapters, function (chapter, index) {
            var markerTimecodeObj = {};
            markerTimecodeObj.displayTimecode = 'Marker ' + (index + 1) + ' - ' + Timecode.fromString(chapter.startTimeCode, {
                frameRate: frameRate,
                dropFrame: false
            }).addFrames(mainVideoFrames.frameNumber).toString();
            markerTimecodeObj.chapterPlusOneFrameInSeconds = Timecode.fromString(chapter.startTimeCode, {
                frameRate: frameRate,
                dropFrame: false
            }).subtractFrames(1).frameCount / frameRate;
            self.markerTimecodesArray.push(markerTimecodeObj);
        });
    };
    var setVideoData = function () {
        self.selectedVideoAudio = self.currentViewData.videosAudios[0];
        self.selectedCCSub = getDefaultSubCC(self.currentViewData.ccSubtitles);
        if (self.selectedVideoAudio) {
            self.selectedVideoAudio.selectedMarker = undefined;
            self.adpodGrid.data = self.currentViewData.adpod && self.currentViewData.adpod.length ? self.currentViewData.adpod[0].adpods : undefined;
        }
        else {
            self.adpodGrid.data = self.currentViewData.adpod = [];
        }
        // For now, always add the main audio to all partners. Future work coming with partner specific audios
        if (masterMediaData[defaultMediaRole] && masterMediaData[defaultMediaRole].audio && masterMediaData[defaultMediaRole].audio.length) {
            self.currentViewData.videosAudios = self.currentViewData.videosAudios.concat(masterMediaData[defaultMediaRole].audio);
        }
        var mediaInfoPromises = getMediaInfo(self.currentViewData.videosAudios);
        $q.all(mediaInfoPromises).then(function () {
            _.forEach(masterMediaData, function (mediaData) {
                if (_.has(mediaData, 'videocomponentmaster')) {
                    // why don't video component masters have these!!
                    mediaData.videocomponentmaster[0].duration = masterMediaData[defaultMediaRole].video[0].duration;
                    mediaData.videocomponentmaster[0].durationTimecode = masterMediaData[defaultMediaRole].video[0].durationTimecode;
                    mediaData.videocomponentmaster[0].mediaInfo = masterMediaData[defaultMediaRole].video[0].mediaInfo;
                }
            });
            if (masterMediaData[defaultMediaRole] && masterMediaData[defaultMediaRole].video) {
                self.mainVideoWithMediaInfo = masterMediaData[defaultMediaRole];
                self.mainVideoMediaInfoFramerate = self.mainVideoWithMediaInfo.video[0].mediaInfo.frameRate;
                markerConversion();
                setMasterVideo();
            }
            $scope.$emit('server-busy', { working: false });
        });
    };
    var handleSelectedVideoAudioChange = function (selectedPartner) {
        if (self.selectedVideoAudio && self.selectedVideoAudio.dropdownLabel !== defaultMediaRole && !self.selectedVideoAudio.prePostRollId) {
            var componentsArray = [];
            currentlySelectedComponent = self.selectedVideoAudio.dropdownLabel.split('+')[1].trim();
            if (self.selectedPartner) {
                angular.forEach(selectedPartner.videoRoles, function (videoRole) {
                    if (videoRole.role.name === currentlySelectedComponent) {
                        angular.forEach(masterMediaData[currentlySelectedComponent].video, function (video) {
                            componentsArray.push(video);
                        });
                    }
                });
            }
            else {
                angular.forEach(masterMediaData, function (val, componentName) {
                    if (componentName === currentlySelectedComponent) {
                        angular.forEach(masterMediaData[currentlySelectedComponent].video, function (video) {
                            componentsArray.push(video);
                        });
                    }
                });
            }
            self.componentsGrid.data = componentsArray;
        }
    };
    var handlePartnerChange = function (selectedPartner) {
        $scope.$emit('server-busy', { working: true });
        if (!selectedPartner) {
            self.currentViewData.videosAudios = [];
            setVideoContentDefaults(masterMediaData[defaultMediaRole]);
        }
        else {
            self.currentViewData.videosAudios = getVideosForPartner(selectedPartner);
            self.selectedVideoAudio = self.currentViewData.videosAudios[0];
            handleSelectedVideoAudioChange(selectedPartner);
            self.currentViewData.ccSubtitles = self.currentViewData.videosAudios && self.currentViewData.videosAudios.length ? getCCSubsForPartner(selectedPartner) : [];
        }
        setVideoData();
    };
    var getPreviewData = function () {
        $scope.$emit('server-busy', { working: true });
        var mediaPromise = PreviewQueryService.getPackageMedia(self.packageObject.id);
        var partnerPackagesPromise = PreviewQueryService.getPartnerPackages(self.packageObject.id);
        var dynamicPropsPromise = DynamicPropertiesService.queryForProperties();
        var downloadViewStatePromise = PermissionsService.getPackagePermissions(DOWNLOAD_PROXY_STATE, self.packageObject.id);
        var writePermsPromise = PermissionsService.canWrite(PREVIEW_TAB_VIEW_STATE);
        var recreateProxyPerm = PermissionsService.canWrite(RECREATE_PROXY_STATE);
        return $q.all({
            media: mediaPromise,
            partners: partnerPackagesPromise,
            dynamicProps: dynamicPropsPromise,
            writePerms: writePermsPromise,
            viewDownloadPerms: downloadViewStatePromise,
            recreatePerms: recreateProxyPerm
        }).then(function (data) {
            masterMediaData = data.media;
            self.canReplaceExistingImages = DynamicPropertiesService.getPropValueAsBoolean('ffmpeg.frameGrabber.replaceExistingImages', false);
            self.perms = {
                write: data.writePerms,
                download: (data.viewDownloadPerms[0].permission & PermissionsService.WRITE_PERMISSION) === PermissionsService.WRITE_PERMISSION,
                recreate: data.recreatePerms,
                exception: data.viewDownloadPerms[0].availableAt
            };
            self.mainVideo = masterMediaData[defaultMediaRole] && masterMediaData[defaultMediaRole].video && masterMediaData[defaultMediaRole].video[0];
            self.currentViewData.partners = data.partners;
            setVideoContentDefaults(masterMediaData[defaultMediaRole]);
            setNonVideoDefaults(masterMediaData[defaultMediaRole]);
            setVideoData();
            self.loading = false;
        });
    };
    self.showVideoTab = function (tab) {
        if (tab === 'details') {
            return self.selectedVideoAudio && self.selectedVideoAudio.assetId ? true : false;
        }
        if (tab === 'markers') {
            return self.selectedVideoAudio && !self.selectedVideoAudio.prePostRollId && self.mainVideo && self.mainVideo.chapters && self.mainVideo.chapters.length ? true : false;
        }
        if (tab === 'adpods') {
            return self.selectedVideoAudio && !self.selectedVideoAudio.prePostRollId && self.currentViewData.adpod && self.currentViewData.adpod.length ? true : false;
        }
        if (tab === 'components') {
            return self.selectedVideoAudio && self.selectedVideoAudio.isComponentMaster ? true : false;
        }
        else {
            return self.captionsGrid && self.captionsGrid.data && self.captionsGrid.data.length ? true : false;
        }
    };
    var setActiveTab = function () {
        if (self.showVideoTab('details')) {
            self.currentViewedTab = 'details';
        }
        else if (self.showVideoTab('markers')) {
            self.currentViewedTab = 'markers';
        }
        else if (self.showVideoTab('adpods')) {
            self.currentViewedTab = 'adpods';
        }
        else if (self.showVideoTab('components')) {
            self.currentViewedTab = 'components';
        }
        else {
            self.currentViewedTab = 'captions';
        }
    };
    var getCuePoints = function () {
        var cuePoints = [];
        if (self.showVideoTab('adpods')) {
            angular.forEach(self.currentViewData.adpod[0].adpods, function (adpod) {
                cuePoints.push({
                    timeLapse: {
                        start: adpod.startTime,
                        end: adpod.endTime
                    },
                    cuePointClass: 'adpod-cue-point'
                });
            });
        }
        if (self.showVideoTab('components')) {
            angular.forEach(self.componentsGrid.data, function (component) {
                cuePoints.push({
                    timeLapse: {
                        start: getSeekTime(component.in, true),
                        end: getSeekTime(component.out, true)
                    },
                    cuePointClass: 'component-cue-point'
                });
            });
        }
        return cuePoints;
    };
    self.download = function (type) {
        var filename = !!this.packageObject ?
            PackageMediaService.generatePackageDownloadFilenamePrefix(this.packageObject, false) :
            'unknown_';
        filename += type + "_proxy.";
        if (type === 'video' || type === 'audio') {
            filename += UtilsService.getFileExtension(self.selectedVideoAudio.proxyPath);
            DownloadAssetService.downloadAsset(self.selectedVideoAudio.assetId, filename, type, DownloadAssetService.ContentUse.Proxy);
        }
        else if (type === 'image') {
            filename += UtilsService.getFileExtension(self.selectedImage.mediaPath);
            DownloadAssetService.downloadAsset(self.selectedImage.assetId, filename, type, DownloadAssetService.ContentUse.Proxy);
        }
        else {
            filename += UtilsService.getFileExtension(self.selectedArtwork.mediaPath);
            DownloadAssetService.downloadAsset(self.selectedArtwork.assetId, filename, type, DownloadAssetService.ContentUse.Proxy);
        }
    };
    self.createSnapshot = function () {
        self.creatingSnapshots[self.mainVideo.id] = true;
        self.tempImagePath = CreateSnapshotService.getSnapshotImage($element.find('video')[0]);
        CreateSnapshotService.createSnapshot(self.packageObject.id, ProxyPlayerService.playerTime)
            .then(getPreviewData)
            .finally(function () {
            self.tempImagePath = undefined;
            self.creatingSnapshots[self.mainVideo.id] = false;
        });
    };
    self.createProxy = function (type) {
        var id;
        if (type === 'video') {
            if (self.selectedVideoAudio.prePostRollId) {
                CreateProxyService.createPrePostRollProxy(self.selectedVideoAudio.id);
            }
            else if (self.selectedVideoAudio.isComponentMaster) {
                CreateProxyService.createComponentMasterProxy(self.selectedVideoAudio.id);
            }
            else {
                CreateProxyService.createVideoProxy(self.selectedVideoAudio.id);
            }
            id = self.selectedVideoAudio.id;
        }
        else if (type === 'audio') {
            CreateProxyService.createAudioProxy(self.selectedVideoAudio.id);
            id = self.selectedVideoAudio.id;
        }
        else {
            CreateProxyService.createImageProxy(self.selectedImage.id);
            id = self.selectedImage.id;
        }
        self.createdProxies[id] = true;
    };
    self.showImageInfoModal = function (packageContent) {
        var imageAssetInfoRendererTemplate = 'package/editor/components/view/preview/renderers/image/preview-image-info-render-template.html';
        var fileNamePrefix = !!this.packageObject ?
            PackageMediaService.generatePackageDownloadFilenamePrefix(this.packageObject, false) :
            'unknown_';
        ModalService.showViewAssetModal(packageContent, false, fileNamePrefix, imageAssetInfoRendererTemplate, false);
    };
    self.showArtworkInfoModal = function (packageContent) {
        var artworkAssetInfoRendererTemplate = 'package/editor/components/view/preview/renderers/artwork/preview-artwork-info-renderer-template.html';
        ModalService.showAssetModal(packageContent, artworkAssetInfoRendererTemplate);
    };
    self.canViewProxy = function () {
        var hasPerms = self.perms.write && self.perms.download;
        var proxyHasReleased = !self.perms.exception || new Date(self.perms.exception).getTime() <= new Date().getTime();
        return hasPerms && proxyHasReleased;
    };
    self.canCreateSnapshot = function () {
        var hasPerms = self.perms.write;
        var previewingMainVideo = self.mainVideo && self.selectedVideoAudio && !self.selectedVideoAudio.isAudio && self.selectedVideoAudio.id === self.mainVideo.id;
        var hasImages = self.currentViewData && self.currentViewData.images && self.currentViewData.images.length;
        var createClicked = self.mainVideo && self.creatingSnapshots[self.mainVideo.id];
        return hasPerms && previewingMainVideo && (self.canReplaceExistingImages || !hasImages) && !createClicked;
    };
    self.canCreateProxy = function (mediaObj) {
        var hasPerms = self.perms.write && self.perms.recreate;
        var statusAllows = mediaObj && (!mediaObj.ingestInfo || !mediaObj.ingestInfo.proxyWorkflowStatus || mediaObj.ingestInfo.proxyWorkflowStatus === 'COMPLETED');
        var createClicked = mediaObj && self.createdProxies[mediaObj.id];
        return hasPerms && statusAllows && !createClicked;
    };
    self.videoAudioRoleChange = function () {
        if (self.selectedVideoAudio.prePostRollId || self.selectedVideoAudio.isAudio) {
            self.previewPlayerOffset = self.selectedVideoAudio.isAudio ? 0 : getSeekTime('01:00:00:00', false);
            self.useMasterVideoOffset = false;
        }
        else {
            startTimecodeInSeconds = getSeekTime(self.mainVideoWithMediaInfo.video[0].startTimecode, false);
            self.previewPlayerOffset = startTimecodeInSeconds;
            if (self.selectedVideoAudio.dropdownLabel === defaultMediaRole) {
                self.currentViewData.ccSubtitles = getCCSubtitles(masterMediaData[defaultMediaRole]);
            }
            if (self.selectedVideoAudio.isComponentMaster) {
                currentlySelectedComponent = self.selectedVideoAudio.dropdownLabel.split('+')[1].trim();
                if (masterMediaData[currentlySelectedComponent].cc || masterMediaData[currentlySelectedComponent].subtitles) {
                    self.currentViewData.ccSubtitles = getCCSubtitles(masterMediaData[currentlySelectedComponent]);
                }
                else {
                    self.currentViewData.ccSubtitles = getCCSubtitles(masterMediaData[defaultMediaRole]);
                }
            }
            self.selectedCCSub = self.currentViewData.ccSubtitles[0];
            self.useMasterVideoOffset = self.isMasterVideo;
        }
        self.masterVideoOffsetChangeHandler();
    };
    // Form should never be dirty
    $scope.$watch(function () {
        return PackageUtilService.editorForm && PackageUtilService.editorForm.$dirty;
    }, function (newVal, oldVal) {
        if (PackageUtilService.editorForm && newVal !== oldVal) {
            PackageUtilService.editorForm.$setPristine();
        }
    });
    $scope.$watch(function () {
        return self.editorForm;
    }, function (newValue) {
        PackageUtilService.editorForm = newValue;
    });
    $scope.$watch(function () {
        return self.selectedVideoAudio;
    }, function (newVal) {
        if (newVal) {
            if (newVal.isAudio) {
                self.cuePoints = [];
            }
            else {
                if (newVal.prePostRollId) {
                    self.selectedCCSub = undefined;
                }
                setActiveTab();
                handleSelectedVideoAudioChange(self.selectedPartner);
                self.cuePoints = getCuePoints();
            }
        }
    });
    $scope.$watch(function () {
        return self.selectedVideoAudio && self.selectedVideoAudio.selectedMarker;
    }, function (newVal) {
        if (typeof newVal === 'number') {
            ProxyPlayerService.seek(newVal);
        }
    });
    $scope.$watch(function () {
        return self.selectedPartner;
    }, function (newVal, oldVal) {
        if (oldVal !== newVal) {
            handlePartnerChange(newVal);
        }
    });
    $scope.$watch(function () {
        return self.selectedArtworkPartner;
    }, function (newVal) {
        if (newVal) {
            self.selectedArtworkLanguage = self.selectedArtworkPartner.languagesData[0];
        }
    });
    $scope.$watch(function () {
        return self.selectedArtworkLanguage;
    }, function (newVal) {
        if (newVal) {
            self.selectedArtwork = self.selectedArtworkLanguage.assets[0];
        }
    });
    $scope.$on('$destroy', function () {
        ProxyPlayerService.onTimeUpdate = null;
        ProxyPlayerService.onChangedState = null;
    });
    getPreviewData();
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 3/23/16.
 */
'use strict';
angular.module('prism-ui.package').directive('packagePreviewView', function () {
    return {
        restrict: 'E',
        controller: 'PackagePreviewViewController as pkgPreviewCtrl',
        templateUrl: 'package/editor/components/view/preview/package-preview-view-template.html',
        scope: true,
        bindToController: {
            packageObject: '='
        }
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.package').controller('PackageTimingsViewController', function (PermissionsService) {
    var self = this;
    self.loading = true;
    var getPermissions = function () {
        var writePerms = PermissionsService.canWrite('PACKAGE_TIMINGS_VIEW_STATE');
        writePerms.then(function (perms) {
            self.writePerms = perms;
            self.loading = false;
        });
    };
    getPermissions();
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.package').directive('packageTimingsView', function () {
    return {
        restrict: 'E',
        controller: 'PackageTimingsViewController',
        templateUrl: 'package/editor/components/view/timings/packagetimings-view-template.html',
        controllerAs: 'pkgTimingsCtrlr',
        scope: true,
        bindToController: {
            packageObject: '='
        }
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.package').controller('PMDatePropertiesSectionController', function ($scope, SearchFilterService) {
    var self = this;
    self.searchCriteria = SearchFilterService.searchCriteria;
    self.selectedDateProperty = SearchFilterService.searchCriteria.dateProperty || '';
    self.selectedDateProperties = {
        'originalReleaseDate': {
            fromDate: (SearchFilterService.searchCriteria.dateProperty === 'originalReleaseDate') ? SearchFilterService.searchCriteria.fromDate : new Date(),
            toDate: (SearchFilterService.searchCriteria.dateProperty === 'originalReleaseDate') ? SearchFilterService.searchCriteria.toDate : new Date()
        },
        'lastEdited': {
            fromDate: (SearchFilterService.searchCriteria.dateProperty === 'lastEdited') ? SearchFilterService.searchCriteria.fromDate : new Date(),
            toDate: (SearchFilterService.searchCriteria.dateProperty === 'lastEdited') ? SearchFilterService.searchCriteria.toDate : new Date()
        },
        'dateCreated': {
            fromDate: (SearchFilterService.searchCriteria.dateProperty === 'dateCreated') ? SearchFilterService.searchCriteria.fromDate : new Date(),
            toDate: (SearchFilterService.searchCriteria.dateProperty === 'dateCreated') ? SearchFilterService.searchCriteria.toDate : new Date()
        }
    };
    $scope.$on('modal.closing', function () {
        SearchFilterService.searchCriteria.dateProperty = self.selectedDateProperty || null;
        SearchFilterService.searchCriteria.fromDate = (self.selectedDateProperty) ? self.selectedDateProperties[self.selectedDateProperty].fromDate : null;
        SearchFilterService.searchCriteria.toDate = (self.selectedDateProperty) ? self.selectedDateProperties[self.selectedDateProperty].toDate : null;
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.package').controller('PMSearchFiltersDeliverySectionController', function (_, $scope, PartnerResourceFactory, SearchFilterService) {
    var self = this;
    self.searchCriteria = SearchFilterService.searchCriteria;
    var deliveredStatus = 0;
    var notDeliveredStatus = 1;
    self.deliveredFlagOptions = [
        { label: 'Delivered', value: true, },
        { label: 'Not Delivered', value: false, },
    ];
    if (SearchFilterService.searchCriteria.delivered === true) {
        self.delivered = self.deliveredFlagOptions[deliveredStatus];
    }
    else if (SearchFilterService.searchCriteria.delivered === false) {
        self.delivered = self.deliveredFlagOptions[notDeliveredStatus];
    }
    else {
        self.delivered = null;
    }
    self.getPartnerLabel = function (partner) {
        if (typeof partner === 'object') {
            return partner.name;
        }
        return _.find(self.availablePartners, { id: partner }).name;
    };
    PartnerResourceFactory.query({ fetchLimit: -1 }).$promise.then(function (partners) {
        self.availablePartners = partners;
        self.deliveredToPartners = SearchFilterService.searchCriteria.deliveredToPartners || [];
    });
    $scope.$on('modal.closing', function () {
        SearchFilterService.searchCriteria.delivered = _.get(self.delivered, 'value');
        SearchFilterService.searchCriteria.deliveredToPartners = self.deliveredToPartners;
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jesse on 5/6/16.
 */
'use strict';
angular.module('prism-ui.package').controller('PMMetadataSearchFieldsSectionController', function ($scope, _, $q, SearchFilterService, MetadataService) {
    var self = this;
    self.searchablePackageFields = [
        { id: '1', selected: true, fieldName: 'id', name: 'ID' },
        { id: '2', selected: false, fieldName: 'keywords', name: 'Keywords' },
        { id: '3', selected: false, fieldName: 'desc1', name: 'Short Description' },
        { id: '4', selected: true, fieldName: 'name', name: 'Nickname' },
        { id: '5', selected: false, fieldName: 'desc2', name: 'Long Description' },
        { id: '6', selected: true, fieldName: 'episodeTitle', name: 'Title' },
        { id: '7', selected: false, fieldName: 'tMSId', name: 'TMS ID' }
    ];
    var getDefaultPackageSearchFields = function () {
        var searchable = [];
        angular.forEach(self.searchablePackageFields, function (field) {
            if (field.selected) {
                searchable.push(field);
            }
        });
        return searchable;
    };
    var retrieveData = function () {
        MetadataService.propertiesPromise.then(function () {
            self.searchablePartnerFields = _.filter(MetadataService.searchableProperties, function (property) { return !property.mvpd; });
            var packageProps = SearchFilterService.getObjectsFromPathProp(self.searchablePackageFields, 'fieldName', 'packageProperties');
            self.selectedSearchablePackageFields = packageProps.length ? packageProps : getDefaultPackageSearchFields();
            self.selectedSearchablePartnerFields = SearchFilterService.getObjectsFromPathProp(self.searchablePartnerFields, 'name', 'partnerProperties');
        });
    };
    retrieveData();
    $scope.$on('modal.closing', function () {
        SearchFilterService.searchCriteria.packageProperties = SearchFilterService.extractQueryProp(self.selectedSearchablePackageFields, 'fieldName');
        SearchFilterService.searchCriteria.partnerProperties = SearchFilterService.extractQueryProp(self.selectedSearchablePartnerFields, 'name');
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.package').controller('PMMetadataSearchSectionController', function ($scope, _, SearchFilterService) {
    var self = this;
    self.searchCriteria = _.cloneDeep(SearchFilterService.searchCriteria);
    $scope.$on('modal.closing', function () {
        SearchFilterService.searchCriteria.keywords = self.searchCriteria.keywords || null;
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.workflows').controller('WorkflowsDatePropertiesSectionController', function ($scope, SearchFilterService) {
    var self = this;
    self.searchCriteria = SearchFilterService.workflowSearchCriteria;
    self.selectedDateProperty = SearchFilterService.workflowSearchCriteria.dateProperty || '';
    self.selectedDateProperties = {
        'startDate': {
            fromDate: (SearchFilterService.workflowSearchCriteria.dateProperty === 'startDate') ? SearchFilterService.workflowSearchCriteria.fromDate : new Date(),
            toDate: (SearchFilterService.workflowSearchCriteria.dateProperty === 'startDate') ? SearchFilterService.workflowSearchCriteria.toDate : new Date()
        }
    };
    self.recentDays = SearchFilterService.workflowSearchCriteria.recentDays || 14;
    $scope.$on('modal.closing', function () {
        SearchFilterService.workflowSearchCriteria.recentDays = self.recentDays;
        SearchFilterService.workflowSearchCriteria.dateProperty = self.selectedDateProperty;
        SearchFilterService.workflowSearchCriteria.fromDate = (self.selectedDateProperty === 'startDate') ? self.selectedDateProperties[self.selectedDateProperty].fromDate : null;
        SearchFilterService.workflowSearchCriteria.toDate = (self.selectedDateProperty === 'startDate') ? self.selectedDateProperties[self.selectedDateProperty].toDate : null;
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.workflows').controller('WorkflowsPropertiesSectionController', function ($scope, $q, SearchFilterService) {
    var self = this;
    self.available = {
        statuses: []
    };
    self.searchCriteria = {
        statuses: []
    };
    var retrieveStatuses = function () {
        var statusesPromise = SearchFilterService.getWorkflowStatuses();
        $q.all({
            statuses: statusesPromise
        }).then(function (data) {
            self.available.statuses = data.statuses;
            self.searchCriteria.statuses = SearchFilterService.getObjectsFromPathProp(self.available.statuses, 'id', 'status');
        });
    };
    $scope.$on('modal.closing', function () {
        SearchFilterService.workflowSearchCriteria.status = SearchFilterService.extractQueryProp(self.searchCriteria.statuses, 'id');
    });
    retrieveStatuses();
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.content').controller('AddContentCategoriesModalController', function ($uibModalInstance, ContentEditService, availableCategories, existingContentCategories) {
    var self = this;
    self.filteredLongFormCategories = [];
    self.filteredShortFormCategories = [];
    self.categoryTypes = [];
    self.catTypeMap = {
        'Long Form': [],
        'Short Form': []
    };
    self.selectedCategoryType = '';
    self.selectedCategory = '';
    self.setContentCategoryCollections = function () {
        angular.forEach(availableCategories, function (categoryType) {
            self.categoryTypes.push(categoryType.name);
        });
        var existingCategories = existingContentCategories.map(function (contentCat) {
            return contentCat.category.id;
        });
        self.filteredLongFormCategories = availableCategories[0].categories.filter(function (cat) {
            return existingCategories.indexOf(cat.id) === -1;
        });
        self.filteredShortFormCategories = availableCategories[1].categories.filter(function (cat) {
            return existingCategories.indexOf(cat.id) === -1;
        });
        self.catTypeMap = { 'Long Form': self.filteredLongFormCategories, 'Short Form': self.filteredShortFormCategories };
    };
    self.onOk = function () {
        $uibModalInstance.close({ category: self.selectedCategory, id: -1 });
    };
    self.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
    self.disableOKButton = function () {
        return self.selectedCategory === '' || self.modalForm.$pristine;
    };
    self.setContentCategoryCollections();
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 1/5/16.
 */
'use strict';
angular.module('prism-ui.content').controller('AddShowLiveFeedModalController', function ($uibModalInstance, ContentEditService, availableFeeds, showLiveFeed) {
    var self = this;
    self.liveFeeds = availableFeeds;
    self.showLiveFeed = showLiveFeed;
    self.onOk = function () {
        $uibModalInstance.close(showLiveFeed);
    };
    self.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
    self.disableOKButton = function () {
        return !self.showLiveFeed.liveFeed || self.modalForm.$pristine;
    };
    self.isDefaultFeedSet = function () {
        var isSet = false;
        angular.forEach(ContentEditService.contentObject.liveFeeds, function (liveFeed) {
            if (liveFeed.defaultFlag) {
                isSet = true;
            }
        });
        return isSet;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
function NewSubscriptionModal(_, $q, uiGridConstants, ContentResourceFactory, NetworkResourceFactory, PartnerResourceFactory, SubscriptionsResourceFactory) {
    var self = this;
    self.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };
    self.selectedPartner = null;
    self.availablePartners = [];
    //====================//
    // Required MAPs grid //
    //====================//
    var dropdownSortByName = function (a, b) {
        return _.toLower(a).localeCompare(_.toLower(b));
    };
    var artworkGridColumns = [
        {
            field: 'artworkAcceptProfile.name',
            name: 'Required Artwork MAPs',
            sortable: true,
            enableSorting: true,
            sort: {
                direction: uiGridConstants.ASC,
                priority: 1
            },
            sortingAlgorithm: dropdownSortByName,
            enableColumnMenu: false,
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        }
    ];
    self.artworkGridOptions = {
        columnDefs: artworkGridColumns,
        enableColumnResizing: false,
        enablePaginationControls: false,
        rowHeight: 26,
        minRowsToShow: 4,
        enableVerticalScrollbar: 2,
        onRegisterApi: function (gridApi) {
            self.artworkGridApi = gridApi;
        }
    };
    //===================//
    // Template Response //
    //===================//
    var filterPartnersList = function () {
        _.forEach(self.subscriptions, function (subscription) {
            if (subscription.partner && subscription.partner.id) {
                _.forEach(self.availablePartners, function (partner, index) {
                    if (partner && partner.id) {
                        if (partner.id === subscription.partner.id) {
                            self.availablePartners.splice(index, 1);
                        }
                    }
                });
            }
        });
    };
    self.onPartnerSelected = function () {
        delete self.selectedArtwork;
        self.artworkSeasonVolume = false;
        self.requiredArtworks.splice(0);
        _.forEach(self.selectedPartner.artwork, function (requiredProfile) {
            var packageCategoryTypeId = _.get(requiredProfile, 'packageCategoryType.id');
            if (!packageCategoryTypeId || packageCategoryTypeId === self.resolve.packageCategoryTypeId) {
                self.requiredArtworks.push({
                    artwork: null,
                    artworkAcceptProfile: requiredProfile.acceptProfile,
                    artworkSeasonVolume: false
                });
            }
        });
    };
    // Update artwork in the subscription's format
    self.onArtworkSelected = function () {
        _.forEach(self.requiredArtworks, function (rowEntity) {
            rowEntity.artwork = self.selectedArtwork;
        });
    };
    self.onSVCheckboxClicked = function () {
        _.forEach(self.requiredArtworks, function (rowEntity) {
            rowEntity.artworkSeasonVolume = self.artworkSeasonVolume;
        });
    };
    self.isOkEnabled = function () {
        return (self.selectedPartner && (!_.size(self.selectedPartner.artwork) || self.selectedArtwork));
    };
    self.onOk = function () {
        self.close({
            $value: {
                partner: self.selectedPartner,
                artwork: self.requiredArtworks
            }
        });
    };
    self.cancel = function () {
        self.dismiss({ $value: 'cancel' });
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    var getArtworks = function () {
        return $q.all({
            content: ContentResourceFactory.get({ id: self.resolve.contentId, view: 'EXTENDED' }).$promise,
            network: NetworkResourceFactory.get({ id: self.resolve.networkId, view: 'EXTENDED' }).$promise
        }).then(function (artworkData) {
            var content = artworkData.content;
            self.availableArtworks = _.concat(content.artwork, artworkData.network.artwork);
            self.showMovieSpecialCheckbox = (!content || content.type !== 'Movie/Special');
            return self.availableArtworks;
        });
    };
    self.$onInit = function () {
        self.loadingIndicator.show = true;
        self.showMovieSpecialCheckbox = true;
        self.availableArtworks = [];
        self.selectedArtwork = null;
        self.artworkSeasonVolume = false;
        // Use 'requiredArtworks' as an alias for "all the grid's rows"
        self.requiredArtworks = [];
        self.artworkGridOptions.data = self.requiredArtworks;
        getArtworks();
        $q.all({
            partners: PartnerResourceFactory.query({
                fetchLimit: -1,
                includeChildren: false
            }).$promise,
            subscriptions: SubscriptionsResourceFactory.getSubscriptionsByContentCategory({
                contentId: self.resolve.contentId,
                categoryId: self.resolve.packageCategoryId,
                includeDisabled: true
            }).$promise
        }).then(function (data) {
            self.availablePartners = data.partners;
            self.subscriptions = data.subscriptions;
            filterPartnersList();
        });
    };
}
angular.module('prism-ui.content').component('newSubscriptionModal', {
    templateUrl: 'meta/content/editor/components/modals/newSubscriptionModal/new-subscription-modal-template.html',
    controller: NewSubscriptionModal,
    bindings: {
        dismiss: '&',
        close: '&',
        resolve: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 3/23/16.
 */
'use strict';
angular.module('prism-ui.package').controller('PackagePreviewHeaderController', function ($scope) {
    var self = this;
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 3/23/16.
 */
'use strict';
angular.module('prism-ui.package').directive('packagePreviewHeader', function () {
    return {
        restrict: 'E',
        controller: 'PackagePreviewHeaderController as pkgPreviewHeaderCtrl',
        templateUrl: 'package/editor/components/view/preview/header/package-preview-header-template.html',
        scope: true,
        bindToController: {
            mediaType: '@',
            mediaObj: '=',
            showCreateSnapshot: '=',
            showCreateProxy: '=',
            showDownload: '=',
            showMasterVideoOffset: '='
        }
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.package').controller('PackageTimingEditModalController', function ($uibModalInstance, pkgTiming) {
    var self = this;
    self.timingTypes = ['Program Start/End', 'Commercial Black'];
    self.selectedTiming = pkgTiming || {
        description: 'Program Start/End',
        startTC: '00:00:00:00',
        endTC: '00:00:00:00',
        durationTC: '00:00:00:00'
    };
    self.selectedTimingType = (pkgTiming && pkgTiming.description === 'Commercial Black') ? 'Commercial Black' : 'Program Start/End';
    self.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
    self.onOk = function () {
        self.selectedTiming.description = self.selectedTimingType;
        $uibModalInstance.close(self.selectedTiming);
    };
    self.disableOk = function () {
        return self.selectedTiming.startTC === '00:00:00:00' || self.selectedTiming.endTC === '00:00:00:00' ||
            self.selectedTiming.endTC < self.selectedTiming.startTC;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 2/16/16.
 */
'use strict';
angular.module('prism-ui.partner').controller('PartnerPropertiesViewController', function (_, $location, $q, $routeParams, $scope, $timeout, uiGridConstants, AcceptProfileResourceFactory, DebugService, DynamicPropertiesService, IntermediateTemplatesResourceFactory, LanguagesService, PackageResourceFactory, PartnerEditService, PartnerResourceFactory, RoleResourceFactory, TerritoriesService) {
    var self = this;
    self.DEFAULT_FORMAT_VALUES = {
        dateFormat: 'MM/dd/yyyy',
        dateTimeFormat: 'MM/dd/yyyy hh:mm:ss a zz',
        timeFormat: 'hh:mm:ss a zz',
        numberFormat: '#.####',
        timeZone: 'PST'
    };
    //=================================//
    // Default Artwork Accept Profiles //
    //=================================//
    self.onArtworkAcceptProfilesChanged = function (artworkAcceptProfiles) {
        self.partnerObject.artwork = artworkAcceptProfiles;
        self.editorForm.$setDirty();
    };
    // Called when partner's artwork array should be
    // rebuilt. (specifically: During initialization and when
    // reverting)
    var resetRequiredArtworksGrid = function () {
        // Gives the grid a copy of the data, so it doesn't revert to partner's artwork after every change
        var bothCategory = _.find(self.availableCategoryTypes, { name: 'Both' });
        self.initialArtworkAcceptProfiles = _.clone(self.partnerObject.artwork);
        _.forEach(self.initialArtworkAcceptProfiles, function (artwork) {
            if (!artwork.packageCategoryType) {
                artwork.packageCategoryType = bothCategory;
            }
        });
    };
    //=======================//
    // Serviceable Languages //
    //=======================//
    var serviceableLanguageFlags = [
        'cCEnabled', 'subtitleEnabled', 'audioEnabled', 'artworkEnabled'
    ];
    //
    // Creates a new ServiceableLanguage object for the given
    // language.
    //
    var createServiceableLanguage = function (language) {
        return {
            language: language,
            cCEnabled: false,
            subtitleEnabled: false,
            audioEnabled: false,
            artworkEnabled: false,
        };
    };
    var serviceableLanguageUsed = function (serviceableLanguage) {
        return _.some(serviceableLanguageFlags, function (flagName) {
            return (serviceableLanguage[flagName] === true);
        });
    };
    var getServiceableLanguageIndex = function (serviceableLanguageList, language) {
        if (language) {
            return _.findIndex(serviceableLanguageList, {
                language: { id: language.id }
            });
        }
        return _.findIndex(serviceableLanguageList, function (serviceableLanguage) {
            return (!serviceableLanguage.language);
        });
    };
    //
    // Called when the serviceable languages array should be
    // rebuilt (specifically, during initialization and when
    // reverting).
    //
    var updateServiceableLanguages = function () {
        _.forEach(self.allAvailableLanguages.concat(undefined), function (language) {
            var partnerIndex = getServiceableLanguageIndex(self.partnerObject.serviceableLanguages, language);
            var serviceableLanguage;
            if (partnerIndex >= 0) {
                serviceableLanguage = self.partnerObject.serviceableLanguages[partnerIndex];
                // If language isn't used, don't keep this language
                if (!serviceableLanguageUsed(serviceableLanguage)) {
                    self.partnerObject.serviceableLanguages.splice(partnerIndex, 1);
                }
            }
            else {
                serviceableLanguage = createServiceableLanguage(language);
            }
            // Add language to visible list
            var gridIndex = getServiceableLanguageIndex(self.availableServiceableLanguages, language);
            if (gridIndex >= 0) {
                _.assign(self.availableServiceableLanguages[gridIndex], serviceableLanguage);
            }
            else {
                self.availableServiceableLanguages.push(serviceableLanguage);
            }
        });
        self.availableServiceableLanguages = _
            .chain(self.availableServiceableLanguages)
            .orderBy('language.name')
            .partition({ language: { name: 'English' } })
            .flatten()
            .partition(function (serviceableLanguage) { return !serviceableLanguage.language; })
            .flatten()
            .value();
        // If nothing selected, implies serviceableLanguage grid "All" chosen (and in valid state),
        // so make array valid also
        if (!self.partnerObject.serviceableLanguages) {
            self.partnerObject.serviceableLanguages = [];
        }
        $timeout(self.editorForm.$setPristine);
    };
    self.onServiceableLanguagesChanged = function (validServiceableLanguages) {
        self.partnerObject.serviceableLanguages = validServiceableLanguages;
        self.editorForm.$setDirty();
    };
    //====================//
    // Delivery Templates //
    //====================//
    self.deliveryTemplateGridColumns = [
        {
            name: 'checkMarkRowHeaderCol',
            field: 'checkMark',
            width: 30,
            enableColumnMenu: false,
            enableSorting: false,
            enableColumnResizing: false,
            cellTemplate: 'components/visual/grid/check-mark-template.html',
            headerCellTemplate: '<div class="ui-grid-cell-contents" col-index="renderIndex" ng-click="grid.appScope.partnerPropCtrlr.toggleRows($event)">' +
                '<input type="checkbox" ng-checked="grid.selection.selectAll"/><label></label></div>'
        },
        {
            field: 'name',
            name: 'Name',
            sort: {
                direction: uiGridConstants.ASC,
                priority: 0
            },
            sortable: false,
            enableColumnMenu: false
        },
        {
            field: 'artwork',
            displayName: 'Artwork',
            sortable: false,
            enableColumnMenu: false,
            width: 70,
            cellTemplate: 'components/visual/grid/radio-button-template.html'
        },
        {
            field: 'audio',
            displayName: 'Audio',
            sortable: false,
            enableColumnMenu: false,
            width: 55,
            cellTemplate: 'components/visual/grid/radio-button-template.html'
        },
        {
            field: 'closedCaption',
            displayName: 'CC',
            sortable: false,
            enableColumnMenu: false,
            width: 40,
            cellTemplate: 'components/visual/grid/radio-button-template.html'
        },
        {
            field: 'image',
            displayName: 'Image',
            sortable: false,
            enableColumnMenu: false,
            width: 60,
            cellTemplate: 'components/visual/grid/radio-button-template.html'
        },
        {
            field: 'metadata',
            displayName: 'Metadata',
            sortable: false,
            enableColumnMenu: false,
            width: 80,
            cellTemplate: 'components/visual/grid/radio-button-template.html'
        },
        {
            field: 'subtitle',
            displayName: 'Subtitle',
            sortable: false,
            enableColumnMenu: false,
            width: 70,
            cellTemplate: 'components/visual/grid/radio-button-template.html'
        },
        {
            field: 'video',
            displayName: 'Video',
            sortable: false,
            enableColumnMenu: false,
            width: 60,
            cellTemplate: 'components/visual/grid/radio-button-template.html'
        },
        {
            field: 'defaultFlag',
            displayName: 'Default',
            sortable: false,
            enableColumnMenu: false,
            width: 70,
            cellTemplate: '<div class="checkbox-grid-cell" ng-if="!row.entity.custom" ng-click="grid.appScope.partnerPropCtrlr.handleDefaultCheckboxClick(row, $event)">' +
                '<input type="checkbox" ng-checked="COL_FIELD" /> <label> </label> </div>'
        }
    ];
    self.deliveryTemplatesGridOptions = {
        selectionRowHeaderColName: 'checkMarkRowHeaderCol',
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: false,
        enablePaginationControls: false,
        enableFullRowSelection: true,
        enableSorting: false,
        rowHeight: 26,
        multiSelect: true,
        minRowsToShow: 4,
        columnDefs: self.deliveryTemplateGridColumns,
        rowTemplate: '<div ' +
            'ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ' +
            'ng-class="row.entity.hidden ? \'ui-grid-cell-hidden\' : \'\'" class="ui-grid-cell" ui-grid-cell> ' +
            '</div>',
        onRegisterApi: function (gridApi) {
            self.gridApi = gridApi;
            self.gridApi.selection.on.rowSelectionChanged($scope, self.gridRowSelectionChangedHandler);
        }
    };
    self.gridRowSelectionChangedHandler = function (row, event) {
        if (event) {
            if (row.isSelected) {
                if (!self.partnerObject.deliveryTemplates) {
                    self.partnerObject.deliveryTemplates = [];
                }
                self.partnerObject.deliveryTemplates.push({ template: row.entity });
            }
            else {
                var templateIndex = 0;
                for (templateIndex; templateIndex < self.partnerObject.deliveryTemplates.length; templateIndex++) {
                    if (self.partnerObject.deliveryTemplates[templateIndex].template.id === row.entity.id) {
                        break;
                    }
                }
                self.partnerObject.deliveryTemplates.splice(templateIndex, 1);
            }
            self.editorForm.$setDirty();
        }
    };
    self.allAvailableLanguages = [];
    self.availableVideoRoles = [];
    self.intermediateTemplates = [];
    var setDefaultTemplate = function (template, matchedTemplates) {
        template.defaultFlag = (matchedTemplates && matchedTemplates.length === 1) ? matchedTemplates[0].defaultFlag : false;
    };
    var findTemplatesAddedToPartner = function (matchedHandlerFunction) {
        angular.forEach(PartnerEditService.deliveryTemplates, function (template) {
            var matchedTemplates = self.partnerObject.deliveryTemplates.filter(function (partnerTemplate) {
                return partnerTemplate.template.id === template.id;
            });
            matchedHandlerFunction(template, matchedTemplates);
        });
    };
    self.handleDefaultCheckboxClick = function (row, event) {
        if (row.isSelected) {
            event.preventDefault();
            event.stopImmediatePropagation();
            angular.forEach(self.partnerObject.deliveryTemplates, function (deliveryTemplate) {
                if (deliveryTemplate.template.id === row.entity.id) {
                    deliveryTemplate.defaultFlag = !deliveryTemplate.defaultFlag;
                }
                else {
                    deliveryTemplate.defaultFlag = false;
                }
            });
            findTemplatesAddedToPartner(setDefaultTemplate);
            self.editorForm.$setDirty();
        }
    };
    var addRemainingDeliveryTemplatesToPartner = function (template, matchedTemplates) {
        if (!matchedTemplates.length) {
            self.partnerObject.deliveryTemplates.push({ template: template });
        }
    };
    self.toggleRows = function (evt) {
        if (self.gridApi.selection.selectAll) {
            self.gridApi.selection.clearSelectedRows(evt);
            self.gridApi.selection.selectAll = false;
            self.partnerObject.deliveryTemplates = [];
        }
        else {
            self.gridApi.selection.selectAllVisibleRows(evt);
            self.gridApi.selection.selectAll = true;
            findTemplatesAddedToPartner(addRemainingDeliveryTemplatesToPartner);
        }
        self.editorForm.$setDirty();
    };
    var setSelectedGridTemplates = function (template, matchedTemplates) {
        $timeout(function () {
            if (matchedTemplates.length) {
                template.defaultFlag = matchedTemplates[0].defaultFlag;
                self.gridApi.selection.selectRow(template);
            }
            else {
                self.gridApi.selection.unSelectRow(template);
                template.defaultFlag = false;
            }
        });
    };
    self.setFormatsToDefault = function () {
        angular.forEach(self.DEFAULT_FORMAT_VALUES, function (formatValue, formatKey) {
            self.partnerObject[formatKey] = formatValue;
        });
        self.editorForm.$setDirty();
    };
    self.resetTabData = function () {
        self.partnerObject = PartnerEditService.partnerObject;
        findTemplatesAddedToPartner(setSelectedGridTemplates);
        resetRequiredArtworksGrid();
        updateServiceableLanguages();
    };
    //================//
    // Tab Management //
    //================//
    PartnerEditService.tabRevertFunction = self.resetTabData;
    PartnerEditService.tabSaveSuccessFunction = self.resetTabData;
    PartnerEditService.tabSaveErrorFunction = self.resetTabData;
    self.selectedParentPartner = undefined;
    self.availableParentPartners = [];
    self.initialArtworkAcceptProfiles = [];
    self.availableArtworkAcceptProfiles = [];
    self.availableCategoryTypes = [];
    self.availableServiceableLanguages = [];
    self.setTabData = function () {
        self.availableParentPartners.length = 0;
        var editDataPromise = PartnerEditService.getEditData().then(function (partnerData) {
            self.partnerObject = PartnerEditService.partnerObject;
            if (!self.partnerObject.id) {
                self.setFormatsToDefault();
                self.partnerObject.artwork = [];
            }
            if (!_.toInteger(self.partnerObject.numberOfChildren)) {
                self.availableParentPartners = partnerData.partnersWithoutChildPartners.filter(function (partner) {
                    return partner.id !== self.partnerObject.id;
                });
                if (self.partnerObject && self.partnerObject.parentId) {
                    var parentPartner = _.find(partnerData.partnersWithoutChildPartners, ['id', self.partnerObject.parentId]);
                    if (parentPartner) {
                        self.selectedParentPartner = _.cloneDeep(parentPartner);
                    }
                }
            }
            // if on the edit view, get the children
            if (_.get(self, 'partnerObject.id') && _.toNumber(_.get(self, 'partnerObject.numberOfChildren'))) {
                PartnerResourceFactory.getChildren({ id: self.partnerObject.id }).$promise.then(function (childPartners) {
                    self.childPartners = childPartners;
                });
            }
            self.deliveryTemplatesGridOptions.data = PartnerEditService.deliveryTemplates;
            if (self.partnerObject.deliveryTemplates && self.partnerObject.deliveryTemplates.length) {
                findTemplatesAddedToPartner(setSelectedGridTemplates);
            }
            // get the available delivery endpoints
            PartnerEditService.getDeliveryEndpointsForPartner($routeParams.id).then(function (deliveryEndpoints) {
                self.availableDeliveryEndpoints = deliveryEndpoints;
            });
            // get the available email endpoints
            PartnerEditService.getEmailEndpointsForPartner($routeParams.id).then(function (emailEndpoints) {
                self.availableEmailEndpoints = emailEndpoints;
            });
        });
        // for video role requirement grid
        var rolesPromise = RoleResourceFactory.query({ mediaType: 'Video' })
            .$promise.then(function (availableVideoRoles) {
            self.availableVideoRoles = availableVideoRoles.filter(function (role) {
                // filter out "Main Video"
                return !role.isDefault;
            });
        });
        // for default template selector
        var intermediateTemplatesPromise = IntermediateTemplatesResourceFactory.query()
            .$promise.then(function (intermediateTemplates) {
            self.intermediateTemplates = intermediateTemplates;
        });
        // for required MAPs grid (artwork accept profiles)
        var artworkAcceptProfilesPromise = AcceptProfileResourceFactory.query({ profileType: 'OTHER' }).$promise.then(function (acceptProfiles) {
            self.availableArtworkAcceptProfiles = acceptProfiles;
        });
        var categoryTypesPromise = PackageResourceFactory.getCategories({ view: 'EXTENDED' }).$promise.then(function (availableCategories) {
            self.availableCategoryTypes = availableCategories;
            self.availableCategoryTypes.push({ name: 'Both' });
        });
        // get the available territories
        var territoriesPromise = TerritoriesService.getAllTerritories({ fetchLimit: 0, includeHidden: false }).then(function (territories) {
            // Place USA at the top of the list
            var territoriesWithUsaFirst = _.chain(territories)
                .partition({ name: 'USA' })
                .flatten()
                .value();
            _.set(self, 'availableTerritories', territoriesWithUsaFirst);
        });
        var languagesPromise = LanguagesService.getAllLanguages().then(function (allAvailableLanguages) {
            self.allAvailableLanguages = _
                .chain(allAvailableLanguages)
                .orderBy('name')
                .partition({ name: 'English' })
                .flatten()
                .value();
        });
        var dynamicPropertiesPromise = DynamicPropertiesService.queryForProperties().then(function () {
            self.availablePartnerTypes = DynamicPropertiesService.getPropValueAsList('partner.types');
        });
        return $q.all([
            editDataPromise,
            rolesPromise,
            intermediateTemplatesPromise,
            artworkAcceptProfilesPromise,
            categoryTypesPromise,
            territoriesPromise,
            languagesPromise,
            dynamicPropertiesPromise
        ]).then(function () {
            resetRequiredArtworksGrid();
            updateServiceableLanguages();
        });
    };
    //======================//
    // Other Template Logic //
    //======================//
    self.enabledVideoRolesUpdated = function (context, newEnabledEntities) {
        self.partnerObject.videoRoles = newEnabledEntities;
        self.editorForm.$setDirty();
    };
    $scope.$watch(function () {
        return self.editorForm;
    }, function () {
        if (self.editorForm) {
            PartnerEditService.editorForm = self.editorForm;
        }
    });
    self.setPartnerObjectParentPartnerId = function () {
        if (self.partnerObject && self.selectedParentPartner) {
            self.partnerObject.parentId = self.selectedParentPartner.id;
        }
        else if (self.partnerObject) {
            self.partnerObject.parentId = undefined;
        }
    };
    self.navigateToChildPartner = function (childPartnerId) {
        $location.url("/system/partners/edit/" + childPartnerId + "/properties");
    };
    self.setTabData();
}).filter('stringToNumber', function () {
    return function (numberAsString) {
        var BASE_TEN_RADIX = 10;
        return parseInt(numberAsString, BASE_TEN_RADIX);
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 2/16/16.
 */
'use strict';
angular.module('prism-ui.partner').directive('partnerPropertiesView', function () {
    return {
        restrict: 'E',
        controller: 'PartnerPropertiesViewController as partnerPropCtrlr',
        templateUrl: 'system/partner/editor/components/view/properties/partner-properties-view-template.html',
        scope: true,
        bindToController: {}
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: content-seasonvolume-editor-component.js
 *
 * Created by randysorensen on 8/12/2017.
 */
'use strict';
function ContentSeasonVolumeEditorController(_, $route, $location, $routeParams, BreadcrumbService, ContentEditService, SidebarService) {
    var self = this;
    //========================//
    // PERMISSION VIEW STATES //
    //========================//
    self.seasonVolumeViewStates = {
        season: {
            preRoll: 'SERIES_SEASON_PREROLL_SEARCH_VIEW_STATE',
            postRoll: 'SERIES_SEASON_POSTROLL_SEARCH_VIEW_STATE'
        },
        volume: {
            preRoll: 'SERIES_VOLUME_PREROLL_SEARCH_VIEW_STATE',
            postRoll: 'SERIES_VOLUME_POSTROLL_SEARCH_VIEW_STATE'
        }
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    self.$onInit = function () {
        self.currentTab = $routeParams.editView;
        self.editService = ContentEditService;
        SidebarService.editService = ContentEditService;
        BreadcrumbService.editService = ContentEditService;
        self.searchEnabledTabs = ['collaborators'];
        // setup breadcrumbs
        self.breadcrumb = ContentEditService.seasonVolumeBreadcrumb;
        ContentEditService.resetBreadcrumbs();
        BreadcrumbService.addBreadcrumb(ContentEditService.contentBreadcrumb);
    };
    self.onTabSelect = function (tabName) {
        $route.updateParams({ editView: tabName });
    };
    self.onTabDeselect = function (tabName, event) {
        if (self.editService.editorForm && self.editService.editorForm.$dirty) {
            event.preventDefault();
            ContentEditService.showUnsavedChangesNotification();
        }
    };
    //======//
    // MISC //
    //======//
    self.isSeason = function () {
        return $location.$$url.indexOf('seasons') > -1;
    };
    self.isSearchEnabled = function () {
        return _.includes(self.searchEnabledTabs, self.currentTab);
    };
    // TODO: Remove function?
    self.isNextPreviousShown = function () {
        return false;
    };
}
angular
    .module('prism-ui.content')
    .component('contentSeasonVolumeEditor', {
    controller: ContentSeasonVolumeEditorController,
    bindings: {
        content: '<',
        season: '<'
    },
    templateUrl: 'meta/content/editor/components/view/seasonvolume/editor/content-seasonvolume-editor-template.html'
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: content-seasonvolume-searchview-component.js
 *
 * Created by randysorensen on 7/19/17.
 */
'use strict';
function ContentSeasonVolumeSearchViewController($location, $routeParams, uiGridConstants, ContentEditService, ModalService, NotificationService, NavbarUtilService) {
    var self = this;
    self.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };
    self.showHidden = false;
    //======//
    // Data //
    //======//
    var getData = function () {
        self.loadingIndicator.show = true;
        var serviceFunc = self.isSeason ? 'getSeasons' : 'getVolumes';
        self.contentObject = ContentEditService[serviceFunc](self.showHidden)
            .then(function (contentObject) {
            self.seasonVolumes = contentObject;
            self.gridOptions.data = self.seasonVolumes;
            self.gridApi.selection.clearSelectedRows();
            self.searchText = $location.search().searchText || null;
            self.filterGrid(self.searchText);
            self.loadingIndicator.show = false;
        });
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    self.$onInit = function () {
        getData();
        // Navbar search button click handler
        NavbarUtilService.viewSearchFunction = getData;
    };
    //======//
    // Grid //
    //======//
    self.gridColumnDefs = [
        {
            field: 'locked',
            type: 'boolean',
            width: 25,
            enableColumnMenu: false,
            enableSorting: true,
            cellTemplate: 'components/visual/grid/lock-icon-template.html',
            headerCellTemplate: 'components/visual/grid/header-lock-icon-template.html',
            displayName: 'Locked',
        },
        {
            field: 'name',
            type: 'string',
            width: '350',
            enableSorting: true,
            sort: {
                direction: 'asc',
                priority: 0
            },
            displayName: 'Name',
            cellTemplate: 'meta/content/editor/components/view/seasonvolume/searchView/gridTemplates/seasonvolume-name-template.html',
        },
        {
            field: 'sequenceNumber',
            type: 'string',
            width: '160',
            enableSorting: true,
            displayName: 'Sequence Number',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html',
        },
        {
            field: 'value',
            type: 'string',
            width: '150',
            enableSorting: true,
            displayName: 'Value',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html',
        },
        {
            field: 'startDate',
            type: 'string',
            width: '200',
            enableSorting: true,
            displayName: 'Start Date',
            cellTemplate: 'components/visual/grid/date-column-template.html',
        },
        {
            field: 'shortDescription',
            type: 'string',
            width: '*',
            enableSorting: true,
            displayName: 'Short Description',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html',
        },
    ];
    self.gridApi = null;
    self.gridOptions = {
        columnDefs: self.gridColumnDefs,
        data: [],
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        multiSelect: false,
        onRegisterApi: function (gridApi) {
            self.gridApi = gridApi;
            self.gridApi.grid.registerRowsProcessor(self.processGridFilter, 200);
        },
        rowSelection: true,
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
    };
    self.processGridFilter = function (renderableRows) {
        renderableRows.forEach(function (row) {
            row.visible = (self.searchText === null) ?
                true :
                row.entity.name.toLowerCase().indexOf(self.searchText) !== -1;
        });
        return renderableRows;
    };
    self.filterGrid = function (searchText) {
        if (searchText !== null) {
            self.searchText = searchText.toLowerCase();
            self.gridApi.grid.refresh();
        }
    };
    var getSelectedCount = function () {
        return self.gridApi.selection.getSelectedCount();
    };
    var getSelectedEntity = function () {
        return self.gridApi.selection.getSelectedRows()[0];
    };
    //=========//
    // Actions //
    //=========//
    var newSeasonVolume = function () {
        $location.url('/meta/series/edit/' + $routeParams.id + '/' +
            (self.isSeason ? 'seasons' : 'volumes') + '/edit/-1/properties');
    };
    var editSeasonVolume = function (seasonVolume) {
        var entityType = self.isSeason ? 'Season' : 'Volume';
        if (seasonVolume.hidden) {
            NotificationService.createWarningNotification(entityType + ' is hidden');
        }
        else {
            $location.url('/meta/series/edit/' + $routeParams.id + '/' +
                (self.isSeason ? 'seasons' : 'volumes') + '/edit/' + seasonVolume.id + '/properties');
        }
    };
    var openConfirmationModal = function (action, resultHandler) {
        var entityType = self.isSeason ? 'Season' : 'Volume';
        var seasonVolumeName = getSelectedEntity().name;
        ModalService.showMessageModal({
            messageText: 'Are you sure you want to ' + action + ' ' + seasonVolumeName + '?',
            title: (action.charAt(0).toUpperCase() + action.slice(1)) + entityType,
            showOK: true,
            okText: 'Yes',
            cancelText: 'No',
            pullCancelLeft: true,
            windowClass: 'confirm-modal-sm'
        }, resultHandler);
    };
    var cloneSelectedSeasonVolume = function () {
        var serviceCloneFunction = self.isSeason ? 'cloneSeason' : 'cloneVolume';
        ContentEditService[serviceCloneFunction](getSelectedEntity()).then(function () {
            getData();
        });
    };
    var toggleSelectedSeasonVolumeVisibility = function () {
        var serviceToggleFunction = self.isSeason ? 'toggleSeasonVisibility' : 'toggleVolumeVisibility';
        ContentEditService[serviceToggleFunction](getSelectedEntity()).then(function () {
            getData();
        });
    };
    var isSelectedSeasonVolumeHidden = function () {
        var seasonVolume = getSelectedEntity();
        return !!seasonVolume && seasonVolume.hidden;
    };
    self.onRowDblClick = function (row) {
        editSeasonVolume(row.entity);
    };
    //=========//
    // Toolbar //
    //=========//
    self.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: function () { return true; },
            onClick: function () { newSeasonVolume(); },
        },
        {
            label: 'Edit',
            enabled: function () { return self.gridApi.selection.getSelectedCount() === 1; },
            onClick: function () { editSeasonVolume(getSelectedEntity()); },
        },
        {
            label: 'Clone',
            enabled: function () { return self.gridApi.selection.getSelectedCount() === 1; },
            onClick: function () { openConfirmationModal('Clone', cloneSelectedSeasonVolume); },
        },
        {
            label: 'Hide',
            enabled: function () { return getSelectedCount() === 1 && !isSelectedSeasonVolumeHidden(); },
            onClick: function () { openConfirmationModal('Hide', toggleSelectedSeasonVolumeVisibility); },
        },
        {
            label: 'Unhide',
            enabled: function () { return getSelectedCount() === 1 && isSelectedSeasonVolumeHidden(); },
            onClick: function () { openConfirmationModal('Unhide', toggleSelectedSeasonVolumeVisibility); },
        }
    ];
    self.toolbarCheckboxDefs = [
        {
            label: 'Show Hidden',
            onUpdate: function (newState) {
                self.showHidden = newState;
                getData();
            },
        }
    ];
}
angular
    .module('prism-ui.content')
    .component('contentSeasonVolumeSearchView', {
    bindings: {
        isSeason: '<',
    },
    controller: ContentSeasonVolumeSearchViewController,
    templateUrl: 'meta/content/editor/components/view/seasonvolume/searchView/content-seasonvolume-searchview-template.html'
})
    .filter('seasonVolumeNameFilter', function () {
    return function (name, grid) {
        var startYear = (new Date(grid.row.entity.startDate)).getFullYear();
        var endYear = (new Date(grid.row.entity.endDate)).getFullYear();
        var nameString = name;
        if (startYear) {
            nameString += ' (' + startYear;
            if (endYear) {
                nameString += ' - ' + endYear;
            }
            nameString += ')';
        }
        return nameString;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 10/22/15.
 */
'use strict';
angular.module('prism-ui.package').controller('ClipScheduleModalController', function ($uibModalInstance, packageObject, defaultFeed, liveFeeds, cancelRecordHandler, RecordResourceFactory) {
    var self = this;
    self.packageObject = packageObject;
    self.currentFeed = defaultFeed;
    self.availableFeeds = liveFeeds.filter(function (feed) {
        return feed.isLive;
    });
    self.recordMap = {};
    self.getRecordForSchedule = function () {
        RecordResourceFactory.get({ id: self.schedule.liveRecordId }).$promise.then(function (record) {
            self.record = record;
            self.recordMap[record.id] = record;
        });
    };
    self.selectScheduleForFeed = function () {
        self.schedule = self.packageObject.liveRecordSchedules.filter(function (schedule) {
            return schedule.showLiveFeedId === self.currentFeed.id;
        })[0];
        self.getRecordForSchedule();
    };
    self.onOk = function () {
        $uibModalInstance.close(self.recordMap);
    };
    self.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
    self.cancelRecording = function (event) {
        self.schedule.liveRecordOverridden = true;
        cancelRecordHandler(event, self.record);
        self.cancel();
    };
    self.disableOKButton = function () {
        if (self.record && (self.record.status === 'complete' || self.record.status === 'cancelled')) {
            return true;
        }
        if (!(self.schedule.startTime && self.schedule.stopTime)) {
            return true;
        }
        var start = new Date(self.schedule.startTime).getTime();
        var end = new Date(self.schedule.stopTime).getTime();
        var now = new Date().getTime();
        if (self.schedule.liveRecordOverridden && (start <= now || end <= start)) {
            return true;
        }
        return false;
    };
    self.disableStopTimeField = function () {
        return !!self.record && (self.record.status === 'complete' || self.record.status === 'cancelled') ||
            !self.schedule.liveRecordOverridden;
    };
    self.disableStartTimeField = function () {
        return !!self.record && self.record.status === 'running' || self.disableStopTimeField();
    };
    self.selectScheduleForFeed();
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 11/20/15.
 */
'use strict';
angular.module('prism-ui.package').controller('CreateClipModalController', function ($uibModalInstance) {
    var self = this;
    self.numberOfClips = 1;
    self.maxClips = 99;
    self.onNumDraftClipsChanged = function (numDraftClips) {
        if (numDraftClips > self.maxClips) {
            self.numberOfClips = self.maxClips;
        }
        else if (isNaN(numDraftClips) || numDraftClips === 0) {
            self.numberOfClips = 1;
        }
        else {
            self.numberOfClips = numDraftClips;
        }
    };
    self.onOk = function () {
        $uibModalInstance.close({ title: self.clipTitle, numberOfClips: self.numberOfClips });
    };
    self.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 4/12/16.
 */
'use strict';
function AssetInfoModalController(_, SystemMediainfoResource, EndPointService, AuthFactory) {
    var _this = this;
    var getProxyContent = function () {
        return "" + EndPointService.mediaAssetEndpoint +
            ("?contentId=" + _this.resolve.asset.proxyId) +
            ("&" + AuthFactory.getAuthQueryString());
    };
    var getSourceContent = function () {
        return "" + EndPointService.mediaAssetEndpoint +
            ("?assetId=" + _this.resolve.asset.assetId) +
            "&contentUse=SOURCE" +
            ("&" + AuthFactory.getAuthQueryString());
    };
    this.assetType = this.resolve.assetType;
    var getAssetAcceptProfile = function () {
        return (_.get(_this, 'resolve.asset.acceptProfile') ||
            _.get(_this, 'resolve.asset.videoAcceptProfile') ||
            _.get(_this, 'resolve.asset.mediaAcceptProfile'));
    };
    this.hasSource = function () {
        var acceptProfileType = _.get(_this, 'resolve.asset.acceptProfile.type');
        return !acceptProfileType || acceptProfileType.toLowerCase() !== 'video';
    };
    this.hasProxy = function () {
        return !_this.hasSource();
    };
    this.downloadAsset = function () {
        if (_.includes(['video', 'image', 'other'], getAssetAcceptProfile().type.toLowerCase())) {
            var path = void 0;
            if (_this.hasSource()) {
                path = getSourceContent();
            }
            else {
                path = getProxyContent();
            }
            window.open(path);
        }
        _this.dismiss({ $value: 'cancel' });
    };
    this.$onInit = function () {
        _this.mediaInfo = SystemMediainfoResource.get({ id: _this.resolve.asset.assetId });
    };
}
angular.module('prism-ui.components').component('assetInfoModal', {
    templateUrl: 'package/editor/components/view/preview/modals/assetInfoModal/asset-info-modal-template.html',
    controller: AssetInfoModalController,
    bindings: {
        resolve: '<',
        dismiss: '&'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 4/18/16.
 */
'use strict';
angular.module('prism-ui.package').service('CreateProxyService', function ($q, WorkflowExecutionResourceFactory, WorkflowService) {
    var CREATE_VIDEO_PROXY_KEY = '_createProxies', CREATE_PRE_POST_PROXY_KEY = 'prePostRollProxyWorkflow', CREATE_COMPONENT_MASTER_PROXY = 'createComponentProxy', CREATE_AUDIO_PROXY_KEY = '_createProxies', CREATE_IMAGE_PROXY_KEY = '_createProxies';
    var self = this;
    self.createVideoProxy = function (videoId) {
        var workflowParameters = {
            subject: '[VideoPackageContent.' + videoId + ']'
        };
        return WorkflowService.startWorkflow(CREATE_VIDEO_PROXY_KEY, workflowParameters);
    };
    self.createComponentMasterProxy = function (videoId) {
        var workflowParameters = {
            subject: '[VideoComponentMaster.' + videoId + ']'
        };
        return WorkflowService.startWorkflow(CREATE_COMPONENT_MASTER_PROXY, workflowParameters);
    };
    self.createAudioProxy = function (audioId) {
        var workflowParameters = {
            subject: '[AudioPackageContent.' + audioId + ']'
        };
        return WorkflowService.startWorkflow(CREATE_AUDIO_PROXY_KEY, workflowParameters);
    };
    self.createImageProxy = function (imageId) {
        var workflowParameters = {
            subject: '[ImagePackageContent.' + imageId + ']'
        };
        return WorkflowService.startWorkflow(CREATE_IMAGE_PROXY_KEY, workflowParameters);
    };
    self.createPrePostRollProxy = function (prePostId) {
        var workflowParameters = {
            subject: '[PrePostRollAsset.' + prePostId + ']'
        };
        WorkflowService.startWorkflow(CREATE_PRE_POST_PROXY_KEY, workflowParameters);
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 3/24/16.
 */
'use strict';
angular.module('prism-ui.package').service('PreviewQueryService', function (_, $cookies, $q, DynamicPropertiesService, DownloadAssetService, NotificationService, PackageMediaResourceFactory, PackageMediaInfoResourceFactory, PackageResourceFactory) {
    var self = this;
    var defaultMediaRole = 'Main Video';
    self.retrievedMediaInfo = {};
    var buildChapterLabels = function (media) {
        angular.forEach(media.chapters, function (chapter) {
            chapter.label = 'Marker ' + (parseInt(chapter.index) + 1) + ' - ' + chapter.startTimeCode;
        });
    };
    var getMediaObjects = function (packageContent, type) {
        // previewObject is an augmented version of
        // the packageContent object
        var previewObject = _.merge({}, packageContent);
        var componentKey;
        switch (type) {
            case 'video':
                componentKey = packageContent.role.name;
                previewObject.cpatMemberId = packageContent.acceptTemplateMember.id;
                previewObject.dropdownLabel = componentKey;
                previewObject.in = packageContent.startTimecode;
                previewObject.out = packageContent.endTimecode;
                previewObject.videoMap = packageContent.acceptTemplateMember.acceptProfile.name;
                if (packageContent.role.name !== defaultMediaRole) {
                    previewObject.name = componentKey;
                }
                break;
            case 'videocomponentmaster':
                componentKey = packageContent.componentRole.name;
                previewObject.isComponentMaster = true;
                previewObject.dropdownLabel = defaultMediaRole + " + " + componentKey;
                break;
            case 'audio':
                componentKey = defaultMediaRole;
                var audioMAPName = packageContent.acceptTemplateMember.acceptProfile.name;
                previewObject.audioMap = packageContent.acceptTemplateMember.acceptProfile.name;
                previewObject.dropdownLabel = "Audio / " + audioMAPName + ": " + packageContent.languageAndRole;
                previewObject.isAudio = true;
                break;
            case 'cc':
            case 'subtitle':
                componentKey = packageContent.componentRole.name;
                var textType = 'CC';
                if (type === 'subtitle') {
                    textType = 'Subtitle';
                }
                previewObject.dropdownLabel = textType + " - " + packageContent.languageAndRole;
                break;
            case 'adpod':
                componentKey = defaultMediaRole;
                previewObject.adpods = packageContent.adPods;
                break;
            case 'image':
                componentKey = defaultMediaRole;
                previewObject.dropdownLabel = packageContent.language.name;
                previewObject.map = packageContent.acceptTemplateMember.acceptProfile.name;
                break;
            default:
        }
        buildChapterLabels(packageContent);
        // if component key remained unset, the content object
        // had an invalid type
        if (componentKey) {
            return {
                component: componentKey,
                objects: [previewObject]
            };
        }
        else {
            return null;
        }
    };
    var parseMedia = function (data) {
        var mediaMap = { 'Main Video': {} };
        angular.forEach(data, function (mediaItem) {
            var type = mediaItem.type.toLowerCase();
            var media = getMediaObjects(mediaItem, type);
            if (media) {
                var componentCollection = mediaMap[media.component];
                if (!componentCollection) {
                    componentCollection = {};
                    mediaMap[media.component] = componentCollection;
                }
                if (!componentCollection[type]) {
                    componentCollection[type] = [];
                }
                componentCollection[type] = componentCollection[type].concat(media.objects);
            }
        });
        return mediaMap;
    };
    var getReachAssetType = function (packageContent) {
        var assetType = _.toLower(packageContent.type);
        switch (assetType) {
            case 'videocomponentmaster':
                assetType = 'video';
                break;
            case 'cc':
            case 'subtitle':
                assetType = 'document';
                break;
            default:
                break;
        }
        return assetType;
    };
    // Fetch the asset URI, then save it to
    // packageContent.mediaPath and the Reach asset type to
    // packageContent.assetType. Return the promise.
    self.getAssetUri = function (abstractContent) {
        var assetType = getReachAssetType(abstractContent);
        var assetId = abstractContent.assetId;
        var contentUse = DownloadAssetService.ContentUse.Proxy;
        abstractContent.assetType = assetType;
        return DynamicPropertiesService.queryForProperties()
            .then(function () {
            if (assetType === 'image' && DynamicPropertiesService.getPropValueAsBoolean('package.previewWithImageSource')) {
                contentUse = DownloadAssetService.ContentUse.Source;
            }
            return DownloadAssetService.getAssetUri(assetId, assetType, contentUse);
        })
            .then(function (assetUriData) {
            abstractContent.mediaPath = assetUriData.uri;
        })
            .catch(function () {
            NotificationService.createFailureNotification('Unable to retrieve media URI', _.startCase(contentUse) + " not available for asset (" + _.toUpper(assetType) + " id: " + assetId + ")", true, 5000);
        });
    };
    var hasAssetUri = function (content) {
        var assetId = _.get(content, 'assetId');
        var type = _.toLower(_.get(content, 'type'));
        var role = _.toLower(_.get(content, 'role.name'));
        return (assetId !== undefined && (type !== 'video' || role === 'main video'));
    };
    var getAssetUris = function (abstractContents) {
        var uriPromises = _.chain(abstractContents)
            .filter(function (content) { return hasAssetUri(content); })
            .map(self.getAssetUri)
            .value();
        return $q.all(uriPromises).then(function () { return abstractContents; });
    };
    self.getPackageMedia = function (packageID) {
        var mediaPromise = PackageMediaResourceFactory.get({
            id: packageID
        }).$promise;
        return mediaPromise
            .then(function (packageContents) { return getAssetUris(packageContents); })
            .then(function (packageContents) { return parseMedia(packageContents); });
    };
    self.getMediaInfo = function (packageContentId, primary) {
        var deferred = $q.defer();
        var mediaInfo = self.retrievedMediaInfo[packageContentId];
        if (mediaInfo) {
            deferred.resolve(mediaInfo);
        }
        else {
            PackageMediaInfoResourceFactory.get({ id: packageContentId, primary: primary }).$promise
                .then(function (mediaInfo) {
                self.retrievedMediaInfo[packageContentId] = mediaInfo;
                deferred.resolve(mediaInfo);
            })
                .catch(function (error) {
                NotificationService.createFailureNotification('Unable to retrieve mediainfo data', "Mediainfo data not available for " + (primary ? 'primary' : 'non-primary') +
                    (" asset (id: " + packageContentId + ")"), true, 5000);
            });
        }
        return deferred.promise;
    };
    var createPartnerList = function (partnerPackages) {
        var partnerListPromises = [];
        angular.forEach(partnerPackages, function (partnerPackage) {
            var partnerData = {
                partner: partnerPackage.partner.name,
                videoRoles: partnerPackage.videoRoles,
            };
            if (partnerPackage.preRoll) {
                partnerData.preRoll = partnerPackage.preRoll;
                partnerData.preRoll.dropdownLabel = "Preroll - " + partnerPackage.preRoll.prePostRollName;
            }
            if (partnerPackage.postRoll) {
                partnerData.postRoll = partnerPackage.postRoll;
                partnerData.postRoll.dropdownLabel = "Postroll - " + partnerPackage.postRoll.prePostRollName;
            }
            if (partnerPackage.breakPreRoll && partnerPackage.breakPostRoll) {
                partnerData.breakPreRoll = partnerPackage.breakPreRoll;
                partnerData.breakPreRoll.dropdownLabel =
                    "Break Preroll - " + partnerPackage.breakPreRoll.prePostRollName;
                partnerData.breakPostRoll = partnerPackage.breakPostRoll;
                partnerData.breakPostRoll.dropdownLabel =
                    "Break Postroll - " + partnerPackage.breakPostRoll.prePostRollName;
            }
            partnerListPromises.push(getAssetUris(partnerPackage.artworkAssets).then(function (artworkContents) {
                partnerData.artworkAssets = artworkContents;
                return partnerData;
            }));
        });
        return $q.all(partnerListPromises);
    };
    self.getPartnerPackages = function (packageID) {
        return PackageResourceFactory.query({ id: packageID, sub: 'partnerPackages' }).$promise.then(function (data) {
            return createPartnerList(data);
        });
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: partner-delivery-endpoints-searchview-component.js
 *
 * Created by randysorensen on 5/9/17.
 */
'use strict';
function PartnerDeliveryEndpointsSearchViewController(_, $location, uiGridConstants, PartnerEditService, PartnerResourceFactory, ModalService, NavbarUtilService, NotificationService) {
    var self = this;
    //======//
    // Data //
    //======//
    var queryForGridData = function () {
        self.loadingIndicator.show = true;
        PartnerEditService
            .getDeliveryEndpointSearchViewData(self.showHidden)
            .then(function (deliveryEndpointsData) {
            self.gridOptions.data = deliveryEndpointsData.deliveryEndpoints;
            self.partnerObject = deliveryEndpointsData.partnerObject;
            self.searchText = $location.search().searchText || null;
            self.filterGrid(self.searchText);
            self.loadingIndicator.show = false;
        });
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    self.$onInit = function () {
        self.showHidden = false;
        if (self.canRead) {
            queryForGridData();
            // Navbar search button click handler
            NavbarUtilService.viewSearchFunction = queryForGridData;
        }
    };
    //==========//
    // Pacifier //
    //==========//
    self.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };
    //======//
    // Grid //
    //======//
    self.gridApi = null;
    self.searchText = null;
    self.gridColumnDefs = [
        {
            field: 'name',
            type: 'string',
            width: '*',
            sort: {
                direction: 'asc',
                priority: 2
            },
            displayName: 'Endpoint Name'
        },
        {
            field: 'type',
            type: 'string',
            width: '*',
            sort: {
                direction: 'asc',
                priority: 1
            },
            displayName: 'Type',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html',
            cellFilter: 'deliveryEndpointTypeLabel : grid.appScope.$ctrl',
        }
    ];
    self.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        multiSelect: false,
        columnDefs: self.gridColumnDefs,
        onRegisterApi: function (gridApi) {
            self.gridApi = gridApi;
            self.gridApi.grid.registerRowsProcessor(self.processGridFilter, 200);
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        data: []
    };
    self.onRowDblClick = function (row) {
        self.editDeliveryEndpoint(row.entity);
    };
    self.filterGrid = function (searchText) {
        if (searchText !== null) {
            self.searchText = searchText.toLowerCase();
            self.gridApi.grid.refresh();
        }
    };
    self.processGridFilter = function (renderableRows) {
        renderableRows.forEach(function (row) {
            row.visible = (self.searchText === null) ?
                true :
                row.entity.name.toLowerCase().indexOf(self.searchText) !== -1;
        });
        return renderableRows;
    };
    var getSelectedDeliveryEndpoint = function () {
        return self.gridApi.selection.getSelectedRows()[0];
    };
    self.getEndpointTypeLabel = PartnerEditService.getEndpointTypeLabel;
    //===========================//
    // Delivery Endpoint Actions //
    //===========================//
    var endpointTypeIsSupported = function (endpoint) {
        return !!endpoint && _.includes(_.keys(PartnerEditService.supportedEndpointTypes), endpoint.type);
    };
    self.newDeliveryEndpoint = function (type) {
        $location.url('/system/partners/edit/' + self.partnerObject.id +
            '/deliveryendpoints/' + type.toLowerCase() +
            '/edit/-1');
    };
    self.editDeliveryEndpoint = function (endpoint) {
        if (endpoint.hidden) {
            NotificationService.createWarningNotification('"' + endpoint.name + '" is hidden');
        }
        else if (!endpointTypeIsSupported(endpoint)) {
            NotificationService.createWarningNotification(endpoint.type + ' endpoints are not yet editable');
        }
        else {
            $location.url('/system/partners/edit/' + self.partnerObject.id +
                '/deliveryendpoints/' + endpoint.type.toLowerCase() +
                '/edit/' + endpoint.id);
        }
    };
    self.cloneSelectedDeliveryEndpoint = function () {
        var endpoint = getSelectedDeliveryEndpoint();
        if (!endpointTypeIsSupported(endpoint)) {
            NotificationService.createWarningNotification(endpoint.type + ' endpoints cannot yet be cloned');
        }
        else {
            self.loadingIndicator.show = true;
            PartnerResourceFactory
                .cloneDeliveryEndpoint({ partnerId: self.partnerObject.id, endpointId: endpoint.id })
                .$promise.then(function () {
                self.gridApi.selection.clearSelectedRows();
                queryForGridData();
                // LI should already be hidden by
                // queryForGridData()
                self.loadingIndicator.show = false;
            });
        }
    };
    self.toggleSelectedDeliveryEndpointVisibility = function () {
        self.loadingIndicator.show = true;
        var endpointId = getSelectedDeliveryEndpoint().id;
        PartnerResourceFactory
            .deleteDeliveryEndpoint({ id: endpointId })
            .$promise.then(function () {
            self.gridApi.selection.clearSelectedRows();
            queryForGridData();
            // LI should already be hidden by
            // queryForGridData()
            self.loadingIndicator.show = false;
        });
    };
    var showConfirmationModal = function (action, handler) {
        var capitalizedAction = action[0].toUpperCase() + action.slice(1);
        ModalService.showMessageModal({
            messageText: 'Are you sure you want to ' + action +
                ' "' + getSelectedDeliveryEndpoint().name + '"?',
            title: capitalizedAction + ' Partner Delivery Endpoint',
            windowClass: 'confirm-modal-sm',
            showOK: true,
            okText: 'Yes',
            pullCancelLeft: true
        }, function () { handler(); }, function () { });
    };
    //=========//
    // Toolbar //
    //=========//
    // Toolbar buttons
    self.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: function () { return self.canWrite; },
            onClick: function () {
                ModalService.showNewDeliveryEndpointModal(_.keys(PartnerEditService.supportedEndpointTypes), self.newDeliveryEndpoint);
            },
        },
        {
            label: 'Edit',
            enabled: function () { return self.gridApi.selection.getSelectedCount() === 1 && self.canWrite; },
            onClick: function () { self.editDeliveryEndpoint(getSelectedDeliveryEndpoint()); },
        },
        {
            label: 'Clone',
            enabled: function () { return self.gridApi.selection.getSelectedCount() === 1 && self.canWrite; },
            onClick: function () { showConfirmationModal('clone', self.cloneSelectedDeliveryEndpoint); },
        },
        {
            label: 'Hide',
            enabled: function () {
                return self.gridApi.selection.getSelectedCount() === 1 &&
                    !getSelectedDeliveryEndpoint().hidden && self.canWrite;
            },
            onClick: function () { showConfirmationModal('hide', self.toggleSelectedDeliveryEndpointVisibility); },
        },
        {
            label: 'Unhide',
            enabled: function () {
                return self.gridApi.selection.getSelectedCount() === 1 &&
                    getSelectedDeliveryEndpoint().hidden && self.canWrite;
            },
            onClick: function () { showConfirmationModal('unhide', self.toggleSelectedDeliveryEndpointVisibility); },
        }
    ];
    self.checkboxDefs = [
        {
            label: 'Show Hidden',
            onUpdate: function (newValue) {
                self.showHidden = newValue;
                queryForGridData();
            },
            isChecked: self.showHidden,
        },
    ];
}
angular.module('prism-ui.partner').component('partnerDeliveryEndpointsSearchView', {
    templateUrl: 'system/partner/editor/components/view/deliveryEndpoints/searchView/partner-delivery-endpoints-searchview-template.html',
    controller: PartnerDeliveryEndpointsSearchViewController,
    bindings: {
        canRead: '<',
        canWrite: '<'
    }
})
    .filter('deliveryEndpointTypeLabel', function () {
    return function (endpointType, $ctrl) {
        return $ctrl.getEndpointTypeLabel(endpointType);
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
function PartnerPlannerEditorController(_, $routeParams, $timeout, BreadcrumbService, PartnerEditService, UtilsService) {
    var self = this;
    var requiredFields = ['name', 'lookBack', 'lookForward', 'filenameExpression'];
    self.updateRequiredFields = function () {
        var oldField = self.plannerObject.scheduleType === 'weekly' ? 'frequency' : 'scheduleTimeOfDay';
        var newField = self.plannerObject.scheduleType === 'recurring' ? 'frequency' : 'scheduleTimeOfDay';
        var oldIndex = requiredFields.indexOf(oldField);
        if (oldIndex > -1) {
            requiredFields.splice(oldIndex, 1);
        }
        requiredFields.push(newField);
    };
    var getPlannerEditData = function () {
        self.loadingIndicator.show = true;
        PartnerEditService.getPlannerEditViewData().then(function (data) {
            self.availableDeliveryEndpoints = data.availableDeliveryEndpoints;
            self.availableEmailEndpoints = data.availableEmailEndpoints;
            self.availableTransformTemplates = data.availableTransformTemplates;
            self.partnerObject = data.partnerObject;
            self.plannerObject = data.plannerObject;
            if (!!self.partnerObject.name) {
                self.breadcrumbName = self.plannerObject.name;
            }
            self.partnerBreadcrumb.location = '/system/partners/edit/' + self.partnerObject.id + '/planner';
            self.partnerBreadcrumb.name = self.partnerObject.name;
            self.updateRequiredFields();
            self.loadingIndicator.show = false;
        });
    };
    self.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };
    self.$onInit = function () {
        // This is two-screens deep from the partners list - add a
        // breadcrumb back to the partner
        self.partnerBreadcrumb = {
            location: '',
            name: '...',
            params: null
        };
        BreadcrumbService.addBreadcrumb(self.partnerBreadcrumb);
        // This planner's breadcrumb
        self.breadcrumbName = 'New Planner';
        BreadcrumbService.editService = PartnerEditService;
        self.editService = PartnerEditService;
        getPlannerEditData();
    };
    self.$postLink = function () {
        $timeout(function () {
            PartnerEditService.editorForm = self.editorForm;
        });
    };
    PartnerEditService.saveDisabled = function () {
        if (self.plannerObject && !self.plannerObject.deliveryEndpoint && !self.plannerObject.emailEndpoint) {
            return true;
        }
        return requiredFields.reduce(function (accum, field) {
            return accum || self.plannerObject && !(UtilsService.hasData(self.plannerObject[field]));
        }, false);
    };
    self.deliveryEndpointChange = function () {
        delete self.plannerObject.passwordExpression;
        delete self.plannerObject.targetPathExpression;
        delete self.plannerObject.userNameExpression;
    };
    self.onSave = function () {
        self.loadingIndicator.show = true;
        PartnerEditService
            .savePartnerPlanner(self.plannerObject)
            .then(function () {
            self.breadcrumbName = self.plannerObject.name;
            self.plannerObject = PartnerEditService.plannerObject;
            self.loadingIndicator.show = false;
        });
    };
    self.onRevert = function () {
        PartnerEditService.revertPartnerPlanner();
        self.plannerObject = PartnerEditService.plannerObject;
    };
    self.onClose = function () {
        PartnerEditService.closePlannerEditView();
    };
    self.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () {
                var isProcessing = self.loadingIndicator.show;
                var isNew = $routeParams.id <= -1;
                var isPristine = PartnerEditService.editorForm && PartnerEditService.editorForm.$pristine;
                var saveDisabled = PartnerEditService.saveDisabled && PartnerEditService.saveDisabled() === true;
                return !isProcessing && (isNew || !isPristine) && !saveDisabled;
            },
            onClick: self.onSave
        },
        {
            label: 'Revert',
            enabled: function () {
                var isProcessing = self.loadingIndicator.show;
                var isNew = $routeParams.id <= -1;
                var isPristine = PartnerEditService.editorForm && PartnerEditService.editorForm.$pristine;
                return !isProcessing && (isNew || !isPristine);
            },
            onClick: self.onRevert
        },
        {
            label: 'Close',
            enabled: function () { return !self.loadingIndicator.show; },
            onClick: self.onClose
        }
    ];
    self.onStepperChanged = function (object, prop, min, max) {
        var value = object[prop];
        if (!value) {
            object[prop] = min;
        }
        else if (!_.isNil(max) && value > max) {
            object[prop] = max;
        }
        else if (!_.isNil(min) && value < min) {
            object[prop] = min;
        }
    };
}
angular.module('prism-ui.partner').component('partnerPlannerEditor', {
    templateUrl: 'system/partner/editor/components/view/planner/editor/partner-planner-editor-template.html',
    controller: PartnerPlannerEditorController,
    bindings: {},
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: partner-planner-searchview-component.js
 *
 * Created by psnyder on 02/15/17.
 */
'use strict';
function PartnerPlannerSearchViewController($location, uiGridConstants, PartnerEditService, ModalService, NavbarUtilService, UtilsService) {
    var self = this;
    //=================//
    // Lifecycle Hooks //
    //=================//
    self.$onInit = function () {
        self.queryForGridData();
    };
    //==========//
    // Pacifier //
    //==========//
    self.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };
    //======//
    // Grid //
    //======//
    self.gridApi = null;
    self.searchText = null;
    self.gridColumnDefs = [
        {
            field: 'id',
            type: 'number',
            width: '60',
            displayName: 'ID',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'name',
            width: '*',
            displayName: 'Name',
            sort: {
                direction: 'asc',
                priority: 1
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'enabledFlag',
            type: 'boolean',
            maxWidth: 95,
            displayName: 'Enabled',
            cellTemplate: 'components/visual/grid/radio-button-template.html'
        },
        {
            field: 'lookBack',
            type: 'number',
            width: 100,
            displayName: 'Back',
            cellTemplate: 'components/visual/grid/day-count-template.html'
        },
        {
            field: 'lookForward',
            type: 'number',
            width: 100,
            displayName: 'Forward',
            cellTemplate: 'components/visual/grid/day-count-template.html'
        },
        {
            field: 'scheduleLabel',
            width: 245,
            displayName: 'Schedule / Interval',
        },
        {
            field: 'nextRun',
            width: 220,
            maxWidth: 220,
            displayName: 'Next Run',
            cellFilter: 'amDateFormat:"MMM D, YYYY, h:mm A"',
            sort: {
                direction: 'desc',
                priority: 0
            },
            sortingAlgorithm: function (a, b) {
                return ((!!a ? new Date(a).getTime() : 0) -
                    (!!b ? new Date(b).getTime() : 0));
            },
            cellTemplate: 'system/partner/editor/components/view/planner/searchView/gridTemplates/next-run-cell-template.html'
        },
        {
            field: 'xslTemplate.name',
            width: '*',
            displayName: 'XSL Template',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'emailEndpoint.name',
            width: '*',
            displayName: 'Email Endpoint',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'deliveryEndpoint.name',
            width: '*',
            displayName: 'Delivery Endpoint',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];
    self.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        multiSelect: false,
        columnDefs: self.gridColumnDefs,
        onRegisterApi: function (gridApi) {
            self.gridApi = gridApi;
            self.gridApi.grid.registerRowsProcessor(self.processGridFilter, 200);
        },
        rowTemplate: 'system/partner/editor/components/view/planner/searchView/gridTemplates/planner-row-template.html',
        data: []
    };
    self.onRowDblClick = function (row) {
        self.editPlanner(row.entity.id);
    };
    self.filterGrid = function (searchText) {
        if (searchText !== null) {
            self.searchText = searchText.toLowerCase();
        }
        self.gridApi.selection.clearSelectedRows();
        self.gridApi.grid.refresh();
    };
    self.processGridFilter = function (renderableRows) {
        renderableRows.forEach(function (row) {
            row.visible = (self.searchText === null) ?
                true :
                row.entity.name.toLowerCase().indexOf(self.searchText) !== -1;
        });
        return renderableRows;
    };
    self.createNextRunLabel = function (planner) {
        if (!planner.enabledFlag || !UtilsService.hasData(planner.nextRun)) {
            return null;
        }
        var runByDate = new Date(planner.nextRun).valueOf();
        if (runByDate >= Date.now()) {
            return runByDate;
        }
        else {
            return null;
        }
    };
    //======//
    // Data //
    //======//
    self.queryForGridData = function () {
        self.loadingIndicator.show = true;
        PartnerEditService.getPlannerSearchViewData().then(function (plannerData) {
            self.gridOptions.data = plannerData.planners;
            self.partnerObject = plannerData.partnerObject;
            self.searchText = $location.search().searchText || null;
            self.filterGrid(self.searchText);
            self.loadingIndicator.show = false;
        });
    };
    //=================//
    // Planner Actions //
    //=================//
    self.newPlanner = function () {
        $location.url('/system/partners/edit/' + self.partnerObject.id + '/planner/edit/-1');
    };
    self.editPlanner = function (id) {
        $location.url('/system/partners/edit/' + self.partnerObject.id + '/planner/edit/' + id);
    };
    self.deleteSelectedPlanner = function () {
        PartnerEditService.deletePlanner(self.gridApi.selection.getSelectedRows()[0]).then(function () {
            self.queryForGridData();
        });
    };
    var showDeleteConfirmationModal = function () {
        ModalService.showMessageModal({
            messageText: 'Are you sure you want to delete "' + self.gridApi.selection.getSelectedRows()[0].name + '"?',
            title: 'Delete Partner Planner',
            windowClass: 'confirm-modal-sm',
            showOK: true,
            okText: 'Yes',
            pullCancelLeft: true
        }, function () { self.deleteSelectedPlanner(); }, function () { });
    };
    //=========//
    // Toolbar //
    //=========//
    self.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: function () { return true; },
            onClick: function () { self.newPlanner(); },
        },
        {
            label: 'Edit',
            enabled: function () { return self.gridApi.selection.getSelectedCount() === 1; },
            onClick: function () { self.editPlanner(self.gridApi.selection.getSelectedRows()[0].id); },
        },
        {
            label: 'Delete',
            enabled: function () { return self.gridApi.selection.getSelectedCount() >= 1; },
            onClick: function () { showDeleteConfirmationModal(); },
        }
    ];
    // Navbar search button click handler
    NavbarUtilService.viewSearchFunction = self.queryForGridData;
}
angular.module('prism-ui.partner').component('partnerPlannerSearchView', {
    templateUrl: 'system/partner/editor/components/view/planner/searchView/partner-planner-searchview-template.html',
    controller: PartnerPlannerSearchViewController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: new-delivery-endpoint-modal-component.js
 *
 * Created by rsorensen-lb on 5/12/17.
 */
'use strict';
function NewDeliveryEndpointModalController(PartnerEditService) {
    var self = this;
    self.$onInit = function () {
        self.supportedEndpointTypes = self.resolve.supportedEndpointTypes;
        self.selectedEndpointType = '';
    };
    self.onCreate = function () {
        self.close({ $value: self.selectedEndpointType });
    };
    self.onCancel = function () {
        self.dismiss({ $value: 'cancel' });
    };
    self.canCreate = function () {
        return self.selectedEndpointType !== '' && !self.modalForm.$pristine;
    };
    self.getLabel = function (endpointType) {
        return PartnerEditService.getEndpointTypeLabel(endpointType);
    };
}
angular.module('prism-ui.partner').component('newDeliveryEndpointModal', {
    templateUrl: 'system/partner/editor/components/view/deliveryEndpoints/searchView/modals/new-delivery-endpoint-modal-template.html',
    controller: NewDeliveryEndpointModalController,
    bindings: {
        resolve: '<',
        // these correspond to their synonymous counterparts in
        // $uibModalInstance and are automatically provided by
        // $uibModal.open()
        close: '&',
        dismiss: '&'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: content-seasonvolume-editor-component.js
 *
 * Created by randysorensen on 7/25/17.
 */
'use strict';
function ContentSeasonVolumePropertiesController(_, $routeParams, $timeout, $route, ContentEditService, DynamicPropertiesService, UtilsService, TranslatableMetadataService) {
    var self = this;
    self.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };
    self.requiredFields = ['name', 'sequenceNumber'];
    self.metadataComponentsMap = {};
    //======//
    // Data //
    //======//
    var getMetadata = function () {
        // get season/volume metadata components map, only after
        // the edit data has been loaded
        return ContentEditService.getSeasonVolumeComponentsMap().then(function (componentsMap) {
            self.metadataComponentsMap = componentsMap;
        });
    };
    var getData = function () {
        return ContentEditService.getSeasonVolumeEditData()
            .then(function () {
            self.seasonVolume = ContentEditService.seasonVolumeObject;
            TranslatableMetadataService.setDataObject(self.seasonVolume);
            return DynamicPropertiesService.queryForProperties();
        }).then(function () {
            self.maxValueLength = DynamicPropertiesService.getPropValueAsInt('content.seasonVolume.maxValueLength', -1);
            self.maxShortDescLength = DynamicPropertiesService.getPropValueAsInt('content.seasonVolume.maxShortDescLength', -1);
            self.maxLongDescLength = DynamicPropertiesService.getPropValueAsInt('content.seasonVolume.maxLongDescLength', -1);
        });
    };
    var copyMetadataInstanceValues = function () {
        if (!self.seasonVolume.metadata) {
            self.seasonVolume.metadata = {
                properties: {}
            };
        }
        _.forEach(self.metadataComponentsMap, function (component, name) {
            var instanceValue = component.instanceData.value;
            if (instanceValue) {
                if (!self.seasonVolume.metadata.properties[name]) {
                    self.seasonVolume.metadata.properties[name] = {
                        // these are required by the metadata DTO
                        valueOverridden: false,
                        required: false,
                    };
                }
                self.seasonVolume.metadata.properties[name].value = instanceValue;
            }
        });
    };
    var requiredFieldsArePopulated = function () {
        return self.requiredFields.reduce(function (accum, field) {
            return accum && UtilsService.hasData(self.seasonVolume[field]);
        }, true);
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    self.$onInit = function () {
        self.loadingIndicator.show = true;
        getData().then(function () {
            var requiredFields = DynamicPropertiesService.getPropValueAsArray('translatable.text.season.volume.required.properties', []);
            self.translatableMetadataFields = [
                {
                    name: 'value',
                    title: 'Value',
                    maxChars: self.maxValueLength,
                    required: _.includes(requiredFields, 'value'),
                },
                {
                    name: 'shortDescription',
                    title: 'Short Description',
                    maxChars: self.maxShortDescLength,
                    required: _.includes(requiredFields, 'shortDescription'),
                },
                {
                    name: 'longDescription',
                    title: 'Long Description',
                    maxChars: self.maxLongDescLength,
                    required: _.includes(requiredFields, 'longDescription'),
                },
            ];
            getMetadata().then(function () {
                if (!self.seasonVolume.id) {
                    self.editorForm.$setDirty();
                }
                $timeout(function () {
                    // if the above promises resolve too quickly,
                    // a $timeout() is required to shut the
                    // pacifier off
                    self.loadingIndicator.show = false;
                });
            });
        });
    };
    self.$onDestroy = function () {
    };
    self.$postLink = function () {
        $timeout(function () {
            ContentEditService.editorForm = self.editorForm;
        });
    };
    //=========//
    // Toolbar //
    //=========//
    self.toolbarButtons = [
        {
            label: 'Save',
            enabled: function () {
                var isDirty = self.editorForm && self.editorForm.$dirty;
                return self.seasonVolume && requiredFieldsArePopulated() && isDirty;
            },
            onClick: function () {
                self.loadingIndicator.show = true;
                copyMetadataInstanceValues();
                TranslatableMetadataService.preSave();
                ContentEditService.saveSeasonVolume().then(function (newSeasonVolume) {
                    // update route params with ID
                    var newRouteParams = {};
                    newRouteParams[$routeParams.seasonId ? 'seasonId' : 'volumeId'] = newSeasonVolume.id;
                    $route.updateParams(newRouteParams);
                    // refresh custom-metadata bindings on page
                    self.seasonVolume = ContentEditService.seasonVolumeObject;
                    TranslatableMetadataService.dataObjectSaved(self.seasonVolume);
                    getMetadata().then(function () {
                        self.loadingIndicator.show = false;
                    });
                });
            },
        },
        {
            label: 'Revert',
            enabled: function () {
                var isNew = !self.seasonVolume || !self.seasonVolume.id;
                var isDirty = self.editorForm && self.editorForm.$dirty;
                return isNew || isDirty;
            },
            onClick: function () {
                self.loadingIndicator.show = true;
                ContentEditService.revertSeasonVolume();
                self.seasonVolume = ContentEditService.seasonVolumeObject;
                TranslatableMetadataService.dataObjectReverted(self.seasonVolume);
                // refresh custom-metadata components on page
                getMetadata().then(function () {
                    self.loadingIndicator.show = false;
                });
            },
        },
        {
            label: 'Close',
            enabled: function () {
                return true;
            },
            onClick: function () {
                ContentEditService.closeSeasonVolumeEditor();
            },
        },
    ];
    //================//
    // Template Logic //
    //================//
    self.isSeason = function () {
        return $routeParams.seasonId !== undefined;
    };
}
angular
    .module('prism-ui.content')
    .component('contentSeasonVolumeProperties', {
    bindings: {},
    controller: ContentSeasonVolumePropertiesController,
    templateUrl: 'meta/content/editor/components/view/seasonvolume/editor/components/view/properties/content-seasonvolume-properties-template.html'
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 2/27/15,
 * Refactored by kyang on 9/24/20
 */
function LoginController(_, $window, LoginEditService, EchoService, SamlResourceFactory, Rx) {
    var _this = this;
    var updateServerStatus = function (newServerStatus) {
        if (newServerStatus.serverResponded) {
            LoginEditService.removeError('serverDown');
            _this.serverDown = false;
        }
        else { // If server didn't respond yet...
            if (newServerStatus.response === undefined) {
                LoginEditService.setError('serverDown', 'Checking server status...');
            }
            else { // and server failed to respond...
                LoginEditService.setError('serverDown', 'Cannot login.  Failed to connect to the server.');
                console.error('Failed to connect to the server. Response:');
                console.error(newServerStatus.response);
                LoginEditService.serverDown = true;
            }
        }
    };
    this.toggleLoginType = function () {
        if (_this.isSamlEnabled && _this.loginType !== 'saml') {
            _this.loginType = 'saml';
        }
        else {
            _this.loginType = 'system';
        }
    };
    this.getTopLogo = function () {
        return {
            href: $window.__wfcConfig.topLogoHref,
            width: $window.__wfcConfig.topLogoWidth,
            height: $window.__wfcConfig.topLogoHeight,
        };
    };
    this.getBottomLogo = function () {
        return {
            href: $window.__wfcConfig.bottomLogoHref,
            width: $window.__wfcConfig.bottomLogoWidth,
            height: $window.__wfcConfig.bottomLogoHeight,
        };
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    var onErrorsChanged = function (errors) {
        _this.errors = errors;
    };
    this.$onInit = function () {
        _this.destroyObservable = new Rx.Subject();
        _this.serverDown = false; // Let user try to login before server status is verified
        SamlResourceFactory.isSamlEnabled().$promise
            .then(function (enabledResponse) {
            _this.isSamlEnabled = enabledResponse.isSamlEnabled;
        })
            .finally(function () {
            _this.loginType = (_this.isSamlEnabled) ? 'saml' : 'system';
        });
        LoginEditService.errorObservable
            .takeUntil(_this.destroyObservable)
            .subscribeOnNext(onErrorsChanged);
        EchoService.initialize();
        EchoService.registerDataUpdateCallback(updateServerStatus);
    };
    this.$onDestroy = function () {
        _this.destroyObservable.onCompleted();
        EchoService.unregisterDataUpdateCallback(updateServerStatus);
    };
}
angular
    .module('prism-ui.login')
    .component('login', {
    controller: LoginController,
    templateUrl: 'login/login-template.html',
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by kyang on 9/24/2020
 */
function LoginEditServiceConstructor($location, Rx, SidebarService) {
    var _this = this;
    this.errorObservable = new Rx.BehaviorSubject({});
    this.setError = function (errorName, displayText) {
        _this.errorObservable.value[errorName] = displayText;
        _this.errorObservable.onNext(_this.errorObservable.value);
    };
    this.removeError = function (errorName) {
        delete _this.errorObservable.value[errorName];
        _this.errorObservable.onNext(_this.errorObservable.value);
    };
    this.navigateToApp = function () {
        SidebarService.clearSessionData();
        if (localStorage.preLoginRoute) {
            $location.url(localStorage.preLoginRoute);
            localStorage.removeItem('preLoginRoute');
        }
        else {
            $location.path('/packages');
        }
    };
}
angular
    .module('prism-ui.login')
    .service('LoginEditService', LoginEditServiceConstructor);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: package-service.ts
 *
 * Created by randysorensen on 2/20/18.
 */
angular.module('prism-ui.package').service('PackageService', function (_, $q, ContentResourceFactory, PackageResourceFactory) {
    this.getCompletedDeliveries = function (packageObject, excludePreDeliveries) {
        return PackageResourceFactory.completedDeliveries({
            id: packageObject.id,
            excludePreDeliveries: excludePreDeliveries
        }).$promise;
    };
    this.remoteCheckIn = function (remotePath, waitForIngest) {
        if (waitForIngest === void 0) { waitForIngest = true; }
        return PackageResourceFactory.checkIn({
            path: remotePath,
            waitForIngest: waitForIngest
        }).$promise;
    };
    var getTerritories = function (partnerValues) {
        return _.flatMap(partnerValues, function (partnerValue) {
            return [partnerValue.territory];
        });
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function AsperaFileSelectController(
// external deps
_, loginService, $q, $scope, $timeout, 
// internal deps
AsperaConnectService, MediaInfoService, ModalService, NotificationService, UtilsService) {
    var _this = this;
    var resetAll = function () {
        _this.registeredFileCount = 0;
        _this.expectedFileCount = 0;
        _this.registeredFiles = {};
        if (!_this.maxFileCount) {
            _this.maxFileCount = 1;
        }
    };
    this.asperaConnectInitialized = function () {
        return AsperaConnectService.initialized;
    };
    var onAllFilesRegistered = function () {
        var asperaUploadObjects = _.map(_this.registeredFiles, 'asperaFileInfo');
        _this.dropHandler(asperaUploadObjects)
            .catch(function (errorData) {
            NotificationService.createFailureNotification("Drag and drop failed.", "" + JSON.stringify(errorData), true, -1);
        })
            .finally(function () {
            _this.loadingIndicator.show = false;
            resetAll();
        });
    };
    var getRegisteredFile = function (fileName) {
        var fileEntry = _.get(_this.registeredFiles, fileName);
        if (!fileEntry) {
            _this.registeredFiles[fileName] = {
                fileSystemItem: null,
                asperaFileInfo: null
            };
            fileEntry = _this.registeredFiles[fileName];
        }
        return fileEntry;
    };
    var registerDroppedFile = function (file) {
        var fileName = UtilsService.getFileNameFromLocalPath(file);
        var fileEntry = getRegisteredFile(fileName);
        if (file.constructor.name === 'File') {
            // this is the DOM's `File` object
            fileEntry.fileSystemItem = file;
        }
        else {
            // this is Aspera's file object
            fileEntry.asperaFileInfo = file;
        }
        if (_.get(fileEntry, 'fileSystemItem') && _.get(fileEntry, 'asperaFileInfo')) {
            fileEntry.asperaFileInfo.file = fileEntry.fileSystemItem;
            _this.registeredFileCount++;
        }
    };
    var validateDOMAndAsperaFileCounts = function (files) {
        var validated = true;
        if (files.length !== _this.expectedFileCount) {
            NotificationService.createFailureNotification("Error: There was a problem adding the dropped files.");
            validated = false;
            console.error("DOM and Aspera file drop counts don't match");
        }
        return validated;
    };
    var validateMaxFileCount = function (files) {
        var validated = true;
        if (files.length > _this.maxFileCount) {
            NotificationService.createFailureNotification("Error: This drop zone accepts at most " + _this.maxFileCount + " file(s) at a time.");
            validated = false;
        }
        return validated;
    };
    var validateFileExtensions = function (files) {
        var validated = true;
        var fileNames = _.map(files, 'name');
        _.forEach(fileNames, function (fileName) {
            var fileExtension = UtilsService.getFileExtension(fileName);
            // TODO: AB#88420 Use UtilsService regex to check any capitalization
            var fileExtensionIsValid = _.includes(_this.fileExtensions, fileExtension);
            validated = validated && fileExtensionIsValid;
        });
        if (!validated) {
            NotificationService.createFailureNotification("Error: This drop zone only accepts files with the following extensions: " +
                ("[ " + UtilsService.filtersToPrettyString(_this.fileExtensions) + " ]"));
        }
        return validated;
    };
    var validateDroppedFiles = function (files) {
        var validated = true;
        if (_this.expectedFileCount !== 0) {
            validated =
                validateDOMAndAsperaFileCounts(files) &&
                    validateMaxFileCount(files) &&
                    validateFileExtensions(files);
        }
        else {
            _this.expectedFileCount = files.length;
        }
        return validated;
    };
    //
    // Called twice per drag & drop event - once to handle the DOM
    // event and once to handle the Aspera event, both for the
    // same files. See the two wrapper handlers below; we need data
    // from both events, and we use this to capture that data.
    //
    var commonDropHandler = function ($event, fileContainer, filesPropPath) {
        if (_.get($event, 'type') === 'drop') {
            _this.loadingIndicator.show = true;
            $event.stopPropagation();
            $event.preventDefault();
            var files = _.chain(fileContainer).get(filesPropPath).toArray().value();
            if (validateDroppedFiles(files)) {
                _.forEach(files, registerDroppedFile);
                if (_this.registeredFileCount === _this.expectedFileCount) {
                    onAllFilesRegistered();
                }
            }
            else {
                _this.loadingIndicator.show = false;
                resetAll();
            }
        }
    };
    //
    // Aspera Connect sends an event like this:
    //
    //  {
    //      event: <DragEvent>{
    //      },
    //      files: {
    //          dataTransfer: {
    //              files: <Object>[...]
    //      }
    //  }
    //
    // The files.dataTransfer.files property is NOT an array of
    // File objects, but rather just descriptors with a subset of
    // the properties of the JS File class.
    //
    // The DragEvent has a dataTransfer property but it is empty.
    //
    // Thus we cannot use information from this event to read the
    // contents of files. However we still need it for use with
    // Aspera Connect.
    //
    var asperaDropEventHandler = function ($asperaEvent) {
        var $event = _.get($asperaEvent, 'event');
        commonDropHandler($event, $asperaEvent, 'files.dataTransfer.files');
    };
    //
    // DOM sends an event like this:
    //
    //  <DragEvent>{
    //      ...
    //      dataTransfer: {
    //          files: <File>[...]
    //      },
    //      ...
    //  }
    //
    // We need these file objects, sent from the DOM, because we
    // can read their contents. We can't do that with the objects
    // that Aspera sends.
    //
    var domDropEventHandler = function ($event) {
        commonDropHandler($event, $event, 'dataTransfer.files');
    };
    this.getToolTip = function () {
        var tooltip = "";
        if (!_this.asperaConnectInitialized()) {
            tooltip = "AsperaConnect<br/> is not initialized";
        }
        else {
            var validExtensions = '(any)';
            if (_.size(_this.fileExtensions)) {
                validExtensions = "[" + UtilsService.filtersToPrettyString(_this.fileExtensions) + "]";
            }
            tooltip = "Accepted extensions: " + validExtensions;
        }
        return tooltip;
    };
    this.$onInit = function () {
        resetAll();
        _this.loadingIndicator = {
            backdrop: false,
            show: false,
            size: 'lg',
            title: '',
            message: ''
        };
    };
    this.$postLink = function () {
        $timeout(function () {
            // add standard DOM event listener
            var dropZone = document.getElementById(_this.dropZoneId);
            dropZone.addEventListener('drop', domDropEventHandler, false);
            // add Aspera's proprietary event listener
            AsperaConnectService.setDropTarget(_this.dropZoneId, asperaDropEventHandler);
        });
    };
}
angular.module('prism-ui.components').component('asperaFileSelect', {
    controller: AsperaFileSelectController,
    templateUrl: 'components/asperaConnect/aspera-file-select-template.html',
    bindings: {
        dropHandler: '<',
        dropZoneId: '<',
        dropZoneSize: '<',
        fileExtensions: '<',
        maxFileCount: '<',
        showDropZone: '<',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.components').service('CollaboratorsService', function (_, CollaboratorsResourceFactory, ContentResourceFactory, $q) {
    this.permissionViewState = 'COLLABORATOR_VIEW_STATE';
    this.originalEditData = {};
    this.newActor = null;
    this.getAllCollaborators = function (queryParams, queryHandler) {
        return CollaboratorsResourceFactory.all(queryParams, queryHandler).$promise;
    };
    this.getCollaboratorById = function (queryParams, queryHandler) {
        return CollaboratorsResourceFactory.byId(queryParams, queryHandler).$promise;
    };
    this.getCollaboratorRoles = function (queryParams, queryHandler) {
        return CollaboratorsResourceFactory.roles(queryParams, queryHandler).$promise;
    };
    this.getCollaboratorRole = function (queryParams) {
        return CollaboratorsResourceFactory.getRole(queryParams).$promise;
    };
    this.saveCollaboratorRole = function (collaboratorRole) {
        return CollaboratorsResourceFactory.saveRole(collaboratorRole).$promise;
    };
    this.updateCollaboratorRole = function (collaboratorRole) {
        return CollaboratorsResourceFactory.updateRole(collaboratorRole).$promise;
    };
    this.deleteCollaboratorRole = function (queryParams, collaboratorRole) {
        return CollaboratorsResourceFactory.deleteRole(queryParams, collaboratorRole).$promise;
    };
    this.deleteCollaboratorRoles = function (collaboratorRoles) {
        var collaboratorRoleDeletePromises = [];
        collaboratorRoles.forEach(function (role) {
            var criteria = {
                id: role.id
            };
            collaboratorRoleDeletePromises.push(CollaboratorsResourceFactory.deleteRole(criteria, role.id).$promise);
        });
        return $q.all(collaboratorRoleDeletePromises);
    };
    this.saveNewCollaborator = function (collaborator, queryHandler) {
        return CollaboratorsResourceFactory.save({}, collaborator, queryHandler).$promise;
    };
    this.updateCollaborator = function (collaborator, queryHandler) {
        return CollaboratorsResourceFactory.update({}, collaborator, queryHandler).$promise;
    };
    this.deleteCollaborator = function (collaborator, queryHandler) {
        return CollaboratorsResourceFactory.delete({}, collaborator, queryHandler).$promise;
    };
    this.getContentActors = function (criteria, queryHandler) {
        return ContentResourceFactory.getActorsByContent(criteria, queryHandler).$promise;
    };
    this.saveContentActor = function (criteria, actor) {
        return ContentResourceFactory.saveActorByContent(criteria, actor).$promise;
    };
    this.deleteContentActors = function (criteria, actors) {
        return ContentResourceFactory.deleteActorsByContent(criteria, actors).$promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
function ContentCollaboratorGridViewController(_, $routeParams, uiGridConstants, CollaboratorViewDataTransformer, NotificationService, ModalService, CollaboratorsService, NavbarUtilService, PaginationService, $location, ContentEditService) {
    var _this = this;
    var contentPathParam = _.isEqual(_.get(this, 'content.type'), 'Series') ? 'series' : 'movies';
    this.isSeason = !_.isNil(_.get(this, 'season'));
    this.isSeries = !_.isNil(_.isEqual(_.get(this, 'content.type'), 'Series'));
    var handleGridDataQuery = function (gridData, responseHeaders) {
        PaginationService.parseResponseHeaders(responseHeaders());
        PaginationService.pageData = gridData;
        _this.gridOptions.data = gridData;
        if (_this.isSeason) {
            ContentEditService.contentObject = _this.content;
            ContentEditService.seasonObject = _this.season;
            ContentEditService.setContentSeasonBreadcrumbs();
        }
    };
    var getCriteria = function (includeAll) {
        var criteria = {
            id: $routeParams.id,
            searchString: $location.search().searchText
        };
        if (includeAll) {
            criteria.fetchLimit = 0;
        }
        else {
            var offset = _this.pagingOptions.pageSize * (_this.pagingOptions.currentPage - 1);
            criteria.seasonId = $routeParams.seasonId || undefined;
            criteria.fetchLimit = _this.pagingOptions.pageSize;
            criteria.fetchOffset = offset;
        }
        return criteria;
    };
    var getData = function (includeAll) {
        if (includeAll === void 0) { includeAll = false; }
        return CollaboratorsService.getContentActors(getCriteria(includeAll), handleGridDataQuery);
    };
    var saveCollaboratorRole = function (actor) {
        CollaboratorsService.updateCollaboratorRole(actor);
    };
    var handleNewActorSelection = function (newActors) {
        _this.loadingIndicator.show = true;
        if (_this.isSeason && !_.isNil(_this.season)) {
            // combine the added actors that the user selected with the existing series-level actors and create an
            // array of unique values based on id
            _this.season.actors = _.unionWith(_this.season.actors, newActors, function (seasonActor, newActor) {
                return _.isEqual(seasonActor.id, newActor.id);
            });
            // Save the entire season with the updated array of actors
            ContentEditService.saveSeason(_this.season).then(function (savedSeason) {
                // set the component's season to the saved season
                _this.season = savedSeason;
                // refresh the data in the list
                getData(false);
            }).finally(function () {
                _this.loadingIndicator.show = false;
            });
        }
        else {
            var actor = {
                type: 'Actor',
                collaborator: newActors[0],
                contentId: $routeParams.id
            };
            CollaboratorsService.newActor = actor;
            // if the collaborator is saved without a character, navigate to the actor edit view to assign a character
            if (_.isNil(_.get(actor, 'collaborator.character'))) {
                $location.url("/meta/" + contentPathParam + "/edit/" + $routeParams.id + "/actor/edit/-1");
            }
            else {
                _this.loadingIndicator.show = false;
                // close the form and reload the grid
                getData(true);
            }
        }
    };
    var openAddCollaboratorModal = function () {
        CollaboratorsService.getContentActors(getCriteria(true), function () {
        }).then(function (collaborators) {
            var availableCollaborators = collaborators;
            if (!_this.isSeason) {
                availableCollaborators = undefined;
            }
            ModalService.showAddCollaboratorModal(availableCollaborators, 'actors', handleNewActorSelection, undefined, !_this.isSeason, !!_this.isSeason, !!_this.isSeries && !!_this.isSeason, true);
        });
    };
    var openConfirmModal = function (messageText, title, handler) {
        ModalService.showMessageModal({
            messageText: messageText,
            pullCancelLeft: true,
            title: title,
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, handler);
    };
    var deleteCollaborators = function () {
        var selectedActorsToDelete = _this.gridApi.selection.getSelectedRows();
        var message = 'Are you sure you want to delete Collaborator Role(s)? ';
        var title = 'Delete Collaborator Role(s)?';
        var resultHandler = function () {
            _this.loadingIndicator.show = true;
            if (_this.isSeason && !_.isNil(_this.season)) {
                _.pullAllWith(_this.season.actors, selectedActorsToDelete, function (seasonActor, selectedActorToDelete) {
                    return (_.isEqual(seasonActor.id, selectedActorToDelete.id));
                });
                // Save the entire season with the updated array of actors
                ContentEditService.saveSeason(_this.season).then(function (savedSeason) {
                    // set the component's season to the saved season
                    _this.season = savedSeason;
                    // refresh the data in the list
                    getData(false);
                }).finally(function () {
                    _this.loadingIndicator.show = false;
                });
            }
            else {
                CollaboratorsService.deleteCollaboratorRoles(selectedActorsToDelete).then(function () {
                    getData();
                    _this.gridApi.selection.clearSelectedRows();
                }).finally(function () {
                    _this.loadingIndicator.show = false;
                });
            }
        };
        openConfirmModal(message, title, resultHandler);
    };
    var onPaginationChanged = function () {
        getData();
    };
    var gridColumns = [
        {
            name: 'checkMarkRowHeaderCol',
            field: 'checkMark',
            width: '2%',
            enableColumnMenu: false,
            enableSorting: false,
            enableColumnResizing: false,
            cellTemplate: 'components/visual/grid/check-mark-template.html',
            headerCellTemplate: 'package/editor/components/view/collaborator/grid-checkbox-header-template.html'
        },
        {
            field: 'collaborator.displayName',
            width: '25%',
            displayName: 'Actor',
            sort: {
                direction: 'asc',
                priority: 0
            }
        },
        {
            field: 'collaborator.nickname',
            width: '25%',
            displayName: 'Nickname',
            enableColumnMenu: false
        },
        {
            field: 'character',
            width: '25%',
            displayName: 'Character',
            enableColumnMenu: false
        },
        {
            field: 'collaborator.iMDbNumber',
            enableColumnMenu: false,
            name: 'imdbColumn',
            displayName: 'IMDB#',
            width: '18%',
            enableSorting: false,
            enableColumnResizing: false,
            cellTemplate: 'components/visual/grid/hyperlink-template.html'
        },
        {
            field: 'disabled',
            enableColumnMenu: false,
            name: 'disabled',
            displayName: 'Disabled',
            width: '5%',
            enableSorting: false,
            enableColumnResizing: false,
            cellTemplate: "<div class=\"checkbox-grid-cell\" ng-click=\"grid.appScope.$ctrl.checkMarkCellClicked(row, $event)\">\n                                <input ng-if=\"!grid.appScope.$ctrl.isSeason\" type=\"checkbox\" ng-checked=\"COL_FIELD\"/>\n                                <label ng-if=\"!grid.appScope.$ctrl.isSeason\"></label>\n                                <div ng-if=\"grid.appScope.$ctrl.isSeason\">{{(!grid.appScope.$ctrl.isSeason) ? '' : (COL_FIELD === true) ? 'YES' : 'NO'}}</div>\n                            </div>"
        }
    ];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: true,
        columnDefs: gridColumns,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        data: []
    };
    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: function () { return true; },
            onClick: openAddCollaboratorModal
        },
        {
            label: 'Delete',
            enabled: function () { return _this.gridApi && _this.gridApi.selection.getSelectedCount() > 0; },
            onClick: deleteCollaborators
        }
    ];
    this.onRowDblClick = function (row) {
        if (!_this.isSeason) {
            $location.url("/meta/" + contentPathParam + "/edit/" + $routeParams.id + "/actor/edit/" + row.entity.id);
        }
    };
    this.checkMarkCellClicked = function (row) {
        row.entity.disabled = !row.entity.disabled;
        saveCollaboratorRole(row.entity);
    };
    this.paginationPageSizeChanged = function () {
        _this.pagingOptions.currentPage = 1;
        onPaginationChanged();
    };
    this.paginationPrevPageHandler = function () {
        --_this.pagingOptions.currentPage;
        onPaginationChanged();
    };
    this.paginationNextPageHandler = function () {
        ++_this.pagingOptions.currentPage;
        onPaginationChanged();
    };
    this.paginationDefs = {
        paginationPrevPageHandler: this.paginationPrevPageHandler,
        paginationNextPageHandler: this.paginationNextPageHandler,
        paginationPageSizeChanged: this.paginationPageSizeChanged,
        paginationJumpToPageHandler: onPaginationChanged,
        pagingOptions: PaginationService,
    };
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        PaginationService.resetToDefaultValues();
        _this.pagingOptions = PaginationService;
        NavbarUtilService.viewSearchFunction = getData;
        getData(false);
    };
    this.$onDestroy = function () {
        NavbarUtilService.viewSearchFunction = null;
    };
}
angular.module('prism-ui.components').component('contentCollaboratorGridView', {
    templateUrl: 'components/collaborators/content-collaborator-grid-view-template.html',
    bindings: {
        content: '<',
        season: '<'
    },
    controller: ContentCollaboratorGridViewController
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: file-select-component.ts
 *
 * Created by kyang on 2021-01-22.
 */
//
// Allow user to select a file from their computer, or the server.
// If file is selected from the server, it is validated before the modal closes.
// However, if file is selected locally, value is changed while validation runs.
//     Component becomes invalid until the file passes validation.
//
// TODO: AB#87913 Merge with other implementations of file upload / selection
//     file-upload == embeddable version of file-upload-modal
function FileSelectController(_, $element, $q, FileSelectService, Rx) {
    var _this = this;
    var FileSource;
    (function (FileSource) {
        FileSource["ASPERA"] = "ASPERA";
        FileSource["LOCAL"] = "LOCAL";
        FileSource["REMOTE"] = "REMOTE";
    })(FileSource || (FileSource = {}));
    var FileValidationStatus;
    (function (FileValidationStatus) {
        FileValidationStatus["NONE"] = "NONE";
        FileValidationStatus["RUNNING"] = "RUNNING";
        FileValidationStatus["PASSED"] = "PASSED";
        FileValidationStatus["FAILED"] = "FAILED";
    })(FileValidationStatus || (FileValidationStatus = {}));
    var filesToTryAdding = [];
    var fileAddErrors;
    //===================//
    // Template Response //
    //===================//
    var getStatus = function (fileValue) {
        return _.get(fileValue, 'status', FileValidationStatus.NONE);
    };
    var canSelectFileValue = function (fileValue) {
        return !_this.isDisabled && getStatus(fileValue) !== FileValidationStatus.RUNNING;
    };
    var canSelectFile = function () {
        return canSelectFileValue(_.get(_this, 'ngModelCtrl.$modelValue'));
    };
    this.isDragDropVisible = function (dropWellSource) {
        return _.get(_this, 'dragDropSource', FileSource.LOCAL) === dropWellSource;
    };
    this.isFileSourceButtonVisible = function (buttonSource) {
        return _.chain(_this)
            .get('buttonSources', [FileSource.LOCAL, FileSource.REMOTE])
            .includes(buttonSource)
            .value();
    };
    this.isFileSourceEnabled = function (fileSource) {
        return canSelectFile() && !_.includes(_this.disabledSources, fileSource);
    };
    this.canShowValidationErrorModal = function () {
        return _.get(_this, 'showValidationErrorModal', true);
    };
    this.isRemoteUploadEnabled = function () {
        return _.get(_this, 'remoteUploadEnabled', true);
    };
    //=================//
    // File Validation //
    //=================//
    this.openWarningsPrompt = function () {
        if (!_this.promptWarnings) {
            return $q.when(true);
        }
        return $q.when(_this.promptWarnings());
    };
    this.openRemoteFileModal = function () {
        return _this.openWarningsPrompt().then(function (canValidate) {
            if (canValidate) {
                FileSelectService.promptFile(_this, FileSource.REMOTE);
            }
        });
    };
    this.onAsperaFilesDropped = function (asperaFileObjects) {
        return _this.openWarningsPrompt().then(function (canValidate) {
            if (canValidate) {
                return FileSelectService.promptFile(_this, FileSource.ASPERA, asperaFileObjects);
            }
        });
    };
    this.openLocalFileModal = function () {
        return _this.openWarningsPrompt().then(function (canValidate) {
            if (canValidate) {
                FileSelectService.promptFile(_this, FileSource.LOCAL);
            }
        });
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    var onNgModelChanged = function (newValue) {
        _this.fileReplacedObservable.onNext();
        _this.loadingIndicator.show = getStatus(newValue) === FileValidationStatus.RUNNING;
        _this.ngModelCtrl.$setValidity('canSelectFile', canSelectFileValue(newValue));
        _this.ngModelCtrl.$setValidity('statusValue', getStatus(newValue) !== FileValidationStatus.FAILED);
        return newValue;
    };
    var onViewValueChanged = function (newValue) {
        _this.loadingIndicator.show = getStatus(newValue) === FileValidationStatus.RUNNING;
        _this.ngModelCtrl.$setValidity('canSelectFile', canSelectFileValue(newValue));
        _this.ngModelCtrl.$setValidity('statusValue', getStatus(newValue) !== FileValidationStatus.FAILED);
        return newValue;
    };
    this.$onInit = function () {
        _this.fileReplacedObservable = new Rx.Subject();
        _this.$element = $element;
        _this.loadingIndicator = {
            backdrop: false,
            show: false,
            size: 'lg',
            title: '',
            message: ''
        };
        FileSelectService.initialize(_this);
        _this.ngModelCtrl.$formatters.push(onNgModelChanged);
        _this.ngModelCtrl.$parsers.push(onViewValueChanged);
    };
    this.$onDestroy = function () {
        _this.fileReplacedObservable.onNext();
        _this.fileReplacedObservable.onCompleted();
        FileSelectService.cleanup(_this);
        delete _this.$element;
    };
}
angular
    .module('prism-ui.components')
    .component('fileSelect', {
    templateUrl: 'components/fileSelect/file-select-template.html',
    controller: FileSelectController,
    require: {
        ngModelCtrl: '^ngModel',
    },
    bindings: {
        /*
         Configuration
         isMultiSelect:            (boolean; optional) If true, user can select
                                   multiple files.
         validateLocalMimeTypes:   (boolean; optional) If true, component will check
                                   local files' mimeTypes instead of file extensions.
                                   // TODO: AB#88420 Change all usages to always test
                                            fileType, not mimeType
         getFileExtensions:        (function; required) Function to determine
                                   which items to show in remote file upload modal.
                                   Should return an array of file extensions to allow.
         initializeUploaderConfig: (function; required) Function to call to
                                   configure FileUploader object. It should
                                   set the filter for the local file modal.
         promptWarnings:           (function; optional) Function to call before
                                   user can select a file; should return a promise.
                                   Promise should resolve to true if user decides
                                   to select files; false if they don't want to.
         getLocalFilePreValidationErrors: (function; required) Function to call
                                          when a FileUploader filter blocks local
                                          file selection.
                                          Should return errors to be displayed.
         remoteUploadEnabled:      (boolean; optional) If false, local uploads will
                                   be disabled. Defaults to true.
         validateRemoteFile: (function; required) Function to return a promise.
                             Promise should be resolved with errors & warnings
                             to be displayed.
                             Called once for each remote file that's selected.
         validateAsperaFile: (function; optional) Function to return a promise.
                             Promise should be resolved with errors & warnings
                             to be displayed.
                             Called once for each Aspera file that's selected.
                             Required if dragDropSource == 'ASPERA'
         validateLocalFile:  (function; required) Function to return a promise.
                             Promise should be resolved with errors & warnings
                             to be displayed.
                             Called once for each local file that's selected.
         ngModel: (any; required) Value == object with 4 properties:
                  - type:    (string) FileSource string that shows if the file
                             is from local computer or the server.
                             Value determines the format of the "file" object.
                  - files:   (JS5Object) The files that were selected.
                             Always an array, even if allowMultipleFiles == false.
                  - results: (any | JS5Object[]) Validation results. If any
                             validation promise is rejected, property == the
                             rejected value.
                  - status:  (string) FileValidationStatus string that shows
                             if this file has already been validated.
                  Replace the value to cancel local file validation.
                  Handled by ngModelCtrl.
         */
        isMultiSelect: '<?',
        validateLocalMimeTypes: '<?',
        getFileExtensions: '&',
        initializeUploaderConfig: '&',
        promptWarnings: '&?',
        getLocalFilePreValidationErrors: '&',
        remoteUploadEnabled: '<?',
        validateRemoteFile: '&',
        validateAsperaFile: '&?',
        validateLocalFile: '&',
        // Component attributes
        isDisabled: '<?ngDisabled',
        /*
         Display Attributes
         buttonSources:   (string[]; optional) Array of FileSource strings.
                          Only the buttons that support the specified FileSources
                          will be shown. Default is to show all FileSource buttons.
         dragDropSource:  (string; optional) Specifies the upload method to use
                          for this drop-zone. If value is null, drop well will not
                          be shown. Defaults to 'LOCAL'.
         disabledSources: (string[]; optional) Array of FileSource strings.
                          Disables the buttons & drop-zone for the listed
                          FileSources.
         dragDropId:      (string; optional) Id to set for the drag-drop zone.
                          Required if dragDropSource == 'ASPERA'
         dragDropClass:   (string; optional) Class to add to the drag-drop zone.
                          Can be used to resize the drop-zone.
         buttonTooltips:  (JS5Object; optional) Object of tooltips to display
                          for each file selection button.
                          - Key == FileSource
                          - value == tooltip to display for that source
         showValidationErrorModal: (boolean; optional) If true, will display a
                                   modal with validation failures / warnings.
                                   If false, modal will only be shown if local
                                   file could not be uploaded. Also, if false:
                                   user will not be able to confirm validations
                                   that only have warnings. Defaults to true.
         */
        buttonSources: '<?',
        dragDropSource: '<?',
        disabledSources: '<?',
        dragDropId: '<?',
        dragDropClass: '<?',
        buttonTooltips: '<?',
        showValidationErrorModal: '<?',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
function FileUploadController(
// external deps
_, FileItem, FileUploader, 
// internal deps
AuthFactory, EndPointService, ModalService, FileUploadService) {
    var _this = this;
    var makeFileExtensionsLowerCase = function () {
        _.forEach(_this.fileExtensions, function (value, index) {
            _this.fileExtensions.splice(index, 1, value.toLowerCase());
        });
    };
    var showMessageModal = function (title, message) {
        var messageModalOpts = {
            messageText: message,
            pullCancelLeft: true,
            title: title,
            showOK: true,
            okText: 'Close',
            showCancel: false,
            windowClass: 'confirm-modal-sm',
        };
        ModalService.showMessageModal(messageModalOpts);
    };
    //===================//
    // File Upload Impl. //
    //===================//
    // Angular FileUploader hooks are prefixed with 'afu'.
    var afuWhenAddingFileFailed = function (item, filter, options) {
        //
        // Note: the 'item' parameter is a "File" object, not a
        // "FileItem" object.
        //
        showMessageModal(item.name, "'" + item.name + "' could not be selected. It may not match the specified type, '" + _this.typeName + "'.");
    };
    var afuAfterAddingAll = function (addedItems) {
        _.forEach(addedItems, function (item) {
            if (!_.includes(_.map(_this.selectedItems, 'file.name'), item.file.name)) {
                _this.selectedItems.push(item);
            }
            else {
                showMessageModal("Ignoring Duplicate", "Ignoring " + item.file.name + " as it is already in the upload list.");
            }
        });
        // this.selectedItems = _.concat(this.selectedItems, addedItems);
    };
    var afuSuccessItem = function (item, response, status, headers) {
        var uploadPath = response.path;
        // could be useful for support purposes to have the remote
        // upload path shown on the JS console
        console.info("'" + item.file.name + "' uploaded to remote path: '" + uploadPath + "'");
        _this.completedItems.push({
            name: item.file.name,
            remotePath: uploadPath,
        });
    };
    var afuErrorItem = function (item, response, status, headers) {
        var errorMsg = ["The server was unable to receive the file(s)."];
        if (status >= 400 && status < 500) {
            //
            // When an Nginx error occurs it sends a simple HTML page
            // in which the title contains the error message. This
            // attempts to parse the error out and return it.
            //
            errorMsg.push("Response: \"" + $(response).filter('title').text() + "\"");
        }
        else if (status > 0) {
            errorMsg.push("(status: " + status + ")");
        }
        showMessageModal('Upload Failed', errorMsg);
        _this.resetUploader();
    };
    var afuProgressAll = function (progress) {
        _this.progress = progress;
        _this.onUploadProgress({ progress: progress });
    };
    var afuCompleteAll = function () {
        _this.onUploadProgress({ progress: 100 });
        _this.onFilesUploaded({ uploadedFiles: _this.completedItems });
    };
    var addFiltersToUploader = function () {
        _this.uploaderConfig.filters.push({
            name: 'extensionFilter',
            fn: function (item, options) {
                var fileName = _.get(item, 'name', null);
                if (fileName && _.includes(fileName, '.')) {
                    var fileExtension = _.reverse(fileName.split('.'))[0].toLowerCase();
                    if (_.includes(_this.fileExtensions, fileExtension)) {
                        return true;
                    }
                }
                return false;
            },
        });
    };
    var createFileUploader = function () {
        var uploaderConfig = new FileUploader();
        uploaderConfig.url = EndPointService.fileUploadEndPoint;
        uploaderConfig.alias = 'multipart-content';
        uploaderConfig.autoUpload = false;
        uploaderConfig.removeAfterUpload = true;
        uploaderConfig.isHTML5 = true;
        uploaderConfig.formData = {};
        uploaderConfig.headers = {
            'Authorization': AuthFactory.getAuthHeader(),
            'Accept': 'application/json, text/plain, */*',
        };
        // set callback hooks
        uploaderConfig.onWhenAddingFileFailed = afuWhenAddingFileFailed;
        uploaderConfig.onAfterAddingAll = afuAfterAddingAll;
        uploaderConfig.onSuccessItem = afuSuccessItem;
        uploaderConfig.onErrorItem = afuErrorItem;
        uploaderConfig.onProgressAll = afuProgressAll;
        uploaderConfig.onCompleteAll = afuCompleteAll;
        return uploaderConfig;
    };
    //================//
    // Template Logic //
    //================//
    this.getSelectedNames = function () {
        return _.map(_this.selectedItems, 'file.name').join(', ');
    };
    this.beginUpload = function () {
        _this.completedItems = [];
        console.info("uploading " + _this.getSelectedNames());
        _this.uploaderConfig.uploadAll();
    };
    this.resetUploader = function () {
        _this.selectedItems = [];
        _this.completedItems = [];
        _this.progress = 0;
        _this.uploaderConfig.cancelAll();
        _this.uploaderConfig.clearQueue();
    };
    this.canUpload = function () { return _this.selectedItems.length > 0; };
    this.canReset = function () { return _this.selectedItems.length > 0; };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        makeFileExtensionsLowerCase();
        _this.selectedItems = [];
        _this.completedItems = [];
        _this.progress = 0;
        _this.uploaderConfig = createFileUploader();
        addFiltersToUploader();
        FileUploadService.beginUpload = _this.beginUpload;
        FileUploadService.resetUploader = _this.resetUploader;
        FileUploadService.canUpload = _this.canUpload;
        FileUploadService.canReset = _this.canReset;
        _this.onUploaderInitialized();
    };
}
angular
    .module('prism-ui.components')
    .component('fileUpload', {
    controller: FileUploadController,
    templateUrl: 'components/fileUpload/file-upload-template.html',
    bindings: {
        //
        // Bindings:
        //
        //      fileExtensions - an array of strings specifying
        //          valid file extensions for this uploader,
        //          e.g. 'PNG' or 'xlsx'. Case insensitive.
        //
        //      typeName - a user-friendly string describing the
        //          type(s) of files accepted by this uploader,
        //          e.g. 'Image (.png, .gif, .jpg)' or
        //          'Excel Spreadsheet (.xlsx)'.
        //
        //      onUploadProgress - a callback that will be invoked
        //          when the upload progress has changed. The
        //          `progress` property ranges from 0 to 100.
        //
        //          const onUploadProgress = (progress: number): void => { /*...*/ };
        //
        //      onFilesUploaded - a callback that will be invoked
        //          when all selected files have completed
        //          uploading. `uploadedFiles` is an array listing
        //          all files that were successfully uploaded.
        //
        //          const onFilesUploaded = (uploadedFiles: JS5Object[]): void => { /*...*/ };
        //
        //          Each item in `uploadedFiles` is an object:
        //
        //          {
        //              name: <the file's name>,
        //              remotePath: <the file's remote path on the server>
        //          }
        //
        fileExtensions: '<',
        typeName: '<',
        onUploaderInitialized: '&',
        onFilesUploaded: '&',
        onUploadProgress: '&',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: file-upload-service.ts
 *
 * Created by randysorensen on 1/18/18.
 */
'use strict';
angular
    .module('prism-ui.components')
    .service('FileUploadService', function (
// external deps
_) {
    this.beginUpload = null;
    this.resetUploader = null;
    this.canUpload = null;
    this.canReset = null;
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: filename-from-path-filter.ts
 *
 * Created by randysorensen on 9/12/18.
 */
function FileNameFromPathFilter(_) {
    return function (path) {
        return _
            .chain(path)
            .split('/')
            .last()
            .value();
    };
}
angular
    .module('prism-ui.components.filters')
    .filter('fileNameFromPath', FileNameFromPathFilter);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function GridServiceConstructor(_, $timeout, uiGridSaveStateService) {
    //=========================//
    // Automatic Data Handling //
    //=========================//
    var _this = this;
    var getFullStorageKey = function (storageKeyName) {
        var trueKeyName;
        if (typeof (storageKeyName) === 'function') {
            trueKeyName = storageKeyName();
        }
        else {
            trueKeyName = storageKeyName;
        }
        return "grid.columns." + trueKeyName;
    };
    this.manageSavedColumns = function (scope, gridApi, storageKeyName) {
        $timeout(function () {
            _this.loadSavedColumns(gridApi, storageKeyName);
        });
        gridApi.colResizable.on.columnSizeChanged(scope, function () {
            _this.saveCurrentColumns(gridApi, storageKeyName);
        });
    };
    //======================//
    // Manual Data Handling //
    //======================//
    this.loadSavedColumns = function (gridApi, storageKeyName) {
        var storedSizeJson = localStorage[getFullStorageKey(storageKeyName)];
        if (storedSizeJson) {
            uiGridSaveStateService.restoreColumns(gridApi.grid, JSON.parse(storedSizeJson));
        }
    };
    this.saveCurrentColumns = function (gridApi, storageKeyName) {
        var columnSizes = uiGridSaveStateService.saveColumns(gridApi.grid);
        localStorage[getFullStorageKey(storageKeyName)] = JSON.stringify(columnSizes);
    };
}
angular.module('prism-ui.components')
    .service('GridService', GridServiceConstructor);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: json-viewer-component.ts
 *
 * Created by randysorensen on 2019-01-28.
 */
function JsonViewerController(_, uiGridConstants) {
    var _this = this;
    var parseJsonData = function (gridData, node, treeLevel) {
        _.forEach(node, function (value, propertyName) {
            var gridRow = {
                property: "" + propertyName,
                columnsContainingSearchResult: [],
                index: _this.indexSeq,
                $$treeLevel: treeLevel
            };
            _this.indexSeq++;
            if (typeof value === 'object') {
                gridRow.value = '';
                gridData.push(gridRow);
                parseJsonData(gridData, value, treeLevel + 1);
            }
            else {
                gridRow.value = "" + value;
                gridData.push(gridRow);
            }
        });
    };
    var updateSearchResults = function () {
        _this.searchResultIndex = 0;
        _this.searchResultRows = [];
        _.forEach(_this.gridOptions.data, function (rowEntity) {
            rowEntity.columnsContainingSearchResult = [];
            var rowMatchesSearchText = false;
            _.forEach(_this.gridOptions.columnDefs, function (columnDef) {
                var lowerCaseValue = _.toLower(rowEntity[columnDef.field]);
                if (_.size(_this.searchText) && _.includes(lowerCaseValue, _this.searchText)) {
                    rowMatchesSearchText = true;
                    rowEntity.columnsContainingSearchResult.push(columnDef.field);
                }
            });
            if (rowMatchesSearchText) {
                _this.searchResultRows.push(rowEntity);
            }
        });
        _this.setCurrentSearchResultIndex(_this.searchResultIndex + 1);
        _this.setSearchResultTotal(_this.searchResultRows.length);
    };
    var transformScrollToRowNumber = function (rowNumber) {
        var gridDiv = document.getElementById('jsonViewerGrid');
        var gridHeightInRows = Math.floor(gridDiv.clientHeight / _this.gridOptions.rowHeight);
        var destinationRow = rowNumber + gridHeightInRows;
        return Math.min(destinationRow - 1, _this.gridOptions.data.length - 1);
    };
    var goToCurrentSearchResult = function () {
        var resultNumber = _this.searchResultIndex;
        var resultRow = _this.searchResultRows[resultNumber];
        if (_.isNil(resultRow)) {
            // scroll to top if there's no search results
            resultRow = _this.gridOptions.data[0];
        }
        var resultRowIndex = resultRow.index;
        if (_this.scrollDirection > 0) {
            // advance the current index enough to make the result appear on top
            var scrollToIndex = transformScrollToRowNumber(resultRowIndex);
            resultRow = _this.gridOptions.data[scrollToIndex];
        }
        // this.gridApi.core.scrollTo(_.first(this.gridOptions.data[0]))
        _this.gridApi.core.scrollTo(resultRow).then(function () {
            _this.setCurrentSearchResultIndex(resultNumber + 1);
            _this.gridApi.core.refresh();
        });
    };
    //==========================//
    // Search Result Navigation //
    //==========================//
    this.findNext = function () {
        _this.searchResultIndex++;
        if (_this.searchResultIndex >= _this.searchResultRows.length) {
            _this.searchResultIndex = 0;
            _this.scrollDirection = -1;
        }
        else {
            _this.scrollDirection = 1;
        }
        goToCurrentSearchResult();
    };
    this.findPrevious = function () {
        _this.searchResultIndex--;
        if (_this.searchResultIndex < 0) {
            _this.searchResultIndex = _this.searchResultRows.length - 1;
            _this.scrollDirection = 1;
        }
        else {
            _this.scrollDirection = -1;
        }
        goToCurrentSearchResult();
    };
    //=================================//
    // Result Tally Message Generators //
    //=================================//
    this.getSearchResultCountString = function () {
        var currentIndex = _this.currentSearchResultIndex;
        var totalResults = _this.searchResultTotal;
        if (_.size(_this.searchText) && _this.searchResultTotal > 0) {
            return currentIndex + " of " + totalResults;
        }
        else {
            return '';
        }
    };
    this.getNoResultsMsg = function () {
        if (_.size(_this.searchText) && _this.searchResultTotal === 0) {
            return _this.searchText + " not found.";
        }
        else {
            return '';
        }
    };
    //================//
    // Event Handlers //
    //================//
    this.onSearchTextUpdated = function (searchText) {
        var searchTextLowerCase = _.toLower(searchText);
        if (searchTextLowerCase !== _this.searchText) {
            _this.searchText = searchTextLowerCase;
            updateSearchResults();
            goToCurrentSearchResult();
        }
        else {
            _this.findNext();
        }
    };
    this.onKeyUp = function ($event) {
        if ($event.key === 'Enter') {
            _this.findNext();
        }
    };
    //
    // This facilitates "search as you type" when using the native
    // search.
    //
    this.onSearchTextInputChanged = function () {
        _this.onSearchTextUpdated(_this.searchTextInput);
    };
    //======//
    // Grid //
    //======//
    this.cellHasASearchResult = function (rowEntity, colFieldName) {
        return _.includes(rowEntity.columnsContainingSearchResult, colFieldName);
    };
    this.cellHasCurrentSearchResult = function (rowEntity, colFieldName) {
        return (_.includes(rowEntity.columnsContainingSearchResult, colFieldName) &&
            _this.searchResultRows[_this.searchResultIndex] === rowEntity);
    };
    var initGrid = function () {
        _this.gridOptions = {
            enableSorting: false,
            enableFiltering: false,
            enableColumnMenus: false,
            showTreeExpandNoChildren: false,
            treeRowHeaderBaseWidth: 12,
            enableHorizontalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
            enableVerticalScrollbar: uiGridConstants.scrollbars.ALWAYS,
            rowHeight: 26,
            showHeader: false,
            rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
            onRegisterApi: function (gridApi) {
                _this.gridApi = gridApi;
                _this.gridApi.grid.registerDataChangeCallback(function () {
                    _this.gridApi.treeBase.expandAllRows();
                });
            },
            data: []
        };
        _this.gridOptions.columnDefs = [
            {
                field: 'property',
                type: 'string',
                width: '25%',
                displayName: 'Property',
                cellTemplate: 'components/jsonViewer/gridTemplates/json-property-cell-template.html'
            },
            {
                field: 'value',
                type: 'string',
                width: '*',
                displayName: 'Value',
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            }
        ];
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$postLink = function () {
        _this.jsonDataPromise.then(function (jsonData) {
            _this.gridOptions.data = [];
            parseJsonData(_this.gridOptions.data, jsonData, 0);
        });
    };
    this.$onInit = function () {
        _this.searchText = '';
        _this.searchTextInput = '';
        _this.searchResultIndex = 0;
        _this.indexSeq = 0;
        _this.scrollDirection = 1;
        _this.searchResultRows = [];
        if (_this.useNativeSearch) {
            _this.setSearchResultTotal = function (searchResultTotal) {
                _this.searchResultTotal = searchResultTotal;
            };
            _this.setCurrentSearchResultIndex = function (currentSearchResultIndex) {
                _this.currentSearchResultIndex = currentSearchResultIndex;
            };
        }
        else {
            _this.setSearchCallback(_this.onSearchTextUpdated);
            _this.setFindNextCallback(_this.findNext);
            _this.setFindPreviousCallback(_this.findPrevious);
            _this.setShowNoResultsMsg(true);
        }
        _this.setSearchResultTotal(0);
        _this.setCurrentSearchResultIndex(0);
        initGrid();
    };
    this.$onDestroy = function () {
        if (!_this.useNativeSearch) {
            _this.setSearchCallback(null);
            _this.setFindNextCallback(null);
            _this.setFindPreviousCallback(null);
            _this.setSearchResultTotal(0);
            _this.setCurrentSearchResultIndex(0);
            _this.setShowNoResultsMsg(false);
        }
    };
}
angular.module('prism-ui.components').component('jsonViewer', {
    controller: JsonViewerController,
    templateUrl: 'components/jsonViewer/json-viewer-template.html',
    bindings: {
        // promise that resolves with the json data to display
        jsonDataPromise: '<',
        // "true" if not using the search controls on the app's
        // navbar, in which case all bindings below will be ignored
        useNativeSearch: '<',
        //========================//
        // Navbar Search Bindings //
        //========================//
        // called during $onInit() to expose our component's
        // "execute search" function
        setSearchCallback: '<',
        // called during $onInit() to expose our "find next"
        // function
        setFindNextCallback: '<',
        // called during $onInit() to expose our "find previous"
        // function
        setFindPreviousCallback: '<',
        // called when the total number of search results changes
        // based on search keyword changes
        setSearchResultTotal: '<',
        // called when the current search result index is changed
        // (i.e. by the "find next" action)
        setCurrentSearchResultIndex: '<',
        // called to explicitly tell the navbar (or other external
        // search component) to turn off the "... not found"
        // message
        setShowNoResultsMsg: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 5/7/15.
 */
function ModalServiceConstructor(_, $uibModal, ContentResourceFactory, LanguageResourceFactory, PackageResourceFactory, PartnerResourceFactory, RoleResourceFactory, TerritoriesService) {
    var _this = this;
    var openModals = [];
    var removemodal = function (modal) {
        var modalIndex = openModals.indexOf(modal);
        openModals.splice(modalIndex, 1);
    };
    var handleNewModal = function (modal, resultHandler, cancelHandler) {
        if (resultHandler === void 0) { resultHandler = null; }
        if (cancelHandler === void 0) { cancelHandler = null; }
        openModals.push(modal);
        modal.result.then(function (result) {
            if (resultHandler) {
                resultHandler(result);
            }
            removemodal(modal);
        }, function (cancelMessage) {
            if (cancelHandler) {
                cancelHandler(cancelMessage);
            }
            removemodal(modal);
        });
    };
    this.currentModalInstance = function () {
        return openModals.length ? openModals[openModals.length - 1] : null;
    };
    this.closeAllModals = function () {
        angular.forEach(openModals, function (modal) {
            modal.dismiss('cancel');
            modal = null;
        });
        openModals = [];
    };
    this.closeCurrentModal = function () {
        if (_this.currentModalInstance()) {
            _this.currentModalInstance().dismiss('cancel');
        }
    };
    this.showMessageModal = function (options, resultHandler, cancelHandler) {
        var modal = $uibModal.open({
            templateUrl: 'components/modal/message-modal-template.html',
            controller: 'MessageModalController as msgMdlCntrlr',
            windowClass: options.windowClass,
            resolve: {
                options: function () {
                    return options;
                }
            }
        });
        handleNewModal(modal, resultHandler, cancelHandler);
    };
    this.showFileSelectionModal = function (fileFilterType, resultHandler, validateFileFunc) {
        var modal = $uibModal.open({
            component: 'selectAssetModal',
            windowClass: 'file-browser-modal',
            resolve: {
                fileFilterType: function () {
                    return fileFilterType;
                },
                validateFileFunc: function () {
                    return validateFileFunc;
                }
            }
        });
        handleNewModal(modal, resultHandler);
    };
    this.showFileUploadModal = function (acceptTemplateMembers, fileFilterType, resultHandler) {
        var modal = $uibModal.open({
            component: 'fileUploadModal',
            resolve: {
                acceptTemplateMembers: function () {
                    return acceptTemplateMembers;
                },
                fileFilterType: function () {
                    return fileFilterType;
                }
            }
        });
        handleNewModal(modal, resultHandler);
    };
    this.showAddCollaboratorModal = function (availableCollaborators, type, resultHandler, savedRoles, showContentCollaborators, isSeries, allowMultiSelect, showNewButton) {
        if (allowMultiSelect === void 0) { allowMultiSelect = true; }
        if (showNewButton === void 0) { showNewButton = true; }
        var modal = $uibModal.open({
            component: 'collaboratorAddModal',
            windowClass: 'add-collaborator-modal',
            resolve: {
                collaborators: function () { return availableCollaborators; },
                type: function () { return type; },
                savedRoles: function () { return savedRoles; },
                showContentCollaborators: function () { return showContentCollaborators; },
                isSeries: function () { return isSeries; },
                allowMultiSelect: function () { return allowMultiSelect; },
                showNewButton: function () { return showNewButton; }
            }
        });
        handleNewModal(modal, resultHandler);
    };
    this.showNewCrewCollaboratorModal = function (newActor, resultHandler) {
        var modal = $uibModal.open({
            component: 'addNewCrewCollaboratorModal',
            resolve: {
                newActor: function () { return newActor; }
            }
        });
        handleNewModal(modal, resultHandler);
    };
    this.showCreateCollaboratorModal = function (resultHandler) {
        var modal = $uibModal.open({
            templateUrl: 'meta/collaborator/editor/components/create-collaborator-modal-template.html',
            controller: 'CreateCollaboratorModalController as createCollaborator'
        });
        handleNewModal(modal, resultHandler);
    };
    this.showGroupsModal = function (availableGroups, resultHandler) {
        var modal = $uibModal.open({
            component: 'groupsModal',
            resolve: {
                availableGroups: function () {
                    return availableGroups;
                }
            }
        });
        handleNewModal(modal, resultHandler);
    };
    this.showAliasesModal = function (resultHandler) {
        var modal = $uibModal.open({
            component: 'aliasesModal',
        });
        handleNewModal(modal, resultHandler);
    };
    this.showMediaAcceptProfilesModal = function (resultHandler, mediaAcceptProfileType) {
        var modal = $uibModal.open({
            component: 'mediaAcceptProfilesModal',
            resolve: {
                mediaAcceptProfileType: function () { return mediaAcceptProfileType; }
            }
        });
        handleNewModal(modal, resultHandler);
    };
    this.showEditableQualityControlModal = function (asset, canEdit, resultHandler) {
        var modal = $uibModal.open({
            templateUrl: 'package/editor/components/modals/qualitycontrol/quality-control-modal-template.html',
            controller: 'QualityControlModalController as qualCntrlMdlCntrlr',
            windowClass: 'package-qc-modal',
            resolve: {
                qcNoteData: function () {
                    return asset.qualityControlNote;
                },
                canEdit: function () {
                    return canEdit;
                }
            }
        });
        openModals.push(modal);
        modal.result.then(function (qcNote) {
            resultHandler(asset, qcNote);
            removemodal(modal);
        }, function () {
            removemodal(modal);
        });
    };
    this.showPackageQCNotesModal = function (mediaData) {
        var modal = $uibModal.open({
            templateUrl: 'package/manager/modals/packagequalitycontrol/package-quality-control-modal-template.html',
            controller: 'QualityControlModalController as qualCntrlMdlCntrlr',
            windowClass: 'package-qc-modal',
            resolve: {
                qcNoteData: function () {
                    return mediaData;
                },
                canEdit: function () {
                    return false;
                }
            }
        });
        handleNewModal(modal);
    };
    this.showViewAssetModal = function (packageContent, secondaryAsset, downloadFileNamePrefix, contentTemplateUrl, showPreview) {
        var modal = $uibModal.open({
            component: 'viewAssetModal',
            windowClass: 'view-asset-modal',
            resolve: {
                packageContent: function () { return packageContent; },
                secondaryAsset: function () { return secondaryAsset; },
                downloadFileNamePrefix: function () { return downloadFileNamePrefix; },
                contentTemplateUrl: function () { return contentTemplateUrl; },
                showPreview: function () { return showPreview; }
            }
        });
        handleNewModal(modal);
    };
    this.showErrorsWarningsModal = function (validationResults, packageName, showCancel, resultHandler) {
        var modal = $uibModal.open({
            component: 'errorsWarningsModal',
            windowClass: 'errors-warnings-modal',
            resolve: {
                validationResults: function () { return validationResults; },
                packageName: function () { return packageName; },
                showCancel: function () { return showCancel; }
            }
        });
        handleNewModal(modal, resultHandler);
    };
    this.showNewPackageModal = function (resultHandler) {
        var modal = $uibModal.open({
            templateUrl: 'package/manager/modals/newPackage/new-package-modal-template.html',
            controller: 'NewPackageModalController as newPackageCtrl',
            windowClass: 'new-package-modal'
        });
        handleNewModal(modal, resultHandler);
    };
    this.showContentSubscriptionPropertiesModal = function (subscriptions, batchUpdate, isPartner, resultHandler, cancelHandler) {
        var modal = $uibModal.open({
            component: 'subscriptionPropertiesModal',
            windowClass: 'metadata-properties-modal',
            resolve: {
                isPartner: function () {
                    return isPartner;
                },
                subscriptions: function () {
                    return subscriptions;
                }
            }
        });
        handleNewModal(modal, resultHandler, cancelHandler);
    };
    this.showPartnerEmailRecipientModal = function (recipientObject, resolveHandler) {
        handleNewModal($uibModal.open({
            component: 'partnerEmailRecipientModal',
            resolve: {
                recipientObject: function () {
                    return recipientObject;
                },
            },
        }), resolveHandler);
    };
    this.showContactsSelectModal = function (existingContactIds, resultHandler) {
        handleNewModal($uibModal.open({
            component: 'contactsSelectModal',
            resolve: {
                existingContactIds: function () {
                    return existingContactIds;
                },
            },
        }), resultHandler);
    };
    this.showContentSelectModal = function (contentType, contents, resultHandler) {
        var modal = $uibModal.open({
            component: 'contentSelectModalComponent',
            windowClass: 'content-browser-modal',
            resolve: {
                contentType: function () { return contentType; },
                contents: function () { return contents; }
            }
        });
        handleNewModal(modal, resultHandler);
    };
    this.showRejectPackageModal = function (rejectReason, showRejectClipWarning, editable, resultHandler) {
        var modal = $uibModal.open({
            templateUrl: 'package/editor/components/modals/rejectPackage/reject-package-modal-template.html',
            controller: 'RejectPackageModalController as rejectPkgCntrlr',
            resolve: {
                rejectReason: function () {
                    return rejectReason;
                },
                showRejectClipWarning: function () {
                    return showRejectClipWarning;
                },
                editable: function () {
                    return editable;
                }
            }
        });
        handleNewModal(modal, resultHandler);
    };
    this.showCompletedDeliveriesModal = function (packageObject, resultHandler) {
        handleNewModal($uibModal.open({
            component: 'completedDeliveriesModal',
            windowClass: 'completed-deliveries-modal',
            resolve: {
                packageObject: function () { return packageObject; }
            }
        }), resultHandler, resultHandler);
    };
    this.showCheckinResultModal = function (resultsDict, resultHandler) {
        handleNewModal($uibModal.open({
            component: 'checkinResultModal',
            windowClass: 'checkin-result-modal',
            resolve: {
                resultsDict: function () { return resultsDict; }
            },
        }), resultHandler, resultHandler);
    };
    this.showAdHocSelectPartnersModal = function (currentPartners, isSeries, isSeason, isVolume, resultHandler) {
        var modal = $uibModal.open({
            templateUrl: 'package/editor/components/modals/adHocSelectPartners/adhoc-subscription-modal-template.html',
            controller: 'AdHocSelectPartnersModalController as adHocPartnersCntrlr',
            resolve: {
                currentPartners: function () {
                    return currentPartners;
                },
                isSeries: function () {
                    return isSeries;
                },
                isSeason: function () {
                    return isSeason;
                },
                isVolume: function () {
                    return isVolume;
                },
                allPartners: function () {
                    return PartnerResourceFactory.query({ fetchLimit: 1000 }).$promise;
                }
            }
        });
        handleNewModal(modal, resultHandler);
    };
    this.showLiveClipScheduleModal = function (packageObject, defaultFeed, liveFeeds, cancelHandler, resultHandler) {
        var modal = $uibModal.open({
            templateUrl: 'package/editor/components/view/liveclip/modals/clipSchedule/clip-schedule-modal-template.html',
            controller: 'ClipScheduleModalController as scheduleCtrlr',
            windowClass: 'clip-schedule-modal',
            resolve: {
                packageObject: function () {
                    return packageObject;
                },
                defaultFeed: function () {
                    return defaultFeed;
                },
                liveFeeds: function () {
                    return liveFeeds;
                },
                cancelRecordHandler: function () {
                    return cancelHandler;
                }
            }
        });
        handleNewModal(modal, resultHandler);
    };
    this.showCreateClipModal = function (resultHandler) {
        var modal = $uibModal.open({
            templateUrl: 'package/editor/components/view/liveclip/modals/createNewClip/create-clip-modal-template.html',
            controller: 'CreateClipModalController as createClipMdlCntrlr'
        });
        openModals.push(modal);
        modal.result.then(function (result) {
            resultHandler(result);
            removemodal(modal);
        }, function () {
            removemodal(modal);
        });
    };
    this.showSelectDraftClipModal = function (draftClips, resultHandler, cancelHandler) {
        var modal = $uibModal.open({
            component: 'selectDraftClipModal',
            resolve: {
                draftClips: function () { return draftClips; }
            }
        });
        handleNewModal(modal, resultHandler, cancelHandler);
    };
    this.showAddLiveFeedModal = function (liveFeeds, liveFeed, resultHandler) {
        var modal = $uibModal.open({
            templateUrl: 'meta/content/editor/components/modals/addShowLiveFeed/add-showlivefeed-modal-template.html',
            controller: 'AddShowLiveFeedModalController as addShowLiveFeedCtrlr',
            resolve: {
                availableFeeds: function () {
                    return liveFeeds;
                },
                showLiveFeed: function () {
                    return liveFeed;
                }
            }
        });
        handleNewModal(modal, resultHandler);
    };
    this.showAddContentCategoryModal = function (contentId, resultHandler) {
        var modal = $uibModal.open({
            templateUrl: 'meta/content/editor/components/modals/addContentCategoriesModal/add-content-categories-modal-template.html',
            controller: 'AddContentCategoriesModalController as addContentCategoriesModalCtrl',
            resolve: {
                availableCategories: function () {
                    return PackageResourceFactory.getCategories({ view: 'EXTENDED' }).$promise;
                },
                existingContentCategories: function () {
                    return ContentResourceFactory.getContentCategories({ id: contentId }).$promise;
                }
            }
        });
        handleNewModal(modal, resultHandler);
    };
    this.showNewSubscriptionModal = function (packageCategoryTypeId, packageCategoryId, contentId, networkId, resultHandler) {
        var modal = $uibModal.open({
            component: 'newSubscriptionModal',
            windowClass: 'new-subscription-modal',
            resolve: {
                packageCategoryTypeId: function () {
                    return packageCategoryTypeId;
                },
                packageCategoryId: function () {
                    return packageCategoryId;
                },
                contentId: function () {
                    return contentId;
                },
                networkId: function () {
                    return networkId;
                }
            }
        });
        handleNewModal(modal, resultHandler);
    };
    this.showSelectDeliveryPartnersModal = function (resultHandler) {
        var modal = $uibModal.open({
            templateUrl: 'package/common/selectDeliveryPartnersModal/select-delivery-partners-modal-template.html',
            controller: 'SelectDeliveryPartnersModalController as selectDeliveryPartnersMdlCtrlr',
            windowClass: 'select-delivery-partners-modal',
            resolve: {}
        });
        handleNewModal(modal, resultHandler);
    };
    this.showCreateReportModal = function (report, resultHandler, showPartners) {
        var modal = $uibModal.open({
            templateUrl: 'dashboard/reports/modals/createReportModal/create-report-modal-template.html',
            controller: 'CreateReportModalController as createReportModal',
            resolve: {
                report: function () { return report; },
                showPartners: function () { return showPartners; }
            }
        });
        handleNewModal(modal, resultHandler);
    };
    this.showSelectMasterMediaTypesModal = function (resultHandler) {
        var modal = $uibModal.open({
            templateUrl: 'package/common/selectMasterMediaTypesModal/select-master-media-types-modal-template.html',
            controller: 'SelectMasterMediaTypesModalController as selectMasterMediaTypesModal',
            windowClass: 'select-media-content-modal'
        });
        handleNewModal(modal, resultHandler);
    };
    this.showAssetValidationResultsModal = function (validationResults, showCancel, resultHandler) {
        var modal = $uibModal.open({
            component: 'errorsWarningsModal',
            templateUrl: 'package/editor/components/modals/assetValidationResults/asset-validation-results-modal-template.html',
            windowClass: 'errors-warnings-modal',
            resolve: {
                validationResults: function () {
                    return validationResults;
                },
                packageName: function () {
                    return '';
                },
                showCancel: function () {
                    return showCancel;
                }
            }
        });
        handleNewModal(modal, resultHandler);
    };
    this.showAssetModal = function (asset, contentTemplate, assetType, resultHandler) {
        var modal = $uibModal.open({
            component: 'assetInfoModal',
            resolve: {
                contentTemplate: function () { return contentTemplate; },
                asset: function () { return asset; },
                assetType: function () { return assetType; }
            }
        });
        handleNewModal(modal);
    };
    this.showPMSearchFilterModal = function (resultHandler, cancelHandler) {
        var modal = $uibModal.open({
            templateUrl: 'package/manager/modals/filter/filter-modal-template.html',
            controller: 'FilterModalController as pmFilterModal',
            windowClass: 'search-filter-modal'
        });
        handleNewModal(modal, resultHandler, cancelHandler);
    };
    this.showPkgTimingEditModal = function (pkgTiming, resultHandler) {
        var modal = $uibModal.open({
            templateUrl: 'package/editor/components/view/timings/editor/pkg-timing-edit-modal-template.html',
            controller: 'PackageTimingEditModalController as pkgTimingEditor',
            resolve: {
                pkgTiming: function () {
                    return pkgTiming;
                }
            }
        });
        handleNewModal(modal, resultHandler);
    };
    this.showPkgHierarchicalMetadataModal = function (packageObject) {
        handleNewModal($uibModal.open({
            component: 'hierarchicalMetadataModal',
            windowClass: 'hierarchical-metadata-modal',
            resolve: {
                packageObject: function () { return packageObject; },
            },
        }));
    };
    this.showBrandingDistributionOverridesModal = function (partnerPackage, packageObject, viewState, readOnly, resultHandler) {
        handleNewModal($uibModal.open({
            component: 'brandingDistributionOverridesModal',
            windowClass: 'wide-message-modal',
            resolve: {
                partnerPackage: function () { return partnerPackage; },
                packageObject: function () { return packageObject; },
                viewState: function () { return viewState; },
                readOnly: function () { return readOnly; },
            },
        }), resultHandler);
    };
    this.showMediaModal = function (type, media, clipId, resultHandler) {
        var modal = $uibModal.open({
            templateUrl: 'components/modal/media-modal/media-modal-template.html',
            controller: 'MediaModalController as mediaModal',
            windowClass: 'wide-message-modal',
            resolve: {
                type: function () { return type; },
                media: function () { return media; },
                clipId: function () { return clipId; }
            }
        });
        handleNewModal(modal, resultHandler);
    };
    this.showMetadataItemEditorModal = function (ownerClass, propertyId, mvpd, conversion, resultHandler) {
        var modal = $uibModal.open({
            component: 'metadataItemEditModal',
            windowClass: 'metadata-property-modal',
            resolve: {
                ownerClass: function () {
                    return ownerClass;
                },
                propertyId: function () {
                    return propertyId;
                },
                mvpd: function () { return mvpd; },
                conversion: function () { return conversion; },
            }
        });
        handleNewModal(modal, resultHandler);
    };
    this.showWorkflowSearchFilterModal = function (resultHandler, cancelHandler) {
        var modal = $uibModal.open({
            templateUrl: 'dashboard/workflows/searchView/modals/filter/workflow-filter-modal-template.html',
            controller: 'FilterModalController as workflowFilterModal',
            windowClass: 'search-filter-modal'
        });
        handleNewModal(modal, resultHandler, cancelHandler);
    };
    this.showQueueLimiterModal = function (queueId, resultHandler, closeHandler) {
        var modal = $uibModal.open({
            templateUrl: 'dashboard/queues/modals/queueLimiterList/queue-limiter-list-modal-template.html',
            controller: 'QueueLimiterListController as queueLimiterController',
            windowClass: 'queue-limiter-list-modal',
            resolve: {
                queueId: function () {
                    return queueId;
                }
            }
        });
        handleNewModal(modal, resultHandler, closeHandler);
    };
    this.showQueueLimiterEditModal = function (limiterId, queueMaxActive, resultHandler) {
        var modal = $uibModal.open({
            templateUrl: 'dashboard/queues/modals/queueLimiterEditor/queue-limiter-edit-template.html',
            controller: 'QueueLimiterEditController as queueLimiterEditCtrl',
            windowClass: 'queue-limiter-edit-modal',
            resolve: {
                limiterId: function () {
                    return limiterId;
                },
                queueMaxActive: function () {
                    return queueMaxActive;
                }
            }
        });
        handleNewModal(modal, resultHandler);
    };
    this.showNewDeliveryEndpointModal = function (supportedEndpointTypes, resultHandler) {
        var modal = $uibModal.open({
            component: 'newDeliveryEndpointModal',
            resolve: {
                supportedEndpointTypes: function () {
                    return supportedEndpointTypes;
                }
            }
        });
        handleNewModal(modal, resultHandler);
    };
    this.showContentCategorySubscriptionFilterModal = function (seasons, volumes, resultHandler, cancelHandler) {
        var modal = $uibModal.open({
            component: 'contentSubscriptionFilterModal',
            resolve: {
                availableSeasons: function () { return seasons; },
                availableVolumes: function () { return volumes; }
            }
        });
        handleNewModal(modal, resultHandler, cancelHandler);
    };
    this.showPartnerSubscriptionFilterModal = function (resultHandler, cancelHandler) {
        var modal = $uibModal.open({
            templateUrl: 'system/partner/editor/components/view/subscriptions/modal/partner-subscription-filter-template.html',
            controller: 'FilterModalController as pmFilterModal',
            windowClass: 'partner-sub-filter-modal'
        });
        handleNewModal(modal, resultHandler, cancelHandler);
    };
    this.showNewMediaProfileModal = function (resultHandler, acceptProfiles) {
        var modal = $uibModal.open({
            component: 'newMediaProfileModal',
            resolve: {
                acceptProfiles: function () {
                    return acceptProfiles;
                }
            }
        });
        handleNewModal(modal, resultHandler);
    };
    this.showChangePasswordModal = function (okayHandler, cancelHandler) {
        var modal = $uibModal.open({
            component: 'changePasswordModal'
        });
        handleNewModal(modal, okayHandler, cancelHandler);
    };
    this.showPartnerPackageAcceptRejectModal = function (action, partnerPackagePartnerName, okayHandler, cancelHandler) {
        var modal = $uibModal.open({
            component: 'partnerPackageAcceptRejectModal',
            resolve: {
                action: function () { return action; },
                partnerPackagePartnerName: function () { return partnerPackagePartnerName; }
            }
        });
        handleNewModal(modal, okayHandler, cancelHandler);
    };
    this.showGroupsExceptionModal = function (series, movies, categories, exceptionPermission, isEdit, resultHandler) {
        var modal = $uibModal.open({
            component: 'groupsExceptionModal',
            resolve: {
                series: function () { return series; },
                movies: function () { return movies; },
                categories: function () { return categories; },
                exceptionPermission: function () { return exceptionPermission; },
                isEdit: function () { return isEdit; }
            }
        });
        handleNewModal(modal, resultHandler);
    };
    this.showExternalIngestTypeModal = function (okayHandler, cancelHandler) {
        var modal = $uibModal.open({
            component: 'externalIngestTypeModal'
        });
        handleNewModal(modal, okayHandler, cancelHandler);
    };
    this.showExternalIngestRunModal = function (externalIngestSourceId, okayHandler, cancelHandler) {
        var modal = $uibModal.open({
            component: 'externalIngestRunModal',
            resolve: {
                externalIngestSourceId: function () { return externalIngestSourceId; },
            }
        });
        handleNewModal(modal, okayHandler, cancelHandler);
    };
    this.showExternalIngestQueueEditorModal = function (externalIngestJobs, saveHandler, cancelHandler) {
        var modal = $uibModal.open({
            component: 'externalIngestQueueEditorModal',
            resolve: {
                externalIngestJobs: function () { return externalIngestJobs; }
            }
        });
        handleNewModal(modal, saveHandler, cancelHandler);
    };
    this.showJsonViewerModal = function (jsonData) {
        var modal = $uibModal.open({
            component: 'jsonViewerModal',
            resolve: {
                jsonData: function () { return jsonData; }
            },
            windowClass: 'json-viewer-modal'
        });
        handleNewModal(modal);
    };
    this.showMetricsFilterModal = function (acceptHandler) {
        var modal = $uibModal.open({
            component: 'metricsFilterModal',
            windowClass: 'metrics-filter-modal'
        });
        handleNewModal(modal, acceptHandler);
    };
    this.showMMCInventoryModal = function (packageId, partnerId, readOnly) {
        var modal = $uibModal.open({
            component: 'mmcInventoryModal',
            resolve: {
                packageId: function () { return packageId; },
                partnerId: function () { return partnerId; },
                readOnly: function () { return readOnly; }
            },
            windowClass: 'mmc-inventory-modal'
        });
        handleNewModal(modal);
    };
    this.showAttachmentSelectModal = function (availableDeliveryItems, resultHandler) {
        var modal = $uibModal.open({
            component: 'attachmentSelectModal',
            resolve: {
                availableDeliveryItems: function () { return availableDeliveryItems; }
            },
            windowClass: 'attachment-select-modal'
        });
        handleNewModal(modal, resultHandler);
    };
    this.showQueuePriorityEditorModal = function (queueSteps, resultHandler) {
        var modal = $uibModal.open({
            component: 'queuePriorityModal',
            resolve: {
                queueSteps: function () { return queueSteps; }
            },
        });
        handleNewModal(modal, resultHandler);
    };
    this.showFileProgressModal = function (initUploads, canInsertRows, resultHandler) {
        var modal = $uibModal.open({
            component: 'fileProgressModal',
            resolve: {},
            windowClass: 'file-progress-modal',
        });
        handleNewModal(modal, resultHandler);
    };
    this.showMoveDirectoryModal = function (sourceFileSystemId, resultHandler) {
        handleNewModal($uibModal.open({
            component: 'moveDirectoryModal',
            resolve: {
                sourceFileSystemId: function () {
                    return sourceFileSystemId;
                },
            },
        }), resultHandler);
    };
    this.showGenerateAcceptProfileModal = function (mediaAcceptProfileType, mediaAcceptProfileId, resultHandler) {
        var modal = $uibModal.open({
            component: 'generateAcceptProfileModal',
            resolve: {
                mediaAcceptProfileType: function () {
                    return mediaAcceptProfileType;
                },
                mediaAcceptProfileId: function () {
                    return mediaAcceptProfileId;
                }
            }
        });
        handleNewModal(modal, resultHandler);
    };
}
angular.module('prism-ui.components').service('ModalService', ModalServiceConstructor);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2022 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by kyang on 10/25/22.
 */
function PrismInitializationController($q, $scope, $timeout, loginService, DynamicStyleService, EchoService, MetadataService, RequestService, ServerInfoService) {
    var _this = this;
    var securedReqsStarted = false;
    var onStatusChange = function () {
        // Some initialization has to happen after login, so don't hide login screen
        _this.loadingIndicator.show = (loginService.isAuthenticated() && _this.isLoading);
        if (!securedReqsStarted && loginService.isAuthenticated()) {
            securedReqsStarted = true;
            MetadataService.initialize();
            $q.all([
                MetadataService.propertiesPromise,
                ServerInfoService.queryForServerInfo()
            ]).then(function () {
                _this.isLoading = false;
                _this.loadingIndicator.show = false;
            });
        }
    };
    this.$onInit = function () {
        _this.isLoading = true;
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        loginService.useLocalStorage(true);
        DynamicStyleService.initialize();
        EchoService.initialize();
        RequestService.initialize();
        $scope.$on('$routeChangeStart', onStatusChange);
        onStatusChange();
    };
}
angular.module('prism-ui.components').component('prismInitialization', {
    controller: PrismInitializationController,
    templateUrl: 'components/prism-initialization/prism-initialization-template.html'
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.components').service('AsperaConnectService', function ($q, _, AW4, EndPointService, ModalService, NotificationService, DynamicPropertiesService) {
    var _this = this;
    var AsperaWeb;
    var filesReadyForUpload = [];
    var asperaPropertyPrefix = 'asperaConnect.';
    var asperaPropertyNames = [
        'initializationTimeout', 'minVersion', 'destinationRoot',
        'remoteHost', 'remoteUser', 'remotePassword',
        'targetRateKbps', 'virtualRoot'
    ];
    this.unregisterAllFiles = function () {
        filesReadyForUpload = [];
    };
    this.isFileRegistered = function (asperaFileObject) {
        var fileName = _.get(asperaFileObject, 'name');
        return _.some(filesReadyForUpload, { name: fileName });
    };
    this.registerFileForUpload = function (asperaFileObject) {
        console.info("AsperaConnectService.registerFileForUpload(): registering " + asperaFileObject.name);
        var registered = false;
        if (_this.isFileRegistered(asperaFileObject)) {
            var message = 'File already selected for upload.';
            var detail = "The local file \"" + asperaFileObject.name + "\" has" +
                " already been selected for upload. Please" +
                " select a different file, or add this file" +
                " after the current selections have been saved.";
            NotificationService.createFailureNotification(message, detail, true, 0);
        }
        else {
            filesReadyForUpload.push(asperaFileObject);
            registered = true;
        }
        return registered;
    };
    this.unregisterFile = function (asperaFileObject) {
        if (asperaFileObject) {
            console.info("AsperaConnectService.unregisterFile(): unregistering" +
                (" " + _.get(asperaFileObject, 'name')));
            _.remove(filesReadyForUpload, function (file) {
                return file.name === _.get(asperaFileObject, 'name');
            });
        }
    };
    var initializationFailed = false;
    this.reset = function () {
        _this.asperaConnectProperties = null;
        delete _this.asperaConnectProperties;
        _this.unregisterAllFiles();
        AsperaWeb = null;
        initializationFailed = false;
        _this.initialized = false;
        _this.initializationDeferred = $q.defer();
    };
    this.initialize = function (targetSubdirectory) {
        return DynamicPropertiesService.queryForProperties().then(function () {
            _this.reset();
            var asperaConnectEnabled = DynamicPropertiesService.getPropValueAsBoolean('mediaTabRemoteUpload.enabled', false) &&
                DynamicPropertiesService.getPropValueAsBoolean('asperaConnect.enabled', false);
            if (!asperaConnectEnabled) {
                return;
            }
            _this.asperaConnectProperties = {};
            _.forEach(asperaPropertyNames, function (propertyName) {
                var value = DynamicPropertiesService.getPropValue(asperaPropertyPrefix + propertyName, null);
                if (value !== null) {
                    _this.asperaConnectProperties[propertyName] = value;
                }
            });
            _this.destinationRoot = targetSubdirectory;
            var connectInstaller = new AW4.ConnectInstaller({
                sdkLocation: EndPointService.asperaConnectSdkPath,
            });
            var defaultInitializationTimeout = 15000;
            var initializationTimeout = _.get(_this, 'asperaConnectProperties.initializationTimeout', defaultInitializationTimeout);
            AsperaWeb = new AW4.Connect({
                connectLaunchWaitTimeoutMs: initializationTimeout,
                sdkLocation: EndPointService.asperaConnectSdkPath,
                minVersion: _this.asperaConnectProperties.minVersion,
                dragDropEnabled: true
            });
            _this.initializedDeferred = $q.defer();
            var statusEventListener = function (eventType, data) {
                if (eventType === AW4.Connect.EVENT.STATUS) {
                    switch (data) {
                        case AW4.Connect.STATUS.INITIALIZING:
                            _this.initialized = false;
                            console.info("AsperaConnectService.initialize(): Aspera indicates that it's initializing");
                            connectInstaller.showLaunching();
                            break;
                        case AW4.Connect.STATUS.FAILED:
                            _this.initialized = false;
                            initializationFailed = true;
                            console.warn("AsperaConnectService.initialize(): Aspera indicates that it's failed!");
                            connectInstaller.showDownload();
                            _this.initializedDeferred.reject(_this.asperaConnectProperties.minVersion);
                            break;
                        case AW4.Connect.STATUS.OUTDATED:
                            _this.initialized = false;
                            initializationFailed = true;
                            console.warn("AsperaConnectService.initialize(): Aspera indicates that it's outdated");
                            connectInstaller.showUpdate();
                            _this.initializedDeferred.reject(_this.asperaConnectProperties.minVersion);
                            break;
                        case AW4.Connect.STATUS.RUNNING:
                            if (!initializationFailed) {
                                _this.initialized = true;
                                console.info("AsperaConnectService.initialize(): Aspera indicates that it's running");
                                connectInstaller.connected();
                                _this.initializedDeferred.resolve();
                            }
                            break;
                        case AW4.Connect.STATUS.RETRYING:
                            _this.initialized = false;
                            console.info("AsperaConnectService.initialize(): Aspera indicates that it's retrying");
                            break;
                        default:
                            console.info("AsperaConnectService.initialize(): Unhandled event...");
                            break;
                    }
                }
            };
            AsperaWeb.addEventListener(AW4.Connect.EVENT.STATUS, statusEventListener);
            AsperaWeb.addEventListener(AW4.Connect.EVENT.TRANSFER, handleTransferEvents);
            AsperaWeb.initSession();
            return _this.initializedDeferred.promise;
        });
    };
    this.setDropTarget = function (dropTarget, dropTargetListener) {
        var options = {
            dragEnter: false,
            dragLeave: false,
            dragOver: false,
            drop: true
        };
        AsperaWeb.setDragDropTargets("." + dropTarget, options, dropTargetListener);
    };
    var startTransfer = function (transferSpec, connectSettings, token) {
        if (typeof token !== 'undefined' && token !== '') {
            transferSpec.authentication = 'token';
            transferSpec.token = token;
        }
        var onError = function (obj) {
            var failureMessage = JSON.stringify(obj, null, 4);
            console.error("Failed to start :  " + failureMessage);
            NotificationService.createFailureNotification('Failed to start!', failureMessage, true);
        };
        var onSuccess = function () {
            var fileNames = [];
            _.forEach(transferSpec.paths, function (path) {
                fileNames.push(path.source.slice(path.source.lastIndexOf('/') + 1));
            });
            NotificationService.createSuccessNotification("Aspera transfer initiated: " + _.join(fileNames, ', '), 5000);
            _this.unregisterAllFiles();
        };
        AsperaWeb.startTransfer(transferSpec, connectSettings, {
            error: onError,
            success: onSuccess
        });
    };
    this.beginUpload = function (targetPath) {
        var transferSpec = {
            cookie: "u-" + new Date().getTime(),
            create_dir: true,
            destination_root: "" + _this.asperaConnectProperties.destinationRoot + targetPath,
            direction: 'send',
            paths: [],
            remote_host: _this.asperaConnectProperties.remoteHost,
            remote_user: _this.asperaConnectProperties.remoteUser,
            remote_password: _this.asperaConnectProperties.remotePassword,
            resume: 'sparse_checksum',
            target_rate_kbps: _this.asperaConnectProperties.targetRateKbps
        };
        _.forEach(filesReadyForUpload, function (file) {
            transferSpec.paths.push({
                source: file.name
            });
            console.info("AsperaConnectService.beginUpload(): added " + file.name + " to upload batch");
        });
        if (transferSpec.paths.length > 0) {
            var connectSettings = {
                allow_dialogs: 'true'
            };
            startTransfer(transferSpec, connectSettings, '');
        }
        else {
            console.warn("AsperaConnectService.beginUpload(): initiated transfer of 0 files");
        }
    };
    var showAsperaTransferErrors = function (asperaErrors) {
        asperaErrors = _.uniq(asperaErrors);
        if (_.size(asperaErrors)) {
            _.forEach(asperaErrors, function (asperaError) {
                var message = "Aspera Connect failed to start the transfer.";
                var detail = "The Aspera Connect plugin provided the following error message: \"" + asperaError + "\"";
                NotificationService.createFailureNotification(message, detail, true, 0);
            });
        }
    };
    var handleAsperaTransferEvent = function (transfersJsonObject) {
        var asperaErrors = [];
        _.forEach(transfersJsonObject.transfers, function (transfer) {
            console.info("AsperaConnectService.handleTransferEvents(): " + transfer.title + " - " + transfer.status);
            switch (transfer.status) {
                case 'failed':
                    var asperaError = transfer.title + " - " + transfer.error_desc;
                    asperaErrors.push(asperaError);
                    break;
                case 'completed':
                default:
                    break;
            }
        });
        showAsperaTransferErrors(asperaErrors);
    };
    var handleTransferEvents = function (event, transfersJsonObject) {
        switch (event) {
            case 'transfer':
                handleAsperaTransferEvent(transfersJsonObject);
                break;
        }
    };
    var getTransferEvents = function (iterationToken) {
        if (iterationToken === void 0) { iterationToken = undefined; }
        var callbacks = {
            success: function (allTransfers) {
                if (typeof allTransfers.error === 'undefined') {
                    var resultcount = allTransfers.result_count;
                    var transfers = allTransfers.transfers;
                    // Put any logic related to transfers in this block
                }
            }
        };
        AsperaWeb.getAllTransfers(iterationToken, callbacks);
    };
    var $onInit = function () {
        //
        // Put service entry stuff here:
        //
        _this.reset();
    };
    $onInit();
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: asset-validation-service.ts
 *
 * Created by randysorensen on 8/17/18.
 */
angular.module('prism-ui.components.data').service('AssetValidationService', function ($q, _, MediaInfoService, MediaProfileResourceFactory, PackageResourceFactory) {
    var parseValidationFailures = function (validationResults, assetPath, acceptProfileId) {
        var validationMessageList = {
            source: assetPath,
            errors: [],
            warnings: []
        };
        if (_.has(validationResults, acceptProfileId)) {
            //
            // Some validation result objects are keyed by e.g.
            // the accept profile id; others are simply arrays of
            // result objects.
            //
            validationResults = validationResults[acceptProfileId].failures;
        }
        else if (_.has(validationResults, 'failures')) {
            //
            // And, some validation result objects simply have a
            // property named "failures".
            //
            validationResults = validationResults.failures;
        }
        if (validationResults.length) {
            _.forEach(validationResults, function (value) {
                if (value.property && value.actualValue && value.expectedValue) {
                    value.description =
                        value.property + ": Actual value " + value.actualValue + "; " +
                            ("expected value " + value.expectedValue);
                }
                else if (value.source) {
                    value.description = value.source + ": " + value.description;
                }
                if (value.severity === 'WARNING') {
                    validationMessageList.warnings.push(value);
                }
                else {
                    validationMessageList.errors.push(value);
                }
            });
        }
        return validationMessageList;
    };
    //==================//
    // Media Validation //
    //==================//
    this.validateMediaLocal = function (localMediaFile, mediaAcceptProfile) {
        return MediaInfoService.executeMediaInfo(localMediaFile)
            .then(function (mediaInfoXml) {
            var queryParams = {
                profileId: mediaAcceptProfile.id
            };
            return MediaProfileResourceFactory.validateXML(queryParams, mediaInfoXml).$promise
                .then(function (validationResults) {
                var result = parseValidationFailures(validationResults, localMediaFile.name, mediaAcceptProfile.id);
                result.mediaInfo = mediaInfoXml;
                return result;
            });
        });
    };
    this.validateMediaRemote = function (virtualPath, mediaAcceptProfileId) {
        var queryParams = {
            profileId: mediaAcceptProfileId,
            path: virtualPath
        };
        return MediaProfileResourceFactory.validate(queryParams).$promise
            .then(function (validationResults) {
            return parseValidationFailures(validationResults, virtualPath, mediaAcceptProfileId);
        });
    };
    //=================//
    // Text Validation //
    //=================//
    var readFile = function (textFile) {
        var onloadDeferred = $q.defer();
        var fileReader = new FileReader();
        fileReader.onload = function () {
            onloadDeferred.resolve(fileReader.result);
        };
        fileReader.readAsDataURL(textFile);
        return onloadDeferred.promise;
    };
    this.validateTextLocalMainVideoLocal = function (textFile, textAcceptTemplate, mainVideoAcceptTemplateMember, videoMediaInfoXML) {
        return readFile(textFile)
            .then(function (readerResult) {
            var timedTextValidationDTO = {
                timedTextFilename: textFile.name,
                timedTextData: readerResult,
                videoAcceptTemplateMemberId: mainVideoAcceptTemplateMember.id,
                mainVideoInfoXML: videoMediaInfoXML
            };
            if (textAcceptTemplate) {
                timedTextValidationDTO.textAcceptTemplateId = textAcceptTemplate.id;
            }
            return MediaProfileResourceFactory.validateCCSubtitle({}, timedTextValidationDTO)
                .$promise.then(function (validationResults) {
                return parseValidationFailures(validationResults, textFile.name, _.get(textAcceptTemplate, 'id'));
            });
        });
    };
    this.validateTextLocalMainVideoRemote = function (textFile, textAcceptTemplate, mainVideoAcceptTemplateMember, video) {
        return readFile(textFile)
            .then(function (readerResult) {
            var timedTextValidationDTO = {
                timedTextFilename: textFile.name,
                timedTextData: readerResult,
                videoAcceptTemplateMemberId: mainVideoAcceptTemplateMember.id,
                mainVideoId: video.id
            };
            if (textAcceptTemplate) {
                timedTextValidationDTO.textAcceptTemplateId = textAcceptTemplate.id;
            }
            return MediaProfileResourceFactory.validateCCSubtitle({}, timedTextValidationDTO)
                .$promise.then(function (validationResults) {
                return parseValidationFailures(validationResults, textFile.name, _.get(textAcceptTemplate, 'id'));
            });
        });
    };
    this.validateTextRemoteMainVideoRemote = function (virtualPath, textAcceptTemplate, video) {
        var textAcceptTemplateId = _.get(textAcceptTemplate, 'id', '');
        var videoId = _.get(video, "id", null);
        var videoPath = _.get(video, "virtualPath", null);
        var videoIngestProgress = _.get(video, "ingestInfo.progress", 0);
        var videoAcceptTemplateMember = video.acceptTemplateMember;
        var queryParams = {
            ccPath: virtualPath,
            videoAcceptTemplateMemberId: videoAcceptTemplateMember.id,
            textAcceptTemplateId: textAcceptTemplateId,
        };
        if (videoId && parseInt(videoIngestProgress) === 100) {
            queryParams.videoMediaId = videoId;
        }
        else {
            queryParams.videoPath = videoPath;
        }
        var validationPromise = MediaProfileResourceFactory.validateClosedCaption(queryParams).$promise;
        return validationPromise.then(function (validationResults) {
            return parseValidationFailures(validationResults, virtualPath, textAcceptTemplateId);
        });
    };
    //============================//
    // Component Video Validation //
    //============================//
    this.validateComponentsLocal = function (packageId, mediaInfoDTOList, newVideoComponentFile, mediaAcceptProfile, componentRoleId, excludedComponentVideoIds, mainVideoMediaInfoDTO) {
        return MediaInfoService.executeMediaInfo(newVideoComponentFile)
            .then(function (newVideoComponentMediaInfoXml) {
            var videoComponentValidationDTO = {
                packageId: packageId,
                profileId: mediaAcceptProfile.id,
                roleId: componentRoleId,
                videoComponents: [],
                excludedContentIds: excludedComponentVideoIds
            };
            if (mainVideoMediaInfoDTO) {
                videoComponentValidationDTO.mainMediaInfo = mainVideoMediaInfoDTO;
            }
            _.forEach(mediaInfoDTOList, function (mediaInfoDTO) {
                videoComponentValidationDTO.videoComponents.push(mediaInfoDTO);
            });
            videoComponentValidationDTO.videoComponents.push({
                filePath: newVideoComponentFile.name,
                mediaInfo: newVideoComponentMediaInfoXml
            });
            return MediaProfileResourceFactory
                .validateVideoComponents({}, videoComponentValidationDTO).$promise
                .then(function (validationResults) {
                var results = [];
                _.forEach(validationResults, function (validationResult, assetPath) {
                    if (_.has(validationResult, 'failures')) {
                        var parsedValidationResult = parseValidationFailures(validationResult.failures, assetPath, mediaAcceptProfile.id);
                        results.push(parsedValidationResult);
                    }
                });
                if (_.isEmpty(results)) {
                    results.push({
                        source: 'Component Videos',
                        errors: [],
                        warnings: [],
                    });
                }
                results[0].uploadedData = {
                    mediaInfoDTO: {
                        filePath: newVideoComponentFile.name,
                        mediaInfo: newVideoComponentMediaInfoXml,
                    },
                };
                return results;
            });
        });
    };
    this.validateComponentsRemoteMainVideoRemote = function (packageId, componentVirtualPaths, mediaAcceptProfileId, componentRoleId, excludedComponentVideoIds) {
        var queryParams = {
            id: packageId,
            path: componentVirtualPaths,
            profileId: mediaAcceptProfileId,
            roleId: componentRoleId,
            sub: 'videoComponentValidationResult',
            excludeContentId: excludedComponentVideoIds
        };
        return PackageResourceFactory.get(queryParams).$promise.then(function (validationResults) {
            var results = [];
            _.forEach(validationResults, function (validationResult, assetPath) {
                if (_.has(validationResult, 'failures')) {
                    var parsedValidationResult = parseValidationFailures(validationResult.failures, assetPath, mediaAcceptProfileId);
                    results.push(parsedValidationResult);
                }
            });
            if (_.isEmpty(results)) {
                results.push({
                    source: 'Component Videos',
                    errors: [],
                    warnings: [],
                });
            }
            return results;
        });
    };
    //==================//
    // AdPod Validation //
    //==================//
    this.validateAdPodLocal = function (adPodFile, adPodAcceptProfile) {
        return readFile(adPodFile)
            .then(function (readerResult) {
            var adPodFilename = adPodFile.name;
            var adPodAcceptProfileId = adPodAcceptProfile.id;
            var adPodValidationDTO = {
                adPodProfileId: adPodAcceptProfileId,
                adPodFilename: adPodFilename,
                adPodData: readerResult
            };
            return MediaProfileResourceFactory.validateAdPod({}, adPodValidationDTO)
                .$promise.then(function (validationResults) {
                return parseValidationFailures(validationResults, adPodFilename, adPodAcceptProfileId);
            });
        });
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: debug-service.ts
 *
 * Created by randysorensen on 2019-04-10.
 */
function DebugServiceConstructor(_, $window) {
    //
    // Be very safe here... this can't ever crash a page.
    //
    var _this = this;
    var supportedLogLevels = [
        //
        // Listed in order of severity, from least to greatest
        //
        'trace',
        'debug',
        'info',
        'warn',
        'error'
    ];
    var loggers = {
        //
        // Function to call on messages, for each of the above
        // log levels
        //
        trace: console.info,
        debug: console.info,
        info: console.info,
        warn: console.warn,
        error: console.error
    };
    var defaultDebugLevel = 'info';
    this.currentLogLevel = _.get($window, '__wfcConfig.debugLevel', defaultDebugLevel);
    this.currentLogLevel = this.currentLogLevel.toLowerCase();
    this.levelEnabled = function (level) {
        return supportedLogLevels.indexOf(level) >= supportedLogLevels.indexOf(_this.currentLogLevel);
    };
    _.forEach(supportedLogLevels, function (level) {
        if (_this.levelEnabled(level)) {
            _this[level] = function (msg) {
                if (msg !== undefined) {
                    var levelUpperCase = _.invoke(level, 'toLocaleUpperCase');
                    var timeStamp = new Date().toISOString();
                    loggers[level](levelUpperCase + " - " + timeStamp + " - " + msg);
                }
                return true;
            };
        }
        else {
            _this[level] = function () { return false; };
        }
    });
    this.info("DebugService: current logging level is \"" + this.currentLogLevel + "\"");
}
angular.module('prism-ui.components').service('DebugService', DebugServiceConstructor);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: utils-service.ts
 *
 * Created by sjacobs on 3/16/18.
 */
'use strict';
angular.module('prism-ui.components').service('DeliveryItemsService', function (_, $q, LanguagesService, RolesService, MediaConversionTemplateService, AssetContentTemplatesService, ConditionalTemplatesService, TransformTemplatesService, MacCaptionTemplatesService, MediaAcceptProfileService, MetadataEditService, PartnerEditService) {
    this.getDeliveryItemEditViewFormData = function (partnerId) {
        var deliveryItemDefaultMetadataPromise = MetadataEditService.getMetadataByGroup('Media Conversion')
            .then(function (metadataItems) {
            var defaultMetadata = {};
            _.forEach(metadataItems, function (metadataItem) {
                defaultMetadata[metadataItem.name] = {
                    mvpd: metadataItem.mvpd,
                    required: false,
                    valueOverridden: false
                };
            });
            return defaultMetadata;
        });
        return $q.all({
            mediaConversionTemplates: MediaConversionTemplateService.getAllMediaConversionTemplates(),
            macCaptionTemplates: MacCaptionTemplatesService.getAllMacCaptionTemplates(),
            conditionalTemplates: ConditionalTemplatesService.getAllConditionalTemplates(),
            transformTemplates: TransformTemplatesService.getAllTransformTemplates(),
            languages: LanguagesService.getAllLanguages(),
            roles: RolesService.getAllRoles(),
            assetContentTemplates: AssetContentTemplatesService.getAllAssetContentTemplates(),
            mediaAcceptProfiles: MediaAcceptProfileService.getAcceptProfiles({ fetchLimit: 0 }),
            deliveryEndpointsForPartner: PartnerEditService.getDeliveryEndpointsForPartner(partnerId),
            deliveryItemDefaultMetadata: deliveryItemDefaultMetadataPromise
        });
    };
    this.getSearchViewColumnDefinitions = function (deliveryItemType) {
        var columnDefinitions = [];
        switch (deliveryItemType) {
            case 'Archive':
                columnDefinitions = [
                    {
                        field: 'name',
                        displayName: 'Name',
                        width: '500',
                        sort: {
                            direction: 'asc',
                        },
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'sourceEndpoint.name',
                        displayName: 'FROM',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'deliveryEndpoint.name',
                        displayName: 'TO',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'targetPathExpression',
                        displayName: 'Target Path',
                        width: '500',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    }
                ];
                break;
            case 'Artwork':
                columnDefinitions = [
                    {
                        field: 'name',
                        displayName: 'Name',
                        sort: {
                            direction: 'asc',
                        },
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'sourceMediaAcceptProfile.name',
                        displayName: 'From Artwork MAP',
                        width: '500',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'targetContentTemplate.name',
                        displayName: 'To Template',
                        width: '500',
                        cellTemplate: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/searchView/cell-templates/to-template-cell-template.html'
                    },
                    {
                        field: 'deliveryEndpoint.name',
                        displayName: 'Via',
                        width: '500',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'targetPathExpression',
                        displayName: 'Target Path',
                        width: '500',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    }
                ];
                break;
            case 'Audio':
                columnDefinitions = [
                    {
                        field: 'name',
                        displayName: 'Name',
                        sort: {
                            direction: 'asc',
                        },
                        width: '500',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'sourceMediaAcceptProfile.name',
                        displayName: 'From Audio MAP',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'mediaConversionTemplate',
                        displayName: 'To Template',
                        cellTemplate: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/searchView/cell-templates/to-template-cell-template.html'
                    },
                    {
                        field: 'deliveryEndpoint.name',
                        displayName: 'Via',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'targetPathExpression',
                        displayName: 'Target Path',
                        width: '500',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    }
                ];
                break;
            case 'CC':
                columnDefinitions = [
                    {
                        field: 'name',
                        displayName: 'Name',
                        sort: {
                            direction: 'asc',
                        },
                        width: '500',
                        cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'targetContentTemplate.name',
                        displayName: 'To Format',
                        cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'deliveryEndpoint.name',
                        displayName: 'Via',
                        cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'targetPathExpression',
                        displayName: 'Target Path',
                        width: '500',
                        cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                    }
                ];
                break;
            case 'Image':
                columnDefinitions = [
                    {
                        field: 'name',
                        displayName: 'Name',
                        sort: {
                            direction: 'asc',
                        },
                        width: '500',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'sourceMediaAcceptProfile.name',
                        displayName: 'From Images MAP',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'targetContentTemplate.name',
                        displayName: 'To Template',
                        cellTemplate: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/searchView/cell-templates/to-template-cell-template.html'
                    },
                    {
                        field: 'deliveryEndpoint.name',
                        displayName: 'Via',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'targetPathExpression',
                        displayName: 'Target Path',
                        width: '500',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    }
                ];
                break;
            case 'Metadata':
                columnDefinitions = [
                    {
                        field: 'name',
                        displayName: 'Name',
                        sort: {
                            direction: 'asc',
                        },
                        width: '500',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'xslTemplate.name',
                        displayName: 'XSLT',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'deliveryEndpoint.name',
                        displayName: 'Via',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'targetPathExpression',
                        displayName: 'Target Path',
                        width: '500',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    }
                ];
                break;
            case 'Subtitle':
                columnDefinitions = [
                    {
                        field: 'name',
                        displayName: 'Name',
                        sort: {
                            direction: 'asc',
                        },
                        width: '500',
                        cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'targetContentTemplate.name',
                        displayName: 'To Format',
                        cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'deliveryEndpoint.name',
                        displayName: 'Via',
                        cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'targetPathExpression',
                        displayName: 'Target Path',
                        width: '500',
                        cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                    }
                ];
                break;
            case 'Video':
                columnDefinitions = [
                    {
                        field: 'name',
                        displayName: 'Name',
                        sort: {
                            direction: 'asc',
                        },
                        width: '500',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'mediaConversionTemplate',
                        displayName: 'To Template',
                        cellTemplate: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/searchView/cell-templates/to-template-cell-template.html'
                    },
                    {
                        field: 'deliveryEndpoint.name',
                        displayName: 'Via',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'targetPathExpression',
                        displayName: 'Target Path',
                        width: '500',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    }
                ];
                break;
            default:
                console.warn("Could not get visible column definitions, Unknown Delivery Item Edit View specified. [" + deliveryItemType + "]");
                break;
        }
        return columnDefinitions;
    };
    this.getVisibleEditViewPanels = function (deliveryItemType) {
        var visiblePanels = {};
        switch (deliveryItemType) {
            case 'Archive':
                visiblePanels = {
                    general: true,
                    archive: true,
                    delivery: true,
                    redelivery: true,
                    partnerFormat: true
                };
                break;
            case 'Artwork':
                visiblePanels = {
                    general: true,
                    from: true,
                    to: true,
                    delivery: true,
                    redelivery: true,
                    partnerFormat: true
                };
                break;
            case 'Audio':
                visiblePanels = {
                    general: true,
                    from: true,
                    to: true,
                    delivery: true,
                    redelivery: true,
                    partnerFormat: true
                };
                break;
            case 'CC':
                visiblePanels = {
                    general: true,
                    from: true,
                    to: true,
                    delivery: true,
                    redelivery: true,
                    partnerFormat: true
                };
                break;
            case 'Image':
                visiblePanels = {
                    general: true,
                    from: true,
                    to: true,
                    delivery: true,
                    redelivery: true,
                    partnerFormat: true
                };
                break;
            case 'Metadata':
                visiblePanels = {
                    general: true,
                    to: true,
                    delivery: true,
                    redelivery: true,
                    partnerFormat: true
                };
                break;
            case 'Subtitle':
                visiblePanels = {
                    general: true,
                    from: true,
                    to: true,
                    delivery: true,
                    redelivery: true,
                    partnerFormat: true
                };
                break;
            case 'Video':
                visiblePanels = {
                    general: true,
                    from: true,
                    to: true,
                    audioChannelMapping: true,
                    closedCaptioningSubtitle: true,
                    postDeliveryProcessing: true,
                    adPartnerProperties: true,
                    delivery: true,
                    redelivery: true,
                    partnerFormat: true,
                    vantageMd5: true
                };
                break;
            default:
                console.warn("Could not get visible panels, Unknown Delivery Item Edit View specified. [" + deliveryItemType + "]");
                break;
        }
        return visiblePanels;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.components').service('MediaInfoService', function (_, $q, $timeout, $window) {
    var _this = this;
    // try to read 4 MiB at a time
    var CHUNK_SIZE = 4 * (Math.pow(2, 20));
    // const CHUNK_SIZE = 256 * 1024;
    //
    // These are defined in the MediaInfoLib sources.
    //
    var MediaInfoStates;
    (function (MediaInfoStates) {
        MediaInfoStates[MediaInfoStates["NONE"] = 0] = "NONE";
        MediaInfoStates[MediaInfoStates["ACCEPTED"] = 1] = "ACCEPTED";
        MediaInfoStates[MediaInfoStates["FILLED"] = 2] = "FILLED";
        MediaInfoStates[MediaInfoStates["UPDATE"] = 4] = "UPDATE";
        MediaInfoStates[MediaInfoStates["FINALIZED"] = 8] = "FINALIZED";
    })(MediaInfoStates || (MediaInfoStates = {}));
    var mediaInfo = null;
    var mediaInfoDeferred = null;
    var loadMediaInfo = function () {
        if (!mediaInfoDeferred) {
            mediaInfoDeferred = $q.defer();
            console.info("Loading MediaInfo.js ...");
            try {
                $window.MediaInfo(function () {
                    try {
                        //
                        // Note: Errors thrown here will not bubble
                        // back up to the outer scope, hence why
                        // there's a nested try/catch.
                        //
                        //
                        // Note 2: Here, `this` is the local
                        // anonymous function's scope, not the
                        // outer service's scope.
                        //
                        mediaInfo = new this.MediaInfo();
                        mediaInfoDeferred.resolve(mediaInfo);
                    }
                    catch (errorData) {
                        mediaInfoDeferred.reject(errorData);
                    }
                });
            }
            catch (errorData) {
                mediaInfoDeferred.reject(errorData);
            }
        }
        return mediaInfoDeferred.promise;
    };
    var parseFile = function (file, deferredMediaInfoExecution) {
        // console.log(`MediaInfoService.parseFile(): parsing file ${file.name}`);
        var fileUploaderConfig = {
            processing: false,
            fileSize: 0,
            offset: 0,
            state: 0
        };
        if (fileUploaderConfig.processing) {
            console.info("MediaInfoService.parseFile(): returning; already processing");
            return;
        }
        fileUploaderConfig.processing = true;
        fileUploaderConfig.fileSize = file.size;
        mediaInfo.open_buffer_init(fileUploaderConfig.fileSize, fileUploaderConfig.offset);
        var fileReader;
        var seek = function (length) {
            // console.log(`MediaInfoService.parseFile(): seeking to ${length} bytes`);
            if (!fileReader) {
                fileReader = new FileReader();
                fileReader.onload = processChunk;
            }
            if (fileUploaderConfig.processing) {
                var blob = file.slice(fileUploaderConfig.offset, length + fileUploaderConfig.offset);
                fileReader.readAsArrayBuffer(blob);
            }
            else {
                console.info("MediaInfoService.parseFile(): no longer processing - closing mediaInfo");
                mediaInfo.close();
            }
        };
        var openBufferContinueGotoGet = function (chunk, chunkLength) {
            //
            // This is required because the emscripten/JS bindings
            // do not support >32-bit integers.
            //
            var seekTo = -1;
            var seekToLow = mediaInfo.open_buffer_continue_goto_get_lower();
            var seekToHigh = mediaInfo.open_buffer_continue_goto_get_upper();
            if (seekToLow === -1 && seekToHigh === -1) {
                seekTo = -1;
            }
            else if (seekToLow < 0) {
                seekTo = seekToLow + Math.pow(2, 32) + (seekToHigh * Math.pow(2, 32));
            }
            else {
                seekTo = seekToLow + (seekToHigh * Math.pow(2, 32));
            }
            return seekTo;
        };
        var finalize = function () {
            console.info("MediaInfoService.parseFile(): analysis complete; obtaining result");
            mediaInfo.open_buffer_finalize();
            var resultXML = mediaInfo.inform();
            mediaInfo.close();
            // add file name and extension to track 1
            var fileName = file.name;
            var extension = _.chain(fileName).split('.').last().value();
            resultXML = resultXML.replace(/<\/track>/gi, "<FileName>" + fileName + "</FileName>\n" +
                ("<FileExtension>" + extension + "</FileExtension>\n") +
                "</track>");
            // form the final XML, adding an outer "Mediainfo"
            // let mediaInfoXML =
            //     `<Mediainfo version="${this.mediaInfoVersion}">\n` +
            //     `${resultXML}\n` +
            //     `</Mediainfo>`;
            deferredMediaInfoExecution.resolve(resultXML);
        };
        var processChunk = function (event) {
            if (!_.isNil(event.target.error)) {
                var message = "MediaInfo.JS failed: " + event.target.error;
                mediaInfo.close();
                deferredMediaInfoExecution.reject(message);
                return;
            }
            var chunk = new Uint8Array(event.target.result);
            fileUploaderConfig.state = mediaInfo.open_buffer_continue(chunk, chunk.length);
            if (chunk.length == 0 || !!(fileUploaderConfig.state & MediaInfoStates.FINALIZED)) {
                finalize();
                fileUploaderConfig.processing = false;
                return;
            }
            var seekTo = openBufferContinueGotoGet(chunk, chunk.length);
            if (seekTo === -1) {
                fileUploaderConfig.offset += chunk.length;
            }
            else {
                fileUploaderConfig.offset = seekTo;
                mediaInfo.open_buffer_init(fileUploaderConfig.fileSize, seekTo);
            }
            chunk = null;
            seek(CHUNK_SIZE);
        };
        // start
        seek(CHUNK_SIZE);
    };
    this.executeMediaInfo = function (file) {
        console.log("MediaInfoService.executeMediaInfo(): executing MediaInfo on file " + file.name);
        return loadMediaInfo().then(function () {
            if (!_this.mediaInfoVersion) {
                _this.mediaInfoVersion = mediaInfo.get_library_version();
                console.info("MediaInfo.js loaded -- using MediaInfoLib " + _this.mediaInfoVersion);
            }
            var deferredMediaInfoExecution = $q.defer();
            $timeout(function () {
                try {
                    parseFile(file, deferredMediaInfoExecution);
                }
                catch (errorData) {
                    deferredMediaInfoExecution.reject(errorData);
                }
            });
            return deferredMediaInfoExecution.promise;
        });
    };
    this.executeMediaInfoOnAsperaObjects = function (asperaUploadObjects) {
        console.log("MediaInfoService.executeMediaInfoOnAsperaObjects(): executing MediaInfo on " + asperaUploadObjects.length + " Aspera objects");
        var deferredMediaInfoExecutions = {};
        _.forEach(asperaUploadObjects, function (asperaObjectAndFile) {
            deferredMediaInfoExecutions[asperaObjectAndFile.name] = _this.executeMediaInfo(asperaObjectAndFile.file)
                .then(function (mediaInfoXML) {
                asperaObjectAndFile.mediaInfoXML = mediaInfoXML;
                return asperaObjectAndFile;
            });
        });
        return $q.all(deferredMediaInfoExecutions);
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.components').service('PackageAcceptTemplatesService', function (PackageAcceptTemplatesResourceFactory) {
    this.createPackageAcceptTemplate = function (packageAcceptTemplate) {
        return PackageAcceptTemplatesResourceFactory.createPackageAcceptTemplate(packageAcceptTemplate).$promise;
    };
    this.getPackageAcceptTemplate = function (id) {
        return PackageAcceptTemplatesResourceFactory.get({ id: id }).$promise;
    };
    this.getPackageAcceptTemplates = function (criteria) {
        return PackageAcceptTemplatesResourceFactory.query(criteria).$promise;
    };
    this.updatePackageAcceptTemplate = function (packageAcceptTemplate) {
        return PackageAcceptTemplatesResourceFactory.updatePackageAcceptTemplate(packageAcceptTemplate).$promise;
    };
    this.deletePackageAcceptTemplate = function (id) {
        return PackageAcceptTemplatesResourceFactory.deletePackageAcceptTemplate({ id: id }).$promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 *
 * Created by sjacobs on 1/29/19.
 */
'use strict';
angular.module('prism-ui.components').service('PackageCreationTemplatesService', function (_, PackageCreationTemplatesResourceFactory) {
    this.permissionViewState = 'DASHBOARD_TERRITORIES_VIEW_STATE';
    this.originalEditData = {};
    this.getAllPackageCreationTemplates = function (queryParams, queryHandler) {
        return PackageCreationTemplatesResourceFactory.query(queryParams, queryHandler).$promise;
    };
    this.getPackageCreationTemplate = function (id) {
        return PackageCreationTemplatesResourceFactory.getPackageCreationTemplate({ id: id }).$promise;
    };
    this.createPackageCreationTemplate = function (PackageCreationTemplate) {
        return PackageCreationTemplatesResourceFactory.createPackageCreationTemplate(PackageCreationTemplate).$promise;
    };
    this.updatePackageCreationTemplate = function (PackageCreationTemplate) {
        return PackageCreationTemplatesResourceFactory.updatePackageCreationTemplate(PackageCreationTemplate).$promise;
    };
    this.deletePackageCreationTemplate = function (id) {
        return PackageCreationTemplatesResourceFactory.deletePackageCreationTemplate({ id: id }).$promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: utils-service.ts
 *
 * Created by sjacobs on 3/16/18.
 */
'use strict';
angular.module('prism-ui.components').service('TerritoriesService', function (_, TerritoriesResourceFactory) {
    this.permissionViewState = 'DASHBOARD_TERRITORIES_VIEW_STATE';
    this.originalEditData = {};
    this.getAllTerritories = function (queryParams, queryHandler) {
        return TerritoriesResourceFactory.query(queryParams, queryHandler).$promise;
    };
    this.getTerritory = function (id) {
        return TerritoriesResourceFactory.getTerritory({ id: id }).$promise;
    };
    this.createTerritory = function (territory) {
        return TerritoriesResourceFactory.createTerritory(territory).$promise;
    };
    this.updateTerritory = function (territory) {
        return TerritoriesResourceFactory.updateTerritory(territory).$promise;
    };
    this.deleteTerritory = function (id) {
        return TerritoriesResourceFactory.deleteTerritory({ id: id }).$promise;
    };
});

'use strict';
angular.module('prism-ui.components').service('TranslatableMetadataService', function ($q, LanguagesService) {
    var _this = this;
    var dataObjectDeferred = $q.defer();
    this.dataObjectPromise = dataObjectDeferred.promise;
    this.resetDataObjectPromise = function () {
        dataObjectDeferred = $q.defer();
        _this.dataObjectPromise = dataObjectDeferred.promise;
    };
    this.setDataObject = function (dataObject) {
        dataObjectDeferred.resolve(dataObject);
    };
    this.dataObjectSaved = function (newDataObject) {
        _this.resetDataObjectPromise();
        _this.setDataObject(newDataObject);
        _this.onSave();
    };
    this.dataObjectReverted = function (newDataObject) {
        _this.resetDataObjectPromise();
        _this.setDataObject(newDataObject);
        _this.onRevert();
    };
    this.onSave = function () { };
    this.onRevert = function () { };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: utils-service.ts
 *
 * Created by randysorensen on 3/7/17.
 */
angular.module('prism-ui.components').service('UtilsService', function (_, $http, $q) {
    //===============//
    // App Constants //
    //===============//
    var _this = this;
    this.constants = {
        MINUTES_PER_DAY: 60 * 24,
        WEEKDAYS: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        MONTHS: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October',
            'November', 'December'],
        EARLIEST_RECORD_YEAR: 2013,
        DEFAULT_FETCH_LIMIT: 25,
    };
    //================//
    // Time Functions //
    //================//
    this.minutesToWeekday = function (minutes) {
        var weekdayIndex = Math.floor(minutes / _this.constants.MINUTES_PER_DAY);
        return _this.constants.WEEKDAYS[weekdayIndex];
    };
    this.timeToString = function (hours, minutes) {
        var strHours = String(hours);
        var strMinutes = String(minutes);
        if (strHours.length === 1) {
            strHours = '0' + strHours;
        }
        if (strMinutes.length === 1) {
            strMinutes = '0' + strMinutes;
        }
        return strHours + ':' + strMinutes;
    };
    this.minutesToTimeOfDay = function (scheduleMinutes) {
        var MINUTES_PER_DAY = 60 * 24;
        scheduleMinutes = scheduleMinutes % MINUTES_PER_DAY;
        var hours = String(Math.floor(scheduleMinutes / 60));
        var minutes = String(scheduleMinutes % 60);
        return _this.timeToString(hours, minutes);
    };
    //==================//
    // String Functions //
    //==================//
    this.firstToLowerCase = function (str) {
        return str[0].toLowerCase() + str.slice(1);
    };
    this.removeSpaces = function (str) {
        return str.split(' ').join('');
    };
    //=============//
    // Comparators //
    //=============//
    //
    // Returns:
    //      < 0 if date0 is less (earlier) than date1
    //      > 0 if date0 is greater (later) than date1
    //      0 if date0 and date1 are equal
    //
    this.dateCompare = function (date0, date1) {
        return Date.parse(date0) - Date.parse(date1);
    };
    //
    // Returns:
    //      < 0 if str0 is less than str1
    //      > 0 if str0 is greater than str1
    //      0 if str0 and str1 are equal
    //
    this.caseInsensitiveStringCompare = function (str0, str1) {
        str0 = str0.toLowerCase();
        str1 = str1.toLowerCase();
        if (str0 < str1) {
            return -1;
        }
        else if (str0 > str1) {
            return 1;
        }
        else {
            return 0;
        }
    };
    // Deep-compare two objects, but don't compare properties with
    // annotated or mangled names.
    var compareBasicObjects = function (obj0, obj1) {
        var ignoredPropertyNamePrefixes = ['$', '_'];
        var allKeys = _.union(_.keys(obj0), _.keys(obj1));
        return allKeys.reduce(function (accum, key) {
            if (ignoredPropertyNamePrefixes.indexOf(key[0]) < 0) {
                return accum + _this.compareBasic(obj0[key], obj1[key]);
            }
            else {
                return accum;
            }
        }, 0);
    };
    var compareBasicArrays = function (obj0, obj1) {
        if (obj0.length !== obj1.length) {
            return -1;
        }
        if (_.differenceWith(obj0, obj1, function (a, b) {
            return _this.compareBasic(a, b) === 0;
        }).length !== 0) {
            return -1;
        }
        return 0;
    };
    this.compareBasic = function (item0, item1) {
        //
        // Compare two items. Returns 0 if equal, non-zero if not
        // equal.
        //
        // The distinctions of this compare function are as
        // follows:
        //
        //	* object properties starting with '_' or '$' are
        //	  ignored
        //	* arrays are compared in an order-agnostic fashion;
        //    that is, [1, 2, 3] is equal to [2, 3, 1]
        //
        var type = typeof item0;
        var typeOther = typeof item1;
        if (type !== typeOther) {
            return -1;
        }
        if (type === 'object') {
            if (item0 === null || item1 === null) {
                return item0 === item1 ? 0 : -1;
            }
            if (Array.isArray(item0)) {
                return compareBasicArrays(item0, item1);
            }
            return compareBasicObjects(item0, item1);
        }
        else {
            return item0 === item1 ? 0 : -1;
        }
    };
    //============//
    // File Names //
    //============//
    this.buildFilters = function (fileExtensions) {
        return new RegExp('\.(' + fileExtensions.join('|') + ')$', 'i');
    };
    this.filtersToPrettyString = function (fileExtensions) {
        return _.chain(fileExtensions).toLower().split(',').uniq().compact().join(', ').value();
    };
    this.getFileName = function (path) {
        var fileName = '';
        if (path) {
            fileName = _.chain(path).split('/').last().value();
        }
        return fileName;
    };
    this.getFileExtension = function (path) {
        var fileExtension = '';
        if (path) {
            fileExtension = _.chain(path)
                .split('?')
                .first()
                .split('.')
                .last()
                .toLower()
                .value();
        }
        return fileExtension;
    };
    this.isFileNameValid = function (fileName) {
        var testResult = /^[a-zA-Z0-9_~]+([a-zA-Z0-9_~ \.\-])+$/.test(fileName);
        return testResult;
    };
    this.getPathSeparator = function () {
        return _.startsWith(_.lowerCase(window.navigator.platform), 'win') ? '\\' : '/';
    };
    this.getFileNameFromLocalPath = function (filePath) {
        return _.chain(filePath).split(_this.getPathSeparator()).last().value();
    };
    this.appendBaseFilename = function (filename, toAppend) {
        var basename = _.chain(filename).split('.').slice(0, -1).join('.').value();
        var extension = _.chain(filename).split('.').last().value();
        return "" + basename + toAppend + "." + extension;
    };
    //===============//
    // File Download //
    //===============//
    this.downloadFile = function (uri, downloadFileName) {
        if (downloadFileName === void 0) { downloadFileName = null; }
        console.info("Downloading \"" + downloadFileName + "\"");
        console.info("URI: \"" + uri + "\"");
        var downloadPromise;
        if (downloadFileName !== null) {
            downloadPromise = $http({
                // crude trick allowing file downloads to have a
                // custom filename
                url: uri,
                method: 'GET',
                responseType: 'blob'
            }).then(function (response) {
                var downloadLink = document.createElement('a');
                downloadLink.href = URL.createObjectURL(response.data);
                downloadLink.download = downloadFileName;
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            });
        }
        else {
            window.open(uri);
            downloadPromise = $q.when(true);
        }
        return downloadPromise;
    };
    //=======//
    // Misc. //
    //=======//
    // KeyCode expression represents alphanumeric, return and delete keys
    this.canPerformSearchFromKeyCode = function (event) {
        return ((event.keyCode > 47 && event.keyCode < 58) ||
            (event.keyCode > 64 && event.keyCode < 91) ||
            (event.keyCode > 96 && event.keyCode < 123) ||
            event.keyCode == 13 ||
            event.keyCode == 8 ||
            event.keyCode == 0);
    };
    this.callIfNotNull = function (fn) {
        if (fn) {
            return fn();
        }
        else {
            return false;
        }
    };
    this.hasData = function (prop) {
        return (prop !== undefined &&
            prop !== null &&
            prop !== '');
    };
    this.clampNumericProp = function (object, prop, min, max) {
        if (object[prop] > max) {
            object[prop] = max;
        }
        else if (object[prop] < min) {
            object[prop] = min;
        }
        object[prop] = Math.floor(object[prop]);
    };
    this.convertToNumber = function (object, propName) {
        if (!!object && object[propName] !== undefined) {
            object[propName] = Number(object[propName]);
        }
    };
    this.arrayToString = function (array, delimiter, key) {
        var newListString = '';
        _.forEach(array, function (item) {
            if (_.isEmpty(item[key])) {
                return;
            }
            if (_.isEmpty(newListString) && !_.isEmpty(item[key])) {
                newListString += item[key];
            }
            else if (!_.isEmpty(item[key])) {
                if (newListString !== delimiter) {
                    newListString += delimiter + item[key];
                }
                else {
                    newListString += item[key];
                }
            }
        });
        return newListString;
    };
    this.stringToArray = function (value, delimiter, key) {
        var items = [];
        if (_.isString(value)) {
            var stringItems = _.split(value, delimiter);
            _.forEach(stringItems, function (str) {
                var _a;
                items.push((_a = {}, _a[key] = str, _a));
            });
        }
        return items;
    };
    // Transform First (Middle) Last name format to Last, First (Middle) name format.
    this.transformDisplayNameToSortName = function (displayName) {
        // If the display name is nil return an empty string
        if (_.isNil(displayName)) {
            return '';
        }
        // Take the display name and split it on the spaces
        var displayNameDelimited = _.split(displayName, ' ');
        if (_.size(displayNameDelimited) > 1) {
            // if the display name is more than one word take the last word (n) and then concatenate it with a
            // comma and then the rest of the words (0 to n - 1)
            return _.last(displayNameDelimited) + ", " + _.join(_.initial(displayNameDelimited), ' ');
        }
        else {
            // if the display name is not nil and is one word, return it unmodified
            return displayName;
        }
    };
    // takes in a string without the enclosing // and tests it. For example, /[A-Z]+s/ would be '[A-Z]+s'
    this.inputValidatorByRegExpString = function ($event, currentValue, regexString) {
        if ($event.key.length === 1) {
            var newValue = $event.key;
            if (!(new RegExp(regexString).test(newValue))) {
                $event.preventDefault();
            }
        }
    };
    //=================//
    // Domain Specific //
    //=================//
    //
    // Takes in the content type and returns the path friendly keyword for routing
    //
    //     Movie/Special   -> movies
    //     Series          -> series
    //     Ad/PreRoll      -> adsAndPreRolls
    //
    var contentTypeToPathMapping = {
        'Series': 'series',
        'Movie/Special': 'movies',
        'Ad/PreRoll': 'adsAndPreRolls'
    };
    this.getPathKeywordFromContentType = function (contentType) {
        return _.get(contentTypeToPathMapping, contentType);
    };
    //
    // External ingest types
    //
    // - watchFolder
    // - JSONFeed
    //
    this.externalIngestTypes = {
        watchFolder: {
            value: 'watchFolder',
            displayName: 'Watch Folder'
        },
        jsonFeed: {
            value: 'jsonFeed',
            displayName: 'JSON Feed'
        }
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: metrics-dashboard-component.ts
 *
 * Created by randysorensen on 2019-02-13.
 */
function MetricsDashboardController(_, $location, loginService, BreadcrumbService, MetricsDashboardService, ModalService, NotificationService) {
    var _this = this;
    var setupBreadcrumbs = function () {
        BreadcrumbService.clearBreadcrumbs();
        BreadcrumbService.addBreadcrumb({
            name: 'Metrics',
            location: '/dashboard/metrics',
        });
    };
    var setupToolbar = function () {
        _this.toolbarButtonDefs = [
            {
                label: 'Export',
                icon: 'fa-download',
                enabled: function () { return true; },
                onClick: MetricsDashboardService.exportDeliveryMetrics
            }
        ];
    };
    var buildPanelRows = function () {
        _this.panelRows = [
            {
                currentMonthDataProperty: 'packagesDeliveredCurrentMonth',
                monthlyDatasetProperty: 'packagesDeliveredPerMonth',
                sumLabel: 'Total Packages Delivered',
                sumDataProperty: 'totalPackagesDelivered'
            },
            {
                currentMonthDataProperty: 'filesDeliveredCurrentMonth',
                monthlyDatasetProperty: 'filesDeliveredPerMonth',
                sumLabel: 'Total Files Delivered',
                sumDataProperty: 'totalFilesDelivered'
            },
            {
                currentMonthDataProperty: 'hoursDeliveredCurrentMonth',
                monthlyDatasetProperty: 'hoursDeliveredPerMonth',
                sumLabel: 'Total Hours Delivered',
                sumDataProperty: 'totalHoursDelivered'
            },
            {
                currentMonthDataProperty: 'terabytesDeliveredCurrentMonth',
                monthlyDatasetProperty: 'terabytesDeliveredPerMonth',
                sumLabel: 'Total File Size (TB) Delivered',
                sumDataProperty: 'totalTerabytesDelivered'
            }
        ];
    };
    //===================//
    // Template Controls //
    //===================//
    this.onFilterButtonClick = function ($event) {
        $event.target.blur();
        $event.stopImmediatePropagation();
        ModalService.showMetricsFilterModal();
    };
    this.goToLogin = function () {
        $location.url('/login');
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.chromeless = !loginService.isAuthenticated();
        _this.loadingIndicator = {
            backdrop: true,
            show: true,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.metricsData = {
            partnerRatioMap: {},
            packagesDeliveredPerMonth: {},
            filesDeliveredPerMonth: {},
            hoursDeliveredPerMonth: {},
            bytesDeliveredPerMonth: {},
            totalPackagesDelivered: 0,
            totalFilesDelivered: 0,
            totalHoursDelivered: 0,
            totalBytesDelivered: 0
        };
        _this.panelRows = [];
        if (_this.chromeless) {
            initChromeless();
        }
        else {
            initNormal();
        }
    };
    var initChromeless = function () {
        buildPanelRows();
        MetricsDashboardService.initialize(true)
            .finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var initNormal = function () {
        setupBreadcrumbs();
        setupToolbar();
        buildPanelRows();
        MetricsDashboardService.initialize()
            .catch(function (errorData) {
            console.error("MetricsDashboardController.$onInit():");
            console.error(errorData);
            NotificationService.createFailureNotification("Unable to fetch metrics data.", _.get(errorData, 'data.message', errorData), true, -1);
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
}
angular.module('prism-ui.metricsDashboard').component('metricsDashboard', {
    templateUrl: 'dashboard/metrics/metrics-dashboard-template.html',
    controller: MetricsDashboardController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: metrics-dashboard-service.ts
 *
 * Created by randysorensen on 2019-02-19.
 */
function MetricsDashboardServiceConstructor(_, $interval, $q, moment, AuthFactory, DashboardResourceFactory, DynamicPropertiesService, EndPointService, PartnerEditService, UtilsService) {
    var _this = this;
    var dataRefreshInterval;
    var getAllAvailablePartners = function () {
        var partnersCriteria = {
            includeHidden: true,
            fetchLimit: 0,
            fetchOffset: 0
        };
        return PartnerEditService.getAllPartners(partnersCriteria)
            .then(function (allPartners) {
            _this.allAvailablePartners = allPartners;
        });
    };
    var createMonthKey = function (year, month) {
        //
        // Month key format: YYYYMM
        //
        var yearStr = "" + year;
        var monthStr = "" + month;
        if (month < 10) {
            monthStr = "0" + monthStr;
        }
        return parseInt("" + yearStr + monthStr);
    };
    var createMonthKeyRange = function (fromDate, toDate) {
        //
        // Creates all month keys including and between fromDate
        // and toDate.
        //
        var fromKey = createMonthKey(fromDate.getFullYear(), fromDate.getMonth() + 1);
        var toKey = createMonthKey(toDate.getFullYear(), toDate.getMonth() + 1);
        var monthKeys = [];
        var currentKey = fromKey;
        while (currentKey <= toKey) {
            monthKeys.push("" + currentKey);
            if ((currentKey % 100) !== 12) {
                // go to next month
                ++currentKey;
            }
            else {
                // go back to January
                currentKey -= 11;
                // advance year part
                currentKey += 100;
            }
        }
        return monthKeys;
    };
    var getPerMonthDatasetNames = function (metricsData) {
        //
        // Grabs all of the property names which have a
        // "...PerMonth" suffix and returns them as a list of
        // strings
        //
        // get a list of each "...PerMonth" property
        var metricsDataResultKeys = _.keys(metricsData);
        return _.filter(metricsDataResultKeys, function (key) {
            return _.includes(key, 'PerMonth');
        });
    };
    var fillInMissingMonths = function (metricsData, fromDate, toDate) {
        //
        // In each of the "...PerMonth" objects, fill in any
        // missing month sums with an implied 0.
        //
        var perMonthDatasetNames = getPerMonthDatasetNames(metricsData);
        var individualMonthKeys = createMonthKeyRange(fromDate, toDate);
        _.forEach(perMonthDatasetNames, function (datasetKey) {
            _.forEach(individualMonthKeys, function (monthKey) {
                if (metricsData[datasetKey][monthKey] === undefined) {
                    metricsData[datasetKey][monthKey] = 0;
                }
            });
        });
    };
    var addCurrentMonth = function (metricsData, fromDate, toDate) {
        //
        // If the metrics data includes data for the current month,
        // add a new property for each "...PerMonth" data type
        // which has the current month's data.
        //
        var currentDate = new Date();
        if (toDate.getMonth() === currentDate.getMonth() && toDate.getFullYear() && currentDate.getFullYear()) {
            var perMonthDatasetNames = getPerMonthDatasetNames(metricsData);
            var currentMonthKey_1 = createMonthKey(currentDate.getFullYear(), currentDate.getMonth() + 1);
            _.forEach(perMonthDatasetNames, function (perMonthDatasetName) {
                var currentMonthPropertyName = _.replace(perMonthDatasetName, 'PerMonth', 'CurrentMonth');
                metricsData[currentMonthPropertyName] = metricsData[perMonthDatasetName][currentMonthKey_1];
            });
        }
    };
    var toPrettyNumber = function (n) { return _.round(parseInt(n)).toLocaleString(); };
    var bytesToTB = function (b) { return b / (Math.pow(10, 12)); };
    var toPrettyTB = function (b) { return _.round(bytesToTB(parseInt(b))).toLocaleString(); };
    var toPercent = function (value) { return _.round(parseFloat(value) * 100.0); };
    var datasetDescriptors = [
        {
            datasetPropertyName: 'packagesDeliveredPerMonth',
            label: 'Packages',
            prettifier: toPrettyNumber
        },
        {
            datasetPropertyName: 'filesDeliveredPerMonth',
            label: 'Files',
            prettifier: toPrettyNumber
        },
        {
            datasetPropertyName: 'hoursDeliveredPerMonth',
            label: 'Hours',
            prettifier: toPrettyNumber
        },
        {
            datasetPropertyName: 'bytesDeliveredPerMonth',
            label: 'Size (TB)',
            prettifier: toPrettyTB
        }
    ];
    var createTooltipData = function (metricsData) {
        var monthKeys = createMonthKeyRange(_this.currentCriteria.fromDate, _this.currentCriteria.toDate);
        var tooltipData = {};
        _.forEach(monthKeys, function (monthKey) {
            var monthKeyAsNumber = parseInt(monthKey);
            var year = _.floor(monthKeyAsNumber / 100);
            var month = monthKeyAsNumber % 100;
            var monthName = UtilsService.constants.MONTHS[month - 1];
            tooltipData[monthKey] = {};
            tooltipData[monthKey].title = monthName + " " + year;
            tooltipData[monthKey].lines = [];
            tooltipData[monthKey].tooltipClass = 'monthly-bar-graph-tooltip';
            _.forEach(datasetDescriptors, function (datasetDescriptor) {
                var value = metricsData[datasetDescriptor.datasetPropertyName][monthKeyAsNumber];
                var prettyValue = datasetDescriptor.prettifier(value);
                tooltipData[monthKey].lines.push(datasetDescriptor.label + ": " + prettyValue);
            });
        });
        return tooltipData;
    };
    var makeDataPretty = function (metricsData) {
        var prettyMetricsData = {
            partnerRatioMap: metricsData.partnerRatioMap
        };
        var numericProperties = ['totalPackagesDelivered', 'totalFilesDelivered', 'totalHoursDelivered',
            'packagesDeliveredCurrentMonth', 'filesDeliveredCurrentMonth', 'hoursDeliveredCurrentMonth'];
        _.forEach(numericProperties, function (numericProperty) {
            if (metricsData.hasOwnProperty(numericProperty)) {
                prettyMetricsData[numericProperty] = toPrettyNumber(metricsData[numericProperty]);
            }
        });
        var numericDatasets = ['packagesDeliveredPerMonth', 'filesDeliveredPerMonth', 'hoursDeliveredPerMonth',
            'bytesDeliveredPerMonth'];
        _.forEach(numericDatasets, function (numericDataset) {
            prettyMetricsData[numericDataset] = _.cloneDeep(metricsData[numericDataset]);
        });
        var storageSizeProperties = ['totalBytesDelivered', 'bytesDeliveredCurrentMonth'];
        _.forEach(storageSizeProperties, function (storageSizeProperty) {
            if (metricsData.hasOwnProperty(storageSizeProperty)) {
                prettyMetricsData[storageSizeProperty] = metricsData[storageSizeProperty];
                var dstProperty = _.replace(storageSizeProperty, 'bytes', 'terabytes');
                dstProperty = _.replace(dstProperty, 'Bytes', 'Terabytes');
                prettyMetricsData[dstProperty] = toPrettyTB(metricsData[storageSizeProperty]);
            }
        });
        prettyMetricsData.terabytesDeliveredPerMonth = {};
        _.forEach(metricsData.bytesDeliveredPerMonth, function (bytes, monthKey) {
            prettyMetricsData.terabytesDeliveredPerMonth[monthKey] = bytesToTB(parseInt(bytes));
        });
        prettyMetricsData.tooltipData = createTooltipData(prettyMetricsData);
        return prettyMetricsData;
    };
    var addPartnerRatioMap = function (metricsData) {
        _.forEach(metricsData.partnerRatioMap, function (value, key) {
            metricsData.partnerRatioMap[key] = toPercent(value);
        });
    };
    var getMetricsQueryParams = function () {
        var criteria = _this.currentCriteria;
        var fromDateParam = moment(criteria.fromDate).format('MMM DD YYYY');
        var toDateParam = moment(criteria.toDate).format('MMM DD YYYY');
        var queryParams = {
            fromDate: fromDateParam,
            toDate: toDateParam
        };
        if (criteria.partners.length) {
            queryParams.partnerId = _.map(criteria.partners, 'id');
        }
        else if (criteria.partnerTypes.length) {
            queryParams.partnerType = criteria.partnerTypes;
        }
        var dashboardApiKey = '838f7278-626c-4964-9fcd-ca2359b2076e';
        if (_this.chromeless) {
            queryParams.apiKey = dashboardApiKey;
        }
        return queryParams;
    };
    var downloadFile = function (url) {
        window.open(url);
    };
    this.exportDeliveryMetrics = function () {
        var queryParams = getMetricsQueryParams();
        var exportURL = EndPointService.dashboardEndpoint + "/exportDeliveryMetrics";
        var queryParamCount = 0;
        var addParam = function (param) {
            if (queryParamCount === 0) {
                exportURL += '?';
            }
            else {
                exportURL += '&';
            }
            exportURL += param;
            ++queryParamCount;
        };
        addParam("fromDate=" + queryParams.fromDate.split(' ').join('+'));
        addParam("toDate=" + queryParams.toDate.split(' ').join('+'));
        if (queryParams.partnerType) {
            _.forEach(queryParams.partnerType, function (partnerType) {
                addParam("partnerType=" + partnerType);
            });
        }
        if (queryParams.partnerId) {
            _.forEach(queryParams.partnerId, function (partnerId) {
                addParam("partnerId=" + partnerId);
            });
        }
        addParam(AuthFactory.getAuthQueryString());
        console.info("opening report link: " + exportURL);
        downloadFile(exportURL);
    };
    var createInitialData = function () {
        return {
            partnerRatioMap: {
                Other: 1
            },
            totalPackagesDelivered: 0,
            totalFilesDelivered: 0,
            totalHoursDelivered: 0,
            totalBytesDelivered: 0,
            packagesDeliveredPerMonth: {},
            filesDeliveredPerMonth: {},
            hoursDeliveredPerMonth: {},
            bytesDeliveredPerMonth: {}
        };
    };
    var processMetricsData = function (metricsData) {
        var criteria = _this.currentCriteria;
        fillInMissingMonths(metricsData, criteria.fromDate, criteria.toDate);
        addCurrentMonth(metricsData, criteria.fromDate, criteria.toDate);
        metricsData = makeDataPretty(metricsData);
        addPartnerRatioMap(metricsData);
        metricsData.timeStamp = new Date();
        _this.metricsData = metricsData;
        _.forEach(_this.dataUpdateCallbacks, function (callback) {
            callback(metricsData);
        });
        return metricsData;
    };
    this.getMetricsData = function () {
        var queryParams = getMetricsQueryParams();
        if (!_.keys(_this.metricsData).length) {
            var initialPromise = $q.when(processMetricsData(createInitialData()));
            _this.getMetricsData();
            return initialPromise;
        }
        return DashboardResourceFactory.getDeliveryMetrics(queryParams)
            .$promise.then(function (metricsData) {
            return processMetricsData(metricsData);
        });
    };
    var onAutomaticDataRefresh = function () {
        if (_.isEqual(_this.defaultCriteria, _this.currentCriteria)) {
            // keep the current criteria up-to-date
            _this.setDefaultCriteria();
        }
        else {
            _this.getMetricsData();
        }
    };
    this.activateDataRefreshInterval = function () {
        var refreshInterval = DynamicPropertiesService.getPropValueAsInt('metrics.refreshInterval', 5 * 60);
        return _this.getMetricsData().then(function (metricsData) {
            if (dataRefreshInterval === undefined) {
                dataRefreshInterval = $interval(onAutomaticDataRefresh, refreshInterval * 1000);
            }
            return metricsData;
        });
    };
    this.deactivateDataRefreshInterval = function () {
        if (dataRefreshInterval) {
            $interval.cancel(dataRefreshInterval);
        }
        dataRefreshInterval = undefined;
    };
    this.restartDataRefreshInterval = function () {
        _this.deactivateDataRefreshInterval();
        return _this.activateDataRefreshInterval();
    };
    this.registerDataUpdateCallback = function (callback) {
        if (typeof (callback) === 'function') {
            if (!_.includes(_this.dataUpdateCallbacks, callback)) {
                _this.dataUpdateCallbacks.push(callback);
            }
            // prime it with data now
            callback(_this.metricsData);
        }
    };
    this.refreshNow = function () {
        if (dataRefreshInterval) {
            return _this.restartDataRefreshInterval();
        }
        else {
            return _this.getMetricsData();
        }
    };
    this.unregisterDataUpdateCallback = function (callback) {
        _.pull(_this.dataUpdateCallbacks, callback);
    };
    this.setCurrentCriteria = function (currentCriteria) {
        _this.currentCriteria = _.cloneDeep(currentCriteria);
        return _this.refreshNow();
    };
    this.getCurrentCriteria = function () {
        return _.cloneDeep(_this.currentCriteria);
    };
    this.createDefaultCriteria = function () {
        var defaultCriteria = {
            fromDate: new Date(),
            toDate: new Date(),
            partners: []
        };
        //
        // Since we're only concerned with months & years, we set
        // the dates to the 10th & 20th of the applicable months
        // to avoid hitting any timezone boundaries, and also to
        // ensure the toDate is always after the fromDate when
        // they fall in the same month
        //
        // by default, start a year ago next month
        defaultCriteria.fromDate.setFullYear(defaultCriteria.fromDate.getFullYear() - 1);
        defaultCriteria.fromDate.setMonth(defaultCriteria.fromDate.getMonth() + 1);
        defaultCriteria.fromDate.setDate(10);
        // by default, include the most recent data
        defaultCriteria.toDate.setDate(20);
        // select all partners & partner types by default - this is
        // interpreted as all partners and all partner types
        defaultCriteria.partners = [];
        defaultCriteria.partnerTypes = [];
        _this.defaultCriteria = defaultCriteria;
        return _.cloneDeep(defaultCriteria);
    };
    this.setDefaultCriteria = function () {
        _this.createDefaultCriteria();
        _this.setCurrentCriteria(_this.defaultCriteria);
    };
    this.currentCriteriaIncludesPresent = function () {
        return ((new Date()).getMonth() === _.invoke(_this, 'currentCriteria.toDate.getMonth') &&
            (new Date()).getFullYear() === _.invoke(_this, 'currentCriteria.toDate.getFullYear'));
    };
    this.getAllAvailablePartners = function () {
        return _.cloneDeep(_this.allAvailablePartners);
    };
    this.initialize = function (chromeless) {
        if (chromeless === void 0) { chromeless = false; }
        _this.chromeless = chromeless;
        _this.dataUpdateCallbacks = [];
        _this.metricsData = {};
        _this.allAvailablePartners = [];
        _this.defaultCriteria = {};
        _this.currentCriteria = {};
        var defaultCriteria = _this.createDefaultCriteria();
        _this.defaultCriteria = _.cloneDeep(defaultCriteria);
        _this.currentCriteria = _.cloneDeep(defaultCriteria);
        if (!chromeless) {
            return $q.all([
                DynamicPropertiesService.queryForProperties(),
                getAllAvailablePartners()
            ]).then(function () {
                return _this.activateDataRefreshInterval();
            });
        }
        else {
            return DynamicPropertiesService.queryForProperties()
                .then(_this.activateDataRefreshInterval);
        }
    };
    this.shutdown = function () {
        //
        // TODO
        //
    };
}
angular
    .module('prism-ui.metricsDashboard')
    .service('MetricsDashboardService', MetricsDashboardServiceConstructor);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function OffCyclePlanners(_, $location, $timeout, BreadcrumbService, EchoService, NavbarUtilService, NotificationService, PaginationService, PartnerEditService, PartnerResourceFactory, PermissionsService, SearchFilterService) {
    var _this = this;
    var permissionViewState = 'DASHBOARD_OFF_CYCLE_PLANNERS_VIEW_STATE';
    //======//
    // Grid //
    //======//
    this.offCyclePlannerGridColumns = [
        {
            name: 'checkMarkRowHeaderCol',
            field: 'checkMark',
            width: 30,
            enableColumnMenu: false,
            enableSorting: false,
            enableColumnResizing: false,
            cellTemplate: 'components/visual/grid/check-mark-template.html',
            headerCellTemplate: '<div class="ui-grid-cell-contents" col-index="renderIndex" ng-click="grid.appScope.$ctrl.toggleRows($event)">' +
                '<input type="checkbox" ng-checked="grid.selection.selectAll"/><label></label></div>'
        },
        {
            field: 'name',
            name: 'Name',
            sortable: true,
            enableColumnMenu: false
        },
        {
            field: 'lookBack',
            name: 'Back',
            sortable: false,
            enableColumnMenu: false,
            width: 90
        },
        {
            field: 'lookForward',
            name: 'Forward',
            sortable: false,
            enableColumnMenu: false,
            width: 90
        },
        {
            field: 'scheduleLabel',
            name: 'Schedule / Interval',
            sortable: false,
            enableColumnMenu: false
        },
        {
            field: 'lastRun',
            name: 'Last Run',
            cellFilter: 'amDateFormat:"MMM D, YYYY, h:mm A"',
            sortable: false,
            enableColumnMenu: false
        },
        {
            field: 'nextRun',
            name: 'Next Run',
            cellFilter: 'amDateFormat:"MMM D, YYYY, h:mm A"',
            sortable: false,
            enableColumnMenu: false
        }
    ];
    this.toggleRows = function (event) {
        if (_this.gridApi.selection.selectAll) {
            _this.gridApi.selection.clearSelectedRows(event);
            _this.gridApi.selection.selectAll = false;
        }
        else {
            _this.gridApi.selection.selectAllVisibleRows(event);
            _this.gridApi.selection.selectAll = true;
        }
        _this.startPlannersTimeout = null;
        _this.selectedPlanners = _this.gridApi.selection.getSelectedRows();
    };
    this.gridRowSelectionChangedHandler = function (row, event) {
        if (event) {
            _this.startPlannersTimeout = null;
            if (row.isSelected) {
                _this.selectedPlanners.push(row.entity);
            }
            else {
                _.remove(_this.selectedPlanners, function (planner) {
                    return planner.id === row.entity.id;
                });
            }
        }
    };
    this.offCyclePlannersGrid = {
        selectionRowHeaderColName: 'checkMarkRowHeaderCol',
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableFullRowSelection: true,
        enableSorting: true,
        rowHeight: 26,
        multiSelect: true,
        minRowsToShow: 25,
        enableVerticalScrollbar: 2,
        columnDefs: this.offCyclePlannerGridColumns,
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            _this.gridApi.grid.registerRowsProcessor(_this.processGridFilter, 200);
            _this.gridApi.selection.on.rowSelectionChanged(null, _this.gridRowSelectionChangedHandler);
        }
    };
    //======//
    // REST //
    //======//
    var getData = function () {
        _this.loadingIndicator.show = true;
        var offset = _this.pagingOptions.pageSize * (_this.pagingOptions.currentPage - 1);
        PartnerEditService.getPartnerPlanners({
            fetchOffset: offset,
            fetchLimit: _this.pagingOptions.pageSize
        }).then(function (response) {
            _this.offCyclePlannersGrid.data = _.cloneDeep(_.sortBy(response.planners, ['name']));
            PaginationService.parseResponseHeaders(response.headers);
            _this.searchText = $location.search().searchText || null;
            _this.loadingIndicator.show = false;
        });
    };
    this.deliverOffCyclePlanners = function () {
        if (!_this.startPlannersTimeout) {
            var message = 'Planner(s) may take longer than expected. You will be notified once sent.';
            var newTimeout_1;
            newTimeout_1 = $timeout(function () {
                if (_this.startPlannersTimeout === newTimeout_1) {
                    _this.startPlannersTimeout = null;
                }
            }, 5000);
            _this.startPlannersTimeout = newTimeout_1;
            NotificationService.createInfoNotification(message);
            PartnerEditService.deliverOffCyclePlanners(_this.selectedPlanners, _this.offCyclePlannersMessage).then(function (response) {
                // API will create an event when planner workflow is started
                EchoService.awaitNotification(response.id, function (event) {
                    var status;
                    switch (event.eventPayload.status) {
                        case 'SUCCESS':
                            status = EchoService.EventStatus.SUCCEEDED;
                            break;
                        case 'FAILURE':
                            status = EchoService.EventStatus.FAILED;
                            break;
                        default:
                            status = EchoService.EventStatus.PENDING;
                    }
                    return {
                        message: event.eventPayload.body,
                        status: status,
                    };
                });
            });
        }
        else {
            var message = 'Please wait a bit before redelivering planner(s)...';
            NotificationService.createWarningNotification(message);
        }
    };
    //===================//
    // Template Response //
    //===================//
    this.processGridFilter = function (renderableRows) {
        renderableRows.forEach(function (row) {
            row.visible = (_this.searchText === null) ?
                true :
                row.entity.name.toLowerCase().indexOf(_this.searchText) !== -1;
        });
        return renderableRows;
    };
    NavbarUtilService.viewSearchFunction = function (searchText, forceRefresh) {
        _this.searchText = searchText;
        getData();
    };
    this.messageChangedHandler = function () {
        _this.startPlannersTimeout = null;
    };
    //============//
    // Pagination //
    //============//
    this.onPaginationChanged = function () {
        _this.gridApi.selection.clearSelectedRows();
        getData();
    };
    this.paginationPrevPageHandler = function () {
        --_this.pagingOptions.currentPage;
        _this.onPaginationChanged();
    };
    this.paginationNextPageHandler = function () {
        ++_this.pagingOptions.currentPage;
        _this.onPaginationChanged();
    };
    this.paginationJumpToPageHandler = function () {
        _this.onPaginationChanged();
    };
    //===========//
    // Lifecycle //
    //===========//
    this.$onInit = function () {
        _this.startPlannersTimeout = null;
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.pagingOptions = PaginationService;
        PaginationService.pageDataResource = PartnerResourceFactory;
        _this.paginationDefs = {
            paginationPrevPageHandler: _this.paginationPrevPageHandler,
            paginationNextPageHandler: _this.paginationNextPageHandler,
            paginationPageSizeChanged: _this.onPaginationChanged,
            paginationJumpToPageHandler: _this.paginationJumpToPageHandler,
            pagingOptions: _this.pagingOptions
        };
        BreadcrumbService.clearBreadcrumbs();
        _this.breadcrumbLabel = 'Off Cycle Planners';
        _this.selectedPlanners = [];
        SearchFilterService.populateCriteriaFromLocationSearch();
        PermissionsService.getReadWritePermissions(permissionViewState).then(function (permissions) {
            _this.permissions = permissions;
            getData();
        });
    };
}
angular.module('prism-ui.offCyclePlanners').component('offCyclePlannersView', {
    templateUrl: 'dashboard/offCyclePlanners/off-cycle-planners-template.html',
    controller: OffCyclePlanners,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: package-checkin-component.ts
 *
 * Created by randysorensen on 1/9/18.
 */
'use strict';
//
// This is the tab controller and gets its name from the sidebar
// item. The "BatchCheckinController" is specific to the check-in
// tab.
//
function PackageCheckinController(
// external deps
_, 
// internal deps
BreadcrumbService, ModalService) {
    //================//
    // Template Logic //
    //================//
    this.onTabSelect = function (name) {
        switch (name) {
            case 'checkin':
                break;
            case 'checkedOut':
                break;
            default:
                console.warn("PackageCheckinController.onTabSelect(): no such tab '" + name + "'");
                break;
        }
    };
    this.onTabDeselect = function (name, $event) {
        switch (name) {
            case 'checkin':
                break;
            case 'checkedOut':
                break;
            default:
                console.warn("PackageCheckinController.onTabDeselect(): no such tab '" + name + "'");
                break;
        }
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        BreadcrumbService.clearBreadcrumbs();
        BreadcrumbService.addBreadcrumb({
            name: 'Package Check-in',
            location: '/dashboard/checkin',
        });
    };
}
angular
    .module('prism-ui.dashboard.checkin')
    .component('packageCheckin', {
    controller: PackageCheckinController,
    templateUrl: 'dashboard/packageCheckin/package-checkin-template.html',
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.mvpd').service('MVPDViewService', function (_, MetadataService, MetadataEditService) {
    var _this = this;
    var _componentsMap = {};
    var getProps = function (properties) {
        var props = {};
        angular.forEach(properties, function (prop, name) {
            props[name] = prop;
        });
        return props;
    };
    this.permissionViewState = 'MVPD_VIEW_STATE';
    this.editorForm = undefined;
    this.originalEditData = {};
    this.getComponentsMap = function (newComponentsMap) {
        if (newComponentsMap) {
            _componentsMap = newComponentsMap;
        }
        return _componentsMap;
    };
    this.getMetadataByGroup = function (groupName, editData) {
        return MetadataEditService.getMetadataByGroup(groupName).then(function (properties) {
            var componentsMap = {};
            _this.metadataProperties = properties;
            if (editData.metadata) {
                componentsMap = _this.buildComponentsMap(editData);
            }
            else {
                var metadataItems = _this.metadataProperties.reduce(function (mappedItems, metadataItem) {
                    mappedItems[metadataItem.name] = { required: false, valueOverridden: false };
                    return mappedItems;
                }, {});
                componentsMap = MetadataService.buildCustomComponentMap(metadataItems, undefined, true, MetadataService.textListInputProps.delimiter, MetadataService.textListInputProps.objectKey);
            }
            _this.getComponentsMap(componentsMap);
            return editData;
        });
    };
    this.buildComponentsMap = function (editData) {
        var allComponents = MetadataService.buildCustomComponentMap(editData.metadata.properties, undefined, true, MetadataService.textListInputProps.delimiter, MetadataService.textListInputProps.objectKey);
        return getProps(allComponents);
    };
    this.revertMVPDEditData = function () {
        _.forEach(_this.getComponentsMap(undefined), function (comp, key) {
            comp.instanceData.value = _this.originalEditData.metadata.properties[key].value;
        });
        return _this.getComponentsMap(undefined);
    };
    this.getFieldErrorsTooltip = function (missingMVPDFields) {
        return "Missing " + missingMVPDFields.length + " Input Value(s): " + _.join(missingMVPDFields, ', ');
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.assetContentTemplates').service('AssetContentTemplatesService', function (_, AssetContentTemplatesResourceFactory) {
    this.getAllAssetContentTemplates = function (type) {
        if (type === void 0) { type = null; }
        return AssetContentTemplatesResourceFactory.query({ type: type }).$promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.categories').service('CategoriesService', function (CategoriesResourceFactory) {
    this.originalEditData = {};
    this.viewData;
    this.getAllCategories = function (criteria) {
        return CategoriesResourceFactory.getAllCategories(criteria).$promise;
    };
    this.getCategoryTypes = function () {
        return CategoriesResourceFactory.getCategoryTypes().$promise;
    };
    this.createCategory = function (category) {
        return CategoriesResourceFactory.createCategory(category).$promise;
    };
    this.getCategory = function (categoryId) {
        return CategoriesResourceFactory.getCategory({ id: categoryId }).$promise;
    };
    this.updateCategory = function (category) {
        return CategoriesResourceFactory.updateCategory(category).$promise;
    };
    this.deleteCategory = function (categoryId) {
        return CategoriesResourceFactory.deleteCategory({ id: categoryId }).$promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: contacts-service.ts
 *
 * Created by randysorensen on 10/2/17.
 */
'use strict';
angular
    .module('prism-ui.system')
    .service('ContactsService', function (_, $location, $q, $route, $routeParams, ContactsResourceFactory, NotificationService, PaginationService) {
    var _this = this;
    this.getContactsList = function (queryOpts) {
        return ContactsResourceFactory.query(queryOpts, function (contacts, headersCB) {
            PaginationService.parseResponseHeaders(headersCB());
        }).$promise;
    };
    this.createContact = function (contact) {
        return ContactsResourceFactory.save(contact).$promise;
    };
    this.getContact = function (contactId) {
        return ContactsResourceFactory.get({
            contactId: contactId
        }).$promise;
    };
    this.updateContact = function (contact) {
        return ContactsResourceFactory.update(contact).$promise;
    };
    this.toggleContactVisibility = function (contactId) {
        return ContactsResourceFactory.delete({
            contactId: contactId
        }).$promise;
    };
    this.getContactEditData = function () {
        var contactPromise;
        var contactId = $routeParams.contactId;
        if (contactId < 0) {
            var contactDeferral = $q.defer();
            contactDeferral.resolve({
                // In Flex this defaults to false for new
                // contacts.
                enabled: false
            });
            contactPromise = contactDeferral.promise;
        }
        else {
            contactPromise = _this.getContact(contactId);
        }
        return contactPromise.then(function (contact) {
            _this.contact = contact;
            _this.originalContact = _.cloneDeep(contact);
            return contact;
        });
    };
    this.canExitEditView = function () {
        var contactIsSaved = !!_.get(_this.contact, 'id');
        return !_this.editorForm || (contactIsSaved && _this.editorForm.$pristine);
    };
    var closeEditView = function () {
        _this.contact = undefined;
        _this.originalContact = undefined;
        _this.editorForm = undefined;
        $location.path($route.current.rootRoute);
    };
    this.showUnsavedChangesNotification = function () {
        NotificationService.createWarningNotification('You have unsaved changes. Please save or revert.');
    };
    this.exitEdit = function () {
        if (_this.canExitEditView()) {
            closeEditView();
        }
        else {
            _this.showUnsavedChangesNotification();
        }
    };
    this.revertEditData = function () {
        _this.contact = _.cloneDeep(_this.originalContact);
        _this.editorForm.$setPristine();
        return _this.contact;
    };
    this.saveEditData = function () {
        var saveFunction;
        if ($routeParams.contactId < 0) {
            saveFunction = _this.createContact;
        }
        else {
            saveFunction = _this.updateContact;
        }
        return saveFunction(_this.contact)
            .then(function (savedContact) {
            _this.contact = savedContact;
            _this.originalContact = _.cloneDeep(savedContact);
            $route.updateParams({
                contactId: savedContact.id
            });
            _this.editorForm.$setPristine();
            return _this.contact;
        }).catch(function (error) {
            NotificationService.createFailureNotification('An error occurred while saving the contact.', error.data.message);
        });
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components').service('DeliveryTemplatesService', function (_, DeliveryTemplatesResourceFactory) {
    this.originalEditData = {};
    this.getAllDeliveryTemplates = function (queryParams, queryHandler) {
        return DeliveryTemplatesResourceFactory.query(queryParams, queryHandler).$promise;
    };
    this.getDeliveryTemplate = function (deliveryTemplateId) {
        return DeliveryTemplatesResourceFactory.get({ deliveryTemplateId: deliveryTemplateId }).$promise;
    };
    this.createDeliveryTemplate = function (deliveryTemplate) {
        return DeliveryTemplatesResourceFactory.save(deliveryTemplate).$promise;
    };
    this.cloneDeliveryTemplate = function (deliveryTemplate) {
        return DeliveryTemplatesResourceFactory.clone({ id: deliveryTemplate.id }).$promise;
    };
    this.updateDeliveryTemplate = function (deliveryTemplate) {
        return DeliveryTemplatesResourceFactory.update(deliveryTemplate).$promise;
    };
    this.deleteDeliveryTemplate = function (deliveryTemplateId) {
        return DeliveryTemplatesResourceFactory.delete({ deliveryTemplateId: deliveryTemplateId }).$promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by kyang on 9/11/19.
 */
function DynamicPropertiesEditServiceConstructor(_, $location, $q, BreadcrumbService, DynamicPropertiesService, NotificationService, PermissionsService) {
    //=============//
    // Breadcrumbs //
    //=============//
    var _this = this;
    this.resetBreadcrumbs = function () {
        BreadcrumbService.clearBreadcrumbs();
    };
    if (BreadcrumbService.getBreadcrumbs().length === 0) {
        this.resetBreadcrumbs();
    }
    //==========//
    // Requests //
    //==========//
    this.originalPropertyValue = null;
    this.editData = null;
    this.getViewPermissions = function () {
        return PermissionsService.isAdmin();
    };
    this.getEditData = function (propertyName) {
        return DynamicPropertiesService.queryForProperties()
            .then(function () {
            return {
                name: propertyName,
                value: DynamicPropertiesService.getPropValue(propertyName, undefined),
                hasConfidentialInfo: DynamicPropertiesService.propContainsConfidentialInfo(propertyName)
            };
        });
    };
    //====================//
    // Edit View Handlers //
    //====================//
    this.editorForm = null;
    var closeEditView = function () {
        BreadcrumbService.clearBreadcrumbs();
        _this.originalPropertyValue = null;
        _this.editData = null;
        _this.editorForm = null;
        $location.path("/system/properties/search");
        $location.search('propertyName', null);
        $location.search('tab', 'DynamicProps');
    };
    this.revertEditData = function () {
        if (_this.originalPropertyValue) {
            _this.editorForm.$setPristine();
            _this.editData.value = _.cloneDeep(_this.originalPropertyValue);
        }
        else {
            closeEditView();
        }
    };
    this.saveEditData = function () {
        if (!DynamicPropertiesService.propNameIsValid(_this.editData.name)) {
            return $q.reject('Property has an invalid name. Does it use a $ at the start of the name?', '');
        }
        else if (!DynamicPropertiesService.propIsEditable(_this.editData.name)) {
            return $q.reject('Cannot use this property name. It is reserved for internal use.', '');
        }
        else if (!_this.originalPropertyValue && !_.isNull(DynamicPropertiesService.getPropValue(_this.editData.name, null))) {
            return $q.reject('Property already exists. Please select a different name.', '');
        }
        _this.editData.value = _this.editData.value.replace(/[\t\r\n]/g, '');
        return DynamicPropertiesService.saveProperty(_this.editData.name, _this.editData.value).then(function () {
            _this.originalPropertyValue = _this.editData.value;
            _this.editorForm.$setPristine();
        });
    };
    var showUnsavedChangesNotification = function () {
        NotificationService.createWarningNotification('You have unsaved changes. Please save or revert.', '');
    };
    this.exitEdit = function () {
        if (_this.originalPropertyValue && _this.editorForm.$pristine) {
            closeEditView();
        }
        else {
            showUnsavedChangesNotification();
        }
    };
}
angular
    .module('prism-ui.system')
    .service('DynamicPropertiesEditService', DynamicPropertiesEditServiceConstructor);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components').service('EmailTemplatesService', function (_, EmailTemplatesResourceFactory, PaginationService) {
    var _this = this;
    this.originalEditData = {};
    var handleGridDataQuery = function (gridData, responseHeaders) {
        PaginationService.parseResponseHeaders(responseHeaders());
        PaginationService.pageData = gridData;
        _this.currentPageSize = gridData.length;
    };
    this.getAllEmailTemplates = function (queryParams) {
        return EmailTemplatesResourceFactory.query(queryParams, handleGridDataQuery).$promise;
    };
    this.getEmailTemplate = function (emailTemplateId, handleGridDataQuery) {
        return EmailTemplatesResourceFactory.get({ emailTemplateId: emailTemplateId }).$promise;
    };
    this.createEmailTemplate = function (emailTemplate) {
        return EmailTemplatesResourceFactory.save(emailTemplate).$promise;
    };
    this.updateEmailTemplate = function (emailTemplate) {
        return EmailTemplatesResourceFactory.update(emailTemplate).$promise;
    };
    this.toggleEmailTemplateHidden = function (emailTemplateId) {
        return EmailTemplatesResourceFactory.delete({ emailTemplateId: emailTemplateId }).$promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: external-metadata-template
 *
 * Created by rwilliams on 10/5/17.
 */
function ExternalMetadataController($route, $routeParams, ExternalMetadataService, NotificationService) {
    var _this = this;
    this.activeTabs = {
        setup: false,
        queue: false,
        logging: false
    };
    this.onTabSelect = function (tab) {
        $route.updateParams({ view: tab });
    };
    this.onTabDeselect = function (tab, event) {
        if (ExternalMetadataService.editorForm && ExternalMetadataService.editorForm.$dirty) {
            event.preventDefault();
            NotificationService.createWarningNotification('Please save or revert your changes before navigating away from this page.');
        }
    };
    this.$onInit = function () {
        _this.currentTab = $routeParams.view;
        _this.activeTabs[$routeParams.view] = true;
    };
}
angular.module('prism-ui.externalMetadata').component('externalMetadata', {
    controller: ExternalMetadataController,
    templateUrl: 'system/externalMetadata/external-metadata-template.html'
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: file-system-service.ts
 *
 * Created by kyang on 2020-09-10.
 */
function FileSystemServiceConstructor(_, FileSystemResourceFactory, PaginationService) {
    var updatePagination = function (data, responseHeaders) {
        PaginationService.parseResponseHeaders(responseHeaders());
        PaginationService.pageData = data;
    };
    this.getFileSystems = function (criteria) {
        var firstIndex = _.get(criteria, 'fetchOffset', 0);
        var lastIndex = firstIndex + _.get(criteria, 'fetchLimit', 25) - 1;
        var finalCriteria = _.omit(criteria, ['fetchOffset', 'fetchLimit', 'searchString']);
        finalCriteria.range = "storagefilesystems " + firstIndex + "-" + lastIndex;
        finalCriteria.name = _.get(criteria, 'searchString');
        return FileSystemResourceFactory.query(finalCriteria, updatePagination).$promise;
    };
    this.getFileSystem = function (id) {
        return FileSystemResourceFactory.getFileSystem({ id: id }).$promise;
    };
    this.createFileSystem = function (fileSystem) {
        return FileSystemResourceFactory.createFileSystem(fileSystem).$promise;
    };
    this.updateFileSystem = function (fileSystem) {
        return FileSystemResourceFactory.updateFileSystem(fileSystem).$promise;
    };
    this.getFileSystemTypes = function () {
        return FileSystemResourceFactory.getFileSystemTypes({ range: 'storagefilesystemstype 0-1000000' }).$promise;
    };
}
angular
    .module('prism-ui.fileSystem')
    .service('FileSystemService', FileSystemServiceConstructor);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.groups').service('GroupsService', function (_, X2JS, AggregationResourceFactory, ReachPermissionsResourceFactory, SecurityRolesResourceFactory, NetworkResourceFactory, PackageResourceFactory, PermissionsService, ContentResourceFactory, PaginationService, UsersService, $q) {
    var _this = this;
    this.XJS = new X2JS();
    this.originalEditData;
    this.editorForm;
    this.breadcrumbName;
    var getTargetClass = function (target) {
        if (target.startsWith('[') && target.endsWith(']')) {
            return target.substring(1, target.indexOf('.'));
        }
        else {
            return target;
        }
    };
    var generatePermissionContextMap = function (permissionContexts) {
        var permissionContextObject = {};
        var permissionContextGroups = _.groupBy(permissionContexts, function (permissionContext) { return getTargetClass(permissionContext.target); });
        _.forEach(permissionContextGroups, function (contexts, key) {
            if (key === 'Authorities') {
                permissionContextObject[key] = _.keyBy(contexts, function (context) { return _this.XJS.xml2js(context.targetCriteria).and.condition._property; });
            }
            else {
                permissionContextObject[key] = _.keyBy(contexts, function (context) { return context.target; });
            }
        });
        return permissionContextObject;
    };
    var responseHandler = function (data, responseHeaders) {
        PaginationService.parseResponseHeaders(responseHeaders());
        PaginationService.pageData = data;
    };
    var getDataObjectInstances = function (group) {
        var permissionsPromise = _.has(group, 'id') ? SecurityRolesResourceFactory.getRolePermissions({ id: group.id }).$promise : { rows: [] };
        var networkPromise = NetworkResourceFactory.query({ fetchLimit: -1, view: 'MINIMAL' }).$promise;
        var categoryTypePromise = PackageResourceFactory.getCategories({ view: 'EXTENDED' }).$promise;
        var seriesPromise = ContentResourceFactory.query({ fetchLimit: -1, type: 'Series', view: 'MINIMAL' }).$promise;
        var moviePromise = ContentResourceFactory.query({ fetchLimit: -1, type: 'Movie/Special', view: 'MINIMAL' }).$promise;
        var adPromise = ContentResourceFactory.query({ fetchLimit: -1, type: 'Ad/PreRoll', view: 'MINIMAL' }).$promise;
        var aggregationSetupPromise = AggregationResourceFactory.query({ fetchLimit: -1 }).$promise;
        return $q.all({
            group: group,
            permissionContexts: permissionsPromise,
            network: networkPromise,
            packageCategoryType: categoryTypePromise,
            series: seriesPromise,
            movie: moviePromise,
            advertisement: adPromise,
            aggregationSetup: aggregationSetupPromise
        })
            .then(function (data) {
            return {
                group: data.group,
                permissionContexts: data.permissionContexts.rows,
                permissionContextMap: generatePermissionContextMap(data.permissionContexts.rows),
                mappingData: {
                    network: data.network,
                    longFormType: [data.packageCategoryType[0]],
                    longForm: data.packageCategoryType[0].categories,
                    shortFormType: [data.packageCategoryType[1]],
                    shortForm: data.packageCategoryType[1].categories,
                    series: _.keyBy(data.series, function (data) { return "[Series.null." + data.id + "]"; }),
                    movie: _.keyBy(data.movie, function (data) { return "[Movie.null." + data.id + "]"; }),
                    advertisement: _.keyBy(data.advertisement, function (data) { return "[Advertisement.null." + data.id + "]"; }),
                    aggregationSetup: _.keyBy(data.aggregationSetup, function (data) { return "[AggregationSetup.null." + data.id + "]"; })
                }
            };
        });
    };
    var getAllUsersWithGroups = function (showHidden) {
        var usersCriteria = {
            fetchLimit: -1,
            includeRoles: true,
            includeArchived: showHidden
        };
        return UsersService.getAllUsers(usersCriteria);
    };
    var addUsersToGroups = function (groups, usersWithGroups) {
        var groupsById = {};
        _.forEach(groups, function (group) {
            group.users = [];
            groupsById[group.id] = group;
        });
        usersWithGroups.forEach(function (user) {
            user.roles.forEach(function (userGroup) {
                if (_.has(groupsById, userGroup.id)) {
                    groupsById[userGroup.id].users.push(user);
                }
            });
            delete user.roles;
        });
    };
    this.getAllGroups = function (criteria) {
        if (_.get(criteria, 'includeUsers')) {
            var groupResponseHeaders_1;
            var groupResponseHandler = function (data, responseHeaders) {
                groupResponseHeaders_1 = responseHeaders;
            };
            delete criteria.includeUsers;
            return $q.all({
                groups: SecurityRolesResourceFactory.query(criteria, groupResponseHandler).$promise,
                users: getAllUsersWithGroups(_.get(criteria, 'showHidden'))
            }).then(function (data) {
                addUsersToGroups(data.groups, data.users);
                responseHandler(data.groups, groupResponseHeaders_1);
                return data.groups;
            });
        }
        else {
            return SecurityRolesResourceFactory.query(criteria, responseHandler).$promise;
        }
    };
    this.getGroup = function (groupId, criteria) {
        if (_.get(criteria, 'includeUsers')) {
            return $q.all({
                group: SecurityRolesResourceFactory.getRole({ id: groupId }).$promise,
                users: getAllUsersWithGroups(false)
            }).then(function (data) {
                addUsersToGroups([data.group], data.users);
                return data.group;
            });
        }
        else {
            return SecurityRolesResourceFactory.getRole({ id: groupId }).$promise;
        }
    };
    this.getGroupAndMappingData = function (groupId) {
        if (_.toNumber(groupId) === -1) {
            return getDataObjectInstances({
                name: '',
                permissionContexts: []
            });
        }
        else {
            return _this.getGroup(groupId)
                .then(getDataObjectInstances);
        }
    };
    this.isSystemOperatorGroup = function (groupId) {
        return SecurityRolesResourceFactory.getRolePermissions({ id: groupId }).$promise.then(function (permissions) {
            return _.some(permissions.rows, function (permissionContext) {
                var viewState = _.get(_this.XJS.xml2js(permissionContext.targetCriteria), 'and.condition._property');
                return viewState === 'DEBUG_SYSTEM_OPERATIONS_VIEW_STATE';
            });
        });
    };
    this.updateMappingData = function (data) {
        data.permissionContextMap = generatePermissionContextMap(data.permissionContexts);
    };
    var savePermissions = function (group, permissionContexts) {
        var permissionPromises = _.map(permissionContexts, function (permissionContext) {
            permissionContext.roleUuid = group.uuid;
            if (permissionContext.uuid) {
                return ReachPermissionsResourceFactory.updatePermission(permissionContext).$promise;
            }
            else {
                return ReachPermissionsResourceFactory.createPermission(permissionContext).$promise;
            }
        });
        return $q.all(permissionPromises);
    };
    var getUpdatedEditData = function (group) {
        return SecurityRolesResourceFactory.getRolePermissions({ id: group.id }).$promise
            .then(function (permissions) {
            return {
                group: group,
                permissionContexts: permissions.rows
            };
        });
    };
    this.createGroup = function (group, permissionContexts) {
        return SecurityRolesResourceFactory.createRole(group).$promise
            .then(function (resultGroup) {
            return savePermissions(resultGroup, permissionContexts).then(function () {
                return getUpdatedEditData(resultGroup);
            });
        });
    };
    this.updateGroup = function (group, oldPermissionContexts, newPermissionContexts) {
        var updateRolePromise = SecurityRolesResourceFactory.updateRole(group).$promise;
        var savePermissionsPromise = savePermissions(group, newPermissionContexts);
        var deleteContextPromises = _.chain(oldPermissionContexts)
            .filter(function (oldPermissionContext) {
            return !_.find(newPermissionContexts, { uuid: oldPermissionContext.uuid });
        }).map(function (oldPermissionContext) {
            return ReachPermissionsResourceFactory.deletePermission({ uuid: oldPermissionContext.uuid }).$promise;
        })
            .value();
        return $q.all([
            updateRolePromise,
            savePermissionsPromise
        ].concat(deleteContextPromises)).then(function (data) { return getUpdatedEditData(data[0]); });
    };
    this.deleteGroup = function (groupId) {
        return SecurityRolesResourceFactory.deleteRole({ id: groupId }).$promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.genres').service('GenresService', function (GenresResourceFactory, PaginationService) {
    this.originalEditData;
    this.viewData;
    var responseHandler = function (data, responseHeaders) {
        PaginationService.parseResponseHeaders(responseHeaders());
        PaginationService.pageData = data;
    };
    this.getAllGenres = function (criteria) {
        return GenresResourceFactory.query(criteria, responseHandler).$promise;
    };
    this.createGenre = function (genre) {
        return GenresResourceFactory.createGenre(genre).$promise;
    };
    this.getGenre = function (genreId) {
        return GenresResourceFactory.getGenre({ id: genreId }).$promise;
    };
    this.updateGenre = function (genre) {
        return GenresResourceFactory.updateGenre(genre).$promise;
    };
    this.deleteGenre = function (genreId) {
        return GenresResourceFactory.deleteGenre({ id: genreId }).$promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.languages').service('LanguagesService', function (_, LanguageResourceFactory, ContentResourceFactory, PaginationService) {
    var _this = this;
    var responseHandler = function (data, responseHeaders) {
        PaginationService.parseResponseHeaders(responseHeaders());
        PaginationService.pageData = data;
    };
    this.getAllLanguages = function () {
        var criteria = {
            fetchLimit: -1,
            fetchOffset: 0
        };
        return LanguageResourceFactory.query(criteria).$promise;
    };
    this.getAllLanguagesPaginated = function (criteria) {
        return LanguageResourceFactory.query(criteria, responseHandler).$promise;
    };
    this.getAllLanguagesSorted = function () {
        return _this.getAllLanguages().then(function (allLanguages) {
            var _a = _.partition(allLanguages, { isDefault: true }), defaultLanguages = _a[0], nonDefaultLanguages = _a[1];
            var sortedNonDefaultLanguages = _.sortBy(nonDefaultLanguages, 'name');
            return _.concat(defaultLanguages, sortedNonDefaultLanguages);
        });
    };
    this.createLanguage = function (language) {
        return LanguageResourceFactory.createLanguage(language).$promise;
    };
    this.getLanguage = function (languageId) {
        return LanguageResourceFactory.getLanguage({ id: languageId }).$promise;
    };
    this.updateLanguage = function (language) {
        return LanguageResourceFactory.updateLanguage(language).$promise;
    };
    this.deleteLanguage = function (languageId) {
        return LanguageResourceFactory.deleteLanguage({ id: languageId }).$promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: package-notifications-service.ts
 *
 * Created by randysorensen on 4/9/18.
 */
angular
    .module('prism-ui.packageNotifications')
    .service('PackageNotificationsService', function (_, $q, $location, $route, $routeParams, PackageNotificationsResourceFactory, NotificationService, EmailTemplatesResourceFactory) {
    var _this = this;
    this.packageStatusDictionary = {
        DRAFT: 'Draft',
        READY_FOR_DELIVERY: 'Ready for Delivery',
        RESTORING: 'Restoring',
        PENDING_RESTORE: 'Pending Restore',
        TRANSCODING: 'Creating Package Media',
        CREATING_CLIP: 'Creating Clip Media',
        PENDING_DELIVERY: 'Pending Delivery',
        DELIVERING: 'Delivering',
        PENDING_APPROVAL: 'Pending Approval',
        STALLED: 'Stalled',
        REJECTED: 'Rejected',
        DELIVERED: 'Delivered'
    };
    this.getPackageNotifications = function () {
        return PackageNotificationsResourceFactory.query().$promise;
    };
    this.createPackageNotification = function (notification) {
        return PackageNotificationsResourceFactory.save(notification).$promise;
    };
    this.getPackageNotification = function (notificationId) {
        return PackageNotificationsResourceFactory.get({
            notificationId: notificationId
        }).$promise;
    };
    this.updatePackageNotification = function (notification) {
        return PackageNotificationsResourceFactory.update(notification).$promise;
    };
    this.getPackageNotificationEditData = function () {
        var emailTemplatesPromise = EmailTemplatesResourceFactory.query().$promise;
        var availablePackageStatuses = [];
        _.forEach(_this.packageStatusDictionary, function (label, status) {
            availablePackageStatuses.push({
                label: label,
                status: status
            });
        });
        var packageNotificationPromise;
        if ($routeParams.notificationId < 0) {
            var packageNotificationDeferral = $q.defer();
            packageNotificationDeferral.resolve({
                recipients: []
            });
            packageNotificationPromise = packageNotificationDeferral.promise;
        }
        else {
            packageNotificationPromise = _this.getPackageNotification($routeParams.notificationId);
        }
        return $q.all({
            emailTemplates: emailTemplatesPromise,
            availablePackageStatuses: availablePackageStatuses,
            packageNotification: packageNotificationPromise
        }).then(function (editData) {
            _this.notification = editData.packageNotification;
            _this.originalNotification = _.cloneDeep(_this.notification);
            return editData;
        });
    };
    this.canRevertEditView = function () {
        return _.get(_this.editorForm, '$dirty') || $routeParams.notificationId < 0;
    };
    this.canExitEditView = function () {
        var notificationIsSaved = !!_.get(_this.notification, 'id');
        return !_this.editorForm || (notificationIsSaved && _this.editorForm.$pristine);
    };
    var closeEditView = function () {
        _this.notification = undefined;
        _this.originalNotification = undefined;
        _this.editorForm = undefined;
        $location.path($route.current.rootRoute);
    };
    this.showUnsavedChangesNotification = function () {
        NotificationService.createWarningNotification('You have unsaved changes. Please save or revert.', '');
    };
    this.exitEdit = function () {
        if (_this.canExitEditView()) {
            closeEditView();
        }
        else {
            _this.showUnsavedChangesNotification();
        }
    };
    this.revertEditData = function () {
        if ($routeParams.notificationId < 0) {
            closeEditView();
        }
        else {
            _this.notification = _.cloneDeep(_this.originalNotification);
            _this.editorForm.$setPristine();
            return _this.notification;
        }
    };
    this.saveEditData = function () {
        var saveFunction;
        if ($routeParams.notificationId < 0) {
            saveFunction = _this.createPackageNotification;
        }
        else {
            saveFunction = _this.updatePackageNotification;
        }
        return saveFunction(_this.notification)
            .then(function (savedNotification) {
            _this.notification = savedNotification;
            _this.originalNotification = _.cloneDeep(savedNotification);
            $route.updateParams({
                notificationId: savedNotification.id
            });
            _this.editorForm.$setPristine();
            return _this.notification;
        }).catch(function (error) {
            NotificationService.createFailureNotification('An error occurred while saving the notification.', error.data.message);
        });
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.roles').service('RolesService', function (RolesResourceFactory, PaginationService) {
    var _this = this;
    this.originalEditData;
    this.viewData;
    var responseHandler = function (data, responseHeaders) {
        PaginationService.parseResponseHeaders(responseHeaders());
        PaginationService.pageData = data;
    };
    this.getAllRoles = function () {
        var criteria = {
            fetchLimit: -1,
            fetchOffset: 0
        };
        return RolesResourceFactory.query(criteria).$promise;
    };
    this.getTypedRoles = function (mediaType) {
        if (mediaType === 'cc') {
            return _this.getAllRoles().then(function (roles) {
                return _.filter(roles, function (role) {
                    return role.type === 'CC';
                });
            });
        }
        return RolesResourceFactory.query({ mediaType: _.capitalize(mediaType) }).$promise;
    };
    this.getAllRolesPaginated = function (criteria) {
        return RolesResourceFactory.query(criteria, responseHandler).$promise;
    };
    this.createRole = function (role) {
        return RolesResourceFactory.save(role).$promise;
    };
    this.getRole = function (roleId) {
        return RolesResourceFactory.get({ roleId: roleId }).$promise;
    };
    this.updateRole = function (role) {
        return RolesResourceFactory.update(role).$promise;
    };
    this.deleteRole = function (roleId) {
        return RolesResourceFactory.delete({ roleId: roleId }).$promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.users').service('UsersService', function (loginService, ModalService, NotificationService, PermissionsService, UsersResourceFactory, ContentResourceFactory, PaginationService, $q) {
    this.originalEditData = {};
    this.viewData;
    var responseHandler = function (data, responseHeaders) {
        PaginationService.parseResponseHeaders(responseHeaders());
        PaginationService.pageData = data;
    };
    this.getAllUsers = function (criteria) {
        return UsersResourceFactory.query(criteria, responseHandler).$promise
            .then(function (users) {
            _.forEach(users, function (user) {
                user.roles = user.roles.rows;
            });
            return users;
        });
    };
    var saveRoles = function (user, newRoles, oldRoles) {
        var rolePromises = [];
        var missingRolesById = _.keyBy(oldRoles, 'id');
        _.forEach(newRoles, function (role) {
            if (_.has(missingRolesById, role.id)) {
                delete missingRolesById[role.id];
            }
            else {
                rolePromises.push(UsersResourceFactory.addUserRole({ id: user.id, roleId: role.id }));
            }
        });
        _.forEach(missingRolesById, function (role, roleId) {
            rolePromises.push(UsersResourceFactory.removeUserRole({ id: user.id, roleId: roleId }));
        });
        return rolePromises;
    };
    var addRolesToUser = function (user, roles) {
        // Remove role properties added by Resource API
        user.roles = _.clone(roles);
    };
    this.createUser = function (user) {
        var roles = user.roles;
        return UsersResourceFactory.createUser(_.omit(user, 'roles')).$promise
            .then(function (savedUser) {
            return $q.all(saveRoles(savedUser, roles, []))
                .then(function () {
                return UsersResourceFactory.getUserRoles({ id: savedUser.id }).$promise
                    .then(function (savedRoles) {
                    addRolesToUser(savedUser, savedRoles);
                    return savedUser;
                });
            });
        });
    };
    this.getUser = function (userId) {
        return $q.all({
            user: UsersResourceFactory.getUser({ id: userId }).$promise,
            roles: UsersResourceFactory.getUserRoles({ id: userId }).$promise
        }).then(function (data) {
            addRolesToUser(data.user, data.roles);
            return data.user;
        });
    };
    this.updateUser = function (user, oldRoles) {
        var promises = saveRoles(user, user.roles, oldRoles);
        promises.push(UsersResourceFactory.updateUser(_.omit(user, 'roles')).$promise);
        return $q.all(promises).then(function (data) {
            var savedUser = data.pop();
            return UsersResourceFactory.getUserRoles({ id: savedUser.id }).$promise
                .then(function (savedRoles) {
                addRolesToUser(savedUser, savedRoles);
                return savedUser;
            });
        });
    };
    this.deleteUser = function (userId) {
        return UsersResourceFactory.deleteUser({ id: userId }).$promise;
    };
    this.openChangePasswordModal = function () {
        PermissionsService.isExternalUser()
            .then(function (isExternalUser) {
            if (isExternalUser) {
                NotificationService.createFailureNotification("Cannot change password for an external user");
            }
            else {
                ModalService.showChangePasswordModal(function () {
                });
            }
        });
    };
    this.showResetPasswordModal = function (user) {
        if (user.externalUser) {
            NotificationService.createFailureNotification("Cannot change password for an external user");
            return;
        }
        ModalService.showMessageModal({
            messageText: "Are you sure you want to send an email to " + user.username + " with instructions to reset their password?",
            pullCancelLeft: true,
            title: 'Reset Password',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, function () {
            var pendingMessage = "Sending password reset email to " + user.username;
            var successMessage = "Successfully sent password reset email to " + user.username;
            NotificationService.createInfoNotification(pendingMessage);
            UsersResourceFactory.sendResetPasswordEmail({ id: user.id }).$promise
                .then(function () { return NotificationService.createInfoNotification(successMessage); });
        });
    };
    this.getPasswordRequirements = function () {
        return UsersResourceFactory.getPasswordRequirements().$promise;
    };
    this.updatePassword = function (oldPassword, newPassword) {
        return UsersResourceFactory.updatePassword({ oldPassword: oldPassword, newPassword: newPassword }).$promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: rating-overlay-search-view-component.ts
 *
 * Created by kyang on 1/7/2021.
 */
function RatingOverlaySearchViewController(_, $q, $routeParams, PermissionsService, BrandingAssetService, BrandingViewService) {
    //=========//
    // Toolbar //
    //=========//
    var _this = this;
    this.hideEmpty = false;
    this.toolbarCheckboxDefs = [
        {
            label: 'Hide Empty',
            onUpdate: function (newValue) {
                _this.hideEmpty = newValue;
            },
            isChecked: this.hideEmpty,
        }
    ];
    //======//
    // Data //
    //======//
    var getBrandingConfig = function () {
        return {
            parentLocation: _this.baseUrl + "/edit/" + $routeParams.id,
            id: $routeParams.id,
            type: 'ratingOverlays',
            isShow: _this.groupName !== 'networks',
            groupName: _this.groupName,
        };
    };
    var getData = function () {
        _this.loadingIndicator.show = true;
        $q.all({
            container: BrandingAssetService.getBrandingAssetContainer(_this.brandingConfig),
            mediaAcceptProfiles: BrandingViewService.getMediaAcceptProfiles(),
        })
            .then(function (data) {
            if (_this.canReadOverlays) {
                _this.container = data.container;
                _this.mediaAcceptProfiles = data.mediaAcceptProfiles;
            }
        })
            .finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.brandingConfig = getBrandingConfig();
        _this.loadingIndicator.show = true;
        PermissionsService.getReadWritePermissions(_this.permissionViewState)
            .then(function (permissions) {
            _this.canReadOverlays = permissions.read;
            return getData();
        });
    };
}
angular.module('prism-ui.components.branding').component('ratingOverlaySearchView', {
    templateUrl: 'components/branding/ratingOverlaySearchView/rating-overlay-search-view-template.html',
    controller: RatingOverlaySearchViewController,
    bindings: {
        isAdmin: '<',
        permissionViewState: '<',
        groupName: '<',
        baseUrl: '<',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: branding-container-edit-service.ts
 *
 * Created by kyang on 10/16/2020.
 */
angular.module('prism-ui.components.branding').service('BrandingContainerEditService', function (_) {
    var _this = this;
    this.editorForm = null;
    this.originalEditData = null;
    this.setOriginalEditData = function (fileSystem) {
        _this.originalEditData = _.cloneDeep(fileSystem);
        _.invoke(_this, 'editorForm.$setPristine');
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: branding-container-edit-view-component.ts
 *
 * Created by rwilliams on 8/6/17,
 * Refactored by kyang on 10/15/20.
 */
//
// Notes:
//
// * A branding asset is any of: a preroll, a postroll, a visual
//   watermark, artwork, or a "break pre/post roll".
//
// * Branding assets are aggregated together in a named object
//   known as a "container". Contents and Networks may have zero
//   or more containers for each type of branding asset.
//
// * Series containers can be overridden by season- or
//   volume-specific containers; these appear in the branding
//   asset search view as child containers and appear under the
//   name of the season or volume to which they apply.
//
// * An asset object encapsulates a particular branding asset or,
//   in the case of "break pre/post rolls", encapsulates both the
//   break preroll and break postroll.
//
// * Each container has at most one asset object per relevant MAP.
//
// * Relevant MAPs consist of all VIDEO MAPs in the system, except
//   in the case of artwork, in which case they consist of all
//   MAPs of type "OTHER" (not of type "IMAGE" as you might
//   expect).
//
// * Season or volume specific assets will have a seasonId or a
//   volumeId, respectively.
//
function BrandingContainerEditViewController($route, $routeParams, BrandingContainerEditService, BrandingViewService, BreadcrumbService) {
    var _this = this;
    this.getBreadcrumbName = function () {
        return _.get(BrandingContainerEditService, 'originalEditData.name', "New " + _this.brandingConfig.type);
    };
    this.editingNewBrandingAssetContainer = function () {
        return $routeParams.containerId === '-1';
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        BrandingViewService.initializeParentBreadcrumbs(_this.brandingConfig, $route.current.params);
    };
    this.$onDestroy = function () {
        BreadcrumbService.clearBreadcrumbs();
    };
}
angular
    .module('prism-ui.components.branding')
    .component('brandingContainerEditView', {
    templateUrl: 'components/branding/editView/branding-container-edit-view-template.html',
    controller: BrandingContainerEditViewController,
    bindings: {
        brandingConfig: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: watermark-asset-service.ts
 *
 * Created by kyang on 10/21/20.
 */
// This service is an implementation for BrandingAssetService.
// Components should invoke the abstract BrandingAssetService, not this specific implementation.
//
// BrandingAssetService implementations work on
// the root asset object to display in the editor.
// Artwork needs to displayed as a list of unrelated assets,
// So, use the list of artworks as the "root asset object" instead.
angular.module('prism-ui.components.branding').service('ArtworkAssetService', function (_, $q, ArtworkResourceFactory, BrandingAssetService, BrandingViewService, MediaProfileResourceFactory) {
    //==========================//
    // Branding Asset Container //
    //==========================//
    var _this = this;
    this.getBrandingAssetContainer = function (containerId) {
        return ArtworkResourceFactory.get({ containerId: containerId }).$promise;
    };
    this.parseBrandingAssetContainer = function (brandingConfig, brandingAssetContainer) {
        brandingAssetContainer.assets = BrandingAssetService.filterBrandingAssets(brandingConfig, brandingAssetContainer.assets, { anySeasonVolume: true });
    };
    this.updateBrandingAssetContainer = function (brandingConfig, brandingAssetContainer) {
        return ArtworkResourceFactory.update({
            containerId: brandingAssetContainer.id
        }, brandingAssetContainer).$promise;
    };
    //=======//
    // Asset //
    //=======//
    var parseArtworkDTO = function (asset) {
        if (!asset.language) {
            asset.language = {
                id: -1,
                name: '[None]'
            };
        }
        return asset;
    };
    var createRootArtworkAsset = function (containerId, seasonId, volumeId, artworkType, acceptProfile, artworkAssets) {
        return {
            id: containerId,
            seasonId: seasonId,
            volumeId: volumeId,
            acceptProfile: acceptProfile,
            assets: _.cloneDeep(artworkAssets),
            type: artworkType,
            originalAssetsById: _.keyBy(artworkAssets, 'id'),
        };
    };
    this.getRootBrandingAsset = function (brandingConfig, container, acceptProfile) {
        var artworkAssets = BrandingAssetService.filterBrandingAssets(brandingConfig, container.assets)
            .filter(function (artwork) { return artwork.acceptProfile.id === acceptProfile.id; })
            .map(parseArtworkDTO);
        var artworkType = 'Artwork';
        if (brandingConfig.seasonId) {
            artworkType = 'SeasonArtwork';
        }
        else if (brandingConfig.volumeId) {
            artworkType = 'VolumeArtwork';
        }
        return createRootArtworkAsset(container.id, brandingConfig.seasonId, brandingConfig.volumeId, artworkType, _.get(artworkAssets, '0.acceptProfile', acceptProfile), artworkAssets);
    };
    this.validateNonTextAsset = function (acceptProfileId, asset, virtualPath) {
        return MediaProfileResourceFactory.validate({
            path: virtualPath,
            profileId: acceptProfileId
        }).$promise.then(function (validationResult) {
            return _.get(validationResult, acceptProfileId + ".failures");
        });
    };
    this.createRootBrandingAsset = function (brandingConfig, rootAsset) {
        return $q.reject({
            description: 'Artworks use mock rootBrandingAssets, which cannot be created by this function'
        });
    };
    var saveAssets = function (brandingConfig, assets, originalAssetsById) {
        var savePromises = _.map(assets, function (asset) {
            var savePromise;
            if (_.get(asset, 'language.id') === -1) {
                asset.language = null;
            }
            if (asset.id && angular.equals(asset, originalAssetsById[asset.id])) {
                savePromise = $q.when(asset);
            }
            else if (asset.id) {
                savePromise = ArtworkResourceFactory.updateAsset({ assetId: asset.id }, asset).$promise;
            }
            else {
                savePromise = ArtworkResourceFactory.createAsset({ containerId: brandingConfig.id }, asset).$promise;
            }
            return savePromise.then(parseArtworkDTO);
        });
        return $q.all(savePromises);
    };
    this.updateRootBrandingAsset = function (brandingConfig, rootAsset) {
        // TODO: When API is updated, make this one API call
        var deleteAssetPromises = _.chain(rootAsset.originalAssetsById)
            .filter(function (originalAsset) {
            return !_.find(rootAsset.assets, { id: originalAsset.id });
        }).map(function (originalAsset) {
            return ArtworkResourceFactory.deleteAsset({ assetId: originalAsset.id }).$promise;
        }).value();
        var saveAssetsPromise = saveAssets(brandingConfig, rootAsset.assets, rootAsset.originalAssetsById);
        return $q.all(deleteAssetPromises.concat([saveAssetsPromise]))
            .then(function (data) {
            return createRootArtworkAsset(rootAsset.id, rootAsset.seasonId, rootAsset.volumeId, rootAsset.type, rootAsset.acceptProfile, _.last(data));
        });
    };
    //=========//
    // Proxies //
    //=========//
    this.hasVideoAssetProxyStatus = function (brandingConfig, rootAsset) {
        return _.some(rootAsset.assets, function (artworkAsset) {
            return !BrandingAssetService.assetWasIngested(artworkAsset);
        });
    };
    var getArtworkAssetProxyStatus = function (updatedArtworkAsset) {
        if (BrandingAssetService.assetHasProxy(updatedArtworkAsset)) {
            return BrandingAssetService.ProxyStatus.PROXY_COMPLETE;
        }
        else if (_.get(updatedArtworkAsset, 'ingestInfo.workflowStatus') === BrandingAssetService.ProxyStatus.PROXY_STALLED) {
            return BrandingAssetService.ProxyStatus.PROXY_STALLED;
        }
        return BrandingAssetService.ProxyStatus.PROXY_RUNNING;
    };
    this.updateVideoAssetProxyStatus = function (brandingConfig, rootAsset, intervalData) {
        return _this.getBrandingAssetContainer(brandingConfig.id)
            .then(function (updatedContainer) {
            var updatedAsset = _this.getRootBrandingAsset(brandingConfig, updatedContainer, rootAsset.acceptProfile);
            var finalState = BrandingAssetService.ProxyStatus.PROXY_COMPLETE;
            _.forEach(updatedAsset.assets, function (artworkAsset) {
                var updatedStatus = getArtworkAssetProxyStatus(artworkAsset);
                var prevStatus = _.get(intervalData, artworkAsset.id, updatedStatus);
                if (updatedStatus !== prevStatus) {
                    BrandingViewService.showVideoIngestStatusNotifications(brandingConfig, artworkAsset, updatedStatus, "- " + artworkAsset.language.name + " ");
                }
                switch (updatedStatus) {
                    case BrandingAssetService.ProxyStatus.PROXY_COMPLETE:
                        break;
                    case BrandingAssetService.ProxyStatus.PROXY_STALLED:
                        if (finalState === BrandingAssetService.ProxyStatus.PROXY_COMPLETE) {
                            finalState = BrandingAssetService.ProxyStatus.PROXY_STALLED;
                        }
                        break;
                    case BrandingAssetService.ProxyStatus.PROXY_RUNNING:
                        finalState = BrandingAssetService.ProxyStatus.PROXY_RUNNING;
                }
                intervalData[artworkAsset.id] = updatedStatus;
            });
            return finalState;
        });
    };
});
//=================//
// Lifecycle Hooks //
//=================//
// Load this service when app is initialized
angular.module('prism-ui.components.branding').run(function (BrandingAssetService, ArtworkAssetService) {
    BrandingAssetService.registerAssetServiceImplementation('artwork', ArtworkAssetService);
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: branding-asset-service.ts
 *
 * Created by kyang on 10/21/20.
 */
// This service is an interface for all the container type-specific asset services.
angular.module('prism-ui.components.branding').service('BrandingAssetService', function (_, $q, ContentResourceFactory, NetworkResourceFactory) {
    //========================//
    // Abstract Functionality //
    //========================//
    var _this = this;
    var assetServiceImplementations = {};
    this.registerAssetServiceImplementation = function (containerType, service) {
        if (_.has(assetServiceImplementations, containerType)) {
            console.warn("Replacing previous BrandingAssetService implementation for container type: " + containerType);
        }
        assetServiceImplementations[containerType] = service;
    };
    this.getAssetServiceImplementation = function (containerType) {
        return assetServiceImplementations[containerType];
    };
    //==================================//
    // Abstract Container Functionality //
    //==================================//
    this.getBrandingAssetContainer = function (brandingConfig) {
        if (brandingConfig.id > -1) {
            return _this.getAssetServiceImplementation(brandingConfig.type)
                .getBrandingAssetContainer(brandingConfig.id);
        }
        return $q.when({});
    };
    this.parseBrandingAssetContainer = function (brandingConfig, brandingAssetContainer) {
        return _this.getAssetServiceImplementation(brandingConfig.type)
            .parseBrandingAssetContainer(brandingConfig, brandingAssetContainer);
    };
    this.updateBrandingAssetContainer = function (brandingConfig, brandingAssetContainer) {
        return _this.getAssetServiceImplementation(brandingConfig.type)
            .updateBrandingAssetContainer(brandingConfig, brandingAssetContainer);
    };
    //==============================//
    // Abstract Asset Functionality //
    //==============================//
    this.getRootBrandingAsset = function (brandingConfig, container, acceptProfile) {
        return _this.getAssetServiceImplementation(brandingConfig.type)
            .getRootBrandingAsset(brandingConfig, container, acceptProfile);
    };
    this.validateNonTextAsset = function (containerType, acceptProfileId, asset, virtualPath) {
        return _this.getAssetServiceImplementation(containerType)
            .validateNonTextAsset(acceptProfileId, asset, virtualPath);
    };
    this.createRootBrandingAsset = function (brandingConfig, rootAsset) {
        var savePayload = _.cloneDeep(rootAsset);
        if (_.get(savePayload, 'language.id') === -1) {
            savePayload.language = null;
        }
        return _this.getAssetServiceImplementation(brandingConfig.type)
            .createRootBrandingAsset(brandingConfig, savePayload);
    };
    this.updateRootBrandingAsset = function (brandingConfig, rootAsset) {
        var savePayload = _.cloneDeep(rootAsset);
        if (_.get(savePayload, 'language.id') === -1) {
            savePayload.language = null;
        }
        return _this.getAssetServiceImplementation(brandingConfig.type)
            .updateRootBrandingAsset(brandingConfig, savePayload);
    };
    //==============================//
    // Abstract Proxy Functionality //
    //==============================//
    var ProxyStatus;
    (function (ProxyStatus) {
        ProxyStatus["PROXY_COMPLETE"] = "COMPLETED";
        ProxyStatus["PROXY_STALLED"] = "STALLED";
        ProxyStatus["PROXY_RUNNING"] = "RUNNING";
    })(ProxyStatus || (ProxyStatus = {}));
    this.ProxyStatus = ProxyStatus;
    this.hasVideoAssetProxyStatus = function (brandingConfig, rootAsset) {
        return _this.getAssetServiceImplementation(brandingConfig.type)
            .hasVideoAssetProxyStatus(brandingConfig, rootAsset);
    };
    // Function is invoked by BrandingViewService.createRootAssetProxyNotifications()
    this.updateVideoAssetProxyStatus = function (brandingConfig, rootAsset, intervalData) {
        return _this.getAssetServiceImplementation(brandingConfig.type)
            .updateVideoAssetProxyStatus(brandingConfig, rootAsset, intervalData);
    };
    //==========================================//
    // Branding Container Owner Implementations //
    //==========================================//
    var BRANDING_ASSET_CONTAINER_OWNERS = {
        networks: {
            getBrandingAssetContainers: NetworkResourceFactory.getBranding,
            createBrandingAssetContainer: NetworkResourceFactory.saveBranding,
            toggleBrandingAssetContainerVisibility: NetworkResourceFactory.delete,
        },
        series: {
            getBrandingAssetContainers: ContentResourceFactory.getBranding,
            createBrandingAssetContainer: ContentResourceFactory.saveBranding,
            toggleBrandingAssetContainerVisibility: ContentResourceFactory.delete,
        },
        movies: {
            getBrandingAssetContainers: ContentResourceFactory.getBranding,
            createBrandingAssetContainer: ContentResourceFactory.saveBranding,
            toggleBrandingAssetContainerVisibility: ContentResourceFactory.delete,
        }
    };
    this.getBrandingAssetContainers = function (brandingConfig, ownerId, includeHidden) {
        var containerOwnerService = BRANDING_ASSET_CONTAINER_OWNERS[brandingConfig.groupName];
        return containerOwnerService.getBrandingAssetContainers({
            fetchLimit: 0,
            id: ownerId,
            view: brandingConfig.type,
            includeHidden: includeHidden
        }).$promise
            .then(function (brandingAssetContainers) {
            _.forEach(brandingAssetContainers, function (brandingAssetContainer) {
                _this.parseBrandingAssetContainer(brandingConfig, brandingAssetContainer);
            });
            return brandingAssetContainers;
        });
    };
    this.createBrandingAssetContainer = function (brandingConfig, ownerId, brandingAssetContainer) {
        if (brandingConfig.type === 'ratingOverlays') {
            return $q.reject({
                message: 'Rating overlays use a mock brandingAssetContainer, which cannot be saved to the database'
            });
        }
        var containerOwnerService = BRANDING_ASSET_CONTAINER_OWNERS[brandingConfig.groupName];
        return containerOwnerService.createBrandingAssetContainer({
            id: ownerId,
            view: brandingConfig.type,
        }, brandingAssetContainer).$promise;
    };
    this.toggleBrandingAssetContainerVisibility = function (brandingConfig, brandingAssetContainer) {
        var containerOwnerService = BRANDING_ASSET_CONTAINER_OWNERS[brandingConfig.groupName];
        return containerOwnerService.toggleBrandingAssetContainerVisibility({
            containerId: brandingAssetContainer.id,
        }).$promise;
    };
    //========================//
    // Shared Implementations //
    //========================//
    this.assetWasIngested = function (asset) {
        return !!_.get(asset, 'assetId');
    };
    this.assetHasProxy = function (asset) {
        var assetDTO = _.get(asset, 'asset', asset);
        return !!_.get(assetDTO, 'proxyId') || _.some(_.get(assetDTO, 'contents'), function (assetContent) {
            return _.includes(assetContent.contentUses, 'PROXY');
        });
    };
    this.getRootAssetRouteId = function (containerType, rootAsset) {
        if (containerType === 'watermarks') {
            return _.get(rootAsset, 'videoAcceptProfile.id');
        }
        else if (containerType === 'ratingOverlays') {
            return _.get(rootAsset, 'mediaAcceptProfile.id');
        }
        return _.get(rootAsset, 'acceptProfile.id');
    };
    this.filterBrandingAssets = function (brandingConfig, assets, options) {
        if (options === void 0) { options = {}; }
        var filterFunc;
        if (options.anySeasonVolume) {
            // Keep all the containers
            filterFunc = function (asset) { return true; };
        }
        else if (brandingConfig.seasonId) {
            // For season containers:
            // Only keep assets that belong to this season
            filterFunc = function (asset) { return (asset.seasonId === brandingConfig.seasonId
                && !asset.volumeId); };
        }
        else if (brandingConfig.volumeId) {
            // For volume containers:
            // Only keep assets that belong to this volume
            filterFunc = function (asset) { return (asset.volumeId === brandingConfig.volumeId
                && !asset.seasonId); };
        }
        else {
            // For non-season & non-volume containers:
            // Only keep assets that don't belong to a season or volume
            filterFunc = function (asset) { return (!asset.seasonId
                && !asset.volumeId); };
        }
        return _.filter(assets, function (asset) {
            return !!_this.getRootAssetRouteId(brandingConfig.type, asset) && filterFunc(asset);
        });
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: break-prepostroll-asset-service.ts
 *
 * Created by kyang on 10/28/20.
 */
// This service is an implementation for BrandingAssetService.
// Components should invoke the abstract BrandingAssetService, not this specific implementation.
angular.module('prism-ui.components.branding').service('BreakPrePostRollAssetService', function (_, $q, BrandingAssetService, BrandingViewService, BreakPrePostRollResourceFactory, MediaProfileResourceFactory, PrePostRollResourceFactory) {
    //==========================//
    // Branding Asset Container //
    //==========================//
    var _this = this;
    this.getBrandingAssetContainer = function (containerId) {
        return BreakPrePostRollResourceFactory.get({ containerId: containerId }).$promise;
    };
    this.parseBrandingAssetContainer = function (brandingConfig, brandingAssetContainer) {
        brandingAssetContainer.breakPrePostRolls = BrandingAssetService.filterBrandingAssets(brandingConfig, brandingAssetContainer.breakPrePostRolls, { anySeasonVolume: true });
    };
    this.updateBrandingAssetContainer = function (brandingConfig, brandingAssetContainer) {
        return BreakPrePostRollResourceFactory.update({
            containerId: brandingAssetContainer.id
        }, brandingAssetContainer).$promise;
    };
    //=======//
    // Asset //
    //=======//
    var createEmptyRootBrandingAsset = function (brandingConfig, acceptProfile) {
        var rootAsset = {
            acceptProfile: acceptProfile,
            preRoll: {
                acceptProfile: acceptProfile,
                audios: [],
                texts: [],
            },
            postRoll: {
                acceptProfile: acceptProfile,
                audios: [],
                texts: [],
            },
        };
        if (brandingConfig.seasonId) {
            rootAsset.seasonId = brandingConfig.seasonId;
        }
        else if (brandingConfig.volumeId) {
            rootAsset.volumeId = brandingConfig.volumeId;
        }
        return rootAsset;
    };
    this.getRootBrandingAsset = function (brandingConfig, container, acceptProfile) {
        var breakPrePostRolls = BrandingAssetService.filterBrandingAssets(brandingConfig, container.breakPrePostRolls);
        var rootAsset = _.find(breakPrePostRolls, {
            acceptProfile: { id: acceptProfile.id }
        });
        if (rootAsset) {
            rootAsset.preRoll.audios = _.get(rootAsset.preRoll, 'audios', []);
            rootAsset.preRoll.texts = _.get(rootAsset.preRoll, 'texts', []);
            rootAsset.postRoll.audios = _.get(rootAsset.postRoll, 'audios', []);
            rootAsset.postRoll.texts = _.get(rootAsset.postRoll, 'texts', []);
            return rootAsset;
        }
        return createEmptyRootBrandingAsset(brandingConfig, acceptProfile);
    };
    this.validateNonTextAsset = function (acceptProfileId, asset, virtualPath) {
        return MediaProfileResourceFactory.validatePrePostRoll({
            path: virtualPath,
            profileId: acceptProfileId
        }).$promise.then(function (validationResult) {
            return _.get(validationResult, acceptProfileId + ".failures");
        });
    };
    var updateSubAssets = function (brandingConfig, acceptProfile) {
        return _this.getBrandingAssetContainer(brandingConfig.id)
            .then(function (container) {
            return _this.getRootBrandingAsset(brandingConfig, container, acceptProfile);
        })
            .then(function (savedBreakPrePostRoll) {
            return $q.all([
                ingestSubAssets(savedBreakPrePostRoll.preRoll),
                ingestSubAssets(savedBreakPrePostRoll.postRoll),
            ]).then(function () {
                return savedBreakPrePostRoll;
            });
        });
    };
    var ingestSubAssets = function (videoAsset) {
        var audioAssetPromises = [];
        var textAssetPromises = [];
        _.forEach(videoAsset.audios, function (audioAsset) {
            if (!audioAsset.assetId) {
                audioAssetPromises.push(PrePostRollResourceFactory.updateAssetData({
                    subTypeKey: 'audios',
                    subTypeId: audioAsset.id,
                }, audioAsset).$promise);
            }
        });
        _.forEach(videoAsset.texts, function (textAsset) {
            if (!textAsset.assetId) {
                textAssetPromises.push(PrePostRollResourceFactory.updateAssetData({
                    subTypeKey: 'texts',
                    subTypeId: textAsset.id,
                }, textAsset).$promise);
            }
        });
        return $q.all({
            audios: $q.all(audioAssetPromises),
            texts: $q.all(textAssetPromises),
        });
    };
    this.createRootBrandingAsset = function (brandingConfig, rootAsset) {
        // There is no /assets endpoint, so update the container instead
        return BreakPrePostRollResourceFactory.createAsset({ containerId: brandingConfig.id }, rootAsset).$promise
            .then(function () {
            return updateSubAssets(brandingConfig, rootAsset.acceptProfile);
        });
    };
    this.updateRootBrandingAsset = function (brandingConfig, rootAsset) {
        return BreakPrePostRollResourceFactory.updateAsset({ assetId: rootAsset.id }, rootAsset).$promise
            .then(function () {
            return updateSubAssets(brandingConfig, rootAsset.acceptProfile);
        });
    };
    //=========//
    // Proxies //
    //=========//
    this.hasVideoAssetProxyStatus = function (brandingConfig, rootAsset) {
        return (!BrandingAssetService.assetWasIngested(rootAsset.preRoll)
            || !BrandingAssetService.assetWasIngested(rootAsset.postRoll));
    };
    var getVideoAssetProxyStatus = function (updatedVideoAsset) {
        if (_.get(updatedVideoAsset, 'proxyId')) {
            return BrandingAssetService.ProxyStatus.PROXY_COMPLETE;
        }
        else if (_.get(updatedVideoAsset, 'ingestInfo.workflowStatus') === BrandingAssetService.ProxyStatus.PROXY_STALLED) {
            return BrandingAssetService.ProxyStatus.PROXY_STALLED;
        }
        return BrandingAssetService.ProxyStatus.PROXY_RUNNING;
    };
    this.updateVideoAssetProxyStatus = function (brandingConfig, rootAsset, intervalData) {
        return _this.getBrandingAssetContainer(brandingConfig.id)
            .then(function (updatedContainer) {
            var updatedAsset = _this.getRootBrandingAsset(brandingConfig, updatedContainer, rootAsset.acceptProfile);
            var preRollStatus = getVideoAssetProxyStatus(updatedAsset.preRoll);
            var postRollStatus = getVideoAssetProxyStatus(updatedAsset.postRoll);
            if (preRollStatus !== _.get(intervalData, 'prevPreRollStatus', BrandingAssetService.ProxyStatus.PROXY_RUNNING)) {
                BrandingViewService.showVideoIngestStatusNotifications(brandingConfig, updatedAsset.preRoll, preRollStatus, '- PreRoll ');
            }
            if (postRollStatus !== _.get(intervalData, 'prevPostRollStatus', BrandingAssetService.ProxyStatus.PROXY_RUNNING)) {
                BrandingViewService.showVideoIngestStatusNotifications(brandingConfig, updatedAsset.postRoll, postRollStatus, '- PostRoll ');
            }
            intervalData.prevPreRollStatus = preRollStatus;
            intervalData.prevPostRollStatus = postRollStatus;
            if (preRollStatus === BrandingAssetService.ProxyStatus.PROXY_COMPLETE && postRollStatus === BrandingAssetService.ProxyStatus.PROXY_COMPLETE) {
                return BrandingAssetService.ProxyStatus.PROXY_COMPLETE;
            }
            else if (preRollStatus !== BrandingAssetService.ProxyStatus.PROXY_RUNNING && postRollStatus !== BrandingAssetService.ProxyStatus.PROXY_RUNNING) {
                return BrandingAssetService.ProxyStatus.PROXY_STALLED;
            }
            return BrandingAssetService.ProxyStatus.PROXY_RUNNING;
        });
    };
});
//=================//
// Lifecycle Hooks //
//=================//
// Load this service when app is initialized
angular.module('prism-ui.components.branding').run(function (BrandingAssetService, BreakPrePostRollAssetService) {
    BrandingAssetService.registerAssetServiceImplementation('breakPrePostRolls', BreakPrePostRollAssetService);
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: prepostroll-asset-service.ts
 *
 * Created by kyang on 10/21/20.
 */
// This service is an implementation for BrandingAssetService.
// Components should invoke the abstract BrandingAssetService, not this specific implementation.
angular.module('prism-ui.components.branding').service('PrePostRollAssetService', function (_, $q, BrandingAssetService, BrandingViewService, MediaProfileResourceFactory, PrePostRollResourceFactory) {
    //==========================//
    // Branding Asset Container //
    //==========================//
    this.getBrandingAssetContainer = function (containerId) {
        return PrePostRollResourceFactory.get({ containerId: containerId }).$promise;
    };
    this.parseBrandingAssetContainer = function (brandingConfig, brandingAssetContainer) {
        brandingAssetContainer.assets = BrandingAssetService.filterBrandingAssets(brandingConfig, brandingAssetContainer.assets, { anySeasonVolume: true });
    };
    this.updateBrandingAssetContainer = function (brandingConfig, brandingAssetContainer) {
        return PrePostRollResourceFactory.update({
            containerId: brandingAssetContainer.id
        }, brandingAssetContainer).$promise;
    };
    //=======//
    // Asset //
    //=======//
    var createEmptyRootBrandingAsset = function (brandingConfig, acceptProfile) {
        var rootAsset = {
            acceptProfile: acceptProfile,
            audios: [],
            texts: [],
        };
        if (brandingConfig.seasonId) {
            rootAsset.seasonId = brandingConfig.seasonId;
        }
        else if (brandingConfig.volumeId) {
            rootAsset.volumeId = brandingConfig.volumeId;
        }
        return rootAsset;
    };
    this.getRootBrandingAsset = function (brandingConfig, container, acceptProfile) {
        var videoAssets = BrandingAssetService.filterBrandingAssets(brandingConfig, container.assets);
        var rootAsset = _.find(videoAssets, {
            acceptProfile: { id: acceptProfile.id }
        });
        if (rootAsset) {
            rootAsset.audios = _.get(rootAsset, 'audios', []);
            rootAsset.texts = _.get(rootAsset, 'texts', []);
            return rootAsset;
        }
        return createEmptyRootBrandingAsset(brandingConfig, acceptProfile);
    };
    this.validateNonTextAsset = function (acceptProfileId, asset, virtualPath) {
        return MediaProfileResourceFactory.validatePrePostRoll({
            path: virtualPath,
            profileId: acceptProfileId
        }).$promise.then(function (validationResult) {
            return _.get(validationResult, acceptProfileId + ".failures");
        });
    };
    this.createRootBrandingAsset = function (brandingConfig, rootAsset) {
        return PrePostRollResourceFactory.createAsset({ containerId: brandingConfig.id }, rootAsset).$promise;
    };
    this.updateRootBrandingAsset = function (brandingConfig, rootAsset) {
        return PrePostRollResourceFactory.updateAsset({ assetId: rootAsset.id }, rootAsset).$promise;
    };
    //=========//
    // Proxies //
    //=========//
    this.hasVideoAssetProxyStatus = function (brandingConfig, rootAsset) {
        return !BrandingAssetService.assetWasIngested(rootAsset);
    };
    this.updateVideoAssetProxyStatus = function (brandingConfig, rootAsset, intervalData) {
        return PrePostRollResourceFactory.getAsset({ assetId: rootAsset.id }).$promise
            .then(function (updatedRootAsset) {
            var status = BrandingAssetService.ProxyStatus.PROXY_RUNNING;
            if (_.get(updatedRootAsset, 'proxyId')) {
                status = BrandingAssetService.ProxyStatus.PROXY_COMPLETE;
            }
            else if (_.get(updatedRootAsset, 'ingestInfo.workflowStatus') === BrandingAssetService.ProxyStatus.PROXY_STALLED) {
                status = BrandingAssetService.ProxyStatus.PROXY_STALLED;
            }
            BrandingViewService.showVideoIngestStatusNotifications(brandingConfig, updatedRootAsset, status, '');
            return status;
        });
    };
});
//=================//
// Lifecycle Hooks //
//=================//
// Load this service when app is initialized
angular.module('prism-ui.components.branding').run(function (BrandingAssetService, PrePostRollAssetService) {
    BrandingAssetService.registerAssetServiceImplementation('preRolls', PrePostRollAssetService);
    BrandingAssetService.registerAssetServiceImplementation('postRolls', PrePostRollAssetService);
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: rating-overlay-asset-service.ts
 *
 * Created by kyang on 10/21/20.
 */
// This service is an implementation for BrandingAssetService.
// Components should invoke the abstract BrandingAssetService, not this specific implementation.
//
// BrandingAssetService implementations work on brandingAssetContainers.
// However, rating overlays don't have a container.
// So, use the list of overlays as the brandingAssetContainer instead.
angular.module('prism-ui.components.branding').service('RatingOverlayAssetService', function (_, $q, NetworkResourceFactory, BrandingAssetService, BrandingViewService) {
    var _this = this;
    var RATING_OVERLAY_TYPE = 'ratingOverlays';
    //==========================//
    // Branding Asset Container //
    //==========================//
    var createRatingOverlayBrandingContainer = function (networkId, ratingOverlays) {
        return {
            id: networkId,
            assets: ratingOverlays
        };
    };
    this.getBrandingAssetContainer = function (networkId) {
        return NetworkResourceFactory.getBranding({ id: networkId, view: RATING_OVERLAY_TYPE }).$promise
            .then(function (ratingOverlays) {
            return createRatingOverlayBrandingContainer(networkId, ratingOverlays);
        });
    };
    this.parseBrandingAssetContainer = function (brandingConfig, brandingAssetContainer) {
        brandingAssetContainer.assets = BrandingAssetService.filterBrandingAssets(brandingConfig, brandingAssetContainer.assets, { anySeasonVolume: true });
    };
    this.updateBrandingAssetContainer = function (brandingConfig, brandingAssetContainer) {
        return $q.reject({
            description: 'Rating overlays use a mock brandingAssetContainer, which cannot be saved to the database'
        });
    };
    //=======//
    // Asset //
    //=======//
    var parseRatingOverlayDTO = function (ratingOverlay) {
        _.forEach(ratingOverlay.images, function (image) {
            image.mediaAcceptProfile = ratingOverlay.mediaAcceptProfile;
            if (_.isEmpty(image.ratingDescriptors)) {
                image.ratingDescriptors = [{
                        id: -1,
                        name: '[None]'
                    }];
            }
        });
        return ratingOverlay;
    };
    var createEmptyRootBrandingAsset = function (brandingConfig, acceptProfile) {
        var rootAsset = {
            mediaAcceptProfile: acceptProfile,
            images: [],
        };
        return rootAsset;
    };
    this.getRootBrandingAsset = function (brandingConfig, container, acceptProfile) {
        var ratingOverlays = BrandingAssetService.filterBrandingAssets(brandingConfig, container.assets)
            .map(parseRatingOverlayDTO);
        var rootAsset = _.find(ratingOverlays, {
            mediaAcceptProfile: { id: acceptProfile.id }
        });
        return (rootAsset) ? rootAsset : createEmptyRootBrandingAsset(brandingConfig, acceptProfile);
    };
    this.validateNonTextAsset = function (acceptProfileId, asset, virtualPath) {
        // Rating overlay images aren't validated
        return $q.when([]);
    };
    var prepareRatingOverlay = function (ratingOverlay) {
        _.forEach(ratingOverlay.images, function (image) {
            _.unset(image, 'mediaAcceptProfile');
            _.remove(image.ratingDescriptors, { id: -1 });
        });
    };
    this.createRootBrandingAsset = function (brandingConfig, rootAsset) {
        prepareRatingOverlay(rootAsset);
        return NetworkResourceFactory.saveBranding({ id: brandingConfig.id, view: RATING_OVERLAY_TYPE }, rootAsset).$promise
            .then(parseRatingOverlayDTO);
    };
    this.updateRootBrandingAsset = function (brandingConfig, rootAsset) {
        prepareRatingOverlay(rootAsset);
        return NetworkResourceFactory.saveBranding({ id: brandingConfig.id, view: RATING_OVERLAY_TYPE }, rootAsset).$promise
            .then(parseRatingOverlayDTO);
    };
    //=========//
    // Proxies //
    //=========//
    this.hasVideoAssetProxyStatus = function (brandingConfig, rootAsset) {
        return _.some(rootAsset.images, function (image) {
            return !BrandingAssetService.assetWasIngested(image);
        });
    };
    var getRatingOverlayImageProxyStatus = function (updatedImage) {
        if (BrandingAssetService.assetHasProxy(updatedImage)) {
            return BrandingAssetService.ProxyStatus.PROXY_COMPLETE;
        }
        else if (_.get(updatedImage, 'ingestInfo.workflowStatus') === BrandingAssetService.ProxyStatus.PROXY_STALLED) {
            return BrandingAssetService.ProxyStatus.PROXY_STALLED;
        }
        return BrandingAssetService.ProxyStatus.PROXY_RUNNING;
    };
    this.updateVideoAssetProxyStatus = function (brandingConfig, rootAsset, intervalData) {
        return _this.getBrandingAssetContainer(brandingConfig.id)
            .then(function (updatedContainer) {
            var updatedAsset = _this.getRootBrandingAsset(brandingConfig, updatedContainer, rootAsset.mediaAcceptProfile);
            var finalState = BrandingAssetService.ProxyStatus.PROXY_COMPLETE;
            _.forEach(updatedAsset.images, function (image) {
                var updatedStatus = getRatingOverlayImageProxyStatus(image);
                var prevStatus = _.get(intervalData, image.id, updatedStatus);
                if (updatedStatus !== prevStatus) {
                    BrandingViewService.showVideoIngestStatusNotifications(brandingConfig, image, updatedStatus, "- " + image.rating.name + " ");
                }
                switch (updatedStatus) {
                    case BrandingAssetService.ProxyStatus.PROXY_COMPLETE:
                        break;
                    case BrandingAssetService.ProxyStatus.PROXY_STALLED:
                        if (finalState === BrandingAssetService.ProxyStatus.PROXY_COMPLETE) {
                            finalState = BrandingAssetService.ProxyStatus.PROXY_STALLED;
                        }
                        break;
                    case BrandingAssetService.ProxyStatus.PROXY_RUNNING:
                        finalState = BrandingAssetService.ProxyStatus.PROXY_RUNNING;
                }
                intervalData[image.id] = updatedStatus;
            });
            return finalState;
        });
    };
});
//=================//
// Lifecycle Hooks //
//=================//
// Load this service when app is initialized
angular.module('prism-ui.components.branding').run(function (BrandingAssetService, RatingOverlayAssetService) {
    BrandingAssetService.registerAssetServiceImplementation('ratingOverlays', RatingOverlayAssetService);
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: watermark-asset-service.ts
 *
 * Created by kyang on 10/28/20.
 */
// This service is an implementation for BrandingAssetService.
// Components should invoke the abstract BrandingAssetService, not this specific implementation.
angular.module('prism-ui.components.branding').service('WatermarkAssetService', function (_, $q, BrandingAssetService, WatermarkResourceFactory) {
    //==========================//
    // Branding Asset Container //
    //==========================//
    this.getBrandingAssetContainer = function (containerId) {
        return WatermarkResourceFactory.get({ containerId: containerId }).$promise;
    };
    this.parseBrandingAssetContainer = function (brandingConfig, brandingAssetContainer) {
        brandingAssetContainer.assets = BrandingAssetService.filterBrandingAssets(brandingConfig, brandingAssetContainer.assets, { anySeasonVolume: true });
    };
    this.updateBrandingAssetContainer = function (brandingConfig, brandingAssetContainer) {
        return WatermarkResourceFactory.update({
            containerId: brandingAssetContainer.id
        }, brandingAssetContainer).$promise;
    };
    //=======//
    // Asset //
    //=======//
    var createEmptyRootBrandingAsset = function (brandingConfig, acceptProfile) {
        var rootAsset = { videoAcceptProfile: acceptProfile };
        if (brandingConfig.seasonId) {
            rootAsset.seasonId = brandingConfig.seasonId;
        }
        else if (brandingConfig.volumeId) {
            rootAsset.volumeId = brandingConfig.volumeId;
        }
        return rootAsset;
    };
    this.getRootBrandingAsset = function (brandingConfig, container, acceptProfile) {
        var watermarkAssets = BrandingAssetService.filterBrandingAssets(brandingConfig, container.assets);
        var rootAsset = _.find(watermarkAssets, {
            videoAcceptProfile: { id: acceptProfile.id }
        });
        return (!!rootAsset) ? rootAsset : createEmptyRootBrandingAsset(brandingConfig, acceptProfile);
    };
    this.validateNonTextAsset = function (acceptProfileId, asset, virtualPath) {
        // Watermarks aren't validated
        return $q.when([]);
    };
    this.createRootBrandingAsset = function (brandingConfig, rootAsset) {
        return WatermarkResourceFactory.createAsset({ containerId: brandingConfig.id }, rootAsset).$promise;
    };
    this.updateRootBrandingAsset = function (brandingConfig, rootAsset) {
        return WatermarkResourceFactory.updateAsset({ assetId: rootAsset.id }, rootAsset).$promise;
    };
    //=========//
    // Proxies //
    //=========//
    this.hasVideoAssetProxyStatus = function (brandingConfig, rootAsset) {
        return false;
    };
});
//=================//
// Lifecycle Hooks //
//=================//
// Load this service when app is initialized
angular.module('prism-ui.components.branding').run(function (BrandingAssetService, WatermarkAssetService) {
    BrandingAssetService.registerAssetServiceImplementation('watermarks', WatermarkAssetService);
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: branding-search-view-component.ts
 *
 * Created by rwilliams on 8/3/17.
 */
function BrandingSearchViewController(_, $routeParams, $location, uiGridConstants, PermissionsService, BrandingAssetService, ContentEditService, ModalService, NotificationService) {
    var _this = this;
    var showHidden = false;
    var seasonsVolumes = null;
    var seasonVolumeId = null;
    var treeData;
    var assetsKey = function () {
        switch (_this.type) {
            case 'artwork':
            case 'preRolls':
            case 'postRolls':
            case 'watermarks':
                return 'assets';
            case 'breakPrePostRolls':
                return 'breakPrePostRolls';
            default:
                console.error("unrecognized branding asset type " + _this.type);
                return '';
        }
    };
    var acceptProfileKey = function () {
        switch (_this.type) {
            case 'artwork':
            case 'preRolls':
            case 'postRolls':
            case 'breakPrePostRolls':
                return 'acceptProfile';
            case 'watermarks':
                return 'videoAcceptProfile';
            default:
                console.error("unrecognized branding asset type " + _this.type);
                return '';
        }
    };
    //======//
    // Grid //
    //======//
    var gridColumns = [
        {
            field: 'name',
            displayName: 'Name',
            cellTooltip: true,
            cellTemplate: 'components/branding/searchView/cellTemplates/branding-tree-template.html',
            enableSorting: false
        }
    ];
    var addBaseContainerAssets = function (containerAssets) {
        // add assets which don't belong to any season or
        // volume first; sort them by the accept profile name
        _.chain(containerAssets)
            .filter(function (asset) { return !asset.seasonName && !asset.volumeName; })
            .sortBy(acceptProfileKey())
            .forEach(function (asset) {
            asset.$$treeLevel = 1;
            treeData.push(asset);
        })
            .value();
    };
    var addChildContainerAssets = function (containerAssets, childContainerNameKey, childContainerName) {
        _.chain(containerAssets)
            .filter(function (asset) { return asset[childContainerNameKey] === childContainerName; })
            .sortBy(acceptProfileKey())
            .forEach(function (asset) {
            asset.$$treeLevel = 2;
            treeData.push(asset);
        })
            .value();
    };
    var addChildContainers = function (childContainerNameKey, containerAssets) {
        // add season child containers, their assets,
        // volume containers and their assets, all sorted
        // `childContainerNamesKey` is either "seasonName" or
        // "volumeName"
        _.chain(containerAssets)
            .filter(function (asset) { return !!asset[childContainerNameKey]; })
            .map(childContainerNameKey)
            .uniq()
            .sortBy( /* No key: => just sort the array */)
            .forEach(function (childContainerName) {
            // add the child container itself to level 1
            treeData.push({
                name: childContainerName,
                $$treeLevel: 1
            });
            // add this child container's assets to level 2
            addChildContainerAssets(containerAssets, childContainerNameKey, childContainerName);
        })
            .value();
    };
    var addOnlySeasonVolumeAssets = function (containerAssets) {
        var seasonOrVolumeIdKey = seasonsVolumes === 'seasons' ? 'seasonId' : 'volumeId';
        _.chain(containerAssets)
            .filter(function (asset) { return asset[seasonOrVolumeIdKey] === $routeParams[seasonOrVolumeIdKey]; })
            .sortBy(acceptProfileKey())
            .forEach(function (asset) {
            asset.$$treeLevel = 1;
            treeData.push(asset);
        })
            .value();
    };
    var buildTreeView = function (containers) {
        _this.gridOptions.data = treeData = [];
        _.chain(containers)
            .sortBy('name')
            .forEach(function (container) {
            container.$$treeLevel = 0;
            treeData.push(container);
            var containerAssets = container[assetsKey()];
            if (!_this.isSeasonVolume) {
                addBaseContainerAssets(containerAssets);
                _.forEach(['seasonName', 'volumeName'], function (childContainerNameKey) {
                    addChildContainers(childContainerNameKey, containerAssets);
                });
            }
            else {
                addOnlySeasonVolumeAssets(containerAssets);
            }
        })
            .value();
        return treeData;
    };
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: false,
        enablePaginationControls: false,
        useExternalPagination: false,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableSorting: false,
        enableFiltering: false,
        showTreeExpandNoChildren: false,
        showHeader: true,
        rowHeight: 26,
        treeRowHeaderBaseWidth: 24,
        multiSelect: false,
        columnDefs: gridColumns,
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
        }
    };
    var editBrandingAssetContainer = function (container) {
        if (!_.get(_this, 'permissions.read')) {
            NotificationService.createWarningNotification('You do not have permission to view branding assets.');
            return;
        }
        if (container.$$treeLevel === 0 && !container.hidden) {
            var basePath = _this.baseUrl + "/edit/" + $routeParams.id + "/";
            var seasonVolumePath = _this.isSeasonVolume ? seasonsVolumes + "/edit/" + seasonVolumeId + "/" : "";
            var containerPath = _this.type + "/edit/" + container.id;
            $location.url(basePath + seasonVolumePath + containerPath);
        }
    };
    this.rowDoubleClick = function (entity) {
        editBrandingAssetContainer(entity);
    };
    this.getAssetAcceptProfile = function (asset) {
        return asset[acceptProfileKey()];
    };
    //======//
    // Data //
    //======//
    var getBrandingConfig = function () {
        return {
            id: $routeParams.id,
            seasonId: $routeParams.seasonId,
            volumeId: $routeParams.volumeId,
            type: _this.type,
            isShow: _this.groupName !== 'networks',
            groupName: _this.groupName
        };
    };
    var getData = function () {
        _this.loadingIndicator.show = true;
        _this.isBreakPrePostRoll = _this.type === 'breakPrePostRolls';
        if (_this.isSeasonVolume) {
            ContentEditService.setBrandingBreadcrumbs();
        }
        BrandingAssetService.getBrandingAssetContainers(getBrandingConfig(), $routeParams.id, showHidden)
            .then(function (containers) {
            if ($routeParams.seasonId) {
                seasonsVolumes = 'seasons';
                seasonVolumeId = $routeParams.seasonId;
            }
            else if ($routeParams.volumeId) {
                seasonsVolumes = 'volumes';
                seasonVolumeId = $routeParams.volumeId;
            }
            _this.loadingIndicator.show = false;
            buildTreeView(containers);
            _this.gridApi.selection.clearSelectedRows();
        });
    };
    //=========//
    // Toolbar //
    //=========//
    var enableNewButton = function () {
        return (_this.gridApi.selection.getSelectedCount() === 0 &&
            _.get(_this, 'permissions.write'));
    };
    var enableEditButtons = function () {
        return (_this.gridApi.selection.getSelectedCount() === 1 &&
            _this.gridApi.selection.getSelectedRows()[0].$$treeLevel === 0 &&
            _.get(_this, 'permissions.write'));
    };
    var isSelectedHidden = function () {
        var exactlyOneSelected = _this.gridApi.selection.getSelectedCount() === 1;
        var selectedItemArray = _this.gridApi.selection.getSelectedRows();
        var selectedItemIsHidden = _.get(selectedItemArray, '[0].hidden');
        return exactlyOneSelected && selectedItemIsHidden;
    };
    var toggleBrandingAssetContainerVisibility = function (container) {
        BrandingAssetService.toggleBrandingAssetContainerVisibility(getBrandingConfig(), container)
            .then(function () {
            _this.gridApi.selection.clearSelectedRows();
            getData();
        });
    };
    var openConfirmationModal = function (action, resultHandler) {
        var brandName = _this.gridApi.selection.getSelectedRows()[0].name;
        ModalService.showMessageModal({
            messageText: "Are you sure you want to " + action + " " + brandName + " ?",
            pullCancelLeft: true,
            title: "" + action.charAt(0).toUpperCase() + action.slice(1) + " " + _this.type,
            showOK: true,
            okText: 'Yes',
            windowClass: 'confirm-modal-sm'
        }, resultHandler);
    };
    var showHideUnhideConfirmationModal = function (title) {
        openConfirmationModal(title, function () {
            toggleBrandingAssetContainerVisibility(_this.gridApi.selection.getSelectedRows()[0]);
        });
    };
    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: function () { return enableNewButton(); },
            onClick: function () {
                var seasonVolumePart = '';
                if (seasonVolumeId) {
                    seasonVolumePart = seasonsVolumes + "/edit/" + seasonVolumeId + "/";
                }
                var newUrl = _this.baseUrl + "/edit/" + $routeParams.id + "/" + seasonVolumePart + _this.type + "/edit/-1";
                $location.url(newUrl);
            }
        },
        {
            label: 'Edit',
            enabled: function () { return enableEditButtons(); },
            onClick: function () {
                var container = _this.gridApi.selection.getSelectedRows()[0];
                editBrandingAssetContainer(container);
            }
        },
        {
            label: 'Hide',
            enabled: function () { return enableEditButtons() && !isSelectedHidden(); },
            onClick: function () {
                showHideUnhideConfirmationModal('Hide');
            }
        },
        {
            label: 'Unhide',
            enabled: function () { return enableEditButtons() && isSelectedHidden(); },
            onClick: function () {
                showHideUnhideConfirmationModal('Unhide');
            }
        }
    ];
    this.toolbarCheckboxDefs = [
        {
            label: 'Show Hidden',
            onUpdate: function (newValue) {
                showHidden = newValue;
                getData();
            },
            isChecked: showHidden,
        }
    ];
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        PermissionsService.getReadWritePermissions(_this.permissionViewState)
            .then(function (permissions) {
            _this.permissions = permissions;
            getData();
        });
    };
}
angular.module('prism-ui.components.branding').component('brandingSearchView', {
    templateUrl: 'components/branding/searchView/branding-search-view-template.html',
    controller: BrandingSearchViewController,
    bindings: {
        isAdmin: '<',
        permissionViewState: '<',
        groupName: '<',
        type: '<',
        baseUrl: '<',
        isSeasonVolume: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
function ActorEditViewController($routeParams, $route, $location, $timeout, CollaboratorsService, BreadcrumbService, _, ModalService) {
    var _this = this;
    this.actorIsSelf = false;
    var contentPathParam = (this.isSeries) ? 'series' : 'movies';
    var initializeBreadcrumbs = function () {
        BreadcrumbService.clearBreadcrumbs();
        BreadcrumbService.addBreadcrumb({
            name: $route.current.label,
            location: $route.current.rootRoute
        });
        BreadcrumbService.addBreadcrumb({
            name: _this.contentName,
            location: "/meta/" + contentPathParam + "/edit/" + $routeParams.id + "/collaborators"
        });
    };
    var getData = function () {
        _this.loadingIndicator.show = true;
        CollaboratorsService.getCollaboratorRole({ id: $routeParams.actorId }).then(function (data) {
            _this.editData = _.cloneDeep(data);
            _this.actorIsSelf = _.isEqual(_.get(_this.editData, 'character'), 'Self');
            _.set(CollaboratorsService, 'originalEditData', angular.copy(_this.editData));
            _this.loadingIndicator.show = false;
        });
    };
    this.saveEditData = function () {
        _this.loadingIndicator.show = true;
        // If the Self checkbox is set, set the character property to the string 'Self'
        if (_this.actorIsSelf) {
            _.set(_this.editData, 'character', 'Self');
        }
        saveCollaboratorRole();
    };
    var saveCollaboratorRole = function () {
        if (isThisActorNew()) {
            createNewRole();
        }
        else {
            updateExistingRole();
        }
    };
    var updateExistingRole = function () {
        CollaboratorsService.updateCollaboratorRole(_this.editData).then(function (data) {
            CollaboratorsService.originalEditData = _.cloneDeep(data);
            _this.loadingIndicator.show = false;
            _this.editorForm.$setPristine();
        }).catch(function () {
            _this.handleDuplicateRole();
        });
    };
    var createNewRole = function () {
        CollaboratorsService.saveContentActor({ id: $routeParams.id }, _this.editData).then(function (data) {
            CollaboratorsService.originalEditData = _.cloneDeep(data);
            _this.editorForm.$setPristine();
        }).finally(function () {
            _this.loadingIndicator.show = false;
            $location.url("/meta/" + contentPathParam + "/edit/" + $routeParams.id + "/collaborators");
        });
    };
    this.handleDuplicateRole = function () {
        _.set(_this, 'actorIsSelf', _.isEqual(_.get(CollaboratorsService.originalEditData, 'character'), 'Self'));
        _this.loadingIndicator.show = false;
    };
    var isThisActorNew = function () {
        return _.isEqual(_.toInteger($routeParams.actorId), -1);
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return _this.editorForm && _this.editorForm.$dirty; },
            onClick: function () {
                _this.saveEditData();
            }
        },
        {
            label: 'Revert',
            enabled: function () { return _this.editorForm && _this.editorForm.$dirty; },
            onClick: function () {
                _this.editData = _.cloneDeep(CollaboratorsService.originalEditData);
                _this.editorForm.$setPristine();
                _this.actorIsSelf = _.isEqual(_.get(_this.editData, 'character'), 'Self');
            }
        },
        {
            label: 'Close',
            enabled: function () { return _this.editorForm && !_this.editorForm.$dirty; },
            onClick: function () { return $location.url("/meta/" + contentPathParam + "/edit/" + $routeParams.id + "/collaborators"); }
        }
    ];
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        initializeBreadcrumbs();
        if ($routeParams.actorId === '-1') {
            if (CollaboratorsService.newActor) {
                _this.editData = _.cloneDeep(CollaboratorsService.newActor);
                CollaboratorsService.originalEditData = _.cloneDeep(CollaboratorsService.newActor);
            }
            else {
                $location.url('/login');
            }
        }
        else {
            getData();
        }
    };
    this.$postLink = function () {
        $timeout(function () {
            _this.editorForm.$setPristine();
            CollaboratorsService.editorForm = _this.editorForm;
            BreadcrumbService.editService = CollaboratorsService;
        });
    };
    this.$onDestroy = function () {
        BreadcrumbService.clearBreadcrumbs();
        _this.editData = null;
        CollaboratorsService.newActor = null;
        CollaboratorsService.editData = null;
        CollaboratorsService.originalEditData = null;
    };
    this.changeActorForRole = function () {
        CollaboratorsService.originalEditData = _.cloneDeep(_this.editData);
        CollaboratorsService.newActor = _this.editData;
        _this.editorForm.$setDirty();
        ModalService.showAddCollaboratorModal([], 'actors', handleNewActorSelection, undefined, !_this.isSeason, _this.isSeries, false, false);
    };
    var handleNewActorSelection = function (collaborators) {
        _.set(_this, 'editData.collaborator', collaborators[0]);
    };
}
angular.module('prism-ui.components').component('actorEditView', {
    templateUrl: 'components/collaborators/roles/actor-edit-view-template.html',
    controller: ActorEditViewController,
    bindings: {
        contentName: '<',
        isSeries: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
/**
 * Created by kyang on 4/8/19.
 */
function EchoServiceConstructor(_, $http, $q, $window, loginService, EndPointService, NotificationService, RequestService) {
    var _this = this;
    var dataRefreshInterval;
    // Default, should only be used in unit tests.
    this.serverStatusRefreshEnabled = _.get($window, '__wfcConfig.serverStatusRefreshEnabled', true);
    this.serverStatusRefreshDelay = _.get($window, '__wfcConfig.serverStatusRefreshDelay', 5);
    this.getRefreshDelayMillis = function () {
        return _this.serverStatusRefreshDelay * 1000;
    };
    /* Handle callbacks */
    this.registerDataUpdateCallback = function (callbackFunc) {
        if (typeof (callbackFunc) == 'function') {
            if (!_.includes(_this.dataUpdateCallbacks, callbackFunc)) {
                _this.dataUpdateCallbacks.push(callbackFunc);
                callbackFunc(_this.serverStatus); // Send current value
            }
        }
    };
    this.unregisterDataUpdateCallback = function (callbackFunc) {
        _.pull(_this.dataUpdateCallbacks, callbackFunc);
    };
    /* Functions to start & stop updating status every so often */
    this.activateDataRefreshInterval = function () {
        var deferred = $q.defer();
        if (!dataRefreshInterval) {
            dataRefreshInterval = RequestService.createRequestInterval(updateStatus, _this.getRefreshDelayMillis(), { startImmediately: true });
        }
        if (_this.serverStatus.response === undefined) {
            var resolveCallback_1 = function (newServerStatus) {
                if (_.get(newServerStatus, 'response')) {
                    deferred.resolve(newServerStatus);
                    _this.unregisterDataUpdateCallback(resolveCallback_1);
                }
            };
            _this.registerDataUpdateCallback(resolveCallback_1);
        }
        else {
            deferred.resolve(_this.serverStatus);
        }
        return deferred.promise;
    };
    this.deactivateDataRefreshInterval = function () {
        if (dataRefreshInterval) {
            RequestService.cancelRequestInterval(dataRefreshInterval);
        }
        dataRefreshInterval = undefined;
    };
    var EventStatus;
    (function (EventStatus) {
        EventStatus[EventStatus["PENDING"] = 0] = "PENDING";
        EventStatus[EventStatus["SUCCEEDED"] = 1] = "SUCCEEDED";
        EventStatus[EventStatus["FAILED"] = 2] = "FAILED";
    })(EventStatus || (EventStatus = {}));
    this.EventStatus = EventStatus;
    // parseEventFn accepts 1 arg: Event DTO. Returns object with 2 keys: status & message
    this.awaitNotification = function (id, parseEventFn) {
        _this.pendingNotifications.push({ id: id, parseEventFn: parseEventFn });
    };
    // Save status, & report new status to all callbacks
    var updateStatus = function () {
        return _this.getServerStatus().then(function (serverStatus) {
            _this.serverStatus = serverStatus;
            // Clone callbacks so outside functions can't mess with the forEach loop
            // Example: One of the callbacks can unregister itself when triggered
            _.forEach(_.clone(_this.dataUpdateCallbacks), function (callback) {
                callback(_this.serverStatus);
            });
        });
    };
    // Try to connect to the server
    this.getServerStatus = function () {
        var statusPromise;
        if (loginService.isAuthenticated() && _this.pendingNotifications.length > 0) {
            statusPromise = _this.getEventNotifications();
        }
        else if (_this.serverStatusRefreshEnabled) {
            statusPromise = $http({
                method: 'GET',
                url: EndPointService.echoEndPoint
            });
        }
        else {
            statusPromise = $q.when({
                status: 200,
                statusText: 'OK',
                data: {}
            });
        }
        // Convert success & failure into an object
        return statusPromise.then(function (successResponse) {
            return { serverResponded: true, response: _.pick(successResponse, ['status', 'statusText', 'data']) };
        }, function (failResponse) {
            return { serverResponded: false, response: _.pick(failResponse, ['status', 'statusText', 'data']) };
        });
    };
    // Get event notifications & display them. Expects at least 1 pendingNotification to exist
    this.getEventNotifications = function () {
        // Make requests & parse them
        var eventRequests = _this.pendingNotifications.map(function (eventInfo) {
            return $http({
                method: 'GET',
                url: EndPointService.eventNotificationsEndPoint + '/' + eventInfo.id,
            }).then(function (eventResponse) {
                return __assign({}, eventInfo.parseEventFn(eventResponse.data), { eventResponse: eventResponse });
            }, function (failResponse) {
                return { eventResponse: failResponse };
            });
        });
        // Show notifications & update pendingNotifications
        return $q.all(eventRequests).then(function (parsedEventsInfo) {
            var pingResponse = undefined;
            _this.pendingNotifications = _this.pendingNotifications.filter(function (eventInfo, index) {
                var parsedEventInfo = parsedEventsInfo[index];
                if (!parsedEventInfo) {
                    return true;
                }
                else if (parsedEventInfo.status === undefined) {
                    pingResponse = parsedEventInfo.eventResponse;
                    return true;
                }
                else if (parsedEventInfo.status === EventStatus.SUCCEEDED) {
                    NotificationService.createPersistentInfoNotification(parsedEventInfo.message);
                    return false;
                }
                else if (parsedEventInfo.status === EventStatus.FAILED) {
                    NotificationService.createFailureNotification(parsedEventInfo.message, '', true, -1);
                    return false;
                }
                else {
                    return true;
                }
            });
            if (pingResponse) {
                return $q.reject(pingResponse);
            }
            return parsedEventsInfo[0].eventResponse;
        });
    };
    var disconnectNotification;
    var notificationCallback = function (serverStatus) {
        if (serverStatus.serverResponded || !loginService.isAuthenticated()) {
            if (!!disconnectNotification) {
                disconnectNotification.close();
                disconnectNotification = undefined;
            }
            // No response, and logged in, check next case
        }
        else if (!!serverStatus.response && !disconnectNotification) {
            disconnectNotification = NotificationService.createFailureNotification('Got disconnected from the server', '', false, -1);
        }
    };
    this.initialize = function () {
        if (!_this.dataUpdateCallbacks) {
            _this.pendingNotifications = [];
            _this.serverStatus = { serverResponded: false, response: undefined };
            _this.dataUpdateCallbacks = [notificationCallback];
        }
        return _this.activateDataRefreshInterval();
    };
}
angular
    .module('prism-ui.components.data')
    .service('EchoService', EchoServiceConstructor);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by richardwilliams on 3/31/15.
 */
function EndPointServiceConstructor(_, $window, appUriConfig) {
    var setDefaultWFCConfig = function () {
        //
        // This should only be used while running unit tests.
        //
        var defaultWFCConfig = {
            reachengineServerUrl: 'https://localhost',
            liveClippingServerUrl: 'https://localhost/liveclipping/api',
            liveClippingMediaUrl: 'https://localhost/liveclipping/hls',
            asperaConnectSdkPath: 'https://localhost/connect/v4'
        };
        if (!$window.hasOwnProperty('__wfcConfig')) {
            console.warn("$window.__wfcConfig not defined; using defaults");
            $window.__wfcConfig = $window.__wfcConfig || {};
            Object.assign($window.__wfcConfig, defaultWFCConfig);
        }
    };
    setDefaultWFCConfig();
    this.reachengineServerUrl = $window.__wfcConfig.reachengineServerUrl;
    this.liveClippingServerUrl = $window.__wfcConfig.liveClippingServerUrl;
    this.liveClippingMediaUrl = $window.__wfcConfig.liveClippingMediaUrl;
    this.webProxyMp4Url = $window.__wfcConfig.webProxyMp4Url;
    this.proxyUrl = $window.__wfcConfig.proxyUrl;
    this.asperaConnectSdkPath = $window.__wfcConfig.asperaConnectSdkPath;
    this.asperaConnectDestinationHost = $window.__wfcConfig.asperaConnectDestinationHost;
    this.acceptProfileEndPoint = this.reachengineServerUrl + appUriConfig.acceptProfilesUri;
    this.aggregationEndPoint = this.reachengineServerUrl + appUriConfig.aggregationUri;
    this.assetContentTemplatesEndPoint = this.reachengineServerUrl + appUriConfig.assetContentTemplatesUri;
    this.artworkEndpoint = this.reachengineServerUrl + appUriConfig.artworkUri;
    this.breakPrePostRollEndpoint = this.reachengineServerUrl + appUriConfig.breakPrePostRollUri;
    this.calendarsEndpoint = this.reachengineServerUrl + appUriConfig.calendarsUri;
    this.categoriesEndpoint = this.reachengineServerUrl + appUriConfig.categoriesUri;
    this.captionsEndpoint = this.reachengineServerUrl + appUriConfig.captionsUri;
    this.checkInEndpoint = this.reachengineServerUrl + appUriConfig.checkInUri;
    this.clipEndpoint = this.reachengineServerUrl + appUriConfig.clipsUri;
    this.collaboratorsEndPoint = this.reachengineServerUrl + appUriConfig.collaboratorsUri;
    this.componentInventoryEndPoint = this.reachengineServerUrl + appUriConfig.componentInventoryUri;
    this.conditionalTemplateEndPoint = this.reachengineServerUrl + appUriConfig.conditionalTemplatesUri;
    this.contactsEndPoint = this.reachengineServerUrl + appUriConfig.contactsUri;
    this.contentEndPoint = this.reachengineServerUrl + appUriConfig.contentUri;
    this.dashboardEndpoint = this.reachengineServerUrl + appUriConfig.dashboardUri;
    this.deliveryTemplatesEndPoint = this.reachengineServerUrl + appUriConfig.deliveryTemplatesUri;
    this.deliveryEndPoint = this.reachengineServerUrl + appUriConfig.deliveryUri;
    this.directoryEndPoint = this.reachengineServerUrl + appUriConfig.directoryUri;
    this.dynamicPropertiesEndPoint = this.reachengineServerUrl + appUriConfig.dynamicPropertiesUri;
    this.echoEndPoint = this.reachengineServerUrl + appUriConfig.echoUri;
    this.emailTemplatesEndPoint = this.reachengineServerUrl + appUriConfig.emailTemplatesUri;
    this.enumEndPoint = this.reachengineServerUrl + appUriConfig.enumUri;
    this.eventNotificationsEndPoint = this.reachengineServerUrl + appUriConfig.eventNotificationsUri;
    this.externalMetadataSourcesEndPoint = this.reachengineServerUrl + appUriConfig.externalMetadataSourcesUri;
    this.externalMetadataLoggingEndPoint = this.reachengineServerUrl + appUriConfig.externalMetadataLoggingUri;
    this.externalMetadataQueueEndPoint = this.reachengineServerUrl + appUriConfig.externalMetadataQueueUri;
    this.execServersEndPoint = this.reachengineServerUrl + appUriConfig.execServersUri;
    this.fileSystemEndPoint = this.reachengineServerUrl + appUriConfig.fileSystemUri;
    this.ffmpegTemplateEndPoint = this.reachengineServerUrl + appUriConfig.ffmpegTemplatesUri;
    this.fileUploadEndPoint = this.reachengineServerUrl + appUriConfig.fileUploadUri;
    this.genresEndPoint = this.reachengineServerUrl + appUriConfig.genresUri;
    this.imageTemplatesEndpoint = this.reachengineServerUrl + appUriConfig.imageTemplatesUri;
    this.intermediateTemplateEndPoint = this.reachengineServerUrl + appUriConfig.intermediateTemplatesUri;
    this.inventoryEndPoint = this.reachengineServerUrl + appUriConfig.inventoryUri;
    this.languageEndPoint = this.reachengineServerUrl + appUriConfig.languageUri;
    this.liveClipEndPoint = this.reachengineServerUrl + appUriConfig.liveClipUri;
    this.livefeedsEndPoint = this.reachengineServerUrl + appUriConfig.livefeedsUri;
    this.macCaptionTemplatesEndpoint = this.reachengineServerUrl + appUriConfig.macCaptionTemplatesUri;
    this.mediaAssetEndpoint = this.reachengineServerUrl + appUriConfig.mediaAssetUri;
    this.mediaAssetDownloadEndpoint = this.reachengineServerUrl + appUriConfig.mediaAssetUri;
    this.mediaConversionTemplateEndpoint = this.reachengineServerUrl + appUriConfig.mediaConversionTemplateUri;
    this.mediaProfileEndPoint = this.reachengineServerUrl + appUriConfig.mediaProfile;
    this.metaGroupsEndpoint = this.reachengineServerUrl + appUriConfig.metaGroupsUri;
    this.metaPropertiesEndpoint = this.reachengineServerUrl + appUriConfig.metaPropsUri;
    this.networksEndPoint = this.reachengineServerUrl + appUriConfig.networksUri;
    this.packageAcceptTemplatesEndPoint = this.reachengineServerUrl + appUriConfig.packageAcceptTemplatesUri;
    this.packageEndPoint = this.reachengineServerUrl + appUriConfig.packageUri;
    this.packageCategoriesEndpoint = this.reachengineServerUrl + appUriConfig.packageCategoriesUri;
    this.packageCreationTemplatesEndpoint = this.reachengineServerUrl + appUriConfig.packageCreationTemplatesUri;
    this.packageMediaInfoEndpoint = this.reachengineServerUrl + appUriConfig.packageMediaInfoUri;
    this.packageStatusNotificationsEndPoint = this.reachengineServerUrl + appUriConfig.packageStatusNotificationsUri;
    this.partnerEndPoint = this.reachengineServerUrl + appUriConfig.partnerUri;
    this.partnerPackagesEndPoint = this.reachengineServerUrl + appUriConfig.partnerPackagesUri;
    this.permissionsEndPoint = this.reachengineServerUrl + appUriConfig.permissionsUri;
    this.prePostRollEndpoint = this.reachengineServerUrl + appUriConfig.prePostRollUri;
    this.proxyEndPoint = this.reachengineServerUrl + appUriConfig.proxyUri;
    this.queuesEndpoint = this.reachengineServerUrl + appUriConfig.queuesUri;
    this.reachDynamicPropertiesEndPoint = this.reachengineServerUrl + appUriConfig.reachDynamicPropertiesUri;
    this.ratingsEndPoint = this.reachengineServerUrl + appUriConfig.ratingsUri;
    this.reachPermissionsEndpoint = this.reachengineServerUrl + appUriConfig.reachPermissionsUri;
    this.recordEndPoint = this.liveClippingServerUrl + appUriConfig.recordUri;
    this.reportEndpoint = this.reachengineServerUrl + appUriConfig.reportUri;
    this.repositoryRootsEndpoint = this.reachengineServerUrl + appUriConfig.repositoryRootsUri;
    this.roleEndPoint = this.reachengineServerUrl + appUriConfig.roleUri;
    this.samlEndPoint = this.reachengineServerUrl + appUriConfig.samlUri;
    this.securityRolesEndPoint = this.reachengineServerUrl + appUriConfig.securityRolesUri;
    this.serverInfoEndpoint = this.reachengineServerUrl + appUriConfig.serverInfoUri;
    this.systemMediainfoEndpoint = this.reachengineServerUrl + appUriConfig.mediainfoUri;
    this.temporaryFileUploadEndpoint = this.reachengineServerUrl + appUriConfig.temporaryFileUploadUri;
    this.territoriesEndpoint = this.reachengineServerUrl + appUriConfig.territoriesUri;
    this.transformTemplatesEndPoint = this.reachengineServerUrl + appUriConfig.transformTemplatesUri;
    this.userEndPoint = this.reachengineServerUrl + appUriConfig.userUri;
    this.virtualPathEndPoint = this.reachengineServerUrl + appUriConfig.virtualPathUri;
    this.watermarkEndpoint = this.reachengineServerUrl + appUriConfig.watermarkUri;
    this.workflowExecutionEndPoint = this.reachengineServerUrl + appUriConfig.workflowExecutionsUri;
    this.workflowFilesEndpoint = this.reachengineServerUrl + appUriConfig.workflowFilesUri;
}
angular
    .module('prism-ui.components.data')
    .service('EndPointService', EndPointServiceConstructor);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by kyang on 2/14/20.
 */
function RequestServiceConstructor(_, $q, $timeout, $window, PaginationService) {
    //==============//
    // Page Queries //
    //==============//
    var _this = this;
    // TODO: Replace PaginationService.pageDataResource usage with this function?
    // TODO: Replace PaginationService.queryForNewPageData() usage with this function?
    // queryFn - Function that makes a request for data, and returns a promise with that data.
    //           If request passed the last page of data,
    //           it should also update PaginationService.currentPage
    // isPageEmptyFn - Function that checks if the response is empty.
    //                 Is called with the value returned by queryFn's promise
    //                 Defaults to _.isEmpty
    this.queryForNewData = function (queryFn, isPageEmptyFn) {
        if (isPageEmptyFn === void 0) { isPageEmptyFn = _.isEmpty; }
        var previousPage = PaginationService.currentPage;
        return queryFn().then(function (pageData) {
            if (isPageEmptyFn(pageData) && PaginationService.currentPage !== previousPage) {
                return _this.queryForNewData(queryFn, isPageEmptyFn);
            }
            return pageData;
        });
    };
    //=================//
    // Page Visibility //
    //=================//
    /* Returns a promise. Promise resolves when page is visible. */
    this.whenPageVisible = function () {
        var deferred = $q.defer();
        if ($window.document.hidden) {
            _this.visibilityPromises.push(deferred);
        }
        else {
            deferred.resolve();
        }
        return deferred.promise;
    };
    var onVisibilityChange = function () {
        if (!$window.document.hidden && _this.visibilityPromises.length > 0) {
            _.forEach(_this.visibilityPromises, function (deferred) {
                deferred.resolve();
            });
            _this.visibilityPromises = [];
        }
    };
    //===================//
    // Request Intervals //
    //===================//
    var nextIntervalId = 0;
    this.intervals = {};
    var intervalCallback = function (interval) {
        var waitPromise = interval.waitForPageVisibility ? _this.whenPageVisible() : $q.when();
        waitPromise
            .then(interval.promiseFunc)
            .finally(function () {
            if (_this.intervals[interval.id]) {
                interval.timeoutPromise = $timeout(intervalCallback.bind(_this, interval), interval.delay);
            }
        });
    };
    // options has 2 possible keys: startImmediately, waitForPageVisibility
    this.createRequestInterval = function (promiseFunc, delay, options) {
        _this.initialize();
        var newInterval = {
            id: nextIntervalId,
            promiseFunc: promiseFunc,
            waitForPageVisibility: _.get(options, 'waitForPageVisibility', true),
            delay: delay,
        };
        _this.intervals[nextIntervalId++] = newInterval;
        if (_.get(options, 'startImmediately', false)) {
            intervalCallback(newInterval);
        }
        else {
            newInterval.timeoutPromise = $timeout(intervalCallback.bind(_this, newInterval), delay);
        }
        return newInterval.id;
    };
    this.cancelRequestInterval = function (intervalId) {
        var interval = _this.intervals[intervalId];
        if (interval) {
            if (interval.promiseFunc) {
                $timeout.cancel(interval.timeoutPromise);
            }
            delete _this.intervals[intervalId];
        }
    };
    this.initialize = function () {
        if (!_this.visibilityPromises) {
            _this.visibilityPromises = [];
            $window.document.addEventListener('visibilitychange', onVisibilityChange);
        }
    };
}
angular
    .module('prism-ui.components.data')
    .service('RequestService', RequestServiceConstructor);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2022 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by kyang on 10/21/22.
 */
function ServerInfoServiceConstructor(_, ServerInfoResourceFactory) {
    var _this = this;
    this.serverInfoPromise = null;
    this.timezoneOffsetMillis = null;
    this.queryForServerInfo = function () {
        if (!_this.serverInfoPromise) {
            _this.serverInfoPromise = ServerInfoResourceFactory.get().$promise.then(function (data) {
                _this.timezoneOffsetMillis = _.chain(data)
                    .get('timezoneOffsetMillis', '0')
                    .parseInt()
                    .value();
                return data;
            });
        }
        return _this.serverInfoPromise;
    };
    this.getServerTimezoneOffsetMillis = function () {
        if (_this.timezoneOffsetMillis === null) {
            console.error('getServerTimezoneOffsetMillis() expected serverInfo to return successfully');
            return 0;
        }
        return _this.timezoneOffsetMillis;
    };
}
angular
    .module('prism-ui.components.data')
    .service('ServerInfoService', ServerInfoServiceConstructor);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by kyang on 7/26/21.
 */
function DynamicStyleServiceConstructor(_, $window) {
    var _this = this;
    // Expects color to start with '#', followed by 6-digit hex color (RRGGBB)
    // Returns null if format not matched.
    var cssColorToPercent = function (hexColor) {
        var percents = [];
        var hexSection = '([0-9a-fA-F]{2})';
        var matches = hexColor.match('^#' + hexSection.repeat(3) + '$');
        if (!matches) {
            return null;
        }
        for (var i = 1; i <= 3; ++i) {
            var section = matches[i];
            percents.push(parseInt(section, 16) / 255);
        }
        return percents;
    };
    this.setPageTitle = function (newTitle) {
        if (newTitle && $window.document) {
            $window.document.title = newTitle;
        }
    };
    this.setFavicon = function (newFaviconUrl) {
        if (newFaviconUrl && $window.document) {
            var faviconElem = $window.document.head.querySelector('link[rel=icon]');
            if (faviconElem) {
                faviconElem.href = newFaviconUrl;
            }
            else {
                faviconElem = $window.document.createElement('link');
                faviconElem.rel = 'icon';
                faviconElem.type = 'image/ico';
                faviconElem.href = newFaviconUrl;
                $window.document.head.appendChild(faviconElem);
            }
        }
    };
    this.setPreloaderColor = function (cssColor) {
        if (cssColor) {
            var filterElem = $window.document.body.querySelector('#colorizeProgress > feColorMatrix[type=matrix]');
            if (filterElem) {
                var percents = cssColorToPercent(cssColor);
                if (percents) {
                    filterElem.setAttribute('values', ('0 0 0 0 ' + percents[0] +
                        ' 0 0 0 0 ' + percents[1] +
                        ' 0 0 0 0 ' + percents[2] +
                        ' 0 0 0 1 0'));
                }
                else {
                    console.warn("preloaderColor \"" + cssColor + "\" is not in #RRGGBB format. Skipping...");
                }
            }
        }
    };
    this.setCssVariables = function (cssVars) {
        if (cssVars) {
            var bodyStyles = $window.document.body.style;
            for (var varName in cssVars) {
                if (varName.startsWith('--')) {
                    bodyStyles.setProperty(varName, cssVars[varName]);
                }
                else {
                    console.warn("cssVariables prop \"" + varName + "\" is not a css variable. Skipping...");
                }
            }
        }
    };
    this.initialize = function () {
        _this.setPageTitle(_.get($window, '__wfcConfig.clientTitle'));
        _this.setFavicon(_.get($window, '__wfcConfig.clientFavIcon'));
        _this.setPreloaderColor(_.get($window, '__wfcConfig.preloaderColor'));
        _this.setCssVariables(_.get($window, '__wfcConfig.cssVariables'));
    };
}
angular
    .module('prism-ui.components.data')
    .service('DynamicStyleService', DynamicStyleServiceConstructor);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
//
// ...this is not how to do this...
//
// Leaving it here in case it's holding up half the universe or
// something but should be removed when Remote Upload is working
// and stable.
//
// angular.module('prism-ui.components.data').factory('MediaInfoResourceFactory', function ($window: JS5Object) {
//     return $window.MediaInfo;
// });
var delete_me = function () { };

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2023 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: external-metadata-resource-factory
 */
'use strict';
angular
    .module('prism-ui.components.data')
    .factory('AggregationResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.aggregationEndPoint + '/setup/:id', { id: '@id' }, {
        save: {
            method: 'POST',
            url: EndPointService.aggregationEndPoint + '/setup',
            isArray: false
        },
        update: {
            method: 'PUT',
            url: EndPointService.aggregationEndPoint + '/setup/:id',
            isArray: false
        },
        run: {
            method: 'POST',
            url: EndPointService.aggregationEndPoint + '/setup/:id',
            isArray: true,
            params: {
                filename: '@filename',
            },
            headers: {
                'Content-Type': 'application/xml',
            },
        },
        getTasks: {
            method: 'GET',
            url: EndPointService.aggregationEndPoint + '/tasks',
            isArray: true,
            params: {
                contentId: '@contentId',
                packageId: '@packageId',
                externalSystem: '@externalSystem',
                externalId: '@externalId',
            },
        },
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: watermark-resource-factory
 *
 * Created by randysorensen on 2/15/18.
 */
angular
    .module('prism-ui.components.data')
    .factory('ArtworkResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.artworkEndpoint + "/:containerId", {}, {
        //===============//
        // Container API //
        //===============//
        update: {
            method: 'PUT'
        },
        //===========//
        // Asset API //
        //===========//
        createAsset: {
            method: 'POST',
            url: EndPointService.artworkEndpoint + "/:containerId/assets"
        },
        getAsset: {
            method: 'GET',
            url: EndPointService.artworkEndpoint + "/assets/:assetId"
        },
        updateAsset: {
            method: 'PUT',
            url: EndPointService.artworkEndpoint + "/assets/:assetId"
        },
        deleteAsset: {
            method: 'DELETE',
            url: EndPointService.artworkEndpoint + "/assets/:assetId"
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 4/4/16.
 */
'use strict';
angular.module('prism-ui.components.data').factory('AssetContentTemplatesResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.assetContentTemplatesEndPoint, {
        type: '@type'
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.components.data').factory('CategoriesResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.categoriesEndPoint, {}, {
        createCategory: {
            method: 'POST',
            url: "" + EndPointService.packageCategoriesEndpoint,
            isArray: false
        },
        getAllCategories: {
            method: 'GET',
            url: "" + EndPointService.packageCategoriesEndpoint,
            isArray: true,
        },
        getCategory: {
            method: 'GET',
            url: EndPointService.packageCategoriesEndpoint + "/:id",
            isArray: false,
            id: '@id'
        },
        getCategoryTypes: {
            method: 'GET',
            url: EndPointService.packageEndPoint + "/categoryTypes?view=MINIMAL",
            isArray: true
        },
        updateCategory: {
            method: 'PUT',
            url: "" + EndPointService.packageCategoriesEndpoint,
            isArray: false,
        },
        deleteCategory: {
            method: 'DELETE',
            url: EndPointService.packageCategoriesEndpoint + "/:id",
            isArray: false,
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: collaborators-resource-factory.ts
 *
 * Created by sjacobs on 2/2/18.
 */
'use strict';
angular.module('prism-ui.components.data').factory('CollaboratorsResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.collaboratorsEndPoint, {}, {
        all: {
            method: 'GET',
            fetchOffset: '@fetchOffset',
            fetchLimit: '@fetchLimit',
            searchString: '@searchString',
            includeHidden: '@includeHidden',
            url: EndPointService.collaboratorsEndPoint,
            isArray: true
        },
        byId: {
            method: 'GET',
            params: {
                id: '@id'
            },
            url: EndPointService.collaboratorsEndPoint + "/:id",
            isArray: false
        },
        roles: {
            method: 'GET',
            url: EndPointService.collaboratorsEndPoint + "/:id/roles",
            isArray: true
        },
        getRole: {
            method: 'GET',
            url: EndPointService.collaboratorsEndPoint + "/roles/:id",
            isArray: false
        },
        saveRole: {
            method: 'POST',
            url: EndPointService.collaboratorsEndPoint + "/roles/:id",
            isArray: false
        },
        updateRole: {
            method: 'PUT',
            url: EndPointService.collaboratorsEndPoint + "/roles",
            isArray: false
        },
        deleteRole: {
            method: 'DELETE',
            url: EndPointService.collaboratorsEndPoint + "/roles/:id",
            isArray: false
        },
        save: {
            method: 'POST',
            url: EndPointService.collaboratorsEndPoint,
            isArray: false
        },
        update: {
            method: 'PUT',
            params: {
                id: '@id'
            },
            url: EndPointService.collaboratorsEndPoint + "/:id",
            isArray: false
        },
        delete: {
            method: 'DELETE',
            params: {
                id: '@id'
            },
            url: EndPointService.collaboratorsEndPoint + "/:id",
            isArray: false
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: component-inventory-resource-factory.ts
 *
 * Created by randysorensen on 2019-05-09.
 */
angular.module('prism-ui.components.data').factory('ComponentInventoryResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.componentInventoryEndPoint + "/:packageId/:partnerId", {
        packageId: "@packageId",
        partnerId: "@partnerId",
    }, {
        updateComponentInventory: {
            method: 'PUT',
            url: EndPointService.componentInventoryEndPoint + "/:id",
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: contacts-resource-factory.ts
 *
 * Created by randysorensen on 10/2/17.
 */
'use strict';
angular
    .module('prism-ui.components.data')
    .factory('ContactsResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.contactsEndPoint + '/:contactId', {
        contactId: '@contactId',
        fetchOffset: '@fetchOffset',
        fetchLimit: '@fetchLimit',
        searchString: '@searchString',
        includeHidden: '@includeHidden'
    }, {
        update: {
            method: 'PUT'
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular
    .module('prism-ui.components.data')
    .factory('DeliveryTemplatesResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.deliveryTemplatesEndPoint + '/:deliveryTemplateId', {
        deliveryTemplateId: '@deliveryTemplateId',
        fetchOffset: '@fetchOffset',
        fetchLimit: '@fetchLimit',
        searchString: '@searchString',
        includeHidden: '@includeHidden'
    }, {
        update: {
            method: 'PUT',
            url: EndPointService.deliveryTemplatesEndPoint + "/:id",
            params: {
                id: '@id'
            },
            isArray: false
        },
        clone: {
            method: 'POST',
            url: EndPointService.deliveryTemplatesEndPoint + "/:id",
            params: {
                id: '@id'
            },
            isArray: false
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular
    .module('prism-ui.components.data')
    .factory('DirectoryResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.directoryEndPoint, {}, {
        query: {
            method: 'GET',
            url: EndPointService.directoryEndPoint,
            isArray: true,
            headers: {
                Range: function (request) {
                    var range = request.params.range;
                    delete request.params.range;
                    return range;
                }
            }
        },
        createDirectory: {
            method: 'POST',
            url: EndPointService.directoryEndPoint
        },
        getDirectory: {
            method: 'GET',
            url: EndPointService.directoryEndPoint + "/:id",
            params: { id: '@id' }
        },
        updateDirectory: {
            method: 'PUT',
            url: EndPointService.directoryEndPoint + "/:id",
            params: { id: '@id' }
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular
    .module('prism-ui.components.data')
    .factory('EmailTemplatesResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.emailTemplatesEndPoint + '/:emailTemplateId', {
        emailTemplateId: '@emailTemplateId',
        fetchOffset: '@fetchOffset',
        fetchLimit: '@fetchLimit',
        searchString: '@searchString',
        includeHidden: '@includeHidden'
    }, {
        update: {
            method: 'PUT',
            url: EndPointService.emailTemplatesEndPoint + "/:id",
            params: {
                id: '@id'
            },
            isArray: false
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.components.data').factory('ExternalMetadataLoggingResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.externalMetadataLoggingEndPoint);
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.components.data').factory('ExternalMetadataQueueResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.externalMetadataQueueEndPoint, {}, {
        update: {
            method: 'PUT'
        },
        cancelIngests: {
            method: 'DELETE',
            url: EndPointService.externalMetadataQueueEndPoint
        },
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular
    .module('prism-ui.components.data')
    .factory('FileSystemResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.fileSystemEndPoint, {}, {
        query: {
            method: 'GET',
            url: EndPointService.fileSystemEndPoint,
            isArray: true,
            headers: {
                Range: function (request) {
                    var range = request.params.range;
                    delete request.params.range;
                    return range;
                }
            }
        },
        createFileSystem: {
            method: 'POST',
            url: EndPointService.fileSystemEndPoint
        },
        getFileSystem: {
            method: 'GET',
            url: EndPointService.fileSystemEndPoint + "/:id",
            params: { id: '@id' }
        },
        updateFileSystem: {
            method: 'PUT',
            url: EndPointService.fileSystemEndPoint + "/:id",
            params: { id: '@id' }
        },
        getFileSystemTypes: {
            method: 'GET',
            url: EndPointService.fileSystemEndPoint + "/types",
            isArray: true,
            headers: {
                Range: function (request) {
                    var range = request.params.range;
                    delete request.params.range;
                    return range;
                }
            }
        },
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular
    .module('prism-ui.components.data')
    .factory('GenresResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.genresEndPoint + "/:id", {}, {
        createGenre: {
            method: 'POST',
            url: EndPointService.genresEndPoint
        },
        getGenres: {
            method: 'GET',
            url: EndPointService.genresEndPoint,
            isArray: true
        },
        getGenre: {
            method: 'GET',
            url: EndPointService.genresEndPoint + "/:id"
        },
        updateGenre: {
            method: 'PUT',
            url: EndPointService.genresEndPoint
        },
        deleteGenre: {
            method: 'DELETE',
            url: EndPointService.genresEndPoint + "/:id"
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components.data')
    .factory('InventoryResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.inventoryEndPoint, {}, {
        getAssetUri: {
            method: 'GET',
            url: EndPointService.inventoryEndPoint + "/asset/:id/uri",
            params: {
                assetType: '@assetType',
                contentUse: '@contentUse',
                id: '@id'
            }
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.components.data').factory('LanguageResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.languageEndPoint + "/:id", {
        searchString: '@searchString',
        fetchLimit: '@fetchLimit',
        fetchOffset: '@fetchOffset',
        fetchStart: '@fetchStart',
        includeHidden: '@includeHidden',
    }, {
        createLanguage: {
            method: 'POST',
            url: EndPointService.languageEndPoint,
            isArray: false
        },
        getLanguage: {
            method: 'GET',
            url: EndPointService.languageEndPoint + "/:id",
            isArray: false
        },
        updateLanguage: {
            method: 'PUT',
            url: EndPointService.languageEndPoint,
            isArray: false
        },
        deleteLanguage: {
            method: 'DELETE',
            url: EndPointService.languageEndPoint + "/:id",
            isArray: false
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 4/23/15.
 */
angular.module('prism-ui.components.data').factory('MediaProfileResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.mediaProfileEndPoint, {}, {
        validate: {
            method: 'GET',
            url: EndPointService.mediaProfileEndPoint + "/validate",
            params: {
                path: '@path',
                profileId: '@profileId'
            }
        },
        validateXML: {
            method: 'POST',
            url: EndPointService.mediaProfileEndPoint + "/validate",
            params: {
                profileId: '@profileId'
            }
        },
        validateCCSubtitle: {
            // this is for remote upload timed text
            // validation
            method: 'POST',
            url: EndPointService.mediaProfileEndPoint + "/validate/closedCaption"
        },
        validateClosedCaption: {
            // this is for traditional/repository based
            // text validation
            method: 'GET',
            url: EndPointService.mediaProfileEndPoint + "/validateClosedCaption",
            params: {
                ccPath: '@ccPath',
                videoMediaId: '@videoMediaId',
                videoPath: '@videoPath',
                videoAcceptTemplateMemberId: '@videoAcceptTemplateMemberId',
                textAcceptTemplateId: '@textAcceptTemplateId'
            }
        },
        validatePrePostRoll: {
            method: 'GET',
            url: EndPointService.mediaProfileEndPoint + "/validate/prePostRoll",
            params: {
                path: '@path',
                profileId: '@profileId'
            }
        },
        validateVideoComponents: {
            method: 'POST',
            url: EndPointService.mediaProfileEndPoint + "/validate/videoComponent"
        },
        validateAdPod: {
            method: 'POST',
            url: EndPointService.mediaProfileEndPoint + "/validate/adPod"
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.components.data').factory('PackageAcceptTemplatesResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.packageAcceptTemplatesEndPoint + "/:id", {
        includeHidden: '@includeHidden',
        view: '@view'
    }, {
        createPackageAcceptTemplate: {
            method: 'POST'
        },
        updatePackageAcceptTemplate: {
            method: 'PUT'
        },
        deletePackageAcceptTemplate: {
            method: 'DELETE'
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: packageCreationTemplates-resource-factory
 *
 * Created by sjacobs on 3/16/18.
 */
angular
    .module('prism-ui.components.data')
    .factory('PackageCreationTemplatesResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.packageCreationTemplatesEndpoint + '/:id', {
        id: '@id',
        fetchOffset: '@fetchOffset',
        fetchLimit: '@fetchLimit',
        searchString: '@searchString',
        includeHidden: '@includeHidden'
    }, {
        getPackageCreationTemplate: {
            method: 'GET',
            params: {
                id: '@id'
            },
            url: EndPointService.packageCreationTemplatesEndpoint + "/:id",
            isArray: false
        },
        createPackageCreationTemplate: {
            method: 'POST',
            url: "" + EndPointService.packageCreationTemplatesEndpoint,
            isArray: false
        },
        updatePackageCreationTemplate: {
            method: 'PUT',
            url: "" + EndPointService.packageCreationTemplatesEndpoint,
            isArray: false
        },
        deletePackageCreationTemplate: {
            method: 'DELETE',
            params: {
                id: '@id'
            },
            url: EndPointService.packageCreationTemplatesEndpoint + "/:id",
            isArray: false
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: package-notifications-resource-factory.ts
 *
 * Created by randysorensen on 4/9/18.
 */
angular
    .module('prism-ui.components.data')
    .factory('PackageNotificationsResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.packageStatusNotificationsEndPoint + '/:notificationId', {
        notificationId: '@notificationId'
    }, {
        update: {
            method: 'PUT'
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.components.data').factory('RatingsResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.ratingsEndPoint, {}, {
        getRatingSystems: {
            method: 'GET',
            url: EndPointService.ratingsEndPoint + "/systems",
            isArray: true
        },
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.components.data').factory('ReachPermissionsResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.reachPermissionsEndpoint, { uuid: '@uuid' }, {
        createPermission: {
            method: 'POST',
            url: EndPointService.reachPermissionsEndpoint,
            isArray: false
        },
        getPermission: {
            method: 'GET',
            url: EndPointService.reachPermissionsEndpoint + '/:uuid',
            isArray: false
        },
        updatePermission: {
            method: 'PUT',
            url: EndPointService.reachPermissionsEndpoint + '/:uuid',
            isArray: false
        },
        deletePermission: {
            method: 'DELETE',
            url: EndPointService.reachPermissionsEndpoint + '/:uuid',
            isArray: false
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.components.data')
    .factory('RolesResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.roleEndPoint + "/:roleId", {
        roleId: '@roleId',
        fetchOffset: '@fetchOffset',
        fetchLimit: '@fetchLimit',
        searchString: '@searchString',
        includeHidden: '@includeHidden',
    }, {
        'update': { method: 'PUT' }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.components.data')
    .factory('SamlResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.samlEndPoint, {}, {
        isSamlEnabled: {
            method: 'GET',
            url: EndPointService.samlEndPoint,
            params: { isSamlEnabled: true },
            isArray: false,
            transformResponse: function (data) {
                return {
                    isSamlEnabled: "" + data === 'true'
                };
            }
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.components.data').factory('SecurityRolesResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.securityRolesEndPoint, { id: '@id' }, {
        createRole: {
            method: 'POST',
            url: EndPointService.securityRolesEndPoint,
            isArray: false
        },
        getRole: {
            method: 'GET',
            url: EndPointService.securityRolesEndPoint + '/:id',
            isArray: false
        },
        updateRole: {
            method: 'PUT',
            url: EndPointService.securityRolesEndPoint + '/:id',
            isArray: false
        },
        deleteRole: {
            method: 'DELETE',
            url: EndPointService.securityRolesEndPoint + '/:id',
            isArray: false
        },
        getRolePermissions: {
            method: 'GET',
            url: EndPointService.securityRolesEndPoint + '/:id/permissions',
            params: { id: '@id' },
            isArray: false
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2022 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: server-info-resource-factory
 *
 * Created by kyang on 10/21/22.
 */
angular
    .module('prism-ui.components.data')
    .factory('ServerInfoResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.serverInfoEndpoint, {}, {
        get: {
            method: 'GET',
            isArray: false
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: temporary-file-upload-resource-factory
 *
 * Created by kyang on 3/1/21.
 */
angular
    .module('prism-ui.components.data')
    .factory('TemporaryFileUploadResourceFactory', function ($resource, EndPointService) {
    return $resource("" + EndPointService.temporaryFileUploadEndpoint, {}, {
        getConfiguration: {
            method: 'GET',
            url: EndPointService.temporaryFileUploadEndpoint + "/configuration",
            params: {
                name: '@name',
                destinationPath: '@destinationPath',
            }
        },
        getTemporaryUploadCredentials: {
            method: 'GET',
            url: EndPointService.temporaryFileUploadEndpoint + "/upload-credentials",
            params: {
                name: '@name',
                destinationPath: '@destinationPath',
            }
        },
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: territories-resource-factory
 *
 * Created by sjacobs on 3/16/18.
 */
angular
    .module('prism-ui.components.data')
    .factory('TerritoriesResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.territoriesEndpoint + '/:id', {
        id: '@id',
        fetchOffset: '@fetchOffset',
        fetchLimit: '@fetchLimit',
        searchString: '@searchString',
        includeHidden: '@includeHidden'
    }, {
        getTerritory: {
            method: 'GET',
            params: {
                id: '@id'
            },
            url: EndPointService.territoriesEndpoint + "/:id",
            isArray: false
        },
        createTerritory: {
            method: 'POST',
            url: "" + EndPointService.territoriesEndpoint,
            isArray: false
        },
        updateTerritory: {
            method: 'PUT',
            url: "" + EndPointService.territoriesEndpoint,
            isArray: false
        },
        deleteTerritory: {
            method: 'DELETE',
            params: {
                id: '@id'
            },
            url: EndPointService.territoriesEndpoint + "/:id",
            isArray: false
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.components.data').factory('UsersResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.userEndPoint, {
        id: '@id'
    }, {
        query: {
            method: 'GET',
            headers: { 'api-version': '2.0' },
            params: {
                fetchOffset: '@fetchOffset',
                fetchLimit: '@fetchLimit',
                filter: '@filter'
            },
            isArray: true,
        },
        createUser: {
            method: 'POST',
            url: EndPointService.userEndPoint,
            headers: { 'api-version': '2.0' },
            isArray: false
        },
        getUser: {
            method: 'GET',
            url: EndPointService.userEndPoint + '/:id',
            headers: { 'api-version': '2.0' },
            isArray: false
        },
        getCurrentUser: {
            method: 'GET',
            url: EndPointService.userEndPoint + '/current',
            headers: { 'api-version': '2.0' },
            isArray: false
        },
        updateUser: {
            method: 'PUT',
            url: EndPointService.userEndPoint + '/:id',
            headers: { 'api-version': '2.0' },
            isArray: false
        },
        deleteUser: {
            method: 'DELETE',
            url: EndPointService.userEndPoint + '/:id',
            headers: { 'api-version': '2.0' },
            isArray: false
        },
        getUserRoles: {
            method: 'GET',
            url: EndPointService.userEndPoint + '/:id/roles',
            headers: { 'api-version': '2.0' },
            isArray: true
        },
        addUserRole: {
            method: 'POST',
            url: EndPointService.userEndPoint + '/:id/roles/:roleId',
            headers: { 'api-version': '2.0' },
            params: {
                roleId: '@roleId'
            },
            isArray: false
        },
        removeUserRole: {
            method: 'DELETE',
            url: EndPointService.userEndPoint + '/:id/roles/:roleId',
            headers: { 'api-version': '2.0' },
            params: {
                roleId: '@roleId'
            },
            isArray: false
        },
        getPasswordRequirements: {
            method: 'GET',
            url: EndPointService.userEndPoint + "/password",
            headers: { 'api-version': '2.0' },
            isArray: false
        },
        updatePassword: {
            method: 'PUT',
            url: EndPointService.userEndPoint + "/password",
            headers: { 'api-version': '2.0' },
            isArray: false
        },
        sendResetPasswordEmail: {
            method: 'PUT',
            url: EndPointService.userEndPoint + "/:id/password",
            headers: { 'api-version': '2.0' },
            isArray: false
        },
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: watermark-resource-factory
 *
 * Created by randysorensen on 2/15/18.
 */
angular
    .module('prism-ui.components.data')
    .factory('WatermarkResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.watermarkEndpoint + "/:containerId", {}, {
        //===============//
        // Container API //
        //===============//
        update: {
            method: 'PUT'
        },
        //===========//
        // Asset API //
        //===========//
        createAsset: {
            method: 'POST',
            url: EndPointService.watermarkEndpoint + "/:containerId/assets"
        },
        getAsset: {
            method: 'GET',
            url: EndPointService.watermarkEndpoint + "/assets/:assetId"
        },
        updateAsset: {
            method: 'PUT',
            url: EndPointService.watermarkEndpoint + "/assets/:assetId"
        },
        deleteAsset: {
            method: 'DELETE',
            url: EndPointService.watermarkEndpoint + "/assets/:assetId"
        }
    });
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: aspera-file-select-service.ts
 */
// This service is an implementation for FileSelectService.
// Components should invoke the abstract FileSelectService, not this specific implementation.
angular.module('prism-ui.components').service('AsperaFileSelectService', function (_, $q, AsperaConnectService, FileSelectService, ModalService) {
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.initialize = function (fileSelectConfig) {
        // Nothing to initialize
    };
    var unregisterCurrentAsperaFiles = function (fileSelectConfig) {
        _.forEach(fileSelectConfig.currentAsperaFileObjects, function (asperaFileObject) {
            AsperaConnectService.unregisterFile(asperaFileObject);
        });
        fileSelectConfig.currentAsperaFileObjects = null;
    };
    this.onFileChanged = function (fileSelectConfig, newFileValue) {
        if (_.get(newFileValue, 'type') !== 'ASPERA') {
            unregisterCurrentAsperaFiles(fileSelectConfig);
        }
    };
    this.cleanup = function (fileSelectConfig) {
        unregisterCurrentAsperaFiles(fileSelectConfig);
    };
    //========================//
    // Aspera File Validation //
    //========================//
    this.promptFile = function (fileSelectConfig, asperaFileObjects) {
        unregisterCurrentAsperaFiles(fileSelectConfig);
        if (!fileSelectConfig.isMultiSelect) {
            asperaFileObjects = asperaFileObjects.slice(0, 1);
        }
        FileSelectService.startValidation(fileSelectConfig, 'ASPERA', asperaFileObjects);
        var validationPromises = asperaFileObjects.map(function (asperaFileObject) {
            return fileSelectConfig.validateAsperaFile({
                asperaFileObject: asperaFileObject,
            });
        });
        return FileSelectService.waitForValidation(fileSelectConfig, $q.all(validationPromises), function (validationResults) {
            onValidationResolved(fileSelectConfig, asperaFileObjects, validationResults);
        }, function (rejectedValue) {
            onValidationFailed(fileSelectConfig, asperaFileObjects, rejectedValue);
        });
    };
    var onValidationResolved = function (fileSelectConfig, asperaFileObjects, validationResults) {
        var hasErrors = false;
        var hasWarnings = false;
        var flattenedResults = _.flatten(validationResults);
        _.forEach(flattenedResults, function (validationResult) {
            hasErrors = hasErrors || !_.isEmpty(validationResult.errors);
            hasWarnings = hasWarnings || !_.isEmpty(validationResult.warnings);
        });
        if (hasErrors || hasWarnings) {
            onValidationFailed(fileSelectConfig, asperaFileObjects, validationResults);
            if (fileSelectConfig.canShowValidationErrorModal()) {
                ModalService.showAssetValidationResultsModal(flattenedResults, !hasErrors, function () {
                    onValidationCompleted(fileSelectConfig, asperaFileObjects, validationResults);
                });
            }
        }
        else {
            onValidationCompleted(fileSelectConfig, asperaFileObjects, validationResults);
        }
    };
    var onValidationCompleted = function (fileSelectConfig, asperaFileObjects, validationResults) {
        fileSelectConfig.currentAsperaFileObjects = _.clone(asperaFileObjects);
        _.forEach(asperaFileObjects, function (asperaFileObject) {
            AsperaConnectService.registerFileForUpload(asperaFileObject);
        });
        FileSelectService.completeValidation(fileSelectConfig, 'ASPERA', asperaFileObjects, validationResults);
    };
    var onValidationFailed = function (fileSelectConfig, asperaFileObjects, results) {
        FileSelectService.failValidation(fileSelectConfig, 'ASPERA', asperaFileObjects, results);
    };
});
//=================//
// Lifecycle Hooks //
//=================//
// Load this service when app is initialized
angular.module('prism-ui.components').run(function (FileSelectService, AsperaFileSelectService) {
    FileSelectService.registerFileSelectServiceImplementation('ASPERA', AsperaFileSelectService);
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: file-select-service.ts
 */
// This service is an interface for all the file-select implementation services.
angular.module('prism-ui.components').service('FileSelectService', function (_, $q, Rx) {
    var _this = this;
    var FileValidationStatus;
    (function (FileValidationStatus) {
        FileValidationStatus["NONE"] = "NONE";
        FileValidationStatus["RUNNING"] = "RUNNING";
        FileValidationStatus["PASSED"] = "PASSED";
        FileValidationStatus["FAILED"] = "FAILED";
    })(FileValidationStatus || (FileValidationStatus = {}));
    //========================//
    // Abstract Functionality //
    //========================//
    var fileSelectServiceImplementations = {};
    this.registerFileSelectServiceImplementation = function (fileSourceType, service) {
        if (_.has(fileSelectServiceImplementations, fileSourceType)) {
            console.warn("Replacing previous FileSelectService implementation for file source type: " + fileSourceType);
        }
        fileSelectServiceImplementations[fileSourceType] = service;
    };
    this.getFileSelectServiceImplementation = function (fileSourceType) {
        return fileSelectServiceImplementations[fileSourceType];
    };
    //====================================//
    // Abstract File Select Functionality //
    //====================================//
    this.initialize = function (fileSelectConfig) {
        _.forEach(fileSelectServiceImplementations, function (fileSelectServiceImplementation) {
            fileSelectServiceImplementation.initialize(fileSelectConfig);
        });
    };
    this.promptFile = function (fileSelectConfig, fileSourceType, options) {
        return _this.getFileSelectServiceImplementation(fileSourceType)
            .promptFile(fileSelectConfig, options);
    };
    this.onFileChanged = function (fileSelectConfig, newFileValue) {
        _.forEach(fileSelectServiceImplementations, function (fileSelectServiceImplementation) {
            fileSelectServiceImplementation.onFileChanged(fileSelectConfig, newFileValue);
        });
    };
    this.cleanup = function (fileSelectConfig) {
        _.forEach(fileSelectServiceImplementations, function (fileSelectServiceImplementation) {
            fileSelectServiceImplementation.cleanup(fileSelectConfig);
        });
    };
    //========================//
    // Shared Implementations //
    //========================//
    var setFileValue = function (fileSelectConfig, fileSourceType, files, results, status) {
        var newFileValue = {
            type: fileSourceType,
            files: files,
            status: status,
        };
        if (results) {
            newFileValue.results = results;
        }
        fileSelectConfig.ngModelCtrl.$setViewValue(newFileValue);
        _this.onFileChanged(fileSelectConfig, newFileValue);
    };
    this.startValidation = function (fileSelectConfig, fileSourceType, files) {
        setFileValue(fileSelectConfig, fileSourceType, files, undefined, FileValidationStatus.RUNNING);
    };
    this.completeValidation = function (fileSelectConfig, fileSourceType, files, results) {
        setFileValue(fileSelectConfig, fileSourceType, files, results, FileValidationStatus.PASSED);
    };
    this.failValidation = function (fileSelectConfig, fileSourceType, files, results) {
        setFileValue(fileSelectConfig, fileSourceType, files, results, FileValidationStatus.FAILED);
    };
    // Listen to promise and call onResolved / onReject.
    // However, don't invoke if file is changed.
    // Returns a promise that completes when any of these happen:
    //     - onResolved is called
    //     - onReject is called
    //     - File is changed (aka: validation is cancelled)
    this.waitForValidation = function (fileSelectConfig, validationPromise, onResolvedFunc, onRejectFunc) {
        var deferred = $q.defer();
        var validationObservable = Rx.Observable
            .fromPromise(validationPromise, Rx.Scheduler.immediate)
            .takeUntil(fileSelectConfig.fileReplacedObservable);
        validationObservable.subscribe(onResolvedFunc, function (rejectedValue) {
            onRejectFunc(rejectedValue);
            deferred.resolve();
        }, function () {
            deferred.resolve();
        });
        return deferred.promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: local-file-select-service.ts
 */
// This service is an implementation for FileSelectService.
// Components should invoke the abstract FileSelectService, not this specific implementation.
angular.module('prism-ui.components').service('LocalFileSelectService', function (_, $injector, $q, FileSelectService, ModalService, UtilsService) {
    //=================//
    // Lifecycle Hooks //
    //=================//
    var addLocalFileFilters = function (fileSelectConfig, fileUploader) {
        fileSelectConfig.localFilesToTryAdding = [];
        var fileExtensionFilter = {
            name: 'fileTypeFilter',
            errorDescription: ''
        };
        fileUploader.filters.splice(0, 0, {
            name: 'fileAddAttemptCounter',
            fn: function () {
                fileSelectConfig.localFilesToTryAdding.shift();
                return true;
            }
        });
        fileExtensionFilter.fn = function (file, options) {
            var fileExtensions = _.map(fileSelectConfig.getFileExtensions(), _.toLower);
            // TODO: AB#88420 Merge w/ select-asset-modal & aspera filter or remove completely
            // "this is ridiculous". Add other alias for these file types
            if (_.includes(fileExtensions, 'aif')) {
                fileExtensions.push('aiff');
            }
            if (_.includes(fileExtensions, 'jpg')) {
                fileExtensions.push('jpeg');
            }
            fileExtensionFilter.errorDescription = "File Type did not match [" + UtilsService.filtersToPrettyString(fileExtensions) + "]";
            var fileTypeRegex = UtilsService.buildFilters(fileExtensions);
            var searchStr;
            if (fileSelectConfig.validateLocalMimeTypes) {
                searchStr = "." + file.type.slice(file.type.lastIndexOf('/') + 1);
            }
            else {
                searchStr = file.name.slice(file.name.lastIndexOf('.'));
            }
            return fileTypeRegex.test(searchStr);
        };
        fileSelectConfig.localFileExtensionFilter = fileExtensionFilter;
        fileUploader.filters.push(fileSelectConfig.localFileExtensionFilter);
    };
    this.initialize = function (fileSelectConfig) {
        // If FileUploader is added to service constructor params,
        // many unit tests fail because "FileUploaderProvider" doesn't exist.
        // Minimize unit test breakage by getting FileUploder during run-time instead.
        var FileUploaderConstructor = $injector.get('FileUploader');
        var fileUploader = new FileUploaderConstructor();
        addLocalFileFilters(fileSelectConfig, fileUploader);
        fileSelectConfig.localFileUploaderConfig = fileUploader;
        fileSelectConfig.localFileDropZoneOptions = {
            openLocalWarningsPrompt: true,
        };
        fileSelectConfig.initializeUploaderConfig({ fileUploaderConfig: fileUploader });
        fileUploader.onAfterAddingFile = function (fileItem) {
            onLocalFileAdded(fileSelectConfig, fileItem);
        };
        fileUploader.onWhenAddingFileFailed = function (file, filter) {
            onLocalFileAddFailed(fileSelectConfig, file, filter);
        };
        var origAddToQueueFunc = fileUploader.addToQueue;
        fileUploader.addToQueue = function (files, options, filters) {
            var startPromise;
            if (_.get(options, 'openLocalWarningsPrompt')) {
                startPromise = fileSelectConfig.openWarningsPrompt();
            }
            else {
                startPromise = $q.when(true);
            }
            startPromise.then(function (canValidate) {
                if (canValidate) {
                    fileSelectConfig.localFilesToTryAdding = fileUploader.isArrayLikeObject(files) ? Array.prototype.slice.call(files) : [files];
                    fileSelectConfig.localFileAddErrors = [];
                    fileUploader.clearQueue();
                    origAddToQueueFunc.call(fileUploader, files, options, filters);
                }
            });
        };
    };
    var clearLocalFileValue = function (fileSelectConfig) {
        fileSelectConfig.$element.find('input').val(null);
        if (fileSelectConfig.localFileUploaderConfig) {
            fileSelectConfig.localFileUploaderConfig.clearQueue();
        }
    };
    this.onFileChanged = function (fileSelectConfig, newFileValue) {
        if (_.get(newFileValue, 'type') !== 'LOCAL') {
            clearLocalFileValue(fileSelectConfig);
        }
    };
    this.cleanup = function (fileSelectConfig) {
        // Nothing to clean up
    };
    //=======================//
    // Local File Validation //
    //=======================//
    this.promptFile = function (fileSelectConfig, options) {
        var fileInput;
        if (fileSelectConfig.isMultiSelect) {
            fileInput = fileSelectConfig.$element.find('input.localUploadInputMultiple')[0];
        }
        else {
            fileInput = fileSelectConfig.$element.find('input.localUploadInputSingle')[0];
        }
        clearLocalFileValue(fileSelectConfig);
        fileInput.click();
    };
    var onLocalFileAddFailed = function (fileSelectConfig, file, filter) {
        var errors;
        if (filter === fileSelectConfig.localFileExtensionFilter) {
            errors = {
                source: file.name,
                errors: [{
                        description: filter.errorDescription,
                        severity: 'ERROR'
                    }],
                warnings: []
            };
        }
        else {
            errors = fileSelectConfig.getLocalFilePreValidationErrors({ file: file, filter: filter });
        }
        fileSelectConfig.localFileAddErrors.push(errors);
        if (_.isEmpty(fileSelectConfig.localFilesToTryAdding)) {
            onAfterAddingAllAttempts(fileSelectConfig);
        }
    };
    var onLocalFileAdded = function (fileSelectConfig, fileItem) {
        var queueIndex = fileSelectConfig.localFileUploaderConfig.getIndexOfItem(fileItem);
        if (!fileSelectConfig.isMultiSelect && queueIndex !== 0) {
            fileSelectConfig.localFileUploaderConfig.removeFromQueue(queueIndex);
        }
        if (_.isEmpty(fileSelectConfig.localFilesToTryAdding)) {
            onAfterAddingAllAttempts(fileSelectConfig);
        }
    };
    var onAfterAddingAllAttempts = function (fileSelectConfig) {
        if (!_.isEmpty(fileSelectConfig.localFileAddErrors)) {
            clearLocalFileValue(fileSelectConfig);
            // ngModel value is not updated, so other components can't detect the error.
            // So, always display this modal.
            ModalService.showAssetValidationResultsModal(fileSelectConfig.localFileAddErrors, false);
            return;
        }
        var fileItems = fileSelectConfig.localFileUploaderConfig.getNotUploadedItems();
        FileSelectService.startValidation(fileSelectConfig, 'LOCAL', fileItems);
        var validationPromises = fileItems.map(function (fileItem) {
            return fileSelectConfig.validateLocalFile({
                fileItem: fileItem,
                fileUploaderConfig: fileSelectConfig.localFileUploaderConfig
            });
        });
        FileSelectService.waitForValidation(fileSelectConfig, $q.all(validationPromises), function (validationResults) {
            onValidationResolved(fileSelectConfig, fileItems, validationResults);
        }, function (rejectedValue) {
            onValidationFailed(fileSelectConfig, fileItems, rejectedValue);
        });
    };
    var onValidationResolved = function (fileSelectConfig, fileItems, validationResults) {
        var hasErrors = false;
        var hasWarnings = false;
        var flattenedResults = _.flatten(validationResults);
        _.forEach(flattenedResults, function (validationResult) {
            hasErrors = hasErrors || !_.isEmpty(validationResult.errors);
            hasWarnings = hasWarnings || !_.isEmpty(validationResult.warnings);
        });
        if (hasErrors || hasWarnings) {
            onValidationFailed(fileSelectConfig, fileItems, validationResults);
            if (fileSelectConfig.canShowValidationErrorModal()) {
                ModalService.showAssetValidationResultsModal(flattenedResults, !hasErrors, function () {
                    onValidationCompleted(fileSelectConfig, fileItems, validationResults);
                });
            }
        }
        else {
            onValidationCompleted(fileSelectConfig, fileItems, validationResults);
        }
    };
    var onValidationCompleted = function (fileSelectConfig, fileItems, validationResults) {
        FileSelectService.completeValidation(fileSelectConfig, 'LOCAL', fileItems, validationResults);
    };
    var onValidationFailed = function (fileSelectConfig, fileItems, results) {
        FileSelectService.failValidation(fileSelectConfig, 'LOCAL', fileItems, results);
    };
});
//=================//
// Lifecycle Hooks //
//=================//
// Load this service when app is initialized
angular.module('prism-ui.components').run(function (FileSelectService, LocalFileSelectService) {
    FileSelectService.registerFileSelectServiceImplementation('LOCAL', LocalFileSelectService);
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: remote-file-select-service.ts
 */
// This service is an implementation for FileSelectService.
// Components should invoke the abstract FileSelectService, not this specific implementation.
angular.module('prism-ui.components').service('RemoteFileSelectService', function (_, FileSelectService, ModalService) {
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.initialize = function (fileSelectConfig) {
        // Nothing to initialize
    };
    this.onFileChanged = function (fileSelectConfig, newFileValue) {
        // No response needed
    };
    this.cleanup = function (fileSelectConfig) {
        // Nothing to clean up
    };
    //========================//
    // Remote File Validation //
    //========================//
    this.promptFile = function (fileSelectConfig, options) {
        var fileExtensions = fileSelectConfig.getFileExtensions();
        ModalService.showFileSelectionModal(fileExtensions, function (virtualPath) {
            onValidRemoteFileSelected(fileSelectConfig, virtualPath);
        }, function (fileSystemItem) {
            return fileSelectConfig.validateRemoteFile({ fileSystemItem: fileSystemItem });
        });
    };
    var onValidRemoteFileSelected = function (fileSelectConfig, virtualPath) {
        FileSelectService.completeValidation(fileSelectConfig, 'REMOTE', [{ virtualPath: virtualPath }], [{
                source: virtualPath,
                errors: [],
                warnings: []
            }]);
    };
});
//=================//
// Lifecycle Hooks //
//=================//
// Load this service when app is initialized
angular.module('prism-ui.components').run(function (FileSelectService, RemoteFileSelectService) {
    FileSelectService.registerFileSelectServiceImplementation('REMOTE', RemoteFileSelectService);
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 6/11/15,
 * Converted to TypeScript by kyang on 8/7/2019
 */
function CustomMetadataComponent(_) {
    var _this = this;
    var prevComponentsMap;
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$doCheck = function () {
        if (prevComponentsMap !== _this.componentsMap) {
            _this.orderedComponents = _.sortBy(_this.componentsMap, function (componentDef) {
                return parseInt(componentDef.displayIndex);
            });
            prevComponentsMap = _this.componentsMap;
        }
    };
    this.$onInit = function () {
        _this.orderedComponents = _this.orderedComponents || [];
    };
}
angular.module('prism-ui.components').component('customMetadata', {
    templateUrl: 'components/form/customMetadata/custom-metadata-template.html',
    controller: CustomMetadataComponent,
    bindings: {
        componentsMap: '=',
        componentStyleOverrides: '=',
        disableComponents: '=',
        idPrefix: '@',
        ignorePreferredWidth: '=',
        labelColSize: '@',
        onUpdate: '&',
        revision: '=',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: default-artwork-maps-grid-component.ts
 *
 * Created by kyang on 2019-04-29.
 */
function DefaultMapsGridController(_, $q, $scope, uiGridConstants) {
    //======//
    // Grid //
    //======//
    var _this = this;
    var gridOptionsReadyDeferred = $q.defer();
    var gridApiReadyDeferred = $q.defer();
    var gridOptionsReadyPromise = gridOptionsReadyDeferred.promise;
    var gridApiReadyPromise = gridApiReadyDeferred.promise;
    //
    // This promise will resolve when the grid is ready for data
    // and API calls.
    //
    var gridReadyPromise = $q.all([
        gridOptionsReadyPromise,
        gridApiReadyPromise
    ]);
    var dropdownSortByName = function (a, b) {
        return _.toLower(_.get(a, 'name')).localeCompare(_.toLower(_.get(b, 'name')));
    };
    var colDefs = [
        {
            cellTemplate: 'components/visual/grid/check-mark-template.html',
            enableColumnMenu: false,
            enableSorting: false,
            enableColumnResizing: false,
            field: 'checkMark',
            fieldName: 'Selection',
            headerCellTemplate: 'components/grids/default-artwork-maps-grid/cell-templates/header-check-mark-row-count-template.html',
            width: 55,
        },
        {
            cellTemplate: 'components/grids/default-artwork-maps-grid/cell-templates/artwork-accept-profile-cell-template.html',
            enableColumnMenu: false,
            enableSorting: true,
            field: 'artworkAcceptProfile',
            displayName: 'MAPs',
            sort: {
                direction: uiGridConstants.ASC,
                priority: 1
            },
            sortable: true,
            sortingAlgorithm: dropdownSortByName,
            width: 455,
        },
        {
            cellTemplate: 'components/grids/default-artwork-maps-grid/cell-templates/category-type-cell-template.html',
            enableColumnMenu: false,
            enableSorting: false,
            field: 'artworkAcceptProfile',
            displayName: 'Category Type',
            width: 200,
        }
    ];
    this.gridOptions = {
        selectionRowHeaderColName: 'Selection',
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: false,
        enablePaginationControls: false,
        enableFullRowSelection: true,
        enableSorting: true,
        rowHeight: 26,
        multiSelect: true,
        minRowsToShow: 7,
        columnDefs: colDefs,
        data: [],
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            gridApiReadyDeferred.resolve(true);
        }
    };
    this.areAllRowsSelected = function () {
        return _this.gridApi.selection.getSelectedCount() >= _this.gridOptions.data.length;
    };
    this.onSelectAllToggled = function ($event) {
        if (_this.areAllRowsSelected()) {
            _this.gridApi.selection.clearSelectedRows($event);
        }
        else {
            _this.gridApi.selection.selectAllRows($event);
        }
    };
    //=======================//
    // Grid Row Manipulation //
    //=======================//
    this.addDefaultMap = function () {
        _this.gridOptions.data.push({
            acceptProfile: null,
            packageCategoryType: _.find(_this.categoryTypes, { name: 'Both' })
        });
        _this.onArtworkAcceptProfilesChanged({ validAcceptProfiles: null });
    };
    this.removeDefaultMaps = function () {
        var selectedRows = _this.gridApi.selection.getSelectedRows();
        if (selectedRows.length > 0) {
            _.pullAll(_this.gridOptions.data, selectedRows);
            _this.gridApi.selection.clearSelectedRows();
        }
        _this.onArtworkAcceptProfilesChanged({ validAcceptProfiles: getValidAcceptProfiles() });
    };
    //================//
    // Template Logic //
    //================//
    this.onArtworkRowChanged = function (rowEntity) {
        _this.onArtworkAcceptProfilesChanged({ validAcceptProfiles: getValidAcceptProfiles() });
    };
    var isValid = function () {
        var profileIdsFound = {};
        return _.every(_this.gridOptions.data, function (rowEntity) {
            // Each profile can only be added once
            var profileId = _.get(rowEntity, 'acceptProfile.id');
            if (profileIdsFound[profileId]) {
                return false;
            }
            profileIdsFound[profileId] = true;
            return !!rowEntity.acceptProfile;
        });
    };
    var getValidAcceptProfiles = function () {
        if (isValid()) {
            return _this.gridOptions.data;
        }
        else {
            return null;
        }
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onChanges = function () {
        gridReadyPromise.then(function () {
            _.invoke(_this.gridApi, 'selection.clearSelectedRows');
            _this.gridOptions.data = _this.initialArtworkAcceptProfiles || [];
        });
    };
    this.availableArtworkAcceptProfiles = [];
    this.gridApi = null;
    this.$onInit = function () {
        gridOptionsReadyDeferred.resolve(true);
    };
}
angular.module('prism-ui.components').component('defaultMapsGrid', {
    bindings: {
        onArtworkAcceptProfilesChanged: '&',
        categoryTypes: '<',
        availableArtworkAcceptProfiles: '<',
        initialArtworkAcceptProfiles: '<'
    },
    controller: DefaultMapsGridController,
    templateUrl: 'components/grids/default-artwork-maps-grid/default-artwork-maps-grid-template.html'
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: partner-email-endpoints-searchview-component.ts
 *
 * Created by randysorensen on 10/2/17.
 */
'use strict';
function ContactsSelectModalController(_, uiGridConstants, ContactsService) {
    var _this = this;
    var enabledHeaderTemplate = 'components/visual/grid/header-check-mark-component-template.html';
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.searchText = '';
        _this.existingContactIds = _this.resolve.existingContactIds;
        ContactsService
            .getContactsList()
            .then(function (contacts) {
            // Remove contacts that are specified in
            // this.resolve.existingContacts
            _.remove(contacts, function (contact) {
                return _.includes(_this.resolve.existingContactIds, contact.id);
            });
            _this.contactsGridOptions.data = contacts;
        });
    };
    //===============//
    // Contacts Grid //
    //===============//
    var contactsGridColDefs = [
        {
            name: 'checkMarkRowHeaderCol',
            field: 'checkMark',
            width: 30,
            enableColumnMenu: false,
            enableSorting: false,
            enableColumnResizing: false,
            headerCellTemplate: enabledHeaderTemplate,
            cellTemplate: 'components/visual/grid/check-mark-template.html'
        },
        {
            field: 'firstName',
            type: 'string',
            width: '25%',
            sort: {
                direction: uiGridConstants.ASC,
                priority: 2
            },
            displayName: 'First Name',
        },
        {
            field: 'lastName',
            type: 'string',
            width: '25%',
            sort: {
                direction: uiGridConstants.ASC,
                priority: 1
            },
            displayName: 'Last Name',
        },
        {
            field: 'emailAddress',
            type: 'string',
            width: '*',
            sort: {
                direction: uiGridConstants.ASC,
                priority: 3
            },
            displayName: 'Email Address',
        },
    ];
    this.contactsGridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        multiSelect: true,
        columnDefs: contactsGridColDefs,
        onRegisterApi: function (gridApi) {
            _this.contactsGridApi = gridApi;
            _this.contactsGridApi.grid.registerRowsProcessor(processGridFilter, 200);
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        data: []
    };
    var processGridFilter = function (renderableRows) {
        _.forEach(renderableRows, function (row) {
            if (_this.searchText === null || _this.searchText === '') {
                row.visible = true;
            }
            else {
                var criteria = _this.searchText.toLowerCase();
                row.visible =
                    row.entity.firstName && row.entity.firstName.toLowerCase().indexOf(criteria) !== -1 ||
                        row.entity.lastName && row.entity.lastName.toLowerCase().indexOf(criteria) !== -1 ||
                        row.entity.emailAddress && row.entity.emailAddress.toLowerCase().indexOf(criteria) !== -1;
            }
        });
        return renderableRows;
    };
    this.executeSearch = function (searchText) {
        _this.searchText = searchText;
        _this.contactsGridApi.grid.refresh();
    };
    this.onSelectAllToggled = function ($event) {
        if (_this.contactsGridApi.selection.getSelectAllState()) {
            _this.contactsGridApi.selection.clearSelectedRows();
        }
        else {
            _this.contactsGridApi.selection.selectAllVisibleRows();
        }
    };
    //================//
    // Template Logic //
    //================//
    this.getSelectedCount = function () {
        return (_this.contactsGridApi &&
            _this.contactsGridApi.selection &&
            _this.contactsGridApi.selection.getSelectedCount());
    };
    this.onOk = function () {
        _this.close({
            $value: _this.contactsGridApi.selection.getSelectedRows()
        });
    };
}
angular
    .module('prism-ui.components')
    .component('contactsSelectModal', {
    controller: ContactsSelectModalController,
    templateUrl: 'components/modal/contactsSelectModal/contacts-select-modal-template.html',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: serviceable-languages-grid-component.ts
 *
 * Created by randysorensen on 2019-04-12.
 */
function ServiceableLanguagesGridController(_, $attrs, $q, $scope) {
    var _this = this;
    var rowColumns = [
        { fieldProperty: 'cCEnabled', label: 'CC' },
        { fieldProperty: 'subtitleEnabled', label: 'Subtitle' },
        { fieldProperty: 'audioEnabled', label: 'Audio Sidecar' },
        { fieldProperty: 'artworkEnabled', label: 'Artwork' },
    ];
    var getRowFields = function () { return _.map(rowColumns, 'fieldProperty'); };
    //======//
    // Grid //
    //======//
    var gridOptionsReadyDeferred = $q.defer();
    var gridApiReadyDeferred = $q.defer();
    var gridOptionsReadyPromise = gridOptionsReadyDeferred.promise;
    var gridApiReadyPromise = gridApiReadyDeferred.promise;
    //
    // This promise will resolve when the grid is ready for data
    // and API calls.
    //
    var gridReadyPromise = $q.all([
        gridOptionsReadyPromise,
        gridApiReadyPromise
    ]);
    this.onSelectRadioToggled = function (nowCanSelectLanguages) {
        _this.canSelectLanguages = nowCanSelectLanguages;
        _this.isRadioGroupEmpty = false;
        if (!nowCanSelectLanguages) {
            _this.gridApi.selection.clearSelectedRows();
            setAllRowFields(false);
        }
        _this.onServiceableLanguagesChanged({ validServiceableLanguages: _this.getValidServiceableLanguages() });
    };
    var toggleRowFields = function (row) {
        var rowFields = getRowFields();
        _.forEach(rowFields, function (rowField) {
            row.entity[rowField] = row.isSelected;
        });
    };
    var setAllRowFields = function (nowSelected) {
        _.forEach(_this.gridOptions.data, function (rowEntity) {
            toggleRowFields({
                entity: rowEntity,
                isSelected: nowSelected
            });
        });
    };
    //
    // Registered with the Grid API as the row selection handler.
    //
    // Selecting a row is a shortcut for setting/clearing all
    // of the row's language requirements.
    //
    this.onRowSelectionToggled = function (row) {
        toggleRowFields(row);
        _this.onServiceableLanguagesChanged({ validServiceableLanguages: _this.getValidServiceableLanguages() });
    };
    var createGridColumn = function (rowColumn) {
        return {
            cellTemplate: 'components/grids/serviceable-languages-grid/cell-templates/check-mark-template.html',
            displayName: rowColumn.label,
            enableColumnMenu: false,
            enableSorting: false,
            enableColumnResizing: false,
            field: rowColumn.fieldProperty,
            name: rowColumn.fieldProperty + "Col",
            width: '*',
        };
    };
    var createGridOptions = function () {
        var colDefs = [
            {
                cellTemplate: 'components/visual/grid/check-mark-template.html',
                enableColumnMenu: false,
                enableSorting: false,
                enableColumnResizing: false,
                field: 'checkMark',
                name: 'checkMarkRowHeaderCol',
                headerCellTemplate: 'components/grids/serviceable-languages-grid/cell-templates/header-check-mark-row-count-template.html',
                width: 55,
            },
            {
                cellTemplate: 'components/grids/serviceable-languages-grid/cell-templates/language-name-template.html',
                displayName: 'Language',
                field: 'language.name',
                name: 'languageCol',
                width: 200,
            }
        ];
        _.forEach(rowColumns, function (rowColumn) {
            colDefs.push(createGridColumn(rowColumn));
        });
        return {
            selectionRowHeaderColName: 'checkMarkRowHeaderCol',
            rowSelection: true,
            enableRowHeaderSelection: false,
            enableSelectAll: true,
            enableColumnResizing: false,
            enablePaginationControls: false,
            enableFullRowSelection: true,
            enableSorting: true,
            rowHeight: 26,
            multiSelect: true,
            minRowsToShow: 7,
            columnDefs: colDefs,
            data: [],
            onRegisterApi: function (gridApi) {
                _this.gridApi = gridApi;
                _this.gridApi.selection.on.rowSelectionChanged(null, _this.onRowSelectionToggled);
                gridApiReadyDeferred.resolve(true);
            }
        };
    };
    //================//
    // Template Logic //
    //================//
    //
    // Determine whether each and every one of the rows in the grid
    // is selected.
    //
    this.areAllRowsSelected = function () {
        return _this.gridApi.selection.getSelectedCount() === _this.gridOptions.data.length;
    };
    //
    // ng-click handler for the "Select All" checkbox in the top
    // right corner of the grid.
    //
    this.onSelectAllToggled = function ($event) {
        var allSelected = _this.areAllRowsSelected();
        if (allSelected) {
            _this.gridApi.selection.clearSelectedRows($event);
        }
        else {
            _this.gridApi.selection.selectAllRows();
        }
        // toggle each row's selection flag
        setAllRowFields(!allSelected);
        _this.onServiceableLanguagesChanged({ validServiceableLanguages: _this.getValidServiceableLanguages() });
    };
    var areAnyEntityRequirementsChecked = function (rowEntity) {
        var rowFields = getRowFields();
        return _.some(rowFields, function (rowField) {
            return rowEntity[rowField] === true;
        });
    };
    //
    // Determine whether all of a row's language requirements are
    // checked. Used to determine whether the row itself should
    // appear selected in the far left column.
    //
    var areAllRowRequirementsChecked = function (row) {
        var rowFields = getRowFields();
        var allRowFieldsChecked = true;
        _.forEach(rowFields, function (rowField) {
            if (!allRowFieldsChecked || !row.entity[rowField]) {
                allRowFieldsChecked = false;
            }
        });
        return allRowFieldsChecked;
    };
    //
    // ng-click handler for each of the language requirement
    // checkboxes in the grid.
    //
    this.checkMarkCellClicked = function (row, col, $event) {
        $event.stopImmediatePropagation();
        $event.target.blur();
        row.entity[col.colDef.field] = !row.entity[col.colDef.field];
        _this.onServiceableLanguagesChanged({ validServiceableLanguages: _this.getValidServiceableLanguages() });
        if (!!row.isSelected !== areAllRowRequirementsChecked(row)) {
            // Only call row.setSelected() when the selection flag
            // will be changed. A ui-grid bug causes the selection
            // count to drift otherwise.
            row.setSelected(areAllRowRequirementsChecked(row));
        }
    };
    //
    // Called when the `serviceableLanguages` binding has been
    // updated. Ensures that the row selection indicators are
    // updated after assigning the data to the grid.
    //
    var onUpdateServiceableLanguages = function (serviceableLanguages) {
        _this.gridOptions.data = serviceableLanguages;
        _this.canSelectLanguages = _.isNull(_this.canSelectLanguages) ? null : false;
        var rowsToSelect = [];
        _.forEach(_this.gridOptions.data, function (rowEntity) {
            if (!_this.canSelectLanguages && areAnyEntityRequirementsChecked(rowEntity)) {
                _this.canSelectLanguages = true;
                _this.isRadioGroupEmpty = false;
            }
            if (areAllRowRequirementsChecked({ entity: rowEntity })) {
                rowsToSelect.push(rowEntity);
            }
        });
        if (rowsToSelect.length) {
            _this.gridApi.grid.modifyRows(_this.gridOptions.data);
            _.forEach(rowsToSelect, function (rowEntity) {
                _this.gridApi.selection.selectRow(rowEntity);
            });
        }
    };
    //==============//
    // Output Logic //
    //==============//
    this.isValid = function () {
        return !_.isNull(_this.canSelectLanguages) && (_this.canSelectLanguages === false ||
            _.some(_this.gridOptions.data, function (rowEntity) {
                return areAnyEntityRequirementsChecked(rowEntity);
            }));
    };
    this.getValidServiceableLanguages = function () {
        if (_this.isValid()) {
            return _.filter(_this.gridOptions.data, areAnyEntityRequirementsChecked);
        }
        else if (_.isNull(_this.canSelectLanguages)) {
            return undefined;
        }
        else {
            return null;
        }
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onChanges = function (changes) {
        if (changes.isRadioGroupEmpty && _this.isRadioGroupEmpty) {
            _this.canSelectLanguages = null;
        }
        gridReadyPromise.then(function () {
            if (changes.isRadioGroupEmpty && _this.isRadioGroupEmpty) {
                _this.gridApi.selection.clearSelectedRows();
                setAllRowFields(false);
                _this.onServiceableLanguagesChanged({ validServiceableLanguages: _this.getValidServiceableLanguages() });
            }
            else {
                _this.gridApi.selection.clearSelectedRows();
                onUpdateServiceableLanguages(_this.serviceableLanguages);
            }
        });
    };
    this.$onInit = function () {
        _this.gridApi = null;
        _this.canSelectLanguages = _this.isRadioGroupEmpty ? null : false;
        _this.gridOptions = createGridOptions();
        gridOptionsReadyDeferred.resolve(true);
    };
}
angular.module('prism-ui.components').component('serviceableLanguagesGrid', {
    bindings: {
        onServiceableLanguagesChanged: '&',
        serviceableLanguages: '<',
        isRadioGroupEmpty: '<',
        isDisabled: '<ngDisabled'
    },
    controller: ServiceableLanguagesGridController,
    templateUrl: 'components/grids/serviceable-languages-grid/serviceable-languages-grid-template.html'
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by kyang on 7/29/19.
 */
function ContentSubscriptionFilterModalComponent(SearchFilterService, SubscriptionsService) {
    //===================//
    // Template Bindings //
    //===================//
    var _this = this;
    this.onSeasonSelected = function () {
        _this.selectedVolume = null;
    };
    this.onVolumeSelected = function () {
        _this.selectedSeason = null;
    };
    this.onOk = function () {
        var criteria = SearchFilterService.getCurrentSearchCriteria();
        if (_this.selectedSeason) {
            criteria.season = SearchFilterService.extractQueryProp([_this.selectedSeason], 'id');
            _this.selectedVolume = null;
        }
        else {
            delete SubscriptionsService.queryOptions.season;
            delete criteria.season;
        }
        if (_this.selectedVolume) {
            criteria.volume = SearchFilterService.extractQueryProp([_this.selectedVolume], 'id');
        }
        else {
            delete SubscriptionsService.queryOptions.volume;
            delete criteria.volume;
        }
        _this.close();
    };
    this.reset = function () {
        _this.dismiss({ $value: 'setToDefaults' });
    };
    this.cancel = function () {
        _this.dismiss({ $value: 'cancel' });
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    var getFirstObjectFromPathProp = function (collection, objectProp, pathParam) {
        var selectedObjs = SearchFilterService.getObjectsFromPathProp(collection, objectProp, pathParam);
        return _.get(selectedObjs, '0');
    };
    this.$onInit = function () {
        if (_.size(_this.resolve.availableSeasons) < 1) {
            _this.resolve.availableSeasons = [];
        }
        if (_.size(_this.resolve.availableVolumes) < 1) {
            _this.resolve.availableVolumes = [];
        }
        _this.selectedSeason = getFirstObjectFromPathProp(_this.resolve.availableSeasons, 'id', 'season');
        _this.selectedVolume = getFirstObjectFromPathProp(_this.resolve.availableVolumes, 'id', 'volume');
    };
}
angular
    .module('prism-ui.components')
    .component('contentSubscriptionFilterModal', {
    controller: ContentSubscriptionFilterModalComponent,
    templateUrl: 'components/modal/content-category-filter-modal/content-subscription-filter-template.html',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 7/17/15.
 */
function ContentSelectModalComponent($filter, $scope, uiGridConstants, ContentResourceFactory) {
    //======//
    // Grid //
    //======//
    var _this = this;
    this.gridOptions = {
        data: [],
        enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
        enableRowHeaderSelection: false,
        enableRowSelection: true,
        enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED || 2,
        multiSelect: false,
        rowSelection: true,
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        columnDefs: [{
                cellTemplate: 'components/modal/content-select-modal/locked-content-cell-template.html',
                enableColumnMenu: false,
                enableFiltering: false,
                field: 'name',
                sort: {
                    direction: 'asc',
                    priority: 0
                },
            }],
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            _this.gridApi.selection.on.rowSelectionChanged($scope, _this.gridRowSelectionHandler);
        },
    };
    this.gridRowSelectionHandler = function (row) {
        if (row.entity.locked && row.isSelected) {
            _this.gridApi.selection.unSelectRow(row.entity);
        }
    };
    this.onRowDblClick = function (row) {
        var content = row.entity;
        if (!content.locked) {
            _this.close({ $value: content });
        }
    };
    //===================//
    // Template Response //
    //===================//
    var getSelectedContent = function () {
        if (!_this.gridApi) {
            return undefined;
        }
        return _this.gridApi.selection.getSelectedRows()[0];
    };
    this.executeSearch = function (searchText) {
        // Case is handled by the filter to make case insensitive searches
        var searchCriteria = { name: searchText };
        _this.gridOptions.data = $filter('filter')(_this.originalData, searchCriteria);
    };
    this.disableOKButton = function () {
        return !getSelectedContent();
    };
    this.onOK = function () {
        var selectedContent = getSelectedContent();
        _this.close({ $value: selectedContent });
    };
    this.cancel = function () {
        _this.dismiss({ $value: 'cancel' });
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    var executeQuery = function () {
        if (_this.resolve.contents) {
            _this.gridOptions.data = _this.resolve.contents;
            _this.originalData = angular.copy(_this.resolve.contents);
        }
        else {
            ContentResourceFactory.query({
                type: _this.resolve.contentType,
                fetchLimit: '10000',
                includeHidden: false,
                view: 'MINIMAL'
            }).$promise.then(function (data) {
                _this.gridOptions.data = data;
                _this.originalData = angular.copy(data);
            });
        }
    };
    this.$onInit = function () {
        executeQuery();
    };
}
angular.module('prism-ui.package').component('contentSelectModalComponent', {
    bindings: {
        close: '&',
        dismiss: '&',
        resolve: '<'
    },
    controller: ContentSelectModalComponent,
    templateUrl: 'components/modal/content-select-modal/content-select-modal-template.html'
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by kyang on 6/19/19.
 */
function AttachmentSelectModalController(_, $q, $filter) {
    //======//
    // Grid //
    //======//
    var _this = this;
    var colDefs = [
        {
            cellTemplate: 'components/visual/grid/check-mark-template.html',
            enableColumnMenu: false,
            enableSorting: false,
            enableColumnResizing: false,
            field: 'checkMark',
            fieldName: 'Selection',
            headerCellTemplate: 'components/grids/default-artwork-maps-grid/cell-templates/header-check-mark-row-count-template.html',
            width: 55,
        },
        {
            cellTemplate: 'components/visual/grid/base-tooltip-template.html',
            enableColumnMenu: false,
            enableSorting: true,
            field: 'sourceMediaAcceptProfile.name',
            displayName: 'Media Accept Profile',
        },
        {
            cellTemplate: 'system/templates/mediaAcceptProfiles/searchView/renderers/accept-profile-tooltip-template.html',
            enableColumnMenu: false,
            enableSorting: true,
            field: 'sourceMediaAcceptProfile.type',
            displayName: 'Type',
        }
    ];
    this.gridOptions = {
        selectionRowHeaderColName: 'Selection',
        rowSelection: true,
        multiSelect: true,
        enableFullRowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: false,
        enableHorizontalScrollbar: 0,
        enableVerticalScrollbar: 2,
        enablePaginationControls: false,
        enableSorting: true,
        rowHeight: 26,
        minRowsToShow: 5,
        columnDefs: colDefs,
        data: [],
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
        }
    };
    this.areAllRowsSelected = function () {
        return _this.gridApi.selection.getSelectedCount() === _this.gridOptions.data.length;
    };
    this.onSelectAllToggled = function () {
        if (_this.areAllRowsSelected()) {
            _this.gridApi.selection.clearSelectedRows();
        }
        else {
            _this.gridApi.selection.selectAllRows();
        }
    };
    //===================//
    // Template Bindings //
    //===================//
    this.disableOKButton = function () {
        return _this.gridApi.selection.getSelectedCount() < 1;
    };
    this.onOK = function () {
        _this.close({ $value: _this.gridApi.selection.getSelectedRows() });
    };
    this.cancel = function () {
        _this.dismiss({ $value: 'cancel' });
    };
    this.executeSearch = function (searchText) {
        // Case is handled by the filter to make case insensitive searches
        var searchFields = ['sourceMediaAcceptProfile.name', 'type', 'targetPathExpression'];
        _this.gridOptions.data = $filter('gridSearch')(_this.resolve.availableDeliveryItems, searchText, searchFields);
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.gridOptions.data = _.clone(_this.resolve.availableDeliveryItems);
    };
}
angular
    .module('prism-ui.components')
    .component('attachmentSelectModal', {
    controller: AttachmentSelectModalController,
    templateUrl: 'components/modal/email-attachment-modal/email-attachment-modal-template.html',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by kyang on 4/1/21.
 */
function FileProgressModalComponent(_, uiGridConstants, Rx, FileProgressService) {
    //======//
    // Grid //
    //======//
    var _this = this;
    this.gridOptions = {
        data: null,
        enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
        enableRowHeaderSelection: false,
        enableRowSelection: true,
        enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
        multiSelect: false,
        rowSelection: true,
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        columnDefs: [{
                field: 'status',
                name: 'statusIcon',
                displayName: '',
                width: '35',
                enableSorting: false,
                enableColumnMenu: false,
                enableColumnResizing: false,
                enableFiltering: false,
                cellTemplate: 'components/modal/fileProgressModal/cellTemplates/upload-status-cell-template.html',
            }, {
                field: 'filename',
                displayName: 'File',
                enableColumnMenu: false,
                enableFiltering: false,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html',
            }, {
                field: 'targetPackageId',
                displayName: 'Package',
                width: '90',
                enableColumnMenu: false,
                enableFiltering: false,
                cellTemplate: 'components/modal/fileProgressModal/cellTemplates/target-package-link-cell-template.html',
            }, {
                field: 'progress',
                displayName: 'Upload Progress',
                width: '15%',
                enableColumnMenu: false,
                enableFiltering: false,
                cellTemplate: 'components/modal/fileProgressModal/cellTemplates/upload-progress-cell-template.html',
            }, {
                field: 'dateStarted',
                displayName: 'Date Started',
                width: '250',
                enableColumnMenu: false,
                enableFiltering: false,
                cellFilter: 'amDateFormat:"MMM, D, YYYY, h:mm:ss A"',
                sort: { direction: uiGridConstants.DESC },
            }],
    };
    //================//
    // Template Logic //
    //================//
    this.onPackageNavigationStarted = function () {
        _this.loadingIndicator.show = true;
    };
    this.onPackageNavigationEnded = function () {
        _this.loadingIndicator.show = false;
    };
    this.updateRowFilter = function () {
        _this.gridOptions.data = [];
        _this.endObservable.onNext();
        updatePendingFiles();
    };
    this.clearCompletedUploads = function () {
        FileProgressService.clearCompletedUploads();
        _this.updateRowFilter();
    };
    this.close = function () {
        _this.dismiss({ $value: 'cancel' });
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    var updatePendingFiles = function () {
        // TODO: Add button to clear completed => Don't re-add cleared & completed rows
        var newUploadInfos = (_this.showCompleted) ? FileProgressService.getAllUploads().slice() : FileProgressService.getPendingUploads().slice();
        _.forEach(_this.gridOptions.data, function (currentRow) {
            var matchingUploadIndex = newUploadInfos.indexOf(currentRow.uploadInfo);
            if (matchingUploadIndex >= 0) {
                newUploadInfos.splice(matchingUploadIndex, 1);
            }
        });
        _.forEach(newUploadInfos, function (newUploadInfo) {
            console.log(newUploadInfo);
            var newRow = {
                status: newUploadInfo.status,
                filename: newUploadInfo.filename,
                targetPackageId: newUploadInfo.targetPackageId,
                dateStarted: newUploadInfo.dateStarted,
                uploadInfo: newUploadInfo,
                progress: Math.floor(newUploadInfo.progressObservable.value * 100),
            };
            _this.gridOptions.data.push(newRow);
            var observable = newUploadInfo.progressObservable.takeUntil(_this.endObservable);
            observable.subscribeOnNext(function (progress) {
                newRow.status = newUploadInfo.status;
                newRow.progress = Math.floor(progress * 100);
            });
            observable.subscribeOnCompleted(function () {
                newRow.status = newUploadInfo.status;
            });
        });
    };
    this.$onInit = function () {
        _this.endObservable = new Rx.Subject();
        _this.showCompleted = true;
        _this.gridOptions.data = [];
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.packageIdList = ['(placeholder)'];
        updatePendingFiles();
    };
    this.$doCheck = function () {
        if (_this.gridOptions.data) {
            updatePendingFiles();
        }
    };
    this.$onDestroy = function () {
        _this.endObservable.onCompleted();
    };
}
angular.module('prism-ui.components').component('fileProgressModal', {
    bindings: {
        close: '&',
        dismiss: '&',
        resolve: '<'
    },
    controller: FileProgressModalComponent,
    templateUrl: 'components/modal/fileProgressModal/file-progress-modal-template.html'
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2022 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by kyang on 8/4/22.
 */
function FileProgressServiceConstructor(_, $timeout, Rx, ModalService, NotificationService) {
    var currentUploads = [];
    var allUploads = [];
    var uploadNotification = null;
    var UploadStatus;
    (function (UploadStatus) {
        UploadStatus["PENDING"] = "PENDING";
        UploadStatus["SUCCEEDED"] = "SUCCEEDED";
        UploadStatus["FAILED"] = "FAILED";
        UploadStatus["CANCELLED"] = "CANCELLED";
    })(UploadStatus || (UploadStatus = {}));
    ;
    this.UploadStatus = UploadStatus;
    this.getPendingUploads = function () {
        return currentUploads.filter(function (uploadInfo) {
            return (uploadInfo.status === UploadStatus.PENDING);
        });
    };
    // Includes previous batches & current batch
    this.getAllUploads = function () {
        return allUploads;
    };
    this.addPendingUpload = function (filename, targetPackageId, extraProps) {
        var uploadInfo = {
            status: UploadStatus.PENDING,
            filename: filename,
            targetPackageId: targetPackageId,
            dateStarted: new Date(),
            progressObservable: new Rx.BehaviorSubject(0),
            extraProps: extraProps
        };
        currentUploads.push(uploadInfo);
        allUploads.push(uploadInfo);
        if (!uploadNotification) {
            uploadNotification = NotificationService.createPersistentWarningNotification('FILE UPLOAD IN PROGRESS', 'Uploading files... DO NOT refresh or close the page.', function () { ModalService.showFileProgressModal(); }, false);
        }
        return uploadInfo;
    };
    var endUpload = function (uploadInfo) {
        var anyUploadPending = false;
        var anyUploadFailed = false;
        for (var _i = 0, currentUploads_1 = currentUploads; _i < currentUploads_1.length; _i++) {
            var uploadInfo_1 = currentUploads_1[_i];
            anyUploadPending = anyUploadPending || uploadInfo_1.status === UploadStatus.PENDING;
            anyUploadFailed = anyUploadFailed || uploadInfo_1.status === UploadStatus.FAILED;
        }
        uploadInfo.progressObservable.onCompleted();
        if (!anyUploadPending) {
            var closingNotification_1 = uploadNotification;
            currentUploads = [];
            uploadNotification = null;
            if (anyUploadFailed) {
                NotificationService.createFailureNotification('Some files failed to upload.', {
                    delay: -1,
                    moreInfoClickHandler: function () { ModalService.showFileProgressModal(); }
                });
            }
            else {
                NotificationService.createPersistentSuccessNotification('UPLOAD COMPLETED', 'It is now SAFE to refresh or close this page.', function () { ModalService.showFileProgressModal(); }, true);
            }
            // Notice: When $timeout resolves, uploadNotification != closingNotification
            $timeout(function () { return closingNotification_1.close(); });
        }
    };
    this.completeUpload = function (uploadInfo) {
        uploadInfo.status = UploadStatus.SUCCEEDED;
        uploadInfo.progressObservable.onNext(1);
        endUpload(uploadInfo);
    };
    this.cancelUpload = function (uploadInfo) {
        uploadInfo.status = UploadStatus.CANCELLED;
        endUpload(uploadInfo);
    };
    this.failUpload = function (uploadInfo, error) {
        uploadInfo.status = UploadStatus.FAILED;
        endUpload(uploadInfo);
    };
    this.clearCompletedUploads = function () {
        _.remove(currentUploads, function (uploadInfo) { return uploadInfo.status !== UploadStatus.PENDING; });
        _.remove(allUploads, function (uploadInfo) { return uploadInfo.status !== UploadStatus.PENDING; });
    };
}
angular
    .module('prism-ui.system')
    .service('FileProgressService', FileProgressServiceConstructor);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: file-select-modal-component.ts
 *
 * Created by kyang on 2021-03-25.
 */
function FileSelectModalController(_) {
    //===================//
    // Template Response //
    //===================//
    var _this = this;
    this.isValidating = function () {
        return (_.get(_this, 'buttonFile.type') === 'LOCAL'
            && _.get(_this, 'buttonFile.status') === 'RUNNING');
    };
    this.okButtonEnabled = function () {
        return _.get(_this, 'buttonFile.status') === 'PASSED';
    };
    this.onOkClicked = function () {
        _this.onSelectClicked({ fileValue: _this.buttonFile });
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.filePath = null;
    };
    this.onFileChanged = function (newFile) {
        _this.buttonFile = newFile;
        _this.dropFile = newFile;
        _this.validationError = _.chain(newFile)
            .get('results.0.errors')
            .map(function (error) {
            return error.description;
        })
            .join('; ')
            .value();
        switch (_.get(newFile, 'type')) {
            case 'LOCAL':
                _this.filePath = newFile.files[0].file.name;
                break;
            case 'REMOTE':
                _this.filePath = newFile.files[0].virtualPath;
                break;
            default:
                _this.filePath = null;
        }
    };
}
angular
    .module('prism-ui.components')
    .component('fileSelectModal', {
    templateUrl: 'components/modal/fileSelectModal/file-select-modal-template.html',
    controller: FileSelectModalController,
    transclude: {
        // preview: This section is shown when file value is valid
        preview: '?fileSelectModalPreview'
    },
    bindings: {
        modalTitle: '<',
        dropZoneLabel: '<',
        getFileExtensions: '&',
        initializeUploaderConfig: '&',
        getLocalFilePreValidationErrors: '&',
        validateRemoteFile: '&',
        validateLocalFile: '&',
        validateProgress: '<?',
        buttonSources: '<?',
        buttonTooltips: '<?',
        onCancelClicked: '&',
        onSelectClicked: '&',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: generate-accept-profile-modal-component.ts
 *
 * Created by kyang on 2021-01-26.
 */
function GenerateAcceptProfileModalController(_, $filter, $q, MediaAcceptProfileService, MediaInfoService, VALID_FILE_EXTENSIONS) {
    //========================//
    // Remote File Validation //
    //========================//
    var _this = this;
    this.getFileExtensions = function () {
        return VALID_FILE_EXTENSIONS[_this.mediaAcceptProfileType];
    };
    this.validateRemoteFile = function (fileSystemItem) {
        var virtualPath = fileSystemItem.parent + fileSystemItem.name;
        return $q.when({
            source: virtualPath,
            errors: [],
            warnings: [],
        });
    };
    //=======================//
    // Local File Validation //
    //=======================//
    this.getLocalFilePreValidationErrors = function (file, filter) {
        // Doesn't add any local file filters
    };
    this.validateLocalFile = function (fileItem) {
        return MediaInfoService.executeMediaInfo(fileItem._file)
            .then(function (mediaInfoXml) {
            return {
                source: fileItem.file.name,
                errors: [],
                warnings: [],
                mediaInfoXml: mediaInfoXml,
            };
        })
            .catch(function (errorData) {
            return {
                source: fileItem.file.name,
                errors: [{
                        source: fileItem.file.name,
                        description: "Failed to run MediaInfo: " + JSON.stringify(errorData),
                        severity: 'ERROR',
                    }],
                warnings: [],
            };
        });
    };
    //===================//
    // Template Response //
    //===================//
    this.onCancelClicked = function () {
        _this.dismiss({ $value: 'cancel' });
    };
    this.onOkClicked = function (buttonFile) {
        var updateValidatorsPromise;
        _this.loadingIndicator.show = true;
        switch (buttonFile.type) {
            case 'LOCAL':
                updateValidatorsPromise = MediaAcceptProfileService.updateValidatorsFromMediaInfo(_this.mediaAcceptProfileId, buttonFile.results[0].mediaInfoXml);
                break;
            case 'REMOTE':
                updateValidatorsPromise = MediaAcceptProfileService.updateValidatorsFromMedia(_this.mediaAcceptProfileId, buttonFile.files[0].virtualPath);
                break;
        }
        updateValidatorsPromise.then(function () {
            _this.close();
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.mediaAcceptProfileType = _this.resolve.mediaAcceptProfileType;
        _this.mediaAcceptProfileId = _this.resolve.mediaAcceptProfileId;
        _this.typeName = (_this.mediaAcceptProfileType === 'OTHER') ? 'ARTWORK' : _this.mediaAcceptProfileType;
        _this.dropZoneLabel = "Drop " + $filter('capitalize')(_this.typeName) + " File Here";
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
    };
    this.initializeLocalUploaderConfig = function (fileUploaderConfig) {
    };
}
angular
    .module('prism-ui.components')
    .component('generateAcceptProfileModal', {
    templateUrl: 'components/modal/generateAcceptProfileModal/generate-accept-profile-modal-template.html',
    controller: GenerateAcceptProfileModalController,
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: item-select-select-modal-component.ts
 *
 * Created by kyang on 2019-06-17.
 */
function ItemSelectModalController(_) {
    var _this = this;
    this.$onInit = function () {
        _this.searchText = '';
    };
}
angular
    .module('prism-ui.components')
    .component('itemSelectModal', {
    controller: ItemSelectModalController,
    templateUrl: 'components/modal/item-select-modal/item-select-modal-template.html',
    transclude: true,
    bindings: {
        modalTitle: '<',
        selectButtonText: '<',
        loadingIndicator: '=?',
        executeSearch: '&',
        onSearchRefresh: '&?',
        gridIsEmpty: '&',
        onCancelClicked: '&',
        onSelectClicked: '&',
        selectButtonEnabled: '&'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by sjacobs on 1/21/19.
 */
function JsonViewerModalController(_, $q, $routeParams, NotificationService) {
    var _this = this;
    this.$onInit = function () {
        _this.jsonDataPromise = $q.when(_this.resolve.jsonData);
    };
    this.onCopyContextDataClicked = function () {
        if (!_.isNil(navigator.clipboard)) {
            console.warn('Navigator available. Copying to clipboard using Clipboard API');
            navigator.clipboard.writeText(JSON.stringify(_this.resolve.jsonData))
                .then(function () {
                NotificationService.createSuccessNotification('Copied Context JSON Data to clipboard successfully', 2000);
            }, function () {
                NotificationService.createFailureNotification('Unable to copy Context JSON Data to clipboard', '', true, -1);
            });
        }
        else {
            console.warn('Navigator not available. Copying to clipboard using document.execCommand');
            var input = document.createElement('input');
            document.body.appendChild(input);
            input.value = JSON.stringify(_this.resolve.jsonData);
            input.focus();
            input.select();
            var result = document.execCommand('copy');
            input.remove();
            if (result) {
                NotificationService.createSuccessNotification('Copied Context JSON Data to clipboard successfully', 2000);
            }
            else {
                NotificationService.createFailureNotification('Unable to copy Context JSON Data to clipboard', '', true, -1);
            }
        }
    };
}
angular.module('prism-ui.components').component('jsonViewerModal', {
    controller: JsonViewerModalController,
    templateUrl: 'components/modal/jsonViewerModal/json-viewer-modal-template.html',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: move-directory-component.ts
 *
 * Created by kyang on 2020-09-23.
 */
function MoveDirectoryModalController(_, uiGridConstants, FileSystemService) {
    //=================//
    // Lifecycle Hooks //
    //=================//
    var _this = this;
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.searchText = '';
        _this.sourceFileSystemId = _this.resolve.sourceFileSystemId;
        FileSystemService
            .getFileSystems()
            .then(function (fileSystems) {
            _.remove(fileSystems, { id: _this.sourceFileSystemId });
            _this.gridOptions.data = fileSystems;
        });
    };
    //===================//
    // File Systems Grid //
    //===================//
    var columnDefs = [
        {
            name: 'checkMarkRowHeaderCol',
            field: 'checkMark',
            width: 30,
            enableColumnMenu: false,
            enableSorting: false,
            enableColumnResizing: false,
            cellTemplate: 'components/visual/grid/check-mark-template.html'
        },
        {
            field: 'name',
            type: 'string',
            displayName: 'Name',
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }, {
            field: 'typeName',
            displayName: 'Type',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }, {
            field: 'pathPrefix',
            displayName: 'Path Prefix',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: false,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        multiSelect: false,
        columnDefs: columnDefs,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            _this.gridApi.grid.registerRowsProcessor(processGridFilter, 200);
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        data: []
    };
    var processGridFilter = function (renderableRows) {
        _.forEach(renderableRows, function (row) {
            if (_this.searchText === null || _this.searchText === '') {
                row.visible = true;
            }
            else {
                var criteria = _this.searchText.toLowerCase();
                row.visible =
                    row.entity.name && row.entity.name.toLowerCase().indexOf(criteria) !== -1 ||
                        row.entity.typeName && row.entity.typeName.toLowerCase().indexOf(criteria) !== -1 ||
                        row.entity.pathPrefix && row.entity.pathPrefix.toLowerCase().indexOf(criteria) !== -1;
            }
        });
        return renderableRows;
    };
    this.executeSearch = function (searchText) {
        _this.searchText = searchText;
        _this.gridApi.grid.refresh();
    };
    //================//
    // Template Logic //
    //================//
    this.getSelectedCount = function () {
        return (_this.gridApi &&
            _this.gridApi.selection &&
            _this.gridApi.selection.getSelectedCount());
    };
    this.onOk = function () {
        _this.close({
            $value: _this.gridApi.selection.getSelectedRows()[0]
        });
    };
}
angular
    .module('prism-ui.components')
    .component('moveDirectoryModal', {
    controller: MoveDirectoryModalController,
    templateUrl: 'components/modal/moveDirectoryModal/move-directory-modal-template.html',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function PartnerPackageAcceptRejectModalController(_) {
    var _this = this;
    this.approvalMessage = '';
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
    };
    this.onDone = function () {
        _this.close({ $value: _this.approvalMessage });
    };
}
angular
    .module('prism-ui.components')
    .component('partnerPackageAcceptRejectModal', {
    controller: PartnerPackageAcceptRejectModalController,
    templateUrl: 'components/modal/partnerPackageAcceptReject/partner-package-accept-reject-modal-template.html',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: queue-priority-modal-component.ts
 *
 * Created by kyang on 2019-10-14.
 */
function QueuePriorityModalController() {
    //================//
    // Template Logic //
    //================//
    var _this = this;
    this.okButtonEnabled = function () {
        return _this.editorForm.$valid && _this.editorForm.$dirty;
    };
    var getStepPriority = function (queueStep) {
        if (queueStep.priorityOverride) {
            return parseInt(queueStep.priorityOverride);
        }
        return parseInt(queueStep.priority);
    };
    this.onOkClicked = function () {
        var changedQueueSteps = [];
        var newPriority = "" + _this.priority;
        _.forEach(_this.queueSteps, function (queueStep) {
            if (getStepPriority(queueStep) !== _this.priority) {
                delete queueStep.priorityOverride;
                queueStep.priority = newPriority;
                changedQueueSteps.push(queueStep);
            }
        });
        _this.close({
            $value: changedQueueSteps
        });
    };
    this.onCancelClicked = function () {
        _this.dismiss();
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.queueSteps = _this.resolve.queueSteps;
        _this.priority = getStepPriority(_this.queueSteps[0]);
        if (_.some(_this.queueSteps, function (queueStep) {
            return getStepPriority(queueStep) !== _this.priority;
        })) {
            _this.priority = null;
        }
    };
}
angular
    .module('prism-ui.components')
    .component('queuePriorityModal', {
    controller: QueuePriorityModalController,
    templateUrl: 'components/modal/queue-priority-modal/queue-priority-modal-template.html',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 5/5/15.
 */
'use strict';
function ViewAssetModalController(_, $q, uiGridConstants, DownloadAssetService, EndPointService, PermissionsService, PreviewQueryService, UtilsService) {
    var _this = this;
    var PackageViewDownloadProxyViewState = 'PACKAGE_VIEW_DOWNLOAD_PROXY_VIEW_STATE';
    //=============//
    // Permissions //
    //=============//
    var getPermissions = function () {
        return PermissionsService.canRead(PackageViewDownloadProxyViewState)
            .then(function (canRead) {
            _this.haveViewDownloadProxyPermission = canRead;
            return _this.haveViewDownloadProxyPermission;
        });
    };
    //=======//
    // Asset //
    //=======//
    this.getAssetType = function () { return _.toLower(_this.packageContent.type); };
    // this.packageContent.asset.id is a UUID and the Reach
    // inventory API doesn't like those at the moment
    var getAssetId = function () { return _.get(_this.packageContent, 'assetId', 0); };
    this.isVideoModal = function () { return !_this.secondaryAsset && _this.getAssetType() === 'video'; };
    this.hasPixels = function () { return !_this.secondaryAsset && _.includes(['image', 'video'], _this.getAssetType()); };
    //=========//
    // Preview //
    //=========//
    // use a getter for this since it's not always initialized
    this.getMediaPath = function () { return _.get(_this.packageContent, 'mediaPath'); };
    var hasProxy = function () {
        return _.chain(_this.packageContent)
            .get('asset.contents')
            .filter(function (content) { return _.includes(_.toLower(content.contentUses), DownloadAssetService.ContentUse.Proxy); })
            .value()
            .length > 0;
    };
    this.assetTypeAllowsPreview = function () { return !_this.secondaryAsset &&
        _.includes(['image', 'video', 'audio'], _this.getAssetType()); };
    this.showImagePreview = function () { return !_this.secondaryAsset && _.includes(['image'], _this.getAssetType()); };
    this.showProxyPlayer = function () { return !_this.secondaryAsset && _.includes(['video', 'audio'], _this.getAssetType()); };
    this.isAudio = function () { return !_this.secondaryAsset && _.includes(['audio'], _this.getAssetType()); };
    this.showPreviewContainer = function () { return (_this.resolve.showPreview
        && !_this.secondaryAsset
        && _this.assetTypeAllowsPreview()
        && _this.haveViewDownloadProxyPermission); };
    var loadPreviewMediaUri = function () {
        if (_this.haveViewDownloadProxyPermission && hasProxy() && (_this.showImagePreview() || _this.showProxyPlayer())) {
            DownloadAssetService.getAssetUri(getAssetId(), _this.getAssetType(), DownloadAssetService.ContentUse.Proxy)
                .then(function (proxyUriInfo) { _this.packageContent.mediaPath = proxyUriInfo.uri; })
                .catch(function () { _.unset(_this.packageContent, 'mediaPath'); });
        }
    };
    //================//
    // Asset Download //
    //================//
    this.canDownloadSource = function () { return !_this.secondaryAsset && _this.getAssetType() !== 'video' && getAssetId() > 0; };
    this.canDownloadProxy = function () { return !_this.secondaryAsset && hasProxy(); };
    var getDownloadFileName = function (contentUse) {
        // append e.g. 'video_proxy.mov' to the provided download
        // filename prefix
        var extension = UtilsService.getFileExtension(_this.assets[_.toUpper(contentUse)].filePath);
        return _this.downloadFileNamePrefix +
            ("" + _.toLower(_this.getAssetType())) +
            ("_" + _.toLower(contentUse)) +
            ("." + _.toLower(extension));
    };
    var downloadAsset = function (contentUse) {
        if (_this.haveViewDownloadProxyPermission) {
            _this.loadingIndicator.show = true;
            DownloadAssetService.downloadAsset(getAssetId(), getDownloadFileName(contentUse), _this.getAssetType(), contentUse).then(function () {
                _this.loadingIndicator.show = false;
            });
        }
    };
    this.downloadSource = function () {
        downloadAsset(DownloadAssetService.ContentUse.Source);
    };
    this.downloadProxy = function () {
        downloadAsset(DownloadAssetService.ContentUse.Proxy);
    };
    //===================//
    // Audio Tracks Grid //
    //===================//
    var colDefs = [
        {
            cellTemplate: 'components/visual/grid/base-tooltip-template.html',
            enableColumnMenu: false,
            enableColumnResizing: false,
            field: 'trackNumber',
            cellFilter: 'addOne',
            name: 'Track',
            width: 70,
            type: 'number',
            sort: {
                direction: uiGridConstants.ASC,
                priority: 0
            },
            sortDirectionCycle: [uiGridConstants.ASC]
        },
        {
            cellTemplate: 'components/visual/grid/base-tooltip-template.html',
            enableColumnMenu: false,
            enableSorting: false,
            enableColumnResizing: false,
            field: 'layout',
            name: 'Layout',
            width: 200
        },
        {
            cellTemplate: 'components/visual/grid/base-tooltip-template.html',
            enableColumnMenu: false,
            enableSorting: false,
            enableColumnResizing: false,
            field: 'numberOfChannels',
            name: 'Channels',
            width: 95
        },
        {
            cellTemplate: 'components/visual/grid/base-tooltip-template.html',
            enableColumnMenu: false,
            enableSorting: false,
            enableColumnResizing: false,
            field: 'language.name',
            name: 'Language',
            width: 200
        },
        {
            cellTemplate: 'components/visual/grid/base-tooltip-template.html',
            enableColumnMenu: false,
            enableSorting: false,
            enableColumnResizing: false,
            field: 'role.name',
            name: 'Audio Role',
            width: 200
        },
    ];
    this.audioTracksGridOptions = {
        enableColumnResizing: false,
        enablePaginationControls: false,
        enableSorting: true,
        rowHeight: 26,
        minRowsToShow: 8,
        columnDefs: colDefs,
        data: []
    };
    //===========//
    // Lifecycle //
    //===========//
    this.onDone = function () {
        _this.close({ $value: 'done' });
    };
    var getData = function () {
        var dataPromises = {
            mediaInfo: PreviewQueryService.getMediaInfo(_this.packageContent.id, !_this.secondaryAsset),
            haveViewDownloadProxyPermission: getPermissions()
        };
        return $q.all(dataPromises)
            .then(function (results) {
            _this.mediaInfo = _.get(results, 'mediaInfo', {});
            _this.haveViewDownloadProxyPermission = _.get(results, 'haveViewDownloadProxyPermission', false);
            return loadPreviewMediaUri();
        })
            .then(function () {
            _this.loadingIndicator.show = false;
        });
    };
    this.$onInit = function () {
        _this.packageContent = _this.resolve.packageContent;
        _this.assets = [];
        _.forEach(_this.packageContent.asset.contents, function (content) {
            _this.assets[content.contentUses[0]] = content;
        });
        _this.secondaryAsset = _this.resolve.secondaryAsset;
        _this.downloadFileNamePrefix = _this.resolve.downloadFileNamePrefix;
        _this.contentTemplateUrl = _this.resolve.contentTemplateUrl;
        _this.showPreview = _this.resolve.showPreview;
        _this.haveViewDownloadProxyPermission = false;
        _this.audioTracksGridOptions.data = _.get(_this, 'packageContent.audioTrackDescriptors', []);
        _this.mediaInfo = {};
        _this.loadingIndicator = {
            backdrop: true,
            show: true,
            title: 'Working',
            message: 'Please wait...'
        };
        getData();
    };
}
angular.module('prism-ui.package').component('viewAssetModal', {
    bindings: {
        close: '&',
        dismiss: '&',
        resolve: '<'
    },
    controller: ViewAssetModalController,
    templateUrl: "components/modal/view-asset-modal/view-asset-modal-template.html"
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: navbar-component.js
 *
 * Created by rsorensen-lb on 5/18/17.
 */
function NavbarController(_, $location, $route, $routeParams, $uibModal, jwtStore, loginService, BreadcrumbService, UsersService, NavbarUtilService, PaginationService, PermissionsService, SearchFilterService, SidebarService) {
    var _this = this;
    this.$onInit = function () {
        _this.username = function () {
            return jwtStore.decode().sub;
        };
        PermissionsService.isExternalUser()
            .then(function (isExternalUser) {
            _this.canChangePassword = !isExternalUser;
        });
        _this.showPMViewMenu = $location.path() === '/packages';
        if (_this.searchEnabled === undefined) {
            _this.searchEnabled = $route.current.searchEnabled ||
                $location.path() === '/packages/package/edit/' + $routeParams.id + '/collaborators';
        }
        if (_this.filterEnabled === undefined) {
            _this.filterEnabled = $route.current.filterEnabled;
        }
        if (_this.showRefreshOnly === undefined) {
            _this.showRefreshOnly = $route.current.showRefreshOnly;
        }
        NavbarUtilService.clearCurrentSearch = _this.onClearCurrentSearch;
    };
    var doLogout = function () {
        var deferred = loginService.logout();
        deferred.then(function () {
            SidebarService.clearSessionData();
            PermissionsService.clearPermissions();
            PaginationService.resetToDefaultValues();
            $location.path('/login');
            $location.search({});
            BreadcrumbService.clearBreadcrumbs();
        }, function () {
            _this.errors = 'Failed to logout user.';
        });
        return deferred;
    };
    this.logout = function () {
        if (BreadcrumbService.editService && BreadcrumbService.editService.postCloseUpdate) {
            BreadcrumbService.editService.postCloseUpdate().then(function () {
                return doLogout();
            });
        }
        else {
            return doLogout();
        }
    };
    this.newPassword = '';
    this.keywords = function (newKeywords) {
        var criteria = SearchFilterService.getCurrentSearchCriteria();
        if (newKeywords !== undefined) {
            criteria.keywords = newKeywords;
        }
        else {
            return criteria.keywords;
        }
    };
    // Bound to searchField in template
    this.openChangePasswordModal = function () {
        UsersService.openChangePasswordModal();
    };
    this.setPMView = function (newView) {
        if ($location.path() === '/packages') {
            $location.search('pmView', newView);
        }
        else {
            $location.search('pmView', null);
        }
    };
    this.getPMViewSelectorLabel = function () {
        if (_this.showPMViewMenu) {
            switch ($location.search().pmView) {
                case 'basic':
                    return 'Basic Inventory View';
                case 'detailed':
                    return 'Detailed View';
                case 'status':
                    return 'Status View';
                default:
                    _this.setPMView('basic');
                    return 'Basic Inventory View';
            }
        }
        return '';
    };
    this.setSearchText = function (forceUpdate) {
        PaginationService.currentPage = 1;
        var previousText = $location.search().searchText;
        var currentText = _this.keywords();
        if (currentText && currentText.length > 0) {
            $location.search('searchText', currentText);
        }
        else {
            $location.search('searchText', null);
        }
        if (NavbarUtilService.viewSearchFunction) {
            var refresh = forceUpdate && (!previousText || previousText === currentText);
            NavbarUtilService.viewSearchFunction(currentText, refresh);
        }
    };
    this.refreshView = function () {
        if (NavbarUtilService.viewSearchFunction) {
            NavbarUtilService.viewSearchFunction();
        }
    };
    this.filterBtnClickHandler = function () {
        if (NavbarUtilService.viewFilterBtnHandler) {
            NavbarUtilService.viewFilterBtnHandler();
        }
    };
    this.reportBtnHandler = function (reportType) {
        if (NavbarUtilService.viewReportButtonHandlers[reportType]) {
            NavbarUtilService.viewReportButtonHandlers[reportType]();
        }
    };
    this.isFilterApplied = SearchFilterService.isSearchFilterApplied;
    this.findNext = function () {
        NavbarUtilService.searchButtonHandlers.onFindNext();
    };
    this.findPrevious = function () {
        NavbarUtilService.searchButtonHandlers.onFindPrevious();
    };
    this.getSearchResultCountString = function () {
        var currentIndex = NavbarUtilService.currentSearchResultIndex;
        var totalResults = NavbarUtilService.searchResultTotal;
        var searchText = $location.search().searchText;
        if (_.size(searchText) && NavbarUtilService.searchResultTotal > 0) {
            return currentIndex + " of " + totalResults;
        }
        else {
            return '';
        }
    };
    this.getNoResultsMsg = function () {
        var searchText = $location.search().searchText;
        if (_.size(searchText) &&
            NavbarUtilService.searchResultTotal === 0 &&
            NavbarUtilService.showNoResultsMsg) {
            return searchText + " not found.";
        }
        else {
            return '';
        }
    };
    this.onClearCurrentSearch = function () {
        //
        // TODO
        //
        // This should probably clear out all search criteria
        //
        _this.keywords('');
        $location.search('searchText', null);
    };
}
angular
    .module('prism-ui.components.navigation')
    .component('navbar', {
    templateUrl: 'components/navigation/navbar/navbar-template.html',
    controller: NavbarController,
    bindings: {
        searchEnabled: '<',
        filterEnabled: '<',
        showNextPreviousButtons: '<',
        showRefreshOnly: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 10/5/15.
 */
angular
    .module('prism-ui.components.navigation')
    .service('NavbarUtilService', function (_) {
    var _this = this;
    this.viewSearchFunction = null;
    this.viewFilterBtnHandler = null;
    this.viewReportButtonHandlers = {
        deliveryReport: null,
        packageMediaReport: null,
        packageReport: null,
        packageMetadataReport: null,
        packageAuditLevelReport: null
    };
    this.searchButtonHandlers = {
        onFindNext: null,
        onFindPrevious: null
    };
    this.searchResultTotal = 0;
    this.currentSearchResultIndex = 0;
    this.showNoResultsMsg = false;
    this.resetSearchResultStats = function () {
        _this.searchResultTotal = 0;
        _this.currentSearchResultIndex = 0;
        _this.showNoResultsMsg = false;
    };
    this.setSearchResultTotal = function (searchResultTotal) {
        _this.searchResultTotal = searchResultTotal;
    };
    this.setCurrentSearchResultIndex = function (currentSearchResultIndex) {
        _this.currentSearchResultIndex = currentSearchResultIndex;
    };
    this.setShowNoResultsMsg = function (showNoResultsMsg) {
        _this.showNoResultsMsg = showNoResultsMsg;
    };
    this.clearCurrentSearch = null;
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2022 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: native-temp-file-upload-service.ts
 *
 * Created by kyang on 2022-08-22.
 */
// This service is an implementation for TempFileUploadService.
angular.module('prism-ui.components').service('NativeTempFileUploadService', function (_, $injector, $q, EndPointService) {
    this.initialize = function (fileUploader) {
        // Service is created & registered before AuthFactory is created
        var AuthFactory = $injector.get('AuthFactory');
        fileUploader.url = EndPointService.fileUploadEndPoint;
        fileUploader.alias = 'multipart-content';
        fileUploader.autoUpload = false;
        fileUploader.formData = {};
        fileUploader.headers = {
            'Authorization': AuthFactory.getAuthHeader(),
            'Accept': 'application/json, text/plain, */*'
        };
    };
    this.uploadFileToTemp = function (fileUploader, origFileItem, origIndex, origUploadInfo, targetSubdirectory, targetPackageId) {
        if (fileUploader.url !== EndPointService.fileUploadEndPoint) {
            throw 'fileUploader must be initialized before upload!';
        }
        if (origIndex !== 0) {
            return origUploadInfo.extraProps.nativeTempDeferredFileUpload.promise;
        }
        // Upload all fileItems at once
        origUploadInfo.extraProps.allUploadInfos.forEach(function (currUploadInfo) {
            currUploadInfo.extraProps.nativeTempDeferredFileUpload = $q.defer();
        });
        fileUploader.onProgressItem = function (currFileItem, progress) {
            var currUploadInfo = origUploadInfo.extraProps.findUploadInfoForFileItem(currFileItem);
            currUploadInfo.progressObservable.onNext(progress / 100);
        };
        fileUploader.onSuccessItem = function (currFileItem, response) {
            var currUploadInfo = origUploadInfo.extraProps.findUploadInfoForFileItem(currFileItem);
            currUploadInfo.extraProps.deferredVirtualPath.resolve(response.path);
            currUploadInfo.extraProps.nativeTempDeferredFileUpload.resolve(response);
        };
        fileUploader.onErrorItem = function (currFileItem, response, status, headers) {
            var currUploadInfo = origUploadInfo.extraProps.findUploadInfoForFileItem(currFileItem);
            currUploadInfo.extraProps.nativeTempDeferredFileUpload.reject(response);
        };
        fileUploader.uploadAll();
        return origUploadInfo.extraProps.nativeTempDeferredFileUpload.promise;
    };
    this.cleanup = function (fileUploader) {
        // Nothing to cleanup
    };
});
//=================//
// Lifecycle Hooks //
//=================//
// Load this service when app is initialized
angular.module('prism-ui.components').run(function (NativeTempFileUploadService, TempFileUploadService) {
    TempFileUploadService.registerTempFileUploadServiceImplementation('NATIVE', NativeTempFileUploadService);
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: s3-temp-file-upload-service.ts
 *
 * Created by kyang on 2021-02-25.
 */
// This service is an implementation for TempFileUploadService.
angular.module('prism-ui.components').service('S3TempFileUploadService', function (_, $q, AWS, TempFileUploadService) {
    this.initialize = function (fileUploader) {
        // Nothing to initialize
    };
    this.uploadFileToTemp = function (fileUploader, fileItem, index, uploadInfo, targetSubdirectory, targetPackageId) {
        return TempFileUploadService.getTempDirectoryConfiguration().then(function (tempDirConfig) {
            if (!tempDirConfig.tempCredentialsSupported) {
                return $q.reject({
                    message: 'Webapp is not configured to upload to temp S3 directory'
                });
            }
            return uploadToTempS3(fileItem._file, targetSubdirectory, tempDirConfig, uploadInfo);
        });
    };
    var getVirtualPath = function (bucket, s3Key) {
        // virtualPath can be set to S3 URIs for ingests
        return "s3:" + bucket + ":" + s3Key;
    };
    var uploadToTempS3 = function (file, targetSubdirectory, tempDirConfig, uploadInfo) {
        return TempFileUploadService.getTempUploadCredentials(file.name, targetSubdirectory).then(function (uploadCredentials) {
            var bucket = uploadCredentials.bucket;
            var s3Path = uploadCredentials.key;
            var s3Client = new AWS.S3({
                params: { Bucket: bucket },
                credentials: new AWS.Credentials(uploadCredentials.credentials),
                region: tempDirConfig.region,
                endpoint: uploadCredentials.credentials.endpoint ? uploadCredentials.credentials.endpoint : undefined,
                useAccelerateEndpoint: uploadCredentials.credentials.useAcceleration === 'true',
            });
            var upload = s3Client.upload({
                Key: s3Path,
                ContentType: file.type,
                Body: file,
                Bucket: bucket
            });
            upload.on('httpUploadProgress', function (event) {
                uploadInfo.extraProps.deferredVirtualPath.resolve(getVirtualPath(bucket, event.key));
                if (!!event.total) {
                    uploadInfo.progressObservable.onNext(event.loaded / event.total);
                }
            });
            return upload.promise();
        });
    };
    this.cleanup = function (fileUploader) {
        // Nothing to cleanup
    };
});
//=================//
// Lifecycle Hooks //
//=================//
// Load this service when app is initialized
angular.module('prism-ui.components').run(function (S3TempFileUploadService, TempFileUploadService) {
    TempFileUploadService.registerTempFileUploadServiceImplementation('S3', S3TempFileUploadService);
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2022 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: temp-file-upload-service.ts
 */
// This service is an interface for all the temp-file-upload implementation services.
angular.module('prism-ui.components').service('TempFileUploadService', function (_, $q, $timeout, FileProgressService, TemporaryFileUploadResourceFactory) {
    //========================//
    // Abstract Functionality //
    //========================//
    var _this = this;
    var tempFileUploadServiceImplementations = {};
    this.registerTempFileUploadServiceImplementation = function (fileDestinationType, service) {
        if (_.has(tempFileUploadServiceImplementations, fileDestinationType)) {
            console.warn("Replacing previous TempFileUploadService implementation for file destination type: " + fileDestinationType);
        }
        tempFileUploadServiceImplementations[fileDestinationType] = service;
    };
    this.getTempFileUploadServiceImplementation = function (fileDestinationType) {
        return tempFileUploadServiceImplementations[fileDestinationType];
    };
    this.getConfiguredTempFileUploadServiceImplementation = function () {
        return _this.getTempDirectoryConfiguration().then(function (tempDirConfig) {
            var implementation = tempFileUploadServiceImplementations[tempDirConfig.storageProvider];
            if (!implementation) {
                throw 'Webapp is not configured to upload to temp directory';
            }
            return implementation;
        });
    };
    //====================================//
    // Abstract File Upload Functionality //
    //====================================//
    var _initialize = function (fileUploader) {
        return _this.getConfiguredTempFileUploadServiceImplementation().then(function (implementation) {
            return implementation.initialize(fileUploader);
        });
    };
    this.initialize = _.memoize(_initialize);
    // Implementations should resolve uploadInfo.extraProps.deferredVirtualPath...
    // and return a JS5Promise
    this.uploadFileToTemp = function (fileUploader, fileItem, index, uploadInfo, targetSubdirectory, targetPackageId) {
        return _this.initialize(fileUploader)
            .then(function () { return _this.getConfiguredTempFileUploadServiceImplementation(); })
            .then(function (implementation) {
            return implementation.uploadFileToTemp(fileUploader, fileItem, index, uploadInfo, targetSubdirectory, targetPackageId);
        });
    };
    this.cleanup = function (fileUploader) {
        _this.initialize(fileUploader)
            .then(function () { return _this.getConfiguredTempFileUploadServiceImplementation(); })
            .then(function (implementation) {
            // Timeout ensures all upload promises are started before cleanup is called
            $timeout(function () {
                _this.initialize.cache.delete(fileUploader);
                implementation.cleanup(fileUploader);
            });
        })
            .catch(function () {
            _this.initialize.cache.delete(fileUploader);
        });
    };
    //========================//
    // Shared Implementations //
    //========================//
    this.tempDirConfigPromise = null;
    this.getTempDirectoryConfiguration = function () {
        if (!_this.tempDirConfigPromise) {
            _this.tempDirConfigPromise = TemporaryFileUploadResourceFactory.getConfiguration().$promise;
        }
        return _this.tempDirConfigPromise;
    };
    this.getTempUploadCredentials = function (fileName, destinationPath) {
        return TemporaryFileUploadResourceFactory.getTemporaryUploadCredentials({
            name: fileName,
            destinationPath: destinationPath,
        }).$promise;
    };
    this.uploadFiles = function (fileUploader, targetSubdirectory, targetPackageId) {
        var uploadInfos = [];
        var fileItems = fileUploader.getNotUploadedItems();
        var findUploadInfoFn = function (fileItem) {
            return _.find(uploadInfos, function (uploadInfo) {
                return uploadInfo.extraProps.fileItem === fileItem;
            });
        };
        return fileItems.map(function (fileItem, index) {
            var deferredVirtualPath = $q.defer();
            var uploadInfo = FileProgressService.addPendingUpload(fileItem._file.name, targetPackageId, {
                deferredVirtualPath: deferredVirtualPath,
                findUploadInfoForFileItem: findUploadInfoFn,
                cancelUploadFn: function () {
                    var cancelData = 'Upload was cancelled';
                    FileProgressService.cancelUpload(uploadInfo);
                    deferredVirtualPath.reject(cancelData);
                },
                fileItem: fileItem,
                allUploadInfos: uploadInfos,
            });
            uploadInfos.push(uploadInfo);
            var nestedUploadPromise = _this.uploadFileToTemp(fileUploader, fileItem, index, uploadInfo, targetSubdirectory, targetPackageId)
                .catch(function (error) {
                FileProgressService.failUpload(uploadInfo, error);
                deferredVirtualPath.reject(error);
            });
            var uploadPromise = deferredVirtualPath.promise
                .then(function () {
                // Ensure virtualPath resolves before upload
                var deferred = $q.defer();
                $timeout(function () { return deferred.resolve(); });
                return deferred.promise;
            })
                .then(function () { return nestedUploadPromise; })
                .then(function (fileData) {
                FileProgressService.completeUpload(uploadInfo);
                return fileData;
            });
            return {
                fileItem: fileItem,
                virtualPathPromise: deferredVirtualPath.promise,
                progressObservable: uploadInfo.progressObservable,
                uploadPromise: uploadPromise,
            };
        });
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.components').component('assetInfoRow', {
    controller: function () { },
    templateUrl: 'components/visual/asset-info-row/asset-info-row-template.html',
    bindings: {
        inputId: '<',
        label: '<',
        value: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: bar-graph-component.ts
 *
 * Created by randysorensen on 2019-02-22.
 */
function BarGraphController(_) {
    var _this = this;
    this.getBars = function () {
        return _this.barGraphData.bars;
    };
    this.isLastBar = function (index) {
        var lastIndex = _
            .chain(_this.barGraphData.bars)
            .keys()
            .sort()
            .last()
            .value();
        return index === lastIndex;
    };
    var getOrderOfMagnitude = function (value) {
        var oom = 1;
        while (oom * 10 < value) {
            oom *= 10;
        }
        return oom;
    };
    var getMaxScale = function () {
        var maxValue = _
            .chain(_this.barGraphData.bars)
            .map('value')
            .max()
            .value();
        var oom = getOrderOfMagnitude(maxValue);
        var max = oom;
        while (max < maxValue) {
            max += oom;
        }
        return max;
    };
    this.getScaleLines = function () {
        return {
            max: getMaxScale(),
            threeFourths: '',
            half: getMaxScale() / 2,
            oneFourth: '',
            zero: ''
        };
    };
    this.getAnimationDuration = function () {
        var source = _this.barGraphData.animationDuration;
        var result;
        if (typeof (source) === 'function') {
            result = source();
        }
        else {
            result = parseFloat(source) || 0;
        }
        var dataAge = (new Date().getTime() - _this.barGraphData.timeStamp.getTime()) / 1000;
        if (dataAge > result) {
            result = 0;
        }
        return result;
    };
    this.getHeight = function (bar) {
        return 100.0 * parseFloat(bar.value) / getMaxScale();
    };
    this.$onInit = function () {
    };
}
angular.module('prism-ui.components').component('barGraph', {
    controller: BarGraphController,
    templateUrl: 'components/visual/bar-graph/bar-graph-template.html',
    bindings: {
        barGraphData: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: conversion-template-dropdown-component.ts
 *
 * Created by kyang on 2020-08-03.
 */
function ConversionTemplateDropdownController(_, $animate, $attrs, $element, $scope, ModalService, Rx) {
    var _this = this;
    this.conversionTypeObservable = new Rx.BehaviorSubject(null);
    this.conversionTemplateObservable = new Rx.BehaviorSubject(null);
    //===================//
    // Template Response //
    //===================//
    this.isTypeRequired = function () {
        return _this.forceTypeRequired || _this.isRequired;
    };
    this.isTypePromptVisible = function () {
        return _.size(_this.typeWhitelist) !== 1 || _this.conversionTypes.length !== 1;
    };
    this.isTemplatePromptVisible = function () {
        return _this.selectedType() !== 'Passthrough';
    };
    this.isTemplatePromptEnabled = function () {
        return !!_this.selectedType() || !_this.isTypePromptVisible();
    };
    this.getTemplatePrompt = function () {
        var prefix = _.get(_this, 'templatePromptPrefix', '');
        var selectedType = _this.selectedType() || '';
        var suffix = _.get(_this, 'templatePromptSuffix', '');
        return (prefix + " " + selectedType + " " + suffix).trim();
    };
    this.selectedType = function (newType) {
        if (newType === undefined) {
            return _this.conversionTypeObservable.value;
        }
        else {
            _this.conversionTypeObservable.onNext(newType);
        }
    };
    var updateTemplateChoices = function () {
        _this.conversionTemplates = _.filter(_this.collection, { converterType: _this.selectedType() });
    };
    var onTypeChanged = function () {
        var selectedType = _this.selectedType();
        var selectedTemplate = _this.selectedTemplate();
        updateTemplateChoices();
        _.invoke(_this, 'onTypeChange', { type: selectedType });
        if (selectedTemplate && selectedTemplate.converterType !== selectedType) {
            _this.selectedTemplate(null);
        }
    };
    this.selectedTemplate = function (newTemplate) {
        if (newTemplate === undefined) {
            return _this.conversionTemplateObservable.value;
        }
        else {
            _this.conversionTemplateObservable.onNext(newTemplate);
        }
    };
    var onTemplateChanged = function () {
        var newTemplateName = _.get(_this.selectedTemplate(), 'name');
        if (_this.ngModelCtrl.$modelValue !== newTemplateName) {
            _this.ngModelCtrl.$setViewValue(newTemplateName);
        }
        _.invoke(_this, 'onTemplateChange', { template: _this.selectedTemplate() });
    };
    this.templateHasDescription = function () {
        return !!_.get(_this.selectedTemplate(), 'description');
    };
    this.openDescriptionModal = function () {
        return ModalService.showMessageModal({
            messageText: _this.selectedTemplate().description,
            pullCancelLeft: true,
            title: "Template Description",
            showOK: true,
            okText: 'Close',
            showCancel: false,
            windowClass: 'confirm-modal-sm',
        });
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    var updateConversionTypes = function () {
        if (_.isEmpty(_this.typeWhitelist)) {
            _this.conversionTypes = _.chain(_this.collection)
                .keyBy('converterType')
                .keys()
                .sortBy()
                .value();
        }
        else {
            _this.conversionTypes = _.chain(_this.typeWhitelist)
                .values()
                .sortBy()
                .value();
            if (_this.typeWhitelist.length == 1 && _this.conversionTypes.length == 1) {
                _this.defaultTemplateType = _this.typeWhitelist[0];
            }
        }
        if (_this.includePassthrough) {
            _this.conversionTypes.push('Passthrough');
        }
    };
    var onTemplateNameChanged = function (templateName) {
        var newConversionTemplate = _.find(_this.collection, { name: templateName });
        var selectedValidTemplate = newConversionTemplate && (_.isEmpty(_this.typeWhitelist) || _.includes(_this.typeWhitelist, newConversionTemplate.converterType));
        if ((!newConversionTemplate && templateName) || (newConversionTemplate && !selectedValidTemplate)) {
            _this.selectedType(_this.defaultTemplateType ? _this.defaultTemplateType : null);
            _this.selectedTemplate({ name: templateName });
            return templateName;
        }
        if (newConversionTemplate) { // && selectedValidTemplate
            _this.selectedTemplate(newConversionTemplate);
            _this.selectedType(newConversionTemplate.converterType);
        }
        else { // templateName == null
            _this.selectedTemplate(null);
            _this.selectedType(_this.defaultTemplateType ? _this.defaultTemplateType : null);
        }
        return _.get(newConversionTemplate, 'name');
    };
    var onChildClassChanged = function (element) {
        if (!_.some(element.get(), function (htmlElement) { return htmlElement.localName.toLowerCase() === 'dropdown-select'; })) {
            return;
        }
        var nowPristine = !$element.find('dropdown-select').hasClass('ng-dirty');
        if (nowPristine && !_this.innerControlsPristine) {
            $scope.$apply(function () {
                onTemplateNameChanged(_this.ngModelCtrl.$viewValue);
            });
        }
        _this.innerControlsPristine = nowPristine;
    };
    this.$onInit = function () {
        _this.innerControlsPristine = true;
        _this.conversionTemplates = [];
        _this.destroyObservable = new Rx.Subject();
        _this.ngModelCtrl.$formatters.push(onTemplateNameChanged);
        updateConversionTypes();
        if (_this.defaultTemplateType) {
            _this.selectedType(_this.defaultTemplateType);
        }
        _this.conversionTypeObservable
            .takeUntil(_this.destroyObservable)
            .distinctUntilChanged()
            .subscribeOnNext(onTypeChanged);
        _this.conversionTemplateObservable
            .takeUntil(_this.destroyObservable)
            .distinctUntilChanged()
            .subscribeOnNext(onTemplateChanged);
    };
    this.$postLink = function () {
        _this.promptWidthNum = parseInt(_this.promptWidth);
        if (!_.isNumber(_this.promptWidthNum) || _this.promptWidthNum < 1 || Number.isNaN(_this.promptWidthNum)) {
            _this.promptWidthNum = 3;
        }
        $attrs.$observe('required', function (nowRequired) {
            _this.isRequired = nowRequired;
        });
        $attrs.$observe('disabled', function (nowDisabled) {
            _this.isDisabled = nowDisabled;
        });
        $animate.on('setClass', $element, onChildClassChanged);
    };
    this.$onChanges = function (changes) {
        if (_.has(changes, 'typeWhitelist')
            || _.has(changes, 'includePassthrough')
            || (_.isEmpty(_this.typeWhitelist) && _.has(changes, 'collection'))) {
            updateConversionTypes();
        }
        if (_.has(changes, 'typeWhitelist') || _.has(changes, 'collection')) {
            onTemplateNameChanged(_this.ngModelCtrl.$viewValue);
            updateTemplateChoices();
        }
    };
    this.$onDestroy = function () {
        _this.destroyObservable.onCompleted();
    };
}
angular.module('prism-ui.components').component('conversionTemplateDropdown', {
    bindings: {
        /*
         collection:          (array; required) List of conversion templates
                              to pick from.
         defaultTemplateType: (string; optional) When template name is removed
                              programmatically, this template type is selected.
                              Default = null
         ngModel:             (any; required) Value == the name of the
                              selected template. Handled by ngModelCtrl.
         */
        collection: '<',
        defaultTemplateType: '<?',
        /*
         Component attributes
         forceTypeRequired: (boolean; optional) If true, forces user to select
                         a template type. However, template is allowed to be null.
                         To require a template to be selected, use ngRequired.
                         If false, ngRequired determines if type must be selected.
         Note: ngRequired & ngDisabled processed via $attrs, not the bindings.
         */
        id: '@',
        ngRequired: '<',
        ngDisabled: '<',
        forceTypeRequired: '<?',
        /*
         Display attributes
         promptWidth:         (integer; optional) A number between 1-11 that
                              determines which col-md-## class to use.
                              Default = 3
         typeTooltipTemplate: (string; optional) Path to tooltip html to use
                              for the type dropdown.
         typeTooltipClass:    (string; optional) Class to add onto the tooltip
                              html specified above.
         */
        promptWidth: '@',
        typeTooltipTemplate: '<?',
        typeTooltipClass: '@?',
        /*
         Selection Responses
         typePrompt:        (string; required) String to display
                            next to type selection dropdown
         templatePromptPrefix: (string; optional) When a template type is selected,
                               this is the first part of the prompt to display.
         templatePromptSuffix: (string; optional) When a template type is selected,
                               this is the last part of the prompt to display.
         typeWhitelist: (string[]; optional) If specified, determines which types
                            can be selected.
                        If array only has one value && not including Passthrough,
                            the type prompt will not appear.
                            Type always == the single value. Also, forcibly sets
                            defaultTemplateType == the single value.
                        If not specified, user can select any type that has
                            templates in the system.
         includePassthrough: (boolean; optional) If specified, will add "Passthrough"
                             as a template type. This type sets the template == null.
         */
        typePrompt: '@',
        templatePromptPrefix: '@',
        templatePromptSuffix: '@',
        typeWhitelist: '<',
        includePassthrough: '<',
        /*
         Events
         onTypeChange:     (function; optional) Is invoked every time
                           a different type is selected. E.g.
                           onTypeChange(newType)
         onTemplateChange: (function; optional) Is invoked every time
                           a different template is selected. E.g.
                           onTypeChange(newTemplate)
         ngChange:         (function; optional) Is invoked every time
                           a different template is selected.
                           Handled by ngModelCtrl.
         */
        // TODO: In Angular 2, replace function calls with Observables?
        onTypeChange: '&?',
        onTemplateChange: '&?',
    },
    require: {
        ngModelCtrl: '^ngModel',
    },
    controller: ConversionTemplateDropdownController,
    templateUrl: 'components/visual/conversionTemplateDropdown/conversion-template-dropdown-template.html'
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: contacts-list-component.ts
 *
 * Created by randysorensen on 6/4/18.
 */
function ContactsListController(_, $timeout, uiGridConstants, ModalService) {
    var _this = this;
    var getContactsList = function () {
        var contactsList;
        if (_this.modelProp) {
            contactsList = _.get(_this.ngModel, _this.modelProp);
        }
        else {
            contactsList = _.get(_this, 'ngModel');
        }
        return contactsList;
    };
    var initGrid = function () {
        _this.gridOptions = {
            rowSelection: true,
            enableRowHeaderSelection: false,
            enableSelectAll: true,
            enableColumnResizing: true,
            enablePaginationControls: false,
            enableSorting: true,
            enableColumnMenus: false,
            enableFullRowSelection: true,
            enableHorizontalScrollbar: uiGridConstants.ALWAYS,
            enableVerticalScrollbar: uiGridConstants.ALWAYS,
            multiSelect: true,
            onRegisterApi: function (gridApi) {
                _this.gridApi = gridApi;
            },
            rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
        };
        _this.gridOptions.columnDefs = [
            {
                name: 'checkMarkRowHeaderCol',
                field: 'checkMark',
                width: 30,
                enableSorting: false,
                enableColumnResizing: false,
                headerCellTemplate: 'components/visual/grid/header-check-mark-component-template.html',
                cellTemplate: 'components/visual/grid/check-mark-template.html'
            },
            {
                field: 'firstName',
                type: 'string',
                width: '25%',
                enableColumnResizing: true,
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 2
                },
                displayName: 'First Name',
            },
            {
                field: 'lastName',
                type: 'string',
                width: '25%',
                enableColumnResizing: true,
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 1
                },
                displayName: 'Last Name',
            },
            {
                field: 'emailAddress',
                type: 'string',
                width: '*',
                enableColumnResizing: true,
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 3
                },
                displayName: 'Email Address',
            }
        ];
    };
    this.onSelectAllToggled = function ($event) {
        if (_this.gridApi.selection.getSelectAllState()) {
            _this.gridApi.selection.clearSelectedRows();
        }
        else {
            _this.gridApi.selection.selectAllRows();
        }
    };
    var contactsSelected = function (selectedContacts) {
        _.forEach(selectedContacts, function (contact) {
            // at least one contact added - dirty the form
            _this.editorForm.$setDirty();
            getContactsList().push(contact);
        });
    };
    this.onAddContactsClick = function ($event) {
        var existingContactIds = _.map(getContactsList(), 'id');
        ModalService.showContactsSelectModal(existingContactIds, contactsSelected);
        // defocus button
        $event.target.blur();
    };
    this.onRemoveContactsClick = function ($event) {
        var selectedContacts = _this.gridApi.selection.getSelectedRows();
        _.forEach(selectedContacts, function (contact) {
            _this.gridApi.selection.unSelectRow(contact);
            // at least one contact removed - dirty the form
            _this.editorForm.$setDirty();
            _.remove(getContactsList(), contact);
        });
        // defocus button
        $event.target.blur();
    };
    var assignGridData = function () {
        if (_.isNil(getContactsList())) {
            if (_this.modelProp) {
                _.set(_this, "ngModel." + _this.modelProp, []);
            }
            else {
                _.set(_this, 'ngModel', []);
            }
        }
        _.set(_this, 'gridOptions.data', getContactsList());
    };
    this.$onInit = function () {
        initGrid();
    };
    this.$onChanges = function () {
        assignGridData();
    };
}
angular.module('prism-ui.components').component('contactsList', {
    controller: ContactsListController,
    templateUrl: 'components/visual/contactsList/contacts-list-template.html',
    bindings: {
        ngModel: '<',
        modelProp: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: dropdown-component.ts
 *
 * Created by kyang on 2019-11-05.
 */
// TODO: Don't use old scss for styles (button)
function DropdownController(_, DropdownService, DropdownMultiSelectService, DropdownSingleSelectService) {
    var _this = this;
    // Values from component's properties override these values
    // Note: Selection field refers to ngModelCtrl's modelValue instead
    var defaultConfig = {
        prompt: '',
        collection: null,
        labelPath: null,
        labelFunction: null,
        itemDisablePath: 'disabled',
        clearable: false,
        selection: null,
        isMultiSelect: false,
        filter: '',
    };
    //===================//
    // Template Response //
    //===================//
    this.toggleItemsVisibility = function () {
        _this.areItemsVisible = !_this.areItemsVisible;
        if (_this.areItemsVisible) {
            _.invoke(_this, 'onDropdownOpened');
        }
    };
    this.onKeyDown = function ($event) {
        if (DropdownService.tryUpdateFilter(_this.config, $event)) {
            $event.preventDefault();
            $event.stopPropagation();
        }
        // TODO: Navigate list
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$doCheck = function () {
        if (!_this.config) {
            return;
        }
        if (!_.isEmpty(_this.configKeysChanged)) {
            // Change object reference to update child components
            _this.config = Object.defineProperties({}, Object.getOwnPropertyDescriptors(_this.config));
            _this.configKeysChanged = {};
        }
        if (_this.wereItemsVisible && !_this.areItemsVisible) {
            _this.config.filter = '';
        }
        _this.wereItemsVisible = _this.areItemsVisible;
    };
    this.$onInit = function () {
        _this.areItemsVisible = false;
        _this.wereItemsVisible = false;
        _this.configKeysChanged = {};
        _this.config = {};
        // Inside get & set functions, "this" == the config object
        var self = _this;
        // The config exposes a few properties from this component to its children.
        // If a child updates the config, the parent's property is set.
        //
        // ... Mainly to let the children see when this component's collection changes,
        // and to let the children update the this component's selection property
        //
        // TODO: In Angular 2, check to see if this causes "ExpressionChangedAfterItHasBeenChecked" error.
        //  Tests imply that it won't happen, but if it does, try:
        //      a) Manually invoke changeDetector
        //      b) Rewire services & components to use observables, not the current config
        //          - Should still use one config object to represent the entire dropdown
        Object.defineProperties(_this.config, _.mapValues(defaultConfig, function (defaultValue, fieldName) {
            if (self[fieldName] === undefined) {
                self[fieldName] = defaultValue;
            }
            return {
                enumerable: true,
                get: function () {
                    if (fieldName === 'selection') {
                        return self.ngModelCtrl.$modelValue;
                    }
                    return self[fieldName];
                },
                set: function (newValue) {
                    self.configKeysChanged[fieldName] = true;
                    if (fieldName === 'selection') {
                        self.ngModelCtrl.$setViewValue(newValue);
                    }
                    else {
                        self[fieldName] = newValue;
                    }
                },
            };
        }));
        if (_this.isMultiSelect) {
            _this.selectService = DropdownMultiSelectService;
        }
        else {
            _this.selectService = DropdownSingleSelectService;
        }
    };
}
angular.module('prism-ui.components').component('dropdown', {
    bindings: {
        /*
         collection:  (array; required) List of items to pick from.
         modelProp:   (string; required) Name of a property in each item,
                      used to uniquely identify the option.
                      Used to be set as modelValue for single selection
         ngModel:     (any; required) Value == the items selected in the dropdown.
                      Handled by ngModelCtrl.
         */
        collection: '<',
        collectionFilter: '<?',
        modelProp: '<?',
        // Component attributes
        clearable: '<?',
        isDisabled: '<?ngDisabled',
        isMultiSelect: '<',
        enableSelectAll: '<?',
        /*
         Selection Responses
         prompt:          (string; required) String to display
                          when no items selected. To changed during runtime, use {{ ... }}
         labelPath:       (string; required) Path to a property in each item,
                          used to display currently selected item in button.
         labelFunction:   (function; optional) Returned value is displayed
                          when this item is selected.
                          Overrides label field behaviour. E.g.
                          labelFunction(item, labelPath)
                          Warning: Function is only called when the selection, or collection changes.
                              Labels will not be recomputed if the item's properties change.

         itemDisablePath:  (string; optional) Path to a property in each item.
                           If property is set, user cannot interact with this item.
                           If property is set to a blank string, items cannot be disabled.
                           If not specified, defaults to: 'disabled'
         */
        prompt: '@',
        labelPath: '@',
        labelFunction: '=?',
        itemDisablePath: '@?',
        /*
         Display attributes
         attachToBody: (boolean; optional) If true, creates dropdown-list in <body> tag.
                       Otherwise, creates it as a child of this component. Used to display
                       lists that won't get truncated by the dropdown's parent.
                       If not specified, defaults to: false
         maxHeight:    (number; optional) Path to a property in each item,
                       used to display currently selected item in button.
                       If not specified, uses default dropdown height (specified in css).
         */
        btnMinWidth: '<?',
        dropup: '<?',
        attachToBody: '<?',
        maxHeight: '<?',
        /*
         Events
         ngChange: (function; optional) Is invoked every time
                   the selection is modified.
                   Handled by ngModelCtrl.

         */
        // TODO: In Angular 2, replace function calls with Observables?
        onDropdownOpened: '&?',
    },
    require: {
        ngModelCtrl: '^ngModel',
    },
    controller: DropdownController,
    templateUrl: 'components/visual/dropdown/dropdown-template.html'
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: email-recipients-list-component.ts
 *
 * Created by randysorensen on 4/19/18.
 */
function EmailRecipientsListController(_, $timeout, uiGridConstants, ModalService, UtilsService) {
    var _this = this;
    var getRecipientsList = function () {
        var recipientsList;
        if (_this.modelProp) {
            recipientsList = _.get(_this.ngModel, _this.modelProp);
        }
        else {
            recipientsList = _.get(_this, 'ngModel');
        }
        return recipientsList;
    };
    var initGrid = function () {
        _this.gridOptions = {
            rowSelection: true,
            enableRowHeaderSelection: false,
            enableSelectAll: true,
            enableColumnResizing: true,
            enablePaginationControls: false,
            enableSorting: true,
            enableColumnMenus: false,
            enableFullRowSelection: true,
            enableHorizontalScrollbar: uiGridConstants.ALWAYS,
            enableVerticalScrollbar: uiGridConstants.ALWAYS,
            multiSelect: true,
            onRegisterApi: function (gridApi) {
                _this.gridApi = gridApi;
            },
            rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
        };
        _this.gridOptions.columnDefs = [
            {
                name: 'checkMarkRowHeaderCol',
                field: 'checkMark',
                width: 30,
                enableSorting: false,
                enableColumnResizing: false,
                headerCellTemplate: 'components/visual/grid/header-check-mark-component-template.html',
                cellTemplate: 'components/visual/grid/check-mark-template.html'
            },
            {
                field: 'contact.firstName',
                type: 'string',
                width: '15%',
                enableColumnResizing: true,
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 2
                },
                displayName: 'First Name',
            },
            {
                field: 'contact.lastName',
                type: 'string',
                width: '17.5%',
                enableColumnResizing: true,
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 1
                },
                displayName: 'Last Name',
            },
            {
                field: 'contact.emailAddress',
                type: 'string',
                width: '*',
                enableColumnResizing: true,
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 3
                },
                displayName: 'Email Address',
            },
            {
                field: 'applicableNetworks',
                type: 'string',
                width: '20%',
                enableColumnResizing: true,
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 4
                },
                cellTemplate: 'components/visual/emailRecipientsList/gridTemplates/networks-list-cell-template.html',
                displayName: 'Networks',
            },
            {
                field: 'longFormFlag',
                type: 'string',
                width: '12%',
                enableColumnResizing: true,
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 5
                },
                displayName: 'Long Form',
            },
            {
                field: 'shortFormFlag',
                type: 'string',
                width: '12%',
                enableColumnResizing: true,
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 6
                },
                displayName: 'Short Form',
            },
        ];
    };
    this.onSelectAllToggled = function ($event) {
        if (_this.gridApi.selection.getSelectAllState()) {
            _this.gridApi.selection.clearSelectedRows();
        }
        else {
            _this.gridApi.selection.selectAllRows();
        }
    };
    var onUpdateRecipient = function (recipient) {
        var existingRecipient = _.find(getRecipientsList(), {
            contact: recipient.contact,
        });
        if (existingRecipient === undefined) {
            console.warn('Unable to update recipient:');
            console.warn(recipient);
        }
        else if (UtilsService.compareBasic(existingRecipient, recipient) !== 0) {
            existingRecipient.applicableNetworks = recipient.applicableNetworks;
            existingRecipient.longFormFlag = recipient.longFormFlag;
            existingRecipient.shortFormFlag = recipient.shortFormFlag;
            _this.editorForm.$setDirty();
        }
    };
    this.onRowDblClick = function (row) {
        ModalService.showPartnerEmailRecipientModal(row.entity, onUpdateRecipient);
    };
    var contactsSelected = function (selectedContacts) {
        _.forEach(selectedContacts, function (contact) {
            // at least one contact added - dirty the form
            _this.editorForm.$setDirty();
            getRecipientsList().push({
                contact: contact,
                longFormFlag: true,
                shortFormFlag: true,
                applicableNetworks: []
            });
        });
    };
    this.onAddRecipientsClick = function ($event) {
        var existingContactIds = _.map(getRecipientsList(), 'contact.id');
        ModalService.showContactsSelectModal(existingContactIds, contactsSelected);
        // defocus button
        $event.target.blur();
    };
    this.onRemoveRecipientsClick = function ($event) {
        var selectedRecipients = _this.gridApi.selection.getSelectedRows();
        _.forEach(selectedRecipients, function (recipient) {
            _this.gridApi.selection.unSelectRow(recipient);
            // at least one contact removed - dirty the form
            _this.editorForm.$setDirty();
            _.remove(getRecipientsList(), {
                // Note: unsaved recipients have no ID yet
                contact: recipient.contact,
                longFormFlag: recipient.longFormFlag,
                shortFormFlag: recipient.shortFormFlag,
                applicableNetworks: recipient.applicableNetworks
            });
        });
        // defocus button
        $event.target.blur();
    };
    this.getNetworksList = function (rowEntity) {
        return _.map(rowEntity.applicableNetworks, 'name').sort();
    };
    var assignGridData = function () {
        if (_.isNil(getRecipientsList())) {
            if (_this.modelProp) {
                _.set(_this, "ngModel." + _this.modelProp, []);
            }
            else {
                _.set(_this, 'ngModel', []);
            }
        }
        _.set(_this, 'gridOptions.data', getRecipientsList());
    };
    this.$onInit = function () {
        initGrid();
    };
    this.$onChanges = function () {
        assignGridData();
    };
}
angular.module('prism-ui.components').component('emailRecipientsList', {
    controller: EmailRecipientsListController,
    templateUrl: 'components/visual/emailRecipientsList/email-recipients-list-template.html',
    bindings: {
        ngModel: '<',
        modelProp: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: field-validation-component.ts
 *
 * Created by kyang on 2020-09-14.
 */
//
// FieldValidation
//
// Given:
//  * a list of N objects that look something like this:
//      {
//          getDescription: function() { ... },
//          isValid: function() { ... },
//          isWarning: function() { ... },
//      }
//
// This component displays a list of descriptions in a bulleted list.
// Bullet changes based on the output of isValid() & isWarning():
//     - If isValid() returns true, bullet is a checkmark.
//     - Otherwise, if isWarning() returns true, bullet is a warning triangle.
//     - Otherwise, bullet is an X.
//
// getDescription() is a function to allow dynamic descriptions, such as:
//     - Current length: # / 15
//
// See the bindings for the complete list of configurable options.
//
// The general concept is to indicate why a field is invalid.
function FieldValidationController(_, $animate, $element) {
    var _this = this;
    var INVALID_STATUS = 1;
    var WARNING_STATUS = 2;
    var VALID_STATUS = 3;
    //================//
    // Template Logic //
    //================//
    this.isValid = function (requirement) {
        return requirement.status === VALID_STATUS;
    };
    this.isWarning = function (requirement) {
        return requirement.status === WARNING_STATUS;
    };
    this.isFail = function (requirement) {
        return requirement.status === INVALID_STATUS;
    };
    this.getDescription = function (requirement) {
        return requirement.getDescription();
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$doCheck = function () {
        var someRequirementsInvalid = false;
        _.forEach(_this.requirements, function (requirement) {
            if (requirement.isValid()) {
                requirement.status = VALID_STATUS;
            }
            else if (_.invoke(requirement, 'isWarning')) {
                requirement.status = WARNING_STATUS;
                someRequirementsInvalid = someRequirementsInvalid || !!_this.invalidOnWarn;
            }
            else {
                requirement.status = INVALID_STATUS;
                someRequirementsInvalid = true;
            }
        });
        if (_this.editorForm) {
            _this.editorForm.$setValidity('requirements', !someRequirementsInvalid);
        }
    };
    this.$onInit = function () {
        // Workaround a bug with ng-class:
        // If class is added during a $digest cycle,
        // and next frame, the next $digest cycle tries to remove that class...
        // The class will not be removed.
        $animate.enabled($element[0], false);
    };
}
angular.module('prism-ui.components').component('fieldValidation', {
    templateUrl: 'components/visual/fieldValidation/field-validation-template.html',
    controller: FieldValidationController,
    bindings: {
        /*
         List Properties
         header:       (string; required) Text to display at the top of this list
         requirements: (JS5Object[]; required) Array of objects. Each object can
                       declare 3 functions:
                           - getDescription(): (return string; required) Current text
                                               to display for this list item
                           - isValid():   (return boolean; required) If returns true,
                                          uses a checkmark as this item's bullet
                           - isWarning(): (return boolean; optional) If not valid,
                                          and this function returns true, uses a
                                          warning triangle as this item's bullet
         invalidOnWarn: (boolean; optional) If true, warnings will invalidate this
                        component's form
         */
        header: '@',
        requirements: '<',
        invalidOnWarn: '<',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 8/18/15.
 * Converted to TypeScript by kyang on 9/24/2019.
 */
function QcNoteIconController() {
}
angular.module('prism-ui.components').component('qcNoteIcon', {
    bindings: {
        iconState: '='
    },
    controller: QcNoteIconController,
    templateUrl: 'components/visual/icon/qc-notes-icon-template.html'
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 6/1/15.
 */
function StatusIconController() {
}
angular.module('prism-ui.components').component('statusIcon', {
    bindings: {
        status: '='
    },
    controller: StatusIconController,
    templateUrl: 'components/visual/icon/status-icon-template.html',
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by randysorensen on 1/31/17.
 */
//
// RequirementList
//
// Given:
//  * a list of N objects that look something like this:
//      {
//          widget: { id: 1, ... },
//          required: true
//      }
//
//  * an array with any number 0..N of these objects, with
//    inclusion implying that the object is enabled
//
// This component creates a grid where objects can be added to
// the enabled list by selecting grid rows, and where objects
// can be marked as required in a column of checkboxes.
//
// The name of the properties in the object are configurable
// by binding, as is the name of the object's class (which will
// show up in the list header).
//
// See the bindings for the complete list of configurable options.
//
// The general concept is to allow the user to indicate that
// selections from a list are either not applicable, optional
// or required.
//
function RequirementListController(_, $attrs, $q, $scope, uiGridConstants) {
    var _this = this;
    var enabledHeaderTemplate = 'components/visual/grid/header-check-mark-component-template.html';
    var requiredHeaderTemplate = 'components/visual/requirementList/gridCells/required-column-header-cell-template.html';
    var requiredCellTemplate = 'components/visual/requirementList/gridCells/required-column-grid-cell-template.html';
    var gridApiPromise = $q.defer();
    this.disabled = $scope.$eval($attrs.ngDisabled);
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        rowHeight: 26,
        multiSelect: true,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            _this.gridApi.selection.on.rowSelectionChanged(null, _this.onEntityEnableClicked);
            // this.gridApi may now be used.
            gridApiPromise.resolve();
        },
        columnDefs: [
            {
                name: 'checkMarkRowHeaderCol',
                field: 'checkMark',
                width: 30,
                enableColumnMenu: false,
                enableSorting: false,
                enableColumnResizing: false,
                headerCellTemplate: enabledHeaderTemplate,
                cellTemplate: 'components/visual/grid/check-mark-template.html'
            },
            {
                name: 'label',
                width: 300,
                enableSorting: false,
                displayName: this.entityName,
                cellClass: 'ui-grid-cell-contents',
                cellTemplate: '<div class="padding-left-sm">{{row.entity.label}}</div>',
                enableColumnResizing: false,
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 0
                },
            },
            {
                name: 'required',
                width: 100,
                enableSorting: false,
                displayName: 'Required',
                cellClass: 'ui-grid-cell-contents',
                headerCellTemplate: requiredHeaderTemplate,
                cellTemplate: requiredCellTemplate,
                enableColumnResizing: false
            }
        ],
        data: []
    };
    //
    // Functions to convert grid data into DTO-friendly data
    //
    var findExistingEntityId = function (entityName) {
        var _a;
        var existingEntity = _.find(_this.originalEnabledEntities, (_a = {},
            _a[_this.entityProp] = {
                name: entityName
            },
            _a));
        return _.get(existingEntity, 'id', null);
    };
    var buildEntityFromGridRow = function (row) {
        var _a;
        var entity = _.find(_this.allEntities, {
            name: row.label
        });
        var newEnabledEntity = (_a = {},
            _a[_this.entityProp] = entity,
            _a[_this.requiredFlagProp] = row.required,
            _a);
        var existingEntityId = findExistingEntityId(row.label);
        if (existingEntityId) {
            newEnabledEntity.id = existingEntityId;
        }
        return newEnabledEntity;
    };
    var buildEnabledEntitiesList = function () {
        var enabledEntities = [];
        _.forEach(_this.gridApi.selection.getSelectedRows(), function (row) {
            enabledEntities.push(buildEntityFromGridRow(row));
        });
        return enabledEntities;
    };
    var dataChanged = function () {
        _this.enabledEntities = buildEnabledEntitiesList();
        _.invoke(_this, 'onUpdate', {
            context: _this.context,
            newEnabledEntities: _this.enabledEntities
        });
    };
    //
    // Event handlers
    //
    this.onEntityEnableClicked = function (row, $event) {
        if (!row.isSelected) {
            row.entity.required = false;
        }
        if ($event) {
            dataChanged();
        }
    };
    this.onEntityRequireClicked = function (row, $event) {
        $event.stopPropagation();
        row.isSelected = true;
        row.entity.required = !row.entity.required;
        dataChanged();
    };
    this.areAllEntitiesRequired = function () {
        return _this.gridOptions.data.reduce(function (allChecked, row) {
            return allChecked && row.required;
        }, _this.gridOptions.data.length > 0);
    };
    this.onSelectAllToggled = function (event) {
        if (_this.gridApi.selection.getSelectAllState()) {
            _this.gridApi.selection.clearSelectedRows(event);
            _.forEach(_this.gridOptions.data, function (row) {
                row.required = false;
            });
        }
        else {
            _this.gridApi.selection.selectAllRows();
        }
        dataChanged();
    };
    this.onRequireAllClicked = function () {
        var newVal = !_this.areAllEntitiesRequired();
        _.forEach(_this.gridOptions.data, function (row) {
            row.required = newVal;
            if (newVal) {
                _this.gridApi.grid.modifyRows(_this.gridOptions.data);
                _this.gridApi.selection.selectRow(row);
            }
        });
        dataChanged();
    };
    //
    // functions to take DTO-formed data and assemble
    // grid-friendly data
    //
    var isEnabledAndRequired = function (entityName, required) {
        //
        // Returns true if the entity with the specified name is
        // enabled; if the second argument is true, this only
        // returns true if the named entity is also required.
        //
        if (required === void 0) { required = undefined; }
        var criteria = {};
        criteria[_this.entityProp] = {
            name: entityName
        };
        if (required !== undefined) {
            criteria[_this.requiredFlagProp] = required;
        }
        return _.find(_this.enabledEntities, criteria) !== undefined;
    };
    var buildGridRow = function (entity) {
        return {
            label: entity.name,
            required: isEnabledAndRequired(entity.name, true)
        };
    };
    var buildGridData = function () {
        _this.gridOptions.data = [];
        _.forEach(_this.allEntities, function (entity) {
            _this.gridOptions.data.push(buildGridRow(entity));
        });
    };
    var selectEnabledEntityRows = function () {
        _.forEach(_this.gridOptions.data, function (row) {
            if (isEnabledAndRequired(row.label)) {
                _this.gridApi.grid.modifyRows(_this.gridOptions.data);
                _this.gridApi.selection.selectRow(row);
            }
        });
    };
    var updateGridData = function () {
        //
        // Wait until the gridApi is registered before selecting
        // rows with it.
        //
        gridApiPromise.promise.then(function () {
            if (_this.enabledEntities && _this.allEntities) {
                _this.originalEnabledEntities = _.cloneDeep(_this.enabledEntities);
                buildGridData();
                selectEnabledEntityRows();
                _this.gridApi.core.refresh();
            }
        });
    };
    this.$onChanges = function () {
        updateGridData();
    };
    updateGridData();
}
angular.module('prism-ui.components').component('requirementList', {
    templateUrl: 'components/visual/requirementList/requirement-list-template.html',
    controller: RequirementListController,
    bindings: {
        // all data object choices
        allEntities: '<',
        // arbitrary/user-defined context - passed to onUpdate
        context: '<',
        // set of enabled data object choices and whether they're required
        enabledEntities: '<',
        // the title above the first column, e.g. "Video Role" or "Language"
        entityName: '@',
        // the property name that the data object is stored by, e.g. 'language' or 'role'
        entityProp: '@',
        // callback signaling data change to parent
        onUpdate: '&',
        // the property name that the required flag is stored by, e.g. 'required' or 'isRequired'
        requiredFlagProp: '@'
    }
    //
    // Note: the 'enabledEntities' binding is one-directionally
    // bound, however as it's an object reference, changes to the
    // object's properties will be visible to the parent
    // controller.
    //
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function TextListInputController(_, $timeout) {
    var _this = this;
    this.canAddItem = function () {
        var canAdd = true;
        _.forEach(_this.items, function (item) {
            if (item.stringValue === '') {
                canAdd = false;
            }
        });
        return canAdd;
    };
    this.selectAll = function () {
        var enableDisable = function (active) {
            _.forEach(_this.items, function (item) {
                item.active = active;
            });
        };
        if (_this.selectAllActive) {
            enableDisable(true);
        }
        else {
            enableDisable(false);
        }
    };
    this.addStringItem = function (event) {
        _this.errors = false;
        if (!_this.items) {
            _this.items = [];
        }
        _this.items.push({ stringValue: '' });
        $timeout(function () {
            angular.element("#" + _this.name + "_stringInput_" + (_this.items.length - 1)).focus();
        });
    };
    this.removeStringItem = function () {
        if (!_.isEmpty(_this.items)) {
            _.pullAllBy(_this.items, [{ active: true }], 'active');
            _this.form.$setDirty();
        }
        if (_.isEmpty(_this.items)) {
            _this.errors = false;
            _this.onUpdate({
                event: {
                    name: _this.name,
                    items: undefined,
                    errors: _this.errors
                }
            });
        }
        else {
            _this.updateModel();
        }
        _this.selectAllActive = false;
    };
    this.updateModel = function (event) {
        _this.onUpdate({
            event: {
                name: _this.name,
                items: _this.items,
                errors: _this.errors
            }
        });
    };
    this.$onChanges = function (changes) {
        if (changes.items && changes.items.currentValue) {
            var changedItems = _.cloneDeep(changes.items.currentValue);
            _this.items.splice(0, _this.items.length);
            _.forEach(changedItems, function (changedItem) {
                _this.items.push(changedItem);
            });
        }
    };
}
angular.module('prism-ui.components').component('textListInput', {
    templateUrl: "components/visual/textListInput/text-list-input-template.html",
    controller: TextListInputController,
    bindings: {
        name: '@',
        componentDisabled: '=ngDisabled',
        items: '<',
        onUpdate: '&'
    },
    require: {
        form: '?^form'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 5/16/15,
 * Refactored by kyang on 12/13/19
 */
function TimecodeInputController($element) {
    var _this = this;
    /**
     * Add extra 0s in front of timecode's strings.
     * (This modifies the parameter)
     */
    var padTimecodeObj = function (timecodeObj) {
        timecodeObj.hours = timecodeObj.hours.padStart(2, '0');
        timecodeObj.minutes = timecodeObj.minutes.padStart(2, '0');
        timecodeObj.seconds = timecodeObj.seconds.padStart(2, '0');
        timecodeObj.frames = timecodeObj.frames.padStart(2, '0');
    };
    //===================//
    // NgModel Functions //
    //===================//
    /**
     * Reset displayed (scope) values based on $viewValue
     */
    var renderModelCtrl = function () {
        if (_this.ngModelCtrl.$viewValue) {
            _this.hours = _this.ngModelCtrl.$viewValue.hours;
            _this.minutes = _this.ngModelCtrl.$viewValue.minutes;
            _this.seconds = _this.ngModelCtrl.$viewValue.seconds;
            _this.frames = _this.ngModelCtrl.$viewValue.frames;
        }
        else {
            _this.hours = '';
            _this.minutes = '';
            _this.seconds = '';
            _this.frames = '';
        }
    };
    var stringToTimecodeObj = function (modelValue) {
        if (modelValue) {
            var parts = modelValue.split(/[:|;]/);
            return {
                hours: parts[0],
                minutes: parts[1],
                seconds: parts[2],
                frames: parts[3]
            };
        }
        return null;
    };
    var timecodeObjToString = function (timecodeObj) {
        // Copy in cleaned up view values to handle cases where multiple component parts are changed
        // padding only applies to the copied timecodeObj, not the parameter object
        var parsedTimecodeObj = JSON.parse(JSON.stringify(timecodeObj));
        padTimecodeObj(parsedTimecodeObj);
        return parsedTimecodeObj.hours + ':' + parsedTimecodeObj.minutes + ':' + parsedTimecodeObj.seconds + ':' + parsedTimecodeObj.frames;
    };
    //===================//
    // Template Response //
    //===================//
    this.timecodeChanged = function (currentComponent, nextComponent) {
        var newValue = _this[currentComponent].replace(/\D/g, '');
        // User typed in field & reaches length 2
        if (newValue.length === 2) {
            $element.find('#' + nextComponent)[0].focus();
            // User re-enters field and starts typing
        }
        else if (newValue.length > 2) {
            newValue = newValue.slice(2, 4);
        }
        _this[currentComponent] = newValue;
        _this.ngModelCtrl.$setViewValue({
            hours: _this.hours,
            minutes: _this.minutes,
            seconds: _this.seconds,
            frames: _this.frames
        });
        // Update timecodeCtrl's copy as well
        _this.ngModelCtrl.$render();
    };
    this.onPartExit = function (event) {
        // Update view value, model is already correct
        padTimecodeObj(_this.ngModelCtrl.$viewValue);
        // Update timecodeCtrl's copy as well
        _this.ngModelCtrl.$render();
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.ngModelCtrl.$render = renderModelCtrl;
        // Called whenever the model is changed programmatically and also on initial loading.
        // $viewValue is set == Returned value
        _this.ngModelCtrl.$formatters.push(stringToTimecodeObj);
        // Called when the view value is set manually as done in timecodeChanged
        // $modelValue is set == Returned value
        _this.ngModelCtrl.$parsers.push(timecodeObjToString);
    };
}
angular
    .module('prism-ui.components')
    .component('timecodeInput', {
    bindings: {
        componentDisabled: '=ngDisabled',
        dropFrame: '=',
        rootClass: '@',
    },
    require: {
        ngModelCtrl: '^ngModel'
    },
    controller: TimecodeInputController,
    templateUrl: 'components/visual/timecode/timecodeinput-template.html',
});

function TranslatableMetadataController(_, $q, LanguagesService, TranslatableMetadataService) {
    //=======================
    // Internal Functions
    //=======================
    var _this = this;
    var getSortedLanguageList = function (allLanguages, dataObject) {
        // if the dataObject has an `originalLanguage` property,
        // that will always be first
        var originalLanguage = _.find(allLanguages, { id: _.get(dataObject, 'originalLanguage.id') });
        // find the root translatable text language
        var rootLanguage = _.find(allLanguages, { id: _.get(dataObject, 'translatableText.language.id') });
        // find the default language in the system
        var defaultLanguage = _.find(allLanguages, { isDefault: true });
        // find all translated languages in the data object and sort them by name
        var translatedLanguages = _.chain(dataObject)
            .get('translatableText.translations')
            .map(function (translation) { return _.find(allLanguages, { id: translation.language.id }); })
            .sortBy('name')
            .value();
        // make an ordered list of all used languages
        var usedLanguages = [];
        if (_.get(originalLanguage, 'id')) {
            usedLanguages.push(originalLanguage.id);
        }
        if (_.get(rootLanguage, 'id') && _.get(originalLanguage, 'id') && rootLanguage.id !== originalLanguage.id) {
            usedLanguages.push(rootLanguage.id);
        }
        if (!_.includes(usedLanguages, defaultLanguage.id)) {
            usedLanguages.push(defaultLanguage.id);
        }
        usedLanguages.push.apply(usedLanguages, _.map(translatedLanguages, 'id'));
        // make another list of all unused languages
        var unusedLanguages = _.chain(allLanguages)
            .filter(function (language) { return !_.includes(usedLanguages, language.id); })
            .map('id')
            .value();
        var languages = [];
        languages.push.apply(languages, _.map(usedLanguages, function (language) { return _.find(allLanguages, { id: language }); }));
        languages.push.apply(languages, _.map(unusedLanguages, function (language) { return _.find(allLanguages, { id: language }); }));
        return languages;
    };
    var getTranslationForLanguage = function (languageId) {
        return _.find(_this.dataObject.translatableText.translations, { language: { id: languageId } });
    };
    var createTranslationForLanguage = function (languageId) {
        var translation = {
            language: {
                id: languageId,
                aliasCount: 0
            }
        };
        _.forEach(_this.fields, function (field) {
            translation[field.name] = '';
        });
        if (!_.get(_this, 'dataObject.translatableText.translations')) {
            _this.dataObject.translatableText.translations = [];
        }
        _this.dataObject.translatableText.translations.push(translation);
        return getTranslationForLanguage(languageId);
    };
    var setSelectedLanguageTranslation = function () {
        var selectedLanguageId = _.get(_this, 'selectedLanguage.id');
        if (selectedLanguageId === _this.dataObject.translatableText.language.id) {
            // edit the root translatable
            _this.translation = _this.dataObject.translatableText;
        }
        else {
            // edit one of the translations
            _this.translation = getTranslationForLanguage(selectedLanguageId);
            // if the translation doesn't exist, create it and
            // edit the created one
            if (!_this.translation) {
                _this.translation = createTranslationForLanguage(selectedLanguageId);
            }
        }
    };
    var captureDataObject = function () {
        return $q.all({
            languages: LanguagesService.getAllLanguages(),
            dataObject: TranslatableMetadataService.dataObjectPromise,
        }).then(function (data) {
            _this.languages = getSortedLanguageList(data.languages, data.dataObject);
            _this.dataObject = data.dataObject;
            // initialize translatable text object if it doesn't
            // exist
            if (!_.get(_this, 'dataObject.translatableText')) {
                _this.dataObject.translatableText = {
                    language: _this.languages[0],
                    translations: [],
                };
            }
        });
    };
    //===============//
    // Service Hooks //
    //===============//
    var preSave = function () {
        console.log("preSave() hook called");
        _.remove(_this.dataObject.translatableText.translations, function (translation) {
            var fields = ['value', 'title', 'shortDescription', 'longDescription', 'keywords'];
            // return _.every(fields, (field: JS5Object) => !_.get(translation, field, undefined));
            var shouldRemove = _.every(fields, function (field) { return !_.get(translation, field, undefined); });
            var translationName = _.find(_this.languages, { id: translation.language.id }).name;
            if (shouldRemove) {
                console.log("removing translation: " + translationName);
            }
            else {
                console.log("not removing translation: " + translationName);
            }
            return shouldRemove;
        });
    };
    var onSave = function () {
        var selectedLanguageId = _.get(_this, 'selectedLanguage.id', _this.languages[0]);
        captureDataObject().then(function () {
            _this.selectedLanguage = _.find(_this.languages, { id: selectedLanguageId });
            setSelectedLanguageTranslation();
        });
    };
    var onRevert = function () {
        captureDataObject().then(function () {
            _this.selectedLanguage = _this.languages[0];
            setSelectedLanguageTranslation();
        });
    };
    //=======================
    // Template Logic
    //=======================
    this.isFieldEnabled = function (name) {
        return _.find(_this.fields, { name: name }) != undefined;
    };
    this.isFieldRequired = function (name) {
        var field = _.find(_this.fields, { name: name });
        return _.get(field, 'required', false);
    };
    this.getFieldTitle = function (name) {
        return _.get(_.find(_this.fields, { name: name }), 'title', 'undefined');
    };
    this.getFieldMaxChars = function (name) {
        var field = _.find(_this.fields, { name: name });
        return _.get(field, 'maxChars', -1);
    };
    this.onLanguageChange = function () {
        setSelectedLanguageTranslation();
    };
    this.clearAllFields = function () {
        _this.editorForm.$setDirty();
        _.forEach(_this.fields, function (field) {
            _this.translation[field.name] = '';
        });
    };
    //=======================
    // Lifecycle Hooks
    //=======================
    this.$onDestroy = function () {
        TranslatableMetadataService.resetDataObjectPromise();
    };
    this.$onInit = function () {
        // binding defaults
        _this.formTitle = _this.formTitle || 'METADATA';
        TranslatableMetadataService.preSave = preSave;
        TranslatableMetadataService.onSave = onSave;
        TranslatableMetadataService.onRevert = onRevert;
        captureDataObject().then(function () {
            _this.selectedLanguage = _this.languages[0];
            setSelectedLanguageTranslation();
        });
    };
}
angular
    .module('prism-ui.components')
    .component('translatableMetadata', {
    templateUrl: 'components/visual/translatableMetadata/translatable-metadata-template.html',
    controller: TranslatableMetadataController,
    bindings: {
        fields: '<',
        formTitle: '<?',
    },
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 2/3/16,
 * Refactored by kyang on 9/27/19
 */
function CalendarController(_, $filter, $location, BreadcrumbService, SidebarService) {
    //======//
    // Grid //
    //======//
    var _this = this;
    this.currentGridOptions = {
        rowHeight: 26,
        columnDefs: this.columnDefs,
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableFullRowSelection: true,
        multiSelect: true,
        enableColumnMenus: false,
        enableSorting: false,
        enableColumnResizing: true,
        enableVerticalScrollbar: 2,
        rowTemplate: 'dashboard/calendars/base/gridTemplates/calendar-row-template.html'
    };
    this.rowDoubleClicked = function (row, tab) {
        BreadcrumbService.addBreadcrumb({
            location: '/packages',
            name: 'Packages - Edit',
            params: angular.copy($location.search())
        });
        var url = '';
        if (row.parentPackageId) {
            url = '/packages/package/edit/' + row.parentPackageId + '/liveClip?livePackageId=' + row.packageId;
        }
        else {
            url = '/packages/package/edit/' + row.packageId + (tab || '/metadata');
        }
        SidebarService.goToUrl(url, 'packages', 'calendars');
    };
    var sortKeys = function (data) {
        var keys = Object.keys(data);
        keys.sort(function (a, b) {
            var aTime = new Date(a).getTime();
            var bTime = new Date(b).getTime();
            if (isNaN(aTime) && isNaN(bTime)) {
                if (data[a].position < data[b].position) {
                    return -1;
                }
                else {
                    return 1;
                }
            }
            else if (isNaN(aTime)) {
                return -1;
            }
            else if (isNaN(bTime)) {
                return 1;
            }
            else {
                if (aTime < bTime) {
                    return -1;
                }
                else {
                    return 1;
                }
            }
        });
        return keys;
    };
    var createGroupings = function (data) {
        var customGridItems = [];
        var todayItems = [];
        var laterItems = [];
        var sortedKeys = sortKeys(data);
        angular.forEach(sortedKeys, function (key) {
            var val = data[key];
            var header = { header: true, title: key };
            if (val.data && val.data.length) {
                if (val.style) {
                    header.style = val.style;
                    customGridItems.push(header);
                    customGridItems = customGridItems.concat(val.data);
                    header.title = key;
                }
                else {
                    var dateKey = new Date(key);
                    if (!isNaN(dateKey.getTime())) {
                        if (dateKey.setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0)) {
                            header.style = 'today-cal-header';
                            todayItems.push(header);
                            todayItems = todayItems.concat(val.data);
                        }
                        else {
                            header.style = 'default-cal-header';
                            laterItems.push(header);
                            laterItems = laterItems.concat(val.data);
                        }
                        header.title = $filter('amDateFormat')(dateKey, 'dddd MMMM DD, YYYY');
                    }
                }
            }
        });
        return _.concat(customGridItems, todayItems, laterItems);
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        if (_this.gridData) {
            _this.currentGridOptions.data = createGroupings(_this.gridData);
        }
        if (_this.columnDefs) {
            _this.currentGridOptions.columnDefs = _this.columnDefs;
        }
    };
    this.$onChanges = function (changes) {
        if (_.get(changes, 'gridData.currentValue')) {
            _this.currentGridOptions.data = createGroupings(changes.gridData.currentValue);
        }
        if (_.get(changes, 'columnDefs.currentValue')) {
            _this.currentGridOptions.columnDefs = changes.columnDefs.currentValue;
        }
    };
    this.$onDestroy = function () {
        SidebarService.ignoreNavUpdates = false;
    };
}
angular.module('prism-ui.calendars').component('calendar', {
    bindings: {
        columnDefs: '=',
        gridData: '=',
        allowRowClick: '=',
        calName: '@'
    },
    controller: CalendarController,
    templateUrl: 'dashboard/calendars/base/calendar-template.html',
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: dashboard-panel-component.ts
 *
 * Created by randysorensen on 2019-02-19.
 */
function DashboardPanelController(_, MetricsDashboardService) {
    var _this = this;
    var onMetricsDataUpdated = function (newMetricsData) {
        _this.metricsData = _.cloneDeep(newMetricsData);
    };
    this.getPanelData = function () {
        return _.get(_this, 'panelData') || _.get(_this, "metricsData[" + _this.panelDataProperty + "]");
    };
    this.$onInit = function () {
        _this.metricsData = {};
        MetricsDashboardService.registerDataUpdateCallback(onMetricsDataUpdated);
    };
}
angular.module('prism-ui.metricsDashboard').component('dashboardPanel', {
    controller: DashboardPanelController,
    templateUrl: 'dashboard/metrics/dashboard-panels/dashboard-panel-template.html',
    bindings: {
        headerBGColor: '<',
        headerTextSize: '<',
        headerLabel: '<',
        panelData: '<',
        panelDataProperty: '<',
        panelTemplateUrl: '<',
        panelTextSize: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: metrics-filter-modal-component.ts
 *
 * Created by randysorensen on 2019-02-14.
 */
function MetricsFilterModalController(_, DynamicPropertiesService, MetricsDashboardService, UtilsService) {
    var _this = this;
    var allPartners = [];
    var createYearsCollection = function () {
        var currentYear = new Date().getFullYear();
        var startYear = UtilsService.constants.EARLIEST_RECORD_YEAR;
        _this.years = _.range(startYear, currentYear + 1);
    };
    //=======================//
    // Filter Getter/Setters //
    //=======================//
    this.fromDateMonth = function (newMonth) {
        if (newMonth === void 0) { newMonth = null; }
        if (newMonth) {
            _this.currentCriteria.fromDate.setMonth(_.indexOf(UtilsService.constants.MONTHS, newMonth));
        }
        return UtilsService.constants.MONTHS[_this.currentCriteria.fromDate.getMonth()];
    };
    this.fromDateYear = function (newYear) {
        if (newYear === void 0) { newYear = null; }
        if (newYear) {
            _this.currentCriteria.fromDate.setFullYear(newYear);
        }
        return _this.currentCriteria.fromDate.getFullYear();
    };
    this.toDateMonth = function (newMonth) {
        if (newMonth === void 0) { newMonth = null; }
        if (newMonth) {
            _this.currentCriteria.toDate.setMonth(_.indexOf(UtilsService.constants.MONTHS, newMonth));
        }
        return UtilsService.constants.MONTHS[_this.currentCriteria.toDate.getMonth()];
    };
    this.toDateYear = function (newYear) {
        if (newYear === void 0) { newYear = null; }
        if (newYear) {
            _this.currentCriteria.toDate.setFullYear(newYear);
        }
        return _this.currentCriteria.toDate.getFullYear();
    };
    //===================//
    // Template Controls //
    //===================//
    var deselectPartnersBasedOnType = function () {
        var selectedPartnerTypes = _this.currentCriteria.partnerTypes;
        var selectedPartners = _.cloneDeep(_this.currentCriteria.partners);
        _.remove(selectedPartners, function (partner) {
            var otherEnabled = _.includes(selectedPartnerTypes, 'Other');
            var partnerTypeIsOther = !_.includes(_this.availablePartnerTypes, partner.type);
            var removePartner = false;
            if (partnerTypeIsOther) {
                removePartner = !otherEnabled;
            }
            else {
                removePartner = !_.includes(selectedPartnerTypes, partner.type);
            }
            return removePartner;
        });
        _this.currentCriteria.partners = selectedPartners;
    };
    this.onPartnerTypeSelectionsChanged = function () {
        if (_this.currentCriteria.partnerTypes.length > 0) {
            deselectPartnersBasedOnType();
        }
        updatePartnerDropdownLabel();
    };
    this.onAcceptCriteria = function ($event, setToDefault) {
        $event.target.blur();
        $event.stopImmediatePropagation();
        if (setToDefault) {
            _this.currentCriteria = MetricsDashboardService.createDefaultCriteria();
        }
        if (_this.currentCriteria.partners.length === allPartners.length) {
            _this.currentCriteria.partners = [];
        }
        MetricsDashboardService.setCurrentCriteria(_this.currentCriteria);
        _this.close();
    };
    this.dateRangeIsInvalid = function () {
        var nextMonth = new Date();
        nextMonth.setMonth(nextMonth.getMonth() + 1);
        return (_this.currentCriteria.fromDate > _this.currentCriteria.toDate ||
            _this.currentCriteria.fromDate >= nextMonth ||
            _this.currentCriteria.toDate >= nextMonth);
    };
    this.applyButtonEnabled = function () { return !_this.dateRangeIsInvalid(); };
    //
    // Returns a list of partners filtered by the specified
    // partner types
    //
    var filterPartnersByPartnerTypes = function (selectedPartnerTypes) {
        return _.filter(allPartners, function (partner) {
            var typeMatch = _.includes(selectedPartnerTypes, partner.type);
            // partner has no type and 'Other' is selected
            var noTypeMatch = (_.includes(selectedPartnerTypes, 'Other') &&
                !_.includes(_this.availablePartnerTypes, partner.type));
            return typeMatch || noTypeMatch;
        });
    };
    //
    // A memoize'd variant of the above function which prevents
    // AngularJS from over-$digest()'ing
    //
    var memoizedFilterPartnerByPartnerTypes = _.memoize(filterPartnersByPartnerTypes, function (key) { return key.join('|'); });
    this.getAvailablePartners = function () {
        var partners = allPartners;
        if (_this.currentCriteria.partnerTypes.length > 0) {
            partners = memoizedFilterPartnerByPartnerTypes(_this.currentCriteria.partnerTypes);
        }
        return partners;
    };
    var updatePartnerDropdownLabel = function () {
        var label = 'Select ';
        if (_.get(_this, 'currentCriteria.partnerTypes', []).length) {
            label += _this.currentCriteria.partnerTypes.join(' / ') + ' ';
        }
        label += 'Partner(s)';
        _this.partnerDropdownLabel = label;
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        allPartners = MetricsDashboardService.getAllAvailablePartners();
        DynamicPropertiesService.queryForProperties().then(function () {
            _this.availablePartnerTypes = _
                .concat(DynamicPropertiesService.getPropValueAsList('partner.types'));
        });
        _this.months = _.cloneDeep(UtilsService.constants.MONTHS);
        createYearsCollection();
        updatePartnerDropdownLabel();
        _this.currentCriteria = MetricsDashboardService.getCurrentCriteria();
    };
}
angular.module('prism-ui.components').component('metricsFilterModal', {
    controller: MetricsFilterModalController,
    templateUrl: 'dashboard/metrics/metrics-filter-modal/metrics-filter-modal-template.html',
    bindings: {
        close: '&',
        dismiss: '&',
        resolve: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 7/25/16.
 */
function WorkflowSearchViewController(_, $filter, $interval, $location, $q, $timeout, uiGridConstants, GridService, BreadcrumbService, ModalService, NavbarUtilService, PaginationService, PermissionsService, SearchFilterService, WorkflowsService) {
    var _this = this;
    var refreshInterval;
    //======================//
    // Configuration Values //
    //======================//
    var REFRESH_DELAY = 30000;
    var TREE_LEVEL_PADDING = 15;
    var ACTION_TO_PENDING_STATE_NAME = {
        resume: 'EXECUTING',
        pause: 'PAUSED',
        abandon: 'ABANDONED'
    };
    //==================//
    // Update Grid Rows //
    //==================//
    var addPendingStatusRequest = function (workflow, action) {
        var newStatus = ACTION_TO_PENDING_STATE_NAME[action];
        if (newStatus) {
            _this.pendingStatusRequests[workflow.id] = {
                currentStatus: workflow.status,
                newStatus: newStatus,
                // Add dateRequested for debugging purposes
                dateRequested: new Date(),
            };
            workflow.pendingStatus = newStatus;
        }
    };
    // Function flattens the newTopLevels tree into gridData by modifying newTopLevels array (in-place)
    var flattenExpandedSubflows = function (newTopLevels, subflowsByParentId, parentIterationOrder) {
        // Note: parentIterationOrder is ordered so that parents are found before any of its descendants
        _.forEach(parentIterationOrder, function (parentId) {
            var subflows = subflowsByParentId[parentId];
            // Ordering forces expandedItem's parent workflow to be processed,
            // ensuring expandedItem is in newTopLevels (aka: partially flattened grid data)
            var expandedItem = newTopLevels.filter(function (item) { return item.id === parentId; })[0];
            if (expandedItem) {
                var itemIndex = newTopLevels.indexOf(expandedItem) + 1;
                expandedItem.expanded = true;
                expandedItem.subflows = subflows;
                newTopLevels.splice.apply(newTopLevels, [itemIndex, 0].concat(expandedItem.subflows));
                _this.currentPageSize += subflows.length;
                // Case occurs when previously expanded parent is no longer in the grid (For example: Going to a new page of workflows)
            }
            else {
                WorkflowsService.removeItemFromExpandedWorkflows(parentId);
            }
        });
        return newTopLevels;
    };
    var updateGridRow = function (gridIndex, workflow) {
        _.forEach(_this.gridOptions.data[gridIndex], function (value, key, row) {
            if (!_.isEqual(value, workflow[key])) {
                row[key] = workflow[key];
            }
        });
    };
    var updateGridData = function (newWorkflowData) {
        var newWorkflowsById = {};
        var newIndex = 0;
        var gridIndex = 0;
        newWorkflowData.forEach(function (workflow) {
            var pendingRequest = _this.pendingStatusRequests[workflow.id];
            if (pendingRequest && pendingRequest.currentStatus === workflow.status && !workflow.pendingStatus) {
                workflow.pendingStatus = pendingRequest.newStatus;
            }
            else {
                delete _this.pendingStatusRequests[workflow.id];
            }
            newWorkflowsById[workflow.id] = workflow;
        });
        while (newIndex < newWorkflowData.length && gridIndex < _this.gridOptions.data.length) {
            if (_this.gridOptions.data[gridIndex].id in newWorkflowsById) { // Try to update row that already exists
                if (_this.gridOptions.data[gridIndex].id === newWorkflowData[newIndex].id) {
                    updateGridRow(gridIndex, newWorkflowData[newIndex]);
                }
                else { // newWorkflowData should appear before existing row
                    _this.gridOptions.data.splice(gridIndex, 0, newWorkflowData[newIndex]);
                }
                newIndex++;
                gridIndex++;
            }
            else { // Grid row was removed
                _this.gridOptions.data.splice(gridIndex, 1);
            }
        }
        // If reached end of a table, just copy the rest of the data
        if (newIndex >= newWorkflowData.length) { // remove remaining grid rows
            _this.gridOptions.data.splice(gridIndex, _this.gridOptions.data.length);
        }
        else { // add remaining "new" workflows to end of grid (Notice: gridIndex >= this.gridOptions.data.length)
            var remaining = newWorkflowData.length - newIndex;
            _this.gridOptions.data = _this.gridOptions.data.concat(newWorkflowData.splice(newIndex, remaining));
        }
    };
    //====================//
    // Workflow Retrieval //
    //====================//
    var getWorkflows = function () {
        var deferred = $q.defer();
        WorkflowsService.getWorkflows(_this.pagingOptions, SearchFilterService.setSearchCriteriaForQueryOpts())
            .then(function (newTopLevels) {
            WorkflowsService.retrieveAllExpandedSubflows()
                .then(function (subflowsInfo) {
                var gridData = flattenExpandedSubflows(newTopLevels, _.get(subflowsInfo, 'subflowsByParentId', {}), subflowsInfo.parentIterationOrder);
                updateGridData(gridData);
                deferred.resolve(true);
            });
        });
        return deferred.promise;
    };
    var getViewData = function () {
        _this.loadingIndicator.show = true;
        $interval.cancel(refreshInterval);
        refreshInterval = undefined;
        return getWorkflows().then().finally(function () {
            refreshInterval = $interval(getWorkflows, REFRESH_DELAY, 0, false);
            _this.loadingIndicator.show = false;
        });
    };
    //===============================//
    // Inner Component Configuration //
    //===============================//
    this.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };
    var gridColumnDefs = [
        {
            name: 'checkMarkRowHeaderCol',
            field: 'checkMark',
            width: '1%',
            enableSorting: false,
            enableColumnResizing: false,
            cellTemplate: 'components/visual/grid/check-mark-template.html',
            headerCellTemplate: 'dashboard/workflows/gridTemplates/header-check-mark-template.html'
        },
        {
            field: 'index',
            name: 'indexColumn',
            displayName: '',
            width: '5%',
            enableSorting: false,
            cellTemplate: 'dashboard/workflows/gridTemplates/index-column-template.html'
        },
        {
            field: 'status',
            name: 'statusIcon',
            displayName: '',
            width: '1%',
            enableSorting: false,
            enableColumnResizing: false,
            cellTemplate: 'dashboard/workflows/gridTemplates/status-template.html'
        },
        {
            field: 'executionLabel',
            name: 'Subject',
            width: '23%',
            enableSorting: false,
            cellTemplate: 'dashboard/workflows/gridTemplates/workflow-subject-expandable-template.html'
        },
        {
            field: 'packageId',
            name: 'Package',
            width: '5%',
            enableSorting: false,
            enableColumnResizing: false,
            cellTemplate: 'dashboard/workflows/gridTemplates/package-link-icons-template.html'
        },
        {
            field: 'status',
            name: 'Status',
            width: '10%',
            enableSorting: false,
            cellTemplate: 'dashboard/workflows/gridTemplates/package-status-template.html'
        },
        {
            field: 'deliveryWorkflowProgress',
            name: 'Progress',
            width: '11%',
            enableSorting: false,
            cellTemplate: 'dashboard/workflows/gridTemplates/delivery-progress-template.html'
        },
        {
            field: 'startedByLabel',
            name: 'Submitter',
            width: '10%',
            enableSorting: false,
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        },
        {
            field: 'dateCreated',
            name: 'Created',
            width: '11%',
            enableSorting: false,
            cellFilter: 'amDateFormat:"MMM, D, YYYY, h:mm:ss A"'
        },
        {
            field: 'startTime',
            name: 'Start',
            width: '11%',
            enableSorting: false,
            cellFilter: 'amDateFormat:"MMM, D, YYYY, h:mm:ss A"'
        },
        {
            field: 'endTime',
            name: 'End',
            width: '11%',
            enableSorting: false,
            cellFilter: 'amDateFormat:"MMM, D, YYYY, h:mm:ss A"'
        }
    ];
    var getColumnDefs = function () {
        if (PermissionsService.isAdmin()) {
            gridColumnDefs.push({
                field: 'runtimeNodeId',
                name: 'Workflow Node',
                width: '11%',
                enableSorting: false
            });
        }
        return gridColumnDefs;
    };
    var getRowIdentity = function (workflow) {
        return workflow.id;
    };
    this.gridOptions = {
        selectionRowHeaderColName: 'checkMarkRowHeaderCol',
        rowIdentity: getRowIdentity,
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableExpandAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        rowHeight: 26,
        data: [],
        showTreeRowHeader: false,
        showTreeExpandNoChildren: true,
        multiSelect: true,
        useExternalSorting: true,
        columnDefs: getColumnDefs(),
        rowTemplate: '<div ng-dblclick="grid.appScope.$ctrl.rowDoubleClicked(row.entity)" ' +
            'ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" ' +
            'style="font-weight: normal !important;"' +
            'class="ui-grid-cell" ui-grid-cell>' +
            '</div>',
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            GridService.manageSavedColumns(null, _this.gridApi, 'dashboard.workflows');
        }
    };
    this.toggleRows = function (evt) {
        if (_this.gridApi.selection.selectAll) {
            _this.gridApi.selection.clearSelectedRows(evt);
            _this.gridApi.selection.selectAll = false;
        }
        else {
            _this.gridApi.selection.selectAllVisibleRows(evt);
            _this.gridApi.selection.selectAll = true;
        }
    };
    //========================//
    // HTML Value Calculation //
    //========================//
    this.getTreeLevelPadding = function (workflow) {
        return (Number(workflow.subflowCount) ? 0 : 15) + TREE_LEVEL_PADDING * workflow.$$treeLevel + 'px';
    };
    this.getWorkflowStatusColumnText = function (workflow) {
        if (workflow.status === 'WAITING') {
            return $filter('enumFilter')(workflow.packageStatus, 'Package_status').toUpperCase();
        }
        else {
            return workflow.status;
        }
    };
    this.getWorkflowStatusColumnTooltip = function (workflow) {
        var columnText = _this.getWorkflowStatusColumnText(workflow);
        return (workflow.pendingStatus) ? columnText + ", changing to: " + workflow.pendingStatus : columnText;
    };
    this.isWorkflowActionDisabled = function (action) {
        return !WorkflowsService.canDoWorkflowAction(action, _this.gridApi.selection.getSelectedRows());
    };
    //==================//
    // HTML Interfacing //
    //==================//
    this.onPackageNavigationStarted = function () {
        _this.loadingIndicator.show = true;
    };
    this.onPackageNavigationEnded = function () {
        _this.loadingIndicator.show = false;
    };
    this.filterByPackageId = function (workflow) {
        _this.pagingOptions.currentPage = 1;
        SearchFilterService.workflowSearchCriteria.keywords = workflow.packageId;
        SearchFilterService.updateLocationSearch();
        getViewData();
    };
    // Wrapper around treeBase.expandRow()
    var treeBaseExpandRow = function (gridIndex) {
        _this.gridApi.treeBase.expandRow(_this.gridApi.grid.rows[gridIndex]);
    };
    // Wrapper around treeBase.collapseRow()
    var treeBaseCollapseRow = function (gridIndex) {
        _this.gridApi.treeBase.collapseRow(_this.gridApi.grid.rows[gridIndex]);
    };
    // Recursively hide workflows & their children.
    // Returns # of workflows hidden.
    var collapseDescendants = function (workflows) {
        var amountRemoved = 0;
        _.forEach(workflows, function (workflow) {
            ++amountRemoved;
            if (workflow.expanded) {
                workflow.expanded = false;
                amountRemoved += collapseDescendants(workflow.subflows);
            }
        });
        return amountRemoved;
    };
    this.toggleChildrenVisibility = function (workflow, event) {
        if (event) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
        workflow.expanded = !workflow.expanded;
        var parentIndex = _this.gridOptions.data.indexOf(workflow);
        if (workflow.expanded) {
            _this.loadingIndicator.show = true;
            WorkflowsService.retrieveSubflowData([workflow], workflow.$$treeLevel + 1).then(function (subflowsByParentId) {
                var _a;
                WorkflowsService.addItemToExpandedWorkflows(workflow);
                (_a = _this.gridOptions.data).splice.apply(_a, [parentIndex + 1, 0].concat(subflowsByParentId[workflow.id]));
                _this.currentPageSize += workflow.subflows.length;
                treeBaseExpandRow(parentIndex);
                _this.loadingIndicator.show = false;
            });
        }
        else {
            _this.currentPageSize -= workflow.subflows.length;
            var numDescendants = collapseDescendants(workflow.subflows);
            _this.gridOptions.data.splice(parentIndex + 1, numDescendants);
            WorkflowsService.removeItemFromExpandedWorkflows(workflow.id);
            treeBaseCollapseRow(parentIndex);
        }
    };
    this.rowDoubleClicked = function (workflow) {
        BreadcrumbService.addBreadcrumb({
            location: '/dashboard/workflows',
            name: 'Workflow Execution Progress',
            params: angular.copy($location.search())
        });
        $location.url('/dashboard/workflows/' + workflow.id + '/steps');
    };
    this.handleWorkflowAction = function (action) {
        var selectedWorkflows = _this.gridApi.selection.getSelectedRows();
        if (action === 'view') {
            _this.rowDoubleClicked(selectedWorkflows[0]);
        }
        else if (action === 'abandon' && !_this.isWorkflowActionDisabled(action)) {
            ModalService.showMessageModal({
                messageText: 'Are you sure you want to abandon this workflow?',
                pullCancelLeft: true,
                title: 'Warning',
                windowClass: 'confirm-modal-lg',
                showOK: true
            }, function () {
                selectedWorkflows.forEach(function (workflow) { return addPendingStatusRequest(workflow, 'abandon'); });
                WorkflowsService.abandon(selectedWorkflows).then(function (abandonedWorkflows) {
                    _.chain(selectedWorkflows)
                        .filter(function (workflow) { return _.find(abandonedWorkflows, { workflowId: workflow.workflowId }); })
                        .forEach(function (selectedWorkflow) {
                        _this.gridApi.selection.unSelectRow(selectedWorkflow);
                    });
                    $interval.cancel(refreshInterval);
                    getViewData();
                });
            });
        }
        else if (!_this.isWorkflowActionDisabled(action)) {
            selectedWorkflows.forEach(function (workflow) { return addPendingStatusRequest(workflow, action); });
            WorkflowsService[action](selectedWorkflows).then(getViewData);
        }
    };
    this.paginationPrevPageHandler = function () {
        --_this.pagingOptions.currentPage;
        getViewData();
    };
    this.paginationNextPageHandler = function () {
        ++_this.pagingOptions.currentPage;
        getViewData();
    };
    this.paginationJumpToPageHandler = function () {
        getViewData();
    };
    this.paginationSizeChangeHandler = function () {
        getViewData();
    };
    var handleSearchFilterModalApply = function () {
        _this.pagingOptions.currentPage = 1;
        SearchFilterService.updateLocationSearch();
        getViewData();
    };
    var handleSearchFilterModalCancel = function (cancelMessage) {
        if (cancelMessage === 'setToDefaults') {
            _this.pagingOptions.currentPage = 1;
            SearchFilterService.resetCriteriaToDefault();
            getViewData();
        }
    };
    var showWorkflowSearchViewFilterModal = function () {
        ModalService.showWorkflowSearchFilterModal(handleSearchFilterModalApply, handleSearchFilterModalCancel);
    };
    var onSearchTextUpdated = function (searchText, forceUpdate) {
        if (forceUpdate) {
            getViewData();
        }
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.loadingIndicator.show = true;
        _this.pagingOptions = PaginationService;
        _this.currentPageSize = _this.pagingOptions.pageSize;
        _this.parentWorkflows = [];
        _this.pendingStatusRequests = {};
        NavbarUtilService.viewFilterBtnHandler = showWorkflowSearchViewFilterModal;
        NavbarUtilService.viewSearchFunction = onSearchTextUpdated;
        SearchFilterService.populateCriteriaFromLocationSearch();
        WorkflowsService.initialize().then(function () {
            if (WorkflowsService.canReadWorkflows()) {
                return getViewData();
            }
        }).finally(function () {
            $timeout(function () {
                _.forEach(_this.gridOptions.data, function (workflow, index) {
                    if (workflow.expanded) {
                        treeBaseExpandRow(index);
                    }
                });
                _this.loadingIndicator.show = false;
            });
        });
        SearchFilterService.populateCriteriaFromLocationSearch();
    };
    this.$onDestroy = function () {
        NavbarUtilService.viewFilterBtnHandler = null;
        $interval.cancel(refreshInterval);
        refreshInterval = undefined;
    };
}
angular.module('prism-ui.workflows').component('workflowSearchView', {
    templateUrl: 'dashboard/workflows/searchView/workflows-search-view-template.html',
    controller: WorkflowSearchViewController,
    bindings: {
        packageObject: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by kyang on 9/24/20
 */
function SamlLoginController(_, $window, EndPointService, LoginEditService) {
    this.login = function () {
        var url = '/packages';
        LoginEditService.navigateToApp();
        $window.open(EndPointService.samlEndPoint + "?redirectUrl=" + url, '_self');
    };
}
angular
    .module('prism-ui.login')
    .component('samlLogin', {
    controller: SamlLoginController,
    templateUrl: 'login/components/samlLogin/saml-login-template.html',
    bindings: {
        canSubmit: '<',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by kyang on 9/24/20
 */
function SystemLoginController(_, loginService, LoginEditService) {
    var _this = this;
    this.login = function () {
        loginService.login(_this.username, _this.password)
            .then(function () {
            LoginEditService.removeError('systemAuthFailed');
            LoginEditService.navigateToApp();
        }, function () {
            LoginEditService.setError('systemAuthFailed', 'Could not login.  Try again.');
        });
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.username = '';
        _this.password = '';
        loginService.useLocalStorage(true);
    };
    this.$onDestroy = function () {
        LoginEditService.removeError('systemAuthFailed');
    };
}
angular
    .module('prism-ui.login')
    .component('systemLogin', {
    controller: SystemLoginController,
    templateUrl: 'login/components/systemLogin/system-login-template.html',
    bindings: {
        canSubmit: '<',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
function CollaboratorsEditViewController(_, $location, $route, $routeParams, uiGridConstants, NetworkViewService, $timeout, BreadcrumbService, CollaboratorsService, PermissionsService, UtilsService, SidebarService) {
    var _this = this;
    var initializeBreadcrumbs = function () {
        BreadcrumbService.clearBreadcrumbs();
        BreadcrumbService.addBreadcrumb({
            name: 'Collaborators',
            location: $route.current.rootRoute
        });
    };
    var columnDefinitions = [
        {
            field: 'type',
            displayName: 'Role',
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'contentName',
            displayName: 'Content Name',
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: columnDefinitions,
        onRegisterApi: function (gridApi) {
            _this.CollaboratorsGridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        data: []
    };
    this.paginationDefs = {
        paginationPrevPageHandler: this.paginationPrevPageHandler,
        paginationNextPageHandler: this.paginationNextPageHandler,
        paginationPageSizeChanged: this.paginationPageSizeChanged,
    };
    this.getData = function () {
        _this.loadingIndicator.show = true;
        var collaboratorId = $routeParams.id;
        var criteria = {
            id: collaboratorId
        };
        CollaboratorsService.getCollaboratorById(criteria).then(function (collaborator) {
            _this.editData = collaborator;
            _this.loadingIndicator.show = false;
            CollaboratorsService.originalEditData = _.cloneDeep(collaborator);
            CollaboratorsService.getCollaboratorRoles(criteria).then(function (roles) {
                roles.forEach(function (role) {
                    if (role.type === 'Crew') {
                        role.contentName = role.role;
                    }
                });
                _this.editData['roles'] = roles;
                _this.gridOptions.data = _this.editData.roles;
            });
        });
    };
    this.saveEditData = function () {
        _this.loadingIndicator.show = true;
        var collaboratorWithoutRoles = angular.copy(_this.editData);
        delete collaboratorWithoutRoles.roles;
        CollaboratorsService.updateCollaborator(collaboratorWithoutRoles).then(function (savedCollaborator) {
            CollaboratorsService.originalEditData = _.cloneDeep(savedCollaborator);
            _this.editorForm.$pristine = true;
            _this.editorForm.$setPristine();
            _this.loadingIndicator.show = false;
        });
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () {
                return _this.editorForm && !_this.editorForm.$pristine && _.get(_this, 'permissions.write');
            },
            onClick: function () {
                if (_.get(_this, 'permissions.write')) {
                    _this.saveEditData();
                }
            }
        },
        {
            label: 'Revert',
            enabled: function () {
                return _this.editorForm && !_this.editorForm.$pristine && _.get(_this, 'permissions.write');
            },
            onClick: function () {
                _this.editData = _.cloneDeep(CollaboratorsService.originalEditData);
                _this.editorForm.$pristine = true;
                _this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: function () {
                return _this.editorForm && !_this.editorForm.$dirty;
            },
            onClick: function () {
                $location.url($route.current.rootRoute);
            }
        }
    ];
    this.$onInit = function () {
        initializeBreadcrumbs();
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        SidebarService.editService = CollaboratorsService;
        PermissionsService.getReadWritePermissions(CollaboratorsService.permissionViewState).then(function (permissions) {
            _this.permissions = permissions;
            _this.getData();
        });
    };
    this.$postLink = function () {
        $timeout(function () {
            CollaboratorsService.editorForm = _this.editorForm;
            BreadcrumbService.editService = CollaboratorsService;
        });
    };
    this.$onDestroy = function () {
        BreadcrumbService.clearBreadcrumbs();
        _this.editData = null;
    };
    this.handleDisplayNameChange = function () {
        _.set(_this.editData, 'sortName', _.cloneDeep(UtilsService.transformDisplayNameToSortName(_.get(_this.editData, 'displayName'))));
    };
}
angular.module('prism-ui.collaborators').component('collaboratorsEditView', {
    templateUrl: 'meta/collaborator/editView/collaborators-edit-view-template.html',
    controller: CollaboratorsEditViewController
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: collaborators-grid-search-view-component
 *
 * Created by sjacobs on 2/1/18.
 */
'use strict';
function CollaboratorsGridSearchViewController(_, $location, $routeParams, uiGridConstants, CollaboratorsResourceFactory, CollaboratorsService, ModalService, NavbarUtilService, PaginationService, PermissionsService, SearchFilterService) {
    var _this = this;
    var handleGridDataQuery = function (gridData, responseHeaders) {
        PaginationService.parseResponseHeaders(responseHeaders());
        PaginationService.pageData = gridData;
    };
    var navigateToCollaboratorsEditView = function (row) {
        $location.url("/meta/collaborators/edit/" + row.id);
    };
    this.getData = function () {
        _this.searchText = $location.search().searchText || null;
        var criteria = {
            fetchOffset: _this.pagingOptions.pageSize * (_this.pagingOptions.currentPage - 1),
            fetchLimit: _this.pagingOptions.pageSize,
            searchString: _this.searchText
        };
        _this.loadingIndicator.show = true;
        _this.searchText = $location.search().searchText || null;
        CollaboratorsService.getAllCollaborators(criteria, handleGridDataQuery).then(function (collaborators) {
            _this.gridOptions.data = collaborators;
            _this.loadingIndicator.show = false;
        });
    };
    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: function () {
                return _.get(_this, 'permissions.write');
            },
            onClick: function () {
                ModalService.showCreateCollaboratorModal(_this.checkToSaveNewCollaborator);
            }
        },
        {
            label: 'Edit',
            enabled: function () {
                var selectedRows = _this.collaboratorsGridApi.selection.getSelectedRows();
                return selectedRows && selectedRows.length && _.get(_this, 'permissions.write');
            },
            onClick: function () {
                var selectedRows = _this.collaboratorsGridApi.selection.getSelectedRows();
                if (selectedRows && selectedRows.length) {
                    var selectedCollaborator = selectedRows[0];
                    if (selectedCollaborator && selectedCollaborator.id && _this.permissions.write) {
                        $location.url("/meta/collaborators/edit/" + selectedCollaborator.id);
                    }
                }
            }
        },
        {
            label: 'Delete',
            enabled: function () {
                var selectedRows = _this.collaboratorsGridApi.selection.getSelectedRows();
                return selectedRows && selectedRows.length && _.get(_this, 'permissions.write');
            },
            onClick: function () {
                var selectedRows = _this.collaboratorsGridApi.selection.getSelectedRows();
                if (selectedRows && selectedRows.length) {
                    var selectedCollaborator_1 = selectedRows[0];
                    if (selectedCollaborator_1 && selectedCollaborator_1.id) {
                        ModalService.showMessageModal({
                            messageText: 'Are you sure you want to delete this Collaborator',
                            pullCancelLeft: true,
                            title: 'Delete Collaborator',
                            windowClass: 'confirm-modal-sm',
                            showOK: true
                        }, function () {
                            _this.loadingIndicator.show = true;
                            CollaboratorsService.deleteCollaborator(selectedCollaborator_1).then(function () {
                                _this.loadingIndicator.show = false;
                                _this.getData();
                            });
                        });
                    }
                }
            }
        }
    ];
    var onPaginationChanged = function () {
        _this.getData();
    };
    this.checkToSaveNewCollaborator = function (collaboratorToSave) {
        _this.loadingIndicator.show = true;
        CollaboratorsService.getAllCollaborators({
            searchString: collaboratorToSave.displayName
        }, function () {
        }).then(function (collaborators) {
            _this.loadingIndicator.show = false;
            var matches = collaborators.filter(function (collaborator) {
                return collaborator.displayName === collaboratorToSave.displayName;
            });
            if (matches.length) {
                ModalService.showMessageModal({
                    messageText: 'A collaborator with this display name already exists in the system, would you like to continue to create a duplicate?',
                    pullCancelLeft: true,
                    title: 'Duplicate Collaborator Found',
                    showOK: true
                }, function () {
                    _this.saveNewCollaborator(collaboratorToSave);
                }, _this.cancelCreateDuplicateCollaborator);
            }
            else {
                _this.saveNewCollaborator(collaboratorToSave);
            }
        });
    };
    this.cancelCreateDuplicateCollaborator = function () {
        ModalService.showCreateCollaboratorModal(_this.checkToSaveNewCollaborator);
    };
    this.saveNewCollaborator = function (newCollaborator) {
        CollaboratorsService.saveNewCollaborator(newCollaborator).then(function (savedCollaboraor) {
            _this.getData();
        });
    };
    this.executeSearch = function () {
        _this.collaboratorsGridApi.grid.refresh();
    };
    this.paginationPageSizeChanged = function () {
        _this.pagingOptions.currentPage = 1;
        onPaginationChanged();
    };
    this.paginationPrevPageHandler = function () {
        --_this.pagingOptions.currentPage;
        onPaginationChanged();
    };
    this.paginationJumpToPageHandler = function () {
        onPaginationChanged();
        _this.getData();
    };
    this.paginationNextPageHandler = function () {
        ++_this.pagingOptions.currentPage;
        onPaginationChanged();
    };
    this.onRowDblClick = function (row) {
        navigateToCollaboratorsEditView(row.entity);
    };
    var columnDefinitions = [
        {
            field: 'displayName',
            displayName: 'Name',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'sortName',
            displayName: 'Sort Name',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'nickname',
            displayName: 'Nickname',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'iMDbNumber',
            displayName: 'IMDB#',
            cellTemplate: 'components/visual/grid/hyperlink-template.html'
        }
    ];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: false,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: columnDefinitions,
        onRegisterApi: function (gridApi) {
            _this.collaboratorsGridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        data: []
    };
    this.paginationDefs = {
        paginationPrevPageHandler: this.paginationPrevPageHandler,
        paginationNextPageHandler: this.paginationNextPageHandler,
        paginationPageSizeChanged: this.paginationPageSizeChanged,
        paginationJumpToPageHandler: this.paginationJumpToPageHandler,
        pagingOptions: PaginationService,
    };
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        PaginationService.resetToDefaultValues();
        _this.searchText = '';
        _this.pagingOptions = PaginationService;
        NavbarUtilService.viewSearchFunction = _this.getData;
        SearchFilterService.populateCriteriaFromLocationSearch();
        PermissionsService.getReadWritePermissions(CollaboratorsService.permissionViewState).then(function (permissions) {
            _this.permissions = permissions;
            _this.getData();
        });
    };
    this.$onDestroy = function () {
        NavbarUtilService.viewSearchFunction = null;
    };
}
angular.module('prism-ui.collaborators').component('collaboratorsGridSearchView', {
    controller: CollaboratorsGridSearchViewController,
    templateUrl: 'meta/collaborator/searchView/collaborators-grid-search-view-template.html',
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 1/4/16.
 */
function ContentEditServiceConstructor(_, $location, $q, $route, $routeParams, AcceptProfileResourceFactory, BreadcrumbService, CategoriesResourceFactory, ContentResourceFactory, EnumService, GenresResourceFactory, LanguageResourceFactory, LivefeedsResourceFactory, MetadataEditService, MetadataService, ModalService, NetworkResourceFactory, NotificationService, PackageAcceptTemplatesResourceFactory, PackageResourceFactory, PermissionsService, RoleResourceFactory, UtilsService) {
    var _this = this;
    var originalContentData = {};
    var originalContentCategoryData = {};
    var setBreakPrePostrollPermissions = function (permissions) {
        var readPerms = _.get(permissions, 'preRoll.read') && _.get(permissions, 'postRoll.read');
        var writePerms = _.get(permissions, 'preRoll.write') && _.get(permissions, 'postRoll.write');
        permissions.breakprepostroll = { read: readPerms, write: writePerms };
        return permissions;
    };
    var getTabViewPermissions = function (permissionViewStates) {
        var promises = {};
        _.forEach(permissionViewStates, function (value, key) {
            promises[key] = PermissionsService.getReadWritePermissions(value);
        });
        return $q.all(promises).then(function (permissions) {
            return setBreakPrePostrollPermissions(permissions);
        });
    };
    this.contentObject = null;
    this.metadataComponentsMap = null;
    this.editorForm = null;
    this.originalPackageAcceptTemplateData = null;
    this.genres = null;
    this.networks = null;
    this.contentCategoryObject = null;
    this.allCategories = null;
    this.contentCategoryRoles = null;
    this.languages = null;
    this.ccRoles = null;
    this.subtitleRoles = null;
    this.videoAcceptProfiles = null;
    this.tabRevertFunction = null;
    this.tabSaveSuccessFunction = null;
    this.tabSaveErrorFunction = null;
    this.originalContentCategoryObject = null;
    this.contentBreadcrumb = {
        location: '',
        name: '',
        params: null,
    };
    this.categoryBreadcrumb = {
        location: '',
        name: '',
        params: null,
    };
    this.resetBreadcrumbs = function () {
        var contentPathKeyword = UtilsService.getPathKeywordFromContentType(_this.contentType);
        BreadcrumbService.clearBreadcrumbs();
        if (!_.isNil(contentPathKeyword)) {
            BreadcrumbService.addBreadcrumb({
                name: _this.contentType,
                location: "/meta/" + contentPathKeyword + "/search",
                params: angular.copy($location.search())
            });
        }
    };
    var closeEditView = function () {
        BreadcrumbService.clearBreadcrumbs();
        _this.contentObject = null;
        _this.editorForm = null;
        $location.path("/meta/" + UtilsService.getPathKeywordFromContentType(_this.contentType) + "/search");
    };
    var closeContentCategoryEditView = function () {
        _this.resetBreadcrumbs();
        _this.contentCategoryObject = originalContentCategoryData;
        _this.editorForm = null;
        $location.path("/meta/" + UtilsService.getPathKeywordFromContentType(_this.contentType) + "/edit/" + _this.contentObject.id + "/categories");
    };
    this.getViewPermissions = function (viewStates) {
        return getTabViewPermissions(viewStates);
    };
    // Assumes EnumService.queryForEnums() has been called & promise resolved
    this.setAvailableBreakPatterns = function () {
        _this.availableBreakPatterns = EnumService.getEnumPicklist('AbstractShow_breakPrePostRollPattern');
    };
    this.getEditData = function () {
        var contentReady = $q.defer();
        if ($routeParams.id > -1) {
            _this.contentObject = ContentResourceFactory.get({ id: $routeParams.id });
            _this.contentObject.$promise.then(function (contentData) {
                originalContentData = angular.copy(contentData);
                contentReady.resolve(contentData);
            });
        }
        else {
            _this.contentObject = new ContentResourceFactory({ type: _this.contentType, airTime: '00:00' });
            contentReady.resolve(_this.contentObject);
        }
        _this.genres = GenresResourceFactory.query({ fetchLimit: 0 });
        _this.networks = NetworkResourceFactory.getNetworks({ fetchLimit: 0 });
        var editDataDeferred = $q.defer();
        $q.all({
            content: contentReady.promise,
            genres: _this.genres.$promise,
            networks: _this.networks.$promise
        }).then(function (contentData) {
            $q.all({
                metadataComponents: _this.getContentComponentsMap(),
                liveFeeds: _this.getAvailableLiveFeeds().$promise,
            }).then(function (auxData) {
                editDataDeferred.resolve({
                    content: contentData.content,
                    genres: contentData.genres,
                    networks: contentData.networks,
                    metadataComponents: auxData.metadataComponents,
                    liveFeeds: auxData.liveFeeds,
                });
            });
        });
        return editDataDeferred.promise;
    };
    this.getContentPackageAcceptTemplatesEditData = function (contentId) {
        var contentPromises = {
            packageAcceptTemplates: PackageAcceptTemplatesResourceFactory.query({ view: 'EXTENDED' }).$promise,
            contentPackageAcceptTemplateContainers: ContentResourceFactory.getPackageAcceptTemplates({ id: contentId }).$promise,
            validationTypes: EnumService.queryForEnums().then(function () { return EnumService.getEnumPicklist('ContentPackageAcceptTemplateMember_validationType'); }),
            categoryTypes: CategoriesResourceFactory.getCategoryTypes().$promise
        };
        return $q.all(contentPromises).then(function (data) {
            _.forEach(data.packageAcceptTemplates, function (template) {
                template.type = _.camelCase(template.name);
                template.mediaAcceptProfiles = _.groupBy(template.mediaAcceptProfiles, 'type');
            });
            _.forEach(data.contentPackageAcceptTemplateContainers, function (container) {
                container.members = _.groupBy(container.members, 'acceptProfile.type');
            });
            _.forEach(data.categoryTypes, function (categoryType) {
                if (!_.find(_.get(data, 'contentPackageAcceptTemplateContainers'), { categoryType: categoryType })) {
                    data.contentPackageAcceptTemplateContainers.push({
                        categoryType: categoryType,
                        members: [],
                        packageAcceptTemplate: {}
                    });
                }
            });
            data.contentPackageAcceptTemplateContainers = _
                .orderBy(data.contentPackageAcceptTemplateContainers, 'categoryType.name', 'asc');
            return data;
        });
    };
    this.updateContentPackageAcceptTemplates = function (contentId, cPats) {
        return ContentResourceFactory.updatePackageAcceptTemplates({ id: contentId }, cPats)
            .$promise.then(function (data) {
            data = _.orderBy(data, 'categoryType.name', 'asc');
            _.forEach(data, function (container) {
                container.members = _.groupBy(container.members, 'acceptProfile.type');
            });
            return data;
        });
    };
    this.getContentCategoryEditData = function () {
        var contentReady = $q.defer();
        _this.contentObject = ContentResourceFactory.get({ id: $routeParams.id });
        if ($routeParams.contentCategoryId > -1) {
            _this.contentCategoryObject = ContentResourceFactory.getContentCategory({ contentCategoryId: $routeParams.contentCategoryId });
            _this.contentCategoryObject.$promise.then(function (contentCategory) {
                originalContentCategoryData = _.cloneDeep(contentCategory);
                contentReady.resolve(contentCategory);
            });
        }
        else {
            contentReady.resolve(_this.contentCategoryObject);
        }
        if (!_this.allCategories) {
            _this.allCategories = PackageResourceFactory.getCategories({ view: 'EXTENDED' });
        }
        if (!_this.contentCategoryRoles) {
            _this.contentCategoryRoles = RoleResourceFactory.query({ mediaType: 'Video' });
        }
        if (!_this.languages) {
            _this.languages = LanguageResourceFactory.query();
        }
        if (!_this.ccRoles) {
            _this.ccRoles = RoleResourceFactory.query({ mediaType: 'CC' });
        }
        if (!_this.subtitleRoles) {
            _this.subtitleRoles = RoleResourceFactory.query({ mediaType: 'Subtitle' });
        }
        if (!_this.videoAcceptProfiles) {
            _this.videoAcceptProfiles = AcceptProfileResourceFactory.query({ profileType: 'VIDEO' });
        }
        return $q.all({
            content: _this.contentObject.$promise,
            contentCategoryObject: contentReady.promise,
            allCategories: _this.allCategories.$promise,
            contentCategoryRoles: _this.contentCategoryRoles.$promise,
            languages: _this.languages.$promise,
            ccRoles: _this.ccRoles.$promise,
            subtitleRoles: _this.subtitleRoles.$promise,
            videoAcceptProfiles: _this.videoAcceptProfiles.$promise
        });
    };
    this.getAvailableLiveFeeds = function () {
        _this.liveFeeds = LivefeedsResourceFactory.query();
        return _this.liveFeeds;
    };
    this.showNewContentCategoryModal = function () {
        ModalService.showAddContentCategoryModal($routeParams.id, _this.handleAddContentCategoryModal);
    };
    this.openContentCategoryEditView = function (contentCategoryObject) {
        $location.url("/meta/" + UtilsService.getPathKeywordFromContentType(_this.contentType) +
            ("/edit/" + _this.contentObject.id + "/categories/edit/" + contentCategoryObject.id));
    };
    this.handleAddContentCategoryModal = function (contentCategoryObject) {
        _this.contentCategoryObject = contentCategoryObject;
        _this.openContentCategoryEditView(contentCategoryObject);
    };
    this.groupMetadataProperties = [];
    var getMetadataPropertiesByGroup = function (groupName) {
        var metadataGroupPromise;
        if (!_this.groupMetadataProperties[groupName]) {
            metadataGroupPromise = MetadataEditService.getMetadataByGroup(groupName)
                .then(function (groupProperties) {
                _this.groupMetadataProperties[groupName] = groupProperties;
            });
        }
        else {
            var deferred = $q.defer();
            deferred.resolve();
            metadataGroupPromise = deferred.promise;
        }
        return metadataGroupPromise;
    };
    var getContentMetadataDefs = function () {
        return getMetadataPropertiesByGroup(_this.contentType);
    };
    this.getContentComponentsMap = function () {
        return getContentMetadataDefs().then(function () {
            var metadataItems = {};
            if (_this.contentObject.metadata && _this.contentObject.metadata.properties) {
                metadataItems = _this.contentObject.metadata.properties;
            }
            else {
                _.forEach(_this.groupMetadataProperties[_this.contentType], function (property) {
                    metadataItems[property.name] = {
                        required: false,
                        valueOverridden: false
                    };
                });
                _this.contentObject.metadata = {
                    properties: metadataItems
                };
            }
            _this.contentMetadataComponentsMap = MetadataService.buildCustomComponentMap(metadataItems);
            return _this.contentMetadataComponentsMap;
        });
    };
    this.revertEditData = function () {
        if (_this.contentObject.id) {
            _this.contentObject = angular.copy(originalContentData);
            _this.metadataComponentsMap = MetadataService.buildCustomComponentMap(_this.contentObject.metadata.properties);
            _this.editorForm.$setPristine();
            if (_this.tabRevertFunction) {
                _this.tabRevertFunction();
            }
        }
        else {
            closeEditView();
        }
    };
    this.revertContentCategoryEditData = function () {
        if (_this.contentCategoryObject.id > -1) {
            _this.contentCategoryObject = angular.copy(originalContentCategoryData);
            _this.editorForm.$setPristine();
        }
        else {
            closeContentCategoryEditView();
        }
    };
    this.saveEditData = function () {
        var savePromise = (_this.contentObject.id > -1) ? _this.contentObject.$update() : _this.contentObject.$save();
        savePromise.then(function (contentData) {
            originalContentData = _.cloneDeep(contentData);
            _this.metadataComponentsMap = MetadataService.buildCustomComponentMap(_this.contentObject.metadata.properties);
            _this.editorForm.$setPristine();
            $route.updateParams({ id: contentData.id });
            if (_this.tabSaveSuccessFunction) {
                _this.tabSaveSuccessFunction();
            }
        }, function () {
            if (_this.tabSaveErrorFunction) {
                _this.tabSaveErrorFunction();
            }
        });
        return savePromise;
    };
    this.contentCategorySaveValid = function () {
        var saveValid = true;
        if (_this.contentCategoryObject.videoRoles) {
            angular.forEach(_this.contentCategoryObject.videoRoles, function (videoRole) {
                if (videoRole.closedCaptioningAcceptTemplate) {
                    if (videoRole.closedCaptioningAcceptTemplate.languageRoleMap.length === 0) {
                        _this.errorRole = videoRole.role.name;
                        saveValid = false;
                    }
                }
                if (videoRole.subtitleAcceptTemplate) {
                    if (videoRole.subtitleAcceptTemplate.languageRoleMap.length === 0) {
                        _this.errorRole = videoRole.role.name;
                        saveValid = false;
                    }
                }
            });
        }
        return saveValid;
    };
    this.saveContentCategoryEditData = function () {
        if (_this.contentCategorySaveValid()) {
            if ($routeParams.contentCategoryId > -1) {
                var updateContentCategoryPromise = ContentResourceFactory.updateContentCategory({
                    contentCategoryId: $routeParams.contentCategoryId
                }, _this.contentCategoryObject).$promise;
                updateContentCategoryPromise.then(function (data) {
                    originalContentCategoryData = _.cloneDeep(data);
                    _this.contentCategoryObject = data;
                });
                return updateContentCategoryPromise;
            }
            else {
                _this.contentCategoryObject.id = null;
                var saveCategoryPromise = ContentResourceFactory.saveContentCategory({
                    id: $routeParams.id
                }, _this.contentCategoryObject).$promise;
                saveCategoryPromise.then(function (data) {
                    originalContentCategoryData = angular.copy(data);
                    _this.contentCategoryObject = data;
                    _this.editorForm.$setPristine();
                    $route.updateParams({ contentCategoryId: data.id });
                });
                return saveCategoryPromise;
            }
        }
        else {
            NotificationService.createWarningNotification("You have no language roles selected for Role: " +
                (_this.errorRole + ". Please select at least one."));
            return $q.reject('Save Invalid');
        }
    };
    this.showUnsavedChangesNotification = function () {
        NotificationService.createWarningNotification('You have unsaved changes. Please save or revert.', '');
    };
    this.exitEdit = function () {
        if (_.get(_this, 'contentObject.id') !== -1 && _this.editorForm.$pristine) {
            closeEditView();
        }
        else {
            _this.showUnsavedChangesNotification();
        }
    };
    this.exitContentCategoryEdit = function () {
        if (_this.contentCategoryObject.id && _this.editorForm.$pristine) {
            closeContentCategoryEditView();
        }
        else {
            _this.showUnsavedChangesNotification();
        }
    };
    if (BreadcrumbService.getBreadcrumbs().length === 0) {
        this.resetBreadcrumbs();
    }
    //
    // Seasons / Volumes Search View
    //
    this.getSeasons = function (includeHidden) {
        var query = {
            contentId: $routeParams.id,
        };
        if (includeHidden) {
            query.includeHidden = true;
        }
        return ContentResourceFactory.getSeasons(query).$promise;
    };
    this.getSeason = function (seasonId, view, mvpdPartnerId) {
        if (view === void 0) { view = null; }
        if (mvpdPartnerId === void 0) { mvpdPartnerId = null; }
        return ContentResourceFactory.getSeason({
            id: seasonId,
            view: view,
            mvpdPartnerId: mvpdPartnerId
        }).$promise;
    };
    this.saveSeason = function (season) {
        return ContentResourceFactory.updateSeason({ seasonId: season.id }, season).$promise;
    };
    this.getVolumes = function (includeHidden) {
        var query = {
            contentId: $routeParams.id,
        };
        if (includeHidden) {
            query.includeHidden = true;
        }
        return ContentResourceFactory.getVolumes(query).$promise;
    };
    this.toggleSeasonVisibility = function (season) {
        return ContentResourceFactory.toggleSeasonVisibility({ seasonId: season.id }).$promise;
    };
    this.toggleVolumeVisibility = function (volume) {
        return ContentResourceFactory.toggleVolumeVisibility({ volumeId: volume.id }).$promise;
    };
    this.cloneSeason = function (season) {
        var seasonClone = _.cloneDeep(season);
        delete seasonClone.id;
        return ContentResourceFactory.createSeason({ contentId: $routeParams.id }, seasonClone).$promise;
    };
    this.cloneVolume = function (volume) {
        var volumeClone = _.cloneDeep(volume);
        delete volumeClone.id;
        return ContentResourceFactory.createVolume({ contentId: $routeParams.id }, volumeClone).$promise;
    };
    //
    // Seasons / Volumes Editor
    //
    this.seasonVolumeBreadcrumb = {
        name: '',
    };
    this.getContentObject = function () {
        return ContentResourceFactory.get({ id: $routeParams.id }).$promise;
    };
    var getSeasonVolumeEditApi = function () {
        //
        // This returns an object containing all of the resource
        // functions required to manipulate season and volume
        // objects, as well as relevant object IDs from the
        // route parameters.
        //
        var idName = $routeParams.seasonId ? 'seasonId' : 'volumeId';
        var seasonVolumeId = $routeParams[idName];
        var contentId = $routeParams.id;
        var resourceMethodSuffix = $routeParams.seasonId ? 'Season' : 'Volume';
        return {
            id: seasonVolumeId,
            idName: idName,
            create: function (seasonVolumeObject) {
                return ContentResourceFactory['create' + resourceMethodSuffix]({ contentId: contentId }, seasonVolumeObject);
            },
            update: ContentResourceFactory['update' + resourceMethodSuffix],
            get: ContentResourceFactory['get' + resourceMethodSuffix],
        };
    };
    var setSeasonVolumeBreadcrumbs = function () {
        // content breadcrumb
        _this.contentBreadcrumb.name = _this.contentObject.name;
        _this.contentBreadcrumb.location = '/meta/series/edit/' +
            $routeParams.id + '/' +
            ($routeParams.seasonId ? 'seasons' : 'volumes');
        // season/volume breadcrumb
        _this.seasonVolumeBreadcrumb.name = _this.seasonVolumeObject.name ?
            _.cloneDeep(_this.seasonVolumeObject.name) :
            'New ' + ($routeParams.seasonId ? 'Season' : 'Volume');
    };
    this.setContentSeasonBreadcrumbs = function () {
        // content breadcrumb
        _this.contentBreadcrumb.name = _this.contentObject.name;
        _this.contentBreadcrumb.location = '/meta/series/edit/' +
            $routeParams.id + '/' +
            ($routeParams.seasonId ? 'seasons' : 'volumes');
        // season/volume breadcrumb
        _this.seasonVolumeBreadcrumb.name = _this.seasonObject.name ? _.cloneDeep(_this.seasonObject.name) : 'New ' + ($routeParams.seasonId ? 'Season' : 'Volume');
    };
    var getSeasonVolumeEditDataPromise = function (seasonVolumeResourceMethods) {
        var seasonVolumePromise;
        if (seasonVolumeResourceMethods.id < 0) {
            // ID is negative = create a new season/volume object
            var seasonVolumeDeferred = $q.defer();
            seasonVolumeDeferred.resolve({
                metadata: {
                    properties: {}
                }
            });
            seasonVolumePromise = seasonVolumeDeferred.promise;
        }
        else {
            // ID is non-negative = query for season volume object
            seasonVolumePromise = seasonVolumeResourceMethods.get({ id: seasonVolumeResourceMethods.id }).$promise;
        }
        return seasonVolumePromise;
    };
    this.setBrandingBreadcrumbs = function () {
        if (_this.contentObject) {
            return $q.when();
        }
        return $q.all({
            seasonVolumeObject: getSeasonVolumeEditDataPromise(getSeasonVolumeEditApi()),
            contentObject: _this.getContentObject(),
        }).then(function (seasonVolumeData) {
            _this.seasonVolumeObject = seasonVolumeData.seasonVolumeObject;
            _this.contentObject = seasonVolumeData.contentObject;
            setSeasonVolumeBreadcrumbs();
        });
    };
    this.getSeasonVolumeEditData = function () {
        var seasonVolumeResourceMethods = getSeasonVolumeEditApi();
        var deferred = $q.defer();
        // only fetch data if necessary, e.g. if ID in route
        // params doesn't match the data we already have
        var seasonVolumeEditDataReady = _this.seasonVolumeObject && _this.seasonVolumeObject.id === seasonVolumeResourceMethods.id;
        if (!seasonVolumeEditDataReady) {
            // We do not already have the data, so we'll fetch it
            // from the server (or create a new copy if need be)
            // now.
            $q.all({
                seasonVolumeObject: getSeasonVolumeEditDataPromise(seasonVolumeResourceMethods),
                contentObject: _this.getContentObject(),
            }).then(function (seasonVolumeEditData) {
                _this.seasonVolumeObject = seasonVolumeEditData.seasonVolumeObject;
                _this.contentObject = seasonVolumeEditData.contentObject;
                _this.originalSeasonVolumeObject = _.cloneDeep(seasonVolumeEditData.seasonVolumeObject);
                setSeasonVolumeBreadcrumbs();
                deferred.resolve({
                    seasonVolumeObject: _this.seasonVolumeObject,
                    contentObject: _this.contentObject,
                });
            });
        }
        else {
            // We already have the latest data from the server, as
            // well as any updates made through saving, so
            // re-resolve the deferred with our local data.
            setSeasonVolumeBreadcrumbs();
            deferred.resolve({
                seasonVolumeObject: _this.seasonVolumeObject,
                contentObject: _this.contentObject,
            });
        }
        return deferred.promise;
    };
    this.saveSeasonVolume = function () {
        var promise;
        var seasonVolumeResourceMethods = getSeasonVolumeEditApi();
        if (seasonVolumeResourceMethods.id < 0) {
            promise = seasonVolumeResourceMethods.create(_this.seasonVolumeObject).$promise;
        }
        else {
            var updateParams = {};
            updateParams[seasonVolumeResourceMethods.idName] = seasonVolumeResourceMethods.id;
            promise = seasonVolumeResourceMethods.update(updateParams, _this.seasonVolumeObject).$promise;
        }
        promise.then(function (seasonVolume) {
            _this.seasonVolumeObject = seasonVolume;
            _this.originalSeasonVolumeObject = _.cloneDeep(seasonVolume);
            var newRouteParams = {};
            newRouteParams[seasonVolumeResourceMethods.idName] = seasonVolume.id;
            $route.updateParams(newRouteParams);
            setSeasonVolumeBreadcrumbs();
            _this.editorForm.$setPristine();
        });
        return promise;
    };
    this.closeSeasonVolumeEditor = function () {
        if (_this.editorForm && _this.editorForm.$dirty) {
            _this.showUnsavedChangesNotification();
        }
        else {
            _this.resetBreadcrumbs();
            _this.seasonVolumeObject = null;
            _this.originalSeasonVolumeObject = null;
            _this.editorForm = null;
            $location.url('/meta/series/edit/' + $routeParams.id + '/' +
                ($routeParams.seasonId ? 'seasons' : 'volumes'));
        }
    };
    this.revertSeasonVolume = function () {
        _this.editorForm.$setPristine();
        if (_this.seasonVolumeObject.id !== undefined) {
            _this.seasonVolumeObject = _.cloneDeep(_this.originalSeasonVolumeObject);
        }
        else {
            _this.closeSeasonVolumeEditor();
        }
    };
    var getSeasonVolumeMetadataDefs = function () {
        var groupName = $routeParams.seasonId ? 'Season' : 'Volume';
        return getMetadataPropertiesByGroup(groupName);
    };
    //
    // Note: don't call this unless this.seasonVolumeObject is up
    //		 to date - e.g. resolve getSeasonVolumeEditData() or
    //		 saveSeasonVolume() before calling this
    //
    this.getSeasonVolumeComponentsMap = function () {
        _this.metadataComponentsMap = {};
        var deferred = $q.defer();
        return getSeasonVolumeMetadataDefs().then(function () {
            var metadataItems = {};
            var groupName = $routeParams.seasonId ? 'Season' : 'Volume';
            _.forEach(_this.groupMetadataProperties[groupName], function (property) {
                // use property sent by DTO if it exists,
                // otherwise create a default from scratch
                if (_this.seasonVolumeObject.metadata.properties.hasOwnProperty(property.name)) {
                    metadataItems[property.name] = _this.seasonVolumeObject.metadata.properties[property.name];
                }
                else {
                    metadataItems[property.name] = { required: false, valueOverridden: false };
                }
            });
            _this.metadataComponentsMap = MetadataService.buildCustomComponentMap(metadataItems);
            deferred.resolve(_this.metadataComponentsMap);
            return deferred.promise;
        });
    };
}
angular
    .module('prism-ui.content')
    .service('ContentEditService', ContentEditServiceConstructor);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function ContentEditViewController(_, $route, $routeParams, ContentEditService, BreadcrumbService, NotificationService, SidebarService, UtilsService) {
    var _this = this;
    var getData = function () {
        ContentEditService.getEditData().then(function (editData) {
            _this.contentObject = editData.content;
            _this.genres = editData.genres;
            _this.networks = editData.networks;
            _this.metadataComponentsMap = editData.metadataComponents;
            _this.availableLiveFeeds = editData.liveFeeds;
            _this.contentLoaded = true;
        });
    };
    BreadcrumbService.editService = ContentEditService;
    this.editService = ContentEditService;
    this.contentObject = {};
    this.currentViewedTab = $routeParams.editView;
    this.searchEnabledTabs = ['collaborators', 'seasons', 'volumes'];
    this.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };
    var showUnsavedChangesWarning = function () {
        var message = 'You have unsaved changes.  Please save or revert.';
        NotificationService.createWarningNotification(message, '');
    };
    this.permissionViewStates = {
        'Series': {
            preRoll: 'SERIES_PREROLL_SEARCH_VIEW_STATE',
            postRoll: 'SERIES_POSTROLL_SEARCH_VIEW_STATE',
            breakPrePostRoll: 'SERIES_PREROLL_SEARCH_VIEW_STATE',
            watermark: 'SERIES_WATERMARK_SEARCH_VIEW_STATE',
            artwork: 'SERIES_ARTWORK_SEARCH_VIEW_STATE',
        },
        'Movie/Special': {
            preRoll: 'MOVIE_PREROLL_SEARCH_VIEW_STATE',
            postRoll: 'MOVIE_POSTROLL_SEARCH_VIEW_STATE',
            breakPrePostRoll: 'MOVIE_PREROLL_SEARCH_VIEW_STATE',
            watermark: 'MOVIE_WATERMARK_SEARCH_VIEW_STATE',
            artwork: 'MOVIE_ARTWORK_SEARCH_VIEW_STATE'
        }
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        ContentEditService.contentType = _this.contentType;
        SidebarService.editService = ContentEditService;
        ContentEditService.resetBreadcrumbs();
        _this.baseUrl = "/meta/" + UtilsService.getPathKeywordFromContentType(_this.contentType);
        _this.brandingConfigGroup = UtilsService.getPathKeywordFromContentType(_this.contentType);
        ContentEditService.getViewPermissions(_.get(_this, "permissionViewStates." + _this.contentType)).then(function (permissions) {
            _this.permissions = permissions;
            getData();
        });
    };
    //================//
    // Event Handlers //
    //================//
    this.isSearchEnabled = function () {
        return _.includes(_this.searchEnabledTabs, _this.currentViewedTab);
    };
    // TODO: Remove function?
    this.isNextPreviousShown = function () {
        return false;
    };
    this.onTabSelect = function (tabName) {
        $route.updateParams({ editView: tabName });
    };
    this.onTabDeselect = function (event) {
        if (ContentEditService.editorForm && ContentEditService.editorForm.$dirty || $routeParams.id === '-1') {
            event.preventDefault();
            showUnsavedChangesWarning();
        }
    };
    var convertBreakPattern = function () {
        ContentEditService.contentObject.breakPrePostRollPattern =
            _.filter(ContentEditService.availableBreakPatterns, function (pattern) {
                if (pattern.id === ContentEditService.contentObject.breakPrePostRollPattern) {
                    return pattern;
                }
            })[0];
    };
    this.onSave = function () {
        _this.loadingIndicator.show = true;
        if (typeof _this.contentObject.breakPrePostRollPattern === 'object') {
            _this.contentObject.breakPrePostRollPattern = _this.contentObject.breakPrePostRollPattern.id;
        }
        ContentEditService.saveEditData().then(function () {
            convertBreakPattern();
            _this.contentObject = ContentEditService.contentObject;
            _this.loadingIndicator.show = false;
        });
    };
    this.onRevert = function () {
        ContentEditService.revertEditData();
        convertBreakPattern();
        _this.contentObject = ContentEditService.contentObject;
    };
    this.onClose = function () {
        ContentEditService.exitEdit();
    };
}
angular
    .module('prism-ui.content')
    .component('contentEditView', {
    controller: ContentEditViewController,
    bindings: {
        contentType: '<',
        isSeason: '<'
    },
    templateUrl: 'meta/content/editor/content-edit-view-template.html'
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 1/7/16.
 */
'use strict';
angular.module('prism-ui.content')
    .service('ContentSearchService', function (PaginationService, uiGridConstants, ContentResourceFactory) {
    var _this = this;
    var handleGridDataQuery = function (gridData, responseHeaders) {
        PaginationService.parseResponseHeaders(responseHeaders());
        PaginationService.pageData = gridData;
        _this.currentPageSize = gridData.length;
    };
    this.getSearchViewData = function (criteria) {
        _this.breadcrumbName = '';
        return ContentResourceFactory.query(criteria, handleGridDataQuery).$promise;
    };
    this.toggleContentHidden = function (id) {
        return ContentResourceFactory.toggleArchive({ id: id }).$promise;
    };
    _.set(this, 'Ad/PreRollColumnDefs', [
        {
            field: 'locked',
            name: 'lockColumn',
            displayName: '',
            width: 25,
            enableColumnMenu: false,
            enableSorting: false,
            cellTemplate: 'components/visual/grid/lock-icon-template.html',
            headerCellTemplate: 'components/visual/grid/header-lock-icon-template.html'
        },
        {
            field: 'name',
            name: 'Name',
            minWidth: 250,
            sort: {
                direction: uiGridConstants.ASC,
                priority: 0
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ]);
    _.set(this, 'SeriesColumnDefs', [
        {
            field: 'locked',
            name: 'lockColumn',
            displayName: '',
            width: 25,
            enableColumnMenu: false,
            enableSorting: false,
            cellTemplate: 'components/visual/grid/lock-icon-template.html',
            headerCellTemplate: 'components/visual/grid/header-lock-icon-template.html'
        },
        {
            field: 'name',
            name: 'Name',
            minWidth: 250,
            sort: {
                direction: uiGridConstants.ASC,
                priority: 0
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'value',
            name: 'Value',
            minWidth: 250,
            sortable: false,
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'prefix',
            name: 'Prefix',
            width: 110,
            sortable: false,
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'airTime',
            name: 'Airtime',
            width: 110,
            sortable: false,
            cellTemplate: 'components/visual/grid/time-column-template.html'
        },
        {
            field: 'genre.name',
            name: 'Genre',
            minWidth: 200,
            sortable: false,
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'shortDescription',
            name: 'Description 1',
            minWidth: 1500,
            sortable: false,
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ]);
    _.set(this, 'Movie/SpecialColumnDefs', [
        {
            field: 'locked',
            name: 'lockColumn',
            displayName: '',
            width: 25,
            enableColumnMenu: false,
            enableSorting: false,
            cellTemplate: 'components/visual/grid/lock-icon-template.html',
            headerCellTemplate: 'components/visual/grid/header-lock-icon-template.html'
        },
        {
            field: 'name',
            name: 'Name',
            minWidth: 250,
            sort: {
                direction: uiGridConstants.ASC,
                priority: 0
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'value',
            name: 'Value',
            minWidth: 250,
            sortable: false,
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'prefix',
            name: 'Prefix',
            width: 200,
            sortable: false,
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'shortDescription',
            name: 'Description 1',
            minWidth: 110,
            sortable: false,
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'genre.name',
            name: 'Genre',
            minWidth: 200,
            sortable: false,
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ]);
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function ContentSearchViewController($location, uiGridConstants, ContentSearchService, ModalService, NavbarUtilService, PaginationService, SearchFilterService, UtilsService) {
    var _this = this;
    var getData = function () {
        _this.showHidden = $location.search().showHidden;
        var criteria = {
            fetchOffset: _this.pagingOptions.pageSize * (_this.pagingOptions.currentPage - 1),
            fetchLimit: _this.pagingOptions.pageSize,
            includeHidden: _this.showHidden,
            searchString: $location.search().searchText,
            type: _this.contentType
        };
        _this.loadingIndicator.show = true;
        ContentSearchService.getSearchViewData(criteria).then(function () {
            _this.gridOptions.columnDefs = _.get(ContentSearchService, _this.contentType + "ColumnDefs", []);
            _this.gridOptions.data = PaginationService.pageData;
            _this.loadingIndicator.show = false;
        });
    };
    var paginationPreviousPageHandler = function () {
        --_this.pagingOptions.currentPage;
        getData();
    };
    var paginationNextPageHandler = function () {
        ++_this.pagingOptions.currentPage;
        getData();
    };
    var paginationPageSizeChanged = function () {
        _this.pagingOptions.currentPage = 1;
        getData();
    };
    var navigateToEditView = function (content) {
        var contentPathKeyword = UtilsService.getPathKeywordFromContentType(_this.contentType);
        if (_.isNil(content)) {
            $location.url("meta/" + contentPathKeyword + "/edit/" + _.get(_.first(_this.gridApi.selection.getSelectedRows()), 'id') + "/properties");
        }
        else {
            $location.url("meta/" + contentPathKeyword + "/edit/" + _.get(content, 'id') + "/properties");
        }
    };
    var navigateToEditViewToCreateContent = function () {
        $location.url("meta/" + UtilsService.getPathKeywordFromContentType(_this.contentType) + "/edit/-1/properties");
    };
    var toggleContentHiddenUnhidden = function (message) {
        ModalService.showMessageModal({
            messageText: message,
            pullCancelLeft: true,
            title: 'Hide Content',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, function () {
            _this.loadingIndicator.show = true;
            var contentId = _.get(_.first(_this.gridApi.selection.getSelectedRows()), 'id');
            ContentSearchService.toggleContentHidden(contentId).then(function () {
                getData();
                _this.editorForm.$setDirty();
            }).finally(function () {
                _this.loadingIndicator.show = false;
            });
        });
    };
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: [],
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
    this.onRowDblClick = function (row) {
        if (!row.entity.hidden) {
            navigateToEditView(row.entity);
        }
    };
    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: function () { return true; },
            onClick: navigateToEditViewToCreateContent
        },
        {
            label: 'Edit',
            enabled: function () {
                var selectedRow = _.first(_this.gridApi.selection.getSelectedRows());
                return selectedRow && !_.get(selectedRow, 'hidden');
            },
            onClick: navigateToEditView
        },
        {
            label: 'Hide',
            enabled: function () {
                var selectedRow = _.first(_this.gridApi.selection.getSelectedRows());
                return selectedRow && !_.get(selectedRow, 'hidden');
            },
            onClick: function () { return toggleContentHiddenUnhidden('Are you sure that you want to hide this content?'); }
        },
        {
            label: 'Unhide',
            enabled: function () {
                var selectedRow = _.first(_this.gridApi.selection.getSelectedRows());
                return selectedRow && _.get(selectedRow, 'hidden');
            },
            onClick: function () { return toggleContentHiddenUnhidden('Are you sure that you want to unhide this content?'); }
        }
    ];
    this.paginationDefs = {
        paginationPrevPageHandler: paginationPreviousPageHandler,
        paginationNextPageHandler: paginationNextPageHandler,
        paginationPageSizeChanged: paginationPageSizeChanged,
        paginationJumpToPageHandler: getData,
        pagingOptions: PaginationService,
    };
    this.toolbarCheckboxDefs = [
        {
            label: 'Show Hidden',
            onUpdate: function (newState) {
                _this.showHidden = newState;
                $location.search('showHidden', newState);
                getData();
            },
            isChecked: this.showHidden
        }
    ];
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.showHidden = $location.search().showHidden;
        _this.toolbarCheckboxDefs[0].isChecked = _this.showHidden;
        PaginationService.resetToDefaultValues();
        _this.pagingOptions = PaginationService;
        NavbarUtilService.viewSearchFunction = getData;
        SearchFilterService.populateCriteriaFromLocationSearch();
        getData();
    };
}
angular.module('prism-ui.content').component('contentSearchView', {
    templateUrl: 'meta/content/searchView/content-searchview-template.html',
    controller: ContentSearchViewController,
    bindings: {
        contentType: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
function MVPDMetadataItemEditViewController(_, $location, $route, $routeParams, uiGridConstants, NetworkViewService, $timeout, BreadcrumbService, MVPDViewService, PermissionsService, ContentResourceFactory, NavbarUtilService, NotificationService, MetadataService, SidebarService) {
    var _this = this;
    var initializeBreadcrumbs = function () {
        BreadcrumbService.clearBreadcrumbs();
        BreadcrumbService.addBreadcrumb({
            name: 'MVPD Partners',
            location: $route.current.rootRoute
        });
        BreadcrumbService.addBreadcrumb({
            name: _this.mvpdConfig.partnerName,
            location: _this.mvpdConfig.parentLocation
        });
    };
    var getPromiseKey = function (method, criteria) {
        if ($routeParams.view === 'properties' || $routeParams.subView === 'properties') {
            criteria.id = $routeParams.groupId;
            if ($routeParams.view === 'seasons' || $routeParams.view === 'volumes') {
                criteria.id = $routeParams.seasonVolumeId;
                return "" + method + _.upperFirst($routeParams.view.substring(0, $routeParams.view.length - 1));
            }
            else {
                if ($routeParams.groupName === 'networks') {
                    return method + "Network";
                }
                return method + "Content";
            }
        }
        else {
            criteria.contentId = $routeParams.groupId;
            if ($routeParams.view === 'seasons' || $routeParams.view === 'volumes') {
                return "" + method + _.upperFirst($routeParams.view);
            }
            return method + "Content";
        }
    };
    var getGroupName = function () {
        if ($routeParams.groupName === 'networks') {
            return 'Network';
        }
        else if ($routeParams.groupName === 'movies') {
            return 'Movie/Special';
        }
        else {
            if ($routeParams.seasonVolumeId) {
                return _.upperFirst($routeParams.view.substring(0, $routeParams.view.length - 1));
            }
            return 'Series';
        }
    };
    var getData = function () {
        _this.loadingIndicator.show = true;
        _this.isSeries = $routeParams.groupName === 'series';
        var criteria = {
            mvpdPartnerId: $routeParams.id
        };
        var groupSearchDataPromises = {
            getNetwork: function () { return NetworkViewService.getEditViewData(criteria); },
            getContent: function () { return ContentResourceFactory.getMVPDContent(criteria).$promise; },
            getSeason: function () { return ContentResourceFactory.getSeason(criteria).$promise; },
            getVolume: function () { return ContentResourceFactory.getVolume(criteria).$promise; },
            getSeasons: function () { return ContentResourceFactory.getSeasons(criteria).$promise; },
            getVolumes: function () { return ContentResourceFactory.getVolumes(criteria).$promise; }
        };
        var setEditData = function (editData) {
            MVPDViewService.originalEditData = _.cloneDeep(editData);
            _this.editData = editData;
            _this.loadingIndicator.show = false;
        };
        groupSearchDataPromises[getPromiseKey('get', criteria)]().then(function (groupData) {
            if (_this.activeTabs.properties) {
                MVPDViewService.getMetadataByGroup(getGroupName(), groupData).then(function (groupData) {
                    var seasonVolume = $routeParams.view === 'seasons' || $routeParams.view === 'volumes';
                    if (seasonVolume) {
                        criteria.id = $routeParams.groupId;
                        groupSearchDataPromises['getContent']().then(function (contentData) {
                            BreadcrumbService.addBreadcrumb({
                                name: contentData.name,
                                location: _this.mvpdConfig.parentLocation
                            });
                            setEditData(groupData);
                        });
                    }
                    else {
                        setEditData(groupData);
                    }
                });
            }
            else {
                delete criteria.contentId;
                criteria.id = $routeParams.groupId;
                groupSearchDataPromises['getContent']().then(function (contentData) {
                    _this.gridOptions.data = groupData;
                    _this.editData = contentData;
                    _this.loadingIndicator.show = false;
                });
            }
        });
    };
    var navigateToSeasonVolumeMetadataEditView = function (seasonVolumeId) {
        $location.url("/meta/mvpd/edit/partner/" + $routeParams.id + "/" + $routeParams.groupName + "/" + $routeParams.groupId + "/metadata/" + $routeParams.view + "/" + seasonVolumeId + "/edit/properties");
    };
    var saveEditData = function () {
        _this.loadingIndicator.show = true;
        // **************************************************************** //
        // **************************************************************** //
        // **** Seriously! Always perform this action before you save  **** //
        // **** metadata items to ensure the correct data is persisted **** //
        // **************************************************************** //
        // **************************************************************** //
        var cleanData = MetadataService.cleanData(_this.editData, MVPDViewService.getComponentsMap(undefined));
        var groupPromises = {
            saveNetwork: function () { return NetworkViewService.saveNetwork(cleanData); },
            saveContent: function () { return ContentResourceFactory.update(cleanData).$promise; },
            saveSeason: function () { return ContentResourceFactory.updateSeason({ seasonId: $routeParams.seasonVolumeId }, cleanData).$promise; },
            saveVolume: function () { return ContentResourceFactory.updateVolume({ volumeId: $routeParams.seasonVolumeId }, cleanData).$promise; }
        };
        groupPromises[getPromiseKey('save', {})]().then(function (editData) {
            MVPDViewService.getMetadataByGroup(getGroupName(), editData).then(function (editData) {
                MVPDViewService.originalEditData = _.cloneDeep(editData);
                _this.editData = editData;
                _this.loadingIndicator.show = false;
                _this.editorForm.$pristine = true;
                _this.editorForm.$setPristine();
            });
        });
    };
    // **************************************************************** //
    // **************************************************************** //
    // **** Seriously! Always perform this action before you save  **** //
    // **** metadata items to ensure the correct data is persisted **** //
    // **************************************************************** //
    // **************************************************************** //
    this.onUpdate = function (event) {
        _this.validationErrors = event.errors;
        if (!_this.validationErrors) {
            MVPDViewService.getComponentsMap(undefined)[event.name].instanceData.value = event.items;
        }
    };
    this.getComponentsMap = function () {
        return MVPDViewService.getComponentsMap();
    };
    this.hasMetadataProperties = function (entity) {
        return !_.isEmpty(entity.metadata.properties);
    };
    this.onRowDblClick = function (row) {
        if (_this.hasMetadataProperties(row.entity)) {
            navigateToSeasonVolumeMetadataEditView(row.entity.id);
        }
    };
    this.onTabSelect = function (tab) {
        var param = (_this.seasonVolumeId) ? { subView: tab } : { view: tab };
        $route.updateParams(param);
    };
    var showUnsavedChangesWarning = function () {
        var message = 'You have unsaved changes.  Please save or revert.';
        NotificationService.createWarningNotification(message, '');
    };
    this.onTabDeselect = function (tab, event) {
        if (_this.editorForm && _this.editorForm.$dirty) {
            event.preventDefault();
            showUnsavedChangesWarning();
        }
    };
    this.getFieldErrorsTooltip = function (missingMVPDFields) {
        return MVPDViewService.getFieldErrorsTooltip(missingMVPDFields);
    };
    this.columnDefinitions = [
        {
            field: 'name',
            displayName: 'Name',
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/mvpd-required-error-template.html'
        }
    ];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: this.columnDefinitions,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
        },
        rowTemplate: "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\"\n\t\t\t\t\t\t   ng-class=\"{ 'ui-grid-cell-hidden' : row.entity.hidden || (row.entity.mvpdPartnerId && !grid.appScope.$ctrl.hasMetadataProperties(row.entity))}\"\n\t\t\t\t\t\t   class=\"ui-grid-cell ng-scope ng-binding\"\n\t\t\t\t\t\t   ui-grid-cell\n\t\t\t\t\t\t   ng-dblclick=\"grid.appScope.$ctrl.onRowDblClick(row)\">\n\t\t\t\t\t </div>",
        data: []
    };
    this.toolbarButtonDefs = [
        {
            label: 'Edit',
            enabled: function () {
                return _this.gridApi && _this.gridApi.selection.getSelectedCount() === 1 && _this.hasMetadataProperties(_this.gridApi.selection.getSelectedRows()[0]);
            },
            onClick: function () {
                navigateToSeasonVolumeMetadataEditView(_this.gridApi.selection.getSelectedRows()[0].id);
            }
        },
        {
            label: 'Save',
            enabled: function () { return _this.editorForm && !_this.editorForm.$pristine && !_this.validationErrors; },
            onClick: saveEditData
        },
        {
            label: 'Revert',
            enabled: function () { return _this.editorForm && !_this.editorForm.$pristine; },
            onClick: function () {
                MVPDViewService.revertMVPDEditData();
                _this.editorForm.$pristine = true;
                _this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: function () {
                return (_this.editorForm && !_this.editorForm.$dirty) || _this.currentTab !== 'properties';
            },
            onClick: function () { return $location.url(_this.mvpdConfig.parentLocation); }
        }
    ];
    this.$onInit = function () {
        SidebarService.editService = MVPDViewService;
        initializeBreadcrumbs();
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.activeTabs = {
            properties: false,
            seasons: false,
            volumes: false
        };
        _this.seasonVolumeId = $routeParams.seasonVolumeId;
        if (_this.seasonVolumeId) {
            _this.currentTab = 'properties';
            _this.activeTabs.properties = true;
        }
        else {
            _this.currentTab = $routeParams.view;
            _this.activeTabs[$routeParams.view] = true;
            NavbarUtilService.viewSearchFunction = getData;
        }
        PermissionsService.getReadWritePermissions(MVPDViewService.permissionViewState).then(function (permissions) {
            _this.permissions = permissions;
            getData();
        });
    };
    this.$postLink = function () {
        $timeout(function () {
            MVPDViewService.editorForm = _this.editorForm;
            BreadcrumbService.editService = MVPDViewService;
        });
    };
    this.$onDestroy = function () {
        BreadcrumbService.clearBreadcrumbs();
        _this.editData = null;
        MVPDViewService.getComponentsMap({});
    };
}
angular.module('prism-ui.mvpd').component('mvpdMetadataItemEditView', {
    templateUrl: 'meta/mvpd/metadataEditView/mvpd-metadata-item-edit-view-template.html',
    controller: MVPDMetadataItemEditViewController,
    bindings: {
        mvpdConfig: "<"
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
function MVPDPartnerGridSearchViewController(_, $location, $route, $routeParams, uiGridConstants, BreadcrumbService, ContentSearchService, MVPDViewService, NavbarUtilService, NetworkViewService, PaginationService, PermissionsService, SearchFilterService) {
    var _this = this;
    var initializeBreadcrumbs = function () {
        BreadcrumbService.clearBreadcrumbs();
        BreadcrumbService.addBreadcrumb({
            name: 'MVPD Partners',
            location: $route.current.rootRoute
        });
    };
    var processGridFilter = function (renderableRows) {
        _.forEach(renderableRows, function (row) {
            if (_this.searchText === null || _this.searchText === '') {
                row.visible = true;
            }
            else {
                var criteria = _this.searchText.toLowerCase();
                row.visible = row.entity.name && row.entity.name.toLowerCase().indexOf(criteria) !== -1;
            }
        });
        return renderableRows;
    };
    var overrideUpdateCurrentPage = function (tab) {
        if (PaginationService.pageNumberMap) {
            if (!PaginationService.pageNumberMap[tab]) {
                PaginationService.pageNumberMap[tab] = 1;
            }
            else {
                _this.pagingOptions.currentPage = PaginationService.pageNumberMap[tab];
            }
        }
        else {
            PaginationService.pageNumberMap = {};
            PaginationService.pageNumberMap[tab] = 1;
        }
    };
    var navigateToPartnerMetadataEditView = function (groupId) {
        $location.url("/meta/mvpd/edit/partner/" + $routeParams.id + "/" + $routeParams.groupName + "/" + groupId + "/metadata/properties");
    };
    var onPaginationChanged = function () {
        getData();
    };
    var handleGridDataQuery = function (gridData, responseHeaders) {
        PaginationService.parseResponseHeaders(responseHeaders(), $routeParams.groupName);
        PaginationService.pageData = gridData;
    };
    var getSearchCriteria = function (content) {
        var criteria = {
            mvpdPartnerId: $routeParams.id,
            mvpdOnly: !_this.showAll,
            searchString: _this.searchText
        };
        if ($routeParams.groupName === 'networks') {
            criteria.fetchLimit = 0;
        }
        else {
            criteria.fetchOffset = _this.pagingOptions.pageSize * (_this.pagingOptions.currentPage - 1);
            criteria.fetchLimit = _this.pagingOptions.pageSize;
            criteria.type = content;
        }
        return criteria;
    };
    var getData = function () {
        _this.loadingIndicator.show = true;
        _this.searchText = $location.search().searchText || null;
        var groupPromises = {
            networks: function () { return NetworkViewService.getSearchViewData(getSearchCriteria(undefined), handleGridDataQuery); },
            series: function () {
                return ContentSearchService.getSearchViewData(getSearchCriteria('Series'), handleGridDataQuery);
            },
            movies: function () {
                return ContentSearchService.getSearchViewData(getSearchCriteria('Movie/Special'), handleGridDataQuery);
            }
        };
        groupPromises[$routeParams.groupName]().then(function (groupData) {
            _this.gridOptions.data = groupData;
            _this.loadingIndicator.show = false;
        });
    };
    this.executeSearch = function () {
        _this.gridApi.grid.refresh();
    };
    this.paginationPageSizeChanged = function () {
        _this.pagingOptions.currentPage = 1;
        onPaginationChanged();
    };
    this.paginationPrevPageHandler = function () {
        --_this.pagingOptions.currentPage;
        onPaginationChanged();
    };
    this.paginationNextPageHandler = function () {
        ++_this.pagingOptions.currentPage;
        onPaginationChanged();
    };
    this.hasMetadataProperties = function (entity) {
        return !_.isEmpty(entity.metadata.properties);
    };
    this.onRowDblClick = function (row) {
        navigateToPartnerMetadataEditView(row.entity.id);
    };
    this.getFieldErrorsTooltip = function (missingMVPDFields) {
        return MVPDViewService.getFieldErrorsTooltip(missingMVPDFields);
    };
    this.columnDefinitions = [
        {
            field: 'name',
            displayName: 'Name',
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/mvpd-required-error-template.html'
        }
    ];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: this.columnDefinitions,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            _this.gridApi.grid.registerRowsProcessor(processGridFilter, 200);
        },
        rowTemplate: "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\"\n\t\t\t\t\t\t   ng-class=\"{ 'ui-grid-cell-hidden' : row.entity.hidden}\"\n\t\t\t\t\t\t   class=\"ui-grid-cell ng-scope ng-binding\"\n\t\t\t\t\t\t   ui-grid-cell\n\t\t\t\t\t\t   ng-dblclick=\"grid.appScope.$ctrl.onRowDblClick(row)\">\n\t\t\t\t\t </div>",
        data: []
    };
    this.toolbarButtonDefs = [
        {
            label: 'Edit',
            enabled: function () {
                return _this.gridApi && _this.gridApi.selection.getSelectedCount() === 1 && _this.hasMetadataProperties(_this.gridApi.selection.getSelectedRows()[0]);
            },
            onClick: function () {
                navigateToPartnerMetadataEditView(_this.gridApi.selection.getSelectedRows()[0].id);
            }
        }
    ];
    this.toolbarCheckboxDefs = [
        {
            label: 'Show All',
            onUpdate: function (newValue) {
                _this.showAll = newValue;
                getData();
            },
            isChecked: false
        }
    ];
    this.onTabSelect = function (tab) {
        $route.updateParams({ groupName: tab });
        overrideUpdateCurrentPage(tab);
    };
    this.onTabDeselect = function (tab, event) {
        PaginationService.pageNumberMap[tab] = this.pagingOptions.currentPage;
    };
    this.$onInit = function () {
        initializeBreadcrumbs();
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.activeTabs = {
            networks: false,
            series: false,
            movies: false
        };
        if ($routeParams.groupName === 'networks') {
            _this.paginationDefs = null;
        }
        else {
            _this.paginationDefs = {
                paginationPrevPageHandler: _this.paginationPrevPageHandler,
                paginationNextPageHandler: _this.paginationNextPageHandler,
                paginationPageSizeChanged: _this.paginationPageSizeChanged,
                paginationJumpToPageHandler: onPaginationChanged,
                pagingOptions: PaginationService,
            };
        }
        _this.currentTab = $routeParams.groupName;
        _this.activeTabs[$routeParams.groupName] = true;
        _this.searchText = '';
        _this.pagingOptions = PaginationService;
        NavbarUtilService.viewSearchFunction = getData;
        SearchFilterService.populateCriteriaFromLocationSearch();
        PermissionsService.getReadWritePermissions(MVPDViewService.permissionViewState).then(function (permissions) {
            _this.permissions = permissions;
            getData();
        });
    };
    this.$onDestroy = function () {
        NavbarUtilService.viewSearchFunction = null;
    };
}
angular.module('prism-ui.mvpd').component('mvpdPartnerGridSearchView', {
    templateUrl: 'meta/mvpd/partnerSearchView/mvpd-partner-grid-search-view-template.html',
    controller: MVPDPartnerGridSearchViewController,
    bindings: {
        mvpdConfig: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: mvpd-grid-search-view-component
 *
 * Created by rwilliams on 10/16/17.
 */
'use strict';
function MVPDGridSearchViewController(_, $location, $routeParams, uiGridConstants, PaginationService, PartnerEditService, NavbarUtilService, SearchFilterService) {
    var _this = this;
    var processGridFilter = function (renderableRows) {
        _.forEach(renderableRows, function (row) {
            if (_this.searchText === null || _this.searchText === '') {
                row.visible = true;
            }
            else {
                var criteria = _this.searchText.toLowerCase();
                row.visible = row.entity.name && row.entity.name.toLowerCase().indexOf(criteria) !== -1;
            }
        });
        return renderableRows;
    };
    var handleGridDataQuery = function (gridData, responseHeaders) {
        PaginationService.parseResponseHeaders(responseHeaders());
        PaginationService.pageData = gridData;
    };
    var navigateToMVPDPartnerSearchView = function (row) {
        var searchView = $routeParams.searchView || 'networks';
        $location.url("/meta/mvpd/edit/partner/" + row.id + "/" + searchView);
    };
    var getData = function () {
        var criteria = {
            fetchOffset: _this.pagingOptions.pageSize * (_this.pagingOptions.currentPage - 1),
            fetchLimit: _this.pagingOptions.pageSize,
            mvpd: true
        };
        _this.loadingIndicator.show = true;
        _this.searchText = $location.search().searchText || null;
        PartnerEditService.getAllPartners(criteria, handleGridDataQuery).then(function (partners) {
            _this.gridOptions.data = partners;
            _this.loadingIndicator.show = false;
        });
    };
    var onPaginationChanged = function () {
        getData();
    };
    this.executeSearch = function () {
        _this.partnerGridApi.grid.refresh();
    };
    this.paginationPageSizeChanged = function () {
        this.pagingOptions.currentPage = 1;
        onPaginationChanged();
    };
    this.paginationPrevPageHandler = function () {
        --this.pagingOptions.currentPage;
        onPaginationChanged();
    };
    this.paginationNextPageHandler = function () {
        ++this.pagingOptions.currentPage;
        onPaginationChanged();
    };
    this.onRowDblClick = function (row) {
        navigateToMVPDPartnerSearchView(row.entity);
    };
    this.columnDefinitions = [
        {
            field: 'name',
            displayName: 'Name',
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'subscriptionCount',
            displayName: 'Subscriptions',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: this.columnDefinitions,
        onRegisterApi: function (gridApi) {
            _this.partnerGridApi = gridApi;
            _this.partnerGridApi.grid.registerRowsProcessor(processGridFilter, 200);
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        data: []
    };
    this.paginationDefs = {
        paginationPrevPageHandler: this.paginationPrevPageHandler,
        paginationNextPageHandler: this.paginationNextPageHandler,
        paginationPageSizeChanged: this.paginationPageSizeChanged,
        paginationJumpToPageHandler: onPaginationChanged,
        pagingOptions: PaginationService,
    };
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        PaginationService.resetToDefaultValues();
        _this.searchText = '';
        _this.pagingOptions = PaginationService;
        NavbarUtilService.viewSearchFunction = getData;
        SearchFilterService.populateCriteriaFromLocationSearch();
        getData();
    };
    this.$onDestroy = function () {
        NavbarUtilService.viewSearchFunction = null;
    };
}
angular.module('prism-ui.mvpd').component('mvpdGridSearchView', {
    controller: MVPDGridSearchViewController,
    templateUrl: 'meta/mvpd/searchView/mvpd-grid-search-view-template.html',
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function CategoriesEditViewController(_, $location, $route, $routeParams, $timeout, uiGridConstants, BreadcrumbService, CategoriesService, DynamicPropertiesService, MediaAcceptProfileService, ModalService, NotificationService, PermissionsService, SidebarService, TranslatableMetadataService) {
    var _this = this;
    this.editData = {};
    var getData = function () {
        _this.loadingIndicator.show = true;
        CategoriesService.getCategory($routeParams.id).then(function (category) {
            CategoriesService.originalEditData = _.cloneDeep(category);
            _this.editData = category;
            _this.gridOptions.data = _.concat(_.toArray(_this.gridOptions.data), category.aliases);
        }).finally(function () {
            TranslatableMetadataService.setDataObject(_this.editData);
            _this.loadingIndicator.show = false;
        });
    };
    var getAvailableAdPodProfiles = function () {
        var criteria = {
            fetchLimit: 0,
            fetchOffset: 0,
            profileType: 'DOCUMENT',
            view: 'EXTENDED',
            includeHidden: true
        };
        MediaAcceptProfileService.getAcceptProfiles(criteria).then(function (acceptProfiles) {
            _this.availableAdPodProfiles = acceptProfiles;
        });
    };
    var getAvailableCategoryTypes = function () {
        CategoriesService.getCategoryTypes().then(function (categoryTypes) {
            _this.availableCategoryTypes = categoryTypes;
        });
    };
    var saveHandler = function () {
        _.set(_this.editData, 'aliases', _.toArray(_this.gridOptions.data));
        _.forEach(_.get(_this.editData, 'aliases'), function (alias) {
            _.unset(alias, 'edited');
        });
        _this.loadingIndicator.show = true;
        if ($routeParams.id === '-1') {
            saveNewCategory();
        }
        else {
            updateCategory();
        }
    };
    var updateCategory = function () {
        TranslatableMetadataService.preSave();
        CategoriesService.updateCategory(_this.editData).then(function (category) {
            CategoriesService.originalEditData = _.cloneDeep(category);
            _this.editData = category;
            _this.editorForm.$setPristine();
            _this.gridApi.selection.clearSelectedRows();
        }).finally(function () {
            TranslatableMetadataService.dataObjectSaved(_this.editData);
            _this.loadingIndicator.show = false;
        });
    };
    var saveNewCategory = function () {
        TranslatableMetadataService.preSave();
        CategoriesService.createCategory(_this.editData).then(function (category) {
            $route.updateParams({ id: category.id });
            _this.gridApi.selection.clearSelectedRows();
        }).finally(function () {
            TranslatableMetadataService.dataObjectSaved(_this.editData);
            _this.loadingIndicator.show = false;
        });
    };
    var addAliasHandler = function (selectedPartners) {
        var originalGridDataSize = _.size(_this.gridOptions.data);
        var selectedAliases = new Array();
        selectedPartners.forEach(function (selectedPartner) {
            selectedAliases.push({
                alias: '',
                edited: true,
                partner: selectedPartner
            });
        });
        _this.gridOptions.data = _.unionWith(_.toArray(_this.gridOptions.data), selectedAliases, function (gridAlias, selectedAlias) {
            return _.isEqual(gridAlias.partner.id, selectedAlias.partner.id);
        });
        if (_.size(_this.gridOptions.data) > originalGridDataSize) {
            _this.editorForm.$setDirty();
        }
        _this.loadingIndicator.show = false;
    };
    this.removeAlias = function () {
        var selectedAliases = _this.gridApi.selection.getSelectedRows();
        ModalService.showMessageModal({
            messageText: 'Are you sure you want to remove the selected alias(es)?',
            pullCancelLeft: true,
            title: 'Remove Alias(es)',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, function () {
            _this.gridOptions.data = _.differenceWith(_this.gridOptions.data, selectedAliases, function (gridAlias, selectedAlias) {
                return _.isEqual(gridAlias.partner.id, selectedAlias.partner.id);
            });
            _this.editorForm.$setDirty();
        });
    };
    this.addAlias = function () {
        ModalService.showAliasesModal(addAliasHandler);
    };
    var columnDefinitions = [
        {
            field: 'partner.name',
            displayName: 'Partner (Read-Only)',
            cellEditableCondition: false,
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'alias',
            displayName: 'Alias (Double Click to Edit)',
            cellTemplate: 'components/visual/grid/inline-edit-template.html'
        }
    ];
    this.gridOptions = {
        enableRowHeaderSelection: true,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: false,
        enableCellEditOnFocus: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: true,
        columnDefs: columnDefinitions,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            _this.gridApi.edit.on.afterCellEdit(null, function (rowEntity, colDef, newValue, oldValue) {
                if (newValue !== oldValue) {
                    _.set(rowEntity, 'edited', true);
                }
            });
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return !_.get(_this.editorForm, '$pristine')
                && !!_.get(_this.editData, 'name')
                && !!_.get(_this.editData, 'type.name')
                && _.every(_this.gridOptions.data, function (gridItem) {
                    return _.size(gridItem.alias);
                }); },
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: function () { return !_.get(_this.editorForm, '$pristine'); },
            onClick: function () {
                _this.editData = _.cloneDeep(CategoriesService.originalEditData);
                TranslatableMetadataService.dataObjectReverted(_this.editData);
                _this.gridOptions.data = _.get(_this.editData, 'aliases');
                _this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: function () { return !_.get(_this.editorForm, '$dirty'); },
            onClick: function () { return $location.url("/system/properties/search").search({ tab: 'Categories' }); }
        }
    ];
    this.$onInit = function () {
        SidebarService.editService = CategoriesService;
        _this.isAdmin = PermissionsService.isAdmin();
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        DynamicPropertiesService.queryForProperties().then(function () {
            var requiredFields = DynamicPropertiesService.getPropValueAsArray('translatable.text.package.category.required.properties', []);
            _this.translatableMetadataFields = [
                {
                    name: 'value',
                    title: 'Value',
                    required: _.includes(requiredFields, 'value'),
                },
            ];
        });
        if (_this.isAdmin) {
            if ($routeParams.id !== '-1') {
                if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                    BreadcrumbService.addBreadcrumb({
                        name: 'Edit Category',
                        location: '/system/properties/search',
                        params: { tab: 'Categories' }
                    });
                }
                getData();
            }
            else {
                TranslatableMetadataService.setDataObject(_this.editData);
                _this.allowCategoryTypeEdit = true;
                BreadcrumbService.addBreadcrumb({
                    name: 'Create Category',
                    location: '/system/properties/search',
                    params: { tab: 'Categories' }
                });
            }
            getAvailableAdPodProfiles();
            getAvailableCategoryTypes();
        }
        else {
            $location.url('/login');
        }
    };
    this.$onDestroy = function () {
        CategoriesService.originalEditData = null;
        CategoriesService.viewData = null;
    };
    this.$postLink = function () {
        $timeout(function () {
            CategoriesService.editorForm = _this.editorForm;
            BreadcrumbService.editService = CategoriesService;
        });
    };
}
angular.module('prism-ui.categories').component('categoriesEditView', {
    templateUrl: 'system/categories/editor/categories-edit-view-template.html',
    controller: CategoriesEditViewController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: contacts-edit-view-component.ts
 *
 * Created by randysorensen on 5/4/18.
 */
function ContactsEditViewController(_, $timeout, BreadcrumbService, ContactsService, SidebarService) {
    var _this = this;
    var getData = function () {
        _this.loadingIndicator.show = true;
        return ContactsService.getContactEditData()
            .then(function (contact) {
            _this.contact = contact;
        })
            .finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var requiredFieldsArePopulated = function () {
        var emailAddress = _.get(_this, 'contact.emailAddress.length') > 0;
        return emailAddress;
    };
    var saveContact = function () {
        _this.loadingIndicator.show = true;
        ContactsService.saveEditData()
            .then(function (savedContact) {
            _this.contact = savedContact;
        })
            .finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var revertContact = function () {
        _this.contact = ContactsService.revertEditData();
    };
    var initToolbar = function () {
        _this.toolbarButtonDefs = [
            {
                label: 'Save',
                enabled: function () { return _this.editorForm.$dirty && requiredFieldsArePopulated(); },
                onClick: saveContact
            },
            {
                label: 'Revert',
                enabled: function () { return _this.editorForm.$dirty; },
                onClick: revertContact
            },
            {
                label: 'Close',
                enabled: function () { return true; },
                onClick: function () { return ContactsService.exitEdit(); }
            }
        ];
    };
    this.$onInit = function () {
        _this.contact = {};
        _this.breadcrumbName = '';
        _this.toolbarButtonDefs = undefined;
        BreadcrumbService.editService = ContactsService;
        SidebarService.editService = ContactsService;
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        initToolbar();
        getData();
    };
    this.$postLink = function () {
        $timeout(function () {
            ContactsService.editorForm = _this.editorForm;
        });
    };
    this.getBreadcrumbName = function () {
        var firstName = _.get(ContactsService, 'originalContact.firstName');
        var lastName = _.get(ContactsService, 'originalContact.lastName');
        var breadcrumbName = lastName;
        if (lastName && firstName) {
            breadcrumbName += ', ';
        }
        breadcrumbName += firstName;
        return (breadcrumbName || '<New Contact>');
    };
}
angular.module('prism-ui.system').component('contactsEditView', {
    controller: ContactsEditViewController,
    templateUrl: 'system/contacts/editView/contacts-edit-view-template.html',
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: contacts-search-view-component.ts
 *
 * Created by randysorensen on 4/23/18.
 */
function ContactsSearchViewController(_, $location, uiGridConstants, ContactsService, ModalService, NavbarUtilService, PaginationService, SearchFilterService, UtilsService) {
    var _this = this;
    var getData = function () {
        _this.loadingIndicator.show = true;
        if (_.get(_this, 'gridApi.selection')) {
            _this.gridApi.selection.clearSelectedRows();
        }
        _this.searchText = $location.search().searchText || null;
        var offset = _this.pagingOptions.pageSize * (_this.pagingOptions.currentPage - 1);
        var queryOptions = {
            fetchOffset: offset,
            fetchLimit: _this.pagingOptions.pageSize,
            searchString: _this.searchText,
            includeHidden: _this.showHidden
        };
        ContactsService.getContactsList(queryOptions).then(function (contacts) {
            _this.gridOptions.data = contacts;
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var getSelectedCount = function () {
        var selectedCount = 0;
        if (_.get(_this, 'gridApi.selection')) {
            selectedCount = _this.gridApi.selection.getSelectedCount();
        }
        return selectedCount;
    };
    var editContact = function (contact) {
        $location.url("/system/contacts/edit/" + contact.id);
    };
    var toggleSelectedContactVisibility = function () {
        var selectedContact = _this.gridApi.selection.getSelectedRows()[0];
        ContactsService.toggleContactVisibility(selectedContact.id)
            .finally(function () {
            getData();
        });
    };
    var showConfirmationModal = function (action, handler) {
        var capitalizedAction = "" + action[0].toUpperCase() + action.slice(1);
        ModalService.showMessageModal({
            messageText: "Are you sure you want to " + action + " the selected contact?",
            title: capitalizedAction + ' Contact',
            windowClass: 'confirm-modal-sm',
            showOK: true,
            okText: 'Yes',
            pullCancelLeft: true
        }, handler);
    };
    this.onRowDblClick = function (row) {
        editContact(row.entity);
    };
    this.onPaginationChanged = function () {
        getData();
    };
    this.paginationPageSizeChanged = function () {
        _this.pagingOptions.currentPage = 1;
        _this.onPaginationChanged();
    };
    this.paginationPrevPageHandler = function () {
        --_this.pagingOptions.currentPage;
        _this.onPaginationChanged();
    };
    this.paginationNextPageHandler = function () {
        ++_this.pagingOptions.currentPage;
        _this.onPaginationChanged();
    };
    var initGrid = function () {
        _this.gridOptions = {
            rowSelection: true,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            enableSelectAll: false,
            multiSelect: false,
            enableColumnResizing: true,
            enableSorting: true,
            enableHorizontalScrollbar: uiGridConstants.ALWAYS,
            enableVerticalScrollbar: uiGridConstants.ALWAYS,
            rowHeight: 26,
            rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
            onRegisterApi: function (gridApi) {
                _this.gridApi = gridApi;
            }
        };
        _this.gridOptions.columnDefs = [
            {
                field: 'firstName',
                displayName: 'First Name',
                width: '17%',
                sort: {
                    direction: 'asc',
                    priority: 1
                },
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                field: 'lastName',
                displayName: 'Last Name',
                width: '17%',
                sort: {
                    direction: 'asc',
                    priority: 0
                },
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                field: 'title',
                displayName: 'Title',
                width: '17%',
                sort: {
                    direction: 'asc',
                    priority: 3,
                },
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                field: 'emailAddress',
                displayName: 'Email Address',
                width: '*',
                sort: {
                    direction: 'asc',
                    priority: 2
                },
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                field: 'phoneNumber',
                displayName: 'Phone Number',
                width: '17%',
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            }
        ];
    };
    var initToolbar = function () {
        _this.toolbarButtonDefs = [
            {
                label: 'New',
                enabled: function () { return true; },
                onClick: function () { return $location.url("/system/contacts/edit/-1"); }
            },
            {
                label: 'Edit',
                enabled: function () { return getSelectedCount() === 1; },
                onClick: function () { return editContact(_this.gridApi.selection.getSelectedRows()[0]); }
            },
            {
                label: 'Hide',
                enabled: function () { return getSelectedCount() === 1 && !_this.gridApi.selection.getSelectedRows()[0].hidden; },
                onClick: function () { return showConfirmationModal('hide', toggleSelectedContactVisibility); }
            },
            {
                label: 'Unhide',
                enabled: function () { return getSelectedCount() === 1 && _this.gridApi.selection.getSelectedRows()[0].hidden; },
                onClick: function () { return showConfirmationModal('unhide', toggleSelectedContactVisibility); }
            }
        ];
        _this.toolbarCheckboxDefs = [
            {
                label: 'Show Hidden',
                onUpdate: function (newValue) {
                    _this.showHidden = newValue;
                    getData();
                },
                isChecked: _this.showHidden
            }
        ];
    };
    var initPaging = function () {
        _this.pagingOptions = PaginationService;
        _this.pagingOptions.currentPage = 1;
        _this.pagingOptions.pageSize = UtilsService.constants.DEFAULT_FETCH_LIMIT;
        _this.paginationDefs = {
            paginationPrevPageHandler: _this.paginationPrevPageHandler,
            paginationNextPageHandler: _this.paginationNextPageHandler,
            paginationPageSizeChanged: _this.paginationPageSizeChanged,
            paginationJumpToPageHandler: _this.onPaginationChanged,
            pagingOptions: PaginationService,
        };
    };
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.gridOptions = undefined;
        _this.gridApi = undefined;
        _this.toolbarButtonDefs = undefined;
        _this.toolbarCheckboxDefs = undefined;
        _this.showHidden = false;
        initGrid();
        initToolbar();
        initPaging();
        getData();
        NavbarUtilService.viewSearchFunction = _this.getData;
        SearchFilterService.populateCriteriaFromLocationSearch();
    };
}
angular
    .module('prism-ui.system')
    .component('contactsSearchView', {
    bindings: {},
    templateUrl: 'system/contacts/searchView/contacts-search-view-template.html',
    controller: ContactsSearchViewController
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function DeliveryTemplatesEditViewController(_, $location, $route, $routeParams, $timeout, BreadcrumbService, DeliveryTemplatesService, ModalService, PermissionsService, SidebarService) {
    var _this = this;
    this.editData = {};
    var getData = function () {
        _this.loadingIndicator.show = true;
        DeliveryTemplatesService.getDeliveryTemplate($routeParams.id).then(function (deliveryTemplate) {
            DeliveryTemplatesService.originalEditData = _.cloneDeep(deliveryTemplate);
            _this.editData = deliveryTemplate;
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveHandler = function () {
        _this.loadingIndicator.show = true;
        if ($routeParams.id === '-1') {
            saveNewDeliveryTemplate();
        }
        else {
            updateDeliveryTemplate();
        }
    };
    var updateDeliveryTemplate = function () {
        DeliveryTemplatesService.updateDeliveryTemplate(_this.editData).then(function (deliveryTemplate) {
            DeliveryTemplatesService.originalEditData = _.cloneDeep(deliveryTemplate);
            _this.editData = deliveryTemplate;
            _this.editorForm.$setPristine();
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveNewDeliveryTemplate = function () {
        DeliveryTemplatesService.createDeliveryTemplate(_this.editData).then(function (deliveryTemplate) {
            $route.updateParams({ id: deliveryTemplate.id });
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return !_.get(_this.editorForm, '$pristine') && _.size(_.get(_this.editData, 'name')) && !_.get(_this.editData, 'custom'); },
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: function () { return !_.get(_this.editorForm, '$pristine'); },
            onClick: function () {
                _this.editData = _.cloneDeep(DeliveryTemplatesService.originalEditData);
                _this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: function () { return !_.get(_this.editorForm, '$dirty'); },
            onClick: function () { return $location.url("/system/templates/search").search({ tab: 'DeliveryTemplates' }); }
        }
    ];
    this.$onInit = function () {
        SidebarService.editService = DeliveryTemplatesService;
        _this.isAdmin = PermissionsService.isAdmin();
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        if (_this.isAdmin) {
            if ($routeParams.id !== '-1') {
                if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                    BreadcrumbService.addBreadcrumb({
                        name: 'Edit Delivery Template',
                        location: '/system/templates/search',
                        params: { tab: 'DeliveryTemplates' }
                    });
                }
                getData();
            }
            else {
                BreadcrumbService.addBreadcrumb({
                    name: 'Create Delivery Template',
                    location: '/system/templates/search',
                    params: { tab: 'DeliveryTemplates' }
                });
            }
        }
        else {
            $location.url('/login');
        }
    };
    this.$onDestroy = function () {
        DeliveryTemplatesService.originalEditData = null;
        DeliveryTemplatesService.viewData = null;
    };
    this.$postLink = function () {
        $timeout(function () {
            DeliveryTemplatesService.editorForm = _this.editorForm;
            BreadcrumbService.editService = DeliveryTemplatesService;
        });
    };
}
angular.module('prism-ui.deliveryTemplates').component('deliveryTemplatesEditView', {
    templateUrl: 'system/deliveryTemplate/editor/delivery-template-edit-template.html',
    controller: DeliveryTemplatesEditViewController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function DynamicPropsEditViewController(_, $location, DynamicPropertiesEditService, BreadcrumbService, NotificationService, PermissionsService, SidebarService, $timeout) {
    //===================//
    // Template Response //
    //===================//
    var _this = this;
    this.isCreatingProperty = function () {
        return !DynamicPropertiesEditService.originalPropertyValue;
    };
    var onSaveClicked = function () {
        var propertyNamePath = encodeURIComponent(_this.editData.name);
        _this.loadingIndicator.show = true;
        DynamicPropertiesEditService.saveEditData().then(function () {
            $location.search('propertyName', propertyNamePath);
            return getData();
        }, function (rejectionReason) {
            NotificationService.createFailureNotification(rejectionReason, '');
            _this.loadingIndicator.show = false;
        });
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return !_.get(_this.editorForm, '$pristine') && _.get(_this.editorForm, '$valid'); },
            onClick: onSaveClicked
        }, {
            label: 'Revert',
            enabled: function () { return _this.isCreatingProperty() || !_.get(_this, 'editorForm.$pristine'); },
            onClick: DynamicPropertiesEditService.revertEditData
        }, {
            label: 'Close',
            enabled: function () { return true; },
            onClick: DynamicPropertiesEditService.exitEdit
        }
    ];
    //=================//
    // Lifecycle Hooks //
    //=================//
    var getData = function () {
        var propertyName = decodeURIComponent(_.get($location.search(), 'propertyName', ''));
        _this.loadingIndicator.show = true;
        return DynamicPropertiesEditService.getEditData(propertyName)
            .then(function (editData) {
            DynamicPropertiesEditService.originalPropertyValue = _.cloneDeep(editData.value);
            DynamicPropertiesEditService.editData = editData;
            _this.editData = editData;
        })
            .finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    this.$onInit = function () {
        BreadcrumbService.editService = DynamicPropertiesEditService;
        SidebarService.editService = DynamicPropertiesEditService;
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        if (PermissionsService.isAdmin()) {
            getData().then(function () {
                var breadcrumbName;
                if (_this.editData.value) {
                    breadcrumbName = 'Edit Dynamic Property';
                }
                else {
                    breadcrumbName = 'Create Dynamic Property';
                    _this.editData.value = '';
                }
                BreadcrumbService.addBreadcrumb({
                    name: breadcrumbName,
                    location: '/system/properties/search',
                    params: { tab: 'DynamicProps' }
                });
            });
        }
        else {
            $location.url('/login');
        }
    };
    this.$postLink = function () {
        $timeout(function () {
            DynamicPropertiesEditService.editorForm = _this.editorForm;
        });
    };
    this.$onDestroy = function () {
        DynamicPropertiesEditService.originalEditData = null;
        DynamicPropertiesEditService.viewData = null;
        DynamicPropertiesEditService.editorForm = null;
        BreadcrumbService.editService = null;
        SidebarService.editService = null;
    };
}
angular.module('prism-ui.system').component('dynamicPropsEditView', {
    templateUrl: 'system/dynamicProperties/editor/dynamic-property-edit-view-template.html',
    controller: DynamicPropsEditViewController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function EmailTemplatesEditViewController(_, $location, $route, $routeParams, $timeout, BreadcrumbService, EmailTemplatesService, ModalService, PermissionsService, SidebarService) {
    var _this = this;
    this.editData = {};
    var getData = function () {
        _this.loadingIndicator.show = true;
        EmailTemplatesService.getEmailTemplate($routeParams.id).then(function (emailTemplate) {
            EmailTemplatesService.originalEditData = _.cloneDeep(emailTemplate);
            _this.editData = emailTemplate;
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveHandler = function () {
        _this.loadingIndicator.show = true;
        if ($routeParams.id === '-1') {
            saveNewEmailTemplate();
        }
        else {
            updateEmailTemplate();
        }
    };
    var updateEmailTemplate = function () {
        EmailTemplatesService.updateEmailTemplate(_this.editData).then(function (emailTemplate) {
            EmailTemplatesService.originalEditData = _.cloneDeep(emailTemplate);
            _this.editData = emailTemplate;
            _this.editorForm.$setPristine();
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveNewEmailTemplate = function () {
        EmailTemplatesService.createEmailTemplate(_this.editData).then(function (emailTemplate) {
            $route.updateParams({ id: emailTemplate.id });
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return !_.get(_this.editorForm, '$pristine') && _.size(_.get(_this.editData, 'name')); },
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: function () { return !_.get(_this.editorForm, '$pristine'); },
            onClick: function () {
                _this.editData = _.cloneDeep(EmailTemplatesService.originalEditData);
                _this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: function () { return !_.get(_this.editorForm, '$dirty'); },
            onClick: function () { return $location.url("/system/templates/search").search({ tab: 'EmailTemplates' }); }
        }
    ];
    this.$onInit = function () {
        SidebarService.editService = EmailTemplatesService;
        _this.isAdmin = PermissionsService.isAdmin();
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        if (_this.isAdmin) {
            if ($routeParams.id !== '-1') {
                if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                    BreadcrumbService.addBreadcrumb({
                        name: 'Edit Email Template',
                        location: '/system/templates/search',
                        params: { tab: 'EmailTemplates' }
                    });
                }
                getData();
            }
            else {
                BreadcrumbService.addBreadcrumb({
                    name: 'Create Email Template',
                    location: '/system/templates/search',
                    params: { tab: 'EmailTemplates' }
                });
            }
        }
        else {
            $location.url('/login');
        }
    };
    this.$onDestroy = function () {
        EmailTemplatesService.originalEditData = null;
        EmailTemplatesService.viewData = null;
    };
    this.$postLink = function () {
        $timeout(function () {
            EmailTemplatesService.editorForm = _this.editorForm;
            BreadcrumbService.editService = EmailTemplatesService;
        });
    };
}
angular.module('prism-ui.emailTemplates').component('emailTemplatesEditView', {
    templateUrl: 'system/emailTemplate/editor/email-template-edit-template.html',
    controller: EmailTemplatesEditViewController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: external-system-logging-component
 *
 * Created by rwilliams on 10/5/17.
 */
'use strict';
function ExternalMetadataSystemLoggingController(_, $location, $timeout, uiGridConstants, ExternalMetadataService, NavbarUtilService, PaginationService, SearchFilterService) {
    var _this = this;
    var gridColumns = [
        {
            field: 'externalSystem',
            displayName: 'External System',
            sort: {
                direction: uiGridConstants.ASC,
                priority: 0
            },
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        },
        {
            field: 'externalId',
            displayName: 'External ID',
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        },
        {
            field: 'packageName',
            displayName: 'Package Name',
            cellTemplate: 'components/visual/grid/base-tooltip-template.html',
            width: 300
        },
        {
            field: 'packageId',
            displayName: 'Package Id',
            cellTemplate: 'system/externalMetadata/logging/external-metadata-package-link-cell-template.html'
        },
        {
            field: 'date',
            displayName: 'Date',
            cellFilter: 'amDateFormat:"MMM, D, YYYY, h:mm:ss A"'
        },
        {
            field: 'source',
            displayName: 'Source',
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        },
        {
            field: 'type',
            displayName: 'Type',
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        },
        {
            field: 'body',
            displayName: 'Body',
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        }
    ];
    var getData = function () {
        var criteria = {
            fetchOffset: _this.pagingOptions.pageSize * (_this.pagingOptions.currentPage - 1),
            fetchLimit: _this.pagingOptions.pageSize,
            searchString: $location.search().searchText || null
        };
        _this.loadingIndicator.show = true;
        ExternalMetadataService.getExternalMetadataLogging(criteria, handleGridDataQuery).then(function (data) {
            _this.gridOptions.data = data;
            _this.loadingIndicator.show = false;
        });
    };
    function onPaginationChanged() {
        getData();
    }
    function handleGridDataQuery(gridData, responseHeaders) {
        PaginationService.parseResponseHeaders(responseHeaders());
        PaginationService.pageData = gridData;
    }
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: gridColumns,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        data: []
    };
    this.executeSearch = function () {
        _this.gridApi.grid.refresh();
    };
    // Should be able to replace this with a template variable in Angular 2
    // If not, then use @Input with an observable
    this.onPackageIdClicked = function (packageId) {
        $timeout(function () {
            document.getElementById("packageLinkIcon" + packageId).click();
        });
    };
    this.onPackageNavigationStarted = function () {
        _this.loadingIndicator.show = true;
    };
    this.onPackageNavigationEnded = function () {
        _this.loadingIndicator.show = false;
    };
    this.paginationPageSizeChanged = function () {
        this.pagingOptions.currentPage = 1;
        onPaginationChanged();
    };
    this.paginationPrevPageHandler = function () {
        --this.pagingOptions.currentPage;
        onPaginationChanged();
    };
    this.paginationNextPageHandler = function () {
        ++this.pagingOptions.currentPage;
        onPaginationChanged();
    };
    this.paginationDefs = {
        paginationPrevPageHandler: this.paginationPrevPageHandler,
        paginationNextPageHandler: this.paginationNextPageHandler,
        paginationPageSizeChanged: this.paginationPageSizeChanged,
        paginationJumpToPageHandler: onPaginationChanged,
        pagingOptions: PaginationService,
        pageNumberIsTextInput: true,
    };
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.pagingOptions = PaginationService;
        NavbarUtilService.viewSearchFunction = getData;
        SearchFilterService.populateCriteriaFromLocationSearch();
        getData();
    };
    this.$onDestroy = function () {
        NavbarUtilService.viewSearchFunction = null;
    };
}
angular.module('prism-ui.externalMetadata').component('externalMetadataSystemLogging', {
    controller: ExternalMetadataSystemLoggingController,
    templateUrl: 'system/externalMetadata/logging/external-metadata-system-logging-template.html'
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: external-metadata-queue-component.ts
 *
 * Created by kyang on 2019-08-02.
 */
function ExternalMetadataQueueComponent(_, $location, $q, $timeout, uiGridConstants, ExternalMetadataQueueResourceFactory, ModalService, NavbarUtilService, NotificationService, PaginationService, RequestService, SearchFilterService) {
    var _this = this;
    var loadDataTimeout;
    //======//
    // Grid //
    //======//
    var handleSortColumnChange = function (grid, sortColumns) {
        var newColumn = _.last(sortColumns);
        if (newColumn.suppressRemoveSort) {
            getEditData();
            return;
        }
        newColumn.suppressRemoveSort = true;
        newColumn.priority = 0;
        if (newColumn.colDef.field === 'dateCreated') {
            var priorityColumn = _.find(sortColumns, { colDef: { field: 'priority' } });
            priorityColumn.suppressRemoveSort = false;
            priorityColumn.sort.priority = 1;
            priorityColumn.unsort();
            getEditData();
        }
        else if (newColumn.colDef.field === 'priority') {
            var dateColumn = _.find(sortColumns, { colDef: { field: 'dateCreated' } });
            dateColumn.suppressRemoveSort = false;
            dateColumn.sort.priority = 1;
            dateColumn.unsort();
            getEditData();
        }
    };
    var gridColumnDefs = [
        {
            name: 'checkMarkRowHeaderCol',
            field: 'checkMark',
            width: '2%',
            enableSorting: false,
            enableColumnResizing: false,
            cellTemplate: 'components/visual/grid/check-mark-template.html',
            headerCellTemplate: 'components/visual/grid/header-check-mark-component-template.html'
        },
        {
            cellTemplate: 'system/externalMetadata/queue/cellTemplates/external-ingest-priority-cell-template.html',
            displayName: 'Priority',
            field: 'priority',
            sort: {
                direction: 'desc',
            },
            sortDirectionCycle: [null, uiGridConstants.DESC],
            suppressRemoveSort: true,
            type: 'number',
            width: '85',
        }, {
            cellTemplate: 'system/externalMetadata/queue/cellTemplates/external-ingest-source-cell-template.html',
            displayName: 'Source ID',
            enableSorting: false,
            field: 'sourceId',
            type: 'number',
            width: '100',
        }, {
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html',
            displayName: 'Name',
            enableSorting: false,
            field: 'name',
            width: '*',
        }, {
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html',
            displayName: 'System Name',
            enableSorting: false,
            field: 'systemName',
            width: '*',
        }, {
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html',
            displayName: 'Filename',
            enableSorting: false,
            field: 'filename',
            width: '*',
        }, {
            cellFilter: "date:'MM/dd/yyyy hh:mm:ss a'",
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html',
            displayName: 'Date Created',
            field: 'dateCreated',
            sort: {
                priority: 1
            },
            sortDirectionCycle: [null, uiGridConstants.ASC],
            type: 'number',
            width: 195,
        }
    ];
    this.gridOptions = {
        enableColumnMenus: false,
        enableColumnResizing: true,
        enableFullRowSelection: true,
        enableRowHeaderSelection: false,
        enableRowSelection: true,
        enableSorting: true,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        multiSelect: true,
        columnDefs: gridColumnDefs,
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        useExternalSorting: true,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            gridApi.core.on.sortChanged(null, handleSortColumnChange);
        }
    };
    this.onSelectAllToggled = function () {
        if (_this.gridApi.selection.getSelectedCount() === _this.gridOptions.data.length) {
            _this.gridApi.selection.clearSelectedRows();
        }
        else {
            _this.gridApi.selection.selectAllRows();
        }
    };
    //================//
    // Template Logic //
    //================//
    var showExternalIngestQueueEditorModal = function () {
        ModalService.showExternalIngestQueueEditorModal(_this.gridApi.selection.getSelectedRows(), onModalSave);
    };
    var cancelExternalIngests = function (cancellingIngests) {
        _this.loadingIndicator.show = true;
        $timeout.cancel(loadDataTimeout);
        return ExternalMetadataQueueResourceFactory.cancelIngests({ jobId: cancellingIngests.map(function (ingest) { return ingest.id; }) }).$promise
            .then(getEditData)
            .catch(getEditData);
    };
    this.toolbarButtonDefs = [
        {
            label: 'Edit',
            enabled: function () { return _this.gridApi && _this.gridApi.selection.getSelectedCount() > 0; },
            onClick: function () { return showExternalIngestQueueEditorModal(); }
        },
        {
            icon: 'fa-times',
            label: 'Cancel',
            enabled: function () { return _this.gridApi && _this.gridApi.selection.getSelectedCount() > 0; },
            onClick: function () { return cancelExternalIngests(_this.gridApi.selection.getSelectedRows()); },
        },
    ];
    var onModalSave = function (modifiedExternalIngestJobs) {
        _this.loadingIndicator.show = true;
        $q.all(_.map(modifiedExternalIngestJobs, function (ingestJob) {
            return ExternalMetadataQueueResourceFactory.update(ingestJob).$promise;
        }))
            .catch(function () {
            NotificationService.createWarningNotification('Failed to set priority on some of the external ingest jobs: Some jobs were already started / cancelled', '', true);
        })
            .finally(getEditData);
    };
    this.onPriorityCellDoubleClicked = function (row, event) {
        event.preventDefault();
        event.stopPropagation();
        row.setSelected(true);
        showExternalIngestQueueEditorModal();
    };
    this.onIngestCellDoubleClicked = function (row, event) {
        $timeout.cancel(loadDataTimeout);
        event.preventDefault();
        event.stopPropagation();
        _this.loadingIndicator.show = true;
        $location.url("/system/aggregation/edit/" + row.entity.sourceId + "/");
    };
    NavbarUtilService.viewSearchFunction = function (searchText, forceRefresh) {
        getEditData();
    };
    //============//
    // Pagination //
    //============//
    var paginationPrevPageHandler = function () {
        --_this.pagingOptions.currentPage;
        getEditData();
    };
    var paginationNextPageHandler = function () {
        ++_this.pagingOptions.currentPage;
        getEditData();
    };
    var paginationPageSizeChanged = function () {
        _this.pagingOptions.currentPage = 1;
        getEditData();
    };
    var onPaginationChanged = function () {
        getEditData();
    };
    this.paginationDefs = {
        paginationPrevPageHandler: paginationPrevPageHandler,
        paginationNextPageHandler: paginationNextPageHandler,
        paginationPageSizeChanged: paginationPageSizeChanged,
        paginationJumpToPageHandler: onPaginationChanged,
        pagingOptions: PaginationService,
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    var updatePagination = function (externalIngestJobs, responseHeaders) {
        PaginationService.parseResponseHeaders(responseHeaders());
        PaginationService.pageData = externalIngestJobs;
    };
    var isOrderedByDate = function () {
        var dateCreatedColumn = _.chain(_this)
            .get('gridApi.grid.columns', [])
            .find({ field: 'dateCreated' })
            .value();
        if (!dateCreatedColumn) {
            return false;
        }
        return !!_.size(dateCreatedColumn.sort);
    };
    var isAscendingSort = function () {
        var columns = _.get(_this, 'gridApi.grid.columns');
        if (!columns) {
            return false;
        }
        return _.some(columns, function (column) {
            return _.get(column, 'sort.direction') === 'asc';
        });
    };
    var getDataQuery = function () {
        var criteria = {
            fetchOffset: _this.pagingOptions.pageSize * (_this.pagingOptions.currentPage - 1),
            fetchLimit: _this.pagingOptions.pageSize,
            orderByDate: isOrderedByDate(),
            sortAscending: isAscendingSort(),
            searchString: $location.search().searchText || null,
        };
        return ExternalMetadataQueueResourceFactory.query(criteria, updatePagination).$promise;
    };
    var getEditData = function () {
        _this.loadingIndicator.show = true;
        $timeout.cancel(loadDataTimeout);
        var selectedIds = [];
        if (_this.gridApi) {
            selectedIds = _this.gridApi.selection.getSelectedRows().map(function (row) { return row.id; });
        }
        return RequestService.queryForNewData(getDataQuery)
            .then(function (externalsQueue) {
            _this.gridOptions.data = externalsQueue;
        }).then(function () {
            var deferred = $q.defer();
            $timeout(function () {
                _this.gridApi.selection.clearSelectedRows();
                _.forEach(selectedIds, function (selectedId) {
                    var matchingRow = _.find(_this.gridOptions.data, { id: selectedId });
                    if (matchingRow) {
                        _this.gridApi.selection.selectRow(matchingRow);
                    }
                });
                deferred.resolve(_this.gridOptions.data);
            });
            return deferred;
        }).finally(function () {
            _this.loadingIndicator.show = false;
            loadDataTimeout = $timeout(getEditData, 15000);
        });
    };
    this.$onInit = function () {
        loadDataTimeout = null;
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        SearchFilterService.populateCriteriaFromLocationSearch();
        PaginationService.resetToDefaultValues();
        _this.pagingOptions = PaginationService;
        getEditData();
    };
    this.$onDestroy = function () {
        $timeout.cancel(loadDataTimeout);
        loadDataTimeout = null;
    };
}
angular.module('prism-ui.externalMetadata').component('externalMetadataQueue', {
    controller: ExternalMetadataQueueComponent,
    templateUrl: 'system/externalMetadata/queue/external-metadata-queue-template.html'
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: file-system-edit-service.ts
 *
 * Created by kyang on 2020-09-11.
 */
angular.module('prism-ui.fileSystem').service('FileSystemEditService', function (_) {
    var _this = this;
    this.editorForm = null;
    this.originalEditData = null;
    this.setOriginalEditData = function (fileSystem) {
        _this.originalEditData = _.cloneDeep(fileSystem);
        _.invoke(_this, 'editorForm.$setPristine');
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: field-system-edit-view-component.ts
 *
 * Created by kyang on 2020-09-11.
 */
function FileSystemEditViewController($location, $route, $routeParams, BreadcrumbService, FileSystemEditService, NotificationService, PermissionsService) {
    var _this = this;
    this.getBreadcrumbName = function () {
        return _.get(FileSystemEditService, 'originalEditData.name', 'Edit File System');
    };
    this.editingNewFileSystem = function () {
        return $routeParams.id === '-1';
    };
    //=================//
    // Tab Definitions //
    //=================//
    this.setActiveTab = function (newTab) {
        _this.currentTab = newTab;
    };
    this.onTabSelect = function (newTab) {
        $route.updateParams({ editView: newTab });
    };
    this.onTabDeselect = function ($event) {
        if (!_.get(FileSystemEditService, 'editorForm.$pristine', true)) {
            $event.preventDefault();
            NotificationService.createWarningNotification('You have unsaved changes. Please save or revert.', '');
        }
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        if (!PermissionsService.isAdmin()) {
            $location.url('/login');
        }
        else {
            BreadcrumbService.clearBreadcrumbs();
            BreadcrumbService.addBreadcrumb({
                location: '/system/fileSystems/search',
                name: 'File Systems',
            });
            _this.setActiveTab($routeParams.editView || 'properties');
        }
    };
}
angular.module('prism-ui.fileSystem').component('fileSystemEditView', {
    templateUrl: 'system/fileSystem/editView/file-system-edit-view-template.html',
    controller: FileSystemEditViewController
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: file-system-search-view-component.ts
 *
 * Created by kyang on 2020-09-11.
 */
function FileSystemSearchViewController($location, FileSystemService, NavbarUtilService, PaginationService, PermissionsService, SearchFilterService, uiGridConstants) {
    //======//
    // Grid //
    //======//
    var _this = this;
    var columnDefs = [
        {
            field: 'name',
            displayName: 'Name',
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }, {
            field: 'typeName',
            displayName: 'Type',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }, {
            field: 'pathPrefix',
            displayName: 'Path Prefix',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: false,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: columnDefs,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
    this.onRowDblClick = function (row) {
        navigateToEditView(row.entity);
    };
    //======//
    // Data //
    //======//
    var getData = function () {
        var criteria = {
            fetchOffset: _this.pagingOptions.pageSize * (_this.pagingOptions.currentPage - 1),
            fetchLimit: _this.pagingOptions.pageSize,
            searchString: $location.search().searchText
        };
        _this.loadingIndicator.show = true;
        FileSystemService.getFileSystems(criteria)
            .then(function (fileSystems) {
            _this.gridOptions.data = fileSystems;
            _this.loadingIndicator.show = false;
        });
    };
    //=========//
    // Toolbar //
    //=========//
    var navigateToEditView = function (entity) {
        var fileSystemId = _.get(entity, 'id') || _this.gridApi.selection.getSelectedRows()[0].id;
        $location.url("/system/fileSystems/edit/" + fileSystemId + "/properties");
    };
    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: function () { return true; },
            onClick: function () {
                navigateToEditView({ id: -1 });
            }
        }, {
            label: 'Edit',
            enabled: function () {
                return !_.isEmpty(_this.gridApi.selection.getSelectedRows());
            },
            onClick: navigateToEditView
        }
    ];
    //============//
    // Pagination //
    //============//
    var paginationPreviousPageHandler = function () {
        --_this.pagingOptions.currentPage;
        getData();
    };
    var paginationNextPageHandler = function () {
        ++_this.pagingOptions.currentPage;
        getData();
    };
    var paginationPageSizeChanged = function () {
        _this.pagingOptions.currentPage = 1;
        getData();
    };
    this.paginationDefs = {
        paginationPrevPageHandler: paginationPreviousPageHandler,
        paginationNextPageHandler: paginationNextPageHandler,
        paginationPageSizeChanged: paginationPageSizeChanged,
        paginationJumpToPageHandler: getData,
        pagingOptions: PaginationService,
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        if (!PermissionsService.isAdmin()) {
            $location.url('/login');
        }
        else {
            PaginationService.resetToDefaultValues();
            _this.pagingOptions = PaginationService;
            NavbarUtilService.viewSearchFunction = getData;
            SearchFilterService.populateCriteriaFromLocationSearch();
            getData();
        }
    };
}
angular.module('prism-ui.fileSystem').component('fileSystemSearchView', {
    templateUrl: 'system/fileSystem/searchView/file-system-search-view-template.html',
    controller: FileSystemSearchViewController
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function GroupEditViewController($location, GroupsService, PermissionsService) {
    var _this = this;
    this.getBreadcrumbName = function () {
        return GroupsService.breadcrumbName;
    };
    this.setActiveTab = function (tab) {
        $location.search('view', tab);
        if (_this.currentTab !== tab) {
            _this.currentTab = tab;
        }
    };
    this.$onInit = function () {
        _this.isAdmin = PermissionsService.isAdmin();
        _this.setActiveTab($location.search().view || 'properties');
    };
}
angular.module('prism-ui.groups').component('groupEditView', {
    templateUrl: 'system/groups/editor/group-edit-view-template.html',
    controller: GroupEditViewController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function GroupsExceptionModalController(PERMISSION_EXCEPTION_LIST, GroupsService) {
    var _this = this;
    this.exception = {};
    this.closeHandler = function () {
        var exceptionPermission = _this.resolve.exceptionPermission;
        exceptionPermission.exception = _this.exception;
        _this.close({
            $value: {
                exceptionPermission: exceptionPermission,
                isEdit: _this.resolve.isEdit
            }
        });
    };
    this.$onInit = function () {
        var stateName = GroupsService.XJS.xml2js(_this.resolve.exceptionPermission.permission.permissionContext.targetCriteria).and.condition._property;
        _this.includeOffset = _.get(_.get(PERMISSION_EXCEPTION_LIST, stateName), 'includeOffset');
        if (_this.resolve.isEdit) {
            _this.contentType = _this.resolve.exceptionPermission.exception.content.type;
            _this.exception = _this.resolve.exceptionPermission.exception;
        }
        else {
            _this.contentType = 'Series';
        }
    };
}
angular.module('prism-ui.groups').component('groupsExceptionModal', {
    templateUrl: 'system/groups/modals/groups-exception-modal-template.html',
    controller: GroupsExceptionModalController,
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function GroupsSearchViewController($location, $q, uiGridConstants, GroupsService, ModalService, NavbarUtilService, PaginationService, PermissionsService, SearchFilterService) {
    var _this = this;
    var getData = function () {
        var criteria = {
            fetchOffset: _this.pagingOptions.pageSize * (_this.pagingOptions.currentPage - 1),
            fetchLimit: _this.pagingOptions.pageSize,
            includeUsers: true,
            searchString: $location.search().searchText
        };
        _this.loadingIndicator.show = true;
        $q.all({
            groups: GroupsService.getAllGroups(criteria),
            isSystemOps: PermissionsService.isSystemOperator()
        }).then(function (data) {
            var writeGroupPromises = [];
            _.forEach(PaginationService.pageData, function (group) {
                if (data.isSystemOps) {
                    group.hidden = false;
                }
                else {
                    writeGroupPromises.push(GroupsService.isSystemOperatorGroup(group.id).then(function (isSystemOpsOnly) {
                        group.hidden = isSystemOpsOnly;
                    }));
                }
            });
            _this.gridOptions.data = PaginationService.pageData;
            return $q.all(writeGroupPromises);
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var deleteGroup = function () {
        var groupId = _this.gridApi.selection.getSelectedRows()[0].id;
        ModalService.showMessageModal({
            messageText: 'Are you sure you want to delete this Group?',
            pullCancelLeft: true,
            title: 'Delete Group',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, function () {
            _this.loadingIndicator.show = true;
            GroupsService.deleteGroup(groupId).then(function () {
                getData();
            }).finally(function () {
                _this.loadingIndicator.show = false;
            });
        });
    };
    var paginationPreviousPageHandler = function () {
        --_this.pagingOptions.currentPage;
        getData();
    };
    var paginationNextPageHandler = function () {
        ++_this.pagingOptions.currentPage;
        getData();
    };
    var paginationPageSizeChanged = function () {
        _this.pagingOptions.currentPage = 1;
        getData();
    };
    var navigateToEditView = function (entity) {
        var groupId = _.get(entity, 'id') || _.get(_this.gridApi.selection.getSelectedRows()[0], 'id');
        $location.url("system/groups/edit/" + groupId);
    };
    var canEditSelection = function () {
        var selection = _this.gridApi.selection.getSelectedRows();
        return !!selection.length && !selection[0].hidden;
    };
    var columnDefinitions = [
        {
            field: 'name',
            displayName: 'Name',
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'users.length',
            displayName: 'Users',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: columnDefinitions,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
    this.onRowDblClick = function (row) {
        if (!row.entity.hidden) {
            navigateToEditView(row.entity);
        }
    };
    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: function () { return true; },
            onClick: function () {
                navigateToEditView({ id: -1 });
            }
        },
        {
            label: 'Edit',
            enabled: canEditSelection,
            onClick: navigateToEditView
        },
        {
            label: 'Delete',
            enabled: canEditSelection,
            onClick: deleteGroup
        }
    ];
    this.paginationDefs = {
        paginationPrevPageHandler: paginationPreviousPageHandler,
        paginationNextPageHandler: paginationNextPageHandler,
        paginationPageSizeChanged: paginationPageSizeChanged,
        paginationJumpToPageHandler: getData,
        pagingOptions: PaginationService,
    };
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.isAdmin = PermissionsService.isAdmin();
        PaginationService.resetToDefaultValues();
        _this.pagingOptions = PaginationService;
        NavbarUtilService.viewSearchFunction = getData;
        SearchFilterService.populateCriteriaFromLocationSearch();
        getData();
    };
}
angular.module('prism-ui.groups').component('groupsSearchView', {
    templateUrl: 'system/groups/searchView/groups-search-view-template.html',
    controller: GroupsSearchViewController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function GenresEditViewController(_, $location, $q, $route, $routeParams, $timeout, uiGridConstants, BreadcrumbService, DynamicPropertiesService, GenresService, ModalService, PermissionsService, SidebarService, TranslatableMetadataService) {
    var _this = this;
    this.editData = {};
    var getData = function () {
        _this.loadingIndicator.show = true;
        $q.all({
            genre: GenresService.getGenre($routeParams.id),
        }).then(function (data) {
            _this.editData = data.genre;
            GenresService.originalEditData = _.cloneDeep(_this.editData);
            _this.gridOptions.data = _.toArray(data.genre.aliases);
            TranslatableMetadataService.setDataObject(_this.editData);
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveHandler = function () {
        _.set(_this.editData, 'aliases', _.toArray(_this.gridOptions.data));
        _.forEach(_.get(_this.editData, 'aliases'), function (alias) {
            _.unset(alias, 'edited');
        });
        _this.loadingIndicator.show = true;
        TranslatableMetadataService.preSave();
        if ($routeParams.id === '-1') {
            saveNewGenre();
        }
        else {
            updateGenre();
        }
    };
    var updateGenre = function () {
        TranslatableMetadataService.preSave();
        GenresService.updateGenre(_this.editData).then(function (genre) {
            GenresService.originalEditData = _.cloneDeep(genre);
            _this.editData = genre;
            _this.editorForm.$setPristine();
            _this.gridApi.selection.clearSelectedRows();
        }).finally(function () {
            TranslatableMetadataService.dataObjectSaved(_this.editData);
            _this.loadingIndicator.show = false;
        });
    };
    var saveNewGenre = function () {
        GenresService.createGenre(_this.editData).then(function (genre) {
            $route.updateParams({ id: genre.id });
            _this.gridApi.selection.clearSelectedRows();
        }).finally(function () {
            TranslatableMetadataService.dataObjectSaved(_this.editData);
            _this.loadingIndicator.show = false;
        });
    };
    var addAliasHandler = function (selectedPartners) {
        var originalGridDataSize = _.size(_this.gridOptions.data);
        var selectedAliases = new Array();
        selectedPartners.forEach(function (selectedPartner) {
            selectedAliases.push({
                alias: '',
                edited: true,
                partner: selectedPartner
            });
        });
        _this.gridOptions.data = _.unionBy(_.toArray(_this.gridOptions.data), selectedAliases, 'partner.id');
        if (_.size(_this.gridOptions.data) > originalGridDataSize) {
            _this.editorForm.$setDirty();
        }
        _this.loadingIndicator.show = false;
    };
    this.removeAlias = function () {
        var selectedAliases = _this.gridApi.selection.getSelectedRows();
        ModalService.showMessageModal({
            messageText: 'Are you sure you want to remove the selected alias(es)?',
            pullCancelLeft: true,
            title: 'Remove Alias(es)',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, function () {
            _this.gridOptions.data = _.differenceBy(_this.gridOptions.data, selectedAliases, 'partner.id');
            _this.editorForm.$setDirty();
        });
    };
    this.addAlias = function () {
        ModalService.showAliasesModal(addAliasHandler);
    };
    var columnDefinitions = [
        {
            field: 'partner.name',
            displayName: 'Partner (Read-Only)',
            cellEditableCondition: false,
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'alias',
            displayName: 'Alias (Double Click to Edit)',
            cellTemplate: 'components/visual/grid/inline-edit-template.html'
        }
    ];
    this.gridOptions = {
        enableRowHeaderSelection: true,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: false,
        enableCellEditOnFocus: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: true,
        columnDefs: columnDefinitions,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            _this.gridApi.edit.on.afterCellEdit(null, function (rowEntity, colDef, newValue, oldValue) {
                if (newValue !== oldValue) {
                    _.set(rowEntity, 'edited', true);
                }
            });
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return !_.get(_this.editorForm, '$pristine')
                && !!_.get(_this.editData, 'name')
                && _.every(_this.gridOptions.data, function (gridItem) {
                    return _.size(gridItem.alias);
                }); },
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: function () { return !_.get(_this.editorForm, '$pristine'); },
            onClick: function () {
                _this.editData = _.cloneDeep(GenresService.originalEditData);
                TranslatableMetadataService.dataObjectReverted(_this.editData);
                _this.gridOptions.data = _.get(_this.editData, 'aliases');
                _this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: function () { return !_.get(_this.editorForm, '$dirty'); },
            onClick: function () { return $location.url("/system/properties/search").search({ tab: 'Genres' }); }
        }
    ];
    this.$onInit = function () {
        SidebarService.editService = GenresService;
        _this.isAdmin = PermissionsService.isAdmin();
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        DynamicPropertiesService.queryForProperties().then(function () {
            var requiredFields = DynamicPropertiesService.getPropValueAsArray('translatable.text.genre.required.properties', []);
            _this.translatableMetadataFields = [
                {
                    name: 'value',
                    title: 'Value',
                    required: _.includes(requiredFields, 'value'),
                },
            ];
        });
        if (_this.isAdmin) {
            if ($routeParams.id !== '-1') {
                if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                    BreadcrumbService.addBreadcrumb({
                        name: 'Edit Genre',
                        location: '/system/properties/search',
                        params: {
                            tab: 'Genres'
                        }
                    });
                }
                getData();
            }
            else {
                TranslatableMetadataService.setDataObject(_this.editData);
                BreadcrumbService.addBreadcrumb({
                    name: 'Create Genre',
                    location: '/system/properties/search',
                    params: {
                        tab: 'Genres'
                    }
                });
            }
        }
        else {
            $location.url('/login');
        }
    };
    this.$onDestroy = function () {
        GenresService.originalEditData = null;
        GenresService.viewData = null;
    };
    this.$postLink = function () {
        $timeout(function () {
            GenresService.editorForm = _this.editorForm;
            BreadcrumbService.editService = GenresService;
        });
    };
}
angular.module('prism-ui.genres').component('genresEditView', {
    templateUrl: 'system/genres/editor/genres-edit-view-template.html',
    controller: GenresEditViewController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function LanguagesEditViewController(_, $location, $route, $routeParams, $timeout, uiGridConstants, BreadcrumbService, LanguagesService, ModalService, PermissionsService, SidebarService, UtilsService) {
    var _this = this;
    this.editData = {};
    var getData = function () {
        _this.loadingIndicator.show = true;
        LanguagesService.getLanguage($routeParams.id).then(function (language) {
            LanguagesService.originalEditData = _.cloneDeep(language);
            _this.editData = language;
            _this.gridOptions.data = _.toArray(language.aliases);
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveHandler = function () {
        _.set(_this.editData, 'aliases', _.toArray(_this.gridOptions.data));
        _this.editData.iso2Code = _.toUpper(_this.editData.iso2Code);
        _.forEach(_.get(_this.editData, 'aliases'), function (alias) {
            _.unset(alias, 'edited');
        });
        _this.loadingIndicator.show = true;
        if ($routeParams.id === '-1') {
            saveNewLanguage();
        }
        else {
            updateLanguage();
        }
    };
    var updateLanguage = function () {
        LanguagesService.updateLanguage(_this.editData).then(function (language) {
            LanguagesService.originalEditData = _.cloneDeep(language);
            _this.editData = language;
            _this.editorForm.$setPristine();
            _this.gridApi.selection.clearSelectedRows();
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveNewLanguage = function () {
        LanguagesService.createLanguage(_this.editData).then(function (language) {
            $route.updateParams({ id: language.id });
            _this.gridApi.selection.clearSelectedRows();
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var addAliasHandler = function (selectedPartners) {
        var originalGridDataSize = _.size(_this.gridOptions.data);
        var selectedAliases = new Array();
        selectedPartners.forEach(function (selectedPartner) {
            selectedAliases.push({
                alias: '',
                edited: true,
                partner: selectedPartner
            });
        });
        _this.gridOptions.data = _.unionBy(_.toArray(_this.gridOptions.data), selectedAliases, 'partner.id');
        if (_.size(_this.gridOptions.data) > originalGridDataSize) {
            _this.editorForm.$setDirty();
        }
        _this.loadingIndicator.show = false;
    };
    this.removeAlias = function () {
        var selectedAliases = _this.gridApi.selection.getSelectedRows();
        ModalService.showMessageModal({
            messageText: 'Are you sure you want to remove the selected alias(es)?',
            pullCancelLeft: true,
            title: 'Remove Alias(es)',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, function () {
            _this.gridOptions.data = _.differenceBy(_this.gridOptions.data, selectedAliases, 'partner.id');
            _this.editorForm.$setDirty();
        });
    };
    this.addAlias = function () {
        ModalService.showAliasesModal(addAliasHandler);
    };
    this.validateInput = function ($event, currentValue, regexString) {
        UtilsService.inputValidatorByRegExpString($event, currentValue, regexString);
    };
    var columnDefinitions = [
        {
            field: 'partner.name',
            displayName: 'Partner (Read-Only)',
            cellEditableCondition: false,
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'alias',
            displayName: 'Alias (Double Click to Edit)',
            cellTemplate: 'components/visual/grid/inline-edit-template.html'
        }
    ];
    this.gridOptions = {
        enableRowHeaderSelection: true,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: false,
        enableCellEditOnFocus: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: true,
        columnDefs: columnDefinitions,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            _this.gridApi.edit.on.afterCellEdit(null, function (rowEntity, colDef, newValue, oldValue) {
                if (newValue !== oldValue) {
                    _.set(rowEntity, 'edited', true);
                }
            });
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return !_.get(_this.editorForm, '$pristine')
                && _.size(_.get(_this.editData, 'name'))
                && _.size(_.get(_this.editData, 'iso2Code')) === 2
                && _.every(_this.gridOptions.data, function (gridItem) {
                    return _.size(gridItem.alias);
                }); },
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: function () { return !_.get(_this.editorForm, '$pristine'); },
            onClick: function () {
                _this.editData = _.cloneDeep(LanguagesService.originalEditData);
                _this.gridOptions.data = _.get(_this.editData, 'aliases');
                _this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: function () { return !_.get(_this.editorForm, '$dirty'); },
            onClick: function () { return $location.url("/system/properties/search").search({ tab: 'Languages' }); }
        }
    ];
    this.$onInit = function () {
        SidebarService.editService = LanguagesService;
        _this.isAdmin = PermissionsService.isAdmin();
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        if (_this.isAdmin) {
            if ($routeParams.id !== '-1') {
                if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                    BreadcrumbService.addBreadcrumb({
                        name: 'Edit Language',
                        location: '/system/properties/search',
                        params: { tab: 'Languages' }
                    });
                }
                getData();
            }
            else {
                BreadcrumbService.addBreadcrumb({
                    name: 'Create Language',
                    location: '/system/properties/search',
                    params: { tab: 'Languages' }
                });
            }
        }
        else {
            $location.url('/login');
        }
    };
    this.$onDestroy = function () {
        LanguagesService.originalEditData = null;
        LanguagesService.viewData = null;
    };
    this.$postLink = function () {
        $timeout(function () {
            LanguagesService.editorForm = _this.editorForm;
            BreadcrumbService.editService = LanguagesService;
        });
    };
}
angular.module('prism-ui.languages').component('languagesEditView', {
    templateUrl: 'system/languages/editor/languages-edit-view-template.html',
    controller: LanguagesEditViewController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 1/13/16,
 * Refactored by kyang on 10/3/19.
 */
function LiveFeedSearchViewController($location, $scope, BreadcrumbService, LivefeedsResourceFactory, ModalService, NavbarUtilService, NotificationService, SearchFilterService, uiGridConstants) {
    var _this = this;
    var openLiveFeedEditView = function (liveFeed) {
        BreadcrumbService.addBreadcrumb({
            location: '/system/livefeeds/search',
            name: 'Live Feeds',
            params: angular.copy($location.search())
        });
        $location.url('/system/livefeeds/edit/' + liveFeed.id);
    };
    //======//
    // Grid //
    //======//
    var gridColumns = [
        {
            field: 'name',
            name: 'Name',
            minWidth: 250,
            sort: {
                direction: uiGridConstants.ASC,
                priority: 0
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }, {
            field: 'elementalAddress',
            name: 'Elemental Address',
            minWidth: 250,
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }, {
            field: 'profileName',
            name: 'Profile Name',
            minWidth: 250,
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }, {
            field: 'profilePermaLinkID',
            name: 'Profile PermaLink ID',
            minWidth: 250,
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];
    var gridRowSelectionChangedHandler = function (row) {
        if (row.isSelected) {
            _this.selectedLiveFeed = row.entity;
        }
        else {
            _this.selectedLiveFeed = null;
        }
    };
    var filterGrid = function (searchText) {
        _this.searchText = searchText.toLowerCase();
        _this.gridApi.grid.refresh();
    };
    var processGridFilter = function (renderableRows) {
        renderableRows.forEach(function (row) {
            row.visible = (_this.searchText) ? row.entity.name.toLowerCase().indexOf(_this.searchText) !== -1 : true;
        });
        return renderableRows;
    };
    this.currentGridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        rowHeight: 26,
        multiSelect: false,
        enableVerticalScrollbar: 2,
        columnDefs: gridColumns,
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged($scope, gridRowSelectionChangedHandler);
            gridApi.grid.registerRowsProcessor(processGridFilter, 200);
        }
    };
    this.onRowDblClick = function (row) {
        openLiveFeedEditView(row.entity);
    };
    //=========//
    // Toolbar //
    //=========//
    var cloneSelectedLiveFeed = function () {
        _this.loadingIndicator.show = true;
        LivefeedsResourceFactory.clone({ id: _this.selectedLiveFeed.id })
            .$promise.then(function (clone) {
            _this.loadingIndicator.show = false;
            openLiveFeedEditView(clone);
        });
    };
    var deleteLiveFeed = function () {
        _this.loadingIndicator.show = true;
        LivefeedsResourceFactory.toggleArchive({ id: _this.selectedLiveFeed.id })
            .$promise.then(function () {
            queryForGridData();
        });
    };
    var deleteMessage = 'Are you sure you want to delete ';
    var cloneMessage = 'Are you sure you want to clone ';
    var openConfirmModal = function (messageText, title, handler) {
        messageText += _this.selectedLiveFeed.name + '?';
        title += _this.selectedLiveFeed.name + '?';
        ModalService.showMessageModal({
            messageText: messageText,
            pullCancelLeft: true,
            title: title,
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, handler);
    };
    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: function () { return _this.searchPerms.read && _this.searchPerms.write; },
            onClick: function () {
                openLiveFeedEditView({ id: -1 });
            }
        }, {
            label: 'Edit',
            enabled: function () {
                return (_this.searchPerms.read &&
                    _this.searchPerms.write &&
                    !!_this.selectedLiveFeed);
            },
            onClick: function () {
                openLiveFeedEditView(_this.selectedLiveFeed);
            }
        }, {
            label: 'Clone',
            enabled: function () {
                return (_this.searchPerms.clone.read &&
                    _this.searchPerms.clone.write &&
                    !!_this.selectedLiveFeed);
            },
            onClick: function () {
                openConfirmModal(cloneMessage, 'Clone ', cloneSelectedLiveFeed);
            }
        }, {
            label: 'Delete',
            enabled: function () { return _this.searchPerms.read && !!_this.selectedLiveFeed; },
            onClick: function () {
                openConfirmModal(deleteMessage, 'Delete ', deleteLiveFeed);
            }
        }
    ];
    //=================//
    // Lifecycle Hooks //
    //=================//
    var handleGridDataQuery = function (gridData, responseHeaders) {
        if ($location.search().searchText) {
            filterGrid($location.search().searchText);
        }
        _this.loadingIndicator.show = false;
    };
    var queryForGridData = function () {
        _this.loadingIndicator.show = true;
        _this.selectedLiveFeed = null;
        _this.currentGridOptions.data = LivefeedsResourceFactory.query({}, handleGridDataQuery);
        return _this.currentGridOptions.data.$promise;
    };
    this.$onInit = function () {
        _this.selectedLiveFeed = null;
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.searchPerms = {
            read: true,
            write: true,
            clone: {
                read: true,
                write: true,
                batch: {
                    write: true
                }
            }
        };
        SearchFilterService.populateCriteriaFromLocationSearch();
        NavbarUtilService.viewSearchFunction = filterGrid;
        queryForGridData();
    };
}
angular.module('prism-ui.livefeed').component('livefeedSearchview', {
    bindings: {},
    controller: LiveFeedSearchViewController,
    templateUrl: 'system/livefeed/searchView/livefeed-searchview-template.html',
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by randysorensen on 8/10/16,
 * Refactored by kyang on 9/25/2019
 */
function MetadataItemsGridController(_, $q, $scope, MetadataEditService, ModalService) {
    //======//
    // Grid //
    //======//
    var _this = this;
    this.currentGridOptions = {
        selectionRowHeaderColName: 'checkMarkRowHeaderCol',
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        rowHeight: 26,
        multiSelect: true,
        rowTemplate: '<div ng-dblclick="grid.appScope.$ctrl.rowDoubleClicked(row)" ' +
            'ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ui-grid-cell> ' +
            '</div>',
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged($scope, _this.gridRowSelectionChangedHandler);
        }
    };
    this.gridRowSelectionChangedHandler = function (row) {
        if (row.isSelected) {
            _this.selectedMetadataRows.push(row.entity);
        }
        else {
            var index = _this.selectedMetadataRows.indexOf(row.entity);
            _this.selectedMetadataRows.splice(index, 1);
        }
    };
    this.toggleRows = function (evt) {
        if (_this.gridApi.selection.selectAll) {
            _this.gridApi.selection.clearSelectedRows(evt);
            _this.gridApi.selection.selectAll = false;
        }
        else {
            _this.gridApi.selection.selectAllVisibleRows(evt);
            _this.gridApi.selection.selectAll = true;
        }
        _this.selectedMetadataRows = _this.gridApi.selection.getSelectedRows();
    };
    this.rowDoubleClicked = function (row) {
        showMetadataItemModal(row.entity);
    };
    //=================//
    // Toolbar Buttons //
    //=================//
    this.saveMetadataItem = function (prop) {
        _this.loadingIndicator.show = true;
        if (prop.id < 0) {
            delete prop.id;
        }
        prop.required = !!prop.required;
        prop.mvpd = _this.showMVPD;
        MetadataEditService.saveProperty(prop).then(function () {
            _this.queryForGridData();
        });
    };
    var showMetadataItemModal = function (row) {
        ModalService.showMetadataItemEditorModal(_this.ownerClass, _.get(row, 'id', -1), _this.showMVPD, _this.showConversion, _this.saveMetadataItem);
    };
    var openAddMetadataItemModal = function () {
        showMetadataItemModal();
    };
    var openEditMetadataItemModal = function () {
        showMetadataItemModal(_this.selectedMetadataRows[0]);
    };
    var confirmDeleteMetadataItem = function () {
        var title = "Delete " + (_this.showConversion ? 'Conversion Template Variable' : 'Metadata Item');
        var message = "Are you sure you want to delete this " + (_this.showConversion ? 'conversion template variable' : 'metadata item') + "?";
        ModalService.showMessageModal({
            messageText: message,
            pullCancelLeft: true,
            title: title,
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, function () {
            var promises = [];
            _this.loadingIndicator.show = true;
            angular.forEach(_this.selectedMetadataRows, function (metadataObject) {
                var item = MetadataEditService.deleteProperty(metadataObject);
                promises.push(item);
            });
            $q.all(promises).then(function () {
                _this.queryForGridData();
            });
        });
    };
    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: function () { return _this.selectedMetadataRows.length === 0; },
            onClick: openAddMetadataItemModal
        }, {
            label: 'Edit',
            enabled: function () { return _this.selectedMetadataRows.length === 1; },
            onClick: openEditMetadataItemModal
        }, {
            label: 'Delete',
            enabled: function () { return _this.selectedMetadataRows.length >= 1; },
            onClick: confirmDeleteMetadataItem
        }
    ];
    this.checkMarkCellClicked = function (row) {
        _this.saveMetadataItem(row);
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.queryForGridData = function () {
        _this.selectedMetadataRows = [];
        return _this.getPropertiesPromise()
            .then(function (data) {
            _this.currentGridOptions.data = data;
            _this.loadingIndicator.show = false;
        });
    };
    this.$onInit = function () {
        _this.selectedMetadataRows = [];
        _this.loadingIndicator = {
            backdrop: true,
            show: true,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.currentGridOptions.columnDefs = _this.columnDefs;
        _this.queryForGridData();
    };
}
angular.module('prism-ui.metadataItems').component('metadataItemsGrid', {
    bindings: {
        columnDefs: '=',
        getPropertiesPromise: '&',
        headerTitle: '=',
        ownerClass: '=',
        showMVPD: '=',
        showConversion: '=',
    },
    controller: MetadataItemsGridController,
    templateUrl: 'system/metadata/grid/metadata-items-grid-template.html'
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by randysorensen on 8/10/16,
 * Refactored by kyang on 9/25/2019
 */
function MetadataItemsSearchViewController(_, $location, $routeParams, BreadcrumbService, MetadataItemsViewDataTransformerFactory, MetadataItemsSearchViewService) {
    //================//
    // Template Logic //
    //================//
    var _this = this;
    this.headerTitle = function () {
        switch (_this.currentTab) {
            case 'package':
                return 'Package Metadata';
            case 'conversion':
                return 'Conversion Template Variables';
            default:
                return 'Non-Package Metadata';
        }
    };
    this.onTabSelect = function (tabName) {
        switch (tabName) {
            case 'package':
                $location.path('/system/metadataItems/package');
                break;
            case 'conversion':
                $location.path('/system/metadataItems/conversion');
                break;
            default:
                $location.path('/system/metadataItems/nonPackage');
                break;
        }
    };
    this.getPropertiesPromise = function () {
        if (_this.currentTab === 'conversion') {
            return MetadataItemsSearchViewService.getMetadataProperties('nonPackage', true);
        }
        return MetadataItemsSearchViewService.getMetadataProperties(_this.currentTab, false);
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.currentTab = $routeParams.type;
        _this.columnDefs = MetadataItemsViewDataTransformerFactory[_this.currentTab + "Columns"];
    };
}
angular.module('prism-ui.metadataItems').component('metadataItemsSearchView', {
    bindings: {},
    controller: MetadataItemsSearchViewController,
    templateUrl: 'system/metadata/searchView/metadata-items-searchview-template.html'
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.metadataItems').service('MetadataItemsSearchViewService', function (_, $q, MetadataEditService, MetaPropsResourceFactory, PartnerResourceFactory) {
    this.getMetadataProperties = function (type, conversionVariablesOnly) {
        return MetaPropsResourceFactory.query({ ownerFilter: type })
            .$promise.then(function (metadataItems) {
            var ownerPromises = [];
            angular.forEach(metadataItems, function (metadataItem) {
                ownerPromises.push(MetadataEditService.getGroupNamesByIds(metadataItem.groupIds)
                    .then(function (groupNames) {
                    metadataItem.owners = groupNames;
                    metadataItem.ownersString = groupNames.toString();
                    return metadataItem;
                }));
            });
            return $q.all(ownerPromises).then(function (metadataItems) {
                return metadataItems.filter(function (metadataItem) {
                    return conversionVariablesOnly === _.includes(metadataItem.owners, 'Media Conversion');
                });
            });
        });
    };
    this.getPartnerMetadataProperties = function (partnerId, showMVPD) {
        return PartnerResourceFactory.getMetadataProperties({
            id: partnerId, mvpd: showMVPD
        }).$promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.metadataItems').factory('MetadataItemsViewDataTransformerFactory', function (uiGridConstants) {
    return {
        packageColumns: [
            {
                name: 'checkMarkRowHeaderCol',
                field: 'checkMark',
                width: 30,
                enableColumnMenu: false,
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'components/visual/grid/check-mark-template.html',
                headerCellTemplate: 'system/metadata/searchView/cellTemplates/header-check-mark-template.html'
            },
            {
                field: 'displayIndex',
                displayName: '#',
                width: 60,
                type: 'number',
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 0
                },
                sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC]
            },
            {
                field: 'displayName',
                width: '20%',
                sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC]
            },
            {
                field: 'ownersString',
                width: '10%',
                displayName: 'Type',
                enableSorting: false
            },
            {
                field: 'requiredLongSeason',
                displayName: 'Long Form Season',
                cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
                enableSorting: false
            },
            {
                field: 'requiredShortSeason',
                displayName: 'Short Form Season',
                cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
                enableSorting: false
            },
            {
                field: 'requiredLongVolume',
                displayName: 'Long Form Volume',
                cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
                enableSorting: false
            },
            {
                field: 'requiredShortVolume',
                displayName: 'Short Form Volume',
                cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
                enableSorting: false
            },
            {
                field: 'requiredLongMovie',
                displayName: 'Long Form Movie',
                cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
                enableSorting: false
            },
            {
                field: 'requiredShortMovie',
                displayName: 'Short Form Movie',
                cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
                enableSorting: false
            },
            {
                field: 'requiredAdPreRoll',
                displayName: 'Ad/Preroll',
                cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
                enableSorting: false
            }
        ],
        nonPackageColumns: [
            {
                name: 'checkMarkRowHeaderCol',
                field: 'checkMark',
                width: 30,
                enableColumnMenu: false,
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'components/visual/grid/check-mark-template.html',
                headerCellTemplate: 'system/metadata/searchView/cellTemplates/header-check-mark-template.html'
            },
            {
                field: 'displayIndex',
                displayName: '#',
                width: 60,
                type: 'number',
                sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC]
            },
            {
                field: 'displayName',
                width: '20%',
                sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC]
            },
            {
                field: 'ownersString',
                displayName: 'Type',
                type: 'string',
                sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 0
                }
            },
            {
                field: 'uiControlHint',
                displayName: 'Component',
                sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC]
            }
        ],
        conversionColumns: [
            {
                name: 'checkMarkRowHeaderCol',
                field: 'checkMark',
                width: 30,
                enableColumnMenu: false,
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'components/visual/grid/check-mark-template.html',
                headerCellTemplate: 'system/metadata/searchView/cellTemplates/header-check-mark-template.html'
            },
            {
                field: 'displayIndex',
                displayName: '#',
                width: 60,
                type: 'number',
                sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC]
            },
            {
                field: 'displayName',
                width: '50%',
                sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC]
            },
            {
                field: 'uiControlHint',
                displayName: 'Component',
                sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC]
            }
        ],
        partnerColumns: [
            {
                name: 'checkMarkRowHeaderCol',
                field: 'checkMark',
                width: 30,
                enableColumnMenu: false,
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'components/visual/grid/check-mark-template.html',
                headerCellTemplate: 'system/metadata/searchView/cellTemplates/header-check-mark-template.html'
            },
            {
                field: 'displayIndex',
                displayName: '#',
                width: 60,
                type: 'number',
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 0
                },
                sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC]
            },
            {
                field: 'displayName',
                width: '20%',
                sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC]
            },
            {
                field: 'requiredLongSeason',
                displayName: 'Long Form Season',
                cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
                enableSorting: false
            },
            {
                field: 'requiredShortSeason',
                displayName: 'Short Form Season',
                cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
                enableSorting: false
            },
            {
                field: 'requiredLongVolume',
                displayName: 'Long Form Volume',
                cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
                enableSorting: false
            },
            {
                field: 'requiredShortVolume',
                displayName: 'Short Form Volume',
                cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
                enableSorting: false
            },
            {
                field: 'requiredLongMovie',
                displayName: 'Long Form Movie',
                cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
                enableSorting: false
            },
            {
                field: 'requiredShortMovie',
                displayName: 'Short Form Movie',
                cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
                enableSorting: false
            },
            {
                field: 'requiredAdPreRoll',
                displayName: 'Ad/Preroll',
                cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
                enableSorting: false
            }
        ],
        mvpdColumns: [
            {
                name: 'checkMarkRowHeaderCol',
                field: 'checkMark',
                width: 30,
                enableColumnMenu: false,
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'components/visual/grid/check-mark-template.html',
                headerCellTemplate: 'system/metadata/searchView/cellTemplates/header-check-mark-template.html'
            },
            {
                field: 'displayIndex',
                displayName: '#',
                width: 60,
                type: 'number',
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 0
                },
                sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC]
            },
            {
                field: 'displayName',
                width: '20%',
                sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC]
            },
            {
                field: 'required',
                displayName: 'Required',
                cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
                enableSorting: false
            }
        ]
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: package-notifications-edit-view-component.ts
 *
 * Created by randysorensen on 4/11/18.
 */
function PackageNotificationsEditViewController(_, $timeout, PackageNotificationsService, SidebarService, BreadcrumbService) {
    var _this = this;
    var getData = function () {
        _this.loadingIndicator.show = true;
        return PackageNotificationsService.getPackageNotificationEditData()
            .then(function (editData) {
            _this.availableEmailTemplates = editData.emailTemplates;
            _this.availablePackageStatuses = editData.availablePackageStatuses;
            _this.notification = editData.packageNotification;
        })
            .finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var requiredFieldsArePopulated = function () {
        var statusIsPopulated = _.get(_this, 'notification.status.length') > 0;
        var delayIsPositive = _.get(_this, 'notification.delay') >= 0;
        var emailTemplateIsSelected = !_.isNil(_.get(_this, 'notification.emailTemplate'));
        return statusIsPopulated && delayIsPositive && emailTemplateIsSelected;
    };
    var saveNotification = function () {
        _this.loadingIndicator.show = true;
        PackageNotificationsService.saveEditData()
            .then(function (savedNotification) {
            _this.notification = savedNotification;
        })
            .finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var revertNotification = function () {
        _this.notification = PackageNotificationsService.revertEditData();
    };
    var initToolbar = function () {
        _this.toolbarButtonDefs = [
            {
                label: 'Save',
                enabled: function () { return _this.editorForm.$dirty && requiredFieldsArePopulated(); },
                onClick: saveNotification
            },
            {
                label: 'Revert',
                enabled: function () { return PackageNotificationsService.canRevertEditView(); },
                onClick: revertNotification
            },
            {
                label: 'Close',
                enabled: function () { return true; },
                onClick: function () { return PackageNotificationsService.exitEdit(); }
            }
        ];
    };
    this.$onInit = function () {
        _this.notification = {};
        _this.availableEmailTemplates = [];
        _this.availablePackageStatuses = [];
        _this.breadcrumbName = 'Edit Package Status Notification';
        _this.toolbarButtonDefs = undefined;
        BreadcrumbService.editService = PackageNotificationsService;
        SidebarService.editService = PackageNotificationsService;
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        initToolbar();
        getData();
    };
    this.$postLink = function () {
        $timeout(function () {
            PackageNotificationsService.editorForm = _this.editorForm;
        });
    };
}
angular.module('prism-ui.packageNotifications').component('packageNotificationsEditView', {
    controller: PackageNotificationsEditViewController,
    templateUrl: 'system/packageNotifications/editView/package-notifications-edit-view-template.html',
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: package-notifications-search-view-component.ts
 *
 * Created by randysorensen on 4/9/18.
 */
function PackageNotificationsSearchViewController(_, $location, uiGridConstants, ModalService, NotificationService, PackageNotificationsService) {
    var _this = this;
    var getData = function () {
        _this.loadingIndicator.show = true;
        if (_.get(_this, 'gridApi.selection')) {
            _this.gridApi.selection.clearSelectedRows();
        }
        PackageNotificationsService.getPackageNotifications().then(function (notifications) {
            _this.gridOptions.data = notifications;
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    this.getStatusDescription = function (status) { return PackageNotificationsService.packageStatusDictionary[status]; };
    var getSelectedCount = function () {
        var selectedCount = 0;
        if (_.get(_this, 'gridApi.selection')) {
            selectedCount = _this.gridApi.selection.getSelectedCount();
        }
        return selectedCount;
    };
    var editPackageNotification = function (notification) {
        if (!notification.hidden) {
            $location.url("/system/packageNotifications/edit/" + notification.id);
        }
        else {
            NotificationService.createFailureNotification('Notification is hidden');
        }
    };
    var showConfirmationModal = function (action, handler) {
        var capitalizedAction = "" + action[0].toUpperCase() + action.slice(1);
        ModalService.showMessageModal({
            messageText: "Are you sure you want to " + action + " the selected notification?",
            title: capitalizedAction + ' Package Status Notification',
            windowClass: 'confirm-modal-sm',
            showOK: true,
            okText: 'Yes',
            pullCancelLeft: true
        }, handler);
    };
    this.onRowDblClick = function (row) {
        editPackageNotification(row.entity);
    };
    var initGrid = function () {
        _this.gridOptions = {
            rowSelection: true,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            enableSelectAll: false,
            multiSelect: false,
            enableColumnResizing: true,
            enableSorting: true,
            enableHorizontalScrollbar: uiGridConstants.ALWAYS,
            enableVerticalScrollbar: uiGridConstants.ALWAYS,
            rowHeight: 26,
            rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
            onRegisterApi: function (gridApi) {
                _this.gridApi = gridApi;
            }
        };
        _this.gridOptions.columnDefs = [
            {
                field: 'status',
                displayName: 'Status',
                width: '15%',
                sort: {
                    direction: 'asc',
                    priority: 0
                },
                cellTemplate: 'system/packageNotifications/searchView/gridTemplates/package-status-cell-template.html'
            },
            {
                field: 'delay',
                displayName: 'Waiting Time',
                width: '10%',
                sort: {
                    direction: 'asc',
                    priority: 1
                },
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                field: 'emailSubjectExpression',
                displayName: 'Email Subject Expression',
                width: '*',
                sort: {
                    direction: 'asc',
                    priority: 3,
                },
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                field: 'emailTemplate.name',
                displayName: 'Email Template',
                width: '20%',
                sort: {
                    direction: 'asc',
                    priority: 3
                },
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                field: 'recipients.length',
                displayName: '# of Recipients',
                width: '10%',
                sort: {
                    direction: 'asc',
                    priority: 2
                },
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            }
        ];
    };
    var initToolbar = function () {
        _this.toolbarButtonDefs = [
            {
                label: 'New',
                enabled: function () { return true; },
                onClick: function () { return $location.url("/system/packageNotifications/edit/-1"); }
            },
            {
                label: 'Edit',
                enabled: function () { return getSelectedCount() === 1; },
                onClick: function () { return editPackageNotification(_this.gridApi.selection.getSelectedRows()[0]); }
            }
        ];
    };
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.gridOptions = undefined;
        _this.gridApi = undefined;
        _this.toolbarButtonDefs = undefined;
        initGrid();
        initToolbar();
        getData();
    };
}
angular
    .module('prism-ui.packageNotifications')
    .component('packageNotificationsSearchView', {
    bindings: {},
    templateUrl: 'system/packageNotifications/searchView/package-notifications-search-view-template.html',
    controller: PackageNotificationsSearchViewController
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 2/16/16,
 * Refactored by kyang on 9/30/19.
 */
function PartnerSearchViewController($scope, $location, uiGridConstants, NotificationService, BreadcrumbService, ModalService, NavbarUtilService, PartnerResourceFactory, PaginationService, SearchFilterService) {
    //======//
    // Grid //
    //======//
    var _this = this;
    var gridColumns = [
        {
            field: 'name',
            name: 'Name',
            sort: {
                direction: uiGridConstants.ASC,
                priority: 0
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }, {
            field: 'subscriptionCount',
            name: 'Subscriptions',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];
    var gridRowSelectionChangedHandler = function (row) {
        if (row.isSelected) {
            _this.selectedPartner = row.entity;
        }
        else {
            _this.selectedPartner = null;
        }
    };
    this.currentGridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: gridColumns,
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged($scope, gridRowSelectionChangedHandler);
        }
    };
    var openPartnerEditView = function (partner) {
        BreadcrumbService.addBreadcrumb({
            location: '/system/partners/search',
            name: 'Partners',
            params: angular.copy($location.search())
        });
        $location.url('/system/partners/edit/' + partner.id + '/properties');
    };
    this.onRowDblClick = function (row) {
        openPartnerEditView(row.entity);
    };
    //=========//
    // Toolbar //
    //=========//
    var hideMessage = 'Are you sure you want to hide ';
    var unhideMessage = 'Are you sure you want to unhide ';
    var openConfirmModal = function (messageText, title, handler) {
        messageText += _this.selectedPartner.name + '?';
        title += _this.selectedPartner.name + '?';
        ModalService.showMessageModal({
            messageText: messageText,
            pullCancelLeft: true,
            title: title,
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, handler);
    };
    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: function () { return _this.searchPerms.read && !!_this.searchPerms.write; },
            onClick: function () { return openPartnerEditView({ id: -1 }); }
        }, {
            label: 'Edit',
            enabled: function () { return _this.searchPerms.read && _this.searchPerms.write && !!_this.selectedPartner; },
            onClick: function () { return openPartnerEditView(_this.selectedPartner); }
        }, {
            label: 'Hide',
            enabled: function () { return _this.searchPerms.read && _this.searchPerms.write && _this.selectedPartner && !_this.selectedPartner.hidden; },
            onClick: function () { return openConfirmModal(hideMessage, 'Hide', _this.toggleArchiveFlag); }
        }, {
            label: 'Unhide',
            enabled: function () { return _this.searchPerms.read && _this.searchPerms.write && _this.selectedPartner && !!_this.selectedPartner.hidden; },
            onClick: function () { return openConfirmModal(unhideMessage, 'Unhide', _this.toggleArchiveFlag); }
        }
    ];
    this.toggleArchiveFlag = function () {
        _this.loadingIndicator.show = true;
        PartnerResourceFactory.toggleArchive({ id: _this.selectedPartner.id }).$promise.then(function () {
            _this.queryForGridData();
        });
    };
    this.toolbarCheckboxDefs = [{
            label: 'Show Hidden',
            onUpdate: function (nowShowHidden) {
                _this.includeArchived = nowShowHidden;
                _this.queryForGridData();
            }
        }];
    //============//
    // Pagination //
    //============//
    var onPaginationChanged = function () {
        _this.queryForGridData();
    };
    var paginationPrevPageHandler = function () {
        --_this.pagingOptions.currentPage;
        onPaginationChanged();
    };
    var paginationNextPageHandler = function () {
        ++_this.pagingOptions.currentPage;
        onPaginationChanged();
    };
    var paginationPageSizeChangedHandler = function () {
        _this.pagingOptions.currentPage = 1;
        onPaginationChanged();
    };
    this.paginationDefs = {
        paginationPrevPageHandler: paginationPrevPageHandler,
        paginationNextPageHandler: paginationNextPageHandler,
        paginationPageSizeChanged: paginationPageSizeChangedHandler,
        paginationJumpToPageHandler: onPaginationChanged,
        pagingOptions: PaginationService,
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.queryForGridData = function () {
        var offset = _this.pagingOptions.pageSize * (_this.pagingOptions.currentPage - 1);
        var queryOpts = {
            fetchOffset: offset,
            fetchLimit: _this.pagingOptions.pageSize,
            includeHidden: _this.includeArchived,
            type: _this.contentType
        };
        if ($location.search().hasOwnProperty('searchText')) {
            queryOpts.searchString = $location.search().searchText;
        }
        _this.loadingIndicator.show = true;
        _this.selectedPartner = null;
        return PartnerResourceFactory.query(queryOpts, function (data, responseHeaders) {
            PaginationService.parseResponseHeaders(responseHeaders());
        }).$promise.then(function (data) {
            PaginationService.pageData = data;
            _this.currentGridOptions.data = data;
            _this.loadingIndicator.show = false;
        });
    };
    this.$onInit = function () {
        _this.pagingOptions = PaginationService;
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.searchPerms = {
            read: true,
            write: true,
            clone: {
                read: true,
                write: true,
                batch: {
                    write: true
                }
            }
        };
        NavbarUtilService.viewSearchFunction = _this.queryForGridData;
        PaginationService.pageDataResource = PartnerResourceFactory;
        SearchFilterService.populateCriteriaFromLocationSearch();
        _this.queryForGridData();
    };
    this.$onDestroy = function () {
        NavbarUtilService.viewSearchFunction = null;
    };
}
angular.module('prism-ui.partner').component('partnerSearchview', {
    bindings: {},
    controller: PartnerSearchViewController,
    templateUrl: 'system/partner/searchView/partner-searchview-template.html'
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function PropertiesSearchViewController(_, $location, uiGridConstants, CategoriesService, DynamicPropertiesService, GenresService, LanguagesService, ModalService, NavbarUtilService, RolesService, SearchFilterService, TerritoriesService) {
    //=======================//
    // Generic Tab Functions //
    //=======================//
    var _this = this;
    var setAllDataFunction = function (getAllDataFunction, queryParams) {
        if (queryParams === void 0) { queryParams = undefined; }
        return getAllDataFunction(queryParams).then(function (data) {
            _this.gridOptions.data = data;
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var filterGridBySearchText = function (rows) {
        var searchText = $location.search().searchText;
        if (_.size(searchText)) {
            rows.forEach(function (row) {
                _.set(row, 'visible', _.includes(_.toLower(row.entity.name), _.toLower(searchText)));
            });
        }
        return rows;
    };
    var navigateToCreateView = function (routeSuffix) {
        if (routeSuffix === void 0) { routeSuffix = ''; }
        $location.url("/system/properties/" + _this.currentTab.editRoute + "/edit/-1" + routeSuffix);
    };
    var navigateToEditView = function (entity) {
        $location.url("/system/properties/" + _this.currentTab.editRoute + "/edit/" + _.get(entity, 'id'));
    };
    //=======//
    // Roles //
    //=======//
    var getCurrentSubTabType = function () {
        return _.get(_this, 'currentSubTab.type');
    };
    var setRolesGridData = function () {
        _this.currentSubTab = _.get(_this.tabs.Roles.subTabs, $location.search().subTab);
        return setAllDataFunction(RolesService.getAllRolesPaginated);
    };
    var processRolesGridFilter = function (rows) {
        var subTabType = getCurrentSubTabType();
        rows = filterGridBySearchText(rows);
        if (!_.isNil(subTabType)) {
            rows.forEach(function (row) {
                _.set(row, 'visible', _.get(row, 'visible') && _.isEqual(row.entity.type, subTabType));
            });
        }
        return rows;
    };
    var navigateToRolesCreateView = function () {
        var suffix = '';
        if (!_.isNil(getCurrentSubTabType())) {
            suffix = "/" + getCurrentSubTabType();
        }
        navigateToCreateView(suffix);
    };
    //====================//
    // Dynamic Properties //
    //====================//
    var setDynamicPropsGridData = function () {
        return DynamicPropertiesService.queryForProperties()
            .then(function (propertiesMap) {
            _this.gridOptions.data = _.flatMap(propertiesMap, function (value, name) {
                if (!DynamicPropertiesService.propIsEditable(name)) {
                    return [];
                }
                return [{
                        name: name,
                        value: value,
                        hasConfidentialInfo: DynamicPropertiesService.propContainsConfidentialInfo(name)
                    }];
            });
        });
    };
    var navigateToDynamicPropsCreateView = function () {
        $location.url("/system/properties/" + _this.currentTab.editRoute + "/edit");
    };
    var navigateToDynamicPropsEditView = function (entity) {
        var propertyNamePath = encodeURIComponent(_.get(entity, 'name'));
        $location.url("/system/properties/" + _this.currentTab.editRoute + "/edit");
        $location.search('propertyName', propertyNamePath);
    };
    var deleteDynamicProperty = function () {
        var entity = _.first(_this.gridApi.selection.getSelectedRows());
        _this.loadingIndicator.show = true;
        DynamicPropertiesService.deleteProperty(entity.name)
            .then(getData);
    };
    var confirmDynamicPropDeletion = function (entity) {
        ModalService.showMessageModal({
            messageText: "Are you sure you want to delete " + entity.name + "?",
            pullCancelLeft: true,
            title: "Delete " + entity.name + "?",
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, deleteDynamicProperty);
    };
    //=================//
    // Tab Definitions //
    //=================//
    this.tabs = {
        Categories: {
            type: 'Categories',
            displayName: 'Categories',
            editRoute: 'categories',
            setGridDataFunction: function () { return setAllDataFunction(CategoriesService.getAllCategories); },
            processGridFilterFunction: filterGridBySearchText,
            createPropertyFunction: navigateToCreateView,
            editPropertyFunction: navigateToEditView,
            columnDefinitions: [
                {
                    field: 'name',
                    displayName: 'Name',
                    sort: {
                        direction: 'asc',
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                },
                {
                    field: 'type.name',
                    displayName: 'Type',
                    cellTemplate: 'components/visual/grid/category-type-cell-template.html'
                },
                {
                    field: 'adPodAcceptProfile.name',
                    displayName: 'AD POD Accept Profile',
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                },
                {
                    field: 'adPodEnabledForUpLynk',
                    displayName: 'AD PROD Enabled for UpLynk',
                    cellTemplate: 'components/visual/grid/radio-button-template.html'
                },
                {
                    field: 'cloneable',
                    displayName: 'Enabled for Clone',
                    cellTemplate: 'components/visual/grid/radio-button-template.html'
                },
                {
                    field: 'aliasCount',
                    displayName: '# of Alias',
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }
            ]
        },
        Genres: {
            type: 'Genres',
            displayName: 'Genres',
            editRoute: 'genres',
            setGridDataFunction: function () { return setAllDataFunction(GenresService.getAllGenres); },
            processGridFilterFunction: filterGridBySearchText,
            createPropertyFunction: navigateToCreateView,
            editPropertyFunction: navigateToEditView,
            columnDefinitions: [
                {
                    field: 'name',
                    displayName: 'Name',
                    sort: {
                        direction: 'asc',
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                },
                {
                    field: 'aliasCount',
                    displayName: '# of Alias',
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                },
            ]
        },
        Languages: {
            type: 'Languages',
            displayName: 'Languages',
            editRoute: 'languages',
            setGridDataFunction: function () { return setAllDataFunction(LanguagesService.getAllLanguagesPaginated); },
            processGridFilterFunction: filterGridBySearchText,
            createPropertyFunction: navigateToCreateView,
            editPropertyFunction: navigateToEditView,
            columnDefinitions: [
                {
                    field: 'name',
                    displayName: 'Name',
                    sort: {
                        direction: 'asc',
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html',
                },
                {
                    field: 'aITranslate',
                    displayName: 'AI Translate',
                    cellTemplate: 'components/visual/grid/boolean-flag-checkmark-template.html',
                    width: 108,
                },
                {
                    field: 'iso2Code',
                    displayName: 'ISO2 Code',
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html',
                },
                {
                    field: 'locale',
                    displayName: 'Locale',
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html',
                },
                {
                    field: 'aliasCount',
                    displayName: '# of Alias',
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html',
                },
            ],
        },
        Territories: {
            type: 'Territories',
            displayName: 'Territories',
            editRoute: 'territories',
            setGridDataFunction: function () { return setAllDataFunction(TerritoriesService.getAllTerritories, { fetchLimit: 10000 }); },
            processGridFilterFunction: filterGridBySearchText,
            createPropertyFunction: navigateToCreateView,
            editPropertyFunction: navigateToEditView,
            columnDefinitions: [
                {
                    field: 'name',
                    displayName: 'Name',
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                },
                {
                    field: 'value',
                    displayName: 'Value',
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                },
                {
                    field: 'iSO2Code',
                    displayName: 'ISO2 Code',
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                },
                {
                    field: 'iSO3Code',
                    displayName: 'ISO3 Code',
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }
            ],
        },
        Roles: {
            type: 'Roles',
            displayName: 'Roles',
            editRoute: 'roles',
            setGridDataFunction: setRolesGridData,
            processGridFilterFunction: processRolesGridFilter,
            createPropertyFunction: navigateToRolesCreateView,
            editPropertyFunction: navigateToEditView,
            columnDefinitions: [
                {
                    field: 'name',
                    displayName: 'Name',
                    sort: {
                        direction: 'asc',
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                },
                {
                    field: 'type',
                    displayName: 'Type',
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                },
                {
                    field: 'aliasCount',
                    displayName: '# of Alias',
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }
            ],
            subTabs: {
                All: {
                    displayName: 'All'
                },
                Audio: {
                    type: 'Audio',
                    displayName: 'Audio Properties'
                },
                CC: {
                    type: 'CC',
                    displayName: 'Closed Captioning Properties'
                },
                Subtitle: {
                    type: 'Subtitle',
                    displayName: 'Subtitles Properties'
                },
                Video: {
                    type: 'Video',
                    displayName: 'Video Component Properties'
                }
            }
        },
        DynamicProps: {
            type: 'DynamicProps',
            displayName: 'Dynamic Properties',
            editRoute: 'dynamicProperty',
            setGridDataFunction: setDynamicPropsGridData,
            processGridFilterFunction: filterGridBySearchText,
            createPropertyFunction: navigateToDynamicPropsCreateView,
            editPropertyFunction: navigateToDynamicPropsEditView,
            deletePropertyFunction: confirmDynamicPropDeletion,
            columnDefinitions: [
                {
                    field: 'name',
                    displayName: 'Name',
                    sort: {
                        direction: 'asc',
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                },
                {
                    field: 'value',
                    displayName: 'Value',
                    cellTemplate: 'system/properties/searchView/cellTemplates/dynamic-prop-value-template.html'
                }
            ]
        }
    };
    //======//
    // Grid //
    //======//
    this.processGridFilter = function (rows) {
        return _.invoke(_this.currentTab, 'processGridFilterFunction', rows);
    };
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        columnDefs: [],
        data: [],
        multiSelect: false,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            _this.gridApi.grid.registerRowsProcessor(_this.processGridFilter, 200);
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
    this.onRowDblClick = function (row) {
        _.invoke(_this.currentTab, 'editPropertyFunction', row.entity);
    };
    //================//
    // Template Logic //
    //================//
    this.changeTab = function (tab) {
        if (_.isEqual(tab, _this.tabs.Roles)) {
            $location.search('tab', tab.type);
        }
        else {
            $location.search('tab', tab.type);
            $location.search('subTab', null);
        }
        getData();
    };
    this.changeSubTab = function (subTab) {
        _this.currentSubTab = subTab;
        $location.search('subTab', subTab.type);
        getData();
    };
    var onCreateButtonClicked = function () {
        _.invoke(_this.currentTab, 'createPropertyFunction');
    };
    var onEditButtonClicked = function () {
        _.invoke(_this.currentTab, 'editPropertyFunction', _.first(_this.gridApi.selection.getSelectedRows()));
    };
    var onDeleteButtonClicked = function () {
        _.invoke(_this.currentTab, 'deletePropertyFunction', _.first(_this.gridApi.selection.getSelectedRows()));
    };
    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: function () { return true; },
            onClick: onCreateButtonClicked
        },
        {
            label: 'Edit',
            enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()); },
            onClick: onEditButtonClicked
        },
        {
            label: 'Delete',
            enabled: function () { return _.get(_this.currentTab, 'deletePropertyFunction') && _.size(_this.gridApi.selection.getSelectedRows()); },
            onClick: onDeleteButtonClicked
        }
    ];
    //=================//
    // Lifecycle Hooks //
    //=================//
    var getData = function () {
        _this.currentTab = _.get(_this.tabs, $location.search().tab, _this.tabs.Categories);
        _this.gridOptions.columnDefs = _.get(_this.currentTab, 'columnDefinitions');
        _this.loadingIndicator.show = true;
        _.invoke(_this.currentTab, 'setGridDataFunction').finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        NavbarUtilService.viewSearchFunction = getData;
        SearchFilterService.populateCriteriaFromLocationSearch();
        getData();
    };
}
angular.module('prism-ui.properties').component('propertiesSearchView', {
    templateUrl: 'system/properties/searchView/properties-search-view-template.html',
    controller: PropertiesSearchViewController
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function RolesEditViewController(_, $location, $route, $routeParams, $timeout, uiGridConstants, BreadcrumbService, ModalService, PermissionsService, RolesService, SidebarService) {
    var _this = this;
    this.editData = {};
    var getData = function () {
        _this.loadingIndicator.show = true;
        RolesService.getRole($routeParams.id).then(function (role) {
            RolesService.originalEditData = _.cloneDeep(role);
            _this.editData = role;
            _this.gridOptions.data = _.toArray(role.aliases);
            if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                BreadcrumbService.addBreadcrumb({
                    name: 'Edit Role',
                    location: '/system/properties/search',
                    params: {
                        tab: 'Roles',
                        subTab: _this.editData.type
                    }
                });
            }
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveHandler = function () {
        _.set(_this.editData, 'aliases', _.toArray(_this.gridOptions.data));
        _.forEach(_.get(_this.editData, 'aliases'), function (alias) {
            _.unset(alias, 'edited');
        });
        _this.loadingIndicator.show = true;
        if ($routeParams.id === '-1') {
            saveNewRole();
        }
        else {
            updateRole();
        }
    };
    var updateRole = function () {
        RolesService.updateRole(_this.editData).then(function (role) {
            RolesService.originalEditData = _.cloneDeep(role);
            _this.editData = role;
            _this.editorForm.$setPristine();
            _this.gridApi.selection.clearSelectedRows();
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveNewRole = function () {
        if (_this.editData.type !== 'Audio') {
            _.unset(_this.editData, 'dvsFlag');
        }
        RolesService.createRole(_this.editData).then(function (role) {
            $route.updateParams({ id: role.id });
            _this.gridApi.selection.clearSelectedRows();
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var addAliasHandler = function (selectedPartners) {
        var originalGridDataSize = _.size(_this.gridOptions.data);
        var selectedAliases = new Array();
        selectedPartners.forEach(function (selectedPartner) {
            selectedAliases.push({
                alias: '',
                edited: true,
                partner: selectedPartner
            });
        });
        _this.gridOptions.data = _.unionBy(_.toArray(_this.gridOptions.data), selectedAliases, 'partner.id');
        if (_.size(_this.gridOptions.data) > originalGridDataSize) {
            _this.editorForm.$setDirty();
        }
        _this.loadingIndicator.show = false;
    };
    this.removeAlias = function () {
        var selectedAliases = _this.gridApi.selection.getSelectedRows();
        ModalService.showMessageModal({
            messageText: 'Are you sure you want to remove the selected alias(es)?',
            pullCancelLeft: true,
            title: 'Remove Alias(es)',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, function () {
            _this.gridOptions.data = _.differenceBy(_this.gridOptions.data, selectedAliases, 'partner.id');
            _this.editorForm.$setDirty();
        });
    };
    this.addAlias = function () {
        ModalService.showAliasesModal(addAliasHandler);
    };
    var columnDefinitions = [
        {
            field: 'partner.name',
            displayName: 'Partner (Read-Only)',
            cellEditableCondition: false,
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'alias',
            displayName: 'Alias (Double Click to Edit)',
            cellTemplate: 'components/visual/grid/inline-edit-template.html'
        }
    ];
    this.roleTypes = [
        'Audio',
        'Video',
        'CC',
        'Subtitle'
    ];
    this.gridOptions = {
        enableRowHeaderSelection: true,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: false,
        enableCellEditOnFocus: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: true,
        columnDefs: columnDefinitions,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            _this.gridApi.edit.on.afterCellEdit(null, function (rowEntity, colDef, newValue, oldValue) {
                if (newValue !== oldValue) {
                    _.set(rowEntity, 'edited', true);
                }
            });
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return !_.get(_this.editorForm, '$pristine')
                && !!_.get(_this.editData, 'name')
                && !!_.get(_this.editData, 'type')
                && _.every(_this.gridOptions.data, function (gridItem) {
                    return _.size(gridItem.alias);
                }); },
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: function () { return !_.get(_this.editorForm, '$pristine'); },
            onClick: function () {
                _this.editData = _.cloneDeep(RolesService.originalEditData);
                _this.gridOptions.data = _.get(_this.editData, 'aliases');
                _this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: function () { return !_.get(_this.editorForm, '$dirty'); },
            onClick: function () { return $location.url("/system/properties/search").search({
                tab: 'Roles',
                subTab: _.get(_this.editData, 'type')
            }); }
        }
    ];
    this.$onInit = function () {
        SidebarService.editService = RolesService;
        _this.isAdmin = PermissionsService.isAdmin();
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        if (_this.isAdmin) {
            if ($routeParams.id !== '-1') {
                getData();
            }
            else {
                _this.allowRoleTypeEdit = _.isNil(_.get($routeParams, 'type'));
                if (!_this.allowRoleTypeEdit) {
                    _.set(_this.editData, 'type', _.get($routeParams, 'type'));
                }
                BreadcrumbService.addBreadcrumb({
                    name: 'Create Role',
                    location: '/system/properties/search',
                    params: _this.allowRoleTypeEdit ? { tab: 'Roles' } : {
                        tab: 'Roles',
                        subTab: _.get($routeParams, 'type')
                    }
                });
            }
        }
        else {
            $location.url('/login');
        }
    };
    this.$onDestroy = function () {
        RolesService.originalEditData = null;
        RolesService.viewData = null;
    };
    this.$postLink = function () {
        $timeout(function () {
            RolesService.editorForm = _this.editorForm;
            BreadcrumbService.editService = RolesService;
        });
    };
}
angular.module('prism-ui.roles').component('rolesEditView', {
    templateUrl: 'system/roles/editor/roles-edit-view-template.html',
    controller: RolesEditViewController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function TerritoriesEditViewController(_, $location, $route, $routeParams, $timeout, uiGridConstants, BreadcrumbService, MediaAcceptProfileService, ModalService, NotificationService, PermissionsService, SidebarService, TerritoriesService, UtilsService) {
    var _this = this;
    this.editData = {};
    var getData = function () {
        _this.loadingIndicator.show = true;
        TerritoriesService.getTerritory($routeParams.id).then(function (territory) {
            TerritoriesService.originalEditData = _.cloneDeep(territory);
            _this.editData = territory;
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveHandler = function () {
        _this.loadingIndicator.show = true;
        _this.editData.iSO2Code = _.toUpper(_this.editData.iSO2Code);
        _this.editData.iSO3Code = _.toUpper(_this.editData.iSO3Code);
        if ($routeParams.id === '-1') {
            saveNewTerritory();
        }
        else {
            updateTerritory();
        }
    };
    var updateTerritory = function () {
        TerritoriesService.updateTerritory(_this.editData).then(function (territory) {
            TerritoriesService.originalEditData = _.cloneDeep(territory);
            _this.editData = territory;
            _this.editorForm.$setPristine();
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveNewTerritory = function () {
        TerritoriesService.createTerritory(_this.editData).then(function (territory) {
            $route.updateParams({ id: territory.id });
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return !_.get(_this.editorForm, '$pristine')
                && _.size(_.get(_this.editData, 'name'))
                && _.size(_.get(_this.editData, 'value'))
                && _.size(_.get(_this.editData, 'iSO2Code')) === 2
                && _.size(_.get(_this.editData, 'iSO3Code')) === 3; },
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: function () { return !_.get(_this.editorForm, '$pristine'); },
            onClick: function () {
                _this.editData = _.cloneDeep(TerritoriesService.originalEditData);
                _this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: function () { return !_.get(_this.editorForm, '$dirty'); },
            onClick: function () { return $location.url("/system/properties/search").search({ tab: 'Territories' }); }
        }
    ];
    this.$onInit = function () {
        SidebarService.editService = TerritoriesService;
        _this.isAdmin = PermissionsService.isAdmin();
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        if (_this.isAdmin) {
            if ($routeParams.id !== '-1') {
                if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                    BreadcrumbService.addBreadcrumb({
                        name: 'Create Territory',
                        location: '/system/properties/search',
                        params: { tab: 'Territories' }
                    });
                }
                getData();
            }
            else {
                _this.allowTerritoryTypeEdit = true;
                BreadcrumbService.addBreadcrumb({
                    name: 'Create Territory',
                    location: '/system/properties/search',
                    params: { tab: 'Territories' }
                });
            }
        }
        else {
            $location.url('/login');
        }
    };
    this.validateInput = function ($event, currentValue, regexString) {
        UtilsService.inputValidatorByRegExpString($event, currentValue, regexString);
    };
    this.$onDestroy = function () {
        TerritoriesService.originalEditData = null;
        TerritoriesService.viewData = null;
    };
    this.$postLink = function () {
        $timeout(function () {
            TerritoriesService.editorForm = _this.editorForm;
            BreadcrumbService.editService = TerritoriesService;
        });
    };
}
angular.module('prism-ui.territories').component('territoriesEditView', {
    templateUrl: 'system/territories/editor/territories-edit-view-template.html',
    controller: TerritoriesEditViewController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components').service('ConditionalTemplatesService', function (_, ConditionalTemplatesResourceFactory) {
    this.originalEditData = {};
    this.getAllConditionalTemplates = function (queryParams, queryHandler) {
        return ConditionalTemplatesResourceFactory.query(queryParams, queryHandler).$promise;
    };
    this.getConditionalTemplate = function (conditionalTemplateId) {
        return ConditionalTemplatesResourceFactory.get({ id: conditionalTemplateId }).$promise;
    };
    this.createConditionalTemplate = function (conditionalTemplate) {
        return ConditionalTemplatesResourceFactory.save(conditionalTemplate).$promise;
    };
    this.cloneConditionalTemplate = function (conditionalTemplate) {
        return ConditionalTemplatesResourceFactory.clone({ id: conditionalTemplate.id }).$promise;
    };
    this.updateConditionalTemplate = function (conditionalTemplate) {
        return ConditionalTemplatesResourceFactory.update(conditionalTemplate).$promise;
    };
    this.deleteConditionalTemplate = function (conditionalTemplateId) {
        return ConditionalTemplatesResourceFactory.delete({ id: conditionalTemplateId }).$promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components').service('FfmpegTemplatesService', function (_, FFmpegTemplatesResourceFactory) {
    this.originalEditData = {};
    this.getAllFfmpegTemplates = function (queryParams, queryHandler) {
        return FFmpegTemplatesResourceFactory.query(queryParams, queryHandler).$promise;
    };
    this.getFfmpegTemplate = function (ffmpegTemplateId) {
        return FFmpegTemplatesResourceFactory.get({ id: ffmpegTemplateId }).$promise;
    };
    this.createFfmpegTemplate = function (ffmpegTemplate) {
        return FFmpegTemplatesResourceFactory.save(ffmpegTemplate).$promise;
    };
    this.cloneFfmpegTemplate = function (ffmpegTemplate) {
        return FFmpegTemplatesResourceFactory.clone({ id: ffmpegTemplate.id }).$promise;
    };
    this.updateFfmpegTemplate = function (ffmpegTemplate) {
        return FFmpegTemplatesResourceFactory.update(ffmpegTemplate).$promise;
    };
    this.toggleFfmpegTemplateHidden = function (ffmpegTemplateId) {
        return FFmpegTemplatesResourceFactory.toggleArchive({ id: ffmpegTemplateId }).$promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular.module('prism-ui.templates').service('HybrikTemplateEditService', function (_) {
    var _this = this;
    this.editorForm = null;
    this.originalEditData = null;
    this.setOriginalEditData = function (template) {
        _this.originalEditData = _.cloneDeep(template);
        _.invoke(_this, 'editorForm.$setPristine');
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components').service('ImageTemplatesService', function (_, ImageTemplateResourceFactory, PaginationService) {
    var _this = this;
    this.originalEditData = {};
    var handleGridDataQuery = function (gridData, responseHeaders) {
        PaginationService.parseResponseHeaders(responseHeaders());
        PaginationService.pageData = gridData;
        _this.currentPageSize = gridData.length;
    };
    this.getAllImageTemplates = function (queryParams) {
        return ImageTemplateResourceFactory.query(queryParams, handleGridDataQuery).$promise;
    };
    this.getImageTemplate = function (imageTemplateId) {
        return ImageTemplateResourceFactory.get({ id: imageTemplateId }).$promise;
    };
    this.createImageTemplate = function (imageTemplate) {
        return ImageTemplateResourceFactory.save(imageTemplate).$promise;
    };
    this.cloneImageTemplate = function (imageTemplate) {
        return ImageTemplateResourceFactory.clone({ id: imageTemplate.id }).$promise;
    };
    this.updateImageTemplate = function (imageTemplate) {
        return ImageTemplateResourceFactory.update(imageTemplate).$promise;
    };
    this.deleteImageTemplate = function (imageTemplateId) {
        return ImageTemplateResourceFactory.delete({ id: imageTemplateId }).$promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components').service('IntermediateTemplatesService', function (_, IntermediateTemplatesResourceFactory) {
    this.originalEditData = {};
    this.getAllIntermediateTemplates = function (queryParams, queryHandler) {
        return IntermediateTemplatesResourceFactory.query(queryParams, queryHandler).$promise;
    };
    this.getIntermediateTemplate = function (intermediateTemplateId) {
        return IntermediateTemplatesResourceFactory.get({ id: intermediateTemplateId }).$promise;
    };
    this.createIntermediateTemplate = function (intermediateTemplate) {
        return IntermediateTemplatesResourceFactory.save(intermediateTemplate).$promise;
    };
    this.cloneIntermediateTemplate = function (intermediateTemplate) {
        return IntermediateTemplatesResourceFactory.clone({ id: intermediateTemplate.id }).$promise;
    };
    this.updateIntermediateTemplate = function (intermediateTemplate) {
        return IntermediateTemplatesResourceFactory.update(intermediateTemplate).$promise;
    };
    this.deleteIntermediateTemplate = function (intermediateTemplateId) {
        return IntermediateTemplatesResourceFactory.delete({ id: intermediateTemplateId }).$promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.system').service('MacCaptionTemplatesService', function (_, MacCaptionTemplatesResourceFactory, PaginationService) {
    var _this = this;
    this.originalEditData = {};
    var handleGridDataQuery = function (gridData, responseHeaders) {
        PaginationService.parseResponseHeaders(responseHeaders());
        PaginationService.pageData = gridData;
        _this.currentPageSize = gridData.length;
    };
    this.getAllMacCaptionTemplates = function (queryParams) {
        return MacCaptionTemplatesResourceFactory.query(queryParams, handleGridDataQuery).$promise;
    };
    this.getMacCaptionTemplate = function (macCaptionTemplateId) {
        return MacCaptionTemplatesResourceFactory.get({ id: macCaptionTemplateId }).$promise;
    };
    this.createMacCaptionTemplate = function (macCaptionTemplate) {
        return MacCaptionTemplatesResourceFactory.save(macCaptionTemplate).$promise;
    };
    this.cloneMacCaptionTemplate = function (macCaptionTemplate) {
        return MacCaptionTemplatesResourceFactory.clone({ id: macCaptionTemplate.id }).$promise;
    };
    this.updateMacCaptionTemplate = function (macCaptionTemplate) {
        return MacCaptionTemplatesResourceFactory.update(macCaptionTemplate).$promise;
    };
    this.toggleMacCaptionTemplateHidden = function (macCaptionTemplateId) {
        return MacCaptionTemplatesResourceFactory.toggleArchive({ id: macCaptionTemplateId }).$promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components').service('MediaConversionTemplateService', function (_, MediaConversionTemplateResource) {
    var _this = this;
    this.getAllMediaConversionTemplates = function () {
        return MediaConversionTemplateResource.getMediaConversionTemplates().$promise
            .then(function (response) {
            return _.filter(response.results, function (template) {
                return template.converterType !== 'Vantage' || _.startsWith(template.name, 'RE_');
            });
        });
    };
    this.getTypedMediaConversionTemplates = function (templateType) {
        return _this.getAllMediaConversionTemplates()
            .then(function (templates) {
            return _.filter(templates, function (template) {
                return template.converterType === templateType;
            });
        });
    };
    this.getMediaConversionTemplate = function (templateId) {
        return MediaConversionTemplateResource.getMediaConversionTemplate({ id: templateId }).$promise;
    };
    this.createMediaConversionTemplate = function (template) {
        return MediaConversionTemplateResource.createMediaConversionTemplate(template).$promise;
    };
    this.updateMediaConversionTemplate = function (template) {
        return MediaConversionTemplateResource.updateMediaConversionTemplate(template).$promise;
    };
    this.deleteMediaConversionTemplate = function (templateId) {
        return MediaConversionTemplateResource.deleteMediaConversionTemplate({ id: templateId }).$promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function TemplatesSearchViewController($location, $q, loginService, uiGridConstants, ConditionalTemplatesService, DeliveryTemplatesService, EmailTemplatesService, FfmpegTemplatesService, ImageTemplatesService, IntermediateTemplatesService, MacCaptionTemplatesService, MediaAcceptProfileService, MediaConversionTemplateService, ModalService, NavbarUtilService, NotificationService, PackageAcceptTemplatesService, PackageCreationTemplatesService, PaginationService, PermissionsService, SearchFilterService, TransformTemplatesService, UtilsService) {
    var _this = this;
    this.showHidden = false;
    this.toolbarCheckboxDefs = [];
    this.toolbarButtonDefs = [];
    var getData = function () {
        getGridConfig();
        var promises = [];
        var systemOpsPromise = PermissionsService.isSystemOperator().then(function (isSystemOps) {
            _this.canReadPackageTemplates = isSystemOps;
        });
        promises.push(systemOpsPromise);
        var offset = _this.pagingOptions.pageSize * (_this.pagingOptions.currentPage - 1);
        var queryOptions = {
            fetchOffset: _this.enablePagination ? offset : 0,
            fetchLimit: _this.enablePagination ? _this.pagingOptions.pageSize : 0,
            searchString: $location.search().searchText,
            keywords: $location.search().searchText,
            includeHidden: _this.showHidden
        };
        if (_this.serviceGetAllFunction && _this.gridOptions.columnDefs) {
            _this.loadingIndicator.show = true;
            var serviceGetAllFunctionPromise = _.invoke(_this, 'serviceGetAllFunction', queryOptions)
                .then(function (data) {
                _this.gridOptions.data = data;
            });
            promises.push(serviceGetAllFunctionPromise);
        }
        $q.all(promises).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var getGridConfig = function () {
        _this.currentTab = _.get(_this.tabs, $location.search().tab, _this.tabs.DeliveryTemplates);
        _this.currentSubTab = _.get(_this.currentTab, "subTabs." + $location.search().subTab);
        _this.enablePagination = _.get(_this, 'currentSubTab.enablePagination') ?
            _.get(_this, 'currentSubTab.enablePagination') :
            _.get(_this, 'currentTab.enablePagination');
        _this.gridOptions.columnDefs = _.get(_this, 'currentSubTab.columnDefinitions') ?
            _.get(_this, 'currentSubTab.columnDefinitions') :
            _.get(_this, 'currentTab.columnDefinitions');
        _this.serviceGetAllFunction = _.get(_this, 'currentSubTab.serviceGetAllDataFunction') ?
            _.get(_this, 'currentSubTab.serviceGetAllDataFunction') :
            _.get(_this, 'currentTab.serviceGetAllDataFunction');
        _this.toolbarButtonDefs = _.get(_this, 'currentSubTab.toolbarButtonDefs') ?
            _.get(_this, 'currentSubTab.toolbarButtonDefs') :
            _.get(_this, 'currentTab.toolbarButtonDefs');
        _this.toolbarCheckboxDefs = _.get(_this, 'currentSubTab.toolbarCheckboxDefs') ?
            _.get(_this, 'currentSubTab.toolbarCheckboxDefs') :
            _.get(_this, 'currentTab.toolbarCheckboxDefs');
        if (_this.toolbarCheckboxDefs) {
            _.set(_this, 'toolbarCheckboxDefs[0].isChecked', _this.showHidden);
        }
    };
    var navigateToEditViewFromDoubleClick = function (entity) {
        if (_this.currentSubTab === _this.tabs.Media.subTabs.MediaAcceptProfiles) {
            $location.url("/system/templates/" + _this.currentSubTab.editRoute + "/edit/" + _.get(entity, 'id') + "?editView=properties");
        }
        else if (!!_this.currentSubTab) {
            $location.url("/system/templates/" + _this.currentSubTab.editRoute + "/edit/" + _.get(entity, 'id'));
        }
        else {
            $location.url("/system/templates/" + _this.currentTab.editRoute + "/edit/" + _.get(entity, 'id'));
        }
    };
    var navigateToEditViewFromEditButton = function () {
        if (_this.currentSubTab === _this.tabs.Media.subTabs.MediaAcceptProfiles) {
            $location.url("/system/templates/" + _this.currentSubTab.editRoute + "/edit/" + _.get(_.first(_this.gridApi.selection.getSelectedRows()), 'id') + "?editView=properties");
        }
        else if (!!_this.currentSubTab) {
            $location.url("/system/templates/" + _this.currentSubTab.editRoute + "/edit/" + _.get(_.first(_this.gridApi.selection.getSelectedRows()), 'id'));
        }
        else {
            $location.url("/system/templates/" + _this.currentTab.editRoute + "/edit/" + _.get(_.first(_this.gridApi.selection.getSelectedRows()), 'id'));
        }
    };
    var navigateToCreateView = function () {
        if (!!_this.currentSubTab) {
            $location.url("/system/templates/" + _this.currentSubTab.editRoute + "/edit/-1");
        }
        else {
            $location.url("/system/templates/" + _this.currentTab.editRoute + "/edit/-1");
        }
    };
    var deleteItem = function () {
        var entityToDelete = _.first(_this.gridApi.selection.getSelectedRows());
        var typeOfEntityToDelete = _.get(_this, 'currentSubTab.displayName') ? _this.currentSubTab.displayName : _this.currentTab.displayName;
        _this.serviceDeleteFunction = _.get(_this, 'currentSubTab.serviceDeleteFunction') ? _this.currentSubTab.serviceDeleteFunction : _this.currentTab.serviceDeleteFunction;
        ModalService.showMessageModal({
            messageText: "Are you sure you want to delete the selected " + typeOfEntityToDelete + "?",
            pullCancelLeft: true,
            title: "Delete " + typeOfEntityToDelete,
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, function () {
            if (_this.serviceDeleteFunction) {
                _this.loadingIndicator.show = true;
                var serviceDeleteFunctionPromise = _.invoke(_this, 'serviceDeleteFunction', _.get(entityToDelete, 'id'));
                serviceDeleteFunctionPromise.then(function () {
                    NotificationService.createSuccessNotification(typeOfEntityToDelete + " deleted successfully!");
                    getData();
                }).catch(function () {
                    NotificationService.createFailureNotification("Could not delete the selected " + typeOfEntityToDelete);
                }).finally(function () {
                    _this.loadingIndicator.show = false;
                });
            }
        });
    };
    var cloneItem = function () {
        var entityToClone = _.first(_this.gridApi.selection.getSelectedRows());
        var typeOfEntityToClone = _.get(_this, 'currentSubTab.displayName') ? _this.currentSubTab.displayName : _this.currentTab.displayName;
        _this.serviceCloneFunction = _.get(_this, 'currentSubTab.serviceCloneFunction') ? _this.currentSubTab.serviceCloneFunction : _this.currentTab.serviceCloneFunction;
        ModalService.showMessageModal({
            messageText: "Are you sure you want to clone the selected " + typeOfEntityToClone + "?",
            pullCancelLeft: true,
            title: "Clone " + typeOfEntityToClone,
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, function () {
            if (_this.serviceCloneFunction) {
                _this.loadingIndicator.show = true;
                var serviceCloneFunctionPromise = _.invoke(_this, 'serviceCloneFunction', entityToClone);
                serviceCloneFunctionPromise.then(function () {
                    NotificationService.createSuccessNotification(typeOfEntityToClone + " cloned successfully!");
                    getData();
                }).catch(function () {
                    NotificationService.createFailureNotification("Could not clone the selected " + typeOfEntityToClone);
                }).finally(function () {
                    _this.loadingIndicator.show = false;
                });
            }
        });
    };
    var toggleItemHidden = function () {
        var entityToHide = _.first(_this.gridApi.selection.getSelectedRows());
        var isHidden = _.get(entityToHide, 'hidden');
        var actionType = isHidden ? 'Unhide' : 'Hide';
        var typeOfEntityToHide = _.get(_this, 'currentSubTab.displayName') ? _this.currentSubTab.displayName : _this.currentTab.displayName;
        _this.serviceToggleHiddenFunction = _.get(_this, 'currentSubTab.serviceToggleHiddenFunction') ? _this.currentSubTab.serviceToggleHiddenFunction : _this.currentTab.serviceToggleHiddenFunction;
        ModalService.showMessageModal({
            messageText: "Are you sure you want to " + _.lowerCase(actionType) + " the selected " + typeOfEntityToHide + "?",
            pullCancelLeft: true,
            title: actionType + " " + typeOfEntityToHide,
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, function () {
            if (_this.serviceToggleHiddenFunction) {
                _this.loadingIndicator.show = true;
                var serviceToggleHiddenFunctionPromise = _.invoke(_this, 'serviceToggleHiddenFunction', _.get(entityToHide, 'id'));
                serviceToggleHiddenFunctionPromise.then(function () {
                    NotificationService.createSuccessNotification(_.lowerCase(typeOfEntityToHide) + " " + actionType + "n successfully!");
                    getData();
                }).catch(function () {
                    NotificationService.createFailureNotification("Could not " + _.lowerCase(actionType) + " the selected " + typeOfEntityToHide);
                }).finally(function () {
                    _this.loadingIndicator.show = false;
                });
            }
        });
    };
    this.changeTab = function (tab) {
        initPaging();
        _this.currentTab = tab;
        _this.showHidden = false;
        $location.search('showHidden', null);
        if (_.has(tab, 'subTabs')) {
            $location.search('tab', tab.type);
        }
        else {
            $location.search('tab', tab.type);
            $location.search('subTab', null);
            getData();
        }
    };
    this.changeSubTab = function (subTab) {
        initPaging();
        _this.currentSubTab = subTab;
        _this.showHidden = false;
        $location.search('showHidden', null);
        $location.search('subTab', subTab.type);
        getData();
    };
    this.processGridFilter = function (rows) {
        var searchText = $location.search().searchText;
        if (_.get(_this, 'currentTab.useFrontEndSearch')) {
            if (_.size(searchText)) {
                rows.forEach(function (row) {
                    _.set(row, 'visible', _.includes(_.toLower(row.entity.name), _.toLower(searchText)));
                });
            }
        }
        if (_.get(_this, 'currentSubTab.useFrontEndSearch')) {
            if (_.size(searchText)) {
                rows.forEach(function (row) {
                    _.set(row, 'visible', _.includes(_.toLower(row.entity.name), _.toLower(searchText)));
                });
            }
        }
        return rows;
    };
    this.tabs = {
        DeliveryTemplates: {
            type: 'DeliveryTemplates',
            tabName: 'Delivery',
            displayName: 'Delivery Template',
            editRoute: 'deliveryTemplates',
            useFrontEndSearch: true,
            serviceGetAllDataFunction: DeliveryTemplatesService.getAllDeliveryTemplates,
            serviceCloneFunction: DeliveryTemplatesService.cloneDeliveryTemplate,
            serviceDeleteFunction: DeliveryTemplatesService.deleteDeliveryTemplate,
            columnDefinitions: [
                {
                    field: 'name',
                    displayName: 'Name',
                    minWidth: 250,
                    sort: {
                        direction: uiGridConstants.ASC,
                        priority: 0
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                },
                {
                    field: 'artwork',
                    displayName: 'Artwork',
                    cellTemplate: 'components/visual/grid/radio-button-template.html'
                },
                {
                    field: 'audio',
                    displayName: 'Audio',
                    cellTemplate: 'components/visual/grid/radio-button-template.html'
                },
                {
                    field: 'closedCaption',
                    displayName: 'CC',
                    cellTemplate: 'components/visual/grid/radio-button-template.html'
                },
                {
                    field: 'image',
                    displayName: 'Image',
                    cellTemplate: 'components/visual/grid/radio-button-template.html'
                },
                {
                    field: 'metadata',
                    displayName: 'Metadata',
                    cellTemplate: 'components/visual/grid/radio-button-template.html'
                },
                {
                    field: 'subtitle',
                    displayName: 'Subtitle',
                    cellTemplate: 'components/visual/grid/radio-button-template.html'
                },
                {
                    field: 'video',
                    displayName: 'Video',
                    cellTemplate: 'components/visual/grid/radio-button-template.html'
                }
            ],
            toolbarButtonDefs: [
                {
                    label: 'New',
                    enabled: function () { return true; },
                    onClick: navigateToCreateView
                },
                {
                    label: 'Edit',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) && !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'custom'); },
                    onClick: navigateToEditViewFromEditButton
                },
                {
                    label: 'Clone',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) && !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'custom'); },
                    onClick: cloneItem
                },
                {
                    label: 'Delete',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) && !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'custom'); },
                    onClick: deleteItem
                }
            ]
        },
        EmailTemplates: {
            type: 'EmailTemplates',
            tabName: 'Email',
            displayName: 'Email Template',
            editRoute: 'emailTemplates',
            useFrontEndSearch: true,
            enablePagination: true,
            serviceGetAllDataFunction: EmailTemplatesService.getAllEmailTemplates,
            serviceCloneFunction: EmailTemplatesService.cloneEmailTemplate,
            serviceToggleHiddenFunction: EmailTemplatesService.toggleEmailTemplateHidden,
            toolbarButtonDefs: [
                {
                    label: 'New',
                    enabled: function () { return true; },
                    onClick: navigateToCreateView
                },
                {
                    label: 'Edit',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) &&
                        !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
                    onClick: navigateToEditViewFromEditButton
                },
                {
                    label: 'Hide',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) &&
                        !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
                    onClick: toggleItemHidden
                },
                {
                    label: 'Unhide',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) &&
                        _.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
                    onClick: toggleItemHidden
                }
            ],
            toolbarCheckboxDefs: [
                {
                    label: 'Show Hidden',
                    onUpdate: function (newState) {
                        _this.showHidden = newState;
                        $location.search('showHidden', newState);
                        getData();
                    },
                    isChecked: this.showHidden
                }
            ],
            columnDefinitions: [
                {
                    field: 'name',
                    displayName: 'Name',
                    minWidth: 250,
                    sort: {
                        direction: uiGridConstants.ASC,
                        priority: 0
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }
            ]
        },
        HybrikTemplates: {
            type: 'HybrikTemplates',
            tabName: 'Hybrik',
            displayName: 'Hybrik Template',
            editRoute: 'hybrikTemplates',
            useFrontEndSearch: true,
            enablePagination: false,
            serviceGetAllDataFunction: function () { return MediaConversionTemplateService.getTypedMediaConversionTemplates('Hybrik'); },
            serviceDeleteFunction: MediaConversionTemplateService.deleteMediaConversionTemplate,
            toolbarButtonDefs: [
                {
                    label: 'New',
                    enabled: function () { return true; },
                    onClick: navigateToCreateView
                },
                {
                    label: 'Edit',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) &&
                        !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
                    onClick: navigateToEditViewFromEditButton
                },
                {
                    label: 'Delete',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()); },
                    onClick: deleteItem
                }
            ],
            columnDefinitions: [
                {
                    field: 'name',
                    displayName: 'Name',
                    minWidth: 250,
                    sort: {
                        direction: uiGridConstants.ASC,
                        priority: 0
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }
            ]
        },
        FfmpegTemplates: {
            type: 'FfmpegTemplates',
            tabName: 'FFmpeg',
            displayName: 'FFmpeg Template',
            editRoute: 'ffmpegTemplates',
            useFrontEndSearch: true,
            enablePagination: false,
            serviceGetAllDataFunction: FfmpegTemplatesService.getAllFfmpegTemplates,
            serviceCloneFunction: FfmpegTemplatesService.cloneFfmpegTemplate,
            serviceDeleteFunction: FfmpegTemplatesService.toggleFfmpegTemplateHidden,
            toolbarButtonDefs: [
                {
                    label: 'New',
                    enabled: function () { return true; },
                    onClick: navigateToCreateView
                },
                {
                    label: 'Edit',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) &&
                        !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
                    onClick: navigateToEditViewFromEditButton
                },
                {
                    label: 'Clone',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()); },
                    onClick: cloneItem
                },
                {
                    label: 'Delete',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()); },
                    onClick: deleteItem
                }
            ],
            columnDefinitions: [
                {
                    field: 'name',
                    displayName: 'Name',
                    minWidth: 250,
                    sort: {
                        direction: uiGridConstants.ASC,
                        priority: 0
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }
            ]
        },
        IntermediateTemplates: {
            type: 'IntermediateTemplates',
            tabName: 'Intermediate',
            displayName: 'Intermediate Template',
            editRoute: 'intermediateTemplates',
            useFrontEndSearch: true,
            enablePagination: false,
            serviceGetAllDataFunction: IntermediateTemplatesService.getAllIntermediateTemplates,
            serviceCloneFunction: IntermediateTemplatesService.cloneIntermediateTemplate,
            serviceDeleteFunction: IntermediateTemplatesService.deleteIntermediateTemplate,
            toolbarButtonDefs: [
                {
                    label: 'New',
                    enabled: function () { return true; },
                    onClick: navigateToCreateView
                },
                {
                    label: 'Edit',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()); },
                    onClick: navigateToEditViewFromEditButton
                },
                {
                    label: 'Clone',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()); },
                    onClick: cloneItem
                },
                {
                    label: 'Delete',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()); },
                    onClick: deleteItem
                }
            ],
            columnDefinitions: [
                {
                    field: 'name',
                    displayName: 'Name',
                    minWidth: 250,
                    sort: {
                        direction: uiGridConstants.ASC,
                        priority: 0
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                },
                {
                    field: 'programStartOffset',
                    displayName: 'Program Start Offset',
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                },
                {
                    field: 'programEndOffset',
                    displayName: 'Program End Offset',
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }
            ]
        },
        PackageCreationTemplates: {
            type: 'PackageCreationTemplates',
            tabName: 'Package Creation Templates',
            displayName: 'Package Creation Templates',
            editRoute: 'packageCreationTemplates',
            useFrontEndSearch: true,
            enablePagination: false,
            serviceGetAllDataFunction: PackageCreationTemplatesService.getAllPackageCreationTemplates,
            serviceDeleteFunction: PackageCreationTemplatesService.deletePackageCreationTemplate,
            toolbarButtonDefs: [
                {
                    label: 'New',
                    enabled: function () { return true; },
                    onClick: navigateToCreateView
                },
                {
                    label: 'Edit',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()); },
                    onClick: navigateToEditViewFromEditButton
                },
                {
                    label: 'Delete',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()); },
                    onClick: deleteItem
                }
            ],
            columnDefinitions: [
                {
                    field: 'name',
                    displayName: 'Name',
                    width: 350,
                    sort: {
                        direction: uiGridConstants.ASC,
                        priority: 0
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                },
                {
                    field: 'template',
                    displayName: 'Template',
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }
            ]
        },
        ConditionalTemplates: {
            type: 'ConditionalTemplates',
            tabName: 'Conditional',
            displayName: 'Conditional Template',
            editRoute: 'conditionalTemplates',
            useFrontEndSearch: true,
            enablePagination: false,
            serviceGetAllDataFunction: ConditionalTemplatesService.getAllConditionalTemplates,
            serviceCloneFunction: ConditionalTemplatesService.cloneConditionalTemplate,
            serviceDeleteFunction: ConditionalTemplatesService.deleteConditionalTemplate,
            toolbarButtonDefs: [
                {
                    label: 'New',
                    enabled: function () { return true; },
                    onClick: navigateToCreateView
                },
                {
                    label: 'Edit',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()); },
                    onClick: navigateToEditViewFromEditButton
                },
                {
                    label: 'Clone',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()); },
                    onClick: cloneItem
                },
                {
                    label: 'Delete',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()); },
                    onClick: deleteItem
                }
            ],
            columnDefinitions: [
                {
                    field: 'name',
                    displayName: 'Name',
                    minWidth: 250,
                    sort: {
                        direction: uiGridConstants.ASC,
                        priority: 0
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                },
                {
                    field: 'expression',
                    displayName: 'Expression',
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }
            ]
        },
        TransformTemplates: {
            type: 'TransformTemplates',
            tabName: 'Transform',
            displayName: 'Transform Template',
            editRoute: 'transformTemplates',
            useFrontEndSearch: false,
            enablePagination: true,
            serviceGetAllDataFunction: TransformTemplatesService.getAllTransformTemplates,
            serviceCloneFunction: TransformTemplatesService.cloneTransformTemplate,
            serviceToggleHiddenFunction: TransformTemplatesService.toggleTransformTemplateHidden,
            toolbarButtonDefs: [
                {
                    label: 'New',
                    enabled: function () { return true; },
                    onClick: navigateToCreateView
                },
                {
                    label: 'Edit',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) &&
                        !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
                    onClick: navigateToEditViewFromEditButton
                },
                {
                    label: 'Clone',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()); },
                    onClick: cloneItem
                },
                {
                    label: 'Hide',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) &&
                        !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
                    onClick: toggleItemHidden
                },
                {
                    label: 'Unhide',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) &&
                        _.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
                    onClick: toggleItemHidden
                }
            ],
            toolbarCheckboxDefs: [
                {
                    label: 'Show Hidden',
                    onUpdate: function (newState) {
                        _this.showHidden = newState;
                        $location.search('showHidden', newState);
                        getData();
                    },
                    isChecked: this.showHidden
                }
            ],
            columnDefinitions: [
                {
                    field: 'name',
                    displayName: 'Name',
                    sort: {
                        direction: 'asc',
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }
            ]
        },
        ImageTemplates: {
            type: 'ImageTemplates',
            tabName: 'Image',
            displayName: 'Image Template',
            editRoute: 'imageTemplates',
            useFrontEndSearch: false,
            enablePagination: true,
            serviceGetAllDataFunction: ImageTemplatesService.getAllImageTemplates,
            serviceCloneFunction: ImageTemplatesService.cloneImageTemplate,
            serviceDeleteFunction: ImageTemplatesService.deleteImageTemplate,
            toolbarButtonDefs: [
                {
                    label: 'New',
                    enabled: function () { return true; },
                    onClick: navigateToCreateView
                },
                {
                    label: 'Edit',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) &&
                        !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
                    onClick: navigateToEditViewFromEditButton
                },
                {
                    label: 'Clone',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()); },
                    onClick: cloneItem
                },
                {
                    label: 'Delete',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()); },
                    onClick: deleteItem
                }
            ],
            columnDefinitions: [
                {
                    field: 'name',
                    displayName: 'Name',
                    sort: {
                        direction: 'asc',
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }
            ]
        },
        MacCaptionTemplates: {
            type: 'MacCaptionTemplates',
            tabName: 'MacCaption',
            displayName: 'MacCaption Template',
            editRoute: 'macCaptionTemplates',
            useFrontEndSearch: false,
            enablePagination: true,
            serviceGetAllDataFunction: MacCaptionTemplatesService.getAllMacCaptionTemplates,
            serviceCloneFunction: MacCaptionTemplatesService.cloneMacCaptionTemplate,
            serviceToggleHiddenFunction: MacCaptionTemplatesService.toggleMacCaptionTemplateHidden,
            toolbarButtonDefs: [
                {
                    label: 'New',
                    enabled: function () { return true; },
                    onClick: navigateToCreateView
                },
                {
                    label: 'Edit',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) &&
                        !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
                    onClick: navigateToEditViewFromEditButton
                },
                {
                    label: 'Clone',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()); },
                    onClick: cloneItem
                },
                {
                    label: 'Hide',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) &&
                        !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
                    onClick: toggleItemHidden
                },
                {
                    label: 'Unhide',
                    enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) &&
                        _.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
                    onClick: toggleItemHidden
                }
            ],
            toolbarCheckboxDefs: [
                {
                    label: 'Show Hidden',
                    onUpdate: function (newState) {
                        _this.showHidden = newState;
                        $location.search('showHidden', newState);
                        getData();
                    },
                    isChecked: this.showHidden
                }
            ],
            columnDefinitions: [
                {
                    field: 'name',
                    displayName: 'Name',
                    sort: {
                        direction: 'asc',
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }
            ]
        },
        Media: {
            type: 'Media',
            tabName: 'Media',
            displayName: 'Media',
            subTabs: {
                MediaAcceptProfiles: {
                    type: 'MediaAcceptProfiles',
                    tabName: 'Media Accept Profile',
                    displayName: 'Media Accept Profile',
                    useFrontEndSearch: false,
                    editRoute: 'media/acceptProfiles',
                    enablePagination: true,
                    serviceGetAllDataFunction: MediaAcceptProfileService.getAcceptProfiles,
                    serviceCloneFunction: MediaAcceptProfileService.cloneAcceptProfile,
                    serviceToggleHiddenFunction: MediaAcceptProfileService.hideAcceptProfile,
                    toolbarButtonDefs: [
                        {
                            label: 'New',
                            enabled: function () { return true; },
                            onClick: function () {
                                ModalService.showNewMediaProfileModal(MediaAcceptProfileService.createNewProfile, _this.gridOptions.data);
                            }
                        },
                        {
                            label: 'Edit',
                            enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) &&
                                !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
                            onClick: navigateToEditViewFromEditButton
                        },
                        {
                            label: 'Clone',
                            enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) &&
                                !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
                            onClick: cloneItem
                        },
                        {
                            label: 'Hide',
                            enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) &&
                                !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
                            onClick: toggleItemHidden
                        },
                        {
                            label: 'Unhide',
                            enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) &&
                                _.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
                            onClick: toggleItemHidden
                        }
                    ],
                    toolbarCheckboxDefs: [
                        {
                            label: 'Show Hidden',
                            onUpdate: function (newState) {
                                _this.showHidden = newState;
                                $location.search('showHidden', newState);
                                getData();
                            },
                            isChecked: this.showHidden
                        }
                    ],
                    columnDefinitions: [
                        {
                            field: 'name',
                            minWidth: 232,
                            displayName: 'Name',
                            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                        },
                        {
                            field: 'type',
                            minWidth: 232,
                            displayName: 'Type',
                            cellTemplate: 'system/templates/mediaAcceptProfiles/searchView/renderers/accept-profile-tooltip-template.html'
                        }
                    ],
                },
                PackageAcceptTemplates: {
                    type: 'PackageAcceptTemplates',
                    tabName: 'Package Accept Template',
                    displayName: 'Package Accept Template',
                    useFrontEndSearch: true,
                    editRoute: 'media/packageAcceptTemplates',
                    enablePagination: false,
                    serviceGetAllDataFunction: PackageAcceptTemplatesService.getPackageAcceptTemplates,
                    serviceToggleHiddenFunction: PackageAcceptTemplatesService.deletePackageAcceptTemplate,
                    toolbarButtonDefs: [
                        {
                            label: 'New',
                            enabled: function () { return true; },
                            onClick: navigateToCreateView
                        },
                        {
                            label: 'Edit',
                            enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) &&
                                !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
                            onClick: navigateToEditViewFromEditButton
                        },
                        {
                            label: 'Hide',
                            enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) &&
                                !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
                            onClick: toggleItemHidden
                        },
                        {
                            label: 'Unhide',
                            enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) &&
                                _.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
                            onClick: toggleItemHidden
                        }
                    ],
                    toolbarCheckboxDefs: [
                        {
                            label: 'Show Hidden',
                            onUpdate: function (newState) {
                                _this.showHidden = newState;
                                $location.search('showHidden', newState);
                                getData();
                            },
                            isChecked: this.showHidden
                        }
                    ],
                    columnDefinitions: [
                        {
                            field: 'name',
                            displayName: 'Name',
                            sort: {
                                direction: uiGridConstants.ASC,
                                priority: 0
                            },
                            cellTemplate: 'system/templates/mediaAcceptProfiles/searchView/renderers/accept-profile-tooltip-template.html'
                        }
                    ],
                }
            }
        }
    };
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        columnDefs: [],
        data: [],
        multiSelect: false,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            _this.gridApi.grid.registerRowsProcessor(_this.processGridFilter, 200);
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
    this.onRowDblClick = function (row) {
        var shouldNavigate = true;
        if (_this.currentTab === _this.tabs.DeliveryTemplates && row.entity.custom) {
            shouldNavigate = false;
        }
        if (shouldNavigate) {
            navigateToEditViewFromDoubleClick(row.entity);
        }
    };
    this.onPaginationChanged = function () {
        getData();
    };
    this.paginationJumpToPageHandler = function () {
        _this.onPaginationChanged();
    };
    this.paginationPageSizeChanged = function () {
        _this.pagingOptions.currentPage = 1;
        _this.onPaginationChanged();
    };
    this.paginationPrevPageHandler = function () {
        --_this.pagingOptions.currentPage;
        _this.onPaginationChanged();
    };
    this.paginationNextPageHandler = function () {
        ++_this.pagingOptions.currentPage;
        _this.onPaginationChanged();
    };
    var initPaging = function () {
        _this.pagingOptions = PaginationService;
        _this.pagingOptions.currentPage = 1;
        _this.pagingOptions.pageSize = UtilsService.constants.DEFAULT_FETCH_LIMIT;
        _this.paginationDefs = {
            paginationPrevPageHandler: _this.paginationPrevPageHandler,
            paginationNextPageHandler: _this.paginationNextPageHandler,
            paginationPageSizeChanged: _this.paginationPageSizeChanged,
            paginationJumpToPageHandler: _this.paginationJumpToPageHandler,
            pagingOptions: PaginationService,
        };
    };
    this.$onInit = function () {
        $location.search('editView', null);
        initPaging();
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        NavbarUtilService.viewSearchFunction = getData;
        SearchFilterService.populateCriteriaFromLocationSearch();
        getData();
    };
}
angular.module('prism-ui.templates').component('templatesSearchView', {
    templateUrl: 'system/templates/searchView/templates-search-view-template.html',
    controller: TemplatesSearchViewController
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components').service('TransformTemplatesService', function (_, TransformTemplatesResourceFactory, PaginationService) {
    var _this = this;
    this.originalEditData = {};
    var handleGridDataQuery = function (gridData, responseHeaders) {
        PaginationService.parseResponseHeaders(responseHeaders());
        PaginationService.pageData = gridData;
        _this.currentPageSize = gridData.length;
    };
    this.getAllTransformTemplates = function (queryParams) {
        return TransformTemplatesResourceFactory.query(queryParams, handleGridDataQuery).$promise;
    };
    this.getTransformTemplate = function (transformTemplateId) {
        return TransformTemplatesResourceFactory.get({ id: transformTemplateId }).$promise;
    };
    this.createTransformTemplate = function (transformTemplate) {
        return TransformTemplatesResourceFactory.save(transformTemplate).$promise;
    };
    this.cloneTransformTemplate = function (transformTemplate) {
        return TransformTemplatesResourceFactory.clone({ id: transformTemplate.id }).$promise;
    };
    this.updateTransformTemplate = function (transformTemplate) {
        return TransformTemplatesResourceFactory.update(transformTemplate).$promise;
    };
    this.toggleTransformTemplateHidden = function (transformTemplateId) {
        return TransformTemplatesResourceFactory.toggleArchive({ id: transformTemplateId }).$promise;
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function UsersEditViewController(_, $location, $q, $route, $routeParams, $timeout, uiGridConstants, BreadcrumbService, GroupsService, ModalService, NotificationService, PermissionsService, SidebarService, UsersService) {
    var _this = this;
    var EMPTY_STRING = '';
    this.editData = {};
    this.emailUsernameInput = '';
    this.passwordInput = '';
    this.retypedPasswordInput = '';
    this.requirePassword = $routeParams.id === '-1';
    this.passwordValid = false;
    this.retypedPasswordValid = false;
    var getAvailableGroups = function () {
        var criteria = {
            fetchLimit: 0,
            includeHidden: false
        };
        return $q.all({
            groups: GroupsService.getAllGroups(criteria),
            isSystemOps: PermissionsService.isSystemOperator()
        }).then(function (data) {
            var groupsById = _.keyBy(data.groups, 'id');
            var writeGroupPromises = [];
            _.forEach(groupsById, function (group) {
                if (!data.isSystemOps) {
                    writeGroupPromises.push(GroupsService.isSystemOperatorGroup(group.id).then(function (isSystemOpsOnly) {
                        if (isSystemOpsOnly) {
                            delete groupsById[group.id];
                        }
                    }));
                }
            });
            return $q.all(writeGroupPromises).then(function () {
                _this.availableGroups = _.values(groupsById);
            });
        });
    };
    var getData = function () {
        return UsersService.getUser($routeParams.id).then(function (user) {
            UsersService.originalEditData = _.cloneDeep(user);
            _this.editData = user;
            _this.emailUsernameInput = _.get(user, 'username');
            _this.gridOptions.data = _.toArray(_.get(_this.editData, 'roles'));
        });
    };
    this.retypedPasswordRequirements = [{
            getDescription: function () {
                var thisRequirement = _this.retypedPasswordRequirements[0];
                if (thisRequirement.isValid()) {
                    return "Passwords match";
                }
                else if (thisRequirement.isWarning()) {
                    return "Passwords empty";
                }
                else {
                    return "Passwords don't match";
                }
            },
            isValid: function () { return _this.passwordInput === _this.retypedPasswordInput && !!_this.passwordInput.length; },
            isWarning: function () { return !_this.passwordInput.length && !_this.retypedPasswordInput.length; }
        }];
    var saveHandler = function () {
        _this.loadingIndicator.show = true;
        _.set(_this.editData, 'roles', _.unionBy(_.get(_this.editData, 'roles'), _this.gridOptions.data, 'id'));
        _.set(_this.editData, 'username', _this.emailUsernameInput);
        _.set(_this.editData, 'emailAddress', _this.emailUsernameInput);
        if (_this.requirePassword) {
            _.set(_this.editData, 'password', _.get(_this, 'passwordInput'));
        }
        if ($routeParams.id === '-1') {
            saveNewUser();
        }
        else {
            updateUser();
        }
    };
    var updateUser = function () {
        UsersService.updateUser(_this.editData, UsersService.originalEditData.roles).then(function (user) {
            UsersService.originalEditData = _.cloneDeep(user);
            _this.editData = user;
            _this.editorForm.$setPristine();
            _this.gridApi.selection.clearSelectedRows();
            NotificationService.createSuccessNotification('User updated successfully');
        }).catch(function (error) {
            _.unset(_this.editData, 'password');
            NotificationService.createFailureNotification(_.get(error, 'data.message'));
        }).finally(function () {
            resetPasswordFields();
            _this.loadingIndicator.show = false;
        });
    };
    var saveNewUser = function () {
        UsersService.createUser(_this.editData).then(function (user) {
            $route.updateParams({ id: user.id });
            _this.gridApi.selection.clearSelectedRows();
            NotificationService.createSuccessNotification('User created successfully');
        }).catch(function (error) {
            _.unset(_this.editData, 'password');
            NotificationService.createFailureNotification(_.get(error, 'data.message'));
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var addUserToGroupsSelectionHandler = function (selectedGroups) {
        var originalGroupSize = _.size(_this.gridOptions.data);
        _this.gridOptions.data = _.unionBy(_this.gridOptions.data, selectedGroups, 'id');
        if (_.size(_this.gridOptions.data) > originalGroupSize) {
            _this.editorForm.$setDirty();
        }
        _this.loadingIndicator.show = false;
    };
    this.removeUserFromSelectedGroups = function () {
        var selectedGroups = _this.gridApi.selection.getSelectedRows();
        ModalService.showMessageModal({
            messageText: 'Are you sure you want to remove this user from the selected group(s)?',
            pullCancelLeft: true,
            title: 'Remove User from Group(s)',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, function () {
            _.set(_this.editData, 'roles', _.differenceBy(_this.gridOptions.data, selectedGroups, 'id'));
            _this.gridOptions.data = _.toArray(_.get(_this.editData, 'roles'));
            _this.editorForm.$setDirty();
        });
    };
    this.addUserToNewGroup = function () {
        ModalService.showGroupsModal(_this.availableGroups, addUserToGroupsSelectionHandler);
    };
    var columnDefinitions = [
        {
            field: 'name',
            displayName: 'Name',
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: true,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: true,
        columnDefs: columnDefinitions,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () {
                var passwordsMatch = _.isEqual(_this.passwordInput, _this.retypedPasswordInput);
                return _this.editorForm.$dirty && _.size(_.get(_this, 'emailUsernameInput')) &&
                    (_this.requirePassword ? (_this.passwordValid && _this.retypedPasswordValid && passwordsMatch) : true);
            },
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: function () {
                return !_.get(_this.editorForm, '$pristine');
            },
            onClick: function () {
                _this.editData = _.cloneDeep(UsersService.originalEditData);
                _this.gridOptions.data = _.get(_this.editData, 'roles');
                _this.gridOptions.data = [];
                _this.editorForm.$setPristine();
                resetPasswordFields();
            }
        },
        {
            label: 'Close',
            enabled: function () { return !_.get(_this.editorForm, '$dirty'); },
            onClick: function () { return $location.url($route.current.rootRoute); }
        }
    ];
    this.$onInit = function () {
        SidebarService.editService = UsersService;
        _this.isAdmin = PermissionsService.isAdmin();
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        resetPasswordFields();
        if (_this.isAdmin) {
            var promises = [];
            _this.loadingIndicator.show = true;
            if ($routeParams.id !== '-1') {
                promises.push(getData());
            }
            promises.push(getAvailableGroups());
            promises.push(UsersService.getPasswordRequirements().then(function (passwordRequirements) {
                _this.passwordRequirements = passwordRequirements;
            }));
            $q.all(promises).then(function () {
                _this.loadingIndicator.show = false;
            });
        }
        else {
            $location.url('/login');
        }
    };
    var resetPasswordFields = function () {
        _.set(_this, 'passwordInput', EMPTY_STRING);
        _.set(_this, 'retypedPasswordInput', EMPTY_STRING);
    };
    this.$onDestroy = function () {
        UsersService.originalEditData = null;
        UsersService.viewData = null;
    };
    this.$postLink = function () {
        $timeout(function () {
            UsersService.editorForm = _this.editorForm;
            BreadcrumbService.editService = UsersService;
        });
    };
}
angular.module('prism-ui.users').component('usersEditView', {
    templateUrl: 'system/users/editor/users-edit-view-template.html',
    controller: UsersEditViewController,
    bindings: {}
}).directive('noDirty', function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ngModelCtrl) {
            // override the $setDirty method on ngModelController
            ngModelCtrl.$setDirty = angular.noop;
        }
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function UsersSearchViewController($location, uiGridConstants, ModalService, NavbarUtilService, PaginationService, SearchFilterService, UsersService) {
    var _this = this;
    var getData = function () {
        var criteria = {
            fetchOffset: _this.pagingOptions.pageSize * (_this.pagingOptions.currentPage - 1),
            fetchLimit: _this.pagingOptions.pageSize,
            includeRoles: true,
            filter: $location.search().searchText
        };
        _this.loadingIndicator.show = true;
        UsersService.getAllUsers(criteria).then(function () {
            _this.gridOptions.data = PaginationService.pageData;
            _this.loadingIndicator.show = false;
        });
    };
    var paginationPreviousPageHandler = function () {
        --_this.pagingOptions.currentPage;
        getData();
    };
    var paginationNextPageHandler = function () {
        ++_this.pagingOptions.currentPage;
        getData();
    };
    var paginationPageSizeChanged = function () {
        _this.pagingOptions.currentPage = 1;
        getData();
    };
    var navigateToEditView = function (user) {
        if (_.isNil(user)) {
            $location.url("system/users/edit/" + _.get(_.first(_this.gridApi.selection.getSelectedRows()), 'id'));
        }
        else {
            $location.url("system/users/edit/" + _.get(user, 'id'));
        }
    };
    var navigateToEditViewToCreateUser = function () {
        $location.url('system/users/edit/-1');
    };
    var deleteUser = function () {
        ModalService.showMessageModal({
            messageText: 'Are you sure that you want to delete this user?',
            pullCancelLeft: true,
            title: 'Delete User',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, function () {
            _this.loadingIndicator.show = true;
            var userId = _.get(_.first(_this.gridApi.selection.getSelectedRows()), 'id');
            UsersService.deleteUser(userId).then(function () {
                getData();
                _this.editorForm.$setDirty();
            }).finally(function () {
                _this.loadingIndicator.show = false;
            });
        });
    };
    var resetPasswordEnabled = function () {
        var selection = _this.gridApi.selection.getSelectedRows();
        return !_.isEmpty(selection) && !selection[0].externalUser;
    };
    var showResetPasswordModal = function () {
        var user = _.first(_this.gridApi.selection.getSelectedRows());
        UsersService.showResetPasswordModal(user);
    };
    var columnDefinitions = [
        {
            field: 'username',
            width: 300,
            displayName: 'Username',
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'firstName',
            width: 200,
            displayName: 'First Name',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'lastName',
            width: 200,
            displayName: 'Last Name',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'emailAddress',
            width: 300,
            displayName: 'Email',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'roles',
            displayName: 'Groups',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html',
            cellFilter: 'arrayToCsv'
        },
        {
            field: 'adminFlag',
            width: 75,
            displayName: 'Admin',
            cellTemplate: 'components/visual/grid/radio-button-template.html'
        },
        {
            field: 'externalUser',
            width: 85,
            displayName: 'External',
            cellTemplate: 'components/visual/grid/radio-button-template.html'
        }
    ];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: columnDefinitions,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
    this.onRowDblClick = function (row) {
        navigateToEditView(row.entity);
    };
    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: function () { return true; },
            onClick: navigateToEditViewToCreateUser
        },
        {
            label: 'Edit',
            enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()); },
            onClick: navigateToEditView
        },
        {
            label: 'Delete',
            enabled: function () { return _.first(_this.gridApi.selection.getSelectedRows()); },
            onClick: deleteUser
        },
        {
            label: 'Reset Password',
            icon: 'fa-key',
            enabled: resetPasswordEnabled,
            onClick: showResetPasswordModal
        }
    ];
    this.paginationDefs = {
        paginationPrevPageHandler: paginationPreviousPageHandler,
        paginationNextPageHandler: paginationNextPageHandler,
        paginationPageSizeChanged: paginationPageSizeChanged,
        paginationJumpToPageHandler: getData,
        pagingOptions: PaginationService,
    };
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        PaginationService.resetToDefaultValues();
        SearchFilterService.populateCriteriaFromLocationSearch();
        _this.pagingOptions = PaginationService;
        NavbarUtilService.viewSearchFunction = getData;
        getData();
    };
}
angular.module('prism-ui.users').component('usersSearchView', {
    templateUrl: 'system/users/searchView/users-search-view-template.html',
    controller: UsersSearchViewController
}).filter('arrayToCsv', function () {
    return function (array) {
        return _.chain(array).map('name').value().join(', ');
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by kyang on 8/7/2019
 */
function CustomMetadataFieldComponent(_) {
    //======================//
    // Field Type Constants //
    //======================//
    var _this = this;
    var defaultFormData = {
        textinput: {
            columnClass: 'pad-sm-right col-sm-',
            componentClass: 'prism-text-input',
            requiredClass: 'required-text-input',
            warningClass: 'spacer-top-xsm'
        },
        datetimefield: {
            columnClass: 'col-sm-7 date-time padding-bottom-xsm no-padding',
            requiredClass: 'required-text-input',
            warningClass: 'spacer-top-xsm'
        },
        datetimefieldenhanced: {
            requiredClass: 'required-text-input',
            warningClass: 'spacer-top-xsm'
        },
        datefieldenhanced: {
            requiredClass: 'required-text-input',
            warningClass: 'spacer-top-xsm'
        },
        datefield: {
            columnClass: 'col-sm-3 pad-sm-right',
            requiredClass: 'required-text-input',
            warningClass: 'spacer-top-xsm'
        },
        textarea: {
            columnClass: 'pad-sm-right col-sm-',
            componentClass: 'form-control prism-text-input',
            requiredClass: 'required-text-area-3',
            warningClass: 'error-warning-text-area-3'
        },
        timeinput: {
            columnClass: 'col-sm-2 top-margin pad-sm-right auto-width time-component',
            requiredClass: 'required-time-picker',
            warningClass: 'spacer-top-sm'
        },
        timecodeinput: {
            requiredClass: 'required-text-input',
            warningClass: 'spacer-top-xsm',
            attributes: {
                'root-class': 'col-sm-2'
            }
        },
        checkbox: {
            columnClass: 'col-sm-1 spacer-top-sm pad-sm-right auto-width',
            componentClass: 'timepicker col-sm-3',
            requiredClass: 'required-text-input',
            warningClass: 'spacer-top-sm'
        },
        dropdownlist: {
            columnClass: 'col-md-2 metadata-control-col',
            warningClass: 'metadata-icons-col',
            requiredClass: 'required-text-input',
        },
        checkboxlist: {
            columnClass: 'col-sm-2 checkbox-list-md',
            requiredClass: 'required-checkbox-list',
            warningClass: 'error-warning-checkbox-list'
        },
        list: {
            columnClass: 'col-sm-2 checkbox-list-md',
            requiredClass: 'required-list',
            warningClass: 'error-warning-list'
        },
        textlistinput: {
            columnClass: 'col-sm-4 text-list-input',
            requiredClass: 'required-list',
            warningClass: 'error-warning-list'
        }
    };
    //====================//
    // Style Modification //
    //====================//
    var calculateColumnSize = function (percentage) {
        return Math.round((11 - _this.labelColSize) * (parseInt(percentage) / 100));
    };
    this.getColumnClassSize = function () {
        if (_this.ignorePreferredWidth) {
            // Leave column for override, warning/error, required asterisk
            return 9;
        }
        if (_this.componentDef.preferredWidth) {
            return calculateColumnSize(_this.componentDef.preferredWidth);
        }
        return (5 - _this.labelColSize);
    };
    var applyOverriddenStyles = function (formData, overrides) {
        angular.forEach(overrides, function (override, overrideProperty) {
            if (overrideProperty === 'attributes') {
                angular.forEach(override, function (attrOverride, attrProperty) {
                    formData.attributes[attrProperty] = attrOverride;
                });
            }
            else {
                formData[overrideProperty] = override;
            }
        });
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$doCheck = function () {
        _this.showOverrideCheckbox = (_this.componentDef.liveUpdate
            && ((_this.revision < 2) || _this.componentDef.alwaysLive));
        _this.disabled = _this.showOverrideCheckbox && !_this.componentDef.instanceData.valueOverridden;
    };
    this.$onInit = function () {
        _this.fieldType = _this.componentDef.uiControlHint.toLowerCase();
        _this.inputId = _this.idPrefix + _this.componentDef.name;
        _this.labelColSize = _this.labelColSize || 2;
        _.forEach(defaultFormData, function (defaultData) {
            defaultData.labelClass = 'control-label col-sm-' + _this.labelColSize;
        });
        var formData = _.assign({}, defaultFormData[_this.fieldType]);
        applyOverriddenStyles(formData, _.get(_this, "componentStyleOverrides." + _this.fieldType));
        applyOverriddenStyles(formData, _.get(_this, "componentStyleOverrides." + _this.componentDef.name));
        _this.formData = formData;
        _this.$doCheck();
    };
}
angular.module('prism-ui.components').component('customMetadataField', {
    templateUrl: 'components/form/customMetadata/customMetadataField/custom-metadata-field-template.html',
    controller: CustomMetadataFieldComponent,
    bindings: {
        componentDef: '=',
        componentStyleOverrides: '<',
        disableComponents: '<',
        idPrefix: '<',
        ignorePreferredWidth: '<',
        labelColSize: '<',
        onUpdate: '&',
        revision: '<',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by kyang on 8/02/19.
 */
function ExternalIngestQueueEditorModalComponent(_) {
    //================//
    // Template Logic //
    //================//
    var _this = this;
    this.cancel = function () {
        _this.dismiss({ $value: 'cancel' });
    };
    this.canSave = function () {
        return _this.editorForm.$valid && _this.editorForm.$dirty;
    };
    this.onSave = function () {
        _.forEach(_this.editData, function (ingestJob) {
            ingestJob.priority = _this.priority;
        });
        _this.close({ $value: _this.editData });
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.editData = _.cloneDeep(_this.resolve.externalIngestJobs);
        _this.priority = _.parseInt(_this.editData[0].priority);
        if (_.some(_this.editData, function (ingestJob) {
            return ingestJob.priority !== _this.priority;
        })) {
            _this.priority = null;
        }
    };
}
angular
    .module('prism-ui.components')
    .component('externalIngestQueueEditorModal', {
    controller: ExternalIngestQueueEditorModalComponent,
    templateUrl: 'components/modal/externalIngest/externalIngestQueueEditorModal/external-ingest-queue-editor-modal-template.html',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by sjacobs on 8/23/18.
 */
function ExternalIngestTypeModalController(_, UtilsService) {
    var _this = this;
    this.$onInit = function () {
        _this.externalIngestTypes = _.values(UtilsService.externalIngestTypes);
    };
    this.onDone = function () {
        _this.close({ $value: _this.externalIngestType.value });
    };
}
angular
    .module('prism-ui.components')
    .component('externalIngestTypeModal', {
    controller: ExternalIngestTypeModalController,
    templateUrl: 'components/modal/externalIngest/externalIngestTypeModal/external-ingest-type-modal-template.html',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by kyang on 3/26/21.
 */
function ExternalIngestRunModalController(_, $q, ExternalMetadataService, ModalService) {
    //================//
    // Template Logic //
    //================//
    var _this = this;
    this.onCancelClicked = function () {
        _this.dismiss({ $value: 'cancel' });
    };
    this.onOkClicked = function (fileValue) {
        _this.loadingIndicator.show = true;
        var fileName = fileValue.files[0].file.name;
        ExternalMetadataService.runMetadataSource(_this.resolve.externalIngestSourceId, fileName, fileValue.results[0].fileText).then(function () {
            _this.close();
        }).catch(function (error) {
            if (error.status === 400 && error.data.message) {
                ModalService.showMessageModal({
                    messageText: error.data.message,
                    pullCancelLeft: true,
                    title: 'Aggregation Error Message',
                    windowClass: 'wide-message-modal'
                });
            }
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    //=================//
    // File Validation //
    //=================//
    this.getFileExtensions = function () {
        return ['xml'];
    };
    this.getLocalFilePreValidationErrors = function () {
        // Doesn't add any local file filters
    };
    this.validateLocalFile = function (fileItem) {
        var deferred = $q.defer();
        var reader = new FileReader();
        var self = _this;
        _this.validationProgress = 1;
        reader.onload = function (event) {
            deferred.resolve({
                source: fileItem.file.name,
                errors: [],
                warnings: [],
                fileText: event.target.result,
            });
        };
        reader.onprogress = function (event) {
            self.validationProgress = Math.round((event.loaded * 100) / event.total);
        };
        reader.onerror = function () {
            deferred.resolve({
                source: fileItem.file.name,
                errors: [{
                        description: 'Browser failed to read the selected file',
                        severity: 'ERROR'
                    }],
                warnings: [],
            });
        };
        reader.readAsText(fileItem._file);
        return deferred.promise;
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
    };
    this.initializeLocalUploaderConfig = function (fileUploaderConfig) {
        // Doesn't require any additional initialization
    };
}
angular
    .module('prism-ui.components')
    .component('externalIngestRunModal', {
    controller: ExternalIngestRunModalController,
    templateUrl: 'components/modal/externalIngest/externalIngestRunModal/external-ingest-run-modal-template.html',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
function ChangePasswordModalController(_, UsersService, NotificationService) {
    var _this = this;
    this.currentPasswordInput = '';
    this.passwordInput = '';
    this.retypedPasswordInput = '';
    this.passwordInputValid = false;
    this.retypedPasswordInputValid = false;
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        UsersService.getPasswordRequirements().then(function (passwordRequirements) {
            _this.passwordRequirements = passwordRequirements;
        });
    };
    this.retypedPasswordRequirements = [{
            getDescription: function () {
                var thisRequirement = _this.retypedPasswordRequirements[0];
                if (thisRequirement.isValid()) {
                    return "Passwords match";
                }
                else if (thisRequirement.isWarning()) {
                    return "Passwords empty";
                }
                else {
                    return "Passwords don't match";
                }
            },
            isValid: function () { return _this.passwordInput === _this.retypedPasswordInput && !!_this.passwordInput.length; },
            isWarning: function () { return !_this.passwordInput.length && !_this.retypedPasswordInput.length; }
        }];
    this.onDone = function () {
        UsersService.updatePassword(_this.currentPasswordInput, _this.passwordInput).then(function () {
            NotificationService.createSuccessNotification('Password updated successfully');
            _this.close({
                $value: true
            });
        }).catch(function (error) {
            NotificationService.createFailureNotification(_.get(error, 'data.validationErrors[0].message'));
        });
    };
    this.doneEnabled = function () {
        return !_.isEmpty(_this.currentPasswordInput) && _this.passwordInputValid && _this.retypedPasswordValid && _.isEqual(_this.passwordInput, _this.retypedPasswordInput);
    };
}
angular
    .module('prism-ui.components')
    .component('changePasswordModal', {
    controller: ChangePasswordModalController,
    templateUrl: 'components/modal/security/changePasswordModal/change-password-modal-template.html',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: dropdown-button-component.ts
 *
 * Created by kyang on 2019-11-05.
 */
function DropdownButtonController(_, DropdownService) {
    //===================//
    // Template Response //
    //===================//
    var _this = this;
    this.getButtonText = function () {
        if (_this.dropdownConfig.filter.length > 0) {
            return _this.dropdownConfig.filter;
        }
        if (_this.selectService.hasSelection(_this.dropdownConfig)) {
            return _this.selectService.getSelectionText(_this.dropdownConfig);
        }
        return DropdownService.getPrompt(_this.dropdownConfig);
    };
    this.toggleDropDown = function (event) {
        event.preventDefault();
        event.stopPropagation();
        _this.onDropdownToggled();
    };
    this.canClearSelection = function () {
        return !!_this.dropdownConfig.clearable && _this.selectService.hasSelection(_this.dropdownConfig);
    };
    this.onClearClicked = function () {
        _this.selectService.clearSelection(_this.dropdownConfig);
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    // this.$onChanges = () => {
    // };
    // this.$onInit = () => {
    // };
}
angular.module('prism-ui.components').component('dropdownButton', {
    bindings: {
        selectService: '<',
        dropdownConfig: '<',
        onDropdownToggled: '&',
        btnMinWidth: '<?',
        isDisabled: '<ngDisabled',
    },
    controller: DropdownButtonController,
    templateUrl: 'components/visual/dropdown/dropdownButton/dropdown-button-template.html'
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: dropdown-list-component.ts
 *
 * Created by kyang on 2019-11-05.
 */
function DropdownListController(_, $scope, DropdownService, Rx) {
    //===================//
    // Template Response //
    //===================//
    var _this = this;
    this.getItemLabel = function (item) {
        return DropdownService.getLabel(_this.dropdownConfig, item);
    };
    this.isItemDisabled = function (item) {
        return DropdownService.isItemDisabled(_this.dropdownConfig, item);
    };
    this.isItemSelected = function (item) {
        return _this.selectService.isItemSelected(_this.dropdownConfig, item);
    };
    this.areAllItemsSelected = function () {
        return _this.selectService.areAllEnabledItemsSelected(_this.dropdownConfig);
    };
    this.onItemClicked = function (item) {
        if (_this.dropdownConfig.isMultiSelect) {
            _this.selectService.toggleItemSelection(_this.dropdownConfig, item);
        }
        else {
            _this.selectService.setSelection(_this.dropdownConfig, item);
        }
    };
    this.onSelectAllClicked = function () {
        if (_this.areAllItemsSelected()) {
            _this.selectService.setSelection(_this.dropdownConfig, []);
        }
        else {
            _this.selectService.setSelection(_this.dropdownConfig, _this.dropdownConfig.collection);
        }
    };
    this.shouldShowItem = function (item) {
        var label = DropdownService.getLabel(_this.dropdownConfig, item).toUpperCase();
        return label.includes(_this.currentFilter);
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onChanges = function () {
        if (_this.filterObservable) {
            _this.filterObservable.onNext(_this.dropdownConfig.filter);
        }
    };
    this.$onInit = function () {
        _this.currentFilter = _this.dropdownConfig.filter.toUpperCase();
        _this.filterObservable = new Rx.BehaviorSubject(_this.currentFilter.toUpperCase());
        _this.filterObservable
            .distinctUntilChanged()
            .debounce(100)
            .subscribeOnNext(function (newFilter) {
            $scope.$apply(function () { return _this.currentFilter = newFilter.toUpperCase(); });
        });
    };
}
angular.module('prism-ui.components').component('dropdownList', {
    bindings: {
        selectService: '<',
        dropdownConfig: '<',
        isDisabled: '<ngDisabled',
        enableSelectAll: '<?',
        maxHeightStyle: '<?',
    },
    transclude: {
        'dropdown-option': '?dropdown-option'
    },
    controller: DropdownListController,
    templateUrl: 'components/visual/dropdown/dropdownList/dropdown-list-template.html'
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: dropdown-multi-select-service.ts
 *
 * Created by kyang on 2019-12-05.
 */
function DropdownMultiSelectServiceConstructor(_, DropdownService) {
    //=========//
    // Queries //
    //=========//
    var _this = this;
    this.hasSelection = function (dropdown) {
        return _.size(dropdown.selection) > 0;
    };
    this.isItemSelected = function (dropdown, item) {
        return !!_this.hasSelection(dropdown) && DropdownService.getItemIndex(dropdown, dropdown.selection, item) > -1;
    };
    this.areAllEnabledItemsSelected = function (dropdown) {
        return _.chain(dropdown.collection)
            .differenceWith(dropdown.selection, function (itemA, itemB) {
            return DropdownService.areItemsEqual(dropdown, itemA, itemB);
        })
            .every(function (unselectedItem) {
            return DropdownService.isItemDisabled(dropdown, unselectedItem);
        })
            .value();
    };
    this.getSelectionText = function (dropdown) {
        if (_.size(dropdown.selection) > 1) {
            return 'multiple selections';
        }
        else if (_.size(dropdown.selection) === 1) {
            return DropdownService.getLabel(dropdown, dropdown.selection[0]);
        }
        return undefined;
    };
    //==============//
    // Modification //
    //==============//
    this.toggleItemSelection = function (dropdown, newSelectedItem) {
        if (DropdownService.isItemDisabled(dropdown, newSelectedItem)) {
            return;
        }
        // Replace selection object to update listeners also
        var anyItemRemoved = false;
        var newSelection = _.filter(dropdown.selection, function (item) {
            var itemsEqual = DropdownService.areItemsEqual(dropdown, item, newSelectedItem);
            anyItemRemoved = anyItemRemoved || itemsEqual;
            return !itemsEqual;
        });
        if (!anyItemRemoved) {
            newSelection.push(newSelectedItem);
        }
        dropdown.selection = newSelection;
    };
    this.setSelection = function (dropdown, newSelectedItems) {
        dropdown.selection = _.concat(_.filter(dropdown.selection, function (item) { return DropdownService.isItemDisabled(dropdown, item); }), _.filter(newSelectedItems, function (item) { return !DropdownService.isItemDisabled(dropdown, item); }));
    };
    this.clearSelection = function (dropdown) {
        dropdown.selection = _.filter(dropdown.selection, function (item) {
            return DropdownService.isItemDisabled(dropdown, item);
        });
    };
}
angular
    .module('prism-ui.components')
    .service('DropdownMultiSelectService', DropdownMultiSelectServiceConstructor);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: dropdown-service.ts
 *
 * Created by kyang on 2019-11-06.
 */
function DropdownServiceConstructor(_) {
    //=========//
    // Utility //
    //=========//
    var _this = this;
    // In many cases, the items in a dropdown's collection
    // aren't the same as the selected object.
    // For example:
    //     - Collection is a list of items, returned from the server
    //     - Selected item is a property of a different object, returned from the server
    //
    // This function detects those cases, and resolves it.
    this.areItemsEqual = function (dropdown, itemA, itemB) {
        // TODO: Handle duplicates via modelProp?
        return itemA === itemB;
    };
    // This function also works on redundant copies of items.
    // See areItemsEqual() for more information.
    this.getItemIndex = function (dropdown, array, item) {
        // TODO: Check can handle duplicates
        return _.findIndex(array, function (searchItem) {
            return _this.areItemsEqual(dropdown, searchItem, item);
        });
    };
    //==================//
    // Property Parsing //
    //==================//
    this.getPrompt = function (dropdown) {
        return String(dropdown.prompt);
    };
    this.getLabel = function (dropdown, item) {
        var labelValue;
        if (_.isFunction(dropdown.labelFunction)) {
            labelValue = dropdown.labelFunction(item, dropdown.labelPath);
        }
        else if (dropdown.labelPath) {
            labelValue = _.get(item, dropdown.labelPath);
        }
        else {
            labelValue = item;
        }
        return String(labelValue);
    };
    this.isItemDisabled = function (dropdown, item) {
        if (_.size(dropdown.itemDisablePath) < 1) {
            return false;
        }
        return _.get(item, dropdown.itemDisablePath);
    };
    //================//
    // List Searching //
    //================//
    // Returns true if the filter was modified, false if it wasn't
    this.tryUpdateFilter = function (dropdown, keyEvent) {
        var filterModified = false;
        if (keyEvent.key.length === 1) {
            dropdown.filter += keyEvent.key;
            filterModified = true;
        }
        else if (keyEvent.key === 'Backspace' || keyEvent.key === 'Delete') {
            dropdown.filter = dropdown.filter.substring(0, dropdown.filter.length - 1);
            filterModified = true;
        }
        else if (keyEvent.key === 'Clear') {
            dropdown.filter = '';
            filterModified = true;
        }
        return filterModified;
    };
}
angular
    .module('prism-ui.components')
    .service('DropdownService', DropdownServiceConstructor);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: dropdown-single-select-service.ts
 *
 * Created by kyang on 2019-12-04.
 */
function DropdownSingleSelectServiceConstructor(_, DropdownService) {
    //=========//
    // Queries //
    //=========//
    var _this = this;
    // TODO: toggleSelection
    this.hasSelection = function (dropdown) {
        return !!dropdown.selection;
    };
    this.isItemSelected = function (dropdown, item) {
        return DropdownService.areItemsEqual(dropdown, dropdown.selection, item);
    };
    this.getSelectionText = function (dropdown) {
        if (_this.hasSelection(dropdown)) {
            return DropdownService.getLabel(dropdown, dropdown.selection);
        }
        return undefined;
    };
    //==============//
    // Modification //
    //==============//
    // If item is selected, this function deselects it.
    // If item wasn't selected, previous selection is removed, and then this function selects the new.
    this.toggleItemSelection = function (dropdown, newSelectedItem) {
        if (DropdownService.areItemsEqual(dropdown, dropdown.selection, newSelectedItem)) {
            _this.clearSelection(dropdown);
        }
        else {
            _this.setSelection(dropdown, newSelectedItem);
        }
    };
    this.setSelection = function (dropdown, newSelectedItem) {
        if (DropdownService.isItemDisabled(dropdown, dropdown.selection) || DropdownService.isItemDisabled(dropdown, newSelectedItem)) {
            return;
        }
        dropdown.selection = newSelectedItem;
    };
    this.clearSelection = function (dropdown) {
        _this.setSelection(dropdown, null);
    };
}
angular
    .module('prism-ui.components')
    .service('DropdownSingleSelectService', DropdownSingleSelectServiceConstructor);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: partner-email-recipient-modal-component.ts
 *
 * Created by randysorensen on 10/12/17.
 */
'use strict';
function PartnerEmailRecipientModalController(_, NetworkViewService) {
    //=================//
    // Lifecycle Hooks //
    //=================//
    var _this = this;
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.loadingIndicator.show = true;
        NetworkViewService.getSearchViewData({ fetchLimit: 0 })
            .then(function (networksList) {
            _this.availableNetworks = networksList;
            _this.loadingIndicator.show = false;
        });
        _this.recipientObject = _.cloneDeep(_this.resolve.recipientObject);
    };
    //================//
    // Template Logic //
    //================//
    this.onOk = function () {
        _this.close({
            $value: _this.recipientObject,
        });
    };
}
angular
    .module('prism-ui.partner')
    .component('partnerEmailRecipientModal', {
    controller: PartnerEmailRecipientModalController,
    templateUrl: 'components/visual/emailRecipientsList/modals/partner-email-recipient-modal-template.html',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&',
    },
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: package-link-icon-component.ts
 *
 * Created by kyang on 6/7/19.
 */
function PackageLinkIconController($element, $location, PackageResourceFactory, PaginationService, SidebarService) {
    var _this = this;
    var gettingPackageInfo;
    var navigationStarted;
    this.onClick = function ($event) {
        $event.preventDefault();
        $event.stopImmediatePropagation();
        if (gettingPackageInfo || navigationStarted) {
            return;
        }
        gettingPackageInfo = true;
        _this.onNavigationStarted();
        if (_this.packageIdList === undefined || _this.packageIdList.length === 1) {
            PackageResourceFactory.get({ id: _this.packageId, view: 'NORMAL' }).$promise.then(function (pkgData) {
                if (!gettingPackageInfo) {
                    return;
                }
                var url = '';
                if (pkgData.parentPackageId) {
                    url = "/packages/package/edit/" + pkgData.parentPackageId + "/liveClip?livePackageId=" + pkgData.id;
                }
                else {
                    url = "/packages/package/edit/" + pkgData.id + "/metadata";
                }
                navigationStarted = true;
                SidebarService.goToUrl(url, 'packages', SidebarService.getSelectedItem());
                _this.onNavigationEnded();
            });
        }
        else {
            navigationStarted = true;
            var packages = _this.packageIdList.join(',');
            var url = "/packages?searchText=" + packages;
            //
            // If we don't reset the pagination, the package
            // manager will go to the same page as the WF search
            // view.
            //
            // We'd rather save the pagination state where it may
            // be recalled per sidebar item... for now this is a
            // slight bug.
            //
            PaginationService.resetToDefaultValues();
            SidebarService.goToUrl(url, 'packages', SidebarService.getSelectedItem());
            _this.onNavigationEnded();
        }
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        gettingPackageInfo = false;
        navigationStarted = false;
        $element.on('click', _this.onClick);
    };
    this.$onDestroy = function () {
        if (gettingPackageInfo) {
            gettingPackageInfo = false;
        }
        if (navigationStarted) {
            SidebarService.ignoreNavUpdates = false;
        }
    };
}
angular.module('prism-ui.components').component('packageLinkIcon', {
    controller: PackageLinkIconController,
    templateUrl: 'components/visual/icon/packageLinkIcon/package-link-icon-template.html',
    bindings: {
        packageIdList: '<',
        packageId: '<',
        onNavigationStarted: '&',
        onNavigationEnded: '&'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: metric-panel-row-component.ts
 *
 * Created by randysorensen on 2019-02-20.
 */
function MetricPanelRowController(MetricsDashboardService) {
    this.showCurrentMonthData = function () {
        return MetricsDashboardService.currentCriteriaIncludesPresent();
    };
}
angular.module('prism-ui.metricsDashboard').component('metricPanelRow', {
    controller: MetricPanelRowController,
    templateUrl: 'dashboard/metrics/dashboard-panels/metric-panel-row/metric-panel-row-template.html',
    bindings: {
        currentMonthDataProperty: '<',
        monthlyDatasetProperty: '<',
        sumLabel: '<',
        sumDataProperty: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: monthly-bar-graph-component.ts
 *
 * Created by randysorensen on 2019-02-22.
 */
function MonthlyBarGraphController(_, DynamicPropertiesService, MetricsDashboardService, UtilsService) {
    var _this = this;
    var createTooltip = function (tooltipData) {
        var tooltip = "<div class=\"text-align-left\">";
        tooltip += tooltipData.title + "<br/><hr/>";
        _.forEach(tooltipData.lines, function (line) {
            tooltip += line + "<br/>";
        });
        return tooltip;
    };
    var createBars = function (timeStamp, metricsData, tooltipData) {
        var prismBarGraphBlue = '#43A6DC';
        var prismBarGraphGreen = '#26CA00';
        var today = new Date();
        var bars = {};
        var keys = _.keys(metricsData).sort();
        _.forEach(keys, function (key) {
            var keyAsInt = parseInt(key);
            var bar = {};
            bar.year = _.floor(keyAsInt / 100);
            bar.month = _.floor(keyAsInt % 100);
            bar.label = UtilsService.constants.MONTHS[bar.month - 1].substring(0, 3);
            bar.value = parseFloat(metricsData[key]);
            bar.tooltip = createTooltip(tooltipData[key]);
            bar.tooltipClass = tooltipData[key].tooltipClass;
            if (today.getFullYear() === bar.year && today.getMonth() + 1 === bar.month) {
                bar.color = prismBarGraphGreen;
            }
            else {
                bar.color = prismBarGraphBlue;
            }
            bars[key] = bar;
        });
        return bars;
    };
    //
    // Memoize the bar array based on the data timestamp.
    //
    var memoizedCreateBars = _.memoize(createBars, function (timeStamp, metricsData, tooltipData) { return _.invoke(timeStamp, 'getTime'); });
    var barGraphDataUpdated = function (metricsData) {
        var barGraphData = _.get(metricsData, _this.monthlyDatasetProperty, {});
        var tooltipData = _.get(metricsData, 'tooltipData', {});
        _this.monthlyBarGraphData = {
            bars: memoizedCreateBars(metricsData.timeStamp, barGraphData, tooltipData),
            animationDuration: DynamicPropertiesService.getPropValueAsInt('metrics.animationTime', 0.5),
            timeStamp: metricsData.timeStamp
        };
    };
    this.$onInit = function () {
        _this.monthlyBarGraphData = {};
        DynamicPropertiesService.queryForProperties()
            .then(function () {
            MetricsDashboardService.registerDataUpdateCallback(barGraphDataUpdated);
        });
    };
}
angular.module('prism-ui.metricsDashboard').component('monthlyBarGraph', {
    controller: MonthlyBarGraphController,
    templateUrl: 'dashboard/metrics/dashboard-panels/monthly-bar-graph/monthly-bar-graph-template.html',
    bindings: {
        monthlyDatasetProperty: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: partner-distribution-dashboard-panel-component.ts
 *
 * Created by randysorensen on 2019-02-19.
 */
function PartnerDistributionDashboardPanelController(_, MetricsDashboardService, UtilsService) {
    var _this = this;
    this.getDateRange = function () {
        var dateRange = '';
        var fromDate = _.get(_this, 'fromDate');
        var toDate = _.get(_this, 'toDate');
        if (fromDate && toDate) {
            var fromMonth = _.invoke(fromDate, 'getMonth');
            fromMonth = UtilsService.constants.MONTHS[fromMonth];
            var fromYear = _.invoke(fromDate, 'getFullYear');
            var toMonth = _.invoke(toDate, 'getMonth');
            toMonth = UtilsService.constants.MONTHS[toMonth];
            var toYear = _.invoke(toDate, 'getFullYear');
            dateRange = fromMonth + " " + fromYear + " - " + toMonth + " " + toYear;
        }
        return dateRange;
    };
    var metricsDataUpdated = function (metricsData) {
        _this.fromDate = MetricsDashboardService.getCurrentCriteria().fromDate;
        _this.toDate = MetricsDashboardService.getCurrentCriteria().toDate;
        _this.partnerRatioMap = metricsData.partnerRatioMap;
    };
    this.$onInit = function () {
        _this.fromDate = MetricsDashboardService.getCurrentCriteria().fromDate;
        _this.toDate = MetricsDashboardService.getCurrentCriteria().toDate;
        _this.partnerRatioMap = {};
        MetricsDashboardService.registerDataUpdateCallback(metricsDataUpdated);
    };
}
angular.module('prism-ui.metricsDashboard').component('partnerDistributionDashboardPanel', {
    controller: PartnerDistributionDashboardPanelController,
    templateUrl: 'dashboard/metrics/dashboard-panels/partner-distribution/partner-distribution-dashboard-panel-template.html',
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: queue-detail-grid-component
 *
 * Created by rwilliams on 4/3/17.
 */
function QueueDetailGridController(_, $location, $routeParams, $timeout, ModalService) {
    //======//
    // Grid //
    //======//
    var _this = this;
    var defaultGridColumns = [
        {
            field: 'proxyId',
            enableColumnMenu: false,
            name: 'playIconColumn',
            displayName: '',
            width: 30,
            minWidth: 30,
            enableSorting: false,
            enableColumnResizing: false,
            cellTemplate: 'components/visual/grid/play-proxy-icon-template.html'
        },
        {
            field: 'priority',
            enableSorting: false,
            width: 70,
            cellTemplate: 'dashboard/queues/queueDetail/components/cellTemplates/queue-priority-cell-template.html'
        },
        {
            field: 'percentComplete',
            name: 'Progress',
            width: '18%',
            enableSorting: false,
            cellTemplate: 'components/visual/grid/progress-bar-template.html'
        },
        {
            field: 'retries',
            name: 'Retries',
            enableSorting: false,
            width: 65
        },
        {
            field: 'bandwidth',
            name: 'Bandwidth',
            enableSorting: false,
            width: 130,
            cellTemplate: 'dashboard/queues/queueDetail/components/cellTemplates/queue-bandwidth-cell-template.html'
        },
        {
            field: 'eTA',
            name: 'ETA',
            displayName: 'ETA',
            enableSorting: false,
            minWidth: 195,
            cellFilter: 'date:\'MM/dd/yyyy hh:mm:ss a\''
        },
        {
            field: 'categoryTypeName',
            name: 'Category Type',
            enableSorting: false,
            width: 130
        },
        {
            field: 'networkName',
            name: 'Network',
            enableSorting: false,
            width: 140
        },
        {
            field: 'contentName',
            name: 'Series/Movie/Ad',
            enableSorting: false,
            width: 140
        },
        {
            field: 'title',
            name: 'Title',
            enableSorting: false,
            width: 200
        },
        {
            field: 'originalReleaseDate',
            name: 'Original Release Date',
            enableSorting: false,
            width: 160,
            cellFilter: 'date:\'MM/dd/yyyy\''
        },
        {
            field: 'airTime',
            name: 'Air Time',
            enableSorting: false,
            width: 100,
            cellFilter: 'date:\'hh:mm\''
        },
        {
            field: 'categoryName',
            name: 'Category',
            enableSorting: false,
            width: 100
        },
        {
            field: 'partnerName',
            name: 'Partner',
            enableSorting: false,
            width: 100
        },
        {
            field: 'creationTime',
            name: 'Creation Time',
            enableSorting: false,
            minWidth: 195,
            cellFilter: 'date:\'MM/dd/yyyy hh:mm:ss a\''
        },
        {
            field: 'startTime',
            name: 'Start Time',
            enableSorting: false,
            width: 195,
            cellFilter: 'date:\'MM/dd/yyyy hh:mm:ss a\''
        },
        {
            field: 'endTime',
            name: 'Complete Time',
            enableSorting: false,
            cellFilter: 'date:\'MM/dd/yyyy hh:mm:ss a\'',
            minWidth: 195
        }
    ];
    this.gridOptions = {
        appScopeProvider: this,
        rowSelection: false,
        enableRowHeaderSelection: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: false,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: 1,
        enableVerticalScrollbar: 2,
        multiSelect: true,
        rowTemplate: 'dashboard/queues/queueDetail/components/cellTemplates/queue-step-row-template.html',
        isRowSelectable: function (row) {
            return _this.canEditPriority({ queueStep: row.entity });
        },
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
        }
    };
    var updateExcludedColumns = function () {
        var excludedColumns = _.uniq(_this.excludedColumns);
        var newColumnDefs = _.clone(defaultGridColumns);
        _.remove(newColumnDefs, function (colDef) {
            return _.includes(excludedColumns, colDef.field);
        });
        // Retitle 'Retries' column as 'Iterations' in the
        // Restores queue, per Robert/AWS restore
        if (_.includes($routeParams.group, 'restore')) {
            _.forEach(newColumnDefs, function (colDef) {
                if (colDef.name === 'Retries') {
                    colDef.name = 'Iterations';
                }
            });
        }
        _this.gridOptions.columnDefs = newColumnDefs;
    };
    var buildGridData = function (activeSteps, queuedSteps) {
        var activeHeader = { header: true, title: 'Active', style: 'active-queue-header' };
        var queuedHeader = { header: true, title: 'Queued', style: 'queued-queue-header' };
        var noneRow = { header: true, title: 'None', style: 'blank-queue-header' };
        if (activeSteps.length === _this.pagingOptions.pageSize) {
            return _.concat([], activeHeader, activeSteps);
        }
        else if (_this.pagingOptions.currentPage === 1) {
            return _.concat([], activeHeader, (activeSteps.length > 0) ? activeSteps : noneRow, queuedHeader, (queuedSteps.length > 0) ? queuedSteps : noneRow);
        }
        else if (activeSteps.length === 0) {
            return _.concat([], queuedHeader, queuedSteps);
        }
        else {
            return _.concat([], activeHeader, (activeSteps.length > 0) ? activeSteps : noneRow, queuedHeader, (queuedSteps.length > 0) ? queuedSteps : noneRow);
        }
    };
    var updateGridData = function () {
        var prevSelectedStepIds = {};
        if (_this.gridApi) {
            _.forEach(_this.gridApi.selection.getSelectedRows(), function (queueStep) {
                prevSelectedStepIds[queueStep.id] = true;
            });
            _this.gridApi.selection.clearSelectedRows();
        }
        if (_this.statusName === 'active') {
            var sortedSteps = _.partition(_this.queueSteps, function (step) {
                return step.status === 'EXECUTING';
            });
            var activeSteps = sortedSteps[0];
            var queuedSteps = sortedSteps[1];
            _this.gridOptions.data = buildGridData(activeSteps, queuedSteps);
        }
        else {
            _this.gridOptions.data = _this.queueSteps;
        }
        if (_.size(prevSelectedStepIds) > 0) {
            $timeout(function () {
                _.forEach(_this.gridOptions.data, function (queueStep) {
                    if (_this.canEditPriority({ queueStep: queueStep }) &&
                        prevSelectedStepIds[queueStep.id]) {
                        _this.gridApi.selection.selectRow(queueStep);
                    }
                });
            });
        }
    };
    var invokeOnStepPrioritiesChanged = function (modifiedQueueSteps) {
        _this.gridApi.selection.clearSelectedRows();
        _this.onStepPrioritiesChanged({
            modifiedQueueSteps: modifiedQueueSteps
        });
    };
    this.onRowDoubleClicked = function (row) {
        if (_this.canEditPriority({ queueStep: row.entity })) {
            _this.gridApi.selection.selectRow(row.entity);
            var queueSteps = _this.gridApi.selection.getSelectedRows();
            ModalService.showQueuePriorityEditorModal(queueSteps, invokeOnStepPrioritiesChanged);
        }
    };
    this.openVideoModal = function (media) {
        if (_this.canOpenVideoModel({ media: media })) {
            ModalService.showMediaModal('video', media, media.proxyId);
        }
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onChanges = function (changes) {
        if (changes.excludedColumns) {
            updateExcludedColumns();
        }
        if (changes.queueSteps) {
            updateGridData();
        }
    };
    this.$onInit = function () {
        updateExcludedColumns();
        updateGridData();
    };
}
angular.module('prism-ui.queues').component('queueDetailGrid', {
    bindings: {
        canOpenVideoModel: '&',
        canEditPriority: '&',
        onStepPrioritiesChanged: '&',
        excludedColumns: '<',
        pagingOptions: '=',
        queueSteps: '<',
        statusName: '@'
    },
    controller: QueueDetailGridController,
    templateUrl: 'dashboard/queues/queueDetail/components/queue-detail-grid-template.html'
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by rwilliams on 10/10/17.
 */
function ExternalMetadataEditViewController(_, $route, $routeParams, $location, $timeout, ExternalMetadataService, BreadcrumbService, UtilsService, MacCaptionTemplatesService) {
    var _this = this;
    var originalEditData;
    this.systemNameLocked = true;
    this.showSystemNamePadLock = true;
    var parentBreadcrumb = {
        location: '/system/aggregation/setup',
        name: 'Setup'
    };
    var validateExternalIngestType = function () {
        var ingestType = _.get(_this.externalIngestTypes, _this.externalIngestType);
        if (!_.isNil(ingestType)) {
            _this.externalIngestTypeDisplayText = _.get(ingestType, 'displayName');
            $location.url("/system/aggregation/edit/" + $routeParams.id + "/" + ingestType.value);
            return true;
        }
        return false;
    };
    var getData = function () {
        BreadcrumbService.clearBreadcrumbs();
        BreadcrumbService.addBreadcrumb(parentBreadcrumb);
        MacCaptionTemplatesService.getAllMacCaptionTemplates().then(function (macCaptionTemplates) {
            _this.availableMacCaptionTemplates = macCaptionTemplates;
        });
        if ($routeParams.id !== '-1') {
            _this.loadingIndicator.show = true;
            ExternalMetadataService.getExternalSource($routeParams.id).then(function (data) {
                _this.externalIngestType = _.get(ExternalMetadataService.getExternalSourceType(data), 'value');
                if (validateExternalIngestType()) {
                    data.priority = _.parseInt(data.priority);
                    data.ingestsPerMinute = parseFloat(data.ingestsPerMinute);
                    originalEditData = _.cloneDeep(data);
                    _this.editData = data;
                    _this.originalExternalSourceData = _.cloneDeep(data);
                    _this.loadingIndicator.show = false;
                }
                else {
                    $location.url(parentBreadcrumb.location);
                }
            });
        }
        else {
            _this.systemNameLocked = false;
            _this.showSystemNamePadLock = false;
            _this.editData = {};
        }
    };
    var saveEditData = function () {
        _this.loadingIndicator.show = true;
        var requestMethod = _.has(_this.editData, 'id') ? 'update' : 'save';
        if (_.isDate(_this.editData.minimumReleaseDate)) {
            _this.editData.minimumReleaseDate = _this.editData.minimumReleaseDate.toISOString().split("T")[0];
        }
        if (_this.editData.ingestsPerMinute <= 0) {
            _this.editData.ingestsPerMinute = null;
        }
        ExternalMetadataService.saveUpdateMetadataSource(requestMethod, _this.editData).then(function (data) {
            originalEditData = _.cloneDeep(data);
            if (requestMethod === 'save') {
                $route.updateParams({ id: data.id });
            }
            _this.editorForm.$setPristine();
            _this.loadingIndicator.show = false;
        });
    };
    this.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () {
                var enableSave = !_.get(_this.editorForm, '$pristine') && _.get(_this.editorForm, '$valid');
                var requiredFields = [
                    'name',
                    'systemName'
                ];
                switch (_this.externalIngestType) {
                    case _this.externalIngestTypes.watchFolder.value:
                        requiredFields.push('watchFolderPath');
                        requiredFields.push('xslTemplate');
                        break;
                    case _this.externalIngestTypes.jsonFeed.value:
                        requiredFields.push('feedUrl');
                        requiredFields.push('pollInterval');
                        requiredFields.push('channelTitle');
                        break;
                    default:
                        break;
                }
                _.forEach(requiredFields, function (requireField) {
                    enableSave = enableSave && _.size(_.get(_this.editData, requireField));
                });
                return enableSave;
            },
            onClick: saveEditData
        },
        {
            label: 'Revert',
            enabled: function () {
                var revertEnabled = true;
                if ($routeParams.id !== '-1') {
                    revertEnabled = _this.editorForm && !_this.editorForm.$pristine;
                }
                return revertEnabled;
            },
            onClick: function () {
                _this.editData = _.cloneDeep(originalEditData);
                _this.editorForm.$pristine = true;
                _this.editorForm.$setPristine();
                if ($routeParams.id === '-1') {
                    $location.url(parentBreadcrumb.location);
                }
            }
        },
        {
            label: 'Close',
            enabled: function () { return true; },
            onClick: function () {
                $location.url(parentBreadcrumb.location);
            }
        }
    ];
    this.$onInit = function () {
        _this.externalIngestType = $routeParams.externalIngestType;
        _this.externalIngestTypes = UtilsService.externalIngestTypes;
        if ((_.isNil(_this.externalIngestType) && $routeParams.id !== '-1') || validateExternalIngestType()) {
            getData();
        }
        else {
            $location.url(parentBreadcrumb.location);
        }
    };
    this.$postLink = function () {
        $timeout(function () {
            ExternalMetadataService.editorForm = _this.editorForm;
        });
    };
}
angular.module('prism-ui.externalMetadata').component('externalMetadataEditView', {
    bindings: {
        xslTemplates: '<'
    },
    controller: ExternalMetadataEditViewController,
    templateUrl: 'system/externalMetadata/setup/editor/external-metadata-edit-view-template.html'
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function ExternalMetadataGridViewController(uiGridConstants, $location, ExternalMetadataService, UtilsService, ModalService) {
    var _this = this;
    var gridColumns = [
        {
            field: 'enabled',
            displayName: 'Enabled',
            cellTemplate: 'components/visual/grid/radio-button-template.html',
            width: 70
        },
        {
            field: 'name',
            displayName: 'External Source Name',
            sort: {
                direction: uiGridConstants.ASC,
                priority: 1
            },
            cellTemplate: 'components/visual/grid/base-tooltip-template.html',
            width: 300
        },
        {
            field: 'type',
            sort: {
                direction: uiGridConstants.ASC,
                priority: 0
            },
            displayName: 'Type',
            cellTemplate: 'components/visual/grid/base-tooltip-template.html',
            width: 200
        },
        {
            field: 'sourceLocation',
            displayName: 'Source Location',
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        },
        {
            field: 'xslTemplate.name',
            displayName: 'Template Name',
            cellTemplate: 'components/visual/grid/base-tooltip-template.html',
            width: 400
        },
        {
            field: 'minimumReleaseDate',
            displayName: 'Minimum Release Date',
            cellTemplate: 'components/visual/grid/base-tooltip-template.html',
            cellFilter: 'amDateFormat: \'MMMM DD, YYYY\'',
            width: 200
        }
    ];
    var getData = function () {
        _this.loadingIndicator.show = true;
        ExternalMetadataService.getExternalSources().then(function (data) {
            embellishGridDataItems(data);
            _this.gridOptions.data = data;
            _this.loadingIndicator.show = false;
        });
    };
    var embellishGridDataItems = function (data) {
        _.forEach(data, function (entity) {
            var ingestType = ExternalMetadataService.getExternalSourceType(entity);
            entity.type = ingestType.displayName;
            if (ingestType === UtilsService.externalIngestTypes.watchFolder) {
                entity.sourceLocation = entity.watchFolderPath;
            }
            else {
                entity.sourceLocation = entity.feedUrl;
            }
        });
    };
    var editExternalSystem = function (entity) {
        $location.url("/system/aggregation/edit/" + entity.id + "/" + ExternalMetadataService.getExternalSourceType(entity).value);
    };
    this.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };
    this.onRowDblClick = function (row) {
        editExternalSystem(row.entity);
    };
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: gridColumns,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        data: []
    };
    var onSelectExternalIngestType = function (selectedType) {
        $location.url("/system/aggregation/edit/-1/" + selectedType);
    };
    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: function () { return true; },
            onClick: function () {
                ModalService.showExternalIngestTypeModal(onSelectExternalIngestType);
            }
        },
        {
            label: 'Edit',
            enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()); },
            onClick: function () {
                editExternalSystem(_.first(_this.gridApi.selection.getSelectedRows()));
            }
        },
        {
            icon: 'fa-upload',
            label: 'Run',
            enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()); },
            onClick: function () {
                ModalService.showExternalIngestRunModal(_.first(_this.gridApi.selection.getSelectedRows()).id);
            }
        }
    ];
    this.$onInit = function () {
        getData();
    };
}
angular.module('prism-ui.externalMetadata').component('externalMetadataGridView', {
    controller: ExternalMetadataGridViewController,
    templateUrl: 'system/externalMetadata/setup/gridView/external-metadata-grid-view-template.html'
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: directory-service.ts
 *
 * Created by kyang on 2020-09-10.
 */
function DirectoryServiceConstructor(_, DirectoryResourceFactory) {
    var _this = this;
    this.getDirectories = function (criteria) {
        var finalCriteria = _.omit(criteria, ['fetchOffset', 'fetchLimit', 'searchString']);
        var firstIndex = _.get(criteria, 'fetchOffset', 0);
        var lastIndex = firstIndex + _.get(criteria, 'fetchLimit', 25) - 1;
        finalCriteria.range = "storageDirectories " + firstIndex + "-" + lastIndex;
        finalCriteria.name = _.get(criteria, 'searchString');
        return DirectoryResourceFactory.query(finalCriteria).$promise;
    };
    this.getDirectory = function (id) {
        return DirectoryResourceFactory.getDirectory({ id: id }).$promise;
    };
    this.createDirectory = function (directory) {
        return DirectoryResourceFactory.createDirectory(directory).$promise;
    };
    this.updateDirectory = function (directory) {
        return DirectoryResourceFactory.updateDirectory(directory).$promise;
    };
    this.moveDirectory = function (directory, targetFileSystemId) {
        var directoryCopy = _.assign({}, directory, { filesystemId: targetFileSystemId });
        return _this.updateDirectory(directoryCopy);
    };
}
angular
    .module('prism-ui.fileSystem')
    .service('DirectoryService', DirectoryServiceConstructor);

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: file-system-properties-component.ts
 *
 * Created by kyang on 2020-09-11.
 */
function FileSystemPropertiesController($location, $q, $route, $routeParams, FileSystemService, FileSystemEditService, SidebarService) {
    var _this = this;
    this.editingNewFileSystem = function () {
        return $routeParams.id === '-1';
    };
    //=========//
    // Toolbar //
    //=========//
    var saveEditData = function () {
        var savePromise;
        _this.loadingIndicator.show = true;
        if (_this.editingNewFileSystem()) {
            savePromise = FileSystemService.createFileSystem(_this.fileSystemObject);
        }
        else {
            savePromise = FileSystemService.updateFileSystem(_this.fileSystemObject);
        }
        savePromise.then(function (fileSystem) {
            FileSystemEditService.setOriginalEditData(fileSystem);
            _this.fileSystemObject = fileSystem;
            $route.updateParams({ id: fileSystem.id });
        })
            .finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var revertEditData = function () {
        _this.fileSystemObject = _.cloneDeep(FileSystemEditService.originalEditData);
        _this.editorForm.$setPristine();
        if (_this.editingNewFileSystem()) {
            exitEdit();
        }
    };
    var exitEdit = function () {
        $location.url('/system/fileSystems/search');
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return !_this.editorForm.$pristine && _this.editorForm.$valid; },
            onClick: saveEditData
        }, {
            label: 'Revert',
            enabled: function () { return !_this.editorForm.$pristine || _this.editingNewFileSystem(); },
            onClick: revertEditData
        }, {
            label: 'Close',
            enabled: function () { return _this.editorForm.$pristine && !_this.editingNewFileSystem(); },
            onClick: exitEdit
        }
    ];
    //=================//
    // Lifecycle Hooks //
    //=================//
    var getData = function () {
        var promises = [];
        _this.loadingIndicator.show = true;
        promises.push(FileSystemService.getFileSystemTypes()
            .then(function (fileSystemTypes) {
            _this.fileSystemTypes = fileSystemTypes;
        }));
        if (_this.editingNewFileSystem()) {
            _this.fileSystemObject = _.get(_this, 'fileSystemObject', {});
            FileSystemEditService.setOriginalEditData(_this.fileSystemObject);
        }
        else {
            promises.push(FileSystemService.getFileSystem($routeParams.id)
                .then(function (fileSystem) {
                FileSystemEditService.setOriginalEditData(fileSystem);
                _this.fileSystemObject = fileSystem;
            }));
        }
        $q.all(promises).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        getData();
    };
    this.$postLink = function () {
        FileSystemEditService.editorForm = _this.editorForm;
        SidebarService.editService = FileSystemEditService;
    };
    this.$onDestroy = function () {
        FileSystemEditService.editorForm = null;
    };
}
angular.module('prism-ui.fileSystem').component('fileSystemPropertiesView', {
    templateUrl: 'system/fileSystem/editView/properties/file-system-properties-template.html',
    controller: FileSystemPropertiesController
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function GroupMemberSearchViewController($routeParams, $location, GroupsService, uiGridConstants) {
    var _this = this;
    var getData = function () {
        _this.loadingIndicator.show = true;
        GroupsService.getGroup($routeParams.id, { includeUsers: true }).then(function (viewData) {
            GroupsService.breadcrumbName = viewData.name;
            _this.gridOptions.data = viewData.users;
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    this.gridOptions = {
        rowSelection: false,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: [{
                field: 'username',
                type: 'string',
                enableSorting: true,
                sort: {
                    direction: 'asc',
                    priority: 0
                },
                displayName: 'Username',
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                field: 'firstName',
                type: 'string',
                enableSorting: true,
                displayName: 'First Name',
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                field: 'lastName',
                type: 'string',
                enableSorting: true,
                displayName: 'Last Name',
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            }],
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
        },
        data: []
    };
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        if (_this.isAdmin) {
            if (_.toNumber($routeParams.id) !== -1) {
                getData();
            }
        }
        else {
            $location.url('/login');
        }
    };
    this.$onDestroy = function () {
        GroupsService.breadcrumbName = undefined;
        GroupsService.originalEditData = undefined;
        GroupsService.editorForm = undefined;
    };
}
angular.module('prism-ui.groups').component('groupMemberSearchView', {
    templateUrl: 'system/groups/editor/members/group-member-search-view-template.html',
    controller: GroupMemberSearchViewController,
    bindings: {
        isAdmin: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function GroupPropertiesEditViewController(_, $q, $routeParams, $route, $location, GroupsService, PermissionsService, uiGridConstants, ModalService, APPLICATION_STATE_LIST, PERMISSION_EXCEPTION_LIST, SidebarService, $timeout) {
    var _this = this;
    var defaultPermissionFlags = ['VIEW', 'MODIFY'];
    var createContentDataPermissions = function (contentObjectClass) {
        var existingPermissionContexts = _this.editData.permissionContextMap;
        var mappingData = _this.editData.mappingData;
        var newPermissions = [];
        var permissionContextMap = _.get(existingPermissionContexts, _.upperFirst(contentObjectClass));
        if (permissionContextMap) {
            _.forEach(permissionContextMap, function (context) {
                var newPermission = {
                    name: mappingData[contentObjectClass][context.target].name,
                    permissionContext: context
                };
                newPermissions.push(newPermission);
            });
            _this.permissionGridContainers[contentObjectClass].gridOptions.data = newPermissions;
        }
    };
    var createPermissionContainer = function (stateDisplayName, stateNameKey) {
        return {
            name: stateDisplayName,
            permissionContext: {
                target: 'Authorities',
                targetCriteria: "<and><condition property='" + stateNameKey + "' op='notnull'/></and>",
                actions: []
            }
        };
    };
    var addChildPermissionContextExceptions = function (newChildViewPermission, existingPermissionContextMap, stateDisplayName, stateNameKey) {
        if (_.get(PERMISSION_EXCEPTION_LIST, stateNameKey)) {
            newChildViewPermission.permissionContext.exceptions = [];
        }
        if (_.get(existingPermissionContextMap, stateNameKey)) {
            newChildViewPermission.name = stateDisplayName;
            newChildViewPermission.permissionContext = existingPermissionContextMap[stateNameKey];
            if (_.get(existingPermissionContextMap[stateNameKey], 'exceptions')) {
                var permissionExceptions_1 = [];
                _.forEach(existingPermissionContextMap[stateNameKey].exceptions, function (exception) {
                    permissionExceptions_1.push({
                        permission: {
                            name: PERMISSION_EXCEPTION_LIST[stateNameKey].displayName,
                            permissionContext: existingPermissionContextMap[stateNameKey]
                        },
                        exception: exception
                    });
                });
                _this.permissionGridContainers.exceptions.gridOptions.data = _.concat(_this.permissionGridContainers.exceptions.gridOptions.data, permissionExceptions_1);
            }
        }
    };
    var createViewPermissions = function () {
        var existingPermissionContextMap = _this.editData.permissionContextMap.Authorities;
        var newViewPermissionObject = {};
        _.forEach(APPLICATION_STATE_LIST, function (stateGroup, key) {
            _.forEach(stateGroup.parentViewStates, function (stateDisplayName, stateNameKey) {
                var newParentViewPermission = createPermissionContainer(stateDisplayName, stateNameKey);
                if (_.get(existingPermissionContextMap, stateNameKey)) {
                    newParentViewPermission.name = stateDisplayName;
                    newParentViewPermission.permissionContext = existingPermissionContextMap[stateNameKey];
                }
                if (!_.get(newViewPermissionObject, key)) {
                    newViewPermissionObject[key] = [];
                }
                newViewPermissionObject[key].push(newParentViewPermission);
            });
            _.forEach(stateGroup.childViewStates, function (childStates, key) {
                _.forEach(childStates, function (stateDisplayName, stateNameKey) {
                    var newChildViewPermission = createPermissionContainer(stateDisplayName, stateNameKey);
                    addChildPermissionContextExceptions(newChildViewPermission, existingPermissionContextMap, stateDisplayName, stateNameKey);
                    if (!_.get(newViewPermissionObject, key)) {
                        newViewPermissionObject[key] = [];
                    }
                    newViewPermissionObject[key].push(newChildViewPermission);
                });
            });
        });
        _.forEach(newViewPermissionObject, function (viewPermissions, permissionsKey) {
            _this.permissionGridContainers[permissionsKey].gridOptions.data = viewPermissions;
        });
    };
    var getPermissionContextFromMap = function (existingPermissionContextMap, targetClass, targetId) {
        return _.get(existingPermissionContextMap, "[" + targetClass + ".null." + targetId + "]");
    };
    var createPermissionsFromMappingData = function () {
        var existingPermissionContexts = _this.editData.permissionContextMap;
        var mappingData = _this.editData.mappingData;
        createViewPermissions();
        // Iterate through the mapping data group keys: "network, packageCategoryType, longForm, shortForm" to
        // generate map/permissionContext objects in order to populate grids
        _.forEach(mappingData, function (mappingObjectClassArray, targetClassKey) {
            if (targetClassKey === 'series' ||
                targetClassKey === 'movie' ||
                targetClassKey === 'advertisement') {
                createContentDataPermissions(targetClassKey);
            }
            else {
                var targetClass_1 = targetClassKey;
                var newPermissions_1 = [];
                // Iterate through mappingObjectClassArray
                _.forEach(mappingObjectClassArray, function (mappingClassObject) {
                    var newPermission = {};
                    var existingPermissionContext = {};
                    var existingPermissionContextMap = {};
                    // Retrieve existing permission context if it exists
                    if (targetClassKey === 'longForm' || targetClassKey === 'shortForm') {
                        targetClass_1 = 'PackageCategory';
                        existingPermissionContextMap = _.get(existingPermissionContexts, 'PackageCategory');
                        existingPermissionContext = getPermissionContextFromMap(existingPermissionContextMap, targetClass_1, mappingClassObject.id);
                    }
                    else if (targetClassKey === 'longFormType' || targetClassKey === 'shortFormType') {
                        targetClass_1 = 'PackageCategoryType';
                        existingPermissionContextMap = _.get(existingPermissionContexts, 'PackageCategoryType');
                        existingPermissionContext = getPermissionContextFromMap(existingPermissionContextMap, targetClass_1, mappingClassObject.id);
                    }
                    else {
                        existingPermissionContextMap = _.get(existingPermissionContexts, _.upperFirst(targetClassKey));
                        existingPermissionContext = getPermissionContextFromMap(existingPermissionContextMap, _.upperFirst(targetClassKey), mappingClassObject.id);
                    }
                    // Create new permission and it's context
                    if (_.isUndefined(existingPermissionContext)) {
                        newPermission = {
                            name: mappingClassObject.name,
                            permissionContext: {
                                target: "[" + _.upperFirst(targetClass_1) + ".null." + mappingClassObject.id + "]",
                                actions: []
                            }
                        };
                        newPermissions_1.push(newPermission);
                    }
                    else {
                        newPermission.name = mappingClassObject.name;
                        newPermission.permissionContext = existingPermissionContext;
                        newPermissions_1.push(newPermission);
                    }
                });
                // Add permissions to corresponding grid
                _this.permissionGridContainers[_.lowerFirst(targetClassKey)].gridOptions.data = newPermissions_1;
            }
        });
    };
    var getContentType = function (contentType) {
        var contentTypeSubString = _.split(contentType.toLowerCase(), '/', 1)[0];
        if (contentTypeSubString === 'ad') {
            contentTypeSubString = 'advertisement';
        }
        return contentTypeSubString;
    };
    var createPermissionContext = function (content) {
        var newPermissionContext = {
            target: "[" + _.upperFirst(getContentType(content.type)) + ".null." + content.id + "]",
            actions: defaultPermissionFlags
        };
        return newPermissionContext;
    };
    var contentSelectionHandler = function (content) {
        var newPermissionContext = createPermissionContext(content);
        _this.permissionGridContainers[getContentType(content.type)].gridOptions.data.push({
            name: content.name,
            permissionContext: newPermissionContext
        });
        _this.editData.permissionContexts.push(newPermissionContext);
        _this.editorForm.$setDirty();
    };
    var revertPermissions = function () {
        _this.editData.group = _.cloneDeep(GroupsService.originalEditData.group);
        _this.editData.permissionContexts = _.cloneDeep(GroupsService.originalEditData.permissionContexts);
        _.forEach(_this.permissionGridContainers, function (gridContainer, gridContainerKey) {
            _.forEach(_this.originalPermissionGridContainers, function (originalGridContainer, originalContainerKey) {
                if (gridContainerKey === originalContainerKey) {
                    gridContainer.gridOptions.data = _.cloneDeep(originalGridContainer.gridOptions.data);
                }
            });
        });
        _this.editorForm.$setPristine();
    };
    var getData = function () {
        _this.loadingIndicator.show = true;
        $q.all([
            PermissionsService.isSystemOperator().then(function (isSystemOps) {
                _this.canWriteSystemOpsPermissions = isSystemOps;
            }),
            GroupsService.getGroupAndMappingData($routeParams.id).then(function (viewData) {
                GroupsService.breadcrumbName = viewData.group.name;
                GroupsService.originalEditData = {
                    group: _.cloneDeep(viewData.group),
                    permissionContexts: _.cloneDeep(viewData.permissionContexts)
                };
                _this.editData = viewData;
                createPermissionsFromMappingData();
                _this.originalPermissionGridContainers = _.cloneDeep(_this.permissionGridContainers);
            })
        ]).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var createOrUpdateData = function () {
        var isNew = _.toNumber($routeParams.id) === -1;
        var createOrUpdatePromise;
        _this.loadingIndicator.show = true;
        if (isNew) {
            createOrUpdatePromise = GroupsService.createGroup(_this.editData.group, _this.editData.permissionContexts);
        }
        else {
            createOrUpdatePromise = GroupsService.updateGroup(_this.editData.group, GroupsService.originalEditData.permissionContexts, _this.editData.permissionContexts);
        }
        createOrUpdatePromise.then(function (viewData) {
            GroupsService.originalEditData = _.cloneDeep(viewData);
            _this.editData.group = viewData.group;
            _this.editData.permissionContexts = viewData.permissionContexts;
            GroupsService.updateMappingData(_this.editData);
            createPermissionsFromMappingData();
            _this.originalPermissionGridContainers = _.cloneDeep(_this.permissionGridContainers);
            $route.updateParams({ id: _this.editData.group.id });
            _this.editorForm.$setPristine();
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var columnDefinitionObject = {
        name: {
            displayName: 'Name',
            field: 'name',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        read: {
            displayName: 'Read',
            field: 'permissionContext.actions',
            width: 120,
            cellTemplate: 'components/visual/grid/read-check-mark-template.html'
        },
        writeExecute: {
            displayName: 'Write/Execute',
            field: 'permissionContext.actions',
            width: 120,
            cellTemplate: 'components/visual/grid/write-execute-check-mark-template.html'
        },
        action: {
            displayName: '',
            field: 'permissionContext',
            width: 30,
            cellTemplate: 'components/visual/grid/exception-icon-template.html'
        },
        exceptions: [
            {
                displayName: 'Exception Type',
                field: 'permission.name',
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                displayName: 'Content',
                field: 'exception.content.type',
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html',
                width: 140
            },
            {
                displayName: 'Series/Movie',
                field: 'exception.content.name',
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                displayName: 'Categories',
                field: 'exception.categories',
                cellFilter: 'arrayToCsv',
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html',
                width: 300
            },
            {
                displayName: 'Offset',
                field: 'exception.proxyReleaseOffsetInMinutes',
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html',
                width: 60
            },
            {
                displayName: '',
                field: 'edit',
                width: 30,
                cellTemplate: 'components/visual/grid/exception-icon-template.html'
            },
            {
                displayName: '',
                field: 'remove',
                width: 30,
                cellTemplate: 'components/visual/grid/exception-icon-template.html'
            }
        ]
    };
    var getGridOptions = function (targetClassName, columnDefinitionKeys) {
        return {
            rowSelection: false,
            enableRowHeaderSelection: false,
            enableSelectAll: false,
            enableColumnResizing: true,
            enablePaginationControls: false,
            enableSorting: true,
            enableColumnMenus: false,
            enableFullRowSelection: true,
            enableHorizontalScrollbar: uiGridConstants.ALWAYS,
            enableVerticalScrollbar: uiGridConstants.ALWAYS,
            rowHeight: 26,
            multiSelect: false,
            columnDefs: _.chain(_.cloneDeep(columnDefinitionObject)).pick(columnDefinitionKeys).toArray().flatten().value(),
            onRegisterApi: function (gridApi) {
                _this.permissionGridContainers[targetClassName]['gridApi'] = gridApi;
            },
            data: []
        };
    };
    var exceptionCloseHandler = function (exceptionData) {
        if (!exceptionData.isEdit) {
            exceptionData.exceptionPermission.permission.permissionContext.exceptions.push(exceptionData.exceptionPermission.exception);
            _this.permissionGridContainers.exceptions.gridOptions.data.push(exceptionData.exceptionPermission);
        }
        else {
            _.forEach(_this.editData.permissionContexts, function (context) {
                if (context.targetCriteria === exceptionData.exceptionPermission.permission.permissionContext.targetCriteria) {
                    context.exceptions = exceptionData.exceptionPermission.permission.permissionContext.exceptions;
                }
            });
        }
        _this.editorForm.$setDirty();
    };
    var isReadColumn = function (column) {
        return _.split(column.displayName, '/')[0] === 'Read';
    };
    var calculateNewRowActions = function (toggledRow, toggledColumn) {
        var permission = toggledRow.entity;
        var isViewPermission = _.get(permission.permissionContext, 'target') === 'Authorities';
        var selectionMap = {
            readOnly: ['READ'],
            readWrite: ['READ', 'WRITE'],
            writeExecute: ['VIEW', 'MODIFY'],
            noPermissions: []
        };
        var newActions;
        if (isViewPermission) {
            var readToggled = isReadColumn(toggledColumn);
            if (readToggled) {
                var hadReadAction = _.difference(selectionMap.readOnly, permission.permissionContext.actions).length === 0;
                newActions = (hadReadAction) ? selectionMap.noPermissions : selectionMap.readOnly;
            }
            else { // Write/Execute toggled
                var readColumnVisible = _.some(toggledRow.grid.columns, isReadColumn);
                var hadWriteAction = _.difference(selectionMap.readWrite, permission.permissionContext.actions).length === 0;
                if (!hadWriteAction) {
                    newActions = selectionMap.readWrite;
                }
                else {
                    newActions = (readColumnVisible) ? selectionMap.readOnly : selectionMap.noPermissions;
                }
            }
        }
        else {
            var hadActions = !_.isEqual(selectionMap.noPermissions, permission.permissionContext.actions);
            newActions = (hadActions) ? selectionMap.noPermissions : selectionMap.writeExecute;
        }
        return newActions;
    };
    var updatePermission = function (prevPermission, newActions) {
        var prevHadActions = !_.isEmpty(prevPermission.permissionContext.actions);
        var nowHasActions = !_.isEmpty(newActions);
        prevPermission.permissionContext.actions = newActions;
        if (!prevHadActions && nowHasActions) {
            _this.editData.permissionContexts.push(prevPermission.permissionContext);
        }
        else if (prevHadActions && !nowHasActions) {
            _.remove(_this.editData.permissionContexts, function (groupContext) {
                var isViewPermission = _.get(prevPermission.permissionContext, 'target') === 'Authorities';
                if (isViewPermission) {
                    return _.get(groupContext, 'targetCriteria') &&
                        GroupsService.XJS.xml2js(prevPermission.permissionContext.targetCriteria).and.condition._property === GroupsService.XJS.xml2js(groupContext.targetCriteria).and.condition._property;
                }
                else {
                    return prevPermission.permissionContext.target === groupContext.target;
                }
            });
        }
    };
    this.checkMarkCellClicked = function (row, column) {
        var impliedPermission = _.includes(_this.permissionGridContainers.impliedSystemOps.gridOptions.data, row.entity);
        if (impliedPermission) {
            return;
        }
        var newActions = calculateNewRowActions(row, column);
        updatePermission(row.entity, newActions);
        var isSystemOpsPermission = _.includes(_this.permissionGridContainers.systemOps.gridOptions.data, row.entity);
        if (isSystemOpsPermission) {
            _.forEach(_this.permissionGridContainers.impliedSystemOps.gridOptions.data, function (impliedPermission) {
                updatePermission(impliedPermission, newActions);
            });
        }
        _this.editorForm.$setDirty();
    };
    this.exceptionCellClickHandler = function (row, column, index, event) {
        var addException = column.field === 'permissionContext';
        if (addException && row.entity.permissionContext.actions.length === 0) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
        }
        if (column.field === 'remove') {
            _.remove(row.entity.permission.permissionContext.exceptions, function (existingException) {
                return _.isEqual(row.entity.exception, existingException) ||
                    _.get(row.entity.exception, 'id') === _.get(existingException, 'id');
            });
            _.pullAt(_this.permissionGridContainers.exceptions.gridOptions.data, index);
            _this.editorForm.$setDirty();
        }
        else {
            var isEdit = column.field === 'edit';
            var series = _.toArray(_this.editData.mappingData.series);
            var movies = _.toArray(_this.editData.mappingData.movie);
            var categories = _.toArray(_.concat(_this.editData.mappingData.shortForm, _this.editData.mappingData.longForm));
            var permissionException = {
                permission: row.entity,
                exception: {}
            };
            if (isEdit) {
                var proxyReleaseOffsetInMinutes = _.toNumber(_.get(row.entity.exception, 'proxyReleaseOffsetInMinutes'));
                row.entity.exception.proxyReleaseOffsetInMinutes = _.isNaN(proxyReleaseOffsetInMinutes) ? undefined : proxyReleaseOffsetInMinutes;
                permissionException = row.entity;
            }
            ModalService.showGroupsExceptionModal(series, movies, categories, permissionException, isEdit, exceptionCloseHandler);
        }
    };
    this.permissionGridContainers = {
        network: {
            displayName: 'Networks',
            gridOptions: getGridOptions('network', ['name', 'writeExecute'])
        },
        longFormType: {
            displayName: 'Long Form',
            gridOptions: getGridOptions('longFormType', ['name', 'writeExecute'])
        },
        shortFormType: {
            displayName: 'Short Form',
            gridOptions: getGridOptions('shortFormType', ['name', 'writeExecute'])
        },
        longForm: {
            targetClass: 'PackageCategory',
            gridOptions: getGridOptions('longForm', ['name', 'writeExecute'])
        },
        shortForm: {
            targetClass: 'PackageCategory',
            gridOptions: getGridOptions('shortForm', ['name', 'writeExecute'])
        },
        series: {
            displayName: 'Series',
            gridOptions: getGridOptions('series', ['name'])
        },
        movie: {
            displayName: 'Movies/Specials',
            gridOptions: getGridOptions('movie', ['name'])
        },
        advertisement: {
            displayName: 'Ads',
            gridOptions: getGridOptions('advertisement', ['name'])
        },
        dashboard: {
            displayName: 'Dashboard',
            gridOptions: getGridOptions('dashboard', ['name', 'read', 'writeExecute'])
        },
        meta: {
            displayName: 'Meta',
            gridOptions: getGridOptions('meta', ['name', 'read', 'writeExecute'])
        },
        metaNetwork: {
            displayName: 'Networks',
            gridOptions: getGridOptions('metaNetwork', ['name', 'read', 'writeExecute'])
        },
        metaSeries: {
            displayName: 'Series',
            gridOptions: getGridOptions('metaSeries', ['name', 'read', 'writeExecute'])
        },
        metaMovie: {
            displayName: 'Movies',
            gridOptions: getGridOptions('metaMovie', ['name', 'read', 'writeExecute'])
        },
        packages: {
            displayName: 'Package',
            gridOptions: getGridOptions('packages', ['name', 'read', 'writeExecute'])
        },
        packageAction: {
            displayName: 'Package',
            gridOptions: getGridOptions('packageAction', ['name', 'read', 'writeExecute', 'action'])
        },
        packageBasic: {
            displayName: 'Package',
            gridOptions: getGridOptions('packageBasic', ['name', 'read', 'writeExecute'])
        },
        packageActionClip: {
            displayName: 'Package',
            gridOptions: getGridOptions('packageActionClip', ['name', 'read', 'writeExecute', 'action'])
        },
        packageClip: {
            displayName: 'Package',
            gridOptions: getGridOptions('packageBasic', ['name', 'read', 'writeExecute'])
        },
        aggregationSetup: {
            displayName: 'Aggregation',
            gridOptions: getGridOptions('aggregationSetup', ['name', 'read', 'writeExecute'])
        },
        system: {
            displayName: 'System',
            gridOptions: getGridOptions('system', ['name', 'read', 'writeExecute'])
        },
        systemPartner: {
            displayName: 'Partners',
            gridOptions: getGridOptions('systemPartner', ['name', 'read', 'writeExecute'])
        },
        systemOps: {
            displayName: 'System Operations',
            gridOptions: getGridOptions('systemOps', ['name', 'writeExecute'])
        },
        impliedSystemOps: {
            displayName: 'System Operations - Implied',
            gridOptions: getGridOptions('impliedSystemOps', ['name', 'writeExecute'])
        },
        exceptions: {
            displayName: 'Exceptions',
            gridOptions: getGridOptions('exceptions', ['exceptions'])
        }
    };
    this.addContent = function (contentType) {
        var formattedContentType = getContentType(contentType);
        var filteredContent = _.filter(_this.editData.mappingData[formattedContentType], function (content) {
            return !_.find(_this.permissionGridContainers[formattedContentType].gridOptions.data, function (permission) { return permission.permissionContext.target.endsWith(content.id + "]"); });
        });
        ModalService.showContentSelectModal(contentType, filteredContent, contentSelectionHandler);
    };
    this.removeGridContentAndPermissionContext = function (contentType) {
        var permissionGridContainer = _this.permissionGridContainers[getContentType(contentType)];
        var selectedRow = permissionGridContainer.gridApi.selection.getSelectedRows()[0];
        _.remove(permissionGridContainer.gridOptions.data, function (permission) { return permission.permissionContext.target === selectedRow.permissionContext.target; });
        _.remove(_this.editData.permissionContexts, function (permissionContext) { return permissionContext.target === selectedRow.permissionContext.target; });
        _this.editorForm.$setDirty();
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return !_.get(_this.editorForm, '$pristine') && !!_.get(_this.editData.group, 'name'); },
            onClick: createOrUpdateData
        },
        {
            label: 'Revert',
            enabled: function () { return !_.get(_this.editorForm, '$pristine'); },
            onClick: function () {
                revertPermissions();
            }
        },
        {
            label: 'Close',
            enabled: function () { return !_.get(_this.editorForm, '$dirty'); },
            onClick: function () { return $location.url($route.current.rootRoute); }
        }
    ];
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        if (_this.isAdmin) {
            getData();
        }
        else {
            $location.url('/login');
        }
    };
    this.$postLink = function () {
        var _this = this;
        $timeout(function () {
            GroupsService.editorForm = _this.editorForm;
            SidebarService.editService = GroupsService;
        });
    };
    this.$onDestroy = function () {
        GroupsService.breadcrumbName = undefined;
        GroupsService.originalEditData = undefined;
        GroupsService.editorForm = undefined;
    };
}
angular.module('prism-ui.groups').component('groupPropertiesEditView', {
    templateUrl: 'system/groups/editor/properties/group-properties-edit-view-template.html',
    controller: GroupPropertiesEditViewController,
    bindings: {
        isAdmin: '<'
    }
})
    .filter('arrayToCsv', function () {
    return function (array) {
        return _.chain(array).map('name').value().join(', ');
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function ConditionalTemplatesEditViewController(_, $location, $route, $routeParams, $timeout, BreadcrumbService, ConditionalTemplatesService, ModalService, PermissionsService, SidebarService) {
    var _this = this;
    this.editData = {};
    var getData = function () {
        _this.loadingIndicator.show = true;
        ConditionalTemplatesService.getConditionalTemplate($routeParams.id).then(function (conditionalTemplate) {
            ConditionalTemplatesService.originalEditData = _.cloneDeep(conditionalTemplate);
            _this.editData = conditionalTemplate;
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveHandler = function () {
        _this.loadingIndicator.show = true;
        if ($routeParams.id === '-1') {
            saveNewConditionalTemplate();
        }
        else {
            updateConditionalTemplate();
        }
    };
    var updateConditionalTemplate = function () {
        ConditionalTemplatesService.updateConditionalTemplate(_this.editData).then(function (conditionalTemplate) {
            ConditionalTemplatesService.originalEditData = _.cloneDeep(conditionalTemplate);
            _this.editData = conditionalTemplate;
            _this.editorForm.$setPristine();
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveNewConditionalTemplate = function () {
        ConditionalTemplatesService.createConditionalTemplate(_this.editData).then(function (conditionalTemplate) {
            $route.updateParams({ id: conditionalTemplate.id });
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return !_.get(_this.editorForm, '$pristine') && _.get(_this.editorForm, '$valid'); },
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: function () { return !_.get(_this.editorForm, '$pristine'); },
            onClick: function () {
                _this.editData = _.cloneDeep(ConditionalTemplatesService.originalEditData);
                _this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: function () { return !_.get(_this.editorForm, '$dirty'); },
            onClick: function () { return $location.url("/system/templates/search").search({ tab: 'ConditionalTemplates' }); }
        }
    ];
    this.$onInit = function () {
        SidebarService.editService = ConditionalTemplatesService;
        _this.isAdmin = PermissionsService.isAdmin();
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        if (_this.isAdmin) {
            if ($routeParams.id !== '-1') {
                if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                    BreadcrumbService.addBreadcrumb({
                        name: 'Edit Conditional Template',
                        location: '/system/templates/search',
                        params: { tab: 'ConditionalTemplates' }
                    });
                }
                getData();
            }
            else {
                ConditionalTemplatesService.originalEditData = _.cloneDeep(_this.editData);
                BreadcrumbService.addBreadcrumb({
                    name: 'Create Conditional Template',
                    location: '/system/templates/search',
                    params: { tab: 'ConditionalTemplates' }
                });
            }
        }
        else {
            $location.url('/login');
        }
    };
    this.$onDestroy = function () {
        ConditionalTemplatesService.originalEditData = null;
        ConditionalTemplatesService.viewData = null;
    };
    this.$postLink = function () {
        $timeout(function () {
            ConditionalTemplatesService.editorForm = _this.editorForm;
            BreadcrumbService.editService = ConditionalTemplatesService;
        });
    };
}
angular.module('prism-ui.conditionalTemplate').component('conditionalTemplatesEditView', {
    templateUrl: 'system/templates/conditionalTemplate/editor/conditional-template-edit-template.html',
    controller: ConditionalTemplatesEditViewController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function FfmpegTemplatesEditViewController(_, $routeParams, $route, $location, $timeout, BreadcrumbService, FfmpegTemplatesService, ModalService, PermissionsService, SidebarService) {
    var _this = this;
    this.editData = {};
    var getData = function () {
        _this.loadingIndicator.show = true;
        FfmpegTemplatesService.getFfmpegTemplate($routeParams.id).then(function (ffmpegTemplate) {
            FfmpegTemplatesService.originalEditData = _.cloneDeep(ffmpegTemplate);
            _this.editData = ffmpegTemplate;
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveHandler = function () {
        _this.loadingIndicator.show = true;
        if ($routeParams.id === '-1') {
            saveNewFfmpegTemplate();
        }
        else {
            updateFfmpegTemplate();
        }
    };
    var updateFfmpegTemplate = function () {
        FfmpegTemplatesService.updateFfmpegTemplate(_this.editData).then(function (ffmpegTemplate) {
            FfmpegTemplatesService.originalEditData = _.cloneDeep(ffmpegTemplate);
            _this.editData = ffmpegTemplate;
            _this.editorForm.$setPristine();
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveNewFfmpegTemplate = function () {
        FfmpegTemplatesService.createFfmpegTemplate(_this.editData).then(function (ffmpegTemplate) {
            $route.updateParams({ id: ffmpegTemplate.id });
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return !_.get(_this.editorForm, '$pristine') && _.size(_.get(_this.editData, 'name')); },
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: function () { return !_.get(_this.editorForm, '$pristine'); },
            onClick: function () {
                _this.editData = _.cloneDeep(FfmpegTemplatesService.originalEditData);
                _this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: function () { return !_.get(_this.editorForm, '$dirty'); },
            onClick: function () { return $location.url("/system/templates/search").search({ tab: 'FfmpegTemplates' }); }
        }
    ];
    this.$onInit = function () {
        SidebarService.editService = FfmpegTemplatesService;
        _this.isAdmin = PermissionsService.isAdmin();
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        if (_this.isAdmin) {
            if ($routeParams.id !== '-1') {
                if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                    BreadcrumbService.addBreadcrumb({
                        name: 'Edit FFmpeg Template',
                        location: '/system/templates/search',
                        params: { tab: 'FfmpegTemplates' }
                    });
                }
                getData();
            }
            else {
                FfmpegTemplatesService.originalEditData = _.cloneDeep(_this.editData);
                BreadcrumbService.addBreadcrumb({
                    name: 'Create Ffmpeg Template',
                    location: '/system/templates/search',
                    params: { tab: 'FfmpegTemplates' }
                });
            }
        }
        else {
            $location.url('/login');
        }
    };
    this.$onDestroy = function () {
        FfmpegTemplatesService.originalEditData = null;
        FfmpegTemplatesService.viewData = null;
    };
    this.$postLink = function () {
        $timeout(function () {
            FfmpegTemplatesService.editorForm = _this.editorForm;
            BreadcrumbService.editService = FfmpegTemplatesService;
        });
    };
}
angular.module('prism-ui.ffmpegTemplate').component('ffmpegTemplatesEditView', {
    templateUrl: 'system/templates/ffmpegTemplate/editor/ffmpeg-template-edit-template.html',
    controller: FfmpegTemplatesEditViewController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function HybrikTemplateEditViewController(_, $routeParams, $location, $timeout, BreadcrumbService, HybrikTemplateEditService, MediaConversionTemplateService, NotificationService, PermissionsService, SidebarService) {
    var _this = this;
    var setEditData = function (template) {
        HybrikTemplateEditService.setOriginalEditData(template);
        _this.editData = template;
        _this.payloadString = JSON.stringify(template.conversionInfo.jobPayload, null, 4);
        if (_this.editorForm) {
            _this.editorForm.$setPristine();
        }
    };
    var getData = function () {
        _this.loadingIndicator.show = true;
        MediaConversionTemplateService.getMediaConversionTemplate($routeParams.id)
            .then(setEditData)
            .finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveNewHybrikTemplate = function () {
        MediaConversionTemplateService.createMediaConversionTemplate(_this.editData)
            .then(function (template) {
            setEditData(template);
            $location.url("/system/templates/hybrikTemplates/edit/" + template.id);
        });
    };
    var updateHybrikTemplate = function () {
        MediaConversionTemplateService.updateMediaConversionTemplate(_this.editData)
            .then(setEditData)
            .finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    this.toolbarButtonDefs = [{
            label: 'Save',
            enabled: function () { return !_.get(_this.editorForm, '$pristine') && _.get(_this.editorForm, '$valid'); },
            onClick: function () {
                _this.loadingIndicator.show = true;
                try {
                    _this.editData.conversionInfo.jobPayload = JSON.parse(_this.payloadString);
                    if ($routeParams.id === '-1') {
                        saveNewHybrikTemplate();
                    }
                    else {
                        updateHybrikTemplate();
                    }
                }
                catch (error) {
                    NotificationService.createFailureNotification(error.message, '', true, -1);
                    _this.errorIndex = parseInt(_.chain(error.message)
                        .words()
                        .last()
                        .value());
                    _this.loadingIndicator.show = false;
                }
            }
        }, {
            label: 'Revert',
            enabled: function () { return !_.get(_this.editorForm, '$pristine'); },
            onClick: function () {
                setEditData(_.cloneDeep(HybrikTemplateEditService.originalEditData));
            }
        }, {
            label: 'Close',
            enabled: function () { return !_.get(_this.editorForm, '$dirty'); },
            onClick: function () { return $location.url("/system/templates/search").search({ tab: 'HybrikTemplates' }); }
        }];
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        SidebarService.editService = MediaConversionTemplateService;
        _this.isAdmin = PermissionsService.isAdmin();
        _this.errorIndex = null;
        _this.payloadString = '';
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        if (_this.isAdmin) {
            if ($routeParams.id !== '-1') {
                if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                    BreadcrumbService.addBreadcrumb({
                        name: 'Edit Hybrik Template',
                        location: '/system/templates/search',
                        params: { tab: 'HybrikTemplates' }
                    });
                }
                getData();
            }
            else {
                setEditData({
                    name: '',
                    converterType: 'Hybrik',
                    conversionInfo: {
                        converterType: 'Hybrik',
                        jobPayload: {
                            name: '',
                            payload: {},
                            definitions: {}
                        }
                    },
                });
                BreadcrumbService.addBreadcrumb({
                    name: 'Create Hybrik Template',
                    location: '/system/templates/search',
                    params: { tab: 'HybrikTemplates' }
                });
            }
        }
        else {
            $location.url('/login');
        }
    };
    this.$postLink = function () {
        $timeout(function () {
            HybrikTemplateEditService.editorForm = _this.editorForm;
            BreadcrumbService.editService = HybrikTemplateEditService;
        });
    };
    this.$onDestroy = function () {
        HybrikTemplateEditService.originalEditData = null;
        HybrikTemplateEditService.editorForm = null;
    };
}
angular.module('prism-ui.templates').component('hybrikTemplateEditView', {
    templateUrl: 'system/templates/hybrikTemplate/editor/hybrik-template-edit-template.html',
    controller: HybrikTemplateEditViewController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function ImageTemplatesEditViewController(_, $location, $route, $routeParams, $timeout, BreadcrumbService, ImageTemplatesService, ModalService, PermissionsService, SidebarService) {
    var _this = this;
    this.editData = {};
    var getData = function () {
        _this.loadingIndicator.show = true;
        ImageTemplatesService.getImageTemplate($routeParams.id).then(function (imageTemplate) {
            ImageTemplatesService.originalEditData = _.cloneDeep(imageTemplate);
            _this.editData = imageTemplate;
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveHandler = function () {
        _this.loadingIndicator.show = true;
        if ($routeParams.id === '-1') {
            saveNewImageTemplate();
        }
        else {
            updateImageTemplate();
        }
    };
    var updateImageTemplate = function () {
        ImageTemplatesService.updateImageTemplate(_this.editData).then(function (imageTemplate) {
            ImageTemplatesService.originalEditData = _.cloneDeep(imageTemplate);
            _this.editData = imageTemplate;
            _this.editorForm.$setPristine();
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveNewImageTemplate = function () {
        ImageTemplatesService.createImageTemplate(_this.editData).then(function (imageTemplate) {
            $route.updateParams({ id: imageTemplate.id });
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return !_.get(_this.editorForm, '$pristine')
                && _.size(_.get(_this.editData, 'params'))
                && _.size(_.get(_this.editData, 'name')); },
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: function () { return !_.get(_this.editorForm, '$pristine'); },
            onClick: function () {
                _this.editData = _.cloneDeep(ImageTemplatesService.originalEditData);
                _this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: function () { return !_.get(_this.editorForm, '$dirty'); },
            onClick: function () { return $location.url("/system/templates/search").search({ tab: 'ImageTemplates' }); }
        }
    ];
    this.$onInit = function () {
        SidebarService.editService = ImageTemplatesService;
        _this.isAdmin = PermissionsService.isAdmin();
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        if (_this.isAdmin) {
            if ($routeParams.id !== '-1') {
                if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                    BreadcrumbService.addBreadcrumb({
                        name: 'Edit Image Template',
                        location: '/system/templates/search',
                        params: { tab: 'ImageTemplates' }
                    });
                }
                getData();
            }
            else {
                ImageTemplatesService.originalEditData = _.cloneDeep(_this.editData);
                BreadcrumbService.addBreadcrumb({
                    name: 'Create Image Template',
                    location: '/system/templates/search',
                    params: { tab: 'ImageTemplates' }
                });
            }
        }
        else {
            $location.url('/login');
        }
    };
    this.$onDestroy = function () {
        ImageTemplatesService.originalEditData = null;
        ImageTemplatesService.viewData = null;
    };
    this.$postLink = function () {
        $timeout(function () {
            ImageTemplatesService.editorForm = _this.editorForm;
            BreadcrumbService.editService = ImageTemplatesService;
        });
    };
}
angular.module('prism-ui.imageTemplate').component('imageTemplatesEditView', {
    templateUrl: 'system/templates/imageTemplate/editView/image-template-edit-view-template.html',
    controller: ImageTemplatesEditViewController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function IntermediateTemplatesEditViewController(_, $location, $route, $routeParams, $timeout, BreadcrumbService, IntermediateTemplatesService, ModalService, PermissionsService, SidebarService) {
    var _this = this;
    this.editData = {};
    var getData = function () {
        _this.loadingIndicator.show = true;
        IntermediateTemplatesService.getIntermediateTemplate($routeParams.id).then(function (intermediateTemplate) {
            IntermediateTemplatesService.originalEditData = _.cloneDeep(intermediateTemplate);
            _this.editData = intermediateTemplate;
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveHandler = function () {
        _this.loadingIndicator.show = true;
        if ($routeParams.id === '-1') {
            saveNewIntermediateTemplate();
        }
        else {
            updateIntermediateTemplate();
        }
    };
    var updateIntermediateTemplate = function () {
        IntermediateTemplatesService.updateIntermediateTemplate(_this.editData).then(function (intermediateTemplate) {
            IntermediateTemplatesService.originalEditData = _.cloneDeep(intermediateTemplate);
            _this.editData = intermediateTemplate;
            _this.editorForm.$setPristine();
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveNewIntermediateTemplate = function () {
        IntermediateTemplatesService.createIntermediateTemplate(_this.editData).then(function (intermediateTemplate) {
            $route.updateParams({ id: intermediateTemplate.id });
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return !_.get(_this.editorForm, '$pristine') && _.size(_.get(_this.editData, 'name')); },
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: function () { return !_.get(_this.editorForm, '$pristine'); },
            onClick: function () {
                _this.editData = _.cloneDeep(IntermediateTemplatesService.originalEditData);
                _this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: function () { return !_.get(_this.editorForm, '$dirty'); },
            onClick: function () { return $location.url("/system/templates/search").search({ tab: 'IntermediateTemplates' }); }
        }
    ];
    this.$onInit = function () {
        SidebarService.editService = IntermediateTemplatesService;
        _this.isAdmin = PermissionsService.isAdmin();
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        if (_this.isAdmin) {
            if ($routeParams.id !== '-1') {
                if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                    BreadcrumbService.addBreadcrumb({
                        name: 'Edit Intermediate Template',
                        location: '/system/templates/search',
                        params: { tab: 'IntermediateTemplates' }
                    });
                }
                getData();
            }
            else {
                IntermediateTemplatesService.originalEditData = _.cloneDeep(_this.editData);
                BreadcrumbService.addBreadcrumb({
                    name: 'Create Intermediate Template',
                    location: '/system/templates/search',
                    params: { tab: 'IntermediateTemplates' }
                });
            }
        }
        else {
            $location.url('/login');
        }
    };
    this.$onDestroy = function () {
        IntermediateTemplatesService.originalEditData = null;
        IntermediateTemplatesService.viewData = null;
    };
    this.$postLink = function () {
        $timeout(function () {
            IntermediateTemplatesService.editorForm = _this.editorForm;
            BreadcrumbService.editService = IntermediateTemplatesService;
        });
    };
}
angular.module('prism-ui.intermediateTemplate').component('intermediateTemplatesEditView', {
    templateUrl: 'system/templates/intermediateTemplate/editor/intermediate-template-edit-template.html',
    controller: IntermediateTemplatesEditViewController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function MacCaptionTemplatesEditViewController(_, $location, $route, $routeParams, $timeout, BreadcrumbService, MacCaptionTemplatesService, ModalService, PermissionsService, SidebarService) {
    var _this = this;
    this.editData = {};
    var getData = function () {
        _this.loadingIndicator.show = true;
        MacCaptionTemplatesService.getMacCaptionTemplate($routeParams.id).then(function (macCaptionTemplate) {
            MacCaptionTemplatesService.originalEditData = _.cloneDeep(macCaptionTemplate);
            _this.editData = macCaptionTemplate;
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveHandler = function () {
        _this.loadingIndicator.show = true;
        if ($routeParams.id === '-1') {
            saveNewMacCaptionTemplate();
        }
        else {
            updateMacCaptionTemplate();
        }
    };
    var updateMacCaptionTemplate = function () {
        MacCaptionTemplatesService.updateMacCaptionTemplate(_this.editData).then(function (macCaptionTemplate) {
            MacCaptionTemplatesService.originalEditData = _.cloneDeep(macCaptionTemplate);
            _this.editData = macCaptionTemplate;
            _this.editorForm.$setPristine();
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveNewMacCaptionTemplate = function () {
        MacCaptionTemplatesService.createMacCaptionTemplate(_this.editData).then(function (macCaptionTemplate) {
            $route.updateParams({ id: macCaptionTemplate.id });
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return !_.get(_this.editorForm, '$pristine') &&
                _.size(_.get(_this.editData, 'name')) &&
                _.size(_.get(_this.editData, 'template')); },
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: function () { return !_.get(_this.editorForm, '$pristine'); },
            onClick: function () {
                _this.editData = _.cloneDeep(MacCaptionTemplatesService.originalEditData);
                _this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: function () { return !_.get(_this.editorForm, '$dirty'); },
            onClick: function () { return $location.url("/system/templates/search").search({ tab: 'MacCaptionTemplates' }); }
        }
    ];
    this.$onInit = function () {
        SidebarService.editService = MacCaptionTemplatesService;
        _this.isAdmin = PermissionsService.isAdmin();
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        if (_this.isAdmin) {
            if ($routeParams.id !== '-1') {
                if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                    BreadcrumbService.addBreadcrumb({
                        name: 'Edit MacCaption Template',
                        location: '/system/templates/search',
                        params: { tab: 'MacCaptionTemplates' }
                    });
                }
                getData();
            }
            else {
                MacCaptionTemplatesService.originalEditData = _.cloneDeep(_this.editData);
                BreadcrumbService.addBreadcrumb({
                    name: 'Create MacCaption Template',
                    location: '/system/templates/search',
                    params: { tab: 'MacCaptionTemplates' }
                });
            }
        }
        else {
            $location.url('/login');
        }
    };
    this.$onDestroy = function () {
        MacCaptionTemplatesService.originalEditData = null;
        MacCaptionTemplatesService.viewData = null;
    };
    this.$postLink = function () {
        $timeout(function () {
            MacCaptionTemplatesService.editorForm = _this.editorForm;
            BreadcrumbService.editService = MacCaptionTemplatesService;
        });
    };
}
angular.module('prism-ui.system.maccaptionTemplate').component('macCaptionTemplatesEditView', {
    templateUrl: 'system/templates/maccaptionTemplate/editor/maccaption-template-edit-view-template.html',
    controller: MacCaptionTemplatesEditViewController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
function MediaAcceptProfilesEditView(_, $location, $q, $route, $routeParams, $timeout, BreadcrumbService, EnumService, MediaAcceptProfileService, MediaConversionTemplateService, ModalService, NotificationService, PermissionsService, SidebarService) {
    var _this = this;
    // Gets the data to populate dropdowns etc
    var getDataForFormControls = function () {
        _this.loadingIndicator.show = true;
        MediaAcceptProfileService.getMediaAcceptProfileEditViewData().then(function (data) {
            initializeFormControls(data);
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var getData = function () {
        _.set(_this.enabledTabs, $location.search().editView, true);
        EnumService.queryForEnums().then(function () {
            if ($routeParams.id !== '-1') {
                getMapObject();
            }
            else {
                _this.mapObject = _.cloneDeep(MediaAcceptProfileService.mapObject);
                getDataForFormControls();
            }
        });
    };
    var initializeFormControls = function (data) {
        _this.macCaptionTemplates = _.cloneDeep(data.macCaptionTemplates);
        _this.mediaConversionTemplates = _.cloneDeep(data.mediaConversionTemplates);
        _this.repositoryRoots = _.cloneDeep(data.repositoryRoots);
        setAvailableVideoMasterTypes();
        setVideoMasterType();
        _this.videoAcceptProfiles = _.filter(_.cloneDeep(data.acceptTemplates), { type: 'VIDEO' });
    };
    var setAvailableVideoMasterTypes = function () {
        //Setup Video Master Types for use in template
        if (_.get(_this, 'mapObject.type') === 'VIDEO') {
            _this.availableVideoMasterTypes = [];
            var tempVideoMasterTypes = EnumService.getEnumPicklist('MediaAcceptProfile_videoMasterType');
            _.forEach(tempVideoMasterTypes, function (type) {
                var typeObj = { type: type.id, displayName: type.displayName };
                _this.availableVideoMasterTypes.push(typeObj);
            });
        }
    };
    //
    // The goal of this is to set the MAP's video master type to
    // an object with the properties "type" and "displayName".
    // This is accomplished by either looking it up by the MAP's
    // existing videoMasterType id which is the capitalized
    // underscore delimited string and then getting the
    // displayName and type or if in the other case where the MAP
    // does not have a video master type defined, by setting it to
    // the PICTURE_TO_PICTURE video master type.
    //
    // For example, if the MAP object's video master type is
    //
    //  {
    //      type: "'MASTER_VIDEO',
    //      programTimingRequired: true
    //  }
    //
    //  it will be set to
    //
    //  {
    //      displayName: 'Master Video',
    //      type: 'MASTER_VIDEO'
    //  }
    //
    //  In the case where the MAP object's video master type is
    //  undefined it will be set to
    //
    //  {
    //      displayName: 'Picture To Picture',
    //      type: 'PICTURE_TO_PICTURE'
    //  }
    //
    var setVideoMasterType = function () {
        var videoMasterTypeId = 'PICTURE_TO_PICTURE';
        if (_.has(_this, 'mapObject.videoMasterType')) {
            videoMasterTypeId = _this.mapObject.videoMasterType.type;
        }
        var videoMasterType = _
            .chain(EnumService.getEnumPicklist('MediaAcceptProfile_videoMasterType'))
            .find({ id: videoMasterTypeId })
            .mapKeys(function (value, key) {
            if (key === 'id') {
                return 'type';
            }
            else {
                return key;
            }
        })
            .value();
        _.set(_this, 'mapObject.videoMasterType', videoMasterType);
    };
    // Get the MAP object
    var getMapObject = function () {
        _this.loadingIndicator.show = true;
        $q.all({
            acceptProfile: MediaAcceptProfileService.getAcceptProfile($routeParams.id),
            formControlsData: MediaAcceptProfileService.getMediaAcceptProfileEditViewData()
        }).then(function (data) {
            _this.mapObject = _.cloneDeep(data.acceptProfile);
            MediaAcceptProfileService.originalAcceptProfile = _.cloneDeep(_this.mapObject);
            initializeFormControls(data.formControlsData);
            //For breadcrumbs
            _this.acceptProfileName = _this.mapObject.name;
            setEnabledTabs(_this.mapObject.type);
            _this.minimumCaptionResult = _this.mapObject.minimumCaptionDurationErrorFlag ? 'Error' : 'Warning';
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var resetTabsToPropertiesEnabledOnly = function () {
        _this.enabledTabs = {
            properties: true,
            general: false,
            intermediates: false,
            sharedVideo: false,
            proxyPlayer: false,
            ccExtraction: false,
            clipExtraction: false,
            audio: false,
            video: false,
            audioChannels: false,
            image: false,
            artwork: false,
            text: false
        };
    };
    var setEnabledTabs = function (type) {
        resetTabsToPropertiesEnabledOnly();
        if ($routeParams.id !== '-1') {
            switch (type) {
                case 'VIDEO':
                    _this.enabledTabs.general = true;
                    _this.enabledTabs.video = true;
                    _this.enabledTabs.audio = true;
                    _this.enabledTabs.audioChannels = true;
                    _this.enabledTabs.text = true;
                    _this.enabledTabs.intermediates = true;
                    _this.enabledTabs.sharedVideo = true;
                    _this.enabledTabs.ccExtraction = true;
                    _this.enabledTabs.clipExtraction = true;
                    _this.enabledTabs.proxyPlayer = true;
                    break;
                case 'IMAGE':
                    _this.enabledTabs.general = true;
                    _this.enabledTabs.image = true;
                    break;
                case 'AUDIO':
                    _this.enabledTabs.general = true;
                    _this.enabledTabs.audio = true;
                    _this.enabledTabs.audioChannels = true;
                    break;
                case 'OTHER':
                    _this.enabledTabs.general = true;
                    _this.enabledTabs.artwork = true;
                    break;
                case 'DOCUMENT':
                    _this.enabledTabs.general = true;
                    break;
                default:
                    _this.enabledTabs.properties = false;
                    console.warn('Unknown MAP type encountered when initializing MAP Edit View tabs.');
                    break;
            }
        }
    };
    var setToolbarButtonDefs = function () {
        if (_this.currentTab === 'properties') {
            _this.toolbarButtonDefs = allToolbarButtonDefs;
        }
        else {
            _this.toolbarButtonDefs = _.reject(allToolbarButtonDefs, { label: 'Derive' });
        }
    };
    var saveMediaAcceptProfile = function () {
        _this.loadingIndicator.show = true;
        if (_.get(_this, 'mapObject.type') === 'ARTWORK') {
            _this.mapObject.type = 'OTHER';
        }
        if (_.has(_this.mapObject, 'sharedVideoDeliveryItem')) {
            _.set(_this.mapObject, 'sharedVideoDeliveryItem.type', 'Video');
        }
        MediaAcceptProfileService.saveAcceptProfile(_this.mapObject).then(function (savedProfile) {
            _this.editorForm.$setPristine();
            MediaAcceptProfileService.originalAcceptProfile = _.cloneDeep(savedProfile);
            $route.updateParams({ id: savedProfile.id });
            _this.minimumCaptionResult = savedProfile.minimumCaptionDurationErrorFlag ? 'Error' : 'Warning';
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    //================//
    // Template Logic //
    //================//
    this.onClipMezzanineTypeChanged = function (conversionType) {
        _this.clipMezzanineType = conversionType;
        if (conversionType && conversionType !== 'FFmpeg') {
            _.unset(_this.mapObject, 'liveClipHLSConcatTemplate');
            _.unset(_this.mapObject, 'liveClipIntermediateTemplate');
            _.unset(_this.mapObject, 'ccExtractTemplate');
            _.unset(_this.mapObject, 'liveClipsCCDelay');
        }
    };
    this.isClipMezzanineTemplateRequired = function () {
        return _this.clipMezzanineType === 'Vantage';
    };
    this.onChildComponentSetFormPristineHandler = function () {
        _this.editorForm.$setPristine();
    };
    this.numericFieldKeyDown = function ($event, currentValue) {
        if ($event.key.length === 1) {
            var newValue = currentValue || '';
            newValue += $event.key;
            if (!(/^([0-9]*|[0-9]*[.][0-9]*)$/.test(newValue))) {
                $event.preventDefault();
            }
        }
    };
    this.onTabDeselect = function (tab, event) {
        if (_this.editorForm.$dirty) {
            NotificationService.createWarningNotification('You have unsaved changes.  Please save or revert.', '');
            event.preventDefault();
        }
        else {
            _this.editorForm.$setPristine();
        }
    };
    this.onTabSelect = function (tab) {
        if (!_this.editorForm.$dirty) {
            _this.currentTab = tab;
            setToolbarButtonDefs();
            $location.search('editView', tab);
        }
    };
    this.onMinimumCaptionResultChanged = function () {
        _this.mapObject.minimumCaptionDurationErrorFlag = _.toLower(_this.minimumCaptionResult) === 'error';
    };
    var returnToMAPSearch = function () {
        $location.url("/system/templates/search").search({ tab: 'Media', subTab: 'MediaAcceptProfiles' });
    };
    var allToolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () {
                // shared video delivery items require a filename
                // expression
                var sharedVideoDeliveryItemValid = true;
                if (_.get(_this, 'mapObject.sharedVideoDeliveryItem.mediaConversionTemplate') &&
                    !_.size(_.get(_this, 'mapObject.sharedVideoDeliveryItem.filenameExpression'))) {
                    sharedVideoDeliveryItemValid = false;
                }
                // clip mezzanines require a transcoder template
                var clipMezzanineTemplateValid = true;
                if (_this.isClipMezzanineTemplateRequired() &&
                    !_.get(_this, 'mapObject.videoExtractTemplate')) {
                    clipMezzanineTemplateValid = false;
                }
                var proxyTemplateValid = true;
                if (_.get(_this, 'mapObject.type') === 'VIDEO' || _.get(_this, 'mapObject.type') === 'AUDIO') {
                    proxyTemplateValid = !!_.get(_this, 'mapObject.proxyTemplate');
                }
                // all MAPs require a name
                return !_.isEmpty(_.get(_this, 'mapObject.name'))
                    && sharedVideoDeliveryItemValid
                    && clipMezzanineTemplateValid
                    && proxyTemplateValid
                    && _.get(_this, 'editorForm.$dirty');
            },
            onClick: function () {
                saveMediaAcceptProfile();
            }
        },
        {
            label: 'Revert',
            enabled: function () {
                return _this.editorForm && _this.editorForm.$dirty;
            },
            onClick: function () {
                if ($routeParams.id !== '-1') {
                    _this.mapObject = _.cloneDeep(MediaAcceptProfileService.originalAcceptProfile);
                    _this.editorForm.$setPristine();
                }
                else {
                    returnToMAPSearch();
                }
            }
        },
        {
            label: 'Derive',
            icon: 'fa-upload',
            enabled: function () {
                return $routeParams.id !== '-1' && !_.get(_this, 'editorForm.$dirty');
            },
            onClick: function () {
                ModalService.showGenerateAcceptProfileModal(_this.mapObject.type, $routeParams.id);
            }
        },
        {
            label: 'Close',
            enabled: function () {
                return !_.get(_this, 'editorForm.$dirty');
            },
            onClick: function () {
                returnToMAPSearch();
            }
        }
    ];
    //=================//
    // Lifecycle Hooks //
    //=================//
    var setBreadcrumb = function (action) {
        var name = action + " Media Accept Profile";
        BreadcrumbService.addBreadcrumb({
            name: name,
            location: '/system/templates/search',
            params: {
                tab: 'Media',
                subTab: 'MediaAcceptProfiles'
            }
        });
    };
    this.$onInit = function () {
        // Needed for now because dropdown-select doesn't like
        // boolean model-props
        _this.minimumCaptionResultOptions = ['Warning', 'Error'];
        _this.minimumCaptionResult = 'Warning';
        _this.clipMezzanineTypeTooltip = 'system/templates/mediaAcceptProfiles/editView/renderers/clipextraction-mezzanine-type-tooltip-template.html';
        _this.isAdmin = PermissionsService.isAdmin();
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        resetTabsToPropertiesEnabledOnly();
        if (_this.isAdmin) {
            _this.enabledTabs[$location.search().editView] = true;
            _this.currentTab = $location.search().editView;
            setToolbarButtonDefs();
            BreadcrumbService.clearBreadcrumbs();
            if ($routeParams.id !== '-1') {
                // get existing MAP
                if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                    setBreadcrumb('Edit');
                }
                getData();
            }
            else {
                // create new MAP
                if (_.has(MediaAcceptProfileService.mapObject, 'type')) {
                    _.set(_this.editData, 'mediaAcceptProfiles', []);
                    setEnabledTabs(_.get(MediaAcceptProfileService.mapObject, 'type'));
                    MediaAcceptProfileService.originalEditData = _.cloneDeep(_this.editData);
                    setBreadcrumb('Create');
                    getData();
                }
                else {
                    $location.url("/system/templates/search").search({ tab: 'Media', subTab: 'MediaAcceptProfiles' });
                }
            }
        }
        else {
            //
            // TODO
            //
            // Display a warning notification here and return to
            // the MAP search view
            //
            $location.url('/login');
        }
    };
    this.$postLink = function () {
        $timeout(function () {
            MediaAcceptProfileService.editorForm = _this.editorForm;
            SidebarService.editService = MediaAcceptProfileService;
        });
    };
    this.$onDestroy = function () {
        MediaAcceptProfileService.editorForm = null;
    };
}
angular.module('prism-ui.mediaAcceptProfiles').component('mediaAcceptProfilesEditView', {
    templateUrl: 'system/templates/mediaAcceptProfiles/editView/media-accept-profiles-editview-template.html',
    controller: MediaAcceptProfilesEditView,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function PackageAcceptTemplatesEditViewController(_, $location, $route, $routeParams, $timeout, BreadcrumbService, ModalService, PackageAcceptTemplatesService, PermissionsService, SidebarService) {
    var _this = this;
    this.editData = {};
    this.mediaAcceptProfileTypes = [
        'VIDEO',
        'AUDIO',
        'DOCUMENT',
        'IMAGE',
        'OTHER'
    ];
    var getData = function () {
        _this.loadingIndicator.show = true;
        PackageAcceptTemplatesService.getPackageAcceptTemplate($routeParams.id).then(function (packageAcceptTemplate) {
            PackageAcceptTemplatesService.originalEditData = _.cloneDeep(packageAcceptTemplate);
            _this.editData = packageAcceptTemplate;
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveHandler = function () {
        _this.loadingIndicator.show = true;
        if ($routeParams.id === '-1') {
            saveNewPackageAcceptTemplate();
        }
        else {
            updatePackageAcceptTemplate();
        }
    };
    var updatePackageAcceptTemplate = function () {
        PackageAcceptTemplatesService.updatePackageAcceptTemplate(_this.editData).then(function (packageAcceptTemplate) {
            PackageAcceptTemplatesService.originalEditData = _.cloneDeep(packageAcceptTemplate);
            _this.editData = packageAcceptTemplate;
            _this.editorForm.$setPristine();
            getData();
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveNewPackageAcceptTemplate = function () {
        PackageAcceptTemplatesService.createPackageAcceptTemplate(_this.editData).then(function (packageAcceptTemplate) {
            $route.updateParams({ id: packageAcceptTemplate.id });
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return !_.get(_this.editorForm, '$pristine') &&
                _.size(_.get(_this.editData, 'name')) &&
                _.size(_.filter(_.get(_this.editData, 'mediaAcceptProfiles'), { type: 'VIDEO' })); },
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: function () { return !_.get(_this.editorForm, '$pristine'); },
            onClick: function () {
                _this.editData = _.cloneDeep(PackageAcceptTemplatesService.originalEditData);
                _this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: function () { return !_.get(_this.editorForm, '$dirty'); },
            onClick: function () { return $location.url("/system/templates/search").search({
                tab: 'Media',
                subTab: 'PackageAcceptTemplates'
            }); }
        }
    ];
    this.$onInit = function () {
        SidebarService.editService = PackageAcceptTemplatesService;
        _this.isAdmin = PermissionsService.isAdmin();
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        if (_this.isAdmin) {
            if ($routeParams.id !== '-1') {
                if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                    BreadcrumbService.addBreadcrumb({
                        name: 'Edit Package Accept Template',
                        location: '/system/templates/search',
                        params: { tab: 'Media', subTab: 'PackageAcceptTemplates' }
                    });
                }
                getData();
            }
            else {
                _.set(_this.editData, 'mediaAcceptProfiles', []);
                PackageAcceptTemplatesService.originalEditData = _.cloneDeep(_this.editData);
                BreadcrumbService.addBreadcrumb({
                    name: 'Create Package Accept Template',
                    location: '/system/templates/search',
                    params: { tab: 'Media', subTab: 'PackageAcceptTemplates' }
                });
            }
        }
        else {
            $location.url('/login');
        }
    };
    this.$onDestroy = function () {
        PackageAcceptTemplatesService.originalEditData = null;
        PackageAcceptTemplatesService.viewData = null;
    };
    this.$postLink = function () {
        $timeout(function () {
            PackageAcceptTemplatesService.editorForm = _this.editorForm;
            BreadcrumbService.editService = PackageAcceptTemplatesService;
        });
    };
}
angular.module('prism-ui.packageAcceptTemplate').component('packageAcceptTemplatesEditView', {
    templateUrl: 'system/templates/packageAcceptTemplates/editView/package-accept-templates-edit-view-template.html',
    controller: PackageAcceptTemplatesEditViewController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function PackageCreationTemplatesEditViewController(_, $routeParams, $route, $location, PackageCreationTemplatesService, PermissionsService, ModalService, NotificationService, BreadcrumbService, loginService, SidebarService, $timeout) {
    var _this = this;
    this.editData = {};
    this.templateJson = '{}';
    var getData = function () {
        _this.loadingIndicator.show = true;
        PackageCreationTemplatesService.getPackageCreationTemplate($routeParams.id).then(function (packageCreationTemplate) {
            PackageCreationTemplatesService.originalEditData = _.cloneDeep(packageCreationTemplate);
            _this.editData = packageCreationTemplate;
            _this.templateJson = JSON.stringify(_this.editData.template, null, 2);
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveHandler = function () {
        _this.loadingIndicator.show = true;
        try {
            var parsedTemplateFromString = JSON.parse(_this.templateJson);
            _.set(_this.editData, 'template', parsedTemplateFromString);
            if ($routeParams.id === '-1') {
                saveNewPackageCreationTemplate();
            }
            else {
                updatePackageCreationTemplate();
            }
        }
        catch (error) {
            NotificationService.createFailureNotification(error.message, '', true, -1);
            _this.errorIndex = parseInt(_.chain(error.message)
                .words()
                .last()
                .value());
            _this.loadingIndicator.show = false;
        }
    };
    var updatePackageCreationTemplate = function () {
        PackageCreationTemplatesService.updatePackageCreationTemplate(_this.editData).then(function (packageCreationTemplate) {
            PackageCreationTemplatesService.originalEditData = _.cloneDeep(packageCreationTemplate);
            _this.editData = packageCreationTemplate;
            _this.editorForm.$setPristine();
            getData();
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveNewPackageCreationTemplate = function () {
        PackageCreationTemplatesService.createPackageCreationTemplate(_this.editData).then(function (packageCreationTemplate) {
            $route.updateParams({ id: packageCreationTemplate.id });
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return !_.get(_this.editorForm, '$pristine'); },
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: function () { return !_.get(_this.editorForm, '$pristine'); },
            onClick: function () {
                _this.editData = _.cloneDeep(PackageCreationTemplatesService.originalEditData);
                _this.editorForm.$setPristine();
                _this.templateJson = JSON.stringify(_this.editData.template, null, 2);
            }
        },
        {
            label: 'Close',
            enabled: function () { return !_.get(_this.editorForm, '$dirty'); },
            onClick: function () { return $location.url("/system/templates/search").search({
                tab: 'PackageCreationTemplates',
            }); }
        }
    ];
    this.$onInit = function () {
        SidebarService.editService = PackageCreationTemplatesService;
        _this.errorIndex = null;
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        PermissionsService.isSystemOperator().then(function (isSystemOps) {
            if (isSystemOps) {
                if ($routeParams.id !== '-1') {
                    if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                        BreadcrumbService.addBreadcrumb({
                            name: 'Edit Package Accept Template',
                            location: '/system/templates/search',
                            params: { tab: 'PackageCreationTemplates', subTab: null }
                        });
                    }
                    getData();
                }
                else {
                    PackageCreationTemplatesService.originalEditData = _.cloneDeep(_this.editData);
                    BreadcrumbService.addBreadcrumb({
                        name: 'Create Package Accept Template',
                        location: '/system/templates/search',
                        params: { tab: 'PackageCreationTemplates', subTab: null }
                    });
                }
            }
            else {
                $location.url('/login');
            }
        });
    };
    this.$onDestroy = function () {
        PackageCreationTemplatesService.originalEditData = null;
        PackageCreationTemplatesService.viewData = null;
    };
    this.$postLink = function () {
        $timeout(function () {
            PackageCreationTemplatesService.editorForm = _this.editorForm;
            BreadcrumbService.editService = PackageCreationTemplatesService;
        });
    };
}
angular.module('prism-ui.packageCreationTemplate').component('packageCreationTemplatesEditView', {
    templateUrl: 'system/templates/packageCreationTemplates/editView/package-creation-templates-edit-view-template.html',
    controller: PackageCreationTemplatesEditViewController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function TransformTemplatesEditViewController(_, $location, $route, $routeParams, $timeout, BreadcrumbService, ModalService, TransformTemplatesService, PermissionsService, SidebarService) {
    var _this = this;
    this.editData = {};
    var getData = function () {
        _this.loadingIndicator.show = true;
        TransformTemplatesService.getTransformTemplate($routeParams.id).then(function (transformTemplate) {
            TransformTemplatesService.originalEditData = _.cloneDeep(transformTemplate);
            _this.editData = transformTemplate;
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveHandler = function () {
        _this.loadingIndicator.show = true;
        if ($routeParams.id === '-1') {
            saveNewTransformTemplate();
        }
        else {
            updateTransformTemplate();
        }
    };
    var updateTransformTemplate = function () {
        TransformTemplatesService.updateTransformTemplate(_this.editData).then(function (transformTemplate) {
            TransformTemplatesService.originalEditData = _.cloneDeep(transformTemplate);
            _this.editData = transformTemplate;
            _this.editorForm.$setPristine();
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveNewTransformTemplate = function () {
        TransformTemplatesService.createTransformTemplate(_this.editData).then(function (transformTemplate) {
            $route.updateParams({ id: transformTemplate.id });
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return !_.get(_this.editorForm, '$pristine') && _.size(_.get(_this.editData, 'name')); },
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: function () { return !_.get(_this.editorForm, '$pristine'); },
            onClick: function () {
                _this.editData = _.cloneDeep(TransformTemplatesService.originalEditData);
                _this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: function () { return !_.get(_this.editorForm, '$dirty'); },
            onClick: function () { return $location.url("/system/templates/search").search({ tab: 'TransformTemplates' }); }
        }
    ];
    this.$onInit = function () {
        SidebarService.editService = TransformTemplatesService;
        _this.isAdmin = PermissionsService.isAdmin();
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        if (_this.isAdmin) {
            if ($routeParams.id !== '-1') {
                if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                    BreadcrumbService.addBreadcrumb({
                        name: 'Edit Transform Template',
                        location: '/system/templates/search',
                        params: { tab: 'TransformTemplates' }
                    });
                }
                getData();
            }
            else {
                TransformTemplatesService.originalEditData = _.cloneDeep(_this.editData);
                BreadcrumbService.addBreadcrumb({
                    name: 'Create Transform Template',
                    location: '/system/templates/search',
                    params: { tab: 'TransformTemplates' }
                });
            }
        }
        else {
            $location.url('/login');
        }
    };
    this.$onDestroy = function () {
        TransformTemplatesService.originalEditData = null;
        TransformTemplatesService.viewData = null;
    };
    this.$postLink = function () {
        $timeout(function () {
            TransformTemplatesService.editorForm = _this.editorForm;
            BreadcrumbService.editService = TransformTemplatesService;
        });
    };
}
angular.module('prism-ui.transformTemplate').component('transformTemplatesEditView', {
    templateUrl: 'system/templates/transformTemplate/editor/transform-template-editor-template.html',
    controller: TransformTemplatesEditViewController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function PasswordValidationController(_, $scope) {
    var _this = this;
    this.requirements = [{
            getDescription: function () { return "Minimum Length: " + _this.passwordRequirements.minLength; },
            isValid: function () { return (_this.password.length >= _.get(_this, 'passwordRequirements.minLength')); },
        }, {
            getDescription: function () { return "Minimum Uppercase Letters: " + _this.passwordRequirements.numUppers; },
            isValid: function () { return (_this.password.replace(/[^A-Z]/g, '').length >= _.get(_this, 'passwordRequirements.numUppers')); },
        }, {
            getDescription: function () { return "Minimum Lowercase Letters: " + _this.passwordRequirements.numLowers; },
            isValid: function () { return (_this.password.replace(/[^a-z]/g, '').length >= _.get(_this, 'passwordRequirements.numLowers')); },
        }, {
            getDescription: function () { return "Minimum Numerics: " + _this.passwordRequirements.numNumerics; },
            isValid: function () { return (_this.password.replace(/[^0-9]/g, '').length >= _.get(_this, 'passwordRequirements.numNumerics')); },
        }, {
            getDescription: function () { return "Minimum Special Characters: " + _this.passwordRequirements.numSpecials; },
            isValid: function () { return (_this.password.replace(/[^!@#$%^&*()?:;~|]/g, '').length >= _.get(_this, 'passwordRequirements.numSpecials')); },
        }];
    $scope.$watch(function () {
        return _.get(_this, 'editorForm.$valid', false);
    }, function () {
        _this.isValid = _.get(_this, 'editorForm.$valid', false);
    });
}
angular.module('prism-ui.users').component('passwordValidation', {
    templateUrl: 'system/users/editor/passwordValidation/password-validation-template.html',
    controller: PasswordValidationController,
    bindings: {
        password: '<',
        passwordRequirements: '<',
        isValid: '=',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: branding-container-properties-component.ts
 *
 * Created by kyang on 10/16/2020.
 */
function BrandingContainerPropertiesController($location, $q, $route, $routeParams, BrandingAssetService, BrandingContainerEditService, BreadcrumbService, BrandingViewService, NotificationService, SidebarService) {
    var _this = this;
    var ContainerType;
    (function (ContainerType) {
        ContainerType["PRE_ROLL"] = "preRolls";
        ContainerType["POST_ROLL"] = "postRolls";
        ContainerType["BREAK_PRE_POST_ROLL"] = "breakPrePostRolls";
        ContainerType["ARTWORK"] = "artwork";
        ContainerType["WATERMARK"] = "watermarks";
    })(ContainerType || (ContainerType = {}));
    this.editingNewBrandingAssetContainer = function () {
        return $routeParams.containerId === '-1';
    };
    this.editingPreRolls = function () {
        return _this.brandingConfig.type === ContainerType.PRE_ROLL;
    };
    this.toggleHidden = function () {
        _this.hideEmpty = !_this.hideEmpty;
    };
    this.onAcceptProfileClicked = function () {
        if (!_this.editorForm.$pristine) {
            NotificationService.createWarningNotification('You have unsaved changes. Please save or revert.', '');
        }
    };
    //=========//
    // Toolbar //
    //=========//
    var saveEditData = function () {
        var networkOrContent = ($location.path().indexOf('networks') !== -1) ? 'networks' : 'content';
        var savePromise;
        _this.loadingIndicator.show = true;
        if ($routeParams.type === ContainerType.BREAK_PRE_POST_ROLL) {
            _this.brandingAssetContainer.breakPrePostRolls = [];
        }
        if (_this.editingNewBrandingAssetContainer()) {
            savePromise = BrandingAssetService.createBrandingAssetContainer(_this.brandingConfig, $routeParams.id, _this.brandingAssetContainer);
        }
        else {
            savePromise = BrandingAssetService.updateBrandingAssetContainer(_this.brandingConfig, _this.brandingAssetContainer);
        }
        savePromise.then(function (brandingAssetContainer) {
            brandingAssetContainer.leadBlackDuration = _.toNumber(brandingAssetContainer.leadBlackDuration);
            BrandingContainerEditService.setOriginalEditData(brandingAssetContainer);
            _this.brandingAssetContainer = brandingAssetContainer;
            $route.updateParams({ containerId: brandingAssetContainer.id });
        })
            .finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var revertEditData = function () {
        _this.brandingAssetContainer = _.cloneDeep(BrandingContainerEditService.originalEditData);
        _this.editorForm.$setPristine();
        if (_this.editingNewBrandingAssetContainer()) {
            exitEdit();
        }
    };
    var exitEdit = function () {
        $location.path(_this.brandingConfig.parentLocation);
        $location.search("view=" + _this.brandingConfig.type);
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return _this.canWriteContainer && !_this.editorForm.$pristine && _this.editorForm.$valid; },
            onClick: saveEditData
        }, {
            label: 'Revert',
            enabled: function () { return !_this.editorForm.$pristine || _this.editingNewBrandingAssetContainer(); },
            onClick: revertEditData
        }, {
            label: 'Close',
            enabled: function () { return _this.editorForm.$pristine && !_this.editingNewBrandingAssetContainer(); },
            onClick: exitEdit
        }
    ];
    //=================//
    // Lifecycle Hooks //
    //=================//
    var getData = function () {
        _this.loadingIndicator.show = true;
        return $q.all({
            container: BrandingAssetService.getBrandingAssetContainer(_this.brandingConfig),
            mediaAcceptProfiles: BrandingViewService.getMediaAcceptProfiles(),
        })
            .then(function (data) {
            data.container.leadBlackDuration = _.toNumber(data.container.leadBlackDuration);
            BrandingContainerEditService.setOriginalEditData(data.container);
            if (_this.canReadContainer) {
                _this.brandingAssetContainer = data.container;
                _this.mediaAcceptProfiles = data.mediaAcceptProfiles;
            }
        })
            .finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    this.$onInit = function () {
        _this.hideEmpty = false;
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.loadingIndicator.show = true;
        BrandingViewService.getReadWritePermissions(_this.brandingConfig)
            .then(function (permissions) {
            _this.canReadContainer = permissions.read;
            _this.canWriteContainer = permissions.write;
            return getData();
        });
    };
    this.$postLink = function () {
        BrandingContainerEditService.editorForm = _this.editorForm;
        BreadcrumbService.editService = BrandingContainerEditService;
        SidebarService.editService = BrandingContainerEditService;
    };
    this.$onDestroy = function () {
        BrandingContainerEditService.editorForm = null;
    };
}
angular
    .module('prism-ui.components.branding')
    .component('brandingContainerProperties', {
    templateUrl: 'components/branding/editView/components/properties/branding-container-properties-template.html',
    controller: BrandingContainerPropertiesController,
    bindings: {
        brandingConfig: '<',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: branding-media-search-grid-component.ts
 *
 * Created by kyang on 11/3/2020.
 */
function BrandingMediaSearchGridController(_, $location, $routeParams, BRAND_ASSET_MAP_TYPES, BrandingAssetService, BrandingMediaViewDataTransformer, BrandingViewService, uiGridConstants) {
    var _this = this;
    var ContainerType;
    (function (ContainerType) {
        ContainerType["PRE_ROLL"] = "preRolls";
        ContainerType["POST_ROLL"] = "postRolls";
        ContainerType["BREAK_PRE_POST_ROLL"] = "breakPrePostRolls";
        ContainerType["ARTWORK"] = "artwork";
        ContainerType["WATERMARK"] = "watermarks";
        ContainerType["RATING_OVERLAY"] = "ratingOverlays";
    })(ContainerType || (ContainerType = {}));
    var isBreakPrePostRoll = function () {
        return $routeParams.type === ContainerType.BREAK_PRE_POST_ROLL;
    };
    //======//
    // Grid //
    //======//
    var getVisibleAssetForCell = function (rootAsset, colField) {
        switch (_this.brandingConfig.type) {
            case ContainerType.PRE_ROLL:
            case ContainerType.POST_ROLL:
            case ContainerType.WATERMARK:
                return rootAsset;
            case ContainerType.BREAK_PRE_POST_ROLL:
                return (colField.startsWith('preRoll')) ? rootAsset.preRoll : rootAsset.postRoll;
            case ContainerType.ARTWORK:
            case ContainerType.RATING_OVERLAY:
                return null;
            default:
                console.warn("Did not recognize type for branding asset container type: " + _this.brandingConfig.type);
                return null;
        }
    };
    this.assetHasInfo = function (rootAsset, colField) {
        var asset = getVisibleAssetForCell(rootAsset, colField);
        return BrandingAssetService.assetWasIngested(asset);
    };
    this.assetHasPreview = function (rootAsset, colField) {
        var asset = getVisibleAssetForCell(rootAsset, colField);
        return BrandingAssetService.assetHasProxy(asset);
    };
    this.hasEitherPrePostRollField = function (row, col) {
        return (!_.isNil(_.get(row.entity, col.colDef.preRollField)) ||
            !_.isNil(_.get(row.entity, col.colDef.postRollField)));
    };
    this.getPreRollField = function (row, col) {
        return _.get(row.entity, col.colDef.preRollField);
    };
    this.getPostRollField = function (row, col) {
        return _.get(row.entity, col.colDef.postRollField);
    };
    var getColumnDefs = function () {
        switch (_this.brandingConfig.type) {
            case ContainerType.PRE_ROLL:
            case ContainerType.POST_ROLL:
                return BrandingMediaViewDataTransformer.prePostRolls;
            case ContainerType.BREAK_PRE_POST_ROLL:
                return BrandingMediaViewDataTransformer.breakPrePostRolls;
            case ContainerType.ARTWORK:
                return BrandingMediaViewDataTransformer.artwork;
            case ContainerType.WATERMARK:
                return BrandingMediaViewDataTransformer.watermarks;
            case ContainerType.RATING_OVERLAY:
                return BrandingMediaViewDataTransformer.ratingOverlays;
        }
    };
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: false,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 30,
        multiSelect: false,
        columnDefs: getColumnDefs(),
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
    this.onRowDblClick = function (row) {
        if (!_this.isDisabled) {
            var targetPath = void 0;
            var assetRouteId = BrandingAssetService.getRootAssetRouteId(_this.brandingConfig.type, row.entity);
            var basePath = _this.brandingConfig.parentLocation;
            if (_this.brandingConfig.groupName === 'networks') {
                basePath += '/' + _this.brandingConfig.type;
            }
            if (_this.brandingConfig.type === ContainerType.RATING_OVERLAY) {
                targetPath = basePath + "/edit/" + assetRouteId;
            }
            else {
                var currentPath = basePath + "/edit/" + _this.container.id + "/acceptProfiles";
                targetPath = currentPath + "/edit/" + assetRouteId;
            }
            $location.path(targetPath);
        }
        if (_this.onRowClicked) {
            _this.onRowClicked(row.entity);
        }
    };
    this.openAssetPreviewModal = function (rootAsset, colField) {
        var asset = getVisibleAssetForCell(rootAsset, colField);
        switch (_this.brandingConfig.type) {
            case ContainerType.PRE_ROLL:
            case ContainerType.POST_ROLL:
            case ContainerType.BREAK_PRE_POST_ROLL:
                BrandingViewService.openAssetPreviewModal(asset, 'video');
                break;
            case ContainerType.WATERMARK:
                BrandingViewService.openAssetPreviewModal(asset, 'watermark');
                break;
            default:
                console.warn('Tried to show asset preview modal for unknown asset type');
                break;
        }
    };
    this.openAssetInfoModal = function (rootAsset, colField) {
        var asset = getVisibleAssetForCell(rootAsset, colField);
        switch (_this.brandingConfig.type) {
            case ContainerType.PRE_ROLL:
            case ContainerType.POST_ROLL:
            case ContainerType.BREAK_PRE_POST_ROLL:
                BrandingViewService.openAssetInfoModal(asset, 'video');
                break;
            case ContainerType.WATERMARK:
                BrandingViewService.openAssetInfoModal(asset, 'watermark');
                break;
            default:
                console.warn('Tried to show asset preview modal for unknown asset type');
                break;
        }
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    //
    // Remove season assets that don't match the current season,
    // or volume assets that don't match the current volume, or
    // both season and volume assets when we're not working on a
    // season or volume child container.
    //
    var removeIrrelevantAssets = function () {
        if (isBreakPrePostRoll()) {
            _this.container.breakPrePostRolls = BrandingAssetService.filterBrandingAssets(_this.brandingConfig, _this.container.breakPrePostRolls);
        }
        else {
            _this.container.assets = BrandingAssetService.filterBrandingAssets(_this.brandingConfig, _this.container.assets);
        }
    };
    var setAssetCounts = function (rootAsset) {
        switch (_this.brandingConfig.type) {
            case ContainerType.PRE_ROLL:
            case ContainerType.POST_ROLL:
                rootAsset.numberOfAudios = _.size(rootAsset.audios);
                rootAsset.numberOfTexts = _.size(rootAsset.texts);
                rootAsset.numberOfAssets = (rootAsset.numberOfAudios +
                    rootAsset.numberOfTexts +
                    ((!!rootAsset.id) ? 1 : 0));
                break;
            case ContainerType.BREAK_PRE_POST_ROLL:
                rootAsset.numberOfBreakPreRollTexts = _.size(rootAsset.preRoll.texts);
                rootAsset.numberOfBreakPreRollAudios = _.size(rootAsset.preRoll.audios);
                rootAsset.numberOfBreakPostRollTexts = _.size(rootAsset.postRoll.texts);
                rootAsset.numberOfBreakPostRollAudios = _.size(rootAsset.postRoll.audios);
                rootAsset.numberOfAssets = (rootAsset.numberOfBreakPostRollTexts +
                    rootAsset.numberOfBreakPreRollAudios +
                    rootAsset.numberOfBreakPostRollAudios +
                    rootAsset.numberOfBreakPreRollTexts +
                    ((!!rootAsset.preRoll.id) ? 1 : 0) +
                    ((!!rootAsset.postRoll.id) ? 1 : 0));
                break;
            case ContainerType.ARTWORK:
                rootAsset.numberOfAssets = _.size(rootAsset.assets);
                break;
            case ContainerType.WATERMARK:
                rootAsset.numberOfAssets = (!!rootAsset.virtualPath) ? 1 : 0;
                break;
            case ContainerType.RATING_OVERLAY:
                rootAsset.numberOfAssets = _.size(rootAsset.images);
                break;
        }
    };
    var getAssetObjectForAcceptProfile = function (acceptProfile) {
        var rootAsset = BrandingAssetService.getRootBrandingAsset(_this.brandingConfig, _this.container, acceptProfile);
        setAssetCounts(rootAsset);
        return rootAsset;
    };
    //
    // This will return a list of asset objects, one per
    // applicable MAP. MAPs which do not currently have a
    // corresponding asset in this container are populated with an
    // empty/blank asset object.
    //
    var createFullAssetList = function (mediaAcceptProfiles) {
        var rootAssets = [];
        _.chain(mediaAcceptProfiles)
            .filter({ type: BRAND_ASSET_MAP_TYPES[_this.brandingConfig.type] })
            .forEach(function (acceptProfile) {
            var rootAsset = getAssetObjectForAcceptProfile(acceptProfile);
            rootAssets.push(rootAsset);
        })
            .value();
        return rootAssets;
    };
    var getRootAssets = function (mediaAcceptProfiles) {
        removeIrrelevantAssets();
        return createFullAssetList(mediaAcceptProfiles);
    };
    var filterRootAssets = function (rootAssets) {
        return _.filter(rootAssets, function (rootAsset) {
            return !_this.hideEmpty || rootAsset.numberOfAssets > 0;
        });
    };
    this.$onChanges = function () {
        if (_this.brandingConfig && _this.container && _this.mediaAcceptProfiles) {
            var rootAssets = getRootAssets(_this.mediaAcceptProfiles);
            _this.gridOptions.data = filterRootAssets(rootAssets);
        }
    };
}
angular
    .module('prism-ui.components.branding')
    .component('brandingMediaSearchGrid', {
    templateUrl: 'components/branding/editView/components/searchGrid/branding-media-search-grid-template.html',
    controller: BrandingMediaSearchGridController,
    bindings: {
        brandingConfig: '<',
        hideEmpty: '<',
        container: '<',
        mediaAcceptProfiles: '<',
        isDisabled: '<ngDisabled',
        onRowClicked: '&?',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
angular
    .module('prism-ui.components.branding')
    .factory('BrandingMediaViewDataTransformer', function (uiGridConstants) {
    return {
        prePostRolls: [
            {
                field: 'acceptProfile.name',
                displayName: 'Media Accept Profile',
                width: '*',
                sort: {
                    direction: uiGridConstants.ASC,
                },
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            }, {
                field: 'virtualPath',
                displayName: 'Video File',
                width: '*',
                cellTemplate: 'components/branding/editView/components/searchGrid/cellTemplates/asset-info-cell-template.html'
            }, {
                field: 'numberOfAudios',
                displayName: '# Audios',
                width: '100',
                type: 'number',
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            }, {
                field: 'numberOfTexts',
                displayName: '# CC',
                width: '100',
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            }
        ],
        breakPrePostRolls: [
            {
                field: 'acceptProfile.name',
                displayName: 'Media Accept Profile',
                width: '*',
                sort: {
                    direction: uiGridConstants.ASC,
                },
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            }, {
                field: 'preRoll.virtualPath',
                displayName: 'PreRoll Video File',
                width: '25%',
                cellTemplate: 'components/branding/editView/components/searchGrid/cellTemplates/asset-info-cell-template.html'
            }, {
                field: 'postRoll.virtualPath',
                displayName: 'PostRoll Video File',
                width: '25%',
                cellTemplate: 'components/branding/editView/components/searchGrid/cellTemplates/asset-info-cell-template.html'
            }, {
                name: 'numberOfAudios',
                preRollField: 'numberOfBreakPreRollAudios',
                postRollField: 'numberOfBreakPostRollAudios',
                displayName: '# Audios',
                width: '100',
                cellTemplate: 'components/branding/editView/components/searchGrid/cellTemplates/break-prepostroll-cell-template.html'
            }, {
                name: 'numberOfTexts',
                preRollField: 'numberOfBreakPreRollTexts',
                postRollField: 'numberOfBreakPostRollTexts',
                displayName: '# CC',
                width: '100',
                cellTemplate: 'components/branding/editView/components/searchGrid/cellTemplates/break-prepostroll-cell-template.html'
            }
        ],
        watermarks: [
            {
                field: 'videoAcceptProfile.name',
                displayName: 'Media Accept Profile',
                width: '*',
                sort: {
                    direction: uiGridConstants.ASC,
                },
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            }, {
                field: 'virtualPath',
                displayName: 'Watermark File',
                width: '*',
                cellTemplate: 'components/branding/editView/components/searchGrid/cellTemplates/asset-info-cell-template.html'
            }
        ],
        artwork: [
            {
                field: 'acceptProfile.name',
                displayName: 'Media Accept Profile',
                width: '*',
                sort: {
                    direction: uiGridConstants.ASC,
                },
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            }, {
                field: 'numberOfAssets',
                displayName: '# Artwork',
                width: '100',
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            }
        ],
        ratingOverlays: [
            {
                field: 'mediaAcceptProfile.name',
                displayName: 'Media Accept Profile',
                width: '*',
                sort: {
                    direction: uiGridConstants.ASC,
                },
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            }, {
                field: 'numberOfAssets',
                displayName: '# Images',
                width: '100',
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            }
        ]
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: checkin-result-modal-component.ts
 *
 * Created by randysorensen on 1/19/18.
 */
'use strict';
function CheckinResultModalController(_) {
    var _this = this;
    this.gridOptions = {
        enableSorting: false,
        enableFiltering: false,
        enableColumnMenus: false,
        showTreeExpandNoChildren: false,
        treeRowHeaderBaseWidth: 12,
        data: [],
        columnDefs: [
            {
                name: 'name',
                displayName: 'Spreadsheet Name',
                width: '90%',
                cellTemplate: 'dashboard/packageCheckin/components/modals/checkinResultModal/gridTemplates/result-cell-template.html',
            },
        ],
    };
    this.$onInit = function () {
        _.forEach(_this.resolve.resultsDict, function (resultsForFile, fileName) {
            _this.gridOptions.data.push({
                name: fileName,
                top: true,
                $$treeLevel: 0,
            });
            _.forEach(resultsForFile, function (result) {
                _this.gridOptions.data.push({
                    name: result,
                    $$treeLevel: 1
                });
            });
        });
    };
    this.$onDestroy = function () {
        _this.close();
    };
}
angular.module('prism-ui.components').component('checkinResultModal', {
    templateUrl: 'dashboard/packageCheckin/components/modals/checkinResultModal/checkin-result-modal-template.html',
    controller: CheckinResultModalController,
    bindings: {
        resolve: '<',
        dismiss: '&',
        close: '&',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: batch-checkin-component.ts
 *
 * Created by randysorensen on 1/18/18.
 */
function BatchCheckinController(
// external deps
_, $q, 
// internal deps
ModalService, PackageService, FileUploadService) {
    var _this = this;
    var showMessageModal = function (title, message, resultHandler) {
        var messageModalOpts = {
            messageText: message,
            pullCancelLeft: true,
            title: title,
            showOK: true,
            okText: 'Close',
            showCancel: false,
            windowClass: 'message-modal-sm',
        };
        ModalService.showMessageModal(messageModalOpts, resultHandler);
    };
    this.onUploadProgress = function (progress) {
        // The uploader will give us a progress percentage; once
        // the files have been uploaded, we're only half-done
        // as we still need to call the check-in API.
        _this.progress = progress / 2;
    };
    var resetUploader = function () {
        _this.filesWithErrors = 0;
        _this.progress = 0;
        _this.resultsDict = {};
        FileUploadService.resetUploader();
    };
    this.onFilesUploaded = function (uploadedFiles) {
        var checkinPromises = [];
        _.forEach(uploadedFiles, function (file) {
            var checkinPromise = PackageService.remoteCheckIn(file.remotePath, true)
                .then(function () {
                // success
                _this.resultsDict[file.name] = ['All packages were successfully imported.'];
            })
                .catch(function (response) {
                // fail
                _this.resultsDict[file.name] = response.data;
                ++(_this.filesWithErrors);
            })
                .finally(function () {
                // regardless
                _this.progress += 50 / uploadedFiles.length;
            });
            checkinPromises.push(checkinPromise);
        });
        $q.all(checkinPromises).then(function () {
            if (_this.filesWithErrors > 0) {
                ModalService.showCheckinResultModal(_this.resultsDict, resetUploader);
            }
            else {
                showMessageModal('Success', 'All packages were successfully imported.', resetUploader);
            }
        });
    };
    this.onUploaderInitialized = function () {
        resetUploader();
    };
    //=========//
    // Toolbar //
    //=========//
    this.toolbarButtonDefs = [
        {
            label: 'Upload',
            enabled: function () { return FileUploadService.canUpload(); },
            icon: 'fa-upload',
            onClick: function () {
                FileUploadService.beginUpload();
            },
        },
        {
            label: 'Reset',
            enabled: function () { return FileUploadService.canReset(); },
            icon: 'fa-undo',
            onClick: function () {
                FileUploadService.resetUploader();
            },
        },
    ];
}
angular
    .module('prism-ui.dashboard.checkin')
    .component('batchCheckin', {
    templateUrl: 'dashboard/packageCheckin/components/views/batchCheckIn/batch-checkin-template.html',
    controller: BatchCheckinController,
    bindings: {},
});
// (EOF)

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: checked-out-package-list-component.ts
 *
 * Created by randysorensen on 1/4/18.
 */
'use strict';
function CheckedOutPackageListController(_, uiGridConstants) {
    //======//
    // Data //
    //======//
    var _this = this;
    var queryForGridData = function () {
        _this.loadingIndicator.show = true;
        _this.loadingIndicator.show = false;
    };
    //======//
    // Grid //
    //======//
    var gridColDefs = [
        //
        // ID
        //
        {
            field: 'id',
            type: 'number',
            width: '150',
            sort: {
                direction: uiGridConstants.ASC,
                priority: 1,
            },
            displayName: 'ID',
        },
        //
        // Title
        //
        {
            field: 'title',
            type: 'string',
            width: '*',
            sort: {
                direction: uiGridConstants.ASC,
                priority: 0,
            },
            displayName: 'Title',
        },
    ];
    this.gridOptions = {
        rowSelection: false,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        multiSelect: false,
        columnDefs: gridColDefs,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
        },
        data: [],
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...',
        };
        queryForGridData();
    };
}
angular
    .module('prism-ui.dashboard.checkin')
    .component('checkedOutPackageList', {
    templateUrl: 'dashboard/packageCheckin/components/views/checkedOutPackageList/checked-out-package-list-template.html',
    controller: CheckedOutPackageListController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function AliasesModalController(PartnerEditService, uiGridConstants) {
    var _this = this;
    var searchText = '';
    var getData = function () {
        var criteria = {
            fetchLimit: 0,
            includeHidden: false,
            searchString: searchText
        };
        _this.loadingIndicator.show = true;
        PartnerEditService.getAllPartners(criteria).then(function (partners) {
            _this.gridOptions.data = partners;
            _this.loadingIndicator.show = false;
        });
    };
    //===============//
    // Search Filter //
    //===============//
    var processGridFilter = function (renderableRows) {
        renderableRows.forEach(function (row) {
            if (_.includes(_.toLower(row.entity.name), _.toLower(searchText))) {
                row.visible = true;
            }
            else {
                row.visible = false;
            }
        });
        return renderableRows;
    };
    this.executeSearch = function (newSearchText) {
        searchText = newSearchText;
        _this.gridApi.grid.refresh();
    };
    this.onSearchRefresh = function (newSearchText) {
        searchText = newSearchText;
        getData();
    };
    //======//
    // Grid //
    //======//
    var columnDefinitions = [
        {
            field: 'name',
            displayName: 'Name',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: true,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: true,
        columnDefs: columnDefinitions,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            _this.gridApi.grid.registerRowsProcessor(processGridFilter, 200);
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
    //===================//
    // Template Response //
    //===================//
    this.disableOKButton = function () {
        return _this.gridApi.selection.getSelectedRows().length === 0;
    };
    this.onOK = function () {
        _this.close({
            $value: _this.gridApi.selection.getSelectedRows()
        });
    };
    this.cancel = (function () {
        _this.dismiss({ $value: 'cancel' });
    });
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        getData();
    };
}
angular.module('prism-ui.package').component('aliasesModal', {
    templateUrl: 'package/editor/components/modals/aliases/aliases-modal-template.html',
    controller: AliasesModalController,
    bindings: {
        close: '&',
        dismiss: '&',
        resolve: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
function BrandingDistributionOverridesModalController(PermissionsService) {
    //======//
    // Data //
    //======//
    var _this = this;
    var getWritePermission = function () {
        return PermissionsService.getPermissionsForViewState(_this.resolve.viewState)
            .then(function (viewStatePerm) {
            _this.overrideContext.canWriteOverrides = PermissionsService.hasWritePermission(viewStatePerm.permission);
        });
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.partnerPackage = _this.resolve.partnerPackage;
        _this.overrideContext = {
            packageObject: _this.resolve.packageObject,
            viewState: _this.resolve.viewState,
            readOnly: _this.resolve.readOnly,
            canWriteOverrides: false,
        };
        getWritePermission();
        _this.overrideAssetDescriptors = {
            watermark: {
                displayName: 'Watermark',
                seasonVolumeFlagPropertyName: 'watermarkSeasonVolume',
                basePropertyName: 'watermark',
                overridePropertyName: 'watermarkOverride',
                overrideFlagPropertyName: 'watermarkOverridden',
                containerAssetsPropertyName: 'assets',
                previewPropertyDescriptors: [
                    {
                        label: 'Watermark',
                        subPropertyName: null,
                    },
                ],
            },
            preRoll: {
                displayName: 'Preroll',
                seasonVolumeFlagPropertyName: 'preRollSeasonVolume',
                basePropertyName: 'preRoll',
                overridePropertyName: 'preRollOverride',
                overrideFlagPropertyName: 'preRollOverridden',
                containerAssetsPropertyName: 'assets',
                previewPropertyDescriptors: [
                    {
                        label: 'Preroll',
                        subPropertyName: null,
                    },
                ],
            },
            postRoll: {
                displayName: 'Postroll',
                seasonVolumeFlagPropertyName: 'postRollSeasonVolume',
                basePropertyName: 'postRoll',
                overridePropertyName: 'postRollOverride',
                overrideFlagPropertyName: 'postRollOverridden',
                containerAssetsPropertyName: 'assets',
                previewPropertyDescriptors: [
                    {
                        label: 'Postroll',
                        subPropertyName: null,
                    },
                ],
            },
            breakPrePostRoll: {
                displayName: 'Break Pre/Postroll',
                //
                // 2017-Nov-14 - Uncomment the following line to
                // enable season/volume break pre and post rolls
                // once they are supported
                //
                // seasonVolumeFlagPropertyName: 'breakPrePostRollSeasonVolume',
                basePropertyName: 'breakPrePostRoll',
                overridePropertyName: 'breakPrePostRollOverride',
                overrideFlagPropertyName: 'breakPrePostRollOverridden',
                containerAssetsPropertyName: 'breakPrePostRolls',
                previewPropertyDescriptors: [
                    {
                        label: 'Preroll',
                        subPropertyName: 'preRoll',
                    },
                    {
                        label: 'Postroll',
                        subPropertyName: 'postRoll',
                    },
                ],
            },
        };
    };
}
angular
    .module('prism-ui.package')
    .component('brandingDistributionOverridesModal', {
    controller: BrandingDistributionOverridesModalController,
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&',
    },
    templateUrl: 'package/editor/components/modals/brandingDistributionOverrides/branding-distribution-overrides-modal-template.html',
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: branding-distribution-overrides-selector-component.ts
 *
 * Created by randysorensen on 11/7/17.
 */
'use strict';
function BrandingDistributionOverridesSelectorController(_, $q, ModalService, ContentResourceFactory, NetworkResourceFactory, PackageResourceFactory, UtilsService) {
    var _this = this;
    var NoneAsset = {
        id: null,
        name: '(None)',
    };
    var overridden = function () {
        return _this.partnerPackage[_this.overrideAssetDescriptor.overrideFlagPropertyName];
    };
    //======//
    // Data //
    //======//
    var queryBranding = function (packageObject, containerType, destination) {
        return $q.all({
            contentBrandingContainers: ContentResourceFactory.getBranding({
                id: packageObject.content.id,
                view: containerType,
            }).$promise,
            networkBrandingContainers: NetworkResourceFactory.getBranding({
                id: packageObject.content.network.id,
                view: containerType,
            }).$promise,
        }).then(function (brandingData) {
            var addAvailableContainer = function (container) {
                destination.push(container);
            };
            _.forEach(brandingData.networkBrandingContainers, addAvailableContainer);
            _.forEach(brandingData.contentBrandingContainers, addAvailableContainer);
            return destination;
        });
    };
    var getAvailableContainers = function () {
        _this.availableContainers = [NoneAsset];
        switch (_this.overrideAssetType) {
            case 'watermark':
                // watermarks still use old API
                PackageResourceFactory.query({
                    id: _this.partnerPackage.packageId,
                    sub: 'watermarksByContent',
                }).$promise.then(function (availableWatermarkContainers) {
                    _this.availableContainers = _this.availableContainers.concat(availableWatermarkContainers);
                });
                break;
            // listing all of the cases, while shunting them to
            // default, just for readability/clarity
            case 'preRoll':
            case 'postRoll':
            case 'breakPrePostRoll':
            default:
                queryBranding(_this.overrideContext.packageObject, _this.overrideAssetType + 's', _this.availableContainers);
                break;
        }
    };
    //================//
    // Template Logic //
    //================//
    this.dropDownEnabled = function () {
        return overridden() &&
            _this.overrideContext.canWriteOverrides &&
            !_this.overrideContext.readOnly;
    };
    this._viewProperty = function (newProp) {
        var overrideProp = _this.overrideAssetDescriptor.overridePropertyName;
        var baseProp = _this.overrideAssetDescriptor.basePropertyName;
        // set the container if a new one is provided (setter)
        if (newProp) {
            if (overridden()) {
                if (UtilsService.compareBasic(NoneAsset, newProp) === 0) {
                    delete _this.partnerPackage[overrideProp];
                }
                else {
                    _this.partnerPackage[overrideProp] = _.cloneDeep(newProp);
                }
            }
            else {
                console.warn("selector modified but should be disabled");
            }
        }
        // grab the correct container
        var container;
        if (overridden()) {
            container = _this.partnerPackage[overrideProp];
        }
        else {
            // make sure there's no stale overridden property - it
            // should default to the original from the
            // subscription
            _this.partnerPackage[overrideProp] = _.cloneDeep(_this.partnerPackage.subscription[baseProp]);
            container = _this.partnerPackage.subscription[baseProp];
        }
        // return the container (getter)
        if (!container) {
            return NoneAsset;
        }
        else {
            var containerName_1 = container.name;
            return _this.availableContainers.filter(function (availableContainer) {
                return availableContainer.name === containerName_1;
            })[0];
        }
    };
    this._viewAssetSeasonVolumeFlag = function (newFlag) {
        var flagPropName = _this.overrideAssetDescriptor.seasonVolumeFlagPropertyName;
        if (newFlag !== undefined) {
            if (overridden()) {
                _this.partnerPackage[flagPropName] = newFlag;
            }
            else {
                console.warn("season/volume flag modified but should be disabled");
            }
        }
        if (overridden()) {
            return _this.partnerPackage[flagPropName];
        }
        else {
            // make sure there's no stale season/volume flag on
            // the partner package - it should default to the
            // original from the subscription
            _this.partnerPackage[flagPropName] = _this.partnerPackage.subscription[flagPropName];
            return _this.partnerPackage.subscription[flagPropName];
        }
    };
    this.seasonVolumeCBEnabled = function () {
        return overridden() &&
            _this.overrideContext.packageObject.content.type === 'Series' &&
            _this._viewProperty() &&
            !_this._viewProperty().networkId &&
            _this.overrideContext.canWriteOverrides &&
            !_this.overrideContext.readOnly;
    };
    this.previewEnabled = function () {
        return true;
    };
    var getSeasonVolumePreviewAsset = function (type, assetPool) {
        var assetsFound = assetPool.filter(function (asset) {
            return asset[type + 'Id'] === _this.overrideContext.packageObject[type].id;
        });
        return assetsFound.length > 0 ? assetsFound[0] : null;
    };
    var getNonSeasonVolumePreviewAsset = function (assetPool) {
        var assetsFound = assetPool.filter(function (asset) {
            return !asset.volumeId && !asset.seasonId;
        });
        return assetsFound.length > 0 ? assetsFound[0] : null;
    };
    this.getPreviewInfo = function (previewInfo) {
        var assetPool = _this._viewProperty()[_this.overrideAssetDescriptor.containerAssetsPropertyName];
        var sv = _this._viewAssetSeasonVolumeFlag();
        var assetObject;
        if (sv) {
            if (_this.partnerPackage.subscription.seasonSubscription) {
                assetObject = getSeasonVolumePreviewAsset('season', assetPool);
            }
            else {
                assetObject = getSeasonVolumePreviewAsset('volume', assetPool);
            }
        }
        if (!assetObject) {
            assetObject = getNonSeasonVolumePreviewAsset(assetPool);
        }
        if (previewInfo.subPropertyName) {
            return assetObject[previewInfo.subPropertyName];
        }
        else {
            return assetObject;
        }
    };
    this.openMediaModal = function ($event, assetInfo) {
        ModalService.showMediaModal(assetInfo.watermarkId ? 'watermark' : 'video', assetInfo);
        $event.currentTarget.blur();
    };
    this.getDefaultLabel = function () {
        var defaultContainer = _this.partnerPackage.subscription[_this.overrideAssetDescriptor.basePropertyName];
        var defaultLabel = {
            name: '',
            svLabel: '',
        };
        if (defaultContainer) {
            var defaultContainerSV = _this.partnerPackage.subscription[_this.overrideAssetDescriptor.seasonVolumeFlagPropertyName];
            defaultLabel.name = defaultContainer.name;
            if (defaultContainerSV) {
                defaultLabel.svLabel = _this.partnerPackage.subscription.seasonSubscription ? '(Season)' : '(Volume)';
            }
        }
        else {
            defaultLabel.name = NoneAsset.name;
        }
        return defaultLabel;
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        if (!_this.partnerPackage[_this.overrideAssetDescriptor.basePropertyName]) {
            _this.partnerPackage[_this.overrideAssetDescriptor.basePropertyName] = _.cloneDeep(NoneAsset);
        }
        getAvailableContainers();
    };
}
angular
    .module('prism-ui.package')
    .component('brandingDistributionOverridesSelector', {
    controller: BrandingDistributionOverridesSelectorController,
    bindings: {
        overrideContext: '=',
        overrideAssetDescriptor: '=',
        overrideAssetType: '=',
        partnerPackage: '=',
    },
    templateUrl: 'package/editor/components/modals/brandingDistributionOverrides/branding-distribution-overrides-selector-template.html',
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by richardwilliams on 6/23/15.
 */
'use strict';
function CollaboratorAddModalController($routeParams, $filter, PaginationService, ModalService, CollaboratorsResourceFactory, CollaboratorsService, $location, DynamicPropertiesService, UtilsService) {
    var _this = this;
    var getCollaborators = function () {
        if (_this.resolve.type === 'crew' || _this.resolve.showContentCollaborators) {
            _this.loadingIndicator.show = true;
            var offset = _this.pagingOptions.pageSize * (_this.pagingOptions.currentPage - 1);
            _this.selectedRows = [];
            var queryOpts = {
                fetchOffset: offset,
                fetchLimit: _this.pagingOptions.pageSize
            };
            if (_this.searchText && _this.searchText.length) {
                queryOpts.searchString = _this.searchText;
            }
            var handleGridDataQuery = function (collaborators, responseHeaders) {
                PaginationService.parseResponseHeaders(responseHeaders());
                if (_this.resolve.savedRoles) {
                    _.forEach(collaborators, function (collaborator) {
                        _this.createRoleSelections(collaborator);
                    });
                }
                _this.gridOptions.data = collaborators;
                _this.originalData = angular.copy(collaborators);
                PaginationService.pageData = collaborators;
                _this.loadingIndicator.show = false;
            };
            CollaboratorsService.getAllCollaborators(queryOpts, handleGridDataQuery);
        }
        else {
            _this.gridOptions.data = _this.resolve.collaborators;
            _this.originalData = angular.copy(_this.resolve.collaborators);
        }
    };
    this.saveNewCollab = function (newCollab) {
        if (_this.resolve.showContentCollaborators) {
            CollaboratorsService.saveNewCollaborator(newCollab.collaborator).then(function (collaborator) {
                var contentPathParam = (_this.resolve.isSeries) ? 'series' : 'movies';
                var actor = {
                    type: 'Actor',
                    collaborator: collaborator,
                    contentId: $routeParams.id,
                    character: _.get(newCollab, 'collaborator.character')
                };
                CollaboratorsService.newActor = actor;
                if (_.isNil(_.get(newCollab, 'collaborator.character'))) {
                    $location.url("/meta/" + contentPathParam + "/edit/" + $routeParams.id + "/actor/edit/-1");
                }
                else {
                    CollaboratorsService.saveContentActor({ id: $routeParams.id }, CollaboratorsService.newActor).then(function (data) {
                        CollaboratorsService.originalEditData = angular.copy(data);
                        _.set(collaborator, 'character', _.get(newCollab, 'collaborator.character'));
                        CollaboratorsService.newActor = null;
                        _this.close({ $value: [collaborator] });
                    });
                }
            });
        }
        else {
            CollaboratorsService.saveNewCollaborator(_.get(newCollab, 'collaborator')).then(function (collaborator) {
                var selectedRoles = _.toArray(_.get(newCollab, 'selectedRoles'));
                if (!_.isEmpty(selectedRoles)) {
                    collaborator.collaboratorRoleSelection = selectedRoles.map(function (role) {
                        return { name: role };
                    });
                }
                _this.close({ $value: [collaborator] });
            });
        }
    };
    var checkToSaveNewCollaborator = function (newCollabData) {
        var newCollab = _.get(newCollabData, 'newCrewCollab');
        if (!_.isNil(newCollab)) {
            if (_.get(newCollabData, 'actorIsSelf')) {
                _.set(newCollab, 'collaborator.character', 'Self');
            }
            _this.loadingIndicator.show = true;
            var criteria = {
                fetchOffset: 0,
                fetchLimit: 100,
                searchString: _.get(newCollab, 'collaborator.displayName')
            };
            CollaboratorsService.getAllCollaborators(criteria).then(function (collaborators) {
                // CHeck if there is a collaborator in the system with the same name
                var alreadyExistingCollaborator = _.find(collaborators, function (collab) {
                    return _.isEqual(_.get(collab, 'displayName'), _.get(newCollab, 'collaborator.displayName'));
                });
                // if the collaborator already exists, prompt the user to overwrite it or to cancel
                if (!_.isNil(alreadyExistingCollaborator)) {
                    ModalService.showMessageModal({
                        messageText: 'A collaborator with this display name already exists in the system, would you like to continue to create a duplicate?',
                        title: 'Duplicate Collaborator Found',
                        showOK: true
                    }, function () {
                        _this.saveNewCollab(newCollab);
                    }, function () {
                        _this.loadingIndicator.show = false;
                        _this.newCollaborator();
                    });
                }
                else {
                    _this.saveNewCollab(newCollab);
                }
            });
        }
        else {
            _this.newCollaborator();
        }
    };
    var onPaginationChanged = function () {
        getCollaborators();
    };
    var collaboratorRoleColumns = [
        {
            name: 'checkMarkRowHeaderCol',
            field: 'checkMark',
            width: 30,
            enableColumnMenu: false,
            enableSorting: false,
            cellTemplate: 'components/visual/grid/check-mark-template.html',
            headerCellTemplate: 'package/editor/components/modals/collaborators/grid-checkbox-header-template.html'
        },
        {
            field: 'displayName',
            width: '40%',
            displayName: 'DisplayName',
            sort: { direction: 'asc', priority: 0 },
            enableColumnMenu: false
        },
        {
            field: 'nickname',
            width: '20%',
            displayName: 'Nickname',
            enableColumnMenu: false
        },
        {
            field: 'iMDbNumber',
            enableColumnMenu: false,
            name: 'imdbColumn',
            displayName: 'IMDB#',
            width: '35%',
            enableSorting: false,
            enableColumnResizing: false,
            cellTemplate: 'components/visual/grid/hyperlink-template.html'
        }
    ];
    var actorColumns = [
        {
            name: 'checkMarkRowHeaderCol',
            field: 'checkMark',
            width: 30,
            enableColumnMenu: false,
            enableSorting: false,
            cellTemplate: 'components/visual/grid/check-mark-template.html',
            headerCellTemplate: 'package/editor/components/modals/collaborators/grid-checkbox-header-template.html'
        },
        {
            field: 'collaborator.displayName',
            width: '40%',
            displayName: 'DisplayName',
            sort: { direction: 'asc', priority: 0 },
            enableColumnMenu: false
        },
        {
            field: 'collaborator.nickname',
            width: '20%',
            displayName: 'Nickname',
            enableColumnMenu: false
        },
        {
            field: 'character',
            width: '35%',
            displayName: 'Character',
            enableColumnMenu: false
        }
    ];
    var crewColumns = [
        {
            name: 'checkMarkRowHeaderCol',
            field: 'checkMark',
            width: 30,
            enableColumnMenu: false,
            enableSorting: false,
            cellTemplate: 'components/visual/grid/check-mark-template.html',
            headerCellTemplate: 'package/editor/components/modals/collaborators/grid-checkbox-header-template.html'
        },
        {
            field: 'displayName',
            width: '46%',
            displayName: 'DisplayName',
            sort: { direction: 'asc', priority: 0 },
            enableColumnMenu: false
        },
        {
            field: 'nickname',
            width: '24%',
            displayName: 'Nickname',
            enableColumnMenu: false
        },
        {
            field: 'collaboratorRoleDropdownElements',
            width: '26%',
            enableColumnMenu: false,
            displayName: 'Role',
            cellTemplate: 'package/editor/components/modals/collaborators/role-grid-cell-template.html'
        }
    ];
    this.searchText = '';
    this.selectedRows = [];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableRowSelection: true,
        enableSelectAll: true,
        enableColumnMenu: false,
        multiSelect: this.resolve.allowMultiSelect,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            _this.gridApi.selection.on.rowSelectionChanged(null, _this.gridRowSelectionChangedHandler);
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
    };
    this.getAvailableRoles = function () {
        return DynamicPropertiesService.getPropValueAsList('package.crewMemberRoles');
    };
    this.createRoleSelections = function (collab) {
        var currentRoles = _this.resolve.savedRoles[parseInt(collab.id)];
        var idSuffix = 0;
        collab.collaboratorRoleDropdownElements = [];
        angular.forEach(_this.availableRoles, function (availableRole) {
            collab.collaboratorRoleDropdownElements.push({
                id: collab.displayName + idSuffix++,
                name: availableRole,
                disabled: !!(currentRoles && currentRoles.indexOf(availableRole) > -1)
            });
        });
    };
    this.toggleRows = function (evt) {
        if (_this.gridApi.selection.selectAll) {
            _this.gridApi.selection.clearSelectedRows(evt);
            _this.gridApi.selection.selectAll = false;
        }
        else {
            _this.gridApi.selection.selectAllVisibleRows(evt);
            _this.gridApi.selection.selectAll = true;
        }
        _this.selectedRows = _this.gridApi.selection.getSelectedRows();
    };
    this.gridRowSelectionChangedHandler = function (row) {
        if (row.isSelected) {
            _this.selectedRows.push(row.entity);
        }
        else {
            var index = _this.selectedRows.indexOf(row.entity);
            _this.selectedRows.splice(index, 1);
        }
    };
    this.executeSearch = function (event) {
        var canPerformSearchFromKeyCode = true;
        if (event) {
            canPerformSearchFromKeyCode = UtilsService.canPerformSearchFromKeyCode(event);
        }
        if (canPerformSearchFromKeyCode && (_this.resolve.type === 'crew' || _this.resolve.showContentCollaborators)) {
            getCollaborators();
        }
        else if (!_this.resolve.showContentCollaborators) {
            var searchFields = ['character', 'collaborator.displayName', 'collaborator.nickName', 'collaborator.iMDbNumber'];
            _this.gridOptions.data = $filter('gridSearch')(_this.originalData, _this.searchText, searchFields);
        }
    };
    this.disableOKButton = function () {
        return _this.selectedRows.length === 0;
    };
    this.newCollaborator = function () {
        ModalService.showNewCrewCollaboratorModal(_this.resolve.showContentCollaborators, checkToSaveNewCollaborator);
    };
    this.paginationPrevPageHandler = function () {
        --_this.pagingOptions.currentPage;
        onPaginationChanged();
    };
    this.paginationNextPageHandler = function () {
        ++_this.pagingOptions.currentPage;
        onPaginationChanged();
    };
    this.paginationJumpToPageHandler = function () {
        onPaginationChanged();
    };
    this.showPaginationControls = function () { return _this.resolve.type === 'crew' || _this.resolve.showContentCollaborators; };
    this.pageSizeChangeHandler = function () {
        onPaginationChanged();
    };
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        if (_this.resolve.type === 'actors') {
            if (_this.resolve.showContentCollaborators) {
                _this.gridOptions.columnDefs = collaboratorRoleColumns;
            }
            else {
                _this.gridOptions.columnDefs = actorColumns;
            }
        }
        else {
            _this.gridOptions.columnDefs = crewColumns;
        }
        _this.pagingOptions = PaginationService;
        PaginationService.pageDataResource = CollaboratorsResourceFactory;
        _this.loadingIndicator.show = true;
        DynamicPropertiesService.queryForProperties()
            .then(function () {
            _this.availableRoles = _this.getAvailableRoles();
            return getCollaborators();
        })
            .finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
}
angular.module('prism-ui.package').component('collaboratorAddModal', {
    templateUrl: 'package/editor/components/modals/collaborators/collaborator-add-modal-template.html',
    controller: CollaboratorAddModalController,
    bindings: {
        close: '&',
        dismiss: '&',
        resolve: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 6/15/15.
 */
'use strict';
function CompletedDeliveriesModalController(_) {
    //================//
    // Template Logic //
    //================//
    var _this = this;
    this.onOk = function () {
        _this.dismiss();
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: ' ',
            message: ' '
        };
    };
}
angular
    .module('prism-ui.package')
    .component('completedDeliveriesModal', {
    controller: CompletedDeliveriesModalController,
    templateUrl: 'package/editor/components/modals/completedDeliveries/completed-deliveries-modal-template.html',
    bindings: {
        resolve: '<',
        dismiss: '&',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 6/5/15.
 */
'use strict';
function ErrorsWarningsModalController(_, $timeout) {
    var _this = this;
    var gridOptions = {
        enableSorting: false,
        enableFiltering: false,
        enableColumnMenus: false,
        showTreeExpandNoChildren: false,
        showHeader: false,
        rowHeight: 26,
        treeRowHeaderBaseWidth: 10,
        columnDefs: [
            {
                name: 'label',
                cellTooltip: true,
                cellTemplate: 'package/editor/components/modals/errorsWarnings/errors-warnings-tree-cell-template.html'
            }
        ],
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
        }
    };
    var parseValidationResult = function () {
        var allList = [];
        var warningList = [];
        var errorList = [];
        var results = _this.resolve.validationResults;
        angular.forEach(results, function (result) {
            var rootNode = {
                label: result.source,
                $$treeLevel: 0,
                type: (result.errors.length) ? 'error' : 'warning'
            };
            allList.push(rootNode);
            if (result.errors.length) {
                errorList.push(rootNode);
            }
            if (result.warnings.length) {
                var warningRootNode = angular.copy(rootNode);
                warningRootNode.type = 'warning';
                warningList.push(warningRootNode);
            }
            angular.forEach(result.warnings, function (warning) {
                var warnNode = { label: warning.description, $$treeLevel: 1, type: 'warning' };
                allList.push(warnNode);
                warningList.push(warnNode);
            });
            angular.forEach(result.errors, function (error) {
                var errorNode = {
                    label: error.description,
                    $$treeLevel: 1,
                    type: 'error'
                };
                if (error.member === 'mvpd') {
                    errorNode.label = _.split(error.description, ':')[0];
                    allList.push(errorNode);
                    errorList.push(errorNode);
                    var mvpdErrors = _.split(_.split(error.description, ':')[1], ',');
                    _.forEach(mvpdErrors, function (error) {
                        var mvpdErrorNode = {
                            label: error,
                            $$treeLevel: 2,
                            type: 'error'
                        };
                        allList.push(mvpdErrorNode);
                        errorList.push(mvpdErrorNode);
                    });
                }
                else {
                    allList.push(errorNode);
                    errorList.push(errorNode);
                }
            });
        });
        _this.combinedOptions.data = allList;
        _this.errorsOptions.data = errorList;
        _this.warningsOptions.data = warningList;
    };
    this.activateTab = function (tab) {
        _this.currentTab = tab;
        $timeout(function () {
            _this.gridApi.treeBase.expandAllRows();
        }, 50);
    };
    this.onOk = function () {
        if (_this.resolve.showCancel) {
            _this.close({ $value: 'ok' });
        }
        else {
            _this.dismiss({ $value: 'cancel' });
        }
    };
    this.onCancel = function () {
        _this.dismiss({ $value: 'cancel' });
    };
    this.$onInit = function () {
        _this.combinedOptions = angular.copy(gridOptions);
        _this.warningsOptions = angular.copy(gridOptions);
        _this.errorsOptions = angular.copy(gridOptions);
        parseValidationResult();
        _this.activateTab('all');
    };
}
angular.module('prism-ui.package').component('errorsWarningsModal', {
    templateUrl: 'package/editor/components/modals/errorsWarnings/errors-warnings-modal-template.html',
    controller: ErrorsWarningsModalController,
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
function GroupsModalController(uiGridConstants) {
    var _this = this;
    var columnDefinitions = [
        {
            field: 'name',
            displayName: 'Name',
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];
    this.searchText = '';
    this.selectedRows = [];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: true,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: true,
        columnDefs: columnDefinitions,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            _this.gridApi.grid.registerRowsProcessor(_this.processGridFilter, 200);
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
    this.executeSearch = function () {
        _this.gridApi.grid.refresh();
    };
    this.processGridFilter = function (renderableRows) {
        renderableRows.forEach(function (row) {
            if (_.includes(_.toLower(row.entity.name), _.toLower(_this.searchText))) {
                row.visible = true;
            }
            else {
                row.visible = false;
            }
        });
        return renderableRows;
    };
    this.disableOKButton = function () {
        return _this.gridApi.selection.getSelectedRows().length === 0;
    };
    this.$onInit = function () {
        _this.gridOptions.data = _this.resolve.availableGroups;
    };
}
angular.module('prism-ui.package').component('groupsModal', {
    templateUrl: 'package/editor/components/modals/groups/groups-modal-template.html',
    controller: GroupsModalController,
    bindings: {
        close: '&',
        dismiss: '&',
        resolve: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: hierarchical-metadata-modal-component.ts
 *
 * Created by randysorensen on 11/30/17.
 */
'use strict';
function HierarchicalMetadataModalController(_, $q, $location, $anchorScroll, $filter, PermissionsService, MetadataService, PartnerPackagesService, NetworkResourceFactory, ContentResourceFactory) {
    var _this = this;
    var PACKAGE_ADVANCED_METADATA_VIEW_STATE = 'PACKAGE_ADVANCED_METADATA_VIEW_STATE';
    var typeDefs;
    var typeList;
    //======//
    // Data //
    //======//
    var getStaticMetadata = function () {
        var promises = {
            metaService: MetadataService.propertiesPromise,
        };
        promises.network = NetworkResourceFactory.get({
            id: _this.resolve.packageObject.content.network.id
        }).$promise;
        promises.content = ContentResourceFactory.get({
            id: _this.resolve.packageObject.content.id
        }).$promise;
        if (_this.resolve.packageObject.season) {
            promises.season = ContentResourceFactory.getSeason({
                id: _this.resolve.packageObject.season.id
            }).$promise;
        }
        if (_this.resolve.packageObject.volume) {
            promises.volume = ContentResourceFactory.getVolume({
                id: _this.resolve.packageObject.volume.id
            }).$promise;
        }
        $q.all(promises).then(function (viewData) {
            _.forEach(viewData, function (view, key) {
                if (key !== 'metaService') {
                    if (view.metadata) {
                        view.metadata = MetadataService.buildCustomComponentMap(view.metadata.properties);
                    }
                    _this.viewData[key] = view;
                    _this.viewData[key].show = true;
                }
            });
        });
    };
    var createTypeDefs = function (packageObject) {
        typeDefs = {};
        //
        // Properties in these typeDefs:
        //
        //      factory:
        //          the resource factory where the partner's
        //          metadata items originate
        //
        //      method:
        //          the resource factory method to use
        //
        //      id:
        //          the id criteria to use when requesting the
        //          resource
        //
        //      seasonSubscription:
        //          if undefined, this resource is applicable to
        //          both season and volume subscriptions;
        //
        //          if true, this resource is only applicable to
        //          season subscriptions;
        //
        //          if false, this resource is only applicable to
        //          volume subscriptions.
        //
        typeDefs.network = {
            factory: NetworkResourceFactory,
            method: 'get',
            id: packageObject.content.network.id,
            seasonSubscription: undefined,
        };
        typeDefs.content = {
            factory: ContentResourceFactory,
            method: 'get',
            id: packageObject.content.id,
            seasonSubscription: undefined,
        };
        if (packageObject.season) {
            typeDefs.season = {
                factory: ContentResourceFactory,
                method: 'getSeason',
                id: packageObject.season.id,
                seasonSubscription: true,
            };
        }
        if (packageObject.volume) {
            typeDefs.volume = {
                factory: ContentResourceFactory,
                method: 'getVolume',
                id: packageObject.volume.id,
                seasonSubscription: false,
            };
        }
        typeList = _.keys(typeDefs);
    };
    var getPartnerItemValues = function (partnerPackages) {
        var partnerPackageLookup = _.keyBy(partnerPackages, 'partner.name');
        _this.partnerList = _.map(partnerPackages, 'partner');
        // get each partner's MVPD item values for each type
        var partnerMVPDPromises = {};
        _.forEach(typeDefs, function (typeDef, typeName) {
            partnerMVPDPromises[typeName] = {};
            _.forEach(_this.partnerList, function (partner) {
                if (typeDef.seasonSubscription === undefined ||
                    typeDef.seasonSubscription === partnerPackageLookup[partner.name].subscription.seasonSubscription) {
                    partnerMVPDPromises[typeName][partner.name] = typeDef.factory[typeDef.method]({
                        id: typeDef.id,
                        mvpdPartnerId: partner.id,
                    }).$promise;
                }
            });
        });
        return $q.all({
            network: $q.all(partnerMVPDPromises.network),
            content: $q.all(partnerMVPDPromises.content),
            season: $q.all(partnerMVPDPromises.season),
            volume: $q.all(partnerMVPDPromises.volume),
        });
    };
    var transformPartnerItemValues = function (mvpdItemsByTypeAndPartner) {
        var partnerHasMVPDItems = {};
        // build a by-partner item lookup for each
        // metadata type
        _.forEach(typeList, function (type) {
            _.forEach(mvpdItemsByTypeAndPartner[type], function (partnerMVPDItems, partnerName) {
                if (_.keys(_.get(partnerMVPDItems, 'metadata.properties')).length > 0) {
                    partnerHasMVPDItems[partnerName] = true;
                    _this.partnerMVPDProperties[type][partnerName] =
                        MetadataService.buildCustomComponentMap(partnerMVPDItems.metadata.properties, [], true);
                }
            });
        });
        // partner list gets trimmed to only partners who have
        // MVPD data
        _.remove(_this.partnerList, function (partner) {
            return !partnerHasMVPDItems[partner.name];
        });
    };
    var getMVPDMetadata = function () {
        return MetadataService.propertiesPromise
            .then(function () {
            // get list of partners relevant to this package
            return PartnerPackagesService.queryPartnerPackages(_this.resolve.packageObject.id, _this.resolve.packageObject);
        })
            .then(getPartnerItemValues)
            .then(transformPartnerItemValues);
    };
    var getPermissions = function () {
        return PermissionsService.canRead(PACKAGE_ADVANCED_METADATA_VIEW_STATE);
    };
    //================//
    // Template Logic //
    //================//
    this.getMetadataValue = function (item) {
        var result = '';
        if (item && item.instanceData) {
            switch (item.uiControlHint) {
                case 'CheckboxList':
                    // Multi Picklists
                    result = _
                        .chain(item.picklistItems)
                        .filter(function (picklistItem) {
                        return _.includes(item.instanceData.value, picklistItem.id);
                    })
                        .map('displayName')
                        .join(', ')
                        .value();
                    break;
                case 'DropDownList':
                case 'List':
                    // Single Picklists
                    result = _.filter(item.picklistItems, function (picklistItem) {
                        return picklistItem.id === item.instanceData.value;
                    });
                    result = result.length > 0 ? result[0].displayName : '';
                    break;
                case 'DateField':
                case 'DateFieldEnhanced':
                case 'DateTimeField':
                case 'DateTimeFieldEnhanced':
                    result = $filter('amDateFormat')(item.instanceData.value, 'MMMM DD, YYYY, h:mm A');
                    break;
                case 'TextListInput':
                    // Dynamic Picklists
                    result = _
                        .chain(item.instanceData.value)
                        .map('stringValue')
                        .join('|')
                        .value();
                    break;
                default:
                    // All others
                    result = item.instanceData.value;
            }
        }
        return result;
    };
    this.onNavigate = function ($event, anchorId) {
        $event.target.blur();
        $location.hash(anchorId);
        $anchorScroll();
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.viewData = {
            network: {},
            content: {},
            season: {},
            volume: {},
        };
        _this.partnerMVPDProperties = {
            network: {},
            content: {},
            season: {},
            volume: {},
        };
        _this.loadingIndicator.show = true;
        // this promise chain could probably be reworked to be
        // clearer...
        getPermissions()
            .then(function (perms) {
            if (perms) {
                getStaticMetadata();
                createTypeDefs(_this.resolve.packageObject);
                getMVPDMetadata()
                    .then(function () {
                    // select partner 0 by default
                    if (_this.partnerList.length > 0) {
                        _this.selectedPartner = _this.partnerList[0].name;
                    }
                    _this.loadingIndicator.show = false;
                });
            }
        });
    };
    this.$onDestroy = function () {
        // clear the anchor so the scrollbar starts at the top the
        // next time the modal is opened
        $location.hash(null);
    };
}
angular
    .module('prism-ui.package')
    .component('hierarchicalMetadataModal', {
    controller: HierarchicalMetadataModalController,
    templateUrl: 'package/editor/components/modals/hierarchicalMetadata/hierarchical-metadata-modal-template.html',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&',
    },
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: completed-deliveries-component.ts
 *
 * Created by randysorensen on 2/20/18.
 */
function CompletedDeliveriesController(_, $q, $filter, EndPointService, AuthFactory, PermissionsService, PackageService, UtilsService) {
    //================//
    // Template Logic //
    //================//
    var _this = this;
    var getMasterMetadataURL = function (job) {
        return EndPointService.reportEndpoint + '/masterMetadataXml/' + job.id;
    };
    var getPartnerMetadataURL = function (file) {
        return EndPointService.reportEndpoint + '/partnerMetadataXml/' + file.id;
    };
    var getPartnerProxyURL = function (file) {
        return EndPointService.mediaAssetEndpoint + '?contentId=' + file.proxyId;
    };
    var getPartnerQCReportURL = function (file) {
        return EndPointService.mediaAssetEndpoint + '?contentId=' + file.qcReportId;
    };
    var getAuthenticatedURL = function (link) {
        var delimiter = _.includes(link, '?') ? '&' : '?';
        return link + delimiter + AuthFactory.getAuthQueryString();
    };
    this.downloadFile = function (url) {
        window.open(url);
    };
    //======//
    // Grid //
    //======//
    this.gridOptions = {
        enableSorting: false,
        enableFiltering: false,
        enableColumnMenus: false,
        showTreeExpandNoChildren: false,
        treeRowHeaderBaseWidth: 12,
        rowTemplate: 'package/editor/components/shared/completedDeliveries/gridTemplates/delivery-row-template.html',
        data: [],
        columnDefs: [
            //
            // The "Delivery" column serves a few purposes.
            //
            // The top level of each tree node in the modal is
            // used for each partner that the package has been
            // delivered to in the past.
            //
            // When expanding this top-level tree node, the first
            // "level" is a date/time on which a full delivery to
            // this partner was completed. It is indented 12
            // pixels.
            //
            // When expanding that, each file asset that was
            // delivered to the partner in that partner delivery
            // workflow is shown. This column shows that file's
            // completion date/time. It is indented 24 pixels.
            //
            {
                name: 'delivery',
                displayName: 'Delivery',
                width: '27%',
                cellTemplate: 'package/editor/components/shared/completedDeliveries/gridTemplates/delivery-cell-template.html',
            },
            {
                name: 'metadata',
                displayName: 'Meta',
                width: '6%',
                cellTemplate: 'components/visual/grid/text-file-download-template.html',
            },
            {
                name: 'proxy',
                displayName: 'Proxy',
                width: '6%',
                cellTemplate: 'components/visual/grid/video-file-download-template.html',
            },
            {
                name: 'qcReport',
                displayName: 'QC',
                width: '6%',
                cellTemplate: 'components/visual/grid/pdf-file-download-template.html',
            },
            {
                name: 'fileAsset',
                displayName: 'File/Asset',
                width: '*',
                cellTemplate: 'components/visual/grid/read-only-text-input-template.html'
            },
            {
                name: 'preDeliveryValidationFlag',
                displayName: 'Validator (Pre-Delivery)',
                width: '6%',
                cellTemplate: 'components/visual/grid/predelivery-validate-icon-template.html',
            },
            {
                name: 'preDeliveryApprovalFlag',
                displayName: 'QC Approval (Pre-Delivery)',
                width: '6%',
                cellTemplate: 'components/visual/grid/predelivery-approval-icon-template.html',
            }
        ],
    };
    //======//
    // Data //
    //======//
    var formatDate = function (dateStr) {
        return $filter('amDateFormat')(dateStr, 'MMMM DD, YYYY, h:mm A');
    };
    var completionDateSortFunction = function (event0, event1) {
        var completionDate0 = _.get(event0, 'completionDate');
        var completionDate1 = _.get(event1, 'completionDate');
        return UtilsService.dateCompare(completionDate0, completionDate1);
    };
    var partnerNameSortFunction = function (delivery0, delivery1) {
        var partnerName0 = _.get(delivery0, 'partnerName');
        var partnerName1 = _.get(delivery1, 'partnerName');
        return UtilsService.caseInsensitiveStringCompare(partnerName0, partnerName1);
    };
    var addDeliveredFile = function (file, treeLevel) {
        _this.gridOptions.data.push({
            delivery: formatDate(file.completionDate),
            isFile: true,
            fileAsset: file.fileName,
            metadata: file.metadataAvailable ? getAuthenticatedURL(getPartnerMetadataURL(file)) : '',
            proxy: file.proxyId ? getAuthenticatedURL(getPartnerProxyURL(file)) : '',
            qcReport: file.qcReportId ? getAuthenticatedURL(getPartnerQCReportURL(file)) : '',
            preDeliveryValidationFlag: file.preDeliveryValidationFlag,
            preDeliveryApprovalFlag: file.preDeliveryApprovalFlag,
            $$treeLevel: treeLevel,
        });
    };
    var addDeliveryJob = function (job, treeLevel) {
        _this.gridOptions.data.push({
            delivery: formatDate(job.completionDate),
            isJob: true,
            metadata: _this.adminFlag && job.metadataAvailable ? getAuthenticatedURL(getMasterMetadataURL(job)) : '',
            $$treeLevel: treeLevel,
        });
        job.filesDelivered.sort(completionDateSortFunction);
        _.forEach(job.filesDelivered, function (deliveredFile) {
            addDeliveredFile(deliveredFile, treeLevel + 1);
        });
    };
    var addDelivery = function (delivery, treeLevel) {
        _this.gridOptions.data.push({
            delivery: delivery.partnerName,
            top: treeLevel === 0,
            $$treeLevel: treeLevel,
        });
        if (delivery.childDeliveries) {
            delivery.childDeliveries.sort(partnerNameSortFunction);
            _.forEach(delivery.childDeliveries, function (childDelivery) {
                addDelivery(childDelivery, treeLevel + 1);
            });
        }
        else {
            delivery.deliveryJobs.sort(completionDateSortFunction);
            _.forEach(delivery.deliveryJobs, function (childDelivery) {
                addDeliveryJob(childDelivery, treeLevel + 1);
            });
        }
    };
    var getSuperPartnerNames = function (completedDeliveries) {
        var superPartners = _.chain(completedDeliveries)
            .filter(function (delivery) { return !!delivery.parentPartnerName; })
            .map('parentPartnerName')
            .uniq()
            .value();
        return superPartners;
    };
    var createSuperPartnerDelivery = function (superPartnerName, completedDeliveries) {
        var childDeliveries = _.remove(completedDeliveries, function (completedDelivery) { return completedDelivery.parentPartnerName === superPartnerName; });
        var superPartnerDelivery = {
            partnerName: superPartnerName,
            childDeliveries: childDeliveries
        };
        return superPartnerDelivery;
    };
    var getSuperPartnerDeliveries = function (completedDeliveries) {
        var superPartnerNames = getSuperPartnerNames(completedDeliveries);
        var superPartnerDeliveries = [];
        _.forEach(superPartnerNames, function (superPartnerName) {
            var superPartnerDelivery = createSuperPartnerDelivery(superPartnerName, completedDeliveries);
            superPartnerDeliveries.push(superPartnerDelivery);
        });
        return superPartnerDeliveries;
    };
    var processCompletedDeliveries = function (completedDeliveries) {
        var superPartnerDeliveries = getSuperPartnerDeliveries(completedDeliveries);
        completedDeliveries = _.concat(completedDeliveries, superPartnerDeliveries);
        completedDeliveries.sort(partnerNameSortFunction);
        _.forEach(completedDeliveries, function (completedDelivery) {
            addDelivery(completedDelivery, 0);
        });
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _.set(_this, 'loadingIndicator.show', true);
        _this.adminFlag = PermissionsService.isAdmin();
        //
        // Admin flag is used to enable download links for
        // post-delivery processing artifacts, metadata and
        // possibly other items - it is _not_ used to permission
        // the completed deliveries data itself
        //
        $q.all([
            // get completed deliveries list
            PackageService.getCompletedDeliveries(_this.packageObject).then(function (completedDeliveries) {
                processCompletedDeliveries(completedDeliveries);
                _this.completedDeliveries = completedDeliveries;
            })
        ]).finally(function () {
            _.set(_this, 'loadingIndicator.show', false);
        });
    };
}
angular
    .module('prism-ui.package')
    .component('completedDeliveries', {
    controller: CompletedDeliveriesController,
    templateUrl: 'package/editor/components/shared/completedDeliveries/completed-deliveries-template.html',
    bindings: {
        packageObject: '=',
        loadingIndicator: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: package-advanced-metadata-view-component.ts
 *
 * Created by randysorensen on 11/30/17.
 */
'use strict';
function PackageAdvancedMetadataViewController(_, $q, ModalService, PackageUtilService, PermissionsService, MetadataService) {
    var _this = this;
    var PACKAGE_ADVANCED_METADATA_VIEW_STATE = 'PACKAGE_ADVANCED_METADATA_VIEW_STATE';
    //======//
    // Data //
    //======//
    var queryForPermissions = function () {
        return $q.all({
            canRead: PermissionsService.canRead(PACKAGE_ADVANCED_METADATA_VIEW_STATE),
            canWrite: PermissionsService.canWrite(PACKAGE_ADVANCED_METADATA_VIEW_STATE),
        })
            .then(function (perms) {
            _this.isAdmin = PermissionsService.isAdmin();
            _this.canRead = perms.canRead || perms.canWrite; // write implies read
            _this.canWrite = perms.canWrite;
            return perms;
        });
    };
    var composeMetadataComponents = function (packageObject) {
        _this.metadataComponentsMap = MetadataService.buildCustomComponentMap(packageObject.metadata.properties, PackageUtilService.errorsAndWarnings()[packageObject.name]);
        _this.metadataComponentsMap = _.pickBy(_this.metadataComponentsMap, function (pkgMetaProp) {
            return pkgMetaProp.advanced;
        });
    };
    var queryForData = function () {
        if (_this.canRead) {
            $q.all({
                metadataProperties: MetadataService.propertiesPromise,
            })
                .then(function (editData) {
                composeMetadataComponents(_this.packageObject);
                _this.loadingIndicator.show = false;
                return editData;
            });
        }
        else {
            _this.loadingIndicator.show = false;
        }
    };
    var packageReverted = function (packageObject) {
        composeMetadataComponents(packageObject);
    };
    var packageSaved = function () {
        PackageUtilService.createErrorsAndWarningsMap(_this.packageObject.validationResult);
        composeMetadataComponents(_this.packageObject);
    };
    //================//
    // Template Logic //
    //================//
    this.showHierarchicalMetadataModal = function () {
        ModalService.showPkgHierarchicalMetadataModal(_this.packageObject);
    };
    this.onExternalIdChange = function () {
        if (_.get(_this.packageObject, 'externalId.length') == 0)
            _this.packageObject.externalId = null;
    };
    this.clearExternalId = function () {
        _this.packageObject.externalId = null;
        _this.packageAdvancedMetadataEditorForm.$setDirty();
    };
    this.clearExternalDateUpdated = function () {
        _this.packageObject.externalDateUpdated = null;
        _this.packageAdvancedMetadataEditorForm.$setDirty();
    };
    // shared Nielsen properties list
    // property name => user-friendly label
    // order determines display order
    this.nielsenFieldLabels = {
        nielsenDsrcId: 'DSRC ID',
        nielsenDsrcName: 'DSRC Name',
        nielsenAssetId: 'Asset ID',
        nielsenAssetName: 'Asset Name',
        nielsenEpisodeId: 'Episode ID',
        nielsenSId: 'SID',
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.showHierarchicalMetadataButton = true;
        _this.canRead = false;
        _this.canWrite = false;
        _this.isAdmin = false;
        _this.loadingIndicator.show = true;
        // Set event handlers in PackageUtilService
        PackageUtilService.tabSaveFunction = null;
        PackageUtilService.tabRevertFunction = packageReverted;
        PackageUtilService.postPackageSaveFunction = packageSaved;
        queryForPermissions()
            .then(function () {
            queryForData();
        });
    };
    this.$postLink = function () {
        PackageUtilService.editorForm = _this.packageAdvancedMetadataEditorForm;
    };
}
angular
    .module('prism-ui.package')
    .component('packageAdvancedMetadataView', {
    controller: PackageAdvancedMetadataViewController,
    templateUrl: 'package/editor/components/view/advancedMetadata/package-advanced-metadata-view-template.html',
    bindings: {
        packageObject: '=',
        loadingIndicator: '=',
        pkgEditCtrl: '=',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by richardwilliams on 5/28/15.
 */
'use strict';
function PackageCollaboratorsViewController(_, $filter, $location, $q, $routeParams, $timeout, CollaboratorViewDataTransformer, ModalService, NavbarUtilService, NotificationService, PackageLiveClipViewService, PackageResourceFactory, PackageUtilService, PermissionsService, SearchFilterService) {
    var _this = this;
    var PACKAGE_COLLABORATORS_VIEW_STATE = 'PACKAGE_COLLABORATORS_VIEW_STATE';
    var CLIP_COLLABORATORS_VIEW_STATE = 'CLIP_COLLABORATORS_VIEW_STATE';
    var CLIP_TABS_VIEW_STATE = 'PACKAGE_VIDEO_CLIPS_VIEW_STATE';
    var originalCollaborators = [];
    this.collaboratorData = { actors: [], crew: [] };
    var queryId;
    var availableActorsQueryParam;
    var setQueryProperties = function () {
        if (_this.isClipCollaborators) {
            queryId = _this.packageObject.id;
            availableActorsQueryParam = 'actors';
        }
        else {
            queryId = $routeParams.id;
            availableActorsQueryParam = 'actorsByContent';
        }
    };
    var getSavedRolesMap = function () {
        var roleMap = {};
        _.forEach(_this.collaboratorData.crew, function (crewMember) {
            var roles = roleMap[crewMember.collaborator.id];
            if (!roles) {
                roles = [];
                roleMap[crewMember.collaborator.id] = roles;
            }
            roles.push(crewMember.role);
        });
        return roleMap;
    };
    var filterAvailableCollaborators = function (availableCollaborators) {
        var filteredResults = [];
        var activeCollabs = _this.collaboratorData[_this.currentTab.toLowerCase()];
        angular.forEach(availableCollaborators, function (collab) {
            var collabAlreadyAdded = $filter('filter')(activeCollabs, { id: collab.id }).length !== 0;
            if (!collabAlreadyAdded) {
                filteredResults.push(collab);
            }
        });
        return filteredResults;
    };
    var generateRoles = function (newCollabs) {
        if (_this.currentTab === 'Actors') {
            return newCollabs;
        }
        var collaboratorRoles = [];
        var savedRoles = getSavedRolesMap();
        _.forEach(newCollabs, function (collaborator) {
            angular.forEach(collaborator.collaboratorRoleSelection, function (memberRole) {
                if (savedRoles[collaborator.id] && savedRoles[collaborator.id].indexOf(memberRole.name) > -1) {
                    return;
                }
                collaboratorRoles.push({
                    type: 'Crew',
                    packageId: $routeParams.id,
                    role: memberRole.name,
                    collaborator: collaborator
                });
            });
            delete collaborator.collaboratorRoleSelection;
            delete collaborator.collaboratorRoleDropdownElements;
        });
        return collaboratorRoles;
    };
    var openConfirmModal = function (messageText, title, handler) {
        ModalService.showMessageModal({
            messageText: messageText,
            pullCancelLeft: true,
            title: title,
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, handler);
    };
    var buildCollaboratorsMap = function (collaborators) {
        var result = {
            actors: [],
            crew: [],
            disabled: {
                actors: [],
                crew: []
            }
        };
        _.forEach(collaborators, function (item) {
            var typeKey = item.type === 'Actor' ? 'actors' : 'crew';
            if (item.disabled) {
                result.disabled[typeKey].push(item);
                _this.disabledFound = true;
            }
            else {
                result[typeKey].push(item);
            }
        });
        return result;
    };
    var handleGridDataQuery = function (collabs) {
        _this.selectedRows = [];
        _this.savedCollaboratorsMap = buildCollaboratorsMap(collabs);
        _this.collaboratorData = {
            actors: _this.savedCollaboratorsMap.actors.concat(_this.savedCollaboratorsMap.disabled.actors),
            crew: _this.savedCollaboratorsMap.crew.concat(_this.savedCollaboratorsMap.disabled.crew)
        };
        originalCollaborators = angular.copy(_this.collaboratorData);
        _this.activateTab($location.search().subView || 'Actors');
    };
    var getEditData = function () {
        _this.loadingIndicator.show = true;
        var viewState = _this.isClipCollaborators ?
            CLIP_COLLABORATORS_VIEW_STATE :
            PACKAGE_COLLABORATORS_VIEW_STATE;
        var promises = {
            savedActors: PackageResourceFactory.query({ id: queryId, sub: 'actors' }).$promise,
            availableActors: PackageResourceFactory.query({ id: $routeParams.id, sub: availableActorsQueryParam }).$promise,
            clipWrite: PermissionsService.canWrite(CLIP_TABS_VIEW_STATE),
            readPerms: PermissionsService.canRead(viewState),
            writePerms: PermissionsService.canWrite(viewState)
        };
        if (!_this.isClipCollaborators) {
            promises.savedCrew = PackageResourceFactory.query({ id: queryId, sub: 'crew' }).$promise;
        }
        $q.all(promises).then(function (editData) {
            if (editData.readPerms || editData.clipWrite) {
                if (_this.isClipCollaborators) {
                    handleGridDataQuery(editData.savedActors);
                }
                else {
                    handleGridDataQuery(editData.savedActors.concat(editData.savedCrew));
                }
                _this.availableCollaboratorsMap = buildCollaboratorsMap(editData.availableActors);
                _this.hasWrite = editData.writePerms && (!_this.isClipCollaborators || (_this.isClipCollaborators && editData.clipWrite));
            }
            _this.loadingIndicator.show = false;
        });
    };
    this.currentGridOptions = {
        selectionRowHeaderColName: 'checkMarkRowHeaderCol',
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        useExternalPagination: false,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        rowHeight: 26,
        multiSelect: true,
        columnDefs: CollaboratorViewDataTransformer.actorsColumns,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged(null, _this.gridRowSelectionChangedHandler);
        },
        rowTemplate: "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" class=\"ui-grid-cell\" ui-grid-cell></div>"
    };
    this.activateTab = function (tab) {
        _this.currentTab = tab;
        var activeCollectionKey = _this.currentTab.toLowerCase();
        var columnDefKey = activeCollectionKey + "Columns";
        _this.roleTabs[activeCollectionKey] = true;
        if (!_this.isClipCollaborators) {
            $location.search('subView', _this.currentTab);
        }
        if (_this.savedCollaboratorsMap && _this.savedCollaboratorsMap[activeCollectionKey]) {
            var data = _this.savedCollaboratorsMap[activeCollectionKey].concat(_this.savedCollaboratorsMap.disabled[activeCollectionKey]);
            _this.currentGridOptions.columnDefs = CollaboratorViewDataTransformer[columnDefKey];
            _this.currentGridOptions.data = data;
            _this.gridDataCopy = angular.copy(_this.currentGridOptions.data);
        }
        _this.filter($location.search().searchText);
    };
    this.openAddCollaboratorModal = function (showDisabled) {
        var typeKey = _this.currentTab.toLowerCase();
        if (_this.currentTab === 'Actors') {
            var activeCollection = void 0;
            var disabledCollection = _this.availableCollaboratorsMap.disabled.actors;
            var enabledCollection = _this.availableCollaboratorsMap.actors;
            if (_this.isClipCollaborators) {
                activeCollection = disabledCollection.concat(enabledCollection);
            }
            else if (showDisabled) {
                activeCollection = disabledCollection;
            }
            else {
                activeCollection = enabledCollection;
            }
            ModalService.showAddCollaboratorModal(filterAvailableCollaborators(activeCollection), typeKey, _this.handleNewSelection, undefined);
        }
        else {
            ModalService.showAddCollaboratorModal([], typeKey, _this.handleNewSelection, getSavedRolesMap());
        }
    };
    this.addCollaborator = function () {
        if (!_this.isClipCollaborators && _this.packageObject.content.type === 'Series' && !_this.packageObject.season) {
            NotificationService.createWarningNotification('Before adding a collaborator, a season must be selected on the package.');
        }
        else {
            _this.openAddCollaboratorModal(false);
        }
    };
    this.addDisabledCollaborator = function () {
        if (!_this.isClipCollaborators && _this.packageObject.content.type === 'Series' && !_this.packageObject.season) {
            NotificationService.createWarningNotification('Before adding a collaborator, a season must be selected on the package.');
        }
        else {
            _this.openAddCollaboratorModal(true);
        }
    };
    this.deleteCollaborator = function () {
        var removeCollaborators = function () {
            _.forEach(_this.selectedRows, function (selectedCollaborator) {
                for (var i = 0; i < _this.collaboratorData[_this.currentTab.toLowerCase()].length; i++) {
                    if (selectedCollaborator.id === _this.collaboratorData[_this.currentTab.toLowerCase()][i].id) {
                        _this.collaboratorData[_this.currentTab.toLowerCase()].splice(i, 1);
                    }
                }
            });
        };
        var confirmResult = function () {
            removeCollaborators();
            _this.saveCollaborators();
        };
        if (_this.isClipCollaborators) {
            removeCollaborators();
            _this.currentGridOptions.data = _this.collaboratorData.actors;
            _this.setDirtyFctn();
        }
        else {
            var message = 'Are you sure you want to delete Collaborator Role(s)? ';
            var title = 'Delete Collaborator Role(s)?';
            openConfirmModal(message, title, confirmResult);
        }
    };
    this.saveCollaborators = function () {
        _this.loadingIndicator.show = true;
        var collabType = _this.currentTab.toLowerCase();
        var newCollaboratorPromise = PackageResourceFactory.saveCollaborators({ id: queryId, sub: collabType }, _this.collaboratorData[collabType]).$promise;
        newCollaboratorPromise.then(function (collaborators) {
            _this.collaboratorData[collabType] = collaborators;
            handleGridDataQuery(_this.collaboratorData.actors.concat(_this.collaboratorData.crew));
            _this.packageObject.acceptStatus = null;
            _this.packageObject.rejectReason = null;
            var packageSavePromise = PackageResourceFactory.save({ id: $routeParams.id }, _this.packageObject).$promise;
            packageSavePromise.then(function () {
                PackageUtilService.pollForPackageUpdates();
            });
            _this.loadingIndicator.show = false;
        });
        return newCollaboratorPromise;
    };
    this.handleNewSelection = function (newCollaborators) {
        var collabType = _this.currentTab.toLowerCase();
        var confirmResult = function () {
            _this.collaboratorData[collabType] = _this.collaboratorData[collabType].concat(generateRoles(newCollaborators));
            _this.saveCollaborators();
        };
        if (_this.isClipCollaborators) {
            _this.collaboratorData[collabType] = _this.collaboratorData[collabType].concat(newCollaborators);
            _this.currentGridOptions.data = _this.collaboratorData[collabType];
            _this.setDirtyFctn();
        }
        else {
            var message = 'Are you sure you want to add Collaborator Role(s)? ';
            var title = 'Add Collaborator Role(s)?';
            openConfirmModal(message, title, confirmResult);
        }
    };
    this.filter = function (searchText) {
        var searchFields = ['character', 'collaborator.displayName', 'collaborator.nickName', 'collaborator.iMDbNumber'];
        _this.currentGridOptions.data = $filter('gridSearch')(_this.gridDataCopy, searchText, searchFields);
    };
    this.tabAddDisabledInvalid = function () {
        return !_this.disabledFound;
    };
    this.deleteInvalid = function () {
        return _this.hasWrite && _this.selectedRows.length < 1;
    };
    this.gridRowSelectionChangedHandler = function (row) {
        if (row.isSelected) {
            _this.selectedRows.push(row.entity);
        }
        else {
            var index = _this.selectedRows.indexOf(row.entity);
            _this.selectedRows.splice(index, 1);
        }
    };
    this.toggleRows = function (evt) {
        if (_this.gridApi.selection.selectAll) {
            _this.gridApi.selection.clearSelectedRows(evt);
            _this.gridApi.selection.selectAll = false;
        }
        else {
            _this.gridApi.selection.selectAllVisibleRows(evt);
            _this.gridApi.selection.selectAll = true;
        }
        _this.selectedRows = _this.gridApi.selection.getSelectedRows();
    };
    this.filterValue = '';
    this.disabledFound = false;
    this.gridDataCopy = [];
    this.selectedRows = [];
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.roleTabs = {
            actors: false,
            crew: false
        };
        _this.isClipCollaborators = $routeParams.editView === 'liveClip';
        _this.currentTab = $location.search().subView || 'Actors';
        if (_this.isClipCollaborators) {
            PackageUtilService.subTabSaveFunctions[_this.editorFormName] = {
                data: function () { return _this.collaboratorData.actors; },
                callback: handleGridDataQuery
            };
            PackageUtilService.subTabRevertFunctions[_this.editorFormName] = function () {
                _this.collaboratorData.actors = angular.copy(originalCollaborators.actors);
                _this.currentGridOptions.data = _this.savedCollaboratorsMap.actors;
            };
        }
        setQueryProperties();
        getEditData();
        PackageUtilService.tabNewFunction = _this.addCollaborator;
        PackageUtilService.tabDeleteFunction = _this.deleteCollaborator;
        PackageUtilService.tabAddDisabledFunction = _this.addDisabledCollaborator;
        PackageUtilService.tabAddDisabledInvalid = _this.tabAddDisabledInvalid;
        PackageUtilService.tabDeleteInvalid = _this.deleteInvalid;
        NavbarUtilService.viewSearchFunction = _this.filter;
        SearchFilterService.populateCriteriaFromLocationSearch();
    };
    this.$postLink = function () {
        $timeout(function () {
            if (_this.isClipCollaborators) {
                PackageUtilService.editorForm = PackageLiveClipViewService[_this.editorFormName];
            }
            else {
                PackageUtilService.editorForm = _this.packageCollaboratorsEditorForm;
            }
        });
    };
    this.$onDestroy = function () {
        $location.search('subView', null);
        NavbarUtilService.viewSearchFunction = null;
        if (_this.isClipCollaborators && _this.editorFormName) {
            delete PackageUtilService.subTabSaveFunctions[_this.editorFormName];
            delete PackageUtilService.subTabRevertFunctions[_this.editorFormName];
        }
    };
}
angular.module('prism-ui.package').component('packageCollaboratorsView', {
    templateUrl: 'package/editor/components/view/collaborator/packagecollaborators-view-template.html',
    controller: PackageCollaboratorsViewController,
    bindings: {
        packageObject: '=',
        editorFormName: '=',
        setDirtyFctn: '=',
        statusAllowsEdit: '&'
    },
    transclude: true,
    require: {
        pkgLiveClip: '?^packageLiveclipView',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: package-completed-deliveries-view-component.ts
 *
 * Created by randysorensen on 2/19/18.
 */
function PackageCompletedDeliveriesViewController(
// external dependencies
_, 
// internal dependencies
PackageUtilService) {
    //=================//
    // Lifecycle Hooks //
    //=================//
    var _this = this;
    this.$postLink = function () {
        PackageUtilService.editorForm = _this.packageCompletedDeliveriesEditorForm;
    };
}
angular
    .module('prism-ui.package')
    .component('packageCompletedDeliveriesView', {
    controller: PackageCompletedDeliveriesViewController,
    templateUrl: 'package/editor/components/view/completedDeliveries/package-completed-deliveries-view-template.html',
    bindings: {
        packageObject: '=',
        loadingIndicator: '=',
        pkgEditCtrl: '=',
    }
});
// (EOF)

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by kyang on 1/28/20.
 */
function ExternalIngestsTabController($q, $timeout, $window, uiGridConstants, AggregationResourceFactory, DownloadAssetService, EndPointService, PackageResourceFactory, PackageUtilService, PermissionsService, UtilsService) {
    var _this = this;
    var PACKAGE_EXTERNAL_INGESTS_VIEW_STATE = 'PACKAGE_EXTERNAL_INGESTS_VIEW_STATE';
    //======//
    // Grid //
    //======//
    var gridColumnDefs = [
        {
            field: 'aggregationDate',
            width: 250,
            cellTemplate: 'components/visual/grid/date-time-column-template.html'
        },
        {
            displayName: 'Source Link',
            field: 'sourceFile.uri',
            width: 90,
            cellTemplate: 'components/visual/grid/text-file-download-template.html',
        },
        {
            displayName: 'Source Filename',
            field: 'sourceFile.filename',
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        },
        {
            displayName: 'Transf. Link',
            field: 'transformedFile.uri',
            width: 90,
            cellTemplate: 'components/visual/grid/text-file-download-template.html',
        },
        {
            displayName: 'Transformed Filename',
            field: 'transformedFile.filename',
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        },
    ];
    var uriLookup = {};
    this.gridOptions = {
        enableColumnMenus: false,
        enableColumnResizing: false,
        enableFullRowSelection: false,
        enablePaginationControls: false,
        enableRowHeaderSelection: false,
        enableRowSelection: false,
        enableSorting: false,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        multiSelect: false,
        columnDefs: gridColumnDefs,
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
    this.getAssetURI = function (assetVersionId) {
        if (_.size(assetVersionId) <= 0) {
            return undefined;
        }
        return DownloadAssetService.getAssetUri(assetVersionId, 'document', DownloadAssetService.ContentUse.Source);
    };
    this.downloadFile = function (taskUri) {
        var file = uriLookup[taskUri];
        UtilsService.downloadFile(file.uri, file.filename);
    };
    //===================//
    // Template Response //
    //===================//
    this.areControlsEnabled = function () {
        return _this.pkgEditCtrl.statusAllowsEdit() && !_this.packageObject.locked && _this.canWrite;
    };
    this.onExternalIdChange = function () {
        if (_.get(_this.packageObject, 'externalId.length') == 0)
            _this.packageObject.externalId = null;
    };
    this.clearExternalId = function () {
        _this.packageObject.externalId = null;
        _this.externalIngestsTabEditorForm.$setDirty();
    };
    this.clearExternalDateUpdated = function () {
        _this.packageObject.externalDateUpdated = null;
        _this.externalIngestsTabEditorForm.$setDirty();
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    var getEditData = function () {
        return AggregationResourceFactory.getTasks({
            packageId: _this.packageObject.id,
            externalSystem: _this.packageObject.externalSystem,
            externalId: _this.packageObject.externalId,
        }).$promise.then(function (ingestLogs) {
            _this.gridOptions.data = ingestLogs;
            var uriPromises = [];
            _.forEach(ingestLogs, function (ingestLog) {
                var sourceFile = {
                    uri: EndPointService.aggregationEndPoint + "/tasks/" + ingestLog.id + "/xml?sourceXml=true",
                    filename: ingestLog.sourceFilename,
                };
                uriLookup[sourceFile.uri] = sourceFile;
                ingestLog.sourceFile = sourceFile;
                var transformedFile = {
                    uri: EndPointService.aggregationEndPoint + "/tasks/" + ingestLog.id + "/xml?sourceXml=false",
                    filename: UtilsService.appendBaseFilename(ingestLog.sourceFilename, '_transformed'),
                };
                uriLookup[transformedFile.uri] = transformedFile;
                ingestLog.transformedFile = transformedFile;
            });
            return $q.all(uriPromises);
        }).then(function () {
            _this.loadingIndicator.show = false;
        });
    };
    this.$onInit = function () {
        _this.loadingIndicator.show = true;
        _this.canRead = false;
        _this.canWrite = false;
        PermissionsService.getReadWritePermissions(PACKAGE_EXTERNAL_INGESTS_VIEW_STATE)
            .then(function (perms) {
            _this.canRead = perms.write || perms.read;
            _this.canWrite = perms.write;
            if (_this.canRead) {
                return getEditData();
            }
        });
    };
    this.$postLink = function () {
        $timeout(function () {
            PackageUtilService.editorForm = _this.externalIngestsTabEditorForm;
        });
    };
}
angular
    .module('prism-ui.package')
    .component('externalIngestsTab', {
    templateUrl: 'package/editor/components/view/externalIngests/external-ingests-tab-template.html',
    controller: ExternalIngestsTabController,
    bindings: {
        packageObject: '<',
        loadingIndicator: '<',
        pkgEditCtrl: '<',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: package-media-service.ts
 *
 * Created by randysorensen on 9/10/18.
 */
//
// NOTICE:
//
// 2018-Sep-19 - Robert is no longer using package artwork and
// permitted us to remove it from the package media tab.
//
angular.module('prism-ui.package').service('PackageMediaService', function (_, $q, AsperaConnectService, ContentResourceFactory, LanguageResourceFactory, ModalService, PackageFileUploadService, PackageMediaResourceFactory, PackageResourceFactory, PackageUtilService, PermissionsService, RequestService, RolesService) {
    var _this = this;
    // private members
    var viewAssetModalRendererUrl = 'package/editor/components/view/media/renderers/packagemedia-view-asset-mediainfo-template.html';
    var packageMediaDataDeferred = null;
    var ingestPollingIntervalId = null;
    this.resetPackageMediaData = function (packageObject) {
        _this.deactivateIngestProgressPollingInterval();
        PackageFileUploadService.unregisterAllFiles();
        packageMediaDataDeferred = $q.defer();
        _this.packageObject = packageObject;
        if (!_this.packageMediaPermissions) {
            _this.packageMediaPermissions = {
                isAdmin: false,
                canRead: false,
                canWrite: false
            };
        }
        _this.originalPackageMediaData = null;
        _this.packageMediaData = {
            languages: [],
            componentRoles: [],
            audioRoles: [],
            ccRoles: [],
            subtitleRoles: [],
            requirements: [],
            mainVideoMediaInfoXML: null,
            selectedImageAcceptTemplateMember: _.get(_this, "packageObject.primaryImage.acceptTemplateMember", null),
            selectedVideoAcceptTemplateMember: _.get(_this, "packageObject.primaryAcceptTemplateMember", null),
            adPodAcceptProfile: null,
            acceptTemplateMembers: [],
            assets: [],
            //
            // We set the pending ingest flag to whatever the
            // value on the package is. But we do not bind
            // anything in the UI to it; it will be set or
            // cleared by the media tab controller based on
            // the user's modal response, and then passed as
            // a query parameter to the package media API.
            //
            // The server will then set/clear the flag on the
            // package as needed.
            //
            pendingIngest: _.get(_this, "packageObject.pendingIngest", true),
        };
    };
    //=================//
    // Validation Type //
    //=================//
    var supportedAssetTypes = ['IMAGE', 'AUDIO', 'OTHER', 'DOCUMENT'];
    var supportedTextTrackTypes = ['CC', 'SUBTITLE'];
    var alwaysRequiredTypes = ['SDR VIDEO', 'HDR VIDEO', 'VIDEO METADATA', 'AD POD'];
    var getPackageValidationStatusForComponentRole = function (componentRole) {
        var validationStatus = 'OPTIONAL';
        if (componentRole.isDefault || componentRole._partnersRequiring.length) {
            validationStatus = 'REQUIRED';
        }
        return validationStatus;
    };
    var getPackageValidationStatusForNonTextTrackAssets = function (mediaType) {
        var acceptTemplateMembers = _.filter(_this.packageMediaData.acceptTemplateMembers, {
            acceptProfile: {
                type: mediaType
            }
        });
        var hasRequired = _.some(acceptTemplateMembers, { validationType: 'REQUIRED' });
        var hasOptional = _.some(acceptTemplateMembers, { validationType: 'OPTIONAL' });
        var validationStatus = 'NOT APPLICABLE';
        if (hasRequired) {
            validationStatus = 'REQUIRED';
        }
        else if (hasOptional) {
            validationStatus = 'OPTIONAL';
        }
        return validationStatus;
    };
    var getPackageValidationStatusForTextTrackAssets = function (variant, componentRole) {
        variant = _.toLower(variant);
        var validationStatus = 'NOT APPLICABLE';
        if (_.get(componentRole, "_" + variant + "AcceptTemplate")) {
            validationStatus = 'REQUIRED';
            var componentRoleValidationStatus = getPackageValidationStatusForComponentRole(componentRole);
            var componentRoleIsRequired = _.includes(componentRoleValidationStatus, 'REQUIRED');
            var extractClosedCaptioning = _.get(_this.getPrimaryAcceptTemplateMember(), 'acceptProfile.extractClosedCaptioning');
            if (!componentRole.isDefault && !componentRoleIsRequired) {
                validationStatus += ' (If Video Ingested)';
            }
            else if (extractClosedCaptioning && variant === 'cc' && componentRole.isDefault) {
                validationStatus += ' (Extracted from Video)';
            }
        }
        else if (_.get(componentRole, 'isDefault')) {
            validationStatus = 'OPTIONAL';
        }
        return validationStatus;
    };
    var getPackageValidationStatus = function (mediaType, componentRole) {
        if (componentRole === void 0) { componentRole = null; }
        mediaType = _.toUpper(mediaType);
        if (!componentRole) {
            componentRole = _this.getDefaultComponentRole();
        }
        var validationStatus = 'NOT APPLICABLE';
        if (mediaType === 'VIDEO') {
            validationStatus = getPackageValidationStatusForComponentRole(componentRole);
        }
        else if (_.includes(alwaysRequiredTypes, mediaType)) {
            validationStatus = 'REQUIRED';
        }
        else if (_.includes(supportedAssetTypes, mediaType)) {
            validationStatus = getPackageValidationStatusForNonTextTrackAssets(mediaType);
        }
        else if (_.includes(supportedTextTrackTypes, mediaType)) {
            validationStatus = getPackageValidationStatusForTextTrackAssets(mediaType, componentRole);
        }
        return validationStatus;
    };
    var getPartnerValidationStatus = function (mediaType, componentRole) {
        mediaType = _.toLower(mediaType);
        var filterCriteria = {
            mediaType: mediaType,
            required: true
        };
        if (componentRole) {
            filterCriteria.videoRoleId = componentRole.id;
        }
        var partnerRequirements = _.filter(_this.packageMediaData.requirements, filterCriteria);
        var validationStatus = 'NOT APPLICABLE';
        if (_.chain(partnerRequirements).map('partnerName').uniq().compact().size().value()) {
            validationStatus = 'REQUIRED (PARTNER)';
        }
        return validationStatus;
    };
    var getValidationStatusWeight = function (validationStatus) {
        var weight = 0;
        if (_.includes(validationStatus, 'REQUIRED')) {
            weight += 2;
        }
        else if (_.includes(validationStatus, 'OPTIONAL')) {
            weight += 1;
        }
        return weight;
    };
    this.getValidationStatus = function (mediaType, componentRole) {
        if (componentRole === void 0) { componentRole = null; }
        var packageValidationStatus = getPackageValidationStatus(mediaType, componentRole);
        var partnerValidationStatus = getPartnerValidationStatus(mediaType, componentRole);
        var packageValidationWeight = getValidationStatusWeight(packageValidationStatus);
        var partnerValidationWeight = getValidationStatusWeight(partnerValidationStatus);
        if (packageValidationWeight >= partnerValidationWeight) {
            return packageValidationStatus;
        }
        else {
            return partnerValidationStatus;
        }
    };
    this.getPartnersRequiring = function (mediaType, componentRole) {
        if (componentRole === void 0) { componentRole = null; }
        mediaType = _.toLower(mediaType);
        var partnersRequiring = [];
        if (mediaType === 'video') {
            partnersRequiring = _.get(componentRole, '_partnersRequiring', []);
        }
        else {
            var filterCriteria = {
                mediaType: mediaType,
                required: true
            };
            if (componentRole) {
                filterCriteria.videoRoleId = componentRole.id;
            }
            var partnerRequirements = _.filter(_this.packageMediaData.requirements, filterCriteria);
            partnersRequiring = _.chain(partnerRequirements).map('partnerName').uniq().compact().value();
        }
        return partnersRequiring;
    };
    //=============//
    // Permissions //
    //=============//
    var MEDIA_TAB_VIEW_STATE = 'PACKAGE_MEDIA_VIEW_STATE';
    this.getPackageMediaPermissions = function () {
        var adminFlag = PermissionsService.isAdmin();
        _this.packageMediaPermissions.isAdmin = adminFlag;
        _this.packageMediaPermissions.canRead = adminFlag;
        _this.packageMediaPermissions.canWrite = adminFlag;
        if (!adminFlag) {
            return $q.all({
                canRead: PermissionsService.canRead(MEDIA_TAB_VIEW_STATE),
                canWrite: PermissionsService.canWrite(MEDIA_TAB_VIEW_STATE)
            }).then(function (permissionsData) {
                _this.packageMediaPermissions.canWrite = permissionsData.canWrite;
                _this.packageMediaPermissions.canRead = permissionsData.canWrite || permissionsData.canRead;
                return _this.packageMediaPermissions;
            });
        }
        else {
            return $q.when(_this.packageMediaPermissions);
        }
    };
    //=====================//
    // Asset Editor Modals //
    //=====================//
    this.generatePackageDownloadFilenamePrefix = function (packageObject, secondaryAsset, componentRoleName) {
        if (componentRoleName === void 0) { componentRoleName = null; }
        var packageDownloadFilenamePrefix = ("" + packageObject.content.prefix +
            ("_" + packageObject.productionNumber) +
            ("_" + packageObject.title) +
            ("_" + packageObject.id) +
            "_");
        if (componentRoleName !== null) {
            packageDownloadFilenamePrefix += componentRoleName + "_";
        }
        if (secondaryAsset) {
            packageDownloadFilenamePrefix += 'secondary_';
        }
        return packageDownloadFilenamePrefix;
    };
    this.openViewAssetModal = function (packageContent, secondaryAsset) {
        if (secondaryAsset === void 0) { secondaryAsset = false; }
        var ingestProgress = _.get(packageContent, "ingestInfo.progress", 0);
        if (!!packageContent && parseInt(ingestProgress) === 100) {
            var fileNamePrefix = !!_this.packageObject
                ? _this.generatePackageDownloadFilenamePrefix(_this.packageObject, secondaryAsset)
                : 'unknown_';
            ModalService.showViewAssetModal(packageContent, secondaryAsset, fileNamePrefix, viewAssetModalRendererUrl, true);
        }
    };
    this.openQualityControlModal = function (asset) {
        var setQCNote = function (asset, qcNote) {
            asset.qualityControlNote = qcNote;
            PackageUtilService.editorForm.$setDirty();
        };
        if (asset && PackageUtilService.statusAllowsEdit(_this.packageObject.status)) {
            ModalService.showEditableQualityControlModal(asset, _this.packageMediaPermissions.canWrite, setQCNote);
        }
    };
    //==================//
    // Media Operations //
    //==================//
    this.resetAllMedia = function () {
        _this.deactivateIngestProgressPollingInterval();
        _this.packageMediaData.assets = [];
        _this.packageMediaData.selectedImageAcceptTemplateMember = null;
        _this.packageMediaData.selectedVideoAcceptTemplateMember = null;
        PackageFileUploadService.unregisterAllFiles();
    };
    var determineSelectedImageAcceptTemplateMember = function () {
        var imageAssets = _this.getAssetList('Image');
        if (_.size(imageAssets)) {
            var currentMAPs = _.chain(imageAssets).map('acceptTemplateMember').uniqBy('id').compact().value();
            if (_.size(currentMAPs) === 1) {
                _this.packageMediaData.selectedImageAcceptTemplateMember = _.first(currentMAPs);
            }
            else {
                console.warn("determineSelectedImageAcceptTemplateMember(): found multiple image MAPs");
            }
        }
    };
    var processPackageMediaList = function (packageMediaAssets) {
        _this.resetAllMedia();
        _this.packageMediaData.assets = _.cloneDeep(packageMediaAssets);
        determineSelectedImageAcceptTemplateMember();
        var primaryAcceptTemplateMember = _.get(_this.getMainVideo(), "acceptTemplateMember");
        _this.packageObject.primaryAcceptTemplateMember = primaryAcceptTemplateMember;
        _this.packageMediaData.selectedVideoAcceptTemplateMember = primaryAcceptTemplateMember;
    };
    this.getAssetList = function (type, componentRole) {
        if (componentRole === void 0) { componentRole = null; }
        var filter = {
            type: type
        };
        if (componentRole) {
            if (type === 'Video') {
                _.set(filter, 'role.id', componentRole.id);
            }
            else {
                _.set(filter, 'componentRole.id', componentRole.id);
            }
        }
        return _.filter(_this.packageMediaData.assets, filter);
    };
    this.getMainVideo = function () {
        var mainVideo = _.find(_this.packageMediaData.assets, {
            type: 'Video',
            role: {
                isDefault: true
            }
        });
        if (!mainVideo) {
            mainVideo = {
                acceptTemplateMember: null,
                pendingIngest: false,
                role: _.find(_this.packageMediaData.componentRoles, {
                    isDefault: true
                }),
                type: 'Video',
                virtualPath: null
            };
            _this.packageMediaData.assets.push(mainVideo);
        }
        return mainVideo;
    };
    this.mainVideoIngestHasCompleted = function () {
        var hasMainVideoID = !!_this.getMainVideo().id;
        var ingestProgress = parseInt(_.get(_this.getMainVideo(), 'ingestInfo.progress', 0));
        var ingestHasCompleted = ingestProgress === 100;
        return hasMainVideoID && ingestHasCompleted;
    };
    this.mainVideoIngestHasStarted = function () {
        var hasMainVideoID = !!_this.getMainVideo().id;
        var ingestProgress = _.get(_this.getMainVideo(), 'ingestInfo.progress', 0);
        var ingestWorkflowId = _.get(_this.getMainVideo(), 'ingestInfo.workflowId', null);
        var proxyWorkflowId = _.get(_this.getMainVideo(), 'ingestInfo.proxyWorkflowId', null);
        var ingestHasStarted = (ingestProgress > 0) || !!ingestWorkflowId || !!proxyWorkflowId;
        return hasMainVideoID && ingestHasStarted;
    };
    this.getPrimaryAcceptTemplateMember = function () {
        return (_.get(_this, 'packageMediaData.selectedVideoAcceptTemplateMember') ||
            _.get(_this.getMainVideo(), 'acceptTemplateMember') ||
            _.get(_this, 'packageObject.primaryAcceptTemplateMember'));
    };
    this.setMainVideoMediaInfoXML = function (mainVideoMediaInfoXML) {
        console.info("PackageMediaService.setMainVideoMediaInfoXML():" +
            " resetting active main video Mediainfo XML");
        _this.packageMediaData.mainVideoMediaInfoXML = _.cloneDeep(mainVideoMediaInfoXML);
    };
    this.getMainVideoMediaInfoXML = function () {
        return _this.packageMediaData.mainVideoMediaInfoXML;
    };
    this.getComponentVideoMediaInfoXMLList = function (componentRole) {
        var componentVideosForRole = _this.getAssetList('Video', componentRole);
        return _.chain(componentVideosForRole).map('mediaInfoDTO').compact().value();
    };
    this.getDefaultComponentRole = function () {
        return _.chain(_this.packageMediaData.componentRoles).filter({ isDefault: true }).first().value();
    };
    this.hasMainVideo = function () {
        return !!_.get(_this.getMainVideo(), 'virtualPath');
    };
    this.getExcludedComponentIdList = function (role) {
        var originalComponentList = _.filter(_this.originalPackageMediaData.assets, {
            type: 'Video',
            role: {
                id: role.id
            }
        });
        var originalComponentIdList = _.map(originalComponentList, 'id');
        var currentComponentList = _this.getAssetList('Video', role);
        var currentComponentIdList = _.map(currentComponentList, 'id');
        return _.difference(originalComponentIdList, currentComponentIdList);
    };
    this.getNewComponentVirtualPathList = function (role) {
        var currentComponentList = _this.getAssetList('Video', role);
        var newComponentList = _.filter(currentComponentList, function (component) {
            return !_.has(component, 'id');
        });
        return _.map(newComponentList, 'virtualPath');
    };
    var addRelatedItem = function (relatedItem) {
        var type = relatedItem.type.toLowerCase();
        var defaultRole = _.find(_this.packageMediaData.componentRoles, { isDefault: true });
        var validationStatus = _this.getValidationStatus(type, defaultRole);
        if (!_.includes(validationStatus, 'NOT APPLICABLE')) {
            if (type === 'cc' || type === 'subtitle') {
                relatedItem.componentRole = defaultRole;
            }
            _this.packageMediaData.assets.push(relatedItem);
        }
        else {
            console.info("addRelatedItem(): ignoring inapplicable related item " + relatedItem.virtualPath);
        }
    };
    this.findRelatedItems = function () {
        var acceptTemplateMemberId = _.get(_this.getPrimaryAcceptTemplateMember(), 'id');
        var findRelatedPromise = PackageResourceFactory.findRelatedItems({
            id: _this.packageObject.id,
            videoPath: _.get(_this.getMainVideo(), 'virtualPath'),
            acceptTemplateMemberId: acceptTemplateMemberId
        }).$promise;
        return findRelatedPromise.then(function (relatedItems) {
            var validationResults = [];
            var relatedItemsToConfirm = [];
            _.forEach(relatedItems, function (relatedItem) {
                if (_.get(relatedItem, 'validationResult', []).length) {
                    validationResults = _.concat(validationResults, relatedItem.validationResult);
                    relatedItemsToConfirm.push(relatedItem);
                }
                else {
                    addRelatedItem(relatedItem);
                }
            });
            if (_.size(validationResults)) {
                ModalService.showAssetValidationResultsModal(validationResults, true, function () {
                    _.forEach(relatedItemsToConfirm, addRelatedItem);
                });
            }
            determineSelectedImageAcceptTemplateMember();
        });
    };
    this.isAnUploadPath = function (virtualPath) {
        if (virtualPath === void 0) { virtualPath = null; }
        if (!virtualPath) {
            virtualPath = _.get(_this.getMainVideo(), 'virtualPath');
        }
        var asperaVirtualRoot = _.get(AsperaConnectService, 'asperaConnectProperties.virtualRoot', null);
        return _.startsWith(virtualPath, asperaVirtualRoot) || _.startsWith(virtualPath, 's3:');
    };
    //=================//
    // Ingest Progress //
    //=================//
    this.calculateIngestPercent = function (assetList) {
        var assetCount = _.size(assetList);
        var percentSum = 0;
        _.forEach(assetList, function (asset) {
            if (_.has(asset, 'ingestInfo')) {
                percentSum += _.chain(asset).get('ingestInfo.progress', 0).toInteger().value();
            }
            else {
                --assetCount;
            }
        });
        var ingestPercent;
        if (assetCount === 0) {
            ingestPercent = _.toInteger(-1);
        }
        else {
            ingestPercent = _.toInteger(percentSum / assetCount);
        }
        return ingestPercent;
    };
    this.deactivateIngestProgressPollingInterval = function () {
        RequestService.cancelRequestInterval(ingestPollingIntervalId);
    };
    this.activateIngestProgressPollingInterval = function () {
        _this.deactivateIngestProgressPollingInterval();
        ingestPollingIntervalId = RequestService.createRequestInterval(_this.updateIngestStatus, 10000, { startImmediately: true });
    };
    this.restartIngestProgressPollingInterval = function () {
        return _this.activateIngestProgressPollingInterval();
    };
    //=========================//
    // Retrieve Media Tab Data //
    //=========================//
    var getLanguages = function () {
        return LanguageResourceFactory.query().$promise.then(function (languages) {
            _this.packageMediaData.languages =
                _.chain(languages).orderBy('name').partition({ isDefault: true }).flatten().concat().value();
        });
    };
    var getRoles = function () {
        return RolesService.getAllRoles().then(function (roles) {
            _.forEach(roles, function (role) {
                switch (role.type.toLowerCase()) {
                    case 'video':
                        _this.packageMediaData.componentRoles.push(role);
                        break;
                    case 'audio':
                        _this.packageMediaData.audioRoles.push(role);
                        break;
                    case 'cc':
                        _this.packageMediaData.ccRoles.push(role);
                        break;
                    case 'subtitle':
                        _this.packageMediaData.subtitleRoles.push(role);
                        break;
                    default:
                        console.warn("Unknown role type: " + role.type);
                        break;
                }
            });
        });
    };
    var getPackageAcceptTemplateMembers = function () {
        //
        // Note that we ignore the 'document' accept profile type,
        // as they are only used for Ad Pods, and  the correct
        // Ad Pod accept profile is specified by the package
        // category and may not be changed on the package Media
        // tab
        //
        return PackageResourceFactory.query({
            id: _this.packageObject.id,
            sub: 'acceptTemplateMembers'
        }).$promise.then(function (acceptTemplateMembers) {
            _this.packageMediaData.acceptTemplateMembers = _.cloneDeep(acceptTemplateMembers);
        });
    };
    var getPackageMediaRequirements = function () {
        //
        // The package media requirements should always be
        // updateable, however there are no requirements unless
        // a package video MAP is active.
        //
        var requirementsDeferred = $q.defer();
        var acceptTemplateMember = _.get(_this, "packageObject.primaryAcceptTemplateMember");
        if (_.has(acceptTemplateMember, "acceptProfile.id")) {
            requirementsDeferred.resolve(PackageResourceFactory.query({
                id: _this.packageObject.id,
                mapId: acceptTemplateMember.acceptProfile.id,
                sub: 'mediaRequirement'
            }).$promise.then(function (packageMediaRequirements) {
                _.forEach(packageMediaRequirements, function (packageMediaRequirement) {
                    var mediaType = packageMediaRequirement.mediaType;
                    if (mediaType === 'PACKAGE_IMAGE') {
                        mediaType = 'image';
                    }
                    else {
                        mediaType = _.toLower(mediaType);
                    }
                    packageMediaRequirement.mediaType = mediaType;
                });
                _this.packageMediaData.requirements = packageMediaRequirements;
            }));
        }
        else {
            _this.packageMediaData.requirements = [];
            requirementsDeferred.resolve();
        }
        return requirementsDeferred.promise;
    };
    var getPackageMediaAssets = function () {
        return PackageMediaResourceFactory.get({
            id: _this.packageObject.id
        }).$promise.then(processPackageMediaList);
    };
    var getContentCategory = function () {
        return ContentResourceFactory.query({
            id: _this.packageObject.content.id,
            sub: 'categories',
            categoryId: _this.packageObject.category.id
        }).$promise.then(function (contentCategories) {
            // server should only return one content category when
            // a category ID is provided
            if (contentCategories.length !== 1) {
                console.warn("Expected exactly 1 content category (found " + contentCategories.length + ")");
            }
            var contentCategory = contentCategories[0];
            // save Ad Pod accept profile from category
            _this.packageMediaData.adPodAcceptProfile = _.get(contentCategory, 'category.adPodAcceptProfile');
            // save component roles and associated text accept
            // templates - note that each element in the videoRoles
            // array from the server has text accept templates as
            // well as a video role object named simply "role"
            _.forEach(_.get(contentCategory, 'videoRoles'), function (videoRole) {
                var componentRole = _.find(_this.packageMediaData.componentRoles, {
                    id: videoRole.role.id
                });
                componentRole._ccAcceptTemplate = videoRole.closedCaptioningAcceptTemplate;
                componentRole._subtitleAcceptTemplate = videoRole.subtitleAcceptTemplate;
                if (!videoRole.role.isDefault) {
                    componentRole._contentCategoryEnabled = true;
                    componentRole._partnersRequiring = [];
                    componentRole._partnersEnabled = [];
                }
            });
        });
    };
    var getPartnerPackages = function () {
        return PackageResourceFactory.query({
            id: _this.packageObject.id,
            sub: 'partnerPackages'
        }).$promise.then(function (partnerPackages) {
            _.forEach(partnerPackages, function (partnerPackage) {
                var requiredComponentRoleIds = _.chain(partnerPackage.videoRoles).filter({ isRequired: true }).map('role.id').value();
                var optionalComponentRoleIds = _.chain(partnerPackage.videoRoles).filter({ isRequired: false }).map('role.id').value();
                _.forEach(requiredComponentRoleIds, function (roleId) {
                    var role = _.find(_this.packageMediaData.componentRoles, { id: roleId });
                    role._partnersRequiring.push(partnerPackage.partner.name);
                });
                _.forEach(optionalComponentRoleIds, function (roleId) {
                    var role = _.find(_this.packageMediaData.componentRoles, { id: roleId });
                    role._partnersEnabled.push(partnerPackage.partner.name);
                });
            });
        });
    };
    this.updateIngestStatus = function () {
        return PackageMediaResourceFactory.get({
            id: _this.packageObject.id
        }).$promise.then(function (packageMediaAssets) {
            _.forEach(packageMediaAssets, function (packageMediaAsset) {
                var localAsset = _.find(_this.packageMediaData.assets, { id: packageMediaAsset.id });
                if (localAsset) {
                    if (_.has(packageMediaAsset, 'ingestInfo')) {
                        localAsset.ingestInfo = packageMediaAsset.ingestInfo;
                    }
                    else {
                        delete localAsset.ingestInfo;
                    }
                }
            });
        }).then(function () {
            getPackageMediaRequirements();
        });
    };
    this.getPackageMediaData = function (packageObject) {
        if (_.get(_this, 'packageObject.id') === _.get(packageObject, 'id')) {
            //
            // We already have this package's media data, so just
            // detach the old package object and attach the new
            // one
            //
            _this.packageObject = packageObject;
            return packageMediaDataDeferred.promise;
        }
        else if (packageObject !== undefined) {
            _this.resetPackageMediaData(packageObject);
            if (_.has(packageObject, 'category.id')) {
                $q.all([
                    getLanguages(),
                    getRoles(),
                    getPackageAcceptTemplateMembers(),
                    getPackageMediaRequirements()
                ]).then(function () {
                    return getContentCategory();
                }).then(function () {
                    return getPartnerPackages();
                }).then(function () {
                    return getPackageMediaAssets();
                }).then(function () {
                    _this.packageObject.primaryAcceptTemplateMember =
                        _.get(_this.getMainVideo(), "acceptTemplateMember", null);
                    _this.originalPackageMediaData = _.cloneDeep(_this.packageMediaData);
                    packageMediaDataDeferred.resolve(_this.packageMediaData);
                });
            }
            else {
                _this.originalPackageMediaData = _.cloneDeep(_this.packageMediaData);
                packageMediaDataDeferred.resolve(_this.packageMediaData);
            }
        }
        return packageMediaDataDeferred.promise;
    };
    //=============//
    // Save/Revert //
    //=============//
    var textTrackListHasDuplicates = function (textTrackList) {
        var duplicatesFound = false;
        _.forEach(textTrackList, function (textAsset) {
            if (!duplicatesFound) {
                var filterCriteria = {
                    language: {
                        id: _.get(textAsset, 'language.id')
                    },
                    role: {
                        id: _.get(textAsset, 'role.id')
                    }
                };
                duplicatesFound = _.filter(textTrackList, filterCriteria).length > 1;
            }
        });
        return duplicatesFound;
    };
    var componentRoleHasDuplicateTextLanguageAndRole = function (textAssetType, componentRole) {
        var assetList = _.filter(_this.packageMediaData.assets, {
            type: textAssetType,
            componentRole: {
                id: componentRole.id
            }
        });
        return _.size(assetList) >= 2 && textTrackListHasDuplicates(assetList);
    };
    var hasDuplicateTextLanguageAndRole = function () {
        var duplicatesFound = false;
        _.forEach(_this.packageMediaData.componentRoles, function (componentRole) {
            if (!duplicatesFound) {
                duplicatesFound =
                    componentRoleHasDuplicateTextLanguageAndRole('CC', componentRole) ||
                        componentRoleHasDuplicateTextLanguageAndRole('Subtitle', componentRole);
            }
        });
        return duplicatesFound;
    };
    this.hasSaveConflict = function () {
        return hasDuplicateTextLanguageAndRole();
    };
    this.savePackageMediaData = function () {
        _this.deactivateIngestProgressPollingInterval();
        var savePromise = PackageMediaResourceFactory.save({
            id: _this.packageObject.id,
            pendingIngest: _this.packageMediaData.pendingIngest
        }, _this.packageMediaData.assets).$promise;
        return savePromise.then(function (savedMediaAssets) {
            processPackageMediaList(savedMediaAssets);
        }).then(function () {
            _this.originalPackageMediaData = _.cloneDeep(_this.packageMediaData);
        }).finally(function () {
            return _this.activateIngestProgressPollingInterval();
        });
    };
    this.revertPackageMediaData = function () {
        //
        // To prevent ingest indicator flickering after a revert,
        // we remove ingest info from all assets and update it
        // immediately after reverting.
        //
        _this.deactivateIngestProgressPollingInterval();
        _.forEach(_this.originalPackageMediaData.assets, function (asset) {
            delete asset.ingestInfo;
        });
        _this.packageMediaData = _.cloneDeep(_this.originalPackageMediaData);
        return _this.activateIngestProgressPollingInterval();
    };
    //===============//
    // Service Entry //
    //===============//
    var svcInit = function () {
        _this.packageMediaDataPromise = null;
        _this.resetPackageMediaData(null);
    };
    svcInit();
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by richardwilliams on 4/9/15.
 */
function PackageMediaViewController(_, $q, $routeParams, $timeout, AsperaConnectService, AssetValidationService, ContentResourceFactory, DynamicPropertiesService, LanguageResourceFactory, MediaProfileResourceFactory, ModalService, NotificationService, PackageFileUploadService, PackageMediaResourceFactory, PackageMediaService, PackageResourceFactory, PermissionsService, PackageUtilService) {
    var _this = this;
    this.getMainVideo = function () {
        return PackageMediaService.getMainVideo();
    };
    this.showFileProgressModal = function () {
        ModalService.showFileProgressModal();
        console.log('hi');
    };
    //================//
    // Template Logic //
    //================//
    this.isComponentRoleRequired = function (componentRole) {
        return componentRole.isDefault || !!_.size(componentRole._partnersRequiring);
    };
    this.isComponentRoleEnabled = function (componentRole) {
        return componentRole._contentCategoryEnabled || componentRole.isDefault;
    };
    this.getComponentRoleCount = function () {
        return _.filter(_this.componentRoles, function (componentRole) {
            return _this.isComponentRoleEnabled(componentRole);
        }).length;
    };
    var getAllVideos = function () {
        var allRoleVideos = _.filter(PackageMediaService.packageMediaData.assets, {
            type: 'VideoComponentMaster'
        });
        return _.concat(allRoleVideos, [_this.getMainVideo()]);
    };
    var checkVideosForRunningWorkflow = function (videos, workflowPropertyName) {
        var foundWorkflow = false;
        _.forEach(videos, function (video) {
            foundWorkflow = foundWorkflow || !!_.get(video, "ingestInfo." + workflowPropertyName);
        });
        return foundWorkflow;
    };
    var isWorkflowInProgress = function (workflowIdProperty) {
        var videos = [];
        if (_this.activeTabRole.isDefault) {
            videos = getAllVideos();
        }
        else {
            var roleVideo = _.find(PackageMediaService.packageMediaData.assets, {
                type: 'VideoComponentMaster',
                componentRole: {
                    id: _this.activeTabRole.id
                }
            });
            if (roleVideo) {
                videos.push(roleVideo);
            }
        }
        return checkVideosForRunningWorkflow(videos, workflowIdProperty);
    };
    this.getLockMessage = function () {
        if (isWorkflowInProgress('workflowId')) {
            return "Ingest in progress";
        }
        else if (isWorkflowInProgress('proxyWorkflowId')) {
            return "Proxy creation in progress";
        }
        else {
            return "";
        }
    };
    this.wasMainVideoUploaded = function () {
        return PackageMediaService.isAnUploadPath();
    };
    this.getDefaultComponentRole = function () {
        return _.find(PackageMediaService.packageMediaData.componentRoles, { isDefault: true });
    };
    this.onTabSelect = function (componentRole) {
        _this.activeTabRole = componentRole;
    };
    this.onTabDeselect = function (componentRole, $event) {
        if (_.get(_this, "packageMediaEditorForm.$dirty", false)) {
            $event.preventDefault();
            NotificationService.createWarningNotification('Please save or revert your changes before editing another component role.');
        }
    };
    this.onFindRelated = function () {
        _this.loadingIndicator.show = true;
        PackageMediaService.findRelatedItems().finally(function () {
            _this.loadingIndicator.show = false;
        });
        _this.packageMediaEditorForm.$setDirty();
    };
    //=========//
    // Toolbar //
    //=========//
    var savePackageMediaData = function () {
        _this.loadingIndicator.show = true;
        PackageFileUploadService.uploadFiles(_this.packageObjectData, _this.loadingIndicator)
            .then(function () { return PackageMediaService.savePackageMediaData(); })
            .then(function () {
            _this.packageMediaEditorForm.$setPristine();
        })
            .finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var hasRedundantAudioLanguage = function () {
        var audioAssets = PackageMediaService.getAssetList('Audio');
        var hasConflict = false;
        _.forEach(audioAssets, function (asset) {
            var isSpokenLanguage = asset.role.name === 'Spoken Language';
            var languageMatchesMainVideo = _.get(PackageMediaService.getMainVideo(), 'language.id') === _.get(asset, 'language.id');
            hasConflict = hasConflict || (isSpokenLanguage && languageMatchesMainVideo);
        });
        return hasConflict;
    };
    this.onSaveClicked = function () {
        if (!hasRedundantAudioLanguage()) {
            var clearPendingIngestAndSave = function () {
                PackageMediaService.packageMediaData.pendingIngest = false;
                savePackageMediaData();
            };
            var setPendingIngestAndSave = function () {
                PackageMediaService.packageMediaData.pendingIngest = true;
                savePackageMediaData();
            };
            if (_this.getComponentRoleCount() > 1) {
                ModalService.showMessageModal({
                    title: 'Save Package Media',
                    pullCancelLeft: true,
                    messageText: "Have all component files been ingested?",
                    windowClass: 'confirm-modal-sm text-align-center',
                    okText: 'Yes',
                    cancelText: 'No',
                    showOK: true
                }, clearPendingIngestAndSave, setPendingIngestAndSave);
            }
            else {
                // Save without prompt when there's no active component
                // roles for this package
                clearPendingIngestAndSave();
            }
        }
        else {
            ModalService.showMessageModal({
                messageText: "Language for audio asset with role \"Spoken Language\" conflicts with main video language",
                pullCancelLeft: true,
                title: 'Audio Role Language Conflict',
                windowClass: 'confirm-modal-lg',
                showOK: true
            });
        }
    };
    this.onRevertClicked = function (originalPackageObjectData) {
        originalPackageObjectData.primaryAcceptTemplateMember =
            PackageMediaService.originalPackageMediaData.selectedVideoAcceptTemplateMember;
        PackageMediaService.revertPackageMediaData();
        _this.packageObjectData = originalPackageObjectData;
        PackageMediaService.getPackageMediaData(_this.packageObjectData);
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    var setupComponentTabs = function (componentRoles) {
        var defaultRole = {};
        var requiredRoles = [];
        var optionalRoles = [];
        // order roles by 1) default, 2) required, 3) optional
        _.forEach(componentRoles, function (componentRole) {
            if (componentRole.isDefault) {
                defaultRole = componentRole;
            }
            else if (_.size(componentRole._partnersRequiring)) {
                requiredRoles.push(componentRole);
            }
            else {
                optionalRoles.push(componentRole);
            }
            _this.activeTabs[componentRole.name] = componentRole.isDefault;
        });
        _this.componentRoles = _.flatten([defaultRole, requiredRoles, optionalRoles]);
        _this.activeTabs[defaultRole.name] = true;
        _this.activeTabRole = _.find(componentRoles, { isDefault: true });
    };
    var getData = function () {
        return PackageMediaService.getPackageMediaData(_this.packageObjectData).then(function (packageMediaData) {
            return packageMediaData;
        });
    };
    var initRemoteUpload = function () {
        AsperaConnectService.initialize()
            .then(function () {
            console.info("PackageMediaView.initRemoteUpload(): init succeeded");
        })
            .catch(function (minAsperaConnectVersion) {
            console.info("PackageMediaView.initRemoteUpload(): init failed");
            ModalService.showMessageModal({
                messageText: "The AsperaConnect browser plugin failed to launch in time." +
                    " Would you like to try again?",
                title: "Re-launch AsperaConnect Plugin",
                windowClass: 'confirm-modal-sm',
                showOK: true,
                okText: 'Yes',
                pullCancelLeft: true
            }, 
            // accept handler
            function () {
                console.info("PackageMediaView.initRemoteUpload(): trying again");
                initRemoteUpload();
            }, 
            // reject handler
            function () {
                AsperaConnectService.reset();
                console.info("PackageMediaView.initRemoteUpload(): user declined to try again");
                NotificationService.createFailureNotification("AsperaConnect failed to launch.", "AsperaConnect could not be installed and/or launched. Asset upload will be disabled." +
                    " Please verify that AsperaConnect" +
                    (" " + minAsperaConnectVersion + " is installed and working") +
                    " properly and refresh the tab to try again.", true, -1);
            });
        });
    };
    this.$onInit = function () {
        _this.loadingIndicator.show = true;
        _this.activeTabs = {};
        PackageMediaService.getPackageMediaPermissions().then(function (permissions) {
            _this.isAdmin = permissions.isAdmin;
            _this.canRead = permissions.canRead;
            _this.canWrite = permissions.canWrite;
            if (_this.canRead) {
                getData().then(function (packageMediaData) {
                    initRemoteUpload();
                    setupComponentTabs(packageMediaData.componentRoles);
                    PackageUtilService.tabSaveFunction = _this.onSaveClicked;
                    PackageUtilService.tabRevertFunction = _this.onRevertClicked;
                    _this.loadingIndicator.show = false;
                    PackageMediaService.activateIngestProgressPollingInterval();
                });
            }
            else {
                _this.loadingIndicator.show = false;
            }
        });
        PackageUtilService.showHoldForComponentsCB = function () {
            return PackageMediaService.packageMediaData.pendingIngest && _this.getComponentRoleCount() > 1;
        };
    };
    this.$onDestroy = function () {
        PackageMediaService.deactivateIngestProgressPollingInterval();
        PackageMediaService.resetPackageMediaData(null);
        PackageFileUploadService.unregisterAllFiles();
        AsperaConnectService.reset();
    };
    this.$postLink = function () {
        $timeout(function () {
            PackageUtilService.editorForm = _this.packageMediaEditorForm;
        });
    };
}
angular.module('prism-ui.package').component('packageMediaView', {
    controller: PackageMediaViewController,
    templateUrl: 'package/editor/components/view/media/packagemedia-view-template.html',
    bindings: {
        loadingIndicator: '=',
        packageObjectData: '=',
        pkgEditCtrl: '='
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by richardwilliams on 5/27/15.
 */
'use strict';
function PackageMetadataViewController(_, $location, $q, $routeParams, $filter, $scope, $timeout, PackageUtilService, MetadataService, PackageResourceFactory, LanguageResourceFactory, ModalService, PermissionsService, PartnerPackagesService, NotificationService, RatingsService, DynamicPropertiesService) {
    var _this = this;
    var META_TAB_VIEW_STATE = 'PACKAGE_METADATA_VIEW_STATE';
    var ORD_VIEW_STATE = 'PACKAGE_ORD_VIEW_STATE';
    this.showAcceptedAndRejected = false;
    var originalPackageData = [];
    var lockFields = function () {
        var delivered = _this.packageObject.revision > 1;
        _this.lockableFields.title =
            _this.packageObject.categoryType.name === 'Long Form' &&
                _this.packageObject.title &&
                delivered;
        _this.lockableFields.productionNumber =
            _this.packageObject.categoryType.name === 'Long Form' &&
                _this.packageObject.productionNumber &&
                delivered;
        _this.lockableFields.category = !!_this.packageObject.category;
        _this.lockableFields.originalReleaseDate =
            _this.packageObject.categoryType.name === 'Long Form' &&
                _this.packageObject.originalReleaseDate && (!_this.ordPerms && !_this.packageObject.clone || delivered);
        _this.lockableFields.season = _this.packageObject.season && delivered;
        _this.lockableFields.volume = _this.packageObject.volume && delivered;
    };
    var composeMetadataComponents = function (packageObject) {
        _this.metadataComponentsMap = MetadataService.buildCustomComponentMap(packageObject.metadata.properties, PackageUtilService.errorsAndWarnings()[packageObject.name], true);
        _this.metadataComponentsMap =
            PackageUtilService.metadataComponentsMap =
                _.pickBy(_this.metadataComponentsMap, function (pkgMetaProp) {
                    return !pkgMetaProp.advanced;
                });
    };
    this.onRatingSystemChange = function () {
        _this.packageObject.rating.ratingCode = {};
        _this.packageObject.rating.ratingAdvisoryCodes = [];
        _this.advisoryCodes = [];
        PackageUtilService.editorForm.$setDirty();
    };
    var setAdvisoryCodes = function () {
        _this.advisoryCodes = [];
        var advisoryCodes = _.get(_this, 'ratingSystem.advisoryCodes', []);
        var applicableAdvisoryCodes = _.get(_this.packageObject, 'rating.ratingCode.applicableAdvisoryCodes', []);
        _this.advisoryCodes = _.filter(advisoryCodes, function (advisoryCode) {
            return _.includes(applicableAdvisoryCodes, advisoryCode.advisoryCode);
        });
    };
    this.onRatingChange = function () {
        _.set(_this.packageObject, 'rating.ratingAdvisoryCodes', []);
        setAdvisoryCodes();
    };
    this.onRatingClear = function () {
        _this.onRatingChange();
    };
    this.ratingSystem = undefined;
    this.setRatingSystem = function (packageObject) {
        var ratingSystemCode = DynamicPropertiesService.getPropValue('package.ratingSystem.default');
        ratingSystemCode = _.isUndefined(ratingSystemCode) ? 'us-tv' : ratingSystemCode;
        if (!_.isUndefined(_.get(packageObject, 'rating.ratingCode'))) {
            ratingSystemCode = RatingsService.getRatingSystemByRatingCode(_this.ratingSystems, packageObject.rating.ratingCode).systemCode;
        }
        _this.ratingSystem = _this.ratingSystems[ratingSystemCode];
    };
    var getEditData = function () {
        _this.loadingIndicator.show = true;
        _this.isAdmin = PermissionsService.isAdmin();
        _this.languages = LanguageResourceFactory.query({});
        _this.availableCategories = PackageResourceFactory.query({
            sub: 'categories',
            id: $routeParams.id
        });
        var metaServicePromise = MetadataService.propertiesPromise;
        var languagePromise = _this.languages.$promise;
        var categoriesPromise = _this.availableCategories.$promise;
        var ratingSystemsPromise = RatingsService.getRatingSystems();
        var writePermsPromise = PermissionsService.canWrite(META_TAB_VIEW_STATE);
        var ordWritePromise = PermissionsService.canWrite(ORD_VIEW_STATE);
        $location.search('subView', null);
        var promises = {
            languages: languagePromise,
            metaService: metaServicePromise,
            categories: categoriesPromise,
            ratingSystems: ratingSystemsPromise,
            write: writePermsPromise,
            ord: ordWritePromise,
        };
        if (_this.packageObject.content.type === 'Series') {
            promises.seasons = PackageResourceFactory.query({
                sub: 'seasons',
                id: $routeParams.id
            }).$promise;
            promises.volumes = PackageResourceFactory.query({
                sub: 'volumes',
                id: $routeParams.id
            }).$promise;
        }
        return $q.all(promises).then(function (editData) {
            if (_this.packageObject.clone) {
                var categoriesFilter = {
                    cloneable: true
                };
                _this.availableCategories = $filter('filter')(_this.availableCategories, categoriesFilter);
            }
            composeMetadataComponents(_this.packageObject);
            _this.languages = _.chain(_this.languages).partition({ isDefault: true }).flatten().value();
            _this.availableSeasons = editData.seasons;
            _this.availableVolumes = editData.volumes;
            _this.ratingSystems = editData.ratingSystems;
            _this.ratingSystemValues = _.values(_this.ratingSystems);
            _this.writePerms = editData.write;
            _this.ordPerms = editData.ord;
            _this.loading = false;
            lockFields();
            _this.setRatingSystem(_this.packageObject);
            setAdvisoryCodes();
            originalPackageData = angular.copy(_this.packageObject);
            _this.loadingIndicator.show = false;
        });
    };
    this.lockInitializer = function () {
        return false;
    };
    var packageSaved = function () {
        lockFields();
        PackageUtilService.createErrorsAndWarningsMap(_this.packageObject.validationResult);
        composeMetadataComponents(_this.packageObject);
    };
    this.revertMetadata = function (packageObject) {
        _this.setRatingSystem(packageObject);
        composeMetadataComponents(packageObject);
    };
    this.contentSelectionHandler = function (newContent) {
        if (newContent.id !== _this.packageObject.content.id) {
            ModalService.showMessageModal({
                messageText: 'Are you sure you want to update package content?',
                pullCancelLeft: true,
                title: 'Update Content',
                windowClass: 'confirm-modal-sm',
                showOK: true,
                okText: 'Yes',
                cancelText: 'No'
            }, function (confirmationResult) {
                if (confirmationResult === 'OK') {
                    _this.packageObject.content = newContent;
                    _this.packageMetadataEditorForm.$setDirty();
                    PackageUtilService.tabSaveFunction().then(function () {
                        // the DTO isn't refreshed on save, so
                        // manually grab the new data to get e.g.
                        // the new categories
                        getEditData();
                    });
                }
            });
        }
    };
    this.changeContent = function () {
        ModalService.showContentSelectModal(_this.packageObject.content.type, undefined, _this.contentSelectionHandler);
    };
    this.isRatingRequired = function () {
        return _this.packageObject.content.type === 'Series';
    };
    this.hasVolumes = function () {
        return (_this.packageObject.content.type === 'Series' &&
            !!_this.availableVolumes &&
            _this.availableVolumes.length > 0);
    };
    this.showApprovalMessage = function (partnerPackage) {
        ModalService.showMessageModal({
            messageText: "Message: " + partnerPackage.approvalMessage,
            title: _.capitalize(partnerPackage.approvalStatus) + " " + partnerPackage.partnerName + " Pre-Delivery QC Approval",
            windowClass: 'confirm-modal-lg',
            showOK: true,
            showCancel: false
        });
    };
    this.showApprovePartnerPackageModal = function (partnerPackage) {
        ModalService.showPartnerPackageAcceptRejectModal('Accept', partnerPackage.partnerName, function (approvalMessage) {
            approvePartnerPackageForPreDeliveryQc(partnerPackage, approvalMessage);
        });
    };
    var approvePartnerPackageForPreDeliveryQc = function (partnerPackage, message) {
        _this.loadingIndicator.show = true;
        PartnerPackagesService.approvePartnerPackageForPreDeliveryQc(partnerPackage.id, message).then(function () {
            NotificationService.createSuccessNotification("Accepted " + partnerPackage.partnerName + " Pre-Delivery QC Approval.", 5000);
            getPackageStatus();
        }).catch(function (error) {
            NotificationService.createFailureNotification("Could not Accept " + partnerPackage.partnerName + " Pre-Delivery QC Approval. [" + error + "]");
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    this.showRejectPartnerPackageModal = function (partnerPackage) {
        ModalService.showPartnerPackageAcceptRejectModal('Reject', partnerPackage.partnerName, function (approvalMessage) {
            rejectPartnerPackageForPreDeliveryQc(partnerPackage, approvalMessage);
        });
    };
    var rejectPartnerPackageForPreDeliveryQc = function (partnerPackage, message) {
        _this.loadingIndicator.show = true;
        PartnerPackagesService.rejectPartnerPackageForPreDeliveryQc(partnerPackage.id, message).then(function () {
            NotificationService.createSuccessNotification("Rejected " + partnerPackage.partnerName + " Pre-Delivery QC Approval.", 5000);
            getPackageStatus();
        }).catch(function (error) {
            console.error("Could not Reject " + partnerPackage.partnerName + ". [" + error + "]");
            NotificationService.createFailureNotification("Could not Reject " + partnerPackage.partnerName + " Pre-Delivery QC Approval. [" + error + "]");
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var getPackageStatus = function () {
        PackageResourceFactory.get({
            id: $routeParams.id,
            view: 'STATUS'
        }).$promise
            .then(function (packageData) {
            _this.pendingPartnerPackages = packageData.pendingPartnerPackages;
        });
    };
    // **************************************************************** //
    // **************************************************************** //
    // **** Seriously! Always perform this action before you save  **** //
    // **** metadata items to ensure the correct data is persisted **** //
    // **************************************************************** //
    // **************************************************************** //
    this.onMetadataUpdate = function (event) {
        _this.validationErrors = event.errors;
        if (!_this.validationErrors) {
            _this.metadataComponentsMap[event.name].instanceData.value = event.items;
        }
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        // Map of lockable fields and isLocked status
        _this.lockableFields = {
            title: false,
            productionNumber: false,
            category: false,
            originalReleaseDate: false,
            season: false,
            volume: false
        };
        _this.isAdmin = false;
        _this.loading = true;
        _this.metadataComponentsMap = {};
        _this.advisoryCodes = [];
        // Set event handlers in PackageUtilService
        PackageUtilService.tabRevertFunction = _this.revertMetadata;
        PackageUtilService.postPackageSaveFunction = packageSaved;
        getEditData().then(function () {
            _this.isLongformEditor = _this.packageObject.categoryType.name === 'Long Form';
            // queryForProperties called by package-edit-controller
            _this.maxTitleLength = DynamicPropertiesService.getPropValueAsInt('package.longForm.maxTitleLength', -1);
            _this.maxShortDescLength = DynamicPropertiesService.getPropValueAsInt('package.longForm.maxShortDescLength', -1);
            _this.maxLongDescLength = DynamicPropertiesService.getPropValueAsInt('package.longForm.maxLongDescLength', -1);
            _this.maxKeywordsLength = DynamicPropertiesService.getPropValueAsInt('package.longForm.maxKeywordsLength', -1);
            if (!_this.isLongformEditor) {
                // default to long form values if there's no
                // shortForm-specific properties set
                _this.maxTitleLength = DynamicPropertiesService.getPropValueAsInt('package.shortForm.maxTitleLength', _this.maxTitleLength);
                _this.maxShortDescLength = DynamicPropertiesService.getPropValueAsInt('package.shortForm.maxShortDescLength', _this.maxShortDescLength);
                _this.maxLongDescLength = DynamicPropertiesService.getPropValueAsInt('package.shortForm.maxLongDescLength', _this.maxLongDescLength);
                _this.maxKeywordsLength = DynamicPropertiesService.getPropValueAsInt('package.shortForm.maxKeywordsLength', _this.maxKeywordsLength);
            }
            var requiredFields = DynamicPropertiesService.getPropValueAsArray('translatable.text.package.required.properties', []);
            _this.translatableMetadataFields = [
                {
                    name: 'title',
                    title: 'Title',
                    maxChars: _this.maxTitleLength,
                    required: _.includes(requiredFields, 'title'),
                },
                {
                    name: 'shortDescription',
                    title: 'Short Description',
                    maxChars: _this.maxShortDescLength,
                    required: _.includes(requiredFields, 'shortDescription'),
                },
                {
                    name: 'longDescription',
                    title: 'Long Description',
                    maxChars: _this.maxLongDescLength,
                    required: _.includes(requiredFields, 'longDescription'),
                },
                {
                    name: 'keywords',
                    title: 'Keywords',
                    type: 'multi',
                    maxChars: _this.maxKeywordsLength,
                    required: _.includes(requiredFields, 'keywords'),
                },
            ];
            _this.pendingPartnerPackages = _this.packageObject.pendingPartnerPackages;
        });
    };
    this.$onChanges = function (changes) {
        _this.pendingPartnerPackages = changes.pendingPartnerPackages.currentValue;
    };
    this.$postLink = function () {
        $timeout(function () {
            PackageUtilService.editorForm = _this.packageMetadataEditorForm;
        });
    };
}
angular
    .module('prism-ui.package')
    .component('packageMetadataView', {
    controller: PackageMetadataViewController,
    templateUrl: 'package/editor/components/view/metadata/packagemetadata-view-template.html',
    bindings: {
        packageObject: '=',
        loadingIndicator: '=',
        pkgEditCtrl: '=',
        pendingPartnerPackages: '<'
    },
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by richardwilliams on 5/28/15,
 * Refactored by kyang on 10/2/19.
 */
function PackageStatusBarController($routeParams, $scope, ModalService, PermissionsService) {
    var _this = this;
    var APPROVAL_VIEW_STATE = 'PACKAGE_APPROVE_REJECT_VIEW_STATE';
    //==============//
    // Errors Modal //
    //==============//
    this.showErrorsWarningsButton = function () {
        return _this.packageObject.validationResult && _this.packageObject.validationResult.length;
    };
    this.showErrorsWarningsModal = function () {
        ModalService.showErrorsWarningsModal(_this.packageObject.validationResult, _this.packageObject.name);
    };
    //==================//
    // Approval Buttons //
    //==================//
    this.showApprovalButtons = function () {
        return !_this.packageObject.acceptStatus &&
            _this.packageObject.metadataErrorCount === '0' &&
            _this.packageObject.mediaErrorCount === '0' &&
            (_this.packageObject.primaryVideo &&
                _this.packageObject.primaryVideo.proxyId);
    };
    this.showApprovalText = function () {
        return !_this.showApprovalButtons();
    };
    this.showRejectedButton = function () {
        return _this.packageObject.acceptStatus === 'REJECTED';
    };
    this.openRejectionModal = function () {
        ModalService.showRejectPackageModal(_this.packageObject.rejectReason);
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    var getApprovePermissions = function () {
        PermissionsService.canWritePackage(APPROVAL_VIEW_STATE, $routeParams.id)
            .then(function (perms) {
            _this.approvalPermitted = perms;
        });
    };
    this.$onInit = function () {
        _this.approvalPermitted = false;
        getApprovePermissions();
    };
}
angular.module('prism-ui.package').component('packageStatusBar', {
    bindings: {
        packageObject: '=',
        acceptHandler: '&',
        rejectHandler: '&'
    },
    controller: PackageStatusBarController,
    templateUrl: 'package/editor/components/view/statusbar/packagestatus-bar-template.html',
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by sjacobs on 8/27/18.
 */
function SourceCollaboratorsController(ModalService, uiGridConstants) {
    var _this = this;
    this.$onInit = function () {
        _this.gridOptions.data = _this.editData.emailContacts;
    };
    this.addContact = function () {
        var existingEmailContactIds = _.map(_this.editData.emailContacts, 'id');
        ModalService.showContactsSelectModal(existingEmailContactIds, onContactSelected);
    };
    this.removeSelectedContacts = function () {
        var selectedContacts = _this.gridApi.selection.getSelectedRows();
        ModalService.showMessageModal({
            messageText: 'Are you sure you want to remove the selected contact(s)?',
            pullCancelLeft: true,
            title: 'Remove Contact(s)',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, function () {
            _.set(_this, 'editData.emailContacts', _.differenceBy(_this.editData.emailContacts, selectedContacts, 'id'));
            _this.gridOptions.data = _this.editData.emailContacts;
            _this.editorForm.$setDirty();
        });
    };
    var onContactSelected = function (selection) {
        _.set(_this, 'editData.emailContacts', _.unionBy(_this.editData.emailContacts, selection, 'id'));
        _this.gridOptions.data = _this.editData.emailContacts;
        _this.editorForm.$setDirty();
    };
    var columnDefinitions = [
        {
            field: 'firstName',
            displayName: 'First Name',
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'lastName',
            displayName: 'Last Name',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'emailAddress',
            displayName: 'Email Address',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: true,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: true,
        data: [],
        columnDefs: columnDefinitions,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
}
angular.module('prism-ui.externalMetadata').component('sourceCollaborators', {
    controller: SourceCollaboratorsController,
    templateUrl: 'system/externalMetadata/setup/editor/sourceCollaborators/source-collaborators-template.html',
    bindings: {
        editData: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: directory-edit-service.ts
 *
 * Created by kyang on 2020-09-15.
 */
angular.module('prism-ui.fileSystem').service('DirectoryEditService', function () {
    this.editorForm = null;
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: directory-edit-view-component.ts
 *
 * Created by kyang on 2020-09-11.
 */
function DirectoryEditViewController($location, $q, $route, $routeParams, BreadcrumbService, DirectoryService, DirectoryEditService, FileSystemService, SidebarService) {
    //================//
    // Template Logic //
    //================//
    var _this = this;
    var pathRequirementsByType = {
        AWS: [{
                getDescription: function () { return 'AWS path must end with a "/"'; },
                isValid: function () { return _this.directoryObject && _.endsWith(_this.directoryObject.path, '/'); },
            }]
    };
    this.editingNewDirectory = function () {
        return $routeParams.directoryId === '-1';
    };
    //=========//
    // Toolbar //
    //=========//
    var saveEditData = function () {
        var savePromise;
        _this.loadingIndicator.show = true;
        if (_this.editingNewDirectory()) {
            savePromise = DirectoryService.createDirectory(_this.directoryObject);
        }
        else {
            savePromise = DirectoryService.updateDirectory(_this.directoryObject);
        }
        savePromise.then(function (directory) {
            _this.originalEditData = _.cloneDeep(directory);
            _this.directoryObject = directory;
            _this.editorForm.$setPristine();
            $route.updateParams({ id: $routeParams.id, directoryId: directory.id });
        })
            .finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var revertEditData = function () {
        _this.directoryObject = _.cloneDeep(_this.originalEditData);
        _this.editorForm.$setPristine();
        if (_this.editingNewDirectory()) {
            exitEdit();
        }
    };
    var exitEdit = function () {
        var fileSystemId = $routeParams.id;
        $location.url("/system/fileSystems/edit/" + fileSystemId + "/directories");
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return !_this.editorForm.$pristine && _this.editorForm.$valid; },
            onClick: saveEditData
        }, {
            label: 'Revert',
            enabled: function () { return !_this.editorForm.$pristine || _this.editingNewDirectory(); },
            onClick: revertEditData
        }, {
            label: 'Close',
            enabled: function () { return _this.editorForm.$pristine && !_this.editingNewDirectory(); },
            onClick: exitEdit
        }
    ];
    //=================//
    // Lifecycle Hooks //
    //=================//
    var setBreadcrumbData = function (fileSystem) {
        BreadcrumbService.clearBreadcrumbs();
        BreadcrumbService.addBreadcrumb({
            location: '/system/fileSystems/search',
            name: 'File Systems',
        });
        BreadcrumbService.addBreadcrumb({
            location: "/system/fileSystems/edit/" + fileSystem.id + "/directories",
            name: fileSystem.name,
        });
    };
    var getData = function () {
        var promises = [];
        _this.loadingIndicator.show = true;
        promises.push(FileSystemService.getFileSystem($routeParams.id)
            .then(function (fileSystem) {
            _this.pathRequirements = pathRequirementsByType[fileSystem.typeName];
            setBreadcrumbData(fileSystem);
        }));
        if (_this.editingNewDirectory()) {
            _this.directoryObject = _.get(_this, 'directoryObject', {
                filesystemId: $routeParams.id,
                defaultPermissionRead: true,
                defaultPermissionWrite: true,
            });
            _this.originalEditData = _.cloneDeep(_this.directoryObject);
        }
        else {
            promises.push(DirectoryService.getDirectory($routeParams.directoryId)
                .then(function (directory) {
                _this.originalEditData = _.cloneDeep(directory);
                _this.directoryObject = directory;
            }));
        }
        $q.all(promises).then(function () {
            _this.loadingIndicator.show = false;
        });
    };
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        getData();
    };
    this.$postLink = function () {
        DirectoryEditService.editorForm = _this.editorForm;
        SidebarService.editService = DirectoryEditService;
    };
}
angular.module('prism-ui.fileSystem').component('directoryEditView', {
    templateUrl: 'system/fileSystem/editView/directory/editView/directory-edit-view-template.html',
    controller: DirectoryEditViewController
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: directory-search-view-component.ts
 *
 * Created by kyang on 2020-09-11.
 */
function DirectorySearchViewController($location, $q, $routeParams, BreadcrumbService, DirectoryService, FileSystemService, FileSystemEditService, ModalService, NavbarUtilService, PermissionsService, SearchFilterService, uiGridConstants) {
    //======//
    // Grid //
    //======//
    var _this = this;
    var columnDefs = [
        {
            field: 'name',
            displayName: 'Name',
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }, {
            field: 'description',
            displayName: 'Description',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }, {
            field: 'path',
            displayName: 'Path',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }, {
            field: 'defaultPermissionRead',
            type: 'boolean',
            maxWidth: 95,
            displayName: 'Read',
            cellTemplate: 'components/visual/grid/radio-button-template.html'
        }, {
            field: 'defaultPermissionWrite',
            type: 'boolean',
            maxWidth: 95,
            displayName: 'Write',
            cellTemplate: 'components/visual/grid/radio-button-template.html'
        }
    ];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: false,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: columnDefs,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
    this.onRowDblClick = function (row) {
        navigateToEditView(row.entity);
    };
    //======//
    // Data //
    //======//
    var setBreadcrumbData = function (fileSystem) {
        BreadcrumbService.clearBreadcrumbs();
        BreadcrumbService.addBreadcrumb({
            location: '/system/fileSystems/search',
            name: 'File Systems',
            params: angular.copy($location.search())
        });
        FileSystemEditService.setOriginalEditData(fileSystem);
    };
    var getData = function () {
        var criteria = {
            fetchOffset: 0,
            fetchLimit: 1000000,
            searchString: $location.search().searchText
        };
        _this.loadingIndicator.show = true;
        $q.all([
            DirectoryService.getDirectories(criteria)
                .then(function (directories) {
                _this.gridOptions.data = _.filter(directories, {
                    filesystemId: $routeParams.id
                });
            }),
            FileSystemService.getFileSystem($routeParams.id)
                .then(setBreadcrumbData)
        ]).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    //=========//
    // Toolbar //
    //=========//
    var navigateToEditView = function (entity) {
        var fileSystemId = $routeParams.id;
        var directoryId = _.get(entity, 'id') || _this.gridApi.selection.getSelectedRows()[0].id;
        $location.url("/system/fileSystems/edit/" + fileSystemId + "/directories/edit/" + directoryId);
    };
    var openMoveFolderModal = function () {
        var sourceFileSystemId = $routeParams.id;
        var directory = _this.gridApi.selection.getSelectedRows()[0];
        ModalService.showMoveDirectoryModal(sourceFileSystemId, function (targetFileSystem) {
            _this.loadingIndicator.show = true;
            DirectoryService.moveDirectory(directory, targetFileSystem.id)
                .then(getData);
        });
    };
    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: function () { return true; },
            onClick: function () {
                navigateToEditView({ id: -1 });
            }
        }, {
            label: 'Edit',
            enabled: function () {
                return !_.isEmpty(_this.gridApi.selection.getSelectedRows());
            },
            onClick: navigateToEditView
        }, {
            label: 'Move',
            icon: ['fa-folder-o', 'fa-arrow-right'],
            enabled: function () {
                return !_.isEmpty(_this.gridApi.selection.getSelectedRows());
            },
            onClick: openMoveFolderModal
        }
    ];
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        if (!PermissionsService.isAdmin()) {
            $location.url('/login');
        }
        else {
            NavbarUtilService.viewSearchFunction = getData;
            SearchFilterService.populateCriteriaFromLocationSearch();
            getData();
        }
    };
}
angular.module('prism-ui.fileSystem').component('directorySearchView', {
    templateUrl: 'system/fileSystem/editView/directory/searchView/directory-search-view-template.html',
    controller: DirectorySearchViewController
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function MediaAcceptProfileMemberController(_, uiGridConstants, $route, $location, PackageAcceptTemplatesService, ModalService, BreadcrumbService, SidebarService, $timeout) {
    var _this = this;
    this.$onInit = function () {
        setGridData();
    };
    this.$onChanges = function () {
        setGridData();
    };
    var setGridData = function () {
        _this.gridOptions.data = _.filter(_.get(_this.ngModel, _this.modelProp), function (mediaAcceptProfile) {
            return mediaAcceptProfile.type === _this.mediaAcceptProfileType;
        });
    };
    this.addMediaProfileHandler = function () {
        ModalService.showMediaAcceptProfilesModal(selectedMediaAcceptProfilesHandler, _this.mediaAcceptProfileType);
    };
    this.removeMediaAcceptProfile = function () {
        var selectedMediaAcceptProfiles = _this.gridApi.selection.getSelectedRows();
        ModalService.showMessageModal({
            messageText: 'Are you sure you want to remove the selected mediaAcceptProfile(s)?',
            pullCancelLeft: true,
            title: 'Remove Media Accept Profile(s)',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, function () {
            _.set(_this.ngModel, _this.modelProp, _.differenceBy(_.get(_this.ngModel, _this.modelProp), selectedMediaAcceptProfiles, 'id'));
            setGridData();
            _this.editorForm.$setDirty();
        });
    };
    var selectedMediaAcceptProfilesHandler = function (selectedMediaAcceptProfiles) {
        var numberOfMediaAcceptProfilesBeforeAdd = _.size(_.get(_this.ngModel, _this.modelProp));
        _.set(_this.ngModel, _this.modelProp, _.unionBy(_.get(_this.ngModel, _this.modelProp), selectedMediaAcceptProfiles, 'id'));
        if (_.size(_.get(_this.ngModel, _this.modelProp)) > numberOfMediaAcceptProfilesBeforeAdd) {
            _this.editorForm.$setDirty();
            setGridData();
        }
    };
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: true,
        columnDefs: [
            {
                field: 'name',
                displayName: 'Name',
                sort: {
                    direction: 'asc',
                },
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                field: 'type',
                displayName: 'Type',
                cellTemplate: 'system/templates/mediaAcceptProfiles/searchView/renderers/accept-profile-tooltip-template.html'
            }
        ],
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        data: []
    };
}
angular.module('prism-ui.packageAcceptTemplate').component('mediaAcceptProfileMember', {
    templateUrl: 'system/templates/packageAcceptTemplates/editView/mediaAcceptProfileMembers/media-accept-profile-member-template.html',
    controller: MediaAcceptProfileMemberController,
    bindings: {
        mediaAcceptProfileType: '<',
        ngModel: '<',
        modelProp: '<',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: branding-asset-edit-service.ts
 *
 * Created by kyang on 1/11/2021.
 */
angular.module('prism-ui.components.branding').service('BrandingAssetEditService', function (_) {
    this.editorForm = null;
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: branding-media-edit-view-component.ts
 *
 * Created by rwilliams on 8/6/17,
 * Refactored by kyang on 10/20/20.
 */
function BrandingMediaEditViewController(_, $q, $location, $route, $routeParams, BrandingAssetEditService, BrandingAssetService, BrandingViewService, BreadcrumbService, LanguagesService, RatingsService, RolesService, SidebarService, TerritoriesService) {
    var _this = this;
    var hasBrandingAssetContainer = function () {
        return _this.brandingConfig.type !== 'ratingOverlays';
    };
    var getContainerLocation = function () {
        var basePath = _this.brandingConfig.parentLocation;
        if (_this.brandingConfig.groupName === 'networks') {
            basePath += '/' + $route.current.params.type;
        }
        return basePath + "/edit/" + _this.brandingAssetContainer.id;
    };
    var editingNewBrandingAsset = function () {
        return !_.get(_this, 'originalEditData.id');
    };
    //===================//
    // Template Response //
    //===================//
    this.addAudio = function () {
        _this.rootAsset.audios.push({});
        _this.editorForm.$setDirty();
    };
    this.removeAudio = function (audioIndex) {
        _this.rootAsset.audios.splice(audioIndex, 1);
        _this.editorForm.$setDirty();
    };
    this.addText = function () {
        _this.rootAsset.texts.push({});
        _this.editorForm.$setDirty();
    };
    this.removeText = function (textIndex) {
        _this.rootAsset.texts.splice(textIndex, 1);
        _this.editorForm.$setDirty();
    };
    this.addArtwork = function () {
        _this.rootAsset.assets.push({
            acceptProfile: _this.rootAsset.acceptProfile,
            type: _this.rootAsset.type,
        });
        _this.editorForm.$setDirty();
    };
    this.removeArtwork = function (artIndex) {
        _this.rootAsset.assets.splice(artIndex, 1);
        _this.editorForm.$setDirty();
    };
    this.addOverlayImage = function () {
        _this.rootAsset.images.push({
            mediaAcceptProfile: _this.rootAsset.mediaAcceptProfile,
        });
        _this.editorForm.$setDirty();
    };
    this.removeOverlayImage = function (imageIndex) {
        _this.rootAsset.images.splice(imageIndex, 1);
        _this.editorForm.$setDirty();
    };
    //=========//
    // Toolbar //
    //=========//
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return _this.canWriteMedia && !_this.editorForm.$pristine && _this.editorForm.$valid; },
            onClick: function () {
                var savePromise;
                _this.loadingIndicator.show = true;
                if (editingNewBrandingAsset()) {
                    savePromise = BrandingAssetService.createRootBrandingAsset(_this.brandingConfig, _this.rootAsset);
                }
                else {
                    savePromise = BrandingAssetService.updateRootBrandingAsset(_this.brandingConfig, _this.rootAsset);
                }
                savePromise.then(function () {
                    return getData();
                }).then(function () {
                    if (BrandingAssetService.hasVideoAssetProxyStatus(_this.brandingConfig, _this.rootAsset)) {
                        BrandingViewService.createRootAssetProxyNotifications(_this.brandingConfig, _this.rootAsset)
                            .finally(getData);
                    }
                }).finally(function () {
                    _this.loadingIndicator.show = false;
                });
            }
        }, {
            label: 'Revert',
            enabled: function () { return !_this.editorForm.$pristine; },
            onClick: function () {
                _this.rootAsset = _.cloneDeep(_this.originalEditData);
                _this.selectedRatingSystems = _.cloneDeep(_this.originalSelectedRatingSystems);
                _this.editorForm.$setPristine();
            }
        }, {
            label: 'Close',
            enabled: function () { return _this.editorForm.$pristine; },
            onClick: function () {
                if (hasBrandingAssetContainer()) {
                    $location.path(getContainerLocation());
                }
                else {
                    $location.path(_this.brandingConfig.parentLocation);
                    $location.search("view=" + _this.brandingConfig.type);
                }
            }
        }
    ];
    //=================//
    // Lifecycle Hooks //
    //=================//
    var setBreadcrumbs = function () {
        if (!_this.breadcrumbName) {
            return BrandingViewService.initializeParentBreadcrumbs(_this.brandingConfig, $route.current.params)
                .then(function () {
                if (hasBrandingAssetContainer()) {
                    BreadcrumbService.addBreadcrumb({
                        name: _this.brandingAssetContainer.name,
                        location: getContainerLocation(),
                    });
                }
                _this.breadcrumbName = _this.mediaAcceptProfile.name;
            });
        }
    };
    var getData = function () {
        _this.loadingIndicator.show = true;
        return $q.all({
            container: BrandingAssetService.getBrandingAssetContainer(_this.brandingConfig),
            audioRoles: RolesService.getTypedRoles('audio'),
            ccRoles: RolesService.getTypedRoles('cc'),
            languages: LanguagesService.getAllLanguages(),
            mediaAcceptProfiles: BrandingViewService.getMediaAcceptProfiles(),
            ratingSystems: RatingsService.getRatingSystems(),
            territories: TerritoriesService.getAllTerritories({ fetchLimit: 0, includeHidden: false }),
        }).then(function (data) {
            var _a;
            _this.brandingAssetContainer = data.container;
            _this.mediaAcceptProfile = data.mediaAcceptProfiles.find(function (acceptProfile) {
                return acceptProfile.id === $routeParams.acceptProfileId;
            });
            _this.editorForm.$setPristine();
            _this.originalEditData = BrandingAssetService.getRootBrandingAsset(_this.brandingConfig, _this.brandingAssetContainer, _this.mediaAcceptProfile);
            if (_this.canReadMedia) {
                _this.rootAsset = _.cloneDeep(_this.originalEditData);
                _this.availableAudioRoles = _.sortBy(data.audioRoles, 'name');
                _this.availableLanguages = _.chain(data.languages)
                    .orderBy('name')
                    .partition({ isDefault: true })
                    .flatten()
                    .value();
                if (_this.brandingConfig.groupName === 'networks') {
                    _this.availableRatingSystems = _.values(data.ratingSystems);
                    _this.selectedRatingSystems = _.map(_this.rootAsset.images, function (image) {
                        return RatingsService.getRatingSystemByRatingCode(data.ratingSystems, image.rating.ratingCode);
                    });
                    _this.originalSelectedRatingSystems = _.cloneDeep(_this.selectedRatingSystems);
                }
                _this.availableTerritories = _.chain(data.territories)
                    .orderBy('name')
                    .partition({ name: 'USA' })
                    .flatten()
                    .value();
                _this.availableTextRoles = _.sortBy(data.ccRoles, 'name');
                data.mediaAcceptProfiles = _.sortBy(data.mediaAcceptProfiles, 'name');
                _this.availableArtworkAcceptProfiles = _.filter(data.mediaAcceptProfiles, { type: 'OTHER' });
                _this.availableAudioAcceptProfiles = _.filter(data.mediaAcceptProfiles, { type: 'AUDIO' });
                _this.availableImageAcceptProfiles = _.filter(data.mediaAcceptProfiles, { type: 'IMAGE' });
                _this.availableArtworkLanguages = [{
                        id: -1,
                        name: '[None]'
                    }];
                (_a = _this.availableArtworkLanguages).push.apply(_a, data.languages);
            }
            setBreadcrumbs();
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    this.$onInit = function () {
        _this.breadcrumbName = '';
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.loadingIndicator.show = true;
        BrandingViewService.getReadWritePermissions(_this.brandingConfig)
            .then(function (permissions) {
            _this.canReadMedia = permissions.read;
            _this.canWriteMedia = permissions.write;
            return getData();
        });
    };
    this.$postLink = function () {
        BrandingAssetEditService.editorForm = _this.editorForm;
        BreadcrumbService.editService = BrandingAssetEditService;
        SidebarService.editService = BrandingAssetEditService;
    };
    this.$onDestroy = function () {
        BrandingAssetEditService.editorForm = null;
        BreadcrumbService.clearBreadcrumbs();
    };
}
angular
    .module('prism-ui.components.branding')
    .component('brandingMediaEditView', {
    templateUrl: 'components/branding/editView/components/media/editView/branding-media-edit-view-template.html',
    controller: BrandingMediaEditViewController,
    bindings: {
        brandingConfig: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function AggregationTabController($q, $timeout, uiGridConstants, AggregationResourceFactory, ContentEditService, DownloadAssetService, EndPointService, UtilsService) {
    // const PACKAGE_EXTERNAL_INGESTS_VIEW_STATE = 'PACKAGE_EXTERNAL_INGESTS_VIEW_STATE';
    var _this = this;
    //======//
    // Grid //
    //======//
    var gridColumnDefs = [
        {
            field: 'aggregationDate',
            width: 250,
            cellTemplate: 'components/visual/grid/date-time-column-template.html'
        },
        {
            displayName: 'Source Link',
            field: 'sourceFile.uri',
            width: 90,
            cellTemplate: 'components/visual/grid/text-file-download-template.html',
        },
        {
            displayName: 'Source Filename',
            field: 'sourceFile.filename',
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        },
        {
            displayName: 'Transf. Link',
            field: 'transformedFile.uri',
            width: 90,
            cellTemplate: 'components/visual/grid/text-file-download-template.html',
        },
        {
            displayName: 'Transformed Filename',
            field: 'transformedFile.filename',
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        },
    ];
    var uriLookup = {};
    this.gridOptions = {
        enableColumnMenus: false,
        enableColumnResizing: false,
        enableFullRowSelection: false,
        enablePaginationControls: false,
        enableRowHeaderSelection: false,
        enableRowSelection: false,
        enableSorting: false,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        multiSelect: false,
        columnDefs: gridColumnDefs,
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
    this.getAssetURI = function (assetVersionId) {
        if (_.size(assetVersionId) <= 0) {
            return undefined;
        }
        return DownloadAssetService.getAssetUri(assetVersionId, 'document', DownloadAssetService.ContentUse.Source);
    };
    this.downloadFile = function (taskUri) {
        var file = uriLookup[taskUri];
        UtilsService.downloadFile(file.uri, file.filename);
    };
    //===================//
    // Template Response //
    //===================//
    this.areControlsEnabled = function () {
        return true;
    };
    this.onExternalIdChange = function () {
        if (_.get(_this.contentObject, 'externalId.length') == 0)
            _this.contentObject.externalId = null;
    };
    this.clearExternalId = function () {
        _this.contentObject.externalId = null;
        _this.editorForm.$setDirty();
    };
    this.clearExternalDateUpdated = function () {
        _this.contentObject.externalDateUpdated = null;
        _this.editorForm.$setDirty();
    };
    //=========//
    // Toolbar //
    //=========//
    var isDirty = function () {
        var isDirty = _.get(_this, 'editorForm.$dirty');
        return _this.contentObject && isDirty;
    };
    this.toolbarButtonDefs = [
        // Save
        {
            label: 'Save',
            enabled: function () { return isDirty(); },
            onClick: function () {
                _this.loadingIndicator.show = true;
                ContentEditService.saveEditData().then(function () {
                    _this.contentObject = ContentEditService.contentObject;
                    _this.loadingIndicator.show = false;
                    _this.editorForm.$setPristine();
                });
            }
        },
        // Revert
        {
            label: 'Revert',
            enabled: function () { return isDirty(); },
            onClick: function () {
                ContentEditService.revertEditData();
                _this.contentObject = ContentEditService.contentObject;
                _this.editorForm.$setPristine();
            }
        },
        // Close
        {
            label: 'Close',
            enabled: function () { return true; },
            onClick: function () { return ContentEditService.exitEdit(); },
        }
    ];
    //=================//
    // Lifecycle Hooks //
    //=================//
    var getEditData = function () {
        return AggregationResourceFactory.getTasks({
            contentId: _this.contentObject.id,
            externalSystem: _this.contentObject.externalSystem,
            externalId: _this.contentObject.externalId,
        }).$promise.then(function (ingestLogs) {
            _this.gridOptions.data = ingestLogs;
            var uriPromises = [];
            _.forEach(ingestLogs, function (ingestLog) {
                var sourceFile = {
                    uri: EndPointService.aggregationEndPoint + "/tasks/" + ingestLog.id + "/xml?sourceXml=true",
                    filename: ingestLog.sourceFilename,
                };
                uriLookup[sourceFile.uri] = sourceFile;
                ingestLog.sourceFile = sourceFile;
                var transformedFile = {
                    uri: EndPointService.aggregationEndPoint + "/tasks/" + ingestLog.id + "/xml?sourceXml=false",
                    filename: UtilsService.appendBaseFilename(ingestLog.sourceFilename, '_transformed'),
                };
                uriLookup[transformedFile.uri] = transformedFile;
                ingestLog.transformedFile = transformedFile;
            });
            return $q.all(uriPromises);
        });
    };
    this.$onInit = function () {
        _this.loadingIndicator.show = true;
        ContentEditService.contentObject.$promise.then(function () {
            _this.contentObject = ContentEditService.contentObject;
            return getEditData();
        }).then(function () {
            _this.loadingIndicator.show = false;
        });
    };
    this.$postLink = function () {
        $timeout(function () {
            ContentEditService.editorForm = _this.editorForm;
        });
    };
}
angular
    .module('prism-ui.content')
    .component('aggregationTab', {
    templateUrl: 'meta/content/editor/components/view/aggregation/aggregation-tab-template.html',
    controller: AggregationTabController,
    bindings: {
        loadingIndicator: '<',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function ContentPackageAcceptTemplatesController($routeParams, ContentEditService, EnumService, $timeout, $location, $route) {
    var _this = this;
    /*
        Get the CPAT data
     */
    var getData = function () {
        _this.loadingIndicator.show = true;
        _this.editData = undefined;
        EnumService.queryForEnums().then(function () {
            return ContentEditService.getContentPackageAcceptTemplatesEditData($routeParams.id).then(function (editData) {
                ContentEditService.originalPackageAcceptTemplateData = _.cloneDeep(editData);
                _this.editData = editData;
                _this.editorForm.$setPristine();
            });
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    /*
        Handler for Save toolbar button
     */
    var updateData = function () {
        _this.loadingIndicator.show = true;
        prepareContentPackageAcceptTemplateContainersForUpdate();
        ContentEditService.updateContentPackageAcceptTemplates($routeParams.id, _this.editData.contentPackageAcceptTemplateContainers).then(function (data) {
            getData();
        });
    };
    /*
        Transforms members array and removes any CPAT Containers that have not been associated with members
     */
    var prepareContentPackageAcceptTemplateContainersForUpdate = function () {
        _.forEach(_.get(_this, 'editData.contentPackageAcceptTemplateContainers'), function (contentPackageAcceptTemplateContainer) {
            _.set(contentPackageAcceptTemplateContainer, 'members', _.flatMap(_.get(contentPackageAcceptTemplateContainer, 'members')));
            _.unset(contentPackageAcceptTemplateContainer, 'packageAcceptTemplate.mediaAcceptProfiles');
            _.unset(contentPackageAcceptTemplateContainer, 'packageAcceptTemplate.type');
        });
        _.remove(_.get(_this, 'editData.contentPackageAcceptTemplateContainers'), function (contentPackageAcceptTemplateContainer) {
            return _.isNil(_.get(contentPackageAcceptTemplateContainer, 'packageAcceptTemplate.id'));
        });
    };
    /*
        Handler for Revert toolbar button
     */
    var revertEditData = function () {
        _this.editData = _.cloneDeep(ContentEditService.originalPackageAcceptTemplateData);
        _this.editorForm.$setPristine();
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return _this.editorForm && _this.editorForm.$dirty; },
            onClick: updateData
        },
        {
            label: 'Revert',
            enabled: function () { return _this.editorForm && _this.editorForm.$dirty; },
            onClick: revertEditData
        },
        {
            label: 'Close',
            enabled: function () { return true; },
            onClick: function () {
                $location.url($route.current.rootRoute);
            }
        }
    ];
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        getData();
    };
    this.$postLink = function () {
        $timeout(function () {
            ContentEditService.editorForm = _this.editorForm;
        });
    };
}
angular.module('prism-ui.content').component('contentPackageAcceptTemplates', {
    templateUrl: 'meta/content/editor/components/view/packageAcceptTemplates/content-package-accept-templates-template.html',
    controller: ContentPackageAcceptTemplatesController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function ContentPropertiesViewController(_, $location, $q, $routeParams, $route, $timeout, BreadcrumbService, ContentEditService, DynamicPropertiesService, EnumService, LanguagesService, MediaAcceptProfileService, ModalService, NotificationService, PermissionsService, SidebarService, TerritoriesService, TranslatableMetadataService) {
    var _this = this;
    this.editData = {};
    this.availableTerritories = [];
    var getData = function () {
        var promises = [];
        _this.loadingIndicator.show = true;
        promises.push(PermissionsService.isSystemOperator()
            .then(function (isSystemOperator) {
            _this.canWriteLiveFeeds = isSystemOperator;
        }));
        promises.push(EnumService.queryForEnums()
            .then(function () {
            ContentEditService.setAvailableBreakPatterns();
            _this.availableBreakPatterns = ContentEditService.availableBreakPatterns;
            _this.contentObject.breakPrePostRollPattern =
                _.filter(ContentEditService.availableBreakPatterns, function (pattern) {
                    if (pattern.id === _this.contentObject.breakPrePostRollPattern) {
                        return pattern;
                    }
                })[0];
            _this.liveFeedsGridOptions.data = ContentEditService.contentObject.liveFeeds;
        }));
        // get the available territories
        promises.push(TerritoriesService.getAllTerritories({ fetchLimit: 0, includeHidden: false })
            .then(function (territories) {
            // Place USA at the top of the list
            var territoriesWithUsaFirst = _.chain(territories)
                .partition({ name: 'USA' })
                .flatten()
                .value();
            _.set(_this, 'availableTerritories', territoriesWithUsaFirst);
        }));
        promises.push(LanguagesService.getAllLanguagesSorted()
            .then(function (languages) {
            _this.languages = languages;
        }));
        promises.push(DynamicPropertiesService.queryForProperties());
        return $q.all(promises).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    this.$onInit = function () {
        SidebarService.editService = ContentEditService;
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.selectedFeeds = [];
        getData().then(function () {
            _this.maxValueLength = DynamicPropertiesService.getPropValueAsInt('content.maxValueLength', -1);
            _this.maxShortDescLength = DynamicPropertiesService.getPropValueAsInt('content.maxShortDescLength', -1);
            _this.maxLongDescLength = DynamicPropertiesService.getPropValueAsInt('content.maxLongDescLength', -1);
            _this.maxKeywordsLength = DynamicPropertiesService.getPropValueAsInt('content.maxKeywordsLength', -1);
            $timeout(function () {
                var requiredFields;
                if (ContentEditService.contentObject.type === 'Series') {
                    requiredFields = DynamicPropertiesService.getPropValueAsArray('translatable.text.content.series.required.properties', []);
                }
                else if (ContentEditService.contentObject.type === 'Movie/Special') {
                    requiredFields = DynamicPropertiesService.getPropValueAsArray('translatable.text.content.movieSpecial.required.properties', []);
                }
                _this.translatableMetadataFields = [
                    {
                        name: 'value',
                        title: 'Value',
                        maxChars: _this.maxValueLength,
                        required: _.includes(requiredFields, 'value'),
                    },
                    {
                        name: 'shortDescription',
                        title: 'Short Description',
                        maxChars: _this.maxShortDescLength,
                        required: _.includes(requiredFields, 'shortDescription'),
                    },
                    {
                        name: 'longDescription',
                        title: 'Long Description',
                        maxChars: _this.maxLongDescLength,
                        required: _.includes(requiredFields, 'longDescription'),
                    },
                    {
                        name: 'keywords',
                        title: 'Auto Keywords',
                        type: 'multi',
                        maxChars: _this.maxKeywordsLength,
                        required: _.includes(requiredFields, 'keywords'),
                    },
                ];
            });
        });
    };
    this.liveFeedGridColumns = [
        {
            name: 'checkMarkRowHeaderCol',
            field: 'checkMark',
            width: 30,
            enableColumnMenu: false,
            enableSorting: false,
            enableColumnResizing: false,
            cellTemplate: 'components/visual/grid/check-mark-template.html',
            headerCellTemplate: '<div class="ui-grid-cell-contents" col-index="renderIndex" ng-click="grid.appScope.contentPropCtrlr.toggleRows($event)">' +
                '<input type="checkbox" ng-checked="grid.selection.selectAll"/><label></label></div>'
        },
        {
            field: 'liveFeed.name',
            name: 'Live Feed',
            sortable: false,
            enableColumnMenu: false
        },
        {
            field: 'timezoneOffset',
            name: 'Eastern Timezone Offset (minutes)',
            width: 250,
            sortable: false,
            enableColumnMenu: false
        },
        {
            field: 'defaultFlag',
            name: 'Default',
            enableColumnMenu: false,
            enableSorting: false,
            enableColumnResizing: false,
            width: 70,
            cellTemplate: 'components/visual/grid/boolean-flag-template.html'
        }
    ];
    this.liveFeedsGridOptions = {
        selectionRowHeaderColName: 'checkMarkRowHeaderCol',
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: false,
        enablePaginationControls: false,
        enableFullRowSelection: true,
        enableSorting: false,
        rowHeight: 26,
        multiSelect: true,
        minRowsToShow: 4,
        enableVerticalScrollbar: 2,
        columnDefs: this.liveFeedGridColumns,
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            _this.gridApi.selection.on.rowSelectionChanged(null, _this.gridRowSelectionChangedHandler);
        }
    };
    this.gridRowSelectionChangedHandler = function (row) {
        if (row.isSelected) {
            _this.selectedFeeds.push(row.entity);
        }
        else {
            var index = _this.selectedFeeds.indexOf(row.entity);
            _this.selectedFeeds.splice(index, 1);
        }
    };
    this.toggleRows = function (evt) {
        if (_this.gridApi.selection.selectAll) {
            _this.gridApi.selection.clearSelectedRows(evt);
            _this.gridApi.selection.selectAll = false;
        }
        else {
            _this.gridApi.selection.selectAllVisibleRows(evt);
            _this.gridApi.selection.selectAll = true;
        }
        _this.selectedFeeds = _this.gridApi.selection.getSelectedRows();
    };
    this.addFeed = function (feed) {
        if (!ContentEditService.contentObject.liveFeeds) {
            ContentEditService.contentObject.liveFeeds = [];
        }
        ContentEditService.contentObject.liveFeeds.push(feed);
        _this.liveFeedsGridOptions.data = ContentEditService.contentObject.liveFeeds;
        _this.editorForm.$setDirty();
    };
    this.removeSelectedFeeds = function () {
        _.remove(ContentEditService.contentObject.liveFeeds, function (liveFeed) {
            return _this.selectedFeeds.indexOf(liveFeed) >= 0;
        });
        _this.liveFeedsGridOptions.data = ContentEditService.contentObject.liveFeeds;
        _this.editorForm.$setDirty();
    };
    this.canRemoveSelected = function () {
        var canRemove = _this.selectedFeeds.length > 0;
        _.forEach(_this.selectedFeeds, function (feed) {
            if (!feed.canBeDeleted) {
                canRemove = false;
            }
        });
        return canRemove;
    };
    this.addShowLiveFeed = function () {
        ModalService.showAddLiveFeedModal(_this.availableLiveFeeds, {
            liveFeed: null,
            timezoneOffset: ''
        }, _this.addFeed);
    };
    this.editShowLiveFeed = function (liveFeed) {
        ModalService.showAddLiveFeedModal(_this.availableLiveFeeds, liveFeed, _this.editorForm.$setDirty);
    };
    this.onRowDblClick = function (row) {
        _this.editShowLiveFeed(row.entity);
    };
    this.resetContentData = function () {
        _this.contentObject = ContentEditService.contentObject;
        _this.metadataComponentsMap = ContentEditService.metadataComponentsMap;
        _this.liveFeedsGridOptions.data = ContentEditService.contentObject.liveFeeds;
    };
    this.toggleContentLock = function () {
        _this.editorForm.$setDirty();
    };
    var convertBreakPattern = function () {
        ContentEditService.contentObject.breakPrePostRollPattern =
            _.filter(ContentEditService.availableBreakPatterns, function (pattern) {
                if (pattern.id === ContentEditService.contentObject.breakPrePostRollPattern) {
                    return pattern;
                }
            })[0];
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () {
                var enableSave = false;
                if (_.get(_this, 'contentObject.type') === 'Ad/PreRoll') {
                    enableSave = !_.get(_this.editorForm, '$pristine') &&
                        !!_.get(_this.contentObject, 'name') &&
                        !!_.get(_this.contentObject, 'network') &&
                        !!_.get(_this.contentObject, 'originalLanguage');
                }
                else {
                    enableSave = !_.get(_this.editorForm, '$pristine') &&
                        !!_.get(_this.contentObject, 'name') &&
                        !!_.get(_this.contentObject, 'network') &&
                        !!_.get(_this.contentObject, 'originalLanguage') &&
                        !!_.get(_this.contentObject, 'territory');
                }
                return enableSave;
            },
            onClick: function () {
                _this.loadingIndicator.show = true;
                if (typeof _this.contentObject.breakPrePostRollPattern === 'object') {
                    _this.contentObject.breakPrePostRollPattern = _this.contentObject.breakPrePostRollPattern.id;
                }
                TranslatableMetadataService.preSave();
                ContentEditService.saveEditData().then(function () {
                    convertBreakPattern();
                    _this.contentObject = ContentEditService.contentObject;
                    TranslatableMetadataService.dataObjectSaved(_this.contentObject);
                    _this.loadingIndicator.show = false;
                    _this.editorForm.$setPristine();
                });
            }
        },
        {
            label: 'Revert',
            enabled: function () { return _.get(_this.editorForm, '$dirty'); },
            onClick: function () {
                ContentEditService.revertEditData();
                convertBreakPattern();
                _this.contentObject = ContentEditService.contentObject;
                TranslatableMetadataService.dataObjectReverted(_this.contentObject);
                _this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: function () { return true; },
            onClick: function () {
                ContentEditService.exitEdit();
            }
        }
    ];
    ContentEditService.tabRevertFunction = this.resetContentData;
    ContentEditService.tabSaveSuccessFunction = this.resetContentData;
    ContentEditService.tabSaveErrorFunction = this.resetContentData;
    this.$onDestroy = function () {
        ContentEditService.originalEditData = null;
        ContentEditService.viewData = null;
    };
    this.$postLink = function () {
        $timeout(function () {
            ContentEditService.editorForm = _this.editorForm;
            BreadcrumbService.editService = ContentEditService;
            TranslatableMetadataService.setDataObject(ContentEditService.contentObject);
        });
    };
}
angular.module('prism-ui.content').component('contentPropertiesView', {
    templateUrl: 'meta/content/editor/components/view/properties/content-properties-view-template.html',
    controller: ContentPropertiesViewController,
    bindings: {
        contentObject: '<',
        genres: '<',
        networks: '<',
        metadataComponentsMap: '<',
        availableLiveFeeds: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
function AddNewCrewCollaboratorModalController(DynamicPropertiesService, UtilsService) {
    var _this = this;
    this.disableOKButton = function () {
        return _this.newCollabEditForm.$pristine ||
            !_.get(_this, 'newCrewCollab.collaborator.displayName') ||
            !_.get(_this, 'newCrewCollab.collaborator.sortName') ||
            !_.get(_this, 'newCrewCollab.selectedRoles') ||
            (!_.get(_this, 'newCrewCollab.collaborator.character') && !_.get(_this, 'actorIsSelf') && _this.resolve.newActor) ||
            (_.get(_this, 'newCrewCollab.selectedRoles') && !_.size(_.get(_this, 'newCrewCollab.selectedRoles')));
    };
    this.$onInit = function () {
        _this.newCrewCollab = {};
        _this.actorIsSelf = false;
        if (_this.resolve.newActor) {
            _this.newCrewCollab.selectedRoles = ['Actor'];
        }
        else {
            DynamicPropertiesService.queryForProperties().then(function () {
                _this.availableRoles = DynamicPropertiesService.getPropValueAsList('package.crewMemberRoles');
            });
        }
    };
    this.handleDisplayNameChange = function () {
        _.set(_this, 'newCrewCollab.collaborator.sortName', _.cloneDeep(UtilsService.transformDisplayNameToSortName(_.get(_this, 'newCrewCollab.collaborator.displayName'))));
    };
}
angular.module('prism-ui.package').component('addNewCrewCollaboratorModal', {
    templateUrl: 'package/editor/components/modals/collaborators/addNewCrewCollaboratorModal/add-new-crew-collaborator-modal-template.html',
    controller: AddNewCrewCollaboratorModalController,
    bindings: {
        close: '&',
        dismiss: '&',
        resolve: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: mmc-inventory-modal-component.ts
 *
 * Created by randysorensen on 2019-05-09.
 */
function MMCInventoryModalController(_, $q, uiGridConstants, ModalService, NotificationService, PartnerPackagesService) {
    var _this = this;
    var getComponentInventory = function () {
        var packageId = _this.resolve.packageId;
        var partnerId = _this.resolve.partnerId;
        _this.loadingIndicator.show = true;
        return PartnerPackagesService.getComponentInventory(packageId, partnerId)
            .then(function (componentInventory) {
            return componentInventory;
        }).catch(function (error) {
            NotificationService.createFailureNotification("Failed to receive MMC inventory", _.get(error, 'data.message'));
            _this.close({});
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var setInventoryObjectDirty = function (id) {
        _this.dirtyInventoryIds.push(id);
    };
    var getModifiedInventories = function () {
        return _.filter(_this.componentInventory, function (inventoryObject) {
            return _.includes(_this.dirtyInventoryIds, inventoryObject.id);
        });
    };
    //======//
    // Grid //
    //======//
    var setupGrid = function () {
        var colDefs = [
            {
                // Active Checkbox
                cellTemplate: 'package/editor/components/view/distributionGrid/mmcInventoryModal/cellTemplates/check-mark-template.html',
                headerCellTemplate: 'package/editor/components/view/distributionGrid/mmcInventoryModal/cellTemplates/check-mark-header-template.html',
                displayName: 'Active',
                enableCellEdit: false,
                field: 'active',
                width: '70',
            },
            {
                // Inventory ID
                // Note: This function takes priority over enableCellEdit
                cellEditableCondition: function () { return !_this.readOnly; },
                cellTemplate: 'package/editor/components/view/distributionGrid/mmcInventoryModal/cellTemplates/inline-edit-template.html',
                displayName: 'Inventory ID',
                enableCellEdit: true,
                field: 'inventoryId',
                width: '750',
            },
            {
                // Type
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html',
                displayName: 'Type',
                enableCellEdit: false,
                field: 'type',
                width: '90'
            },
            {
                // Filename
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html',
                displayName: 'Filename',
                enableCellEdit: false,
                enableSorting: true,
                field: 'filename',
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 1,
                },
                width: '600',
            },
            {
                // Date Delivered
                cellTemplate: 'components/visual/grid/date-time-column-template.html',
                displayName: 'Date Delivered',
                enableCellEdit: false,
                enableSorting: true,
                field: 'dateDelivered',
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 1,
                },
                width: '185',
            }
        ];
        _this.gridOptions = {
            columnDefs: colDefs,
            data: [],
            enableColumnMenus: false,
            enableRowHeaderSelection: false,
            enableRowSelection: true,
            enableSelectAll: false,
            enableSorting: false,
            enableHorizontalScrollbar: uiGridConstants.ALWAYS,
            enableVerticalScrollbar: uiGridConstants.ALWAYS,
            multiSelect: false,
            onRegisterApi: function (gridApi) {
                _this.gridApi = gridApi;
                _this.gridApi.edit.on.afterCellEdit(null, function (rowEntity) {
                    setInventoryObjectDirty(rowEntity.id);
                });
            },
            rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
        };
    };
    //================//
    // Template Logic //
    //================//
    this.saveButtonDisabled = function () {
        var disabled = false;
        _.forEach(_this.componentInventory, function (inventoryItem) {
            disabled = disabled || _.size(inventoryItem.inventoryId) === 0;
        });
        disabled = disabled || _this.dirtyInventoryIds.length === 0;
        return disabled;
    };
    this.onSaveClicked = function () {
        var modifiedInventories = getModifiedInventories();
        var inventorySavePromises = [];
        _.forEach(modifiedInventories, function (inventoryToSave) {
            inventorySavePromises.push(PartnerPackagesService.updateComponentInventory(inventoryToSave));
        });
        _this.loadingIndicator.show = true;
        return $q.all(inventorySavePromises)
            .then(function () {
            _this.close({});
        }).catch(function (error) {
            NotificationService.createFailureNotification("Failed to update MMC inventory", _.get(error, 'data.message'));
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var showUnsavedChangesNotification = function (resultHandler) {
        ModalService.showMessageModal({
            messageText: 'You have unsaved changes. Are you sure you wish to cancel?',
            pullCancelLeft: true,
            title: 'Discard Unsaved Changes?',
            showOK: true,
            okText: 'Yes',
            windowClass: 'confirm-modal-sm'
        }, resultHandler);
    };
    this.onCancelClicked = function () {
        if (getModifiedInventories().length) {
            showUnsavedChangesNotification(function () {
                _this.close({});
            });
        }
        else {
            _this.close({});
        }
    };
    this.areAllRowsActive = function () {
        return _.every(_this.gridOptions.data, 'active');
    };
    this.onCheckMarkHeaderClicked = function ($event) {
        var wasAllRowsActive = _this.areAllRowsActive();
        $event.stopImmediatePropagation();
        $event.target.blur();
        _.forEach(_this.gridOptions.data, function (rowEntity) {
            rowEntity.active = !wasAllRowsActive;
            setInventoryObjectDirty(rowEntity.id);
        });
    };
    this.onCheckMarkCellClicked = function (row, $event) {
        $event.stopImmediatePropagation();
        $event.target.blur();
        row.entity.active = !row.entity.active;
        setInventoryObjectDirty(row.entity.id);
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.readOnly = _this.resolve.readOnly;
        _this.gridOptions = {};
        _this.dirtyInventoryIds = [];
        setupGrid();
        getComponentInventory()
            .then(function (componentInventory) {
            _this.componentInventory = componentInventory;
            _this.gridOptions.data = componentInventory;
        });
    };
}
angular.module('prism-ui.package').component('mmcInventoryModal', {
    bindings: {
        close: '&',
        dismiss: '&',
        resolve: '<'
    },
    controller: MMCInventoryModalController,
    templateUrl: 'package/editor/components/view/distributionGrid/mmcInventoryModal/mmc-inventory-modal-template.html'
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: package-file-service.ts
 *
 * Created by kyang on 2/10/21.
 */
//
// This service contains all the logic used to
// upload files for package media tab.
//
angular.module('prism-ui.package').service('PackageFileUploadService', function (_, $q, AsperaConnectService, TempFileUploadService, UtilsService) {
    //===============//
    // Aspera Upload //
    //===============//
    var _this = this;
    this.parseAsperaValidationResult = function (packageObject, asperaFileObject, result) {
        var virtualRoot = AsperaConnectService.asperaConnectProperties.virtualRoot;
        var destinationRoot = AsperaConnectService.asperaConnectProperties.destinationRoot;
        var packageId = packageObject.id;
        var fileName = UtilsService.getFileNameFromLocalPath(asperaFileObject.name);
        var resultPath = "" + virtualRoot + destinationRoot + packageId + "/" + fileName;
        if (result.uploadedData) {
            result.uploadedData.asperaPath = resultPath;
        }
        else {
            result.uploadedData = resultPath;
        }
        return result;
    };
    //===================//
    // Local File Upload //
    //===================//
    var localConfigsReadyForUpload = [];
    this.registerLocalConfigForUpload = function (uploaderConfig) {
        if (localConfigsReadyForUpload.indexOf(uploaderConfig) === -1) {
            localConfigsReadyForUpload.push(uploaderConfig);
        }
    };
    this.unregisterLocalConfig = function (uploaderConfig) {
        _.pull(localConfigsReadyForUpload, uploaderConfig);
    };
    //========================//
    // Shared Implementations //
    //========================//
    this.unregisterAllFiles = function () {
        AsperaConnectService.unregisterAllFiles();
        localConfigsReadyForUpload = [];
    };
    this.uploadFiles = function (packageObject, loadingIndicator) {
        if (AsperaConnectService.initialized) {
            AsperaConnectService.beginUpload(packageObject.id + "/");
        }
        var subdirectory = packageObject.id + "/";
        var virtualPathPromises = [];
        _.forEach(localConfigsReadyForUpload, function (uploaderConfig) {
            loadingIndicator.show = false;
            var uploads = TempFileUploadService.uploadFiles(uploaderConfig, subdirectory, packageObject.id);
            var _loop_1 = function (upload) {
                upload.uploadPromise.then(function () {
                    uploaderConfig.removeFromQueue(upload.fileItem);
                    _this.unregisterLocalConfig(uploaderConfig);
                });
                // Callback ensures that listener completes before promise is resolved
                virtualPathPromises.push(upload.virtualPathPromise.then(function (virtualPath) {
                    return upload.fileItem.onVirtualPathSet(virtualPath);
                }));
            };
            for (var _i = 0, uploads_1 = uploads; _i < uploads_1.length; _i++) {
                var upload = uploads_1[_i];
                _loop_1(upload);
            }
        });
        return $q.all(virtualPathPromises);
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2023 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function PackageTimingsSearchViewController(_, $scope, uiGridConstants, PackageUtilService, PackageResourceFactory, ModalService, NotificationService) {
    var _this = this;
    this.selectedItems = [];
    var parseTimingsData = function (timings) {
        _this.pkgTimings = timings;
        var timingsData = [];
        var commBlacks = timings.commercialBlackTimings.map(function (commercialTiming) {
            return { id: commercialTiming.id, description: 'Commercial Black', startTC: commercialTiming.startTC,
                endTC: commercialTiming.endTC, durationTC: commercialTiming.durationTC };
        });
        if (timings.programTiming) {
            timingsData.push({ description: 'Program Start', startTC: timings.programTiming.startTC });
            Array.prototype.push.apply(timingsData, commBlacks);
            timingsData.push({ description: 'Program End', startTC: timings.programTiming.endTC, durationTC: timings.programTiming.durationTC });
        }
        else {
            Array.prototype.push.apply(timingsData, commBlacks);
        }
        _this.currentGridOptions.data = timingsData;
        PackageUtilService.tabLoadDataFunction();
        $scope.$emit('server-busy', { working: false });
    };
    var getSearchData = function () {
        $scope.$emit('server-busy', { working: true });
        PackageResourceFactory.getTimings({ id: _this.packageObject.id }).$promise.then(parseTimingsData);
    };
    var fileUploadModalHandler = function (fileUploadObject) {
        $scope.$emit('server-busy', { working: true });
        PackageResourceFactory.uploadTimings({ id: _this.packageObject.id }, fileUploadObject).$promise.then(parseTimingsData);
    };
    this.toggleRows = function (evt) {
        if (_this.gridApi.selection.selectAll) {
            _this.gridApi.selection.clearSelectedRows(evt);
            _this.gridApi.selection.selectAll = false;
        }
        else {
            _this.gridApi.selection.selectAllVisibleRows(evt);
            _this.gridApi.selection.selectAll = true;
        }
        _this.selectedItems = _this.gridApi.selection.getSelectedRows();
    };
    this.gridRowSelectionChangedHandler = function (row, event) {
        var timing = row.entity;
        if (row.isSelected) {
            _this.selectedItems.push(timing);
            if (timing.description === 'Program Start' && event) {
                _this.gridApi.selection.selectRow(_this.currentGridOptions.data[_this.currentGridOptions.data.length - 1]);
            }
            else if (timing.description === 'Program End' && event) {
                _this.gridApi.selection.selectRow(_this.currentGridOptions.data[0]);
            }
        }
        else {
            var index = _this.selectedItems.indexOf(timing);
            _this.selectedItems.splice(index, 1);
            if (timing.description === 'Program End' && event) {
                _this.gridApi.selection.unSelectRow(_this.currentGridOptions.data[0]);
            }
            else if (timing.description === 'Program Start' && event) {
                _this.gridApi.selection.unSelectRow(_this.currentGridOptions.data[_this.currentGridOptions.data.length - 1]);
            }
        }
    };
    this.rowDoubleClicked = function (row) {
        var timing = row.entity;
        if (timing.description.indexOf('Program') > -1) {
            ModalService.showPkgTimingEditModal(_this.pkgTimings.programTiming, _this.saveTiming);
        }
        else {
            var commercialTiming = _this.pkgTimings.commercialBlackTimings.filter(function (commercialTiming) {
                return commercialTiming.id === timing.id;
            })[0];
            commercialTiming.description = 'Commercial Black';
            ModalService.showPkgTimingEditModal(commercialTiming, _this.saveTiming);
        }
    };
    this.gridColumns = [
        {
            name: 'checkMarkRowHeaderCol',
            field: 'checkMark',
            width: 30,
            enableColumnMenu: false,
            enableSorting: false,
            enableColumnResizing: false,
            cellTemplate: 'components/visual/grid/check-mark-template.html',
            headerCellTemplate: 'components/visual/grid/header-check-mark-template.html'
        },
        {
            field: 'description',
            displayName: 'Description',
            minWidth: 250,
            enableSorting: false,
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'startTC',
            displayName: 'Timecode In *',
            sort: {
                direction: uiGridConstants.ASC,
                priority: 0
            },
            enableSorting: false,
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'endTC',
            displayName: 'Timecode Out *',
            enableSorting: false,
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'durationTC',
            displayName: 'Duration *',
            enableSorting: false,
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];
    this.currentGridOptions = {
        selectionRowHeaderColName: 'checkMarkRowHeaderCol',
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: 0,
        enableVerticalScrollbar: 0,
        rowHeight: 26,
        multiSelect: true,
        columnDefs: this.gridColumns,
        rowTemplate: '<div ng-dblclick="grid.appScope.searchController.rowDoubleClicked(row)" ' +
            'ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ' +
            'ng-class="row.entity.hidden ? \'ui-grid-cell-hidden\' : \'\'" class="ui-grid-cell" ui-grid-cell> ' +
            '</div>',
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged($scope, _this.gridRowSelectionChangedHandler);
        }
    };
    $scope.$watch(function () {
        return _this.timingsSearchForm;
    }, function (newValue) {
        if (newValue) {
            PackageUtilService.editorForm = _this.timingsSearchForm;
        }
    });
    this.$onDestroy = function () {
        PackageUtilService.tabNewFunction = null;
        PackageUtilService.tabDeleteFunction = null;
    };
    this.saveTiming = function (timingToSave) {
        if (timingToSave.description === 'Commercial Black') {
            if (_.get(_this.packageObject, 'primaryAcceptTemplateMember.acceptProfile.videoMasterType.programTimingRequired') && !_this.pkgTimings.programTiming) {
                NotificationService.createWarningNotification('Program Start/End needs to be set before adding Commercial Black timings');
                return;
            }
            if (_this.pkgTimings.programTiming && (timingToSave.startTC < _this.pkgTimings.programTiming.startTC || timingToSave.endTC > _this.pkgTimings.programTiming.endTC)) {
                NotificationService.createWarningNotification('Commercial Black Timing cannot be outside the range of Program Start/End');
                return;
            }
        }
        $scope.$emit('server-busy', { working: true });
        if (!timingToSave.id) {
            if (timingToSave.description === 'Commercial Black') {
                _this.pkgTimings.commercialBlackTimings.push(timingToSave);
            }
            else {
                _this.pkgTimings.programTiming = timingToSave;
            }
        }
        PackageResourceFactory.saveTiming({ id: _this.packageObject.id }, _this.pkgTimings).$promise.then(parseTimingsData);
    };
    this.addTiming = function () {
        ModalService.showPkgTimingEditModal(null, _this.saveTiming);
    };
    this.deleteSelectedTimings = function () {
        $scope.$emit('server-busy', { working: true });
        angular.forEach(_this.selectedItems, function (selectedTiming) {
            if (selectedTiming.description.indexOf('Program') > -1) {
                _this.pkgTimings.programTiming = null;
            }
            else {
                _this.pkgTimings.commercialBlackTimings = _this.pkgTimings.commercialBlackTimings.filter(function (timing) {
                    return timing.id !== selectedTiming.id;
                });
            }
        });
        PackageResourceFactory.saveTiming({ id: _this.packageObject.id }, _this.pkgTimings).$promise.then(parseTimingsData);
    };
    this.deleteInvalid = function () {
        return _this.selectedItems.length === 0;
    };
    this.timingsUploadBtnHandler = function () {
        var uploadTemplate = { acceptProfile: { fileExtensions: ['csv', 'CSV'] } };
        ModalService.showFileUploadModal([uploadTemplate], 'CSV', fileUploadModalHandler);
    };
    this.$onInit = function () {
        PackageUtilService.tabNewFunction = _this.addTiming;
        PackageUtilService.tabDeleteFunction = _this.deleteSelectedTimings;
        PackageUtilService.tabDeleteInvalid = _this.deleteInvalid;
        PackageUtilService.tabUploadFunction = _this.timingsUploadBtnHandler;
        getSearchData();
    };
}
angular
    .module('prism-ui.package')
    .component('packageTimingsSearchView', {
    controller: PackageTimingsSearchViewController,
    templateUrl: 'package/editor/components/view/timings/searchView/packagetimings-search-view-template.html',
    bindings: {
        packageObject: '=',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: field-system-parameters-component.ts
 *
 * Created by kyang on 2020-09-14.
 */
function FileSystemParametersController(_) {
    var _this = this;
    this.hasParameters = function () {
        return _this.selectedTypeName && !_.isEmpty(_this.typeParameters);
    };
    this.onParameterChanged = function (parameter) {
        if (parameter.value) {
            _this.fileSystemObject.parameters[parameter.name] = parameter.value;
        }
        else {
            delete _this.fileSystemObject.parameters[parameter.name];
        }
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    var updateTypeParameters = function () {
        if (!_this.fileSystemTypes) {
            return;
        }
        var newParameterNames = [];
        var fileSystemParameters = _.get(_this.fileSystemObject, 'parameters', {});
        var selectedType = _.find(_this.fileSystemTypes, {
            name: _this.selectedTypeName
        });
        _this.typeParameters = _.chain(selectedType)
            .get('parameters', [])
            .sortBy('name')
            .map(function (parameter) {
            newParameterNames.push(parameter.name);
            return _.assign({
                value: (parameter.type === 'boolean') ? fileSystemParameters[parameter.name] === 'true' : fileSystemParameters[parameter.name]
            }, parameter);
        })
            .value();
        if (_this.fileSystemObject) {
            _this.fileSystemObject.parameters = _.pick(_this.fileSystemObject.parameters, newParameterNames);
        }
    };
    this.$onChanges = function (changes) {
        if (changes.selectedTypeName && !changes.fileSystemObject && _this.fileSystemObject) {
            _this.fileSystemObject.parameters = {};
        }
        updateTypeParameters();
    };
    this.$onInit = function () {
        updateTypeParameters();
    };
}
angular.module('prism-ui.fileSystem').component('fileSystemParameters', {
    templateUrl: 'system/fileSystem/editView/properties/components/fileSystemParameters/file-system-parameters-template.html',
    controller: FileSystemParametersController,
    bindings: {
        fileSystemObject: '<',
        fileSystemTypes: '<',
        selectedTypeName: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: partner-audio-mapping-rules-component.ts
 *
 * Created by kyang on 12/20/19.
 */
function PartnerAudioMappingRulesGridComponent(_, $q, uiGridConstants, LanguagesService, ModalService, PartnerEditService, RoleResourceFactory) {
    //======//
    // Grid //
    //======//
    var _this = this;
    this.gridColumnDefs = [
        {
            field: 'index',
            type: 'number',
            width: '70',
            displayName: 'Rule',
            enableCellEdit: false,
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'layout1Pattern',
            minWidth: '155',
            displayName: 'Track Selector Layout Expression',
            cellTemplate: 'system/partner/editor/components/view/audioMappingRules/cellTemplates/validated-inline-edit-cell-template.html',
            isFieldValid: function (layout) { return layout && layout.length > 0; },
        },
        {
            field: 'layout2Pattern',
            minWidth: '155',
            displayName: 'Combined Track Selector Layout Expression',
            cellTemplate: 'components/visual/grid/inline-edit-template.html'
        },
        {
            field: 'language',
            width: '230',
            displayName: 'Language',
            cellEditableCondition: false,
            cellTemplate: 'system/partner/editor/components/view/audioMappingRules/cellTemplates/language-cell-template.html',
            isFieldValid: function (language) { return !!language; }
        },
        {
            field: 'role',
            width: '230',
            displayName: 'Role',
            cellEditableCondition: false,
            cellTemplate: 'system/partner/editor/components/view/audioMappingRules/cellTemplates/role-cell-template.html',
            isFieldValid: function (role) { return !!role; }
        },
        {
            field: 'routingRatio',
            type: 'number',
            width: '160',
            displayName: 'Channel Routing Ratio',
            cellTemplate: 'system/partner/editor/components/view/audioMappingRules/cellTemplates/validated-inline-edit-cell-template.html',
            isFieldValid: function (ratio) { return Number.isInteger(ratio) && ratio >= 1 && ratio <= 32; },
        },
    ];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: false,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        multiSelect: false,
        rowHeight: 35,
        columnDefs: this.gridColumnDefs,
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        data: [],
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            _this.gridApi.edit.on.cancelCellEdit(null, _this.checkColumnsValidity);
            _this.gridApi.edit.on.afterCellEdit(null, _this.checkColumnsValidity);
        }
    };
    this.checkColumnsValidity = function () {
        _.forEach(_this.gridColumnDefs, function (colDef) {
            _this.editorForm.$setValidity(colDef.field + "Check", !_.isFunction(colDef.isFieldValid) || _.every(_this.gridOptions.data, function (routingRule) { return colDef.isFieldValid(routingRule[colDef.field]); }));
        });
    };
    //===================//
    // Data Modification //
    //===================//
    var transformRoutingRulesForDisplay = function () {
        var languageAll = _this.availableLanguages[0];
        var roleAll = _this.availableRoles[0];
        _.forEach(_this.partnerObject.audioRoutingRules, function (routingRule, index) {
            routingRule.index = parseInt(routingRule.index) + 1;
            routingRule.language = routingRule.language || languageAll;
            routingRule.role = routingRule.role || roleAll;
            routingRule.routingRatio = parseInt(routingRule.routingRatio);
            // Field is used by checkbox-cell to uniquely identify each row
            routingRule.name = index;
        });
    };
    var transformRoutingRulesForSaving = function () {
        _.forEach(_this.gridOptions.data, function (routingRule) {
            routingRule.index = "" + (routingRule.index - 1);
            routingRule.routingRatio = "" + routingRule.routingRatio;
            if (!routingRule.language.id) {
                delete routingRule.language;
            }
            if (!routingRule.role.id) {
                delete routingRule.role;
            }
            delete routingRule.name;
        });
    };
    var updateIndices = function () {
        _.forEach(_this.gridOptions.data, function (routingRule, index) {
            routingRule.index = index + 1;
        });
    };
    //=========//
    // Toolbar //
    //=========//
    var canMoveRuleUp = function () {
        var selectedIndex = _this.gridOptions.data.indexOf(_this.gridApi.selection.getSelectedRows()[0]);
        return selectedIndex >= 1;
    };
    var canMoveRuleDown = function () {
        var selectedIndex = _this.gridOptions.data.indexOf(_this.gridApi.selection.getSelectedRows()[0]);
        return selectedIndex >= 0 && selectedIndex < _this.gridOptions.data.length - 1;
    };
    var onNewClicked = function () {
        _this.gridOptions.data.push({
            index: _this.gridOptions.data.length + 1,
            routingRatio: 1,
        });
        _this.checkColumnsValidity();
        _this.editorForm.$setDirty();
        _this.gridApi.selection.clearSelectedRows();
    };
    var onSaveClicked = function () {
        transformRoutingRulesForSaving();
        _this.loadingIndicator.show = true;
        PartnerEditService.saveEditData()
            .then(function () {
            _this.resetTabData();
            _this.loadingIndicator.show = false;
        });
    };
    var onDeleteClicked = function () {
        var audioMappingRule = _this.gridApi.selection.getSelectedRows()[0];
        _.remove(_this.gridOptions.data, audioMappingRule);
        updateIndices();
        _this.checkColumnsValidity();
        _this.editorForm.$setDirty();
        _this.gridApi.selection.clearSelectedRows();
    };
    var onMoveUpClicked = function () {
        var selectedRule = _this.gridApi.selection.getSelectedRows()[0];
        var selectedIndex = _this.gridOptions.data.indexOf(selectedRule);
        var previousRule = _this.gridOptions.data[selectedIndex - 1];
        _this.gridOptions.data.splice(selectedIndex - 1, 2, selectedRule, previousRule);
        updateIndices();
        _this.editorForm.$setDirty();
    };
    var onMoveDownClicked = function () {
        var selectedRule = _this.gridApi.selection.getSelectedRows()[0];
        var selectedIndex = _this.gridOptions.data.indexOf(selectedRule);
        var nextRule = _this.gridOptions.data[selectedIndex + 1];
        _this.gridOptions.data.splice(selectedIndex, 2, nextRule, selectedRule);
        updateIndices();
        _this.editorForm.$setDirty();
    };
    this.toolbarButtonDefs = [{
            label: 'New',
            enabled: function () { return true; },
            onClick: onNewClicked,
        }, {
            label: 'Save',
            enabled: function () { return _this.editorForm.$dirty && _this.editorForm.$valid; },
            onClick: onSaveClicked,
        }, {
            label: 'Revert',
            enabled: function () { return _this.editorForm.$dirty; },
            onClick: function () { return PartnerEditService.revertEditData(); },
        }, {
            label: 'Delete',
            enabled: function () { return _this.gridApi.selection.getSelectedCount() >= 1; },
            onClick: onDeleteClicked,
        }, {
            label: 'Move Up',
            icon: 'fa-arrow-up',
            enabled: canMoveRuleUp,
            onClick: onMoveUpClicked,
        }, {
            label: 'Move Down',
            icon: 'fa-arrow-down',
            enabled: canMoveRuleDown,
            onClick: onMoveDownClicked,
        }];
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.resetTabData = function () {
        _this.partnerObject = PartnerEditService.partnerObject;
        transformRoutingRulesForDisplay();
        _this.partnerObject.audioRoutingRules = _.sortBy(_this.partnerObject.audioRoutingRules, 'index');
        _this.gridOptions.data = _this.partnerObject.audioRoutingRules;
        if (_this.gridApi) {
            _this.gridApi.selection.clearSelectedRows();
        }
        _this.checkColumnsValidity();
    };
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        var languagesPromise = LanguagesService.getAllLanguages()
            .then(function (availableLanguages) {
            _this.availableLanguages = _.orderBy(availableLanguages, 'name');
            _this.availableLanguages.unshift({
                name: '[All]',
                id: null
            });
        });
        var rolesPromise = RoleResourceFactory.query({ mediaType: 'Audio' })
            .$promise.then(function (availableRoles) {
            _this.availableRoles = _.orderBy(availableRoles, 'name');
            _this.availableRoles.unshift({
                name: '[All]',
                id: null
            });
        });
        _this.loadingIndicator.show = true;
        $q.all([
            languagesPromise,
            rolesPromise,
        ]).then(function () {
            _this.resetTabData();
            _this.loadingIndicator.show = false;
        });
    };
    this.$postLink = function () {
        PartnerEditService.editorForm = _this.editorForm;
        PartnerEditService.tabRevertFunction = _this.resetTabData;
    };
    this.$onDestroy = function () {
        PartnerEditService.editorForm = null;
        PartnerEditService.tabRevertFunction = null;
    };
}
angular.module('prism-ui.partner').component('partnerAudioMappingRulesGrid', {
    controller: PartnerAudioMappingRulesGridComponent,
    templateUrl: 'system/partner/editor/components/view/audioMappingRules/partner-audio-mapping-rules-grid-template.html',
    bindings: {
        canRead: '<',
        canWrite: '<',
        partnerObject: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: ratings-service.ts
 *
 * Created by kyang on 1/13/2021.
 */
angular.module('prism-ui.components.branding').service('RatingsService', function (_, RatingsResourceFactory) {
    var ratingSystemsPromise = undefined;
    var mapRatingSystems = function (ratingSystems) {
        return _.keyBy(ratingSystems, 'systemCode');
    };
    this.getRatingSystems = function () {
        if (_.isUndefined(ratingSystemsPromise)) {
            ratingSystemsPromise = RatingsResourceFactory.getRatingSystems().$promise.then(mapRatingSystems);
        }
        return ratingSystemsPromise;
    };
    this.getRatingSystemByRatingCode = function (ratingSystems, ratingCodeNeedle) {
        return _.find(ratingSystems, function (ratingSystem) { return _.some(ratingSystem.ratingCodes, function (ratingCode) { return ratingCode.id === ratingCodeNeedle.id; }); });
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function ContentCategoriesEditViewComponent(_, $location, $route, $routeParams, $timeout, BreadcrumbService, ContentEditService, ModalService, NotificationService, PermissionsService, SubscriptionsService) {
    //=============//
    // HTML Events //
    //=============//
    var _this = this;
    this.onTabSelect = function (tabName) {
        if (_this.viewTab && tabName === $location.search().viewTab) {
            return;
        }
        if (_this.viewTab && tabName !== $location.search().viewTab || !$location.search().viewTab) {
            $location.search('viewTab', tabName);
            _this.viewTab = tabName;
        }
        else {
            _this.viewTab = $location.search().viewTab;
        }
        _this.searchEnabled = _this.viewTab === 'subscriptions';
        _this.filterEnabled = _this.viewTab === 'subscriptions';
    };
    this.onTabDeselect = function (tabName, event) {
        var preventLeave;
        switch (tabName) {
            case 'properties':
                preventLeave = ContentEditService.contentCategoryObject && ContentEditService.contentCategoryObject.id && ContentEditService.editorForm && ContentEditService.editorForm.$dirty;
                break;
            case 'subscriptions':
                preventLeave = SubscriptionsService.editorForm && SubscriptionsService.editorForm.$dirty;
                break;
            default:
                preventLeave = false;
                break;
        }
        if (preventLeave) {
            event.preventDefault();
            NotificationService.createWarningNotification('Please save or revert your changes before navigating away from this page.');
        }
    };
    this.subscriptionsDisabled = function () {
        return !ContentEditService.contentCategoryObject || (_this.viewTab === 'properties' && ContentEditService.contentCategoryObject.id < 0);
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        ContentEditService.contentType = _this.contentType;
        ContentEditService.resetBreadcrumbs();
        // Add the content breadcrumb
        _this.contentBreadcrumb = {
            location: '',
            name: '',
            params: null,
        };
        _this.categoryBreadcrumb = {
            location: '',
            name: '',
            params: null,
        };
        BreadcrumbService.addBreadcrumb(_this.contentBreadcrumb);
    };
    this.$onDestroy = function () {
        $location.search('viewTab', null);
    };
}
angular.module('prism-ui.content').component('contentCategoriesEditView', {
    templateUrl: 'meta/content/editor/components/view/categories/editor/content-categories-edit-view-template.html',
    controller: ContentCategoriesEditViewComponent,
    bindings: {
        contentType: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function ContentCategoriesSearchViewComponent(_, $q, $routeParams, BreadcrumbService, ContentEditService, ContentResourceFactory, SubscriptionsResourceFactory, PermissionsService, uiGridConstants) {
    //======//
    // Grid //
    //======//
    var _this = this;
    var gridColumns = [
        {
            field: 'category.name',
            displayName: 'Category',
            maxWidth: 325,
            sort: {
                direction: uiGridConstants.ASC,
                priority: 1
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'category.type.name',
            displayName: 'Category Type',
            maxWidth: 325,
            sort: {
                direction: uiGridConstants.ASC,
                priority: 2
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'commercialBlackTimingRequired',
            displayName: 'Commercial Black TCs',
            maxWidth: 300,
            cellTemplate: 'components/visual/grid/radio-button-template.html'
        },
        {
            field: 'liveClippingEnabled',
            displayName: 'Live Clipping',
            maxWidth: 300,
            cellTemplate: 'components/visual/grid/radio-button-template.html'
        },
        {
            field: 'hidden',
            displayName: 'Has No Subscriptions',
            enableHiding: false,
            visible: false,
            maxWidth: 30,
            cellTemplate: '<span></span>',
            suppressRemoveSort: true,
            sort: {
                direction: uiGridConstants.ASC,
                priority: 0
            }
        }
    ];
    this.currentGridOptions = {
        rowSelection: false,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        rowHeight: 26,
        multiSelect: false,
        enableVerticalScrollbar: 2,
        columnDefs: gridColumns,
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
        }
    };
    this.onRowDblClick = function (row) {
        ContentEditService.openContentCategoryEditView(row.entity);
    };
    //=========//
    // Toolbar //
    //=========//
    this.toolbarButtonDefs = [{
            label: 'New',
            enabled: function () { return true; },
            onClick: function () { return ContentEditService.showNewContentCategoryModal(); }
        }];
    //================//
    // Data Retrieval //
    //================//
    var getFilledCategoriesPromise = function (contentId, contentCategories) {
        var requests = {};
        _.forEach(contentCategories, function (contentCategory) {
            requests[contentCategory.id] = SubscriptionsResourceFactory.getSubscriptionsByContentCategory({
                contentId: contentId,
                categoryId: contentCategory.category.id,
                fetchLimit: 1,
                fetchOffset: 0,
                includeDisabled: false,
                includeEnabled: true,
                searchString: ''
            }, function (subscriptions) {
                return subscriptions;
            }).$promise.then(function (subscriptions) {
                return _.size(subscriptions) >= 1;
            });
        });
        return $q.all(requests);
    };
    var getCategoryStyles = function (contentCategories) {
        return getFilledCategoriesPromise($routeParams.id, contentCategories)
            .then(function (filledCategoryIds) {
            _.forEach(contentCategories, function (category) {
                category.hidden = !filledCategoryIds[category.id];
            });
            return contentCategories;
        });
    };
    this.queryForGridData = function () {
        _this.loadingIndicator.show = true;
        var systemOpsPromise = PermissionsService.isSystemOperator()
            .then(function (isSystemOperator) {
            if (!isSystemOperator) {
                _.remove(gridColumns, { field: 'liveClippingEnabled' });
            }
        });
        var dataPromise = ContentResourceFactory.getContentCategories({
            id: $routeParams.id
        }).$promise
            .then(getCategoryStyles)
            .then(function (contentCategories) {
            _this.currentGridOptions.data = contentCategories;
        });
        $q.all([
            systemOpsPromise,
            dataPromise
        ]).then(function () {
            _this.loadingIndicator.show = false;
        });
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.queryForGridData();
    };
    this.$onChanges = function () {
        if (_this.editorForm) {
            ContentEditService.editorForm = _this.editorForm;
        }
    };
}
angular.module('prism-ui.content').component('contentCategoriesSearchView', {
    bindings: {
        contentObject: '='
    },
    controller: ContentCategoriesSearchViewComponent,
    templateUrl: 'meta/content/editor/components/view/categories/searchView/content-categories-searchview-template.html'
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function ContentPackageAcceptTemplatesMemberViewController(_, $timeout, PackageAcceptTemplatesService) {
    var _this = this;
    var setupMembers = function () {
        //
        // TODO
        //
        // Make this not spaghetti.
        //
        var availableMediaAcceptProfiles = [];
        var availableMediaAcceptProfileTypes = [];
        var mediaAcceptProfiles = _this.contentPackageAcceptTemplateContainer.packageAcceptTemplate.mediaAcceptProfiles;
        _.forIn(mediaAcceptProfiles, function (mediaAcceptProfile) {
            availableMediaAcceptProfiles.push(mediaAcceptProfile);
        });
        _.set(_this, 'contentPackageAcceptTemplateContainer.members', {});
        availableMediaAcceptProfiles = _.flatMap(availableMediaAcceptProfiles);
        _.forEach(availableMediaAcceptProfiles, function (availableMediaAcceptProfile) {
            availableMediaAcceptProfileTypes.push(availableMediaAcceptProfile.type);
        });
        availableMediaAcceptProfileTypes = _.uniq(availableMediaAcceptProfileTypes);
        _.forEach(availableMediaAcceptProfileTypes, function (availableMediaAcceptProfileType) {
            _.set(_this, "contentPackageAcceptTemplateContainer.members." + availableMediaAcceptProfileType, _.map(_.get(_this.contentPackageAcceptTemplateContainer.packageAcceptTemplate.mediaAcceptProfiles, availableMediaAcceptProfileType), function (mediaAcceptProfile) {
                return {
                    acceptProfile: mediaAcceptProfile,
                    validationType: 'NOT_APPLICABLE'
                };
            }));
        });
    };
    var setMediaAcceptProfileTypes = function (mediaAcceptProfiles) {
        //
        // When the selected PAT changes, build collection of MAPs
        // that are interpolated in the ng-repeat
        //
        _this.mediaAcceptProfiles = [];
        _.forIn(mediaAcceptProfiles, function (value, key) {
            _this.mediaAcceptProfiles.push({
                mediaAcceptProfileType: key,
                mediaAcceptProfiles: value
            });
        });
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.mediaAcceptProfiles = [];
        _this.loadingIndicator = {
            backdrop: true,
            show: true,
            title: 'Working',
            message: 'Please wait...'
        };
    };
    this.$postLink = function () {
        //
        // After all of the bindings are available set the PAT in
        // the PAT dropdown
        //
        $timeout(function () {
            var packageAcceptTempmlate = _.find(_this.packageAcceptTemplates, function (packageAcceptTemplate) {
                var patID = _.get(packageAcceptTemplate, 'id');
                var cpatID = _.get(_this, 'contentPackageAcceptTemplateContainer.packageAcceptTemplate.id');
                return patID === cpatID;
            });
            _.set(_this, 'packageAcceptTemplate', packageAcceptTempmlate);
            setMediaAcceptProfileTypes(_.get(_this, 'packageAcceptTemplate.mediaAcceptProfiles'));
            _this.loadingIndicator.show = false;
        });
    };
    this.$onChanges = function () {
        //
        // Handles any changes to the PAT binding
        //
        setMediaAcceptProfileTypes(_.get(_this, 'packageAcceptTemplate.mediaAcceptProfiles'));
    };
    //================//
    // Template Logic //
    //================//
    this.onSelectedPackageAcceptTemplateChangeHandler = function () {
        PackageAcceptTemplatesService.getPackageAcceptTemplates({ view: 'EXTENDED' })
            .then(function (packageAcceptTemplates) {
            _this.packageAcceptTemplates = packageAcceptTemplates;
            _.forEach(_this.packageAcceptTemplates, function (template) {
                template.type = _.camelCase(template.name);
                template.mediaAcceptProfiles = _.groupBy(template.mediaAcceptProfiles, 'type');
            });
            setupMembers();
            setMediaAcceptProfileTypes(_.get(_this, 'contentPackageAcceptTemplateContainer.packageAcceptTemplate.mediaAcceptProfiles'));
        });
    };
}
angular.module('prism-ui.content').component('contentPackageAcceptTemplatesMemberView', {
    templateUrl: 'meta/content/editor/components/view/packageAcceptTemplates/content-package-accept-templates-member-view-component/content-package-accept-templates-member-view-template.html',
    controller: ContentPackageAcceptTemplatesMemberViewController,
    bindings: {
        contentPackageAcceptTemplateContainer: '<',
        packageAcceptTemplates: '<',
        validationTypes: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
function SelectDraftClipModalController() {
    var _this = this;
    this.selectClip = function (clip) {
        _this.selectedClip = (_this.selectedClip !== clip) ? clip : null;
    };
    this.searchDrafts = function (clip) {
        return !_this.draftClipSearch.length ||
            (clip.title &&
                clip.title.toLowerCase().indexOf(_this.draftClipSearch.toLowerCase()) !== -1);
    };
    this.onOk = function (clip) {
        _this.close({ $value: clip });
    };
    this.cancel = function () {
        _this.dismiss({ $value: 'cancel' });
    };
    this.$onInit = function () {
        _this.draftClipSearch = '';
    };
}
angular.module('prism-ui.package').component('selectDraftClipModal', {
    templateUrl: 'package/editor/components/view/liveclip/modals/selectDraftClip/select-draft-clip-modal-template.html',
    controller: SelectDraftClipModalController,
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: package-media-adpod-asset-list-component.ts
 *
 * Created by randysorensen on 9/19/18.
 */
function PackageMediaAdPodAssetListController(_, PackageMediaService, PackageUtilService) {
    //================//
    // Template Logic //
    //================//
    var _this = this;
    this.getAdPod = function () {
        return _.first(PackageMediaService.getAssetList('AdPod'));
    };
    this.isEnabled = function () {
        return !_this.getAdPod() && !!PackageMediaService.hasMainVideo();
    };
    this.getIngestPercent = function () {
        return parseInt(_.get(_this.getAdPod(), 'ingestInfo.progress', -1));
    };
    this.addNewAdPod = function () {
        PackageMediaService.packageMediaData.assets.push({
            type: 'AdPod',
            adPodAcceptProfile: PackageMediaService.packageMediaData.adPodAcceptProfile
        });
        PackageUtilService.editorForm.$setDirty();
    };
    this.removeAdPod = function () {
        _.pull(PackageMediaService.packageMediaData.assets, _this.getAdPod());
        PackageUtilService.editorForm.$setDirty();
    };
    // =================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.adPodAcceptProfile = PackageMediaService.packageMediaData.adPodAcceptProfile;
    };
}
angular.module('prism-ui.package').component('packageMediaAdPodAssetList', {
    controller: PackageMediaAdPodAssetListController,
    templateUrl: 'package/editor/components/view/media/assetList/adPodAssetList/package-media-adpod-asset-list-template.html',
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: package-media-audio-asset-list-component.ts
 *
 * Created by randysorensen on 9/19/18.
 */
function PackageMediaAudioAssetListController(_, PackageMediaService, PackageUtilService) {
    //================//
    // Template Logic //
    //================//
    var _this = this;
    this.getAudioList = function () {
        return PackageMediaService.getAssetList('Audio');
    };
    this.isVisible = function () {
        return PackageMediaService.getValidationStatus('AUDIO') !== 'NOT APPLICABLE';
    };
    this.isEnabled = function () {
        return PackageMediaService.hasMainVideo();
    };
    this.getIngestPercent = function () {
        return PackageMediaService.calculateIngestPercent(_this.getAudioList());
    };
    this.getValidationStatus = function () {
        return PackageMediaService.getValidationStatus('AUDIO');
    };
    this.addNewAudio = function () {
        PackageMediaService.packageMediaData.assets.push({
            acceptTemplateMember: null,
            type: 'Audio'
        });
        PackageUtilService.editorForm.$setDirty();
    };
    this.removeAudio = function (audioAsset) {
        _.pull(PackageMediaService.packageMediaData.assets, audioAsset);
        PackageUtilService.editorForm.$setDirty();
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
    };
}
angular.module('prism-ui.package').component('packageMediaAudioAssetList', {
    controller: PackageMediaAudioAssetListController,
    templateUrl: 'package/editor/components/view/media/assetList/audioAssetList/package-media-audio-asset-list-template.html',
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by seaster on 5/8/15.
 */
function PackageMediaAssetListHeaderController(_, PackageMediaService) {
    var _this = this;
    this.getTooltip = function () {
        var partnersRequiring = PackageMediaService.getPartnersRequiring(_this.type, _this.componentRole);
        if (_.size(partnersRequiring)) {
            return 'Required by Partners:<br/>' + _.join(partnersRequiring, '<br/>');
        }
        else {
            return '';
        }
    };
    this.getTypeLabel = function () {
        var typeLabelMap = {
            video: 'VIDEO',
            'video metadata': 'VIDEO METADATA',
            'ad pod': 'AD POD',
            cc: 'CLOSED CAPTIONING',
            subtitle: 'SUBTITLE',
            audio: 'AUDIO',
            image: 'IMAGE',
            'sdr video': 'SDR VIDEO',
            'hdr video': 'HDR VIDEO'
        };
        return typeLabelMap[_this.type];
    };
    this.getValidationStatus = function () {
        return PackageMediaService.getValidationStatus(_this.type, _this.componentRole);
    };
}
angular.module('prism-ui.package').component('packageMediaAssetListHeader', {
    controller: PackageMediaAssetListHeaderController,
    templateUrl: 'package/editor/components/view/media/assetList/header/package-media-asset-list-header-template.html',
    bindings: {
        componentRole: '<',
        ingestPercent: '<',
        type: '<',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: package-media-image-asset-list-component.ts
 *
 * Created by randysorensen on 9/17/18.
 */
function PackageMediaImageAssetListController(_, ModalService, PackageMediaService, PackageUtilService) {
    //================//
    // Template Logic //
    //================//
    var _this = this;
    this.getImageList = function () {
        return PackageMediaService.getAssetList('Image');
    };
    this.isVisible = function () {
        return PackageMediaService.getValidationStatus('IMAGE') !== 'NOT APPLICABLE';
    };
    this.isEnabled = function () {
        return PackageMediaService.hasMainVideo();
    };
    this.getIngestPercent = function () {
        return PackageMediaService.calculateIngestPercent(_this.getImageList());
    };
    this.getValidationStatus = function () {
        return PackageMediaService.getValidationStatus('IMAGE');
    };
    this.selectedImageAcceptTemplateMember = function (newValue) {
        if (newValue === void 0) { newValue = null; }
        if (newValue) {
            PackageMediaService.packageMediaData.selectedImageAcceptTemplateMember = newValue;
        }
        return PackageMediaService.packageMediaData.selectedImageAcceptTemplateMember;
    };
    var openChangeAcceptProfileConfirmationModal = function (acceptHandler, rejectHandler) {
        ModalService.showMessageModal({
            messageText: "Are you sure you want to change the package's image accept profile? This will remove all" +
                " image assets from the package.",
            pullCancelLeft: true,
            title: 'Change Image Accept Profile',
            windowClass: 'confirm-modal-lg',
            showOK: true
        }, acceptHandler, rejectHandler);
    };
    this.onImageAcceptTemplateMemberChanged = function () {
        var setNewImageAcceptTemplateMember = function () {
            _.remove(PackageMediaService.packageMediaData.assets, { type: 'Image' });
            _this.oldSelectedImageAcceptTemplateMember =
                PackageMediaService.packageMediaData.selectedImageAcceptTemplateMember;
            PackageUtilService.editorForm.$setDirty();
        };
        var revertOldImageAcceptTemplateMember = function () {
            PackageMediaService.packageMediaData.selectedImageAcceptTemplateMember =
                _this.oldSelectedImageAcceptTemplateMember;
        };
        if (!_.size(_this.getImageList())) {
            setNewImageAcceptTemplateMember();
        }
        else {
            openChangeAcceptProfileConfirmationModal(setNewImageAcceptTemplateMember, revertOldImageAcceptTemplateMember);
        }
    };
    this.addNewImage = function () {
        PackageMediaService.packageMediaData.assets.push({
            acceptTemplateMember: PackageMediaService.packageMediaData.selectedImageAcceptTemplateMember,
            type: 'Image'
        });
        PackageUtilService.editorForm.$setDirty();
    };
    this.removeImage = function (imageAsset) {
        _.pull(PackageMediaService.packageMediaData.assets, imageAsset);
        PackageUtilService.editorForm.$setDirty();
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        PackageMediaService.getPackageMediaData().then(function () {
            _this.acceptTemplateMembers = PackageMediaService.packageMediaData.acceptTemplateMembers;
            _this.oldSelectedImageAcceptTemplateMember =
                PackageMediaService.packageMediaData.selectedImageAcceptTemplateMember;
        });
    };
}
angular.module('prism-ui.package').component('packageMediaImageAssetList', {
    controller: PackageMediaImageAssetListController,
    templateUrl: 'package/editor/components/view/media/assetList/imageAssetList/package-media-image-asset-list-template.html',
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: package-media-text-asset-list-component.ts
 *
 * Created by randysorensen on 9/18/18.
 */
function PackageMediaTextManagerController(_, PackageMediaService, PackageUtilService) {
    //================//
    // Template Logic //
    //================//
    var _this = this;
    this.getAcceptTemplate = function () {
        var acceptTemplate;
        if (_this.variant === 'cc') {
            acceptTemplate = _.get(_this.componentRole, "_ccAcceptTemplate");
        }
        else {
            acceptTemplate = _.get(_this.componentRole, "_subtitleAcceptTemplate");
        }
        return acceptTemplate;
    };
    this.getTextTrackList = function () {
        var type = _this.variant === 'cc' ? 'CC' : 'Subtitle';
        return PackageMediaService.getAssetList(type, _this.componentRole);
    };
    this.isEnabled = function () {
        return PackageMediaService.hasMainVideo();
    };
    this.isVisible = function () {
        return PackageMediaService.getValidationStatus(_.toUpper(_this.variant), _this.componentRole) !== 'NOT APPLICABLE';
    };
    this.getIngestPercent = function () {
        return PackageMediaService.calculateIngestPercent(_this.getTextTrackList());
    };
    this.addNewTextTrack = function () {
        PackageMediaService.packageMediaData.assets.push({
            componentRole: _.cloneDeep(_this.componentRole),
            type: _this.variant === 'cc' ? 'CC' : 'Subtitle'
        });
        PackageUtilService.editorForm.$setDirty();
    };
    this.removeTextTrack = function (textTrackAsset) {
        _.pull(PackageMediaService.packageMediaData.assets, textTrackAsset);
        PackageUtilService.editorForm.$setDirty();
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
    };
}
angular.module('prism-ui.package').component('packageMediaTextAssetList', {
    controller: PackageMediaTextManagerController,
    templateUrl: 'package/editor/components/view/media/assetList/textAssetList/package-media-text-asset-list-template.html',
    bindings: {
        componentRole: '<',
        variant: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: package-media-component-video-asset-list-component.ts
 *
 * Created by randysorensen on 9/23/18.
 */
function PackageMediaComponentVideoAssetListController(_, PackageMediaService, PackageUtilService) {
    //================//
    // Template Logic //
    //================//
    var _this = this;
    this.getComponentVideoList = function () {
        return PackageMediaService.getAssetList('Video', _this.componentRole);
    };
    this.getIngestPercent = function () {
        return PackageMediaService.calculateIngestPercent(_this.getComponentVideoList());
    };
    this.getValidationStatus = function () {
        if (_this.componentRole.isDefault || !!_.size(_this.componentRole._partnersRequiring)) {
            return 'REQUIRED';
        }
        else {
            return 'OPTIONAL';
        }
    };
    this.addNewComponentVideo = function () {
        PackageMediaService.packageMediaData.assets.push({
            acceptTemplateMember: PackageMediaService.getPrimaryAcceptTemplateMember(),
            type: 'Video',
            role: _this.componentRole
        });
        PackageUtilService.editorForm.$setDirty();
    };
    this.removeComponentVideo = function (componentVideoAsset) {
        _.pull(PackageMediaService.packageMediaData.assets, componentVideoAsset);
        PackageUtilService.editorForm.$setDirty();
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
    };
}
angular.module('prism-ui.package').component('packageMediaComponentVideoAssetList', {
    controller: PackageMediaComponentVideoAssetListController,
    templateUrl: 'package/editor/components/view/media/assetList/videoComponentAssetList/package-media-component-video-asset-list-template.html',
    bindings: {
        componentRole: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: package-media-main-video-asset-list-component.ts
 *
 * Created by randysorensen on 9/12/18.
 */
function PackageMediaMainVideoAssetListController(_, ModalService, PackageMediaService, PackageUtilService) {
    var _this = this;
    this.getPackageObject = function () {
        return PackageMediaService.packageObject;
    };
    this.getMainVideo = function () {
        return PackageMediaService.getMainVideo();
    };
    this.isHdrVideo = function () {
        var acceptProfile = _this.selectedVideoAcceptTemplateMember();
        return !!_.get(acceptProfile, 'acceptProfile.hdrVideoFlag');
    };
    this.hasHdrVideoXml = function () {
        return !!_.get(_this.getMainVideo(), 'hdrMetadataPath');
    };
    //================//
    // Template Logic //
    //================//
    this.selectedVideoAcceptTemplateMember = function (newValue) {
        if (newValue === void 0) { newValue = null; }
        if (newValue) {
            PackageMediaService.packageMediaData.selectedVideoAcceptTemplateMember = newValue;
        }
        return PackageMediaService.packageMediaData.selectedVideoAcceptTemplateMember;
    };
    var openChangeAcceptProfileConfirmationModal = function (acceptHandler, rejectHandler) {
        ModalService.showMessageModal({
            messageText: "Are you sure you want to change the package's video accept profile? This will invalidate all of" +
                " your assets, and reintialize the view.",
            pullCancelLeft: true,
            title: 'Change Video Accept Profile',
            windowClass: 'confirm-modal-lg',
            showOK: true
        }, acceptHandler, rejectHandler);
    };
    var setNewVideoAcceptTemplateMember = function () {
        var selectedVideoAcceptTemplateMember = PackageMediaService.packageMediaData.selectedVideoAcceptTemplateMember;
        PackageMediaService.resetAllMedia();
        PackageMediaService.packageMediaData.selectedVideoAcceptTemplateMember = selectedVideoAcceptTemplateMember;
        var mainVideo = _this.getMainVideo();
        _.merge(mainVideo, {
            acceptTemplateMember: selectedVideoAcceptTemplateMember,
            type: 'Video',
            role: _.find(PackageMediaService.packageMediaData.componentRoles, { isDefault: true })
        });
        PackageMediaService.packageObject.primaryAcceptTemplateMember = selectedVideoAcceptTemplateMember;
    };
    var revertOldVideoAcceptTemplateMember = function () {
        _this.selectedVideoAcceptTemplateMember(_this.getMainVideo().acceptTemplateMember);
    };
    this.onVideoAcceptProfileChange = function () {
        if (!PackageMediaService.hasMainVideo()) {
            setNewVideoAcceptTemplateMember();
        }
        else {
            openChangeAcceptProfileConfirmationModal(setNewVideoAcceptTemplateMember, revertOldVideoAcceptTemplateMember);
        }
    };
    this.getIngestPercent = function () {
        return PackageMediaService.calculateIngestPercent([_this.getMainVideo()]);
    };
    this.removeHdrXml = function () {
        var mainVideo = _this.getMainVideo();
        delete mainVideo.hdrMetadataAssetId;
        delete mainVideo.hdrMetadataPath;
        PackageUtilService.editorForm.$setDirty();
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        PackageMediaService.getPackageMediaData().then(function () {
            _this.acceptTemplateMembers = _.cloneDeep(PackageMediaService.packageMediaData.acceptTemplateMembers);
        });
    };
}
angular.module('prism-ui.package').component('packageMediaMainVideoAssetList', {
    controller: PackageMediaMainVideoAssetListController,
    templateUrl: 'package/editor/components/view/media/assetList/videoMainAssetList/package-media-main-video-asset-list-template.html',
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 4/27/15.
 */
function PackageMediaAdpodAssetSelectorController(_, AssetValidationService, DynamicPropertiesService, PackageFileUploadService, PackageMediaService, PackageUtilService, TempFileUploadService) {
    var _this = this;
    var setAdPod = function (virtualPath, isRemoteUploadEnabled) {
        _this.adpodAsset.virtualPath = virtualPath;
        _this.adpodAsset.assetId = -1;
        if (isRemoteUploadEnabled) {
            _this.adpodAsset.pendingIngest = true;
        }
        else {
            delete _this.adpodAsset.pendingIngest;
        }
        PackageUtilService.editorForm.$setDirty();
    };
    //================//
    // Template Logic //
    //================//
    this.remoteUploadEnabled = function () {
        return DynamicPropertiesService.getPropValueAsBoolean('mediaTabRemoteUpload.enabled', false);
    };
    this.getAcceptProfile = function () {
        return _this.adpodAsset.adPodAcceptProfile;
    };
    this.onQualityControlButtonClick = function ($event) {
        $event.stopImmediatePropagation();
        PackageMediaService.openQualityControlModal(_this.adpodAsset);
    };
    this.onCurrentFileChanged = function () {
        PackageFileUploadService.unregisterLocalConfig(_this.uploaderConfig);
        setAdPod(null, false);
        if (_.get(_this, 'currentFile.status') === 'PASSED') {
            switch (_this.currentFile.type) {
                case 'ASPERA':
                    // TODO: Test in UI when Aspera is configured
                    setAdPod(_this.currentFile.results[0].uploadedData, true);
                    break;
                case 'LOCAL':
                    // Display fileName (Correct virtualPath is set when media is saved)
                    PackageFileUploadService.registerLocalConfigForUpload(_this.uploaderConfig);
                    setAdPod("s3:fakePath/" + _this.currentFile.files[0].file.name, false);
                    break;
                case 'REMOTE':
                    setAdPod(_this.currentFile.files[0].virtualPath, false);
                    break;
            }
        }
    };
    //========================//
    // Remote File Validation //
    //========================//
    this.validateRemoteFile = function (fileSystemItem) {
        var virtualPath = fileSystemItem.parent + fileSystemItem.name;
        return AssetValidationService.validateMediaRemote(virtualPath, _this.getAcceptProfile().id);
    };
    //========================//
    // Aspera File Validation //
    //========================//
    this.validateAsperaFile = function (asperaFileObject) {
        return AssetValidationService.validateAdPodLocal(asperaFileObject.file, _this.getAcceptProfile())
            .then(function (result) {
            return PackageFileUploadService.parseAsperaValidationResult(PackageMediaService.packageObject, asperaFileObject, result);
        });
    };
    //=======================//
    // Local File Validation //
    //=======================//
    this.getLocalFilePreValidationErrors = function (file, filter) {
        // Doesn't add any local file filters
    };
    this.validateLocalFile = function (fileItem, uploaderConfig) {
        fileItem.onVirtualPathSet = function (virtualPath) {
            setAdPod(virtualPath, true);
        };
        return AssetValidationService.validateAdPodLocal(fileItem._file, _this.getAcceptProfile());
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.initializeLocalUploaderConfig = function (uploaderConfig) {
        TempFileUploadService.initialize(uploaderConfig);
        _this.uploaderConfig = uploaderConfig;
    };
    this.$onChanges = function (changes) {
        if (changes.adpodAsset && _this.uploaderConfig) {
            _this.currentFile = null;
        }
    };
    this.$onDestroy = function () {
        PackageFileUploadService.unregisterLocalConfig(_this.uploaderConfig);
    };
}
angular.module('prism-ui.package').component('packageMediaAdpodAssetSelector', {
    controller: PackageMediaAdpodAssetSelectorController,
    templateUrl: 'package/editor/components/view/media/assetSelector/adPod/package-media-adpod-asset-selector-template.html',
    bindings: {
        adpodAsset: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 4/27/15.
 */
function PackageMediaAudioIngesterController(_, AssetValidationService, DynamicPropertiesService, ModalService, PackageFileUploadService, PackageMediaService, PackageUtilService, TempFileUploadService) {
    var _this = this;
    var getAcceptProfile = function () {
        return _.get(_this, 'audioAsset.acceptTemplateMember.acceptProfile');
    };
    var setAudio = function (virtualPath, isRemoteUploadEnabled) {
        _this.audioAsset.virtualPath = virtualPath;
        _this.audioAsset.assetId = -1;
        if (isRemoteUploadEnabled) {
            _this.audioAsset.pendingIngest = true;
        }
        else {
            delete _this.audioAsset.pendingIngest;
        }
        PackageUtilService.editorForm.$setDirty();
    };
    //================//
    // Template Logic //
    //================//
    this.remoteUploadEnabled = function () {
        return DynamicPropertiesService.getPropValueAsBoolean('mediaTabRemoteUpload.enabled', false);
    };
    var openChangeAcceptProfileConfirmationModal = function (acceptHandler, rejectHandler) {
        ModalService.showMessageModal({
            messageText: "Are you sure you want to change the audio asset's accept profile? This will clear the asset's" +
                " path and require you to select a new asset.",
            pullCancelLeft: true,
            title: 'Change Audio Accept Profile',
            windowClass: 'confirm-modal-lg',
            showOK: true
        }, acceptHandler, rejectHandler);
    };
    this.onAudioAcceptTemplateMemberChanged = function () {
        var setNewAudioAcceptTemplateMember = function () {
            delete _this.audioAsset.virtualPath;
            delete _this.audioAsset.qualityControlNote;
            _this.currentFile = null;
            _this.oldSelectedAudioAcceptTemplateMember = _this.audioAsset.acceptTemplateMember;
            PackageUtilService.editorForm.$setDirty();
        };
        var revertOldAudioAcceptTemplateMember = function () {
            _this.audioAsset.acceptTemplateMember = _this.oldSelectedAudioAcceptTemplateMember;
        };
        if (!_.size(_this.audioAsset.virtualPath)) {
            setNewAudioAcceptTemplateMember();
        }
        else {
            openChangeAcceptProfileConfirmationModal(setNewAudioAcceptTemplateMember, revertOldAudioAcceptTemplateMember);
        }
    };
    this.onViewAssetButtonClick = function ($event) {
        $event.stopImmediatePropagation();
        PackageMediaService.openViewAssetModal(_this.audioAsset);
    };
    this.onQualityControlButtonClick = function ($event) {
        $event.stopImmediatePropagation();
        PackageMediaService.openQualityControlModal(_this.audioAsset);
    };
    this.onCurrentFileChanged = function () {
        PackageFileUploadService.unregisterLocalConfig(_this.uploaderConfig);
        setAudio(null, false);
        if (_.get(_this, 'currentFile.status') === 'PASSED') {
            switch (_this.currentFile.type) {
                case 'ASPERA':
                    // TODO: Test in UI when Aspera is configured
                    setAudio(_this.currentFile.results[0].uploadedData, true);
                    break;
                case 'LOCAL':
                    // Display fileName (Correct virtualPath is set when media is saved)
                    PackageFileUploadService.registerLocalConfigForUpload(_this.uploaderConfig);
                    setAudio("s3:fakePath/" + _this.currentFile.files[0].file.name, false);
                    break;
                case 'REMOTE':
                    setAudio(_this.currentFile.files[0].virtualPath, false);
                    break;
            }
        }
    };
    //========================//
    // Remote File Validation //
    //========================//
    this.getFileExtensions = function () {
        return _.get(getAcceptProfile(), 'fileExtensions', []);
    };
    this.validateRemoteFile = function (fileSystemItem) {
        var virtualPath = fileSystemItem.parent + fileSystemItem.name;
        return AssetValidationService.validateMediaRemote(virtualPath, getAcceptProfile().id);
    };
    //========================//
    // Aspera File Validation //
    //========================//
    this.validateAsperaFile = function (asperaFileObject) {
        return AssetValidationService.validateMediaLocal(asperaFileObject.file, getAcceptProfile())
            .then(function (result) {
            return PackageFileUploadService.parseAsperaValidationResult(PackageMediaService.packageObject, asperaFileObject, result);
        });
    };
    //=======================//
    // Local File Validation //
    //=======================//
    this.getLocalFilePreValidationErrors = function (file, filter) {
        // Doesn't add any local file filters
    };
    this.validateLocalFile = function (fileItem, uploaderConfig) {
        fileItem.onVirtualPathSet = function (virtualPath) {
            setAudio(virtualPath, true);
        };
        return AssetValidationService.validateMediaLocal(fileItem._file, getAcceptProfile());
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.acceptTemplateMembers = PackageMediaService.packageMediaData.acceptTemplateMembers;
        _this.audioRoles = PackageMediaService.packageMediaData.audioRoles;
        _this.languages = PackageMediaService.packageMediaData.languages;
        _this.oldSelectedAudioAcceptTemplateMember = _this.audioAsset.acceptTemplateMember;
    };
    this.initializeLocalUploaderConfig = function (uploaderConfig) {
        TempFileUploadService.initialize(uploaderConfig);
        _this.uploaderConfig = uploaderConfig;
    };
    this.$onChanges = function (changes) {
        if (changes.audioAsset && _this.uploaderConfig) {
            _this.currentFile = null;
        }
    };
    this.$onDestroy = function () {
        PackageFileUploadService.unregisterLocalConfig(_this.uploaderConfig);
    };
}
angular.module('prism-ui.package').component('packageMediaAudioAssetSelector', {
    controller: PackageMediaAudioIngesterController,
    templateUrl: 'package/editor/components/view/media/assetSelector/audio/package-media-audio-asset-selector-template.html',
    bindings: {
        audioAsset: '<',
        listIndex: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by richardwilliams on 4/15/15.
 */
function PackageMediaImageAssetSelectorController(_, AssetValidationService, DynamicPropertiesService, PackageFileUploadService, PackageMediaService, PackageUtilService, TempFileUploadService) {
    var _this = this;
    var setImage = function (virtualPath, isRemoteUploadEnabled) {
        _this.imageAsset.virtualPath = virtualPath;
        _this.imageAsset.assetId = -1;
        if (isRemoteUploadEnabled) {
            _this.imageAsset.pendingIngest = true;
        }
        else {
            delete _this.imageAsset.pendingIngest;
        }
        PackageUtilService.editorForm.$setDirty();
    };
    //================//
    // Template Logic //
    //================//
    this.remoteUploadEnabled = function () {
        return DynamicPropertiesService.getPropValueAsBoolean('mediaTabRemoteUpload.enabled', false);
    };
    this.getSelectedAcceptTemplateMember = function () {
        return PackageMediaService.packageMediaData.selectedImageAcceptTemplateMember;
    };
    this.onViewAssetButtonClick = function ($event) {
        $event.stopImmediatePropagation();
        PackageMediaService.openViewAssetModal(_this.imageAsset);
    };
    this.onQualityControlButtonClick = function ($event) {
        $event.stopImmediatePropagation();
        PackageMediaService.openQualityControlModal(_this.imageAsset);
    };
    this.onCurrentFileChanged = function () {
        PackageFileUploadService.unregisterLocalConfig(_this.uploaderConfig);
        setImage(null, false);
        if (_.get(_this, 'currentFile.status') === 'PASSED') {
            switch (_this.currentFile.type) {
                case 'ASPERA':
                    // TODO: Test in UI when Aspera is configured
                    setImage(_this.currentFile.results[0].uploadedData, true);
                    break;
                case 'LOCAL':
                    // Display fileName (Correct virtualPath is set when media is saved)
                    PackageFileUploadService.registerLocalConfigForUpload(_this.uploaderConfig);
                    setImage("s3:fakePath/" + _this.currentFile.files[0].file.name, false);
                    break;
                case 'REMOTE':
                    setImage(_this.currentFile.files[0].virtualPath, false);
                    break;
            }
        }
    };
    //========================//
    // Remote File Validation //
    //========================//
    var getAcceptProfile = function () {
        return _this.getSelectedAcceptTemplateMember().acceptProfile;
    };
    this.validateRemoteFile = function (fileSystemItem) {
        var virtualPath = fileSystemItem.parent + fileSystemItem.name;
        return AssetValidationService.validateMediaRemote(virtualPath, getAcceptProfile().id);
    };
    //========================//
    // Aspera File Validation //
    //========================//
    this.validateAsperaFile = function (asperaFileObject) {
        return AssetValidationService.validateMediaLocal(asperaFileObject.file, getAcceptProfile())
            .then(function (result) {
            return PackageFileUploadService.parseAsperaValidationResult(PackageMediaService.packageObject, asperaFileObject, result);
        });
    };
    //=======================//
    // Local File Validation //
    //=======================//
    this.getLocalFilePreValidationErrors = function (file, filter) {
        // Doesn't add any local file filters
    };
    this.validateLocalFile = function (fileItem, uploaderConfig) {
        fileItem.onVirtualPathSet = function (virtualPath) {
            setImage(virtualPath, true);
        };
        return AssetValidationService.validateMediaLocal(fileItem._file, getAcceptProfile());
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.languages = PackageMediaService.packageMediaData.languages;
    };
    this.initializeLocalUploaderConfig = function (uploaderConfig) {
        TempFileUploadService.initialize(uploaderConfig);
        _this.uploaderConfig = uploaderConfig;
    };
    this.$onChanges = function (changes) {
        if (changes.imageAsset && _this.uploaderConfig) {
            _this.currentFile = null;
        }
    };
    this.$onDestroy = function () {
        PackageFileUploadService.unregisterLocalConfig(_this.uploaderConfig);
    };
}
angular.module('prism-ui.package').component('packageMediaImageAssetSelector', {
    controller: PackageMediaImageAssetSelectorController,
    templateUrl: 'package/editor/components/view/media/assetSelector/image/package-media-image-asset-selector-template.html',
    bindings: {
        imageAsset: '<',
        listIndex: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 4/27/15.
 */
function PackageMediaTextAssetSelectorController(_, AssetValidationService, DynamicPropertiesService, ModalService, PackageFileUploadService, PackageMediaService, PackageUtilService, TempFileUploadService, VALID_FILE_EXTENSIONS) {
    var _this = this;
    var setAssetVirtualPath = function (virtualPath, isRemoteUploadEnabled) {
        _this.textAsset.virtualPath = virtualPath;
        _this.textAsset.assetId = -1;
        if (isRemoteUploadEnabled) {
            _this.textAsset.pendingIngest = true;
        }
        else {
            delete _this.textAsset.pendingIngest;
        }
        PackageUtilService.editorForm.$setDirty();
    };
    //================//
    // Template Logic //
    //================//
    this.remoteUploadEnabled = function () {
        return DynamicPropertiesService.getPropValueAsBoolean('mediaTabRemoteUpload.enabled', false);
    };
    this.hasMainVideo = function () {
        return PackageMediaService.hasMainVideo();
    };
    var canUpload = function () {
        var hasMainVideoMediaInfo = !!PackageMediaService.getMainVideoMediaInfoXML();
        var ingestHasBegun = PackageMediaService.mainVideoIngestHasStarted();
        return hasMainVideoMediaInfo || ingestHasBegun;
    };
    var canSelectRemote = function () {
        var mainVideoPath = _.get(PackageMediaService.getMainVideo(), 'virtualPath');
        var mainVideoIsUpload = PackageMediaService.isAnUploadPath(mainVideoPath);
        var mainVideoIngestHasCompleted = PackageMediaService.mainVideoIngestHasCompleted();
        return !mainVideoIsUpload || mainVideoIngestHasCompleted;
    };
    this.getDisabledFileSources = function () {
        var newDisabledSources = [];
        if (!canUpload()) {
            newDisabledSources.push('ASPERA');
            newDisabledSources.push('LOCAL');
        }
        if (!canSelectRemote()) {
            newDisabledSources.push('REMOTE');
        }
        if (!_.isEqual(newDisabledSources, _this.disabledFileSources)) {
            _this.disabledFileSources = newDisabledSources;
        }
        return _this.disabledFileSources;
    };
    this.getButtonTooltips = function () {
        var newTooltips = {};
        if (!canUpload()) {
            newTooltips.LOCAL =
                'Local-file ingest of this asset type will be' +
                    ' enabled after the main video workflow has' +
                    ' started.';
        }
        if (!canSelectRemote()) {
            newTooltips.REMOTE =
                'Network-based ingest of this asset type will be' +
                    ' enabled after the main video workflow has' +
                    ' completed.';
        }
        if (!_.isEqual(newTooltips, _this.buttonTooltips)) {
            _this.buttonTooltips = newTooltips;
        }
        return _this.buttonTooltips;
    };
    this.onViewAssetButtonClick = function ($event) {
        $event.stopImmediatePropagation();
        PackageMediaService.openViewAssetModal(_this.textAsset);
    };
    this.onQualityControlButtonClick = function ($event) {
        $event.stopImmediatePropagation();
        PackageMediaService.openQualityControlModal(_this.textAsset);
    };
    this.showAssetWarnings = function () {
        ModalService.showAssetValidationResultsModal(_this.textAsset.validationResult, false);
    };
    this.onCurrentFileChanged = function () {
        PackageFileUploadService.unregisterLocalConfig(_this.uploaderConfig);
        setAssetVirtualPath(null, false);
        if (_.get(_this, 'currentFile.status') === 'PASSED') {
            switch (_this.currentFile.type) {
                case 'ASPERA':
                    // TODO: Test in UI when Aspera is configured
                    setAssetVirtualPath(_this.currentFile.results[0].uploadedData, true);
                    break;
                case 'LOCAL':
                    // Display fileName (Correct virtualPath is set when media is saved)
                    PackageFileUploadService.registerLocalConfigForUpload(_this.uploaderConfig);
                    setAssetVirtualPath("s3:fakePath/" + _this.currentFile.files[0].file.name, false);
                    break;
                case 'REMOTE':
                    setAssetVirtualPath(_this.currentFile.files[0].virtualPath, false);
                    break;
            }
        }
    };
    //========================//
    // Remote File Validation //
    //========================//
    this.getFileExtensions = function () {
        var fileFilterType;
        if (_this.variant === 'cc') {
            fileFilterType = 'CC';
        }
        else {
            fileFilterType = 'SUBTITLE';
        }
        return VALID_FILE_EXTENSIONS[fileFilterType];
    };
    this.validateRemoteFile = function (fileSystemItem) {
        var virtualPath = fileSystemItem.parent + fileSystemItem.name;
        return AssetValidationService.validateTextRemoteMainVideoRemote(virtualPath, _this.textAcceptTemplate, PackageMediaService.getMainVideo());
    };
    //========================//
    // Aspera File Validation //
    //========================//
    var validateLocalFile = function (localFile) {
        var validationPromise;
        var mainVideo = PackageMediaService.getMainVideo();
        //
        // TODO:
        //
        // These should be collapsed into a single call, the
        // validation service can figure out whether ingest
        // started or not.
        //
        if (PackageMediaService.mainVideoIngestHasStarted()) {
            validationPromise = AssetValidationService.validateTextLocalMainVideoRemote(localFile, _this.textAcceptTemplate, PackageMediaService.getPrimaryAcceptTemplateMember(), mainVideo);
        }
        else {
            validationPromise = AssetValidationService.validateTextLocalMainVideoLocal(localFile, _this.textAcceptTemplate, PackageMediaService.getPrimaryAcceptTemplateMember(), PackageMediaService.getMainVideoMediaInfoXML());
        }
        return validationPromise;
    };
    this.validateAsperaFile = function (asperaFileObject) {
        return validateLocalFile(asperaFileObject.file)
            .then(function (result) {
            return PackageFileUploadService.parseAsperaValidationResult(PackageMediaService.packageObject, asperaFileObject, result);
        });
    };
    //=======================//
    // Local File Validation //
    //=======================//
    this.getLocalFilePreValidationErrors = function (file, filter) {
        // Doesn't add any local file filters
    };
    this.validateLocalFile = function (fileItem, uploaderConfig) {
        fileItem.onVirtualPathSet = function (virtualPath) {
            setAssetVirtualPath(virtualPath, true);
        };
        return validateLocalFile(fileItem._file);
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        var textTrackRolesProperty = _this.variant + "Roles";
        _this.disabledFileSources = [];
        _this.buttonTooltips = {};
        _this.componentRoleName = _this.componentRole.name;
        _this.languages = PackageMediaService.packageMediaData.languages;
        _this.textTrackRoles = PackageMediaService.packageMediaData[textTrackRolesProperty];
        _this.warnings = {};
        if (_.size(_this.textAsset.validationResult)) {
            _this.warnings.type = 'warning';
            _this.warnings.message = '';
        }
    };
    this.initializeLocalUploaderConfig = function (uploaderConfig) {
        TempFileUploadService.initialize(uploaderConfig);
        _this.uploaderConfig = uploaderConfig;
    };
    this.$onChanges = function (changes) {
        if (changes.textAsset && _this.uploaderConfig) {
            _this.currentFile = null;
        }
    };
    this.$onDestroy = function () {
        PackageFileUploadService.unregisterLocalConfig(_this.uploaderConfig);
    };
}
angular.module('prism-ui.package').component('packageMediaTextAssetSelector', {
    controller: PackageMediaTextAssetSelectorController,
    templateUrl: 'package/editor/components/view/media/assetSelector/text/package-media-text-asset-selector-template.html',
    bindings: {
        componentRole: '<',
        listIndex: '<',
        textAcceptTemplate: '<',
        textAsset: '<',
        variant: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 9/15/15.
 */
function PackageMediaComponentVideoAssetSelectorController(_, AssetValidationService, DynamicPropertiesService, PackageFileUploadService, PackageMediaService, PackageUtilService, TempFileUploadService) {
    var _this = this;
    var setComponentVideo = function (assetPath, isRemoteUploadEnabled) {
        _this.componentVideoAsset.acceptTemplateMember = _this.getPrimaryAcceptTemplateMember();
        _this.componentVideoAsset.virtualPath = assetPath;
        _this.componentVideoAsset.assetId = -1;
        if (isRemoteUploadEnabled) {
            _this.componentVideoAsset.pendingIngest = true;
        }
        else {
            delete _this.componentVideoAsset.pendingIngest;
        }
        PackageUtilService.editorForm.$setDirty();
    };
    //================//
    // Template Logic //
    //================//
    this.remoteUploadEnabled = function () {
        return DynamicPropertiesService.getPropValueAsBoolean('mediaTabRemoteUpload.enabled', false);
    };
    var canUpload = function () {
        var hasMainVideoMediaInfo = !!PackageMediaService.getMainVideoMediaInfoXML();
        var ingestHasBegun = PackageMediaService.mainVideoIngestHasStarted();
        return hasMainVideoMediaInfo || ingestHasBegun;
    };
    var canSelectRemote = function () {
        var mainVideoPath = _.get(PackageMediaService.getMainVideo(), 'virtualPath');
        var mainVideoIsUpload = PackageMediaService.isAnUploadPath(mainVideoPath);
        var mainVideoIngestHasCompleted = PackageMediaService.mainVideoIngestHasCompleted();
        return !mainVideoIsUpload || mainVideoIngestHasCompleted;
    };
    this.getDisabledFileSources = function () {
        var newDisabledSources = [];
        if (!canUpload()) {
            newDisabledSources.push('ASPERA');
            newDisabledSources.push('LOCAL');
        }
        if (!canSelectRemote()) {
            newDisabledSources.push('REMOTE');
        }
        if (!_.isEqual(newDisabledSources, _this.disabledFileSources)) {
            _this.disabledFileSources = newDisabledSources;
        }
        return _this.disabledFileSources;
    };
    this.getButtonTooltips = function () {
        var newTooltips = {};
        if (!canUpload()) {
            newTooltips.LOCAL =
                'Local-file ingest of this asset type will be' +
                    ' enabled after the main video workflow has' +
                    ' started.';
        }
        if (!canSelectRemote()) {
            newTooltips.REMOTE =
                'Network-based ingest of this asset type will be' +
                    ' enabled after the main video workflow has' +
                    ' completed.';
        }
        if (!_.isEqual(newTooltips, _this.buttonTooltips)) {
            _this.buttonTooltips = newTooltips;
        }
        return _this.buttonTooltips;
    };
    this.getPrimaryAcceptTemplateMember = function () {
        return PackageMediaService.getPrimaryAcceptTemplateMember();
    };
    this.onViewAssetButtonClick = function ($event) {
        $event.stopImmediatePropagation();
        PackageMediaService.openViewAssetModal(_this.componentVideoAsset);
    };
    this.onQualityControlButtonClick = function ($event) {
        $event.stopImmediatePropagation();
        PackageMediaService.openQualityControlModal(_this.componentVideoAsset);
    };
    this.onCurrentFileChanged = function () {
        PackageFileUploadService.unregisterLocalConfig(_this.uploaderConfig);
        setComponentVideo(null, false);
        if (_.get(_this, 'currentFile.status') === 'PASSED') {
            switch (_this.currentFile.type) {
                case 'ASPERA':
                    // TODO: Test in UI when Aspera is configured
                    setComponentVideo(_this.currentFile.results[0][0].uploadedData.asperaPath, true);
                    _this.componentVideoAsset.mediaInfoDTO = _this.currentFile.results[0][0].uploadedData.mediaInfoDTO;
                    break;
                case 'LOCAL':
                    // Display fileName (Correct virtualPath is set when media is saved)
                    PackageFileUploadService.registerLocalConfigForUpload(_this.uploaderConfig);
                    setComponentVideo("s3:fakePath/" + _this.currentFile.files[0].file.name, false);
                    _this.componentVideoAsset.mediaInfoDTO = _this.currentFile.results[0][0].uploadedData.mediaInfoDTO;
                    break;
                case 'REMOTE':
                    setComponentVideo(_this.currentFile.files[0].virtualPath, false);
                    break;
            }
        }
    };
    //========================//
    // Remote File Validation //
    //========================//
    this.validateRemoteFile = function (fileSystemItem) {
        var assetPath = fileSystemItem.parent + fileSystemItem.name;
        var excludedComponentVideoIdList = PackageMediaService.getExcludedComponentIdList(_this.componentRole);
        var newComponentVirtualPaths = PackageMediaService.getNewComponentVirtualPathList(_this.componentRole);
        //
        // "this" component's component video is still active. If
        // it's already ingested, its ID should be added to the
        // excluded list. If it's not already ingested but has been
        // previously selected since the last save, its virtual
        // path needs to be removed from the "new" list.
        //
        if (_.has(_this.componentVideoAsset, 'id')) {
            excludedComponentVideoIdList.push(_this.componentVideoAsset.id);
        }
        _.pull(newComponentVirtualPaths, _.get(_this, 'componentVideoAsset.virtualPath'));
        var acceptProfileId = PackageMediaService.getPrimaryAcceptTemplateMember().acceptProfile.id;
        newComponentVirtualPaths.push(assetPath);
        return AssetValidationService.validateComponentsRemoteMainVideoRemote(PackageMediaService.packageObject.id, newComponentVirtualPaths, acceptProfileId, _this.componentRole.id, excludedComponentVideoIdList);
    };
    //========================//
    // Aspera File Validation //
    //========================//
    var validateLocalMedia = function (localFile) {
        var excludedComponentVideoIdList = PackageMediaService.getExcludedComponentIdList(_this.componentRole);
        var newComponentVideoMediaInfoXMLList = PackageMediaService.getComponentVideoMediaInfoXMLList();
        var mainVideoMediaInfoXML = PackageMediaService.getMainVideoMediaInfoXML();
        var mainVideoMediaInfoDTO = null;
        if (mainVideoMediaInfoXML) {
            mainVideoMediaInfoDTO = {
                filePath: PackageMediaService.getMainVideo().virtualPath,
                mediaInfo: mainVideoMediaInfoXML
            };
        }
        return AssetValidationService.validateComponentsLocal(PackageMediaService.packageObject.id, newComponentVideoMediaInfoXMLList, localFile, PackageMediaService.getPrimaryAcceptTemplateMember().acceptProfile, _this.componentRole.id, excludedComponentVideoIdList, mainVideoMediaInfoDTO);
    };
    this.validateAsperaFile = function (asperaFileObject) {
        return validateLocalMedia(asperaFileObject.file)
            .then(function (result) {
            return PackageFileUploadService.parseAsperaValidationResult(PackageMediaService.packageObject, asperaFileObject, result[0]);
        });
    };
    //=======================//
    // Local File Validation //
    //=======================//
    this.getLocalFilePreValidationErrors = function (file, filter) {
        // Doesn't add any local file filters
    };
    this.validateLocalFile = function (fileItem, uploaderConfig) {
        fileItem.onVirtualPathSet = function (virtualPath) {
            setComponentVideo(virtualPath, true);
        };
        return validateLocalMedia(fileItem._file);
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.initializeLocalUploaderConfig = function (uploaderConfig) {
        TempFileUploadService.initialize(uploaderConfig);
        _this.uploaderConfig = uploaderConfig;
    };
    this.$onChanges = function (changes) {
        if (changes.componentVideoAsset && _this.uploaderConfig) {
            _this.currentFile = null;
        }
    };
    this.$onDestroy = function () {
        PackageFileUploadService.unregisterLocalConfig(_this.uploaderConfig);
    };
}
angular.module('prism-ui.package').component('packageMediaComponentVideoAssetSelector', {
    controller: PackageMediaComponentVideoAssetSelectorController,
    templateUrl: 'package/editor/components/view/media/assetSelector/videoComponent/package-media-component-video-asset-selector-template.html',
    bindings: {
        componentRole: '<',
        componentVideoAsset: '<',
        componentVideoMediaInfoXMLList: '<',
        listIndex: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: video-metadata-component.ts
 *
 * Created by randysorensen on 9/12/18.
 */
function PackageMediaMainVideoAssetSelectorController(_, $q, AssetValidationService, DynamicPropertiesService, ModalService, PackageFileUploadService, PackageMediaService, PackageUtilService, TempFileUploadService) {
    var _this = this;
    this.getMainVideo = function () {
        return PackageMediaService.getMainVideo();
    };
    this.getPrimaryAcceptTemplateMember = function () {
        return PackageMediaService.getPrimaryAcceptTemplateMember();
    };
    var setMainVideo = function (virtualPath, isRemoteUploadEnabled) {
        var mainVideo = _this.getMainVideo();
        _.merge(mainVideo, {
            acceptTemplateMember: PackageMediaService.packageMediaData.selectedVideoAcceptTemplateMember,
            assetId: -1,
            pendingIngest: isRemoteUploadEnabled,
            virtualPath: virtualPath
        });
        PackageUtilService.editorForm.$setDirty();
    };
    //================//
    // Template Logic //
    //================//
    this.remoteUploadEnabled = function () {
        return DynamicPropertiesService.getPropValueAsBoolean('mediaTabRemoteUpload.enabled', false);
    };
    this.onViewAssetButtonClick = function ($event) {
        $event.stopImmediatePropagation();
        PackageMediaService.openViewAssetModal(_this.getMainVideo());
    };
    this.onQualityControlButtonClick = function ($event) {
        $event.stopImmediatePropagation();
        PackageMediaService.openQualityControlModal(_this.getMainVideo());
    };
    var hasMainVideo = function () {
        return !!_.get(_this.getMainVideo(), "virtualPath", null);
    };
    var resetPackageMediaForVideoChange = function () {
        var selectedVideoAcceptTemplateMember = _this.getPrimaryAcceptTemplateMember();
        PackageMediaService.resetAllMedia();
        _this.currentFile = null;
        _this.prevMainVideo = PackageMediaService.getMainVideo();
        PackageMediaService.packageMediaData.selectedVideoAcceptTemplateMember = selectedVideoAcceptTemplateMember;
        PackageMediaService.packageObject.primaryAcceptTemplateMember = selectedVideoAcceptTemplateMember;
    };
    this.onCurrentFileChanged = function () {
        PackageFileUploadService.unregisterLocalConfig(_this.uploaderConfig);
        setMainVideo(null, false);
        if (_.get(_this, 'currentFile.status') === 'PASSED') {
            switch (_this.currentFile.type) {
                case 'ASPERA':
                    // TODO: Test in UI when Aspera is configured
                    PackageMediaService.setMainVideoMediaInfoXML(_this.currentFile.results[0].mediaInfo);
                    setMainVideo(_this.currentFile.results[0].uploadedData, true);
                    break;
                case 'LOCAL':
                    // Display fileName (Correct virtualPath is set when media is saved)
                    PackageFileUploadService.registerLocalConfigForUpload(_this.uploaderConfig);
                    PackageMediaService.setMainVideoMediaInfoXML(_this.currentFile.results[0].mediaInfo);
                    setMainVideo("s3:fakePath/" + _this.currentFile.files[0].file.name, false);
                    break;
                case 'REMOTE':
                    setMainVideo(_this.currentFile.files[0].virtualPath, false);
                    break;
            }
        }
    };
    //========================//
    // Remote File Validation //
    //========================//
    var openChangeVideoConfirmationModal = function () {
        var deferred = $q.defer();
        ModalService.showMessageModal({
            messageText: "Are you sure you want to change the package's main video? This will invalidate all of your " +
                " assets, and reintialize the view.",
            pullCancelLeft: true,
            title: 'Change Package Main Video',
            windowClass: 'confirm-modal-lg',
            showOK: true
        }, function () {
            resetPackageMediaForVideoChange();
            deferred.resolve(true);
        }, function () {
            deferred.resolve(false);
        });
        return deferred.promise;
    };
    this.promptFileWarnings = function () {
        if (!hasMainVideo()) {
            return true;
        }
        else {
            return openChangeVideoConfirmationModal();
        }
    };
    this.validateRemoteFile = function (fileSystemItem) {
        var acceptProfileId = _this.getPrimaryAcceptTemplateMember().acceptProfile.id;
        var virtualPath = fileSystemItem.parent + fileSystemItem.name;
        return AssetValidationService.validateMediaRemote(virtualPath, acceptProfileId);
    };
    //========================//
    // Aspera File Validation //
    //========================//
    this.validateAsperaFile = function (asperaFileObject) {
        return AssetValidationService.validateMediaLocal(asperaFileObject.file, _this.getPrimaryAcceptTemplateMember().acceptProfile)
            .then(function (result) {
            return PackageFileUploadService.parseAsperaValidationResult(PackageMediaService.packageObject, asperaFileObject, result);
        });
    };
    //=======================//
    // Local File Validation //
    //=======================//
    this.getLocalFilePreValidationErrors = function (file, filter) {
        // Doesn't add any local file filters
    };
    this.validateLocalFile = function (fileItem, uploaderConfig) {
        fileItem.onVirtualPathSet = function (virtualPath) {
            setMainVideo(virtualPath, true);
        };
        return AssetValidationService.validateMediaLocal(fileItem._file, _this.getPrimaryAcceptTemplateMember().acceptProfile);
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.prevMainVideo = PackageMediaService.getMainVideo();
    };
    this.initializeLocalUploaderConfig = function (uploaderConfig) {
        TempFileUploadService.initialize(uploaderConfig);
        _this.uploaderConfig = uploaderConfig;
    };
    this.$doCheck = function () {
        var mainVideo = PackageMediaService.getMainVideo();
        if (_this.uploaderConfig && _this.prevMainVideo !== mainVideo) {
            _this.currentFile = null;
            _this.prevMainVideo = mainVideo;
        }
    };
    this.$onDestroy = function () {
        PackageFileUploadService.unregisterLocalConfig(_this.uploaderConfig);
    };
}
angular.module('prism-ui.package').component('packageMediaVideoMainAssetSelector', {
    controller: PackageMediaMainVideoAssetSelectorController,
    templateUrl: 'package/editor/components/view/media/assetSelector/videoMain/package-media-video-main-asset-selector-template.html',
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: video-metadata-component.ts
 *
 * Created by randysorensen on 9/12/18.
 */
function VideoMetadataController(_, DynamicPropertiesService, ModalService, PackageMediaService) {
    var _this = this;
    this.getPackageObject = function () {
        return PackageMediaService.packageObject;
    };
    this.getMainVideo = function () {
        return PackageMediaService.getMainVideo();
    };
    //================//
    // Template Logic //
    //================//
    this.showMasterVideoKindDD = function () {
        var videoMasterType = _.get(PackageMediaService.getPrimaryAcceptTemplateMember(), "acceptProfile.videoMasterType.type");
        return videoMasterType === 'MASTER_VIDEO';
    };
    this.hasMainVideo = function () {
        return !!_.get(_this.getMainVideo(), "virtualPath", null);
    };
    this.onHelpClicked = function (context) {
        var message = '';
        var title = '';
        switch (context) {
            case 'burnedSub':
                message =
                    "Subtitles can either be a form of written translation of a dialog in a foreign language, or a" +
                        " written rendering of the dialog in the same language, with or without added information to help" +
                        " viewers who are deaf and hard of hearing to follow the dialog. Subtitles can also be for people" +
                        " who cannot understand the spoken dialogue or who have problems understanding a person\u2019s spoken" +
                        " accent. Opening title sequences and credits are not considered \u201Csubtitles\u201D in this case.";
                title = 'Burned-in Subtitles';
                break;
            case 'narrativeBurned':
                message =
                    "Narrative text is text that appears on screen to supplement the plot of the story without the" +
                        " use the use of a narrator, such as \u201CEarlier that morning\u201D, \u201C2 A.M.\u201D or \u201CSydney, Australia.\u201D" +
                        " Opening title sequences and credits are not considered \u201Ctext\u201D in this case.";
                title = 'Narrative Burned-in Text';
                break;
            case 'recap':
                message =
                    "This is the timecode at which the recap at the top of the program has concluded, but before the" +
                        " main program has started. This may or may not be a clean point in time. For example an" +
                        " audio/video dip to black between recap and program would be considered \u2018clean\u2019, whereas a" +
                        " cross-fade from the recap to the main program would not be considered \u201Cclean\u201D. If the recap" +
                        " ending timecode is a clean point in time, identify this as a \u2018clean\u2019 recap ending timecode.";
                title = 'Recap Ending Timecode';
                break;
        }
        ModalService.showMessageModal({
            messageText: message,
            title: title,
            cancelText: 'OK'
        });
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        DynamicPropertiesService.queryForProperties()
            .then(function () {
            _this.availableMediaVersions = DynamicPropertiesService.getPropValueAsList('package.mediaVersions');
            _this.availableRevisions = _.range(1, 51);
            _this.masterVideoKinds = DynamicPropertiesService.getPropValueAsList('package.masterVideoKind');
            return PackageMediaService.getPackageMediaData();
        }).then(function () {
            _this.languages = PackageMediaService.packageMediaData.languages;
        });
    };
}
angular.module('prism-ui.package').component('videoMetadata', {
    controller: VideoMetadataController,
    templateUrl: 'package/editor/components/view/media/components/videoMetadata/video-metadata-template.html',
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: create-snapshot-service.ts
 *
 * Created by kyang on 12/8/20.
 */
angular.module('prism-ui.package').service('CreateSnapshotService', function (_, $q, $window, NotificationService, PackageMediaResourceFactory, RequestService, WorkflowExecutionResourceFactory) {
    var WorkflowStatus;
    (function (WorkflowStatus) {
        WorkflowStatus["RUNNING"] = "RUNNING";
        WorkflowStatus["COMPLETED"] = "COMPLETED";
        WorkflowStatus["STALLED"] = "STALLED";
    })(WorkflowStatus || (WorkflowStatus = {}));
    var waitForWorkflowCompletion = function (getWorkflowStatusFunc) {
        var deferred = $q.defer();
        var intervalId;
        intervalId = RequestService.createRequestInterval(function () {
            return getWorkflowStatusFunc()
                .then(function (status) {
                if (status === WorkflowStatus.COMPLETED) {
                    RequestService.cancelRequestInterval(intervalId);
                    deferred.resolve('Workflow COMPLETED');
                }
                else if (status === WorkflowStatus.STALLED) {
                    RequestService.cancelRequestInterval(intervalId);
                    deferred.reject('Workflow STALLED');
                }
            })
                .catch(function (error) {
                RequestService.cancelRequestInterval(intervalId);
                deferred.reject(error);
            });
        }, 2000);
        return deferred.promise;
    };
    var waitForAssetCreation = function (workflow) {
        return waitForWorkflowCompletion(function () {
            return WorkflowExecutionResourceFactory.getWorkflowExecution({
                id: workflow.workflowGuid
            }).$promise.then(function (updatedWorkflow) {
                return updatedWorkflow.status;
            });
        });
    };
    var waitForSnapshotProxy = function (packageId) {
        var snapshotContent;
        var remainingMediaRetries = 30;
        return waitForWorkflowCompletion(function () {
            return PackageMediaResourceFactory.get({
                id: packageId
            }).$promise.then(function (media) {
                if (!snapshotContent) {
                    snapshotContent = _.find(media, function (packageContent) {
                        return packageContent.type === 'Image' && _.has(packageContent, 'ingestInfo.progress');
                    });
                    if (!snapshotContent) {
                        if (--remainingMediaRetries >= 0) {
                            return WorkflowStatus.RUNNING;
                        }
                        else {
                            return $q.reject('Workflow completed, but resulting image not found');
                        }
                    }
                }
                var updatedContent = _.find(media, {
                    type: snapshotContent.type,
                    id: snapshotContent.id,
                });
                if (!_.has(updatedContent, 'ingestInfo.progress')) {
                    return $q.reject('Workflow completed, but image was replaced');
                }
                return _.has(updatedContent, 'proxyId') ? WorkflowStatus.COMPLETED : WorkflowStatus.RUNNING;
            });
        });
    };
    this.getSnapshotImage = function (videoElement) {
        var width = videoElement.videoWidth;
        var height = videoElement.videoHeight;
        var canvas = $window.document.createElement('canvas');
        var context = canvas.getContext('2d');
        canvas.width = width;
        canvas.height = height;
        context.drawImage(videoElement, 0, 0, width, height);
        return canvas.toDataURL();
    };
    this.createSnapshot = function (packageId, timeOffset) {
        NotificationService.createInfoNotification("Creating a snapshot from video player");
        return WorkflowExecutionResourceFactory.createPackageSnapshot({
            packageId: packageId,
            frameOffset: timeOffset,
        }).$promise
            .then(waitForAssetCreation)
            .then(function () { return waitForSnapshotProxy(packageId); })
            .then(function () {
            NotificationService.createSuccessNotification("Snapshot was successfully created.");
        })
            .catch(function (error) {
            NotificationService.createFailureNotification("Failed to create the snapshot.", error);
            return $q.reject(error);
        });
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by jessenelson on 4/18/16.
 */
'use strict';
angular.module('prism-ui.package').service('DownloadAssetService', function ($q, AuthFactory, DebugService, EndPointService, InventoryResourceFactory, ProxyResourceFactory, UtilsService) {
    var _this = this;
    var AssetType;
    (function (AssetType) {
        AssetType["Video"] = "video";
        AssetType["VideoClip"] = "video_clip";
        AssetType["Clip"] = "clip";
        AssetType["Image"] = "image";
        AssetType["Audio"] = "audio";
        AssetType["Document"] = "document";
    })(AssetType || (AssetType = {}));
    this.AssetType = AssetType;
    var ContentUse;
    (function (ContentUse) {
        ContentUse["Source"] = "source";
        ContentUse["Proxy"] = "proxy";
    })(ContentUse || (ContentUse = {}));
    this.ContentUse = ContentUse;
    // use Lodash to memoize/cache server-provided asset URIs
    var getUriCacheKey = function (id, assetType, contentUse) { return assetType.length + "," + contentUse.length + "," + id + assetType + contentUse; };
    var loadAssetUriPromise = function (id, assetType, contentUse) {
        DebugService.debug("loading " + contentUse + " URI for " + assetType + " with id " + id);
        return InventoryResourceFactory.getAssetUri({ assetType: assetType, contentUse: contentUse, id: id }).$promise
            .then(function (uriData) {
            if (uriData.uri.includes(':')) {
                return uriData;
            }
            return { uri: EndPointService.mediaAssetEndpoint + "?assetType=" + assetType + "&assetId=" + id + "&contentUse=" + contentUse + "&" + AuthFactory.getAuthQueryString() };
        })
            .catch(function (errorData) {
            // discard this promise from the cache
            _this.getAssetUri.cache.delete(getUriCacheKey(id, assetType, contentUse));
            console.error("caught error loading URI");
            return $q.reject(errorData);
        });
    };
    this.getAssetUri = _.memoize(loadAssetUriPromise, getUriCacheKey);
    this.downloadAsset = function (id, downloadFileName, assetType, contentUse) {
        return _this.getAssetUri(id, assetType, contentUse)
            .then(function (uriObj) {
            DebugService.debug("downloading " + downloadFileName + " from " + uriObj.uri);
            return UtilsService.downloadFile(uriObj.uri, downloadFileName);
        });
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: partner-delivery-endpoints-editor-component.ts
 *
 * Created by randysorensen on 5/9/17.
 */
'use strict';
function PartnerDeliveryEndpointsEditorController(_, $timeout, $routeParams, $route, $location, BreadcrumbService, PartnerEditService, UtilsService) {
    var _this = this;
    var requiredFieldsLookup = {
        general: ['name'],
        applenews: ['channelId', 'apiKeyId', 'apiKeySecret'],
        aspera: ['serverAddress', 'userName'],
        aspera_cli: ['serverAddress', 'userName'],
        aspera_key: ['serverAddress', 'userName'],
        ftp: ['serverAddress'],
        itunes: ['networkPath', 'userName', 'password', 'logLevel'],
        ivi: ['iviUserName', 'iviPassword', 'iviNetworkId'],
        netflix: ['serverAddress', 'userName', 'netflixSSHKeyFilename', 'netflixClientId', 'netflixClientSecret', 'netflixPassword'],
        network: ['networkPath'],
        s3: ['s3Bucket', 'awsAccessKey', 'awsSecretKey'],
        sftp: ['serverAddress', 'userName'],
        uplynk: ['userName'],
        vantage: ['vantageWorkflow']
    };
    this.asperaTransferPolicies = [
        {
            label: 'Fixed - Transfer at the specified target rate',
            value: '-'
        },
        {
            label: 'Adaptive (Recommended) - Adjust and share network',
            value: '-Q'
        },
        {
            label: 'Low (Trickle)',
            value: '-QQ'
        },
    ];
    this.asperaResumePolicies = [
        {
            label: 'Off',
            value: '0'
        },
        {
            label: 'File attribute check',
            value: '1'
        },
        {
            label: 'Fast integrity check',
            value: '2'
        },
        {
            label: 'Full integrity check',
            value: '3'
        },
    ];
    this.asperaCLIRatePolicies = [
        {
            label: 'Fixed',
            value: 'fixed'
        },
        {
            label: 'High',
            value: 'high'
        },
        {
            label: 'Fair',
            value: 'fair'
        },
        {
            label: 'Low',
            value: 'low'
        }
    ];
    this.asperaCLICiphers = [
        {
            label: 'None',
            value: 'none'
        },
        {
            label: 'AES-128',
            value: 'aes-128'
        }
    ];
    this.iTunesDeliveryMethods = [
        {
            label: 'Auto (default)',
            value: 'Auto'
        },
        {
            label: 'Aspera',
            value: 'Aspera'
        },
        {
            label: 'Signiant',
            value: 'Signiant'
        },
        {
            label: 'DAV',
            value: 'DAV'
        }
    ];
    this.iTunesLogLevels = [
        {
            label: 'Off',
            value: 'off'
        },
        {
            label: 'Detailed',
            value: 'detailed'
        },
        {
            label: 'Informational',
            value: 'informational'
        },
        {
            label: 'Critical',
            value: 'critical'
        },
        {
            label: 'Extreme',
            value: 'eXtreme'
        }
    ];
    var getViewPermissions = function () {
        return PartnerEditService.getViewPermissions(PartnerEditService.viewStates.SYSTEM_PARTNERS_DELIVERYENDPOINTS_VIEW_STATE);
    };
    this.canWrite = false;
    var assignEndpointObject = function (endpointObject) {
        // UI shows kbps, not bps
        endpointObject.bandwidthThreshold = _.toNumber(endpointObject.bandwidthThreshold) / 1000;
        _this.endpointObject = endpointObject;
    };
    var getEndpointEditData = function () {
        _this.loadingIndicator.show = true;
        return PartnerEditService.getPartnerDeliveryEndpointEditData()
            .then(function (data) {
            _this.partnerObject = data.partnerObject;
            assignEndpointObject(data.endpointObject);
            _this.partnerBreadcrumb.location = "/system/partners/edit/" + _this.partnerObject.id + "/deliveryEndpoints";
            _this.partnerBreadcrumb.name = _this.partnerObject.name;
            _this.mediaConversionTemplates = data.mediaConversionTemplates;
            if (!!_this.endpointObject.name) {
                _this.breadcrumbName = _this.endpointObject.name;
            }
            PartnerEditService.parentRoute = "/system/partners/edit/" + data.partnerObject.id + "/deliveryEndpoints";
            // loading indicator won't shut off without
            // wrapping this in a $timeout() ...?
            $timeout(function () {
                _this.loadingIndicator.show = false;
            });
        });
    };
    this.getEndpointTypeLabel = PartnerEditService.getEndpointTypeLabel;
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.endpointWorkflowTypeWhitelist = ['Vantage'];
        // Get endpoint protocol type from route param
        _this.endpointType = $routeParams.endpointType;
        // Init partner breadcrumb
        BreadcrumbService.editService = PartnerEditService;
        _this.partnerBreadcrumb = {
            location: '',
            name: '...',
            params: null
        };
        if (BreadcrumbService.getBreadcrumbs().length < 2) {
            // Why this "if" is necessary:
            //
            // When new endpoints are saved, the route params are
            // updated, reinstantiating this controller. This
            // causes redundant breadcrumbs to appear.
            BreadcrumbService.addBreadcrumb(_this.partnerBreadcrumb);
        }
        // Init delivery endpoint breadcrumb
        _this.breadcrumbName = 'New Delivery Endpoint';
        // Get endpoint & partner data
        getViewPermissions().then(function (permissions) {
            _this.canWrite = permissions.deliveryEndpointsWrite;
            getEndpointEditData();
        });
    };
    this.$postLink = function () {
        $timeout(function () {
            PartnerEditService.editorForm = _this.editorForm;
        });
    };
    var saveEditData = function () {
        _this.loadingIndicator.show = true;
        var endpointObject = _.cloneDeep(_this.endpointObject);
        endpointObject.bandwidthThreshold = _.toNumber(_this.endpointObject.bandwidthThreshold) * 1000;
        PartnerEditService
            .savePartnerDeliveryEndpoint(endpointObject)
            .then(function () {
            _this.bradcrumbName = _this.endpointObject.name;
            // UI shows kbps, not bps
            assignEndpointObject(PartnerEditService.endpointObject);
            _this.loadingIndicator.show = false;
            $route.updateParams({ endpointId: _this.endpointObject.id });
        });
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () {
                var requiredFields = requiredFieldsLookup.general.concat(requiredFieldsLookup[_this.endpointType]);
                var requiredFieldsArePopulated = _this.endpointObject && requiredFields.reduce(function (accum, field) {
                    return accum && UtilsService.hasData(_this.endpointObject[field]);
                }, true);
                // special case for GDPR private key filename -
                // only required if GDPR enabled flag is set
                if (requiredFieldsArePopulated && _.get(_this, 'endpointObject.generalDataProtectionRegulationFlag')) {
                    requiredFieldsArePopulated = _.size(_this.endpointObject.privateKeyFilename) > 0;
                }
                // For UpLynk deliveries, require an API key, and
                // if there's a secondary username, require a
                // secondary API key
                if (requiredFieldsArePopulated && _this.endpointType === 'uplynk') {
                    var hasApiKey = _.size(_this.endpointObject.apiKey) > 0;
                    var hasSecondaryUsername = _.size(_this.endpointObject.secondaryUserName) > 0;
                    var hasSecondaryApiKey = _.size(_this.endpointObject.secondaryApiKey) > 0;
                    requiredFieldsArePopulated = (hasApiKey &&
                        ((hasSecondaryUsername && hasSecondaryApiKey) ||
                            !hasSecondaryUsername));
                }
                var isNotPristine = _this.editorForm && !_this.editorForm.$pristine;
                return requiredFieldsArePopulated && isNotPristine;
            },
            onClick: saveEditData
        },
        {
            label: 'Revert',
            enabled: function () {
                var isNew = $routeParams.endpointId < 0;
                var isNotPristine = _this.editorForm && !_this.editorForm.$pristine;
                return isNew || isNotPristine;
            },
            onClick: function () {
                PartnerEditService.revertPartnerDeliveryEndpoint();
                assignEndpointObject(PartnerEditService.endpointObject);
            }
        },
        {
            label: 'Close',
            enabled: function () {
                return true;
            },
            onClick: PartnerEditService.exitEdit
        }
    ];
    this.onStepperChanged = function (object, prop, min, max) {
        UtilsService.clampNumericProp(object, prop, min, max);
    };
    this.numericFieldKeyDown = function ($event, currentValue) {
        if ($event.key.length === 1) {
            var newValue = currentValue || '';
            newValue += $event.key;
            if (!(/^[0-9]+$/.test(newValue))) {
                $event.preventDefault();
            }
        }
    };
}
angular.module('prism-ui.partner').component('partnerDeliveryEndpointsEditor', {
    templateUrl: 'system/partner/editor/components/view/deliveryEndpoints/editor/partner-delivery-endpoints-editor-template.html',
    controller: PartnerDeliveryEndpointsEditorController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function DeliveryProfilesEditViewController(_, $routeParams, $route, $location, PartnerEditService, uiGridConstants, ModalService, NotificationService, MediaAcceptProfileService, BreadcrumbService) {
    var _this = this;
    this.activeTabs = {
        properties: false,
        emails: false,
        deliveryItems: false
    };
    this.enabledTabs = {
        properties: true,
        emails: $routeParams.deliveryProfileId !== '-1',
        deliveryItems: $routeParams.deliveryProfileId !== '-1'
    };
    //Tab Functionality
    this.onTabSelect = function (tab) {
        _this.currentTab = tab;
        $location.search('tab', tab);
    };
    var setupBreadcrumbs = function () {
        if (_.size(BreadcrumbService.getBreadcrumbs()) === 0) {
            BreadcrumbService.addBreadcrumb({
                name: 'Partners',
                location: "/system/partners",
                params: null
            });
            BreadcrumbService.addBreadcrumb({
                name: _this.partnerName,
                location: "/system/partners/edit/" + $routeParams.id + "/deliveryProfiles"
            });
        }
        else if (_.size(BreadcrumbService.getBreadcrumbs()) === 1) {
            BreadcrumbService.addBreadcrumb({
                name: _this.partnerName,
                location: "/system/partners/edit/" + $routeParams.id + "/deliveryProfiles"
            });
        }
    };
    this.$onInit = function () {
        _this.currentTab = $location.search().tab;
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        setupBreadcrumbs();
    };
}
angular.module('prism-ui.deliveryProfiles').component('deliveryProfilesEditView', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/delivery-profiles-edit-view-template.html',
    controller: DeliveryProfilesEditViewController,
    bindings: {
        partnerName: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
function PartnerDeliveryProfilesSearchViewController(_, $location, $routeParams, uiGridConstants, PartnerEditService) {
    var _this = this;
    var getData = function () {
        _this.loadingIndicator.show = true;
        PartnerEditService.getDeliveryProfilesForPartner($routeParams.id).then(function (deliveryProfiles) {
            _this.gridOptions.data = deliveryProfiles;
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var buildEditViewUrl = function (id) {
        return "/system/partners/edit/" + $routeParams.id + "/deliveryProfiles/edit/" + id;
    };
    var navigateToDeliveryProfilesEditViewFromDoubleClick = function (row) {
        $location.url(buildEditViewUrl(row.id));
    };
    var navigateToCreateView = function () {
        $location.url(buildEditViewUrl('-1'));
    };
    var navigateToEditViewFromEditButton = function () {
        $location.url(buildEditViewUrl(_.first(_this.gridApi.selection.getSelectedRows()).id));
    };
    this.onRowDblClick = function (row) {
        navigateToDeliveryProfilesEditViewFromDoubleClick(row.entity);
    };
    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: function () { return true; },
            onClick: navigateToCreateView
        },
        {
            label: 'Edit',
            enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()); },
            onClick: navigateToEditViewFromEditButton
        }
    ];
    var columnDefinitions = [
        {
            field: 'packageAcceptTemplate.name',
            displayName: 'Package Accept Template',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'categoryType.name',
            displayName: 'Content Type',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: false,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: columnDefinitions,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        data: []
    };
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        getData();
    };
}
angular.module('prism-ui.deliveryProfiles').component('partnerDeliveryProfilesSearchView', {
    controller: PartnerDeliveryProfilesSearchViewController,
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/searchView/partner-delivery-profiles-searchview-template.html'
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: partner-due-date-templates-editor-component.ts
 *
 * Created by randysorensen on 6/1/18.
 */
function PartnerDueDateTemplatesEditorController(_, $q, $route, $timeout, BreadcrumbService, PartnerEditService, PermissionsService, SidebarService, UtilsService) {
    var _this = this;
    var setBreadcrumbData = function () {
        _this.partnerBreadcrumb.location = "/system/partners/edit/" + _this.partnerObject.id + "/dueDateTemplates";
        _this.partnerBreadcrumb.name = _this.partnerObject.name;
        _this.breadcrumbName = _.get(_this, 'dueDateTemplateObject.name', 'New SLA Template');
    };
    var getEditData = function () {
        if (_this.canRead) {
            _this.loadingIndicator.show = true;
            PartnerEditService.getDueDateTemplatesEditViewData().then(function (editData) {
                _this.partnerObject = editData.partnerObject;
                _this.availableEmailTemplates = editData.availableEmailTemplates;
                _this.availableBusinesses = editData.availableBusinesses;
                _this.dueDateTemplateObject = editData.dueDateTemplateObject;
                if (_.isNil(_this.dueDateTemplateObject.id)) {
                    _this.editorForm.$setDirty();
                }
                setBreadcrumbData();
            }).finally(function () {
                $timeout(function () {
                    _this.loadingIndicator.show = false;
                });
            });
        }
    };
    var getPermissions = function () {
        var partnerDueDateTemplatesViewState = 'SYSTEM_PARTNERS_DUE_DATE_TEMPLATES_VIEW_STATE';
        return $q.all({
            canRead: PermissionsService.canRead(partnerDueDateTemplatesViewState),
            canWrite: PermissionsService.canWrite(partnerDueDateTemplatesViewState)
        }).then(function (permissions) {
            _this.canRead = permissions.canRead;
            _this.canWrite = permissions.canWrite;
        });
    };
    this.onStepperChanged = function (object, prop, min, max) {
        UtilsService.clampNumericProp(object, prop, min, max);
    };
    var requiredFieldsArePopulated = function () {
        var requiredFields = [
            'name',
            'expression',
            'overdueTemplate',
            'dueDateWarningTemplate',
            'warningThresholdHours'
        ];
        var allFieldsPopulated = requiredFields.reduce(function (accum, field) {
            return accum && UtilsService.hasData(_this.dueDateTemplateObject[field]);
        }, true);
        return allFieldsPopulated;
    };
    var initToolbar = function () {
        _this.toolbarButtonDefs = [
            {
                label: 'Save',
                enabled: function () { return _this.editorForm.$dirty && _this.canWrite && requiredFieldsArePopulated(); },
                onClick: function () {
                    _this.loadingIndicator.show = true;
                    PartnerEditService.saveDueDateTemplate(_this.dueDateTemplateObject).then(function (newDueDateTemplateObject) {
                        _this.dueDateTemplateObject = newDueDateTemplateObject;
                        $route.updateParams({ dueDateTemplateId: _this.dueDateTemplateObject.id });
                        setBreadcrumbData();
                    }).finally(function () {
                        _this.loadingIndicator.show = false;
                    });
                }
            },
            {
                label: 'Revert',
                enabled: function () { return _this.editorForm.$dirty; },
                onClick: function () {
                    PartnerEditService.revertDueDateTemplate(_this.partnerBreadcrumb.location);
                    _this.dueDateTemplateObject = PartnerEditService.dueDateTemplateObject;
                    setBreadcrumbData();
                }
            },
            {
                label: 'Close',
                enabled: function () { return true; },
                onClick: function () { return PartnerEditService.exitEdit(_this.partnerBreadcrumb.location); }
            }
        ];
    };
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.canRead = false;
        _this.canWrite = false;
        _this.breadcrumbName = '';
        _this.partnerBreadcrumb = {
            location: '',
            name: '...',
            params: null,
        };
        initToolbar();
        SidebarService.editService = PartnerEditService;
        BreadcrumbService.editService = PartnerEditService;
        if (BreadcrumbService.getBreadcrumbs().length < 2) {
            // add partner breadcrumb if it's not already added
            BreadcrumbService.addBreadcrumb(_this.partnerBreadcrumb);
        }
        getPermissions().then(getEditData);
    };
    this.$postLink = function () {
        $timeout(function () {
            PartnerEditService.editorForm = _this.editorForm;
        });
    };
}
angular
    .module('prism-ui.partner')
    .component('partnerDueDateTemplatesEditor', {
    templateUrl: 'system/partner/editor/components/view/dueDateTemplates/editor/partner-due-date-templates-editor-template.html',
    controller: PartnerDueDateTemplatesEditorController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: partner-due-date-templates-searchview-component.ts
 *
 * Created by randysorensen on 5/21/18.
 */
function PartnerDueDateTemplatesSearchViewController(_, uiGridConstants, $location, ModalService, NavbarUtilService, NotificationService, PartnerEditService) {
    var _this = this;
    var queryForGridData = function () {
        PartnerEditService.getDueDateTemplatesSearchViewData(_this.showHidden)
            .then(function (dueDateTemplatesData) {
            _this.gridOptions.data = dueDateTemplatesData.dueDateTemplates;
            _this.partnerObject = dueDateTemplatesData.partnerObject;
            _this.searchText = _.get($location.search(), 'searchText') || null;
            filterGrid(_this.searchText);
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var getSelectedCount = function () {
        var selectedCount = 0;
        if (_.get(_this, 'gridApi.selection')) {
            selectedCount = _this.gridApi.selection.getSelectedCount();
        }
        return selectedCount;
    };
    var isSelectedRowHidden = function () {
        //
        // Equivalent to:
        //
        //  return this.gridApi.selection.getSelectedRows()[0].hidden;
        //
        return _.get(_.invoke(_this, 'gridApi.selection.getSelectedRows'), '[0].hidden');
    };
    var editDueDateTemplate = function (dueDateTemplate) {
        if (_.get(dueDateTemplate, 'hidden')) {
            NotificationService.createWarningNotification('You cannot edit a hidden SLA template.');
        }
        else {
            var dueDateTemplateId = _.get(dueDateTemplate, 'id') || -1;
            $location.url("/system/partners/edit/" + _this.partnerObject.id + "/dueDateTemplates/edit/" + dueDateTemplateId);
        }
    };
    var cloneSelectedDueDateTemplate = function () {
        var selectedDueDateTemplate = _this.gridApi.selection.getSelectedRows()[0];
        PartnerEditService.cloneDueDateTemplate(selectedDueDateTemplate)
            .then(function () {
            queryForGridData();
            NotificationService.createSuccessNotification('SLA template successfully cloned.');
        });
    };
    var toggleSelectedDueDateTemplateVisibility = function () {
        var selectedDueDateTemplate = _this.gridApi.selection.getSelectedRows()[0];
        PartnerEditService.toggleDueDateTemplateVisibility(selectedDueDateTemplate)
            .finally(function () {
            queryForGridData();
        });
    };
    var showConfirmationModal = function (action, handler) {
        var capitalizedAction = "" + action[0].toUpperCase() + action.slice(1);
        ModalService.showMessageModal({
            messageText: "Are you sure you want to " + action + " the selected SLA template?",
            title: capitalizedAction + ' SLA Template',
            windowClass: 'confirm-modal-sm',
            showOK: true,
            okText: 'Yes',
            pullCancelLeft: true
        }, handler);
    };
    this.onRowDblClick = function (row) {
        editDueDateTemplate(row.entity);
    };
    var filterGrid = function (searchText) {
        if (!_.isNil(searchText)) {
            _this.searchText = searchText.toLowerCase();
            _this.gridApi.grid.refresh();
        }
    };
    this.processGridFilter = function (rows) {
        _.forEach(rows, function (row) {
            row.visible = _.size(_this.searchText) < 1 || _.includes(row.entity.name.toLowerCase(), _this.searchText);
        });
        return rows;
    };
    var initGrid = function () {
        _this.gridOptions = {
            rowSelection: true,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            enableSelectAll: false,
            multiSelect: false,
            enableColumnResizing: true,
            enableSorting: true,
            enableColumnMenus: false,
            enableHorizontalScrollbar: uiGridConstants.ALWAYS,
            enableVerticalScrollbar: uiGridConstants.ALWAYS,
            rowHeight: 26,
            rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
            onRegisterApi: function (gridApi) {
                _this.gridApi = gridApi;
                _this.gridApi.grid.registerRowsProcessor(_this.processGridFilter, 200);
            },
            data: []
        };
        _this.gridOptions.columnDefs = [
            {
                field: 'name',
                type: 'string',
                width: '*',
                sort: {
                    direction: 'asc',
                    priority: 0
                },
                displayName: 'Name',
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                field: 'expression',
                type: 'string',
                width: '*',
                sort: {
                    direction: 'asc',
                    priority: 3
                },
                displayName: 'Expression',
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                field: 'warningThresholdHours',
                type: 'number',
                width: '15%',
                sort: {
                    direction: 'asc',
                    priority: 1
                },
                displayName: 'Warn Hours Before',
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                field: 'business.name',
                type: 'string',
                width: '15%',
                sort: {
                    direction: 'asc',
                    priority: 2
                },
                displayName: 'Operational Hour Set',
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            }
        ];
    };
    var initToolbar = function () {
        _this.toolbarButtonDefs = [
            {
                label: 'New',
                enabled: function () { return _this.canWrite; },
                onClick: function () { return editDueDateTemplate(null); }
            },
            {
                label: 'Edit',
                enabled: function () { return getSelectedCount() === 1 && !isSelectedRowHidden(); },
                onClick: function () { return editDueDateTemplate(_this.gridApi.selection.getSelectedRows()[0]); }
            },
            {
                label: 'Clone',
                enabled: function () { return _this.canWrite && getSelectedCount() === 1 && !isSelectedRowHidden(); },
                onClick: function () { return showConfirmationModal('clone', cloneSelectedDueDateTemplate); }
            },
            {
                label: 'Hide',
                enabled: function () { return _this.canWrite && getSelectedCount() === 1 && !isSelectedRowHidden(); },
                onClick: function () { return showConfirmationModal('hide', toggleSelectedDueDateTemplateVisibility); }
            },
            {
                label: 'Unhide',
                enabled: function () { return _this.canWrite && getSelectedCount() === 1 && isSelectedRowHidden(); },
                onClick: function () { return showConfirmationModal('unhide', toggleSelectedDueDateTemplateVisibility); }
            }
        ];
        _this.toolbarCheckboxDefs = [
            {
                label: 'Show Hidden',
                onUpdate: function (newValue) {
                    _this.showHidden = newValue;
                    queryForGridData();
                },
                isChecked: _this.showHidden
            }
        ];
    };
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.gridApi = null;
        _this.searchText = null;
        _this.gridOptions = {};
        _this.showHidden = false;
        initGrid();
        initToolbar();
        if (_this.canRead) {
            queryForGridData();
            NavbarUtilService.viewSearchFunction = queryForGridData;
        }
        else {
            NavbarUtilService.viewSearchFunction = function () { };
        }
    };
}
angular.module('prism-ui.partner').component('partnerDueDateTemplatesSearchView', {
    controller: PartnerDueDateTemplatesSearchViewController,
    templateUrl: 'system/partner/editor/components/view/dueDateTemplates/searchView/partner-due-date-templates-searchview-template.html',
    bindings: {
        canRead: '<',
        canWrite: '<',
        partnerObject: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: partner-email-endpoints-editor-component.ts
 *
 * Created by rsorensen-lb on 9/28/17.
 */
'use strict';
function PartnerEmailEndpointsEditorController(_, $q, $route, $routeParams, $timeout, uiGridConstants, BreadcrumbService, ModalService, PartnerEditService, PermissionsService, SidebarService, UtilsService) {
    //=================//
    // Lifecycle Hooks //
    //=================//
    var _this = this;
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.canRead = false;
        _this.canWrite = false;
        SidebarService.editService = PartnerEditService;
        BreadcrumbService.editService = PartnerEditService;
        _this.partnerBreadcrumb = {
            location: '',
            name: '...',
            params: null,
        };
        if (BreadcrumbService.getBreadcrumbs().length < 2) {
            // add partner breadcrumb if it's not already added
            BreadcrumbService.addBreadcrumb(_this.partnerBreadcrumb);
        }
        getPermissions().then(function () { return getEndpointEditData(); });
    };
    this.$postLink = function () {
        $timeout(function () {
            PartnerEditService.editorForm = _this.editorForm;
        });
    };
    //======//
    // Data //
    //======//
    var getPermissions = function () {
        var emailEndpointsViewState = 'SYSTEM_PARTNERS_EMAIL_VIEW_STATE';
        return $q.all({
            canRead: PermissionsService.canRead(emailEndpointsViewState),
            canWrite: PermissionsService.canWrite(emailEndpointsViewState),
        }).then(function (permissions) {
            _this.canRead = permissions.canRead;
            _this.canWrite = permissions.canWrite;
        });
    };
    var setBreadcrumbData = function () {
        _this.partnerBreadcrumb.location =
            '/system/partners/edit/' +
                _this.partnerObject.id +
                '/emailEndpoints';
        _this.partnerBreadcrumb.name = _this.partnerObject.name;
        _this.breadcrumbName = _this.endpointObject.name || 'New Email Endpoint';
    };
    var getEndpointEditData = function () {
        if (_this.canRead) {
            _this.loadingIndicator.show = true;
            PartnerEditService.getEmailEndpointEditData().then(function (data) {
                _this.partnerObject = data.partnerObject;
                _this.availableDeliveryTemplates = _this.partnerObject.deliveryTemplates;
                _this.endpointObject = data.endpointObject;
                _this.availableEmailTemplates = data.availableEmailTemplates;
                if (!_this.endpointObject.id) {
                    _this.editorForm.$setDirty();
                }
                setBreadcrumbData();
                // loading indicator won't shut off without
                // wrapping this in a $timeout() ...?
                $timeout(function () {
                    _this.loadingIndicator.show = false;
                });
            });
        }
    };
    //================//
    // Template Logic //
    //================//
    this.getDeliveryTemplateName = function (deliveryTemplate) {
        return deliveryTemplate.template.name;
    };
    this.reqdFieldsArePopulated = function () {
        var reqdFields = [
            'name',
            'emailTemplate',
            'subjectExpression',
        ];
        return reqdFields.reduce(function (accum, field) {
            return accum && UtilsService.hasData(_this.endpointObject[field]);
        }, true);
    };
    //=================//
    // Toolbar Buttons //
    //=================//
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return _this.editorForm.$dirty && _this.canWrite && _this.reqdFieldsArePopulated(); },
            onClick: function () {
                _this.loadingIndicator.show = true;
                PartnerEditService.saveEmailEndpoint(_this.endpointObject).then(function (newEndpointObject) {
                    _this.endpointObject = newEndpointObject;
                    $route.updateParams({ endpointId: _this.endpointObject.id });
                    setBreadcrumbData();
                    _this.loadingIndicator.show = false;
                });
            },
        },
        {
            label: 'Revert',
            enabled: function () { return _this.editorForm.$dirty; },
            onClick: function () {
                PartnerEditService.revertEmailEndpoint(_this.partnerBreadcrumb.location);
                _this.endpointObject = PartnerEditService.endpointObject;
                setBreadcrumbData();
            },
        },
        {
            label: 'Close',
            enabled: function () { return true; },
            onClick: function () { return PartnerEditService.exitEdit(_this.partnerBreadcrumb.location); },
        }
    ];
}
angular
    .module('prism-ui.partner')
    .component('partnerEmailEndpointsEditor', {
    templateUrl: 'system/partner/editor/components/view/emailEndpoints/editor/partner-email-endpoints-editor-template.html',
    controller: PartnerEmailEndpointsEditorController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: partner-email-endpoints-searchview-component.ts
 *
 * Created by randysorensen on 9/28/17.
 */
'use strict';
function PartnerEmailEndpointsSearchViewController(_, $location, uiGridConstants, ModalService, NavbarUtilService, NotificationService, PartnerEditService) {
    //=================//
    // Lifecycle Hooks //
    //=================//
    var _this = this;
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.showHidden = false;
        // Navbar search button click handler
        NavbarUtilService.viewSearchFunction = queryForGridData;
        queryForGridData();
    };
    //======//
    // Data //
    //======//
    var queryForGridData = function () {
        if (_this.canRead) {
            _this.loadingIndicator.show = true;
            PartnerEditService
                .getEmailEndpointSearchViewData(_this.showHidden)
                .then(function (data) {
                _this.partnerObject = data.partnerObject;
                _this.gridOptions.data = data.emailEndpoints;
                _this.searchText = $location.search().searchText || null;
                _this.loadingIndicator.show = false;
            });
        }
    };
    //=========//
    // Actions //
    //=========//
    var newEmailEndpoint = function () {
        $location.url('/system/partners/edit/' + _this.partnerObject.id +
            '/emailendpoints/edit/-1');
    };
    var editEmailEndpoint = function (endpoint) {
        if (endpoint.hidden) {
            NotificationService.createWarningNotification('"' + endpoint.name + '" is hidden');
        }
        else {
            $location.url('/system/partners/edit/' + _this.partnerObject.id +
                '/emailendpoints/edit/' + endpoint.id);
        }
    };
    var cloneSelectedEmailEndpoint = function () {
        _this.loadingIndicator.show = true;
        var endpoint = getSelectedEmailEndpoint();
        PartnerEditService.cloneEmailEndpoint(endpoint.id)
            .then(function () {
            _this.gridApi.selection.clearSelectedRows();
            queryForGridData();
            // LI should already be hidden by
            // queryForGridData()
            _this.loadingIndicator.show = false;
        });
    };
    var toggleSelectedEmailEndpointVisibility = function () {
        _this.loadingIndicator.show = true;
        var endpoint = getSelectedEmailEndpoint();
        PartnerEditService.toggleEmailEndpointVisibility(endpoint.id)
            .then(function () {
            _this.gridApi.selection.clearSelectedRows();
            queryForGridData();
            // LI should already be hidden by
            // queryForGridData()
            _this.loadingIndicator.show = false;
        });
    };
    var showConfirmationModal = function (action, handler) {
        var capitalizedAction = action[0].toUpperCase() + action.slice(1);
        ModalService.showMessageModal({
            messageText: 'Are you sure you want to ' + action +
                ' "' + getSelectedEmailEndpoint().name + '"?',
            title: capitalizedAction + ' Partner Email Endpoint',
            windowClass: 'confirm-modal-sm',
            showOK: true,
            okText: 'Yes',
            pullCancelLeft: true
        }, function () { handler(); }, function () { });
    };
    //======//
    // Grid //
    //======//
    var gridColDefs = [
        {
            field: 'name',
            type: 'string',
            width: '15%',
            sort: {
                direction: uiGridConstants.ASC,
                priority: 0,
            },
            displayName: 'Name',
        },
        {
            field: 'emailTemplate.name',
            type: 'string',
            width: '15%',
            sort: {
                direction: uiGridConstants.ASC,
                priority: 1,
            },
            displayName: 'Email Template',
        },
        {
            field: 'subjectExpression',
            type: 'string',
            width: '*',
            sort: {
                direction: uiGridConstants.ASC,
                priority: 3,
            },
            displayName: 'Subject Expression',
        },
        {
            field: 'deliveryTemplates',
            type: 'string',
            width: '*',
            sort: {
                direction: uiGridConstants.ASC,
                priority: 2,
            },
            cellTemplate: 'system/partner/editor/components/view/emailEndpoints/searchView/gridTemplates/delivery-template-list-cell-template.html',
            displayName: 'Delivery Templates',
        },
        {
            field: 'recipients.length',
            type: 'number',
            width: 125,
            sort: {
                direction: uiGridConstants.ASC,
                priority: 4,
            },
            displayName: '# of Recipients',
        }
    ];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        multiSelect: false,
        columnDefs: gridColDefs,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            _this.gridApi.grid.registerRowsProcessor(processGridFilter, 200);
            filterGrid(_this.searchText);
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        data: []
    };
    this.onRowDblClick = function (row) {
        editEmailEndpoint(row.entity);
    };
    var filterGrid = function (searchText) {
        if (searchText !== null) {
            _this.searchText = searchText;
            _this.gridApi.grid.refresh();
        }
    };
    var processGridFilter = function (renderableRows) {
        _.forEach(renderableRows, function (row) {
            row.visible = (_this.searchText === null) ?
                true :
                _.includes(row.entity.name.toLowerCase(), _this.searchText.toLowerCase());
        });
        return renderableRows;
    };
    var getSelectedEmailEndpoint = function () {
        return _this.gridApi.selection.getSelectedRows()[0];
    };
    this.getDeliveryTemplateNames = function (rowEntity) {
        return _.map(rowEntity.deliveryTemplates, 'template.name').sort();
    };
    //=========//
    // Toolbar //
    //=========//
    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: function () { return _this.canWrite; },
            onClick: function () { return newEmailEndpoint(); },
        },
        {
            label: 'Edit',
            enabled: function () { return _this.gridApi.selection.getSelectedCount() === 1 && _this.canRead; },
            onClick: function () { return editEmailEndpoint(getSelectedEmailEndpoint()); },
        },
        {
            label: 'Clone',
            enabled: function () { return _this.gridApi.selection.getSelectedCount() === 1 && _this.canWrite; },
            onClick: function () { return showConfirmationModal('clone', cloneSelectedEmailEndpoint); },
        },
        {
            label: 'Hide',
            enabled: function () {
                return _this.gridApi.selection.getSelectedCount() === 1 &&
                    !getSelectedEmailEndpoint().hidden &&
                    _this.canWrite;
            },
            onClick: function () { return showConfirmationModal('hide', toggleSelectedEmailEndpointVisibility); },
        },
        {
            label: 'Unhide',
            enabled: function () {
                return _this.gridApi.selection.getSelectedCount() === 1 &&
                    getSelectedEmailEndpoint().hidden &&
                    _this.canWrite;
            },
            onClick: function () { return showConfirmationModal('hide', toggleSelectedEmailEndpointVisibility); },
        }
    ];
    this.toolbarCheckboxDefs = [
        {
            label: 'Show Hidden',
            onUpdate: function (newValue) {
                _this.showHidden = newValue;
                queryForGridData();
            },
            isChecked: this.showHidden,
        },
    ];
}
angular
    .module('prism-ui.partner')
    .component('partnerEmailEndpointsSearchView', {
    templateUrl: 'system/partner/editor/components/view/emailEndpoints/searchView/partner-email-endpoints-searchview-template.html',
    controller: PartnerEmailEndpointsSearchViewController,
    bindings: {
        canRead: '<',
        canWrite: '<',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function nielsenTemplatesEditViewController(_, $routeParams, $route, $location, PartnerEditService, uiGridConstants, ModalService, NotificationService, MediaAcceptProfileService, BreadcrumbService, UtilsService, SidebarService, $timeout) {
    var _this = this;
    this.editData = {};
    var getData = function () {
        _this.loadingIndicator.show = true;
        PartnerEditService.getNielsenTemplate($routeParams.nielsenTemplateId).then(function (nielsenTemplate) {
            PartnerEditService.originalnielsenTemplateData = _.cloneDeep(nielsenTemplate);
            _this.editData = nielsenTemplate;
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveHandler = function () {
        _this.loadingIndicator.show = true;
        if (_.isNil(_.get(_this, 'editData.data')) || _.isEmpty(_.get(_this, 'editData.data'))) {
            _.set(_this, 'editData.data', {});
        }
        if ($routeParams.nielsenTemplateId === '-1') {
            saveNewNielsenTemplate();
        }
        else {
            updateNielsenTemplate();
        }
    };
    var updateNielsenTemplate = function () {
        PartnerEditService.updateNielsenTemplate(_this.editData).then(function (nielsenTemplate) {
            PartnerEditService.originalnielsenTemplateData = _.cloneDeep(nielsenTemplate);
            _this.editData = nielsenTemplate;
            _this.editorForm.$setPristine();
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveNewNielsenTemplate = function () {
        PartnerEditService.createNielsenTemplate($routeParams.id, _this.editData).then(function (nielsenTemplate) {
            _this.editData = nielsenTemplate;
            $route.updateParams({ nielsenTemplateId: nielsenTemplate.id });
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return !_.get(_this.editorForm, '$pristine')
                && _.size(_.get(_this.editData, 'name')); },
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: function () { return !_.get(_this.editorForm, '$pristine'); },
            onClick: function () {
                _this.editData = _.cloneDeep(PartnerEditService.originalnielsenTemplateData);
                _this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: function () { return !_.get(_this.editorForm, '$dirty'); },
            onClick: function () { return $location.url("/system/partners/edit/" + $routeParams.id + "/nielsenTemplates"); }
        }
    ];
    this.$onInit = function () {
        SidebarService.editService = PartnerEditService;
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        if ($routeParams.nielsenTemplateId !== '-1') {
            getData();
        }
        if (_.isNil(_.get(PartnerEditService, 'partnerObject'))) {
            PartnerEditService.getEditData().then(function () {
                setupBreadcrumbs();
            });
        }
        else {
            setupBreadcrumbs();
        }
    };
    var setupBreadcrumbs = function () {
        if ($routeParams.nielsenTemplateId !== '-1') {
            if (_.size(BreadcrumbService.getBreadcrumbs()) < 2) {
                BreadcrumbService.addBreadcrumb({
                    name: _.get(PartnerEditService, 'partnerObject.name', 'Edit Nielsen Template'),
                    location: "/system/partners/edit/" + $routeParams.id + "/nielsenTemplates"
                });
            }
        }
        else {
            _this.allowNielsenTemplateTypeEdit = true;
            BreadcrumbService.addBreadcrumb({
                name: _.get(PartnerEditService, 'partnerObject.name', 'Create Nielsen Template'),
                location: "/system/partners/edit/" + $routeParams.id + "/nielsenTemplates"
            });
        }
    };
    this.$onDestroy = function () {
        PartnerEditService.originalnielsenTemplateData = null;
        PartnerEditService.viewData = null;
    };
    this.$postLink = function () {
        $timeout(function () {
            PartnerEditService.editorForm = _this.editorForm;
            BreadcrumbService.editService = PartnerEditService;
        });
    };
}
angular.module('prism-ui.nielsenTemplates').component('nielsenTemplatesEditView', {
    templateUrl: 'system/partner/editor/components/view/nielsenTemplates/editor/nielsen-templates-edit-view-template.html',
    controller: nielsenTemplatesEditViewController
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
function nielsenTemplatesSearchViewController(_, $location, uiGridConstants, ModalService, NavbarUtilService, $timeout, PartnerEditService, NotificationService) {
    var _this = this;
    this.showHidden = false;
    var getData = function () {
        _this.loadingIndicator.show = true;
        PartnerEditService.getNielsenTemplatesForPartner(_this.partnerObject.id, _this.showHidden)
            .then(function (nielsenTemplates) {
            _this.gridOptions.data = nielsenTemplates;
            _this.searchText = _.get($location.search(), 'searchText') || null;
            filterGrid(_this.searchText);
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var navigateTonielsenTemplatesEditViewFromDoubleClick = function (row) {
        if (!_.get(row, 'hidden')) {
            $location.url("/system/partners/edit/" + _this.partnerObject.id + "/nielsenTemplates/edit/" + row.id);
        }
    };
    var navigateToCreateView = function () {
        $location.url("/system/partners/edit/" + _this.partnerObject.id + "/nielsenTemplates/edit/-1");
    };
    var navigateToEditViewFromEditButton = function () {
        $location.url("/system/partners/edit/" + _this.partnerObject.id + "/nielsenTemplates/edit/" + _.first(_this.gridApi.selection.getSelectedRows()).id);
    };
    var cloneItem = function () {
        var nielsenTemplateToClone = _.cloneDeep(_.first(_this.gridApi.selection.getSelectedRows()));
        ModalService.showMessageModal({
            messageText: 'Are you sure you want to clone the selected nielsen Template?',
            pullCancelLeft: true,
            title: 'Clone nielsen Template',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, function () {
            _this.loadingIndicator.show = true;
            PartnerEditService.cloneNielsenTemplate(nielsenTemplateToClone.id).then(function () {
                NotificationService.createSuccessNotification('nielsen template successfully cloned!');
                getData();
            }).catch(function () {
                NotificationService.createFailureNotification('Could not clone nielsen template!');
            }).finally(function () {
                _this.loadingIndicator.show = false;
            });
        });
    };
    var toggleItemHidden = function () {
        var nielsenTemplateToToggleHidden = _.cloneDeep(_.first(_this.gridApi.selection.getSelectedRows()));
        ModalService.showMessageModal({
            messageText: "Are you sure you want to " + (nielsenTemplateToToggleHidden.hidden ? 'unhide' : 'hide') + " the selected nielsen Template?",
            pullCancelLeft: true,
            title: (nielsenTemplateToToggleHidden.hidden ? 'Unhide' : 'Hide') + " nielsen Template",
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, function () {
            _this.loadingIndicator.show = true;
            PartnerEditService.toggleNielsenTemplateHidden(nielsenTemplateToToggleHidden.id).then(function () {
                NotificationService.createSuccessNotification("nielsen template successfully " + (nielsenTemplateToToggleHidden.hidden ? 'unhidden' : 'hidden') + "!");
                getData();
            }).catch(function () {
                NotificationService.createFailureNotification("Could not " + (nielsenTemplateToToggleHidden.hidden ? 'unhide' : 'hide') + " nielsen template!");
            }).finally(function () {
                _this.loadingIndicator.show = false;
            });
        });
    };
    this.onRowDblClick = function (row) {
        navigateTonielsenTemplatesEditViewFromDoubleClick(row.entity);
    };
    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: function () { return true; },
            onClick: navigateToCreateView
        },
        {
            label: 'Edit',
            enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) && !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
            onClick: navigateToEditViewFromEditButton
        },
        {
            label: 'Clone',
            enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) && !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
            onClick: cloneItem
        },
        {
            label: 'Hide',
            enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) &&
                !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
            onClick: toggleItemHidden
        },
        {
            label: 'Unhide',
            enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) &&
                _.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
            onClick: toggleItemHidden
        }
    ];
    var columnDefinitions = [
        {
            field: 'name',
            displayName: 'Name',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'data.nielsenAssetId',
            displayName: 'Asset ID',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'data.nielsenAssetName',
            displayName: 'Asset Name',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'data.nielsenDsrcId',
            displayName: 'DSRC ID',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'data.nielsenDsrcName',
            displayName: 'DSRC Name',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'data.nielsenEpisodeId',
            displayName: 'Episode ID',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'data.nielsenSId',
            displayName: 'SID',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: false,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: columnDefinitions,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            _this.gridApi.grid.registerRowsProcessor(_this.processGridFilter, 200);
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        data: []
    };
    this.toolbarCheckboxDefs = [
        {
            label: 'Show Hidden',
            onUpdate: function (newValue) {
                _this.showHidden = newValue;
                getData();
            },
            isChecked: this.showHidden
        }
    ];
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        NavbarUtilService.viewSearchFunction = getData;
        getData();
    };
    var filterGrid = function (searchText) {
        if (!_.isNil(searchText)) {
            _this.searchText = searchText.toLowerCase();
            _this.gridApi.grid.refresh();
        }
    };
    this.processGridFilter = function (rows) {
        var searchText = $location.search().searchText;
        rows.forEach(function (row) {
            _.set(row, 'visible', _.includes(_.toLower(row.entity.name), _.toLower(searchText)));
        });
        return rows;
    };
    this.$onDestroy = function () {
        NavbarUtilService.viewSearchFunction = null;
    };
    this.$postLink = function () {
        $timeout(function () {
            PartnerEditService.editorForm = _this.editorForm;
        });
    };
}
angular.module('prism-ui.nielsenTemplates').component('nielsenTemplatesSearchView', {
    controller: nielsenTemplatesSearchViewController,
    templateUrl: 'system/partner/editor/components/view/nielsenTemplates/searchView/nielsen-templates-searchview-template.html',
    bindings: {
        partnerObject: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function MediaAcceptProfilesArtworkValidatorsSearchViewController(MediaAcceptProfileService, uiGridConstants, $location, NavbarUtilService, ModalService, $routeParams, BreadcrumbService) {
    var _this = this;
    var getData = function () {
        MediaAcceptProfileService.getValidators($routeParams.id, _this.showHidden, { validatorType: 'IMAGE' }, _this.showHidden).then(function (validators) {
            _this.gridOptions.data = validators;
            _this.gridApi.selection.clearSelectedRows();
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var addMapBreadCrumb = function () {
        BreadcrumbService.addBreadcrumb({
            name: _this.mediaAcceptProfile.name,
            location: "/system/templates/media/acceptProfiles/edit/" + _this.mediaAcceptProfile.id,
            params: { editView: 'artwork' }
        });
    };
    var navigateToEditView = function (artworkValidator) {
        addMapBreadCrumb();
        if (_.isNil(artworkValidator)) {
            $location.url("system/templates/media/acceptProfiles/edit/" + $routeParams.id + "/artworkValidators/edit/" + _.get(_.first(_this.gridApi.selection.getSelectedRows()), 'id'));
        }
        else {
            $location.url("system/templates/media/acceptProfiles/edit/" + $routeParams.id + "/artworkValidators/edit/" + _.get(artworkValidator, 'id'));
        }
    };
    var navigateToEditViewToCreateArtworkValidator = function () {
        addMapBreadCrumb();
        $location.url("system/templates/media/acceptProfiles/edit/" + $routeParams.id + "/artworkValidators/edit/-1");
    };
    var toggleVisibility = function (message) {
        ModalService.showMessageModal({
            messageText: message,
            pullCancelLeft: true,
            title: 'Hide Artwork Validator',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, function () {
            _this.loadingIndicator.show = true;
            var artworkValidatorId = _.get(_.first(_this.gridApi.selection.getSelectedRows()), 'id');
            MediaAcceptProfileService.toggleValidatorVisibility(artworkValidatorId).then(function () {
                getData();
            }).finally(function () {
                _this.setFormPristine();
                _this.loadingIndicator.show = false;
            });
        });
    };
    var columnDefinitions = [
        {
            field: 'trackNumber',
            width: 150,
            type: 'number',
            displayName: 'Track Number',
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'format',
            displayName: 'Format',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'bitDepth',
            displayName: 'Bit Depth',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'colorSpace',
            displayName: 'Color Space',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        data: [],
        multiSelect: false,
        columnDefs: columnDefinitions,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
    this.onRowDblClick = function (row) {
        if (!_.get(row.entity, 'hidden')) {
            navigateToEditView(row.entity);
        }
    };
    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: function () { return true; },
            onClick: navigateToEditViewToCreateArtworkValidator
        },
        {
            label: 'Edit',
            enabled: function () { return _this.gridApi.selection.getSelectedCount() && !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
            onClick: navigateToEditView
        },
        {
            label: 'Hide',
            enabled: function () { return _.first(_this.gridApi.selection.getSelectedRows()) && !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
            onClick: function () { return toggleVisibility('Are you sure that you want to hide this Artwork Validator?'); }
        },
        {
            label: 'Unhide',
            enabled: function () { return _.first(_this.gridApi.selection.getSelectedRows()) && _.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
            onClick: function () { return toggleVisibility('Are you sure that you want to unhide this Artwork Validator?'); }
        }
    ];
    this.toolbarCheckboxDefs = [
        {
            label: 'Show Hidden',
            onUpdate: function (newState) {
                _this.showHidden = newState;
                $location.search('showHidden', newState);
                getData();
                _this.setFormPristine();
            },
            isChecked: this.showHidden
        }
    ];
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.showHidden = $location.search().showHidden;
        _this.toolbarCheckboxDefs[0].isChecked = _this.showHidden;
        getData();
    };
}
angular.module('prism-ui.mediaAcceptProfiles').component('mediaAcceptProfilesArtworkValidatorsSearchView', {
    templateUrl: 'system/templates/mediaAcceptProfiles/components/validators/artwork/searchView/media-accept-profiles-artwork-validators-search-view-template.html',
    controller: MediaAcceptProfilesArtworkValidatorsSearchViewController,
    bindings: {
        setFormPristine: '&',
        mediaAcceptProfile: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function MediaAcceptProfilesAudioValidatorsSearchViewController(MediaAcceptProfileService, uiGridConstants, $location, NavbarUtilService, ModalService, $routeParams, BreadcrumbService) {
    var _this = this;
    var getData = function () {
        MediaAcceptProfileService.getValidators($routeParams.id, _this.showHidden).then(function (validators) {
            _this.gridOptions.data = _.filter(validators, { validatorType: 'AUDIO' });
            _this.validators = validators;
            _this.gridApi.selection.clearSelectedRows();
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var addMapBreadCrumb = function () {
        BreadcrumbService.addBreadcrumb({
            name: _this.mediaAcceptProfile.name,
            location: "/system/templates/media/acceptProfiles/edit/" + _this.mediaAcceptProfile.id,
            params: { editView: 'audio' }
        });
    };
    var navigateToEditView = function (audioValidator) {
        addMapBreadCrumb();
        if (_.isNil(audioValidator)) {
            $location.url("system/templates/media/acceptProfiles/edit/" + $routeParams.id + "/audioValidators/edit/" + _.get(_.first(_this.gridApi.selection.getSelectedRows()), 'id'));
        }
        else {
            $location.url("system/templates/media/acceptProfiles/edit/" + $routeParams.id + "/audioValidators/edit/" + _.get(audioValidator, 'id'));
        }
    };
    var navigateToEditViewToCreateAudioValidator = function () {
        addMapBreadCrumb();
        $location.url("system/templates/media/acceptProfiles/edit/" + $routeParams.id + "/audioValidators/edit/-1");
    };
    var toggleVisibility = function (message) {
        ModalService.showMessageModal({
            messageText: message,
            pullCancelLeft: true,
            title: 'Delete Audio Validator',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, function () {
            var trackNumber = _.get(_.first(_this.gridApi.selection.getSelectedRows()), 'trackNumber');
            _.remove(_this.validators, { trackNumber: trackNumber, validatorType: 'AUDIO' });
            _.remove(_this.validators, { trackNumber: trackNumber, validatorType: 'AUDIOCHANNEL' });
            _this.loadingIndicator.show = true;
            MediaAcceptProfileService.updateValidators($routeParams.id, _this.validators).then(function () {
                getData();
            }).finally(function () {
                _this.loadingIndicator.show = false;
                _this.setFormPristine();
            });
        });
    };
    var columnDefinitions = [
        {
            field: 'trackNumber',
            type: 'number',
            width: 150,
            displayName: 'Track Number',
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'format',
            displayName: 'Format',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'title',
            displayName: 'Title',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'codec',
            displayName: 'Codec',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'duration',
            width: 300,
            displayName: 'Duration',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        data: [],
        multiSelect: false,
        columnDefs: columnDefinitions,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
    this.onRowDblClick = function (row) {
        if (!_.get(row.entity, 'hidden')) {
            navigateToEditView(row.entity);
        }
    };
    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: function () { return true; },
            onClick: navigateToEditViewToCreateAudioValidator
        },
        {
            label: 'Edit',
            enabled: function () { return _this.gridApi.selection.getSelectedCount() && !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
            onClick: navigateToEditView
        },
        {
            label: 'Delete',
            enabled: function () { return _.first(_this.gridApi.selection.getSelectedRows()) && !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
            onClick: function () { return toggleVisibility('Are you sure that you want to delete this Audio Validator and the Corresponding Audio Channel Validators that share the same Track Number?'); }
        }
    ];
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.showHidden = $location.search().showHidden;
        getData();
    };
}
angular.module('prism-ui.mediaAcceptProfiles').component('mediaAcceptProfilesAudioValidatorsSearchView', {
    templateUrl: 'system/templates/mediaAcceptProfiles/components/validators/audio/searchView/media-accept-profiles-audio-validators-search-view-template.html',
    controller: MediaAcceptProfilesAudioValidatorsSearchViewController,
    bindings: {
        setFormPristine: '&',
        mediaAcceptProfile: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function MediaAcceptProfilesAudioValidatorEditViewController($location, $route, $routeParams, $timeout, BreadcrumbService, MediaAcceptProfileService) {
    var _this = this;
    this.validateInteger = function (value) {
        return _.isInteger(value) && _.toNumber(value) > -1;
    };
    var splitValidators = function (validators) {
        if ($routeParams.validatorId !== '-1') {
            _this.editData = _.first(_.remove(validators, { id: $routeParams.validatorId }));
        }
        _this.otherValidators = _.cloneDeep(validators);
    };
    var setValidator = function (validators) {
        splitValidators(validators);
        MediaAcceptProfileService.originalAudioValidatorEditData = _.cloneDeep(_this.editData);
        _this.originalTrackNumber = _.toNumber(_this.editData.trackNumber);
        _this.editData.trackNumber = !_.isNil(_this.editData.trackNumber) ? _.toNumber(_this.editData.trackNumber) : undefined;
    };
    var getData = function () {
        _this.loadingIndicator.show = true;
        MediaAcceptProfileService.getValidators($routeParams.id).then(function (validators) {
            setValidator(validators);
            if (_.get(_this.editData, 'hidden') || _.isNil(_this.editData)) {
                $location.url("/system/templates/media/acceptProfiles/edit/" + $routeParams.id).search({ editView: 'audio' });
            }
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var getExistingValidators = function () {
        MediaAcceptProfileService.getValidators($routeParams.id, false, { validatorType: 'AUDIO' })
            .then(function (existingAudioValidators) {
            _this.existingAudioValidatorTrackNumbers = [];
            _.forEachRight(existingAudioValidators, function (audioValidator) {
                _this.existingAudioValidatorTrackNumbers.push(_.toNumber(_.get(audioValidator, 'trackNumber')));
            });
            _this.existingAudioValidatorTrackNumbers.sort();
            _this.existingAudioValidatorTrackNumberWarningMessage = {
                type: 'error',
                message: "This track number is already in use! Track numbers currently in use: " + _this.existingAudioValidatorTrackNumbers.join(', ')
            };
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var trackNumberExists = function (suppliedTrackNumber) {
        return _.includes(_this.existingAudioValidatorTrackNumbers, suppliedTrackNumber);
    };
    this.trackNumberNotAllowed = function () {
        return trackNumberExists(_this.editData.trackNumber)
            && _this.editData.trackNumber > -1
            && _this.editorForm.$dirty
            && _this.originalTrackNumber !== _this.editData.trackNumber;
    };
    var saveHandler = function () {
        _this.loadingIndicator.show = true;
        _this.editData.validatorType = 'AUDIO';
        var validatorsToSave = _.concat([_this.editData], _this.otherValidators);
        MediaAcceptProfileService.updateValidators($routeParams.id, validatorsToSave)
            .then(function (validators) {
            var updatedValidator = _.find(validators, {
                trackNumber: _.toString(_this.editData.trackNumber),
                validatorType: 'AUDIO'
            });
            $route.updateParams({ validatorId: updatedValidator.id });
            setValidator(validators);
        }).finally(function () {
            _this.loadingIndicator.show = false;
            _this.editorForm.$setPristine();
        });
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return !_.get(_this.editorForm, '$pristine')
                && !_this.trackNumberNotAllowed()
                && !_.isNil(_.get(_this.editData, 'trackNumber'))
                && _.toNumber(_.get(_this.editData, 'trackNumber')) > -1
                && _.isInteger(_.toNumber(_.get(_this.editData, 'trackNumber'))); },
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: function () { return !_.get(_this.editorForm, '$pristine'); },
            onClick: function () {
                _this.editorForm.$setPristine();
                if ($routeParams.validatorId !== '-1') {
                    _this.originalTrackNumber = _.toNumber(MediaAcceptProfileService.originalAudioValidatorEditData.trackNumber);
                    _this.editData = _.cloneDeep(MediaAcceptProfileService.originalAudioValidatorEditData);
                    _this.editData.trackNumber = _.toNumber(MediaAcceptProfileService.originalAudioValidatorEditData.trackNumber);
                    _this.editorForm.$setPristine();
                }
                else {
                    $location.url("/system/templates/media/acceptProfiles/edit/" + $routeParams.id).search({ editView: 'audio' });
                }
            }
        },
        {
            label: 'Close',
            enabled: function () { return !_.get(_this.editorForm, '$dirty'); },
            onClick: function () { return $location.url("/system/templates/media/acceptProfiles/edit/" + $routeParams.id).search({ editView: 'audio' }); }
        }
    ];
    this.$onInit = function () {
        _this.editData = {
            trackNumber: undefined
        };
        _this.existingAudioValidatorTrackNumbers = [];
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        getExistingValidators();
        getData();
        if (!_.size(BreadcrumbService.getBreadcrumbs())) {
            BreadcrumbService.addBreadcrumb({
                name: 'Edit Media Accept Profile Template',
                location: "/system/templates/search",
                params: { tab: 'Media', subTab: 'MediaAcceptProfiles' }
            });
            BreadcrumbService.addBreadcrumb({
                name: _.get(_this, 'acceptProfile.name'),
                location: "/system/templates/media/acceptProfiles/edit/" + _.get(_this, 'acceptProfile.id'),
                params: { editView: 'audio' }
            });
        }
    };
    this.$postLink = function () {
        $timeout(function () {
            MediaAcceptProfileService.editorForm = _this.editorForm;
        });
    };
    this.$onDestroy = function () {
        MediaAcceptProfileService.editorForm = null;
    };
}
angular.module('prism-ui.mediaAcceptProfiles').component('mediaAcceptProfilesAudioValidatorEditView', {
    templateUrl: 'system/templates/mediaAcceptProfiles/components/validators/audio/editor/media-accept-profiles-audio-validator-edit-view-template.html',
    controller: MediaAcceptProfilesAudioValidatorEditViewController,
    bindings: {
        acceptProfile: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function MediaAcceptProfilesGeneralValidatorEditViewController(_, $location, $route, $routeParams, $timeout, uiGridConstants, MediaAcceptProfileService) {
    var _this = this;
    this.editData = {
        trackNumber: null
    };
    this.onTruncatedChanged = function () {
        switch (_.toLower(_this.truncated)) {
            case 'required':
                _this.editData.truncated = 'true';
                break;
            case 'forbidden':
                _this.editData.truncated = 'false';
                break;
            default:
                _this.editData.truncated = null;
        }
    };
    this.validateInteger = function (value) {
        return _.isInteger(value) && _.toNumber(value) > -1;
    };
    var setValidator = function (validators) {
        _this.validators = validators;
        var validator = _.first(_.remove(validators, { validatorType: 'GENERAL' }));
        if (!_.isNil(validator)) {
            _this.editData = _.cloneDeep(validator);
            _this.editData.trackNumber = _.toInteger(validator.trackNumber);
            _this.originalTrackNumber = _.toInteger(validator.trackNumber);
        }
        else {
            _this.originalTrackNumber = null;
        }
        MediaAcceptProfileService.originalGeneralValidatorEditData = _.cloneDeep(_this.editData);
    };
    var getData = function () {
        _this.loadingIndicator.show = true;
        MediaAcceptProfileService.getValidators($routeParams.id, false).then(function (validators) {
            setValidator(validators);
        }).finally(function () {
            switch (_this.editData.truncated) {
                case 'true':
                    _this.truncated = 'Required';
                    break;
                case 'false':
                    _this.truncated = 'Forbidden';
                    break;
                default:
                    _this.truncated = 'Not Validated';
                    break;
            }
            _this.loadingIndicator.show = false;
        });
    };
    var saveHandler = function () {
        _this.loadingIndicator.show = true;
        _this.editData.validatorType = 'GENERAL';
        var validatorsToSave = _.concat([_this.editData], _this.validators);
        MediaAcceptProfileService.updateValidators($routeParams.id, validatorsToSave).then(function (validators) {
            setValidator(validators);
        }).finally(function () {
            _this.loadingIndicator.show = false;
            _this.editorForm.$setPristine();
            _this.setFormPristine();
        });
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return !_.get(_this.editorForm, '$pristine')
                && !_.isNil(_.get(_this.editData, 'trackNumber'))
                && _.toNumber(_.get(_this.editData, 'trackNumber')) > -1
                && _.isInteger(_.toNumber(_.get(_this.editData, 'trackNumber'))); },
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: function () { return !_.get(_this.editorForm, '$pristine'); },
            onClick: function () {
                _this.editData = _.cloneDeep(MediaAcceptProfileService.originalGeneralValidatorEditData);
                if (!_.isNil(MediaAcceptProfileService.originalGeneralValidatorEditData.trackNumber)) {
                    _this.editData.trackNumber = _.toInteger(MediaAcceptProfileService.originalGeneralValidatorEditData.trackNumber);
                }
                else {
                    _this.editData.trackNumber = null;
                }
                _this.setFormPristine();
            }
        },
        {
            label: 'Close',
            enabled: function () { return true; },
            onClick: function () { return $location.url("/system/templates/search").search({
                tab: 'Media',
                subTab: 'MediaAcceptProfiles'
            }); }
        }
    ];
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.truncatedOptions = ['Required', 'Forbidden', 'Not Validated'];
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        getData();
    };
    this.$postLink = function () {
        $timeout(function () {
            MediaAcceptProfileService.editorForm = _this.editorForm;
        });
    };
    this.$onDestroy = function () {
        MediaAcceptProfileService.editorForm = null;
    };
}
angular.module('prism-ui.mediaAcceptProfiles').component('mediaAcceptProfilesGeneralValidatorEditView', {
    templateUrl: 'system/templates/mediaAcceptProfiles/components/validators/general/editor/media-accept-profiles-general-validator-edit-view-template.html',
    controller: MediaAcceptProfilesGeneralValidatorEditViewController,
    bindings: {
        setFormPristine: '&',
        mediaAcceptProfile: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function MediaAcceptProfilesImageValidatorEditViewController(MediaAcceptProfileService, uiGridConstants, $location, NavbarUtilService, ModalService, $routeParams, $route, $timeout, BreadcrumbService) {
    var _this = this;
    this.validateInteger = function (value) {
        return _.isInteger(value) && _.toNumber(value) > -1;
    };
    var splitValidators = function (validators) {
        if ($routeParams.validatorId !== '-1') {
            _this.editData = _.first(_.remove(validators, { id: $routeParams.validatorId }));
        }
        _this.otherValidators = _.cloneDeep(validators);
    };
    var setValidator = function (validators) {
        splitValidators(validators);
        MediaAcceptProfileService.originalImageValidatorEditData = _.cloneDeep(_this.editData);
        _this.originalTrackNumber = _.toNumber(_this.editData.trackNumber);
        _this.editData.trackNumber = !_.isNil(_this.editData.trackNumber) ? _.toNumber(_this.editData.trackNumber) : undefined;
    };
    var getData = function () {
        _this.loadingIndicator.show = true;
        MediaAcceptProfileService.getValidators($routeParams.id).then(function (validators) {
            setValidator(validators);
            if (_.get(_this.editData, 'hidden') || _.isNil(_this.editData)) {
                $location.url("/system/templates/media/acceptProfiles/edit/" + $routeParams.id).search({ editView: 'image' });
            }
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var getExistingValidators = function () {
        MediaAcceptProfileService.getValidators($routeParams.id, false, { validatorType: 'IMAGE' })
            .then(function (existingImageValidators) {
            _this.existingImageValidatorTrackNumbers = [];
            _.forEachRight(existingImageValidators, function (imageValidator) {
                _this.existingImageValidatorTrackNumbers.push(_.toNumber(_.get(imageValidator, 'trackNumber')));
            });
            _this.existingImageValidatorTrackNumbers.sort();
            _this.existingImageValidatorTrackNumberWarningMessage = {
                type: 'error',
                message: "This track number is already in use! Track numbers currently in use: " + _this.existingImageValidatorTrackNumbers.join(', ')
            };
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var trackNumberExists = function (suppliedTrackNumber) {
        return _.includes(_this.existingImageValidatorTrackNumbers, suppliedTrackNumber);
    };
    this.trackNumberNotAllowed = function () {
        return trackNumberExists(_this.editData.trackNumber)
            && _this.editData.trackNumber > -1
            && _this.editorForm.$dirty
            && _this.originalTrackNumber !== _this.editData.trackNumber;
    };
    var saveHandler = function () {
        _this.loadingIndicator.show = true;
        _this.editData.validatorType = 'IMAGE';
        var validatorsToSave = _.concat([_this.editData], _this.otherValidators);
        MediaAcceptProfileService.updateValidators($routeParams.id, validatorsToSave).then(function (validators) {
            var updatedValidator = _.find(validators, {
                trackNumber: _.toString(_this.editData.trackNumber),
                validatorType: 'IMAGE'
            });
            $route.updateParams({ validatorId: updatedValidator.id });
            setValidator(validators);
        }).finally(function () {
            _this.loadingIndicator.show = false;
            _this.editorForm.$setPristine();
        });
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return !_.get(_this.editorForm, '$pristine')
                && !_this.trackNumberNotAllowed()
                && !_.isNil(_.get(_this.editData, 'trackNumber'))
                && _.toNumber(_.get(_this.editData, 'trackNumber')) > -1
                && _.isInteger(_.toNumber(_.get(_this.editData, 'trackNumber'))); },
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: function () { return !_.get(_this.editorForm, '$pristine'); },
            onClick: function () {
                _this.editorForm.$setPristine();
                if ($routeParams.validatorId !== '-1') {
                    _this.originalTrackNumber = _.toNumber(MediaAcceptProfileService.originalImageValidatorEditData.trackNumber);
                    _this.editData = _.cloneDeep(MediaAcceptProfileService.originalImageValidatorEditData);
                    _this.editData.trackNumber = _.toNumber(MediaAcceptProfileService.originalImageValidatorEditData.trackNumber);
                    _this.editorForm.$setPristine();
                }
                else {
                    $location.url("/system/templates/media/acceptProfiles/edit/" + $routeParams.id).search({ editView: _.get(_this, 'acceptProfile.type') === 'OTHER' ? 'artwork' : 'image' });
                }
            }
        },
        {
            label: 'Close',
            enabled: function () { return !_.get(_this.editorForm, '$dirty'); },
            onClick: function () { return $location.url("/system/templates/media/acceptProfiles/edit/" + $routeParams.id).search({ editView: _.get(_this, 'acceptProfile.type') === 'OTHER' ? 'artwork' : 'image' }); }
        }
    ];
    this.$onInit = function () {
        _this.editData = {
            trackNumber: undefined
        };
        _this.existingImageValidatorTrackNumbers = [];
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        getExistingValidators();
        getData();
        if (!_.size(BreadcrumbService.getBreadcrumbs())) {
            BreadcrumbService.addBreadcrumb({
                name: 'Edit Media Accept Profile Template',
                location: "/system/templates/search",
                params: { tab: 'Media', subTab: 'MediaAcceptProfiles' }
            });
            BreadcrumbService.addBreadcrumb({
                name: _.get(_this, 'acceptProfile.name'),
                location: "/system/templates/media/acceptProfiles/edit/" + _.get(_this, 'acceptProfile.id'),
                params: { editView: _.get(_this, 'acceptProfile.type') === 'OTHER' ? 'artwork' : 'image' }
            });
        }
    };
    this.$postLink = function () {
        $timeout(function () {
            MediaAcceptProfileService.editorForm = _this.editorForm;
        });
    };
    this.$onDestroy = function () {
        MediaAcceptProfileService.editorForm = null;
    };
}
angular.module('prism-ui.mediaAcceptProfiles').component('mediaAcceptProfilesImageValidatorEditView', {
    templateUrl: 'system/templates/mediaAcceptProfiles/components/validators/image/editor/media-accept-profiles-image-validator-edit-view-template.html',
    controller: MediaAcceptProfilesImageValidatorEditViewController,
    bindings: {
        acceptProfile: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function MediaAcceptProfilesImageValidatorsSearchViewController(MediaAcceptProfileService, uiGridConstants, $location, NavbarUtilService, ModalService, $routeParams, BreadcrumbService) {
    var _this = this;
    var getData = function () {
        MediaAcceptProfileService.getValidators($routeParams.id, _this.showHidden, { validatorType: 'IMAGE' }, _this.showHidden).then(function (validators) {
            _this.gridOptions.data = validators;
            _this.gridApi.selection.clearSelectedRows();
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var addMapBreadCrumb = function () {
        BreadcrumbService.addBreadcrumb({
            name: _this.mediaAcceptProfile.name,
            location: "/system/templates/media/acceptProfiles/edit/" + _this.mediaAcceptProfile.id,
            params: { editView: 'image' }
        });
    };
    var navigateToEditView = function (imageValidator) {
        addMapBreadCrumb();
        if (_.isNil(imageValidator)) {
            $location.url("system/templates/media/acceptProfiles/edit/" + $routeParams.id + "/imageValidators/edit/" + _.get(_.first(_this.gridApi.selection.getSelectedRows()), 'id'));
        }
        else {
            $location.url("system/templates/media/acceptProfiles/edit/" + $routeParams.id + "/imageValidators/edit/" + _.get(imageValidator, 'id'));
        }
    };
    var navigateToEditViewToCreateImageValidator = function () {
        addMapBreadCrumb();
        $location.url("system/templates/media/acceptProfiles/edit/" + $routeParams.id + "/imageValidators/edit/-1");
    };
    var toggleVisibility = function (message) {
        ModalService.showMessageModal({
            messageText: message,
            pullCancelLeft: true,
            title: 'Hide Image Validator',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, function () {
            _this.loadingIndicator.show = true;
            var imageValidatorId = _.get(_.first(_this.gridApi.selection.getSelectedRows()), 'id');
            MediaAcceptProfileService.toggleValidatorVisibility(imageValidatorId).then(function () {
                getData();
            }).finally(function () {
                _this.setFormPristine();
                _this.loadingIndicator.show = false;
            });
        });
    };
    var columnDefinitions = [
        {
            field: 'trackNumber',
            type: 'number',
            width: 150,
            displayName: 'Track Number',
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'format',
            displayName: 'Format',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'bitDepth',
            displayName: 'Bit Depth',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        data: [],
        multiSelect: false,
        columnDefs: columnDefinitions,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
    this.onRowDblClick = function (row) {
        if (!_.get(row.entity, 'hidden')) {
            navigateToEditView(row.entity);
        }
    };
    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: function () { return true; },
            onClick: navigateToEditViewToCreateImageValidator
        },
        {
            label: 'Edit',
            enabled: function () { return _this.gridApi.selection.getSelectedCount() && !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
            onClick: navigateToEditView
        },
        {
            label: 'Hide',
            enabled: function () { return _.first(_this.gridApi.selection.getSelectedRows()) && !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
            onClick: function () { return toggleVisibility('Are you sure that you want to hide this Image Validator?'); }
        },
        {
            label: 'Unhide',
            enabled: function () { return _.first(_this.gridApi.selection.getSelectedRows()) && _.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
            onClick: function () { return toggleVisibility('Are you sure that you want to unhide this Image Validator?'); }
        }
    ];
    this.toolbarCheckboxDefs = [
        {
            label: 'Show Hidden',
            onUpdate: function (newState) {
                _this.showHidden = newState;
                $location.search('showHidden', newState);
                getData();
                _this.setFormPristine();
            },
            isChecked: this.showHidden
        }
    ];
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.showHidden = $location.search().showHidden;
        _this.toolbarCheckboxDefs[0].isChecked = _this.showHidden;
        getData();
    };
}
angular.module('prism-ui.mediaAcceptProfiles').component('mediaAcceptProfilesImageValidatorsSearchView', {
    templateUrl: 'system/templates/mediaAcceptProfiles/components/validators/image/searchView/media-accept-profiles-image-validators-search-view-template.html',
    controller: MediaAcceptProfilesImageValidatorsSearchViewController,
    bindings: {
        setFormPristine: '&',
        mediaAcceptProfile: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function MediaAcceptProfilesTextValidatorEditViewController(MediaAcceptProfileService, uiGridConstants, $location, NavbarUtilService, ModalService, $routeParams, $route, $timeout) {
    var _this = this;
    this.eia608 = false;
    this.eia708 = false;
    var setEiaFromFormat = function (format) {
        _this.eia608 = false;
        _this.eia708 = false;
        if (_.includes(format, 'EIA-608')) {
            _this.eia608 = true;
        }
        if (_.includes(format, 'EIA-708')) {
            _this.eia708 = true;
        }
    };
    var getFormatStringFromEia = function (eia608, eia708) {
        var format = '';
        if (eia608 && !eia708) {
            format = 'EIA-608';
        }
        else if (!eia608 && eia708) {
            format = 'EIA-708';
        }
        else if (eia608 && eia708) {
            format = 'EIA-608,EIA-708';
        }
        return format;
    };
    var setValidator = function (validators) {
        _this.validators = validators;
        if (_.some(validators, { validatorType: 'TEXT' })) {
            var validator = _.first(_.remove(validators, { validatorType: 'TEXT' }));
            _this.editData = _.cloneDeep(validator);
        }
        else {
            _this.editData = { format: '' };
        }
        MediaAcceptProfileService.originalTextValidatorEditData = _.cloneDeep(_this.editData);
    };
    var getData = function () {
        _this.loadingIndicator.show = true;
        MediaAcceptProfileService.getValidators($routeParams.id, false).then(function (validators) {
            setValidator(validators);
            setEiaFromFormat(_this.editData.format);
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveHandler = function () {
        _this.loadingIndicator.show = true;
        _this.editData.format = getFormatStringFromEia(_this.eia608, _this.eia708);
        _this.editData.validatorType = "TEXT";
        _this.editData.trackNumber = "0";
        _this.loadingIndicator.show = true;
        var validatorsToSave = _.concat([_this.editData], _this.validators);
        MediaAcceptProfileService.updateValidators($routeParams.id, validatorsToSave).then(function (validators) {
            setValidator(validators);
            setEiaFromFormat(_this.editData.format);
        }).finally(function () {
            _this.loadingIndicator.show = false;
            _this.setFormPristine();
        });
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return !_.get(_this.editorForm, '$pristine'); },
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: function () { return !_.get(_this.editorForm, '$pristine'); },
            onClick: function () {
                _this.editorForm.$setPristine();
                _this.editData = _.cloneDeep(MediaAcceptProfileService.originalTextValidatorEditData);
                setEiaFromFormat(_this.editData.format);
                _this.setFormPristine();
            }
        },
        {
            label: 'Close',
            enabled: function () { return true; },
            onClick: function () { return $location.url("/system/templates/search").search({
                tab: 'Media',
                subTab: 'MediaAcceptProfiles'
            }); }
        }
    ];
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        getData();
    };
    this.$postLink = function () {
        $timeout(function () {
            MediaAcceptProfileService.editorForm = _this.editorForm;
        });
    };
    this.$onDestroy = function () {
        MediaAcceptProfileService.editorForm = null;
    };
}
angular.module('prism-ui.mediaAcceptProfiles').component('mediaAcceptProfilesTextValidatorEditView', {
    templateUrl: 'system/templates/mediaAcceptProfiles/components/validators/text/editor/media-accept-profiles-text-validator-edit-view-template.html',
    controller: MediaAcceptProfilesTextValidatorEditViewController,
    bindings: {
        setFormPristine: '&'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function MediaAcceptProfilesVideoValidatorEditViewController(MediaAcceptProfileService, uiGridConstants, $location, NavbarUtilService, ModalService, $routeParams, $route, $timeout, BreadcrumbService) {
    var _this = this;
    this.validateInteger = function (value) {
        return _.isInteger(value) && _.toNumber(value) > -1;
    };
    var splitValidators = function (validators) {
        if ($routeParams.validatorId !== '-1') {
            _this.editData = _.first(_.remove(validators, { id: $routeParams.validatorId }));
        }
        _this.otherValidators = _.cloneDeep(validators);
    };
    this.dropframeOptions = [
        {
            name: 'Drop Frame',
            value: 'true'
        }, {
            name: 'Non-Drop Frame',
            value: 'false'
        }
    ];
    var setValidator = function (validators) {
        splitValidators(validators);
        _this.dropFrame = _.find(_this.dropframeOptions, {
            value: _this.editData.dropFrame
        });
        MediaAcceptProfileService.originalVideoValidatorEditData = _.cloneDeep(_this.editData);
        _this.originalTrackNumber = _.toNumber(_this.editData.trackNumber);
        _this.editData.trackNumber = !_.isNil(_this.editData.trackNumber) ? _.toNumber(_this.editData.trackNumber) : undefined;
    };
    var getData = function () {
        _this.loadingIndicator.show = true;
        MediaAcceptProfileService.getValidators($routeParams.id).then(function (validators) {
            setValidator(validators);
            if (_.get(_this.editData, 'hidden') || _.isNil(_this.editData)) {
                $location.url("/system/templates/media/acceptProfiles/edit/" + $routeParams.id).search({ editView: 'video' });
            }
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var getExistingValidators = function () {
        MediaAcceptProfileService.getValidators($routeParams.id, false, { validatorType: 'VIDEO' }).then(function (existingVideoValidators) {
            _this.existingVideoValidatorTrackNumbers = [];
            _.forEachRight(existingVideoValidators, function (videoValidator) {
                _this.existingVideoValidatorTrackNumbers.push(_.toNumber(_.get(videoValidator, 'trackNumber')));
            });
            _this.existingVideoValidatorTrackNumbers.sort();
            _this.existingVideoValidatorTrackNumberWarningMessage = {
                type: 'error',
                message: "This track number is already in use! Track numbers currently in use: " + _this.existingVideoValidatorTrackNumbers.join(', ')
            };
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var trackNumberExists = function (suppliedTrackNumber) {
        return _.includes(_this.existingVideoValidatorTrackNumbers, suppliedTrackNumber);
    };
    this.trackNumberNotAllowed = function () {
        return trackNumberExists(_this.editData.trackNumber)
            && _this.editData.trackNumber > -1
            && _this.editorForm.$dirty
            && _this.originalTrackNumber !== _this.editData.trackNumber;
    };
    var saveHandler = function () {
        _this.loadingIndicator.show = true;
        _this.editData.dropFrame = _.get(_this, 'dropFrame.value');
        _this.editData.validatorType = 'VIDEO';
        if (!_.size(_.get(_this, 'editData.startTime'))) {
            _.unset(_this, 'editData.startTime');
        }
        var validatorsToSave = _.concat([_this.editData], _this.otherValidators);
        MediaAcceptProfileService.updateValidators($routeParams.id, validatorsToSave).then(function (validators) {
            var updatedValidator = _.find(validators, {
                trackNumber: _.toString(_this.editData.trackNumber),
                validatorType: 'VIDEO'
            });
            $route.updateParams({ validatorId: updatedValidator.id });
            setValidator(validators);
        }).finally(function () {
            _this.loadingIndicator.show = false;
            _this.editorForm.$setPristine();
        });
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return !_.get(_this.editorForm, '$pristine')
                && !_this.trackNumberNotAllowed()
                && !_.isNil(_.get(_this.editData, 'trackNumber'))
                && _.toNumber(_.get(_this.editData, 'trackNumber')) > -1
                && _.isInteger(_.toNumber(_.get(_this.editData, 'trackNumber'))); },
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: function () { return !_.get(_this.editorForm, '$pristine'); },
            onClick: function () {
                _this.editorForm.$setPristine();
                if ($routeParams.validatorId !== '-1') {
                    _this.originalTrackNumber = _.toNumber(MediaAcceptProfileService.originalVideoValidatorEditData.trackNumber);
                    _this.editData = _.cloneDeep(MediaAcceptProfileService.originalVideoValidatorEditData);
                    _this.editData.trackNumber = _.toNumber(MediaAcceptProfileService.originalVideoValidatorEditData.trackNumber);
                    _this.dropFrame = _this.editData.dropFrame === 'true';
                    _this.editorForm.$setPristine();
                }
                else {
                    $location.url("/system/templates/media/acceptProfiles/edit/" + $routeParams.id).search({ editView: 'video' });
                }
            }
        },
        {
            label: 'Close',
            enabled: function () { return !_.get(_this.editorForm, '$dirty'); },
            onClick: function () { return $location.url("/system/templates/media/acceptProfiles/edit/" + $routeParams.id).search({ editView: 'video' }); }
        }
    ];
    this.$onInit = function () {
        _this.editData = {
            trackNumber: undefined
        };
        _this.dropFrame = null;
        _this.existingVideoValidatorTrackNumbers = [];
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        getExistingValidators();
        getData();
        if (!_.size(BreadcrumbService.getBreadcrumbs())) {
            BreadcrumbService.addBreadcrumb({
                name: 'Edit Media Accept Profile Template',
                location: "/system/templates/search",
                params: { tab: 'Media', subTab: 'MediaAcceptProfiles' }
            });
            BreadcrumbService.addBreadcrumb({
                name: _.get(_this, 'acceptProfile.name'),
                location: "/system/templates/media/acceptProfiles/edit/" + _.get(_this, 'acceptProfile.id'),
                params: { editView: 'video' }
            });
        }
    };
    this.$postLink = function () {
        $timeout(function () {
            MediaAcceptProfileService.editorForm = _this.editorForm;
        });
    };
    this.$onDestroy = function () {
        MediaAcceptProfileService.editorForm = null;
    };
}
angular.module('prism-ui.mediaAcceptProfiles').component('mediaAcceptProfilesVideoValidatorEditView', {
    templateUrl: 'system/templates/mediaAcceptProfiles/components/validators/video/editor/media-accept-profiles-video-validator-edit-view-template.html',
    controller: MediaAcceptProfilesVideoValidatorEditViewController,
    bindings: {
        acceptProfile: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function MediaAcceptProfilesVideoValidatorsSearchViewController(MediaAcceptProfileService, uiGridConstants, $location, NavbarUtilService, ModalService, $routeParams, BreadcrumbService) {
    var _this = this;
    var getData = function () {
        MediaAcceptProfileService.getValidators($routeParams.id, _this.showHidden, { validatorType: 'VIDEO' }, _this.showHidden).then(function (validators) {
            _this.gridOptions.data = validators;
            _this.gridApi.selection.clearSelectedRows();
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var addMapBreadCrumb = function () {
        BreadcrumbService.addBreadcrumb({
            name: _this.mediaAcceptProfile.name,
            location: "/system/templates/media/acceptProfiles/edit/" + _this.mediaAcceptProfile.id,
            params: { editView: 'video' }
        });
    };
    var navigateToEditView = function (videoValidator) {
        addMapBreadCrumb();
        if (_.isNil(videoValidator)) {
            $location.url("system/templates/media/acceptProfiles/edit/" + $routeParams.id + "/videoValidators/edit/" + _.get(_.first(_this.gridApi.selection.getSelectedRows()), 'id'));
        }
        else {
            $location.url("system/templates/media/acceptProfiles/edit/" + $routeParams.id + "/videoValidators/edit/" + _.get(videoValidator, 'id'));
        }
    };
    var navigateToEditViewToCreateVideoValidator = function () {
        addMapBreadCrumb();
        $location.url("system/templates/media/acceptProfiles/edit/" + $routeParams.id + "/videoValidators/edit/-1");
    };
    var toggleVisibility = function (message) {
        ModalService.showMessageModal({
            messageText: message,
            pullCancelLeft: true,
            title: 'Hide Video Validator',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, function () {
            _this.loadingIndicator.show = true;
            var videoValidatorId = _.get(_.first(_this.gridApi.selection.getSelectedRows()), 'id');
            MediaAcceptProfileService.toggleValidatorVisibility(videoValidatorId).then(function () {
                getData();
            }).finally(function () {
                _this.loadingIndicator.show = false;
                _this.setFormPristine();
            });
        });
    };
    var columnDefinitions = [
        {
            field: 'trackNumber',
            type: 'number',
            width: 150,
            displayName: 'Track Number',
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'codec',
            displayName: 'Codec',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'duration',
            width: 300,
            displayName: 'Duration',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        data: [],
        multiSelect: false,
        columnDefs: columnDefinitions,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
    this.onRowDblClick = function (row) {
        if (!_.get(row.entity, 'hidden')) {
            navigateToEditView(row.entity);
        }
    };
    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: function () { return true; },
            onClick: navigateToEditViewToCreateVideoValidator
        },
        {
            label: 'Edit',
            enabled: function () { return _this.gridApi.selection.getSelectedCount() && !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
            onClick: navigateToEditView
        },
        {
            label: 'Hide',
            enabled: function () { return _.first(_this.gridApi.selection.getSelectedRows()) && !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
            onClick: function () { return toggleVisibility('Are you sure that you want to hide this Video Validator?'); }
        },
        {
            label: 'Unhide',
            enabled: function () { return _.first(_this.gridApi.selection.getSelectedRows()) && _.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
            onClick: function () { return toggleVisibility('Are you sure that you want to unhide this Video Validator?'); }
        }
    ];
    this.toolbarCheckboxDefs = [
        {
            label: 'Show Hidden',
            onUpdate: function (newState) {
                _this.showHidden = newState;
                $location.search('showHidden', newState);
                getData();
                _this.setFormPristine();
            },
            isChecked: this.showHidden
        }
    ];
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        _this.showHidden = $location.search().showHidden;
        _this.toolbarCheckboxDefs[0].isChecked = _this.showHidden;
        getData();
    };
}
angular.module('prism-ui.mediaAcceptProfiles').component('mediaAcceptProfilesVideoValidatorsSearchView', {
    templateUrl: 'system/templates/mediaAcceptProfiles/components/validators/video/searchView/media-accept-profiles-video-validators-search-view-template.html',
    controller: MediaAcceptProfilesVideoValidatorsSearchViewController,
    bindings: {
        setFormPristine: '&',
        mediaAcceptProfile: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function MediaAcceptProfilesModalController(MediaAcceptProfileService, uiGridConstants) {
    var _this = this;
    var searchText = '';
    var getData = function () {
        var criteria = {
            fetchLimit: 0,
            includeHidden: false,
            searchString: ''
        };
        _this.loadingIndicator.show = true;
        MediaAcceptProfileService.getAcceptProfiles(criteria).then(function (profiles) {
            if (_this.resolve.mediaAcceptProfileType) {
                _this.gridOptions.data = _.filter(profiles, { type: _this.resolve.mediaAcceptProfileType });
            }
            else {
                _this.gridOptions.data = profiles;
            }
            _this.loadingIndicator.show = false;
        });
    };
    //===============//
    // Search Filter //
    //===============//
    var processGridFilter = function (renderableRows) {
        renderableRows.forEach(function (row) {
            if (_.includes(_.toLower(row.entity.name), _.toLower(searchText))) {
                row.visible = true;
            }
            else {
                row.visible = false;
            }
        });
        return renderableRows;
    };
    this.executeSearch = function (newSearchText) {
        searchText = newSearchText;
        _this.gridApi.grid.refresh();
    };
    this.onSearchRefresh = function (newSearchText) {
        searchText = newSearchText;
        getData();
    };
    //======//
    // Grid //
    //======//
    var columnDefinitions = [
        {
            field: 'name',
            displayName: 'Name',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: true,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: true,
        columnDefs: columnDefinitions,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            _this.gridApi.grid.registerRowsProcessor(processGridFilter, 200);
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
    //===================//
    // Template Response //
    //===================//
    this.disableOKButton = function () {
        return _this.gridApi.selection.getSelectedRows().length === 0;
    };
    this.onOK = function () {
        _this.close({
            $value: _this.gridApi.selection.getSelectedRows()
        });
    };
    this.cancel = function () {
        _this.dismiss({ $value: 'cancel' });
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        getData();
    };
}
angular.module('prism-ui.package').component('mediaAcceptProfilesModal', {
    templateUrl: 'system/templates/packageAcceptTemplates/editView/mediaAcceptProfileMembers/modals/mediaAcceptProfiles/media-accept-profiles-modal-template.html',
    controller: MediaAcceptProfilesModalController,
    bindings: {
        close: '&',
        dismiss: '&',
        resolve: '<',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: branding-media-edit-view-asset-component.ts
 *
 * Created by kyang on 10/29/20.
 */
function BrandingMediaEditViewAssetController() {
    var _this = this;
    this.onIngestProgress = function (progress) {
        if (progress === null) {
            delete _this.ingestPercent;
        }
        else {
            _this.ingestPercent = Math.round(progress * 100);
        }
    };
}
angular
    .module('prism-ui.components.branding')
    .component('brandingMediaEditViewAsset', {
    templateUrl: 'components/branding/editView/components/media/editView/components/asset/branding-media-edit-view-asset-template.html',
    controller: BrandingMediaEditViewAssetController,
    bindings: {
        sectionName: '@',
        containerType: '@',
        assetType: '@',
        rootAsset: '<',
        asset: '<',
        availableAcceptProfiles: '<?',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: branding-media-edit-view-break-prepostroll-component.ts
 *
 * Created by kyang on 10/29/20.
 */
function BrandingMediaEditViewBreakPrePostRollController() {
    //===========================//
    // PreRoll Template Response //
    //===========================//
    var _this = this;
    this.addPreRollAudio = function () {
        _this.breakPrePostRoll.preRoll.audios.push({});
        _this.editorForm.$setDirty();
    };
    this.removePreRollAudio = function (audioIndex) {
        _this.breakPrePostRoll.preRoll.audios.splice(audioIndex, 1);
        _this.editorForm.$setDirty();
    };
    this.addPreRollText = function () {
        _this.breakPrePostRoll.preRoll.texts.push({});
        _this.editorForm.$setDirty();
    };
    this.removePreRollText = function (textIndex) {
        _this.breakPrePostRoll.preRoll.texts.splice(textIndex, 1);
        _this.editorForm.$setDirty();
    };
    //============================//
    // PostRoll Template Response //
    //============================//
    this.addPostRollAudio = function () {
        _this.breakPrePostRoll.postRoll.audios.push({});
        _this.editorForm.$setDirty();
    };
    this.removePostRollAudio = function (audioIndex) {
        _this.breakPrePostRoll.postRoll.audios.splice(audioIndex, 1);
        _this.editorForm.$setDirty();
    };
    this.addPostRollText = function () {
        _this.breakPrePostRoll.postRoll.texts.push({});
        _this.editorForm.$setDirty();
    };
    this.removePostRollText = function (textIndex) {
        _this.breakPrePostRoll.postRoll.texts.splice(textIndex, 1);
        _this.editorForm.$setDirty();
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.containerType = 'breakPrePostRolls';
    };
}
angular
    .module('prism-ui.components.branding')
    .component('brandingMediaEditViewBreakPrePostRoll', {
    templateUrl: 'components/branding/editView/components/media/editView/components/breakPrePostRoll/branding-media-edit-view-break-prepostroll-template.html',
    controller: BrandingMediaEditViewBreakPrePostRollController,
    bindings: {
        breakPrePostRoll: '<',
        availableLanguages: '<',
        availableTerritories: '<',
        availableAudioAcceptProfiles: '<',
        availableAudioRoles: '<',
        availableTextRoles: '<',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: branding-file-selector-component.ts
 *
 * Created by kyang on 10/15/20.
 */
function BrandingFileSelectorController(_, BrandingAssetService, BrandingFileSelectionService, BrandingViewService, Rx, VALID_FILE_EXTENSIONS) {
    var _this = this;
    var ASSET_PROPERTIES = ['containerType', 'assetType', 'rootAsset', 'asset'];
    var TYPES_WITH_PROFILE_FILTERS = ['video', 'audio', 'artwork'];
    var TYPES_WITH_PROXIES = ['video', 'watermark', 'artwork', 'ratingOverlay'];
    var FILTER_TYPE_KEYS = {
        'video': 'VIDEO',
        'cc': 'CC',
        'audio': 'AUDIO',
        'watermark': 'IMAGE',
        'artwork': 'OTHER',
        'ratingOverlay': 'RATING_OVERLAY',
    };
    var getCorrespondingAcceptProfile = function () {
        if (!_this.asset) {
            return undefined;
        }
        return BrandingFileSelectionService.getAssetAcceptProfile(_this.asset, _this.assetType);
    };
    //============//
    // Validation //
    //============//
    this.getFileExtensions = function () {
        var fileExtensions;
        if (_.includes(TYPES_WITH_PROFILE_FILTERS, _this.assetType)
            && _.size(getCorrespondingAcceptProfile().fileExtensions) > 0) {
            fileExtensions = getCorrespondingAcceptProfile().fileExtensions;
        }
        else {
            var filterTypeKey = FILTER_TYPE_KEYS[_this.assetType];
            fileExtensions = VALID_FILE_EXTENSIONS[filterTypeKey];
        }
        return fileExtensions;
    };
    this.validateRemoteFile = function (fileSystemItem) {
        var validation = BrandingFileSelectionService.validateRemoteFile(_this.containerType, _this.assetType, _this.rootAsset, _this.availableAcceptProfiles, _this.asset, fileSystemItem);
        return validation.promise;
    };
    var onValidRemoteFileSelected = function (virtualPath) {
        BrandingFileSelectionService.onFileSelected(_this.assetType, _this.rootAsset, _this.asset, virtualPath);
        if (_this.onFileSelected) {
            _this.onFileSelected({ virtualPath: virtualPath });
        }
    };
    //===================//
    // Local File Upload //
    //===================//
    this.getLocalFilePreValidationErrors = function (file, filter) {
        // Doesn't add any local file filters
    };
    var updateIngestProgress = function (progress) {
        if (_this.onIngestProgress) {
            _this.onIngestProgress({ progress: progress });
        }
    };
    this.validateLocalFile = function (fileItem) {
        var validation = BrandingFileSelectionService.validateLocalFile(_this.containerType, _this.assetType, _this.rootAsset, _this.availableAcceptProfiles, _this.asset, fileItem, _this.localFileUploaderConfig);
        var progressObservable = validation.progressObservable.takeUntil(_this.assetReplacedObservable);
        progressObservable.subscribeOnNext(updateIngestProgress);
        progressObservable.subscribeOnCompleted(function () {
            updateIngestProgress(null);
        });
        return validation.promise;
    };
    var onLocalFileChanged = function (fileItem, uploadedData) {
        var filePath = _.get(uploadedData, 'remotePath', fileItem.file.name);
        BrandingFileSelectionService.onFileSelected(_this.assetType, _this.rootAsset, _this.asset, filePath);
        if (_this.file.status === 'PASSED' && _this.onFileSelected) {
            _this.onFileSelected({ virtualPath: uploadedData.remotePath });
        }
    };
    //===================//
    // Template Response //
    //===================//
    this.getCorrespondingAcceptProfileName = function () {
        return _.get(getCorrespondingAcceptProfile(), 'name');
    };
    this.canSelectFile = function () {
        return !_this.promptAcceptProfile || !!getCorrespondingAcceptProfile();
    };
    this.assetFileIsValid = function () {
        return _.get(_this, 'file.status') === 'PASSED';
    };
    this.assetFileIsInvalid = function () {
        return _.get(_this, 'file.status') === 'FAILED';
    };
    this.getAssetError = function () {
        if (_this.assetFileIsInvalid()) {
            return 'File did not pass validation';
        }
        else if (_this.assetFileIsValid()) {
            return _this.extraPropertiesError;
        }
        return null;
    };
    this.assetHasInfo = function () {
        return BrandingAssetService.assetWasIngested(_this.asset);
    };
    this.assetHasPreview = function () {
        return _.includes(TYPES_WITH_PROXIES, _this.assetType) && BrandingAssetService.assetHasProxy(_this.asset);
    };
    this.removeAsset = function () {
        if (_this.onRemoveClicked) {
            _this.onRemoveClicked();
        }
    };
    this.openAssetPreviewModal = function () {
        BrandingViewService.openAssetPreviewModal(_this.asset, _this.assetType);
    };
    this.openAssetInfoModal = function () {
        BrandingViewService.openAssetInfoModal(_this.asset, _this.assetType);
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    var updateValidity = function () {
        if (_this.editorForm) {
            _this.editorForm.$setValidity('extraPropertiesErrored', !_this.extraPropertiesError);
        }
    };
    var resetFileStatus = function () {
        if (_this.assetReplacedObservable) {
            _this.assetReplacedObservable.onNext();
        }
        if (_.get(_this, 'asset.id')) {
            _this.file = {
                type: 'REMOTE',
                files: { virtualPath: _this.asset.virtualPath },
                results: {
                    source: _this.asset.virtualPath,
                    errors: [],
                    warnings: [],
                },
                status: 'PASSED'
            };
        }
        else {
            _this.file = null;
        }
    };
    this.$onChanges = function (changes) {
        if (_.some(ASSET_PROPERTIES, function (property) { return changes[property]; })) {
            if (_this.localFileUploaderConfig) {
                BrandingFileSelectionService.reinitializeLocalUploaderConfig(_this.assetType, _this.localFileUploaderConfig);
            }
            resetFileStatus();
        }
        if (changes.extraPropertiesError) {
            updateValidity();
        }
    };
    this.onFileChanged = function () {
        switch (_.get(_this, 'file.type')) {
            case 'LOCAL':
                onLocalFileChanged(_this.file.files[0], _.get(_this.file, 'results.0.uploadedData'));
                break;
            case 'REMOTE':
                onValidRemoteFileSelected(_this.file.files[0].virtualPath);
                break;
        }
    };
    this.initializeLocalUploaderConfig = function (fileUploaderConfig) {
        _this.localFileUploaderConfig = fileUploaderConfig;
        BrandingFileSelectionService.reinitializeLocalUploaderConfig(_this.assetType, _this.localFileUploaderConfig);
    };
    this.$onInit = function () {
        _this.assetReplacedObservable = new Rx.Subject();
        resetFileStatus();
        updateValidity();
    };
    this.$onDestroy = function () {
        _this.assetReplacedObservable.onNext();
        _this.assetReplacedObservable.onCompleted();
        if (_.get(_this, 'editorForm.$$parentForm')) {
            _this.editorForm.$$parentForm.$removeControl(_this.editorForm);
        }
    };
}
angular
    .module('prism-ui.components.branding')
    .component('brandingFileSelector', {
    templateUrl: 'components/branding/editView/components/media/editView/components/brandingFileSelector/branding-file-selector-template.html',
    transclude: {
        // TODO: After Aspera integrated, add optional info buttons? (for package media QC button)
        // properties: This HTML is added to right-side of file info buttons
        'properties': '?brandingFileSelectorProperties'
    },
    controller: BrandingFileSelectorController,
    bindings: {
        /*
        Asset Config
        containerType: (string; required) Branding asset container's type
        assetType: (string; required) This specific asset's type
        rootAsset: (JS5Object; required) The asset that holds all the info
                   needed for the branding edit view
        asset:     (JS5Object; required) The asset to modify
        includeAcceptProfile: (boolean; required) If true, asset's
                              corresponding acceptProfile will be displayed.
        promptAcceptProfile:  (boolean; optional) If true, asset.acceptProfile
                              can be set to any of the availableAcceptProfiles.
                              Note: If includeAcceptProfile == false,
                              this variable won't do anything.
        availableAcceptProfiles: (JS5Object[]; optional) Array of values
                                 to use for asset's acceptProfile prompt.
                                 Array is also used to validate watermarks.
        onIngestProgress:        (function; optional) Is invoked periodically
                                 when a file is being uploaded.
                                 Reports progress as percent between 0 & 1.
                                 When ingest is stopped, function is called with null.
        onFileSelected:          (function; optional) Is invoked when
                                 a file is selected.
        extraPropertiesError:    (string; optional) String to display when hovering
                                 over the error triangle. Is only displayed after
                                 file passes validation.
                                 If specified, forces asset to an invalid state.
        */
        containerType: '@',
        assetType: '@',
        rootAsset: '<',
        asset: '<',
        includeAcceptProfile: '<',
        promptAcceptProfile: '<?',
        availableAcceptProfiles: '<?',
        onIngestProgress: '&?',
        onFileSelected: '&?',
        extraPropertiesError: '<?',
        /*
        File Removal
        canRemove: (boolean; optional) If true, displays an X button at the
                   top-right of the file-selector.
        onRemoveClicked: (function; optional) Is invoked when X button
                         is clicked. If used, canRemove should == true.
         */
        canRemove: '<',
        onRemoveClicked: '&?',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: branding-file-service.ts
 *
 * Created by kyang on 10/21/20.
 */
//
// This service contains all the logic used to
// upload & validate files for branding assets.
//
angular.module('prism-ui.components.branding').service('BrandingFileSelectionService', function (_, $q, AuthFactory, BrandingAssetService, BrandingViewService, EndPointService, MediaProfileResourceFactory, Rx) {
    var _this = this;
    var ContainerType;
    (function (ContainerType) {
        ContainerType["PRE_ROLL"] = "preRolls";
        ContainerType["POST_ROLL"] = "postRolls";
        ContainerType["BREAK_PRE_POST_ROLL"] = "breakPrePostRolls";
        ContainerType["ARTWORK"] = "artwork";
        ContainerType["WATERMARK"] = "watermarks";
        ContainerType["RATING_OVERLAY"] = "ratingOverlays";
    })(ContainerType || (ContainerType = {}));
    this.getAssetAcceptProfile = function (asset, assetType) {
        switch (assetType) {
            case 'watermark':
                return asset.videoAcceptProfile;
            case 'ratingOverlay':
                return asset.mediaAcceptProfile;
            default:
                return asset.acceptProfile;
        }
    };
    this.onFileSelected = function (assetType, rootAsset, asset, virtualPath) {
        asset.virtualPath = virtualPath;
        _.unset(asset, 'assetId');
        _.unset(asset, 'asset');
        _.unset(asset, 'contents');
        _.unset(asset, 'proxyId');
        if (assetType === 'artwork') {
            //
            // Spaghetti: at this point, `asset` is
            // just the MAP entry in the artwork
            // container.
            //
            if (rootAsset.seasonId) {
                asset.seasonId = rootAsset.seasonId;
            }
            else if (rootAsset.volumeId) {
                asset.volumeId = rootAsset.volumeId;
            }
        }
    };
    //==========================//
    // Remote Upload Validation //
    //==========================//
    var getVideoAsset = function (containerType, assetType, rootAsset, asset) {
        if (containerType === ContainerType.PRE_ROLL || containerType === ContainerType.POST_ROLL) {
            return rootAsset;
        }
        else if (containerType === ContainerType.BREAK_PRE_POST_ROLL) {
            var preRollAssets = void 0;
            switch (assetType) {
                case 'video':
                    return asset;
                case 'audio':
                    preRollAssets = rootAsset.preRoll.audios;
                    break;
                case 'cc':
                    preRollAssets = rootAsset.preRoll.texts;
                    break;
                default:
                    return null;
            }
            return (_.includes(preRollAssets, asset)) ? rootAsset.preRoll : rootAsset.postRoll;
        }
        return null;
    };
    var validateTextAsset = function (videoAsset, asset, virtualPath) {
        var textQueryParams = {
            ccPath: virtualPath,
            prePostRollId: videoAsset.id
        };
        return MediaProfileResourceFactory.validateClosedCaption(textQueryParams, asset).$promise
            .then(function (validationResult) {
            return validationResult.failures;
        });
    };
    var validateWatermark = function (availableAcceptProfiles, asset, virtualPath) {
        // We don't, at this time, validate watermarks.
        return $q.when([ /* Empty validation failure list */]);
    };
    var validateRatingOverlayImage = function (availableAcceptProfiles, asset, virtualPath) {
        // We don't, at this time, validate rating overlay images.
        return $q.when([ /* Empty validation failure list */]);
    };
    var validateNonTextAsset = function (containerType, acceptProfileId, asset, virtualPath) {
        return BrandingAssetService.validateNonTextAsset(containerType, acceptProfileId, asset, virtualPath);
    };
    // Errors & warnings are objects with:
    // {
    //     description: string, severity: 'WARNING' | 'ERROR',
    // From server:
    //     source: string, error: string, property: string, actualValue: string, expectedValue: string
    // }
    var parseValidationFailures = function (failures, assetPath) {
        var sortedValidation = { source: assetPath, errors: [], warnings: [] };
        angular.forEach(failures, function (failure) {
            if (failure.property && failure.actualValue && failure.expectedValue) {
                failure.description = failure.property + ': Actual value ' + failure.actualValue + ', expected value ' + failure.expectedValue;
            }
            else {
                failure.description = failure.source + ': ' + failure.description;
            }
            if (failure.severity === 'WARNING') {
                sortedValidation.warnings.push(failure);
            }
            else {
                sortedValidation.errors.push(failure);
            }
        });
        return sortedValidation;
    };
    var runRemoteValidationChecks = function (containerType, assetType, rootAsset, availableAcceptProfiles, asset, virtualPath) {
        var videoAsset = getVideoAsset(containerType, assetType, rootAsset, asset);
        var validationPromise;
        if (assetType === 'cc') {
            validationPromise = validateTextAsset(videoAsset, asset, virtualPath);
        }
        else if (assetType === 'watermark') {
            validationPromise = validateWatermark(availableAcceptProfiles, asset, virtualPath);
        }
        else if (assetType === 'ratingOverlay') {
            validationPromise = validateRatingOverlayImage(availableAcceptProfiles, asset, virtualPath);
        }
        else {
            validationPromise = validateNonTextAsset(containerType, _this.getAssetAcceptProfile(asset, assetType).id, asset, virtualPath);
        }
        return validationPromise.then(function (validationFailures) {
            if (!validationFailures.length) {
                return { source: virtualPath, errors: [], warnings: [] };
            }
            else {
                return parseValidationFailures(validationFailures, virtualPath);
            }
        });
    };
    this.validateRemoteFile = function (containerType, assetType, rootAsset, availableAcceptProfiles, asset, fileSystemItem) {
        var progressObservable = new Rx.BehaviorSubject(0.01);
        var virtualPath = fileSystemItem.parent + fileSystemItem.name;
        var validationPromise = runRemoteValidationChecks(containerType, assetType, rootAsset, availableAcceptProfiles, asset, virtualPath).then(function (validationResult) {
            progressObservable.onNext(1);
            progressObservable.onCompleted();
            return validationResult;
        }).catch(function (error) {
            progressObservable.onCompleted();
            return {
                source: virtualPath,
                errors: [{
                        description: _.toString(error),
                        severity: 'ERROR',
                    }],
                warnings: [],
            };
        });
        return {
            promise: validationPromise,
            progressObservable: progressObservable,
        };
    };
    //===================//
    // Local File Upload //
    //===================//
    this.reinitializeLocalUploaderConfig = function (assetType, uploaderConfig) {
        // TODO: Call TempFileUploadService instead. Would need to move service to another module to avoid circular dependencies. <components.data?>
        uploaderConfig.url = EndPointService.fileUploadEndPoint;
        uploaderConfig.alias = 'multipart-content';
        uploaderConfig.autoUpload = false;
        uploaderConfig.formData = {};
        uploaderConfig.headers = {
            'Authorization': AuthFactory.getAuthHeader(),
            'Accept': 'application/json, text/plain, */*'
        };
        var typeFilter = _.find(uploaderConfig.filters, { name: 'fileTypeFilter' });
        if (!typeFilter.origFn) {
            typeFilter.origFn = typeFilter.fn;
        }
        // TODO: AB#88420 Once file-select checks fileTypes, remove this override
        typeFilter.fn = function (file, options) {
            var type = file.type.slice(file.type.lastIndexOf('/') + 1).toLowerCase();
            if (assetType === 'video') {
                typeFilter.errorDescription = 'File Type not valid!';
                return type === 'quicktime';
            }
            else if (assetType === 'cc') {
                typeFilter.errorDescription = 'File Type not valid!';
                return type === '';
            }
            return typeFilter.origFn(file, options);
        };
    };
    var isImageSizeValid = function (availableAcceptProfiles, img, property) {
        var anySizeAllowed = true;
        var imgSize = img[property];
        return _.some(availableAcceptProfiles, function (acceptProfile) {
            var rangesStr = _.get(acceptProfile, property);
            if (!imgSize) {
                return false;
            }
            if (!rangesStr) {
                return true;
            }
            var ranges = rangesStr.split(',');
            return _.some(ranges, function (range) {
                var separatorIndex = range.indexOf('..');
                var min = Number.MIN_VALUE;
                var max = Number.MAX_VALUE;
                anySizeAllowed = false;
                if (separatorIndex < 0) {
                    min = parseInt(range);
                    max = min;
                }
                else if (separatorIndex === 0) {
                    max = parseInt(range.substring(separatorIndex + 2));
                }
                else if (separatorIndex < range.length - 2) {
                    min = parseInt(range.substring(0, separatorIndex));
                    max = parseInt(range.substring(separatorIndex + 2));
                }
                else {
                    min = parseInt(range.substring(0, separatorIndex));
                }
                return min <= img[property] && imgSize <= max;
            });
        }) || anySizeAllowed;
    };
    var setupLocalImageValidationChecks = function (availableAcceptProfiles, reader, deferredValidation) {
        reader.onload = function () {
            var img = new Image();
            img.onload = function () {
                var errors = [];
                var validWidths = _.chain(availableAcceptProfiles)
                    .map(function (acceptProfile) { return acceptProfile.width ? acceptProfile.width.split(',') : []; })
                    .flatten()
                    .uniq()
                    .join(',')
                    .value();
                var validHeights = _.chain(availableAcceptProfiles)
                    .map(function (acceptProfile) { return acceptProfile.height ? acceptProfile.height.split(',') : []; })
                    .flatten()
                    .uniq()
                    .join(',')
                    .value();
                if (!isImageSizeValid(availableAcceptProfiles, img, 'width')) {
                    errors.push({
                        description: "Browser check: File width not valid! (" + img.width + " did not match the expected value: " + validWidths + ")",
                        severity: 'ERROR'
                    });
                }
                if (!isImageSizeValid(availableAcceptProfiles, img, 'height')) {
                    errors.push({
                        description: "Browser check: File height not valid! (" + img.height + " did not match the expected value: " + validHeights + ")",
                        severity: 'ERROR'
                    });
                }
                deferredValidation.resolve({ errors: errors, warnings: [] });
            };
            img.onerror = function (ev) {
                deferredValidation.resolve({
                    errors: [],
                    warnings: [{
                            description: 'Browser could not check the size of the image',
                            severity: 'WARNING',
                        }],
                });
            };
            img.src = reader.result;
        };
    };
    var skipLocalValidationChecks = function (reader, deferredValidation) {
        reader.onload = function () {
            deferredValidation.resolve({ errors: [], warnings: [] });
        };
    };
    var runLocalValidationChecks = function (assetType, availableAcceptProfiles, asset, fileItem) {
        var reader = new FileReader();
        var progressObservable = new Rx.BehaviorSubject(0);
        var deferredValidation = $q.defer();
        switch (assetType) {
            case 'watermark':
                setupLocalImageValidationChecks(availableAcceptProfiles, reader, deferredValidation);
                break;
            case 'artwork':
                setupLocalImageValidationChecks([
                    _this.getAssetAcceptProfile(asset, assetType)
                ], reader, deferredValidation);
                break;
            case 'ratingOverlay':
            case 'audio':
            case 'video':
            default:
                skipLocalValidationChecks(reader, deferredValidation);
                break;
        }
        reader.onprogress = function (event) {
            progressObservable.onNext(event.loaded / event.total);
        };
        reader.readAsDataURL(fileItem._file);
        return {
            progressObservable: progressObservable,
            promise: deferredValidation.promise.then(function (validationMessages) {
                if (!validationMessages.errors.length) {
                    progressObservable.onNext(1);
                }
                progressObservable.onCompleted();
                return {
                    source: fileItem.file.name,
                    uploadedData: reader.result,
                    errors: validationMessages.errors,
                    warnings: validationMessages.warnings,
                };
            })
        };
    };
    var uploadAndRunRemoteValidationChecks = function (containerType, assetType, rootAsset, availableAcceptProfiles, asset, uploaderConfig) {
        var progressObservable = new Rx.BehaviorSubject(0);
        var deferredResult = $q.defer();
        uploaderConfig.onProgressItem = function (fileItem, progress) {
            progressObservable.onNext(progress / 100 / 2);
        };
        uploaderConfig.onSuccessItem = function (fileItem, response) {
            progressObservable.onNext(0.5);
            deferredResult.resolve(runRemoteValidationChecks(containerType, assetType, rootAsset, availableAcceptProfiles, asset, response.path).then(function (validationResult) {
                progressObservable.onNext(1);
                progressObservable.onCompleted();
                validationResult.uploadedData = response.path;
                return validationResult;
            }).catch(function (error) {
                progressObservable.onCompleted();
                return $q.reject(error);
            }));
        };
        uploaderConfig.onErrorItem = function (fileItem, response, status, headers) {
            progressObservable.onCompleted();
            deferredResult.reject("Failed to upload file. Error code: " + status);
        };
        uploaderConfig.uploadAll();
        return {
            promise: deferredResult.promise,
            progressObservable: progressObservable
        };
    };
    this.validateLocalFile = function (containerType, assetType, rootAsset, availableAcceptProfiles, asset, fileItem, uploaderConfig) {
        var localValidation = runLocalValidationChecks(assetType, availableAcceptProfiles, asset, fileItem);
        var uploadValidation = uploadAndRunRemoteValidationChecks(containerType, assetType, rootAsset, availableAcceptProfiles, asset, uploaderConfig);
        var stopProgressObservable = new Rx.Subject();
        var progressObservable = localValidation.progressObservable
            .takeUntil(stopProgressObservable)
            .combineLatest(uploadValidation.progressObservable, function (localProgress, remoteProgress) {
            return (localProgress + remoteProgress) / 2;
        });
        var validationPromise = $q.all({
            local: localValidation.promise,
            remote: uploadValidation.promise,
        }).then(function (results) {
            stopProgressObservable.onCompleted();
            return {
                source: results.local.source,
                uploadedData: {
                    loadedData: results.local.uploadedData,
                    remotePath: results.remote.uploadedData,
                },
                errors: results.local.errors.concat(results.remote.errors),
                warnings: results.local.warnings.concat(results.remote.warnings),
            };
        }).catch(function (error) {
            stopProgressObservable.onCompleted();
            return {
                source: fileItem.file.name,
                uploadedData: {},
                errors: [{
                        description: _.toString(error),
                        severity: 'ERROR',
                    }],
                warnings: [],
            };
        });
        return {
            promise: validationPromise,
            progressObservable: progressObservable,
        };
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: branding-media-edit-view-asset-list-component.ts
 *
 * Created by kyang on 10/29/20.
 */
function BrandingMediaEditViewAssetListController(_) {
    //===================//
    // Template Response //
    //===================//
    var _this = this;
    this.getExtraAssetPropertiesError = function (index) {
        return _this.duplicateAssetErrors[index];
    };
    this.assetContainsAcceptProfile = function () {
        return _this.assetType !== 'cc';
    };
    var updateTotalProgress = function () {
        _this.ingestPercent = Math.round(_.chain(_this.assetList)
            .map('_progress')
            .filter(function (asset) { return !_.isNil(asset); })
            .mean()
            .value() * 100);
        if (isNaN(_this.ingestPercent)) {
            delete _this.ingestPercent;
        }
    };
    this.onIngestProgress = function (asset, progress) {
        asset._progress = progress;
        updateTotalProgress();
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    var hasDuplicateIds = function (objectArray, otherArray) {
        if (!objectArray) {
            objectArray = [];
        }
        if (!otherArray) {
            otherArray = [];
        }
        return (objectArray.length === otherArray.length
            && _.differenceBy(objectArray, otherArray, 'id').length === 0);
    };
    this.updateValidity = function () {
        var hasDuplicate = false;
        _this.duplicateAssetErrors = {};
        _.forEach(_this.assetList, function (asset, index) {
            var isDuplicate = _.some(_this.assetList, function (other) { return (asset !== other
                && (!_this.promptAcceptProfile || _.get(asset, 'acceptProfile.id') === _.get(other, 'acceptProfile.id'))
                && (!_this.availableLanguages || _.get(asset, 'language.id') === _.get(other, 'language.id'))
                && (!_this.availableRatingSystems
                    || ((_.get(asset, 'rating.ratingCode.id') === _.get(other, 'rating.ratingCode.id'))
                        && _.isEqual(_.map(_.get(asset, 'rating.ratingAdvisoryCodes'), function (rac) { return rac.id; }).sort(), _.map(_.get(other, 'rating.ratingAdvisoryCodes'), function (rac) { return rac.id; }).sort())))
                && (!_this.availableRoles || _.get(asset, 'role.id') === _.get(other, 'role.id'))
                && (!_this.availableTerritories || hasDuplicateIds(asset.territories, other.territories))); });
            if (isDuplicate) {
                _this.duplicateAssetErrors[index] = 'Assets must have different properties';
                hasDuplicate = true;
            }
        });
        if (_this.editorForm) {
            _this.editorForm.$setValidity('duplicateProperties', !hasDuplicate);
        }
    };
    this.onRatingSystemChanged = function (asset) {
        asset.rating.ratingCode = null;
        asset.rating.ratingAdvisoryCodes = [];
        _this.updateValidity();
    };
    var updatePrevState = function () {
        _this.prevState = {
            assetList: _this.assetList,
            'assetList.length': _.get(_this, 'assetList.length'),
            availableAcceptProfiles: _this.availableAcceptProfiles,
            availableLanguages: _this.availableLanguages,
            availableRatingSystems: _this.availableRatingSystems,
            availableRoles: _this.availableRoles,
            availableTerritories: _this.availableTerritories,
            selectedRatingSystems: _this.selectedRatingSystems,
        };
    };
    this.$doCheck = function () {
        if (_.some(_this.prevState, function (prevValue, property) {
            return _.get(_this, property) !== prevValue;
        })) {
            if (_this.assetList !== _this.prevState.assetList || _this.assetList.length !== _this.prevState['assetList.length']) {
                updateTotalProgress();
            }
            _this.updateValidity();
            updatePrevState();
        }
    };
    this.$onInit = function () {
        _this.updateValidity();
        updatePrevState();
    };
}
angular
    .module('prism-ui.components.branding')
    .component('brandingMediaEditViewAssetList', {
    templateUrl: 'components/branding/editView/components/media/editView/components/assetList/branding-media-edit-view-asset-list-template.html',
    controller: BrandingMediaEditViewAssetListController,
    bindings: {
        sectionName: '@',
        containerType: '@',
        assetType: '@',
        rootAsset: '<',
        assetList: '<',
        availableAcceptProfiles: '<?',
        availableLanguages: '<',
        availableRoles: '<',
        availableRatingSystems: '<',
        availableTerritories: '<',
        selectedRatingSystems: '<',
        promptAcceptProfile: '<',
        addAsset: '<',
        removeAsset: '<',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function MemberGridController(uiGridConstants) {
    var _this = this;
    this.validationType = { displayName: 'Not Applicable', id: 'NOT_APPLICABLE' };
    this.$onInit = function () {
        _this.members = _.get(_.get(_this, 'availableMembers'), _.get(_this, 'mediaAcceptProfileType'));
        _this.gridOptions.data = _.toArray(_.get(_this, 'mediaAcceptProfiles'));
        if (_this.mediaAcceptProfileType === 'VIDEO') {
            _this.validationType = _.find(_this.availableValidationTypes, { 'id': 'REQUIRED' });
        }
        else {
            setValidationType();
        }
    };
    /*
        This sets the drop down upon loading the data
     */
    var setValidationType = function () {
        var applicableMembers = _.filter(_.get(_this, 'members'), function (member) {
            return member.validationType !== 'NOT_APPLICABLE';
        });
        _this.validationType = _.find(_this.availableValidationTypes, { 'id': _.get(_.first(applicableMembers), 'validationType', 'NOT_APPLICABLE') });
    };
    /*
        Handles when the validation type drop down changes. Take all the selected rows and set the corresponding
         member's validation type to what's in the drop down. Set all of the members that correspond to the unselected
         rows to 'NOT_APPLICABLE'
     */
    this.onValidationTypeChanged = function () {
        _.forEach(_this.members, function (member) {
            var row = _.find(_this.gridApi.core.getVisibleRows(_this), function (row) {
                return _.isEqual(_.get(row, 'entity.id'), _.get(member, 'acceptProfile.id'));
            });
            _.set(member, 'validationType', _.get(row, 'isSelected') ? _this.validationType.id : 'NOT_APPLICABLE');
        });
    };
    /*
        Handles when one row is toggled
     */
    this.onRowSelection = function (row) {
        setMemberValidation(row);
    };
    /*
        Handles when the select all is toggled
     */
    this.onSelectAllRows = function (rows) {
        _.forEach(rows, function (row) {
            setMemberValidation(row);
        });
    };
    /*
        For a single row, take its checked state and the selected validation type in the validation type drop down and
         look up its member and set the validation type to whats in the drop down.

        If the row is being deselected, set the validation type to 'NOT_APPLICABLE'
    */
    var setMemberValidation = function (row) {
        var matchedMember = _.find(_this.members, function (member) {
            return _.isEqual(_.get(row, 'entity.id'), _.get(member, 'acceptProfile.id'));
        });
        if (_.isNil(matchedMember)) {
            _this.members.push({
                validationType: _this.validationType.id,
                acceptProfile: row.entity
            });
        }
        _.set(matchedMember, 'validationType', _.get(row, 'isSelected') ? _.get(_this, 'validationType.id') : 'NOT_APPLICABLE');
        _this.editorForm.$setDirty();
    };
    /*
        This handles setting the checkbox state for each row upon loading the data. It takes the row's entity and looks
         up the validation state in the members collection and sets the checkbox if it's found and the validation type
         is not'NOT_APPLICABLE'
     */
    this.processGridFilter = function (renderableRows) {
        renderableRows.forEach(function (row) {
            var matchedAcceptProfile = _.find(_this.members, function (member) {
                return _.isEqual(_.get(row, 'entity.id'), _.get(member, 'acceptProfile.id'))
                    && _.isEqual(_.get(member, 'validationType'), _.get(_this, 'validationType.id'));
            });
            if (!_.isNil(matchedAcceptProfile) && row && _.get(_this, 'validationType.id') !== 'NOT_APPLICABLE') {
                row.setSelected(true);
            }
            else if (row) {
                row.setSelected(false);
            }
        });
        return renderableRows;
    };
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: true,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        multiSelect: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        columnDefs: [
            {
                field: 'name',
                displayName: 'Media Profile Name',
                enableColumnMenu: false,
                enableSorting: false,
                enableColumnResizing: false,
                sort: {
                    direction: 'asc',
                    priority: 0
                },
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            }
        ],
        data: [],
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            _this.gridApi.grid.registerRowsProcessor(_this.processGridFilter, 200);
            gridApi.selection.on.rowSelectionChanged(null, _this.onRowSelection);
            gridApi.selection.on.rowSelectionChangedBatch(null, _this.onSelectAllRows);
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
}
angular.module('prism-ui.content').component('memberGrid', {
    templateUrl: 'meta/content/editor/components/view/packageAcceptTemplates/content-package-accept-templates-member-view-component/member-grid-component/member-grid-template.html',
    controller: MemberGridController,
    bindings: {
        mediaAcceptProfiles: '<',
        mediaAcceptProfileType: '<',
        availableValidationTypes: '<',
        availableMembers: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Filename: package-media-hdr-xml-asset-selector-component.ts
 *
 * Created by kyang on 3/27/2020.
 */
function PackageMediaHdrXmlAssetSelectorController(_, $q, DynamicPropertiesService, PackageMediaService, PackageFileUploadService, PackageUtilService, TempFileUploadService) {
    var _this = this;
    this.getMainVideo = function () {
        return PackageMediaService.getMainVideo();
    };
    var setHdrXml = function (virtualPath, isRemoteUploadEnabled) {
        var mainVideo = _this.getMainVideo();
        mainVideo.pendingIngest = mainVideo.pendingIngest || isRemoteUploadEnabled;
        mainVideo.hdrMetadataAssetId = (mainVideo.hdrMetadataPath) ? -1 : null;
        mainVideo.hdrMetadataPath = virtualPath;
        PackageUtilService.editorForm.$setDirty();
    };
    //================//
    // Template Logic //
    //================//
    this.remoteUploadEnabled = function () {
        return DynamicPropertiesService.getPropValueAsBoolean('mediaTabRemoteUpload.enabled', false);
    };
    this.canIngestHdrXml = function () {
        return PackageMediaService.hasMainVideo();
    };
    this.onViewAssetButtonClick = function ($event) {
        $event.stopImmediatePropagation();
        PackageMediaService.openViewAssetModal(_this.getMainVideo(), true);
    };
    this.onCurrentFileChanged = function () {
        PackageFileUploadService.unregisterLocalConfig(_this.uploaderConfig);
        if (PackageMediaService.hasMainVideo()) {
            if (_.get(_this, 'currentFile.status') === 'PASSED') {
                switch (_this.currentFile.type) {
                    case 'ASPERA':
                        setHdrXml(_this.currentFile.results[0].uploadedData, true);
                        break;
                    case 'LOCAL':
                        // Display fileName (Correct virtualPath is set when media is saved)
                        PackageFileUploadService.registerLocalConfigForUpload(_this.uploaderConfig);
                        setHdrXml("s3:fakePath/" + _this.currentFile.files[0].file.name, false);
                        break;
                    case 'REMOTE':
                        setHdrXml(_this.currentFile.files[0].virtualPath, false);
                        break;
                }
            }
            else {
                _this.getMainVideo().hdrMetadataPath = null;
            }
        }
    };
    //========================//
    // Remote File Validation //
    //========================//
    this.getFileExtensions = function () {
        return ['xml'];
    };
    this.validateRemoteFile = function (fileSystemItem) {
        // XMLs aren't validated
        var virtualPath = fileSystemItem.parent + fileSystemItem.name;
        return $q.when({
            source: virtualPath,
            errors: [],
            warnings: []
        });
    };
    //========================//
    // Aspera File Validation //
    //========================//
    this.validateAsperaFile = function (asperaFileObject) {
        // XMLs aren't validated
        var validationResult = {
            source: asperaFileObject.name,
            errors: [],
            warnings: []
        };
        return PackageFileUploadService.parseAsperaValidationResult(PackageMediaService.packageObject, asperaFileObject, validationResult);
    };
    //=======================//
    // Local File Validation //
    //=======================//
    this.getLocalFilePreValidationErrors = function (file, filter) {
        // Doesn't add any local file filters
    };
    this.validateLocalFile = function (fileItem, uploaderConfig) {
        // XMLs aren't validated
        fileItem.onVirtualPathSet = function (virtualPath) {
            var mainVideo = _this.getMainVideo();
            mainVideo.hdrMetadataPath = virtualPath;
            mainVideo.pendingIngest = true;
        };
        return {
            source: fileItem.file.name,
            errors: [],
            warnings: []
        };
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.prevMainVideo = PackageMediaService.getMainVideo();
    };
    this.initializeLocalUploaderConfig = function (uploaderConfig) {
        TempFileUploadService.initialize(uploaderConfig);
        _this.uploaderConfig = uploaderConfig;
    };
    this.$doCheck = function () {
        var mainVideo = PackageMediaService.getMainVideo();
        if (_this.uploaderConfig && _this.prevMainVideo !== mainVideo) {
            _this.currentFile = null;
            _this.prevMainVideo = mainVideo;
        }
    };
    this.$onDestroy = function () {
        PackageFileUploadService.unregisterLocalConfig(_this.uploaderConfig);
    };
}
angular.module('prism-ui.package').component('packageMediaHdrXmlAssetSelector', {
    controller: PackageMediaHdrXmlAssetSelectorController,
    templateUrl: 'package/editor/components/view/media/assetSelector/videoMain/hdrXml/package-media-hdr-xml-asset-selector-template.html',
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function ContentCategoriesPropertiesEditViewComponent(_, $routeParams, $route, $location, ContentEditService, ModalService, BreadcrumbService, $timeout, NotificationService, PermissionsService, UtilsService) {
    var _this = this;
    var NOTIFICATION_TIMEOUT_SECONDS = 5;
    this.editData = {};
    var getData = function () {
        _this.loadingIndicator.show = true;
        ContentEditService.getContentCategoryEditData().then(function (contentCategory) {
            unpackEditData(contentCategory);
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var unpackEditData = function (contentCategory) {
        var contentPathKeyword = UtilsService.getPathKeywordFromContentType(contentCategory.content.type);
        if (_.has(contentCategory, 'contentCategoryObject.category')) {
            contentCategory.languages = _.chain(_.get(contentCategory, 'languages')).partition({ isDefault: true }).flatten().value();
            _this.editData = _.cloneDeep(contentCategory);
            ContentEditService.originalContentCategoryObject = _.cloneDeep(contentCategory);
            _this.originalVideoRolesLength = _.size(_.get(_this, 'editData.contentCategoryObject.videoRoles'));
            ContentEditService.parentRoute = "/meta/" + contentPathKeyword + "/search";
            _.set(_this, 'contentBreadcrumb.location', "/meta/" + contentPathKeyword + "/edit/" + _.get(ContentEditService, 'contentObject.id') + "/categories");
            _.set(_this, 'contentBreadcrumb.name', _.get(ContentEditService, 'contentObject.name'));
            _.set(_this, 'categoryBreadcrumb.name', _.get(ContentEditService, 'contentCategoryObject.category.name'));
        }
        else {
            $location.path("/meta/" + contentPathKeyword + "/edit/" + _.get(ContentEditService, 'contentObject.id') + "/categories");
        }
    };
    var saveHandler = function () {
        ContentEditService.contentCategoryObject = _this.editData.contentCategoryObject;
        var currentSizeOfVideoRoles = _.size(_.get(_this, 'editData.contentCategoryObject.videoRoles'));
        if (currentSizeOfVideoRoles > _this.originalVideoRolesLength && currentSizeOfVideoRoles > 1) {
            var numberOfNewRolesToAssign = currentSizeOfVideoRoles - _this.originalVideoRolesLength;
            var confirmMsgText = "This will assign " + numberOfNewRolesToAssign + " video role(s) to this content category. This cannot be undone. Do you wish to continue?";
            ModalService.showMessageModal({
                messageText: confirmMsgText,
                title: 'Save Content Category',
                windowClass: 'confirm-modal-sm',
                showOK: true,
                okText: 'Yes',
                pullCancelLeft: true
            }, function () {
                updateContentCategory();
            });
        }
        else {
            if ($routeParams.contentCategoryId === '-1') {
                saveNewContentCategory();
            }
            else {
                updateContentCategory();
            }
        }
    };
    var updateContentCategory = function () {
        _this.loadingIndicator.show = true;
        ContentEditService.saveContentCategoryEditData(_this.editData).then(function () {
            NotificationService.createSuccessNotification('Content Category updated successfully', NOTIFICATION_TIMEOUT_SECONDS);
            getData();
            _this.editorForm.$setPristine();
        }).catch(function () {
            NotificationService.createFailureNotification('Could not update Content Category');
            _this.loadingIndicator.show = false;
        });
    };
    this.getCategoryName = function () {
        return _.get(_this, 'editData.contentCategoryObject.category.name');
    };
    var saveNewContentCategory = function () {
        ContentEditService.saveContentCategoryEditData(_this.editData).then(function () {
            NotificationService.createSuccessNotification('Content Category created successfully', NOTIFICATION_TIMEOUT_SECONDS);
            getData();
        }).catch(function () {
            NotificationService.createFailureNotification('Could not create new Content Category');
            _this.loadingIndicator.show = false;
        });
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () {
                if (_.get(_this, 'editData.contentCategoryObject.liveClippingEnabled')) {
                    return !_.get(_this.editorForm, '$pristine') &&
                        _.get(_this, 'editData.contentCategoryObject.liveClipCategory') &&
                        _.get(_this, 'editData.contentCategoryObject.liveClipAcceptProfile');
                }
                else {
                    return !_.get(_this.editorForm, '$pristine');
                }
            },
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: function () { return !_.get(_this.editorForm, '$pristine'); },
            onClick: function () {
                if ($routeParams.contentCategoryId !== '-1') {
                    getData();
                    _this.editorForm.$setPristine();
                }
                else {
                    $location.url($route.current.rootRoute.replace(':id', $routeParams.id));
                }
            }
        },
        {
            label: 'Close',
            enabled: function () { return !_.get(_this.editorForm, '$dirty'); },
            onClick: function () { return $location.url($route.current.rootRoute.replace(':id', $routeParams.id)); }
        }
    ];
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        if (!PermissionsService.isAdmin()) {
            $location.url('/login');
        }
        else {
            getData();
        }
        _this.isCreatingNewContentCategory = $routeParams.contentCategoryId === '-1';
    };
    this.$onDestroy = function () {
        ContentEditService.originalEditData = null;
        ContentEditService.viewData = null;
    };
    this.$postLink = function () {
        $timeout(function () {
            ContentEditService.editorForm = _this.editorForm;
            if (_this.isCreatingNewContentCategory) {
                _this.editorForm.$setDirty();
            }
            BreadcrumbService.editService = ContentEditService;
        });
    };
}
angular.module('prism-ui.content').component('contentCategoriesPropertiesEditView', {
    templateUrl: 'meta/content/editor/components/view/categories/editor/components/contentCategoriesPropertiesView/content-categories-properties-edit-view-template.html',
    controller: ContentCategoriesPropertiesEditViewComponent,
    bindings: {
        contentBreadcrumb: '<',
        categoryBreadcrumb: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function DeliveryProfilesPropertiesEditViewController(_, $routeParams, $route, $location, PartnerEditService, uiGridConstants, ModalService, NotificationService, MediaAcceptProfileService, BreadcrumbService, UtilsService, SidebarService, $timeout, $q, PackageAcceptTemplatesService, PackagePropertiesQueryService) {
    var _this = this;
    this.editData = {};
    var getData = function () {
        _this.loadingIndicator.show = true;
        var promises = {
            availablePackageAcceptTemplates: PackageAcceptTemplatesService.getPackageAcceptTemplates({ view: 'EXTENDED' }),
            availableCategoryTypes: PackagePropertiesQueryService.getCategories(),
            existingDeliveryProfilesForPartner: PartnerEditService.getDeliveryProfilesForPartner($routeParams.id)
        };
        if ($routeParams.deliveryProfileId !== '-1') {
            _.set(promises, 'deliveryProfile', PartnerEditService.getDeliveryProfile($routeParams.deliveryProfileId));
        }
        $q.all(promises).then(function (data) {
            PartnerEditService.originalDeliveryProfileData = _.cloneDeep(data.deliveryProfile);
            _this.editData = data.deliveryProfile;
            _this.availablePackageAcceptTemplates = data.availablePackageAcceptTemplates;
            _this.availableCategoryTypes = data.availableCategoryTypes;
            _this.existingDeliveryProfilesForPartner = data.existingDeliveryProfilesForPartner;
            _this.selectedPackageAcceptTemplateInUseError = {
                message: "This Package Accept Template as it is already in use for this this Partner.)",
                type: 'error'
            };
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveHandler = function () {
        _this.loadingIndicator.show = true;
        if ($routeParams.deliveryProfileId === '-1') {
            saveNewDeliveryProfile();
        }
        else {
            updateDeliveryProfile();
        }
    };
    var updateDeliveryProfile = function () {
        PartnerEditService.updateDeliveryProfile(_this.editData).then(function (deliveryProfile) {
            PartnerEditService.originalDeliveryProfileData = _.cloneDeep(deliveryProfile);
            _this.editData = deliveryProfile;
            _this.editorForm.$setPristine();
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveNewDeliveryProfile = function () {
        PartnerEditService.createDeliveryProfile($routeParams.id, _this.editData).then(function (deliveryProfile) {
            PartnerEditService.originalDeliveryProfileData = _.cloneDeep(deliveryProfile);
            _this.editData = deliveryProfile;
            $route.updateParams({ deliveryProfileId: deliveryProfile.id });
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () { return !_.get(_this.editorForm, '$pristine')
                && _.has(_this.editData, 'packageAcceptTemplate')
                && _.has(_this.editData, 'categoryType')
                && !_this.selectedPackageAcceptTemplateInUse(); },
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: function () { return !_.get(_this.editorForm, '$pristine'); },
            onClick: function () {
                _this.editData = _.cloneDeep(PartnerEditService.originalDeliveryProfileData);
                _this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: function () { return !_.get(_this.editorForm, '$dirty'); },
            onClick: function () { return $location.url("/system/partners/edit/" + $routeParams.id + "/deliveryProfiles"); }
        }
    ];
    this.$onInit = function () {
        SidebarService.editService = PartnerEditService;
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        getData();
    };
    this.selectedPackageAcceptTemplateInUse = function () {
        var selectedPATId = _.get(_this.editData, 'packageAcceptTemplate.id');
        var selectedPATChanged = selectedPATId !== _.get(PartnerEditService, 'originalDeliveryProfileData.packageAcceptTemplate.id');
        var patInUse = _.some(_this.existingDeliveryProfilesForPartner, {
            packageAcceptTemplate: {
                id: selectedPATId
            }
        });
        return selectedPATChanged && patInUse;
    };
    this.$onDestroy = function () {
        PartnerEditService.originalDeliveryProfileData = null;
        PartnerEditService.viewData = null;
    };
    this.$postLink = function () {
        $timeout(function () {
            PartnerEditService.editorForm = _this.editorForm;
            BreadcrumbService.editService = PartnerEditService;
        });
    };
}
angular.module('prism-ui.deliveryProfiles').component('deliveryProfilesPropertiesEditView', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/properties/delivery-profiles-properties-edit-view-template.html',
    controller: DeliveryProfilesPropertiesEditViewController
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function ContentCategoriesAutomaticCreationPanelComponent(_) {
    var _this = this;
    this.$onInit = function () {
        _.set(_this, 'editData.contentCategoryObject.daysOfWeekSchedule', _.get(_this, 'editData.contentCategoryObject.daysOfWeekSchedule', []));
    };
    this.$onChanges = function () {
        _.set(_this, 'editData.contentCategoryObject.daysOfWeekSchedule', _.get(_this, 'editData.contentCategoryObject.daysOfWeekSchedule', []));
    };
}
angular.module('prism-ui.content').component('contentCategoriesAutomaticCreationPanel', {
    templateUrl: 'meta/content/editor/components/view/categories/editor/components/contentCategoriesPropertiesView/automaticCreationPanel/content-categories-automatic-creation-panel-template.html',
    controller: ContentCategoriesAutomaticCreationPanelComponent,
    bindings: {
        editData: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function ContentCategoriesPropertiesPanelComponent(_, CategoriesService, PermissionsService) {
    var _this = this;
    var getData = function () {
        PermissionsService.isSystemOperator().then(function (isSystemOperator) {
            _this.canWriteLiveClipProps = isSystemOperator;
        });
        CategoriesService.getAllCategories().then(function (categories) {
            _this.shortFormCategoriesForLiveClips = _.filter(categories, function (category) {
                return _.isEqual(_.get(category, 'type.name'), 'Short Form');
            });
        });
    };
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        getData();
    };
}
angular.module('prism-ui.content').component('contentCategoriesPropertiesPanel', {
    templateUrl: 'meta/content/editor/components/view/categories/editor/components/contentCategoriesPropertiesView/categoryPropertiesPanel/content-categories-properties-panel-template.html',
    controller: ContentCategoriesPropertiesPanelComponent,
    bindings: {
        editData: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function ContentCategoriesVideoComponentRolesPanelComponent(_, $routeParams, uiGridConstants, $timeout) {
    var _this = this;
    this.$onInit = function () {
        setupData();
    };
    this.$onChanges = function () {
        setupData();
    };
    var setupData = function () {
        _.set(_this, 'gridOptions.data', _.chain(_.get(_this, 'editData.contentCategoryRoles')).partition(function (contentCategoryRole) {
            return contentCategoryRole.name === 'Main Video';
        }).flatten().value());
        if ($routeParams.contentCategoryId === '-1') {
            addMainVideoRole();
        }
    };
    var addMainVideoRole = function () {
        if (_.isNil(_.get(_this, 'editData.contentCategoryObject.videoRoles'))) {
            _.set(_this, 'editData.contentCategoryObject.videoRoles', []);
        }
        var mainVideoRole = _.find(_.get(_this, 'editData.contentCategoryRoles'), { name: 'Main Video' });
        if (!_.isNil(mainVideoRole)) {
            _.get(_this, 'editData.contentCategoryObject.videoRoles').push({ role: mainVideoRole });
        }
    };
    this.processGridFilter = function (renderableRows) {
        renderableRows.forEach(function (row) {
            if (_.find(_.get(_this, 'editData.contentCategoryObject.videoRoles'), function (videoRole) {
                return videoRole.role.name === row.entity.name;
            })) {
                row.setSelected(true);
            }
            else {
                row.setSelected(false);
            }
        });
        return renderableRows;
    };
    this.gridRowSelectionChangedHandler = function (row) {
        if (row.entity.name !== 'Main Video') {
            if (_.isNil(_.get(_this, 'editData.contentCategoryObject.videoRoles'))) {
                _.set(_this, 'editData.contentCategoryObject.videoRoles', []);
            }
            var videoRoles = _.get(_this, 'editData.contentCategoryObject.videoRoles');
            var existingVideoComponentRole = _.find(videoRoles, function (videoRole) {
                return videoRole.role.id === row.entity.id;
            });
            if (_.isNil(existingVideoComponentRole)) {
                videoRoles.push({
                    role: row.entity
                });
            }
            else if (_.has(existingVideoComponentRole, 'id')) {
                row.setSelected(true);
            }
            else {
                _.remove(videoRoles, function (videoRole) {
                    return videoRole.role.id === row.entity.id;
                });
            }
            _this.editorForm.$setDirty();
            _.set(_this, 'editData.contentCategoryObject.videoRoles', _.sortBy(videoRoles, function (videoRole) {
                return videoRole.role.name;
            }));
            _.set(_this, 'editData.contentCategoryObject.videoRoles', _.chain(_.get(_this, 'editData.contentCategoryObject.videoRoles')).partition(function (videoRole) {
                return videoRole.role.name === 'Main Video';
            }).flatten().value());
        }
        else {
            row.setSelected(true);
        }
    };
    var columnDefinitions = [
        {
            name: 'checkMarkRowHeaderCol',
            field: 'checkMark',
            width: 30,
            enableColumnMenu: false,
            enableSorting: false,
            enableColumnResizing: false,
            headerCellTemplate: '<div></div>',
            cellTemplate: 'components/visual/grid/check-mark-template.html'
        },
        {
            field: 'name',
            displayName: 'Name',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        rowHeight: 26,
        multiSelect: true,
        columnDefs: columnDefinitions,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            _this.gridApi.grid.registerRowsProcessor(_this.processGridFilter, 200);
            _this.gridApi.selection.on.rowSelectionChanged(null, _this.gridRowSelectionChangedHandler);
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
}
angular.module('prism-ui.content').component('contentCategoriesVideoComponentRolesPanel', {
    templateUrl: 'meta/content/editor/components/view/categories/editor/components/contentCategoriesPropertiesView/videoComponentRoles/content-categories-video-component-roles-panel-template.html',
    controller: ContentCategoriesVideoComponentRolesPanelComponent,
    bindings: {
        editData: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function ContentCategoriesVideoRolesPanelComponent(_, $location) {
    var _this = this;
    this.videoRole = {};
    this.$onInit = function () {
        setupTabs();
        setVideoRole(_this.activeTab);
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
    };
    this.$onChanges = function () {
        setupTabs();
        setVideoRole(_this.activeTab);
    };
    var setVideoRole = function (videoRole) {
        _.unset(_this, 'videoRole');
        _.set(_this, 'videoRole', videoRole);
        $location.search('videoRole', _.get(videoRole, 'role.id'));
    };
    this.onTabSelect = function (videoRole) {
        setVideoRole(videoRole);
    };
    var setupTabs = function () {
        _.set(_this, 'editData.contentCategoryObject.videoRoles', _.chain(_.get(_this, 'editData.contentCategoryObject.videoRoles'))
            .sortBy(function (videoRole) {
            return _.lowerCase(videoRole.role.name);
        }).partition(function (videoRole) {
            return videoRole.role.name === 'Main Video';
        }).flatten()
            .value());
        if (!_.isNil($location.search().videoRole)) {
            _this.activeTab = _this.activeTab ? _this.activeTab : _.find(_.get(_this, 'editData.contentCategoryObject.videoRoles'), function (videoRole) {
                return videoRole.role.id === $location.search().videoRole;
            });
        }
        else {
            _this.activeTab = _this.activeTab ? _this.activeTab : _.find(_.get(_this, 'editData.contentCategoryObject.videoRoles'), function (videoRole) {
                return videoRole.role.name === 'Main Video';
            });
        }
    };
}
angular.module('prism-ui.content').component('contentCategoriesVideoRolesPanel', {
    templateUrl: 'meta/content/editor/components/view/categories/editor/components/contentCategoriesPropertiesView/videoRolesPanel/content-categories-video-roles-panel-template.html',
    controller: ContentCategoriesVideoRolesPanelComponent,
    bindings: {
        editData: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function SeasonAggregationTabController($timeout, ContentEditService) {
    var _this = this;
    this.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };
    var getData = function () {
        return ContentEditService.getSeasonVolumeEditData().then(function () {
            _this.seasonVolume = ContentEditService.seasonVolumeObject;
        });
    };
    //===================//
    // Template Response //
    //===================//
    this.onExternalIdChange = function () {
        if (_.get(_this.seasonVolume, 'externalId.length') == 0)
            _this.seasonVolume.externalId = null;
    };
    this.clearExternalId = function () {
        _this.seasonVolume.externalId = null;
        _this.editorForm.$setDirty();
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.loadingIndicator.show = true;
        getData().then(function () {
            $timeout(function () {
                // if the above promises resolve too quickly,
                // a $timeout() is required to shut the
                // pacifier off
                _this.loadingIndicator.show = false;
            });
        });
    };
    this.$onDestroy = function () {
    };
    this.$postLink = function () {
        var _this = this;
        $timeout(function () {
            ContentEditService.editorForm = _this.editorForm;
        });
    };
    //=========//
    // Toolbar //
    //=========//
    var isDirty = function () {
        var isDirty = _.get(_this, 'editorForm.$dirty');
        return _this.seasonVolume && isDirty;
    };
    this.toolbarButtons = [
        // Save
        {
            label: 'Save',
            enabled: function () { return isDirty(); },
            onClick: function () {
                _this.loadingIndicator.show = true;
                ContentEditService.saveSeasonVolume().then(function () {
                    _this.seasonVolume = ContentEditService.seasonVolumeObject;
                    _this.loadingIndicator.show = false;
                    _this.editorForm.$setPristine();
                });
            },
        },
        // Revert
        {
            label: 'Revert',
            enabled: function () { return isDirty(); },
            onClick: function () {
                ContentEditService.revertSeasonVolume();
                _this.seasonVolume = ContentEditService.seasonVolumeObject;
                _this.editorForm.$setPristine();
            },
        },
        // Close
        {
            label: 'Close',
            enabled: function () { return true; },
            onClick: function () { return ContentEditService.closeSeasonVolumeEditor(); },
        },
    ];
}
angular
    .module('prism-ui.content')
    .component('seasonAggregationTab', {
    templateUrl: 'meta/content/editor/components/view/seasonvolume/editor/components/view/aggregation/aggregation-tab-template.html',
    controller: SeasonAggregationTabController,
    bindings: {}
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function DeliveryProfilesDeliveryItemsEditViewController(_, $routeParams, $route, $location, PartnerEditService, uiGridConstants, ModalService, NotificationService, MediaAcceptProfileService, BreadcrumbService) {
    var _this = this;
    this.activeTabs = {
        Video: false,
        Audio: false,
        Image: false,
        Artwork: false,
        CC: false,
        Subtitle: false,
        Metadata: false,
        Archive: false
    };
    this.enabledTabs = {
        Video: true,
        Audio: true,
        Image: true,
        Artwork: true,
        CC: true,
        Subtitle: true,
        Metadata: true,
        Archive: true
    };
    //Tab Functionality
    this.onTabSelect = function (tab) {
        _this.currentTab = tab;
        $location.search('tab', tab);
    };
    var setupBreadcrumbs = function () {
        var breadCrumbSize = _.size(BreadcrumbService.getBreadcrumbs());
        if (breadCrumbSize === 0 || breadCrumbSize === 1) {
            BreadcrumbService.addBreadcrumb({
                name: _this.resolveData.partnerName,
                location: "/system/partners/edit/" + $routeParams.id + "/deliveryProfiles"
            });
            BreadcrumbService.addBreadcrumb({
                name: 'Delivery Profiles',
                location: "/system/partners/edit/" + $routeParams.id + "/deliveryProfiles/edit/" + $routeParams.deliveryProfileId,
                params: { tab: 'deliveryItems' }
            });
        }
        else if (breadCrumbSize === 2) {
            BreadcrumbService.addBreadcrumb({
                name: 'Delivery Profiles',
                location: "/system/partners/edit/" + $routeParams.id + "/deliveryProfiles/edit/" + $routeParams.deliveryProfileId,
                params: { tab: 'deliveryItems' }
            });
        }
    };
    this.$onInit = function () {
        _this.currentTab = $location.search().tab;
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        setupBreadcrumbs();
    };
}
angular.module('prism-ui.deliveryProfiles').component('deliveryProfilesDeliveryItemsEditView', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/delivery-profiles-delivery-items-edit-view-template.html',
    controller: DeliveryProfilesDeliveryItemsEditViewController,
    bindings: {
        resolveData: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
function DeliveryProfilesDeliveryItemsSearchViewController(_, $location, $q, $routeParams, uiGridConstants, PartnerEditService, BreadcrumbService) {
    var _this = this;
    var getData = function () {
        _this.loadingIndicator.show = true;
        PartnerEditService.getDeliveryProfile($routeParams.deliveryProfileId).then(function (deliveryProfile) {
            _this.gridOptions.data = [];
            if (_this.hideEmpty) {
                _.forEach(deliveryProfile.deliveryItemCounts, function (deliveryItemCount) {
                    if (deliveryItemCount.numberOfArchiveItems !== "0"
                        || deliveryItemCount.numberOfArtworkItems !== "0"
                        || deliveryItemCount.numberOfAudioItems !== "0"
                        || deliveryItemCount.numberOfClosedCaptioningItems !== "0"
                        || deliveryItemCount.numberOfImageItems !== "0"
                        || deliveryItemCount.numberOfMetadataItems !== "0"
                        || deliveryItemCount.numberOfSubtitleItems !== "0"
                        || deliveryItemCount.numberOfVideoItems !== "0") {
                        _this.gridOptions.data.push(deliveryItemCount);
                    }
                });
            }
            else {
                _this.gridOptions.data = deliveryProfile.deliveryItemCounts;
            }
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var columnDefinitions = [
        {
            field: 'mAPName',
            displayName: 'From Video Map',
            sort: {
                direction: 'asc',
            },
            width: '800',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'numberOfVideoItems',
            displayName: '# Videos',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'numberOfAudioItems',
            displayName: '# Audios',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'numberOfArtworkItems',
            displayName: '# Artwork',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'numberOfImageItems',
            displayName: '# Images',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'numberOfClosedCaptioningItems',
            displayName: '# CCs',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'numberOfSubtitleItems',
            displayName: '# Subtitles',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'numberOfMetadataItems',
            displayName: '# Metadata',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'numberOfArchiveItems',
            displayName: '# Archives',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];
    var navigateToDeliveryProfilesEditViewFromDoubleClick = function (row) {
        $location.url("/system/partners/edit/" + $routeParams.id + "/deliveryProfiles/edit/" + $routeParams.deliveryProfileId + "/deliveryItems/edit/" + row.mAPId);
    };
    this.onRowDblClick = function (row) {
        navigateToDeliveryProfilesEditViewFromDoubleClick(row.entity);
    };
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: false,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: columnDefinitions,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        data: []
    };
    this.toolbarCheckboxDefs = [
        {
            label: 'Hide Empty',
            onUpdate: function (newValue) {
                _this.hideEmpty = newValue;
                getData();
            },
            isChecked: this.hideEmpty
        }
    ];
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        getData();
        setupBreadcrumbs();
    };
    var setupBreadcrumbs = function () {
        var breadCrumbSize = _.size(BreadcrumbService.getBreadcrumbs());
        if (breadCrumbSize === 0 || breadCrumbSize === 1) {
            BreadcrumbService.addBreadcrumb({
                name: _this.resolveData.partnerName,
                location: "/system/partners/edit/" + $routeParams.id + "/deliveryProfiles"
            });
            BreadcrumbService.addBreadcrumb({
                name: 'Delivery Profiles',
                location: "/system/partners/edit/" + $routeParams.id + "/deliveryProfiles/edit/" + $routeParams.deliveryProfileId,
                params: { tab: 'deliveryItems' }
            });
            BreadcrumbService.addBreadcrumb({
                name: _this.resolveData.mediaAcceptProfile.name,
                location: "/system/partners/edit/" + $routeParams.id + "/deliveryProfiles/edit/" + $routeParams.deliveryProfileId + "/deliveryItems/edit/" + $routeParams.mediaAcceptProfileId,
                params: { tab: 'videos' }
            });
        }
    };
}
angular.module('prism-ui.deliveryProfiles').component('deliveryProfilesDeliveryItemsSearchView', {
    controller: DeliveryProfilesDeliveryItemsSearchViewController,
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/searchView/delivery-profiles-delivery-items-search-view-template.html'
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function DeliveryProfilesDeliveryEmailsEditViewController(_, $location, $timeout, $q, $routeParams, BreadcrumbService, ModalService, NotificationService, PartnerEditService, PartnerResourceFactory) {
    var _this = this;
    var setupBreadcrumbs = function () {
        BreadcrumbService.clearBreadcrumbs();
        BreadcrumbService.addBreadcrumb({
            name: 'Partners',
            "location": "/system/partners/search",
            "params": {
                "tab": "properties"
            },
        });
        BreadcrumbService.addBreadcrumb({
            name: _this.partnerName,
            location: "/system/partners/edit/" + $routeParams.id + "/deliveryProfiles"
        });
        BreadcrumbService.addBreadcrumb({
            name: 'Delivery Profiles',
            location: "/system/partners/edit/" + $routeParams.id + "/deliveryProfiles/edit/" + $routeParams.deliveryProfileId,
            params: { tab: 'emails' }
        });
    };
    var navigateToDeliveryEmailSearchView = function () {
        $location.url("/system/partners/edit/" + $routeParams.id + "/deliveryProfiles/edit/" + $routeParams.deliveryProfileId + "?tab=emails");
    };
    var navigateToNewDeliveryEmailEditView = function (newDeliveryEmail) {
        $location.url("/system/partners/edit/" + $routeParams.id + "/deliveryProfiles/edit/" + $routeParams.deliveryProfileId + "/emails/edit/" + newDeliveryEmail.id);
    };
    //=================//
    // Data Management //
    //=================//
    var originalDeliveryEmail;
    var getOriginalDeliveryEmail = function () {
        if ($routeParams.deliveryEmailId === '-1') {
            return $q.when(null);
        }
        return PartnerEditService.getDeliveryEmail($routeParams.deliveryProfileId, $routeParams.deliveryEmailId);
    };
    var getEditData = function () {
        _this.loadingIndicator.show = true;
        return $q.all([
            PartnerResourceFactory.get({ id: $routeParams.id }).$promise
                .then(function (partner) {
                _this.partnerName = partner.name;
            }),
            PartnerEditService.getDeliveryProfile($routeParams.deliveryProfileId)
                .then(function (deliveryProfile) {
                _this.deliveryProfile = deliveryProfile;
            }),
            getOriginalDeliveryEmail()
                .then(function (deliveryEmail) {
                originalDeliveryEmail = deliveryEmail;
                if (deliveryEmail === null) {
                    _this.deliveryEmail = {
                        attachments: []
                    };
                }
                else {
                    _this.deliveryEmail = _.cloneDeep(deliveryEmail);
                }
                _this.gridOptions.data = _this.deliveryEmail.attachments;
                _this.editorForm.$setPristine();
            }),
            PartnerEditService.getEmailEndpointsForPartner($routeParams.id)
                .then(function (availableEndpoints) {
                _this.availableEndpoints = availableEndpoints;
            }),
            PartnerEditService.getDeliveryItemsForProfile({
                // From results of flexClient query, looks like it isn't filtered on profileId
                profileId: $routeParams.deliveryProfileId,
                includeHidden: false,
            }).then(function (deliveryItems) {
                _this.availableDeliveryItems = _.uniqBy(deliveryItems, 'sourceMediaAcceptProfile.id');
                _.remove(_this.availableDeliveryItems, function (deliveryItem) {
                    return !_.has(deliveryItem, 'sourceMediaAcceptProfile.id');
                });
            })
        ]).then(function () {
            _this.loadingIndicator.show = false;
        });
    };
    //======//
    // Grid //
    //======//
    var colDefs = [
        {
            cellTemplate: 'components/visual/grid/check-mark-template.html',
            enableColumnMenu: false,
            enableSorting: false,
            enableColumnResizing: false,
            field: 'checkMark',
            fieldName: 'Selection',
            headerCellTemplate: 'components/grids/default-artwork-maps-grid/cell-templates/header-check-mark-row-count-template.html',
            width: 55,
        },
        {
            cellTemplate: 'components/visual/grid/base-tooltip-template.html',
            enableColumnMenu: false,
            enableSorting: false,
            field: 'deliveryItem.sourceMediaAcceptProfile.name',
            displayName: 'Media Accept Profile',
            width: 455,
        },
        {
            cellTemplate: 'system/templates/mediaAcceptProfiles/searchView/renderers/accept-profile-tooltip-template.html',
            enableColumnMenu: false,
            enableSorting: false,
            field: 'deliveryItem.sourceMediaAcceptProfile.type',
            displayName: 'Type',
            width: 150,
        }
    ];
    this.gridOptions = {
        selectionRowHeaderColName: 'Selection',
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: false,
        enablePaginationControls: false,
        enableFullRowSelection: true,
        enableSorting: true,
        rowHeight: 26,
        multiSelect: true,
        minRowsToShow: 5,
        columnDefs: colDefs,
        data: [],
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
        }
    };
    this.areAllRowsSelected = function () {
        return _this.gridApi.selection.getSelectedCount() === _this.gridOptions.data.length;
    };
    this.onSelectAllToggled = function () {
        if (_this.areAllRowsSelected()) {
            _this.gridApi.selection.clearSelectedRows();
        }
        else {
            _this.gridApi.selection.selectAllRows();
        }
    };
    //==================//
    // HTML Interfacing //
    //==================//
    this.onAddAttachmentClicked = function () {
        var currentDeliveryItems = _.map(_this.gridOptions.data, 'deliveryItem');
        var remainingOptions = _.difference(_this.availableDeliveryItems, currentDeliveryItems, 'id');
        ModalService.showAttachmentSelectModal(remainingOptions, _this.onAttachmentsSelected);
    };
    this.onAttachmentsSelected = function (selectedDeliveryItems) {
        var _a;
        var newAttachments = _.chain(selectedDeliveryItems)
            .map(function (deliveryItem) {
            return {
                deliveryItem: deliveryItem
            };
        })
            .differenceBy(_this.gridOptions.data, 'deliveryItem.sourceMediaAcceptProfile.id')
            .value();
        (_a = _this.gridOptions.data).splice.apply(_a, [_this.gridOptions.data.length, 0].concat(newAttachments));
        _this.editorForm.$setDirty();
    };
    this.onRemoveAttachmentsClicked = function () {
        var selectedRows = _this.gridApi.selection.getSelectedRows();
        if (selectedRows.length > 0) {
            _.pullAll(_this.gridOptions.data, selectedRows);
            _this.gridApi.selection.clearSelectedRows();
        }
        _this.editorForm.$setDirty();
    };
    var canSave = function () {
        return _this.editorForm.$dirty && _this.editorForm.$valid;
    };
    var onSaveClicked = function () {
        _this.loadingIndicator.show = true;
        if (originalDeliveryEmail) {
            PartnerEditService.updateDeliveryEmail(_this.deliveryProfile.id, _this.deliveryEmail)
                .then(getEditData);
        }
        else {
            PartnerEditService.createDeliveryEmail(_this.deliveryProfile.id, _this.deliveryEmail)
                .then(function (newDeliveryEmail) {
                navigateToNewDeliveryEmailEditView(newDeliveryEmail);
            });
        }
    };
    var onRevertClicked = function () {
        if (originalDeliveryEmail) {
            _this.deliveryEmail = _.cloneDeep(originalDeliveryEmail);
            _this.gridOptions.data = _this.deliveryEmail.attachments;
            _this.editorForm.$setPristine();
        }
        else {
            navigateToDeliveryEmailSearchView();
        }
    };
    var onCloseClicked = function () {
        if (_this.editorForm.$pristine) {
            navigateToDeliveryEmailSearchView();
        }
        else {
            NotificationService.createWarningNotification('Please save or revert your changes before navigating away from this page.');
        }
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: canSave,
            onClick: onSaveClicked
        },
        {
            label: 'Revert',
            enabled: function () { return originalDeliveryEmail === null || _this.editorForm.$dirty; },
            onClick: onRevertClicked
        },
        {
            label: 'Close',
            enabled: function () { return true; },
            onClick: onCloseClicked
        }
    ];
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        getEditData().then(setupBreadcrumbs);
    };
}
angular.module('prism-ui.deliveryProfiles').component('deliveryEmailEditView', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/emails/editor/delivery-profiles-delivery-emails-edit-view-template.html',
    controller: DeliveryProfilesDeliveryEmailsEditViewController
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function DeliveryProfilesEmailsSearchViewController(_, $location, $q, $routeParams, uiGridConstants, BreadcrumbService, NotificationService, PartnerEditService, PartnerResourceFactory, PermissionsService) {
    var _this = this;
    var SYSTEM_PARTNERS_DELIVERYPROFILES_VIEW_STATE = 'SYSTEM_PARTNERS_DELIVERYPROFILES_VIEW_STATE';
    //=========//
    // Routing //
    //=========//
    var setupBreadcrumbs = function () {
        BreadcrumbService.clearBreadcrumbs();
        BreadcrumbService.addBreadcrumb({
            name: 'Partners',
            "location": "/system/partners/search",
            "params": {
                "tab": "properties"
            },
        });
        BreadcrumbService.addBreadcrumb({
            name: _this.partnerName,
            location: "/system/partners/edit/" + $routeParams.id + "/deliveryProfiles"
        });
    };
    var navigateToDeliveryEmailEditView = function (deliveryEmail) {
        if (_this.writePerms) {
            if (deliveryEmail.hidden) {
                NotificationService.createWarningNotification("\"" + deliveryEmail.emailConfig.name + "\" is hidden");
            }
            else {
                $location.url("/system/partners/edit/" + $routeParams.id + "/deliveryProfiles/edit/" + $routeParams.deliveryProfileId + "/emails/edit/" + deliveryEmail.id);
            }
        }
    };
    //======//
    // Grid //
    //======//
    var columnDefinitions = [
        {
            field: 'emailConfig.name',
            displayName: 'Name',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'emailConfig.emailTemplate.name',
            displayName: 'Email Template',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'emailConfig.recipients.length',
            displayName: '# of Recipients',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: columnDefinitions,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        data: []
    };
    this.onRowDblClick = function (row) {
        navigateToDeliveryEmailEditView(row.entity);
    };
    var getData = function () {
        var promises = [];
        _this.showHidden = $location.search().showHidden;
        _this.loadingIndicator.show = true;
        promises.push(PartnerResourceFactory.get({ id: $routeParams.id }).$promise
            .then(function (partner) {
            _this.partnerName = partner.name;
        }));
        if (_this.readPerms) {
            promises.push(PartnerEditService.getDeliveryProfile($routeParams.deliveryProfileId, _this.showHidden)
                .then(function (deliveryProfile) {
                _this.gridOptions.data = deliveryProfile.deliveryEmailConfigs;
            }));
        }
        return $q.all(promises).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    //==================//
    // HTML Interfacing //
    //==================//
    var getSelectedEmail = function () {
        return _.first(_this.gridApi.selection.getSelectedRows());
    };
    var onNewClicked = function () {
        navigateToDeliveryEmailEditView({ id: -1 });
    };
    var onEditClicked = function () {
        navigateToDeliveryEmailEditView(getSelectedEmail());
    };
    var onHideClicked = function () {
        var profile = getSelectedEmail();
        if (!profile.hidden) {
            _this.loadingIndicator.show = true;
            PartnerEditService.toggleDeliveryEmailHidden($routeParams.deliveryProfileId, profile.id).then(getData);
        }
    };
    var onUnhideClicked = function () {
        var profile = getSelectedEmail();
        if (profile.hidden) {
            _this.loadingIndicator.show = true;
            PartnerEditService.toggleDeliveryEmailHidden($routeParams.deliveryProfileId, profile.id).then(getData);
        }
    };
    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: function () { return _this.writePerms; },
            onClick: onNewClicked
        },
        {
            label: 'Edit',
            enabled: function () { return _this.writePerms && getSelectedEmail(); },
            onClick: onEditClicked
        },
        {
            label: 'Hide',
            enabled: function () { return _this.writePerms && getSelectedEmail() && !_.get(getSelectedEmail(), 'hidden'); },
            onClick: onHideClicked
        },
        {
            label: 'Unhide',
            enabled: function () { return _this.writePerms && _.get(getSelectedEmail(), 'hidden'); },
            onClick: onUnhideClicked
        }
    ];
    this.toolbarCheckboxDefs = [
        {
            label: 'Show Hidden',
            onUpdate: function (newState) {
                _this.showHidden = newState;
                $location.search('showHidden', newState);
                // Changing search should restart the component. In case it doesn't, manually call getData
                getData();
            },
            isChecked: this.showHidden
        }
    ];
    //=================//
    // Lifecycle Hooks //
    //=================//
    var getPermissions = function () {
        _this.isAdmin = PermissionsService.isAdmin();
        var permsPromises = {
            canRead: PermissionsService.canRead(SYSTEM_PARTNERS_DELIVERYPROFILES_VIEW_STATE),
            canWrite: PermissionsService.canWrite(SYSTEM_PARTNERS_DELIVERYPROFILES_VIEW_STATE),
        };
        return $q.all(permsPromises).then(function (perms) {
            _this.readPerms = _.get(perms, 'canRead') || _this.isAdmin;
            _this.writePerms = _.get(perms, 'canWrite') || _this.isAdmin;
        });
    };
    this.$onInit = function () {
        _this.showHidden = $location.search().showHidden;
        // Binding doesn't get initial state, so get it here
        _this.toolbarCheckboxDefs[0].isChecked = _this.showHidden;
        _this.loadingIndicator = {
            backdrop: true,
            show: true,
            title: 'Working',
            message: 'Please wait...'
        };
        getPermissions().then(getData).then(setupBreadcrumbs);
    };
}
angular.module('prism-ui.deliveryProfiles').component('deliveryProfilesEmailsSearchView', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/emails/searchView/delivery-profiles-emails-search-view-template.html',
    controller: DeliveryProfilesEmailsSearchViewController
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function ContentCategoriesRoleDefinitionsPanelComponent(_, $routeParams, $route, $location, ContentEditService, uiGridConstants, ModalService, UtilsService, $timeout) {
    var _this = this;
    this.videoRoleMapping = [];
    this.roleTypes = [
        {
            label: 'Any', value: 'ANY'
        },
        {
            label: 'Pop-On', value: 'POP_ON'
        },
        {
            label: 'Roll-up', value: 'ROLL_UP'
        }
    ];
    this.requiresMapping = false;
    this.columnDefinitions = [{
            field: 'name',
            displayName: 'Language',
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'meta/content/editor/components/view/categories/editor/components/contentCategoriesPropertiesView/videoRolesPanel/roleDefinitionsPanel/checkbox-cell-template.html',
        }];
    this.$onInit = function () {
        setupGrid();
    };
    this.$onChanges = function () {
        _this.videoRoleAcceptTemplate = _.get(_this, "videoRole." + _this.acceptTemplateType);
        _.set(_this, 'requiresMapping', !!_.size(_.get(_this, 'videoRoleAcceptTemplate.languageRoleMap')));
        setupGrid();
    };
    var setupGrid = function () {
        _this.columnDefinitions = [{
                field: 'name',
                displayName: 'Language',
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            }];
        _.forEach(_.get(_this, 'roles'), function (role) {
            _this.columnDefinitions.push({
                field: role.id,
                displayName: role.name,
                cellTemplate: 'components/visual/grid/checkbox-cell-template.html',
            });
        });
        _this.gridOptions.columnDefs = _this.columnDefinitions;
        _this.gridOptions.data = _.get(_this, 'editData.languages');
    };
    this.requiresMappingCheckboxToggled = function () {
        if (_this.requiresMapping) {
            if (_.isNil(_this.videoRoleAcceptTemplate)) {
                _.set(_this, "videoRole." + _this.acceptTemplateType, {
                    displayMode: 'ANY',
                    type: _.get(_this, 'roles[0].type'),
                    languageRoleMap: _.get(_this, "previousMappings", [])
                });
                _.unset(_this, 'previousMappings');
                _this.videoRoleAcceptTemplate = _.get(_this, "videoRole." + _this.acceptTemplateType);
            }
        }
        else {
            _this.previousMappings = _.cloneDeep(_.get(_this, "videoRole." + _this.acceptTemplateType + ".languageRoleMap"));
            _.unset(_this, "videoRole." + _this.acceptTemplateType);
            _this.videoRoleAcceptTemplate = _.get(_this, "videoRole." + _this.acceptTemplateType);
        }
        setupGrid();
    };
    this.shouldBeChecked = function (row, col) {
        var shouldBeChecked = false;
        var mapping = _.find(_.get(_this, 'videoRoleAcceptTemplate.languageRoleMap'), function (languageRoleMapItem) {
            return languageRoleMapItem.language.id === row.entity.id && languageRoleMapItem.role.id === col.field;
        });
        if (!_.isNil(mapping)) {
            shouldBeChecked = true;
        }
        return shouldBeChecked;
    };
    this.onRowSelection = function (row, col, event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var language = _.find(_this.editData.languages, function (language) {
            return language.id === row.entity.id;
        });
        var role = _.find(_this.roles, function (role) {
            return role.id === col.field;
        });
        setupMappings(role, language);
        setupGrid();
        _this.editorForm.$setDirty();
    };
    var setupMappings = function (role, language) {
        var languageRoleMap = _.get(_this, 'videoRoleAcceptTemplate.languageRoleMap');
        if (_.isNil(languageRoleMap)) {
            _.set(_this, 'videoRoleAcceptTemplate.languageRoleMap', []);
            _.set(_this, 'videoRoleAcceptTemplate.type', role.type);
            languageRoleMap = _.get(_this, 'videoRoleAcceptTemplate.languageRoleMap');
        }
        var mapping = _.find(languageRoleMap, function (languageRoleMapItem) {
            return languageRoleMapItem.language.id === language.id && languageRoleMapItem.role.id === role.id;
        });
        if (_.isNil(mapping)) {
            addMapping(languageRoleMap, language, role);
        }
        else {
            _.remove(languageRoleMap, function (languageRoleMapItem) {
                return languageRoleMapItem.language.id === mapping.language.id && languageRoleMapItem.role.id === mapping.role.id;
            });
        }
    };
    var addMapping = function (languageRoleMap, language, role) {
        var existingMapping = _.find(ContentEditService.originalContentCategoryObject.contentCategoryObject.videoRoles, function (videoRole) {
            return videoRole.id === _this.videoRole.id;
        });
        if (!_.isNil(existingMapping)) {
            var languageRoleMapItem = _.find(_.get(existingMapping, _this.acceptTemplateType + ".languageRoleMap"), function (languageRoleMapItem) {
                return languageRoleMapItem.language.id === language.id && languageRoleMapItem.role.id === role.id;
            });
            if (!_.isNil(languageRoleMapItem)) {
                languageRoleMap.push(languageRoleMapItem);
            }
            else {
                languageRoleMap.push({
                    role: role,
                    language: language
                });
            }
        }
        else {
            languageRoleMap.push({
                role: role,
                language: language
            });
        }
    };
    this.processGridFilter = function (renderableRows) {
        renderableRows.forEach(function (row) {
            row.visible = _.includes(_.toLower(row.entity.name), _.toLower(_this.searchText));
        });
        return renderableRows;
    };
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        rowHeight: 26,
        multiSelect: true,
        columnDefs: this.columnDefinitions,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            _this.gridApi.grid.registerRowsProcessor(_this.processGridFilter, 200);
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
}
angular.module('prism-ui.content').component('contentCategoriesRoleDefinitionsPanel', {
    templateUrl: 'meta/content/editor/components/view/categories/editor/components/contentCategoriesPropertiesView/videoRolesPanel/roleDefinitionsPanel/content-categories-role-definitions-panel-template.html',
    controller: ContentCategoriesRoleDefinitionsPanelComponent,
    bindings: {
        editData: '<',
        headingText: '<',
        videoRole: '<',
        roles: '<',
        acceptTemplateType: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
function DeliveryItemSearchViewController(_, $location, $q, $routeParams, uiGridConstants, PartnerEditService, ModalService, NotificationService, PaginationService, UtilsService, DeliveryItemsService) {
    var _this = this;
    var getData = function () {
        _this.loadingIndicator.show = true;
        PartnerEditService.getDeliveryItemsForProfile({
            fetchLimit: _this.pagingOptions.pageSize,
            fetchOffset: _this.pagingOptions.pageSize * (_this.pagingOptions.currentPage - 1),
            profileId: $routeParams.deliveryProfileId,
            includeHidden: _this.showHidden,
            acceptProfileId: $routeParams.mediaAcceptProfileId,
            type: _this.deliveryItemType === 'Artwork' ? 'Image' : _this.deliveryItemType,
            artwork: _this.deliveryItemType === 'Artwork'
        }).then(function (deliveryItems) {
            _this.gridOptions.data = deliveryItems;
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    this.toolbarCheckboxDefs = [
        {
            label: 'Show Hidden',
            onUpdate: function (newValue) {
                _this.showHidden = newValue;
                getData();
            },
            isChecked: this.showHidden,
        },
    ];
    var buildEditViewUrl = function (id) {
        return "/system/partners/edit/" + $routeParams.id + "/deliveryProfiles/edit/" + $routeParams.deliveryProfileId + "/deliveryItems/edit/" + $routeParams.mediaAcceptProfileId + "/" + _this.deliveryItemType + "/edit/" + id;
    };
    var navigateToDeliveryItemsVideosEditViewFromDoubleClick = function (row) {
        $location.url(buildEditViewUrl(row.id));
    };
    this.onRowDblClick = function (row) {
        if (!row.entity.hidden) {
            navigateToDeliveryItemsVideosEditViewFromDoubleClick(row.entity);
        }
    };
    var navigateToCreateView = function () {
        $location.url(buildEditViewUrl('-1'));
    };
    var navigateToEditViewFromEditButton = function () {
        $location.url(buildEditViewUrl(_.first(_this.gridApi.selection.getSelectedRows()).id));
    };
    var getSelectedDeliveryItem = function () {
        return _.cloneDeep(_.first(_this.gridApi.selection.getSelectedRows()));
    };
    var toggleHiddenOkHandler = function () {
        var deliveryItem = getSelectedDeliveryItem();
        _this.loadingIndicator.show = true;
        PartnerEditService.toggleDeliveryItemHidden(deliveryItem.id).then(function () {
            var successNotification = "Delivery Item successfully " + (deliveryItem.hidden ? 'unhidden' : 'hidden') + "!";
            NotificationService.createSuccessNotification(successNotification);
            getData();
        }).catch(function () {
            var failureNotification = "Could not " + (deliveryItem.hidden ? 'unhide' : 'hide') + " Delivery Item!";
            NotificationService.createFailureNotification(failureNotification);
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var toggleItemHidden = function () {
        var deliveryItem = getSelectedDeliveryItem();
        var messageText = "Are you sure you want to " + (deliveryItem.hidden ? 'unhide' : 'hide') + " this Delivery Item?";
        var title = (deliveryItem.hidden ? 'Unhide' : 'Hide') + " Delivery Item";
        ModalService.showMessageModal({
            messageText: messageText,
            pullCancelLeft: true,
            title: title,
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, toggleHiddenOkHandler);
    };
    var cloneOnOkHandler = function () {
        _this.loadingIndicator.show = true;
        PartnerEditService.cloneDeliveryItem(getSelectedDeliveryItem().id).then(function () {
            NotificationService.createSuccessNotification('Delivery item successfully cloned!');
            getData();
        }).catch(function () {
            NotificationService.createFailureNotification('Could not clone delivery item!');
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var cloneItem = function () {
        ModalService.showMessageModal({
            messageText: 'Are you sure you want to clone the selected Delivery Item?',
            pullCancelLeft: true,
            title: 'Clone Delivery Item',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, cloneOnOkHandler);
    };
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: false,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: DeliveryItemsService.getSearchViewColumnDefinitions(this.deliveryItemType),
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        data: []
    };
    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: function () { return true; },
            onClick: navigateToCreateView
        },
        {
            label: 'Edit',
            enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) &&
                !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
            onClick: navigateToEditViewFromEditButton
        },
        {
            label: 'Clone',
            enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) &&
                !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
            onClick: cloneItem
        },
        {
            label: 'Hide',
            enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) &&
                !_.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
            onClick: toggleItemHidden
        },
        {
            label: 'Unhide',
            enabled: function () { return _.size(_this.gridApi.selection.getSelectedRows()) &&
                _.get(_.first(_this.gridApi.selection.getSelectedRows()), 'hidden'); },
            onClick: toggleItemHidden
        }
    ];
    this.$onInit = function () {
        _this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        initPaging();
        getData();
    };
    this.onPaginationChanged = function () {
        getData();
    };
    this.paginationJumpToPageHandler = function () {
        _this.onPaginationChanged();
    };
    this.paginationPageSizeChanged = function () {
        _this.pagingOptions.currentPage = 1;
        _this.onPaginationChanged();
    };
    this.paginationPrevPageHandler = function () {
        --_this.pagingOptions.currentPage;
        _this.onPaginationChanged();
    };
    this.paginationNextPageHandler = function () {
        ++_this.pagingOptions.currentPage;
        _this.onPaginationChanged();
    };
    var initPaging = function () {
        _this.pagingOptions = PaginationService;
        _this.pagingOptions.currentPage = 1;
        _this.pagingOptions.pageSize = UtilsService.constants.DEFAULT_FETCH_LIMIT;
        _this.paginationDefs = {
            paginationPrevPageHandler: _this.paginationPrevPageHandler,
            paginationNextPageHandler: _this.paginationNextPageHandler,
            paginationPageSizeChanged: _this.paginationPageSizeChanged,
            paginationJumpToPageHandler: _this.paginationJumpToPageHandler,
            pagingOptions: PaginationService
        };
    };
}
angular.module('prism-ui.deliveryProfiles').component('deliveryItemSearchView', {
    controller: DeliveryItemSearchViewController,
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/searchView/delivery-item-search-view-template.html',
    bindings: {
        deliveryItemType: '<',
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function DeliveryItemEditViewController(_, $location, $q, $route, $routeParams, $timeout, BreadcrumbService, DeliveryItemsService, EnumService, MetadataService, NotificationService, PackageAcceptTemplatesService, PartnerEditService, SidebarService) {
    var _this = this;
    var getFormData = function () {
        return $q.all({
            packageAcceptTemplate: PackageAcceptTemplatesService.getPackageAcceptTemplate(_this.resolveData.deliveryProfilePackageAcceptTemplateId),
            deliveryItemEditViewFormData: DeliveryItemsService.getDeliveryItemEditViewFormData($routeParams.id)
        }).then(function (data) {
            // Delivery Item Form Data
            _this.assetContentTemplates = data.deliveryItemEditViewFormData.assetContentTemplates;
            _this.macCaptionTemplates = data.deliveryItemEditViewFormData.macCaptionTemplates;
            _this.packageAcceptTemplate = data.packageAcceptTemplate;
            _this.mediaAcceptProfiles = data.deliveryItemEditViewFormData.mediaAcceptProfiles;
            _this.languages = _.chain(data.deliveryItemEditViewFormData.languages)
                .partition({ isDefault: true })
                .flatten()
                .value();
            _this.roles = data.deliveryItemEditViewFormData.roles;
            _this.deliveryEndpointsForPartner = data.deliveryItemEditViewFormData.deliveryEndpointsForPartner;
            _this.transformTemplates = data.deliveryItemEditViewFormData.transformTemplates;
            _this.conditionalTemplates = data.deliveryItemEditViewFormData.conditionalTemplates;
            _this.mediaConversionTemplates = data.deliveryItemEditViewFormData.mediaConversionTemplates;
            getVisiblePanels();
            return data;
        }).catch(function (error) {
            NotificationService.createFailureNotification('Error getting Delivery Item Form Data');
            console.warn(error);
        });
    };
    var getVisiblePanels = function () {
        _this.visiblePanels = DeliveryItemsService.getVisibleEditViewPanels($routeParams.deliveryItemType);
    };
    var getDeliveryItem = function () {
        return PartnerEditService.getDeliveryItem($routeParams.deliveryItemId).then(function (deliveryItem) {
            // Delivery Item
            PartnerEditService.originalEditData = _.cloneDeep(deliveryItem);
            return _.cloneDeep(deliveryItem);
        }).catch(function (error) {
            NotificationService.createFailureNotification('Error getting Delivery Item');
            console.warn(error);
        });
    };
    this.onMediaConversionTemplateTypeChanged = function (type) {
        _this.mediaConversionTemplateType = type;
    };
    var prepareEditDataForSave = function () {
        _this.editData.deliveryProfileId = $routeParams.deliveryProfileId;
        if (_this.mediaConversionTemplateType !== 'Vantage') {
            delete _this.editData.vantageCompositionFlag;
            delete _this.editData.vantageCompositionProcessorName;
            delete _this.editData.fadeInSeconds;
            delete _this.editData.fadeOutSeconds;
            delete _this.editData.startTimecodeExpression;
            delete _this.editData.nielsenDisabledFlag;
            delete _this.editData.nexGuardDisabledFlag;
        }
        if (!_this.mediaConversionTemplateType) {
            console.warn('No FFmpeg, Vantage, or Passthrough Template set before save');
        }
    };
    var saveHandler = function () {
        _this.loadingIndicator.show = true;
        prepareEditDataForSave();
        if ($routeParams.deliveryItemId === '-1') {
            saveNewDeliveryItem();
        }
        else {
            updateDeliveryItem();
        }
    };
    var updateDeliveryItem = function () {
        PartnerEditService.updateDeliveryItem(_this.editData).then(function (deliveryItem) {
            PartnerEditService.originalEditData = _.cloneDeep(deliveryItem);
            _this.editData = _.cloneDeep(deliveryItem);
            _this.conversionTemplateVariableComponentsMap = MetadataService.buildCustomComponentMap(_this.editData.metadata.properties);
            _this.editorForm.$setPristine();
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    var saveNewDeliveryItem = function () {
        _this.editData.sourceVideoAcceptProfile = _this.resolveData.mediaAcceptProfile;
        PartnerEditService.createDeliveryItem(_this.editData).then(function (deliveryItem) {
            _this.editData = _.cloneDeep(deliveryItem);
            _this.conversionTemplateVariableComponentsMap = MetadataService.buildCustomComponentMap(_this.editData.metadata.properties);
            $route.updateParams({ deliveryItemId: deliveryItem.id });
        }).finally(function () {
            _this.loadingIndicator.show = false;
        });
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function () {
                var formDirty = !_.get(_this.editorForm, '$pristine');
                var allFieldsValid = _.get(_this.editorForm, '$valid');
                return formDirty && allFieldsValid;
            },
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: function () { return !_.get(_this.editorForm, '$pristine'); },
            onClick: function () {
                if ($routeParams.deliveryItemId === '-1') {
                    $location.url("/system/partners/edit/" + $routeParams.id + "/deliveryProfiles/edit/" + $routeParams.deliveryProfileId + "/deliveryItems/edit/" + $routeParams.mediaAcceptProfileId)
                        .search({ tab: $routeParams.deliveryItemType });
                }
                else {
                    _this.editData = _.cloneDeep(PartnerEditService.originalEditData);
                    _this.conversionTemplateVariableComponentsMap = MetadataService.buildCustomComponentMap(_this.editData.metadata.properties);
                    _this.editorForm.$setPristine();
                }
            }
        },
        {
            label: 'Close',
            enabled: function () { return !_.get(_this.editorForm, '$dirty'); },
            onClick: function () {
                $location.url("/system/partners/edit/" + $routeParams.id + "/deliveryProfiles/edit/" + $routeParams.deliveryProfileId + "/deliveryItems/edit/" + $routeParams.mediaAcceptProfileId)
                    .search({ tab: $routeParams.deliveryItemType });
            }
        }
    ];
    var setupBreadcrumbs = function () {
        var breadCrumbSize = _.size(BreadcrumbService.getBreadcrumbs());
        if (breadCrumbSize === 0 || breadCrumbSize === 1) {
            BreadcrumbService.addBreadcrumb({
                name: _this.resolveData.partnerName,
                location: "/system/partners/edit/" + $routeParams.id + "/deliveryProfiles"
            });
            BreadcrumbService.addBreadcrumb({
                name: 'Delivery Profiles',
                location: "/system/partners/edit/" + $routeParams.id + "/deliveryProfiles/edit/" + $routeParams.deliveryProfileId,
                params: { tab: 'deliveryItems' }
            });
            BreadcrumbService.addBreadcrumb({
                name: _this.resolveData.mediaAcceptProfile.name,
                location: "/system/partners/edit/" + $routeParams.id + "/deliveryProfiles/edit/" + $routeParams.deliveryProfileId + "/deliveryItems/edit/" + $routeParams.mediaAcceptProfileId,
                params: { tab: $routeParams.deliveryItemType }
            });
        }
        else if (breadCrumbSize === 2) {
            BreadcrumbService.addBreadcrumb({
                name: 'Delivery Profiles',
                location: "/system/partners/edit/" + $routeParams.id + "/deliveryProfiles/edit/" + $routeParams.deliveryProfileId,
                params: { tab: 'deliveryItems' }
            });
            BreadcrumbService.addBreadcrumb({
                name: _this.resolveData.mediaAcceptProfile.name,
                location: "/system/partners/edit/" + $routeParams.id + "/deliveryProfiles/edit/" + $routeParams.deliveryProfileId + "/deliveryItems/edit/" + $routeParams.mediaAcceptProfileId,
                params: { tab: $routeParams.deliveryItemType }
            });
        }
        else if (breadCrumbSize === 3) {
            BreadcrumbService.addBreadcrumb({
                name: _this.resolveData.mediaAcceptProfile.name,
                location: "/system/partners/edit/" + $routeParams.id + "/deliveryProfiles/edit/" + $routeParams.deliveryProfileId + "/deliveryItems/edit/" + $routeParams.mediaAcceptProfileId,
                params: { tab: $routeParams.deliveryItemType }
            });
        }
    };
    this.$onInit = function () {
        SidebarService.editService = DeliveryItemsService;
        _this.deliveryItemType = $routeParams.deliveryItemType;
        _this.mediaConversionTemplateType = null;
        _this.loadingIndicator = {
            backdrop: true,
            show: true,
            title: 'Working',
            message: 'Please wait...'
        };
        EnumService.queryForEnums().then(function () {
            setupBreadcrumbs();
            var pendingEditData;
            var editViewPromises = [];
            if ($routeParams.deliveryItemId === '-1') {
                pendingEditData = {
                    type: $routeParams.deliveryItemType,
                    metadata: {
                        modified: false,
                        properties: {},
                    }
                };
                switch ($routeParams.deliveryItemType) {
                    case 'Image':
                        pendingEditData.sourceType = 'PACKAGE_IMAGE';
                        pendingEditData.languages = [];
                        break;
                    case 'Artwork':
                        pendingEditData.type = 'Image';
                        pendingEditData.sourceType = 'ARTWORK_IMAGE';
                        break;
                    case 'CC':
                    case 'Subtitle':
                    case 'Audio':
                        pendingEditData.roles = [];
                        pendingEditData.languages = [];
                        break;
                    default:
                        break;
                }
                editViewPromises.push(getFormData().then(function (data) {
                    pendingEditData.metadata.properties = data.deliveryItemEditViewFormData.deliveryItemDefaultMetadata;
                    return data;
                }));
            }
            else {
                editViewPromises.push(getDeliveryItem().then(function (deliveryItem) {
                    pendingEditData = deliveryItem;
                }));
                editViewPromises.push(getFormData());
            }
            $q.all(editViewPromises).finally(function () {
                _this.editData = pendingEditData;
                _this.conversionTemplateVariableComponentsMap = MetadataService.buildCustomComponentMap(_this.editData.metadata.properties);
                _this.loadingIndicator.show = false;
            });
        });
    };
    this.$onDestroy = function () {
        PartnerEditService.originalEditData = null;
        PartnerEditService.viewData = null;
    };
    this.$postLink = function () {
        $timeout(function () {
            PartnerEditService.editorForm = _this.editorForm;
            BreadcrumbService.editService = PartnerEditService;
        });
    };
}
angular.module('prism-ui.deliveryProfiles').component('deliveryItemEditView', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/delivery-item-edit-view-template.html',
    controller: DeliveryItemEditViewController,
    bindings: {
        isAdmin: '<',
        resolveData: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function VideoDeliveryItemEditViewAdPartnerPropertiesController(_, EnumService) {
    var _this = this;
    var getData = function () {
        EnumService.queryForEnums().then(function () {
            _this.availableAdPartnerTypeValidators = EnumService.getEnumPicklist('VideoDeliveryItem_adPartnerType');
        });
    };
    this.$onInit = function () {
        getData();
    };
}
angular.module('prism-ui.deliveryProfiles').component('videoDeliveryItemEditViewAdPartnerProperties', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/adPartnerProperties/delivery-items-video-edit-view-ad-partner-properties-template.html',
    controller: VideoDeliveryItemEditViewAdPartnerPropertiesController,
    bindings: {
        editData: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function DeliveryItemEditViewArchiveController(EnumService) {
    var _this = this;
    this.$onInit = function () {
        _this.availableSourceEndpoints = _.filter(_this.deliveryEndpointsForPartner, { type: 'Network' });
        EnumService.queryForEnums().then(function () {
            _this.availableFormats = EnumService.getEnumPicklist('ArchiveDeliveryItem_archiveFormat');
        });
    };
}
angular.module('prism-ui.deliveryProfiles').component('deliveryItemEditViewArchive', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/archive/delivery-items-edit-view-archive-template.html',
    controller: DeliveryItemEditViewArchiveController,
    bindings: {
        editData: '<',
        deliveryEndpointsForPartner: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by kyang on 7/5/19.
 */
angular.module('prism-ui.deliveryProfiles').service('AudioChannelMappingService', function () {
    var _this = this;
    var AUDIO_MAPPING_TYPE = 'AUDIO';
    var VIDEO_MAPPING_TYPE = 'VIDEO';
    var DEFAULT_AUDIO_CHANNEL_GROUP_STARTING_INDEX = 1;
    var deliveryItem;
    var videoChannelMapGroup;
    var revertDataCallbacks = [];
    this.audioChannelMapGroups = [];
    //===================//
    // Data Revert Event //
    //===================//
    this.registerRevertDataCallback = function (callbackFunc) {
        if (typeof (callbackFunc) === 'function') {
            if (!_.includes(revertDataCallbacks, callbackFunc)) {
                revertDataCallbacks.push(callbackFunc);
            }
        }
    };
    this.unregisterRevertDataCallback = function (callbackFunc) {
        _.pull(revertDataCallbacks, callbackFunc);
    };
    var notifyRevertDataListeners = function () {
        _.forEach(_.clone(revertDataCallbacks), function (callback) {
            callback();
        });
    };
    //=================================//
    // Audio Channel Map Change Events //
    //=================================//
    this.onChannelUpdate = function (outputChannelOwner, outputChannel) {
        _this.getChannelGroupFromOutputChannel.cache.delete(outputChannel);
    };
    var _getChannelGroupFromOutputChannel = function (outputChannel) {
        for (var index in deliveryItem.audioChannelMapGroups) {
            var group = deliveryItem.audioChannelMapGroups[index];
            if (_.find(group.audioChannelMaps, { output: outputChannel })) {
                return group;
            }
        }
        return null;
    };
    this.getChannelGroupFromOutputChannel = _.memoize(_getChannelGroupFromOutputChannel);
    var clearCacheForChannelGroup = function (channelMappingGroup) {
        _.forEach(channelMappingGroup.audioChannelMaps, function (channelMap) {
            _this.getChannelGroupFromOutputChannel.cache.delete(channelMap.output);
        });
    };
    //==============================//
    // Audio Channel Map Management //
    //==============================//
    var onChannelGroupChanged = function () {
        var _a;
        var newAudioMapGroups = _.filter(deliveryItem.audioChannelMapGroups, { type: AUDIO_MAPPING_TYPE });
        _.forEach(deliveryItem.audioChannelMapGroups, function (channelMappingGroup, index) {
            channelMappingGroup.index = index;
        });
        (_a = _this.audioChannelMapGroups).splice.apply(_a, [0, _this.audioChannelMapGroups.length].concat(newAudioMapGroups));
    };
    var createChannelMappingGroup = function (mappingType, index) {
        var newChannelMappingGroup = {
            type: mappingType,
            audioChannelMaps: [],
            index: index
        };
        if (mappingType === AUDIO_MAPPING_TYPE) {
            index += DEFAULT_AUDIO_CHANNEL_GROUP_STARTING_INDEX;
            newChannelMappingGroup.index = index;
        }
        deliveryItem.audioChannelMapGroups.splice(index, 0, newChannelMappingGroup);
        return newChannelMappingGroup;
    };
    this.getChannelMappingGroup = function (mappingType, index) {
        if (mappingType === VIDEO_MAPPING_TYPE) {
            return videoChannelMapGroup;
        }
        return _this.audioChannelMapGroups[index];
    };
    this.addAudioSidecar = function () {
        createChannelMappingGroup(AUDIO_MAPPING_TYPE, _this.audioChannelMapGroups.length);
        onChannelGroupChanged();
    };
    this.swapAudioSidecars = function (fromAudioChannelGroupIndex, toAudioChannelGroupIndex) {
        var fromAudioChannel = _this.audioChannelMapGroups[fromAudioChannelGroupIndex];
        var toAudioChannel = _this.audioChannelMapGroups[toAudioChannelGroupIndex];
        if (_.isNil(fromAudioChannel) || _.isNil(toAudioChannel) || fromAudioChannel === toAudioChannel) {
            return;
        }
        var fromArrayIndex = _.findIndex(deliveryItem.audioChannelMapGroups, fromAudioChannel);
        var toArrayIndex = _.findIndex(deliveryItem.audioChannelMapGroups, toAudioChannel);
        if (fromArrayIndex < 0 || toArrayIndex < 0) {
            return;
        }
        deliveryItem.audioChannelMapGroups.splice(fromArrayIndex, 1, toAudioChannel);
        deliveryItem.audioChannelMapGroups.splice(toArrayIndex, 1, fromAudioChannel);
        onChannelGroupChanged();
    };
    this.removeAudioSidecar = function (audioChannelGroupIndex) {
        var arrayIndex = _.findIndex(deliveryItem.audioChannelMapGroups, {
            type: 'AUDIO',
            index: audioChannelGroupIndex + DEFAULT_AUDIO_CHANNEL_GROUP_STARTING_INDEX
        });
        if (arrayIndex < 0) {
            return;
        }
        var removedAudioChannelGroup = deliveryItem.audioChannelMapGroups.splice(arrayIndex, 1);
        clearCacheForChannelGroup(removedAudioChannelGroup[0]);
        onChannelGroupChanged();
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.setDeliveryItem = function (_deliveryItem_) {
        deliveryItem = _deliveryItem_;
        if (!_.size(deliveryItem.audioChannelMapGroups)) {
            deliveryItem.audioChannelMapGroups = [];
        }
        deliveryItem.audioChannelMapGroups = _.sortBy(deliveryItem.audioChannelMapGroups, function (channelMapGroup) {
            return parseInt(channelMapGroup.index);
        });
        videoChannelMapGroup = _.find(deliveryItem.audioChannelMapGroups, { type: VIDEO_MAPPING_TYPE });
        if (!videoChannelMapGroup) {
            videoChannelMapGroup = createChannelMappingGroup(VIDEO_MAPPING_TYPE, 0);
        }
        _this.getChannelGroupFromOutputChannel.cache.clear();
        onChannelGroupChanged();
        notifyRevertDataListeners();
    };
    this.initialize = function (deliveryItem) {
        videoChannelMapGroup = undefined;
        _this.setDeliveryItem(deliveryItem);
    };
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function VideoDeliveryItemEditViewAudioChannelMappingController(AudioChannelMappingService) {
    var _this = this;
    this.$onChanges = function (changes) {
        if (_.has(changes, 'editData')) {
            AudioChannelMappingService.setDeliveryItem(_this.editData);
            _this.videoChannelMapGroup = AudioChannelMappingService.getChannelMappingGroup('VIDEO', 0);
        }
    };
    this.$onInit = function () {
        AudioChannelMappingService.initialize(_this.editData);
        _this.videoChannelMapGroup = AudioChannelMappingService.getChannelMappingGroup('VIDEO', 0);
    };
}
angular.module('prism-ui.deliveryProfiles').component('videoDeliveryItemEditViewAudioChannelMapping', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/audioChannelMapping/delivery-items-video-edit-view-audio-channel-mapping-template.html',
    controller: VideoDeliveryItemEditViewAudioChannelMappingController,
    bindings: {
        editData: '<',
        mediaAcceptProfiles: '<',
        languages: '<',
        roles: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function VideoDeliveryItemEditViewClosedCaptioningSubtitleController(_) {
    var _this = this;
    this.buildCcSubtitleRoleName = function (role) {
        return role.type + " - " + role.name;
    };
    this.$onInit = function () {
        _this.roles = _.chain(_this.roles)
            .filter(function (role) {
            return role.type === 'CC' || role.type === 'Subtitle';
        })
            .sortBy(['type'])
            .value();
        _this.closedCaptionAssetContentTemplates = _.filter(_this.assetContentTemplates, { contentType: 'CC' });
    };
}
angular.module('prism-ui.deliveryProfiles').component('videoDeliveryItemEditViewClosedCaptioningSubtitle', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/closedCaptioningSubtitles/delivery-items-video-edit-view-closed-captioning-subtitle-template.html',
    controller: VideoDeliveryItemEditViewClosedCaptioningSubtitleController,
    bindings: {
        editData: '<',
        audioMaps: '<',
        languages: '<',
        roles: '<',
        assetContentTemplates: '<',
        macCaptionTemplates: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function DeliveryItemEditViewVantageMd5Controller() {
    // This component is intentionally empty
}
angular.module('prism-ui.deliveryProfiles').component('deliveryItemEditViewVantageMd5', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/vantageMd5/delivery-items-edit-view-vantage-md5-template.html',
    controller: DeliveryItemEditViewVantageMd5Controller,
    bindings: {
        editData: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function VideoDeliveryItemEditViewPostDeliveryProcessingController(_) {
    this.buildCcSubtitleRoleName = function (role) {
        return role.type + " - " + role.name;
    };
    this.$onInit = function () {
    };
}
angular.module('prism-ui.deliveryProfiles').component('videoDeliveryItemEditViewPostDeliveryProcessing', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/postDeliveryProcessing/delivery-items-video-edit-view-post-delivery-processing-template.html',
    controller: VideoDeliveryItemEditViewPostDeliveryProcessingController,
    bindings: {
        editData: '<',
        mediaConversionTemplates: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function VideoDeliveryItemEditViewAudioChannelMappingAudioSidecarController(_, AudioChannelMappingService) {
    var _this = this;
    this.$onInit = function () {
        _this.audioMediaAcceptProfiles = _.filter(_this.mediaAcceptProfiles, { type: 'AUDIO' });
        _this.audioRoles = _.filter(_this.roles, { type: 'Audio' });
        _this.audioChannelMapGroups = AudioChannelMappingService.audioChannelMapGroups;
    };
    this.addGroup = function () {
        AudioChannelMappingService.addAudioSidecar();
        _this.editorForm.$setDirty();
    };
    this.removeGroup = function (audioChannelMapGroupIndex) {
        AudioChannelMappingService.removeAudioSidecar(audioChannelMapGroupIndex);
        _this.editorForm.$setDirty();
    };
    this.swap = function (audioChannelMapGroupIndex, offset) {
        AudioChannelMappingService.swapAudioSidecars(audioChannelMapGroupIndex, audioChannelMapGroupIndex + offset);
        _this.editorForm.$setDirty();
    };
}
angular.module('prism-ui.deliveryProfiles').component('videoDeliveryItemEditViewAudioChannelMappingAudioSidecar', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/audioChannelMapping/deliveryItemsVideoEditViewAudioChannelMappingAudioSidecarComponent/delivery-items-video-edit-view-audio-channel-mapping-audio-sidecar-template.html',
    controller: VideoDeliveryItemEditViewAudioChannelMappingAudioSidecarController,
    bindings: {
        editData: '<',
        mediaAcceptProfiles: '<',
        roles: '<',
        languages: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function VideoDeliveryItemEditViewAudioChannelMapsListController(_, $timeout, AudioChannelMappingService) {
    var _this = this;
    var NUMBER_OF_INPUT_OUTPUT_CHANNELS = 32;
    var allAudioChannelMaps;
    var prevChannelMapGroup;
    var channelMapsInitialized = false;
    var getChannelMaps = function () {
        if (!_this.channelMapGroup.audioChannelMaps) {
            _this.channelMapGroup.audioChannelMaps = [];
        }
        return _this.channelMapGroup.audioChannelMaps;
    };
    var updateInputValidity = function (channelMaps) {
        var inputsValidity = {};
        var areInputsUnique = _.every(channelMaps, function (channelMap) {
            inputsValidity[channelMap.input] = !inputsValidity[channelMap.input];
            return inputsValidity[channelMap.input];
        });
        _this.editorForm.$setValidity('repeatedInput', areInputsUnique);
    };
    this.updateViewData = function () {
        prevChannelMapGroup = _this.channelMapGroup;
        if (!_this.channelMapGroup) {
            return;
        }
        var channelMaps = getChannelMaps();
        parseAudioChannelMaps(channelMaps);
        if (!channelMapsInitialized) {
            _this.showUnassignedAudioChannelMaps = _.every(allAudioChannelMaps, function (audioChannelMap) {
                return _.isNil(audioChannelMap.input);
            });
            $timeout(function () { return updateInputValidity(channelMaps); });
        }
        else {
            updateInputValidity(channelMaps);
        }
        _this.updateVisibleChannelMaps();
        channelMapsInitialized = true;
    };
    //======================//
    // Channel Map Handling //
    //======================//
    this.updateVisibleChannelMaps = function () {
        _this.visibleAudioChannelMaps = _.filter(allAudioChannelMaps, function (channelMap) {
            return _this.showUnassignedAudioChannelMaps || !_.isNil(channelMap.input);
        });
    };
    var removeEmptyAudioChannelMapDTO = function (channelMaps, audioChannelMap) {
        var channelMapId = _.get(audioChannelMap, 'id');
        var alternateId = _.get(audioChannelMap, 'output');
        if (channelMapId) {
            _.pullAllBy(channelMaps, [{ id: channelMapId }], 'id');
        }
        else if (alternateId) {
            _.pullAllBy(channelMaps, [{ output: alternateId }], 'output');
        }
    };
    var parseAudioChannelMaps = function (channelMaps) {
        allAudioChannelMaps = [];
        _this.visibleAudioChannelMaps = [];
        var orderedChannelMaps = _.groupBy(channelMaps, function (channelMap) { return parseInt(channelMap.output); });
        for (var outputChannel = 0; outputChannel < NUMBER_OF_INPUT_OUTPUT_CHANNELS; ++outputChannel) {
            var possibleChannelMaps = _.get(orderedChannelMaps, outputChannel, []);
            var chosenChannelMap = possibleChannelMaps.shift();
            var inputChannelBase0 = _.chain(chosenChannelMap)
                .get('input')
                .parseInt()
                .value();
            if (chosenChannelMap && !isNaN(inputChannelBase0)) {
                chosenChannelMap._userInput = inputChannelBase0 + 1;
            }
            else if (chosenChannelMap) {
                removeEmptyAudioChannelMapDTO(channelMaps, chosenChannelMap);
                chosenChannelMap = undefined;
            }
            if (!chosenChannelMap) {
                chosenChannelMap = { output: "" + outputChannel };
            }
            allAudioChannelMaps.push(chosenChannelMap);
            _.forEach(possibleChannelMaps, function (leftoverMap) { return removeEmptyAudioChannelMapDTO(channelMaps, leftoverMap); });
        }
        _.forEach(orderedChannelMaps, function (leftoverChannelMaps) {
            _.forEach(leftoverChannelMaps, function (leftoverMap) { return removeEmptyAudioChannelMapDTO(channelMaps, leftoverMap); });
        });
    };
    //=====================//
    // Input Channel Field //
    //=====================//
    this.isInputDisabled = function (audioChannelMap) {
        var outputChannelOwner = AudioChannelMappingService.getChannelGroupFromOutputChannel(audioChannelMap.output);
        return _this.isDisabled || (!_.isNil(outputChannelOwner) && outputChannelOwner !== _this.channelMapGroup);
    };
    this.onInputChange = function (audioChannelMap) {
        var channelMaps = getChannelMaps();
        var userInput = audioChannelMap._userInput;
        if (!_.isNil(userInput)) {
            if (!audioChannelMap.input) {
                channelMaps.push(audioChannelMap);
            }
            audioChannelMap.input = "" + (userInput - 1);
        }
        else {
            removeEmptyAudioChannelMapDTO(channelMaps, audioChannelMap);
            delete audioChannelMap.input;
        }
        updateInputValidity(channelMaps);
        AudioChannelMappingService.onChannelUpdate(_this.channelMapGroup, audioChannelMap.output);
    };
    //=================//
    // Lifecycle Hooks //
    //=================//
    this.$onInit = function () {
        AudioChannelMappingService.registerRevertDataCallback(_this.onDataReset);
        _this.updateViewData();
    };
    this.$onDestroy = function () {
        AudioChannelMappingService.unregisterRevertDataCallback(_this.onDataReset);
    };
    this.$doCheck = function () {
        if (prevChannelMapGroup !== _this.channelMapGroup) {
            _this.updateViewData();
        }
    };
    this.onDataReset = function () {
        channelMapsInitialized = false;
    };
}
angular.module('prism-ui.deliveryProfiles').component('videoDeliveryItemEditViewAudioChannelMapsList', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/audioChannelMapping/deliveryItemsVideoEditViewAudioChannelMapsListComponent/delivery-items-video-edit-view-audio-channel-maps-list-template.html',
    controller: VideoDeliveryItemEditViewAudioChannelMapsListController,
    bindings: {
        channelMapGroup: '=',
        isDisabled: '<ngDisabled'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function DeliveryItemEditViewDeliveryController(_, DynamicPropertiesService, LanguagesService, MetadataItemsSearchViewService, PartnerEditService, $routeParams) {
    var _this = this;
    this.availableDeliveryPriorities = [
        'CRITICAL_FIRST',
        'CRITICAL_LAST',
        'NON_CRITICAL'
    ];
    this.transformDeliveryPriorityLabel = function (value) {
        var label = 'Unknown - Error';
        switch (value) {
            case 'CRITICAL_FIRST':
                label = 'Critical - Deliver First';
                break;
            case 'CRITICAL_LAST':
                label = 'Critical - Deliver Last';
                break;
            case 'NON_CRITICAL':
                label = 'Non-Critical';
                break;
            default:
                break;
        }
        return label;
    };
    var setVisibleFormControls = function (deliveryItemType) {
        switch (deliveryItemType) {
            case 'Archive':
                _this.visibleFormControls = {
                    usernameExpression: true,
                    passwordExpression: true,
                    namingScheme: true,
                    targetPath: true,
                    deliveryEndpoint: true,
                    deliveryPriority: true,
                };
                break;
            case 'Artwork':
            case 'Image':
            case 'CC':
            case 'Subtitle':
            case 'Audio':
            case 'Video':
                _this.visibleFormControls = {
                    usernameExpression: true,
                    passwordExpression: true,
                    namingScheme: true,
                    targetPath: true,
                    componentInventoryId: true,
                    deliveryEndpoint: true,
                    deliveryPriority: true,
                };
                break;
            case 'Metadata':
                _this.visibleFormControls = {
                    usernameExpression: true,
                    passwordExpression: true,
                    namingScheme: true,
                    targetPath: true,
                    componentInventoryId: true,
                    deliveryEndpoint: true,
                    deliveryPriority: true,
                    deliveryDelay: true
                };
                break;
            default:
                _this.visibleFormControls = null;
                console.warn("Unknown delivery item type [" + deliveryItemType + "] when setting visibly form controls ");
                break;
        }
    };
    var requiredFormControls = {
        namingScheme: ['Archive', 'Artwork', 'Audio', 'Image', 'Metadata', 'Video']
    };
    this.isFieldRequired = function (formControlName) {
        return _.chain(requiredFormControls)
            .get(formControlName, [])
            .includes($routeParams.deliveryItemType)
            .value();
    };
    var getFormData = function () {
        // partner delivery endpoint collection
        PartnerEditService.getDeliveryEndpointsForPartner($routeParams.id, true)
            .then(function (deliveryEndpoints) {
            _this.availableDeliveryEndpoints = deliveryEndpoints;
        });
        DynamicPropertiesService.queryForProperties().then(function () {
            LanguagesService.getAllLanguages().then(function (languages) {
                _this.availableLanguages = _
                    .chain(languages)
                    .orderBy('name')
                    .partition({ name: 'English' })
                    .flatten()
                    .value();
            });
            // Netflix dropdown collections
            _this.availableNetflixChannelMappings = _
                .sortBy(DynamicPropertiesService.getPropValueAsList('netflixPartner.channelMappings'));
            MetadataItemsSearchViewService.getPartnerMetadataProperties($routeParams.id, false)
                .then(function (partnerMetadataProperties) {
                _this.availablePartnerMetadataProperties = _.orderBy(partnerMetadataProperties, 'displayName');
            });
        });
    };
    var getFullDeliveryEndpoint = function () {
        //
        // The DeliveryItemDTO includes the deliveryEndpoint
        // property; however it is the minimal form of the
        // DeliveryEndpointDTO. The DTO does not include
        // some flags that we previously needed here.
        //
        // We can get the extended form DTO from the delivery
        // endpoint collection.
        //
        // TODO: Evaluate if edit view still needs extended form DTO
        var deliveryEndpointId = _.get(_this, 'editData.deliveryEndpoint.id');
        var deliveryEndpoint = _.find(_this.availableDeliveryEndpoints, { id: deliveryEndpointId });
        return deliveryEndpoint;
    };
    this.showNetflixFields = function () {
        var deliveryEndpoint = getFullDeliveryEndpoint();
        var isNetflix = _.get(deliveryEndpoint, 'type') === 'Netflix';
        return isNetflix;
    };
    this.$onInit = function () {
        _this.availableLanguages = [];
        _this.availableNetflixChannelMappings = [];
        _this.availablePartnerMetadataProperties = [];
        setVisibleFormControls($routeParams.deliveryItemType);
        getFormData();
    };
}
angular.module('prism-ui.deliveryProfiles').component('deliveryItemEditViewDelivery', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/common/delivery/delivery-items-edit-view-delivery-template.html',
    controller: DeliveryItemEditViewDeliveryController,
    bindings: {
        editData: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function DeliveryItemEditViewGeneralController(_, $routeParams) {
    var _this = this;
    var setVisibleFormControls = function (type) {
        switch (type) {
            case 'Video':
                _this.visibleFormControls = {
                    type: true,
                    name: true,
                    deliveryConditionTemplate: true,
                    ccRequiredForDelivery: true
                };
                break;
            case 'Audio':
            case 'Image':
            case 'Artwork':
            case 'CC':
            case 'Subtitle':
                _this.visibleFormControls = {
                    type: true,
                    name: true,
                    deliveryConditionTemplate: true,
                    requiredForDelivery: true
                };
                break;
            case 'Metadata':
                _this.visibleFormControls = {
                    type: true,
                    name: true,
                    deliveryConditionTemplate: true,
                    requiredForDelivery: true,
                    includeMd5Values: true,
                    byteOrderMark: true,
                    embargoManifestFlag: true
                };
                break;
            case 'Archive':
                _this.visibleFormControls = {
                    type: true,
                    name: true
                };
                break;
            default:
                _this.visibleFormControls = null;
                console.warn("Unknown delivery item type [" + _this.editData.type + "] when setting visibly form controls ");
                break;
        }
    };
    this.handleDeliveryConditionTemplateChange = function () {
        if (_this.deliveryConditions != null) {
            _this.editData.deliveryConditions = [_this.deliveryConditions];
        }
        else {
            _this.editData.deliveryConditions = [];
        }
    };
    var setDeliveryConditions = function () {
        if (_.size(_this.editData.deliveryConditions)) {
            _this.deliveryConditions = _.first(_this.editData.deliveryConditions);
        }
        else {
            _this.deliveryConditions = null;
        }
    };
    this.$onInit = function () {
        setVisibleFormControls($routeParams.deliveryItemType);
        setDeliveryConditions();
    };
    this.$onChanges = function () {
        setDeliveryConditions();
    };
}
angular.module('prism-ui.deliveryProfiles').component('deliveryItemEditViewGeneral', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/common/general/delivery-items-edit-view-general-template.html',
    controller: DeliveryItemEditViewGeneralController,
    bindings: {
        editData: '<',
        conditionalTemplates: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function DeliveryItemEditViewFromController(_, EnumService, $routeParams) {
    var _this = this;
    var setVisibleFormControls = function (type) {
        switch (type) {
            case 'Video':
                _this.visibleFormControls = {
                    deliveryMode: true,
                    languages: _this.editData.mode === 'DUB_CARDS',
                };
                break;
            case 'Audio':
                _this.visibleFormControls = {
                    languages: true,
                    profile: true,
                    roles: true,
                };
                break;
            case 'Artwork':
                _this.visibleFormControls = {
                    languages: true,
                    profile: true,
                };
                break;
            case 'Image':
                _this.visibleFormControls = {
                    languages: true,
                    profile: true,
                };
                break;
            case 'CC':
                _this.visibleFormControls = {
                    deliveryMode: true,
                    languages: true,
                    roles: true,
                };
                break;
            case 'Subtitle':
                _this.visibleFormControls = {
                    deliveryMode: true,
                    languages: true,
                    roles: true,
                };
                break;
            case 'Metadata':
            case 'Archive':
                _this.visibleFormControls = {};
                break;
            default:
                _this.visibleFormControls = null;
                console.warn("Unknown delivery item type [" + _this.editData.type + "] when setting visibly form controls ");
                break;
        }
    };
    var requiredFormControls = {
        deliveryMode: ['Video']
    };
    this.isFieldRequired = function (formControlName) {
        return _.chain(requiredFormControls)
            .get(formControlName, [])
            .includes($routeParams.deliveryItemType)
            .value();
    };
    var getFormData = function () {
        switch (_this.editData.type) {
            case 'Video':
                _this.deliveryModes = EnumService.getEnumPicklist('VideoDeliveryItem_mode');
                break;
            case 'Subtitle':
            case 'CC':
                _this.deliveryModes = EnumService.getEnumPicklist('TextDeliveryItem_mode');
                break;
            default:
                break;
        }
    };
    this.transformDeliveryModeLabel = function (item) {
        return _this.editData.type + " - " + item.displayName;
    };
    this.handleDeliveryConditionTemplateChange = function () {
        if (_this.deliveryConditions != null) {
            _this.editData.deliveryConditions = [_this.deliveryConditions];
        }
        else {
            _this.editData.deliveryConditions = [];
        }
    };
    var setDeliveryConditions = function () {
        if (_.size(_this.editData.deliveryConditions)) {
            _this.deliveryConditions = _.first(_this.editData.deliveryConditions);
        }
        else {
            _this.deliveryConditions = null;
        }
    };
    this.$onInit = function () {
        if (_this.editData.sourceType == 'ARTWORK_IMAGE') {
            _this.mediaAcceptProfiles = _.filter(_this.mediaAcceptProfiles, { type: 'OTHER' });
        }
        else {
            _this.mediaAcceptProfiles = _.filter(_this.packageAcceptTemplate.mediaAcceptProfiles, { type: _.toUpper(_this.editData.type) });
        }
        EnumService.queryForEnums().then(function () {
            setVisibleFormControls($routeParams.deliveryItemType);
            getFormData();
            setDeliveryConditions();
            var defaultModeId = _.chain(_this.deliveryModes)
                .find({ id: 'DEFAULT' })
                .get('id')
                .value();
            if (!_this.editData.mode && defaultModeId) {
                _this.editData.mode = defaultModeId;
            }
        });
    };
    this.$onChanges = function () {
        if (_this.visibleFormControls !== undefined) {
            setDeliveryConditions();
        }
    };
    this.onDeliveryModeChanged = function () {
        setVisibleFormControls($routeParams.deliveryItemType);
    };
}
angular.module('prism-ui.deliveryProfiles').component('deliveryItemEditViewFrom', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/common/from/delivery-items-edit-view-from-template.html',
    controller: DeliveryItemEditViewFromController,
    bindings: {
        editData: '<',
        languages: '<',
        roles: '<',
        packageAcceptTemplate: '<',
        mediaAcceptProfiles: '<',
        conditionalTemplates: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function DeliveryItemEditViewToController(_, EnumService, $routeParams) {
    var _this = this;
    this.deliveryItemExists = function () {
        return $routeParams.deliveryItemId !== '-1';
    };
    this.isTemplateRequired = function () {
        return _this.templateType !== 'Passthrough';
    };
    this.onTemplateTypeChanged = function (type) {
        _this.templateType = type;
        setVisibleFormControls($routeParams.deliveryItemType);
        _.invoke(_this, 'onMediaConversionTemplateTypeChange', { type: _this.templateType });
    };
    var setVisibleFormControls = function (type) {
        switch (type) {
            case 'Video':
                _this.visibleFormControls = {
                    templateDropdown: true,
                    forceVantageComposition: _this.templateType === 'Vantage',
                    vantageProcessorName: _this.templateType === 'Vantage',
                    vantageVideoNickname: _this.templateType === 'Vantage',
                    fadeInDuration: _this.templateType === 'Vantage',
                    fadeOutDuration: _this.templateType === 'Vantage',
                    startTimecode: _this.templateType === 'Vantage',
                    disableNielsenWatermarking: _this.templateType === 'Vantage',
                    disableNexGuardWatermarking: _this.templateType === 'Vantage',
                    conversionTemplateVariables: _this.templateType === 'Hybrik',
                    splitAndStitch: true,
                    minDuration: true,
                    maxNumberOfSplits: true,
                    activePixelsWidth: true,
                    activePixelsHeight: true
                };
                break;
            case 'Audio':
                _this.visibleFormControls = {
                    templateDropdown: true
                };
                break;
            case 'Artwork':
            case 'Image':
                _this.visibleFormControls = {
                    imageTemplate: true
                };
                break;
            case 'CC':
            case 'Subtitle':
                _this.visibleFormControls = {
                    closedCaptionsSubtitleProfile: true,
                    macCaptionTemplate: true
                };
                break;
            case 'Metadata':
                _this.visibleFormControls = {
                    metaDataProfile: true,
                    createAFileForEachAct: true
                };
                break;
            default:
                _this.visibleFormControls = null;
                console.warn("Unknown delivery item type [" + _this.editData.type + "] when setting visibly form controls ");
                break;
        }
    };
    var setTemplateTypeDropdown = function () {
        _this.nullTemplateType = _this.deliveryItemExists() ? 'Passthrough' : null;
    };
    var setFormControls = function () {
        setTemplateTypeDropdown();
    };
    this.$onInit = function () {
        _this.availableClosedCaptionAssetContentTemplates = _.filter(_this.assetContentTemplates, { contentType: 'CC' });
        _this.availableImageAssetContentTemplates = _.filter(_this.assetContentTemplates, { contentType: 'IMAGE' });
        _this.availableMediaConversionTemplates = _this.mediaConversionTemplates;
        _this.availableMacCaptionTemplates = _this.macCaptionTemplates;
        if ($routeParams.deliveryItemType === 'Video') {
            _this.tooltipTemplate = 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/common/to/to-panel-template-type-tooltip-template.html';
        }
        setFormControls();
        setVisibleFormControls($routeParams.deliveryItemType);
    };
    this.$onChanges = function () {
        setFormControls();
        setVisibleFormControls($routeParams.deliveryItemType);
    };
}
angular.module('prism-ui.deliveryProfiles').component('deliveryItemEditViewTo', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/common/to/delivery-items-edit-view-to-template.html',
    controller: DeliveryItemEditViewToController,
    bindings: {
        editData: '<',
        mediaConversionTemplates: '<',
        assetContentTemplates: '<',
        transformTemplates: '<',
        macCaptionTemplates: '<',
        conversionTemplateVariableComponentsMap: '<',
        onMediaConversionTemplateTypeChange: '&?'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function DeliveryItemEditViewPartnerFormatController() {
    this.$onInit = function () {
        // This component is intentionally empty
    };
}
angular.module('prism-ui.deliveryProfiles').component('deliveryItemEditViewPartnerFormat', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/common/partnerFormat/delivery-items-edit-view-partner-format-template.html',
    controller: DeliveryItemEditViewPartnerFormatController,
    bindings: {
        editData: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function DeliveryItemEditViewRedeliveryController() {
    this.$onInit = function () {
        // This component is intentionally empty
    };
}
angular.module('prism-ui.deliveryProfiles').component('deliveryItemEditViewRedelivery', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/common/redelivery/delivery-items-edit-view-redelivery-template.html',
    controller: DeliveryItemEditViewRedeliveryController,
    bindings: {
        editData: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function DeliveryItemsFromLanguagesSearchViewController(LanguagesService, uiGridConstants, PartnerEditService, $timeout) {
    var _this = this;
    var setLanguageRadioSelection = function () {
        _this.languagesBeforeSelectAll = _.cloneDeep(_this.editData.languages);
        _this.languageRadioSelection = _.size(_this.editData.languages) ? 'Custom' : 'All';
    };
    var setRowSelection = function (row) {
        if (row.isSelected) {
            _this.editData.languages.push(row.entity);
        }
        else {
            _.remove(_this.editData.languages, { id: row.entity.id });
        }
        _this.editorForm.$setDirty();
    };
    this.onRowSelection = function (row) {
        setRowSelection(row);
    };
    this.onSelectAllToggled = function () {
        _this.gridApi.selection.selectAllRows();
        if (_this.gridApi.selection.getSelectedCount() !== _.size(_this.editData.languages)) {
            _this.editData.languages = _.cloneDeep(_this.languages);
        }
        else {
            _this.editData.languages = [];
            _this.gridApi.selection.clearSelectedRows();
        }
        _this.editorForm.$setDirty();
    };
    this.handleLanguageRadioSelectionChanged = function () {
        switch (_this.languageRadioSelection) {
            case 'All':
                _this.languagesBeforeSelectAll = _.cloneDeep(_this.editData.languages);
                _this.editData.languages = [];
                break;
            case 'Custom':
                _this.editData.languages = _.cloneDeep(_this.languagesBeforeSelectAll);
                _this.processGridFilter(_.invoke(_this.gridApi, 'core.getVisibleRows', _this));
                break;
            default:
                break;
        }
    };
    this.processGridFilter = function (renderableRows) {
        _.forEach(renderableRows, function (renderableRow) {
            renderableRow.setSelected(_.some(_this.editData.languages, { id: renderableRow.entity.id }));
        });
        return renderableRows;
    };
    var columnDefinitions = [
        {
            name: 'checkMarkRowHeaderCol',
            field: 'checkMark',
            width: 30,
            enableSorting: false,
            enableColumnResizing: false,
            headerCellTemplate: 'components/visual/grid/header-check-mark-component-template.html',
            cellTemplate: 'components/visual/grid/check-mark-template.html'
        }, {
            field: 'name',
            displayName: 'Language',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        multiSelect: true,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        columnDefs: columnDefinitions,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            _this.gridApi.grid.registerRowsProcessor(_this.processGridFilter, 200);
            gridApi.selection.on.rowSelectionChanged(null, _this.onRowSelection);
        },
        cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
    };
    this.$onInit = function () {
        _this.gridOptions.data = _.cloneDeep(_this.languages);
        _this.showGrid = true;
        setLanguageRadioSelection();
    };
    this.$onChanges = function () {
        setLanguageRadioSelection();
        _this.processGridFilter(_.invoke(_this.gridApi, 'core.getVisibleRows', _this));
    };
    this.$postLink = function () {
        $timeout(function () {
            PartnerEditService.editorForm = _this.editorForm;
        });
    };
}
angular.module('prism-ui.deliveryProfiles').component('deliveryItemsFromLanguagesSearchView', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/common/from/languagesGrid/delivery-items-from-languages-grid-template.html',
    controller: DeliveryItemsFromLanguagesSearchViewController,
    bindings: {
        editData: '<',
        languages: '<'
    }
});

/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
function DeliveryItemsFromRolesSearchViewController(RolesService, uiGridConstants, PartnerEditService, $timeout) {
    var _this = this;
    var setRoleRadioSelection = function () {
        _this.rolesBeforeSelectAll = _.cloneDeep(_this.editData.roles);
        _this.roleRadioSelection = _.size(_this.editData.roles) ? 'Custom' : 'All';
    };
    var setRowSelection = function (row) {
        if (row.isSelected) {
            _this.editData.roles.push(row.entity);
        }
        else {
            _.remove(_this.editData.roles, { id: row.entity.id });
        }
        _this.editorForm.$setDirty();
    };
    this.onRowSelection = function (row) {
        setRowSelection(row);
    };
    this.onSelectAllToggled = function () {
        _this.gridApi.selection.selectAllRows();
        if (_this.gridApi.selection.getSelectedCount() !== _.size(_this.editData.roles)) {
            _this.editData.roles = _.cloneDeep(_this.roles);
        }
        else {
            _this.editData.roles = [];
            _this.gridApi.selection.clearSelectedRows();
        }
        _this.editorForm.$setDirty();
    };
    this.handleRoleRadioSelectionChanged = function () {
        switch (_this.roleRadioSelection) {
            case 'All':
                _this.rolesBeforeSelectAll = _.cloneDeep(_this.editData.roles);
                _this.editData.roles = [];
                break;
            case 'Custom':
                _this.editData.roles = _.cloneDeep(_this.rolesBeforeSelectAll);
                _this.processGridFilter(_.invoke(_this.gridApi, 'core.getVisibleRows', _this));
                break;
            default:
                break;
        }
    };
    this.processGridFilter = function (renderableRows) {
        _.forEach(renderableRows, function (renderableRow) {
            renderableRow.setSelected(_.some(_this.editData.roles, { id: renderableRow.entity.id }));
        });
        return renderableRows;
    };
    var columnDefinitions = [
        {
            name: 'checkMarkRowHeaderCol',
            field: 'checkMark',
            width: 30,
            enableSorting: false,
            enableColumnResizing: false,
            headerCellTemplate: 'components/visual/grid/header-check-mark-component-template.html',
            cellTemplate: 'components/visual/grid/check-mark-template.html'
        }, {
            field: 'name',
            displayName: 'Role',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        multiSelect: true,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        columnDefs: columnDefinitions,
        onRegisterApi: function (gridApi) {
            _this.gridApi = gridApi;
            _this.gridApi.grid.registerRowsProcessor(_this.processGridFilter, 200);
            gridApi.selection.on.rowSelectionChanged(null, _this.onRowSelection);
        },
        cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
    };
    this.$onInit = function () {
        _this.roles = _.filter(_this.roles, { type: _this.editData.type });
        _this.gridOptions.data = _.cloneDeep(_this.roles);
        _this.showGrid = true;
        setRoleRadioSelection();
    };
    this.$onChanges = function () {
        setRoleRadioSelection();
        _this.processGridFilter(_.invoke(_this.gridApi, 'core.getVisibleRows', _this));
    };
    this.$postLink = function () {
        $timeout(function () {
            PartnerEditService.editorForm = _this.editorForm;
        });
    };
}
angular.module('prism-ui.deliveryProfiles').component('deliveryItemsFromRolesSearchView', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/common/from/rolesGrid/delivery-items-from-roles-grid-template.html',
    controller: DeliveryItemsFromRolesSearchViewController,
    bindings: {
        editData: '<',
        roles: '<'
    }
});
